/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		2: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "static/js/" + ({}[chunkId]||chunkId) + "." + {"0":"761f2e9e","1":"844718f3"}[chunkId] + ".chunk.js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 664);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(671);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _pure = _interopRequireDefault(__webpack_require__(920));

var _SvgIcon = _interopRequireDefault(__webpack_require__(73));

function createSvgIcon(path, displayName) {
  var Icon = function Icon(props) {
    return _react.default.createElement(_SvgIcon.default, props, path);
  };

  Icon.displayName = displayName;
  Icon = (0, _pure.default)(Icon);
  Icon.muiName = 'SvgIcon';
  return Icon;
}

;
var _default = createSvgIcon;
exports.default = _default;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(704)();
}


/***/ }),
/* 4 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "createGenerateClassName", {
  enumerable: true,
  get: function get() {
    return _createGenerateClassName.default;
  }
});
Object.defineProperty(exports, "createMuiTheme", {
  enumerable: true,
  get: function get() {
    return _createMuiTheme.default;
  }
});
Object.defineProperty(exports, "jssPreset", {
  enumerable: true,
  get: function get() {
    return _jssPreset.default;
  }
});
Object.defineProperty(exports, "MuiThemeProvider", {
  enumerable: true,
  get: function get() {
    return _MuiThemeProvider.default;
  }
});
Object.defineProperty(exports, "createStyles", {
  enumerable: true,
  get: function get() {
    return _createStyles.default;
  }
});
Object.defineProperty(exports, "withStyles", {
  enumerable: true,
  get: function get() {
    return _withStyles.default;
  }
});
Object.defineProperty(exports, "withTheme", {
  enumerable: true,
  get: function get() {
    return _withTheme.default;
  }
});

var _createGenerateClassName = _interopRequireDefault(__webpack_require__(433));

var _createMuiTheme = _interopRequireDefault(__webpack_require__(290));

var _jssPreset = _interopRequireDefault(__webpack_require__(440));

var _MuiThemeProvider = _interopRequireDefault(__webpack_require__(790));

var _createStyles = _interopRequireDefault(__webpack_require__(447));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _withTheme = _interopRequireDefault(__webpack_require__(90));

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
     true ? factory(exports, __webpack_require__(0), __webpack_require__(3), __webpack_require__(281)) :
    typeof define === 'function' && define.amd ? define(['exports', 'react', 'prop-types', 'apollo-client'], factory) :
    (factory((global['react-apollo'] = {}),global.React,global.PropTypes,global.apolloClient));
}(this, (function (exports,React,PropTypes,apolloClient) { 'use strict';

    function getProps(element) {
        return element.props || element.attributes;
    }
    function isReactElement(element) {
        return !!element.type;
    }
    function isComponentClass(Comp) {
        return Comp.prototype && (Comp.prototype.render || Comp.prototype.isReactComponent);
    }
    function providesChildContext(instance) {
        return !!instance.getChildContext;
    }
    function walkTree(element, context, visitor) {
        if (Array.isArray(element)) {
            element.forEach(function (item) { return walkTree(item, context, visitor); });
            return;
        }
        if (!element) {
            return;
        }
        if (isReactElement(element)) {
            if (typeof element.type === 'function') {
                var Comp = element.type;
                var props = Object.assign({}, Comp.defaultProps, getProps(element));
                var childContext_1 = context;
                var child = void 0;
                if (isComponentClass(Comp)) {
                    var instance_1 = new Comp(props, context);
                    Object.defineProperty(instance_1, 'props', {
                        value: instance_1.props || props,
                    });
                    instance_1.context = instance_1.context || context;
                    instance_1.state = instance_1.state || null;
                    instance_1.setState = function (newState) {
                        if (typeof newState === 'function') {
                            newState = newState(instance_1.state, instance_1.props, instance_1.context);
                        }
                        instance_1.state = Object.assign({}, instance_1.state, newState);
                    };
                    if (Comp.getDerivedStateFromProps) {
                        var result = Comp.getDerivedStateFromProps(instance_1.props, instance_1.state);
                        if (result !== null) {
                            instance_1.state = Object.assign({}, instance_1.state, result);
                        }
                    }
                    else if (instance_1.UNSAFE_componentWillMount) {
                        instance_1.UNSAFE_componentWillMount();
                    }
                    else if (instance_1.componentWillMount) {
                        instance_1.componentWillMount();
                    }
                    if (providesChildContext(instance_1)) {
                        childContext_1 = Object.assign({}, context, instance_1.getChildContext());
                    }
                    if (visitor(element, instance_1, context, childContext_1) === false) {
                        return;
                    }
                    child = instance_1.render();
                }
                else {
                    if (visitor(element, null, context) === false) {
                        return;
                    }
                    child = Comp(props, context);
                }
                if (child) {
                    if (Array.isArray(child)) {
                        child.forEach(function (item) { return walkTree(item, childContext_1, visitor); });
                    }
                    else {
                        walkTree(child, childContext_1, visitor);
                    }
                }
            }
            else if (element.type._context || element.type.Consumer) {
                if (visitor(element, null, context) === false) {
                    return;
                }
                var child = void 0;
                if (element.type._context) {
                    element.type._context._currentValue = element.props.value;
                    child = element.props.children;
                }
                else {
                    child = element.props.children(element.type._currentValue);
                }
                if (child) {
                    if (Array.isArray(child)) {
                        child.forEach(function (item) { return walkTree(item, context, visitor); });
                    }
                    else {
                        walkTree(child, context, visitor);
                    }
                }
            }
            else {
                if (visitor(element, null, context) === false) {
                    return;
                }
                if (element.props && element.props.children) {
                    React.Children.forEach(element.props.children, function (child) {
                        if (child) {
                            walkTree(child, context, visitor);
                        }
                    });
                }
            }
        }
        else if (typeof element === 'string' || typeof element === 'number') {
            visitor(element, null, context);
        }
    }
    function hasFetchDataFunction(instance) {
        return typeof instance.fetchData === 'function';
    }
    function isPromise(promise) {
        return typeof promise.then === 'function';
    }
    function getPromisesFromTree(_a) {
        var rootElement = _a.rootElement, _b = _a.rootContext, rootContext = _b === void 0 ? {} : _b;
        var promises = [];
        walkTree(rootElement, rootContext, function (_, instance, context, childContext) {
            if (instance && hasFetchDataFunction(instance)) {
                var promise = instance.fetchData();
                if (isPromise(promise)) {
                    promises.push({ promise: promise, context: childContext || context, instance: instance });
                    return false;
                }
            }
        });
        return promises;
    }
    function getDataFromTree(rootElement, rootContext) {
        if (rootContext === void 0) { rootContext = {}; }
        var promises = getPromisesFromTree({ rootElement: rootElement, rootContext: rootContext });
        if (!promises.length) {
            return Promise.resolve();
        }
        var errors = [];
        var mappedPromises = promises.map(function (_a) {
            var promise = _a.promise, context = _a.context, instance = _a.instance;
            return promise
                .then(function (_) { return getDataFromTree(instance.render(), context); })
                .catch(function (e) { return errors.push(e); });
        });
        return Promise.all(mappedPromises).then(function (_) {
            if (errors.length > 0) {
                var error = errors.length === 1
                    ? errors[0]
                    : new Error(errors.length + " errors were thrown when executing your fetchData functions.");
                error.queryErrors = errors;
                throw error;
            }
        });
    }

    var invariant = __webpack_require__(67);
    var ApolloConsumer = function (props, context) {
        invariant(!!context.client, "Could not find \"client\" in the context of ApolloConsumer. Wrap the root component in an <ApolloProvider>");
        return props.children(context.client);
    };
    ApolloConsumer.contextTypes = {
        client: PropTypes.object.isRequired,
    };
    ApolloConsumer.propTypes = {
        children: PropTypes.func.isRequired,
    };

    var __extends = (undefined && undefined.__extends) || (function () {
        var extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var invariant$1 = __webpack_require__(67);
    var ApolloProvider = (function (_super) {
        __extends(ApolloProvider, _super);
        function ApolloProvider(props, context) {
            var _this = _super.call(this, props, context) || this;
            _this.operations = new Map();
            invariant$1(props.client, 'ApolloProvider was not passed a client instance. Make ' +
                'sure you pass in your client via the "client" prop.');
            if (!props.client.__operations_cache__) {
                props.client.__operations_cache__ = _this.operations;
            }
            return _this;
        }
        ApolloProvider.prototype.getChildContext = function () {
            return {
                client: this.props.client,
                operations: this.props.client.__operations_cache__,
            };
        };
        ApolloProvider.prototype.render = function () {
            return this.props.children;
        };
        ApolloProvider.propTypes = {
            client: PropTypes.object.isRequired,
            children: PropTypes.node.isRequired,
        };
        ApolloProvider.childContextTypes = {
            client: PropTypes.object.isRequired,
            operations: PropTypes.object,
        };
        return ApolloProvider;
    }(React.Component));

    var invariant$2 = __webpack_require__(67);
    var DocumentType;
    (function (DocumentType) {
        DocumentType[DocumentType["Query"] = 0] = "Query";
        DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
        DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
    })(DocumentType || (DocumentType = {}));
    var cache = new Map();
    function parser(document) {
        var cached = cache.get(document);
        if (cached)
            return cached;
        var variables, type, name;
        invariant$2(!!document && !!document.kind, "Argument of " + document + " passed to parser was not a valid GraphQL " +
            "DocumentNode. You may need to use 'graphql-tag' or another method " +
            "to convert your operation into a document");
        var fragments = document.definitions.filter(function (x) { return x.kind === 'FragmentDefinition'; });
        var queries = document.definitions.filter(function (x) { return x.kind === 'OperationDefinition' && x.operation === 'query'; });
        var mutations = document.definitions.filter(function (x) { return x.kind === 'OperationDefinition' && x.operation === 'mutation'; });
        var subscriptions = document.definitions.filter(function (x) { return x.kind === 'OperationDefinition' && x.operation === 'subscription'; });
        invariant$2(!fragments.length || (queries.length || mutations.length || subscriptions.length), "Passing only a fragment to 'graphql' is not yet supported. " +
            "You must include a query, subscription or mutation as well");
        invariant$2(queries.length + mutations.length + subscriptions.length <= 1, "react-apollo only supports a query, subscription, or a mutation per HOC. " +
            (document + " had " + queries.length + " queries, " + subscriptions.length + " ") +
            ("subscriptions and " + mutations.length + " mutations. ") +
            "You can use 'compose' to join multiple operation types to a component");
        type = queries.length ? DocumentType.Query : DocumentType.Mutation;
        if (!queries.length && !mutations.length)
            type = DocumentType.Subscription;
        var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
        invariant$2(definitions.length === 1, "react-apollo only supports one defintion per HOC. " + document + " had " +
            (definitions.length + " definitions. ") +
            "You can use 'compose' to join multiple operation types to a component");
        var definition = definitions[0];
        variables = definition.variableDefinitions || [];
        if (definition.name && definition.name.kind === 'Name') {
            name = definition.name.value;
        }
        else {
            name = 'data';
        }
        var payload = { name: name, type: type, variables: variables };
        cache.set(document, payload);
        return payload;
    }

    var __extends$1 = (undefined && undefined.__extends) || (function () {
        var extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var __assign = (undefined && undefined.__assign) || Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    var __rest = (undefined && undefined.__rest) || function (s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
                t[p[i]] = s[p[i]];
        return t;
    };
    var shallowEqual = __webpack_require__(141);
    var invariant$3 = __webpack_require__(67);
    function compact(obj) {
        return Object.keys(obj).reduce(function (acc, key) {
            if (obj[key] !== undefined) {
                acc[key] = obj[key];
            }
            return acc;
        }, {});
    }
    function observableQueryFields(observable) {
        var fields = {
            variables: observable.variables,
            refetch: observable.refetch.bind(observable),
            fetchMore: observable.fetchMore.bind(observable),
            updateQuery: observable.updateQuery.bind(observable),
            startPolling: observable.startPolling.bind(observable),
            stopPolling: observable.stopPolling.bind(observable),
            subscribeToMore: observable.subscribeToMore.bind(observable),
        };
        return fields;
    }
    var Query = (function (_super) {
        __extends$1(Query, _super);
        function Query(props, context) {
            var _this = _super.call(this, props, context) || this;
            _this.previousData = {};
            _this.hasMounted = false;
            _this.startQuerySubscription = function () {
                if (_this.querySubscription)
                    return;
                var current = _this.getQueryResult();
                _this.querySubscription = _this.queryObservable.subscribe({
                    next: function () {
                        if (current && current.networkStatus === 7) {
                            current = undefined;
                            return;
                        }
                        _this.updateCurrentData();
                    },
                    error: function (error) {
                        _this.resubscribeToQuery();
                        if (!error.hasOwnProperty('graphQLErrors'))
                            throw error;
                        _this.updateCurrentData();
                    },
                });
            };
            _this.removeQuerySubscription = function () {
                if (_this.querySubscription) {
                    _this.querySubscription.unsubscribe();
                    delete _this.querySubscription;
                }
            };
            _this.updateCurrentData = function () {
                var _a = _this.props, onCompleted = _a.onCompleted, onError = _a.onError;
                if (onCompleted || onError) {
                    var currentResult = _this.queryObservable.currentResult();
                    var loading = currentResult.loading, error = currentResult.error, data = currentResult.data;
                    if (onCompleted && !loading && !error) {
                        onCompleted(data);
                    }
                    else if (onError && !loading && error) {
                        onError(error);
                    }
                }
                if (_this.hasMounted)
                    _this.forceUpdate();
            };
            _this.getQueryResult = function () {
                var data = { data: Object.create(null) };
                Object.assign(data, observableQueryFields(_this.queryObservable));
                var currentResult = _this.queryObservable.currentResult();
                var loading = currentResult.loading, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
                var error = currentResult.error;
                if (errors && errors.length > 0) {
                    error = new apolloClient.ApolloError({ graphQLErrors: errors });
                }
                Object.assign(data, { loading: loading, networkStatus: networkStatus, error: error });
                if (loading) {
                    Object.assign(data.data, _this.previousData, currentResult.data);
                }
                else if (error) {
                    Object.assign(data, {
                        data: (_this.queryObservable.getLastResult() || {}).data,
                    });
                }
                else {
                    Object.assign(data.data, currentResult.data);
                    _this.previousData = currentResult.data;
                }
                if (!_this.querySubscription) {
                    var oldRefetch_1 = data.refetch;
                    data.refetch = function (args) {
                        if (_this.querySubscription) {
                            return oldRefetch_1(args);
                        }
                        else {
                            return new Promise(function (r, f) {
                                _this.refetcherQueue = { resolve: r, reject: f, args: args };
                            });
                        }
                    };
                }
                data.client = _this.client;
                return data;
            };
            _this.client = props.client || context.client;
            invariant$3(!!_this.client, "Could not find \"client\" in the context of Query or as passed props. Wrap the root component in an <ApolloProvider>");
            _this.initializeQueryObservable(props);
            return _this;
        }
        Query.prototype.fetchData = function () {
            if (this.props.skip)
                return false;
            var _a = this.props, children = _a.children, ssr = _a.ssr, displayName = _a.displayName, skip = _a.skip, client = _a.client, onCompleted = _a.onCompleted, onError = _a.onError, opts = __rest(_a, ["children", "ssr", "displayName", "skip", "client", "onCompleted", "onError"]);
            var fetchPolicy = opts.fetchPolicy;
            if (ssr === false)
                return false;
            if (fetchPolicy === 'network-only' || fetchPolicy === 'cache-and-network') {
                fetchPolicy = 'cache-first';
            }
            var observable = this.client.watchQuery(__assign({}, opts, { fetchPolicy: fetchPolicy }));
            var result = this.queryObservable.currentResult();
            return result.loading ? observable.result() : false;
        };
        Query.prototype.componentDidMount = function () {
            this.hasMounted = true;
            if (this.props.skip)
                return;
            this.startQuerySubscription();
            if (this.refetcherQueue) {
                var _a = this.refetcherQueue, args = _a.args, resolve = _a.resolve, reject = _a.reject;
                this.queryObservable.refetch(args)
                    .then(resolve)
                    .catch(reject);
            }
        };
        Query.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
            if (nextProps.skip && !this.props.skip) {
                this.removeQuerySubscription();
                return;
            }
            var client = nextProps.client;
            if (shallowEqual(this.props, nextProps) &&
                (this.client === client || this.client === nextContext.client)) {
                return;
            }
            if (this.client !== client && this.client !== nextContext.client) {
                if (client) {
                    this.client = client;
                }
                else {
                    this.client = nextContext.client;
                }
                this.removeQuerySubscription();
                this.queryObservable = null;
                this.previousData = {};
                this.updateQuery(nextProps);
            }
            if (this.props.query !== nextProps.query) {
                this.removeQuerySubscription();
            }
            this.updateQuery(nextProps);
            if (nextProps.skip)
                return;
            this.startQuerySubscription();
        };
        Query.prototype.componentWillUnmount = function () {
            this.removeQuerySubscription();
            this.hasMounted = false;
        };
        Query.prototype.render = function () {
            var children = this.props.children;
            var queryResult = this.getQueryResult();
            return children(queryResult);
        };
        Query.prototype.extractOptsFromProps = function (props) {
            var variables = props.variables, pollInterval = props.pollInterval, fetchPolicy = props.fetchPolicy, errorPolicy = props.errorPolicy, notifyOnNetworkStatusChange = props.notifyOnNetworkStatusChange, query = props.query, _a = props.displayName, displayName = _a === void 0 ? 'Query' : _a, _b = props.context, context = _b === void 0 ? {} : _b;
            this.operation = parser(query);
            invariant$3(this.operation.type === DocumentType.Query, "The <Query /> component requires a graphql query, but got a " + (this.operation.type === DocumentType.Mutation ? 'mutation' : 'subscription') + ".");
            return compact({
                variables: variables,
                pollInterval: pollInterval,
                query: query,
                fetchPolicy: fetchPolicy,
                errorPolicy: errorPolicy,
                notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
                metadata: { reactComponent: { displayName: displayName } },
                context: context,
            });
        };
        Query.prototype.initializeQueryObservable = function (props) {
            var opts = this.extractOptsFromProps(props);
            if (this.context.operations) {
                this.context.operations.set(this.operation.name, {
                    query: opts.query,
                    variables: opts.variables,
                });
            }
            this.queryObservable = this.client.watchQuery(opts);
        };
        Query.prototype.updateQuery = function (props) {
            if (!this.queryObservable)
                this.initializeQueryObservable(props);
            this.queryObservable.setOptions(this.extractOptsFromProps(props))
                .catch(function () { return null; });
        };
        Query.prototype.resubscribeToQuery = function () {
            this.removeQuerySubscription();
            var lastError = this.queryObservable.getLastError();
            var lastResult = this.queryObservable.getLastResult();
            this.queryObservable.resetLastResults();
            this.startQuerySubscription();
            Object.assign(this.queryObservable, { lastError: lastError, lastResult: lastResult });
        };
        Query.contextTypes = {
            client: PropTypes.object.isRequired,
            operations: PropTypes.object,
        };
        Query.propTypes = {
            children: PropTypes.func.isRequired,
            fetchPolicy: PropTypes.string,
            notifyOnNetworkStatusChange: PropTypes.bool,
            onCompleted: PropTypes.func,
            onError: PropTypes.func,
            pollInterval: PropTypes.number,
            query: PropTypes.object.isRequired,
            variables: PropTypes.object,
            ssr: PropTypes.bool,
        };
        return Query;
    }(React.Component));

    var __extends$2 = (undefined && undefined.__extends) || (function () {
        var extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var __assign$1 = (undefined && undefined.__assign) || Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    var invariant$4 = __webpack_require__(67);
    var shallowEqual$1 = __webpack_require__(141);
    var initialState = {
        loading: false,
        called: false,
        error: undefined,
        data: undefined,
    };
    var Mutation = (function (_super) {
        __extends$2(Mutation, _super);
        function Mutation(props, context) {
            var _this = _super.call(this, props, context) || this;
            _this.hasMounted = false;
            _this.runMutation = function (options) {
                if (options === void 0) { options = {}; }
                _this.onStartMutation();
                var mutationId = _this.generateNewMutationId();
                return _this.mutate(options)
                    .then(function (response) {
                    _this.onCompletedMutation(response, mutationId);
                    return response;
                })
                    .catch(function (e) {
                    _this.onMutationError(e, mutationId);
                    if (!_this.props.onError)
                        throw e;
                });
            };
            _this.mutate = function (options) {
                var _a = _this.props, mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, context = _b === void 0 ? {} : _b;
                var refetchQueries = options.refetchQueries || _this.props.refetchQueries;
                if (refetchQueries && refetchQueries.length && Array.isArray(refetchQueries)) {
                    refetchQueries = refetchQueries.map(function (x) {
                        if (typeof x === 'string' && _this.context.operations)
                            return _this.context.operations.get(x) || x;
                        return x;
                    });
                    delete options.refetchQueries;
                }
                return _this.client.mutate(__assign$1({ mutation: mutation,
                    variables: variables,
                    optimisticResponse: optimisticResponse,
                    refetchQueries: refetchQueries,
                    update: update,
                    context: context }, options));
            };
            _this.onStartMutation = function () {
                if (!_this.state.loading && !_this.props.ignoreResults) {
                    _this.setState({
                        loading: true,
                        error: undefined,
                        data: undefined,
                        called: true,
                    });
                }
            };
            _this.onCompletedMutation = function (response, mutationId) {
                if (_this.hasMounted === false) {
                    return;
                }
                var _a = _this.props, onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
                var data = response.data;
                var callOncomplete = function () { return (onCompleted ? onCompleted(data) : null); };
                if (_this.isMostRecentMutation(mutationId) && !ignoreResults) {
                    _this.setState({ loading: false, data: data }, callOncomplete);
                }
                else {
                    callOncomplete();
                }
            };
            _this.onMutationError = function (error, mutationId) {
                if (_this.hasMounted === false) {
                    return;
                }
                var onError = _this.props.onError;
                var callOnError = function () { return (onError ? onError(error) : null); };
                if (_this.isMostRecentMutation(mutationId)) {
                    _this.setState({ loading: false, error: error }, callOnError);
                }
                else {
                    callOnError();
                }
            };
            _this.generateNewMutationId = function () {
                _this.mostRecentMutationId = _this.mostRecentMutationId + 1;
                return _this.mostRecentMutationId;
            };
            _this.isMostRecentMutation = function (mutationId) {
                return _this.mostRecentMutationId === mutationId;
            };
            _this.verifyDocumentIsMutation = function (mutation) {
                var operation = parser(mutation);
                invariant$4(operation.type === DocumentType.Mutation, "The <Mutation /> component requires a graphql mutation, but got a " + (operation.type === DocumentType.Query ? 'query' : 'subscription') + ".");
            };
            _this.client = props.client || context.client;
            invariant$4(!!_this.client, 'Could not find "client" in the context or props of Mutation. Wrap ' +
                'the root component in an <ApolloProvider>, or pass an ApolloClient ' +
                'instance in via props.');
            _this.verifyDocumentIsMutation(props.mutation);
            _this.mostRecentMutationId = 0;
            _this.state = initialState;
            return _this;
        }
        Mutation.prototype.componentDidMount = function () {
            this.hasMounted = true;
        };
        Mutation.prototype.componentWillUnmount = function () {
            this.hasMounted = false;
        };
        Mutation.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
            var client = nextProps.client;
            if (shallowEqual$1(this.props, nextProps) &&
                (this.client === client || this.client === nextContext.client)) {
                return;
            }
            if (this.props.mutation !== nextProps.mutation) {
                this.verifyDocumentIsMutation(nextProps.mutation);
            }
            if (this.client !== client && this.client !== nextContext.client) {
                this.client = client || nextContext.client;
                this.setState(initialState);
            }
        };
        Mutation.prototype.render = function () {
            var children = this.props.children;
            var _a = this.state, loading = _a.loading, data = _a.data, error = _a.error, called = _a.called;
            var result = {
                called: called,
                loading: loading,
                data: data,
                error: error,
                client: this.client,
            };
            return children(this.runMutation, result);
        };
        Mutation.contextTypes = {
            client: PropTypes.object.isRequired,
            operations: PropTypes.object,
        };
        Mutation.propTypes = {
            mutation: PropTypes.object.isRequired,
            variables: PropTypes.object,
            optimisticResponse: PropTypes.object,
            refetchQueries: PropTypes.oneOfType([
                PropTypes.arrayOf(PropTypes.string),
                PropTypes.arrayOf(PropTypes.object),
                PropTypes.func,
            ]),
            update: PropTypes.func,
            children: PropTypes.func.isRequired,
            onCompleted: PropTypes.func,
            onError: PropTypes.func,
        };
        return Mutation;
    }(React.Component));

    var __extends$3 = (undefined && undefined.__extends) || (function () {
        var extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var shallowEqual$2 = __webpack_require__(141);
    var invariant$5 = __webpack_require__(67);
    var Subscription = (function (_super) {
        __extends$3(Subscription, _super);
        function Subscription(props, context) {
            var _this = _super.call(this, props, context) || this;
            _this.initialize = function (props) {
                if (_this.queryObservable)
                    return;
                _this.queryObservable = _this.client.subscribe({
                    query: props.subscription,
                    variables: props.variables,
                });
            };
            _this.startSubscription = function () {
                if (_this.querySubscription)
                    return;
                _this.querySubscription = _this.queryObservable.subscribe({
                    next: _this.updateCurrentData,
                    error: _this.updateError,
                });
            };
            _this.getInitialState = function () { return ({
                loading: true,
                error: undefined,
                data: undefined,
            }); };
            _this.updateCurrentData = function (result) {
                _this.setState({
                    data: result.data,
                    loading: false,
                    error: undefined,
                });
            };
            _this.updateError = function (error) {
                _this.setState({
                    error: error,
                    loading: false,
                });
            };
            _this.endSubscription = function () {
                if (_this.querySubscription) {
                    _this.querySubscription.unsubscribe();
                    delete _this.querySubscription;
                }
            };
            invariant$5(!!context.client, "Could not find \"client\" in the context of Subscription. Wrap the root component in an <ApolloProvider>");
            _this.client = context.client;
            _this.initialize(props);
            _this.state = _this.getInitialState();
            return _this;
        }
        Subscription.prototype.componentDidMount = function () {
            this.startSubscription();
        };
        Subscription.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
            if (shallowEqual$2(this.props.variables, nextProps.variables) &&
                this.client === nextContext.client &&
                this.props.subscription === nextProps.subscription) {
                return;
            }
            var shouldResubscribe = nextProps.shouldResubscribe;
            if (typeof shouldResubscribe === 'function') {
                shouldResubscribe = !!shouldResubscribe(this.props, nextProps);
            }
            var shouldNotResubscribe = shouldResubscribe === false;
            if (this.client !== nextContext.client) {
                this.client = nextContext.client;
            }
            if (!shouldNotResubscribe) {
                this.endSubscription();
                delete this.queryObservable;
                this.initialize(nextProps);
                this.startSubscription();
                this.setState(this.getInitialState());
                return;
            }
            this.initialize(nextProps);
            this.startSubscription();
        };
        Subscription.prototype.componentWillUnmount = function () {
            this.endSubscription();
        };
        Subscription.prototype.render = function () {
            var result = Object.assign({}, this.state, {
                variables: this.props.variables,
            });
            return this.props.children(result);
        };
        Subscription.contextTypes = {
            client: PropTypes.object.isRequired,
        };
        Subscription.propTypes = {
            subscription: PropTypes.object.isRequired,
            variables: PropTypes.object,
            children: PropTypes.func.isRequired,
            shouldResubscribe: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
        };
        return Subscription;
    }(React.Component));

    var __extends$4 = (undefined && undefined.__extends) || (function () {
        var extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var invariant$6 = __webpack_require__(67);
    var defaultMapPropsToOptions = function () { return ({}); };
    var defaultMapPropsToSkip = function () { return false; };
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    function calculateVariablesFromProps(operation, props, graphQLDisplayName, wrapperName) {
        var variables = {};
        for (var _i = 0, _a = operation.variables; _i < _a.length; _i++) {
            var _b = _a[_i], variable = _b.variable, type = _b.type;
            if (!variable.name || !variable.name.value)
                continue;
            var variableName = variable.name.value;
            var variableProp = props[variableName];
            if (typeof variableProp !== 'undefined') {
                variables[variableName] = variableProp;
                continue;
            }
            if (type.kind !== 'NonNullType') {
                variables[variableName] = null;
                continue;
            }
            if (operation.type === DocumentType.Mutation)
                return;
            invariant$6(typeof variableProp !== 'undefined', "The operation '" + operation.name + "' wrapping '" + wrapperName + "' " +
                ("is expecting a variable: '" + variable.name.value + "' but it was not found in the props ") +
                ("passed to '" + graphQLDisplayName + "'"));
        }
        return variables;
    }
    var GraphQLBase = (function (_super) {
        __extends$4(GraphQLBase, _super);
        function GraphQLBase(props) {
            var _this = _super.call(this, props) || this;
            _this.withRef = false;
            _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
            return _this;
        }
        GraphQLBase.prototype.getWrappedInstance = function () {
            invariant$6(this.withRef, "To access the wrapped instance, you need to specify " + "{ withRef: true } in the options");
            return this.wrappedInstance;
        };
        GraphQLBase.prototype.setWrappedInstance = function (ref) {
            this.wrappedInstance = ref;
        };
        return GraphQLBase;
    }(React.Component));

    var __extends$5 = (undefined && undefined.__extends) || (function () {
        var extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var __assign$2 = (undefined && undefined.__assign) || Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    var __rest$1 = (undefined && undefined.__rest) || function (s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
                t[p[i]] = s[p[i]];
        return t;
    };
    var hoistNonReactStatics = __webpack_require__(94);
    function query(document, operationOptions) {
        if (operationOptions === void 0) { operationOptions = {}; }
        var operation = parser(document);
        var _a = operationOptions.options, options = _a === void 0 ? defaultMapPropsToOptions : _a, _b = operationOptions.skip, skip = _b === void 0 ? defaultMapPropsToSkip : _b, _c = operationOptions.alias, alias = _c === void 0 ? 'Apollo' : _c;
        var mapPropsToOptions = options;
        if (typeof mapPropsToOptions !== 'function')
            mapPropsToOptions = function () { return options; };
        var mapPropsToSkip = skip;
        if (typeof mapPropsToSkip !== 'function')
            mapPropsToSkip = function () { return skip; };
        var lastResultProps;
        return function (WrappedComponent) {
            var graphQLDisplayName = alias + "(" + getDisplayName(WrappedComponent) + ")";
            var GraphQL = (function (_super) {
                __extends$5(GraphQL, _super);
                function GraphQL() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                GraphQL.prototype.render = function () {
                    var _this = this;
                    var props = this.props;
                    var shouldSkip = mapPropsToSkip(props);
                    var opts = shouldSkip ? Object.create(null) : mapPropsToOptions(props);
                    if (!shouldSkip && !opts.variables && operation.variables.length > 0) {
                        opts.variables = calculateVariablesFromProps(operation, props, graphQLDisplayName, getDisplayName(WrappedComponent));
                    }
                    return (React.createElement(Query, __assign$2({}, opts, { displayName: graphQLDisplayName, skip: shouldSkip, query: document, warnUnhandledError: true }), function (_a) {
                        var _ = _a.client, data = _a.data, r = __rest$1(_a, ["client", "data"]);
                        var _b, _c;
                        if (operationOptions.withRef) {
                            _this.withRef = true;
                            props = Object.assign({}, props, {
                                ref: _this.setWrappedInstance,
                            });
                        }
                        if (shouldSkip)
                            return React.createElement(WrappedComponent, __assign$2({}, props));
                        var result = Object.assign(r, data || {});
                        var name = operationOptions.name || 'data';
                        var childProps = (_b = {}, _b[name] = result, _b);
                        if (operationOptions.props) {
                            var newResult = (_c = {},
                                _c[name] = result,
                                _c.ownProps = props,
                                _c);
                            lastResultProps = operationOptions.props(newResult, lastResultProps);
                            childProps = lastResultProps;
                        }
                        return React.createElement(WrappedComponent, __assign$2({}, props, childProps));
                    }));
                };
                GraphQL.displayName = graphQLDisplayName;
                GraphQL.WrappedComponent = WrappedComponent;
                return GraphQL;
            }(GraphQLBase));
            return hoistNonReactStatics(GraphQL, WrappedComponent, {});
        };
    }

    var __extends$6 = (undefined && undefined.__extends) || (function () {
        var extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var __assign$3 = (undefined && undefined.__assign) || Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    var hoistNonReactStatics$1 = __webpack_require__(94);
    function mutation(document, operationOptions) {
        if (operationOptions === void 0) { operationOptions = {}; }
        var operation = parser(document);
        var _a = operationOptions.options, options = _a === void 0 ? defaultMapPropsToOptions : _a, _b = operationOptions.alias, alias = _b === void 0 ? 'Apollo' : _b;
        var mapPropsToOptions = options;
        if (typeof mapPropsToOptions !== 'function')
            mapPropsToOptions = function () { return options; };
        return function (WrappedComponent) {
            var graphQLDisplayName = alias + "(" + getDisplayName(WrappedComponent) + ")";
            var GraphQL = (function (_super) {
                __extends$6(GraphQL, _super);
                function GraphQL() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                GraphQL.prototype.render = function () {
                    var props = this.props;
                    var opts = mapPropsToOptions(props);
                    if (operationOptions.withRef) {
                        this.withRef = true;
                        props = Object.assign({}, props, {
                            ref: this.setWrappedInstance,
                        });
                    }
                    if (!opts.variables && operation.variables.length > 0) {
                        opts.variables = calculateVariablesFromProps(operation, props, graphQLDisplayName, getDisplayName(WrappedComponent));
                    }
                    return (React.createElement(Mutation, __assign$3({}, opts, { mutation: document, ignoreResults: true }), function (mutate, _result) {
                        var _a, _b;
                        var name = operationOptions.name || 'mutate';
                        var childProps = (_a = {}, _a[name] = mutate, _a);
                        if (operationOptions.props) {
                            var newResult = (_b = {},
                                _b[name] = mutate,
                                _b.ownProps = props,
                                _b);
                            childProps = operationOptions.props(newResult);
                        }
                        return React.createElement(WrappedComponent, __assign$3({}, props, childProps));
                    }));
                };
                GraphQL.displayName = graphQLDisplayName;
                GraphQL.WrappedComponent = WrappedComponent;
                return GraphQL;
            }(GraphQLBase));
            return hoistNonReactStatics$1(GraphQL, WrappedComponent, {});
        };
    }

    var __extends$7 = (undefined && undefined.__extends) || (function () {
        var extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var __assign$4 = (undefined && undefined.__assign) || Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    var __rest$2 = (undefined && undefined.__rest) || function (s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
                t[p[i]] = s[p[i]];
        return t;
    };
    var hoistNonReactStatics$2 = __webpack_require__(94);
    function subscribe(document, operationOptions) {
        if (operationOptions === void 0) { operationOptions = {}; }
        var operation = parser(document);
        var _a = operationOptions.options, options = _a === void 0 ? defaultMapPropsToOptions : _a, _b = operationOptions.skip, skip = _b === void 0 ? defaultMapPropsToSkip : _b, _c = operationOptions.alias, alias = _c === void 0 ? 'Apollo' : _c, shouldResubscribe = operationOptions.shouldResubscribe;
        var mapPropsToOptions = options;
        if (typeof mapPropsToOptions !== 'function')
            mapPropsToOptions = function () { return options; };
        var mapPropsToSkip = skip;
        if (typeof mapPropsToSkip !== 'function')
            mapPropsToSkip = function () { return skip; };
        var lastResultProps;
        return function (WrappedComponent) {
            var graphQLDisplayName = alias + "(" + getDisplayName(WrappedComponent) + ")";
            var GraphQL = (function (_super) {
                __extends$7(GraphQL, _super);
                function GraphQL(props) {
                    var _this = _super.call(this, props) || this;
                    _this.state = { resubscribe: false };
                    return _this;
                }
                GraphQL.prototype.componentWillReceiveProps = function (nextProps) {
                    if (!shouldResubscribe)
                        return;
                    this.setState({
                        resubscribe: shouldResubscribe(this.props, nextProps),
                    });
                };
                GraphQL.prototype.render = function () {
                    var _this = this;
                    var props = this.props;
                    var shouldSkip = mapPropsToSkip(props);
                    var opts = shouldSkip ? Object.create(null) : mapPropsToOptions(props);
                    if (!shouldSkip && !opts.variables && operation.variables.length > 0) {
                        opts.variables = calculateVariablesFromProps(operation, props, graphQLDisplayName, getDisplayName(WrappedComponent));
                    }
                    return (React.createElement(Subscription, __assign$4({}, opts, { displayName: graphQLDisplayName, skip: shouldSkip, subscription: document, shouldResubscribe: this.state.resubscribe }), function (_a) {
                        var data = _a.data, r = __rest$2(_a, ["data"]);
                        var _b, _c;
                        if (operationOptions.withRef) {
                            _this.withRef = true;
                            props = Object.assign({}, props, {
                                ref: _this.setWrappedInstance,
                            });
                        }
                        if (shouldSkip)
                            return React.createElement(WrappedComponent, __assign$4({}, props));
                        var result = Object.assign(r, data || {});
                        var name = operationOptions.name || 'data';
                        var childProps = (_b = {}, _b[name] = result, _b);
                        if (operationOptions.props) {
                            var newResult = (_c = {},
                                _c[name] = result,
                                _c.ownProps = props,
                                _c);
                            lastResultProps = operationOptions.props(newResult, lastResultProps);
                            childProps = lastResultProps;
                        }
                        return React.createElement(WrappedComponent, __assign$4({}, props, childProps));
                    }));
                };
                GraphQL.displayName = graphQLDisplayName;
                GraphQL.WrappedComponent = WrappedComponent;
                return GraphQL;
            }(GraphQLBase));
            return hoistNonReactStatics$2(GraphQL, WrappedComponent, {});
        };
    }

    function graphql(document, operationOptions) {
        if (operationOptions === void 0) { operationOptions = {}; }
        switch (parser(document).type) {
            case DocumentType.Mutation:
                return mutation(document, operationOptions);
            case DocumentType.Subscription:
                return subscribe(document, operationOptions);
            case DocumentType.Query:
            default:
                return query(document, operationOptions);
        }
    }

    var __extends$8 = (undefined && undefined.__extends) || (function () {
        var extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return function (d, b) {
            extendStatics(d, b);
            function __() { this.constructor = d; }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    })();
    var __assign$5 = (undefined && undefined.__assign) || Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    var invariant$7 = __webpack_require__(67);
    var hoistNonReactStatics$3 = __webpack_require__(94);
    function getDisplayName$1(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    function withApollo(WrappedComponent, operationOptions) {
        if (operationOptions === void 0) { operationOptions = {}; }
        var withDisplayName = "withApollo(" + getDisplayName$1(WrappedComponent) + ")";
        var WithApollo = (function (_super) {
            __extends$8(WithApollo, _super);
            function WithApollo(props) {
                var _this = _super.call(this, props) || this;
                _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
                return _this;
            }
            WithApollo.prototype.getWrappedInstance = function () {
                invariant$7(operationOptions.withRef, "To access the wrapped instance, you need to specify " + "{ withRef: true } in the options");
                return this.wrappedInstance;
            };
            WithApollo.prototype.setWrappedInstance = function (ref) {
                this.wrappedInstance = ref;
            };
            WithApollo.prototype.render = function () {
                var _this = this;
                return (React.createElement(ApolloConsumer, null, function (client) {
                    var props = Object.assign({}, _this.props, {
                        client: client,
                        ref: operationOptions.withRef ? _this.setWrappedInstance : undefined,
                    });
                    return React.createElement(WrappedComponent, __assign$5({}, props));
                }));
            };
            WithApollo.displayName = withDisplayName;
            WithApollo.WrappedComponent = WrappedComponent;
            return WithApollo;
        }(React.Component));
        return hoistNonReactStatics$3(WithApollo, WrappedComponent, {});
    }

    var compose = __webpack_require__(712);

    exports.compose = compose;
    exports.getDataFromTree = getDataFromTree;
    exports.ApolloConsumer = ApolloConsumer;
    exports.ApolloProvider = ApolloProvider;
    exports.Query = Query;
    exports.Mutation = Mutation;
    exports.Subscription = Subscription;
    exports.graphql = graphql;
    exports.withApollo = withApollo;
    exports.walkTree = walkTree;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=react-apollo.browser.umd.js.map


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gql */
/* unused harmony export resetCaches */
/* unused harmony export disableFragmentWarnings */
/* unused harmony export enableExperimentalFragmentVariables */
/* unused harmony export disableExperimentalFragmentVariables */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql__ = __webpack_require__(676);


var docCache = new Map();
var fragmentSourceMap = new Map();
var printFragmentWarnings = true;
var experimentalFragmentVariables = false;
function normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function cacheKeyFromLoc(loc) {
    return normalize(loc.source.body.substring(loc.start, loc.end));
}
function processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function (fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if (printFragmentWarnings) {
                    console.warn("Warning: fragment with name " + fragmentName + " already exists.\n"
                        + "graphql-tag enforces all fragment names across your application to be unique; read more about\n"
                        + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
                }
            }
            else if (!sourceKeySet) {
                fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            }
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        }
        else {
            definitions.push(fragmentDefinition);
        }
    });
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, ast), { definitions: definitions });
}
function stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function (node) {
        if (node.loc)
            delete node.loc;
        Object.keys(node).forEach(function (key) {
            var value = node[key];
            if (value && typeof value === 'object') {
                workSet.add(value);
            }
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function parseDocument(source) {
    var cacheKey = normalize(source);
    if (!docCache.has(cacheKey)) {
        var parsed = Object(__WEBPACK_IMPORTED_MODULE_1_graphql__["a" /* parse */])(source, {
            experimentalFragmentVariables: experimentalFragmentVariables,
            allowLegacyFragmentVariables: experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') {
            throw new Error('Not a valid GraphQL document.');
        }
        docCache.set(cacheKey, stripLoc(processFragments(parsed)));
    }
    return docCache.get(cacheKey);
}
function gql(literals) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (typeof literals === 'string') {
        literals = [literals];
    }
    var result = literals[0];
    args.forEach(function (arg, i) {
        if (arg && arg.kind === 'Document') {
            result += arg.loc.source.body;
        }
        else {
            result += arg;
        }
        result += literals[i + 1];
    });
    return parseDocument(result);
}
function resetCaches() {
    docCache.clear();
    fragmentSourceMap.clear();
}
function disableFragmentWarnings() {
    printFragmentWarnings = false;
}
function enableExperimentalFragmentVariables() {
    experimentalFragmentVariables = true;
}
function disableExperimentalFragmentVariables() {
    experimentalFragmentVariables = false;
}
var extras = {
    gql: gql,
    resetCaches: resetCaches,
    disableFragmentWarnings: disableFragmentWarnings,
    enableExperimentalFragmentVariables: enableExperimentalFragmentVariables,
    disableExperimentalFragmentVariables: disableExperimentalFragmentVariables
};
(function (gql_1) {
    gql_1.gql = extras.gql, gql_1.resetCaches = extras.resetCaches, gql_1.disableFragmentWarnings = extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = extras.disableExperimentalFragmentVariables;
})(gql || (gql = {}));
gql["default"] = gql;
/* harmony default export */ __webpack_exports__["a"] = (gql);
//# sourceMappingURL=index.js.map

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Button.default;
  }
});

var _Button = _interopRequireDefault(__webpack_require__(884));

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Grid.default;
  }
});

var _Grid = _interopRequireDefault(__webpack_require__(821));

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(905);


/***/ }),
/* 11 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function getLoginId(){return parseInt(localStorage.getItem('Login_id'),10);}/* harmony default export */ __webpack_exports__["a"] = (getLoginId);

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Typography.default;
  }
});

var _Typography = _interopRequireDefault(__webpack_require__(824));

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(751);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__colors__);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "colors", function() { return __WEBPACK_IMPORTED_MODULE_0__colors__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_1__styles__, "createGenerateClassName")) __webpack_require__.d(__webpack_exports__, "createGenerateClassName", function() { return __WEBPACK_IMPORTED_MODULE_1__styles__["createGenerateClassName"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_1__styles__, "createMuiTheme")) __webpack_require__.d(__webpack_exports__, "createMuiTheme", function() { return __WEBPACK_IMPORTED_MODULE_1__styles__["createMuiTheme"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_1__styles__, "createStyles")) __webpack_require__.d(__webpack_exports__, "createStyles", function() { return __WEBPACK_IMPORTED_MODULE_1__styles__["createStyles"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_1__styles__, "jssPreset")) __webpack_require__.d(__webpack_exports__, "jssPreset", function() { return __WEBPACK_IMPORTED_MODULE_1__styles__["jssPreset"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_1__styles__, "MuiThemeProvider")) __webpack_require__.d(__webpack_exports__, "MuiThemeProvider", function() { return __WEBPACK_IMPORTED_MODULE_1__styles__["MuiThemeProvider"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_1__styles__, "withStyles")) __webpack_require__.d(__webpack_exports__, "withStyles", function() { return __WEBPACK_IMPORTED_MODULE_1__styles__["withStyles"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_1__styles__, "withTheme")) __webpack_require__.d(__webpack_exports__, "withTheme", function() { return __WEBPACK_IMPORTED_MODULE_1__styles__["withTheme"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppBar__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__AppBar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "AppBar", function() { return __WEBPACK_IMPORTED_MODULE_2__AppBar___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Avatar__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Avatar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Avatar", function() { return __WEBPACK_IMPORTED_MODULE_3__Avatar___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Backdrop__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Backdrop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Backdrop__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Backdrop", function() { return __WEBPACK_IMPORTED_MODULE_4__Backdrop___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Badge__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Badge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Badge__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_5__Badge___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BottomNavigation__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BottomNavigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__BottomNavigation__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "BottomNavigation", function() { return __WEBPACK_IMPORTED_MODULE_6__BottomNavigation___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BottomNavigationAction__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BottomNavigationAction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__BottomNavigationAction__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "BottomNavigationAction", function() { return __WEBPACK_IMPORTED_MODULE_7__BottomNavigationAction___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Button__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Button", function() { return __WEBPACK_IMPORTED_MODULE_8__Button___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ButtonBase__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ButtonBase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ButtonBase__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ButtonBase", function() { return __WEBPACK_IMPORTED_MODULE_9__ButtonBase___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Card__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Card__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Card", function() { return __WEBPACK_IMPORTED_MODULE_10__Card___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CardActions__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CardActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__CardActions__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CardActions", function() { return __WEBPACK_IMPORTED_MODULE_11__CardActions___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CardContent__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CardContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__CardContent__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CardContent", function() { return __WEBPACK_IMPORTED_MODULE_12__CardContent___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CardHeader__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CardHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__CardHeader__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CardHeader", function() { return __WEBPACK_IMPORTED_MODULE_13__CardHeader___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CardMedia__ = __webpack_require__(1002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CardMedia___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__CardMedia__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CardMedia", function() { return __WEBPACK_IMPORTED_MODULE_14__CardMedia___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Checkbox__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__Checkbox__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Checkbox", function() { return __WEBPACK_IMPORTED_MODULE_15__Checkbox___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Chip__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Chip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__Chip__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Chip", function() { return __WEBPACK_IMPORTED_MODULE_16__Chip___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__CircularProgress__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CircularProgress", function() { return __WEBPACK_IMPORTED_MODULE_17__CircularProgress___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ClickAwayListener__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ClickAwayListener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__ClickAwayListener__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ClickAwayListener", function() { return __WEBPACK_IMPORTED_MODULE_18__ClickAwayListener___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Collapse__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__Collapse__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Collapse", function() { return __WEBPACK_IMPORTED_MODULE_19__Collapse___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__CssBaseline__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__CssBaseline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__CssBaseline__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "CssBaseline", function() { return __WEBPACK_IMPORTED_MODULE_20__CssBaseline___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Dialog__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__Dialog__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Dialog", function() { return __WEBPACK_IMPORTED_MODULE_21__Dialog___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__DialogActions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__DialogActions__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DialogActions", function() { return __WEBPACK_IMPORTED_MODULE_22__DialogActions___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__DialogContent__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__DialogContent__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DialogContent", function() { return __WEBPACK_IMPORTED_MODULE_23__DialogContent___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__DialogContentText__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__DialogContentText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__DialogContentText__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DialogContentText", function() { return __WEBPACK_IMPORTED_MODULE_24__DialogContentText___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__DialogTitle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__DialogTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__DialogTitle__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "DialogTitle", function() { return __WEBPACK_IMPORTED_MODULE_25__DialogTitle___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__Divider__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Divider", function() { return __WEBPACK_IMPORTED_MODULE_26__Divider___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Drawer__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Drawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__Drawer__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Drawer", function() { return __WEBPACK_IMPORTED_MODULE_27__Drawer___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__ExpansionPanel__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__ExpansionPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__ExpansionPanel__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ExpansionPanel", function() { return __WEBPACK_IMPORTED_MODULE_28__ExpansionPanel___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__ExpansionPanelActions__ = __webpack_require__(1011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__ExpansionPanelActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__ExpansionPanelActions__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ExpansionPanelActions", function() { return __WEBPACK_IMPORTED_MODULE_29__ExpansionPanelActions___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__ExpansionPanelDetails__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__ExpansionPanelDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__ExpansionPanelDetails__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ExpansionPanelDetails", function() { return __WEBPACK_IMPORTED_MODULE_30__ExpansionPanelDetails___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__ExpansionPanelSummary__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__ExpansionPanelSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__ExpansionPanelSummary__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ExpansionPanelSummary", function() { return __WEBPACK_IMPORTED_MODULE_31__ExpansionPanelSummary___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Fade__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Fade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__Fade__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Fade", function() { return __WEBPACK_IMPORTED_MODULE_32__Fade___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__FormControl__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "FormControl", function() { return __WEBPACK_IMPORTED_MODULE_33__FormControl___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__FormControlLabel__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__FormControlLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__FormControlLabel__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "FormControlLabel", function() { return __WEBPACK_IMPORTED_MODULE_34__FormControlLabel___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__FormGroup__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__FormGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__FormGroup__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "FormGroup", function() { return __WEBPACK_IMPORTED_MODULE_35__FormGroup___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__FormHelperText__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__FormHelperText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__FormHelperText__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "FormHelperText", function() { return __WEBPACK_IMPORTED_MODULE_36__FormHelperText___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__FormLabel__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__FormLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__FormLabel__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "FormLabel", function() { return __WEBPACK_IMPORTED_MODULE_37__FormLabel___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__Grid__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Grid", function() { return __WEBPACK_IMPORTED_MODULE_38__Grid___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__GridList__ = __webpack_require__(1017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__GridList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__GridList__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "GridList", function() { return __WEBPACK_IMPORTED_MODULE_39__GridList___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__GridListTile__ = __webpack_require__(1019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__GridListTile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__GridListTile__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "GridListTile", function() { return __WEBPACK_IMPORTED_MODULE_40__GridListTile___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__GridListTileBar__ = __webpack_require__(1021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__GridListTileBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__GridListTileBar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "GridListTileBar", function() { return __WEBPACK_IMPORTED_MODULE_41__GridListTileBar___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__Grow__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__Grow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__Grow__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Grow", function() { return __WEBPACK_IMPORTED_MODULE_42__Grow___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__Hidden__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__Hidden___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__Hidden__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Hidden", function() { return __WEBPACK_IMPORTED_MODULE_43__Hidden___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__Icon__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__Icon__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Icon", function() { return __WEBPACK_IMPORTED_MODULE_44__Icon___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__IconButton__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__IconButton__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "IconButton", function() { return __WEBPACK_IMPORTED_MODULE_45__IconButton___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__Input__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__Input__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Input", function() { return __WEBPACK_IMPORTED_MODULE_46__Input___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__InputAdornment__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__InputAdornment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__InputAdornment__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "InputAdornment", function() { return __WEBPACK_IMPORTED_MODULE_47__InputAdornment___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__InputLabel__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "InputLabel", function() { return __WEBPACK_IMPORTED_MODULE_48__InputLabel___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__LinearProgress__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__LinearProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__LinearProgress__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "LinearProgress", function() { return __WEBPACK_IMPORTED_MODULE_49__LinearProgress___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__List__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__List__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "List", function() { return __WEBPACK_IMPORTED_MODULE_50__List___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__ListItem__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__ListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__ListItem__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ListItem", function() { return __WEBPACK_IMPORTED_MODULE_51__ListItem___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__ListItemAvatar__ = __webpack_require__(1028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__ListItemAvatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__ListItemAvatar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ListItemAvatar", function() { return __WEBPACK_IMPORTED_MODULE_52__ListItemAvatar___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__ListItemIcon__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__ListItemIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__ListItemIcon__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ListItemIcon", function() { return __WEBPACK_IMPORTED_MODULE_53__ListItemIcon___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__ListItemSecondaryAction__ = __webpack_require__(1031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__ListItemSecondaryAction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__ListItemSecondaryAction__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ListItemSecondaryAction", function() { return __WEBPACK_IMPORTED_MODULE_54__ListItemSecondaryAction___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__ListItemText__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__ListItemText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__ListItemText__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ListItemText", function() { return __WEBPACK_IMPORTED_MODULE_55__ListItemText___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__ListSubheader__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__ListSubheader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__ListSubheader__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ListSubheader", function() { return __WEBPACK_IMPORTED_MODULE_56__ListSubheader___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__Menu__ = __webpack_require__(1035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__Menu__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Menu", function() { return __WEBPACK_IMPORTED_MODULE_57__Menu___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__MenuItem__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MenuItem", function() { return __WEBPACK_IMPORTED_MODULE_58__MenuItem___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__MenuList__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__MenuList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__MenuList__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MenuList", function() { return __WEBPACK_IMPORTED_MODULE_59__MenuList___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__MobileStepper__ = __webpack_require__(1036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__MobileStepper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60__MobileStepper__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "MobileStepper", function() { return __WEBPACK_IMPORTED_MODULE_60__MobileStepper___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__Modal__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61__Modal__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Modal", function() { return __WEBPACK_IMPORTED_MODULE_61__Modal___default.a; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_61__Modal__, "ModalManager")) __webpack_require__.d(__webpack_exports__, "ModalManager", function() { return __WEBPACK_IMPORTED_MODULE_61__Modal__["ModalManager"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__NativeSelect__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__NativeSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62__NativeSelect__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NativeSelect", function() { return __WEBPACK_IMPORTED_MODULE_62__NativeSelect___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__NoSsr__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__NoSsr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63__NoSsr__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "NoSsr", function() { return __WEBPACK_IMPORTED_MODULE_63__NoSsr___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__Paper__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64__Paper__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Paper", function() { return __WEBPACK_IMPORTED_MODULE_64__Paper___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__Popover__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__Popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65__Popover__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Popover", function() { return __WEBPACK_IMPORTED_MODULE_65__Popover___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__Popper__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__Popper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66__Popper__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Popper", function() { return __WEBPACK_IMPORTED_MODULE_66__Popper___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__Portal__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__Portal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67__Portal__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Portal", function() { return __WEBPACK_IMPORTED_MODULE_67__Portal___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__Radio__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__Radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68__Radio__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Radio", function() { return __WEBPACK_IMPORTED_MODULE_68__Radio___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__RadioGroup__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__RadioGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69__RadioGroup__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "RadioGroup", function() { return __WEBPACK_IMPORTED_MODULE_69__RadioGroup___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__RootRef__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__RootRef___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70__RootRef__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "RootRef", function() { return __WEBPACK_IMPORTED_MODULE_70__RootRef___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71__Select__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Select", function() { return __WEBPACK_IMPORTED_MODULE_71__Select___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__Slide__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__Slide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72__Slide__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Slide", function() { return __WEBPACK_IMPORTED_MODULE_72__Slide___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__Snackbar__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__Snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73__Snackbar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Snackbar", function() { return __WEBPACK_IMPORTED_MODULE_73__Snackbar___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__SnackbarContent__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__SnackbarContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74__SnackbarContent__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "SnackbarContent", function() { return __WEBPACK_IMPORTED_MODULE_74__SnackbarContent___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__Step__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__Step___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75__Step__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Step", function() { return __WEBPACK_IMPORTED_MODULE_75__Step___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__StepButton__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__StepButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76__StepButton__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "StepButton", function() { return __WEBPACK_IMPORTED_MODULE_76__StepButton___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__StepConnector__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__StepConnector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77__StepConnector__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "StepConnector", function() { return __WEBPACK_IMPORTED_MODULE_77__StepConnector___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__StepContent__ = __webpack_require__(1052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__StepContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78__StepContent__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "StepContent", function() { return __WEBPACK_IMPORTED_MODULE_78__StepContent___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__StepIcon__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__StepIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79__StepIcon__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "StepIcon", function() { return __WEBPACK_IMPORTED_MODULE_79__StepIcon___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__StepLabel__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__StepLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80__StepLabel__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "StepLabel", function() { return __WEBPACK_IMPORTED_MODULE_80__StepLabel___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__Stepper__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__Stepper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81__Stepper__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Stepper", function() { return __WEBPACK_IMPORTED_MODULE_81__Stepper___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__SvgIcon__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__SvgIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82__SvgIcon__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "SvgIcon", function() { return __WEBPACK_IMPORTED_MODULE_82__SvgIcon___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__SwipeableDrawer__ = __webpack_require__(1055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__SwipeableDrawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83__SwipeableDrawer__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "SwipeableDrawer", function() { return __WEBPACK_IMPORTED_MODULE_83__SwipeableDrawer___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__Switch__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__Switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_84__Switch__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Switch", function() { return __WEBPACK_IMPORTED_MODULE_84__Switch___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__Table__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_85__Table__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Table", function() { return __WEBPACK_IMPORTED_MODULE_85__Table___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__TableBody__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__TableBody___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_86__TableBody__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "TableBody", function() { return __WEBPACK_IMPORTED_MODULE_86__TableBody___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__TableCell__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__TableCell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_87__TableCell__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "TableCell", function() { return __WEBPACK_IMPORTED_MODULE_87__TableCell___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__TableFooter__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__TableFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_88__TableFooter__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "TableFooter", function() { return __WEBPACK_IMPORTED_MODULE_88__TableFooter___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__TableHead__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__TableHead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_89__TableHead__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "TableHead", function() { return __WEBPACK_IMPORTED_MODULE_89__TableHead___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__TablePagination__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__TablePagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_90__TablePagination__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "TablePagination", function() { return __WEBPACK_IMPORTED_MODULE_90__TablePagination___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__TableRow__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__TableRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_91__TableRow__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "TableRow", function() { return __WEBPACK_IMPORTED_MODULE_91__TableRow___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__TableSortLabel__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__TableSortLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_92__TableSortLabel__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "TableSortLabel", function() { return __WEBPACK_IMPORTED_MODULE_92__TableSortLabel___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__Tabs__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_93__Tabs__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Tabs", function() { return __WEBPACK_IMPORTED_MODULE_93__Tabs___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__Tab__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__Tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_94__Tab__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Tab", function() { return __WEBPACK_IMPORTED_MODULE_94__Tab___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_95__TextField__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "TextField", function() { return __WEBPACK_IMPORTED_MODULE_95__TextField___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__Toolbar__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_96__Toolbar__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Toolbar", function() { return __WEBPACK_IMPORTED_MODULE_96__Toolbar___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__Tooltip__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__Tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_97__Tooltip__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_97__Tooltip___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_98__Typography__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Typography", function() { return __WEBPACK_IMPORTED_MODULE_98__Typography___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__withMobileDialog__ = __webpack_require__(1059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__withMobileDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_99__withMobileDialog__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "withMobileDialog", function() { return __WEBPACK_IMPORTED_MODULE_99__withMobileDialog___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__withWidth__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__withWidth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_100__withWidth__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "withWidth", function() { return __WEBPACK_IMPORTED_MODULE_100__withWidth___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__Zoom__ = __webpack_require__(1061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__Zoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_101__Zoom__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Zoom", function() { return __WEBPACK_IMPORTED_MODULE_101__Zoom___default.a; });
/** @license Material-UI v1.5.1
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */









































































































/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(144);

var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.sheetsManager = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _warning = _interopRequireDefault(__webpack_require__(37));

var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(94));

var _getDisplayName = _interopRequireDefault(__webpack_require__(296));

var _wrapDisplayName = _interopRequireDefault(__webpack_require__(175));

var _contextTypes = _interopRequireDefault(__webpack_require__(793));

var _jss = __webpack_require__(441);

var ns = _interopRequireWildcard(__webpack_require__(448));

var _jssPreset = _interopRequireDefault(__webpack_require__(440));

var _mergeClasses = _interopRequireDefault(__webpack_require__(449));

var _createMuiTheme = _interopRequireDefault(__webpack_require__(290));

var _themeListener = _interopRequireDefault(__webpack_require__(295));

var _createGenerateClassName = _interopRequireDefault(__webpack_require__(433));

var _getStylesCreator = _interopRequireDefault(__webpack_require__(795));

var _getThemeProps = _interopRequireDefault(__webpack_require__(450));

// Default JSS instance.
var jss = (0, _jss.create)((0, _jssPreset.default)()); // Use a singleton or the provided one by the context.

var generateClassName = (0, _createGenerateClassName.default)(); // Global index counter to preserve source order.
// We create the style sheet during at the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any childs styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.

var indexCounter = -10e10; // Exported for test purposes

var sheetsManager = new Map(); // We use the same empty object to ref count the styles that don't need a theme object.

exports.sheetsManager = sheetsManager;
var noopTheme = {}; // In order to have self-supporting components, we rely on default theme when not provided.

var defaultTheme;

function getDefaultTheme() {
  if (defaultTheme) {
    return defaultTheme;
  }

  defaultTheme = (0, _createMuiTheme.default)();
  return defaultTheme;
} // Link a style sheet with a component.
// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.


var withStyles = function withStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (Component) {
    var _options$withTheme = options.withTheme,
        withTheme = _options$withTheme === void 0 ? false : _options$withTheme,
        _options$flip = options.flip,
        flip = _options$flip === void 0 ? null : _options$flip,
        name = options.name,
        styleSheetOptions = (0, _objectWithoutProperties2.default)(options, ["withTheme", "flip", "name"]);
    var stylesCreator = (0, _getStylesCreator.default)(stylesOrCreator);
    var listenToTheme = stylesCreator.themingEnabled || withTheme || typeof name === 'string';
    indexCounter += 1;
    stylesCreator.options.index = indexCounter;
     false ? (0, _warning.default)(indexCounter < 0, ['Material-UI: you might have a memory leak.', 'The indexCounter is not supposed to grow that much.'].join(' ')) : void 0;

    var WithStyles =
    /*#__PURE__*/
    function (_React$Component) {
      (0, _inherits2.default)(WithStyles, _React$Component);

      function WithStyles(props, context) {
        var _this;

        (0, _classCallCheck2.default)(this, WithStyles);
        _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(WithStyles).call(this, props, context));
        _this.disableStylesGeneration = false;
        _this.jss = null;
        _this.sheetOptions = null;
        _this.sheetsManager = sheetsManager;
        _this.stylesCreatorSaved = null;
        _this.theme = null;
        _this.unsubscribeId = null;
        _this.state = {};
        _this.jss = context[ns.jss] || jss;
        var muiThemeProviderOptions = context.muiThemeProviderOptions;

        if (muiThemeProviderOptions) {
          if (muiThemeProviderOptions.sheetsManager) {
            _this.sheetsManager = muiThemeProviderOptions.sheetsManager;
          }

          _this.disableStylesGeneration = muiThemeProviderOptions.disableStylesGeneration;
        } // Attach the stylesCreator to the instance of the component as in the context
        // of react-hot-loader the hooks can be executed in a different closure context:
        // https://github.com/gaearon/react-hot-loader/blob/master/src/patch.dev.js#L107


        _this.stylesCreatorSaved = stylesCreator;
        _this.sheetOptions = (0, _extends2.default)({
          generateClassName: generateClassName
        }, context[ns.sheetOptions]); // We use || as the function call is lazy evaluated.

        _this.theme = listenToTheme ? _themeListener.default.initial(context) || getDefaultTheme() : noopTheme;

        _this.attach(_this.theme);

        _this.cacheClasses = {
          // Cache for the finalized classes value.
          value: null,
          // Cache for the last used classes prop pointer.
          lastProp: null,
          // Cache for the last used rendered classes pointer.
          lastJSS: {}
        };
        return _this;
      }

      (0, _createClass2.default)(WithStyles, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var _this2 = this;

          if (!listenToTheme) {
            return;
          }

          this.unsubscribeId = _themeListener.default.subscribe(this.context, function (theme) {
            var oldTheme = _this2.theme;
            _this2.theme = theme;

            _this2.attach(_this2.theme); // Rerender the component so the underlying component gets the theme update.
            // By theme update we mean receiving and applying the new class names.


            _this2.setState({}, function () {
              _this2.detach(oldTheme);
            });
          });
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
          // react-hot-loader specific logic
          if (this.stylesCreatorSaved === stylesCreator || "production" === 'production') {
            return;
          }

          this.detach(this.theme);
          this.stylesCreatorSaved = stylesCreator;
          this.attach(this.theme);
          this.forceUpdate();
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.detach(this.theme);

          if (this.unsubscribeId !== null) {
            _themeListener.default.unsubscribe(this.context, this.unsubscribeId);
          }
        }
      }, {
        key: "getClasses",
        value: function getClasses() {
          // Tracks if either the rendered classes or classes prop has changed,
          // requiring the generation of a new finalized classes object.
          var generate = false;

          if (!this.disableStylesGeneration) {
            var sheetManager = this.sheetsManager.get(this.stylesCreatorSaved);
            var sheetsManagerTheme = sheetManager.get(this.theme);

            if (sheetsManagerTheme.sheet.classes !== this.cacheClasses.lastJSS) {
              this.cacheClasses.lastJSS = sheetsManagerTheme.sheet.classes;
              generate = true;
            }
          }

          if (this.props.classes !== this.cacheClasses.lastProp) {
            this.cacheClasses.lastProp = this.props.classes;
            generate = true;
          }

          if (generate) {
            this.cacheClasses.value = (0, _mergeClasses.default)({
              baseClasses: this.cacheClasses.lastJSS,
              newClasses: this.props.classes,
              Component: Component,
              noBase: this.disableStylesGeneration
            });
          }

          return this.cacheClasses.value;
        }
      }, {
        key: "attach",
        value: function attach(theme) {
          if (this.disableStylesGeneration) {
            return;
          }

          var stylesCreatorSaved = this.stylesCreatorSaved;
          var sheetManager = this.sheetsManager.get(stylesCreatorSaved);

          if (!sheetManager) {
            sheetManager = new Map();
            this.sheetsManager.set(stylesCreatorSaved, sheetManager);
          }

          var sheetManagerTheme = sheetManager.get(theme);

          if (!sheetManagerTheme) {
            sheetManagerTheme = {
              refs: 0,
              sheet: null
            };
            sheetManager.set(theme, sheetManagerTheme);
          }

          if (sheetManagerTheme.refs === 0) {
            var styles = stylesCreatorSaved.create(theme, name);
            var meta = name;

            if (false) {
              meta = (0, _getDisplayName.default)(Component);
              process.env.NODE_ENV !== "production" ? (0, _warning.default)(typeof meta === 'string', ['Material-UI: the component displayName is invalid. It needs to be a string.', "Please fix the following component: ".concat(Component, ".")].join('\n')) : void 0;
            }

            var sheet = this.jss.createStyleSheet(styles, (0, _extends2.default)({
              meta: meta,
              classNamePrefix: meta,
              flip: typeof flip === 'boolean' ? flip : theme.direction === 'rtl',
              link: false
            }, this.sheetOptions, stylesCreatorSaved.options, {
              name: name
            }, styleSheetOptions));
            sheetManagerTheme.sheet = sheet;
            sheet.attach();
            var sheetsRegistry = this.context[ns.sheetsRegistry];

            if (sheetsRegistry) {
              sheetsRegistry.add(sheet);
            }
          }

          sheetManagerTheme.refs += 1;
        }
      }, {
        key: "detach",
        value: function detach(theme) {
          if (this.disableStylesGeneration) {
            return;
          }

          var stylesCreatorSaved = this.stylesCreatorSaved;
          var sheetManager = this.sheetsManager.get(stylesCreatorSaved);
          var sheetManagerTheme = sheetManager.get(theme);
          sheetManagerTheme.refs -= 1;

          if (sheetManagerTheme.refs === 0) {
            sheetManager.delete(theme);
            this.jss.removeStyleSheet(sheetManagerTheme.sheet);
            var sheetsRegistry = this.context[ns.sheetsRegistry];

            if (sheetsRegistry) {
              sheetsRegistry.remove(sheetManagerTheme.sheet);
            }
          }
        }
      }, {
        key: "render",
        value: function render() {
          var _this$props = this.props,
              classes = _this$props.classes,
              innerRef = _this$props.innerRef,
              other = (0, _objectWithoutProperties2.default)(_this$props, ["classes", "innerRef"]);
          var more = (0, _getThemeProps.default)({
            theme: this.theme,
            name: name
          }); // Provide the theme to the wrapped component.
          // So we don't have to use the `withTheme()` Higher-order Component.

          if (withTheme) {
            more.theme = this.theme;
          }

          return _react.default.createElement(Component, (0, _extends2.default)({}, more, {
            classes: this.getClasses(),
            ref: innerRef
          }, other));
        }
      }]);
      return WithStyles;
    }(_react.default.Component);

    WithStyles.propTypes =  false ? {
      /**
       * Override or extend the styles applied to the component.
       */
      classes: _propTypes.default.object,

      /**
       * Use that property to pass a ref callback to the decorated component.
       */
      innerRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object])
    } : {};
    WithStyles.contextTypes = (0, _extends2.default)({
      muiThemeProviderOptions: _propTypes.default.object
    }, _contextTypes.default, listenToTheme ? _themeListener.default.contextTypes : {});

    if (false) {
      WithStyles.displayName = (0, _wrapDisplayName.default)(Component, 'WithStyles');
    }

    (0, _hoistNonReactStatics.default)(WithStyles, Component);

    if (false) {
      // Exposed for test purposes.
      WithStyles.Naked = Component;
      WithStyles.options = options;
    }

    return WithStyles;
  };
};

var _default = withStyles;
exports.default = _default;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TextField.default;
  }
});

var _TextField = _interopRequireDefault(__webpack_require__(838));

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FormControl.default;
  }
});

var _FormControl = _interopRequireDefault(__webpack_require__(854));

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withSharedSnackbar_jsx__ = __webpack_require__(241);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__withSharedSnackbar_jsx__["a"]; });


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _interopDefault(e){return e&&"object"==typeof e&&"default"in e?e.default:e}Object.defineProperty(exports,"__esModule",{value:!0});var Paper=_interopDefault(__webpack_require__(49)),styles=__webpack_require__(5),MuiTable=_interopDefault(__webpack_require__(228)),classNames=_interopDefault(__webpack_require__(16)),assignwith=_interopDefault(__webpack_require__(908)),cloneDeep=_interopDefault(__webpack_require__(909)),find=_interopDefault(__webpack_require__(910)),isUndefined=_interopDefault(__webpack_require__(911)),merge=_interopDefault(__webpack_require__(912)),propTypes=_interopDefault(__webpack_require__(3)),React=__webpack_require__(0),React__default=_interopDefault(React),Typography=_interopDefault(__webpack_require__(13)),MuiTableBody=_interopDefault(__webpack_require__(229)),TableCell=_interopDefault(__webpack_require__(179)),TableRow=_interopDefault(__webpack_require__(230)),Checkbox=_interopDefault(__webpack_require__(61)),IconButton=_interopDefault(__webpack_require__(71)),KeyboardArrowRight=_interopDefault(__webpack_require__(480)),Chip=_interopDefault(__webpack_require__(110)),MuiTableHead=_interopDefault(__webpack_require__(321)),reactDom=__webpack_require__(64),TableSortLabel=_interopDefault(__webpack_require__(322)),Tooltip=_interopDefault(__webpack_require__(85)),HelpIcon=_interopDefault(__webpack_require__(497)),MuiTableFooter=_interopDefault(__webpack_require__(498)),MuiTablePagination=_interopDefault(__webpack_require__(323)),Toolbar=_interopDefault(__webpack_require__(121)),MuiPopover=_interopDefault(__webpack_require__(177)),core=__webpack_require__(15),Button=_interopDefault(__webpack_require__(8)),FormControl=_interopDefault(__webpack_require__(19)),FormControlLabel=_interopDefault(__webpack_require__(56)),FormGroup=_interopDefault(__webpack_require__(42)),Input=_interopDefault(__webpack_require__(76)),InputLabel=_interopDefault(__webpack_require__(26)),ListItemText=_interopDefault(__webpack_require__(124)),MenuItem=_interopDefault(__webpack_require__(23)),Select=_interopDefault(__webpack_require__(24)),Grow=_interopDefault(__webpack_require__(226)),TextField$1=_interopDefault(__webpack_require__(18)),SearchIcon=_interopDefault(__webpack_require__(183)),ClearIcon=_interopDefault(__webpack_require__(516)),DownloadIcon=_interopDefault(__webpack_require__(517)),PrintIcon=_interopDefault(__webpack_require__(518)),ViewColumnIcon=_interopDefault(__webpack_require__(519)),FilterIcon=_interopDefault(__webpack_require__(327)),ReactToPrint=_interopDefault(__webpack_require__(1063)),DeleteIcon=_interopDefault(__webpack_require__(240)),_typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},classCallCheck=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")},createClass=function(){function e(e,t){for(var a=0;a<t.length;a++){var o=t[a];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,a,o){return a&&e(t.prototype,a),o&&e(t,o),t}}(),defineProperty=function(e,t,a){return t in e?Object.defineProperty(e,t,{value:a,enumerable:!0,configurable:!0,writable:!0}):e[t]=a,e},_extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var a=arguments[t];for(var o in a)Object.prototype.hasOwnProperty.call(a,o)&&(e[o]=a[o])}return e},inherits=function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)},objectWithoutProperties=function(e,t){var a={};for(var o in e)t.indexOf(o)>=0||Object.prototype.hasOwnProperty.call(e,o)&&(a[o]=e[o]);return a},possibleConstructorReturn=function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t},slicedToArray=function(){return function(e,t){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return function(e,t){var a=[],o=!0,n=!1,r=void 0;try{for(var l,i=e[Symbol.iterator]();!(o=(l=i.next()).done)&&(a.push(l.value),!t||a.length!==t);o=!0);}catch(e){n=!0,r=e}finally{try{!o&&i.return&&i.return()}finally{if(n)throw r}}return a}(e,t);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),toConsumableArray=function(e){if(Array.isArray(e)){for(var t=0,a=Array(e.length);t<e.length;t++)a[t]=e[t];return a}return Array.from(e)},defaultBodyCellStyles=function(e){var t;return{root:{},cellHide:{display:"none"},stackedCommon:defineProperty({},e.breakpoints.down("sm"),(t={display:"inline-block",fontSize:"16px",height:"24px",whiteSpace:"nowrap",width:"calc(50% - 80px)"},defineProperty(t,"whiteSpace","nowrap"),defineProperty(t,"&:last-child",{borderBottom:"none"}),defineProperty(t,"&:nth-last-child(2)",{borderBottom:"none"}),t)),cellStackedSmall:defineProperty({},e.breakpoints.down("sm"),{width:"50%"}),responsiveStackedSmall:defineProperty({},e.breakpoints.down("sm"),{width:"50%"})}},TableBodyCell=function(e){function t(){var e,a,o;classCallCheck(this,t);for(var n=arguments.length,r=Array(n),l=0;l<n;l++)r[l]=arguments[l];return a=o=possibleConstructorReturn(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(r))),o.handleClick=function(e){var t=o.props,a=t.colIndex,n=t.options,r=t.children,l=t.dataIndex,i=t.rowIndex;n.onCellClick&&n.onCellClick(r,{colIndex:a,rowIndex:i,dataIndex:l,event:e})},possibleConstructorReturn(o,a)}return inherits(t,e),createClass(t,[{key:"render",value:function(){var e,t,a=this.props,o=a.children,n=a.classes,r=(a.colIndex,a.columnHeader),l=a.options,i=(a.dataIndex,a.rowIndex,a.className),s=a.print,c=objectWithoutProperties(a,["children","classes","colIndex","columnHeader","options","dataIndex","rowIndex","className","print"]);return[React__default.createElement(TableCell,{key:1,className:classNames((e={},defineProperty(e,n.root,!0),defineProperty(e,n.cellHide,!0),defineProperty(e,n.stackedCommon,"stacked"===l.responsive||"stackedFullWidth"===l.responsive),defineProperty(e,n.cellStackedSmall,"stacked"===l.responsive||"stackedFullWidth"===l.responsive&&("none"===l.setTableProps().padding||"small"===l.setTableProps().size)),defineProperty(e,"datatables-noprint",!s),e),i)},r),React__default.createElement(TableCell,_extends({key:2,onClick:this.handleClick,className:classNames((t={},defineProperty(t,n.root,!0),defineProperty(t,n.stackedCommon,"stacked"===l.responsive||"stackedFullWidth"===l.responsive),defineProperty(t,n.responsiveStackedSmall,"stacked"===l.responsive||"stackedFullWidth"===l.responsive&&("none"===l.setTableProps().padding||"small"===l.setTableProps().size)),defineProperty(t,"datatables-noprint",!s),t),i)},c),o)]}}]),t}(React__default.Component),TableBodyCell$1=styles.withStyles(defaultBodyCellStyles,{name:"MUIDataTableBodyCell"})(TableBodyCell),defaultBodyRowStyles=function(e){return{root:{},hover:{},hoverCursor:{cursor:"pointer"},responsiveStacked:defineProperty({},e.breakpoints.down("sm"),{border:"solid 2px rgba(0, 0, 0, 0.15)"})}},TableBodyRow=function(e){function t(){return classCallCheck(this,t),possibleConstructorReturn(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return inherits(t,e),createClass(t,[{key:"render",value:function(){var e,t=this.props,a=t.classes,o=t.options,n=t.rowSelected,r=t.onClick,l=t.className,i=objectWithoutProperties(t,["classes","options","rowSelected","onClick","className"]);return React__default.createElement(TableRow,_extends({hover:!!o.rowHover,onClick:r,className:classNames((e={},defineProperty(e,a.root,!0),defineProperty(e,a.hover,o.rowHover),defineProperty(e,a.hoverCursor,o.selectableRowsOnClick||o.expandableRowsOnClick),defineProperty(e,a.responsiveStacked,"stacked"===o.responsive||"stackedFullWidth"===o.responsive),e),l),selected:n},i),this.props.children)}}]),t}(React__default.Component),TableBodyRow$1=styles.withStyles(defaultBodyRowStyles,{name:"MUIDataTableBodyRow"})(TableBodyRow),defaultSelectCellStyles=function(e){return{root:{},fixedHeader:{position:"sticky",top:"0px",left:"0px",zIndex:100},fixedHeaderCommon:{position:"sticky",zIndex:100,backgroundColor:e.palette.background.paper},fixedHeaderXAxis:{left:"0px"},fixedHeaderYAxis:{top:"0px"},icon:{cursor:"pointer",transition:"transform 0.25s"},expanded:{transform:"rotate(90deg)"},hide:{visibility:"hidden"},headerCell:{zIndex:110,backgroundColor:e.palette.background.paper},expandDisabled:{},checkboxRoot:{},checked:{},disabled:{}}},TableSelectCell=function(e){function t(){return classCallCheck(this,t),possibleConstructorReturn(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return inherits(t,e),createClass(t,[{key:"render",value:function(){var e,t,a=this.props,o=a.classes,n=a.fixedHeader,r=a.fixedHeaderOptions,l=a.isHeaderCell,i=a.expandableOn,s=a.selectableOn,c=a.isRowExpanded,d=a.onExpand,u=a.isRowSelectable,p=a.selectableRowsHeader,f=a.hideExpandButton,h=objectWithoutProperties(a,["classes","fixedHeader","fixedHeaderOptions","isHeaderCell","expandableOn","selectableOn","isRowExpanded","onExpand","isRowSelectable","selectableRowsHeader","hideExpandButton"]),m=void 0;if(!i&&"none"===s)return!1;n&&(m=o.fixedHeader),r&&(m=o.fixedHeaderCommon,r.xAxis&&(m+=" "+o.fixedHeaderXAxis),r.yAxis&&(m+=" "+o.fixedHeaderYAxis));var b=classNames((defineProperty(e={},o.root,!0),defineProperty(e,m,!0),defineProperty(e,o.headerCell,l),e)),y=classNames(defineProperty({},o.expandDisabled,f)),x=classNames((defineProperty(t={},o.icon,!0),defineProperty(t,o.hide,l),defineProperty(t,o.expanded,c),t));return React__default.createElement(TableCell,{className:b,padding:"checkbox"},React__default.createElement("div",{style:{display:"flex",alignItems:"center"}},i&&React__default.createElement(IconButton,{onClick:d,disabled:l,className:y},React__default.createElement(KeyboardArrowRight,{id:"expandable-button",className:x})),"none"!==s&&(!l||"multiple"===s&&!1!==p?React__default.createElement(Checkbox,_extends({classes:{root:o.checkboxRoot,checked:o.checked,disabled:o.disabled},color:"primary",disabled:!u},h)):null)))}}]),t}(React__default.Component);TableSelectCell.defaultProps={isHeaderCell:!1,isRowExpanded:!1,expandableOn:!1,selectableOn:"none"};var TableSelectCell$1=styles.withStyles(defaultSelectCellStyles,{name:"MUIDataTableSelectCell"})(TableSelectCell);function buildMap(e){return e.reduce(function(e,t){return e[t.dataIndex]=!0,e},{})}function escapeDangerousCSVCharacters(e){return"string"==typeof e?e.replace(/^\+|^\-|^\=|^\@/g,"'$&"):e}function getPageValue(e,t,a){var o=e<=t?1:Math.ceil(e/t);return a>=o?o-1:a}function getCollatorComparator(){if(Intl)return new Intl.Collator(void 0,{numeric:!0,sensitivity:"base"}).compare;return function(e,t){return e.localeCompare(t)}}function sortCompare(e){return function(t,a){var o=null===t.data||void 0===t.data?"":t.data,n=null===a.data||void 0===a.data?"":a.data;return("function"==typeof o.localeCompare?o.localeCompare(n):o-n)*("asc"===e?1:-1)}}function buildCSV(e,t,a){var o=function(e){return"string"==typeof e?e.replace(/\"/g,'""'):e},n=function(e){return e.reduce(function(e,t){return t.download?e+'"'+escapeDangerousCSVCharacters(o(t.label||t.name))+'"'+a.downloadOptions.separator:e},"").slice(0,-1)+"\r\n"},r=n(e),l=function(t){return t.length?t.reduce(function(t,n){return t+'"'+n.data.filter(function(t,a){return e[a].download}).map(function(e){return escapeDangerousCSVCharacters(o(e))}).join('"'+a.downloadOptions.separator+'"')+'"\r\n'},"").trim():""},i=l(t);return a.onDownload?a.onDownload(n,l,e,t):(""+r+i).trim()}function downloadCSV(e,t){var a=new Blob([e],{type:"text/csv"});if(navigator&&navigator.msSaveOrOpenBlob)navigator.msSaveOrOpenBlob(a,t);else{var o="data:text/csv;charset=utf-8,"+e,n=window.URL||window.webkitURL,r=void 0===n.createObjectURL?o:n.createObjectURL(a),l=document.createElement("a");l.setAttribute("href",r),l.setAttribute("download",t),document.body.appendChild(l),l.click(),document.body.removeChild(l)}}function createCSVDownload(e,t,a,o){var n=buildCSV(e,t,a);a.onDownload&&!1===n||o(n,a.downloadOptions.filename)}var defaultBodyStyles={root:{},emptyTitle:{textAlign:"center"}},TableBody=function(e){function t(){var e,a,o;classCallCheck(this,t);for(var n=arguments.length,r=Array(n),l=0;l<n;l++)r[l]=arguments[l];return a=o=possibleConstructorReturn(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(r))),o.handleRowSelect=function(e,t){var a=!(!t||!t.nativeEvent)&&t.nativeEvent.shiftKey,n=[],r=o.props.previousSelectedRow;if(a&&r&&r.index<o.props.data.length){var l=r.index,i=cloneDeep(o.props.selectedRows),s=o.props.data[e.index].dataIndex;0===i.data.filter(function(e){return e.dataIndex===s}).length&&(i.data.push({index:e.index,dataIndex:s}),i.lookup[s]=!0);for(var c=function(){var t=o.props.data[l].dataIndex;if(o.isRowSelectable(t,i)){var a={index:l,dataIndex:t};0===i.data.filter(function(e){return e.dataIndex===t}).length&&(i.data.push(a),i.lookup[t]=!0),n.push(a)}l=e.index>l?l+1:l-1};l!==e.index;)c()}o.props.selectRowUpdate("cell",e,n)},o.handleRowClick=function(e,t,a){if("expandable-button"===a.target.id||"path"===a.target.nodeName&&"expandable-button"===a.target.parentNode.id)o.props.options.onRowClick&&o.props.options.onRowClick(e,t,a);else if(!a.target.id||!a.target.id.startsWith("MUIDataTableSelectCell")){if(o.props.options.selectableRowsOnClick&&"none"!==o.props.options.selectableRows&&o.isRowSelectable(t.dataIndex,o.props.selectedRows)){var n={index:t.rowIndex,dataIndex:t.dataIndex};o.handleRowSelect(n,a)}if(o.props.options.expandableRowsOnClick&&o.props.options.expandableRows&&o.isRowExpandable(t.dataIndex,o.props.expandedRows)){var r={index:t.rowIndex,dataIndex:t.dataIndex};o.props.toggleExpandRow(r)}o.props.options.selectableRowsOnClick||o.props.options.onRowClick&&o.props.options.onRowClick(e,t,a)}},possibleConstructorReturn(o,a)}return inherits(t,e),createClass(t,[{key:"buildRows",value:function(){var e=this.props,t=e.data,a=e.page,o=e.rowsPerPage,n=e.count;if(this.props.options.serverSide)return t.length?t:null;var r=[],l=getPageValue(n,o,a),i=0===l?0:l*o,s=Math.min(n,(l+1)*o);a>l&&console.warn("Current page is out of range, using the highest page that is in range instead.");for(var c=i;c<n&&c<s;c++)void 0!==t[c]&&r.push(t[c]);return r.length?r:null}},{key:"getRowIndex",value:function(e){var t=this.props,a=t.page,o=t.rowsPerPage;return t.options.serverSide?e:(0===a?0:a*o)+e}},{key:"isRowSelected",value:function(e){var t=this.props.selectedRows;return!(!t.lookup||!t.lookup[e])}},{key:"isRowExpanded",value:function(e){var t=this.props.expandedRows;return!(!t.lookup||!t.lookup[e])}},{key:"isRowSelectable",value:function(e,t){var a=this.props.options;return t=t||this.props.selectedRows,!a.isRowSelectable||a.isRowSelectable(e,t)}},{key:"isRowExpandable",value:function(e){var t=this.props,a=t.options,o=t.expandedRows;return!a.isRowExpandable||a.isRowExpandable(e,o)}},{key:"render",value:function(){var e=this,t=this.props,a=t.classes,o=t.columns,n=t.toggleExpandRow,r=t.options,l=this.buildRows(),i=o.filter(function(e){return"true"===e.display}).length;return React__default.createElement(MuiTableBody,null,l&&l.length>0?l.map(function(t,a){var l=t.data,i=t.dataIndex;return r.customRowRender?r.customRowRender(l,i,a):React__default.createElement(React__default.Fragment,{key:a},React__default.createElement(TableBodyRow$1,_extends({},r.setRowProps?r.setRowProps(l,i):{},{options:r,rowSelected:"none"!==r.selectableRows&&e.isRowSelected(i),onClick:e.handleRowClick.bind(null,l,{rowIndex:a,dataIndex:i}),"data-testid":"MUIDataTableBodyRow-"+i,id:"MUIDataTableBodyRow-"+i}),React__default.createElement(TableSelectCell$1,{onChange:e.handleRowSelect.bind(null,{index:e.getRowIndex(a),dataIndex:i}),onExpand:n.bind(null,{index:e.getRowIndex(a),dataIndex:i}),fixedHeader:r.fixedHeader,fixedHeaderOptions:r.fixedHeaderOptions,checked:e.isRowSelected(i),expandableOn:r.expandableRows,hideExpandButton:!e.isRowExpandable(i)&&r.expandableRows,selectableOn:r.selectableRows,isRowExpanded:e.isRowExpanded(i),isRowSelectable:e.isRowSelectable(i),id:"MUIDataTableSelectCell-"+i}),l.map(function(e,t){return"true"===o[t].display&&React__default.createElement(TableBodyCell$1,_extends({},o[t].setCellProps?o[t].setCellProps(e,i,t):{},{"data-testid":"MuiDataTableBodyCell-"+t+"-"+a,dataIndex:i,rowIndex:a,colIndex:t,columnHeader:o[t].label,print:o[t].print,options:r,key:t}),e)})),e.isRowExpanded(i)&&r.renderExpandableRow(l,{rowIndex:a,dataIndex:i}))}):React__default.createElement(TableBodyRow$1,{options:r},React__default.createElement(TableBodyCell$1,{colSpan:"none"!==r.selectableRows||r.expandableRows?i+1:i,options:r,colIndex:0,rowIndex:0},React__default.createElement(Typography,{variant:"subtitle1",className:a.emptyTitle},r.textLabels.body.noMatch))))}}]),t}(React__default.Component);TableBody.defaultProps={toggleExpandRow:function(){}};var TableBody$1=styles.withStyles(defaultBodyStyles,{name:"MUIDataTableBody"})(TableBody),defaultFilterListStyles={root:{display:"flex",justifyContent:"left",flexWrap:"wrap",margin:"0px 16px 0px 16px"},chip:{margin:"8px 8px 0px 0px"}},TableFilterList=function(e){function t(){return classCallCheck(this,t),possibleConstructorReturn(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return inherits(t,e),createClass(t,[{key:"render",value:function(){var e=this.props,t=e.classes,a=e.filterList,o=e.filterUpdate,n=e.filterListRenderers,r=e.columnNames,l=e.serverSideFilterList,i=e.customFilterListUpdate,s=this.props.options.serverSide,c=function(e,a,n,l,s){var c=void 0;return c=s?i[a]?"custom":"chip":r[a].filterType,React__default.createElement(Chip,{label:e,key:n,onDelete:o.bind(null,a,l[n]||[],r[a].name,c,i[a]),className:t.chip})},d=function(e){return e.map(function(a,l){if("custom"===r[l].filterType&&e[l].length){var i=n[l](a);if(i)return Array.isArray(i)?i.map(function(e,t){return c(e,l,t,a,!0)}):c(i,l,l,a,!1)}return a.map(function(e,a){return function(e,a,l){return React__default.createElement(Chip,{label:n[e](a),key:l,onDelete:o.bind(null,e,a,r[e].name,"chip"),className:t.chip})}(l,e,a)})})};return React__default.createElement("div",{className:t.root},d(s?l:a))}}]),t}(React__default.Component),TableFilterList$1=styles.withStyles(defaultFilterListStyles,{name:"MUIDataTableFilterList"})(TableFilterList),defaultHeadCellStyles=function(e){return{root:{},fixedHeader:{position:"sticky",top:"0px",left:"0px",zIndex:100,backgroundColor:e.palette.background.paper},fixedHeaderCommon:{position:"sticky",zIndex:100,backgroundColor:e.palette.background.paper},fixedHeaderXAxis:{left:"0px"},fixedHeaderYAxis:{top:"0px"},tooltip:{cursor:"pointer"},mypopper:{"&[data-x-out-of-boundaries]":{display:"none"}},data:{display:"inline-block"},sortAction:{display:"flex",verticalAlign:"top",cursor:"pointer"},sortLabelRoot:{height:"10px"},sortActive:{color:e.palette.text.primary},toolButton:{display:"flex",outline:"none",cursor:"pointer"},hintIconAlone:{marginTop:"-3px",marginLeft:"3px"},hintIconWithSortIcon:{marginTop:"-3px"}}},TableHeadCell=function(e){function t(){var e,a,o;classCallCheck(this,t);for(var n=arguments.length,r=Array(n),l=0;l<n;l++)r[l]=arguments[l];return a=o=possibleConstructorReturn(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(r))),o.handleKeyboardSortinput=function(e){return"Enter"===e.key&&o.props.toggleSort(o.props.index),!1},o.handleSortClick=function(){o.props.toggleSort(o.props.index)},possibleConstructorReturn(o,a)}return inherits(t,e),createClass(t,[{key:"render",value:function(){var e,t,a=this.props,o=a.children,n=a.classes,r=a.options,l=a.sortDirection,i=a.sort,s=a.hint,c=a.print,d=a.column,u=a.cellHeaderProps,p=void 0===u?{}:u,f=p.className,h=objectWithoutProperties(p,["className"]),m="none"!==l&&void 0!==l,b="none"!==l&&l,y=void 0,x=_extends({classes:{root:n.sortLabelRoot},active:m,hideSortIcon:!0},b?{direction:l}:{});r.fixedHeader&&(y=n.fixedHeader),r.fixedHeaderOptions&&(y=n.fixedHeaderCommon,r.fixedHeaderOptions.xAxis&&(y+=" "+n.fixedHeaderXAxis),r.fixedHeaderOptions.yAxis&&(y+=" "+n.fixedHeaderYAxis));var R=classNames((defineProperty(e={},n.root,!0),defineProperty(e,y,!0),defineProperty(e,"datatables-noprint",!c),defineProperty(e,f,f),e));return React__default.createElement(TableCell,_extends({className:R,scope:"col",sortDirection:b},h),r.sort&&i?React__default.createElement("span",{role:"button",onKeyUp:this.handleKeyboardSortinput,onClick:this.handleSortClick,className:n.toolButton,tabIndex:0},React__default.createElement(Tooltip,{title:r.textLabels.body.columnHeaderTooltip?r.textLabels.body.columnHeaderTooltip(d):r.textLabels.body.toolTip,placement:"bottom-start",classes:{tooltip:n.tooltip,popper:n.mypopper}},React__default.createElement("div",{className:n.sortAction},React__default.createElement("div",{className:classNames((t={},defineProperty(t,n.data,!0),defineProperty(t,n.sortActive,m),t))},o),React__default.createElement("div",{className:n.sortAction},React__default.createElement(TableSortLabel,x)))),s&&React__default.createElement(Tooltip,{title:s},React__default.createElement(HelpIcon,{className:m?n.hintIconWithSortIcon:n.hintIconAlone,fontSize:"small"}))):React__default.createElement("div",{className:s?n.sortAction:null},o,s&&React__default.createElement(Tooltip,{title:s,placement:"bottom-end",classes:{tooltip:n.tooltip,popper:n.mypopper},enterDelay:300},React__default.createElement(HelpIcon,{className:n.hintIconAlone,fontSize:"small"}))))}}]),t}(React__default.Component),TableHeadCell$1=styles.withStyles(defaultHeadCellStyles,{name:"MUIDataTableHeadCell"})(TableHeadCell),defaultHeadRowStyles={root:{}},TableHeadRow=function(e){function t(){return classCallCheck(this,t),possibleConstructorReturn(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return inherits(t,e),createClass(t,[{key:"render",value:function(){var e=this.props.classes;return React__default.createElement(TableRow,{className:classNames(defineProperty({},e.root,!0))},this.props.children)}}]),t}(React__default.Component),TableHeadRow$1=styles.withStyles(defaultHeadRowStyles,{name:"MUIDataTableHeadRow"})(TableHeadRow),defaultHeadStyles=function(e){return{main:{},responsiveStacked:defineProperty({},e.breakpoints.down("sm"),{display:"none"})}},TableHead=function(e){function t(){var e,a,o;classCallCheck(this,t);for(var n=arguments.length,r=Array(n),l=0;l<n;l++)r[l]=arguments[l];return a=o=possibleConstructorReturn(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(r))),o.handleToggleColumn=function(e){o.props.toggleSort(e)},o.handleRowSelect=function(){o.props.selectRowUpdate("head",null)},possibleConstructorReturn(o,a)}return inherits(t,e),createClass(t,[{key:"componentDidMount",value:function(){this.props.handleHeadUpdateRef(this.handleUpdateCheck)}},{key:"render",value:function(){var e,t=this,a=this.props,o=a.classes,n=a.columns,r=a.count,l=a.options,i=a.data,s=a.setCellRef,c=a.selectedRows,d=c&&c.data.length||0,u=d>0&&d<r,p=d===r;if(!0===l.disableToolbarSelect)if(p){for(var f=0;f<i.length;f++)if(!c.lookup[i[f].dataIndex]){p=!1,u=!0;break}}else d>r&&(u=!0);return React__default.createElement(MuiTableHead,{className:classNames((e={},defineProperty(e,o.responsiveStacked,"stacked"===l.responsive||"stackedFullWidth"===l.responsive),defineProperty(e,o.main,!0),e))},React__default.createElement(TableHeadRow$1,null,React__default.createElement(TableSelectCell$1,{ref:function(e){return s(0,reactDom.findDOMNode(e))},onChange:this.handleRowSelect.bind(null),indeterminate:u,checked:p,isHeaderCell:!0,expandableOn:l.expandableRows,selectableOn:l.selectableRows,fixedHeader:l.fixedHeader,fixedHeaderOptions:l.fixedHeaderOptions,selectableRowsHeader:l.selectableRowsHeader,isRowSelectable:!0}),n.map(function(e,a){return"true"===e.display&&(e.customHeadRender?e.customHeadRender(_extends({index:a},e),t.handleToggleColumn):React__default.createElement(TableHeadCell$1,{cellHeaderProps:n[a].setCellHeaderProps?n[a].setCellHeaderProps(_extends({index:a},e)):{},key:a,index:a,type:"cell",ref:function(e){return s(a+1,reactDom.findDOMNode(e))},sort:e.sort,sortDirection:e.sortDirection,toggleSort:t.handleToggleColumn,hint:e.hint,print:e.print,options:l,column:e},e.label))})))}}]),t}(React__default.Component),TableHead$1=styles.withStyles(defaultHeadStyles,{name:"MUIDataTableHead"})(TableHead),defaultPaginationStyles={root:{"&:last-child":{padding:"0px 24px 0px 24px"}},toolbar:{},selectRoot:{},"@media screen and (max-width: 400px)":{toolbar:{"& span:nth-child(2)":{display:"none"}},selectRoot:{marginRight:"8px"}}},TablePagination=function(e){function t(){var e,a,o;classCallCheck(this,t);for(var n=arguments.length,r=Array(n),l=0;l<n;l++)r[l]=arguments[l];return a=o=possibleConstructorReturn(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(r))),o.handleRowChange=function(e){o.props.changeRowsPerPage(e.target.value)},o.handlePageChange=function(e,t){o.props.changePage(t)},possibleConstructorReturn(o,a)}return inherits(t,e),createClass(t,[{key:"render",value:function(){var e=this.props,t=e.count,a=e.classes,o=e.options,n=e.rowsPerPage,r=e.page,l=o.textLabels.pagination;return React__default.createElement(MuiTableFooter,null,React__default.createElement(TableRow,null,React__default.createElement(MuiTablePagination,{className:a.root,classes:{caption:a.caption,toolbar:a.toolbar,selectRoot:a.selectRoot},count:t,rowsPerPage:n,page:getPageValue(t,n,r),labelRowsPerPage:l.rowsPerPage,labelDisplayedRows:function(e){var t=e.from,a=e.to,o=e.count;return t+"-"+a+" "+l.displayRows+" "+o},backIconButtonProps:{id:"pagination-back","data-testid":"pagination-back","aria-label":l.previous},nextIconButtonProps:{id:"pagination-next","data-testid":"pagination-next","aria-label":l.next},SelectProps:{id:"pagination-input",SelectDisplayProps:{id:"pagination-rows","data-testid":"pagination-rows"},MenuProps:{id:"pagination-menu","data-testid":"pagination-menu",MenuListProps:{id:"pagination-menu-list","data-testid":"pagination-menu-list"}}},rowsPerPageOptions:o.rowsPerPageOptions,onChangePage:this.handlePageChange,onChangeRowsPerPage:this.handleRowChange})))}}]),t}(React__default.Component),TablePagination$1=styles.withStyles(defaultPaginationStyles,{name:"MUIDataTablePagination"})(TablePagination),TableFooter=function(e){function t(){return classCallCheck(this,t),possibleConstructorReturn(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return inherits(t,e),createClass(t,[{key:"render",value:function(){var e=this.props,t=e.options,a=e.rowCount,o=e.page,n=e.rowsPerPage,r=e.changeRowsPerPage,l=e.changePage;return React__default.createElement(MuiTable,null,t.customFooter?t.customFooter(a,o,n,r,l,t.textLabels.pagination):t.pagination&&React__default.createElement(TablePagination$1,{count:a,page:o,rowsPerPage:n,changeRowsPerPage:r,changePage:l,component:"div",options:t}))}}]),t}(React__default.Component),defaultResizeStyles={root:{position:"absolute"},resizer:{position:"absolute",width:"1px",height:"100%",left:"100px",cursor:"ew-resize",border:"0.1px solid rgba(224, 224, 224, 1)"}},TableResize=function(e){function t(){var e,a,o;classCallCheck(this,t);for(var n=arguments.length,r=Array(n),l=0;l<n;l++)r[l]=arguments[l];return a=o=possibleConstructorReturn(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(r))),o.state={resizeCoords:{},priorPosition:{},startPosition:0,tableWidth:"100%",tableHeight:"100%"},o.handleResize=function(){window.innerWidth!==o.windowWidth&&(o.windowWidth=window.innerWidth,o.setDividers())},o.setCellRefs=function(e,t){o.cellsRef=e,o.tableRef=t,o.setDividers()},o.setDividers=function(){var e=reactDom.findDOMNode(o.tableRef).getBoundingClientRect(),t=e.width,a=e.height,n=o.state,r=n.priorPosition,l=n.resizeCoords;Object.entries(o.cellsRef).forEach(function(e){var t=slicedToArray(e,2),a=t[0],o=t[1];if(o){var n=o.getBoundingClientRect(),i=window.getComputedStyle(o,null),s=void 0!==l[a]?l[a].left:void 0,c=r[a]||0,d=n.left+o.offsetWidth-parseInt(i.paddingLeft)/2;s!==c&&(l[a]={left:d},r[a]=d)}}),o.setState({tableWidth:t,tableHeight:a,resizeCoords:l,priorPosition:r},o.updateWidths)},o.updateWidths=function(){var e=0,t=o.state,a=t.resizeCoords,n=t.tableWidth;Object.entries(a).forEach(function(t){var a=slicedToArray(t,2),r=a[0],l=a[1],i=Number((l.left-e)/n*100).toFixed(2);e=l.left;var s=o.cellsRef[r];s&&(s.style.width=i+"%")})},o.onResizeStart=function(e,t){o.setState({isResize:!0,id:e,startPosition:t.clientX})},o.onResizeMove=function(e,t){var a=o.state,n=a.startPosition,r=a.isResize,l=a.resizeCoords;if(r){var i=n-(n-t.clientX),s=_extends({},l[e],{left:i}),c=_extends({},l,defineProperty({},e,s));o.setState({resizeCoords:c},o.updateWidths)}},o.onResizeEnd=function(e,t){o.setState({isResize:!1,id:null})},possibleConstructorReturn(o,a)}return inherits(t,e),createClass(t,[{key:"componentDidMount",value:function(){var e=this;this.windowWidth=null,this.props.setResizeable(this.setCellRefs),this.props.updateDividers(function(){return e.setState({updateCoords:!0},function(){return e.updateWidths})}),window.addEventListener("resize",this.handleResize,!1)}},{key:"componentWillUnmount",value:function(){window.removeEventListener("resize",this.handleResize,!1)}},{key:"render",value:function(){var e=this,t=this.props.classes,a=this.state,o=a.id,n=a.isResize,r=a.resizeCoords,l=a.tableWidth,i=a.tableHeight;return React__default.createElement("div",{className:t.root,style:{width:l}},Object.entries(r).map(function(a){var r=slicedToArray(a,2),s=r[0],c=r[1];return React__default.createElement("div",{"aria-hidden":"true",key:s,onMouseMove:e.onResizeMove.bind(null,s),onMouseUp:e.onResizeEnd.bind(null,s),style:{width:n&&o==s?l:"auto",position:"absolute",height:i,zIndex:1e3}},React__default.createElement("div",{"aria-hidden":"true",onMouseDown:e.onResizeStart.bind(null,s),className:t.resizer,style:{left:c.left}}))}))}}]),t}(React__default.Component),TableResize$1=styles.withStyles(defaultResizeStyles,{name:"MUIDataTableResize"})(TableResize),Popover=function(e){function t(){var e,a,o;classCallCheck(this,t);for(var n=arguments.length,r=Array(n),l=0;l<n;l++)r[l]=arguments[l];return a=o=possibleConstructorReturn(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(r))),o.state={open:!1},o.handleClick=function(){o.anchorEl=reactDom.findDOMNode(o.anchorEl),o.setState({open:!0})},o.handleRequestClose=function(e){o.setState({open:!1},e&&"function"==typeof e?e():function(){})},o.handleOnExit=function(){o.props.refExit&&o.props.refExit()},possibleConstructorReturn(o,a)}return inherits(t,e),createClass(t,[{key:"UNSAFE_componentWillMount",value:function(){this.anchorEl=null}},{key:"componentDidMount",value:function(){this.props.refClose&&this.props.refClose(this.handleRequestClose)}},{key:"componentDidUpdate",value:function(e,t){!0===this.state.open&&(this.anchorEl=reactDom.findDOMNode(this.anchorEl),this.popoverActions.updatePosition())}},{key:"render",value:function(){var e=this,t=this.props,a=(t.className,t.placement,t.trigger),o=(t.refExit,t.content),n=objectWithoutProperties(t,["className","placement","trigger","refExit","content"]),r=React__default.cloneElement(React__default.createElement("span",null,a),{key:"content",ref:function(t){return e.anchorEl=t},onClick:function(){a.props.onClick&&a.props.onClick(),e.handleClick()}});return React__default.createElement(React__default.Fragment,null,React__default.createElement(MuiPopover,_extends({action:function(t){return e.popoverActions=t},elevation:2,open:this.state.open,onClose:this.handleRequestClose,onExited:this.handleOnExit,anchorEl:this.anchorEl,ref:function(t){return e.popoverEl},anchorOrigin:{vertical:"bottom",horizontal:"center"},transformOrigin:{vertical:"top",horizontal:"center"}},n),o),r)}}]),t}(React__default.Component),defaultFilterStyles=function(e){return{root:{backgroundColor:e.palette.background.default,padding:"24px 24px 36px 24px",fontFamily:"Roboto"},header:{flex:"0 0 auto",marginBottom:"16px",width:"100%",display:"flex",justifyContent:"space-between"},title:{display:"inline-block",marginLeft:"7px",color:e.palette.text.primary,fontSize:"14px",fontWeight:500},noMargin:{marginLeft:"0px"},reset:{alignSelf:"left"},resetLink:{marginLeft:"16px",fontSize:"12px",cursor:"pointer"},filtersSelected:{alignSelf:"right"},checkboxListTitle:{marginLeft:"7px",marginBottom:"8px",fontSize:"14px",color:e.palette.text.secondary,textAlign:"left",fontWeight:500},checkboxFormGroup:{marginTop:"8px"},checkboxFormControl:{margin:"0px"},checkboxFormControlLabel:{fontSize:"15px",marginLeft:"8px",color:e.palette.text.primary},checkboxIcon:{width:"32px",height:"32px"},checkbox:{"&$checked":{color:e.palette.primary.main}},checked:{},gridListTile:{marginTop:"16px"}}},TableFilter=function(e){function t(){var e,a,o;classCallCheck(this,t);for(var n=arguments.length,r=Array(n),l=0;l<n;l++)r[l]=arguments[l];return a=o=possibleConstructorReturn(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(r))),o.handleCheckboxChange=function(e,t,a){o.props.onFilterUpdate(e,t,a,"checkbox")},o.handleDropdownChange=function(e,t,a){var n=o.props.options.textLabels.filter.all,r=e.target.value===n?[]:[e.target.value];o.props.onFilterUpdate(t,r,a,"dropdown")},o.handleMultiselectChange=function(e,t,a){o.props.onFilterUpdate(e,t,a,"multiselect")},o.handleTextFieldChange=function(e,t,a){o.props.onFilterUpdate(t,e.target.value,a,"textField")},o.handleCustomChange=function(e,t,a){o.props.onFilterUpdate(t,e,a.name,a.filterType)},possibleConstructorReturn(o,a)}return inherits(t,e),createClass(t,[{key:"renderCheckbox",value:function(e,t){var a=this,o=this.props,n=o.classes,r=o.filterData,l=o.filterList;return React__default.createElement(core.GridListTile,{key:t,cols:2},React__default.createElement(FormGroup,null,React__default.createElement(core.Grid,{item:!0,xs:12},React__default.createElement(Typography,{variant:"body2",className:n.checkboxListTitle},e.label)),React__default.createElement(core.Grid,{container:!0},r[t].map(function(o,r){return React__default.createElement(core.Grid,{item:!0,key:r},React__default.createElement(FormControlLabel,{key:r,classes:{root:n.checkboxFormControl,label:n.checkboxFormControlLabel},control:React__default.createElement(Checkbox,{className:n.checkboxIcon,onChange:a.handleCheckboxChange.bind(null,t,o,e.name),checked:l[t].indexOf(o)>=0,classes:{root:n.checkbox,checked:n.checked},value:null!=o?o.toString():""}),label:o}))}))))}},{key:"renderSelect",value:function(e,t){var a=this,o=this.props,n=o.classes,r=o.filterData,l=o.filterList,i=o.options.textLabels.filter;return React__default.createElement(core.GridListTile,{key:t,cols:1,classes:{tile:n.gridListTile}},React__default.createElement(FormControl,{key:t,fullWidth:!0},React__default.createElement(InputLabel,{htmlFor:e.name},e.label),React__default.createElement(Select,{fullWidth:!0,value:l[t].length?l[t].toString():i.all,name:e.name,onChange:function(o){return a.handleDropdownChange(o,t,e.name)},input:React__default.createElement(Input,{name:e.name,id:e.name})},React__default.createElement(MenuItem,{value:i.all,key:0},i.all),r[t].map(function(e,t){return React__default.createElement(MenuItem,{value:e,key:t+1},null!=e?e.toString():"")}))))}},{key:"renderTextField",value:function(e,t){var a=this,o=this.props,n=o.classes,r=o.filterList;return React__default.createElement(core.GridListTile,{key:t,cols:1,classes:{tile:n.gridListTile}},React__default.createElement(FormControl,{key:t,fullWidth:!0},React__default.createElement(core.TextField,{fullWidth:!0,label:e.label,value:r[t].toString()||"",onChange:function(o){return a.handleTextFieldChange(o,t,e.name)}})))}},{key:"renderMultiselect",value:function(e,t){var a=this,o=this.props,n=o.classes,r=o.filterData,l=o.filterList;return React__default.createElement(core.GridListTile,{key:t,cols:1,classes:{tile:n.gridListTile}},React__default.createElement(FormControl,{key:t,fullWidth:!0},React__default.createElement(InputLabel,{htmlFor:e.name},e.label),React__default.createElement(Select,{multiple:!0,fullWidth:!0,value:l[t]||[],renderValue:function(e){return e.join(", ")},name:e.name,onChange:function(o){return a.handleMultiselectChange(t,o.target.value,e.name)},input:React__default.createElement(Input,{name:e.name,id:e.name})},r[t].map(function(e,a){return React__default.createElement(MenuItem,{value:e,key:a+1},React__default.createElement(Checkbox,{checked:l[t].indexOf(e)>=0,value:null!=e?e.toString():"",className:n.checkboxIcon,classes:{root:n.checkbox,checked:n.checked}}),React__default.createElement(ListItemText,{primary:e}))}))))}},{key:"renderCustomField",value:function(e,t){var a=this.props,o=a.classes,n=a.filterList,r=a.options,l=e.filterOptions&&e.filterOptions.display||r.filterOptions&&r.filterOptions.display;if(l)return React__default.createElement(core.GridListTile,{key:t,cols:1,classes:{tile:o.gridListTile}},React__default.createElement(FormControl,{key:t,fullWidth:!0},l(n,this.handleCustomChange,t,e)));console.error('Property "display" is required when using custom filter type.')}},{key:"render",value:function(){var e=this,t=this.props,a=t.classes,o=t.columns,n=t.options,r=t.onFilterReset,l=t.customFooter,i=t.filterList,s=n.textLabels.filter,c=1===o.filter(function(e){return e.filter}).length?1:2;return React__default.createElement("div",{className:a.root},React__default.createElement("div",{className:a.header},React__default.createElement("div",{className:a.reset},React__default.createElement(Typography,{variant:"body2",className:classNames(defineProperty({},a.title,!0))},s.title),React__default.createElement(Button,{color:"primary",className:a.resetLink,tabIndex:0,"aria-label":s.reset,"data-testid":"filterReset-button",onClick:r},s.reset)),React__default.createElement("div",{className:a.filtersSelected})),React__default.createElement(core.GridList,{cellHeight:"auto",cols:c,spacing:34},o.map(function(t,a){if(t.filter){var o=t.filterType||n.filterType;return"checkbox"===o?e.renderCheckbox(t,a):"multiselect"===o?e.renderMultiselect(t,a):"textField"===o?e.renderTextField(t,a):"custom"===o?e.renderCustomField(t,a):e.renderSelect(t,a)}})),l?l(i):"")}}]),t}(React__default.Component),TableFilter$1=styles.withStyles(defaultFilterStyles,{name:"MUIDataTableFilter"})(TableFilter),defaultViewColStyles=function(e){return{root:{padding:"16px 24px 16px 24px",fontFamily:"Roboto"},title:{marginLeft:"-7px",fontSize:"14px",color:e.palette.text.secondary,textAlign:"left",fontWeight:500},formGroup:{marginTop:"8px"},formControl:{},checkbox:{padding:"0px",width:"32px",height:"32px"},checkboxRoot:{"&$checked":{color:e.palette.primary.main}},checked:{},label:{fontSize:"15px",marginLeft:"8px",color:e.palette.text.primary}}},TableViewCol=function(e){function t(){var e,a,o;classCallCheck(this,t);for(var n=arguments.length,r=Array(n),l=0;l<n;l++)r[l]=arguments[l];return a=o=possibleConstructorReturn(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(r))),o.handleColChange=function(e){o.props.onColumnUpdate(e)},possibleConstructorReturn(o,a)}return inherits(t,e),createClass(t,[{key:"render",value:function(){var e=this,t=this.props,a=t.classes,o=t.columns,n=t.options.textLabels.viewColumns;return React__default.createElement(FormControl,{component:"fieldset",className:a.root,"aria-label":n.titleAria},React__default.createElement(Typography,{variant:"caption",className:a.title},n.title),React__default.createElement(FormGroup,{className:a.formGroup},o.map(function(t,o){return"excluded"!==t.display&&!1!==t.viewColumns&&React__default.createElement(FormControlLabel,{key:o,classes:{root:a.formControl,label:a.label},control:React__default.createElement(Checkbox,{className:a.checkbox,classes:{root:a.checkboxRoot,checked:a.checked},onChange:e.handleColChange.bind(null,o),checked:"true"===t.display,value:t.name}),label:t.label})})))}}]),t}(React__default.Component),TableViewCol$1=styles.withStyles(defaultViewColStyles,{name:"MUIDataTableViewCol"})(TableViewCol),defaultSearchStyles=function(e){return{main:{display:"flex",flex:"1 0 auto"},searchIcon:{color:e.palette.text.secondary,marginTop:"10px",marginRight:"8px"},searchText:{flex:"0.8 0"},clearIcon:{"&:hover":{color:e.palette.error.main}}}},TableSearch=function(e){function t(){var e,a,o;classCallCheck(this,t);for(var n=arguments.length,r=Array(n),l=0;l<n;l++)r[l]=arguments[l];return a=o=possibleConstructorReturn(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(r))),o.handleTextChange=function(e){o.props.onSearch(e.target.value)},o.onKeyDown=function(e){27===e.keyCode&&o.props.onHide()},possibleConstructorReturn(o,a)}return inherits(t,e),createClass(t,[{key:"componentDidMount",value:function(){document.addEventListener("keydown",this.onKeyDown,!1)}},{key:"componentWillUnmount",value:function(){document.removeEventListener("keydown",this.onKeyDown,!1)}},{key:"render",value:function(){var e=this,t=this.props,a=t.classes,o=t.options,n=t.onHide,r=t.searchText;return React__default.createElement(Grow,{appear:!0,in:!0,timeout:300},React__default.createElement("div",{className:a.main,ref:function(t){return e.rootRef=t}},React__default.createElement(SearchIcon,{className:a.searchIcon}),React__default.createElement(TextField$1,{className:a.searchText,autoFocus:!0,InputProps:{"data-test-id":o.textLabels.toolbar.search},inputProps:{"aria-label":o.textLabels.toolbar.search},value:r||"",onChange:this.handleTextChange,fullWidth:!0,inputRef:function(t){return e.searchField=t},placeholder:o.searchPlaceholder}),React__default.createElement(IconButton,{className:a.clearIcon,onClick:n},React__default.createElement(ClearIcon,null))))}}]),t}(React__default.Component),TableSearch$1=styles.withStyles(defaultSearchStyles,{name:"MUIDataTableSearch"})(TableSearch),defaultToolbarStyles=function(e){var t;return t={root:{},fullWidthRoot:{},left:{flex:"1 1 auto"},fullWidthLeft:{flex:"1 1 auto"},actions:{flex:"1 1 auto",textAlign:"right"},fullWidthActions:{flex:"1 1 auto",textAlign:"right"},titleRoot:{},titleText:{},fullWidthTitleText:{textAlign:"left"},icon:{"&:hover":{color:e.palette.primary.main}},iconActive:{color:e.palette.primary.main},filterPaper:{maxWidth:"50%"},searchIcon:{display:"inline-flex",marginTop:"10px",marginRight:"8px"}},defineProperty(t,e.breakpoints.down("sm"),{titleRoot:{},titleText:{fontSize:"16px"},spacer:{display:"none"},left:{padding:"8px 0px"},actions:{textAlign:"right"}}),defineProperty(t,e.breakpoints.down("xs"),{root:{display:"block"},left:{padding:"8px 0px 0px 0px"},titleText:{textAlign:"center"},actions:{textAlign:"center"}}),defineProperty(t,"@media screen and (max-width: 480px)",{}),t},RESPONSIVE_FULL_WIDTH_NAME="scrollFullHeightFullWidth",TableToolbar=function(e){function t(){var e,a,o;classCallCheck(this,t);for(var n=arguments.length,r=Array(n),l=0;l<n;l++)r[l]=arguments[l];return a=o=possibleConstructorReturn(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(r))),o.state={iconActive:null,showSearch:Boolean(o.props.searchText||o.props.options.searchText||o.props.options.searchOpen),searchText:o.props.searchText||null},o.handleCSVDownload=function(){var e=o.props,t=e.data,a=e.displayData,n=e.columns,r=e.options,l=cloneDeep(t),i=n;r.downloadOptions&&r.downloadOptions.filterOptions&&(r.downloadOptions.filterOptions.useDisplayedRowsOnly&&(l=a.map(function(e,a){var o=-1;return e.index=a,{data:e.data.map(function(a){return o+=1,"object"!==(void 0===a?"undefined":_typeof(a))||null===a||Array.isArray(a)?a:find(t,function(t){return t.index===e.dataIndex}).data[o]})}})),r.downloadOptions.filterOptions.useDisplayedColumnsOnly&&(i=n.filter(function(e,t){return"true"===e.display}),l=l.map(function(e){return e.data=e.data.filter(function(e,t){return"true"===n[t].display}),e}))),createCSVDownload(i,l,r,downloadCSV)},o.setActiveIcon=function(e){o.setState(function(t){return{showSearch:o.isSearchShown(e),iconActive:e,prevIconActive:t.iconActive}},function(){var e=o.state,t=e.iconActive,a=e.prevIconActive;"filter"===t&&(o.props.setTableAction("onFilterDialogOpen"),o.props.options.onFilterDialogOpen&&o.props.options.onFilterDialogOpen()),void 0===t&&"filter"===a&&(o.props.setTableAction("onFilterDialogClose"),o.props.options.onFilterDialogClose&&o.props.options.onFilterDialogClose())})},o.isSearchShown=function(e){var t=!1;if(o.state.showSearch)if(o.state.searchText)t=!0;else{var a=o.props.options.onSearchClose;o.props.setTableAction("onSearchClose"),a&&a(),t=!1}else"search"===e&&(t=o.showSearch());return t},o.getActiveIcon=function(e,t){var a=o.state.iconActive===t;if("search"===t){var n=o.state,r=n.showSearch,l=n.searchText;a=a||r||l}return a?e.iconActive:e.icon},o.showSearch=function(){return o.props.setTableAction("onSearchOpen"),o.props.options.onSearchOpen&&o.props.options.onSearchOpen(),!0},o.hideSearch=function(){var e=o.props.options.onSearchClose;o.props.setTableAction("onSearchClose"),e&&e(),o.props.searchClose(),o.setState(function(){return{iconActive:null,showSearch:!1,searchText:null}}),o.searchButton.focus()},o.handleSearch=function(e){o.setState({searchText:e}),o.props.searchTextUpdate(e)},o.handleSearchIconClick=function(){var e=o.state,t=e.showSearch,a=e.searchText;t&&!a?o.hideSearch():o.setActiveIcon("search")},possibleConstructorReturn(o,a)}return inherits(t,e),createClass(t,[{key:"componentDidUpdate",value:function(e){this.props.searchText!==e.searchText&&this.setState({searchText:this.props.searchText})}},{key:"render",value:function(){var e=this,t=this.props,a=t.data,o=t.options,n=t.classes,r=t.columns,l=t.filterData,i=t.filterList,s=t.filterUpdate,c=t.resetFilters,d=t.toggleViewColumn,u=t.title,p=(t.tableRef,o.textLabels.toolbar),f=p.search,h=p.downloadCsv,m=p.print,b=p.viewColumns,y=p.filterTable,x=this.state,R=x.showSearch,g=x.searchText;return React__default.createElement(Toolbar,{className:o.responsive!==RESPONSIVE_FULL_WIDTH_NAME?n.root:n.fullWidthRoot,role:"toolbar","aria-label":"Table Toolbar"},React__default.createElement("div",{className:o.responsive!==RESPONSIVE_FULL_WIDTH_NAME?n.left:n.fullWidthLeft},!0===R?o.customSearchRender?o.customSearchRender(g,this.handleSearch,this.hideSearch,o):React__default.createElement(TableSearch$1,{searchText:g,onSearch:this.handleSearch,onHide:this.hideSearch,options:o}):"string"!=typeof u?u:React__default.createElement("div",{className:n.titleRoot,"aria-hidden":"true"},React__default.createElement(Typography,{variant:"h6",className:o.responsive!==RESPONSIVE_FULL_WIDTH_NAME?n.titleText:n.fullWidthTitleText},u))),React__default.createElement("div",{className:o.responsive!==RESPONSIVE_FULL_WIDTH_NAME?n.actions:n.fullWidthActions},o.search&&React__default.createElement(Tooltip,{title:f,disableFocusListener:!0},React__default.createElement(IconButton,{"aria-label":f,"data-testid":f+"-iconButton",buttonRef:function(t){return e.searchButton=t},classes:{root:this.getActiveIcon(n,"search")},onClick:this.handleSearchIconClick},React__default.createElement(SearchIcon,null))),o.download&&React__default.createElement(Tooltip,{title:h},React__default.createElement(IconButton,{"data-testid":h+"-iconButton","aria-label":h,classes:{root:n.icon},onClick:this.handleCSVDownload},React__default.createElement(DownloadIcon,null))),o.print&&React__default.createElement("span",null,React__default.createElement(ReactToPrint,{trigger:function(){return React__default.createElement("span",null,React__default.createElement(Tooltip,{title:m},React__default.createElement(IconButton,{"data-testid":m+"-iconButton","aria-label":m,classes:{root:n.icon}},React__default.createElement(PrintIcon,null))))},content:function(){return e.props.tableRef()}})),o.viewColumns&&React__default.createElement(Popover,{refExit:this.setActiveIcon.bind(null),trigger:React__default.createElement(Tooltip,{title:b,disableFocusListener:!0},React__default.createElement(IconButton,{"data-testid":b+"-iconButton","aria-label":b,classes:{root:this.getActiveIcon(n,"viewcolumns")},onClick:this.setActiveIcon.bind(null,"viewcolumns")},React__default.createElement(ViewColumnIcon,null))),content:React__default.createElement(TableViewCol$1,{data:a,columns:r,options:o,onColumnUpdate:d})}),o.filter&&React__default.createElement(Popover,{refExit:this.setActiveIcon.bind(null),classes:{paper:n.filterPaper},trigger:React__default.createElement(Tooltip,{title:y,disableFocusListener:!0},React__default.createElement(IconButton,{"data-testid":y+"-iconButton","aria-label":y,classes:{root:this.getActiveIcon(n,"filter")},onClick:this.setActiveIcon.bind(null,"filter")},React__default.createElement(FilterIcon,null))),content:React__default.createElement(TableFilter$1,{customFooter:o.customFilterDialogFooter,columns:r,options:o,filterList:i,filterData:l,onFilterUpdate:s,onFilterReset:c})}),o.customToolbar&&o.customToolbar()))}}]),t}(React__default.Component),TableToolbar$1=styles.withStyles(defaultToolbarStyles,{name:"MUIDataTableToolbar"})(TableToolbar),defaultToolbarSelectStyles=function(e){return{root:{backgroundColor:e.palette.background.default,flex:"1 1 100%",display:"flex",position:"relative",zIndex:120,justifyContent:"space-between",alignItems:"center",paddingTop:"function"==typeof e.spacing?e.spacing(1):e.spacing.unit,paddingBottom:"function"==typeof e.spacing?e.spacing(1):e.spacing.unit},title:{paddingLeft:"26px"},iconButton:{marginRight:"24px"},deleteIcon:{}}},TableToolbarSelect=function(e){function t(){var e,a,o;classCallCheck(this,t);for(var n=arguments.length,r=Array(n),l=0;l<n;l++)r[l]=arguments[l];return a=o=possibleConstructorReturn(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(r))),o.handleCustomSelectedRows=function(e){if(!Array.isArray(e))throw new TypeError('"selectedRows" must be an "array", but it\'s "'+(void 0===e?"undefined":_typeof(e))+'"');if(e.some(function(e){return"number"!=typeof e}))throw new TypeError('Array "selectedRows" must contain only numbers');var t=o.props.options;if(e.length>1&&"single"===t.selectableRows)throw new Error('Can not select more than one row when "selectableRows" is "single"');o.props.selectRowUpdate("custom",e)},possibleConstructorReturn(o,a)}return inherits(t,e),createClass(t,[{key:"render",value:function(){var e=this.props,t=e.classes,a=e.onRowsDelete,o=e.selectedRows,n=e.options,r=e.displayData,l=n.textLabels.selectedRows;return React__default.createElement(Paper,{className:t.root},React__default.createElement("div",null,React__default.createElement(Typography,{variant:"subtitle1",className:t.title},o.data.length," ",l.text)),n.customToolbarSelect?n.customToolbarSelect(o,r,this.handleCustomSelectedRows):React__default.createElement(Tooltip,{title:l.delete},React__default.createElement(IconButton,{className:t.iconButton,onClick:a,"aria-label":l.deleteAria},React__default.createElement(DeleteIcon,{className:t.deleteIcon}))))}}]),t}(React__default.Component),TableToolbarSelect$1=styles.withStyles(defaultToolbarSelectStyles,{name:"MUIDataTableToolbarSelect"})(TableToolbarSelect),getTextLabels=function(){return{body:{noMatch:"Sorry, no matching records found",toolTip:"Sort"},pagination:{next:"Next Page",previous:"Previous Page",rowsPerPage:"Rows per page:",displayRows:"of"},toolbar:{search:"Search",downloadCsv:"Download CSV",print:"Print",viewColumns:"View Columns",filterTable:"Filter Table"},filter:{all:"All",title:"FILTERS",reset:"RESET"},viewColumns:{title:"Show Columns",titleAria:"Show/Hide Table Columns"},selectedRows:{text:"row(s) selected",delete:"Delete",deleteAria:"Delete Selected Rows"}}},defaultTableStyles=function(e){return{root:{},paper:{},paperResponsiveScrollFullHeightFullWidth:{position:"absolute"},tableRoot:{outline:"none"},responsiveScroll:{overflowX:"auto",overflow:"auto",height:"100%"},responsiveScrollMaxHeight:{overflowX:"auto",overflow:"auto",height:"100%"},responsiveScrollFullHeight:{height:"100%"},responsiveStacked:defineProperty({overflowX:"auto",overflow:"auto"},e.breakpoints.down("sm"),{overflowX:"hidden",overflow:"hidden"}),responsiveStackedFullWidth:{},caption:{position:"absolute",left:"-3000px"},liveAnnounce:{border:"0",clip:"rect(0 0 0 0)",height:"1px",margin:"-1px",overflow:"hidden",padding:"0",position:"absolute",width:"1px"},"@global":{"@media print":{".datatables-noprint":{display:"none"}}}}},TABLE_LOAD={INITIAL:1,UPDATE:2},TOOLBAR_ITEMS=["title","filter","search","print","download","viewColumns","customToolbar"],hasToolbarItem=function(e,t){return e.title=t,!isUndefined(find(TOOLBAR_ITEMS,function(t){return e[t]}))},MUIDataTable=function(e){function t(){classCallCheck(this,t);var e=possibleConstructorReturn(this,(t.__proto__||Object.getPrototypeOf(t)).call(this));return e.state={announceText:null,activeColumn:null,data:[],displayData:[],page:0,rowsPerPage:0,count:0,columns:[],filterData:[],filterList:[],selectedRows:{data:[],lookup:{}},previousSelectedRow:null,expandedRows:{data:[],lookup:{}},showResponsive:!1,searchText:null},e.getDefaultOptions=function(){return{responsive:"stacked",filterType:"dropdown",pagination:!0,textLabels:getTextLabels(),serverSideFilterList:[],expandableRows:!1,expandableRowsOnClick:!1,resizableColumns:!1,selectableRows:"multiple",selectableRowsOnClick:!1,selectableRowsHeader:!0,caseSensitive:!1,disableToolbarSelect:!1,serverSide:!1,rowHover:!0,elevation:4,rowsPerPage:10,rowsPerPageOptions:[10,15,100],filter:!0,fixedHeaderOptions:{xAxis:!0,yAxis:!0},sortFilterList:!0,sort:!0,search:!0,print:!0,viewColumns:!0,download:!0,downloadOptions:{filename:"tableDownload.csv",separator:","},setTableProps:function(){return{}}}},e.handleOptionDeprecation=function(){"boolean"==typeof e.options.selectableRows&&(e.options.selectableRows=e.options.selectableRows?"multiple":"none"),["scrollMaxHeight","scrollFullHeight","stacked","stackedFullWidth","scrollFullHeightFullWidth"].indexOf(e.options.responsive),e.options.responsive,!1===e.options.fixedHeader||e.options.fixedHeader,e.props.columns.map(function(e){e.options&&e.options.customFilterListRender})},e.setTableAction=function(t){"function"==typeof e.options.onTableChange&&e.options.onTableChange(t,e.state)},e.setTableInit=function(t){"function"==typeof e.options.onTableInit&&e.options.onTableInit(t,e.state)},e.setHeadCellRef=function(t,a){e.headCellRefs[t]=a},e.getTableContentRef=function(){return e.tableContent.current},e.buildColumns=function(e,t){var a=[],o=[],n=[],r=!1;return e.forEach(function(e,l){var i={display:"true",empty:!1,filter:!0,sort:!0,print:!0,searchable:!0,download:!0,viewColumns:!0,sortDirection:"none"},s=_extends({},e.options);"object"===(void 0===e?"undefined":_typeof(e))?(s&&(void 0!==s.display&&(s.display=s.display.toString()),null===s.sortDirection&&(s.sortDirection="none"),void 0!==s.sortDirection&&"none"!==s.sortDirection&&(r?(console.error("sortDirection is set for more than one column. Only the first column will be considered."),s.sortDirection="none"):r=!0)),void 0===s.display&&t[l]&&t[l].name===e.name&&t[l].display&&(s.display=t[l].display),void 0===s.sortDirection&&t[l]&&t[l].name===e.name&&t[l].sortDirection&&(s.sortDirection=t[l].sortDirection),i=_extends({name:e.name,label:e.label?e.label:e.name},i,s)):(t[l]&&t[l].display&&(s.display=t[l].display),t[l]&&t[l].sortDirection&&(s.sortDirection=t[l].sortDirection),i=_extends({},i,s,{name:e,label:e})),a.push(i),o[l]=[],n[l]=[]}),{columns:a,filterData:o,filterList:n}},e.transformData=function(e,t){var a=Array.isArray(t[0])?t.map(function(t){var a=-1;return e.map(function(e){return e.empty||a++,e.empty?void 0:t[a]})}):t.map(function(t){return e.map(function(e){return a=t,e.name.split(".").reduce(function(e,t){return e?e[t]:void 0},a);var a})});a.filter(function(e){return e.filter(function(e){return"object"===(void 0===e?"undefined":_typeof(e))&&null!==e&&!Array.isArray(e)}).length>0}).length;return a},e.hasSearchText=function(e,t,a){var o=e.toString(),n=t.toString();return a||(n=n.toLowerCase(),o=o.toLowerCase()),o.indexOf(n)>=0},e.updateDataCol=function(t,a,o){e.setState(function(n){var r=cloneDeep(n.data),l=cloneDeep(n.filterData),i=e.getTableMeta(t,a,t,n.columns[a],n.data,n),s=n.columns[a].customBodyRender(o,i),c=React__default.isValidElement(s)&&s.props.value?s.props.value:n.data[t][a],d=l[a].indexOf(c);if(l[a].splice(d,1,c),r[t].data[a]=o,e.options.sortFilterList){var u=getCollatorComparator();l[a].sort(u)}return{data:r,filterData:l,displayData:e.getDisplayData(n.columns,r,n.filterList,n.searchText)}})},e.getTableMeta=function(e,t,a,o,n,r){r.columns,r.data,r.displayData,r.filterData;return{rowIndex:e,columnIndex:t,columnData:o,rowData:a,tableData:n,tableState:objectWithoutProperties(r,["columns","data","displayData","filterData"])}},e.toggleViewColumn=function(t){e.setState(function(e){var a=cloneDeep(e.columns);return a[t].display="true"===a[t].display?"false":"true",{columns:a}},function(){e.setTableAction("columnViewChange"),e.options.onColumnViewChange&&e.options.onColumnViewChange(e.state.columns[t].name,"true"===e.state.columns[t].display?"add":"remove")})},e.toggleSortColumn=function(t){e.setState(function(a){for(var o=cloneDeep(a.columns),n=a.data,r="desc"===o[t].sortDirection?"asc":"desc",l=0;l<o.length;l++)o[l].sortDirection=t!==l?"none":r;var i=e.getSortDirection(o[t]),s={columns:o,announceText:"Table now sorted by "+o[t].name+" : "+i,activeColumn:t};if(e.options.serverSide)s=_extends({},s,{data:a.data,displayData:a.displayData,selectedRows:a.selectedRows});else{var c=e.sortTable(n,t,r);s=_extends({},s,{data:c.data,displayData:e.getDisplayData(o,c.data,a.filterList,a.searchText),selectedRows:c.selectedRows,previousSelectedRow:null})}return s},function(){e.setTableAction("sort"),e.options.onColumnSortChange&&e.options.onColumnSortChange(e.state.columns[t].name,e.getSortDirection(e.state.columns[t]))})},e.changeRowsPerPage=function(t){var a=e.options.count||e.state.displayData.length;e.setState(function(){return{rowsPerPage:t,page:getPageValue(a,t,e.state.page)}},function(){e.setTableAction("changeRowsPerPage"),e.options.onChangeRowsPerPage&&e.options.onChangeRowsPerPage(e.state.rowsPerPage)})},e.changePage=function(t){e.setState(function(){return{page:t}},function(){e.setTableAction("changePage"),e.options.onChangePage&&e.options.onChangePage(e.state.page)})},e.searchClose=function(){e.setState(function(t){return{searchText:null,displayData:e.options.serverSide?t.displayData:e.getDisplayData(t.columns,t.data,t.filterList,null)}},function(){e.setTableAction("search"),e.options.onSearchChange&&e.options.onSearchChange(e.state.searchText)})},e.searchTextUpdate=function(t){e.setState(function(a){return{searchText:t&&t.length?t:null,page:0,displayData:e.options.serverSide?a.displayData:e.getDisplayData(a.columns,a.data,a.filterList,t)}},function(){e.setTableAction("search"),e.options.onSearchChange&&e.options.onSearchChange(e.state.searchText)})},e.resetFilters=function(){e.setState(function(t){var a=t.columns.map(function(){return[]});return{filterList:a,displayData:e.options.serverSide?t.displayData:e.getDisplayData(t.columns,t.data,a,t.searchText)}},function(){e.setTableAction("resetFilters"),e.options.onFilterChange&&e.options.onFilterChange(null,e.state.filterList,"reset")})},e.filterUpdate=function(t,a,o,n,r){e.setState(function(o){var l=o.filterList.slice(0),i=l[t].indexOf(a);switch(n){case"checkbox":case"chip":i>=0?l[t].splice(i,1):l[t].push(a);break;case"multiselect":l[t]=""===a?[]:a;break;case"dropdown":l[t]=a;break;case"custom":r?l=r(l,i,t):l[t]=a;break;default:l[t]=i>=0||""===a?[]:[a]}return{page:0,filterList:l,displayData:e.options.serverSide?o.displayData:e.getDisplayData(o.columns,o.data,l,o.searchText),previousSelectedRow:null}},function(){e.setTableAction("filterChange"),e.options.onFilterChange&&e.options.onFilterChange(o,e.state.filterList,n)})},e.selectRowDelete=function(){var t=e.state,a=t.selectedRows,o=t.data,n=t.filterList,r=buildMap(a.data),l=o.filter(function(e){var t=e.index;return!r[t]});e.options.onRowsDelete&&!1===e.options.onRowsDelete(a)||e.setTableData({columns:e.props.columns,data:l,options:{filterList:n}},TABLE_LOAD.UPDATE,!0,function(){e.setTableAction("rowDelete")})},e.toggleExpandRow=function(t){for(var a=t.dataIndex,o=e.options.isRowExpandable,n=e.state.expandedRows,r=[].concat(toConsumableArray(n.data)),l=!1,i=!1,s=[],c=0;c<r.length;c++)if(r[c].dataIndex===a){l=!0;break}l?(o&&o(a,n)||!o)&&(s=r.splice(c,1),i=!0):o&&o(a,n)?r.push(t):o||r.push(t),e.setState({curExpandedRows:i?s:[t],expandedRows:{lookup:buildMap(r),data:r}},function(){e.setTableAction("expandRow"),e.options.onRowsExpand&&e.options.onRowsExpand(e.state.curExpandedRows,e.state.expandedRows.data)})},e.selectRowUpdate=function(t,a){var o=arguments.length>2&&void 0!==arguments[2]?arguments[2]:[],n=e.options.selectableRows;if("none"!==n)if("head"===t){var r=e.options.isRowSelectable;e.setState(function(t){var a=t.displayData,o=t.selectedRows,n=t.selectedRows.data.length,l=n===a.length||n<a.length&&n>0,i=a.reduce(function(e,t,n){return(!r||r(a[n].dataIndex,o))&&e.push({index:n,dataIndex:a[n].dataIndex}),e},[]),s=[].concat(toConsumableArray(i)),c=buildMap(s);if(!0===e.options.disableToolbarSelect)if(n>a.length)l=!0;else for(var d=0;d<a.length;d++)c[a[d].dataIndex]||(l=!0);return l&&(s=t.selectedRows.data.filter(function(e){var t=e.dataIndex;return!c[t]}),c=buildMap(s)),{curSelectedRows:s,selectedRows:{data:s,lookup:c},previousSelectedRow:null}},function(){e.setTableAction("rowsSelect"),e.options.onRowsSelect&&e.options.onRowsSelect(e.state.curSelectedRows,e.state.selectedRows.data)})}else if("cell"===t)e.setState(function(e){for(var t=a.dataIndex,r=[].concat(toConsumableArray(e.selectedRows.data)),l=-1,i=0;i<r.length;i++)if(r[i].dataIndex===t){l=i;break}if(l>=0){if(r.splice(l,1),o.length>0)for(var s=buildMap(o),c=r.length-1;c>=0;c--)s[r[c].dataIndex]&&r.splice(c,1)}else if("single"===n)r=[a];else if(r.push(a),o.length>0){var d=buildMap(r);o.forEach(function(e){d[e.dataIndex]||r.push(e)})}return{selectedRows:{lookup:buildMap(r),data:r},previousSelectedRow:a}},function(){e.setTableAction("rowsSelect"),e.options.onRowsSelect&&e.options.onRowsSelect([a],e.state.selectedRows.data)});else if("custom"===t){var l=e.state.displayData,i=a.map(function(e){return{index:e,dataIndex:l[e].dataIndex}}),s=buildMap(i);e.setState({selectedRows:{data:i,lookup:s},previousSelectedRow:null},function(){e.setTableAction("rowsSelect"),e.options.onRowsSelect&&e.options.onRowsSelect(e.state.selectedRows.data,e.state.selectedRows.data)})}},e.tableRef=!1,e.tableContent=React__default.createRef(),e.headCellRefs={},e.setHeadResizeable=function(){},e.updateDividers=function(){},e}return inherits(t,e),createClass(t,[{key:"UNSAFE_componentWillMount",value:function(){this.initializeTable(this.props)}},{key:"componentDidMount",value:function(){this.setHeadResizeable(this.headCellRefs,this.tableRef),this.props.options.searchText&&!this.props.options.serverSide&&this.setState({page:0})}},{key:"componentDidUpdate",value:function(e){var t=this;if(this.props.data!==e.data||this.props.columns!==e.columns||this.props.options!==e.options){this.updateOptions(this.options,this.props);var a=this.props.data!==e.data;this.props.data&&e.data&&(a=a&&this.props.data.length===e.data.length),this.setTableData(this.props,TABLE_LOAD.INITIAL,a,function(){t.setTableAction("propsUpdate")})}this.props.options.searchText===e.options.searchText||this.props.options.serverSide||this.setState({page:0}),this.options.resizableColumns&&(this.setHeadResizeable(this.headCellRefs,this.tableRef),this.updateDividers())}},{key:"updateOptions",value:function(e,t){this.options=assignwith(e,t.options,function(e,t,a){if("textLabels"===a||"downloadOptions"===a)return merge(e,t)}),this.handleOptionDeprecation()}},{key:"initializeTable",value:function(e){var t=this;this.mergeDefaultOptions(e),this.setTableOptions(),this.setTableData(e,TABLE_LOAD.INITIAL,!0,function(){t.setTableInit("tableInitialized")})}},{key:"mergeDefaultOptions",value:function(e){var t=this.getDefaultOptions();this.updateOptions(t,this.props)}},{key:"validateOptions",value:function(e){if(e.serverSide&&void 0===e.onTableChange)throw Error("onTableChange callback must be provided when using serverSide option");if(e.expandableRows&&void 0===e.renderExpandableRow)throw Error("renderExpandableRow must be provided when using expandableRows option");this.props.options.filterList}},{key:"setTableOptions",value:function(){var e=this,t=["rowsPerPage","page","rowsSelected","rowsPerPageOptions"].reduce(function(t,a){return void 0!==e.options[a]&&(t[a]=e.options[a]),t},{});this.validateOptions(t),this.setState(t)}},{key:"setTableData",value:function(e,t,a){var o=this,n=arguments.length>3&&void 0!==arguments[3]?arguments[3]:function(){},r=[],l=this.buildColumns(e.columns,this.state.columns),i=l.columns,s=l.filterData,c=l.filterList,d=null,u="none",p=void 0,f=t===TABLE_LOAD.INITIAL?this.transformData(i,e.data):e.data,h=t===TABLE_LOAD.INITIAL?this.options.searchText:null;void 0===this.options.searchText&&void 0!==this.state.searchText&&(h=this.state.searchText),i.forEach(function(e,a){for(var n=0;n<f.length;n++){var l=t===TABLE_LOAD.INITIAL?f[n][a]:f[n].data[a];if(void 0===r[n]&&r.push({index:t===TABLE_LOAD.INITIAL?n:f[n].index,data:t===TABLE_LOAD.INITIAL?f[n]:f[n].data}),"function"==typeof e.customBodyRender){var i=r[n].data;p=o.getTableMeta(n,a,i,e,f,o.state);var h=e.customBodyRender(l,p);React__default.isValidElement(h)&&h.props.value?l=h.props.value:"string"==typeof h&&(l=h)}s[a].indexOf(l)<0&&!Array.isArray(l)?s[a].push(l):Array.isArray(l)&&l.forEach(function(e){s[a].indexOf(e)<0&&s[a].push(e)})}if(e.filterOptions&&(Array.isArray(e.filterOptions)?s[a]=cloneDeep(e.filterOptions):Array.isArray(e.filterOptions.names)&&(s[a]=cloneDeep(e.filterOptions.names))),e.filterList?c[a]=cloneDeep(e.filterList):o.state.filterList&&o.state.filterList[a]&&o.state.filterList[a].length>0&&(c[a]=cloneDeep(o.state.filterList[a])),o.options.sortFilterList){var m=getCollatorComparator();s[a].sort(m)}"none"!==e.sortDirection&&(d=a,u=e.sortDirection)});var m={data:[],lookup:{}},b={data:[],lookup:{}};if(TABLE_LOAD.INITIAL){if(this.options.rowsSelected&&this.options.rowsSelected.length&&"multiple"===this.options.selectableRows)this.options.rowsSelected.forEach(function(e){for(var t=e,a=0;a<o.state.displayData.length;a++)if(o.state.displayData[a].dataIndex===e){t=a;break}m.data.push({index:t,dataIndex:e}),m.lookup[e]=!0});else if(this.options.rowsSelected&&1===this.options.rowsSelected.length&&"single"===this.options.selectableRows){for(var y=this.options.rowsSelected[0],x=0;x<this.state.displayData.length;x++)if(this.state.displayData[x].dataIndex===this.options.rowsSelected[0]){y=x;break}m.data.push({index:y,dataIndex:this.options.rowsSelected[0]}),m.lookup[this.options.rowsSelected[0]]=!0}else this.options.rowsSelected&&this.options.rowsSelected.length>1&&"single"===this.options.selectableRows?console.error('Multiple values provided for selectableRows, but selectableRows set to "single". Either supply only a single value or use "multiple".'):void 0===this.options.rowsSelected&&!1===a&&this.state.selectedRows&&(m=Object.assign({},this.state.selectedRows));this.options.rowsExpanded&&this.options.rowsExpanded.length&&this.options.expandableRows?this.options.rowsExpanded.forEach(function(e){for(var t=e,a=0;a<o.state.displayData.length;a++)if(o.state.displayData[a].dataIndex===e){t=a;break}b.data.push({index:t,dataIndex:e}),b.lookup[e]=!0}):void 0===this.options.rowsExpanded&&!1===a&&this.state.expandedRows&&(b=Object.assign({},this.state.expandedRows))}if(!this.options.serverSide&&null!==d){var R=this.sortTable(r,d,u);r=R.data}this.setState({columns:i,filterData:s,filterList:c,searchText:h,selectedRows:m,expandedRows:b,count:this.options.count,data:r,displayData:this.getDisplayData(i,r,c,h,p)},n)}},{key:"computeDisplayRow",value:function(e,t,a,o,n,r,l){for(var i=this,s=!1,c=!1,d=[],u=function(u){var p=t[u],f=t[u],h=e[u];if(h.customBodyRender){var m=i.getTableMeta(a,u,t,h,r,_extends({},i.state,{filterList:o,searchText:n})),b=h.customBodyRender(f,m,i.updateDataCol.bind(null,a,u));p=b,f="string"!=typeof b&&b?b.props&&b.props.value?b.props.value:f:b}d.push(p);var y=null===f||void 0===f?"":f.toString(),x=o[u],R=l.caseSensitive,g=h.filterType||l.filterType;if(x.length||"custom"===g)if(h.filterOptions&&h.filterOptions.logic)h.filterOptions.logic(f,x)&&(s=!0);else if("textField"!==g||i.hasSearchText(y,x,R)){if("textField"!==g&&!1===Array.isArray(f)&&x.indexOf(f)<0)s=!0;else if("textField"!==g&&Array.isArray(f)){x.every(function(e){return f.indexOf(e)>=0})||(s=!0)}}else s=!0;n&&i.hasSearchText(y,n,R)&&"false"!==h.display&&h.searchable&&(c=!0)},p=0;p<t.length;p++)u(p);var f=this.props.options.customSearch;if(n&&f){var h=f(n,t,e);"boolean"!=typeof h?console.error("customSearch must return a boolean"):c=h}return l.serverSide?(f&&console.warn("Server-side filtering is enabled, hence custom search will be ignored."),d):s||n&&!c?null:d}},{key:"getDisplayData",value:function(e,t,a,o,n){for(var r=[],l=n?n.tableData:this.props.data,i=0;i<t.length;i++){var s=t[i].data,c=this.computeDisplayRow(e,s,i,a,o,l,this.options);c&&r.push({data:c,dataIndex:t[i].index})}return r}},{key:"getSortDirection",value:function(e){return"asc"===e.sortDirection?"ascending":"descending"}},{key:"getTableProps",value:function(){var e=this.props.classes,t=this.options.setTableProps();return t.className=classNames(e.tableRoot,t.className),t}},{key:"sortTable",value:function(e,t,a){var o=this,n=this.options.customSort?this.options.customSort(e,t,a||"desc"):e,r=n.map(function(e,a){return{data:e.data[t],rowData:e.data,position:a,rowSelected:!!o.state.selectedRows.lookup[e.index]}});this.options.customSort||r.sort(sortCompare(a));for(var l=[],i=[],s=0;s<r.length;s++){var c=r[s];l.push(n[c.position]),c.rowSelected&&i.push({index:s,dataIndex:n[c.position].index})}return{data:l,selectedRows:{lookup:buildMap(i),data:i}}}},{key:"render",value:function(){var e=this,t=this.props,a=t.classes,o=t.className,n=t.title,r=this.state,l=r.announceText,i=r.activeColumn,s=r.data,c=r.displayData,d=r.columns,u=r.page,p=r.filterData,f=r.filterList,h=r.selectedRows,m=r.previousSelectedRow,b=r.expandedRows,y=r.searchText,x=(r.serverSideFilterList,this.state.count||c.length),R=this.options.pagination?this.state.rowsPerPage:c.length,g=hasToolbarItem(this.options,n),v=d.map(function(t){return{name:t.name,filterType:t.filterType||e.options.filterType}}),_=this.options.responsive,w=a.paper+" "+o,C=void 0,T=void 0;switch(_){case"scroll":T=a.responsiveScroll,C="499px";break;case"scrollMaxHeight":T=a.responsiveScrollMaxHeight,C="499px";break;case"scrollFullHeight":T=a.responsiveScrollFullHeight,C="none";break;case"scrollFullHeightFullWidth":T=a.responsiveScrollFullHeight,w=a.paperResponsiveScrollFullHeightFullWidth+" "+o;break;case"stacked":T=a.responsiveStacked,C="none";break;case"stackedFullWidth":T=a.responsiveStackedFullWidth,w=a.paperResponsiveScrollFullHeightFullWidth+" "+o,C="none"}var S=this.options.setTableProps?this.options.setTableProps():{},k=classNames(a.tableRoot,S.className);return delete S.className,React__default.createElement(Paper,{elevation:this.options.elevation,ref:this.tableContent,className:w},h.data.length&&!0!==this.options.disableToolbarSelect?React__default.createElement(TableToolbarSelect$1,{options:this.options,selectedRows:h,onRowsDelete:this.selectRowDelete,displayData:c,selectRowUpdate:this.selectRowUpdate}):g&&React__default.createElement(TableToolbar$1,{columns:d,displayData:c,data:s,filterData:p,filterList:f,filterUpdate:this.filterUpdate,options:this.options,resetFilters:this.resetFilters,searchText:y,searchTextUpdate:this.searchTextUpdate,searchClose:this.searchClose,tableRef:this.getTableContentRef,title:n,toggleViewColumn:this.toggleViewColumn,setTableAction:this.setTableAction}),React__default.createElement(TableFilterList$1,{options:this.options,serverSideFilterList:this.props.options.serverSideFilterList||[],filterListRenderers:d.map(function(e){return e.customFilterListOptions&&e.customFilterListOptions.render?e.customFilterListOptions.render:e.customFilterListRender?e.customFilterListRender:function(e){return e}}),customFilterListUpdate:d.map(function(e){return e.customFilterListOptions&&e.customFilterListOptions.update?e.customFilterListOptions.update:null}),filterList:f,filterUpdate:this.filterUpdate,columnNames:v}),React__default.createElement("div",{style:{position:"relative",maxHeight:C},className:T},this.options.resizableColumns&&React__default.createElement(TableResize$1,{key:x,updateDividers:function(t){return e.updateDividers=t},setResizeable:function(t){return e.setHeadResizeable=t}}),React__default.createElement(MuiTable,_extends({ref:function(t){return e.tableRef=t},tabIndex:"0",role:"grid",className:k},S),React__default.createElement("caption",{className:a.caption},n),React__default.createElement(TableHead$1,{columns:d,activeColumn:i,data:c,count:x,page:u,rowsPerPage:R,handleHeadUpdateRef:function(t){return e.updateToolbarSelect=t},selectedRows:h,selectRowUpdate:this.selectRowUpdate,toggleSort:this.toggleSortColumn,setCellRef:this.setHeadCellRef,options:this.options}),React__default.createElement(TableBody$1,{data:c,count:x,columns:d,page:u,rowsPerPage:R,selectedRows:h,selectRowUpdate:this.selectRowUpdate,previousSelectedRow:m,expandedRows:b,toggleExpandRow:this.toggleExpandRow,options:this.options,filterList:f}))),React__default.createElement(TableFooter,{options:this.options,page:u,rowCount:x,rowsPerPage:R,changeRowsPerPage:this.changeRowsPerPage,changePage:this.changePage}),React__default.createElement("div",{className:a.liveAnnounce,"aria-live":"polite"},l))}}]),t}(React__default.Component);MUIDataTable.defaultProps={title:"",options:{},data:[],columns:[]};var MUIDataTable$1=styles.withStyles(defaultTableStyles,{name:"MUIDataTable"})(MUIDataTable);function debounce(e,t,a){var o;return function(){var n=this,r=arguments,l=a&&!o;clearTimeout(o),o=setTimeout(function(){o=null,a||e.apply(n,r)},t),l&&e.apply(n,r)}}var defaultStyles=function(e){return{main:{display:"flex",flex:"1 0 auto"},searchIcon:{color:e.palette.text.secondary,marginTop:"10px",marginRight:"8px"},searchText:{flex:"0.8 0"},clearIcon:{"&:hover":{color:e.palette.error.main}}}},_DebounceTableSearch=function(e){function t(){var e,a,o;classCallCheck(this,t);for(var n=arguments.length,r=Array(n),l=0;l<n;l++)r[l]=arguments[l];return a=o=possibleConstructorReturn(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(r))),o.handleTextChangeWrapper=function(e){return function(t){e(t.target.value)}},o.onKeyDown=function(e){27===e.keyCode&&o.props.onHide()},possibleConstructorReturn(o,a)}return inherits(t,e),createClass(t,[{key:"componentDidMount",value:function(){document.addEventListener("keydown",this.onKeyDown,!1)}},{key:"componentWillUnmount",value:function(){document.removeEventListener("keydown",this.onKeyDown,!1)}},{key:"render",value:function(){var e=this,t=this.props,a=t.classes,o=t.options,n=t.onHide,r=t.searchText,l=debounce(function(t){e.props.onSearch(t)},t.debounceWait);return React__default.createElement(Grow,{appear:!0,in:!0,timeout:300},React__default.createElement("div",{className:a.main},React__default.createElement(SearchIcon,{className:a.searchIcon}),React__default.createElement(TextField$1,{className:a.searchText,autoFocus:!0,InputProps:{"data-test-id":o.textLabels.toolbar.search,"aria-label":o.textLabels.toolbar.search},defaultValue:r,onChange:this.handleTextChangeWrapper(l),fullWidth:!0,inputRef:function(t){return e.searchField=t},placeholder:o.searchPlaceholder}),React__default.createElement(IconButton,{className:a.clearIcon,onClick:n},React__default.createElement(ClearIcon,null))))}}]),t}(React__default.Component),DebounceTableSearch=styles.withStyles(defaultStyles,{name:"MUIDataTableSearch"})(_DebounceTableSearch);function debounceSearchRender(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:200;return function(t,a,o,n){return React__default.createElement(DebounceTableSearch,{searchText:t,onSearch:a,onHide:o,options:n,debounceWait:e})}}exports.default=MUIDataTable$1,exports.Popover=Popover,exports.TableBodyCell=TableBodyCell$1,exports.TableBody=TableBody$1,exports.TableBodyRow=TableBodyRow$1,exports.TableFilter=TableFilter$1,exports.TableFilterList=TableFilterList$1,exports.TableFooter=TableFooter,exports.TableHeadCell=TableHeadCell$1,exports.TableHead=TableHead$1,exports.TableHeadRow=TableHeadRow$1,exports.TablePagination=TablePagination$1,exports.TableResize=TableResize$1,exports.TableSearch=TableSearch$1,exports.TableSelectCell=TableSelectCell$1,exports.TableToolbar=TableToolbar$1,exports.TableToolbarSelect=TableToolbarSelect$1,exports.TableViewCol=TableViewCol$1,exports.debounceSearchRender=debounceSearchRender,exports.DebounceTableSearch=DebounceTableSearch;
//# sourceMappingURL=index.js.map


/***/ }),
/* 22 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _MenuItem.default;
  }
});

var _MenuItem = _interopRequireDefault(__webpack_require__(972));

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Select.default;
  }
});

var _Select = _interopRequireDefault(__webpack_require__(856));

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Async */
/* unused harmony export AsyncCreatable */
/* unused harmony export Creatable */
/* unused harmony export Value */
/* unused harmony export Option */
/* unused harmony export defaultMenuRenderer */
/* unused harmony export defaultArrowRenderer */
/* unused harmony export defaultClearRenderer */
/* unused harmony export defaultFilterOptions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_input_autosize__ = __webpack_require__(1085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_input_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_input_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);






var arrowRenderer = function arrowRenderer(_ref) {
	var onMouseDown = _ref.onMouseDown;

	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', {
		className: 'Select-arrow',
		onMouseDown: onMouseDown
	});
};

arrowRenderer.propTypes = {
	onMouseDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};

var clearRenderer = function clearRenderer() {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', {
		className: 'Select-clear',
		dangerouslySetInnerHTML: { __html: '&times;' }
	});
};

var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];

var stripDiacritics = function stripDiacritics(str) {
	for (var i = 0; i < map.length; i++) {
		str = str.replace(map[i].letters, map[i].base);
	}
	return str;
};

var trim = function trim(str) {
  return str.replace(/^\s+|\s+$/g, '');
};

var isValid = function isValid(value) {
	return typeof value !== 'undefined' && value !== null && value !== '';
};

var filterOptions = function filterOptions(options, filterValue, excludeOptions, props) {
	if (props.ignoreAccents) {
		filterValue = stripDiacritics(filterValue);
	}

	if (props.ignoreCase) {
		filterValue = filterValue.toLowerCase();
	}

	if (props.trimFilter) {
		filterValue = trim(filterValue);
	}

	if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
		return i[props.valueKey];
	});

	return options.filter(function (option) {
		if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
		if (props.filterOption) return props.filterOption.call(undefined, option, filterValue);
		if (!filterValue) return true;

		var value = option[props.valueKey];
		var label = option[props.labelKey];
		var hasValue = isValid(value);
		var hasLabel = isValid(label);

		if (!hasValue && !hasLabel) {
			return false;
		}

		var valueTest = hasValue ? String(value) : null;
		var labelTest = hasLabel ? String(label) : null;

		if (props.ignoreAccents) {
			if (valueTest && props.matchProp !== 'label') valueTest = stripDiacritics(valueTest);
			if (labelTest && props.matchProp !== 'value') labelTest = stripDiacritics(labelTest);
		}

		if (props.ignoreCase) {
			if (valueTest && props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
			if (labelTest && props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
		}

		return props.matchPos === 'start' ? valueTest && props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || labelTest && props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : valueTest && props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || labelTest && props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
	});
};

var menuRenderer = function menuRenderer(_ref) {
	var focusedOption = _ref.focusedOption,
	    focusOption = _ref.focusOption,
	    inputValue = _ref.inputValue,
	    instancePrefix = _ref.instancePrefix,
	    onFocus = _ref.onFocus,
	    onOptionRef = _ref.onOptionRef,
	    onSelect = _ref.onSelect,
	    optionClassName = _ref.optionClassName,
	    optionComponent = _ref.optionComponent,
	    optionRenderer = _ref.optionRenderer,
	    options = _ref.options,
	    removeValue = _ref.removeValue,
	    selectValue = _ref.selectValue,
	    valueArray = _ref.valueArray,
	    valueKey = _ref.valueKey;

	var Option = optionComponent;

	return options.map(function (option, i) {
		var isSelected = valueArray && valueArray.some(function (x) {
			return x[valueKey] === option[valueKey];
		});
		var isFocused = option === focusedOption;
		var optionClass = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(optionClassName, {
			'Select-option': true,
			'is-selected': isSelected,
			'is-focused': isFocused,
			'is-disabled': option.disabled
		});

		return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
			Option,
			{
				className: optionClass,
				focusOption: focusOption,
				inputValue: inputValue,
				instancePrefix: instancePrefix,
				isDisabled: option.disabled,
				isFocused: isFocused,
				isSelected: isSelected,
				key: 'option-' + i + '-' + option[valueKey],
				onFocus: onFocus,
				onSelect: onSelect,
				option: option,
				optionIndex: i,
				ref: function ref(_ref2) {
					onOptionRef(_ref2, isFocused);
				},
				removeValue: removeValue,
				selectValue: selectValue
			},
			optionRenderer(option, i, inputValue)
		);
	});
};

menuRenderer.propTypes = {
	focusOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	focusedOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
	inputValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	instancePrefix: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	onOptionRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	optionClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	optionComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	optionRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
	removeValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	selectValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	valueArray: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
	valueKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};

var blockEvent = (function (event) {
	event.preventDefault();
	event.stopPropagation();
	if (event.target.tagName !== 'A' || !('href' in event.target)) {
		return;
	}
	if (event.target.target) {
		window.open(event.target.href, event.target.target);
	} else {
		window.location.href = event.target.href;
	}
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Option = function (_React$Component) {
	inherits(Option, _React$Component);

	function Option(props) {
		classCallCheck(this, Option);

		var _this = possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
		_this.handleMouseMove = _this.handleMouseMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.onFocus = _this.onFocus.bind(_this);
		return _this;
	}

	createClass(Option, [{
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onSelect(this.props.option, event);
		}
	}, {
		key: 'handleMouseEnter',
		value: function handleMouseEnter(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleMouseMove',
		value: function handleMouseMove(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'onFocus',
		value: function onFocus(event) {
			if (!this.props.isFocused) {
				this.props.onFocus(this.props.option, event);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    option = _props.option,
			    instancePrefix = _props.instancePrefix,
			    optionIndex = _props.optionIndex;

			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(this.props.className, option.className);

			return option.disabled ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className,
					onMouseDown: blockEvent,
					onClick: blockEvent },
				this.props.children
			) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className,
					style: option.style,
					role: 'option',
					'aria-label': option.label,
					onMouseDown: this.handleMouseDown,
					onMouseEnter: this.handleMouseEnter,
					onMouseMove: this.handleMouseMove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove,
					onTouchEnd: this.handleTouchEnd,
					id: instancePrefix + '-option-' + optionIndex,
					title: option.title },
				this.props.children
			);
		}
	}]);
	return Option;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Option.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
	className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // className (based on mouse position)
	instancePrefix: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired, // unique prefix for the ids (used for aria)
	isDisabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is disabled
	isFocused: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is focused
	isSelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is selected
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle mouseEnter on option element
	onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle click on option element
	onUnfocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle mouseLeave on option element
	option: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired, // object that is base for that option
	optionIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number // index of the option, used to generate unique ids for aria
};

var Value = function (_React$Component) {
	inherits(Value, _React$Component);

	function Value(props) {
		classCallCheck(this, Value);

		var _this = possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.onRemove = _this.onRemove.bind(_this);
		_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		return _this;
	}

	createClass(Value, [{
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			if (event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			if (this.props.onClick) {
				event.stopPropagation();
				this.props.onClick(this.props.value, event);
				return;
			}
			if (this.props.value.href) {
				event.stopPropagation();
			}
		}
	}, {
		key: 'onRemove',
		value: function onRemove(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onRemove(this.props.value);
		}
	}, {
		key: 'handleTouchEndRemove',
		value: function handleTouchEndRemove(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.onRemove(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'renderRemoveIcon',
		value: function renderRemoveIcon() {
			if (this.props.disabled || !this.props.onRemove) return;
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: 'Select-value-icon',
					'aria-hidden': 'true',
					onMouseDown: this.onRemove,
					onTouchEnd: this.handleTouchEndRemove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove },
				'\xD7'
			);
		}
	}, {
		key: 'renderLabel',
		value: function renderLabel() {
			var className = 'Select-value-label';
			return this.props.onClick || this.props.value.href ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'a',
				{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
				this.props.children
			) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
				this.props.children
			);
		}
	}, {
		key: 'render',
		value: function render() {
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select-value', this.props.value.disabled ? 'Select-value-disabled' : '', this.props.value.className),
					style: this.props.value.style,
					title: this.props.value.title
				},
				this.renderRemoveIcon(),
				this.renderLabel()
			);
		}
	}]);
	return Value;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Value.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
	disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // disabled prop passed to ReactSelect
	id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // Unique id for the value - used for aria
	onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle click on value label
	onRemove: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle removal of the value
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired // the option object for this value
};

/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/react-select
*/
var stringifyValue = function stringifyValue(value) {
	return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
};

var stringOrNode = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]);
var stringOrNumber = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]);

var instanceId = 1;

var shouldShowValue = function shouldShowValue(state, props) {
	var inputValue = state.inputValue,
	    isPseudoFocused = state.isPseudoFocused,
	    isFocused = state.isFocused;
	var onSelectResetsInput = props.onSelectResetsInput;


	if (!inputValue) return true;

	if (!onSelectResetsInput) {
		return !(!isFocused && isPseudoFocused || isFocused && !isPseudoFocused);
	}

	return false;
};

var shouldShowPlaceholder = function shouldShowPlaceholder(state, props, isOpen) {
	var inputValue = state.inputValue,
	    isPseudoFocused = state.isPseudoFocused,
	    isFocused = state.isFocused;
	var onSelectResetsInput = props.onSelectResetsInput;


	return !inputValue || !onSelectResetsInput && !isOpen && !isPseudoFocused && !isFocused;
};

/**
 * Retrieve a value from the given options and valueKey
 * @param {String|Number|Array} value	- the selected value(s)
 * @param {Object}		 props	- the Select component's props (or nextProps)
 */
var expandValue = function expandValue(value, props) {
	var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
	var options = props.options,
	    valueKey = props.valueKey;

	if (!options) return;
	for (var i = 0; i < options.length; i++) {
		if (String(options[i][valueKey]) === String(value)) return options[i];
	}
};

var handleRequired = function handleRequired(value, multi) {
	if (!value) return true;
	return multi ? value.length === 0 : Object.keys(value).length === 0;
};

var Select$1 = function (_React$Component) {
	inherits(Select, _React$Component);

	function Select(props) {
		classCallCheck(this, Select);

		var _this = possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

		['clearValue', 'focusOption', 'getOptionLabel', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleTouchMove', 'handleTouchOutside', 'handleTouchStart', 'handleValueClick', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
			return _this[fn] = _this[fn].bind(_this);
		});

		_this.state = {
			inputValue: '',
			isFocused: false,
			isOpen: false,
			isPseudoFocused: false,
			required: false
		};
		return _this;
	}

	createClass(Select, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
			var valueArray = this.getValueArray(this.props.value);

			if (this.props.required) {
				this.setState({
					required: handleRequired(valueArray[0], this.props.multi)
				});
			}
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (typeof this.props.autofocus !== 'undefined' && typeof console !== 'undefined') {
				console.warn('Warning: The autofocus prop has changed to autoFocus, support will be removed after react-select@1.0');
			}
			if (this.props.autoFocus || this.props.autofocus) {
				this.focus();
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var valueArray = this.getValueArray(nextProps.value, nextProps);

			if (nextProps.required) {
				this.setState({
					required: handleRequired(valueArray[0], nextProps.multi)
				});
			} else if (this.props.required) {
				// Used to be required but it's not any more
				this.setState({ required: false });
			}

			if (this.state.inputValue && this.props.value !== nextProps.value && nextProps.onSelectResetsInput) {
				this.setState({ inputValue: this.handleInputValueChange('') });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			// focus to the selected option
			if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
				var focusedOptionNode = Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.focused);
				var menuNode = Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.menu);

				var scrollTop = menuNode.scrollTop;
				var scrollBottom = scrollTop + menuNode.offsetHeight;
				var optionTop = focusedOptionNode.offsetTop;
				var optionBottom = optionTop + focusedOptionNode.offsetHeight;

				if (scrollTop > optionTop || scrollBottom < optionBottom) {
					menuNode.scrollTop = focusedOptionNode.offsetTop;
				}

				// We still set hasScrolledToOption to true even if we didn't
				// actually need to scroll, as we've still confirmed that the
				// option is in view.
				this.hasScrolledToOption = true;
			} else if (!this.state.isOpen) {
				this.hasScrolledToOption = false;
			}

			if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
				this._scrollToFocusedOptionOnUpdate = false;
				var focusedDOM = Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.focused);
				var menuDOM = Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.menu);
				var focusedRect = focusedDOM.getBoundingClientRect();
				var menuRect = menuDOM.getBoundingClientRect();
				if (focusedRect.bottom > menuRect.bottom) {
					menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
				} else if (focusedRect.top < menuRect.top) {
					menuDOM.scrollTop = focusedDOM.offsetTop;
				}
			}
			if (this.props.scrollMenuIntoView && this.menuContainer) {
				var menuContainerRect = this.menuContainer.getBoundingClientRect();
				if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
					window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
				}
			}
			if (prevProps.disabled !== this.props.disabled) {
				this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
				this.closeMenu();
			}
			if (prevState.isOpen !== this.state.isOpen) {
				this.toggleTouchOutsideEvent(this.state.isOpen);
				var handler = this.state.isOpen ? this.props.onOpen : this.props.onClose;
				handler && handler();
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.toggleTouchOutsideEvent(false);
		}
	}, {
		key: 'toggleTouchOutsideEvent',
		value: function toggleTouchOutsideEvent(enabled) {
			var eventTogglerName = enabled ? document.addEventListener ? 'addEventListener' : 'attachEvent' : document.removeEventListener ? 'removeEventListener' : 'detachEvent';
			var pref = document.addEventListener ? '' : 'on';

			document[eventTogglerName](pref + 'touchstart', this.handleTouchOutside);
			document[eventTogglerName](pref + 'mousedown', this.handleTouchOutside);
		}
	}, {
		key: 'handleTouchOutside',
		value: function handleTouchOutside(event) {
			// handle touch outside on ios to dismiss menu
			if (this.wrapper && !this.wrapper.contains(event.target)) {
				this.closeMenu();
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			if (!this.input) return;
			this.input.focus();
		}
	}, {
		key: 'blurInput',
		value: function blurInput() {
			if (!this.input) return;
			this.input.blur();
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchEndClearValue',
		value: function handleTouchEndClearValue(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Clear the value
			this.clearValue(event);
		}
	}, {
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			if (event.target.tagName === 'INPUT') {
				if (!this.state.isFocused) {
					this._openAfterFocus = this.props.openOnClick;
					this.focus();
				} else if (!this.state.isOpen) {
					this.setState({
						isOpen: true,
						isPseudoFocused: false,
						focusedOption: null
					});
				}

				return;
			}

			// prevent default event handlers
			event.preventDefault();

			// for the non-searchable select, toggle the menu
			if (!this.props.searchable) {
				// This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
				this.focus();
				return this.setState({
					isOpen: !this.state.isOpen,
					focusedOption: null
				});
			}

			if (this.state.isFocused) {
				// On iOS, we can get into a state where we think the input is focused but it isn't really,
				// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
				// Call focus() again here to be safe.
				this.focus();

				var input = this.input;
				var toOpen = true;

				if (typeof input.getInput === 'function') {
					// Get the actual DOM input if the ref is an <AutosizeInput /> component
					input = input.getInput();
				}

				// clears the value so that the cursor will be at the end of input when the component re-renders
				input.value = '';

				if (this._focusAfterClear) {
					toOpen = false;
					this._focusAfterClear = false;
				}

				// if the input is focused, ensure the menu is open
				this.setState({
					isOpen: toOpen,
					isPseudoFocused: false,
					focusedOption: null
				});
			} else {
				// otherwise, focus the input and open the menu
				this._openAfterFocus = this.props.openOnClick;
				this.focus();
				this.setState({ focusedOption: null });
			}
		}
	}, {
		key: 'handleMouseDownOnArrow',
		value: function handleMouseDownOnArrow(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			if (this.state.isOpen) {
				// prevent default event handlers
				event.stopPropagation();
				event.preventDefault();
				// close the menu
				this.closeMenu();
			} else {
				// If the menu isn't open, let the event bubble to the main handleMouseDown
				this.setState({
					isOpen: true
				});
			}
		}
	}, {
		key: 'handleMouseDownOnMenu',
		value: function handleMouseDownOnMenu(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			event.stopPropagation();
			event.preventDefault();

			this._openAfterFocus = true;
			this.focus();
		}
	}, {
		key: 'closeMenu',
		value: function closeMenu() {
			if (this.props.onCloseResetsInput) {
				this.setState({
					inputValue: this.handleInputValueChange(''),
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi
				});
			} else {
				this.setState({
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi
				});
			}
			this.hasScrolledToOption = false;
		}
	}, {
		key: 'handleInputFocus',
		value: function handleInputFocus(event) {
			if (this.props.disabled) return;

			var toOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
			toOpen = this._focusAfterClear ? false : toOpen; //if focus happens after clear values, don't open dropdown yet.

			if (this.props.onFocus) {
				this.props.onFocus(event);
			}

			this.setState({
				isFocused: true,
				isOpen: !!toOpen
			});

			this._focusAfterClear = false;
			this._openAfterFocus = false;
		}
	}, {
		key: 'handleInputBlur',
		value: function handleInputBlur(event) {
			// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
			if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
				this.focus();
				return;
			}

			if (this.props.onBlur) {
				this.props.onBlur(event);
			}
			var onBlurredState = {
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false
			};
			if (this.props.onBlurResetsInput) {
				onBlurredState.inputValue = this.handleInputValueChange('');
			}
			this.setState(onBlurredState);
		}
	}, {
		key: 'handleInputChange',
		value: function handleInputChange(event) {
			var newInputValue = event.target.value;

			if (this.state.inputValue !== event.target.value) {
				newInputValue = this.handleInputValueChange(newInputValue);
			}

			this.setState({
				inputValue: newInputValue,
				isOpen: true,
				isPseudoFocused: false
			});
		}
	}, {
		key: 'setInputValue',
		value: function setInputValue(newValue) {
			if (this.props.onInputChange) {
				var nextState = this.props.onInputChange(newValue);
				if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
					newValue = '' + nextState;
				}
			}
			this.setState({
				inputValue: newValue
			});
		}
	}, {
		key: 'handleInputValueChange',
		value: function handleInputValueChange(newValue) {
			if (this.props.onInputChange) {
				var nextState = this.props.onInputChange(newValue);
				// Note: != used deliberately here to catch undefined and null
				if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
					newValue = '' + nextState;
				}
			}
			return newValue;
		}
	}, {
		key: 'handleKeyDown',
		value: function handleKeyDown(event) {
			if (this.props.disabled) return;

			if (typeof this.props.onInputKeyDown === 'function') {
				this.props.onInputKeyDown(event);
				if (event.defaultPrevented) {
					return;
				}
			}

			switch (event.keyCode) {
				case 8:
					// backspace
					if (!this.state.inputValue && this.props.backspaceRemoves) {
						event.preventDefault();
						this.popValue();
					}
					break;
				case 9:
					// tab
					if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
						break;
					}
					event.preventDefault();
					this.selectFocusedOption();
					break;
				case 13:
					// enter
					event.preventDefault();
					event.stopPropagation();
					if (this.state.isOpen) {
						this.selectFocusedOption();
					} else {
						this.focusNextOption();
					}
					break;
				case 27:
					// escape
					event.preventDefault();
					if (this.state.isOpen) {
						this.closeMenu();
						event.stopPropagation();
					} else if (this.props.clearable && this.props.escapeClearsValue) {
						this.clearValue(event);
						event.stopPropagation();
					}
					break;
				case 32:
					// space
					if (this.props.searchable) {
						break;
					}
					event.preventDefault();
					if (!this.state.isOpen) {
						this.focusNextOption();
						break;
					}
					event.stopPropagation();
					this.selectFocusedOption();
					break;
				case 38:
					// up
					event.preventDefault();
					this.focusPreviousOption();
					break;
				case 40:
					// down
					event.preventDefault();
					this.focusNextOption();
					break;
				case 33:
					// page up
					event.preventDefault();
					this.focusPageUpOption();
					break;
				case 34:
					// page down
					event.preventDefault();
					this.focusPageDownOption();
					break;
				case 35:
					// end key
					if (event.shiftKey) {
						break;
					}
					event.preventDefault();
					this.focusEndOption();
					break;
				case 36:
					// home key
					if (event.shiftKey) {
						break;
					}
					event.preventDefault();
					this.focusStartOption();
					break;
				case 46:
					// delete
					if (!this.state.inputValue && this.props.deleteRemoves) {
						event.preventDefault();
						this.popValue();
					}
					break;
			}
		}
	}, {
		key: 'handleValueClick',
		value: function handleValueClick(option, event) {
			if (!this.props.onValueClick) return;
			this.props.onValueClick(option, event);
		}
	}, {
		key: 'handleMenuScroll',
		value: function handleMenuScroll(event) {
			if (!this.props.onMenuScrollToBottom) return;
			var target = event.target;

			if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
				this.props.onMenuScrollToBottom();
			}
		}
	}, {
		key: 'getOptionLabel',
		value: function getOptionLabel(op) {
			return op[this.props.labelKey];
		}

		/**
   * Turns a value into an array from the given options
   * @param {String|Number|Array} value		- the value of the select input
   * @param {Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
   * @returns	{Array}	the value of the select represented in an array
   */

	}, {
		key: 'getValueArray',
		value: function getValueArray(value) {
			var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

			/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
			var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
			if (props.multi) {
				if (typeof value === 'string') {
					value = value.split(props.delimiter);
				}
				if (!Array.isArray(value)) {
					if (value === null || value === undefined) return [];
					value = [value];
				}
				return value.map(function (value) {
					return expandValue(value, props);
				}).filter(function (i) {
					return i;
				});
			}
			var expandedValue = expandValue(value, props);
			return expandedValue ? [expandedValue] : [];
		}
	}, {
		key: 'setValue',
		value: function setValue(value) {
			var _this2 = this;

			if (this.props.autoBlur) {
				this.blurInput();
			}
			if (this.props.required) {
				var required = handleRequired(value, this.props.multi);
				this.setState({ required: required });
			}
			if (this.props.simpleValue && value) {
				value = this.props.multi ? value.map(function (i) {
					return i[_this2.props.valueKey];
				}).join(this.props.delimiter) : value[this.props.valueKey];
			}
			if (this.props.onChange) {
				this.props.onChange(value);
			}
		}
	}, {
		key: 'selectValue',
		value: function selectValue(value) {
			var _this3 = this;

			// NOTE: we actually add/set the value in a callback to make sure the
			// input value is empty to avoid styling issues in Chrome
			if (this.props.closeOnSelect) {
				this.hasScrolledToOption = false;
			}
			var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
			if (this.props.multi) {
				this.setState({
					focusedIndex: null,
					inputValue: this.handleInputValueChange(updatedValue),
					isOpen: !this.props.closeOnSelect
				}, function () {
					var valueArray = _this3.getValueArray(_this3.props.value);
					if (valueArray.some(function (i) {
						return i[_this3.props.valueKey] === value[_this3.props.valueKey];
					})) {
						_this3.removeValue(value);
					} else {
						_this3.addValue(value);
					}
				});
			} else {
				this.setState({
					inputValue: this.handleInputValueChange(updatedValue),
					isOpen: !this.props.closeOnSelect,
					isPseudoFocused: this.state.isFocused
				}, function () {
					_this3.setValue(value);
				});
			}
		}
	}, {
		key: 'addValue',
		value: function addValue(value) {
			var valueArray = this.getValueArray(this.props.value);
			var visibleOptions = this._visibleOptions.filter(function (val) {
				return !val.disabled;
			});
			var lastValueIndex = visibleOptions.indexOf(value);
			this.setValue(valueArray.concat(value));
			if (!this.props.closeOnSelect) {
				return;
			}
			if (visibleOptions.length - 1 === lastValueIndex) {
				// the last option was selected; focus the second-last one
				this.focusOption(visibleOptions[lastValueIndex - 1]);
			} else if (visibleOptions.length > lastValueIndex) {
				// focus the option below the selected one
				this.focusOption(visibleOptions[lastValueIndex + 1]);
			}
		}
	}, {
		key: 'popValue',
		value: function popValue() {
			var valueArray = this.getValueArray(this.props.value);
			if (!valueArray.length) return;
			if (valueArray[valueArray.length - 1].clearableValue === false) return;
			this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
		}
	}, {
		key: 'removeValue',
		value: function removeValue(value) {
			var _this4 = this;

			var valueArray = this.getValueArray(this.props.value);
			this.setValue(valueArray.filter(function (i) {
				return i[_this4.props.valueKey] !== value[_this4.props.valueKey];
			}));
			this.focus();
		}
	}, {
		key: 'clearValue',
		value: function clearValue(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, ignore it.
			if (event && event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			event.preventDefault();

			this.setValue(this.getResetValue());
			this.setState({
				inputValue: this.handleInputValueChange(''),
				isOpen: false
			}, this.focus);

			this._focusAfterClear = true;
		}
	}, {
		key: 'getResetValue',
		value: function getResetValue() {
			if (this.props.resetValue !== undefined) {
				return this.props.resetValue;
			} else if (this.props.multi) {
				return [];
			} else {
				return null;
			}
		}
	}, {
		key: 'focusOption',
		value: function focusOption(option) {
			this.setState({
				focusedOption: option
			});
		}
	}, {
		key: 'focusNextOption',
		value: function focusNextOption() {
			this.focusAdjacentOption('next');
		}
	}, {
		key: 'focusPreviousOption',
		value: function focusPreviousOption() {
			this.focusAdjacentOption('previous');
		}
	}, {
		key: 'focusPageUpOption',
		value: function focusPageUpOption() {
			this.focusAdjacentOption('page_up');
		}
	}, {
		key: 'focusPageDownOption',
		value: function focusPageDownOption() {
			this.focusAdjacentOption('page_down');
		}
	}, {
		key: 'focusStartOption',
		value: function focusStartOption() {
			this.focusAdjacentOption('start');
		}
	}, {
		key: 'focusEndOption',
		value: function focusEndOption() {
			this.focusAdjacentOption('end');
		}
	}, {
		key: 'focusAdjacentOption',
		value: function focusAdjacentOption(dir) {
			var options = this._visibleOptions.map(function (option, index) {
				return { option: option, index: index };
			}).filter(function (option) {
				return !option.option.disabled;
			});
			this._scrollToFocusedOptionOnUpdate = true;
			if (!this.state.isOpen) {
				var newState = {
					focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null),
					isOpen: true
				};
				if (this.props.onSelectResetsInput) {
					newState.inputValue = '';
				}
				this.setState(newState);
				return;
			}
			if (!options.length) return;
			var focusedIndex = -1;
			for (var i = 0; i < options.length; i++) {
				if (this._focusedOption === options[i].option) {
					focusedIndex = i;
					break;
				}
			}
			if (dir === 'next' && focusedIndex !== -1) {
				focusedIndex = (focusedIndex + 1) % options.length;
			} else if (dir === 'previous') {
				if (focusedIndex > 0) {
					focusedIndex = focusedIndex - 1;
				} else {
					focusedIndex = options.length - 1;
				}
			} else if (dir === 'start') {
				focusedIndex = 0;
			} else if (dir === 'end') {
				focusedIndex = options.length - 1;
			} else if (dir === 'page_up') {
				var potentialIndex = focusedIndex - this.props.pageSize;
				if (potentialIndex < 0) {
					focusedIndex = 0;
				} else {
					focusedIndex = potentialIndex;
				}
			} else if (dir === 'page_down') {
				var _potentialIndex = focusedIndex + this.props.pageSize;
				if (_potentialIndex > options.length - 1) {
					focusedIndex = options.length - 1;
				} else {
					focusedIndex = _potentialIndex;
				}
			}

			if (focusedIndex === -1) {
				focusedIndex = 0;
			}

			this.setState({
				focusedIndex: options[focusedIndex].index,
				focusedOption: options[focusedIndex].option
			});
		}
	}, {
		key: 'getFocusedOption',
		value: function getFocusedOption() {
			return this._focusedOption;
		}
	}, {
		key: 'selectFocusedOption',
		value: function selectFocusedOption() {
			if (this._focusedOption) {
				return this.selectValue(this._focusedOption);
			}
		}
	}, {
		key: 'renderLoading',
		value: function renderLoading() {
			if (!this.props.isLoading) return;
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', { className: 'Select-loading' })
			);
		}
	}, {
		key: 'renderValue',
		value: function renderValue(valueArray, isOpen) {
			var _this5 = this;

			var renderLabel = this.props.valueRenderer || this.getOptionLabel;
			var ValueComponent = this.props.valueComponent;
			if (!valueArray.length) {
				var showPlaceholder = shouldShowPlaceholder(this.state, this.props, isOpen);
				return showPlaceholder ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ className: 'Select-placeholder' },
					this.props.placeholder
				) : null;
			}
			var onClick = this.props.onValueClick ? this.handleValueClick : null;
			if (this.props.multi) {
				return valueArray.map(function (value, i) {
					return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						ValueComponent,
						{
							disabled: _this5.props.disabled || value.clearableValue === false,
							id: _this5._instancePrefix + '-value-' + i,
							instancePrefix: _this5._instancePrefix,
							key: 'value-' + i + '-' + value[_this5.props.valueKey],
							onClick: onClick,
							onRemove: _this5.removeValue,
							placeholder: _this5.props.placeholder,
							value: value,
							values: valueArray
						},
						renderLabel(value, i),
						__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
							'span',
							{ className: 'Select-aria-only' },
							'\xA0'
						)
					);
				});
			} else if (shouldShowValue(this.state, this.props)) {
				if (isOpen) onClick = null;
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					ValueComponent,
					{
						disabled: this.props.disabled,
						id: this._instancePrefix + '-value-item',
						instancePrefix: this._instancePrefix,
						onClick: onClick,
						placeholder: this.props.placeholder,
						value: valueArray[0]
					},
					renderLabel(valueArray[0])
				);
			}
		}
	}, {
		key: 'renderInput',
		value: function renderInput(valueArray, focusedOptionIndex) {
			var _classNames,
			    _this6 = this;

			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select-input', this.props.inputProps.className);
			var isOpen = this.state.isOpen;

			var ariaOwns = __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames = {}, defineProperty(_classNames, this._instancePrefix + '-list', isOpen), defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));

			var value = this.state.inputValue;
			if (value && !this.props.onSelectResetsInput && !this.state.isFocused) {
				// it hides input value when it is not focused and was not reset on select
				value = '';
			}

			var inputProps = _extends({}, this.props.inputProps, {
				'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
				'aria-describedby': this.props['aria-describedby'],
				'aria-expanded': '' + isOpen,
				'aria-haspopup': '' + isOpen,
				'aria-label': this.props['aria-label'],
				'aria-labelledby': this.props['aria-labelledby'],
				'aria-owns': ariaOwns,
				onBlur: this.handleInputBlur,
				onChange: this.handleInputChange,
				onFocus: this.handleInputFocus,
				ref: function ref(_ref) {
					return _this6.input = _ref;
				},
				role: 'combobox',
				required: this.state.required,
				tabIndex: this.props.tabIndex,
				value: value
			});

			if (this.props.inputRenderer) {
				return this.props.inputRenderer(inputProps);
			}

			if (this.props.disabled || !this.props.searchable) {
				var divProps = objectWithoutProperties(this.props.inputProps, []);


				var _ariaOwns = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(defineProperty({}, this._instancePrefix + '-list', isOpen));
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', _extends({}, divProps, {
					'aria-expanded': isOpen,
					'aria-owns': _ariaOwns,
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-disabled': '' + this.props.disabled,
					'aria-label': this.props['aria-label'],
					'aria-labelledby': this.props['aria-labelledby'],
					className: className,
					onBlur: this.handleInputBlur,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref2) {
						return _this6.input = _ref2;
					},
					role: 'combobox',
					style: { border: 0, width: 1, display: 'inline-block' },
					tabIndex: this.props.tabIndex || 0
				}));
			}

			if (this.props.autosize) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_input_autosize___default.a, _extends({ id: this.props.id }, inputProps, { className: className, minWidth: '5' }));
			}
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className, key: 'input-wrap', style: { display: 'inline-block' } },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', _extends({ id: this.props.id }, inputProps))
			);
		}
	}, {
		key: 'renderClear',
		value: function renderClear() {
			var valueArray = this.getValueArray(this.props.value);
			if (!this.props.clearable || !valueArray.length || this.props.disabled || this.props.isLoading) return;
			var ariaLabel = this.props.multi ? this.props.clearAllText : this.props.clearValueText;
			var clear = this.props.clearRenderer();

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{
					'aria-label': ariaLabel,
					className: 'Select-clear-zone',
					onMouseDown: this.clearValue,
					onTouchEnd: this.handleTouchEndClearValue,
					onTouchMove: this.handleTouchMove,
					onTouchStart: this.handleTouchStart,
					title: ariaLabel
				},
				clear
			);
		}
	}, {
		key: 'renderArrow',
		value: function renderArrow() {
			if (!this.props.arrowRenderer) return;

			var onMouseDown = this.handleMouseDownOnArrow;
			var isOpen = this.state.isOpen;
			var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });

			if (!arrow) {
				return null;
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{
					className: 'Select-arrow-zone',
					onMouseDown: onMouseDown
				},
				arrow
			);
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions$$1(excludeOptions) {
			var filterValue = this.state.inputValue;
			var options = this.props.options || [];
			if (this.props.filterOptions) {
				// Maintain backwards compatibility with boolean attribute
				var filterOptions$$1 = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : filterOptions;

				return filterOptions$$1(options, filterValue, excludeOptions, {
					filterOption: this.props.filterOption,
					ignoreAccents: this.props.ignoreAccents,
					ignoreCase: this.props.ignoreCase,
					labelKey: this.props.labelKey,
					matchPos: this.props.matchPos,
					matchProp: this.props.matchProp,
					trimFilter: this.props.trimFilter,
					valueKey: this.props.valueKey
				});
			} else {
				return options;
			}
		}
	}, {
		key: 'onOptionRef',
		value: function onOptionRef(ref, isFocused) {
			if (isFocused) {
				this.focused = ref;
			}
		}
	}, {
		key: 'renderMenu',
		value: function renderMenu(options, valueArray, focusedOption) {
			if (options && options.length) {
				return this.props.menuRenderer({
					focusedOption: focusedOption,
					focusOption: this.focusOption,
					inputValue: this.state.inputValue,
					instancePrefix: this._instancePrefix,
					labelKey: this.props.labelKey,
					onFocus: this.focusOption,
					onOptionRef: this.onOptionRef,
					onSelect: this.selectValue,
					optionClassName: this.props.optionClassName,
					optionComponent: this.props.optionComponent,
					optionRenderer: this.props.optionRenderer || this.getOptionLabel,
					options: options,
					removeValue: this.removeValue,
					selectValue: this.selectValue,
					valueArray: valueArray,
					valueKey: this.props.valueKey
				});
			} else if (this.props.noResultsText) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ className: 'Select-noresults' },
					this.props.noResultsText
				);
			} else {
				return null;
			}
		}
	}, {
		key: 'renderHiddenField',
		value: function renderHiddenField(valueArray) {
			var _this7 = this;

			if (!this.props.name) return;
			if (this.props.joinValues) {
				var value = valueArray.map(function (i) {
					return stringifyValue(i[_this7.props.valueKey]);
				}).join(this.props.delimiter);
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', {
					disabled: this.props.disabled,
					name: this.props.name,
					ref: function ref(_ref3) {
						return _this7.value = _ref3;
					},
					type: 'hidden',
					value: value
				});
			}
			return valueArray.map(function (item, index) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', {
					disabled: _this7.props.disabled,
					key: 'hidden.' + index,
					name: _this7.props.name,
					ref: 'value' + index,
					type: 'hidden',
					value: stringifyValue(item[_this7.props.valueKey])
				});
			});
		}
	}, {
		key: 'getFocusableOptionIndex',
		value: function getFocusableOptionIndex(selectedOption) {
			var options = this._visibleOptions;
			if (!options.length) return null;

			var valueKey = this.props.valueKey;
			var focusedOption = this.state.focusedOption || selectedOption;
			if (focusedOption && !focusedOption.disabled) {
				var focusedOptionIndex = -1;
				options.some(function (option, index) {
					var isOptionEqual = option[valueKey] === focusedOption[valueKey];
					if (isOptionEqual) {
						focusedOptionIndex = index;
					}
					return isOptionEqual;
				});
				if (focusedOptionIndex !== -1) {
					return focusedOptionIndex;
				}
			}

			for (var i = 0; i < options.length; i++) {
				if (!options[i].disabled) return i;
			}
			return null;
		}
	}, {
		key: 'renderOuter',
		value: function renderOuter(options, valueArray, focusedOption) {
			var _this8 = this;

			var menu = this.renderMenu(options, valueArray, focusedOption);
			if (!menu) {
				return null;
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ ref: function ref(_ref5) {
						return _this8.menuContainer = _ref5;
					}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{
						className: 'Select-menu',
						id: this._instancePrefix + '-list',
						onMouseDown: this.handleMouseDownOnMenu,
						onScroll: this.handleMenuScroll,
						ref: function ref(_ref4) {
							return _this8.menu = _ref4;
						},
						role: 'listbox',
						style: this.props.menuStyle,
						tabIndex: -1
					},
					menu
				)
			);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this9 = this;

			var valueArray = this.getValueArray(this.props.value);
			var options = this._visibleOptions = this.filterOptions(this.props.multi && this.props.removeSelected ? valueArray : null);
			var isOpen = this.state.isOpen;
			if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
			var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);

			var focusedOption = null;
			if (focusedOptionIndex !== null) {
				focusedOption = this._focusedOption = options[focusedOptionIndex];
			} else {
				focusedOption = this._focusedOption = null;
			}
			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select', this.props.className, {
				'has-value': valueArray.length,
				'is-clearable': this.props.clearable,
				'is-disabled': this.props.disabled,
				'is-focused': this.state.isFocused,
				'is-loading': this.props.isLoading,
				'is-open': isOpen,
				'is-pseudo-focused': this.state.isPseudoFocused,
				'is-searchable': this.props.searchable,
				'Select--multi': this.props.multi,
				'Select--rtl': this.props.rtl,
				'Select--single': !this.props.multi
			});

			var removeMessage = null;
			if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
				removeMessage = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'span',
					{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
					this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
				);
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ ref: function ref(_ref7) {
						return _this9.wrapper = _ref7;
					},
					className: className,
					style: this.props.wrapperStyle },
				this.renderHiddenField(valueArray),
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ ref: function ref(_ref6) {
							return _this9.control = _ref6;
						},
						className: 'Select-control',
						onKeyDown: this.handleKeyDown,
						onMouseDown: this.handleMouseDown,
						onTouchEnd: this.handleTouchEnd,
						onTouchMove: this.handleTouchMove,
						onTouchStart: this.handleTouchStart,
						style: this.props.style
					},
					__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						'div',
						{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
						this.renderValue(valueArray, isOpen),
						this.renderInput(valueArray, focusedOptionIndex)
					),
					removeMessage,
					this.renderLoading(),
					this.renderClear(),
					this.renderArrow()
				),
				isOpen ? this.renderOuter(options, valueArray, focusedOption) : null
			);
		}
	}]);
	return Select;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Select$1.propTypes = {
	'aria-describedby': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id(s) of element(s) that should be used to describe this input (for assistive tech)
	'aria-label': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // aria label (for assistive tech)
	'aria-labelledby': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id of an element that should be used as the label (for assistive tech)
	arrowRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // create the drop-down caret element
	autoBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // automatically blur the component when an option is selected
	autoFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // autofocus the component on mount
	autofocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // deprecated; use autoFocus instead
	autosize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to enable autosizing or not
	backspaceRemoves: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether backspace removes an item if there is no text input
	backspaceToRemoveMessage: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
	className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // className for the outer element
	clearAllText: stringOrNode, // title for the "clear" control when multi: true
	clearRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // create clearable x element
	clearValueText: stringOrNode, // title for the "clear" control
	clearable: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // should it be possible to reset value
	closeOnSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to close the menu when a value is selected
	deleteRemoves: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether delete removes an item if there is no text input
	delimiter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // delimiter to use to join multiple values for the hidden field value
	disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the Select is disabled or not
	escapeClearsValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether escape clears the value when the menu is closed
	filterOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to filter a single option (option, filterString)
	filterOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
	id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id to set on the input element for accessibility or tests
	ignoreAccents: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to strip diacritics when filtering
	ignoreCase: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to perform case-insensitive filtering
	inputProps: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // custom attributes for the Input
	inputRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // returns a custom input component
	instanceId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // set the components instanceId
	isLoading: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the Select is loading externally or not (such as options being loaded)
	joinValues: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
	labelKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // path of the label value in option objects
	matchPos: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // (any|start) match the start or entire string when filtering
	matchProp: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // (any|label|value) which option property to filter on
	menuBuffer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
	menuContainerStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the menu container
	menuRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // renders a custom menu with options
	menuStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the menu
	multi: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // multi-value input
	name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // generates a hidden <input /> tag with this field name for html forms
	noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
	onBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onBlur handler: function (event) {}
	onBlurResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared on blur
	onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onChange handler: function (newValue) {}
	onClose: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is closed
	onCloseResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared when menu is closed through the arrow
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onFocus handler: function (event) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onInputChange handler: function (inputValue) {}
	onInputKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // input keyDown handler: function (event) {}
	onMenuScrollToBottom: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
	onOpen: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is opened
	onSelectResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared on select (works only for multiselect)
	onValueClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onClick handler for value labels: function (value, event) {}
	openOnClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // boolean to control opening the menu when the control is clicked
	openOnFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // always open options menu on focus
	optionClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // additional class(es) to apply to the <Option /> elements
	optionComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // option component to render in dropdown
	optionRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // optionRenderer: function (option) {}
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, // array of options
	pageSize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, // number of entries to page when using page up/down keys
	placeholder: stringOrNode, // field placeholder, displayed when there's no value
	removeSelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the selected option is removed from the dropdown on multi selects
	required: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // applies HTML5 required attribute when needed
	resetValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // value to use when you clear the control
	rtl: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // set to true in order to use react-select in right-to-left direction
	scrollMenuIntoView: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
	searchable: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to enable searching feature or not
	simpleValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
	style: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the control
	tabIndex: stringOrNumber, // optional tab index of the control
	tabSelectsValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to treat tabbing out while focused to be value selection
	trimFilter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to trim whitespace around filter value
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // initial field value
	valueComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // value component to render
	valueKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // path of the label value in option objects
	valueRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // valueRenderer: function (option) {}
	wrapperStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object // optional style to apply to the component wrapper
};

Select$1.defaultProps = {
	arrowRenderer: arrowRenderer,
	autosize: true,
	backspaceRemoves: true,
	backspaceToRemoveMessage: 'Press backspace to remove {label}',
	clearable: true,
	clearAllText: 'Clear all',
	clearRenderer: clearRenderer,
	clearValueText: 'Clear value',
	closeOnSelect: true,
	deleteRemoves: true,
	delimiter: ',',
	disabled: false,
	escapeClearsValue: true,
	filterOptions: filterOptions,
	ignoreAccents: true,
	ignoreCase: true,
	inputProps: {},
	isLoading: false,
	joinValues: false,
	labelKey: 'label',
	matchPos: 'any',
	matchProp: 'any',
	menuBuffer: 0,
	menuRenderer: menuRenderer,
	multi: false,
	noResultsText: 'No results found',
	onBlurResetsInput: true,
	onCloseResetsInput: true,
	onSelectResetsInput: true,
	openOnClick: true,
	optionComponent: Option,
	pageSize: 5,
	placeholder: 'Select...',
	removeSelected: true,
	required: false,
	rtl: false,
	scrollMenuIntoView: true,
	searchable: true,
	simpleValue: false,
	tabSelectsValue: true,
	trimFilter: true,
	valueComponent: Value,
	valueKey: 'value'
};

var propTypes = {
	autoload: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
	cache: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // object to use to cache results; set to null/false to disable caching
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	ignoreAccents: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // strip diacritics when filtering; defaults to true
	ignoreCase: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // perform case-insensitive filtering; defaults to true
	loadOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
	loadingPlaceholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// replaces the placeholder while options are loading
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	multi: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // multi-value input
	noResultsText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// field noResultsText, displayed when no options come back from the server
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onChange handler: function (newValue) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // optional for keeping track of what is being typed
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired, // array of options
	placeholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	searchPromptText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// label to prompt for search input
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any // initial field value
};

var defaultCache = {};

var defaultChildren = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

var defaultProps = {
	autoload: true,
	cache: defaultCache,
	children: defaultChildren,
	ignoreAccents: true,
	ignoreCase: true,
	loadingPlaceholder: 'Loading...',
	options: [],
	searchPromptText: 'Type to search'
};

var Async = function (_Component) {
	inherits(Async, _Component);

	function Async(props, context) {
		classCallCheck(this, Async);

		var _this = possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));

		_this._cache = props.cache === defaultCache ? {} : props.cache;

		_this.state = {
			inputValue: '',
			isLoading: false,
			options: props.options
		};

		_this.onInputChange = _this.onInputChange.bind(_this);
		return _this;
	}

	createClass(Async, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var autoload = this.props.autoload;


			if (autoload) {
				this.loadOptions('');
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.options !== this.props.options) {
				this.setState({
					options: nextProps.options
				});
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this._callback = null;
		}
	}, {
		key: 'loadOptions',
		value: function loadOptions(inputValue) {
			var _this2 = this;

			var loadOptions = this.props.loadOptions;

			var cache = this._cache;

			if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
				this._callback = null;

				this.setState({
					isLoading: false,
					options: cache[inputValue]
				});

				return;
			}

			var callback = function callback(error, data) {
				var options = data && data.options || [];

				if (cache) {
					cache[inputValue] = options;
				}

				if (callback === _this2._callback) {
					_this2._callback = null;

					_this2.setState({
						isLoading: false,
						options: options
					});
				}
			};

			// Ignore all but the most recent request
			this._callback = callback;

			var promise = loadOptions(inputValue, callback);
			if (promise) {
				promise.then(function (data) {
					return callback(null, data);
				}, function (error) {
					return callback(error);
				});
			}

			if (this._callback && !this.state.isLoading) {
				this.setState({
					isLoading: true
				});
			}
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(inputValue) {
			var _props = this.props,
			    ignoreAccents = _props.ignoreAccents,
			    ignoreCase = _props.ignoreCase,
			    onInputChange = _props.onInputChange;

			var newInputValue = inputValue;

			if (onInputChange) {
				var value = onInputChange(newInputValue);
				// Note: != used deliberately here to catch undefined and null
				if (value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
					newInputValue = '' + value;
				}
			}

			var transformedInputValue = newInputValue;

			if (ignoreAccents) {
				transformedInputValue = stripDiacritics(transformedInputValue);
			}

			if (ignoreCase) {
				transformedInputValue = transformedInputValue.toLowerCase();
			}

			this.setState({ inputValue: newInputValue });
			this.loadOptions(transformedInputValue);

			// Return new input value, but without applying toLowerCase() to avoid modifying the user's view case of the input while typing.
			return newInputValue;
		}
	}, {
		key: 'noResultsText',
		value: function noResultsText() {
			var _props2 = this.props,
			    loadingPlaceholder = _props2.loadingPlaceholder,
			    noResultsText = _props2.noResultsText,
			    searchPromptText = _props2.searchPromptText;
			var _state = this.state,
			    inputValue = _state.inputValue,
			    isLoading = _state.isLoading;


			if (isLoading) {
				return loadingPlaceholder;
			}
			if (inputValue && noResultsText) {
				return noResultsText;
			}
			return searchPromptText;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _props3 = this.props,
			    children = _props3.children,
			    loadingPlaceholder = _props3.loadingPlaceholder,
			    placeholder = _props3.placeholder;
			var _state2 = this.state,
			    isLoading = _state2.isLoading,
			    options = _state2.options;


			var props = {
				noResultsText: this.noResultsText(),
				placeholder: isLoading ? loadingPlaceholder : placeholder,
				options: isLoading && loadingPlaceholder ? [] : options,
				ref: function ref(_ref) {
					return _this3.select = _ref;
				}
			};

			return children(_extends({}, this.props, props, {
				isLoading: isLoading,
				onInputChange: this.onInputChange
			}));
		}
	}]);
	return Async;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

Async.propTypes = propTypes;
Async.defaultProps = defaultProps;

var CreatableSelect = function (_React$Component) {
	inherits(CreatableSelect, _React$Component);

	function CreatableSelect(props, context) {
		classCallCheck(this, CreatableSelect);

		var _this = possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));

		_this.filterOptions = _this.filterOptions.bind(_this);
		_this.menuRenderer = _this.menuRenderer.bind(_this);
		_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
		_this.onInputChange = _this.onInputChange.bind(_this);
		_this.onOptionSelect = _this.onOptionSelect.bind(_this);
		return _this;
	}

	createClass(CreatableSelect, [{
		key: 'createNewOption',
		value: function createNewOption() {
			var _props = this.props,
			    isValidNewOption = _props.isValidNewOption,
			    newOptionCreator = _props.newOptionCreator,
			    onNewOptionClick = _props.onNewOptionClick,
			    _props$options = _props.options,
			    options = _props$options === undefined ? [] : _props$options;


			if (isValidNewOption({ label: this.inputValue })) {
				var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
				var _isOptionUnique = this.isOptionUnique({ option: option, options: options });

				// Don't add the same option twice.
				if (_isOptionUnique) {
					if (onNewOptionClick) {
						onNewOptionClick(option);
					} else {
						options.unshift(option);

						this.select.selectValue(option);
					}
				}
			}
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions$$1() {
			var _props2 = this.props,
			    filterOptions$$1 = _props2.filterOptions,
			    isValidNewOption = _props2.isValidNewOption,
			    promptTextCreator = _props2.promptTextCreator,
			    showNewOptionAtTop = _props2.showNewOptionAtTop;

			// TRICKY Check currently selected options as well.
			// Don't display a create-prompt for a value that's selected.
			// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.

			var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];

			var filteredOptions = filterOptions$$1.apply(undefined, arguments) || [];

			if (isValidNewOption({ label: this.inputValue })) {
				var _newOptionCreator = this.props.newOptionCreator;


				var option = _newOptionCreator({
					label: this.inputValue,
					labelKey: this.labelKey,
					valueKey: this.valueKey
				});

				// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
				// For multi-selects, this would remove it from the filtered list.
				var _isOptionUnique2 = this.isOptionUnique({
					option: option,
					options: excludeOptions.concat(filteredOptions)
				});

				if (_isOptionUnique2) {
					var prompt = promptTextCreator(this.inputValue);

					this._createPlaceholderOption = _newOptionCreator({
						label: prompt,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});

					if (showNewOptionAtTop) {
						filteredOptions.unshift(this._createPlaceholderOption);
					} else {
						filteredOptions.push(this._createPlaceholderOption);
					}
				}
			}

			return filteredOptions;
		}
	}, {
		key: 'isOptionUnique',
		value: function isOptionUnique(_ref) {
			var option = _ref.option,
			    options = _ref.options;
			var isOptionUnique = this.props.isOptionUnique;


			options = options || this.props.options;

			return isOptionUnique({
				labelKey: this.labelKey,
				option: option,
				options: options,
				valueKey: this.valueKey
			});
		}
	}, {
		key: 'menuRenderer',
		value: function menuRenderer$$1(params) {
			var menuRenderer$$1 = this.props.menuRenderer;


			return menuRenderer$$1(_extends({}, params, {
				onSelect: this.onOptionSelect,
				selectValue: this.onOptionSelect
			}));
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(input) {
			var onInputChange = this.props.onInputChange;

			// This value may be needed in between Select mounts (when this.select is null)

			this.inputValue = input;

			if (onInputChange) {
				this.inputValue = onInputChange(input);
			}

			return this.inputValue;
		}
	}, {
		key: 'onInputKeyDown',
		value: function onInputKeyDown(event) {
			var _props3 = this.props,
			    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
			    onInputKeyDown = _props3.onInputKeyDown;

			var focusedOption = this.select.getFocusedOption();

			if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption(event)) {
				this.createNewOption();

				// Prevent decorated Select from doing anything additional with this keyDown event
				event.preventDefault();
			} else if (onInputKeyDown) {
				onInputKeyDown(event);
			}
		}
	}, {
		key: 'onOptionSelect',
		value: function onOptionSelect(option) {
			if (option === this._createPlaceholderOption) {
				this.createNewOption();
			} else {
				this.select.selectValue(option);
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props4 = this.props,
			    refProp = _props4.ref,
			    restProps = objectWithoutProperties(_props4, ['ref']);
			var children = this.props.children;

			// We can't use destructuring default values to set the children,
			// because it won't apply work if `children` is null. A falsy check is
			// more reliable in real world use-cases.

			if (!children) {
				children = defaultChildren$2;
			}

			var props = _extends({}, restProps, {
				allowCreate: true,
				filterOptions: this.filterOptions,
				menuRenderer: this.menuRenderer,
				onInputChange: this.onInputChange,
				onInputKeyDown: this.onInputKeyDown,
				ref: function ref(_ref2) {
					_this2.select = _ref2;

					// These values may be needed in between Select mounts (when this.select is null)
					if (_ref2) {
						_this2.labelKey = _ref2.props.labelKey;
						_this2.valueKey = _ref2.props.valueKey;
					}
					if (refProp) {
						refProp(_ref2);
					}
				}
			});

			return children(props);
		}
	}]);
	return CreatableSelect;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

var defaultChildren$2 = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

var isOptionUnique = function isOptionUnique(_ref3) {
	var option = _ref3.option,
	    options = _ref3.options,
	    labelKey = _ref3.labelKey,
	    valueKey = _ref3.valueKey;

	if (!options || !options.length) {
		return true;
	}

	return options.filter(function (existingOption) {
		return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
	}).length === 0;
};

var isValidNewOption = function isValidNewOption(_ref4) {
	var label = _ref4.label;
	return !!label;
};

var newOptionCreator = function newOptionCreator(_ref5) {
	var label = _ref5.label,
	    labelKey = _ref5.labelKey,
	    valueKey = _ref5.valueKey;

	var option = {};
	option[valueKey] = label;
	option[labelKey] = label;
	option.className = 'Select-create-option-placeholder';

	return option;
};

var promptTextCreator = function promptTextCreator(label) {
	return 'Create option "' + label + '"';
};

var shouldKeyDownEventCreateNewOption = function shouldKeyDownEventCreateNewOption(_ref6) {
	var keyCode = _ref6.keyCode;

	switch (keyCode) {
		case 9: // TAB
		case 13: // ENTER
		case 188:
			// COMMA
			return true;
		default:
			return false;
	}
};

// Default prop methods
CreatableSelect.isOptionUnique = isOptionUnique;
CreatableSelect.isValidNewOption = isValidNewOption;
CreatableSelect.newOptionCreator = newOptionCreator;
CreatableSelect.promptTextCreator = promptTextCreator;
CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;

CreatableSelect.defaultProps = {
	filterOptions: filterOptions,
	isOptionUnique: isOptionUnique,
	isValidNewOption: isValidNewOption,
	menuRenderer: menuRenderer,
	newOptionCreator: newOptionCreator,
	promptTextCreator: promptTextCreator,
	shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption,
	showNewOptionAtTop: true
};

CreatableSelect.propTypes = {
	// Child function responsible for creating the inner Select component
	// This component can be used to compose HOCs (eg Creatable and Async)
	// (props: Object): PropTypes.element
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.filterOptions
	filterOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,

	// Searches for any matching option within the set of options.
	// This function prevents duplicate options from being created.
	// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
	isOptionUnique: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Determines if the current input text represents a valid option.
	// ({ label: string }): boolean
	isValidNewOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.menuRenderer
	menuRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,

	// Factory to create new option.
	// ({ label: string, labelKey: string, valueKey: string }): Object
	newOptionCreator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// input change handler: function (inputValue) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// input keyDown handler: function (event) {}
	onInputKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// new option click handler: function (option) {}
	onNewOptionClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.options
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,

	// Creates prompt/placeholder option text.
	// (filterText: string): string
	promptTextCreator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	ref: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
	shouldKeyDownEventCreateNewOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Where to show prompt/placeholder option text.
	// true: new option prompt at top of list (default)
	// false: new option prompt at bottom of list
	showNewOptionAtTop: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
};

var AsyncCreatableSelect = function (_React$Component) {
	inherits(AsyncCreatableSelect, _React$Component);

	function AsyncCreatableSelect() {
		classCallCheck(this, AsyncCreatableSelect);
		return possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
	}

	createClass(AsyncCreatableSelect, [{
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				Async,
				this.props,
				function (_ref) {
					var ref = _ref.ref,
					    asyncProps = objectWithoutProperties(_ref, ['ref']);

					var asyncRef = ref;
					return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						CreatableSelect,
						asyncProps,
						function (_ref2) {
							var ref = _ref2.ref,
							    creatableProps = objectWithoutProperties(_ref2, ['ref']);

							var creatableRef = ref;
							return _this2.props.children(_extends({}, creatableProps, {
								ref: function ref(select) {
									creatableRef(select);
									asyncRef(select);
									_this2.select = select;
								}
							}));
						}
					);
				}
			);
		}
	}]);
	return AsyncCreatableSelect;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

var defaultChildren$1 = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

AsyncCreatableSelect.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
};

AsyncCreatableSelect.defaultProps = {
	children: defaultChildren$1
};

Select$1.Async = Async;
Select$1.AsyncCreatable = AsyncCreatableSelect;
Select$1.Creatable = CreatableSelect;
Select$1.Value = Value;
Select$1.Option = Option;


/* harmony default export */ __webpack_exports__["a"] = (Select$1);


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _InputLabel.default;
  }
});

var _InputLabel = _interopRequireDefault(__webpack_require__(852));

/***/ }),
/* 27 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;

/***/ }),
/* 28 */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(294);

var assertThisInitialized = __webpack_require__(145);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;

/***/ }),
/* 30 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(791);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Divider.default;
  }
});

var _Divider = _interopRequireDefault(__webpack_require__(1008));

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Card.default;
  }
});

var _Card = _interopRequireDefault(__webpack_require__(998));

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        return name.match('^[^/\\\\]*$') != null;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.4';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(227)(module)))

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _CardContent.default;
  }
});

var _CardContent = _interopRequireDefault(__webpack_require__(1000));

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return epsilon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return epsilon2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return pi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return halfPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return quarterPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return tau; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return degrees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return radians; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return abs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return atan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return atan2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return cos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ceil; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return exp; });
/* unused harmony export floor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return log; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return pow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return sin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return sign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return sqrt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return tan; });
/* harmony export (immutable) */ __webpack_exports__["b"] = acos;
/* harmony export (immutable) */ __webpack_exports__["c"] = asin;
/* harmony export (immutable) */ __webpack_exports__["m"] = haversin;
var epsilon = 1e-6;
var epsilon2 = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var quarterPi = pi / 4;
var tau = pi * 2;

var degrees = 180 / pi;
var radians = pi / 180;

var abs = Math.abs;
var atan = Math.atan;
var atan2 = Math.atan2;
var cos = Math.cos;
var ceil = Math.ceil;
var exp = Math.exp;
var floor = Math.floor;
var log = Math.log;
var pow = Math.pow;
var sin = Math.sin;
var sign = Math.sign || function(x) { return x > 0 ? 1 : x < 0 ? -1 : 0; };
var sqrt = Math.sqrt;
var tan = Math.tan;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}

function asin(x) {
  return x > 1 ? halfPi : x < -1 ? -halfPi : Math.asin(x);
}

function haversin(x) {
  return (x = sin(x / 2)) * x;
}


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _DialogActions.default;
  }
});

var _DialogActions = _interopRequireDefault(__webpack_require__(886));

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _DialogContent.default;
  }
});

var _DialogContent = _interopRequireDefault(__webpack_require__(887));

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1064);

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
})), 'ArrowBack');

exports.default = _default;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FormGroup.default;
  }
});

var _FormGroup = _interopRequireDefault(__webpack_require__(1016));

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GraphQLError__ = __webpack_require__(106);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__GraphQLError__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syntaxError__ = __webpack_require__(678);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__syntaxError__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__locatedError__ = __webpack_require__(393);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__locatedError__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__printError__ = __webpack_require__(390);
/* unused harmony reexport printError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__formatError__ = __webpack_require__(679);
/* unused harmony reexport formatError */
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */







/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FormHelperText.default;
  }
});

var _FormHelperText = _interopRequireDefault(__webpack_require__(855));

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _DialogTitle.default;
  }
});

var _DialogTitle = _interopRequireDefault(__webpack_require__(1007));

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isType */
/* unused harmony export assertType */
/* harmony export (immutable) */ __webpack_exports__["z"] = isScalarType;
/* unused harmony export assertScalarType */
/* harmony export (immutable) */ __webpack_exports__["x"] = isObjectType;
/* harmony export (immutable) */ __webpack_exports__["k"] = assertObjectType;
/* harmony export (immutable) */ __webpack_exports__["s"] = isInterfaceType;
/* harmony export (immutable) */ __webpack_exports__["i"] = assertInterfaceType;
/* harmony export (immutable) */ __webpack_exports__["A"] = isUnionType;
/* unused harmony export assertUnionType */
/* harmony export (immutable) */ __webpack_exports__["p"] = isEnumType;
/* unused harmony export assertEnumType */
/* harmony export (immutable) */ __webpack_exports__["q"] = isInputObjectType;
/* unused harmony export assertInputObjectType */
/* harmony export (immutable) */ __webpack_exports__["u"] = isListType;
/* unused harmony export assertListType */
/* harmony export (immutable) */ __webpack_exports__["w"] = isNonNullType;
/* unused harmony export assertNonNullType */
/* harmony export (immutable) */ __webpack_exports__["r"] = isInputType;
/* unused harmony export assertInputType */
/* harmony export (immutable) */ __webpack_exports__["y"] = isOutputType;
/* unused harmony export assertOutputType */
/* harmony export (immutable) */ __webpack_exports__["t"] = isLeafType;
/* unused harmony export assertLeafType */
/* harmony export (immutable) */ __webpack_exports__["o"] = isCompositeType;
/* unused harmony export assertCompositeType */
/* harmony export (immutable) */ __webpack_exports__["n"] = isAbstractType;
/* unused harmony export assertAbstractType */
/* harmony export (immutable) */ __webpack_exports__["d"] = GraphQLList;
/* harmony export (immutable) */ __webpack_exports__["e"] = GraphQLNonNull;
/* harmony export (immutable) */ __webpack_exports__["B"] = isWrappingType;
/* unused harmony export assertWrappingType */
/* unused harmony export isNullableType */
/* harmony export (immutable) */ __webpack_exports__["j"] = assertNullableType;
/* harmony export (immutable) */ __webpack_exports__["m"] = getNullableType;
/* harmony export (immutable) */ __webpack_exports__["v"] = isNamedType;
/* unused harmony export assertNamedType */
/* harmony export (immutable) */ __webpack_exports__["l"] = getNamedType;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GraphQLScalarType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GraphQLObjectType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GraphQLInterfaceType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GraphQLUnionType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GraphQLEnumType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GraphQLInputObjectType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsutils_instanceOf__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsutils_invariant__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsutils_isInvalid__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__language_kinds__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_valueFromASTUntyped__ = __webpack_require__(389);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */








// Predicates & Assertions

/**
 * These are all of the possible kinds of types.
 */


function isType(type) {
  return isScalarType(type) || isObjectType(type) || isInterfaceType(type) || isUnionType(type) || isEnumType(type) || isInputObjectType(type) || isListType(type) || isNonNullType(type);
}

function assertType(type) {
  !isType(type) ? Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant__["a" /* default */])(0, 'Expected ' + String(type) + ' to be a GraphQL type.') : void 0;
  return type;
}

/**
 * There are predicates for each kind of GraphQL type.
 */

// eslint-disable-next-line no-redeclare
function isScalarType(type) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_instanceOf__["a" /* default */])(type, GraphQLScalarType);
}

function assertScalarType(type) {
  !isScalarType(type) ? Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant__["a" /* default */])(0, 'Expected ' + String(type) + ' to be a GraphQL Scalar type.') : void 0;
  return type;
}

// eslint-disable-next-line no-redeclare
function isObjectType(type) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_instanceOf__["a" /* default */])(type, GraphQLObjectType);
}

function assertObjectType(type) {
  !isObjectType(type) ? Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant__["a" /* default */])(0, 'Expected ' + String(type) + ' to be a GraphQL Object type.') : void 0;
  return type;
}

// eslint-disable-next-line no-redeclare
function isInterfaceType(type) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_instanceOf__["a" /* default */])(type, GraphQLInterfaceType);
}

function assertInterfaceType(type) {
  !isInterfaceType(type) ? Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant__["a" /* default */])(0, 'Expected ' + String(type) + ' to be a GraphQL Interface type.') : void 0;
  return type;
}

// eslint-disable-next-line no-redeclare
function isUnionType(type) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_instanceOf__["a" /* default */])(type, GraphQLUnionType);
}

function assertUnionType(type) {
  !isUnionType(type) ? Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant__["a" /* default */])(0, 'Expected ' + String(type) + ' to be a GraphQL Union type.') : void 0;
  return type;
}

// eslint-disable-next-line no-redeclare
function isEnumType(type) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_instanceOf__["a" /* default */])(type, GraphQLEnumType);
}

function assertEnumType(type) {
  !isEnumType(type) ? Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant__["a" /* default */])(0, 'Expected ' + String(type) + ' to be a GraphQL Enum type.') : void 0;
  return type;
}

// eslint-disable-next-line no-redeclare
function isInputObjectType(type) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_instanceOf__["a" /* default */])(type, GraphQLInputObjectType);
}

function assertInputObjectType(type) {
  !isInputObjectType(type) ? Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant__["a" /* default */])(0, 'Expected ' + String(type) + ' to be a GraphQL Input Object type.') : void 0;
  return type;
}

// eslint-disable-next-line no-redeclare
function isListType(type) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_instanceOf__["a" /* default */])(type, GraphQLList);
}

function assertListType(type) {
  !isListType(type) ? Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant__["a" /* default */])(0, 'Expected ' + String(type) + ' to be a GraphQL List type.') : void 0;
  return type;
}

// eslint-disable-next-line no-redeclare
function isNonNullType(type) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_instanceOf__["a" /* default */])(type, GraphQLNonNull);
}

function assertNonNullType(type) {
  !isNonNullType(type) ? Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant__["a" /* default */])(0, 'Expected ' + String(type) + ' to be a GraphQL Non-Null type.') : void 0;
  return type;
}

/**
 * These types may be used as input types for arguments and directives.
 */


function isInputType(type) {
  return isScalarType(type) || isEnumType(type) || isInputObjectType(type) || isWrappingType(type) && isInputType(type.ofType);
}

function assertInputType(type) {
  !isInputType(type) ? Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant__["a" /* default */])(0, 'Expected ' + String(type) + ' to be a GraphQL input type.') : void 0;
  return type;
}

/**
 * These types may be used as output types as the result of fields.
 */


function isOutputType(type) {
  return isScalarType(type) || isObjectType(type) || isInterfaceType(type) || isUnionType(type) || isEnumType(type) || isWrappingType(type) && isOutputType(type.ofType);
}

function assertOutputType(type) {
  !isOutputType(type) ? Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant__["a" /* default */])(0, 'Expected ' + String(type) + ' to be a GraphQL output type.') : void 0;
  return type;
}

/**
 * These types may describe types which may be leaf values.
 */


function isLeafType(type) {
  return isScalarType(type) || isEnumType(type);
}

function assertLeafType(type) {
  !isLeafType(type) ? Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant__["a" /* default */])(0, 'Expected ' + String(type) + ' to be a GraphQL leaf type.') : void 0;
  return type;
}

/**
 * These types may describe the parent context of a selection set.
 */


function isCompositeType(type) {
  return isObjectType(type) || isInterfaceType(type) || isUnionType(type);
}

function assertCompositeType(type) {
  !isCompositeType(type) ? Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant__["a" /* default */])(0, 'Expected ' + String(type) + ' to be a GraphQL composite type.') : void 0;
  return type;
}

/**
 * These types may describe the parent context of a selection set.
 */


function isAbstractType(type) {
  return isInterfaceType(type) || isUnionType(type);
}

function assertAbstractType(type) {
  !isAbstractType(type) ? Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant__["a" /* default */])(0, 'Expected ' + String(type) + ' to be a GraphQL abstract type.') : void 0;
  return type;
}

/**
 * List Type Wrapper
 *
 * A list is a wrapping type which points to another type.
 * Lists are often created within the context of defining the fields of
 * an object type.
 *
 * Example:
 *
 *     const PersonType = new GraphQLObjectType({
 *       name: 'Person',
 *       fields: () => ({
 *         parents: { type: GraphQLList(PersonType) },
 *         children: { type: GraphQLList(PersonType) },
 *       })
 *     })
 *
 */

// eslint-disable-next-line no-redeclare
function GraphQLList(ofType) {
  if (this instanceof GraphQLList) {
    this.ofType = assertType(ofType);
  } else {
    return new GraphQLList(ofType);
  }
}

// Also provide toJSON and inspect aliases for toString.
var listProto = GraphQLList.prototype;
listProto.toString = listProto.toJSON = listProto.inspect = function toString() {
  return '[' + String(this.ofType) + ']';
};

/**
 * Non-Null Type Wrapper
 *
 * A non-null is a wrapping type which points to another type.
 * Non-null types enforce that their values are never null and can ensure
 * an error is raised if this ever occurs during a request. It is useful for
 * fields which you can make a strong guarantee on non-nullability, for example
 * usually the id field of a database row will never be null.
 *
 * Example:
 *
 *     const RowType = new GraphQLObjectType({
 *       name: 'Row',
 *       fields: () => ({
 *         id: { type: GraphQLNonNull(GraphQLString) },
 *       })
 *     })
 *
 * Note: the enforcement of non-nullability occurs within the executor.
 */

// eslint-disable-next-line no-redeclare
function GraphQLNonNull(ofType) {
  if (this instanceof GraphQLNonNull) {
    this.ofType = assertNullableType(ofType);
  } else {
    return new GraphQLNonNull(ofType);
  }
}

// Also provide toJSON and inspect aliases for toString.
var nonNullProto = GraphQLNonNull.prototype;
nonNullProto.toString = nonNullProto.toJSON = nonNullProto.inspect = function toString() {
  return String(this.ofType) + '!';
};

/**
 * These types wrap and modify other types
 */

function isWrappingType(type) {
  return isListType(type) || isNonNullType(type);
}

function assertWrappingType(type) {
  !isWrappingType(type) ? Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant__["a" /* default */])(0, 'Expected ' + String(type) + ' to be a GraphQL wrapping type.') : void 0;
  return type;
}

/**
 * These types can all accept null as a value.
 */


function isNullableType(type) {
  return isType(type) && !isNonNullType(type);
}

function assertNullableType(type) {
  !isNullableType(type) ? Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant__["a" /* default */])(0, 'Expected ' + String(type) + ' to be a GraphQL nullable type.') : void 0;
  return type;
}

/* eslint-disable no-redeclare */

function getNullableType(type) {
  /* eslint-enable no-redeclare */
  if (type) {
    return isNonNullType(type) ? type.ofType : type;
  }
}

/**
 * These named types do not include modifiers like List or NonNull.
 */


function isNamedType(type) {
  return isScalarType(type) || isObjectType(type) || isInterfaceType(type) || isUnionType(type) || isEnumType(type) || isInputObjectType(type);
}

function assertNamedType(type) {
  !isNamedType(type) ? Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant__["a" /* default */])(0, 'Expected ' + String(type) + ' to be a GraphQL named type.') : void 0;
  return type;
}

/* eslint-disable no-redeclare */

function getNamedType(type) {
  /* eslint-enable no-redeclare */
  if (type) {
    var unwrappedType = type;
    while (isWrappingType(unwrappedType)) {
      unwrappedType = unwrappedType.ofType;
    }
    return unwrappedType;
  }
}

/**
 * Used while defining GraphQL types to allow for circular references in
 * otherwise immutable type definitions.
 */


function resolveThunk(thunk) {
  return typeof thunk === 'function' ? thunk() : thunk;
}

/**
 * Scalar Type Definition
 *
 * The leaf values of any request and input values to arguments are
 * Scalars (or Enums) and are defined with a name and a series of functions
 * used to parse input from ast or variables and to ensure validity.
 *
 * If a type's serialize function does not return a value (i.e. it returns
 * `undefined`) then an error will be raised and a `null` value will be returned
 * in the response. If the serialize function returns `null`, then no error will
 * be included in the response.
 *
 * Example:
 *
 *     const OddType = new GraphQLScalarType({
 *       name: 'Odd',
 *       serialize(value) {
 *         if (value % 2 === 1) {
 *           return value;
 *         }
 *       }
 *     });
 *
 */
var GraphQLScalarType = function () {
  function GraphQLScalarType(config) {
    _classCallCheck(this, GraphQLScalarType);

    this.name = config.name;
    this.description = config.description;
    this.astNode = config.astNode;
    this._scalarConfig = config;
    !(typeof config.name === 'string') ? Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant__["a" /* default */])(0, 'Must provide name.') : void 0;
    !(typeof config.serialize === 'function') ? Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant__["a" /* default */])(0, this.name + ' must provide "serialize" function. If this custom Scalar ' + 'is also used as an input type, ensure "parseValue" and "parseLiteral" ' + 'functions are also provided.') : void 0;
    if (config.parseValue || config.parseLiteral) {
      !(typeof config.parseValue === 'function' && typeof config.parseLiteral === 'function') ? Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant__["a" /* default */])(0, this.name + ' must provide both "parseValue" and "parseLiteral" ' + 'functions.') : void 0;
    }
  }

  // Serializes an internal value to include in a response.


  GraphQLScalarType.prototype.serialize = function serialize(value) {
    var serializer = this._scalarConfig.serialize;
    return serializer(value);
  };

  // Parses an externally provided value to use as an input.


  GraphQLScalarType.prototype.parseValue = function parseValue(value) {
    var parser = this._scalarConfig.parseValue;
    if (Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_isInvalid__["a" /* default */])(value)) {
      return undefined;
    }
    return parser ? parser(value) : value;
  };

  // Parses an externally provided literal value to use as an input.


  GraphQLScalarType.prototype.parseLiteral = function parseLiteral(valueNode, variables) {
    var parser = this._scalarConfig.parseLiteral;
    return parser ? parser(valueNode, variables) : Object(__WEBPACK_IMPORTED_MODULE_4__utilities_valueFromASTUntyped__["a" /* valueFromASTUntyped */])(valueNode, variables);
  };

  GraphQLScalarType.prototype.toString = function toString() {
    return this.name;
  };

  return GraphQLScalarType;
}();

// Also provide toJSON and inspect aliases for toString.
GraphQLScalarType.prototype.toJSON = GraphQLScalarType.prototype.inspect = GraphQLScalarType.prototype.toString;

/**
 * Object Type Definition
 *
 * Almost all of the GraphQL types you define will be object types. Object types
 * have a name, but most importantly describe their fields.
 *
 * Example:
 *
 *     const AddressType = new GraphQLObjectType({
 *       name: 'Address',
 *       fields: {
 *         street: { type: GraphQLString },
 *         number: { type: GraphQLInt },
 *         formatted: {
 *           type: GraphQLString,
 *           resolve(obj) {
 *             return obj.number + ' ' + obj.street
 *           }
 *         }
 *       }
 *     });
 *
 * When two types need to refer to each other, or a type needs to refer to
 * itself in a field, you can use a function expression (aka a closure or a
 * thunk) to supply the fields lazily.
 *
 * Example:
 *
 *     const PersonType = new GraphQLObjectType({
 *       name: 'Person',
 *       fields: () => ({
 *         name: { type: GraphQLString },
 *         bestFriend: { type: PersonType },
 *       })
 *     });
 *
 */
var GraphQLObjectType = function () {
  function GraphQLObjectType(config) {
    _classCallCheck(this, GraphQLObjectType);

    this.name = config.name;
    this.description = config.description;
    this.astNode = config.astNode;
    this.extensionASTNodes = config.extensionASTNodes;
    this.isTypeOf = config.isTypeOf;
    this._typeConfig = config;
    !(typeof config.name === 'string') ? Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant__["a" /* default */])(0, 'Must provide name.') : void 0;
    if (config.isTypeOf) {
      !(typeof config.isTypeOf === 'function') ? Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant__["a" /* default */])(0, this.name + ' must provide "isTypeOf" as a function.') : void 0;
    }
  }

  GraphQLObjectType.prototype.getFields = function getFields() {
    return this._fields || (this._fields = defineFieldMap(this, this._typeConfig.fields));
  };

  GraphQLObjectType.prototype.getInterfaces = function getInterfaces() {
    return this._interfaces || (this._interfaces = defineInterfaces(this, this._typeConfig.interfaces));
  };

  GraphQLObjectType.prototype.toString = function toString() {
    return this.name;
  };

  return GraphQLObjectType;
}();

// Also provide toJSON and inspect aliases for toString.
GraphQLObjectType.prototype.toJSON = GraphQLObjectType.prototype.inspect = GraphQLObjectType.prototype.toString;

function defineInterfaces(type, interfacesThunk) {
  var interfaces = resolveThunk(interfacesThunk) || [];
  !Array.isArray(interfaces) ? Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant__["a" /* default */])(0, type.name + ' interfaces must be an Array or a function which returns ' + 'an Array.') : void 0;
  return interfaces;
}

function defineFieldMap(type, fieldsThunk) {
  var fieldMap = resolveThunk(fieldsThunk) || {};
  !isPlainObj(fieldMap) ? Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant__["a" /* default */])(0, type.name + ' fields must be an object with field names as keys or a ' + 'function which returns such an object.') : void 0;

  var resultFieldMap = Object.create(null);
  Object.keys(fieldMap).forEach(function (fieldName) {
    var fieldConfig = fieldMap[fieldName];
    !isPlainObj(fieldConfig) ? Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant__["a" /* default */])(0, type.name + '.' + fieldName + ' field config must be an object') : void 0;
    !!fieldConfig.hasOwnProperty('isDeprecated') ? Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant__["a" /* default */])(0, type.name + '.' + fieldName + ' should provide "deprecationReason" instead ' + 'of "isDeprecated".') : void 0;
    var field = _extends({}, fieldConfig, {
      isDeprecated: Boolean(fieldConfig.deprecationReason),
      name: fieldName
    });
    !isValidResolver(field.resolve) ? Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant__["a" /* default */])(0, type.name + '.' + fieldName + ' field resolver must be a function if ' + ('provided, but got: ' + String(field.resolve) + '.')) : void 0;
    var argsConfig = fieldConfig.args;
    if (!argsConfig) {
      field.args = [];
    } else {
      !isPlainObj(argsConfig) ? Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant__["a" /* default */])(0, type.name + '.' + fieldName + ' args must be an object with argument ' + 'names as keys.') : void 0;
      field.args = Object.keys(argsConfig).map(function (argName) {
        var arg = argsConfig[argName];
        return {
          name: argName,
          description: arg.description === undefined ? null : arg.description,
          type: arg.type,
          defaultValue: arg.defaultValue,
          astNode: arg.astNode
        };
      });
    }
    resultFieldMap[fieldName] = field;
  });
  return resultFieldMap;
}

function isPlainObj(obj) {
  return obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && !Array.isArray(obj);
}

// If a resolver is defined, it must be a function.
function isValidResolver(resolver) {
  return resolver == null || typeof resolver === 'function';
}

/**
 * Interface Type Definition
 *
 * When a field can return one of a heterogeneous set of types, a Interface type
 * is used to describe what types are possible, what fields are in common across
 * all types, as well as a function to determine which type is actually used
 * when the field is resolved.
 *
 * Example:
 *
 *     const EntityType = new GraphQLInterfaceType({
 *       name: 'Entity',
 *       fields: {
 *         name: { type: GraphQLString }
 *       }
 *     });
 *
 */
var GraphQLInterfaceType = function () {
  function GraphQLInterfaceType(config) {
    _classCallCheck(this, GraphQLInterfaceType);

    this.name = config.name;
    this.description = config.description;
    this.astNode = config.astNode;
    this.extensionASTNodes = config.extensionASTNodes;
    this.resolveType = config.resolveType;
    this._typeConfig = config;
    !(typeof config.name === 'string') ? Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant__["a" /* default */])(0, 'Must provide name.') : void 0;
    if (config.resolveType) {
      !(typeof config.resolveType === 'function') ? Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant__["a" /* default */])(0, this.name + ' must provide "resolveType" as a function.') : void 0;
    }
  }

  GraphQLInterfaceType.prototype.getFields = function getFields() {
    return this._fields || (this._fields = defineFieldMap(this, this._typeConfig.fields));
  };

  GraphQLInterfaceType.prototype.toString = function toString() {
    return this.name;
  };

  return GraphQLInterfaceType;
}();

// Also provide toJSON and inspect aliases for toString.
GraphQLInterfaceType.prototype.toJSON = GraphQLInterfaceType.prototype.inspect = GraphQLInterfaceType.prototype.toString;

/**
 * Union Type Definition
 *
 * When a field can return one of a heterogeneous set of types, a Union type
 * is used to describe what types are possible as well as providing a function
 * to determine which type is actually used when the field is resolved.
 *
 * Example:
 *
 *     const PetType = new GraphQLUnionType({
 *       name: 'Pet',
 *       types: [ DogType, CatType ],
 *       resolveType(value) {
 *         if (value instanceof Dog) {
 *           return DogType;
 *         }
 *         if (value instanceof Cat) {
 *           return CatType;
 *         }
 *       }
 *     });
 *
 */
var GraphQLUnionType = function () {
  function GraphQLUnionType(config) {
    _classCallCheck(this, GraphQLUnionType);

    this.name = config.name;
    this.description = config.description;
    this.astNode = config.astNode;
    this.resolveType = config.resolveType;
    this._typeConfig = config;
    !(typeof config.name === 'string') ? Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant__["a" /* default */])(0, 'Must provide name.') : void 0;
    if (config.resolveType) {
      !(typeof config.resolveType === 'function') ? Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant__["a" /* default */])(0, this.name + ' must provide "resolveType" as a function.') : void 0;
    }
  }

  GraphQLUnionType.prototype.getTypes = function getTypes() {
    return this._types || (this._types = defineTypes(this, this._typeConfig.types));
  };

  GraphQLUnionType.prototype.toString = function toString() {
    return this.name;
  };

  return GraphQLUnionType;
}();

// Also provide toJSON and inspect aliases for toString.
GraphQLUnionType.prototype.toJSON = GraphQLUnionType.prototype.inspect = GraphQLUnionType.prototype.toString;

function defineTypes(unionType, typesThunk) {
  var types = resolveThunk(typesThunk) || [];
  !Array.isArray(types) ? Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant__["a" /* default */])(0, 'Must provide Array of types or a function which returns ' + ('such an array for Union ' + unionType.name + '.')) : void 0;
  return types;
}

/**
 * Enum Type Definition
 *
 * Some leaf values of requests and input values are Enums. GraphQL serializes
 * Enum values as strings, however internally Enums can be represented by any
 * kind of type, often integers.
 *
 * Example:
 *
 *     const RGBType = new GraphQLEnumType({
 *       name: 'RGB',
 *       values: {
 *         RED: { value: 0 },
 *         GREEN: { value: 1 },
 *         BLUE: { value: 2 }
 *       }
 *     });
 *
 * Note: If a value is not provided in a definition, the name of the enum value
 * will be used as its internal value.
 */
var GraphQLEnumType /* <T> */ = function () {
  function GraphQLEnumType(config /* <T> */) {
    _classCallCheck(this, GraphQLEnumType);

    this.name = config.name;
    this.description = config.description;
    this.astNode = config.astNode;
    this._enumConfig = config;
    !(typeof config.name === 'string') ? Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant__["a" /* default */])(0, 'Must provide name.') : void 0;
  }

  GraphQLEnumType.prototype.getValues = function getValues() {
    return this._values || (this._values = defineEnumValues(this, this._enumConfig.values));
  };

  GraphQLEnumType.prototype.getValue = function getValue(name) {
    return this._getNameLookup()[name];
  };

  GraphQLEnumType.prototype.serialize = function serialize(value /* T */) {
    var enumValue = this._getValueLookup().get(value);
    if (enumValue) {
      return enumValue.name;
    }
  };

  GraphQLEnumType.prototype.parseValue = function parseValue(value) /* T */{
    if (typeof value === 'string') {
      var enumValue = this._getNameLookup()[value];
      if (enumValue) {
        return enumValue.value;
      }
    }
  };

  GraphQLEnumType.prototype.parseLiteral = function parseLiteral(valueNode, _variables) /* T */{
    // Note: variables will be resolved to a value before calling this function.
    if (valueNode.kind === __WEBPACK_IMPORTED_MODULE_3__language_kinds__["a" /* Kind */].ENUM) {
      var enumValue = this._getNameLookup()[valueNode.value];
      if (enumValue) {
        return enumValue.value;
      }
    }
  };

  GraphQLEnumType.prototype._getValueLookup = function _getValueLookup() {
    if (!this._valueLookup) {
      var lookup = new Map();
      this.getValues().forEach(function (value) {
        lookup.set(value.value, value);
      });
      this._valueLookup = lookup;
    }
    return this._valueLookup;
  };

  GraphQLEnumType.prototype._getNameLookup = function _getNameLookup() {
    if (!this._nameLookup) {
      var lookup = Object.create(null);
      this.getValues().forEach(function (value) {
        lookup[value.name] = value;
      });
      this._nameLookup = lookup;
    }
    return this._nameLookup;
  };

  GraphQLEnumType.prototype.toString = function toString() {
    return this.name;
  };

  return GraphQLEnumType;
}();

// Also provide toJSON and inspect aliases for toString.
GraphQLEnumType.prototype.toJSON = GraphQLEnumType.prototype.inspect = GraphQLEnumType.prototype.toString;

function defineEnumValues(type, valueMap /* <T> */
) {
  !isPlainObj(valueMap) ? Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant__["a" /* default */])(0, type.name + ' values must be an object with value names as keys.') : void 0;
  return Object.keys(valueMap).map(function (valueName) {
    var value = valueMap[valueName];
    !isPlainObj(value) ? Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant__["a" /* default */])(0, type.name + '.' + valueName + ' must refer to an object with a "value" key ' + ('representing an internal value but got: ' + String(value) + '.')) : void 0;
    !!value.hasOwnProperty('isDeprecated') ? Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant__["a" /* default */])(0, type.name + '.' + valueName + ' should provide "deprecationReason" instead ' + 'of "isDeprecated".') : void 0;
    return {
      name: valueName,
      description: value.description,
      isDeprecated: Boolean(value.deprecationReason),
      deprecationReason: value.deprecationReason,
      astNode: value.astNode,
      value: value.hasOwnProperty('value') ? value.value : valueName
    };
  });
} /* <T> */


/**
 * Input Object Type Definition
 *
 * An input object defines a structured collection of fields which may be
 * supplied to a field argument.
 *
 * Using `NonNull` will ensure that a value must be provided by the query
 *
 * Example:
 *
 *     const GeoPoint = new GraphQLInputObjectType({
 *       name: 'GeoPoint',
 *       fields: {
 *         lat: { type: GraphQLNonNull(GraphQLFloat) },
 *         lon: { type: GraphQLNonNull(GraphQLFloat) },
 *         alt: { type: GraphQLFloat, defaultValue: 0 },
 *       }
 *     });
 *
 */
var GraphQLInputObjectType = function () {
  function GraphQLInputObjectType(config) {
    _classCallCheck(this, GraphQLInputObjectType);

    this.name = config.name;
    this.description = config.description;
    this.astNode = config.astNode;
    this._typeConfig = config;
    !(typeof config.name === 'string') ? Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant__["a" /* default */])(0, 'Must provide name.') : void 0;
  }

  GraphQLInputObjectType.prototype.getFields = function getFields() {
    return this._fields || (this._fields = this._defineFieldMap());
  };

  GraphQLInputObjectType.prototype._defineFieldMap = function _defineFieldMap() {
    var _this = this;

    var fieldMap = resolveThunk(this._typeConfig.fields) || {};
    !isPlainObj(fieldMap) ? Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant__["a" /* default */])(0, this.name + ' fields must be an object with field names as keys or a ' + 'function which returns such an object.') : void 0;
    var resultFieldMap = Object.create(null);
    Object.keys(fieldMap).forEach(function (fieldName) {
      var field = _extends({}, fieldMap[fieldName], {
        name: fieldName
      });
      !!field.hasOwnProperty('resolve') ? Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant__["a" /* default */])(0, _this.name + '.' + fieldName + ' field type has a resolve property, but ' + 'Input Types cannot define resolvers.') : void 0;
      resultFieldMap[fieldName] = field;
    });
    return resultFieldMap;
  };

  GraphQLInputObjectType.prototype.toString = function toString() {
    return this.name;
  };

  return GraphQLInputObjectType;
}();

// Also provide toJSON and inspect aliases for toString.
GraphQLInputObjectType.prototype.toJSON = GraphQLInputObjectType.prototype.toString;
GraphQLInputObjectType.prototype.inspect = GraphQLInputObjectType.prototype.toString;

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Loader_jsx__ = __webpack_require__(463);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Loader_jsx__["a"]; });


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_voronoi__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__animation__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_scales_utils__ = __webpack_require__(69);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.








var propTypes = _extends({}, Object(__WEBPACK_IMPORTED_MODULE_4__utils_scales_utils__["j" /* getScalePropTypesByAttribute */])('x'), Object(__WEBPACK_IMPORTED_MODULE_4__utils_scales_utils__["j" /* getScalePropTypesByAttribute */])('y'), Object(__WEBPACK_IMPORTED_MODULE_4__utils_scales_utils__["j" /* getScalePropTypesByAttribute */])('size'), Object(__WEBPACK_IMPORTED_MODULE_4__utils_scales_utils__["j" /* getScalePropTypesByAttribute */])('opacity'), Object(__WEBPACK_IMPORTED_MODULE_4__utils_scales_utils__["j" /* getScalePropTypesByAttribute */])('color'), {
  width: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  data: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.array])),
  onValueMouseOver: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onValueMouseOut: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onValueClick: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onValueRightClick: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onSeriesMouseOver: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onSeriesMouseOut: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onSeriesClick: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onSeriesRightClick: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onNearestX: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onNearestXY: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  style: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
  animation: __WEBPACK_IMPORTED_MODULE_3__animation__["a" /* AnimationPropType */],
  stack: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
});

var defaultProps = {
  className: '',
  stack: false,
  style: {}
};

var AbstractSeries = function (_PureComponent) {
  _inherits(AbstractSeries, _PureComponent);

  function AbstractSeries() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AbstractSeries);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AbstractSeries.__proto__ || Object.getPrototypeOf(AbstractSeries)).call.apply(_ref, [this].concat(args))), _this), _this._seriesClickHandler = function (event) {
      var onSeriesClick = _this.props.onSeriesClick;

      if (onSeriesClick) {
        onSeriesClick({ event: event });
      }
    }, _this._seriesMouseOutHandler = function (event) {
      var onSeriesMouseOut = _this.props.onSeriesMouseOut;

      if (onSeriesMouseOut) {
        onSeriesMouseOut({ event: event });
      }
    }, _this._seriesMouseOverHandler = function (event) {
      var onSeriesMouseOver = _this.props.onSeriesMouseOver;

      if (onSeriesMouseOver) {
        onSeriesMouseOver({ event: event });
      }
    }, _this._seriesRightClickHandler = function (event) {
      var onSeriesRightClick = _this.props.onSeriesRightClick;

      if (onSeriesRightClick) {
        onSeriesRightClick({ event: event });
      }
    }, _this._valueClickHandler = function (d, event) {
      var _this$props = _this.props,
          onValueClick = _this$props.onValueClick,
          onSeriesClick = _this$props.onSeriesClick;

      if (onValueClick) {
        onValueClick(d, { event: event });
      }
      if (onSeriesClick) {
        onSeriesClick({ event: event });
      }
    }, _this._valueMouseOutHandler = function (d, event) {
      var _this$props2 = _this.props,
          onValueMouseOut = _this$props2.onValueMouseOut,
          onSeriesMouseOut = _this$props2.onSeriesMouseOut;

      if (onValueMouseOut) {
        onValueMouseOut(d, { event: event });
      }
      if (onSeriesMouseOut) {
        onSeriesMouseOut({ event: event });
      }
    }, _this._valueMouseOverHandler = function (d, event) {
      var _this$props3 = _this.props,
          onValueMouseOver = _this$props3.onValueMouseOver,
          onSeriesMouseOver = _this$props3.onSeriesMouseOver;

      if (onValueMouseOver) {
        onValueMouseOver(d, { event: event });
      }
      if (onSeriesMouseOver) {
        onSeriesMouseOver({ event: event });
      }
    }, _this._valueRightClickHandler = function (d, event) {
      var _this$props4 = _this.props,
          onValueRightClick = _this$props4.onValueRightClick,
          onSeriesRightClick = _this$props4.onSeriesRightClick;

      if (onValueRightClick) {
        onValueRightClick(d, { event: event });
      }
      if (onSeriesRightClick) {
        onSeriesRightClick({ event: event });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AbstractSeries, [{
    key: 'onParentMouseMove',
    value: function onParentMouseMove(event) {
      var _props = this.props,
          onNearestX = _props.onNearestX,
          onNearestXY = _props.onNearestXY,
          data = _props.data;

      if (!onNearestX && !onNearestXY || !data) {
        return;
      }
      if (onNearestXY) {
        this._handleNearestXY(event);
      } else {
        this._handleNearestX(event);
      }
    }
  }, {
    key: 'onParentTouchMove',
    value: function onParentTouchMove(e) {
      e.preventDefault();
      this.onParentMouseMove(e);
    }
  }, {
    key: 'onParentTouchStart',
    value: function onParentTouchStart(e) {
      // prevent mouse event emulation
      e.preventDefault();
    }

    /**
     * Get the attr0 functor.
     * @param {string} attr Attribute name.
     * @returns {*} Functor.
     * @private
     */

  }, {
    key: '_getAttr0Functor',
    value: function _getAttr0Functor(attr) {
      return Object(__WEBPACK_IMPORTED_MODULE_4__utils_scales_utils__["b" /* getAttr0Functor */])(this.props, attr);
    }

    /**
     * Get attribute functor.
     * @param {string} attr Attribute name
     * @returns {*} Functor.
     * @protected
     */

  }, {
    key: '_getAttributeFunctor',
    value: function _getAttributeFunctor(attr) {
      return Object(__WEBPACK_IMPORTED_MODULE_4__utils_scales_utils__["c" /* getAttributeFunctor */])(this.props, attr);
    }

    /**
     * Get the attribute value if it is available.
     * @param {string} attr Attribute name.
     * @returns {*} Attribute value if available, fallback value or undefined
     * otherwise.
     * @protected
     */

  }, {
    key: '_getAttributeValue',
    value: function _getAttributeValue(attr) {
      return Object(__WEBPACK_IMPORTED_MODULE_4__utils_scales_utils__["e" /* getAttributeValue */])(this.props, attr);
    }

    /**
     * Get the scale object distance by the attribute from the list of properties.
     * @param {string} attr Attribute name.
     * @returns {number} Scale distance.
     * @protected
     */

  }, {
    key: '_getScaleDistance',
    value: function _getScaleDistance(attr) {
      var scaleObject = Object(__WEBPACK_IMPORTED_MODULE_4__utils_scales_utils__["i" /* getScaleObjectFromProps */])(this.props, attr);
      return scaleObject ? scaleObject.distance : 0;
    }
  }, {
    key: '_getXYCoordinateInContainer',
    value: function _getXYCoordinateInContainer(event) {
      var _props2 = this.props,
          _props2$marginTop = _props2.marginTop,
          marginTop = _props2$marginTop === undefined ? 0 : _props2$marginTop,
          _props2$marginLeft = _props2.marginLeft,
          marginLeft = _props2$marginLeft === undefined ? 0 : _props2$marginLeft;
      var evt = event.nativeEvent,
          currentTarget = event.currentTarget;

      var rect = currentTarget.getBoundingClientRect();
      var x = evt.clientX;
      var y = evt.clientY;
      if (evt.type === 'touchmove') {
        x = evt.touches[0].pageX;
        y = evt.touches[0].pageY;
      }
      return {
        x: x - rect.left - currentTarget.clientLeft - marginLeft,
        y: y - rect.top - currentTarget.clientTop - marginTop
      };
    }
  }, {
    key: '_handleNearestX',
    value: function _handleNearestX(event) {
      var _props3 = this.props,
          onNearestX = _props3.onNearestX,
          data = _props3.data;

      var minDistance = Number.POSITIVE_INFINITY;
      var value = null;
      var valueIndex = null;

      var coordinate = this._getXYCoordinateInContainer(event);
      var xScaleFn = this._getAttributeFunctor('x');

      data.forEach(function (item, i) {
        var currentCoordinate = xScaleFn(item);
        var newDistance = Math.abs(coordinate.x - currentCoordinate);
        if (newDistance < minDistance) {
          minDistance = newDistance;
          value = item;
          valueIndex = i;
        }
      });
      if (!value) {
        return;
      }
      onNearestX(value, {
        innerX: xScaleFn(value),
        index: valueIndex,
        event: event.nativeEvent
      });
    }
  }, {
    key: '_handleNearestXY',
    value: function _handleNearestXY(event) {
      var _props4 = this.props,
          onNearestXY = _props4.onNearestXY,
          data = _props4.data;


      var coordinate = this._getXYCoordinateInContainer(event);
      var xScaleFn = this._getAttributeFunctor('x');
      var yScaleFn = this._getAttributeFunctor('y');

      // Create a voronoi with each node center points
      var voronoiInstance = Object(__WEBPACK_IMPORTED_MODULE_1_d3_voronoi__["a" /* voronoi */])().x(xScaleFn).y(yScaleFn);

      var foundPoint = voronoiInstance(data).find(coordinate.x, coordinate.y);
      var value = foundPoint.data;

      if (!value) {
        return;
      }
      onNearestXY(value, {
        innerX: foundPoint[0],
        innerY: foundPoint[1],
        index: foundPoint.index,
        event: event.nativeEvent
      });
    }

    /**
     * Click handler for the entire series.
     * @param {Object} event Event.
     * @protected
     */


    /**
     * Mouse out handler for the entire series.
     * @param {Object} event Event.
     * @protected
     */


    /**
     * Mouse over handler for the entire series.
     * @param {Object} event Event.
     * @protected
     */


    /**
     * Right Click handler for the entire series.
     * @param {Object} event Event.
     * @protected
     */


    /**
     * Click handler for the specific series' value.
     * @param {Object} d Value object
     * @param {Object} event Event.
     * @protected
     */


    /**
     * Mouse out handler for the specific series' value.
     * @param {Object} d Value object
     * @param {Object} event Event.
     * @protected
     */


    /**
     * Mouse over handler for the specific series' value.
     * @param {Object} d Value object
     * @param {Object} event Event.
     * @protected
     */


    /**
     * Right Click handler for the specific series' value.
     * @param {Object} d Value object
     * @param {Object} event Event.
     * @protected
     */

  }], [{
    key: 'getParentConfig',

    /**
     * Get a default config for the parent.
     * @returns {Object} Empty config.
     */
    value: function getParentConfig() {
      return {};
    }

    /**
     * Tells the rest of the world that it requires SVG to work.
     * @returns {boolean} Result.
     */

  }, {
    key: 'requiresSVG',
    get: function get() {
      return true;
    }
  }]);

  return AbstractSeries;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]);

AbstractSeries.displayName = 'AbstractSeries';
AbstractSeries.propTypes = propTypes;
AbstractSeries.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (AbstractSeries);

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Paper.default;
  }
});

var _Paper = _interopRequireDefault(__webpack_require__(876));

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _DialogContentText.default;
  }
});

var _DialogContentText = _interopRequireDefault(__webpack_require__(1006));

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.capitalize = capitalize;
exports.contains = contains;
exports.findIndex = findIndex;
exports.find = find;
exports.createChainedFunction = createChainedFunction;

var _typeof2 = _interopRequireDefault(__webpack_require__(294));

var _warning = _interopRequireDefault(__webpack_require__(37));

function capitalize(string) {
  if (false) {
    throw new Error('Material-UI: capitalize(string) expects a string argument.');
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
}

function contains(obj, pred) {
  return Object.keys(pred).every(function (key) {
    return obj.hasOwnProperty(key) && obj[key] === pred[key];
  });
}

function findIndex(arr, pred) {
  var predType = (0, _typeof2.default)(pred);

  for (var i = 0; i < arr.length; i += 1) {
    if (predType === 'function' && !!pred(arr[i], i, arr) === true) {
      return i;
    }

    if (predType === 'object' && contains(arr[i], pred)) {
      return i;
    }

    if (['string', 'number', 'boolean'].indexOf(predType) !== -1) {
      return arr.indexOf(pred);
    }
  }

  return -1;
}

function find(arr, pred) {
  var index = findIndex(arr, pred);
  return index > -1 ? arr[index] : undefined;
}
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */


function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.reduce(function (acc, func) {
    if (func == null) {
      return acc;
    }

     false ? (0, _warning.default)(typeof func === 'function', 'Material-UI: invalid Argument Type, must only provide functions, undefined, or null.') : void 0;
    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      func.apply(this, args);
    };
  }, function () {});
}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(a,b){if(true)!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (b),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if("undefined"!=typeof exports)b();else{b(),a.FileSaver={exports:{}}.exports}})(this,function(){"use strict";function b(a,b){return"undefined"==typeof b?b={autoBom:!1}:"object"!=typeof b&&(console.warn("Deprecated: Expected third argument to be a object"),b={autoBom:!b}),b.autoBom&&/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type)?new Blob(["\uFEFF",a],{type:a.type}):a}function c(a,b,c){var d=new XMLHttpRequest;d.open("GET",a),d.responseType="blob",d.onload=function(){g(d.response,b,c)},d.onerror=function(){console.error("could not download file")},d.send()}function d(a){var b=new XMLHttpRequest;b.open("HEAD",a,!1);try{b.send()}catch(a){}return 200<=b.status&&299>=b.status}function e(a){try{a.dispatchEvent(new MouseEvent("click"))}catch(c){var b=document.createEvent("MouseEvents");b.initMouseEvent("click",!0,!0,window,0,0,0,80,20,!1,!1,!1,!1,0,null),a.dispatchEvent(b)}}var f="object"==typeof window&&window.window===window?window:"object"==typeof self&&self.self===self?self:"object"==typeof global&&global.global===global?global:void 0,a=f.navigator&&/Macintosh/.test(navigator.userAgent)&&/AppleWebKit/.test(navigator.userAgent)&&!/Safari/.test(navigator.userAgent),g=f.saveAs||("object"!=typeof window||window!==f?function(){}:"download"in HTMLAnchorElement.prototype&&!a?function(b,g,h){var i=f.URL||f.webkitURL,j=document.createElement("a");g=g||b.name||"download",j.download=g,j.rel="noopener","string"==typeof b?(j.href=b,j.origin===location.origin?e(j):d(j.href)?c(b,g,h):e(j,j.target="_blank")):(j.href=i.createObjectURL(b),setTimeout(function(){i.revokeObjectURL(j.href)},4E4),setTimeout(function(){e(j)},0))}:"msSaveOrOpenBlob"in navigator?function(f,g,h){if(g=g||f.name||"download","string"!=typeof f)navigator.msSaveOrOpenBlob(b(f,h),g);else if(d(f))c(f,g,h);else{var i=document.createElement("a");i.href=f,i.target="_blank",setTimeout(function(){e(i)})}}:function(b,d,e,g){if(g=g||open("","_blank"),g&&(g.document.title=g.document.body.innerText="downloading..."),"string"==typeof b)return c(b,d,e);var h="application/octet-stream"===b.type,i=/constructor/i.test(f.HTMLElement)||f.safari,j=/CriOS\/[\d]+/.test(navigator.userAgent);if((j||h&&i||a)&&"undefined"!=typeof FileReader){var k=new FileReader;k.onloadend=function(){var a=k.result;a=j?a:a.replace(/^data:[^;]*;/,"data:attachment/file;"),g?g.location.href=a:location=a,g=null},k.readAsDataURL(b)}else{var l=f.URL||f.webkitURL,m=l.createObjectURL(b);g?g.location=m:location.href=m,g=null,setTimeout(function(){l.revokeObjectURL(m)},4E4)}});f.saveAs=g.saveAs=g,"undefined"!=typeof module&&(module.exports=g)});

//# sourceMappingURL=FileSaver.min.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(72)))

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = extractAnimatedPropValues;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnimationPropType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_interpolate__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_motion__ = __webpack_require__(2106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_motion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_motion__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var ANIMATION_PROPTYPES = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  stiffness: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  nonAnimatedProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),
  damping: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
}), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool]);

var propTypes = {
  animatedProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string).isRequired,
  animation: ANIMATION_PROPTYPES,
  onStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onEnd: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/**
 * Format the animation style object
 * @param {Object|String} animationStyle - The animation style property, either the name of a
 * presets are one of noWobble, gentle, wobbly, stiff
 */
function getAnimationStyle() {
  var animationStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_3_react_motion__["presets"].noWobble;

  if (typeof animationStyle === 'string') {
    return __WEBPACK_IMPORTED_MODULE_3_react_motion__["presets"][animationStyle] || __WEBPACK_IMPORTED_MODULE_3_react_motion__["presets"].noWobble;
  }
  var damping = animationStyle.damping,
      stiffness = animationStyle.stiffness;

  return _extends({
    damping: damping || __WEBPACK_IMPORTED_MODULE_3_react_motion__["presets"].noWobble.damping,
    stiffness: stiffness || __WEBPACK_IMPORTED_MODULE_3_react_motion__["presets"].noWobble.stiffness
  }, animationStyle);
}

/**
 * Extract the animated props from the entire props object.
 * @param {Object} props Props.
 * @returns {Object} Object of animated props.
 */
function extractAnimatedPropValues(props) {
  var animatedProps = props.animatedProps,
      otherProps = _objectWithoutProperties(props, ['animatedProps']);

  return animatedProps.reduce(function (result, animatedPropName) {
    if (otherProps.hasOwnProperty(animatedPropName)) {
      result[animatedPropName] = otherProps[animatedPropName];
    }
    return result;
  }, {});
}

var Animation = function (_PureComponent) {
  _inherits(Animation, _PureComponent);

  function Animation(props) {
    _classCallCheck(this, Animation);

    var _this = _possibleConstructorReturn(this, (Animation.__proto__ || Object.getPrototypeOf(Animation)).call(this, props));

    _this._motionEndHandler = function () {
      if (_this.props.onEnd) {
        _this.props.onEnd();
      }
    };

    _this._renderChildren = function (_ref) {
      var i = _ref.i;
      var children = _this.props.children;

      var interpolator = _this._interpolator;
      var child = __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.only(children);
      var interpolatedProps = interpolator ? interpolator(i) : interpolator;

      // interpolator doesnt play nice with deeply nested objected
      // so we expose an additional prop for situations like these, soit _data,
      // which stores the full tree and can be recombined with the sanitized version
      // after interpolation
      var data = interpolatedProps && interpolatedProps.data || null;
      if (data && child.props._data) {
        data = data.map(function (row, index) {
          var correspondingCell = child.props._data[index];
          return _extends({}, row, {
            parent: correspondingCell.parent,
            children: correspondingCell.children
          });
        });
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, _extends({}, child.props, interpolatedProps, {
        data: data || child.props.data || null,
        // enforce re-rendering
        _animation: Math.random()
      }));
    };

    _this._updateInterpolator(props);
    return _this;
  }

  _createClass(Animation, [{
    key: 'componentWillUpdate',
    value: function componentWillUpdate(props) {
      this._updateInterpolator(this.props, props);
      if (props.onStart) {
        props.onStart();
      }
    }

    /**
     * Render the child into the parent.
     * @param {Number} i Number generated by the spring.
     * @returns {React.Component} Rendered react element.
     * @private
     */

  }, {
    key: '_updateInterpolator',


    /**
     * Update the interpolator function and assign it to this._interpolator.
     * @param {Object} oldProps Old props.
     * @param {Object} newProps New props.
     * @private
     */
    value: function _updateInterpolator(oldProps, newProps) {
      this._interpolator = Object(__WEBPACK_IMPORTED_MODULE_2_d3_interpolate__["a" /* interpolate */])(extractAnimatedPropValues(oldProps), newProps ? extractAnimatedPropValues(newProps) : null);
    }
  }, {
    key: 'render',
    value: function render() {
      var animationStyle = getAnimationStyle(this.props.animation);
      var defaultStyle = { i: 0 };
      var style = { i: Object(__WEBPACK_IMPORTED_MODULE_3_react_motion__["spring"])(1, animationStyle) };
      // In order to make Motion re-run animations each time, the random key is
      // always passed.
      // TODO: find a better solution for the spring.
      var key = Math.random();
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_react_motion__["Motion"],
        _extends({ defaultStyle: defaultStyle, style: style, key: key }, { onRest: this._motionEndHandler }),
        this._renderChildren
      );
    }
  }]);

  return Animation;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Animation.propTypes = propTypes;
Animation.displayName = 'Animation';

/* harmony default export */ __webpack_exports__["b"] = (Animation);

var AnimationPropType = ANIMATION_PROPTYPES;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _CircularProgress.default;
  }
});

var _CircularProgress = _interopRequireDefault(__webpack_require__(819));

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Dialog.default;
  }
});

var _Dialog = _interopRequireDefault(__webpack_require__(885));

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FormControlLabel.default;
  }
});

var _FormControlLabel = _interopRequireDefault(__webpack_require__(1015));

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Kind; });
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * The set of allowed kind values for AST nodes.
 */
var Kind = Object.freeze({
  // Name
  NAME: 'Name',

  // Document
  DOCUMENT: 'Document',
  OPERATION_DEFINITION: 'OperationDefinition',
  VARIABLE_DEFINITION: 'VariableDefinition',
  VARIABLE: 'Variable',
  SELECTION_SET: 'SelectionSet',
  FIELD: 'Field',
  ARGUMENT: 'Argument',

  // Fragments
  FRAGMENT_SPREAD: 'FragmentSpread',
  INLINE_FRAGMENT: 'InlineFragment',
  FRAGMENT_DEFINITION: 'FragmentDefinition',

  // Values
  INT: 'IntValue',
  FLOAT: 'FloatValue',
  STRING: 'StringValue',
  BOOLEAN: 'BooleanValue',
  NULL: 'NullValue',
  ENUM: 'EnumValue',
  LIST: 'ListValue',
  OBJECT: 'ObjectValue',
  OBJECT_FIELD: 'ObjectField',

  // Directives
  DIRECTIVE: 'Directive',

  // Types
  NAMED_TYPE: 'NamedType',
  LIST_TYPE: 'ListType',
  NON_NULL_TYPE: 'NonNullType',

  // Type System Definitions
  SCHEMA_DEFINITION: 'SchemaDefinition',
  OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',

  // Type Definitions
  SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
  OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
  FIELD_DEFINITION: 'FieldDefinition',
  INPUT_VALUE_DEFINITION: 'InputValueDefinition',
  INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
  UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
  ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
  ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
  INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',

  // Type Extensions
  SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
  OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
  INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
  UNION_TYPE_EXTENSION: 'UnionTypeExtension',
  ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
  INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension',

  // Directive Definitions
  DIRECTIVE_DEFINITION: 'DirectiveDefinition'
});

/**
 * The enum type representing the possible kind values of AST nodes.
 */

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _CardActions.default;
  }
});

var _CardActions = _interopRequireDefault(__webpack_require__(999));

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _withRouter = __webpack_require__(1104);

var _withRouter2 = _interopRequireDefault(_withRouter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _withRouter2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DatePickerModal$1; });
/* unused harmony export InlineDatePicker */
/* unused harmony export TimePicker */
/* unused harmony export InlineTimePicker */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DateTimePickerModal$1; });
/* unused harmony export InlineDateTimePicker */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MuiPickersUtilsProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_text_mask__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_text_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_text_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Icon__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_IconButton__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_InputAdornment__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_InputAdornment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_InputAdornment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_DialogActions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_DialogContent__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles_withStyles__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_event_listener__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_event_listener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_event_listener__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_keycode__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_keycode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_keycode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_styles_createStyles__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_styles_createStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_styles_createStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_Toolbar__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_Toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_transition_group__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_dom__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_core_Popover__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_core_Popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__material_ui_core_Paper__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__material_ui_core_Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__material_ui_core_Paper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__material_ui_core_styles_withTheme__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__material_ui_core_styles_withTheme___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__material_ui_core_styles_withTheme__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__material_ui_core_Tab__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__material_ui_core_Tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__material_ui_core_Tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__material_ui_core_Tabs__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__material_ui_core_Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__material_ui_core_Tabs__);



























var _a = Object(__WEBPACK_IMPORTED_MODULE_2_react__["createContext"])(null),
    Consumer = _a.Consumer,
    Provider = _a.Provider;

var MuiPickersContextConsumer = Consumer;

var MuiPickersUtilsProvider =
/*@__PURE__*/
function (_super) {
  Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(MuiPickersUtilsProvider, _super);

  function MuiPickersUtilsProvider() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      utils: null
    };
    return _this;
  }

  MuiPickersUtilsProvider.getDerivedStateFromProps = function (_a) {
    var Utils = _a.utils,
        locale = _a.locale,
        moment = _a.moment;
    return {
      utils: new Utils({
        locale: locale,
        moment: moment
      })
    };
  };

  MuiPickersUtilsProvider.prototype.render = function () {
    return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(Provider, {
      value: this.state.utils,
      children: this.props.children
    });
  };

   false ? MuiPickersUtilsProvider.propTypes = {
    utils: func.isRequired,
    locale: oneOfType([object, string]),
    children: oneOfType([element.isRequired, arrayOf(element.isRequired)]).isRequired,
    moment: func
  } : void 0;
  MuiPickersUtilsProvider.defaultProps = {
    locale: undefined,
    moment: undefined
  };
  return MuiPickersUtilsProvider;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

var checkUtils = function (utils) {
  if (!utils) {
    // tslint:disable-next-line
    throw new Error('Can not find utils in context. You either a) forgot to wrap your component tree in MuiPickersUtilsProvider; or b) mixed named and direct file imports.  Recommendation: use named imports from the module index.');
  }
};

var withUtils = function () {
  return function (Component$$1) {
    var WithUtils = function (props) {
      return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(MuiPickersContextConsumer, null, function (utils) {
        checkUtils(utils);
        return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(Component$$1, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({
          utils: utils
        }, props));
      });
    };

    WithUtils.displayName = "WithUtils(" + (Component$$1.displayName || Component$$1.name) + ")";
    return WithUtils;
  };
};

var getInitialDate = function (_a) {
  var utils = _a.utils,
      value = _a.value,
      initialFocusedDate = _a.initialFocusedDate;
  var initialDate = value || initialFocusedDate || utils.date();
  var date = utils.date(initialDate);
  return utils.isValid(date) ? date : utils.date();
};

var BasePicker =
/*@__PURE__*/
function (_super) {
  Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(BasePicker, _super);

  function BasePicker() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      date: getInitialDate(_this.props),
      isAccepted: false
    };

    _this.changeDate = function (date, callback) {
      return _this.setState({
        date: date
      }, callback);
    };

    _this.handleAcceptedChange = function (isAccepted, callback) {
      return _this.setState({
        isAccepted: isAccepted
      }, callback);
    };

    _this.handleClear = function () {
      return _this.props.onChange(null);
    };

    _this.handleAccept = function () {
      return _this.props.onChange(_this.state.date);
    };

    _this.handleSetTodayDate = function () {
      return _this.handleChange(_this.props.utils.date(), false);
    };

    _this.handleTextFieldChange = function (date) {
      var onChange = _this.props.onChange;

      if (date === null) {
        onChange(null);
      } else {
        _this.changeDate(date, function () {
          return onChange(date);
        });
      }
    };

    _this.pick12hOr24hFormat = function (default12hFormat, default24hFormat) {
      var _a = _this.props,
          format = _a.format,
          ampm = _a.ampm;

      if (format) {
        return format;
      }

      return ampm ? default12hFormat : default24hFormat;
    };

    _this.handleChange = function (newDate, isFinish) {
      if (isFinish === void 0) {
        isFinish = true;
      }

      var _a = _this.props,
          autoOk = _a.autoOk,
          onChange = _a.onChange;

      _this.changeDate(newDate, function () {
        if (isFinish && autoOk) {
          onChange(newDate); // pass down accept true, and make it false in the next tick

          _this.handleAcceptedChange(true, function () {
            return _this.handleAcceptedChange(false);
          });
        }
      });
    };

    _this.handleDismiss = function () {
      _this.setState({
        date: getInitialDate(_this.props)
      });
    };

    return _this;
  }

  BasePicker.prototype.componentDidUpdate = function (prevProps) {
    var _a = this.props,
        utils = _a.utils,
        value = _a.value,
        initialFocusedDate = _a.initialFocusedDate;

    if (prevProps.value !== value || prevProps.utils.locale !== utils.locale || prevProps.initialFocusedDate !== initialFocusedDate) {
      this.changeDate(getInitialDate(this.props));
    }
  };

  BasePicker.prototype.render = function () {
    return this.props.children(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this.state, {
      utils: this.props.utils,
      changeDate: this.changeDate,
      handleAcceptedChange: this.handleAcceptedChange,
      handleClear: this.handleClear,
      handleAccept: this.handleAccept,
      handleDismiss: this.handleDismiss,
      handleSetTodayDate: this.handleSetTodayDate,
      handleTextFieldChange: this.handleTextFieldChange,
      pick12hOr24hFormat: this.pick12hOr24hFormat,
      handleChange: this.handleChange
    }));
  };

  return BasePicker;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);
var BasePicker$1 = withUtils()(BasePicker);

var date = Object(__WEBPACK_IMPORTED_MODULE_1_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_1_prop_types__["object"], __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"], __WEBPACK_IMPORTED_MODULE_1_prop_types__["number"], Object(__WEBPACK_IMPORTED_MODULE_1_prop_types__["instanceOf"])(Date)]);
var DomainPropTypes = {
  date: date
};

var Input =
/*@__PURE__*/
function (_super) {
  Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(Input, _super);

  function Input() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Input.prototype.render = function () {
    var _a = this.props,
        inputRef = _a.inputRef,
        rest = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __rest */])(_a, ["inputRef"]);

    return this.props.mask ? Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_3_react_text_mask___default.a, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, rest, {
      ref: inputRef
    })) : Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("input", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, rest, {
      ref: inputRef
    }));
  };

   false ? Input.propTypes = {
    mask: any,
    inputRef: func.isRequired
  } : void 0;
  Input.defaultProps = {
    mask: undefined
  };
  return Input;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]);

var getDisplayDate = function (_a) {
  var utils = _a.utils,
      value = _a.value,
      format = _a.format,
      invalidLabel = _a.invalidLabel,
      emptyLabel = _a.emptyLabel,
      labelFunc = _a.labelFunc;
  var isEmpty = value === null;
  var date = utils.date(value);

  if (labelFunc) {
    return labelFunc(isEmpty ? null : date, invalidLabel);
  }

  if (isEmpty) {
    return emptyLabel;
  }

  return utils.isValid(date) ? utils.format(date, format) : invalidLabel;
};

var getError = function (value, props) {
  var utils = props.utils,
      maxDate = props.maxDate,
      minDate = props.minDate,
      disablePast = props.disablePast,
      disableFuture = props.disableFuture,
      maxDateMessage = props.maxDateMessage,
      minDateMessage = props.minDateMessage,
      invalidDateMessage = props.invalidDateMessage;

  if (!utils.isValid(value)) {
    // if null - do not show error
    if (utils.isNull(value)) {
      return '';
    }

    return invalidDateMessage;
  }

  if (maxDate && utils.isAfter(value, utils.endOfDay(utils.date(maxDate))) || disableFuture && utils.isAfter(value, utils.endOfDay(utils.date()))) {
    return maxDateMessage;
  }

  if (minDate && utils.isBefore(value, utils.startOfDay(utils.date(minDate))) || disablePast && utils.isBefore(value, utils.startOfDay(utils.date()))) {
    return minDateMessage;
  }

  return '';
};

var DateTextField =
/*@__PURE__*/
function (_super) {
  Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(DateTextField, _super);

  function DateTextField() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = DateTextField.updateState(_this.props);

    _this.commitUpdates = function (value) {
      var _a = _this.props,
          clearable = _a.clearable,
          onClear = _a.onClear,
          utils = _a.utils,
          format = _a.format,
          onError = _a.onError;

      if (value === '') {
        if (_this.props.value === null) {
          _this.setState(DateTextField.updateState(_this.props));
        } else if (clearable && onClear) {
          onClear();
        }

        return;
      }

      var oldValue = utils.date(_this.state.value);
      var newValue = utils.parse(value, format);
      var error = getError(newValue, _this.props);

      _this.setState({
        error: error,
        displayValue: value,
        value: error ? newValue : oldValue
      }, function () {
        if (!error && !utils.isEqual(newValue, oldValue)) {
          _this.props.onChange(newValue);
        }

        if (error && onError) {
          onError(newValue, error);
        }
      });
    };

    _this.handleBlur = function (e) {
      if (_this.props.keyboard) {
        e.preventDefault();
        e.stopPropagation();

        _this.commitUpdates(e.target.value);

        if (_this.props.onBlur) {
          _this.props.onBlur(e);
        }
      }
    };

    _this.handleChange = function (e) {
      var _a = _this.props,
          utils = _a.utils,
          format = _a.format,
          onInputChange = _a.onInputChange;
      var parsedValue = utils.parse(e.target.value, format);

      if (onInputChange) {
        onInputChange(e);
      }

      _this.setState({
        displayValue: e.target.value,
        error: getError(parsedValue, _this.props)
      });
    };

    _this.handleFocus = function (e) {
      e.stopPropagation();
      e.preventDefault();

      if (!_this.props.keyboard) {
        _this.openPicker(e);
      }
    };

    _this.handleKeyPress = function (e) {
      if (e.key === 'Enter') {
        if (!_this.props.disableOpenOnEnter) {
          _this.openPicker(e);
        } else {
          // @ts-ignore TODO check me
          _this.commitUpdates(e.target.value);
        }
      }
    };

    _this.openPicker = function (e) {
      var _a = _this.props,
          disabled = _a.disabled,
          onClick = _a.onClick;

      if (!disabled) {
        onClick(e);
      }
    };

    return _this;
  }

  DateTextField.prototype.componentDidUpdate = function (prevProps) {
    if (!this.props.utils.isEqual(this.props.value, prevProps.value) || prevProps.format !== this.props.format || prevProps.maxDate !== this.props.maxDate || prevProps.minDate !== this.props.minDate || prevProps.emptyLabel !== this.props.emptyLabel || prevProps.utils !== this.props.utils) {
      /* eslint-disable-next-line react/no-did-update-set-state */
      this.setState(DateTextField.updateState(this.props));
    }
  };

  DateTextField.prototype.render = function () {
    var _a = this.props,
        adornmentPosition = _a.adornmentPosition,
        clearable = _a.clearable,
        disabled = _a.disabled,
        disableFuture = _a.disableFuture,
        disableOpenOnEnter = _a.disableOpenOnEnter,
        disablePast = _a.disablePast,
        emptyLabel = _a.emptyLabel,
        format = _a.format,
        InputAdornmentProps = _a.InputAdornmentProps,
        InputProps = _a.InputProps,
        invalidDateMessage = _a.invalidDateMessage,
        invalidLabel = _a.invalidLabel,
        keyboard = _a.keyboard,
        keyboardIcon = _a.keyboardIcon,
        labelFunc = _a.labelFunc,
        mask = _a.mask,
        maxDate = _a.maxDate,
        maxDateMessage = _a.maxDateMessage,
        minDate = _a.minDate,
        minDateMessage = _a.minDateMessage,
        onBlur = _a.onBlur,
        onClear = _a.onClear,
        onClick = _a.onClick,
        pipe = _a.pipe,
        TextFieldComponent = _a.TextFieldComponent,
        utils = _a.utils,
        value = _a.value,
        onInputChange = _a.onInputChange,
        other = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __rest */])(_a, ["adornmentPosition", "clearable", "disabled", "disableFuture", "disableOpenOnEnter", "disablePast", "emptyLabel", "format", "InputAdornmentProps", "InputProps", "invalidDateMessage", "invalidLabel", "keyboard", "keyboardIcon", "labelFunc", "mask", "maxDate", "maxDateMessage", "minDate", "minDateMessage", "onBlur", "onClear", "onClick", "pipe", "TextFieldComponent", "utils", "value", "onInputChange"]);

    var _b = this.state,
        displayValue = _b.displayValue,
        error = _b.error;
    var localInputProps = {
      inputComponent: Input,
      inputProps: {
        mask: !keyboard ? null : mask,
        pipe: !keyboard ? null : pipe,
        readOnly: !keyboard
      }
    };

    if (keyboard) {
      localInputProps[adornmentPosition + "Adornment"] = Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_InputAdornment___default.a, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({
        position: adornmentPosition
      }, InputAdornmentProps), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_IconButton___default.a, {
        disabled: disabled,
        onClick: this.openPicker
      }, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Icon___default.a, null, " ", keyboardIcon, " ")));
    }

    var Component$$1 = TextFieldComponent;

    var inputProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, localInputProps, InputProps);

    return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(Component$$1, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({
      onClick: this.handleFocus,
      error: !!error,
      helperText: error,
      onKeyPress: this.handleKeyPress,
      onBlur: this.handleBlur,
      disabled: disabled,
      value: displayValue
    }, other, {
      onError: undefined,
      onChange: this.handleChange,
      InputProps: inputProps
    }));
  };

   false ? DateTextField.propTypes = {
    value: oneOfType([object, string, number, instanceOf(Date)]),
    minDate: DomainPropTypes.date,
    maxDate: DomainPropTypes.date,
    disablePast: bool,
    disableFuture: bool,
    format: string,
    onBlur: func,
    onChange: func.isRequired,
    onClear: func,
    onClick: func.isRequired,
    clearable: bool,
    utils: object.isRequired,
    disabled: bool,
    InputProps: shape({}),

    /** Input mask, used in keyboard mode read more <a href="https://github.com/text-mask/text-mask/blob/master/componentDocumentation.md#readme">here</a> */
    mask: any,

    /** Error message, shown if date is less then minimal date */
    minDateMessage: node,

    /** Error message, shown if date is more then maximal date */
    maxDateMessage: node,

    /** Message displaying in text field, if date is invalid (doesn't work in keyboard mode) */
    invalidLabel: string,

    /** Message displaying in text field, if null passed (doesn't work in keyboard mode) */
    emptyLabel: string,

    /** Dynamic label generation function [(date: Date, invalidLabel: string) => string] */
    labelFunc: func,

    /** On/off manual keyboard input mode */
    keyboard: bool,

    /** Icon displayed for open picker button in keyboard mode */
    keyboardIcon: node,

    /** enables/disable automatic opening of the picker when the user clicks enter */
    disableOpenOnEnter: bool,

    /** Message, appearing when date cannot be parsed */
    invalidDateMessage: node,

    /** Component that should replace the default Material-UI TextField */
    TextFieldComponent: oneOfType([string, func]),

    /** Props to pass to keyboard input adornment */
    InputAdornmentProps: object,

    /** Specifies position of keyboard button adornment */
    adornmentPosition: oneOf(['start', 'end']),

    /**
     * Callback firing when date that applied in the keyboard is invalid
     *  [(error: string) => void]
     */
    onError: func,

    /** Callback firing on change input in keyboard mode [(e: Event) => void] */
    onInputChange: func,
    pipe: func
  } : void 0;
  DateTextField.defaultProps = {
    disabled: false,
    invalidLabel: 'Unknown',
    emptyLabel: '',
    value: new Date(),
    labelFunc: undefined,
    format: undefined,
    InputProps: undefined,
    keyboard: false,
    mask: undefined,
    keyboardIcon: 'event',
    disableOpenOnEnter: false,
    invalidDateMessage: 'Invalid Date Format',
    clearable: false,
    onBlur: undefined,
    onClear: undefined,
    disablePast: false,
    disableFuture: false,
    onError: undefined,
    onInputChange: undefined,
    minDate: '1900-01-01',
    maxDate: '2100-01-01',
    minDateMessage: 'Date should not be before minimal date',
    maxDateMessage: 'Date should not be after maximal date',
    TextFieldComponent: __WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a,
    InputAdornmentProps: {},
    adornmentPosition: 'end',
    pipe: undefined
  };

  DateTextField.updateState = function (props) {
    return {
      value: props.value,
      displayValue: getDisplayDate(props),
      error: getError(props.utils.date(props.value), props)
    };
  };

  return DateTextField;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]);

var DateTextField$1 = withUtils()(DateTextField);

var dialogWidth = 310;
var dialogHeight = 405;
var styles = {
  dialogRoot: {
    minWidth: dialogWidth,
    minHeight: dialogHeight
  },
  dialog: {
    width: dialogWidth,
    minHeight: dialogHeight,
    overflow: 'hidden',
    '&:first-child': {
      padding: 0
    }
  },
  dialogActions: {
    // set justifyContent to default value to fix IE11 layout bug
    // see https://github.com/dmtrKovalenko/material-ui-pickers/pull/267
    justifyContent: 'flex-start'
  },
  clearableDialogAction: {
    '&:first-child': {
      marginRight: 'auto'
    }
  },
  todayDialogAction: {
    '&:first-child': {
      marginRight: 'auto'
    }
  },
  dialogAction: {// empty but may be needed for override
  }
};
var ModalDialog = function (_a) {
  var children = _a.children,
      classes = _a.classes,
      onKeyDown = _a.onKeyDown,
      onAccept = _a.onAccept,
      onDismiss = _a.onDismiss,
      onClear = _a.onClear,
      onSetToday = _a.onSetToday,
      okLabel = _a.okLabel,
      cancelLabel = _a.cancelLabel,
      clearLabel = _a.clearLabel,
      todayLabel = _a.todayLabel,
      dialogContentClassName = _a.dialogContentClassName,
      clearable = _a.clearable,
      showTodayButton = _a.showTodayButton,
      other = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __rest */])(_a, ["children", "classes", "onKeyDown", "onAccept", "onDismiss", "onClear", "onSetToday", "okLabel", "cancelLabel", "clearLabel", "todayLabel", "dialogContentClassName", "clearable", "showTodayButton"]);

  var _b;

  return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog___default.a, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({
    onClose: onDismiss,
    classes: {
      paper: classes.dialogRoot
    },
    role: "dialog"
  }, other), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_14_react_event_listener___default.a, {
    target: "window",
    onKeyDown: onKeyDown
  }), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_DialogContent___default.a, {
    className: __WEBPACK_IMPORTED_MODULE_13_classnames___default()(classes.dialog, dialogContentClassName)
  }, children), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_DialogActions___default.a, {
    classes: {
      root: clearable || showTodayButton ? classes.dialogActions : undefined,
      action: __WEBPACK_IMPORTED_MODULE_13_classnames___default()(classes.dialogAction, (_b = {}, _b[classes.clearableDialogAction] = clearable, _b[classes.todayDialogAction] = !clearable && showTodayButton, _b))
    }
  }, clearable && Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button___default.a, {
    color: "primary",
    onClick: onClear
  }, clearLabel), !clearable && showTodayButton && Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button___default.a, {
    color: "primary",
    onClick: onSetToday
  }, todayLabel), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button___default.a, {
    color: "primary",
    onClick: onDismiss
  }, cancelLabel), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button___default.a, {
    color: "primary",
    onClick: onAccept
  }, okLabel)));
};
ModalDialog.displayName = 'ModalDialog';
 false ? ModalDialog.propTypes = {
  children: node.isRequired,
  onKeyDown: func.isRequired,
  onAccept: func.isRequired,
  onDismiss: func.isRequired,
  onClear: func.isRequired,
  classes: object.isRequired,
  dialogContentClassName: string,
  okLabel: node.isRequired,
  cancelLabel: node.isRequired,
  clearLabel: node.isRequired,
  clearable: bool.isRequired,
  todayLabel: node.isRequired,
  showTodayButton: bool.isRequired,
  onSetToday: func.isRequired
} : void 0;
ModalDialog.defaultProps = {
  dialogContentClassName: ''
};
var ModalDialog$1 = __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles_withStyles___default()(styles, {
  name: 'MuiPickersModal'
})(ModalDialog);

var ModalWrapper =
/*@__PURE__*/
function (_super) {
  Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(ModalWrapper, _super);

  function ModalWrapper() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      open: false
    };

    _this.handleKeyDown = function (event) {
      switch (__WEBPACK_IMPORTED_MODULE_15_keycode___default()(event)) {
        case 'enter':
          _this.handleAccept();

          break;

        default:
          // if keycode is not handled, stop execution
          return;
      } // if event was handled prevent other side effects


      event.preventDefault();
    };

    _this.handleSetTodayDate = function () {
      if (_this.props.onSetToday) {
        _this.props.onSetToday();
      }
    };

    _this.open = function () {
      _this.setState({
        open: true
      });

      if (_this.props.onOpen) {
        _this.props.onOpen();
      }
    };

    _this.close = function () {
      _this.setState({
        open: false
      });

      if (_this.props.onClose) {
        _this.props.onClose();
      }
    };

    _this.handleAccept = function () {
      _this.close();

      if (_this.props.onAccept) {
        _this.props.onAccept();
      }
    };

    _this.handleDismiss = function () {
      _this.close();

      if (_this.props.onDismiss) {
        _this.props.onDismiss();
      }
    };

    _this.handleClear = function () {
      _this.close();

      if (_this.props.onClear) {
        _this.props.onClear();
      }
    };

    return _this;
  }

  ModalWrapper.getDerivedStateFromProps = function (nextProps) {
    // only if accept = true close the dialog
    if (nextProps.isAccepted) {
      return {
        open: false
      };
    }

    return null;
  };

  ModalWrapper.prototype.render = function () {
    var _a = this.props,
        value = _a.value,
        format = _a.format,
        children = _a.children,
        dialogContentClassName = _a.dialogContentClassName,
        onAccept = _a.onAccept,
        onDismiss = _a.onDismiss,
        invalidLabel = _a.invalidLabel,
        labelFunc = _a.labelFunc,
        okLabel = _a.okLabel,
        cancelLabel = _a.cancelLabel,
        clearLabel = _a.clearLabel,
        clearable = _a.clearable,
        todayLabel = _a.todayLabel,
        showTodayButton = _a.showTodayButton,
        onOpen = _a.onOpen,
        onClose = _a.onClose,
        onSetToday = _a.onSetToday,
        isAccepted = _a.isAccepted,
        DialogProps = _a.DialogProps,
        other = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __rest */])(_a, ["value", "format", "children", "dialogContentClassName", "onAccept", "onDismiss", "invalidLabel", "labelFunc", "okLabel", "cancelLabel", "clearLabel", "clearable", "todayLabel", "showTodayButton", "onOpen", "onClose", "onSetToday", "isAccepted", "DialogProps"]);

    return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"], null, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(DateTextField$1, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({
      value: value,
      format: format,
      onClick: this.open,
      // onFocus={this.togglePicker} <- Currently not properly works with .blur() on TextField
      invalidLabel: invalidLabel,
      labelFunc: labelFunc,
      clearable: clearable
    }, other)), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(ModalDialog$1, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({
      open: this.state.open,
      onKeyDown: this.handleKeyDown,
      onClear: this.handleClear,
      onAccept: this.handleAccept,
      onDismiss: this.handleDismiss,
      onSetToday: this.handleSetTodayDate,
      dialogContentClassName: dialogContentClassName,
      clearLabel: clearLabel,
      todayLabel: todayLabel,
      okLabel: okLabel,
      cancelLabel: cancelLabel,
      clearable: clearable,
      showTodayButton: showTodayButton,
      children: children
    }, DialogProps)));
  };

   false ? ModalWrapper.propTypes = {
    /** "OK" label message */
    okLabel: node,

    /** "Cancel" label message */
    cancelLabel: node,

    /** "Clear" label message */
    clearLabel: node,

    /** If true clear button will be displayed */
    clearable: bool,

    /** "Today" label message */
    todayLabel: string,

    /**
     * If true today button will be displayed
     * <b>Note*</b> that clear button has higher priority
     */
    showTodayButton: bool,

    /** On open callback [(e: Event) => void] */
    onOpen: func,

    /** On close callback [(e: Event) => void] */
    format: string,

    /** Dialog props passed to material-ui Dialog */
    DialogProps: object,
    value: DomainPropTypes.date,
    invalidLabel: node,
    labelFunc: func,
    onClose: func,
    onAccept: func,
    onDismiss: func,
    onClear: func,
    onSetToday: func,
    children: node.isRequired,
    dialogContentClassName: string,
    isAccepted: bool.isRequired
  } : void 0;
  ModalWrapper.defaultProps = {
    dialogContentClassName: '',
    invalidLabel: undefined,
    value: new Date(),
    labelFunc: undefined,
    okLabel: 'OK',
    cancelLabel: 'Cancel',
    clearLabel: 'Clear',
    todayLabel: 'Today',
    clearable: false,
    showTodayButton: false,
    format: undefined,
    onAccept: undefined,
    onDismiss: undefined,
    onClear: undefined,
    onOpen: undefined,
    onClose: undefined,
    onSetToday: undefined,
    DialogProps: undefined,
    isAccepted: false
  };
  return ModalWrapper;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]);

var PickerToolbar = function (_a) {
  var children = _a.children,
      className = _a.className,
      classes = _a.classes,
      other = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __rest */])(_a, ["children", "className", "classes"]);

  return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_Toolbar___default.a, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({
    className: __WEBPACK_IMPORTED_MODULE_13_classnames___default()(classes.toolbar, className)
  }, other), children);
};

 false ? PickerToolbar.propTypes = {
  children: arrayOf(node).isRequired,
  className: string,
  classes: any.isRequired,
  innerRef: any
} : void 0;
PickerToolbar.defaultProps = {
  className: ''
};

var styles$1 = function (theme) {
  return __WEBPACK_IMPORTED_MODULE_16__material_ui_core_styles_createStyles___default()({
    toolbar: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'center',
      height: 100,
      backgroundColor: theme.palette.type === 'light' ? theme.palette.primary.main : theme.palette.background.default
    }
  });
};

var PickerToolbar$1 = __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles_withStyles___default()(styles$1, {
  name: 'MuiPickersToolbar'
})(PickerToolbar);

var ToolbarButton = function (_a) {
  var classes = _a.classes,
      selected = _a.selected,
      label = _a.label,
      className = _a.className,
      other = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __rest */])(_a, ["classes", "selected", "label", "className"]);

  var _b;

  return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_Typography___default.a, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({
    className: __WEBPACK_IMPORTED_MODULE_13_classnames___default()(classes.toolbarBtn, className, (_b = {}, _b[classes.toolbarBtnSelected] = selected, _b))
  }, other), label);
};

 false ? ToolbarButton.propTypes = {
  selected: bool.isRequired,
  label: string.isRequired,
  classes: any.isRequired,
  className: string,
  innerRef: any
} : void 0;
ToolbarButton.defaultProps = {
  className: ''
};

var styles$2 = function (theme) {
  return {
    toolbarBtn: {
      cursor: 'pointer',
      color: 'rgba(255, 255, 255, 0.54)'
    },
    toolbarBtnSelected: {
      color: theme.palette.common.white
    }
  };
};

var ToolbarButton$1 = __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles_withStyles___default()(styles$2, {
  name: 'MuiPickersToolbarButton'
})(ToolbarButton);

var findClosestEnabledDate = function (_a) {
  var date = _a.date,
      utils = _a.utils,
      minDate = _a.minDate,
      maxDate = _a.maxDate,
      disableFuture = _a.disableFuture,
      disablePast = _a.disablePast,
      shouldDisableDate = _a.shouldDisableDate;
  var today = utils.startOfDay(utils.date());
  minDate = minDate && utils.date(minDate);
  maxDate = maxDate && utils.date(maxDate);

  if (disablePast && utils.isBefore(minDate, today)) {
    minDate = today;
  }

  if (disableFuture && utils.isAfter(maxDate, today)) {
    maxDate = today;
  }

  var forward = utils.date(date);
  var backward = utils.date(date);

  if (utils.isBefore(date, minDate)) {
    forward = minDate;
    backward = null;
  }

  if (utils.isAfter(date, maxDate)) {
    if (backward) {
      backward = maxDate;
    }

    forward = null;
  }

  while (forward || backward) {
    if (forward && utils.isAfter(forward, maxDate)) {
      forward = null;
    }

    if (backward && utils.isBefore(backward, minDate)) {
      backward = null;
    }

    if (forward) {
      if (!shouldDisableDate(forward)) {
        return forward;
      }

      forward = utils.addDays(forward, 1);
    }

    if (backward) {
      if (!shouldDisableDate(backward)) {
        return backward;
      }

      backward = utils.addDays(backward, -1);
    }
  }

  return null;
};

var animationDuration = 350;

var SlideTransition = function (_a) {
  var classes = _a.classes,
      className = _a.className,
      children = _a.children,
      transKey = _a.transKey,
      slideDirection = _a.slideDirection;
  return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_19_react_transition_group__["TransitionGroup"], {
    className: __WEBPACK_IMPORTED_MODULE_13_classnames___default()(classes.transitionContainer, className)
  }, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_19_react_transition_group__["CSSTransition"], {
    key: transKey,
    mountOnEnter: true,
    unmountOnExit: true,
    timeout: animationDuration,
    children: children,
    classNames: {
      enter: classes["slideEnter-" + slideDirection],
      enterActive: classes.slideEnterActive,
      exit: classes.slideExit,
      exitActive: classes["slideExitActiveLeft-" + slideDirection]
    }
  }));
};

 false ? SlideTransition.propTypes = {
  classes: shape({}).isRequired,
  children: node.isRequired,
  className: string,
  slideDirection: oneOf(['left', 'right']).isRequired,
  transKey: string.isRequired,
  innerRef: any
} : void 0;
SlideTransition.defaultProps = {
  className: undefined
};

var styles$3 = function (theme) {
  var slideTransition = theme.transitions.create('transform', {
    duration: animationDuration,
    easing: 'cubic-bezier(0.35, 0.8, 0.4, 1)'
  });
  return __WEBPACK_IMPORTED_MODULE_16__material_ui_core_styles_createStyles___default()({
    transitionContainer: {
      display: 'block',
      position: 'relative',
      '& > *': {
        position: 'absolute',
        top: 0,
        right: 0,
        left: 0
      }
    },
    'slideEnter-left': {
      willChange: 'transform',
      transform: 'translate(100%)'
    },
    'slideEnter-right': {
      willChange: 'transform',
      transform: 'translate(-100%)'
    },
    slideEnterActive: {
      transform: 'translate(0%)',
      transition: slideTransition
    },
    slideExit: {
      transform: 'translate(0%)'
    },
    'slideExitActiveLeft-left': {
      willChange: 'transform',
      transform: 'translate(-100%)',
      transition: slideTransition
    },
    'slideExitActiveLeft-right': {
      willChange: 'transform',
      transform: 'translate(100%)',
      transition: slideTransition
    }
  });
};

var SlideTransition$1 = __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles_withStyles___default()(styles$3, {
  name: 'MuiPickersSlideTransition'
})(SlideTransition);

var CalendarHeader = function (_a) {
  var classes = _a.classes,
      theme = _a.theme,
      currentMonth = _a.currentMonth,
      onMonthChange = _a.onMonthChange,
      leftArrowIcon = _a.leftArrowIcon,
      rightArrowIcon = _a.rightArrowIcon,
      disablePrevMonth = _a.disablePrevMonth,
      disableNextMonth = _a.disableNextMonth,
      utils = _a.utils,
      slideDirection = _a.slideDirection;
  var rtl = theme.direction === 'rtl';

  var selectNextMonth = function () {
    return onMonthChange(utils.getNextMonth(currentMonth), 'left');
  };

  var selectPreviousMonth = function () {
    return onMonthChange(utils.getPreviousMonth(currentMonth), 'right');
  };

  return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("div", null, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("div", {
    className: classes.switchHeader
  }, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_IconButton___default.a, {
    disabled: disablePrevMonth,
    onClick: selectPreviousMonth,
    className: classes.iconButton
  }, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Icon___default.a, null, rtl ? rightArrowIcon : leftArrowIcon)), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(SlideTransition$1, {
    slideDirection: slideDirection,
    transKey: currentMonth.toString(),
    className: classes.transitionContainer
  }, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_Typography___default.a, {
    align: "center",
    variant: "body1"
  }, utils.getCalendarHeaderText(currentMonth))), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_IconButton___default.a, {
    disabled: disableNextMonth,
    onClick: selectNextMonth,
    className: classes.iconButton
  }, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Icon___default.a, null, rtl ? leftArrowIcon : rightArrowIcon))), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("div", {
    className: classes.daysHeader
  }, utils.getWeekdays().map(function (day, index) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_Typography___default.a, {
      key: index,
      variant: "caption",
      className: classes.dayLabel
    }, day);
  })));
};
 false ? CalendarHeader.propTypes = {
  currentMonth: object.isRequired,
  onMonthChange: func.isRequired,
  classes: object.isRequired,
  theme: object.isRequired,
  leftArrowIcon: node,
  rightArrowIcon: node,
  disablePrevMonth: bool,
  disableNextMonth: bool,
  utils: object.isRequired,
  slideDirection: oneOf(['right', 'left']).isRequired,
  innerRef: any
} : void 0;
CalendarHeader.defaultProps = {
  leftArrowIcon: 'keyboard_arrow_left',
  rightArrowIcon: 'keyboard_arrow_right',
  disablePrevMonth: false,
  disableNextMonth: false
};

var styles$4 = function (theme) {
  return __WEBPACK_IMPORTED_MODULE_16__material_ui_core_styles_createStyles___default()({
    switchHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginTop: theme.spacing.unit / 2,
      marginBottom: theme.spacing.unit
    },
    transitionContainer: {
      width: '100%',
      height: 20
    },
    iconButton: {
      zIndex: 2,
      backgroundColor: theme.palette.background.paper,
      '& > *': {
        // label
        backgroundColor: theme.palette.background.paper,
        '& > *': {
          // icon
          zIndex: 1,
          overflow: 'visible'
        }
      }
    },
    daysHeader: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      maxHeight: 16
    },
    dayLabel: {
      width: 36,
      margin: '0 2px',
      textAlign: 'center',
      color: theme.palette.text.hint
    }
  });
};

var CalendarHeader$1 = __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles_withStyles___default()(styles$4, {
  withTheme: true,
  name: 'MuiPickersCalendarHeader'
})(withUtils()(CalendarHeader));

var Day =
/*@__PURE__*/
function (_super) {
  Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(Day, _super);

  function Day() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Day.prototype.render = function () {
    var _a;

    var _b = this.props,
        children = _b.children,
        classes = _b.classes,
        disabled = _b.disabled,
        hidden = _b.hidden,
        current = _b.current,
        selected = _b.selected,
        other = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __rest */])(_b, ["children", "classes", "disabled", "hidden", "current", "selected"]);

    var className = __WEBPACK_IMPORTED_MODULE_13_classnames___default()(classes.day, (_a = {}, _a[classes.hidden] = hidden, _a[classes.current] = current, _a[classes.selected] = selected, _a[classes.disabled] = disabled, _a));
    return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_IconButton___default.a, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({
      className: className,
      tabIndex: hidden || disabled ? -1 : 0
    }, other), children);
  };

   false ? Day.propTypes = {
    children: node.isRequired,
    classes: object.isRequired,
    current: bool,
    disabled: bool,
    hidden: bool,
    selected: bool,
    innerRef: any
  } : void 0;
  Day.defaultProps = {
    disabled: false,
    hidden: false,
    current: false,
    selected: false
  };
  return Day;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]);

var styles$5 = function (theme) {
  return __WEBPACK_IMPORTED_MODULE_16__material_ui_core_styles_createStyles___default()({
    day: {
      width: 36,
      height: 36,
      fontSize: theme.typography.caption.fontSize,
      margin: '0 2px',
      color: theme.palette.text.primary,
      fontWeight: theme.typography.fontWeightMedium,
      padding: 0
    },
    hidden: {
      opacity: 0,
      pointerEvents: 'none'
    },
    current: {
      color: theme.palette.primary.main,
      fontWeight: 600
    },
    selected: {
      color: theme.palette.common.white,
      backgroundColor: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightMedium,
      '&:hover': {
        backgroundColor: theme.palette.primary.main
      }
    },
    disabled: {
      pointerEvents: 'none',
      color: theme.palette.text.hint
    }
  });
};

var Day$1 = __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles_withStyles___default()(styles$5, {
  name: 'MuiPickersDay'
})(Day);

var DayWrapper =
/*@__PURE__*/
function (_super) {
  Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(DayWrapper, _super);

  function DayWrapper() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.handleClick = function () {
      _this.props.onSelect(_this.props.value);
    };

    return _this;
  }

  DayWrapper.prototype.render = function () {
    var _a = this.props,
        children = _a.children,
        value = _a.value,
        dayInCurrentMonth = _a.dayInCurrentMonth,
        disabled = _a.disabled,
        onSelect = _a.onSelect,
        other = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __rest */])(_a, ["children", "value", "dayInCurrentMonth", "disabled", "onSelect"]);

    return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("div", Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({
      onClick: dayInCurrentMonth && !disabled ? this.handleClick : undefined,
      onKeyPress: dayInCurrentMonth && !disabled ? this.handleClick : undefined,
      role: "presentation"
    }, other), children);
  };

   false ? DayWrapper.propTypes = {
    children: node.isRequired,
    dayInCurrentMonth: bool,
    disabled: bool,
    onSelect: func.isRequired,
    value: any.isRequired
  } : void 0;
  DayWrapper.defaultProps = {
    dayInCurrentMonth: true,
    disabled: false
  };
  return DayWrapper;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]);

var Calendar =
/*@__PURE__*/
function (_super) {
  Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(Calendar, _super);

  function Calendar() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      slideDirection: 'left',
      currentMonth: _this.props.utils.getStartOfMonth(_this.props.date)
    };

    _this.onDateSelect = function (day, isFinish) {
      if (isFinish === void 0) {
        isFinish = true;
      }

      var _a = _this.props,
          date = _a.date,
          utils = _a.utils;

      _this.props.onChange(utils.mergeDateAndTime(day, date), isFinish);
    };

    _this.handleChangeMonth = function (newMonth, slideDirection) {
      _this.setState({
        currentMonth: newMonth,
        slideDirection: slideDirection
      });
    };

    _this.validateMinMaxDate = function (day) {
      var _a = _this.props,
          minDate = _a.minDate,
          maxDate = _a.maxDate,
          utils = _a.utils;
      return minDate && utils.isBeforeDay(day, utils.date(minDate)) || maxDate && utils.isAfterDay(day, utils.date(maxDate));
    };

    _this.shouldDisablePrevMonth = function () {
      var _a = _this.props,
          utils = _a.utils,
          disablePast = _a.disablePast,
          minDate = _a.minDate;
      var now = utils.date();
      return !utils.isBefore(utils.getStartOfMonth(disablePast && utils.isAfter(now, minDate) ? now : utils.date(minDate)), _this.state.currentMonth);
    };

    _this.shouldDisableNextMonth = function () {
      var _a = _this.props,
          utils = _a.utils,
          disableFuture = _a.disableFuture,
          maxDate = _a.maxDate;
      var now = utils.date();
      return !utils.isAfter(utils.getStartOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : utils.date(maxDate)), _this.state.currentMonth);
    };

    _this.shouldDisableDate = function (day) {
      var _a = _this.props,
          disablePast = _a.disablePast,
          disableFuture = _a.disableFuture,
          shouldDisableDate = _a.shouldDisableDate,
          utils = _a.utils;
      return Boolean(disableFuture && utils.isAfterDay(day, utils.date()) || disablePast && utils.isBeforeDay(day, utils.date()) || _this.validateMinMaxDate(day) || shouldDisableDate && shouldDisableDate(day));
    };

    _this.moveToDay = function (day) {
      if (day && !_this.shouldDisableDate(day)) {
        _this.onDateSelect(day, false);
      }
    };

    _this.handleKeyDown = function (event) {
      var _a = _this.props,
          theme = _a.theme,
          date = _a.date,
          utils = _a.utils;

      switch (__WEBPACK_IMPORTED_MODULE_15_keycode___default()(event)) {
        case 'up':
          _this.moveToDay(utils.addDays(date, -7));

          break;

        case 'down':
          _this.moveToDay(utils.addDays(date, 7));

          break;

        case 'left':
          theme.direction === 'ltr' ? _this.moveToDay(utils.addDays(date, -1)) : _this.moveToDay(utils.addDays(date, 1));
          break;

        case 'right':
          theme.direction === 'ltr' ? _this.moveToDay(utils.addDays(date, 1)) : _this.moveToDay(utils.addDays(date, -1));
          break;

        default:
          // if keycode is not handled, stop execution
          return;
      } // if event was handled prevent other side effects (e.g. page scroll)


      event.preventDefault();
    };

    _this.renderWeeks = function () {
      var utils = _this.props.utils;
      var currentMonth = _this.state.currentMonth;
      var weeks = utils.getWeekArray(currentMonth);
      return weeks.map(function (week) {
        return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("div", {
          key: "week-" + week[0].toString(),
          className: _this.props.classes.week
        }, _this.renderDays(week));
      });
    };

    _this.renderDays = function (week) {
      var _a = _this.props,
          date = _a.date,
          renderDay = _a.renderDay,
          utils = _a.utils;
      var selectedDate = utils.startOfDay(date);
      var currentMonthNumber = utils.getMonth(_this.state.currentMonth);
      var now = utils.date();
      return week.map(function (day) {
        var disabled = _this.shouldDisableDate(day);

        var dayInCurrentMonth = utils.getMonth(day) === currentMonthNumber;
        var dayComponent = Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(Day$1, {
          current: utils.isSameDay(day, now),
          hidden: !dayInCurrentMonth,
          disabled: disabled,
          selected: utils.isSameDay(selectedDate, day)
        }, utils.getDayText(day));

        if (renderDay) {
          dayComponent = renderDay(day, selectedDate, dayInCurrentMonth, dayComponent);
        }

        return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(DayWrapper, {
          key: day.toString(),
          value: day,
          dayInCurrentMonth: dayInCurrentMonth,
          disabled: disabled,
          onSelect: _this.onDateSelect
        }, dayComponent);
      });
    };

    return _this;
  }

  Calendar.getDerivedStateFromProps = function (nextProps, state) {
    if (!nextProps.utils.isEqual(nextProps.date, state.lastDate)) {
      return {
        lastDate: nextProps.date,
        currentMonth: nextProps.utils.getStartOfMonth(nextProps.date)
      };
    }

    return null;
  };

  Calendar.prototype.componentDidMount = function () {
    var _a = this.props,
        date = _a.date,
        minDate = _a.minDate,
        maxDate = _a.maxDate,
        utils = _a.utils,
        disableFuture = _a.disableFuture,
        disablePast = _a.disablePast;

    if (this.shouldDisableDate(date)) {
      this.onDateSelect(findClosestEnabledDate({
        date: date,
        utils: utils,
        minDate: minDate,
        maxDate: maxDate,
        disablePast: Boolean(disablePast),
        disableFuture: Boolean(disablePast),
        shouldDisableDate: this.shouldDisableDate
      }), false);
    }
  };

  Calendar.prototype.render = function () {
    var _a = this.state,
        currentMonth = _a.currentMonth,
        slideDirection = _a.slideDirection;
    var _b = this.props,
        classes = _b.classes,
        utils = _b.utils,
        allowKeyboardControl = _b.allowKeyboardControl;
    return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"], null, allowKeyboardControl && Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_14_react_event_listener___default.a, {
      target: "window",
      onKeyDown: this.handleKeyDown
    }), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(CalendarHeader$1, {
      slideDirection: slideDirection,
      currentMonth: currentMonth,
      onMonthChange: this.handleChangeMonth,
      leftArrowIcon: this.props.leftArrowIcon,
      rightArrowIcon: this.props.rightArrowIcon,
      disablePrevMonth: this.shouldDisablePrevMonth(),
      disableNextMonth: this.shouldDisableNextMonth()
    }), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(SlideTransition$1, {
      slideDirection: slideDirection,
      transKey: currentMonth.toString(),
      className: classes.transitionContainer
    }, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("div", {
      // @ts-ignore Autofocus required for getting work keyboard navigation feature
      autoFocus: true
    }, this.renderWeeks())));
  };

   false ? Calendar.propTypes = {
    date: object.isRequired,
    minDate: DomainPropTypes.date,
    maxDate: DomainPropTypes.date,
    classes: object.isRequired,
    onChange: func.isRequired,
    disablePast: bool,
    disableFuture: bool,
    leftArrowIcon: node,
    rightArrowIcon: node,
    renderDay: func,
    theme: object.isRequired,
    shouldDisableDate: func,
    utils: object.isRequired,
    allowKeyboardControl: bool,
    innerRef: any
  } : void 0;
  Calendar.defaultProps = {
    minDate: '1900-01-01',
    maxDate: '2100-01-01',
    disablePast: false,
    disableFuture: false,
    leftArrowIcon: undefined,
    rightArrowIcon: undefined,
    renderDay: undefined,
    allowKeyboardControl: false,
    shouldDisableDate: function () {
      return false;
    }
  };
  return Calendar;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

var styles$6 = function (theme) {
  return {
    transitionContainer: {
      minHeight: 36 * 6,
      marginTop: theme.spacing.unit * 1.5
    },
    week: {
      display: 'flex',
      justifyContent: 'center'
    }
  };
};

var Calendar$1 = __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles_withStyles___default()(styles$6, {
  name: 'MuiPickersCalendar',
  withTheme: true
})(withUtils()(Calendar));

var Year =
/*@__PURE__*/
function (_super) {
  Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(Year, _super);

  function Year() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.handleClick = function () {
      _this.props.onSelect(_this.props.value);
    };

    return _this;
  }

  Year.prototype.render = function () {
    var _a;

    var _b = this.props,
        classes = _b.classes,
        selected = _b.selected,
        disabled = _b.disabled,
        value = _b.value,
        children = _b.children,
        other = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __rest */])(_b, ["classes", "selected", "disabled", "value", "children"]);

    return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_Typography___default.a, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({
      role: "button",
      component: "div",
      className: __WEBPACK_IMPORTED_MODULE_13_classnames___default()(classes.root, (_a = {}, _a[classes.selected] = selected, _a[classes.disabled] = disabled, _a)),
      tabIndex: disabled ? -1 : 0,
      onClick: this.handleClick,
      onKeyPress: this.handleClick,
      color: selected ? 'primary' : 'default',
      variant: selected ? 'h5' : 'subtitle1'
    }, other), children);
  };

   false ? Year.propTypes = {
    children: node.isRequired,
    classes: object.isRequired,
    disabled: bool,
    onSelect: func.isRequired,
    selected: bool,
    value: any.isRequired,
    innerRef: any
  } : void 0;
  Year.defaultProps = {
    selected: false,
    disabled: false
  };
  return Year;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]);

var styles$7 = function (theme) {
  return __WEBPACK_IMPORTED_MODULE_16__material_ui_core_styles_createStyles___default()({
    root: {
      height: theme.spacing.unit * 5,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      outline: 'none',
      '&:focus': {
        color: theme.palette.primary.main,
        fontWeight: theme.typography.fontWeightMedium
      }
    },
    selected: {
      margin: '10px 0',
      fontWeight: theme.typography.fontWeightMedium
    },
    disabled: {
      pointerEvents: 'none',
      color: theme.palette.text.hint
    }
  });
};

var Year$1 = __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles_withStyles___default()(styles$7, {
  name: 'MuiPickersYear'
})(Year);

var YearSelection =
/*@__PURE__*/
function (_super) {
  Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(YearSelection, _super);

  function YearSelection() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.selectedYearRef = undefined;

    _this.getSelectedYearRef = function (ref) {
      _this.selectedYearRef = ref;
    };

    _this.scrollToCurrentYear = function (domNode) {
      var animateYearScrolling = _this.props.animateYearScrolling;
      var currentYearElement = Object(__WEBPACK_IMPORTED_MODULE_20_react_dom__["findDOMNode"])(domNode);

      if (currentYearElement && currentYearElement.scrollIntoView) {
        if (animateYearScrolling) {
          setTimeout(function () {
            return currentYearElement.scrollIntoView({
              behavior: 'smooth'
            });
          }, 100);
        } else {
          currentYearElement.scrollIntoView();
        }
      }
    };

    _this.componentDidMount = function () {
      if (_this.selectedYearRef) {
        _this.scrollToCurrentYear(_this.selectedYearRef);
      }
    };

    _this.onYearSelect = function (year) {
      var _a = _this.props,
          date = _a.date,
          onChange = _a.onChange,
          utils = _a.utils;
      var newDate = utils.setYear(date, year);
      onChange(newDate);
    };

    return _this;
  }

  YearSelection.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        minDate = _a.minDate,
        maxDate = _a.maxDate,
        date = _a.date,
        classes = _a.classes,
        disablePast = _a.disablePast,
        disableFuture = _a.disableFuture,
        utils = _a.utils;
    var currentYear = utils.getYear(date);
    return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("div", {
      className: classes.container
    }, utils.getYearRange(minDate, maxDate).map(function (year) {
      var yearNumber = utils.getYear(year);
      var selected = yearNumber === currentYear;
      return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(Year$1, {
        key: utils.getYearText(year),
        selected: selected,
        value: yearNumber,
        onSelect: _this.onYearSelect,
        // @ts-ignore
        ref: selected ? _this.getSelectedYearRef : undefined,
        disabled: disablePast && utils.isBeforeYear(year, utils.date()) || disableFuture && utils.isAfterYear(year, utils.date())
      }, utils.getYearText(year));
    }));
  };

   false ? YearSelection.propTypes = {
    date: shape({}).isRequired,
    minDate: DomainPropTypes.date,
    maxDate: DomainPropTypes.date,
    classes: object.isRequired,
    onChange: func.isRequired,
    disablePast: bool,
    disableFuture: bool,
    animateYearScrolling: bool,
    utils: object.isRequired,
    innerRef: any
  } : void 0;
  YearSelection.defaultProps = {
    animateYearScrolling: false
  };
  return YearSelection;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]);
var styles$8 = __WEBPACK_IMPORTED_MODULE_16__material_ui_core_styles_createStyles___default()({
  container: {
    maxHeight: 300,
    overflowY: 'auto',
    justifyContent: 'center'
  }
});
var YearSelection$1 = __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles_withStyles___default()(styles$8, {
  name: 'MuiPickersYearSelection'
})(withUtils()(YearSelection));

var DatePicker =
/*@__PURE__*/
function (_super) {
  Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(DatePicker, _super);

  function DatePicker() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      showYearSelection: Boolean(_this.props.openToYearSelection)
    };

    _this.handleYearSelect = function (date) {
      _this.props.onChange(date, false);

      _this.openCalendar();
    };

    _this.openYearSelection = function () {
      _this.setState({
        showYearSelection: true
      });
    };

    _this.openCalendar = function () {
      _this.setState({
        showYearSelection: false
      });
    };

    return _this;
  }

  Object.defineProperty(DatePicker.prototype, "date", {
    get: function () {
      return this.props.utils.startOfDay(this.props.date);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DatePicker.prototype, "minDate", {
    get: function () {
      return this.props.utils.date(this.props.minDate);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DatePicker.prototype, "maxDate", {
    get: function () {
      return this.props.utils.date(this.props.maxDate);
    },
    enumerable: true,
    configurable: true
  });

  DatePicker.prototype.render = function () {
    var showYearSelection = this.state.showYearSelection;
    var _a = this.props,
        disablePast = _a.disablePast,
        disableFuture = _a.disableFuture,
        onChange = _a.onChange,
        animateYearScrolling = _a.animateYearScrolling,
        leftArrowIcon = _a.leftArrowIcon,
        rightArrowIcon = _a.rightArrowIcon,
        renderDay = _a.renderDay,
        utils = _a.utils,
        shouldDisableDate = _a.shouldDisableDate,
        allowKeyboardControl = _a.allowKeyboardControl;
    return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"], null, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(PickerToolbar$1, null, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(ToolbarButton$1, {
      variant: "subtitle1",
      onClick: this.openYearSelection,
      selected: showYearSelection,
      label: utils.getYearText(this.date)
    }), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(ToolbarButton$1, {
      variant: "h4",
      onClick: this.openCalendar,
      selected: !showYearSelection,
      label: utils.getDatePickerHeaderText(this.date)
    })), this.props.children, showYearSelection ? Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(YearSelection$1, {
      date: this.date,
      onChange: this.handleYearSelect,
      minDate: this.minDate,
      maxDate: this.maxDate,
      disablePast: disablePast,
      disableFuture: disableFuture,
      animateYearScrolling: animateYearScrolling
    }) : Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(Calendar$1, {
      date: this.date,
      onChange: onChange,
      disablePast: disablePast,
      disableFuture: disableFuture,
      minDate: this.minDate,
      maxDate: this.maxDate,
      leftArrowIcon: leftArrowIcon,
      rightArrowIcon: rightArrowIcon,
      renderDay: renderDay,
      shouldDisableDate: shouldDisableDate,
      allowKeyboardControl: allowKeyboardControl
    }));
  };

   false ? DatePicker.propTypes = {
    date: object.isRequired,
    minDate: DomainPropTypes.date,
    maxDate: DomainPropTypes.date,
    onChange: func.isRequired,
    disablePast: bool,
    disableFuture: bool,
    animateYearScrolling: bool,
    openToYearSelection: bool,
    children: node,
    leftArrowIcon: node,
    rightArrowIcon: node,
    renderDay: func,
    utils: object.isRequired,
    shouldDisableDate: func,
    allowKeyboardControl: bool,
    initialFocusedDate: DomainPropTypes.date
  } : void 0;
  DatePicker.defaultProps = {
    minDate: '1900-01-01',
    maxDate: '2100-01-01',
    disablePast: false,
    disableFuture: false,
    allowKeyboardControl: false,
    animateYearScrolling: undefined,
    openToYearSelection: false,
    children: null,
    leftArrowIcon: undefined,
    rightArrowIcon: undefined,
    renderDay: undefined,
    shouldDisableDate: undefined
  };
  return DatePicker;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]);
var DatePicker$1 = withUtils()(DatePicker);

var DatePickerModal = function (props) {
  var allowKeyboardControl = props.allowKeyboardControl,
      animateYearScrolling = props.animateYearScrolling,
      autoOk = props.autoOk,
      disableFuture = props.disableFuture,
      disablePast = props.disablePast,
      format = props.format,
      forwardedRef = props.forwardedRef,
      labelFunc = props.labelFunc,
      leftArrowIcon = props.leftArrowIcon,
      maxDate = props.maxDate,
      minDate = props.minDate,
      initialFocusedDate = props.initialFocusedDate,
      onChange = props.onChange,
      openToYearSelection = props.openToYearSelection,
      renderDay = props.renderDay,
      rightArrowIcon = props.rightArrowIcon,
      shouldDisableDate = props.shouldDisableDate,
      value = props.value,
      other = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __rest */])(props, ["allowKeyboardControl", "animateYearScrolling", "autoOk", "disableFuture", "disablePast", "format", "forwardedRef", "labelFunc", "leftArrowIcon", "maxDate", "minDate", "initialFocusedDate", "onChange", "openToYearSelection", "renderDay", "rightArrowIcon", "shouldDisableDate", "value"]);

  return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(BasePicker$1, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props), function (_a) {
    var date = _a.date,
        utils = _a.utils,
        handleAccept = _a.handleAccept,
        handleChange = _a.handleChange,
        handleClear = _a.handleClear,
        handleDismiss = _a.handleDismiss,
        handleSetTodayDate = _a.handleSetTodayDate,
        handleTextFieldChange = _a.handleTextFieldChange,
        isAccepted = _a.isAccepted;
    return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(ModalWrapper, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({
      disableFuture: disableFuture,
      disablePast: disablePast,
      format: format || utils.dateFormat,
      labelFunc: labelFunc,
      maxDate: maxDate,
      minDate: minDate,
      onAccept: handleAccept,
      onChange: handleTextFieldChange,
      onClear: handleClear,
      onDismiss: handleDismiss,
      onSetToday: handleSetTodayDate,
      ref: forwardedRef,
      value: value,
      isAccepted: isAccepted
    }, other), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(DatePicker$1, {
      date: date,
      allowKeyboardControl: allowKeyboardControl,
      animateYearScrolling: animateYearScrolling,
      disableFuture: disableFuture,
      disablePast: disablePast,
      leftArrowIcon: leftArrowIcon,
      maxDate: maxDate,
      minDate: minDate,
      onChange: handleChange,
      openToYearSelection: openToYearSelection,
      renderDay: renderDay,
      rightArrowIcon: rightArrowIcon,
      shouldDisableDate: shouldDisableDate
    }));
  });
};
 false ? DatePickerModal.propTypes = {
  /** Datepicker value */
  value: DomainPropTypes.date,

  /** Min selectable date */
  minDate: DomainPropTypes.date,

  /** Max selectable date */
  maxDate: DomainPropTypes.date,

  /** Initial focused date when calendar opens, if no value is provided */
  initialFocusedDate: DomainPropTypes.date,

  /** Date format string for input */
  format: string,

  /** Callback firing when date accepted [(date: Date) => void] */
  onChange: func.isRequired,

  /** Auto accept date on selection */
  autoOk: bool,

  /** Disable past dates */
  disablePast: bool,

  /** Disable future dates */
  disableFuture: bool,

  /** To animate scrolling to current year (with scrollIntoView) */
  animateYearScrolling: bool,

  /** Open datepicker from year selection */
  openToYearSelection: bool,

  /**
   * Allow to specify dynamic label for text field
   * [(date: Date, invalidLabel: string) => string]
   */
  labelFunc: func,

  /** Left arrow icon */
  leftArrowIcon: node,

  /** Right arrow icon */
  rightArrowIcon: node,

  /**
   * Custom renderer for day
   * [(date: Date, nowSelectedDate: Date, isInCurrentMonth: boolean) => ReactElement]
   */
  renderDay: func,

  /** Disable specific date [(date: Date) => boolean] */
  shouldDisableDate: func,

  /** Enables keyboard listener for moving between days in calendar */
  allowKeyboardControl: bool,
  forwardedRef: oneOfType([func, object])
} : void 0;
DatePickerModal.defaultProps = {
  value: new Date(),
  format: undefined,
  autoOk: false,
  minDate: '1900-01-01',
  maxDate: '2100-01-01',
  initialFocusedDate: undefined,
  disableFuture: false,
  disablePast: false,
  animateYearScrolling: false,
  openToYearSelection: false,
  allowKeyboardControl: true,
  leftArrowIcon: 'keyboard_arrow_left',
  rightArrowIcon: 'keyboard_arrow_right',
  renderDay: undefined,
  labelFunc: undefined,
  shouldDisableDate: undefined,
  forwardedRef: undefined
};
var DatePickerModal$1 = Object(__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"])(function (props, ref) {
  return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(DatePickerModal, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props, {
    forwardedRef: ref
  }));
});

var InlineWrapper =
/*@__PURE__*/
function (_super) {
  Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(InlineWrapper, _super);

  function InlineWrapper() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      anchorEl: null
    };

    _this.open = function (e) {
      _this.setState({
        anchorEl: e.currentTarget
      });

      if (_this.props.onOpen) {
        _this.props.onOpen();
      }
    };

    _this.close = function () {
      _this.setState({
        anchorEl: null
      });

      _this.props.handleAccept();

      if (_this.props.onClose) {
        _this.props.onClose();
      }
    };

    _this.handleKeyDown = function (event) {
      switch (__WEBPACK_IMPORTED_MODULE_15_keycode___default()(event)) {
        case 'enter':
          {
            _this.props.handleAccept();

            _this.close();

            break;
          }

        default:
          // if keycode is not handled, stop execution
          return;
      } // if event was handled prevent other side effects


      event.preventDefault();
    };

    return _this;
  }

  InlineWrapper.getDerivedStateFromProps = function (nextProps) {
    // only if accept = true close the popover
    if (nextProps.isAccepted) {
      return {
        anchorEl: null
      };
    }

    return null;
  };

  InlineWrapper.prototype.render = function () {
    var _a = this.props,
        value = _a.value,
        format = _a.format,
        children = _a.children,
        onOpen = _a.onOpen,
        onClose = _a.onClose,
        PopoverProps = _a.PopoverProps,
        isAccepted = _a.isAccepted,
        keyboard = _a.keyboard,
        onlyCalendar = _a.onlyCalendar,
        classes = _a.classes,
        handleAccept = _a.handleAccept,
        other = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __rest */])(_a, ["value", "format", "children", "onOpen", "onClose", "PopoverProps", "isAccepted", "keyboard", "onlyCalendar", "classes", "handleAccept"]);

    var isOpen = Boolean(this.state.anchorEl);
    return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"], null, isOpen && Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_14_react_event_listener___default.a, {
      target: "window",
      onKeyDown: this.handleKeyDown
    }), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(DateTextField$1, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({
      value: value,
      format: format,
      onClick: this.open,
      keyboard: keyboard
    }, other)), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Popover___default.a, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({
      id: "picker-popover",
      open: isOpen,
      anchorEl: this.state.anchorEl,
      onClose: this.close,
      classes: {
        paper: classes.popoverPaper
      },
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: keyboard ? 'right' : 'center'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: keyboard ? 'right' : 'center'
      },
      children: children
    }, PopoverProps)));
  };

   false ? InlineWrapper.propTypes = {
    /** Show only calendar for datepicker in popover mode */
    onlyCalendar: bool,

    /** Picker value */
    value: DomainPropTypes.date,

    /** On open callback [(e: Event) => void] */
    onOpen: func,

    /** On close callback [(e: Event) => void] */
    onClose: func,

    /** Format string */
    format: string,

    /** Dialog props passed to material-ui Dialog */
    PopoverProps: object,
    labelFunc: func,
    onClear: func,
    isAccepted: bool,
    handleAccept: func.isRequired,
    children: node.isRequired,
    keyboard: bool,
    classes: object.isRequired,
    innerRef: any
  } : void 0;
  InlineWrapper.defaultProps = {
    value: new Date(),
    labelFunc: undefined,
    onlyCalendar: false,
    format: undefined,
    onClear: undefined,
    onOpen: undefined,
    onClose: undefined,
    PopoverProps: undefined,
    isAccepted: false,
    keyboard: undefined
  };
  return InlineWrapper;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]);
var styles$9 = {
  popoverPaper: {
    maxWidth: 310,
    minWidth: 290,
    paddingBottom: 8
  }
}; // @ts-ignore

var InlineWrapper$1 = __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles_withStyles___default()(styles$9)(InlineWrapper);

var DatePickerInline = function (props) {
  var allowKeyboardControl = props.allowKeyboardControl,
      animateYearScrolling = props.animateYearScrolling,
      disableFuture = props.disableFuture,
      disablePast = props.disablePast,
      format = props.format,
      forwardedRef = props.forwardedRef,
      labelFunc = props.labelFunc,
      leftArrowIcon = props.leftArrowIcon,
      maxDate = props.maxDate,
      minDate = props.minDate,
      initialFocusedDate = props.initialFocusedDate,
      onChange = props.onChange,
      openToYearSelection = props.openToYearSelection,
      renderDay = props.renderDay,
      rightArrowIcon = props.rightArrowIcon,
      shouldDisableDate = props.shouldDisableDate,
      value = props.value,
      autoOk = props.autoOk,
      onlyCalendar = props.onlyCalendar,
      other = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __rest */])(props, ["allowKeyboardControl", "animateYearScrolling", "disableFuture", "disablePast", "format", "forwardedRef", "labelFunc", "leftArrowIcon", "maxDate", "minDate", "initialFocusedDate", "onChange", "openToYearSelection", "renderDay", "rightArrowIcon", "shouldDisableDate", "value", "autoOk", "onlyCalendar"]);

  var ComponentToShow = onlyCalendar ? Calendar$1 : DatePicker$1;
  return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(BasePicker$1, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props, {
    autoOk: true
  }), function (_a) {
    var date = _a.date,
        utils = _a.utils,
        isAccepted = _a.isAccepted,
        handleChange = _a.handleChange,
        handleTextFieldChange = _a.handleTextFieldChange,
        handleAccept = _a.handleAccept;
    return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(InlineWrapper$1, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({
      disableFuture: disableFuture,
      disablePast: disablePast,
      format: format || utils.dateFormat,
      labelFunc: labelFunc,
      maxDate: maxDate,
      minDate: minDate,
      onChange: handleTextFieldChange,
      innerRef: forwardedRef,
      value: value,
      isAccepted: isAccepted,
      handleAccept: handleAccept
    }, other), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(ComponentToShow, {
      date: date,
      allowKeyboardControl: allowKeyboardControl,
      animateYearScrolling: animateYearScrolling,
      disableFuture: disableFuture,
      disablePast: disablePast,
      leftArrowIcon: leftArrowIcon,
      maxDate: maxDate,
      minDate: minDate,
      onChange: handleChange,
      openToYearSelection: openToYearSelection,
      renderDay: renderDay,
      rightArrowIcon: rightArrowIcon,
      shouldDisableDate: shouldDisableDate
    }));
  });
};
 false ? DatePickerInline.propTypes = {
  onlyCalendar: bool,
  value: DomainPropTypes.date,
  minDate: DomainPropTypes.date,
  maxDate: DomainPropTypes.date,
  initialFocusedDate: DomainPropTypes.date,
  format: string,
  onChange: func.isRequired,
  disablePast: bool,
  disableFuture: bool,
  animateYearScrolling: bool,
  openToYearSelection: bool,
  labelFunc: func,
  leftArrowIcon: node,
  rightArrowIcon: node,
  renderDay: func,
  shouldDisableDate: func,
  allowKeyboardControl: bool,
  forwardedRef: oneOfType([func, object]),
  autoOk: bool
} : void 0;
DatePickerInline.defaultProps = {
  value: new Date(),
  format: undefined,
  minDate: '1900-01-01',
  maxDate: '2100-01-01',
  initialFocusedDate: undefined,
  disableFuture: false,
  disablePast: false,
  animateYearScrolling: false,
  openToYearSelection: false,
  allowKeyboardControl: true,
  leftArrowIcon: 'keyboard_arrow_left',
  rightArrowIcon: 'keyboard_arrow_right',
  renderDay: undefined,
  labelFunc: undefined,
  shouldDisableDate: undefined,
  forwardedRef: undefined,
  autoOk: undefined,
  onlyCalendar: false
};
var DatePickerInline$1 = Object(__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"])(function (props, ref) {
  return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(DatePickerInline, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props, {
    forwardedRef: ref
  }));
});

var center = {
  x: 260 / 2,
  y: 260 / 2
};
var basePoint = {
  x: center.x,
  y: 0
};
var cx = basePoint.x - center.x;
var cy = basePoint.y - center.y;

var rad2deg = function (rad) {
  return rad * 57.29577951308232;
};

var getAngleValue = function (step, offsetX, offsetY) {
  var x = offsetX - center.x;
  var y = offsetY - center.y;
  var atan = Math.atan2(cx, cy) - Math.atan2(x, y);
  var deg = rad2deg(atan);
  deg = Math.round(deg / step) * step;
  deg %= 360;
  var value = Math.floor(deg / step) || 0;
  var delta = Math.pow(x, 2) + Math.pow(y, 2);
  var distance = Math.sqrt(delta);
  return {
    value: value,
    distance: distance
  };
};

var getHours = function (offsetX, offsetY, ampm) {
  // tslint:disable-next-line
  var _a = getAngleValue(30, offsetX, offsetY),
      value = _a.value,
      distance = _a.distance;

  value = value || 12;

  if (!ampm) {
    if (distance < 90) {
      value += 12;
      value %= 24;
    }
  } else {
    value %= 12;
  }

  return value;
};
var getMinutes = function (offsetX, offsetY, step) {
  if (step === void 0) {
    step = 6;
  }

  var value = getAngleValue(step, offsetX, offsetY).value;
  return value;
};
var convertToMeridiem = function (time, meridiem, ampm, utils) {
  if (ampm) {
    var currentMeridiem = utils.getHours(time) >= 12 ? 'pm' : 'am';

    if (currentMeridiem !== meridiem) {
      var hours = meridiem === 'am' ? utils.getHours(time) - 12 : utils.getHours(time) + 12;
      return utils.setHours(time, hours);
    }
  }

  return time;
};

var ClockType;

(function (ClockType) {
  ClockType["HOURS"] = "hours";
  ClockType["MINUTES"] = "minutes";
  ClockType["SECONDS"] = "seconds";
})(ClockType || (ClockType = {}));

var ClockType$1 = ClockType;

var ClockPointer =
/*@__PURE__*/
function (_super) {
  Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(ClockPointer, _super);

  function ClockPointer() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      toAnimateTransform: false,
      previousType: undefined
    };

    _this.getAngleStyle = function () {
      var _a = _this.props,
          value = _a.value,
          isInner = _a.isInner,
          type = _a.type;
      var max = type === ClockType$1.HOURS ? 12 : 60;
      var angle = 360 / max * value;

      if (type === ClockType$1.HOURS && value > 12) {
        angle -= 360; // round up angle to max 360 degrees
      }

      return {
        height: isInner ? '26%' : '40%',
        transform: "rotateZ(" + angle + "deg)"
      };
    };

    return _this;
  }

  ClockPointer.prototype.render = function () {
    var _a, _b;

    var _c = this.props,
        classes = _c.classes,
        hasSelected = _c.hasSelected;
    return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("div", {
      style: this.getAngleStyle(),
      className: __WEBPACK_IMPORTED_MODULE_13_classnames___default()(classes.pointer, (_a = {}, _a[classes.animateTransform] = this.state.toAnimateTransform, _a))
    }, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("div", {
      className: __WEBPACK_IMPORTED_MODULE_13_classnames___default()(classes.thumb, (_b = {}, _b[classes.noPoint] = hasSelected, _b))
    }));
  };

   false ? ClockPointer.propTypes = {
    classes: object.isRequired,
    value: number.isRequired,
    hasSelected: bool.isRequired,
    isInner: bool.isRequired,
    innerRef: any,
    type: oneOf(Object.keys(ClockType$1).map(function (key) {
      return ClockType$1[key];
    })).isRequired
  } : void 0;

  ClockPointer.getDerivedStateFromProps = function (nextProps, state) {
    if (nextProps.type !== state.previousType) {
      return {
        toAnimateTransform: true,
        previousType: nextProps.type
      };
    }

    return {
      toAnimateTransform: false,
      previousType: nextProps.type
    };
  };

  return ClockPointer;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

var styles$a = function (theme) {
  return __WEBPACK_IMPORTED_MODULE_16__material_ui_core_styles_createStyles___default()({
    pointer: {
      width: 2,
      backgroundColor: theme.palette.primary.main,
      position: 'absolute',
      left: 'calc(50% - 1px)',
      bottom: '50%',
      transformOrigin: 'center bottom 0px'
    },
    animateTransform: {
      transition: theme.transitions.create(['transform', 'height'])
    },
    thumb: {
      width: 4,
      height: 4,
      backgroundColor: theme.palette.common.white,
      borderRadius: '100%',
      position: 'absolute',
      top: -21,
      left: -15,
      border: "14px solid " + theme.palette.primary.main,
      boxSizing: 'content-box'
    },
    noPoint: {
      backgroundColor: theme.palette.primary.main
    }
  });
};

var ClockPointer$1 = __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles_withStyles___default()(styles$a, {
  name: 'MuiPickersClockPointer'
})(ClockPointer);

var Clock =
/*@__PURE__*/
function (_super) {
  Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(Clock, _super);

  function Clock() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.isMoving = false;

    _this.handleTouchMove = function (e) {
      _this.isMoving = true;

      _this.setTime(e);
    };

    _this.handleTouchEnd = function (e) {
      if (_this.isMoving) {
        _this.setTime(e, true);

        _this.isMoving = false;
      }
    };

    _this.handleMove = function (e) {
      e.preventDefault();
      e.stopPropagation(); // MouseEvent.which is deprecated, but MouseEvent.buttons is not supported in Safari

      var isButtonPressed = typeof e.buttons === 'undefined' ? e.nativeEvent.which === 1 : e.buttons === 1;

      if (isButtonPressed) {
        _this.setTime(e.nativeEvent, false);
      }
    };

    _this.handleMouseUp = function (e) {
      if (_this.isMoving) {
        _this.isMoving = false;
      }

      _this.setTime(e.nativeEvent, true);
    };

    _this.hasSelected = function () {
      var _a = _this.props,
          type = _a.type,
          value = _a.value;

      if (type === ClockType$1.HOURS) {
        return true;
      }

      return value % 5 === 0;
    };

    return _this;
  }

  Clock.prototype.setTime = function (e, isFinish) {
    if (isFinish === void 0) {
      isFinish = false;
    }

    var offsetX = e.offsetX,
        offsetY = e.offsetY;

    if (typeof offsetX === 'undefined') {
      var rect = e.target.getBoundingClientRect();
      offsetX = e.changedTouches[0].clientX - rect.left;
      offsetY = e.changedTouches[0].clientY - rect.top;
    }

    var value = this.props.type === ClockType$1.SECONDS || this.props.type === ClockType$1.MINUTES ? getMinutes(offsetX, offsetY) : getHours(offsetX, offsetY, Boolean(this.props.ampm));
    this.props.onChange(value, isFinish);
  };

  Clock.prototype.render = function () {
    var _a = this.props,
        classes = _a.classes,
        value = _a.value,
        children = _a.children,
        type = _a.type,
        ampm = _a.ampm;
    var isPointerInner = !ampm && type === ClockType$1.HOURS && (value < 1 || value > 12);
    return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("div", {
      className: classes.container
    }, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("div", {
      className: classes.clock
    }, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("div", {
      role: "menu",
      tabIndex: -1,
      className: classes.squareMask,
      onTouchMove: this.handleTouchMove,
      onTouchEnd: this.handleTouchEnd,
      onMouseUp: this.handleMouseUp,
      onMouseMove: this.handleMove
    }), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("div", {
      className: classes.pin
    }), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(ClockPointer$1, {
      type: type,
      value: value,
      isInner: isPointerInner,
      hasSelected: this.hasSelected()
    }), children));
  };

   false ? Clock.propTypes = {
    type: oneOf(Object.keys(ClockType$1).map(function (key) {
      return ClockType$1[key];
    })).isRequired,
    classes: object.isRequired,
    value: number.isRequired,
    onChange: func.isRequired,
    children: arrayOf(node).isRequired,
    ampm: bool,
    innerRef: any
  } : void 0;
  Clock.defaultProps = {
    ampm: false
  };
  return Clock;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

var styles$b = function (theme) {
  return __WEBPACK_IMPORTED_MODULE_16__material_ui_core_styles_createStyles___default()({
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-end',
      margin: theme.spacing.unit * 4 + "px 0 " + theme.spacing.unit + "px"
    },
    clock: {
      backgroundColor: 'rgba(0,0,0,.07)',
      borderRadius: '50%',
      height: 260,
      width: 260,
      position: 'relative',
      pointerEvents: 'none',
      zIndex: 1
    },
    squareMask: {
      width: '100%',
      height: '100%',
      position: 'absolute',
      pointerEvents: 'auto',
      outline: 'none',
      touchActions: 'none',
      userSelect: 'none',
      '&:active': {
        cursor: 'move'
      }
    },
    pin: {
      width: 6,
      height: 6,
      borderRadius: '50%',
      backgroundColor: theme.palette.primary.main,
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    }
  });
};

var Clock$1 = __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles_withStyles___default()(styles$b, {
  name: 'MuiPickersClock'
})(Clock);

var positions = {
  0: [0, 40],
  1: [55, 19.6],
  2: [94.4, 59.5],
  3: [109, 114],
  4: [94.4, 168.5],
  5: [54.5, 208.4],
  6: [0, 223],
  7: [-54.5, 208.4],
  8: [-94.4, 168.5],
  9: [-109, 114],
  10: [-94.4, 59.5],
  11: [-54.5, 19.6],
  12: [0, 5],
  13: [36.9, 49.9],
  14: [64, 77],
  15: [74, 114],
  16: [64, 151],
  17: [37, 178],
  18: [0, 188],
  19: [-37, 178],
  20: [-64, 151],
  21: [-74, 114],
  22: [-64, 77],
  23: [-37, 50]
};

var ClockNumber =
/*@__PURE__*/
function (_super) {
  Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(ClockNumber, _super);

  function ClockNumber() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.getTransformStyle = function (index) {
      var position = positions[index];
      return {
        transform: "translate(" + position[0] + "px, " + position[1] + "px"
      };
    };

    return _this;
  }

  ClockNumber.prototype.render = function () {
    var _a;

    var _b = this.props,
        selected = _b.selected,
        label = _b.label,
        index = _b.index,
        classes = _b.classes,
        isInner = _b.isInner;
    var className = __WEBPACK_IMPORTED_MODULE_13_classnames___default()(classes.clockNumber, (_a = {}, _a[classes.selected] = selected, _a));
    return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_Typography___default.a, {
      variant: isInner ? 'body1' : 'subtitle1',
      component: "span",
      className: className,
      style: this.getTransformStyle(index)
    }, label);
  };

   false ? ClockNumber.propTypes = {
    index: number.isRequired,
    label: string.isRequired,
    selected: bool.isRequired,
    classes: object.isRequired,
    isInner: bool,
    innerRef: any
  } : void 0;
  ClockNumber.defaultProps = {
    isInner: false
  };
  return ClockNumber;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

var styles$c = function (theme) {
  var size = theme.spacing.unit * 4;
  return __WEBPACK_IMPORTED_MODULE_16__material_ui_core_styles_createStyles___default()({
    clockNumber: {
      width: size,
      height: size,
      userSelect: 'none',
      position: 'absolute',
      left: "calc(50% - " + size / 2 + "px)",
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '50%',
      color: theme.palette.type === 'light' ? theme.palette.text.primary : theme.palette.text.hint
    },
    selected: {
      color: theme.palette.common.white
    }
  });
};

var ClockNumber$1 = __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles_withStyles___default()(styles$c, {
  name: 'MuiPickersClockNumber'
})(ClockNumber);

var getHourNumbers = function (_a) {
  var ampm = _a.ampm,
      utils = _a.utils,
      date = _a.date;
  var currentHours = utils.getHours(date);
  var hourNumbers = [];
  var startHour = ampm ? 1 : 0;
  var endHour = ampm ? 12 : 23;

  var isSelected = function (hour) {
    if (ampm) {
      if (hour === 12) {
        return currentHours === 12 || currentHours === 0;
      }

      return currentHours === hour || currentHours - 12 === hour;
    }

    return currentHours === hour;
  };

  for (var hour = startHour; hour <= endHour; hour += 1) {
    var label = hour.toString();

    if (hour === 0) {
      label = '00';
    }

    var props = {
      index: hour,
      label: utils.formatNumber(label),
      selected: isSelected(hour),
      isInner: !ampm && (hour === 0 || hour > 12)
    };
    hourNumbers.push(Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(ClockNumber$1, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({
      key: hour
    }, props)));
  }

  return hourNumbers;
};
var getMinutesNumbers = function (_a) {
  var value = _a.value,
      utils = _a.utils;
  var f = utils.formatNumber;
  return [Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(ClockNumber$1, {
    label: f('00'),
    selected: value === 0,
    index: 12,
    key: 12
  }), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(ClockNumber$1, {
    label: f('05'),
    selected: value === 5,
    index: 1,
    key: 1
  }), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(ClockNumber$1, {
    label: f('10'),
    selected: value === 10,
    index: 2,
    key: 2
  }), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(ClockNumber$1, {
    label: f('15'),
    selected: value === 15,
    index: 3,
    key: 3
  }), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(ClockNumber$1, {
    label: f('20'),
    selected: value === 20,
    index: 4,
    key: 4
  }), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(ClockNumber$1, {
    label: f('25'),
    selected: value === 25,
    index: 5,
    key: 5
  }), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(ClockNumber$1, {
    label: f('30'),
    selected: value === 30,
    index: 6,
    key: 6
  }), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(ClockNumber$1, {
    label: f('35'),
    selected: value === 35,
    index: 7,
    key: 7
  }), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(ClockNumber$1, {
    label: f('40'),
    selected: value === 40,
    index: 8,
    key: 8
  }), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(ClockNumber$1, {
    label: f('45'),
    selected: value === 45,
    index: 9,
    key: 9
  }), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(ClockNumber$1, {
    label: f('50'),
    selected: value === 50,
    index: 10,
    key: 10
  }), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(ClockNumber$1, {
    label: f('55'),
    selected: value === 55,
    index: 11,
    key: 11
  })];
};

var TimePickerView =
/*@__PURE__*/
function (_super) {
  Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(TimePickerView, _super);

  function TimePickerView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.getViewProps = function () {
      var _a = _this.props,
          type = _a.type,
          ampm = _a.ampm,
          date = _a.date,
          utils = _a.utils;

      switch (type) {
        case ClockType$1.HOURS:
          return {
            value: utils.getHours(date),
            children: getHourNumbers({
              date: date,
              ampm: Boolean(ampm),
              utils: utils
            }),
            onChange: _this.handleHourChange
          };

        case ClockType$1.MINUTES:
          var minutesValue = utils.getMinutes(date);
          return {
            value: minutesValue,
            children: getMinutesNumbers({
              value: minutesValue,
              utils: utils
            }),
            onChange: _this.handleMinutesChange
          };

        case ClockType$1.SECONDS:
          var secondsValue = utils.getSeconds(date);
          return {
            value: secondsValue,
            children: getMinutesNumbers({
              value: secondsValue,
              utils: utils
            }),
            onChange: _this.handleSecondsChange
          };

        default:
          throw new Error('You must provide the type for TimePickerView');
      }
    };

    _this.handleHourChange = function (hours, isFinish) {
      var _a = _this.props,
          date = _a.date,
          utils = _a.utils;
      var updatedTime = utils.setHours(date, hours);

      _this.props.onHourChange(updatedTime, isFinish);
    };

    _this.handleMinutesChange = function (minutes, isFinish) {
      var _a = _this.props,
          date = _a.date,
          utils = _a.utils;
      var updatedTime = utils.setMinutes(date, minutes);

      _this.props.onMinutesChange(updatedTime, isFinish);
    };

    _this.handleSecondsChange = function (seconds, isFinish) {
      var _a = _this.props,
          date = _a.date,
          utils = _a.utils;
      var updatedTime = utils.setSeconds(date, seconds);

      _this.props.onSecondsChange(updatedTime, isFinish);
    };

    return _this;
  }

  TimePickerView.prototype.render = function () {
    var _a = this.props,
        ampm = _a.ampm,
        type = _a.type;
    var viewProps = this.getViewProps();
    return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(Clock$1, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({
      type: type,
      ampm: ampm
    }, viewProps));
  };

   false ? TimePickerView.propTypes = {
    date: object.isRequired,
    onHourChange: func.isRequired,
    onMinutesChange: func.isRequired,
    onSecondsChange: func.isRequired,
    utils: object.isRequired,
    ampm: bool,
    type: oneOf(Object.keys(ClockType$1).map(function (key) {
      return ClockType$1[key];
    })).isRequired
  } : void 0;
  TimePickerView.defaultProps = {
    ampm: true
  };
  return TimePickerView;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]);
var TimePickerView$1 = withUtils()(TimePickerView);

var TimePicker =
/*@__PURE__*/
function (_super) {
  Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(TimePicker, _super);

  function TimePicker() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      openView: ClockType$1.HOURS,
      meridiemMode: _this.props.utils.getHours(_this.props.date) >= 12 ? 'pm' : 'am'
    };

    _this.setMeridiemMode = function (mode) {
      return function () {
        _this.setState({
          meridiemMode: mode
        }, function () {
          return _this.handleChange({
            time: _this.props.date,
            isFinish: false,
            openMinutes: false,
            openSeconds: false
          });
        });
      };
    };

    _this.handleChange = function (_a) {
      var time = _a.time,
          isFinish = _a.isFinish,
          openMinutes = _a.openMinutes,
          openSeconds = _a.openSeconds;
      var withMeridiem = convertToMeridiem(time, _this.state.meridiemMode, Boolean(_this.props.ampm), _this.props.utils);

      if (isFinish) {
        if (!openMinutes && !openSeconds) {
          _this.props.onChange(withMeridiem, isFinish);

          return;
        }

        if (openMinutes) {
          _this.openMinutesView();
        }

        if (openSeconds) {
          _this.openSecondsView();
        }
      }

      _this.props.onChange(withMeridiem, false);
    };

    _this.handleHourChange = function (time, isFinish) {
      _this.handleChange({
        time: time,
        isFinish: isFinish,
        openMinutes: true,
        openSeconds: false
      });
    };

    _this.handleMinutesChange = function (time, isFinish) {
      _this.handleChange({
        time: time,
        isFinish: isFinish,
        openMinutes: false,
        openSeconds: Boolean(_this.props.seconds)
      });
    };

    _this.handleSecondsChange = function (time, isFinish) {
      _this.handleChange({
        time: time,
        isFinish: isFinish,
        openMinutes: false,
        openSeconds: false
      });
    };

    _this.openSecondsView = function () {
      _this.setState({
        openView: ClockType$1.SECONDS
      });
    };

    _this.openMinutesView = function () {
      _this.setState({
        openView: ClockType$1.MINUTES
      });
    };

    _this.openHourView = function () {
      _this.setState({
        openView: ClockType$1.HOURS
      });
    };

    return _this;
  }

  TimePicker.prototype.render = function () {
    var _a;

    var _b = this.props,
        classes = _b.classes,
        theme = _b.theme,
        date = _b.date,
        utils = _b.utils,
        ampm = _b.ampm,
        seconds = _b.seconds;
    var _c = this.state,
        meridiemMode = _c.meridiemMode,
        openView = _c.openView;
    var rtl = theme.direction === 'rtl';
    var hourMinuteClassName = rtl ? classes.hourMinuteLabelReverse : classes.hourMinuteLabel;
    return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"], null, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(PickerToolbar$1, {
      className: __WEBPACK_IMPORTED_MODULE_13_classnames___default()(classes.toolbar, (_a = {}, _a[classes.toolbarLeftPadding] = ampm, _a))
    }, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("div", {
      className: hourMinuteClassName
    }, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(ToolbarButton$1, {
      variant: "h2",
      onClick: this.openHourView,
      selected: openView === ClockType$1.HOURS,
      label: utils.getHourText(date, Boolean(ampm))
    }), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(ToolbarButton$1, {
      variant: "h2",
      label: ":",
      selected: false,
      className: classes.separator
    }), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(ToolbarButton$1, {
      variant: "h2",
      onClick: this.openMinutesView,
      selected: openView === ClockType$1.MINUTES,
      label: utils.getMinuteText(date)
    }), seconds && Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"], null, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(ToolbarButton$1, {
      variant: "h2",
      label: ":",
      selected: false,
      className: classes.separator
    }), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(ToolbarButton$1, {
      variant: "h2",
      onClick: this.openSecondsView,
      selected: openView === ClockType$1.SECONDS,
      label: utils.getSecondText(date)
    }))), ampm && Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("div", {
      className: seconds ? classes.ampmSelectionWithSeconds : classes.ampmSelection
    }, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(ToolbarButton$1, {
      className: classes.ampmLabel,
      selected: meridiemMode === 'am',
      variant: "subtitle1",
      label: utils.getMeridiemText('am'),
      onClick: this.setMeridiemMode('am')
    }), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(ToolbarButton$1, {
      className: classes.ampmLabel,
      selected: meridiemMode === 'pm',
      variant: "subtitle1",
      label: utils.getMeridiemText('pm'),
      onClick: this.setMeridiemMode('pm')
    }))), this.props.children, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(TimePickerView$1, {
      date: date,
      type: this.state.openView,
      ampm: ampm,
      onHourChange: this.handleHourChange,
      onMinutesChange: this.handleMinutesChange,
      onSecondsChange: this.handleSecondsChange
    }));
  };

   false ? TimePicker.propTypes = {
    date: object.isRequired,
    onChange: func.isRequired,
    classes: object.isRequired,
    theme: object.isRequired,
    children: node,
    utils: object.isRequired,
    ampm: bool,
    seconds: bool,
    innerRef: any
  } : void 0;
  TimePicker.defaultProps = {
    children: null,
    ampm: true,
    seconds: false
  };
  return TimePicker;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

var styles$d = function () {
  return __WEBPACK_IMPORTED_MODULE_16__material_ui_core_styles_createStyles___default()({
    toolbar: {
      flexDirection: 'row',
      alignItems: 'center'
    },
    toolbarLeftPadding: {
      paddingLeft: 50
    },
    separator: {
      margin: '0 4px 0 2px',
      cursor: 'default'
    },
    ampmSelection: {
      marginLeft: 20,
      marginRight: -20
    },
    ampmSelectionWithSeconds: {
      marginLeft: 15,
      marginRight: 10
    },
    ampmLabel: {
      fontSize: 18
    },
    hourMinuteLabel: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'flex-end'
    },
    hourMinuteLabelReverse: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'flex-end',
      flexDirection: 'row-reverse'
    }
  });
};

var TimePicker$1 = __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles_withStyles___default()(styles$d, {
  withTheme: true,
  name: 'MuiPickersTimePicker'
})(withUtils()(TimePicker));

var TimePickerModal = function (props) {
  var value = props.value,
      format = props.format,
      autoOk = props.autoOk,
      onChange = props.onChange,
      ampm = props.ampm,
      forwardedRef = props.forwardedRef,
      seconds = props.seconds,
      other = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __rest */])(props, ["value", "format", "autoOk", "onChange", "ampm", "forwardedRef", "seconds"]);

  return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(BasePicker$1, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props), function (_a) {
    var date = _a.date,
        utils = _a.utils,
        handleAccept = _a.handleAccept,
        handleChange = _a.handleChange,
        handleClear = _a.handleClear,
        handleDismiss = _a.handleDismiss,
        handleSetTodayDate = _a.handleSetTodayDate,
        handleTextFieldChange = _a.handleTextFieldChange,
        isAccepted = _a.isAccepted,
        pick12hOr24hFormat = _a.pick12hOr24hFormat;
    return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(ModalWrapper, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({
      ref: forwardedRef,
      value: value,
      onClear: handleClear,
      onAccept: handleAccept,
      onChange: handleTextFieldChange,
      onDismiss: handleDismiss,
      onSetToday: handleSetTodayDate,
      isAccepted: isAccepted,
      format: pick12hOr24hFormat(utils.time12hFormat, utils.time24hFormat)
    }, other), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(TimePicker$1, {
      date: date,
      onChange: handleChange,
      ampm: ampm,
      seconds: seconds
    }));
  });
};
 false ? TimePickerModal.propTypes = {
  /** DateTimepicker value */
  value: DomainPropTypes.date,

  /** Date format string for input */
  format: string,

  /** Callback firing when date accepted [(date: Date) => void] */
  onChange: func.isRequired,

  /** Auto accept date on minute selection */
  autoOk: bool,

  /** 12h/24h view for hour selection clock */
  ampm: bool,

  /** Show the seconds view */
  seconds: bool,
  forwardedRef: oneOfType([func, object])
} : void 0;
TimePickerModal.defaultProps = {
  value: new Date(),
  format: undefined,
  autoOk: false,
  ampm: true,
  forwardedRef: undefined,
  seconds: false
};
var TimePickerModal$1 = Object(__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"])(function (props, ref) {
  return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(TimePickerModal, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props, {
    forwardedRef: ref
  }));
});

var TimePickerInline = function (props) {
  var value = props.value,
      format = props.format,
      onChange = props.onChange,
      ampm = props.ampm,
      forwardedRef = props.forwardedRef,
      seconds = props.seconds,
      other = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __rest */])(props, ["value", "format", "onChange", "ampm", "forwardedRef", "seconds"]);

  return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(BasePicker$1, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props, {
    autoOk: true
  }), function (_a) {
    var date = _a.date,
        utils = _a.utils,
        handleChange = _a.handleChange,
        handleTextFieldChange = _a.handleTextFieldChange,
        isAccepted = _a.isAccepted,
        pick12hOr24hFormat = _a.pick12hOr24hFormat,
        handleAccept = _a.handleAccept;
    return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(InlineWrapper$1, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({
      innerRef: forwardedRef,
      value: value,
      onChange: handleTextFieldChange,
      isAccepted: isAccepted,
      handleAccept: handleAccept,
      format: pick12hOr24hFormat(utils.time12hFormat, utils.time24hFormat)
    }, other), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(TimePicker$1, {
      date: date,
      onChange: handleChange,
      ampm: ampm,
      seconds: seconds
    }));
  });
};
 false ? TimePickerInline.propTypes = {
  value: DomainPropTypes.date,
  format: string,
  onChange: func.isRequired,
  ampm: bool,
  seconds: bool,
  forwardedRef: oneOfType([func, object])
} : void 0;
TimePickerInline.defaultProps = {
  ampm: true,
  value: new Date(),
  format: undefined,
  forwardedRef: undefined,
  seconds: false
};
var TimePickerInline$1 = Object(__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"])(function (props, ref) {
  return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(TimePickerInline, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props, {
    forwardedRef: ref
  }));
});

var DateTimePickerView;

(function (DateTimePickerView) {
  DateTimePickerView["YEAR"] = "year";
  DateTimePickerView["DATE"] = "date";
  DateTimePickerView["HOUR"] = "hours";
  DateTimePickerView["MINUTES"] = "minutes";
})(DateTimePickerView || (DateTimePickerView = {}));

var DateTimePickerView$1 = DateTimePickerView;

var DateTimePickerHeader = function (props) {
  var date = props.date,
      classes = props.classes,
      openView = props.openView,
      meridiemMode = props.meridiemMode,
      onOpenViewChange = props.onOpenViewChange,
      setMeridiemMode = props.setMeridiemMode,
      theme = props.theme,
      utils = props.utils,
      ampm = props.ampm;

  var changeOpenView = function (view) {
    return function () {
      return onOpenViewChange(view);
    };
  };

  var rtl = theme.direction === 'rtl';
  var hourMinuteClassName = rtl ? classes.hourMinuteLabelReverse : classes.hourMinuteLabel;
  return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(PickerToolbar$1, {
    className: classes.toolbar
  }, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("div", {
    className: classes.dateHeader
  }, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(ToolbarButton$1, {
    variant: "subtitle1",
    onClick: changeOpenView(DateTimePickerView$1.YEAR),
    selected: openView === DateTimePickerView$1.YEAR,
    label: utils.getYearText(date)
  }), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(ToolbarButton$1, {
    variant: "h4",
    onClick: changeOpenView(DateTimePickerView$1.DATE),
    selected: openView === DateTimePickerView$1.DATE,
    label: utils.getDateTimePickerHeaderText(date)
  })), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("div", {
    className: classes.timeHeader
  }, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("div", {
    className: hourMinuteClassName
  }, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(ToolbarButton$1, {
    variant: "h3",
    onClick: changeOpenView(DateTimePickerView$1.HOUR),
    selected: openView === DateTimePickerView$1.HOUR,
    label: utils.getHourText(date, ampm)
  }), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(ToolbarButton$1, {
    variant: "h3",
    label: ":",
    selected: false,
    className: classes.separator
  }), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(ToolbarButton$1, {
    variant: "h3",
    onClick: changeOpenView(DateTimePickerView$1.MINUTES),
    selected: openView === DateTimePickerView$1.MINUTES,
    label: utils.getMinuteText(date)
  })), ampm && Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("div", {
    className: classes.ampmSelection
  }, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(ToolbarButton$1, {
    className: classes.ampmLabel,
    selected: meridiemMode === 'am',
    variant: "subtitle1",
    label: utils.getMeridiemText('am'),
    onClick: setMeridiemMode('am')
  }), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(ToolbarButton$1, {
    className: classes.ampmLabel,
    selected: meridiemMode === 'pm',
    variant: "subtitle1",
    label: utils.getMeridiemText('pm'),
    onClick: setMeridiemMode('pm')
  }))));
};
 false ? DateTimePickerHeader.propTypes = {
  date: object.isRequired,
  classes: object.isRequired,
  theme: object.isRequired,
  meridiemMode: string.isRequired,
  openView: string.isRequired,
  onOpenViewChange: func.isRequired,
  setMeridiemMode: func.isRequired,
  utils: object.isRequired,
  ampm: bool,
  innerRef: any
} : void 0;
DateTimePickerHeader.defaultProps = {
  ampm: true
};

var styles$e = function () {
  return __WEBPACK_IMPORTED_MODULE_16__material_ui_core_styles_createStyles___default()({
    toolbar: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingLeft: 16,
      paddingRight: 16,
      justifyContent: 'space-around'
    },
    separator: {
      margin: '0 4px 0 2px',
      cursor: 'default'
    },
    ampmSelection: {
      marginLeft: 10,
      marginRight: -10
    },
    ampmLabel: {
      fontSize: 18
    },
    hourMinuteLabel: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'flex-end'
    },
    hourMinuteLabelReverse: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'flex-end',
      flexDirection: 'row-reverse'
    },
    dateHeader: {
      height: 65
    },
    timeHeader: {
      height: 65,
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'flex-end'
    }
  });
};

var DatetimePickerHeader = __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles_withStyles___default()(styles$e, {
  withTheme: true
})(withUtils()(DateTimePickerHeader));

var viewToTabIndex = function (openView) {
  if (openView === DateTimePickerView$1.DATE || openView === DateTimePickerView$1.YEAR) {
    return 'date';
  }

  return 'time';
};

var tabIndexToView = function (tab) {
  if (tab === 'date') {
    return DateTimePickerView$1.DATE;
  }

  return DateTimePickerView$1.HOUR;
};

var DateTimePickerTabs = function (props) {
  var view = props.view,
      onChange = props.onChange,
      classes = props.classes,
      theme = props.theme,
      dateRangeIcon = props.dateRangeIcon,
      timeIcon = props.timeIcon;
  var indicatorColor = theme.palette.type === 'light' ? 'secondary' : 'primary';

  var handleChange = function (e, value) {
    if (value !== viewToTabIndex(view)) {
      onChange(tabIndexToView(value));
    }
  };

  return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_22__material_ui_core_Paper___default.a, null, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_25__material_ui_core_Tabs___default.a, {
    fullWidth: true,
    value: viewToTabIndex(view),
    onChange: handleChange,
    className: classes.tabs,
    indicatorColor: indicatorColor
  }, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_24__material_ui_core_Tab___default.a, {
    value: "date",
    icon: Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Icon___default.a, null, dateRangeIcon)
  }), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_24__material_ui_core_Tab___default.a, {
    value: "time",
    icon: Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Icon___default.a, null, timeIcon)
  })));
};
 false ? DateTimePickerTabs.propTypes = {
  view: string.isRequired,
  onChange: func.isRequired,
  classes: object.isRequired,
  theme: object.isRequired,
  dateRangeIcon: node.isRequired,
  timeIcon: node.isRequired
} : void 0;

var styles$f = function (theme) {
  return {
    tabs: {
      color: theme.palette.common.white,
      backgroundColor: theme.palette.type === 'light' ? theme.palette.primary.main : theme.palette.background.default
    }
  };
};

var DateTimePickerTabs$1 = __WEBPACK_IMPORTED_MODULE_23__material_ui_core_styles_withTheme___default()()(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles_withStyles___default()(styles$f, {
  name: 'MuiPickerDTTabs'
})(DateTimePickerTabs));

var DateTimePickerView$2 = function (_a) {
  var selected = _a.selected,
      children = _a.children,
      classes = _a.classes;

  if (!selected) {
    return null;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])("div", {
    className: classes.view
  }, children);
};
 false ? DateTimePickerView$2.propTypes = {
  selected: bool.isRequired,
  children: node.isRequired,
  classes: object.isRequired
} : void 0;
var styles$g = __WEBPACK_IMPORTED_MODULE_16__material_ui_core_styles_createStyles___default()({
  view: {
    zIndex: 1,
    position: 'absolute',
    left: 0,
    right: 0
  }
});
var View = __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles_withStyles___default()(styles$g, {
  name: 'MuiPickerDTPickerView '
})(DateTimePickerView$2);

var DateTimePicker =
/*@__PURE__*/
function (_super) {
  Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(DateTimePicker, _super);

  function DateTimePicker() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      openView: _this.props.openTo,
      meridiemMode: _this.props.utils.getHours(_this.props.date) >= 12 ? 'pm' : 'am'
    };

    _this.onChange = function (time, isFinish, nextView) {
      if (isFinish === void 0) {
        isFinish = true;
      }

      _this.handleChange(time);

      if (isFinish && _this.props.autoSubmit) {
        _this.handleViewChange(nextView);
      }
    };

    _this.setMeridiemMode = function (mode) {
      return function () {
        _this.setState({
          meridiemMode: mode
        }, function () {
          return _this.handleChange(_this.props.date, false);
        });
      };
    };

    _this.handleViewChange = function (view) {
      _this.setState({
        openView: view
      });
    };

    _this.handleChange = function (time, isFinish) {
      if (isFinish === void 0) {
        isFinish = false;
      }

      var withMeridiem = convertToMeridiem(time, _this.state.meridiemMode, Boolean(_this.props.ampm), _this.props.utils);

      _this.props.onChange(withMeridiem, isFinish);
    };

    _this.handleYearChange = function (date) {
      _this.onChange(date, false, DateTimePickerView$1.DATE);
    };

    _this.handleDayChange = function (date, isFinish) {
      _this.onChange(date, isFinish, DateTimePickerView$1.HOUR);
    };

    _this.handleHourChange = function (time, isFinish) {
      _this.onChange(time, isFinish, DateTimePickerView$1.MINUTES);
    };

    return _this;
  }

  DateTimePicker.prototype.render = function () {
    var _a = this.state,
        openView = _a.openView,
        meridiemMode = _a.meridiemMode;
    var _b = this.props,
        date = _b.date,
        minDate = _b.minDate,
        maxDate = _b.maxDate,
        showTabs = _b.showTabs,
        disablePast = _b.disablePast,
        disableFuture = _b.disableFuture,
        leftArrowIcon = _b.leftArrowIcon,
        rightArrowIcon = _b.rightArrowIcon,
        dateRangeIcon = _b.dateRangeIcon,
        timeIcon = _b.timeIcon,
        renderDay = _b.renderDay,
        ampm = _b.ampm,
        shouldDisableDate = _b.shouldDisableDate,
        animateYearScrolling = _b.animateYearScrolling,
        classes = _b.classes,
        allowKeyboardControl = _b.allowKeyboardControl,
        ViewContainerComponent = _b.ViewContainerComponent;
    var Container = ViewContainerComponent;
    var ViewContainerComponentProps = typeof ViewContainerComponent === 'string' ? {} : {
      openView: openView,
      onChange: this.onChange
    };
    return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"], null, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(DatetimePickerHeader, {
      date: date,
      openView: openView,
      meridiemMode: meridiemMode,
      setMeridiemMode: this.setMeridiemMode,
      onOpenViewChange: this.handleViewChange,
      ampm: ampm
    }), showTabs && Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(DateTimePickerTabs$1, {
      view: openView,
      onChange: this.handleViewChange,
      dateRangeIcon: dateRangeIcon,
      timeIcon: timeIcon
    }), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(Container, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({
      className: classes.viewContainer
    }, ViewContainerComponentProps), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(View, {
      selected: openView === DateTimePickerView$1.YEAR
    }, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(YearSelection$1, {
      date: date,
      minDate: minDate,
      maxDate: maxDate,
      onChange: this.handleYearChange,
      disablePast: disablePast,
      disableFuture: disableFuture,
      animateYearScrolling: animateYearScrolling
    })), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(View, {
      selected: openView === DateTimePickerView$1.DATE
    }, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(Calendar$1, {
      allowKeyboardControl: allowKeyboardControl,
      date: date,
      minDate: minDate,
      maxDate: maxDate,
      onChange: this.handleDayChange,
      disablePast: disablePast,
      disableFuture: disableFuture,
      leftArrowIcon: leftArrowIcon,
      rightArrowIcon: rightArrowIcon,
      renderDay: renderDay,
      shouldDisableDate: shouldDisableDate
    })), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(View, {
      selected: openView === DateTimePickerView$1.HOUR || openView === DateTimePickerView$1.MINUTES
    }, Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(TimePickerView$1, {
      date: date,
      type: openView,
      onHourChange: this.handleHourChange,
      onMinutesChange: this.handleChange,
      onSecondsChange: this.handleChange,
      ampm: ampm
    }))));
  };

   false ? DateTimePicker.propTypes = {
    allowKeyboardControl: bool,
    ampm: bool,
    animateYearScrolling: bool,
    autoSubmit: bool,
    classes: object.isRequired,
    date: object.isRequired,
    initialFocusedDate: any,
    innerRef: any,
    dateRangeIcon: node,
    disableFuture: bool,
    disablePast: bool,
    leftArrowIcon: node,
    maxDate: DomainPropTypes.date.isRequired,
    minDate: DomainPropTypes.date.isRequired,
    onChange: func.isRequired,
    openTo: oneOf(Object.keys(DateTimePickerView$1).map(function (key) {
      return DateTimePickerView$1[key];
    })).isRequired,
    renderDay: func,
    rightArrowIcon: node,
    shouldDisableDate: func,
    showTabs: bool,
    timeIcon: node,
    utils: object.isRequired,
    ViewContainerComponent: oneOfType([string, func, object])
  } : void 0;
  DateTimePicker.defaultProps = {
    allowKeyboardControl: false,
    ampm: true,
    animateYearScrolling: false,
    autoSubmit: true,
    dateRangeIcon: undefined,
    disableFuture: false,
    disablePast: false,
    leftArrowIcon: undefined,
    renderDay: undefined,
    rightArrowIcon: undefined,
    shouldDisableDate: undefined,
    showTabs: true,
    timeIcon: undefined,
    ViewContainerComponent: 'div'
  };
  return DateTimePicker;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);
var styles$h = __WEBPACK_IMPORTED_MODULE_16__material_ui_core_styles_createStyles___default()({
  viewContainer: {
    minHeight: 300,
    position: 'relative'
  }
});
var DateTimePicker$1 = __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles_withStyles___default()(styles$h, {
  name: 'MuiPickersDateTimePicker'
})(withUtils()(DateTimePicker));

var DateTimePickerModal = function (props) {
  var value = props.value,
      format = props.format,
      autoOk = props.autoOk,
      openTo = props.openTo,
      minDate = props.minDate,
      maxDate = props.maxDate,
      initialFocusedDate = props.initialFocusedDate,
      showTabs = props.showTabs,
      autoSubmit = props.autoSubmit,
      disablePast = props.disablePast,
      disableFuture = props.disableFuture,
      leftArrowIcon = props.leftArrowIcon,
      rightArrowIcon = props.rightArrowIcon,
      dateRangeIcon = props.dateRangeIcon,
      timeIcon = props.timeIcon,
      renderDay = props.renderDay,
      ampm = props.ampm,
      shouldDisableDate = props.shouldDisableDate,
      animateYearScrolling = props.animateYearScrolling,
      forwardedRef = props.forwardedRef,
      allowKeyboardControl = props.allowKeyboardControl,
      other = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __rest */])(props, ["value", "format", "autoOk", "openTo", "minDate", "maxDate", "initialFocusedDate", "showTabs", "autoSubmit", "disablePast", "disableFuture", "leftArrowIcon", "rightArrowIcon", "dateRangeIcon", "timeIcon", "renderDay", "ampm", "shouldDisableDate", "animateYearScrolling", "forwardedRef", "allowKeyboardControl"]);

  return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(BasePicker$1, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props), function (_a) {
    var date = _a.date,
        utils = _a.utils,
        handleAccept = _a.handleAccept,
        handleChange = _a.handleChange,
        handleClear = _a.handleClear,
        handleDismiss = _a.handleDismiss,
        handleSetTodayDate = _a.handleSetTodayDate,
        handleTextFieldChange = _a.handleTextFieldChange,
        isAccepted = _a.isAccepted,
        pick12hOr24hFormat = _a.pick12hOr24hFormat;
    return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(ModalWrapper, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({
      ref: forwardedRef,
      disableFuture: disableFuture,
      disablePast: disablePast,
      maxDate: maxDate,
      minDate: minDate,
      onAccept: handleAccept,
      onChange: handleTextFieldChange,
      onClear: handleClear,
      onDismiss: handleDismiss,
      onSetToday: handleSetTodayDate,
      value: value,
      isAccepted: isAccepted,
      format: pick12hOr24hFormat(utils.dateTime12hFormat, utils.dateTime24hFormat)
    }, other), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(DateTimePicker$1, {
      allowKeyboardControl: allowKeyboardControl,
      ampm: ampm,
      animateYearScrolling: animateYearScrolling,
      autoSubmit: autoSubmit,
      date: date,
      dateRangeIcon: dateRangeIcon,
      disableFuture: disableFuture,
      disablePast: disablePast,
      leftArrowIcon: leftArrowIcon,
      maxDate: maxDate,
      minDate: minDate,
      onChange: handleChange,
      openTo: openTo,
      renderDay: renderDay,
      rightArrowIcon: rightArrowIcon,
      shouldDisableDate: shouldDisableDate,
      showTabs: showTabs,
      timeIcon: timeIcon
    }));
  });
};
 false ? DateTimePickerModal.propTypes = {
  /** Date-time picker value */
  value: DomainPropTypes.date,

  /** Date format string for input */
  format: string,

  /** Callback firing when date accepted [(date: Date) => void] */
  onChange: func.isRequired,

  /** Auto accept date on minute selection */
  autoOk: bool,

  /** Move to the next part of date on select (year -> date -> hour -> minute) */
  autoSubmit: bool,

  /** Disable future dates */
  disableFuture: bool,

  /** Disable past dates */
  disablePast: bool,

  /** Min selectable date */
  minDate: DomainPropTypes.date,

  /** Max selectable date */
  maxDate: DomainPropTypes.date,

  /** Initial focused date when calendar opens, if no value is provided */
  initialFocusedDate: DomainPropTypes.date,

  /** Show date/time tabs */
  showTabs: bool,

  /** Left arrow icon */
  leftArrowIcon: node,

  /** Right arrow icon */
  rightArrowIcon: node,

  /** Date tab icon */
  dateRangeIcon: node,

  /** Time tab icon */
  timeIcon: node,

  /**
   * Custom renderer for day
   * [(date: Date, nowSelectedDate: Date, isInCurrentMonth: boolean) => ReactElement]
   */
  renderDay: func,

  /** 12h/24h view for hour selection clock */
  ampm: bool,

  /** Disable specific date [(date: Date) => boolean] */
  shouldDisableDate: func,

  /** Enable animated scrolling to current year */
  animateYearScrolling: bool,

  /** Open directly to particular view */
  openTo: oneOf(['year', 'date', 'hour', 'minutes']),

  /** Enables keyboard listener for moving between days in calendar */
  allowKeyboardControl: bool,
  forwardedRef: oneOfType([func, object])
} : void 0;
DateTimePickerModal.defaultProps = {
  value: new Date(),
  format: undefined,
  autoOk: false,
  autoSubmit: true,
  openTo: 'date',
  disableFuture: false,
  disablePast: false,
  minDate: '1900-01-01',
  maxDate: '2100-01-01',
  initialFocusedDate: undefined,
  showTabs: true,
  leftArrowIcon: 'keyboard_arrow_left',
  rightArrowIcon: 'keyboard_arrow_right',
  dateRangeIcon: 'date_range',
  timeIcon: 'access_time',
  renderDay: undefined,
  ampm: true,
  shouldDisableDate: undefined,
  animateYearScrolling: false,
  forwardedRef: undefined,
  allowKeyboardControl: true
};
var DateTimePickerModal$1 = Object(__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"])(function (props, ref) {
  return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(DateTimePickerModal, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props, {
    forwardedRef: ref
  }));
});

var DateTimePickerInline = function (props) {
  var value = props.value,
      format = props.format,
      autoOk = props.autoOk,
      openTo = props.openTo,
      minDate = props.minDate,
      maxDate = props.maxDate,
      initialFocusedDate = props.initialFocusedDate,
      showTabs = props.showTabs,
      autoSubmit = props.autoSubmit,
      disablePast = props.disablePast,
      disableFuture = props.disableFuture,
      leftArrowIcon = props.leftArrowIcon,
      rightArrowIcon = props.rightArrowIcon,
      dateRangeIcon = props.dateRangeIcon,
      timeIcon = props.timeIcon,
      renderDay = props.renderDay,
      ampm = props.ampm,
      shouldDisableDate = props.shouldDisableDate,
      animateYearScrolling = props.animateYearScrolling,
      forwardedRef = props.forwardedRef,
      allowKeyboardControl = props.allowKeyboardControl,
      other = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __rest */])(props, ["value", "format", "autoOk", "openTo", "minDate", "maxDate", "initialFocusedDate", "showTabs", "autoSubmit", "disablePast", "disableFuture", "leftArrowIcon", "rightArrowIcon", "dateRangeIcon", "timeIcon", "renderDay", "ampm", "shouldDisableDate", "animateYearScrolling", "forwardedRef", "allowKeyboardControl"]);

  return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(BasePicker$1, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props, {
    autoOk: true
  }), function (_a) {
    var date = _a.date,
        utils = _a.utils,
        handleChange = _a.handleChange,
        handleTextFieldChange = _a.handleTextFieldChange,
        isAccepted = _a.isAccepted,
        pick12hOr24hFormat = _a.pick12hOr24hFormat,
        handleAccept = _a.handleAccept;
    return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(InlineWrapper$1, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({
      innerRef: forwardedRef,
      disableFuture: disableFuture,
      disablePast: disablePast,
      maxDate: maxDate,
      minDate: minDate,
      onChange: handleTextFieldChange,
      value: value,
      isAccepted: isAccepted,
      handleAccept: handleAccept,
      format: pick12hOr24hFormat(utils.dateTime12hFormat, utils.dateTime24hFormat)
    }, other), Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(DateTimePicker$1, {
      allowKeyboardControl: allowKeyboardControl,
      ampm: ampm,
      animateYearScrolling: animateYearScrolling,
      autoSubmit: autoSubmit,
      date: date,
      dateRangeIcon: dateRangeIcon,
      disableFuture: disableFuture,
      disablePast: disablePast,
      leftArrowIcon: leftArrowIcon,
      maxDate: maxDate,
      minDate: minDate,
      onChange: handleChange,
      openTo: openTo,
      renderDay: renderDay,
      rightArrowIcon: rightArrowIcon,
      shouldDisableDate: shouldDisableDate,
      showTabs: showTabs,
      timeIcon: timeIcon
    }));
  });
};
 false ? DateTimePickerInline.propTypes = {
  value: DomainPropTypes.date,
  format: string,
  onChange: func.isRequired,
  autoOk: bool,
  autoSubmit: bool,
  disableFuture: bool,
  disablePast: bool,
  minDate: DomainPropTypes.date,
  maxDate: DomainPropTypes.date,
  initialFocusedDate: DomainPropTypes.date,
  showTabs: bool,
  leftArrowIcon: node,
  rightArrowIcon: node,
  dateRangeIcon: node,
  timeIcon: node,
  renderDay: func,
  ampm: bool,
  shouldDisableDate: func,
  animateYearScrolling: bool,
  openTo: oneOf(['year', 'date', 'hour', 'minutes']),
  allowKeyboardControl: bool,
  forwardedRef: oneOfType([func, object])
} : void 0;
DateTimePickerInline.defaultProps = {
  value: new Date(),
  format: undefined,
  autoOk: false,
  autoSubmit: true,
  openTo: 'date',
  disableFuture: false,
  disablePast: false,
  minDate: '1900-01-01',
  maxDate: '2100-01-01',
  initialFocusedDate: undefined,
  showTabs: true,
  leftArrowIcon: 'keyboard_arrow_left',
  rightArrowIcon: 'keyboard_arrow_right',
  dateRangeIcon: 'date_range',
  timeIcon: 'access_time',
  renderDay: undefined,
  ampm: true,
  shouldDisableDate: undefined,
  animateYearScrolling: false,
  forwardedRef: undefined,
  allowKeyboardControl: true
};
var DateTimePickerInline$1 = Object(__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"])(function (props, ref) {
  return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(DateTimePickerInline, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props, {
    forwardedRef: ref
  }));
});


//# sourceMappingURL=material-ui-pickers.esm.js.map


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Checkbox.default;
  }
});

var _Checkbox = _interopRequireDefault(__webpack_require__(916));

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _CardHeader.default;
  }
});

var _CardHeader = _interopRequireDefault(__webpack_require__(1001));

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DISCRETE_COLOR_RANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return EXTENDED_DISCRETE_COLOR_RANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONTINUOUS_COLOR_RANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SIZE_RANGE; });
/* unused harmony export OPACITY_RANGE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return OPACITY_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DEFAULT_OPACITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DEFAULT_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_COLOR; });
/* unused harmony export DEFAULT_TICK_SIZE */
// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

var DISCRETE_COLOR_RANGE = ['#12939A', '#79C7E3', '#1A3177', '#FF9833', '#EF5D28'];

var EXTENDED_DISCRETE_COLOR_RANGE = ['#19CDD7', '#DDB27C', '#88572C', '#FF991F', '#F15C17', '#223F9A', '#DA70BF', '#125C77', '#4DC19C', '#776E57', '#12939A', '#17B8BE', '#F6D18A', '#B7885E', '#FFCB99', '#F89570', '#829AE3', '#E79FD5', '#1E96BE', '#89DAC1', '#B3AD9E'];

var CONTINUOUS_COLOR_RANGE = ['#EF5D28', '#FF9833'];

var SIZE_RANGE = [1, 10];

var OPACITY_RANGE = [0.1, 1];
var OPACITY_TYPE = 'literal';
var DEFAULT_OPACITY = 1;

var DEFAULT_SIZE = 5;

var DEFAULT_COLOR = DISCRETE_COLOR_RANGE[0];

var DEFAULT_TICK_SIZE = 7;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(672);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ConfirmationalDialog;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Dialog__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_DialogActions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_DialogContent__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogContentText__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogContentText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogContentText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogTitle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
function ConfirmationalDialog(props){var isDialogOpen=props.isDialogOpen,dialogTitle=props.dialogTitle,dialogMessage=props.dialogMessage,positiveResponseButtonText=props.positiveResponseButtonText,negativeResponseButtonText=props.negativeResponseButtonText,positiveResponseHandler=props.positiveResponseHandler,negativeResponseHandler=props.negativeResponseHandler,dialogCloseHandler=props.dialogCloseHandler,isSaveBtnDisabled=props.isSaveBtnDisabled;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Dialog___default.a,{open:isDialogOpen,onEscapeKeyDown:dialogCloseHandler||negativeResponseHandler,onBackdropClick:dialogCloseHandler||negativeResponseHandler},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogTitle___default.a,null,dialogTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogContentText___default.a,null,dialogMessage)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_DialogActions___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button___default.a,{color:'secondary',onClick:negativeResponseHandler},negativeResponseButtonText),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button___default.a,{color:'secondary',onClick:positiveResponseHandler,disabled:isSaveBtnDisabled},positiveResponseButtonText)));}ConfirmationalDialog.defaultProps={dialogTitle:'Confirmation',dialogMessage:'Are you sure you want to continue?',negativeResponseButtonText:'No',positiveResponseButtonText:'Yes'};ConfirmationalDialog.propTypes={isDialogOpen:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool.isRequired,dialogTitle:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,dialogMessage:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,positiveResponseButtonText:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,negativeResponseButtonText:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,positiveResponseHandler:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,negativeResponseHandler:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,dialogCloseHandler:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func};

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isSeriesChild */
/* harmony export (immutable) */ __webpack_exports__["c"] = getSeriesChildren;
/* harmony export (immutable) */ __webpack_exports__["f"] = getStackedData;
/* harmony export (immutable) */ __webpack_exports__["d"] = getSeriesPropsFromChildren;
/* harmony export (immutable) */ __webpack_exports__["b"] = getRadialDomain;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ANIMATED_SERIES_PROPS; });
/* harmony export (immutable) */ __webpack_exports__["e"] = getStackParams;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plot_series_abstract_series__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__theme__ = __webpack_require__(63);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.






/**
 * Check if the component is series or not.
 * @param {React.Component} child Component.
 * @returns {boolean} True if the child is series, false otherwise.
 */
function isSeriesChild(child) {
  var prototype = child.type.prototype;

  return prototype instanceof __WEBPACK_IMPORTED_MODULE_1__plot_series_abstract_series__["a" /* default */];
}

/**
 * Get all series from the 'children' object of the component.
 * @param {Object} children Children.
 * @returns {Array} Array of children.
 */
function getSeriesChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.toArray(children).filter(function (child) {
    return child && isSeriesChild(child);
  });
}

/**
 * Collect the map of repetitions of the series type for all children.
 * @param {Array} children Array of children.
 * @returns {{}} Map of repetitions where sameTypeTotal is the total amount and
 * sameTypeIndex is always 0.
 */
function collectSeriesTypesInfo(children) {
  var result = {};
  children.filter(isSeriesChild).forEach(function (child) {
    var displayName = child.type.displayName;
    var cluster = child.props.cluster;

    if (!result[displayName]) {
      result[displayName] = {
        sameTypeTotal: 0,
        sameTypeIndex: 0,
        clusters: new Set()
      };
    }
    result[displayName].clusters.add(cluster);
    result[displayName].sameTypeTotal++;
  });
  return result;
}

/**
 * Check series to see if it has angular data that needs to be converted
 * @param {Array} data - an array of objects to check
 * @returns {Boolean} whether or not this series contains polar configuration
 */
function seriesHasAngleRadius() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  if (!data) {
    return false;
  }
  return data.some(function (row) {
    return row.radius && row.angle;
  });
}

/**
 * Possibly convert polar coordinates to x/y for computing domain
 * @param {Array} data - an array of objects to check
 * @param {String} attr - the property being checked
 * @returns {Boolean} whether or not this series contains polar configuration
 */
function prepareData(data) {
  if (!seriesHasAngleRadius(data)) {
    return data;
  }

  return data.map(function (row) {
    return _extends({}, row, {
      x: row.radius * Math.cos(row.angle),
      y: row.radius * Math.sin(row.angle)
    });
  });
}

/**
 * Collect the stacked data for all children in use. If the children don't have
 * the data (e.g. the child is invalid series or something else), then the child
 * is skipped.
 * Each next value of attr is equal to the previous value plus the difference
 * between attr0 and attr.
 * @param {Array} children Array of children.
 * @param {string} attr Attribute to stack by.
 * @returns {Array} New array of children for the series.
 */
function getStackedData(children, attr) {
  var areSomeSeriesStacked = children.some(function (series) {
    return series && series.props.stack;
  });
  // It stores the last segment position added to each bar, separated by cluster.
  var latestAttrPositions = {};

  return children.reduce(function (accumulator, series, seriesIndex) {
    // Skip the children that are not series (e.g. don't have any data).
    if (!series) {
      accumulator.push(null);
      return accumulator;
    }
    var seriesType = series.type.displayName;

    var _series$props = series.props,
        data = _series$props.data,
        _series$props$cluster = _series$props.cluster,
        cluster = _series$props$cluster === undefined ? 'default' : _series$props$cluster,
        stack = _series$props.stack;

    var preppedData = prepareData(data, attr);

    if (!attr || !preppedData || !preppedData.length || areSomeSeriesStacked && !stack) {
      accumulator.push(preppedData);
      return accumulator;
    }

    var attr0 = attr + '0';
    var baseAttr = attr === 'y' ? 'x' : 'y';

    accumulator.push(preppedData.map(function (d, dIndex) {
      var _extends2, _latestAttrPositions$2;

      if (!latestAttrPositions[cluster]) {
        latestAttrPositions[cluster] = {};
      }
      if (!latestAttrPositions[cluster][seriesType]) {
        latestAttrPositions[cluster][seriesType] = {};
      }

      var prevD = latestAttrPositions[cluster][seriesType][d[baseAttr]];
      // It is the first segment of a bar.
      if (!prevD) {
        var _latestAttrPositions$;

        latestAttrPositions[cluster][seriesType][d[baseAttr]] = (_latestAttrPositions$ = {}, _defineProperty(_latestAttrPositions$, attr0, d[attr0]), _defineProperty(_latestAttrPositions$, attr, d[attr]), _latestAttrPositions$);

        return _extends({}, d);
      }

      // Calculate the position of the next segment in a bar.
      var nextD = _extends({}, d, (_extends2 = {}, _defineProperty(_extends2, attr0, prevD[attr]), _defineProperty(_extends2, attr, prevD[attr] + d[attr] - (d[attr0] || 0)), _extends2));

      latestAttrPositions[cluster][seriesType][d[baseAttr]] = (_latestAttrPositions$2 = {}, _defineProperty(_latestAttrPositions$2, attr0, nextD[attr0]), _defineProperty(_latestAttrPositions$2, attr, nextD[attr]), _latestAttrPositions$2);

      return nextD;
    }));

    return accumulator;
  }, []);
}

/**
 * Get the list of series props for a child.
 * @param {Array} children Array of all children.
 * @returns {Array} Array of series props for each child. If a child is not a
 * series, than it's undefined.
 */
function getSeriesPropsFromChildren(children) {
  var result = [];
  var seriesTypesInfo = collectSeriesTypesInfo(children);
  var seriesIndex = 0;
  var _opacityValue = __WEBPACK_IMPORTED_MODULE_2__theme__["c" /* DEFAULT_OPACITY */];
  children.forEach(function (child) {
    var props = void 0;
    if (isSeriesChild(child)) {
      var seriesTypeInfo = seriesTypesInfo[child.type.displayName];
      var _colorValue = __WEBPACK_IMPORTED_MODULE_2__theme__["e" /* DISCRETE_COLOR_RANGE */][seriesIndex % __WEBPACK_IMPORTED_MODULE_2__theme__["e" /* DISCRETE_COLOR_RANGE */].length];
      props = _extends({}, seriesTypeInfo, {
        seriesIndex: seriesIndex,
        _colorValue: _colorValue,
        _opacityValue: _opacityValue
      });
      seriesTypeInfo.sameTypeIndex++;
      seriesIndex++;
      if (child.props.cluster) {
        props.cluster = child.props.cluster;
        // Using Array.from() so we can use .indexOf
        props.clusters = Array.from(seriesTypeInfo.clusters);
        props.sameTypeTotal = props.clusters.length;
        props.sameTypeIndex = props.clusters.indexOf(child.props.cluster);
      }
    }
    result.push(props);
  });
  return result;
}

/**
 * Find the max radius value from the nodes to be rendered after they have been
 * transformed into an array
 * @param {Array} data - the tree data after it has been broken into a iterable
 * it is an array of objects!
 * @returns {number} the maximum value in coordinates for the radial variable
 */
function getRadialDomain(data) {
  return data.reduce(function (res, row) {
    return Math.max(row.radius, res);
  }, 0);
}

var ANIMATED_SERIES_PROPS = ['xRange', 'xDomain', 'x', 'yRange', 'yDomain', 'y', 'colorRange', 'colorDomain', 'color', 'opacityRange', 'opacityDomain', 'opacity', 'strokeRange', 'strokeDomain', 'stroke', 'fillRange', 'fillDomain', 'fill', 'width', 'height', 'marginLeft', 'marginTop', 'marginRight', 'marginBottom', 'data', 'angleDomain', 'angleRange', 'angle', 'radiusDomain', 'radiusRange', 'radius', 'innerRadiusDomain', 'innerRadiusRange', 'innerRadius'];

function getStackParams(props) {
  var _stackBy = props._stackBy,
      valuePosAttr = props.valuePosAttr,
      cluster = props.cluster;
  var _props$sameTypeTotal = props.sameTypeTotal,
      sameTypeTotal = _props$sameTypeTotal === undefined ? 1 : _props$sameTypeTotal,
      _props$sameTypeIndex = props.sameTypeIndex,
      sameTypeIndex = _props$sameTypeIndex === undefined ? 0 : _props$sameTypeIndex;

  // If bars are stacked, but not clustering, override `sameTypeTotal` and
  // `sameTypeIndex` such that bars are stacked and not staggered.

  if (_stackBy === valuePosAttr && !cluster) {
    sameTypeTotal = 1;
    sameTypeIndex = 0;
  }
  return { sameTypeTotal: sameTypeTotal, sameTypeIndex: sameTypeIndex };
}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function getAccountType(){return localStorage.getItem('Account_type');}/* harmony default export */ __webpack_exports__["a"] = (getAccountType);

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export _getSmallestDistanceIndex */
/* unused harmony export getScaleFnFromScaleObject */
/* unused harmony export getDomainByAccessor */
/* unused harmony export _getScaleDistanceAndAdjustedDomain */
/* unused harmony export _adjustCategoricalScale */
/* harmony export (immutable) */ __webpack_exports__["i"] = getScaleObjectFromProps;
/* harmony export (immutable) */ __webpack_exports__["d"] = getAttributeScale;
/* harmony export (immutable) */ __webpack_exports__["c"] = getAttributeFunctor;
/* harmony export (immutable) */ __webpack_exports__["b"] = getAttr0Functor;
/* harmony export (immutable) */ __webpack_exports__["e"] = getAttributeValue;
/* harmony export (immutable) */ __webpack_exports__["j"] = getScalePropTypesByAttribute;
/* harmony export (immutable) */ __webpack_exports__["a"] = extractScalePropsFromProps;
/* harmony export (immutable) */ __webpack_exports__["g"] = getMissingScaleProps;
/* unused harmony export literalScale */
/* harmony export (immutable) */ __webpack_exports__["f"] = getFontColorFromBackground;
/* harmony export (immutable) */ __webpack_exports__["k"] = getXYPlotValues;
/* harmony export (immutable) */ __webpack_exports__["h"] = getOptionalScaleProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_scale__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_array__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_collection__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_color__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__react_utils__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_utils__ = __webpack_require__(355);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _SCALE_FUNCTIONS;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.











/**
 * Linear scale name.
 * @type {string}
 * @const
 */
var LINEAR_SCALE_TYPE = 'linear';

/**
 * Ordinal scale name.
 * @type {string}
 * @const
 */
var ORDINAL_SCALE_TYPE = 'ordinal';

/**
 * Category scale.
 * @type {string}
 * @const
 */
var CATEGORY_SCALE_TYPE = 'category';

/**
 * Literal scale.
 * Differs slightly from d3's identity scale in that it does not coerce value
 * into numbers, it simply returns exactly what you give it
 * @type {string}
 * @const
 */
var LITERAL_SCALE_TYPE = 'literal';

/**
 * Log scale name.
 * @type {string}
 * @const
 */
var LOG_SCALE_TYPE = 'log';

/**
 * Time scale name.
 * @type {string}
 * @const
 */
var TIME_SCALE_TYPE = 'time';

/**
 * Time UTC scale name.
 * @type {string}
 * @const
 */
var TIME_UTC_SCALE_TYPE = 'time-utc';

/**
 * Scale functions that are supported in the library.
 * @type {Object}
 * @const
 */
var SCALE_FUNCTIONS = (_SCALE_FUNCTIONS = {}, _defineProperty(_SCALE_FUNCTIONS, LINEAR_SCALE_TYPE, __WEBPACK_IMPORTED_MODULE_0_d3_scale__["a" /* scaleLinear */]), _defineProperty(_SCALE_FUNCTIONS, ORDINAL_SCALE_TYPE, __WEBPACK_IMPORTED_MODULE_0_d3_scale__["d" /* scalePoint */]), _defineProperty(_SCALE_FUNCTIONS, CATEGORY_SCALE_TYPE, __WEBPACK_IMPORTED_MODULE_0_d3_scale__["c" /* scaleOrdinal */]), _defineProperty(_SCALE_FUNCTIONS, LITERAL_SCALE_TYPE, literalScale), _defineProperty(_SCALE_FUNCTIONS, LOG_SCALE_TYPE, __WEBPACK_IMPORTED_MODULE_0_d3_scale__["b" /* scaleLog */]), _defineProperty(_SCALE_FUNCTIONS, TIME_SCALE_TYPE, __WEBPACK_IMPORTED_MODULE_0_d3_scale__["f" /* scaleTime */]), _defineProperty(_SCALE_FUNCTIONS, TIME_UTC_SCALE_TYPE, __WEBPACK_IMPORTED_MODULE_0_d3_scale__["g" /* scaleUtc */]), _SCALE_FUNCTIONS);

/**
 * Attrs for which a scale can be set up at XYPlot level
 * @type {Array}
 * @const
 */

var XYPLOT_ATTR = ['color', 'fill', 'opacity', 'stroke'];

/**
 * Title case a given string
 * @param {String} str Array of values.
 * @returns {String} titlecased string
 */
function toTitleCase(str) {
  return '' + str[0].toUpperCase() + str.slice(1);
}

/**
 * Find the smallest distance between the values on a given scale and return
 * the index of the element, where the smallest distance was found.
 * It returns the first occurrence of i where
 * `scale(value[i]) - scale(value[i - 1])` is minimal
 * @param {Array} values Array of values.
 * @param {Object} scaleObject Scale object.
 * @returns {number} Index of an element where the smallest distance was found.
 * @private
 */
function _getSmallestDistanceIndex(values, scaleObject) {
  var scaleFn = getScaleFnFromScaleObject(scaleObject);
  var result = 0;
  if (scaleFn) {
    var nextValue = void 0;
    var currentValue = scaleFn(values[0]);
    var distance = Infinity;
    var nextDistance = void 0;

    for (var i = 1; i < values.length; i++) {
      nextValue = scaleFn(values[i]);
      nextDistance = Math.abs(nextValue - currentValue);
      if (nextDistance < distance) {
        distance = nextDistance;
        result = i;
      }
      currentValue = nextValue;
    }
  }
  return result;
}

/**
 * This is a workaround for issue that ordinal scale
 * does not have invert method implemented in d3-scale.
 * @param {Object} Ordinal d3-scale object.
 * @returns {void}
 * @private
 */

function addInvertFunctionToOrdinalScaleObject(scale) {
  if (scale.invert) {
    return;
  }

  scale.invert = function invert(value) {
    var _scale$range = scale.range(),
        _scale$range2 = _slicedToArray(_scale$range, 2),
        lower = _scale$range2[0],
        upper = _scale$range2[1];

    var start = Math.min(lower, upper);
    var stop = Math.max(lower, upper);

    if (value < start + scale.padding() * scale.step()) {
      return scale.domain()[0];
    }

    if (value > stop - scale.padding() * scale.step()) {
      return scale.domain()[scale.domain().length - 1];
    }

    var index = Math.floor((value - start - scale.padding() * scale.step()) / scale.step());
    return scale.domain()[index];
  };
}

/**
 * Crate a scale function from the scale object.
 * @param {Object} scaleObject Scale object.
 - scaleObject.domain {Array}
 - scaleObject.range {Array}
 - scaleObject.type {string}
 - scaleObject.attr {string}
 * @returns {*} Scale function.
 * @private
 */
function getScaleFnFromScaleObject(scaleObject) {
  if (!scaleObject) {
    return null;
  }
  var type = scaleObject.type,
      domain = scaleObject.domain,
      range = scaleObject.range;

  var modDomain = domain[0] === domain[1] ? domain[0] === 0 ? [-1, 0] : [-domain[0], domain[0]] : domain;
  if (type === LITERAL_SCALE_TYPE) {
    return literalScale(range[0]);
  }
  var scale = SCALE_FUNCTIONS[type]().domain(modDomain).range(range);
  if (type === ORDINAL_SCALE_TYPE) {
    scale.padding(0.5);
    addInvertFunctionToOrdinalScaleObject(scale);
  }
  return scale;
}

/**
 * Get the domain from the array of data.
 * @param {Array} allData All data.
 * @param {function} accessor - accessor for main value.
 * @param {function} accessor0 - accessor for the naught value.
 * @param {string} type Scale type.
 * @returns {Array} Domain.
 * @private
 */
function getDomainByAccessor(allData, accessor, accessor0, type) {
  var domain = void 0;

  // Collect both attr and available attr0 values from the array of data.
  var values = allData.reduce(function (data, d) {
    var value = accessor(d);
    var value0 = accessor0(d);
    if (_isDefined(value)) {
      data.push(value);
    }
    if (_isDefined(value0)) {
      data.push(value0);
    }
    return data;
  }, []);

  if (!values.length) {
    return [];
  }

  // Create proper domain depending on the type of the scale.
  if (type !== ORDINAL_SCALE_TYPE && type !== CATEGORY_SCALE_TYPE) {
    domain = Object(__WEBPACK_IMPORTED_MODULE_1_d3_array__["d" /* extent */])(values);
  } else {
    domain = Object(__WEBPACK_IMPORTED_MODULE_2_d3_collection__["c" /* set */])(values).values();
  }
  return domain;
}

/**
 * Create custom scale object from the value. When the scale is created from
 * this object, it should return the same value all time.
 * @param {string} attr Attribute.
 * @param {*} value Value.
 * @param {string} type - the type of scale being used
 * @param {function} accessor - the accessor function
 * @param {function} accessor0 - the accessor function for the potential naught value
 * @returns {Object} Custom scale object.
 * @private
 */
function _createScaleObjectForValue(attr, value, type, accessor, accessor0) {
  if (type === LITERAL_SCALE_TYPE) {
    return {
      type: LITERAL_SCALE_TYPE,
      domain: [],
      range: [value],
      distance: 0,
      attr: attr,
      baseValue: undefined,
      isValue: true,
      accessor: accessor,
      accessor0: accessor0
    };
  }
  if (typeof value === 'undefined') {
    return null;
  }
  return {
    type: CATEGORY_SCALE_TYPE,
    range: [value],
    domain: [],
    distance: 0,
    attr: attr,
    baseValue: undefined,
    isValue: true,
    accessor: accessor,
    accessor0: accessor0
  };
}

/**
 * Create a regular scale object for a further use from the existing parameters.
 * @param {Array} domain - Domain.
 * @param {Array} range - Range.
 * @param {string} type - Type.
 * @param {number} distance - Distance.
 * @param {string} attr - Attribute.
 * @param {number} baseValue - Base value.
 * @param {function} accessor - Attribute accesor
 * @param {function} accessor0 - Attribute accesor for potential naught value
 * @returns {Object} Scale object.
 * @private
 */
function _createScaleObjectForFunction(_ref) {
  var domain = _ref.domain,
      range = _ref.range,
      type = _ref.type,
      distance = _ref.distance,
      attr = _ref.attr,
      baseValue = _ref.baseValue,
      accessor = _ref.accessor,
      accessor0 = _ref.accessor0;

  return {
    domain: domain,
    range: range,
    type: type,
    distance: distance,
    attr: attr,
    baseValue: baseValue,
    isValue: false,
    accessor: accessor,
    accessor0: accessor0
  };
}

/**
 * Get scale object from props. E. g. object like {xRange, xDomain, xDistance,
 * xType} is transformed into {range, domain, distance, type}.
 * @param {Object} props Props.
 * @param {string} attr Attribute.
 * @returns {*} Null or an object with the scale.
 * @private
 */
function _collectScaleObjectFromProps(props, attr) {
  var value = props[attr],
      fallbackValue = props['_' + attr + 'Value'],
      range = props[attr + 'Range'],
      _props$ = props[attr + 'Distance'],
      distance = _props$ === undefined ? 0 : _props$,
      baseValue = props[attr + 'BaseValue'],
      _props$2 = props[attr + 'Type'],
      type = _props$2 === undefined ? LINEAR_SCALE_TYPE : _props$2,
      noFallBack = props[attr + 'NoFallBack'],
      _props$3 = props['get' + toTitleCase(attr)],
      accessor = _props$3 === undefined ? function (d) {
    return d[attr];
  } : _props$3,
      _props$4 = props['get' + toTitleCase(attr) + '0'],
      accessor0 = _props$4 === undefined ? function (d) {
    return d[attr + '0'];
  } : _props$4;
  var domain = props[attr + 'Domain'];
  // Return value-based scale if the value is assigned.

  if (!noFallBack && typeof value !== 'undefined') {
    return _createScaleObjectForValue(attr, value, props[attr + 'Type'], accessor, accessor0);
  }
  // Pick up the domain from the properties and create a new one if it's not
  // available.
  if (typeof baseValue !== 'undefined') {
    domain = Object(__WEBPACK_IMPORTED_MODULE_6__data_utils__["a" /* addValueToArray */])(domain, baseValue);
  }

  // Make sure that the minimum necessary properties exist.
  if (!range || !domain || !domain.length) {
    // Try to use the fallback value if it is available.
    return _createScaleObjectForValue(attr, fallbackValue, props[attr + 'Type'], accessor, accessor0);
  }

  return _createScaleObjectForFunction({
    domain: domain,
    range: range,
    type: type,
    distance: distance,
    attr: attr,
    baseValue: baseValue,
    accessor: accessor,
    accessor0: accessor0
  });
}

/**
 * Compute left domain adjustment for the given values.
 * @param {Array} values Array of values.
 * @returns {number} Domain adjustment.
 * @private
 */
function _computeLeftDomainAdjustment(values) {
  if (values.length > 1) {
    return (values[1] - values[0]) / 2;
  }
  if (values.length === 1) {
    return values[0] - 0.5;
  }
  return 0;
}

/**
 * Compute right domain adjustment for the given values.
 * @param {Array} values Array of values.
 * @returns {number} Domain adjustment.
 * @private
 */
function _computeRightDomainAdjustment(values) {
  if (values.length > 1) {
    return (values[values.length - 1] - values[values.length - 2]) / 2;
  }
  if (values.length === 1) {
    return values[0] - 0.5;
  }
  return 0;
}

/**
 * Compute distance for the given values.
 * @param {Array} values Array of values.
 * @param {Array} domain Domain.
 * @param {number} bestDistIndex Index of a best distance found.
 * @param {function} scaleFn Scale function.
 * @returns {number} Domain adjustment.
 * @private
 */
function _computeScaleDistance(values, domain, bestDistIndex, scaleFn) {
  if (values.length > 1) {
    // Avoid zero indexes.
    var i = Math.max(bestDistIndex, 1);
    return Math.abs(scaleFn(values[i]) - scaleFn(values[i - 1]));
  }
  if (values.length === 1) {
    return Math.abs(scaleFn(domain[1]) - scaleFn(domain[0]));
  }
  return 0;
}

/**
 * Normilize array of values with a single value.
 * @param {Array} arr Array of data.
 * @param {Array} values Array of values.
 * @param {string} attr Attribute.
 * @param {string} type Type.
 * @private
 */
function _normalizeValues(data, values, accessor0, type) {
  if (type === TIME_SCALE_TYPE && values.length === 1) {
    var attr0 = accessor0(data[0]);

    return [attr0].concat(_toConsumableArray(values));
  }

  return values;
}

/**
 * Get the distance, the smallest and the largest value of the domain.
 * @param {Array} data Array of data for the single series.
 * @param {Object} scaleObject Scale object.
 * @returns {{domain0: number, domainN: number, distance: number}} Result.
 * @private
 */
function _getScaleDistanceAndAdjustedDomain(data, scaleObject) {
  var domain = scaleObject.domain,
      type = scaleObject.type,
      accessor = scaleObject.accessor,
      accessor0 = scaleObject.accessor0;


  var uniqueValues = Object(__WEBPACK_IMPORTED_MODULE_6__data_utils__["b" /* getUniquePropertyValues */])(data, accessor);

  // Fix time scale if a data has only one value.
  var values = _normalizeValues(data, uniqueValues, accessor0, type);
  var index = _getSmallestDistanceIndex(values, scaleObject);

  var adjustedDomain = [].concat(domain);

  adjustedDomain[0] -= _computeLeftDomainAdjustment(values);
  adjustedDomain[domain.length - 1] += _computeRightDomainAdjustment(values);
  // Fix log scale if it's too small.
  if (type === LOG_SCALE_TYPE && domain[0] <= 0) {
    adjustedDomain[0] = Math.min(domain[1] / 10, 1);
  }

  var adjustedScaleFn = getScaleFnFromScaleObject(_extends({}, scaleObject, {
    domain: adjustedDomain
  }));

  var distance = _computeScaleDistance(values, adjustedDomain, index, adjustedScaleFn);

  return {
    domain0: adjustedDomain[0],
    domainN: adjustedDomain[adjustedDomain.length - 1],
    distance: distance
  };
}

/**
 * Returns true if scale adjustments are possible for a given scale.
 * @param {Object} props Props.
 * @param {Object} scaleObject Scale object.
 * @returns {boolean} True if scale adjustments possible.
 * @private
 */
function _isScaleAdjustmentPossible(props, scaleObject) {
  var attr = scaleObject.attr;
  var _props$_adjustBy = props._adjustBy,
      adjustBy = _props$_adjustBy === undefined ? [] : _props$_adjustBy,
      _props$_adjustWhat = props._adjustWhat,
      adjustWhat = _props$_adjustWhat === undefined ? [] : _props$_adjustWhat;

  // The scale cannot be adjusted if there's no attributes to adjust, no
  // suitable values

  return adjustWhat.length && adjustBy.length && adjustBy.indexOf(attr) !== -1;
}

/**
 * Adjust continuous scales (e.g. 'linear', 'log' and 'time') by adding the
 * space from the left and right of them and by computing the best distance.
 * @param {Object} props Props.
 * @param {Object} scaleObject Scale object.
 * @returns {*} Scale object with adjustments.
 * @private
 */
function _adjustContinuousScale(props, scaleObject) {
  var allSeriesData = props._allData,
      _props$_adjustWhat2 = props._adjustWhat,
      adjustWhat = _props$_adjustWhat2 === undefined ? [] : _props$_adjustWhat2;

  // Assign the initial values.

  var domainLength = scaleObject.domain.length;
  var domain = scaleObject.domain;

  var scaleDomain0 = domain[0];
  var scaleDomainN = domain[domainLength - 1];
  var scaleDistance = scaleObject.distance;

  // Find the smallest left position of the domain, the largest right position
  // of the domain and the best distance for them.
  allSeriesData.forEach(function (data, index) {
    if (adjustWhat.indexOf(index) === -1) {
      return;
    }
    if (data && data.length) {
      var _getScaleDistanceAndA = _getScaleDistanceAndAdjustedDomain(data, scaleObject),
          domain0 = _getScaleDistanceAndA.domain0,
          domainN = _getScaleDistanceAndA.domainN,
          distance = _getScaleDistanceAndA.distance;

      scaleDomain0 = Math.min(scaleDomain0, domain0);
      scaleDomainN = Math.max(scaleDomainN, domainN);
      scaleDistance = Math.max(scaleDistance, distance);
    }
  });

  scaleObject.domain = [scaleDomain0].concat(_toConsumableArray(domain.slice(1, -1)), [scaleDomainN]);

  scaleObject.distance = scaleDistance;

  return scaleObject;
}

/**
 * Get an adjusted scale. Suitable for 'category' and 'ordinal' scales.
 * @param {Object} scaleObject Scale object.
 * @returns {*} Scale object with adjustments.
 * @private
 */
function _adjustCategoricalScale(scaleObject) {
  var scaleFn = getScaleFnFromScaleObject(scaleObject);
  var domain = scaleObject.domain,
      range = scaleObject.range;

  if (domain.length > 1) {
    scaleObject.distance = Math.abs(scaleFn(domain[1]) - scaleFn(domain[0]));
  } else {
    scaleObject.distance = Math.abs(range[1] - range[0]);
  }

  return scaleObject;
}

/**
 * Retrieve a scale object or a value from the properties passed.
 * @param {Object} props Object of props.
 * @param {string} attr Attribute.
 * @returns {*} Scale object, value or null.
 */
function getScaleObjectFromProps(props, attr) {
  // Create the initial scale object.
  var scaleObject = _collectScaleObjectFromProps(props, attr);
  if (!scaleObject) {
    return null;
  }

  // Make sure if it's possible to add space to the scale object. If not,
  // return the object immediately.
  if (!_isScaleAdjustmentPossible(props, scaleObject)) {
    return scaleObject;
  }

  var type = scaleObject.type;
  // Depending on what type the scale is, apply different adjustments. Distances
  // for the ordinal and category scales are even, equal domains cannot be
  // adjusted.

  if (type === ORDINAL_SCALE_TYPE || type === CATEGORY_SCALE_TYPE) {
    return _adjustCategoricalScale(scaleObject);
  }
  return _adjustContinuousScale(props, scaleObject);
}

/**
 * Get d3 scale for a given prop.
 * @param {Object} props Props.
 * @param {string} attr Attribute.
 * @returns {function} d3 scale function.
 */
function getAttributeScale(props, attr) {
  var scaleObject = getScaleObjectFromProps(props, attr);
  return getScaleFnFromScaleObject(scaleObject);
}

/**
 * Get the value of `attr` from the object.
 * @param {Object} d - data Object.
 * @param {Function} accessor - accessor function.
 * @returns {*} Value of the point.
 * @private
 */
function _getAttrValue(d, accessor) {
  return accessor(d.data ? d.data : d);
}

function _isDefined(value) {
  return typeof value !== 'undefined';
}

/*
 * Adds a percentage of padding to a given domain
 * @param {Array} domain X or Y domain to pad.
 * @param {Number} padding Percentage of padding to add to domain
 * @returns {Array} Padded Domain
 */
function _padDomain(domain, padding) {
  if (!domain) {
    return domain;
  }
  if (isNaN(parseFloat(domain[0])) || isNaN(parseFloat(domain[1]))) {
    return domain;
  }

  var _domain = _slicedToArray(domain, 2),
      min = _domain[0],
      max = _domain[1];

  var domainPadding = (max - min) * (padding * 0.01);
  return [min - domainPadding, max + domainPadding];
}

/**
 * Get prop functor (either a value or a function) for a given attribute.
 * @param {Object} props Series props.
 * @param {Function} accessor - Property accessor.
 * @returns {*} Function or value.
 */
function getAttributeFunctor(props, attr) {
  var scaleObject = getScaleObjectFromProps(props, attr);
  if (scaleObject) {
    var scaleFn = getScaleFnFromScaleObject(scaleObject);
    return function (d) {
      return scaleFn(_getAttrValue(d, scaleObject.accessor));
    };
  }
  return null;
}

/**
 * Get the functor which extracts value form [attr]0 property. Use baseValue if
 * no attr0 property for a given object is defined. Fall back to domain[0] if no
 * base value is available.
 * @param {Object} props Object of props.
 * @param {string} attr Attribute name.
 * @returns {*} Function which returns value or null if no values available.
 */
function getAttr0Functor(props, attr) {
  var scaleObject = getScaleObjectFromProps(props, attr);
  if (scaleObject) {
    var domain = scaleObject.domain;
    var _scaleObject$baseValu = scaleObject.baseValue,
        baseValue = _scaleObject$baseValu === undefined ? domain[0] : _scaleObject$baseValu;

    var scaleFn = getScaleFnFromScaleObject(scaleObject);
    return function (d) {
      var value = _getAttrValue(d, scaleObject.accessor0);
      return scaleFn(_isDefined(value) ? value : baseValue);
    };
  }
  return null;
}

/**
 * Tries to get the string|number value of the attr and falls back to
 * a fallback property in case if the value is a scale.
 * @param {Object} props Series props.
 * @param {string} attr Property name.
 * @returns {*} Function or value.
 */
function getAttributeValue(props, attr) {
  var scaleObject = getScaleObjectFromProps(props, attr);
  if (scaleObject) {
    if (!scaleObject.isValue && props['_' + attr + 'Value'] === undefined) {
      Object(__WEBPACK_IMPORTED_MODULE_5__react_utils__["b" /* warning */])('[React-vis] Cannot use data defined ' + attr + ' for this ' + 'series type. Using fallback value instead.');
    }
    return props['_' + attr + 'Value'] || scaleObject.range[0];
  }
  return null;
}

/**
 * Get prop types by the attribute.
 * @param {string} attr Attribute.
 * @returns {Object} Object of xDomain, xRange, xType, xDistance and _xValue,
 * where x is an attribute passed to the function.
 */
function getScalePropTypesByAttribute(attr) {
  var _ref2;

  return _ref2 = {}, _defineProperty(_ref2, '_' + attr + 'Value', __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any), _defineProperty(_ref2, attr + 'Domain', __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array), _defineProperty(_ref2, 'get' + toTitleCase(attr), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func), _defineProperty(_ref2, 'get' + toTitleCase(attr) + '0', __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func), _defineProperty(_ref2, attr + 'Range', __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array), _defineProperty(_ref2, attr + 'Type', __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(Object.keys(SCALE_FUNCTIONS))), _defineProperty(_ref2, attr + 'Distance', __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number), _defineProperty(_ref2, attr + 'BaseValue', __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any), _ref2;
}

/**
 * Extract the list of scale properties from the entire props object.
 * @param {Object} props Props.
 * @param {Array<String>} attributes Array of attributes for the given
 * components (for instance, `['x', 'y', 'color']`).
 * @returns {Object} Collected props.
 */
function extractScalePropsFromProps(props, attributes) {
  var result = {};
  Object.keys(props).forEach(function (key) {
    // this filtering is critical for extracting the correct accessors!
    var attr = attributes.find(function (a) {
      // width
      var isPlainSet = key.indexOf(a) === 0;
      // Ex: _data
      var isUnderscoreSet = key.indexOf('_' + a) === 0;
      // EX: getX
      var usesGet = key.indexOf('get' + toTitleCase(a)) === 0;
      return isPlainSet || isUnderscoreSet || usesGet;
    });
    if (!attr) {
      return;
    }
    result[key] = props[key];
  });
  return result;
}

/**
 * Extract the missing scale props from the given data and return them as
 * an object.
 * @param {Object} props Props.
 * @param {Array} data Array of all data.
 * @param {Array<String>} attributes Array of attributes for the given
 * components (for instance, `['x', 'y', 'color']`).
 * @returns {Object} Collected props.
 */
function getMissingScaleProps(props, data, attributes) {
  var result = {};
  // Make sure that the domain is set pad it if specified
  attributes.forEach(function (attr) {
    if (!props['get' + toTitleCase(attr)]) {
      result['get' + toTitleCase(attr)] = function (d) {
        return d[attr];
      };
    }
    if (!props['get' + toTitleCase(attr) + '0']) {
      result['get' + toTitleCase(attr) + '0'] = function (d) {
        return d[attr + '0'];
      };
    }
    if (!props[attr + 'Domain']) {
      result[attr + 'Domain'] = getDomainByAccessor(data, props['get' + toTitleCase(attr)] || result['get' + toTitleCase(attr)], props['get' + toTitleCase(attr) + '0'] || result['get' + toTitleCase(attr) + '0'], props[attr + 'Type']);
      if (props[attr + 'Padding']) {
        result[attr + 'Domain'] = _padDomain(result[attr + 'Domain'], props[attr + 'Padding']);
      }
    }
  });

  return result;
}

/**
 * Return a d3 scale that returns the literal value that was given to it
 * @returns {function} literal scale.
 */
function literalScale(defaultValue) {
  function scale(d) {
    if (d === undefined) {
      return defaultValue;
    }
    return d;
  }

  function response() {
    return scale;
  }

  scale.domain = response;
  scale.range = response;
  scale.unknown = response;
  scale.copy = response;

  return scale;
}

function getFontColorFromBackground(background) {
  if (background) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_d3_color__["d" /* hsl */])(background).l > 0.57 ? '#222' : '#fff';
  }
  return null;
}

/**
 * Creates fallback values for series from scales defined at XYPlot level.
 * @param {Object} props Props of the XYPlot object.
 * @param {Array<Object>} children Array of components, children of XYPlot
 * @returns {Array<Object>} Collected props.
 */

function getXYPlotValues(props, children) {
  var XYPlotScales = XYPLOT_ATTR.reduce(function (prev, attr) {
    var domain = props[attr + 'Domain'],
        range = props[attr + 'Range'],
        type = props[attr + 'Type'];


    if (domain && range && type) {
      return _extends({}, prev, _defineProperty({}, attr, SCALE_FUNCTIONS[type]().domain(domain).range(range)));
    }
    return prev;
  }, {});

  return children.map(function (child) {
    return XYPLOT_ATTR.reduce(function (prev, attr) {
      if (child.props && child.props[attr] !== undefined) {
        var scaleInput = child.props[attr];
        var scale = XYPlotScales[attr];
        var fallbackValue = scale ? scale(scaleInput) : scaleInput;
        return _extends({}, prev, _defineProperty({}, '_' + attr + 'Value', fallbackValue));
      }
      return prev;
    }, {});
  });
}

var OPTIONAL_SCALE_PROPS = ['Padding'];
var OPTIONAL_SCALE_PROPS_REGS = OPTIONAL_SCALE_PROPS.map(function (str) {
  return new RegExp(str + '$', 'i');
});
/**
 * Get the list of optional scale-related settings for XYPlot
 * mostly just used to find padding properties
 * @param {Object} props Object of props.
 * @returns {Object} Optional Props.
 * @private
 */
function getOptionalScaleProps(props) {
  return Object.keys(props).reduce(function (acc, prop) {
    var propIsNotOptional = OPTIONAL_SCALE_PROPS_REGS.every(function (reg) {
      return !prop.match(reg);
    });
    if (propIsNotOptional) {
      return acc;
    }
    acc[prop] = props[prop];
    return acc;
  }, {});
}

/* unused harmony default export */ var _unused_webpack_default_export = ({
  extractScalePropsFromProps: extractScalePropsFromProps,
  getAttributeScale: getAttributeScale,
  getAttributeFunctor: getAttributeFunctor,
  getAttr0Functor: getAttr0Functor,
  getAttributeValue: getAttributeValue,
  getDomainByAccessor: getDomainByAccessor,
  getFontColorFromBackground: getFontColorFromBackground,
  getMissingScaleProps: getMissingScaleProps,
  getOptionalScaleProps: getOptionalScaleProps,
  getScaleObjectFromProps: getScaleObjectFromProps,
  getScalePropTypesByAttribute: getScalePropTypesByAttribute,
  getXYPlotValues: getXYPlotValues,
  literalScale: literalScale
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bisect__ = __webpack_require__(563);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__bisect__["a"]; });
/* unused harmony reexport bisectRight */
/* unused harmony reexport bisectLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(162);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__ascending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bisector__ = __webpack_require__(564);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__bisector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cross__ = __webpack_require__(2115);
/* unused harmony reexport cross */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__descending__ = __webpack_require__(2116);
/* unused harmony reexport descending */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__deviation__ = __webpack_require__(566);
/* unused harmony reexport deviation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__extent__ = __webpack_require__(568);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_6__extent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__histogram__ = __webpack_require__(2117);
/* unused harmony reexport histogram */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__threshold_freedmanDiaconis__ = __webpack_require__(2120);
/* unused harmony reexport thresholdFreedmanDiaconis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__threshold_scott__ = __webpack_require__(2121);
/* unused harmony reexport thresholdScott */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__threshold_sturges__ = __webpack_require__(572);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_10__threshold_sturges__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__max__ = __webpack_require__(2122);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_11__max__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mean__ = __webpack_require__(2123);
/* unused harmony reexport mean */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__median__ = __webpack_require__(2124);
/* unused harmony reexport median */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__merge__ = __webpack_require__(2125);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_14__merge__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__min__ = __webpack_require__(573);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_15__min__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pairs__ = __webpack_require__(565);
/* unused harmony reexport pairs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__permute__ = __webpack_require__(2126);
/* unused harmony reexport permute */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__quantile__ = __webpack_require__(349);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_18__quantile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__range__ = __webpack_require__(570);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_19__range__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__scan__ = __webpack_require__(2127);
/* unused harmony reexport scan */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__shuffle__ = __webpack_require__(2128);
/* unused harmony reexport shuffle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__sum__ = __webpack_require__(2129);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_22__sum__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__ticks__ = __webpack_require__(571);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_23__ticks__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_23__ticks__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_23__ticks__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__transpose__ = __webpack_require__(574);
/* unused harmony reexport transpose */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__variance__ = __webpack_require__(567);
/* unused harmony reexport variance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__zip__ = __webpack_require__(2130);
/* unused harmony reexport zip */





























/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _IconButton.default;
  }
});

var _IconButton = _interopRequireDefault(__webpack_require__(827));

/***/ }),
/* 72 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _SvgIcon.default;
  }
});

var _SvgIcon = _interopRequireDefault(__webpack_require__(883));

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = newInterval;
var t0 = new Date,
    t1 = new Date;

function newInterval(floori, offseti, count, field) {

  function interval(date) {
    return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
  }

  interval.floor = function(date) {
    return floori(date = new Date(+date)), date;
  };

  interval.ceil = function(date) {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };

  interval.round = function(date) {
    var d0 = interval(date),
        d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };

  interval.offset = function(date, step) {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };

  interval.range = function(start, stop, step) {
    var range = [], previous;
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
    while (previous < start && start < stop);
    return range;
  };

  interval.filter = function(test) {
    return newInterval(function(date) {
      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
    }, function(date, step) {
      if (date >= date) {
        if (step < 0) while (++step <= 0) {
          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
        } else while (--step >= 0) {
          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
        }
      }
    });
  };

  if (count) {
    interval.count = function(start, end) {
      t0.setTime(+start), t1.setTime(+end);
      floori(t0), floori(t1);
      return Math.floor(count(t0, t1));
    };

    interval.every = function(step) {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null
          : !(step > 1) ? interval
          : interval.filter(field
              ? function(d) { return field(d) % step === 0; }
              : function(d) { return interval.count(0, d) % step === 0; });
    };
  }

  return interval;
}


/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isSchema;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GraphQLSchema; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__definition__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__introspection__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jsutils_find__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jsutils_instanceOf__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__jsutils_invariant__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__jsutils_objectValues__ = __webpack_require__(105);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */











/**
 * Test if the given value is a GraphQL schema.
 */

// eslint-disable-next-line no-redeclare
function isSchema(schema) {
  return Object(__WEBPACK_IMPORTED_MODULE_4__jsutils_instanceOf__["a" /* default */])(schema, GraphQLSchema);
}

/**
 * Schema Definition
 *
 * A Schema is created by supplying the root types of each type of operation,
 * query and mutation (optional). A schema definition is then supplied to the
 * validator and executor.
 *
 * Example:
 *
 *     const MyAppSchema = new GraphQLSchema({
 *       query: MyAppQueryRootType,
 *       mutation: MyAppMutationRootType,
 *     })
 *
 * Note: If an array of `directives` are provided to GraphQLSchema, that will be
 * the exact list of directives represented and allowed. If `directives` is not
 * provided then a default set of the specified directives (e.g. @include and
 * @skip) will be used. If you wish to provide *additional* directives to these
 * specified directives, you must explicitly declare them. Example:
 *
 *     const MyAppSchema = new GraphQLSchema({
 *       ...
 *       directives: specifiedDirectives.concat([ myCustomDirective ]),
 *     })
 *
 */
var GraphQLSchema = function () {
  // Used as a cache for validateSchema().
  function GraphQLSchema(config) {
    var _this = this;

    _classCallCheck(this, GraphQLSchema);

    // If this schema was built from a source known to be valid, then it may be
    // marked with assumeValid to avoid an additional type system validation.
    if (config && config.assumeValid) {
      this.__validationErrors = [];
    } else {
      // Otherwise check for common mistakes during construction to produce
      // clear and early error messages.
      !((typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object') ? Object(__WEBPACK_IMPORTED_MODULE_5__jsutils_invariant__["a" /* default */])(0, 'Must provide configuration object.') : void 0;
      !(!config.types || Array.isArray(config.types)) ? Object(__WEBPACK_IMPORTED_MODULE_5__jsutils_invariant__["a" /* default */])(0, '"types" must be Array if provided but got: ' + String(config.types) + '.') : void 0;
      !(!config.directives || Array.isArray(config.directives)) ? Object(__WEBPACK_IMPORTED_MODULE_5__jsutils_invariant__["a" /* default */])(0, '"directives" must be Array if provided but got: ' + (String(config.directives) + '.')) : void 0;
      !(!config.allowedLegacyNames || Array.isArray(config.allowedLegacyNames)) ? Object(__WEBPACK_IMPORTED_MODULE_5__jsutils_invariant__["a" /* default */])(0, '"allowedLegacyNames" must be Array if provided but got: ' + (String(config.allowedLegacyNames) + '.')) : void 0;
    }

    this.__allowedLegacyNames = config.allowedLegacyNames;
    this._queryType = config.query;
    this._mutationType = config.mutation;
    this._subscriptionType = config.subscription;
    // Provide specified directives (e.g. @include and @skip) by default.
    this._directives = config.directives || __WEBPACK_IMPORTED_MODULE_1__directives__["h" /* specifiedDirectives */];
    this.astNode = config.astNode;

    // Build type map now to detect any errors within this schema.
    var initialTypes = [this.getQueryType(), this.getMutationType(), this.getSubscriptionType(), __WEBPACK_IMPORTED_MODULE_2__introspection__["e" /* __Schema */]];

    var types = config.types;
    if (types) {
      initialTypes = initialTypes.concat(types);
    }

    // Keep track of all types referenced within the schema.
    var typeMap = Object.create(null);

    // First by deeply visiting all initial types.
    typeMap = initialTypes.reduce(typeMapReducer, typeMap);

    // Then by deeply visiting all directive types.
    typeMap = this._directives.reduce(typeMapDirectiveReducer, typeMap);

    // Storing the resulting map for reference by the schema.
    this._typeMap = typeMap;

    // Keep track of all implementations by interface name.
    this._implementations = Object.create(null);
    Object.keys(this._typeMap).forEach(function (typeName) {
      var type = _this._typeMap[typeName];
      if (Object(__WEBPACK_IMPORTED_MODULE_0__definition__["x" /* isObjectType */])(type)) {
        type.getInterfaces().forEach(function (iface) {
          if (Object(__WEBPACK_IMPORTED_MODULE_0__definition__["s" /* isInterfaceType */])(iface)) {
            var impls = _this._implementations[iface.name];
            if (impls) {
              impls.push(type);
            } else {
              _this._implementations[iface.name] = [type];
            }
          }
        });
      }
    });
  }
  // Referenced by validateSchema().


  GraphQLSchema.prototype.getQueryType = function getQueryType() {
    return this._queryType;
  };

  GraphQLSchema.prototype.getMutationType = function getMutationType() {
    return this._mutationType;
  };

  GraphQLSchema.prototype.getSubscriptionType = function getSubscriptionType() {
    return this._subscriptionType;
  };

  GraphQLSchema.prototype.getTypeMap = function getTypeMap() {
    return this._typeMap;
  };

  GraphQLSchema.prototype.getType = function getType(name) {
    return this.getTypeMap()[name];
  };

  GraphQLSchema.prototype.getPossibleTypes = function getPossibleTypes(abstractType) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__definition__["A" /* isUnionType */])(abstractType)) {
      return abstractType.getTypes();
    }
    return this._implementations[abstractType.name];
  };

  GraphQLSchema.prototype.isPossibleType = function isPossibleType(abstractType, possibleType) {
    var possibleTypeMap = this._possibleTypeMap;
    if (!possibleTypeMap) {
      this._possibleTypeMap = possibleTypeMap = Object.create(null);
    }

    if (!possibleTypeMap[abstractType.name]) {
      var possibleTypes = this.getPossibleTypes(abstractType);
      !Array.isArray(possibleTypes) ? Object(__WEBPACK_IMPORTED_MODULE_5__jsutils_invariant__["a" /* default */])(0, 'Could not find possible implementing types for ' + abstractType.name + ' ' + 'in schema. Check that schema.types is defined and is an array of ' + 'all possible types in the schema.') : void 0;
      possibleTypeMap[abstractType.name] = possibleTypes.reduce(function (map, type) {
        return map[type.name] = true, map;
      }, Object.create(null));
    }

    return Boolean(possibleTypeMap[abstractType.name][possibleType.name]);
  };

  GraphQLSchema.prototype.getDirectives = function getDirectives() {
    return this._directives;
  };

  GraphQLSchema.prototype.getDirective = function getDirective(name) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__jsutils_find__["a" /* default */])(this.getDirectives(), function (directive) {
      return directive.name === name;
    });
  };

  return GraphQLSchema;
}();

function typeMapReducer(map, type) {
  if (!type) {
    return map;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_0__definition__["B" /* isWrappingType */])(type)) {
    return typeMapReducer(map, type.ofType);
  }
  if (map[type.name]) {
    !(map[type.name] === type) ? Object(__WEBPACK_IMPORTED_MODULE_5__jsutils_invariant__["a" /* default */])(0, 'Schema must contain unique named types but contains multiple ' + ('types named "' + type.name + '".')) : void 0;
    return map;
  }
  map[type.name] = type;

  var reducedMap = map;

  if (Object(__WEBPACK_IMPORTED_MODULE_0__definition__["A" /* isUnionType */])(type)) {
    reducedMap = type.getTypes().reduce(typeMapReducer, reducedMap);
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_0__definition__["x" /* isObjectType */])(type)) {
    reducedMap = type.getInterfaces().reduce(typeMapReducer, reducedMap);
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_0__definition__["x" /* isObjectType */])(type) || Object(__WEBPACK_IMPORTED_MODULE_0__definition__["s" /* isInterfaceType */])(type)) {
    Object(__WEBPACK_IMPORTED_MODULE_6__jsutils_objectValues__["a" /* default */])(type.getFields()).forEach(function (field) {
      if (field.args) {
        var fieldArgTypes = field.args.map(function (arg) {
          return arg.type;
        });
        reducedMap = fieldArgTypes.reduce(typeMapReducer, reducedMap);
      }
      reducedMap = typeMapReducer(reducedMap, field.type);
    });
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_0__definition__["q" /* isInputObjectType */])(type)) {
    Object(__WEBPACK_IMPORTED_MODULE_6__jsutils_objectValues__["a" /* default */])(type.getFields()).forEach(function (field) {
      reducedMap = typeMapReducer(reducedMap, field.type);
    });
  }

  return reducedMap;
}

function typeMapDirectiveReducer(map, directive) {
  // Directives are not validated until validateSchema() is called.
  if (!Object(__WEBPACK_IMPORTED_MODULE_1__directives__["f" /* isDirective */])(directive)) {
    return map;
  }
  return directive.args.reduce(function (_map, arg) {
    return typeMapReducer(_map, arg.type);
  }, map);
}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Input.default;
  }
});

var _Input = _interopRequireDefault(__webpack_require__(302));

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(520);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};


/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color_js__ = __webpack_require__(340);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__color_js__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__color_js__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__color_js__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lab_js__ = __webpack_require__(2091);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__lab_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__lab_js__["b"]; });
/* unused harmony reexport lch */
/* unused harmony reexport gray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cubehelix_js__ = __webpack_require__(2092);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__cubehelix_js__["a"]; });





/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = invariant;
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

function invariant(condition, message) {
  /* istanbul ignore else */
  if (!condition) {
    throw new Error(message);
  }
}

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertHexToRGB = convertHexToRGB;
exports.rgbToHex = rgbToHex;
exports.decomposeColor = decomposeColor;
exports.recomposeColor = recomposeColor;
exports.getContrastRatio = getContrastRatio;
exports.getLuminance = getLuminance;
exports.emphasize = emphasize;
exports.fade = fade;
exports.darken = darken;
exports.lighten = lighten;

var _warning = _interopRequireDefault(__webpack_require__(37));

/* eslint-disable no-use-before-define */

/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
   false ? (0, _warning.default)(value >= min && value <= max, "Material-UI: the value provided ".concat(value, " is out of range [").concat(min, ", ").concat(max, "].")) : void 0;

  if (value < min) {
    return min;
  }

  if (value > max) {
    return max;
  }

  return value;
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */


function convertHexToRGB(color) {
  color = color.substr(1);
  var re = new RegExp(".{1,".concat(color.length / 3, "}"), 'g');
  var colors = color.match(re);

  if (colors && colors[0].length === 1) {
    colors = colors.map(function (n) {
      return n + n;
    });
  }

  return colors ? "rgb(".concat(colors.map(function (n) {
    return parseInt(n, 16);
  }).join(', '), ")") : '';
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 *
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */


function rgbToHex(color) {
  // Pass hex straight through
  if (color.indexOf('#') === 0) {
    return color;
  }

  function intToHex(c) {
    var hex = c.toString(16);
    return hex.length === 1 ? "0".concat(hex) : hex;
  }

  var _decomposeColor = decomposeColor(color),
      values = _decomposeColor.values;

  values = values.map(function (n) {
    return intToHex(n);
  });
  return "#".concat(values.join(''));
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */


function decomposeColor(color) {
  if (color.charAt(0) === '#') {
    return decomposeColor(convertHexToRGB(color));
  }

  var marker = color.indexOf('(');
  var type = color.substring(0, marker);
  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });

  if (false) {
    if (['rgb', 'rgba', 'hsl', 'hsla'].indexOf(type) === -1) {
      throw new Error(["Material-UI: unsupported `".concat(color, "` color."), 'We support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().'].join('\n'));
    }
  }

  return {
    type: type,
    values: values
  };
}
/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */


function recomposeColor(color) {
  var type = color.type;
  var values = color.values;

  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function (n, i) {
      return i < 3 ? parseInt(n, 10) : n;
    });
  }

  if (type.indexOf('hsl') !== -1) {
    values[1] = "".concat(values[1], "%");
    values[2] = "".concat(values[2], "%");
  }

  return "".concat(color.type, "(").concat(values.join(', '), ")");
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */


function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */


function getLuminance(color) {
  var decomposedColor = decomposeColor(color);

  if (decomposedColor.type.indexOf('rgb') !== -1) {
    var rgb = decomposedColor.values.map(function (val) {
      val /= 255; // normalized

      return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    }); // Truncate at 3 digits

    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
  } // else if (decomposedColor.type.indexOf('hsl') !== -1)


  return decomposedColor.values[2] / 100;
}
/**
 * Darken or lighten a colour, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */


function emphasize(color) {
  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}
/**
 * Set the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0 -1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */


function fade(color, value) {
   false ? (0, _warning.default)(color, "Material-UI: missing color argument in fade(".concat(color, ", ").concat(value, ").")) : void 0;
  if (!color) return color;
  color = decomposeColor(color);
  value = clamp(value);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }

  color.values[3] = value;
  return recomposeColor(color);
}
/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */


function darken(color, coefficient) {
   false ? (0, _warning.default)(color, "Material-UI: missing color argument in darken(".concat(color, ", ").concat(coefficient, ").")) : void 0;
  if (!color) return color;
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }

  return recomposeColor(color);
}
/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */


function lighten(color, coefficient) {
   false ? (0, _warning.default)(color, "Material-UI: missing color argument in lighten(".concat(color, ", ").concat(coefficient, ").")) : void 0;
  if (!color) return color;
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return recomposeColor(color);
}

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(176);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _shouldUpdate = _interopRequireDefault(__webpack_require__(879));

var _shallowEqual = _interopRequireDefault(__webpack_require__(882));

var _setDisplayName = _interopRequireDefault(__webpack_require__(475));

var _wrapDisplayName = _interopRequireDefault(__webpack_require__(175));

var pure = function pure(BaseComponent) {
  var hoc = (0, _shouldUpdate.default)(function (props, nextProps) {
    return !(0, _shallowEqual.default)(props, nextProps);
  });

  if (false) {
    return (0, _setDisplayName.default)((0, _wrapDisplayName.default)(BaseComponent, 'pure'))(hoc(BaseComponent));
  }

  return hoc(BaseComponent);
};

var _default = pure;
exports.default = _default;

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ORIENTATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DIRECTION; });
/* harmony export (immutable) */ __webpack_exports__["f"] = getTicksTotalFromSize;
/* harmony export (immutable) */ __webpack_exports__["e"] = getTickValues;
/* unused harmony export generateFit */
/* harmony export (immutable) */ __webpack_exports__["c"] = generatePoints;
/* harmony export (immutable) */ __webpack_exports__["d"] = getAxisAngle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_scale__ = __webpack_require__(130);
// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.




var ORIENTATION = {
  TOP: 'top',
  LEFT: 'left',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal'
};

var DIRECTION = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal'
};

/**
 * Get total amount of ticks from a given size in pixels.
 * @param {number} size Size of the axis in pixels.
 * @returns {number} Total amount of ticks.
 */
function getTicksTotalFromSize(size) {
  if (size < 700) {
    if (size > 300) {
      return 10;
    }
    return 5;
  }
  return 20;
}

/**
 * Get the tick values from a given d3 scale.
 * @param {d3.scale} scale Scale function.
 * @param {number} tickTotal Total number of ticks
 * @param {Array} tickValues Array of tick values if they exist.
 * @returns {Array} Array of tick values.
 */
function getTickValues(scale, tickTotal, tickValues) {
  return !tickValues ? scale.ticks ? scale.ticks(tickTotal) : scale.domain() : tickValues;
}

/**
 * Generate a description of a decorative axis in terms of a linear equation
 * y = slope * x + offset in coordinates
 * @param {Object} axisStart Object of format {x, y} describing in coordinates
 * the start position of the decorative axis
 * @param {Object} axisEnd Object of format {x, y} describing in coordinates
 * the start position of the decorative axis
 * @returns {Number} Object describing each the line in coordinates
 */
function generateFit(axisStart, axisEnd) {
  // address the special case when the slope is infinite
  if (axisStart.x === axisEnd.x) {
    return {
      left: axisStart.y,
      right: axisEnd.y,
      slope: 0,
      offset: axisStart.x
    };
  }
  var slope = (axisStart.y - axisEnd.y) / (axisStart.x - axisEnd.x);
  return {
    left: axisStart.x,
    right: axisEnd.x,
    // generate the linear projection of the axis direction
    slope: slope,
    offset: axisStart.y - slope * axisStart.x
  };
}

/**
 * Generate a description of a decorative axis in terms of a linear equation
 * y = slope * x + offset in coordinates
 * @param props
 * props.@param {Object} axisStart Object of format {x, y} describing in coordinates
 * the start position of the decorative axis
 * props.@param {Object} axisEnd Object of format {x, y} describing in coordinates
 * the start position of the decorative axis
 * props.@param {Number} numberOfTicks The number of ticks on the axis
 * props.@param {Array.Numbers} axisDomain The values to be interpolated across for the axis
 * @returns {Number} Object describing the slope and the specific coordinates of the points
 */
function generatePoints(_ref) {
  var axisStart = _ref.axisStart,
      axisEnd = _ref.axisEnd,
      numberOfTicks = _ref.numberOfTicks,
      axisDomain = _ref.axisDomain;

  var _generateFit = generateFit(axisStart, axisEnd),
      left = _generateFit.left,
      right = _generateFit.right,
      slope = _generateFit.slope,
      offset = _generateFit.offset;
  // construct a linear band of points, then map them


  var pointSlope = (right - left) / numberOfTicks;
  var axisScale = Object(__WEBPACK_IMPORTED_MODULE_1_d3_scale__["a" /* scaleLinear */])().domain([left, right]).range(axisDomain);

  var slopeVertical = axisStart.x === axisEnd.x;
  return {
    slope: slopeVertical ? Infinity : slope,
    points: Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["i" /* range */])(left, right + pointSlope, pointSlope).map(function (val) {
      if (slopeVertical) {
        return { y: val, x: slope * val + offset, text: axisScale(val) };
      }
      return { x: val, y: slope * val + offset, text: axisScale(val) };
    }).slice(0, numberOfTicks + 1)
  };
}

/**
 * Compute the angle (in radians) of a decorative axis
 * @param {Object} axisStart Object of format {x, y} describing in coordinates
 * the start position of the decorative axis
 * @param {Object} axisEnd Object of format {x, y} describing in coordinates
 * the start position of the decorative axis
 * @returns {Number} Angle in radials
 */
function getAxisAngle(axisStart, axisEnd) {
  if (axisStart.x === axisEnd.x) {
    return axisEnd.y > axisStart.y ? Math.PI / 2 : 3 * Math.PI / 2;
  }
  return Math.atan((axisEnd.y - axisStart.y) / (axisEnd.x - axisStart.x));
}

/* unused harmony default export */ var _unused_webpack_default_export = ({
  DIRECTION: DIRECTION,
  ORIENTATION: ORIENTATION,
  getTicksTotalFromSize: getTicksTotalFromSize,
  getTickValues: getTickValues
});

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Tab.default;
  }
});

var _Tab = _interopRequireDefault(__webpack_require__(895));

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Tabs.default;
  }
});

var _Tabs = _interopRequireDefault(__webpack_require__(896));

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Tooltip.default;
  }
});

var _Tooltip = _interopRequireDefault(__webpack_require__(967));

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = projection;
/* harmony export (immutable) */ __webpack_exports__["b"] = projectionMutator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__clip_antimeridian_js__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clip_circle_js__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__clip_rectangle_js__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__compose_js__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__identity_js__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__math_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rotation_js__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__transform_js__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fit_js__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__resample_js__ = __webpack_require__(2229);











var transformRadians = Object(__WEBPACK_IMPORTED_MODULE_7__transform_js__["a" /* transformer */])({
  point: function(x, y) {
    this.stream.point(x * __WEBPACK_IMPORTED_MODULE_5__math_js__["r" /* radians */], y * __WEBPACK_IMPORTED_MODULE_5__math_js__["r" /* radians */]);
  }
});

function transformRotate(rotate) {
  return Object(__WEBPACK_IMPORTED_MODULE_7__transform_js__["a" /* transformer */])({
    point: function(x, y) {
      var r = rotate(x, y);
      return this.stream.point(r[0], r[1]);
    }
  });
}

function scaleTranslate(k, dx, dy, sx, sy) {
  function transform(x, y) {
    x *= sx; y *= sy;
    return [dx + k * x, dy - k * y];
  }
  transform.invert = function(x, y) {
    return [(x - dx) / k * sx, (dy - y) / k * sy];
  };
  return transform;
}

function scaleTranslateRotate(k, dx, dy, sx, sy, alpha) {
  var cosAlpha = Object(__WEBPACK_IMPORTED_MODULE_5__math_js__["g" /* cos */])(alpha),
      sinAlpha = Object(__WEBPACK_IMPORTED_MODULE_5__math_js__["t" /* sin */])(alpha),
      a = cosAlpha * k,
      b = sinAlpha * k,
      ai = cosAlpha / k,
      bi = sinAlpha / k,
      ci = (sinAlpha * dy - cosAlpha * dx) / k,
      fi = (sinAlpha * dx + cosAlpha * dy) / k;
  function transform(x, y) {
    x *= sx; y *= sy;
    return [a * x - b * y + dx, dy - b * x - a * y];
  }
  transform.invert = function(x, y) {
    return [sx * (ai * x - bi * y + ci), sy * (fi - bi * x - ai * y)];
  };
  return transform;
}

function projection(project) {
  return projectionMutator(function() { return project; })();
}

function projectionMutator(projectAt) {
  var project,
      k = 150, // scale
      x = 480, y = 250, // translate
      lambda = 0, phi = 0, // center
      deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, // pre-rotate
      alpha = 0, // post-rotate angle
      sx = 1, // reflectX
      sy = 1, // reflectX
      theta = null, preclip = __WEBPACK_IMPORTED_MODULE_0__clip_antimeridian_js__["a" /* default */], // pre-clip angle
      x0 = null, y0, x1, y1, postclip = __WEBPACK_IMPORTED_MODULE_4__identity_js__["a" /* default */], // post-clip extent
      delta2 = 0.5, // precision
      projectResample,
      projectTransform,
      projectRotateTransform,
      cache,
      cacheStream;

  function projection(point) {
    return projectRotateTransform(point[0] * __WEBPACK_IMPORTED_MODULE_5__math_js__["r" /* radians */], point[1] * __WEBPACK_IMPORTED_MODULE_5__math_js__["r" /* radians */]);
  }

  function invert(point) {
    point = projectRotateTransform.invert(point[0], point[1]);
    return point && [point[0] * __WEBPACK_IMPORTED_MODULE_5__math_js__["h" /* degrees */], point[1] * __WEBPACK_IMPORTED_MODULE_5__math_js__["h" /* degrees */]];
  }

  projection.stream = function(stream) {
    return cache && cacheStream === stream ? cache : cache = transformRadians(transformRotate(rotate)(preclip(projectResample(postclip(cacheStream = stream)))));
  };

  projection.preclip = function(_) {
    return arguments.length ? (preclip = _, theta = undefined, reset()) : preclip;
  };

  projection.postclip = function(_) {
    return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
  };

  projection.clipAngle = function(_) {
    return arguments.length ? (preclip = +_ ? Object(__WEBPACK_IMPORTED_MODULE_1__clip_circle_js__["a" /* default */])(theta = _ * __WEBPACK_IMPORTED_MODULE_5__math_js__["r" /* radians */]) : (theta = null, __WEBPACK_IMPORTED_MODULE_0__clip_antimeridian_js__["a" /* default */]), reset()) : theta * __WEBPACK_IMPORTED_MODULE_5__math_js__["h" /* degrees */];
  };

  projection.clipExtent = function(_) {
    return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, __WEBPACK_IMPORTED_MODULE_4__identity_js__["a" /* default */]) : Object(__WEBPACK_IMPORTED_MODULE_2__clip_rectangle_js__["a" /* default */])(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };

  projection.scale = function(_) {
    return arguments.length ? (k = +_, recenter()) : k;
  };

  projection.translate = function(_) {
    return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [x, y];
  };

  projection.center = function(_) {
    return arguments.length ? (lambda = _[0] % 360 * __WEBPACK_IMPORTED_MODULE_5__math_js__["r" /* radians */], phi = _[1] % 360 * __WEBPACK_IMPORTED_MODULE_5__math_js__["r" /* radians */], recenter()) : [lambda * __WEBPACK_IMPORTED_MODULE_5__math_js__["h" /* degrees */], phi * __WEBPACK_IMPORTED_MODULE_5__math_js__["h" /* degrees */]];
  };

  projection.rotate = function(_) {
    return arguments.length ? (deltaLambda = _[0] % 360 * __WEBPACK_IMPORTED_MODULE_5__math_js__["r" /* radians */], deltaPhi = _[1] % 360 * __WEBPACK_IMPORTED_MODULE_5__math_js__["r" /* radians */], deltaGamma = _.length > 2 ? _[2] % 360 * __WEBPACK_IMPORTED_MODULE_5__math_js__["r" /* radians */] : 0, recenter()) : [deltaLambda * __WEBPACK_IMPORTED_MODULE_5__math_js__["h" /* degrees */], deltaPhi * __WEBPACK_IMPORTED_MODULE_5__math_js__["h" /* degrees */], deltaGamma * __WEBPACK_IMPORTED_MODULE_5__math_js__["h" /* degrees */]];
  };

  projection.angle = function(_) {
    return arguments.length ? (alpha = _ % 360 * __WEBPACK_IMPORTED_MODULE_5__math_js__["r" /* radians */], recenter()) : alpha * __WEBPACK_IMPORTED_MODULE_5__math_js__["h" /* degrees */];
  };

  projection.reflectX = function(_) {
    return arguments.length ? (sx = _ ? -1 : 1, recenter()) : sx < 0;
  };

  projection.reflectY = function(_) {
    return arguments.length ? (sy = _ ? -1 : 1, recenter()) : sy < 0;
  };

  projection.precision = function(_) {
    return arguments.length ? (projectResample = Object(__WEBPACK_IMPORTED_MODULE_9__resample_js__["a" /* default */])(projectTransform, delta2 = _ * _), reset()) : Object(__WEBPACK_IMPORTED_MODULE_5__math_js__["u" /* sqrt */])(delta2);
  };

  projection.fitExtent = function(extent, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_8__fit_js__["a" /* fitExtent */])(projection, extent, object);
  };

  projection.fitSize = function(size, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_8__fit_js__["c" /* fitSize */])(projection, size, object);
  };

  projection.fitWidth = function(width, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_8__fit_js__["d" /* fitWidth */])(projection, width, object);
  };

  projection.fitHeight = function(height, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_8__fit_js__["b" /* fitHeight */])(projection, height, object);
  };

  function recenter() {
    var center = scaleTranslateRotate(k, 0, 0, sx, sy, alpha).apply(null, project(lambda, phi)),
        transform = (alpha ? scaleTranslateRotate : scaleTranslate)(k, x - center[0], y - center[1], sx, sy, alpha);
    rotate = Object(__WEBPACK_IMPORTED_MODULE_6__rotation_js__["b" /* rotateRadians */])(deltaLambda, deltaPhi, deltaGamma);
    projectTransform = Object(__WEBPACK_IMPORTED_MODULE_3__compose_js__["a" /* default */])(project, transform);
    projectRotateTransform = Object(__WEBPACK_IMPORTED_MODULE_3__compose_js__["a" /* default */])(rotate, projectTransform);
    projectResample = Object(__WEBPACK_IMPORTED_MODULE_9__resample_js__["a" /* default */])(projectTransform, delta2);
    return reset();
  }

  function reset() {
    cache = cacheStream = null;
    return projection;
  }

  return function() {
    project = projectAt.apply(this, arguments);
    projection.invert = project.invert && invert;
    return recenter();
  };
}


/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isInvalid;
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Returns true if a value is undefined, or NaN.
 */
function isInvalid(value) {
  return value === undefined || value !== value;
}

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = isDirective;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GraphQLDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GraphQLIncludeDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GraphQLSkipDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_DEPRECATION_REASON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GraphQLDeprecatedDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return specifiedDirectives; });
/* harmony export (immutable) */ __webpack_exports__["g"] = isSpecifiedDirective;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__definition__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scalars__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsutils_instanceOf__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jsutils_invariant__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation__ = __webpack_require__(138);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

 /**
                                                * Copyright (c) 2015-present, Facebook, Inc.
                                                *
                                                * This source code is licensed under the MIT license found in the
                                                * LICENSE file in the root directory of this source tree.
                                                *
                                                *  strict
                                                */







/**
 * Test if the given value is a GraphQL directive.
 */

// eslint-disable-next-line no-redeclare
function isDirective(directive) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_instanceOf__["a" /* default */])(directive, GraphQLDirective);
}

/**
 * Directives are used by the GraphQL runtime as a way of modifying execution
 * behavior. Type system creators will usually not create these directly.
 */
var GraphQLDirective = function GraphQLDirective(config) {
  _classCallCheck(this, GraphQLDirective);

  this.name = config.name;
  this.description = config.description;
  this.locations = config.locations;
  this.astNode = config.astNode;
  !config.name ? Object(__WEBPACK_IMPORTED_MODULE_3__jsutils_invariant__["a" /* default */])(0, 'Directive must be named.') : void 0;
  !Array.isArray(config.locations) ? Object(__WEBPACK_IMPORTED_MODULE_3__jsutils_invariant__["a" /* default */])(0, 'Must provide locations for directive.') : void 0;

  var args = config.args;
  if (!args) {
    this.args = [];
  } else {
    !!Array.isArray(args) ? Object(__WEBPACK_IMPORTED_MODULE_3__jsutils_invariant__["a" /* default */])(0, '@' + config.name + ' args must be an object with argument names as keys.') : void 0;
    this.args = Object.keys(args).map(function (argName) {
      var arg = args[argName];
      return {
        name: argName,
        description: arg.description === undefined ? null : arg.description,
        type: arg.type,
        defaultValue: arg.defaultValue,
        astNode: arg.astNode
      };
    });
  }
};

/**
 * Used to conditionally include fields or fragments.
 */
var GraphQLIncludeDirective = new GraphQLDirective({
  name: 'include',
  description: 'Directs the executor to include this field or fragment only when ' + 'the `if` argument is true.',
  locations: [__WEBPACK_IMPORTED_MODULE_4__language_directiveLocation__["a" /* DirectiveLocation */].FIELD, __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation__["a" /* DirectiveLocation */].FRAGMENT_SPREAD, __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation__["a" /* DirectiveLocation */].INLINE_FRAGMENT],
  args: {
    if: {
      type: Object(__WEBPACK_IMPORTED_MODULE_0__definition__["e" /* GraphQLNonNull */])(__WEBPACK_IMPORTED_MODULE_1__scalars__["a" /* GraphQLBoolean */]),
      description: 'Included when true.'
    }
  }
});

/**
 * Used to conditionally skip (exclude) fields or fragments.
 */
var GraphQLSkipDirective = new GraphQLDirective({
  name: 'skip',
  description: 'Directs the executor to skip this field or fragment when the `if` ' + 'argument is true.',
  locations: [__WEBPACK_IMPORTED_MODULE_4__language_directiveLocation__["a" /* DirectiveLocation */].FIELD, __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation__["a" /* DirectiveLocation */].FRAGMENT_SPREAD, __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation__["a" /* DirectiveLocation */].INLINE_FRAGMENT],
  args: {
    if: {
      type: Object(__WEBPACK_IMPORTED_MODULE_0__definition__["e" /* GraphQLNonNull */])(__WEBPACK_IMPORTED_MODULE_1__scalars__["a" /* GraphQLBoolean */]),
      description: 'Skipped when true.'
    }
  }
});

/**
 * Constant string used for default reason for a deprecation.
 */
var DEFAULT_DEPRECATION_REASON = 'No longer supported';

/**
 * Used to declare element of a GraphQL schema as deprecated.
 */
var GraphQLDeprecatedDirective = new GraphQLDirective({
  name: 'deprecated',
  description: 'Marks an element of a GraphQL schema as no longer supported.',
  locations: [__WEBPACK_IMPORTED_MODULE_4__language_directiveLocation__["a" /* DirectiveLocation */].FIELD_DEFINITION, __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation__["a" /* DirectiveLocation */].ENUM_VALUE],
  args: {
    reason: {
      type: __WEBPACK_IMPORTED_MODULE_1__scalars__["c" /* GraphQLString */],
      description: 'Explains why this element was deprecated, usually also including a ' + 'suggestion for how to access supported similar data. Formatted ' + 'in [Markdown](https://daringfireball.net/projects/markdown/).',
      defaultValue: DEFAULT_DEPRECATION_REASON
    }
  }
});

/**
 * The full list of specified directives.
 */
var specifiedDirectives = [GraphQLIncludeDirective, GraphQLSkipDirective, GraphQLDeprecatedDirective];

function isSpecifiedDirective(directive) {
  return specifiedDirectives.some(function (specifiedDirective) {
    return specifiedDirective.name === directive.name;
  });
}

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __Schema; });
/* unused harmony export __Directive */
/* unused harmony export __DirectiveLocation */
/* unused harmony export __Type */
/* unused harmony export __Field */
/* unused harmony export __InputValue */
/* unused harmony export __EnumValue */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TypeKind; });
/* unused harmony export __TypeKind */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SchemaMetaFieldDef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TypeMetaFieldDef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TypeNameMetaFieldDef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return introspectionTypes; });
/* harmony export (immutable) */ __webpack_exports__["g"] = isIntrospectionType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsutils_isInvalid__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsutils_objectValues__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_astFromValue__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__language_printer__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__definition__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scalars__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__language_directiveLocation__ = __webpack_require__(138);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */










var __Schema = new __WEBPACK_IMPORTED_MODULE_4__definition__["f" /* GraphQLObjectType */]({
  name: '__Schema',
  isIntrospection: true,
  description: 'A GraphQL Schema defines the capabilities of a GraphQL server. It ' + 'exposes all available types and directives on the server, as well as ' + 'the entry points for query, mutation, and subscription operations.',
  fields: function fields() {
    return {
      types: {
        description: 'A list of all types supported by this server.',
        type: Object(__WEBPACK_IMPORTED_MODULE_4__definition__["e" /* GraphQLNonNull */])(Object(__WEBPACK_IMPORTED_MODULE_4__definition__["d" /* GraphQLList */])(Object(__WEBPACK_IMPORTED_MODULE_4__definition__["e" /* GraphQLNonNull */])(__Type))),
        resolve: function resolve(schema) {
          return Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_objectValues__["a" /* default */])(schema.getTypeMap());
        }
      },
      queryType: {
        description: 'The type that query operations will be rooted at.',
        type: Object(__WEBPACK_IMPORTED_MODULE_4__definition__["e" /* GraphQLNonNull */])(__Type),
        resolve: function resolve(schema) {
          return schema.getQueryType();
        }
      },
      mutationType: {
        description: 'If this server supports mutation, the type that ' + 'mutation operations will be rooted at.',
        type: __Type,
        resolve: function resolve(schema) {
          return schema.getMutationType();
        }
      },
      subscriptionType: {
        description: 'If this server support subscription, the type that ' + 'subscription operations will be rooted at.',
        type: __Type,
        resolve: function resolve(schema) {
          return schema.getSubscriptionType();
        }
      },
      directives: {
        description: 'A list of all directives supported by this server.',
        type: Object(__WEBPACK_IMPORTED_MODULE_4__definition__["e" /* GraphQLNonNull */])(Object(__WEBPACK_IMPORTED_MODULE_4__definition__["d" /* GraphQLList */])(Object(__WEBPACK_IMPORTED_MODULE_4__definition__["e" /* GraphQLNonNull */])(__Directive))),
        resolve: function resolve(schema) {
          return schema.getDirectives();
        }
      }
    };
  }
});

var __Directive = new __WEBPACK_IMPORTED_MODULE_4__definition__["f" /* GraphQLObjectType */]({
  name: '__Directive',
  isIntrospection: true,
  description: 'A Directive provides a way to describe alternate runtime execution and ' + 'type validation behavior in a GraphQL document.' + "\n\nIn some cases, you need to provide options to alter GraphQL's " + 'execution behavior in ways field arguments will not suffice, such as ' + 'conditionally including or skipping a field. Directives provide this by ' + 'describing additional information to the executor.',
  fields: function fields() {
    return {
      name: { type: Object(__WEBPACK_IMPORTED_MODULE_4__definition__["e" /* GraphQLNonNull */])(__WEBPACK_IMPORTED_MODULE_5__scalars__["c" /* GraphQLString */]) },
      description: { type: __WEBPACK_IMPORTED_MODULE_5__scalars__["c" /* GraphQLString */] },
      locations: {
        type: Object(__WEBPACK_IMPORTED_MODULE_4__definition__["e" /* GraphQLNonNull */])(Object(__WEBPACK_IMPORTED_MODULE_4__definition__["d" /* GraphQLList */])(Object(__WEBPACK_IMPORTED_MODULE_4__definition__["e" /* GraphQLNonNull */])(__DirectiveLocation)))
      },
      args: {
        type: Object(__WEBPACK_IMPORTED_MODULE_4__definition__["e" /* GraphQLNonNull */])(Object(__WEBPACK_IMPORTED_MODULE_4__definition__["d" /* GraphQLList */])(Object(__WEBPACK_IMPORTED_MODULE_4__definition__["e" /* GraphQLNonNull */])(__InputValue))),
        resolve: function resolve(directive) {
          return directive.args || [];
        }
      },
      // NOTE: the following three fields are deprecated and are no longer part
      // of the GraphQL specification.
      onOperation: {
        deprecationReason: 'Use `locations`.',
        type: Object(__WEBPACK_IMPORTED_MODULE_4__definition__["e" /* GraphQLNonNull */])(__WEBPACK_IMPORTED_MODULE_5__scalars__["a" /* GraphQLBoolean */]),
        resolve: function resolve(d) {
          return d.locations.indexOf(__WEBPACK_IMPORTED_MODULE_6__language_directiveLocation__["a" /* DirectiveLocation */].QUERY) !== -1 || d.locations.indexOf(__WEBPACK_IMPORTED_MODULE_6__language_directiveLocation__["a" /* DirectiveLocation */].MUTATION) !== -1 || d.locations.indexOf(__WEBPACK_IMPORTED_MODULE_6__language_directiveLocation__["a" /* DirectiveLocation */].SUBSCRIPTION) !== -1;
        }
      },
      onFragment: {
        deprecationReason: 'Use `locations`.',
        type: Object(__WEBPACK_IMPORTED_MODULE_4__definition__["e" /* GraphQLNonNull */])(__WEBPACK_IMPORTED_MODULE_5__scalars__["a" /* GraphQLBoolean */]),
        resolve: function resolve(d) {
          return d.locations.indexOf(__WEBPACK_IMPORTED_MODULE_6__language_directiveLocation__["a" /* DirectiveLocation */].FRAGMENT_SPREAD) !== -1 || d.locations.indexOf(__WEBPACK_IMPORTED_MODULE_6__language_directiveLocation__["a" /* DirectiveLocation */].INLINE_FRAGMENT) !== -1 || d.locations.indexOf(__WEBPACK_IMPORTED_MODULE_6__language_directiveLocation__["a" /* DirectiveLocation */].FRAGMENT_DEFINITION) !== -1;
        }
      },
      onField: {
        deprecationReason: 'Use `locations`.',
        type: Object(__WEBPACK_IMPORTED_MODULE_4__definition__["e" /* GraphQLNonNull */])(__WEBPACK_IMPORTED_MODULE_5__scalars__["a" /* GraphQLBoolean */]),
        resolve: function resolve(d) {
          return d.locations.indexOf(__WEBPACK_IMPORTED_MODULE_6__language_directiveLocation__["a" /* DirectiveLocation */].FIELD) !== -1;
        }
      }
    };
  }
});

var __DirectiveLocation = new __WEBPACK_IMPORTED_MODULE_4__definition__["a" /* GraphQLEnumType */]({
  name: '__DirectiveLocation',
  isIntrospection: true,
  description: 'A Directive can be adjacent to many parts of the GraphQL language, a ' + '__DirectiveLocation describes one such possible adjacencies.',
  values: {
    QUERY: {
      value: __WEBPACK_IMPORTED_MODULE_6__language_directiveLocation__["a" /* DirectiveLocation */].QUERY,
      description: 'Location adjacent to a query operation.'
    },
    MUTATION: {
      value: __WEBPACK_IMPORTED_MODULE_6__language_directiveLocation__["a" /* DirectiveLocation */].MUTATION,
      description: 'Location adjacent to a mutation operation.'
    },
    SUBSCRIPTION: {
      value: __WEBPACK_IMPORTED_MODULE_6__language_directiveLocation__["a" /* DirectiveLocation */].SUBSCRIPTION,
      description: 'Location adjacent to a subscription operation.'
    },
    FIELD: {
      value: __WEBPACK_IMPORTED_MODULE_6__language_directiveLocation__["a" /* DirectiveLocation */].FIELD,
      description: 'Location adjacent to a field.'
    },
    FRAGMENT_DEFINITION: {
      value: __WEBPACK_IMPORTED_MODULE_6__language_directiveLocation__["a" /* DirectiveLocation */].FRAGMENT_DEFINITION,
      description: 'Location adjacent to a fragment definition.'
    },
    FRAGMENT_SPREAD: {
      value: __WEBPACK_IMPORTED_MODULE_6__language_directiveLocation__["a" /* DirectiveLocation */].FRAGMENT_SPREAD,
      description: 'Location adjacent to a fragment spread.'
    },
    INLINE_FRAGMENT: {
      value: __WEBPACK_IMPORTED_MODULE_6__language_directiveLocation__["a" /* DirectiveLocation */].INLINE_FRAGMENT,
      description: 'Location adjacent to an inline fragment.'
    },
    SCHEMA: {
      value: __WEBPACK_IMPORTED_MODULE_6__language_directiveLocation__["a" /* DirectiveLocation */].SCHEMA,
      description: 'Location adjacent to a schema definition.'
    },
    SCALAR: {
      value: __WEBPACK_IMPORTED_MODULE_6__language_directiveLocation__["a" /* DirectiveLocation */].SCALAR,
      description: 'Location adjacent to a scalar definition.'
    },
    OBJECT: {
      value: __WEBPACK_IMPORTED_MODULE_6__language_directiveLocation__["a" /* DirectiveLocation */].OBJECT,
      description: 'Location adjacent to an object type definition.'
    },
    FIELD_DEFINITION: {
      value: __WEBPACK_IMPORTED_MODULE_6__language_directiveLocation__["a" /* DirectiveLocation */].FIELD_DEFINITION,
      description: 'Location adjacent to a field definition.'
    },
    ARGUMENT_DEFINITION: {
      value: __WEBPACK_IMPORTED_MODULE_6__language_directiveLocation__["a" /* DirectiveLocation */].ARGUMENT_DEFINITION,
      description: 'Location adjacent to an argument definition.'
    },
    INTERFACE: {
      value: __WEBPACK_IMPORTED_MODULE_6__language_directiveLocation__["a" /* DirectiveLocation */].INTERFACE,
      description: 'Location adjacent to an interface definition.'
    },
    UNION: {
      value: __WEBPACK_IMPORTED_MODULE_6__language_directiveLocation__["a" /* DirectiveLocation */].UNION,
      description: 'Location adjacent to a union definition.'
    },
    ENUM: {
      value: __WEBPACK_IMPORTED_MODULE_6__language_directiveLocation__["a" /* DirectiveLocation */].ENUM,
      description: 'Location adjacent to an enum definition.'
    },
    ENUM_VALUE: {
      value: __WEBPACK_IMPORTED_MODULE_6__language_directiveLocation__["a" /* DirectiveLocation */].ENUM_VALUE,
      description: 'Location adjacent to an enum value definition.'
    },
    INPUT_OBJECT: {
      value: __WEBPACK_IMPORTED_MODULE_6__language_directiveLocation__["a" /* DirectiveLocation */].INPUT_OBJECT,
      description: 'Location adjacent to an input object type definition.'
    },
    INPUT_FIELD_DEFINITION: {
      value: __WEBPACK_IMPORTED_MODULE_6__language_directiveLocation__["a" /* DirectiveLocation */].INPUT_FIELD_DEFINITION,
      description: 'Location adjacent to an input object field definition.'
    }
  }
});

var __Type = new __WEBPACK_IMPORTED_MODULE_4__definition__["f" /* GraphQLObjectType */]({
  name: '__Type',
  isIntrospection: true,
  description: 'The fundamental unit of any GraphQL Schema is the type. There are ' + 'many kinds of types in GraphQL as represented by the `__TypeKind` enum.' + '\n\nDepending on the kind of a type, certain fields describe ' + 'information about that type. Scalar types provide no information ' + 'beyond a name and description, while Enum types provide their values. ' + 'Object and Interface types provide the fields they describe. Abstract ' + 'types, Union and Interface, provide the Object types possible ' + 'at runtime. List and NonNull types compose other types.',
  fields: function fields() {
    return {
      kind: {
        type: Object(__WEBPACK_IMPORTED_MODULE_4__definition__["e" /* GraphQLNonNull */])(__TypeKind),
        resolve: function resolve(type) {
          if (Object(__WEBPACK_IMPORTED_MODULE_4__definition__["z" /* isScalarType */])(type)) {
            return TypeKind.SCALAR;
          } else if (Object(__WEBPACK_IMPORTED_MODULE_4__definition__["x" /* isObjectType */])(type)) {
            return TypeKind.OBJECT;
          } else if (Object(__WEBPACK_IMPORTED_MODULE_4__definition__["s" /* isInterfaceType */])(type)) {
            return TypeKind.INTERFACE;
          } else if (Object(__WEBPACK_IMPORTED_MODULE_4__definition__["A" /* isUnionType */])(type)) {
            return TypeKind.UNION;
          } else if (Object(__WEBPACK_IMPORTED_MODULE_4__definition__["p" /* isEnumType */])(type)) {
            return TypeKind.ENUM;
          } else if (Object(__WEBPACK_IMPORTED_MODULE_4__definition__["q" /* isInputObjectType */])(type)) {
            return TypeKind.INPUT_OBJECT;
          } else if (Object(__WEBPACK_IMPORTED_MODULE_4__definition__["u" /* isListType */])(type)) {
            return TypeKind.LIST;
          } else if (Object(__WEBPACK_IMPORTED_MODULE_4__definition__["w" /* isNonNullType */])(type)) {
            return TypeKind.NON_NULL;
          }
          throw new Error('Unknown kind of type: ' + type);
        }
      },
      name: { type: __WEBPACK_IMPORTED_MODULE_5__scalars__["c" /* GraphQLString */] },
      description: { type: __WEBPACK_IMPORTED_MODULE_5__scalars__["c" /* GraphQLString */] },
      fields: {
        type: Object(__WEBPACK_IMPORTED_MODULE_4__definition__["d" /* GraphQLList */])(Object(__WEBPACK_IMPORTED_MODULE_4__definition__["e" /* GraphQLNonNull */])(__Field)),
        args: {
          includeDeprecated: { type: __WEBPACK_IMPORTED_MODULE_5__scalars__["a" /* GraphQLBoolean */], defaultValue: false }
        },
        resolve: function resolve(type, _ref) {
          var includeDeprecated = _ref.includeDeprecated;

          if (Object(__WEBPACK_IMPORTED_MODULE_4__definition__["x" /* isObjectType */])(type) || Object(__WEBPACK_IMPORTED_MODULE_4__definition__["s" /* isInterfaceType */])(type)) {
            var fields = Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_objectValues__["a" /* default */])(type.getFields());
            if (!includeDeprecated) {
              fields = fields.filter(function (field) {
                return !field.deprecationReason;
              });
            }
            return fields;
          }
          return null;
        }
      },
      interfaces: {
        type: Object(__WEBPACK_IMPORTED_MODULE_4__definition__["d" /* GraphQLList */])(Object(__WEBPACK_IMPORTED_MODULE_4__definition__["e" /* GraphQLNonNull */])(__Type)),
        resolve: function resolve(type) {
          if (Object(__WEBPACK_IMPORTED_MODULE_4__definition__["x" /* isObjectType */])(type)) {
            return type.getInterfaces();
          }
        }
      },
      possibleTypes: {
        type: Object(__WEBPACK_IMPORTED_MODULE_4__definition__["d" /* GraphQLList */])(Object(__WEBPACK_IMPORTED_MODULE_4__definition__["e" /* GraphQLNonNull */])(__Type)),
        resolve: function resolve(type, args, context, _ref2) {
          var schema = _ref2.schema;

          if (Object(__WEBPACK_IMPORTED_MODULE_4__definition__["n" /* isAbstractType */])(type)) {
            return schema.getPossibleTypes(type);
          }
        }
      },
      enumValues: {
        type: Object(__WEBPACK_IMPORTED_MODULE_4__definition__["d" /* GraphQLList */])(Object(__WEBPACK_IMPORTED_MODULE_4__definition__["e" /* GraphQLNonNull */])(__EnumValue)),
        args: {
          includeDeprecated: { type: __WEBPACK_IMPORTED_MODULE_5__scalars__["a" /* GraphQLBoolean */], defaultValue: false }
        },
        resolve: function resolve(type, _ref3) {
          var includeDeprecated = _ref3.includeDeprecated;

          if (Object(__WEBPACK_IMPORTED_MODULE_4__definition__["p" /* isEnumType */])(type)) {
            var values = type.getValues();
            if (!includeDeprecated) {
              values = values.filter(function (value) {
                return !value.deprecationReason;
              });
            }
            return values;
          }
        }
      },
      inputFields: {
        type: Object(__WEBPACK_IMPORTED_MODULE_4__definition__["d" /* GraphQLList */])(Object(__WEBPACK_IMPORTED_MODULE_4__definition__["e" /* GraphQLNonNull */])(__InputValue)),
        resolve: function resolve(type) {
          if (Object(__WEBPACK_IMPORTED_MODULE_4__definition__["q" /* isInputObjectType */])(type)) {
            return Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_objectValues__["a" /* default */])(type.getFields());
          }
        }
      },
      ofType: { type: __Type }
    };
  }
});

var __Field = new __WEBPACK_IMPORTED_MODULE_4__definition__["f" /* GraphQLObjectType */]({
  name: '__Field',
  isIntrospection: true,
  description: 'Object and Interface types are described by a list of Fields, each of ' + 'which has a name, potentially a list of arguments, and a return type.',
  fields: function fields() {
    return {
      name: { type: Object(__WEBPACK_IMPORTED_MODULE_4__definition__["e" /* GraphQLNonNull */])(__WEBPACK_IMPORTED_MODULE_5__scalars__["c" /* GraphQLString */]) },
      description: { type: __WEBPACK_IMPORTED_MODULE_5__scalars__["c" /* GraphQLString */] },
      args: {
        type: Object(__WEBPACK_IMPORTED_MODULE_4__definition__["e" /* GraphQLNonNull */])(Object(__WEBPACK_IMPORTED_MODULE_4__definition__["d" /* GraphQLList */])(Object(__WEBPACK_IMPORTED_MODULE_4__definition__["e" /* GraphQLNonNull */])(__InputValue))),
        resolve: function resolve(field) {
          return field.args || [];
        }
      },
      type: { type: Object(__WEBPACK_IMPORTED_MODULE_4__definition__["e" /* GraphQLNonNull */])(__Type) },
      isDeprecated: { type: Object(__WEBPACK_IMPORTED_MODULE_4__definition__["e" /* GraphQLNonNull */])(__WEBPACK_IMPORTED_MODULE_5__scalars__["a" /* GraphQLBoolean */]) },
      deprecationReason: {
        type: __WEBPACK_IMPORTED_MODULE_5__scalars__["c" /* GraphQLString */]
      }
    };
  }
});

var __InputValue = new __WEBPACK_IMPORTED_MODULE_4__definition__["f" /* GraphQLObjectType */]({
  name: '__InputValue',
  isIntrospection: true,
  description: 'Arguments provided to Fields or Directives and the input fields of an ' + 'InputObject are represented as Input Values which describe their type ' + 'and optionally a default value.',
  fields: function fields() {
    return {
      name: { type: Object(__WEBPACK_IMPORTED_MODULE_4__definition__["e" /* GraphQLNonNull */])(__WEBPACK_IMPORTED_MODULE_5__scalars__["c" /* GraphQLString */]) },
      description: { type: __WEBPACK_IMPORTED_MODULE_5__scalars__["c" /* GraphQLString */] },
      type: { type: Object(__WEBPACK_IMPORTED_MODULE_4__definition__["e" /* GraphQLNonNull */])(__Type) },
      defaultValue: {
        type: __WEBPACK_IMPORTED_MODULE_5__scalars__["c" /* GraphQLString */],
        description: 'A GraphQL-formatted string representing the default value for this ' + 'input value.',
        resolve: function resolve(inputVal) {
          return Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_isInvalid__["a" /* default */])(inputVal.defaultValue) ? null : Object(__WEBPACK_IMPORTED_MODULE_3__language_printer__["a" /* print */])(Object(__WEBPACK_IMPORTED_MODULE_2__utilities_astFromValue__["a" /* astFromValue */])(inputVal.defaultValue, inputVal.type));
        }
      }
    };
  }
});

var __EnumValue = new __WEBPACK_IMPORTED_MODULE_4__definition__["f" /* GraphQLObjectType */]({
  name: '__EnumValue',
  isIntrospection: true,
  description: 'One possible value for a given Enum. Enum values are unique values, not ' + 'a placeholder for a string or numeric value. However an Enum value is ' + 'returned in a JSON response as a string.',
  fields: function fields() {
    return {
      name: { type: Object(__WEBPACK_IMPORTED_MODULE_4__definition__["e" /* GraphQLNonNull */])(__WEBPACK_IMPORTED_MODULE_5__scalars__["c" /* GraphQLString */]) },
      description: { type: __WEBPACK_IMPORTED_MODULE_5__scalars__["c" /* GraphQLString */] },
      isDeprecated: { type: Object(__WEBPACK_IMPORTED_MODULE_4__definition__["e" /* GraphQLNonNull */])(__WEBPACK_IMPORTED_MODULE_5__scalars__["a" /* GraphQLBoolean */]) },
      deprecationReason: {
        type: __WEBPACK_IMPORTED_MODULE_5__scalars__["c" /* GraphQLString */]
      }
    };
  }
});

var TypeKind = {
  SCALAR: 'SCALAR',
  OBJECT: 'OBJECT',
  INTERFACE: 'INTERFACE',
  UNION: 'UNION',
  ENUM: 'ENUM',
  INPUT_OBJECT: 'INPUT_OBJECT',
  LIST: 'LIST',
  NON_NULL: 'NON_NULL'
};

var __TypeKind = new __WEBPACK_IMPORTED_MODULE_4__definition__["a" /* GraphQLEnumType */]({
  name: '__TypeKind',
  isIntrospection: true,
  description: 'An enum describing what kind of type a given `__Type` is.',
  values: {
    SCALAR: {
      value: TypeKind.SCALAR,
      description: 'Indicates this type is a scalar.'
    },
    OBJECT: {
      value: TypeKind.OBJECT,
      description: 'Indicates this type is an object. ' + '`fields` and `interfaces` are valid fields.'
    },
    INTERFACE: {
      value: TypeKind.INTERFACE,
      description: 'Indicates this type is an interface. ' + '`fields` and `possibleTypes` are valid fields.'
    },
    UNION: {
      value: TypeKind.UNION,
      description: 'Indicates this type is a union. ' + '`possibleTypes` is a valid field.'
    },
    ENUM: {
      value: TypeKind.ENUM,
      description: 'Indicates this type is an enum. ' + '`enumValues` is a valid field.'
    },
    INPUT_OBJECT: {
      value: TypeKind.INPUT_OBJECT,
      description: 'Indicates this type is an input object. ' + '`inputFields` is a valid field.'
    },
    LIST: {
      value: TypeKind.LIST,
      description: 'Indicates this type is a list. ' + '`ofType` is a valid field.'
    },
    NON_NULL: {
      value: TypeKind.NON_NULL,
      description: 'Indicates this type is a non-null. ' + '`ofType` is a valid field.'
    }
  }
});

/**
 * Note that these are GraphQLField and not GraphQLFieldConfig,
 * so the format for args is different.
 */

var SchemaMetaFieldDef = {
  name: '__schema',
  type: Object(__WEBPACK_IMPORTED_MODULE_4__definition__["e" /* GraphQLNonNull */])(__Schema),
  description: 'Access the current type schema of this server.',
  args: [],
  resolve: function resolve(source, args, context, _ref4) {
    var schema = _ref4.schema;
    return schema;
  }
};

var TypeMetaFieldDef = {
  name: '__type',
  type: __Type,
  description: 'Request the type information of a single type.',
  args: [{ name: 'name', type: Object(__WEBPACK_IMPORTED_MODULE_4__definition__["e" /* GraphQLNonNull */])(__WEBPACK_IMPORTED_MODULE_5__scalars__["c" /* GraphQLString */]) }],
  resolve: function resolve(source, _ref5, context, _ref6) {
    var name = _ref5.name;
    var schema = _ref6.schema;
    return schema.getType(name);
  }
};

var TypeNameMetaFieldDef = {
  name: '__typename',
  type: Object(__WEBPACK_IMPORTED_MODULE_4__definition__["e" /* GraphQLNonNull */])(__WEBPACK_IMPORTED_MODULE_5__scalars__["c" /* GraphQLString */]),
  description: 'The name of the current Object type at runtime.',
  args: [],
  resolve: function resolve(source, args, context, _ref7) {
    var parentType = _ref7.parentType;
    return parentType.name;
  }
};

var introspectionTypes = [__Schema, __Directive, __DirectiveLocation, __Type, __Field, __InputValue, __EnumValue, __TypeKind];

function isIntrospectionType(type) {
  return Object(__WEBPACK_IMPORTED_MODULE_4__definition__["v" /* isNamedType */])(type) && (
  // Would prefer to use introspectionTypes.some(), however %checks needs
  // a simple expression.
  type.name === __Schema.name || type.name === __Directive.name || type.name === __DirectiveLocation.name || type.name === __Type.name || type.name === __Field.name || type.name === __InputValue.name || type.name === __EnumValue.name || type.name === __TypeKind.name);
}

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(94));

var _wrapDisplayName = _interopRequireDefault(__webpack_require__(175));

var _createMuiTheme = _interopRequireDefault(__webpack_require__(290));

var _themeListener = _interopRequireDefault(__webpack_require__(295));

var defaultTheme;

function getDefaultTheme() {
  if (defaultTheme) {
    return defaultTheme;
  }

  defaultTheme = (0, _createMuiTheme.default)();
  return defaultTheme;
} // Provide the theme object as a property to the input component.


var withTheme = function withTheme() {
  return function (Component) {
    var WithTheme =
    /*#__PURE__*/
    function (_React$Component) {
      (0, _inherits2.default)(WithTheme, _React$Component);

      function WithTheme(props, context) {
        var _this;

        (0, _classCallCheck2.default)(this, WithTheme);
        _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(WithTheme).call(this));
        _this.unsubscribeId = null;
        _this.state = {};
        _this.state = {
          // We use || as the function call is lazy evaluated.
          theme: _themeListener.default.initial(context) || getDefaultTheme()
        };
        return _this;
      }

      (0, _createClass2.default)(WithTheme, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var _this2 = this;

          this.unsubscribeId = _themeListener.default.subscribe(this.context, function (theme) {
            _this2.setState({
              theme: theme
            });
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          if (this.unsubscribeId !== null) {
            _themeListener.default.unsubscribe(this.context, this.unsubscribeId);
          }
        }
      }, {
        key: "render",
        value: function render() {
          var _this$props = this.props,
              innerRef = _this$props.innerRef,
              other = (0, _objectWithoutProperties2.default)(_this$props, ["innerRef"]);
          return _react.default.createElement(Component, (0, _extends2.default)({
            theme: this.state.theme,
            ref: innerRef
          }, other));
        }
      }]);
      return WithTheme;
    }(_react.default.Component);

    WithTheme.propTypes =  false ? {
      /**
       * Use that property to pass a ref callback to the decorated component.
       */
      innerRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object])
    } : {};
    WithTheme.contextTypes = _themeListener.default.contextTypes;

    if (false) {
      WithTheme.displayName = (0, _wrapDisplayName.default)(Component, 'WithTheme');
    }

    (0, _hoistNonReactStatics.default)(WithTheme, Component);

    if (false) {
      // Exposed for test purposes.
      WithTheme.Naked = Component;
    }

    return WithTheme;
  };
};

var _default = withTheme;
exports.default = _default;

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(797);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(803);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(451);
/* unused harmony reexport Link */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(804);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(805);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(807);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(808);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(453);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(297);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(809);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(810);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(811);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(812);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(813);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_13__withRouter__["a"]; });





























/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ButtonBase.default;
  }
});

var _ButtonBase = _interopRequireDefault(__webpack_require__(828));

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _classCallCheck = _interopDefault(__webpack_require__(840));
var _createClass = _interopDefault(__webpack_require__(841));
var _possibleConstructorReturn = _interopDefault(__webpack_require__(844));
var _getPrototypeOf = _interopDefault(__webpack_require__(846));
var _inherits = _interopDefault(__webpack_require__(847));
var _typeof = _interopDefault(__webpack_require__(224));
var _objectWithoutProperties = _interopDefault(__webpack_require__(849));
var _extends = _interopDefault(__webpack_require__(851));
var React = _interopDefault(__webpack_require__(0));
var PropTypes = _interopDefault(__webpack_require__(3));
var warning = _interopDefault(__webpack_require__(37));

function defineProperty(object, property, attr) {
  return Object.defineProperty(object, property, attr);
} // Passive options
// Inspired by https://github.com/Modernizr/Modernizr/blob/master/feature-detects/dom/passiveeventlisteners.js


var passiveOption = function () {
  var cache = null;
  return function () {
    if (cache !== null) {
      return cache;
    }

    var supportsPassiveOption = false;

    try {
      window.addEventListener('test', null, defineProperty({}, 'passive', {
        get: function get() {
          supportsPassiveOption = true;
        }
      }));
    } catch (err) {//
    }

    cache = supportsPassiveOption;
    return supportsPassiveOption;
  }();
}();

var defaultEventOptions = {
  capture: false,
  passive: false
};

function mergeDefaultEventOptions(options) {
  return _extends({}, defaultEventOptions, options);
}

function getEventListenerArgs(eventName, callback, options) {
  var args = [eventName, callback];
  args.push(passiveOption ? options : options.capture);
  return args;
}

function on(target, eventName, callback, options) {
  // eslint-disable-next-line prefer-spread
  target.addEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
}

function off(target, eventName, callback, options) {
  // eslint-disable-next-line prefer-spread
  target.removeEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
}

function forEachListener(props, iteratee) {
  var children = props.children,
      target = props.target,
      eventProps = _objectWithoutProperties(props, ["children", "target"]);

  Object.keys(eventProps).forEach(function (name) {
    if (name.substring(0, 2) !== 'on') {
      return;
    }

    var prop = eventProps[name];

    var type = _typeof(prop);

    var isObject = type === 'object';
    var isFunction = type === 'function';

    if (!isObject && !isFunction) {
      return;
    }

    var capture = name.substr(-7).toLowerCase() === 'capture';
    var eventName = name.substring(2).toLowerCase();
    eventName = capture ? eventName.substring(0, eventName.length - 7) : eventName;

    if (isObject) {
      iteratee(eventName, prop.handler, prop.options);
    } else {
      iteratee(eventName, prop, mergeDefaultEventOptions({
        capture: capture
      }));
    }
  });
}

function withOptions(handler, options) {
   false ? warning(options, 'react-event-listener: should be specified options in withOptions.') : void 0;
  return {
    handler: handler,
    options: mergeDefaultEventOptions(options)
  };
}

var EventListener =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(EventListener, _React$PureComponent);

  function EventListener() {
    _classCallCheck(this, EventListener);

    return _possibleConstructorReturn(this, _getPrototypeOf(EventListener).apply(this, arguments));
  }

  _createClass(EventListener, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.applyListeners(on);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.applyListeners(off, prevProps);
      this.applyListeners(on);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.applyListeners(off);
    }
  }, {
    key: "applyListeners",
    value: function applyListeners(onOrOff) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;
      var target = props.target;

      if (target) {
        var element = target;

        if (typeof target === 'string') {
          element = window[target];
        }

        forEachListener(props, onOrOff.bind(null, element));
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children || null;
    }
  }]);

  return EventListener;
}(React.PureComponent);

EventListener.propTypes =  false ? {
  /**
   * You can provide a single child too.
   */
  children: PropTypes.node,

  /**
   * The DOM target to listen to.
   */
  target: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired
} : {};

exports.withOptions = withOptions;
exports.default = EventListener;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = print;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__visitor__ = __webpack_require__(96);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */
function print(ast) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__visitor__["b" /* visit */])(ast, { leave: printDocASTReducer });
}

var printDocASTReducer = {
  Name: function Name(node) {
    return node.value;
  },
  Variable: function Variable(node) {
    return '$' + node.name;
  },

  // Document

  Document: function Document(node) {
    return join(node.definitions, '\n\n') + '\n';
  },

  OperationDefinition: function OperationDefinition(node) {
    var op = node.operation;
    var name = node.name;
    var varDefs = wrap('(', join(node.variableDefinitions, ', '), ')');
    var directives = join(node.directives, ' ');
    var selectionSet = node.selectionSet;
    // Anonymous queries with no directives or variable definitions can use
    // the query short form.
    return !name && !directives && !varDefs && op === 'query' ? selectionSet : join([op, join([name, varDefs]), directives, selectionSet], ' ');
  },


  VariableDefinition: function VariableDefinition(_ref) {
    var variable = _ref.variable,
        type = _ref.type,
        defaultValue = _ref.defaultValue;
    return variable + ': ' + type + wrap(' = ', defaultValue);
  },

  SelectionSet: function SelectionSet(_ref2) {
    var selections = _ref2.selections;
    return block(selections);
  },

  Field: function Field(_ref3) {
    var alias = _ref3.alias,
        name = _ref3.name,
        args = _ref3.arguments,
        directives = _ref3.directives,
        selectionSet = _ref3.selectionSet;
    return join([wrap('', alias, ': ') + name + wrap('(', join(args, ', '), ')'), join(directives, ' '), selectionSet], ' ');
  },

  Argument: function Argument(_ref4) {
    var name = _ref4.name,
        value = _ref4.value;
    return name + ': ' + value;
  },

  // Fragments

  FragmentSpread: function FragmentSpread(_ref5) {
    var name = _ref5.name,
        directives = _ref5.directives;
    return '...' + name + wrap(' ', join(directives, ' '));
  },

  InlineFragment: function InlineFragment(_ref6) {
    var typeCondition = _ref6.typeCondition,
        directives = _ref6.directives,
        selectionSet = _ref6.selectionSet;
    return join(['...', wrap('on ', typeCondition), join(directives, ' '), selectionSet], ' ');
  },

  FragmentDefinition: function FragmentDefinition(_ref7) {
    var name = _ref7.name,
        typeCondition = _ref7.typeCondition,
        variableDefinitions = _ref7.variableDefinitions,
        directives = _ref7.directives,
        selectionSet = _ref7.selectionSet;
    return (
      // Note: fragment variable definitions are experimental and may be changed
      // or removed in the future.
      'fragment ' + name + wrap('(', join(variableDefinitions, ', '), ')') + ' ' + ('on ' + typeCondition + ' ' + wrap('', join(directives, ' '), ' ')) + selectionSet
    );
  },

  // Value

  IntValue: function IntValue(_ref8) {
    var value = _ref8.value;
    return value;
  },
  FloatValue: function FloatValue(_ref9) {
    var value = _ref9.value;
    return value;
  },
  StringValue: function StringValue(_ref10, key) {
    var value = _ref10.value,
        isBlockString = _ref10.block;
    return isBlockString ? printBlockString(value, key === 'description') : JSON.stringify(value);
  },
  BooleanValue: function BooleanValue(_ref11) {
    var value = _ref11.value;
    return value ? 'true' : 'false';
  },
  NullValue: function NullValue() {
    return 'null';
  },
  EnumValue: function EnumValue(_ref12) {
    var value = _ref12.value;
    return value;
  },
  ListValue: function ListValue(_ref13) {
    var values = _ref13.values;
    return '[' + join(values, ', ') + ']';
  },
  ObjectValue: function ObjectValue(_ref14) {
    var fields = _ref14.fields;
    return '{' + join(fields, ', ') + '}';
  },
  ObjectField: function ObjectField(_ref15) {
    var name = _ref15.name,
        value = _ref15.value;
    return name + ': ' + value;
  },

  // Directive

  Directive: function Directive(_ref16) {
    var name = _ref16.name,
        args = _ref16.arguments;
    return '@' + name + wrap('(', join(args, ', '), ')');
  },

  // Type

  NamedType: function NamedType(_ref17) {
    var name = _ref17.name;
    return name;
  },
  ListType: function ListType(_ref18) {
    var type = _ref18.type;
    return '[' + type + ']';
  },
  NonNullType: function NonNullType(_ref19) {
    var type = _ref19.type;
    return type + '!';
  },

  // Type System Definitions

  SchemaDefinition: function SchemaDefinition(_ref20) {
    var directives = _ref20.directives,
        operationTypes = _ref20.operationTypes;
    return join(['schema', join(directives, ' '), block(operationTypes)], ' ');
  },

  OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
    var operation = _ref21.operation,
        type = _ref21.type;
    return operation + ': ' + type;
  },

  ScalarTypeDefinition: addDescription(function (_ref22) {
    var name = _ref22.name,
        directives = _ref22.directives;
    return join(['scalar', name, join(directives, ' ')], ' ');
  }),

  ObjectTypeDefinition: addDescription(function (_ref23) {
    var name = _ref23.name,
        interfaces = _ref23.interfaces,
        directives = _ref23.directives,
        fields = _ref23.fields;
    return join(['type', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  }),

  FieldDefinition: addDescription(function (_ref24) {
    var name = _ref24.name,
        args = _ref24.arguments,
        type = _ref24.type,
        directives = _ref24.directives;
    return name + wrap('(', join(args, ', '), ')') + ': ' + type + wrap(' ', join(directives, ' '));
  }),

  InputValueDefinition: addDescription(function (_ref25) {
    var name = _ref25.name,
        type = _ref25.type,
        defaultValue = _ref25.defaultValue,
        directives = _ref25.directives;
    return join([name + ': ' + type, wrap('= ', defaultValue), join(directives, ' ')], ' ');
  }),

  InterfaceTypeDefinition: addDescription(function (_ref26) {
    var name = _ref26.name,
        directives = _ref26.directives,
        fields = _ref26.fields;
    return join(['interface', name, join(directives, ' '), block(fields)], ' ');
  }),

  UnionTypeDefinition: addDescription(function (_ref27) {
    var name = _ref27.name,
        directives = _ref27.directives,
        types = _ref27.types;
    return join(['union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
  }),

  EnumTypeDefinition: addDescription(function (_ref28) {
    var name = _ref28.name,
        directives = _ref28.directives,
        values = _ref28.values;
    return join(['enum', name, join(directives, ' '), block(values)], ' ');
  }),

  EnumValueDefinition: addDescription(function (_ref29) {
    var name = _ref29.name,
        directives = _ref29.directives;
    return join([name, join(directives, ' ')], ' ');
  }),

  InputObjectTypeDefinition: addDescription(function (_ref30) {
    var name = _ref30.name,
        directives = _ref30.directives,
        fields = _ref30.fields;
    return join(['input', name, join(directives, ' '), block(fields)], ' ');
  }),

  ScalarTypeExtension: function ScalarTypeExtension(_ref31) {
    var name = _ref31.name,
        directives = _ref31.directives;
    return join(['extend scalar', name, join(directives, ' ')], ' ');
  },

  ObjectTypeExtension: function ObjectTypeExtension(_ref32) {
    var name = _ref32.name,
        interfaces = _ref32.interfaces,
        directives = _ref32.directives,
        fields = _ref32.fields;
    return join(['extend type', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  },

  InterfaceTypeExtension: function InterfaceTypeExtension(_ref33) {
    var name = _ref33.name,
        directives = _ref33.directives,
        fields = _ref33.fields;
    return join(['extend interface', name, join(directives, ' '), block(fields)], ' ');
  },

  UnionTypeExtension: function UnionTypeExtension(_ref34) {
    var name = _ref34.name,
        directives = _ref34.directives,
        types = _ref34.types;
    return join(['extend union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
  },

  EnumTypeExtension: function EnumTypeExtension(_ref35) {
    var name = _ref35.name,
        directives = _ref35.directives,
        values = _ref35.values;
    return join(['extend enum', name, join(directives, ' '), block(values)], ' ');
  },

  InputObjectTypeExtension: function InputObjectTypeExtension(_ref36) {
    var name = _ref36.name,
        directives = _ref36.directives,
        fields = _ref36.fields;
    return join(['extend input', name, join(directives, ' '), block(fields)], ' ');
  },

  DirectiveDefinition: addDescription(function (_ref37) {
    var name = _ref37.name,
        args = _ref37.arguments,
        locations = _ref37.locations;
    return 'directive @' + name + wrap('(', join(args, ', '), ')') + ' on ' + join(locations, ' | ');
  })
};

function addDescription(cb) {
  return function (node) {
    return join([node.description, cb(node)], '\n');
  };
}

/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */
function join(maybeArray, separator) {
  return maybeArray ? maybeArray.filter(function (x) {
    return x;
  }).join(separator || '') : '';
}

/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */
function block(array) {
  return array && array.length !== 0 ? '{\n' + indent(join(array, '\n')) + '\n}' : '';
}

/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise
 * print an empty string.
 */
function wrap(start, maybeString, end) {
  return maybeString ? start + maybeString + (end || '') : '';
}

function indent(maybeString) {
  return maybeString && '  ' + maybeString.replace(/\n/g, '\n  ');
}

/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 */
function printBlockString(value, isDescription) {
  var escaped = value.replace(/"""/g, '\\"""');
  return (value[0] === ' ' || value[0] === '\t') && value.indexOf('\n') === -1 ? '"""' + escaped.replace(/"$/, '"\n') + '"""' : '"""\n' + (isDescription ? escaped : indent(escaped)) + '\n"""';
}

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export QueryDocumentKeys */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BREAK; });
/* harmony export (immutable) */ __webpack_exports__["b"] = visit;
/* harmony export (immutable) */ __webpack_exports__["c"] = visitInParallel;
/* harmony export (immutable) */ __webpack_exports__["d"] = visitWithTypeInfo;
/* unused harmony export getVisitFn */


/**
 * A visitor is comprised of visit functions, which are called on each node
 * during the visitor's traversal.
 */


/**
 * A visitor is provided to visit, it contains the collection of
 * relevant functions to be called during the visitor's traversal.
 */
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

var QueryDocumentKeys = {
  Name: [],

  Document: ['definitions'],
  OperationDefinition: ['name', 'variableDefinitions', 'directives', 'selectionSet'],
  VariableDefinition: ['variable', 'type', 'defaultValue'],
  Variable: ['name'],
  SelectionSet: ['selections'],
  Field: ['alias', 'name', 'arguments', 'directives', 'selectionSet'],
  Argument: ['name', 'value'],

  FragmentSpread: ['name', 'directives'],
  InlineFragment: ['typeCondition', 'directives', 'selectionSet'],
  FragmentDefinition: ['name',
  // Note: fragment variable definitions are experimental and may be changed
  // or removed in the future.
  'variableDefinitions', 'typeCondition', 'directives', 'selectionSet'],

  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ['values'],
  ObjectValue: ['fields'],
  ObjectField: ['name', 'value'],

  Directive: ['name', 'arguments'],

  NamedType: ['name'],
  ListType: ['type'],
  NonNullType: ['type'],

  SchemaDefinition: ['directives', 'operationTypes'],
  OperationTypeDefinition: ['type'],

  ScalarTypeDefinition: ['description', 'name', 'directives'],
  ObjectTypeDefinition: ['description', 'name', 'interfaces', 'directives', 'fields'],
  FieldDefinition: ['description', 'name', 'arguments', 'type', 'directives'],
  InputValueDefinition: ['description', 'name', 'type', 'defaultValue', 'directives'],
  InterfaceTypeDefinition: ['description', 'name', 'directives', 'fields'],
  UnionTypeDefinition: ['description', 'name', 'directives', 'types'],
  EnumTypeDefinition: ['description', 'name', 'directives', 'values'],
  EnumValueDefinition: ['description', 'name', 'directives'],
  InputObjectTypeDefinition: ['description', 'name', 'directives', 'fields'],

  ScalarTypeExtension: ['name', 'directives'],
  ObjectTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  InterfaceTypeExtension: ['name', 'directives', 'fields'],
  UnionTypeExtension: ['name', 'directives', 'types'],
  EnumTypeExtension: ['name', 'directives', 'values'],
  InputObjectTypeExtension: ['name', 'directives', 'fields'],

  DirectiveDefinition: ['description', 'name', 'arguments', 'locations']
};

/**
 * A KeyMap describes each the traversable properties of each kind of node.
 */


var BREAK = {};

/**
 * visit() will walk through an AST using a depth first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 *     const editedAST = visit(ast, {
 *       enter(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: skip visiting this node
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       },
 *       leave(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: no action
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       }
 *     });
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to four permutations of
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node a specific kind.
 *
 *     visit(ast, {
 *       Kind(node) {
 *         // enter the "Kind" node
 *       }
 *     })
 *
 * 2) Named visitors that trigger upon entering and leaving a node of
 *    a specific kind.
 *
 *     visit(ast, {
 *       Kind: {
 *         enter(node) {
 *           // enter the "Kind" node
 *         }
 *         leave(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 *     visit(ast, {
 *       enter(node) {
 *         // enter any node
 *       },
 *       leave(node) {
 *         // leave any node
 *       }
 *     })
 *
 * 4) Parallel visitors for entering and leaving nodes of a specific kind.
 *
 *     visit(ast, {
 *       enter: {
 *         Kind(node) {
 *           // enter the "Kind" node
 *         }
 *       },
 *       leave: {
 *         Kind(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 */
function visit(root, visitor) {
  var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : QueryDocumentKeys;

  /* eslint-disable no-undef-init */
  var stack = undefined;
  var inArray = Array.isArray(root);
  var keys = [root];
  var index = -1;
  var edits = [];
  var node = undefined;
  var key = undefined;
  var parent = undefined;
  var path = [];
  var ancestors = [];
  var newRoot = root;
  /* eslint-enable no-undef-init */

  do {
    index++;
    var isLeaving = index === keys.length;
    var isEdited = isLeaving && edits.length !== 0;
    if (isLeaving) {
      key = ancestors.length === 0 ? undefined : path[path.length - 1];
      node = parent;
      parent = ancestors.pop();
      if (isEdited) {
        if (inArray) {
          node = node.slice();
        } else {
          var clone = {};
          for (var k in node) {
            if (node.hasOwnProperty(k)) {
              clone[k] = node[k];
            }
          }
          node = clone;
        }
        var editOffset = 0;
        for (var ii = 0; ii < edits.length; ii++) {
          var editKey = edits[ii][0];
          var editValue = edits[ii][1];
          if (inArray) {
            editKey -= editOffset;
          }
          if (inArray && editValue === null) {
            node.splice(editKey, 1);
            editOffset++;
          } else {
            node[editKey] = editValue;
          }
        }
      }
      index = stack.index;
      keys = stack.keys;
      edits = stack.edits;
      inArray = stack.inArray;
      stack = stack.prev;
    } else {
      key = parent ? inArray ? index : keys[index] : undefined;
      node = parent ? parent[key] : newRoot;
      if (node === null || node === undefined) {
        continue;
      }
      if (parent) {
        path.push(key);
      }
    }

    var result = void 0;
    if (!Array.isArray(node)) {
      if (!isNode(node)) {
        throw new Error('Invalid AST Node: ' + JSON.stringify(node));
      }
      var visitFn = getVisitFn(visitor, node.kind, isLeaving);
      if (visitFn) {
        result = visitFn.call(visitor, node, key, parent, path, ancestors);

        if (result === BREAK) {
          break;
        }

        if (result === false) {
          if (!isLeaving) {
            path.pop();
            continue;
          }
        } else if (result !== undefined) {
          edits.push([key, result]);
          if (!isLeaving) {
            if (isNode(result)) {
              node = result;
            } else {
              path.pop();
              continue;
            }
          }
        }
      }
    }

    if (result === undefined && isEdited) {
      edits.push([key, node]);
    }

    if (isLeaving) {
      path.pop();
    } else {
      stack = { inArray: inArray, index: index, keys: keys, edits: edits, prev: stack };
      inArray = Array.isArray(node);
      keys = inArray ? node : visitorKeys[node.kind] || [];
      index = -1;
      edits = [];
      if (parent) {
        ancestors.push(parent);
      }
      parent = node;
    }
  } while (stack !== undefined);

  if (edits.length !== 0) {
    newRoot = edits[edits.length - 1][1];
  }

  return newRoot;
}

function isNode(maybeNode) {
  return Boolean(maybeNode && typeof maybeNode.kind === 'string');
}

/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */
function visitInParallel(visitors) {
  var skipping = new Array(visitors.length);

  return {
    enter: function enter(node) {
      for (var i = 0; i < visitors.length; i++) {
        if (!skipping[i]) {
          var fn = getVisitFn(visitors[i], node.kind, /* isLeaving */false);
          if (fn) {
            var result = fn.apply(visitors[i], arguments);
            if (result === false) {
              skipping[i] = node;
            } else if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined) {
              return result;
            }
          }
        }
      }
    },
    leave: function leave(node) {
      for (var i = 0; i < visitors.length; i++) {
        if (!skipping[i]) {
          var fn = getVisitFn(visitors[i], node.kind, /* isLeaving */true);
          if (fn) {
            var result = fn.apply(visitors[i], arguments);
            if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined && result !== false) {
              return result;
            }
          }
        } else if (skipping[i] === node) {
          skipping[i] = null;
        }
      }
    }
  };
}

/**
 * Creates a new visitor instance which maintains a provided TypeInfo instance
 * along with visiting visitor.
 */
function visitWithTypeInfo(typeInfo, visitor) {
  return {
    enter: function enter(node) {
      typeInfo.enter(node);
      var fn = getVisitFn(visitor, node.kind, /* isLeaving */false);
      if (fn) {
        var result = fn.apply(visitor, arguments);
        if (result !== undefined) {
          typeInfo.leave(node);
          if (isNode(result)) {
            typeInfo.enter(result);
          }
        }
        return result;
      }
    },
    leave: function leave(node) {
      var fn = getVisitFn(visitor, node.kind, /* isLeaving */true);
      var result = void 0;
      if (fn) {
        result = fn.apply(visitor, arguments);
      }
      typeInfo.leave(node);
      return result;
    }
  };
}

/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 */
function getVisitFn(visitor, kind, isLeaving) {
  var kindVisitor = visitor[kind];
  if (kindVisitor) {
    if (!isLeaving && typeof kindVisitor === 'function') {
      // { Kind() {} }
      return kindVisitor;
    }
    var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
    if (typeof kindSpecificVisitor === 'function') {
      // { Kind: { enter() {}, leave() {} } }
      return kindSpecificVisitor;
    }
  } else {
    var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
    if (specificVisitor) {
      if (typeof specificVisitor === 'function') {
        // { enter() {}, leave() {} }
        return specificVisitor;
      }
      var specificKindVisitor = specificVisitor[kind];
      if (typeof specificKindVisitor === 'function') {
        // { enter: { Kind() {} }, leave: { Kind() {} } }
        return specificKindVisitor;
      }
    }
  }
}

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = typeFromAST;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__language_kinds__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type_definition__ = __webpack_require__(46);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */





/**
 * Given a Schema and an AST node describing a type, return a GraphQLType
 * definition which applies to that type. For example, if provided the parsed
 * AST node for `[User]`, a GraphQLList instance will be returned, containing
 * the type called "User" found in the schema. If a type called "User" is not
 * found in the schema, then undefined will be returned.
 */
/* eslint-disable no-redeclare */

function typeFromAST(schema, typeNode) {
  /* eslint-enable no-redeclare */
  var innerType = void 0;
  if (typeNode.kind === __WEBPACK_IMPORTED_MODULE_0__language_kinds__["a" /* Kind */].LIST_TYPE) {
    innerType = typeFromAST(schema, typeNode.type);
    return innerType && Object(__WEBPACK_IMPORTED_MODULE_1__type_definition__["d" /* GraphQLList */])(innerType);
  }
  if (typeNode.kind === __WEBPACK_IMPORTED_MODULE_0__language_kinds__["a" /* Kind */].NON_NULL_TYPE) {
    innerType = typeFromAST(schema, typeNode.type);
    return innerType && Object(__WEBPACK_IMPORTED_MODULE_1__type_definition__["e" /* GraphQLNonNull */])(innerType);
  }
  if (typeNode.kind === __WEBPACK_IMPORTED_MODULE_0__language_kinds__["a" /* Kind */].NAMED_TYPE) {
    return schema.getType(typeNode.name.value);
  }
  /* istanbul ignore next */
  throw new Error('Unexpected type kind: ' + typeNode.kind + '.');
}

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["e"] = __rest;
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* harmony export (immutable) */ __webpack_exports__["b"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["d"] = __generator;
/* unused harmony export __createBinding */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* harmony export (immutable) */ __webpack_exports__["f"] = __spreadArrays;
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/* unused harmony export __classPrivateFieldGet */
/* unused harmony export __classPrivateFieldSet */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.isNumber = exports.isString = exports.formatMs = exports.duration = exports.easing = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _warning = _interopRequireDefault(__webpack_require__(37));

/* eslint-disable no-param-reassign */

/* eslint-disable no-restricted-globals */
// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
var easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing

exports.easing = easing;
var duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
exports.duration = duration;

var formatMs = function formatMs(milliseconds) {
  return "".concat(Math.round(milliseconds), "ms");
};

exports.formatMs = formatMs;

var isString = function isString(value) {
  return typeof value === 'string';
};

exports.isString = isString;

var isNumber = function isNumber(value) {
  return !isNaN(parseFloat(value));
};
/**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */


exports.isNumber = isNumber;
var _default = {
  easing: easing,
  duration: duration,
  create: function create() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$duration = options.duration,
        durationOption = _options$duration === void 0 ? duration.standard : _options$duration,
        _options$easing = options.easing,
        easingOption = _options$easing === void 0 ? easing.easeInOut : _options$easing,
        _options$delay = options.delay,
        delay = _options$delay === void 0 ? 0 : _options$delay,
        other = (0, _objectWithoutProperties2.default)(options, ["duration", "easing", "delay"]);
     false ? (0, _warning.default)(isString(props) || Array.isArray(props), 'Material-UI: argument "props" must be a string or Array.') : void 0;
     false ? (0, _warning.default)(isNumber(durationOption) || isString(durationOption), "Material-UI: argument \"duration\" must be a number or a string but found ".concat(durationOption, ".")) : void 0;
     false ? (0, _warning.default)(isString(easingOption), 'Material-UI: argument "easing" must be a string.') : void 0;
     false ? (0, _warning.default)(isNumber(delay) || isString(delay), 'Material-UI: argument "delay" must be a number or a string.') : void 0;
     false ? (0, _warning.default)(Object.keys(other).length === 0, "Material-UI: unrecognized argument(s) [".concat(Object.keys(other).join(','), "]")) : void 0;
    return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
      return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
    }).join(',');
  },
  getAutoHeightDuration: function getAutoHeightDuration(height) {
    if (!height) {
      return 0;
    }

    var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10

    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
  }
};
exports.default = _default;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

var _default = ownerDocument;
exports.default = _default;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(64));

var _reactLifecyclesCompat = __webpack_require__(465);

var _PropTypes = __webpack_require__(466);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Radio.default;
  }
});

var _Radio = _interopRequireDefault(__webpack_require__(1039));

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return durationSecond; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return durationMinute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return durationHour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return durationDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return durationWeek; });
var durationSecond = 1e3;
var durationMinute = 6e4;
var durationHour = 36e5;
var durationDay = 864e5;
var durationWeek = 6048e5;


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GraphQLInt */
/* unused harmony export GraphQLFloat */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GraphQLString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GraphQLBoolean; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GraphQLID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return specifiedScalarTypes; });
/* harmony export (immutable) */ __webpack_exports__["d"] = isSpecifiedScalarType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__definition__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__language_kinds__ = __webpack_require__(57);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */




// As per the GraphQL Spec, Integers are only treated as valid when a valid
// 32-bit signed integer, providing the broadest support across platforms.
//
// n.b. JavaScript's integers are safe between -(2^53 - 1) and 2^53 - 1 because
// they are internally represented as IEEE 754 doubles.
var MAX_INT = 2147483647;
var MIN_INT = -2147483648;

function coerceInt(value) {
  if (value === '') {
    throw new TypeError('Int cannot represent non 32-bit signed integer value: (empty string)');
  }
  var num = Number(value);
  if (num !== num || num > MAX_INT || num < MIN_INT) {
    throw new TypeError('Int cannot represent non 32-bit signed integer value: ' + String(value));
  }
  var int = Math.floor(num);
  if (int !== num) {
    throw new TypeError('Int cannot represent non-integer value: ' + String(value));
  }
  return int;
}

var GraphQLInt = new __WEBPACK_IMPORTED_MODULE_0__definition__["g" /* GraphQLScalarType */]({
  name: 'Int',
  description: 'The `Int` scalar type represents non-fractional signed whole numeric ' + 'values. Int can represent values between -(2^31) and 2^31 - 1. ',
  serialize: coerceInt,
  parseValue: coerceInt,
  parseLiteral: function parseLiteral(ast) {
    if (ast.kind === __WEBPACK_IMPORTED_MODULE_1__language_kinds__["a" /* Kind */].INT) {
      var num = parseInt(ast.value, 10);
      if (num <= MAX_INT && num >= MIN_INT) {
        return num;
      }
    }
    return undefined;
  }
});

function coerceFloat(value) {
  if (value === '') {
    throw new TypeError('Float cannot represent non numeric value: (empty string)');
  }
  var num = Number(value);
  if (num === num) {
    return num;
  }
  throw new TypeError('Float cannot represent non numeric value: ' + String(value));
}

var GraphQLFloat = new __WEBPACK_IMPORTED_MODULE_0__definition__["g" /* GraphQLScalarType */]({
  name: 'Float',
  description: 'The `Float` scalar type represents signed double-precision fractional ' + 'values as specified by ' + '[IEEE 754](http://en.wikipedia.org/wiki/IEEE_floating_point). ',
  serialize: coerceFloat,
  parseValue: coerceFloat,
  parseLiteral: function parseLiteral(ast) {
    return ast.kind === __WEBPACK_IMPORTED_MODULE_1__language_kinds__["a" /* Kind */].FLOAT || ast.kind === __WEBPACK_IMPORTED_MODULE_1__language_kinds__["a" /* Kind */].INT ? parseFloat(ast.value) : undefined;
  }
});

function coerceString(value) {
  if (Array.isArray(value)) {
    throw new TypeError('String cannot represent an array value: [' + String(value) + ']');
  }
  return String(value);
}

var GraphQLString = new __WEBPACK_IMPORTED_MODULE_0__definition__["g" /* GraphQLScalarType */]({
  name: 'String',
  description: 'The `String` scalar type represents textual data, represented as UTF-8 ' + 'character sequences. The String type is most often used by GraphQL to ' + 'represent free-form human-readable text.',
  serialize: coerceString,
  parseValue: coerceString,
  parseLiteral: function parseLiteral(ast) {
    return ast.kind === __WEBPACK_IMPORTED_MODULE_1__language_kinds__["a" /* Kind */].STRING ? ast.value : undefined;
  }
});

var GraphQLBoolean = new __WEBPACK_IMPORTED_MODULE_0__definition__["g" /* GraphQLScalarType */]({
  name: 'Boolean',
  description: 'The `Boolean` scalar type represents `true` or `false`.',
  serialize: Boolean,
  parseValue: Boolean,
  parseLiteral: function parseLiteral(ast) {
    return ast.kind === __WEBPACK_IMPORTED_MODULE_1__language_kinds__["a" /* Kind */].BOOLEAN ? ast.value : undefined;
  }
});

var GraphQLID = new __WEBPACK_IMPORTED_MODULE_0__definition__["g" /* GraphQLScalarType */]({
  name: 'ID',
  description: 'The `ID` scalar type represents a unique identifier, often used to ' + 'refetch an object or as key for a cache. The ID type appears in a JSON ' + 'response as a String; however, it is not intended to be human-readable. ' + 'When expected as an input type, any string (such as `"4"`) or integer ' + '(such as `4`) input value will be accepted as an ID.',
  serialize: String,
  parseValue: String,
  parseLiteral: function parseLiteral(ast) {
    return ast.kind === __WEBPACK_IMPORTED_MODULE_1__language_kinds__["a" /* Kind */].STRING || ast.kind === __WEBPACK_IMPORTED_MODULE_1__language_kinds__["a" /* Kind */].INT ? ast.value : undefined;
  }
});

var specifiedScalarTypes = [GraphQLString, GraphQLInt, GraphQLFloat, GraphQLBoolean, GraphQLID];

function isSpecifiedScalarType(type) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__definition__["v" /* isNamedType */])(type) && (
  // Would prefer to use specifiedScalarTypes.some(), however %checks needs
  // a simple expression.
  type.name === GraphQLString.name || type.name === GraphQLInt.name || type.name === GraphQLFloat.name || type.name === GraphQLBoolean.name || type.name === GraphQLID.name);
}

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* eslint-disable no-redeclare */
// $FlowFixMe workaround for: https://github.com/facebook/flow/issues/2221
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

var objectValues = Object.values || function (obj) {
  return Object.keys(obj).map(function (key) {
    return obj[key];
  });
};
/* harmony default export */ __webpack_exports__["a"] = (objectValues);

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = GraphQLError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__printError__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__language_location__ = __webpack_require__(274);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */




/**
 * A GraphQLError describes an Error found during the parse, validate, or
 * execute phases of performing a GraphQL operation. In addition to a message
 * and stack trace, it also includes information about the locations in a
 * GraphQL document and/or execution result that correspond to the Error.
 */


function GraphQLError( // eslint-disable-line no-redeclare
message, nodes, source, positions, path, originalError, extensions) {
  // Compute list of blame nodes.
  var _nodes = Array.isArray(nodes) ? nodes.length !== 0 ? nodes : undefined : nodes ? [nodes] : undefined;

  // Compute locations in the source for the given nodes/positions.
  var _source = source;
  if (!_source && _nodes) {
    var node = _nodes[0];
    _source = node && node.loc && node.loc.source;
  }

  var _positions = positions;
  if (!_positions && _nodes) {
    _positions = _nodes.reduce(function (list, node) {
      if (node.loc) {
        list.push(node.loc.start);
      }
      return list;
    }, []);
  }
  if (_positions && _positions.length === 0) {
    _positions = undefined;
  }

  var _locations = void 0;
  if (positions && source) {
    _locations = positions.map(function (pos) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__language_location__["a" /* getLocation */])(source, pos);
    });
  } else if (_nodes) {
    _locations = _nodes.reduce(function (list, node) {
      if (node.loc) {
        list.push(Object(__WEBPACK_IMPORTED_MODULE_1__language_location__["a" /* getLocation */])(node.loc.source, node.loc.start));
      }
      return list;
    }, []);
  }

  Object.defineProperties(this, {
    message: {
      value: message,
      // By being enumerable, JSON.stringify will include `message` in the
      // resulting output. This ensures that the simplest possible GraphQL
      // service adheres to the spec.
      enumerable: true,
      writable: true
    },
    locations: {
      // Coercing falsey values to undefined ensures they will not be included
      // in JSON.stringify() when not provided.
      value: _locations || undefined,
      // By being enumerable, JSON.stringify will include `locations` in the
      // resulting output. This ensures that the simplest possible GraphQL
      // service adheres to the spec.
      enumerable: true
    },
    path: {
      // Coercing falsey values to undefined ensures they will not be included
      // in JSON.stringify() when not provided.
      value: path || undefined,
      // By being enumerable, JSON.stringify will include `path` in the
      // resulting output. This ensures that the simplest possible GraphQL
      // service adheres to the spec.
      enumerable: true
    },
    nodes: {
      value: _nodes || undefined
    },
    source: {
      value: _source || undefined
    },
    positions: {
      value: _positions || undefined
    },
    originalError: {
      value: originalError
    },
    extensions: {
      value: extensions || originalError && originalError.extensions
    }
  });

  // Include (non-enumerable) stack trace.
  if (originalError && originalError.stack) {
    Object.defineProperty(this, 'stack', {
      value: originalError.stack,
      writable: true,
      configurable: true
    });
  } else if (Error.captureStackTrace) {
    Error.captureStackTrace(this, GraphQLError);
  } else {
    Object.defineProperty(this, 'stack', {
      value: Error().stack,
      writable: true,
      configurable: true
    });
  }
}

GraphQLError.prototype = Object.create(Error.prototype, {
  constructor: { value: GraphQLError },
  name: { value: 'GraphQLError' },
  toString: {
    value: function toString() {
      return Object(__WEBPACK_IMPORTED_MODULE_0__printError__["a" /* printError */])(this);
    }
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = keyMap;


/**
 * Creates a keyed JS object from an array, given a function to produce the keys
 * for each value in the array.
 *
 * This provides a convenient lookup for the array items if the key function
 * produces unique results.
 *
 *     const phoneBook = [
 *       { name: 'Jon', num: '555-1234' },
 *       { name: 'Jenny', num: '867-5309' }
 *     ]
 *
 *     // { Jon: { name: 'Jon', num: '555-1234' },
 *     //   Jenny: { name: 'Jenny', num: '867-5309' } }
 *     const entriesByName = keyMap(
 *       phoneBook,
 *       entry => entry.name
 *     )
 *
 *     // { name: 'Jenny', num: '857-6309' }
 *     const jennyEntry = entriesByName['Jenny']
 *
 */
function keyMap(list, keyFn) {
  return list.reduce(function (map, item) {
    return map[keyFn(item)] = item, map;
  }, Object.create(null));
} /**
   * Copyright (c) 2015-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *
   *  strict
   */

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Modal.default;
  }
});
Object.defineProperty(exports, "ModalManager", {
  enumerable: true,
  get: function get() {
    return _ModalManager.default;
  }
});

var _Modal = _interopRequireDefault(__webpack_require__(859));

var _ModalManager = _interopRequireDefault(__webpack_require__(470));

/***/ }),
/* 109 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Chip.default;
  }
});

var _Chip = _interopRequireDefault(__webpack_require__(962));

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
})), 'Menu');

exports.default = _default;

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Mail__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Mail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Mail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_ContactPhone__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_ContactPhone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_ContactPhone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Person__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Person___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Person__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_LocationOn__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_LocationOn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_LocationOn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_LocationCity__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_LocationCity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_LocationCity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Card__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_CardHeader__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_CardHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_CardHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_CardContent__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_CardContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_CardContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_CardActions__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_CardActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_CardActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_icons_AccountCircle__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_icons_AccountCircle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_icons_AccountCircle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_icons_Timelapse__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_icons_Timelapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_icons_Timelapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_icons_DirectionsCar__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_icons_DirectionsCar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__material_ui_icons_DirectionsCar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_icons_SettingsPower__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_icons_SettingsPower___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__material_ui_icons_SettingsPower__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__common_Loader__ = __webpack_require__(47);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query GetAdminUserDetailsByRole($roleName: [String]) {\n    getAdminUserDetailsByRole(roleName: $roleName) {\n      id\n      role\n      username\n    }\n  }\n'],['\n  query GetAdminUserDetailsByRole($roleName: [String]) {\n    getAdminUserDetailsByRole(roleName: $roleName) {\n      id\n      role\n      username\n    }\n  }\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// import BubbleChartIcon from '@material-ui/icons/BubbleChart'
// import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew'
var styles=function styles(theme){return{card:{wordBreak:'break-all'},cardItemIcon:{paddingRight:'10px'}};};var GET_ZM_KAM_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_17_graphql_tag__["a" /* default */])(_templateObject);var roleNames=["Zonal Manager(ZM)","Key Account Manager(KAM)"];var CustomerDetailsCard=function(_Component){_inherits(CustomerDetailsCard,_Component);function CustomerDetailsCard(){_classCallCheck(this,CustomerDetailsCard);return _possibleConstructorReturn(this,(CustomerDetailsCard.__proto__||Object.getPrototypeOf(CustomerDetailsCard)).apply(this,arguments));}_createClass(CustomerDetailsCard,[{key:'render',value:function render(){var _props=this.props,classes=_props.classes,clientDetail=_props.clientDetail,actions=_props.actions;console.log('icons',clientDetail);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_react_apollo__["Query"],{query:GET_ZM_KAM_DETAILS,variables:{roleName:roleNames}// fetchPolicy="network-only"
},function(_ref){var loadingZMKAM=_ref.loading,errorZMKAM=_ref.error,_ref$data=_ref.data;_ref$data=_ref$data===undefined?{}:_ref$data;var getAdminUserDetailsByRole=_ref$data.getAdminUserDetailsByRole;if(loadingZMKAM)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__common_Loader__["a" /* default */],null);if(errorZMKAM)return'Error with ZM/KAM details: '+errorZMKAM.message;// Process clients and ZM/KAM details
var zonalManagers=getAdminUserDetailsByRole.filter(function(user){return user.role==="Zonal Manager(ZM)";});var keyAccountManagers=getAdminUserDetailsByRole.filter(function(user){return user.role==="Key Account Manager(KAM)";});var zonalManager=zonalManagers.find(function(zm){return zm.id===clientDetail.zonalManager;});var zonalManagerUsername=zonalManager?zonalManager.username:'N/A';var keyAccountManager=keyAccountManagers.find(function(zm){return zm.id===clientDetail.keyAccountManager;});var keyAccountManagerUsername=keyAccountManager?keyAccountManager.username:'N/A';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Card___default.a,{className:classes.card},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_CardHeader___default.a,{title:clientDetail.clientName,subheader:'Customer Details'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,alignItems:'baseline',spacing:16},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:6,sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,alignItems:'flex-start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,md:'auto',className:classes.cardItemIcon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Person___default.a,{color:'primary'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body2'},'Contact Person:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body1'},clientDetail.contactPerson||'N/A')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:6,sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,alignItems:'flex-start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,md:'auto',className:classes.cardItemIcon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_icons_AccountCircle___default.a,{color:'primary'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body2'},'Account Type:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body1'},clientDetail.type||'N/A')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:6,sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,alignItems:'flex-start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,md:'auto',className:classes.cardItemIcon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_LocationOn___default.a,{color:'primary'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body2'},'Address:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body1'},clientDetail.address||'N/A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body1'},(clientDetail.city||'N/A')+' '+(clientDetail.state.name||'')+' '+(clientDetail.country.name||'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body1'},clientDetail.pincode||'')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:6,sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,alignItems:'flex-start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,md:'auto',className:classes.cardItemIcon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Mail___default.a,{color:'primary'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body2'},'E-Mail:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body1'},clientDetail.email||'N/A')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:6,sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,alignItems:'flex-start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,md:'auto',className:classes.cardItemIcon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_ContactPhone___default.a,{color:'primary'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body2'},'Contact Number:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body1'},clientDetail.contactNumber||'N/A')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:6,sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,alignItems:'flex-start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,md:'auto',className:classes.cardItemIcon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_icons_Timelapse___default.a,{color:'primary'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body2'},'Deactivates On:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body1'},clientDetail.expiryDate?__WEBPACK_IMPORTED_MODULE_19_moment___default.a.unix(clientDetail.expiryDate).format('MMM Do YYYY, hh:mm A'):'N/A')))))),clientDetail.channelPartnerName?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:6,sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,alignItems:'flex-start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,md:'auto',className:classes.cardItemIcon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Person___default.a,{color:'primary'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body2'},'CHANNEL PARTNER:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body1'},clientDetail.channelPartnerName)))))):null,clientDetail.zonalManager?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:6,sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,alignItems:'flex-start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,md:'auto',className:classes.cardItemIcon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Person___default.a,{color:'primary'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body2'},'ZONAL MANAGER:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body1'},zonalManagerUsername)))))):null,clientDetail.keyAccountManager?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:6,sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,alignItems:'flex-start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,md:'auto',className:classes.cardItemIcon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Person___default.a,{color:'primary'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body2'},'KEY ACCOUNT MANAGER:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body1'},keyAccountManagerUsername)))))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:6,sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,alignItems:'flex-start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,md:'auto',className:classes.cardItemIcon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_icons_SettingsPower___default.a,{color:'primary'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body2'},'Client Status:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body1'},clientDetail.status?'Active':'Inactive'||'N/A',console.log('clientDetail.status',clientDetail))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:6,sm:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,alignItems:'flex-start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,md:'auto',className:classes.cardItemIcon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_icons_DirectionsCar___default.a,{color:'primary'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body2'},'Total Potential Vehicles:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body1'},clientDetail.totalPotentialVehicles||'N/A')))))))),actions&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_CardActions___default.a,null,actions()));});}}]);return CustomerDetailsCard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);CustomerDetailsCard.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__["withStyles"])(styles)(CustomerDetailsCard));

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = noop;
function noop() {}


/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_deep_equal__ = __webpack_require__(2263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_deep_equal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_deep_equal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_series_utils__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_chart_utils__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__animation__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__theme__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__series_canvas_wrapper__ = __webpack_require__(2277);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.













var ATTRIBUTES = ['x', 'y', 'radius', 'angle', 'color', 'fill', 'stroke', 'opacity', 'size'];

/**
 * Remove parents from tree formatted data. deep-equal doesnt play nice with data
 * that has circular structures, so we make every node single directional by pruning the parents.
 * @param {Array} data - the data object to have circular deps resolved in
 * @returns {Array} the sanitized data
 */
function cleanseData(data) {
  return data.map(function (series) {
    if (!Array.isArray(series)) {
      return series;
    }
    return series.map(function (row) {
      return _extends({}, row, { parent: null });
    });
  });
}

/**
 * Wrapper on the deep-equal method for checking equality of next props vs current props
 * @param {Object} scaleMixins - Scale object.
 * @param {Object} nextScaleMixins - Scale object.
 * @param {Boolean} hasTreeStructure - Whether or not to cleanse the data of possible cyclic structures
 * @returns {Boolean} whether or not the two mixins objects are equal
 */
function checkIfMixinsAreEqual(nextScaleMixins, scaleMixins, hasTreeStructure) {
  var newMixins = _extends({}, nextScaleMixins, {
    _allData: hasTreeStructure ? cleanseData(nextScaleMixins._allData) : nextScaleMixins._allData
  });
  var oldMixins = _extends({}, scaleMixins, {
    _allData: hasTreeStructure ? cleanseData(scaleMixins._allData) : scaleMixins._allData
  });
  // it's hard to say if this function is reasonable?
  return __WEBPACK_IMPORTED_MODULE_2_deep_equal___default()(newMixins, oldMixins);
}

var XYPlot = function (_React$Component) {
  _inherits(XYPlot, _React$Component);

  _createClass(XYPlot, null, [{
    key: 'defaultProps',
    get: function get() {
      return {
        className: ''
      };
    }
  }, {
    key: 'propTypes',
    get: function get() {
      return {
        animation: __WEBPACK_IMPORTED_MODULE_6__animation__["a" /* AnimationPropType */],
        className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        dontCheckIfEmpty: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
        height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
        margin: __WEBPACK_IMPORTED_MODULE_5__utils_chart_utils__["b" /* MarginPropType */],
        onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
        onDoubleClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
        onMouseDown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
        onMouseUp: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
        onMouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
        onMouseLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
        onMouseMove: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
        onTouchStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
        onTouchMove: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
        onTouchEnd: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
        onTouchCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
        onWheel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
        stackBy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(ATTRIBUTES),
        style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
        width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
      };
    }
  }]);

  function XYPlot(props) {
    _classCallCheck(this, XYPlot);

    var _this = _possibleConstructorReturn(this, (XYPlot.__proto__ || Object.getPrototypeOf(XYPlot)).call(this, props));

    _initialiseProps.call(_this);

    var stackBy = props.stackBy;

    var children = Object(__WEBPACK_IMPORTED_MODULE_4__utils_series_utils__["c" /* getSeriesChildren */])(props.children);
    var data = Object(__WEBPACK_IMPORTED_MODULE_4__utils_series_utils__["f" /* getStackedData */])(children, stackBy);
    _this.state = {
      scaleMixins: _this._getScaleMixins(data, props),
      data: data
    };
    return _this;
  }

  _createClass(XYPlot, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var children = Object(__WEBPACK_IMPORTED_MODULE_4__utils_series_utils__["c" /* getSeriesChildren */])(nextProps.children);
      var nextData = Object(__WEBPACK_IMPORTED_MODULE_4__utils_series_utils__["f" /* getStackedData */])(children, nextProps.stackBy);
      var scaleMixins = this.state.scaleMixins;

      var nextScaleMixins = this._getScaleMixins(nextData, nextProps);
      if (!checkIfMixinsAreEqual(nextScaleMixins, scaleMixins, nextProps.hasTreeStructure)) {
        this.setState({
          scaleMixins: nextScaleMixins,
          data: nextData
        });
      }
    }

    /**
     * Trigger click related callbacks if they are available.
     * @param {React.SyntheticEvent} event Click event.
     * @private
     */


    /**
     * Trigger doule-click related callbacks if they are available.
     * @param {React.SyntheticEvent} event Double-click event.
     * @private
     */

  }, {
    key: '_getClonedChildComponents',


    /**
     * Prepare the child components (including series) for rendering.
     * @returns {Array} Array of child components.
     * @private
     */
    value: function _getClonedChildComponents() {
      var _this2 = this;

      var props = this.props;
      var animation = this.props.animation;
      var _state = this.state,
          scaleMixins = _state.scaleMixins,
          data = _state.data;

      var dimensions = Object(__WEBPACK_IMPORTED_MODULE_5__utils_chart_utils__["c" /* getInnerDimensions */])(this.props, __WEBPACK_IMPORTED_MODULE_5__utils_chart_utils__["a" /* DEFAULT_MARGINS */]);
      var children = __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.toArray(this.props.children);
      var seriesProps = Object(__WEBPACK_IMPORTED_MODULE_4__utils_series_utils__["d" /* getSeriesPropsFromChildren */])(children);
      var XYPlotValues = Object(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["k" /* getXYPlotValues */])(props, children);
      return children.map(function (child, index) {
        var dataProps = null;
        if (seriesProps[index]) {
          // Get the index of the series in the list of props and retrieve
          // the data property from it.
          var seriesIndex = seriesProps[index].seriesIndex;

          dataProps = { data: data[seriesIndex] };
        }
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, _extends({}, dimensions, {
          animation: animation
        }, dataProps && child.type.prototype && child.type.prototype.render ? {
          ref: function ref(_ref) {
            return _this2['series' + seriesProps[index].seriesIndex] = _ref;
          }
        } : {}, seriesProps[index], scaleMixins, child.props, XYPlotValues[index], dataProps));
      });
    }
    /**
     * Get the list of scale-related settings that should be applied by default.
     * @param {Object} props Object of props.
     * @returns {Object} Defaults.
     * @private
     */

  }, {
    key: '_getDefaultScaleProps',
    value: function _getDefaultScaleProps(props) {
      var _getInnerDimensions = Object(__WEBPACK_IMPORTED_MODULE_5__utils_chart_utils__["c" /* getInnerDimensions */])(props, __WEBPACK_IMPORTED_MODULE_5__utils_chart_utils__["a" /* DEFAULT_MARGINS */]),
          innerWidth = _getInnerDimensions.innerWidth,
          innerHeight = _getInnerDimensions.innerHeight;

      var colorRanges = ['color', 'fill', 'stroke'].reduce(function (acc, attr) {
        var range = props[attr + 'Type'] === 'category' ? __WEBPACK_IMPORTED_MODULE_7__theme__["f" /* EXTENDED_DISCRETE_COLOR_RANGE */] : __WEBPACK_IMPORTED_MODULE_7__theme__["a" /* CONTINUOUS_COLOR_RANGE */];
        return _extends({}, acc, _defineProperty({}, attr + 'Range', range));
      }, {});

      return _extends({
        xRange: [0, innerWidth],
        yRange: [innerHeight, 0]
      }, colorRanges, {
        opacityType: __WEBPACK_IMPORTED_MODULE_7__theme__["g" /* OPACITY_TYPE */],
        sizeRange: __WEBPACK_IMPORTED_MODULE_7__theme__["h" /* SIZE_RANGE */]
      });
    }

    /**
     * Get the map of scales from the props, apply defaults to them and then pass
     * them further.
     * @param {Object} data Array of all data.
     * @param {Object} props Props of the component.
     * @returns {Object} Map of scale-related props.
     * @private
     */

  }, {
    key: '_getScaleMixins',
    value: function _getScaleMixins(data, props) {
      var _ref2;

      var filteredData = data.filter(function (d) {
        return d;
      });
      var allData = (_ref2 = []).concat.apply(_ref2, _toConsumableArray(filteredData));

      var defaultScaleProps = this._getDefaultScaleProps(props);
      var optionalScaleProps = Object(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["h" /* getOptionalScaleProps */])(props);
      var userScaleProps = Object(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["a" /* extractScalePropsFromProps */])(props, ATTRIBUTES);
      var missingScaleProps = Object(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["g" /* getMissingScaleProps */])(_extends({}, defaultScaleProps, optionalScaleProps, userScaleProps), allData, ATTRIBUTES);
      var children = Object(__WEBPACK_IMPORTED_MODULE_4__utils_series_utils__["c" /* getSeriesChildren */])(props.children);
      var zeroBaseProps = {};
      var adjustBy = new Set();
      var adjustWhat = new Set();
      children.forEach(function (child, index) {
        if (!child || !data[index]) {
          return;
        }
        ATTRIBUTES.forEach(function (attr) {
          var _child$type$getParent = child.type.getParentConfig(attr, child.props),
              isDomainAdjustmentNeeded = _child$type$getParent.isDomainAdjustmentNeeded,
              zeroBaseValue = _child$type$getParent.zeroBaseValue;

          if (isDomainAdjustmentNeeded) {
            adjustBy.add(attr);
            adjustWhat.add(index);
          }
          if (zeroBaseValue) {
            var specifiedDomain = props[attr + 'Domain'];
            zeroBaseProps[attr + 'BaseValue'] = specifiedDomain ? specifiedDomain[0] : 0;
          }
        });
      });
      return _extends({}, defaultScaleProps, zeroBaseProps, userScaleProps, missingScaleProps, {
        _allData: data,
        _adjustBy: Array.from(adjustBy),
        _adjustWhat: Array.from(adjustWhat),
        _stackBy: props.stackBy
      });
    }

    /**
     * Checks if the plot is empty or not.
     * Currently checks the data only.
     * @returns {boolean} True for empty.
     * @private
     */

  }, {
    key: '_isPlotEmpty',
    value: function _isPlotEmpty() {
      var data = this.state.data;

      return !data || !data.length || !data.some(function (series) {
        return series && series.some(function (d) {
          return d;
        });
      });
    }

    /**
     * Trigger mouse-down related callbacks if they are available.
     * @param {React.SyntheticEvent} event Mouse down event.
     * @private
     */


    /**
     * Trigger onMouseEnter handler if it was passed in props.
     * @param {React.SyntheticEvent} event Mouse enter event.
     * @private
     */


    /**
     * Trigger onMouseLeave handler if it was passed in props.
     * @param {React.SyntheticEvent} event Mouse leave event.
     * @private
     */


    /**
     * Trigger movement-related callbacks if they are available.
     * @param {React.SyntheticEvent} event Mouse move event.
     * @private
     */


    /**
     * Trigger mouse-up related callbacks if they are available.
     * @param {React.SyntheticEvent} event Mouse up event.
     * @private
     */


    /**
     * Trigger onTouchCancel handler if it was passed in props.
     * @param {React.SyntheticEvent} event Touch Cancel event.
     * @private
     */


    /**
     * Trigger onTouchEnd handler if it was passed in props.
     * @param {React.SyntheticEvent} event Touch End event.
     * @private
     */


    /**
     * Trigger touch movement-related callbacks if they are available.
     * @param {React.SyntheticEvent} event Touch move event.
     * @private
     */


    /**
     * Trigger touch-start related callbacks if they are available.
     * @param {React.SyntheticEvent} event Touch start event.
     * @private
     */


    /**
     * Trigger doule-click related callbacks if they are available.
     * @param {React.SyntheticEvent} event Double-click event.
     * @private
     */

  }, {
    key: 'renderCanvasComponents',
    value: function renderCanvasComponents(components, props) {
      var componentsToRender = components.filter(function (c) {
        return c && !c.type.requiresSVG && c.type.isCanvas;
      });

      if (componentsToRender.length === 0) {
        return null;
      }
      var _componentsToRender$ = componentsToRender[0].props,
          marginLeft = _componentsToRender$.marginLeft,
          marginTop = _componentsToRender$.marginTop,
          marginBottom = _componentsToRender$.marginBottom,
          marginRight = _componentsToRender$.marginRight,
          innerHeight = _componentsToRender$.innerHeight,
          innerWidth = _componentsToRender$.innerWidth;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__series_canvas_wrapper__["a" /* default */],
        {
          innerHeight: innerHeight,
          innerWidth: innerWidth,
          marginLeft: marginLeft,
          marginTop: marginTop,
          marginBottom: marginBottom,
          marginRight: marginRight
        },
        componentsToRender
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          dontCheckIfEmpty = _props.dontCheckIfEmpty,
          style = _props.style,
          width = _props.width,
          height = _props.height;


      if (!dontCheckIfEmpty && this._isPlotEmpty()) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
          className: 'rv-xy-plot ' + className,
          style: _extends({
            width: width + 'px',
            height: height + 'px'
          }, this.props.style)
        });
      }
      var components = this._getClonedChildComponents();
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          style: {
            width: width + 'px',
            height: height + 'px'
          },
          className: 'rv-xy-plot ' + className
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'svg',
          {
            className: 'rv-xy-plot__inner',
            width: width,
            height: height,
            style: style,
            onClick: this._clickHandler,
            onDoubleClick: this._doubleClickHandler,
            onMouseDown: this._mouseDownHandler,
            onMouseUp: this._mouseUpHandler,
            onMouseMove: this._mouseMoveHandler,
            onMouseLeave: this._mouseLeaveHandler,
            onMouseEnter: this._mouseEnterHandler,
            onTouchStart: this._mouseDownHandler,
            onTouchMove: this._touchMoveHandler,
            onTouchEnd: this._touchEndHandler,
            onTouchCancel: this._touchCancelHandler,
            onWheel: this._wheelHandler
          },
          components.filter(function (c) {
            return c && c.type.requiresSVG;
          })
        ),
        this.renderCanvasComponents(components, this.props),
        components.filter(function (c) {
          return c && !c.type.requiresSVG && !c.type.isCanvas;
        })
      );
    }
  }]);

  return XYPlot;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this._clickHandler = function (event) {
    var onClick = _this3.props.onClick;

    if (onClick) {
      onClick(event);
    }
  };

  this._doubleClickHandler = function (event) {
    var onDoubleClick = _this3.props.onDoubleClick;

    if (onDoubleClick) {
      onDoubleClick(event);
    }
  };

  this._mouseDownHandler = function (event) {
    var _props2 = _this3.props,
        onMouseDown = _props2.onMouseDown,
        children = _props2.children;

    if (onMouseDown) {
      onMouseDown(event);
    }
    var seriesChildren = Object(__WEBPACK_IMPORTED_MODULE_4__utils_series_utils__["c" /* getSeriesChildren */])(children);
    seriesChildren.forEach(function (child, index) {
      var component = _this3['series' + index];
      if (component && component.onParentMouseDown) {
        component.onParentMouseDown(event);
      }
    });
  };

  this._mouseEnterHandler = function (event) {
    var _props3 = _this3.props,
        onMouseEnter = _props3.onMouseEnter,
        children = _props3.children;

    if (onMouseEnter) {
      onMouseEnter(event);
    }
    var seriesChildren = Object(__WEBPACK_IMPORTED_MODULE_4__utils_series_utils__["c" /* getSeriesChildren */])(children);
    seriesChildren.forEach(function (child, index) {
      var component = _this3['series' + index];
      if (component && component.onParentMouseEnter) {
        component.onParentMouseEnter(event);
      }
    });
  };

  this._mouseLeaveHandler = function (event) {
    var _props4 = _this3.props,
        onMouseLeave = _props4.onMouseLeave,
        children = _props4.children;

    if (onMouseLeave) {
      onMouseLeave(event);
    }
    var seriesChildren = Object(__WEBPACK_IMPORTED_MODULE_4__utils_series_utils__["c" /* getSeriesChildren */])(children);
    seriesChildren.forEach(function (child, index) {
      var component = _this3['series' + index];
      if (component && component.onParentMouseLeave) {
        component.onParentMouseLeave(event);
      }
    });
  };

  this._mouseMoveHandler = function (event) {
    var _props5 = _this3.props,
        onMouseMove = _props5.onMouseMove,
        children = _props5.children;

    if (onMouseMove) {
      onMouseMove(event);
    }
    var seriesChildren = Object(__WEBPACK_IMPORTED_MODULE_4__utils_series_utils__["c" /* getSeriesChildren */])(children);
    seriesChildren.forEach(function (child, index) {
      var component = _this3['series' + index];
      if (component && component.onParentMouseMove) {
        component.onParentMouseMove(event);
      }
    });
  };

  this._mouseUpHandler = function (event) {
    var _props6 = _this3.props,
        onMouseUp = _props6.onMouseUp,
        children = _props6.children;

    if (onMouseUp) {
      onMouseUp(event);
    }
    var seriesChildren = Object(__WEBPACK_IMPORTED_MODULE_4__utils_series_utils__["c" /* getSeriesChildren */])(children);
    seriesChildren.forEach(function (child, index) {
      var component = _this3['series' + index];
      if (component && component.onParentMouseUp) {
        component.onParentMouseUp(event);
      }
    });
  };

  this._touchCancelHandler = function (event) {
    var onTouchCancel = _this3.props.onTouchCancel;

    if (onTouchCancel) {
      onTouchCancel(event);
    }
  };

  this._touchEndHandler = function (event) {
    var onTouchEnd = _this3.props.onTouchEnd;

    if (onTouchEnd) {
      onTouchEnd(event);
    }
  };

  this._touchMoveHandler = function (event) {
    var _props7 = _this3.props,
        onTouchMove = _props7.onTouchMove,
        children = _props7.children;

    if (onTouchMove) {
      onTouchMove(event);
    }
    var seriesChildren = Object(__WEBPACK_IMPORTED_MODULE_4__utils_series_utils__["c" /* getSeriesChildren */])(children);
    seriesChildren.forEach(function (child, index) {
      var component = _this3['series' + index];
      if (component && component.onParentTouchMove) {
        component.onParentTouchMove(event);
      }
    });
  };

  this._touchStartHandler = function (event) {
    var _props8 = _this3.props,
        onTouchStart = _props8.onTouchStart,
        children = _props8.children;

    if (onTouchStart) {
      onTouchStart(event);
    }
    var seriesChildren = Object(__WEBPACK_IMPORTED_MODULE_4__utils_series_utils__["c" /* getSeriesChildren */])(children);
    seriesChildren.forEach(function (child, index) {
      var component = _this3['series' + index];
      if (component && component.onParentTouchStart) {
        component.onParentTouchStart(event);
      }
    });
  };

  this._wheelHandler = function (event) {
    var onWheel = _this3.props.onWheel;

    if (onWheel) {
      onWheel(event);
    }
  };
};

XYPlot.displayName = 'XYPlot';

/* harmony default export */ __webpack_exports__["a"] = (XYPlot);

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.specialProperty = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _extends3 = _interopRequireDefault(__webpack_require__(11));

// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
// Only exported for test purposes.
var specialProperty = "exact-prop: \u200B";
exports.specialProperty = specialProperty;

function exactProp(propTypes) {
  /* istanbul ignore if */
  if (true) {
    return propTypes;
  }

  return (0, _extends3.default)({}, propTypes, (0, _defineProperty2.default)({}, specialProperty, function (props) {
    var unsupportedProps = Object.keys(props).filter(function (prop) {
      return !propTypes.hasOwnProperty(prop);
    });

    if (unsupportedProps.length > 0) {
      return new Error("The following properties are not supported: ".concat(unsupportedProps.map(function (prop) {
        return "`".concat(prop, "`");
      }).join(', '), ". Please remove them."));
    }

    return null;
  }));
}

var _default = exactProp;
exports.default = _default;

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PrivateRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PublicRoute; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__storage__ = __webpack_require__(461);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var PrivateRoute=function PrivateRoute(_ref){var children=_ref.children,props=_objectWithoutProperties(_ref,['children']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__auth__["a" /* AuthConsumer */],null,function(_ref2){var authStatus=_ref2.authStatus;if(!authStatus){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Redirect */],{to:{pathname:'/'}});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],props,children);});};var PublicRoute=function PublicRoute(_ref3){var children=_ref3.children,props=_objectWithoutProperties(_ref3,['children']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__auth__["a" /* AuthConsumer */],null,function(_ref4){var authStatus=_ref4.authStatus;if(authStatus){var accountType=Object(__WEBPACK_IMPORTED_MODULE_3__storage__["b" /* getItem */])('Account_type');var pathname=void 0;switch(accountType){case'SA':pathname='/home/dashboard';break;case'PA':pathname='/home/plans';break;case'SAL':pathname='/home/customers';break;case'SER':pathname='/home/VehcileDashboard/Dashboard';break;case'ACC':case'INV':pathname='/home/subscriptions';break;case'RES':pathname='/home/reseller/customers';break;default:pathname='/home/dashboard';break;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Redirect */],{to:{pathname:pathname}});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],props,children);});};

/***/ }),
/* 117 */
/***/ (function(module, exports) {

// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes

/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */

function keyCode(searchInput) {
  // Keyboard Events
  if (searchInput && 'object' === typeof searchInput) {
    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
    if (hasKeyCode) searchInput = hasKeyCode
  }

  // Numbers
  if ('number' === typeof searchInput) return names[searchInput]

  // Everything else (cast to string)
  var search = String(searchInput)

  // check codes
  var foundNamedKey = codes[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // check aliases
  var foundNamedKey = aliases[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // weird character?
  if (search.length === 1) return search.charCodeAt(0)

  return undefined
}

/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */
keyCode.isEventKey = function isEventKey(event, nameOrCode) {
  if (event && 'object' === typeof event) {
    var keyCode = event.which || event.keyCode || event.charCode
    if (keyCode === null || keyCode === undefined) { return false; }
    if (typeof nameOrCode === 'string') {
      // check codes
      var foundNamedKey = codes[nameOrCode.toLowerCase()]
      if (foundNamedKey) { return foundNamedKey === keyCode; }
    
      // check aliases
      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
      if (foundNamedKey) { return foundNamedKey === keyCode; }
    } else if (typeof nameOrCode === 'number') {
      return nameOrCode === keyCode;
    }
    return false;
  }
}

exports = module.exports = keyCode;

/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */

var codes = exports.code = exports.codes = {
  'backspace': 8,
  'tab': 9,
  'enter': 13,
  'shift': 16,
  'ctrl': 17,
  'alt': 18,
  'pause/break': 19,
  'caps lock': 20,
  'esc': 27,
  'space': 32,
  'page up': 33,
  'page down': 34,
  'end': 35,
  'home': 36,
  'left': 37,
  'up': 38,
  'right': 39,
  'down': 40,
  'insert': 45,
  'delete': 46,
  'command': 91,
  'left command': 91,
  'right command': 93,
  'numpad *': 106,
  'numpad +': 107,
  'numpad -': 109,
  'numpad .': 110,
  'numpad /': 111,
  'num lock': 144,
  'scroll lock': 145,
  'my computer': 182,
  'my calculator': 183,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  "'": 222
}

// Helper aliases

var aliases = exports.aliases = {
  'windows': 91,
  '⇧': 16,
  '⌥': 18,
  '⌃': 17,
  '⌘': 91,
  'ctl': 17,
  'control': 17,
  'option': 18,
  'pause': 19,
  'break': 19,
  'caps': 20,
  'return': 13,
  'escape': 27,
  'spc': 32,
  'spacebar': 32,
  'pgup': 33,
  'pgdn': 34,
  'ins': 45,
  'del': 46,
  'cmd': 91
}

/*!
 * Programatically add the following
 */

// lower case chars
for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32

// numbers
for (var i = 48; i < 58; i++) codes[i - 48] = i

// function keys
for (i = 1; i < 13; i++) codes['f'+i] = i + 111

// numpad keys
for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96

/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */

var names = exports.names = exports.title = {} // title for backward compat

// Create reverse mapping
for (i in codes) names[codes[i]] = i

// Add aliases
for (var alias in aliases) {
  codes[alias] = aliases[alias]
}


/***/ }),
/* 118 */
/***/ (function(module, exports) {

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */
function debounce(func, wait, immediate){
  var timeout, args, context, timestamp, result;
  if (null == wait) wait = 100;

  function later() {
    var last = Date.now() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        context = args = null;
      }
    }
  };

  var debounced = function(){
    context = this;
    args = arguments;
    timestamp = Date.now();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };

  debounced.clear = function() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };
  
  debounced.flush = function() {
    if (timeout) {
      result = func.apply(context, args);
      context = args = null;
      
      clearTimeout(timeout);
      timeout = null;
    }
  };

  return debounced;
};

// Adds compatibility for ES modules
debounce.debounce = debounce;

module.exports = debounce;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cloneElementWithClassName = cloneElementWithClassName;
exports.cloneChildrenWithClassName = cloneChildrenWithClassName;
exports.isMuiElement = isMuiElement;
exports.isMuiComponent = isMuiComponent;

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(16));

/* eslint-disable import/prefer-default-export */
function cloneElementWithClassName(child, className) {
  return _react.default.cloneElement(child, {
    className: (0, _classnames.default)(child.props.className, className)
  });
}

function cloneChildrenWithClassName(children, className) {
  return _react.default.Children.map(children, function (child) {
    return _react.default.isValidElement(child) && cloneElementWithClassName(child, className);
  });
}

function isMuiElement(element, muiNames) {
  return _react.default.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}

function isMuiComponent(element, muiNames) {
  return muiNames.indexOf(element.muiName) !== -1;
}

/***/ }),
/* 120 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Toolbar.default;
  }
});

var _Toolbar = _interopRequireDefault(__webpack_require__(888));

/***/ }),
/* 122 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _AppBar.default;
  }
});

var _AppBar = _interopRequireDefault(__webpack_require__(991));

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ListItemText.default;
  }
});

var _ListItemText = _interopRequireDefault(__webpack_require__(1033));

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _RadioGroup.default;
  }
});

var _RadioGroup = _interopRequireDefault(__webpack_require__(1042));

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Card__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_CardContent__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_CardContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_CardContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__);
var style={smoothBorder:{borderRadius:'5px'}};function ItemCard(props){var classes=props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Card___default.a,{className:classes.smoothBorder},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_CardContent___default.a,null,props.children));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__["withStyles"])(style)(ItemCard));

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
})), 'LocationOn');

exports.default = _default;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15 11V5l-3-3-3 3v2H3v14h18V11h-6zm-8 8H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm6 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm6 12h-2v-2h2v2zm0-4h-2v-2h2v2z"
})), 'LocationCity');

exports.default = _default;

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value_js__ = __webpack_require__(339);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__value_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array_js__ = __webpack_require__(558);
/* unused harmony reexport interpolateArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basis_js__ = __webpack_require__(342);
/* unused harmony reexport interpolateBasis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__basisClosed_js__ = __webpack_require__(556);
/* unused harmony reexport interpolateBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__date_js__ = __webpack_require__(559);
/* unused harmony reexport interpolateDate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__discrete_js__ = __webpack_require__(2093);
/* unused harmony reexport interpolateDiscrete */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hue_js__ = __webpack_require__(2094);
/* unused harmony reexport interpolateHue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__number_js__ = __webpack_require__(253);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__number_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__numberArray_js__ = __webpack_require__(343);
/* unused harmony reexport interpolateNumberArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__object_js__ = __webpack_require__(560);
/* unused harmony reexport interpolateObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__round_js__ = __webpack_require__(2095);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_10__round_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__string_js__ = __webpack_require__(561);
/* unused harmony reexport interpolateString */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__transform_index_js__ = __webpack_require__(2096);
/* unused harmony reexport interpolateTransformCss */
/* unused harmony reexport interpolateTransformSvg */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zoom_js__ = __webpack_require__(2099);
/* unused harmony reexport interpolateZoom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__rgb_js__ = __webpack_require__(555);
/* unused harmony reexport interpolateRgb */
/* unused harmony reexport interpolateRgbBasis */
/* unused harmony reexport interpolateRgbBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__hsl_js__ = __webpack_require__(2100);
/* unused harmony reexport interpolateHsl */
/* unused harmony reexport interpolateHslLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lab_js__ = __webpack_require__(2101);
/* unused harmony reexport interpolateLab */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__hcl_js__ = __webpack_require__(2102);
/* unused harmony reexport interpolateHcl */
/* unused harmony reexport interpolateHclLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__cubehelix_js__ = __webpack_require__(2103);
/* unused harmony reexport interpolateCubehelix */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_18__cubehelix_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__piecewise_js__ = __webpack_require__(2104);
/* unused harmony reexport piecewise */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__quantize_js__ = __webpack_require__(2105);
/* unused harmony reexport quantize */























/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_band__ = __webpack_require__(2114);
/* unused harmony reexport scaleBand */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__src_band__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_identity__ = __webpack_require__(2136);
/* unused harmony reexport scaleIdentity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_linear__ = __webpack_require__(193);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__src_linear__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_log__ = __webpack_require__(2148);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__src_log__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_ordinal__ = __webpack_require__(575);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__src_ordinal__["a"]; });
/* unused harmony reexport scaleImplicit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_pow__ = __webpack_require__(2149);
/* unused harmony reexport scalePow */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__src_pow__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_quantile__ = __webpack_require__(2150);
/* unused harmony reexport scaleQuantile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_quantize__ = __webpack_require__(2151);
/* unused harmony reexport scaleQuantize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_threshold__ = __webpack_require__(2152);
/* unused harmony reexport scaleThreshold */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_time__ = __webpack_require__(581);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_9__src_time__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_utcTime__ = __webpack_require__(2168);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_10__src_utcTime__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_category10__ = __webpack_require__(2169);
/* unused harmony reexport schemeCategory10 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_category20b__ = __webpack_require__(2170);
/* unused harmony reexport schemeCategory20b */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_category20c__ = __webpack_require__(2171);
/* unused harmony reexport schemeCategory20c */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_category20__ = __webpack_require__(2172);
/* unused harmony reexport schemeCategory20 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__ = __webpack_require__(2173);
/* unused harmony reexport interpolateCubehelixDefault */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_rainbow__ = __webpack_require__(2174);
/* unused harmony reexport interpolateRainbow */
/* unused harmony reexport interpolateWarm */
/* unused harmony reexport interpolateCool */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_viridis__ = __webpack_require__(2175);
/* unused harmony reexport interpolateViridis */
/* unused harmony reexport interpolateMagma */
/* unused harmony reexport interpolateInferno */
/* unused harmony reexport interpolatePlasma */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_sequential__ = __webpack_require__(2176);
/* unused harmony reexport scaleSequential */







































/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
var array = Array.prototype;

var map = array.map;
var slice = array.slice;


/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function constant() {
    return x;
  };
});


/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function streamGeometry(geometry, stream) {
  if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) {
    streamGeometryType[geometry.type](geometry, stream);
  }
}

var streamObjectType = {
  Feature: function(object, stream) {
    streamGeometry(object.geometry, stream);
  },
  FeatureCollection: function(object, stream) {
    var features = object.features, i = -1, n = features.length;
    while (++i < n) streamGeometry(features[i].geometry, stream);
  }
};

var streamGeometryType = {
  Sphere: function(object, stream) {
    stream.sphere();
  },
  Point: function(object, stream) {
    object = object.coordinates;
    stream.point(object[0], object[1], object[2]);
  },
  MultiPoint: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) object = coordinates[i], stream.point(object[0], object[1], object[2]);
  },
  LineString: function(object, stream) {
    streamLine(object.coordinates, stream, 0);
  },
  MultiLineString: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) streamLine(coordinates[i], stream, 0);
  },
  Polygon: function(object, stream) {
    streamPolygon(object.coordinates, stream);
  },
  MultiPolygon: function(object, stream) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) streamPolygon(coordinates[i], stream);
  },
  GeometryCollection: function(object, stream) {
    var geometries = object.geometries, i = -1, n = geometries.length;
    while (++i < n) streamGeometry(geometries[i], stream);
  }
};

function streamLine(coordinates, stream, closed) {
  var i = -1, n = coordinates.length - closed, coordinate;
  stream.lineStart();
  while (++i < n) coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
  stream.lineEnd();
}

function streamPolygon(coordinates, stream) {
  var i = -1, n = coordinates.length;
  stream.polygonStart();
  while (++i < n) streamLine(coordinates[i], stream, 1);
  stream.polygonEnd();
}

/* harmony default export */ __webpack_exports__["a"] = (function(object, stream) {
  if (object && streamObjectType.hasOwnProperty(object.type)) {
    streamObjectType[object.type](object, stream);
  } else {
    streamGeometry(object, stream);
  }
});


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__abstract_series__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__animation__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_series_utils__ = __webpack_require__(66);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.






var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--label';

var getTextAnchor = function getTextAnchor(labelAnchorX, leftOfMiddle) {
  return labelAnchorX ? labelAnchorX : leftOfMiddle ? 'start' : 'end';
};
var getDominantBaseline = function getDominantBaseline(labelAnchorY, aboveMiddle) {
  return labelAnchorY ? labelAnchorY : aboveMiddle ? 'text-before-edge' : 'text-after-edge';
};

var LabelSeries = function (_AbstractSeries) {
  _inherits(LabelSeries, _AbstractSeries);

  function LabelSeries() {
    _classCallCheck(this, LabelSeries);

    return _possibleConstructorReturn(this, (LabelSeries.__proto__ || Object.getPrototypeOf(LabelSeries)).apply(this, arguments));
  }

  _createClass(LabelSeries, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          animation = _props.animation,
          allowOffsetToBeReversed = _props.allowOffsetToBeReversed,
          className = _props.className,
          data = _props.data,
          _data = _props._data,
          getLabel = _props.getLabel,
          marginLeft = _props.marginLeft,
          marginTop = _props.marginTop,
          rotation = _props.rotation,
          style = _props.style,
          xRange = _props.xRange,
          yRange = _props.yRange,
          labelAnchorX = _props.labelAnchorX,
          labelAnchorY = _props.labelAnchorY;

      if (!data) {
        return null;
      }

      if (animation) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__animation__["b" /* default */],
          _extends({}, this.props, { animatedProps: __WEBPACK_IMPORTED_MODULE_4__utils_series_utils__["a" /* ANIMATED_SERIES_PROPS */] }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LabelSeries, _extends({}, this.props, { animation: null, _data: data }))
        );
      }

      var xFunctor = this._getAttributeFunctor('x');
      var yFunctor = this._getAttributeFunctor('y');

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        {
          className: predefinedClassName + ' ' + className,
          transform: 'translate(' + marginLeft + ',' + marginTop + ')',
          style: style
        },
        data.reduce(function (res, d, i) {
          var markStyle = d.style,
              xOffset = d.xOffset,
              yOffset = d.yOffset;

          if (!getLabel(d)) {
            return res;
          }
          var xVal = xFunctor(d);
          var yVal = yFunctor(d);
          var leftOfMiddle = xVal < (xRange[1] - xRange[0]) / 2;
          var aboveMiddle = yVal < Math.abs(yRange[1] - yRange[0]) / 2;

          var x = xVal + (allowOffsetToBeReversed && leftOfMiddle ? -1 : 1) * (xOffset || 0);
          var y = yVal + (allowOffsetToBeReversed && aboveMiddle ? -1 : 1) * (yOffset || 0);

          var hasRotationValueSet = d.rotation === 0 || d.rotation;
          var labelRotation = hasRotationValueSet ? d.rotation : rotation;
          var attrs = _extends({
            dominantBaseline: getDominantBaseline(labelAnchorY, aboveMiddle),
            className: 'rv-xy-plot__series--label-text',
            key: i,
            onClick: function onClick(e) {
              return _this2._valueClickHandler(d, e);
            },
            onContextMenu: function onContextMenu(e) {
              return _this2._valueRightClickHandler(d, e);
            },
            onMouseOver: function onMouseOver(e) {
              return _this2._valueMouseOverHandler(d, e);
            },
            onMouseOut: function onMouseOut(e) {
              return _this2._valueMouseOutHandler(d, e);
            },
            textAnchor: getTextAnchor(labelAnchorX, leftOfMiddle),
            x: x,
            y: y,
            transform: 'rotate(' + labelRotation + ',' + x + ',' + y + ')'
          }, markStyle);
          var textContent = getLabel(_data ? _data[i] : d);
          return res.concat([__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'text',
            attrs,
            textContent
          )]);
        }, [])
      );
    }
  }]);

  return LabelSeries;
}(__WEBPACK_IMPORTED_MODULE_2__abstract_series__["a" /* default */]);

LabelSeries.propTypes = {
  animation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  allowOffsetToBeReversed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
    y: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
    angle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    radius: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    xOffset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    yOffset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  })).isRequired,
  marginLeft: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  marginTop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  rotation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  xRange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number),
  yRange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number),
  labelAnchorX: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  labelAnchorY: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
LabelSeries.defaultProps = _extends({}, __WEBPACK_IMPORTED_MODULE_2__abstract_series__["a" /* default */].defaultProps, {
  animation: false,
  rotation: 0,
  getLabel: function getLabel(d) {
    return d.label;
  }
});
LabelSeries.displayName = 'LabelSeries';
/* harmony default export */ __webpack_exports__["a"] = (LabelSeries);

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getInnerDimensions;
/* harmony export (immutable) */ __webpack_exports__["d"] = getRadialLayoutMargin;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MarginPropType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_MARGINS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.



/**
 * Get the dimensions of the component for the future use.
 * @param {Object} props Props.
 * @param {Object} defaultMargins Object with default margins.
 * @returns {Object} Dimensions of the component.
 */
function getInnerDimensions(props, defaultMargins) {
  var margin = props.margin,
      width = props.width,
      height = props.height;

  var marginProps = _extends({}, defaultMargins, typeof margin === 'number' ? {
    left: margin,
    right: margin,
    top: margin,
    bottom: margin
  } : margin);
  var _marginProps$left = marginProps.left,
      marginLeft = _marginProps$left === undefined ? 0 : _marginProps$left,
      _marginProps$top = marginProps.top,
      marginTop = _marginProps$top === undefined ? 0 : _marginProps$top,
      _marginProps$right = marginProps.right,
      marginRight = _marginProps$right === undefined ? 0 : _marginProps$right,
      _marginProps$bottom = marginProps.bottom,
      marginBottom = _marginProps$bottom === undefined ? 0 : _marginProps$bottom;

  return {
    marginLeft: marginLeft,
    marginTop: marginTop,
    marginRight: marginRight,
    marginBottom: marginBottom,
    innerHeight: height - marginBottom - marginTop,
    innerWidth: width - marginLeft - marginRight
  };
}

/**
 * Calculate the margin of the sunburst,
 * so it can be at the center of the container
 * @param  {Number} width - the width of the container
 * @param  {Number} height - the height of the container
 * @param  {Number} radius - the max radius of the sunburst
 * @return {Object} an object includes {bottom, left, right, top}
 */
function getRadialLayoutMargin(width, height, radius) {
  var marginX = width / 2 - radius;
  var marginY = height / 2 - radius;
  return {
    bottom: marginY,
    left: marginX,
    right: marginX,
    top: marginY
  };
}

var MarginPropType = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  left: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  top: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  right: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
  bottom: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number
}), __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number]);

var DEFAULT_MARGINS = {
  left: 40,
  right: 10,
  top: 10,
  bottom: 40
};

/***/ }),
/* 136 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 137 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DirectiveLocation; });
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * The set of allowed directive location values.
 */
var DirectiveLocation = Object.freeze({
  // Request Definitions
  QUERY: 'QUERY',
  MUTATION: 'MUTATION',
  SUBSCRIPTION: 'SUBSCRIPTION',
  FIELD: 'FIELD',
  FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
  FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
  INLINE_FRAGMENT: 'INLINE_FRAGMENT',
  // Type System Definitions
  SCHEMA: 'SCHEMA',
  SCALAR: 'SCALAR',
  OBJECT: 'OBJECT',
  FIELD_DEFINITION: 'FIELD_DEFINITION',
  ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
  INTERFACE: 'INTERFACE',
  UNION: 'UNION',
  ENUM: 'ENUM',
  ENUM_VALUE: 'ENUM_VALUE',
  INPUT_OBJECT: 'INPUT_OBJECT',
  INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
});

/**
 * The enum type representing the directive location values.
 */

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = find;
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

function find(list, predicate) {
  for (var i = 0; i < list.length; i++) {
    if (predicate(list[i])) {
      return list[i];
    }
  }
}

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApolloLink; });
/* unused harmony export concat */
/* unused harmony export createOperation */
/* unused harmony export empty */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return execute; });
/* unused harmony export from */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fromError; });
/* unused harmony export fromPromise */
/* unused harmony export makePromise */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return split; });
/* unused harmony export toPromise */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__ = __webpack_require__(425);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ts_invariant__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tslib__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_apollo_utilities__ = __webpack_require__(171);
/* unused harmony reexport getOperationName */







function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context',
    ];
    for (var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++) {
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) {
            throw  true ? new __WEBPACK_IMPORTED_MODULE_1_ts_invariant__["a" /* InvariantError */](2) : new InvariantError("illegal argument: " + key);
        }
    }
    return operation;
}
var LinkError = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["c" /* __extends */])(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error));
function isTerminating(link) {
    return link.request.length <= 1;
}
function toPromise(observable) {
    var completed = false;
    return new Promise(function (resolve, reject) {
        observable.subscribe({
            next: function (data) {
                if (completed) {
                    "production" === "production" || __WEBPACK_IMPORTED_MODULE_1_ts_invariant__["b" /* invariant */].warn("Promise Wrapper does not support multiple results from Observable");
                }
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject,
        });
    });
}
var makePromise = toPromise;
function fromPromise(promise) {
    return new __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */](function (observer) {
        promise
            .then(function (value) {
            observer.next(value);
            observer.complete();
        })
            .catch(observer.error.bind(observer));
    });
}
function fromError(errorValue) {
    return new __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */](function (observer) {
        observer.error(errorValue);
    });
}
function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query,
    };
    if (!transformedOperation.operationName) {
        transformedOperation.operationName =
            typeof transformedOperation.query !== 'string'
                ? Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["n" /* getOperationName */])(transformedOperation.query)
                : '';
    }
    return transformedOperation;
}
function createOperation(starting, operation) {
    var context = Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["a" /* __assign */])({}, starting);
    var setContext = function (next) {
        if (typeof next === 'function') {
            context = Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["a" /* __assign */])({}, context, next(context));
        }
        else {
            context = Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["a" /* __assign */])({}, context, next);
        }
    };
    var getContext = function () { return (Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["a" /* __assign */])({}, context)); };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext,
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext,
    });
    Object.defineProperty(operation, 'toKey', {
        enumerable: false,
        value: function () { return getKey(operation); },
    });
    return operation;
}
function getKey(operation) {
    var query = operation.query, variables = operation.variables, operationName = operation.operationName;
    return JSON.stringify([operationName, query, variables]);
}

function passthrough(op, forward) {
    return forward ? forward(op) : __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].of();
}
function toLink(handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
}
function empty() {
    return new ApolloLink(function () { return __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].of(); });
}
function from(links) {
    if (links.length === 0)
        return empty();
    return links.map(toLink).reduce(function (x, y) { return x.concat(y); });
}
function split(test, left, right) {
    var leftLink = toLink(left);
    var rightLink = toLink(right || new ApolloLink(passthrough));
    if (isTerminating(leftLink) && isTerminating(rightLink)) {
        return new ApolloLink(function (operation) {
            return test(operation)
                ? leftLink.request(operation) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].of()
                : rightLink.request(operation) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].of();
        });
    }
    else {
        return new ApolloLink(function (operation, forward) {
            return test(operation)
                ? leftLink.request(operation, forward) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].of()
                : rightLink.request(operation, forward) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].of();
        });
    }
}
var concat = function (first, second) {
    var firstLink = toLink(first);
    if (isTerminating(firstLink)) {
        "production" === "production" || __WEBPACK_IMPORTED_MODULE_1_ts_invariant__["b" /* invariant */].warn(new LinkError("You are calling concat on a terminating link, which will have no effect", firstLink));
        return firstLink;
    }
    var nextLink = toLink(second);
    if (isTerminating(nextLink)) {
        return new ApolloLink(function (operation) {
            return firstLink.request(operation, function (op) { return nextLink.request(op) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].of(); }) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].of();
        });
    }
    else {
        return new ApolloLink(function (operation, forward) {
            return (firstLink.request(operation, function (op) {
                return nextLink.request(op, forward) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].of();
            }) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].of());
        });
    }
};
var ApolloLink = (function () {
    function ApolloLink(request) {
        if (request)
            this.request = request;
    }
    ApolloLink.prototype.split = function (test, left, right) {
        return this.concat(split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function (next) {
        return concat(this, next);
    };
    ApolloLink.prototype.request = function (operation, forward) {
        throw  true ? new __WEBPACK_IMPORTED_MODULE_1_ts_invariant__["a" /* InvariantError */](1) : new InvariantError('request is not implemented');
    };
    ApolloLink.empty = empty;
    ApolloLink.from = from;
    ApolloLink.split = split;
    ApolloLink.execute = execute;
    return ApolloLink;
}());
function execute(link, operation) {
    return (link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].of());
}


//# sourceMappingURL=bundle.esm.js.map


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(142);

var _warning2 = _interopRequireDefault(_warning);

var _toCss = __webpack_require__(291);

var _toCss2 = _interopRequireDefault(_toCss);

var _toCssValue = __webpack_require__(216);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StyleRule = function () {
  function StyleRule(key, style, options) {
    _classCallCheck(this, StyleRule);

    this.type = 'style';
    this.isProcessed = false;
    var sheet = options.sheet,
        Renderer = options.Renderer,
        selector = options.selector;

    this.key = key;
    this.options = options;
    this.style = style;
    if (selector) this.selectorText = selector;
    this.renderer = sheet ? sheet.renderer : new Renderer();
  }

  /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */


  _createClass(StyleRule, [{
    key: 'prop',


    /**
     * Get or set a style property.
     */
    value: function prop(name, value) {
      // It's a getter.
      if (value === undefined) return this.style[name];

      // Don't do anything if the value has not changed.
      if (this.style[name] === value) return this;

      value = this.options.jss.plugins.onChangeValue(value, name, this);

      var isEmpty = value == null || value === false;
      var isDefined = name in this.style;

      // Value is empty and wasn't defined before.
      if (isEmpty && !isDefined) return this;

      // We are going to remove this value.
      var remove = isEmpty && isDefined;

      if (remove) delete this.style[name];else this.style[name] = value;

      // Renderable is defined if StyleSheet option `link` is true.
      if (this.renderable) {
        if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, value);
        return this;
      }

      var sheet = this.options.sheet;

      if (sheet && sheet.attached) {
        (0, _warning2['default'])(false, 'Rule is not linked. Missing sheet option "link: true".');
      }
      return this;
    }

    /**
     * Apply rule to an element inline.
     */

  }, {
    key: 'applyTo',
    value: function applyTo(renderable) {
      var json = this.toJSON();
      for (var prop in json) {
        this.renderer.setProperty(renderable, prop, json[prop]);
      }return this;
    }

    /**
     * Returns JSON representation of the rule.
     * Fallbacks are not supported.
     * Useful for inline styles.
     */

  }, {
    key: 'toJSON',
    value: function toJSON() {
      var json = {};
      for (var prop in this.style) {
        var value = this.style[prop];
        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = (0, _toCssValue2['default'])(value);
      }
      return json;
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      var sheet = this.options.sheet;

      var link = sheet ? sheet.options.link : false;
      var opts = link ? _extends({}, options, { allowEmpty: true }) : options;
      return (0, _toCss2['default'])(this.selector, this.style, opts);
    }
  }, {
    key: 'selector',
    set: function set(selector) {
      if (selector === this.selectorText) return;

      this.selectorText = selector;

      if (!this.renderable) return;

      var hasChanged = this.renderer.setSelector(this.renderable, selector);

      // If selector setter is not implemented, rerender the rule.
      if (!hasChanged && this.renderable) {
        var renderable = this.renderer.replaceRule(this.renderable, this);
        if (renderable) this.renderable = renderable;
      }
    }

    /**
     * Get selector string.
     */
    ,
    get: function get() {
      return this.selectorText;
    }
  }]);

  return StyleRule;
}();

exports['default'] = StyleRule;

/***/ }),
/* 144 */
/***/ (function(module, exports) {

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

module.exports = _interopRequireWildcard;

/***/ }),
/* 145 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(802);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Icon.default;
  }
});

var _Icon = _interopRequireDefault(__webpack_require__(826));

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTransitionProps = getTransitionProps;
exports.reflow = void 0;

var reflow = function reflow(node) {
  return node.scrollTop;
};

exports.reflow = reflow;

function getTransitionProps(props, options) {
  var timeout = props.timeout,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style;
  return {
    duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode],
    delay: style.transitionDelay
  };
}

/***/ }),
/* 149 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(151);
var createDesc = __webpack_require__(234);
module.exports = __webpack_require__(153) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(180);
var IE8_DOM_DEFINE = __webpack_require__(484);
var toPrimitive = __webpack_require__(310);
var dP = Object.defineProperty;

exports.f = __webpack_require__(153) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 152 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(233)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(931);
var defined = __webpack_require__(309);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(315)('wks');
var uid = __webpack_require__(235);
var Symbol = __webpack_require__(109).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Switch.default;
  }
});

var _Switch = _interopRequireDefault(__webpack_require__(1058));

/***/ }),
/* 157 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
})), 'Person');

exports.default = _default;

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_AppBar__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_AppBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_AppBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Tabs__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Tab__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Countries__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__States__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormHelperText__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormHelperText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormHelperText__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function TabContainer(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{component:'div',style:{padding:8*3}},props.children);}TabContainer.propTypes={children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired};var styles=function styles(theme){return{root:{flexGrow:1,backgroundColor:theme.palette.background.paper// padding: theme.spacing.unit * 2
}};};var CustomTabs=function(_React$Component){_inherits(CustomTabs,_React$Component);function CustomTabs(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CustomTabs);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CustomTabs.__proto__||Object.getPrototypeOf(CustomTabs)).call.apply(_ref,[this].concat(args))),_this),_this.state={value:0},_this.handleChange=function(event,value){_this.setState({value:value});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CustomTabs,[{key:'handleStateRender',value:function handleStateRender(){if(this.props.country){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__States__["a" /* default */],{countryId:this.props.country,zoneId:this.props.state,handleStateChange:this.props.handleStateChange})));}}},{key:'render',value:function render(){var classes=this.props.classes;var value=this.state.value;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_AppBar___default.a,{position:'static'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Tabs___default.a,{value:value,onChange:this.handleChange},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Tab___default.a,{label:'Address'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Tab___default.a,{label:'Tax Information'}))),value===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Grid___default.a,{container:true,spacing:16,style:{paddingTop:'2%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a// autoComplete="username"
,{name:'address1',value:this.props.address1,type:'text',onChange:this.props.handleInputChange,label:'Address Line 1',required:true// error={!isUsernameValid}
// onBlur={this.checkUsernameValidity}
// label={!isUsernameValid ? 'Invalid Username' : ''}
}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a// autoComplete="username"
,{name:'address2',value:this.props.address2,type:'text',onChange:this.props.handleInputChange,label:'Address Line 2'// error={!isUsernameValid}
// onBlur={this.checkUsernameValidity}
// label={!isUsernameValid ? 'Invalid Username' : ''}
}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Countries__["a" /* default */],{countryId:this.props.country,handleCountryChange:this.props.handleCountryChange}))),this.handleStateRender(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a// autoComplete="username"
,{name:'city',value:this.props.city,type:'text',onChange:this.props.handleInputChange,label:'City',required:true// error={!isUsernameValid}
,onBlur:this.props.checkCityValidity// label={!isUsernameValid ? 'Invalid Username' : ''}
}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},this.props.isCityValid?'':'Invalid City Name'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a// autoComplete="username"
,{name:'pincode',value:this.props.pincode,type:'text',onChange:this.props.handleInputChange,label:'PIN Code'// error={!isUsernameValid}
,onBlur:this.props.checkPinValidity// label={!isUsernameValid ? 'Invalid Username' : ''}
}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},this.props.isPinValid?'':'Invalid Pin Number')))),value===1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Grid___default.a,{container:true,spacing:16,style:{paddingTop:'2%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a// autoComplete="username"
,{name:'pan',value:this.props.pan,type:'text',onChange:this.props.handleInputChange,label:'PAN'// error={!isUsernameValid}
,onBlur:this.props.checkPanValidity// label={!isUsernameValid ? 'Invalid Username' : ''}
}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},this.props.isPanValid?'':this.props.panNoRes))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a// autoComplete="username"
,{name:'gst',value:this.props.gst,type:'text',onChange:this.props.handleInputChange,label:'GST Number'// error={!isUsernameValid}
,onBlur:this.props.checkGSTValidity// label={!isUsernameValid ? 'Invalid Username' : ''}
}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},this.props.isGSTValid?'':this.props.gstNoRes)))));}}]);return CustomTabs;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);CustomTabs.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["withApollo"])(CustomTabs)));

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z"
})), 'DeleteForever');

exports.default = _default;

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = hue;
/* harmony export (immutable) */ __webpack_exports__["b"] = gamma;
/* harmony export (immutable) */ __webpack_exports__["a"] = nogamma;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant_js__ = __webpack_require__(557);


function linear(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function hue(a, b) {
  var d = b - a;
  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : Object(__WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */])(isNaN(a) ? b : a);
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : Object(__WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */])(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear(a, d) : Object(__WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */])(isNaN(a) ? b : a);
}


/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
});


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arc_js__ = __webpack_require__(2177);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "arc", function() { return __WEBPACK_IMPORTED_MODULE_0__arc_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__area_js__ = __webpack_require__(585);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "area", function() { return __WEBPACK_IMPORTED_MODULE_1__area_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__line_js__ = __webpack_require__(357);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "line", function() { return __WEBPACK_IMPORTED_MODULE_2__line_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pie_js__ = __webpack_require__(2179);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pie", function() { return __WEBPACK_IMPORTED_MODULE_3__pie_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__areaRadial_js__ = __webpack_require__(2182);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "areaRadial", function() { return __WEBPACK_IMPORTED_MODULE_4__areaRadial_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "radialArea", function() { return __WEBPACK_IMPORTED_MODULE_4__areaRadial_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lineRadial_js__ = __webpack_require__(587);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "lineRadial", function() { return __WEBPACK_IMPORTED_MODULE_5__lineRadial_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "radialLine", function() { return __WEBPACK_IMPORTED_MODULE_5__lineRadial_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pointRadial_js__ = __webpack_require__(588);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "pointRadial", function() { return __WEBPACK_IMPORTED_MODULE_6__pointRadial_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__link_index_js__ = __webpack_require__(2183);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "linkHorizontal", function() { return __WEBPACK_IMPORTED_MODULE_7__link_index_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "linkVertical", function() { return __WEBPACK_IMPORTED_MODULE_7__link_index_js__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "linkRadial", function() { return __WEBPACK_IMPORTED_MODULE_7__link_index_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__symbol_js__ = __webpack_require__(2184);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbol", function() { return __WEBPACK_IMPORTED_MODULE_8__symbol_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbols", function() { return __WEBPACK_IMPORTED_MODULE_8__symbol_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__symbol_circle_js__ = __webpack_require__(590);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolCircle", function() { return __WEBPACK_IMPORTED_MODULE_9__symbol_circle_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__symbol_cross_js__ = __webpack_require__(591);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolCross", function() { return __WEBPACK_IMPORTED_MODULE_10__symbol_cross_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__symbol_diamond_js__ = __webpack_require__(592);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolDiamond", function() { return __WEBPACK_IMPORTED_MODULE_11__symbol_diamond_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__symbol_square_js__ = __webpack_require__(594);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolSquare", function() { return __WEBPACK_IMPORTED_MODULE_12__symbol_square_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__symbol_star_js__ = __webpack_require__(593);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolStar", function() { return __WEBPACK_IMPORTED_MODULE_13__symbol_star_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__symbol_triangle_js__ = __webpack_require__(595);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolTriangle", function() { return __WEBPACK_IMPORTED_MODULE_14__symbol_triangle_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__symbol_wye_js__ = __webpack_require__(596);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "symbolWye", function() { return __WEBPACK_IMPORTED_MODULE_15__symbol_wye_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__curve_basisClosed_js__ = __webpack_require__(2185);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveBasisClosed", function() { return __WEBPACK_IMPORTED_MODULE_16__curve_basisClosed_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__curve_basisOpen_js__ = __webpack_require__(2186);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveBasisOpen", function() { return __WEBPACK_IMPORTED_MODULE_17__curve_basisOpen_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__curve_basis_js__ = __webpack_require__(260);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveBasis", function() { return __WEBPACK_IMPORTED_MODULE_18__curve_basis_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__curve_bundle_js__ = __webpack_require__(2187);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveBundle", function() { return __WEBPACK_IMPORTED_MODULE_19__curve_bundle_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__curve_cardinalClosed_js__ = __webpack_require__(597);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCardinalClosed", function() { return __WEBPACK_IMPORTED_MODULE_20__curve_cardinalClosed_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__curve_cardinalOpen_js__ = __webpack_require__(598);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCardinalOpen", function() { return __WEBPACK_IMPORTED_MODULE_21__curve_cardinalOpen_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__curve_cardinal_js__ = __webpack_require__(261);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCardinal", function() { return __WEBPACK_IMPORTED_MODULE_22__curve_cardinal_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__curve_catmullRomClosed_js__ = __webpack_require__(2188);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCatmullRomClosed", function() { return __WEBPACK_IMPORTED_MODULE_23__curve_catmullRomClosed_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__curve_catmullRomOpen_js__ = __webpack_require__(2189);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCatmullRomOpen", function() { return __WEBPACK_IMPORTED_MODULE_24__curve_catmullRomOpen_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__curve_catmullRom_js__ = __webpack_require__(359);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveCatmullRom", function() { return __WEBPACK_IMPORTED_MODULE_25__curve_catmullRom_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__curve_linearClosed_js__ = __webpack_require__(2190);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveLinearClosed", function() { return __WEBPACK_IMPORTED_MODULE_26__curve_linearClosed_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__curve_linear_js__ = __webpack_require__(258);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveLinear", function() { return __WEBPACK_IMPORTED_MODULE_27__curve_linear_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__curve_monotone_js__ = __webpack_require__(2191);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveMonotoneX", function() { return __WEBPACK_IMPORTED_MODULE_28__curve_monotone_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveMonotoneY", function() { return __WEBPACK_IMPORTED_MODULE_28__curve_monotone_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__curve_natural_js__ = __webpack_require__(2192);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveNatural", function() { return __WEBPACK_IMPORTED_MODULE_29__curve_natural_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__curve_step_js__ = __webpack_require__(2193);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveStep", function() { return __WEBPACK_IMPORTED_MODULE_30__curve_step_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveStepAfter", function() { return __WEBPACK_IMPORTED_MODULE_30__curve_step_js__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "curveStepBefore", function() { return __WEBPACK_IMPORTED_MODULE_30__curve_step_js__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__stack_js__ = __webpack_require__(2194);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stack", function() { return __WEBPACK_IMPORTED_MODULE_31__stack_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__offset_expand_js__ = __webpack_require__(2195);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOffsetExpand", function() { return __WEBPACK_IMPORTED_MODULE_32__offset_expand_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__offset_diverging_js__ = __webpack_require__(2196);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOffsetDiverging", function() { return __WEBPACK_IMPORTED_MODULE_33__offset_diverging_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__offset_none_js__ = __webpack_require__(199);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOffsetNone", function() { return __WEBPACK_IMPORTED_MODULE_34__offset_none_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__offset_silhouette_js__ = __webpack_require__(2197);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOffsetSilhouette", function() { return __WEBPACK_IMPORTED_MODULE_35__offset_silhouette_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__offset_wiggle_js__ = __webpack_require__(2198);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOffsetWiggle", function() { return __WEBPACK_IMPORTED_MODULE_36__offset_wiggle_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__order_appearance_js__ = __webpack_require__(599);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOrderAppearance", function() { return __WEBPACK_IMPORTED_MODULE_37__order_appearance_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__order_ascending_js__ = __webpack_require__(360);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOrderAscending", function() { return __WEBPACK_IMPORTED_MODULE_38__order_ascending_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__order_descending_js__ = __webpack_require__(2199);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOrderDescending", function() { return __WEBPACK_IMPORTED_MODULE_39__order_descending_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__order_insideOut_js__ = __webpack_require__(2200);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOrderInsideOut", function() { return __WEBPACK_IMPORTED_MODULE_40__order_insideOut_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__order_none_js__ = __webpack_require__(200);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOrderNone", function() { return __WEBPACK_IMPORTED_MODULE_41__order_none_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__order_reverse_js__ = __webpack_require__(2201);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stackOrderReverse", function() { return __WEBPACK_IMPORTED_MODULE_42__order_reverse_js__["a"]; });




 // Note: radialArea is deprecated!
 // Note: radialLine is deprecated!










































/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Adds floating point numbers with twice the normal precision.
// Reference: J. R. Shewchuk, Adaptive Precision Floating-Point Arithmetic and
// Fast Robust Geometric Predicates, Discrete & Computational Geometry 18(3)
// 305–363 (1997).
// Code adapted from GeographicLib by Charles F. F. Karney,
// http://geographiclib.sourceforge.net/

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return new Adder;
});

function Adder() {
  this.reset();
}

Adder.prototype = {
  constructor: Adder,
  reset: function() {
    this.s = // rounded value
    this.t = 0; // exact error
  },
  add: function(y) {
    add(temp, y, this.t);
    add(this, temp.s, this.s);
    if (this.s) this.t += temp.t;
    else this.s = temp.t;
  },
  valueOf: function() {
    return this.s;
  }
};

var temp = new Adder;

function add(adder, a, b) {
  var x = adder.s = a + b,
      bv = x - a,
      av = x - bv;
  adder.t = (a - av) + (b - bv);
}


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(268);
var createDesc = __webpack_require__(656);
module.exports = __webpack_require__(205) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}// Fetches the client's public IP address (via ipify) for server-side audit
// logging. Caches successful lookups in localStorage so repeat calls on the
// same device don't need a fresh network call every time, and aren't exposed
// to a slow/hung ipify response. Only successful lookups are ever cached — a
// failed/timed-out lookup never overwrites a previously good value.
var CLIENT_IP_CACHE_KEY='clientPublicIp';var CLIENT_IP_CACHE_FRESH_MS=15*60*1000;// 15 minutes
var getCachedClientIp=function getCachedClientIp(){try{var raw=localStorage.getItem(CLIENT_IP_CACHE_KEY);return raw?JSON.parse(raw):null;}catch(error){return null;}};var setCachedClientIp=function setCachedClientIp(ip){try{localStorage.setItem(CLIENT_IP_CACHE_KEY,JSON.stringify({ip:ip,timestamp:Date.now()}));}catch(error){// ignore storage errors (quota, private mode, etc.)
}};var fetchClientPublicIp=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var cached,isFresh,controller,timeoutId,response,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:cached=getCachedClientIp();isFresh=cached&&Date.now()-cached.timestamp<CLIENT_IP_CACHE_FRESH_MS;if(!isFresh){_context.next=4;break;}return _context.abrupt('return',cached.ip);case 4:_context.prev=4;controller=new AbortController();timeoutId=setTimeout(function(){return controller.abort();},5000);_context.next=9;return fetch('https://api.ipify.org?format=json',{signal:controller.signal});case 9:response=_context.sent;clearTimeout(timeoutId);if(response.ok){_context.next=13;break;}throw new Error('ipify returned a non-OK response');case 13:_context.next=15;return response.json();case 15:data=_context.sent;if(!(!data||!data.ip)){_context.next=18;break;}throw new Error('ipify response missing ip');case 18:setCachedClientIp(data.ip);return _context.abrupt('return',data.ip);case 22:_context.prev=22;_context.t0=_context['catch'](4);return _context.abrupt('return',cached?cached.ip:undefined);case 25:case'end':return _context.stop();}}},_callee,_this,[[4,22]]);}));return function fetchClientPublicIp(){return _ref.apply(this,arguments);};}();/* harmony default export */ __webpack_exports__["a"] = (fetchClientPublicIp);

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export $$iterator */
/* unused harmony export isIterable */
/* unused harmony export isArrayLike */
/* harmony export (immutable) */ __webpack_exports__["e"] = isCollection;
/* unused harmony export getIterator */
/* unused harmony export getIteratorMethod */
/* unused harmony export createIterator */
/* harmony export (immutable) */ __webpack_exports__["b"] = forEach;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return $$asyncIterator; });
/* harmony export (immutable) */ __webpack_exports__["d"] = isAsyncIterable;
/* harmony export (immutable) */ __webpack_exports__["c"] = getAsyncIterator;
/* unused harmony export getAsyncIteratorMethod */
/* unused harmony export createAsyncIterator */
/* unused harmony export forAwaitEach */
/**
 * Copyright (c) 2016, Lee Byron
 * All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @flow
 * @ignore
 */

/**
 * [Iterator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterator)
 * is a *protocol* which describes a standard way to produce a sequence of
 * values, typically the values of the Iterable represented by this Iterator.
 *
 * While described by the [ES2015 version of JavaScript](http://www.ecma-international.org/ecma-262/6.0/#sec-iterator-interface)
 * it can be utilized by any version of JavaScript.
 *
 * @external Iterator
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterator|MDN Iteration protocols}
 */

/**
 * [Iterable](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable)
 * is a *protocol* which when implemented allows a JavaScript object to define
 * their iteration behavior, such as what values are looped over in a
 * [`for...of`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/for...of)
 * loop or `iterall`'s `forEach` function. Many [built-in types](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#Builtin_iterables)
 * implement the Iterable protocol, including `Array` and `Map`.
 *
 * While described by the [ES2015 version of JavaScript](http://www.ecma-international.org/ecma-262/6.0/#sec-iterable-interface)
 * it can be utilized by any version of JavaScript.
 *
 * @external Iterable
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable|MDN Iteration protocols}
 */

// In ES2015 environments, Symbol exists
var SYMBOL /*: any */ = typeof Symbol === 'function' ? Symbol : void 0

// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
var SYMBOL_ITERATOR = SYMBOL && SYMBOL.iterator

/**
 * A property name to be used as the name of an Iterable's method responsible
 * for producing an Iterator, referred to as `@@iterator`. Typically represents
 * the value `Symbol.iterator` but falls back to the string `"@@iterator"` when
 * `Symbol.iterator` is not defined.
 *
 * Use `$$iterator` for defining new Iterables instead of `Symbol.iterator`,
 * but do not use it for accessing existing Iterables, instead use
 * {@link getIterator} or {@link isIterable}.
 *
 * @example
 *
 * var $$iterator = require('iterall').$$iterator
 *
 * function Counter (to) {
 *   this.to = to
 * }
 *
 * Counter.prototype[$$iterator] = function () {
 *   return {
 *     to: this.to,
 *     num: 0,
 *     next () {
 *       if (this.num >= this.to) {
 *         return { value: undefined, done: true }
 *       }
 *       return { value: this.num++, done: false }
 *     }
 *   }
 * }
 *
 * var counter = new Counter(3)
 * for (var number of counter) {
 *   console.log(number) // 0 ... 1 ... 2
 * }
 *
 * @type {Symbol|string}
 */
/*:: declare export var $$iterator: '@@iterator'; */
var $$iterator = SYMBOL_ITERATOR || '@@iterator'

/**
 * Returns true if the provided object implements the Iterator protocol via
 * either implementing a `Symbol.iterator` or `"@@iterator"` method.
 *
 * @example
 *
 * var isIterable = require('iterall').isIterable
 * isIterable([ 1, 2, 3 ]) // true
 * isIterable('ABC') // true
 * isIterable({ length: 1, 0: 'Alpha' }) // false
 * isIterable({ key: 'value' }) // false
 * isIterable(new Map()) // true
 *
 * @param obj
 *   A value which might implement the Iterable protocol.
 * @return {boolean} true if Iterable.
 */
/*:: declare export function isIterable(obj: any): boolean; */
function isIterable(obj) {
  return !!getIteratorMethod(obj)
}

/**
 * Returns true if the provided object implements the Array-like protocol via
 * defining a positive-integer `length` property.
 *
 * @example
 *
 * var isArrayLike = require('iterall').isArrayLike
 * isArrayLike([ 1, 2, 3 ]) // true
 * isArrayLike('ABC') // true
 * isArrayLike({ length: 1, 0: 'Alpha' }) // true
 * isArrayLike({ key: 'value' }) // false
 * isArrayLike(new Map()) // false
 *
 * @param obj
 *   A value which might implement the Array-like protocol.
 * @return {boolean} true if Array-like.
 */
/*:: declare export function isArrayLike(obj: any): boolean; */
function isArrayLike(obj) {
  var length = obj != null && obj.length
  return typeof length === 'number' && length >= 0 && length % 1 === 0
}

/**
 * Returns true if the provided object is an Object (i.e. not a string literal)
 * and is either Iterable or Array-like.
 *
 * This may be used in place of [Array.isArray()][isArray] to determine if an
 * object should be iterated-over. It always excludes string literals and
 * includes Arrays (regardless of if it is Iterable). It also includes other
 * Array-like objects such as NodeList, TypedArray, and Buffer.
 *
 * @example
 *
 * var isCollection = require('iterall').isCollection
 * isCollection([ 1, 2, 3 ]) // true
 * isCollection('ABC') // false
 * isCollection({ length: 1, 0: 'Alpha' }) // true
 * isCollection({ key: 'value' }) // false
 * isCollection(new Map()) // true
 *
 * @example
 *
 * var forEach = require('iterall').forEach
 * if (isCollection(obj)) {
 *   forEach(obj, function (value) {
 *     console.log(value)
 *   })
 * }
 *
 * @param obj
 *   An Object value which might implement the Iterable or Array-like protocols.
 * @return {boolean} true if Iterable or Array-like Object.
 */
/*:: declare export function isCollection(obj: any): boolean; */
function isCollection(obj) {
  return Object(obj) === obj && (isArrayLike(obj) || isIterable(obj))
}

/**
 * If the provided object implements the Iterator protocol, its Iterator object
 * is returned. Otherwise returns undefined.
 *
 * @example
 *
 * var getIterator = require('iterall').getIterator
 * var iterator = getIterator([ 1, 2, 3 ])
 * iterator.next() // { value: 1, done: false }
 * iterator.next() // { value: 2, done: false }
 * iterator.next() // { value: 3, done: false }
 * iterator.next() // { value: undefined, done: true }
 *
 * @template T the type of each iterated value
 * @param {Iterable<T>} iterable
 *   An Iterable object which is the source of an Iterator.
 * @return {Iterator<T>} new Iterator instance.
 */
/*:: declare export var getIterator:
  & (<+TValue>(iterable: Iterable<TValue>) => Iterator<TValue>)
  & ((iterable: mixed) => void | Iterator<mixed>); */
function getIterator(iterable) {
  var method = getIteratorMethod(iterable)
  if (method) {
    return method.call(iterable)
  }
}

/**
 * If the provided object implements the Iterator protocol, the method
 * responsible for producing its Iterator object is returned.
 *
 * This is used in rare cases for performance tuning. This method must be called
 * with obj as the contextual this-argument.
 *
 * @example
 *
 * var getIteratorMethod = require('iterall').getIteratorMethod
 * var myArray = [ 1, 2, 3 ]
 * var method = getIteratorMethod(myArray)
 * if (method) {
 *   var iterator = method.call(myArray)
 * }
 *
 * @template T the type of each iterated value
 * @param {Iterable<T>} iterable
 *   An Iterable object which defines an `@@iterator` method.
 * @return {function(): Iterator<T>} `@@iterator` method.
 */
/*:: declare export var getIteratorMethod:
  & (<+TValue>(iterable: Iterable<TValue>) => (() => Iterator<TValue>))
  & ((iterable: mixed) => (void | (() => Iterator<mixed>))); */
function getIteratorMethod(iterable) {
  if (iterable != null) {
    var method =
      (SYMBOL_ITERATOR && iterable[SYMBOL_ITERATOR]) || iterable['@@iterator']
    if (typeof method === 'function') {
      return method
    }
  }
}

/**
 * Similar to {@link getIterator}, this method returns a new Iterator given an
 * Iterable. However it will also create an Iterator for a non-Iterable
 * Array-like collection, such as Array in a non-ES2015 environment.
 *
 * `createIterator` is complimentary to `forEach`, but allows a "pull"-based
 * iteration as opposed to `forEach`'s "push"-based iteration.
 *
 * `createIterator` produces an Iterator for Array-likes with the same behavior
 * as ArrayIteratorPrototype described in the ECMAScript specification, and
 * does *not* skip over "holes".
 *
 * @example
 *
 * var createIterator = require('iterall').createIterator
 *
 * var myArraylike = { length: 3, 0: 'Alpha', 1: 'Bravo', 2: 'Charlie' }
 * var iterator = createIterator(myArraylike)
 * iterator.next() // { value: 'Alpha', done: false }
 * iterator.next() // { value: 'Bravo', done: false }
 * iterator.next() // { value: 'Charlie', done: false }
 * iterator.next() // { value: undefined, done: true }
 *
 * @template T the type of each iterated value
 * @param {Iterable<T>|{ length: number }} collection
 *   An Iterable or Array-like object to produce an Iterator.
 * @return {Iterator<T>} new Iterator instance.
 */
/*:: declare export var createIterator:
  & (<+TValue>(collection: Iterable<TValue>) => Iterator<TValue>)
  & ((collection: {length: number}) => Iterator<mixed>)
  & ((collection: mixed) => (void | Iterator<mixed>)); */
function createIterator(collection) {
  if (collection != null) {
    var iterator = getIterator(collection)
    if (iterator) {
      return iterator
    }
    if (isArrayLike(collection)) {
      return new ArrayLikeIterator(collection)
    }
  }
}

// When the object provided to `createIterator` is not Iterable but is
// Array-like, this simple Iterator is created.
function ArrayLikeIterator(obj) {
  this._o = obj
  this._i = 0
}

// Note: all Iterators are themselves Iterable.
ArrayLikeIterator.prototype[$$iterator] = function() {
  return this
}

// A simple state-machine determines the IteratorResult returned, yielding
// each value in the Array-like object in order of their indicies.
ArrayLikeIterator.prototype.next = function() {
  if (this._o === void 0 || this._i >= this._o.length) {
    this._o = void 0
    return { value: void 0, done: true }
  }
  return { value: this._o[this._i++], done: false }
}

/**
 * Given an object which either implements the Iterable protocol or is
 * Array-like, iterate over it, calling the `callback` at each iteration.
 *
 * Use `forEach` where you would expect to use a `for ... of` loop in ES6.
 * However `forEach` adheres to the behavior of [Array#forEach][] described in
 * the ECMAScript specification, skipping over "holes" in Array-likes. It will
 * also delegate to a `forEach` method on `collection` if one is defined,
 * ensuring native performance for `Arrays`.
 *
 * Similar to [Array#forEach][], the `callback` function accepts three
 * arguments, and is provided with `thisArg` as the calling context.
 *
 * Note: providing an infinite Iterator to forEach will produce an error.
 *
 * [Array#forEach]: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach
 *
 * @example
 *
 * var forEach = require('iterall').forEach
 *
 * forEach(myIterable, function (value, index, iterable) {
 *   console.log(value, index, iterable === myIterable)
 * })
 *
 * @example
 *
 * // ES6:
 * for (let value of myIterable) {
 *   console.log(value)
 * }
 *
 * // Any JavaScript environment:
 * forEach(myIterable, function (value) {
 *   console.log(value)
 * })
 *
 * @template T the type of each iterated value
 * @param {Iterable<T>|{ length: number }} collection
 *   The Iterable or array to iterate over.
 * @param {function(T, number, object)} callback
 *   Function to execute for each iteration, taking up to three arguments
 * @param [thisArg]
 *   Optional. Value to use as `this` when executing `callback`.
 */
/*:: declare export var forEach:
  & (<+TValue, TCollection: Iterable<TValue>>(
      collection: TCollection,
      callbackFn: (value: TValue, index: number, collection: TCollection) => any,
      thisArg?: any
    ) => void)
  & (<TCollection: {length: number}>(
      collection: TCollection,
      callbackFn: (value: mixed, index: number, collection: TCollection) => any,
      thisArg?: any
    ) => void); */
function forEach(collection, callback, thisArg) {
  if (collection != null) {
    if (typeof collection.forEach === 'function') {
      return collection.forEach(callback, thisArg)
    }
    var i = 0
    var iterator = getIterator(collection)
    if (iterator) {
      var step
      while (!(step = iterator.next()).done) {
        callback.call(thisArg, step.value, i++, collection)
        // Infinite Iterators could cause forEach to run forever.
        // After a very large number of iterations, produce an error.
        /* istanbul ignore if */
        if (i > 9999999) {
          throw new TypeError('Near-infinite iteration.')
        }
      }
    } else if (isArrayLike(collection)) {
      for (; i < collection.length; i++) {
        if (collection.hasOwnProperty(i)) {
          callback.call(thisArg, collection[i], i, collection)
        }
      }
    }
  }
}

/////////////////////////////////////////////////////
//                                                 //
//                 ASYNC ITERATORS                 //
//                                                 //
/////////////////////////////////////////////////////

/**
 * [AsyncIterable](https://tc39.github.io/proposal-async-iteration/#sec-asynciterable-interface)
 * is a *protocol* which when implemented allows a JavaScript object to define
 * an asynchronous iteration behavior, such as what values are looped over in
 * a [`for-await-of`](https://tc39.github.io/proposal-async-iteration/#sec-for-in-and-for-of-statements)
 * loop or `iterall`'s {@link forAwaitEach} function.
 *
 * While described as a proposed addition to the [ES2017 version of JavaScript](https://tc39.github.io/proposal-async-iteration/)
 * it can be utilized by any version of JavaScript.
 *
 * @external AsyncIterable
 * @see {@link https://tc39.github.io/proposal-async-iteration/#sec-asynciterable-interface|Async Iteration Proposal}
 * @template T The type of each iterated value
 * @property {function (): AsyncIterator<T>} Symbol.asyncIterator
 *   A method which produces an AsyncIterator for this AsyncIterable.
 */

/**
 * [AsyncIterator](https://tc39.github.io/proposal-async-iteration/#sec-asynciterator-interface)
 * is a *protocol* which describes a standard way to produce and consume an
 * asynchronous sequence of values, typically the values of the
 * {@link AsyncIterable} represented by this {@link AsyncIterator}.
 *
 * AsyncIterator is similar to Observable or Stream. Like an {@link Iterator} it
 * also as a `next()` method, however instead of an IteratorResult,
 * calling this method returns a {@link Promise} for a IteratorResult.
 *
 * While described as a proposed addition to the [ES2017 version of JavaScript](https://tc39.github.io/proposal-async-iteration/)
 * it can be utilized by any version of JavaScript.
 *
 * @external AsyncIterator
 * @see {@link https://tc39.github.io/proposal-async-iteration/#sec-asynciterator-interface|Async Iteration Proposal}
 */

// In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
var SYMBOL_ASYNC_ITERATOR = SYMBOL && SYMBOL.asyncIterator

/**
 * A property name to be used as the name of an AsyncIterable's method
 * responsible for producing an Iterator, referred to as `@@asyncIterator`.
 * Typically represents the value `Symbol.asyncIterator` but falls back to the
 * string `"@@asyncIterator"` when `Symbol.asyncIterator` is not defined.
 *
 * Use `$$asyncIterator` for defining new AsyncIterables instead of
 * `Symbol.asyncIterator`, but do not use it for accessing existing Iterables,
 * instead use {@link getAsyncIterator} or {@link isAsyncIterable}.
 *
 * @example
 *
 * var $$asyncIterator = require('iterall').$$asyncIterator
 *
 * function Chirper (to) {
 *   this.to = to
 * }
 *
 * Chirper.prototype[$$asyncIterator] = function () {
 *   return {
 *     to: this.to,
 *     num: 0,
 *     next () {
 *       return new Promise(resolve => {
 *         if (this.num >= this.to) {
 *           resolve({ value: undefined, done: true })
 *         } else {
 *           setTimeout(() => {
 *             resolve({ value: this.num++, done: false })
 *           }, 1000)
 *         }
 *       })
 *     }
 *   }
 * }
 *
 * var chirper = new Chirper(3)
 * for await (var number of chirper) {
 *   console.log(number) // 0 ...wait... 1 ...wait... 2
 * }
 *
 * @type {Symbol|string}
 */
/*:: declare export var $$asyncIterator: '@@asyncIterator'; */
var $$asyncIterator = SYMBOL_ASYNC_ITERATOR || '@@asyncIterator'

/**
 * Returns true if the provided object implements the AsyncIterator protocol via
 * either implementing a `Symbol.asyncIterator` or `"@@asyncIterator"` method.
 *
 * @example
 *
 * var isAsyncIterable = require('iterall').isAsyncIterable
 * isAsyncIterable(myStream) // true
 * isAsyncIterable('ABC') // false
 *
 * @param obj
 *   A value which might implement the AsyncIterable protocol.
 * @return {boolean} true if AsyncIterable.
 */
/*:: declare export function isAsyncIterable(obj: any): boolean; */
function isAsyncIterable(obj) {
  return !!getAsyncIteratorMethod(obj)
}

/**
 * If the provided object implements the AsyncIterator protocol, its
 * AsyncIterator object is returned. Otherwise returns undefined.
 *
 * @example
 *
 * var getAsyncIterator = require('iterall').getAsyncIterator
 * var asyncIterator = getAsyncIterator(myStream)
 * asyncIterator.next().then(console.log) // { value: 1, done: false }
 * asyncIterator.next().then(console.log) // { value: 2, done: false }
 * asyncIterator.next().then(console.log) // { value: 3, done: false }
 * asyncIterator.next().then(console.log) // { value: undefined, done: true }
 *
 * @template T the type of each iterated value
 * @param {AsyncIterable<T>} asyncIterable
 *   An AsyncIterable object which is the source of an AsyncIterator.
 * @return {AsyncIterator<T>} new AsyncIterator instance.
 */
/*:: declare export var getAsyncIterator:
  & (<+TValue>(asyncIterable: AsyncIterable<TValue>) => AsyncIterator<TValue>)
  & ((asyncIterable: mixed) => (void | AsyncIterator<mixed>)); */
function getAsyncIterator(asyncIterable) {
  var method = getAsyncIteratorMethod(asyncIterable)
  if (method) {
    return method.call(asyncIterable)
  }
}

/**
 * If the provided object implements the AsyncIterator protocol, the method
 * responsible for producing its AsyncIterator object is returned.
 *
 * This is used in rare cases for performance tuning. This method must be called
 * with obj as the contextual this-argument.
 *
 * @example
 *
 * var getAsyncIteratorMethod = require('iterall').getAsyncIteratorMethod
 * var method = getAsyncIteratorMethod(myStream)
 * if (method) {
 *   var asyncIterator = method.call(myStream)
 * }
 *
 * @template T the type of each iterated value
 * @param {AsyncIterable<T>} asyncIterable
 *   An AsyncIterable object which defines an `@@asyncIterator` method.
 * @return {function(): AsyncIterator<T>} `@@asyncIterator` method.
 */
/*:: declare export var getAsyncIteratorMethod:
  & (<+TValue>(asyncIterable: AsyncIterable<TValue>) => (() => AsyncIterator<TValue>))
  & ((asyncIterable: mixed) => (void | (() => AsyncIterator<mixed>))); */
function getAsyncIteratorMethod(asyncIterable) {
  if (asyncIterable != null) {
    var method =
      (SYMBOL_ASYNC_ITERATOR && asyncIterable[SYMBOL_ASYNC_ITERATOR]) ||
      asyncIterable['@@asyncIterator']
    if (typeof method === 'function') {
      return method
    }
  }
}

/**
 * Similar to {@link getAsyncIterator}, this method returns a new AsyncIterator
 * given an AsyncIterable. However it will also create an AsyncIterator for a
 * non-async Iterable as well as non-Iterable Array-like collection, such as
 * Array in a pre-ES2015 environment.
 *
 * `createAsyncIterator` is complimentary to `forAwaitEach`, but allows a
 * buffering "pull"-based iteration as opposed to `forAwaitEach`'s
 * "push"-based iteration.
 *
 * `createAsyncIterator` produces an AsyncIterator for non-async Iterables as
 * described in the ECMAScript proposal [Async-from-Sync Iterator Objects](https://tc39.github.io/proposal-async-iteration/#sec-async-from-sync-iterator-objects).
 *
 * > Note: Creating `AsyncIterator`s requires the existence of `Promise`.
 * > While `Promise` has been available in modern browsers for a number of
 * > years, legacy browsers (like IE 11) may require a polyfill.
 *
 * @example
 *
 * var createAsyncIterator = require('iterall').createAsyncIterator
 *
 * var myArraylike = { length: 3, 0: 'Alpha', 1: 'Bravo', 2: 'Charlie' }
 * var iterator = createAsyncIterator(myArraylike)
 * iterator.next().then(console.log) // { value: 'Alpha', done: false }
 * iterator.next().then(console.log) // { value: 'Bravo', done: false }
 * iterator.next().then(console.log) // { value: 'Charlie', done: false }
 * iterator.next().then(console.log) // { value: undefined, done: true }
 *
 * @template T the type of each iterated value
 * @param {AsyncIterable<T>|Iterable<T>|{ length: number }} source
 *   An AsyncIterable, Iterable, or Array-like object to produce an Iterator.
 * @return {AsyncIterator<T>} new AsyncIterator instance.
 */
/*:: declare export var createAsyncIterator:
  & (<+TValue>(
      collection: Iterable<Promise<TValue> | TValue> | AsyncIterable<TValue>
    ) => AsyncIterator<TValue>)
  & ((collection: {length: number}) => AsyncIterator<mixed>)
  & ((collection: mixed) => (void | AsyncIterator<mixed>)); */
function createAsyncIterator(source) {
  if (source != null) {
    var asyncIterator = getAsyncIterator(source)
    if (asyncIterator) {
      return asyncIterator
    }
    var iterator = createIterator(source)
    if (iterator) {
      return new AsyncFromSyncIterator(iterator)
    }
  }
}

// When the object provided to `createAsyncIterator` is not AsyncIterable but is
// sync Iterable, this simple wrapper is created.
function AsyncFromSyncIterator(iterator) {
  this._i = iterator
}

// Note: all AsyncIterators are themselves AsyncIterable.
AsyncFromSyncIterator.prototype[$$asyncIterator] = function() {
  return this
}

// A simple state-machine determines the IteratorResult returned, yielding
// each value in the Array-like object in order of their indicies.
AsyncFromSyncIterator.prototype.next = function(value) {
  return unwrapAsyncFromSync(this._i, 'next', value)
}

AsyncFromSyncIterator.prototype.return = function(value) {
  return this._i.return
    ? unwrapAsyncFromSync(this._i, 'return', value)
    : Promise.resolve({ value: value, done: true })
}

AsyncFromSyncIterator.prototype.throw = function(value) {
  return this._i.throw
    ? unwrapAsyncFromSync(this._i, 'throw', value)
    : Promise.reject(value)
}

function unwrapAsyncFromSync(iterator, fn, value) {
  var step
  return new Promise(function(resolve) {
    step = iterator[fn](value)
    resolve(step.value)
  }).then(function(value) {
    return { value: value, done: step.done }
  })
}

/**
 * Given an object which either implements the AsyncIterable protocol or is
 * Array-like, iterate over it, calling the `callback` at each iteration.
 *
 * Use `forAwaitEach` where you would expect to use a [for-await-of](https://tc39.github.io/proposal-async-iteration/#sec-for-in-and-for-of-statements) loop.
 *
 * Similar to [Array#forEach][], the `callback` function accepts three
 * arguments, and is provided with `thisArg` as the calling context.
 *
 * > Note: Using `forAwaitEach` requires the existence of `Promise`.
 * > While `Promise` has been available in modern browsers for a number of
 * > years, legacy browsers (like IE 11) may require a polyfill.
 *
 * @example
 *
 * var forAwaitEach = require('iterall').forAwaitEach
 *
 * forAwaitEach(myIterable, function (value, index, iterable) {
 *   console.log(value, index, iterable === myIterable)
 * })
 *
 * @example
 *
 * // ES2017:
 * for await (let value of myAsyncIterable) {
 *   console.log(await doSomethingAsync(value))
 * }
 * console.log('done')
 *
 * // Any JavaScript environment:
 * forAwaitEach(myAsyncIterable, function (value) {
 *   return doSomethingAsync(value).then(console.log)
 * }).then(function () {
 *   console.log('done')
 * })
 *
 * @template T the type of each iterated value
 * @param {AsyncIterable<T>|Iterable<Promise<T> | T>|{ length: number }} source
 *   The AsyncIterable or array to iterate over.
 * @param {function(T, number, object)} callback
 *   Function to execute for each iteration, taking up to three arguments
 * @param [thisArg]
 *   Optional. Value to use as `this` when executing `callback`.
 */
/*:: declare export var forAwaitEach:
  & (<+TValue, TCollection: Iterable<Promise<TValue> | TValue> | AsyncIterable<TValue>>(
      collection: TCollection,
      callbackFn: (value: TValue, index: number, collection: TCollection) => any,
      thisArg?: any
    ) => Promise<void>)
  & (<TCollection: { length: number }>(
      collection: TCollection,
      callbackFn: (value: mixed, index: number, collection: TCollection) => any,
      thisArg?: any
    ) => Promise<void>); */
function forAwaitEach(source, callback, thisArg) {
  var asyncIterator = createAsyncIterator(source)
  if (asyncIterator) {
    var i = 0
    return new Promise(function(resolve, reject) {
      function next() {
        asyncIterator
          .next()
          .then(function(step) {
            if (!step.done) {
              Promise.resolve(callback.call(thisArg, step.value, i++, source))
                .then(next)
                .catch(reject)
            } else {
              resolve()
            }
            // Explicitly return null, silencing bluebird-style warnings.
            return null
          })
          .catch(reject)
        // Explicitly return null, silencing bluebird-style warnings.
        return null
      }
      next()
    })
  }
}


/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parse;
/* harmony export (immutable) */ __webpack_exports__["b"] = parseValue;
/* unused harmony export parseType */
/* unused harmony export parseConstValue */
/* unused harmony export parseTypeReference */
/* unused harmony export parseNamedType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__source__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lexer__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__kinds__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__directiveLocation__ = __webpack_require__(138);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */










/**
 * Configuration options to control parser behavior
 */


/**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */
function parse(source, options) {
  var sourceObj = typeof source === 'string' ? new __WEBPACK_IMPORTED_MODULE_0__source__["a" /* Source */](source) : source;
  if (!(sourceObj instanceof __WEBPACK_IMPORTED_MODULE_0__source__["a" /* Source */])) {
    throw new TypeError('Must provide Source. Received: ' + String(sourceObj));
  }
  var lexer = Object(__WEBPACK_IMPORTED_MODULE_2__lexer__["b" /* createLexer */])(sourceObj, options || {});
  return parseDocument(lexer);
}

/**
 * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
 * that value.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Values directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: valueFromAST().
 */
function parseValue(source, options) {
  var sourceObj = typeof source === 'string' ? new __WEBPACK_IMPORTED_MODULE_0__source__["a" /* Source */](source) : source;
  var lexer = Object(__WEBPACK_IMPORTED_MODULE_2__lexer__["b" /* createLexer */])(sourceObj, options || {});
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].SOF);
  var value = parseValueLiteral(lexer, false);
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].EOF);
  return value;
}

/**
 * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
 * that type.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Types directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: typeFromAST().
 */
function parseType(source, options) {
  var sourceObj = typeof source === 'string' ? new __WEBPACK_IMPORTED_MODULE_0__source__["a" /* Source */](source) : source;
  var lexer = Object(__WEBPACK_IMPORTED_MODULE_2__lexer__["b" /* createLexer */])(sourceObj, options || {});
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].SOF);
  var type = parseTypeReference(lexer);
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].EOF);
  return type;
}

/**
 * Converts a name lex token into a name parse node.
 */
function parseName(lexer) {
  var token = expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].NAME);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].NAME,
    value: token.value,
    loc: loc(lexer, token)
  };
}

// Implements the parsing rules in the Document section.

/**
 * Document : Definition+
 */
function parseDocument(lexer) {
  var start = lexer.token;
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].SOF);
  var definitions = [];
  do {
    definitions.push(parseDefinition(lexer));
  } while (!skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].EOF));

  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].DOCUMENT,
    definitions: definitions,
    loc: loc(lexer, start)
  };
}

/**
 * Definition :
 *   - ExecutableDefinition
 *   - TypeSystemDefinition
 */
function parseDefinition(lexer) {
  if (peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].NAME)) {
    switch (lexer.token.value) {
      case 'query':
      case 'mutation':
      case 'subscription':
      case 'fragment':
        return parseExecutableDefinition(lexer);
      case 'schema':
      case 'scalar':
      case 'type':
      case 'interface':
      case 'union':
      case 'enum':
      case 'input':
      case 'extend':
      case 'directive':
        // Note: The schema definition language is an experimental addition.
        return parseTypeSystemDefinition(lexer);
    }
  } else if (peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L)) {
    return parseExecutableDefinition(lexer);
  } else if (peekDescription(lexer)) {
    // Note: The schema definition language is an experimental addition.
    return parseTypeSystemDefinition(lexer);
  }

  throw unexpected(lexer);
}

/**
 * ExecutableDefinition :
 *   - OperationDefinition
 *   - FragmentDefinition
 */
function parseExecutableDefinition(lexer) {
  if (peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].NAME)) {
    switch (lexer.token.value) {
      case 'query':
      case 'mutation':
      case 'subscription':
        return parseOperationDefinition(lexer);

      case 'fragment':
        return parseFragmentDefinition(lexer);
    }
  } else if (peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L)) {
    return parseOperationDefinition(lexer);
  }

  throw unexpected(lexer);
}

// Implements the parsing rules in the Operations section.

/**
 * OperationDefinition :
 *  - SelectionSet
 *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
 */
function parseOperationDefinition(lexer) {
  var start = lexer.token;
  if (peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L)) {
    return {
      kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].OPERATION_DEFINITION,
      operation: 'query',
      name: undefined,
      variableDefinitions: [],
      directives: [],
      selectionSet: parseSelectionSet(lexer),
      loc: loc(lexer, start)
    };
  }
  var operation = parseOperationType(lexer);
  var name = void 0;
  if (peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].NAME)) {
    name = parseName(lexer);
  }
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].OPERATION_DEFINITION,
    operation: operation,
    name: name,
    variableDefinitions: parseVariableDefinitions(lexer),
    directives: parseDirectives(lexer, false),
    selectionSet: parseSelectionSet(lexer),
    loc: loc(lexer, start)
  };
}

/**
 * OperationType : one of query mutation subscription
 */
function parseOperationType(lexer) {
  var operationToken = expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].NAME);
  switch (operationToken.value) {
    case 'query':
      return 'query';
    case 'mutation':
      return 'mutation';
    case 'subscription':
      return 'subscription';
  }

  throw unexpected(lexer, operationToken);
}

/**
 * VariableDefinitions : ( VariableDefinition+ )
 */
function parseVariableDefinitions(lexer) {
  return peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PAREN_L) ? many(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PAREN_L, parseVariableDefinition, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PAREN_R) : [];
}

/**
 * VariableDefinition : Variable : Type DefaultValue?
 */
function parseVariableDefinition(lexer) {
  var start = lexer.token;
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].VARIABLE_DEFINITION,
    variable: parseVariable(lexer),
    type: (expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].COLON), parseTypeReference(lexer)),
    defaultValue: skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].EQUALS) ? parseValueLiteral(lexer, true) : undefined,
    loc: loc(lexer, start)
  };
}

/**
 * Variable : $ Name
 */
function parseVariable(lexer) {
  var start = lexer.token;
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].DOLLAR);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].VARIABLE,
    name: parseName(lexer),
    loc: loc(lexer, start)
  };
}

/**
 * SelectionSet : { Selection+ }
 */
function parseSelectionSet(lexer) {
  var start = lexer.token;
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].SELECTION_SET,
    selections: many(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L, parseSelection, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_R),
    loc: loc(lexer, start)
  };
}

/**
 * Selection :
 *   - Field
 *   - FragmentSpread
 *   - InlineFragment
 */
function parseSelection(lexer) {
  return peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].SPREAD) ? parseFragment(lexer) : parseField(lexer);
}

/**
 * Field : Alias? Name Arguments? Directives? SelectionSet?
 *
 * Alias : Name :
 */
function parseField(lexer) {
  var start = lexer.token;

  var nameOrAlias = parseName(lexer);
  var alias = void 0;
  var name = void 0;
  if (skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].COLON)) {
    alias = nameOrAlias;
    name = parseName(lexer);
  } else {
    name = nameOrAlias;
  }

  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].FIELD,
    alias: alias,
    name: name,
    arguments: parseArguments(lexer, false),
    directives: parseDirectives(lexer, false),
    selectionSet: peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L) ? parseSelectionSet(lexer) : undefined,
    loc: loc(lexer, start)
  };
}

/**
 * Arguments[Const] : ( Argument[?Const]+ )
 */
function parseArguments(lexer, isConst) {
  var item = isConst ? parseConstArgument : parseArgument;
  return peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PAREN_L) ? many(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PAREN_L, item, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PAREN_R) : [];
}

/**
 * Argument[Const] : Name : Value[?Const]
 */
function parseArgument(lexer) {
  var start = lexer.token;
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].ARGUMENT,
    name: parseName(lexer),
    value: (expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].COLON), parseValueLiteral(lexer, false)),
    loc: loc(lexer, start)
  };
}

function parseConstArgument(lexer) {
  var start = lexer.token;
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].ARGUMENT,
    name: parseName(lexer),
    value: (expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].COLON), parseConstValue(lexer)),
    loc: loc(lexer, start)
  };
}

// Implements the parsing rules in the Fragments section.

/**
 * Corresponds to both FragmentSpread and InlineFragment in the spec.
 *
 * FragmentSpread : ... FragmentName Directives?
 *
 * InlineFragment : ... TypeCondition? Directives? SelectionSet
 */
function parseFragment(lexer) {
  var start = lexer.token;
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].SPREAD);
  if (peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].NAME) && lexer.token.value !== 'on') {
    return {
      kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].FRAGMENT_SPREAD,
      name: parseFragmentName(lexer),
      directives: parseDirectives(lexer, false),
      loc: loc(lexer, start)
    };
  }
  var typeCondition = void 0;
  if (lexer.token.value === 'on') {
    lexer.advance();
    typeCondition = parseNamedType(lexer);
  }
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].INLINE_FRAGMENT,
    typeCondition: typeCondition,
    directives: parseDirectives(lexer, false),
    selectionSet: parseSelectionSet(lexer),
    loc: loc(lexer, start)
  };
}

/**
 * FragmentDefinition :
 *   - fragment FragmentName on TypeCondition Directives? SelectionSet
 *
 * TypeCondition : NamedType
 */
function parseFragmentDefinition(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'fragment');
  // Experimental support for defining variables within fragments changes
  // the grammar of FragmentDefinition:
  //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
  if (lexer.options.experimentalFragmentVariables) {
    return {
      kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].FRAGMENT_DEFINITION,
      name: parseFragmentName(lexer),
      variableDefinitions: parseVariableDefinitions(lexer),
      typeCondition: (expectKeyword(lexer, 'on'), parseNamedType(lexer)),
      directives: parseDirectives(lexer, false),
      selectionSet: parseSelectionSet(lexer),
      loc: loc(lexer, start)
    };
  }
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].FRAGMENT_DEFINITION,
    name: parseFragmentName(lexer),
    typeCondition: (expectKeyword(lexer, 'on'), parseNamedType(lexer)),
    directives: parseDirectives(lexer, false),
    selectionSet: parseSelectionSet(lexer),
    loc: loc(lexer, start)
  };
}

/**
 * FragmentName : Name but not `on`
 */
function parseFragmentName(lexer) {
  if (lexer.token.value === 'on') {
    throw unexpected(lexer);
  }
  return parseName(lexer);
}

// Implements the parsing rules in the Values section.

/**
 * Value[Const] :
 *   - [~Const] Variable
 *   - IntValue
 *   - FloatValue
 *   - StringValue
 *   - BooleanValue
 *   - NullValue
 *   - EnumValue
 *   - ListValue[?Const]
 *   - ObjectValue[?Const]
 *
 * BooleanValue : one of `true` `false`
 *
 * NullValue : `null`
 *
 * EnumValue : Name but not `true`, `false` or `null`
 */
function parseValueLiteral(lexer, isConst) {
  var token = lexer.token;
  switch (token.kind) {
    case __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACKET_L:
      return parseList(lexer, isConst);
    case __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L:
      return parseObject(lexer, isConst);
    case __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].INT:
      lexer.advance();
      return {
        kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].INT,
        value: token.value,
        loc: loc(lexer, token)
      };
    case __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].FLOAT:
      lexer.advance();
      return {
        kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].FLOAT,
        value: token.value,
        loc: loc(lexer, token)
      };
    case __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].STRING:
    case __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BLOCK_STRING:
      return parseStringLiteral(lexer);
    case __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].NAME:
      if (token.value === 'true' || token.value === 'false') {
        lexer.advance();
        return {
          kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].BOOLEAN,
          value: token.value === 'true',
          loc: loc(lexer, token)
        };
      } else if (token.value === 'null') {
        lexer.advance();
        return {
          kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].NULL,
          loc: loc(lexer, token)
        };
      }
      lexer.advance();
      return {
        kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].ENUM,
        value: token.value,
        loc: loc(lexer, token)
      };
    case __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].DOLLAR:
      if (!isConst) {
        return parseVariable(lexer);
      }
      break;
  }
  throw unexpected(lexer);
}

function parseStringLiteral(lexer) {
  var token = lexer.token;
  lexer.advance();
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].STRING,
    value: token.value,
    block: token.kind === __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BLOCK_STRING,
    loc: loc(lexer, token)
  };
}

function parseConstValue(lexer) {
  return parseValueLiteral(lexer, true);
}

function parseValueValue(lexer) {
  return parseValueLiteral(lexer, false);
}

/**
 * ListValue[Const] :
 *   - [ ]
 *   - [ Value[?Const]+ ]
 */
function parseList(lexer, isConst) {
  var start = lexer.token;
  var item = isConst ? parseConstValue : parseValueValue;
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].LIST,
    values: any(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACKET_L, item, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACKET_R),
    loc: loc(lexer, start)
  };
}

/**
 * ObjectValue[Const] :
 *   - { }
 *   - { ObjectField[?Const]+ }
 */
function parseObject(lexer, isConst) {
  var start = lexer.token;
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L);
  var fields = [];
  while (!skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_R)) {
    fields.push(parseObjectField(lexer, isConst));
  }
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].OBJECT,
    fields: fields,
    loc: loc(lexer, start)
  };
}

/**
 * ObjectField[Const] : Name : Value[?Const]
 */
function parseObjectField(lexer, isConst) {
  var start = lexer.token;
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].OBJECT_FIELD,
    name: parseName(lexer),
    value: (expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].COLON), parseValueLiteral(lexer, isConst)),
    loc: loc(lexer, start)
  };
}

// Implements the parsing rules in the Directives section.

/**
 * Directives[Const] : Directive[?Const]+
 */
function parseDirectives(lexer, isConst) {
  var directives = [];
  while (peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].AT)) {
    directives.push(parseDirective(lexer, isConst));
  }
  return directives;
}

/**
 * Directive[Const] : @ Name Arguments[?Const]?
 */
function parseDirective(lexer, isConst) {
  var start = lexer.token;
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].AT);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].DIRECTIVE,
    name: parseName(lexer),
    arguments: parseArguments(lexer, isConst),
    loc: loc(lexer, start)
  };
}

// Implements the parsing rules in the Types section.

/**
 * Type :
 *   - NamedType
 *   - ListType
 *   - NonNullType
 */
function parseTypeReference(lexer) {
  var start = lexer.token;
  var type = void 0;
  if (skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACKET_L)) {
    type = parseTypeReference(lexer);
    expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACKET_R);
    type = {
      kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].LIST_TYPE,
      type: type,
      loc: loc(lexer, start)
    };
  } else {
    type = parseNamedType(lexer);
  }
  if (skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BANG)) {
    return {
      kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].NON_NULL_TYPE,
      type: type,
      loc: loc(lexer, start)
    };
  }
  return type;
}

/**
 * NamedType : Name
 */
function parseNamedType(lexer) {
  var start = lexer.token;
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].NAMED_TYPE,
    name: parseName(lexer),
    loc: loc(lexer, start)
  };
}

// Implements the parsing rules in the Type Definition section.

/**
 * TypeSystemDefinition :
 *   - SchemaDefinition
 *   - TypeDefinition
 *   - TypeExtension
 *   - DirectiveDefinition
 *
 * TypeDefinition :
 *   - ScalarTypeDefinition
 *   - ObjectTypeDefinition
 *   - InterfaceTypeDefinition
 *   - UnionTypeDefinition
 *   - EnumTypeDefinition
 *   - InputObjectTypeDefinition
 */
function parseTypeSystemDefinition(lexer) {
  // Many definitions begin with a description and require a lookahead.
  var keywordToken = peekDescription(lexer) ? lexer.lookahead() : lexer.token;

  if (keywordToken.kind === __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].NAME) {
    switch (keywordToken.value) {
      case 'schema':
        return parseSchemaDefinition(lexer);
      case 'scalar':
        return parseScalarTypeDefinition(lexer);
      case 'type':
        return parseObjectTypeDefinition(lexer);
      case 'interface':
        return parseInterfaceTypeDefinition(lexer);
      case 'union':
        return parseUnionTypeDefinition(lexer);
      case 'enum':
        return parseEnumTypeDefinition(lexer);
      case 'input':
        return parseInputObjectTypeDefinition(lexer);
      case 'extend':
        return parseTypeExtension(lexer);
      case 'directive':
        return parseDirectiveDefinition(lexer);
    }
  }

  throw unexpected(lexer, keywordToken);
}

function peekDescription(lexer) {
  return peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].STRING) || peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BLOCK_STRING);
}

/**
 * Description : StringValue
 */
function parseDescription(lexer) {
  if (peekDescription(lexer)) {
    return parseStringLiteral(lexer);
  }
}

/**
 * SchemaDefinition : schema Directives[Const]? { OperationTypeDefinition+ }
 */
function parseSchemaDefinition(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'schema');
  var directives = parseDirectives(lexer, true);
  var operationTypes = many(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L, parseOperationTypeDefinition, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_R);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].SCHEMA_DEFINITION,
    directives: directives,
    operationTypes: operationTypes,
    loc: loc(lexer, start)
  };
}

/**
 * OperationTypeDefinition : OperationType : NamedType
 */
function parseOperationTypeDefinition(lexer) {
  var start = lexer.token;
  var operation = parseOperationType(lexer);
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].COLON);
  var type = parseNamedType(lexer);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].OPERATION_TYPE_DEFINITION,
    operation: operation,
    type: type,
    loc: loc(lexer, start)
  };
}

/**
 * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
 */
function parseScalarTypeDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'scalar');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].SCALAR_TYPE_DEFINITION,
    description: description,
    name: name,
    directives: directives,
    loc: loc(lexer, start)
  };
}

/**
 * ObjectTypeDefinition :
 *   Description?
 *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
 */
function parseObjectTypeDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'type');
  var name = parseName(lexer);
  var interfaces = parseImplementsInterfaces(lexer);
  var directives = parseDirectives(lexer, true);
  var fields = parseFieldsDefinition(lexer);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].OBJECT_TYPE_DEFINITION,
    description: description,
    name: name,
    interfaces: interfaces,
    directives: directives,
    fields: fields,
    loc: loc(lexer, start)
  };
}

/**
 * ImplementsInterfaces :
 *   - implements `&`? NamedType
 *   - ImplementsInterfaces & NamedType
 */
function parseImplementsInterfaces(lexer) {
  var types = [];
  if (lexer.token.value === 'implements') {
    lexer.advance();
    // Optional leading ampersand
    skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].AMP);
    do {
      types.push(parseNamedType(lexer));
    } while (skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].AMP) ||
    // Legacy support for the SDL?
    lexer.options.allowLegacySDLImplementsInterfaces && peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].NAME));
  }
  return types;
}

/**
 * FieldsDefinition : { FieldDefinition+ }
 */
function parseFieldsDefinition(lexer) {
  // Legacy support for the SDL?
  if (lexer.options.allowLegacySDLEmptyFields && peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L) && lexer.lookahead().kind === __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_R) {
    lexer.advance();
    lexer.advance();
    return [];
  }
  return peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L) ? many(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L, parseFieldDefinition, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_R) : [];
}

/**
 * FieldDefinition :
 *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
 */
function parseFieldDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  var name = parseName(lexer);
  var args = parseArgumentDefs(lexer);
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].COLON);
  var type = parseTypeReference(lexer);
  var directives = parseDirectives(lexer, true);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].FIELD_DEFINITION,
    description: description,
    name: name,
    arguments: args,
    type: type,
    directives: directives,
    loc: loc(lexer, start)
  };
}

/**
 * ArgumentsDefinition : ( InputValueDefinition+ )
 */
function parseArgumentDefs(lexer) {
  if (!peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PAREN_L)) {
    return [];
  }
  return many(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PAREN_L, parseInputValueDef, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PAREN_R);
}

/**
 * InputValueDefinition :
 *   - Description? Name : Type DefaultValue? Directives[Const]?
 */
function parseInputValueDef(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  var name = parseName(lexer);
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].COLON);
  var type = parseTypeReference(lexer);
  var defaultValue = void 0;
  if (skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].EQUALS)) {
    defaultValue = parseConstValue(lexer);
  }
  var directives = parseDirectives(lexer, true);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].INPUT_VALUE_DEFINITION,
    description: description,
    name: name,
    type: type,
    defaultValue: defaultValue,
    directives: directives,
    loc: loc(lexer, start)
  };
}

/**
 * InterfaceTypeDefinition :
 *   - Description? interface Name Directives[Const]? FieldsDefinition?
 */
function parseInterfaceTypeDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'interface');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var fields = parseFieldsDefinition(lexer);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].INTERFACE_TYPE_DEFINITION,
    description: description,
    name: name,
    directives: directives,
    fields: fields,
    loc: loc(lexer, start)
  };
}

/**
 * UnionTypeDefinition :
 *   - Description? union Name Directives[Const]? UnionMemberTypes?
 */
function parseUnionTypeDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'union');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var types = parseUnionMemberTypes(lexer);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].UNION_TYPE_DEFINITION,
    description: description,
    name: name,
    directives: directives,
    types: types,
    loc: loc(lexer, start)
  };
}

/**
 * UnionMemberTypes :
 *   - = `|`? NamedType
 *   - UnionMemberTypes | NamedType
 */
function parseUnionMemberTypes(lexer) {
  var types = [];
  if (skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].EQUALS)) {
    // Optional leading pipe
    skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PIPE);
    do {
      types.push(parseNamedType(lexer));
    } while (skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PIPE));
  }
  return types;
}

/**
 * EnumTypeDefinition :
 *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
 */
function parseEnumTypeDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'enum');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var values = parseEnumValuesDefinition(lexer);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].ENUM_TYPE_DEFINITION,
    description: description,
    name: name,
    directives: directives,
    values: values,
    loc: loc(lexer, start)
  };
}

/**
 * EnumValuesDefinition : { EnumValueDefinition+ }
 */
function parseEnumValuesDefinition(lexer) {
  return peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L) ? many(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L, parseEnumValueDefinition, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_R) : [];
}

/**
 * EnumValueDefinition : Description? EnumValue Directives[Const]?
 *
 * EnumValue : Name
 */
function parseEnumValueDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].ENUM_VALUE_DEFINITION,
    description: description,
    name: name,
    directives: directives,
    loc: loc(lexer, start)
  };
}

/**
 * InputObjectTypeDefinition :
 *   - Description? input Name Directives[Const]? InputFieldsDefinition?
 */
function parseInputObjectTypeDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'input');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var fields = parseInputFieldsDefinition(lexer);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].INPUT_OBJECT_TYPE_DEFINITION,
    description: description,
    name: name,
    directives: directives,
    fields: fields,
    loc: loc(lexer, start)
  };
}

/**
 * InputFieldsDefinition : { InputValueDefinition+ }
 */
function parseInputFieldsDefinition(lexer) {
  return peek(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L) ? many(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_L, parseInputValueDef, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].BRACE_R) : [];
}

/**
 * TypeExtension :
 *   - ScalarTypeExtension
 *   - ObjectTypeExtension
 *   - InterfaceTypeExtension
 *   - UnionTypeExtension
 *   - EnumTypeExtension
 *   - InputObjectTypeDefinition
 */
function parseTypeExtension(lexer) {
  var keywordToken = lexer.lookahead();

  if (keywordToken.kind === __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].NAME) {
    switch (keywordToken.value) {
      case 'scalar':
        return parseScalarTypeExtension(lexer);
      case 'type':
        return parseObjectTypeExtension(lexer);
      case 'interface':
        return parseInterfaceTypeExtension(lexer);
      case 'union':
        return parseUnionTypeExtension(lexer);
      case 'enum':
        return parseEnumTypeExtension(lexer);
      case 'input':
        return parseInputObjectTypeExtension(lexer);
    }
  }

  throw unexpected(lexer, keywordToken);
}

/**
 * ScalarTypeExtension :
 *   - extend scalar Name Directives[Const]
 */
function parseScalarTypeExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'scalar');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  if (directives.length === 0) {
    throw unexpected(lexer);
  }
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].SCALAR_TYPE_EXTENSION,
    name: name,
    directives: directives,
    loc: loc(lexer, start)
  };
}

/**
 * ObjectTypeExtension :
 *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
 *  - extend type Name ImplementsInterfaces? Directives[Const]
 *  - extend type Name ImplementsInterfaces
 */
function parseObjectTypeExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'type');
  var name = parseName(lexer);
  var interfaces = parseImplementsInterfaces(lexer);
  var directives = parseDirectives(lexer, true);
  var fields = parseFieldsDefinition(lexer);
  if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) {
    throw unexpected(lexer);
  }
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].OBJECT_TYPE_EXTENSION,
    name: name,
    interfaces: interfaces,
    directives: directives,
    fields: fields,
    loc: loc(lexer, start)
  };
}

/**
 * InterfaceTypeExtension :
 *   - extend interface Name Directives[Const]? FieldsDefinition
 *   - extend interface Name Directives[Const]
 */
function parseInterfaceTypeExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'interface');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var fields = parseFieldsDefinition(lexer);
  if (directives.length === 0 && fields.length === 0) {
    throw unexpected(lexer);
  }
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].INTERFACE_TYPE_EXTENSION,
    name: name,
    directives: directives,
    fields: fields,
    loc: loc(lexer, start)
  };
}

/**
 * UnionTypeExtension :
 *   - extend union Name Directives[Const]? UnionMemberTypes
 *   - extend union Name Directives[Const]
 */
function parseUnionTypeExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'union');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var types = parseUnionMemberTypes(lexer);
  if (directives.length === 0 && types.length === 0) {
    throw unexpected(lexer);
  }
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].UNION_TYPE_EXTENSION,
    name: name,
    directives: directives,
    types: types,
    loc: loc(lexer, start)
  };
}

/**
 * EnumTypeExtension :
 *   - extend enum Name Directives[Const]? EnumValuesDefinition
 *   - extend enum Name Directives[Const]
 */
function parseEnumTypeExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'enum');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var values = parseEnumValuesDefinition(lexer);
  if (directives.length === 0 && values.length === 0) {
    throw unexpected(lexer);
  }
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].ENUM_TYPE_EXTENSION,
    name: name,
    directives: directives,
    values: values,
    loc: loc(lexer, start)
  };
}

/**
 * InputObjectTypeExtension :
 *   - extend input Name Directives[Const]? InputFieldsDefinition
 *   - extend input Name Directives[Const]
 */
function parseInputObjectTypeExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'input');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var fields = parseInputFieldsDefinition(lexer);
  if (directives.length === 0 && fields.length === 0) {
    throw unexpected(lexer);
  }
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].INPUT_OBJECT_TYPE_EXTENSION,
    name: name,
    directives: directives,
    fields: fields,
    loc: loc(lexer, start)
  };
}

/**
 * DirectiveDefinition :
 *   - Description? directive @ Name ArgumentsDefinition? on DirectiveLocations
 */
function parseDirectiveDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'directive');
  expect(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].AT);
  var name = parseName(lexer);
  var args = parseArgumentDefs(lexer);
  expectKeyword(lexer, 'on');
  var locations = parseDirectiveLocations(lexer);
  return {
    kind: __WEBPACK_IMPORTED_MODULE_3__kinds__["a" /* Kind */].DIRECTIVE_DEFINITION,
    description: description,
    name: name,
    arguments: args,
    locations: locations,
    loc: loc(lexer, start)
  };
}

/**
 * DirectiveLocations :
 *   - `|`? DirectiveLocation
 *   - DirectiveLocations | DirectiveLocation
 */
function parseDirectiveLocations(lexer) {
  // Optional leading pipe
  skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PIPE);
  var locations = [];
  do {
    locations.push(parseDirectiveLocation(lexer));
  } while (skip(lexer, __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].PIPE));
  return locations;
}

/*
 * DirectiveLocation :
 *   - ExecutableDirectiveLocation
 *   - TypeSystemDirectiveLocation
 *
 * ExecutableDirectiveLocation : one of
 *   `QUERY`
 *   `MUTATION`
 *   `SUBSCRIPTION`
 *   `FIELD`
 *   `FRAGMENT_DEFINITION`
 *   `FRAGMENT_SPREAD`
 *   `INLINE_FRAGMENT`
 *
 * TypeSystemDirectiveLocation : one of
 *   `SCHEMA`
 *   `SCALAR`
 *   `OBJECT`
 *   `FIELD_DEFINITION`
 *   `ARGUMENT_DEFINITION`
 *   `INTERFACE`
 *   `UNION`
 *   `ENUM`
 *   `ENUM_VALUE`
 *   `INPUT_OBJECT`
 *   `INPUT_FIELD_DEFINITION`
 */
function parseDirectiveLocation(lexer) {
  var start = lexer.token;
  var name = parseName(lexer);
  if (__WEBPACK_IMPORTED_MODULE_4__directiveLocation__["a" /* DirectiveLocation */].hasOwnProperty(name.value)) {
    return name;
  }
  throw unexpected(lexer, start);
}

// Core parsing utility functions

/**
 * Returns a location object, used to identify the place in
 * the source that created a given parsed object.
 */
function loc(lexer, startToken) {
  if (!lexer.options.noLocation) {
    return new Loc(startToken, lexer.lastToken, lexer.source);
  }
}

function Loc(startToken, endToken, source) {
  this.start = startToken.start;
  this.end = endToken.end;
  this.startToken = startToken;
  this.endToken = endToken;
  this.source = source;
}

// Print a simplified form when appearing in JSON/util.inspect.
Loc.prototype.toJSON = Loc.prototype.inspect = function toJSON() {
  return { start: this.start, end: this.end };
};

/**
 * Determines if the next token is of a given kind
 */
function peek(lexer, kind) {
  return lexer.token.kind === kind;
}

/**
 * If the next token is of the given kind, return true after advancing
 * the lexer. Otherwise, do not change the parser state and return false.
 */
function skip(lexer, kind) {
  var match = lexer.token.kind === kind;
  if (match) {
    lexer.advance();
  }
  return match;
}

/**
 * If the next token is of the given kind, return that token after advancing
 * the lexer. Otherwise, do not change the parser state and throw an error.
 */
function expect(lexer, kind) {
  var token = lexer.token;
  if (token.kind === kind) {
    lexer.advance();
    return token;
  }
  throw Object(__WEBPACK_IMPORTED_MODULE_1__error__["c" /* syntaxError */])(lexer.source, token.start, 'Expected ' + kind + ', found ' + Object(__WEBPACK_IMPORTED_MODULE_2__lexer__["c" /* getTokenDesc */])(token));
}

/**
 * If the next token is a keyword with the given value, return that token after
 * advancing the lexer. Otherwise, do not change the parser state and return
 * false.
 */
function expectKeyword(lexer, value) {
  var token = lexer.token;
  if (token.kind === __WEBPACK_IMPORTED_MODULE_2__lexer__["a" /* TokenKind */].NAME && token.value === value) {
    lexer.advance();
    return token;
  }
  throw Object(__WEBPACK_IMPORTED_MODULE_1__error__["c" /* syntaxError */])(lexer.source, token.start, 'Expected "' + value + '", found ' + Object(__WEBPACK_IMPORTED_MODULE_2__lexer__["c" /* getTokenDesc */])(token));
}

/**
 * Helper function for creating an error when an unexpected lexed token
 * is encountered.
 */
function unexpected(lexer, atToken) {
  var token = atToken || lexer.token;
  return Object(__WEBPACK_IMPORTED_MODULE_1__error__["c" /* syntaxError */])(lexer.source, token.start, 'Unexpected ' + Object(__WEBPACK_IMPORTED_MODULE_2__lexer__["c" /* getTokenDesc */])(token));
}

/**
 * Returns a possibly empty list of parse nodes, determined by
 * the parseFn. This list begins with a lex token of openKind
 * and ends with a lex token of closeKind. Advances the parser
 * to the next lex token after the closing token.
 */
function any(lexer, openKind, parseFn, closeKind) {
  expect(lexer, openKind);
  var nodes = [];
  while (!skip(lexer, closeKind)) {
    nodes.push(parseFn(lexer));
  }
  return nodes;
}

/**
 * Returns a non-empty list of parse nodes, determined by
 * the parseFn. This list begins with a lex token of openKind
 * and ends with a lex token of closeKind. Advances the parser
 * to the next lex token after the closing token.
 */
function many(lexer, openKind, parseFn, closeKind) {
  expect(lexer, openKind);
  var nodes = [parseFn(lexer)];
  while (!skip(lexer, closeKind)) {
    nodes.push(parseFn(lexer));
  }
  return nodes;
}

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TypeInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__language_kinds__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type_definition__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type_introspection__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__typeFromAST__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jsutils_find__ = __webpack_require__(139);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */









/**
 * TypeInfo is a utility class which, given a GraphQL schema, can keep track
 * of the current field and type definitions at any point in a GraphQL document
 * AST during a recursive descent by calling `enter(node)` and `leave(node)`.
 */
var TypeInfo = function () {
  function TypeInfo(schema,
  // NOTE: this experimental optional second parameter is only needed in order
  // to support non-spec-compliant codebases. You should never need to use it.
  getFieldDefFn,
  // Initial type may be provided in rare cases to facilitate traversals
  initialType) {
    _classCallCheck(this, TypeInfo);

    this._schema = schema;
    this._typeStack = [];
    this._parentTypeStack = [];
    this._inputTypeStack = [];
    this._fieldDefStack = [];
    this._directive = null;
    this._argument = null;
    this._enumValue = null;
    this._getFieldDef = getFieldDefFn || getFieldDef;
    if (initialType) {
      if (Object(__WEBPACK_IMPORTED_MODULE_1__type_definition__["r" /* isInputType */])(initialType)) {
        this._inputTypeStack.push(initialType);
      }
      if (Object(__WEBPACK_IMPORTED_MODULE_1__type_definition__["o" /* isCompositeType */])(initialType)) {
        this._parentTypeStack.push(initialType);
      }
      if (Object(__WEBPACK_IMPORTED_MODULE_1__type_definition__["y" /* isOutputType */])(initialType)) {
        this._typeStack.push(initialType);
      }
    }
  }

  TypeInfo.prototype.getType = function getType() {
    if (this._typeStack.length > 0) {
      return this._typeStack[this._typeStack.length - 1];
    }
  };

  TypeInfo.prototype.getParentType = function getParentType() {
    if (this._parentTypeStack.length > 0) {
      return this._parentTypeStack[this._parentTypeStack.length - 1];
    }
  };

  TypeInfo.prototype.getInputType = function getInputType() {
    if (this._inputTypeStack.length > 0) {
      return this._inputTypeStack[this._inputTypeStack.length - 1];
    }
  };

  TypeInfo.prototype.getParentInputType = function getParentInputType() {
    if (this._inputTypeStack.length > 1) {
      return this._inputTypeStack[this._inputTypeStack.length - 2];
    }
  };

  TypeInfo.prototype.getFieldDef = function getFieldDef() {
    if (this._fieldDefStack.length > 0) {
      return this._fieldDefStack[this._fieldDefStack.length - 1];
    }
  };

  TypeInfo.prototype.getDirective = function getDirective() {
    return this._directive;
  };

  TypeInfo.prototype.getArgument = function getArgument() {
    return this._argument;
  };

  TypeInfo.prototype.getEnumValue = function getEnumValue() {
    return this._enumValue;
  };

  // Flow does not yet handle this case.


  TypeInfo.prototype.enter = function enter(node /* ASTNode */) {
    var schema = this._schema;
    // Note: many of the types below are explicitly typed as "mixed" to drop
    // any assumptions of a valid schema to ensure runtime types are properly
    // checked before continuing since TypeInfo is used as part of validation
    // which occurs before guarantees of schema and document validity.
    switch (node.kind) {
      case __WEBPACK_IMPORTED_MODULE_0__language_kinds__["a" /* Kind */].SELECTION_SET:
        var namedType = Object(__WEBPACK_IMPORTED_MODULE_1__type_definition__["l" /* getNamedType */])(this.getType());
        this._parentTypeStack.push(Object(__WEBPACK_IMPORTED_MODULE_1__type_definition__["o" /* isCompositeType */])(namedType) ? namedType : undefined);
        break;
      case __WEBPACK_IMPORTED_MODULE_0__language_kinds__["a" /* Kind */].FIELD:
        var parentType = this.getParentType();
        var fieldDef = void 0;
        var fieldType = void 0;
        if (parentType) {
          fieldDef = this._getFieldDef(schema, parentType, node);
          if (fieldDef) {
            fieldType = fieldDef.type;
          }
        }
        this._fieldDefStack.push(fieldDef);
        this._typeStack.push(Object(__WEBPACK_IMPORTED_MODULE_1__type_definition__["y" /* isOutputType */])(fieldType) ? fieldType : undefined);
        break;
      case __WEBPACK_IMPORTED_MODULE_0__language_kinds__["a" /* Kind */].DIRECTIVE:
        this._directive = schema.getDirective(node.name.value);
        break;
      case __WEBPACK_IMPORTED_MODULE_0__language_kinds__["a" /* Kind */].OPERATION_DEFINITION:
        var type = void 0;
        if (node.operation === 'query') {
          type = schema.getQueryType();
        } else if (node.operation === 'mutation') {
          type = schema.getMutationType();
        } else if (node.operation === 'subscription') {
          type = schema.getSubscriptionType();
        }
        this._typeStack.push(Object(__WEBPACK_IMPORTED_MODULE_1__type_definition__["x" /* isObjectType */])(type) ? type : undefined);
        break;
      case __WEBPACK_IMPORTED_MODULE_0__language_kinds__["a" /* Kind */].INLINE_FRAGMENT:
      case __WEBPACK_IMPORTED_MODULE_0__language_kinds__["a" /* Kind */].FRAGMENT_DEFINITION:
        var typeConditionAST = node.typeCondition;
        var outputType = typeConditionAST ? Object(__WEBPACK_IMPORTED_MODULE_3__typeFromAST__["a" /* typeFromAST */])(schema, typeConditionAST) : Object(__WEBPACK_IMPORTED_MODULE_1__type_definition__["l" /* getNamedType */])(this.getType());
        this._typeStack.push(Object(__WEBPACK_IMPORTED_MODULE_1__type_definition__["y" /* isOutputType */])(outputType) ? outputType : undefined);
        break;
      case __WEBPACK_IMPORTED_MODULE_0__language_kinds__["a" /* Kind */].VARIABLE_DEFINITION:
        var inputType = Object(__WEBPACK_IMPORTED_MODULE_3__typeFromAST__["a" /* typeFromAST */])(schema, node.type);
        this._inputTypeStack.push(Object(__WEBPACK_IMPORTED_MODULE_1__type_definition__["r" /* isInputType */])(inputType) ? inputType : undefined);
        break;
      case __WEBPACK_IMPORTED_MODULE_0__language_kinds__["a" /* Kind */].ARGUMENT:
        var argDef = void 0;
        var argType = void 0;
        var fieldOrDirective = this.getDirective() || this.getFieldDef();
        if (fieldOrDirective) {
          argDef = Object(__WEBPACK_IMPORTED_MODULE_4__jsutils_find__["a" /* default */])(fieldOrDirective.args, function (arg) {
            return arg.name === node.name.value;
          });
          if (argDef) {
            argType = argDef.type;
          }
        }
        this._argument = argDef;
        this._inputTypeStack.push(Object(__WEBPACK_IMPORTED_MODULE_1__type_definition__["r" /* isInputType */])(argType) ? argType : undefined);
        break;
      case __WEBPACK_IMPORTED_MODULE_0__language_kinds__["a" /* Kind */].LIST:
        var listType = Object(__WEBPACK_IMPORTED_MODULE_1__type_definition__["m" /* getNullableType */])(this.getInputType());
        var itemType = Object(__WEBPACK_IMPORTED_MODULE_1__type_definition__["u" /* isListType */])(listType) ? listType.ofType : listType;
        this._inputTypeStack.push(Object(__WEBPACK_IMPORTED_MODULE_1__type_definition__["r" /* isInputType */])(itemType) ? itemType : undefined);
        break;
      case __WEBPACK_IMPORTED_MODULE_0__language_kinds__["a" /* Kind */].OBJECT_FIELD:
        var objectType = Object(__WEBPACK_IMPORTED_MODULE_1__type_definition__["l" /* getNamedType */])(this.getInputType());
        var inputFieldType = void 0;
        if (Object(__WEBPACK_IMPORTED_MODULE_1__type_definition__["q" /* isInputObjectType */])(objectType)) {
          var inputField = objectType.getFields()[node.name.value];
          if (inputField) {
            inputFieldType = inputField.type;
          }
        }
        this._inputTypeStack.push(Object(__WEBPACK_IMPORTED_MODULE_1__type_definition__["r" /* isInputType */])(inputFieldType) ? inputFieldType : undefined);
        break;
      case __WEBPACK_IMPORTED_MODULE_0__language_kinds__["a" /* Kind */].ENUM:
        var enumType = Object(__WEBPACK_IMPORTED_MODULE_1__type_definition__["l" /* getNamedType */])(this.getInputType());
        var enumValue = void 0;
        if (Object(__WEBPACK_IMPORTED_MODULE_1__type_definition__["p" /* isEnumType */])(enumType)) {
          enumValue = enumType.getValue(node.value);
        }
        this._enumValue = enumValue;
        break;
    }
  };

  TypeInfo.prototype.leave = function leave(node) {
    switch (node.kind) {
      case __WEBPACK_IMPORTED_MODULE_0__language_kinds__["a" /* Kind */].SELECTION_SET:
        this._parentTypeStack.pop();
        break;
      case __WEBPACK_IMPORTED_MODULE_0__language_kinds__["a" /* Kind */].FIELD:
        this._fieldDefStack.pop();
        this._typeStack.pop();
        break;
      case __WEBPACK_IMPORTED_MODULE_0__language_kinds__["a" /* Kind */].DIRECTIVE:
        this._directive = null;
        break;
      case __WEBPACK_IMPORTED_MODULE_0__language_kinds__["a" /* Kind */].OPERATION_DEFINITION:
      case __WEBPACK_IMPORTED_MODULE_0__language_kinds__["a" /* Kind */].INLINE_FRAGMENT:
      case __WEBPACK_IMPORTED_MODULE_0__language_kinds__["a" /* Kind */].FRAGMENT_DEFINITION:
        this._typeStack.pop();
        break;
      case __WEBPACK_IMPORTED_MODULE_0__language_kinds__["a" /* Kind */].VARIABLE_DEFINITION:
        this._inputTypeStack.pop();
        break;
      case __WEBPACK_IMPORTED_MODULE_0__language_kinds__["a" /* Kind */].ARGUMENT:
        this._argument = null;
        this._inputTypeStack.pop();
        break;
      case __WEBPACK_IMPORTED_MODULE_0__language_kinds__["a" /* Kind */].LIST:
      case __WEBPACK_IMPORTED_MODULE_0__language_kinds__["a" /* Kind */].OBJECT_FIELD:
        this._inputTypeStack.pop();
        break;
      case __WEBPACK_IMPORTED_MODULE_0__language_kinds__["a" /* Kind */].ENUM:
        this._enumValue = null;
        break;
    }
  };

  return TypeInfo;
}();

/**
 * Not exactly the same as the executor's definition of getFieldDef, in this
 * statically evaluated environment we do not always have an Object type,
 * and need to handle Interface and Union types.
 */
function getFieldDef(schema, parentType, fieldNode) {
  var name = fieldNode.name.value;
  if (name === __WEBPACK_IMPORTED_MODULE_2__type_introspection__["a" /* SchemaMetaFieldDef */].name && schema.getQueryType() === parentType) {
    return __WEBPACK_IMPORTED_MODULE_2__type_introspection__["a" /* SchemaMetaFieldDef */];
  }
  if (name === __WEBPACK_IMPORTED_MODULE_2__type_introspection__["c" /* TypeMetaFieldDef */].name && schema.getQueryType() === parentType) {
    return __WEBPACK_IMPORTED_MODULE_2__type_introspection__["c" /* TypeMetaFieldDef */];
  }
  if (name === __WEBPACK_IMPORTED_MODULE_2__type_introspection__["d" /* TypeNameMetaFieldDef */].name && Object(__WEBPACK_IMPORTED_MODULE_1__type_definition__["o" /* isCompositeType */])(parentType)) {
    return __WEBPACK_IMPORTED_MODULE_2__type_introspection__["d" /* TypeNameMetaFieldDef */];
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_1__type_definition__["x" /* isObjectType */])(parentType) || Object(__WEBPACK_IMPORTED_MODULE_1__type_definition__["s" /* isInterfaceType */])(parentType)) {
    return parentType.getFields()[name];
  }
}

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = suggestionList;
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Given an invalid input string and a list of valid options, returns a filtered
 * list of valid options sorted based on their similarity with the input.
 */
function suggestionList(input, options) {
  var optionsByDistance = Object.create(null);
  var oLength = options.length;
  var inputThreshold = input.length / 2;
  for (var i = 0; i < oLength; i++) {
    var distance = lexicalDistance(input, options[i]);
    var threshold = Math.max(inputThreshold, options[i].length / 2, 1);
    if (distance <= threshold) {
      optionsByDistance[options[i]] = distance;
    }
  }
  return Object.keys(optionsByDistance).sort(function (a, b) {
    return optionsByDistance[a] - optionsByDistance[b];
  });
}

/**
 * Computes the lexical distance between strings A and B.
 *
 * The "distance" between two strings is given by counting the minimum number
 * of edits needed to transform string A into string B. An edit can be an
 * insertion, deletion, or substitution of a single character, or a swap of two
 * adjacent characters.
 *
 * Includes a custom alteration from Damerau-Levenshtein to treat case changes
 * as a single edit which helps identify mis-cased values with an edit distance
 * of 1.
 *
 * This distance can be useful for detecting typos in input or sorting
 *
 * @param {string} a
 * @param {string} b
 * @return {int} distance in number of edits
 */
function lexicalDistance(aStr, bStr) {
  if (aStr === bStr) {
    return 0;
  }

  var i = void 0;
  var j = void 0;
  var d = [];
  var a = aStr.toLowerCase();
  var b = bStr.toLowerCase();
  var aLength = a.length;
  var bLength = b.length;

  // Any case change counts as a single edit
  if (a === b) {
    return 1;
  }

  for (i = 0; i <= aLength; i++) {
    d[i] = [i];
  }

  for (j = 1; j <= bLength; j++) {
    d[0][j] = j;
  }

  for (i = 1; i <= aLength; i++) {
    for (j = 1; j <= bLength; j++) {
      var cost = a[i - 1] === b[j - 1] ? 0 : 1;

      d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + cost);

      if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) {
        d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + cost);
      }
    }
  }

  return d[aLength][bLength];
}

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addTypenameToDocument; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return argumentsObjectFromField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return buildQueryFromSelectionSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return canUseWeakMap; });
/* unused harmony export checkDocument */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return cloneDeep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return createFragmentMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getDefaultValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getDirectiveInfoFromField; });
/* unused harmony export getDirectiveNames */
/* unused harmony export getDirectivesFromDocument */
/* unused harmony export getEnv */
/* unused harmony export getFragmentDefinition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getFragmentDefinitions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getFragmentQueryDocument; });
/* unused harmony export getInclusionDirectives */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getMainDefinition; });
/* unused harmony export getMutationDefinition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getOperationDefinition; });
/* unused harmony export getOperationDefinitionOrDie */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getOperationName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getQueryDefinition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getStoreKeyName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return graphQLResultHasError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return hasClientExports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return hasDirectives; });
/* unused harmony export isDevelopment */
/* unused harmony export isEnv */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return isField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return isIdValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return isInlineFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return isJsonValue; });
/* unused harmony export isNumberValue */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return isProduction; });
/* unused harmony export isScalarValue */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return isTest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return maybeDeepFreeze; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return mergeDeep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return mergeDeepArray; });
/* unused harmony export removeArgumentsFromDocument */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return removeClientSetsFromDocument; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return removeConnectionDirectiveFromDocument; });
/* unused harmony export removeDirectivesFromDocument */
/* unused harmony export removeFragmentSpreadFromDocument */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return resultKeyNameFromField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return shouldInclude; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return storeKeyNameFromField; });
/* unused harmony export stripSymbols */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return toIdValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return tryFunctionOrLogError; });
/* unused harmony export valueFromNode */
/* unused harmony export valueToObjectRepresentation */
/* unused harmony export variablesInOperation */
/* unused harmony export warnOnceInDevelopment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_language_visitor__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ts_invariant__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tslib__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fast_json_stable_stringify__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fast_json_stable_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_fast_json_stable_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__wry_equality__ = __webpack_require__(707);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_4__wry_equality__["a"]; });






function isScalarValue(value) {
    return ['StringValue', 'BooleanValue', 'EnumValue'].indexOf(value.kind) > -1;
}
function isNumberValue(value) {
    return ['IntValue', 'FloatValue'].indexOf(value.kind) > -1;
}
function isStringValue(value) {
    return value.kind === 'StringValue';
}
function isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function isIntValue(value) {
    return value.kind === 'IntValue';
}
function isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function isVariable(value) {
    return value.kind === 'Variable';
}
function isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function isListValue(value) {
    return value.kind === 'ListValue';
}
function isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function isNullValue(value) {
    return value.kind === 'NullValue';
}
function valueToObjectRepresentation(argObj, name, value, variables) {
    if (isIntValue(value) || isFloatValue(value)) {
        argObj[name.value] = Number(value.value);
    }
    else if (isBooleanValue(value) || isStringValue(value)) {
        argObj[name.value] = value.value;
    }
    else if (isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function (obj) {
            return valueToObjectRepresentation(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    }
    else if (isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    }
    else if (isListValue(value)) {
        argObj[name.value] = value.values.map(function (listValue) {
            var nestedArgArrayObj = {};
            valueToObjectRepresentation(nestedArgArrayObj, name, listValue, variables);
            return nestedArgArrayObj[name.value];
        });
    }
    else if (isEnumValue(value)) {
        argObj[name.value] = value.value;
    }
    else if (isNullValue(value)) {
        argObj[name.value] = null;
    }
    else {
        throw  true ? new __WEBPACK_IMPORTED_MODULE_1_ts_invariant__["a" /* InvariantError */](17) : new InvariantError("The inline argument \"" + name.value + "\" of kind \"" + value.kind + "\"" +
            'is not supported. Use variables instead of inline arguments to ' +
            'overcome this limitation.');
    }
}
function storeKeyNameFromField(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function (directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) {
                directive.arguments.forEach(function (_a) {
                    var name = _a.name, value = _a.value;
                    return valueToObjectRepresentation(directivesObj[directive.name.value], name, value, variables);
                });
            }
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj, name, value, variables);
        });
    }
    return getStoreKeyName(field.name.value, argObj, directivesObj);
}
var KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export',
];
function getStoreKeyName(fieldName, args, directives) {
    if (directives &&
        directives['connection'] &&
        directives['connection']['key']) {
        if (directives['connection']['filter'] &&
            directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter']
                ? directives['connection']['filter']
                : [];
            filterKeys.sort();
            var queryArgs_1 = args;
            var filteredArgs_1 = {};
            filterKeys.forEach(function (key) {
                filteredArgs_1[key] = queryArgs_1[key];
            });
            return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
        }
        else {
            return directives['connection']['key'];
        }
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = __WEBPACK_IMPORTED_MODULE_3_fast_json_stable_stringify___default()(args);
        completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) {
        Object.keys(directives).forEach(function (key) {
            if (KNOWN_DIRECTIVES.indexOf(key) !== -1)
                return;
            if (directives[key] && Object.keys(directives[key]).length) {
                completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
            }
            else {
                completeFieldName += "@" + key;
            }
        });
    }
    return completeFieldName;
}
function argumentsObjectFromField(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function resultKeyNameFromField(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function isField(selection) {
    return selection.kind === 'Field';
}
function isInlineFragment(selection) {
    return selection.kind === 'InlineFragment';
}
function isIdValue(idObject) {
    return idObject &&
        idObject.type === 'id' &&
        typeof idObject.generated === 'boolean';
}
function toIdValue(idConfig, generated) {
    if (generated === void 0) { generated = false; }
    return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["a" /* __assign */])({ type: 'id', generated: generated }, (typeof idConfig === 'string'
        ? { id: idConfig, typename: undefined }
        : idConfig));
}
function isJsonValue(jsonObject) {
    return (jsonObject != null &&
        typeof jsonObject === 'object' &&
        jsonObject.type === 'json');
}
function defaultValueFromVariable(node) {
    throw  true ? new __WEBPACK_IMPORTED_MODULE_1_ts_invariant__["a" /* InvariantError */](18) : new InvariantError("Variable nodes are not supported by valueFromNode");
}
function valueFromNode(node, onVariable) {
    if (onVariable === void 0) { onVariable = defaultValueFromVariable; }
    switch (node.kind) {
        case 'Variable':
            return onVariable(node);
        case 'NullValue':
            return null;
        case 'IntValue':
            return parseInt(node.value, 10);
        case 'FloatValue':
            return parseFloat(node.value);
        case 'ListValue':
            return node.values.map(function (v) { return valueFromNode(v, onVariable); });
        case 'ObjectValue': {
            var value = {};
            for (var _i = 0, _a = node.fields; _i < _a.length; _i++) {
                var field = _a[_i];
                value[field.name.value] = valueFromNode(field.value, onVariable);
            }
            return value;
        }
        default:
            return node.value;
    }
}

function getDirectiveInfoFromField(field, variables) {
    if (field.directives && field.directives.length) {
        var directiveObj_1 = {};
        field.directives.forEach(function (directive) {
            directiveObj_1[directive.name.value] = argumentsObjectFromField(directive, variables);
        });
        return directiveObj_1;
    }
    return null;
}
function shouldInclude(selection, variables) {
    if (variables === void 0) { variables = {}; }
    return getInclusionDirectives(selection.directives).every(function (_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === 'Variable') {
            evaledValue = variables[ifArgument.value.name.value];
             true ? Object(__WEBPACK_IMPORTED_MODULE_1_ts_invariant__["b" /* invariant */])(evaledValue !== void 0, 13) : invariant(evaledValue !== void 0, "Invalid variable referenced in @" + directive.name.value + " directive.");
        }
        else {
            evaledValue = ifArgument.value.value;
        }
        return directive.name.value === 'skip' ? !evaledValue : evaledValue;
    });
}
function getDirectiveNames(doc) {
    var names = [];
    Object(__WEBPACK_IMPORTED_MODULE_0_graphql_language_visitor__["b" /* visit */])(doc, {
        Directive: function (node) {
            names.push(node.name.value);
        },
    });
    return names;
}
function hasDirectives(names, doc) {
    return getDirectiveNames(doc).some(function (name) { return names.indexOf(name) > -1; });
}
function hasClientExports(document) {
    return (document &&
        hasDirectives(['client'], document) &&
        hasDirectives(['export'], document));
}
function isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === 'skip' || value === 'include';
}
function getInclusionDirectives(directives) {
    return directives ? directives.filter(isInclusionDirective).map(function (directive) {
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
         true ? Object(__WEBPACK_IMPORTED_MODULE_1_ts_invariant__["b" /* invariant */])(directiveArguments && directiveArguments.length === 1, 14) : invariant(directiveArguments && directiveArguments.length === 1, "Incorrect number of arguments for the @" + directiveName + " directive.");
        var ifArgument = directiveArguments[0];
         true ? Object(__WEBPACK_IMPORTED_MODULE_1_ts_invariant__["b" /* invariant */])(ifArgument.name && ifArgument.name.value === 'if', 15) : invariant(ifArgument.name && ifArgument.name.value === 'if', "Invalid argument for the @" + directiveName + " directive.");
        var ifValue = ifArgument.value;
         true ? Object(__WEBPACK_IMPORTED_MODULE_1_ts_invariant__["b" /* invariant */])(ifValue &&
            (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 16) : invariant(ifValue &&
            (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), "Argument for the @" + directiveName + " directive must be a variable or a boolean value.");
        return { directive: directive, ifArgument: ifArgument };
    }) : [];
}

function getFragmentQueryDocument(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function (definition) {
        if (definition.kind === 'OperationDefinition') {
            throw  true ? new __WEBPACK_IMPORTED_MODULE_1_ts_invariant__["a" /* InvariantError */](11) : new InvariantError("Found a " + definition.operation + " operation" + (definition.name ? " named '" + definition.name.value + "'" : '') + ". " +
                'No operations are allowed when using a fragment as a query. Only fragments are allowed.');
        }
        if (definition.kind === 'FragmentDefinition') {
            fragments.push(definition);
        }
    });
    if (typeof actualFragmentName === 'undefined') {
         true ? Object(__WEBPACK_IMPORTED_MODULE_1_ts_invariant__["b" /* invariant */])(fragments.length === 1, 12) : invariant(fragments.length === 1, "Found " + fragments.length + " fragments. `fragmentName` must be provided when there is not exactly 1 fragment.");
        actualFragmentName = fragments[0].name.value;
    }
    var query = Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["a" /* __assign */])({}, document), { definitions: Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["f" /* __spreadArrays */])([
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName,
                            },
                        },
                    ],
                },
            }
        ], document.definitions) });
    return query;
}

function assign(target) {
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    sources.forEach(function (source) {
        if (typeof source === 'undefined' || source === null) {
            return;
        }
        Object.keys(source).forEach(function (key) {
            target[key] = source[key];
        });
    });
    return target;
}

function getMutationDefinition(doc) {
    checkDocument(doc);
    var mutationDef = doc.definitions.filter(function (definition) {
        return definition.kind === 'OperationDefinition' &&
            definition.operation === 'mutation';
    })[0];
     true ? Object(__WEBPACK_IMPORTED_MODULE_1_ts_invariant__["b" /* invariant */])(mutationDef, 1) : invariant(mutationDef, 'Must contain a mutation definition.');
    return mutationDef;
}
function checkDocument(doc) {
     true ? Object(__WEBPACK_IMPORTED_MODULE_1_ts_invariant__["b" /* invariant */])(doc && doc.kind === 'Document', 2) : invariant(doc && doc.kind === 'Document', "Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql");
    var operations = doc.definitions
        .filter(function (d) { return d.kind !== 'FragmentDefinition'; })
        .map(function (definition) {
        if (definition.kind !== 'OperationDefinition') {
            throw  true ? new __WEBPACK_IMPORTED_MODULE_1_ts_invariant__["a" /* InvariantError */](3) : new InvariantError("Schema type definitions not allowed in queries. Found: \"" + definition.kind + "\"");
        }
        return definition;
    });
     true ? Object(__WEBPACK_IMPORTED_MODULE_1_ts_invariant__["b" /* invariant */])(operations.length <= 1, 4) : invariant(operations.length <= 1, "Ambiguous GraphQL document: contains " + operations.length + " operations");
    return doc;
}
function getOperationDefinition(doc) {
    checkDocument(doc);
    return doc.definitions.filter(function (definition) { return definition.kind === 'OperationDefinition'; })[0];
}
function getOperationDefinitionOrDie(document) {
    var def = getOperationDefinition(document);
     true ? Object(__WEBPACK_IMPORTED_MODULE_1_ts_invariant__["b" /* invariant */])(def, 5) : invariant(def, "GraphQL document is missing an operation");
    return def;
}
function getOperationName(doc) {
    return (doc.definitions
        .filter(function (definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    })
        .map(function (x) { return x.name.value; })[0] || null);
}
function getFragmentDefinitions(doc) {
    return doc.definitions.filter(function (definition) { return definition.kind === 'FragmentDefinition'; });
}
function getQueryDefinition(doc) {
    var queryDef = getOperationDefinition(doc);
     true ? Object(__WEBPACK_IMPORTED_MODULE_1_ts_invariant__["b" /* invariant */])(queryDef && queryDef.operation === 'query', 6) : invariant(queryDef && queryDef.operation === 'query', 'Must contain a query definition.');
    return queryDef;
}
function getFragmentDefinition(doc) {
     true ? Object(__WEBPACK_IMPORTED_MODULE_1_ts_invariant__["b" /* invariant */])(doc.kind === 'Document', 7) : invariant(doc.kind === 'Document', "Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql");
     true ? Object(__WEBPACK_IMPORTED_MODULE_1_ts_invariant__["b" /* invariant */])(doc.definitions.length <= 1, 8) : invariant(doc.definitions.length <= 1, 'Fragment must have exactly one definition.');
    var fragmentDef = doc.definitions[0];
     true ? Object(__WEBPACK_IMPORTED_MODULE_1_ts_invariant__["b" /* invariant */])(fragmentDef.kind === 'FragmentDefinition', 9) : invariant(fragmentDef.kind === 'FragmentDefinition', 'Must be a fragment definition.');
    return fragmentDef;
}
function getMainDefinition(queryDoc) {
    checkDocument(queryDoc);
    var fragmentDefinition;
    for (var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++) {
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' ||
                operation === 'mutation' ||
                operation === 'subscription') {
                return definition;
            }
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) {
            fragmentDefinition = definition;
        }
    }
    if (fragmentDefinition) {
        return fragmentDefinition;
    }
    throw  true ? new __WEBPACK_IMPORTED_MODULE_1_ts_invariant__["a" /* InvariantError */](10) : new InvariantError('Expected a parsed GraphQL query with a query, mutation, subscription, or a fragment.');
}
function createFragmentMap(fragments) {
    if (fragments === void 0) { fragments = []; }
    var symTable = {};
    fragments.forEach(function (fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function getDefaultValues(definition) {
    if (definition &&
        definition.variableDefinitions &&
        definition.variableDefinitions.length) {
        var defaultValues = definition.variableDefinitions
            .filter(function (_a) {
            var defaultValue = _a.defaultValue;
            return defaultValue;
        })
            .map(function (_a) {
            var variable = _a.variable, defaultValue = _a.defaultValue;
            var defaultValueObj = {};
            valueToObjectRepresentation(defaultValueObj, variable.name, defaultValue);
            return defaultValueObj;
        });
        return assign.apply(void 0, Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["f" /* __spreadArrays */])([{}], defaultValues));
    }
    return {};
}
function variablesInOperation(operation) {
    var names = new Set();
    if (operation.variableDefinitions) {
        for (var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++) {
            var definition = _a[_i];
            names.add(definition.variable.name.value);
        }
    }
    return names;
}

function filterInPlace(array, test, context) {
    var target = 0;
    array.forEach(function (elem, i) {
        if (test.call(this, elem, i, array)) {
            array[target++] = elem;
        }
    }, context);
    array.length = target;
    return array;
}

var TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename',
    },
};
function isEmpty(op, fragments) {
    return op.selectionSet.selections.every(function (selection) {
        return selection.kind === 'FragmentSpread' &&
            isEmpty(fragments[selection.name.value], fragments);
    });
}
function nullIfDocIsEmpty(doc) {
    return isEmpty(getOperationDefinition(doc) || getFragmentDefinition(doc), createFragmentMap(getFragmentDefinitions(doc)))
        ? null
        : doc;
}
function getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function (dir) {
            return (dir.name && dir.name === directive.name.value) ||
                (dir.test && dir.test(directive));
        });
    };
}
function removeDirectivesFromDocument(directives, doc) {
    var variablesInUse = Object.create(null);
    var variablesToRemove = [];
    var fragmentSpreadsInUse = Object.create(null);
    var fragmentSpreadsToRemove = [];
    var modifiedDoc = nullIfDocIsEmpty(Object(__WEBPACK_IMPORTED_MODULE_0_graphql_language_visitor__["b" /* visit */])(doc, {
        Variable: {
            enter: function (node, _key, parent) {
                if (parent.kind !== 'VariableDefinition') {
                    variablesInUse[node.name.value] = true;
                }
            },
        },
        Field: {
            enter: function (node) {
                if (directives && node.directives) {
                    var shouldRemoveField = directives.some(function (directive) { return directive.remove; });
                    if (shouldRemoveField &&
                        node.directives &&
                        node.directives.some(getDirectiveMatcher(directives))) {
                        if (node.arguments) {
                            node.arguments.forEach(function (arg) {
                                if (arg.value.kind === 'Variable') {
                                    variablesToRemove.push({
                                        name: arg.value.name.value,
                                    });
                                }
                            });
                        }
                        if (node.selectionSet) {
                            getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function (frag) {
                                fragmentSpreadsToRemove.push({
                                    name: frag.name.value,
                                });
                            });
                        }
                        return null;
                    }
                }
            },
        },
        FragmentSpread: {
            enter: function (node) {
                fragmentSpreadsInUse[node.name.value] = true;
            },
        },
        Directive: {
            enter: function (node) {
                if (getDirectiveMatcher(directives)(node)) {
                    return null;
                }
            },
        },
    }));
    if (modifiedDoc &&
        filterInPlace(variablesToRemove, function (v) { return !variablesInUse[v.name]; }).length) {
        modifiedDoc = removeArgumentsFromDocument(variablesToRemove, modifiedDoc);
    }
    if (modifiedDoc &&
        filterInPlace(fragmentSpreadsToRemove, function (fs) { return !fragmentSpreadsInUse[fs.name]; })
            .length) {
        modifiedDoc = removeFragmentSpreadFromDocument(fragmentSpreadsToRemove, modifiedDoc);
    }
    return modifiedDoc;
}
function addTypenameToDocument(doc) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_graphql_language_visitor__["b" /* visit */])(checkDocument(doc), {
        SelectionSet: {
            enter: function (node, _key, parent) {
                if (parent &&
                    parent.kind === 'OperationDefinition') {
                    return;
                }
                var selections = node.selections;
                if (!selections) {
                    return;
                }
                var skip = selections.some(function (selection) {
                    return (isField(selection) &&
                        (selection.name.value === '__typename' ||
                            selection.name.value.lastIndexOf('__', 0) === 0));
                });
                if (skip) {
                    return;
                }
                var field = parent;
                if (isField(field) &&
                    field.directives &&
                    field.directives.some(function (d) { return d.name.value === 'export'; })) {
                    return;
                }
                return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["a" /* __assign */])({}, node), { selections: Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["f" /* __spreadArrays */])(selections, [TYPENAME_FIELD]) });
            },
        },
    });
}
var connectionRemoveConfig = {
    test: function (directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) {
            if (!directive.arguments ||
                !directive.arguments.some(function (arg) { return arg.name.value === 'key'; })) {
                "production" === "production" || __WEBPACK_IMPORTED_MODULE_1_ts_invariant__["b" /* invariant */].warn('Removing an @connection directive even though it does not have a key. ' +
                    'You may want to use the key parameter to specify a store key.');
            }
        }
        return willRemove;
    },
};
function removeConnectionDirectiveFromDocument(doc) {
    return removeDirectivesFromDocument([connectionRemoveConfig], checkDocument(doc));
}
function hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) { nestedCheck = true; }
    return (selectionSet &&
        selectionSet.selections &&
        selectionSet.selections.some(function (selection) {
            return hasDirectivesInSelection(directives, selection, nestedCheck);
        }));
}
function hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) { nestedCheck = true; }
    if (!isField(selection)) {
        return true;
    }
    if (!selection.directives) {
        return false;
    }
    return (selection.directives.some(getDirectiveMatcher(directives)) ||
        (nestedCheck &&
            hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck)));
}
function getDirectivesFromDocument(directives, doc) {
    checkDocument(doc);
    var parentPath;
    return nullIfDocIsEmpty(Object(__WEBPACK_IMPORTED_MODULE_0_graphql_language_visitor__["b" /* visit */])(doc, {
        SelectionSet: {
            enter: function (node, _key, _parent, path) {
                var currentPath = path.join('-');
                if (!parentPath ||
                    currentPath === parentPath ||
                    !currentPath.startsWith(parentPath)) {
                    if (node.selections) {
                        var selectionsWithDirectives = node.selections.filter(function (selection) { return hasDirectivesInSelection(directives, selection); });
                        if (hasDirectivesInSelectionSet(directives, node, false)) {
                            parentPath = currentPath;
                        }
                        return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["a" /* __assign */])({}, node), { selections: selectionsWithDirectives });
                    }
                    else {
                        return null;
                    }
                }
            },
        },
    }));
}
function getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function (aConfig) {
            return argument.value &&
                argument.value.kind === 'Variable' &&
                argument.value.name &&
                (aConfig.name === argument.value.name.value ||
                    (aConfig.test && aConfig.test(argument)));
        });
    };
}
function removeArgumentsFromDocument(config, doc) {
    var argMatcher = getArgumentMatcher(config);
    return nullIfDocIsEmpty(Object(__WEBPACK_IMPORTED_MODULE_0_graphql_language_visitor__["b" /* visit */])(doc, {
        OperationDefinition: {
            enter: function (node) {
                return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["a" /* __assign */])({}, node), { variableDefinitions: node.variableDefinitions.filter(function (varDef) {
                        return !config.some(function (arg) { return arg.name === varDef.variable.name.value; });
                    }) });
            },
        },
        Field: {
            enter: function (node) {
                var shouldRemoveField = config.some(function (argConfig) { return argConfig.remove; });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    node.arguments.forEach(function (arg) {
                        if (argMatcher(arg)) {
                            argMatchCount_1 += 1;
                        }
                    });
                    if (argMatchCount_1 === 1) {
                        return null;
                    }
                }
            },
        },
        Argument: {
            enter: function (node) {
                if (argMatcher(node)) {
                    return null;
                }
            },
        },
    }));
}
function removeFragmentSpreadFromDocument(config, doc) {
    function enter(node) {
        if (config.some(function (def) { return def.name === node.name.value; })) {
            return null;
        }
    }
    return nullIfDocIsEmpty(Object(__WEBPACK_IMPORTED_MODULE_0_graphql_language_visitor__["b" /* visit */])(doc, {
        FragmentSpread: { enter: enter },
        FragmentDefinition: { enter: enter },
    }));
}
function getAllFragmentSpreadsFromSelectionSet(selectionSet) {
    var allFragments = [];
    selectionSet.selections.forEach(function (selection) {
        if ((isField(selection) || isInlineFragment(selection)) &&
            selection.selectionSet) {
            getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function (frag) { return allFragments.push(frag); });
        }
        else if (selection.kind === 'FragmentSpread') {
            allFragments.push(selection);
        }
    });
    return allFragments;
}
function buildQueryFromSelectionSet(document) {
    var definition = getMainDefinition(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === 'query') {
        return document;
    }
    var modifiedDoc = Object(__WEBPACK_IMPORTED_MODULE_0_graphql_language_visitor__["b" /* visit */])(document, {
        OperationDefinition: {
            enter: function (node) {
                return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["a" /* __assign */])({}, node), { operation: 'query' });
            },
        },
    });
    return modifiedDoc;
}
function removeClientSetsFromDocument(document) {
    checkDocument(document);
    var modifiedDoc = removeDirectivesFromDocument([
        {
            test: function (directive) { return directive.name.value === 'client'; },
            remove: true,
        },
    ], document);
    if (modifiedDoc) {
        modifiedDoc = Object(__WEBPACK_IMPORTED_MODULE_0_graphql_language_visitor__["b" /* visit */])(modifiedDoc, {
            FragmentDefinition: {
                enter: function (node) {
                    if (node.selectionSet) {
                        var isTypenameOnly = node.selectionSet.selections.every(function (selection) {
                            return isField(selection) && selection.name.value === '__typename';
                        });
                        if (isTypenameOnly) {
                            return null;
                        }
                    }
                },
            },
        });
    }
    return modifiedDoc;
}

var canUseWeakMap = typeof WeakMap === 'function' && !(typeof navigator === 'object' &&
    navigator.product === 'ReactNative');

var toString = Object.prototype.toString;
function cloneDeep(value) {
    return cloneDeepHelper(value, new Map());
}
function cloneDeepHelper(val, seen) {
    switch (toString.call(val)) {
        case "[object Array]": {
            if (seen.has(val))
                return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function (child, i) {
                copy_1[i] = cloneDeepHelper(child, seen);
            });
            return copy_1;
        }
        case "[object Object]": {
            if (seen.has(val))
                return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function (key) {
                copy_2[key] = cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        }
        default:
            return val;
    }
}

function getEnv() {
    if (typeof process !== 'undefined' && "production") {
        return "production";
    }
    return 'development';
}
function isEnv(env) {
    return getEnv() === env;
}
function isProduction() {
    return isEnv('production') === true;
}
function isDevelopment() {
    return isEnv('development') === true;
}
function isTest() {
    return isEnv('test') === true;
}

function tryFunctionOrLogError(f) {
    try {
        return f();
    }
    catch (e) {
        if (console.error) {
            console.error(e);
        }
    }
}
function graphQLResultHasError(result) {
    return result.errors && result.errors.length;
}

function deepFreeze(o) {
    Object.freeze(o);
    Object.getOwnPropertyNames(o).forEach(function (prop) {
        if (o[prop] !== null &&
            (typeof o[prop] === 'object' || typeof o[prop] === 'function') &&
            !Object.isFrozen(o[prop])) {
            deepFreeze(o[prop]);
        }
    });
    return o;
}
function maybeDeepFreeze(obj) {
    if (isDevelopment() || isTest()) {
        var symbolIsPolyfilled = typeof Symbol === 'function' && typeof Symbol('') === 'string';
        if (!symbolIsPolyfilled) {
            return deepFreeze(obj);
        }
    }
    return obj;
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
function mergeDeep() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    return mergeDeepArray(sources);
}
function mergeDeepArray(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var pastCopies = [];
        target = shallowCopyForMerge(target, pastCopies);
        for (var i = 1; i < count; ++i) {
            target = mergeHelper(target, sources[i], pastCopies);
        }
    }
    return target;
}
function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
function mergeHelper(target, source, pastCopies) {
    if (isObject(source) && isObject(target)) {
        if (Object.isExtensible && !Object.isExtensible(target)) {
            target = shallowCopyForMerge(target, pastCopies);
        }
        Object.keys(source).forEach(function (sourceKey) {
            var sourceValue = source[sourceKey];
            if (hasOwnProperty.call(target, sourceKey)) {
                var targetValue = target[sourceKey];
                if (sourceValue !== targetValue) {
                    target[sourceKey] = mergeHelper(shallowCopyForMerge(targetValue, pastCopies), sourceValue, pastCopies);
                }
            }
            else {
                target[sourceKey] = sourceValue;
            }
        });
        return target;
    }
    return source;
}
function shallowCopyForMerge(value, pastCopies) {
    if (value !== null &&
        typeof value === 'object' &&
        pastCopies.indexOf(value) < 0) {
        if (Array.isArray(value)) {
            value = value.slice(0);
        }
        else {
            value = Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["a" /* __assign */])({ __proto__: Object.getPrototypeOf(value) }, value);
        }
        pastCopies.push(value);
    }
    return value;
}

var haveWarned = Object.create({});
function warnOnceInDevelopment(msg, type) {
    if (type === void 0) { type = 'warn'; }
    if (!isProduction() && !haveWarned[msg]) {
        if (!isTest()) {
            haveWarned[msg] = true;
        }
        if (type === 'error') {
            console.error(msg);
        }
        else {
            console.warn(msg);
        }
    }
}

function stripSymbols(data) {
    return JSON.parse(JSON.stringify(data));
}


//# sourceMappingURL=bundle.esm.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(137)))

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InvariantError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return invariant; });
/* unused harmony export process */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(98);


var genericMessage = "Invariant Violation";
var _a = Object.setPrototypeOf, setPrototypeOf = _a === void 0 ? function (obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : _a;
var InvariantError = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) { message = genericMessage; }
        var _this = _super.call(this, typeof message === "number"
            ? genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)"
            : message) || this;
        _this.framesToPop = 1;
        _this.name = genericMessage;
        setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error));
function invariant(condition, message) {
    if (!condition) {
        throw new InvariantError(message);
    }
}
function wrapConsoleMethod(method) {
    return function () {
        return console[method].apply(console, arguments);
    };
}
(function (invariant) {
    invariant.warn = wrapConsoleMethod("warn");
    invariant.error = wrapConsoleMethod("error");
})(invariant || (invariant = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var processStub = { env: {} };
if (typeof process === "object") {
    processStub = process;
}
else
    try {
        // Using Function to evaluate this assignment in global scope also escapes
        // the strict mode of the current module, thereby allowing the assignment.
        // Inspired by https://github.com/facebook/regenerator/pull/369.
        Function("stub", "process = stub")(processStub);
    }
    catch (atLeastWeTried) {
        // The assignment can fail if a Content Security Policy heavy-handedly
        // forbids Function usage. In those environments, developers should take
        // extra care to replace process.env.NODE_ENV in their production builds,
        // or define an appropriate global.process polyfill.
    }
var invariant$1 = invariant;

/* unused harmony default export */ var _unused_webpack_default_export = (invariant$1);

//# sourceMappingURL=invariant.esm.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(137)))

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createBreakpoints;
exports.keys = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
var keys = ['xs', 'sm', 'md', 'lg', 'xl']; // Keep in mind that @media is inclusive by the CSS specification.

exports.keys = keys;

function createBreakpoints(breakpoints) {
  var _breakpoints$values = breakpoints.values,
      values = _breakpoints$values === void 0 ? {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  } : _breakpoints$values,
      _breakpoints$unit = breakpoints.unit,
      unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit,
      _breakpoints$step = breakpoints.step,
      step = _breakpoints$step === void 0 ? 5 : _breakpoints$step,
      other = (0, _objectWithoutProperties2.default)(breakpoints, ["values", "unit", "step"]);

  function up(key) {
    var value = typeof values[key] === 'number' ? values[key] : key;
    return "@media (min-width:".concat(value).concat(unit, ")");
  }

  function down(key) {
    var endIndex = keys.indexOf(key) + 1;
    var upperbound = values[keys[endIndex]];

    if (endIndex === keys.length) {
      // xl down applies to all sizes
      return up('xs');
    }

    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
    return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
  }

  function between(start, end) {
    var endIndex = keys.indexOf(end) + 1;

    if (endIndex === keys.length) {
      return up(start);
    }

    return "@media (min-width:".concat(values[start]).concat(unit, ") and ") + "(max-width:".concat(values[keys[endIndex]] - step / 100).concat(unit, ")");
  }

  function only(key) {
    return between(key, key);
  }

  function width(key) {
    return values[key];
  }

  return (0, _extends2.default)({
    keys: keys,
    values: values,
    up: up,
    down: down,
    between: between,
    only: only,
    width: width
  }, other);
}

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _createRule = __webpack_require__(217);

var _createRule2 = _interopRequireDefault(_createRule);

var _linkRule = __webpack_require__(444);

var _linkRule2 = _interopRequireDefault(_linkRule);

var _StyleRule = __webpack_require__(143);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _escape = __webpack_require__(764);

var _escape2 = _interopRequireDefault(_escape);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Contains rules objects and allows adding/removing etc.
 * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
 */
var RuleList = function () {

  // Original styles object.
  function RuleList(options) {
    var _this = this;

    _classCallCheck(this, RuleList);

    this.map = {};
    this.raw = {};
    this.index = [];

    this.update = function (name, data) {
      var _options = _this.options,
          plugins = _options.jss.plugins,
          sheet = _options.sheet;

      if (typeof name === 'string') {
        plugins.onUpdate(data, _this.get(name), sheet);
      } else {
        for (var index = 0; index < _this.index.length; index++) {
          plugins.onUpdate(name, _this.index[index], sheet);
        }
      }
    };

    this.options = options;
    this.classes = options.classes;
  }

  /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */


  // Used to ensure correct rules order.

  // Rules registry for access by .get() method.
  // It contains the same rule registered by name and by selector.


  _createClass(RuleList, [{
    key: 'add',
    value: function add(name, decl, options) {
      var _options2 = this.options,
          parent = _options2.parent,
          sheet = _options2.sheet,
          jss = _options2.jss,
          Renderer = _options2.Renderer,
          generateClassName = _options2.generateClassName;


      options = _extends({
        classes: this.classes,
        parent: parent,
        sheet: sheet,
        jss: jss,
        Renderer: Renderer,
        generateClassName: generateClassName
      }, options);

      if (!options.selector && this.classes[name]) {
        options.selector = '.' + (0, _escape2['default'])(this.classes[name]);
      }

      this.raw[name] = decl;

      var rule = (0, _createRule2['default'])(name, decl, options);

      var className = void 0;

      if (!options.selector && rule instanceof _StyleRule2['default']) {
        className = generateClassName(rule, sheet);
        rule.selector = '.' + (0, _escape2['default'])(className);
      }

      this.register(rule, className);

      var index = options.index === undefined ? this.index.length : options.index;
      this.index.splice(index, 0, rule);

      return rule;
    }

    /**
     * Get a rule.
     */

  }, {
    key: 'get',
    value: function get(name) {
      return this.map[name];
    }

    /**
     * Delete a rule.
     */

  }, {
    key: 'remove',
    value: function remove(rule) {
      this.unregister(rule);
      this.index.splice(this.indexOf(rule), 1);
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.index.indexOf(rule);
    }

    /**
     * Run `onProcessRule()` plugins on every rule.
     */

  }, {
    key: 'process',
    value: function process() {
      var plugins = this.options.jss.plugins;
      // We need to clone array because if we modify the index somewhere else during a loop
      // we end up with very hard-to-track-down side effects.

      this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    }

    /**
     * Register a rule in `.map` and `.classes` maps.
     */

  }, {
    key: 'register',
    value: function register(rule, className) {
      this.map[rule.key] = rule;
      if (rule instanceof _StyleRule2['default']) {
        this.map[rule.selector] = rule;
        if (className) this.classes[rule.key] = className;
      }
    }

    /**
     * Unregister a rule.
     */

  }, {
    key: 'unregister',
    value: function unregister(rule) {
      delete this.map[rule.key];
      if (rule instanceof _StyleRule2['default']) {
        delete this.map[rule.selector];
        delete this.classes[rule.key];
      }
    }

    /**
     * Update the function values with a new data.
     */

  }, {
    key: 'link',


    /**
     * Link renderable rules with CSSRuleList.
     */
    value: function link(cssRules) {
      var map = this.options.sheet.renderer.getUnescapedKeysMap(this.index);

      for (var i = 0; i < cssRules.length; i++) {
        var cssRule = cssRules[i];
        var _key = this.options.sheet.renderer.getKey(cssRule);
        if (map[_key]) _key = map[_key];
        var rule = this.map[_key];
        if (rule) (0, _linkRule2['default'])(rule, cssRule);
      }
    }

    /**
     * Convert rules to a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      var str = '';
      var sheet = this.options.sheet;

      var link = sheet ? sheet.options.link : false;

      for (var index = 0; index < this.index.length; index++) {
        var rule = this.index[index];
        var css = rule.toString(options);

        // No need to render an empty rule.
        if (!css && !link) continue;

        if (str) str += '\n';
        str += css;
      }

      return str;
    }
  }]);

  return RuleList;
}();

exports['default'] = RuleList;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(176);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _getDisplayName = _interopRequireDefault(__webpack_require__(296));

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + "(" + (0, _getDisplayName.default)(BaseComponent) + ")";
};

var _default = wrapDisplayName;
exports.default = _default;

/***/ }),
/* 176 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Popover.default;
  }
});

var _Popover = _interopRequireDefault(__webpack_require__(858));

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _List.default;
  }
});

var _List = _interopRequireDefault(__webpack_require__(878));

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TableCell.default;
  }
});

var _TableCell = _interopRequireDefault(__webpack_require__(914));

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(152);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ListItem.default;
  }
});

var _ListItem = _interopRequireDefault(__webpack_require__(973));

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _NoSsr.default;
  }
});

var _NoSsr = _interopRequireDefault(__webpack_require__(1038));

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
})), 'Search');

exports.default = _default;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
})), 'Close');

exports.default = _default;

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return GET_FILE_FORMAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return GET_UPLOAD_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return GET_DEVICE_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return GET_CLIENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return GET_VLPN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return GET_SELECT_DEV_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return GET_SIM_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GET_ACCESSORY_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return GET_SELECT_PHONE_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return GET_ZMKAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return GET_DASHCAM_REGISTRATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GET_ALL_ASSIGNED_ROLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return GET_RCS_INVENTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return UPDATE_RCS_INVENTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_VEHICLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return GET_CLIENT_DETAILS_BYID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CHECK_ENGINE_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHECK_CHASSIS_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return GET_SUBSCRIPTION_BY_PARTNERID; });
/* unused harmony export GET_MAKE_AND_MODELS_MASTER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return GET_VEHICLE_MAKES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GET_ALL_DG_MAKES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return GET_DG_MODELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return GET_DG_SPECS_FROM_MODEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return GET_VEHICLE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return GET_VEHICLE_MODELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return GET_VEHICLE_PARAMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return GET_VEHICLE_VAHAAN_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return GET_DROPDOWN_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return GET_DROPDOWN_CATEGORIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return GET_DROPDOWN_VALUES_BY_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return GET_CUSTOMER_TYPE_AND_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GET_ALL_VEHICLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return GET_CALIBRATION_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return GET_CLIENT_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CONFIRM_VEHICLE_REGISTRATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return GET_SOLUTION_TYPES; });
/* unused harmony export GET_SOLUTION_TYPES_WITH_PLANS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(7);
var _templateObject=_taggedTemplateLiteral(['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n'],['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n'],['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query getAllAssignedDevicesToClient($clientId: Int!) {\n    device: getAllAssignedDevicesToClient(clientLoginId: $clientId) {\n      uniqueDeviceId\n      deviceModel {\n        model_name\n      }\n    }\n  }\n'],['\n  query getAllAssignedDevicesToClient($clientId: Int!) {\n    device: getAllAssignedDevicesToClient(clientLoginId: $clientId) {\n      uniqueDeviceId\n      deviceModel {\n        model_name\n      }\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query allClientDetails($partnerLoginId: Int, $status: Int) {\n    clientsDetails: allClientDetails(\n      partnerLoginId: $partnerLoginId\n      status: $status\n    ) {\n      clientName\n      loginId\n      partner {\n        businessName\n      }\n      zonalManager\n      keyAccountManager\n      channelPartnerName\n    }\n  }\n'],['\n  query allClientDetails($partnerLoginId: Int, $status: Int) {\n    clientsDetails: allClientDetails(\n      partnerLoginId: $partnerLoginId\n      status: $status\n    ) {\n      clientName\n      loginId\n      partner {\n        businessName\n      }\n      zonalManager\n      keyAccountManager\n      channelPartnerName\n    }\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  query checkVehicleNumber($vlpn: String!) {\n    checkVehicleNumber(vehicleNumber: $vlpn)\n  }\n'],['\n  query checkVehicleNumber($vlpn: String!) {\n    checkVehicleNumber(vehicleNumber: $vlpn)\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  query devicePartnerAssignDetail($uniqueId: String) {\n    devicePartnerAssignDetail(uniqueDeviceId: $uniqueId) {\n      deviceModel {\n        id\n        model_name\n        devicetype\n      }\n      uniqueDeviceId\n    }\n  }\n'],['\n  query devicePartnerAssignDetail($uniqueId: String) {\n    devicePartnerAssignDetail(uniqueDeviceId: $uniqueId) {\n      deviceModel {\n        id\n        model_name\n        devicetype\n      }\n      uniqueDeviceId\n    }\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  query getAllAssignedSimToClient($clientId: Int!) {\n    simDetails: getAllAssignedSimToClient(clientLoginId: $clientId) {\n      id\n      simId\n      sim {\n        phoneNumber\n      }\n    }\n  }\n'],['\n  query getAllAssignedSimToClient($clientId: Int!) {\n    simDetails: getAllAssignedSimToClient(clientLoginId: $clientId) {\n      id\n      simId\n      sim {\n        phoneNumber\n      }\n    }\n  }\n']),_templateObject8=_taggedTemplateLiteral(['\n  query getAllAssignedAccessoryToClient($clientId: Int!) {\n    getAllAssignedAccessoryToClient(clientLoginId: $clientId) {\n      accessory {\n        uniqueAccessoryId\n      }\n    }\n  }\n'],['\n  query getAllAssignedAccessoryToClient($clientId: Int!) {\n    getAllAssignedAccessoryToClient(clientLoginId: $clientId) {\n      accessory {\n        uniqueAccessoryId\n      }\n    }\n  }\n']),_templateObject9=_taggedTemplateLiteral(['\n  query simPartnerAssignDetail($simId: Int) {\n    simPartnerAssignDetail(simId: $simId) {\n      sim {\n        simNumber\n      }\n      serviceProvider {\n        name\n      }\n    }\n  }\n'],['\n  query simPartnerAssignDetail($simId: Int) {\n    simPartnerAssignDetail(simId: $simId) {\n      sim {\n        simNumber\n      }\n      serviceProvider {\n        name\n      }\n    }\n  }\n']),_templateObject10=_taggedTemplateLiteral(['\n  query getAdminUserDetailsByRole($roleName: [String]) {\n    getAdminUserDetailsByRole(roleName: $roleName) {\n      id\n      username\n      role\n    }\n  }\n'],['\n  query getAdminUserDetailsByRole($roleName: [String]) {\n    getAdminUserDetailsByRole(roleName: $roleName) {\n      id\n      username\n      role\n    }\n  }\n']),_templateObject11=_taggedTemplateLiteral(['\n  query GetDashcamRegistrations {\n    getDashcamRegistrations {\n      success\n      message\n      data {\n        uuid\n        simid\n        memorycardid\n        uniqueid\n        vtid\n        status\n        createdat\n        updatedat\n      }\n    }\n  }\n'],['\n  query GetDashcamRegistrations {\n    getDashcamRegistrations {\n      success\n      message\n      data {\n        uuid\n        simid\n        memorycardid\n        uniqueid\n        vtid\n        status\n        createdat\n        updatedat\n      }\n    }\n  }\n']),_templateObject12=_taggedTemplateLiteral(['\n  query GetAllAssignedRoles {\n    getAllAssignedRoles {\n      id\n      uuid\n      username\n      email\n      mobile_number\n      role\n      client_ids\n      createdAt\n      updatedAt\n    }\n  }\n'],['\n  query GetAllAssignedRoles {\n    getAllAssignedRoles {\n      id\n      uuid\n      username\n      email\n      mobile_number\n      role\n      client_ids\n      createdAt\n      updatedAt\n    }\n  }\n']),_templateObject13=_taggedTemplateLiteral(['\n  query GetReverseCameraAndScreenInventory {\n    getReverseCameraAndScreenInventory {\n      data {\n        rcs_serial_number\n      }\n    }\n  }\n'],['\n  query GetReverseCameraAndScreenInventory {\n    getReverseCameraAndScreenInventory {\n      data {\n        rcs_serial_number\n      }\n    }\n  }\n']),_templateObject14=_taggedTemplateLiteral(['\n  mutation updateReverseCameraAndScreenInventory($rcsSerialNumber: String!, $input: UpdateReverseCameraAndScreenInventoryInput!) {\n    updateReverseCameraAndScreenInventory(rcs_serial_number: $rcsSerialNumber, input: $input) {\n      success\n      message\n    }\n  }\n'],['\n  mutation updateReverseCameraAndScreenInventory($rcsSerialNumber: String!, $input: UpdateReverseCameraAndScreenInventoryInput!) {\n    updateReverseCameraAndScreenInventory(rcs_serial_number: $rcsSerialNumber, input: $input) {\n      success\n      message\n    }\n  }\n']),_templateObject15=_taggedTemplateLiteral(['\n  mutation addVehicleDetail(\n    $rcsSerialNumber: String\n    $vehicleNumber: String!\n    $engineNumber: String\n    $chassisNumber: String\n    $clientLoginId: Int!\n    $uniqueDeviceId: String!\n    $simId: Int!\n    $speedSensorType: String!\n    $speedLimit: Int!\n    $uniqueAccessoryId: String\n    $vehicleType: String\n    $vehicleMake: String\n    $averageMileage: Int\n    $vehicleModel: String!\n    $vehicleCapacity: Int\n    $isActivated: Boolean\n    $partnerSubscriptionId: Int!\n    $accountType: String\n    $vehicleIdentificationNumber: String\n    $vehicleColour: String\n    $invoiceNumber: String\n    $idlingSpeed: Int\n    $equipmentSerialNumber: String\n    $equipmentName: String\n    $commissioningDate: Int\n    $invoiceDate: Int\n    $department: String\n    $contractorName: String\n    $operatorName: String\n    $operatorContactNumber: String\n    $engineTorque: String\n    $engineLoad: String\n    $fuelType: String\n    $torquePower: String\n    $engineSpecification: String\n    $emissionRateType: String\n    $vehicleMakeId: String\n    $vehicleModelId: String\n    $grossVehicleWeight: Float\n    $manufacturingYear: Int\n    $vehicleSegment: String\n    $equipmentTypeClass: String\n    $constructionVehicleType: String\n    $passengerVehicleType: String\n    $transportationVehicleType: String\n    $vehicleNickName: String\n    $haulageType: String\n    $vehicleWheeler: String\n    $application: String\n    $documentUpload: String\n    $documentUploadNew: JSON\n    $baselineDataForFE: Float\n    $baselineDataType: String\n    $baselineDataHour: Float\n    $baselineDataForFELPH: Float\n    $fuelTankCapacity: String\n    $noOfGears: Int\n    $gearRatio: String\n    $adblueCapacity: String\n    $vehicleRegistrationNumber: String\n    $registrationDate: String\n    $registrationValidUpto: String\n    $stateCode: String\n    $rtoCode: String\n    $vehicleCategoryCode: String\n    $vehicleCategoryDescription: String\n    $vehicleClassDescription: String\n    $makerDescription: String\n    $makerModel: String\n    $bodyTypeDescription: String\n    $emissionNormsDescription: String\n    $fitmentUpto: String\n    $nationalPermitUpto: String\n    $taxUpto: String\n    $insurerName: String\n    $insuranceUpto: String\n    $manufacturingMonthYear: String\n    $unladenWeight: Int\n    $registeredAt: String\n    $puccUpto: String\n    $permitNumber: String\n    $permitIssueDate: String\n    $permitValidFrom: String\n    $permitValidUpto: String\n    $permitType: String\n    $permitCode: String\n    $numberOfAxles: Int\n    $fuelCode: String\n    $vehicleClass: String\n    $baselineDistance: Float\n    $immobilize: Boolean\n    $solutionType: String\n    $solution_type: [String]\n    $isDualEngine: Boolean\n    $eoff_voltage: Float\n    $eon_voltage: Float\n    $zonalManager: String\n    $keyAccountManager: String\n    $channelPartnerName: String\n    $duplicateVehicle: Boolean\n    $portedVehicle: Boolean\n    $isTestingVehicle: Boolean\n    $hasArm: Boolean\n    $isElockConnection: Boolean\n    $kvaRating: String\n    $dgSetType: String\n    $bhp: String\n    $phase: String\n    $engineModel: String\n    $gensetController: String\n    $videoTelematicsType: String\n    $videoTelematicsId: String\n    $inputParameter: Float\n    $multiplicationFactor: Float\n    $engineOnHours: String\n    $odometerDistance: String\n    $clientName: String!\n    $custCode: String\n    $custType: String\n    $noOfWheels: Int\n    $baselineHours: Int\n    $isIndividualViewOrCombinedView: Boolean\n    $vehicleCustomizedBodyType: String\n    $tensionerConductorLength: Float\n    $tensionerRotationSensorDirection: String\n    $isRotationSensor: Boolean\n    $technicianName: String\n    $createdBy: String\n    $istachoenabled: Boolean\n    $tachoidlerpm: Int\n    $tachoshifthours: Int\n    $tachoengineonmin: Int\n    $tachoengineonmax: Int\n  ) {\n    addVehicleDetail(\n      rcsSerialNumber: $rcsSerialNumber\n      vehicleNumber: $vehicleNumber\n      engineNumber: $engineNumber\n      chassisNumber: $chassisNumber\n      clientLoginId: $clientLoginId\n      uniqueDeviceId: $uniqueDeviceId\n      simId: $simId\n      speedSensorType: $speedSensorType\n      speedLimit: $speedLimit\n      uniqueAccessoryId: $uniqueAccessoryId\n      vehicleType: $vehicleType\n      vehicleMake: $vehicleMake\n      averageMileage: $averageMileage\n      vehicleModel: $vehicleModel\n      vehicleCapacity: $vehicleCapacity\n      isActivated: $isActivated\n      partnerSubscriptionId: $partnerSubscriptionId\n      accountType: $accountType\n      vehicleIdentificationNumber: $vehicleIdentificationNumber\n      vehicleColour: $vehicleColour\n      invoiceNumber: $invoiceNumber\n      idlingSpeed: $idlingSpeed\n      equipmentSerialNumber: $equipmentSerialNumber\n      equipmentName: $equipmentName\n      commissioningDate: $commissioningDate\n      invoiceDate: $invoiceDate\n      department: $department\n      contractorName: $contractorName\n      operatorName: $operatorName\n      operatorContactNumber: $operatorContactNumber\n      engineTorque: $engineTorque\n      engineLoad: $engineLoad\n      fuelType: $fuelType\n      torquePower: $torquePower\n      engineSpecification: $engineSpecification\n      emissionRateType: $emissionRateType\n      vehicleMakeId: $vehicleMakeId\n      vehicleModelId: $vehicleModelId\n      grossVehicleWeight: $grossVehicleWeight\n      manufacturingYear: $manufacturingYear\n      vehicleSegment: $vehicleSegment\n      equipmentTypeClass: $equipmentTypeClass\n      constructionVehicleType: $constructionVehicleType\n      passengerVehicleType: $passengerVehicleType\n      transportationVehicleType: $transportationVehicleType\n      vehicleNickName: $vehicleNickName\n      haulageType: $haulageType\n      vehicleWheeler: $vehicleWheeler\n      application: $application\n      documentUpload: $documentUpload\n      documentUploadNew: $documentUploadNew\n      baselineDataForFE: $baselineDataForFE\n      baselineDataType: $baselineDataType\n      baselineDataHour: $baselineDataHour\n      baselineDataForFELPH: $baselineDataForFELPH\n      fuelTankCapacity: $fuelTankCapacity\n      noOfGears: $noOfGears\n      gearRatio: $gearRatio\n      adblueCapacity: $adblueCapacity\n\n      vehicleRegistrationNumber: $vehicleRegistrationNumber\n      registrationDate: $registrationDate\n      registrationValidUpto: $registrationValidUpto\n      stateCode: $stateCode\n      rtoCode: $rtoCode\n      vehicleCategoryCode: $vehicleCategoryCode\n      vehicleCategoryDescription: $vehicleCategoryDescription\n      vehicleClassDescription: $vehicleClassDescription\n      makerDescription: $makerDescription\n      makerModel: $makerModel\n      bodyTypeDescription: $bodyTypeDescription\n      emissionNormsDescription: $emissionNormsDescription\n      fitmentUpto: $fitmentUpto\n      nationalPermitUpto: $nationalPermitUpto\n      taxUpto: $taxUpto\n      insurerName: $insurerName\n      insuranceUpto: $insuranceUpto\n      manufacturingMonthYear: $manufacturingMonthYear\n      unladenWeight: $unladenWeight\n      registeredAt: $registeredAt\n      puccUpto: $puccUpto\n      permitNumber: $permitNumber\n      permitIssueDate: $permitIssueDate\n      permitValidFrom: $permitValidFrom\n      permitValidUpto: $permitValidUpto\n      permitType: $permitType\n      permitCode: $permitCode\n      numberOfAxles: $numberOfAxles\n      fuelCode: $fuelCode\n      vehicleClass: $vehicleClass\n\n      baselineDistance: $baselineDistance\n      immobilize: $immobilize\n      solutionType: $solutionType\n      solution_type: $solution_type\n      isDualEngine: $isDualEngine\n      eoff_voltage: $eoff_voltage\n      eon_voltage: $eon_voltage\n      zonalManager: $zonalManager\n      keyAccountManager: $keyAccountManager\n      channelPartnerName: $channelPartnerName\n      duplicateVehicle: $duplicateVehicle\n      portedVehicle: $portedVehicle\n      isTestingVehicle: $isTestingVehicle\n      hasArm: $hasArm\n      isElockConnection: $isElockConnection\n      kvaRating: $kvaRating\n      dgSetType: $dgSetType\n      bhp: $bhp\n      phase: $phase\n      engineModel: $engineModel\n      gensetController: $gensetController\n      videoTelematicsType: $videoTelematicsType\n      videoTelematicsId: $videoTelematicsId\n      inputParameter: $inputParameter\n      multiplicationFactor: $multiplicationFactor\n\n      engineOnHours: $engineOnHours\n      odometerDistance: $odometerDistance\n\n      technicianName: $technicianName\n      createdBy: $createdBy\n\n      clientName: $clientName\n      custCode: $custCode\n      custType: $custType\n      noOfWheels: $noOfWheels\n      baselineHours: $baselineHours\n      isIndividualViewOrCombinedView: $isIndividualViewOrCombinedView\n      vehicleCustomizedBodyType: $vehicleCustomizedBodyType\n      tensionerConductorLength: $tensionerConductorLength\n      tensionerRotationSensorDirection: $tensionerRotationSensorDirection\n      isRotationSensor: $isRotationSensor\n      istachoenabled: $istachoenabled\n      tachoidlerpm: $tachoidlerpm\n      tachoengineonmin: $tachoengineonmin\n      tachoengineonmax: $tachoengineonmax\n      tachoshifthours: $tachoshifthours\n    )\n  }\n'],['\n  mutation addVehicleDetail(\n    $rcsSerialNumber: String\n    $vehicleNumber: String!\n    $engineNumber: String\n    $chassisNumber: String\n    $clientLoginId: Int!\n    $uniqueDeviceId: String!\n    $simId: Int!\n    $speedSensorType: String!\n    $speedLimit: Int!\n    $uniqueAccessoryId: String\n    $vehicleType: String\n    $vehicleMake: String\n    $averageMileage: Int\n    $vehicleModel: String!\n    $vehicleCapacity: Int\n    $isActivated: Boolean\n    $partnerSubscriptionId: Int!\n    $accountType: String\n    $vehicleIdentificationNumber: String\n    $vehicleColour: String\n    $invoiceNumber: String\n    $idlingSpeed: Int\n    $equipmentSerialNumber: String\n    $equipmentName: String\n    $commissioningDate: Int\n    $invoiceDate: Int\n    $department: String\n    $contractorName: String\n    $operatorName: String\n    $operatorContactNumber: String\n    $engineTorque: String\n    $engineLoad: String\n    $fuelType: String\n    $torquePower: String\n    $engineSpecification: String\n    $emissionRateType: String\n    $vehicleMakeId: String\n    $vehicleModelId: String\n    $grossVehicleWeight: Float\n    $manufacturingYear: Int\n    $vehicleSegment: String\n    $equipmentTypeClass: String\n    $constructionVehicleType: String\n    $passengerVehicleType: String\n    $transportationVehicleType: String\n    $vehicleNickName: String\n    $haulageType: String\n    $vehicleWheeler: String\n    $application: String\n    $documentUpload: String\n    $documentUploadNew: JSON\n    $baselineDataForFE: Float\n    $baselineDataType: String\n    $baselineDataHour: Float\n    $baselineDataForFELPH: Float\n    $fuelTankCapacity: String\n    $noOfGears: Int\n    $gearRatio: String\n    $adblueCapacity: String\n    $vehicleRegistrationNumber: String\n    $registrationDate: String\n    $registrationValidUpto: String\n    $stateCode: String\n    $rtoCode: String\n    $vehicleCategoryCode: String\n    $vehicleCategoryDescription: String\n    $vehicleClassDescription: String\n    $makerDescription: String\n    $makerModel: String\n    $bodyTypeDescription: String\n    $emissionNormsDescription: String\n    $fitmentUpto: String\n    $nationalPermitUpto: String\n    $taxUpto: String\n    $insurerName: String\n    $insuranceUpto: String\n    $manufacturingMonthYear: String\n    $unladenWeight: Int\n    $registeredAt: String\n    $puccUpto: String\n    $permitNumber: String\n    $permitIssueDate: String\n    $permitValidFrom: String\n    $permitValidUpto: String\n    $permitType: String\n    $permitCode: String\n    $numberOfAxles: Int\n    $fuelCode: String\n    $vehicleClass: String\n    $baselineDistance: Float\n    $immobilize: Boolean\n    $solutionType: String\n    $solution_type: [String]\n    $isDualEngine: Boolean\n    $eoff_voltage: Float\n    $eon_voltage: Float\n    $zonalManager: String\n    $keyAccountManager: String\n    $channelPartnerName: String\n    $duplicateVehicle: Boolean\n    $portedVehicle: Boolean\n    $isTestingVehicle: Boolean\n    $hasArm: Boolean\n    $isElockConnection: Boolean\n    $kvaRating: String\n    $dgSetType: String\n    $bhp: String\n    $phase: String\n    $engineModel: String\n    $gensetController: String\n    $videoTelematicsType: String\n    $videoTelematicsId: String\n    $inputParameter: Float\n    $multiplicationFactor: Float\n    $engineOnHours: String\n    $odometerDistance: String\n    $clientName: String!\n    $custCode: String\n    $custType: String\n    $noOfWheels: Int\n    $baselineHours: Int\n    $isIndividualViewOrCombinedView: Boolean\n    $vehicleCustomizedBodyType: String\n    $tensionerConductorLength: Float\n    $tensionerRotationSensorDirection: String\n    $isRotationSensor: Boolean\n    $technicianName: String\n    $createdBy: String\n    $istachoenabled: Boolean\n    $tachoidlerpm: Int\n    $tachoshifthours: Int\n    $tachoengineonmin: Int\n    $tachoengineonmax: Int\n  ) {\n    addVehicleDetail(\n      rcsSerialNumber: $rcsSerialNumber\n      vehicleNumber: $vehicleNumber\n      engineNumber: $engineNumber\n      chassisNumber: $chassisNumber\n      clientLoginId: $clientLoginId\n      uniqueDeviceId: $uniqueDeviceId\n      simId: $simId\n      speedSensorType: $speedSensorType\n      speedLimit: $speedLimit\n      uniqueAccessoryId: $uniqueAccessoryId\n      vehicleType: $vehicleType\n      vehicleMake: $vehicleMake\n      averageMileage: $averageMileage\n      vehicleModel: $vehicleModel\n      vehicleCapacity: $vehicleCapacity\n      isActivated: $isActivated\n      partnerSubscriptionId: $partnerSubscriptionId\n      accountType: $accountType\n      vehicleIdentificationNumber: $vehicleIdentificationNumber\n      vehicleColour: $vehicleColour\n      invoiceNumber: $invoiceNumber\n      idlingSpeed: $idlingSpeed\n      equipmentSerialNumber: $equipmentSerialNumber\n      equipmentName: $equipmentName\n      commissioningDate: $commissioningDate\n      invoiceDate: $invoiceDate\n      department: $department\n      contractorName: $contractorName\n      operatorName: $operatorName\n      operatorContactNumber: $operatorContactNumber\n      engineTorque: $engineTorque\n      engineLoad: $engineLoad\n      fuelType: $fuelType\n      torquePower: $torquePower\n      engineSpecification: $engineSpecification\n      emissionRateType: $emissionRateType\n      vehicleMakeId: $vehicleMakeId\n      vehicleModelId: $vehicleModelId\n      grossVehicleWeight: $grossVehicleWeight\n      manufacturingYear: $manufacturingYear\n      vehicleSegment: $vehicleSegment\n      equipmentTypeClass: $equipmentTypeClass\n      constructionVehicleType: $constructionVehicleType\n      passengerVehicleType: $passengerVehicleType\n      transportationVehicleType: $transportationVehicleType\n      vehicleNickName: $vehicleNickName\n      haulageType: $haulageType\n      vehicleWheeler: $vehicleWheeler\n      application: $application\n      documentUpload: $documentUpload\n      documentUploadNew: $documentUploadNew\n      baselineDataForFE: $baselineDataForFE\n      baselineDataType: $baselineDataType\n      baselineDataHour: $baselineDataHour\n      baselineDataForFELPH: $baselineDataForFELPH\n      fuelTankCapacity: $fuelTankCapacity\n      noOfGears: $noOfGears\n      gearRatio: $gearRatio\n      adblueCapacity: $adblueCapacity\n\n      vehicleRegistrationNumber: $vehicleRegistrationNumber\n      registrationDate: $registrationDate\n      registrationValidUpto: $registrationValidUpto\n      stateCode: $stateCode\n      rtoCode: $rtoCode\n      vehicleCategoryCode: $vehicleCategoryCode\n      vehicleCategoryDescription: $vehicleCategoryDescription\n      vehicleClassDescription: $vehicleClassDescription\n      makerDescription: $makerDescription\n      makerModel: $makerModel\n      bodyTypeDescription: $bodyTypeDescription\n      emissionNormsDescription: $emissionNormsDescription\n      fitmentUpto: $fitmentUpto\n      nationalPermitUpto: $nationalPermitUpto\n      taxUpto: $taxUpto\n      insurerName: $insurerName\n      insuranceUpto: $insuranceUpto\n      manufacturingMonthYear: $manufacturingMonthYear\n      unladenWeight: $unladenWeight\n      registeredAt: $registeredAt\n      puccUpto: $puccUpto\n      permitNumber: $permitNumber\n      permitIssueDate: $permitIssueDate\n      permitValidFrom: $permitValidFrom\n      permitValidUpto: $permitValidUpto\n      permitType: $permitType\n      permitCode: $permitCode\n      numberOfAxles: $numberOfAxles\n      fuelCode: $fuelCode\n      vehicleClass: $vehicleClass\n\n      baselineDistance: $baselineDistance\n      immobilize: $immobilize\n      solutionType: $solutionType\n      solution_type: $solution_type\n      isDualEngine: $isDualEngine\n      eoff_voltage: $eoff_voltage\n      eon_voltage: $eon_voltage\n      zonalManager: $zonalManager\n      keyAccountManager: $keyAccountManager\n      channelPartnerName: $channelPartnerName\n      duplicateVehicle: $duplicateVehicle\n      portedVehicle: $portedVehicle\n      isTestingVehicle: $isTestingVehicle\n      hasArm: $hasArm\n      isElockConnection: $isElockConnection\n      kvaRating: $kvaRating\n      dgSetType: $dgSetType\n      bhp: $bhp\n      phase: $phase\n      engineModel: $engineModel\n      gensetController: $gensetController\n      videoTelematicsType: $videoTelematicsType\n      videoTelematicsId: $videoTelematicsId\n      inputParameter: $inputParameter\n      multiplicationFactor: $multiplicationFactor\n\n      engineOnHours: $engineOnHours\n      odometerDistance: $odometerDistance\n\n      technicianName: $technicianName\n      createdBy: $createdBy\n\n      clientName: $clientName\n      custCode: $custCode\n      custType: $custType\n      noOfWheels: $noOfWheels\n      baselineHours: $baselineHours\n      isIndividualViewOrCombinedView: $isIndividualViewOrCombinedView\n      vehicleCustomizedBodyType: $vehicleCustomizedBodyType\n      tensionerConductorLength: $tensionerConductorLength\n      tensionerRotationSensorDirection: $tensionerRotationSensorDirection\n      isRotationSensor: $isRotationSensor\n      istachoenabled: $istachoenabled\n      tachoidlerpm: $tachoidlerpm\n      tachoengineonmin: $tachoengineonmin\n      tachoengineonmax: $tachoengineonmax\n      tachoshifthours: $tachoshifthours\n    )\n  }\n']),_templateObject16=_taggedTemplateLiteral(['\n  query clientDetail($clientId: Int!) {\n    clientDetail(loginId: $clientId) {\n      clientName\n      id\n      address\n      city\n      zonalManager\n      keyAccountManager\n      channelPartnerName\n    }\n  }\n'],['\n  query clientDetail($clientId: Int!) {\n    clientDetail(loginId: $clientId) {\n      clientName\n      id\n      address\n      city\n      zonalManager\n      keyAccountManager\n      channelPartnerName\n    }\n  }\n']),_templateObject17=_taggedTemplateLiteral(['\n  query checkEngineNumber($engineNumber: String!) {\n    checkEngineNumber(engineNumber: $engineNumber)\n  }\n'],['\n  query checkEngineNumber($engineNumber: String!) {\n    checkEngineNumber(engineNumber: $engineNumber)\n  }\n']),_templateObject18=_taggedTemplateLiteral(['\n  query checkChassisNumber($chassisNumber: String!) {\n    checkChassisNumber(chassisNumber: $chassisNumber)\n  }\n'],['\n  query checkChassisNumber($chassisNumber: String!) {\n    checkChassisNumber(chassisNumber: $chassisNumber)\n  }\n']),_templateObject19=_taggedTemplateLiteral(['\n  query getAllPartnerSubscriptions(\n    $partnerId: Int\n    $deviceModelId: Int\n    $status: [Int]\n  ) {\n    getAllPartnerSubscriptions(\n      partnerLoginId: $partnerId\n      deviceModelId: $deviceModelId\n      status: $status\n    ) {\n      id\n      deviceTrackingCharges\n      totalSoftwareQty\n    }\n  }\n'],['\n  query getAllPartnerSubscriptions(\n    $partnerId: Int\n    $deviceModelId: Int\n    $status: [Int]\n  ) {\n    getAllPartnerSubscriptions(\n      partnerLoginId: $partnerId\n      deviceModelId: $deviceModelId\n      status: $status\n    ) {\n      id\n      deviceTrackingCharges\n      totalSoftwareQty\n    }\n  }\n']),_templateObject20=_taggedTemplateLiteral(['\n  query {\n    getMakeAndModelMasterData {\n      vehicleMake\n      vehicleModel\n      emissionRateType\n    }\n  }\n'],['\n  query {\n    getMakeAndModelMasterData {\n      vehicleMake\n      vehicleModel\n      emissionRateType\n    }\n  }\n']),_templateObject21=_taggedTemplateLiteral(['\n  query {\n    getVehicleMakes {\n      make\n      id\n    }\n  }\n'],['\n  query {\n    getVehicleMakes {\n      make\n      id\n    }\n  }\n']),_templateObject22=_taggedTemplateLiteral(['\n  query GetDgMakes {\n    getDgMakes\n  }\n'],['\n  query GetDgMakes {\n    getDgMakes\n  }\n']),_templateObject23=_taggedTemplateLiteral(['\n  query GetDgModels($make: String!) {\n    getDgModels(make: $make)\n  }\n'],['\n  query GetDgModels($make: String!) {\n    getDgModels(make: $make)\n  }\n']),_templateObject24=_taggedTemplateLiteral(['\n  query GetDgSpecsFromModel($make: String!, $model: String!) {\n    getDgspecsFromModel(make: $make, model: $model) {\n      id\n      make\n      model\n      kvaRating\n      dgSetType\n    }\n  }\n'],['\n  query GetDgSpecsFromModel($make: String!, $model: String!) {\n    getDgspecsFromModel(make: $make, model: $model) {\n      id\n      make\n      model\n      kvaRating\n      dgSetType\n    }\n  }\n']),_templateObject25=_taggedTemplateLiteral(['\n  query getAllVehicleType {\n    getAllVehicleType {\n      vehicleTypeId\n      vehicleType\n    }\n  }\n'],['\n  query getAllVehicleType {\n    getAllVehicleType {\n      vehicleTypeId\n      vehicleType\n    }\n  }\n']),_templateObject26=_taggedTemplateLiteral(['\n  query GetVehicleModels($makeId: String!) {\n    getVehicleModels(makeId: $makeId) {\n      id\n      model\n    }\n  }\n'],['\n  query GetVehicleModels($makeId: String!) {\n    getVehicleModels(makeId: $makeId) {\n      id\n      model\n    }\n  }\n']),_templateObject27=_taggedTemplateLiteral(['\n  query GetVehicleParameters($modelId: String!) {\n    getVehicleParameters(modelId: $modelId) {\n      id\n      emission_type\n      status\n      model_id\n      fuel_capacity\n      adblue_capacity\n      manufacturing_year\n      fuel_type\n      gross_vehicle_weight\n      engine_specification\n    }\n  }\n'],['\n  query GetVehicleParameters($modelId: String!) {\n    getVehicleParameters(modelId: $modelId) {\n      id\n      emission_type\n      status\n      model_id\n      fuel_capacity\n      adblue_capacity\n      manufacturing_year\n      fuel_type\n      gross_vehicle_weight\n      engine_specification\n    }\n  }\n']),_templateObject28=_taggedTemplateLiteral(['\n  query GetVehicleVahaanDetails($vehicleNumber: String!) {\n    getVehicleVahaanDetails(vehicleNumber: $vehicleNumber) {\n      id\n      rcRegnNo\n      rcRegnDt\n      rcRegnUpto\n      rcPurchaseDt\n      rcOwnerSr\n      rcOwnerName\n      stateCd\n      rtoCd\n      rcPresentAddress\n      rcPermanentAddress\n      rcVchCatg\n      rcVhClassDesc\n      rcChasiNo\n      rcEngNo\n      rcMakerDesc\n      rcMakerModel\n      rcBodyTypeDesc\n      rcFuelDesc\n      rcColor\n      rcNormsDesc\n      rcFitUpto\n      rcNpUpto\n      rcNpIssuedBy\n      rcTaxUpto\n      rcFinancer\n      rcInsuranceComp\n      rcInsurancePolicyNo\n      rcInsuranceUpto\n      rcManuMonthYr\n      rcUnldWt\n      rcGvw\n      rcNoCyl\n      rcCubicCap\n      rcSeatCap\n      rcSleeperCap\n      rcStandCap\n      rcWheelbase\n      rcRegisteredAt\n      rcStatusAsOn\n      rcPuccUpto\n      rcPuccNo\n      rcStatus\n      rcNcrbStatus\n      rcBlacklistStatus\n      rcPermitNo\n      rcPermitIssueDt\n      rcPermitValidFrom\n      rcPermitValidUpto\n      rcPermitType\n      rcPermitCode\n      rcNocDetails\n      rcVhType\n      rcVhClass\n      rcNocDt\n      rcFuelCd\n      rcMakerCd\n      rcModelCd\n      rcNormsCd\n      rcSaleAmt\n      rcOwnCatgDesc\n      rcVhClassDesc\n      rcOwnerCdDesc\n      rcCurrentaddDistrictcode\n      rcNonUse\n      rcPassengerTax\n      rcGoodsTax\n      rcNoOfAxle\n      rcApprovalDate\n      rcHp\n      rcMandalDesc\n      rcTalukCd\n    }\n  }\n'],['\n  query GetVehicleVahaanDetails($vehicleNumber: String!) {\n    getVehicleVahaanDetails(vehicleNumber: $vehicleNumber) {\n      id\n      rcRegnNo\n      rcRegnDt\n      rcRegnUpto\n      rcPurchaseDt\n      rcOwnerSr\n      rcOwnerName\n      stateCd\n      rtoCd\n      rcPresentAddress\n      rcPermanentAddress\n      rcVchCatg\n      rcVhClassDesc\n      rcChasiNo\n      rcEngNo\n      rcMakerDesc\n      rcMakerModel\n      rcBodyTypeDesc\n      rcFuelDesc\n      rcColor\n      rcNormsDesc\n      rcFitUpto\n      rcNpUpto\n      rcNpIssuedBy\n      rcTaxUpto\n      rcFinancer\n      rcInsuranceComp\n      rcInsurancePolicyNo\n      rcInsuranceUpto\n      rcManuMonthYr\n      rcUnldWt\n      rcGvw\n      rcNoCyl\n      rcCubicCap\n      rcSeatCap\n      rcSleeperCap\n      rcStandCap\n      rcWheelbase\n      rcRegisteredAt\n      rcStatusAsOn\n      rcPuccUpto\n      rcPuccNo\n      rcStatus\n      rcNcrbStatus\n      rcBlacklistStatus\n      rcPermitNo\n      rcPermitIssueDt\n      rcPermitValidFrom\n      rcPermitValidUpto\n      rcPermitType\n      rcPermitCode\n      rcNocDetails\n      rcVhType\n      rcVhClass\n      rcNocDt\n      rcFuelCd\n      rcMakerCd\n      rcModelCd\n      rcNormsCd\n      rcSaleAmt\n      rcOwnCatgDesc\n      rcVhClassDesc\n      rcOwnerCdDesc\n      rcCurrentaddDistrictcode\n      rcNonUse\n      rcPassengerTax\n      rcGoodsTax\n      rcNoOfAxle\n      rcApprovalDate\n      rcHp\n      rcMandalDesc\n      rcTalukCd\n    }\n  }\n']),_templateObject29=_taggedTemplateLiteral(['\n  query Query {\n    getDropDownDetail\n  }\n'],['\n  query Query {\n    getDropDownDetail\n  }\n']),_templateObject30=_taggedTemplateLiteral(['\n  query GetDropdownCategories {\n    getDropdownCategories {\n      category_name\n      id\n    }\n  }\n'],['\n  query GetDropdownCategories {\n    getDropdownCategories {\n      category_name\n      id\n    }\n  }\n']),_templateObject31=_taggedTemplateLiteral(['\n  query GetDropdownValuesByCategory($categoryId: ID) {\n    getDropdownValuesByCategory(category_id: $categoryId) {\n      value_name\n    }\n  }\n'],['\n  query GetDropdownValuesByCategory($categoryId: ID) {\n    getDropdownValuesByCategory(category_id: $categoryId) {\n      value_name\n    }\n  }\n']),_templateObject32=_taggedTemplateLiteral(['\n  query GetCustomerTypeAndCode($clientName: String!) {\n    getCustomerTypeAndCode(clientName: $clientName) {\n      id\n      clientName\n      registrationType\n      directCustomerSAPCode\n      channelPartnerSAPCode\n    }\n  }\n'],['\n  query GetCustomerTypeAndCode($clientName: String!) {\n    getCustomerTypeAndCode(clientName: $clientName) {\n      id\n      clientName\n      registrationType\n      directCustomerSAPCode\n      channelPartnerSAPCode\n    }\n  }\n']),_templateObject33=_taggedTemplateLiteral(['\n  query getAllVehicleDetails($clientLoginId: Int) {\n    getAllVehicleDetails(clientLoginId: $clientLoginId) {\n      entityId\n      vehicleNumber\n      deviceDetail {\n        uniqueDeviceId\n      }\n    }\n  }\n'],['\n  query getAllVehicleDetails($clientLoginId: Int) {\n    getAllVehicleDetails(clientLoginId: $clientLoginId) {\n      entityId\n      vehicleNumber\n      deviceDetail {\n        uniqueDeviceId\n      }\n    }\n  }\n']),_templateObject34=_taggedTemplateLiteral(['\n  query getFuelCalibrationDetail($entityId: Int) {\n    getFuelCalibrationDetail(vehicleId: $entityId) {\n      fuelUserType\n      fuelSensorType\n      minTankCapacity\n      minValue\n      maxTankCapacity\n      totalFuelTank\n      maxValue\n      pilferageTolerance\n      calibration_filename\n      url\n      availableDataTypes\n      preferedDataType\n      hasSecondaryTank\n      hasInSameTank\n      isDualSensor\n      useTaabiAlgo\n      secondaryTankMinCapacity\n      secondaryTankMaxCapacity\n      secondaryTankTotalFuel\n      secondaryTankMinValue\n      secondaryTankMaxValue\n      secondaryPolynomialEquation\n      secondary_tank_calibration_filename\n      secondaryUrl\n      fuelSensorNames\n      fuelSensorIMEIs\n    }\n  }\n'],['\n  query getFuelCalibrationDetail($entityId: Int) {\n    getFuelCalibrationDetail(vehicleId: $entityId) {\n      fuelUserType\n      fuelSensorType\n      minTankCapacity\n      minValue\n      maxTankCapacity\n      totalFuelTank\n      maxValue\n      pilferageTolerance\n      calibration_filename\n      url\n      availableDataTypes\n      preferedDataType\n      hasSecondaryTank\n      hasInSameTank\n      isDualSensor\n      useTaabiAlgo\n      secondaryTankMinCapacity\n      secondaryTankMaxCapacity\n      secondaryTankTotalFuel\n      secondaryTankMinValue\n      secondaryTankMaxValue\n      secondaryPolynomialEquation\n      secondary_tank_calibration_filename\n      secondaryUrl\n      fuelSensorNames\n      fuelSensorIMEIs\n    }\n  }\n']),_templateObject35=_taggedTemplateLiteral(['\n  query clientDetail($loginId: Int) {\n    clientDetail(loginId: $loginId) {\n      id\n      zone\n      keyAccountManager\n      litemode\n      videoTelematicsType\n      plan {\n        id\n        planName\n      }\n    }\n  }\n'],['\n  query clientDetail($loginId: Int) {\n    clientDetail(loginId: $loginId) {\n      id\n      zone\n      keyAccountManager\n      litemode\n      videoTelematicsType\n      plan {\n        id\n        planName\n      }\n    }\n  }\n']),_templateObject36=_taggedTemplateLiteral(['\n  mutation confirmVehicleRegistration($input: onboardingVehicleInput!) {\n    confirmVehicleRegistration(input: $input) {\n      success\n      message\n      vehicleId\n    }\n  }\n'],['\n  mutation confirmVehicleRegistration($input: onboardingVehicleInput!) {\n    confirmVehicleRegistration(input: $input) {\n      success\n      message\n      vehicleId\n    }\n  }\n']),_templateObject37=_taggedTemplateLiteral(['\n  query GetAllMasterSolutionType {\n    getAllMasterSolutionType {\n      id\n      solutionTypeName\n    }\n  }\n'],['\n  query GetAllMasterSolutionType {\n    getAllMasterSolutionType {\n      id\n      solutionTypeName\n    }\n  }\n']),_templateObject38=_taggedTemplateLiteral(['\n  query GetAllSolutionTypes($clientCategory: ClientCategory, $clientLoginId: Int) {\n    getAllSolutionTypes(\n      clientCategory: $clientCategory\n      clientLoginId: $clientLoginId\n    ) {\n      id\n      solution_type_name\n      description\n      solutionTypeCategory\n      createdAt\n      plans {\n        id\n        planName\n        planTypeId\n        durationInYears\n        durationInMonths\n        durationLabel\n        description\n        createdAt\n        updatedAt\n        status\n        createdBy\n        updatedBy\n        clientLoginId\n        basePrice\n        discount\n        clientCategory\n        perMonthBaseValue\n        perMonthDiscountedValue\n        clientName\n        isPopular\n      }\n    }\n  }\n'],['\n  query GetAllSolutionTypes($clientCategory: ClientCategory, $clientLoginId: Int) {\n    getAllSolutionTypes(\n      clientCategory: $clientCategory\n      clientLoginId: $clientLoginId\n    ) {\n      id\n      solution_type_name\n      description\n      solutionTypeCategory\n      createdAt\n      plans {\n        id\n        planName\n        planTypeId\n        durationInYears\n        durationInMonths\n        durationLabel\n        description\n        createdAt\n        updatedAt\n        status\n        createdBy\n        updatedBy\n        clientLoginId\n        basePrice\n        discount\n        clientCategory\n        perMonthBaseValue\n        perMonthDiscountedValue\n        clientName\n        isPopular\n      }\n    }\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_FILE_FORMAT=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject);var GET_UPLOAD_URL=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject2);var GET_DEVICE_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject3);var GET_CLIENTS=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject4);var GET_VLPN=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject5);var GET_SELECT_DEV_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject6);var GET_SIM_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject7);var GET_ACCESSORY_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject8);var GET_SELECT_PHONE_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject9);var GET_ZMKAM=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject10);var GET_DASHCAM_REGISTRATIONS=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject11);var GET_ALL_ASSIGNED_ROLES=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject12);var GET_RCS_INVENTORY=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject13);var UPDATE_RCS_INVENTORY=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject14);var ADD_VEHICLE=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject15);var GET_CLIENT_DETAILS_BYID=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject16);var CHECK_ENGINE_NUMBER=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject17);var CHECK_CHASSIS_NUMBER=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject18);var GET_SUBSCRIPTION_BY_PARTNERID=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject19);var GET_MAKE_AND_MODELS_MASTER=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject20);var GET_VEHICLE_MAKES=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject21);var GET_ALL_DG_MAKES=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject22);var GET_DG_MODELS=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject23);var GET_DG_SPECS_FROM_MODEL=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject24);var GET_VEHICLE_TYPE=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject25);var GET_VEHICLE_MODELS=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject26);var GET_VEHICLE_PARAMS=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject27);var GET_VEHICLE_VAHAAN_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject28);var GET_DROPDOWN_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject29);var GET_DROPDOWN_CATEGORIES=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject30);var GET_DROPDOWN_VALUES_BY_CATEGORY=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject31);var GET_CUSTOMER_TYPE_AND_CODE=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject32);var GET_ALL_VEHICLES=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject33);var GET_CALIBRATION_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject34);var GET_CLIENT_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject35);var CONFIRM_VEHICLE_REGISTRATION=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject36);var GET_SOLUTION_TYPES=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject37);var GET_SOLUTION_TYPES_WITH_PLANS=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject38);

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_NoSsr__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_NoSsr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_NoSsr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Chip__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Chip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Chip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles_colorManipulator__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles_colorManipulator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles_colorManipulator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_graphql_tag__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query {\n    allCountries {\n      country_id\n      name\n    }\n  }\n'],['\n  query {\n    allCountries {\n      country_id\n      name\n    }\n  }\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_COUNTRIES=Object(__WEBPACK_IMPORTED_MODULE_12_graphql_tag__["a" /* default */])(_templateObject);var styles=function styles(theme){return{root:{flexGrow:1},input:{display:'flex',padding:0},valueContainer:{display:'flex',flex:1,alignItems:'center'},chip:{margin:theme.spacing.unit/2+'px '+theme.spacing.unit/4+'px'},chipFocused:{backgroundColor:Object(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles_colorManipulator__["emphasize"])(theme.palette.type==='light'?theme.palette.grey[300]:theme.palette.grey[700],0.08)},noOptionsMessage:{fontSize:16,padding:theme.spacing.unit+'px '+theme.spacing.unit*2+'px'},singleValue:{fontSize:16},placeholder:{position:'absolute',left:2,fontSize:16}};};function NoOptionsMessage(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,Object.assign({color:'textSecondary',className:props.selectProps.classes.noOptionsMessage},props.innerProps),props.children);}function inputComponent(_ref){var inputRef=_ref.inputRef,props=_objectWithoutProperties(_ref,['inputRef']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({ref:inputRef},props));}function Control(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a,{fullWidth:true,InputProps:{inputComponent:inputComponent,inputProps:Object.assign({className:props.selectProps.classes.input,ref:props.innerRef,children:props.children},props.innerProps)}});}function Option(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default.a,Object.assign({buttonRef:props.innerRef,selected:props.isFocused,component:'div',style:{fontWeight:props.isSelected?500:400}},props.innerProps),props.children);}function Placeholder(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,Object.assign({color:'textSecondary',className:props.selectProps.classes.placeholder},props.innerProps),props.children);}function SingleValue(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,Object.assign({className:props.selectProps.classes.singleValue},props.innerProps),props.children);}function ValueContainer(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:props.selectProps.classes.valueContainer},props.children);}function MultiValue(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Chip___default.a,{tabIndex:-1,label:props.children,className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(props.selectProps.classes.chip,_defineProperty({},props.selectProps.classes.chipFocused,props.isFocused)),onDelete:function onDelete(event){props.removeProps.onClick();props.removeProps.onMouseDown(event);}});}var components={Option:Option,Control:Control,NoOptionsMessage:NoOptionsMessage,Placeholder:Placeholder,SingleValue:SingleValue,MultiValue:MultiValue,ValueContainer:ValueContainer};var Countries=function(_React$Component){_inherits(Countries,_React$Component);function Countries(){_classCallCheck(this,Countries);return _possibleConstructorReturn(this,(Countries.__proto__||Object.getPrototypeOf(Countries)).apply(this,arguments));}_createClass(Countries,[{key:'render',value:function render(){var _this2=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["Query"],{query:GET_COUNTRIES},function(_ref2){var loading=_ref2.loading,error=_ref2.error,allCountries=_ref2.data.allCountries;if(loading)return'Loading...';if(error)return'Error!: '+error;var sortedCountries=allCountries.map(function(country){return{value:country.country_id,label:country.name};});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_NoSsr___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */]// classes={classes}
,{options:sortedCountries// components={components}
,value:_this2.props.countryId,onChange:_this2.props.handleCountryChange,placeholder:'Select Country *'})));});}}]);return Countries;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Countries.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__["withStyles"])(styles)(Countries));

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var data = __webpack_require__(1112);

module.exports = {
  getTimezones: function () {
    return Object.keys(data.zones);
  },

  getCountriesAbbr: function () {
    return Object.keys(data.countries);
  },

  getCountries: function () {
    var countryNames = [];
    for(var el in data.countries)
      countryNames.push(data.countries[el].name);
    return countryNames;
  },

  getZoneByCountry: function (country) {
    for(var el in data.countries)
      if(data.countries[el].name === country)
        return data.countries[el].zones;
    return [];
  }
};

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__ = __webpack_require__(452);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Prompt__ = __webpack_require__(454);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redirect__ = __webpack_require__(455);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(298);
/* unused harmony reexport Route */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(219);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StaticRouter__ = __webpack_require__(456);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch__ = __webpack_require__(457);
/* unused harmony reexport Switch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__generatePath__ = __webpack_require__(300);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__matchPath__ = __webpack_require__(220);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__withRouter__ = __webpack_require__(458);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_9__withRouter__["a"]; });





















/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
})), 'Mail');

exports.default = _default;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 3H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zM8 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1zm3.85-4h1.64L21 16l-1.99 1.99c-1.31-.98-2.28-2.38-2.73-3.99-.18-.64-.28-1.31-.28-2s.1-1.36.28-2c.45-1.62 1.42-3.01 2.73-3.99L21 8l-1.51 2h-1.64c-.22.63-.35 1.3-.35 2s.13 1.37.35 2z"
})), 'ContactPhone');

exports.default = _default;

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return epsilon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return epsilon2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return beaches; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return cells; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return circles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return edges; });
/* harmony export (immutable) */ __webpack_exports__["d"] = Diagram;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Beach__ = __webpack_require__(2090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Cell__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Circle__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Edge__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RedBlackTree__ = __webpack_require__(337);






var epsilon = 1e-6;
var epsilon2 = 1e-12;
var beaches;
var cells;
var circles;
var edges;

function triangleArea(a, b, c) {
  return (a[0] - c[0]) * (b[1] - a[1]) - (a[0] - b[0]) * (c[1] - a[1]);
}

function lexicographic(a, b) {
  return b[1] - a[1]
      || b[0] - a[0];
}

function Diagram(sites, extent) {
  var site = sites.sort(lexicographic).pop(),
      x,
      y,
      circle;

  edges = [];
  cells = new Array(sites.length);
  beaches = new __WEBPACK_IMPORTED_MODULE_4__RedBlackTree__["b" /* default */];
  circles = new __WEBPACK_IMPORTED_MODULE_4__RedBlackTree__["b" /* default */];

  while (true) {
    circle = __WEBPACK_IMPORTED_MODULE_2__Circle__["c" /* firstCircle */];
    if (site && (!circle || site[1] < circle.y || (site[1] === circle.y && site[0] < circle.x))) {
      if (site[0] !== x || site[1] !== y) {
        Object(__WEBPACK_IMPORTED_MODULE_0__Beach__["a" /* addBeach */])(site);
        x = site[0], y = site[1];
      }
      site = sites.pop();
    } else if (circle) {
      Object(__WEBPACK_IMPORTED_MODULE_0__Beach__["b" /* removeBeach */])(circle.arc);
    } else {
      break;
    }
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__Cell__["d" /* sortCellHalfedges */])();

  if (extent) {
    var x0 = +extent[0][0],
        y0 = +extent[0][1],
        x1 = +extent[1][0],
        y1 = +extent[1][1];
    Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["a" /* clipEdges */])(x0, y0, x1, y1);
    Object(__WEBPACK_IMPORTED_MODULE_1__Cell__["b" /* clipCells */])(x0, y0, x1, y1);
  }

  this.edges = edges;
  this.cells = cells;

  beaches =
  circles =
  edges =
  cells = null;
}

Diagram.prototype = {
  constructor: Diagram,

  polygons: function() {
    var edges = this.edges;

    return this.cells.map(function(cell) {
      var polygon = cell.halfedges.map(function(i) { return Object(__WEBPACK_IMPORTED_MODULE_1__Cell__["a" /* cellHalfedgeStart */])(cell, edges[i]); });
      polygon.data = cell.site.data;
      return polygon;
    });
  },

  triangles: function() {
    var triangles = [],
        edges = this.edges;

    this.cells.forEach(function(cell, i) {
      if (!(m = (halfedges = cell.halfedges).length)) return;
      var site = cell.site,
          halfedges,
          j = -1,
          m,
          s0,
          e1 = edges[halfedges[m - 1]],
          s1 = e1.left === site ? e1.right : e1.left;

      while (++j < m) {
        s0 = s1;
        e1 = edges[halfedges[j]];
        s1 = e1.left === site ? e1.right : e1.left;
        if (s0 && s1 && i < s0.index && i < s1.index && triangleArea(site, s0, s1) < 0) {
          triangles.push([site.data, s0.data, s1.data]);
        }
      }
    });

    return triangles;
  },

  links: function() {
    return this.edges.filter(function(edge) {
      return edge.right;
    }).map(function(edge) {
      return {
        source: edge.left.data,
        target: edge.right.data
      };
    });
  },

  find: function(x, y, radius) {
    var that = this, i0, i1 = that._found || 0, n = that.cells.length, cell;

    // Use the previously-found cell, or start with an arbitrary one.
    while (!(cell = that.cells[i1])) if (++i1 >= n) return null;
    var dx = x - cell.site[0], dy = y - cell.site[1], d2 = dx * dx + dy * dy;

    // Traverse the half-edges to find a closer cell, if any.
    do {
      cell = that.cells[i0 = i1], i1 = null;
      cell.halfedges.forEach(function(e) {
        var edge = that.edges[e], v = edge.left;
        if ((v === cell.site || !v) && !(v = edge.right)) return;
        var vx = x - v[0], vy = y - v[1], v2 = vx * vx + vy * vy;
        if (v2 < d2) d2 = v2, i1 = v.index;
      });
    } while (i1 !== null);

    that._found = i0;

    return radius == null || d2 <= radius * radius ? cell.site : null;
  }
}


/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x === null ? NaN : +x;
});


/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = linearish;
/* harmony export (immutable) */ __webpack_exports__["a"] = linear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__continuous__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tickFormat__ = __webpack_require__(2137);





function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function(count) {
    var d = domain();
    return Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["n" /* ticks */])(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function(count, specifier) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__tickFormat__["a" /* default */])(domain(), count, specifier);
  };

  scale.nice = function(count) {
    if (count == null) count = 10;

    var d = domain(),
        i0 = 0,
        i1 = d.length - 1,
        start = d[i0],
        stop = d[i1],
        step;

    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }

    step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["l" /* tickIncrement */])(start, stop, count);

    if (step > 0) {
      start = Math.floor(start / step) * step;
      stop = Math.ceil(stop / step) * step;
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["l" /* tickIncrement */])(start, stop, count);
    } else if (step < 0) {
      start = Math.ceil(start * step) / step;
      stop = Math.floor(stop * step) / step;
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["l" /* tickIncrement */])(start, stop, count);
    }

    if (step > 0) {
      d[i0] = Math.floor(start / step) * step;
      d[i1] = Math.ceil(stop / step) * step;
      domain(d);
    } else if (step < 0) {
      d[i0] = Math.ceil(start * step) / step;
      d[i1] = Math.floor(stop * step) / step;
      domain(d);
    }

    return scale;
  };

  return scale;
}

function linear() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["b" /* default */])(__WEBPACK_IMPORTED_MODULE_2__continuous__["c" /* deinterpolateLinear */], __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["c" /* interpolateNumber */]);

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["a" /* copy */])(scale, linear());
  };

  return linearish(scale);
}


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultLocale_js__ = __webpack_require__(2138);
/* unused harmony reexport formatDefaultLocale */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__defaultLocale_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__defaultLocale_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locale_js__ = __webpack_require__(577);
/* unused harmony reexport formatLocale */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatSpecifier_js__ = __webpack_require__(578);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__formatSpecifier_js__["a"]; });
/* unused harmony reexport FormatSpecifier */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__precisionFixed_js__ = __webpack_require__(2145);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__precisionFixed_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__precisionPrefix_js__ = __webpack_require__(2146);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__precisionPrefix_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__precisionRound_js__ = __webpack_require__(2147);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__precisionRound_js__["a"]; });








/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(s) {
  return s.match(/.{6}/g).map(function(x) {
    return "#" + x;
  });
});


/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export isReactDOMSupported */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDOMNode; });
/* harmony export (immutable) */ __webpack_exports__["b"] = warning;
/* unused harmony export warnOnce */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.



var _React$version$split = __WEBPACK_IMPORTED_MODULE_0_react___default.a.version.split('.'),
    _React$version$split2 = _slicedToArray(_React$version$split, 2),
    major = _React$version$split2[0],
    minor = _React$version$split2[1];

var versionHigherThanThirteen = Number(minor) > 13 || Number(major) > 13;

var isReactDOMSupported = function isReactDOMSupported() {
  return versionHigherThanThirteen;
};

/**
 * Support React 0.13 and greater where refs are React components, not DOM
 * nodes.
 * @param {*} ref React's ref.
 * @returns {Element} DOM element.
 */
var getDOMNode = function getDOMNode(ref) {
  if (!isReactDOMSupported()) {
    return ref && ref.getDOMNode();
  }
  return ref;
};

var USED_MESSAGES = {};
var HIDDEN_PROCESSES = {
  test: true,
  production: true
};

/**
 * Warn the user about something
 * @param {String} message - the message to be shown
 * @param {Boolean} onlyShowMessageOnce - whether or not we allow the
 - message to be show multiple times
 */
function warning(message) {
  var onlyShowMessageOnce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  /* eslint-disable no-undef, no-process-env */
  if (global.process && HIDDEN_PROCESSES["production"]) {
    return;
  }
  /* eslint-enable no-undef, no-process-env */
  if (!onlyShowMessageOnce || !USED_MESSAGES[message]) {
    /* eslint-disable no-console */
    console.warn(message);
    /* eslint-enable no-console */
    USED_MESSAGES[message] = true;
  }
}

/**
 * Convience wrapper for warning
 * @param {String} message - the message to be shown
 */
function warnOnce(message) {
  warning(message, true);
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(72)))

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__path_js__ = __webpack_require__(2178);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__path_js__["a"]; });



/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return abs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return atan2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return cos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return max; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return min; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return sin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return sqrt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return epsilon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return pi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return halfPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return tau; });
/* harmony export (immutable) */ __webpack_exports__["b"] = acos;
/* harmony export (immutable) */ __webpack_exports__["c"] = asin;
var abs = Math.abs;
var atan2 = Math.atan2;
var cos = Math.cos;
var max = Math.max;
var min = Math.min;
var sin = Math.sin;
var sqrt = Math.sqrt;

var epsilon = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var tau = 2 * pi;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}

function asin(x) {
  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
}


/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
    s0 = s1, s1 = series[order[i]];
    for (j = 0; j < m; ++j) {
      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
  }
});


/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  var n = series.length, o = new Array(n);
  while (--n >= 0) o[n] = n;
  return o;
});


/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = spherical;
/* harmony export (immutable) */ __webpack_exports__["a"] = cartesian;
/* harmony export (immutable) */ __webpack_exports__["d"] = cartesianDot;
/* harmony export (immutable) */ __webpack_exports__["c"] = cartesianCross;
/* harmony export (immutable) */ __webpack_exports__["b"] = cartesianAddInPlace;
/* harmony export (immutable) */ __webpack_exports__["f"] = cartesianScale;
/* harmony export (immutable) */ __webpack_exports__["e"] = cartesianNormalizeInPlace;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math_js__ = __webpack_require__(36);


function spherical(cartesian) {
  return [Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["e" /* atan2 */])(cartesian[1], cartesian[0]), Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["c" /* asin */])(cartesian[2])];
}

function cartesian(spherical) {
  var lambda = spherical[0], phi = spherical[1], cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["g" /* cos */])(phi);
  return [cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["g" /* cos */])(lambda), cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["t" /* sin */])(lambda), Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["t" /* sin */])(phi)];
}

function cartesianDot(a, b) {
  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}

function cartesianCross(a, b) {
  return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
}

// TODO return a
function cartesianAddInPlace(a, b) {
  a[0] += b[0], a[1] += b[1], a[2] += b[2];
}

function cartesianScale(vector, k) {
  return [vector[0] * k, vector[1] * k, vector[2] * k];
}

// TODO return d
function cartesianNormalizeInPlace(d) {
  var l = Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["u" /* sqrt */])(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
  d[0] /= l, d[1] /= l, d[2] /= l;
}


/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = azimuthalRaw;
/* harmony export (immutable) */ __webpack_exports__["a"] = azimuthalInvert;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math_js__ = __webpack_require__(36);


function azimuthalRaw(scale) {
  return function(x, y) {
    var cx = Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["g" /* cos */])(x),
        cy = Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["g" /* cos */])(y),
        k = scale(cx * cy);
    return [
      k * cy * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["t" /* sin */])(x),
      k * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["t" /* sin */])(y)
    ];
  }
}

function azimuthalInvert(angle) {
  return function(x, y) {
    var z = Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["u" /* sqrt */])(x * x + y * y),
        c = angle(z),
        sc = Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["t" /* sin */])(c),
        cc = Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["g" /* cos */])(c);
    return [
      Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["e" /* atan2 */])(x * sc, z * cc),
      Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["c" /* asin */])(z && y * sc / z)
    ];
  }
}


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(626);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var hasPropertyDescriptors = __webpack_require__(2270)();

var supportsDescriptors = origDefineProperty && hasPropertyDescriptors;

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value; // eslint-disable-line no-param-reassign
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      node,
      i = -1,
      n = nodes.length,
      k = parent.value && (x1 - x0) / parent.value;

  while (++i < n) {
    node = nodes[i], node.y0 = y0, node.y1 = y1;
    node.x0 = x0, node.x1 = x0 += node.value * k;
  }
});


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(653)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(381)('wks');
var uid = __webpack_require__(383);
var Symbol = __webpack_require__(136).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = validateSchema;
/* harmony export (immutable) */ __webpack_exports__["a"] = assertValidSchema;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__definition__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__introspection__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__schema__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jsutils_find__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__jsutils_invariant__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__jsutils_objectValues__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__error_GraphQLError__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utilities_assertValidName__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utilities_typeComparators__ = __webpack_require__(211);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */
















/**
 * Implements the "Type Validation" sub-sections of the specification's
 * "Type System" section.
 *
 * Validation runs synchronously, returning an array of encountered errors, or
 * an empty array if no errors were encountered and the Schema is valid.
 */
function validateSchema(schema) {
  // First check to ensure the provided value is in fact a GraphQLSchema.
  !Object(__WEBPACK_IMPORTED_MODULE_3__schema__["b" /* isSchema */])(schema) ? Object(__WEBPACK_IMPORTED_MODULE_5__jsutils_invariant__["a" /* default */])(0, 'Expected ' + String(schema) + ' to be a GraphQL schema.') : void 0;

  // If this Schema has already been validated, return the previous results.
  if (schema.__validationErrors) {
    return schema.__validationErrors;
  }

  // Validate the schema, producing a list of errors.
  var context = new SchemaValidationContext(schema);
  validateRootTypes(context);
  validateDirectives(context);
  validateTypes(context);

  // Persist the results of validation before returning to ensure validation
  // does not run multiple times for this schema.
  var errors = context.getErrors();
  schema.__validationErrors = errors;
  return errors;
}

/**
 * Utility function which asserts a schema is valid by throwing an error if
 * it is invalid.
 */
function assertValidSchema(schema) {
  var errors = validateSchema(schema);
  if (errors.length !== 0) {
    throw new Error(errors.map(function (error) {
      return error.message;
    }).join('\n\n'));
  }
}

var SchemaValidationContext = function () {
  function SchemaValidationContext(schema) {
    _classCallCheck(this, SchemaValidationContext);

    this._errors = [];
    this.schema = schema;
  }

  SchemaValidationContext.prototype.reportError = function reportError(message, nodes) {
    var _nodes = (Array.isArray(nodes) ? nodes : [nodes]).filter(Boolean);
    this.addError(new __WEBPACK_IMPORTED_MODULE_7__error_GraphQLError__["a" /* GraphQLError */](message, _nodes));
  };

  SchemaValidationContext.prototype.addError = function addError(error) {
    this._errors.push(error);
  };

  SchemaValidationContext.prototype.getErrors = function getErrors() {
    return this._errors;
  };

  return SchemaValidationContext;
}();

function validateRootTypes(context) {
  var schema = context.schema;
  var queryType = schema.getQueryType();
  if (!queryType) {
    context.reportError('Query root type must be provided.', schema.astNode);
  } else if (!Object(__WEBPACK_IMPORTED_MODULE_0__definition__["x" /* isObjectType */])(queryType)) {
    context.reportError('Query root type must be Object type, it cannot be ' + String(queryType) + '.', getOperationTypeNode(schema, queryType, 'query'));
  }

  var mutationType = schema.getMutationType();
  if (mutationType && !Object(__WEBPACK_IMPORTED_MODULE_0__definition__["x" /* isObjectType */])(mutationType)) {
    context.reportError('Mutation root type must be Object type if provided, it cannot be ' + (String(mutationType) + '.'), getOperationTypeNode(schema, mutationType, 'mutation'));
  }

  var subscriptionType = schema.getSubscriptionType();
  if (subscriptionType && !Object(__WEBPACK_IMPORTED_MODULE_0__definition__["x" /* isObjectType */])(subscriptionType)) {
    context.reportError('Subscription root type must be Object type if provided, it cannot be ' + (String(subscriptionType) + '.'), getOperationTypeNode(schema, subscriptionType, 'subscription'));
  }
}

function getOperationTypeNode(schema, type, operation) {
  var astNode = schema.astNode;
  var operationTypeNode = astNode && astNode.operationTypes.find(function (operationType) {
    return operationType.operation === operation;
  });
  return operationTypeNode ? operationTypeNode.type : type && type.astNode;
}

function validateDirectives(context) {
  var directives = context.schema.getDirectives();
  directives.forEach(function (directive) {
    // Ensure all directives are in fact GraphQL directives.
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__directives__["f" /* isDirective */])(directive)) {
      context.reportError('Expected directive but got: ' + String(directive) + '.', directive && directive.astNode);
      return;
    }

    // Ensure they are named correctly.
    validateName(context, directive);

    // TODO: Ensure proper locations.

    // Ensure the arguments are valid.
    var argNames = Object.create(null);
    directive.args.forEach(function (arg) {
      var argName = arg.name;

      // Ensure they are named correctly.
      validateName(context, arg);

      // Ensure they are unique per directive.
      if (argNames[argName]) {
        context.reportError('Argument @' + directive.name + '(' + argName + ':) can only be defined once.', getAllDirectiveArgNodes(directive, argName));
        return; // continue loop
      }
      argNames[argName] = true;

      // Ensure the type is an input type.
      if (!Object(__WEBPACK_IMPORTED_MODULE_0__definition__["r" /* isInputType */])(arg.type)) {
        context.reportError('The type of @' + directive.name + '(' + argName + ':) must be Input Type ' + ('but got: ' + String(arg.type) + '.'), getDirectiveArgTypeNode(directive, argName));
      }
    });
  });
}

function validateName(context, node) {
  // If a schema explicitly allows some legacy name which is no longer valid,
  // allow it to be assumed valid.
  if (context.schema.__allowedLegacyNames && context.schema.__allowedLegacyNames.indexOf(node.name) !== -1) {
    return;
  }
  // Ensure names are valid, however introspection types opt out.
  var error = Object(__WEBPACK_IMPORTED_MODULE_8__utilities_assertValidName__["a" /* isValidNameError */])(node.name, node.astNode || undefined);
  if (error) {
    context.addError(error);
  }
}

function validateTypes(context) {
  var typeMap = context.schema.getTypeMap();
  Object(__WEBPACK_IMPORTED_MODULE_6__jsutils_objectValues__["a" /* default */])(typeMap).forEach(function (type) {
    // Ensure all provided types are in fact GraphQL type.
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__definition__["v" /* isNamedType */])(type)) {
      context.reportError('Expected GraphQL named type but got: ' + String(type) + '.', type && type.astNode);
      return;
    }

    // Ensure it is named correctly (excluding introspection types).
    if (!Object(__WEBPACK_IMPORTED_MODULE_2__introspection__["g" /* isIntrospectionType */])(type)) {
      validateName(context, type);
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_0__definition__["x" /* isObjectType */])(type)) {
      // Ensure fields are valid
      validateFields(context, type);

      // Ensure objects implement the interfaces they claim to.
      validateObjectInterfaces(context, type);
    } else if (Object(__WEBPACK_IMPORTED_MODULE_0__definition__["s" /* isInterfaceType */])(type)) {
      // Ensure fields are valid.
      validateFields(context, type);
    } else if (Object(__WEBPACK_IMPORTED_MODULE_0__definition__["A" /* isUnionType */])(type)) {
      // Ensure Unions include valid member types.
      validateUnionMembers(context, type);
    } else if (Object(__WEBPACK_IMPORTED_MODULE_0__definition__["p" /* isEnumType */])(type)) {
      // Ensure Enums have valid values.
      validateEnumValues(context, type);
    } else if (Object(__WEBPACK_IMPORTED_MODULE_0__definition__["q" /* isInputObjectType */])(type)) {
      // Ensure Input Object fields are valid.
      validateInputFields(context, type);
    }
  });
}

function validateFields(context, type) {
  var fields = Object(__WEBPACK_IMPORTED_MODULE_6__jsutils_objectValues__["a" /* default */])(type.getFields());

  // Objects and Interfaces both must define one or more fields.
  if (fields.length === 0) {
    context.reportError('Type ' + type.name + ' must define one or more fields.', getAllObjectOrInterfaceNodes(type));
  }

  fields.forEach(function (field) {
    // Ensure they are named correctly.
    validateName(context, field);

    // Ensure they were defined at most once.
    var fieldNodes = getAllFieldNodes(type, field.name);
    if (fieldNodes.length > 1) {
      context.reportError('Field ' + type.name + '.' + field.name + ' can only be defined once.', fieldNodes);
      return; // continue loop
    }

    // Ensure the type is an output type
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__definition__["y" /* isOutputType */])(field.type)) {
      context.reportError('The type of ' + type.name + '.' + field.name + ' must be Output Type ' + ('but got: ' + String(field.type) + '.'), getFieldTypeNode(type, field.name));
    }

    // Ensure the arguments are valid
    var argNames = Object.create(null);
    field.args.forEach(function (arg) {
      var argName = arg.name;

      // Ensure they are named correctly.
      validateName(context, arg);

      // Ensure they are unique per field.
      if (argNames[argName]) {
        context.reportError('Field argument ' + type.name + '.' + field.name + '(' + argName + ':) can only ' + 'be defined once.', getAllFieldArgNodes(type, field.name, argName));
      }
      argNames[argName] = true;

      // Ensure the type is an input type
      if (!Object(__WEBPACK_IMPORTED_MODULE_0__definition__["r" /* isInputType */])(arg.type)) {
        context.reportError('The type of ' + type.name + '.' + field.name + '(' + argName + ':) must be Input ' + ('Type but got: ' + String(arg.type) + '.'), getFieldArgTypeNode(type, field.name, argName));
      }
    });
  });
}

function validateObjectInterfaces(context, object) {
  var implementedTypeNames = Object.create(null);
  object.getInterfaces().forEach(function (iface) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__definition__["s" /* isInterfaceType */])(iface)) {
      context.reportError('Type ' + String(object) + ' must only implement Interface types, ' + ('it cannot implement ' + String(iface) + '.'), getImplementsInterfaceNode(object, iface));
      return;
    }

    if (implementedTypeNames[iface.name]) {
      context.reportError('Type ' + object.name + ' can only implement ' + iface.name + ' once.', getAllImplementsInterfaceNodes(object, iface));
      return; // continue loop
    }
    implementedTypeNames[iface.name] = true;
    validateObjectImplementsInterface(context, object, iface);
  });
}

function validateObjectImplementsInterface(context, object, iface) {
  var objectFieldMap = object.getFields();
  var ifaceFieldMap = iface.getFields();

  // Assert each interface field is implemented.
  Object.keys(ifaceFieldMap).forEach(function (fieldName) {
    var objectField = objectFieldMap[fieldName];
    var ifaceField = ifaceFieldMap[fieldName];

    // Assert interface field exists on object.
    if (!objectField) {
      context.reportError('Interface field ' + iface.name + '.' + fieldName + ' expected but ' + (object.name + ' does not provide it.'), [getFieldNode(iface, fieldName), object.astNode]);
      // Continue loop over fields.
      return;
    }

    // Assert interface field type is satisfied by object field type, by being
    // a valid subtype. (covariant)
    if (!Object(__WEBPACK_IMPORTED_MODULE_9__utilities_typeComparators__["c" /* isTypeSubTypeOf */])(context.schema, objectField.type, ifaceField.type)) {
      context.reportError('Interface field ' + iface.name + '.' + fieldName + ' expects type ' + (String(ifaceField.type) + ' but ' + object.name + '.' + fieldName + ' ') + ('is type ' + String(objectField.type) + '.'), [getFieldTypeNode(iface, fieldName), getFieldTypeNode(object, fieldName)]);
    }

    // Assert each interface field arg is implemented.
    ifaceField.args.forEach(function (ifaceArg) {
      var argName = ifaceArg.name;
      var objectArg = Object(__WEBPACK_IMPORTED_MODULE_4__jsutils_find__["a" /* default */])(objectField.args, function (arg) {
        return arg.name === argName;
      });

      // Assert interface field arg exists on object field.
      if (!objectArg) {
        context.reportError('Interface field argument ' + iface.name + '.' + fieldName + '(' + argName + ':) ' + ('expected but ' + object.name + '.' + fieldName + ' does not provide it.'), [getFieldArgNode(iface, fieldName, argName), getFieldNode(object, fieldName)]);
        // Continue loop over arguments.
        return;
      }

      // Assert interface field arg type matches object field arg type.
      // (invariant)
      // TODO: change to contravariant?
      if (!Object(__WEBPACK_IMPORTED_MODULE_9__utilities_typeComparators__["b" /* isEqualType */])(ifaceArg.type, objectArg.type)) {
        context.reportError('Interface field argument ' + iface.name + '.' + fieldName + '(' + argName + ':) ' + ('expects type ' + String(ifaceArg.type) + ' but ') + (object.name + '.' + fieldName + '(' + argName + ':) is type ') + (String(objectArg.type) + '.'), [getFieldArgTypeNode(iface, fieldName, argName), getFieldArgTypeNode(object, fieldName, argName)]);
      }

      // TODO: validate default values?
    });

    // Assert additional arguments must not be required.
    objectField.args.forEach(function (objectArg) {
      var argName = objectArg.name;
      var ifaceArg = Object(__WEBPACK_IMPORTED_MODULE_4__jsutils_find__["a" /* default */])(ifaceField.args, function (arg) {
        return arg.name === argName;
      });
      if (!ifaceArg && Object(__WEBPACK_IMPORTED_MODULE_0__definition__["w" /* isNonNullType */])(objectArg.type)) {
        context.reportError('Object field argument ' + object.name + '.' + fieldName + '(' + argName + ':) ' + ('is of required type ' + String(objectArg.type) + ' but is not also ') + ('provided by the Interface field ' + iface.name + '.' + fieldName + '.'), [getFieldArgTypeNode(object, fieldName, argName), getFieldNode(iface, fieldName)]);
      }
    });
  });
}

function validateUnionMembers(context, union) {
  var memberTypes = union.getTypes();

  if (memberTypes.length === 0) {
    context.reportError('Union type ' + union.name + ' must define one or more member types.', union.astNode);
  }

  var includedTypeNames = Object.create(null);
  memberTypes.forEach(function (memberType) {
    if (includedTypeNames[memberType.name]) {
      context.reportError('Union type ' + union.name + ' can only include type ' + (memberType.name + ' once.'), getUnionMemberTypeNodes(union, memberType.name));
      return; // continue loop
    }
    includedTypeNames[memberType.name] = true;
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__definition__["x" /* isObjectType */])(memberType)) {
      context.reportError('Union type ' + union.name + ' can only include Object types, ' + ('it cannot include ' + String(memberType) + '.'), getUnionMemberTypeNodes(union, String(memberType)));
    }
  });
}

function validateEnumValues(context, enumType) {
  var enumValues = enumType.getValues();

  if (enumValues.length === 0) {
    context.reportError('Enum type ' + enumType.name + ' must define one or more values.', enumType.astNode);
  }

  enumValues.forEach(function (enumValue) {
    var valueName = enumValue.name;

    // Ensure no duplicates.
    var allNodes = getEnumValueNodes(enumType, valueName);
    if (allNodes && allNodes.length > 1) {
      context.reportError('Enum type ' + enumType.name + ' can include value ' + valueName + ' only once.', allNodes);
    }

    // Ensure valid name.
    validateName(context, enumValue);
    if (valueName === 'true' || valueName === 'false' || valueName === 'null') {
      context.reportError('Enum type ' + enumType.name + ' cannot include value: ' + valueName + '.', enumValue.astNode);
    }
  });
}

function validateInputFields(context, inputObj) {
  var fields = Object(__WEBPACK_IMPORTED_MODULE_6__jsutils_objectValues__["a" /* default */])(inputObj.getFields());

  if (fields.length === 0) {
    context.reportError('Input Object type ' + inputObj.name + ' must define one or more fields.', inputObj.astNode);
  }

  // Ensure the arguments are valid
  fields.forEach(function (field) {
    // Ensure they are named correctly.
    validateName(context, field);

    // TODO: Ensure they are unique per field.

    // Ensure the type is an input type
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__definition__["r" /* isInputType */])(field.type)) {
      context.reportError('The type of ' + inputObj.name + '.' + field.name + ' must be Input Type ' + ('but got: ' + String(field.type) + '.'), field.astNode && field.astNode.type);
    }
  });
}

function getAllObjectNodes(type) {
  return type.astNode ? type.extensionASTNodes ? [type.astNode].concat(type.extensionASTNodes) : [type.astNode] : type.extensionASTNodes || [];
}

function getAllObjectOrInterfaceNodes(type) {
  return type.astNode ? type.extensionASTNodes ? [type.astNode].concat(type.extensionASTNodes) : [type.astNode] : type.extensionASTNodes || [];
}

function getImplementsInterfaceNode(type, iface) {
  return getAllImplementsInterfaceNodes(type, iface)[0];
}

function getAllImplementsInterfaceNodes(type, iface) {
  var implementsNodes = [];
  var astNodes = getAllObjectNodes(type);
  for (var i = 0; i < astNodes.length; i++) {
    var _astNode = astNodes[i];
    if (_astNode && _astNode.interfaces) {
      _astNode.interfaces.forEach(function (node) {
        if (node.name.value === iface.name) {
          implementsNodes.push(node);
        }
      });
    }
  }
  return implementsNodes;
}

function getFieldNode(type, fieldName) {
  return getAllFieldNodes(type, fieldName)[0];
}

function getAllFieldNodes(type, fieldName) {
  var fieldNodes = [];
  var astNodes = getAllObjectOrInterfaceNodes(type);
  for (var i = 0; i < astNodes.length; i++) {
    var _astNode2 = astNodes[i];
    if (_astNode2 && _astNode2.fields) {
      _astNode2.fields.forEach(function (node) {
        if (node.name.value === fieldName) {
          fieldNodes.push(node);
        }
      });
    }
  }
  return fieldNodes;
}

function getFieldTypeNode(type, fieldName) {
  var fieldNode = getFieldNode(type, fieldName);
  return fieldNode && fieldNode.type;
}

function getFieldArgNode(type, fieldName, argName) {
  return getAllFieldArgNodes(type, fieldName, argName)[0];
}

function getAllFieldArgNodes(type, fieldName, argName) {
  var argNodes = [];
  var fieldNode = getFieldNode(type, fieldName);
  if (fieldNode && fieldNode.arguments) {
    fieldNode.arguments.forEach(function (node) {
      if (node.name.value === argName) {
        argNodes.push(node);
      }
    });
  }
  return argNodes;
}

function getFieldArgTypeNode(type, fieldName, argName) {
  var fieldArgNode = getFieldArgNode(type, fieldName, argName);
  return fieldArgNode && fieldArgNode.type;
}

function getAllDirectiveArgNodes(directive, argName) {
  var argNodes = [];
  var directiveNode = directive.astNode;
  if (directiveNode && directiveNode.arguments) {
    directiveNode.arguments.forEach(function (node) {
      if (node.name.value === argName) {
        argNodes.push(node);
      }
    });
  }
  return argNodes;
}

function getDirectiveArgTypeNode(directive, argName) {
  var argNode = getAllDirectiveArgNodes(directive, argName)[0];
  return argNode && argNode.type;
}

function getUnionMemberTypeNodes(union, typeName) {
  return union.astNode && union.astNode.types && union.astNode.types.filter(function (type) {
    return type.name.value === typeName;
  });
}

function getEnumValueNodes(enumType, valueName) {
  return enumType.astNode && enumType.astNode.values && enumType.astNode.values.filter(function (value) {
    return value.name.value === valueName;
  });
}

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = keyValMap;


/**
 * Creates a keyed JS object from an array, given a function to produce the keys
 * and a function to produce the values from each item in the array.
 *
 *     const phoneBook = [
 *       { name: 'Jon', num: '555-1234' },
 *       { name: 'Jenny', num: '867-5309' }
 *     ]
 *
 *     // { Jon: '555-1234', Jenny: '867-5309' }
 *     const phonesByName = keyValMap(
 *       phoneBook,
 *       entry => entry.name,
 *       entry => entry.num
 *     )
 *
 */
function keyValMap(list, keyFn, valFn) {
  return list.reduce(function (map, item) {
    return map[keyFn(item)] = valFn(item), map;
  }, Object.create(null));
} /**
   * Copyright (c) 2015-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *
   *  strict
   */

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isNullish;
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Returns true if a value is null, undefined, or NaN.
 */
function isNullish(value) {
  return value === null || value === undefined || value !== value;
}

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isEqualType;
/* harmony export (immutable) */ __webpack_exports__["c"] = isTypeSubTypeOf;
/* harmony export (immutable) */ __webpack_exports__["a"] = doTypesOverlap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type_definition__ = __webpack_require__(46);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */




/**
 * Provided two types, return true if the types are equal (invariant).
 */
function isEqualType(typeA, typeB) {
  // Equivalent types are equal.
  if (typeA === typeB) {
    return true;
  }

  // If either type is non-null, the other must also be non-null.
  if (Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["w" /* isNonNullType */])(typeA) && Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["w" /* isNonNullType */])(typeB)) {
    return isEqualType(typeA.ofType, typeB.ofType);
  }

  // If either type is a list, the other must also be a list.
  if (Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["u" /* isListType */])(typeA) && Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["u" /* isListType */])(typeB)) {
    return isEqualType(typeA.ofType, typeB.ofType);
  }

  // Otherwise the types are not equal.
  return false;
}

/**
 * Provided a type and a super type, return true if the first type is either
 * equal or a subset of the second super type (covariant).
 */
function isTypeSubTypeOf(schema, maybeSubType, superType) {
  // Equivalent type is a valid subtype
  if (maybeSubType === superType) {
    return true;
  }

  // If superType is non-null, maybeSubType must also be non-null.
  if (Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["w" /* isNonNullType */])(superType)) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["w" /* isNonNullType */])(maybeSubType)) {
      return isTypeSubTypeOf(schema, maybeSubType.ofType, superType.ofType);
    }
    return false;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["w" /* isNonNullType */])(maybeSubType)) {
    // If superType is nullable, maybeSubType may be non-null or nullable.
    return isTypeSubTypeOf(schema, maybeSubType.ofType, superType);
  }

  // If superType type is a list, maybeSubType type must also be a list.
  if (Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["u" /* isListType */])(superType)) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["u" /* isListType */])(maybeSubType)) {
      return isTypeSubTypeOf(schema, maybeSubType.ofType, superType.ofType);
    }
    return false;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["u" /* isListType */])(maybeSubType)) {
    // If superType is not a list, maybeSubType must also be not a list.
    return false;
  }

  // If superType type is an abstract type, maybeSubType type may be a currently
  // possible object type.
  if (Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["n" /* isAbstractType */])(superType) && Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["x" /* isObjectType */])(maybeSubType) && schema.isPossibleType(superType, maybeSubType)) {
    return true;
  }

  // Otherwise, the child type is not a valid subtype of the parent type.
  return false;
}

/**
 * Provided two composite types, determine if they "overlap". Two composite
 * types overlap when the Sets of possible concrete types for each intersect.
 *
 * This is often used to determine if a fragment of a given type could possibly
 * be visited in a context of another type.
 *
 * This function is commutative.
 */
function doTypesOverlap(schema, typeA, typeB) {
  // Equivalent types overlap
  if (typeA === typeB) {
    return true;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["n" /* isAbstractType */])(typeA)) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["n" /* isAbstractType */])(typeB)) {
      // If both types are abstract, then determine if there is any intersection
      // between possible concrete types of each.
      return schema.getPossibleTypes(typeA).some(function (type) {
        return schema.isPossibleType(typeB, type);
      });
    }
    // Determine if the latter type is a possible concrete type of the former.
    return schema.isPossibleType(typeA, typeB);
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["n" /* isAbstractType */])(typeB)) {
    // Determine if the former type is a possible concrete type of the latter.
    return schema.isPossibleType(typeB, typeA);
  }

  // Otherwise the types do not overlap.
  return false;
}

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = execute;
/* harmony export (immutable) */ __webpack_exports__["j"] = responsePathAsArray;
/* harmony export (immutable) */ __webpack_exports__["a"] = addPath;
/* harmony export (immutable) */ __webpack_exports__["b"] = assertValidExecutionArguments;
/* harmony export (immutable) */ __webpack_exports__["c"] = buildExecutionContext;
/* harmony export (immutable) */ __webpack_exports__["h"] = getOperationRootType;
/* harmony export (immutable) */ __webpack_exports__["e"] = collectFields;
/* harmony export (immutable) */ __webpack_exports__["d"] = buildResolveInfo;
/* harmony export (immutable) */ __webpack_exports__["i"] = resolveFieldValueOrError;
/* unused harmony export defaultFieldResolver */
/* harmony export (immutable) */ __webpack_exports__["g"] = getFieldDef;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_iterall__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsutils_invariant__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jsutils_isInvalid__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jsutils_isNullish__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__jsutils_isPromise__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__jsutils_memoize3__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__jsutils_promiseForObject__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__jsutils_promiseReduce__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utilities_typeFromAST__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__language_kinds__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__values__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__type_definition__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__type_schema__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__type_introspection__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__type_directives__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__type_validate__ = __webpack_require__(208);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */






















/**
 * Terminology
 *
 * "Definitions" are the generic name for top-level statements in the document.
 * Examples of this include:
 * 1) Operations (such as a query)
 * 2) Fragments
 *
 * "Operations" are a generic name for requests in the document.
 * Examples of this include:
 * 1) query,
 * 2) mutation
 *
 * "Selections" are the definitions that can appear legally and at
 * single level of the query. These include:
 * 1) field references e.g "a"
 * 2) fragment "spreads" e.g. "...c"
 * 3) inline fragment "spreads" e.g. "...on Type { a }"
 */

/**
 * Data that must be available at all points during query execution.
 *
 * Namely, schema of the type system that is currently executing,
 * and the fragments defined in the query document
 */


/**
 * The result of GraphQL execution.
 *
 *   - `errors` is included when any errors occurred as a non-empty array.
 *   - `data` is the result of a successful execution of the query.
 */


/**
 * Implements the "Evaluating requests" section of the GraphQL specification.
 *
 * Returns either a synchronous ExecutionResult (if all encountered resolvers
 * are synchronous), or a Promise of an ExecutionResult that will eventually be
 * resolved and never rejected.
 *
 * If the arguments to this function do not result in a legal execution context,
 * a GraphQLError will be thrown immediately explaining the invalid input.
 *
 * Accepts either an object with named arguments, or individual arguments.
 */

/* eslint-disable no-redeclare */

function execute(argsOrSchema, document, rootValue, contextValue, variableValues, operationName, fieldResolver) {
  /* eslint-enable no-redeclare */
  // Extract arguments from object args if provided.
  return arguments.length === 1 ? executeImpl(argsOrSchema.schema, argsOrSchema.document, argsOrSchema.rootValue, argsOrSchema.contextValue, argsOrSchema.variableValues, argsOrSchema.operationName, argsOrSchema.fieldResolver) : executeImpl(argsOrSchema, document, rootValue, contextValue, variableValues, operationName, fieldResolver);
}

function executeImpl(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver) {
  // If arguments are missing or incorrect, throw an error.
  assertValidExecutionArguments(schema, document, variableValues);

  // If a valid context cannot be created due to incorrect arguments,
  // a "Response" with only errors is returned.
  var context = buildExecutionContext(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver);

  // Return early errors if execution context failed.
  if (Array.isArray(context)) {
    return { errors: context };
  }

  // Return a Promise that will eventually resolve to the data described by
  // The "Response" section of the GraphQL specification.
  //
  // If errors are encountered while executing a GraphQL field, only that
  // field and its descendants will be omitted, and sibling fields will still
  // be executed. An execution which encounters errors will still result in a
  // resolved Promise.
  var data = executeOperation(context, context.operation, rootValue);
  return buildResponse(context, data);
}

/**
 * Given a completed execution context and data, build the { errors, data }
 * response defined by the "Response" section of the GraphQL specification.
 */
function buildResponse(context, data) {
  if (Object(__WEBPACK_IMPORTED_MODULE_5__jsutils_isPromise__["a" /* default */])(data)) {
    return data.then(function (resolved) {
      return buildResponse(context, resolved);
    });
  }
  return context.errors.length === 0 ? { data: data } : { errors: context.errors, data: data };
}

/**
 * Given a ResponsePath (found in the `path` entry in the information provided
 * as the last argument to a field resolver), return an Array of the path keys.
 */
function responsePathAsArray(path) {
  var flattened = [];
  var curr = path;
  while (curr) {
    flattened.push(curr.key);
    curr = curr.prev;
  }
  return flattened.reverse();
}

/**
 * Given a ResponsePath and a key, return a new ResponsePath containing the
 * new key.
 */
function addPath(prev, key) {
  return { prev: prev, key: key };
}

/**
 * Essential assertions before executing to provide developer feedback for
 * improper use of the GraphQL library.
 */
function assertValidExecutionArguments(schema, document, rawVariableValues) {
  !document ? Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_invariant__["a" /* default */])(0, 'Must provide document') : void 0;

  // If the schema used for execution is invalid, throw an error.
  Object(__WEBPACK_IMPORTED_MODULE_16__type_validate__["a" /* assertValidSchema */])(schema);

  // Variables, if provided, must be an object.
  !(!rawVariableValues || (typeof rawVariableValues === 'undefined' ? 'undefined' : _typeof(rawVariableValues)) === 'object') ? Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_invariant__["a" /* default */])(0, 'Variables must be provided as an Object where each property is a ' + 'variable value. Perhaps look to see if an unparsed JSON string ' + 'was provided.') : void 0;
}

/**
 * Constructs a ExecutionContext object from the arguments passed to
 * execute, which we will pass throughout the other execution methods.
 *
 * Throws a GraphQLError if a valid execution context cannot be created.
 */
function buildExecutionContext(schema, document, rootValue, contextValue, rawVariableValues, operationName, fieldResolver) {
  var errors = [];
  var operation = void 0;
  var hasMultipleAssumedOperations = false;
  var fragments = Object.create(null);
  for (var i = 0; i < document.definitions.length; i++) {
    var definition = document.definitions[i];
    switch (definition.kind) {
      case __WEBPACK_IMPORTED_MODULE_10__language_kinds__["a" /* Kind */].OPERATION_DEFINITION:
        if (!operationName && operation) {
          hasMultipleAssumedOperations = true;
        } else if (!operationName || definition.name && definition.name.value === operationName) {
          operation = definition;
        }
        break;
      case __WEBPACK_IMPORTED_MODULE_10__language_kinds__["a" /* Kind */].FRAGMENT_DEFINITION:
        fragments[definition.name.value] = definition;
        break;
    }
  }

  if (!operation) {
    if (operationName) {
      errors.push(new __WEBPACK_IMPORTED_MODULE_1__error__["a" /* GraphQLError */]('Unknown operation named "' + operationName + '".'));
    } else {
      errors.push(new __WEBPACK_IMPORTED_MODULE_1__error__["a" /* GraphQLError */]('Must provide an operation.'));
    }
  } else if (hasMultipleAssumedOperations) {
    errors.push(new __WEBPACK_IMPORTED_MODULE_1__error__["a" /* GraphQLError */]('Must provide operation name if query contains ' + 'multiple operations.'));
  }

  var variableValues = void 0;
  if (operation) {
    var coercedVariableValues = Object(__WEBPACK_IMPORTED_MODULE_11__values__["c" /* getVariableValues */])(schema, operation.variableDefinitions || [], rawVariableValues || {});

    if (coercedVariableValues.errors) {
      errors.push.apply(errors, coercedVariableValues.errors);
    } else {
      variableValues = coercedVariableValues.coerced;
    }
  }

  if (errors.length !== 0) {
    return errors;
  }

  !operation ? Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_invariant__["a" /* default */])(0, 'Has operation if no errors.') : void 0;
  !variableValues ? Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_invariant__["a" /* default */])(0, 'Has variables if no errors.') : void 0;

  return {
    schema: schema,
    fragments: fragments,
    rootValue: rootValue,
    contextValue: contextValue,
    operation: operation,
    variableValues: variableValues,
    fieldResolver: fieldResolver || defaultFieldResolver,
    errors: errors
  };
}

/**
 * Implements the "Evaluating operations" section of the spec.
 */
function executeOperation(exeContext, operation, rootValue) {
  var type = getOperationRootType(exeContext.schema, operation);
  var fields = collectFields(exeContext, type, operation.selectionSet, Object.create(null), Object.create(null));

  var path = undefined;

  // Errors from sub-fields of a NonNull type may propagate to the top level,
  // at which point we still log the error and null the parent field, which
  // in this case is the entire response.
  //
  // Similar to completeValueCatchingError.
  try {
    var result = operation.operation === 'mutation' ? executeFieldsSerially(exeContext, type, rootValue, path, fields) : executeFields(exeContext, type, rootValue, path, fields);
    if (Object(__WEBPACK_IMPORTED_MODULE_5__jsutils_isPromise__["a" /* default */])(result)) {
      return result.then(undefined, function (error) {
        exeContext.errors.push(error);
        return Promise.resolve(null);
      });
    }
    return result;
  } catch (error) {
    exeContext.errors.push(error);
    return null;
  }
}

/**
 * Extracts the root type of the operation from the schema.
 */
function getOperationRootType(schema, operation) {
  switch (operation.operation) {
    case 'query':
      var queryType = schema.getQueryType();
      if (!queryType) {
        throw new __WEBPACK_IMPORTED_MODULE_1__error__["a" /* GraphQLError */]('Schema does not define the required query root type.', [operation]);
      }
      return queryType;
    case 'mutation':
      var mutationType = schema.getMutationType();
      if (!mutationType) {
        throw new __WEBPACK_IMPORTED_MODULE_1__error__["a" /* GraphQLError */]('Schema is not configured for mutations.', [operation]);
      }
      return mutationType;
    case 'subscription':
      var subscriptionType = schema.getSubscriptionType();
      if (!subscriptionType) {
        throw new __WEBPACK_IMPORTED_MODULE_1__error__["a" /* GraphQLError */]('Schema is not configured for subscriptions.', [operation]);
      }
      return subscriptionType;
    default:
      throw new __WEBPACK_IMPORTED_MODULE_1__error__["a" /* GraphQLError */]('Can only execute queries, mutations and subscriptions.', [operation]);
  }
}

/**
 * Implements the "Evaluating selection sets" section of the spec
 * for "write" mode.
 */
function executeFieldsSerially(exeContext, parentType, sourceValue, path, fields) {
  return Object(__WEBPACK_IMPORTED_MODULE_8__jsutils_promiseReduce__["a" /* default */])(Object.keys(fields), function (results, responseName) {
    var fieldNodes = fields[responseName];
    var fieldPath = addPath(path, responseName);
    var result = resolveField(exeContext, parentType, sourceValue, fieldNodes, fieldPath);
    if (result === undefined) {
      return results;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_5__jsutils_isPromise__["a" /* default */])(result)) {
      return result.then(function (resolvedResult) {
        results[responseName] = resolvedResult;
        return results;
      });
    }
    results[responseName] = result;
    return results;
  }, Object.create(null));
}

/**
 * Implements the "Evaluating selection sets" section of the spec
 * for "read" mode.
 */
function executeFields(exeContext, parentType, sourceValue, path, fields) {
  var containsPromise = false;

  var finalResults = Object.keys(fields).reduce(function (results, responseName) {
    var fieldNodes = fields[responseName];
    var fieldPath = addPath(path, responseName);
    var result = resolveField(exeContext, parentType, sourceValue, fieldNodes, fieldPath);
    if (result === undefined) {
      return results;
    }
    results[responseName] = result;
    if (!containsPromise && Object(__WEBPACK_IMPORTED_MODULE_5__jsutils_isPromise__["a" /* default */])(result)) {
      containsPromise = true;
    }
    return results;
  }, Object.create(null));

  // If there are no promises, we can just return the object
  if (!containsPromise) {
    return finalResults;
  }

  // Otherwise, results is a map from field name to the result
  // of resolving that field, which is possibly a promise. Return
  // a promise that will return this same map, but with any
  // promises replaced with the values they resolved to.
  return Object(__WEBPACK_IMPORTED_MODULE_7__jsutils_promiseForObject__["a" /* default */])(finalResults);
}

/**
 * Given a selectionSet, adds all of the fields in that selection to
 * the passed in map of fields, and returns it at the end.
 *
 * CollectFields requires the "runtime type" of an object. For a field which
 * returns an Interface or Union type, the "runtime type" will be the actual
 * Object type returned by that field.
 */
function collectFields(exeContext, runtimeType, selectionSet, fields, visitedFragmentNames) {
  for (var i = 0; i < selectionSet.selections.length; i++) {
    var selection = selectionSet.selections[i];
    switch (selection.kind) {
      case __WEBPACK_IMPORTED_MODULE_10__language_kinds__["a" /* Kind */].FIELD:
        if (!shouldIncludeNode(exeContext, selection)) {
          continue;
        }
        var name = getFieldEntryKey(selection);
        if (!fields[name]) {
          fields[name] = [];
        }
        fields[name].push(selection);
        break;
      case __WEBPACK_IMPORTED_MODULE_10__language_kinds__["a" /* Kind */].INLINE_FRAGMENT:
        if (!shouldIncludeNode(exeContext, selection) || !doesFragmentConditionMatch(exeContext, selection, runtimeType)) {
          continue;
        }
        collectFields(exeContext, runtimeType, selection.selectionSet, fields, visitedFragmentNames);
        break;
      case __WEBPACK_IMPORTED_MODULE_10__language_kinds__["a" /* Kind */].FRAGMENT_SPREAD:
        var fragName = selection.name.value;
        if (visitedFragmentNames[fragName] || !shouldIncludeNode(exeContext, selection)) {
          continue;
        }
        visitedFragmentNames[fragName] = true;
        var fragment = exeContext.fragments[fragName];
        if (!fragment || !doesFragmentConditionMatch(exeContext, fragment, runtimeType)) {
          continue;
        }
        collectFields(exeContext, runtimeType, fragment.selectionSet, fields, visitedFragmentNames);
        break;
    }
  }
  return fields;
}

/**
 * Determines if a field should be included based on the @include and @skip
 * directives, where @skip has higher precidence than @include.
 */
function shouldIncludeNode(exeContext, node) {
  var skip = Object(__WEBPACK_IMPORTED_MODULE_11__values__["b" /* getDirectiveValues */])(__WEBPACK_IMPORTED_MODULE_15__type_directives__["e" /* GraphQLSkipDirective */], node, exeContext.variableValues);
  if (skip && skip.if === true) {
    return false;
  }

  var include = Object(__WEBPACK_IMPORTED_MODULE_11__values__["b" /* getDirectiveValues */])(__WEBPACK_IMPORTED_MODULE_15__type_directives__["d" /* GraphQLIncludeDirective */], node, exeContext.variableValues);
  if (include && include.if === false) {
    return false;
  }
  return true;
}

/**
 * Determines if a fragment is applicable to the given type.
 */
function doesFragmentConditionMatch(exeContext, fragment, type) {
  var typeConditionNode = fragment.typeCondition;
  if (!typeConditionNode) {
    return true;
  }
  var conditionalType = Object(__WEBPACK_IMPORTED_MODULE_9__utilities_typeFromAST__["a" /* typeFromAST */])(exeContext.schema, typeConditionNode);
  if (conditionalType === type) {
    return true;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_12__type_definition__["n" /* isAbstractType */])(conditionalType)) {
    return exeContext.schema.isPossibleType(conditionalType, type);
  }
  return false;
}

/**
 * Implements the logic to compute the key of a given field's entry
 */
function getFieldEntryKey(node) {
  return node.alias ? node.alias.value : node.name.value;
}

/**
 * Resolves the field on the given source object. In particular, this
 * figures out the value that the field returns by calling its resolve function,
 * then calls completeValue to complete promises, serialize scalars, or execute
 * the sub-selection-set for objects.
 */
function resolveField(exeContext, parentType, source, fieldNodes, path) {
  var fieldNode = fieldNodes[0];
  var fieldName = fieldNode.name.value;

  var fieldDef = getFieldDef(exeContext.schema, parentType, fieldName);
  if (!fieldDef) {
    return;
  }

  var resolveFn = fieldDef.resolve || exeContext.fieldResolver;

  var info = buildResolveInfo(exeContext, fieldDef, fieldNodes, parentType, path);

  // Get the resolve function, regardless of if its result is normal
  // or abrupt (error).
  var result = resolveFieldValueOrError(exeContext, fieldDef, fieldNodes, resolveFn, source, info);

  return completeValueCatchingError(exeContext, fieldDef.type, fieldNodes, info, path, result);
}

function buildResolveInfo(exeContext, fieldDef, fieldNodes, parentType, path) {
  // The resolve function's optional fourth argument is a collection of
  // information about the current execution state.
  return {
    fieldName: fieldNodes[0].name.value,
    fieldNodes: fieldNodes,
    returnType: fieldDef.type,
    parentType: parentType,
    path: path,
    schema: exeContext.schema,
    fragments: exeContext.fragments,
    rootValue: exeContext.rootValue,
    operation: exeContext.operation,
    variableValues: exeContext.variableValues
  };
}

// Isolates the "ReturnOrAbrupt" behavior to not de-opt the `resolveField`
// function. Returns the result of resolveFn or the abrupt-return Error object.
function resolveFieldValueOrError(exeContext, fieldDef, fieldNodes, resolveFn, source, info) {
  try {
    // Build a JS object of arguments from the field.arguments AST, using the
    // variables scope to fulfill any variable references.
    // TODO: find a way to memoize, in case this field is within a List type.
    var args = Object(__WEBPACK_IMPORTED_MODULE_11__values__["a" /* getArgumentValues */])(fieldDef, fieldNodes[0], exeContext.variableValues);

    // The resolve function's optional third argument is a context value that
    // is provided to every resolve function within an execution. It is commonly
    // used to represent an authenticated user, or request-specific caches.
    var context = exeContext.contextValue;

    var result = resolveFn(source, args, context, info);
    return Object(__WEBPACK_IMPORTED_MODULE_5__jsutils_isPromise__["a" /* default */])(result) ? result.then(undefined, asErrorInstance) : result;
  } catch (error) {
    return asErrorInstance(error);
  }
}

// Sometimes a non-error is thrown, wrap it as an Error instance to ensure a
// consistent Error interface.
function asErrorInstance(error) {
  return error instanceof Error ? error : new Error(error || undefined);
}

// This is a small wrapper around completeValue which detects and logs errors
// in the execution context.
function completeValueCatchingError(exeContext, returnType, fieldNodes, info, path, result) {
  // If the field type is non-nullable, then it is resolved without any
  // protection from errors, however it still properly locates the error.
  if (Object(__WEBPACK_IMPORTED_MODULE_12__type_definition__["w" /* isNonNullType */])(returnType)) {
    return completeValueWithLocatedError(exeContext, returnType, fieldNodes, info, path, result);
  }

  // Otherwise, error protection is applied, logging the error and resolving
  // a null value for this field if one is encountered.
  try {
    var completed = completeValueWithLocatedError(exeContext, returnType, fieldNodes, info, path, result);
    if (Object(__WEBPACK_IMPORTED_MODULE_5__jsutils_isPromise__["a" /* default */])(completed)) {
      // If `completeValueWithLocatedError` returned a rejected promise, log
      // the rejection error and resolve to null.
      // Note: we don't rely on a `catch` method, but we do expect "thenable"
      // to take a second callback for the error case.
      return completed.then(undefined, function (error) {
        exeContext.errors.push(error);
        return Promise.resolve(null);
      });
    }
    return completed;
  } catch (error) {
    // If `completeValueWithLocatedError` returned abruptly (threw an error),
    // log the error and return null.
    exeContext.errors.push(error);
    return null;
  }
}

// This is a small wrapper around completeValue which annotates errors with
// location information.
function completeValueWithLocatedError(exeContext, returnType, fieldNodes, info, path, result) {
  try {
    var completed = completeValue(exeContext, returnType, fieldNodes, info, path, result);
    if (Object(__WEBPACK_IMPORTED_MODULE_5__jsutils_isPromise__["a" /* default */])(completed)) {
      return completed.then(undefined, function (error) {
        return Promise.reject(Object(__WEBPACK_IMPORTED_MODULE_1__error__["b" /* locatedError */])(asErrorInstance(error), fieldNodes, responsePathAsArray(path)));
      });
    }
    return completed;
  } catch (error) {
    throw Object(__WEBPACK_IMPORTED_MODULE_1__error__["b" /* locatedError */])(asErrorInstance(error), fieldNodes, responsePathAsArray(path));
  }
}

/**
 * Implements the instructions for completeValue as defined in the
 * "Field entries" section of the spec.
 *
 * If the field type is Non-Null, then this recursively completes the value
 * for the inner type. It throws a field error if that completion returns null,
 * as per the "Nullability" section of the spec.
 *
 * If the field type is a List, then this recursively completes the value
 * for the inner type on each item in the list.
 *
 * If the field type is a Scalar or Enum, ensures the completed value is a legal
 * value of the type by calling the `serialize` method of GraphQL type
 * definition.
 *
 * If the field is an abstract type, determine the runtime type of the value
 * and then complete based on that type
 *
 * Otherwise, the field type expects a sub-selection set, and will complete the
 * value by evaluating all sub-selections.
 */
function completeValue(exeContext, returnType, fieldNodes, info, path, result) {
  // If result is a Promise, apply-lift over completeValue.
  if (Object(__WEBPACK_IMPORTED_MODULE_5__jsutils_isPromise__["a" /* default */])(result)) {
    return result.then(function (resolved) {
      return completeValue(exeContext, returnType, fieldNodes, info, path, resolved);
    });
  }

  // If result is an Error, throw a located error.
  if (result instanceof Error) {
    throw result;
  }

  // If field type is NonNull, complete for inner type, and throw field error
  // if result is null.
  if (Object(__WEBPACK_IMPORTED_MODULE_12__type_definition__["w" /* isNonNullType */])(returnType)) {
    var completed = completeValue(exeContext, returnType.ofType, fieldNodes, info, path, result);
    if (completed === null) {
      throw new Error('Cannot return null for non-nullable field ' + info.parentType.name + '.' + info.fieldName + '.');
    }
    return completed;
  }

  // If result value is null-ish (null, undefined, or NaN) then return null.
  if (Object(__WEBPACK_IMPORTED_MODULE_4__jsutils_isNullish__["a" /* default */])(result)) {
    return null;
  }

  // If field type is List, complete each item in the list with the inner type
  if (Object(__WEBPACK_IMPORTED_MODULE_12__type_definition__["u" /* isListType */])(returnType)) {
    return completeListValue(exeContext, returnType, fieldNodes, info, path, result);
  }

  // If field type is a leaf type, Scalar or Enum, serialize to a valid value,
  // returning null if serialization is not possible.
  if (Object(__WEBPACK_IMPORTED_MODULE_12__type_definition__["t" /* isLeafType */])(returnType)) {
    return completeLeafValue(returnType, result);
  }

  // If field type is an abstract type, Interface or Union, determine the
  // runtime Object type and complete for that type.
  if (Object(__WEBPACK_IMPORTED_MODULE_12__type_definition__["n" /* isAbstractType */])(returnType)) {
    return completeAbstractValue(exeContext, returnType, fieldNodes, info, path, result);
  }

  // If field type is Object, execute and complete all sub-selections.
  if (Object(__WEBPACK_IMPORTED_MODULE_12__type_definition__["x" /* isObjectType */])(returnType)) {
    return completeObjectValue(exeContext, returnType, fieldNodes, info, path, result);
  }

  // Not reachable. All possible output types have been considered.
  /* istanbul ignore next */
  throw new Error('Cannot complete value of unexpected type "' + String(returnType) + '".');
}

/**
 * Complete a list value by completing each item in the list with the
 * inner type
 */
function completeListValue(exeContext, returnType, fieldNodes, info, path, result) {
  !Object(__WEBPACK_IMPORTED_MODULE_0_iterall__["e" /* isCollection */])(result) ? Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_invariant__["a" /* default */])(0, 'Expected Iterable, but did not find one for field ' + info.parentType.name + '.' + info.fieldName + '.') : void 0;

  // This is specified as a simple map, however we're optimizing the path
  // where the list contains no Promises by avoiding creating another Promise.
  var itemType = returnType.ofType;
  var containsPromise = false;
  var completedResults = [];
  Object(__WEBPACK_IMPORTED_MODULE_0_iterall__["b" /* forEach */])(result, function (item, index) {
    // No need to modify the info object containing the path,
    // since from here on it is not ever accessed by resolver functions.
    var fieldPath = addPath(path, index);
    var completedItem = completeValueCatchingError(exeContext, itemType, fieldNodes, info, fieldPath, item);

    if (!containsPromise && Object(__WEBPACK_IMPORTED_MODULE_5__jsutils_isPromise__["a" /* default */])(completedItem)) {
      containsPromise = true;
    }
    completedResults.push(completedItem);
  });

  return containsPromise ? Promise.all(completedResults) : completedResults;
}

/**
 * Complete a Scalar or Enum by serializing to a valid value, returning
 * null if serialization is not possible.
 */
function completeLeafValue(returnType, result) {
  !returnType.serialize ? Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_invariant__["a" /* default */])(0, 'Missing serialize method on type') : void 0;
  var serializedResult = returnType.serialize(result);
  if (Object(__WEBPACK_IMPORTED_MODULE_3__jsutils_isInvalid__["a" /* default */])(serializedResult)) {
    throw new Error('Expected a value of type "' + String(returnType) + '" but ' + ('received: ' + String(result)));
  }
  return serializedResult;
}

/**
 * Complete a value of an abstract type by determining the runtime object type
 * of that value, then complete the value for that type.
 */
function completeAbstractValue(exeContext, returnType, fieldNodes, info, path, result) {
  var runtimeType = returnType.resolveType ? returnType.resolveType(result, exeContext.contextValue, info) : defaultResolveTypeFn(result, exeContext.contextValue, info, returnType);

  if (Object(__WEBPACK_IMPORTED_MODULE_5__jsutils_isPromise__["a" /* default */])(runtimeType)) {
    return runtimeType.then(function (resolvedRuntimeType) {
      return completeObjectValue(exeContext, ensureValidRuntimeType(resolvedRuntimeType, exeContext, returnType, fieldNodes, info, result), fieldNodes, info, path, result);
    });
  }

  return completeObjectValue(exeContext, ensureValidRuntimeType(runtimeType, exeContext, returnType, fieldNodes, info, result), fieldNodes, info, path, result);
}

function ensureValidRuntimeType(runtimeTypeOrName, exeContext, returnType, fieldNodes, info, result) {
  var runtimeType = typeof runtimeTypeOrName === 'string' ? exeContext.schema.getType(runtimeTypeOrName) : runtimeTypeOrName;

  if (!Object(__WEBPACK_IMPORTED_MODULE_12__type_definition__["x" /* isObjectType */])(runtimeType)) {
    throw new __WEBPACK_IMPORTED_MODULE_1__error__["a" /* GraphQLError */]('Abstract type ' + returnType.name + ' must resolve to an Object type at ' + ('runtime for field ' + info.parentType.name + '.' + info.fieldName + ' with ') + ('value "' + String(result) + '", received "' + String(runtimeType) + '". ') + ('Either the ' + returnType.name + ' type should provide a "resolveType" ') + 'function or each possible types should provide an ' + '"isTypeOf" function.', fieldNodes);
  }

  if (!exeContext.schema.isPossibleType(returnType, runtimeType)) {
    throw new __WEBPACK_IMPORTED_MODULE_1__error__["a" /* GraphQLError */]('Runtime Object type "' + runtimeType.name + '" is not a possible type ' + ('for "' + returnType.name + '".'), fieldNodes);
  }

  return runtimeType;
}

/**
 * Complete an Object value by executing all sub-selections.
 */
function completeObjectValue(exeContext, returnType, fieldNodes, info, path, result) {
  // If there is an isTypeOf predicate function, call it with the
  // current result. If isTypeOf returns false, then raise an error rather
  // than continuing execution.
  if (returnType.isTypeOf) {
    var isTypeOf = returnType.isTypeOf(result, exeContext.contextValue, info);

    if (Object(__WEBPACK_IMPORTED_MODULE_5__jsutils_isPromise__["a" /* default */])(isTypeOf)) {
      return isTypeOf.then(function (resolvedIsTypeOf) {
        if (!resolvedIsTypeOf) {
          throw invalidReturnTypeError(returnType, result, fieldNodes);
        }
        return collectAndExecuteSubfields(exeContext, returnType, fieldNodes, info, path, result);
      });
    }

    if (!isTypeOf) {
      throw invalidReturnTypeError(returnType, result, fieldNodes);
    }
  }

  return collectAndExecuteSubfields(exeContext, returnType, fieldNodes, info, path, result);
}

function invalidReturnTypeError(returnType, result, fieldNodes) {
  return new __WEBPACK_IMPORTED_MODULE_1__error__["a" /* GraphQLError */]('Expected value of type "' + returnType.name + '" but got: ' + String(result) + '.', fieldNodes);
}

function collectAndExecuteSubfields(exeContext, returnType, fieldNodes, info, path, result) {
  // Collect sub-fields to execute to complete this value.
  var subFieldNodes = collectSubfields(exeContext, returnType, fieldNodes);
  return executeFields(exeContext, returnType, result, path, subFieldNodes);
}

/**
 * A memoized collection of relevant subfields in the context of the return
 * type. Memoizing ensures the subfields are not repeatedly calculated, which
 * saves overhead when resolving lists of values.
 */
var collectSubfields = Object(__WEBPACK_IMPORTED_MODULE_6__jsutils_memoize3__["a" /* default */])(_collectSubfields);
function _collectSubfields(exeContext, returnType, fieldNodes) {
  var subFieldNodes = Object.create(null);
  var visitedFragmentNames = Object.create(null);
  for (var i = 0; i < fieldNodes.length; i++) {
    var selectionSet = fieldNodes[i].selectionSet;
    if (selectionSet) {
      subFieldNodes = collectFields(exeContext, returnType, selectionSet, subFieldNodes, visitedFragmentNames);
    }
  }
  return subFieldNodes;
}

/**
 * If a resolveType function is not given, then a default resolve behavior is
 * used which attempts two strategies:
 *
 * First, See if the provided value has a `__typename` field defined, if so, use
 * that value as name of the resolved type.
 *
 * Otherwise, test each possible type for the abstract type by calling
 * isTypeOf for the object being coerced, returning the first type that matches.
 */
function defaultResolveTypeFn(value, context, info, abstractType) {
  // First, look for `__typename`.
  if (value !== null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && typeof value.__typename === 'string') {
    return value.__typename;
  }

  // Otherwise, test each possible type.
  var possibleTypes = info.schema.getPossibleTypes(abstractType);
  var promisedIsTypeOfResults = [];

  for (var i = 0; i < possibleTypes.length; i++) {
    var type = possibleTypes[i];

    if (type.isTypeOf) {
      var isTypeOfResult = type.isTypeOf(value, context, info);

      if (Object(__WEBPACK_IMPORTED_MODULE_5__jsutils_isPromise__["a" /* default */])(isTypeOfResult)) {
        promisedIsTypeOfResults[i] = isTypeOfResult;
      } else if (isTypeOfResult) {
        return type;
      }
    }
  }

  if (promisedIsTypeOfResults.length) {
    return Promise.all(promisedIsTypeOfResults).then(function (isTypeOfResults) {
      for (var _i = 0; _i < isTypeOfResults.length; _i++) {
        if (isTypeOfResults[_i]) {
          return possibleTypes[_i];
        }
      }
    });
  }
}

/**
 * If a resolve function is not given, then a default resolve behavior is used
 * which takes the property of the source object of the same name as the field
 * and returns it as the result, or if it's a function, returns the result
 * of calling that function while passing along args and context.
 */
var defaultFieldResolver = function defaultFieldResolver(source, args, context, info) {
  // ensure source is a value for which property access is acceptable.
  if ((typeof source === 'undefined' ? 'undefined' : _typeof(source)) === 'object' || typeof source === 'function') {
    var property = source[info.fieldName];
    if (typeof property === 'function') {
      return source[info.fieldName](args, context, info);
    }
    return property;
  }
};

/**
 * This method looks up the field on the given type defintion.
 * It has special casing for the two introspection fields, __schema
 * and __typename. __typename is special because it can always be
 * queried as a field, even in situations where no other fields
 * are allowed, like on a Union. __schema could get automatically
 * added to the query type, but that would require mutating type
 * definitions, which would cause issues.
 */
function getFieldDef(schema, parentType, fieldName) {
  if (fieldName === __WEBPACK_IMPORTED_MODULE_14__type_introspection__["a" /* SchemaMetaFieldDef */].name && schema.getQueryType() === parentType) {
    return __WEBPACK_IMPORTED_MODULE_14__type_introspection__["a" /* SchemaMetaFieldDef */];
  } else if (fieldName === __WEBPACK_IMPORTED_MODULE_14__type_introspection__["c" /* TypeMetaFieldDef */].name && schema.getQueryType() === parentType) {
    return __WEBPACK_IMPORTED_MODULE_14__type_introspection__["c" /* TypeMetaFieldDef */];
  } else if (fieldName === __WEBPACK_IMPORTED_MODULE_14__type_introspection__["d" /* TypeNameMetaFieldDef */].name) {
    return __WEBPACK_IMPORTED_MODULE_14__type_introspection__["d" /* TypeNameMetaFieldDef */];
  }
  return parentType.getFields()[fieldName];
}

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getVariableValues;
/* harmony export (immutable) */ __webpack_exports__["a"] = getArgumentValues;
/* harmony export (immutable) */ __webpack_exports__["b"] = getDirectiveValues;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsutils_find__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsutils_isInvalid__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jsutils_keyMap__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_coerceValue__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_typeFromAST__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_valueFromAST__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__language_kinds__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__language_printer__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__type_definition__ = __webpack_require__(46);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */













/**
 * Prepares an object map of variableValues of the correct type based on the
 * provided variable definitions and arbitrary input. If the input cannot be
 * parsed to match the variable definitions, a GraphQLError will be thrown.
 *
 * Note: The returned value is a plain Object with a prototype, since it is
 * exposed to user code. Care should be taken to not pull values from the
 * Object prototype.
 */
function getVariableValues(schema, varDefNodes, inputs) {
  var errors = [];
  var coercedValues = {};
  for (var i = 0; i < varDefNodes.length; i++) {
    var varDefNode = varDefNodes[i];
    var varName = varDefNode.variable.name.value;
    var varType = Object(__WEBPACK_IMPORTED_MODULE_5__utilities_typeFromAST__["a" /* typeFromAST */])(schema, varDefNode.type);
    if (!Object(__WEBPACK_IMPORTED_MODULE_9__type_definition__["r" /* isInputType */])(varType)) {
      errors.push(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* GraphQLError */]('Variable "$' + varName + '" expected value of type ' + ('"' + Object(__WEBPACK_IMPORTED_MODULE_8__language_printer__["a" /* print */])(varDefNode.type) + '" which cannot be used as an input type.'), [varDefNode.type]));
    } else {
      var value = inputs[varName];
      if (Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_isInvalid__["a" /* default */])(value)) {
        if (Object(__WEBPACK_IMPORTED_MODULE_9__type_definition__["w" /* isNonNullType */])(varType)) {
          errors.push(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* GraphQLError */]('Variable "$' + varName + '" of required type ' + ('"' + String(varType) + '" was not provided.'), [varDefNode]));
        } else if (varDefNode.defaultValue) {
          coercedValues[varName] = Object(__WEBPACK_IMPORTED_MODULE_6__utilities_valueFromAST__["a" /* valueFromAST */])(varDefNode.defaultValue, varType);
        }
      } else {
        var _coerced = Object(__WEBPACK_IMPORTED_MODULE_4__utilities_coerceValue__["a" /* coerceValue */])(value, varType, varDefNode);
        var coercionErrors = _coerced.errors;
        if (coercionErrors) {
          (function () {
            var messagePrelude = 'Variable "$' + varName + '" got invalid value ' + JSON.stringify(value) + '; ';
            coercionErrors.forEach(function (error) {
              error.message = messagePrelude + error.message;
            });
            errors.push.apply(errors, coercionErrors);
          })();
        } else {
          coercedValues[varName] = _coerced.value;
        }
      }
    }
  }
  return errors.length === 0 ? { errors: undefined, coerced: coercedValues } : { errors: errors, coerced: undefined };
}

/**
 * Prepares an object map of argument values given a list of argument
 * definitions and list of argument AST nodes.
 *
 * Note: The returned value is a plain Object with a prototype, since it is
 * exposed to user code. Care should be taken to not pull values from the
 * Object prototype.
 */
function getArgumentValues(def, node, variableValues) {
  var coercedValues = {};
  var argDefs = def.args;
  var argNodes = node.arguments;
  if (!argDefs || !argNodes) {
    return coercedValues;
  }
  var argNodeMap = Object(__WEBPACK_IMPORTED_MODULE_3__jsutils_keyMap__["a" /* default */])(argNodes, function (arg) {
    return arg.name.value;
  });
  for (var i = 0; i < argDefs.length; i++) {
    var argDef = argDefs[i];
    var name = argDef.name;
    var argType = argDef.type;
    var argumentNode = argNodeMap[name];
    var defaultValue = argDef.defaultValue;
    if (!argumentNode) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_isInvalid__["a" /* default */])(defaultValue)) {
        coercedValues[name] = defaultValue;
      } else if (Object(__WEBPACK_IMPORTED_MODULE_9__type_definition__["w" /* isNonNullType */])(argType)) {
        throw new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* GraphQLError */]('Argument "' + name + '" of required type ' + ('"' + String(argType) + '" was not provided.'), [node]);
      }
    } else if (argumentNode.value.kind === __WEBPACK_IMPORTED_MODULE_7__language_kinds__["a" /* Kind */].VARIABLE) {
      var variableName = argumentNode.value.name.value;
      if (variableValues && Object.prototype.hasOwnProperty.call(variableValues, variableName) && !Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_isInvalid__["a" /* default */])(variableValues[variableName])) {
        // Note: this does not check that this variable value is correct.
        // This assumes that this query has been validated and the variable
        // usage here is of the correct type.
        coercedValues[name] = variableValues[variableName];
      } else if (!Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_isInvalid__["a" /* default */])(defaultValue)) {
        coercedValues[name] = defaultValue;
      } else if (Object(__WEBPACK_IMPORTED_MODULE_9__type_definition__["w" /* isNonNullType */])(argType)) {
        throw new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* GraphQLError */]('Argument "' + name + '" of required type "' + String(argType) + '" was ' + ('provided the variable "$' + variableName + '" which was not provided ') + 'a runtime value.', [argumentNode.value]);
      }
    } else {
      var valueNode = argumentNode.value;
      var coercedValue = Object(__WEBPACK_IMPORTED_MODULE_6__utilities_valueFromAST__["a" /* valueFromAST */])(valueNode, argType, variableValues);
      if (Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_isInvalid__["a" /* default */])(coercedValue)) {
        // Note: ValuesOfCorrectType validation should catch this before
        // execution. This is a runtime check to ensure execution does not
        // continue with an invalid argument value.
        throw new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* GraphQLError */]('Argument "' + name + '" has invalid value ' + Object(__WEBPACK_IMPORTED_MODULE_8__language_printer__["a" /* print */])(valueNode) + '.', [argumentNode.value]);
      }
      coercedValues[name] = coercedValue;
    }
  }
  return coercedValues;
}

/**
 * Prepares an object map of argument values given a directive definition
 * and a AST node which may contain directives. Optionally also accepts a map
 * of variable values.
 *
 * If the directive does not exist on the node, returns undefined.
 *
 * Note: The returned value is a plain Object with a prototype, since it is
 * exposed to user code. Care should be taken to not pull values from the
 * Object prototype.
 */
function getDirectiveValues(directiveDef, node, variableValues) {
  var directiveNode = node.directives && Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_find__["a" /* default */])(node.directives, function (directive) {
    return directive.name.value === directiveDef.name;
  });

  if (directiveNode) {
    return getArgumentValues(directiveDef, directiveNode, variableValues);
  }
}

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = valueFromAST;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsutils_keyMap__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsutils_isInvalid__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsutils_objectValues__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__language_kinds__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__type_definition__ = __webpack_require__(46);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */









/**
 * Produces a JavaScript value given a GraphQL Value AST.
 *
 * A GraphQL type must be provided, which will be used to interpret different
 * GraphQL Value literals.
 *
 * Returns `undefined` when the value could not be validly coerced according to
 * the provided type.
 *
 * | GraphQL Value        | JSON Value    |
 * | -------------------- | ------------- |
 * | Input Object         | Object        |
 * | List                 | Array         |
 * | Boolean              | Boolean       |
 * | String               | String        |
 * | Int / Float          | Number        |
 * | Enum Value           | Mixed         |
 * | NullValue            | null          |
 *
 */
function valueFromAST(valueNode, type, variables) {
  if (!valueNode) {
    // When there is no node, then there is also no value.
    // Importantly, this is different from returning the value null.
    return;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_4__type_definition__["w" /* isNonNullType */])(type)) {
    if (valueNode.kind === __WEBPACK_IMPORTED_MODULE_3__language_kinds__["a" /* Kind */].NULL) {
      return; // Invalid: intentionally return no value.
    }
    return valueFromAST(valueNode, type.ofType, variables);
  }

  if (valueNode.kind === __WEBPACK_IMPORTED_MODULE_3__language_kinds__["a" /* Kind */].NULL) {
    // This is explicitly returning the value null.
    return null;
  }

  if (valueNode.kind === __WEBPACK_IMPORTED_MODULE_3__language_kinds__["a" /* Kind */].VARIABLE) {
    var variableName = valueNode.name.value;
    if (!variables || Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_isInvalid__["a" /* default */])(variables[variableName])) {
      // No valid return value.
      return;
    }
    // Note: we're not doing any checking that this variable is correct. We're
    // assuming that this query has been validated and the variable usage here
    // is of the correct type.
    return variables[variableName];
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_4__type_definition__["u" /* isListType */])(type)) {
    var itemType = type.ofType;
    if (valueNode.kind === __WEBPACK_IMPORTED_MODULE_3__language_kinds__["a" /* Kind */].LIST) {
      var coercedValues = [];
      var itemNodes = valueNode.values;
      for (var i = 0; i < itemNodes.length; i++) {
        if (isMissingVariable(itemNodes[i], variables)) {
          // If an array contains a missing variable, it is either coerced to
          // null or if the item type is non-null, it considered invalid.
          if (Object(__WEBPACK_IMPORTED_MODULE_4__type_definition__["w" /* isNonNullType */])(itemType)) {
            return; // Invalid: intentionally return no value.
          }
          coercedValues.push(null);
        } else {
          var itemValue = valueFromAST(itemNodes[i], itemType, variables);
          if (Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_isInvalid__["a" /* default */])(itemValue)) {
            return; // Invalid: intentionally return no value.
          }
          coercedValues.push(itemValue);
        }
      }
      return coercedValues;
    }
    var coercedValue = valueFromAST(valueNode, itemType, variables);
    if (Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_isInvalid__["a" /* default */])(coercedValue)) {
      return; // Invalid: intentionally return no value.
    }
    return [coercedValue];
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_4__type_definition__["q" /* isInputObjectType */])(type)) {
    if (valueNode.kind !== __WEBPACK_IMPORTED_MODULE_3__language_kinds__["a" /* Kind */].OBJECT) {
      return; // Invalid: intentionally return no value.
    }
    var coercedObj = Object.create(null);
    var fieldNodes = Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_keyMap__["a" /* default */])(valueNode.fields, function (field) {
      return field.name.value;
    });
    var fields = Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_objectValues__["a" /* default */])(type.getFields());
    for (var _i = 0; _i < fields.length; _i++) {
      var field = fields[_i];
      var fieldNode = fieldNodes[field.name];
      if (!fieldNode || isMissingVariable(fieldNode.value, variables)) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_isInvalid__["a" /* default */])(field.defaultValue)) {
          coercedObj[field.name] = field.defaultValue;
        } else if (Object(__WEBPACK_IMPORTED_MODULE_4__type_definition__["w" /* isNonNullType */])(field.type)) {
          return; // Invalid: intentionally return no value.
        }
        continue;
      }
      var fieldValue = valueFromAST(fieldNode.value, field.type, variables);
      if (Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_isInvalid__["a" /* default */])(fieldValue)) {
        return; // Invalid: intentionally return no value.
      }
      coercedObj[field.name] = fieldValue;
    }
    return coercedObj;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_4__type_definition__["p" /* isEnumType */])(type)) {
    if (valueNode.kind !== __WEBPACK_IMPORTED_MODULE_3__language_kinds__["a" /* Kind */].ENUM) {
      return; // Invalid: intentionally return no value.
    }
    var enumValue = type.getValue(valueNode.value);
    if (!enumValue) {
      return; // Invalid: intentionally return no value.
    }
    return enumValue.value;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_4__type_definition__["z" /* isScalarType */])(type)) {
    // Scalars fulfill parsing a literal value via parseLiteral().
    // Invalid values represent a failure to parse correctly, in which case
    // no value is returned.
    var result = void 0;
    try {
      result = type.parseLiteral(valueNode, variables);
    } catch (_error) {
      return; // Invalid: intentionally return no value.
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_isInvalid__["a" /* default */])(result)) {
      return; // Invalid: intentionally return no value.
    }
    return result;
  }

  /* istanbul ignore next */
  throw new Error('Unknown type: ' + type + '.');
}

// Returns true if the provided valueNode is a variable which is not defined
// in the set of variables.
function isMissingVariable(valueNode, variables) {
  return valueNode.kind === __WEBPACK_IMPORTED_MODULE_3__language_kinds__["a" /* Kind */].VARIABLE && (!variables || Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_isInvalid__["a" /* default */])(variables[valueNode.name.value]));
}

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		Object.keys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	Object.keys(source).forEach(function(key) {
		if (!options.isMergeableObject(source[key]) || !target[key]) {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		} else {
			destination[key] = deepmerge(target[key], source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

/* harmony default export */ __webpack_exports__["default"] = (deepmerge_1);


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = toCssValue;
var join = function join(value, by) {
  var result = '';
  for (var i = 0; i < value.length; i++) {
    // Remove !important from the value, it will be readded later.
    if (value[i] === '!important') break;
    if (result) result += by;
    result += value[i];
  }
  return result;
};

/**
 * Converts array values to string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */
function toCssValue(value) {
  var ignoreImportant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!Array.isArray(value)) return value;

  var cssValue = '';

  // Support space separated values via `[['5px', '10px']]`.
  if (Array.isArray(value[0])) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === '!important') break;
      if (cssValue) cssValue += ', ';
      cssValue += join(value[i], ' ');
    }
  } else cssValue = join(value, ', ');

  // Add !important, because it was ignored.
  if (!ignoreImportant && value[value.length - 1] === '!important') {
    cssValue += ' !important';
  }

  return cssValue;
}

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = createRule;

var _warning = __webpack_require__(142);

var _warning2 = _interopRequireDefault(_warning);

var _StyleRule = __webpack_require__(143);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _cloneStyle = __webpack_require__(763);

var _cloneStyle2 = _interopRequireDefault(_cloneStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Create a rule instance.
 */
function createRule() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'unnamed';
  var decl = arguments[1];
  var options = arguments[2];
  var jss = options.jss;

  var declCopy = (0, _cloneStyle2['default'])(decl);

  var rule = jss.plugins.onCreateRule(name, declCopy, options);
  if (rule) return rule;

  // It is an at-rule and it has no instance.
  if (name[0] === '@') {
    (0, _warning2['default'])(false, '[JSS] Unknown at-rule %s', name);
  }

  return new _StyleRule2['default'](name, declCopy, options);
}

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isBrowser", function() { return isBrowser; });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;

/* harmony default export */ __webpack_exports__["default"] = (isBrowser);


/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ownerDocument = _interopRequireDefault(__webpack_require__(100));

function ownerWindow(node) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  var doc = (0, _ownerDocument.default)(node);
  return doc.defaultView || doc.parentView || fallback;
}

var _default = ownerWindow;
exports.default = _default;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(831);

var iterableToArray = __webpack_require__(832);

var nonIterableSpread = __webpack_require__(833);

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _InputAdornment.default;
  }
});

var _InputAdornment = _interopRequireDefault(__webpack_require__(837));

/***/ }),
/* 224 */
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FormLabel.default;
  }
});

var _FormLabel = _interopRequireDefault(__webpack_require__(853));

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Grow.default;
  }
});

var _Grow = _interopRequireDefault(__webpack_require__(875));

/***/ }),
/* 227 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Table.default;
  }
});

var _Table = _interopRequireDefault(__webpack_require__(907));

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TableBody.default;
  }
});

var _TableBody = _interopRequireDefault(__webpack_require__(913));

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TableRow.default;
  }
});

var _TableRow = _interopRequireDefault(__webpack_require__(915));

/***/ }),
/* 231 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(109);
var core = __webpack_require__(149);
var ctx = __webpack_require__(483);
var hide = __webpack_require__(150);
var has = __webpack_require__(122);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 233 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 234 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 235 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Collapse.default;
  }
});

var _Collapse = _interopRequireDefault(__webpack_require__(1005));

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Slide.default;
  }
});

var _Slide = _interopRequireDefault(__webpack_require__(1009));

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(144);

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _withWidth.default;
  }
});

var _withWidth = _interopRequireWildcard(__webpack_require__(1025));

Object.keys(_withWidth).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _withWidth[key];
    }
  });
});

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _NativeSelect.default;
  }
});

var _NativeSelect = _interopRequireDefault(__webpack_require__(476));

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
})), 'Delete');

exports.default = _default;

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Reusable_SharedSnackbar_SharedSnackbar_context__ = __webpack_require__(329);
/* harmony default export */ __webpack_exports__["a"] = (function(Component){return function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Reusable_SharedSnackbar_SharedSnackbar_context__["a" /* SharedSnackbarConsumer */],null,function(_ref){var openSnackbar=_ref.openSnackbar;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,Object.assign({openSnackbar:openSnackbar},props));});};});

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16.5 12c1.38 0 2.49-1.12 2.49-2.5S17.88 7 16.5 7C15.12 7 14 8.12 14 9.5s1.12 2.5 2.5 2.5zM9 11c1.66 0 2.99-1.34 2.99-3S10.66 5 9 5C7.34 5 6 6.34 6 8s1.34 3 3 3zm7.5 3c-1.83 0-5.5.92-5.5 2.75V19h11v-2.25c0-1.83-3.67-2.75-5.5-2.75zM9 13c-2.33 0-7 1.17-7 3.5V19h7v-2.25c0-.85.33-2.34 2.37-3.47C10.5 13.1 9.66 13 9 13z"
})), 'SupervisorAccount');

exports.default = _default;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.99 4c0-1.1-.89-2-1.99-2h-8L4 8v12c0 1.1.9 2 2 2h12.01c1.1 0 1.99-.9 1.99-2l-.01-16zM9 19H7v-2h2v2zm8 0h-2v-2h2v2zm-8-4H7v-4h2v4zm4 4h-2v-4h2v4zm0-6h-2v-2h2v2zm4 2h-2v-4h2v4z"
})), 'SimCard');

exports.default = _default;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 9V7h-2V5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2v-2h-2V9h2zm-4 10H4V5h14v14zM6 13h5v4H6zm6-6h4v3h-4zM6 7h5v5H6zm6 4h4v6h-4z"
})), 'DeveloperBoard');

exports.default = _default;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 6.92l-1.41-1.41-2.85 3.21C15.68 6.4 12.83 5 9.61 5 6.72 5 4.07 6.16 2 8l1.42 1.42C5.12 7.93 7.27 7 9.61 7c2.74 0 5.09 1.26 6.77 3.24l-2.88 3.24-4-4L2 16.99l1.5 1.5 6-6.01 4 4 4.05-4.55c.75 1.35 1.25 2.9 1.44 4.55H21c-.22-2.3-.95-4.39-2.04-6.14L22 6.92z"
})), 'MultilineChart');

exports.default = _default;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M2.53 19.65l1.34.56v-9.03l-2.43 5.86c-.41 1.02.08 2.19 1.09 2.61zm19.5-3.7L17.07 3.98c-.31-.75-1.04-1.21-1.81-1.23-.26 0-.53.04-.79.15L7.1 5.95c-.75.31-1.21 1.03-1.23 1.8-.01.27.04.54.15.8l4.96 11.97c.31.76 1.05 1.22 1.83 1.23.26 0 .52-.05.77-.15l7.36-3.05c1.02-.42 1.51-1.59 1.09-2.6zM7.88 8.75c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-2 11c0 1.1.9 2 2 2h1.45l-3.45-8.34v6.34z"
})), 'Style');

exports.default = _default;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M14 10H2v2h12v-2zm0-4H2v2h12V6zM2 16h8v-2H2v2zm19.5-4.5L23 13l-6.99 7-4.51-4.5L13 14l3.01 3 5.49-5.5z"
})), 'PlaylistAddCheck');

exports.default = _default;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11 9h2V6h3V4h-3V1h-2v3H8v2h3v3zm-4 9c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm-9.83-3.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.86-7.01L19.42 4h-.01l-1.1 2-2.76 5H8.53l-.13-.27L6.16 6l-.95-2-.94-2H1v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.13 0-.25-.11-.25-.25z"
})), 'AddShoppingCart');

exports.default = _default;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



if (true) {
  module.exports = __webpack_require__(1110)
} else {
  module.exports = require('./multiselect-react-dropdown.cjs.development.js')
}


/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_NoSsr__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_NoSsr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_NoSsr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Chip__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Chip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Chip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles_colorManipulator__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles_colorManipulator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles_colorManipulator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_graphql_tag__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getStatesByCountryId($countryId: Int!) {\n    allStatesByCountryId(country_id: $countryId) {\n      name\n      zone_id\n    }\n  }\n'],['\n  query getStatesByCountryId($countryId: Int!) {\n    allStatesByCountryId(country_id: $countryId) {\n      name\n      zone_id\n    }\n  }\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_STATES_FOR_COUNTRY=Object(__WEBPACK_IMPORTED_MODULE_12_graphql_tag__["a" /* default */])(_templateObject);var styles=function styles(theme){return{root:{flexGrow:1},input:{display:'flex',padding:0},valueContainer:{display:'flex',flex:1,alignItems:'center'},chip:{margin:theme.spacing.unit/2+'px '+theme.spacing.unit/4+'px'},chipFocused:{backgroundColor:Object(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles_colorManipulator__["emphasize"])(theme.palette.type==='light'?theme.palette.grey[300]:theme.palette.grey[700],0.08)},noOptionsMessage:{fontSize:16,padding:theme.spacing.unit+'px '+theme.spacing.unit*2+'px'},singleValue:{fontSize:16},placeholder:{position:'absolute',left:2,fontSize:16}};};function NoOptionsMessage(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,Object.assign({color:'textSecondary',className:props.selectProps.classes.noOptionsMessage},props.innerProps),props.children);}function inputComponent(_ref){var inputRef=_ref.inputRef,props=_objectWithoutProperties(_ref,['inputRef']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({ref:inputRef},props));}function Control(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a,{fullWidth:true,InputProps:{inputComponent:inputComponent,inputProps:Object.assign({className:props.selectProps.classes.input,ref:props.innerRef,children:props.children},props.innerProps)}});}function Option(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default.a,Object.assign({buttonRef:props.innerRef,selected:props.isFocused,component:'div',style:{fontWeight:props.isSelected?500:400}},props.innerProps),props.children);}function Placeholder(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,Object.assign({color:'textSecondary',className:props.selectProps.classes.placeholder},props.innerProps),props.children);}function SingleValue(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,Object.assign({className:props.selectProps.classes.singleValue},props.innerProps),props.children);}function ValueContainer(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:props.selectProps.classes.valueContainer},props.children);}function MultiValue(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Chip___default.a,{tabIndex:-1,label:props.children,className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(props.selectProps.classes.chip,_defineProperty({},props.selectProps.classes.chipFocused,props.isFocused)),onDelete:function onDelete(event){props.removeProps.onClick();props.removeProps.onMouseDown(event);}});}var components={Option:Option,Control:Control,NoOptionsMessage:NoOptionsMessage,Placeholder:Placeholder,SingleValue:SingleValue,MultiValue:MultiValue,ValueContainer:ValueContainer};var States=function(_React$Component){_inherits(States,_React$Component);function States(){_classCallCheck(this,States);return _possibleConstructorReturn(this,(States.__proto__||Object.getPrototypeOf(States)).apply(this,arguments));}_createClass(States,[{key:'render',value:function render(){var _this2=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["Query"],{query:GET_STATES_FOR_COUNTRY,variables:{countryId:parseInt(this.props.countryId,10)}},function(_ref2){var loading=_ref2.loading,error=_ref2.error,allStatesByCountryId=_ref2.data.allStatesByCountryId;if(loading)return'Loading...';if(error)return'Error!: '+error;var sortedStates=allStatesByCountryId.map(function(state){return{value:state.zone_id,label:state.name};});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_NoSsr___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{classes:classes,options:sortedStates,components:components,value:_this2.props.zoneId,onChange:_this2.props.handleStateChange,placeholder:'Select State *'})));});}}]);return States;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);States.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__["withStyles"])(styles)(States));

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var style=function style(theme){return{// root: {
//   padding: theme.spacing.unit * 4,
//   flexGrow: 1,
//   backgroundColor: theme.palette.background.paper
// },
// paper: {
//   padding: theme.spacing.unit * 2,
//   textAlign: 'center',
//   color: theme.palette.text.secondary
// },
// iconSmall: {
//   fontSize: 20
// },
// selectStyle: {
//   margin: theme.spacing.unit,
//   minWidth: 250
// },
textField:{// marginLeft: theme.spacing.unit,
marginRight:theme.spacing.unit,minWidth:250// pad: {
//   padding: theme.spacing.unit * 2
// }
}};};var PaymentMethod=function(_Component){_inherits(PaymentMethod,_Component);function PaymentMethod(){_classCallCheck(this,PaymentMethod);return _possibleConstructorReturn(this,(PaymentMethod.__proto__||Object.getPrototypeOf(PaymentMethod)).apply(this,arguments));}_createClass(PaymentMethod,[{key:'render',value:function render(){var _props=this.props,classes=_props.classes,isValidReferenceNumber=_props.isValidReferenceNumber,checkReferenceNumberValidity=_props.checkReferenceNumberValidity,referenceMessage=_props.referenceMessage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.paymentThrough==='ONLINE'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row',justify:'flex-start',alignItems:'flex-start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_TextField___default.a,{id:'Transaction ID',label:'Transaction ID',className:classes.textField,margin:'none',variant:'outlined',onChange:this.props.handleChangereferenceNumber,value:this.props.referenceNumber// error={!isValidReferenceNumber}
,onBlur:checkReferenceNumberValidity,helperText:this.props.referenceMessage}))))||this.props.paymentThrough==='CASH'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row',justify:'flex-start',alignItems:'flex-start'}))||this.props.paymentThrough==='CHEQUE'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row',justify:'flex-start',alignItems:'flex-start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_TextField___default.a,{id:'Cheque No',label:'Cheque No.',className:classes.textField,margin:'none',variant:'outlined',onChange:this.props.handleChangereferenceNumber,value:this.props.referenceNumber// error={!isValidReferenceNumber}
,onBlur:checkReferenceNumberValidity,helperText:referenceMessage})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_TextField___default.a,{id:'outlined-uncontrolled',label:'Bank Name',className:classes.textField,margin:'none',variant:'outlined',value:this.props.bankName,onChange:this.props.handleChangeBankName}))))||this.props.paymentThrough==='DD'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row',justify:'flex-start',alignItems:'flex-start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_TextField___default.a,{id:'DD No',label:'DD No.',className:classes.textField,margin:'none',variant:'outlined',onChange:this.props.handleChangereferenceNumber,value:this.props.referenceNumber// error={!isValidReferenceNumber}
,onBlur:checkReferenceNumberValidity,helperText:this.props.referenceMessage})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_TextField___default.a,{id:'Bank Name',label:'Bank Name',className:classes.textField,margin:'none',variant:'outlined',value:this.props.bankName,onChange:this.props.handleChangeBankName})))));}}]);return PaymentMethod;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__["withStyles"])(style)(PaymentMethod));

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
})), 'Business');

exports.default = _default;

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b = +b, function(t) {
    return a * (1 - t) + b * t;
  };
});


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}



exports.__esModule = true;
exports['default'] = stripStyle;

function stripStyle(style) {
  var ret = {};
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }
    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = deinterpolateLinear;
/* harmony export (immutable) */ __webpack_exports__["a"] = copy;
/* harmony export (immutable) */ __webpack_exports__["b"] = continuous;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(576);






var unit = [0, 1];

function deinterpolateLinear(a, b) {
  return (b -= (a = +a))
      ? function(x) { return (x - a) / b; }
      : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(b);
}

function deinterpolateClamp(deinterpolate) {
  return function(a, b) {
    var d = deinterpolate(a = +a, b = +b);
    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
  };
}

function reinterpolateClamp(reinterpolate) {
  return function(a, b) {
    var r = reinterpolate(a = +a, b = +b);
    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
  };
}

function bimap(domain, range, deinterpolate, reinterpolate) {
  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
  return function(x) { return r0(d0(x)); };
}

function polymap(domain, range, deinterpolate, reinterpolate) {
  var j = Math.min(domain.length, range.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }

  while (++i < j) {
    d[i] = deinterpolate(domain[i], domain[i + 1]);
    r[i] = reinterpolate(range[i], range[i + 1]);
  }

  return function(x) {
    var i = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* bisect */])(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}

function copy(source, target) {
  return target
      .domain(source.domain())
      .range(source.range())
      .interpolate(source.interpolate())
      .clamp(source.clamp());
}

// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
function continuous(deinterpolate, reinterpolate) {
  var domain = unit,
      range = unit,
      interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["a" /* interpolate */],
      clamp = false,
      piecewise,
      output,
      input;

  function rescale() {
    piecewise = Math.min(domain.length, range.length) > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return (output || (output = piecewise(domain, range, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate)))(+x);
  }

  scale.invert = function(y) {
    return (input || (input = piecewise(range, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
  };

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_2__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]), rescale()) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["d" /* interpolateRound */], rescale();
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, rescale()) : clamp;
  };

  scale.interpolate = function(_) {
    return arguments.length ? (interpolate = _, rescale()) : interpolate;
  };

  return rescale();
}


/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__ = __webpack_require__(257);


/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__["b" /* formatDecimalParts */])(Math.abs(x)), x ? x[1] : NaN;
});


/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = formatDecimalParts;
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return Math.abs(x = Math.round(x)) >= 1e21
      ? x.toLocaleString("en").replace(/,/g, "")
      : x.toString(10);
});

// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function formatDecimalParts(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i, coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x.slice(i + 1)
  ];
}


/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function Linear(context) {
  this._context = context;
}

Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: this._context.lineTo(x, y); break;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new Linear(context);
});


/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {});


/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = point;
/* harmony export (immutable) */ __webpack_exports__["a"] = Basis;
function point(that, x, y) {
  that._context.bezierCurveTo(
    (2 * that._x0 + that._x1) / 3,
    (2 * that._y0 + that._y1) / 3,
    (that._x0 + 2 * that._x1) / 3,
    (that._y0 + 2 * that._y1) / 3,
    (that._x0 + 4 * that._x1 + x) / 6,
    (that._y0 + 4 * that._y1 + y) / 6
  );
}

function Basis(context) {
  this._context = context;
}

Basis.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3: point(this, this._x1, this._y1); // proceed
      case 2: this._context.lineTo(this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
      default: point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ __webpack_exports__["b"] = (function(context) {
  return new Basis(context);
});


/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = point;
/* harmony export (immutable) */ __webpack_exports__["a"] = Cardinal;
function point(that, x, y) {
  that._context.bezierCurveTo(
    that._x1 + that._k * (that._x2 - that._x0),
    that._y1 + that._k * (that._y2 - that._y0),
    that._x2 + that._k * (that._x1 - x),
    that._y2 + that._k * (that._y1 - y),
    that._x2,
    that._y2
  );
}

function Cardinal(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

Cardinal.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: point(this, this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
      case 2: this._point = 3; // proceed
      default: point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["b"] = ((function custom(tension) {

  function cardinal(context) {
    return new Cardinal(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = rotateRadians;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose_js__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math_js__ = __webpack_require__(36);



function rotationIdentity(lambda, phi) {
  return [Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["a" /* abs */])(lambda) > __WEBPACK_IMPORTED_MODULE_1__math_js__["o" /* pi */] ? lambda + Math.round(-lambda / __WEBPACK_IMPORTED_MODULE_1__math_js__["w" /* tau */]) * __WEBPACK_IMPORTED_MODULE_1__math_js__["w" /* tau */] : lambda, phi];
}

rotationIdentity.invert = rotationIdentity;

function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
  return (deltaLambda %= __WEBPACK_IMPORTED_MODULE_1__math_js__["w" /* tau */]) ? (deltaPhi || deltaGamma ? Object(__WEBPACK_IMPORTED_MODULE_0__compose_js__["a" /* default */])(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma))
    : rotationLambda(deltaLambda))
    : (deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma)
    : rotationIdentity);
}

function forwardRotationLambda(deltaLambda) {
  return function(lambda, phi) {
    return lambda += deltaLambda, [lambda > __WEBPACK_IMPORTED_MODULE_1__math_js__["o" /* pi */] ? lambda - __WEBPACK_IMPORTED_MODULE_1__math_js__["w" /* tau */] : lambda < -__WEBPACK_IMPORTED_MODULE_1__math_js__["o" /* pi */] ? lambda + __WEBPACK_IMPORTED_MODULE_1__math_js__["w" /* tau */] : lambda, phi];
  };
}

function rotationLambda(deltaLambda) {
  var rotation = forwardRotationLambda(deltaLambda);
  rotation.invert = forwardRotationLambda(-deltaLambda);
  return rotation;
}

function rotationPhiGamma(deltaPhi, deltaGamma) {
  var cosDeltaPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["g" /* cos */])(deltaPhi),
      sinDeltaPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["t" /* sin */])(deltaPhi),
      cosDeltaGamma = Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["g" /* cos */])(deltaGamma),
      sinDeltaGamma = Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["t" /* sin */])(deltaGamma);

  function rotation(lambda, phi) {
    var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["g" /* cos */])(phi),
        x = Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["g" /* cos */])(lambda) * cosPhi,
        y = Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["t" /* sin */])(lambda) * cosPhi,
        z = Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["t" /* sin */])(phi),
        k = z * cosDeltaPhi + x * sinDeltaPhi;
    return [
      Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["e" /* atan2 */])(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
      Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["c" /* asin */])(k * cosDeltaGamma + y * sinDeltaGamma)
    ];
  }

  rotation.invert = function(lambda, phi) {
    var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["g" /* cos */])(phi),
        x = Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["g" /* cos */])(lambda) * cosPhi,
        y = Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["t" /* sin */])(lambda) * cosPhi,
        z = Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["t" /* sin */])(phi),
        k = z * cosDeltaGamma - y * sinDeltaGamma;
    return [
      Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["e" /* atan2 */])(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
      Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["c" /* asin */])(k * cosDeltaPhi - x * sinDeltaPhi)
    ];
  };

  return rotation;
}

/* harmony default export */ __webpack_exports__["a"] = (function(rotate) {
  rotate = rotateRadians(rotate[0] * __WEBPACK_IMPORTED_MODULE_1__math_js__["r" /* radians */], rotate[1] * __WEBPACK_IMPORTED_MODULE_1__math_js__["r" /* radians */], rotate.length > 2 ? rotate[2] * __WEBPACK_IMPORTED_MODULE_1__math_js__["r" /* radians */] : 0);

  function forward(coordinates) {
    coordinates = rotate(coordinates[0] * __WEBPACK_IMPORTED_MODULE_1__math_js__["r" /* radians */], coordinates[1] * __WEBPACK_IMPORTED_MODULE_1__math_js__["r" /* radians */]);
    return coordinates[0] *= __WEBPACK_IMPORTED_MODULE_1__math_js__["h" /* degrees */], coordinates[1] *= __WEBPACK_IMPORTED_MODULE_1__math_js__["h" /* degrees */], coordinates;
  }

  forward.invert = function(coordinates) {
    coordinates = rotate.invert(coordinates[0] * __WEBPACK_IMPORTED_MODULE_1__math_js__["r" /* radians */], coordinates[1] * __WEBPACK_IMPORTED_MODULE_1__math_js__["r" /* radians */]);
    return coordinates[0] *= __WEBPACK_IMPORTED_MODULE_1__math_js__["h" /* degrees */], coordinates[1] *= __WEBPACK_IMPORTED_MODULE_1__math_js__["h" /* degrees */], coordinates;
  };

  return forward;
});


/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = clipRectangle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__buffer_js__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__line_js__ = __webpack_require__(2219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rejoin_js__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_array__ = __webpack_require__(70);






var clipMax = 1e9, clipMin = -clipMax;

// TODO Use d3-polygon’s polygonContains here for the ring check?
// TODO Eliminate duplicate buffering in clipBuffer and polygon.push?

function clipRectangle(x0, y0, x1, y1) {

  function visible(x, y) {
    return x0 <= x && x <= x1 && y0 <= y && y <= y1;
  }

  function interpolate(from, to, direction, stream) {
    var a = 0, a1 = 0;
    if (from == null
        || (a = corner(from, direction)) !== (a1 = corner(to, direction))
        || comparePoint(from, to) < 0 ^ direction > 0) {
      do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
      while ((a = (a + direction + 4) % 4) !== a1);
    } else {
      stream.point(to[0], to[1]);
    }
  }

  function corner(p, direction) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["a" /* abs */])(p[0] - x0) < __WEBPACK_IMPORTED_MODULE_0__math_js__["i" /* epsilon */] ? direction > 0 ? 0 : 3
        : Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["a" /* abs */])(p[0] - x1) < __WEBPACK_IMPORTED_MODULE_0__math_js__["i" /* epsilon */] ? direction > 0 ? 2 : 1
        : Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["a" /* abs */])(p[1] - y0) < __WEBPACK_IMPORTED_MODULE_0__math_js__["i" /* epsilon */] ? direction > 0 ? 1 : 0
        : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
  }

  function compareIntersection(a, b) {
    return comparePoint(a.x, b.x);
  }

  function comparePoint(a, b) {
    var ca = corner(a, 1),
        cb = corner(b, 1);
    return ca !== cb ? ca - cb
        : ca === 0 ? b[1] - a[1]
        : ca === 1 ? a[0] - b[0]
        : ca === 2 ? a[1] - b[1]
        : b[0] - a[0];
  }

  return function(stream) {
    var activeStream = stream,
        bufferStream = Object(__WEBPACK_IMPORTED_MODULE_1__buffer_js__["a" /* default */])(),
        segments,
        polygon,
        ring,
        x__, y__, v__, // first point
        x_, y_, v_, // previous point
        first,
        clean;

    var clipStream = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: polygonStart,
      polygonEnd: polygonEnd
    };

    function point(x, y) {
      if (visible(x, y)) activeStream.point(x, y);
    }

    function polygonInside() {
      var winding = 0;

      for (var i = 0, n = polygon.length; i < n; ++i) {
        for (var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j) {
          a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
          if (a1 <= y1) { if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding; }
          else { if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding; }
        }
      }

      return winding;
    }

    // Buffer geometry within a polygon and then clip it en masse.
    function polygonStart() {
      activeStream = bufferStream, segments = [], polygon = [], clean = true;
    }

    function polygonEnd() {
      var startInside = polygonInside(),
          cleanInside = clean && startInside,
          visible = (segments = Object(__WEBPACK_IMPORTED_MODULE_4_d3_array__["f" /* merge */])(segments)).length;
      if (cleanInside || visible) {
        stream.polygonStart();
        if (cleanInside) {
          stream.lineStart();
          interpolate(null, null, 1, stream);
          stream.lineEnd();
        }
        if (visible) {
          Object(__WEBPACK_IMPORTED_MODULE_3__rejoin_js__["a" /* default */])(segments, compareIntersection, startInside, interpolate, stream);
        }
        stream.polygonEnd();
      }
      activeStream = stream, segments = polygon = ring = null;
    }

    function lineStart() {
      clipStream.point = linePoint;
      if (polygon) polygon.push(ring = []);
      first = true;
      v_ = false;
      x_ = y_ = NaN;
    }

    // TODO rather than special-case polygons, simply handle them separately.
    // Ideally, coincident intersection points should be jittered to avoid
    // clipping issues.
    function lineEnd() {
      if (segments) {
        linePoint(x__, y__);
        if (v__ && v_) bufferStream.rejoin();
        segments.push(bufferStream.result());
      }
      clipStream.point = point;
      if (v_) activeStream.lineEnd();
    }

    function linePoint(x, y) {
      var v = visible(x, y);
      if (polygon) ring.push([x, y]);
      if (first) {
        x__ = x, y__ = y, v__ = v;
        first = false;
        if (v) {
          activeStream.lineStart();
          activeStream.point(x, y);
        }
      } else {
        if (v && v_) activeStream.point(x, y);
        else {
          var a = [x_ = Math.max(clipMin, Math.min(clipMax, x_)), y_ = Math.max(clipMin, Math.min(clipMax, y_))],
              b = [x = Math.max(clipMin, Math.min(clipMax, x)), y = Math.max(clipMin, Math.min(clipMax, y))];
          if (Object(__WEBPACK_IMPORTED_MODULE_2__line_js__["a" /* default */])(a, b, x0, y0, x1, y1)) {
            if (!v_) {
              activeStream.lineStart();
              activeStream.point(a[0], a[1]);
            }
            activeStream.point(b[0], b[1]);
            if (!v) activeStream.lineEnd();
            clean = false;
          } else if (v) {
            activeStream.lineStart();
            activeStream.point(x, y);
            clean = false;
          }
        }
      }
      x_ = x, y_ = y, v_ = v;
    }

    return clipStream;
  };
}


/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = transformer;
/* unused harmony default export */ var _unused_webpack_default_export = (function(methods) {
  return {
    stream: transformer(methods)
  };
});

function transformer(methods) {
  return function(stream) {
    var s = new TransformStream;
    for (var key in methods) s[key] = methods[key];
    s.stream = stream;
    return s;
  };
}

function TransformStream() {}

TransformStream.prototype = {
  constructor: TransformStream,
  point: function(x, y) { this.stream.point(x, y); },
  sphere: function() { this.stream.sphere(); },
  lineStart: function() { this.stream.lineStart(); },
  lineEnd: function() { this.stream.lineEnd(); },
  polygonStart: function() { this.stream.polygonStart(); },
  polygonEnd: function() { this.stream.polygonEnd(); }
};


/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__animation__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_series_utils__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_react_utils__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__theme__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__abstract_series__ = __webpack_require__(48);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.












var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--mark';
var DEFAULT_STROKE_WIDTH = 1;

var MarkSeries = function (_AbstractSeries) {
  _inherits(MarkSeries, _AbstractSeries);

  function MarkSeries() {
    _classCallCheck(this, MarkSeries);

    return _possibleConstructorReturn(this, (MarkSeries.__proto__ || Object.getPrototypeOf(MarkSeries)).apply(this, arguments));
  }

  _createClass(MarkSeries, [{
    key: '_renderCircle',
    value: function _renderCircle(d, i, strokeWidth, style, scalingFunctions) {
      var _this2 = this;

      var fill = scalingFunctions.fill,
          opacity = scalingFunctions.opacity,
          size = scalingFunctions.size,
          stroke = scalingFunctions.stroke,
          x = scalingFunctions.x,
          y = scalingFunctions.y;


      var attrs = {
        r: size ? size(d) : __WEBPACK_IMPORTED_MODULE_5__theme__["d" /* DEFAULT_SIZE */],
        cx: x(d),
        cy: y(d),
        style: _extends({
          opacity: opacity ? opacity(d) : __WEBPACK_IMPORTED_MODULE_5__theme__["c" /* DEFAULT_OPACITY */],
          stroke: stroke && stroke(d),
          fill: fill && fill(d),
          strokeWidth: strokeWidth || DEFAULT_STROKE_WIDTH
        }, style),
        key: i,
        onClick: function onClick(e) {
          return _this2._valueClickHandler(d, e);
        },
        onContextMenu: function onContextMenu(e) {
          return _this2._valueRightClickHandler(d, e);
        },
        onMouseOver: function onMouseOver(e) {
          return _this2._valueMouseOverHandler(d, e);
        },
        onMouseOut: function onMouseOut(e) {
          return _this2._valueMouseOutHandler(d, e);
        }
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle', attrs);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          animation = _props.animation,
          className = _props.className,
          data = _props.data,
          marginLeft = _props.marginLeft,
          marginTop = _props.marginTop,
          strokeWidth = _props.strokeWidth,
          style = _props.style;


      if (this.props.nullAccessor) {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_react_utils__["b" /* warning */])('nullAccessor has been renamed to getNull', true);
      }

      var getNull = this.props.nullAccessor || this.props.getNull;

      if (!data) {
        return null;
      }

      if (animation) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__animation__["b" /* default */],
          _extends({}, this.props, { animatedProps: __WEBPACK_IMPORTED_MODULE_3__utils_series_utils__["a" /* ANIMATED_SERIES_PROPS */] }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MarkSeries, _extends({}, this.props, { animation: null }))
        );
      }

      var scalingFunctions = {
        fill: this._getAttributeFunctor('fill') || this._getAttributeFunctor('color'),
        opacity: this._getAttributeFunctor('opacity'),
        size: this._getAttributeFunctor('size'),
        stroke: this._getAttributeFunctor('stroke') || this._getAttributeFunctor('color'),
        x: this._getAttributeFunctor('x'),
        y: this._getAttributeFunctor('y')
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        {
          className: predefinedClassName + ' ' + className,
          transform: 'translate(' + marginLeft + ',' + marginTop + ')'
        },
        data.map(function (d, i) {
          return getNull(d) && _this3._renderCircle(d, i, strokeWidth, style, scalingFunctions);
        })
      );
    }
  }]);

  return MarkSeries;
}(__WEBPACK_IMPORTED_MODULE_6__abstract_series__["a" /* default */]);

MarkSeries.displayName = 'MarkSeries';
MarkSeries.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_6__abstract_series__["a" /* default */].propTypes, {
  getNull: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  strokeWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
});
MarkSeries.defaultProps = {
  getNull: function getNull() {
    return true;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (MarkSeries);

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      node,
      i = -1,
      n = nodes.length,
      k = parent.value && (y1 - y0) / parent.value;

  while (++i < n) {
    node = nodes[i], node.x0 = x0, node.x1 = x1;
    node.y0 = y0, node.y1 = y0 += node.value * k;
  }
});


/***/ }),
/* 267 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(379);
var IE8_DOM_DEFINE = __webpack_require__(2471);
var toPrimitive = __webpack_require__(2472);
var dP = Object.defineProperty;

exports.f = __webpack_require__(205) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 269 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AuthProvider__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AuthConsumer__ = __webpack_require__(817);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__components_AuthProvider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__components_AuthConsumer__["a"]; });


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"
})), 'AccountCircle');

exports.default = _default;

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

/* harmony default export */ __webpack_exports__["a"] = (process && "production" !== 'production' ? // eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
  if (value instanceof constructor) {
    return true;
  }
  if (value) {
    var valueClass = value.constructor;
    var className = constructor.name;
    if (valueClass && valueClass.name === className) {
      throw new Error('Cannot use ' + className + ' "' + value + '" from another module or realm.\n\nEnsure that there is only one instance of "graphql" in the node_modules\ndirectory. If different versions of "graphql" are the dependencies of other\nrelied on modules, use "resolutions" to ensure only one version is installed.\n\nhttps://yarnpkg.com/en/docs/selective-version-resolutions\n\nDuplicate "graphql" modules cannot be used at the same time since different\nversions may have different capabilities and behavior. The data from one\nversion used in the function from another could produce confusing and\nspurious results.');
    }
  }
  return false;
} : // eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
  return value instanceof constructor;
}); /**
    * Copyright (c) 2015-present, Facebook, Inc.
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    *
    *  strict
    */

/**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 */
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(137)))

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = astFromValue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_iterall__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsutils_isNullish__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsutils_isInvalid__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jsutils_objectValues__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__language_kinds__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__type_definition__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__type_scalars__ = __webpack_require__(104);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */












/**
 * Produces a GraphQL Value AST given a JavaScript value.
 *
 * A GraphQL type must be provided, which will be used to interpret different
 * JavaScript values.
 *
 * | JSON Value    | GraphQL Value        |
 * | ------------- | -------------------- |
 * | Object        | Input Object         |
 * | Array         | List                 |
 * | Boolean       | Boolean              |
 * | String        | String / Enum Value  |
 * | Number        | Int / Float          |
 * | Mixed         | Enum Value           |
 * | null          | NullValue            |
 *
 */
function astFromValue(value, type) {
  if (Object(__WEBPACK_IMPORTED_MODULE_5__type_definition__["w" /* isNonNullType */])(type)) {
    var astValue = astFromValue(value, type.ofType);
    if (astValue && astValue.kind === __WEBPACK_IMPORTED_MODULE_4__language_kinds__["a" /* Kind */].NULL) {
      return null;
    }
    return astValue;
  }

  // only explicit null, not undefined, NaN
  if (value === null) {
    return { kind: __WEBPACK_IMPORTED_MODULE_4__language_kinds__["a" /* Kind */].NULL };
  }

  // undefined, NaN
  if (Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_isInvalid__["a" /* default */])(value)) {
    return null;
  }

  // Convert JavaScript array to GraphQL list. If the GraphQLType is a list, but
  // the value is not an array, convert the value using the list's item type.
  if (Object(__WEBPACK_IMPORTED_MODULE_5__type_definition__["u" /* isListType */])(type)) {
    var itemType = type.ofType;
    if (Object(__WEBPACK_IMPORTED_MODULE_0_iterall__["e" /* isCollection */])(value)) {
      var valuesNodes = [];
      Object(__WEBPACK_IMPORTED_MODULE_0_iterall__["b" /* forEach */])(value, function (item) {
        var itemNode = astFromValue(item, itemType);
        if (itemNode) {
          valuesNodes.push(itemNode);
        }
      });
      return { kind: __WEBPACK_IMPORTED_MODULE_4__language_kinds__["a" /* Kind */].LIST, values: valuesNodes };
    }
    return astFromValue(value, itemType);
  }

  // Populate the fields of the input object by creating ASTs from each value
  // in the JavaScript object according to the fields in the input type.
  if (Object(__WEBPACK_IMPORTED_MODULE_5__type_definition__["q" /* isInputObjectType */])(type)) {
    if (value === null || (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
      return null;
    }
    var fields = Object(__WEBPACK_IMPORTED_MODULE_3__jsutils_objectValues__["a" /* default */])(type.getFields());
    var fieldNodes = [];
    fields.forEach(function (field) {
      var fieldValue = astFromValue(value[field.name], field.type);
      if (fieldValue) {
        fieldNodes.push({
          kind: __WEBPACK_IMPORTED_MODULE_4__language_kinds__["a" /* Kind */].OBJECT_FIELD,
          name: { kind: __WEBPACK_IMPORTED_MODULE_4__language_kinds__["a" /* Kind */].NAME, value: field.name },
          value: fieldValue
        });
      }
    });
    return { kind: __WEBPACK_IMPORTED_MODULE_4__language_kinds__["a" /* Kind */].OBJECT, fields: fieldNodes };
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_5__type_definition__["z" /* isScalarType */])(type) || Object(__WEBPACK_IMPORTED_MODULE_5__type_definition__["p" /* isEnumType */])(type)) {
    // Since value is an internally represented value, it must be serialized
    // to an externally represented value before converting into an AST.
    var serialized = type.serialize(value);
    if (Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_isNullish__["a" /* default */])(serialized)) {
      return null;
    }

    // Others serialize based on their corresponding JavaScript scalar types.
    if (typeof serialized === 'boolean') {
      return { kind: __WEBPACK_IMPORTED_MODULE_4__language_kinds__["a" /* Kind */].BOOLEAN, value: serialized };
    }

    // JavaScript numbers can be Int or Float values.
    if (typeof serialized === 'number') {
      var stringNum = String(serialized);
      return integerStringRegExp.test(stringNum) ? { kind: __WEBPACK_IMPORTED_MODULE_4__language_kinds__["a" /* Kind */].INT, value: stringNum } : { kind: __WEBPACK_IMPORTED_MODULE_4__language_kinds__["a" /* Kind */].FLOAT, value: stringNum };
    }

    if (typeof serialized === 'string') {
      // Enum types use Enum literals.
      if (Object(__WEBPACK_IMPORTED_MODULE_5__type_definition__["p" /* isEnumType */])(type)) {
        return { kind: __WEBPACK_IMPORTED_MODULE_4__language_kinds__["a" /* Kind */].ENUM, value: serialized };
      }

      // ID types can use Int literals.
      if (type === __WEBPACK_IMPORTED_MODULE_6__type_scalars__["b" /* GraphQLID */] && integerStringRegExp.test(serialized)) {
        return { kind: __WEBPACK_IMPORTED_MODULE_4__language_kinds__["a" /* Kind */].INT, value: serialized };
      }

      return {
        kind: __WEBPACK_IMPORTED_MODULE_4__language_kinds__["a" /* Kind */].STRING,
        value: serialized
      };
    }

    throw new TypeError('Cannot convert value to AST: ' + String(serialized));
  }

  /* istanbul ignore next */
  throw new Error('Unknown type: ' + type + '.');
}

/**
 * IntValue:
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit ( Digit+ )?
 */
var integerStringRegExp = /^-?(0|[1-9][0-9]*)$/;

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getLocation;


/**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

function getLocation(source, position) {
  var lineRegexp = /\r\n|[\n\r]/g;
  var line = 1;
  var column = position + 1;
  var match = void 0;
  while ((match = lineRegexp.exec(source.body)) && match.index < position) {
    line += 1;
    column = position + 1 - (match.index + match[0].length);
  }
  return { line: line, column: column };
}

/**
 * Represents a location in a Source.
 */

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createLexer;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TokenKind; });
/* harmony export (immutable) */ __webpack_exports__["c"] = getTokenDesc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__blockStringValue__ = __webpack_require__(394);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */




/**
 * Given a Source object, this returns a Lexer for that source.
 * A Lexer is a stateful stream generator in that every time
 * it is advanced, it returns the next token in the Source. Assuming the
 * source lexes, the final Token emitted by the lexer will be of kind
 * EOF, after which the lexer will repeatedly return the same EOF token
 * whenever called.
 */
function createLexer(source, options) {
  var startOfFileToken = new Tok(TokenKind.SOF, 0, 0, 0, 0, null);
  var lexer = {
    source: source,
    options: options,
    lastToken: startOfFileToken,
    token: startOfFileToken,
    line: 1,
    lineStart: 0,
    advance: advanceLexer,
    lookahead: lookahead
  };
  return lexer;
}

function advanceLexer() {
  this.lastToken = this.token;
  var token = this.token = this.lookahead();
  return token;
}

function lookahead() {
  var token = this.token;
  if (token.kind !== TokenKind.EOF) {
    do {
      // Note: next is only mutable during parsing, so we cast to allow this.
      token = token.next || (token.next = readToken(this, token));
    } while (token.kind === TokenKind.COMMENT);
  }
  return token;
}

/**
 * The return type of createLexer.
 */


/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */
var TokenKind = Object.freeze({
  SOF: '<SOF>',
  EOF: '<EOF>',
  BANG: '!',
  DOLLAR: '$',
  AMP: '&',
  PAREN_L: '(',
  PAREN_R: ')',
  SPREAD: '...',
  COLON: ':',
  EQUALS: '=',
  AT: '@',
  BRACKET_L: '[',
  BRACKET_R: ']',
  BRACE_L: '{',
  PIPE: '|',
  BRACE_R: '}',
  NAME: 'Name',
  INT: 'Int',
  FLOAT: 'Float',
  STRING: 'String',
  BLOCK_STRING: 'BlockString',
  COMMENT: 'Comment'
});

/**
 * The enum type representing the token kinds values.
 */


/**
 * A helper function to describe a token as a string for debugging
 */
function getTokenDesc(token) {
  var value = token.value;
  return value ? token.kind + ' "' + value + '"' : token.kind;
}

var charCodeAt = String.prototype.charCodeAt;
var slice = String.prototype.slice;

/**
 * Helper function for constructing the Token object.
 */
function Tok(kind, start, end, line, column, prev, value) {
  this.kind = kind;
  this.start = start;
  this.end = end;
  this.line = line;
  this.column = column;
  this.value = value;
  this.prev = prev;
  this.next = null;
}

// Print a simplified form when appearing in JSON/util.inspect.
Tok.prototype.toJSON = Tok.prototype.inspect = function toJSON() {
  return {
    kind: this.kind,
    value: this.value,
    line: this.line,
    column: this.column
  };
};

function printCharCode(code) {
  return (
    // NaN/undefined represents access beyond the end of the file.
    isNaN(code) ? TokenKind.EOF : // Trust JSON for ASCII.
    code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : // Otherwise print the escaped form.
    '"\\u' + ('00' + code.toString(16).toUpperCase()).slice(-4) + '"'
  );
}

/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace and comments until it finds the next lexable
 * token, then lexes punctuators immediately or calls the appropriate helper
 * function for more complicated tokens.
 */
function readToken(lexer, prev) {
  var source = lexer.source;
  var body = source.body;
  var bodyLength = body.length;

  var pos = positionAfterWhitespace(body, prev.end, lexer);
  var line = lexer.line;
  var col = 1 + pos - lexer.lineStart;

  if (pos >= bodyLength) {
    return new Tok(TokenKind.EOF, bodyLength, bodyLength, line, col, prev);
  }

  var code = charCodeAt.call(body, pos);

  // SourceCharacter
  if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
    throw Object(__WEBPACK_IMPORTED_MODULE_0__error__["c" /* syntaxError */])(source, pos, 'Cannot contain the invalid character ' + printCharCode(code) + '.');
  }

  switch (code) {
    // !
    case 33:
      return new Tok(TokenKind.BANG, pos, pos + 1, line, col, prev);
    // #
    case 35:
      return readComment(source, pos, line, col, prev);
    // $
    case 36:
      return new Tok(TokenKind.DOLLAR, pos, pos + 1, line, col, prev);
    // &
    case 38:
      return new Tok(TokenKind.AMP, pos, pos + 1, line, col, prev);
    // (
    case 40:
      return new Tok(TokenKind.PAREN_L, pos, pos + 1, line, col, prev);
    // )
    case 41:
      return new Tok(TokenKind.PAREN_R, pos, pos + 1, line, col, prev);
    // .
    case 46:
      if (charCodeAt.call(body, pos + 1) === 46 && charCodeAt.call(body, pos + 2) === 46) {
        return new Tok(TokenKind.SPREAD, pos, pos + 3, line, col, prev);
      }
      break;
    // :
    case 58:
      return new Tok(TokenKind.COLON, pos, pos + 1, line, col, prev);
    // =
    case 61:
      return new Tok(TokenKind.EQUALS, pos, pos + 1, line, col, prev);
    // @
    case 64:
      return new Tok(TokenKind.AT, pos, pos + 1, line, col, prev);
    // [
    case 91:
      return new Tok(TokenKind.BRACKET_L, pos, pos + 1, line, col, prev);
    // ]
    case 93:
      return new Tok(TokenKind.BRACKET_R, pos, pos + 1, line, col, prev);
    // {
    case 123:
      return new Tok(TokenKind.BRACE_L, pos, pos + 1, line, col, prev);
    // |
    case 124:
      return new Tok(TokenKind.PIPE, pos, pos + 1, line, col, prev);
    // }
    case 125:
      return new Tok(TokenKind.BRACE_R, pos, pos + 1, line, col, prev);
    // A-Z _ a-z
    case 65:
    case 66:
    case 67:
    case 68:
    case 69:
    case 70:
    case 71:
    case 72:
    case 73:
    case 74:
    case 75:
    case 76:
    case 77:
    case 78:
    case 79:
    case 80:
    case 81:
    case 82:
    case 83:
    case 84:
    case 85:
    case 86:
    case 87:
    case 88:
    case 89:
    case 90:
    case 95:
    case 97:
    case 98:
    case 99:
    case 100:
    case 101:
    case 102:
    case 103:
    case 104:
    case 105:
    case 106:
    case 107:
    case 108:
    case 109:
    case 110:
    case 111:
    case 112:
    case 113:
    case 114:
    case 115:
    case 116:
    case 117:
    case 118:
    case 119:
    case 120:
    case 121:
    case 122:
      return readName(source, pos, line, col, prev);
    // - 0-9
    case 45:
    case 48:
    case 49:
    case 50:
    case 51:
    case 52:
    case 53:
    case 54:
    case 55:
    case 56:
    case 57:
      return readNumber(source, pos, code, line, col, prev);
    // "
    case 34:
      if (charCodeAt.call(body, pos + 1) === 34 && charCodeAt.call(body, pos + 2) === 34) {
        return readBlockString(source, pos, line, col, prev);
      }
      return readString(source, pos, line, col, prev);
  }

  throw Object(__WEBPACK_IMPORTED_MODULE_0__error__["c" /* syntaxError */])(source, pos, unexpectedCharacterMessage(code));
}

/**
 * Report a message that an unexpected character was encountered.
 */
function unexpectedCharacterMessage(code) {
  if (code === 39) {
    // '
    return "Unexpected single quote character ('), did you mean to use " + 'a double quote (")?';
  }

  return 'Cannot parse the unexpected character ' + printCharCode(code) + '.';
}

/**
 * Reads from body starting at startPosition until it finds a non-whitespace
 * or commented character, then returns the position of that character for
 * lexing.
 */
function positionAfterWhitespace(body, startPosition, lexer) {
  var bodyLength = body.length;
  var position = startPosition;
  while (position < bodyLength) {
    var code = charCodeAt.call(body, position);
    // tab | space | comma | BOM
    if (code === 9 || code === 32 || code === 44 || code === 0xfeff) {
      ++position;
    } else if (code === 10) {
      // new line
      ++position;
      ++lexer.line;
      lexer.lineStart = position;
    } else if (code === 13) {
      // carriage return
      if (charCodeAt.call(body, position + 1) === 10) {
        position += 2;
      } else {
        ++position;
      }
      ++lexer.line;
      lexer.lineStart = position;
    } else {
      break;
    }
  }
  return position;
}

/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */
function readComment(source, start, line, col, prev) {
  var body = source.body;
  var code = void 0;
  var position = start;

  do {
    code = charCodeAt.call(body, ++position);
  } while (code !== null && (
  // SourceCharacter but not LineTerminator
  code > 0x001f || code === 0x0009));

  return new Tok(TokenKind.COMMENT, start, position, line, col, prev, slice.call(body, start + 1, position));
}

/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */
function readNumber(source, start, firstCode, line, col, prev) {
  var body = source.body;
  var code = firstCode;
  var position = start;
  var isFloat = false;

  if (code === 45) {
    // -
    code = charCodeAt.call(body, ++position);
  }

  if (code === 48) {
    // 0
    code = charCodeAt.call(body, ++position);
    if (code >= 48 && code <= 57) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__error__["c" /* syntaxError */])(source, position, 'Invalid number, unexpected digit after 0: ' + printCharCode(code) + '.');
    }
  } else {
    position = readDigits(source, position, code);
    code = charCodeAt.call(body, position);
  }

  if (code === 46) {
    // .
    isFloat = true;

    code = charCodeAt.call(body, ++position);
    position = readDigits(source, position, code);
    code = charCodeAt.call(body, position);
  }

  if (code === 69 || code === 101) {
    // E e
    isFloat = true;

    code = charCodeAt.call(body, ++position);
    if (code === 43 || code === 45) {
      // + -
      code = charCodeAt.call(body, ++position);
    }
    position = readDigits(source, position, code);
  }

  return new Tok(isFloat ? TokenKind.FLOAT : TokenKind.INT, start, position, line, col, prev, slice.call(body, start, position));
}

/**
 * Returns the new position in the source after reading digits.
 */
function readDigits(source, start, firstCode) {
  var body = source.body;
  var position = start;
  var code = firstCode;
  if (code >= 48 && code <= 57) {
    // 0 - 9
    do {
      code = charCodeAt.call(body, ++position);
    } while (code >= 48 && code <= 57); // 0 - 9
    return position;
  }
  throw Object(__WEBPACK_IMPORTED_MODULE_0__error__["c" /* syntaxError */])(source, position, 'Invalid number, expected digit but got: ' + printCharCode(code) + '.');
}

/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */
function readString(source, start, line, col, prev) {
  var body = source.body;
  var position = start + 1;
  var chunkStart = position;
  var code = 0;
  var value = '';

  while (position < body.length && (code = charCodeAt.call(body, position)) !== null &&
  // not LineTerminator
  code !== 0x000a && code !== 0x000d) {
    // Closing Quote (")
    if (code === 34) {
      value += slice.call(body, chunkStart, position);
      return new Tok(TokenKind.STRING, start, position + 1, line, col, prev, value);
    }

    // SourceCharacter
    if (code < 0x0020 && code !== 0x0009) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__error__["c" /* syntaxError */])(source, position, 'Invalid character within String: ' + printCharCode(code) + '.');
    }

    ++position;
    if (code === 92) {
      // \
      value += slice.call(body, chunkStart, position - 1);
      code = charCodeAt.call(body, position);
      switch (code) {
        case 34:
          value += '"';
          break;
        case 47:
          value += '/';
          break;
        case 92:
          value += '\\';
          break;
        case 98:
          value += '\b';
          break;
        case 102:
          value += '\f';
          break;
        case 110:
          value += '\n';
          break;
        case 114:
          value += '\r';
          break;
        case 116:
          value += '\t';
          break;
        case 117:
          // u
          var charCode = uniCharCode(charCodeAt.call(body, position + 1), charCodeAt.call(body, position + 2), charCodeAt.call(body, position + 3), charCodeAt.call(body, position + 4));
          if (charCode < 0) {
            throw Object(__WEBPACK_IMPORTED_MODULE_0__error__["c" /* syntaxError */])(source, position, 'Invalid character escape sequence: ' + ('\\u' + body.slice(position + 1, position + 5) + '.'));
          }
          value += String.fromCharCode(charCode);
          position += 4;
          break;
        default:
          throw Object(__WEBPACK_IMPORTED_MODULE_0__error__["c" /* syntaxError */])(source, position, 'Invalid character escape sequence: \\' + String.fromCharCode(code) + '.');
      }
      ++position;
      chunkStart = position;
    }
  }

  throw Object(__WEBPACK_IMPORTED_MODULE_0__error__["c" /* syntaxError */])(source, position, 'Unterminated string.');
}

/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */
function readBlockString(source, start, line, col, prev) {
  var body = source.body;
  var position = start + 3;
  var chunkStart = position;
  var code = 0;
  var rawValue = '';

  while (position < body.length && (code = charCodeAt.call(body, position)) !== null) {
    // Closing Triple-Quote (""")
    if (code === 34 && charCodeAt.call(body, position + 1) === 34 && charCodeAt.call(body, position + 2) === 34) {
      rawValue += slice.call(body, chunkStart, position);
      return new Tok(TokenKind.BLOCK_STRING, start, position + 3, line, col, prev, Object(__WEBPACK_IMPORTED_MODULE_1__blockStringValue__["a" /* default */])(rawValue));
    }

    // SourceCharacter
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__error__["c" /* syntaxError */])(source, position, 'Invalid character within String: ' + printCharCode(code) + '.');
    }

    // Escape Triple-Quote (\""")
    if (code === 92 && charCodeAt.call(body, position + 1) === 34 && charCodeAt.call(body, position + 2) === 34 && charCodeAt.call(body, position + 3) === 34) {
      rawValue += slice.call(body, chunkStart, position) + '"""';
      position += 4;
      chunkStart = position;
    } else {
      ++position;
    }
  }

  throw Object(__WEBPACK_IMPORTED_MODULE_0__error__["c" /* syntaxError */])(source, position, 'Unterminated string.');
}

/**
 * Converts four hexidecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */
function uniCharCode(a, b, c, d) {
  return char2hex(a) << 12 | char2hex(b) << 8 | char2hex(c) << 4 | char2hex(d);
}

/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */
function char2hex(a) {
  return a >= 48 && a <= 57 ? a - 48 // 0-9
  : a >= 65 && a <= 70 ? a - 55 // A-F
  : a >= 97 && a <= 102 ? a - 87 // a-f
  : -1;
}

/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */
function readName(source, start, line, col, prev) {
  var body = source.body;
  var bodyLength = body.length;
  var position = start + 1;
  var code = 0;
  while (position !== bodyLength && (code = charCodeAt.call(body, position)) !== null && (code === 95 || // _
  code >= 48 && code <= 57 || // 0-9
  code >= 65 && code <= 90 || // A-Z
  code >= 97 && code <= 122) // a-z
  ) {
    ++position;
  }
  return new Tok(TokenKind.NAME, start, position, line, col, prev, slice.call(body, start, position));
}

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quotedOrList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__orList__ = __webpack_require__(277);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */



/**
 * Given [ A, B, C ] return '"A", "B", or "C"'.
 */
function quotedOrList(items) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__orList__["a" /* default */])(items.map(function (item) {
    return '"' + item + '"';
  }));
}

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = orList;
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

var MAX_LENGTH = 5;

/**
 * Given [ A, B, C ] return 'A, B, or C'.
 */
function orList(items) {
  var selected = items.slice(0, MAX_LENGTH);
  return selected.reduce(function (list, quoted, index) {
    return list + (selected.length > 2 ? ', ' : ' ') + (index === selected.length - 1 ? 'or ' : '') + quoted;
  });
}

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export badValueMessage */
/* unused harmony export requiredFieldMessage */
/* unused harmony export unknownFieldMessage */
/* harmony export (immutable) */ __webpack_exports__["a"] = ValuesOfCorrectType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__language_printer__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type_definition__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jsutils_isInvalid__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jsutils_keyMap__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__jsutils_orList__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__jsutils_suggestionList__ = __webpack_require__(170);

 /**
                                             * Copyright (c) 2015-present, Facebook, Inc.
                                             *
                                             * This source code is licensed under the MIT license found in the
                                             * LICENSE file in the root directory of this source tree.
                                             *
                                             *  strict
                                             */










function badValueMessage(typeName, valueName, message) {
  return 'Expected type ' + typeName + ', found ' + valueName + (message ? '; ' + message : '.');
}

function requiredFieldMessage(typeName, fieldName, fieldTypeName) {
  return 'Field ' + typeName + '.' + fieldName + ' of required type ' + (fieldTypeName + ' was not provided.');
}

function unknownFieldMessage(typeName, fieldName, message) {
  return 'Field "' + fieldName + '" is not defined by type ' + typeName + (message ? '; ' + message : '.');
}

/**
 * Value literals of correct type
 *
 * A GraphQL document is only valid if all value literals are of the type
 * expected at their position.
 */
function ValuesOfCorrectType(context) {
  return {
    NullValue: function NullValue(node) {
      var type = context.getInputType();
      if (Object(__WEBPACK_IMPORTED_MODULE_2__type_definition__["w" /* isNonNullType */])(type)) {
        context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* GraphQLError */](badValueMessage(String(type), Object(__WEBPACK_IMPORTED_MODULE_1__language_printer__["a" /* print */])(node)), node));
      }
    },
    ListValue: function ListValue(node) {
      // Note: TypeInfo will traverse into a list's item type, so look to the
      // parent input type to check if it is a list.
      var type = Object(__WEBPACK_IMPORTED_MODULE_2__type_definition__["m" /* getNullableType */])(context.getParentInputType());
      if (!Object(__WEBPACK_IMPORTED_MODULE_2__type_definition__["u" /* isListType */])(type)) {
        isValidScalar(context, node);
        return false; // Don't traverse further.
      }
    },
    ObjectValue: function ObjectValue(node) {
      var type = Object(__WEBPACK_IMPORTED_MODULE_2__type_definition__["l" /* getNamedType */])(context.getInputType());
      if (!Object(__WEBPACK_IMPORTED_MODULE_2__type_definition__["q" /* isInputObjectType */])(type)) {
        isValidScalar(context, node);
        return false; // Don't traverse further.
      }
      // Ensure every required field exists.
      var inputFields = type.getFields();
      var fieldNodeMap = Object(__WEBPACK_IMPORTED_MODULE_4__jsutils_keyMap__["a" /* default */])(node.fields, function (field) {
        return field.name.value;
      });
      Object.keys(inputFields).forEach(function (fieldName) {
        var fieldType = inputFields[fieldName].type;
        var fieldNode = fieldNodeMap[fieldName];
        if (!fieldNode && Object(__WEBPACK_IMPORTED_MODULE_2__type_definition__["w" /* isNonNullType */])(fieldType)) {
          context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* GraphQLError */](requiredFieldMessage(type.name, fieldName, String(fieldType)), node));
        }
      });
    },
    ObjectField: function ObjectField(node) {
      var parentType = Object(__WEBPACK_IMPORTED_MODULE_2__type_definition__["l" /* getNamedType */])(context.getParentInputType());
      var fieldType = context.getInputType();
      if (!fieldType && Object(__WEBPACK_IMPORTED_MODULE_2__type_definition__["q" /* isInputObjectType */])(parentType)) {
        var suggestions = Object(__WEBPACK_IMPORTED_MODULE_6__jsutils_suggestionList__["a" /* default */])(node.name.value, Object.keys(parentType.getFields()));
        var didYouMean = suggestions.length !== 0 ? 'Did you mean ' + Object(__WEBPACK_IMPORTED_MODULE_5__jsutils_orList__["a" /* default */])(suggestions) + '?' : undefined;
        context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* GraphQLError */](unknownFieldMessage(parentType.name, node.name.value, didYouMean), node));
      }
    },
    EnumValue: function EnumValue(node) {
      var type = Object(__WEBPACK_IMPORTED_MODULE_2__type_definition__["l" /* getNamedType */])(context.getInputType());
      if (!Object(__WEBPACK_IMPORTED_MODULE_2__type_definition__["p" /* isEnumType */])(type)) {
        isValidScalar(context, node);
      } else if (!type.getValue(node.value)) {
        context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* GraphQLError */](badValueMessage(type.name, Object(__WEBPACK_IMPORTED_MODULE_1__language_printer__["a" /* print */])(node), enumTypeSuggestion(type, node)), node));
      }
    },

    IntValue: function IntValue(node) {
      return isValidScalar(context, node);
    },
    FloatValue: function FloatValue(node) {
      return isValidScalar(context, node);
    },
    StringValue: function StringValue(node) {
      return isValidScalar(context, node);
    },
    BooleanValue: function BooleanValue(node) {
      return isValidScalar(context, node);
    }
  };
}

/**
 * Any value literal may be a valid representation of a Scalar, depending on
 * that scalar type.
 */
function isValidScalar(context, node) {
  // Report any error at the full type expected by the location.
  var locationType = context.getInputType();
  if (!locationType) {
    return;
  }

  var type = Object(__WEBPACK_IMPORTED_MODULE_2__type_definition__["l" /* getNamedType */])(locationType);

  if (!Object(__WEBPACK_IMPORTED_MODULE_2__type_definition__["z" /* isScalarType */])(type)) {
    context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* GraphQLError */](badValueMessage(String(locationType), Object(__WEBPACK_IMPORTED_MODULE_1__language_printer__["a" /* print */])(node), enumTypeSuggestion(type, node)), node));
    return;
  }

  // Scalars determine if a literal value is valid via parseLiteral() which
  // may throw or return an invalid value to indicate failure.
  try {
    var parseResult = type.parseLiteral(node, undefined /* variables */);
    if (Object(__WEBPACK_IMPORTED_MODULE_3__jsutils_isInvalid__["a" /* default */])(parseResult)) {
      context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* GraphQLError */](badValueMessage(String(locationType), Object(__WEBPACK_IMPORTED_MODULE_1__language_printer__["a" /* print */])(node)), node));
    }
  } catch (error) {
    // Ensure a reference to the original error is maintained.
    context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* GraphQLError */](badValueMessage(String(locationType), Object(__WEBPACK_IMPORTED_MODULE_1__language_printer__["a" /* print */])(node), error.message), node, undefined, undefined, undefined, error));
  }
}

function enumTypeSuggestion(type, node) {
  if (Object(__WEBPACK_IMPORTED_MODULE_2__type_definition__["p" /* isEnumType */])(type)) {
    var suggestions = Object(__WEBPACK_IMPORTED_MODULE_6__jsutils_suggestionList__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__language_printer__["a" /* print */])(node), type.getValues().map(function (value) {
      return value.name;
    }));
    if (suggestions.length !== 0) {
      return 'Did you mean the enum value ' + Object(__WEBPACK_IMPORTED_MODULE_5__jsutils_orList__["a" /* default */])(suggestions) + '?';
    }
  }
}

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__language_visitor__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__language_kinds__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__type_schema__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_TypeInfo__ = __webpack_require__(169);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

 /**
                                          * Copyright (c) 2015-present, Facebook, Inc.
                                          *
                                          * This source code is licensed under the MIT license found in the
                                          * LICENSE file in the root directory of this source tree.
                                          *
                                          *  strict
                                          */








/**
 * An instance of this class is passed as the "this" context to all validators,
 * allowing access to commonly useful contextual information from within a
 * validation rule.
 */
var ValidationContext = function () {
  function ValidationContext(schema, ast, typeInfo) {
    _classCallCheck(this, ValidationContext);

    this._schema = schema;
    this._ast = ast;
    this._typeInfo = typeInfo;
    this._errors = [];
    this._fragmentSpreads = new Map();
    this._recursivelyReferencedFragments = new Map();
    this._variableUsages = new Map();
    this._recursiveVariableUsages = new Map();
  }

  ValidationContext.prototype.reportError = function reportError(error) {
    this._errors.push(error);
  };

  ValidationContext.prototype.getErrors = function getErrors() {
    return this._errors;
  };

  ValidationContext.prototype.getSchema = function getSchema() {
    return this._schema;
  };

  ValidationContext.prototype.getDocument = function getDocument() {
    return this._ast;
  };

  ValidationContext.prototype.getFragment = function getFragment(name) {
    var fragments = this._fragments;
    if (!fragments) {
      this._fragments = fragments = this.getDocument().definitions.reduce(function (frags, statement) {
        if (statement.kind === __WEBPACK_IMPORTED_MODULE_2__language_kinds__["a" /* Kind */].FRAGMENT_DEFINITION) {
          frags[statement.name.value] = statement;
        }
        return frags;
      }, Object.create(null));
    }
    return fragments[name];
  };

  ValidationContext.prototype.getFragmentSpreads = function getFragmentSpreads(node) {
    var spreads = this._fragmentSpreads.get(node);
    if (!spreads) {
      spreads = [];
      var setsToVisit = [node];
      while (setsToVisit.length !== 0) {
        var set = setsToVisit.pop();
        for (var i = 0; i < set.selections.length; i++) {
          var selection = set.selections[i];
          if (selection.kind === __WEBPACK_IMPORTED_MODULE_2__language_kinds__["a" /* Kind */].FRAGMENT_SPREAD) {
            spreads.push(selection);
          } else if (selection.selectionSet) {
            setsToVisit.push(selection.selectionSet);
          }
        }
      }
      this._fragmentSpreads.set(node, spreads);
    }
    return spreads;
  };

  ValidationContext.prototype.getRecursivelyReferencedFragments = function getRecursivelyReferencedFragments(operation) {
    var fragments = this._recursivelyReferencedFragments.get(operation);
    if (!fragments) {
      fragments = [];
      var collectedNames = Object.create(null);
      var nodesToVisit = [operation.selectionSet];
      while (nodesToVisit.length !== 0) {
        var _node = nodesToVisit.pop();
        var spreads = this.getFragmentSpreads(_node);
        for (var i = 0; i < spreads.length; i++) {
          var fragName = spreads[i].name.value;
          if (collectedNames[fragName] !== true) {
            collectedNames[fragName] = true;
            var fragment = this.getFragment(fragName);
            if (fragment) {
              fragments.push(fragment);
              nodesToVisit.push(fragment.selectionSet);
            }
          }
        }
      }
      this._recursivelyReferencedFragments.set(operation, fragments);
    }
    return fragments;
  };

  ValidationContext.prototype.getVariableUsages = function getVariableUsages(node) {
    var usages = this._variableUsages.get(node);
    if (!usages) {
      var newUsages = [];
      var typeInfo = new __WEBPACK_IMPORTED_MODULE_4__utilities_TypeInfo__["a" /* TypeInfo */](this._schema);
      Object(__WEBPACK_IMPORTED_MODULE_1__language_visitor__["b" /* visit */])(node, Object(__WEBPACK_IMPORTED_MODULE_1__language_visitor__["d" /* visitWithTypeInfo */])(typeInfo, {
        VariableDefinition: function VariableDefinition() {
          return false;
        },
        Variable: function Variable(variable) {
          newUsages.push({ node: variable, type: typeInfo.getInputType() });
        }
      }));
      usages = newUsages;
      this._variableUsages.set(node, usages);
    }
    return usages;
  };

  ValidationContext.prototype.getRecursiveVariableUsages = function getRecursiveVariableUsages(operation) {
    var usages = this._recursiveVariableUsages.get(operation);
    if (!usages) {
      usages = this.getVariableUsages(operation);
      var fragments = this.getRecursivelyReferencedFragments(operation);
      for (var i = 0; i < fragments.length; i++) {
        Array.prototype.push.apply(usages, this.getVariableUsages(fragments[i]));
      }
      this._recursiveVariableUsages.set(operation, usages);
    }
    return usages;
  };

  ValidationContext.prototype.getType = function getType() {
    return this._typeInfo.getType();
  };

  ValidationContext.prototype.getParentType = function getParentType() {
    return this._typeInfo.getParentType();
  };

  ValidationContext.prototype.getInputType = function getInputType() {
    return this._typeInfo.getInputType();
  };

  ValidationContext.prototype.getParentInputType = function getParentInputType() {
    return this._typeInfo.getParentInputType();
  };

  ValidationContext.prototype.getFieldDef = function getFieldDef() {
    return this._typeInfo.getFieldDef();
  };

  ValidationContext.prototype.getDirective = function getDirective() {
    return this._typeInfo.getDirective();
  };

  ValidationContext.prototype.getArgument = function getArgument() {
    return this._typeInfo.getArgument();
  };

  return ValidationContext;
}();

/* harmony default export */ __webpack_exports__["a"] = (ValidationContext);

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = coerceValue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_iterall__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsutils_isInvalid__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsutils_isNullish__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jsutils_orList__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jsutils_suggestionList__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__error__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__type_definition__ = __webpack_require__(46);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */











/**
 * Coerces a JavaScript value given a GraphQL Type.
 *
 * Returns either a value which is valid for the provided type or a list of
 * encountered coercion errors.
 *
 */
function coerceValue(value, type, blameNode, path) {
  // A value must be provided if the type is non-null.
  if (Object(__WEBPACK_IMPORTED_MODULE_6__type_definition__["w" /* isNonNullType */])(type)) {
    if (Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_isNullish__["a" /* default */])(value)) {
      return ofErrors([coercionError('Expected non-nullable type ' + String(type) + ' not to be null', blameNode, path)]);
    }
    return coerceValue(value, type.ofType, blameNode, path);
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_isNullish__["a" /* default */])(value)) {
    // Explicitly return the value null.
    return ofValue(null);
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_6__type_definition__["z" /* isScalarType */])(type)) {
    // Scalars determine if a value is valid via parseValue(), which can
    // throw to indicate failure. If it throws, maintain a reference to
    // the original error.
    try {
      var parseResult = type.parseValue(value);
      if (Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_isInvalid__["a" /* default */])(parseResult)) {
        return ofErrors([coercionError('Expected type ' + type.name, blameNode, path)]);
      }
      return ofValue(parseResult);
    } catch (error) {
      return ofErrors([coercionError('Expected type ' + type.name, blameNode, path, error.message, error)]);
    }
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_6__type_definition__["p" /* isEnumType */])(type)) {
    if (typeof value === 'string') {
      var enumValue = type.getValue(value);
      if (enumValue) {
        return ofValue(enumValue.value);
      }
    }
    var suggestions = Object(__WEBPACK_IMPORTED_MODULE_4__jsutils_suggestionList__["a" /* default */])(String(value), type.getValues().map(function (enumValue) {
      return enumValue.name;
    }));
    var didYouMean = suggestions.length !== 0 ? 'did you mean ' + Object(__WEBPACK_IMPORTED_MODULE_3__jsutils_orList__["a" /* default */])(suggestions) + '?' : undefined;
    return ofErrors([coercionError('Expected type ' + type.name, blameNode, path, didYouMean)]);
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_6__type_definition__["u" /* isListType */])(type)) {
    var itemType = type.ofType;
    if (Object(__WEBPACK_IMPORTED_MODULE_0_iterall__["e" /* isCollection */])(value)) {
      var _errors = void 0;
      var coercedValue = [];
      Object(__WEBPACK_IMPORTED_MODULE_0_iterall__["b" /* forEach */])(value, function (itemValue, index) {
        var coercedItem = coerceValue(itemValue, itemType, blameNode, atPath(path, index));
        if (coercedItem.errors) {
          _errors = add(_errors, coercedItem.errors);
        } else if (!_errors) {
          coercedValue.push(coercedItem.value);
        }
      });
      return _errors ? ofErrors(_errors) : ofValue(coercedValue);
    }
    // Lists accept a non-list value as a list of one.
    var coercedItem = coerceValue(value, itemType, blameNode);
    return coercedItem.errors ? coercedItem : ofValue([coercedItem.value]);
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_6__type_definition__["q" /* isInputObjectType */])(type)) {
    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
      return ofErrors([coercionError('Expected type ' + type.name + ' to be an object', blameNode, path)]);
    }
    var _errors2 = void 0;
    var _coercedValue = {};
    var fields = type.getFields();

    // Ensure every defined field is valid.
    for (var fieldName in fields) {
      if (hasOwnProperty.call(fields, fieldName)) {
        var field = fields[fieldName];
        var fieldValue = value[fieldName];
        if (Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_isInvalid__["a" /* default */])(fieldValue)) {
          if (!Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_isInvalid__["a" /* default */])(field.defaultValue)) {
            _coercedValue[fieldName] = field.defaultValue;
          } else if (Object(__WEBPACK_IMPORTED_MODULE_6__type_definition__["w" /* isNonNullType */])(field.type)) {
            _errors2 = add(_errors2, coercionError('Field ' + printPath(atPath(path, fieldName)) + ' of required ' + ('type ' + String(field.type) + ' was not provided'), blameNode));
          }
        } else {
          var coercedField = coerceValue(fieldValue, field.type, blameNode, atPath(path, fieldName));
          if (coercedField.errors) {
            _errors2 = add(_errors2, coercedField.errors);
          } else if (!_errors2) {
            _coercedValue[fieldName] = coercedField.value;
          }
        }
      }
    }

    // Ensure every provided field is defined.
    for (var _fieldName in value) {
      if (hasOwnProperty.call(value, _fieldName)) {
        if (!fields[_fieldName]) {
          var _suggestions = Object(__WEBPACK_IMPORTED_MODULE_4__jsutils_suggestionList__["a" /* default */])(_fieldName, Object.keys(fields));
          var _didYouMean = _suggestions.length !== 0 ? 'did you mean ' + Object(__WEBPACK_IMPORTED_MODULE_3__jsutils_orList__["a" /* default */])(_suggestions) + '?' : undefined;
          _errors2 = add(_errors2, coercionError('Field "' + _fieldName + '" is not defined by type ' + type.name, blameNode, path, _didYouMean));
        }
      }
    }

    return _errors2 ? ofErrors(_errors2) : ofValue(_coercedValue);
  }

  /* istanbul ignore next */
  throw new Error('Unexpected type: ' + type + '.');
}

function ofValue(value) {
  return { errors: undefined, value: value };
}

function ofErrors(errors) {
  return { errors: errors, value: undefined };
}

function add(errors, moreErrors) {
  return (errors || []).concat(moreErrors);
}

function atPath(prev, key) {
  return { prev: prev, key: key };
}

function coercionError(message, blameNode, path, subMessage, originalError) {
  var pathStr = printPath(path);
  // Return a GraphQLError instance
  return new __WEBPACK_IMPORTED_MODULE_5__error__["a" /* GraphQLError */](message + (pathStr ? ' at ' + pathStr : '') + (subMessage ? '; ' + subMessage : '.'), blameNode, undefined, undefined, undefined, originalError);
}

// Build a string describing the path into the value where the error was found
function printPath(path) {
  var pathStr = '';
  var currentPath = path;
  while (currentPath) {
    pathStr = (typeof currentPath.key === 'string' ? '.' + currentPath.key : '[' + String(currentPath.key) + ']') + pathStr;
    currentPath = currentPath.prev;
  }
  return pathStr ? 'value' + pathStr : '';
}

var hasOwnProperty = Object.prototype.hasOwnProperty;

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ApolloClient", function() { return ApolloClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ApolloError", function() { return ApolloError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FetchType", function() { return FetchType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NetworkStatus", function() { return NetworkStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ObservableQuery", function() { return ObservableQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isApolloError", function() { return isApolloError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_apollo_utilities__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apollo_link__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_symbol_observable__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ts_invariant__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_graphql_language_visitor__ = __webpack_require__(96);







var NetworkStatus;
(function (NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})(NetworkStatus || (NetworkStatus = {}));
function isNetworkRequestInFlight(networkStatus) {
    return networkStatus < 7;
}

var Observable = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(Observable, _super);
    function Observable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Observable.prototype[__WEBPACK_IMPORTED_MODULE_3_symbol_observable__["default"]] = function () {
        return this;
    };
    Observable.prototype['@@observable'] = function () {
        return this;
    };
    return Observable;
}(__WEBPACK_IMPORTED_MODULE_2_apollo_link__["b" /* Observable */]));

function isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}

function isApolloError(err) {
    return err.hasOwnProperty('graphQLErrors');
}
var generateErrorMessage = function (err) {
    var message = '';
    if (isNonEmptyArray(err.graphQLErrors)) {
        err.graphQLErrors.forEach(function (graphQLError) {
            var errorMessage = graphQLError
                ? graphQLError.message
                : 'Error message not found.';
            message += "GraphQL error: " + errorMessage + "\n";
        });
    }
    if (err.networkError) {
        message += 'Network error: ' + err.networkError.message + '\n';
    }
    message = message.replace(/\n$/, '');
    return message;
};
var ApolloError = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.graphQLErrors = graphQLErrors || [];
        _this.networkError = networkError || null;
        if (!errorMessage) {
            _this.message = generateErrorMessage(_this);
        }
        else {
            _this.message = errorMessage;
        }
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error));

var FetchType;
(function (FetchType) {
    FetchType[FetchType["normal"] = 1] = "normal";
    FetchType[FetchType["refetch"] = 2] = "refetch";
    FetchType[FetchType["poll"] = 3] = "poll";
})(FetchType || (FetchType = {}));

var hasError = function (storeValue, policy) {
    if (policy === void 0) { policy = 'none'; }
    return storeValue && (storeValue.networkError ||
        (policy === 'none' && isNonEmptyArray(storeValue.graphQLErrors)));
};
var ObservableQuery = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, options = _a.options, _b = _a.shouldSubscribe, shouldSubscribe = _b === void 0 ? true : _b;
        var _this = _super.call(this, function (observer) {
            return _this.onSubscribe(observer);
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.isTornDown = false;
        _this.options = options;
        _this.variables = options.variables || {};
        _this.queryId = queryManager.generateQueryId();
        _this.shouldSubscribe = shouldSubscribe;
        var opDef = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["m" /* getOperationDefinition */])(options.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        _this.queryManager = queryManager;
        return _this;
    }
    ObservableQuery.prototype.result = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var observer = {
                next: function (result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) {
                        _this.queryManager.removeQuery(_this.queryId);
                    }
                    setTimeout(function () {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject,
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.currentResult = function () {
        var result = this.getCurrentResult();
        if (result.data === undefined) {
            result.data = {};
        }
        return result;
    };
    ObservableQuery.prototype.getCurrentResult = function () {
        if (this.isTornDown) {
            var lastResult = this.lastResult;
            return {
                data: !this.lastError && lastResult && lastResult.data || void 0,
                error: this.lastError,
                loading: false,
                networkStatus: NetworkStatus.error,
            };
        }
        var _a = this.queryManager.getCurrentQueryResult(this), data = _a.data, partial = _a.partial;
        var queryStoreValue = this.queryManager.queryStore.get(this.queryId);
        var result;
        var fetchPolicy = this.options.fetchPolicy;
        var isNetworkFetchPolicy = fetchPolicy === 'network-only' ||
            fetchPolicy === 'no-cache';
        if (queryStoreValue) {
            var networkStatus = queryStoreValue.networkStatus;
            if (hasError(queryStoreValue, this.options.errorPolicy)) {
                return {
                    data: void 0,
                    loading: false,
                    networkStatus: networkStatus,
                    error: new ApolloError({
                        graphQLErrors: queryStoreValue.graphQLErrors,
                        networkError: queryStoreValue.networkError,
                    }),
                };
            }
            if (queryStoreValue.variables) {
                this.options.variables = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this.options.variables), queryStoreValue.variables);
                this.variables = this.options.variables;
            }
            result = {
                data: data,
                loading: isNetworkRequestInFlight(networkStatus),
                networkStatus: networkStatus,
            };
            if (queryStoreValue.graphQLErrors && this.options.errorPolicy === 'all') {
                result.errors = queryStoreValue.graphQLErrors;
            }
        }
        else {
            var loading = isNetworkFetchPolicy ||
                (partial && fetchPolicy !== 'cache-only');
            result = {
                data: data,
                loading: loading,
                networkStatus: loading ? NetworkStatus.loading : NetworkStatus.ready,
            };
        }
        if (!partial) {
            this.updateLastResult(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, result), { stale: false }));
        }
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, result), { partial: partial });
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function (newResult) {
        var snapshot = this.lastResultSnapshot;
        return !(snapshot &&
            newResult &&
            snapshot.networkStatus === newResult.networkStatus &&
            snapshot.stale === newResult.stale &&
            Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["t" /* isEqual */])(snapshot.data, newResult.data));
    };
    ObservableQuery.prototype.getLastResult = function () {
        return this.lastResult;
    };
    ObservableQuery.prototype.getLastError = function () {
        return this.lastError;
    };
    ObservableQuery.prototype.resetLastResults = function () {
        delete this.lastResult;
        delete this.lastResultSnapshot;
        delete this.lastError;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function () {
        var queryStore = this.queryManager.queryStore.get(this.queryId);
        if (queryStore) {
            queryStore.networkError = null;
            queryStore.graphQLErrors = [];
        }
    };
    ObservableQuery.prototype.refetch = function (variables) {
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === 'cache-only') {
            return Promise.reject( true ? new __WEBPACK_IMPORTED_MODULE_4_ts_invariant__["a" /* InvariantError */](1) : new InvariantError('cache-only fetchPolicy option should not be used together with query refetch.'));
        }
        if (fetchPolicy !== 'no-cache' &&
            fetchPolicy !== 'cache-and-network') {
            fetchPolicy = 'network-only';
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["t" /* isEqual */])(this.variables, variables)) {
            this.variables = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this.variables), variables);
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["t" /* isEqual */])(this.options.variables, this.variables)) {
            this.options.variables = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this.options.variables), this.variables);
        }
        return this.queryManager.fetchQuery(this.queryId, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this.options), { fetchPolicy: fetchPolicy }), FetchType.refetch);
    };
    ObservableQuery.prototype.fetchMore = function (fetchMoreOptions) {
        var _this = this;
         true ? Object(__WEBPACK_IMPORTED_MODULE_4_ts_invariant__["b" /* invariant */])(fetchMoreOptions.updateQuery, 2) : invariant(fetchMoreOptions.updateQuery, 'updateQuery option is required. This function defines how to update the query data with the new results.');
        var combinedOptions = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (fetchMoreOptions.query ? fetchMoreOptions : Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this.options), fetchMoreOptions), { variables: Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this.variables), fetchMoreOptions.variables) }))), { fetchPolicy: 'network-only' });
        var qid = this.queryManager.generateQueryId();
        return this.queryManager
            .fetchQuery(qid, combinedOptions, FetchType.normal, this.queryId)
            .then(function (fetchMoreResult) {
            _this.updateQuery(function (previousResult) {
                return fetchMoreOptions.updateQuery(previousResult, {
                    fetchMoreResult: fetchMoreResult.data,
                    variables: combinedOptions.variables,
                });
            });
            _this.queryManager.stopQuery(qid);
            return fetchMoreResult;
        }, function (error) {
            _this.queryManager.stopQuery(qid);
            throw error;
        });
    };
    ObservableQuery.prototype.subscribeToMore = function (options) {
        var _this = this;
        var subscription = this.queryManager
            .startGraphQLSubscription({
            query: options.document,
            variables: options.variables,
        })
            .subscribe({
            next: function (subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) {
                    _this.updateQuery(function (previous, _a) {
                        var variables = _a.variables;
                        return updateQuery(previous, {
                            subscriptionData: subscriptionData,
                            variables: variables,
                        });
                    });
                }
            },
            error: function (err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
                "production" === "production" || __WEBPACK_IMPORTED_MODULE_4_ts_invariant__["b" /* invariant */].error('Unhandled GraphQL subscription error', err);
            },
        });
        this.subscriptions.add(subscription);
        return function () {
            if (_this.subscriptions.delete(subscription)) {
                subscription.unsubscribe();
            }
        };
    };
    ObservableQuery.prototype.setOptions = function (opts) {
        var oldFetchPolicy = this.options.fetchPolicy;
        this.options = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this.options), opts);
        if (opts.pollInterval) {
            this.startPolling(opts.pollInterval);
        }
        else if (opts.pollInterval === 0) {
            this.stopPolling();
        }
        var fetchPolicy = opts.fetchPolicy;
        return this.setVariables(this.options.variables, oldFetchPolicy !== fetchPolicy && (oldFetchPolicy === 'cache-only' ||
            oldFetchPolicy === 'standby' ||
            fetchPolicy === 'network-only'), opts.fetchResults);
    };
    ObservableQuery.prototype.setVariables = function (variables, tryFetch, fetchResults) {
        if (tryFetch === void 0) { tryFetch = false; }
        if (fetchResults === void 0) { fetchResults = true; }
        this.isTornDown = false;
        variables = variables || this.variables;
        if (!tryFetch && Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["t" /* isEqual */])(variables, this.variables)) {
            return this.observers.size && fetchResults
                ? this.result()
                : Promise.resolve();
        }
        this.variables = this.options.variables = variables;
        if (!this.observers.size) {
            return Promise.resolve();
        }
        return this.queryManager.fetchQuery(this.queryId, this.options);
    };
    ObservableQuery.prototype.updateQuery = function (mapFn) {
        var queryManager = this.queryManager;
        var _a = queryManager.getQueryWithPreviousResult(this.queryId), previousResult = _a.previousResult, variables = _a.variables, document = _a.document;
        var newResult = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["J" /* tryFunctionOrLogError */])(function () {
            return mapFn(previousResult, { variables: variables });
        });
        if (newResult) {
            queryManager.dataStore.markUpdateQueryResult(document, variables, newResult);
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.stopPolling = function () {
        this.queryManager.stopPollingQuery(this.queryId);
        this.options.pollInterval = undefined;
    };
    ObservableQuery.prototype.startPolling = function (pollInterval) {
        assertNotCacheFirstOrOnly(this);
        this.options.pollInterval = pollInterval;
        this.queryManager.startPollingQuery(this.options, this.queryId);
    };
    ObservableQuery.prototype.updateLastResult = function (newResult) {
        var previousResult = this.lastResult;
        this.lastResult = newResult;
        this.lastResultSnapshot = this.queryManager.assumeImmutableResults
            ? newResult
            : Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["f" /* cloneDeep */])(newResult);
        return previousResult;
    };
    ObservableQuery.prototype.onSubscribe = function (observer) {
        var _this = this;
        try {
            var subObserver = observer._subscription._observer;
            if (subObserver && !subObserver.error) {
                subObserver.error = defaultSubscriptionObserverErrorCallback;
            }
        }
        catch (_a) { }
        var first = !this.observers.size;
        this.observers.add(observer);
        if (observer.next && this.lastResult)
            observer.next(this.lastResult);
        if (observer.error && this.lastError)
            observer.error(this.lastError);
        if (first) {
            this.setUpQuery();
        }
        return function () {
            if (_this.observers.delete(observer) && !_this.observers.size) {
                _this.tearDownQuery();
            }
        };
    };
    ObservableQuery.prototype.setUpQuery = function () {
        var _this = this;
        var _a = this, queryManager = _a.queryManager, queryId = _a.queryId;
        if (this.shouldSubscribe) {
            queryManager.addObservableQuery(queryId, this);
        }
        if (this.options.pollInterval) {
            assertNotCacheFirstOrOnly(this);
            queryManager.startPollingQuery(this.options, queryId);
        }
        var onError = function (error) {
            _this.updateLastResult(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, _this.lastResult), { errors: error.graphQLErrors, networkStatus: NetworkStatus.error, loading: false }));
            iterateObserversSafely(_this.observers, 'error', _this.lastError = error);
        };
        queryManager.observeQuery(queryId, this.options, {
            next: function (result) {
                if (_this.lastError || _this.isDifferentFromLastResult(result)) {
                    var previousResult_1 = _this.updateLastResult(result);
                    var _a = _this.options, query_1 = _a.query, variables = _a.variables, fetchPolicy_1 = _a.fetchPolicy;
                    if (queryManager.transform(query_1).hasClientExports) {
                        queryManager.getLocalState().addExportedVariables(query_1, variables).then(function (variables) {
                            var previousVariables = _this.variables;
                            _this.variables = _this.options.variables = variables;
                            if (!result.loading &&
                                previousResult_1 &&
                                fetchPolicy_1 !== 'cache-only' &&
                                queryManager.transform(query_1).serverQuery &&
                                !Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["t" /* isEqual */])(previousVariables, variables)) {
                                _this.refetch();
                            }
                            else {
                                iterateObserversSafely(_this.observers, 'next', result);
                            }
                        });
                    }
                    else {
                        iterateObserversSafely(_this.observers, 'next', result);
                    }
                }
            },
            error: onError,
        }).catch(onError);
    };
    ObservableQuery.prototype.tearDownQuery = function () {
        var queryManager = this.queryManager;
        this.isTornDown = true;
        queryManager.stopPollingQuery(this.queryId);
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
        this.subscriptions.clear();
        queryManager.removeObservableQuery(this.queryId);
        queryManager.stopQuery(this.queryId);
        this.observers.clear();
    };
    return ObservableQuery;
}(Observable));
function defaultSubscriptionObserverErrorCallback(error) {
    "production" === "production" || __WEBPACK_IMPORTED_MODULE_4_ts_invariant__["b" /* invariant */].error('Unhandled error', error.message, error.stack);
}
function iterateObserversSafely(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function (obs) { return obs[method] && observersWithMethod.push(obs); });
    observersWithMethod.forEach(function (obs) { return obs[method](argument); });
}
function assertNotCacheFirstOrOnly(obsQuery) {
    var fetchPolicy = obsQuery.options.fetchPolicy;
     true ? Object(__WEBPACK_IMPORTED_MODULE_4_ts_invariant__["b" /* invariant */])(fetchPolicy !== 'cache-first' && fetchPolicy !== 'cache-only', 3) : invariant(fetchPolicy !== 'cache-first' && fetchPolicy !== 'cache-only', 'Queries that specify the cache-first and cache-only fetchPolicies cannot also be polling queries.');
}

var MutationStore = (function () {
    function MutationStore() {
        this.store = {};
    }
    MutationStore.prototype.getStore = function () {
        return this.store;
    };
    MutationStore.prototype.get = function (mutationId) {
        return this.store[mutationId];
    };
    MutationStore.prototype.initMutation = function (mutationId, mutation, variables) {
        this.store[mutationId] = {
            mutation: mutation,
            variables: variables || {},
            loading: true,
            error: null,
        };
    };
    MutationStore.prototype.markMutationError = function (mutationId, error) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = error;
        }
    };
    MutationStore.prototype.markMutationResult = function (mutationId) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = null;
        }
    };
    MutationStore.prototype.reset = function () {
        this.store = {};
    };
    return MutationStore;
}());

var QueryStore = (function () {
    function QueryStore() {
        this.store = {};
    }
    QueryStore.prototype.getStore = function () {
        return this.store;
    };
    QueryStore.prototype.get = function (queryId) {
        return this.store[queryId];
    };
    QueryStore.prototype.initQuery = function (query) {
        var previousQuery = this.store[query.queryId];
         true ? Object(__WEBPACK_IMPORTED_MODULE_4_ts_invariant__["b" /* invariant */])(!previousQuery ||
            previousQuery.document === query.document ||
            Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["t" /* isEqual */])(previousQuery.document, query.document), 19) : invariant(!previousQuery ||
            previousQuery.document === query.document ||
            isEqual(previousQuery.document, query.document), 'Internal Error: may not update existing query string in store');
        var isSetVariables = false;
        var previousVariables = null;
        if (query.storePreviousVariables &&
            previousQuery &&
            previousQuery.networkStatus !== NetworkStatus.loading) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["t" /* isEqual */])(previousQuery.variables, query.variables)) {
                isSetVariables = true;
                previousVariables = previousQuery.variables;
            }
        }
        var networkStatus;
        if (isSetVariables) {
            networkStatus = NetworkStatus.setVariables;
        }
        else if (query.isPoll) {
            networkStatus = NetworkStatus.poll;
        }
        else if (query.isRefetch) {
            networkStatus = NetworkStatus.refetch;
        }
        else {
            networkStatus = NetworkStatus.loading;
        }
        var graphQLErrors = [];
        if (previousQuery && previousQuery.graphQLErrors) {
            graphQLErrors = previousQuery.graphQLErrors;
        }
        this.store[query.queryId] = {
            document: query.document,
            variables: query.variables,
            previousVariables: previousVariables,
            networkError: null,
            graphQLErrors: graphQLErrors,
            networkStatus: networkStatus,
            metadata: query.metadata,
        };
        if (typeof query.fetchMoreForQueryId === 'string' &&
            this.store[query.fetchMoreForQueryId]) {
            this.store[query.fetchMoreForQueryId].networkStatus =
                NetworkStatus.fetchMore;
        }
    };
    QueryStore.prototype.markQueryResult = function (queryId, result, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId])
            return;
        this.store[queryId].networkError = null;
        this.store[queryId].graphQLErrors = isNonEmptyArray(result.errors) ? result.errors : [];
        this.store[queryId].previousVariables = null;
        this.store[queryId].networkStatus = NetworkStatus.ready;
        if (typeof fetchMoreForQueryId === 'string' &&
            this.store[fetchMoreForQueryId]) {
            this.store[fetchMoreForQueryId].networkStatus = NetworkStatus.ready;
        }
    };
    QueryStore.prototype.markQueryError = function (queryId, error, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId])
            return;
        this.store[queryId].networkError = error;
        this.store[queryId].networkStatus = NetworkStatus.error;
        if (typeof fetchMoreForQueryId === 'string') {
            this.markQueryResultClient(fetchMoreForQueryId, true);
        }
    };
    QueryStore.prototype.markQueryResultClient = function (queryId, complete) {
        var storeValue = this.store && this.store[queryId];
        if (storeValue) {
            storeValue.networkError = null;
            storeValue.previousVariables = null;
            if (complete) {
                storeValue.networkStatus = NetworkStatus.ready;
            }
        }
    };
    QueryStore.prototype.stopQuery = function (queryId) {
        delete this.store[queryId];
    };
    QueryStore.prototype.reset = function (observableQueryIds) {
        var _this = this;
        Object.keys(this.store).forEach(function (queryId) {
            if (observableQueryIds.indexOf(queryId) < 0) {
                _this.stopQuery(queryId);
            }
            else {
                _this.store[queryId].networkStatus = NetworkStatus.loading;
            }
        });
    };
    return QueryStore;
}());

function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

var LocalState = (function () {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.cache = cache;
        if (client) {
            this.client = client;
        }
        if (resolvers) {
            this.addResolvers(resolvers);
        }
        if (fragmentMatcher) {
            this.setFragmentMatcher(fragmentMatcher);
        }
    }
    LocalState.prototype.addResolvers = function (resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) {
            resolvers.forEach(function (resolverGroup) {
                _this.resolvers = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["B" /* mergeDeep */])(_this.resolvers, resolverGroup);
            });
        }
        else {
            this.resolvers = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["B" /* mergeDeep */])(this.resolvers, resolvers);
        }
    };
    LocalState.prototype.setResolvers = function (resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function () {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function (_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_c) {
                if (document) {
                    return [2, this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function (localResult) { return (Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, remoteResult), { data: localResult.result })); })];
                }
                return [2, remoteResult];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function (fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function () {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function (document) {
        if (Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["s" /* hasDirectives */])(['client'], document)) {
            if (this.resolvers) {
                return document;
            }
            "production" === "production" || __WEBPACK_IMPORTED_MODULE_4_ts_invariant__["b" /* invariant */].warn('Found @client directives in a query but no ApolloClient resolvers ' +
                'were specified. This means ApolloClient local resolver handling ' +
                'has been disabled, and @client directives will be passed through ' +
                'to your link chain.');
        }
        return null;
    };
    LocalState.prototype.serverQuery = function (document) {
        return this.resolvers ? Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["D" /* removeClientSetsFromDocument */])(document) : document;
    };
    LocalState.prototype.prepareContext = function (context) {
        if (context === void 0) { context = {}; }
        var cache = this.cache;
        var newContext = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, context), { cache: cache, getCacheKey: function (obj) {
                if (cache.config) {
                    return cache.config.dataIdFromObject(obj);
                }
                else {
                     true ? Object(__WEBPACK_IMPORTED_MODULE_4_ts_invariant__["b" /* invariant */])(false, 6) : invariant(false, 'To use context.getCacheKey, you need to use a cache that has ' +
                        'a configurable dataIdFromObject, like apollo-cache-inmemory.');
                }
            } });
        return newContext;
    };
    LocalState.prototype.addExportedVariables = function (document, variables, context) {
        if (variables === void 0) { variables = {}; }
        if (context === void 0) { context = {}; }
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
                if (document) {
                    return [2, this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function (data) { return (Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, variables), data.exportedVariables)); })];
                }
                return [2, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, variables)];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function (document) {
        var forceResolvers = false;
        Object(__WEBPACK_IMPORTED_MODULE_5_graphql_language_visitor__["b" /* visit */])(document, {
            Directive: {
                enter: function (node) {
                    if (node.name.value === 'client' && node.arguments) {
                        forceResolvers = node.arguments.some(function (arg) {
                            return arg.name.value === 'always' &&
                                arg.value.kind === 'BooleanValue' &&
                                arg.value.value === true;
                        });
                        if (forceResolvers) {
                            return __WEBPACK_IMPORTED_MODULE_5_graphql_language_visitor__["a" /* BREAK */];
                        }
                    }
                },
            },
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function (document, variables) {
        return this.cache.diff({
            query: Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["d" /* buildQueryFromSelectionSet */])(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false,
        }).result;
    };
    LocalState.prototype.resolveDocument = function (document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) { context = {}; }
        if (variables === void 0) { variables = {}; }
        if (fragmentMatcher === void 0) { fragmentMatcher = function () { return true; }; }
        if (onlyRunForcedResolvers === void 0) { onlyRunForcedResolvers = false; }
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_b) {
                mainDefinition = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["l" /* getMainDefinition */])(document);
                fragments = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["j" /* getFragmentDefinitions */])(document);
                fragmentMap = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["g" /* createFragmentMap */])(fragments);
                definitionOperation = mainDefinition
                    .operation;
                defaultOperationType = definitionOperation
                    ? capitalizeFirstLetter(definitionOperation)
                    : 'Query';
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, context), { cache: cache,
                        client: client }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    onlyRunForcedResolvers: onlyRunForcedResolvers,
                };
                return [2, this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function (result) { return ({
                        result: result,
                        exportedVariables: execContext.exportedVariables,
                    }); })];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function (selectionSet, rootValue, execContext) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [rootValue];
                execute = function (selection) { return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */])(_this, void 0, void 0, function () {
                    var fragment, typeCondition;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
                        if (!Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["G" /* shouldInclude */])(selection, variables)) {
                            return [2];
                        }
                        if (Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["u" /* isField */])(selection)) {
                            return [2, this.resolveField(selection, rootValue, execContext).then(function (fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== 'undefined') {
                                        resultsToMerge.push((_a = {},
                                            _a[Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["F" /* resultKeyNameFromField */])(selection)] = fieldResult,
                                            _a));
                                    }
                                })];
                        }
                        if (Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["w" /* isInlineFragment */])(selection)) {
                            fragment = selection;
                        }
                        else {
                            fragment = fragmentMap[selection.name.value];
                             true ? Object(__WEBPACK_IMPORTED_MODULE_4_ts_invariant__["b" /* invariant */])(fragment, 7) : invariant(fragment, "No fragment named " + selection.name.value);
                        }
                        if (fragment && fragment.typeCondition) {
                            typeCondition = fragment.typeCondition.name.value;
                            if (execContext.fragmentMatcher(rootValue, typeCondition, context)) {
                                return [2, this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function (fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })];
                            }
                        }
                        return [2];
                    });
                }); };
                return [2, Promise.all(selectionSet.selections.map(execute)).then(function () {
                        return Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["C" /* mergeDeepArray */])(resultsToMerge);
                    })];
            });
        });
    };
    LocalState.prototype.resolveField = function (field, rootValue, execContext) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["F" /* resultKeyNameFromField */])(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers ||
                    this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) {
                            resultPromise = Promise.resolve(resolve(rootValue, Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["b" /* argumentsObjectFromField */])(field, variables), execContext.context, { field: field, fragmentMap: execContext.fragmentMap }));
                        }
                    }
                }
                return [2, resultPromise.then(function (result) {
                        if (result === void 0) { result = defaultResult; }
                        if (field.directives) {
                            field.directives.forEach(function (directive) {
                                if (directive.name.value === 'export' && directive.arguments) {
                                    directive.arguments.forEach(function (arg) {
                                        if (arg.name.value === 'as' && arg.value.kind === 'StringValue') {
                                            execContext.exportedVariables[arg.value.value] = result;
                                        }
                                    });
                                }
                            });
                        }
                        if (!field.selectionSet) {
                            return result;
                        }
                        if (result == null) {
                            return result;
                        }
                        if (Array.isArray(result)) {
                            return _this.resolveSubSelectedArray(field, result, execContext);
                        }
                        if (field.selectionSet) {
                            return _this.resolveSelectionSet(field.selectionSet, result, execContext);
                        }
                    })];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function (field, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function (item) {
            if (item === null) {
                return null;
            }
            if (Array.isArray(item)) {
                return _this.resolveSubSelectedArray(field, item, execContext);
            }
            if (field.selectionSet) {
                return _this.resolveSelectionSet(field.selectionSet, item, execContext);
            }
        }));
    };
    return LocalState;
}());

function multiplex(inner) {
    var observers = new Set();
    var sub = null;
    return new Observable(function (observer) {
        observers.add(observer);
        sub = sub || inner.subscribe({
            next: function (value) {
                observers.forEach(function (obs) { return obs.next && obs.next(value); });
            },
            error: function (error) {
                observers.forEach(function (obs) { return obs.error && obs.error(error); });
            },
            complete: function () {
                observers.forEach(function (obs) { return obs.complete && obs.complete(); });
            },
        });
        return function () {
            if (observers.delete(observer) && !observers.size && sub) {
                sub.unsubscribe();
                sub = null;
            }
        };
    });
}
function asyncMap(observable, mapFn) {
    return new Observable(function (observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeNextCount = 0;
        var completed = false;
        var handler = {
            next: function (value) {
                ++activeNextCount;
                new Promise(function (resolve) {
                    resolve(mapFn(value));
                }).then(function (result) {
                    --activeNextCount;
                    next && next.call(observer, result);
                    completed && handler.complete();
                }, function (e) {
                    --activeNextCount;
                    error && error.call(observer, e);
                });
            },
            error: function (e) {
                error && error.call(observer, e);
            },
            complete: function () {
                completed = true;
                if (!activeNextCount) {
                    complete && complete.call(observer);
                }
            },
        };
        var sub = observable.subscribe(handler);
        return function () { return sub.unsubscribe(); };
    });
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
var QueryManager = (function () {
    function QueryManager(_a) {
        var link = _a.link, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, store = _a.store, _c = _a.onBroadcast, onBroadcast = _c === void 0 ? function () { return undefined; } : _c, _d = _a.ssrMode, ssrMode = _d === void 0 ? false : _d, _e = _a.clientAwareness, clientAwareness = _e === void 0 ? {} : _e, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
        this.mutationStore = new MutationStore();
        this.queryStore = new QueryStore();
        this.clientAwareness = {};
        this.idCounter = 1;
        this.queries = new Map();
        this.fetchQueryRejectFns = new Map();
        this.transformCache = new (__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["e" /* canUseWeakMap */] ? WeakMap : Map)();
        this.inFlightLinkObservables = new Map();
        this.pollingInfoByQueryId = new Map();
        this.link = link;
        this.queryDeduplication = queryDeduplication;
        this.dataStore = store;
        this.onBroadcast = onBroadcast;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new LocalState({ cache: store.getCache() });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = !!assumeImmutableResults;
    }
    QueryManager.prototype.stop = function () {
        var _this = this;
        this.queries.forEach(function (_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.fetchQueryRejectFns.forEach(function (reject) {
            reject( true ? new __WEBPACK_IMPORTED_MODULE_4_ts_invariant__["a" /* InvariantError */](8) : new InvariantError('QueryManager stopped while query was in flight'));
        });
    };
    QueryManager.prototype.mutate = function (_a) {
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueriesByName = _a.updateQueries, _b = _a.refetchQueries, refetchQueries = _b === void 0 ? [] : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, updateWithProxyFn = _a.update, _d = _a.errorPolicy, errorPolicy = _d === void 0 ? 'none' : _d, fetchPolicy = _a.fetchPolicy, _e = _a.context, context = _e === void 0 ? {} : _e;
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var mutationId, generateUpdateQueriesInfo, self;
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_f) {
                switch (_f.label) {
                    case 0:
                         true ? Object(__WEBPACK_IMPORTED_MODULE_4_ts_invariant__["b" /* invariant */])(mutation, 9) : invariant(mutation, 'mutation option is required. You must specify your GraphQL document in the mutation option.');
                         true ? Object(__WEBPACK_IMPORTED_MODULE_4_ts_invariant__["b" /* invariant */])(!fetchPolicy || fetchPolicy === 'no-cache', 10) : invariant(!fetchPolicy || fetchPolicy === 'no-cache', "Mutations only support a 'no-cache' fetchPolicy. If you don't want to disable the cache, remove your fetchPolicy setting to proceed with the default mutation behavior.");
                        mutationId = this.generateQueryId();
                        mutation = this.transform(mutation).document;
                        this.setQuery(mutationId, function () { return ({ document: mutation }); });
                        variables = this.getVariables(mutation, variables);
                        if (!this.transform(mutation).hasClientExports) return [3, 2];
                        return [4, this.localState.addExportedVariables(mutation, variables, context)];
                    case 1:
                        variables = _f.sent();
                        _f.label = 2;
                    case 2:
                        generateUpdateQueriesInfo = function () {
                            var ret = {};
                            if (updateQueriesByName) {
                                _this.queries.forEach(function (_a, queryId) {
                                    var observableQuery = _a.observableQuery;
                                    if (observableQuery) {
                                        var queryName = observableQuery.queryName;
                                        if (queryName &&
                                            hasOwnProperty.call(updateQueriesByName, queryName)) {
                                            ret[queryId] = {
                                                updater: updateQueriesByName[queryName],
                                                query: _this.queryStore.get(queryId),
                                            };
                                        }
                                    }
                                });
                            }
                            return ret;
                        };
                        this.mutationStore.initMutation(mutationId, mutation, variables);
                        this.dataStore.markMutationInit({
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            updateQueries: generateUpdateQueriesInfo(),
                            update: updateWithProxyFn,
                            optimisticResponse: optimisticResponse,
                        });
                        this.broadcastQueries();
                        self = this;
                        return [2, new Promise(function (resolve, reject) {
                                var storeResult;
                                var error;
                                self.getObservableFromLink(mutation, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, context), { optimisticResponse: optimisticResponse }), variables, false).subscribe({
                                    next: function (result) {
                                        if (Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["q" /* graphQLResultHasError */])(result) && errorPolicy === 'none') {
                                            error = new ApolloError({
                                                graphQLErrors: result.errors,
                                            });
                                            return;
                                        }
                                        self.mutationStore.markMutationResult(mutationId);
                                        if (fetchPolicy !== 'no-cache') {
                                            self.dataStore.markMutationResult({
                                                mutationId: mutationId,
                                                result: result,
                                                document: mutation,
                                                variables: variables,
                                                updateQueries: generateUpdateQueriesInfo(),
                                                update: updateWithProxyFn,
                                            });
                                        }
                                        storeResult = result;
                                    },
                                    error: function (err) {
                                        self.mutationStore.markMutationError(mutationId, err);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse,
                                        });
                                        self.broadcastQueries();
                                        self.setQuery(mutationId, function () { return ({ document: null }); });
                                        reject(new ApolloError({
                                            networkError: err,
                                        }));
                                    },
                                    complete: function () {
                                        if (error) {
                                            self.mutationStore.markMutationError(mutationId, error);
                                        }
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse,
                                        });
                                        self.broadcastQueries();
                                        if (error) {
                                            reject(error);
                                            return;
                                        }
                                        if (typeof refetchQueries === 'function') {
                                            refetchQueries = refetchQueries(storeResult);
                                        }
                                        var refetchQueryPromises = [];
                                        if (isNonEmptyArray(refetchQueries)) {
                                            refetchQueries.forEach(function (refetchQuery) {
                                                if (typeof refetchQuery === 'string') {
                                                    self.queries.forEach(function (_a) {
                                                        var observableQuery = _a.observableQuery;
                                                        if (observableQuery &&
                                                            observableQuery.queryName === refetchQuery) {
                                                            refetchQueryPromises.push(observableQuery.refetch());
                                                        }
                                                    });
                                                }
                                                else {
                                                    var queryOptions = {
                                                        query: refetchQuery.query,
                                                        variables: refetchQuery.variables,
                                                        fetchPolicy: 'network-only',
                                                    };
                                                    if (refetchQuery.context) {
                                                        queryOptions.context = refetchQuery.context;
                                                    }
                                                    refetchQueryPromises.push(self.query(queryOptions));
                                                }
                                            });
                                        }
                                        Promise.all(awaitRefetchQueries ? refetchQueryPromises : []).then(function () {
                                            self.setQuery(mutationId, function () { return ({ document: null }); });
                                            if (errorPolicy === 'ignore' &&
                                                storeResult &&
                                                Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["q" /* graphQLResultHasError */])(storeResult)) {
                                                delete storeResult.errors;
                                            }
                                            resolve(storeResult);
                                        });
                                    },
                                });
                            })];
                }
            });
        });
    };
    QueryManager.prototype.fetchQuery = function (queryId, options, fetchType, fetchMoreForQueryId) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var _a, metadata, _b, fetchPolicy, _c, context, query, variables, storeResult, isNetworkOnly, needToFetch, _d, complete, result, shouldFetch, requestId, cancel, networkResult;
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _a = options.metadata, metadata = _a === void 0 ? null : _a, _b = options.fetchPolicy, fetchPolicy = _b === void 0 ? 'cache-first' : _b, _c = options.context, context = _c === void 0 ? {} : _c;
                        query = this.transform(options.query).document;
                        variables = this.getVariables(query, options.variables);
                        if (!this.transform(query).hasClientExports) return [3, 2];
                        return [4, this.localState.addExportedVariables(query, variables, context)];
                    case 1:
                        variables = _e.sent();
                        _e.label = 2;
                    case 2:
                        options = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, options), { variables: variables });
                        isNetworkOnly = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
                        needToFetch = isNetworkOnly;
                        if (!isNetworkOnly) {
                            _d = this.dataStore.getCache().diff({
                                query: query,
                                variables: variables,
                                returnPartialData: true,
                                optimistic: false,
                            }), complete = _d.complete, result = _d.result;
                            needToFetch = !complete || fetchPolicy === 'cache-and-network';
                            storeResult = result;
                        }
                        shouldFetch = needToFetch && fetchPolicy !== 'cache-only' && fetchPolicy !== 'standby';
                        if (Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["s" /* hasDirectives */])(['live'], query))
                            shouldFetch = true;
                        requestId = this.idCounter++;
                        cancel = fetchPolicy !== 'no-cache'
                            ? this.updateQueryWatch(queryId, query, options)
                            : undefined;
                        this.setQuery(queryId, function () { return ({
                            document: query,
                            lastRequestId: requestId,
                            invalidated: true,
                            cancel: cancel,
                        }); });
                        this.invalidate(fetchMoreForQueryId);
                        this.queryStore.initQuery({
                            queryId: queryId,
                            document: query,
                            storePreviousVariables: shouldFetch,
                            variables: variables,
                            isPoll: fetchType === FetchType.poll,
                            isRefetch: fetchType === FetchType.refetch,
                            metadata: metadata,
                            fetchMoreForQueryId: fetchMoreForQueryId,
                        });
                        this.broadcastQueries();
                        if (shouldFetch) {
                            networkResult = this.fetchRequest({
                                requestId: requestId,
                                queryId: queryId,
                                document: query,
                                options: options,
                                fetchMoreForQueryId: fetchMoreForQueryId,
                            }).catch(function (error) {
                                if (isApolloError(error)) {
                                    throw error;
                                }
                                else {
                                    if (requestId >= _this.getQuery(queryId).lastRequestId) {
                                        _this.queryStore.markQueryError(queryId, error, fetchMoreForQueryId);
                                        _this.invalidate(queryId);
                                        _this.invalidate(fetchMoreForQueryId);
                                        _this.broadcastQueries();
                                    }
                                    throw new ApolloError({ networkError: error });
                                }
                            });
                            if (fetchPolicy !== 'cache-and-network') {
                                return [2, networkResult];
                            }
                            networkResult.catch(function () { });
                        }
                        this.queryStore.markQueryResultClient(queryId, !shouldFetch);
                        this.invalidate(queryId);
                        this.invalidate(fetchMoreForQueryId);
                        if (this.transform(query).hasForcedResolvers) {
                            return [2, this.localState.runResolvers({
                                    document: query,
                                    remoteResult: { data: storeResult },
                                    context: context,
                                    variables: variables,
                                    onlyRunForcedResolvers: true,
                                }).then(function (result) {
                                    _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                                    _this.broadcastQueries();
                                    return result;
                                })];
                        }
                        this.broadcastQueries();
                        return [2, { data: storeResult }];
                }
            });
        });
    };
    QueryManager.prototype.markQueryResult = function (queryId, result, _a, fetchMoreForQueryId) {
        var fetchPolicy = _a.fetchPolicy, variables = _a.variables, errorPolicy = _a.errorPolicy;
        if (fetchPolicy === 'no-cache') {
            this.setQuery(queryId, function () { return ({
                newData: { result: result.data, complete: true },
            }); });
        }
        else {
            this.dataStore.markQueryResult(result, this.getQuery(queryId).document, variables, fetchMoreForQueryId, errorPolicy === 'ignore' || errorPolicy === 'all');
        }
    };
    QueryManager.prototype.queryListenerForObserver = function (queryId, options, observer) {
        var _this = this;
        function invoke(method, argument) {
            if (observer[method]) {
                try {
                    observer[method](argument);
                }
                catch (e) {
                    "production" === "production" || __WEBPACK_IMPORTED_MODULE_4_ts_invariant__["b" /* invariant */].error(e);
                }
            }
            else if (method === 'error') {
                "production" === "production" || __WEBPACK_IMPORTED_MODULE_4_ts_invariant__["b" /* invariant */].error(argument);
            }
        }
        return function (queryStoreValue, newData) {
            _this.invalidate(queryId, false);
            if (!queryStoreValue)
                return;
            var _a = _this.getQuery(queryId), observableQuery = _a.observableQuery, document = _a.document;
            var fetchPolicy = observableQuery
                ? observableQuery.options.fetchPolicy
                : options.fetchPolicy;
            if (fetchPolicy === 'standby')
                return;
            var loading = isNetworkRequestInFlight(queryStoreValue.networkStatus);
            var lastResult = observableQuery && observableQuery.getLastResult();
            var networkStatusChanged = !!(lastResult &&
                lastResult.networkStatus !== queryStoreValue.networkStatus);
            var shouldNotifyIfLoading = options.returnPartialData ||
                (!newData && queryStoreValue.previousVariables) ||
                (networkStatusChanged && options.notifyOnNetworkStatusChange) ||
                fetchPolicy === 'cache-only' ||
                fetchPolicy === 'cache-and-network';
            if (loading && !shouldNotifyIfLoading) {
                return;
            }
            var hasGraphQLErrors = isNonEmptyArray(queryStoreValue.graphQLErrors);
            var errorPolicy = observableQuery
                && observableQuery.options.errorPolicy
                || options.errorPolicy
                || 'none';
            if (errorPolicy === 'none' && hasGraphQLErrors || queryStoreValue.networkError) {
                return invoke('error', new ApolloError({
                    graphQLErrors: queryStoreValue.graphQLErrors,
                    networkError: queryStoreValue.networkError,
                }));
            }
            try {
                var data = void 0;
                var isMissing = void 0;
                if (newData) {
                    if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'network-only') {
                        _this.setQuery(queryId, function () { return ({ newData: null }); });
                    }
                    data = newData.result;
                    isMissing = !newData.complete;
                }
                else {
                    var lastError = observableQuery && observableQuery.getLastError();
                    var errorStatusChanged = errorPolicy !== 'none' &&
                        (lastError && lastError.graphQLErrors) !==
                            queryStoreValue.graphQLErrors;
                    if (lastResult && lastResult.data && !errorStatusChanged) {
                        data = lastResult.data;
                        isMissing = false;
                    }
                    else {
                        var diffResult = _this.dataStore.getCache().diff({
                            query: document,
                            variables: queryStoreValue.previousVariables ||
                                queryStoreValue.variables,
                            returnPartialData: true,
                            optimistic: true,
                        });
                        data = diffResult.result;
                        isMissing = !diffResult.complete;
                    }
                }
                var stale = isMissing && !(options.returnPartialData ||
                    fetchPolicy === 'cache-only');
                var resultFromStore = {
                    data: stale ? lastResult && lastResult.data : data,
                    loading: loading,
                    networkStatus: queryStoreValue.networkStatus,
                    stale: stale,
                };
                if (errorPolicy === 'all' && hasGraphQLErrors) {
                    resultFromStore.errors = queryStoreValue.graphQLErrors;
                }
                invoke('next', resultFromStore);
            }
            catch (networkError) {
                invoke('error', new ApolloError({ networkError: networkError }));
            }
        };
    };
    QueryManager.prototype.transform = function (document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cache = this.dataStore.getCache();
            var transformed = cache.transformDocument(document);
            var forLink = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["E" /* removeConnectionDirectiveFromDocument */])(cache.transformForLink(transformed));
            var clientQuery = this.localState.clientQuery(transformed);
            var serverQuery = this.localState.serverQuery(forLink);
            var cacheEntry_1 = {
                document: transformed,
                hasClientExports: Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["r" /* hasClientExports */])(transformed),
                hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                clientQuery: clientQuery,
                serverQuery: serverQuery,
                defaultVars: Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["h" /* getDefaultValues */])(Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["m" /* getOperationDefinition */])(transformed)),
            };
            var add = function (doc) {
                if (doc && !transformCache.has(doc)) {
                    transformCache.set(doc, cacheEntry_1);
                }
            };
            add(document);
            add(transformed);
            add(clientQuery);
            add(serverQuery);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function (document, variables) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this.transform(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function (options, shouldSubscribe) {
        if (shouldSubscribe === void 0) { shouldSubscribe = true; }
         true ? Object(__WEBPACK_IMPORTED_MODULE_4_ts_invariant__["b" /* invariant */])(options.fetchPolicy !== 'standby', 11) : invariant(options.fetchPolicy !== 'standby', 'client.watchQuery cannot be called with fetchPolicy set to "standby"');
        options.variables = this.getVariables(options.query, options.variables);
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') {
            options.notifyOnNetworkStatusChange = false;
        }
        var transformedOptions = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, options);
        return new ObservableQuery({
            queryManager: this,
            options: transformedOptions,
            shouldSubscribe: shouldSubscribe,
        });
    };
    QueryManager.prototype.query = function (options) {
        var _this = this;
         true ? Object(__WEBPACK_IMPORTED_MODULE_4_ts_invariant__["b" /* invariant */])(options.query, 12) : invariant(options.query, 'query option is required. You must specify your GraphQL document ' +
            'in the query option.');
         true ? Object(__WEBPACK_IMPORTED_MODULE_4_ts_invariant__["b" /* invariant */])(options.query.kind === 'Document', 13) : invariant(options.query.kind === 'Document', 'You must wrap the query string in a "gql" tag.');
         true ? Object(__WEBPACK_IMPORTED_MODULE_4_ts_invariant__["b" /* invariant */])(!options.returnPartialData, 14) : invariant(!options.returnPartialData, 'returnPartialData option only supported on watchQuery.');
         true ? Object(__WEBPACK_IMPORTED_MODULE_4_ts_invariant__["b" /* invariant */])(!options.pollInterval, 15) : invariant(!options.pollInterval, 'pollInterval option only supported on watchQuery.');
        return new Promise(function (resolve, reject) {
            var watchedQuery = _this.watchQuery(options, false);
            _this.fetchQueryRejectFns.set("query:" + watchedQuery.queryId, reject);
            watchedQuery
                .result()
                .then(resolve, reject)
                .then(function () {
                return _this.fetchQueryRejectFns.delete("query:" + watchedQuery.queryId);
            });
        });
    };
    QueryManager.prototype.generateQueryId = function () {
        return String(this.idCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function (queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function (queryId) {
        this.stopPollingQuery(queryId);
        this.queryStore.stopQuery(queryId);
        this.invalidate(queryId);
    };
    QueryManager.prototype.addQueryListener = function (queryId, listener) {
        this.setQuery(queryId, function (_a) {
            var listeners = _a.listeners;
            listeners.add(listener);
            return { invalidated: false };
        });
    };
    QueryManager.prototype.updateQueryWatch = function (queryId, document, options) {
        var _this = this;
        var cancel = this.getQuery(queryId).cancel;
        if (cancel)
            cancel();
        var previousResult = function () {
            var previousResult = null;
            var observableQuery = _this.getQuery(queryId).observableQuery;
            if (observableQuery) {
                var lastResult = observableQuery.getLastResult();
                if (lastResult) {
                    previousResult = lastResult.data;
                }
            }
            return previousResult;
        };
        return this.dataStore.getCache().watch({
            query: document,
            variables: options.variables,
            optimistic: true,
            previousResult: previousResult,
            callback: function (newData) {
                _this.setQuery(queryId, function () { return ({ invalidated: true, newData: newData }); });
            },
        });
    };
    QueryManager.prototype.addObservableQuery = function (queryId, observableQuery) {
        this.setQuery(queryId, function () { return ({ observableQuery: observableQuery }); });
    };
    QueryManager.prototype.removeObservableQuery = function (queryId) {
        var cancel = this.getQuery(queryId).cancel;
        this.setQuery(queryId, function () { return ({ observableQuery: null }); });
        if (cancel)
            cancel();
    };
    QueryManager.prototype.clearStore = function () {
        this.fetchQueryRejectFns.forEach(function (reject) {
            reject( true ? new __WEBPACK_IMPORTED_MODULE_4_ts_invariant__["a" /* InvariantError */](16) : new InvariantError('Store reset while query was in flight (not completed in link chain)'));
        });
        var resetIds = [];
        this.queries.forEach(function (_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery)
                resetIds.push(queryId);
        });
        this.queryStore.reset(resetIds);
        this.mutationStore.reset();
        return this.dataStore.reset();
    };
    QueryManager.prototype.resetStore = function () {
        var _this = this;
        return this.clearStore().then(function () {
            return _this.reFetchObservableQueries();
        });
    };
    QueryManager.prototype.reFetchObservableQueries = function (includeStandby) {
        var _this = this;
        if (includeStandby === void 0) { includeStandby = false; }
        var observableQueryPromises = [];
        this.queries.forEach(function (_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) {
                var fetchPolicy = observableQuery.options.fetchPolicy;
                observableQuery.resetLastResults();
                if (fetchPolicy !== 'cache-only' &&
                    (includeStandby || fetchPolicy !== 'standby')) {
                    observableQueryPromises.push(observableQuery.refetch());
                }
                _this.setQuery(queryId, function () { return ({ newData: null }); });
                _this.invalidate(queryId);
            }
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.observeQuery = function (queryId, options, observer) {
        this.addQueryListener(queryId, this.queryListenerForObserver(queryId, options, observer));
        return this.fetchQuery(queryId, options);
    };
    QueryManager.prototype.startQuery = function (queryId, options, listener) {
        "production" === "production" || __WEBPACK_IMPORTED_MODULE_4_ts_invariant__["b" /* invariant */].warn("The QueryManager.startQuery method has been deprecated");
        this.addQueryListener(queryId, listener);
        this.fetchQuery(queryId, options)
            .catch(function () { return undefined; });
        return queryId;
    };
    QueryManager.prototype.startGraphQLSubscription = function (_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, variables = _a.variables;
        query = this.transform(query).document;
        variables = this.getVariables(query, variables);
        var makeObservable = function (variables) {
            return _this.getObservableFromLink(query, {}, variables, false).map(function (result) {
                if (!fetchPolicy || fetchPolicy !== 'no-cache') {
                    _this.dataStore.markSubscriptionResult(result, query, variables);
                    _this.broadcastQueries();
                }
                if (Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["q" /* graphQLResultHasError */])(result)) {
                    throw new ApolloError({
                        graphQLErrors: result.errors,
                    });
                }
                return result;
            });
        };
        if (this.transform(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables).then(makeObservable);
            return new Observable(function (observer) {
                var sub = null;
                observablePromise_1.then(function (observable) { return sub = observable.subscribe(observer); }, observer.error);
                return function () { return sub && sub.unsubscribe(); };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function (queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function (queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function (queryId) {
        this.fetchQueryRejectFns.delete("query:" + queryId);
        this.fetchQueryRejectFns.delete("fetchRequest:" + queryId);
        this.getQuery(queryId).subscriptions.forEach(function (x) { return x.unsubscribe(); });
        this.queries.delete(queryId);
    };
    QueryManager.prototype.getCurrentQueryResult = function (observableQuery, optimistic) {
        if (optimistic === void 0) { optimistic = true; }
        var _a = observableQuery.options, variables = _a.variables, query = _a.query, fetchPolicy = _a.fetchPolicy, returnPartialData = _a.returnPartialData;
        var lastResult = observableQuery.getLastResult();
        var newData = this.getQuery(observableQuery.queryId).newData;
        if (newData && newData.complete) {
            return { data: newData.result, partial: false };
        }
        if (fetchPolicy === 'no-cache' || fetchPolicy === 'network-only') {
            return { data: undefined, partial: false };
        }
        var _b = this.dataStore.getCache().diff({
            query: query,
            variables: variables,
            previousResult: lastResult ? lastResult.data : undefined,
            returnPartialData: true,
            optimistic: optimistic,
        }), result = _b.result, complete = _b.complete;
        return {
            data: (complete || returnPartialData) ? result : void 0,
            partial: !complete,
        };
    };
    QueryManager.prototype.getQueryWithPreviousResult = function (queryIdOrObservable) {
        var observableQuery;
        if (typeof queryIdOrObservable === 'string') {
            var foundObserveableQuery = this.getQuery(queryIdOrObservable).observableQuery;
             true ? Object(__WEBPACK_IMPORTED_MODULE_4_ts_invariant__["b" /* invariant */])(foundObserveableQuery, 17) : invariant(foundObserveableQuery, "ObservableQuery with this id doesn't exist: " + queryIdOrObservable);
            observableQuery = foundObserveableQuery;
        }
        else {
            observableQuery = queryIdOrObservable;
        }
        var _a = observableQuery.options, variables = _a.variables, query = _a.query;
        return {
            previousResult: this.getCurrentQueryResult(observableQuery, false).data,
            variables: variables,
            document: query,
        };
    };
    QueryManager.prototype.broadcastQueries = function () {
        var _this = this;
        this.onBroadcast();
        this.queries.forEach(function (info, id) {
            if (info.invalidated) {
                info.listeners.forEach(function (listener) {
                    if (listener) {
                        listener(_this.queryStore.get(id), info.newData);
                    }
                });
            }
        });
    };
    QueryManager.prototype.getLocalState = function () {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function (query, context, variables, deduplication) {
        var _this = this;
        if (deduplication === void 0) { deduplication = this.queryDeduplication; }
        var observable;
        var serverQuery = this.transform(query).serverQuery;
        if (serverQuery) {
            var _a = this, inFlightLinkObservables_1 = _a.inFlightLinkObservables, link = _a.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["n" /* getOperationName */])(serverQuery) || void 0,
                context: this.prepareContext(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, context), { forceFetch: !deduplication })),
            };
            context = operation.context;
            if (deduplication) {
                var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                var varJson_1 = JSON.stringify(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    byVariables_1.set(varJson_1, observable = multiplex(Object(__WEBPACK_IMPORTED_MODULE_2_apollo_link__["c" /* execute */])(link, operation)));
                    var cleanup = function () {
                        byVariables_1.delete(varJson_1);
                        if (!byVariables_1.size)
                            inFlightLinkObservables_1.delete(serverQuery);
                        cleanupSub_1.unsubscribe();
                    };
                    var cleanupSub_1 = observable.subscribe({
                        next: cleanup,
                        error: cleanup,
                        complete: cleanup,
                    });
                }
            }
            else {
                observable = multiplex(Object(__WEBPACK_IMPORTED_MODULE_2_apollo_link__["c" /* execute */])(link, operation));
            }
        }
        else {
            observable = Observable.of({ data: {} });
            context = this.prepareContext(context);
        }
        var clientQuery = this.transform(query).clientQuery;
        if (clientQuery) {
            observable = asyncMap(observable, function (result) {
                return _this.localState.runResolvers({
                    document: clientQuery,
                    remoteResult: result,
                    context: context,
                    variables: variables,
                });
            });
        }
        return observable;
    };
    QueryManager.prototype.fetchRequest = function (_a) {
        var _this = this;
        var requestId = _a.requestId, queryId = _a.queryId, document = _a.document, options = _a.options, fetchMoreForQueryId = _a.fetchMoreForQueryId;
        var variables = options.variables, _b = options.errorPolicy, errorPolicy = _b === void 0 ? 'none' : _b, fetchPolicy = options.fetchPolicy;
        var resultFromStore;
        var errorsFromStore;
        return new Promise(function (resolve, reject) {
            var observable = _this.getObservableFromLink(document, options.context, variables);
            var fqrfId = "fetchRequest:" + queryId;
            _this.fetchQueryRejectFns.set(fqrfId, reject);
            var cleanup = function () {
                _this.fetchQueryRejectFns.delete(fqrfId);
                _this.setQuery(queryId, function (_a) {
                    var subscriptions = _a.subscriptions;
                    subscriptions.delete(subscription);
                });
            };
            var subscription = observable.map(function (result) {
                if (requestId >= _this.getQuery(queryId).lastRequestId) {
                    _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                    _this.queryStore.markQueryResult(queryId, result, fetchMoreForQueryId);
                    _this.invalidate(queryId);
                    _this.invalidate(fetchMoreForQueryId);
                    _this.broadcastQueries();
                }
                if (errorPolicy === 'none' && isNonEmptyArray(result.errors)) {
                    return reject(new ApolloError({
                        graphQLErrors: result.errors,
                    }));
                }
                if (errorPolicy === 'all') {
                    errorsFromStore = result.errors;
                }
                if (fetchMoreForQueryId || fetchPolicy === 'no-cache') {
                    resultFromStore = result.data;
                }
                else {
                    var _a = _this.dataStore.getCache().diff({
                        variables: variables,
                        query: document,
                        optimistic: false,
                        returnPartialData: true,
                    }), result_1 = _a.result, complete = _a.complete;
                    if (complete || options.returnPartialData) {
                        resultFromStore = result_1;
                    }
                }
            }).subscribe({
                error: function (error) {
                    cleanup();
                    reject(error);
                },
                complete: function () {
                    cleanup();
                    resolve({
                        data: resultFromStore,
                        errors: errorsFromStore,
                        loading: false,
                        networkStatus: NetworkStatus.ready,
                        stale: false,
                    });
                },
            });
            _this.setQuery(queryId, function (_a) {
                var subscriptions = _a.subscriptions;
                subscriptions.add(subscription);
            });
        });
    };
    QueryManager.prototype.getQuery = function (queryId) {
        return (this.queries.get(queryId) || {
            listeners: new Set(),
            invalidated: false,
            document: null,
            newData: null,
            lastRequestId: 1,
            observableQuery: null,
            subscriptions: new Set(),
        });
    };
    QueryManager.prototype.setQuery = function (queryId, updater) {
        var prev = this.getQuery(queryId);
        var newInfo = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, prev), updater(prev));
        this.queries.set(queryId, newInfo);
    };
    QueryManager.prototype.invalidate = function (queryId, invalidated) {
        if (invalidated === void 0) { invalidated = true; }
        if (queryId) {
            this.setQuery(queryId, function () { return ({ invalidated: invalidated }); });
        }
    };
    QueryManager.prototype.prepareContext = function (context) {
        if (context === void 0) { context = {}; }
        var newContext = this.localState.prepareContext(context);
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, newContext), { clientAwareness: this.clientAwareness });
    };
    QueryManager.prototype.checkInFlight = function (queryId) {
        var query = this.queryStore.get(queryId);
        return (query &&
            query.networkStatus !== NetworkStatus.ready &&
            query.networkStatus !== NetworkStatus.error);
    };
    QueryManager.prototype.startPollingQuery = function (options, queryId, listener) {
        var _this = this;
        var pollInterval = options.pollInterval;
         true ? Object(__WEBPACK_IMPORTED_MODULE_4_ts_invariant__["b" /* invariant */])(pollInterval, 18) : invariant(pollInterval, 'Attempted to start a polling query without a polling interval.');
        if (!this.ssrMode) {
            var info = this.pollingInfoByQueryId.get(queryId);
            if (!info) {
                this.pollingInfoByQueryId.set(queryId, (info = {}));
            }
            info.interval = pollInterval;
            info.options = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, options), { fetchPolicy: 'network-only' });
            var maybeFetch_1 = function () {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    if (_this.checkInFlight(queryId)) {
                        poll_1();
                    }
                    else {
                        _this.fetchQuery(queryId, info.options, FetchType.poll).then(poll_1, poll_1);
                    }
                }
            };
            var poll_1 = function () {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    clearTimeout(info.timeout);
                    info.timeout = setTimeout(maybeFetch_1, info.interval);
                }
            };
            if (listener) {
                this.addQueryListener(queryId, listener);
            }
            poll_1();
        }
        return queryId;
    };
    QueryManager.prototype.stopPollingQuery = function (queryId) {
        this.pollingInfoByQueryId.delete(queryId);
    };
    return QueryManager;
}());

var DataStore = (function () {
    function DataStore(initialCache) {
        this.cache = initialCache;
    }
    DataStore.prototype.getCache = function () {
        return this.cache;
    };
    DataStore.prototype.markQueryResult = function (result, document, variables, fetchMoreForQueryId, ignoreErrors) {
        if (ignoreErrors === void 0) { ignoreErrors = false; }
        var writeWithErrors = !Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["q" /* graphQLResultHasError */])(result);
        if (ignoreErrors && Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["q" /* graphQLResultHasError */])(result) && result.data) {
            writeWithErrors = true;
        }
        if (!fetchMoreForQueryId && writeWithErrors) {
            this.cache.write({
                result: result.data,
                dataId: 'ROOT_QUERY',
                query: document,
                variables: variables,
            });
        }
    };
    DataStore.prototype.markSubscriptionResult = function (result, document, variables) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["q" /* graphQLResultHasError */])(result)) {
            this.cache.write({
                result: result.data,
                dataId: 'ROOT_SUBSCRIPTION',
                query: document,
                variables: variables,
            });
        }
    };
    DataStore.prototype.markMutationInit = function (mutation) {
        var _this = this;
        if (mutation.optimisticResponse) {
            var optimistic_1;
            if (typeof mutation.optimisticResponse === 'function') {
                optimistic_1 = mutation.optimisticResponse(mutation.variables);
            }
            else {
                optimistic_1 = mutation.optimisticResponse;
            }
            this.cache.recordOptimisticTransaction(function (c) {
                var orig = _this.cache;
                _this.cache = c;
                try {
                    _this.markMutationResult({
                        mutationId: mutation.mutationId,
                        result: { data: optimistic_1 },
                        document: mutation.document,
                        variables: mutation.variables,
                        updateQueries: mutation.updateQueries,
                        update: mutation.update,
                    });
                }
                finally {
                    _this.cache = orig;
                }
            }, mutation.mutationId);
        }
    };
    DataStore.prototype.markMutationResult = function (mutation) {
        var _this = this;
        if (!Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["q" /* graphQLResultHasError */])(mutation.result)) {
            var cacheWrites_1 = [{
                    result: mutation.result.data,
                    dataId: 'ROOT_MUTATION',
                    query: mutation.document,
                    variables: mutation.variables,
                }];
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) {
                Object.keys(updateQueries_1).forEach(function (id) {
                    var _a = updateQueries_1[id], query = _a.query, updater = _a.updater;
                    var _b = _this.cache.diff({
                        query: query.document,
                        variables: query.variables,
                        returnPartialData: true,
                        optimistic: false,
                    }), currentQueryResult = _b.result, complete = _b.complete;
                    if (complete) {
                        var nextQueryResult = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["J" /* tryFunctionOrLogError */])(function () {
                            return updater(currentQueryResult, {
                                mutationResult: mutation.result,
                                queryName: Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["n" /* getOperationName */])(query.document) || undefined,
                                queryVariables: query.variables,
                            });
                        });
                        if (nextQueryResult) {
                            cacheWrites_1.push({
                                result: nextQueryResult,
                                dataId: 'ROOT_QUERY',
                                query: query.document,
                                variables: query.variables,
                            });
                        }
                    }
                });
            }
            this.cache.performTransaction(function (c) {
                cacheWrites_1.forEach(function (write) { return c.write(write); });
                var update = mutation.update;
                if (update) {
                    Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["J" /* tryFunctionOrLogError */])(function () { return update(c, mutation.result); });
                }
            });
        }
    };
    DataStore.prototype.markMutationComplete = function (_a) {
        var mutationId = _a.mutationId, optimisticResponse = _a.optimisticResponse;
        if (optimisticResponse) {
            this.cache.removeOptimistic(mutationId);
        }
    };
    DataStore.prototype.markUpdateQueryResult = function (document, variables, newResult) {
        this.cache.write({
            result: newResult,
            dataId: 'ROOT_QUERY',
            variables: variables,
            query: document,
        });
    };
    DataStore.prototype.reset = function () {
        return this.cache.reset();
    };
    return DataStore;
}());

var version = "2.6.10";

var hasSuggestedDevtools = false;
var ApolloClient = (function () {
    function ApolloClient(options) {
        var _this = this;
        this.defaultOptions = {};
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        var cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, connectToDevTools = options.connectToDevTools, _c = options.queryDeduplication, queryDeduplication = _c === void 0 ? true : _c, defaultOptions = options.defaultOptions, _d = options.assumeImmutableResults, assumeImmutableResults = _d === void 0 ? false : _d, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link && resolvers) {
            link = __WEBPACK_IMPORTED_MODULE_2_apollo_link__["a" /* ApolloLink */].empty();
        }
        if (!link || !cache) {
            throw  true ? new __WEBPACK_IMPORTED_MODULE_4_ts_invariant__["a" /* InvariantError */](4) : new InvariantError("In order to initialize Apollo Client, you must specify 'link' and 'cache' properties in the options object.\n" +
                "These options are part of the upgrade requirements when migrating from Apollo Client 1.x to Apollo Client 2.x.\n" +
                "For more information, please visit: https://www.apollographql.com/docs/tutorial/client.html#apollo-client-setup");
        }
        this.link = link;
        this.cache = cache;
        this.store = new DataStore(cache);
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || {};
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) {
            setTimeout(function () { return (_this.disableNetworkFetches = false); }, ssrForceFetchDelay);
        }
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        var defaultConnectToDevTools = "production" !== 'production' &&
            typeof window !== 'undefined' &&
            !window.__APOLLO_CLIENT__;
        if (typeof connectToDevTools === 'undefined'
            ? defaultConnectToDevTools
            : connectToDevTools && typeof window !== 'undefined') {
            window.__APOLLO_CLIENT__ = this;
        }
        if (!hasSuggestedDevtools && "production" !== 'production') {
            hasSuggestedDevtools = true;
            if (typeof window !== 'undefined' &&
                window.document &&
                window.top === window.self) {
                if (typeof window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
                    if (window.navigator &&
                        window.navigator.userAgent &&
                        window.navigator.userAgent.indexOf('Chrome') > -1) {
                        console.debug('Download the Apollo DevTools ' +
                            'for a better development experience: ' +
                            'https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm');
                    }
                }
            }
        }
        this.version = version;
        this.localState = new LocalState({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher,
        });
        this.queryManager = new QueryManager({
            link: this.link,
            store: this.store,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion,
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: function () {
                if (_this.devToolsHookCb) {
                    _this.devToolsHookCb({
                        action: {},
                        state: {
                            queries: _this.queryManager.queryStore.getStore(),
                            mutations: _this.queryManager.mutationStore.getStore(),
                        },
                        dataWithOptimisticResults: _this.cache.extract(true),
                    });
                }
            },
        });
    }
    ApolloClient.prototype.stop = function () {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function (options) {
        if (this.defaultOptions.watchQuery) {
            options = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this.defaultOptions.watchQuery), options);
        }
        if (this.disableNetworkFetches &&
            (options.fetchPolicy === 'network-only' ||
                options.fetchPolicy === 'cache-and-network')) {
            options = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, options), { fetchPolicy: 'cache-first' });
        }
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function (options) {
        if (this.defaultOptions.query) {
            options = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this.defaultOptions.query), options);
        }
         true ? Object(__WEBPACK_IMPORTED_MODULE_4_ts_invariant__["b" /* invariant */])(options.fetchPolicy !== 'cache-and-network', 5) : invariant(options.fetchPolicy !== 'cache-and-network', 'The cache-and-network fetchPolicy does not work with client.query, because ' +
            'client.query can only return a single result. Please use client.watchQuery ' +
            'to receive multiple results from the cache and the network, or consider ' +
            'using a different fetchPolicy, such as cache-first or network-only.');
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') {
            options = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, options), { fetchPolicy: 'cache-first' });
        }
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function (options) {
        if (this.defaultOptions.mutate) {
            options = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this.defaultOptions.mutate), options);
        }
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function (options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function (options) {
        var result = this.cache.writeQuery(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeFragment = function (options) {
        var result = this.cache.writeFragment(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeData = function (options) {
        var result = this.cache.writeData(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.__actionHookForDevTools = function (cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function (payload) {
        return Object(__WEBPACK_IMPORTED_MODULE_2_apollo_link__["c" /* execute */])(this.link, payload);
    };
    ApolloClient.prototype.initQueryManager = function () {
        "production" === "production" || __WEBPACK_IMPORTED_MODULE_4_ts_invariant__["b" /* invariant */].warn('Calling the initQueryManager method is no longer necessary, ' +
            'and it will be removed from ApolloClient in version 3.0.');
        return this.queryManager;
    };
    ApolloClient.prototype.resetStore = function () {
        var _this = this;
        return Promise.resolve()
            .then(function () { return _this.queryManager.clearStore(); })
            .then(function () { return Promise.all(_this.resetStoreCallbacks.map(function (fn) { return fn(); })); })
            .then(function () { return _this.reFetchObservableQueries(); });
    };
    ApolloClient.prototype.clearStore = function () {
        var _this = this;
        return Promise.resolve()
            .then(function () { return _this.queryManager.clearStore(); })
            .then(function () { return Promise.all(_this.clearStoreCallbacks.map(function (fn) { return fn(); })); });
    };
    ApolloClient.prototype.onResetStore = function (cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function () {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function (c) { return c !== cb; });
        };
    };
    ApolloClient.prototype.onClearStore = function (cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function () {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function (c) { return c !== cb; });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function (includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.extract = function (optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function (serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function (resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function (resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function () {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function (fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    return ApolloClient;
}());

/* harmony default export */ __webpack_exports__["default"] = (ApolloClient);

//# sourceMappingURL=bundle.esm.js.map


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(427),
    baseLodash = __webpack_require__(284);

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;


/***/ }),
/* 283 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 284 */
/***/ (function(module, exports) {

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(286);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(719);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 287 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 288 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(427),
    baseLodash = __webpack_require__(284);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _deepmerge = _interopRequireDefault(__webpack_require__(215));

var _isPlainObject = _interopRequireDefault(__webpack_require__(752));

var _warning = _interopRequireDefault(__webpack_require__(37));

var _createBreakpoints = _interopRequireDefault(__webpack_require__(173));

var _createMixins = _interopRequireDefault(__webpack_require__(754));

var _createPalette = _interopRequireDefault(__webpack_require__(755));

var _createTypography = _interopRequireDefault(__webpack_require__(756));

var _shadows = _interopRequireDefault(__webpack_require__(757));

var _shape = _interopRequireDefault(__webpack_require__(758));

var _spacing = _interopRequireDefault(__webpack_require__(759));

var _transitions = _interopRequireDefault(__webpack_require__(99));

var _zIndex = _interopRequireDefault(__webpack_require__(439));

// < 1kb payload overhead when lodash/merge is > 3kb.
function createMuiTheme() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$breakpoints = options.breakpoints,
      breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints,
      _options$mixins = options.mixins,
      mixinsInput = _options$mixins === void 0 ? {} : _options$mixins,
      _options$palette = options.palette,
      paletteInput = _options$palette === void 0 ? {} : _options$palette,
      shadowsInput = options.shadows,
      _options$typography = options.typography,
      typographyInput = _options$typography === void 0 ? {} : _options$typography,
      other = (0, _objectWithoutProperties2.default)(options, ["breakpoints", "mixins", "palette", "shadows", "typography"]);
  var palette = (0, _createPalette.default)(paletteInput);
  var breakpoints = (0, _createBreakpoints.default)(breakpointsInput);
  var muiTheme = (0, _extends2.default)({
    breakpoints: breakpoints,
    direction: 'ltr',
    mixins: (0, _createMixins.default)(breakpoints, _spacing.default, mixinsInput),
    overrides: {},
    // Inject custom styles
    palette: palette,
    props: {},
    // Inject custom properties
    shadows: shadowsInput || _shadows.default,
    typography: (0, _createTypography.default)(palette, typographyInput)
  }, (0, _deepmerge.default)({
    shape: _shape.default,
    spacing: _spacing.default,
    transitions: _transitions.default,
    zIndex: _zIndex.default
  }, other, {
    isMergeableObject: _isPlainObject.default
  }));
   false ? (0, _warning.default)(muiTheme.shadows.length === 25, 'Material-UI: the shadows array provided to createMuiTheme should support 25 elevations.') : void 0;
  return muiTheme;
}

var _default = createMuiTheme;
exports.default = _default;

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = toCss;

var _toCssValue = __webpack_require__(216);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */
function indentStr(str, indent) {
  var result = '';
  for (var index = 0; index < indent; index++) {
    result += '  ';
  }return result + str;
}

/**
 * Converts a Rule to CSS string.
 */

function toCss(selector, style) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var result = '';

  if (!style) return result;

  var _options$indent = options.indent,
      indent = _options$indent === undefined ? 0 : _options$indent;
  var fallbacks = style.fallbacks;


  indent++;

  // Apply fallbacks first.
  if (fallbacks) {
    // Array syntax {fallbacks: [{prop: value}]}
    if (Array.isArray(fallbacks)) {
      for (var index = 0; index < fallbacks.length; index++) {
        var fallback = fallbacks[index];
        for (var prop in fallback) {
          var value = fallback[prop];
          if (value != null) {
            result += '\n' + indentStr(prop + ': ' + (0, _toCssValue2['default'])(value) + ';', indent);
          }
        }
      }
    } else {
      // Object syntax {fallbacks: {prop: value}}
      for (var _prop in fallbacks) {
        var _value = fallbacks[_prop];
        if (_value != null) {
          result += '\n' + indentStr(_prop + ': ' + (0, _toCssValue2['default'])(_value) + ';', indent);
        }
      }
    }
  }

  for (var _prop2 in style) {
    var _value2 = style[_prop2];
    if (_value2 != null && _prop2 !== 'fallbacks') {
      result += '\n' + indentStr(_prop2 + ': ' + (0, _toCssValue2['default'])(_value2) + ';', indent);
    }
  }

  // Allow empty style in this case, because properties will be added dynamically.
  if (!result && !options.allowEmpty) return result;

  indent--;
  result = indentStr(selector + ' {' + result + '\n', indent) + indentStr('}', indent);

  return result;
}

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SheetsRegistry = __webpack_require__(442);

var _SheetsRegistry2 = _interopRequireDefault(_SheetsRegistry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */
exports['default'] = new _SheetsRegistry2['default']();

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isInBrowser = __webpack_require__(218);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var js = ''; /**
              * Export javascript style and css style vendor prefixes.
              * Based on "transform" support test.
              */

var css = '';

// We should not do anything if required serverside.
if (_isInBrowser2['default']) {
  // Order matters. We need to check Webkit the last one because
  // other vendors use to add Webkit prefixes to some properties
  var jsCssMap = {
    Moz: '-moz-',
    // IE did it wrong again ...
    ms: '-ms-',
    O: '-o-',
    Webkit: '-webkit-'
  };
  var style = document.createElement('p').style;
  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      js = key;
      css = jsCssMap[key];
      break;
    }
  }
}

/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String}}
 * @api public
 */
exports['default'] = { js: js, css: css };

/***/ }),
/* 294 */
/***/ (function(module, exports) {

function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CHANNEL = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

// Same value used by react-jss
var CHANNEL = '__THEMING__';
exports.CHANNEL = CHANNEL;
var themeListener = {
  contextTypes: (0, _defineProperty2.default)({}, CHANNEL, _propTypes.default.object),
  initial: function initial(context) {
    if (!context[CHANNEL]) {
      return null;
    }

    return context[CHANNEL].getState();
  },
  subscribe: function subscribe(context, cb) {
    if (!context[CHANNEL]) {
      return null;
    }

    return context[CHANNEL].subscribe(cb);
  },
  unsubscribe: function unsubscribe(context, subscriptionId) {
    if (context[CHANNEL]) {
      context[CHANNEL].unsubscribe(subscriptionId);
    }
  }
};
var _default = themeListener;
exports.default = _default;

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var getDisplayName = function getDisplayName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (!Component) {
    return undefined;
  }

  return Component.displayName || Component.name || 'Component';
};

var _default = getDisplayName;
exports.default = _default;

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(219);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(220);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(806)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(465);

var _ChildMapping = __webpack_require__(834);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
  /**
   * The `<TransitionGroup>` component manages a set of transition components
   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
   * components, `<TransitionGroup>` is a state machine for managing the mounting
   * and unmounting of components over time.
   *
   * Consider the example below. As items are removed or added to the TodoList the
   * `in` prop is toggled automatically by the `<TransitionGroup>`.
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual transition
   * component. This means you can mix and match animations across different list
   * items.
   */

};

var TransitionGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear


    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: {
        isMounting: !this.appeared
      }
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
    this.mounted = true;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }

    return _react.default.createElement(Component, props, children);
  };

  return TransitionGroup;
}(_react.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes.default.object.isRequired
};
TransitionGroup.propTypes =  false ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes.default.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: _propTypes.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes.default.func
} : {};
TransitionGroup.defaultProps = defaultProps;

var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasValue = hasValue;
exports.isFilled = isFilled;
exports.isAdornedStart = isAdornedStart;
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _Textarea = _interopRequireDefault(__webpack_require__(839));

// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function hasValue(value) {
  return value != null && !(Array.isArray(value) && value.length === 0);
} // Determine if field is empty or filled.
// Response determines if label is presented above field or as placeholder.
//
// @param obj
// @param SSR
// @returns {boolean} False when not present or empty string.
//                    True when any number or string with length.


function isFilled(obj) {
  var SSR = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return obj && (hasValue(obj.value) && obj.value !== '' || SSR && hasValue(obj.defaultValue) && obj.defaultValue !== '');
} // Determine if an Input is adorned on start.
// It's corresponding to the left with LTR.
//
// @param obj
// @returns {boolean} False when no adornments.
//                    True when adorned at the start.


function isAdornedStart(obj) {
  return obj.startAdornment;
}

var styles = function styles(theme) {
  var light = theme.palette.type === 'light';
  var placeholder = {
    color: 'currentColor',
    opacity: light ? 0.42 : 0.5,
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shorter
    })
  };
  var placeholderHidden = {
    opacity: 0
  };
  var placeholderVisible = {
    opacity: light ? 0.42 : 0.5
  };
  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
  return {
    /* Styles applied to the root element. */
    root: {
      // Mimics the default input display property used by browsers for an input.
      display: 'inline-flex',
      position: 'relative',
      fontFamily: theme.typography.fontFamily,
      color: theme.palette.text.primary,
      fontSize: theme.typography.pxToRem(16),
      lineHeight: '1.1875em',
      // Reset (19px), match the native input line-height
      '&$disabled': {
        color: theme.palette.text.disabled
      }
    },

    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {
      'label + &': {
        marginTop: 16
      }
    },

    /* Styles applied to the root element if the component is focused. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `disableUnderline={false}`. */
    underline: {
      '&:after': {
        borderBottom: "2px solid ".concat(theme.palette.primary[light ? 'dark' : 'light']),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        position: 'absolute',
        right: 0,
        transform: 'scaleX(0)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.easeOut
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&$focused:after': {
        transform: 'scaleX(1)'
      },
      '&$error:after': {
        borderBottomColor: theme.palette.error.main,
        transform: 'scaleX(1)' // error is always underlined in red

      },
      '&:before': {
        borderBottom: "1px solid ".concat(bottomLineColor),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
        content: '"\\00a0"',
        position: 'absolute',
        right: 0,
        transition: theme.transitions.create('border-bottom-color', {
          duration: theme.transitions.duration.shorter
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&:hover:not($disabled):not($focused):not($error):before': {
        borderBottom: "2px solid ".concat(theme.palette.text.primary)
      },
      '&$disabled:before': {
        borderBottom: "1px dotted ".concat(bottomLineColor)
      }
    },

    /* Styles applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {
      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px")
    },

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: '100%'
    },

    /* Styles applied to the `input` element. */
    input: {
      font: 'inherit',
      color: 'currentColor',
      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px"),
      border: 0,
      boxSizing: 'content-box',
      verticalAlign: 'middle',
      background: 'none',
      margin: 0,
      // Reset for Safari
      // Remove grey highlight
      WebkitTapHighlightColor: 'transparent',
      display: 'block',
      // Make the flex item shrink with Firefox
      minWidth: 0,
      flexGrow: 1,
      '&::-webkit-input-placeholder': placeholder,
      '&::-moz-placeholder': placeholder,
      // Firefox 19+
      '&:-ms-input-placeholder': placeholder,
      // IE 11
      '&::-ms-input-placeholder': placeholder,
      // Edge
      '&:focus': {
        outline: 0
      },
      // Reset Firefox invalid required input style
      '&:invalid': {
        boxShadow: 'none'
      },
      '&::-webkit-search-decoration': {
        // Remove the padding when type=search.
        '-webkit-appearance': 'none'
      },
      // Show and hide the placeholder logic
      'label[data-shrink=false] + $formControl &': {
        '&::-webkit-input-placeholder': placeholderHidden,
        '&::-moz-placeholder': placeholderHidden,
        // Firefox 19+
        '&:-ms-input-placeholder': placeholderHidden,
        // IE 11
        '&::-ms-input-placeholder': placeholderHidden,
        // Edge
        '&:focus::-webkit-input-placeholder': placeholderVisible,
        '&:focus::-moz-placeholder': placeholderVisible,
        // Firefox 19+
        '&:focus:-ms-input-placeholder': placeholderVisible,
        // IE 11
        '&:focus::-ms-input-placeholder': placeholderVisible // Edge

      },
      '&$disabled': {
        opacity: 1 // Reset iOS opacity

      }
    },

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {
      paddingTop: 4 - 1
    },

    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {
      resize: 'none',
      padding: 0
    },

    /* Styles applied to the `input` element if `type` is not "text"`. */
    inputType: {
      // type="date" or type="time", etc. have specific styles we need to reset.
      height: '1.1875em' // Reset (19px), match the native input line-height

    },

    /* Styles applied to the `input` element if `type="search"`. */
    inputTypeSearch: {
      // Improve type search style.
      '-moz-appearance': 'textfield',
      '-webkit-appearance': 'textfield'
    }
  };
};

exports.styles = styles;

function formControlState(props, context) {
  var disabled = props.disabled;
  var error = props.error;
  var margin = props.margin;
  var required = props.required;

  if (context && context.muiFormControl) {
    if (typeof disabled === 'undefined') {
      disabled = context.muiFormControl.disabled;
    }

    if (typeof error === 'undefined') {
      error = context.muiFormControl.error;
    }

    if (typeof margin === 'undefined') {
      margin = context.muiFormControl.margin;
    }

    if (typeof required === 'undefined') {
      required = context.muiFormControl.required;
    }
  }

  return {
    disabled: disabled,
    error: error,
    margin: margin,
    required: required
  };
}

var Input =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Input, _React$Component);

  // Holds the input reference
  function Input(props, context) {
    var _this;

    (0, _classCallCheck2.default)(this, Input);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Input).call(this, props, context));
    _this.isControlled = null;
    _this.input = null;
    _this.state = {
      focused: false
    };

    _this.handleFocus = function (event) {
      // Fix a bug with IE11 where the focus/blur events are triggered
      // while the input is disabled.
      if (formControlState(_this.props, _this.context).disabled) {
        event.stopPropagation();
        return;
      }

      _this.setState({
        focused: true
      });

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }

      var muiFormControl = _this.context.muiFormControl;

      if (muiFormControl && muiFormControl.onFocus) {
        muiFormControl.onFocus(event);
      }
    };

    _this.handleBlur = function (event) {
      _this.setState({
        focused: false
      });

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }

      var muiFormControl = _this.context.muiFormControl;

      if (muiFormControl && muiFormControl.onBlur) {
        muiFormControl.onBlur(event);
      }
    };

    _this.handleChange = function (event) {
      if (!_this.isControlled) {
        _this.checkDirty(_this.inputRef);
      } // Perform in the willUpdate


      if (_this.props.onChange) {
        _this.props.onChange(event);
      }
    };

    _this.handleRefInput = function (ref) {
      _this.inputRef = ref;
      var refProp;

      if (_this.props.inputRef) {
        refProp = _this.props.inputRef;
      } else if (_this.props.inputProps && _this.props.inputProps.ref) {
        refProp = _this.props.inputProps.ref;
      }

      if (refProp) {
        if (typeof refProp === 'function') {
          refProp(ref);
        } else {
          refProp.current = ref;
        }
      }
    };

    _this.isControlled = props.value != null;

    if (_this.isControlled) {
      _this.checkDirty(props);
    }

    var componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
      // The blur won't fire when the disabled state is set on a focused input.
      // We need to book keep the focused state manually.
      if (!formControlState(_this.props, _this.context).disabled && formControlState(nextProps, nextContext).disabled) {
        _this.setState({
          focused: false
        });
      }
    };

    var componentWillUpdate = function componentWillUpdate(nextProps, nextState, nextContext) {
      // Book keep the focused state.
      if (!formControlState(_this.props, _this.context).disabled && formControlState(nextProps, nextContext).disabled) {
        var muiFormControl = _this.context.muiFormControl;

        if (muiFormControl && muiFormControl.onBlur) {
          muiFormControl.onBlur();
        }
      }
    }; // Support for react >= 16.3.0 && < 17.0.0

    /* istanbul ignore else */


    if (_react.default.createContext) {
      _this.UNSAFE_componentWillReceiveProps = componentWillReceiveProps;
      _this.UNSAFE_componentWillUpdate = componentWillUpdate;
    } else {
      _this.componentWillReceiveProps = componentWillReceiveProps;
      _this.componentWillUpdate = componentWillUpdate;
    }

    return _this;
  }

  (0, _createClass2.default)(Input, [{
    key: "getChildContext",
    value: function getChildContext() {
      // We are consuming the parent muiFormControl context.
      // We don't want a child to consume it a second time.
      return {
        muiFormControl: null
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.isControlled) {
        this.checkDirty(this.inputRef);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.isControlled) {
        this.checkDirty(this.props);
      } // else performed in the onChange

    }
  }, {
    key: "checkDirty",
    value: function checkDirty(obj) {
      var muiFormControl = this.context.muiFormControl;

      if (isFilled(obj)) {
        if (muiFormControl && muiFormControl.onFilled) {
          muiFormControl.onFilled();
        }

        if (this.props.onFilled) {
          this.props.onFilled();
        }

        return;
      }

      if (muiFormControl && muiFormControl.onEmpty) {
        muiFormControl.onEmpty();
      }

      if (this.props.onEmpty) {
        this.props.onEmpty();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames, _classNames2;

      var _this$props = this.props,
          autoComplete = _this$props.autoComplete,
          autoFocus = _this$props.autoFocus,
          classes = _this$props.classes,
          classNameProp = _this$props.className,
          defaultValue = _this$props.defaultValue,
          disabledProp = _this$props.disabled,
          disableUnderline = _this$props.disableUnderline,
          endAdornment = _this$props.endAdornment,
          errorProp = _this$props.error,
          fullWidth = _this$props.fullWidth,
          id = _this$props.id,
          inputComponent = _this$props.inputComponent,
          _this$props$inputProp = _this$props.inputProps;
      _this$props$inputProp = _this$props$inputProp === void 0 ? {} : _this$props$inputProp;
      var inputPropsClassName = _this$props$inputProp.className,
          inputPropsProp = (0, _objectWithoutProperties2.default)(_this$props$inputProp, ["className"]),
          inputRef = _this$props.inputRef,
          marginProp = _this$props.margin,
          multiline = _this$props.multiline,
          name = _this$props.name,
          onBlur = _this$props.onBlur,
          onChange = _this$props.onChange,
          onEmpty = _this$props.onEmpty,
          onFilled = _this$props.onFilled,
          onFocus = _this$props.onFocus,
          onKeyDown = _this$props.onKeyDown,
          onKeyUp = _this$props.onKeyUp,
          placeholder = _this$props.placeholder,
          readOnly = _this$props.readOnly,
          rows = _this$props.rows,
          rowsMax = _this$props.rowsMax,
          startAdornment = _this$props.startAdornment,
          type = _this$props.type,
          value = _this$props.value,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["autoComplete", "autoFocus", "classes", "className", "defaultValue", "disabled", "disableUnderline", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "multiline", "name", "onBlur", "onChange", "onEmpty", "onFilled", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "rows", "rowsMax", "startAdornment", "type", "value"]);
      var muiFormControl = this.context.muiFormControl;

      var _formControlState = formControlState(this.props, this.context),
          disabled = _formControlState.disabled,
          error = _formControlState.error,
          margin = _formControlState.margin,
          required = _formControlState.required;

      var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.error, error), (0, _defineProperty2.default)(_classNames, classes.fullWidth, fullWidth), (0, _defineProperty2.default)(_classNames, classes.focused, this.state.focused), (0, _defineProperty2.default)(_classNames, classes.formControl, muiFormControl), (0, _defineProperty2.default)(_classNames, classes.multiline, multiline), (0, _defineProperty2.default)(_classNames, classes.underline, !disableUnderline), _classNames), classNameProp);
      var inputClassName = (0, _classnames.default)(classes.input, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames2, classes.inputType, type !== 'text'), (0, _defineProperty2.default)(_classNames2, classes.inputTypeSearch, type === 'search'), (0, _defineProperty2.default)(_classNames2, classes.inputMultiline, multiline), (0, _defineProperty2.default)(_classNames2, classes.inputMarginDense, margin === 'dense'), _classNames2), inputPropsClassName);
      var InputComponent = 'input';
      var inputProps = (0, _extends2.default)({}, inputPropsProp, {
        ref: this.handleRefInput
      });

      if (inputComponent) {
        InputComponent = inputComponent;
        inputProps = (0, _extends2.default)({
          // Rename ref to inputRef as we don't know the
          // provided `inputComponent` structure.
          inputRef: this.handleRefInput
        }, inputProps, {
          ref: null
        });
      } else if (multiline) {
        if (rows && !rowsMax) {
          InputComponent = 'textarea';
        } else {
          inputProps = (0, _extends2.default)({
            rowsMax: rowsMax,
            textareaRef: this.handleRefInput
          }, inputProps, {
            ref: null
          });
          InputComponent = _Textarea.default;
        }
      }

      return _react.default.createElement("div", (0, _extends2.default)({
        className: className
      }, other), startAdornment, _react.default.createElement(InputComponent, (0, _extends2.default)({
        "aria-invalid": error,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        className: inputClassName,
        defaultValue: defaultValue,
        disabled: disabled,
        id: id,
        name: name,
        onBlur: this.handleBlur,
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        placeholder: placeholder,
        readOnly: readOnly,
        required: required,
        rows: rows,
        type: type,
        value: value
      }, inputProps)), endAdornment);
    }
  }]);
  return Input;
}(_react.default.Component);

Input.propTypes =  false ? {
  /**
   * This property helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it here:
   * https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill
   */
  autoComplete: _propTypes.default.string,

  /**
   * If `true`, the input will be focused during the first mount.
   */
  autoFocus: _propTypes.default.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The CSS class name of the wrapper element.
   */
  className: _propTypes.default.string,

  /**
   * The default input value, useful when not controlling the component.
   */
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * If `true`, the input will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the input will not have an underline.
   */
  disableUnderline: _propTypes.default.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: _propTypes.default.node,

  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: _propTypes.default.bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * The id of the `input` element.
   */
  id: _propTypes.default.string,

  /**
   * The component used for the native input.
   * Either a string to use a DOM element or a component.
   */
  inputComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Attributes applied to the `input` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: _propTypes.default.oneOf(['dense', 'none']),

  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: _propTypes.default.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: _propTypes.default.string,

  /**
   * @ignore
   */
  onBlur: _propTypes.default.func,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   */
  onChange: _propTypes.default.func,

  /**
   * @ignore
   */
  onEmpty: _propTypes.default.func,

  /**
   * @ignore
   */
  onFilled: _propTypes.default.func,

  /**
   * @ignore
   */
  onFocus: _propTypes.default.func,

  /**
   * @ignore
   */
  onKeyDown: _propTypes.default.func,

  /**
   * @ignore
   */
  onKeyUp: _propTypes.default.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: _propTypes.default.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: _propTypes.default.bool,

  /**
   * If `true`, the input will be required.
   */
  required: _propTypes.default.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: _propTypes.default.node,

  /**
   * Type of the input element. It should be a valid HTML5 input type.
   */
  type: _propTypes.default.string,

  /**
   * The input value, required for a controlled component.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]))])
} : {};
Input.muiName = 'Input';
Input.defaultProps = {
  disableUnderline: false,
  fullWidth: false,
  multiline: false,
  type: 'text'
};
Input.contextTypes = {
  muiFormControl: _propTypes.default.object
};
Input.childContextTypes = {
  muiFormControl: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiInput'
})(Input);

exports.default = _default;

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _RootRef.default;
  }
});

var _RootRef = _interopRequireDefault(__webpack_require__(860));

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Portal.default;
  }
});

var _Portal = _interopRequireDefault(__webpack_require__(861));

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Fade.default;
  }
});

var _Fade = _interopRequireDefault(__webpack_require__(874));

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function unsupportedProp(props, propName, componentName, location, propFullName) {
  /* istanbul ignore if */
  if (true) {
    return null;
  }

  var propFullNameSafe = propFullName || propName;

  if (typeof props[propName] !== 'undefined') {
    return new Error("The property `".concat(propFullNameSafe, "` is not supported. Please remove it."));
  }

  return null;
}

var _default = unsupportedProp;
exports.default = _default;

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _IconButton = _interopRequireDefault(__webpack_require__(71));

// @inheritedComponent IconButton
var styles = {
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    transition: 'none',
    '&:hover': {
      // Disable the hover effect for the IconButton.
      backgroundColor: 'transparent'
    }
  },
  checked: {},
  disabled: {},
  input: {
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0
  }
};
/**
 * @ignore - internal component.
 */

exports.styles = styles;

var SwitchBase =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(SwitchBase, _React$Component);

  function SwitchBase(props) {
    var _this;

    (0, _classCallCheck2.default)(this, SwitchBase);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SwitchBase).call(this));
    _this.input = null;
    _this.isControlled = null;
    _this.state = {};

    _this.handleFocus = function (event) {
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }

      var muiFormControl = _this.context.muiFormControl;

      if (muiFormControl && muiFormControl.onFocus) {
        muiFormControl.onFocus(event);
      }
    };

    _this.handleBlur = function (event) {
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }

      var muiFormControl = _this.context.muiFormControl;

      if (muiFormControl && muiFormControl.onBlur) {
        muiFormControl.onBlur(event);
      }
    };

    _this.handleInputChange = function (event) {
      var checked = event.target.checked;

      if (!_this.isControlled) {
        _this.setState({
          checked: checked
        });
      }

      if (_this.props.onChange) {
        _this.props.onChange(event, checked);
      }
    };

    _this.isControlled = props.checked != null;

    if (!_this.isControlled) {
      // not controlled, use internal state
      _this.state.checked = props.defaultChecked !== undefined ? props.defaultChecked : false;
    }

    return _this;
  }

  (0, _createClass2.default)(SwitchBase, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          autoFocus = _this$props.autoFocus,
          checkedProp = _this$props.checked,
          checkedIcon = _this$props.checkedIcon,
          classes = _this$props.classes,
          classNameProp = _this$props.className,
          disabledProp = _this$props.disabled,
          icon = _this$props.icon,
          id = _this$props.id,
          inputProps = _this$props.inputProps,
          inputRef = _this$props.inputRef,
          name = _this$props.name,
          onBlur = _this$props.onBlur,
          onChange = _this$props.onChange,
          onFocus = _this$props.onFocus,
          readOnly = _this$props.readOnly,
          required = _this$props.required,
          tabIndex = _this$props.tabIndex,
          type = _this$props.type,
          value = _this$props.value,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["autoFocus", "checked", "checkedIcon", "classes", "className", "disabled", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"]);
      var muiFormControl = this.context.muiFormControl;
      var disabled = disabledProp;

      if (muiFormControl) {
        if (typeof disabled === 'undefined') {
          disabled = muiFormControl.disabled;
        }
      }

      var checked = this.isControlled ? checkedProp : this.state.checked;
      var hasLabelFor = type === 'checkbox' || type === 'radio';
      return _react.default.createElement(_IconButton.default, (0, _extends2.default)({
        component: "span",
        className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.checked, checked), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), _classNames), classNameProp),
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur
      }, other), checked ? checkedIcon : icon, _react.default.createElement("input", (0, _extends2.default)({
        autoFocus: autoFocus,
        checked: checked,
        className: classes.input,
        disabled: disabled,
        id: hasLabelFor && id,
        name: name,
        onChange: this.handleInputChange,
        readOnly: readOnly,
        ref: inputRef,
        required: required,
        tabIndex: tabIndex,
        type: type,
        value: value
      }, inputProps)));
    }
  }]);
  return SwitchBase;
}(_react.default.Component); // NB: If changed, please update Checkbox, Switch and Radio
// so that the API documentation is updated.


SwitchBase.propTypes =  false ? {
  /**
   * If `true`, the input will be focused during the first mount.
   */
  autoFocus: _propTypes.default.bool,

  /**
   * If `true`, the component is checked.
   */
  checked: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   */
  defaultChecked: _propTypes.default.bool,

  /**
   * If `true`, the switch will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes.default.bool,

  /**
   * The icon to display when the component is unchecked.
   */
  icon: _propTypes.default.node.isRequired,

  /**
   * The id of the `input` element.
   */
  id: _propTypes.default.string,

  /**
   * If `true`, the component appears indeterminate.
   */
  indeterminate: _propTypes.default.bool,

  /**
   * The icon to display when the component is indeterminate.
   */
  indeterminateIcon: _propTypes.default.node,

  /**
   * Attributes applied to the `input` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /*
   * @ignore
   */
  name: _propTypes.default.string,

  /**
   * @ignore
   */
  onBlur: _propTypes.default.func,

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.checked`.
   * @param {boolean} checked The `checked` value of the switch
   */
  onChange: _propTypes.default.func,

  /**
   * @ignore
   */
  onFocus: _propTypes.default.func,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: _propTypes.default.bool,

  /**
   * If `true`, the input will be required.
   */
  required: _propTypes.default.bool,

  /**
   * @ignore
   */
  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * The input component property `type`.
   */
  type: _propTypes.default.string.isRequired,

  /**
   * The value of the component.
   */
  value: _propTypes.default.string
} : {};
SwitchBase.contextTypes = {
  muiFormControl: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiSwitchBase'
})(SwitchBase);

exports.default = _default;

/***/ }),
/* 308 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 309 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(152);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 311 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(180);
var dPs = __webpack_require__(930);
var enumBugKeys = __webpack_require__(316);
var IE_PROTO = __webpack_require__(314)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(485)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(935).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(487);
var enumBugKeys = __webpack_require__(316);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(315)('keys');
var uid = __webpack_require__(235);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(149);
var global = __webpack_require__(109);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(231) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 316 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(151).f;
var has = __webpack_require__(122);
var TAG = __webpack_require__(155)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(155);


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(109);
var core = __webpack_require__(149);
var LIBRARY = __webpack_require__(231);
var wksExt = __webpack_require__(318);
var defineProperty = __webpack_require__(151).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 320 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TableHead.default;
  }
});

var _TableHead = _interopRequireDefault(__webpack_require__(964));

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TableSortLabel.default;
  }
});

var _TableSortLabel = _interopRequireDefault(__webpack_require__(965));

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TablePagination.default;
  }
});

var _TablePagination = _interopRequireDefault(__webpack_require__(971));

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Avatar.default;
  }
});

var _Avatar = _interopRequireDefault(__webpack_require__(495));

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isHorizontal = isHorizontal;
exports.getAnchor = getAnchor;
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _Modal = _interopRequireDefault(__webpack_require__(108));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _Slide = _interopRequireDefault(__webpack_require__(237));

var _Paper = _interopRequireDefault(__webpack_require__(49));

var _helpers = __webpack_require__(51);

var _transitions = __webpack_require__(99);

var oppositeDirection = {
  left: 'right',
  right: 'left',
  top: 'down',
  bottom: 'up'
};

function isHorizontal(props) {
  return ['left', 'right'].indexOf(props.anchor) !== -1;
}

function getAnchor(props) {
  return props.theme.direction === 'rtl' && isHorizontal(props) ? oppositeDirection[props.anchor] : props.anchor;
}

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element if `variant="permanent or persistent"`. */
    docked: {
      flex: '0 0 auto'
    },

    /* Styles applied to the `Paper` component. */
    paper: {
      overflowY: 'auto',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      flex: '1 0 auto',
      zIndex: theme.zIndex.drawer,
      WebkitOverflowScrolling: 'touch',
      // Add iOS momentum scrolling.
      // temporary style
      position: 'fixed',
      top: 0,
      // We disable the focus ring for mouse, touch and keyboard users.
      // At some point, it would be better to keep it for keyboard users.
      // :focus-ring CSS pseudo-class will help.
      outline: 'none'
    },

    /* Styles applied to the `Paper` component if `anchor="left"`. */
    paperAnchorLeft: {
      left: 0,
      right: 'auto'
    },

    /* Styles applied to the `Paper` component if `anchor="right"`. */
    paperAnchorRight: {
      left: 'auto',
      right: 0
    },

    /* Styles applied to the `Paper` component if `anchor="top"`. */
    paperAnchorTop: {
      top: 0,
      left: 0,
      bottom: 'auto',
      right: 0,
      height: 'auto',
      maxHeight: '100%'
    },

    /* Styles applied to the `Paper` component if `anchor="bottom"`. */
    paperAnchorBottom: {
      top: 'auto',
      left: 0,
      bottom: 0,
      right: 0,
      height: 'auto',
      maxHeight: '100%'
    },

    /* Styles applied to the `Paper` component if `anchor="left"` & `variant` is not "temporary". */
    paperAnchorDockedLeft: {
      borderRight: "1px solid ".concat(theme.palette.divider)
    },

    /* Styles applied to the `Paper` component if `anchor="top"` & `variant` is not "temporary". */
    paperAnchorDockedTop: {
      borderBottom: "1px solid ".concat(theme.palette.divider)
    },

    /* Styles applied to the `Paper` component if `anchor="right"` & `variant` is not "temporary". */
    paperAnchorDockedRight: {
      borderLeft: "1px solid ".concat(theme.palette.divider)
    },

    /* Styles applied to the `Paper` component if `anchor="bottom"` & `variant` is not "temporary". */
    paperAnchorDockedBottom: {
      borderTop: "1px solid ".concat(theme.palette.divider)
    },

    /* Styles applied to the `Modal` component. */
    modal: {}
  };
};
/**
 * The properties of the [Modal](/api/modal) component are available
 * when `variant="temporary"` is set.
 */


exports.styles = styles;

var Drawer =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Drawer, _React$Component);

  function Drawer() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Drawer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Drawer)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.mounted = false;
    return _this;
  }

  (0, _createClass2.default)(Drawer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          anchorProp = _this$props.anchor,
          children = _this$props.children,
          classes = _this$props.classes,
          className = _this$props.className,
          elevation = _this$props.elevation,
          _this$props$ModalProp = _this$props.ModalProps;
      _this$props$ModalProp = _this$props$ModalProp === void 0 ? {} : _this$props$ModalProp;
      var BackdropPropsProp = _this$props$ModalProp.BackdropProps,
          ModalProps = (0, _objectWithoutProperties2.default)(_this$props$ModalProp, ["BackdropProps"]),
          onClose = _this$props.onClose,
          open = _this$props.open,
          PaperProps = _this$props.PaperProps,
          SlideProps = _this$props.SlideProps,
          theme = _this$props.theme,
          transitionDuration = _this$props.transitionDuration,
          variant = _this$props.variant,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["anchor", "children", "classes", "className", "elevation", "ModalProps", "onClose", "open", "PaperProps", "SlideProps", "theme", "transitionDuration", "variant"]);
      var anchor = getAnchor(this.props);

      var drawer = _react.default.createElement(_Paper.default, (0, _extends2.default)({
        elevation: variant === 'temporary' ? elevation : 0,
        square: true,
        className: (0, _classnames.default)(classes.paper, classes["paperAnchor".concat((0, _helpers.capitalize)(anchor))], (0, _defineProperty2.default)({}, classes["paperAnchorDocked".concat((0, _helpers.capitalize)(anchor))], variant !== 'temporary'))
      }, PaperProps), children);

      if (variant === 'permanent') {
        return _react.default.createElement("div", (0, _extends2.default)({
          className: (0, _classnames.default)(classes.docked, className)
        }, other), drawer);
      }

      var slidingDrawer = _react.default.createElement(_Slide.default, (0, _extends2.default)({
        in: open,
        direction: oppositeDirection[anchor],
        timeout: transitionDuration,
        appear: this.mounted
      }, SlideProps), drawer);

      if (variant === 'persistent') {
        return _react.default.createElement("div", (0, _extends2.default)({
          className: (0, _classnames.default)(classes.docked, className)
        }, other), slidingDrawer);
      } // variant === temporary


      return _react.default.createElement(_Modal.default, (0, _extends2.default)({
        BackdropProps: (0, _extends2.default)({}, BackdropPropsProp, {
          transitionDuration: transitionDuration
        }),
        className: (0, _classnames.default)(classes.modal, className),
        open: open,
        onClose: onClose
      }, other, ModalProps), slidingDrawer);
    }
  }]);
  return Drawer;
}(_react.default.Component);

Drawer.propTypes =  false ? {
  /**
   * Side from which the drawer will appear.
   */
  anchor: _propTypes.default.oneOf(['left', 'top', 'right', 'bottom']),

  /**
   * The contents of the drawer.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The elevation of the drawer.
   */
  elevation: _propTypes.default.number,

  /**
   * Properties applied to the [`Modal`](/api/modal) element.
   */
  ModalProps: _propTypes.default.object,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes.default.func,

  /**
   * If `true`, the drawer is open.
   */
  open: _propTypes.default.bool,

  /**
   * Properties applied to the [`Paper`](/api/paper) element.
   */
  PaperProps: _propTypes.default.object,

  /**
   * Properties applied to the [`Slide`](/api/slide) element.
   */
  SlideProps: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })]),

  /**
   * The variant to use.
   */
  variant: _propTypes.default.oneOf(['permanent', 'persistent', 'temporary'])
} : {};
Drawer.defaultProps = {
  anchor: 'left',
  elevation: 16,
  open: false,
  transitionDuration: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  },
  variant: 'temporary' // Mobile first.

};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiDrawer',
  flip: false,
  withTheme: true
})(Drawer);

exports.default = _default;

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ListItemIcon.default;
  }
});

var _ListItemIcon = _interopRequireDefault(__webpack_require__(1030));

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
})), 'FilterList');

exports.default = _default;

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(77);
var normalizeHeaderName = __webpack_require__(1069);
var enhanceError = __webpack_require__(522);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(523);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(523);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(137)))

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SharedSnackbarProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SharedSnackbarConsumer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SharedSnackbar_component__ = __webpack_require__(1082);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SharedSnackbarContext=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext();var SharedSnackbarProvider=function(_Component){_inherits(SharedSnackbarProvider,_Component);function SharedSnackbarProvider(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SharedSnackbarProvider);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SharedSnackbarProvider.__proto__||Object.getPrototypeOf(SharedSnackbarProvider)).call.apply(_ref,[this].concat(args))),_this),_this.state={isOpen:false,message:'',duration:3000,verticalPosition:'bottom',horizontalPosition:'left',autoHide:true},_this.openSnackbar=function(message,options){var snackbarOptions={duration:3000,verticalPosition:'bottom',horizontalPosition:'left',autoHide:true};if(options){snackbarOptions=options;}_this.setState(Object.assign({message:message,isOpen:true},snackbarOptions));},_this.closeSnackbar=function(){_this.setState({isOpen:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SharedSnackbarProvider,[{key:'render',value:function render(){var children=this.props.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SharedSnackbarContext.Provider,{value:{openSnackbar:this.openSnackbar,closeSnackbar:this.closeSnackbar,snackbarIsOpen:this.state.isOpen,message:this.state.message,duration:this.state.duration,verticalPosition:this.state.verticalPosition,horizontalPosition:this.state.horizontalPosition,autoHide:this.state.autoHide}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__SharedSnackbar_component__["a" /* default */],null),children);}}]);return SharedSnackbarProvider;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var SharedSnackbarConsumer=SharedSnackbarContext.Consumer;

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MENU_DRAWER_WIDTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MINI_MENU_DRAWER_WIDTH; });
/* unused harmony export DISCRETE_COLOR_RANGE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EXTENDED_DISCRETE_COLOR_RANGE; });
/* unused harmony export CONTINUOUS_COLOR_RANGE */
var MENU_DRAWER_WIDTH=290;var MINI_MENU_DRAWER_WIDTH=72;var DISCRETE_COLOR_RANGE=['#12939A','#79C7E3','#1A3177','#FF9833','#EF5D28'];var EXTENDED_DISCRETE_COLOR_RANGE=['#19CDD7','#DDB27C','#88572C','#FF991F','#F15C17','#223F9A','#DA70BF','#125C77','#4DC19C','#776E57','#12939A','#17B8BE','#F6D18A','#B7885E','#FFCB99','#F89570','#829AE3','#E79FD5','#1E96BE','#89DAC1','#B3AD9E'];var CONTINUOUS_COLOR_RANGE=['#EF5D28','#FF9833'];

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
})), 'ExpandMore');

exports.default = _default;

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GET_PARTNER_CLIENT_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GET_FUEL_SENSOR_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GET_FUEL_SENSOR_ASSIGNMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_ALL_VEHICLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return GET_UPLOAD_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_VEHICLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_CALIBRATION_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GET_FILE_FORMAT; });
/* unused harmony export GET_ALL_ALGO */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_ELOCK_CONNECTION; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_tag__ = __webpack_require__(7);
var _templateObject=_taggedTemplateLiteral(['\n  query allClientDetails($partnerLoginId: Int) {\n    clientsDetails: allClientDetails(partnerLoginId: $partnerLoginId) {\n      clientName\n      loginId\n    }\n  }\n'],['\n  query allClientDetails($partnerLoginId: Int) {\n    clientsDetails: allClientDetails(partnerLoginId: $partnerLoginId) {\n      clientName\n      loginId\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query GetFuelSensorDetails {\n    getFuelSensorDetails {\n      fuelSensorId\n      fuelSensorName\n      fuelDeviceType\n    }\n  }\n'],['\n  query GetFuelSensorDetails {\n    getFuelSensorDetails {\n      fuelSensorId\n      fuelSensorName\n      fuelDeviceType\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query GetFuelSensorAssignments($fuelSensorId: String, $status: String) {\n    getFuelSensorAssignments(fuelSensorId: $fuelSensorId, status: $status) {\n      uuid\n      status\n      imeiNumber\n      uniqueId\n      fuelSensorId\n    }\n  }\n'],['\n  query GetFuelSensorAssignments($fuelSensorId: String, $status: String) {\n    getFuelSensorAssignments(fuelSensorId: $fuelSensorId, status: $status) {\n      uuid\n      status\n      imeiNumber\n      uniqueId\n      fuelSensorId\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query getAllVehicleDetails($clientLoginId: Int) {\n    getAllVehicleDetails(clientLoginId: $clientLoginId) {\n      entityId\n      vehicleNumber\n      deviceDetail {\n        uniqueDeviceId\n      }\n    }\n  }\n'],['\n  query getAllVehicleDetails($clientLoginId: Int) {\n    getAllVehicleDetails(clientLoginId: $clientLoginId) {\n      entityId\n      vehicleNumber\n      deviceDetail {\n        uniqueDeviceId\n      }\n    }\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n'],['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  mutation excelFileUpload(\n    $fileInfo: FileUploadInput!\n    $secondaryFileInfo: FileUploadInput!\n    $commonInput: CommonInput!\n    $tanks: JSON\n  ) {\n    excelFileUpload(\n      fileInfo: $fileInfo\n      secondaryFileInfo: $secondaryFileInfo\n      commonInput: $commonInput\n      tanks: $tanks\n    ) {\n      failedToUpload\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedUploadList\n    }\n  }\n'],['\n  mutation excelFileUpload(\n    $fileInfo: FileUploadInput!\n    $secondaryFileInfo: FileUploadInput!\n    $commonInput: CommonInput!\n    $tanks: JSON\n  ) {\n    excelFileUpload(\n      fileInfo: $fileInfo\n      secondaryFileInfo: $secondaryFileInfo\n      commonInput: $commonInput\n      tanks: $tanks\n    ) {\n      failedToUpload\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedUploadList\n    }\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  query getFuelCalibrationDetail($entityId: Int) {\n    getFuelCalibrationDetail(vehicleId: $entityId) {\n      # refuelThreshold\n      # drainThreshold\n      # medianFilter\n      fuelUserType\n      fuelSensorType\n      minTankCapacity\n      minValue\n      maxTankCapacity\n      totalFuelTank\n      maxValue\n      # pfPerMin\n      pilferageTolerance\n      # minimumPilferageDuration\n      calibration_filename\n      url\n      # overallThreshold\n      availableDataTypes\n      preferedDataType\n      # secondary tank\n      hasSecondaryTank\n      hasInSameTank\n      isDualSensor\n      useTaabiAlgo\n      # obdAlgo\n      # fuelSensorAlgo\n      secondaryTankMinCapacity\n      secondaryTankMaxCapacity\n      secondaryTankTotalFuel\n      secondaryTankMinValue\n      secondaryTankMaxValue\n      secondaryPolynomialEquation\n      secondary_tank_calibration_filename\n      secondaryUrl\n      fuelSensorNames\n      fuelSensorIMEIs\n      tanks\n    }\n  }\n'],['\n  query getFuelCalibrationDetail($entityId: Int) {\n    getFuelCalibrationDetail(vehicleId: $entityId) {\n      # refuelThreshold\n      # drainThreshold\n      # medianFilter\n      fuelUserType\n      fuelSensorType\n      minTankCapacity\n      minValue\n      maxTankCapacity\n      totalFuelTank\n      maxValue\n      # pfPerMin\n      pilferageTolerance\n      # minimumPilferageDuration\n      calibration_filename\n      url\n      # overallThreshold\n      availableDataTypes\n      preferedDataType\n      # secondary tank\n      hasSecondaryTank\n      hasInSameTank\n      isDualSensor\n      useTaabiAlgo\n      # obdAlgo\n      # fuelSensorAlgo\n      secondaryTankMinCapacity\n      secondaryTankMaxCapacity\n      secondaryTankTotalFuel\n      secondaryTankMinValue\n      secondaryTankMaxValue\n      secondaryPolynomialEquation\n      secondary_tank_calibration_filename\n      secondaryUrl\n      fuelSensorNames\n      fuelSensorIMEIs\n      tanks\n    }\n  }\n']),_templateObject8=_taggedTemplateLiteral(['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n'],['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n']),_templateObject9=_taggedTemplateLiteral(['\n  query getAllAlgos {\n    getAllAlgos {\n      algoName\n      algoInt\n    }\n  }\n'],['\n  query getAllAlgos {\n    getAllAlgos {\n      algoName\n      algoInt\n    }\n  }\n']),_templateObject10=_taggedTemplateLiteral(['\nmutation AddELOCKconnection($uniqueId: String!, $status: Int!, $deviceType: String!) {\n  addELOCKconnection(uniqueId: $uniqueId, status: $status, deviceType: $deviceType) \n}\n'],['\nmutation AddELOCKconnection($uniqueId: String!, $status: Int!, $deviceType: String!) {\n  addELOCKconnection(uniqueId: $uniqueId, status: $status, deviceType: $deviceType) \n}\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_PARTNER_CLIENT_LIST=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject);var GET_FUEL_SENSOR_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject2);var GET_FUEL_SENSOR_ASSIGNMENTS=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject3);var GET_ALL_VEHICLES=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject4);var GET_UPLOAD_URL=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject5);var ADD_VEHICLES=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject6);var GET_CALIBRATION_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject7);var GET_FILE_FORMAT=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject8);var GET_ALL_ALGO=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject9);var ADD_ELOCK_CONNECTION=Object(__WEBPACK_IMPORTED_MODULE_0_graphql_tag__["a" /* default */])(_templateObject10);

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"
})), 'FileDownload');

exports.default = _default;

/***/ }),
/* 334 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_getLoginId__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query {\n    models: allDeviceModels {\n      id\n      model_name\n    }\n  }\n'],['\n  query {\n    models: allDeviceModels {\n      id\n      model_name\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query deviceModel($modelId: Int) {\n    deviceModel(id: $modelId) {\n      devicetype\n    }\n  }\n'],['\n  query deviceModel($modelId: Int) {\n    deviceModel(id: $modelId) {\n      devicetype\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query {\n    manufacturers: getAllManufacturer {\n      id\n      manufacturerName\n      manufacturerCode\n    }\n  }\n'],['\n  query {\n    manufacturers: getAllManufacturer {\n      id\n      manufacturerName\n      manufacturerCode\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  mutation addDeviceDetail(\n    $serial_num: String!\n    $imei_num: String!\n    $device_model_id: Int!\n    $uniqueSerialNumber: String!\n    $manufacturerId: Int!\n    $ownerLoginId: Int!\n  ) {\n    addDeviceDetail(\n      serial_num: $serial_num\n      imei_num: $imei_num\n      deviceModelId: $device_model_id\n      uniqueDeviceId: $uniqueSerialNumber\n      manufacturerId: $manufacturerId\n      ownerLoginId: $ownerLoginId\n    )\n  }\n'],['\n  mutation addDeviceDetail(\n    $serial_num: String!\n    $imei_num: String!\n    $device_model_id: Int!\n    $uniqueSerialNumber: String!\n    $manufacturerId: Int!\n    $ownerLoginId: Int!\n  ) {\n    addDeviceDetail(\n      serial_num: $serial_num\n      imei_num: $imei_num\n      deviceModelId: $device_model_id\n      uniqueDeviceId: $uniqueSerialNumber\n      manufacturerId: $manufacturerId\n      ownerLoginId: $ownerLoginId\n    )\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_MODELS=Object(__WEBPACK_IMPORTED_MODULE_14_graphql_tag__["a" /* default */])(_templateObject);var GET_MODEL_TYPE=Object(__WEBPACK_IMPORTED_MODULE_14_graphql_tag__["a" /* default */])(_templateObject2);var GET_MANUFACTURER=Object(__WEBPACK_IMPORTED_MODULE_14_graphql_tag__["a" /* default */])(_templateObject3);// calling server for updation
var ADD_DEVICE=Object(__WEBPACK_IMPORTED_MODULE_14_graphql_tag__["a" /* default */])(_templateObject4);var styles=function styles(theme){return{button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{margin:theme.spacing.unit,minWidth:120}};};var AddDevice=function(_Component){_inherits(AddDevice,_Component);function AddDevice(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,AddDevice);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AddDevice.__proto__||Object.getPrototypeOf(AddDevice)).call.apply(_ref,[this].concat(args))),_this),_this.state={open:false,open1:false,modelname:'',serialno:'',imeino:'',uniqueSerialNumber:'',isModelNameValid:true,isSerialnoValid:true,isImeinoValid:true,isManufacturerNameValid:true,manufacturerName:'',open_man:false,manufacturerCode:'',manufacturerId:'',deviceType:''},_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));};},_this.handleClickOpen=function(){_this.setState({open:true});},_this.handleClose=function(){_this.setState({open:false});},_this.handleChange=function(event){_this.setState(_defineProperty({},event.target.name,event.target.value));},_this.handleModelChange=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _ref3,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.setState(_defineProperty({},event.target.name,event.target.value));_context.next=3;return _this.props.client.query({query:GET_MODEL_TYPE,variables:{modelId:event.target.value}});case 3:_ref3=_context.sent;data=_ref3.data;// console.log(data, 'modelType')
_this.setState({deviceType:data.deviceModel.devicetype});case 6:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}(),_this.handleOpen=function(){_this.setState({open:true});},_this.handleOpenSelect=function(){_this.setState({open1:true});},_this.handleCloseSelect=function(){_this.setState({open1:false});},_this.handleOpenSelectMan=function(){_this.setState({open_man:true});},_this.handleCloseSelectMan=function(){_this.setState({open_man:false});},_this.checkImeinoValidity=function(){var regex=new RegExp(// eslint-disable-next-line
/^[0-9]+$/);var code=[];code=_this.state.manufacturerName.split('*');if(code[0]===''){_this.setState({isImeinoValid:regex.test(_this.state.imeino)||_this.state.imeino===''// this.state.modelname === ''
});}else{_this.setState({isImeinoValid:regex.test(_this.state.imeino)||_this.state.imeino===''// this.state.modelname === ''
});if(_this.state.deviceType==='AS140'){_this.setState({uniqueSerialNumber:code[1]+'_'+_this.state.imeino});}}// console.log(this.state.isModelNameValid)
},_this.checkSerialnoValidity=function(){var regex=new RegExp(/^[0-9]+$/);var code=[];code=_this.state.manufacturerName.split('*');if(code[0]===''){_this.setState({isSerialnoValid:regex.test(_this.state.serialno)||_this.state.serialno===''});}else{_this.setState({isSerialnoValid:regex.test(_this.state.serialno)||_this.state.serialno===''});if(_this.state.deviceType!=='AS140'){_this.setState({uniqueSerialNumber:code[1]+'_'+_this.state.serialno});}}},_this.checkModelNameValidity=function(){_this.setState({isModelNameValid:_this.state.modelname!==''});},_this.checkManufacturerNameValidity=function(){console.log(_this.state.manufacturerName);var code=_this.state.manufacturerName.split('*');console.log('man',code[0]);_this.setState({isManufacturerNameValid:_this.state.manufacturerName!=='',// manufacturerCode:this
uniqueSerialNumber:code[1]+'_'+_this.state.serialno,manufacturerId:code[0]});},_this.addBulkUpload=function(e){console.log('bulk');_this.props.history.push({pathname:'/home/DeviceInventory/BulkUpload'});},_this.assignBulkUpload=function(e){console.log('bulk');_this.props.history.push({pathname:'/home/DeviceInventory/BulkDeviceAssign'});},_this.handleSubmit=function(addDevice){return function(e){e.preventDefault();addDevice({variables:{serial_num:_this.state.serialno,imei_num:_this.state.imeino,device_model_id:parseInt(_this.state.modelname,10),uniqueSerialNumber:_this.state.uniqueSerialNumber,manufacturerId:parseInt(_this.state.manufacturerId,10),ownerLoginId:Object(__WEBPACK_IMPORTED_MODULE_17__utils_getLoginId__["a" /* default */])()}});// this.state.simprovider = ''
_this.setState({serial_num:'',imei_num:'',device_model_id:'',uniqueSerialNumber:'',manufacturerId:''});};},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AddDevice,[{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;console.log('MID=',this.state.manufacturerId,this.state.uniqueSerialNumber);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_apollo__["Query"],{query:GET_MODELS},function(_ref4){var isModelsLoading=_ref4.loading,error=_ref4.error,models=_ref4.data.models;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_apollo__["Query"],{query:GET_MANUFACTURER},function(_ref5){var isManufacturersLoading=_ref5.loading,error=_ref5.error,manufacturers=_ref5.data.manufacturers;if(isModelsLoading||isManufacturersLoading)return null;if(error)return'Error!: '+error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_apollo__["Mutation"],{mutation:ADD_DEVICE},function(addDevice,_ref6){var data=_ref6.data,error=_ref6.error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle___default.a,{id:'form-dialog-title'},'Add Device Details :'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core__["Typography"],{variant:'subheading',gutterBottom:true,style:{color:'red',marginLeft:'25px'}},error&&error.graphQLErrors.map(function(_ref7,i){var message=_ref7.message;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{key:i},message);})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core__["Typography"],{variant:'subheading',gutterBottom:true,style:{color:'green',marginLeft:'25px'}},data&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Sucessfully Added')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Divider___default.a,{light:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{onSubmit:_this3.handleSubmit(addDevice)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText___default.a,null,'* Marked fields are mandatory'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel___default.a,{htmlFor:'demo-controlled-open-select'},'Select Manufacturer *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select___default.a,{open:_this3.state.open_man,fullWidth:true,onClose:_this3.handleCloseSelectMan,onOpen:_this3.handleOpenSelectMan,value:_this3.state.manufacturerName,onChange:_this3.handleChange,onBlur:_this3.checkManufacturerNameValidity,inputProps:{name:'manufacturerName',id:'manufacturerName'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),manufacturers.map(function(manufacturer){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{value:manufacturer.id+'*'+manufacturer.manufacturerCode,key:manufacturer.id},manufacturer.manufacturerName);}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel___default.a,{htmlFor:'demo-controlled-open-select'},'Select Model *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select___default.a,{open:_this3.state.open1,fullWidth:true,onClose:_this3.handleCloseSelect,onOpen:_this3.handleOpenSelect,value:_this3.state.modelname,onChange:_this3.handleModelChange,onBlur:_this3.checkModelNameValidity,inputProps:{name:'modelname',id:'modelname'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),models.map(function(allDeviceModelsByStatus){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{value:allDeviceModelsByStatus.id,key:allDeviceModelsByStatus.id},allDeviceModelsByStatus.model_name);}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'serialno',name:'serialno',label:'Serial No',type:'text',required:true,value:_this3.state.serialno,fullWidth:true,onChange:_this3.handleInputChange('serialno'),error:!_this3.state.isSerialnoValid,onBlur:_this3.checkSerialnoValidity})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'imeino',name:'imeino',label:'IMEI No',type:'text',required:true,fullWidth:true,value:_this3.state.imeino,onChange:_this3.handleInputChange('imeino'),error:!_this3.state.isImeinoValid,onBlur:_this3.checkImeinoValidity})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'uniqueSerialNumber',name:'uniqueSerialNumber',label:'Unique Id',type:'text',disabled:true,required:true,fullWidth:true,value:_this3.state.uniqueSerialNumber,onChange:_this3.handleInputChange('uniqueSerialNumber')// error={!this.state.isImeinoValid}
// onBlur={this.checkImeinoValidity}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:_this3.props.handleClose,color:'default',variant:'contained'},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a// onClick={this.handleClose}
,{type:'submit',color:'primary',variant:'contained',disabled:!(_this3.state.isModelNameValid&&_this3.state.isSerialnoValid&&_this3.state.isImeinoValid&&_this3.state.serialno!==''&&_this3.state.imeino!==''&&_this3.state.manufacturerName!==''&&_this3.state.uniqueSerialNumber!=='')},'Submit'))));});});});}}]);return AddDevice;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_15_react_apollo__["withApollo"])(AddDevice)));

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_vis_dist_style_css__ = __webpack_require__(2085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_vis_dist_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_vis_dist_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_vis__ = __webpack_require__(2086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_styles__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_classes__ = __webpack_require__(2324);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PieChart=function(_Component){_inherits(PieChart,_Component);function PieChart(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PieChart);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PieChart.__proto__||Object.getPrototypeOf(PieChart)).call.apply(_ref,[this].concat(args))),_this),_this.state={selectedValue:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PieChart,[{key:'_mapData',value:function _mapData(){var arcClass=this.props.classes['arc'];return this.props.data.map(function(item){return Object.assign({},item,{className:arcClass});});}},{key:'render',value:function render(){var _this2=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_vis__["b" /* RadialChart */],{animation:true,innerRadius:0,radius:Math.min(this.props.width/2-4,this.props.height/2-4),colorRange:__WEBPACK_IMPORTED_MODULE_5__constants_styles__["a" /* EXTENDED_DISCRETE_COLOR_RANGE */],getAngle:function getAngle(d){return d.value;},data:this._mapData(),onValueMouseOver:function onValueMouseOver(v){return _this2.setState({selectedValue:v});},onSeriesMouseOut:function onSeriesMouseOut(v){return _this2.setState({selectedValue:false});},width:this.props.width,height:this.props.height},this.state.selectedValue&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_vis__["a" /* Hint */],{value:this.state.selectedValue},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes['chart-hint']},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.selectedValue.label,': '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.selectedValue.value))));}}]);return PieChart;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);PieChart.propTypes={width:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,height:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,margin:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({left:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,right:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,top:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,bottom:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number}),data:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired})).isRequired};PieChart.defaultProps={width:200,height:200,margin:{left:10,right:10,top:10,bottom:10}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__["withStyles"])(__WEBPACK_IMPORTED_MODULE_6__constants_classes__["a" /* RADIAL_CHART_STYLE */])(PieChart));

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = RedBlackNode;
function RedBlackTree() {
  this._ = null; // root node
}

function RedBlackNode(node) {
  node.U = // parent node
  node.C = // color - true for red, false for black
  node.L = // left node
  node.R = // right node
  node.P = // previous node
  node.N = null; // next node
}

RedBlackTree.prototype = {
  constructor: RedBlackTree,

  insert: function(after, node) {
    var parent, grandpa, uncle;

    if (after) {
      node.P = after;
      node.N = after.N;
      if (after.N) after.N.P = node;
      after.N = node;
      if (after.R) {
        after = after.R;
        while (after.L) after = after.L;
        after.L = node;
      } else {
        after.R = node;
      }
      parent = after;
    } else if (this._) {
      after = RedBlackFirst(this._);
      node.P = null;
      node.N = after;
      after.P = after.L = node;
      parent = after;
    } else {
      node.P = node.N = null;
      this._ = node;
      parent = null;
    }
    node.L = node.R = null;
    node.U = parent;
    node.C = true;

    after = node;
    while (parent && parent.C) {
      grandpa = parent.U;
      if (parent === grandpa.L) {
        uncle = grandpa.R;
        if (uncle && uncle.C) {
          parent.C = uncle.C = false;
          grandpa.C = true;
          after = grandpa;
        } else {
          if (after === parent.R) {
            RedBlackRotateLeft(this, parent);
            after = parent;
            parent = after.U;
          }
          parent.C = false;
          grandpa.C = true;
          RedBlackRotateRight(this, grandpa);
        }
      } else {
        uncle = grandpa.L;
        if (uncle && uncle.C) {
          parent.C = uncle.C = false;
          grandpa.C = true;
          after = grandpa;
        } else {
          if (after === parent.L) {
            RedBlackRotateRight(this, parent);
            after = parent;
            parent = after.U;
          }
          parent.C = false;
          grandpa.C = true;
          RedBlackRotateLeft(this, grandpa);
        }
      }
      parent = after.U;
    }
    this._.C = false;
  },

  remove: function(node) {
    if (node.N) node.N.P = node.P;
    if (node.P) node.P.N = node.N;
    node.N = node.P = null;

    var parent = node.U,
        sibling,
        left = node.L,
        right = node.R,
        next,
        red;

    if (!left) next = right;
    else if (!right) next = left;
    else next = RedBlackFirst(right);

    if (parent) {
      if (parent.L === node) parent.L = next;
      else parent.R = next;
    } else {
      this._ = next;
    }

    if (left && right) {
      red = next.C;
      next.C = node.C;
      next.L = left;
      left.U = next;
      if (next !== right) {
        parent = next.U;
        next.U = node.U;
        node = next.R;
        parent.L = node;
        next.R = right;
        right.U = next;
      } else {
        next.U = parent;
        parent = next;
        node = next.R;
      }
    } else {
      red = node.C;
      node = next;
    }

    if (node) node.U = parent;
    if (red) return;
    if (node && node.C) { node.C = false; return; }

    do {
      if (node === this._) break;
      if (node === parent.L) {
        sibling = parent.R;
        if (sibling.C) {
          sibling.C = false;
          parent.C = true;
          RedBlackRotateLeft(this, parent);
          sibling = parent.R;
        }
        if ((sibling.L && sibling.L.C)
            || (sibling.R && sibling.R.C)) {
          if (!sibling.R || !sibling.R.C) {
            sibling.L.C = false;
            sibling.C = true;
            RedBlackRotateRight(this, sibling);
            sibling = parent.R;
          }
          sibling.C = parent.C;
          parent.C = sibling.R.C = false;
          RedBlackRotateLeft(this, parent);
          node = this._;
          break;
        }
      } else {
        sibling = parent.L;
        if (sibling.C) {
          sibling.C = false;
          parent.C = true;
          RedBlackRotateRight(this, parent);
          sibling = parent.L;
        }
        if ((sibling.L && sibling.L.C)
          || (sibling.R && sibling.R.C)) {
          if (!sibling.L || !sibling.L.C) {
            sibling.R.C = false;
            sibling.C = true;
            RedBlackRotateLeft(this, sibling);
            sibling = parent.L;
          }
          sibling.C = parent.C;
          parent.C = sibling.L.C = false;
          RedBlackRotateRight(this, parent);
          node = this._;
          break;
        }
      }
      sibling.C = true;
      node = parent;
      parent = parent.U;
    } while (!node.C);

    if (node) node.C = false;
  }
};

function RedBlackRotateLeft(tree, node) {
  var p = node,
      q = node.R,
      parent = p.U;

  if (parent) {
    if (parent.L === p) parent.L = q;
    else parent.R = q;
  } else {
    tree._ = q;
  }

  q.U = parent;
  p.U = q;
  p.R = q.L;
  if (p.R) p.R.U = p;
  q.L = p;
}

function RedBlackRotateRight(tree, node) {
  var p = node,
      q = node.L,
      parent = p.U;

  if (parent) {
    if (parent.L === p) parent.L = q;
    else parent.R = q;
  } else {
    tree._ = q;
  }

  q.U = parent;
  p.U = q;
  p.L = q.R;
  if (p.L) p.L.U = p;
  q.R = p;
}

function RedBlackFirst(node) {
  while (node.L) node = node.L;
  return node;
}

/* harmony default export */ __webpack_exports__["b"] = (RedBlackTree);


/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = createEdge;
/* harmony export (immutable) */ __webpack_exports__["b"] = createBorderEdge;
/* harmony export (immutable) */ __webpack_exports__["d"] = setEdgeEnd;
/* harmony export (immutable) */ __webpack_exports__["a"] = clipEdges;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Diagram__ = __webpack_require__(191);


function createEdge(left, right, v0, v1) {
  var edge = [null, null],
      index = __WEBPACK_IMPORTED_MODULE_0__Diagram__["e" /* edges */].push(edge) - 1;
  edge.left = left;
  edge.right = right;
  if (v0) setEdgeEnd(edge, left, right, v0);
  if (v1) setEdgeEnd(edge, right, left, v1);
  __WEBPACK_IMPORTED_MODULE_0__Diagram__["b" /* cells */][left.index].halfedges.push(index);
  __WEBPACK_IMPORTED_MODULE_0__Diagram__["b" /* cells */][right.index].halfedges.push(index);
  return edge;
}

function createBorderEdge(left, v0, v1) {
  var edge = [v0, v1];
  edge.left = left;
  return edge;
}

function setEdgeEnd(edge, left, right, vertex) {
  if (!edge[0] && !edge[1]) {
    edge[0] = vertex;
    edge.left = left;
    edge.right = right;
  } else if (edge.left === right) {
    edge[1] = vertex;
  } else {
    edge[0] = vertex;
  }
}

// Liang–Barsky line clipping.
function clipEdge(edge, x0, y0, x1, y1) {
  var a = edge[0],
      b = edge[1],
      ax = a[0],
      ay = a[1],
      bx = b[0],
      by = b[1],
      t0 = 0,
      t1 = 1,
      dx = bx - ax,
      dy = by - ay,
      r;

  r = x0 - ax;
  if (!dx && r > 0) return;
  r /= dx;
  if (dx < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dx > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = x1 - ax;
  if (!dx && r < 0) return;
  r /= dx;
  if (dx < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dx > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  r = y0 - ay;
  if (!dy && r > 0) return;
  r /= dy;
  if (dy < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dy > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = y1 - ay;
  if (!dy && r < 0) return;
  r /= dy;
  if (dy < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dy > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  if (!(t0 > 0) && !(t1 < 1)) return true; // TODO Better check?

  if (t0 > 0) edge[0] = [ax + t0 * dx, ay + t0 * dy];
  if (t1 < 1) edge[1] = [ax + t1 * dx, ay + t1 * dy];
  return true;
}

function connectEdge(edge, x0, y0, x1, y1) {
  var v1 = edge[1];
  if (v1) return true;

  var v0 = edge[0],
      left = edge.left,
      right = edge.right,
      lx = left[0],
      ly = left[1],
      rx = right[0],
      ry = right[1],
      fx = (lx + rx) / 2,
      fy = (ly + ry) / 2,
      fm,
      fb;

  if (ry === ly) {
    if (fx < x0 || fx >= x1) return;
    if (lx > rx) {
      if (!v0) v0 = [fx, y0];
      else if (v0[1] >= y1) return;
      v1 = [fx, y1];
    } else {
      if (!v0) v0 = [fx, y1];
      else if (v0[1] < y0) return;
      v1 = [fx, y0];
    }
  } else {
    fm = (lx - rx) / (ry - ly);
    fb = fy - fm * fx;
    if (fm < -1 || fm > 1) {
      if (lx > rx) {
        if (!v0) v0 = [(y0 - fb) / fm, y0];
        else if (v0[1] >= y1) return;
        v1 = [(y1 - fb) / fm, y1];
      } else {
        if (!v0) v0 = [(y1 - fb) / fm, y1];
        else if (v0[1] < y0) return;
        v1 = [(y0 - fb) / fm, y0];
      }
    } else {
      if (ly < ry) {
        if (!v0) v0 = [x0, fm * x0 + fb];
        else if (v0[0] >= x1) return;
        v1 = [x1, fm * x1 + fb];
      } else {
        if (!v0) v0 = [x1, fm * x1 + fb];
        else if (v0[0] < x0) return;
        v1 = [x0, fm * x0 + fb];
      }
    }
  }

  edge[0] = v0;
  edge[1] = v1;
  return true;
}

function clipEdges(x0, y0, x1, y1) {
  var i = __WEBPACK_IMPORTED_MODULE_0__Diagram__["e" /* edges */].length,
      edge;

  while (i--) {
    if (!connectEdge(edge = __WEBPACK_IMPORTED_MODULE_0__Diagram__["e" /* edges */][i], x0, y0, x1, y1)
        || !clipEdge(edge, x0, y0, x1, y1)
        || !(Math.abs(edge[0][0] - edge[1][0]) > __WEBPACK_IMPORTED_MODULE_0__Diagram__["f" /* epsilon */]
            || Math.abs(edge[0][1] - edge[1][1]) > __WEBPACK_IMPORTED_MODULE_0__Diagram__["f" /* epsilon */])) {
      delete __WEBPACK_IMPORTED_MODULE_0__Diagram__["e" /* edges */][i];
    }
  }
}


/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rgb_js__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array_js__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__date_js__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number_js__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__object_js__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__string_js__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constant_js__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__numberArray_js__ = __webpack_require__(343);










/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? Object(__WEBPACK_IMPORTED_MODULE_7__constant_js__["a" /* default */])(b)
      : (t === "number" ? __WEBPACK_IMPORTED_MODULE_4__number_js__["a" /* default */]
      : t === "string" ? ((c = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* color */])(b)) ? (b = c, __WEBPACK_IMPORTED_MODULE_1__rgb_js__["a" /* default */]) : __WEBPACK_IMPORTED_MODULE_6__string_js__["a" /* default */])
      : b instanceof __WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* color */] ? __WEBPACK_IMPORTED_MODULE_1__rgb_js__["a" /* default */]
      : b instanceof Date ? __WEBPACK_IMPORTED_MODULE_3__date_js__["a" /* default */]
      : Object(__WEBPACK_IMPORTED_MODULE_8__numberArray_js__["b" /* isNumberArray */])(b) ? __WEBPACK_IMPORTED_MODULE_8__numberArray_js__["a" /* default */]
      : Array.isArray(b) ? __WEBPACK_IMPORTED_MODULE_2__array_js__["a" /* genericArray */]
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? __WEBPACK_IMPORTED_MODULE_5__object_js__["a" /* default */]
      : __WEBPACK_IMPORTED_MODULE_4__number_js__["a" /* default */])(a, b);
});


/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Color;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return darker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return brighter; });
/* harmony export (immutable) */ __webpack_exports__["e"] = color;
/* harmony export (immutable) */ __webpack_exports__["h"] = rgbConvert;
/* harmony export (immutable) */ __webpack_exports__["g"] = rgb;
/* harmony export (immutable) */ __webpack_exports__["b"] = Rgb;
/* unused harmony export hslConvert */
/* harmony export (immutable) */ __webpack_exports__["f"] = hsl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define_js__ = __webpack_require__(341);


function Color() {}

var darker = 0.7;
var brighter = 1 / darker;

var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex = /^#([0-9a-f]{3,8})$/,
    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

Object(__WEBPACK_IMPORTED_MODULE_0__define_js__["a" /* default */])(Color, color, {
  copy: function(channels) {
    return Object.assign(new this.constructor, this, channels);
  },
  displayable: function() {
    return this.rgb().displayable();
  },
  hex: color_formatHex, // Deprecated! Use color.formatHex.
  formatHex: color_formatHex,
  formatHsl: color_formatHsl,
  formatRgb: color_formatRgb,
  toString: color_formatRgb
});

function color_formatHex() {
  return this.rgb().formatHex();
}

function color_formatHsl() {
  return hslConvert(this).formatHsl();
}

function color_formatRgb() {
  return this.rgb().formatRgb();
}

function color(format) {
  var m, l;
  format = (format + "").trim().toLowerCase();
  return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
      : l === 3 ? new Rgb((m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1) // #f00
      : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
      : l === 4 ? rgba((m >> 12 & 0xf) | (m >> 8 & 0xf0), (m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), (((m & 0xf) << 4) | (m & 0xf)) / 0xff) // #f000
      : null) // invalid hex
      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
      : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
      : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb;
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define_js__["a" /* default */])(Rgb, rgb, Object(__WEBPACK_IMPORTED_MODULE_0__define_js__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return (-0.5 <= this.r && this.r < 255.5)
        && (-0.5 <= this.g && this.g < 255.5)
        && (-0.5 <= this.b && this.b < 255.5)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  hex: rgb_formatHex, // Deprecated! Use color.formatHex.
  formatHex: rgb_formatHex,
  formatRgb: rgb_formatRgb,
  toString: rgb_formatRgb
}));

function rgb_formatHex() {
  return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}

function rgb_formatRgb() {
  var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
  return (a === 1 ? "rgb(" : "rgba(")
      + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
      + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
      + Math.max(0, Math.min(255, Math.round(this.b) || 0))
      + (a === 1 ? ")" : ", " + a + ")");
}

function hex(value) {
  value = Math.max(0, Math.min(255, Math.round(value) || 0));
  return (value < 16 ? "0" : "") + value.toString(16);
}

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl;
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define_js__["a" /* default */])(Hsl, hsl, Object(__WEBPACK_IMPORTED_MODULE_0__define_js__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  formatHsl: function() {
    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "hsl(" : "hsla(")
        + (this.h || 0) + ", "
        + (this.s || 0) * 100 + "%, "
        + (this.l || 0) * 100 + "%"
        + (a === 1 ? ")" : ", " + a + ")");
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}


/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extend;
/* harmony default export */ __webpack_exports__["a"] = (function(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
});

function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}


/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = basis;
function basis(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1, t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
      + (4 - 6 * t2 + 3 * t3) * v1
      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
      + t3 * v3) / 6;
}

/* harmony default export */ __webpack_exports__["b"] = (function(values) {
  var n = values.length - 1;
  return function(t) {
    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
        v1 = values[i],
        v2 = values[i + 1],
        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isNumberArray;
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  if (!b) b = [];
  var n = a ? Math.min(b.length, a.length) : 0,
      c = b.slice(),
      i;
  return function(t) {
    for (i = 0; i < n; ++i) c[i] = a[i] * (1 - t) + b[i] * t;
    return c;
  };
});

function isNumberArray(x) {
  return ArrayBuffer.isView(x) && !(x instanceof DataView);
}


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// currently used to initiate the velocity style object to 0


exports.__esModule = true;
exports['default'] = mapToZero;

function mapToZero(obj) {
  var ret = {};
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      ret[key] = 0;
    }
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// stepper is used a lot. Saves allocation to return the same array wrapper.
// This is fine and danger-free against mutations because the callsite
// immediately destructures it and gets the numbers inside without passing the


exports.__esModule = true;
exports["default"] = stepper;

var reusedTuple = [0, 0];

function stepper(secondPerFrame, x, v, destX, k, b, precision) {
  // Spring stiffness, in kg / s^2

  // for animations, destX is really spring length (spring at rest). initial
  // position is considered as the stretched/compressed position of a spring
  var Fspring = -k * (x - destX);

  // Damping, in kg / s
  var Fdamper = -b * v;

  // usually we put mass here, but for animation purposes, specifying mass is a
  // bit redundant. you could simply adjust k and b accordingly
  // let a = (Fspring + Fdamper) / mass;
  var a = Fspring + Fdamper;

  var newV = v + a * secondPerFrame;
  var newX = x + newV * secondPerFrame;

  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
    reusedTuple[0] = destX;
    reusedTuple[1] = 0;
    return reusedTuple;
  }

  reusedTuple[0] = newX;
  reusedTuple[1] = newV;
  return reusedTuple;
}

module.exports = exports["default"];
// array reference around.

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
(function() {
  var getNanoSeconds, hrtime, loadTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - loadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    loadTime = getNanoSeconds();
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(137)))

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(2108)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(72)))

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// usage assumption: currentStyle values have already been rendered but it says
// nothing of whether currentStyle is stale (see unreadPropStyle)


exports.__esModule = true;
exports['default'] = shouldStopAnimation;

function shouldStopAnimation(currentStyle, style, currentVelocity) {
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }

    if (currentVelocity[key] !== 0) {
      return false;
    }

    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
    // stepper will have already taken care of rounding precision errors, so
    // won't have such thing as 0.9999 !=== 1
    if (currentStyle[key] !== styleValue) {
      return false;
    }
  }

  return true;
}

module.exports = exports['default'];

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(192);


/* harmony default export */ __webpack_exports__["a"] = (function(values, p, valueof) {
  if (valueof == null) valueof = __WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */];
  if (!(n = values.length)) return;
  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
  var n,
      i = (n - 1) * p,
      i0 = Math.floor(i),
      value0 = +valueof(values[i0], i0, values),
      value1 = +valueof(values[i0 + 1], i0 + 1, values);
  return value0 + (value1 - value0) * (i - i0);
});


/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nest__ = __webpack_require__(2131);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__nest__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__set__ = __webpack_require__(2132);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__set__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__map__ = __webpack_require__(351);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__map__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__keys__ = __webpack_require__(2133);
/* unused harmony reexport keys */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__values__ = __webpack_require__(2134);
/* unused harmony reexport values */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__entries__ = __webpack_require__(2135);
/* unused harmony reexport entries */








/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prefix; });
var prefix = "$";

function Map() {}

Map.prototype = map.prototype = {
  constructor: Map,
  has: function(key) {
    return (prefix + key) in this;
  },
  get: function(key) {
    return this[prefix + key];
  },
  set: function(key, value) {
    this[prefix + key] = value;
    return this;
  },
  remove: function(key) {
    var property = prefix + key;
    return property in this && delete this[property];
  },
  clear: function() {
    for (var property in this) if (property[0] === prefix) delete this[property];
  },
  keys: function() {
    var keys = [];
    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
    return keys;
  },
  values: function() {
    var values = [];
    for (var property in this) if (property[0] === prefix) values.push(this[property]);
    return values;
  },
  entries: function() {
    var entries = [];
    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
    return entries;
  },
  size: function() {
    var size = 0;
    for (var property in this) if (property[0] === prefix) ++size;
    return size;
  },
  empty: function() {
    for (var property in this) if (property[0] === prefix) return false;
    return true;
  },
  each: function(f) {
    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
  }
};

function map(object, f) {
  var map = new Map;

  // Copy constructor.
  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });

  // Index array by numeric index or specified key function.
  else if (Array.isArray(object)) {
    var i = -1,
        n = object.length,
        o;

    if (f == null) while (++i < n) map.set(i, object[i]);
    else while (++i < n) map.set(f(o = object[i], i, object), o);
  }

  // Convert object to map.
  else if (object) for (var key in object) map.set(key, object[key]);

  return map;
}

/* harmony default export */ __webpack_exports__["a"] = (map);


/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(74);
/* unused harmony reexport timeInterval */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__millisecond_js__ = __webpack_require__(2153);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__millisecond_js__["a"]; });
/* unused harmony reexport timeMilliseconds */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_1__millisecond_js__["a"]; });
/* unused harmony reexport utcMilliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__second_js__ = __webpack_require__(2154);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__second_js__["a"]; });
/* unused harmony reexport timeSeconds */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_2__second_js__["a"]; });
/* unused harmony reexport utcSeconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__minute_js__ = __webpack_require__(2155);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__minute_js__["a"]; });
/* unused harmony reexport timeMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hour_js__ = __webpack_require__(2156);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__hour_js__["a"]; });
/* unused harmony reexport timeHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__day_js__ = __webpack_require__(2157);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__day_js__["a"]; });
/* unused harmony reexport timeDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__week_js__ = __webpack_require__(2158);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_6__week_js__["b"]; });
/* unused harmony reexport timeWeeks */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_6__week_js__["b"]; });
/* unused harmony reexport timeSundays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_6__week_js__["a"]; });
/* unused harmony reexport timeMondays */
/* unused harmony reexport timeTuesday */
/* unused harmony reexport timeTuesdays */
/* unused harmony reexport timeWednesday */
/* unused harmony reexport timeWednesdays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_6__week_js__["c"]; });
/* unused harmony reexport timeThursdays */
/* unused harmony reexport timeFriday */
/* unused harmony reexport timeFridays */
/* unused harmony reexport timeSaturday */
/* unused harmony reexport timeSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__month_js__ = __webpack_require__(2159);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_7__month_js__["a"]; });
/* unused harmony reexport timeMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__year_js__ = __webpack_require__(2160);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_8__year_js__["a"]; });
/* unused harmony reexport timeYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utcMinute_js__ = __webpack_require__(2161);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_9__utcMinute_js__["a"]; });
/* unused harmony reexport utcMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utcHour_js__ = __webpack_require__(2162);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_10__utcHour_js__["a"]; });
/* unused harmony reexport utcHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utcDay_js__ = __webpack_require__(2163);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_11__utcDay_js__["a"]; });
/* unused harmony reexport utcDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utcWeek_js__ = __webpack_require__(2164);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_12__utcWeek_js__["b"]; });
/* unused harmony reexport utcWeeks */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_12__utcWeek_js__["b"]; });
/* unused harmony reexport utcSundays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_12__utcWeek_js__["a"]; });
/* unused harmony reexport utcMondays */
/* unused harmony reexport utcTuesday */
/* unused harmony reexport utcTuesdays */
/* unused harmony reexport utcWednesday */
/* unused harmony reexport utcWednesdays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_12__utcWeek_js__["c"]; });
/* unused harmony reexport utcThursdays */
/* unused harmony reexport utcFriday */
/* unused harmony reexport utcFridays */
/* unused harmony reexport utcSaturday */
/* unused harmony reexport utcSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utcMonth_js__ = __webpack_require__(2165);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_13__utcMonth_js__["a"]; });
/* unused harmony reexport utcMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utcYear_js__ = __webpack_require__(2166);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_14__utcYear_js__["a"]; });
/* unused harmony reexport utcYears */































/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return timeFormat; });
/* unused harmony export timeParse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return utcParse; });
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_js__ = __webpack_require__(583);


var locale;
var timeFormat;
var timeParse;
var utcFormat;
var utcParse;

defaultLocale({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});

function defaultLocale(definition) {
  locale = Object(__WEBPACK_IMPORTED_MODULE_0__locale_js__["a" /* default */])(definition);
  timeFormat = locale.format;
  timeParse = locale.parse;
  utcFormat = locale.utcFormat;
  utcParse = locale.utcParse;
  return locale;
}


/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getUniquePropertyValues;
/* harmony export (immutable) */ __webpack_exports__["a"] = addValueToArray;
/* harmony export (immutable) */ __webpack_exports__["c"] = transformValueToString;
// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

/**
 * Get unique property values from an array.
 * @param {Array} arr Array of data.
 * @param {string} propertyName Prop name.
 * @returns {Array} Array of unique values.
 */
function getUniquePropertyValues(arr, accessor) {
  var setOfValues = new Set(arr.map(accessor));
  return Array.from(setOfValues);
}

/**
 * Add zero to the domain.
 * @param {Array} arr Add zero to the domain.
 * @param {Number} value Add zero to domain.
 * @returns {Array} Adjusted domain.
 */
function addValueToArray(arr, value) {
  var result = [].concat(arr);
  if (result[0] > value) {
    result[0] = value;
  }
  if (result[result.length - 1] < value) {
    result[result.length - 1] = value;
  }
  return result;
}

/**
 * Transforms a value ( number or date ) to a string.
 * @param {Date | number} value The value as date or number.
 * @returns {string | number} The value as string.
 */
function transformValueToString(value) {
  return Object.prototype.toString.call(value) === '[object Date]' ? value.toDateString() : value;
}

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__animation__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_series_utils__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_shape__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__abstract_series__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_scales_utils__ = __webpack_require__(69);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.












var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--arc';
var ATTRIBUTES = ['radius', 'angle'];

var defaultProps = _extends({}, __WEBPACK_IMPORTED_MODULE_5__abstract_series__["a" /* default */].defaultProps, {
  center: { x: 0, y: 0 },
  arcClassName: '',
  className: '',
  style: {},
  padAngle: 0
});

/**
 * Prepare the internal representation of row for real use.
 * This is necessary because d3 insists on starting at 12 oclock and moving
 * clockwise, rather than starting at 3 oclock and moving counter clockwise
 * as one might expect from polar
 * @param {Object} row - coordinate object to be modifed
 * @return {Object} angle corrected object
 */
function modifyRow(row) {
  var radius = row.radius,
      angle = row.angle,
      angle0 = row.angle0;

  var truedAngle = -1 * angle + Math.PI / 2;
  var truedAngle0 = -1 * angle0 + Math.PI / 2;
  return _extends({}, row, {
    x: radius * Math.cos(truedAngle),
    y: radius * Math.sin(truedAngle),
    angle: truedAngle,
    angle0: truedAngle0
  });
}

var ArcSeries = function (_AbstractSeries) {
  _inherits(ArcSeries, _AbstractSeries);

  function ArcSeries(props) {
    _classCallCheck(this, ArcSeries);

    var _this = _possibleConstructorReturn(this, (ArcSeries.__proto__ || Object.getPrototypeOf(ArcSeries)).call(this, props));

    var scaleProps = _this._getAllScaleProps(props);
    _this.state = { scaleProps: scaleProps };
    return _this;
  }

  _createClass(ArcSeries, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({ scaleProps: this._getAllScaleProps(nextProps) });
    }

    /**
     * Get the map of scales from the props.
     * @param {Object} props Props.
     * @param {Array} data Array of all data.
     * @returns {Object} Map of scales.
     * @private
     */

  }, {
    key: '_getAllScaleProps',
    value: function _getAllScaleProps(props) {
      var defaultScaleProps = this._getDefaultScaleProps(props);
      var userScaleProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_scales_utils__["a" /* extractScalePropsFromProps */])(props, ATTRIBUTES);
      var missingScaleProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_scales_utils__["g" /* getMissingScaleProps */])(_extends({}, defaultScaleProps, userScaleProps), props.data, ATTRIBUTES);

      return _extends({}, defaultScaleProps, userScaleProps, missingScaleProps);
    }

    /**
     * Get the list of scale-related settings that should be applied by default.
     * @param {Object} props Object of props.
     * @returns {Object} Defaults.
     * @private
     */

  }, {
    key: '_getDefaultScaleProps',
    value: function _getDefaultScaleProps(props) {
      var innerWidth = props.innerWidth,
          innerHeight = props.innerHeight;

      var radius = Math.min(innerWidth / 2, innerHeight / 2);
      return {
        radiusRange: [0, radius],
        _radiusValue: radius,
        angleType: 'literal'
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          arcClassName = _props.arcClassName,
          animation = _props.animation,
          className = _props.className,
          center = _props.center,
          data = _props.data,
          disableSeries = _props.disableSeries,
          hideSeries = _props.hideSeries,
          marginLeft = _props.marginLeft,
          marginTop = _props.marginTop,
          padAngle = _props.padAngle,
          style = _props.style;


      if (!data) {
        return null;
      }

      if (animation) {
        var cloneData = data.map(function (d) {
          return _extends({}, d);
        });
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          { className: 'rv-xy-plot__series--arc__animation-wrapper' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2__animation__["b" /* default */],
            _extends({}, this.props, {
              animatedProps: __WEBPACK_IMPORTED_MODULE_3__utils_series_utils__["a" /* ANIMATED_SERIES_PROPS */],
              data: cloneData
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ArcSeries, _extends({}, this.props, {
              animation: null,
              disableSeries: true,
              data: cloneData
            }))
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ArcSeries, _extends({}, this.props, {
            animation: null,
            hideSeries: true,
            style: { stroke: 'red' }
          }))
        );
      }

      var scaleProps = this.state.scaleProps;
      var radiusDomain = scaleProps.radiusDomain;
      // need to generate our own functors as abstract series doesnt have anythign for us

      var radius = Object(__WEBPACK_IMPORTED_MODULE_6__utils_scales_utils__["c" /* getAttributeFunctor */])(scaleProps, 'radius');
      var radius0 = Object(__WEBPACK_IMPORTED_MODULE_6__utils_scales_utils__["b" /* getAttr0Functor */])(scaleProps, 'radius');
      var angle = Object(__WEBPACK_IMPORTED_MODULE_6__utils_scales_utils__["c" /* getAttributeFunctor */])(scaleProps, 'angle');
      var angle0 = Object(__WEBPACK_IMPORTED_MODULE_6__utils_scales_utils__["b" /* getAttr0Functor */])(scaleProps, 'angle');
      // but it does have good color support!
      var fill = this._getAttributeFunctor('fill') || this._getAttributeFunctor('color');
      var stroke = this._getAttributeFunctor('stroke') || this._getAttributeFunctor('color');
      var opacity = this._getAttributeFunctor('opacity');
      var x = this._getAttributeFunctor('x');
      var y = this._getAttributeFunctor('y');

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        {
          className: predefinedClassName + ' ' + className,
          onMouseOver: this._seriesMouseOverHandler,
          onMouseOut: this._seriesMouseOutHandler,
          onClick: this._seriesClickHandler,
          onContextMenu: this._seriesRightClickHandler,
          opacity: hideSeries ? 0 : 1,
          pointerEvents: disableSeries ? 'none' : 'all',
          transform: 'translate(' + (marginLeft + x(center)) + ',' + (marginTop + y(center)) + ')'
        },
        data.map(function (row, i) {
          var noRadius = radiusDomain[1] === radiusDomain[0];
          var arcArg = {
            innerRadius: noRadius ? 0 : radius0(row),
            outerRadius: radius(row),
            startAngle: angle0(row) || 0,
            endAngle: angle(row)
          };
          var arcedData = Object(__WEBPACK_IMPORTED_MODULE_4_d3_shape__["arc"])().padAngle(padAngle);
          var rowStyle = row.style || {};
          var rowClassName = row.className || '';
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
            style: _extends({
              opacity: opacity && opacity(row),
              stroke: stroke && stroke(row),
              fill: fill && fill(row)
            }, style, rowStyle),
            onClick: function onClick(e) {
              return _this2._valueClickHandler(modifyRow(row), e);
            },
            onContextMenu: function onContextMenu(e) {
              return _this2._valueRightClickHandler(modifyRow(row), e);
            },
            onMouseOver: function onMouseOver(e) {
              return _this2._valueMouseOverHandler(modifyRow(row), e);
            },
            onMouseOut: function onMouseOut(e) {
              return _this2._valueMouseOutHandler(modifyRow(row), e);
            },
            key: i,
            className: predefinedClassName + '-path ' + arcClassName + ' ' + rowClassName,
            d: arcedData(arcArg)
          });
        })
      );
    }
  }]);

  return ArcSeries;
}(__WEBPACK_IMPORTED_MODULE_5__abstract_series__["a" /* default */]);

ArcSeries.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_5__abstract_series__["a" /* default */].propTypes, Object(__WEBPACK_IMPORTED_MODULE_6__utils_scales_utils__["j" /* getScalePropTypesByAttribute */])('radius'), Object(__WEBPACK_IMPORTED_MODULE_6__utils_scales_utils__["j" /* getScalePropTypesByAttribute */])('angle'), {
  center: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  }),
  arcClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  padAngle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])
});
ArcSeries.defaultProps = defaultProps;
ArcSeries.displayName = 'ArcSeries';

/* harmony default export */ __webpack_exports__["a"] = (ArcSeries);

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant_js__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curve_linear_js__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__point_js__ = __webpack_require__(358);





/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x = __WEBPACK_IMPORTED_MODULE_3__point_js__["a" /* x */],
      y = __WEBPACK_IMPORTED_MODULE_3__point_js__["b" /* y */],
      defined = Object(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(true),
      context = null,
      curve = __WEBPACK_IMPORTED_MODULE_2__curve_linear_js__["a" /* default */],
      output = null;

  function line(data) {
    var i,
        n = data.length,
        d,
        defined0 = false,
        buffer;

    if (context == null) output = curve(buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) output.lineStart();
        else output.lineEnd();
      }
      if (defined0) output.point(+x(d, i, data), +y(d, i, data));
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  line.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(+_), line) : x;
  };

  line.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(+_), line) : y;
  };

  line.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(!!_), line) : defined;
  };

  line.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
  };

  line.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
  };

  return line;
});


/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = x;
/* harmony export (immutable) */ __webpack_exports__["b"] = y;
function x(p) {
  return p[0];
}

function y(p) {
  return p[1];
}


/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = point;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math_js__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cardinal_js__ = __webpack_require__(261);



function point(that, x, y) {
  var x1 = that._x1,
      y1 = that._y1,
      x2 = that._x2,
      y2 = that._y2;

  if (that._l01_a > __WEBPACK_IMPORTED_MODULE_0__math_js__["f" /* epsilon */]) {
    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
  }

  if (that._l23_a > __WEBPACK_IMPORTED_MODULE_0__math_js__["f" /* epsilon */]) {
    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
  }

  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}

function CatmullRom(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRom.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: this.point(this._x2, this._y2); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; // proceed
      default: point(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRom(context, alpha) : new __WEBPACK_IMPORTED_MODULE_1__cardinal_js__["a" /* Cardinal */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = sum;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none_js__ = __webpack_require__(200);


/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  var sums = series.map(sum);
  return Object(__WEBPACK_IMPORTED_MODULE_0__none_js__["a" /* default */])(series).sort(function(a, b) { return sums[a] - sums[b]; });
});

function sum(series) {
  var s = 0, i = -1, n = series.length, v;
  while (++i < n) if (v = +series[i][1]) s += v;
  return s;
}


/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export conicEqualAreaRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conic_js__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cylindricalEqualArea_js__ = __webpack_require__(2230);




function conicEqualAreaRaw(y0, y1) {
  var sy0 = Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["t" /* sin */])(y0), n = (sy0 + Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["t" /* sin */])(y1)) / 2;

  // Are the parallels symmetrical around the Equator?
  if (Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["a" /* abs */])(n) < __WEBPACK_IMPORTED_MODULE_0__math_js__["i" /* epsilon */]) return Object(__WEBPACK_IMPORTED_MODULE_2__cylindricalEqualArea_js__["a" /* cylindricalEqualAreaRaw */])(y0);

  var c = 1 + sy0 * (2 * n - sy0), r0 = Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["u" /* sqrt */])(c) / n;

  function project(x, y) {
    var r = Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["u" /* sqrt */])(c - 2 * n * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["t" /* sin */])(y)) / n;
    return [r * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["t" /* sin */])(x *= n), r0 - r * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["g" /* cos */])(x)];
  }

  project.invert = function(x, y) {
    var r0y = r0 - y,
        l = Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["e" /* atan2 */])(x, Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["a" /* abs */])(r0y)) * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["s" /* sign */])(r0y);
    if (r0y * n < 0)
      l -= __WEBPACK_IMPORTED_MODULE_0__math_js__["o" /* pi */] * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["s" /* sign */])(x) * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["s" /* sign */])(r0y);
    return [l / n, Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["c" /* asin */])((c - (x * x + r0y * r0y) * n * n) / (2 * n))];
  };

  return project;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__conic_js__["a" /* conicProjection */])(conicEqualAreaRaw)
      .scale(155.424)
      .center([0, 33.6442]);
});


/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = conicProjection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_js__ = __webpack_require__(86);



function conicProjection(projectAt) {
  var phi0 = 0,
      phi1 = __WEBPACK_IMPORTED_MODULE_0__math_js__["o" /* pi */] / 3,
      m = Object(__WEBPACK_IMPORTED_MODULE_1__index_js__["b" /* projectionMutator */])(projectAt),
      p = m(phi0, phi1);

  p.parallels = function(_) {
    return arguments.length ? m(phi0 = _[0] * __WEBPACK_IMPORTED_MODULE_0__math_js__["r" /* radians */], phi1 = _[1] * __WEBPACK_IMPORTED_MODULE_0__math_js__["r" /* radians */]) : [phi0 * __WEBPACK_IMPORTED_MODULE_0__math_js__["h" /* degrees */], phi1 * __WEBPACK_IMPORTED_MODULE_0__math_js__["h" /* degrees */]];
  };

  return p;
}


/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fitExtent;
/* harmony export (immutable) */ __webpack_exports__["c"] = fitSize;
/* harmony export (immutable) */ __webpack_exports__["d"] = fitWidth;
/* harmony export (immutable) */ __webpack_exports__["b"] = fitHeight;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stream_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__path_bounds_js__ = __webpack_require__(615);



function fit(projection, fitBounds, object) {
  var clip = projection.clipExtent && projection.clipExtent();
  projection.scale(150).translate([0, 0]);
  if (clip != null) projection.clipExtent(null);
  Object(__WEBPACK_IMPORTED_MODULE_0__stream_js__["a" /* default */])(object, projection.stream(__WEBPACK_IMPORTED_MODULE_1__path_bounds_js__["a" /* default */]));
  fitBounds(__WEBPACK_IMPORTED_MODULE_1__path_bounds_js__["a" /* default */].result());
  if (clip != null) projection.clipExtent(clip);
  return projection;
}

function fitExtent(projection, extent, object) {
  return fit(projection, function(b) {
    var w = extent[1][0] - extent[0][0],
        h = extent[1][1] - extent[0][1],
        k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])),
        x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2,
        y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
    projection.scale(150 * k).translate([x, y]);
  }, object);
}

function fitSize(projection, size, object) {
  return fitExtent(projection, [[0, 0], size], object);
}

function fitWidth(projection, width, object) {
  return fit(projection, function(b) {
    var w = +width,
        k = w / (b[1][0] - b[0][0]),
        x = (w - k * (b[1][0] + b[0][0])) / 2,
        y = -k * b[0][1];
    projection.scale(150 * k).translate([x, y]);
  }, object);
}

function fitHeight(projection, height, object) {
  return fit(projection, function(b) {
    var h = +height,
        k = h / (b[1][1] - b[0][1]),
        x = -k * b[0][0],
        y = (h - k * (b[1][1] + b[0][1])) / 2;
    projection.scale(150 * k).translate([x, y]);
  }, object);
}


/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = mercatorRaw;
/* harmony export (immutable) */ __webpack_exports__["a"] = mercatorProjection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rotation_js__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_js__ = __webpack_require__(86);




function mercatorRaw(lambda, phi) {
  return [lambda, Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["n" /* log */])(Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["v" /* tan */])((__WEBPACK_IMPORTED_MODULE_0__math_js__["l" /* halfPi */] + phi) / 2))];
}

mercatorRaw.invert = function(x, y) {
  return [x, 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["d" /* atan */])(Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["k" /* exp */])(y)) - __WEBPACK_IMPORTED_MODULE_0__math_js__["l" /* halfPi */]];
};

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return mercatorProjection(mercatorRaw)
      .scale(961 / __WEBPACK_IMPORTED_MODULE_0__math_js__["w" /* tau */]);
});

function mercatorProjection(project) {
  var m = Object(__WEBPACK_IMPORTED_MODULE_2__index_js__["a" /* default */])(project),
      center = m.center,
      scale = m.scale,
      translate = m.translate,
      clipExtent = m.clipExtent,
      x0 = null, y0, x1, y1; // clip extent

  m.scale = function(_) {
    return arguments.length ? (scale(_), reclip()) : scale();
  };

  m.translate = function(_) {
    return arguments.length ? (translate(_), reclip()) : translate();
  };

  m.center = function(_) {
    return arguments.length ? (center(_), reclip()) : center();
  };

  m.clipExtent = function(_) {
    return arguments.length ? ((_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1])), reclip()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };

  function reclip() {
    var k = __WEBPACK_IMPORTED_MODULE_0__math_js__["o" /* pi */] * scale(),
        t = m(Object(__WEBPACK_IMPORTED_MODULE_1__rotation_js__["a" /* default */])(m.rotate()).invert([0, 0]));
    return clipExtent(x0 == null
        ? [[t[0] - k, t[1] - k], [t[0] + k, t[1] + k]] : project === mercatorRaw
        ? [[Math.max(t[0] - k, x0), y0], [Math.min(t[0] + k, x1), y1]]
        : [[x0, Math.max(t[1] - k, y0)], [x1, Math.min(t[1] + k, y1)]]);
  }

  return reclip();
}


/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__series_abstract_series__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__decorative_axis_ticks__ = __webpack_require__(2245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__animation__ = __webpack_require__(53);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.









var predefinedClassName = 'rv-xy-manipulable-axis rv-xy-plot__axis';

var animatedProps = ['xRange', 'yRange', 'xDomain', 'yDomain', 'width', 'height', 'marginLeft', 'marginTop', 'marginRight', 'marginBottom', 'tickSize', 'tickTotal', 'tickSizeInner', 'tickSizeOuter'];

var DecorativeAxis = function (_AbstractSeries) {
  _inherits(DecorativeAxis, _AbstractSeries);

  function DecorativeAxis() {
    _classCallCheck(this, DecorativeAxis);

    return _possibleConstructorReturn(this, (DecorativeAxis.__proto__ || Object.getPrototypeOf(DecorativeAxis)).apply(this, arguments));
  }

  _createClass(DecorativeAxis, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          animation = _props.animation,
          className = _props.className,
          marginLeft = _props.marginLeft,
          marginTop = _props.marginTop,
          axisStart = _props.axisStart,
          axisEnd = _props.axisEnd,
          axisDomain = _props.axisDomain,
          numberOfTicks = _props.numberOfTicks,
          tickValue = _props.tickValue,
          tickSize = _props.tickSize,
          style = _props.style;


      if (animation) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__animation__["b" /* default */],
          _extends({}, this.props, { animatedProps: animatedProps }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DecorativeAxis, _extends({}, this.props, { animation: null }))
        );
      }

      var x = this._getAttributeFunctor('x');
      var y = this._getAttributeFunctor('y');

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        {
          className: predefinedClassName + ' ' + className,
          transform: 'translate(' + marginLeft + ',' + marginTop + ')'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line', _extends({}, _extends({
          x1: x({ x: axisStart.x }),
          x2: x({ x: axisEnd.x }),
          y1: y({ y: axisStart.y }),
          y2: y({ y: axisEnd.y })
        }, style.line), {
          className: 'rv-xy-plot__axis__line'
        })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          { className: 'rv-xy-manipulable-axis__ticks' },
          Object(__WEBPACK_IMPORTED_MODULE_4__decorative_axis_ticks__["a" /* default */])({
            axisDomain: axisDomain,
            axisEnd: { x: x(axisEnd), y: y(axisEnd) },
            axisStart: { x: x(axisStart), y: y(axisStart) },
            numberOfTicks: numberOfTicks,
            tickValue: tickValue,
            tickSize: tickSize,
            style: style
          })
        )
      );
    }
  }]);

  return DecorativeAxis;
}(__WEBPACK_IMPORTED_MODULE_3__series_abstract_series__["a" /* default */]);

var DEFAULT_FORMAT = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["a" /* format */])('.2r');

DecorativeAxis.defaultProps = {
  className: '',
  numberOfTicks: 10,
  tickValue: function tickValue(d) {
    return DEFAULT_FORMAT(d);
  },
  tickSize: 5,
  style: {
    line: {
      strokeWidth: 1
    },
    ticks: {
      strokeWidth: 2
    },
    text: {}
  }
};
DecorativeAxis.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_3__series_abstract_series__["a" /* default */].propTypes, {
  axisDomain: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number).isRequired,
  axisEnd: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
    y: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string])
  }).isRequired,
  axisStart: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
    y: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string])
  }).isRequired,
  className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  numberOfTicks: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  tickValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  tickSize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  style: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    line: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    ticks: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    text: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  })
});
DecorativeAxis.displayName = 'DecorativeAxis';
/* harmony default export */ __webpack_exports__["a"] = (DecorativeAxis);

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_scales_utils__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__animation__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_axis_utils__ = __webpack_require__(82);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.










var VERTICAL = __WEBPACK_IMPORTED_MODULE_4__utils_axis_utils__["a" /* DIRECTION */].VERTICAL,
    HORIZONTAL = __WEBPACK_IMPORTED_MODULE_4__utils_axis_utils__["a" /* DIRECTION */].HORIZONTAL;


var propTypes = {
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([VERTICAL, HORIZONTAL]),
  attr: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  left: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  tickValues: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])),
  tickTotal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  animation: __WEBPACK_IMPORTED_MODULE_3__animation__["a" /* AnimationPropType */],

  // generally supplied by xyplot
  marginTop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  marginBottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  marginLeft: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  marginRight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  innerWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  innerHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

var defaultProps = {
  direction: VERTICAL
};

var animatedProps = ['xRange', 'yRange', 'xDomain', 'yDomain', 'width', 'height', 'marginLeft', 'marginTop', 'marginRight', 'marginBottom', 'tickTotal'];

var GridLines = function (_PureComponent) {
  _inherits(GridLines, _PureComponent);

  function GridLines() {
    _classCallCheck(this, GridLines);

    return _possibleConstructorReturn(this, (GridLines.__proto__ || Object.getPrototypeOf(GridLines)).apply(this, arguments));
  }

  _createClass(GridLines, [{
    key: '_getDefaultProps',
    value: function _getDefaultProps() {
      var _props = this.props,
          innerWidth = _props.innerWidth,
          innerHeight = _props.innerHeight,
          marginTop = _props.marginTop,
          marginLeft = _props.marginLeft,
          direction = _props.direction;

      return {
        left: marginLeft,
        top: marginTop,
        width: innerWidth,
        height: innerHeight,
        tickTotal: Object(__WEBPACK_IMPORTED_MODULE_4__utils_axis_utils__["f" /* getTicksTotalFromSize */])(direction === VERTICAL ? innerWidth : innerHeight)
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          animation = _props2.animation,
          className = _props2.className;

      if (animation) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__animation__["b" /* default */],
          _extends({}, this.props, { animatedProps: animatedProps }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GridLines, _extends({}, this.props, { animation: null }))
        );
      }

      var props = _extends({}, this._getDefaultProps(), this.props);

      var attr = props.attr,
          direction = props.direction,
          width = props.width,
          height = props.height,
          style = props.style,
          tickTotal = props.tickTotal,
          tickValues = props.tickValues,
          top = props.top,
          left = props.left;

      var isVertical = direction === VERTICAL;
      var tickXAttr = isVertical ? 'y' : 'x';
      var tickYAttr = isVertical ? 'x' : 'y';
      var length = isVertical ? height : width;

      var scale = Object(__WEBPACK_IMPORTED_MODULE_2__utils_scales_utils__["d" /* getAttributeScale */])(props, attr);
      var values = Object(__WEBPACK_IMPORTED_MODULE_4__utils_axis_utils__["e" /* getTickValues */])(scale, tickTotal, tickValues);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        {
          transform: 'translate(' + left + ',' + top + ')',
          className: 'rv-xy-plot__grid-lines ' + className
        },
        values.map(function (v, i) {
          var _pathProps;

          var pos = scale(v);
          var pathProps = (_pathProps = {}, _defineProperty(_pathProps, tickYAttr + '1', pos), _defineProperty(_pathProps, tickYAttr + '2', pos), _defineProperty(_pathProps, tickXAttr + '1', 0), _defineProperty(_pathProps, tickXAttr + '2', length), _pathProps);
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line', _extends({}, pathProps, {
            key: i,
            className: 'rv-xy-plot__grid-lines__line',
            style: style
          }));
        })
      );
    }
  }]);

  return GridLines;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

GridLines.displayName = 'GridLines';
GridLines.defaultProps = defaultProps;
GridLines.propTypes = propTypes;
GridLines.requiresSVG = true;

/* harmony default export */ __webpack_exports__["a"] = (GridLines);

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__animation__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_series_utils__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__abstract_series__ = __webpack_require__(48);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.










var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--rect';

var RectSeries = function (_AbstractSeries) {
  _inherits(RectSeries, _AbstractSeries);

  function RectSeries() {
    _classCallCheck(this, RectSeries);

    return _possibleConstructorReturn(this, (RectSeries.__proto__ || Object.getPrototypeOf(RectSeries)).apply(this, arguments));
  }

  _createClass(RectSeries, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          animation = _props.animation,
          className = _props.className,
          data = _props.data,
          linePosAttr = _props.linePosAttr,
          lineSizeAttr = _props.lineSizeAttr,
          marginLeft = _props.marginLeft,
          marginTop = _props.marginTop,
          style = _props.style,
          valuePosAttr = _props.valuePosAttr,
          valueSizeAttr = _props.valueSizeAttr;


      if (!data) {
        return null;
      }

      if (animation) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__animation__["b" /* default */],
          _extends({}, this.props, { animatedProps: __WEBPACK_IMPORTED_MODULE_3__utils_series_utils__["a" /* ANIMATED_SERIES_PROPS */] }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RectSeries, _extends({}, this.props, { animation: null }))
        );
      }

      var lineFunctor = this._getAttributeFunctor(linePosAttr);
      var line0Functor = this._getAttr0Functor(linePosAttr);
      var valueFunctor = this._getAttributeFunctor(valuePosAttr);
      var value0Functor = this._getAttr0Functor(valuePosAttr);
      var fillFunctor = this._getAttributeFunctor('fill') || this._getAttributeFunctor('color');
      var strokeFunctor = this._getAttributeFunctor('stroke') || this._getAttributeFunctor('color');
      var opacityFunctor = this._getAttributeFunctor('opacity');

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        {
          className: predefinedClassName + ' ' + className,
          transform: 'translate(' + marginLeft + ',' + marginTop + ')'
        },
        data.map(function (d, i) {
          var _attrs;

          var attrs = (_attrs = {
            style: _extends({
              opacity: opacityFunctor && opacityFunctor(d),
              stroke: strokeFunctor && strokeFunctor(d),
              fill: fillFunctor && fillFunctor(d)
            }, style)
          }, _defineProperty(_attrs, linePosAttr, line0Functor(d)), _defineProperty(_attrs, lineSizeAttr, Math.abs(lineFunctor(d) - line0Functor(d))), _defineProperty(_attrs, valuePosAttr, Math.min(value0Functor(d), valueFunctor(d))), _defineProperty(_attrs, valueSizeAttr, Math.abs(-value0Functor(d) + valueFunctor(d))), _defineProperty(_attrs, 'onClick', function onClick(e) {
            return _this2._valueClickHandler(d, e);
          }), _defineProperty(_attrs, 'onContextMenu', function onContextMenu(e) {
            return _this2._valueRightClickHandler(d, e);
          }), _defineProperty(_attrs, 'onMouseOver', function onMouseOver(e) {
            return _this2._valueMouseOverHandler(d, e);
          }), _defineProperty(_attrs, 'onMouseOut', function onMouseOut(e) {
            return _this2._valueMouseOutHandler(d, e);
          }), _defineProperty(_attrs, 'key', i), _attrs);
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', attrs);
        })
      );
    }
  }], [{
    key: 'propTypes',
    get: function get() {
      return _extends({}, __WEBPACK_IMPORTED_MODULE_4__abstract_series__["a" /* default */].propTypes, {
        linePosAttr: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        valuePosAttr: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        lineSizeAttr: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        valueSizeAttr: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
      });
    }
  }]);

  return RectSeries;
}(__WEBPACK_IMPORTED_MODULE_4__abstract_series__["a" /* default */]);

RectSeries.displayName = 'RectSeries';

/* harmony default export */ __webpack_exports__["a"] = (RectSeries);

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_color__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__theme__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__abstract_series__ = __webpack_require__(48);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.







var RectSeriesCanvas = function (_AbstractSeries) {
  _inherits(RectSeriesCanvas, _AbstractSeries);

  function RectSeriesCanvas() {
    _classCallCheck(this, RectSeriesCanvas);

    return _possibleConstructorReturn(this, (RectSeriesCanvas.__proto__ || Object.getPrototypeOf(RectSeriesCanvas)).apply(this, arguments));
  }

  _createClass(RectSeriesCanvas, [{
    key: 'render',
    value: function render() {
      return null;
    }
  }], [{
    key: 'renderLayer',
    value: function renderLayer(props, ctx) {
      var data = props.data,
          linePosAttr = props.linePosAttr,
          lineSizeAttr = props.lineSizeAttr,
          marginLeft = props.marginLeft,
          marginTop = props.marginTop,
          valuePosAttr = props.valuePosAttr;

      if (!data || data.length === 0) {
        return;
      }

      var line = Object(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["c" /* getAttributeFunctor */])(props, linePosAttr);
      var line0 = Object(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["b" /* getAttr0Functor */])(props, linePosAttr);
      var value = Object(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["c" /* getAttributeFunctor */])(props, valuePosAttr);
      var value0 = Object(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["b" /* getAttr0Functor */])(props, valuePosAttr);
      var fill = Object(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["c" /* getAttributeFunctor */])(props, 'fill') || Object(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["c" /* getAttributeFunctor */])(props, 'color');
      var stroke = Object(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["c" /* getAttributeFunctor */])(props, 'stroke') || Object(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["c" /* getAttributeFunctor */])(props, 'color');
      var opacity = Object(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["c" /* getAttributeFunctor */])(props, 'opacity');

      data.forEach(function (row) {
        var fillColor = Object(__WEBPACK_IMPORTED_MODULE_1_d3_color__["f" /* rgb */])(fill(row));
        var strokeColor = Object(__WEBPACK_IMPORTED_MODULE_1_d3_color__["f" /* rgb */])(stroke(row));
        var rowOpacity = opacity(row) || __WEBPACK_IMPORTED_MODULE_2__theme__["c" /* DEFAULT_OPACITY */];

        var linePos = line0(row);
        var valuePos = Math.min(value0(row), value(row));
        var x = valuePosAttr === 'x' ? valuePos : linePos;
        var y = valuePosAttr === 'y' ? valuePos : linePos;

        var lineSize = Math.abs(line(row) - line0(row));
        var valueSize = Math.abs(-value0(row) + value(row));
        var height = lineSizeAttr === 'height' ? lineSize : valueSize;
        var width = lineSizeAttr === 'width' ? lineSize : valueSize;

        ctx.beginPath();
        ctx.rect(x + marginLeft, y + marginTop, width, height);
        ctx.fillStyle = 'rgba(' + fillColor.r + ', ' + fillColor.g + ', ' + fillColor.b + ', ' + rowOpacity + ')';
        ctx.fill();
        ctx.strokeStyle = 'rgba(' + strokeColor.r + ', ' + strokeColor.g + ', ' + strokeColor.b + ', ' + rowOpacity + ')';
        ctx.stroke();
      });
    }
  }, {
    key: 'requiresSVG',
    get: function get() {
      return false;
    }
  }, {
    key: 'isCanvas',
    get: function get() {
      return true;
    }
  }]);

  return RectSeriesCanvas;
}(__WEBPACK_IMPORTED_MODULE_4__abstract_series__["a" /* default */]);

RectSeriesCanvas.displayName = 'RectSeriesCanvas';
RectSeriesCanvas.defaultProps = _extends({}, __WEBPACK_IMPORTED_MODULE_4__abstract_series__["a" /* default */].defaultProps, {
  linePosAttr: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  valuePosAttr: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  lineSizeAttr: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  valueSizeAttr: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
});

RectSeriesCanvas.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_4__abstract_series__["a" /* default */].propTypes);

/* harmony default export */ __webpack_exports__["a"] = (RectSeriesCanvas);

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_shape__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__animation__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__theme__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_series_utils__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_react_utils__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__abstract_series__ = __webpack_require__(48);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.












var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--line';

var STROKE_STYLES = {
  dashed: '6, 2',
  solid: null
};

var LineSeries = function (_AbstractSeries) {
  _inherits(LineSeries, _AbstractSeries);

  function LineSeries() {
    _classCallCheck(this, LineSeries);

    return _possibleConstructorReturn(this, (LineSeries.__proto__ || Object.getPrototypeOf(LineSeries)).apply(this, arguments));
  }

  _createClass(LineSeries, [{
    key: '_renderLine',
    value: function _renderLine(data, x, y, curve, getNull) {
      var line = __WEBPACK_IMPORTED_MODULE_2_d3_shape__["line"]();
      if (curve !== null) {
        if (typeof curve === 'string' && __WEBPACK_IMPORTED_MODULE_2_d3_shape__[curve]) {
          line = line.curve(__WEBPACK_IMPORTED_MODULE_2_d3_shape__[curve]);
        } else if (typeof curve === 'function') {
          line = line.curve(curve);
        }
      }
      line = line.defined(getNull);
      line = line.x(x).y(y);
      return line(data);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          animation = _props.animation,
          className = _props.className,
          data = _props.data;


      if (this.props.nullAccessor) {
        Object(__WEBPACK_IMPORTED_MODULE_6__utils_react_utils__["b" /* warning */])('nullAccessor has been renamed to getNull', true);
      }

      if (!data) {
        return null;
      }

      if (animation) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__animation__["b" /* default */],
          _extends({}, this.props, { animatedProps: __WEBPACK_IMPORTED_MODULE_5__utils_series_utils__["a" /* ANIMATED_SERIES_PROPS */] }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LineSeries, _extends({}, this.props, { animation: null }))
        );
      }

      var _props2 = this.props,
          curve = _props2.curve,
          marginLeft = _props2.marginLeft,
          marginTop = _props2.marginTop,
          strokeDasharray = _props2.strokeDasharray,
          strokeStyle = _props2.strokeStyle,
          strokeWidth = _props2.strokeWidth,
          style = _props2.style;


      var x = this._getAttributeFunctor('x');
      var y = this._getAttributeFunctor('y');
      var stroke = this._getAttributeValue('stroke') || this._getAttributeValue('color');
      var newOpacity = this._getAttributeValue('opacity');
      var opacity = Number.isFinite(newOpacity) ? newOpacity : __WEBPACK_IMPORTED_MODULE_4__theme__["c" /* DEFAULT_OPACITY */];
      var getNull = this.props.nullAccessor || this.props.getNull;
      var d = this._renderLine(data, x, y, curve, getNull);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
        d: d,
        className: predefinedClassName + ' ' + className,
        transform: 'translate(' + marginLeft + ',' + marginTop + ')',
        onMouseOver: this._seriesMouseOverHandler,
        onMouseOut: this._seriesMouseOutHandler,
        onClick: this._seriesClickHandler,
        onContextMenu: this._seriesRightClickHandler,
        style: _extends({
          opacity: opacity,
          strokeDasharray: STROKE_STYLES[strokeStyle] || strokeDasharray,
          strokeWidth: strokeWidth,
          stroke: stroke
        }, style)
      });
    }
  }]);

  return LineSeries;
}(__WEBPACK_IMPORTED_MODULE_7__abstract_series__["a" /* default */]);

LineSeries.displayName = 'LineSeries';
LineSeries.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_7__abstract_series__["a" /* default */].propTypes, {
  strokeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(Object.keys(STROKE_STYLES)),
  curve: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  getNull: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
});
LineSeries.defaultProps = _extends({}, __WEBPACK_IMPORTED_MODULE_7__abstract_series__["a" /* default */].defaultProps, {
  strokeStyle: 'solid',
  style: {},
  opacity: 1,
  curve: null,
  className: '',
  getNull: function getNull() {
    return true;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (LineSeries);

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__animation__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_series_utils__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__abstract_series__ = __webpack_require__(48);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.








var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--polygon';
var DEFAULT_COLOR = '#12939A';

var generatePath = function generatePath(data, xFunctor, yFunctor) {
  return data.reduce(function (res, row, i) {
    return res + ' ' + (i ? 'L' : 'M') + xFunctor(row) + ' ' + yFunctor(row);
  }, '') + ' Z';
};

var PolygonSeries = function (_AbstractSeries) {
  _inherits(PolygonSeries, _AbstractSeries);

  function PolygonSeries() {
    _classCallCheck(this, PolygonSeries);

    return _possibleConstructorReturn(this, (PolygonSeries.__proto__ || Object.getPrototypeOf(PolygonSeries)).apply(this, arguments));
  }

  _createClass(PolygonSeries, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          animation = _props.animation,
          color = _props.color,
          className = _props.className,
          data = _props.data,
          marginLeft = _props.marginLeft,
          marginTop = _props.marginTop,
          style = _props.style;


      if (!data) {
        return null;
      }

      if (animation) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1__animation__["b" /* default */],
          _extends({}, this.props, { animatedProps: __WEBPACK_IMPORTED_MODULE_2__utils_series_utils__["a" /* ANIMATED_SERIES_PROPS */] }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PolygonSeries, _extends({}, this.props, { animation: null }))
        );
      }
      var xFunctor = this._getAttributeFunctor('x');
      var yFunctor = this._getAttributeFunctor('y');

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
        className: predefinedClassName + ' ' + className,
        onMouseOver: function onMouseOver(e) {
          return _this2._seriesMouseOverHandler(data, e);
        },
        onMouseOut: function onMouseOut(e) {
          return _this2._seriesMouseOutHandler(data, e);
        },
        onClick: this._seriesClickHandler,
        onContextMenu: this._seriesRightClickHandler,
        fill: color || DEFAULT_COLOR,
        style: style,
        d: generatePath(data, xFunctor, yFunctor),
        transform: 'translate(' + marginLeft + ',' + marginTop + ')'
      });
    }
  }], [{
    key: 'propTypes',
    get: function get() {
      return _extends({}, __WEBPACK_IMPORTED_MODULE_3__abstract_series__["a" /* default */].propTypes);
    }
  }]);

  return PolygonSeries;
}(__WEBPACK_IMPORTED_MODULE_3__abstract_series__["a" /* default */]);

PolygonSeries.displayName = 'PolygonSeries';

/* harmony default export */ __webpack_exports__["a"] = (PolygonSeries);

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasSymbols = __webpack_require__(628);

module.exports = function hasToStringTagShams() {
	return hasSymbols() && !!Symbol.toStringTag;
};


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(2266)();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(374);
var hasOwn = __webpack_require__(2268);
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(2267);

module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(374);
var GetIntrinsic = __webpack_require__(373);

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(bind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = hierarchy;
/* harmony export (immutable) */ __webpack_exports__["b"] = computeHeight;
/* harmony export (immutable) */ __webpack_exports__["a"] = Node;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__count_js__ = __webpack_require__(2298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__each_js__ = __webpack_require__(2299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eachBefore_js__ = __webpack_require__(2300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eachAfter_js__ = __webpack_require__(2301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sum_js__ = __webpack_require__(2302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sort_js__ = __webpack_require__(2303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__path_js__ = __webpack_require__(2304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ancestors_js__ = __webpack_require__(2305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__descendants_js__ = __webpack_require__(2306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__leaves_js__ = __webpack_require__(2307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__links_js__ = __webpack_require__(2308);












function hierarchy(data, children) {
  var root = new Node(data),
      valued = +data.value && (root.value = data.value),
      node,
      nodes = [root],
      child,
      childs,
      i,
      n;

  if (children == null) children = defaultChildren;

  while (node = nodes.pop()) {
    if (valued) node.value = +node.data.value;
    if ((childs = children(node.data)) && (n = childs.length)) {
      node.children = new Array(n);
      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = node.children[i] = new Node(childs[i]));
        child.parent = node;
        child.depth = node.depth + 1;
      }
    }
  }

  return root.eachBefore(computeHeight);
}

function node_copy() {
  return hierarchy(this).eachBefore(copyData);
}

function defaultChildren(d) {
  return d.children;
}

function copyData(node) {
  node.data = node.data.data;
}

function computeHeight(node) {
  var height = 0;
  do node.height = height;
  while ((node = node.parent) && (node.height < ++height));
}

function Node(data) {
  this.data = data;
  this.depth =
  this.height = 0;
  this.parent = null;
}

Node.prototype = hierarchy.prototype = {
  constructor: Node,
  count: __WEBPACK_IMPORTED_MODULE_0__count_js__["a" /* default */],
  each: __WEBPACK_IMPORTED_MODULE_1__each_js__["a" /* default */],
  eachAfter: __WEBPACK_IMPORTED_MODULE_3__eachAfter_js__["a" /* default */],
  eachBefore: __WEBPACK_IMPORTED_MODULE_2__eachBefore_js__["a" /* default */],
  sum: __WEBPACK_IMPORTED_MODULE_4__sum_js__["a" /* default */],
  sort: __WEBPACK_IMPORTED_MODULE_5__sort_js__["a" /* default */],
  path: __WEBPACK_IMPORTED_MODULE_6__path_js__["a" /* default */],
  ancestors: __WEBPACK_IMPORTED_MODULE_7__ancestors_js__["a" /* default */],
  descendants: __WEBPACK_IMPORTED_MODULE_8__descendants_js__["a" /* default */],
  leaves: __WEBPACK_IMPORTED_MODULE_9__leaves_js__["a" /* default */],
  links: __WEBPACK_IMPORTED_MODULE_10__links_js__["a" /* default */],
  copy: node_copy
};


/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = optional;
/* harmony export (immutable) */ __webpack_exports__["b"] = required;
function optional(f) {
  return f == null ? null : required(f);
}

function required(f) {
  if (typeof f !== "function") throw new Error;
  return f;
}


/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return phi; });
/* harmony export (immutable) */ __webpack_exports__["c"] = squarifyRatio;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dice_js__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slice_js__ = __webpack_require__(266);



var phi = (1 + Math.sqrt(5)) / 2;

function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
  var rows = [],
      nodes = parent.children,
      row,
      nodeValue,
      i0 = 0,
      i1 = 0,
      n = nodes.length,
      dx, dy,
      value = parent.value,
      sumValue,
      minValue,
      maxValue,
      newRatio,
      minRatio,
      alpha,
      beta;

  while (i0 < n) {
    dx = x1 - x0, dy = y1 - y0;

    // Find the next non-empty node.
    do sumValue = nodes[i1++].value; while (!sumValue && i1 < n);
    minValue = maxValue = sumValue;
    alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
    beta = sumValue * sumValue * alpha;
    minRatio = Math.max(maxValue / beta, beta / minValue);

    // Keep adding nodes while the aspect ratio maintains or improves.
    for (; i1 < n; ++i1) {
      sumValue += nodeValue = nodes[i1].value;
      if (nodeValue < minValue) minValue = nodeValue;
      if (nodeValue > maxValue) maxValue = nodeValue;
      beta = sumValue * sumValue * alpha;
      newRatio = Math.max(maxValue / beta, beta / minValue);
      if (newRatio > minRatio) { sumValue -= nodeValue; break; }
      minRatio = newRatio;
    }

    // Position and record the row orientation.
    rows.push(row = {value: sumValue, dice: dx < dy, children: nodes.slice(i0, i1)});
    if (row.dice) Object(__WEBPACK_IMPORTED_MODULE_0__dice_js__["a" /* default */])(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
    else Object(__WEBPACK_IMPORTED_MODULE_1__slice_js__["a" /* default */])(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
    value -= sumValue, i0 = i1;
  }

  return rows;
}

/* harmony default export */ __webpack_exports__["a"] = ((function custom(ratio) {

  function squarify(parent, x0, y0, x1, y1) {
    squarifyRatio(ratio, parent, x0, y0, x1, y1);
  }

  squarify.ratio = function(x) {
    return custom((x = +x) > 1 ? x : 1);
  };

  return squarify;
})(phi));


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(380);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 380 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(382);
var global = __webpack_require__(136);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(655) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 382 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 383 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 384 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(2477);
var defined = __webpack_require__(657);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(136);
var hide = __webpack_require__(165);
var has = __webpack_require__(269);
var SRC = __webpack_require__(383)('src');
var $toString = __webpack_require__(2481);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(382).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(381)('keys');
var uid = __webpack_require__(383);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(667);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = valueFromASTUntyped;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsutils_keyValMap__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsutils_isInvalid__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__language_kinds__ = __webpack_require__(57);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */







/**
 * Produces a JavaScript value given a GraphQL Value AST.
 *
 * Unlike `valueFromAST()`, no type is provided. The resulting JavaScript value
 * will reflect the provided GraphQL value AST.
 *
 * | GraphQL Value        | JavaScript Value |
 * | -------------------- | ---------------- |
 * | Input Object         | Object           |
 * | List                 | Array            |
 * | Boolean              | Boolean          |
 * | String / Enum        | String           |
 * | Int / Float          | Number           |
 * | Null                 | null             |
 *
 */
function valueFromASTUntyped(valueNode, variables) {
  switch (valueNode.kind) {
    case __WEBPACK_IMPORTED_MODULE_2__language_kinds__["a" /* Kind */].NULL:
      return null;
    case __WEBPACK_IMPORTED_MODULE_2__language_kinds__["a" /* Kind */].INT:
      return parseInt(valueNode.value, 10);
    case __WEBPACK_IMPORTED_MODULE_2__language_kinds__["a" /* Kind */].FLOAT:
      return parseFloat(valueNode.value);
    case __WEBPACK_IMPORTED_MODULE_2__language_kinds__["a" /* Kind */].STRING:
    case __WEBPACK_IMPORTED_MODULE_2__language_kinds__["a" /* Kind */].ENUM:
    case __WEBPACK_IMPORTED_MODULE_2__language_kinds__["a" /* Kind */].BOOLEAN:
      return valueNode.value;
    case __WEBPACK_IMPORTED_MODULE_2__language_kinds__["a" /* Kind */].LIST:
      return valueNode.values.map(function (node) {
        return valueFromASTUntyped(node, variables);
      });
    case __WEBPACK_IMPORTED_MODULE_2__language_kinds__["a" /* Kind */].OBJECT:
      return Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_keyValMap__["a" /* default */])(valueNode.fields, function (field) {
        return field.name.value;
      }, function (field) {
        return valueFromASTUntyped(field.value, variables);
      });
    case __WEBPACK_IMPORTED_MODULE_2__language_kinds__["a" /* Kind */].VARIABLE:
      var variableName = valueNode.name.value;
      return variables && !Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_isInvalid__["a" /* default */])(variables[variableName]) ? variables[variableName] : undefined;
  }
  /* istanbul ignore next */
  throw new Error('Unexpected value kind: ' + valueNode.kind);
}

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = printError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__language_location__ = __webpack_require__(274);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */




/**
 * Prints a GraphQLError to a string, representing useful location information
 * about the error's position in the source.
 */
function printError(error) {
  var printedLocations = [];
  if (error.nodes) {
    error.nodes.forEach(function (node) {
      if (node.loc) {
        printedLocations.push(highlightSourceAtLocation(node.loc.source, Object(__WEBPACK_IMPORTED_MODULE_0__language_location__["a" /* getLocation */])(node.loc.source, node.loc.start)));
      }
    });
  } else if (error.source && error.locations) {
    var source = error.source;
    error.locations.forEach(function (location) {
      printedLocations.push(highlightSourceAtLocation(source, location));
    });
  }
  return printedLocations.length === 0 ? error.message : [error.message].concat(printedLocations).join('\n\n') + '\n';
}

/**
 * Render a helpful description of the location of the error in the GraphQL
 * Source document.
 */
function highlightSourceAtLocation(source, location) {
  var line = location.line;
  var lineOffset = source.locationOffset.line - 1;
  var columnOffset = getColumnOffset(source, location);
  var contextLine = line + lineOffset;
  var contextColumn = location.column + columnOffset;
  var prevLineNum = (contextLine - 1).toString();
  var lineNum = contextLine.toString();
  var nextLineNum = (contextLine + 1).toString();
  var padLen = nextLineNum.length;
  var lines = source.body.split(/\r\n|[\n\r]/g);
  lines[0] = whitespace(source.locationOffset.column - 1) + lines[0];
  var outputLines = [source.name + ' (' + contextLine + ':' + contextColumn + ')', line >= 2 && lpad(padLen, prevLineNum) + ': ' + lines[line - 2], lpad(padLen, lineNum) + ': ' + lines[line - 1], whitespace(2 + padLen + contextColumn - 1) + '^', line < lines.length && lpad(padLen, nextLineNum) + ': ' + lines[line]];
  return outputLines.filter(Boolean).join('\n');
}

function getColumnOffset(source, location) {
  return location.line === 1 ? source.locationOffset.column - 1 : 0;
}

function whitespace(len) {
  return Array(len + 1).join(' ');
}

function lpad(len, str) {
  return whitespace(len - str.length) + str;
}

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export assertValidName */
/* harmony export (immutable) */ __webpack_exports__["a"] = isValidNameError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsutils_invariant__ = __webpack_require__(79);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */





var NAME_RX = /^[_a-zA-Z][_a-zA-Z0-9]*$/;

/**
 * Upholds the spec rules about naming.
 */
function assertValidName(name) {
  var error = isValidNameError(name);
  if (error) {
    throw error;
  }
  return name;
}

/**
 * Returns an Error if a name is invalid.
 */
function isValidNameError(name, node) {
  !(typeof name === 'string') ? Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant__["a" /* default */])(0, 'Expected string') : void 0;
  if (name.length > 1 && name[0] === '_' && name[1] === '_') {
    return new __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError__["a" /* GraphQLError */]('Name "' + name + '" must not begin with "__", which is reserved by ' + 'GraphQL introspection.', node);
  }
  if (!NAME_RX.test(name)) {
    return new __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError__["a" /* GraphQLError */]('Names must match /^[_a-zA-Z][_a-zA-Z0-9]*$/ but "' + name + '" does not.', node);
  }
}

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Source; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsutils_invariant__ = __webpack_require__(79);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */



/**
 * A representation of source input to GraphQL.
 * `name` and `locationOffset` are optional. They are useful for clients who
 * store GraphQL documents in source files; for example, if the GraphQL input
 * starts at line 40 in a file named Foo.graphql, it might be useful for name to
 * be "Foo.graphql" and location to be `{ line: 40, column: 0 }`.
 * line and column in locationOffset are 1-indexed
 */
var Source = function Source(body, name, locationOffset) {
  _classCallCheck(this, Source);

  this.body = body;
  this.name = name || 'GraphQL request';
  this.locationOffset = locationOffset || { line: 1, column: 1 };
  !(this.locationOffset.line > 0) ? Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_invariant__["a" /* default */])(0, 'line in locationOffset is 1-indexed and must be positive') : void 0;
  !(this.locationOffset.column > 0) ? Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_invariant__["a" /* default */])(0, 'column in locationOffset is 1-indexed and must be positive') : void 0;
};

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = locatedError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GraphQLError__ = __webpack_require__(106);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */




/**
 * Given an arbitrary Error, presumably thrown while attempting to execute a
 * GraphQL operation, produce a new GraphQLError aware of the location in the
 * document responsible for the original Error.
 */
function locatedError(originalError, nodes, path) {
  // Note: this uses a brand-check to support GraphQL errors originating from
  // other contexts.
  // $FlowFixMe(>=0.68.0)
  if (originalError && Array.isArray(originalError.path)) {
    return originalError;
  }

  return new __WEBPACK_IMPORTED_MODULE_0__GraphQLError__["a" /* GraphQLError */](originalError && originalError.message, originalError && originalError.nodes || nodes, originalError && originalError.source, originalError && originalError.positions, path, originalError);
}

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = blockStringValue;
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Produces the value of a block string from its parsed raw value, similar to
 * Coffeescript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 */
function blockStringValue(rawString) {
  // Expand a block string's raw value into independent lines.
  var lines = rawString.split(/\r\n|[\n\r]/g);

  // Remove common indentation from all lines but first.
  var commonIndent = null;
  for (var i = 1; i < lines.length; i++) {
    var line = lines[i];
    var indent = leadingWhitespace(line);
    if (indent < line.length && (commonIndent === null || indent < commonIndent)) {
      commonIndent = indent;
      if (commonIndent === 0) {
        break;
      }
    }
  }

  if (commonIndent) {
    for (var _i = 1; _i < lines.length; _i++) {
      lines[_i] = lines[_i].slice(commonIndent);
    }
  }

  // Remove leading and trailing blank lines.
  while (lines.length > 0 && isBlank(lines[0])) {
    lines.shift();
  }
  while (lines.length > 0 && isBlank(lines[lines.length - 1])) {
    lines.pop();
  }

  // Return a string of the lines joined with U+000A.
  return lines.join('\n');
}

function leadingWhitespace(str) {
  var i = 0;
  while (i < str.length && (str[i] === ' ' || str[i] === '\t')) {
    i++;
  }
  return i;
}

function isBlank(str) {
  return leadingWhitespace(str) === str.length;
}

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsutils_invariant__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__language_visitor__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__type_schema__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__type_validate__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_TypeInfo__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__specifiedRules__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ValidationContext__ = __webpack_require__(279);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */











/**
 * Implements the "Validation" section of the spec.
 *
 * Validation runs synchronously, returning an array of encountered errors, or
 * an empty array if no errors were encountered and the document is valid.
 *
 * A list of specific validation rules may be provided. If not provided, the
 * default list of rules defined by the GraphQL specification will be used.
 *
 * Each validation rules is a function which returns a visitor
 * (see the language/visitor API). Visitor methods are expected to return
 * GraphQLErrors, or Arrays of GraphQLErrors when invalid.
 *
 * Optionally a custom TypeInfo instance may be provided. If not provided, one
 * will be created from the provided schema.
 */
function validate(schema, ast, rules, typeInfo) {
  !ast ? Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_invariant__["a" /* default */])(0, 'Must provide document') : void 0;
  // If the schema used for validation is invalid, throw an error.
  Object(__WEBPACK_IMPORTED_MODULE_4__type_validate__["a" /* assertValidSchema */])(schema);
  return visitUsingRules(schema, typeInfo || new __WEBPACK_IMPORTED_MODULE_5__utilities_TypeInfo__["a" /* TypeInfo */](schema), ast, rules || __WEBPACK_IMPORTED_MODULE_6__specifiedRules__["a" /* specifiedRules */]);
}

/**
 * This uses a specialized visitor which runs multiple visitors in parallel,
 * while maintaining the visitor skip and break API.
 *
 * @internal
 */
function visitUsingRules(schema, typeInfo, documentAST, rules) {
  var context = new __WEBPACK_IMPORTED_MODULE_7__ValidationContext__["a" /* default */](schema, documentAST, typeInfo);
  var visitors = rules.map(function (rule) {
    return rule(context);
  });
  // Visit the whole document with each instance of all provided rules.
  Object(__WEBPACK_IMPORTED_MODULE_2__language_visitor__["b" /* visit */])(documentAST, Object(__WEBPACK_IMPORTED_MODULE_2__language_visitor__["d" /* visitWithTypeInfo */])(typeInfo, Object(__WEBPACK_IMPORTED_MODULE_2__language_visitor__["c" /* visitInParallel */])(visitors)));
  return context.getErrors();
}

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return specifiedRules; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rules_ExecutableDefinitions__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rules_UniqueOperationNames__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_LoneAnonymousOperation__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rules_SingleFieldSubscriptions__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rules_KnownTypeNames__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_FragmentsOnCompositeTypes__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_VariablesAreInputTypes__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rules_ScalarLeafs__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__rules_FieldsOnCorrectType__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__rules_UniqueFragmentNames__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__rules_KnownFragmentNames__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__rules_NoUnusedFragments__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__rules_PossibleFragmentSpreads__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__rules_NoFragmentCycles__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__rules_UniqueVariableNames__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__rules_NoUndefinedVariables__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__rules_NoUnusedVariables__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__rules_KnownDirectives__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__rules_UniqueDirectivesPerLocation__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__rules_KnownArgumentNames__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__rules_UniqueArgumentNames__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__rules_ValuesOfCorrectType__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__rules_ProvidedNonNullArguments__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__rules_VariablesDefaultValueAllowed__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__rules_VariablesInAllowedPosition__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__rules_OverlappingFieldsCanBeMerged__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__rules_UniqueInputFieldNames__ = __webpack_require__(421);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

// Spec Section: "Executable Definitions"


// Spec Section: "Operation Name Uniqueness"


// Spec Section: "Lone Anonymous Operation"


// Spec Section: "Subscriptions with Single Root Field"


// Spec Section: "Fragment Spread Type Existence"


// Spec Section: "Fragments on Composite Types"


// Spec Section: "Variables are Input Types"


// Spec Section: "Leaf Field Selections"


// Spec Section: "Field Selections on Objects, Interfaces, and Unions Types"


// Spec Section: "Fragment Name Uniqueness"


// Spec Section: "Fragment spread target defined"


// Spec Section: "Fragments must be used"


// Spec Section: "Fragment spread is possible"


// Spec Section: "Fragments must not form cycles"


// Spec Section: "Variable Uniqueness"


// Spec Section: "All Variable Used Defined"


// Spec Section: "All Variables Used"


// Spec Section: "Directives Are Defined"


// Spec Section: "Directives Are Unique Per Location"


// Spec Section: "Argument Names"


// Spec Section: "Argument Uniqueness"


// Spec Section: "Value Type Correctness"


// Spec Section: "Argument Optionality"


// Spec Section: "Variables Default Value Is Allowed"


// Spec Section: "All Variable Usages Are Allowed"


// Spec Section: "Field Selection Merging"


// Spec Section: "Input Object Field Uniqueness"


/**
 * This set includes all validation rules defined by the GraphQL spec.
 *
 * The order of the rules in this list has been adjusted to lead to the
 * most clear output when encountering multiple validation errors.
 */
var specifiedRules = [__WEBPACK_IMPORTED_MODULE_0__rules_ExecutableDefinitions__["a" /* ExecutableDefinitions */], __WEBPACK_IMPORTED_MODULE_1__rules_UniqueOperationNames__["a" /* UniqueOperationNames */], __WEBPACK_IMPORTED_MODULE_2__rules_LoneAnonymousOperation__["a" /* LoneAnonymousOperation */], __WEBPACK_IMPORTED_MODULE_3__rules_SingleFieldSubscriptions__["a" /* SingleFieldSubscriptions */], __WEBPACK_IMPORTED_MODULE_4__rules_KnownTypeNames__["a" /* KnownTypeNames */], __WEBPACK_IMPORTED_MODULE_5__rules_FragmentsOnCompositeTypes__["a" /* FragmentsOnCompositeTypes */], __WEBPACK_IMPORTED_MODULE_6__rules_VariablesAreInputTypes__["a" /* VariablesAreInputTypes */], __WEBPACK_IMPORTED_MODULE_7__rules_ScalarLeafs__["a" /* ScalarLeafs */], __WEBPACK_IMPORTED_MODULE_8__rules_FieldsOnCorrectType__["a" /* FieldsOnCorrectType */], __WEBPACK_IMPORTED_MODULE_9__rules_UniqueFragmentNames__["a" /* UniqueFragmentNames */], __WEBPACK_IMPORTED_MODULE_10__rules_KnownFragmentNames__["a" /* KnownFragmentNames */], __WEBPACK_IMPORTED_MODULE_11__rules_NoUnusedFragments__["a" /* NoUnusedFragments */], __WEBPACK_IMPORTED_MODULE_12__rules_PossibleFragmentSpreads__["a" /* PossibleFragmentSpreads */], __WEBPACK_IMPORTED_MODULE_13__rules_NoFragmentCycles__["a" /* NoFragmentCycles */], __WEBPACK_IMPORTED_MODULE_14__rules_UniqueVariableNames__["a" /* UniqueVariableNames */], __WEBPACK_IMPORTED_MODULE_15__rules_NoUndefinedVariables__["a" /* NoUndefinedVariables */], __WEBPACK_IMPORTED_MODULE_16__rules_NoUnusedVariables__["a" /* NoUnusedVariables */], __WEBPACK_IMPORTED_MODULE_17__rules_KnownDirectives__["a" /* KnownDirectives */], __WEBPACK_IMPORTED_MODULE_18__rules_UniqueDirectivesPerLocation__["a" /* UniqueDirectivesPerLocation */], __WEBPACK_IMPORTED_MODULE_19__rules_KnownArgumentNames__["a" /* KnownArgumentNames */], __WEBPACK_IMPORTED_MODULE_20__rules_UniqueArgumentNames__["a" /* UniqueArgumentNames */], __WEBPACK_IMPORTED_MODULE_21__rules_ValuesOfCorrectType__["a" /* ValuesOfCorrectType */], __WEBPACK_IMPORTED_MODULE_22__rules_ProvidedNonNullArguments__["a" /* ProvidedNonNullArguments */], __WEBPACK_IMPORTED_MODULE_23__rules_VariablesDefaultValueAllowed__["a" /* VariablesDefaultValueAllowed */], __WEBPACK_IMPORTED_MODULE_24__rules_VariablesInAllowedPosition__["a" /* VariablesInAllowedPosition */], __WEBPACK_IMPORTED_MODULE_25__rules_OverlappingFieldsCanBeMerged__["a" /* OverlappingFieldsCanBeMerged */], __WEBPACK_IMPORTED_MODULE_26__rules_UniqueInputFieldNames__["a" /* UniqueInputFieldNames */]];

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export duplicateOperationNameMessage */
/* harmony export (immutable) */ __webpack_exports__["a"] = UniqueOperationNames;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__(43);

 /**
                                             * Copyright (c) 2015-present, Facebook, Inc.
                                             *
                                             * This source code is licensed under the MIT license found in the
                                             * LICENSE file in the root directory of this source tree.
                                             *
                                             *  strict
                                             */

function duplicateOperationNameMessage(operationName) {
  return 'There can be only one operation named "' + operationName + '".';
}

/**
 * Unique operation names
 *
 * A GraphQL document is only valid if all defined operations have unique names.
 */
function UniqueOperationNames(context) {
  var knownOperationNames = Object.create(null);
  return {
    OperationDefinition: function OperationDefinition(node) {
      var operationName = node.name;
      if (operationName) {
        if (knownOperationNames[operationName.value]) {
          context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* GraphQLError */](duplicateOperationNameMessage(operationName.value), [knownOperationNames[operationName.value], operationName]));
        } else {
          knownOperationNames[operationName.value] = operationName;
        }
      }
      return false;
    },

    FragmentDefinition: function FragmentDefinition() {
      return false;
    }
  };
}

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export anonOperationNotAloneMessage */
/* harmony export (immutable) */ __webpack_exports__["a"] = LoneAnonymousOperation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__language_kinds__ = __webpack_require__(57);

 /**
                                             * Copyright (c) 2015-present, Facebook, Inc.
                                             *
                                             * This source code is licensed under the MIT license found in the
                                             * LICENSE file in the root directory of this source tree.
                                             *
                                             *  strict
                                             */




function anonOperationNotAloneMessage() {
  return 'This anonymous operation must be the only defined operation.';
}

/**
 * Lone anonymous operation
 *
 * A GraphQL document is only valid if when it contains an anonymous operation
 * (the query short-hand) that it contains only that one operation definition.
 */
function LoneAnonymousOperation(context) {
  var operationCount = 0;
  return {
    Document: function Document(node) {
      operationCount = node.definitions.filter(function (definition) {
        return definition.kind === __WEBPACK_IMPORTED_MODULE_1__language_kinds__["a" /* Kind */].OPERATION_DEFINITION;
      }).length;
    },
    OperationDefinition: function OperationDefinition(node) {
      if (!node.name && operationCount > 1) {
        context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* GraphQLError */](anonOperationNotAloneMessage(), [node]));
      }
    }
  };
}

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export singleFieldOnlyMessage */
/* harmony export (immutable) */ __webpack_exports__["a"] = SingleFieldSubscriptions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__(43);

 /**
                                             * Copyright (c) 2015-present, Facebook, Inc.
                                             *
                                             * This source code is licensed under the MIT license found in the
                                             * LICENSE file in the root directory of this source tree.
                                             *
                                             *  strict
                                             */

function singleFieldOnlyMessage(name) {
  return (name ? 'Subscription "' + name + '" ' : 'Anonymous Subscription ') + 'must select only one top level field.';
}

/**
 * Subscriptions must only include one field.
 *
 * A GraphQL subscription is valid only if it contains a single root field.
 */
function SingleFieldSubscriptions(context) {
  return {
    OperationDefinition: function OperationDefinition(node) {
      if (node.operation === 'subscription') {
        if (node.selectionSet.selections.length !== 1) {
          context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* GraphQLError */](singleFieldOnlyMessage(node.name && node.name.value), node.selectionSet.selections.slice(1)));
        }
      }
    }
  };
}

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export unknownTypeMessage */
/* harmony export (immutable) */ __webpack_exports__["a"] = KnownTypeNames;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsutils_suggestionList__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsutils_quotedOrList__ = __webpack_require__(276);

 /**
                                             * Copyright (c) 2015-present, Facebook, Inc.
                                             *
                                             * This source code is licensed under the MIT license found in the
                                             * LICENSE file in the root directory of this source tree.
                                             *
                                             *  strict
                                             */





function unknownTypeMessage(typeName, suggestedTypes) {
  var message = 'Unknown type "' + typeName + '".';
  if (suggestedTypes.length) {
    message += ' Did you mean ' + Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_quotedOrList__["a" /* default */])(suggestedTypes) + '?';
  }
  return message;
}

/**
 * Known type names
 *
 * A GraphQL document is only valid if referenced types (specifically
 * variable definitions and fragment conditions) are defined by the type schema.
 */
function KnownTypeNames(context) {
  return {
    // TODO: when validating IDL, re-enable these. Experimental version does not
    // add unreferenced types, resulting in false-positive errors. Squelched
    // errors for now.
    ObjectTypeDefinition: function ObjectTypeDefinition() {
      return false;
    },
    InterfaceTypeDefinition: function InterfaceTypeDefinition() {
      return false;
    },
    UnionTypeDefinition: function UnionTypeDefinition() {
      return false;
    },
    InputObjectTypeDefinition: function InputObjectTypeDefinition() {
      return false;
    },
    NamedType: function NamedType(node) {
      var schema = context.getSchema();
      var typeName = node.name.value;
      var type = schema.getType(typeName);
      if (!type) {
        context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* GraphQLError */](unknownTypeMessage(typeName, Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_suggestionList__["a" /* default */])(typeName, Object.keys(schema.getTypeMap()))), [node]));
      }
    }
  };
}

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export inlineFragmentOnNonCompositeErrorMessage */
/* unused harmony export fragmentOnNonCompositeErrorMessage */
/* harmony export (immutable) */ __webpack_exports__["a"] = FragmentsOnCompositeTypes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__language_printer__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type_definition__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_typeFromAST__ = __webpack_require__(97);

 /**
                                             * Copyright (c) 2015-present, Facebook, Inc.
                                             *
                                             * This source code is licensed under the MIT license found in the
                                             * LICENSE file in the root directory of this source tree.
                                             *
                                             *  strict
                                             */







function inlineFragmentOnNonCompositeErrorMessage(type) {
  return 'Fragment cannot condition on non composite type "' + String(type) + '".';
}

function fragmentOnNonCompositeErrorMessage(fragName, type) {
  return 'Fragment "' + fragName + '" cannot condition on non composite ' + ('type "' + String(type) + '".');
}

/**
 * Fragments on composite type
 *
 * Fragments use a type condition to determine if they apply, since fragments
 * can only be spread into a composite type (object, interface, or union), the
 * type condition must also be a composite type.
 */
function FragmentsOnCompositeTypes(context) {
  return {
    InlineFragment: function InlineFragment(node) {
      var typeCondition = node.typeCondition;
      if (typeCondition) {
        var type = Object(__WEBPACK_IMPORTED_MODULE_3__utilities_typeFromAST__["a" /* typeFromAST */])(context.getSchema(), typeCondition);
        if (type && !Object(__WEBPACK_IMPORTED_MODULE_2__type_definition__["o" /* isCompositeType */])(type)) {
          context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* GraphQLError */](inlineFragmentOnNonCompositeErrorMessage(Object(__WEBPACK_IMPORTED_MODULE_1__language_printer__["a" /* print */])(typeCondition)), [typeCondition]));
        }
      }
    },
    FragmentDefinition: function FragmentDefinition(node) {
      var type = Object(__WEBPACK_IMPORTED_MODULE_3__utilities_typeFromAST__["a" /* typeFromAST */])(context.getSchema(), node.typeCondition);
      if (type && !Object(__WEBPACK_IMPORTED_MODULE_2__type_definition__["o" /* isCompositeType */])(type)) {
        context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* GraphQLError */](fragmentOnNonCompositeErrorMessage(node.name.value, Object(__WEBPACK_IMPORTED_MODULE_1__language_printer__["a" /* print */])(node.typeCondition)), [node.typeCondition]));
      }
    }
  };
}

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export nonInputTypeOnVarMessage */
/* harmony export (immutable) */ __webpack_exports__["a"] = VariablesAreInputTypes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__language_printer__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type_definition__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_typeFromAST__ = __webpack_require__(97);

 /**
                                             * Copyright (c) 2015-present, Facebook, Inc.
                                             *
                                             * This source code is licensed under the MIT license found in the
                                             * LICENSE file in the root directory of this source tree.
                                             *
                                             *  strict
                                             */






function nonInputTypeOnVarMessage(variableName, typeName) {
  return 'Variable "$' + variableName + '" cannot be non-input type "' + typeName + '".';
}

/**
 * Variables are input types
 *
 * A GraphQL operation is only valid if all the variables it defines are of
 * input types (scalar, enum, or input object).
 */
function VariablesAreInputTypes(context) {
  return {
    VariableDefinition: function VariableDefinition(node) {
      var type = Object(__WEBPACK_IMPORTED_MODULE_3__utilities_typeFromAST__["a" /* typeFromAST */])(context.getSchema(), node.type);

      // If the variable type is not an input type, return an error.
      if (type && !Object(__WEBPACK_IMPORTED_MODULE_2__type_definition__["r" /* isInputType */])(type)) {
        var variableName = node.variable.name.value;
        context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* GraphQLError */](nonInputTypeOnVarMessage(variableName, Object(__WEBPACK_IMPORTED_MODULE_1__language_printer__["a" /* print */])(node.type)), [node.type]));
      }
    }
  };
}

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export noSubselectionAllowedMessage */
/* unused harmony export requiredSubselectionMessage */
/* harmony export (immutable) */ __webpack_exports__["a"] = ScalarLeafs;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type_definition__ = __webpack_require__(46);

 /**
                                             * Copyright (c) 2015-present, Facebook, Inc.
                                             *
                                             * This source code is licensed under the MIT license found in the
                                             * LICENSE file in the root directory of this source tree.
                                             *
                                             *  strict
                                             */




function noSubselectionAllowedMessage(fieldName, type) {
  return 'Field "' + fieldName + '" must not have a selection since ' + ('type "' + String(type) + '" has no subfields.');
}

function requiredSubselectionMessage(fieldName, type) {
  return 'Field "' + fieldName + '" of type "' + String(type) + '" must have a ' + ('selection of subfields. Did you mean "' + fieldName + ' { ... }"?');
}

/**
 * Scalar leafs
 *
 * A GraphQL document is valid only if all leaf fields (fields without
 * sub selections) are of scalar or enum types.
 */
function ScalarLeafs(context) {
  return {
    Field: function Field(node) {
      var type = context.getType();
      var selectionSet = node.selectionSet;
      if (type) {
        if (Object(__WEBPACK_IMPORTED_MODULE_1__type_definition__["t" /* isLeafType */])(Object(__WEBPACK_IMPORTED_MODULE_1__type_definition__["l" /* getNamedType */])(type))) {
          if (selectionSet) {
            context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* GraphQLError */](noSubselectionAllowedMessage(node.name.value, type), [selectionSet]));
          }
        } else if (!selectionSet) {
          context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* GraphQLError */](requiredSubselectionMessage(node.name.value, type), [node]));
        }
      }
    }
  };
}

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export undefinedFieldMessage */
/* harmony export (immutable) */ __webpack_exports__["a"] = FieldsOnCorrectType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsutils_suggestionList__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsutils_quotedOrList__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__type_definition__ = __webpack_require__(46);

 /**
                                             * Copyright (c) 2015-present, Facebook, Inc.
                                             *
                                             * This source code is licensed under the MIT license found in the
                                             * LICENSE file in the root directory of this source tree.
                                             *
                                             *  strict
                                             */






function undefinedFieldMessage(fieldName, type, suggestedTypeNames, suggestedFieldNames) {
  var message = 'Cannot query field "' + fieldName + '" on type "' + type + '".';
  if (suggestedTypeNames.length !== 0) {
    var suggestions = Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_quotedOrList__["a" /* default */])(suggestedTypeNames);
    message += ' Did you mean to use an inline fragment on ' + suggestions + '?';
  } else if (suggestedFieldNames.length !== 0) {
    message += ' Did you mean ' + Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_quotedOrList__["a" /* default */])(suggestedFieldNames) + '?';
  }
  return message;
}

/**
 * Fields on correct type
 *
 * A GraphQL document is only valid if all fields selected are defined by the
 * parent type, or are an allowed meta field such as __typename.
 */
function FieldsOnCorrectType(context) {
  return {
    Field: function Field(node) {
      var type = context.getParentType();
      if (type) {
        var fieldDef = context.getFieldDef();
        if (!fieldDef) {
          // This field doesn't exist, lets look for suggestions.
          var schema = context.getSchema();
          var fieldName = node.name.value;
          // First determine if there are any suggested types to condition on.
          var suggestedTypeNames = getSuggestedTypeNames(schema, type, fieldName);
          // If there are no suggested types, then perhaps this was a typo?
          var suggestedFieldNames = suggestedTypeNames.length !== 0 ? [] : getSuggestedFieldNames(schema, type, fieldName);

          // Report an error, including helpful suggestions.
          context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* GraphQLError */](undefinedFieldMessage(fieldName, type.name, suggestedTypeNames, suggestedFieldNames), [node]));
        }
      }
    }
  };
}

/**
 * Go through all of the implementations of type, as well as the interfaces
 * that they implement. If any of those types include the provided field,
 * suggest them, sorted by how often the type is referenced,  starting
 * with Interfaces.
 */
function getSuggestedTypeNames(schema, type, fieldName) {
  if (Object(__WEBPACK_IMPORTED_MODULE_3__type_definition__["n" /* isAbstractType */])(type)) {
    var suggestedObjectTypes = [];
    var interfaceUsageCount = Object.create(null);
    schema.getPossibleTypes(type).forEach(function (possibleType) {
      if (!possibleType.getFields()[fieldName]) {
        return;
      }
      // This object type defines this field.
      suggestedObjectTypes.push(possibleType.name);
      possibleType.getInterfaces().forEach(function (possibleInterface) {
        if (!possibleInterface.getFields()[fieldName]) {
          return;
        }
        // This interface type defines this field.
        interfaceUsageCount[possibleInterface.name] = (interfaceUsageCount[possibleInterface.name] || 0) + 1;
      });
    });

    // Suggest interface types based on how common they are.
    var suggestedInterfaceTypes = Object.keys(interfaceUsageCount).sort(function (a, b) {
      return interfaceUsageCount[b] - interfaceUsageCount[a];
    });

    // Suggest both interface and object types.
    return suggestedInterfaceTypes.concat(suggestedObjectTypes);
  }

  // Otherwise, must be an Object type, which does not have possible fields.
  return [];
}

/**
 * For the field name provided, determine if there are any similar field names
 * that may be the result of a typo.
 */
function getSuggestedFieldNames(schema, type, fieldName) {
  if (Object(__WEBPACK_IMPORTED_MODULE_3__type_definition__["x" /* isObjectType */])(type) || Object(__WEBPACK_IMPORTED_MODULE_3__type_definition__["s" /* isInterfaceType */])(type)) {
    var possibleFieldNames = Object.keys(type.getFields());
    return Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_suggestionList__["a" /* default */])(fieldName, possibleFieldNames);
  }
  // Otherwise, must be a Union type, which does not define fields.
  return [];
}

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export duplicateFragmentNameMessage */
/* harmony export (immutable) */ __webpack_exports__["a"] = UniqueFragmentNames;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__(43);

 /**
                                             * Copyright (c) 2015-present, Facebook, Inc.
                                             *
                                             * This source code is licensed under the MIT license found in the
                                             * LICENSE file in the root directory of this source tree.
                                             *
                                             *  strict
                                             */

function duplicateFragmentNameMessage(fragName) {
  return 'There can be only one fragment named "' + fragName + '".';
}

/**
 * Unique fragment names
 *
 * A GraphQL document is only valid if all defined fragments have unique names.
 */
function UniqueFragmentNames(context) {
  var knownFragmentNames = Object.create(null);
  return {
    OperationDefinition: function OperationDefinition() {
      return false;
    },
    FragmentDefinition: function FragmentDefinition(node) {
      var fragmentName = node.name.value;
      if (knownFragmentNames[fragmentName]) {
        context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* GraphQLError */](duplicateFragmentNameMessage(fragmentName), [knownFragmentNames[fragmentName], node.name]));
      } else {
        knownFragmentNames[fragmentName] = node.name;
      }
      return false;
    }
  };
}

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export unknownFragmentMessage */
/* harmony export (immutable) */ __webpack_exports__["a"] = KnownFragmentNames;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__(43);

 /**
                                             * Copyright (c) 2015-present, Facebook, Inc.
                                             *
                                             * This source code is licensed under the MIT license found in the
                                             * LICENSE file in the root directory of this source tree.
                                             *
                                             *  strict
                                             */

function unknownFragmentMessage(fragName) {
  return 'Unknown fragment "' + fragName + '".';
}

/**
 * Known fragment names
 *
 * A GraphQL document is only valid if all `...Fragment` fragment spreads refer
 * to fragments defined in the same document.
 */
function KnownFragmentNames(context) {
  return {
    FragmentSpread: function FragmentSpread(node) {
      var fragmentName = node.name.value;
      var fragment = context.getFragment(fragmentName);
      if (!fragment) {
        context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* GraphQLError */](unknownFragmentMessage(fragmentName), [node.name]));
      }
    }
  };
}

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export unusedFragMessage */
/* harmony export (immutable) */ __webpack_exports__["a"] = NoUnusedFragments;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__(43);

 /**
                                             * Copyright (c) 2015-present, Facebook, Inc.
                                             *
                                             * This source code is licensed under the MIT license found in the
                                             * LICENSE file in the root directory of this source tree.
                                             *
                                             *  strict
                                             */

function unusedFragMessage(fragName) {
  return 'Fragment "' + fragName + '" is never used.';
}

/**
 * No unused fragments
 *
 * A GraphQL document is only valid if all fragment definitions are spread
 * within operations, or spread within other fragments spread within operations.
 */
function NoUnusedFragments(context) {
  var operationDefs = [];
  var fragmentDefs = [];

  return {
    OperationDefinition: function OperationDefinition(node) {
      operationDefs.push(node);
      return false;
    },
    FragmentDefinition: function FragmentDefinition(node) {
      fragmentDefs.push(node);
      return false;
    },

    Document: {
      leave: function leave() {
        var fragmentNameUsed = Object.create(null);
        operationDefs.forEach(function (operation) {
          context.getRecursivelyReferencedFragments(operation).forEach(function (fragment) {
            fragmentNameUsed[fragment.name.value] = true;
          });
        });

        fragmentDefs.forEach(function (fragmentDef) {
          var fragName = fragmentDef.name.value;
          if (fragmentNameUsed[fragName] !== true) {
            context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* GraphQLError */](unusedFragMessage(fragName), [fragmentDef]));
          }
        });
      }
    }
  };
}

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export typeIncompatibleSpreadMessage */
/* unused harmony export typeIncompatibleAnonSpreadMessage */
/* harmony export (immutable) */ __webpack_exports__["a"] = PossibleFragmentSpreads;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities_typeComparators__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_typeFromAST__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__type_definition__ = __webpack_require__(46);

 /**
                                             * Copyright (c) 2015-present, Facebook, Inc.
                                             *
                                             * This source code is licensed under the MIT license found in the
                                             * LICENSE file in the root directory of this source tree.
                                             *
                                             *  strict
                                             */






function typeIncompatibleSpreadMessage(fragName, parentType, fragType) {
  return 'Fragment "' + fragName + '" cannot be spread here as objects of ' + ('type "' + String(parentType) + '" can never be of type "' + String(fragType) + '".');
}

function typeIncompatibleAnonSpreadMessage(parentType, fragType) {
  return 'Fragment cannot be spread here as objects of ' + ('type "' + String(parentType) + '" can never be of type "' + String(fragType) + '".');
}

/**
 * Possible fragment spread
 *
 * A fragment spread is only valid if the type condition could ever possibly
 * be true: if there is a non-empty intersection of the possible parent types,
 * and possible types which pass the type condition.
 */
function PossibleFragmentSpreads(context) {
  return {
    InlineFragment: function InlineFragment(node) {
      var fragType = context.getType();
      var parentType = context.getParentType();
      if (Object(__WEBPACK_IMPORTED_MODULE_3__type_definition__["o" /* isCompositeType */])(fragType) && Object(__WEBPACK_IMPORTED_MODULE_3__type_definition__["o" /* isCompositeType */])(parentType) && !Object(__WEBPACK_IMPORTED_MODULE_1__utilities_typeComparators__["a" /* doTypesOverlap */])(context.getSchema(), fragType, parentType)) {
        context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* GraphQLError */](typeIncompatibleAnonSpreadMessage(parentType, fragType), [node]));
      }
    },
    FragmentSpread: function FragmentSpread(node) {
      var fragName = node.name.value;
      var fragType = getFragmentType(context, fragName);
      var parentType = context.getParentType();
      if (fragType && parentType && !Object(__WEBPACK_IMPORTED_MODULE_1__utilities_typeComparators__["a" /* doTypesOverlap */])(context.getSchema(), fragType, parentType)) {
        context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* GraphQLError */](typeIncompatibleSpreadMessage(fragName, parentType, fragType), [node]));
      }
    }
  };
}

function getFragmentType(context, name) {
  var frag = context.getFragment(name);
  if (frag) {
    var type = Object(__WEBPACK_IMPORTED_MODULE_2__utilities_typeFromAST__["a" /* typeFromAST */])(context.getSchema(), frag.typeCondition);
    if (Object(__WEBPACK_IMPORTED_MODULE_3__type_definition__["o" /* isCompositeType */])(type)) {
      return type;
    }
  }
}

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export cycleErrorMessage */
/* harmony export (immutable) */ __webpack_exports__["a"] = NoFragmentCycles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__(43);

 /**
                                             * Copyright (c) 2015-present, Facebook, Inc.
                                             *
                                             * This source code is licensed under the MIT license found in the
                                             * LICENSE file in the root directory of this source tree.
                                             *
                                             *  strict
                                             */

function cycleErrorMessage(fragName, spreadNames) {
  var via = spreadNames.length ? ' via ' + spreadNames.join(', ') : '';
  return 'Cannot spread fragment "' + fragName + '" within itself' + via + '.';
}

function NoFragmentCycles(context) {
  // Tracks already visited fragments to maintain O(N) and to ensure that cycles
  // are not redundantly reported.
  var visitedFrags = Object.create(null);

  // Array of AST nodes used to produce meaningful errors
  var spreadPath = [];

  // Position in the spread path
  var spreadPathIndexByName = Object.create(null);

  return {
    OperationDefinition: function OperationDefinition() {
      return false;
    },
    FragmentDefinition: function FragmentDefinition(node) {
      if (!visitedFrags[node.name.value]) {
        detectCycleRecursive(node);
      }
      return false;
    }
  };

  // This does a straight-forward DFS to find cycles.
  // It does not terminate when a cycle was found but continues to explore
  // the graph to find all possible cycles.
  function detectCycleRecursive(fragment) {
    var fragmentName = fragment.name.value;
    visitedFrags[fragmentName] = true;

    var spreadNodes = context.getFragmentSpreads(fragment.selectionSet);
    if (spreadNodes.length === 0) {
      return;
    }

    spreadPathIndexByName[fragmentName] = spreadPath.length;

    for (var i = 0; i < spreadNodes.length; i++) {
      var spreadNode = spreadNodes[i];
      var spreadName = spreadNode.name.value;
      var cycleIndex = spreadPathIndexByName[spreadName];

      if (cycleIndex === undefined) {
        spreadPath.push(spreadNode);
        if (!visitedFrags[spreadName]) {
          var spreadFragment = context.getFragment(spreadName);
          if (spreadFragment) {
            detectCycleRecursive(spreadFragment);
          }
        }
        spreadPath.pop();
      } else {
        var cyclePath = spreadPath.slice(cycleIndex);
        context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* GraphQLError */](cycleErrorMessage(spreadName, cyclePath.map(function (s) {
          return s.name.value;
        })), cyclePath.concat(spreadNode)));
      }
    }

    spreadPathIndexByName[fragmentName] = undefined;
  }
}

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export duplicateVariableMessage */
/* harmony export (immutable) */ __webpack_exports__["a"] = UniqueVariableNames;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__(43);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */




function duplicateVariableMessage(variableName) {
  return 'There can be only one variable named "' + variableName + '".';
}

/**
 * Unique variable names
 *
 * A GraphQL operation is only valid if all its variables are uniquely named.
 */
function UniqueVariableNames(context) {
  var knownVariableNames = Object.create(null);
  return {
    OperationDefinition: function OperationDefinition() {
      knownVariableNames = Object.create(null);
    },
    VariableDefinition: function VariableDefinition(node) {
      var variableName = node.variable.name.value;
      if (knownVariableNames[variableName]) {
        context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* GraphQLError */](duplicateVariableMessage(variableName), [knownVariableNames[variableName], node.variable.name]));
      } else {
        knownVariableNames[variableName] = node.variable.name;
      }
    }
  };
}

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export undefinedVarMessage */
/* harmony export (immutable) */ __webpack_exports__["a"] = NoUndefinedVariables;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__(43);

 /**
                                             * Copyright (c) 2015-present, Facebook, Inc.
                                             *
                                             * This source code is licensed under the MIT license found in the
                                             * LICENSE file in the root directory of this source tree.
                                             *
                                             *  strict
                                             */

function undefinedVarMessage(varName, opName) {
  return opName ? 'Variable "$' + varName + '" is not defined by operation "' + opName + '".' : 'Variable "$' + varName + '" is not defined.';
}

/**
 * No undefined variables
 *
 * A GraphQL operation is only valid if all variables encountered, both directly
 * and via fragment spreads, are defined by that operation.
 */
function NoUndefinedVariables(context) {
  var variableNameDefined = Object.create(null);

  return {
    OperationDefinition: {
      enter: function enter() {
        variableNameDefined = Object.create(null);
      },
      leave: function leave(operation) {
        var usages = context.getRecursiveVariableUsages(operation);

        usages.forEach(function (_ref) {
          var node = _ref.node;

          var varName = node.name.value;
          if (variableNameDefined[varName] !== true) {
            context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* GraphQLError */](undefinedVarMessage(varName, operation.name && operation.name.value), [node, operation]));
          }
        });
      }
    },
    VariableDefinition: function VariableDefinition(node) {
      variableNameDefined[node.variable.name.value] = true;
    }
  };
}

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export unusedVariableMessage */
/* harmony export (immutable) */ __webpack_exports__["a"] = NoUnusedVariables;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__(43);

 /**
                                             * Copyright (c) 2015-present, Facebook, Inc.
                                             *
                                             * This source code is licensed under the MIT license found in the
                                             * LICENSE file in the root directory of this source tree.
                                             *
                                             *  strict
                                             */

function unusedVariableMessage(varName, opName) {
  return opName ? 'Variable "$' + varName + '" is never used in operation "' + opName + '".' : 'Variable "$' + varName + '" is never used.';
}

/**
 * No unused variables
 *
 * A GraphQL operation is only valid if all variables defined by an operation
 * are used, either directly or within a spread fragment.
 */
function NoUnusedVariables(context) {
  var variableDefs = [];

  return {
    OperationDefinition: {
      enter: function enter() {
        variableDefs = [];
      },
      leave: function leave(operation) {
        var variableNameUsed = Object.create(null);
        var usages = context.getRecursiveVariableUsages(operation);
        var opName = operation.name ? operation.name.value : null;

        usages.forEach(function (_ref) {
          var node = _ref.node;

          variableNameUsed[node.name.value] = true;
        });

        variableDefs.forEach(function (variableDef) {
          var variableName = variableDef.variable.name.value;
          if (variableNameUsed[variableName] !== true) {
            context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* GraphQLError */](unusedVariableMessage(variableName, opName), [variableDef]));
          }
        });
      }
    },
    VariableDefinition: function VariableDefinition(def) {
      variableDefs.push(def);
    }
  };
}

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export unknownDirectiveMessage */
/* unused harmony export misplacedDirectiveMessage */
/* harmony export (immutable) */ __webpack_exports__["a"] = KnownDirectives;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsutils_find__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__language_kinds__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__language_directiveLocation__ = __webpack_require__(138);

 /**
                                             * Copyright (c) 2015-present, Facebook, Inc.
                                             *
                                             * This source code is licensed under the MIT license found in the
                                             * LICENSE file in the root directory of this source tree.
                                             *
                                             *  strict
                                             */






function unknownDirectiveMessage(directiveName) {
  return 'Unknown directive "' + directiveName + '".';
}

function misplacedDirectiveMessage(directiveName, location) {
  return 'Directive "' + directiveName + '" may not be used on ' + location + '.';
}

/**
 * Known directives
 *
 * A GraphQL document is only valid if all `@directives` are known by the
 * schema and legally positioned.
 */
function KnownDirectives(context) {
  return {
    Directive: function Directive(node, key, parent, path, ancestors) {
      var directiveDef = Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_find__["a" /* default */])(context.getSchema().getDirectives(), function (def) {
        return def.name === node.name.value;
      });
      if (!directiveDef) {
        context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* GraphQLError */](unknownDirectiveMessage(node.name.value), [node]));
        return;
      }
      var candidateLocation = getDirectiveLocationForASTPath(ancestors);
      if (candidateLocation && directiveDef.locations.indexOf(candidateLocation) === -1) {
        context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* GraphQLError */](misplacedDirectiveMessage(node.name.value, candidateLocation), [node]));
      }
    }
  };
}

function getDirectiveLocationForASTPath(ancestors) {
  var appliedTo = ancestors[ancestors.length - 1];
  if (!Array.isArray(appliedTo)) {
    switch (appliedTo.kind) {
      case __WEBPACK_IMPORTED_MODULE_2__language_kinds__["a" /* Kind */].OPERATION_DEFINITION:
        switch (appliedTo.operation) {
          case 'query':
            return __WEBPACK_IMPORTED_MODULE_3__language_directiveLocation__["a" /* DirectiveLocation */].QUERY;
          case 'mutation':
            return __WEBPACK_IMPORTED_MODULE_3__language_directiveLocation__["a" /* DirectiveLocation */].MUTATION;
          case 'subscription':
            return __WEBPACK_IMPORTED_MODULE_3__language_directiveLocation__["a" /* DirectiveLocation */].SUBSCRIPTION;
        }
        break;
      case __WEBPACK_IMPORTED_MODULE_2__language_kinds__["a" /* Kind */].FIELD:
        return __WEBPACK_IMPORTED_MODULE_3__language_directiveLocation__["a" /* DirectiveLocation */].FIELD;
      case __WEBPACK_IMPORTED_MODULE_2__language_kinds__["a" /* Kind */].FRAGMENT_SPREAD:
        return __WEBPACK_IMPORTED_MODULE_3__language_directiveLocation__["a" /* DirectiveLocation */].FRAGMENT_SPREAD;
      case __WEBPACK_IMPORTED_MODULE_2__language_kinds__["a" /* Kind */].INLINE_FRAGMENT:
        return __WEBPACK_IMPORTED_MODULE_3__language_directiveLocation__["a" /* DirectiveLocation */].INLINE_FRAGMENT;
      case __WEBPACK_IMPORTED_MODULE_2__language_kinds__["a" /* Kind */].FRAGMENT_DEFINITION:
        return __WEBPACK_IMPORTED_MODULE_3__language_directiveLocation__["a" /* DirectiveLocation */].FRAGMENT_DEFINITION;
      case __WEBPACK_IMPORTED_MODULE_2__language_kinds__["a" /* Kind */].SCHEMA_DEFINITION:
        return __WEBPACK_IMPORTED_MODULE_3__language_directiveLocation__["a" /* DirectiveLocation */].SCHEMA;
      case __WEBPACK_IMPORTED_MODULE_2__language_kinds__["a" /* Kind */].SCALAR_TYPE_DEFINITION:
      case __WEBPACK_IMPORTED_MODULE_2__language_kinds__["a" /* Kind */].SCALAR_TYPE_EXTENSION:
        return __WEBPACK_IMPORTED_MODULE_3__language_directiveLocation__["a" /* DirectiveLocation */].SCALAR;
      case __WEBPACK_IMPORTED_MODULE_2__language_kinds__["a" /* Kind */].OBJECT_TYPE_DEFINITION:
      case __WEBPACK_IMPORTED_MODULE_2__language_kinds__["a" /* Kind */].OBJECT_TYPE_EXTENSION:
        return __WEBPACK_IMPORTED_MODULE_3__language_directiveLocation__["a" /* DirectiveLocation */].OBJECT;
      case __WEBPACK_IMPORTED_MODULE_2__language_kinds__["a" /* Kind */].FIELD_DEFINITION:
        return __WEBPACK_IMPORTED_MODULE_3__language_directiveLocation__["a" /* DirectiveLocation */].FIELD_DEFINITION;
      case __WEBPACK_IMPORTED_MODULE_2__language_kinds__["a" /* Kind */].INTERFACE_TYPE_DEFINITION:
      case __WEBPACK_IMPORTED_MODULE_2__language_kinds__["a" /* Kind */].INTERFACE_TYPE_EXTENSION:
        return __WEBPACK_IMPORTED_MODULE_3__language_directiveLocation__["a" /* DirectiveLocation */].INTERFACE;
      case __WEBPACK_IMPORTED_MODULE_2__language_kinds__["a" /* Kind */].UNION_TYPE_DEFINITION:
      case __WEBPACK_IMPORTED_MODULE_2__language_kinds__["a" /* Kind */].UNION_TYPE_EXTENSION:
        return __WEBPACK_IMPORTED_MODULE_3__language_directiveLocation__["a" /* DirectiveLocation */].UNION;
      case __WEBPACK_IMPORTED_MODULE_2__language_kinds__["a" /* Kind */].ENUM_TYPE_DEFINITION:
      case __WEBPACK_IMPORTED_MODULE_2__language_kinds__["a" /* Kind */].ENUM_TYPE_EXTENSION:
        return __WEBPACK_IMPORTED_MODULE_3__language_directiveLocation__["a" /* DirectiveLocation */].ENUM;
      case __WEBPACK_IMPORTED_MODULE_2__language_kinds__["a" /* Kind */].ENUM_VALUE_DEFINITION:
        return __WEBPACK_IMPORTED_MODULE_3__language_directiveLocation__["a" /* DirectiveLocation */].ENUM_VALUE;
      case __WEBPACK_IMPORTED_MODULE_2__language_kinds__["a" /* Kind */].INPUT_OBJECT_TYPE_DEFINITION:
      case __WEBPACK_IMPORTED_MODULE_2__language_kinds__["a" /* Kind */].INPUT_OBJECT_TYPE_EXTENSION:
        return __WEBPACK_IMPORTED_MODULE_3__language_directiveLocation__["a" /* DirectiveLocation */].INPUT_OBJECT;
      case __WEBPACK_IMPORTED_MODULE_2__language_kinds__["a" /* Kind */].INPUT_VALUE_DEFINITION:
        var parentNode = ancestors[ancestors.length - 3];
        return parentNode.kind === __WEBPACK_IMPORTED_MODULE_2__language_kinds__["a" /* Kind */].INPUT_OBJECT_TYPE_DEFINITION ? __WEBPACK_IMPORTED_MODULE_3__language_directiveLocation__["a" /* DirectiveLocation */].INPUT_FIELD_DEFINITION : __WEBPACK_IMPORTED_MODULE_3__language_directiveLocation__["a" /* DirectiveLocation */].ARGUMENT_DEFINITION;
    }
  }
}

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export duplicateDirectiveMessage */
/* harmony export (immutable) */ __webpack_exports__["a"] = UniqueDirectivesPerLocation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__(43);

 /**
                                             * Copyright (c) 2015-present, Facebook, Inc.
                                             *
                                             * This source code is licensed under the MIT license found in the
                                             * LICENSE file in the root directory of this source tree.
                                             *
                                             *  strict
                                             */

function duplicateDirectiveMessage(directiveName) {
  return 'The directive "' + directiveName + '" can only be used once at ' + 'this location.';
}

/**
 * Unique directive names per location
 *
 * A GraphQL document is only valid if all directives at a given location
 * are uniquely named.
 */
function UniqueDirectivesPerLocation(context) {
  return {
    // Many different AST nodes may contain directives. Rather than listing
    // them all, just listen for entering any node, and check to see if it
    // defines any directives.
    enter: function enter(node) {
      // Flow can't refine that node.directives will only contain directives,
      var directives = node.directives;
      if (directives) {
        var knownDirectives = Object.create(null);
        directives.forEach(function (directive) {
          var directiveName = directive.name.value;
          if (knownDirectives[directiveName]) {
            context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* GraphQLError */](duplicateDirectiveMessage(directiveName), [knownDirectives[directiveName], directive]));
          } else {
            knownDirectives[directiveName] = directive;
          }
        });
      }
    }
  };
}

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export unknownArgMessage */
/* unused harmony export unknownDirectiveArgMessage */
/* harmony export (immutable) */ __webpack_exports__["a"] = KnownArgumentNames;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsutils_suggestionList__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsutils_quotedOrList__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__language_kinds__ = __webpack_require__(57);

 /**
                                             * Copyright (c) 2015-present, Facebook, Inc.
                                             *
                                             * This source code is licensed under the MIT license found in the
                                             * LICENSE file in the root directory of this source tree.
                                             *
                                             *  strict
                                             */





function unknownArgMessage(argName, fieldName, typeName, suggestedArgs) {
  var message = 'Unknown argument "' + argName + '" on field "' + fieldName + '" of ' + ('type "' + typeName + '".');
  if (suggestedArgs.length) {
    message += ' Did you mean ' + Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_quotedOrList__["a" /* default */])(suggestedArgs) + '?';
  }
  return message;
}

function unknownDirectiveArgMessage(argName, directiveName, suggestedArgs) {
  var message = 'Unknown argument "' + argName + '" on directive "@' + directiveName + '".';
  if (suggestedArgs.length) {
    message += ' Did you mean ' + Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_quotedOrList__["a" /* default */])(suggestedArgs) + '?';
  }
  return message;
}

/**
 * Known argument names
 *
 * A GraphQL field is only valid if all supplied arguments are defined by
 * that field.
 */
function KnownArgumentNames(context) {
  return {
    Argument: function Argument(node, key, parent, path, ancestors) {
      var argDef = context.getArgument();
      if (!argDef) {
        var argumentOf = ancestors[ancestors.length - 1];
        if (argumentOf.kind === __WEBPACK_IMPORTED_MODULE_3__language_kinds__["a" /* Kind */].FIELD) {
          var fieldDef = context.getFieldDef();
          var parentType = context.getParentType();
          if (fieldDef && parentType) {
            context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* GraphQLError */](unknownArgMessage(node.name.value, fieldDef.name, parentType.name, Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_suggestionList__["a" /* default */])(node.name.value, fieldDef.args.map(function (arg) {
              return arg.name;
            }))), [node]));
          }
        } else if (argumentOf.kind === __WEBPACK_IMPORTED_MODULE_3__language_kinds__["a" /* Kind */].DIRECTIVE) {
          var directive = context.getDirective();
          if (directive) {
            context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* GraphQLError */](unknownDirectiveArgMessage(node.name.value, directive.name, Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_suggestionList__["a" /* default */])(node.name.value, directive.args.map(function (arg) {
              return arg.name;
            }))), [node]));
          }
        }
      }
    }
  };
}

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export duplicateArgMessage */
/* harmony export (immutable) */ __webpack_exports__["a"] = UniqueArgumentNames;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__(43);

 /**
                                             * Copyright (c) 2015-present, Facebook, Inc.
                                             *
                                             * This source code is licensed under the MIT license found in the
                                             * LICENSE file in the root directory of this source tree.
                                             *
                                             *  strict
                                             */

function duplicateArgMessage(argName) {
  return 'There can be only one argument named "' + argName + '".';
}

/**
 * Unique argument names
 *
 * A GraphQL field or directive is only valid if all supplied arguments are
 * uniquely named.
 */
function UniqueArgumentNames(context) {
  var knownArgNames = Object.create(null);
  return {
    Field: function Field() {
      knownArgNames = Object.create(null);
    },
    Directive: function Directive() {
      knownArgNames = Object.create(null);
    },
    Argument: function Argument(node) {
      var argName = node.name.value;
      if (knownArgNames[argName]) {
        context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* GraphQLError */](duplicateArgMessage(argName), [knownArgNames[argName], node.name]));
      } else {
        knownArgNames[argName] = node.name;
      }
      return false;
    }
  };
}

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export missingFieldArgMessage */
/* unused harmony export missingDirectiveArgMessage */
/* harmony export (immutable) */ __webpack_exports__["a"] = ProvidedNonNullArguments;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsutils_keyMap__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type_definition__ = __webpack_require__(46);

 /**
                                             * Copyright (c) 2015-present, Facebook, Inc.
                                             *
                                             * This source code is licensed under the MIT license found in the
                                             * LICENSE file in the root directory of this source tree.
                                             *
                                             *  strict
                                             */





function missingFieldArgMessage(fieldName, argName, type) {
  return 'Field "' + fieldName + '" argument "' + argName + '" of type ' + ('"' + String(type) + '" is required but not provided.');
}

function missingDirectiveArgMessage(directiveName, argName, type) {
  return 'Directive "@' + directiveName + '" argument "' + argName + '" of type ' + ('"' + String(type) + '" is required but not provided.');
}

/**
 * Provided required arguments
 *
 * A field or directive is only valid if all required (non-null) field arguments
 * have been provided.
 */
function ProvidedNonNullArguments(context) {
  return {
    Field: {
      // Validate on leave to allow for deeper errors to appear first.
      leave: function leave(node) {
        var fieldDef = context.getFieldDef();
        if (!fieldDef) {
          return false;
        }
        var argNodes = node.arguments || [];

        var argNodeMap = Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_keyMap__["a" /* default */])(argNodes, function (arg) {
          return arg.name.value;
        });
        fieldDef.args.forEach(function (argDef) {
          var argNode = argNodeMap[argDef.name];
          if (!argNode && Object(__WEBPACK_IMPORTED_MODULE_2__type_definition__["w" /* isNonNullType */])(argDef.type)) {
            context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* GraphQLError */](missingFieldArgMessage(node.name.value, argDef.name, argDef.type), [node]));
          }
        });
      }
    },

    Directive: {
      // Validate on leave to allow for deeper errors to appear first.
      leave: function leave(node) {
        var directiveDef = context.getDirective();
        if (!directiveDef) {
          return false;
        }
        var argNodes = node.arguments || [];

        var argNodeMap = Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_keyMap__["a" /* default */])(argNodes, function (arg) {
          return arg.name.value;
        });
        directiveDef.args.forEach(function (argDef) {
          var argNode = argNodeMap[argDef.name];
          if (!argNode && Object(__WEBPACK_IMPORTED_MODULE_2__type_definition__["w" /* isNonNullType */])(argDef.type)) {
            context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* GraphQLError */](missingDirectiveArgMessage(node.name.value, argDef.name, argDef.type), [node]));
          }
        });
      }
    }
  };
}

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultForRequiredVarMessage */
/* harmony export (immutable) */ __webpack_exports__["a"] = VariablesDefaultValueAllowed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type_definition__ = __webpack_require__(46);

 /**
                                             * Copyright (c) 2015-present, Facebook, Inc.
                                             *
                                             * This source code is licensed under the MIT license found in the
                                             * LICENSE file in the root directory of this source tree.
                                             *
                                             *  strict
                                             */




function defaultForRequiredVarMessage(varName, type, guessType) {
  return 'Variable "$' + varName + '" of type "' + String(type) + '" is required and ' + 'will not use the default value. ' + ('Perhaps you meant to use type "' + String(guessType) + '".');
}

/**
 * Variable's default value is allowed
 *
 * A GraphQL document is only valid if all variable default values are allowed
 * due to a variable not being required.
 */
function VariablesDefaultValueAllowed(context) {
  return {
    VariableDefinition: function VariableDefinition(node) {
      var name = node.variable.name.value;
      var defaultValue = node.defaultValue;
      var type = context.getInputType();
      if (Object(__WEBPACK_IMPORTED_MODULE_1__type_definition__["w" /* isNonNullType */])(type) && defaultValue) {
        context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* GraphQLError */](defaultForRequiredVarMessage(name, type, type.ofType), [defaultValue]));
      }
      return false; // Do not traverse further.
    },

    SelectionSet: function SelectionSet() {
      return false;
    },
    FragmentDefinition: function FragmentDefinition() {
      return false;
    }
  };
}

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export badVarPosMessage */
/* harmony export (immutable) */ __webpack_exports__["a"] = VariablesInAllowedPosition;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type_definition__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_typeComparators__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_typeFromAST__ = __webpack_require__(97);

 /**
                                             * Copyright (c) 2015-present, Facebook, Inc.
                                             *
                                             * This source code is licensed under the MIT license found in the
                                             * LICENSE file in the root directory of this source tree.
                                             *
                                             *  strict
                                             */






function badVarPosMessage(varName, varType, expectedType) {
  return 'Variable "$' + varName + '" of type "' + String(varType) + '" used in ' + ('position expecting type "' + String(expectedType) + '".');
}

/**
 * Variables passed to field arguments conform to type
 */
function VariablesInAllowedPosition(context) {
  var varDefMap = Object.create(null);

  return {
    OperationDefinition: {
      enter: function enter() {
        varDefMap = Object.create(null);
      },
      leave: function leave(operation) {
        var usages = context.getRecursiveVariableUsages(operation);

        usages.forEach(function (_ref) {
          var node = _ref.node,
              type = _ref.type;

          var varName = node.name.value;
          var varDef = varDefMap[varName];
          if (varDef && type) {
            // A var type is allowed if it is the same or more strict (e.g. is
            // a subtype of) than the expected type. It can be more strict if
            // the variable type is non-null when the expected type is nullable.
            // If both are list types, the variable item type can be more strict
            // than the expected item type (contravariant).
            var schema = context.getSchema();
            var varType = Object(__WEBPACK_IMPORTED_MODULE_3__utilities_typeFromAST__["a" /* typeFromAST */])(schema, varDef.type);
            if (varType && !Object(__WEBPACK_IMPORTED_MODULE_2__utilities_typeComparators__["c" /* isTypeSubTypeOf */])(schema, effectiveType(varType, varDef), type)) {
              context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* GraphQLError */](badVarPosMessage(varName, varType, type), [varDef, node]));
            }
          }
        });
      }
    },
    VariableDefinition: function VariableDefinition(node) {
      varDefMap[node.variable.name.value] = node;
    }
  };
}

// If a variable definition has a default value, it's effectively non-null.
function effectiveType(varType, varDef) {
  return !varDef.defaultValue || Object(__WEBPACK_IMPORTED_MODULE_1__type_definition__["w" /* isNonNullType */])(varType) ? varType : Object(__WEBPACK_IMPORTED_MODULE_1__type_definition__["e" /* GraphQLNonNull */])(varType);
}

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fieldsConflictMessage */
/* harmony export (immutable) */ __webpack_exports__["a"] = OverlappingFieldsCanBeMerged;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsutils_find__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__language_kinds__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__language_printer__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__type_definition__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_typeFromAST__ = __webpack_require__(97);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

 /**
                                             * Copyright (c) 2015-present, Facebook, Inc.
                                             *
                                             * This source code is licensed under the MIT license found in the
                                             * LICENSE file in the root directory of this source tree.
                                             *
                                             *  strict
                                             */










function fieldsConflictMessage(responseName, reason) {
  return 'Fields "' + responseName + '" conflict because ' + reasonMessage(reason) + '. Use different aliases on the fields to fetch both if this was ' + 'intentional.';
}

function reasonMessage(reason) {
  if (Array.isArray(reason)) {
    return reason.map(function (_ref) {
      var responseName = _ref[0],
          subreason = _ref[1];
      return 'subfields "' + responseName + '" conflict because ' + reasonMessage(subreason);
    }).join(' and ');
  }
  return reason;
}

/**
 * Overlapping fields can be merged
 *
 * A selection set is only valid if all fields (including spreading any
 * fragments) either correspond to distinct response names or can be merged
 * without ambiguity.
 */
function OverlappingFieldsCanBeMerged(context) {
  // A memoization for when two fragments are compared "between" each other for
  // conflicts. Two fragments may be compared many times, so memoizing this can
  // dramatically improve the performance of this validator.
  var comparedFragmentPairs = new PairSet();

  // A cache for the "field map" and list of fragment names found in any given
  // selection set. Selection sets may be asked for this information multiple
  // times, so this improves the performance of this validator.
  var cachedFieldsAndFragmentNames = new Map();

  return {
    SelectionSet: function SelectionSet(selectionSet) {
      var conflicts = findConflictsWithinSelectionSet(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, context.getParentType(), selectionSet);
      conflicts.forEach(function (_ref2) {
        var _ref2$ = _ref2[0],
            responseName = _ref2$[0],
            reason = _ref2$[1],
            fields1 = _ref2[1],
            fields2 = _ref2[2];
        return context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* GraphQLError */](fieldsConflictMessage(responseName, reason), fields1.concat(fields2)));
      });
    }
  };
}
// Field name and reason.

// Reason is a string, or a nested list of conflicts.

// Tuple defining a field node in a context.

// Map of array of those.


/**
 * Algorithm:
 *
 * Conflicts occur when two fields exist in a query which will produce the same
 * response name, but represent differing values, thus creating a conflict.
 * The algorithm below finds all conflicts via making a series of comparisons
 * between fields. In order to compare as few fields as possible, this makes
 * a series of comparisons "within" sets of fields and "between" sets of fields.
 *
 * Given any selection set, a collection produces both a set of fields by
 * also including all inline fragments, as well as a list of fragments
 * referenced by fragment spreads.
 *
 * A) Each selection set represented in the document first compares "within" its
 * collected set of fields, finding any conflicts between every pair of
 * overlapping fields.
 * Note: This is the *only time* that a the fields "within" a set are compared
 * to each other. After this only fields "between" sets are compared.
 *
 * B) Also, if any fragment is referenced in a selection set, then a
 * comparison is made "between" the original set of fields and the
 * referenced fragment.
 *
 * C) Also, if multiple fragments are referenced, then comparisons
 * are made "between" each referenced fragment.
 *
 * D) When comparing "between" a set of fields and a referenced fragment, first
 * a comparison is made between each field in the original set of fields and
 * each field in the the referenced set of fields.
 *
 * E) Also, if any fragment is referenced in the referenced selection set,
 * then a comparison is made "between" the original set of fields and the
 * referenced fragment (recursively referring to step D).
 *
 * F) When comparing "between" two fragments, first a comparison is made between
 * each field in the first referenced set of fields and each field in the the
 * second referenced set of fields.
 *
 * G) Also, any fragments referenced by the first must be compared to the
 * second, and any fragments referenced by the second must be compared to the
 * first (recursively referring to step F).
 *
 * H) When comparing two fields, if both have selection sets, then a comparison
 * is made "between" both selection sets, first comparing the set of fields in
 * the first selection set with the set of fields in the second.
 *
 * I) Also, if any fragment is referenced in either selection set, then a
 * comparison is made "between" the other set of fields and the
 * referenced fragment.
 *
 * J) Also, if two fragments are referenced in both selection sets, then a
 * comparison is made "between" the two fragments.
 *
 */

// Find all conflicts found "within" a selection set, including those found
// via spreading in fragments. Called when visiting each SelectionSet in the
// GraphQL Document.
function findConflictsWithinSelectionSet(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentType, selectionSet) {
  var conflicts = [];

  var _getFieldsAndFragment = getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType, selectionSet),
      fieldMap = _getFieldsAndFragment[0],
      fragmentNames = _getFieldsAndFragment[1];

  // (A) Find find all conflicts "within" the fields of this selection set.
  // Note: this is the *only place* `collectConflictsWithin` is called.


  collectConflictsWithin(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, fieldMap);

  if (fragmentNames.length !== 0) {
    // (B) Then collect conflicts between these fields and those represented by
    // each spread fragment name found.
    var comparedFragments = Object.create(null);
    for (var i = 0; i < fragmentNames.length; i++) {
      collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragments, comparedFragmentPairs, false, fieldMap, fragmentNames[i]);
      // (C) Then compare this fragment with all other fragments found in this
      // selection set to collect conflicts between fragments spread together.
      // This compares each item in the list of fragment names to every other
      // item in that same list (except for itself).
      for (var j = i + 1; j < fragmentNames.length; j++) {
        collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, false, fragmentNames[i], fragmentNames[j]);
      }
    }
  }
  return conflicts;
}

// Collect all conflicts found between a set of fields and a fragment reference
// including via spreading in any nested fragments.
function collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragments, comparedFragmentPairs, areMutuallyExclusive, fieldMap, fragmentName) {
  // Memoize so a fragment is not compared for conflicts more than once.
  if (comparedFragments[fragmentName]) {
    return;
  }
  comparedFragments[fragmentName] = true;

  var fragment = context.getFragment(fragmentName);
  if (!fragment) {
    return;
  }

  var _getReferencedFieldsA = getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment),
      fieldMap2 = _getReferencedFieldsA[0],
      fragmentNames2 = _getReferencedFieldsA[1];

  // Do not compare a fragment's fieldMap to itself.


  if (fieldMap === fieldMap2) {
    return;
  }

  // (D) First collect any conflicts between the provided collection of fields
  // and the collection of fields represented by the given fragment.
  collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap, fieldMap2);

  // (E) Then collect any conflicts between the provided collection of fields
  // and any fragment names found in the given fragment.
  for (var i = 0; i < fragmentNames2.length; i++) {
    collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragments, comparedFragmentPairs, areMutuallyExclusive, fieldMap, fragmentNames2[i]);
  }
}

// Collect all conflicts found between two fragments, including via spreading in
// any nested fragments.
function collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentName1, fragmentName2) {
  // No need to compare a fragment to itself.
  if (fragmentName1 === fragmentName2) {
    return;
  }

  // Memoize so two fragments are not compared for conflicts more than once.
  if (comparedFragmentPairs.has(fragmentName1, fragmentName2, areMutuallyExclusive)) {
    return;
  }
  comparedFragmentPairs.add(fragmentName1, fragmentName2, areMutuallyExclusive);

  var fragment1 = context.getFragment(fragmentName1);
  var fragment2 = context.getFragment(fragmentName2);
  if (!fragment1 || !fragment2) {
    return;
  }

  var _getReferencedFieldsA2 = getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment1),
      fieldMap1 = _getReferencedFieldsA2[0],
      fragmentNames1 = _getReferencedFieldsA2[1];

  var _getReferencedFieldsA3 = getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment2),
      fieldMap2 = _getReferencedFieldsA3[0],
      fragmentNames2 = _getReferencedFieldsA3[1];

  // (F) First, collect all conflicts between these two collections of fields
  // (not including any nested fragments).


  collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap1, fieldMap2);

  // (G) Then collect conflicts between the first fragment and any nested
  // fragments spread in the second fragment.
  for (var j = 0; j < fragmentNames2.length; j++) {
    collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentName1, fragmentNames2[j]);
  }

  // (G) Then collect conflicts between the second fragment and any nested
  // fragments spread in the first fragment.
  for (var i = 0; i < fragmentNames1.length; i++) {
    collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentNames1[i], fragmentName2);
  }
}

// Find all conflicts found between two selection sets, including those found
// via spreading in fragments. Called when determining if conflicts exist
// between the sub-fields of two overlapping fields.
function findConflictsBetweenSubSelectionSets(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, parentType1, selectionSet1, parentType2, selectionSet2) {
  var conflicts = [];

  var _getFieldsAndFragment2 = getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType1, selectionSet1),
      fieldMap1 = _getFieldsAndFragment2[0],
      fragmentNames1 = _getFieldsAndFragment2[1];

  var _getFieldsAndFragment3 = getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType2, selectionSet2),
      fieldMap2 = _getFieldsAndFragment3[0],
      fragmentNames2 = _getFieldsAndFragment3[1];

  // (H) First, collect all conflicts between these two collections of field.


  collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap1, fieldMap2);

  // (I) Then collect conflicts between the first collection of fields and
  // those referenced by each fragment name associated with the second.
  if (fragmentNames2.length !== 0) {
    var comparedFragments = Object.create(null);
    for (var j = 0; j < fragmentNames2.length; j++) {
      collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragments, comparedFragmentPairs, areMutuallyExclusive, fieldMap1, fragmentNames2[j]);
    }
  }

  // (I) Then collect conflicts between the second collection of fields and
  // those referenced by each fragment name associated with the first.
  if (fragmentNames1.length !== 0) {
    var _comparedFragments = Object.create(null);
    for (var i = 0; i < fragmentNames1.length; i++) {
      collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, _comparedFragments, comparedFragmentPairs, areMutuallyExclusive, fieldMap2, fragmentNames1[i]);
    }
  }

  // (J) Also collect conflicts between any fragment names by the first and
  // fragment names by the second. This compares each item in the first set of
  // names to each item in the second set of names.
  for (var _i = 0; _i < fragmentNames1.length; _i++) {
    for (var _j = 0; _j < fragmentNames2.length; _j++) {
      collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentNames1[_i], fragmentNames2[_j]);
    }
  }
  return conflicts;
}

// Collect all Conflicts "within" one collection of fields.
function collectConflictsWithin(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, fieldMap) {
  // A field map is a keyed collection, where each key represents a response
  // name and the value at that key is a list of all fields which provide that
  // response name. For every response name, if there are multiple fields, they
  // must be compared to find a potential conflict.
  Object.keys(fieldMap).forEach(function (responseName) {
    var fields = fieldMap[responseName];
    // This compares every field in the list to every other field in this list
    // (except to itself). If the list only has one item, nothing needs to
    // be compared.
    if (fields.length > 1) {
      for (var i = 0; i < fields.length; i++) {
        for (var j = i + 1; j < fields.length; j++) {
          var conflict = findConflict(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, false, // within one collection is never mutually exclusive
          responseName, fields[i], fields[j]);
          if (conflict) {
            conflicts.push(conflict);
          }
        }
      }
    }
  });
}

// Collect all Conflicts between two collections of fields. This is similar to,
// but different from the `collectConflictsWithin` function above. This check
// assumes that `collectConflictsWithin` has already been called on each
// provided collection of fields. This is true because this validator traverses
// each individual selection set.
function collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentFieldsAreMutuallyExclusive, fieldMap1, fieldMap2) {
  // A field map is a keyed collection, where each key represents a response
  // name and the value at that key is a list of all fields which provide that
  // response name. For any response name which appears in both provided field
  // maps, each field from the first field map must be compared to every field
  // in the second field map to find potential conflicts.
  Object.keys(fieldMap1).forEach(function (responseName) {
    var fields2 = fieldMap2[responseName];
    if (fields2) {
      var fields1 = fieldMap1[responseName];
      for (var i = 0; i < fields1.length; i++) {
        for (var j = 0; j < fields2.length; j++) {
          var conflict = findConflict(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentFieldsAreMutuallyExclusive, responseName, fields1[i], fields2[j]);
          if (conflict) {
            conflicts.push(conflict);
          }
        }
      }
    }
  });
}

// Determines if there is a conflict between two particular fields, including
// comparing their sub-fields.
function findConflict(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentFieldsAreMutuallyExclusive, responseName, field1, field2) {
  var parentType1 = field1[0],
      node1 = field1[1],
      def1 = field1[2];
  var parentType2 = field2[0],
      node2 = field2[1],
      def2 = field2[2];

  // If it is known that two fields could not possibly apply at the same
  // time, due to the parent types, then it is safe to permit them to diverge
  // in aliased field or arguments used as they will not present any ambiguity
  // by differing.
  // It is known that two parent types could never overlap if they are
  // different Object types. Interface or Union types might overlap - if not
  // in the current state of the schema, then perhaps in some future version,
  // thus may not safely diverge.

  var areMutuallyExclusive = parentFieldsAreMutuallyExclusive || parentType1 !== parentType2 && Object(__WEBPACK_IMPORTED_MODULE_4__type_definition__["x" /* isObjectType */])(parentType1) && Object(__WEBPACK_IMPORTED_MODULE_4__type_definition__["x" /* isObjectType */])(parentType2);

  // The return type for each field.
  var type1 = def1 && def1.type;
  var type2 = def2 && def2.type;

  if (!areMutuallyExclusive) {
    // Two aliases must refer to the same field.
    var name1 = node1.name.value;
    var name2 = node2.name.value;
    if (name1 !== name2) {
      return [[responseName, name1 + ' and ' + name2 + ' are different fields'], [node1], [node2]];
    }

    // Two field calls must have the same arguments.
    if (!sameArguments(node1.arguments || [], node2.arguments || [])) {
      return [[responseName, 'they have differing arguments'], [node1], [node2]];
    }
  }

  if (type1 && type2 && doTypesConflict(type1, type2)) {
    return [[responseName, 'they return conflicting types ' + String(type1) + ' and ' + String(type2)], [node1], [node2]];
  }

  // Collect and compare sub-fields. Use the same "visited fragment names" list
  // for both collections so fields in a fragment reference are never
  // compared to themselves.
  var selectionSet1 = node1.selectionSet;
  var selectionSet2 = node2.selectionSet;
  if (selectionSet1 && selectionSet2) {
    var conflicts = findConflictsBetweenSubSelectionSets(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, Object(__WEBPACK_IMPORTED_MODULE_4__type_definition__["l" /* getNamedType */])(type1), selectionSet1, Object(__WEBPACK_IMPORTED_MODULE_4__type_definition__["l" /* getNamedType */])(type2), selectionSet2);
    return subfieldConflicts(conflicts, responseName, node1, node2);
  }
}

function sameArguments(arguments1, arguments2) {
  if (arguments1.length !== arguments2.length) {
    return false;
  }
  return arguments1.every(function (argument1) {
    var argument2 = Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_find__["a" /* default */])(arguments2, function (argument) {
      return argument.name.value === argument1.name.value;
    });
    if (!argument2) {
      return false;
    }
    return sameValue(argument1.value, argument2.value);
  });
}

function sameValue(value1, value2) {
  return !value1 && !value2 || Object(__WEBPACK_IMPORTED_MODULE_3__language_printer__["a" /* print */])(value1) === Object(__WEBPACK_IMPORTED_MODULE_3__language_printer__["a" /* print */])(value2);
}

// Two types conflict if both types could not apply to a value simultaneously.
// Composite types are ignored as their individual field types will be compared
// later recursively. However List and Non-Null types must match.
function doTypesConflict(type1, type2) {
  if (Object(__WEBPACK_IMPORTED_MODULE_4__type_definition__["u" /* isListType */])(type1)) {
    return Object(__WEBPACK_IMPORTED_MODULE_4__type_definition__["u" /* isListType */])(type2) ? doTypesConflict(type1.ofType, type2.ofType) : true;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_4__type_definition__["u" /* isListType */])(type2)) {
    return true;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_4__type_definition__["w" /* isNonNullType */])(type1)) {
    return Object(__WEBPACK_IMPORTED_MODULE_4__type_definition__["w" /* isNonNullType */])(type2) ? doTypesConflict(type1.ofType, type2.ofType) : true;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_4__type_definition__["w" /* isNonNullType */])(type2)) {
    return true;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_4__type_definition__["t" /* isLeafType */])(type1) || Object(__WEBPACK_IMPORTED_MODULE_4__type_definition__["t" /* isLeafType */])(type2)) {
    return type1 !== type2;
  }
  return false;
}

// Given a selection set, return the collection of fields (a mapping of response
// name to field nodes and definitions) as well as a list of fragment names
// referenced via fragment spreads.
function getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType, selectionSet) {
  var cached = cachedFieldsAndFragmentNames.get(selectionSet);
  if (!cached) {
    var nodeAndDefs = Object.create(null);
    var fragmentNames = Object.create(null);
    _collectFieldsAndFragmentNames(context, parentType, selectionSet, nodeAndDefs, fragmentNames);
    cached = [nodeAndDefs, Object.keys(fragmentNames)];
    cachedFieldsAndFragmentNames.set(selectionSet, cached);
  }
  return cached;
}

// Given a reference to a fragment, return the represented collection of fields
// as well as a list of nested fragment names referenced via fragment spreads.
function getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment) {
  // Short-circuit building a type from the node if possible.
  var cached = cachedFieldsAndFragmentNames.get(fragment.selectionSet);
  if (cached) {
    return cached;
  }

  var fragmentType = Object(__WEBPACK_IMPORTED_MODULE_5__utilities_typeFromAST__["a" /* typeFromAST */])(context.getSchema(), fragment.typeCondition);
  return getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragmentType, fragment.selectionSet);
}

function _collectFieldsAndFragmentNames(context, parentType, selectionSet, nodeAndDefs, fragmentNames) {
  for (var i = 0; i < selectionSet.selections.length; i++) {
    var selection = selectionSet.selections[i];
    switch (selection.kind) {
      case __WEBPACK_IMPORTED_MODULE_2__language_kinds__["a" /* Kind */].FIELD:
        var fieldName = selection.name.value;
        var fieldDef = void 0;
        if (Object(__WEBPACK_IMPORTED_MODULE_4__type_definition__["x" /* isObjectType */])(parentType) || Object(__WEBPACK_IMPORTED_MODULE_4__type_definition__["s" /* isInterfaceType */])(parentType)) {
          fieldDef = parentType.getFields()[fieldName];
        }
        var responseName = selection.alias ? selection.alias.value : fieldName;
        if (!nodeAndDefs[responseName]) {
          nodeAndDefs[responseName] = [];
        }
        nodeAndDefs[responseName].push([parentType, selection, fieldDef]);
        break;
      case __WEBPACK_IMPORTED_MODULE_2__language_kinds__["a" /* Kind */].FRAGMENT_SPREAD:
        fragmentNames[selection.name.value] = true;
        break;
      case __WEBPACK_IMPORTED_MODULE_2__language_kinds__["a" /* Kind */].INLINE_FRAGMENT:
        var typeCondition = selection.typeCondition;
        var inlineFragmentType = typeCondition ? Object(__WEBPACK_IMPORTED_MODULE_5__utilities_typeFromAST__["a" /* typeFromAST */])(context.getSchema(), typeCondition) : parentType;
        _collectFieldsAndFragmentNames(context, inlineFragmentType, selection.selectionSet, nodeAndDefs, fragmentNames);
        break;
    }
  }
}

// Given a series of Conflicts which occurred between two sub-fields, generate
// a single Conflict.
function subfieldConflicts(conflicts, responseName, node1, node2) {
  if (conflicts.length > 0) {
    return [[responseName, conflicts.map(function (_ref3) {
      var reason = _ref3[0];
      return reason;
    })], conflicts.reduce(function (allFields, _ref4) {
      var fields1 = _ref4[1];
      return allFields.concat(fields1);
    }, [node1]), conflicts.reduce(function (allFields, _ref5) {
      var fields2 = _ref5[2];
      return allFields.concat(fields2);
    }, [node2])];
  }
}

/**
 * A way to keep track of pairs of things when the ordering of the pair does
 * not matter. We do this by maintaining a sort of double adjacency sets.
 */

var PairSet = function () {
  function PairSet() {
    _classCallCheck(this, PairSet);

    this._data = Object.create(null);
  }

  PairSet.prototype.has = function has(a, b, areMutuallyExclusive) {
    var first = this._data[a];
    var result = first && first[b];
    if (result === undefined) {
      return false;
    }
    // areMutuallyExclusive being false is a superset of being true,
    // hence if we want to know if this PairSet "has" these two with no
    // exclusivity, we have to ensure it was added as such.
    if (areMutuallyExclusive === false) {
      return result === false;
    }
    return true;
  };

  PairSet.prototype.add = function add(a, b, areMutuallyExclusive) {
    _pairSetAdd(this._data, a, b, areMutuallyExclusive);
    _pairSetAdd(this._data, b, a, areMutuallyExclusive);
  };

  return PairSet;
}();

function _pairSetAdd(data, a, b, areMutuallyExclusive) {
  var map = data[a];
  if (!map) {
    map = Object.create(null);
    data[a] = map;
  }
  map[b] = areMutuallyExclusive;
}

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export duplicateInputFieldMessage */
/* harmony export (immutable) */ __webpack_exports__["a"] = UniqueInputFieldNames;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__(43);

 /**
                                             * Copyright (c) 2015-present, Facebook, Inc.
                                             *
                                             * This source code is licensed under the MIT license found in the
                                             * LICENSE file in the root directory of this source tree.
                                             *
                                             *  strict
                                             */

function duplicateInputFieldMessage(fieldName) {
  return 'There can be only one input field named "' + fieldName + '".';
}

/**
 * Unique input field names
 *
 * A GraphQL input object value is only valid if all supplied fields are
 * uniquely named.
 */
function UniqueInputFieldNames(context) {
  var knownNameStack = [];
  var knownNames = Object.create(null);

  return {
    ObjectValue: {
      enter: function enter() {
        knownNameStack.push(knownNames);
        knownNames = Object.create(null);
      },
      leave: function leave() {
        knownNames = knownNameStack.pop();
      }
    },
    ObjectField: function ObjectField(node) {
      var fieldName = node.name.value;
      if (knownNames[fieldName]) {
        context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* GraphQLError */](duplicateInputFieldMessage(fieldName), [knownNames[fieldName], node.name]));
      } else {
        knownNames[fieldName] = node.name;
      }
      return false;
    }
  };
}

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPromise;


// eslint-disable-next-line no-redeclare
function isPromise(value) {
  return Boolean(value && typeof value.then === 'function');
} /**
   * Copyright (c) 2015-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *
   *  strict
   */

/**
 * Returns true if the value acts like a Promise, i.e. has a "then" function,
 * otherwise returns false.
 */

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getIntrospectionQuery;
/* unused harmony export introspectionQuery */
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

function getIntrospectionQuery(options) {
  var descriptions = !(options && options.descriptions === false);
  return '\n    query IntrospectionQuery {\n      __schema {\n        queryType { name }\n        mutationType { name }\n        subscriptionType { name }\n        types {\n          ...FullType\n        }\n        directives {\n          name\n          ' + (descriptions ? 'description' : '') + '\n          locations\n          args {\n            ...InputValue\n          }\n        }\n      }\n    }\n\n    fragment FullType on __Type {\n      kind\n      name\n      ' + (descriptions ? 'description' : '') + '\n      fields(includeDeprecated: true) {\n        name\n        ' + (descriptions ? 'description' : '') + '\n        args {\n          ...InputValue\n        }\n        type {\n          ...TypeRef\n        }\n        isDeprecated\n        deprecationReason\n      }\n      inputFields {\n        ...InputValue\n      }\n      interfaces {\n        ...TypeRef\n      }\n      enumValues(includeDeprecated: true) {\n        name\n        ' + (descriptions ? 'description' : '') + '\n        isDeprecated\n        deprecationReason\n      }\n      possibleTypes {\n        ...TypeRef\n      }\n    }\n\n    fragment InputValue on __InputValue {\n      name\n      ' + (descriptions ? 'description' : '') + '\n      type { ...TypeRef }\n      defaultValue\n    }\n\n    fragment TypeRef on __Type {\n      kind\n      name\n      ofType {\n        kind\n        name\n        ofType {\n          kind\n          name\n          ofType {\n            kind\n            name\n            ofType {\n              kind\n              name\n              ofType {\n                kind\n                name\n                ofType {\n                  kind\n                  name\n                  ofType {\n                    kind\n                    name\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  ';
}

var introspectionQuery = getIntrospectionQuery();

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export buildASTSchema */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ASTDefinitionBuilder; });
/* unused harmony export getDescription */
/* unused harmony export buildSchema */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsutils_keyMap__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsutils_keyValMap__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__valueFromAST__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__language_blockStringValue__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__language_lexer__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__language_parser__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__execution_values__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__language_kinds__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__type_definition__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__type_directives__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__type_introspection__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__type_scalars__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__type_schema__ = __webpack_require__(75);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */























function buildWrappedType(innerType, inputTypeNode) {
  if (inputTypeNode.kind === __WEBPACK_IMPORTED_MODULE_7__language_kinds__["a" /* Kind */].LIST_TYPE) {
    return Object(__WEBPACK_IMPORTED_MODULE_8__type_definition__["d" /* GraphQLList */])(buildWrappedType(innerType, inputTypeNode.type));
  }
  if (inputTypeNode.kind === __WEBPACK_IMPORTED_MODULE_7__language_kinds__["a" /* Kind */].NON_NULL_TYPE) {
    var wrappedType = buildWrappedType(innerType, inputTypeNode.type);
    return Object(__WEBPACK_IMPORTED_MODULE_8__type_definition__["e" /* GraphQLNonNull */])(Object(__WEBPACK_IMPORTED_MODULE_8__type_definition__["j" /* assertNullableType */])(wrappedType));
  }
  return innerType;
}

function getNamedTypeNode(typeNode) {
  var namedType = typeNode;
  while (namedType.kind === __WEBPACK_IMPORTED_MODULE_7__language_kinds__["a" /* Kind */].LIST_TYPE || namedType.kind === __WEBPACK_IMPORTED_MODULE_7__language_kinds__["a" /* Kind */].NON_NULL_TYPE) {
    namedType = namedType.type;
  }
  return namedType;
}

/**
 * This takes the ast of a schema document produced by the parse function in
 * src/language/parser.js.
 *
 * If no schema definition is provided, then it will look for types named Query
 * and Mutation.
 *
 * Given that AST it constructs a GraphQLSchema. The resulting schema
 * has no resolve methods, so execution will use default resolvers.
 *
 * Accepts options as a second argument:
 *
 *    - commentDescriptions:
 *        Provide true to use preceding comments as the description.
 *
 */
function buildASTSchema(ast, options) {
  if (!ast || ast.kind !== __WEBPACK_IMPORTED_MODULE_7__language_kinds__["a" /* Kind */].DOCUMENT) {
    throw new Error('Must provide a document ast.');
  }

  var schemaDef = void 0;

  var typeDefs = [];
  var nodeMap = Object.create(null);
  var directiveDefs = [];
  for (var i = 0; i < ast.definitions.length; i++) {
    var d = ast.definitions[i];
    switch (d.kind) {
      case __WEBPACK_IMPORTED_MODULE_7__language_kinds__["a" /* Kind */].SCHEMA_DEFINITION:
        if (schemaDef) {
          throw new Error('Must provide only one schema definition.');
        }
        schemaDef = d;
        break;
      case __WEBPACK_IMPORTED_MODULE_7__language_kinds__["a" /* Kind */].SCALAR_TYPE_DEFINITION:
      case __WEBPACK_IMPORTED_MODULE_7__language_kinds__["a" /* Kind */].OBJECT_TYPE_DEFINITION:
      case __WEBPACK_IMPORTED_MODULE_7__language_kinds__["a" /* Kind */].INTERFACE_TYPE_DEFINITION:
      case __WEBPACK_IMPORTED_MODULE_7__language_kinds__["a" /* Kind */].ENUM_TYPE_DEFINITION:
      case __WEBPACK_IMPORTED_MODULE_7__language_kinds__["a" /* Kind */].UNION_TYPE_DEFINITION:
      case __WEBPACK_IMPORTED_MODULE_7__language_kinds__["a" /* Kind */].INPUT_OBJECT_TYPE_DEFINITION:
        var typeName = d.name.value;
        if (nodeMap[typeName]) {
          throw new Error('Type "' + typeName + '" was defined more than once.');
        }
        typeDefs.push(d);
        nodeMap[typeName] = d;
        break;
      case __WEBPACK_IMPORTED_MODULE_7__language_kinds__["a" /* Kind */].DIRECTIVE_DEFINITION:
        directiveDefs.push(d);
        break;
    }
  }

  var operationTypes = schemaDef ? getOperationTypes(schemaDef) : {
    query: nodeMap.Query,
    mutation: nodeMap.Mutation,
    subscription: nodeMap.Subscription
  };

  var definitionBuilder = new ASTDefinitionBuilder(nodeMap, options, function (typeRef) {
    throw new Error('Type "' + typeRef.name.value + '" not found in document.');
  });

  var types = definitionBuilder.buildTypes(typeDefs);
  var directives = directiveDefs.map(function (def) {
    return definitionBuilder.buildDirective(def);
  });

  // If specified directives were not explicitly declared, add them.
  if (!directives.some(function (directive) {
    return directive.name === 'skip';
  })) {
    directives.push(__WEBPACK_IMPORTED_MODULE_9__type_directives__["e" /* GraphQLSkipDirective */]);
  }

  if (!directives.some(function (directive) {
    return directive.name === 'include';
  })) {
    directives.push(__WEBPACK_IMPORTED_MODULE_9__type_directives__["d" /* GraphQLIncludeDirective */]);
  }

  if (!directives.some(function (directive) {
    return directive.name === 'deprecated';
  })) {
    directives.push(__WEBPACK_IMPORTED_MODULE_9__type_directives__["b" /* GraphQLDeprecatedDirective */]);
  }

  // Note: While this could make early assertions to get the correctly
  // typed values below, that would throw immediately while type system
  // validation with validateSchema() will produce more actionable results.
  return new __WEBPACK_IMPORTED_MODULE_12__type_schema__["a" /* GraphQLSchema */]({
    query: operationTypes.query ? definitionBuilder.buildType(operationTypes.query) : null,
    mutation: operationTypes.mutation ? definitionBuilder.buildType(operationTypes.mutation) : null,
    subscription: operationTypes.subscription ? definitionBuilder.buildType(operationTypes.subscription) : null,
    types: types,
    directives: directives,
    astNode: schemaDef,
    assumeValid: options && options.assumeValid,
    allowedLegacyNames: options && options.allowedLegacyNames
  });

  function getOperationTypes(schema) {
    var opTypes = {};
    schema.operationTypes.forEach(function (operationType) {
      var typeName = operationType.type.name.value;
      var operation = operationType.operation;
      if (opTypes[operation]) {
        throw new Error('Must provide only one ' + operation + ' type in schema.');
      }
      if (!nodeMap[typeName]) {
        throw new Error('Specified ' + operation + ' type "' + typeName + '" not found in document.');
      }
      opTypes[operation] = operationType.type;
    });
    return opTypes;
  }
}

var ASTDefinitionBuilder = function () {
  function ASTDefinitionBuilder(typeDefinitionsMap, options, resolveType) {
    _classCallCheck(this, ASTDefinitionBuilder);

    this._typeDefinitionsMap = typeDefinitionsMap;
    this._options = options;
    this._resolveType = resolveType;
    // Initialize to the GraphQL built in scalars and introspection types.
    this._cache = Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_keyMap__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_11__type_scalars__["e" /* specifiedScalarTypes */].concat(__WEBPACK_IMPORTED_MODULE_10__type_introspection__["f" /* introspectionTypes */]), function (type) {
      return type.name;
    });
  }

  ASTDefinitionBuilder.prototype.buildTypes = function buildTypes(nodes) {
    var _this = this;

    return nodes.map(function (node) {
      return _this.buildType(node);
    });
  };

  ASTDefinitionBuilder.prototype.buildType = function buildType(node) {
    var typeName = node.name.value;
    if (!this._cache[typeName]) {
      if (node.kind === __WEBPACK_IMPORTED_MODULE_7__language_kinds__["a" /* Kind */].NAMED_TYPE) {
        var defNode = this._typeDefinitionsMap[typeName];
        this._cache[typeName] = defNode ? this._makeSchemaDef(defNode) : this._resolveType(node);
      } else {
        this._cache[typeName] = this._makeSchemaDef(node);
      }
    }
    return this._cache[typeName];
  };

  ASTDefinitionBuilder.prototype._buildWrappedType = function _buildWrappedType(typeNode) {
    var typeDef = this.buildType(getNamedTypeNode(typeNode));
    return buildWrappedType(typeDef, typeNode);
  };

  ASTDefinitionBuilder.prototype.buildDirective = function buildDirective(directiveNode) {
    return new __WEBPACK_IMPORTED_MODULE_9__type_directives__["c" /* GraphQLDirective */]({
      name: directiveNode.name.value,
      description: getDescription(directiveNode, this._options),
      locations: directiveNode.locations.map(function (node) {
        return node.value;
      }),
      args: directiveNode.arguments && this._makeInputValues(directiveNode.arguments),
      astNode: directiveNode
    });
  };

  ASTDefinitionBuilder.prototype.buildField = function buildField(field) {
    return {
      // Note: While this could make assertions to get the correctly typed
      // value, that would throw immediately while type system validation
      // with validateSchema() will produce more actionable results.
      type: this._buildWrappedType(field.type),
      description: getDescription(field, this._options),
      args: field.arguments && this._makeInputValues(field.arguments),
      deprecationReason: getDeprecationReason(field),
      astNode: field
    };
  };

  ASTDefinitionBuilder.prototype._makeSchemaDef = function _makeSchemaDef(def) {
    switch (def.kind) {
      case __WEBPACK_IMPORTED_MODULE_7__language_kinds__["a" /* Kind */].OBJECT_TYPE_DEFINITION:
        return this._makeTypeDef(def);
      case __WEBPACK_IMPORTED_MODULE_7__language_kinds__["a" /* Kind */].INTERFACE_TYPE_DEFINITION:
        return this._makeInterfaceDef(def);
      case __WEBPACK_IMPORTED_MODULE_7__language_kinds__["a" /* Kind */].ENUM_TYPE_DEFINITION:
        return this._makeEnumDef(def);
      case __WEBPACK_IMPORTED_MODULE_7__language_kinds__["a" /* Kind */].UNION_TYPE_DEFINITION:
        return this._makeUnionDef(def);
      case __WEBPACK_IMPORTED_MODULE_7__language_kinds__["a" /* Kind */].SCALAR_TYPE_DEFINITION:
        return this._makeScalarDef(def);
      case __WEBPACK_IMPORTED_MODULE_7__language_kinds__["a" /* Kind */].INPUT_OBJECT_TYPE_DEFINITION:
        return this._makeInputObjectDef(def);
      default:
        throw new Error('Type kind "' + def.kind + '" not supported.');
    }
  };

  ASTDefinitionBuilder.prototype._makeTypeDef = function _makeTypeDef(def) {
    var _this2 = this;

    var typeName = def.name.value;
    var interfaces = def.interfaces;
    return new __WEBPACK_IMPORTED_MODULE_8__type_definition__["f" /* GraphQLObjectType */]({
      name: typeName,
      description: getDescription(def, this._options),
      fields: function fields() {
        return _this2._makeFieldDefMap(def);
      },
      // Note: While this could make early assertions to get the correctly
      // typed values, that would throw immediately while type system
      // validation with validateSchema() will produce more actionable results.
      interfaces: interfaces ? function () {
        return _this2.buildTypes(interfaces);
      } : [],
      astNode: def
    });
  };

  ASTDefinitionBuilder.prototype._makeFieldDefMap = function _makeFieldDefMap(def) {
    var _this3 = this;

    return def.fields ? Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_keyValMap__["a" /* default */])(def.fields, function (field) {
      return field.name.value;
    }, function (field) {
      return _this3.buildField(field);
    }) : {};
  };

  ASTDefinitionBuilder.prototype._makeInputValues = function _makeInputValues(values) {
    var _this4 = this;

    return Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_keyValMap__["a" /* default */])(values, function (value) {
      return value.name.value;
    }, function (value) {
      // Note: While this could make assertions to get the correctly typed
      // value, that would throw immediately while type system validation
      var type = _this4._buildWrappedType(value.type);
      return {
        type: type,
        description: getDescription(value, _this4._options),
        defaultValue: Object(__WEBPACK_IMPORTED_MODULE_2__valueFromAST__["a" /* valueFromAST */])(value.defaultValue, type),
        astNode: value
      };
    });
  };

  ASTDefinitionBuilder.prototype._makeInterfaceDef = function _makeInterfaceDef(def) {
    var _this5 = this;

    return new __WEBPACK_IMPORTED_MODULE_8__type_definition__["c" /* GraphQLInterfaceType */]({
      name: def.name.value,
      description: getDescription(def, this._options),
      fields: function fields() {
        return _this5._makeFieldDefMap(def);
      },
      astNode: def
    });
  };

  ASTDefinitionBuilder.prototype._makeEnumDef = function _makeEnumDef(def) {
    var _this6 = this;

    return new __WEBPACK_IMPORTED_MODULE_8__type_definition__["a" /* GraphQLEnumType */]({
      name: def.name.value,
      description: getDescription(def, this._options),
      values: def.values ? Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_keyValMap__["a" /* default */])(def.values, function (enumValue) {
        return enumValue.name.value;
      }, function (enumValue) {
        return {
          description: getDescription(enumValue, _this6._options),
          deprecationReason: getDeprecationReason(enumValue),
          astNode: enumValue
        };
      }) : {},
      astNode: def
    });
  };

  ASTDefinitionBuilder.prototype._makeUnionDef = function _makeUnionDef(def) {
    return new __WEBPACK_IMPORTED_MODULE_8__type_definition__["h" /* GraphQLUnionType */]({
      name: def.name.value,
      description: getDescription(def, this._options),
      // Note: While this could make assertions to get the correctly typed
      // values below, that would throw immediately while type system
      // validation with validateSchema() will produce more actionable results.
      types: def.types ? this.buildTypes(def.types) : [],
      astNode: def
    });
  };

  ASTDefinitionBuilder.prototype._makeScalarDef = function _makeScalarDef(def) {
    return new __WEBPACK_IMPORTED_MODULE_8__type_definition__["g" /* GraphQLScalarType */]({
      name: def.name.value,
      description: getDescription(def, this._options),
      astNode: def,
      serialize: function serialize(value) {
        return value;
      }
    });
  };

  ASTDefinitionBuilder.prototype._makeInputObjectDef = function _makeInputObjectDef(def) {
    var _this7 = this;

    return new __WEBPACK_IMPORTED_MODULE_8__type_definition__["b" /* GraphQLInputObjectType */]({
      name: def.name.value,
      description: getDescription(def, this._options),
      fields: function fields() {
        return def.fields ? _this7._makeInputValues(def.fields) : {};
      },
      astNode: def
    });
  };

  return ASTDefinitionBuilder;
}();

/**
 * Given a field or enum value node, returns the string value for the
 * deprecation reason.
 */
function getDeprecationReason(node) {
  var deprecated = Object(__WEBPACK_IMPORTED_MODULE_6__execution_values__["b" /* getDirectiveValues */])(__WEBPACK_IMPORTED_MODULE_9__type_directives__["b" /* GraphQLDeprecatedDirective */], node);
  return deprecated && deprecated.reason;
}

/**
 * Given an ast node, returns its string description.
 *
 * Accepts options as a second argument:
 *
 *    - commentDescriptions:
 *        Provide true to use preceding comments as the description.
 *
 */
function getDescription(node, options) {
  if (node.description) {
    return node.description.value;
  }
  if (options && options.commentDescriptions) {
    var rawValue = getLeadingCommentBlock(node);
    if (rawValue !== undefined) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__language_blockStringValue__["a" /* default */])('\n' + rawValue);
    }
  }
}

function getLeadingCommentBlock(node) {
  var loc = node.loc;
  if (!loc) {
    return;
  }
  var comments = [];
  var token = loc.startToken.prev;
  while (token && token.kind === __WEBPACK_IMPORTED_MODULE_4__language_lexer__["a" /* TokenKind */].COMMENT && token.next && token.prev && token.line + 1 === token.next.line && token.line !== token.prev.line) {
    var value = String(token.value);
    comments.push(value);
    token = token.prev;
  }
  return comments.reverse().join('\n');
}

/**
 * A helper function to build a GraphQLSchema directly from a source
 * document.
 */
function buildSchema(source, options) {
  return buildASTSchema(Object(__WEBPACK_IMPORTED_MODULE_5__language_parser__["a" /* parse */])(source, options), options);
}

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Observable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zen_observable__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zen_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_zen_observable__);


var Observable = __WEBPACK_IMPORTED_MODULE_0_zen_observable___default.a;

/* harmony default export */ __webpack_exports__["a"] = (Observable);

//# sourceMappingURL=bundle.esm.js.map


/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(711);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["default"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(72), __webpack_require__(710)(module)))

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(283);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(285),
    getRawTag = __webpack_require__(722),
    objectToString = __webpack_require__(723);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(730),
    getValue = __webpack_require__(735);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

var metaMap = __webpack_require__(738),
    noop = __webpack_require__(740);

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

module.exports = getData;


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

var realNames = __webpack_require__(741);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = realNames[result],
      length = hasOwnProperty.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

module.exports = getFuncName;


/***/ }),
/* 432 */
/***/ (function(module, exports) {

exports.__esModule = true;
var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};

var TAG_NAMES = exports.TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};

var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
    return TAG_NAMES[name];
});

var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src"
};

var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};

var HELMET_PROPS = exports.HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};

var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
    obj[REACT_TAG_MAP[key]] = key;
    return obj;
}, {});

var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];

var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createGenerateClassName;

var _warning = _interopRequireDefault(__webpack_require__(37));

/* eslint-disable no-underscore-dangle */
// People might bundle this classname generator twice.
// We need to use a global.
global.__MUI_GENERATOR_COUNTER__ = 0;
var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;

function safePrefix(classNamePrefix) {
  var prefix = String(classNamePrefix);
   false ? (0, _warning.default)(prefix.length < 256, "Material-UI: the class name prefix is too long: ".concat(prefix, ".")) : void 0; // Sanitize the string as will be used to prefix the generated class name.

  return prefix.replace(escapeRegex, '-');
} // Returns a function which generates unique class names based on counters.
// When new generator function is created, rule counter is reset.
// We need to reset the rule counter for SSR for each request.
//
// It's inspired by
// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js


function createGenerateClassName() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$dangerouslyU = options.dangerouslyUseGlobalCSS,
      dangerouslyUseGlobalCSS = _options$dangerouslyU === void 0 ? false : _options$dangerouslyU,
      _options$productionPr = options.productionPrefix,
      productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr;
  var ruleCounter = 0; // - HMR can lead to many class name generators being instantiated,
  // so the warning is only triggered in production.
  // - We expect a class name generator to be instantiated per new request on the server,
  // so the warning is only triggered client side.

  if ("production" === 'production' && typeof window !== 'undefined') {
    global.__MUI_GENERATOR_COUNTER__ += 1;

    if (global.__MUI_GENERATOR_COUNTER__ > 2) {
      // eslint-disable-next-line no-console
      console.error(['Material-UI: we have detected more than needed creation of the class name generator.', 'You should only use one class name generator on the client side.', 'If you do otherwise, you take the risk to have conflicting class names in production.'].join('\n'));
    }
  }

  return function (rule, styleSheet) {
    ruleCounter += 1;
     false ? (0, _warning.default)(ruleCounter < 1e10, ['Material-UI: you might have a memory leak.', 'The ruleCounter is not supposed to grow that much.'].join('')) : void 0; // Code branch the whole block at the expense of more code.

    if (dangerouslyUseGlobalCSS) {
      if (styleSheet) {
        if (styleSheet.options.name) {
          return "".concat(styleSheet.options.name, "-").concat(rule.key);
        }

        if (styleSheet.options.classNamePrefix && "production" !== 'production') {
          var prefix = safePrefix(styleSheet.options.classNamePrefix);
          return "".concat(prefix, "-").concat(rule.key, "-").concat(ruleCounter);
        }
      }

      if (true) {
        return "".concat(productionPrefix).concat(ruleCounter);
      }

      return "".concat(rule.key, "-").concat(ruleCounter);
    }

    if (true) {
      return "".concat(productionPrefix).concat(ruleCounter);
    }

    if (styleSheet && styleSheet.options.classNamePrefix) {
      var _prefix = safePrefix(styleSheet.options.classNamePrefix);

      return "".concat(_prefix, "-").concat(rule.key, "-").concat(ruleCounter);
    }

    return "".concat(rule.key, "-").concat(ruleCounter);
  };
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(72)))

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var indigo = {
  50: '#e8eaf6',
  100: '#c5cae9',
  200: '#9fa8da',
  300: '#7986cb',
  400: '#5c6bc0',
  500: '#3f51b5',
  600: '#3949ab',
  700: '#303f9f',
  800: '#283593',
  900: '#1a237e',
  A100: '#8c9eff',
  A200: '#536dfe',
  A400: '#3d5afe',
  A700: '#304ffe'
};
var _default = indigo;
exports.default = _default;

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var pink = {
  50: '#fce4ec',
  100: '#f8bbd0',
  200: '#f48fb1',
  300: '#f06292',
  400: '#ec407a',
  500: '#e91e63',
  600: '#d81b60',
  700: '#c2185b',
  800: '#ad1457',
  900: '#880e4f',
  A100: '#ff80ab',
  A200: '#ff4081',
  A400: '#f50057',
  A700: '#c51162'
};
var _default = pink;
exports.default = _default;

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#d5d5d5',
  A200: '#aaaaaa',
  A400: '#303030',
  A700: '#616161'
};
var _default = grey;
exports.default = _default;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};
var _default = red;
exports.default = _default;

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var common = {
  black: '#000',
  white: '#fff'
};
var _default = common;
exports.default = _default;

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var zIndex = {
  mobileStepper: 1000,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
var _default = zIndex;
exports.default = _default;

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jssGlobal = _interopRequireDefault(__webpack_require__(760));

var _jssNested = _interopRequireDefault(__webpack_require__(778));

var _jssCamelCase = _interopRequireDefault(__webpack_require__(780));

var _jssDefaultUnit = _interopRequireDefault(__webpack_require__(782));

var _jssVendorPrefixer = _interopRequireDefault(__webpack_require__(784));

var _jssPropsSort = _interopRequireDefault(__webpack_require__(789));

// Subset of jss-preset-default with only the plugins the Material-UI
// components are using.
function jssPreset() {
  return {
    plugins: [(0, _jssGlobal.default)(), (0, _jssNested.default)(), (0, _jssCamelCase.default)(), (0, _jssDefaultUnit.default)(), (0, _jssVendorPrefixer.default)(), (0, _jssPropsSort.default)()]
  };
}

var _default = jssPreset;
exports.default = _default;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = exports.createGenerateClassName = exports.sheets = exports.RuleList = exports.SheetsManager = exports.SheetsRegistry = exports.toCssValue = exports.getDynamicStyles = undefined;

var _getDynamicStyles = __webpack_require__(761);

Object.defineProperty(exports, 'getDynamicStyles', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getDynamicStyles)['default'];
  }
});

var _toCssValue = __webpack_require__(216);

Object.defineProperty(exports, 'toCssValue', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_toCssValue)['default'];
  }
});

var _SheetsRegistry = __webpack_require__(442);

Object.defineProperty(exports, 'SheetsRegistry', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SheetsRegistry)['default'];
  }
});

var _SheetsManager = __webpack_require__(762);

Object.defineProperty(exports, 'SheetsManager', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SheetsManager)['default'];
  }
});

var _RuleList = __webpack_require__(174);

Object.defineProperty(exports, 'RuleList', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RuleList)['default'];
  }
});

var _sheets = __webpack_require__(292);

Object.defineProperty(exports, 'sheets', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_sheets)['default'];
  }
});

var _createGenerateClassName = __webpack_require__(445);

Object.defineProperty(exports, 'createGenerateClassName', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_createGenerateClassName)['default'];
  }
});

var _Jss = __webpack_require__(766);

var _Jss2 = _interopRequireDefault(_Jss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Creates a new instance of Jss.
 */
var create = exports.create = function create(options) {
  return new _Jss2['default'](options);
};

/**
 * A global Jss instance.
 */
exports['default'] = create();

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Sheets registry to access them all at one place.
 */
var SheetsRegistry = function () {
  function SheetsRegistry() {
    _classCallCheck(this, SheetsRegistry);

    this.registry = [];
  }

  _createClass(SheetsRegistry, [{
    key: 'add',


    /**
     * Register a Style Sheet.
     */
    value: function add(sheet) {
      var registry = this.registry;
      var index = sheet.options.index;


      if (registry.indexOf(sheet) !== -1) return;

      if (registry.length === 0 || index >= this.index) {
        registry.push(sheet);
        return;
      }

      // Find a position.
      for (var i = 0; i < registry.length; i++) {
        if (registry[i].options.index > index) {
          registry.splice(i, 0, sheet);
          return;
        }
      }
    }

    /**
     * Reset the registry.
     */

  }, {
    key: 'reset',
    value: function reset() {
      this.registry = [];
    }

    /**
     * Remove a Style Sheet.
     */

  }, {
    key: 'remove',
    value: function remove(sheet) {
      var index = this.registry.indexOf(sheet);
      this.registry.splice(index, 1);
    }

    /**
     * Convert all attached sheets to a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      return this.registry.filter(function (sheet) {
        return sheet.attached;
      }).map(function (sheet) {
        return sheet.toString(options);
      }).join('\n');
    }
  }, {
    key: 'index',


    /**
     * Current highest index number.
     */
    get: function get() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]);

  return SheetsRegistry;
}();

exports['default'] = SheetsRegistry;

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _symbolObservable = __webpack_require__(426);

var _symbolObservable2 = _interopRequireDefault(_symbolObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = function (value) {
  return value && value[_symbolObservable2['default']] && value === value[_symbolObservable2['default']]();
};

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = linkRule;
/**
 * Link rule with CSSStyleRule and nested rules with corresponding nested cssRules if both exists.
 */
function linkRule(rule, cssRule) {
  rule.renderable = cssRule;
  if (rule.rules && cssRule.cssRules) rule.rules.link(cssRule.cssRules);
}

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _warning = __webpack_require__(142);

var _warning2 = _interopRequireDefault(_warning);

var _StyleSheet = __webpack_require__(446);

var _StyleSheet2 = _interopRequireDefault(_StyleSheet);

var _moduleId = __webpack_require__(765);

var _moduleId2 = _interopRequireDefault(_moduleId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var maxRules = 1e10;


var env = "production";

/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */

exports['default'] = function () {
  var ruleCounter = 0;
  var defaultPrefix = env === 'production' ? 'c' : '';

  return function (rule, sheet) {
    ruleCounter += 1;

    if (ruleCounter > maxRules) {
      (0, _warning2['default'])(false, '[JSS] You might have a memory leak. Rule counter is at %s.', ruleCounter);
    }

    var prefix = defaultPrefix;
    var jssId = '';

    if (sheet) {
      prefix = sheet.options.classNamePrefix || defaultPrefix;
      if (sheet.options.jss.id != null) jssId += sheet.options.jss.id;
    }

    if (env === 'production') {
      return '' + prefix + _moduleId2['default'] + jssId + ruleCounter;
    }

    return prefix + rule.key + '-' + _moduleId2['default'] + (jssId && '-' + jssId) + '-' + ruleCounter;
  };
};

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _linkRule = __webpack_require__(444);

var _linkRule2 = _interopRequireDefault(_linkRule);

var _RuleList = __webpack_require__(174);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable-next-line no-use-before-define */
var StyleSheet = function () {
  function StyleSheet(styles, options) {
    var _this = this;

    _classCallCheck(this, StyleSheet);

    this.update = function (name, data) {
      if (typeof name === 'string') {
        _this.rules.update(name, data);
      } else {
        _this.rules.update(name);
      }
      return _this;
    };

    this.attached = false;
    this.deployed = false;
    this.linked = false;
    this.classes = {};
    this.options = _extends({}, options, {
      sheet: this,
      parent: this,
      classes: this.classes
    });
    this.renderer = new options.Renderer(this);
    this.rules = new _RuleList2['default'](this.options);

    for (var _name in styles) {
      this.rules.add(_name, styles[_name]);
    }

    this.rules.process();
  }

  /**
   * Attach renderable to the render tree.
   */


  _createClass(StyleSheet, [{
    key: 'attach',
    value: function attach() {
      if (this.attached) return this;
      if (!this.deployed) this.deploy();
      this.renderer.attach();
      if (!this.linked && this.options.link) this.link();
      this.attached = true;
      return this;
    }

    /**
     * Remove renderable from render tree.
     */

  }, {
    key: 'detach',
    value: function detach() {
      if (!this.attached) return this;
      this.renderer.detach();
      this.attached = false;
      return this;
    }

    /**
     * Add a rule to the current stylesheet.
     * Will insert a rule also after the stylesheet has been rendered first time.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, decl, options) {
      var queue = this.queue;

      // Plugins can create rules.
      // In order to preserve the right order, we need to queue all `.addRule` calls,
      // which happen after the first `rules.add()` call.

      if (this.attached && !queue) this.queue = [];

      var rule = this.rules.add(name, decl, options);
      this.options.jss.plugins.onProcessRule(rule);

      if (this.attached) {
        if (!this.deployed) return rule;
        // Don't insert rule directly if there is no stringified version yet.
        // It will be inserted all together when .attach is called.
        if (queue) queue.push(rule);else {
          this.insertRule(rule);
          if (this.queue) {
            this.queue.forEach(this.insertRule, this);
            this.queue = undefined;
          }
        }
        return rule;
      }

      // We can't add rules to a detached style node.
      // We will redeploy the sheet once user will attach it.
      this.deployed = false;

      return rule;
    }

    /**
     * Insert rule into the StyleSheet
     */

  }, {
    key: 'insertRule',
    value: function insertRule(rule) {
      var renderable = this.renderer.insertRule(rule);
      if (renderable && this.options.link) (0, _linkRule2['default'])(rule, renderable);
    }

    /**
     * Create and add rules.
     * Will render also after Style Sheet was rendered the first time.
     */

  }, {
    key: 'addRules',
    value: function addRules(styles, options) {
      var added = [];
      for (var _name2 in styles) {
        added.push(this.addRule(_name2, styles[_name2], options));
      }
      return added;
    }

    /**
     * Get a rule by name.
     */

  }, {
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Delete a rule by name.
     * Returns `true`: if rule has been deleted from the DOM.
     */

  }, {
    key: 'deleteRule',
    value: function deleteRule(name) {
      var rule = this.rules.get(name);

      if (!rule) return false;

      this.rules.remove(rule);

      if (this.attached && rule.renderable) {
        return this.renderer.deleteRule(rule.renderable);
      }

      return true;
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Deploy pure CSS string to a renderable.
     */

  }, {
    key: 'deploy',
    value: function deploy() {
      this.renderer.deploy();
      this.deployed = true;
      return this;
    }

    /**
     * Link renderable CSS rules from sheet with their corresponding models.
     */

  }, {
    key: 'link',
    value: function link() {
      var cssRules = this.renderer.getRules();

      // Is undefined when VirtualRenderer is used.
      if (cssRules) this.rules.link(cssRules);
      this.linked = true;
      return this;
    }

    /**
     * Update the function values with a new data.
     */

  }, {
    key: 'toString',


    /**
     * Convert rules to a CSS string.
     */
    value: function toString(options) {
      return this.rules.toString(options);
    }
  }]);

  return StyleSheet;
}();

exports['default'] = StyleSheet;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createStyles;

function createStyles(styles) {
  return styles;
}

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Namespaces to avoid conflicts on the context.
 */
var jss = exports.jss = '64a55d578f856d258dc345b094a2a2b3';
var sheetsRegistry = exports.sheetsRegistry = 'd4bd0baacbc52bbd48bbb9eb24344ecd';
var managers = exports.managers = 'b768b78919504fba9de2c03545c5cd3a';
var sheetOptions = exports.sheetOptions = '6fc570d6bd61383819d0f9e7407c452d';

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _warning = _interopRequireDefault(__webpack_require__(37));

var _getDisplayName = _interopRequireDefault(__webpack_require__(296));

function mergeClasses() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var baseClasses = options.baseClasses,
      newClasses = options.newClasses,
      Component = options.Component,
      _options$noBase = options.noBase,
      noBase = _options$noBase === void 0 ? false : _options$noBase;

  if (!newClasses) {
    return baseClasses;
  }

  return (0, _extends2.default)({}, baseClasses, Object.keys(newClasses).reduce(function (accumulator, key) {
     false ? (0, _warning.default)(baseClasses[key] || noBase, ["Material-UI: the key `".concat(key, "` ") + "provided to the classes property is not implemented in ".concat((0, _getDisplayName.default)(Component), "."), "You can only override one of the following: ".concat(Object.keys(baseClasses).join(','))].join('\n')) : void 0;
     false ? (0, _warning.default)(!newClasses[key] || typeof newClasses[key] === 'string', ["Material-UI: the key `".concat(key, "` ") + "provided to the classes property is not valid for ".concat((0, _getDisplayName.default)(Component), "."), "You need to provide a non empty string instead of: ".concat(newClasses[key], ".")].join('\n')) : void 0;

    if (newClasses[key]) {
      accumulator[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    }

    return accumulator;
  }, {}));
}

var _default = mergeClasses;
exports.default = _default;

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function getThemeProps(params) {
  var theme = params.theme,
      name = params.name;

  if (!name || !theme.props || !theme.props[name]) {
    return {};
  }

  return theme.props[name];
}

var _default = getThemeProps;
exports.default = _default;

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(146);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(219);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(298);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(300);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(219);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(220);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(298);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Provider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Consumer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _React$createContext=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(),Provider=_React$createContext.Provider,Consumer=_React$createContext.Consumer;

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var base64_url_decode = __webpack_require__(815);

function InvalidTokenError(message) {
  this.message = message;
}

InvalidTokenError.prototype = new Error();
InvalidTokenError.prototype.name = 'InvalidTokenError';

module.exports = function (token,options) {
  if (typeof token !== 'string') {
    throw new InvalidTokenError('Invalid token specified');
  }

  options = options || {};
  var pos = options.header === true ? 0 : 1;
  try {
    return JSON.parse(base64_url_decode(token.split('.')[pos]));
  } catch (e) {
    throw new InvalidTokenError('Invalid token specified: ' + e.message);
  }
};

module.exports.InvalidTokenError = InvalidTokenError;


/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = setItem;
/* harmony export (immutable) */ __webpack_exports__["b"] = getItem;
/* harmony export (immutable) */ __webpack_exports__["c"] = removeItem;
/* harmony export (immutable) */ __webpack_exports__["a"] = clear;
function setItem(key,value){localStorage.setItem(key,value);}function getItem(key){return localStorage.getItem(key);}function removeItem(key){localStorage.removeItem(key);}function clear(){localStorage.clear();}

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _CssBaseline.default;
  }
});

var _CssBaseline = _interopRequireDefault(__webpack_require__(818));

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FullScreenLoader_jsx__ = __webpack_require__(820);
var Loader=function Loader(_ref){var style=_ref.style,mergeStyle=_ref.mergeStyle,fullscreen=_ref.fullscreen,showSpinner=_ref.showSpinner,spinnerSize=_ref.spinnerSize;if(fullscreen)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FullScreenLoader_jsx__["a" /* default */],{showSpinner:showSpinner});var defaultLoaderStyle={height:'100%',width:'100%',display:'flex',justifyContent:'center',alignItems:'center'};var loaderStyle={};if(style){if(mergeStyle){loaderStyle=Object.assign({},defaultLoaderStyle,style);}else{loaderStyle=style;}}else{loaderStyle=defaultLoaderStyle;}var loader=showSpinner?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_CircularProgress___default.a,{size:spinnerSize}):'Loading ...';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:loaderStyle,id:'1'},loader);};Loader.propTypes={style:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,mergeStyle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,fullscreen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,showSpinner:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,spinnerSize:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};Loader.defaultProps={fullscreen:false,showSpinner:true,spinnerSize:24};/* harmony default export */ __webpack_exports__["a"] = (Loader);

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DomainConfigError_jsx__ = __webpack_require__(823);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__DomainConfigError_jsx__["a"]; });


/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number,
  appear: _propTypes.default.number
}).isRequired]) : null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]) : null;
exports.classNamesShape = classNamesShape;

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _reactDom = _interopRequireDefault(__webpack_require__(64));

var _scrollbarSize = _interopRequireDefault(__webpack_require__(468));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _Popover = _interopRequireDefault(__webpack_require__(177));

var _MenuList = _interopRequireDefault(__webpack_require__(473));

// @inheritedComponent Popover
var RTL_ORIGIN = {
  vertical: 'top',
  horizontal: 'right'
};
var LTR_ORIGIN = {
  vertical: 'top',
  horizontal: 'left'
};
var styles = {
  /* Styles applied to the `Paper` component. */
  paper: {
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tapable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling.
    WebkitOverflowScrolling: 'touch'
  }
};
exports.styles = styles;

var Menu =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Menu, _React$Component);

  function Menu() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Menu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Menu)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.menuListRef = null;

    _this.getContentAnchorEl = function () {
      if (!_this.menuListRef || !_this.menuListRef.selectedItemRef) {
        return _reactDom.default.findDOMNode(_this.menuListRef).firstChild;
      }

      return _reactDom.default.findDOMNode(_this.menuListRef.selectedItemRef);
    };

    _this.focus = function () {
      if (_this.menuListRef && _this.menuListRef.selectedItemRef) {
        _reactDom.default.findDOMNode(_this.menuListRef.selectedItemRef).focus();

        return;
      }

      var menuList = _reactDom.default.findDOMNode(_this.menuListRef);

      if (menuList && menuList.firstChild) {
        menuList.firstChild.focus();
      }
    };

    _this.handleEnter = function (element) {
      var _this$props = _this.props,
          disableAutoFocusItem = _this$props.disableAutoFocusItem,
          theme = _this$props.theme;

      var menuList = _reactDom.default.findDOMNode(_this.menuListRef); // Focus so the scroll computation of the Popover works as expected.


      if (disableAutoFocusItem !== true) {
        _this.focus();
      } // Let's ignore that piece of logic if users are already overriding the width
      // of the menu.


      if (menuList && element.clientHeight < menuList.clientHeight && !menuList.style.width) {
        var size = "".concat((0, _scrollbarSize.default)(), "px");
        menuList.style[theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = size;
        menuList.style.width = "calc(100% + ".concat(size, ")");
      }

      if (_this.props.onEnter) {
        _this.props.onEnter(element);
      }
    };

    _this.handleListKeyDown = function (event, key) {
      if (key === 'tab') {
        event.preventDefault();

        if (_this.props.onClose) {
          _this.props.onClose(event);
        }
      }
    };

    return _this;
  }

  (0, _createClass2.default)(Menu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.open && this.props.disableAutoFocusItem !== true) {
        this.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          children = _this$props2.children,
          classes = _this$props2.classes,
          disableAutoFocusItem = _this$props2.disableAutoFocusItem,
          MenuListProps = _this$props2.MenuListProps,
          onEnter = _this$props2.onEnter,
          _this$props2$PaperPro = _this$props2.PaperProps,
          PaperProps = _this$props2$PaperPro === void 0 ? {} : _this$props2$PaperPro,
          PopoverClasses = _this$props2.PopoverClasses,
          theme = _this$props2.theme,
          other = (0, _objectWithoutProperties2.default)(_this$props2, ["children", "classes", "disableAutoFocusItem", "MenuListProps", "onEnter", "PaperProps", "PopoverClasses", "theme"]);
      return _react.default.createElement(_Popover.default, (0, _extends2.default)({
        getContentAnchorEl: this.getContentAnchorEl,
        classes: PopoverClasses,
        onEnter: this.handleEnter,
        anchorOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
        transformOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
        PaperProps: (0, _extends2.default)({}, PaperProps, {
          classes: (0, _extends2.default)({}, PaperProps.classes, {
            root: classes.paper
          })
        })
      }, other), _react.default.createElement(_MenuList.default, (0, _extends2.default)({
        onKeyDown: this.handleListKeyDown
      }, MenuListProps, {
        ref: function ref(_ref) {
          _this2.menuListRef = _ref;
        }
      }), children));
    }
  }]);
  return Menu;
}(_react.default.Component);

Menu.propTypes =  false ? {
  /**
   * The DOM element used to set the position of the menu.
   */
  anchorEl: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * If `true`, the selected / first menu item will not be auto focused.
   */
  disableAutoFocusItem: _propTypes.default.bool,

  /**
   * Properties applied to the [`MenuList`](/api/menu-list) element.
   */
  MenuListProps: _propTypes.default.object,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired before the Menu enters.
   */
  onEnter: _propTypes.default.func,

  /**
   * Callback fired when the Menu has entered.
   */
  onEntered: _propTypes.default.func,

  /**
   * Callback fired when the Menu is entering.
   */
  onEntering: _propTypes.default.func,

  /**
   * Callback fired before the Menu exits.
   */
  onExit: _propTypes.default.func,

  /**
   * Callback fired when the Menu has exited.
   */
  onExited: _propTypes.default.func,

  /**
   * Callback fired when the Menu is exiting.
   */
  onExiting: _propTypes.default.func,

  /**
   * If `true`, the menu is visible.
   */
  open: _propTypes.default.bool.isRequired,

  /**
   * @ignore
   */
  PaperProps: _propTypes.default.object,

  /**
   * `classes` property applied to the [`Popover`](/api/popover) element.
   */
  PopoverClasses: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The length of the transition in `ms`, or 'auto'
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  }), _propTypes.default.oneOf(['auto'])])
} : {};
Menu.defaultProps = {
  disableAutoFocusItem: false,
  transitionDuration: 'auto'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiMenu',
  withTheme: true
})(Menu);

exports.default = _default;

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(120);

exports.__esModule = true;
exports.default = scrollbarSize;

var _inDOM = _interopRequireDefault(__webpack_require__(469));

var size;

function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (_inDOM.default) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}

module.exports = exports["default"];

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _style = _interopRequireDefault(__webpack_require__(862));

var _scrollbarSize = _interopRequireDefault(__webpack_require__(468));

var _ownerDocument = _interopRequireDefault(__webpack_require__(100));

var _isOverflowing = _interopRequireDefault(__webpack_require__(870));

var _manageAriaHidden = __webpack_require__(872);

function findIndexOf(data, callback) {
  var idx = -1;
  data.some(function (item, index) {
    if (callback(item)) {
      idx = index;
      return true;
    }

    return false;
  });
  return idx;
}

function getPaddingRight(node) {
  return parseInt((0, _style.default)(node, 'paddingRight') || 0, 10);
}

function setContainerStyle(data, container) {
  var style = {
    overflow: 'hidden'
  }; // We are only interested in the actual `style` here because we will override it.

  data.style = {
    overflow: container.style.overflow,
    paddingRight: container.style.paddingRight
  };

  if (data.overflowing) {
    var scrollbarSize = (0, _scrollbarSize.default)(); // Use computed style, here to get the real padding to add our scrollbar width.

    style.paddingRight = "".concat(getPaddingRight(container) + scrollbarSize, "px"); // .mui-fixed is a global helper.

    var fixedNodes = (0, _ownerDocument.default)(container).querySelectorAll('.mui-fixed');

    for (var i = 0; i < fixedNodes.length; i += 1) {
      var paddingRight = getPaddingRight(fixedNodes[i]);
      data.prevPaddings.push(paddingRight);
      fixedNodes[i].style.paddingRight = "".concat(paddingRight + scrollbarSize, "px");
    }
  }

  Object.keys(style).forEach(function (key) {
    container.style[key] = style[key];
  });
}

function removeContainerStyle(data, container) {
  Object.keys(data.style).forEach(function (key) {
    container.style[key] = data.style[key];
  });
  var fixedNodes = (0, _ownerDocument.default)(container).querySelectorAll('.mui-fixed');

  for (var i = 0; i < fixedNodes.length; i += 1) {
    fixedNodes[i].style.paddingRight = "".concat(data.prevPaddings[i], "px");
  }
}
/**
 * @ignore - do not document.
 *
 * Proper state managment for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */


var ModalManager =
/*#__PURE__*/
function () {
  function ModalManager() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2.default)(this, ModalManager);
    var _options$hideSiblingN = options.hideSiblingNodes,
        hideSiblingNodes = _options$hideSiblingN === void 0 ? true : _options$hideSiblingN,
        _options$handleContai = options.handleContainerOverflow,
        handleContainerOverflow = _options$handleContai === void 0 ? true : _options$handleContai;
    this.hideSiblingNodes = hideSiblingNodes;
    this.handleContainerOverflow = handleContainerOverflow; // this.modals[modalIdx] = modal

    this.modals = []; // this.containers[containerIdx] = container

    this.containers = []; // this.data[containerIdx] = {
    //   modals: [],
    // }

    this.data = [];
  }

  (0, _createClass2.default)(ModalManager, [{
    key: "add",
    value: function add(modal, container) {
      var modalIdx = this.modals.indexOf(modal);

      if (modalIdx !== -1) {
        return modalIdx;
      }

      modalIdx = this.modals.length;
      this.modals.push(modal);

      if (this.hideSiblingNodes) {
        (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
      }

      var containerIdx = this.containers.indexOf(container);

      if (containerIdx !== -1) {
        this.data[containerIdx].modals.push(modal);
        return modalIdx;
      }

      var data = {
        modals: [modal],
        overflowing: (0, _isOverflowing.default)(container),
        prevPaddings: []
      };

      if (this.handleContainerOverflow) {
        setContainerStyle(data, container);
      }

      this.containers.push(container);
      this.data.push(data);
      return modalIdx;
    }
  }, {
    key: "remove",
    value: function remove(modal) {
      var modalIdx = this.modals.indexOf(modal);

      if (modalIdx === -1) {
        return modalIdx;
      }

      var containerIdx = findIndexOf(this.data, function (item) {
        return item.modals.indexOf(modal) !== -1;
      });
      var data = this.data[containerIdx];
      var container = this.containers[containerIdx];
      data.modals.splice(data.modals.indexOf(modal), 1);
      this.modals.splice(modalIdx, 1); // If that was the last modal in a container, clean up the container.

      if (data.modals.length === 0) {
        if (this.handleContainerOverflow) {
          removeContainerStyle(data, container);
        }

        if (this.hideSiblingNodes) {
          (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
        }

        this.containers.splice(containerIdx, 1);
        this.data.splice(containerIdx, 1);
      } else if (this.hideSiblingNodes) {
        // Otherwise make sure the next top modal is visible to a screan reader.
        (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
      }

      return modalIdx;
    }
  }, {
    key: "isTopModal",
    value: function isTopModal(modal) {
      return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
    }
  }]);
  return ModalManager;
}();

var _default = ModalManager;
exports.default = _default;

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(120);

exports.__esModule = true;
exports.default = camelizeStyleName;

var _camelize = _interopRequireDefault(__webpack_require__(863));

/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
 */
var msPattern = /^-ms-/;

function camelizeStyleName(string) {
  return (0, _camelize.default)(string.replace(msPattern, 'ms-'));
}

module.exports = exports["default"];

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Backdrop.default;
  }
});

var _Backdrop = _interopRequireDefault(__webpack_require__(873));

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _MenuList.default;
  }
});

var _MenuList = _interopRequireDefault(__webpack_require__(877));

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _pure = _interopRequireDefault(__webpack_require__(81));

var _SvgIcon = _interopRequireDefault(__webpack_require__(73));

var _ref = _react.default.createElement("path", {
  d: "M7 10l5 5 5-5z"
});

/**
 * @ignore - internal component.
 */
var ArrowDropDown = function ArrowDropDown(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

ArrowDropDown = (0, _pure.default)(ArrowDropDown);
ArrowDropDown.muiName = 'SvgIcon';
var _default = ArrowDropDown;
exports.default = _default;

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(176);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _setStatic = _interopRequireDefault(__webpack_require__(881));

var setDisplayName = function setDisplayName(displayName) {
  return (0, _setStatic.default)('displayName', displayName);
};

var _default = setDisplayName;
exports.default = _default;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _NativeSelectInput = _interopRequireDefault(__webpack_require__(477));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _ArrowDropDown = _interopRequireDefault(__webpack_require__(474));

var _Input = _interopRequireDefault(__webpack_require__(76));

// @inheritedComponent Input
var styles = function styles(theme) {
  return {
    /* Styles applied to the `Input` component `root` class. */
    root: {
      position: 'relative',
      width: '100%'
    },

    /* Styles applied to the `Input` component `select` class. */
    select: {
      '-moz-appearance': 'none',
      // Reset
      '-webkit-appearance': 'none',
      // Reset
      // When interacting quickly, the text can end up selected.
      // Native select can't be selected either.
      userSelect: 'none',
      paddingRight: 32,
      width: 'calc(100% - 32px)',
      minWidth: 16,
      // So it doesn't collapse.
      cursor: 'pointer',
      '&:focus': {
        // Show that it's not an text input
        background: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)',
        borderRadius: 0 // Reset Chrome style

      },
      // Remove Firefox focus border
      '&:-moz-focusring': {
        color: 'transparent',
        textShadow: '0 0 0 #000'
      },
      // Remove IE11 arrow
      '&::-ms-expand': {
        display: 'none'
      },
      '&$disabled': {
        cursor: 'default'
      }
    },

    /* Styles applied to the `Input` component `selectMenu` class. */
    selectMenu: {
      width: 'auto',
      // Fix Safari textOverflow
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      minHeight: '1.1875em' // Reset (19px), match the native input line-height

    },

    /* Styles applied to the `Input` component `disabled` class. */
    disabled: {},

    /* Styles applied to the `Input` component `icon` class. */
    icon: {
      // We use a position absolute over a flexbox in order to forward the pointer events
      // to the input.
      position: 'absolute',
      right: 0,
      top: 'calc(50% - 12px)',
      // Center vertically
      color: theme.palette.action.active,
      'pointer-events': 'none' // Don't block pointer events on the select under the icon.

    }
  };
};
/**
 * An alternative to `<Select native />` with a much smaller dependency graph.
 */


exports.styles = styles;

function NativeSelect(props) {
  var children = props.children,
      classes = props.classes,
      IconComponent = props.IconComponent,
      input = props.input,
      inputProps = props.inputProps,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "IconComponent", "input", "inputProps"]);
  return _react.default.cloneElement(input, (0, _extends2.default)({
    // Most of the logic is implemented in `NativeSelectInput`.
    // The `Select` component is a simple API wrapper to expose something better to play with.
    inputComponent: _NativeSelectInput.default,
    inputProps: (0, _extends2.default)({
      children: children,
      classes: classes,
      IconComponent: IconComponent,
      type: undefined
    }, inputProps, input ? input.props.inputProps : {})
  }, other));
}

NativeSelect.propTypes =  false ? {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: _propTypes.default.element,

  /**
   * Attributes applied to the `select` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   */
  onChange: _propTypes.default.func,

  /**
   * The input value.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool])
} : {};
NativeSelect.defaultProps = {
  IconComponent: _ArrowDropDown.default,
  input: _react.default.createElement(_Input.default, null)
};
NativeSelect.muiName = 'NativeSelect';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiNativeSelect'
})(NativeSelect);

exports.default = _default;

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

/**
 * @ignore - internal component.
 */
function NativeSelectInput(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      disabled = props.disabled,
      IconComponent = props.IconComponent,
      inputRef = props.inputRef,
      name = props.name,
      onChange = props.onChange,
      value = props.value,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disabled", "IconComponent", "inputRef", "name", "onChange", "value"]);
  return _react.default.createElement("div", {
    className: classes.root
  }, _react.default.createElement("select", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.select, (0, _defineProperty2.default)({}, classes.disabled, disabled), className),
    name: name,
    disabled: disabled,
    onChange: onChange,
    value: value,
    ref: inputRef
  }, other), children), _react.default.createElement(IconComponent, {
    className: classes.icon
  }));
}

NativeSelectInput.propTypes =  false ? {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The CSS class name of the select element.
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the select will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Use that property to pass a ref callback to the native select element.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: _propTypes.default.string,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   */
  onChange: _propTypes.default.func,

  /**
   * The input value.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool])
} : {};
var _default = NativeSelectInput;
exports.default = _default;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _pure = _interopRequireDefault(__webpack_require__(81));

var _SvgIcon = _interopRequireDefault(__webpack_require__(73));

var _ref = _react.default.createElement("path", {
  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
});

/**
 * @ignore - internal component.
 */
var KeyboardArrowLeft = function KeyboardArrowLeft(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

KeyboardArrowLeft = (0, _pure.default)(KeyboardArrowLeft);
KeyboardArrowLeft.muiName = 'SvgIcon';
var _default = KeyboardArrowLeft;
exports.default = _default;

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _pure = _interopRequireDefault(__webpack_require__(81));

var _SvgIcon = _interopRequireDefault(__webpack_require__(73));

var _ref = _react.default.createElement("path", {
  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
});

/**
 * @ignore - internal component.
 */
var KeyboardArrowRight = function KeyboardArrowRight(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

KeyboardArrowRight = (0, _pure.default)(KeyboardArrowRight);
KeyboardArrowRight.muiName = 'SvgIcon';
var _default = KeyboardArrowRight;
exports.default = _default;

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
})), 'KeyboardArrowRight');

exports.default = _default;

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(924);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(941);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(231);
var $export = __webpack_require__(232);
var redefine = __webpack_require__(486);
var hide = __webpack_require__(150);
var Iterators = __webpack_require__(311);
var $iterCreate = __webpack_require__(929);
var setToStringTag = __webpack_require__(317);
var getPrototypeOf = __webpack_require__(936);
var ITERATOR = __webpack_require__(155)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(928);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(153) && !__webpack_require__(233)(function () {
  return Object.defineProperty(__webpack_require__(485)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(152);
var document = __webpack_require__(109).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(150);


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(122);
var toIObject = __webpack_require__(154);
var arrayIndexOf = __webpack_require__(932)(false);
var IE_PROTO = __webpack_require__(314)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 488 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(309);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 490 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(487);
var hiddenKeys = __webpack_require__(316).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(320);
var createDesc = __webpack_require__(234);
var toIObject = __webpack_require__(154);
var toPrimitive = __webpack_require__(310);
var has = __webpack_require__(122);
var IE8_DOM_DEFINE = __webpack_require__(484);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(153) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _setStatic = __webpack_require__(959);

var _setStatic2 = _interopRequireDefault(_setStatic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setDisplayName = function setDisplayName(displayName) {
  return (0, _setStatic2.default)('displayName', displayName);
};

exports.default = setDisplayName;

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getDisplayName = __webpack_require__(960);

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + (0, _getDisplayName2.default)(BaseComponent) + ')';
};

exports.default = wrapDisplayName;

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      width: 40,
      height: 40,
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(20),
      borderRadius: '50%',
      overflow: 'hidden',
      userSelect: 'none'
    },

    /* Styles applied to the root element if there are children and not `src` or `srcSet` */

    /* Styles applied to the root element if `color="default"`. */
    colorDefault: {
      color: theme.palette.background.default,
      backgroundColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
    },

    /* Styles applied to the img element if either `src` or `srcSet` is defined. */
    img: {
      width: '100%',
      height: '100%',
      textAlign: 'center',
      // Handle non-square image. The property isn't supported by IE11.
      objectFit: 'cover'
    }
  };
};

exports.styles = styles;

function Avatar(props) {
  var alt = props.alt,
      childrenProp = props.children,
      childrenClassNameProp = props.childrenClassName,
      classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      imgProps = props.imgProps,
      sizes = props.sizes,
      src = props.src,
      srcSet = props.srcSet,
      other = (0, _objectWithoutProperties2.default)(props, ["alt", "children", "childrenClassName", "classes", "className", "component", "imgProps", "sizes", "src", "srcSet"]);
  var className = (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.colorDefault, childrenProp && !src && !srcSet), classNameProp);
  var children = null;

  if (src || srcSet) {
    children = _react.default.createElement("img", (0, _extends2.default)({
      alt: alt,
      src: src,
      srcSet: srcSet,
      sizes: sizes,
      className: classes.img
    }, imgProps));
  } else if (childrenClassNameProp && _react.default.isValidElement(childrenProp)) {
    var childrenClassName = (0, _classnames.default)(childrenClassNameProp, childrenProp.props.className);
    children = _react.default.cloneElement(childrenProp, {
      className: childrenClassName
    });
  } else {
    children = childrenProp;
  }

  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className
  }, other), children);
}

Avatar.propTypes =  false ? {
  /**
   * Used in combination with `src` or `srcSet` to
   * provide an alt attribute for the rendered `img` element.
   */
  alt: _propTypes.default.string,

  /**
   * Used to render icon or text elements inside the Avatar.
   * `src` and `alt` props will not be used and no `img` will
   * be rendered by default.
   *
   * This can be an element, or just a string.
   */
  children: _propTypes.default.node,

  /**
   * @ignore
   * The className of the child element.
   * Used by Chip and ListItemIcon to style the Avatar icon.
   */
  childrenClassName: _propTypes.default.string,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Attributes applied to the `img` element if the component
   * is used to display an image.
   */
  imgProps: _propTypes.default.object,

  /**
   * The `sizes` attribute for the `img` element.
   */
  sizes: _propTypes.default.string,

  /**
   * The `src` attribute for the `img` element.
   */
  src: _propTypes.default.string,

  /**
   * The `srcSet` attribute for the `img` element.
   */
  srcSet: _propTypes.default.string
} : {};
Avatar.defaultProps = {
  component: 'div'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiAvatar'
})(Avatar);

exports.default = _default;

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Popper.default;
  }
});

var _Popper = _interopRequireDefault(__webpack_require__(968));

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
})), 'Help');

exports.default = _default;

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TableFooter.default;
  }
});

var _TableFooter = _interopRequireDefault(__webpack_require__(970));

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "common", {
  enumerable: true,
  get: function get() {
    return _common.default;
  }
});
Object.defineProperty(exports, "red", {
  enumerable: true,
  get: function get() {
    return _red.default;
  }
});
Object.defineProperty(exports, "pink", {
  enumerable: true,
  get: function get() {
    return _pink.default;
  }
});
Object.defineProperty(exports, "purple", {
  enumerable: true,
  get: function get() {
    return _purple.default;
  }
});
Object.defineProperty(exports, "deepPurple", {
  enumerable: true,
  get: function get() {
    return _deepPurple.default;
  }
});
Object.defineProperty(exports, "indigo", {
  enumerable: true,
  get: function get() {
    return _indigo.default;
  }
});
Object.defineProperty(exports, "blue", {
  enumerable: true,
  get: function get() {
    return _blue.default;
  }
});
Object.defineProperty(exports, "lightBlue", {
  enumerable: true,
  get: function get() {
    return _lightBlue.default;
  }
});
Object.defineProperty(exports, "cyan", {
  enumerable: true,
  get: function get() {
    return _cyan.default;
  }
});
Object.defineProperty(exports, "teal", {
  enumerable: true,
  get: function get() {
    return _teal.default;
  }
});
Object.defineProperty(exports, "green", {
  enumerable: true,
  get: function get() {
    return _green.default;
  }
});
Object.defineProperty(exports, "lightGreen", {
  enumerable: true,
  get: function get() {
    return _lightGreen.default;
  }
});
Object.defineProperty(exports, "lime", {
  enumerable: true,
  get: function get() {
    return _lime.default;
  }
});
Object.defineProperty(exports, "yellow", {
  enumerable: true,
  get: function get() {
    return _yellow.default;
  }
});
Object.defineProperty(exports, "amber", {
  enumerable: true,
  get: function get() {
    return _amber.default;
  }
});
Object.defineProperty(exports, "orange", {
  enumerable: true,
  get: function get() {
    return _orange.default;
  }
});
Object.defineProperty(exports, "deepOrange", {
  enumerable: true,
  get: function get() {
    return _deepOrange.default;
  }
});
Object.defineProperty(exports, "brown", {
  enumerable: true,
  get: function get() {
    return _brown.default;
  }
});
Object.defineProperty(exports, "grey", {
  enumerable: true,
  get: function get() {
    return _grey.default;
  }
});
Object.defineProperty(exports, "blueGrey", {
  enumerable: true,
  get: function get() {
    return _blueGrey.default;
  }
});

var _common = _interopRequireDefault(__webpack_require__(438));

var _red = _interopRequireDefault(__webpack_require__(437));

var _pink = _interopRequireDefault(__webpack_require__(435));

var _purple = _interopRequireDefault(__webpack_require__(976));

var _deepPurple = _interopRequireDefault(__webpack_require__(977));

var _indigo = _interopRequireDefault(__webpack_require__(434));

var _blue = _interopRequireDefault(__webpack_require__(978));

var _lightBlue = _interopRequireDefault(__webpack_require__(979));

var _cyan = _interopRequireDefault(__webpack_require__(980));

var _teal = _interopRequireDefault(__webpack_require__(981));

var _green = _interopRequireDefault(__webpack_require__(982));

var _lightGreen = _interopRequireDefault(__webpack_require__(983));

var _lime = _interopRequireDefault(__webpack_require__(984));

var _yellow = _interopRequireDefault(__webpack_require__(985));

var _amber = _interopRequireDefault(__webpack_require__(986));

var _orange = _interopRequireDefault(__webpack_require__(987));

var _deepOrange = _interopRequireDefault(__webpack_require__(988));

var _brown = _interopRequireDefault(__webpack_require__(989));

var _grey = _interopRequireDefault(__webpack_require__(436));

var _blueGrey = _interopRequireDefault(__webpack_require__(990));

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ClickAwayListener.default;
  }
});

var _ClickAwayListener = _interopRequireDefault(__webpack_require__(1004));

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Drawer.default;
  }
});

var _Drawer = _interopRequireDefault(__webpack_require__(325));

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ExpansionPanel.default;
  }
});

var _ExpansionPanel = _interopRequireDefault(__webpack_require__(1010));

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ExpansionPanelDetails.default;
  }
});

var _ExpansionPanelDetails = _interopRequireDefault(__webpack_require__(1013));

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ExpansionPanelSummary.default;
  }
});

var _ExpansionPanelSummary = _interopRequireDefault(__webpack_require__(1014));

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Hidden.default;
  }
});

var _Hidden = _interopRequireDefault(__webpack_require__(1023));

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _LinearProgress.default;
  }
});

var _LinearProgress = _interopRequireDefault(__webpack_require__(1027));

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ListSubheader.default;
  }
});

var _ListSubheader = _interopRequireDefault(__webpack_require__(1034));

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Snackbar.default;
  }
});

var _Snackbar = _interopRequireDefault(__webpack_require__(1043));

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _SnackbarContent.default;
  }
});

var _SnackbarContent = _interopRequireDefault(__webpack_require__(1044));

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Step.default;
  }
});

var _Step = _interopRequireDefault(__webpack_require__(1045));

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _StepButton.default;
  }
});

var _StepButton = _interopRequireDefault(__webpack_require__(1046));

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _StepLabel.default;
  }
});

var _StepLabel = _interopRequireDefault(__webpack_require__(1047));

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _StepIcon.default;
  }
});

var _StepIcon = _interopRequireDefault(__webpack_require__(1048));

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _StepConnector.default;
  }
});

var _StepConnector = _interopRequireDefault(__webpack_require__(1051));

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Stepper.default;
  }
});

var _Stepper = _interopRequireDefault(__webpack_require__(1054));

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
})), 'Clear');

exports.default = _default;

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM17 13l-5 5-5-5h3V9h4v4h3z"
})), 'CloudDownload');

exports.default = _default;

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z"
})), 'Print');

exports.default = _default;

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 18h5V5h-5v13zm-6 0h5V5H4v13zM16 5v13h5V5h-5z"
})), 'ViewColumn');

exports.default = _default;

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(77);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(77);
var settle = __webpack_require__(1070);
var cookies = __webpack_require__(1071);
var buildURL = __webpack_require__(521);
var buildFullPath = __webpack_require__(1072);
var parseHeaders = __webpack_require__(1075);
var isURLSameOrigin = __webpack_require__(1076);
var createError = __webpack_require__(524);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(
        timeoutErrorMessage,
        config,
        config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(522);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(77);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = [
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
  ];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys)
    .concat(directMergeKeys);

  var otherKeys = Object
    .keys(config1)
    .concat(Object.keys(config2))
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, mergeDeepProperties);

  return config;
};


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
})), 'Refresh');

exports.default = _default;

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 6h18V4H4c-1.1 0-2 .9-2 2v11H0v3h14v-3H4V6zm19 2h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 9h-4v-7h4v7z"
})), 'Phonelink');

exports.default = _default;

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
})), 'Room');

exports.default = _default;

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 14H4v-4h11v4zm0-5H4V9h11v4zm5 5h-4V9h4v9z"
})), 'Web');

exports.default = _default;

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 16l-4-4V8.82C14.16 8.4 15 7.3 15 6c0-1.66-1.34-3-3-3S9 4.34 9 6c0 1.3.84 2.4 2 2.82V12l-4 4H3v5h5v-3.05l4-4.2 4 4.2V21h5v-5h-4z"
})), 'DeviceHub');

exports.default = _default;

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 17H6v-2h12v2zm0-4H6v-2h12v2zm0-4H6V7h12v2zM3 22l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20z"
})), 'Receipt');

exports.default = _default;

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z"
})), 'Build');

exports.default = _default;

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
})), 'ExpandLess');

exports.default = _default;

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vehicle_css__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vehicle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__vehicle_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Reusable_ItemCard__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_IconButton__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_LocationOn__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_LocationOn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_LocationOn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_LocationCity__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_LocationCity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_LocationCity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Person__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Person___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Person__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_fetchClientPublicIp__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_Loader__ = __webpack_require__(47);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getClientLoginToken(\n    $clientid: Int!\n    $clientIp: String\n    $source: String\n    $performedByLoginId: Int\n    $performedByUsername: String\n  ) {\n    getClientLoginToken(\n      id: $clientid\n      clientIp: $clientIp\n      source: $source\n      performedByLoginId: $performedByLoginId\n      performedByUsername: $performedByUsername\n    ) {\n      token\n    }\n  }\n'],['\n  query getClientLoginToken(\n    $clientid: Int!\n    $clientIp: String\n    $source: String\n    $performedByLoginId: Int\n    $performedByUsername: String\n  ) {\n    getClientLoginToken(\n      id: $clientid\n      clientIp: $clientIp\n      source: $source\n      performedByLoginId: $performedByLoginId\n      performedByUsername: $performedByUsername\n    ) {\n      token\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query getPartnerDomainConfig($loginId: Int!) {\n    domain: getPartnerDomainConfig(loginId: $loginId)\n  }\n'],['\n  query getPartnerDomainConfig($loginId: Int!) {\n    domain: getPartnerDomainConfig(loginId: $loginId)\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_LOGIN_TOKEN=Object(__WEBPACK_IMPORTED_MODULE_12_graphql_tag__["a" /* default */])(_templateObject);var GET_CLIENT_DOMAIN=Object(__WEBPACK_IMPORTED_MODULE_12_graphql_tag__["a" /* default */])(_templateObject2);// export default class VehicleRegistration extends Component {
var VehicleRegistration=function(_Component){_inherits(VehicleRegistration,_Component);function VehicleRegistration(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,VehicleRegistration);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=VehicleRegistration.__proto__||Object.getPrototypeOf(VehicleRegistration)).call.apply(_ref,[this].concat(args))),_this),_this.loginCustomer=function(clientId){return _asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var clientIp,_ref3,data,_ref4,domain,clienturl,win;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_14__utils_fetchClientPublicIp__["a" /* default */])();case 3:clientIp=_context.sent;_context.next=6;return _this.props.client.query({query:GET_LOGIN_TOKEN,variables:{clientid:clientId,// clientid: 1969
clientIp:clientIp,source:'admin-frontend',performedByLoginId:Object(__WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__["a" /* default */])(),performedByUsername:localStorage.getItem('username')}});case 6:_ref3=_context.sent;data=_ref3.data;if(!data){_context.next=16;break;}_context.next=11;return _this.props.client.query({query:GET_CLIENT_DOMAIN,variables:{loginId:Object(__WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__["a" /* default */])()}});case 11:_ref4=_context.sent;domain=_ref4.data;clienturl='https://'+domain.domain+'/?token='+data.getClientLoginToken.token;win=window.open(clienturl,'_blank');win.focus();case 16:_context.next=21;break;case 18:_context.prev=18;_context.t0=_context['catch'](0);console.error('GraphQL Query Error: ',_context.t0);case 21:case'end':return _context.stop();}}},_callee,_this2,[[0,18]]);}));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(VehicleRegistration,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,container:true,direction:'row',justify:'flex-start',alignItems:'flex-start'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Reusable_ItemCard__["a" /* default */],{className:'details',style:{width:'100%',margin:'0 auto'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,className:'content1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,alignItems:'center',justifyContent:'space-between',style:{display:'flex',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'title'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_IconButton___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Person___default.a,{color:'primary'})),this.props.clientName)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},this.props.loginId?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Button"],{variant:'outlined',color:'primary',onClick:this.loginCustomer(this.props.loginId)},'LOGIN PREVIEW'):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__common_Loader__["a" /* default */],null))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{component:'p'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_IconButton___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_LocationOn___default.a,{color:'primary'})),this.props.address),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{component:'p'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_IconButton___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_LocationCity___default.a,{color:'primary'})),this.props.city))))));}}]);return VehicleRegistration;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["withApollo"])(VehicleRegistration));

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return phaseOptionsArray; });
var phaseOptionsArray=[{value:'Single Phase',label:'Single Phase'},{value:'Three Phase',label:'Three Phase'}];

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var TensionerRotationSensorReminder=function TensionerRotationSensorReminder(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:'16px',marginBottom:'8px',padding:'12px 16px',backgroundColor:'#e3f2fd',border:'1px solid #90caf9',borderRadius:'4px',color:'#1565c0',fontSize:'14px',lineHeight:'1.5'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Friendly Reminder:'),' You have selected',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Tensioner'),' as the Construction Vehicle Type. Tensioners have a rotation sensor installed to track rotation. Please make sure the',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Rotation Sensor'),' option is enabled so that rotation tracking and downstream logic work correctly.');};/* harmony default export */ __webpack_exports__["a"] = (TensionerRotationSensorReminder);

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_FormHelperText__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_FormHelperText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_FormHelperText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_select__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  mutation updateDeviceCommandsTable(\n    $uniqueId: String!\n    $command: String!\n    $device_password: String!\n  ) {\n    updateDeviceCommandsTable(\n      uniqueId: $uniqueId\n      command: $command\n      device_password: $device_password\n    ) {\n      message\n    }\n  }\n'],['\n  mutation updateDeviceCommandsTable(\n    $uniqueId: String!\n    $command: String!\n    $device_password: String!\n  ) {\n    updateDeviceCommandsTable(\n      uniqueId: $uniqueId\n      command: $command\n      device_password: $device_password\n    ) {\n      message\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query getAllVehicleDetailsByStatus($loginId: Int, $status: Int) {\n    getAllVehicleDetailsByStatus(partnerLoginId: $loginId, status: $status) {\n      vehicleNumber\n      deviceDetail {\n        uniqueDeviceId\n      }\n    }\n  }\n'],['\n  query getAllVehicleDetailsByStatus($loginId: Int, $status: Int) {\n    getAllVehicleDetailsByStatus(partnerLoginId: $loginId, status: $status) {\n      vehicleNumber\n      deviceDetail {\n        uniqueDeviceId\n      }\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// import getLoginId from '../../../utils/getLoginId'
// calling server for updation
var ADD_DEVICE_COMMANDS=Object(__WEBPACK_IMPORTED_MODULE_11_graphql_tag__["a" /* default */])(_templateObject);var GET_VEHICLE_LIST=Object(__WEBPACK_IMPORTED_MODULE_11_graphql_tag__["a" /* default */])(_templateObject2);var styles=function styles(theme){return{button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{margin:theme.spacing.unit,minWidth:120}};};var onlySpaces=function onlySpaces(str){return str.trim().length===0;};var SendCommands=function(_Component){_inherits(SendCommands,_Component);function SendCommands(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,SendCommands);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SendCommands.__proto__||Object.getPrototypeOf(SendCommands)).call.apply(_ref,[this].concat(args))),_this),_this.state={command:'',devicePassword:'',isCommandValid:true,isDevicePasswordValid:true,vehicleNames:'',vehicleName:''},_this.checkCommandValidity=function(){_this.setState({isCommandValid:_this.state.command!==''&&!onlySpaces(_this.state.command)});},_this.checkDevicePasswordValidity=function(){_this.setState({isDevicePasswordValid:_this.state.devicePassword!==''});},_this.handleInputChange=function(e){_this.setState(_defineProperty({},e.target.name,e.target.value));},_this.handleChange=function(event){// console.log(event, 'event')
_this.setState({vehicleName:event.value});},_this.handleSubmit=function(addDeviceCommands){return function(e){e.preventDefault();addDeviceCommands({variables:{uniqueId:_this.state.vehicleName,command:_this.state.command,device_password:_this.state.devicePassword// refetchQueries: [`getPartnerDeviceStockByDeviceModel`]
}});_this.setState({command:'',devicePassword:''});};},_this.getvehicleDetails=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _ref3,data,allVehicles;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.client.query({query:GET_VEHICLE_LIST,variables:{loginId:parseInt(localStorage.getItem('Login_id'),10),status:1}});case 2:_ref3=_context.sent;data=_ref3.data;// console.log(data, 'data')
_this.setState({vehicleList:data.getAllVehicleDetailsByStatus});allVehicles=data.getAllVehicleDetailsByStatus.map(function(v){return{value:v.deviceDetail.uniqueDeviceId,label:v.vehicleNumber};});_this.setState({vehicleNames:allVehicles});// console.log(this.state.vehicleNames, 'vcls')
case 7:case'end':return _context.stop();}}},_callee,_this2);})),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SendCommands,[{key:'componentDidMount',value:function componentDidMount(){this.getvehicleDetails();}},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_apollo__["Mutation"],{mutation:ADD_DEVICE_COMMANDS},function(addDeviceCommands,_ref4){var data=_ref4.data,error=_ref4.error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle___default.a,{id:'form-dialog-title'},'Sending Device Commands :'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["Typography"],{variant:'subheading',gutterBottom:true,style:{color:'red',marginLeft:'25px'}},error&&error.graphQLErrors.map(function(_ref5,i){var message=_ref5.message;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{key:i},message);}),_this3.state.errorMessage&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,_this3.state.errorMessage)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["Typography"],{variant:'subheading',gutterBottom:true,style:{color:'green',marginLeft:'25px'}},data&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Sucessfully Added')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Divider___default.a,{light:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{onSubmit:_this3.handleSubmit(addDeviceCommands)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText___default.a,null,'* Marked fields are mandatory'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl___default.a// className={classes.formControl}
,{style:{minWidth:'60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_select__["a" /* default */]// classes={classes}
,{options:_this3.state.vehicleNames// components={components}
,value:_this3.state.vehicleName,onChange:_this3.handleChange,placeholder:'Select Vehicles *'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField___default.a// autoComplete="username"
,{name:'command',value:_this3.state.command,type:'command',onChange:_this3.handleInputChange,label:'Device Command *',error:!_this3.state.isCommandValid,onBlur:_this3.checkCommandValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this3.state.isCommandValid?'':'Invalid Command')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField___default.a// autoComplete="username"
,{name:'devicePassword',value:_this3.state.devicePassword,type:'devicePassword',onChange:_this3.handleInputChange,label:'Device Password *',error:!_this3.state.isDevicePasswordValid,onBlur:_this3.checkDevicePasswordValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this3.state.isDevicePasswordValid?'':'Password Not Matching'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:_this3.props.handleClose,color:'default',variant:'contained'},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a// onClick={this.handleClose}
,{type:'submit',color:'primary',variant:'contained',disabled:!(_this3.state.isCommandValid&&_this3.state.isDevicePasswordValid&&_this3.state.vehicleName!==''&&_this3.state.devicePassword!==''&&_this3.state.command!=='')},'Submit'))));});}}]);return SendCommands;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_12_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_15__HOCs_withSharedSnackbar__["a" /* default */])(SendCommands))));

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function convertToSnakeCase(input){return input.toLowerCase().replace(/\s+/g,'_');}/* harmony default export */ __webpack_exports__["a"] = (convertToSnakeCase);

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Card__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_CardHeader__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_CardHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_CardHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_CardContent__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_CardContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_CardContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_CardActions__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_CardActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_CardActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_IconButton__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_Input__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__material_ui_core_Hidden__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__material_ui_core_Hidden___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__material_ui_core_Hidden__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__material_ui_icons_FileDownload__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__material_ui_icons_FileDownload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__material_ui_icons_FileDownload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_getAccountType__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__PaymentMethod__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_common_Loader__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__BillingDetails_Subscription__ = __webpack_require__(1114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__common_ConfirmationDialog__ = __webpack_require__(65);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getSubscriptions($subscriptionId: Int) {\n    subscription: getSubscriptions(id: $subscriptionId) {\n      id\n      status\n      gst\n      client {\n        loginId\n        clientName\n        salesPerson {\n          name\n        }\n      }\n      billingMode {\n        id\n        billingMode\n      }\n      billingFrequency {\n        id\n        frequency\n      }\n      deviceQuantity\n      simQuantity\n      accessoryQuantity\n      plan\n      amount\n      createdAt\n      nextPaymentDate\n      unAssignedDeviceQuantity\n      unAssignedAccessoryQuantity\n      unAssignedSimQuantity\n      minimumAmountDue\n      salesRemarks\n      invoiceDownloadLink\n      billingDetails {\n        paymentId\n        totalAmount\n        totalAmountWithGST\n        softwareBill {\n          quantity\n          rate\n          amountWithGST\n          amountToBePaid\n          amountPaidGST\n        }\n        hardwareBill {\n          quantity\n          rate\n          amountWithGST\n          amountToBePaid\n          amountPaidGST\n        }\n        accessoryBill {\n          quantity\n          rate\n          amountWithGST\n          amountToBePaid\n          amountPaidGST\n        }\n        simBill {\n          quantity\n          rate\n          amountWithGST\n          amountToBePaid\n          amountPaidGST\n        }\n      }\n    }\n  }\n'],['\n  query getSubscriptions($subscriptionId: Int) {\n    subscription: getSubscriptions(id: $subscriptionId) {\n      id\n      status\n      gst\n      client {\n        loginId\n        clientName\n        salesPerson {\n          name\n        }\n      }\n      billingMode {\n        id\n        billingMode\n      }\n      billingFrequency {\n        id\n        frequency\n      }\n      deviceQuantity\n      simQuantity\n      accessoryQuantity\n      plan\n      amount\n      createdAt\n      nextPaymentDate\n      unAssignedDeviceQuantity\n      unAssignedAccessoryQuantity\n      unAssignedSimQuantity\n      minimumAmountDue\n      salesRemarks\n      invoiceDownloadLink\n      billingDetails {\n        paymentId\n        totalAmount\n        totalAmountWithGST\n        softwareBill {\n          quantity\n          rate\n          amountWithGST\n          amountToBePaid\n          amountPaidGST\n        }\n        hardwareBill {\n          quantity\n          rate\n          amountWithGST\n          amountToBePaid\n          amountPaidGST\n        }\n        accessoryBill {\n          quantity\n          rate\n          amountWithGST\n          amountToBePaid\n          amountPaidGST\n        }\n        simBill {\n          quantity\n          rate\n          amountWithGST\n          amountToBePaid\n          amountPaidGST\n        }\n      }\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  mutation(\n    $clientLoginId: Int!\n    $paymentId: Int!\n    $subscriptionId: Int!\n    $approveOrReject: approveOrReject!\n    $paidDetails: inputBillingDetails\n    $paymentMode: paymentMode\n    $bankName: String\n    $referenceNumber: String\n    $paymentRemarks: String\n  ) {\n    approveOrRejectSubscription(\n      clientLoginId: $clientLoginId\n      paymentId: $paymentId\n      subscriptionId: $subscriptionId\n      approveOrReject: $approveOrReject\n      paidDetails: $paidDetails\n      paymentMode: $paymentMode\n      bankName: $bankName\n      referenceNumber: $referenceNumber\n      paymentRemarks: $paymentRemarks\n    )\n  }\n'],['\n  mutation(\n    $clientLoginId: Int!\n    $paymentId: Int!\n    $subscriptionId: Int!\n    $approveOrReject: approveOrReject!\n    $paidDetails: inputBillingDetails\n    $paymentMode: paymentMode\n    $bankName: String\n    $referenceNumber: String\n    $paymentRemarks: String\n  ) {\n    approveOrRejectSubscription(\n      clientLoginId: $clientLoginId\n      paymentId: $paymentId\n      subscriptionId: $subscriptionId\n      approveOrReject: $approveOrReject\n      paidDetails: $paidDetails\n      paymentMode: $paymentMode\n      bankName: $bankName\n      referenceNumber: $referenceNumber\n      paymentRemarks: $paymentRemarks\n    )\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation($id: Int!, $clientLoginId: Int!, $partnerLoginId: Int!) {\n    deleteSubscription(\n      id: $id\n      clientLoginId: $clientLoginId\n      partnerLoginId: $partnerLoginId\n    )\n  }\n'],['\n  mutation($id: Int!, $clientLoginId: Int!, $partnerLoginId: Int!) {\n    deleteSubscription(\n      id: $id\n      clientLoginId: $clientLoginId\n      partnerLoginId: $partnerLoginId\n    )\n  }\n']);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_SUBSCRIPTION=Object(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__["a" /* default */])(_templateObject);var APPROVE_REJECT_SUBSCRIPTION=Object(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__["a" /* default */])(_templateObject2);var DELETE_SUBSCRIPTION=Object(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__["a" /* default */])(_templateObject3);var styles=function styles(theme){return{card:{},cardAction:{marginRight:theme.spacing.unit},redButton:{backgroundColor:theme.palette.error.main,'&:hover':{backgroundColor:theme.palette.error.dark}},// buttonBase: {
//   width: '100%',
//   textAlign: 'left'
// },
selectStyle:{minWidth:250},fileDownloadIcon:{marginLeft:theme.spacing.unit,marginRight:-theme.spacing.unit},centerAlign:{display:'flex',alignItems:'center',justifyContent:'center'},billingDetail:{margin:'10px 0'}};};var paymentOption=['NONE','CASH','ONLINE','CHEQUE','DD'];var SubscriptionDetails=function(_Component){_inherits(SubscriptionDetails,_Component);function SubscriptionDetails(props){var _this2=this;_classCallCheck(this,SubscriptionDetails);var _this=_possibleConstructorReturn(this,(SubscriptionDetails.__proto__||Object.getPrototypeOf(SubscriptionDetails)).call(this,props));_this.state={paymentMode:'',error:true,referenceNumber:null,bankName:null,isValidReferenceNumber:true,referenceMessage:'',paidMoney:'',accountRemarks:'',validation:false,hardwarePaymentMade:0,softwarePaymentMade:0,accessoryPaymentMade:0,simPaymentMade:0,paymentId:0,hardwareBalance:0,softwareBalance:0,accessoryBalance:0,simBalance:0,hardwareRemarks:null,softwareRemarks:null,accessoryRemarks:null,simRemarks:null,expectedHardwareDueDate:__WEBPACK_IMPORTED_MODULE_5_moment___default()().add(1,'weeks'),expectedSoftwareDueDate:__WEBPACK_IMPORTED_MODULE_5_moment___default()().add(1,'weeks'),expectedAccessoryDueDate:__WEBPACK_IMPORTED_MODULE_5_moment___default()().add(1,'weeks'),expectedSimsDueDate:__WEBPACK_IMPORTED_MODULE_5_moment___default()().add(1,'weeks'),approveOrReject:null,isCancelConfDialogOpen:false,isSaveConfDialogOpen:false,isDeleteConfDialogOpen:false};_this.assignDevice=function(){_this.props.history.push({pathname:'/home/subscriptions/assign/'+_this.clientLoginId+'/'+_this.subscriptionId});};_this.handleAccountRemarksChange=function(e){_this.setState({accountRemarks:e.target.value});// deassignDevice = () => {
//   this.props.history.push({
//     pathname:
//       '/home/subscriptions/deassign/' +
//       this.clientLoginId +
//       '/' +
//       this.subscriptionId
//   })
// }
// deassignSim = () => {
//   this.props.history.push({
//     pathname:
//       '/home/subscriptions/deassignSim/' +
//       this.clientLoginId +
//       '/' +
//       this.subscriptionId
//   })
// }
// handleAccountRemarksChange = e =>
//   this.setState({ accountRemarks: e.target.value })
};_this.deassignDevice=function(){_this.props.history.push({pathname:'/home/subscriptions/deassign/'+_this.clientLoginId+'/'+_this.subscriptionId});};_this.deassignSim=function(){_this.props.history.push({pathname:'/home/subscriptions/deassignSim/'+_this.clientLoginId+'/'+_this.subscriptionId});};_this.getFormattedDate=function(date1){// const d1 = parseInt(date1, 10)
// const unixEpochTimeMS = d1 * 1000
// const d = new Date(unixEpochTimeMS)
// // Careful, the string output here can vary by implementation...
// const strDate = d.toLocaleDateString()
// return strDate
return __WEBPACK_IMPORTED_MODULE_5_moment___default()(date1*1000).format('DD/MM/YYYY');};_this.handleChangePaymentType=function(event){_this.setState({paymentMode:event.target.value,isValidReferenceNumber:true,referenceMessage:'',referenceNumber:null,bankName:null});};_this.handleChangeReferenceNumber=function(event){_this.setState({referenceNumber:event.target.value});};_this.checkReferenceNumberValidity=function(){var regExValue=new RegExp(/(^[a-zA-Z0-9]{6,15})|(^[0-9]{6,15})|(^[a-zA-Z]{6,15})|(?!)$/);if(_this.state.referenceNumber===null){_this.setState({isValidReferenceNumber:true,referenceMessage:'Please enter Reference/DD/Check number'});}else if(regExValue.test(_this.state.referenceNumber)&&_this.state.referenceNumber!==''){_this.setState({isValidReferenceNumber:true,referenceMessage:''});}else if(_this.state.referenceNumber===''){_this.setState({isValidReferenceNumber:false,referenceMessage:'Please enter Reference/DD/Check number'});}else{_this.setState({isValidReferenceNumber:false,referenceMessage:'Please enter a valid Reference/DD/Check number'});}};_this.handleChangePaidMoney=function(event){_this.setState({paidMoney:event.target.value});};_this.handleChangeBankName=function(event){_this.setState({bankName:event.target.value});};_this.getPaymentId=function(){var subscription=_this.props.data.subscription;var billingDetails=subscription.billingDetails;if(billingDetails!==null){_this.setState({paymentId:billingDetails.paymentId});}else{_this.setState({paymentId:0});}};_this.validateFields=function(){// console.log('this.state.paymentModeff', this.state.paymentMode)
var _this$state=_this.state,hardwarePaymentMade=_this$state.hardwarePaymentMade,softwarePaymentMade=_this$state.softwarePaymentMade,simPaymentMade=_this$state.simPaymentMade,accessoryPaymentMade=_this$state.accessoryPaymentMade;var regExValue=new RegExp(/^([a-zA-Z0-9_-]){5,25}$/);var regExValueBank=new RegExp(/^[A-Za-z\s]{3,30}$/);if(hardwarePaymentMade===''){_this.props.openSnackbar('Hardware payment made should not be blank!');return false;}else if(_this.state.accountRemarks.length>100){console.log('this.state.accountRemarks.length',_this.state.accountRemarks.length);_this.props.openSnackbar('Remarks should be less than 100 Characters!');return false;}else if(softwarePaymentMade===''){_this.props.openSnackbar('Software payment made should not be blank!');return false;}else if(accessoryPaymentMade===''){_this.props.openSnackbar('Accessory payment made should not be blank!');return false;}else if(simPaymentMade===''){_this.props.openSnackbar('Sim payment made should not be blank!');return false;}else if(_this.state.paymentMode==='ONLINE'){if(_this.state.referenceNumber===null||!regExValue.test(_this.state.referenceNumber)){_this.props.openSnackbar('Reference Number length Should between 5 to 25 and Alphanumeric');_this.setState({validation:false});return false;}else if(_this.state.paidMoney<_this.props.data.subscription.minimumAmountDue){_this.props.openSnackbar('Amount Should be greater than or equal to Min. due Amount!');_this.setState({validation:false});return false;}else{_this.setState({validation:true});return true;}}else if(_this.state.paymentMode==='DD'||_this.state.paymentMode==='CHEQUE'){if(!regExValue.test(_this.state.referenceNumber)){_this.props.openSnackbar('Reference Number length Should be between 5 to 25 and Alphanumeric');_this.setState({validation:false});return false;}else if(!regExValueBank.test(_this.state.bankName)||_this.state.bankName===null){console.log('bank name',regExValueBank.test(_this.state.bankName));_this.props.openSnackbar('Bank Name length Should be between 3 to 30 and only alphabets');_this.setState({validation:false});return false;}else if(_this.state.paidMoney<_this.props.data.subscription.minimumAmountDue){_this.props.openSnackbar('Amount Should be greater than or equal to Min. due Amount!');_this.setState({validation:false});return false;}else{console.log('true validation amount',regExValueBank.test(_this.state.bankName));_this.setState({validation:true});return true;}}else{console.log('true validation');_this.setState({validation:true});return true;}};_this.handleRejectMutation=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _ref2,data,approveOrRejectSubscription;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.client.mutate({mutation:APPROVE_REJECT_SUBSCRIPTION,variables:{clientLoginId:_this.clientLoginId,paymentId:parseInt(_this.props.paymentId,10),subscriptionId:parseInt(_this.subscriptionId,10),approveOrReject:_this.state.approveOrReject}});case 2:_ref2=_context.sent;data=_ref2.data;approveOrRejectSubscription=data.approveOrRejectSubscription;if(approveOrRejectSubscription){_this.props.openSnackbar('Subscription Rejected');}_this.props.history.push({pathname:'/home/subscriptions/'});case 7:case'end':return _context.stop();}}},_callee,_this2);}));_this.handleCancelNegativeResponse=function(e){_this.setState({isCancelConfDialogOpen:false});};_this.handleSaveReject=function(){_this.getPaymentId();_this.setState({approveOrReject:'REJECTED'},function(){// console.log('payment Id', this.state.paymentId)
_this.handleRejectMutation();});_this.setState({isCancelConfDialogOpen:false});};_this.handleCancel=function(){_this.setState({isCancelConfDialogOpen:true});};_this.handleApproveMutation=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var _ref4,data,errors;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this.props.client.mutate({mutation:APPROVE_REJECT_SUBSCRIPTION,variables:{clientLoginId:_this.clientLoginId,subscriptionId:parseInt(_this.subscriptionId,10),paidDetails:{hardwareBill:{amountWithGST:parseInt(_this.state.hardwarePaymentMade,10),expectedDateTime:__WEBPACK_IMPORTED_MODULE_5_moment___default()(_this.state.expectedSoftwareDueDate).unix().toString(),accountsRemrks:_this.state.hardwareRemarks},softwareBill:{amountWithGST:parseInt(_this.state.softwarePaymentMade,10),expectedDateTime:__WEBPACK_IMPORTED_MODULE_5_moment___default()(_this.state.expectedHardwareDueDate).unix().toString(),accountsRemrks:_this.state.softwareRemarks},accessoryBill:{amountWithGST:parseInt(_this.state.accessoryPaymentMade,10),expectedDateTime:__WEBPACK_IMPORTED_MODULE_5_moment___default()(_this.state.expectedAccessoryDueDate).unix().toString(),accountsRemrks:_this.state.accessoryRemarks},simBill:{amountWithGST:parseInt(_this.state.simPaymentMade,10),expectedDateTime:__WEBPACK_IMPORTED_MODULE_5_moment___default()(_this.state.expectedSimsDueDate).unix().toString(),accountsRemrks:_this.state.simRemarks}},paymentMode:_this.state.paymentMode,paymentId:parseInt(_this.props.paymentId,10),bankName:_this.state.bankName,referenceNumber:_this.state.referenceNumber,approveOrReject:_this.state.approveOrReject,paymentRemarks:_this.state.accountRemarks},errorPolicy:'all'});case 2:_ref4=_context2.sent;data=_ref4.data;errors=_ref4.errors;// const { approveOrRejectSubscription } = data ? data : ''
if(errors){_this.props.openSnackbar(errors[0].message,{type:'error'});}else if(data.approveOrRejectSubscription){_this.props.openSnackbar(' Subscription Approved');_this.props.history.goBack();}case 6:case'end':return _context2.stop();}}},_callee2,_this2);}));_this.handleSubmitApprove=function(){if(_this.validateFields()){_this.setState({isSaveConfDialogOpen:true});}};_this.handleSaveNegativeResponse=function(e){_this.setState({isSaveConfDialogOpen:false});};_this.handleDeleteNegativeResponse=function(e){_this.setState({isDeleteConfDialogOpen:false});};_this.handleDeleteSubcription=function(e){_this.setState({isDeleteConfDialogOpen:true});};_this.handleSubmit=function(){_this.setState({isSaveConfDialogOpen:false});_this.getPaymentId();if(_this.validateFields()){_this.setState({approveOrReject:'APPROVED'},function(){// console.log('payment Id', this.state.paymentId)
_this.handleApproveMutation();});}};_this.deleteSubscription=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(event){var _ref6,data,errors;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:// event.preventDefault()
// console.log('hi')
_this.setState({isDeleteConfDialogOpen:false});_context3.next=3;return _this.props.client.mutate({mutation:DELETE_SUBSCRIPTION,variables:{clientLoginId:parseInt(_this.clientLoginId),id:parseInt(_this.subscriptionId,10),partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_27__utils_getLoginId__["a" /* default */])()}});case 3:_ref6=_context3.sent;data=_ref6.data;errors=_ref6.errors;if(data){_this.props.openSnackbar('Subscription Deleted Successfully');_this.props.history.push({pathname:'/home/subscriptions'});}else{_this.props.openSnackbar(errors[0].message);}case 7:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x){return _ref5.apply(this,arguments);};}();_this.handleViewPIClick=function(event){var PILink=_this.props.data.subscription.invoiceDownloadLink;if(PILink===null)alert('No PI uploaded.');else window.open(PILink,'_blank');};_this.handlePaymentMade=function(name){return function(event){var value=event.target.value;if(value>=0){_this.setState(_defineProperty({},name,value),function(){_this.calculateBalance(name);});}};};_this.calculateBalance=function(particularName){var _this$state2=_this.state,hardwarePaymentMade=_this$state2.hardwarePaymentMade,softwarePaymentMade=_this$state2.softwarePaymentMade,accessoryPaymentMade=_this$state2.accessoryPaymentMade,simPaymentMade=_this$state2.simPaymentMade;var subscription=_this.props.data.subscription;var _subscription$billing=subscription.billingDetails,hardwareBill=_subscription$billing.hardwareBill,softwareBill=_subscription$billing.softwareBill,accessoryBill=_subscription$billing.accessoryBill,simBill=_subscription$billing.simBill;// console.log('balance calculating:', particularName)
var balanceAmount=0;if(particularName==='hardwarePaymentMade'){balanceAmount=hardwareBill.amountWithGST-hardwarePaymentMade;_this.setState({hardwareBalance:balanceAmount});}if(particularName==='softwarePaymentMade'){balanceAmount=softwareBill.amountWithGST-softwarePaymentMade;_this.setState({softwareBalance:balanceAmount});}if(particularName==='accessoryPaymentMade'){balanceAmount=accessoryBill.amountWithGST-accessoryPaymentMade;_this.setState({accessoryBalance:balanceAmount});}if(particularName==='simPaymentMade'){balanceAmount=simBill.amountWithGST-simPaymentMade;_this.setState({simBalance:balanceAmount});}};_this.getGst=function(Gst){return Gst*100;};_this.handleRemarksChange=function(name){return function(event){var value=event.target.value;_this.setState(_defineProperty({},name,value));// console.log('remarks', name, event)
};};_this.handleExpectedDateChange=function(name){return function(date){_this.setState(_defineProperty({},name,date));};};_this.setInitialBalance=function(){var billingDetails=_this.props.data.subscription.billingDetails;if(billingDetails){var hardwareBill=billingDetails.hardwareBill,softwareBill=billingDetails.softwareBill,accessoryBill=billingDetails.accessoryBill,simBill=billingDetails.simBill;if(hardwareBill){_this.setState({hardwareBalance:hardwareBill.amountWithGST});}if(softwareBill){_this.setState({softwareBalance:softwareBill.amountWithGST});}if(accessoryBill){_this.setState({accessoryBalance:accessoryBill.amountWithGST});}if(simBill){_this.setState({simBalance:simBill.amountWithGST});}}};_this.componentDidMount=function(){if(_this.props.data.subscription){_this.setInitialBalance();}};_this.getStatusType=function(status){if(status===1||status===4){return'Pending';}else if(status===2||status===5){return'Approved';}else if(status===3){return'Rejected';}};_this.subscriptionId=_this.props.subscriptionId;_this.clientLoginId=_this.props.clientLoginId;_this.viewVehicles=_this.props.viewVehicles;_this.clientDetail=_this.props.clientDetail;_this.loginId=_this.props.match.params.loginId;return _this;}// getFormattedDate = timestamp => {
//   moment.unix(parseInt(timestamp, 10)).format('DD/MM/YYYY')
// }
_createClass(SubscriptionDetails,[{key:'render',value:function render(){var _this3=this;var _props=this.props,classes=_props.classes,data=_props.data;var assignDeviceButtonVisible=false;if(['INV'].includes(Object(__WEBPACK_IMPORTED_MODULE_24__utils_getAccountType__["a" /* default */])())&&data&&data.subscription&&data.subscription.unAssignedDeviceQuantity>0||data&&data.subscription&&data.subscription.unAssignedSimQuantity>0||data&&data.subscription&&data.subscription.unAssignedAccessoryQuantity>0){assignDeviceButtonVisible=true;}// const { billingDetails } = data.subscription
var paymentMode=this.state.paymentMode;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__common_ConfirmationDialog__["a" /* default */],{isDialogOpen:this.state.isCancelConfDialogOpen,dialogMessage:'Are you sure you want to Reject?',negativeResponseHandler:this.handleCancelNegativeResponse,positiveResponseHandler:this.handleSaveReject}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__common_ConfirmationDialog__["a" /* default */],{isDialogOpen:this.state.isSaveConfDialogOpen,dialogMessage:'Are you sure you want to Approve?',negativeResponseHandler:this.handleSaveNegativeResponse,positiveResponseHandler:this.handleSubmit}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__common_ConfirmationDialog__["a" /* default */],{isDialogOpen:this.state.isDeleteConfDialogOpen,dialogMessage:'Are you sure you want to Delete Subscription?',negativeResponseHandler:this.handleDeleteNegativeResponse,positiveResponseHandler:this.deleteSubscription})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Grid___default.a,{item:true,xs:12},data.subscription&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Card___default.a,{className:classes.card,raised:true,classes:{action:classes.cardAction},title:data.subscription?data.subscription.billingFrequency.frequency:'N/A',subheader:data.subscription?this.getFormattedDate(data.subscription.createdAt):'N/A',action:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:'body1',style:{fontSize:'20px',paddingTop:'10%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{opacity:'.6'}},'Status:'),data.subscription?this.getStatusType(data.subscription.status):'N/A'),['PA'].includes(Object(__WEBPACK_IMPORTED_MODULE_24__utils_getAccountType__["a" /* default */])())&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__material_ui_core_Hidden___default.a,{xsDown:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Button___default.a,{color:'secondary',variant:'raised',onClick:this.handleViewPIClick},'Download PI',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__material_ui_icons_FileDownload___default.a,{className:classes.fileDownloadIcon}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__material_ui_core_Hidden___default.a,{smUp:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.centerAlign},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_IconButton___default.a,{color:'secondary',variant:'raised',onClick:this.handleViewPIClick},'Download PI',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__material_ui_icons_FileDownload___default.a,{className:classes.fileDownloadIcon})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__material_ui_core_Hidden___default.a,{smUp:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.centerAlign},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_IconButton___default.a,{color:'secondary',onClick:this.handleViewPIClick},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__material_ui_icons_FileDownload___default.a,null))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:'body1'},'Download PI'))))},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Grid___default.a,{item:true,xs:6,sm:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:'body2'},'Quantity:'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:'body1'},data.subscription?data.subscription.deviceQuantity:'N/A')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Grid___default.a,{item:true,xs:6,sm:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:'body2'},'MMTC:'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9',' ',data.subscription?data.subscription.amount+' /-':'N/A')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Grid___default.a,{item:true,xs:6,sm:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:'body2'},'Un-assigned Quantity'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:'body1'},data.subscription?data.subscription.unAssignedDeviceQuantity:'N/A')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Grid___default.a,{item:true,xs:6,sm:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:'body2'},'Sales Remarks:'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:'body1'},data.subscription.salesRemarks?data.subscription.salesRemarks:'N/A')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Grid___default.a,{item:true,xs:6,sm:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:'body2'},'Next Payment Date:'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:'body1'},data.subscription?this.getFormattedDate(data.subscription.nextPaymentDate):'N/A'// eslint-disable-next-line indent
)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Grid___default.a,{item:true,xs:6,sm:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:'body2'},'Bill Mode:'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:'body1'},data.subscription?data.subscription.billingMode.billingMode:'N/A')),!['SER','INV','SAL','ACC','PA'].includes(Object(__WEBPACK_IMPORTED_MODULE_24__utils_getAccountType__["a" /* default */])())&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Grid___default.a,{item:true,xs:6,sm:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:'body2'},'Min. Amount Due:'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9',' ',data.subscription?data.subscription.minimumAmountDue:'N/A')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_CardActions___default.a,null,this.viewVehicles&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:'body1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Button___default.a,{color:'secondary',onClick:this.props.showSubscription(this.props.subscriptionId)},'View Vehicles')),/* eslint-disable indent */['SAL','PA'].includes(Object(__WEBPACK_IMPORTED_MODULE_24__utils_getAccountType__["a" /* default */])())&&data.subscription.unAssignedDeviceQuantity===data.subscription.deviceQuantity&&data.subscription.unAssignedSimQuantity===data.subscription.simQuantity&&data.subscription.unAssignedAccessoryQuantity===data.subscription.accessoryQuantity&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:'body1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Button___default.a,{color:'secondary',onClick:this.deleteSubscription},'Delete Subscription')),/* eslint-disable indent */['INV','PA'].includes(Object(__WEBPACK_IMPORTED_MODULE_24__utils_getAccountType__["a" /* default */])())&&(data.subscription.unAssignedDeviceQuantity>0||data.subscription.unAssignedSimQuantity>0||data.subscription.unAssignedAccessoryQuantity>0)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:'body1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Button___default.a,{color:'secondary',onClick:function onClick(){return _this3.assignDevice(_this3.backUrl);}},'Assign Device'))/* eslint-enable indent */,/* eslint-disable indent */['PA','INV'].includes(Object(__WEBPACK_IMPORTED_MODULE_24__utils_getAccountType__["a" /* default */])())&&data.subscription.unAssignedDeviceQuantity===data.subscription.deviceQuantity&&data.subscription.unAssignedSimQuantity===data.subscription.simQuantity&&data.subscription.unAssignedAccessoryQuantity===data.subscription.accessoryQuantity&&this.getStatusType(data.subscription.status)!=='Approved'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:'body1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Button___default.a,{color:'secondary',onClick:this.handleDeleteSubcription},'Delete Subscription'))/* eslint-enable indent */))),!this.props.isFromCustomer&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Grid___default.a,{item:true,xs:12,className:classes.billingDetail},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__BillingDetails_Subscription__["a" /* default */],{subcriptionData:data,hardwarePaymentMade:this.state.hardwarePaymentMade,softwarePaymentMade:this.state.softwarePaymentMade,accessoryPaymentMade:this.state.accessoryPaymentMade,simPaymentMade:this.state.simPaymentMade,hardwareBalance:this.state.hardwareBalance,softwareBalance:this.state.softwareBalance,accessoryBalance:this.state.accessoryBalance,simBalance:this.state.simBalance,hardwareRemarks:this.state.hardwareRemarks,softwareRemarks:this.state.softwareRemarks,accessoryRemarks:this.state.accessoryRemarks,simRemarks:this.state.simRemarks,expectedHardwareDueDate:this.state.expectedHardwareDueDate,expectedSoftwareDueDate:this.state.expectedSoftwareDueDate,expectedAccessoryDueDate:this.state.expectedAccessoryDueDate,expectedSimsDueDate:this.state.expectedSimsDueDate,handlePaymentMade:this.handlePaymentMade,handleRemarksChange:this.handleRemarksChange,handleExpectedDateChange:this.handleExpectedDateChange})),['ACC'].includes(Object(__WEBPACK_IMPORTED_MODULE_24__utils_getAccountType__["a" /* default */])())&&data.subscription.billingDetails&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Grid___default.a,{item:true,xs:12// data.subscription.minimumAmountDue > 0 &&
},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Card___default.a,{className:classes.card,raised:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_CardHeader___default.a,{title:'Record Payment'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_FormControl___default.a,{className:classes.formControl},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_InputLabel___default.a,{id:'payment-helper'},'Payment Type'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Select___default.a,{labelId:'payment-helper',id:'payment-helper-select',value:this.state.paymentMode,onChange:this.handleChangePaymentType,className:classes.selectStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_MenuItem___default.a,{value:'NONE'},'None'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_MenuItem___default.a,{value:'CASH'},'Cash'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_MenuItem___default.a,{value:'ONLINE'},'Online'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_MenuItem___default.a,{value:'CHEQUE'},'Cheque'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_MenuItem___default.a,{value:'DD'},'DD')))),paymentOption.includes(this.state.paymentMode)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__PaymentMethod__["a" /* default */],{paymentThrough:this.state.paymentMode,handleChangereferenceNumber:this.handleChangeReferenceNumber,checkReferenceNumberValidity:this.checkReferenceNumberValidity,isValidReferenceNumber:this.state.isValidReferenceNumber,referenceMessage:this.state.referenceMessage,handleChangeBankName:this.handleChangeBankName,handleChangePaidMoney:this.handleChangePaidMoney,referenceNumber:this.state.referenceNumber// paidMoney={this.state.paidMoney}
,bankName:this.state.bankName})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_TextField___default.a,{multiline:true,rows:4,label:'Remarks',variant:'contained',onChange:this.handleAccountRemarksChange,value:this.state.accountRemarks,className:classes.selectStyle})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_CardActions___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Button___default.a,{variant:'contained',color:'secondary',classes:{root:classes.redButton},onClick:this.handleCancel},'Reject'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Button___default.a,{disabled:paymentMode==='',variant:'contained',color:'secondary',type:'submit',onClick:this.handleSubmitApprove},'Approve')))));}}]);return SubscriptionDetails;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);SubscriptionDetails.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_26__HOCs_withSharedSnackbar__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["withStyles"])(styles)(function(props){// console.log('props data', props)
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["Query"],{query:GET_SUBSCRIPTION// TODO: Change Query
,variables:{subscriptionId:parseInt(props.subscriptionId,10)}// fetchPolicy="network-only"
},function(_ref7){var loading=_ref7.loading,error=_ref7.error,data=_ref7.data;// console.log('get subscription data', data)
if(loading)return props.disableLoader?null:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__components_common_Loader__["a" /* default */],null);if(error)return'Error!: '+error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SubscriptionDetails,Object.assign({},props,{data:data}));});})))));

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16.24 7.76C15.07 6.59 13.54 6 12 6v6l-4.24 4.24c2.34 2.34 6.14 2.34 8.49 0 2.34-2.34 2.34-6.14-.01-8.48zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
})), 'Timelapse');

exports.default = _default;

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"
})), 'DirectionsCar');

exports.default = _default;

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 24h2v-2H7v2zm4 0h2v-2h-2v2zm2-22h-2v10h2V2zm3.56 2.44l-1.45 1.45C16.84 6.94 18 8.83 18 11c0 3.31-2.69 6-6 6s-6-2.69-6-6c0-2.17 1.16-4.06 2.88-5.12L7.44 4.44C5.36 5.88 4 8.28 4 11c0 4.42 3.58 8 8 8s8-3.58 8-8c0-2.72-1.36-5.12-3.44-6.56zM15 24h2v-2h-2v2z"
})), 'SettingsPower');

exports.default = _default;

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"
})), 'CloudUpload');

exports.default = _default;

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z"
})), 'Folder');

exports.default = _default;

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
})), 'MoreVert');

exports.default = _default;

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Checkbox__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__simpleSnackbar__ = __webpack_require__(2049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import Value from './Value'
var Basic=function(_Component){_inherits(Basic,_Component);function Basic(){_classCallCheck(this,Basic);return _possibleConstructorReturn(this,(Basic.__proto__||Object.getPrototypeOf(Basic)).apply(this,arguments));}_createClass(Basic,[{key:'render',// state = {
//   terms: false
// }
value:function render(){var _this2=this;var cost=0;// console.log('price', this.props.tempPrice)
if(this.props.allFeaturesList){this.props.allFeaturesList.features.map(function(featuresList){return cost=cost+_this2.props.tempPrice[featuresList.id];});}// console.log('totprice', cost)
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,spacing:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'title'},'Total Plan Cost = ',cost)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Checkbox___default.a,{checked:this.terms,onChange:this.props.handleTermsChangeChecked('terms'),value:'terms'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{style:{display:'inline-block'}},'Terms and Conditions')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__simpleSnackbar__["a" /* default */],{terms:this.props.terms,cost:cost,message:this.props.message,planName:this.props.planName,plan:this.props.plan,description:this.props.description,handleSubmit:this.props.handleSubmit,handleCancel:this.props.handleCancel})));}}]);return Basic;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Basic);

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Checkbox__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormGroup__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControlLabel__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControlLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControlLabel__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AllFeatures=function(_Component){_inherits(AllFeatures,_Component);function AllFeatures(){_classCallCheck(this,AllFeatures);return _possibleConstructorReturn(this,(AllFeatures.__proto__||Object.getPrototypeOf(AllFeatures)).apply(this,arguments));}_createClass(AllFeatures,[{key:'render',// constructor(props) {
//   super(props)
// }
value:function render(){var _this2=this;// console.log('component=', this.props.defaultFeatures)
var featuresLists=this.props.allFeaturesList;// const defaultFeatures = this.props.defaultFeatures
var tempState=this.props.tempState;// let defaultFeaturesIds
// if (defaultFeatures) {
//   defaultFeaturesIds = defaultFeatures.getPlans.featureList.map(
//     item => item.id
//   )
// }
console.log('featuresLists',featuresLists);console.log('tempState',tempState);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormGroup___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true},featuresLists.features&&featuresLists.features.map(function(featuresList){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6,md:4,key:featuresList.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Checkbox___default.a,{checked:tempState[featuresList.id],onChange:_this2.props.handleChangeChecked(featuresList.id,featuresList.costPerAssetPerMonth),value:featuresList.id}),label:featuresList.featureName}));})))));}}]);return AllFeatures;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AllFeatures);

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Dialog__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogActions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContent__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogContentText__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogContentText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogContentText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_DialogTitle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_DialogTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_DialogTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_FormHelperText__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_FormHelperText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_FormHelperText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__HOCs_withSharedSnackbar__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  mutation addDeviceModel(\n    $model_name: String!\n    $version: Float!\n    $devicetype: String!\n    $description: String\n    $manufacturerId: Int!\n    $maxPrice: Int\n  ) {\n    addDeviceModel(\n      model_name: $model_name\n      version: $version\n      devicetype: $devicetype\n      description: $description\n      manufacturerId: $manufacturerId\n      maxPrice: $maxPrice\n    )\n  }\n'],['\n  mutation addDeviceModel(\n    $model_name: String!\n    $version: Float!\n    $devicetype: String!\n    $description: String\n    $manufacturerId: Int!\n    $maxPrice: Int\n  ) {\n    addDeviceModel(\n      model_name: $model_name\n      version: $version\n      devicetype: $devicetype\n      description: $description\n      manufacturerId: $manufacturerId\n      maxPrice: $maxPrice\n    )\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query {\n    models: allDeviceModels(status: 1) {\n      id\n      model_name\n      version\n      description\n      maxPrice\n      devicetype\n    }\n  }\n'],['\n  query {\n    models: allDeviceModels(status: 1) {\n      id\n      model_name\n      version\n      description\n      maxPrice\n      devicetype\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query {\n    manufacturers: getAllManufacturer(status: 1) {\n      id\n      manufacturerName\n      manufacturerCode\n    }\n  }\n'],['\n  query {\n    manufacturers: getAllManufacturer(status: 1) {\n      id\n      manufacturerName\n      manufacturerCode\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// calling server for updation
var ADD_MODEL=Object(__WEBPACK_IMPORTED_MODULE_14_graphql_tag__["a" /* default */])(_templateObject);var GET_MODELS=Object(__WEBPACK_IMPORTED_MODULE_14_graphql_tag__["a" /* default */])(_templateObject2);var GET_MANUFACTURER=Object(__WEBPACK_IMPORTED_MODULE_14_graphql_tag__["a" /* default */])(_templateObject3);var styles=function styles(theme){return{button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{margin:theme.spacing.unit,minWidth:120},paper:{position:'absolute',width:theme.spacing.unit*50,backgroundColor:theme.palette.background.paper,boxShadow:theme.shadows[5],padding:theme.spacing.unit*4,top:'20%',left:'20%'},typography:{padding:theme.spacing.unit*2}};};var AddModel=function(_Component){_inherits(AddModel,_Component);function AddModel(props){var _this2=this;_classCallCheck(this,AddModel);var _this=_possibleConstructorReturn(this,(AddModel.__proto__||Object.getPrototypeOf(AddModel)).call(this,props));_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));};};_this.handleClickOpen=function(){_this.setState({open:true});};_this.handleClose=function(){_this.setState({open:false});};_this.handleChange=function(event){_this.setState(_defineProperty({},event.target.name,event.target.value));};_this.handleOpen=function(){_this.setState({open:true});};_this.handleOpenSelect=function(){_this.setState({open1:true});};_this.handleCloseSelect=function(){_this.setState({open1:false});};_this.handleOpenSelectMan=function(){_this.setState({open_man:true});};_this.handleCloseSelectMan=function(){_this.setState({open_man:false});};_this.checkManufacturerNameValidity=function(){var code=_this.state.manufacturerName.split('*');// console.log('man', code[0])
_this.setState({isManufacturerNameValid:_this.state.manufacturerName!=='',manufacturerId:code[0]});};_this.checkModelNameValidity=function(){var regex=new RegExp(// eslint-disable-next-line
/^(?!\s)(?!.*\s$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9 '~?!]{2,}$/);// console.log('a', this.state.modelname)
// console.log(regex.test(this.state.modelname))
_this.setState({isModelNameValid:regex.test(_this.state.modelname)||_this.state.modelname===''// this.state.modelname === ''
});// console.log(this.state.isModelNameValid)
};_this.checkmaxPriceValidity=function(){var regex=new RegExp(/^[0-9]{4,5}$/);// console.log('price', parseInt(this.state.maxPrice, 10))
_this.setState({ismaxPriceValid:regex.test(_this.state.maxPrice)&&_this.state.maxPrice!==''&&// parseInt(this.state.maxPrice, 10) > 1000 ||
parseInt(_this.state.maxPrice,10)!==0});};_this.checkVersionValidity=function(){var regex=new RegExp(// eslint-disable-next-line
// 1-3 dot-separated components, each numeric except that the last one may be *
/^(\d+\.)?(\d+\.)?(\*|\d+)$/);_this.setState({isVersionValid:regex.test(_this.state.version)||_this.state.version===''});};_this.checkDeviceTypeValidity=function(){_this.setState({isDeviceTypeValid:_this.state.devicetype!==''});};_this.handleSubmit=function(client){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _ref2,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:event.preventDefault();_context.next=3;return client.mutate({mutation:ADD_MODEL,variables:{model_name:_this.state.modelname,version:parseFloat(_this.state.version),devicetype:_this.state.devicetype,description:_this.state.description,manufacturerId:parseInt(_this.state.manufacturerId,10),maxPrice:parseInt(_this.state.maxPrice,10)}});case 3:_ref2=_context.sent;data=_ref2.data;// this.state.simprovider = ''
_this.setState({modelname:'',version:'',devicetype:'',description:'',manufacturerId:''});console.log('ADD=',data);_this.props.closeAddModelFunction();_this.props.openSnackbar('New device model added successfully');case 9:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();};_this.getAllManufacturer=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var manufacturers;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this.props.client.query({query:GET_MANUFACTURER});case 2:manufacturers=_context2.sent;if(manufacturers&&manufacturers.data){_this.setState({manufacturers:manufacturers.data.manufacturers});}case 4:case'end':return _context2.stop();}}},_callee2,_this2);}));_this.modelEditForm=function(mid){alert(mid);_this.setState({open2:true});};_this.closeEditModel=function(){_this.setState({modelStatus:false});};_this.state={open:false,open1:false,open2:false,devicetype:'',modelname:'',version:'',description:'',isModelNameValid:true,isDeviceTypeValid:true,isVersionValid:true,response:'',isManufacturerNameValid:true,manufacturerName:'',open_man:false,manufacturerCode:'',manufacturerId:'',manufacturers:[],models:[],maxPrice:'',ismaxPriceValid:true,modelDetails:[],modelStatus:false,mId:''};return _this;}// handleSubmit = addModel => e => {
_createClass(AddModel,[{key:'componentDidMount',value:function componentDidMount(){this.getAllManufacturer();}},{key:'getModalStyle',value:function getModalStyle(){var top=30;var left=20;return{top:top+'%',left:left+'%',transform:'translate(-'+top+'%, -'+left+'%)'};}},{key:'render',// Table display ends
value:function render(){var _this3=this;var classes=this.props.classes;// console.log(this.state.manufacturers)
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_apollo__["Query"],{query:GET_MODELS},function(_ref4){var loading=_ref4.loading,error=_ref4.error,modelsList=_ref4.data.models;if(loading)return'Loading...';if(error)return'Error! '+error.message;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Dialog___default.a,{open:_this3.props.openStatus,onClose:_this3.closeAddModelFunction,'aria-labelledby':'form-dialog-title'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_DialogTitle___default.a,{id:'form-dialog-title'},'Add Model Details :'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{onSubmit:_this3.handleSubmit(_this3.props.client)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogContentText___default.a,null,'* Marked fields are mandatory'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_InputLabel___default.a,{htmlFor:'demo-controlled-open-select'},'Select Manufacturer *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Select___default.a,{open:_this3.state.open_man,fullWidth:true,onClose:_this3.handleCloseSelectMan,onOpen:_this3.handleOpenSelectMan,value:_this3.state.manufacturerName,onChange:_this3.handleChange,onBlur:_this3.checkManufacturerNameValidity,inputProps:{name:'manufacturerName',id:'manufacturerName'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),_this3.state.manufacturers.map(function(manufacturer){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_MenuItem___default.a,{value:manufacturer.id+'*'+manufacturer.manufacturerCode,key:manufacturer.id},manufacturer.manufacturerName);})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!_this3.state.isManufacturerNameValid?'Invalid Selection':'')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'modelname',name:'modelname',label:'Model Name',type:'text',required:true,value:_this3.state.modelname// fullWidth
,onChange:_this3.handleInputChange('modelname'),error:!_this3.state.isModelNameValid,onBlur:_this3.checkModelNameValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!_this3.state.isModelNameValid?'Invalid ModelName':'')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'version',label:'Version',type:'text',required:true// fullWidth
,value:_this3.state.version,onChange:_this3.handleInputChange('version'),error:!_this3.state.isVersionValid,onBlur:_this3.checkVersionValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!_this3.state.isVersionValid?'Invalid Version':'')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_FormControl___default.a// className={classes.formControl}
,{style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_InputLabel___default.a,{htmlFor:'demo-controlled-open-select'},'Device Type *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Select___default.a,{open:_this3.state.open1,onClose:_this3.handleCloseSelect,onOpen:_this3.handleOpenSelect,value:_this3.state.devicetype,onChange:_this3.handleChange,onBlur:_this3.checkDeviceTypeValidity,required:true,inputProps:{name:'devicetype',id:'devicetype'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_MenuItem___default.a,{value:'obd'},'OBD'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_MenuItem___default.a,{value:'nonobd'},'Non OBD'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_MenuItem___default.a,{value:'AS140'},'AS140')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!_this3.state.isDeviceTypeValid?'Invalid Selection':'')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'description',name:'description',label:'Description',type:'text',value:_this3.state.description,onChange:_this3.handleInputChange('description')})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField___default.a// autoFocus
,{margin:'dense',id:'maxPrice',label:'Max Price',type:'text',required:true// fullWidth
,value:_this3.state.maxPrice,onChange:_this3.handleInputChange('maxPrice'),error:!_this3.state.ismaxPriceValid,onBlur:_this3.checkmaxPriceValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!_this3.state.ismaxPriceValid?'Max price should be between 1000 and 10000':''))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogActions___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:_this3.props.closeAddModelFunction,color:'default',variant:'contained'},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a// onClick={this.handleClose}
,{color:'primary',variant:'contained',type:'submit',disabled:!(_this3.state.isVersionValid&&_this3.state.isDeviceTypeValid&&_this3.state.modelname!==''&&_this3.state.version!==''&&_this3.state.maxPrice!==''&&_this3.state.ismaxPriceValid&&_this3.state.isManufacturerNameValid&&_this3.state.manufacturerName!=='')},'Submit'))))));});}}]);return AddModel;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_17__HOCs_withSharedSnackbar__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_15_react_apollo__["withApollo"])(AddModel))));

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__voronoi__ = __webpack_require__(2087);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__voronoi__["a"]; });



/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = createCell;
/* harmony export (immutable) */ __webpack_exports__["a"] = cellHalfedgeStart;
/* unused harmony export cellHalfedgeEnd */
/* harmony export (immutable) */ __webpack_exports__["d"] = sortCellHalfedges;
/* harmony export (immutable) */ __webpack_exports__["b"] = clipCells;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Edge__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Diagram__ = __webpack_require__(191);



function createCell(site) {
  return __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */][site.index] = {
    site: site,
    halfedges: []
  };
}

function cellHalfedgeAngle(cell, edge) {
  var site = cell.site,
      va = edge.left,
      vb = edge.right;
  if (site === vb) vb = va, va = site;
  if (vb) return Math.atan2(vb[1] - va[1], vb[0] - va[0]);
  if (site === va) va = edge[1], vb = edge[0];
  else va = edge[0], vb = edge[1];
  return Math.atan2(va[0] - vb[0], vb[1] - va[1]);
}

function cellHalfedgeStart(cell, edge) {
  return edge[+(edge.left !== cell.site)];
}

function cellHalfedgeEnd(cell, edge) {
  return edge[+(edge.left === cell.site)];
}

function sortCellHalfedges() {
  for (var i = 0, n = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */].length, cell, halfedges, j, m; i < n; ++i) {
    if ((cell = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */][i]) && (m = (halfedges = cell.halfedges).length)) {
      var index = new Array(m),
          array = new Array(m);
      for (j = 0; j < m; ++j) index[j] = j, array[j] = cellHalfedgeAngle(cell, __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */][halfedges[j]]);
      index.sort(function(i, j) { return array[j] - array[i]; });
      for (j = 0; j < m; ++j) array[j] = halfedges[index[j]];
      for (j = 0; j < m; ++j) halfedges[j] = array[j];
    }
  }
}

function clipCells(x0, y0, x1, y1) {
  var nCells = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */].length,
      iCell,
      cell,
      site,
      iHalfedge,
      halfedges,
      nHalfedges,
      start,
      startX,
      startY,
      end,
      endX,
      endY,
      cover = true;

  for (iCell = 0; iCell < nCells; ++iCell) {
    if (cell = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */][iCell]) {
      site = cell.site;
      halfedges = cell.halfedges;
      iHalfedge = halfedges.length;

      // Remove any dangling clipped edges.
      while (iHalfedge--) {
        if (!__WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */][halfedges[iHalfedge]]) {
          halfedges.splice(iHalfedge, 1);
        }
      }

      // Insert any border edges as necessary.
      iHalfedge = 0, nHalfedges = halfedges.length;
      while (iHalfedge < nHalfedges) {
        end = cellHalfedgeEnd(cell, __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */][halfedges[iHalfedge]]), endX = end[0], endY = end[1];
        start = cellHalfedgeStart(cell, __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */][halfedges[++iHalfedge % nHalfedges]]), startX = start[0], startY = start[1];
        if (Math.abs(endX - startX) > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] || Math.abs(endY - startY) > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */]) {
          halfedges.splice(iHalfedge, 0, __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */].push(Object(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site, end,
              Math.abs(endX - x0) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] && y1 - endY > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? [x0, Math.abs(startX - x0) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? startY : y1]
              : Math.abs(endY - y1) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] && x1 - endX > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? [Math.abs(startY - y1) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? startX : x1, y1]
              : Math.abs(endX - x1) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] && endY - y0 > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? [x1, Math.abs(startX - x1) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? startY : y0]
              : Math.abs(endY - y0) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] && endX - x0 > __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? [Math.abs(startY - y0) < __WEBPACK_IMPORTED_MODULE_1__Diagram__["f" /* epsilon */] ? startX : x0, y0]
              : null)) - 1);
          ++nHalfedges;
        }
      }

      if (nHalfedges) cover = false;
    }
  }

  // If there weren’t any edges, have the closest site cover the extent.
  // It doesn’t matter which corner of the extent we measure!
  if (cover) {
    var dx, dy, d2, dc = Infinity;

    for (iCell = 0, cover = null; iCell < nCells; ++iCell) {
      if (cell = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */][iCell]) {
        site = cell.site;
        dx = site[0] - x0;
        dy = site[1] - y0;
        d2 = dx * dx + dy * dy;
        if (d2 < dc) dc = d2, cover = cell;
      }
    }

    if (cover) {
      var v00 = [x0, y0], v01 = [x0, y1], v11 = [x1, y1], v10 = [x1, y0];
      cover.halfedges.push(
        __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */].push(Object(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site = cover.site, v00, v01)) - 1,
        __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */].push(Object(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site, v01, v11)) - 1,
        __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */].push(Object(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site, v11, v10)) - 1,
        __WEBPACK_IMPORTED_MODULE_1__Diagram__["e" /* edges */].push(Object(__WEBPACK_IMPORTED_MODULE_0__Edge__["b" /* createBorderEdge */])(site, v10, v00)) - 1
      );
    }
  }

  // Lastly delete any cells with no edges; these were entirely clipped.
  for (iCell = 0; iCell < nCells; ++iCell) {
    if (cell = __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */][iCell]) {
      if (!cell.halfedges.length) {
        delete __WEBPACK_IMPORTED_MODULE_1__Diagram__["b" /* cells */][iCell];
      }
    }
  }
}


/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return firstCircle; });
/* harmony export (immutable) */ __webpack_exports__["a"] = attachCircle;
/* harmony export (immutable) */ __webpack_exports__["b"] = detachCircle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RedBlackTree__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Diagram__ = __webpack_require__(191);



var circlePool = [];

var firstCircle;

function Circle() {
  Object(__WEBPACK_IMPORTED_MODULE_0__RedBlackTree__["a" /* RedBlackNode */])(this);
  this.x =
  this.y =
  this.arc =
  this.site =
  this.cy = null;
}

function attachCircle(arc) {
  var lArc = arc.P,
      rArc = arc.N;

  if (!lArc || !rArc) return;

  var lSite = lArc.site,
      cSite = arc.site,
      rSite = rArc.site;

  if (lSite === rSite) return;

  var bx = cSite[0],
      by = cSite[1],
      ax = lSite[0] - bx,
      ay = lSite[1] - by,
      cx = rSite[0] - bx,
      cy = rSite[1] - by;

  var d = 2 * (ax * cy - ay * cx);
  if (d >= -__WEBPACK_IMPORTED_MODULE_1__Diagram__["g" /* epsilon2 */]) return;

  var ha = ax * ax + ay * ay,
      hc = cx * cx + cy * cy,
      x = (cy * ha - ay * hc) / d,
      y = (ax * hc - cx * ha) / d;

  var circle = circlePool.pop() || new Circle;
  circle.arc = arc;
  circle.site = cSite;
  circle.x = x + bx;
  circle.y = (circle.cy = y + by) + Math.sqrt(x * x + y * y); // y bottom

  arc.circle = circle;

  var before = null,
      node = __WEBPACK_IMPORTED_MODULE_1__Diagram__["c" /* circles */]._;

  while (node) {
    if (circle.y < node.y || (circle.y === node.y && circle.x <= node.x)) {
      if (node.L) node = node.L;
      else { before = node.P; break; }
    } else {
      if (node.R) node = node.R;
      else { before = node; break; }
    }
  }

  __WEBPACK_IMPORTED_MODULE_1__Diagram__["c" /* circles */].insert(before, circle);
  if (!before) firstCircle = circle;
}

function detachCircle(arc) {
  var circle = arc.circle;
  if (circle) {
    if (!circle.P) firstCircle = circle.N;
    __WEBPACK_IMPORTED_MODULE_1__Diagram__["c" /* circles */].remove(circle);
    circlePool.push(circle);
    Object(__WEBPACK_IMPORTED_MODULE_0__RedBlackTree__["a" /* RedBlackNode */])(circle);
    arc.circle = null;
  }
}


/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deg2rad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return rad2deg; });
var deg2rad = Math.PI / 180;
var rad2deg = 180 / Math.PI;


/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export rgbBasis */
/* unused harmony export rgbBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis_js__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basisClosed_js__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__color_js__ = __webpack_require__(161);





/* harmony default export */ __webpack_exports__["a"] = ((function rgbGamma(y) {
  var color = Object(__WEBPACK_IMPORTED_MODULE_3__color_js__["b" /* gamma */])(y);

  function rgb(start, end) {
    var r = color((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* rgb */])(start)).r, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* rgb */])(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_3__color_js__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb.gamma = rgbGamma;

  return rgb;
})(1));

function rgbSpline(spline) {
  return function(colors) {
    var n = colors.length,
        r = new Array(n),
        g = new Array(n),
        b = new Array(n),
        i, color;
    for (i = 0; i < n; ++i) {
      color = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* rgb */])(colors[i]);
      r[i] = color.r || 0;
      g[i] = color.g || 0;
      b[i] = color.b || 0;
    }
    r = spline(r);
    g = spline(g);
    b = spline(b);
    color.opacity = 1;
    return function(t) {
      color.r = r(t);
      color.g = g(t);
      color.b = b(t);
      return color + "";
    };
  };
}

var rgbBasis = rgbSpline(__WEBPACK_IMPORTED_MODULE_1__basis_js__["b" /* default */]);
var rgbBasisClosed = rgbSpline(__WEBPACK_IMPORTED_MODULE_2__basisClosed_js__["a" /* default */]);


/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis_js__ = __webpack_require__(342);


/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  var n = values.length;
  return function(t) {
    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
        v0 = values[(i + n - 1) % n],
        v1 = values[i % n],
        v2 = values[(i + 1) % n],
        v3 = values[(i + 2) % n];
    return Object(__WEBPACK_IMPORTED_MODULE_0__basis_js__["a" /* basis */])((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = genericArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value_js__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__numberArray_js__ = __webpack_require__(343);



/* unused harmony default export */ var _unused_webpack_default_export = (function(a, b) {
  return (Object(__WEBPACK_IMPORTED_MODULE_1__numberArray_js__["b" /* isNumberArray */])(b) ? __WEBPACK_IMPORTED_MODULE_1__numberArray_js__["a" /* default */] : genericArray)(a, b);
});

function genericArray(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(na),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = Object(__WEBPACK_IMPORTED_MODULE_0__value_js__["a" /* default */])(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
}


/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var d = new Date;
  return a = +a, b = +b, function(t) {
    return d.setTime(a * (1 - t) + b * t), d;
  };
});


/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value_js__ = __webpack_require__(339);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = Object(__WEBPACK_IMPORTED_MODULE_0__value_js__["a" /* default */])(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
});


/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number_js__ = __webpack_require__(253);


var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero(b) {
  return function() {
    return b;
  };
}

function one(b) {
  return function(t) {
    return b(t) + "";
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: Object(__WEBPACK_IMPORTED_MODULE_0__number_js__["a" /* default */])(am, bm)});
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
});


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = {
  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
  gentle: { stiffness: 120, damping: 14 },
  wobbly: { stiffness: 180, damping: 12 },
  stiff: { stiffness: 210, damping: 20 }
};
module.exports = exports["default"];

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bisectRight */
/* unused harmony export bisectLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisector__ = __webpack_require__(564);



var ascendingBisect = Object(__WEBPACK_IMPORTED_MODULE_1__bisector__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]);
var bisectRight = ascendingBisect.right;
var bisectLeft = ascendingBisect.left;
/* harmony default export */ __webpack_exports__["a"] = (bisectRight);


/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(162);


/* harmony default export */ __webpack_exports__["a"] = (function(compare) {
  if (compare.length === 1) compare = ascendingComparator(compare);
  return {
    left: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) < 0) lo = mid + 1;
        else hi = mid;
      }
      return lo;
    },
    right: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) > 0) hi = mid;
        else lo = mid + 1;
      }
      return lo;
    }
  };
});

function ascendingComparator(f) {
  return function(d, x) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */])(f(d), x);
  };
}


/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pair;
/* unused harmony default export */ var _unused_webpack_default_export = (function(array, f) {
  if (f == null) f = pair;
  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
  while (i < n) pairs[i] = f(p, p = array[++i]);
  return pairs;
});

function pair(a, b) {
  return [a, b];
}


/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__variance__ = __webpack_require__(567);


/* harmony default export */ __webpack_exports__["a"] = (function(array, f) {
  var v = Object(__WEBPACK_IMPORTED_MODULE_0__variance__["a" /* default */])(array, f);
  return v ? Math.sqrt(v) : v;
});


/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(192);


/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      m = 0,
      i = -1,
      mean = 0,
      value,
      delta,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  if (m > 1) return sum / (m - 1);
});


/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  return [min, max];
});


/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
var array = Array.prototype;

var slice = array.slice;
var map = array.map;


/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

  var i = -1,
      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
      range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
});


/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = tickIncrement;
/* harmony export (immutable) */ __webpack_exports__["c"] = tickStep;
var e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);

/* harmony default export */ __webpack_exports__["a"] = (function(start, stop, count) {
  var reverse,
      i = -1,
      n,
      ticks,
      step;

  stop = +stop, start = +start, count = +count;
  if (start === stop && count > 0) return [start];
  if (reverse = stop < start) n = start, start = stop, stop = n;
  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

  if (step > 0) {
    start = Math.ceil(start / step);
    stop = Math.floor(stop / step);
    ticks = new Array(n = Math.ceil(stop - start + 1));
    while (++i < n) ticks[i] = (start + i) * step;
  } else {
    start = Math.floor(start * step);
    stop = Math.ceil(stop * step);
    ticks = new Array(n = Math.ceil(start - stop + 1));
    while (++i < n) ticks[i] = (start - i) / step;
  }

  if (reverse) ticks.reverse();

  return ticks;
});

function tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0
      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}

function tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= e10) step1 *= 10;
  else if (error >= e5) step1 *= 5;
  else if (error >= e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}


/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
});


/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  return min;
});


/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__min__ = __webpack_require__(573);


/* harmony default export */ __webpack_exports__["a"] = (function(matrix) {
  if (!(n = matrix.length)) return [];
  for (var i = -1, m = Object(__WEBPACK_IMPORTED_MODULE_0__min__["a" /* default */])(matrix, length), transpose = new Array(m); ++i < m;) {
    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
      row[j] = matrix[j][i];
    }
  }
  return transpose;
});

function length(d) {
  return d.length;
}


/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export implicit */
/* harmony export (immutable) */ __webpack_exports__["a"] = ordinal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_collection__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(131);



var implicit = {name: "implicit"};

function ordinal(range) {
  var index = Object(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["a" /* map */])(),
      domain = [],
      unknown = implicit;

  range = range == null ? [] : __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(range);

  function scale(d) {
    var key = d + "", i = index.get(key);
    if (!i) {
      if (unknown !== implicit) return unknown;
      index.set(key, i = domain.push(d));
    }
    return range[(i - 1) % range.length];
  }

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = Object(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["a" /* map */])();
    var i = -1, n = _.length, d, key;
    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
    return scale;
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), scale) : range.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return ordinal()
        .domain(domain)
        .range(range)
        .unknown(unknown);
  };

  return scale;
}


/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return +x;
});


/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent_js__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatGroup_js__ = __webpack_require__(2139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatNumerals_js__ = __webpack_require__(2140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__formatSpecifier_js__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__formatTrim_js__ = __webpack_require__(2141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__formatTypes_js__ = __webpack_require__(2142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__formatPrefixAuto_js__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__identity_js__ = __webpack_require__(2144);









var map = Array.prototype.map,
    prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];

/* harmony default export */ __webpack_exports__["a"] = (function(locale) {
  var group = locale.grouping === undefined || locale.thousands === undefined ? __WEBPACK_IMPORTED_MODULE_7__identity_js__["a" /* default */] : Object(__WEBPACK_IMPORTED_MODULE_1__formatGroup_js__["a" /* default */])(map.call(locale.grouping, Number), locale.thousands + ""),
      currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "",
      currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "",
      decimal = locale.decimal === undefined ? "." : locale.decimal + "",
      numerals = locale.numerals === undefined ? __WEBPACK_IMPORTED_MODULE_7__identity_js__["a" /* default */] : Object(__WEBPACK_IMPORTED_MODULE_2__formatNumerals_js__["a" /* default */])(map.call(locale.numerals, String)),
      percent = locale.percent === undefined ? "%" : locale.percent + "",
      minus = locale.minus === undefined ? "-" : locale.minus + "",
      nan = locale.nan === undefined ? "NaN" : locale.nan + "";

  function newFormat(specifier) {
    specifier = Object(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier_js__["a" /* default */])(specifier);

    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        trim = specifier.trim,
        type = specifier.type;

    // The "n" type is an alias for ",g".
    if (type === "n") comma = true, type = "g";

    // The "" type, and any invalid type, is an alias for ".12~g".
    else if (!__WEBPACK_IMPORTED_MODULE_5__formatTypes_js__["a" /* default */][type]) precision === undefined && (precision = 12), trim = true, type = "g";

    // If zero fill is specified, padding goes after sign and before digits.
    if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = __WEBPACK_IMPORTED_MODULE_5__formatTypes_js__["a" /* default */][type],
        maybeSuffix = /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision === undefined ? 6
        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
        : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i, n, c;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Determine the sign. -0 is not less than 0, but 1 / -0 is!
        var valueNegative = value < 0 || 1 / value < 0;

        // Perform the initial formatting.
        value = isNaN(value) ? nan : formatType(Math.abs(value), precision);

        // Trim insignificant zeros.
        if (trim) value = Object(__WEBPACK_IMPORTED_MODULE_4__formatTrim_js__["a" /* default */])(value);

        // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
        if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? (sign === "(" ? sign : minus) : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = (type === "s" ? prefixes[8 + __WEBPACK_IMPORTED_MODULE_6__formatPrefixAuto_js__["b" /* prefixExponent */] / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<": value = valuePrefix + value + valueSuffix + padding; break;
        case "=": value = valuePrefix + padding + value + valueSuffix; break;
        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
        default: value = padding + valuePrefix + value + valueSuffix; break;
      }

      return numerals(value);
    }

    format.toString = function() {
      return specifier + "";
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = Object(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier_js__["a" /* default */])(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(Object(__WEBPACK_IMPORTED_MODULE_0__exponent_js__["a" /* default */])(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes[8 + e / 3];
    return function(value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
});


/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatSpecifier;
/* unused harmony export FormatSpecifier */
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;

function formatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
  var match;
  return new FormatSpecifier({
    fill: match[1],
    align: match[2],
    sign: match[3],
    symbol: match[4],
    zero: match[5],
    width: match[6],
    comma: match[7],
    precision: match[8] && match[8].slice(1),
    trim: match[9],
    type: match[10]
  });
}

formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
  this.align = specifier.align === undefined ? ">" : specifier.align + "";
  this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
  this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
  this.zero = !!specifier.zero;
  this.width = specifier.width === undefined ? undefined : +specifier.width;
  this.comma = !!specifier.comma;
  this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
  this.trim = !!specifier.trim;
  this.type = specifier.type === undefined ? "" : specifier.type + "";
}

FormatSpecifier.prototype.toString = function() {
  return this.fill
      + this.align
      + this.sign
      + this.symbol
      + (this.zero ? "0" : "")
      + (this.width === undefined ? "" : Math.max(1, this.width | 0))
      + (this.comma ? "," : "")
      + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0))
      + (this.trim ? "~" : "")
      + this.type;
};


/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prefixExponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__ = __webpack_require__(257);


var prefixExponent;

/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  var d = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__["b" /* formatDecimalParts */])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1],
      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
      n = coefficient.length;
  return i === n ? coefficient
      : i > n ? coefficient + new Array(i - n + 1).join("0")
      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
      : "0." + new Array(1 - i).join("0") + Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__["b" /* formatDecimalParts */])(x, Math.max(0, p + i - 1))[0]; // less than 1y!
});


/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(domain, interval) {
  domain = domain.slice();

  var i0 = 0,
      i1 = domain.length - 1,
      x0 = domain[i0],
      x1 = domain[i1],
      t;

  if (x1 < x0) {
    t = i0, i0 = i1, i1 = t;
    t = x0, x0 = x1, x1 = t;
  }

  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
});


/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calendar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_time_format__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__array__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__continuous__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__nice__ = __webpack_require__(580);








var durationSecond = 1000,
    durationMinute = durationSecond * 60,
    durationHour = durationMinute * 60,
    durationDay = durationHour * 24,
    durationWeek = durationDay * 7,
    durationMonth = durationDay * 30,
    durationYear = durationDay * 365;

function date(t) {
  return new Date(t);
}

function number(t) {
  return t instanceof Date ? +t : +new Date(+t);
}

function calendar(year, month, week, day, hour, minute, second, millisecond, format) {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_5__continuous__["b" /* default */])(__WEBPACK_IMPORTED_MODULE_5__continuous__["c" /* deinterpolateLinear */], __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["c" /* interpolateNumber */]),
      invert = scale.invert,
      domain = scale.domain;

  var formatMillisecond = format(".%L"),
      formatSecond = format(":%S"),
      formatMinute = format("%I:%M"),
      formatHour = format("%I %p"),
      formatDay = format("%a %d"),
      formatWeek = format("%b %d"),
      formatMonth = format("%B"),
      formatYear = format("%Y");

  var tickIntervals = [
    [second,  1,      durationSecond],
    [second,  5,  5 * durationSecond],
    [second, 15, 15 * durationSecond],
    [second, 30, 30 * durationSecond],
    [minute,  1,      durationMinute],
    [minute,  5,  5 * durationMinute],
    [minute, 15, 15 * durationMinute],
    [minute, 30, 30 * durationMinute],
    [  hour,  1,      durationHour  ],
    [  hour,  3,  3 * durationHour  ],
    [  hour,  6,  6 * durationHour  ],
    [  hour, 12, 12 * durationHour  ],
    [   day,  1,      durationDay   ],
    [   day,  2,  2 * durationDay   ],
    [  week,  1,      durationWeek  ],
    [ month,  1,      durationMonth ],
    [ month,  3,  3 * durationMonth ],
    [  year,  1,      durationYear  ]
  ];

  function tickFormat(date) {
    return (second(date) < date ? formatMillisecond
        : minute(date) < date ? formatSecond
        : hour(date) < date ? formatMinute
        : day(date) < date ? formatHour
        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
        : year(date) < date ? formatMonth
        : formatYear)(date);
  }

  function tickInterval(interval, start, stop, step) {
    if (interval == null) interval = 10;

    // If a desired tick count is specified, pick a reasonable tick interval
    // based on the extent of the domain and a rough estimate of tick size.
    // Otherwise, assume interval is already a time interval and use it.
    if (typeof interval === "number") {
      var target = Math.abs(stop - start) / interval,
          i = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["c" /* bisector */])(function(i) { return i[2]; }).right(tickIntervals, target);
      if (i === tickIntervals.length) {
        step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["m" /* tickStep */])(start / durationYear, stop / durationYear, interval);
        interval = year;
      } else if (i) {
        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        step = i[1];
        interval = i[0];
      } else {
        step = Math.max(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["m" /* tickStep */])(start, stop, interval), 1);
        interval = millisecond;
      }
    }

    return step == null ? interval : interval.every(step);
  }

  scale.invert = function(y) {
    return new Date(invert(y));
  };

  scale.domain = function(_) {
    return arguments.length ? domain(__WEBPACK_IMPORTED_MODULE_4__array__["a" /* map */].call(_, number)) : domain().map(date);
  };

  scale.ticks = function(interval, step) {
    var d = domain(),
        t0 = d[0],
        t1 = d[d.length - 1],
        r = t1 < t0,
        t;
    if (r) t = t0, t0 = t1, t1 = t;
    t = tickInterval(interval, t0, t1, step);
    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
    return r ? t.reverse() : t;
  };

  scale.tickFormat = function(count, specifier) {
    return specifier == null ? tickFormat : format(specifier);
  };

  scale.nice = function(interval, step) {
    var d = domain();
    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
        ? domain(Object(__WEBPACK_IMPORTED_MODULE_6__nice__["a" /* default */])(d, interval))
        : scale;
  };

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_5__continuous__["a" /* copy */])(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format));
  };

  return scale;
}

/* harmony default export */ __webpack_exports__["b"] = (function() {
  return calendar(__WEBPACK_IMPORTED_MODULE_2_d3_time__["k" /* timeYear */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["f" /* timeMonth */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["j" /* timeWeek */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["a" /* timeDay */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["b" /* timeHour */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["d" /* timeMinute */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["g" /* timeSecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["c" /* timeMillisecond */], __WEBPACK_IMPORTED_MODULE_3_d3_time_format__["a" /* timeFormat */]).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
});


/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultLocale_js__ = __webpack_require__(354);
/* unused harmony reexport timeFormatDefaultLocale */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__defaultLocale_js__["a"]; });
/* unused harmony reexport timeParse */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__defaultLocale_js__["b"]; });
/* unused harmony reexport utcParse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locale_js__ = __webpack_require__(583);
/* unused harmony reexport timeFormatLocale */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isoFormat_js__ = __webpack_require__(584);
/* unused harmony reexport isoFormat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isoParse_js__ = __webpack_require__(2167);
/* unused harmony reexport isoParse */






/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatLocale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_time__ = __webpack_require__(353);


function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}

function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}

function newDate(y, m, d) {
  return {y: y, m: m, d: d, H: 0, M: 0, S: 0, L: 0};
}

function formatLocale(locale) {
  var locale_dateTime = locale.dateTime,
      locale_date = locale.date,
      locale_time = locale.time,
      locale_periods = locale.periods,
      locale_weekdays = locale.days,
      locale_shortWeekdays = locale.shortDays,
      locale_months = locale.months,
      locale_shortMonths = locale.shortMonths;

  var periodRe = formatRe(locale_periods),
      periodLookup = formatLookup(locale_periods),
      weekdayRe = formatRe(locale_weekdays),
      weekdayLookup = formatLookup(locale_weekdays),
      shortWeekdayRe = formatRe(locale_shortWeekdays),
      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
      monthRe = formatRe(locale_months),
      monthLookup = formatLookup(locale_months),
      shortMonthRe = formatRe(locale_shortMonths),
      shortMonthLookup = formatLookup(locale_shortMonths);

  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "f": formatMicroseconds,
    "g": formatYearISO,
    "G": formatFullYearISO,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "q": formatQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatSeconds,
    "u": formatWeekdayNumberMonday,
    "U": formatWeekNumberSunday,
    "V": formatWeekNumberISO,
    "w": formatWeekdayNumberSunday,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };

  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "f": formatUTCMicroseconds,
    "g": formatUTCYearISO,
    "G": formatUTCFullYearISO,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "q": formatUTCQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatUTCSeconds,
    "u": formatUTCWeekdayNumberMonday,
    "U": formatUTCWeekNumberSunday,
    "V": formatUTCWeekNumberISO,
    "w": formatUTCWeekdayNumberSunday,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };

  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "f": parseMicroseconds,
    "g": parseYear,
    "G": parseFullYear,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "q": parseQuarter,
    "Q": parseUnixTimestamp,
    "s": parseUnixTimestampSeconds,
    "S": parseSeconds,
    "u": parseWeekdayNumberMonday,
    "U": parseWeekNumberSunday,
    "V": parseWeekNumberISO,
    "w": parseWeekdayNumberSunday,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };

  // These recursive directive definitions must be deferred.
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);

  function newFormat(specifier, formats) {
    return function(date) {
      var string = [],
          i = -1,
          j = 0,
          n = specifier.length,
          c,
          pad,
          format;

      if (!(date instanceof Date)) date = new Date(+date);

      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
          else pad = c === "e" ? " " : "0";
          if (format = formats[c]) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }

      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }

  function newParse(specifier, Z) {
    return function(string) {
      var d = newDate(1900, undefined, 1),
          i = parseSpecifier(d, specifier, string += "", 0),
          week, day;
      if (i != string.length) return null;

      // If a UNIX timestamp is specified, return it.
      if ("Q" in d) return new Date(d.Q);
      if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));

      // If this is utcParse, never use the local timezone.
      if (Z && !("Z" in d)) d.Z = 0;

      // The am-pm flag is 0 for AM, and 1 for PM.
      if ("p" in d) d.H = d.H % 12 + d.p * 12;

      // If the month was not specified, inherit from the quarter.
      if (d.m === undefined) d.m = "q" in d ? d.q : 0;

      // Convert day-of-week and week-of-year to day-of-year.
      if ("V" in d) {
        if (d.V < 1 || d.V > 53) return null;
        if (!("w" in d)) d.w = 1;
        if ("Z" in d) {
          week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
          week = day > 4 || day === 0 ? __WEBPACK_IMPORTED_MODULE_0_d3_time__["p" /* utcMonday */].ceil(week) : Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["p" /* utcMonday */])(week);
          week = __WEBPACK_IMPORTED_MODULE_0_d3_time__["l" /* utcDay */].offset(week, (d.V - 1) * 7);
          d.y = week.getUTCFullYear();
          d.m = week.getUTCMonth();
          d.d = week.getUTCDate() + (d.w + 6) % 7;
        } else {
          week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
          week = day > 4 || day === 0 ? __WEBPACK_IMPORTED_MODULE_0_d3_time__["e" /* timeMonday */].ceil(week) : Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["e" /* timeMonday */])(week);
          week = __WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* timeDay */].offset(week, (d.V - 1) * 7);
          d.y = week.getFullYear();
          d.m = week.getMonth();
          d.d = week.getDate() + (d.w + 6) % 7;
        }
      } else if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
        day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
      }

      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }

      // Otherwise, all fields are in local time.
      return localDate(d);
    };
  }

  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
        n = specifier.length,
        m = string.length,
        c,
        parse;

    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads ? specifier.charAt(i++) : c];
        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }

    return j;
  }

  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }

  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }

  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }

  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }

  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }

  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }

  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }

  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }

  function formatQuarter(d) {
    return 1 + ~~(d.getMonth() / 3);
  }

  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }

  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }

  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }

  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }

  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }

  function formatUTCQuarter(d) {
    return 1 + ~~(d.getUTCMonth() / 3);
  }

  return {
    format: function(specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function() { return specifier; };
      return f;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", false);
      p.toString = function() { return specifier; };
      return p;
    },
    utcFormat: function(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function() { return specifier; };
      return f;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier += "", true);
      p.toString = function() { return specifier; };
      return p;
    }
  };
}

var pads = {"-": "", "_": " ", "0": "0"},
    numberRe = /^\s*\d+/, // note: ignores next directive
    percentRe = /^%/,
    requoteRe = /[\\^$*+?|[\]().{}]/g;

function pad(value, fill, width) {
  var sign = value < 0 ? "-" : "",
      string = (sign ? -value : value) + "",
      length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}

function requote(s) {
  return s.replace(requoteRe, "\\$&");
}

function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}

function formatLookup(names) {
  var map = {}, i = -1, n = names.length;
  while (++i < n) map[names[i].toLowerCase()] = i;
  return map;
}

function parseWeekdayNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}

function parseWeekdayNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.u = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberISO(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.V = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}

function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}

function parseYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}

function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}

function parseQuarter(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}

function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}

function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}

function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}

function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}

function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}

function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}

function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}

function parseMicroseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 6));
  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}

function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}

function parseUnixTimestamp(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = +n[0], i + n[0].length) : -1;
}

function parseUnixTimestampSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.s = +n[0], i + n[0].length) : -1;
}

function formatDayOfMonth(d, p) {
  return pad(d.getDate(), p, 2);
}

function formatHour24(d, p) {
  return pad(d.getHours(), p, 2);
}

function formatHour12(d, p) {
  return pad(d.getHours() % 12 || 12, p, 2);
}

function formatDayOfYear(d, p) {
  return pad(1 + __WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* timeDay */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeYear */])(d), d), p, 3);
}

function formatMilliseconds(d, p) {
  return pad(d.getMilliseconds(), p, 3);
}

function formatMicroseconds(d, p) {
  return formatMilliseconds(d, p) + "000";
}

function formatMonthNumber(d, p) {
  return pad(d.getMonth() + 1, p, 2);
}

function formatMinutes(d, p) {
  return pad(d.getMinutes(), p, 2);
}

function formatSeconds(d, p) {
  return pad(d.getSeconds(), p, 2);
}

function formatWeekdayNumberMonday(d) {
  var day = d.getDay();
  return day === 0 ? 7 : day;
}

function formatWeekNumberSunday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["h" /* timeSunday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeYear */])(d) - 1, d), p, 2);
}

function dISO(d) {
  var day = d.getDay();
  return (day >= 4 || day === 0) ? Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* timeThursday */])(d) : __WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* timeThursday */].ceil(d);
}

function formatWeekNumberISO(d, p) {
  d = dISO(d);
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* timeThursday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeYear */])(d), d) + (Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeYear */])(d).getDay() === 4), p, 2);
}

function formatWeekdayNumberSunday(d) {
  return d.getDay();
}

function formatWeekNumberMonday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["e" /* timeMonday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeYear */])(d) - 1, d), p, 2);
}

function formatYear(d, p) {
  return pad(d.getFullYear() % 100, p, 2);
}

function formatYearISO(d, p) {
  d = dISO(d);
  return pad(d.getFullYear() % 100, p, 2);
}

function formatFullYear(d, p) {
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatFullYearISO(d, p) {
  var day = d.getDay();
  d = (day >= 4 || day === 0) ? Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* timeThursday */])(d) : __WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* timeThursday */].ceil(d);
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+"))
      + pad(z / 60 | 0, "0", 2)
      + pad(z % 60, "0", 2);
}

function formatUTCDayOfMonth(d, p) {
  return pad(d.getUTCDate(), p, 2);
}

function formatUTCHour24(d, p) {
  return pad(d.getUTCHours(), p, 2);
}

function formatUTCHour12(d, p) {
  return pad(d.getUTCHours() % 12 || 12, p, 2);
}

function formatUTCDayOfYear(d, p) {
  return pad(1 + __WEBPACK_IMPORTED_MODULE_0_d3_time__["l" /* utcDay */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* utcYear */])(d), d), p, 3);
}

function formatUTCMilliseconds(d, p) {
  return pad(d.getUTCMilliseconds(), p, 3);
}

function formatUTCMicroseconds(d, p) {
  return formatUTCMilliseconds(d, p) + "000";
}

function formatUTCMonthNumber(d, p) {
  return pad(d.getUTCMonth() + 1, p, 2);
}

function formatUTCMinutes(d, p) {
  return pad(d.getUTCMinutes(), p, 2);
}

function formatUTCSeconds(d, p) {
  return pad(d.getUTCSeconds(), p, 2);
}

function formatUTCWeekdayNumberMonday(d) {
  var dow = d.getUTCDay();
  return dow === 0 ? 7 : dow;
}

function formatUTCWeekNumberSunday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["s" /* utcSunday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* utcYear */])(d) - 1, d), p, 2);
}

function UTCdISO(d) {
  var day = d.getUTCDay();
  return (day >= 4 || day === 0) ? Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["t" /* utcThursday */])(d) : __WEBPACK_IMPORTED_MODULE_0_d3_time__["t" /* utcThursday */].ceil(d);
}

function formatUTCWeekNumberISO(d, p) {
  d = UTCdISO(d);
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["t" /* utcThursday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* utcYear */])(d), d) + (Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* utcYear */])(d).getUTCDay() === 4), p, 2);
}

function formatUTCWeekdayNumberSunday(d) {
  return d.getUTCDay();
}

function formatUTCWeekNumberMonday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["p" /* utcMonday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* utcYear */])(d) - 1, d), p, 2);
}

function formatUTCYear(d, p) {
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCYearISO(d, p) {
  d = UTCdISO(d);
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCFullYear(d, p) {
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCFullYearISO(d, p) {
  var day = d.getUTCDay();
  d = (day >= 4 || day === 0) ? Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["t" /* utcThursday */])(d) : __WEBPACK_IMPORTED_MODULE_0_d3_time__["t" /* utcThursday */].ceil(d);
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCZone() {
  return "+0000";
}

function formatLiteralPercent() {
  return "%";
}

function formatUnixTimestamp(d) {
  return +d;
}

function formatUnixTimestampSeconds(d) {
  return Math.floor(+d / 1000);
}


/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isoSpecifier; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultLocale_js__ = __webpack_require__(354);


var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";

function formatIsoNative(date) {
  return date.toISOString();
}

var formatIso = Date.prototype.toISOString
    ? formatIsoNative
    : Object(__WEBPACK_IMPORTED_MODULE_0__defaultLocale_js__["b" /* utcFormat */])(isoSpecifier);

/* unused harmony default export */ var _unused_webpack_default_export = (formatIso);


/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant_js__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curve_linear_js__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__line_js__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__point_js__ = __webpack_require__(358);






/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x0 = __WEBPACK_IMPORTED_MODULE_4__point_js__["a" /* x */],
      x1 = null,
      y0 = Object(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(0),
      y1 = __WEBPACK_IMPORTED_MODULE_4__point_js__["b" /* y */],
      defined = Object(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(true),
      context = null,
      curve = __WEBPACK_IMPORTED_MODULE_2__curve_linear_js__["a" /* default */],
      output = null;

  function area(data) {
    var i,
        j,
        k,
        n = data.length,
        d,
        defined0 = false,
        buffer,
        x0z = new Array(n),
        y0z = new Array(n);

    if (context == null) output = curve(buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) {
          j = i;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k = i - 1; k >= j; --k) {
            output.point(x0z[k], y0z[k]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
      }
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  function arealine() {
    return Object(__WEBPACK_IMPORTED_MODULE_3__line_js__["a" /* default */])().defined(defined).curve(curve).context(context);
  }

  area.x = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(+_), x1 = null, area) : x0;
  };

  area.x0 = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(+_), area) : x0;
  };

  area.x1 = function(_) {
    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(+_), area) : x1;
  };

  area.y = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(+_), y1 = null, area) : y0;
  };

  area.y0 = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(+_), area) : y0;
  };

  area.y1 = function(_) {
    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(+_), area) : y1;
  };

  area.lineX0 =
  area.lineY0 = function() {
    return arealine().x(x0).y(y0);
  };

  area.lineY1 = function() {
    return arealine().x(x0).y(y1);
  };

  area.lineX1 = function() {
    return arealine().x(x1).y(y0);
  };

  area.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(!!_), area) : defined;
  };

  area.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
  };

  area.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
  };

  return area;
});


/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return curveRadialLinear; });
/* harmony export (immutable) */ __webpack_exports__["b"] = curveRadial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear_js__ = __webpack_require__(258);


var curveRadialLinear = curveRadial(__WEBPACK_IMPORTED_MODULE_0__linear_js__["a" /* default */]);

function Radial(curve) {
  this._curve = curve;
}

Radial.prototype = {
  areaStart: function() {
    this._curve.areaStart();
  },
  areaEnd: function() {
    this._curve.areaEnd();
  },
  lineStart: function() {
    this._curve.lineStart();
  },
  lineEnd: function() {
    this._curve.lineEnd();
  },
  point: function(a, r) {
    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
  }
};

function curveRadial(curve) {

  function radial(context) {
    return new Radial(curve(context));
  }

  radial._curve = curve;

  return radial;
}


/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = lineRadial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curve_radial_js__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__line_js__ = __webpack_require__(357);



function lineRadial(l) {
  var c = l.curve;

  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;

  l.curve = function(_) {
    return arguments.length ? c(Object(__WEBPACK_IMPORTED_MODULE_0__curve_radial_js__["b" /* default */])(_)) : c()._curve;
  };

  return l;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return lineRadial(Object(__WEBPACK_IMPORTED_MODULE_1__line_js__["a" /* default */])().curve(__WEBPACK_IMPORTED_MODULE_0__curve_radial_js__["a" /* curveRadialLinear */]));
});


/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x, y) {
  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
});


/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return slice; });
var slice = Array.prototype.slice;


/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math_js__ = __webpack_require__(198);


/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / __WEBPACK_IMPORTED_MODULE_0__math_js__["j" /* pi */]);
    context.moveTo(r, 0);
    context.arc(0, 0, r, 0, __WEBPACK_IMPORTED_MODULE_0__math_js__["m" /* tau */]);
  }
});


/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / 5) / 2;
    context.moveTo(-3 * r, -r);
    context.lineTo(-r, -r);
    context.lineTo(-r, -3 * r);
    context.lineTo(r, -3 * r);
    context.lineTo(r, -r);
    context.lineTo(3 * r, -r);
    context.lineTo(3 * r, r);
    context.lineTo(r, r);
    context.lineTo(r, 3 * r);
    context.lineTo(-r, 3 * r);
    context.lineTo(-r, r);
    context.lineTo(-3 * r, r);
    context.closePath();
  }
});


/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var tan30 = Math.sqrt(1 / 3),
    tan30_2 = tan30 * 2;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var y = Math.sqrt(size / tan30_2),
        x = y * tan30;
    context.moveTo(0, -y);
    context.lineTo(x, 0);
    context.lineTo(0, y);
    context.lineTo(-x, 0);
    context.closePath();
  }
});


/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math_js__ = __webpack_require__(198);


var ka = 0.89081309152928522810,
    kr = Math.sin(__WEBPACK_IMPORTED_MODULE_0__math_js__["j" /* pi */] / 10) / Math.sin(7 * __WEBPACK_IMPORTED_MODULE_0__math_js__["j" /* pi */] / 10),
    kx = Math.sin(__WEBPACK_IMPORTED_MODULE_0__math_js__["m" /* tau */] / 10) * kr,
    ky = -Math.cos(__WEBPACK_IMPORTED_MODULE_0__math_js__["m" /* tau */] / 10) * kr;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size * ka),
        x = kx * r,
        y = ky * r;
    context.moveTo(0, -r);
    context.lineTo(x, y);
    for (var i = 1; i < 5; ++i) {
      var a = __WEBPACK_IMPORTED_MODULE_0__math_js__["m" /* tau */] * i / 5,
          c = Math.cos(a),
          s = Math.sin(a);
      context.lineTo(s * r, -c * r);
      context.lineTo(c * x - s * y, s * x + c * y);
    }
    context.closePath();
  }
});


/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var w = Math.sqrt(size),
        x = -w / 2;
    context.rect(x, x, w, w);
  }
});


/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var sqrt3 = Math.sqrt(3);

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var y = -Math.sqrt(size / (sqrt3 * 3));
    context.moveTo(0, y * 2);
    context.lineTo(-sqrt3 * y, -y);
    context.lineTo(sqrt3 * y, -y);
    context.closePath();
  }
});


/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var c = -0.5,
    s = Math.sqrt(3) / 2,
    k = 1 / Math.sqrt(12),
    a = (k / 2 + 1) * 3;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / a),
        x0 = r / 2,
        y0 = r * k,
        x1 = x0,
        y1 = r * k + r,
        x2 = -x1,
        y2 = y1;
    context.moveTo(x0, y0);
    context.lineTo(x1, y1);
    context.lineTo(x2, y2);
    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
    context.closePath();
  }
});


/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CardinalClosed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop_js__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cardinal_js__ = __webpack_require__(261);



function CardinalClosed(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop_js__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop_js__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: Object(__WEBPACK_IMPORTED_MODULE_1__cardinal_js__["c" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["b"] = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalClosed(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CardinalOpen;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinal_js__ = __webpack_require__(261);


function CardinalOpen(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: Object(__WEBPACK_IMPORTED_MODULE_0__cardinal_js__["c" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["b"] = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalOpen(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none_js__ = __webpack_require__(200);


/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  var peaks = series.map(peak);
  return Object(__WEBPACK_IMPORTED_MODULE_0__none_js__["a" /* default */])(series).sort(function(a, b) { return peaks[a] - peaks[b]; });
});

function peak(series) {
  var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
  while (++i < n) if ((vi = +series[i][1]) > vj) vj = vi, j = i;
  return j;
}


/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ascending__ = __webpack_require__(2208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__area__ = __webpack_require__(2209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constant__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__contains__ = __webpack_require__(2210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__noop__ = __webpack_require__(2211);








var cases = [
  [],
  [[[1.0, 1.5], [0.5, 1.0]]],
  [[[1.5, 1.0], [1.0, 1.5]]],
  [[[1.5, 1.0], [0.5, 1.0]]],
  [[[1.0, 0.5], [1.5, 1.0]]],
  [[[1.0, 1.5], [0.5, 1.0]], [[1.0, 0.5], [1.5, 1.0]]],
  [[[1.0, 0.5], [1.0, 1.5]]],
  [[[1.0, 0.5], [0.5, 1.0]]],
  [[[0.5, 1.0], [1.0, 0.5]]],
  [[[1.0, 1.5], [1.0, 0.5]]],
  [[[0.5, 1.0], [1.0, 0.5]], [[1.5, 1.0], [1.0, 1.5]]],
  [[[1.5, 1.0], [1.0, 0.5]]],
  [[[0.5, 1.0], [1.5, 1.0]]],
  [[[1.0, 1.5], [1.5, 1.0]]],
  [[[0.5, 1.0], [1.0, 1.5]]],
  []
];

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var dx = 1,
      dy = 1,
      threshold = __WEBPACK_IMPORTED_MODULE_0_d3_array__["k" /* thresholdSturges */],
      smooth = smoothLinear;

  function contours(values) {
    var tz = threshold(values);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      var domain = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["d" /* extent */])(values), start = domain[0], stop = domain[1];
      tz = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["m" /* tickStep */])(start, stop, tz);
      tz = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["i" /* range */])(Math.floor(start / tz) * tz, Math.floor(stop / tz) * tz, tz);
    } else {
      tz = tz.slice().sort(__WEBPACK_IMPORTED_MODULE_2__ascending__["a" /* default */]);
    }

    return tz.map(function(value) {
      return contour(values, value);
    });
  }

  // Accumulate, smooth contour rings, assign holes to exterior rings.
  // Based on https://github.com/mbostock/shapefile/blob/v0.6.2/shp/polygon.js
  function contour(values, value) {
    var polygons = [],
        holes = [];

    isorings(values, value, function(ring) {
      smooth(ring, values, value);
      if (Object(__WEBPACK_IMPORTED_MODULE_3__area__["a" /* default */])(ring) > 0) polygons.push([ring]);
      else holes.push(ring);
    });

    holes.forEach(function(hole) {
      for (var i = 0, n = polygons.length, polygon; i < n; ++i) {
        if (Object(__WEBPACK_IMPORTED_MODULE_5__contains__["a" /* default */])((polygon = polygons[i])[0], hole) !== -1) {
          polygon.push(hole);
          return;
        }
      }
    });

    return {
      type: "MultiPolygon",
      value: value,
      coordinates: polygons
    };
  }

  // Marching squares with isolines stitched into rings.
  // Based on https://github.com/topojson/topojson-client/blob/v3.0.0/src/stitch.js
  function isorings(values, value, callback) {
    var fragmentByStart = new Array,
        fragmentByEnd = new Array,
        x, y, t0, t1, t2, t3;

    // Special case for the first row (y = -1, t2 = t3 = 0).
    x = y = -1;
    t1 = values[0] >= value;
    cases[t1 << 1].forEach(stitch);
    while (++x < dx - 1) {
      t0 = t1, t1 = values[x + 1] >= value;
      cases[t0 | t1 << 1].forEach(stitch);
    }
    cases[t1 << 0].forEach(stitch);

    // General case for the intermediate rows.
    while (++y < dy - 1) {
      x = -1;
      t1 = values[y * dx + dx] >= value;
      t2 = values[y * dx] >= value;
      cases[t1 << 1 | t2 << 2].forEach(stitch);
      while (++x < dx - 1) {
        t0 = t1, t1 = values[y * dx + dx + x + 1] >= value;
        t3 = t2, t2 = values[y * dx + x + 1] >= value;
        cases[t0 | t1 << 1 | t2 << 2 | t3 << 3].forEach(stitch);
      }
      cases[t1 | t2 << 3].forEach(stitch);
    }

    // Special case for the last row (y = dy - 1, t0 = t1 = 0).
    x = -1;
    t2 = values[y * dx] >= value;
    cases[t2 << 2].forEach(stitch);
    while (++x < dx - 1) {
      t3 = t2, t2 = values[y * dx + x + 1] >= value;
      cases[t2 << 2 | t3 << 3].forEach(stitch);
    }
    cases[t2 << 3].forEach(stitch);

    function stitch(line) {
      var start = [line[0][0] + x, line[0][1] + y],
          end = [line[1][0] + x, line[1][1] + y],
          startIndex = index(start),
          endIndex = index(end),
          f, g;
      if (f = fragmentByEnd[startIndex]) {
        if (g = fragmentByStart[endIndex]) {
          delete fragmentByEnd[f.end];
          delete fragmentByStart[g.start];
          if (f === g) {
            f.ring.push(end);
            callback(f.ring);
          } else {
            fragmentByStart[f.start] = fragmentByEnd[g.end] = {start: f.start, end: g.end, ring: f.ring.concat(g.ring)};
          }
        } else {
          delete fragmentByEnd[f.end];
          f.ring.push(end);
          fragmentByEnd[f.end = endIndex] = f;
        }
      } else if (f = fragmentByStart[endIndex]) {
        if (g = fragmentByEnd[startIndex]) {
          delete fragmentByStart[f.start];
          delete fragmentByEnd[g.end];
          if (f === g) {
            f.ring.push(end);
            callback(f.ring);
          } else {
            fragmentByStart[g.start] = fragmentByEnd[f.end] = {start: g.start, end: f.end, ring: g.ring.concat(f.ring)};
          }
        } else {
          delete fragmentByStart[f.start];
          f.ring.unshift(start);
          fragmentByStart[f.start = startIndex] = f;
        }
      } else {
        fragmentByStart[startIndex] = fragmentByEnd[endIndex] = {start: startIndex, end: endIndex, ring: [start, end]};
      }
    }
  }

  function index(point) {
    return point[0] * 2 + point[1] * (dx + 1) * 4;
  }

  function smoothLinear(ring, values, value) {
    ring.forEach(function(point) {
      var x = point[0],
          y = point[1],
          xt = x | 0,
          yt = y | 0,
          v0,
          v1 = values[yt * dx + xt];
      if (x > 0 && x < dx && xt === x) {
        v0 = values[yt * dx + xt - 1];
        point[0] = x + (value - v0) / (v1 - v0) - 0.5;
      }
      if (y > 0 && y < dy && yt === y) {
        v0 = values[(yt - 1) * dx + xt];
        point[1] = y + (value - v0) / (v1 - v0) - 0.5;
      }
    });
  }

  contours.contour = contour;

  contours.size = function(_) {
    if (!arguments.length) return [dx, dy];
    var _0 = Math.ceil(_[0]), _1 = Math.ceil(_[1]);
    if (!(_0 > 0) || !(_1 > 0)) throw new Error("invalid size");
    return dx = _0, dy = _1, contours;
  };

  contours.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? Object(__WEBPACK_IMPORTED_MODULE_4__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__array__["a" /* slice */].call(_)) : Object(__WEBPACK_IMPORTED_MODULE_4__constant__["a" /* default */])(_), contours) : threshold;
  };

  contours.smooth = function(_) {
    return arguments.length ? (smooth = _ ? smoothLinear : __WEBPACK_IMPORTED_MODULE_6__noop__["a" /* default */], contours) : smooth === smoothLinear;
  };

  return contours;
});


/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return slice; });
var array = Array.prototype;

var slice = array.slice;


/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return areaRingSum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return areaStream; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder_js__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__noop_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stream_js__ = __webpack_require__(133);





var areaRingSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder_js__["a" /* default */])();

var areaSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder_js__["a" /* default */])(),
    lambda00,
    phi00,
    lambda0,
    cosPhi0,
    sinPhi0;

var areaStream = {
  point: __WEBPACK_IMPORTED_MODULE_2__noop_js__["a" /* default */],
  lineStart: __WEBPACK_IMPORTED_MODULE_2__noop_js__["a" /* default */],
  lineEnd: __WEBPACK_IMPORTED_MODULE_2__noop_js__["a" /* default */],
  polygonStart: function() {
    areaRingSum.reset();
    areaStream.lineStart = areaRingStart;
    areaStream.lineEnd = areaRingEnd;
  },
  polygonEnd: function() {
    var areaRing = +areaRingSum;
    areaSum.add(areaRing < 0 ? __WEBPACK_IMPORTED_MODULE_1__math_js__["w" /* tau */] + areaRing : areaRing);
    this.lineStart = this.lineEnd = this.point = __WEBPACK_IMPORTED_MODULE_2__noop_js__["a" /* default */];
  },
  sphere: function() {
    areaSum.add(__WEBPACK_IMPORTED_MODULE_1__math_js__["w" /* tau */]);
  }
};

function areaRingStart() {
  areaStream.point = areaPointFirst;
}

function areaRingEnd() {
  areaPoint(lambda00, phi00);
}

function areaPointFirst(lambda, phi) {
  areaStream.point = areaPoint;
  lambda00 = lambda, phi00 = phi;
  lambda *= __WEBPACK_IMPORTED_MODULE_1__math_js__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_1__math_js__["r" /* radians */];
  lambda0 = lambda, cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["g" /* cos */])(phi = phi / 2 + __WEBPACK_IMPORTED_MODULE_1__math_js__["q" /* quarterPi */]), sinPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["t" /* sin */])(phi);
}

function areaPoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_1__math_js__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_1__math_js__["r" /* radians */];
  phi = phi / 2 + __WEBPACK_IMPORTED_MODULE_1__math_js__["q" /* quarterPi */]; // half the angular distance from south pole

  // Spherical excess E for a spherical triangle with vertices: south pole,
  // previous point, current point.  Uses a formula derived from Cagnoli’s
  // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
  var dLambda = lambda - lambda0,
      sdLambda = dLambda >= 0 ? 1 : -1,
      adLambda = sdLambda * dLambda,
      cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["g" /* cos */])(phi),
      sinPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["t" /* sin */])(phi),
      k = sinPhi0 * sinPhi,
      u = cosPhi0 * cosPhi + k * Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["g" /* cos */])(adLambda),
      v = k * sdLambda * Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["t" /* sin */])(adLambda);
  areaRingSum.add(Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["e" /* atan2 */])(v, u));

  // Advance the previous points.
  lambda0 = lambda, cosPhi0 = cosPhi, sinPhi0 = sinPhi;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(object) {
  areaSum.reset();
  Object(__WEBPACK_IMPORTED_MODULE_3__stream_js__["a" /* default */])(object, areaStream);
  return areaSum * 2;
});


/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = circleStream;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cartesian_js__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant_js__ = __webpack_require__(2217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rotation_js__ = __webpack_require__(262);





// Generates a circle centered at [0°, 0°], with a given radius and precision.
function circleStream(stream, radius, delta, direction, t0, t1) {
  if (!delta) return;
  var cosRadius = Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["g" /* cos */])(radius),
      sinRadius = Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["t" /* sin */])(radius),
      step = direction * delta;
  if (t0 == null) {
    t0 = radius + direction * __WEBPACK_IMPORTED_MODULE_2__math_js__["w" /* tau */];
    t1 = radius - step / 2;
  } else {
    t0 = circleRadius(cosRadius, t0);
    t1 = circleRadius(cosRadius, t1);
    if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * __WEBPACK_IMPORTED_MODULE_2__math_js__["w" /* tau */];
  }
  for (var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step) {
    point = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian_js__["g" /* spherical */])([cosRadius, -sinRadius * Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["g" /* cos */])(t), -sinRadius * Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["t" /* sin */])(t)]);
    stream.point(point[0], point[1]);
  }
}

// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
function circleRadius(cosRadius, point) {
  point = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian_js__["a" /* cartesian */])(point), point[0] -= cosRadius;
  Object(__WEBPACK_IMPORTED_MODULE_0__cartesian_js__["e" /* cartesianNormalizeInPlace */])(point);
  var radius = Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["b" /* acos */])(-point[1]);
  return ((-point[2] < 0 ? -radius : radius) + __WEBPACK_IMPORTED_MODULE_2__math_js__["w" /* tau */] - __WEBPACK_IMPORTED_MODULE_2__math_js__["i" /* epsilon */]) % __WEBPACK_IMPORTED_MODULE_2__math_js__["w" /* tau */];
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var center = Object(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])([0, 0]),
      radius = Object(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(90),
      precision = Object(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(6),
      ring,
      rotate,
      stream = {point: point};

  function point(x, y) {
    ring.push(x = rotate(x, y));
    x[0] *= __WEBPACK_IMPORTED_MODULE_2__math_js__["h" /* degrees */], x[1] *= __WEBPACK_IMPORTED_MODULE_2__math_js__["h" /* degrees */];
  }

  function circle() {
    var c = center.apply(this, arguments),
        r = radius.apply(this, arguments) * __WEBPACK_IMPORTED_MODULE_2__math_js__["r" /* radians */],
        p = precision.apply(this, arguments) * __WEBPACK_IMPORTED_MODULE_2__math_js__["r" /* radians */];
    ring = [];
    rotate = Object(__WEBPACK_IMPORTED_MODULE_3__rotation_js__["b" /* rotateRadians */])(-c[0] * __WEBPACK_IMPORTED_MODULE_2__math_js__["r" /* radians */], -c[1] * __WEBPACK_IMPORTED_MODULE_2__math_js__["r" /* radians */], 0).invert;
    circleStream(stream, r, p, 1);
    c = {type: "Polygon", coordinates: [ring]};
    ring = rotate = null;
    return c;
  }

  circle.center = function(_) {
    return arguments.length ? (center = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])([+_[0], +_[1]]), circle) : center;
  };

  circle.radius = function(_) {
    return arguments.length ? (radius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(+_), circle) : radius;
  };

  circle.precision = function(_) {
    return arguments.length ? (precision = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(+_), circle) : precision;
  };

  return circle;
});


/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {

  function compose(x, y) {
    return x = a(x, y), b(x[0], x[1]);
  }

  if (a.invert && b.invert) compose.invert = function(x, y) {
    return x = b.invert(x, y), x && a.invert(x[0], x[1]);
  };

  return compose;
});


/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_js__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math_js__ = __webpack_require__(36);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__index_js__["a" /* default */])(
  function() { return true; },
  clipAntimeridianLine,
  clipAntimeridianInterpolate,
  [-__WEBPACK_IMPORTED_MODULE_1__math_js__["o" /* pi */], -__WEBPACK_IMPORTED_MODULE_1__math_js__["l" /* halfPi */]]
));

// Takes a line and cuts into visible segments. Return values: 0 - there were
// intersections or the line was empty; 1 - no intersections; 2 - there were
// intersections, and the first and last segments should be rejoined.
function clipAntimeridianLine(stream) {
  var lambda0 = NaN,
      phi0 = NaN,
      sign0 = NaN,
      clean; // no intersections

  return {
    lineStart: function() {
      stream.lineStart();
      clean = 1;
    },
    point: function(lambda1, phi1) {
      var sign1 = lambda1 > 0 ? __WEBPACK_IMPORTED_MODULE_1__math_js__["o" /* pi */] : -__WEBPACK_IMPORTED_MODULE_1__math_js__["o" /* pi */],
          delta = Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["a" /* abs */])(lambda1 - lambda0);
      if (Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["a" /* abs */])(delta - __WEBPACK_IMPORTED_MODULE_1__math_js__["o" /* pi */]) < __WEBPACK_IMPORTED_MODULE_1__math_js__["i" /* epsilon */]) { // line crosses a pole
        stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? __WEBPACK_IMPORTED_MODULE_1__math_js__["l" /* halfPi */] : -__WEBPACK_IMPORTED_MODULE_1__math_js__["l" /* halfPi */]);
        stream.point(sign0, phi0);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi0);
        stream.point(lambda1, phi0);
        clean = 0;
      } else if (sign0 !== sign1 && delta >= __WEBPACK_IMPORTED_MODULE_1__math_js__["o" /* pi */]) { // line crosses antimeridian
        if (Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["a" /* abs */])(lambda0 - sign0) < __WEBPACK_IMPORTED_MODULE_1__math_js__["i" /* epsilon */]) lambda0 -= sign0 * __WEBPACK_IMPORTED_MODULE_1__math_js__["i" /* epsilon */]; // handle degeneracies
        if (Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["a" /* abs */])(lambda1 - sign1) < __WEBPACK_IMPORTED_MODULE_1__math_js__["i" /* epsilon */]) lambda1 -= sign1 * __WEBPACK_IMPORTED_MODULE_1__math_js__["i" /* epsilon */];
        phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
        stream.point(sign0, phi0);
        stream.lineEnd();
        stream.lineStart();
        stream.point(sign1, phi0);
        clean = 0;
      }
      stream.point(lambda0 = lambda1, phi0 = phi1);
      sign0 = sign1;
    },
    lineEnd: function() {
      stream.lineEnd();
      lambda0 = phi0 = NaN;
    },
    clean: function() {
      return 2 - clean; // if intersections, rejoin first and last segments
    }
  };
}

function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
  var cosPhi0,
      cosPhi1,
      sinLambda0Lambda1 = Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["t" /* sin */])(lambda0 - lambda1);
  return Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["a" /* abs */])(sinLambda0Lambda1) > __WEBPACK_IMPORTED_MODULE_1__math_js__["i" /* epsilon */]
      ? Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["d" /* atan */])((Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["t" /* sin */])(phi0) * (cosPhi1 = Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["g" /* cos */])(phi1)) * Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["t" /* sin */])(lambda1)
          - Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["t" /* sin */])(phi1) * (cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["g" /* cos */])(phi0)) * Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["t" /* sin */])(lambda0))
          / (cosPhi0 * cosPhi1 * sinLambda0Lambda1))
      : (phi0 + phi1) / 2;
}

function clipAntimeridianInterpolate(from, to, direction, stream) {
  var phi;
  if (from == null) {
    phi = direction * __WEBPACK_IMPORTED_MODULE_1__math_js__["l" /* halfPi */];
    stream.point(-__WEBPACK_IMPORTED_MODULE_1__math_js__["o" /* pi */], phi);
    stream.point(0, phi);
    stream.point(__WEBPACK_IMPORTED_MODULE_1__math_js__["o" /* pi */], phi);
    stream.point(__WEBPACK_IMPORTED_MODULE_1__math_js__["o" /* pi */], 0);
    stream.point(__WEBPACK_IMPORTED_MODULE_1__math_js__["o" /* pi */], -phi);
    stream.point(0, -phi);
    stream.point(-__WEBPACK_IMPORTED_MODULE_1__math_js__["o" /* pi */], -phi);
    stream.point(-__WEBPACK_IMPORTED_MODULE_1__math_js__["o" /* pi */], 0);
    stream.point(-__WEBPACK_IMPORTED_MODULE_1__math_js__["o" /* pi */], phi);
  } else if (Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["a" /* abs */])(from[0] - to[0]) > __WEBPACK_IMPORTED_MODULE_1__math_js__["i" /* epsilon */]) {
    var lambda = from[0] < to[0] ? __WEBPACK_IMPORTED_MODULE_1__math_js__["o" /* pi */] : -__WEBPACK_IMPORTED_MODULE_1__math_js__["o" /* pi */];
    phi = direction * lambda / 2;
    stream.point(-lambda, phi);
    stream.point(0, phi);
    stream.point(lambda, phi);
  } else {
    stream.point(to[0], to[1]);
  }
}


/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__buffer_js__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rejoin_js__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__polygonContains_js__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_array__ = __webpack_require__(70);






/* harmony default export */ __webpack_exports__["a"] = (function(pointVisible, clipLine, interpolate, start) {
  return function(sink) {
    var line = clipLine(sink),
        ringBuffer = Object(__WEBPACK_IMPORTED_MODULE_0__buffer_js__["a" /* default */])(),
        ringSink = clipLine(ringBuffer),
        polygonStarted = false,
        polygon,
        segments,
        ring;

    var clip = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() {
        clip.point = pointRing;
        clip.lineStart = ringStart;
        clip.lineEnd = ringEnd;
        segments = [];
        polygon = [];
      },
      polygonEnd: function() {
        clip.point = point;
        clip.lineStart = lineStart;
        clip.lineEnd = lineEnd;
        segments = Object(__WEBPACK_IMPORTED_MODULE_4_d3_array__["f" /* merge */])(segments);
        var startInside = Object(__WEBPACK_IMPORTED_MODULE_3__polygonContains_js__["a" /* default */])(polygon, start);
        if (segments.length) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          Object(__WEBPACK_IMPORTED_MODULE_1__rejoin_js__["a" /* default */])(segments, compareIntersection, startInside, interpolate, sink);
        } else if (startInside) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          interpolate(null, null, 1, sink);
          sink.lineEnd();
        }
        if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
        segments = polygon = null;
      },
      sphere: function() {
        sink.polygonStart();
        sink.lineStart();
        interpolate(null, null, 1, sink);
        sink.lineEnd();
        sink.polygonEnd();
      }
    };

    function point(lambda, phi) {
      if (pointVisible(lambda, phi)) sink.point(lambda, phi);
    }

    function pointLine(lambda, phi) {
      line.point(lambda, phi);
    }

    function lineStart() {
      clip.point = pointLine;
      line.lineStart();
    }

    function lineEnd() {
      clip.point = point;
      line.lineEnd();
    }

    function pointRing(lambda, phi) {
      ring.push([lambda, phi]);
      ringSink.point(lambda, phi);
    }

    function ringStart() {
      ringSink.lineStart();
      ring = [];
    }

    function ringEnd() {
      pointRing(ring[0][0], ring[0][1]);
      ringSink.lineEnd();

      var clean = ringSink.clean(),
          ringSegments = ringBuffer.result(),
          i, n = ringSegments.length, m,
          segment,
          point;

      ring.pop();
      polygon.push(ring);
      ring = null;

      if (!n) return;

      // No intersections.
      if (clean & 1) {
        segment = ringSegments[0];
        if ((m = segment.length - 1) > 0) {
          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          for (i = 0; i < m; ++i) sink.point((point = segment[i])[0], point[1]);
          sink.lineEnd();
        }
        return;
      }

      // Rejoin connected segments.
      // TODO reuse ringBuffer.rejoin()?
      if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));

      segments.push(ringSegments.filter(validSegment));
    }

    return clip;
  };
});

function validSegment(segment) {
  return segment.length > 1;
}

// Intersections are sorted along the clip edge. For both antimeridian cutting
// and circle clipping, the same comparison is used.
function compareIntersection(a, b) {
  return ((a = a.x)[0] < 0 ? a[1] - __WEBPACK_IMPORTED_MODULE_2__math_js__["l" /* halfPi */] - __WEBPACK_IMPORTED_MODULE_2__math_js__["i" /* epsilon */] : __WEBPACK_IMPORTED_MODULE_2__math_js__["l" /* halfPi */] - a[1])
       - ((b = b.x)[0] < 0 ? b[1] - __WEBPACK_IMPORTED_MODULE_2__math_js__["l" /* halfPi */] - __WEBPACK_IMPORTED_MODULE_2__math_js__["i" /* epsilon */] : __WEBPACK_IMPORTED_MODULE_2__math_js__["l" /* halfPi */] - b[1]);
}


/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop_js__ = __webpack_require__(113);


/* harmony default export */ __webpack_exports__["a"] = (function() {
  var lines = [],
      line;
  return {
    point: function(x, y, m) {
      line.push([x, y, m]);
    },
    lineStart: function() {
      lines.push(line = []);
    },
    lineEnd: __WEBPACK_IMPORTED_MODULE_0__noop_js__["a" /* default */],
    rejoin: function() {
      if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
    },
    result: function() {
      var result = lines;
      lines = [];
      line = null;
      return result;
    }
  };
});


/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pointEqual_js__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math_js__ = __webpack_require__(36);



function Intersection(point, points, other, entry) {
  this.x = point;
  this.z = points;
  this.o = other; // another intersection
  this.e = entry; // is an entry?
  this.v = false; // visited
  this.n = this.p = null; // next & previous
}

// A generalized polygon clipping algorithm: given a polygon that has been cut
// into its visible line segments, and rejoins the segments by interpolating
// along the clip edge.
/* harmony default export */ __webpack_exports__["a"] = (function(segments, compareIntersection, startInside, interpolate, stream) {
  var subject = [],
      clip = [],
      i,
      n;

  segments.forEach(function(segment) {
    if ((n = segment.length - 1) <= 0) return;
    var n, p0 = segment[0], p1 = segment[n], x;

    if (Object(__WEBPACK_IMPORTED_MODULE_0__pointEqual_js__["a" /* default */])(p0, p1)) {
      if (!p0[2] && !p1[2]) {
        stream.lineStart();
        for (i = 0; i < n; ++i) stream.point((p0 = segment[i])[0], p0[1]);
        stream.lineEnd();
        return;
      }
      // handle degenerate cases by moving the point
      p1[0] += 2 * __WEBPACK_IMPORTED_MODULE_1__math_js__["i" /* epsilon */];
    }

    subject.push(x = new Intersection(p0, segment, null, true));
    clip.push(x.o = new Intersection(p0, null, x, false));
    subject.push(x = new Intersection(p1, segment, null, false));
    clip.push(x.o = new Intersection(p1, null, x, true));
  });

  if (!subject.length) return;

  clip.sort(compareIntersection);
  link(subject);
  link(clip);

  for (i = 0, n = clip.length; i < n; ++i) {
    clip[i].e = startInside = !startInside;
  }

  var start = subject[0],
      points,
      point;

  while (1) {
    // Find first unvisited intersection.
    var current = start,
        isSubject = true;
    while (current.v) if ((current = current.n) === start) return;
    points = current.z;
    stream.lineStart();
    do {
      current.v = current.o.v = true;
      if (current.e) {
        if (isSubject) {
          for (i = 0, n = points.length; i < n; ++i) stream.point((point = points[i])[0], point[1]);
        } else {
          interpolate(current.x, current.n.x, 1, stream);
        }
        current = current.n;
      } else {
        if (isSubject) {
          points = current.p.z;
          for (i = points.length - 1; i >= 0; --i) stream.point((point = points[i])[0], point[1]);
        } else {
          interpolate(current.x, current.p.x, -1, stream);
        }
        current = current.p;
      }
      current = current.o;
      points = current.z;
      isSubject = !isSubject;
    } while (!current.v);
    stream.lineEnd();
  }
});

function link(array) {
  if (!(n = array.length)) return;
  var n,
      i = 0,
      a = array[0],
      b;
  while (++i < n) {
    a.n = b = array[i];
    b.p = a;
    a = b;
  }
  a.n = b = array[0];
  b.p = a;
}


/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math_js__ = __webpack_require__(36);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["a" /* abs */])(a[0] - b[0]) < __WEBPACK_IMPORTED_MODULE_0__math_js__["i" /* epsilon */] && Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["a" /* abs */])(a[1] - b[1]) < __WEBPACK_IMPORTED_MODULE_0__math_js__["i" /* epsilon */];
});


/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder_js__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cartesian_js__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math_js__ = __webpack_require__(36);




var sum = Object(__WEBPACK_IMPORTED_MODULE_0__adder_js__["a" /* default */])();

function longitude(point) {
  if (Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["a" /* abs */])(point[0]) <= __WEBPACK_IMPORTED_MODULE_2__math_js__["o" /* pi */])
    return point[0];
  else
    return Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["s" /* sign */])(point[0]) * ((Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["a" /* abs */])(point[0]) + __WEBPACK_IMPORTED_MODULE_2__math_js__["o" /* pi */]) % __WEBPACK_IMPORTED_MODULE_2__math_js__["w" /* tau */] - __WEBPACK_IMPORTED_MODULE_2__math_js__["o" /* pi */]);
}

/* harmony default export */ __webpack_exports__["a"] = (function(polygon, point) {
  var lambda = longitude(point),
      phi = point[1],
      sinPhi = Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["t" /* sin */])(phi),
      normal = [Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["t" /* sin */])(lambda), -Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["g" /* cos */])(lambda), 0],
      angle = 0,
      winding = 0;

  sum.reset();

  if (sinPhi === 1) phi = __WEBPACK_IMPORTED_MODULE_2__math_js__["l" /* halfPi */] + __WEBPACK_IMPORTED_MODULE_2__math_js__["i" /* epsilon */];
  else if (sinPhi === -1) phi = -__WEBPACK_IMPORTED_MODULE_2__math_js__["l" /* halfPi */] - __WEBPACK_IMPORTED_MODULE_2__math_js__["i" /* epsilon */];

  for (var i = 0, n = polygon.length; i < n; ++i) {
    if (!(m = (ring = polygon[i]).length)) continue;
    var ring,
        m,
        point0 = ring[m - 1],
        lambda0 = longitude(point0),
        phi0 = point0[1] / 2 + __WEBPACK_IMPORTED_MODULE_2__math_js__["q" /* quarterPi */],
        sinPhi0 = Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["t" /* sin */])(phi0),
        cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["g" /* cos */])(phi0);

    for (var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1) {
      var point1 = ring[j],
          lambda1 = longitude(point1),
          phi1 = point1[1] / 2 + __WEBPACK_IMPORTED_MODULE_2__math_js__["q" /* quarterPi */],
          sinPhi1 = Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["t" /* sin */])(phi1),
          cosPhi1 = Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["g" /* cos */])(phi1),
          delta = lambda1 - lambda0,
          sign = delta >= 0 ? 1 : -1,
          absDelta = sign * delta,
          antimeridian = absDelta > __WEBPACK_IMPORTED_MODULE_2__math_js__["o" /* pi */],
          k = sinPhi0 * sinPhi1;

      sum.add(Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["e" /* atan2 */])(k * sign * Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["t" /* sin */])(absDelta), cosPhi0 * cosPhi1 + k * Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["g" /* cos */])(absDelta)));
      angle += antimeridian ? delta + sign * __WEBPACK_IMPORTED_MODULE_2__math_js__["w" /* tau */] : delta;

      // Are the longitudes either side of the point’s meridian (lambda),
      // and are the latitudes smaller than the parallel (phi)?
      if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
        var arc = Object(__WEBPACK_IMPORTED_MODULE_1__cartesian_js__["c" /* cartesianCross */])(Object(__WEBPACK_IMPORTED_MODULE_1__cartesian_js__["a" /* cartesian */])(point0), Object(__WEBPACK_IMPORTED_MODULE_1__cartesian_js__["a" /* cartesian */])(point1));
        Object(__WEBPACK_IMPORTED_MODULE_1__cartesian_js__["e" /* cartesianNormalizeInPlace */])(arc);
        var intersection = Object(__WEBPACK_IMPORTED_MODULE_1__cartesian_js__["c" /* cartesianCross */])(normal, arc);
        Object(__WEBPACK_IMPORTED_MODULE_1__cartesian_js__["e" /* cartesianNormalizeInPlace */])(intersection);
        var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["c" /* asin */])(intersection[2]);
        if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) {
          winding += antimeridian ^ delta >= 0 ? 1 : -1;
        }
      }
    }
  }

  // First, determine whether the South pole is inside or outside:
  //
  // It is inside if:
  // * the polygon winds around it in a clockwise direction.
  // * the polygon does not (cumulatively) wind around it, but has a negative
  //   (counter-clockwise) area.
  //
  // Second, count the (signed) number of times a segment crosses a lambda
  // from the point to the South pole.  If it is zero, then the point is the
  // same side as the South pole.

  return (angle < -__WEBPACK_IMPORTED_MODULE_2__math_js__["i" /* epsilon */] || angle < __WEBPACK_IMPORTED_MODULE_2__math_js__["i" /* epsilon */] && sum < -__WEBPACK_IMPORTED_MODULE_2__math_js__["i" /* epsilon */]) ^ (winding & 1);
});


/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cartesian_js__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__circle_js__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pointEqual_js__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index_js__ = __webpack_require__(607);






/* harmony default export */ __webpack_exports__["a"] = (function(radius) {
  var cr = Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["g" /* cos */])(radius),
      delta = 6 * __WEBPACK_IMPORTED_MODULE_2__math_js__["r" /* radians */],
      smallRadius = cr > 0,
      notHemisphere = Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["a" /* abs */])(cr) > __WEBPACK_IMPORTED_MODULE_2__math_js__["i" /* epsilon */]; // TODO optimise for this common case

  function interpolate(from, to, direction, stream) {
    Object(__WEBPACK_IMPORTED_MODULE_1__circle_js__["a" /* circleStream */])(stream, radius, delta, direction, from, to);
  }

  function visible(lambda, phi) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["g" /* cos */])(lambda) * Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["g" /* cos */])(phi) > cr;
  }

  // Takes a line and cuts into visible segments. Return values used for polygon
  // clipping: 0 - there were intersections or the line was empty; 1 - no
  // intersections 2 - there were intersections, and the first and last segments
  // should be rejoined.
  function clipLine(stream) {
    var point0, // previous point
        c0, // code for previous point
        v0, // visibility of previous point
        v00, // visibility of first point
        clean; // no intersections
    return {
      lineStart: function() {
        v00 = v0 = false;
        clean = 1;
      },
      point: function(lambda, phi) {
        var point1 = [lambda, phi],
            point2,
            v = visible(lambda, phi),
            c = smallRadius
              ? v ? 0 : code(lambda, phi)
              : v ? code(lambda + (lambda < 0 ? __WEBPACK_IMPORTED_MODULE_2__math_js__["o" /* pi */] : -__WEBPACK_IMPORTED_MODULE_2__math_js__["o" /* pi */]), phi) : 0;
        if (!point0 && (v00 = v0 = v)) stream.lineStart();
        if (v !== v0) {
          point2 = intersect(point0, point1);
          if (!point2 || Object(__WEBPACK_IMPORTED_MODULE_3__pointEqual_js__["a" /* default */])(point0, point2) || Object(__WEBPACK_IMPORTED_MODULE_3__pointEqual_js__["a" /* default */])(point1, point2))
            point1[2] = 1;
        }
        if (v !== v0) {
          clean = 0;
          if (v) {
            // outside going in
            stream.lineStart();
            point2 = intersect(point1, point0);
            stream.point(point2[0], point2[1]);
          } else {
            // inside going out
            point2 = intersect(point0, point1);
            stream.point(point2[0], point2[1], 2);
            stream.lineEnd();
          }
          point0 = point2;
        } else if (notHemisphere && point0 && smallRadius ^ v) {
          var t;
          // If the codes for two points are different, or are both zero,
          // and there this segment intersects with the small circle.
          if (!(c & c0) && (t = intersect(point1, point0, true))) {
            clean = 0;
            if (smallRadius) {
              stream.lineStart();
              stream.point(t[0][0], t[0][1]);
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
            } else {
              stream.point(t[1][0], t[1][1]);
              stream.lineEnd();
              stream.lineStart();
              stream.point(t[0][0], t[0][1], 3);
            }
          }
        }
        if (v && (!point0 || !Object(__WEBPACK_IMPORTED_MODULE_3__pointEqual_js__["a" /* default */])(point0, point1))) {
          stream.point(point1[0], point1[1]);
        }
        point0 = point1, v0 = v, c0 = c;
      },
      lineEnd: function() {
        if (v0) stream.lineEnd();
        point0 = null;
      },
      // Rejoin first and last segments if there were intersections and the first
      // and last points were visible.
      clean: function() {
        return clean | ((v00 && v0) << 1);
      }
    };
  }

  // Intersects the great circle between a and b with the clip circle.
  function intersect(a, b, two) {
    var pa = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian_js__["a" /* cartesian */])(a),
        pb = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian_js__["a" /* cartesian */])(b);

    // We have two planes, n1.p = d1 and n2.p = d2.
    // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
    var n1 = [1, 0, 0], // normal
        n2 = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian_js__["c" /* cartesianCross */])(pa, pb),
        n2n2 = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian_js__["d" /* cartesianDot */])(n2, n2),
        n1n2 = n2[0], // cartesianDot(n1, n2),
        determinant = n2n2 - n1n2 * n1n2;

    // Two polar points.
    if (!determinant) return !two && a;

    var c1 =  cr * n2n2 / determinant,
        c2 = -cr * n1n2 / determinant,
        n1xn2 = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian_js__["c" /* cartesianCross */])(n1, n2),
        A = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian_js__["f" /* cartesianScale */])(n1, c1),
        B = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian_js__["f" /* cartesianScale */])(n2, c2);
    Object(__WEBPACK_IMPORTED_MODULE_0__cartesian_js__["b" /* cartesianAddInPlace */])(A, B);

    // Solve |p(t)|^2 = 1.
    var u = n1xn2,
        w = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian_js__["d" /* cartesianDot */])(A, u),
        uu = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian_js__["d" /* cartesianDot */])(u, u),
        t2 = w * w - uu * (Object(__WEBPACK_IMPORTED_MODULE_0__cartesian_js__["d" /* cartesianDot */])(A, A) - 1);

    if (t2 < 0) return;

    var t = Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["u" /* sqrt */])(t2),
        q = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian_js__["f" /* cartesianScale */])(u, (-w - t) / uu);
    Object(__WEBPACK_IMPORTED_MODULE_0__cartesian_js__["b" /* cartesianAddInPlace */])(q, A);
    q = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian_js__["g" /* spherical */])(q);

    if (!two) return q;

    // Two intersection points.
    var lambda0 = a[0],
        lambda1 = b[0],
        phi0 = a[1],
        phi1 = b[1],
        z;

    if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;

    var delta = lambda1 - lambda0,
        polar = Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["a" /* abs */])(delta - __WEBPACK_IMPORTED_MODULE_2__math_js__["o" /* pi */]) < __WEBPACK_IMPORTED_MODULE_2__math_js__["i" /* epsilon */],
        meridian = polar || delta < __WEBPACK_IMPORTED_MODULE_2__math_js__["i" /* epsilon */];

    if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;

    // Check that the first point is between a and b.
    if (meridian
        ? polar
          ? phi0 + phi1 > 0 ^ q[1] < (Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["a" /* abs */])(q[0] - lambda0) < __WEBPACK_IMPORTED_MODULE_2__math_js__["i" /* epsilon */] ? phi0 : phi1)
          : phi0 <= q[1] && q[1] <= phi1
        : delta > __WEBPACK_IMPORTED_MODULE_2__math_js__["o" /* pi */] ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
      var q1 = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian_js__["f" /* cartesianScale */])(u, (-w + t) / uu);
      Object(__WEBPACK_IMPORTED_MODULE_0__cartesian_js__["b" /* cartesianAddInPlace */])(q1, A);
      return [q, Object(__WEBPACK_IMPORTED_MODULE_0__cartesian_js__["g" /* spherical */])(q1)];
    }
  }

  // Generates a 4-bit vector representing the location of a point relative to
  // the small circle's bounding box.
  function code(lambda, phi) {
    var r = smallRadius ? radius : __WEBPACK_IMPORTED_MODULE_2__math_js__["o" /* pi */] - radius,
        code = 0;
    if (lambda < -r) code |= 1; // left
    else if (lambda > r) code |= 2; // right
    if (phi < -r) code |= 4; // below
    else if (phi > r) code |= 8; // above
    return code;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_4__index_js__["a" /* default */])(visible, clipLine, interpolate, smallRadius ? [0, -radius] : [-__WEBPACK_IMPORTED_MODULE_2__math_js__["o" /* pi */], radius - __WEBPACK_IMPORTED_MODULE_2__math_js__["o" /* pi */]]);
});


/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__length_js__ = __webpack_require__(614);


var coordinates = [null, null],
    object = {type: "LineString", coordinates: coordinates};

/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  coordinates[0] = a;
  coordinates[1] = b;
  return Object(__WEBPACK_IMPORTED_MODULE_0__length_js__["a" /* default */])(object);
});


/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder_js__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__noop_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stream_js__ = __webpack_require__(133);





var lengthSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder_js__["a" /* default */])(),
    lambda0,
    sinPhi0,
    cosPhi0;

var lengthStream = {
  sphere: __WEBPACK_IMPORTED_MODULE_2__noop_js__["a" /* default */],
  point: __WEBPACK_IMPORTED_MODULE_2__noop_js__["a" /* default */],
  lineStart: lengthLineStart,
  lineEnd: __WEBPACK_IMPORTED_MODULE_2__noop_js__["a" /* default */],
  polygonStart: __WEBPACK_IMPORTED_MODULE_2__noop_js__["a" /* default */],
  polygonEnd: __WEBPACK_IMPORTED_MODULE_2__noop_js__["a" /* default */]
};

function lengthLineStart() {
  lengthStream.point = lengthPointFirst;
  lengthStream.lineEnd = lengthLineEnd;
}

function lengthLineEnd() {
  lengthStream.point = lengthStream.lineEnd = __WEBPACK_IMPORTED_MODULE_2__noop_js__["a" /* default */];
}

function lengthPointFirst(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_1__math_js__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_1__math_js__["r" /* radians */];
  lambda0 = lambda, sinPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["t" /* sin */])(phi), cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["g" /* cos */])(phi);
  lengthStream.point = lengthPoint;
}

function lengthPoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_1__math_js__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_1__math_js__["r" /* radians */];
  var sinPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["t" /* sin */])(phi),
      cosPhi = Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["g" /* cos */])(phi),
      delta = Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["a" /* abs */])(lambda - lambda0),
      cosDelta = Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["g" /* cos */])(delta),
      sinDelta = Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["t" /* sin */])(delta),
      x = cosPhi * sinDelta,
      y = cosPhi0 * sinPhi - sinPhi0 * cosPhi * cosDelta,
      z = sinPhi0 * sinPhi + cosPhi0 * cosPhi * cosDelta;
  lengthSum.add(Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["e" /* atan2 */])(Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["u" /* sqrt */])(x * x + y * y), z));
  lambda0 = lambda, sinPhi0 = sinPhi, cosPhi0 = cosPhi;
}

/* harmony default export */ __webpack_exports__["a"] = (function(object) {
  lengthSum.reset();
  Object(__WEBPACK_IMPORTED_MODULE_3__stream_js__["a" /* default */])(object, lengthStream);
  return +lengthSum;
});


/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop_js__ = __webpack_require__(113);


var x0 = Infinity,
    y0 = x0,
    x1 = -x0,
    y1 = x1;

var boundsStream = {
  point: boundsPoint,
  lineStart: __WEBPACK_IMPORTED_MODULE_0__noop_js__["a" /* default */],
  lineEnd: __WEBPACK_IMPORTED_MODULE_0__noop_js__["a" /* default */],
  polygonStart: __WEBPACK_IMPORTED_MODULE_0__noop_js__["a" /* default */],
  polygonEnd: __WEBPACK_IMPORTED_MODULE_0__noop_js__["a" /* default */],
  result: function() {
    var bounds = [[x0, y0], [x1, y1]];
    x1 = y1 = -(y0 = x0 = Infinity);
    return bounds;
  }
};

function boundsPoint(x, y) {
  if (x < x0) x0 = x;
  if (x > x1) x1 = x;
  if (y < y0) y0 = y;
  if (y > y1) y1 = y;
}

/* harmony default export */ __webpack_exports__["a"] = (boundsStream);


/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__conicEqualArea_js__ = __webpack_require__(362);


/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__conicEqualArea_js__["a" /* default */])()
      .parallels([29.5, 45.5])
      .scale(1070)
      .translate([480, 250])
      .rotate([96, 0])
      .center([-0.6, 38.7]);
});


/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = equirectangularRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_js__ = __webpack_require__(86);


function equirectangularRaw(lambda, phi) {
  return [lambda, phi];
}

equirectangularRaw.invert = equirectangularRaw;

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__index_js__["a" /* default */])(equirectangularRaw)
      .scale(152.63);
});


/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__series_abstract_series__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_scales_utils__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






function getLocs(evt) {
  var xLoc = evt.type === 'touchstart' ? evt.pageX : evt.offsetX;
  var yLoc = evt.type === 'touchstart' ? evt.pageY : evt.offsetY;
  return { xLoc: xLoc, yLoc: yLoc };
}

var Highlight = function (_AbstractSeries) {
  _inherits(Highlight, _AbstractSeries);

  function Highlight() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Highlight);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Highlight.__proto__ || Object.getPrototypeOf(Highlight)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      dragging: false,
      brushArea: { top: 0, right: 0, bottom: 0, left: 0 },
      brushing: false,
      startLocX: 0,
      startLocY: 0,
      dragArea: null
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Highlight, [{
    key: '_getDrawArea',
    value: function _getDrawArea(xLoc, yLoc) {
      var _state = this.state,
          startLocX = _state.startLocX,
          startLocY = _state.startLocY;
      var _props = this.props,
          enableX = _props.enableX,
          enableY = _props.enableY,
          highlightWidth = _props.highlightWidth,
          highlightHeight = _props.highlightHeight,
          innerWidth = _props.innerWidth,
          innerHeight = _props.innerHeight,
          marginLeft = _props.marginLeft,
          marginRight = _props.marginRight,
          marginBottom = _props.marginBottom,
          marginTop = _props.marginTop;

      var plotHeight = innerHeight + marginTop + marginBottom;
      var plotWidth = innerWidth + marginLeft + marginRight;
      var touchWidth = highlightWidth || plotWidth;
      var touchHeight = highlightHeight || plotHeight;

      return {
        bottom: enableY ? Math.max(startLocY, yLoc) : touchHeight,
        right: enableX ? Math.max(startLocX, xLoc) : touchWidth,
        left: enableX ? Math.min(xLoc, startLocX) : 0,
        top: enableY ? Math.min(yLoc, startLocY) : 0
      };
    }
  }, {
    key: '_getDragArea',
    value: function _getDragArea(xLoc, yLoc) {
      var _props2 = this.props,
          enableX = _props2.enableX,
          enableY = _props2.enableY;
      var _state2 = this.state,
          startLocX = _state2.startLocX,
          startLocY = _state2.startLocY,
          dragArea = _state2.dragArea;


      return {
        bottom: dragArea.bottom + (enableY ? yLoc - startLocY : 0),
        left: dragArea.left + (enableX ? xLoc - startLocX : 0),
        right: dragArea.right + (enableX ? xLoc - startLocX : 0),
        top: dragArea.top + (enableY ? yLoc - startLocY : 0)
      };
    }
  }, {
    key: '_clickedOutsideDrag',
    value: function _clickedOutsideDrag(xLoc, yLoc) {
      var _props3 = this.props,
          enableX = _props3.enableX,
          enableY = _props3.enableY;
      var _state3 = this.state,
          dragArea = _state3.dragArea,
          _state3$brushArea = _state3.brushArea,
          left = _state3$brushArea.left,
          right = _state3$brushArea.right,
          top = _state3$brushArea.top,
          bottom = _state3$brushArea.bottom;

      var clickedOutsideDragX = dragArea && (xLoc < left || xLoc > right);
      var clickedOutsideDragY = dragArea && (yLoc < top || yLoc > bottom);
      if (enableX && enableY) {
        return clickedOutsideDragX || clickedOutsideDragY;
      }
      if (enableX) {
        return clickedOutsideDragX;
      }
      if (enableY) {
        return clickedOutsideDragY;
      }
      return true;
    }
  }, {
    key: '_convertAreaToCoordinates',
    value: function _convertAreaToCoordinates(brushArea) {
      // NOTE only continuous scales are supported for brushing/getting coordinates back
      var _props4 = this.props,
          enableX = _props4.enableX,
          enableY = _props4.enableY,
          marginLeft = _props4.marginLeft,
          marginTop = _props4.marginTop;

      var xScale = Object(__WEBPACK_IMPORTED_MODULE_2__utils_scales_utils__["d" /* getAttributeScale */])(this.props, 'x');
      var yScale = Object(__WEBPACK_IMPORTED_MODULE_2__utils_scales_utils__["d" /* getAttributeScale */])(this.props, 'y');

      // Ensure that users wishes are being respected about which scales are evaluated
      // this is specifically enabled to ensure brushing on mixed categorical and linear
      // charts will run as expected

      if (enableX && enableY) {
        return {
          bottom: yScale.invert(brushArea.bottom),
          left: xScale.invert(brushArea.left - marginLeft),
          right: xScale.invert(brushArea.right - marginLeft),
          top: yScale.invert(brushArea.top)
        };
      }

      if (enableY) {
        return {
          bottom: yScale.invert(brushArea.bottom - marginTop),
          top: yScale.invert(brushArea.top - marginTop)
        };
      }

      if (enableX) {
        return {
          left: xScale.invert(brushArea.left - marginLeft),
          right: xScale.invert(brushArea.right - marginLeft)
        };
      }

      return {};
    }
  }, {
    key: 'startBrushing',
    value: function startBrushing(e) {
      var _this2 = this;

      var _props5 = this.props,
          onBrushStart = _props5.onBrushStart,
          onDragStart = _props5.onDragStart,
          drag = _props5.drag;
      var dragArea = this.state.dragArea;

      var _getLocs = getLocs(e.nativeEvent),
          xLoc = _getLocs.xLoc,
          yLoc = _getLocs.yLoc;

      var startArea = function startArea(dragging, resetDrag) {
        var emptyBrush = {
          bottom: yLoc,
          left: xLoc,
          right: xLoc,
          top: yLoc
        };
        _this2.setState({
          dragging: dragging,
          brushArea: dragArea && !resetDrag ? dragArea : emptyBrush,
          brushing: !dragging,
          startLocX: xLoc,
          startLocY: yLoc
        });
      };

      var clickedOutsideDrag = this._clickedOutsideDrag(xLoc, yLoc);
      if (drag && !dragArea || !drag || clickedOutsideDrag) {
        startArea(false, clickedOutsideDrag);

        if (onBrushStart) {
          onBrushStart(e);
        }
        return;
      }

      if (drag && dragArea) {
        startArea(true, clickedOutsideDrag);
        if (onDragStart) {
          onDragStart(e);
        }
      }
    }
  }, {
    key: 'stopBrushing',
    value: function stopBrushing(e) {
      var _state4 = this.state,
          brushing = _state4.brushing,
          dragging = _state4.dragging,
          brushArea = _state4.brushArea;
      // Quickly short-circuit if the user isn't brushing in our component

      if (!brushing && !dragging) {
        return;
      }
      var _props6 = this.props,
          onBrushEnd = _props6.onBrushEnd,
          onDragEnd = _props6.onDragEnd,
          drag = _props6.drag;

      var noHorizontal = Math.abs(brushArea.right - brushArea.left) < 5;
      var noVertical = Math.abs(brushArea.top - brushArea.bottom) < 5;
      // Invoke the callback with null if the selected area was < 5px
      var isNulled = noVertical || noHorizontal;
      // Clear the draw area
      this.setState({
        brushing: false,
        dragging: false,
        brushArea: drag ? brushArea : { top: 0, right: 0, bottom: 0, left: 0 },
        startLocX: 0,
        startLocY: 0,
        dragArea: drag && !isNulled && brushArea
      });

      if (brushing && onBrushEnd) {
        onBrushEnd(!isNulled ? this._convertAreaToCoordinates(brushArea) : null);
      }

      if (drag && onDragEnd) {
        onDragEnd(!isNulled ? this._convertAreaToCoordinates(brushArea) : null);
      }
    }
  }, {
    key: 'onBrush',
    value: function onBrush(e) {
      var _props7 = this.props,
          onBrush = _props7.onBrush,
          onDrag = _props7.onDrag,
          drag = _props7.drag;
      var _state5 = this.state,
          brushing = _state5.brushing,
          dragging = _state5.dragging;

      var _getLocs2 = getLocs(e.nativeEvent),
          xLoc = _getLocs2.xLoc,
          yLoc = _getLocs2.yLoc;

      if (brushing) {
        var brushArea = this._getDrawArea(xLoc, yLoc);
        this.setState({ brushArea: brushArea });

        if (onBrush) {
          onBrush(this._convertAreaToCoordinates(brushArea));
        }
      }

      if (drag && dragging) {
        var _brushArea = this._getDragArea(xLoc, yLoc);
        this.setState({ brushArea: _brushArea });
        if (onDrag) {
          onDrag(this._convertAreaToCoordinates(_brushArea));
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props8 = this.props,
          color = _props8.color,
          className = _props8.className,
          highlightHeight = _props8.highlightHeight,
          highlightWidth = _props8.highlightWidth,
          highlightX = _props8.highlightX,
          highlightY = _props8.highlightY,
          innerWidth = _props8.innerWidth,
          innerHeight = _props8.innerHeight,
          marginLeft = _props8.marginLeft,
          marginRight = _props8.marginRight,
          marginTop = _props8.marginTop,
          marginBottom = _props8.marginBottom,
          opacity = _props8.opacity;
      var _state$brushArea = this.state.brushArea,
          left = _state$brushArea.left,
          right = _state$brushArea.right,
          top = _state$brushArea.top,
          bottom = _state$brushArea.bottom;


      var leftPos = 0;
      if (highlightX) {
        var xScale = Object(__WEBPACK_IMPORTED_MODULE_2__utils_scales_utils__["d" /* getAttributeScale */])(this.props, 'x');
        leftPos = xScale(highlightX);
      }

      var topPos = 0;
      if (highlightY) {
        var yScale = Object(__WEBPACK_IMPORTED_MODULE_2__utils_scales_utils__["d" /* getAttributeScale */])(this.props, 'y');
        topPos = yScale(highlightY);
      }

      var plotWidth = marginLeft + marginRight + innerWidth;
      var plotHeight = marginTop + marginBottom + innerHeight;
      var touchWidth = highlightWidth || plotWidth;
      var touchHeight = highlightHeight || plotHeight;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        {
          transform: 'translate(' + leftPos + ', ' + topPos + ')',
          className: className + ' rv-highlight-container'
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', {
          className: 'rv-mouse-target',
          fill: 'black',
          opacity: '0',
          x: '0',
          y: '0',
          width: Math.max(touchWidth, 0),
          height: Math.max(touchHeight, 0),
          onMouseDown: function onMouseDown(e) {
            return _this3.startBrushing(e);
          },
          onMouseMove: function onMouseMove(e) {
            return _this3.onBrush(e);
          },
          onMouseUp: function onMouseUp(e) {
            return _this3.stopBrushing(e);
          },
          onMouseLeave: function onMouseLeave(e) {
            return _this3.stopBrushing(e);
          }
          // preventDefault() so that mouse event emulation does not happen
          , onTouchEnd: function onTouchEnd(e) {
            e.preventDefault();
            _this3.stopBrushing(e);
          },
          onTouchCancel: function onTouchCancel(e) {
            e.preventDefault();
            _this3.stopBrushing(e);
          },
          onContextMenu: function onContextMenu(e) {
            return e.preventDefault();
          },
          onContextMenuCapture: function onContextMenuCapture(e) {
            return e.preventDefault();
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', {
          className: 'rv-highlight',
          pointerEvents: 'none',
          opacity: opacity,
          fill: color,
          x: left,
          y: top,
          width: Math.min(Math.max(0, right - left), touchWidth),
          height: Math.min(Math.max(0, bottom - top), touchHeight)
        })
      );
    }
  }]);

  return Highlight;
}(__WEBPACK_IMPORTED_MODULE_1__series_abstract_series__["a" /* default */]);

Highlight.displayName = 'HighlightOverlay';
Highlight.defaultProps = {
  color: 'rgb(77, 182, 172)',
  className: '',
  enableX: true,
  enableY: true,
  opacity: 0.3
};

Highlight.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_1__series_abstract_series__["a" /* default */].propTypes, {
  enableX: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  enableY: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  highlightHeight: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  highlightWidth: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  highlightX: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number]),
  highlightY: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number]),
  onBrushStart: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  onDragStart: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  onBrush: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  onDrag: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  onBrushEnd: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  onDragEnd: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
});

/* harmony default export */ __webpack_exports__["a"] = (Highlight);

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__animation__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_series_utils__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__abstract_series__ = __webpack_require__(48);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.










var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--bar';

var BarSeries = function (_AbstractSeries) {
  _inherits(BarSeries, _AbstractSeries);

  function BarSeries() {
    _classCallCheck(this, BarSeries);

    return _possibleConstructorReturn(this, (BarSeries.__proto__ || Object.getPrototypeOf(BarSeries)).apply(this, arguments));
  }

  _createClass(BarSeries, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          animation = _props.animation,
          className = _props.className,
          data = _props.data,
          linePosAttr = _props.linePosAttr,
          lineSizeAttr = _props.lineSizeAttr,
          marginLeft = _props.marginLeft,
          marginTop = _props.marginTop,
          style = _props.style,
          valuePosAttr = _props.valuePosAttr,
          valueSizeAttr = _props.valueSizeAttr,
          barWidth = _props.barWidth;


      if (!data) {
        return null;
      }

      if (animation) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__animation__["b" /* default */],
          _extends({}, this.props, { animatedProps: __WEBPACK_IMPORTED_MODULE_3__utils_series_utils__["a" /* ANIMATED_SERIES_PROPS */] }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BarSeries, _extends({}, this.props, { animation: null }))
        );
      }

      var _getStackParams = Object(__WEBPACK_IMPORTED_MODULE_3__utils_series_utils__["e" /* getStackParams */])(this.props),
          sameTypeTotal = _getStackParams.sameTypeTotal,
          sameTypeIndex = _getStackParams.sameTypeIndex;

      var distance = this._getScaleDistance(linePosAttr);
      var lineFunctor = this._getAttributeFunctor(linePosAttr);
      var valueFunctor = this._getAttributeFunctor(valuePosAttr);
      var value0Functor = this._getAttr0Functor(valuePosAttr);
      var fillFunctor = this._getAttributeFunctor('fill') || this._getAttributeFunctor('color');
      var strokeFunctor = this._getAttributeFunctor('stroke') || this._getAttributeFunctor('color');
      var opacityFunctor = this._getAttributeFunctor('opacity');

      var halfSpace = distance / 2 * barWidth;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        {
          className: predefinedClassName + ' ' + className,
          transform: 'translate(' + marginLeft + ',' + marginTop + ')'
        },
        data.map(function (d, i) {
          var _attrs;

          // totalSpaceAvailable is the space we have available to draw all the
          // bars of a same 'linePosAttr' value (a.k.a. sameTypeTotal)
          var totalSpaceAvailable = halfSpace * 2;
          var totalSpaceCenter = lineFunctor(d);
          // totalSpaceStartingPoint is the first pixel were we can start drawing
          var totalSpaceStartingPoint = totalSpaceCenter - halfSpace;
          // spaceTakenByInterBarsPixels has the overhead space consumed by each bar of sameTypeTotal
          var spaceTakenByInterBarsPixels = (sameTypeTotal - 1) / sameTypeTotal;
          // spacePerBar is the space we have available to draw sameTypeIndex bar
          var spacePerBar = totalSpaceAvailable / sameTypeTotal - spaceTakenByInterBarsPixels;
          // barStartingPoint is the first pixel were we can start drawing sameTypeIndex bar
          var barStartingPoint = totalSpaceStartingPoint + spacePerBar * sameTypeIndex + sameTypeIndex;

          var attrs = (_attrs = {
            style: _extends({
              opacity: opacityFunctor && opacityFunctor(d),
              stroke: strokeFunctor && strokeFunctor(d),
              fill: fillFunctor && fillFunctor(d)
            }, style)
          }, _defineProperty(_attrs, linePosAttr, barStartingPoint), _defineProperty(_attrs, lineSizeAttr, spacePerBar), _defineProperty(_attrs, valuePosAttr, Math.min(value0Functor(d), valueFunctor(d))), _defineProperty(_attrs, valueSizeAttr, Math.abs(-value0Functor(d) + valueFunctor(d))), _defineProperty(_attrs, 'onClick', function onClick(e) {
            return _this2._valueClickHandler(d, e);
          }), _defineProperty(_attrs, 'onContextMenu', function onContextMenu(e) {
            return _this2._valueRightClickHandler(d, e);
          }), _defineProperty(_attrs, 'onMouseOver', function onMouseOver(e) {
            return _this2._valueMouseOverHandler(d, e);
          }), _defineProperty(_attrs, 'onMouseOut', function onMouseOut(e) {
            return _this2._valueMouseOutHandler(d, e);
          }), _defineProperty(_attrs, 'key', i), _attrs);
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', attrs);
        })
      );
    }
  }], [{
    key: 'propTypes',
    get: function get() {
      return _extends({}, __WEBPACK_IMPORTED_MODULE_4__abstract_series__["a" /* default */].propTypes, {
        linePosAttr: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        valuePosAttr: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        lineSizeAttr: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        valueSizeAttr: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        cluster: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        barWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
      });
    }
  }, {
    key: 'defaultProps',
    get: function get() {
      return {
        barWidth: 0.85
      };
    }
  }]);

  return BarSeries;
}(__WEBPACK_IMPORTED_MODULE_4__abstract_series__["a" /* default */]);

BarSeries.displayName = 'BarSeries';

/* harmony default export */ __webpack_exports__["a"] = (BarSeries);

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_color__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__theme__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_series_utils__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__abstract_series__ = __webpack_require__(48);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.








function getScaleDistance(props, attr) {
  var scaleObject = Object(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["i" /* getScaleObjectFromProps */])(props, attr);
  return scaleObject ? scaleObject.distance : 0;
}

var BarSeriesCanvas = function (_AbstractSeries) {
  _inherits(BarSeriesCanvas, _AbstractSeries);

  function BarSeriesCanvas() {
    _classCallCheck(this, BarSeriesCanvas);

    return _possibleConstructorReturn(this, (BarSeriesCanvas.__proto__ || Object.getPrototypeOf(BarSeriesCanvas)).apply(this, arguments));
  }

  _createClass(BarSeriesCanvas, [{
    key: 'render',
    value: function render() {
      return null;
    }
  }], [{
    key: 'renderLayer',
    value: function renderLayer(props, ctx) {
      var data = props.data,
          linePosAttr = props.linePosAttr,
          lineSizeAttr = props.lineSizeAttr,
          valuePosAttr = props.valuePosAttr,
          marginTop = props.marginTop,
          marginBottom = props.marginBottom;

      if (!data || data.length === 0) {
        return;
      }

      var distance = getScaleDistance(props, linePosAttr);
      var line = Object(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["c" /* getAttributeFunctor */])(props, linePosAttr);
      var value = Object(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["c" /* getAttributeFunctor */])(props, valuePosAttr);
      var value0 = Object(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["b" /* getAttr0Functor */])(props, valuePosAttr);
      var fill = Object(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["c" /* getAttributeFunctor */])(props, 'fill') || Object(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["c" /* getAttributeFunctor */])(props, 'color');
      var stroke = Object(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["c" /* getAttributeFunctor */])(props, 'stroke') || Object(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["c" /* getAttributeFunctor */])(props, 'color');
      var opacity = Object(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["c" /* getAttributeFunctor */])(props, 'opacity');

      var halfSpace = distance / 2 * 0.85;
      // totalSpaceAvailable is the space we have available to draw all the
      // bars of a same 'linePosAttr' value (a.k.a. sameTypeTotal)
      var totalSpaceAvailable = halfSpace * 2;

      var _getStackParams = Object(__WEBPACK_IMPORTED_MODULE_4__utils_series_utils__["e" /* getStackParams */])(props),
          sameTypeTotal = _getStackParams.sameTypeTotal,
          sameTypeIndex = _getStackParams.sameTypeIndex;

      data.forEach(function (row) {
        var totalSpaceCenter = line(row);
        // totalSpaceStartingPoint is the first pixel were we can start drawing
        var totalSpaceStartingPoint = totalSpaceCenter - halfSpace;

        // spaceTakenByInterBarsPixels has the overhead space consumed by each bar of sameTypeTotal
        var spaceTakenByInterBarsPixels = (sameTypeTotal - 1) / sameTypeTotal;
        // lineSize is the space we have available to draw sameTypeIndex bar
        var lineSize = totalSpaceAvailable / sameTypeTotal - spaceTakenByInterBarsPixels;

        var fillColor = Object(__WEBPACK_IMPORTED_MODULE_1_d3_color__["f" /* rgb */])(fill(row));
        var strokeColor = Object(__WEBPACK_IMPORTED_MODULE_1_d3_color__["f" /* rgb */])(stroke(row));
        var rowOpacity = opacity(row) || __WEBPACK_IMPORTED_MODULE_2__theme__["c" /* DEFAULT_OPACITY */];

        // linePos is the first pixel were we can start drawing sameTypeIndex bar
        var linePos = totalSpaceStartingPoint + lineSize * sameTypeIndex + sameTypeIndex;
        var valuePos = Math.min(value0(row), value(row));
        var x = valuePosAttr === 'x' ? valuePos : linePos;
        var y = valuePosAttr === 'y' ? valuePos : linePos;

        var valueSize = Math.abs(-value0(row) + value(row));
        var height = lineSizeAttr === 'height' ? lineSize : valueSize;
        var width = lineSizeAttr === 'width' ? lineSize : valueSize;

        ctx.beginPath();
        ctx.rect(x + marginBottom, y + marginTop, width, height);
        ctx.fillStyle = 'rgba(' + fillColor.r + ', ' + fillColor.g + ', ' + fillColor.b + ', ' + rowOpacity + ')';
        ctx.fill();
        ctx.strokeStyle = 'rgba(' + strokeColor.r + ', ' + strokeColor.g + ', ' + strokeColor.b + ', ' + rowOpacity + ')';
        ctx.stroke();
      });
    }
  }, {
    key: 'requiresSVG',
    get: function get() {
      return false;
    }
  }, {
    key: 'isCanvas',
    get: function get() {
      return true;
    }
  }]);

  return BarSeriesCanvas;
}(__WEBPACK_IMPORTED_MODULE_5__abstract_series__["a" /* default */]);

BarSeriesCanvas.displayName = 'BarSeriesCanvas';
BarSeriesCanvas.defaultProps = _extends({}, __WEBPACK_IMPORTED_MODULE_5__abstract_series__["a" /* default */].defaultProps, {
  linePosAttr: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  valuePosAttr: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  lineSizeAttr: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  valueSizeAttr: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired
});

BarSeriesCanvas.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_5__abstract_series__["a" /* default */].propTypes);

/* harmony default export */ __webpack_exports__["a"] = (BarSeriesCanvas);

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__abstract_series__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__line_series__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mark_series__ = __webpack_require__(265);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.








var propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_3__line_series__["a" /* default */].propTypes, {
  lineStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  markStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
});

var LineMarkSeries = function (_AbstractSeries) {
  _inherits(LineMarkSeries, _AbstractSeries);

  function LineMarkSeries() {
    _classCallCheck(this, LineMarkSeries);

    return _possibleConstructorReturn(this, (LineMarkSeries.__proto__ || Object.getPrototypeOf(LineMarkSeries)).apply(this, arguments));
  }

  _createClass(LineMarkSeries, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          lineStyle = _props.lineStyle,
          markStyle = _props.markStyle,
          style = _props.style;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        { className: 'rv-xy-plot__series rv-xy-plot__series--linemark' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__line_series__["a" /* default */], _extends({}, this.props, { style: _extends({}, style, lineStyle) })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__mark_series__["a" /* default */], _extends({}, this.props, { style: _extends({}, style, markStyle) }))
      );
    }
  }], [{
    key: 'defaultProps',
    get: function get() {
      return _extends({}, __WEBPACK_IMPORTED_MODULE_3__line_series__["a" /* default */].defaultProps, {
        lineStyle: {},
        markStyle: {}
      });
    }
  }]);

  return LineMarkSeries;
}(__WEBPACK_IMPORTED_MODULE_2__abstract_series__["a" /* default */]);

LineMarkSeries.displayName = 'LineMarkSeries';
LineMarkSeries.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (LineMarkSeries);

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__theme__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_scales_utils__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__abstract_series__ = __webpack_require__(48);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.








var MarkSeriesCanvas = function (_AbstractSeries) {
  _inherits(MarkSeriesCanvas, _AbstractSeries);

  function MarkSeriesCanvas() {
    _classCallCheck(this, MarkSeriesCanvas);

    return _possibleConstructorReturn(this, (MarkSeriesCanvas.__proto__ || Object.getPrototypeOf(MarkSeriesCanvas)).apply(this, arguments));
  }

  _createClass(MarkSeriesCanvas, [{
    key: 'render',
    value: function render() {
      return null;
    }
  }], [{
    key: 'renderLayer',
    value: function renderLayer(props, ctx) {
      var data = props.data,
          marginLeft = props.marginLeft,
          marginTop = props.marginTop;


      var x = Object(__WEBPACK_IMPORTED_MODULE_2__utils_scales_utils__["c" /* getAttributeFunctor */])(props, 'x');
      var y = Object(__WEBPACK_IMPORTED_MODULE_2__utils_scales_utils__["c" /* getAttributeFunctor */])(props, 'y');
      var size = Object(__WEBPACK_IMPORTED_MODULE_2__utils_scales_utils__["c" /* getAttributeFunctor */])(props, 'size') || function (p) {
        return __WEBPACK_IMPORTED_MODULE_1__theme__["d" /* DEFAULT_SIZE */];
      };
      var fill = Object(__WEBPACK_IMPORTED_MODULE_2__utils_scales_utils__["c" /* getAttributeFunctor */])(props, 'fill') || Object(__WEBPACK_IMPORTED_MODULE_2__utils_scales_utils__["c" /* getAttributeFunctor */])(props, 'color');
      var stroke = Object(__WEBPACK_IMPORTED_MODULE_2__utils_scales_utils__["c" /* getAttributeFunctor */])(props, 'stroke') || Object(__WEBPACK_IMPORTED_MODULE_2__utils_scales_utils__["c" /* getAttributeFunctor */])(props, 'color');
      var opacity = Object(__WEBPACK_IMPORTED_MODULE_2__utils_scales_utils__["c" /* getAttributeFunctor */])(props, 'opacity');

      data.forEach(function (row) {
        var fillColor = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* rgb */])(fill(row));
        var strokeColor = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* rgb */])(stroke(row));
        var rowOpacity = opacity(row) || __WEBPACK_IMPORTED_MODULE_1__theme__["c" /* DEFAULT_OPACITY */];
        ctx.beginPath();
        ctx.arc(x(row) + marginLeft, y(row) + marginTop, size(row), 0, 2 * Math.PI);
        ctx.fillStyle = 'rgba(' + fillColor.r + ', ' + fillColor.g + ', ' + fillColor.b + ', ' + rowOpacity + ')';
        ctx.fill();
        ctx.strokeStyle = 'rgba(' + strokeColor.r + ', ' + strokeColor.g + ', ' + strokeColor.b + ', ' + rowOpacity + ')';
        ctx.stroke();
      });
    }
  }, {
    key: 'requiresSVG',
    get: function get() {
      return false;
    }
  }, {
    key: 'isCanvas',
    get: function get() {
      return true;
    }
  }]);

  return MarkSeriesCanvas;
}(__WEBPACK_IMPORTED_MODULE_3__abstract_series__["a" /* default */]);

MarkSeriesCanvas.displayName = 'MarkSeriesCanvas';

MarkSeriesCanvas.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_3__abstract_series__["a" /* default */].propTypes);

/* harmony default export */ __webpack_exports__["a"] = (MarkSeriesCanvas);

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_color__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_shape__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__theme__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_scales_utils__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__abstract_series__ = __webpack_require__(48);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.









var LineSeriesCanvas = function (_AbstractSeries) {
  _inherits(LineSeriesCanvas, _AbstractSeries);

  function LineSeriesCanvas() {
    _classCallCheck(this, LineSeriesCanvas);

    return _possibleConstructorReturn(this, (LineSeriesCanvas.__proto__ || Object.getPrototypeOf(LineSeriesCanvas)).apply(this, arguments));
  }

  _createClass(LineSeriesCanvas, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', null);
    }
  }], [{
    key: 'renderLayer',
    value: function renderLayer(props, ctx) {
      var curve = props.curve,
          data = props.data,
          marginLeft = props.marginLeft,
          marginTop = props.marginTop,
          strokeWidth = props.strokeWidth,
          strokeDasharray = props.strokeDasharray;

      if (!data || data.length === 0) {
        return;
      }

      var x = Object(__WEBPACK_IMPORTED_MODULE_5__utils_scales_utils__["c" /* getAttributeFunctor */])(props, 'x');
      var y = Object(__WEBPACK_IMPORTED_MODULE_5__utils_scales_utils__["c" /* getAttributeFunctor */])(props, 'y');
      var stroke = Object(__WEBPACK_IMPORTED_MODULE_5__utils_scales_utils__["e" /* getAttributeValue */])(props, 'stroke') || Object(__WEBPACK_IMPORTED_MODULE_5__utils_scales_utils__["e" /* getAttributeValue */])(props, 'color');
      var strokeColor = Object(__WEBPACK_IMPORTED_MODULE_1_d3_color__["f" /* rgb */])(stroke);
      var newOpacity = Object(__WEBPACK_IMPORTED_MODULE_5__utils_scales_utils__["e" /* getAttributeValue */])(props, 'opacity');
      var opacity = Number.isFinite(newOpacity) ? newOpacity : __WEBPACK_IMPORTED_MODULE_4__theme__["c" /* DEFAULT_OPACITY */];
      var line = __WEBPACK_IMPORTED_MODULE_2_d3_shape__["line"]().x(function (row) {
        return x(row) + marginLeft;
      }).y(function (row) {
        return y(row) + marginTop;
      });
      if (typeof curve === 'string' && __WEBPACK_IMPORTED_MODULE_2_d3_shape__[curve]) {
        line = line.curve(__WEBPACK_IMPORTED_MODULE_2_d3_shape__[curve]);
      } else if (typeof curve === 'function') {
        line = line.curve(curve);
      }

      ctx.beginPath();
      ctx.strokeStyle = 'rgba(' + strokeColor.r + ', ' + strokeColor.g + ', ' + strokeColor.b + ', ' + opacity + ')';
      ctx.lineWidth = strokeWidth;

      if (strokeDasharray) {
        ctx.setLineDash(strokeDasharray);
      }

      line.context(ctx)(data);
      ctx.stroke();
      ctx.closePath();
      // set back to default
      ctx.lineWidth = 1;
      ctx.setLineDash([]);
    }
  }, {
    key: 'requiresSVG',
    get: function get() {
      return false;
    }
  }, {
    key: 'isCanvas',
    get: function get() {
      return true;
    }
  }]);

  return LineSeriesCanvas;
}(__WEBPACK_IMPORTED_MODULE_6__abstract_series__["a" /* default */]);

LineSeriesCanvas.displayName = 'LineSeriesCanvas';
LineSeriesCanvas.defaultProps = _extends({}, __WEBPACK_IMPORTED_MODULE_6__abstract_series__["a" /* default */].defaultProps, {
  strokeWidth: 2
});

LineSeriesCanvas.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_6__abstract_series__["a" /* default */].propTypes, {
  strokeWidth: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number
});

/* harmony default export */ __webpack_exports__["a"] = (LineSeriesCanvas);

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__abstract_series__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rect_series__ = __webpack_require__(368);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.






var VerticalRectSeries = function (_AbstractSeries) {
  _inherits(VerticalRectSeries, _AbstractSeries);

  function VerticalRectSeries() {
    _classCallCheck(this, VerticalRectSeries);

    return _possibleConstructorReturn(this, (VerticalRectSeries.__proto__ || Object.getPrototypeOf(VerticalRectSeries)).apply(this, arguments));
  }

  _createClass(VerticalRectSeries, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__rect_series__["a" /* default */], _extends({}, this.props, {
        linePosAttr: 'x',
        valuePosAttr: 'y',
        lineSizeAttr: 'width',
        valueSizeAttr: 'height'
      }));
    }
  }], [{
    key: 'getParentConfig',
    value: function getParentConfig(attr) {
      var isDomainAdjustmentNeeded = false;
      var zeroBaseValue = attr === 'y';
      return {
        isDomainAdjustmentNeeded: isDomainAdjustmentNeeded,
        zeroBaseValue: zeroBaseValue
      };
    }
  }]);

  return VerticalRectSeries;
}(__WEBPACK_IMPORTED_MODULE_1__abstract_series__["a" /* default */]);

VerticalRectSeries.displayName = 'VerticalRectSeries';

/* harmony default export */ __webpack_exports__["a"] = (VerticalRectSeries);

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_voronoi__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__ = __webpack_require__(69);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var NOOP = function NOOP(f) {
  return f;
};

// Find the index of the node at coordinates of a touch point
function getNodeIndex(evt) {
  var _evt$nativeEvent = evt.nativeEvent,
      pageX = _evt$nativeEvent.pageX,
      pageY = _evt$nativeEvent.pageY;

  var target = document.elementFromPoint(pageX, pageY);
  if (!target) {
    return -1;
  }
  var parentNode = target.parentNode;

  return Array.prototype.indexOf.call(parentNode.childNodes, target);
}

function getExtent(_ref) {
  var innerWidth = _ref.innerWidth,
      innerHeight = _ref.innerHeight,
      marginLeft = _ref.marginLeft,
      marginTop = _ref.marginTop;

  return [[marginLeft, marginTop], [innerWidth + marginLeft, innerHeight + marginTop]];
}

function Voronoi(props) {
  var className = props.className,
      extent = props.extent,
      nodes = props.nodes,
      onBlur = props.onBlur,
      _onClick = props.onClick,
      _onMouseUp = props.onMouseUp,
      _onMouseDown = props.onMouseDown,
      onHover = props.onHover,
      polygonStyle = props.polygonStyle,
      style = props.style,
      x = props.x,
      y = props.y;
  // Create a voronoi with each node center points

  var voronoiInstance = Object(__WEBPACK_IMPORTED_MODULE_2_d3_voronoi__["a" /* voronoi */])().x(x || Object(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["c" /* getAttributeFunctor */])(props, 'x')).y(y || Object(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["c" /* getAttributeFunctor */])(props, 'y')).extent(extent || getExtent(props));

  // Create an array of polygons corresponding to the cells in voronoi
  var polygons = voronoiInstance.polygons(nodes);

  // Create helper function to handle special logic for touch events
  var handleTouchEvent = function handleTouchEvent(handler) {
    return function (evt) {
      evt.preventDefault();
      var index = getNodeIndex(evt);
      if (index > -1 && index < polygons.length) {
        var d = polygons[index];
        handler(d.data);
      }
    };
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'g',
    {
      className: className + ' rv-voronoi',
      style: style
      // Because of the nature of how touch events, and more specifically touchmove
      // and how it differs from mouseover, we must manage touch events on the parent
      , onTouchEnd: handleTouchEvent(_onMouseUp),
      onTouchStart: handleTouchEvent(_onMouseDown),
      onTouchMove: handleTouchEvent(onHover),
      onTouchCancel: handleTouchEvent(onBlur)
    },
    polygons.map(function (d, i) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
        className: 'rv-voronoi__cell ' + (d.data && d.data.className || ''),
        d: 'M' + d.join('L') + 'Z',
        onClick: function onClick() {
          return _onClick(d.data);
        },
        onMouseUp: function onMouseUp() {
          return _onMouseUp(d.data);
        },
        onMouseDown: function onMouseDown() {
          return _onMouseDown(d.data);
        },
        onMouseOver: function onMouseOver() {
          return onHover(d.data);
        },
        onMouseOut: function onMouseOut() {
          return onBlur(d.data);
        },
        fill: 'none',
        style: _extends({
          pointerEvents: 'all'
        }, polygonStyle, d.data && d.data.style),
        key: i
      });
    })
  );
}

Voronoi.requiresSVG = true;
Voronoi.displayName = 'Voronoi';
Voronoi.defaultProps = {
  className: '',
  onBlur: NOOP,
  onClick: NOOP,
  onHover: NOOP,
  onMouseDown: NOOP,
  onMouseUp: NOOP
};

Voronoi.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  extent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number)),
  nodes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,
  onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onHover: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMouseDown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMouseUp: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  x: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  y: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (Voronoi);

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var slice = Array.prototype.slice;
var isArgs = __webpack_require__(627);

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(2264);

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(373);

var callBind = __webpack_require__(375);

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var numberIsNaN = function (value) {
	return value !== value;
};

module.exports = function is(a, b) {
	if (a === 0 && b === 0) {
		return 1 / a === 1 / b;
	}
	if (a === b) {
		return true;
	}
	if (numberIsNaN(a) && numberIsNaN(b)) {
		return true;
	}
	return false;
};



/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(630);

module.exports = function getPolyfill() {
	return typeof Object.is === 'function' ? Object.is : implementation;
};


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var functionsHaveConfigurableNames = __webpack_require__(2274).functionsHaveConfigurableNames();

var $Object = Object;
var $TypeError = TypeError;

module.exports = function flags() {
	if (this != null && this !== $Object(this)) {
		throw new $TypeError('RegExp.prototype.flags getter called on non-object');
	}
	var result = '';
	if (this.hasIndices) {
		result += 'd';
	}
	if (this.global) {
		result += 'g';
	}
	if (this.ignoreCase) {
		result += 'i';
	}
	if (this.multiline) {
		result += 'm';
	}
	if (this.dotAll) {
		result += 's';
	}
	if (this.unicode) {
		result += 'u';
	}
	if (this.sticky) {
		result += 'y';
	}
	return result;
};

if (functionsHaveConfigurableNames && Object.defineProperty) {
	Object.defineProperty(module.exports, 'name', { value: 'get flags' });
}


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(632);

var supportsDescriptors = __webpack_require__(203).supportsDescriptors;
var $gOPD = Object.getOwnPropertyDescriptor;

module.exports = function getPolyfill() {
	if (supportsDescriptors && (/a/mig).flags === 'gim') {
		var descriptor = $gOPD(RegExp.prototype, 'flags');
		if (
			descriptor
			&& typeof descriptor.get === 'function'
			&& typeof RegExp.prototype.dotAll === 'boolean'
			&& typeof RegExp.prototype.hasIndices === 'boolean'
		) {
			/* eslint getter-return: 0 */
			var calls = '';
			var o = {};
			Object.defineProperty(o, 'hasIndices', {
				get: function () {
					calls += 'd';
				}
			});
			Object.defineProperty(o, 'sticky', {
				get: function () {
					calls += 'y';
				}
			});
			if (calls === 'dy') {
				return descriptor.get;
			}
		}
	}
	return implementation;
};


/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__animation__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_axis_utils__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_scales_utils__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__axis_line__ = __webpack_require__(2279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__axis_ticks__ = __webpack_require__(2280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__axis_title__ = __webpack_require__(2281);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.













var defaultAnimatedProps = ['xRange', 'yRange', 'xDomain', 'yDomain', 'width', 'height', 'marginLeft', 'marginTop', 'marginRight', 'marginBottom', 'tickSize', 'tickTotal', 'tickSizeInner', 'tickSizeOuter'];

var LEFT = __WEBPACK_IMPORTED_MODULE_3__utils_axis_utils__["b" /* ORIENTATION */].LEFT,
    RIGHT = __WEBPACK_IMPORTED_MODULE_3__utils_axis_utils__["b" /* ORIENTATION */].RIGHT,
    TOP = __WEBPACK_IMPORTED_MODULE_3__utils_axis_utils__["b" /* ORIENTATION */].TOP,
    BOTTOM = __WEBPACK_IMPORTED_MODULE_3__utils_axis_utils__["b" /* ORIENTATION */].BOTTOM;


var propTypes = {
  orientation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([LEFT, RIGHT, TOP, BOTTOM]),
  attr: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  attrAxis: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  left: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  hideTicks: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hideLine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  on0: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tickLabelAngle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  tickSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  tickSizeInner: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  tickSizeOuter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  tickPadding: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  tickValues: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])),
  tickFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  tickTotal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  // Not expected to be used by the users.
  // TODO: Add underscore to these properties later.
  marginTop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  marginBottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  marginLeft: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  marginRight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  innerWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  innerHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

var defaultProps = {
  className: '',
  on0: false,
  style: {},
  tickSize: 6,
  tickPadding: 8,
  orientation: BOTTOM
};

var predefinedClassName = 'rv-xy-plot__axis';
var VERTICAL_CLASS_NAME = 'rv-xy-plot__axis--vertical';
var HORIZONTAL_CLASS_NAME = 'rv-xy-plot__axis--horizontal';

var Axis = function (_PureComponent) {
  _inherits(Axis, _PureComponent);

  function Axis() {
    _classCallCheck(this, Axis);

    return _possibleConstructorReturn(this, (Axis.__proto__ || Object.getPrototypeOf(Axis)).apply(this, arguments));
  }

  _createClass(Axis, [{
    key: '_getDefaultAxisProps',

    /**
     * Define the default values depending on the data passed from the outside.
     * @returns {*} Object of default properties.
     * @private
     */
    value: function _getDefaultAxisProps() {
      var _props = this.props,
          innerWidth = _props.innerWidth,
          innerHeight = _props.innerHeight,
          marginTop = _props.marginTop,
          marginBottom = _props.marginBottom,
          marginLeft = _props.marginLeft,
          marginRight = _props.marginRight,
          orientation = _props.orientation;

      if (orientation === BOTTOM) {
        return {
          tickTotal: Object(__WEBPACK_IMPORTED_MODULE_3__utils_axis_utils__["f" /* getTicksTotalFromSize */])(innerWidth),
          top: innerHeight + marginTop,
          left: marginLeft,
          width: innerWidth,
          height: marginBottom
        };
      } else if (orientation === TOP) {
        return {
          tickTotal: Object(__WEBPACK_IMPORTED_MODULE_3__utils_axis_utils__["f" /* getTicksTotalFromSize */])(innerWidth),
          top: 0,
          left: marginLeft,
          width: innerWidth,
          height: marginTop
        };
      } else if (orientation === LEFT) {
        return {
          tickTotal: Object(__WEBPACK_IMPORTED_MODULE_3__utils_axis_utils__["f" /* getTicksTotalFromSize */])(innerHeight),
          top: marginTop,
          left: 0,
          width: marginLeft,
          height: innerHeight
        };
      }
      return {
        tickTotal: Object(__WEBPACK_IMPORTED_MODULE_3__utils_axis_utils__["f" /* getTicksTotalFromSize */])(innerHeight),
        top: marginTop,
        left: marginLeft + innerWidth,
        width: marginRight,
        height: innerHeight
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var animation = this.props.animation;


      if (animation) {
        var animatedProps = animation.nonAnimatedProps ? defaultAnimatedProps.filter(function (prop) {
          return animation.nonAnimatedProps.indexOf(prop) < 0;
        }) : defaultAnimatedProps;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__animation__["b" /* default */],
          _extends({}, this.props, { animatedProps: animatedProps }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Axis, _extends({}, this.props, { animation: null }))
        );
      }

      var props = _extends({}, this._getDefaultAxisProps(), this.props);

      var attrAxis = props.attrAxis,
          className = props.className,
          height = props.height,
          hideLine = props.hideLine,
          hideTicks = props.hideTicks,
          left = props.left,
          marginTop = props.marginTop,
          on0 = props.on0,
          orientation = props.orientation,
          position = props.position,
          style = props.style,
          title = props.title,
          top = props.top,
          width = props.width;

      var isVertical = [LEFT, RIGHT].indexOf(orientation) > -1;
      var axisClassName = isVertical ? VERTICAL_CLASS_NAME : HORIZONTAL_CLASS_NAME;

      var leftPos = left;
      var topPos = top;
      if (on0) {
        var scale = Object(__WEBPACK_IMPORTED_MODULE_4__utils_scales_utils__["d" /* getAttributeScale */])(props, attrAxis);
        if (isVertical) {
          leftPos = scale(0);
        } else {
          topPos = marginTop + scale(0);
        }
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        {
          transform: 'translate(' + leftPos + ',' + topPos + ')',
          className: predefinedClassName + ' ' + axisClassName + ' ' + className,
          style: style
        },
        !hideLine && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__axis_line__["a" /* default */], {
          height: height,
          width: width,
          orientation: orientation,
          style: _extends({}, style, style.line)
        }),
        !hideTicks && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__axis_ticks__["a" /* default */], _extends({}, props, { style: _extends({}, style, style.ticks) })),
        title ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__axis_title__["a" /* default */], {
          position: position,
          title: title,
          height: height,
          width: width,
          style: _extends({}, style, style.title),
          orientation: orientation
        }) : null
      );
    }
  }]);

  return Axis;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Axis.displayName = 'Axis';
Axis.propTypes = propTypes;
Axis.defaultProps = defaultProps;
Axis.requiresSVG = true;

/* harmony default export */ __webpack_exports__["a"] = (Axis);

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__discrete_color_legend_item__ = __webpack_require__(2285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__theme__ = __webpack_require__(63);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.








function DiscreteColorLegend(_ref) {
  var className = _ref.className,
      colors = _ref.colors,
      height = _ref.height,
      items = _ref.items,
      onItemClick = _ref.onItemClick,
      onItemMouseEnter = _ref.onItemMouseEnter,
      onItemMouseLeave = _ref.onItemMouseLeave,
      orientation = _ref.orientation,
      style = _ref.style,
      width = _ref.width;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      className: 'rv-discrete-color-legend ' + orientation + ' ' + className,
      style: _extends({ width: width, height: height }, style)
    },
    items.map(function (item, i) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__discrete_color_legend_item__["a" /* default */], {
        title: item.title ? item.title : item,
        color: item.color ? item.color : colors[i % colors.length],
        strokeDasharray: item.strokeDasharray,
        strokeStyle: item.strokeStyle,
        strokeWidth: item.strokeWidth,
        disabled: Boolean(item.disabled),
        orientation: orientation,
        key: i,
        onClick: onItemClick ? function (e) {
          return onItemClick(item, i, e);
        } : null,
        onMouseEnter: onItemMouseEnter ? function (e) {
          return onItemMouseEnter(item, i, e);
        } : null,
        onMouseLeave: onItemMouseEnter ? function (e) {
          return onItemMouseLeave(item, i, e);
        } : null
      });
    })
  );
}

DiscreteColorLegend.displayName = 'DiscreteColorLegendItem';
DiscreteColorLegend.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  items: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element]).isRequired,
    color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  }), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element])).isRequired,
  onItemClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onItemMouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onItemMouseLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  orientation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['vertical', 'horizontal'])
};

DiscreteColorLegend.defaultProps = {
  className: '',
  colors: __WEBPACK_IMPORTED_MODULE_3__theme__["e" /* DISCRETE_COLOR_RANGE */],
  orientation: 'vertical'
};

/* harmony default export */ __webpack_exports__["a"] = (DiscreteColorLegend);

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = left;
/* harmony export (immutable) */ __webpack_exports__["d"] = right;
/* harmony export (immutable) */ __webpack_exports__["b"] = justify;
/* harmony export (immutable) */ __webpack_exports__["a"] = center;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(70);


function targetDepth(d) {
  return d.target.depth;
}

function left(node) {
  return node.depth;
}

function right(node, n) {
  return n - 1 - node.height;
}

function justify(node, n) {
  return node.sourceLinks.length ? node.depth : n - 1;
}

function center(node) {
  return node.targetLinks.length ? node.depth
      : node.sourceLinks.length ? Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["g" /* min */])(node.sourceLinks, targetDepth) - 1
      : 0;
}


/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cluster_js__ = __webpack_require__(2297);
/* unused harmony reexport cluster */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hierarchy_index_js__ = __webpack_require__(376);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__hierarchy_index_js__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pack_index_js__ = __webpack_require__(2309);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__pack_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pack_siblings_js__ = __webpack_require__(638);
/* unused harmony reexport packSiblings */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pack_enclose_js__ = __webpack_require__(639);
/* unused harmony reexport packEnclose */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__partition_js__ = __webpack_require__(2311);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_5__partition_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__stratify_js__ = __webpack_require__(2312);
/* unused harmony reexport stratify */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tree_js__ = __webpack_require__(2313);
/* unused harmony reexport tree */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__treemap_index_js__ = __webpack_require__(2314);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_8__treemap_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__treemap_binary_js__ = __webpack_require__(2315);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_9__treemap_binary_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__treemap_dice_js__ = __webpack_require__(204);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_10__treemap_dice_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__treemap_slice_js__ = __webpack_require__(266);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_11__treemap_slice_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__treemap_sliceDice_js__ = __webpack_require__(2316);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_12__treemap_sliceDice_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__treemap_squarify_js__ = __webpack_require__(378);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_13__treemap_squarify_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__treemap_resquarify_js__ = __webpack_require__(2317);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_14__treemap_resquarify_js__["a"]; });

















/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = packEnclose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enclose_js__ = __webpack_require__(639);


function place(b, a, c) {
  var dx = b.x - a.x, x, a2,
      dy = b.y - a.y, y, b2,
      d2 = dx * dx + dy * dy;
  if (d2) {
    a2 = a.r + c.r, a2 *= a2;
    b2 = b.r + c.r, b2 *= b2;
    if (a2 > b2) {
      x = (d2 + b2 - a2) / (2 * d2);
      y = Math.sqrt(Math.max(0, b2 / d2 - x * x));
      c.x = b.x - x * dx - y * dy;
      c.y = b.y - x * dy + y * dx;
    } else {
      x = (d2 + a2 - b2) / (2 * d2);
      y = Math.sqrt(Math.max(0, a2 / d2 - x * x));
      c.x = a.x + x * dx - y * dy;
      c.y = a.y + x * dy + y * dx;
    }
  } else {
    c.x = a.x + c.r;
    c.y = a.y;
  }
}

function intersects(a, b) {
  var dr = a.r + b.r - 1e-6, dx = b.x - a.x, dy = b.y - a.y;
  return dr > 0 && dr * dr > dx * dx + dy * dy;
}

function score(node) {
  var a = node._,
      b = node.next._,
      ab = a.r + b.r,
      dx = (a.x * b.r + b.x * a.r) / ab,
      dy = (a.y * b.r + b.y * a.r) / ab;
  return dx * dx + dy * dy;
}

function Node(circle) {
  this._ = circle;
  this.next = null;
  this.previous = null;
}

function packEnclose(circles) {
  if (!(n = circles.length)) return 0;

  var a, b, c, n, aa, ca, i, j, k, sj, sk;

  // Place the first circle.
  a = circles[0], a.x = 0, a.y = 0;
  if (!(n > 1)) return a.r;

  // Place the second circle.
  b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
  if (!(n > 2)) return a.r + b.r;

  // Place the third circle.
  place(b, a, c = circles[2]);

  // Initialize the front-chain using the first three circles a, b and c.
  a = new Node(a), b = new Node(b), c = new Node(c);
  a.next = c.previous = b;
  b.next = a.previous = c;
  c.next = b.previous = a;

  // Attempt to place each remaining circle…
  pack: for (i = 3; i < n; ++i) {
    place(a._, b._, c = circles[i]), c = new Node(c);

    // Find the closest intersecting circle on the front-chain, if any.
    // “Closeness” is determined by linear distance along the front-chain.
    // “Ahead” or “behind” is likewise determined by linear distance.
    j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
    do {
      if (sj <= sk) {
        if (intersects(j._, c._)) {
          b = j, a.next = b, b.previous = a, --i;
          continue pack;
        }
        sj += j._.r, j = j.next;
      } else {
        if (intersects(k._, c._)) {
          a = k, a.next = b, b.previous = a, --i;
          continue pack;
        }
        sk += k._.r, k = k.previous;
      }
    } while (j !== k.next);

    // Success! Insert the new circle c between a and b.
    c.previous = a, c.next = b, a.next = b.previous = b = c;

    // Compute the new closest circle pair to the centroid.
    aa = score(a);
    while ((c = c.next) !== b) {
      if ((ca = score(c)) < aa) {
        a = c, aa = ca;
      }
    }
    b = a.next;
  }

  // Compute the enclosing circle of the front chain.
  a = [b._], c = b; while ((c = c.next) !== b) a.push(c._); c = Object(__WEBPACK_IMPORTED_MODULE_0__enclose_js__["a" /* default */])(a);

  // Translate the circles to put the enclosing circle around the origin.
  for (i = 0; i < n; ++i) a = circles[i], a.x -= c.x, a.y -= c.y;

  return c.r;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(circles) {
  packEnclose(circles);
  return circles;
});


/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array_js__ = __webpack_require__(2310);


/* harmony default export */ __webpack_exports__["a"] = (function(circles) {
  var i = 0, n = (circles = Object(__WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* shuffle */])(__WEBPACK_IMPORTED_MODULE_0__array_js__["b" /* slice */].call(circles))).length, B = [], p, e;

  while (i < n) {
    p = circles[i];
    if (e && enclosesWeak(e, p)) ++i;
    else e = encloseBasis(B = extendBasis(B, p)), i = 0;
  }

  return e;
});

function extendBasis(B, p) {
  var i, j;

  if (enclosesWeakAll(p, B)) return [p];

  // If we get here then B must have at least one element.
  for (i = 0; i < B.length; ++i) {
    if (enclosesNot(p, B[i])
        && enclosesWeakAll(encloseBasis2(B[i], p), B)) {
      return [B[i], p];
    }
  }

  // If we get here then B must have at least two elements.
  for (i = 0; i < B.length - 1; ++i) {
    for (j = i + 1; j < B.length; ++j) {
      if (enclosesNot(encloseBasis2(B[i], B[j]), p)
          && enclosesNot(encloseBasis2(B[i], p), B[j])
          && enclosesNot(encloseBasis2(B[j], p), B[i])
          && enclosesWeakAll(encloseBasis3(B[i], B[j], p), B)) {
        return [B[i], B[j], p];
      }
    }
  }

  // If we get here then something is very wrong.
  throw new Error;
}

function enclosesNot(a, b) {
  var dr = a.r - b.r, dx = b.x - a.x, dy = b.y - a.y;
  return dr < 0 || dr * dr < dx * dx + dy * dy;
}

function enclosesWeak(a, b) {
  var dr = a.r - b.r + 1e-6, dx = b.x - a.x, dy = b.y - a.y;
  return dr > 0 && dr * dr > dx * dx + dy * dy;
}

function enclosesWeakAll(a, B) {
  for (var i = 0; i < B.length; ++i) {
    if (!enclosesWeak(a, B[i])) {
      return false;
    }
  }
  return true;
}

function encloseBasis(B) {
  switch (B.length) {
    case 1: return encloseBasis1(B[0]);
    case 2: return encloseBasis2(B[0], B[1]);
    case 3: return encloseBasis3(B[0], B[1], B[2]);
  }
}

function encloseBasis1(a) {
  return {
    x: a.x,
    y: a.y,
    r: a.r
  };
}

function encloseBasis2(a, b) {
  var x1 = a.x, y1 = a.y, r1 = a.r,
      x2 = b.x, y2 = b.y, r2 = b.r,
      x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1,
      l = Math.sqrt(x21 * x21 + y21 * y21);
  return {
    x: (x1 + x2 + x21 / l * r21) / 2,
    y: (y1 + y2 + y21 / l * r21) / 2,
    r: (l + r1 + r2) / 2
  };
}

function encloseBasis3(a, b, c) {
  var x1 = a.x, y1 = a.y, r1 = a.r,
      x2 = b.x, y2 = b.y, r2 = b.r,
      x3 = c.x, y3 = c.y, r3 = c.r,
      a2 = x1 - x2,
      a3 = x1 - x3,
      b2 = y1 - y2,
      b3 = y1 - y3,
      c2 = r2 - r1,
      c3 = r3 - r1,
      d1 = x1 * x1 + y1 * y1 - r1 * r1,
      d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2,
      d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3,
      ab = a3 * b2 - a2 * b3,
      xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1,
      xb = (b3 * c2 - b2 * c3) / ab,
      ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1,
      yb = (a2 * c3 - a3 * c2) / ab,
      A = xb * xb + yb * yb - 1,
      B = 2 * (r1 + xa * xb + ya * yb),
      C = xa * xa + ya * ya - r1 * r1,
      r = -(A ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
  return {
    x: x1 + xa + xb * r,
    y: y1 + ya + yb * r,
    r: r
  };
}


/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = constantZero;
function constantZero() {
  return 0;
}

/* harmony default export */ __webpack_exports__["b"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(node) {
  node.x0 = Math.round(node.x0);
  node.y0 = Math.round(node.y0);
  node.x1 = Math.round(node.x1);
  node.y1 = Math.round(node.y1);
});


/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Input__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Chip__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Chip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Chip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_apollo_Query__ = __webpack_require__(2330);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query {\n    getAllLicenseType(status: 1) {\n      id\n      licenseType\n    }\n  }\n'],['\n  query {\n    getAllLicenseType(status: 1) {\n      id\n      licenseType\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query {\n    models: allDeviceModels(status: 1) {\n      id\n      model_name\n    }\n  }\n'],['\n  query {\n    models: allDeviceModels(status: 1) {\n      id\n      model_name\n    }\n  }\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_ALL_LICENCES=Object(__WEBPACK_IMPORTED_MODULE_9_graphql_tag__["a" /* default */])(_templateObject);var GET_MODELS=Object(__WEBPACK_IMPORTED_MODULE_9_graphql_tag__["a" /* default */])(_templateObject2);var styles=function styles(theme){return{root:{display:'flex',flexWrap:'wrap'},formControl:{margin:theme.spacing.unit,minWidth:'100%',maxWidth:700},chips:{display:'flex',flexWrap:'wrap'},chip:{margin:theme.spacing.unit/4},noLabel:{marginTop:theme.spacing.unit*3}};};var ITEM_HEIGHT=48;var ITEM_PADDING_TOP=8;var MenuProps={PaperProps:{style:{maxHeight:ITEM_HEIGHT*4.5+ITEM_PADDING_TOP,width:250}}// function getStyles(name, that) {
//   return {
//     fontWeight:
//       that.state.name.indexOf(name) === -1
//         ? that.props.theme.typography.fontWeightRegular
//         : that.props.theme.typography.fontWeightMedium
//   }
// }
};var LicensesList=function(_React$Component){_inherits(LicensesList,_React$Component);function LicensesList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,LicensesList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=LicensesList.__proto__||Object.getPrototypeOf(LicensesList)).call.apply(_ref,[this].concat(args))),_this),_this.state={name:[]},_this.handleChange=function(event){_this.setState({name:event.target.value});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(LicensesList,[{key:'render',value:function render(){var _this2=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_apollo_Query__["a" /* default */],{query:GET_MODELS},function(_ref2){var isModelsLoading=_ref2.loading,error=_ref2.error,models=_ref2.data.models;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_apollo_Query__["a" /* default */],{query:GET_ALL_LICENCES},function(_ref3){var loading=_ref3.loading,error=_ref3.error,data=_ref3.data;if(loading||isModelsLoading)return'Loading';if(error)return'Error!: '+error;var licenseDetails=data.getAllLicenseType;// console.log('licenseDetails', data)
return(// <div>Test</div>
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormControl___default.a,{className:classes.formControl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_InputLabel___default.a,{htmlFor:'select-multiple-chip'},'Select Licenses *'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select___default.a,{multiple:true,value:_this2.props.licenseId,onChange:_this2.props.handleChangeLicense,input:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Input___default.a,{id:'select-multiple-chip'}),renderValue:function renderValue(selected){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.chips},selected.map(function(value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Chip___default.a,{key:value.id,label:value.licenseType,className:classes.chip});}));},MenuProps:MenuProps},licenseDetails.map(function(name){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_MenuItem___default.a,{key:name.id,value:name// style={getStyles(name.id, this)}
},name.licenseType);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormControl___default.a,{className:classes.formControl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_InputLabel___default.a,{htmlFor:'select-multiple-chip'},'Select Models *'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select___default.a,{multiple:true,value:_this2.props.modelName,onChange:_this2.props.handleChangeModels,input:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Input___default.a,{id:'select-multiple-chip'}),renderValue:function renderValue(selected){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.chips},selected.map(function(value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Chip___default.a,{key:value.id,label:value.model_name,className:classes.chip});}));},MenuProps:MenuProps},models.map(function(name){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_MenuItem___default.a,{key:name.id,value:name// style={getStyles(name.id, this)}
},name.model_name);})))));});});}}]);return LicensesList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);LicensesList.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__["withStyles"])(styles)(LicensesList));

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Dialog__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Loader__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_icons_ArrowBack__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_icons_ArrowBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_ArrowBack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__EditDevice__ = __webpack_require__(2350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_getAccountType_js__ = __webpack_require__(68);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getAllDeviceDetailsByLoginId(\n    $loginId: Int!\n    $accountType: String!\n    $deviceModelId: Int!\n  ) {\n    devices: getAllDeviceDetailsByLoginId(\n      loginId: $loginId\n      accountType: $accountType\n      deviceModelId: $deviceModelId\n    ) {\n      serial_num\n      imei_num\n      uniqueDeviceId\n      status\n    }\n  }\n'],['\n  query getAllDeviceDetailsByLoginId(\n    $loginId: Int!\n    $accountType: String!\n    $deviceModelId: Int!\n  ) {\n    devices: getAllDeviceDetailsByLoginId(\n      loginId: $loginId\n      accountType: $accountType\n      deviceModelId: $deviceModelId\n    ) {\n      serial_num\n      imei_num\n      uniqueDeviceId\n      status\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query getAllDeviceDetailsByLoginId(\n    $loginId: Int!\n    $accountType: String!\n    $deviceModelId: Int!\n  ) {\n    devices: getAllDeviceDetailsByLoginId(\n      loginId: $loginId\n      accountType: $accountType\n      deviceModelId: $deviceModelId\n    ) {\n      serial_num\n      imei_num\n      uniqueDeviceId\n      status\n      clientName\n      vehicleDetail {\n        vehicleNumber\n      }\n    }\n  }\n'],['\n  query getAllDeviceDetailsByLoginId(\n    $loginId: Int!\n    $accountType: String!\n    $deviceModelId: Int!\n  ) {\n    devices: getAllDeviceDetailsByLoginId(\n      loginId: $loginId\n      accountType: $accountType\n      deviceModelId: $deviceModelId\n    ) {\n      serial_num\n      imei_num\n      uniqueDeviceId\n      status\n      clientName\n      vehicleDetail {\n        vehicleNumber\n      }\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var style=function style(theme){var _root;return{root:(_root={padding:theme.spacing.unit*4},_defineProperty(_root,theme.breakpoints.down('sm'),{padding:theme.spacing.unit*2}),_defineProperty(_root,'flexGrow',1),_root),paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},iconSmall:{fontSize:20}};};var GET_DEVICE_LIST_BASIC=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject);var GET_DEVICE_LIST_WITH_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject2);var ViewInventoryDevices=function(_Component){_inherits(ViewInventoryDevices,_Component);function ViewInventoryDevices(props){var _this2=this;_classCallCheck(this,ViewInventoryDevices);var _this=_possibleConstructorReturn(this,(ViewInventoryDevices.__proto__||Object.getPrototypeOf(ViewInventoryDevices)).call(this,props));_this.clientId=[];_this.getColumns=function(){if(_this.state.includeClientVehicleDetails){return['SERIAL NO','IMEI NO','UNIQUE ID','STATUS','VEHICLE NO','CLIENT NAME','PARTNER NAME'];}else{return['SERIAL NO','IMEI NO','UNIQUE ID','STATUS','PARTNER NAME'];}};_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:25,onRowClick:function onRowClick(rowData,dataIndex,rowIndex){console.log(_this.status[dataIndex.dataIndex],'di');if(_this.status[dataIndex.dataIndex]===2){_this.editDevice(_this.uniqueDeviceId[dataIndex.dataIndex]);}else{_this.props.openSnackbar('Device cannot be edited');}}};_this.state={open:false,open1:false,openEdit:false,selUniqueDeviceId:'',devicesData:[],loading:false,// Changed to false initially so we don't show loader before dialog choice
fetchOptionsDialogOpen:false,includeClientVehicleDetails:false};_this.componentDidMount=function(){// Check if we have state passed from previous page
if(_this.props.location.state&&typeof _this.props.location.state.includeClientVehicleDetails!=='undefined'){_this.setState({includeClientVehicleDetails:_this.props.location.state.includeClientVehicleDetails,loading:true},function(){_this.fetchDevicesData();});}else{// Fallback: show dialog if accessed directly (though typically it should come from the listing page)
_this.setState({fetchOptionsDialogOpen:true});}};_this.editDevice=function(uniqueDeviceId){// console.log(uniqueDeviceId, 'demo')
_this.setState({selUniqueDeviceId:uniqueDeviceId},function(){console.log(_this.state.selUniqueDeviceId,'uid');});_this.handleClickOpen();};_this.handleClickOpen=function(){_this.setState({openEdit:true});};_this.handleClose=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:console.log('Cancel');_context.next=3;return _this.fetchDevicesData();case 3:_this.setState({openEdit:false,open:false});case 4:case'end':return _context.stop();}}},_callee,_this2);}));_this.getStatus=function(status){if(status===2){return'Instock';}else if(status===3){return'Assigned to Client';}else if(status===4){return'Registered to vehicle';}};_this.handleClickOpen=function(){_this.setState({open:true});};_this.handleCloseFetchOptionsDialog=function(){_this.setState({fetchOptionsDialogOpen:false});_this.props.history.goBack();};_this.handleFetchData=function(){_this.setState({fetchOptionsDialogOpen:false,loading:true},function(){_this.fetchDevicesData();});};_this.handleClickBulkOpen=function(){_this.setState({open1:true});};_this.handleBulkClose=function(){_this.setState({open1:false});};_this.addBulkUpload=function(e){_this.props.history.push({pathname:'/home/DeviceInventory/BulkUpload'});};_this.assignBulkUpload=function(e){console.log('bulk');_this.props.history.push({pathname:'/home/DeviceInventory/BulkDeviceAssign'});};_this.fetchDevicesData=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var query,_ref3,loading,error,devices;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:console.log('Called');query=_this.state.includeClientVehicleDetails?GET_DEVICE_LIST_WITH_DETAILS:GET_DEVICE_LIST_BASIC;_context2.next=4;return _this.props.client.query({query:query,variables:{loginId:Object(__WEBPACK_IMPORTED_MODULE_9__utils_getLoginId__["a" /* default */])(),accountType:localStorage.getItem('Account_type'),deviceModelId:parseInt(_this.props.match.params.modelId,10)},fetchPolicy:'network-only'});case 4:_ref3=_context2.sent;loading=_ref3.loading;error=_ref3.error;devices=_ref3.data.devices;_this.setState({devicesData:_this.mapToArr(devices),loading:false});case 9:case'end':return _context2.stop();}}},_callee2,_this2);}));_this.classes=props;return _this;}_createClass(ViewInventoryDevices,[{key:'mapToArr',value:function mapToArr(devices){var _this3=this;var rowData=[];var fullData=[];this.status=[];this.uniqueDeviceId=[];devices.forEach(function(element){rowData=[];_this3.status.push(element.status);_this3.uniqueDeviceId.push(element.uniqueDeviceId);rowData.push(element.serial_num);rowData.push(element.imei_num);rowData.push(element.uniqueDeviceId);rowData.push(_this3.getStatus(element.status));if(_this3.state.includeClientVehicleDetails){element.vehicleDetail?rowData.push(element.vehicleDetail.vehicleNumber):rowData.push('N/A');element.clientName?rowData.push(element.clientName):rowData.push('N/A');}rowData.push('Taabi Mobility Private Limited');fullData.push(rowData);});// console.log(this.status, this.uniqueDeviceId, 'jj')
return fullData;}// handleClose = () => {
//   this.setState({ open: false }, this.fetchDevicesData())
// }
},{key:'render',value:function render(){var _this4=this;var classes=this.props.classes;var _state=this.state,loading=_state.loading,devicesData=_state.devicesData;return(// <Query
//   query={GET_DEVICE_LIST}
//   variables={{
//     loginId: getLoginId(),
//     accountType: localStorage.getItem('Account_type'),
//     deviceModelId: parseInt(this.props.match.params.modelId, 10)
//   }}
//   fetchPolicy="network-only"
// >
//   {({ loading, error, data: { devices } }) => {
//     if (loading) return <Loader />
//     if (error) return `Error!: ${error}`
//     const data = this.mapToArr(devices)
//     // console.log('devices', devices)
//     return (
__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__common_Loader__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Dialog___default.a,{open:this.state.open,onClose:this.handleClose,'aria-labelledby':'form-dialog-title'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Button___default.a,{variant:'outlined',color:'secondary',className:classes.button,onClick:function onClick(){return _this4.props.history.goBack();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_ArrowBack___default.a,{className:classes.iconSmall}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'headline'},'Device Details')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Dialog___default.a,{open:this.state.open,onClose:this.handleClose,'aria-labelledby':'form-dialog-title'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__EditDevice__["a" /* default */],{handleClose:this.handleClose,selUniqueDecviceId:this.state.selUniqueDeviceId,fetchDevicesData:this.fetchDevicesData})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_mui_datatables___default.a,{data:devicesData,columns:this.getColumns(),options:this.options}))))));}}]);return ViewInventoryDevices;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_13__HOCs_withSharedSnackbar__["a" /* default */])(ViewInventoryDevices))));

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var style=function style(theme){return{root:{padding:theme.spacing.unit*4,flexGrow:1,backgroundColor:theme.palette.background.paper},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},iconSmall:{fontSize:20},selectStyle:{margin:theme.spacing.unit,minWidth:250},textField:{marginLeft:theme.spacing.unit,marginRight:theme.spacing.unit,minWidth:250},pad:{padding:theme.spacing.unit*2}};};var PaymentMethod=function(_Component){_inherits(PaymentMethod,_Component);function PaymentMethod(){_classCallCheck(this,PaymentMethod);return _possibleConstructorReturn(this,(PaymentMethod.__proto__||Object.getPrototypeOf(PaymentMethod)).apply(this,arguments));}_createClass(PaymentMethod,[{key:'render',value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.paymentThrough==='ONLINE'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row',justify:'center',alignItems:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_TextField___default.a,{id:'outlined-uncontrolled',label:'Trasaction ID',className:classes.textField,margin:'normal',variant:'outlined',value:this.props.referenceNumber,onChange:this.props.handleChangereferenceNumber})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_TextField___default.a,{id:'outlined-uncontrolled',label:'Amount',className:classes.textField,margin:'normal',variant:'outlined',value:this.props.paidMoney,onChange:this.props.handleChangePaidMoney}))))||this.props.paymentThrough==='CASH'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row',justify:'flex-start',alignItems:'flex-start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_TextField___default.a,{id:'outlined-uncontrolled',label:'Amount',className:classes.textField,margin:'normal',variant:'outlined',value:this.props.paidMoney,onChange:this.props.handleChangePaidMoney}))))||this.props.paymentThrough==='CHEQUE'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row',justify:'flex-start',alignItems:'flex-start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_TextField___default.a,{id:'outlined-uncontrolled',label:'Cheque No.',className:classes.textField,margin:'normal',variant:'outlined',value:this.props.referenceNumber,onChange:this.props.handleChangereferenceNumber})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_TextField___default.a,{id:'outlined-uncontrolled',label:'Bank Name',className:classes.textField,margin:'normal',variant:'outlined',value:this.props.bankName,onChange:this.props.handleChangeBankName})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_TextField___default.a,{id:'outlined-uncontrolled',label:'Amount',className:classes.textField,margin:'normal',variant:'outlined',value:this.props.paidMoney,onChange:this.props.handleChangePaidMoney}))))||this.props.paymentThrough==='DD'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row',justify:'flex-start',alignItems:'flex-start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_TextField___default.a,{id:'outlined-uncontrolled',label:'DD No.',className:classes.textField,margin:'normal',variant:'outlined',value:this.props.referenceNumber,onChange:this.props.handleChangereferenceNumber})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_TextField___default.a,{id:'outlined-uncontrolled',label:'Bank Name',className:classes.textField,margin:'normal',variant:'outlined',value:this.props.bankName,onChange:this.props.handleChangeBankName})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_TextField___default.a,{id:'outlined-uncontrolled',label:'Amount',className:classes.textField,margin:'normal',variant:'outlined',value:this.props.paidMoney,onChange:this.props.handleChangePaidMoney})))));}}]);return PaymentMethod;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__["withStyles"])(style)(PaymentMethod));

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_ArrowBack__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_ArrowBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_ArrowBack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Loader__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_ConfirmationDialog__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_transition_group_Transition__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_transition_group_Transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_transition_group_Transition__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  mutation(\n    $partnerLoginId: Int!\n    $billingModeId: Int!\n    $billingFrequencyId: Int!\n    $mmtc: Int!\n    $noOfDevices: Int!\n    $subscriptionId: Int\n    $salesRemarks: String\n  ) {\n    createPartnerSubscription(\n      partnerLoginId: $partnerLoginId\n      billingModeId: $billingModeId\n      billingFrequencyId: $billingFrequencyId\n\n      mmtc: $mmtc\n      noOfDevices: $noOfDevices\n      subscriptionId: $subscriptionId\n      salesRemarks: $salesRemarks\n    )\n  }\n'],['\n  mutation(\n    $partnerLoginId: Int!\n    $billingModeId: Int!\n    $billingFrequencyId: Int!\n    $mmtc: Int!\n    $noOfDevices: Int!\n    $subscriptionId: Int\n    $salesRemarks: String\n  ) {\n    createPartnerSubscription(\n      partnerLoginId: $partnerLoginId\n      billingModeId: $billingModeId\n      billingFrequencyId: $billingFrequencyId\n\n      mmtc: $mmtc\n      noOfDevices: $noOfDevices\n      subscriptionId: $subscriptionId\n      salesRemarks: $salesRemarks\n    )\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  mutation createPartnerSubscription(\n    $partnerLoginId: Int!\n    $billingFrequencyId: Int!\n    $GST: Float!\n    $deviceModelId: Int!\n    $hardwareQty: Int!\n    $hardwareCharges: Int!\n    $softwareQty: Int!\n    $softwareTrackingCharges: Int!\n    $serviceProviderId: Int\n    $simQty: Int!\n    $simCharges: Int!\n    $accessoryTypeId: Int\n    $accessoryQty: Int!\n    $accessoryCharges: Int!\n    $salesRemarks: String\n  ) {\n    createPartnerSubscription(\n      partnerLoginId: $partnerLoginId\n      billingFrequencyId: $billingFrequencyId\n      GST: $GST\n      deviceModelId: $deviceModelId\n      hardwareQty: $hardwareQty\n      hardwareCharges: $hardwareCharges\n      softwareQty: $softwareQty\n      softwareTrackingCharges: $softwareTrackingCharges\n      serviceProviderId: $serviceProviderId\n      simQty: $simQty\n      simCharges: $simCharges\n      accessoryTypeId: $accessoryTypeId\n      accessoryQty: $accessoryQty\n      accessoryCharges: $accessoryCharges\n      salesRemarks: $salesRemarks\n    )\n  }\n'],['\n  mutation createPartnerSubscription(\n    $partnerLoginId: Int!\n    $billingFrequencyId: Int!\n    $GST: Float!\n    $deviceModelId: Int!\n    $hardwareQty: Int!\n    $hardwareCharges: Int!\n    $softwareQty: Int!\n    $softwareTrackingCharges: Int!\n    $serviceProviderId: Int\n    $simQty: Int!\n    $simCharges: Int!\n    $accessoryTypeId: Int\n    $accessoryQty: Int!\n    $accessoryCharges: Int!\n    $salesRemarks: String\n  ) {\n    createPartnerSubscription(\n      partnerLoginId: $partnerLoginId\n      billingFrequencyId: $billingFrequencyId\n      GST: $GST\n      deviceModelId: $deviceModelId\n      hardwareQty: $hardwareQty\n      hardwareCharges: $hardwareCharges\n      softwareQty: $softwareQty\n      softwareTrackingCharges: $softwareTrackingCharges\n      serviceProviderId: $serviceProviderId\n      simQty: $simQty\n      simCharges: $simCharges\n      accessoryTypeId: $accessoryTypeId\n      accessoryQty: $accessoryQty\n      accessoryCharges: $accessoryCharges\n      salesRemarks: $salesRemarks\n    )\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query partnerDetail($loginId: Int) {\n    partnerDetail(loginId: $loginId) {\n      id\n      billingMode {\n        id\n        billingMode\n      }\n    }\n  }\n'],['\n  query partnerDetail($loginId: Int) {\n    partnerDetail(loginId: $loginId) {\n      id\n      billingMode {\n        id\n        billingMode\n      }\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query getAllBillingFrequency($billingModeId: Int!) {\n    billingFrequencies: getAllBillingFrequency(billingModeId: $billingModeId) {\n      id\n      frequency\n      billingModeId\n      numberOfMonths\n    }\n  }\n'],['\n  query getAllBillingFrequency($billingModeId: Int!) {\n    billingFrequencies: getAllBillingFrequency(billingModeId: $billingModeId) {\n      id\n      frequency\n      billingModeId\n      numberOfMonths\n    }\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  query {\n    deviceModel: allDeviceModels {\n      id\n      model_name\n    }\n  }\n'],['\n  query {\n    deviceModel: allDeviceModels {\n      id\n      model_name\n    }\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  query {\n    accessoryDetails: getAllAccessoryTypes {\n      id\n      accessoryName\n    }\n  }\n'],['\n  query {\n    accessoryDetails: getAllAccessoryTypes {\n      id\n      accessoryName\n    }\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  query {\n    simDetails: allServiceProviders {\n      id\n      name\n    }\n  }\n'],['\n  query {\n    simDetails: allServiceProviders {\n      id\n      name\n    }\n  }\n']);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_OR_EDIT_SUBSCRIPTION=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject);var CREATE_PARTNER_SUBSCRIPTION=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject2);var GET_PARTNER_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject3);var GET_BILLING_FREQUENCIES=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject4);var GET_DEVICE_MODELS=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject5);var GET_ACCESSORY=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject6);var GET_SIM_PROVIDER=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject7);var styles=function styles(theme){return{container:{padding:theme.spacing.unit*2},formContainer:{marginTop:theme.spacing.unit*2},selectSytle:{width:'80%'},dropdown:{maxWidth:'100%',width:300}};};var SubscriptionForm=function(_Component){_inherits(SubscriptionForm,_Component);function SubscriptionForm(props){var _this2=this;_classCallCheck(this,SubscriptionForm);var _this=_possibleConstructorReturn(this,(SubscriptionForm.__proto__||Object.getPrototypeOf(SubscriptionForm)).call(this,props));_this.handleSaveClick=function(e){_this.setState({isSaveConfDialogOpen:true});};_this.handleCancelClick=function(e){_this.setState({isCancelConfDialogOpen:true});};_this.handleSaveNegativeResponse=function(e){_this.setState({isSaveConfDialogOpen:false});_this.setState({isSaveBtnDisabled:false});};_this.handleCancelNegativeResponse=function(e){_this.setState({isCancelConfDialogOpen:false});};_this.handleSaveSubscription=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _ref2,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:// console.log('save', this.state.salesRemarks)
// console.log(this.state.simModel, 'acc')
// console.log('inputs=', this.state.accessoryId, this.state.accessoryQuantity)
_this.setState({isSaveBtnDisabled:true});if(!(parseInt(_this.state.hardwareQuantity,10)!==parseInt(_this.state.softwareQuantity,10))){_context.next=5;break;}_this.props.openSnackbar('The Software Quantity and Device Quantity Should Be Equal');_context.next=46;break;case 5:if(!(_this.state.hardwareQuantity<1)){_context.next=9;break;}_this.props.openSnackbar('Device quantity should be greater than 0');_context.next=46;break;case 9:if(!(_this.state.softwareTrackingCharges<1)){_context.next=13;break;}_this.props.openSnackbar('Software amount should be greater than 0');_context.next=46;break;case 13:if(!(_this.state.deviceModelId===0||_this.state.deviceModelId==='')){_context.next=17;break;}_this.props.openSnackbar('Please Select Device Model');_context.next=46;break;case 17:if(!(_this.state.simProviderId!==0&&_this.state.simProviderId!==''&&(_this.state.simQuantity<1||_this.state.simQuantity===0||_this.state.simQuantity===''))){_context.next=21;break;}_this.props.openSnackbar('Select valid quantity for Sim');// } else if (
//   this.state.simProviderId !== 0 &&
//   this.state.simProviderId !== '' &&
//   this.state.simQuantity > 0 &&
//   (this.state.simCharges < 1 || this.state.simCharges === '')
// ) {
//   this.props.openSnackbar('Select valid Price for Sim')
// }
_context.next=46;break;case 21:if(!(_this.state.accessoryId!==0&&_this.state.accessoryId!==''&&(_this.state.accessoryQuantity<1||_this.state.accessoryQuantity===0||_this.state.accessoryQuantity===''))){_context.next=25;break;}// console.log('Select valid quantity for Accessory')
_this.props.openSnackbar('Select valid quantity for Accessory');_context.next=46;break;case 25:if(!((_this.state.simProviderId===0||_this.state.simProviderId==='')&&(_this.state.simQuantity>0||_this.state.simQuantity!==0&&_this.state.simQuantity!==''))){_context.next=29;break;}_this.props.openSnackbar('Please Select Sim Provider');_context.next=46;break;case 29:if(!((_this.state.accessoryId===0||_this.state.accessoryId==='')&&(_this.state.accessoryQuantity>0||_this.state.accessoryQuantity!==0&&_this.state.accessoryQuantity!==''))){_context.next=33;break;}_this.props.openSnackbar('Please Select Accessory Model');_context.next=46;break;case 33:_context.next=35;return _this.props.client.mutate({mutation:CREATE_PARTNER_SUBSCRIPTION,variables:{partnerLoginId:_this.partnerLoginId,billingFrequencyId:parseInt(_this.state.billingFrequency,10),GST:parseInt(_this.state.gstRate,10),deviceModelId:parseInt(_this.state.deviceModelId,10),accessoryTypeId:parseInt(_this.state.accessoryId,10),serviceProviderId:parseInt(_this.state.simProviderId,10),hardwareQty:parseInt(_this.state.hardwareQuantity,10),accessoryQty:parseInt(_this.state.accessoryQuantity,10),simQty:parseInt(_this.state.simQuantity,10),softwareQty:parseInt(_this.state.softwareQuantity,10),softwareTrackingCharges:parseInt(_this.state.softwareTrackingCharges,10),simCharges:parseInt(_this.state.simCharges,10),hardwareCharges:parseInt(_this.state.hardwareCharges,10),accessoryCharges:parseInt(_this.state.accessoryCharges,10),salesRemarks:_this.state.salesRemarks}});case 35:_ref2=_context.sent;data=_ref2.data;if(!(data.createPartnerSubscription===true)){_context.next=45;break;}_context.next=40;return _this.props.client.clearStore();case 40:_this.props.openSnackbar('Subscription Creation Successful');_this.setState({isSaveConfDialogOpen:false});_this.props.history.push({pathname:'/home/partner/view/'+_this.partnerLoginId});_context.next=46;break;case 45:_this.props.openSnackbar('Subscription Creation Failed');case 46:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.handleCancelSubscription=function(e){// this.setState({
//   billingMode: null,
//   billingFrequency: null,
//   billingFrequencies: null,
//   totalQuantity: null,
//   totalAmount: null,
//   deviceModel: null,
//   deviceQuantity: null,
//   accessoryModel: null,
//   accessoryQuantity: null,
//   simModel: null,
//   simQuantity: null,
//   grandTotalAmount: null,
//   PIBucketName: null,
//   PIFileName: null
// })
_this.props.history.goBack();};_this.handleInputChange=function(name){return function(e){_this.setState(_defineProperty({},name,e.target.value)// console.log('gfhgf', this.state.salesRemarks)
);};};_this.handleChange=function(name){return function(event){if(event.target.value>=0){_this.setState(_defineProperty({},name,event.target.value),function(){if(name==='softwareQuantity'||name==='softwareTrackingCharges'){var _this$state=_this.state,softwareQuantity=_this$state.softwareQuantity,softwareTrackingCharges=_this$state.softwareTrackingCharges;_this.calculateAmount(softwareQuantity,softwareTrackingCharges,name);}if(name==='hardwareQuantity'||name==='hardwareCharges'){var _this$state2=_this.state,hardwareQuantity=_this$state2.hardwareQuantity,hardwareCharges=_this$state2.hardwareCharges;_this.calculateAmount(hardwareQuantity,hardwareCharges,name);}if(name==='accessoryQuantity'||name==='accessoryCharges'){var _this$state3=_this.state,accessoryQuantity=_this$state3.accessoryQuantity,accessoryCharges=_this$state3.accessoryCharges;_this.calculateAmount(accessoryQuantity,accessoryCharges,name);}if(name==='simQuantity'||name==='simCharges'){var _this$state4=_this.state,simQuantity=_this$state4.simQuantity,simCharges=_this$state4.simCharges;_this.calculateAmount(simQuantity,simCharges,name);}});}else if(!event.target.value){if(name==='softwareQuantity'||name==='softwareTrackingCharges'){var _this$setState3;_this.setState((_this$setState3={},_defineProperty(_this$setState3,name,null),_defineProperty(_this$setState3,'totalAmountSoftware',null),_this$setState3));}if(name==='hardwareQuantity'||name==='hardwareCharges'){var _this$setState4;_this.setState((_this$setState4={},_defineProperty(_this$setState4,name,null),_defineProperty(_this$setState4,'totalAmountHardware',null),_this$setState4));}if(name==='accessoryQuantity'||name==='accessoryCharges'){var _this$setState5;_this.setState((_this$setState5={},_defineProperty(_this$setState5,name,null),_defineProperty(_this$setState5,'totalAmountAccessory',null),_this$setState5));}if(name==='simQuantity'||name==='simCharges'){var _this$setState6;_this.setState((_this$setState6={},_defineProperty(_this$setState6,name,null),_defineProperty(_this$setState6,'totalAmountSim',null),_this$setState6));}}};};_this.handleSelectChange=function(name){return function(value){// console.log('hh', [name], value.value)
if(value){_this.setState(_defineProperty({},name,value.value),function(){});}else{_this.setState(_defineProperty({},name,0),function(){});}};};_this.handleSubmit=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(e){var variables,_ref4,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:e.preventDefault();if(!(_this.state.selectedBillingMode===null||_this.state.billingFrequency===null||_this.state.hardwareQuantity===''||_this.state.deviceRate===''||_this.state.gst==='')){_context2.next=5;break;}_this.props.openSnackbar('Invalid form');_context2.next=14;break;case 5:variables={partnerLoginId:parseInt(_this.props.match.params.loginId,10),billingModeId:parseInt(_this.state.selectedBillingMode,10),billingFrequencyId:parseInt(_this.state.billingFrequency,10),gst:parseFloat(_this.state.gst),mmtc:parseInt(_this.state.deviceRate,10),noOfDevices:parseInt(_this.state.hardwareQuantity,10),salesRemarks:_this.state.salesRemarks};if(_this.props.location.state.subscriptionDetails){variables.subscriptionId=parseInt(_this.props.location.state.subscriptionDetails.id,10);}_this.setState({formSaving:true});_context2.next=10;return _this.props.client.mutate({mutation:GET_OR_EDIT_SUBSCRIPTION,variables:variables});case 10:_ref4=_context2.sent;data=_ref4.data;_this.setState({formSaving:false});if(data&&data.createPartnerSubscription){if(_this.props.location.state.edit){_this.props.openSnackbar('Edited subscription successfully');}else{_this.props.openSnackbar('Created subscription successfully');}_this.props.history.goBack();}else{if(_this.props.location.state.edit){_this.props.openSnackbar('Subscription edit failed');}else{_this.props.openSnackbar('Subscription creation failed');}}case 14:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref3.apply(this,arguments);};}();_this.fillDetailsForEditMode=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(subscriptionDetails){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return _this.fetchBillingFrequencies(subscriptionDetails.selectedBillingMode);case 2:_this.setState(subscriptionDetails);case 3:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x3){return _ref5.apply(this,arguments);};}();_this.setGstRates=function(){var gstRates=[5,10,12,15,18];var billingGst=gstRates.map(function(gst){return{value:gst,label:gst};});_this.setState({gstRates:billingGst});};_this.getPartnerDetails=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){var _ref7,data,billingMode;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return _this.props.client.query({query:GET_PARTNER_DETAILS,variables:{loginId:_this.partnerLoginId}});case 2:_ref7=_context4.sent;data=_ref7.data;if(data&&data.partnerDetail){billingMode=data.partnerDetail.billingMode;// console.log(billingMode.id, 'data')
_this.setState({billingModeId:billingMode.id},function(){_this.getBillingFrequencies();_this.getDeviceModels();_this.getAccessoryDetails();_this.getSimDetails();});}case 5:case'end':return _context4.stop();}}},_callee4,_this2);}));_this.mapBillingFrequencies=function(billingFrequencies){var mappedBillingFrequency=billingFrequencies.reduce(function(acc,item){var billingFrequency={value:item.id,label:item.frequency};acc.push(billingFrequency);return acc;},[]);_this.setState({billingFrequencies:mappedBillingFrequency});};_this.getBillingFrequencies=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(){var _ref9,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return _this.props.client.query({query:GET_BILLING_FREQUENCIES,variables:{billingModeId:_this.state.billingModeId}});case 2:_ref9=_context5.sent;data=_ref9.data;if(data.billingFrequencies){_this.mapBillingFrequencies(data.billingFrequencies);}case 5:case'end':return _context5.stop();}}},_callee5,_this2);}));_this.getDeviceModels=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(){var _ref11,data,mappedDeviceModels;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return _this.props.client.query({query:GET_DEVICE_MODELS});case 2:_ref11=_context6.sent;data=_ref11.data;if(data.deviceModel){mappedDeviceModels=data.deviceModel.reduce(function(acc,item){var deviceModels={value:item.id,label:item.model_name};acc.push(deviceModels);return acc;},[]);_this.setState({deviceModels:mappedDeviceModels});// console.log('deviceModel', this.state.deviceModels)
}case 5:case'end':return _context6.stop();}}},_callee6,_this2);}));_this.getAccessoryDetails=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(){var _ref13,data,mappedaccessoryDetails;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return _this.props.client.query({query:GET_ACCESSORY});case 2:_ref13=_context7.sent;data=_ref13.data;if(data.accessoryDetails){mappedaccessoryDetails=data.accessoryDetails.reduce(function(acc,item){var accessoryDetails={value:item.id,label:item.accessoryName};acc.push(accessoryDetails);return acc;},[]);_this.setState({accessoryDetails:mappedaccessoryDetails});// console.log('deviceModel', this.state.accessoryDetails)
}case 5:case'end':return _context7.stop();}}},_callee7,_this2);}));_this.getSimDetails=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(){var _ref15,data,mappedSimDetails;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return _this.props.client.query({query:GET_SIM_PROVIDER});case 2:_ref15=_context8.sent;data=_ref15.data;if(data.simDetails){mappedSimDetails=data.simDetails.reduce(function(acc,item){var SimDetails={value:item.id,label:item.name};acc.push(SimDetails);return acc;},[]);_this.setState({simDetails:mappedSimDetails});// console.log('deviceModel', this.state.SimDetails)
}case 5:case'end':return _context8.stop();}}},_callee8,_this2);}));_this.partnerLoginId=parseInt(_this.props.match.params.loginId,10);_this.state={billingModeId:null,billingFrequencies:null,billingFrequency:null,deviceModels:null,accessoryDetails:null,simDetails:null,deviceModelId:0,simProviderId:0,accessoryId:0,gstRates:null,gstRate:null,softwareQuantity:0,softwareTrackingCharges:0,hardwareQuantity:0,hardwareCharges:0,accessoryQuantity:0,accessoryCharges:0,simQuantity:0,simCharges:0,totalAmountSoftware:0,totalAmountHardware:0,totalAmountAccessory:0,totalAmountSim:0,isSaveConfDialogOpen:false,isCancelConfDialogOpen:false,isSaveBtnDisabled:false,salesRemarks:null// selectedBillingMode: null,
// selectedBillingFrequency: null,
// deviceRate: '',
// gst: '',
// totalAmount: '',
// formSaving: false
};return _this;}// handleChange = e => {
//   this.setState(
//     {
//       [e.target.name]: e.target.value
//     },
//     () => {
//       if (this.state.deviceQuantity && this.state.deviceRate) {
//         this.setState(({ deviceQuantity, deviceRate }) => ({
//           totalAmount: deviceRate * deviceQuantity
//         }))
//       } else {
//         this.setState({ totalAmount: '' })
//       }
//     }
//   )
// }
// handleBillingFrequencyChange = billingFrequency => {
//   this.setState({
//     selectedBillingFrequency: billingFrequency.value
//   })
// }
// handleBillingModeChange = billingMode => {
//   this.setState(
//     {
//       selectedBillingMode: billingMode.value,
//       selectedBillingFrequency: null
//     },
//     this.fetchBillingFrequencies
//   )
// }
_createClass(SubscriptionForm,[{key:'calculateAmount',value:function calculateAmount(quantity,charges,productPerticular){var totalAmount=0;totalAmount=parseFloat(quantity,10)*parseFloat(charges,10);console.log('total amount',totalAmount);if(productPerticular==='softwareQuantity'||productPerticular==='softwareTrackingCharges'){if(!isNaN(totalAmount)){this.setState({totalAmountSoftware:Math.round(totalAmount)});}else{this.setState({totalAmountSoftware:''});}}if(productPerticular==='hardwareQuantity'||productPerticular==='hardwareCharges'){if(!isNaN(totalAmount)){this.setState({totalAmountHardware:Math.round(totalAmount)});}else{this.setState({totalAmountHardware:''});}}if(productPerticular==='accessoryQuantity'||productPerticular==='accessoryCharges'){if(!isNaN(totalAmount)){this.setState({totalAmountAccessory:Math.round(totalAmount)});}else{this.setState({totalAmountAccessory:''});}}if(productPerticular==='simQuantity'||productPerticular==='simCharges'){if(!isNaN(totalAmount)){this.setState({totalAmountSim:Math.round(totalAmount)});}else{this.setState({totalAmountSim:''});}}}// fetchBillingFrequencies = async billingMode => {
//   const { data } = await this.props.client.query({
//     query: GET_BILLING_FREQUENCIES,
//     variables: {
//       billingModeId: billingMode || this.state.selectedBillingMode
//     }
//   })
//   return new Promise(resolve => {
//     this.setState(
//       {
//         billingFrequencies: data.billingFrequencies.map(billingFrequency => ({
//           label: billingFrequency.frequency,
//           value: billingFrequency.id
//         }))
//       },
//       resolve
//     )
//   })
// }
},{key:'componentDidMount',value:function componentDidMount(){this.getPartnerDetails();this.setGstRates();}},{key:'render',value:function render(){// console.log('hi')
var classes=this.props.classes;var _state=this.state,billingFrequencies=_state.billingFrequencies,billingFrequency=_state.billingFrequency,gstRates=_state.gstRates,gstRate=_state.gstRate,softwareQuantity=_state.softwareQuantity,softwareTrackingCharges=_state.softwareTrackingCharges,hardwareQuantity=_state.hardwareQuantity,hardwareCharges=_state.hardwareCharges,accessoryQuantity=_state.accessoryQuantity,accessoryCharges=_state.accessoryCharges,simQuantity=_state.simQuantity,simCharges=_state.simCharges,totalAmountSoftware=_state.totalAmountSoftware,totalAmountHardware=_state.totalAmountHardware,totalAmountAccessory=_state.totalAmountAccessory,totalAmountSim=_state.totalAmountSim,isSaveConfDialogOpen=_state.isSaveConfDialogOpen,isCancelConfDialogOpen=_state.isCancelConfDialogOpen;var formTitle='Create Subscription';return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_ConfirmationDialog__["a" /* default */],{isDialogOpen:isSaveConfDialogOpen,dialogMessage:'Are you sure you want to Save this subscription?',negativeResponseHandler:this.handleSaveNegativeResponse,positiveResponseHandler:this.handleSaveSubscription,isSaveBtnDisabled:this.state.isSaveBtnDisabled}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_ConfirmationDialog__["a" /* default */],{isDialogOpen:isCancelConfDialogOpen,dialogMessage:'Are you sure you want to Cancel new subscription creation?',negativeResponseHandler:this.handleCancelNegativeResponse,positiveResponseHandler:this.handleCancelSubscription}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{container:true,className:classes.container},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{container:true,alignItems:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["IconButton"],{onClick:this.props.history.goBack},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_ArrowBack___default.a,null))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Typography"],{variant:'title'},formTitle)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Divider"],null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{container:true,alignItems:'baseline',justify:'space-around'},billingFrequencies&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */],{className:classes.selectSytle,options:billingFrequencies,value:billingFrequency,onChange:this.handleSelectChange('billingFrequency'),placeholder:'Billing Frequency *'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */],{className:classes.selectSytle,options:gstRates,value:gstRate,onChange:this.handleSelectChange('gstRate'),placeholder:'Select GST Rate *'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["TextField"],{id:'salesRemarks',label:'Sales Remarks',value:this.state.salesRemarks,name:'salesRemarks',onChange:this.handleInputChange('salesRemarks'),margin:'none'})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Divider"],{className:classes.dividerStyle})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{container:true,alignItems:'baseline',spacing:8},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Typography"],{variant:'body1'},'Software')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{container:true,justify:'flex-start',alignItems:'flex-end'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["TextField"],{disabled:true,label:'AquilaTrack Software'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["TextField"],{id:'softwareQuantity',label:'Software Quantity *',value:softwareQuantity,onChange:this.handleChange('softwareQuantity'),type:'number',inputProps:{min:0},margin:'none'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["TextField"],{id:'softwareTrackingCharges',type:'number',label:'Software Charges *',value:softwareTrackingCharges,onChange:this.handleChange('softwareTrackingCharges'),margin:'none'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Typography"],{variant:'body1'},'Total Amount per month (excl GST): \xA0'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Typography"],{variant:'body2'},'\u20B9 ',console.log(totalAmountSoftware),isNaN(parseInt(totalAmountSoftware,10))?'-':totalAmountSoftware))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Divider"],{className:classes.dividerStyle})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{container:true,alignItems:'baseline',spacing:8},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Typography"],{variant:'body1'},'Devices')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{container:true,justify:'flex-start',alignItems:'flex-end'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */],{className:classes.selectSytle,options:this.state.deviceModels,value:this.state.deviceModelId,onChange:this.handleSelectChange('deviceModelId'),placeholder:'Select Model *'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["TextField"],{id:'quantity',label:'Device Quantity *',value:hardwareQuantity,onChange:this.handleChange('hardwareQuantity'),type:'number',inputProps:{min:0},margin:'none'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["TextField"],{id:'hardwareCharges',type:'number',label:'Hardware Charges *',value:hardwareCharges,onChange:this.handleChange('hardwareCharges'),margin:'none'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Typography"],{variant:'body1'},'Total Amount per month (excl GST): \xA0'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Typography"],{variant:'body2'},'\u20B9',' ',isNaN(parseInt(totalAmountHardware,10))?'-':totalAmountHardware))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Divider"],{className:classes.dividerStyle})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{container:true,alignItems:'baseline',spacing:8},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Typography"],{variant:'body1'},'Accessories')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{container:true,justify:'flex-start',alignItems:'flex-end'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */],{className:classes.selectSytle,options:this.state.accessoryDetails,value:this.state.accessoryId,onChange:this.handleSelectChange('accessoryId'),placeholder:'Select Type'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["TextField"],{id:'accessoryQuantity',label:'Quantity',value:accessoryQuantity,onChange:this.handleChange('accessoryQuantity'),type:'number',inputProps:{min:0},margin:'none'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["TextField"],{id:'accessoryCharges',label:'Accessory Charges',type:'number',value:accessoryCharges,onChange:this.handleChange('accessoryCharges'),margin:'none'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Typography"],{variant:'body1'},'Total Amount per month (excl GST): \xA0'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Typography"],{variant:'body2'},'\u20B9',' ',isNaN(parseInt(totalAmountAccessory,10))?'-':totalAmountAccessory))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Divider"],{className:classes.dividerStyle})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{container:true,alignItems:'baseline',spacing:8},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Typography"],{variant:'body1'},'SIM Cards')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */],{className:classes.selectSytle,options:this.state.simDetails,value:this.state.simProviderId,onChange:this.handleSelectChange('simProviderId'),placeholder:'Select Provider'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["TextField"],{id:'simQuantity',label:'Quantity',value:simQuantity,onChange:this.handleChange('simQuantity'),type:'number',inputProps:{min:0},margin:'none'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["TextField"],{id:'simCharges',type:'number',label:'Annual Sim Charges',value:simCharges,onChange:this.handleChange('simCharges'),margin:'none'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Typography"],{variant:'body1'},'Total Amount per month (excl GST): \xA0'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Typography"],{variant:'body2'},'\u20B9',' ',isNaN(parseInt(totalAmountSim,10))?'-':totalAmountSim)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{item:true},console.log('button calue---',parseInt(softwareTrackingCharges,10)===0||softwareQuantity===0||hardwareCharges===''||hardwareCharges===null||hardwareQuantity===0||hardwareQuantity===''||gstRate===null||gstRate===''||billingFrequency===null||billingFrequency===''||accessoryCharges===''||accessoryCharges===null||parseInt(softwareQuantity,10)!==parseInt(hardwareQuantity,10)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Button"],{color:'secondary',variant:'raised',onClick:this.handleSaveClick,disabled:parseInt(softwareTrackingCharges,10)===0||softwareQuantity===0||hardwareCharges===''||hardwareCharges===null||hardwareQuantity===0||hardwareQuantity===''||gstRate===null||gstRate===''||billingFrequency===null||billingFrequency===''||accessoryCharges===''||accessoryCharges===null||parseInt(softwareQuantity,10)!==parseInt(hardwareQuantity,10)// disabled={this.state.isSaveBtnDisabled}
},'Save'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Button"],{color:'secondary',onClick:this.handleCancelClick},'Cancel'))))));}}]);return SubscriptionForm;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);// export default
// const WrappedSubscriptionForm = withStyles(styles)(
//   withSharedSnackbar(withApollo(SubscriptionForm))
// )
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_9__HOCs_withSharedSnackbar__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["withApollo"])(SubscriptionForm))));// #region
// withRouter(props => {
//   return (
//     <Query query={GET_BILLING_MODES}>
//       {({ loading, error, data, client }) => {
//         if (loading) return <Loader fullscreen={true} />
//         if (error) {
//           return <Typography>Error Loading subscription form</Typography>
//         }
//         return (
//           <WrappedSubscriptionForm
//             {...props}
//             client={client}
//             billingModes={data.billingModes.map(billingMode => ({
//               label: billingMode.billingMode,
//               value: billingMode.id
//             }))}
//           />
//         )
//       }}
//     </Query>
//   )
// })
// #endregion

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Modal__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogActions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_DialogContent__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_FormControlLabel__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_FormControlLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_FormControlLabel__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query {\n    features: allFeatures(status: 1) {\n      id\n      featureName\n      costPerAssetPerMonth\n      featureDescription\n    }\n  }\n'],['\n  query {\n    features: allFeatures(status: 1) {\n      id\n      featureName\n      costPerAssetPerMonth\n      featureDescription\n    }\n  }\n']);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_ALL_FEATURES=Object(__WEBPACK_IMPORTED_MODULE_9_graphql_tag__["a" /* default */])(_templateObject);function getModalStyle(){var top=50;var left=50;return{top:top+'%',left:left+'%',transform:'translate(-'+top+'%, -'+left+'%)'};}var styles=function styles(theme){return{paper:{position:'absolute',width:theme.spacing.unit*100,backgroundColor:theme.palette.background.paper,boxShadow:theme.shadows[5],padding:theme.spacing.unit*4}};};var ViewLicenseInfo=function(_React$Component){_inherits(ViewLicenseInfo,_React$Component);function ViewLicenseInfo(props){_classCallCheck(this,ViewLicenseInfo);var _this=_possibleConstructorReturn(this,(ViewLicenseInfo.__proto__||Object.getPrototypeOf(ViewLicenseInfo)).call(this,props));_this.checkedlist=[];_this.checkModelNameValidity=function(){var regex=new RegExp(// eslint-disable-next-line
/^(?!\s)(?!.*\s$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9 '~?!]{2,}$/);_this.setState({isModelNameValid:regex.test(_this.state.modelname)||_this.state.modelname===''});};_this.checkmaxPriceValidity=function(){var regex=new RegExp(/^[0-9]{2,4}$/);_this.setState({ismaxPriceValid:regex.test(_this.state.maxPrice)||_this.state.maxPrice===''});};_this.checkVersionValidity=function(){var regex=new RegExp(// eslint-disable-next-line
// 1-3 dot-separated components, each numeric except that the last one may be *
/^(\d+\.)?(\d+\.)?(\*|\d+)$/);_this.setState({isVersionValid:regex.test(_this.state.version)||_this.state.version===''});};_this.checkDeviceTypeValidity=function(){_this.setState({isDeviceTypeValid:_this.state.devicetype!==''});};_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));};};_this.handleOpenSelect=function(){_this.setState({open1:true});};_this.handleCloseSelect=function(){_this.setState({open1:false});};_this.handleChange=function(event){_this.setState(_defineProperty({},event.target.name,event.target.value));};_this.licenseInformation=_this.props.licenseInfo;console.log('this.featureList2323= ',_this.licenseInformation.getLicenseType);_this.mapToArr(_this.licenseInformation.getLicenseType.featureList);_this.state={licenseType:_this.licenseInformation.getLicenseType.licenseType,description:_this.licenseInformation.getLicenseType.description,maxPrice:_this.licenseInformation.getLicenseType.maxPrice,licenseId:_this.props.selectedId,open1:false,isLicenseNameValid:true,featureList:_this.licenseInformation.getLicenseType.featureList,checkListArr:''};return _this;}_createClass(ViewLicenseInfo,[{key:'mapToArr',value:function mapToArr(feature){var _this2=this;// let checkedlist = []
feature.forEach(function(element){_this2.checkedlist[element.id]=true;});console.log('checkedlist',this.checkedlist);}},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,null,'Edit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Modal___default.a,{'aria-labelledby':'simple-modal-title','aria-describedby':'simple-modal-description',open:this.props.openStatus// onClose={this.handleClose}
},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:getModalStyle(),className:classes.paper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{margin:'dense',id:'licenseType',name:'licenseType',label:'License Name',type:'text',required:true,value:this.state.licenseType,fullWidth:true,onChange:this.handleInputChange('licenseType')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{margin:'dense',id:'description',label:'Description',type:'text',required:true// fullWidth
,value:this.state.description,onChange:this.handleInputChange('description')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{margin:'dense',id:'maxPrice',label:'Max Price',type:'text',required:true// fullWidth
,value:this.state.maxPrice,onChange:this.handleInputChange('maxPrice'),error:!this.state.maxPrice,onBlur:this.checkmaxPriceValidity})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'title'},'Features'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_apollo__["Query"],{query:GET_ALL_FEATURES},function(_ref){var loading=_ref.loading,error=_ref.error,features=_ref.data.features;console.log('data',features);if(loading)return'Loading...';if(error)return'Error!: '+error;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Grid___default.a,{item:true,container:true,spacing:8,direction:'row',justify:'flex-start',alignItems:'flex-start'},features&&features.map(function(featuresList){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core__["Checkbox"],{checked:/* eslint-disable */_this3.checkedlist[featuresList.id]||false/* eslint-enable */}),label:featuresList.featureName});})));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogActions___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{onClick:this.props.closeEditModelFunction,color:'default',variant:'contained'},'Close')))));}}]);return ViewLicenseInfo;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);ViewLicenseInfo.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired// We need an intermediary variable for handling the recursive nesting.
};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_11__HOCs_withSharedSnackbar__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_10_react_apollo__["withApollo"])(ViewLicenseInfo))));

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Card__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_CardHeader__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_CardHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_CardHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_IconButton__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_MoreVert__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_MoreVert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_MoreVert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_CardContent__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_CardContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_CardContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getResellerSubscriptions($subcriptionid: Int) {\n    subscription: getResellerSubscriptions(id: $subcriptionid) {\n      id\n      client {\n        loginId\n        clientName\n      }\n      billingMode {\n        billingMode\n      }\n      billingFrequency {\n        frequency\n      }\n      deviceQuantity\n\n      amount\n      createdAt\n      unAssignedDeviceQuantity\n    }\n  }\n'],['\n  query getResellerSubscriptions($subcriptionid: Int) {\n    subscription: getResellerSubscriptions(id: $subcriptionid) {\n      id\n      client {\n        loginId\n        clientName\n      }\n      billingMode {\n        billingMode\n      }\n      billingFrequency {\n        frequency\n      }\n      deviceQuantity\n\n      amount\n      createdAt\n      unAssignedDeviceQuantity\n    }\n  }\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// import ButtonBase from '@material-ui/core/ButtonBase'
var GET_SUBSCRIPTION=Object(__WEBPACK_IMPORTED_MODULE_11_graphql_tag__["a" /* default */])(_templateObject);var styles=function styles(theme){return{card:{padding:theme.spacing.unit*2,color:theme.palette.text.secondary,width:'100%'},buttonBase:{width:'100%',textAlign:'left'}};};var SubscriptionDetails=function(_Component){_inherits(SubscriptionDetails,_Component);function SubscriptionDetails(props){_classCallCheck(this,SubscriptionDetails);var _this=_possibleConstructorReturn(this,(SubscriptionDetails.__proto__||Object.getPrototypeOf(SubscriptionDetails)).call(this,props));_this.assignDevice=function(){// console.log('subscriptionId', this.subscriptionId)
// console.log('this.clientId', this.clientLoginId)
// this.clientLoginId = 16
_this.props.history.push({pathname:'/home/reseller/subscriptions/assign/'+_this.clientLoginId+'/'+_this.subscriptionId});};_this.getFormattedDate=function(timestamp){return __WEBPACK_IMPORTED_MODULE_14_moment___default()(timestamp*1000).format('MMM Do YYYY, h:mm a');};_this.subscriptionId=_this.props.subscriptionId;_this.clientLoginId=_this.props.clientLoginId;_this.viewVehicles=_this.props.viewVehicles;return _this;}_createClass(SubscriptionDetails,[{key:'render',value:function render(){var _this2=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_apollo__["Query"],{query:GET_SUBSCRIPTION// TODO: Change Query
,variables:{subcriptionid:parseInt(this.subscriptionId,10)}},function(_ref){var loading=_ref.loading,error=_ref.error,subscription=_ref.data.subscription;if(loading)return'Loading...';if(error)return'Error!: '+error;return(// <ButtonBase
//   className={classes.buttonBase}
//   // onClick={this.props.showSubscription(this.props.subscriptionId)}
//   // disabled={this.props.isDisabled}
// >
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Card___default.a,{className:classes.card,raised:'true'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_CardHeader___default.a,{action:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_IconButton___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_MoreVert___default.a,null)),title:subscription.billingFrequency.frequency// subheader={subscription.createdAt}
,subheader:_this2.getFormattedDate(subscription.createdAt)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true,spacing:16,alignItems:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body2'},'Quantity:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body1'},subscription.deviceQuantity)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body2'},'Amount:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body1'},subscription.amount+' /-')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body2'},'Un-assigned Quantity')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body1'},subscription.unAssignedDeviceQuantity)),_this2.viewVehicles&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Button___default.a,{color:'primary',variant:'outlined',onClick:_this2.props.showSubscription(_this2.props.subscriptionId)},'View Vehicles')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true,spacing:16,alignItems:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body2'},'Bill Date:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body1'},_this2.getFormattedDate(subscription.createdAt))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body2'},'Bill Mode:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body1'},subscription.billingMode.billingMode)),subscription.unAssignedDeviceQuantity>0&&// console.log('propsubid:', this.props.subscriptionId)
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Button___default.a,{color:'primary',variant:'outlined'// onClick={this.assignDevice}
,onClick:function onClick(){return _this2.assignDevice(_this2.backUrl);}},'Assign Device')))))));});}}]);return SubscriptionDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SubscriptionDetails.PropTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__["withStyles"])(styles)(SubscriptionDetails)));

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vehicle_css__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vehicle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__vehicle_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Reusable_ItemCard__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_IconButton__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_LocationOn__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_LocationOn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_LocationOn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_LocationCity__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_LocationCity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_LocationCity__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VehicleRegistration=function(_Component){_inherits(VehicleRegistration,_Component);function VehicleRegistration(){_classCallCheck(this,VehicleRegistration);return _possibleConstructorReturn(this,(VehicleRegistration.__proto__||Object.getPrototypeOf(VehicleRegistration)).apply(this,arguments));}_createClass(VehicleRegistration,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12,container:true,direction:'row',justify:'flex-start',alignItems:'flex-start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Reusable_ItemCard__["a" /* default */],{className:'details',style:{width:'100%',margin:'0 auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true,className:'content1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{component:'p'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_IconButton___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_LocationOn___default.a,{color:'primary'})),this.props.address),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{component:'p'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_IconButton___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_LocationCity___default.a,{color:'primary'})),this.props.city))))));}}]);return VehicleRegistration;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (VehicleRegistration);

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_apollo__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getPurchaseRequestInfo($id: Int!) {\n    prInfo: getPurchaseRequestInfo(id: $id) {\n      reseller {\n        resellerName\n      }\n      licenseTypeList {\n        id\n        licenseType\n        maxPrice\n        requestedQuantity\n        finalPrice\n        gst\n        totalPrice\n      }\n      deviceModelList {\n        id\n        model_name\n        maxPrice\n        requestedQuantity\n        finalPrice\n        gst\n        totalPrice\n      }\n    }\n  }\n'],['\n  query getPurchaseRequestInfo($id: Int!) {\n    prInfo: getPurchaseRequestInfo(id: $id) {\n      reseller {\n        resellerName\n      }\n      licenseTypeList {\n        id\n        licenseType\n        maxPrice\n        requestedQuantity\n        finalPrice\n        gst\n        totalPrice\n      }\n      deviceModelList {\n        id\n        model_name\n        maxPrice\n        requestedQuantity\n        finalPrice\n        gst\n        totalPrice\n      }\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  mutation resellerApprovalForFinalPrice(\n    $purchaseRequestId: Int!\n    $isApproved: Boolean!\n  ) {\n    resellerApprovalForFinalPrice(\n      purchaseRequestId: $purchaseRequestId\n      isApproved: $isApproved\n    )\n  }\n'],['\n  mutation resellerApprovalForFinalPrice(\n    $purchaseRequestId: Int!\n    $isApproved: Boolean!\n  ) {\n    resellerApprovalForFinalPrice(\n      purchaseRequestId: $purchaseRequestId\n      isApproved: $isApproved\n    )\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_PURCHASE_REQUEST=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject);var APPROVE_CANCEL_REQUEST=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject2);var style=function style(theme){return{root:{padding:theme.spacing.unit*2,flexGrow:1}};};function TypeHeader(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'title'},props.header));}function SubHeader(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,container:true,xs:12,spacing:16,direction:'row'},props.headers.map(function(header,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:2,key:index},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading'},header));}));}function Details(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,container:true,xs:12,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading'},props.details.name)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading'},props.details.maxPrice)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading'},props.details.qty)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading'},props.details.finalPrice)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading'},props.details.gst)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading'},props.details.totalPrice)));}var ViewPendingRequest=function(_Component){_inherits(ViewPendingRequest,_Component);function ViewPendingRequest(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,ViewPendingRequest);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ViewPendingRequest.__proto__||Object.getPrototypeOf(ViewPendingRequest)).call.apply(_ref,[this].concat(args))),_this),_this.state={models:[],licenses:[],purchaseRequestId:null},_this.handleBack=function(event){if(_this.props.externallyRendered===true){_this.props.goBack();}else{_this.props.history.goBack();}},_this.handleApprove=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _ref3,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.client.mutate({mutation:APPROVE_CANCEL_REQUEST,variables:{purchaseRequestId:parseInt(_this.state.purchaseRequestId,10),isApproved:true}});case 2:_ref3=_context.sent;data=_ref3.data;if(data.resellerApprovalForFinalPrice===true){_this.props.openSnackbar('Purchase Request Approved');_this.props.history.push({pathname:'/home/reseller/purchase-request'});}else{_this.props.openSnackbar('Approval of Purchase Request Failed');}case 5:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}(),_this.handleCancel=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(event){var _ref5,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this.props.client.mutate({mutation:APPROVE_CANCEL_REQUEST,variables:{purchaseRequestId:parseInt(_this.state.purchaseRequestId,10),isApproved:false}});case 2:_ref5=_context2.sent;data=_ref5.data;if(data.resellerApprovalForFinalPrice===true){_this.props.openSnackbar('Purchase Request Cancelled');_this.props.history.push({pathname:'/home/purchase-request'});}else{_this.props.openSnackbar('Cancellation of Purchase Request Failed');}case 5:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref4.apply(this,arguments);};}(),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ViewPendingRequest,[{key:'componentDidMount',value:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var purchaseRequestId,_ref7,data,deviceDetails,licenseDetails;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:purchaseRequestId=void 0;if(this.props.externallyRendered===true){purchaseRequestId=this.props.purchaseRequestId;}else{purchaseRequestId=this.props.match.params.purchaseRequestId;}// Query to get all relevant information of purchase request
_context3.next=4;return this.props.client.query({query:GET_PURCHASE_REQUEST,variables:{id:parseInt(purchaseRequestId,10)}});case 4:_ref7=_context3.sent;data=_ref7.data;data=data.prInfo;deviceDetails=[];licenseDetails=[];data.deviceModelList.forEach(function(device){var tempObject={};tempObject.id=device.id;tempObject.name=device.model_name;tempObject.maxPrice=device.maxPrice;tempObject.qty=device.requestedQuantity;tempObject.finalPrice=device.finalPrice?device.finalPrice:'NA';tempObject.gst=device.gst?(device.gst*100).toString():'NA';tempObject.totalPrice=device.totalPrice?device.totalPrice:'NA';deviceDetails.push(tempObject);});data.licenseTypeList.forEach(function(license){var tempObject={};tempObject.id=license.id;tempObject.name=license.licenseType;tempObject.maxPrice=license.maxPrice;tempObject.qty=license.requestedQuantity;tempObject.finalPrice=license.finalPrice?license.finalPrice:'NA';tempObject.gst=license.gst?(license.gst*100).toString():'NA';tempObject.totalPrice=license.totalPrice?license.totalPrice:'NA';licenseDetails.push(tempObject);});this.setState({models:deviceDetails,licenses:licenseDetails,purchaseRequestId:purchaseRequestId});case 12:case'end':return _context3.stop();}}},_callee3,this);}));function componentDidMount(){return _ref6.apply(this,arguments);}return componentDidMount;}()},{key:'render',value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button___default.a,{color:'primary',variant:'raised',onClick:this.handleBack},'Back')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},this.props.externallyRendered===false?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'headline'},'Pending Purchase Request')):this.props.details),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,container:true,xs:12,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TypeHeader,{header:'Device Model(s)'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,container:true,xs:12,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SubHeader,{headers:['Model','Maximum Price','Quantity','Final Price','GST','Total Price']})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Divider___default.a,null)),this.state.models.map(function(model,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,container:true,xs:12,spacing:16,direction:'row',key:index},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Details,{details:model}));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,container:true,xs:12,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TypeHeader,{header:'License(s)'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,container:true,xs:12,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SubHeader,{headers:['License','Maximum Price','Quantity','Final Price','GST','Total Price']})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Divider___default.a,null)),this.state.licenses.map(function(license,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,container:true,xs:12,spacing:16,direction:'row',key:index},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Details,{details:license}));}),this.props.externallyRendered===false?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,container:true,xs:12,spacing:16,direction:'row',justify:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button___default.a,{color:'secondary',variant:'raised',onClick:this.handleApprove},'Approve')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button___default.a,{color:'primary',variant:'raised',onClick:this.handleCancel},'Cancel'))):null));}}]);return ViewPendingRequest;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);ViewPendingRequest.defaultProps={externallyRendered:false};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_9_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_6__HOCs_withSharedSnackbar__["a" /* default */])(ViewPendingRequest))));

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Slot; });
/* unused harmony export asyncFromGen */
/* unused harmony export bind */
/* unused harmony export noContext */
/* unused harmony export setTimeout */
/* unused harmony export wrapYieldingFiberMethods */
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var MISSING_VALUE = {};
var idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var makeSlotClass = function () { return /** @class */ (function () {
    function Slot() {
        // If you have a Slot object, you can find out its slot.id, but you cannot
        // guess the slot.id of a Slot you don't have access to, thanks to the
        // randomized suffix.
        this.id = [
            "slot",
            idCounter++,
            Date.now(),
            Math.random().toString(36).slice(2),
        ].join(":");
    }
    Slot.prototype.hasValue = function () {
        for (var context_1 = currentContext; context_1; context_1 = context_1.parent) {
            // We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === MISSING_VALUE)
                    break;
                if (context_1 !== currentContext) {
                    // Cache the value in currentContext.slots so the next lookup will
                    // be faster. This caching is safe because the tree of contexts and
                    // the values of the slots are logically immutable.
                    currentContext.slots[this.id] = value;
                }
                return true;
            }
        }
        if (currentContext) {
            // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            currentContext.slots[this.id] = MISSING_VALUE;
        }
        return false;
    };
    Slot.prototype.getValue = function () {
        if (this.hasValue()) {
            return currentContext.slots[this.id];
        }
    };
    Slot.prototype.withValue = function (value, callback, 
    // Given the prevalence of arrow functions, specifying arguments is likely
    // to be much more common than specifying `this`, hence this ordering:
    args, thisArg) {
        var _a;
        var slots = (_a = {
                __proto__: null
            },
            _a[this.id] = value,
            _a);
        var parent = currentContext;
        currentContext = { parent: parent, slots: slots };
        try {
            // Function.prototype.apply allows the arguments array argument to be
            // omitted or undefined, so args! is fine here.
            return callback.apply(thisArg, args);
        }
        finally {
            currentContext = parent;
        }
    };
    // Capture the current context and wrap a callback function so that it
    // reestablishes the captured context when called.
    Slot.bind = function (callback) {
        var context = currentContext;
        return function () {
            var saved = currentContext;
            try {
                currentContext = context;
                return callback.apply(this, arguments);
            }
            finally {
                currentContext = saved;
            }
        };
    };
    // Immediately run a callback function without any captured context.
    Slot.noContext = function (callback, 
    // Given the prevalence of arrow functions, specifying arguments is likely
    // to be much more common than specifying `this`, hence this ordering:
    args, thisArg) {
        if (currentContext) {
            var saved = currentContext;
            try {
                currentContext = null;
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            }
            finally {
                currentContext = saved;
            }
        }
        else {
            return callback.apply(thisArg, args);
        }
    };
    return Slot;
}()); };
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var globalKey = "@wry/context:Slot";
var host = Array;
var Slot = host[globalKey] || function () {
    var Slot = makeSlotClass();
    try {
        Object.defineProperty(host, globalKey, {
            value: host[globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false,
        });
    }
    finally {
        return Slot;
    }
}();

var bind = Slot.bind, noContext = Slot.noContext;
function setTimeoutWithContext(callback, delay) {
    return setTimeout(bind(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function asyncFromGen(genFn) {
    return function () {
        var gen = genFn.apply(this, arguments);
        var boundNext = bind(gen.next);
        var boundThrow = bind(gen.throw);
        return new Promise(function (resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                }
                catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if (isPromiseLike(result.value)) {
                    result.value.then(next, result.done ? reject : invokeThrow);
                }
                else {
                    next(result.value);
                }
            }
            var invokeNext = function (value) { return invoke(boundNext, value); };
            var invokeThrow = function (error) { return invoke(boundThrow, error); };
            invokeNext();
        });
    };
}
function isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var wrappedFibers = [];
function wrapYieldingFiberMethods(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if (wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function (obj, method) {
            var fn = obj[method];
            obj[method] = function () {
                return noContext(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        wrappedFibers.push(Fiber);
    }
    return Fiber;
}


//# sourceMappingURL=context.esm.js.map


/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checkFetcher; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createSignalIfSupported; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fallbackHttpConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parseAndCheckHttpResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return selectHttpOptionsAndBody; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return selectURI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return serializeFetchParameter; });
/* unused harmony export throwServerError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_language_printer__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ts_invariant__ = __webpack_require__(172);




var defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false,
};
var defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json',
};
var defaultOptions = {
    method: 'POST',
};
var fallbackHttpConfig = {
    http: defaultHttpOptions,
    headers: defaultHeaders,
    options: defaultOptions,
};
var throwServerError = function (response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
var parseAndCheckHttpResponse = function (operations) { return function (response) {
    return (response
        .text()
        .then(function (bodyText) {
        try {
            return JSON.parse(bodyText);
        }
        catch (err) {
            var parseError = err;
            parseError.name = 'ServerParseError';
            parseError.response = response;
            parseError.statusCode = response.status;
            parseError.bodyText = bodyText;
            return Promise.reject(parseError);
        }
    })
        .then(function (result) {
        if (response.status >= 300) {
            throwServerError(response, result, "Response not successful: Received status code " + response.status);
        }
        if (!Array.isArray(result) &&
            !result.hasOwnProperty('data') &&
            !result.hasOwnProperty('errors')) {
            throwServerError(response, result, "Server response was missing for query '" + (Array.isArray(operations)
                ? operations.map(function (op) { return op.operationName; })
                : operations.operationName) + "'.");
        }
        return result;
    }));
}; };
var checkFetcher = function (fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        var library = 'unfetch';
        if (typeof window === 'undefined')
            library = 'node-fetch';
        throw  true ? new __WEBPACK_IMPORTED_MODULE_2_ts_invariant__["a" /* InvariantError */](1) : new InvariantError("\nfetch is not found globally and no fetcher passed, to fix pass a fetch for\nyour environment like https://www.npmjs.com/package/" + library + ".\n\nFor example:\nimport fetch from '" + library + "';\nimport { createHttpLink } from 'apollo-link-http';\n\nconst link = createHttpLink({ uri: '/graphql', fetch: fetch });");
    }
};
var createSignalIfSupported = function () {
    if (typeof AbortController === 'undefined')
        return { controller: false, signal: false };
    var controller = new AbortController();
    var signal = controller.signal;
    return { controller: controller, signal: signal };
};
var selectHttpOptionsAndBody = function (operation, fallbackConfig) {
    var configs = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        configs[_i - 2] = arguments[_i];
    }
    var options = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, fallbackConfig.options, { headers: fallbackConfig.headers, credentials: fallbackConfig.credentials });
    var http = fallbackConfig.http;
    configs.forEach(function (config) {
        options = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, options, config.options, { headers: Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, options.headers, config.headers) });
        if (config.credentials)
            options.credentials = config.credentials;
        http = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, http, config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = { operationName: operationName, variables: variables };
    if (http.includeExtensions)
        body.extensions = extensions;
    if (http.includeQuery)
        body.query = Object(__WEBPACK_IMPORTED_MODULE_1_graphql_language_printer__["a" /* print */])(query);
    return {
        options: options,
        body: body,
    };
};
var serializeFetchParameter = function (p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    }
    catch (e) {
        var parseError =  true ? new __WEBPACK_IMPORTED_MODULE_2_ts_invariant__["a" /* InvariantError */](2) : new InvariantError("Network request failed. " + label + " is not serializable: " + e.message);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
var selectURI = function (operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) {
        return contextURI;
    }
    else if (typeof fallbackURI === 'function') {
        return fallbackURI(operation);
    }
    else {
        return fallbackURI || '/graphql';
    }
};


//# sourceMappingURL=bundle.esm.js.map


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(268).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(205) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 653 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(380);
var document = __webpack_require__(136).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 655 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 656 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 657 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(2487);
var enumBugKeys = __webpack_require__(660);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 659 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 660 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(268).f;
var has = __webpack_require__(269);
var TAG = __webpack_require__(206)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isObject */
/* harmony export (immutable) */ __webpack_exports__["a"] = extractFiles;
/* unused harmony export ReactNativeFile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_function_name__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_function_name___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_function_name__);

var isObject = function isObject(node) {
  return typeof node === 'object' && node !== null
}
function extractFiles(tree, treePath) {
  if (treePath === void 0) {
    treePath = ''
  }

  var files = []

  var recurse = function recurse(node, nodePath) {
    Object.keys(node).forEach(function(key) {
      if (!isObject(node[key])) return
      var path = '' + nodePath + key

      if (
        (typeof File !== 'undefined' && node[key] instanceof File) ||
        (typeof Blob !== 'undefined' && node[key] instanceof Blob) ||
        node[key] instanceof ReactNativeFile
      ) {
        files.push({
          path: path,
          file: node[key]
        })
        node[key] = null
        return
      }

      if (typeof FileList !== 'undefined' && node[key] instanceof FileList)
        node[key] = Array.prototype.slice.call(node[key])
      recurse(node[key], path + '.')
    })
  }

  if (isObject(tree)) recurse(tree, treePath === '' ? treePath : treePath + '.')
  return files
}
var ReactNativeFile = function ReactNativeFile(_ref) {
  var uri = _ref.uri,
    type = _ref.type,
    name = _ref.name
  this.uri = uri
  this.type = type
  this.name = name
}

ReactNativeFile.list = function(files) {
  return files.map(function(file) {
    return new ReactNativeFile(file)
  })
}


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12.65 10C11.83 7.67 9.61 6 7 6c-3.31 0-6 2.69-6 6s2.69 6 6 6c2.61 0 4.83-1.67 5.65-4H17v4h4v-4h2v-4H12.65zM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
})), 'VpnKey');

exports.default = _default;

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(665);
module.exports = __webpack_require__(670);


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(666).enable();
  window.Promise = __webpack_require__(668);
}

// fetch() polyfill for making API calls.
__webpack_require__(669);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(207);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(388);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(72)))

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(388);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 669 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_helmet__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Root__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__auth__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__registerServiceWorker__ = __webpack_require__(2462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__apollo__ = __webpack_require__(2463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_common_Loader__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_common_DomainConfigError__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__index_css__ = __webpack_require__(2494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_utils__ = __webpack_require__(2495);
var _templateObject=_taggedTemplateLiteral(['\n  query($domain: String!) {\n    domainConfiguration(domain: $domain) {\n      header {\n        title\n        shortcutIcon\n      }\n      page {\n        background\n        title\n        subtitle\n        logo\n      }\n      customPage\n      customPageId\n    }\n  }\n'],['\n  query($domain: String!) {\n    domainConfiguration(domain: $domain) {\n      header {\n        title\n        shortcutIcon\n      }\n      page {\n        background\n        title\n        subtitle\n        logo\n      }\n      customPage\n      customPageId\n    }\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_DOMAIN_CONFIG=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject);Object(__WEBPACK_IMPORTED_MODULE_13__utils_utils__["a" /* checkTokenAuth */])();var theme=Object(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles__["createMuiTheme"])({palette:{primary:{main:'#3f3f3f'},secondary:{main:'#43a047'}},typography:{// Use the system font instead of the default Roboto font.
fontFamily:['-apple-system','BlinkMacSystemFont','"Segoe UI"','Roboto','"Helvetica Neue"','Arial','sans-serif','"Apple Color Emoji"','"Segoe UI Emoji"','"Segoe UI Symbol"'].join(',')}});__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__auth__["b" /* AuthProvider */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__auth__["a" /* AuthConsumer */],null,function(_ref){var logout=_ref.logout;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["ApolloProvider"],{client:Object(__WEBPACK_IMPORTED_MODULE_9__apollo__["a" /* default */])({logout:logout})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles__["MuiThemeProvider"],{theme:theme},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["Query"],{query:GET_DOMAIN_CONFIG,variables:{domain:window.location.host}},function(_ref2){var loading=_ref2.loading,error=_ref2.error,data=_ref2.data;if(!data){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Please check your internet connection');}var domainConfiguration=data.domainConfiguration;if(loading)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_common_Loader__["a" /* default */],{fullscreen:true});if(error)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_common_DomainConfigError__["a" /* default */],null);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_helmet__["Helmet"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title',null,domainConfiguration.header.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('link',{rel:'shortcut icon',href:domainConfiguration.header.shortcutIcon})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Root__["a" /* default */],{page:domainConfiguration.page,customPage:domainConfiguration.customPage,customPageId:domainConfiguration.customPageId}));})));})),document.getElementById('root'));// register()
Object(__WEBPACK_IMPORTED_MODULE_8__registerServiceWorker__["a" /* unregister */])();

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(207),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(207),r=__webpack_require__(673);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(674);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __extends */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __createBinding */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* unused harmony export __spreadArrays */
/* unused harmony export __spreadArray */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/* unused harmony export __classPrivateFieldGet */
/* unused harmony export __classPrivateFieldSet */
/* unused harmony export __classPrivateFieldIn */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}


/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__graphql__ = __webpack_require__(677);
/* unused harmony reexport graphql */
/* unused harmony reexport graphqlSync */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(684);
/* unused harmony reexport GraphQLSchema */
/* unused harmony reexport GraphQLScalarType */
/* unused harmony reexport GraphQLObjectType */
/* unused harmony reexport GraphQLInterfaceType */
/* unused harmony reexport GraphQLUnionType */
/* unused harmony reexport GraphQLEnumType */
/* unused harmony reexport GraphQLInputObjectType */
/* unused harmony reexport GraphQLList */
/* unused harmony reexport GraphQLNonNull */
/* unused harmony reexport GraphQLDirective */
/* unused harmony reexport TypeKind */
/* unused harmony reexport specifiedScalarTypes */
/* unused harmony reexport GraphQLInt */
/* unused harmony reexport GraphQLFloat */
/* unused harmony reexport GraphQLString */
/* unused harmony reexport GraphQLBoolean */
/* unused harmony reexport GraphQLID */
/* unused harmony reexport specifiedDirectives */
/* unused harmony reexport GraphQLIncludeDirective */
/* unused harmony reexport GraphQLSkipDirective */
/* unused harmony reexport GraphQLDeprecatedDirective */
/* unused harmony reexport DEFAULT_DEPRECATION_REASON */
/* unused harmony reexport SchemaMetaFieldDef */
/* unused harmony reexport TypeMetaFieldDef */
/* unused harmony reexport TypeNameMetaFieldDef */
/* unused harmony reexport introspectionTypes */
/* unused harmony reexport __Schema */
/* unused harmony reexport __Directive */
/* unused harmony reexport __DirectiveLocation */
/* unused harmony reexport __Type */
/* unused harmony reexport __Field */
/* unused harmony reexport __InputValue */
/* unused harmony reexport __EnumValue */
/* unused harmony reexport __TypeKind */
/* unused harmony reexport isSchema */
/* unused harmony reexport isDirective */
/* unused harmony reexport isType */
/* unused harmony reexport isScalarType */
/* unused harmony reexport isObjectType */
/* unused harmony reexport isInterfaceType */
/* unused harmony reexport isUnionType */
/* unused harmony reexport isEnumType */
/* unused harmony reexport isInputObjectType */
/* unused harmony reexport isListType */
/* unused harmony reexport isNonNullType */
/* unused harmony reexport isInputType */
/* unused harmony reexport isOutputType */
/* unused harmony reexport isLeafType */
/* unused harmony reexport isCompositeType */
/* unused harmony reexport isAbstractType */
/* unused harmony reexport isWrappingType */
/* unused harmony reexport isNullableType */
/* unused harmony reexport isNamedType */
/* unused harmony reexport isSpecifiedScalarType */
/* unused harmony reexport isIntrospectionType */
/* unused harmony reexport isSpecifiedDirective */
/* unused harmony reexport assertType */
/* unused harmony reexport assertScalarType */
/* unused harmony reexport assertObjectType */
/* unused harmony reexport assertInterfaceType */
/* unused harmony reexport assertUnionType */
/* unused harmony reexport assertEnumType */
/* unused harmony reexport assertInputObjectType */
/* unused harmony reexport assertListType */
/* unused harmony reexport assertNonNullType */
/* unused harmony reexport assertInputType */
/* unused harmony reexport assertOutputType */
/* unused harmony reexport assertLeafType */
/* unused harmony reexport assertCompositeType */
/* unused harmony reexport assertAbstractType */
/* unused harmony reexport assertWrappingType */
/* unused harmony reexport assertNullableType */
/* unused harmony reexport assertNamedType */
/* unused harmony reexport getNullableType */
/* unused harmony reexport getNamedType */
/* unused harmony reexport validateSchema */
/* unused harmony reexport assertValidSchema */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__language__ = __webpack_require__(685);
/* unused harmony reexport Source */
/* unused harmony reexport getLocation */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__language__["a"]; });
/* unused harmony reexport parseValue */
/* unused harmony reexport parseType */
/* unused harmony reexport print */
/* unused harmony reexport visit */
/* unused harmony reexport visitInParallel */
/* unused harmony reexport visitWithTypeInfo */
/* unused harmony reexport getVisitFn */
/* unused harmony reexport Kind */
/* unused harmony reexport TokenKind */
/* unused harmony reexport DirectiveLocation */
/* unused harmony reexport BREAK */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__execution__ = __webpack_require__(686);
/* unused harmony reexport execute */
/* unused harmony reexport defaultFieldResolver */
/* unused harmony reexport responsePathAsArray */
/* unused harmony reexport getDirectiveValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__subscription__ = __webpack_require__(687);
/* unused harmony reexport subscribe */
/* unused harmony reexport createSourceEventStream */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__validation__ = __webpack_require__(690);
/* unused harmony reexport validate */
/* unused harmony reexport ValidationContext */
/* unused harmony reexport specifiedRules */
/* unused harmony reexport FieldsOnCorrectTypeRule */
/* unused harmony reexport FragmentsOnCompositeTypesRule */
/* unused harmony reexport KnownArgumentNamesRule */
/* unused harmony reexport KnownDirectivesRule */
/* unused harmony reexport KnownFragmentNamesRule */
/* unused harmony reexport KnownTypeNamesRule */
/* unused harmony reexport LoneAnonymousOperationRule */
/* unused harmony reexport NoFragmentCyclesRule */
/* unused harmony reexport NoUndefinedVariablesRule */
/* unused harmony reexport NoUnusedFragmentsRule */
/* unused harmony reexport NoUnusedVariablesRule */
/* unused harmony reexport OverlappingFieldsCanBeMergedRule */
/* unused harmony reexport PossibleFragmentSpreadsRule */
/* unused harmony reexport ProvidedNonNullArgumentsRule */
/* unused harmony reexport ScalarLeafsRule */
/* unused harmony reexport SingleFieldSubscriptionsRule */
/* unused harmony reexport UniqueArgumentNamesRule */
/* unused harmony reexport UniqueDirectivesPerLocationRule */
/* unused harmony reexport UniqueFragmentNamesRule */
/* unused harmony reexport UniqueInputFieldNamesRule */
/* unused harmony reexport UniqueOperationNamesRule */
/* unused harmony reexport UniqueVariableNamesRule */
/* unused harmony reexport ValuesOfCorrectTypeRule */
/* unused harmony reexport VariablesAreInputTypesRule */
/* unused harmony reexport VariablesDefaultValueAllowedRule */
/* unused harmony reexport VariablesInAllowedPositionRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__error__ = __webpack_require__(43);
/* unused harmony reexport GraphQLError */
/* unused harmony reexport formatError */
/* unused harmony reexport printError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utilities__ = __webpack_require__(691);
/* unused harmony reexport getIntrospectionQuery */
/* unused harmony reexport introspectionQuery */
/* unused harmony reexport getOperationAST */
/* unused harmony reexport introspectionFromSchema */
/* unused harmony reexport buildClientSchema */
/* unused harmony reexport buildASTSchema */
/* unused harmony reexport buildSchema */
/* unused harmony reexport getDescription */
/* unused harmony reexport extendSchema */
/* unused harmony reexport lexicographicSortSchema */
/* unused harmony reexport printSchema */
/* unused harmony reexport printIntrospectionSchema */
/* unused harmony reexport printType */
/* unused harmony reexport typeFromAST */
/* unused harmony reexport valueFromAST */
/* unused harmony reexport valueFromASTUntyped */
/* unused harmony reexport astFromValue */
/* unused harmony reexport TypeInfo */
/* unused harmony reexport coerceValue */
/* unused harmony reexport isValidJSValue */
/* unused harmony reexport isValidLiteralValue */
/* unused harmony reexport concatAST */
/* unused harmony reexport separateOperations */
/* unused harmony reexport isEqualType */
/* unused harmony reexport isTypeSubTypeOf */
/* unused harmony reexport doTypesOverlap */
/* unused harmony reexport assertValidName */
/* unused harmony reexport isValidNameError */
/* unused harmony reexport findBreakingChanges */
/* unused harmony reexport findDangerousChanges */
/* unused harmony reexport BreakingChangeType */
/* unused harmony reexport DangerousChangeType */
/* unused harmony reexport findDeprecatedUsages */



// Create and operate on GraphQL type definitions and schema.
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * GraphQL.js provides a reference implementation for the GraphQL specification
 * but is also a useful utility for operating on GraphQL files and building
 * sophisticated tools.
 *
 * This primary module exports a general purpose function for fulfilling all
 * steps of the GraphQL specification in a single operation, but also includes
 * utilities for every part of the GraphQL specification:
 *
 *   - Parsing the GraphQL language.
 *   - Building a GraphQL type schema.
 *   - Validating a GraphQL request against a type schema.
 *   - Executing a GraphQL request against a type schema.
 *
 * This also includes utility functions for operating on GraphQL types and
 * GraphQL documents to facilitate building tools.
 *
 * You may also import from each sub-directory directly. For example, the
 * following two import statements are equivalent:
 *
 *     import { parse } from 'graphql';
 *     import { parse } from 'graphql/language';
 */

// The primary entry point into fulfilling a GraphQL request.


// Parse and operate on GraphQL language source files.


// Execute GraphQL queries.




// Validate GraphQL queries.


// Create, format, and print GraphQL errors.


// Utilities for operating on GraphQL type schema and parsed sources.


/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export graphql */
/* unused harmony export graphqlSync */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type_validate__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__language_parser__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validation_validate__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__execution_execute__ = __webpack_require__(212);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */






/**
 * This is the primary entry point function for fulfilling GraphQL operations
 * by parsing, validating, and executing a GraphQL document along side a
 * GraphQL schema.
 *
 * More sophisticated GraphQL servers, such as those which persist queries,
 * may wish to separate the validation and execution phases to a static time
 * tooling step, and a server runtime step.
 *
 * Accepts either an object with named arguments, or individual arguments:
 *
 * schema:
 *    The GraphQL type system to use when validating and executing a query.
 * source:
 *    A GraphQL language formatted string representing the requested operation.
 * rootValue:
 *    The value provided as the first argument to resolver functions on the top
 *    level type (e.g. the query object type).
 * variableValues:
 *    A mapping of variable name to runtime value to use for all variables
 *    defined in the requestString.
 * operationName:
 *    The name of the operation to use if requestString contains multiple
 *    possible operations. Can be omitted if requestString contains only
 *    one operation.
 * fieldResolver:
 *    A resolver function to use when one is not provided by the schema.
 *    If not provided, the default field resolver is used (which looks for a
 *    value or method on the source value with the field's name).
 */

/* eslint-disable no-redeclare */

function graphql(argsOrSchema, source, rootValue, contextValue, variableValues, operationName, fieldResolver) {
  var _arguments = arguments;

  /* eslint-enable no-redeclare */
  // Always return a Promise for a consistent API.
  return new Promise(function (resolve) {
    return resolve(
    // Extract arguments from object args if provided.
    _arguments.length === 1 ? graphqlImpl(argsOrSchema.schema, argsOrSchema.source, argsOrSchema.rootValue, argsOrSchema.contextValue, argsOrSchema.variableValues, argsOrSchema.operationName, argsOrSchema.fieldResolver) : graphqlImpl(argsOrSchema, source, rootValue, contextValue, variableValues, operationName, fieldResolver));
  });
}

/**
 * The graphqlSync function also fulfills GraphQL operations by parsing,
 * validating, and executing a GraphQL document along side a GraphQL schema.
 * However, it guarantees to complete synchronously (or throw an error) assuming
 * that all field resolvers are also synchronous.
 */

/* eslint-disable no-redeclare */

function graphqlSync(argsOrSchema, source, rootValue, contextValue, variableValues, operationName, fieldResolver) {
  // Extract arguments from object args if provided.
  var result = arguments.length === 1 ? graphqlImpl(argsOrSchema.schema, argsOrSchema.source, argsOrSchema.rootValue, argsOrSchema.contextValue, argsOrSchema.variableValues, argsOrSchema.operationName, argsOrSchema.fieldResolver) : graphqlImpl(argsOrSchema, source, rootValue, contextValue, variableValues, operationName, fieldResolver);

  // Assert that the execution was synchronous.
  if (result.then) {
    throw new Error('GraphQL execution failed to complete synchronously.');
  }

  return result;
}

function graphqlImpl(schema, source, rootValue, contextValue, variableValues, operationName, fieldResolver) {
  // Validate Schema
  var schemaValidationErrors = Object(__WEBPACK_IMPORTED_MODULE_0__type_validate__["b" /* validateSchema */])(schema);
  if (schemaValidationErrors.length > 0) {
    return { errors: schemaValidationErrors };
  }

  // Parse
  var document = void 0;
  try {
    document = Object(__WEBPACK_IMPORTED_MODULE_1__language_parser__["a" /* parse */])(source);
  } catch (syntaxError) {
    return { errors: [syntaxError] };
  }

  // Validate
  var validationErrors = Object(__WEBPACK_IMPORTED_MODULE_2__validation_validate__["a" /* validate */])(schema, document);
  if (validationErrors.length > 0) {
    return { errors: validationErrors };
  }

  // Execute
  return Object(__WEBPACK_IMPORTED_MODULE_3__execution_execute__["f" /* execute */])(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver);
}

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = syntaxError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GraphQLError__ = __webpack_require__(106);



/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

function syntaxError(source, position, description) {
  return new __WEBPACK_IMPORTED_MODULE_0__GraphQLError__["a" /* GraphQLError */]('Syntax Error: ' + description, undefined, source, [position]);
}

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export formatError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsutils_invariant__ = __webpack_require__(79);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */




/**
 * Given a GraphQLError, format it according to the rules described by the
 * Response Format, Errors section of the GraphQL Specification.
 */
function formatError(error) {
  !error ? Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_invariant__["a" /* default */])(0, 'Received null or undefined error.') : void 0;
  return _extends({}, error.extensions, {
    message: error.message || 'An unknown error occurred.',
    locations: error.locations,
    path: error.path
  });
}

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export nonExecutableDefinitionMessage */
/* harmony export (immutable) */ __webpack_exports__["a"] = ExecutableDefinitions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__language_kinds__ = __webpack_require__(57);

 /**
                                             * Copyright (c) 2015-present, Facebook, Inc.
                                             *
                                             * This source code is licensed under the MIT license found in the
                                             * LICENSE file in the root directory of this source tree.
                                             *
                                             *  strict
                                             */




function nonExecutableDefinitionMessage(defName) {
  return 'The ' + defName + ' definition is not executable.';
}

/**
 * Executable definitions
 *
 * A GraphQL document is only valid for execution if all definitions are either
 * operation or fragment definitions.
 */
function ExecutableDefinitions(context) {
  return {
    Document: function Document(node) {
      node.definitions.forEach(function (definition) {
        if (definition.kind !== __WEBPACK_IMPORTED_MODULE_1__language_kinds__["a" /* Kind */].OPERATION_DEFINITION && definition.kind !== __WEBPACK_IMPORTED_MODULE_1__language_kinds__["a" /* Kind */].FRAGMENT_DEFINITION) {
          context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* GraphQLError */](nonExecutableDefinitionMessage(definition.kind === __WEBPACK_IMPORTED_MODULE_1__language_kinds__["a" /* Kind */].SCHEMA_DEFINITION ? 'schema' : definition.name.value), [definition]));
        }
      });
      return false;
    }
  };
}

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = memoize3;
/**
 * Copyright (c) 2017-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Memoizes the provided three-argument function.
 */
function memoize3(fn) {
  var cache0 = void 0;
  function memoized(a1, a2, a3) {
    if (!cache0) {
      cache0 = new WeakMap();
    }
    var cache1 = cache0.get(a1);
    var cache2 = void 0;
    if (cache1) {
      cache2 = cache1.get(a2);
      if (cache2) {
        var cachedValue = cache2.get(a3);
        if (cachedValue !== undefined) {
          return cachedValue;
        }
      }
    } else {
      cache1 = new WeakMap();
      cache0.set(a1, cache1);
    }
    if (!cache2) {
      cache2 = new WeakMap();
      cache1.set(a2, cache2);
    }
    var newValue = fn.apply(this, arguments);
    cache2.set(a3, newValue);
    return newValue;
  }
  return memoized;
}

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = promiseForObject;


/**
 * This function transforms a JS object `ObjMap<Promise<T>>` into
 * a `Promise<ObjMap<T>>`
 *
 * This is akin to bluebird's `Promise.props`, but implemented only using
 * `Promise.all` so it will work with any implementation of ES6 promises.
 */
function promiseForObject(object) {
  var keys = Object.keys(object);
  var valuesAndPromises = keys.map(function (name) {
    return object[name];
  });
  return Promise.all(valuesAndPromises).then(function (values) {
    return values.reduce(function (resolvedObject, value, i) {
      resolvedObject[keys[i]] = value;
      return resolvedObject;
    }, Object.create(null));
  });
} /**
   * Copyright (c) 2015-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *
   *  strict
   */

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = promiseReduce;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPromise__ = __webpack_require__(422);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */




/**
 * Similar to Array.prototype.reduce(), however the reducing callback may return
 * a Promise, in which case reduction will continue after each promise resolves.
 *
 * If the callback does not return a Promise, then this function will also not
 * return a Promise.
 */
function promiseReduce(values, callback, initialValue) {
  return values.reduce(function (previous, value) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__isPromise__["a" /* default */])(previous) ? previous.then(function (resolved) {
      return callback(resolved, value);
    }) : callback(previous, value);
  }, initialValue);
}

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schema__ = __webpack_require__(75);
/* unused harmony reexport isSchema */
/* unused harmony reexport GraphQLSchema */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__definition__ = __webpack_require__(46);
/* unused harmony reexport isType */
/* unused harmony reexport isScalarType */
/* unused harmony reexport isObjectType */
/* unused harmony reexport isInterfaceType */
/* unused harmony reexport isUnionType */
/* unused harmony reexport isEnumType */
/* unused harmony reexport isInputObjectType */
/* unused harmony reexport isListType */
/* unused harmony reexport isNonNullType */
/* unused harmony reexport isInputType */
/* unused harmony reexport isOutputType */
/* unused harmony reexport isLeafType */
/* unused harmony reexport isCompositeType */
/* unused harmony reexport isAbstractType */
/* unused harmony reexport isWrappingType */
/* unused harmony reexport isNullableType */
/* unused harmony reexport isNamedType */
/* unused harmony reexport assertType */
/* unused harmony reexport assertScalarType */
/* unused harmony reexport assertObjectType */
/* unused harmony reexport assertInterfaceType */
/* unused harmony reexport assertUnionType */
/* unused harmony reexport assertEnumType */
/* unused harmony reexport assertInputObjectType */
/* unused harmony reexport assertListType */
/* unused harmony reexport assertNonNullType */
/* unused harmony reexport assertInputType */
/* unused harmony reexport assertOutputType */
/* unused harmony reexport assertLeafType */
/* unused harmony reexport assertCompositeType */
/* unused harmony reexport assertAbstractType */
/* unused harmony reexport assertWrappingType */
/* unused harmony reexport assertNullableType */
/* unused harmony reexport assertNamedType */
/* unused harmony reexport getNullableType */
/* unused harmony reexport getNamedType */
/* unused harmony reexport GraphQLScalarType */
/* unused harmony reexport GraphQLObjectType */
/* unused harmony reexport GraphQLInterfaceType */
/* unused harmony reexport GraphQLUnionType */
/* unused harmony reexport GraphQLEnumType */
/* unused harmony reexport GraphQLInputObjectType */
/* unused harmony reexport GraphQLList */
/* unused harmony reexport GraphQLNonNull */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(88);
/* unused harmony reexport isDirective */
/* unused harmony reexport GraphQLDirective */
/* unused harmony reexport isSpecifiedDirective */
/* unused harmony reexport specifiedDirectives */
/* unused harmony reexport GraphQLIncludeDirective */
/* unused harmony reexport GraphQLSkipDirective */
/* unused harmony reexport GraphQLDeprecatedDirective */
/* unused harmony reexport DEFAULT_DEPRECATION_REASON */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scalars__ = __webpack_require__(104);
/* unused harmony reexport isSpecifiedScalarType */
/* unused harmony reexport specifiedScalarTypes */
/* unused harmony reexport GraphQLInt */
/* unused harmony reexport GraphQLFloat */
/* unused harmony reexport GraphQLString */
/* unused harmony reexport GraphQLBoolean */
/* unused harmony reexport GraphQLID */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__introspection__ = __webpack_require__(89);
/* unused harmony reexport TypeKind */
/* unused harmony reexport isIntrospectionType */
/* unused harmony reexport introspectionTypes */
/* unused harmony reexport __Schema */
/* unused harmony reexport __Directive */
/* unused harmony reexport __DirectiveLocation */
/* unused harmony reexport __Type */
/* unused harmony reexport __Field */
/* unused harmony reexport __InputValue */
/* unused harmony reexport __EnumValue */
/* unused harmony reexport __TypeKind */
/* unused harmony reexport SchemaMetaFieldDef */
/* unused harmony reexport TypeMetaFieldDef */
/* unused harmony reexport TypeNameMetaFieldDef */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__validate__ = __webpack_require__(208);
/* unused harmony reexport validateSchema */
/* unused harmony reexport assertValidSchema */
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */







// Common built-in scalar instances.






/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__location__ = __webpack_require__(274);
/* unused harmony reexport getLocation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__kinds__ = __webpack_require__(57);
/* unused harmony reexport Kind */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lexer__ = __webpack_require__(275);
/* unused harmony reexport createLexer */
/* unused harmony reexport TokenKind */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parser__ = __webpack_require__(168);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__parser__["a"]; });
/* unused harmony reexport parseValue */
/* unused harmony reexport parseType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__printer__ = __webpack_require__(95);
/* unused harmony reexport print */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__source__ = __webpack_require__(392);
/* unused harmony reexport Source */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__visitor__ = __webpack_require__(96);
/* unused harmony reexport visit */
/* unused harmony reexport visitInParallel */
/* unused harmony reexport visitWithTypeInfo */
/* unused harmony reexport getVisitFn */
/* unused harmony reexport BREAK */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directiveLocation__ = __webpack_require__(138);
/* unused harmony reexport DirectiveLocation */
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */














/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__execute__ = __webpack_require__(212);
/* unused harmony reexport execute */
/* unused harmony reexport defaultFieldResolver */
/* unused harmony reexport responsePathAsArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__values__ = __webpack_require__(213);
/* unused harmony reexport getDirectiveValues */
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */




/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__subscribe__ = __webpack_require__(688);
/* unused harmony reexport subscribe */
/* unused harmony reexport createSourceEventStream */
/**
 * Copyright (c) 2017-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */



/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export subscribe */
/* unused harmony export createSourceEventStream */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_iterall__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error_GraphQLError__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__error_locatedError__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__execution_execute__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__type_schema__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapAsyncIterator__ = __webpack_require__(689);
/**
 * Copyright (c) 2017-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */








/**
 * Implements the "Subscribe" algorithm described in the GraphQL specification.
 *
 * Returns a Promise which resolves to either an AsyncIterator (if successful)
 * or an ExecutionResult (client error). The promise will be rejected if a
 * server error occurs.
 *
 * If the client-provided arguments to this function do not result in a
 * compliant subscription, a GraphQL Response (ExecutionResult) with
 * descriptive errors and no data will be returned.
 *
 * If the the source stream could not be created due to faulty subscription
 * resolver logic or underlying systems, the promise will resolve to a single
 * ExecutionResult containing `errors` and no `data`.
 *
 * If the operation succeeded, the promise resolves to an AsyncIterator, which
 * yields a stream of ExecutionResults representing the response stream.
 *
 * Accepts either an object with named arguments, or individual arguments.
 */

/* eslint-disable no-redeclare */

function subscribe(argsOrSchema, document, rootValue, contextValue, variableValues, operationName, fieldResolver, subscribeFieldResolver) {
  /* eslint-enable no-redeclare */
  // Extract arguments from object args if provided.
  return arguments.length === 1 ? subscribeImpl(argsOrSchema.schema, argsOrSchema.document, argsOrSchema.rootValue, argsOrSchema.contextValue, argsOrSchema.variableValues, argsOrSchema.operationName, argsOrSchema.fieldResolver, argsOrSchema.subscribeFieldResolver) : subscribeImpl(argsOrSchema, document, rootValue, contextValue, variableValues, operationName, fieldResolver, subscribeFieldResolver);
}

/**
 * This function checks if the error is a GraphQLError. If it is, report it as
 * an ExecutionResult, containing only errors and no data. Otherwise treat the
 * error as a system-class error and re-throw it.
 */
function reportGraphQLError(error) {
  if (error instanceof __WEBPACK_IMPORTED_MODULE_1__error_GraphQLError__["a" /* GraphQLError */]) {
    return { errors: [error] };
  }
  throw error;
}

function subscribeImpl(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver, subscribeFieldResolver) {
  var sourcePromise = createSourceEventStream(schema, document, rootValue, contextValue, variableValues, operationName, subscribeFieldResolver);

  // For each payload yielded from a subscription, map it over the normal
  // GraphQL `execute` function, with `payload` as the rootValue.
  // This implements the "MapSourceToResponseEvent" algorithm described in
  // the GraphQL specification. The `execute` function provides the
  // "ExecuteSubscriptionEvent" algorithm, as it is nearly identical to the
  // "ExecuteQuery" algorithm, for which `execute` is also used.
  var mapSourceToResponse = function mapSourceToResponse(payload) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__execution_execute__["f" /* execute */])(schema, document, payload, contextValue, variableValues, operationName, fieldResolver);
  };

  // Resolve the Source Stream, then map every source value to a
  // ExecutionResult value as described above.
  return sourcePromise.then(function (resultOrStream) {
    return (
      // Note: Flow can't refine isAsyncIterable, so explicit casts are used.
      Object(__WEBPACK_IMPORTED_MODULE_0_iterall__["d" /* isAsyncIterable */])(resultOrStream) ? Object(__WEBPACK_IMPORTED_MODULE_5__mapAsyncIterator__["a" /* default */])(resultOrStream, mapSourceToResponse, reportGraphQLError) : resultOrStream
    );
  }, reportGraphQLError);
}

/**
 * Implements the "CreateSourceEventStream" algorithm described in the
 * GraphQL specification, resolving the subscription source event stream.
 *
 * Returns a Promise<AsyncIterable>.
 *
 * If the client-provided invalid arguments, the source stream could not be
 * created, or the resolver did not return an AsyncIterable, this function will
 * will throw an error, which should be caught and handled by the caller.
 *
 * A Source Event Stream represents a sequence of events, each of which triggers
 * a GraphQL execution for that event.
 *
 * This may be useful when hosting the stateful subscription service in a
 * different process or machine than the stateless GraphQL execution engine,
 * or otherwise separating these two steps. For more on this, see the
 * "Supporting Subscriptions at Scale" information in the GraphQL specification.
 */
function createSourceEventStream(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver) {
  // If arguments are missing or incorrectly typed, this is an internal
  // developer mistake which should throw an early error.
  Object(__WEBPACK_IMPORTED_MODULE_3__execution_execute__["b" /* assertValidExecutionArguments */])(schema, document, variableValues);

  try {
    // If a valid context cannot be created due to incorrect arguments,
    // this will throw an error.
    var exeContext = Object(__WEBPACK_IMPORTED_MODULE_3__execution_execute__["c" /* buildExecutionContext */])(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver);

    // Return early errors if execution context failed.
    if (Array.isArray(exeContext)) {
      return Promise.resolve({ errors: exeContext });
    }

    var type = Object(__WEBPACK_IMPORTED_MODULE_3__execution_execute__["h" /* getOperationRootType */])(schema, exeContext.operation);
    var fields = Object(__WEBPACK_IMPORTED_MODULE_3__execution_execute__["e" /* collectFields */])(exeContext, type, exeContext.operation.selectionSet, Object.create(null), Object.create(null));
    var responseNames = Object.keys(fields);
    var responseName = responseNames[0];
    var fieldNodes = fields[responseName];
    var fieldNode = fieldNodes[0];
    var fieldName = fieldNode.name.value;
    var fieldDef = Object(__WEBPACK_IMPORTED_MODULE_3__execution_execute__["g" /* getFieldDef */])(schema, type, fieldName);

    if (!fieldDef) {
      throw new __WEBPACK_IMPORTED_MODULE_1__error_GraphQLError__["a" /* GraphQLError */]('The subscription field "' + fieldName + '" is not defined.', fieldNodes);
    }

    // Call the `subscribe()` resolver or the default resolver to produce an
    // AsyncIterable yielding raw payloads.
    var resolveFn = fieldDef.subscribe || exeContext.fieldResolver;

    var path = Object(__WEBPACK_IMPORTED_MODULE_3__execution_execute__["a" /* addPath */])(undefined, responseName);

    var info = Object(__WEBPACK_IMPORTED_MODULE_3__execution_execute__["d" /* buildResolveInfo */])(exeContext, fieldDef, fieldNodes, type, path);

    // resolveFieldValueOrError implements the "ResolveFieldEventStream"
    // algorithm from GraphQL specification. It differs from
    // "ResolveFieldValue" due to providing a different `resolveFn`.
    var result = Object(__WEBPACK_IMPORTED_MODULE_3__execution_execute__["i" /* resolveFieldValueOrError */])(exeContext, fieldDef, fieldNodes, resolveFn, rootValue, info);

    // Coerce to Promise for easier error handling and consistent return type.
    return Promise.resolve(result).then(function (eventStream) {
      // If eventStream is an Error, rethrow a located error.
      if (eventStream instanceof Error) {
        throw Object(__WEBPACK_IMPORTED_MODULE_2__error_locatedError__["a" /* locatedError */])(eventStream, fieldNodes, Object(__WEBPACK_IMPORTED_MODULE_3__execution_execute__["j" /* responsePathAsArray */])(path));
      }

      // Assert field returned an event stream, otherwise yield an error.
      if (Object(__WEBPACK_IMPORTED_MODULE_0_iterall__["d" /* isAsyncIterable */])(eventStream)) {
        // Note: isAsyncIterable above ensures this will be correct.
        return eventStream;
      }
      throw new Error('Subscription field must return Async Iterable. Received: ' + String(eventStream));
    });
  } catch (error) {
    return Promise.reject(error);
  }
}

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mapAsyncIterator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_iterall__ = __webpack_require__(167);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */




/**
 * Given an AsyncIterable and a callback function, return an AsyncIterator
 * which produces values mapped via calling the callback function.
 */
function mapAsyncIterator(iterable, callback, rejectCallback) {
  var iterator = Object(__WEBPACK_IMPORTED_MODULE_0_iterall__["c" /* getAsyncIterator */])(iterable);
  var $return = void 0;
  var abruptClose = void 0;
  // $FlowFixMe(>=0.68.0)
  if (typeof iterator.return === 'function') {
    $return = iterator.return;
    abruptClose = function abruptClose(error) {
      var rethrow = function rethrow() {
        return Promise.reject(error);
      };
      return $return.call(iterator).then(rethrow, rethrow);
    };
  }

  function mapResult(result) {
    return result.done ? result : asyncMapValue(result.value, callback).then(iteratorResult, abruptClose);
  }

  var mapReject = void 0;
  if (rejectCallback) {
    // Capture rejectCallback to ensure it cannot be null.
    var reject = rejectCallback;
    mapReject = function mapReject(error) {
      return asyncMapValue(error, reject).then(iteratorResult, abruptClose);
    };
  }

  /* TODO: Flow doesn't support symbols as keys:
     https://github.com/facebook/flow/issues/3258 */
  return _defineProperty({
    next: function next() {
      return iterator.next().then(mapResult, mapReject);
    },
    return: function _return() {
      return $return ? $return.call(iterator).then(mapResult, mapReject) : Promise.resolve({ value: undefined, done: true });
    },
    throw: function _throw(error) {
      // $FlowFixMe(>=0.68.0)
      if (typeof iterator.throw === 'function') {
        return iterator.throw(error).then(mapResult, mapReject);
      }
      return Promise.reject(error).catch(abruptClose);
    }
  }, __WEBPACK_IMPORTED_MODULE_0_iterall__["a" /* $$asyncIterator */], function () {
    return this;
  });
}

function asyncMapValue(value, callback) {
  return new Promise(function (resolve) {
    return resolve(callback(value));
  });
}

function iteratorResult(value) {
  return { value: value, done: false };
}

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__validate__ = __webpack_require__(395);
/* unused harmony reexport validate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ValidationContext__ = __webpack_require__(279);
/* unused harmony reexport ValidationContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__specifiedRules__ = __webpack_require__(396);
/* unused harmony reexport specifiedRules */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rules_FieldsOnCorrectType__ = __webpack_require__(404);
/* unused harmony reexport FieldsOnCorrectTypeRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rules_FragmentsOnCompositeTypes__ = __webpack_require__(401);
/* unused harmony reexport FragmentsOnCompositeTypesRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_KnownArgumentNames__ = __webpack_require__(415);
/* unused harmony reexport KnownArgumentNamesRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_KnownDirectives__ = __webpack_require__(413);
/* unused harmony reexport KnownDirectivesRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rules_KnownFragmentNames__ = __webpack_require__(406);
/* unused harmony reexport KnownFragmentNamesRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__rules_KnownTypeNames__ = __webpack_require__(400);
/* unused harmony reexport KnownTypeNamesRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__rules_LoneAnonymousOperation__ = __webpack_require__(398);
/* unused harmony reexport LoneAnonymousOperationRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__rules_NoFragmentCycles__ = __webpack_require__(409);
/* unused harmony reexport NoFragmentCyclesRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__rules_NoUndefinedVariables__ = __webpack_require__(411);
/* unused harmony reexport NoUndefinedVariablesRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__rules_NoUnusedFragments__ = __webpack_require__(407);
/* unused harmony reexport NoUnusedFragmentsRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__rules_NoUnusedVariables__ = __webpack_require__(412);
/* unused harmony reexport NoUnusedVariablesRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__rules_OverlappingFieldsCanBeMerged__ = __webpack_require__(420);
/* unused harmony reexport OverlappingFieldsCanBeMergedRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__rules_PossibleFragmentSpreads__ = __webpack_require__(408);
/* unused harmony reexport PossibleFragmentSpreadsRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__rules_ProvidedNonNullArguments__ = __webpack_require__(417);
/* unused harmony reexport ProvidedNonNullArgumentsRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__rules_ScalarLeafs__ = __webpack_require__(403);
/* unused harmony reexport ScalarLeafsRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__rules_SingleFieldSubscriptions__ = __webpack_require__(399);
/* unused harmony reexport SingleFieldSubscriptionsRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__rules_UniqueArgumentNames__ = __webpack_require__(416);
/* unused harmony reexport UniqueArgumentNamesRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__rules_UniqueDirectivesPerLocation__ = __webpack_require__(414);
/* unused harmony reexport UniqueDirectivesPerLocationRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__rules_UniqueFragmentNames__ = __webpack_require__(405);
/* unused harmony reexport UniqueFragmentNamesRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__rules_UniqueInputFieldNames__ = __webpack_require__(421);
/* unused harmony reexport UniqueInputFieldNamesRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__rules_UniqueOperationNames__ = __webpack_require__(397);
/* unused harmony reexport UniqueOperationNamesRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__rules_UniqueVariableNames__ = __webpack_require__(410);
/* unused harmony reexport UniqueVariableNamesRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__rules_ValuesOfCorrectType__ = __webpack_require__(278);
/* unused harmony reexport ValuesOfCorrectTypeRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__rules_VariablesAreInputTypes__ = __webpack_require__(402);
/* unused harmony reexport VariablesAreInputTypesRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__rules_VariablesDefaultValueAllowed__ = __webpack_require__(418);
/* unused harmony reexport VariablesDefaultValueAllowedRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__rules_VariablesInAllowedPosition__ = __webpack_require__(419);
/* unused harmony reexport VariablesInAllowedPositionRule */
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */



// https://github.com/tc39/proposal-export-default-from





// Spec Section: "Field Selections on Objects, Interfaces, and Unions Types"


// Spec Section: "Fragments on Composite Types"


// Spec Section: "Argument Names"


// Spec Section: "Directives Are Defined"


// Spec Section: "Fragment spread target defined"


// Spec Section: "Fragment Spread Type Existence"


// Spec Section: "Lone Anonymous Operation"


// Spec Section: "Fragments must not form cycles"


// Spec Section: "All Variable Used Defined"


// Spec Section: "Fragments must be used"


// Spec Section: "All Variables Used"


// Spec Section: "Field Selection Merging"


// Spec Section: "Fragment spread is possible"


// Spec Section: "Argument Optionality"


// Spec Section: "Leaf Field Selections"


// Spec Section: "Subscriptions with Single Root Field"


// Spec Section: "Argument Uniqueness"


// Spec Section: "Directives Are Unique Per Location"


// Spec Section: "Fragment Name Uniqueness"


// Spec Section: "Input Object Field Uniqueness"


// Spec Section: "Operation Name Uniqueness"


// Spec Section: "Variable Uniqueness"


// Spec Section: "Values Type Correctness"


// Spec Section: "Variables are Input Types"


// Spec Section: "Variables Default Value Is Allowed"


// Spec Section: "All Variable Usages Are Allowed"


/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__introspectionQuery__ = __webpack_require__(423);
/* unused harmony reexport getIntrospectionQuery */
/* unused harmony reexport introspectionQuery */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getOperationAST__ = __webpack_require__(692);
/* unused harmony reexport getOperationAST */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__introspectionFromSchema__ = __webpack_require__(693);
/* unused harmony reexport introspectionFromSchema */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__buildClientSchema__ = __webpack_require__(694);
/* unused harmony reexport buildClientSchema */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__buildASTSchema__ = __webpack_require__(424);
/* unused harmony reexport buildASTSchema */
/* unused harmony reexport buildSchema */
/* unused harmony reexport getDescription */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__extendSchema__ = __webpack_require__(695);
/* unused harmony reexport extendSchema */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lexicographicSortSchema__ = __webpack_require__(696);
/* unused harmony reexport lexicographicSortSchema */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__schemaPrinter__ = __webpack_require__(697);
/* unused harmony reexport printSchema */
/* unused harmony reexport printType */
/* unused harmony reexport printIntrospectionSchema */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__typeFromAST__ = __webpack_require__(97);
/* unused harmony reexport typeFromAST */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__valueFromAST__ = __webpack_require__(214);
/* unused harmony reexport valueFromAST */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__valueFromASTUntyped__ = __webpack_require__(389);
/* unused harmony reexport valueFromASTUntyped */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__astFromValue__ = __webpack_require__(273);
/* unused harmony reexport astFromValue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__TypeInfo__ = __webpack_require__(169);
/* unused harmony reexport TypeInfo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__coerceValue__ = __webpack_require__(280);
/* unused harmony reexport coerceValue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__isValidJSValue__ = __webpack_require__(698);
/* unused harmony reexport isValidJSValue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__isValidLiteralValue__ = __webpack_require__(699);
/* unused harmony reexport isValidLiteralValue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__concatAST__ = __webpack_require__(700);
/* unused harmony reexport concatAST */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__separateOperations__ = __webpack_require__(701);
/* unused harmony reexport separateOperations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__typeComparators__ = __webpack_require__(211);
/* unused harmony reexport isEqualType */
/* unused harmony reexport isTypeSubTypeOf */
/* unused harmony reexport doTypesOverlap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assertValidName__ = __webpack_require__(391);
/* unused harmony reexport assertValidName */
/* unused harmony reexport isValidNameError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__findBreakingChanges__ = __webpack_require__(702);
/* unused harmony reexport BreakingChangeType */
/* unused harmony reexport DangerousChangeType */
/* unused harmony reexport findBreakingChanges */
/* unused harmony reexport findDangerousChanges */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__findDeprecatedUsages__ = __webpack_require__(703);
/* unused harmony reexport findDeprecatedUsages */
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

// The GraphQL query recommended for a full schema introspection.



// Gets the target Operation from a Document


// Convert a GraphQLSchema to an IntrospectionQuery


// Build a GraphQLSchema from an introspection result.


// Build a GraphQLSchema from GraphQL Schema language.



// Extends an existing GraphQLSchema from a parsed GraphQL Schema language AST.


// Sort a GraphQLSchema.


// Print a GraphQLSchema to GraphQL Schema language.


// Create a GraphQLType from a GraphQL language AST.


// Create a JavaScript value from a GraphQL language AST with a type.


// Create a JavaScript value from a GraphQL language AST without a type.


// Create a GraphQL language AST from a JavaScript value.


// A helper to use within recursive-descent visitors which need to be aware of
// the GraphQL type system.


// Coerces a JavaScript value to a GraphQL type, or produces errors.


// @deprecated use coerceValue


// Determine if AST values adhere to a GraphQL type.


// Concatenates multiple AST together.


// Separates an AST into an AST per Operation.


// Comparators for types


// Asserts that a string is a valid GraphQL name


// Compares two GraphQLSchemas and detects breaking changes.



// Report all deprecated usage within a GraphQL document.


/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getOperationAST */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__language_kinds__ = __webpack_require__(57);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */




/**
 * Returns an operation AST given a document AST and optionally an operation
 * name. If a name is not provided, an operation is only returned if only one is
 * provided in the document.
 */
function getOperationAST(documentAST, operationName) {
  var operation = null;
  for (var i = 0; i < documentAST.definitions.length; i++) {
    var definition = documentAST.definitions[i];
    if (definition.kind === __WEBPACK_IMPORTED_MODULE_0__language_kinds__["a" /* Kind */].OPERATION_DEFINITION) {
      if (!operationName) {
        // If no operation name was provided, only return an Operation if there
        // is one defined in the document. Upon encountering the second, return
        // null.
        if (operation) {
          return null;
        }
        operation = definition;
      } else if (definition.name && definition.name.value === operationName) {
        return definition;
      }
    }
  }
  return operation;
}

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export introspectionFromSchema */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsutils_invariant__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__introspectionQuery__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type_schema__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__execution_execute__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__language_parser__ = __webpack_require__(168);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */








/**
 * Build an IntrospectionQuery from a GraphQLSchema
 *
 * IntrospectionQuery is useful for utilities that care about type and field
 * relationships, but do not need to traverse through those relationships.
 *
 * This is the inverse of buildClientSchema. The primary use case is outside
 * of the server context, for instance when doing schema comparisons.
 */
function introspectionFromSchema(schema, options) {
  var queryAST = Object(__WEBPACK_IMPORTED_MODULE_4__language_parser__["a" /* parse */])(Object(__WEBPACK_IMPORTED_MODULE_1__introspectionQuery__["a" /* getIntrospectionQuery */])(options));
  var result = Object(__WEBPACK_IMPORTED_MODULE_3__execution_execute__["f" /* execute */])(schema, queryAST);
  !(!result.then && !result.errors && result.data) ? Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_invariant__["a" /* default */])(0) : void 0;
  return result.data;
}

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export buildClientSchema */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsutils_invariant__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsutils_keyMap__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsutils_keyValMap__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__valueFromAST__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__language_parser__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__type_schema__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__language_directiveLocation__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__type_definition__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__type_directives__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__type_introspection__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__type_scalars__ = __webpack_require__(104);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */


















/**
 * Build a GraphQLSchema for use by client tools.
 *
 * Given the result of a client running the introspection query, creates and
 * returns a GraphQLSchema instance which can be then used with all graphql-js
 * tools, but cannot be used to execute a query, as introspection does not
 * represent the "resolver", "parse" or "serialize" functions or any other
 * server-internal mechanisms.
 *
 * This function expects a complete introspection result. Don't forget to check
 * the "errors" field of a server response before calling this function.
 */
function buildClientSchema(introspection, options) {
  // Get the schema from the introspection result.
  var schemaIntrospection = introspection.__schema;

  // Converts the list of types into a keyMap based on the type names.
  var typeIntrospectionMap = Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_keyMap__["a" /* default */])(schemaIntrospection.types, function (type) {
    return type.name;
  });

  // A cache to use to store the actual GraphQLType definition objects by name.
  // Initialize to the GraphQL built in scalars. All functions below are inline
  // so that this type def cache is within the scope of the closure.
  var typeDefCache = Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_keyMap__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_10__type_scalars__["e" /* specifiedScalarTypes */].concat(__WEBPACK_IMPORTED_MODULE_9__type_introspection__["f" /* introspectionTypes */]), function (type) {
    return type.name;
  });

  // Given a type reference in introspection, return the GraphQLType instance.
  // preferring cached instances before building new instances.
  function getType(typeRef) {
    if (typeRef.kind === __WEBPACK_IMPORTED_MODULE_9__type_introspection__["b" /* TypeKind */].LIST) {
      var itemRef = typeRef.ofType;
      if (!itemRef) {
        throw new Error('Decorated type deeper than introspection query.');
      }
      return Object(__WEBPACK_IMPORTED_MODULE_7__type_definition__["d" /* GraphQLList */])(getType(itemRef));
    }
    if (typeRef.kind === __WEBPACK_IMPORTED_MODULE_9__type_introspection__["b" /* TypeKind */].NON_NULL) {
      var nullableRef = typeRef.ofType;
      if (!nullableRef) {
        throw new Error('Decorated type deeper than introspection query.');
      }
      var nullableType = getType(nullableRef);
      return Object(__WEBPACK_IMPORTED_MODULE_7__type_definition__["e" /* GraphQLNonNull */])(Object(__WEBPACK_IMPORTED_MODULE_7__type_definition__["j" /* assertNullableType */])(nullableType));
    }
    if (!typeRef.name) {
      throw new Error('Unknown type reference: ' + JSON.stringify(typeRef));
    }
    return getNamedType(typeRef.name);
  }

  function getNamedType(typeName) {
    if (typeDefCache[typeName]) {
      return typeDefCache[typeName];
    }
    var typeIntrospection = typeIntrospectionMap[typeName];
    if (!typeIntrospection) {
      throw new Error('Invalid or incomplete schema, unknown type: ' + typeName + '. Ensure ' + 'that a full introspection query is used in order to build a ' + 'client schema.');
    }
    var typeDef = buildType(typeIntrospection);
    typeDefCache[typeName] = typeDef;
    return typeDef;
  }

  function getInputType(typeRef) {
    var type = getType(typeRef);
    !Object(__WEBPACK_IMPORTED_MODULE_7__type_definition__["r" /* isInputType */])(type) ? Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_invariant__["a" /* default */])(0, 'Introspection must provide input type for arguments.') : void 0;
    return type;
  }

  function getOutputType(typeRef) {
    var type = getType(typeRef);
    !Object(__WEBPACK_IMPORTED_MODULE_7__type_definition__["y" /* isOutputType */])(type) ? Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_invariant__["a" /* default */])(0, 'Introspection must provide output type for fields.') : void 0;
    return type;
  }

  function getObjectType(typeRef) {
    var type = getType(typeRef);
    return Object(__WEBPACK_IMPORTED_MODULE_7__type_definition__["k" /* assertObjectType */])(type);
  }

  function getInterfaceType(typeRef) {
    var type = getType(typeRef);
    return Object(__WEBPACK_IMPORTED_MODULE_7__type_definition__["i" /* assertInterfaceType */])(type);
  }

  // Given a type's introspection result, construct the correct
  // GraphQLType instance.
  function buildType(type) {
    if (type && type.name && type.kind) {
      switch (type.kind) {
        case __WEBPACK_IMPORTED_MODULE_9__type_introspection__["b" /* TypeKind */].SCALAR:
          return buildScalarDef(type);
        case __WEBPACK_IMPORTED_MODULE_9__type_introspection__["b" /* TypeKind */].OBJECT:
          return buildObjectDef(type);
        case __WEBPACK_IMPORTED_MODULE_9__type_introspection__["b" /* TypeKind */].INTERFACE:
          return buildInterfaceDef(type);
        case __WEBPACK_IMPORTED_MODULE_9__type_introspection__["b" /* TypeKind */].UNION:
          return buildUnionDef(type);
        case __WEBPACK_IMPORTED_MODULE_9__type_introspection__["b" /* TypeKind */].ENUM:
          return buildEnumDef(type);
        case __WEBPACK_IMPORTED_MODULE_9__type_introspection__["b" /* TypeKind */].INPUT_OBJECT:
          return buildInputObjectDef(type);
      }
    }
    throw new Error('Invalid or incomplete introspection result. Ensure that a full ' + 'introspection query is used in order to build a client schema:' + JSON.stringify(type));
  }

  function buildScalarDef(scalarIntrospection) {
    return new __WEBPACK_IMPORTED_MODULE_7__type_definition__["g" /* GraphQLScalarType */]({
      name: scalarIntrospection.name,
      description: scalarIntrospection.description,
      serialize: function serialize(value) {
        return value;
      }
    });
  }

  function buildObjectDef(objectIntrospection) {
    if (!objectIntrospection.interfaces) {
      throw new Error('Introspection result missing interfaces: ' + JSON.stringify(objectIntrospection));
    }
    return new __WEBPACK_IMPORTED_MODULE_7__type_definition__["f" /* GraphQLObjectType */]({
      name: objectIntrospection.name,
      description: objectIntrospection.description,
      interfaces: objectIntrospection.interfaces.map(getInterfaceType),
      fields: function fields() {
        return buildFieldDefMap(objectIntrospection);
      }
    });
  }

  function buildInterfaceDef(interfaceIntrospection) {
    return new __WEBPACK_IMPORTED_MODULE_7__type_definition__["c" /* GraphQLInterfaceType */]({
      name: interfaceIntrospection.name,
      description: interfaceIntrospection.description,
      fields: function fields() {
        return buildFieldDefMap(interfaceIntrospection);
      }
    });
  }

  function buildUnionDef(unionIntrospection) {
    if (!unionIntrospection.possibleTypes) {
      throw new Error('Introspection result missing possibleTypes: ' + JSON.stringify(unionIntrospection));
    }
    return new __WEBPACK_IMPORTED_MODULE_7__type_definition__["h" /* GraphQLUnionType */]({
      name: unionIntrospection.name,
      description: unionIntrospection.description,
      types: unionIntrospection.possibleTypes.map(getObjectType)
    });
  }

  function buildEnumDef(enumIntrospection) {
    if (!enumIntrospection.enumValues) {
      throw new Error('Introspection result missing enumValues: ' + JSON.stringify(enumIntrospection));
    }
    return new __WEBPACK_IMPORTED_MODULE_7__type_definition__["a" /* GraphQLEnumType */]({
      name: enumIntrospection.name,
      description: enumIntrospection.description,
      values: Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_keyValMap__["a" /* default */])(enumIntrospection.enumValues, function (valueIntrospection) {
        return valueIntrospection.name;
      }, function (valueIntrospection) {
        return {
          description: valueIntrospection.description,
          deprecationReason: valueIntrospection.deprecationReason
        };
      })
    });
  }

  function buildInputObjectDef(inputObjectIntrospection) {
    if (!inputObjectIntrospection.inputFields) {
      throw new Error('Introspection result missing inputFields: ' + JSON.stringify(inputObjectIntrospection));
    }
    return new __WEBPACK_IMPORTED_MODULE_7__type_definition__["b" /* GraphQLInputObjectType */]({
      name: inputObjectIntrospection.name,
      description: inputObjectIntrospection.description,
      fields: function fields() {
        return buildInputValueDefMap(inputObjectIntrospection.inputFields);
      }
    });
  }

  function buildFieldDefMap(typeIntrospection) {
    if (!typeIntrospection.fields) {
      throw new Error('Introspection result missing fields: ' + JSON.stringify(typeIntrospection));
    }
    return Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_keyValMap__["a" /* default */])(typeIntrospection.fields, function (fieldIntrospection) {
      return fieldIntrospection.name;
    }, function (fieldIntrospection) {
      if (!fieldIntrospection.args) {
        throw new Error('Introspection result missing field args: ' + JSON.stringify(fieldIntrospection));
      }
      return {
        description: fieldIntrospection.description,
        deprecationReason: fieldIntrospection.deprecationReason,
        type: getOutputType(fieldIntrospection.type),
        args: buildInputValueDefMap(fieldIntrospection.args)
      };
    });
  }

  function buildInputValueDefMap(inputValueIntrospections) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_keyValMap__["a" /* default */])(inputValueIntrospections, function (inputValue) {
      return inputValue.name;
    }, buildInputValue);
  }

  function buildInputValue(inputValueIntrospection) {
    var type = getInputType(inputValueIntrospection.type);
    var defaultValue = inputValueIntrospection.defaultValue ? Object(__WEBPACK_IMPORTED_MODULE_3__valueFromAST__["a" /* valueFromAST */])(Object(__WEBPACK_IMPORTED_MODULE_4__language_parser__["b" /* parseValue */])(inputValueIntrospection.defaultValue), type) : undefined;
    return {
      name: inputValueIntrospection.name,
      description: inputValueIntrospection.description,
      type: type,
      defaultValue: defaultValue
    };
  }

  function buildDirective(directiveIntrospection) {
    // Support deprecated `on****` fields for building `locations`, as this
    // is used by GraphiQL which may need to support outdated servers.
    var locations = directiveIntrospection.locations ? directiveIntrospection.locations.slice() : [].concat(!directiveIntrospection.onField ? [] : [__WEBPACK_IMPORTED_MODULE_6__language_directiveLocation__["a" /* DirectiveLocation */].FIELD], !directiveIntrospection.onOperation ? [] : [__WEBPACK_IMPORTED_MODULE_6__language_directiveLocation__["a" /* DirectiveLocation */].QUERY, __WEBPACK_IMPORTED_MODULE_6__language_directiveLocation__["a" /* DirectiveLocation */].MUTATION, __WEBPACK_IMPORTED_MODULE_6__language_directiveLocation__["a" /* DirectiveLocation */].SUBSCRIPTION], !directiveIntrospection.onFragment ? [] : [__WEBPACK_IMPORTED_MODULE_6__language_directiveLocation__["a" /* DirectiveLocation */].FRAGMENT_DEFINITION, __WEBPACK_IMPORTED_MODULE_6__language_directiveLocation__["a" /* DirectiveLocation */].FRAGMENT_SPREAD, __WEBPACK_IMPORTED_MODULE_6__language_directiveLocation__["a" /* DirectiveLocation */].INLINE_FRAGMENT]);
    if (!directiveIntrospection.args) {
      throw new Error('Introspection result missing directive args: ' + JSON.stringify(directiveIntrospection));
    }
    return new __WEBPACK_IMPORTED_MODULE_8__type_directives__["c" /* GraphQLDirective */]({
      name: directiveIntrospection.name,
      description: directiveIntrospection.description,
      locations: locations,
      args: buildInputValueDefMap(directiveIntrospection.args)
    });
  }

  // Iterate through all types, getting the type definition for each, ensuring
  // that any type not directly referenced by a field will get created.
  var types = schemaIntrospection.types.map(function (typeIntrospection) {
    return getNamedType(typeIntrospection.name);
  });

  // Get the root Query, Mutation, and Subscription types.
  var queryType = schemaIntrospection.queryType ? getObjectType(schemaIntrospection.queryType) : null;

  var mutationType = schemaIntrospection.mutationType ? getObjectType(schemaIntrospection.mutationType) : null;

  var subscriptionType = schemaIntrospection.subscriptionType ? getObjectType(schemaIntrospection.subscriptionType) : null;

  // Get the directives supported by Introspection, assuming empty-set if
  // directives were not queried for.
  var directives = schemaIntrospection.directives ? schemaIntrospection.directives.map(buildDirective) : [];

  // Then produce and return a Schema with these types.
  return new __WEBPACK_IMPORTED_MODULE_5__type_schema__["a" /* GraphQLSchema */]({
    query: queryType,
    mutation: mutationType,
    subscription: subscriptionType,
    types: types,
    directives: directives,
    assumeValid: options && options.assumeValid,
    allowedLegacyNames: options && options.allowedLegacyNames
  });
}

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export extendSchema */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsutils_invariant__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsutils_keyMap__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsutils_objectValues__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__buildASTSchema__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__error_GraphQLError__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__type_schema__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__type_introspection__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__type_definition__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__type_directives__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__language_kinds__ = __webpack_require__(57);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */















/**
 * Produces a new schema given an existing schema and a document which may
 * contain GraphQL type extensions and definitions. The original schema will
 * remain unaltered.
 *
 * Because a schema represents a graph of references, a schema cannot be
 * extended without effectively making an entire copy. We do not know until it's
 * too late if subgraphs remain unchanged.
 *
 * This algorithm copies the provided schema, applying extensions while
 * producing the copy. The original schema remains unaltered.
 *
 * Accepts options as a third argument:
 *
 *    - commentDescriptions:
 *        Provide true to use preceding comments as the description.
 *
 */
function extendSchema(schema, documentAST, options) {
  !Object(__WEBPACK_IMPORTED_MODULE_5__type_schema__["b" /* isSchema */])(schema) ? Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_invariant__["a" /* default */])(0, 'Must provide valid GraphQLSchema') : void 0;

  !(documentAST && documentAST.kind === __WEBPACK_IMPORTED_MODULE_9__language_kinds__["a" /* Kind */].DOCUMENT) ? Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_invariant__["a" /* default */])(0, 'Must provide valid Document AST') : void 0;

  // Collect the type definitions and extensions found in the document.
  var typeDefinitionMap = Object.create(null);
  var typeExtensionsMap = Object.create(null);

  // New directives and types are separate because a directives and types can
  // have the same name. For example, a type named "skip".
  var directiveDefinitions = [];

  for (var i = 0; i < documentAST.definitions.length; i++) {
    var def = documentAST.definitions[i];
    switch (def.kind) {
      case __WEBPACK_IMPORTED_MODULE_9__language_kinds__["a" /* Kind */].OBJECT_TYPE_DEFINITION:
      case __WEBPACK_IMPORTED_MODULE_9__language_kinds__["a" /* Kind */].INTERFACE_TYPE_DEFINITION:
      case __WEBPACK_IMPORTED_MODULE_9__language_kinds__["a" /* Kind */].ENUM_TYPE_DEFINITION:
      case __WEBPACK_IMPORTED_MODULE_9__language_kinds__["a" /* Kind */].UNION_TYPE_DEFINITION:
      case __WEBPACK_IMPORTED_MODULE_9__language_kinds__["a" /* Kind */].SCALAR_TYPE_DEFINITION:
      case __WEBPACK_IMPORTED_MODULE_9__language_kinds__["a" /* Kind */].INPUT_OBJECT_TYPE_DEFINITION:
        // Sanity check that none of the defined types conflict with the
        // schema's existing types.
        var typeName = def.name.value;
        if (schema.getType(typeName)) {
          throw new __WEBPACK_IMPORTED_MODULE_4__error_GraphQLError__["a" /* GraphQLError */]('Type "' + typeName + '" already exists in the schema. It cannot also ' + 'be defined in this type definition.', [def]);
        }
        typeDefinitionMap[typeName] = def;
        break;
      case __WEBPACK_IMPORTED_MODULE_9__language_kinds__["a" /* Kind */].OBJECT_TYPE_EXTENSION:
      case __WEBPACK_IMPORTED_MODULE_9__language_kinds__["a" /* Kind */].INTERFACE_TYPE_EXTENSION:
        // Sanity check that this type extension exists within the
        // schema's existing types.
        var extendedTypeName = def.name.value;
        var existingType = schema.getType(extendedTypeName);
        if (!existingType) {
          throw new __WEBPACK_IMPORTED_MODULE_4__error_GraphQLError__["a" /* GraphQLError */]('Cannot extend type "' + extendedTypeName + '" because it does not ' + 'exist in the existing schema.', [def]);
        }
        checkExtensionNode(existingType, def);

        var existingTypeExtensions = typeExtensionsMap[extendedTypeName];
        typeExtensionsMap[extendedTypeName] = existingTypeExtensions ? existingTypeExtensions.concat([def]) : [def];
        break;
      case __WEBPACK_IMPORTED_MODULE_9__language_kinds__["a" /* Kind */].DIRECTIVE_DEFINITION:
        var directiveName = def.name.value;
        var existingDirective = schema.getDirective(directiveName);
        if (existingDirective) {
          throw new __WEBPACK_IMPORTED_MODULE_4__error_GraphQLError__["a" /* GraphQLError */]('Directive "' + directiveName + '" already exists in the schema. It ' + 'cannot be redefined.', [def]);
        }
        directiveDefinitions.push(def);
        break;
      case __WEBPACK_IMPORTED_MODULE_9__language_kinds__["a" /* Kind */].SCALAR_TYPE_EXTENSION:
      case __WEBPACK_IMPORTED_MODULE_9__language_kinds__["a" /* Kind */].UNION_TYPE_EXTENSION:
      case __WEBPACK_IMPORTED_MODULE_9__language_kinds__["a" /* Kind */].ENUM_TYPE_EXTENSION:
      case __WEBPACK_IMPORTED_MODULE_9__language_kinds__["a" /* Kind */].INPUT_OBJECT_TYPE_EXTENSION:
        throw new Error('The ' + def.kind + ' kind is not yet supported by extendSchema().');
    }
  }

  // If this document contains no new types, extensions, or directives then
  // return the same unmodified GraphQLSchema instance.
  if (Object.keys(typeExtensionsMap).length === 0 && Object.keys(typeDefinitionMap).length === 0 && directiveDefinitions.length === 0) {
    return schema;
  }

  var astBuilder = new __WEBPACK_IMPORTED_MODULE_3__buildASTSchema__["a" /* ASTDefinitionBuilder */](typeDefinitionMap, options, function (typeRef) {
    var typeName = typeRef.name.value;
    var existingType = schema.getType(typeName);
    if (existingType) {
      return getExtendedType(existingType);
    }

    throw new __WEBPACK_IMPORTED_MODULE_4__error_GraphQLError__["a" /* GraphQLError */]('Unknown type: "' + typeName + '". Ensure that this type exists ' + 'either in the original schema, or is added in a type definition.', [typeRef]);
  });

  var extendTypeCache = Object.create(null);

  // Get the root Query, Mutation, and Subscription object types.
  var existingQueryType = schema.getQueryType();
  var queryType = existingQueryType ? getExtendedType(existingQueryType) : null;

  var existingMutationType = schema.getMutationType();
  var mutationType = existingMutationType ? getExtendedType(existingMutationType) : null;

  var existingSubscriptionType = schema.getSubscriptionType();
  var subscriptionType = existingSubscriptionType ? getExtendedType(existingSubscriptionType) : null;

  var types = [].concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_objectValues__["a" /* default */])(schema.getTypeMap()).map(function (type) {
    return getExtendedType(type);
  }), astBuilder.buildTypes(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_objectValues__["a" /* default */])(typeDefinitionMap)));

  // Support both original legacy names and extended legacy names.
  var schemaAllowedLegacyNames = schema.__allowedLegacyNames;
  var extendAllowedLegacyNames = options && options.allowedLegacyNames;
  var allowedLegacyNames = schemaAllowedLegacyNames && extendAllowedLegacyNames ? schemaAllowedLegacyNames.concat(extendAllowedLegacyNames) : schemaAllowedLegacyNames || extendAllowedLegacyNames;

  // Then produce and return a Schema with these types.
  return new __WEBPACK_IMPORTED_MODULE_5__type_schema__["a" /* GraphQLSchema */]({
    query: queryType,
    mutation: mutationType,
    subscription: subscriptionType,
    types: types,
    directives: getMergedDirectives(),
    astNode: schema.astNode,
    allowedLegacyNames: allowedLegacyNames
  });

  // Below are functions used for producing this schema that have closed over
  // this scope and have access to the schema, cache, and newly defined types.

  function getMergedDirectives() {
    var existingDirectives = schema.getDirectives();
    !existingDirectives ? Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_invariant__["a" /* default */])(0, 'schema must have default directives') : void 0;

    return existingDirectives.concat(directiveDefinitions.map(function (node) {
      return astBuilder.buildDirective(node);
    }));
  }

  function getExtendedType(type) {
    if (!extendTypeCache[type.name]) {
      extendTypeCache[type.name] = extendType(type);
    }
    return extendTypeCache[type.name];
  }

  // To be called at most once per type. Only getExtendedType should call this.
  function extendType(type) {
    if (Object(__WEBPACK_IMPORTED_MODULE_6__type_introspection__["g" /* isIntrospectionType */])(type)) {
      // Introspection types are not extended.
      return type;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_7__type_definition__["x" /* isObjectType */])(type)) {
      return extendObjectType(type);
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_7__type_definition__["s" /* isInterfaceType */])(type)) {
      return extendInterfaceType(type);
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_7__type_definition__["A" /* isUnionType */])(type)) {
      return extendUnionType(type);
    }
    // This type is not yet extendable.
    return type;
  }

  function extendObjectType(type) {
    var name = type.name;
    var extensionASTNodes = typeExtensionsMap[name] ? type.extensionASTNodes ? type.extensionASTNodes.concat(typeExtensionsMap[name]) : typeExtensionsMap[name] : type.extensionASTNodes;
    return new __WEBPACK_IMPORTED_MODULE_7__type_definition__["f" /* GraphQLObjectType */]({
      name: name,
      description: type.description,
      interfaces: function interfaces() {
        return extendImplementedInterfaces(type);
      },
      fields: function fields() {
        return extendFieldMap(type);
      },
      astNode: type.astNode,
      extensionASTNodes: extensionASTNodes,
      isTypeOf: type.isTypeOf
    });
  }

  function extendInterfaceType(type) {
    var name = type.name;
    var extensionASTNodes = typeExtensionsMap[name] ? type.extensionASTNodes ? type.extensionASTNodes.concat(typeExtensionsMap[name]) : typeExtensionsMap[name] : type.extensionASTNodes;
    return new __WEBPACK_IMPORTED_MODULE_7__type_definition__["c" /* GraphQLInterfaceType */]({
      name: type.name,
      description: type.description,
      fields: function fields() {
        return extendFieldMap(type);
      },
      astNode: type.astNode,
      extensionASTNodes: extensionASTNodes,
      resolveType: type.resolveType
    });
  }

  function extendUnionType(type) {
    return new __WEBPACK_IMPORTED_MODULE_7__type_definition__["h" /* GraphQLUnionType */]({
      name: type.name,
      description: type.description,
      types: type.getTypes().map(getExtendedType),
      astNode: type.astNode,
      resolveType: type.resolveType
    });
  }

  function extendImplementedInterfaces(type) {
    var interfaces = type.getInterfaces().map(getExtendedType);

    // If there are any extensions to the interfaces, apply those here.
    var extensions = typeExtensionsMap[type.name];
    if (extensions) {
      extensions.forEach(function (extension) {
        extension.interfaces.forEach(function (namedType) {
          // Note: While this could make early assertions to get the correctly
          // typed values, that would throw immediately while type system
          // validation with validateSchema() will produce more actionable results.
          interfaces.push(astBuilder.buildType(namedType));
        });
      });
    }

    return interfaces;
  }

  function extendFieldMap(type) {
    var newFieldMap = Object.create(null);
    var oldFieldMap = type.getFields();
    Object.keys(oldFieldMap).forEach(function (fieldName) {
      var field = oldFieldMap[fieldName];
      newFieldMap[fieldName] = {
        description: field.description,
        deprecationReason: field.deprecationReason,
        type: extendFieldType(field.type),
        args: Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_keyMap__["a" /* default */])(field.args, function (arg) {
          return arg.name;
        }),
        astNode: field.astNode,
        resolve: field.resolve
      };
    });

    // If there are any extensions to the fields, apply those here.
    var extensions = typeExtensionsMap[type.name];
    if (extensions) {
      extensions.forEach(function (extension) {
        extension.fields.forEach(function (field) {
          var fieldName = field.name.value;
          if (oldFieldMap[fieldName]) {
            throw new __WEBPACK_IMPORTED_MODULE_4__error_GraphQLError__["a" /* GraphQLError */]('Field "' + type.name + '.' + fieldName + '" already exists in the ' + 'schema. It cannot also be defined in this type extension.', [field]);
          }
          newFieldMap[fieldName] = astBuilder.buildField(field);
        });
      });
    }

    return newFieldMap;
  }

  function extendFieldType(typeDef) {
    if (Object(__WEBPACK_IMPORTED_MODULE_7__type_definition__["u" /* isListType */])(typeDef)) {
      return Object(__WEBPACK_IMPORTED_MODULE_7__type_definition__["d" /* GraphQLList */])(extendFieldType(typeDef.ofType));
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_7__type_definition__["w" /* isNonNullType */])(typeDef)) {
      return Object(__WEBPACK_IMPORTED_MODULE_7__type_definition__["e" /* GraphQLNonNull */])(extendFieldType(typeDef.ofType));
    }
    return getExtendedType(typeDef);
  }
}

function checkExtensionNode(type, node) {
  switch (node.kind) {
    case __WEBPACK_IMPORTED_MODULE_9__language_kinds__["a" /* Kind */].OBJECT_TYPE_EXTENSION:
      if (!Object(__WEBPACK_IMPORTED_MODULE_7__type_definition__["x" /* isObjectType */])(type)) {
        throw new __WEBPACK_IMPORTED_MODULE_4__error_GraphQLError__["a" /* GraphQLError */]('Cannot extend non-object type "' + type.name + '".', [node]);
      }
      break;
    case __WEBPACK_IMPORTED_MODULE_9__language_kinds__["a" /* Kind */].INTERFACE_TYPE_EXTENSION:
      if (!Object(__WEBPACK_IMPORTED_MODULE_7__type_definition__["s" /* isInterfaceType */])(type)) {
        throw new __WEBPACK_IMPORTED_MODULE_4__error_GraphQLError__["a" /* GraphQLError */]('Cannot extend non-interface type "' + type.name + '".', [node]);
      }
      break;
  }
}

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export lexicographicSortSchema */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsutils_keyValMap__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsutils_objectValues__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type_schema__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__type_directives__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__type_definition__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__type_scalars__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__type_introspection__ = __webpack_require__(89);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

 /**
                                               * Copyright (c) 2015-present, Facebook, Inc.
                                               *
                                               * This source code is licensed under the MIT license found in the
                                               * LICENSE file in the root directory of this source tree.
                                               *
                                               *  strict
                                               */









/**
 * Sort GraphQLSchema.
 */
function lexicographicSortSchema(schema) {
  var cache = Object.create(null);

  var sortMaybeType = function sortMaybeType(maybeType) {
    return maybeType && sortNamedType(maybeType);
  };
  return new __WEBPACK_IMPORTED_MODULE_2__type_schema__["a" /* GraphQLSchema */]({
    types: sortTypes(Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_objectValues__["a" /* default */])(schema.getTypeMap())),
    directives: sortByName(schema.getDirectives()).map(sortDirective),
    query: sortMaybeType(schema.getQueryType()),
    mutation: sortMaybeType(schema.getMutationType()),
    subscription: sortMaybeType(schema.getSubscriptionType()),
    astNode: schema.astNode
  });

  function sortDirective(directive) {
    return new __WEBPACK_IMPORTED_MODULE_3__type_directives__["c" /* GraphQLDirective */]({
      name: directive.name,
      description: directive.description,
      locations: sortBy(directive.locations, function (x) {
        return x;
      }),
      args: sortArgs(directive.args),
      astNode: directive.astNode
    });
  }

  function sortArgs(args) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_keyValMap__["a" /* default */])(sortByName(args), function (arg) {
      return arg.name;
    }, function (arg) {
      return _extends({}, arg, {
        type: sortType(arg.type)
      });
    });
  }

  function sortFields(fieldsMap) {
    return sortObjMap(fieldsMap, function (field) {
      return {
        type: sortType(field.type),
        args: sortArgs(field.args),
        resolve: field.resolve,
        subscribe: field.subscribe,
        deprecationReason: field.deprecationReason,
        description: field.description,
        astNode: field.astNode
      };
    });
  }

  function sortInputFields(fieldsMap) {
    return sortObjMap(fieldsMap, function (field) {
      return {
        type: sortType(field.type),
        defaultValue: field.defaultValue,
        description: field.description,
        astNode: field.astNode
      };
    });
  }

  function sortType(type) {
    if (Object(__WEBPACK_IMPORTED_MODULE_4__type_definition__["u" /* isListType */])(type)) {
      return new __WEBPACK_IMPORTED_MODULE_4__type_definition__["d" /* GraphQLList */](sortType(type.ofType));
    } else if (Object(__WEBPACK_IMPORTED_MODULE_4__type_definition__["w" /* isNonNullType */])(type)) {
      return new __WEBPACK_IMPORTED_MODULE_4__type_definition__["e" /* GraphQLNonNull */](sortType(type.ofType));
    }
    return sortNamedType(type);
  }

  function sortTypes(arr) {
    return sortByName(arr).map(sortNamedType);
  }

  function sortNamedType(type) {
    if (Object(__WEBPACK_IMPORTED_MODULE_5__type_scalars__["d" /* isSpecifiedScalarType */])(type) || Object(__WEBPACK_IMPORTED_MODULE_6__type_introspection__["g" /* isIntrospectionType */])(type)) {
      return type;
    }

    var sortedType = cache[type.name];
    if (!sortedType) {
      sortedType = sortNamedTypeImpl(type);
      cache[type.name] = sortedType;
    }
    return sortedType;
  }

  function sortNamedTypeImpl(type) {
    if (Object(__WEBPACK_IMPORTED_MODULE_4__type_definition__["z" /* isScalarType */])(type)) {
      return type;
    } else if (Object(__WEBPACK_IMPORTED_MODULE_4__type_definition__["x" /* isObjectType */])(type)) {
      return new __WEBPACK_IMPORTED_MODULE_4__type_definition__["f" /* GraphQLObjectType */]({
        name: type.name,
        interfaces: function interfaces() {
          return sortTypes(type.getInterfaces());
        },
        fields: function fields() {
          return sortFields(type.getFields());
        },
        isTypeOf: type.isTypeOf,
        description: type.description,
        astNode: type.astNode,
        extensionASTNodes: type.extensionASTNodes
      });
    } else if (Object(__WEBPACK_IMPORTED_MODULE_4__type_definition__["s" /* isInterfaceType */])(type)) {
      return new __WEBPACK_IMPORTED_MODULE_4__type_definition__["c" /* GraphQLInterfaceType */]({
        name: type.name,
        fields: function fields() {
          return sortFields(type.getFields());
        },
        resolveType: type.resolveType,
        description: type.description,
        astNode: type.astNode,
        extensionASTNodes: type.extensionASTNodes
      });
    } else if (Object(__WEBPACK_IMPORTED_MODULE_4__type_definition__["A" /* isUnionType */])(type)) {
      return new __WEBPACK_IMPORTED_MODULE_4__type_definition__["h" /* GraphQLUnionType */]({
        name: type.name,
        types: function types() {
          return sortTypes(type.getTypes());
        },
        resolveType: type.resolveType,
        description: type.description,
        astNode: type.astNode
      });
    } else if (Object(__WEBPACK_IMPORTED_MODULE_4__type_definition__["p" /* isEnumType */])(type)) {
      return new __WEBPACK_IMPORTED_MODULE_4__type_definition__["a" /* GraphQLEnumType */]({
        name: type.name,
        values: Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_keyValMap__["a" /* default */])(sortByName(type.getValues()), function (val) {
          return val.name;
        }, function (val) {
          return {
            value: val.value,
            deprecationReason: val.deprecationReason,
            description: val.description,
            astNode: val.astNode
          };
        }),
        description: type.description,
        astNode: type.astNode
      });
    } else if (Object(__WEBPACK_IMPORTED_MODULE_4__type_definition__["q" /* isInputObjectType */])(type)) {
      return new __WEBPACK_IMPORTED_MODULE_4__type_definition__["b" /* GraphQLInputObjectType */]({
        name: type.name,
        fields: function fields() {
          return sortInputFields(type.getFields());
        },
        description: type.description,
        astNode: type.astNode
      });
    }
    throw new Error('Unknown type: "' + type + '"');
  }
}

function sortObjMap(map, sortValueFn) {
  var sortedMap = Object.create(null);
  var sortedKeys = sortBy(Object.keys(map), function (x) {
    return x;
  });
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = sortedKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var key = _step.value;

      var value = map[key];
      sortedMap[key] = sortValueFn ? sortValueFn(value) : value;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return sortedMap;
}

function sortByName(array) {
  return sortBy(array, function (obj) {
    return obj.name;
  });
}

function sortBy(array, mapToKey) {
  return array.slice().sort(function (obj1, obj2) {
    var key1 = mapToKey(obj1);
    var key2 = mapToKey(obj2);
    return key1.localeCompare(key2);
  });
}

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export printSchema */
/* unused harmony export printIntrospectionSchema */
/* unused harmony export printType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsutils_isNullish__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsutils_isInvalid__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsutils_objectValues__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_astFromValue__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__language_printer__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__type_definition__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__type_scalars__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__type_directives__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__type_introspection__ = __webpack_require__(89);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */













/**
 * Accepts options as a second argument:
 *
 *    - commentDescriptions:
 *        Provide true to use preceding comments as the description.
 *
 */
function printSchema(schema, options) {
  return printFilteredSchema(schema, function (n) {
    return !Object(__WEBPACK_IMPORTED_MODULE_7__type_directives__["g" /* isSpecifiedDirective */])(n);
  }, isDefinedType, options);
}

function printIntrospectionSchema(schema, options) {
  return printFilteredSchema(schema, __WEBPACK_IMPORTED_MODULE_7__type_directives__["g" /* isSpecifiedDirective */], __WEBPACK_IMPORTED_MODULE_8__type_introspection__["g" /* isIntrospectionType */], options);
}

function isDefinedType(type) {
  return !Object(__WEBPACK_IMPORTED_MODULE_6__type_scalars__["d" /* isSpecifiedScalarType */])(type) && !Object(__WEBPACK_IMPORTED_MODULE_8__type_introspection__["g" /* isIntrospectionType */])(type);
}

function printFilteredSchema(schema, directiveFilter, typeFilter, options) {
  var directives = schema.getDirectives().filter(directiveFilter);
  var typeMap = schema.getTypeMap();
  var types = Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_objectValues__["a" /* default */])(typeMap).sort(function (type1, type2) {
    return type1.name.localeCompare(type2.name);
  }).filter(typeFilter);

  return [printSchemaDefinition(schema)].concat(directives.map(function (directive) {
    return printDirective(directive, options);
  }), types.map(function (type) {
    return printType(type, options);
  })).filter(Boolean).join('\n\n') + '\n';
}

function printSchemaDefinition(schema) {
  if (isSchemaOfCommonNames(schema)) {
    return;
  }

  var operationTypes = [];

  var queryType = schema.getQueryType();
  if (queryType) {
    operationTypes.push('  query: ' + queryType.name);
  }

  var mutationType = schema.getMutationType();
  if (mutationType) {
    operationTypes.push('  mutation: ' + mutationType.name);
  }

  var subscriptionType = schema.getSubscriptionType();
  if (subscriptionType) {
    operationTypes.push('  subscription: ' + subscriptionType.name);
  }

  return 'schema {\n' + operationTypes.join('\n') + '\n}';
}

/**
 * GraphQL schema define root types for each type of operation. These types are
 * the same as any other type and can be named in any manner, however there is
 * a common naming convention:
 *
 *   schema {
 *     query: Query
 *     mutation: Mutation
 *   }
 *
 * When using this naming convention, the schema description can be omitted.
 */
function isSchemaOfCommonNames(schema) {
  var queryType = schema.getQueryType();
  if (queryType && queryType.name !== 'Query') {
    return false;
  }

  var mutationType = schema.getMutationType();
  if (mutationType && mutationType.name !== 'Mutation') {
    return false;
  }

  var subscriptionType = schema.getSubscriptionType();
  if (subscriptionType && subscriptionType.name !== 'Subscription') {
    return false;
  }

  return true;
}

function printType(type, options) {
  if (Object(__WEBPACK_IMPORTED_MODULE_5__type_definition__["z" /* isScalarType */])(type)) {
    return printScalar(type, options);
  } else if (Object(__WEBPACK_IMPORTED_MODULE_5__type_definition__["x" /* isObjectType */])(type)) {
    return printObject(type, options);
  } else if (Object(__WEBPACK_IMPORTED_MODULE_5__type_definition__["s" /* isInterfaceType */])(type)) {
    return printInterface(type, options);
  } else if (Object(__WEBPACK_IMPORTED_MODULE_5__type_definition__["A" /* isUnionType */])(type)) {
    return printUnion(type, options);
  } else if (Object(__WEBPACK_IMPORTED_MODULE_5__type_definition__["p" /* isEnumType */])(type)) {
    return printEnum(type, options);
  } else if (Object(__WEBPACK_IMPORTED_MODULE_5__type_definition__["q" /* isInputObjectType */])(type)) {
    return printInputObject(type, options);
  }
  /* istanbul ignore next */
  throw new Error('Unknown type: ' + type + '.');
}

function printScalar(type, options) {
  return printDescription(options, type) + ('scalar ' + type.name);
}

function printObject(type, options) {
  var interfaces = type.getInterfaces();
  var implementedInterfaces = interfaces.length ? ' implements ' + interfaces.map(function (i) {
    return i.name;
  }).join(' & ') : '';
  return printDescription(options, type) + ('type ' + type.name + implementedInterfaces + ' {\n') + printFields(options, type) + '\n' + '}';
}

function printInterface(type, options) {
  return printDescription(options, type) + ('interface ' + type.name + ' {\n') + printFields(options, type) + '\n' + '}';
}

function printUnion(type, options) {
  return printDescription(options, type) + ('union ' + type.name + ' = ' + type.getTypes().join(' | '));
}

function printEnum(type, options) {
  return printDescription(options, type) + ('enum ' + type.name + ' {\n') + printEnumValues(type.getValues(), options) + '\n' + '}';
}

function printEnumValues(values, options) {
  return values.map(function (value, i) {
    return printDescription(options, value, '  ', !i) + '  ' + value.name + printDeprecated(value);
  }).join('\n');
}

function printInputObject(type, options) {
  var fields = Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_objectValues__["a" /* default */])(type.getFields());
  return printDescription(options, type) + ('input ' + type.name + ' {\n') + fields.map(function (f, i) {
    return printDescription(options, f, '  ', !i) + '  ' + printInputValue(f);
  }).join('\n') + '\n' + '}';
}

function printFields(options, type) {
  var fields = Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_objectValues__["a" /* default */])(type.getFields());
  return fields.map(function (f, i) {
    return printDescription(options, f, '  ', !i) + '  ' + f.name + printArgs(options, f.args, '  ') + ': ' + String(f.type) + printDeprecated(f);
  }).join('\n');
}

function printArgs(options, args) {
  var indentation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  if (args.length === 0) {
    return '';
  }

  // If every arg does not have a description, print them on one line.
  if (args.every(function (arg) {
    return !arg.description;
  })) {
    return '(' + args.map(printInputValue).join(', ') + ')';
  }

  return '(\n' + args.map(function (arg, i) {
    return printDescription(options, arg, '  ' + indentation, !i) + '  ' + indentation + printInputValue(arg);
  }).join('\n') + '\n' + indentation + ')';
}

function printInputValue(arg) {
  var argDecl = arg.name + ': ' + String(arg.type);
  if (!Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_isInvalid__["a" /* default */])(arg.defaultValue)) {
    argDecl += ' = ' + Object(__WEBPACK_IMPORTED_MODULE_4__language_printer__["a" /* print */])(Object(__WEBPACK_IMPORTED_MODULE_3__utilities_astFromValue__["a" /* astFromValue */])(arg.defaultValue, arg.type));
  }
  return argDecl;
}

function printDirective(directive, options) {
  return printDescription(options, directive) + 'directive @' + directive.name + printArgs(options, directive.args) + ' on ' + directive.locations.join(' | ');
}

function printDeprecated(fieldOrEnumVal) {
  if (!fieldOrEnumVal.isDeprecated) {
    return '';
  }
  var reason = fieldOrEnumVal.deprecationReason;
  if (Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_isNullish__["a" /* default */])(reason) || reason === '' || reason === __WEBPACK_IMPORTED_MODULE_7__type_directives__["a" /* DEFAULT_DEPRECATION_REASON */]) {
    return ' @deprecated';
  }
  return ' @deprecated(reason: ' + Object(__WEBPACK_IMPORTED_MODULE_4__language_printer__["a" /* print */])(Object(__WEBPACK_IMPORTED_MODULE_3__utilities_astFromValue__["a" /* astFromValue */])(reason, __WEBPACK_IMPORTED_MODULE_6__type_scalars__["c" /* GraphQLString */])) + ')';
}

function printDescription(options, def) {
  var indentation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var firstInBlock = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  if (!def.description) {
    return '';
  }

  var lines = descriptionLines(def.description, 120 - indentation.length);
  if (options && options.commentDescriptions) {
    return printDescriptionWithComments(lines, indentation, firstInBlock);
  }

  var description = indentation && !firstInBlock ? '\n' + indentation + '"""' : indentation + '"""';

  // In some circumstances, a single line can be used for the description.
  if (lines.length === 1 && lines[0].length < 70 && lines[0][lines[0].length - 1] !== '"') {
    return description + escapeQuote(lines[0]) + '"""\n';
  }

  // Format a multi-line block quote to account for leading space.
  var hasLeadingSpace = lines[0][0] === ' ' || lines[0][0] === '\t';
  if (!hasLeadingSpace) {
    description += '\n';
  }
  for (var i = 0; i < lines.length; i++) {
    if (i !== 0 || !hasLeadingSpace) {
      description += indentation;
    }
    description += escapeQuote(lines[i]) + '\n';
  }
  description += indentation + '"""\n';
  return description;
}

function escapeQuote(line) {
  return line.replace(/"""/g, '\\"""');
}

function printDescriptionWithComments(lines, indentation, firstInBlock) {
  var description = indentation && !firstInBlock ? '\n' : '';
  for (var i = 0; i < lines.length; i++) {
    if (lines[i] === '') {
      description += indentation + '#\n';
    } else {
      description += indentation + '# ' + lines[i] + '\n';
    }
  }
  return description;
}

function descriptionLines(description, maxLen) {
  var lines = [];
  var rawLines = description.split('\n');
  for (var i = 0; i < rawLines.length; i++) {
    if (rawLines[i] === '') {
      lines.push(rawLines[i]);
    } else {
      // For > 120 character long lines, cut at space boundaries into sublines
      // of ~80 chars.
      var sublines = breakLine(rawLines[i], maxLen);
      for (var j = 0; j < sublines.length; j++) {
        lines.push(sublines[j]);
      }
    }
  }
  return lines;
}

function breakLine(line, maxLen) {
  if (line.length < maxLen + 5) {
    return [line];
  }
  var parts = line.split(new RegExp('((?: |^).{15,' + (maxLen - 40) + '}(?= |$))'));
  if (parts.length < 4) {
    return [line];
  }
  var sublines = [parts[0] + parts[1] + parts[2]];
  for (var i = 3; i < parts.length; i += 2) {
    sublines.push(parts[i].slice(1) + parts[i + 1]);
  }
  return sublines;
}

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isValidJSValue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coerceValue__ = __webpack_require__(280);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */




/**
 * Deprecated. Use coerceValue() directly for richer information.
 */
function isValidJSValue(value, type) {
  var errors = Object(__WEBPACK_IMPORTED_MODULE_0__coerceValue__["a" /* coerceValue */])(value, type).errors;
  return errors ? errors.map(function (error) {
    return error.message;
  }) : [];
}

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isValidLiteralValue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TypeInfo__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__language_kinds__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__language_visitor__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__type_schema__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__validation_rules_ValuesOfCorrectType__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__validation_ValidationContext__ = __webpack_require__(279);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */










/**
 * Utility which determines if a value literal node is valid for an input type.
 *
 * Deprecated. Rely on validation for documents containing literal values.
 */
function isValidLiteralValue(type, valueNode) {
  var emptySchema = new __WEBPACK_IMPORTED_MODULE_3__type_schema__["a" /* GraphQLSchema */]({});
  var emptyDoc = { kind: __WEBPACK_IMPORTED_MODULE_1__language_kinds__["a" /* Kind */].DOCUMENT, definitions: [] };
  var typeInfo = new __WEBPACK_IMPORTED_MODULE_0__TypeInfo__["a" /* TypeInfo */](emptySchema, undefined, type);
  var context = new __WEBPACK_IMPORTED_MODULE_5__validation_ValidationContext__["a" /* default */](emptySchema, emptyDoc, typeInfo);
  var visitor = Object(__WEBPACK_IMPORTED_MODULE_4__validation_rules_ValuesOfCorrectType__["a" /* ValuesOfCorrectType */])(context);
  Object(__WEBPACK_IMPORTED_MODULE_2__language_visitor__["b" /* visit */])(valueNode, Object(__WEBPACK_IMPORTED_MODULE_2__language_visitor__["d" /* visitWithTypeInfo */])(typeInfo, visitor));
  return context.getErrors();
}

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export concatAST */


/**
 * Provided a collection of ASTs, presumably each from different files,
 * concatenate the ASTs together into batched AST, useful for validating many
 * GraphQL source files which together represent one conceptual application.
 */
function concatAST(asts) {
  var batchDefinitions = [];
  for (var i = 0; i < asts.length; i++) {
    var definitions = asts[i].definitions;
    for (var j = 0; j < definitions.length; j++) {
      batchDefinitions.push(definitions[j]);
    }
  }
  return {
    kind: 'Document',
    definitions: batchDefinitions
  };
} /**
   * Copyright (c) 2015-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *
   *  strict
   */

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export separateOperations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__language_visitor__ = __webpack_require__(96);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */




/**
 * separateOperations accepts a single AST document which may contain many
 * operations and fragments and returns a collection of AST documents each of
 * which contains a single operation as well the fragment definitions it
 * refers to.
 */
function separateOperations(documentAST) {
  var operations = [];
  var fragments = Object.create(null);
  var positions = new Map();
  var depGraph = Object.create(null);
  var fromName = void 0;
  var idx = 0;

  // Populate metadata and build a dependency graph.
  Object(__WEBPACK_IMPORTED_MODULE_0__language_visitor__["b" /* visit */])(documentAST, {
    OperationDefinition: function OperationDefinition(node) {
      fromName = opName(node);
      operations.push(node);
      positions.set(node, idx++);
    },
    FragmentDefinition: function FragmentDefinition(node) {
      fromName = node.name.value;
      fragments[fromName] = node;
      positions.set(node, idx++);
    },
    FragmentSpread: function FragmentSpread(node) {
      var toName = node.name.value;
      (depGraph[fromName] || (depGraph[fromName] = Object.create(null)))[toName] = true;
    }
  });

  // For each operation, produce a new synthesized AST which includes only what
  // is necessary for completing that operation.
  var separatedDocumentASTs = Object.create(null);
  operations.forEach(function (operation) {
    var operationName = opName(operation);
    var dependencies = Object.create(null);
    collectTransitiveDependencies(dependencies, depGraph, operationName);

    // The list of definition nodes to be included for this operation, sorted
    // to retain the same order as the original document.
    var definitions = [operation];
    Object.keys(dependencies).forEach(function (name) {
      definitions.push(fragments[name]);
    });
    definitions.sort(function (n1, n2) {
      return (positions.get(n1) || 0) - (positions.get(n2) || 0);
    });

    separatedDocumentASTs[operationName] = {
      kind: 'Document',
      definitions: definitions
    };
  });

  return separatedDocumentASTs;
}

// Provides the empty string for anonymous operations.
function opName(operation) {
  return operation.name ? operation.name.value : '';
}

// From a dependency graph, collects a list of transitive dependencies by
// recursing through a dependency graph.
function collectTransitiveDependencies(collected, depGraph, fromName) {
  var immediateDeps = depGraph[fromName];
  if (immediateDeps) {
    Object.keys(immediateDeps).forEach(function (toName) {
      if (!collected[toName]) {
        collected[toName] = true;
        collectTransitiveDependencies(collected, depGraph, toName);
      }
    });
  }
}

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BreakingChangeType */
/* unused harmony export DangerousChangeType */
/* unused harmony export findBreakingChanges */
/* unused harmony export findDangerousChanges */
/* unused harmony export findRemovedTypes */
/* unused harmony export findTypesThatChangedKind */
/* unused harmony export findArgChanges */
/* unused harmony export findFieldsThatChangedTypeOnObjectOrInterfaceTypes */
/* unused harmony export findFieldsThatChangedTypeOnInputObjectTypes */
/* unused harmony export findTypesRemovedFromUnions */
/* unused harmony export findTypesAddedToUnions */
/* unused harmony export findValuesRemovedFromEnums */
/* unused harmony export findValuesAddedToEnums */
/* unused harmony export findInterfacesRemovedFromObjectTypes */
/* unused harmony export findInterfacesAddedToObjectTypes */
/* unused harmony export findRemovedDirectives */
/* unused harmony export findRemovedDirectiveArgs */
/* unused harmony export findAddedNonNullDirectiveArgs */
/* unused harmony export findRemovedLocationsForDirective */
/* unused harmony export findRemovedDirectiveLocations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type_definition__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type_directives__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type_schema__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jsutils_keyMap__ = __webpack_require__(107);
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */







var BreakingChangeType = {
  FIELD_CHANGED_KIND: 'FIELD_CHANGED_KIND',
  FIELD_REMOVED: 'FIELD_REMOVED',
  TYPE_CHANGED_KIND: 'TYPE_CHANGED_KIND',
  TYPE_REMOVED: 'TYPE_REMOVED',
  TYPE_REMOVED_FROM_UNION: 'TYPE_REMOVED_FROM_UNION',
  VALUE_REMOVED_FROM_ENUM: 'VALUE_REMOVED_FROM_ENUM',
  ARG_REMOVED: 'ARG_REMOVED',
  ARG_CHANGED_KIND: 'ARG_CHANGED_KIND',
  NON_NULL_ARG_ADDED: 'NON_NULL_ARG_ADDED',
  NON_NULL_INPUT_FIELD_ADDED: 'NON_NULL_INPUT_FIELD_ADDED',
  INTERFACE_REMOVED_FROM_OBJECT: 'INTERFACE_REMOVED_FROM_OBJECT',
  DIRECTIVE_REMOVED: 'DIRECTIVE_REMOVED',
  DIRECTIVE_ARG_REMOVED: 'DIRECTIVE_ARG_REMOVED',
  DIRECTIVE_LOCATION_REMOVED: 'DIRECTIVE_LOCATION_REMOVED',
  NON_NULL_DIRECTIVE_ARG_ADDED: 'NON_NULL_DIRECTIVE_ARG_ADDED'
};

var DangerousChangeType = {
  ARG_DEFAULT_VALUE_CHANGE: 'ARG_DEFAULT_VALUE_CHANGE',
  VALUE_ADDED_TO_ENUM: 'VALUE_ADDED_TO_ENUM',
  INTERFACE_ADDED_TO_OBJECT: 'INTERFACE_ADDED_TO_OBJECT',
  TYPE_ADDED_TO_UNION: 'TYPE_ADDED_TO_UNION',
  NULLABLE_INPUT_FIELD_ADDED: 'NULLABLE_INPUT_FIELD_ADDED',
  NULLABLE_ARG_ADDED: 'NULLABLE_ARG_ADDED'
};

/**
 * Given two schemas, returns an Array containing descriptions of all the types
 * of breaking changes covered by the other functions down below.
 */
function findBreakingChanges(oldSchema, newSchema) {
  return [].concat(findRemovedTypes(oldSchema, newSchema), findTypesThatChangedKind(oldSchema, newSchema), findFieldsThatChangedTypeOnObjectOrInterfaceTypes(oldSchema, newSchema), findFieldsThatChangedTypeOnInputObjectTypes(oldSchema, newSchema).breakingChanges, findTypesRemovedFromUnions(oldSchema, newSchema), findValuesRemovedFromEnums(oldSchema, newSchema), findArgChanges(oldSchema, newSchema).breakingChanges, findInterfacesRemovedFromObjectTypes(oldSchema, newSchema), findRemovedDirectives(oldSchema, newSchema), findRemovedDirectiveArgs(oldSchema, newSchema), findAddedNonNullDirectiveArgs(oldSchema, newSchema), findRemovedDirectiveLocations(oldSchema, newSchema));
}

/**
 * Given two schemas, returns an Array containing descriptions of all the types
 * of potentially dangerous changes covered by the other functions down below.
 */
function findDangerousChanges(oldSchema, newSchema) {
  return [].concat(findArgChanges(oldSchema, newSchema).dangerousChanges, findValuesAddedToEnums(oldSchema, newSchema), findInterfacesAddedToObjectTypes(oldSchema, newSchema), findTypesAddedToUnions(oldSchema, newSchema), findFieldsThatChangedTypeOnInputObjectTypes(oldSchema, newSchema).dangerousChanges);
}

/**
 * Given two schemas, returns an Array containing descriptions of any breaking
 * changes in the newSchema related to removing an entire type.
 */
function findRemovedTypes(oldSchema, newSchema) {
  var oldTypeMap = oldSchema.getTypeMap();
  var newTypeMap = newSchema.getTypeMap();

  var breakingChanges = [];
  Object.keys(oldTypeMap).forEach(function (typeName) {
    if (!newTypeMap[typeName]) {
      breakingChanges.push({
        type: BreakingChangeType.TYPE_REMOVED,
        description: typeName + ' was removed.'
      });
    }
  });
  return breakingChanges;
}

/**
 * Given two schemas, returns an Array containing descriptions of any breaking
 * changes in the newSchema related to changing the type of a type.
 */
function findTypesThatChangedKind(oldSchema, newSchema) {
  var oldTypeMap = oldSchema.getTypeMap();
  var newTypeMap = newSchema.getTypeMap();

  var breakingChanges = [];
  Object.keys(oldTypeMap).forEach(function (typeName) {
    if (!newTypeMap[typeName]) {
      return;
    }
    var oldType = oldTypeMap[typeName];
    var newType = newTypeMap[typeName];
    if (oldType.constructor !== newType.constructor) {
      breakingChanges.push({
        type: BreakingChangeType.TYPE_CHANGED_KIND,
        description: typeName + ' changed from ' + (typeKindName(oldType) + ' to ' + typeKindName(newType) + '.')
      });
    }
  });
  return breakingChanges;
}

/**
 * Given two schemas, returns an Array containing descriptions of any
 * breaking or dangerous changes in the newSchema related to arguments
 * (such as removal or change of type of an argument, or a change in an
 * argument's default value).
 */
function findArgChanges(oldSchema, newSchema) {
  var oldTypeMap = oldSchema.getTypeMap();
  var newTypeMap = newSchema.getTypeMap();

  var breakingChanges = [];
  var dangerousChanges = [];

  Object.keys(oldTypeMap).forEach(function (typeName) {
    var oldType = oldTypeMap[typeName];
    var newType = newTypeMap[typeName];
    if (!(Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["x" /* isObjectType */])(oldType) || Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["s" /* isInterfaceType */])(oldType)) || !(Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["x" /* isObjectType */])(newType) || Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["s" /* isInterfaceType */])(newType)) || newType.constructor !== oldType.constructor) {
      return;
    }

    var oldTypeFields = oldType.getFields();
    var newTypeFields = newType.getFields();

    Object.keys(oldTypeFields).forEach(function (fieldName) {
      if (!newTypeFields[fieldName]) {
        return;
      }

      oldTypeFields[fieldName].args.forEach(function (oldArgDef) {
        var newArgs = newTypeFields[fieldName].args;
        var newArgDef = newArgs.find(function (arg) {
          return arg.name === oldArgDef.name;
        });

        // Arg not present
        if (!newArgDef) {
          breakingChanges.push({
            type: BreakingChangeType.ARG_REMOVED,
            description: oldType.name + '.' + fieldName + ' arg ' + (oldArgDef.name + ' was removed')
          });
        } else {
          var isSafe = isChangeSafeForInputObjectFieldOrFieldArg(oldArgDef.type, newArgDef.type);
          if (!isSafe) {
            breakingChanges.push({
              type: BreakingChangeType.ARG_CHANGED_KIND,
              description: oldType.name + '.' + fieldName + ' arg ' + (oldArgDef.name + ' has changed type from ') + (oldArgDef.type.toString() + ' to ' + newArgDef.type.toString())
            });
          } else if (oldArgDef.defaultValue !== undefined && oldArgDef.defaultValue !== newArgDef.defaultValue) {
            dangerousChanges.push({
              type: DangerousChangeType.ARG_DEFAULT_VALUE_CHANGE,
              description: oldType.name + '.' + fieldName + ' arg ' + (oldArgDef.name + ' has changed defaultValue')
            });
          }
        }
      });
      // Check if a non-null arg was added to the field
      newTypeFields[fieldName].args.forEach(function (newArgDef) {
        var oldArgs = oldTypeFields[fieldName].args;
        var oldArgDef = oldArgs.find(function (arg) {
          return arg.name === newArgDef.name;
        });
        if (!oldArgDef) {
          if (Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["w" /* isNonNullType */])(newArgDef.type)) {
            breakingChanges.push({
              type: BreakingChangeType.NON_NULL_ARG_ADDED,
              description: 'A non-null arg ' + newArgDef.name + ' on ' + (newType.name + '.' + fieldName + ' was added')
            });
          } else {
            dangerousChanges.push({
              type: DangerousChangeType.NULLABLE_ARG_ADDED,
              description: 'A nullable arg ' + newArgDef.name + ' on ' + (newType.name + '.' + fieldName + ' was added')
            });
          }
        }
      });
    });
  });

  return {
    breakingChanges: breakingChanges,
    dangerousChanges: dangerousChanges
  };
}

function typeKindName(type) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["z" /* isScalarType */])(type)) {
    return 'a Scalar type';
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["x" /* isObjectType */])(type)) {
    return 'an Object type';
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["s" /* isInterfaceType */])(type)) {
    return 'an Interface type';
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["A" /* isUnionType */])(type)) {
    return 'a Union type';
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["p" /* isEnumType */])(type)) {
    return 'an Enum type';
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["q" /* isInputObjectType */])(type)) {
    return 'an Input type';
  }
  throw new TypeError('Unknown type ' + type.constructor.name);
}

function findFieldsThatChangedTypeOnObjectOrInterfaceTypes(oldSchema, newSchema) {
  var oldTypeMap = oldSchema.getTypeMap();
  var newTypeMap = newSchema.getTypeMap();

  var breakingChanges = [];
  Object.keys(oldTypeMap).forEach(function (typeName) {
    var oldType = oldTypeMap[typeName];
    var newType = newTypeMap[typeName];
    if (!(Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["x" /* isObjectType */])(oldType) || Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["s" /* isInterfaceType */])(oldType)) || !(Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["x" /* isObjectType */])(newType) || Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["s" /* isInterfaceType */])(newType)) || newType.constructor !== oldType.constructor) {
      return;
    }

    var oldTypeFieldsDef = oldType.getFields();
    var newTypeFieldsDef = newType.getFields();
    Object.keys(oldTypeFieldsDef).forEach(function (fieldName) {
      // Check if the field is missing on the type in the new schema.
      if (!(fieldName in newTypeFieldsDef)) {
        breakingChanges.push({
          type: BreakingChangeType.FIELD_REMOVED,
          description: typeName + '.' + fieldName + ' was removed.'
        });
      } else {
        var oldFieldType = oldTypeFieldsDef[fieldName].type;
        var newFieldType = newTypeFieldsDef[fieldName].type;
        var isSafe = isChangeSafeForObjectOrInterfaceField(oldFieldType, newFieldType);
        if (!isSafe) {
          var oldFieldTypeString = Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["v" /* isNamedType */])(oldFieldType) ? oldFieldType.name : oldFieldType.toString();
          var newFieldTypeString = Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["v" /* isNamedType */])(newFieldType) ? newFieldType.name : newFieldType.toString();
          breakingChanges.push({
            type: BreakingChangeType.FIELD_CHANGED_KIND,
            description: typeName + '.' + fieldName + ' changed type from ' + (oldFieldTypeString + ' to ' + newFieldTypeString + '.')
          });
        }
      }
    });
  });
  return breakingChanges;
}

function findFieldsThatChangedTypeOnInputObjectTypes(oldSchema, newSchema) {
  var oldTypeMap = oldSchema.getTypeMap();
  var newTypeMap = newSchema.getTypeMap();

  var breakingChanges = [];
  var dangerousChanges = [];
  Object.keys(oldTypeMap).forEach(function (typeName) {
    var oldType = oldTypeMap[typeName];
    var newType = newTypeMap[typeName];
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["q" /* isInputObjectType */])(oldType) || !Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["q" /* isInputObjectType */])(newType)) {
      return;
    }

    var oldTypeFieldsDef = oldType.getFields();
    var newTypeFieldsDef = newType.getFields();
    Object.keys(oldTypeFieldsDef).forEach(function (fieldName) {
      // Check if the field is missing on the type in the new schema.
      if (!(fieldName in newTypeFieldsDef)) {
        breakingChanges.push({
          type: BreakingChangeType.FIELD_REMOVED,
          description: typeName + '.' + fieldName + ' was removed.'
        });
      } else {
        var oldFieldType = oldTypeFieldsDef[fieldName].type;
        var newFieldType = newTypeFieldsDef[fieldName].type;

        var isSafe = isChangeSafeForInputObjectFieldOrFieldArg(oldFieldType, newFieldType);
        if (!isSafe) {
          var oldFieldTypeString = Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["v" /* isNamedType */])(oldFieldType) ? oldFieldType.name : oldFieldType.toString();
          var newFieldTypeString = Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["v" /* isNamedType */])(newFieldType) ? newFieldType.name : newFieldType.toString();
          breakingChanges.push({
            type: BreakingChangeType.FIELD_CHANGED_KIND,
            description: typeName + '.' + fieldName + ' changed type from ' + (oldFieldTypeString + ' to ' + newFieldTypeString + '.')
          });
        }
      }
    });
    // Check if a field was added to the input object type
    Object.keys(newTypeFieldsDef).forEach(function (fieldName) {
      if (!(fieldName in oldTypeFieldsDef)) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["w" /* isNonNullType */])(newTypeFieldsDef[fieldName].type)) {
          breakingChanges.push({
            type: BreakingChangeType.NON_NULL_INPUT_FIELD_ADDED,
            description: 'A non-null field ' + fieldName + ' on ' + ('input type ' + newType.name + ' was added.')
          });
        } else {
          dangerousChanges.push({
            type: DangerousChangeType.NULLABLE_INPUT_FIELD_ADDED,
            description: 'A nullable field ' + fieldName + ' on ' + ('input type ' + newType.name + ' was added.')
          });
        }
      }
    });
  });
  return {
    breakingChanges: breakingChanges,
    dangerousChanges: dangerousChanges
  };
}

function isChangeSafeForObjectOrInterfaceField(oldType, newType) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["v" /* isNamedType */])(oldType)) {
    return (
      // if they're both named types, see if their names are equivalent
      Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["v" /* isNamedType */])(newType) && oldType.name === newType.name ||
      // moving from nullable to non-null of the same underlying type is safe
      Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["w" /* isNonNullType */])(newType) && isChangeSafeForObjectOrInterfaceField(oldType, newType.ofType)
    );
  } else if (Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["u" /* isListType */])(oldType)) {
    return (
      // if they're both lists, make sure the underlying types are compatible
      Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["u" /* isListType */])(newType) && isChangeSafeForObjectOrInterfaceField(oldType.ofType, newType.ofType) ||
      // moving from nullable to non-null of the same underlying type is safe
      Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["w" /* isNonNullType */])(newType) && isChangeSafeForObjectOrInterfaceField(oldType, newType.ofType)
    );
  } else if (Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["w" /* isNonNullType */])(oldType)) {
    // if they're both non-null, make sure the underlying types are compatible
    return Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["w" /* isNonNullType */])(newType) && isChangeSafeForObjectOrInterfaceField(oldType.ofType, newType.ofType);
  }
  return false;
}

function isChangeSafeForInputObjectFieldOrFieldArg(oldType, newType) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["v" /* isNamedType */])(oldType)) {
    // if they're both named types, see if their names are equivalent
    return Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["v" /* isNamedType */])(newType) && oldType.name === newType.name;
  } else if (Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["u" /* isListType */])(oldType)) {
    // if they're both lists, make sure the underlying types are compatible
    return Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["u" /* isListType */])(newType) && isChangeSafeForInputObjectFieldOrFieldArg(oldType.ofType, newType.ofType);
  } else if (Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["w" /* isNonNullType */])(oldType)) {
    return (
      // if they're both non-null, make sure the underlying types are
      // compatible
      Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["w" /* isNonNullType */])(newType) && isChangeSafeForInputObjectFieldOrFieldArg(oldType.ofType, newType.ofType) ||
      // moving from non-null to nullable of the same underlying type is safe
      !Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["w" /* isNonNullType */])(newType) && isChangeSafeForInputObjectFieldOrFieldArg(oldType.ofType, newType)
    );
  }
  return false;
}

/**
 * Given two schemas, returns an Array containing descriptions of any breaking
 * changes in the newSchema related to removing types from a union type.
 */
function findTypesRemovedFromUnions(oldSchema, newSchema) {
  var oldTypeMap = oldSchema.getTypeMap();
  var newTypeMap = newSchema.getTypeMap();

  var typesRemovedFromUnion = [];
  Object.keys(oldTypeMap).forEach(function (typeName) {
    var oldType = oldTypeMap[typeName];
    var newType = newTypeMap[typeName];
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["A" /* isUnionType */])(oldType) || !Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["A" /* isUnionType */])(newType)) {
      return;
    }
    var typeNamesInNewUnion = Object.create(null);
    newType.getTypes().forEach(function (type) {
      typeNamesInNewUnion[type.name] = true;
    });
    oldType.getTypes().forEach(function (type) {
      if (!typeNamesInNewUnion[type.name]) {
        typesRemovedFromUnion.push({
          type: BreakingChangeType.TYPE_REMOVED_FROM_UNION,
          description: type.name + ' was removed from union type ' + typeName + '.'
        });
      }
    });
  });
  return typesRemovedFromUnion;
}

/**
 * Given two schemas, returns an Array containing descriptions of any dangerous
 * changes in the newSchema related to adding types to a union type.
 */
function findTypesAddedToUnions(oldSchema, newSchema) {
  var oldTypeMap = oldSchema.getTypeMap();
  var newTypeMap = newSchema.getTypeMap();

  var typesAddedToUnion = [];
  Object.keys(newTypeMap).forEach(function (typeName) {
    var oldType = oldTypeMap[typeName];
    var newType = newTypeMap[typeName];
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["A" /* isUnionType */])(oldType) || !Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["A" /* isUnionType */])(newType)) {
      return;
    }
    var typeNamesInOldUnion = Object.create(null);
    oldType.getTypes().forEach(function (type) {
      typeNamesInOldUnion[type.name] = true;
    });
    newType.getTypes().forEach(function (type) {
      if (!typeNamesInOldUnion[type.name]) {
        typesAddedToUnion.push({
          type: DangerousChangeType.TYPE_ADDED_TO_UNION,
          description: type.name + ' was added to union type ' + typeName + '.'
        });
      }
    });
  });
  return typesAddedToUnion;
}
/**
 * Given two schemas, returns an Array containing descriptions of any breaking
 * changes in the newSchema related to removing values from an enum type.
 */
function findValuesRemovedFromEnums(oldSchema, newSchema) {
  var oldTypeMap = oldSchema.getTypeMap();
  var newTypeMap = newSchema.getTypeMap();

  var valuesRemovedFromEnums = [];
  Object.keys(oldTypeMap).forEach(function (typeName) {
    var oldType = oldTypeMap[typeName];
    var newType = newTypeMap[typeName];
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["p" /* isEnumType */])(oldType) || !Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["p" /* isEnumType */])(newType)) {
      return;
    }
    var valuesInNewEnum = Object.create(null);
    newType.getValues().forEach(function (value) {
      valuesInNewEnum[value.name] = true;
    });
    oldType.getValues().forEach(function (value) {
      if (!valuesInNewEnum[value.name]) {
        valuesRemovedFromEnums.push({
          type: BreakingChangeType.VALUE_REMOVED_FROM_ENUM,
          description: value.name + ' was removed from enum type ' + typeName + '.'
        });
      }
    });
  });
  return valuesRemovedFromEnums;
}

/**
 * Given two schemas, returns an Array containing descriptions of any dangerous
 * changes in the newSchema related to adding values to an enum type.
 */
function findValuesAddedToEnums(oldSchema, newSchema) {
  var oldTypeMap = oldSchema.getTypeMap();
  var newTypeMap = newSchema.getTypeMap();

  var valuesAddedToEnums = [];
  Object.keys(oldTypeMap).forEach(function (typeName) {
    var oldType = oldTypeMap[typeName];
    var newType = newTypeMap[typeName];
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["p" /* isEnumType */])(oldType) || !Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["p" /* isEnumType */])(newType)) {
      return;
    }

    var valuesInOldEnum = Object.create(null);
    oldType.getValues().forEach(function (value) {
      valuesInOldEnum[value.name] = true;
    });
    newType.getValues().forEach(function (value) {
      if (!valuesInOldEnum[value.name]) {
        valuesAddedToEnums.push({
          type: DangerousChangeType.VALUE_ADDED_TO_ENUM,
          description: value.name + ' was added to enum type ' + typeName + '.'
        });
      }
    });
  });
  return valuesAddedToEnums;
}

function findInterfacesRemovedFromObjectTypes(oldSchema, newSchema) {
  var oldTypeMap = oldSchema.getTypeMap();
  var newTypeMap = newSchema.getTypeMap();
  var breakingChanges = [];

  Object.keys(oldTypeMap).forEach(function (typeName) {
    var oldType = oldTypeMap[typeName];
    var newType = newTypeMap[typeName];
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["x" /* isObjectType */])(oldType) || !Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["x" /* isObjectType */])(newType)) {
      return;
    }

    var oldInterfaces = oldType.getInterfaces();
    var newInterfaces = newType.getInterfaces();
    oldInterfaces.forEach(function (oldInterface) {
      if (!newInterfaces.some(function (int) {
        return int.name === oldInterface.name;
      })) {
        breakingChanges.push({
          type: BreakingChangeType.INTERFACE_REMOVED_FROM_OBJECT,
          description: typeName + ' no longer implements interface ' + (oldInterface.name + '.')
        });
      }
    });
  });
  return breakingChanges;
}

function findInterfacesAddedToObjectTypes(oldSchema, newSchema) {
  var oldTypeMap = oldSchema.getTypeMap();
  var newTypeMap = newSchema.getTypeMap();
  var interfacesAddedToObjectTypes = [];

  Object.keys(newTypeMap).forEach(function (typeName) {
    var oldType = oldTypeMap[typeName];
    var newType = newTypeMap[typeName];
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["x" /* isObjectType */])(oldType) || !Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["x" /* isObjectType */])(newType)) {
      return;
    }

    var oldInterfaces = oldType.getInterfaces();
    var newInterfaces = newType.getInterfaces();
    newInterfaces.forEach(function (newInterface) {
      if (!oldInterfaces.some(function (int) {
        return int.name === newInterface.name;
      })) {
        interfacesAddedToObjectTypes.push({
          type: DangerousChangeType.INTERFACE_ADDED_TO_OBJECT,
          description: newInterface.name + ' added to interfaces implemented ' + ('by ' + typeName + '.')
        });
      }
    });
  });
  return interfacesAddedToObjectTypes;
}

function findRemovedDirectives(oldSchema, newSchema) {
  var removedDirectives = [];

  var newSchemaDirectiveMap = getDirectiveMapForSchema(newSchema);
  oldSchema.getDirectives().forEach(function (directive) {
    if (!newSchemaDirectiveMap[directive.name]) {
      removedDirectives.push({
        type: BreakingChangeType.DIRECTIVE_REMOVED,
        description: directive.name + ' was removed'
      });
    }
  });

  return removedDirectives;
}

function findRemovedArgsForDirective(oldDirective, newDirective) {
  var removedArgs = [];
  var newArgMap = getArgumentMapForDirective(newDirective);

  oldDirective.args.forEach(function (arg) {
    if (!newArgMap[arg.name]) {
      removedArgs.push(arg);
    }
  });

  return removedArgs;
}

function findRemovedDirectiveArgs(oldSchema, newSchema) {
  var removedDirectiveArgs = [];
  var oldSchemaDirectiveMap = getDirectiveMapForSchema(oldSchema);

  newSchema.getDirectives().forEach(function (newDirective) {
    var oldDirective = oldSchemaDirectiveMap[newDirective.name];
    if (!oldDirective) {
      return;
    }

    findRemovedArgsForDirective(oldDirective, newDirective).forEach(function (arg) {
      removedDirectiveArgs.push({
        type: BreakingChangeType.DIRECTIVE_ARG_REMOVED,
        description: arg.name + ' was removed from ' + newDirective.name
      });
    });
  });

  return removedDirectiveArgs;
}

function findAddedArgsForDirective(oldDirective, newDirective) {
  var addedArgs = [];
  var oldArgMap = getArgumentMapForDirective(oldDirective);

  newDirective.args.forEach(function (arg) {
    if (!oldArgMap[arg.name]) {
      addedArgs.push(arg);
    }
  });

  return addedArgs;
}

function findAddedNonNullDirectiveArgs(oldSchema, newSchema) {
  var addedNonNullableArgs = [];
  var oldSchemaDirectiveMap = getDirectiveMapForSchema(oldSchema);

  newSchema.getDirectives().forEach(function (newDirective) {
    var oldDirective = oldSchemaDirectiveMap[newDirective.name];
    if (!oldDirective) {
      return;
    }

    findAddedArgsForDirective(oldDirective, newDirective).forEach(function (arg) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_0__type_definition__["w" /* isNonNullType */])(arg.type)) {
        return;
      }

      addedNonNullableArgs.push({
        type: BreakingChangeType.NON_NULL_DIRECTIVE_ARG_ADDED,
        description: 'A non-null arg ' + arg.name + ' on directive ' + (newDirective.name + ' was added')
      });
    });
  });

  return addedNonNullableArgs;
}

function findRemovedLocationsForDirective(oldDirective, newDirective) {
  var removedLocations = [];
  var newLocationSet = new Set(newDirective.locations);

  oldDirective.locations.forEach(function (oldLocation) {
    if (!newLocationSet.has(oldLocation)) {
      removedLocations.push(oldLocation);
    }
  });

  return removedLocations;
}

function findRemovedDirectiveLocations(oldSchema, newSchema) {
  var removedLocations = [];
  var oldSchemaDirectiveMap = getDirectiveMapForSchema(oldSchema);

  newSchema.getDirectives().forEach(function (newDirective) {
    var oldDirective = oldSchemaDirectiveMap[newDirective.name];
    if (!oldDirective) {
      return;
    }

    findRemovedLocationsForDirective(oldDirective, newDirective).forEach(function (location) {
      removedLocations.push({
        type: BreakingChangeType.DIRECTIVE_LOCATION_REMOVED,
        description: location + ' was removed from ' + newDirective.name
      });
    });
  });

  return removedLocations;
}

function getDirectiveMapForSchema(schema) {
  return Object(__WEBPACK_IMPORTED_MODULE_3__jsutils_keyMap__["a" /* default */])(schema.getDirectives(), function (dir) {
    return dir.name;
  });
}

function getArgumentMapForDirective(directive) {
  return Object(__WEBPACK_IMPORTED_MODULE_3__jsutils_keyMap__["a" /* default */])(directive.args, function (arg) {
    return arg.name;
  });
}

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export findDeprecatedUsages */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__language_visitor__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type_definition__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__type_schema__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TypeInfo__ = __webpack_require__(169);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */








/**
 * A validation rule which reports deprecated usages.
 *
 * Returns a list of GraphQLError instances describing each deprecated use.
 */
function findDeprecatedUsages(schema, ast) {
  var errors = [];
  var typeInfo = new __WEBPACK_IMPORTED_MODULE_4__TypeInfo__["a" /* TypeInfo */](schema);

  Object(__WEBPACK_IMPORTED_MODULE_1__language_visitor__["b" /* visit */])(ast, Object(__WEBPACK_IMPORTED_MODULE_1__language_visitor__["d" /* visitWithTypeInfo */])(typeInfo, {
    Field: function Field(node) {
      var fieldDef = typeInfo.getFieldDef();
      if (fieldDef && fieldDef.isDeprecated) {
        var parentType = typeInfo.getParentType();
        if (parentType) {
          var reason = fieldDef.deprecationReason;
          errors.push(new __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError__["a" /* GraphQLError */]('The field ' + parentType.name + '.' + fieldDef.name + ' is deprecated.' + (reason ? ' ' + reason : ''), [node]));
        }
      }
    },
    EnumValue: function EnumValue(node) {
      var enumVal = typeInfo.getEnumValue();
      if (enumVal && enumVal.isDeprecated) {
        var type = Object(__WEBPACK_IMPORTED_MODULE_2__type_definition__["l" /* getNamedType */])(typeInfo.getInputType());
        if (type) {
          var reason = enumVal.deprecationReason;
          errors.push(new __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError__["a" /* GraphQLError */]('The enum value ' + type.name + '.' + enumVal.name + ' is deprecated.' + (reason ? ' ' + reason : ''), [node]));
        }
      }
    }
  }));

  return errors;
}

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(705);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = { cmp: opts };
    var cycles = (typeof opts.cycles === 'boolean') ? opts.cycles : false;

    var cmp = opts.cmp && (function (f) {
        return function (node) {
            return function (a, b) {
                var aobj = { key: a, value: node[a] };
                var bobj = { key: b, value: node[b] };
                return f(aobj, bobj);
            };
        };
    })(opts.cmp);

    var seen = [];
    return (function stringify (node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') {
            node = node.toJSON();
        }

        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);

        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for (i = 0; i < node.length; i++) {
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }

        if (node === null) return 'null';

        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }

        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for (i = 0; i < keys.length; i++) {
            var key = keys[i];
            var value = stringify(node[key]);

            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    })(data);
};


/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return equal; });
var _a = Object.prototype, toString = _a.toString, hasOwnProperty = _a.hasOwnProperty;
var previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */
function equal(a, b) {
    try {
        return check(a, b);
    }
    finally {
        previousComparisons.clear();
    }
}
function check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) {
        return true;
    }
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = toString.call(a);
    var bTag = toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) {
        return false;
    }
    switch (aTag) {
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length)
                return false;
        // Fall through to object case...
        case '[object Object]': {
            if (previouslyCompared(a, b))
                return true;
            var aKeys = Object.keys(a);
            var bKeys = Object.keys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length)
                return false;
            // Now make sure they have the same keys.
            for (var k = 0; k < keyCount; ++k) {
                if (!hasOwnProperty.call(b, aKeys[k])) {
                    return false;
                }
            }
            // Finally, check deep equality of all child properties.
            for (var k = 0; k < keyCount; ++k) {
                var key = aKeys[k];
                if (!check(a[key], b[key])) {
                    return false;
                }
            }
            return true;
        }
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a)
                return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == "" + b;
        case '[object Map]':
        case '[object Set]': {
            if (a.size !== b.size)
                return false;
            if (previouslyCompared(a, b))
                return true;
            var aIterator = a.entries();
            var isMap = aTag === '[object Map]';
            while (true) {
                var info = aIterator.next();
                if (info.done)
                    break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) {
                    return false;
                }
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !check(aValue, b.get(aKey))) {
                    return false;
                }
            }
            return true;
        }
    }
    // Otherwise the values are not equal.
    return false;
}
function previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b))
            return true;
    }
    else {
        previousComparisons.set(a, bSet = new Set);
    }
    bSet.add(b);
    return false;
}

/* unused harmony default export */ var _unused_webpack_default_export = (equal);

//# sourceMappingURL=equality.esm.js.map


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(709).Observable;


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Observable = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// === Symbol Support ===
var hasSymbols = function () {
  return typeof Symbol === 'function';
};

var hasSymbol = function (name) {
  return hasSymbols() && Boolean(Symbol[name]);
};

var getSymbol = function (name) {
  return hasSymbol(name) ? Symbol[name] : '@@' + name;
};

if (hasSymbols() && !hasSymbol('observable')) {
  Symbol.observable = Symbol('observable');
}

var SymbolIterator = getSymbol('iterator');
var SymbolObservable = getSymbol('observable');
var SymbolSpecies = getSymbol('species'); // === Abstract Operations ===

function getMethod(obj, key) {
  var value = obj[key];
  if (value == null) return undefined;
  if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
  return value;
}

function getSpecies(obj) {
  var ctor = obj.constructor;

  if (ctor !== undefined) {
    ctor = ctor[SymbolSpecies];

    if (ctor === null) {
      ctor = undefined;
    }
  }

  return ctor !== undefined ? ctor : Observable;
}

function isObservable(x) {
  return x instanceof Observable; // SPEC: Brand check
}

function hostReportError(e) {
  if (hostReportError.log) {
    hostReportError.log(e);
  } else {
    setTimeout(function () {
      throw e;
    });
  }
}

function enqueue(fn) {
  Promise.resolve().then(function () {
    try {
      fn();
    } catch (e) {
      hostReportError(e);
    }
  });
}

function cleanupSubscription(subscription) {
  var cleanup = subscription._cleanup;
  if (cleanup === undefined) return;
  subscription._cleanup = undefined;

  if (!cleanup) {
    return;
  }

  try {
    if (typeof cleanup === 'function') {
      cleanup();
    } else {
      var unsubscribe = getMethod(cleanup, 'unsubscribe');

      if (unsubscribe) {
        unsubscribe.call(cleanup);
      }
    }
  } catch (e) {
    hostReportError(e);
  }
}

function closeSubscription(subscription) {
  subscription._observer = undefined;
  subscription._queue = undefined;
  subscription._state = 'closed';
}

function flushSubscription(subscription) {
  var queue = subscription._queue;

  if (!queue) {
    return;
  }

  subscription._queue = undefined;
  subscription._state = 'ready';

  for (var i = 0; i < queue.length; ++i) {
    notifySubscription(subscription, queue[i].type, queue[i].value);
    if (subscription._state === 'closed') break;
  }
}

function notifySubscription(subscription, type, value) {
  subscription._state = 'running';
  var observer = subscription._observer;

  try {
    var m = getMethod(observer, type);

    switch (type) {
      case 'next':
        if (m) m.call(observer, value);
        break;

      case 'error':
        closeSubscription(subscription);
        if (m) m.call(observer, value);else throw value;
        break;

      case 'complete':
        closeSubscription(subscription);
        if (m) m.call(observer);
        break;
    }
  } catch (e) {
    hostReportError(e);
  }

  if (subscription._state === 'closed') cleanupSubscription(subscription);else if (subscription._state === 'running') subscription._state = 'ready';
}

function onNotify(subscription, type, value) {
  if (subscription._state === 'closed') return;

  if (subscription._state === 'buffering') {
    subscription._queue.push({
      type: type,
      value: value
    });

    return;
  }

  if (subscription._state !== 'ready') {
    subscription._state = 'buffering';
    subscription._queue = [{
      type: type,
      value: value
    }];
    enqueue(function () {
      return flushSubscription(subscription);
    });
    return;
  }

  notifySubscription(subscription, type, value);
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(observer, subscriber) {
    _classCallCheck(this, Subscription);

    // ASSERT: observer is an object
    // ASSERT: subscriber is callable
    this._cleanup = undefined;
    this._observer = observer;
    this._queue = undefined;
    this._state = 'initializing';
    var subscriptionObserver = new SubscriptionObserver(this);

    try {
      this._cleanup = subscriber.call(undefined, subscriptionObserver);
    } catch (e) {
      subscriptionObserver.error(e);
    }

    if (this._state === 'initializing') this._state = 'ready';
  }

  _createClass(Subscription, [{
    key: "unsubscribe",
    value: function unsubscribe() {
      if (this._state !== 'closed') {
        closeSubscription(this);
        cleanupSubscription(this);
      }
    }
  }, {
    key: "closed",
    get: function () {
      return this._state === 'closed';
    }
  }]);

  return Subscription;
}();

var SubscriptionObserver =
/*#__PURE__*/
function () {
  function SubscriptionObserver(subscription) {
    _classCallCheck(this, SubscriptionObserver);

    this._subscription = subscription;
  }

  _createClass(SubscriptionObserver, [{
    key: "next",
    value: function next(value) {
      onNotify(this._subscription, 'next', value);
    }
  }, {
    key: "error",
    value: function error(value) {
      onNotify(this._subscription, 'error', value);
    }
  }, {
    key: "complete",
    value: function complete() {
      onNotify(this._subscription, 'complete');
    }
  }, {
    key: "closed",
    get: function () {
      return this._subscription._state === 'closed';
    }
  }]);

  return SubscriptionObserver;
}();

var Observable =
/*#__PURE__*/
function () {
  function Observable(subscriber) {
    _classCallCheck(this, Observable);

    if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
    if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
    this._subscriber = subscriber;
  }

  _createClass(Observable, [{
    key: "subscribe",
    value: function subscribe(observer) {
      if (typeof observer !== 'object' || observer === null) {
        observer = {
          next: observer,
          error: arguments[1],
          complete: arguments[2]
        };
      }

      return new Subscription(observer, this._subscriber);
    }
  }, {
    key: "forEach",
    value: function forEach(fn) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        if (typeof fn !== 'function') {
          reject(new TypeError(fn + ' is not a function'));
          return;
        }

        function done() {
          subscription.unsubscribe();
          resolve();
        }

        var subscription = _this.subscribe({
          next: function (value) {
            try {
              fn(value, done);
            } catch (e) {
              reject(e);
              subscription.unsubscribe();
            }
          },
          error: reject,
          complete: resolve
        });
      });
    }
  }, {
    key: "map",
    value: function map(fn) {
      var _this2 = this;

      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
      var C = getSpecies(this);
      return new C(function (observer) {
        return _this2.subscribe({
          next: function (value) {
            try {
              value = fn(value);
            } catch (e) {
              return observer.error(e);
            }

            observer.next(value);
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            observer.complete();
          }
        });
      });
    }
  }, {
    key: "filter",
    value: function filter(fn) {
      var _this3 = this;

      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
      var C = getSpecies(this);
      return new C(function (observer) {
        return _this3.subscribe({
          next: function (value) {
            try {
              if (!fn(value)) return;
            } catch (e) {
              return observer.error(e);
            }

            observer.next(value);
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            observer.complete();
          }
        });
      });
    }
  }, {
    key: "reduce",
    value: function reduce(fn) {
      var _this4 = this;

      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
      var C = getSpecies(this);
      var hasSeed = arguments.length > 1;
      var hasValue = false;
      var seed = arguments[1];
      var acc = seed;
      return new C(function (observer) {
        return _this4.subscribe({
          next: function (value) {
            var first = !hasValue;
            hasValue = true;

            if (!first || hasSeed) {
              try {
                acc = fn(acc, value);
              } catch (e) {
                return observer.error(e);
              }
            } else {
              acc = value;
            }
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
            observer.next(acc);
            observer.complete();
          }
        });
      });
    }
  }, {
    key: "concat",
    value: function concat() {
      var _this5 = this;

      for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
        sources[_key] = arguments[_key];
      }

      var C = getSpecies(this);
      return new C(function (observer) {
        var subscription;
        var index = 0;

        function startNext(next) {
          subscription = next.subscribe({
            next: function (v) {
              observer.next(v);
            },
            error: function (e) {
              observer.error(e);
            },
            complete: function () {
              if (index === sources.length) {
                subscription = undefined;
                observer.complete();
              } else {
                startNext(C.from(sources[index++]));
              }
            }
          });
        }

        startNext(_this5);
        return function () {
          if (subscription) {
            subscription.unsubscribe();
            subscription = undefined;
          }
        };
      });
    }
  }, {
    key: "flatMap",
    value: function flatMap(fn) {
      var _this6 = this;

      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
      var C = getSpecies(this);
      return new C(function (observer) {
        var subscriptions = [];

        var outer = _this6.subscribe({
          next: function (value) {
            if (fn) {
              try {
                value = fn(value);
              } catch (e) {
                return observer.error(e);
              }
            }

            var inner = C.from(value).subscribe({
              next: function (value) {
                observer.next(value);
              },
              error: function (e) {
                observer.error(e);
              },
              complete: function () {
                var i = subscriptions.indexOf(inner);
                if (i >= 0) subscriptions.splice(i, 1);
                completeIfDone();
              }
            });
            subscriptions.push(inner);
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            completeIfDone();
          }
        });

        function completeIfDone() {
          if (outer.closed && subscriptions.length === 0) observer.complete();
        }

        return function () {
          subscriptions.forEach(function (s) {
            return s.unsubscribe();
          });
          outer.unsubscribe();
        };
      });
    }
  }, {
    key: SymbolObservable,
    value: function () {
      return this;
    }
  }], [{
    key: "from",
    value: function from(x) {
      var C = typeof this === 'function' ? this : Observable;
      if (x == null) throw new TypeError(x + ' is not an object');
      var method = getMethod(x, SymbolObservable);

      if (method) {
        var observable = method.call(x);
        if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
        if (isObservable(observable) && observable.constructor === C) return observable;
        return new C(function (observer) {
          return observable.subscribe(observer);
        });
      }

      if (hasSymbol('iterator')) {
        method = getMethod(x, SymbolIterator);

        if (method) {
          return new C(function (observer) {
            enqueue(function () {
              if (observer.closed) return;
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var _item = _step.value;
                  observer.next(_item);
                  if (observer.closed) return;
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }

              observer.complete();
            });
          });
        }
      }

      if (Array.isArray(x)) {
        return new C(function (observer) {
          enqueue(function () {
            if (observer.closed) return;

            for (var i = 0; i < x.length; ++i) {
              observer.next(x[i]);
              if (observer.closed) return;
            }

            observer.complete();
          });
        });
      }

      throw new TypeError(x + ' is not observable');
    }
  }, {
    key: "of",
    value: function of() {
      for (var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        items[_key2] = arguments[_key2];
      }

      var C = typeof this === 'function' ? this : Observable;
      return new C(function (observer) {
        enqueue(function () {
          if (observer.closed) return;

          for (var i = 0; i < items.length; ++i) {
            observer.next(items[i]);
            if (observer.closed) return;
          }

          observer.complete();
        });
      });
    }
  }, {
    key: SymbolSpecies,
    get: function () {
      return this;
    }
  }]);

  return Observable;
}();

exports.Observable = Observable;

if (hasSymbols()) {
  Object.defineProperty(Observable, Symbol('extensions'), {
    value: {
      symbol: SymbolObservable,
      hostReportError: hostReportError
    },
    configurable: true
  });
}

/***/ }),
/* 710 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

var createFlow = __webpack_require__(713);

/**
 * This method is like `_.flow` except that it creates a function that
 * invokes the given functions from right to left.
 *
 * @static
 * @since 3.0.0
 * @memberOf _
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flow
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flowRight([square, _.add]);
 * addSquare(1, 2);
 * // => 9
 */
var flowRight = createFlow(true);

module.exports = flowRight;


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

var LodashWrapper = __webpack_require__(282),
    flatRest = __webpack_require__(714),
    getData = __webpack_require__(430),
    getFuncName = __webpack_require__(431),
    isArray = __webpack_require__(288),
    isLaziable = __webpack_require__(742);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */
function createFlow(fromRight) {
  return flatRest(function(funcs) {
    var length = funcs.length,
        index = length,
        prereq = LodashWrapper.prototype.thru;

    if (fromRight) {
      funcs.reverse();
    }
    while (index--) {
      var func = funcs[index];
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
        var wrapper = new LodashWrapper([], true);
      }
    }
    index = wrapper ? index : length;
    while (++index < length) {
      func = funcs[index];

      var funcName = getFuncName(func),
          data = funcName == 'wrapper' ? getData(func) : undefined;

      if (data && isLaziable(data[0]) &&
            data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
            !data[4].length && data[9] == 1
          ) {
        wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
      } else {
        wrapper = (func.length == 1 && isLaziable(func))
          ? wrapper[funcName]()
          : wrapper.thru(func);
      }
    }
    return function() {
      var args = arguments,
          value = args[0];

      if (wrapper && args.length == 1 && isArray(value)) {
        return wrapper.plant(value).value();
      }
      var index = 0,
          result = length ? funcs[index].apply(this, args) : value;

      while (++index < length) {
        result = funcs[index].call(this, result);
      }
      return result;
    };
  });
}

module.exports = createFlow;


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(715),
    overRest = __webpack_require__(724),
    setToString = __webpack_require__(726);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(716);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(717),
    isFlattenable = __webpack_require__(718);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 717 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(285),
    isArguments = __webpack_require__(720),
    isArray = __webpack_require__(288);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(72)))

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(721),
    isObjectLike = __webpack_require__(287);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(428),
    isObjectLike = __webpack_require__(287);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(285);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 723 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(725);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 725 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(727),
    shortOut = __webpack_require__(737);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(728),
    defineProperty = __webpack_require__(729),
    identity = __webpack_require__(736);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 728 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(429);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(731),
    isMasked = __webpack_require__(732),
    isObject = __webpack_require__(283),
    toSource = __webpack_require__(734);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(428),
    isObject = __webpack_require__(283);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(733);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(286);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 734 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 735 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 736 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 737 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

var WeakMap = __webpack_require__(739);

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(429),
    root = __webpack_require__(286);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 740 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 741 */
/***/ (function(module, exports) {

/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(289),
    getData = __webpack_require__(430),
    getFuncName = __webpack_require__(431),
    lodash = __webpack_require__(743);

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

module.exports = isLaziable;


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(289),
    LodashWrapper = __webpack_require__(282),
    baseLodash = __webpack_require__(284),
    isArray = __webpack_require__(288),
    isObjectLike = __webpack_require__(287),
    wrapperClone = __webpack_require__(744);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

module.exports = lodash;


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(289),
    LodashWrapper = __webpack_require__(282),
    copyArray = __webpack_require__(745);

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

module.exports = wrapperClone;


/***/ }),
/* 745 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.Helmet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSideEffect = __webpack_require__(747);

var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

var _reactFastCompare = __webpack_require__(749);

var _reactFastCompare2 = _interopRequireDefault(_reactFastCompare);

var _HelmetUtils = __webpack_require__(750);

var _HelmetConstants = __webpack_require__(432);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Helmet = function Helmet(Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
        _inherits(HelmetWrapper, _React$Component);

        function HelmetWrapper() {
            _classCallCheck(this, HelmetWrapper);

            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, _reactFastCompare2.default)(this.props, nextProps);
        };

        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) {
                return null;
            }

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.SCRIPT:
                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };

                case _HelmetConstants.TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }

            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };

        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _extends2;

            var child = _ref.child,
                arrayTypeChildren = _ref.arrayTypeChildren,
                newChildProps = _ref.newChildProps,
                nestedChildren = _ref.nestedChildren;

            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
        };

        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _extends3, _extends4;

            var child = _ref2.child,
                newProps = _ref2.newProps,
                newChildProps = _ref2.newChildProps,
                nestedChildren = _ref2.nestedChildren;

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.TITLE:
                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));

                case _HelmetConstants.TAG_NAMES.BODY:
                    return _extends({}, newProps, {
                        bodyAttributes: _extends({}, newChildProps)
                    });

                case _HelmetConstants.TAG_NAMES.HTML:
                    return _extends({}, newProps, {
                        htmlAttributes: _extends({}, newChildProps)
                    });
            }

            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
        };

        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = _extends({}, newProps);

            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
                var _extends5;

                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
            });

            return newFlattenedProps;
        };

        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            if (false) {
                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
                    return child.type === name;
                })) {
                    if (typeof child.type === "function") {
                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
                    }

                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
                }

                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
                    return typeof nestedChild !== "string";
                }))) {
                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
                }
            }

            return true;
        };

        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;

            var arrayTypeChildren = {};

            _react2.default.Children.forEach(children, function (child) {
                if (!child || !child.props) {
                    return;
                }

                var _child$props = child.props,
                    nestedChildren = _child$props.children,
                    childProps = _objectWithoutProperties(_child$props, ["children"]);

                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);

                _this2.warnOnInvalidChildren(child, nestedChildren);

                switch (child.type) {
                    case _HelmetConstants.TAG_NAMES.LINK:
                    case _HelmetConstants.TAG_NAMES.META:
                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    case _HelmetConstants.TAG_NAMES.SCRIPT:
                    case _HelmetConstants.TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;

                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });

            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };

        HelmetWrapper.prototype.render = function render() {
            var _props = this.props,
                children = _props.children,
                props = _objectWithoutProperties(_props, ["children"]);

            var newProps = _extends({}, props);

            if (children) {
                newProps = this.mapChildrenToProps(children, newProps);
            }

            return _react2.default.createElement(Component, newProps);
        };

        _createClass(HelmetWrapper, null, [{
            key: "canUseDOM",


            // Component.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.

            /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */
            set: function set(canUseDOM) {
                Component.canUseDOM = canUseDOM;
            }
        }]);

        return HelmetWrapper;
    }(_react2.default.Component), _class.propTypes = {
        base: _propTypes2.default.object,
        bodyAttributes: _propTypes2.default.object,
        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
        defaultTitle: _propTypes2.default.string,
        defer: _propTypes2.default.bool,
        encodeSpecialCharacters: _propTypes2.default.bool,
        htmlAttributes: _propTypes2.default.object,
        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
        onChangeClientState: _propTypes2.default.func,
        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
        title: _propTypes2.default.string,
        titleAttributes: _propTypes2.default.object,
        titleTemplate: _propTypes2.default.string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function () {
        var mappedState = Component.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = (0, _HelmetUtils.mapStateOnServer)({
                baseTag: [],
                bodyAttributes: {},
                encodeSpecialCharacters: true,
                htmlAttributes: {},
                linkTags: [],
                metaTags: [],
                noscriptTags: [],
                scriptTags: [],
                styleTags: [],
                title: "",
                titleAttributes: {}
            });
        }

        return mappedState;
    }, _temp;
};

var NullComponent = function NullComponent() {
    return null;
};

var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);

var HelmetExport = Helmet(HelmetSideEffects);
HelmetExport.renderStatic = HelmetExport.rewind;

exports.Helmet = HelmetExport;
exports.default = HelmetExport;

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(0);
var React__default = _interopDefault(React);
var shallowEqual = _interopDefault(__webpack_require__(748));

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }

  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }

  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect =
    /*#__PURE__*/
    function (_Component) {
      _inheritsLoose(SideEffect, _Component);

      function SideEffect() {
        return _Component.apply(this, arguments) || this;
      }

      // Try to use displayName of wrapped component
      // Expose canUseDOM so tests can monkeypatch it
      SideEffect.peek = function peek() {
        return state;
      };

      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      var _proto = SideEffect.prototype;

      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return !shallowEqual(nextProps, this.props);
      };

      _proto.componentWillMount = function componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      _proto.render = function render() {
        return React__default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(React.Component);

    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");

    _defineProperty(SideEffect, "canUseDOM", canUseDOM);

    return SideEffect;
  };
}

module.exports = withSideEffect;


/***/ }),
/* 748 */
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;
var hasElementType = typeof Element !== 'undefined';

function equal(a, b) {
  // fast-deep-equal index.js 2.0.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    var arrA = isArray(a)
      , arrB = isArray(b)
      , i
      , length
      , key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    if (arrA != arrB) return false;

    var dateA = a instanceof Date
      , dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();

    var regexpA = a instanceof RegExp
      , regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();

    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length)
      return false;

    for (i = length; i-- !== 0;)
      if (!hasProp.call(b, keys[i])) return false;
    // end fast-deep-equal

    // start react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element && b instanceof Element)
      return a === b;

    // custom handling for React
    for (i = length; i-- !== 0;) {
      key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal(a[key], b[key])) return false;
      }
    }
    // end react-fast-compare

    // fast-deep-equal index.js 2.0.1
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if ((error.message && error.message.match(/stack|recursion/i)) || (error.number === -2146828260)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(207);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _HelmetConstants = __webpack_require__(432);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (encode === false) {
        return String(str);
    }

    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);

    return innermostTitle || innermostDefaultTitle || undefined;
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[_HelmetConstants.TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    return propsList.filter(function (props) {
        if (Array.isArray(props[tagName])) {
            return true;
        }
        if (typeof props[tagName] !== "undefined") {
            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
        }
        return false;
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props.hasOwnProperty(property)) {
            return props[property];
        }
    }

    return null;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        onChangeClientState: getOnChangeClientState(propsList),
        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
    };
};

var rafPolyfill = function () {
    var clock = Date.now();

    return function (callback) {
        var currentTime = Date.now();

        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else {
            setTimeout(function () {
                rafPolyfill(callback);
            }, 0);
        }
    };
}();

var cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};

var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;

var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;

var warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};

var _helmetCallback = null;

var handleClientStateChange = function handleClientStateChange(newState) {
    if (_helmetCallback) {
        cancelAnimationFrame(_helmetCallback);
    }

    if (newState.defer) {
        _helmetCallback = requestAnimationFrame(function () {
            commitTagChanges(newState, function () {
                _helmetCallback = null;
            });
        });
    } else {
        commitTagChanges(newState);
        _helmetCallback = null;
    }
};

var commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag,
        bodyAttributes = newState.bodyAttributes,
        htmlAttributes = newState.htmlAttributes,
        linkTags = newState.linkTags,
        metaTags = newState.metaTags,
        noscriptTags = newState.noscriptTags,
        onChangeClientState = newState.onChangeClientState,
        scriptTags = newState.scriptTags,
        styleTags = newState.styleTags,
        title = newState.title,
        titleAttributes = newState.titleAttributes;

    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);

    updateTitle(title, titleAttributes);

    var tagUpdates = {
        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
    };

    var addedTags = {};
    var removedTags = {};

    Object.keys(tagUpdates).forEach(function (tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType],
            newTags = _tagUpdates$tagType.newTags,
            oldTags = _tagUpdates$tagType.oldTags;


        if (newTags.length) {
            addedTags[tagType] = newTags;
        }
        if (oldTags.length) {
            removedTags[tagType] = tagUpdates[tagType].oldTags;
        }
    });

    cb && cb();

    onChangeClientState(newState, addedTags, removedTags);
};

var flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};

var updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) {
        document.title = flattenArray(title);
    }

    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];

    if (!elementTag) {
        return;
    }

    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";

        if (elementTag.getAttribute(attribute) !== value) {
            elementTag.setAttribute(attribute, value);
        }

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        elementTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = generateElementAttributesAsString(attributes);
    var flattenedTitle = flattenArray(title);
    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function (string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;

        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};

var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(attributes).reduce(function (obj, key) {
        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};

var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(props).reduce(function (obj, key) {
        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;

    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
    var props = convertElementAttributestoReactProps(attributes, initProps);

    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function (tag, i) {
        var _mappedTag;

        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;

            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return _react2.default.createElement(type, mappedTag);
    });
};

var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch (type) {
        case _HelmetConstants.TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags, encode);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag,
        bodyAttributes = _ref.bodyAttributes,
        encode = _ref.encode,
        htmlAttributes = _ref.htmlAttributes,
        linkTags = _ref.linkTags,
        metaTags = _ref.metaTags,
        noscriptTags = _ref.noscriptTags,
        scriptTags = _ref.scriptTags,
        styleTags = _ref.styleTags,
        _ref$title = _ref.title,
        title = _ref$title === undefined ? "" : _ref$title,
        titleAttributes = _ref.titleAttributes;
    return {
        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
    };
};

exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
exports.handleClientStateChange = handleClientStateChange;
exports.mapStateOnServer = mapStateOnServer;
exports.reducePropsToState = reducePropsToState;
exports.requestAnimationFrame = requestAnimationFrame;
exports.warn = warn;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(72)))

/***/ }),
/* 751 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



var isObject = __webpack_require__(753);

function isObjectObject(o) {
  return isObject(o) === true
    && Object.prototype.toString.call(o) === '[object Object]';
}

module.exports = function isPlainObject(o) {
  var ctor,prot;

  if (isObjectObject(o) === false) return false;

  // If has modified constructor
  ctor = o.constructor;
  if (typeof ctor !== 'function') return false;

  // If has modified prototype
  prot = ctor.prototype;
  if (isObjectObject(prot) === false) return false;

  // If constructor does not have an Object-specific method
  if (prot.hasOwnProperty('isPrototypeOf') === false) {
    return false;
  }

  // Most likely a plain Object
  return true;
};


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



module.exports = function isObject(val) {
  return val != null && typeof val === 'object' && Array.isArray(val) === false;
};


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createMixins;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _extends3 = _interopRequireDefault(__webpack_require__(11));

function createMixins(breakpoints, spacing, mixins) {
  var _toolbar;

  return (0, _extends3.default)({
    gutters: function gutters() {
      var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return (0, _extends3.default)({
        paddingLeft: spacing.unit * 2,
        paddingRight: spacing.unit * 2
      }, styles, (0, _defineProperty2.default)({}, breakpoints.up('sm'), (0, _extends3.default)({
        paddingLeft: spacing.unit * 3,
        paddingRight: spacing.unit * 3
      }, styles[breakpoints.up('sm')])));
    },
    toolbar: (_toolbar = {
      minHeight: 56
    }, (0, _defineProperty2.default)(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
      minHeight: 48
    }), (0, _defineProperty2.default)(_toolbar, breakpoints.up('sm'), {
      minHeight: 64
    }), _toolbar)
  }, mixins);
}

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createPalette;
exports.dark = exports.light = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _warning = _interopRequireDefault(__webpack_require__(37));

var _deepmerge = _interopRequireDefault(__webpack_require__(215));

var _indigo = _interopRequireDefault(__webpack_require__(434));

var _pink = _interopRequireDefault(__webpack_require__(435));

var _grey = _interopRequireDefault(__webpack_require__(436));

var _red = _interopRequireDefault(__webpack_require__(437));

var _common = _interopRequireDefault(__webpack_require__(438));

var _colorManipulator = __webpack_require__(80);

// < 1kb payload overhead when lodash/merge is > 3kb.
var light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.54)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)',
    // Text hints.
    hint: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: _common.default.white,
    default: _grey.default[50]
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.08)',
    hoverOpacity: 0.08,
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.14)',
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)'
  }
};
exports.light = light;
var dark = {
  text: {
    primary: _common.default.white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    hint: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: _grey.default[800],
    default: '#303030'
  },
  action: {
    active: _common.default.white,
    hover: 'rgba(255, 255, 255, 0.1)',
    hoverOpacity: 0.1,
    selected: 'rgba(255, 255, 255, 0.2)',
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)'
  }
};
exports.dark = dark;

function addLightOrDark(intent, direction, shade, tonalOffset) {
  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = (0, _colorManipulator.lighten)(intent.main, tonalOffset);
    } else if (direction === 'dark') {
      intent.dark = (0, _colorManipulator.darken)(intent.main, tonalOffset * 1.5);
    }
  }
}

function createPalette(palette) {
  var _palette$primary = palette.primary,
      primary = _palette$primary === void 0 ? {
    light: _indigo.default[300],
    main: _indigo.default[500],
    dark: _indigo.default[700]
  } : _palette$primary,
      _palette$secondary = palette.secondary,
      secondary = _palette$secondary === void 0 ? {
    light: _pink.default.A200,
    main: _pink.default.A400,
    dark: _pink.default.A700
  } : _palette$secondary,
      _palette$error = palette.error,
      error = _palette$error === void 0 ? {
    light: _red.default[300],
    main: _red.default[500],
    dark: _red.default[700]
  } : _palette$error,
      _palette$type = palette.type,
      type = _palette$type === void 0 ? 'light' : _palette$type,
      _palette$contrastThre = palette.contrastThreshold,
      contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre,
      _palette$tonalOffset = palette.tonalOffset,
      tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset,
      other = (0, _objectWithoutProperties2.default)(palette, ["primary", "secondary", "error", "type", "contrastThreshold", "tonalOffset"]);

  function getContrastText(background) {
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    var contrastText = (0, _colorManipulator.getContrastRatio)(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;

    if (false) {
      var contrast = (0, _colorManipulator.getContrastRatio)(background, contrastText);
      process.env.NODE_ENV !== "production" ? (0, _warning.default)(contrast >= 3, ["Material-UI: the contrast ratio of ".concat(contrast, ":1 for ").concat(contrastText, " on ").concat(background), 'falls below the WACG recommended absolute minimum contrast ratio of 3:1.', 'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'].join('\n')) : void 0;
    }

    return contrastText;
  }

  function augmentColor(color) {
    var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
    var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;

    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }

    if (false) {
      throw new Error(['Material-UI: the color provided to augmentColor(color) is invalid.', "The color object needs to have a `main` property or a `".concat(mainShade, "` property.")].join('\n'));
    }

    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);

    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }
  }

  augmentColor(primary);
  augmentColor(secondary, 'A400', 'A200', 'A700');
  augmentColor(error);
  var types = {
    dark: dark,
    light: light
  };
   false ? (0, _warning.default)(types[type], "Material-UI: the palette type `".concat(type, "` is not supported.")) : void 0;
  var paletteOutput = (0, _deepmerge.default)((0, _extends2.default)({
    // A collection of common colors.
    common: _common.default,
    // The palette type, can be light or dark.
    type: type,
    // The colors used to represent primary interface elements for a user.
    primary: primary,
    // The colors used to represent secondary interface elements for a user.
    secondary: secondary,
    // The colors used to represent interface elements that the user should be made aware of.
    error: error,
    // The grey colors.
    grey: _grey.default,
    // Used by `getContrastText()` to maximize the contrast between the background and
    // the text.
    contrastThreshold: contrastThreshold,
    // Take a background color and return the color of the text to maximize the contrast.
    getContrastText: getContrastText,
    // Generate a rich color object.
    augmentColor: augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: tonalOffset
  }, types[type]), other, {
    clone: false // No need to clone deep

  });
  return paletteOutput;
}

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createTypography;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _deepmerge = _interopRequireDefault(__webpack_require__(215));

// < 1kb payload overhead when lodash/merge is > 3kb.
function round(value) {
  return Math.round(value * 1e5) / 1e5;
}

function createTypography(palette, typography) {
  var _ref = typeof typography === 'function' ? typography(palette) : typography,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? '"Roboto", "Helvetica", "Arial", sans-serif' : _ref$fontFamily,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize,
      _ref$fontWeightLight = _ref.fontWeightLight,
      fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight,
      _ref$fontWeightRegula = _ref.fontWeightRegular,
      fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula,
      _ref$fontWeightMedium = _ref.fontWeightMedium,
      fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium,
      _ref$htmlFontSize = _ref.htmlFontSize,
      htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize,
      allVariants = _ref.allVariants,
      other = (0, _objectWithoutProperties2.default)(_ref, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "htmlFontSize", "allVariants"]);

  var coef = fontSize / 14;

  function pxToRem(value) {
    return "".concat(value / htmlFontSize * coef, "rem");
  }

  return (0, _deepmerge.default)({
    pxToRem: pxToRem,
    round: round,
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeightLight: fontWeightLight,
    fontWeightRegular: fontWeightRegular,
    fontWeightMedium: fontWeightMedium,
    display4: (0, _extends2.default)({
      fontSize: pxToRem(112),
      fontWeight: fontWeightLight,
      fontFamily: fontFamily,
      letterSpacing: '-.04em',
      lineHeight: "".concat(round(128 / 112), "em"),
      marginLeft: '-.04em',
      color: palette.text.secondary
    }, allVariants),
    display3: (0, _extends2.default)({
      fontSize: pxToRem(56),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      letterSpacing: '-.02em',
      lineHeight: "".concat(round(73 / 56), "em"),
      marginLeft: '-.02em',
      color: palette.text.secondary
    }, allVariants),
    display2: (0, _extends2.default)({
      fontSize: pxToRem(45),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(51 / 45), "em"),
      marginLeft: '-.02em',
      color: palette.text.secondary
    }, allVariants),
    display1: (0, _extends2.default)({
      fontSize: pxToRem(34),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(41 / 34), "em"),
      color: palette.text.secondary
    }, allVariants),
    headline: (0, _extends2.default)({
      fontSize: pxToRem(24),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(32.5 / 24), "em"),
      color: palette.text.primary
    }, allVariants),
    title: (0, _extends2.default)({
      fontSize: pxToRem(21),
      fontWeight: fontWeightMedium,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(24.5 / 21), "em"),
      color: palette.text.primary
    }, allVariants),
    subheading: (0, _extends2.default)({
      fontSize: pxToRem(16),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(24 / 16), "em"),
      color: palette.text.primary
    }, allVariants),
    body2: (0, _extends2.default)({
      fontSize: pxToRem(14),
      fontWeight: fontWeightMedium,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(24 / 14), "em"),
      color: palette.text.primary
    }, allVariants),
    body1: (0, _extends2.default)({
      fontSize: pxToRem(14),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(20.5 / 14), "em"),
      color: palette.text.primary
    }, allVariants),
    caption: (0, _extends2.default)({
      fontSize: pxToRem(12),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(16.5 / 12), "em"),
      color: palette.text.secondary
    }, allVariants),
    button: (0, _extends2.default)({
      fontSize: pxToRem(14),
      textTransform: 'uppercase',
      fontWeight: fontWeightMedium,
      fontFamily: fontFamily,
      color: palette.text.primary
    }, allVariants)
  }, other, {
    clone: false // No need to clone deep

  });
}

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var shadowKeyUmbraOpacity = 0.2;
var shadowKeyPenumbraOpacity = 0.14;
var shadowAmbientShadowOpacity = 0.12;

function createShadow() {
  return ["".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0, 0, 0, ").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0, 0, 0, ").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0, 0, 0, ").concat(shadowAmbientShadowOpacity, ")")].join(',');
}

var shadows = ['none', createShadow(0, 1, 3, 0, 0, 1, 1, 0, 0, 2, 1, -1), createShadow(0, 1, 5, 0, 0, 2, 2, 0, 0, 3, 1, -2), createShadow(0, 1, 8, 0, 0, 3, 4, 0, 0, 3, 3, -2), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
var _default = shadows;
exports.default = _default;

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var shape = {
  borderRadius: 4
};
var _default = shape;
exports.default = _default;

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var spacing = {
  // All components align to an 8dp square baseline grid for mobile, tablet, and desktop.
  // https://material.io/design/layout/understanding-layout.html#pixel-density
  unit: 8
};
var _default = spacing;
exports.default = _default;

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports['default'] = jssGlobal;

var _jss = __webpack_require__(441);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var propKey = '@global';
var prefixKey = '@global ';

var GlobalContainerRule = function () {
  function GlobalContainerRule(key, styles, options) {
    _classCallCheck(this, GlobalContainerRule);

    this.type = 'global';

    this.key = key;
    this.options = options;
    this.rules = new _jss.RuleList(_extends({}, options, {
      parent: this
    }));

    for (var selector in styles) {
      this.rules.add(selector, styles[selector], { selector: selector });
    }

    this.rules.process();
  }

  /**
   * Get a rule.
   */


  _createClass(GlobalContainerRule, [{
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Create and register rule, run plugins.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, style, options) {
      var rule = this.rules.add(name, style, options);
      this.options.jss.plugins.onProcessRule(rule);
      return rule;
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString() {
      return this.rules.toString();
    }
  }]);

  return GlobalContainerRule;
}();

var GlobalPrefixedRule = function () {
  function GlobalPrefixedRule(name, style, options) {
    _classCallCheck(this, GlobalPrefixedRule);

    this.name = name;
    this.options = options;
    var selector = name.substr(prefixKey.length);
    this.rule = options.jss.createRule(selector, style, _extends({}, options, {
      parent: this,
      selector: selector
    }));
  }

  _createClass(GlobalPrefixedRule, [{
    key: 'toString',
    value: function toString(options) {
      return this.rule.toString(options);
    }
  }]);

  return GlobalPrefixedRule;
}();

var separatorRegExp = /\s*,\s*/g;

function addScope(selector, scope) {
  var parts = selector.split(separatorRegExp);
  var scoped = '';
  for (var i = 0; i < parts.length; i++) {
    scoped += scope + ' ' + parts[i].trim();
    if (parts[i + 1]) scoped += ', ';
  }
  return scoped;
}

function handleNestedGlobalContainerRule(rule) {
  var options = rule.options,
      style = rule.style;

  var rules = style[propKey];

  if (!rules) return;

  for (var name in rules) {
    options.sheet.addRule(name, rules[name], _extends({}, options, {
      selector: addScope(name, rule.selector)
    }));
  }

  delete style[propKey];
}

function handlePrefixedGlobalRule(rule) {
  var options = rule.options,
      style = rule.style;

  for (var prop in style) {
    if (prop.substr(0, propKey.length) !== propKey) continue;

    var selector = addScope(prop.substr(propKey.length), rule.selector);
    options.sheet.addRule(selector, style[prop], _extends({}, options, {
      selector: selector
    }));
    delete style[prop];
  }
}

/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */
function jssGlobal() {
  function onCreateRule(name, styles, options) {
    if (name === propKey) {
      return new GlobalContainerRule(name, styles, options);
    }

    if (name[0] === '@' && name.substr(0, prefixKey.length) === prefixKey) {
      return new GlobalPrefixedRule(name, styles, options);
    }

    var parent = options.parent;


    if (parent) {
      if (parent.type === 'global' || parent.options.parent.type === 'global') {
        options.global = true;
      }
    }

    if (options.global) options.selector = name;

    return null;
  }

  function onProcessRule(rule) {
    if (rule.type !== 'style') return;

    handleNestedGlobalContainerRule(rule);
    handlePrefixedGlobalRule(rule);
  }

  return { onCreateRule: onCreateRule, onProcessRule: onProcessRule };
}

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = getDynamicStyles;
/**
 * Extracts a styles object with only props that contain function values.
 */
function getDynamicStyles(styles) {
  var to = null;

  for (var key in styles) {
    var value = styles[key];
    var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);

    if (type === 'function') {
      if (!to) to = {};
      to[key] = value;
    } else if (type === 'object' && value !== null && !Array.isArray(value)) {
      var extracted = getDynamicStyles(value);
      if (extracted) {
        if (!to) to = {};
        to[key] = extracted;
      }
    }
  }

  return to;
}

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(142);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 */
var SheetsManager = function () {
  function SheetsManager() {
    _classCallCheck(this, SheetsManager);

    this.sheets = [];
    this.refs = [];
    this.keys = [];
  }

  _createClass(SheetsManager, [{
    key: 'get',
    value: function get(key) {
      var index = this.keys.indexOf(key);
      return this.sheets[index];
    }
  }, {
    key: 'add',
    value: function add(key, sheet) {
      var sheets = this.sheets,
          refs = this.refs,
          keys = this.keys;

      var index = sheets.indexOf(sheet);

      if (index !== -1) return index;

      sheets.push(sheet);
      refs.push(0);
      keys.push(key);

      return sheets.length - 1;
    }
  }, {
    key: 'manage',
    value: function manage(key) {
      var index = this.keys.indexOf(key);
      var sheet = this.sheets[index];
      if (this.refs[index] === 0) sheet.attach();
      this.refs[index]++;
      if (!this.keys[index]) this.keys.splice(index, 0, key);
      return sheet;
    }
  }, {
    key: 'unmanage',
    value: function unmanage(key) {
      var index = this.keys.indexOf(key);
      if (index === -1) {
        // eslint-ignore-next-line no-console
        (0, _warning2['default'])(false, "SheetsManager: can't find sheet to unmanage");
        return;
      }
      if (this.refs[index] > 0) {
        this.refs[index]--;
        if (this.refs[index] === 0) this.sheets[index].detach();
      }
    }
  }, {
    key: 'size',
    get: function get() {
      return this.keys.length;
    }
  }]);

  return SheetsManager;
}();

exports['default'] = SheetsManager;

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = cloneStyle;

var _isObservable = __webpack_require__(443);

var _isObservable2 = _interopRequireDefault(_isObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var isArray = Array.isArray;
function cloneStyle(style) {
  // Support empty values in case user ends up with them by accident.
  if (style == null) return style;

  // Support string value for SimpleRule.
  var typeOfStyle = typeof style === 'undefined' ? 'undefined' : _typeof(style);

  if (typeOfStyle === 'string' || typeOfStyle === 'number' || typeOfStyle === 'function') {
    return style;
  }

  // Support array for FontFaceRule.
  if (isArray(style)) return style.map(cloneStyle);

  // Support Observable styles.  Observables are immutable, so we don't need to
  // copy them.
  if ((0, _isObservable2['default'])(style)) return style;

  var newStyle = {};
  for (var name in style) {
    var value = style[name];
    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
      newStyle[name] = cloneStyle(value);
      continue;
    }
    newStyle[name] = value;
  }

  return newStyle;
}

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CSS = global.CSS;

var env = "production";

var escapeRegex = /([[\].#*$><+~=|^:(),"'`])/g;

exports['default'] = function (str) {
  // We don't need to escape it in production, because we are not using user's
  // input for selectors, we are generating a valid selector.
  if (env === 'production') return str;

  if (!CSS || !CSS.escape) {
    return str.replace(escapeRegex, '\\$1');
  }

  return CSS.escape(str);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(72)))

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (global[ns] == null) global[ns] = 0;

// Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.
exports['default'] = global[ns]++;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(72)))

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _isInBrowser = __webpack_require__(218);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _StyleSheet = __webpack_require__(446);

var _StyleSheet2 = _interopRequireDefault(_StyleSheet);

var _PluginsRegistry = __webpack_require__(767);

var _PluginsRegistry2 = _interopRequireDefault(_PluginsRegistry);

var _rules = __webpack_require__(768);

var _rules2 = _interopRequireDefault(_rules);

var _observables = __webpack_require__(774);

var _observables2 = _interopRequireDefault(_observables);

var _functions = __webpack_require__(775);

var _functions2 = _interopRequireDefault(_functions);

var _sheets = __webpack_require__(292);

var _sheets2 = _interopRequireDefault(_sheets);

var _StyleRule = __webpack_require__(143);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _createGenerateClassName = __webpack_require__(445);

var _createGenerateClassName2 = _interopRequireDefault(_createGenerateClassName);

var _createRule2 = __webpack_require__(217);

var _createRule3 = _interopRequireDefault(_createRule2);

var _DomRenderer = __webpack_require__(776);

var _DomRenderer2 = _interopRequireDefault(_DomRenderer);

var _VirtualRenderer = __webpack_require__(777);

var _VirtualRenderer2 = _interopRequireDefault(_VirtualRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var defaultPlugins = _rules2['default'].concat([_observables2['default'], _functions2['default']]);

var instanceCounter = 0;

var Jss = function () {
  function Jss(options) {
    _classCallCheck(this, Jss);

    this.id = instanceCounter++;
    this.version = "9.8.7";
    this.plugins = new _PluginsRegistry2['default']();
    this.options = {
      createGenerateClassName: _createGenerateClassName2['default'],
      Renderer: _isInBrowser2['default'] ? _DomRenderer2['default'] : _VirtualRenderer2['default'],
      plugins: []
    };
    this.generateClassName = (0, _createGenerateClassName2['default'])();

    // eslint-disable-next-line prefer-spread
    this.use.apply(this, defaultPlugins);
    this.setup(options);
  }

  _createClass(Jss, [{
    key: 'setup',
    value: function setup() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (options.createGenerateClassName) {
        this.options.createGenerateClassName = options.createGenerateClassName;
        // $FlowFixMe
        this.generateClassName = options.createGenerateClassName();
      }

      if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
      if (options.virtual || options.Renderer) {
        this.options.Renderer = options.Renderer || (options.virtual ? _VirtualRenderer2['default'] : _DomRenderer2['default']);
      }

      // eslint-disable-next-line prefer-spread
      if (options.plugins) this.use.apply(this, options.plugins);

      return this;
    }

    /**
     * Create a Style Sheet.
     */

  }, {
    key: 'createStyleSheet',
    value: function createStyleSheet(styles) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var index = options.index;
      if (typeof index !== 'number') {
        index = _sheets2['default'].index === 0 ? 0 : _sheets2['default'].index + 1;
      }
      var sheet = new _StyleSheet2['default'](styles, _extends({}, options, {
        jss: this,
        generateClassName: options.generateClassName || this.generateClassName,
        insertionPoint: this.options.insertionPoint,
        Renderer: this.options.Renderer,
        index: index
      }));
      this.plugins.onProcessSheet(sheet);

      return sheet;
    }

    /**
     * Detach the Style Sheet and remove it from the registry.
     */

  }, {
    key: 'removeStyleSheet',
    value: function removeStyleSheet(sheet) {
      sheet.detach();
      _sheets2['default'].remove(sheet);
      return this;
    }

    /**
     * Create a rule without a Style Sheet.
     */

  }, {
    key: 'createRule',
    value: function createRule(name) {
      var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      // Enable rule without name for inline styles.
      if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
        options = style;
        style = name;
        name = undefined;
      }

      // Cast from RuleFactoryOptions to RuleOptions
      // https://stackoverflow.com/questions/41328728/force-casting-in-flow
      var ruleOptions = options;

      ruleOptions.jss = this;
      ruleOptions.Renderer = this.options.Renderer;
      if (!ruleOptions.generateClassName) ruleOptions.generateClassName = this.generateClassName;
      if (!ruleOptions.classes) ruleOptions.classes = {};
      var rule = (0, _createRule3['default'])(name, style, ruleOptions);

      if (!ruleOptions.selector && rule instanceof _StyleRule2['default']) {
        rule.selector = '.' + ruleOptions.generateClassName(rule);
      }

      this.plugins.onProcessRule(rule);

      return rule;
    }

    /**
     * Register plugin. Passed function will be invoked with a rule instance.
     */

  }, {
    key: 'use',
    value: function use() {
      var _this = this;

      for (var _len = arguments.length, plugins = Array(_len), _key = 0; _key < _len; _key++) {
        plugins[_key] = arguments[_key];
      }

      plugins.forEach(function (plugin) {
        // Avoids applying same plugin twice, at least based on ref.
        if (_this.options.plugins.indexOf(plugin) === -1) {
          _this.options.plugins.push(plugin);
          _this.plugins.use(plugin);
        }
      });

      return this;
    }
  }]);

  return Jss;
}();

exports['default'] = Jss;

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(142);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PluginsRegistry = function () {
  function PluginsRegistry() {
    _classCallCheck(this, PluginsRegistry);

    this.hooks = {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []

      /**
       * Call `onCreateRule` hooks and return an object if returned by a hook.
       */
    };
  }

  _createClass(PluginsRegistry, [{
    key: 'onCreateRule',
    value: function onCreateRule(name, decl, options) {
      for (var i = 0; i < this.hooks.onCreateRule.length; i++) {
        var rule = this.hooks.onCreateRule[i](name, decl, options);
        if (rule) return rule;
      }
      return null;
    }

    /**
     * Call `onProcessRule` hooks.
     */

  }, {
    key: 'onProcessRule',
    value: function onProcessRule(rule) {
      if (rule.isProcessed) return;
      var sheet = rule.options.sheet;

      for (var i = 0; i < this.hooks.onProcessRule.length; i++) {
        this.hooks.onProcessRule[i](rule, sheet);
      }

      // $FlowFixMe
      if (rule.style) this.onProcessStyle(rule.style, rule, sheet);

      rule.isProcessed = true;
    }

    /**
     * Call `onProcessStyle` hooks.
     */

  }, {
    key: 'onProcessStyle',
    value: function onProcessStyle(style, rule, sheet) {
      var nextStyle = style;

      for (var i = 0; i < this.hooks.onProcessStyle.length; i++) {
        nextStyle = this.hooks.onProcessStyle[i](nextStyle, rule, sheet);
        // $FlowFixMe
        rule.style = nextStyle;
      }
    }

    /**
     * Call `onProcessSheet` hooks.
     */

  }, {
    key: 'onProcessSheet',
    value: function onProcessSheet(sheet) {
      for (var i = 0; i < this.hooks.onProcessSheet.length; i++) {
        this.hooks.onProcessSheet[i](sheet);
      }
    }

    /**
     * Call `onUpdate` hooks.
     */

  }, {
    key: 'onUpdate',
    value: function onUpdate(data, rule, sheet) {
      for (var i = 0; i < this.hooks.onUpdate.length; i++) {
        this.hooks.onUpdate[i](data, rule, sheet);
      }
    }

    /**
     * Call `onChangeValue` hooks.
     */

  }, {
    key: 'onChangeValue',
    value: function onChangeValue(value, prop, rule) {
      var processedValue = value;
      for (var i = 0; i < this.hooks.onChangeValue.length; i++) {
        processedValue = this.hooks.onChangeValue[i](processedValue, prop, rule);
      }
      return processedValue;
    }

    /**
     * Register a plugin.
     * If function is passed, it is a shortcut for `{onProcessRule}`.
     */

  }, {
    key: 'use',
    value: function use(plugin) {
      for (var name in plugin) {
        if (this.hooks[name]) this.hooks[name].push(plugin[name]);else (0, _warning2['default'])(false, '[JSS] Unknown hook "%s".', name);
      }
    }
  }]);

  return PluginsRegistry;
}();

exports['default'] = PluginsRegistry;

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SimpleRule = __webpack_require__(769);

var _SimpleRule2 = _interopRequireDefault(_SimpleRule);

var _KeyframesRule = __webpack_require__(770);

var _KeyframesRule2 = _interopRequireDefault(_KeyframesRule);

var _ConditionalRule = __webpack_require__(771);

var _ConditionalRule2 = _interopRequireDefault(_ConditionalRule);

var _FontFaceRule = __webpack_require__(772);

var _FontFaceRule2 = _interopRequireDefault(_FontFaceRule);

var _ViewportRule = __webpack_require__(773);

var _ViewportRule2 = _interopRequireDefault(_ViewportRule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var classes = {
  '@charset': _SimpleRule2['default'],
  '@import': _SimpleRule2['default'],
  '@namespace': _SimpleRule2['default'],
  '@keyframes': _KeyframesRule2['default'],
  '@media': _ConditionalRule2['default'],
  '@supports': _ConditionalRule2['default'],
  '@font-face': _FontFaceRule2['default'],
  '@viewport': _ViewportRule2['default'],
  '@-ms-viewport': _ViewportRule2['default']

  /**
   * Generate plugins which will register all rules.
   */
};
var plugins = Object.keys(classes).map(function (key) {
  // https://jsperf.com/indexof-vs-substr-vs-regex-at-the-beginning-3
  var re = new RegExp('^' + key);
  var RuleClass = classes[key];
  var onCreateRule = function onCreateRule(name, decl, options) {
    return re.test(name) ? new RuleClass(name, decl, options) : null;
  };
  return { onCreateRule: onCreateRule };
});

exports['default'] = plugins;

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SimpleRule = function () {
  function SimpleRule(key, value, options) {
    _classCallCheck(this, SimpleRule);

    this.type = 'simple';
    this.isProcessed = false;

    this.key = key;
    this.value = value;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */
  // eslint-disable-next-line no-unused-vars


  _createClass(SimpleRule, [{
    key: 'toString',
    value: function toString(options) {
      if (Array.isArray(this.value)) {
        var str = '';
        for (var index = 0; index < this.value.length; index++) {
          str += this.key + ' ' + this.value[index] + ';';
          if (this.value[index + 1]) str += '\n';
        }
        return str;
      }

      return this.key + ' ' + this.value + ';';
    }
  }]);

  return SimpleRule;
}();

exports['default'] = SimpleRule;

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RuleList = __webpack_require__(174);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Rule for @keyframes
 */
var KeyframesRule = function () {
  function KeyframesRule(key, frames, options) {
    _classCallCheck(this, KeyframesRule);

    this.type = 'keyframes';
    this.isProcessed = false;

    this.key = key;
    this.options = options;
    this.rules = new _RuleList2['default'](_extends({}, options, { parent: this }));

    for (var name in frames) {
      this.rules.add(name, frames[name], _extends({}, this.options, {
        parent: this,
        selector: name
      }));
    }

    this.rules.process();
  }

  /**
   * Generates a CSS string.
   */


  _createClass(KeyframesRule, [{
    key: 'toString',
    value: function toString() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { indent: 1 };

      var inner = this.rules.toString(options);
      if (inner) inner += '\n';
      return this.key + ' {\n' + inner + '}';
    }
  }]);

  return KeyframesRule;
}();

exports['default'] = KeyframesRule;

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RuleList = __webpack_require__(174);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Conditional rule for @media, @supports
 */
var ConditionalRule = function () {
  function ConditionalRule(key, styles, options) {
    _classCallCheck(this, ConditionalRule);

    this.type = 'conditional';
    this.isProcessed = false;

    this.key = key;
    this.options = options;
    this.rules = new _RuleList2['default'](_extends({}, options, { parent: this }));

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }

  /**
   * Get a rule.
   */


  _createClass(ConditionalRule, [{
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Create and register rule, run plugins.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, style, options) {
      var rule = this.rules.add(name, style, options);
      this.options.jss.plugins.onProcessRule(rule);
      return rule;
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { indent: 1 };

      var inner = this.rules.toString(options);
      return inner ? this.key + ' {\n' + inner + '\n}' : '';
    }
  }]);

  return ConditionalRule;
}();

exports['default'] = ConditionalRule;

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _toCss = __webpack_require__(291);

var _toCss2 = _interopRequireDefault(_toCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FontFaceRule = function () {
  function FontFaceRule(key, style, options) {
    _classCallCheck(this, FontFaceRule);

    this.type = 'font-face';
    this.isProcessed = false;

    this.key = key;
    this.style = style;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */


  _createClass(FontFaceRule, [{
    key: 'toString',
    value: function toString(options) {
      if (Array.isArray(this.style)) {
        var str = '';
        for (var index = 0; index < this.style.length; index++) {
          str += (0, _toCss2['default'])(this.key, this.style[index]);
          if (this.style[index + 1]) str += '\n';
        }
        return str;
      }

      return (0, _toCss2['default'])(this.key, this.style, options);
    }
  }]);

  return FontFaceRule;
}();

exports['default'] = FontFaceRule;

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _toCss = __webpack_require__(291);

var _toCss2 = _interopRequireDefault(_toCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ViewportRule = function () {
  function ViewportRule(key, style, options) {
    _classCallCheck(this, ViewportRule);

    this.type = 'viewport';
    this.isProcessed = false;

    this.key = key;
    this.style = style;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */


  _createClass(ViewportRule, [{
    key: 'toString',
    value: function toString(options) {
      return (0, _toCss2['default'])(this.key, this.style, options);
    }
  }]);

  return ViewportRule;
}();

exports['default'] = ViewportRule;

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _StyleRule = __webpack_require__(143);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _createRule = __webpack_require__(217);

var _createRule2 = _interopRequireDefault(_createRule);

var _isObservable = __webpack_require__(443);

var _isObservable2 = _interopRequireDefault(_isObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  onCreateRule: function onCreateRule(name, decl, options) {
    if (!(0, _isObservable2['default'])(decl)) return null;

    // Cast `decl` to `Observable`, since it passed the type guard.
    var style$ = decl;

    var rule = (0, _createRule2['default'])(name, {}, options);

    // TODO
    // Call `stream.subscribe()` returns a subscription, which should be explicitly
    // unsubscribed from when we know this sheet is no longer needed.
    style$.subscribe(function (style) {
      for (var prop in style) {
        rule.prop(prop, style[prop]);
      }
    });

    return rule;
  },
  onProcessRule: function onProcessRule(rule) {
    if (!(rule instanceof _StyleRule2['default'])) return;
    var styleRule = rule;
    var style = styleRule.style;

    var _loop = function _loop(prop) {
      var value = style[prop];
      if (!(0, _isObservable2['default'])(value)) return 'continue';
      delete style[prop];
      value.subscribe({
        next: function next(nextValue) {
          styleRule.prop(prop, nextValue);
        }
      });
    };

    for (var prop in style) {
      var _ret = _loop(prop);

      if (_ret === 'continue') continue;
    }
  }
};

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RuleList = __webpack_require__(174);

var _RuleList2 = _interopRequireDefault(_RuleList);

var _StyleRule = __webpack_require__(143);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _createRule = __webpack_require__(217);

var _createRule2 = _interopRequireDefault(_createRule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// A symbol replacement.
var now = Date.now();

var fnValuesNs = 'fnValues' + now;
var fnStyleNs = 'fnStyle' + ++now;

exports['default'] = {
  onCreateRule: function onCreateRule(name, decl, options) {
    if (typeof decl !== 'function') return null;
    var rule = (0, _createRule2['default'])(name, {}, options);
    rule[fnStyleNs] = decl;
    return rule;
  },
  onProcessStyle: function onProcessStyle(style, rule) {
    var fn = {};
    for (var prop in style) {
      var value = style[prop];
      if (typeof value !== 'function') continue;
      delete style[prop];
      fn[prop] = value;
    }
    rule = rule;
    rule[fnValuesNs] = fn;
    return style;
  },
  onUpdate: function onUpdate(data, rule) {
    // It is a rules container like for e.g. ConditionalRule.
    if (rule.rules instanceof _RuleList2['default']) {
      rule.rules.update(data);
      return;
    }
    if (!(rule instanceof _StyleRule2['default'])) return;

    rule = rule;

    // If we have a fn values map, it is a rule with function values.
    if (rule[fnValuesNs]) {
      for (var prop in rule[fnValuesNs]) {
        rule.prop(prop, rule[fnValuesNs][prop](data));
      }
    }

    rule = rule;

    var fnStyle = rule[fnStyleNs];

    // If we have a style function, the entire rule is dynamic and style object
    // will be returned from that function.
    if (fnStyle) {
      var style = fnStyle(data);
      for (var _prop in style) {
        rule.prop(_prop, style[_prop]);
      }
    }
  }
};

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(142);

var _warning2 = _interopRequireDefault(_warning);

var _sheets = __webpack_require__(292);

var _sheets2 = _interopRequireDefault(_sheets);

var _StyleRule = __webpack_require__(143);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _toCssValue = __webpack_require__(216);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Cache the value from the first time a function is called.
 */
var memoize = function memoize(fn) {
  var value = void 0;
  return function () {
    if (!value) value = fn();
    return value;
  };
};

/**
 * Get a style property value.
 */
function getPropertyValue(cssRule, prop) {
  try {
    return cssRule.style.getPropertyValue(prop);
  } catch (err) {
    // IE may throw if property is unknown.
    return '';
  }
}

/**
 * Set a style property.
 */
function setProperty(cssRule, prop, value) {
  try {
    var cssValue = value;

    if (Array.isArray(value)) {
      cssValue = (0, _toCssValue2['default'])(value, true);

      if (value[value.length - 1] === '!important') {
        cssRule.style.setProperty(prop, cssValue, 'important');
        return true;
      }
    }

    cssRule.style.setProperty(prop, cssValue);
  } catch (err) {
    // IE may throw if property is unknown.
    return false;
  }
  return true;
}

/**
 * Remove a style property.
 */
function removeProperty(cssRule, prop) {
  try {
    cssRule.style.removeProperty(prop);
  } catch (err) {
    (0, _warning2['default'])(false, '[JSS] DOMException "%s" was thrown. Tried to remove property "%s".', err.message, prop);
  }
}

var CSSRuleTypes = {
  STYLE_RULE: 1,
  KEYFRAMES_RULE: 7

  /**
   * Get the CSS Rule key.
   */

};var getKey = function () {
  var extractKey = function extractKey(cssText) {
    var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return cssText.substr(from, cssText.indexOf('{') - 1);
  };

  return function (cssRule) {
    if (cssRule.type === CSSRuleTypes.STYLE_RULE) return cssRule.selectorText;
    if (cssRule.type === CSSRuleTypes.KEYFRAMES_RULE) {
      var name = cssRule.name;

      if (name) return '@keyframes ' + name;

      // There is no rule.name in the following browsers:
      // - IE 9
      // - Safari 7.1.8
      // - Mobile Safari 9.0.0
      var cssText = cssRule.cssText;

      return '@' + extractKey(cssText, cssText.indexOf('keyframes'));
    }

    // Conditionals.
    return extractKey(cssRule.cssText);
  };
}();

/**
 * Set the selector.
 */
function setSelector(cssRule, selectorText) {
  cssRule.selectorText = selectorText;

  // Return false if setter was not successful.
  // Currently works in chrome only.
  return cssRule.selectorText === selectorText;
}

/**
 * Gets the `head` element upon the first call and caches it.
 */
var getHead = memoize(function () {
  return document.head || document.getElementsByTagName('head')[0];
});

/**
 * Gets a map of rule keys, where the property is an unescaped key and value
 * is a potentially escaped one.
 * It is used to identify CSS rules and the corresponding JSS rules. As an identifier
 * for CSSStyleRule we normally use `selectorText`. Though if original selector text
 * contains escaped code points e.g. `:not(#\\20)`, CSSOM will compile it to `:not(# )`
 * and so CSS rule's `selectorText` won't match JSS rule selector.
 *
 * https://www.w3.org/International/questions/qa-escapes#cssescapes
 */
var getUnescapedKeysMap = function () {
  var style = void 0;
  var isAttached = false;

  return function (rules) {
    var map = {};
    // https://github.com/facebook/flow/issues/2696
    if (!style) style = document.createElement('style');
    for (var i = 0; i < rules.length; i++) {
      var rule = rules[i];
      if (!(rule instanceof _StyleRule2['default'])) continue;
      var selector = rule.selector;
      // Only unescape selector over CSSOM if it contains a back slash.

      if (selector && selector.indexOf('\\') !== -1) {
        // Lazilly attach when needed.
        if (!isAttached) {
          getHead().appendChild(style);
          isAttached = true;
        }
        style.textContent = selector + ' {}';
        var _style = style,
            sheet = _style.sheet;

        if (sheet) {
          var cssRules = sheet.cssRules;

          if (cssRules) map[cssRules[0].selectorText] = rule.key;
        }
      }
    }
    if (isAttached) {
      getHead().removeChild(style);
      isAttached = false;
    }
    return map;
  };
}();

/**
 * Find attached sheet with an index higher than the passed one.
 */
function findHigherSheet(registry, options) {
  for (var i = 0; i < registry.length; i++) {
    var sheet = registry[i];
    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }
  return null;
}

/**
 * Find attached sheet with the highest index.
 */
function findHighestSheet(registry, options) {
  for (var i = registry.length - 1; i >= 0; i--) {
    var sheet = registry[i];
    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }
  return null;
}

/**
 * Find a comment with "jss" inside.
 */
function findCommentNode(text) {
  var head = getHead();
  for (var i = 0; i < head.childNodes.length; i++) {
    var node = head.childNodes[i];
    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
      return node;
    }
  }
  return null;
}

/**
 * Find a node before which we can insert the sheet.
 */
function findPrevNode(options) {
  var registry = _sheets2['default'].registry;


  if (registry.length > 0) {
    // Try to insert before the next higher sheet.
    var sheet = findHigherSheet(registry, options);
    if (sheet) return sheet.renderer.element;

    // Otherwise insert after the last attached.
    sheet = findHighestSheet(registry, options);
    if (sheet) return sheet.renderer.element.nextElementSibling;
  }

  // Try to find a comment placeholder if registry is empty.
  var insertionPoint = options.insertionPoint;

  if (insertionPoint && typeof insertionPoint === 'string') {
    var comment = findCommentNode(insertionPoint);
    if (comment) return comment.nextSibling;
    // If user specifies an insertion point and it can't be found in the document -
    // bad specificity issues may appear.
    (0, _warning2['default'])(insertionPoint === 'jss', '[JSS] Insertion point "%s" not found.', insertionPoint);
  }

  return null;
}

/**
 * Insert style element into the DOM.
 */
function insertStyle(style, options) {
  var insertionPoint = options.insertionPoint;

  var prevNode = findPrevNode(options);

  if (prevNode) {
    var parentNode = prevNode.parentNode;

    if (parentNode) parentNode.insertBefore(style, prevNode);
    return;
  }

  // Works with iframes and any node types.
  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
    // https://stackoverflow.com/questions/41328728/force-casting-in-flow
    var insertionPointElement = insertionPoint;
    var _parentNode = insertionPointElement.parentNode;

    if (_parentNode) _parentNode.insertBefore(style, insertionPointElement.nextSibling);else (0, _warning2['default'])(false, '[JSS] Insertion point is not in the DOM.');
    return;
  }

  getHead().insertBefore(style, prevNode);
}

/**
 * Read jss nonce setting from the page if the user has set it.
 */
var getNonce = memoize(function () {
  var node = document.querySelector('meta[property="csp-nonce"]');
  return node ? node.getAttribute('content') : null;
});

var DomRenderer = function () {
  function DomRenderer(sheet) {
    _classCallCheck(this, DomRenderer);

    this.getPropertyValue = getPropertyValue;
    this.setProperty = setProperty;
    this.removeProperty = removeProperty;
    this.setSelector = setSelector;
    this.getKey = getKey;
    this.getUnescapedKeysMap = getUnescapedKeysMap;
    this.hasInsertedRules = false;

    // There is no sheet when the renderer is used from a standalone StyleRule.
    if (sheet) _sheets2['default'].add(sheet);

    this.sheet = sheet;

    var _ref = this.sheet ? this.sheet.options : {},
        media = _ref.media,
        meta = _ref.meta,
        element = _ref.element;

    this.element = element || document.createElement('style');
    this.element.setAttribute('data-jss', '');
    if (media) this.element.setAttribute('media', media);
    if (meta) this.element.setAttribute('data-meta', meta);
    var nonce = getNonce();
    if (nonce) this.element.setAttribute('nonce', nonce);
  }

  /**
   * Insert style element into render tree.
   */


  // HTMLStyleElement needs fixing https://github.com/facebook/flow/issues/2696


  _createClass(DomRenderer, [{
    key: 'attach',
    value: function attach() {
      // In the case the element node is external and it is already in the DOM.
      if (this.element.parentNode || !this.sheet) return;

      // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
      // browsers remove those rules.
      // TODO figure out if its a bug and if it is known.
      // Workaround is to redeploy the sheet before attaching as a string.
      if (this.hasInsertedRules) {
        this.deploy();
        this.hasInsertedRules = false;
      }

      insertStyle(this.element, this.sheet.options);
    }

    /**
     * Remove style element from render tree.
     */

  }, {
    key: 'detach',
    value: function detach() {
      this.element.parentNode.removeChild(this.element);
    }

    /**
     * Inject CSS string into element.
     */

  }, {
    key: 'deploy',
    value: function deploy() {
      if (!this.sheet) return;
      this.element.textContent = '\n' + this.sheet.toString() + '\n';
    }

    /**
     * Insert a rule into element.
     */

  }, {
    key: 'insertRule',
    value: function insertRule(rule, index) {
      var sheet = this.element.sheet;
      var cssRules = sheet.cssRules;

      var str = rule.toString();
      if (!index) index = cssRules.length;

      if (!str) return false;

      try {
        sheet.insertRule(str, index);
      } catch (err) {
        (0, _warning2['default'])(false, '[JSS] Can not insert an unsupported rule \n\r%s', rule);
        return false;
      }
      this.hasInsertedRules = true;

      return cssRules[index];
    }

    /**
     * Delete a rule.
     */

  }, {
    key: 'deleteRule',
    value: function deleteRule(cssRule) {
      var sheet = this.element.sheet;

      var index = this.indexOf(cssRule);
      if (index === -1) return false;
      sheet.deleteRule(index);
      return true;
    }

    /**
     * Get index of a CSS Rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(cssRule) {
      var cssRules = this.element.sheet.cssRules;

      for (var _index = 0; _index < cssRules.length; _index++) {
        if (cssRule === cssRules[_index]) return _index;
      }
      return -1;
    }

    /**
     * Generate a new CSS rule and replace the existing one.
     */

  }, {
    key: 'replaceRule',
    value: function replaceRule(cssRule, rule) {
      var index = this.indexOf(cssRule);
      var newCssRule = this.insertRule(rule, index);
      this.element.sheet.deleteRule(index);
      return newCssRule;
    }

    /**
     * Get all rules elements.
     */

  }, {
    key: 'getRules',
    value: function getRules() {
      return this.element.sheet.cssRules;
    }
  }]);

  return DomRenderer;
}();

exports['default'] = DomRenderer;

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable class-methods-use-this */

/**
 * Rendering backend to do nothing in nodejs.
 */
var VirtualRenderer = function () {
  function VirtualRenderer() {
    _classCallCheck(this, VirtualRenderer);
  }

  _createClass(VirtualRenderer, [{
    key: 'setProperty',
    value: function setProperty() {
      return true;
    }
  }, {
    key: 'getPropertyValue',
    value: function getPropertyValue() {
      return '';
    }
  }, {
    key: 'removeProperty',
    value: function removeProperty() {}
  }, {
    key: 'setSelector',
    value: function setSelector() {
      return true;
    }
  }, {
    key: 'getKey',
    value: function getKey() {
      return '';
    }
  }, {
    key: 'attach',
    value: function attach() {}
  }, {
    key: 'detach',
    value: function detach() {}
  }, {
    key: 'deploy',
    value: function deploy() {}
  }, {
    key: 'insertRule',
    value: function insertRule() {
      return false;
    }
  }, {
    key: 'deleteRule',
    value: function deleteRule() {
      return true;
    }
  }, {
    key: 'replaceRule',
    value: function replaceRule() {
      return false;
    }
  }, {
    key: 'getRules',
    value: function getRules() {}
  }, {
    key: 'indexOf',
    value: function indexOf() {
      return -1;
    }
  }]);

  return VirtualRenderer;
}();

exports['default'] = VirtualRenderer;

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = jssNested;

var _warning = __webpack_require__(779);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var separatorRegExp = /\s*,\s*/g;
var parentRegExp = /&/g;
var refRegExp = /\$([\w-]+)/g;

/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */
function jssNested() {
  // Get a function to be used for $ref replacement.
  function getReplaceRef(container) {
    return function (match, key) {
      var rule = container.getRule(key);
      if (rule) return rule.selector;
      (0, _warning2.default)(false, '[JSS] Could not find the referenced rule %s in %s.', key, container.options.meta || container);
      return key;
    };
  }

  var hasAnd = function hasAnd(str) {
    return str.indexOf('&') !== -1;
  };

  function replaceParentRefs(nestedProp, parentProp) {
    var parentSelectors = parentProp.split(separatorRegExp);
    var nestedSelectors = nestedProp.split(separatorRegExp);

    var result = '';

    for (var i = 0; i < parentSelectors.length; i++) {
      var parent = parentSelectors[i];

      for (var j = 0; j < nestedSelectors.length; j++) {
        var nested = nestedSelectors[j];
        if (result) result += ', ';
        // Replace all & by the parent or prefix & with the parent.
        result += hasAnd(nested) ? nested.replace(parentRegExp, parent) : parent + ' ' + nested;
      }
    }

    return result;
  }

  function getOptions(rule, container, options) {
    // Options has been already created, now we only increase index.
    if (options) return _extends({}, options, { index: options.index + 1 });

    var nestingLevel = rule.options.nestingLevel;

    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;

    return _extends({}, rule.options, {
      nestingLevel: nestingLevel,
      index: container.indexOf(rule) + 1
    });
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;
    var container = rule.options.parent;
    var options = void 0;
    var replaceRef = void 0;
    for (var prop in style) {
      var isNested = hasAnd(prop);
      var isNestedConditional = prop[0] === '@';

      if (!isNested && !isNestedConditional) continue;

      options = getOptions(rule, container, options);

      if (isNested) {
        var selector = replaceParentRefs(prop, rule.selector
        // Lazily create the ref replacer function just once for
        // all nested rules within the sheet.
        );if (!replaceRef) replaceRef = getReplaceRef(container
        // Replace all $refs.
        );selector = selector.replace(refRegExp, replaceRef);

        container.addRule(selector, style[prop], _extends({}, options, { selector: selector }));
      } else if (isNestedConditional) {
        container
        // Place conditional right after the parent rule to ensure right ordering.
        .addRule(prop, null, options).addRule(rule.key, style[prop], { selector: rule.selector });
      }

      delete style[prop];
    }

    return style;
  }

  return { onProcessStyle: onProcessStyle };
}

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = camelCase;

var _hyphenateStyleName = __webpack_require__(781);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Convert camel cased property names to dash separated.
 *
 * @param {Object} style
 * @return {Object}
 */
function convertCase(style) {
  var converted = {};

  for (var prop in style) {
    converted[(0, _hyphenateStyleName2['default'])(prop)] = style[prop];
  }

  if (style.fallbacks) {
    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
  }

  return converted;
}

/**
 * Allow camel cased property names by converting them back to dasherized.
 *
 * @param {Rule} rule
 */
function camelCase() {
  function onProcessStyle(style) {
    if (Array.isArray(style)) {
      // Handle rules like @font-face, which can have multiple styles in an array
      for (var index = 0; index < style.length; index++) {
        style[index] = convertCase(style[index]);
      }
      return style;
    }

    return convertCase(style);
  }

  function onChangeValue(value, prop, rule) {
    var hyphenatedProp = (0, _hyphenateStyleName2['default'])(prop);

    // There was no camel case in place
    if (prop === hyphenatedProp) return value;

    rule.prop(hyphenatedProp, value);

    // Core will ignore that property value we set the proper one above.
    return null;
  }

  return { onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g
var msPattern = /^ms-/
var cache = {}

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache.hasOwnProperty(name)) {
    return cache[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower)
  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
}

/* harmony default export */ __webpack_exports__["default"] = (hyphenateStyleName);


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = defaultUnit;

var _defaultUnits = __webpack_require__(783);

var _defaultUnits2 = _interopRequireDefault(_defaultUnits);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Clones the object and adds a camel cased property version.
 */
function addCamelCasedVersion(obj) {
  var regExp = /(-[a-z])/g;
  var replace = function replace(str) {
    return str[1].toUpperCase();
  };
  var newObj = {};
  for (var key in obj) {
    newObj[key] = obj[key];
    newObj[key.replace(regExp, replace)] = obj[key];
  }
  return newObj;
}

var units = addCamelCasedVersion(_defaultUnits2['default']);

/**
 * Recursive deep style passing function
 *
 * @param {String} current property
 * @param {(Object|Array|Number|String)} property value
 * @param {Object} options
 * @return {(Object|Array|Number|String)} resulting value
 */
function iterate(prop, value, options) {
  if (!value) return value;

  var convertedValue = value;

  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  if (type === 'object' && Array.isArray(value)) type = 'array';

  switch (type) {
    case 'object':
      if (prop === 'fallbacks') {
        for (var innerProp in value) {
          value[innerProp] = iterate(innerProp, value[innerProp], options);
        }
        break;
      }
      for (var _innerProp in value) {
        value[_innerProp] = iterate(prop + '-' + _innerProp, value[_innerProp], options);
      }
      break;
    case 'array':
      for (var i = 0; i < value.length; i++) {
        value[i] = iterate(prop, value[i], options);
      }
      break;
    case 'number':
      if (value !== 0) {
        convertedValue = value + (options[prop] || units[prop] || '');
      }
      break;
    default:
      break;
  }

  return convertedValue;
}

/**
 * Add unit to numeric values.
 */
function defaultUnit() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var camelCasedOptions = addCamelCasedVersion(options);

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      style[prop] = iterate(prop, style[prop], camelCasedOptions);
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return iterate(prop, value, camelCasedOptions);
  }

  return { onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Generated jss-default-unit CSS property units
 *
 * @type object
 */
exports['default'] = {
  'animation-delay': 'ms',
  'animation-duration': 'ms',
  'background-position': 'px',
  'background-position-x': 'px',
  'background-position-y': 'px',
  'background-size': 'px',
  border: 'px',
  'border-bottom': 'px',
  'border-bottom-left-radius': 'px',
  'border-bottom-right-radius': 'px',
  'border-bottom-width': 'px',
  'border-left': 'px',
  'border-left-width': 'px',
  'border-radius': 'px',
  'border-right': 'px',
  'border-right-width': 'px',
  'border-spacing': 'px',
  'border-top': 'px',
  'border-top-left-radius': 'px',
  'border-top-right-radius': 'px',
  'border-top-width': 'px',
  'border-width': 'px',
  'border-after-width': 'px',
  'border-before-width': 'px',
  'border-end-width': 'px',
  'border-horizontal-spacing': 'px',
  'border-start-width': 'px',
  'border-vertical-spacing': 'px',
  bottom: 'px',
  'box-shadow': 'px',
  'column-gap': 'px',
  'column-rule': 'px',
  'column-rule-width': 'px',
  'column-width': 'px',
  'flex-basis': 'px',
  'font-size': 'px',
  'font-size-delta': 'px',
  height: 'px',
  left: 'px',
  'letter-spacing': 'px',
  'logical-height': 'px',
  'logical-width': 'px',
  margin: 'px',
  'margin-after': 'px',
  'margin-before': 'px',
  'margin-bottom': 'px',
  'margin-left': 'px',
  'margin-right': 'px',
  'margin-top': 'px',
  'max-height': 'px',
  'max-width': 'px',
  'margin-end': 'px',
  'margin-start': 'px',
  'mask-position-x': 'px',
  'mask-position-y': 'px',
  'mask-size': 'px',
  'max-logical-height': 'px',
  'max-logical-width': 'px',
  'min-height': 'px',
  'min-width': 'px',
  'min-logical-height': 'px',
  'min-logical-width': 'px',
  motion: 'px',
  'motion-offset': 'px',
  outline: 'px',
  'outline-offset': 'px',
  'outline-width': 'px',
  padding: 'px',
  'padding-bottom': 'px',
  'padding-left': 'px',
  'padding-right': 'px',
  'padding-top': 'px',
  'padding-after': 'px',
  'padding-before': 'px',
  'padding-end': 'px',
  'padding-start': 'px',
  'perspective-origin-x': '%',
  'perspective-origin-y': '%',
  perspective: 'px',
  right: 'px',
  'shape-margin': 'px',
  size: 'px',
  'text-indent': 'px',
  'text-stroke': 'px',
  'text-stroke-width': 'px',
  top: 'px',
  'transform-origin': '%',
  'transform-origin-x': '%',
  'transform-origin-y': '%',
  'transform-origin-z': '%',
  'transition-delay': 'ms',
  'transition-duration': 'ms',
  'vertical-align': 'px',
  width: 'px',
  'word-spacing': 'px',
  // Not existing properties.
  // Used to avoid issues with jss-expand intergration.
  'box-shadow-x': 'px',
  'box-shadow-y': 'px',
  'box-shadow-blur': 'px',
  'box-shadow-spread': 'px',
  'font-line-height': 'px',
  'text-shadow-x': 'px',
  'text-shadow-y': 'px',
  'text-shadow-blur': 'px'
};

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = jssVendorPrefixer;

var _cssVendor = __webpack_require__(785);

var vendor = _interopRequireWildcard(_cssVendor);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/**
 * Add vendor prefix to a property name when needed.
 *
 * @param {Rule} rule
 * @api public
 */
function jssVendorPrefixer() {
  function onProcessRule(rule) {
    if (rule.type === 'keyframes') {
      rule.key = '@' + vendor.prefix.css + rule.key.substr(1);
    }
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      var value = style[prop];

      var changeProp = false;
      var supportedProp = vendor.supportedProperty(prop);
      if (supportedProp && supportedProp !== prop) changeProp = true;

      var changeValue = false;
      var supportedValue = vendor.supportedValue(supportedProp, value);
      if (supportedValue && supportedValue !== value) changeValue = true;

      if (changeProp || changeValue) {
        if (changeProp) delete style[prop];
        style[supportedProp || prop] = supportedValue || value;
      }
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return vendor.supportedValue(prop, value);
  }

  return { onProcessRule: onProcessRule, onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.supportedValue = exports.supportedProperty = exports.prefix = undefined;

var _prefix = __webpack_require__(293);

var _prefix2 = _interopRequireDefault(_prefix);

var _supportedProperty = __webpack_require__(786);

var _supportedProperty2 = _interopRequireDefault(_supportedProperty);

var _supportedValue = __webpack_require__(788);

var _supportedValue2 = _interopRequireDefault(_supportedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  prefix: _prefix2['default'],
  supportedProperty: _supportedProperty2['default'],
  supportedValue: _supportedValue2['default']
}; /**
    * CSS Vendor prefix detection and property feature testing.
    *
    * @copyright Oleg Slobodskoi 2015
    * @website https://github.com/jsstyles/css-vendor
    * @license MIT
    */

exports.prefix = _prefix2['default'];
exports.supportedProperty = _supportedProperty2['default'];
exports.supportedValue = _supportedValue2['default'];

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = supportedProperty;

var _isInBrowser = __webpack_require__(218);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _prefix = __webpack_require__(293);

var _prefix2 = _interopRequireDefault(_prefix);

var _camelize = __webpack_require__(787);

var _camelize2 = _interopRequireDefault(_camelize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var el = void 0;
var cache = {};

if (_isInBrowser2['default']) {
  el = document.createElement('p');

  /**
   * We test every property on vendor prefix requirement.
   * Once tested, result is cached. It gives us up to 70% perf boost.
   * http://jsperf.com/element-style-object-access-vs-plain-object
   *
   * Prefill cache with known css properties to reduce amount of
   * properties we need to feature test at runtime.
   * http://davidwalsh.name/vendor-prefix
   */
  var computed = window.getComputedStyle(document.documentElement, '');
  for (var key in computed) {
    if (!isNaN(key)) cache[computed[key]] = computed[key];
  }
}

/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @return {String|Boolean}
 * @api public
 */
function supportedProperty(prop) {
  // For server-side rendering.
  if (!el) return prop;

  // We have not tested this prop yet, lets do the test.
  if (cache[prop] != null) return cache[prop];

  // Camelization is required because we can't test using
  // css syntax for e.g. in FF.
  // Test if property is supported as it is.
  if ((0, _camelize2['default'])(prop) in el.style) {
    cache[prop] = prop;
  }
  // Test if property is supported with vendor prefix.
  else if (_prefix2['default'].js + (0, _camelize2['default'])('-' + prop) in el.style) {
      cache[prop] = _prefix2['default'].css + prop;
    } else {
      cache[prop] = false;
    }

  return cache[prop];
}

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = camelize;
var regExp = /[-\s]+(.)?/g;

/**
 * Convert dash separated strings to camel cased.
 *
 * @param {String} str
 * @return {String}
 */
function camelize(str) {
  return str.replace(regExp, toUpper);
}

function toUpper(match, c) {
  return c ? c.toUpperCase() : '';
}

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = supportedValue;

var _isInBrowser = __webpack_require__(218);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _prefix = __webpack_require__(293);

var _prefix2 = _interopRequireDefault(_prefix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var cache = {};
var el = void 0;

if (_isInBrowser2['default']) el = document.createElement('p');

/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */
function supportedValue(property, value) {
  // For server-side rendering.
  if (!el) return value;

  // It is a string or a number as a string like '1'.
  // We want only prefixable values here.
  if (typeof value !== 'string' || !isNaN(parseInt(value, 10))) return value;

  var cacheKey = property + value;

  if (cache[cacheKey] != null) return cache[cacheKey];

  // IE can even throw an error in some cases, for e.g. style.content = 'bar'
  try {
    // Test value as it is.
    el.style[property] = value;
  } catch (err) {
    cache[cacheKey] = false;
    return false;
  }

  // Value is supported as it is.
  if (el.style[property] !== '') {
    cache[cacheKey] = value;
  } else {
    // Test value with vendor prefix.
    value = _prefix2['default'].css + value;

    // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
    if (value === '-ms-flex') value = '-ms-flexbox';

    el.style[property] = value;

    // Value is supported with vendor prefix.
    if (el.style[property] !== '') cache[cacheKey] = value;
  }

  if (!cache[cacheKey]) cache[cacheKey] = false;

  // Reset style value.
  el.style[property] = '';

  return cache[cacheKey];
}

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = jssPropsSort;
/**
 * Sort props by length.
 */
function jssPropsSort() {
  function sort(prop0, prop1) {
    return prop0.length - prop1.length;
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    var newStyle = {};
    var props = Object.keys(style).sort(sort);
    for (var prop in props) {
      newStyle[props[prop]] = style[props[prop]];
    }
    return newStyle;
  }

  return { onProcessStyle: onProcessStyle };
}

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(144);

var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _warning = _interopRequireDefault(__webpack_require__(37));

var _brcast = _interopRequireDefault(__webpack_require__(792));

var _themeListener = _interopRequireWildcard(__webpack_require__(295));

var _exactProp = _interopRequireDefault(__webpack_require__(115));

/**
 * This component takes a `theme` property.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */
var MuiThemeProvider =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(MuiThemeProvider, _React$Component);

  // We are not using the React state in order to avoid unnecessary rerender.
  function MuiThemeProvider(props, context) {
    var _this;

    (0, _classCallCheck2.default)(this, MuiThemeProvider);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(MuiThemeProvider).call(this)); // Get the outer theme from the context, can be null

    _this.broadcast = (0, _brcast.default)();
    _this.unsubscribeId = null;
    _this.outerTheme = null;
    _this.outerTheme = _themeListener.default.initial(context); // Propagate the theme so it can be accessed by the children

    _this.broadcast.setState(_this.mergeOuterLocalTheme(props.theme));

    return _this;
  }

  (0, _createClass2.default)(MuiThemeProvider, [{
    key: "getChildContext",
    value: function getChildContext() {
      var _ref;

      var _this$props = this.props,
          sheetsManager = _this$props.sheetsManager,
          disableStylesGeneration = _this$props.disableStylesGeneration;
      var muiThemeProviderOptions = this.context.muiThemeProviderOptions || {};

      if (sheetsManager !== undefined) {
        muiThemeProviderOptions.sheetsManager = sheetsManager;
      }

      if (disableStylesGeneration !== undefined) {
        muiThemeProviderOptions.disableStylesGeneration = disableStylesGeneration;
      }

      return _ref = {}, (0, _defineProperty2.default)(_ref, _themeListener.CHANNEL, this.broadcast), (0, _defineProperty2.default)(_ref, "muiThemeProviderOptions", muiThemeProviderOptions), _ref;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // Subscribe on the outer theme, if present
      this.unsubscribeId = _themeListener.default.subscribe(this.context, function (outerTheme) {
        _this2.outerTheme = outerTheme; // Forward the parent theme update to the children

        _this2.broadcast.setState(_this2.mergeOuterLocalTheme(_this2.props.theme));
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // Propagate a local theme update
      if (this.props.theme !== prevProps.theme) {
        this.broadcast.setState(this.mergeOuterLocalTheme(this.props.theme));
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.unsubscribeId !== null) {
        _themeListener.default.unsubscribe(this.context, this.unsubscribeId);
      }
    } // Simple merge between the outer theme and the local theme

  }, {
    key: "mergeOuterLocalTheme",
    value: function mergeOuterLocalTheme(localTheme) {
      // To support composition of theme.
      if (typeof localTheme === 'function') {
         false ? (0, _warning.default)(this.outerTheme, ['Material-UI: you are providing a theme function property ' + 'to the MuiThemeProvider component:', '<MuiThemeProvider theme={outerTheme => outerTheme} />', 'However, no outer theme is present.', 'Make sure a theme is already injected higher in the React tree ' + 'or provide a theme object.'].join('\n')) : void 0;
        return localTheme(this.outerTheme);
      }

      if (!this.outerTheme) {
        return localTheme;
      }

      return (0, _extends2.default)({}, this.outerTheme, localTheme);
    }
  }, {
    key: "render",
    value: function render() {
      // TODO move the sheetsManager property to a different component.
      // warning(
      //   typeof window !== 'undefined' || this.props.sheetsManager,
      //   [
      //     'Material-UI: you need to provide a sheetsManager to the MuiThemeProvider ' +
      //       'when rendering on the server.',
      //     'If you do not, you might experience a memory leak',
      //   ].join('\n'),
      // );
      return this.props.children;
    }
  }]);
  return MuiThemeProvider;
}(_react.default.Component);

MuiThemeProvider.propTypes =  false ? {
  /**
   * You can wrap a node.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * You can disable the generation of the styles with this option.
   * It can be useful when traversing the React tree outside of the HTML
   * rendering step on the server.
   * Let's say you are using react-apollo to extract all
   * the queries made by the interface server side.
   * You can significantly speed up the traversal with this property.
   */
  disableStylesGeneration: _propTypes.default.bool,

  /**
   * The sheetsManager is used to deduplicate style sheet injection in the page.
   * It's deduplicating using the (theme, styles) couple.
   * On the server, you should provide a new instance for each request.
   */
  sheetsManager: _propTypes.default.object,

  /**
   * A theme object.
   */
  theme: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]).isRequired
} : {};
MuiThemeProvider.propTypes =  false ? (0, _exactProp.default)(MuiThemeProvider.propTypes) : {};
MuiThemeProvider.childContextTypes = (0, _extends2.default)({}, _themeListener.default.contextTypes, {
  muiThemeProviderOptions: _propTypes.default.object
});
MuiThemeProvider.contextTypes = (0, _extends2.default)({}, _themeListener.default.contextTypes, {
  muiThemeProviderOptions: _propTypes.default.object
});
var _default = MuiThemeProvider;
exports.default = _default;

/***/ }),
/* 791 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function createBroadcast (initialState) {
  var listeners = {};
  var id = 1;
  var _state = initialState;

  function getState () {
    return _state
  }

  function setState (state) {
    _state = state;
    var keys = Object.keys(listeners);
    var i = 0;
    var len = keys.length;
    for (; i < len; i++) {
      // if a listener gets unsubscribed during setState we just skip it
      if (listeners[keys[i]]) { listeners[keys[i]](state); }
    }
  }

  // subscribe to changes and return the subscriptionId
  function subscribe (listener) {
    if (typeof listener !== 'function') {
      throw new Error('listener must be a function.')
    }
    var currentId = id;
    listeners[currentId] = listener;
    id += 1;
    return currentId
  }

  // remove subscription by removing the listener function
  function unsubscribe (id) {
    delete listeners[id];
  }

  return { getState: getState, setState: setState, subscribe: subscribe, unsubscribe: unsubscribe }
}

/* harmony default export */ __webpack_exports__["default"] = (createBroadcast);


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ns$jss$ns$sheetOptio;

var _propTypes = __webpack_require__(3);

var _ns = __webpack_require__(448);

var ns = _interopRequireWildcard(_ns);

var _propTypes2 = __webpack_require__(794);

var _propTypes3 = _interopRequireDefault(_propTypes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports['default'] = (_ns$jss$ns$sheetOptio = {}, _defineProperty(_ns$jss$ns$sheetOptio, ns.jss, _propTypes3['default'].jss), _defineProperty(_ns$jss$ns$sheetOptio, ns.sheetOptions, _propTypes.object), _defineProperty(_ns$jss$ns$sheetOptio, ns.sheetsRegistry, _propTypes3['default'].registry), _defineProperty(_ns$jss$ns$sheetOptio, ns.managers, _propTypes.object), _ns$jss$ns$sheetOptio);

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(3);

exports['default'] = {
  jss: (0, _propTypes.shape)({
    options: (0, _propTypes.shape)({
      createGenerateClassName: _propTypes.func.isRequired
    }).isRequired,
    createStyleSheet: _propTypes.func.isRequired,
    removeStyleSheet: _propTypes.func.isRequired
  }),
  registry: (0, _propTypes.shape)({
    add: _propTypes.func.isRequired,
    toString: _propTypes.func.isRequired
  })
};

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _typeof2 = _interopRequireDefault(__webpack_require__(294));

var _warning = _interopRequireDefault(__webpack_require__(37));

var _deepmerge = _interopRequireDefault(__webpack_require__(215));

// < 1kb payload overhead when lodash/merge is > 3kb.
// Support for the jss-expand plugin.
function arrayMerge(destination, source) {
  return source;
}

function getStylesCreator(stylesOrCreator) {
  var themingEnabled = typeof stylesOrCreator === 'function';
   false ? (0, _warning.default)((0, _typeof2.default)(stylesOrCreator) === 'object' || themingEnabled, ['Material-UI: the first argument provided to withStyles() is invalid.', 'You need to provide a function generating the styles or a styles object.'].join('\n')) : void 0;

  function create(theme, name) {
    var styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;

    if (!name || !theme.overrides || !theme.overrides[name]) {
      return styles;
    }

    var overrides = theme.overrides[name];
    var stylesWithOverrides = (0, _extends2.default)({}, styles);
    Object.keys(overrides).forEach(function (key) {
       false ? (0, _warning.default)(stylesWithOverrides[key], ['Material-UI: you are trying to override a style that does not exist.', "Fix the `".concat(key, "` key of `theme.overrides.").concat(name, "`.")].join('\n')) : void 0;
      stylesWithOverrides[key] = (0, _deepmerge.default)(stylesWithOverrides[key], overrides[key], {
        arrayMerge: arrayMerge
      });
    });
    return stylesWithOverrides;
  }

  return {
    create: create,
    options: {},
    themingEnabled: themingEnabled
  };
}

var _default = getStylesCreator;
exports.default = _default;

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Router__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_CssBaseline__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_CssBaseline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_CssBaseline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Loader__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_DomainConfigError__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_pickers__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_pickers_utils_moment_utils__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Pages_AppShell_AppShell_jsx__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config_whiteLabelLandingPages_js__ = __webpack_require__(2459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Reusable_SharedSnackbar_SharedSnackbar_context__ = __webpack_require__(329);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Root=function(_Component){_inherits(Root,_Component);function Root(props){_classCallCheck(this,Root);var _this=_possibleConstructorReturn(this,(Root.__proto__||Object.getPrototypeOf(Root)).call(this,props));_this.state={canRender:false};props.client.resetStore().then(function(){return _this.setState({canRender:true});});return _this;}_createClass(Root,[{key:'render',value:function render(){if(!this.state.canRender)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Loader__["a" /* default */],{fullscreen:true});var _props=this.props,customPage=_props.customPage,customPageId=_props.customPageId,page=_props.page;var LandingPage=void 0;if(customPage){try{LandingPage=__WEBPACK_IMPORTED_MODULE_10__config_whiteLabelLandingPages_js__["a" /* default */][customPageId].component;}catch(e){LandingPage=__WEBPACK_IMPORTED_MODULE_6__common_DomainConfigError__["a" /* default */];}}else{LandingPage=__WEBPACK_IMPORTED_MODULE_10__config_whiteLabelLandingPages_js__["a" /* default */]['AQUILATRACK'].component;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_pickers__["c" /* MuiPickersUtilsProvider */],{utils:__WEBPACK_IMPORTED_MODULE_8_material_ui_pickers_utils_moment_utils__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_CssBaseline___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Reusable_SharedSnackbar_SharedSnackbar_context__["b" /* SharedSnackbarProvider */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* BrowserRouter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Router__["b" /* PublicRoute */],{exact:true,path:'/',render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LandingPage,page);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Router__["a" /* PrivateRoute */],{path:'/home'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Pages_AppShell_AppShell_jsx__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Redirect */],{to:{pathname:'/'}})))));}}]);return Root;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["withApollo"])(Root));

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(297);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);


/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);


/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return invariant; });
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
    throw new Error(value);
}




/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(297);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(452);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(451);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 806 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(454);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(455);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(456);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(457);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(300);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(220);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(458);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isAuthenticated */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__context__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jwt_decode__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__storage__ = __webpack_require__(461);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Helper to get URL parameters
var getQueryParam=function getQueryParam(param){var urlParams=new URLSearchParams(window.location.search);return urlParams.get(param);};// Helper to clean URL parameters
var cleanUrlParams=function cleanUrlParams(){var url=new URL(window.location);url.searchParams.delete('token');url.searchParams.delete('id');url.searchParams.delete('username');url.searchParams.delete('email');url.searchParams.delete('role');window.history.replaceState({},document.title,url.toString());};var isAuthenticated=function isAuthenticated(){var token=Object(__WEBPACK_IMPORTED_MODULE_3__storage__["b" /* getItem */])('Authorization_token');try{var _decode=__WEBPACK_IMPORTED_MODULE_2_jwt_decode___default()(token),exp=_decode.exp;var cur=Math.round(new Date().getTime()/1000);if(cur-exp>=0||exp-cur<=30){Object(__WEBPACK_IMPORTED_MODULE_3__storage__["a" /* clear */])();return false;}}catch(err){return false;}return true;};var AuthProvider=function(_Component){_inherits(AuthProvider,_Component);function AuthProvider(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AuthProvider);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AuthProvider.__proto__||Object.getPrototypeOf(AuthProvider)).call.apply(_ref,[this].concat(args))),_this),_this.state={authStatus:isAuthenticated()},_this.login=function(_ref2){var token=_ref2.token,accountType=_ref2.accountType,loginId=_ref2.loginId;var at=accountType=='SA'?accountType:'PA';Object(__WEBPACK_IMPORTED_MODULE_3__storage__["d" /* setItem */])('Authorization_token',token);Object(__WEBPACK_IMPORTED_MODULE_3__storage__["d" /* setItem */])('Account_type',at);Object(__WEBPACK_IMPORTED_MODULE_3__storage__["d" /* setItem */])('Login_id',loginId);_this.setState({authStatus:true});},_this.tokenLogin=function(token){try{var payload=__WEBPACK_IMPORTED_MODULE_2_jwt_decode___default()(token);var accountType=payload.roles=='SA'?payload.roles:'PA';// Check token expiration
var currentTime=Math.round(Date.now()/1000);if(payload.exp&&currentTime>payload.exp){console.error('Token has expired');return false;}// Set token in storage
Object(__WEBPACK_IMPORTED_MODULE_3__storage__["d" /* setItem */])('Authorization_token',token);Object(__WEBPACK_IMPORTED_MODULE_3__storage__["d" /* setItem */])('Account_type',accountType);Object(__WEBPACK_IMPORTED_MODULE_3__storage__["d" /* setItem */])('Login_id',payload.loginId);return true;}catch(error){console.error('Token processing failed:',error);return false;}},_this.logout=function(){Object(__WEBPACK_IMPORTED_MODULE_3__storage__["c" /* removeItem */])('Authorization_token');Object(__WEBPACK_IMPORTED_MODULE_3__storage__["c" /* removeItem */])('Account_type');Object(__WEBPACK_IMPORTED_MODULE_3__storage__["c" /* removeItem */])('Login_id');// NEW: Notify Service Worker to clear caches
if('serviceWorker'in navigator&&navigator.serviceWorker.controller){navigator.serviceWorker.controller.postMessage({type:'CLEAR_CACHE'});}_this.setState({authStatus:false});},_temp),_possibleConstructorReturn(_this,_ret);}// NEW: Token-based authentication from URL
_createClass(AuthProvider,[{key:'componentDidMount',value:function componentDidMount(){// Handle token from URL only if not already authenticated
if(!this.state.authStatus){var token=getQueryParam('token');if(token){var loginSuccess=this.tokenLogin(token);if(loginSuccess){this.setState({authStatus:true});}// Store user details from URL parameters in localStorage
var userId=getQueryParam('id');var userName=getQueryParam('username');var userEmail=getQueryParam('email');var userRole=getQueryParam('role');if(userId)Object(__WEBPACK_IMPORTED_MODULE_3__storage__["d" /* setItem */])('id',userId);if(userName)Object(__WEBPACK_IMPORTED_MODULE_3__storage__["d" /* setItem */])('username',userName);if(userEmail)Object(__WEBPACK_IMPORTED_MODULE_3__storage__["d" /* setItem */])('email',userEmail);if(userRole)Object(__WEBPACK_IMPORTED_MODULE_3__storage__["d" /* setItem */])('role',userRole);// Clean URL after processing
cleanUrlParams();}}}},{key:'render',value:function render(){var value=Object.assign({},this.state,{login:this.login,logout:this.logout});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__context__["b" /* Provider */],{value:value},this.props.children);}}]);return AuthProvider;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AuthProvider);

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

var atob = __webpack_require__(816);

function b64DecodeUnicode(str) {
  return decodeURIComponent(atob(str).replace(/(.)/g, function (m, p) {
    var code = p.charCodeAt(0).toString(16).toUpperCase();
    if (code.length < 2) {
      code = '0' + code;
    }
    return '%' + code;
  }));
}

module.exports = function(str) {
  var output = str.replace(/-/g, "+").replace(/_/g, "/");
  switch (output.length % 4) {
    case 0:
      break;
    case 2:
      output += "==";
      break;
    case 3:
      output += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }

  try{
    return b64DecodeUnicode(output);
  } catch (err) {
    return atob(output);
  }
};


/***/ }),
/* 816 */
/***/ (function(module, exports) {

/**
 * The code was extracted from:
 * https://github.com/davidchambers/Base64.js
 */

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function InvalidCharacterError(message) {
  this.message = message;
}

InvalidCharacterError.prototype = new Error();
InvalidCharacterError.prototype.name = 'InvalidCharacterError';

function polyfill (input) {
  var str = String(input).replace(/=+$/, '');
  if (str.length % 4 == 1) {
    throw new InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
  }
  for (
    // initialize result and counters
    var bc = 0, bs, buffer, idx = 0, output = '';
    // get next character
    buffer = str.charAt(idx++);
    // character found in table? initialize bit storage and add its ascii value;
    ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
      // and if not first of each 4 characters,
      // convert the first 8 bits to one ascii character
      bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0
  ) {
    // try to find character in table (0-63, not found => -1)
    buffer = chars.indexOf(buffer);
  }
  return output;
}


module.exports = typeof window !== 'undefined' && window.atob && window.atob.bind(window) || polyfill;


/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__context__ = __webpack_require__(459);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__context__["a" /* Consumer */]);

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _styles = __webpack_require__(5);

var _exactProp = _interopRequireDefault(__webpack_require__(115));

/* eslint-disable react/no-unused-prop-types */
var styles = function styles(theme) {
  return {
    '@global': {
      html: {
        WebkitFontSmoothing: 'antialiased',
        // Antialiasing.
        MozOsxFontSmoothing: 'grayscale',
        // Antialiasing.
        // Change from `box-sizing: content-box` so that `width`
        // is not affected by `padding` or `border`.
        boxSizing: 'border-box'
      },
      '*, *::before, *::after': {
        boxSizing: 'inherit'
      },
      body: {
        margin: 0,
        // Remove the margin in all browsers.
        backgroundColor: theme.palette.background.default,
        '@media print': {
          // Save printer ink.
          backgroundColor: theme.palette.common.white
        }
      }
    }
  };
};
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */


var CssBaseline =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(CssBaseline, _React$Component);

  function CssBaseline() {
    (0, _classCallCheck2.default)(this, CssBaseline);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CssBaseline).apply(this, arguments));
  }

  (0, _createClass2.default)(CssBaseline, [{
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
  return CssBaseline;
}(_react.default.Component);

CssBaseline.propTypes =  false ? {
  /**
   * You can wrap a node.
   */
  children: _propTypes.default.node,

  /**
   * @ignore
   */
  classes: _propTypes.default.object.isRequired
} : {};
CssBaseline.propTypes =  false ? (0, _exactProp.default)(CssBaseline.propTypes) : {};
CssBaseline.defaultProps = {
  children: null
};

var _default = (0, _styles.withStyles)(styles, {
  name: 'MuiCssBaseline'
})(CssBaseline);

exports.default = _default;

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _helpers = __webpack_require__(51);

var SIZE = 44;

function getRelativeValue(value, min, max) {
  var clampedValue = Math.min(Math.max(min, value), max);
  return (clampedValue - min) / (max - min);
}

function easeOut(t) {
  t = getRelativeValue(t, 0, 1); // https://gist.github.com/gre/1650294

  t = (t -= 1) * t * t + 1;
  return t;
}

function easeIn(t) {
  return t * t;
}

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-block',
      lineHeight: 1 // Keep the progress centered

    },

    /* Styles applied to the root element if `variant="static"`. */
    static: {
      transition: theme.transitions.create('transform')
    },

    /* Styles applied to the root element if `variant="indeterminate"`. */
    indeterminate: {
      animation: 'mui-progress-circular-rotate 1.4s linear infinite'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the `svg` element. */
    svg: {},

    /* Styles applied to the `circle` svg path. */
    circle: {
      stroke: 'currentColor' // Use butt to follow the specification, by chance, it's already the default CSS value.
      // strokeLinecap: 'butt',

    },

    /* Styles applied to the `circle` svg path if `variant="static"`. */
    circleStatic: {
      transition: theme.transitions.create('stroke-dashoffset')
    },

    /* Styles applied to the `circle` svg path if `variant="indeterminate"`. */
    circleIndeterminate: {
      animation: 'mui-progress-circular-dash 1.4s ease-in-out infinite',
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: '80px, 200px',
      strokeDashoffset: '0px' // Add the unit to fix a Edge 16 and below bug.

    },
    '@keyframes mui-progress-circular-rotate': {
      '100%': {
        transform: 'rotate(360deg)'
      }
    },
    '@keyframes mui-progress-circular-dash': {
      '0%': {
        strokeDasharray: '1px, 200px',
        strokeDashoffset: '0px'
      },
      '50%': {
        strokeDasharray: '100px, 200px',
        strokeDashoffset: '-15px'
      },
      '100%': {
        strokeDasharray: '100px, 200px',
        strokeDashoffset: '-120px'
      }
    }
  };
};
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */


exports.styles = styles;

function CircularProgress(props) {
  var _classNames, _classNames2;

  var classes = props.classes,
      className = props.className,
      color = props.color,
      size = props.size,
      style = props.style,
      thickness = props.thickness,
      value = props.value,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "size", "style", "thickness", "value", "variant"]);
  var circleStyle = {};
  var rootStyle = {};
  var rootProps = {};

  if (variant === 'determinate' || variant === 'static') {
    var circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
    circleStyle.strokeDasharray = circumference.toFixed(3);
    rootProps['aria-valuenow'] = Math.round(value);

    if (variant === 'static') {
      circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
      rootStyle.transform = 'rotate(-90deg)';
    } else {
      circleStyle.strokeDashoffset = "".concat((easeIn((100 - value) / 100) * circumference).toFixed(3), "px");
      rootStyle.transform = "rotate(".concat((easeOut(value / 70) * 270).toFixed(3), "deg)");
    }
  }

  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'inherit'), (0, _defineProperty2.default)(_classNames, classes.indeterminate, variant === 'indeterminate'), (0, _defineProperty2.default)(_classNames, classes.static, variant === 'static'), _classNames), className),
    style: (0, _extends2.default)({
      width: size,
      height: size
    }, rootStyle, style),
    role: "progressbar"
  }, rootProps, other), _react.default.createElement("svg", {
    className: classes.svg,
    viewBox: "".concat(SIZE / 2, " ").concat(SIZE / 2, " ").concat(SIZE, " ").concat(SIZE)
  }, _react.default.createElement("circle", {
    className: (0, _classnames.default)(classes.circle, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.circleIndeterminate, variant === 'indeterminate'), (0, _defineProperty2.default)(_classNames2, classes.circleStatic, variant === 'static'), _classNames2)),
    style: circleStyle,
    cx: SIZE,
    cy: SIZE,
    r: (SIZE - thickness) / 2,
    fill: "none",
    strokeWidth: thickness
  })));
}

CircularProgress.propTypes =  false ? {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['primary', 'secondary', 'inherit']),

  /**
   * The size of the circle.
   */
  size: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * @ignore
   */
  style: _propTypes.default.object,

  /**
   * The thickness of the circle.
   */
  thickness: _propTypes.default.number,

  /**
   * The value of the progress indicator for the determinate and static variants.
   * Value between 0 and 100.
   */
  value: _propTypes.default.number,

  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   */
  variant: _propTypes.default.oneOf(['determinate', 'indeterminate', 'static'])
} : {};
CircularProgress.defaultProps = {
  color: 'primary',
  size: 40,
  thickness: 3.6,
  value: 0,
  variant: 'indeterminate'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiCircularProgress',
  flip: false
})(CircularProgress);

exports.default = _default;

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress__);
var FullScreenLoader=function FullScreenLoader(_ref){var showSpinner=_ref.showSpinner;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true,alignItems:'center',justify:'center',style:{height:'100vh',width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},showSpinner?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress___default.a,{size:100}):'Loading ...'));};FullScreenLoader.propTypes={showSpinner:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};FullScreenLoader.defaultProps={showSpinner:true};/* harmony default export */ __webpack_exports__["a"] = (FullScreenLoader);

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _createBreakpoints = __webpack_require__(173);

var _requirePropFactory = _interopRequireDefault(__webpack_require__(822));

// A grid component using the following libs as inspiration.
//
// For the implementation:
// - http://v4-alpha.getbootstrap.com/layout/flexbox-grid/
// - https://github.com/kristoferjoseph/flexboxgrid/blob/master/src/css/flexboxgrid.css
// - https://github.com/roylee0704/react-flexbox-grid
// - https://material.angularjs.org/latest/layout/introduction
//
// Follow this flexbox Guide to better understand the underlying model:
// - https://css-tricks.com/snippets/css/a-guide-to-flexbox/
var GUTTERS = [0, 8, 16, 24, 32, 40];
var GRID_SIZES = ['auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

function generateGrid(globalStyles, theme, breakpoint) {
  var styles = {};
  GRID_SIZES.forEach(function (size) {
    var key = "grid-".concat(breakpoint, "-").concat(size);

    if (size === true) {
      // For the auto layouting
      styles[key] = {
        flexBasis: 0,
        flexGrow: 1,
        maxWidth: '100%'
      };
      return;
    }

    if (size === 'auto') {
      styles[key] = {
        flexBasis: 'auto',
        flexGrow: 0,
        maxWidth: 'none'
      };
      return;
    } // Only keep 6 significant numbers.


    var width = "".concat(Math.round(size / 12 * 10e6) / 10e4, "%"); // Close to the bootstrap implementation:
    // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41

    styles[key] = {
      flexBasis: width,
      flexGrow: 0,
      maxWidth: width
    };
  }); // No need for a media query for the first size.

  if (breakpoint === 'xs') {
    (0, _extends2.default)(globalStyles, styles);
  } else {
    globalStyles[theme.breakpoints.up(breakpoint)] = styles;
  }
}

function generateGutter(theme, breakpoint) {
  var styles = {};
  GUTTERS.forEach(function (spacing, index) {
    if (index === 0) {
      // Skip the default style.
      return;
    }

    styles["spacing-".concat(breakpoint, "-").concat(spacing)] = {
      margin: -spacing / 2,
      width: "calc(100% + ".concat(spacing, "px)"),
      '& > $item': {
        padding: spacing / 2
      }
    };
  });
  return styles;
} // Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',


var styles = function styles(theme) {
  return (0, _extends2.default)({
    /* Styles applied to the root element if `container={true}`. */
    container: {
      boxSizing: 'border-box',
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%'
    },

    /* Styles applied to the root element if `item={true}`. */
    item: {
      boxSizing: 'border-box',
      margin: '0' // For instance, it's useful when used with a `figure` element.

    },

    /* Styles applied to the root element if `zeroMinWidth={true}`. */
    zeroMinWidth: {
      minWidth: 0
    },

    /* Styles applied to the root element if `direction="column"`. */
    'direction-xs-column': {
      flexDirection: 'column'
    },

    /* Styles applied to the root element if `direction="column-reverse"`. */
    'direction-xs-column-reverse': {
      flexDirection: 'column-reverse'
    },

    /* Styles applied to the root element if `direction="rwo-reverse"`. */
    'direction-xs-row-reverse': {
      flexDirection: 'row-reverse'
    },

    /* Styles applied to the root element if `wrap="nowrap"`. */
    'wrap-xs-nowrap': {
      flexWrap: 'nowrap'
    },

    /* Styles applied to the root element if `wrap="reverse"`. */
    'wrap-xs-wrap-reverse': {
      flexWrap: 'wrap-reverse'
    },

    /* Styles applied to the root element if `alignItems="center"`. */
    'align-items-xs-center': {
      alignItems: 'center'
    },

    /* Styles applied to the root element if `alignItems="flex-start"`. */
    'align-items-xs-flex-start': {
      alignItems: 'flex-start'
    },

    /* Styles applied to the root element if `alignItems="flex-end"`. */
    'align-items-xs-flex-end': {
      alignItems: 'flex-end'
    },

    /* Styles applied to the root element if `alignItems="baseline"`. */
    'align-items-xs-baseline': {
      alignItems: 'baseline'
    },

    /* Styles applied to the root element if `alignContent="center"`. */
    'align-content-xs-center': {
      alignContent: 'center'
    },

    /* Styles applied to the root element if `alignContent="flex-start"`. */
    'align-content-xs-flex-start': {
      alignContent: 'flex-start'
    },

    /* Styles applied to the root element if `alignContent="flex-end"`. */
    'align-content-xs-flex-end': {
      alignContent: 'flex-end'
    },

    /* Styles applied to the root element if `alignContent="space-between"`. */
    'align-content-xs-space-between': {
      alignContent: 'space-between'
    },

    /* Styles applied to the root element if `alignContent="space-around"`. */
    'align-content-xs-space-around': {
      alignContent: 'space-around'
    },

    /* Styles applied to the root element if `justify="center"`. */
    'justify-xs-center': {
      justifyContent: 'center'
    },

    /* Styles applied to the root element if `justify="flex-end"`. */
    'justify-xs-flex-end': {
      justifyContent: 'flex-end'
    },

    /* Styles applied to the root element if `justify="space-between"`. */
    'justify-xs-space-between': {
      justifyContent: 'space-between'
    },

    /* Styles applied to the root element if `justify="space-around"`. */
    'justify-xs-space-around': {
      justifyContent: 'space-around'
    },

    /* Styles applied to the root element if `justify="space-evenly"`. */
    'justify-xs-space-evenly': {
      justifyContent: 'space-evenly'
    }
  }, generateGutter(theme, 'xs'), _createBreakpoints.keys.reduce(function (accumulator, key) {
    // Use side effect over immutability for better performance.
    generateGrid(accumulator, theme, key);
    return accumulator;
  }, {}));
};

exports.styles = styles;

function Grid(props) {
  var _classNames;

  var alignContent = props.alignContent,
      alignItems = props.alignItems,
      classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      container = props.container,
      direction = props.direction,
      item = props.item,
      justify = props.justify,
      lg = props.lg,
      md = props.md,
      sm = props.sm,
      spacing = props.spacing,
      wrap = props.wrap,
      xl = props.xl,
      xs = props.xs,
      zeroMinWidth = props.zeroMinWidth,
      other = (0, _objectWithoutProperties2.default)(props, ["alignContent", "alignItems", "classes", "className", "component", "container", "direction", "item", "justify", "lg", "md", "sm", "spacing", "wrap", "xl", "xs", "zeroMinWidth"]);
  var className = (0, _classnames.default)((_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.container, container), (0, _defineProperty2.default)(_classNames, classes.item, item), (0, _defineProperty2.default)(_classNames, classes.zeroMinWidth, zeroMinWidth), (0, _defineProperty2.default)(_classNames, classes["spacing-xs-".concat(String(spacing))], container && spacing !== 0), (0, _defineProperty2.default)(_classNames, classes["direction-xs-".concat(String(direction))], direction !== Grid.defaultProps.direction), (0, _defineProperty2.default)(_classNames, classes["wrap-xs-".concat(String(wrap))], wrap !== Grid.defaultProps.wrap), (0, _defineProperty2.default)(_classNames, classes["align-items-xs-".concat(String(alignItems))], alignItems !== Grid.defaultProps.alignItems), (0, _defineProperty2.default)(_classNames, classes["align-content-xs-".concat(String(alignContent))], alignContent !== Grid.defaultProps.alignContent), (0, _defineProperty2.default)(_classNames, classes["justify-xs-".concat(String(justify))], justify !== Grid.defaultProps.justify), (0, _defineProperty2.default)(_classNames, classes["grid-xs-".concat(String(xs))], xs !== false), (0, _defineProperty2.default)(_classNames, classes["grid-sm-".concat(String(sm))], sm !== false), (0, _defineProperty2.default)(_classNames, classes["grid-md-".concat(String(md))], md !== false), (0, _defineProperty2.default)(_classNames, classes["grid-lg-".concat(String(lg))], lg !== false), (0, _defineProperty2.default)(_classNames, classes["grid-xl-".concat(String(xl))], xl !== false), _classNames), classNameProp);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className
  }, other));
}

Grid.propTypes =  false ? {
  /**
   * Defines the `align-content` style property.
   * It's applied for all screen sizes.
   */
  alignContent: _propTypes.default.oneOf(['stretch', 'center', 'flex-start', 'flex-end', 'space-between', 'space-around']),

  /**
   * Defines the `align-items` style property.
   * It's applied for all screen sizes.
   */
  alignItems: _propTypes.default.oneOf(['flex-start', 'center', 'flex-end', 'stretch', 'baseline']),

  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   */
  container: _propTypes.default.bool,

  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   */
  direction: _propTypes.default.oneOf(['row', 'row-reverse', 'column', 'column-reverse']),

  /**
   * If `true`, the component will have the flex *item* behavior.
   * You should be wrapping *items* with a *container*.
   */
  item: _propTypes.default.bool,

  /**
   * Defines the `justify-content` style property.
   * It is applied for all screen sizes.
   */
  justify: _propTypes.default.oneOf(['flex-start', 'center', 'flex-end', 'space-between', 'space-around', 'space-evenly']),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `lg` breakpoint and wider screens if not overridden.
   */
  lg: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `md` breakpoint and wider screens if not overridden.
   */
  md: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `sm` breakpoint and wider screens if not overridden.
   */
  sm: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the space between the type `item` component.
   * It can only be used on a type `container` component.
   */
  spacing: _propTypes.default.oneOf(GUTTERS),

  /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   */
  wrap: _propTypes.default.oneOf(['nowrap', 'wrap', 'wrap-reverse']),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `xl` breakpoint and wider screens.
   */
  xl: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for all the screen sizes with the lowest priority.
   */
  xs: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * If `true`, it sets `min-width: 0` on the item.
   * Refer to the limitations section of the documentation to better understand the use case.
   */
  zeroMinWidth: _propTypes.default.bool
} : {};
Grid.defaultProps = {
  alignContent: 'stretch',
  alignItems: 'stretch',
  component: 'div',
  container: false,
  direction: 'row',
  item: false,
  justify: 'flex-start',
  lg: false,
  md: false,
  sm: false,
  spacing: 0,
  wrap: 'wrap',
  xl: false,
  xs: false,
  zeroMinWidth: false
};
var StyledGrid = (0, _withStyles.default)(styles, {
  name: 'MuiGrid'
})(Grid);

if (false) {
  var requireProp = (0, _requirePropFactory.default)('Grid');
  StyledGrid.propTypes = (0, _extends2.default)({}, StyledGrid.propTypes, {
    alignContent: requireProp('container'),
    alignItems: requireProp('container'),
    direction: requireProp('container'),
    justify: requireProp('container'),
    lg: requireProp('item'),
    md: requireProp('item'),
    sm: requireProp('item'),
    spacing: requireProp('container'),
    wrap: requireProp('container'),
    xs: requireProp('item'),
    zeroMinWidth: requireProp('zeroMinWidth')
  });
}

var _default = StyledGrid;
exports.default = _default;

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function requirePropFactory(componentNameInError) {
  /* istanbul ignore if */
  if (true) {
    return function () {
      return null;
    };
  }

  var requireProp = function requireProp(requiredProp) {
    return function (props, propName, componentName, location, propFullName) {
      var propFullNameSafe = propFullName || propName;

      if (typeof props[propName] !== 'undefined' && !props[requiredProp]) {
        return new Error("The property `".concat(propFullNameSafe, "` of ") + "`".concat(componentNameInError, "` must be used on `").concat(requiredProp, "`."));
      }

      return null;
    };
  };

  return requireProp;
}

var _default = requirePropFactory;
exports.default = _default;

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles__);
var errorPageStyle=function errorPageStyle(theme){return{containerGrid:{background:'rgba(229, 255, 252, 0.4)',width:'100%',height:'100vh'},errorTitleBottomMargin:{marginBottom:theme.spacing.unit*5}};};var DomainFetchError=function DomainFetchError(_ref){var classes=_ref.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true,justify:'center',alignItems:'center',className:classes.containerGrid},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true,justify:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,className:classes.errorTitleBottomMargin},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Typography___default.a,{align:'center',gutterBottom:true,variant:'h4'},'Oops, Something went wrong!')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:8,md:6,lg:4,xl:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Typography___default.a,{align:'center',gutterBottom:true,variant:'h6'},'Please try again later')))));};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles_withStyles___default()(errorPageStyle)(DomainFetchError));

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _helpers = __webpack_require__(51);

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'block',
      margin: 0
    },

    /* Styles applied to the root element if `variant="display4"`. */
    display4: theme.typography.display4,

    /* Styles applied to the root element if `variant="display3"`. */
    display3: theme.typography.display3,

    /* Styles applied to the root element if `variant="display2"`. */
    display2: theme.typography.display2,

    /* Styles applied to the root element if `variant="display1"`. */
    display1: theme.typography.display1,

    /* Styles applied to the root element if `variant="headline"`. */
    headline: theme.typography.headline,

    /* Styles applied to the root element if `variant="title"`. */
    title: theme.typography.title,

    /* Styles applied to the root element if `variant="subheading"`. */
    subheading: theme.typography.subheading,

    /* Styles applied to the root element if `variant="body2"`. */
    body2: theme.typography.body2,

    /* Styles applied to the root element if `variant="body1"`. */
    body1: theme.typography.body1,

    /* Styles applied to the root element if `variant="caption"`. */
    caption: theme.typography.caption,

    /* Styles applied to the root element if `variant="button"`. */
    button: theme.typography.button,

    /* Styles applied to the root element if `align="left"`. */
    alignLeft: {
      textAlign: 'left'
    },

    /* Styles applied to the root element if `align="center"`. */
    alignCenter: {
      textAlign: 'center'
    },

    /* Styles applied to the root element if `align="right"`. */
    alignRight: {
      textAlign: 'right'
    },

    /* Styles applied to the root element if `align="justify"`. */
    alignJustify: {
      textAlign: 'justify'
    },

    /* Styles applied to the root element if `align="nowrap"`. */
    noWrap: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the root element if `gutterBottom={true}`. */
    gutterBottom: {
      marginBottom: '0.35em'
    },

    /* Styles applied to the root element if `paragraph={true}`. */
    paragraph: {
      marginBottom: 16
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="textPrimary"`. */
    colorTextPrimary: {
      color: theme.palette.text.primary
    },

    /* Styles applied to the root element if `color="textSecondary"`. */
    colorTextSecondary: {
      color: theme.palette.text.secondary
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    }
  };
};

exports.styles = styles;

function Typography(props) {
  var _classNames;

  var align = props.align,
      classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      componentProp = props.component,
      gutterBottom = props.gutterBottom,
      headlineMapping = props.headlineMapping,
      noWrap = props.noWrap,
      paragraph = props.paragraph,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["align", "classes", "className", "color", "component", "gutterBottom", "headlineMapping", "noWrap", "paragraph", "variant"]);
  var className = (0, _classnames.default)(classes.root, classes[variant], (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'default'), (0, _defineProperty2.default)(_classNames, classes.noWrap, noWrap), (0, _defineProperty2.default)(_classNames, classes.gutterBottom, gutterBottom), (0, _defineProperty2.default)(_classNames, classes.paragraph, paragraph), (0, _defineProperty2.default)(_classNames, classes["align".concat((0, _helpers.capitalize)(align))], align !== 'inherit'), _classNames), classNameProp);
  var Component = componentProp || (paragraph ? 'p' : headlineMapping[variant]) || 'span';
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className
  }, other));
}

Typography.propTypes =  false ? {
  /**
   * Set the text-align on the component.
   */
  align: _propTypes.default.oneOf(['inherit', 'left', 'center', 'right', 'justify']),

  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['default', 'error', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   * By default, it maps the variant to a good default headline component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the text will have a bottom margin.
   */
  gutterBottom: _propTypes.default.bool,

  /**
   * We are empirically mapping the variant property to a range of different DOM element types.
   * For instance, h1 to h6. If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` property.
   */
  headlineMapping: _propTypes.default.object,

  /**
   * If `true`, the text will not wrap, but instead will truncate with an ellipsis.
   */
  noWrap: _propTypes.default.bool,

  /**
   * If `true`, the text will have a bottom margin.
   */
  paragraph: _propTypes.default.bool,

  /**
   * Applies the theme typography styles.
   */
  variant: _propTypes.default.oneOf(['display4', 'display3', 'display2', 'display1', 'headline', 'title', 'subheading', 'body2', 'body1', 'caption', 'button'])
} : {};
Typography.defaultProps = {
  align: 'inherit',
  color: 'default',
  gutterBottom: false,
  headlineMapping: {
    display4: 'h1',
    display3: 'h1',
    display2: 'h1',
    display1: 'h1',
    headline: 'h1',
    title: 'h2',
    subheading: 'h3',
    body2: 'aside',
    body1: 'p'
  },
  noWrap: false,
  paragraph: false,
  variant: 'body1'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTypography'
})(Typography);

exports.default = _default;

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(0)):"function"==typeof define&&define.amd?define(["react"],t):"object"==typeof exports?exports.reactTextMask=t(require("react")):e.reactTextMask=t(e.React)}(this,function(e){return function(e){function t(n){if(r[n])return r[n].exports;var o=r[n]={exports:{},id:n,loaded:!1};return e[n].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var r={};return t.m=e,t.c=r,t.p="",t(0)}([function(e,t,r){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var r={};for(var n in e)t.indexOf(n)>=0||Object.prototype.hasOwnProperty.call(e,n)&&(r[n]=e[n]);return r}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0}),t.conformToMask=void 0;var l=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e},s=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),f=r(2);Object.defineProperty(t,"conformToMask",{enumerable:!0,get:function(){return n(f).default}});var c=r(11),p=n(c),d=r(9),h=n(d),v=r(5),y=n(v),m=function(e){function t(){var e;i(this,t);for(var r=arguments.length,n=Array(r),o=0;o<r;o++)n[o]=arguments[o];var u=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(n)));return u.onBlur=u.onBlur.bind(u),u.onChange=u.onChange.bind(u),u}return u(t,e),s(t,[{key:"initTextMask",value:function(){var e=this.props,t=this.props.value;this.textMaskInputElement=(0,y.default)(l({inputElement:this.inputElement},e)),this.textMaskInputElement.update(t)}},{key:"componentDidMount",value:function(){this.initTextMask()}},{key:"componentDidUpdate",value:function(){this.initTextMask()}},{key:"render",value:function e(){var t=this,r=this.props,e=r.render,n=o(r,["render"]);delete n.mask,delete n.guide,delete n.pipe,delete n.placeholderChar,delete n.keepCharPositions,delete n.value,delete n.onBlur,delete n.onChange,delete n.showMask;var i=function(e){return t.inputElement=e};return e(i,l({onBlur:this.onBlur,onChange:this.onChange,defaultValue:this.props.value},n))}},{key:"onChange",value:function(e){this.textMaskInputElement.update(),"function"==typeof this.props.onChange&&this.props.onChange(e)}},{key:"onBlur",value:function(e){"function"==typeof this.props.onBlur&&this.props.onBlur(e)}}]),t}(p.default.Component);t.default=m,m.propTypes={mask:h.default.oneOfType([h.default.array,h.default.func,h.default.bool,h.default.shape({mask:h.default.oneOfType([h.default.array,h.default.func]),pipe:h.default.func})]).isRequired,guide:h.default.bool,value:h.default.oneOfType([h.default.string,h.default.number]),pipe:h.default.func,placeholderChar:h.default.string,keepCharPositions:h.default.bool,showMask:h.default.bool},m.defaultProps={render:function(e,t){return p.default.createElement("input",l({ref:e},t))}}},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.placeholderChar="_",t.strFunction="function"},function(e,t,r){"use strict";function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:l,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:u,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};if(!(0,i.isArray)(t)){if(("undefined"==typeof t?"undefined":o(t))!==a.strFunction)throw new Error("Text-mask:conformToMask; The mask property must be an array.");t=t(e,r),t=(0,i.processCaretTraps)(t).maskWithoutCaretTraps}var n=r.guide,s=void 0===n||n,f=r.previousConformedValue,c=void 0===f?l:f,p=r.placeholderChar,d=void 0===p?a.placeholderChar:p,h=r.placeholder,v=void 0===h?(0,i.convertMaskToPlaceholder)(t,d):h,y=r.currentCaretPosition,m=r.keepCharPositions,b=s===!1&&void 0!==c,g=e.length,k=c.length,C=v.length,O=t.length,T=g-k,P=T>0,x=y+(P?-T:0),w=x+Math.abs(T);if(m===!0&&!P){for(var _=l,M=x;M<w;M++)v[M]===d&&(_+=d);e=e.slice(0,x)+_+e.slice(x,g)}for(var S=e.split(l).map(function(e,t){return{char:e,isNew:t>=x&&t<w}}),j=g-1;j>=0;j--){var E=S[j].char;if(E!==d){var R=j>=x&&k===O;E===v[R?j-T:j]&&S.splice(j,1)}}var V=l,A=!1;e:for(var N=0;N<C;N++){var B=v[N];if(B===d){if(S.length>0)for(;S.length>0;){var I=S.shift(),F=I.char,q=I.isNew;if(F===d&&b!==!0){V+=d;continue e}if(t[N].test(F)){if(m===!0&&q!==!1&&c!==l&&s!==!1&&P){for(var D=S.length,L=null,W=0;W<D;W++){var J=S[W];if(J.char!==d&&J.isNew===!1)break;if(J.char===d){L=W;break}}null!==L?(V+=F,S.splice(L,1)):N--}else V+=F;continue e}A=!0}b===!1&&(V+=v.substr(N,C));break}V+=B}if(b&&P===!1){for(var U=null,H=0;H<V.length;H++)v[H]===d&&(U=H);V=null!==U?V.substr(0,U+1):l}return{conformedValue:V,meta:{someCharsRejected:A}}}Object.defineProperty(t,"__esModule",{value:!0});var o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=n;var i=r(3),a=r(1),u=[],l=""},function(e,t,r){"use strict";function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:s,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:l.placeholderChar;if(!o(e))throw new Error("Text-mask:convertMaskToPlaceholder; The mask property must be an array.");if(e.indexOf(t)!==-1)throw new Error("Placeholder character must not be used as part of the mask. Please specify a character that is not present in your mask as your placeholder character.\n\n"+("The placeholder character that was received is: "+JSON.stringify(t)+"\n\n")+("The mask that was received is: "+JSON.stringify(e)));return e.map(function(e){return e instanceof RegExp?t:e}).join("")}function o(e){return Array.isArray&&Array.isArray(e)||e instanceof Array}function i(e){return"string"==typeof e||e instanceof String}function a(e){return"number"==typeof e&&void 0===e.length&&!isNaN(e)}function u(e){for(var t=[],r=void 0;r=e.indexOf(f),r!==-1;)t.push(r),e.splice(r,1);return{maskWithoutCaretTraps:e,indexes:t}}Object.defineProperty(t,"__esModule",{value:!0}),t.convertMaskToPlaceholder=n,t.isArray=o,t.isString=i,t.isNumber=a,t.processCaretTraps=u;var l=r(1),s=[],f="[]"},function(e,t){"use strict";function r(e){var t=e.previousConformedValue,r=void 0===t?o:t,i=e.previousPlaceholder,a=void 0===i?o:i,u=e.currentCaretPosition,l=void 0===u?0:u,s=e.conformedValue,f=e.rawValue,c=e.placeholderChar,p=e.placeholder,d=e.indexesOfPipedChars,h=void 0===d?n:d,v=e.caretTrapIndexes,y=void 0===v?n:v;if(0===l||!f.length)return 0;var m=f.length,b=r.length,g=p.length,k=s.length,C=m-b,O=C>0,T=0===b,P=C>1&&!O&&!T;if(P)return l;var x=O&&(r===s||s===p),w=0,_=void 0,M=void 0;if(x)w=l-C;else{var S=s.toLowerCase(),j=f.toLowerCase(),E=j.substr(0,l).split(o),R=E.filter(function(e){return S.indexOf(e)!==-1});M=R[R.length-1];var V=a.substr(0,R.length).split(o).filter(function(e){return e!==c}).length,A=p.substr(0,R.length).split(o).filter(function(e){return e!==c}).length,N=A!==V,B=void 0!==a[R.length-1]&&void 0!==p[R.length-2]&&a[R.length-1]!==c&&a[R.length-1]!==p[R.length-1]&&a[R.length-1]===p[R.length-2];!O&&(N||B)&&V>0&&p.indexOf(M)>-1&&void 0!==f[l]&&(_=!0,M=f[l]);for(var I=h.map(function(e){return S[e]}),F=I.filter(function(e){return e===M}).length,q=R.filter(function(e){return e===M}).length,D=p.substr(0,p.indexOf(c)).split(o).filter(function(e,t){return e===M&&f[t]!==e}).length,L=D+q+F+(_?1:0),W=0,J=0;J<k;J++){var U=S[J];if(w=J+1,U===M&&W++,W>=L)break}}if(O){for(var H=w,Y=w;Y<=g;Y++)if(p[Y]===c&&(H=Y),p[Y]===c||y.indexOf(Y)!==-1||Y===g)return H}else if(_){for(var z=w-1;z>=0;z--)if(s[z]===M||y.indexOf(z)!==-1||0===z)return z}else for(var G=w;G>=0;G--)if(p[G-1]===c||y.indexOf(G)!==-1||0===G)return G}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r;var n=[],o=""},function(e,t,r){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function o(e){var t={previousConformedValue:void 0,previousPlaceholder:void 0};return{state:t,update:function(r){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:e,o=n.inputElement,s=n.mask,c=n.guide,y=n.pipe,b=n.placeholderChar,g=void 0===b?h.placeholderChar:b,k=n.keepCharPositions,C=void 0!==k&&k,O=n.showMask,T=void 0!==O&&O;if("undefined"==typeof r&&(r=o.value),r!==t.previousConformedValue){("undefined"==typeof s?"undefined":l(s))===m&&void 0!==s.pipe&&void 0!==s.mask&&(y=s.pipe,s=s.mask);var P=void 0,x=void 0;if(s instanceof Array&&(P=(0,d.convertMaskToPlaceholder)(s,g)),s!==!1){var w=a(r),_=o.selectionEnd,M=t.previousConformedValue,S=t.previousPlaceholder,j=void 0;if(("undefined"==typeof s?"undefined":l(s))===h.strFunction){if(x=s(w,{currentCaretPosition:_,previousConformedValue:M,placeholderChar:g}),x===!1)return;var E=(0,d.processCaretTraps)(x),R=E.maskWithoutCaretTraps,V=E.indexes;x=R,j=V,P=(0,d.convertMaskToPlaceholder)(x,g)}else x=s;var A={previousConformedValue:M,guide:c,placeholderChar:g,pipe:y,placeholder:P,currentCaretPosition:_,keepCharPositions:C},N=(0,p.default)(w,x,A),B=N.conformedValue,I=("undefined"==typeof y?"undefined":l(y))===h.strFunction,F={};I&&(F=y(B,u({rawValue:w},A)),F===!1?F={value:M,rejected:!0}:(0,d.isString)(F)&&(F={value:F}));var q=I?F.value:B,D=(0,f.default)({previousConformedValue:M,previousPlaceholder:S,conformedValue:q,placeholder:P,rawValue:w,currentCaretPosition:_,placeholderChar:g,indexesOfPipedChars:F.indexesOfPipedChars,caretTrapIndexes:j}),L=q===P&&0===D,W=T?P:v,J=L?W:q;t.previousConformedValue=J,t.previousPlaceholder=P,o.value!==J&&(o.value=J,i(o,D))}}}}}function i(e,t){document.activeElement===e&&(b?g(function(){return e.setSelectionRange(t,t,y)},0):e.setSelectionRange(t,t,y))}function a(e){if((0,d.isString)(e))return e;if((0,d.isNumber)(e))return String(e);if(void 0===e||null===e)return v;throw new Error("The 'value' provided to Text Mask needs to be a string or a number. The value received was:\n\n "+JSON.stringify(e))}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e},l="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=o;var s=r(4),f=n(s),c=r(2),p=n(c),d=r(3),h=r(1),v="",y="none",m="object",b="undefined"!=typeof navigator&&/Android/i.test(navigator.userAgent),g="undefined"!=typeof requestAnimationFrame?requestAnimationFrame:setTimeout},function(e,t){"use strict";function r(e){return function(){return e}}var n=function(){};n.thatReturns=r,n.thatReturnsFalse=r(!1),n.thatReturnsTrue=r(!0),n.thatReturnsNull=r(null),n.thatReturnsThis=function(){return this},n.thatReturnsArgument=function(e){return e},e.exports=n},function(e,t,r){"use strict";function n(e,t,r,n,i,a,u,l){if(o(t),!e){var s;if(void 0===t)s=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var f=[r,n,i,a,u,l],c=0;s=new Error(t.replace(/%s/g,function(){return f[c++]})),s.name="Invariant Violation"}throw s.framesToPop=1,s}}var o=function(e){};e.exports=n},function(e,t,r){"use strict";var n=r(6),o=r(7),i=r(10);e.exports=function(){function e(e,t,r,n,a,u){u!==i&&o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var r={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return r.checkPropTypes=n,r.PropTypes=r,r}},function(e,t,r){"use strict";"function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},e.exports=r(8)()},function(e,t){"use strict";var r="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=r},function(t,r){t.exports=e}])});

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _helpers = __webpack_require__(51);

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      userSelect: 'none',
      fontSize: 24,
      width: '1em',
      height: '1em',
      // Chrome fix for https://bugs.chromium.org/p/chromium/issues/detail?id=820541
      // To remove at some point.
      overflow: 'hidden',
      flexShrink: 0
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="action"`. */
    colorAction: {
      color: theme.palette.action.active
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `color="disabled"`. */
    colorDisabled: {
      color: theme.palette.action.disabled
    },
    fontSizeInherit: {
      fontSize: 'inherit'
    }
  };
};

exports.styles = styles;

function Icon(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      className = props.className,
      color = props.color,
      fontSize = props.fontSize,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "fontSize"]);
  return _react.default.createElement("span", (0, _extends2.default)({
    className: (0, _classnames.default)('material-icons', classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'inherit'), (0, _defineProperty2.default)(_classNames, classes["fontSize".concat((0, _helpers.capitalize)(fontSize))], fontSize !== 'default'), _classNames), className),
    "aria-hidden": "true"
  }, other), children);
}

Icon.propTypes =  false ? {
  /**
   * The name of the icon font ligature.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['inherit', 'primary', 'secondary', 'action', 'error', 'disabled']),

  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   */
  fontSize: _propTypes.default.oneOf(['inherit', 'default'])
} : {};
Icon.defaultProps = {
  color: 'inherit',
  fontSize: 'default'
};
Icon.muiName = 'Icon';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiIcon'
})(Icon);

exports.default = _default;

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _colorManipulator = __webpack_require__(80);

var _ButtonBase = _interopRequireDefault(__webpack_require__(92));

var _helpers = __webpack_require__(51);

// @inheritedComponent ButtonBase
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      textAlign: 'center',
      flex: '0 0 auto',
      fontSize: theme.typography.pxToRem(24),
      width: 48,
      height: 48,
      padding: 0,
      borderRadius: '50%',
      color: theme.palette.action.active,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.action.active, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        },
        '&$disabled': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the children container element. */
    label: {
      width: '100%',
      display: 'flex',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    }
  };
};
/**
 * Refer to the [Icons](/style/icons) section of the documentation
 * regarding the available icon options.
 */


exports.styles = styles;

function IconButton(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      className = props.className,
      color = props.color,
      disabled = props.disabled,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "disabled"]);
  return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'default'), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), _classNames), className),
    centerRipple: true,
    focusRipple: true,
    disabled: disabled
  }, other), _react.default.createElement("span", {
    className: classes.label
  }, children));
}

IconButton.propTypes =  false ? {
  /**
   * The icon element.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary']),

  /**
   * If `true`, the button will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the ripple will be disabled.
   */
  disableRipple: _propTypes.default.bool
} : {};
IconButton.defaultProps = {
  color: 'default',
  disabled: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiIconButton'
})(IconButton);

exports.default = _default;

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(145));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _reactDom = _interopRequireDefault(__webpack_require__(64));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _keycode = _interopRequireDefault(__webpack_require__(117));

var _ownerWindow = _interopRequireDefault(__webpack_require__(221));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _focusVisible = __webpack_require__(829);

var _TouchRipple = _interopRequireDefault(__webpack_require__(830));

var _createRippleHandler = _interopRequireDefault(__webpack_require__(836));

var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    // Remove grey highlight
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 'none',
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    '-moz-appearance': 'none',
    // Reset
    '-webkit-appearance': 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
      borderStyle: 'none' // Remove Firefox dotted outline.

    },
    '&$disabled': {
      pointerEvents: 'none',
      // Disable link interactions
      cursor: 'default'
    }
  },

  /* Styles applied to the root element if `disabled={true}`. */
  disabled: {},

  /* Styles applied to the root element if keyboard focused. */
  focusVisible: {}
};
/* istanbul ignore if */

exports.styles = styles;

if (false) {
  throw new Error('Material-UI: react@16.3.0 or greater is required.');
}
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */


var ButtonBase =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ButtonBase, _React$Component);

  function ButtonBase() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, ButtonBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(ButtonBase)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.ripple = null;
    _this.keyDown = false;
    _this.button = null;
    _this.focusVisibleTimeout = null;
    _this.focusVisibleCheckTime = 50;
    _this.focusVisibleMaxCheckTimes = 5;
    _this.handleMouseDown = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'MouseDown', 'start', function () {
      clearTimeout(_this.focusVisibleTimeout);

      if (_this.state.focusVisible) {
        _this.setState({
          focusVisible: false
        });
      }
    });
    _this.handleMouseUp = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'MouseUp', 'stop');
    _this.handleMouseLeave = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'MouseLeave', 'stop', function (event) {
      if (_this.state.focusVisible) {
        event.preventDefault();
      }
    });
    _this.handleTouchStart = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'TouchStart', 'start');
    _this.handleTouchEnd = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'TouchEnd', 'stop');
    _this.handleTouchMove = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'TouchMove', 'stop');
    _this.handleBlur = (0, _createRippleHandler.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), 'Blur', 'stop', function () {
      clearTimeout(_this.focusVisibleTimeout);

      if (_this.state.focusVisible) {
        _this.setState({
          focusVisible: false
        });
      }
    });
    _this.state = {};

    _this.onRippleRef = function (node) {
      _this.ripple = node;
    };

    _this.onFocusVisibleHandler = function (event) {
      _this.keyDown = false;

      _this.setState({
        focusVisible: true
      });

      if (_this.props.onFocusVisible) {
        _this.props.onFocusVisible(event);
      }
    };

    _this.handleKeyDown = function (event) {
      var _this$props = _this.props,
          component = _this$props.component,
          focusRipple = _this$props.focusRipple,
          onKeyDown = _this$props.onKeyDown,
          onClick = _this$props.onClick;
      var key = (0, _keycode.default)(event); // Check if key is already down to avoid repeats being counted as multiple activations

      if (focusRipple && !_this.keyDown && _this.state.focusVisible && _this.ripple && key === 'space') {
        _this.keyDown = true;
        event.persist();

        _this.ripple.stop(event, function () {
          _this.ripple.start(event);
        });
      }

      if (onKeyDown) {
        onKeyDown(event);
      } // Keyboard accessibility for non interactive elements


      if (event.target === event.currentTarget && component && component !== 'button' && (key === 'space' || key === 'enter') && !(_this.button.tagName === 'A' && _this.button.href)) {
        event.preventDefault();

        if (onClick) {
          onClick(event);
        }
      }
    };

    _this.handleKeyUp = function (event) {
      if (_this.props.focusRipple && (0, _keycode.default)(event) === 'space' && _this.ripple && _this.state.focusVisible) {
        _this.keyDown = false;
        event.persist();

        _this.ripple.stop(event, function () {
          _this.ripple.pulsate(event);
        });
      }

      if (_this.props.onKeyUp) {
        _this.props.onKeyUp(event);
      }
    };

    _this.handleFocus = function (event) {
      if (_this.props.disabled) {
        return;
      } // Fix for https://github.com/facebook/react/issues/7769


      if (!_this.button) {
        _this.button = event.currentTarget;
      }

      event.persist();
      (0, _focusVisible.detectFocusVisible)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), _this.button, function () {
        _this.onFocusVisibleHandler(event);
      });

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(ButtonBase, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.button = _reactDom.default.findDOMNode(this);
      (0, _focusVisible.listenForFocusKeys)((0, _ownerWindow.default)(this.button));

      if (this.props.action) {
        this.props.action({
          focusVisible: function focusVisible() {
            _this2.setState({
              focusVisible: true
            });

            _this2.button.focus();
          }
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.focusRipple && !this.props.disableRipple && !prevState.focusVisible && this.state.focusVisible) {
        this.ripple.pulsate();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.button = null;
      clearTimeout(this.focusVisibleTimeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props2 = this.props,
          action = _this$props2.action,
          buttonRef = _this$props2.buttonRef,
          centerRipple = _this$props2.centerRipple,
          children = _this$props2.children,
          classes = _this$props2.classes,
          classNameProp = _this$props2.className,
          component = _this$props2.component,
          disabled = _this$props2.disabled,
          disableRipple = _this$props2.disableRipple,
          disableTouchRipple = _this$props2.disableTouchRipple,
          focusRipple = _this$props2.focusRipple,
          focusVisibleClassName = _this$props2.focusVisibleClassName,
          onBlur = _this$props2.onBlur,
          onFocus = _this$props2.onFocus,
          onFocusVisible = _this$props2.onFocusVisible,
          onKeyDown = _this$props2.onKeyDown,
          onKeyUp = _this$props2.onKeyUp,
          onMouseDown = _this$props2.onMouseDown,
          onMouseLeave = _this$props2.onMouseLeave,
          onMouseUp = _this$props2.onMouseUp,
          onTouchEnd = _this$props2.onTouchEnd,
          onTouchMove = _this$props2.onTouchMove,
          onTouchStart = _this$props2.onTouchStart,
          tabIndex = _this$props2.tabIndex,
          TouchRippleProps = _this$props2.TouchRippleProps,
          type = _this$props2.type,
          other = (0, _objectWithoutProperties2.default)(_this$props2, ["action", "buttonRef", "centerRipple", "children", "classes", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "onBlur", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "type"]);
      var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.focusVisible, this.state.focusVisible), (0, _defineProperty2.default)(_classNames, focusVisibleClassName, this.state.focusVisible), _classNames), classNameProp);
      var buttonProps = {};
      var ComponentProp = component;

      if (ComponentProp === 'button' && other.href) {
        ComponentProp = 'a';
      }

      if (ComponentProp === 'button') {
        buttonProps.type = type || 'button';
        buttonProps.disabled = disabled;
      } else {
        buttonProps.role = 'button';
      }

      return _react.default.createElement(ComponentProp, (0, _extends2.default)({
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        onKeyDown: this.handleKeyDown,
        onKeyUp: this.handleKeyUp,
        onMouseDown: this.handleMouseDown,
        onMouseLeave: this.handleMouseLeave,
        onMouseUp: this.handleMouseUp,
        onTouchEnd: this.handleTouchEnd,
        onTouchMove: this.handleTouchMove,
        onTouchStart: this.handleTouchStart,
        tabIndex: disabled ? '-1' : tabIndex,
        className: className,
        ref: buttonRef
      }, buttonProps, other), children, !disableRipple && !disabled ? _react.default.createElement(_TouchRipple.default, (0, _extends2.default)({
        innerRef: this.onRippleRef,
        center: centerRipple
      }, TouchRippleProps)) : null);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (typeof prevState.focusVisible === 'undefined') {
        return {
          focusVisible: false,
          lastDisabled: nextProps.disabled
        };
      } // The blur won't fire when the disabled state is set on a focused input.
      // We need to book keep the focused state manually.


      if (!prevState.prevState && nextProps.disabled && prevState.focusVisible) {
        return {
          focusVisible: false,
          lastDisabled: nextProps.disabled
        };
      }

      return {
        lastDisabled: nextProps.disabled
      };
    }
  }]);
  return ButtonBase;
}(_react.default.Component);

ButtonBase.propTypes =  false ? {
  /**
   * Callback fired when the component mounts.
   * This is useful when you want to trigger an action programmatically.
   * It currently only supports `focusVisible()` action.
   *
   * @param {object} actions This object contains all possible actions
   * that can be triggered programmatically.
   */
  action: _propTypes.default.func,

  /**
   * Use that property to pass a ref callback to the native button component.
   */
  buttonRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the ripples will be centered.
   * They won't start at the cursor interaction position.
   */
  centerRipple: _propTypes.default.bool,

  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the base button will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes.default.bool,

  /**
   * If `true`, the touch ripple effect will be disabled.
   */
  disableTouchRipple: _propTypes.default.bool,

  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * `disableRipple` must also be `false`.
   */
  focusRipple: _propTypes.default.bool,

  /**
   * This property can help a person know which element has the keyboard focus.
   * The class name will be applied when the element gain the focus through a keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible feature](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rational for using this feature [is explain here](https://github.com/WICG/focus-visible/blob/master/explainer.md).
   */
  focusVisibleClassName: _propTypes.default.string,

  /**
   * @ignore
   */
  onBlur: _propTypes.default.func,

  /**
   * @ignore
   */
  onClick: _propTypes.default.func,

  /**
   * @ignore
   */
  onFocus: _propTypes.default.func,

  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: _propTypes.default.func,

  /**
   * @ignore
   */
  onKeyDown: _propTypes.default.func,

  /**
   * @ignore
   */
  onKeyUp: _propTypes.default.func,

  /**
   * @ignore
   */
  onMouseDown: _propTypes.default.func,

  /**
   * @ignore
   */
  onMouseLeave: _propTypes.default.func,

  /**
   * @ignore
   */
  onMouseUp: _propTypes.default.func,

  /**
   * @ignore
   */
  onTouchEnd: _propTypes.default.func,

  /**
   * @ignore
   */
  onTouchMove: _propTypes.default.func,

  /**
   * @ignore
   */
  onTouchStart: _propTypes.default.func,

  /**
   * @ignore
   */
  role: _propTypes.default.string,

  /**
   * @ignore
   */
  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * Properties applied to the `TouchRipple` element.
   */
  TouchRippleProps: _propTypes.default.object,

  /**
   * Used to control the button's purpose.
   * This property passes the value to the `type` attribute of the native button component.
   * Valid property values include `button`, `submit`, and `reset`.
   */
  type: _propTypes.default.string
} : {};
ButtonBase.defaultProps = {
  centerRipple: false,
  component: 'button',
  disableRipple: false,
  disableTouchRipple: false,
  focusRipple: false,
  tabIndex: '0',
  type: 'button'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiButtonBase'
})(ButtonBase);

exports.default = _default;

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.detectFocusVisible = detectFocusVisible;
exports.listenForFocusKeys = listenForFocusKeys;

var _keycode = _interopRequireDefault(__webpack_require__(117));

var _warning = _interopRequireDefault(__webpack_require__(37));

var _ownerDocument = _interopRequireDefault(__webpack_require__(100));

var internal = {
  focusKeyPressed: false,
  keyUpEventTimeout: -1
};

function detectFocusVisible(instance, element, callback) {
  var attempt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
   false ? (0, _warning.default)(instance.focusVisibleCheckTime, 'Material-UI: missing instance.focusVisibleCheckTime.') : void 0;
   false ? (0, _warning.default)(instance.focusVisibleMaxCheckTimes, 'Material-UI: missing instance.focusVisibleMaxCheckTimes.') : void 0;
  instance.focusVisibleTimeout = setTimeout(function () {
    var doc = (0, _ownerDocument.default)(element);

    if (internal.focusKeyPressed && (doc.activeElement === element || element.contains(doc.activeElement))) {
      callback();
    } else if (attempt < instance.focusVisibleMaxCheckTimes) {
      detectFocusVisible(instance, element, callback, attempt + 1);
    }
  }, instance.focusVisibleCheckTime);
}

var FOCUS_KEYS = ['tab', 'enter', 'space', 'esc', 'up', 'down', 'left', 'right'];

function isFocusKey(event) {
  return FOCUS_KEYS.indexOf((0, _keycode.default)(event)) > -1;
}

var handleKeyUpEvent = function handleKeyUpEvent(event) {
  if (isFocusKey(event)) {
    internal.focusKeyPressed = true; // Let's consider that the user is using a keyboard during a window frame of 1s.

    clearTimeout(internal.keyUpEventTimeout);
    internal.keyUpEventTimeout = setTimeout(function () {
      internal.focusKeyPressed = false;
    }, 1e3);
  }
};

function listenForFocusKeys(win) {
  // The event listener will only be added once per window.
  // Duplicate event listeners will be ignored by addEventListener.
  // Also, this logic is client side only, we don't need a teardown.
  win.addEventListener('keyup', handleKeyUpEvent);
}

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = exports.DELAY_RIPPLE = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(222));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(145));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _reactDom = _interopRequireDefault(__webpack_require__(64));

var _TransitionGroup = _interopRequireDefault(__webpack_require__(301));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _Ripple = _interopRequireDefault(__webpack_require__(835));

var DURATION = 550;
var DELAY_RIPPLE = 80;
exports.DELAY_RIPPLE = DELAY_RIPPLE;

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'block',
      position: 'absolute',
      overflow: 'hidden',
      borderRadius: 'inherit',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      pointerEvents: 'none',
      zIndex: 0
    },

    /* Styles applied to the internal `Ripple` components `ripple` class. */
    ripple: {
      width: 50,
      height: 50,
      left: 0,
      top: 0,
      opacity: 0,
      position: 'absolute'
    },

    /* Styles applied to the internal `Ripple` components `rippleVisible` class. */
    rippleVisible: {
      opacity: 0.3,
      transform: 'scale(1)',
      animation: "mui-ripple-enter ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
    },

    /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */
    ripplePulsate: {
      animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
    },

    /* Styles applied to the internal `Ripple` components `child` class. */
    child: {
      opacity: 1,
      display: 'block',
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      backgroundColor: 'currentColor'
    },

    /* Styles applied to the internal `Ripple` components `childLeaving` class. */
    childLeaving: {
      opacity: 0,
      animation: "mui-ripple-exit ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
    },

    /* Styles applied to the internal `Ripple` components `childPulsate` class. */
    childPulsate: {
      position: 'absolute',
      left: 0,
      top: 0,
      animation: "mui-ripple-pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
    },
    '@keyframes mui-ripple-enter': {
      '0%': {
        transform: 'scale(0)',
        opacity: 0.1
      },
      '100%': {
        transform: 'scale(1)',
        opacity: 0.3
      }
    },
    '@keyframes mui-ripple-exit': {
      '0%': {
        opacity: 1
      },
      '100%': {
        opacity: 0
      }
    },
    '@keyframes mui-ripple-pulsate': {
      '0%': {
        transform: 'scale(1)'
      },
      '50%': {
        transform: 'scale(0.92)'
      },
      '100%': {
        transform: 'scale(1)'
      }
    }
  };
};

exports.styles = styles;

var TouchRipple =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(TouchRipple, _React$PureComponent);

  function TouchRipple() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, TouchRipple);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(TouchRipple)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.ignoringMouseDown = false;
    _this.startTimer = null;
    _this.startTimerCommit = null;
    _this.state = {
      // eslint-disable-next-line react/no-unused-state
      nextKey: 0,
      ripples: []
    };

    _this.pulsate = function () {
      _this.start({}, {
        pulsate: true
      });
    };

    _this.start = function () {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var cb = arguments.length > 2 ? arguments[2] : undefined;
      var _options$pulsate = options.pulsate,
          pulsate = _options$pulsate === void 0 ? false : _options$pulsate,
          _options$center = options.center,
          center = _options$center === void 0 ? _this.props.center || options.pulsate : _options$center,
          _options$fakeElement = options.fakeElement,
          fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;

      if (event.type === 'mousedown' && _this.ignoringMouseDown) {
        _this.ignoringMouseDown = false;
        return;
      }

      if (event.type === 'touchstart') {
        _this.ignoringMouseDown = true;
      }

      var element = fakeElement ? null : _reactDom.default.findDOMNode((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
      var rect = element ? element.getBoundingClientRect() : {
        width: 0,
        height: 0,
        left: 0,
        top: 0
      }; // Get the size of the ripple

      var rippleX;
      var rippleY;
      var rippleSize;

      if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
        rippleX = Math.round(rect.width / 2);
        rippleY = Math.round(rect.height / 2);
      } else {
        var clientX = event.clientX ? event.clientX : event.touches[0].clientX;
        var clientY = event.clientY ? event.clientY : event.touches[0].clientY;
        rippleX = Math.round(clientX - rect.left);
        rippleY = Math.round(clientY - rect.top);
      }

      if (center) {
        rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.

        if (rippleSize % 2 === 0) {
          rippleSize += 1;
        }
      } else {
        var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
        var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
        rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
      } // Touche devices


      if (event.touches) {
        // Prepare the ripple effect.
        _this.startTimerCommit = function () {
          _this.startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
          });
        }; // Deplay the execution of the ripple effect.


        _this.startTimer = setTimeout(function () {
          if (_this.startTimerCommit) {
            _this.startTimerCommit();

            _this.startTimerCommit = null;
          }
        }, DELAY_RIPPLE); // We have to make a tradeoff with this value.
      } else {
        _this.startCommit({
          pulsate: pulsate,
          rippleX: rippleX,
          rippleY: rippleY,
          rippleSize: rippleSize,
          cb: cb
        });
      }
    };

    _this.startCommit = function (params) {
      var pulsate = params.pulsate,
          rippleX = params.rippleX,
          rippleY = params.rippleY,
          rippleSize = params.rippleSize,
          cb = params.cb;

      _this.setState(function (state) {
        return {
          nextKey: state.nextKey + 1,
          ripples: (0, _toConsumableArray2.default)(state.ripples).concat([_react.default.createElement(_Ripple.default, {
            key: state.nextKey,
            classes: _this.props.classes,
            timeout: {
              exit: DURATION,
              enter: DURATION
            },
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize
          })])
        };
      }, cb);
    };

    _this.stop = function (event, cb) {
      clearTimeout(_this.startTimer);
      var ripples = _this.state.ripples; // The touch interaction occurs too quickly.
      // We still want to show ripple effect.

      if (event.type === 'touchend' && _this.startTimerCommit) {
        event.persist();

        _this.startTimerCommit();

        _this.startTimerCommit = null;
        _this.startTimer = setTimeout(function () {
          _this.stop(event, cb);
        }, 0);
        return;
      }

      _this.startTimerCommit = null;

      if (ripples && ripples.length) {
        _this.setState({
          ripples: ripples.slice(1)
        }, cb);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(TouchRipple, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.startTimer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          center = _this$props.center,
          classes = _this$props.classes,
          className = _this$props.className,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["center", "classes", "className"]);
      return _react.default.createElement(_TransitionGroup.default, (0, _extends2.default)({
        component: "span",
        enter: true,
        exit: true,
        className: (0, _classnames.default)(classes.root, className)
      }, other), this.state.ripples);
    }
  }]);
  return TouchRipple;
}(_react.default.PureComponent);

TouchRipple.propTypes =  false ? {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: _propTypes.default.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string
} : {};
TouchRipple.defaultProps = {
  center: false
};

var _default = (0, _withStyles.default)(styles, {
  flip: false,
  name: 'MuiTouchRipple'
})(TouchRipple);

exports.default = _default;

/***/ }),
/* 831 */
/***/ (function(module, exports) {

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

module.exports = _arrayWithoutHoles;

/***/ }),
/* 832 */
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

module.exports = _iterableToArray;

/***/ }),
/* 833 */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

module.exports = _nonIterableSpread;

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */


function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, _react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0, _react.isValidElement)(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, _react.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _Transition = _interopRequireDefault(__webpack_require__(101));

/**
 * @ignore - internal component.
 */
var Ripple =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Ripple, _React$Component);

  function Ripple() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Ripple);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Ripple)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      visible: false,
      leaving: false
    };

    _this.handleEnter = function () {
      _this.setState({
        visible: true
      });
    };

    _this.handleExit = function () {
      _this.setState({
        leaving: true
      });
    };

    return _this;
  }

  (0, _createClass2.default)(Ripple, [{
    key: "render",
    value: function render() {
      var _classNames, _classNames2;

      var _this$props = this.props,
          classes = _this$props.classes,
          classNameProp = _this$props.className,
          pulsate = _this$props.pulsate,
          rippleX = _this$props.rippleX,
          rippleY = _this$props.rippleY,
          rippleSize = _this$props.rippleSize,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["classes", "className", "pulsate", "rippleX", "rippleY", "rippleSize"]);
      var _this$state = this.state,
          visible = _this$state.visible,
          leaving = _this$state.leaving;
      var rippleClassName = (0, _classnames.default)(classes.ripple, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.rippleVisible, visible), (0, _defineProperty2.default)(_classNames, classes.ripplePulsate, pulsate), _classNames), classNameProp);
      var rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
      };
      var childClassName = (0, _classnames.default)(classes.child, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.childLeaving, leaving), (0, _defineProperty2.default)(_classNames2, classes.childPulsate, pulsate), _classNames2));
      return _react.default.createElement(_Transition.default, (0, _extends2.default)({
        onEnter: this.handleEnter,
        onExit: this.handleExit
      }, other), _react.default.createElement("span", {
        className: rippleClassName,
        style: rippleStyles
      }, _react.default.createElement("span", {
        className: childClassName
      })));
    }
  }]);
  return Ripple;
}(_react.default.Component);

Ripple.propTypes =  false ? {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: _propTypes.default.bool,

  /**
   * Diameter of the ripple.
   */
  rippleSize: _propTypes.default.number,

  /**
   * Horizontal position of the ripple center.
   */
  rippleX: _propTypes.default.number,

  /**
   * Vertical position of the ripple center.
   */
  rippleY: _propTypes.default.number
} : {};
Ripple.defaultProps = {
  pulsate: false
};
var _default = Ripple;
exports.default = _default;

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function createRippleHandler(instance, eventName, action, cb) {
  return function handleEvent(event) {
    if (cb) {
      cb.call(instance, event);
    }

    var ignore = false; // Ignore events that have been `event.preventDefault()` marked.

    if (event.defaultPrevented) {
      ignore = true;
    }

    if (instance.props.disableTouchRipple && eventName !== 'Blur') {
      ignore = true;
    }

    if (!ignore && instance.ripple) {
      instance.ripple[action](event);
    }

    if (typeof instance.props["on".concat(eventName)] === 'function') {
      instance.props["on".concat(eventName)](event);
    }

    return true;
  };
}

var _default = createRippleHandler;
exports.default = _default;

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _Typography = _interopRequireDefault(__webpack_require__(13));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    maxHeight: '2em',
    alignItems: 'center'
  },

  /* Styles applied to the root element if `position="start"`. */
  positionStart: {
    marginRight: 8
  },

  /* Styles applied to the root element if `position="end"`. */
  positionEnd: {
    marginLeft: 8
  }
};
exports.styles = styles;

function InputAdornment(props) {
  var _classNames;

  var children = props.children,
      Component = props.component,
      classes = props.classes,
      className = props.className,
      disableTypography = props.disableTypography,
      position = props.position,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "component", "classes", "className", "disableTypography", "position"]);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.positionStart, position === 'start'), (0, _defineProperty2.default)(_classNames, classes.positionEnd, position === 'end'), _classNames), className)
  }, other), typeof children === 'string' && !disableTypography ? _react.default.createElement(_Typography.default, {
    color: "textSecondary"
  }, children) : children);
}

InputAdornment.propTypes =  false ? {
  /**
   * The content of the component, normally an `IconButton` or string.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If children is a string then disable wrapping in a Typography component.
   */
  disableTypography: _propTypes.default.bool,

  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: _propTypes.default.oneOf(['start', 'end'])
} : {};
InputAdornment.defaultProps = {
  component: 'div',
  disableTypography: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiInputAdornment'
})(InputAdornment);

exports.default = _default;

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _warning = _interopRequireDefault(__webpack_require__(37));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _Input = _interopRequireDefault(__webpack_require__(76));

var _InputLabel = _interopRequireDefault(__webpack_require__(26));

var _FormControl = _interopRequireDefault(__webpack_require__(19));

var _FormHelperText = _interopRequireDefault(__webpack_require__(44));

var _Select = _interopRequireDefault(__webpack_require__(24));

// @inheritedComponent FormControl

/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 * - [FormControl](/api/form-control)
 * - [InputLabel](/api/input-label)
 * - [Input](/api/input)
 * - [FormHelperText](/api/form-helper-text)
 *
 * If you wish to alter the properties applied to the native input, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */
function TextField(props) {
  var autoComplete = props.autoComplete,
      autoFocus = props.autoFocus,
      children = props.children,
      className = props.className,
      defaultValue = props.defaultValue,
      error = props.error,
      FormHelperTextProps = props.FormHelperTextProps,
      fullWidth = props.fullWidth,
      helperText = props.helperText,
      id = props.id,
      InputLabelProps = props.InputLabelProps,
      inputProps = props.inputProps,
      InputProps = props.InputProps,
      inputRef = props.inputRef,
      label = props.label,
      multiline = props.multiline,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onFocus = props.onFocus,
      placeholder = props.placeholder,
      required = props.required,
      rows = props.rows,
      rowsMax = props.rowsMax,
      select = props.select,
      SelectProps = props.SelectProps,
      type = props.type,
      value = props.value,
      other = (0, _objectWithoutProperties2.default)(props, ["autoComplete", "autoFocus", "children", "className", "defaultValue", "error", "FormHelperTextProps", "fullWidth", "helperText", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "rowsMax", "select", "SelectProps", "type", "value"]);
   false ? (0, _warning.default)(!select || Boolean(children), 'Material-UI: `children` must be passed when using the `TextField` component with `select`.') : void 0;
  var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;

  var InputElement = _react.default.createElement(_Input.default, (0, _extends2.default)({
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    defaultValue: defaultValue,
    fullWidth: fullWidth,
    multiline: multiline,
    name: name,
    rows: rows,
    rowsMax: rowsMax,
    type: type,
    value: value,
    id: id,
    inputRef: inputRef,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    placeholder: placeholder,
    inputProps: inputProps
  }, InputProps));

  return _react.default.createElement(_FormControl.default, (0, _extends2.default)({
    "aria-describedby": helperTextId,
    className: className,
    error: error,
    fullWidth: fullWidth,
    required: required
  }, other), label && _react.default.createElement(_InputLabel.default, (0, _extends2.default)({
    htmlFor: id
  }, InputLabelProps), label), select ? _react.default.createElement(_Select.default, (0, _extends2.default)({
    value: value,
    input: InputElement
  }, SelectProps), children) : InputElement, helperText && _react.default.createElement(_FormHelperText.default, (0, _extends2.default)({
    id: helperTextId
  }, FormHelperTextProps), helperText));
}

TextField.propTypes =  false ? {
  /**
   * This property helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it here:
   * https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill
   */
  autoComplete: _propTypes.default.string,

  /**
   * If `true`, the input will be focused during the first mount.
   */
  autoFocus: _propTypes.default.bool,

  /**
   * @ignore
   */
  children: _propTypes.default.node,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The default value of the `Input` element.
   */
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * If `true`, the input will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the label will be displayed in an error state.
   */
  error: _propTypes.default.bool,

  /**
   * Properties applied to the [`FormHelperText`](/api/form-helper-text) element.
   */
  FormHelperTextProps: _propTypes.default.object,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * The helper text content.
   */
  helperText: _propTypes.default.node,

  /**
   * The id of the `input` element.
   * Use that property to make `label` and `helperText` accessible for screen readers.
   */
  id: _propTypes.default.string,

  /**
   * Properties applied to the [`InputLabel`](/api/input-label) element.
   */
  InputLabelProps: _propTypes.default.object,

  /**
   * Properties applied to the `Input` element.
   */
  InputProps: _propTypes.default.object,

  /**
   * Attributes applied to the native `input` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * The label content.
   */
  label: _propTypes.default.node,

  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   */
  margin: _propTypes.default.oneOf(['none', 'dense', 'normal']),

  /**
   * If `true`, a textarea element will be rendered instead of an input.
   */
  multiline: _propTypes.default.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: _propTypes.default.string,

  /**
   * @ignore
   */
  onBlur: _propTypes.default.func,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   */
  onChange: _propTypes.default.func,

  /**
   * @ignore
   */
  onFocus: _propTypes.default.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: _propTypes.default.string,

  /**
   * If `true`, the label is displayed as required and the input will be required.
   */
  required: _propTypes.default.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Render a `Select` element while passing the `Input` element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   */
  select: _propTypes.default.bool,

  /**
   * Properties applied to the [`Select`](/api/select) element.
   */
  SelectProps: _propTypes.default.object,

  /**
   * Type attribute of the `Input` element. It should be a valid HTML5 input type.
   */
  type: _propTypes.default.string,

  /**
   * The value of the `Input` element, required for a controlled component.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]))])
} : {};
TextField.defaultProps = {
  required: false,
  select: false
};
var _default = TextField;
exports.default = _default;

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _debounce = _interopRequireDefault(__webpack_require__(118));

var _reactEventListener = _interopRequireDefault(__webpack_require__(93));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

// < 1kb payload overhead when lodash/debounce is > 3kb.
var ROWS_HEIGHT = 19;
var styles = {
  /* Styles applied to the root element. */
  root: {
    position: 'relative',
    // because the shadow has position: 'absolute',
    width: '100%'
  },
  textarea: {
    width: '100%',
    height: '100%',
    resize: 'none',
    font: 'inherit',
    padding: 0,
    cursor: 'inherit',
    boxSizing: 'border-box',
    lineHeight: 'inherit',
    border: 'none',
    outline: 'none',
    background: 'transparent'
  },
  shadow: {
    // Overflow also needed to here to remove the extra row
    // added to textareas in Firefox.
    overflow: 'hidden',
    // Visibility needed to hide the extra text area on ipads
    visibility: 'hidden',
    position: 'absolute',
    height: 'auto',
    whiteSpace: 'pre-wrap'
  }
};
/**
 * @ignore - internal component.
 */

exports.styles = styles;

var Textarea =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Textarea, _React$Component);

  // Corresponds to 10 frames at 60 Hz.
  function Textarea(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Textarea);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Textarea).call(this));
    _this.isControlled = null;
    _this.shadowRef = null;
    _this.singlelineShadowRef = null;
    _this.inputRef = null;
    _this.value = null;
    _this.handleResize = (0, _debounce.default)(function () {
      _this.syncHeightWithShadow();
    }, 166);
    _this.state = {
      height: null
    };

    _this.handleRefInput = function (ref) {
      _this.inputRef = ref;
      var textareaRef = _this.props.textareaRef;

      if (textareaRef) {
        if (typeof textareaRef === 'function') {
          textareaRef(ref);
        } else {
          textareaRef.current = ref;
        }
      }
    };

    _this.handleRefSinglelineShadow = function (ref) {
      _this.singlelineShadowRef = ref;
    };

    _this.handleRefShadow = function (ref) {
      _this.shadowRef = ref;
    };

    _this.handleChange = function (event) {
      _this.value = event.target.value;

      if (!_this.isControlled) {
        // The component is not controlled, we need to update the shallow value.
        _this.shadowRef.value = _this.value;

        _this.syncHeightWithShadow();
      }

      if (_this.props.onChange) {
        _this.props.onChange(event);
      }
    };

    _this.isControlled = props.value != null; // <Input> expects the components it renders to respond to 'value'
    // so that it can check whether they are filled.

    _this.value = props.value || props.defaultValue || '';
    _this.state = {
      height: Number(props.rows) * ROWS_HEIGHT
    };
    return _this;
  }

  (0, _createClass2.default)(Textarea, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.syncHeightWithShadow();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.syncHeightWithShadow();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handleResize.clear();
    }
  }, {
    key: "syncHeightWithShadow",
    value: function syncHeightWithShadow() {
      var props = this.props; // Guarding for **broken** shallow rendering method that call componentDidMount
      // but doesn't handle refs correctly.
      // To remove once the shallow rendering has been fixed.

      if (!this.shadowRef) {
        return;
      }

      if (this.isControlled) {
        // The component is controlled, we need to update the shallow value.
        this.shadowRef.value = props.value == null ? '' : String(props.value);
      }

      var lineHeight = this.singlelineShadowRef.scrollHeight;
      var newHeight = this.shadowRef.scrollHeight; // Guarding for jsdom, where scrollHeight isn't present.
      // See https://github.com/tmpvar/jsdom/issues/1013

      if (newHeight === undefined) {
        return;
      }

      if (Number(props.rowsMax) >= Number(props.rows)) {
        newHeight = Math.min(Number(props.rowsMax) * lineHeight, newHeight);
      }

      newHeight = Math.max(newHeight, lineHeight); // Need a large enough different to update the height.
      // This prevents infinite rendering loop.

      if (Math.abs(this.state.height - newHeight) > 1) {
        this.setState({
          height: newHeight
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          className = _this$props.className,
          defaultValue = _this$props.defaultValue,
          onChange = _this$props.onChange,
          rows = _this$props.rows,
          rowsMax = _this$props.rowsMax,
          textareaRef = _this$props.textareaRef,
          value = _this$props.value,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["classes", "className", "defaultValue", "onChange", "rows", "rowsMax", "textareaRef", "value"]);
      return _react.default.createElement("div", {
        className: classes.root,
        style: {
          height: this.state.height
        }
      }, _react.default.createElement(_reactEventListener.default, {
        target: "window",
        onResize: this.handleResize
      }), _react.default.createElement("textarea", {
        "aria-hidden": "true",
        className: (0, _classnames.default)(classes.textarea, classes.shadow),
        readOnly: true,
        ref: this.handleRefSinglelineShadow,
        rows: "1",
        tabIndex: -1,
        value: ""
      }), _react.default.createElement("textarea", {
        "aria-hidden": "true",
        className: (0, _classnames.default)(classes.textarea, classes.shadow),
        defaultValue: defaultValue,
        readOnly: true,
        ref: this.handleRefShadow,
        rows: rows,
        tabIndex: -1,
        value: value
      }), _react.default.createElement("textarea", (0, _extends2.default)({
        rows: rows,
        className: (0, _classnames.default)(classes.textarea, className),
        defaultValue: defaultValue,
        value: value,
        onChange: this.handleChange,
        ref: this.handleRefInput
      }, other)));
    }
  }]);
  return Textarea;
}(_react.default.Component);

Textarea.propTypes =  false ? {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   */
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * @ignore
   */
  disabled: _propTypes.default.bool,

  /**
   * @ignore
   */
  onChange: _propTypes.default.func,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Use that property to pass a ref callback to the native textarea element.
   */
  textareaRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * @ignore
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
} : {};
Textarea.defaultProps = {
  rows: 1
};

var _default = (0, _withStyles.default)(styles)(Textarea);

exports.default = _default;

/***/ }),
/* 840 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(842);
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(224)["default"];
var toPrimitive = __webpack_require__(843);
function _toPropertyKey(arg) {
  var key = toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(224)["default"];
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(224)["default"];
var assertThisInitialized = __webpack_require__(845);
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return assertThisInitialized(self);
}
module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 845 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 846 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _getPrototypeOf(o);
}
module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(848);
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}
module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 848 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _setPrototypeOf(o, p);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(850);
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 850 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 851 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _extends.apply(this, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _FormLabel = _interopRequireDefault(__webpack_require__(225));

// @inheritedComponent FormLabel
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      transformOrigin: 'top left'
    },

    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {
      position: 'absolute',
      left: 0,
      top: 0,
      // slight alteration to spec spacing to match visual spec result
      transform: 'translate(0, 24px) scale(1)'
    },

    /* Styles applied to the root element if `margin="dense"`. */
    marginDense: {
      // Compensation for the `Input.inputDense` style.
      transform: 'translate(0, 21px) scale(1)'
    },

    /* Styles applied to the `input` element if `shrink={true}`. */
    shrink: {
      transform: 'translate(0, 1.5px) scale(0.75)',
      transformOrigin: 'top left'
    },

    /* Styles applied to the `input` element if `disableAnimation={false}`. */
    animated: {
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      })
    }
  };
};

exports.styles = styles;

function InputLabel(props, context) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      disableAnimation = props.disableAnimation,
      FormLabelClasses = props.FormLabelClasses,
      marginProp = props.margin,
      shrinkProp = props.shrink,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disableAnimation", "FormLabelClasses", "margin", "shrink"]);
  var muiFormControl = context.muiFormControl;
  var shrink = shrinkProp;

  if (typeof shrink === 'undefined' && muiFormControl) {
    shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
  }

  var margin = marginProp;

  if (typeof margin === 'undefined' && muiFormControl) {
    margin = muiFormControl.margin;
  }

  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.formControl, muiFormControl), (0, _defineProperty2.default)(_classNames, classes.animated, !disableAnimation), (0, _defineProperty2.default)(_classNames, classes.shrink, shrink), (0, _defineProperty2.default)(_classNames, classes.marginDense, margin === 'dense'), _classNames), classNameProp);
  return _react.default.createElement(_FormLabel.default, (0, _extends2.default)({
    "data-shrink": shrink,
    className: className,
    classes: FormLabelClasses
  }, other), children);
}

InputLabel.propTypes =  false ? {
  /**
   * The contents of the `InputLabel`.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the transition animation is disabled.
   */
  disableAnimation: _propTypes.default.bool,

  /**
   * If `true`, apply disabled class.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the label will be displayed in an error state.
   */
  error: _propTypes.default.bool,

  /**
   * If `true`, the input of this label is focused.
   */
  focused: _propTypes.default.bool,

  /**
   * `classes` property applied to the [`FormLabel`](/api/form-label) element.
   */
  FormLabelClasses: _propTypes.default.object,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: _propTypes.default.oneOf(['dense']),

  /**
   * if `true`, the label will indicate that the input is required.
   */
  required: _propTypes.default.bool,

  /**
   * If `true`, the label is shrunk.
   */
  shrink: _propTypes.default.bool
} : {};
InputLabel.defaultProps = {
  disableAnimation: false
};
InputLabel.contextTypes = {
  muiFormControl: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiInputLabel'
})(InputLabel);

exports.default = _default;

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      fontFamily: theme.typography.fontFamily,
      color: theme.palette.text.secondary,
      fontSize: theme.typography.pxToRem(16),
      lineHeight: 1,
      padding: 0,
      '&$focused': {
        color: theme.palette.primary[theme.palette.type === 'light' ? 'dark' : 'light']
      },
      '&$disabled': {
        color: theme.palette.text.disabled
      },
      '&$error': {
        color: theme.palette.error.main
      }
    },

    /* Styles applied to the root element if `focused={true}`. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the root element if `filled={true}`. */
    filled: {},

    /* Styles applied to the root element if `required={true}`. */
    required: {},
    asterisk: {
      '&$error': {
        color: theme.palette.error.main
      }
    }
  };
};

exports.styles = styles;

function FormLabel(props, context) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      disabledProp = props.disabled,
      errorProp = props.error,
      filledProp = props.filled,
      focusedProp = props.focused,
      requiredProp = props.required,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "disabled", "error", "filled", "focused", "required"]);
  var muiFormControl = context.muiFormControl;
  var disabled = disabledProp;
  var error = errorProp;
  var filled = filledProp;
  var focused = focusedProp;
  var required = requiredProp;

  if (muiFormControl) {
    if (typeof required === 'undefined') {
      required = muiFormControl.required;
    }

    if (typeof focused === 'undefined') {
      focused = muiFormControl.focused;
    }

    if (typeof disabled === 'undefined') {
      disabled = muiFormControl.disabled;
    }

    if (typeof error === 'undefined') {
      error = muiFormControl.error;
    }

    if (typeof filled === 'undefined') {
      filled = muiFormControl.filled;
    }
  }

  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.error, error), (0, _defineProperty2.default)(_classNames, classes.filled, filled), (0, _defineProperty2.default)(_classNames, classes.focused, focused), (0, _defineProperty2.default)(_classNames, classes.required, required), _classNames), classNameProp);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className
  }, other), children, required && _react.default.createElement("span", {
    className: (0, _classnames.default)(classes.asterisk, (0, _defineProperty2.default)({}, classes.error, error))
  }, "\u2009*"));
}

FormLabel.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the label should be displayed in an error state.
   */
  error: _propTypes.default.bool,

  /**
   * If `true`, the label should use filled classes key.
   */
  filled: _propTypes.default.bool,

  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: _propTypes.default.bool,

  /**
   * If `true`, the label will indicate that the input is required.
   */
  required: _propTypes.default.bool
} : {};
FormLabel.defaultProps = {
  component: 'label'
};
FormLabel.contextTypes = {
  muiFormControl: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiFormLabel'
})(FormLabel);

exports.default = _default;

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _Input = __webpack_require__(302);

var _helpers = __webpack_require__(51);

var _reactHelpers = __webpack_require__(119);

var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'inline-flex',
    flexDirection: 'column',
    position: 'relative',
    // Reset fieldset default style
    minWidth: 0,
    padding: 0,
    margin: 0,
    border: 0
  },

  /* Styles applied to the root element if `margin="normal"`. */
  marginNormal: {
    marginTop: 16,
    marginBottom: 8
  },

  /* Styles applied to the root element if `margin="dense"`. */
  marginDense: {
    marginTop: 8,
    marginBottom: 4
  },

  /* Styles applied to the root element if `fullWidth={true}`. */
  fullWidth: {
    width: '100%'
  }
};
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibilty and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 */

exports.styles = styles;

var FormControl =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(FormControl, _React$Component);

  function FormControl(props) {
    var _this;

    (0, _classCallCheck2.default)(this, FormControl);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FormControl).call(this)); // We need to iterate through the children and find the Input in order
    // to fully support server side rendering.

    _this.state = {
      adornedStart: false,
      filled: false,
      focused: false
    };

    _this.handleFocus = function () {
      _this.setState(function (state) {
        return !state.focused ? {
          focused: true
        } : null;
      });
    };

    _this.handleBlur = function () {
      _this.setState(function (state) {
        return state.focused ? {
          focused: false
        } : null;
      });
    };

    _this.handleDirty = function () {
      if (!_this.state.filled) {
        _this.setState({
          filled: true
        });
      }
    };

    _this.handleClean = function () {
      if (_this.state.filled) {
        _this.setState({
          filled: false
        });
      }
    };

    var children = props.children;

    if (children) {
      _react.default.Children.forEach(children, function (child) {
        if (!(0, _reactHelpers.isMuiElement)(child, ['Input', 'Select', 'NativeSelect'])) {
          return;
        }

        if ((0, _Input.isFilled)(child.props, true)) {
          _this.state.filled = true;
        }

        var input = (0, _reactHelpers.isMuiElement)(child, ['Select', 'NativeSelect']) ? child.props.input : child;

        if (input && (0, _Input.isAdornedStart)(input.props)) {
          _this.state.adornedStart = true;
        }
      });
    }

    return _this;
  }

  (0, _createClass2.default)(FormControl, [{
    key: "getChildContext",
    value: function getChildContext() {
      var _this$props = this.props,
          disabled = _this$props.disabled,
          error = _this$props.error,
          required = _this$props.required,
          margin = _this$props.margin;
      var _this$state = this.state,
          adornedStart = _this$state.adornedStart,
          filled = _this$state.filled,
          focused = _this$state.focused;
      return {
        muiFormControl: {
          adornedStart: adornedStart,
          disabled: disabled,
          error: error,
          filled: filled,
          focused: focused,
          margin: margin,
          onBlur: this.handleBlur,
          onEmpty: this.handleClean,
          onFilled: this.handleDirty,
          onFocus: this.handleFocus,
          required: required
        }
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props2 = this.props,
          classes = _this$props2.classes,
          className = _this$props2.className,
          Component = _this$props2.component,
          disabled = _this$props2.disabled,
          error = _this$props2.error,
          fullWidth = _this$props2.fullWidth,
          margin = _this$props2.margin,
          required = _this$props2.required,
          other = (0, _objectWithoutProperties2.default)(_this$props2, ["classes", "className", "component", "disabled", "error", "fullWidth", "margin", "required"]);
      return _react.default.createElement(Component, (0, _extends2.default)({
        className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["margin".concat((0, _helpers.capitalize)(margin))], margin !== 'none'), (0, _defineProperty2.default)(_classNames, classes.fullWidth, fullWidth), _classNames), className)
      }, other));
    }
  }]);
  return FormControl;
}(_react.default.Component);

FormControl.propTypes =  false ? {
  /**
   * The contents of the form control.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the label should be displayed in an error state.
   */
  error: _propTypes.default.bool,

  /**
   * If `true`, the component will take up the full width of its container.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   */
  margin: _propTypes.default.oneOf(['none', 'dense', 'normal']),

  /**
   * If `true`, the label will indicate that the input is required.
   */
  required: _propTypes.default.bool
} : {};
FormControl.defaultProps = {
  component: 'div',
  disabled: false,
  error: false,
  fullWidth: false,
  margin: 'none',
  required: false
};
FormControl.childContextTypes = {
  muiFormControl: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiFormControl'
})(FormControl);

exports.default = _default;

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: theme.palette.text.secondary,
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(12),
      textAlign: 'left',
      marginTop: 8,
      lineHeight: '1em',
      minHeight: '1em',
      margin: 0,
      '&$error': {
        color: theme.palette.error.main
      },
      '&$disabled': {
        color: theme.palette.text.disabled
      }
    },

    /* Styles applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `margin="dense"`. */
    marginDense: {
      marginTop: 4
    },

    /* Styles applied to the root element if `focused={true}`. */
    focused: {},

    /* Styles applied to the root element if `filled={true}`. */
    filled: {},

    /* Styles applied to the root element if `required={true}`. */
    required: {}
  };
};

exports.styles = styles;

function FormHelperText(props, context) {
  var _classNames;

  var classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      disabledProp = props.disabled,
      errorProp = props.error,
      filledProp = props.filled,
      focusedProp = props.focused,
      marginProp = props.margin,
      requiredProp = props.required,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "disabled", "error", "filled", "focused", "margin", "required"]);
  var muiFormControl = context.muiFormControl;
  var disabled = disabledProp;
  var error = errorProp;
  var filled = filledProp;
  var focused = focusedProp;
  var margin = marginProp;
  var required = requiredProp;

  if (muiFormControl) {
    if (typeof disabled === 'undefined') {
      disabled = muiFormControl.disabled;
    }

    if (typeof error === 'undefined') {
      error = muiFormControl.error;
    }

    if (typeof margin === 'undefined') {
      margin = muiFormControl.margin;
    }

    if (typeof required === 'undefined') {
      required = muiFormControl.required;
    }

    if (typeof focused === 'undefined') {
      focused = muiFormControl.focused;
    }

    if (typeof filled === 'undefined') {
      filled = muiFormControl.filled;
    }
  }

  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.error, error), (0, _defineProperty2.default)(_classNames, classes.filled, filled), (0, _defineProperty2.default)(_classNames, classes.focused, focused), (0, _defineProperty2.default)(_classNames, classes.marginDense, margin === 'dense'), (0, _defineProperty2.default)(_classNames, classes.required, required), _classNames), classNameProp);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className
  }, other));
}

FormHelperText.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: _propTypes.default.bool,

  /**
   * If `true`, the helper text should use filled classes key.
   */
  filled: _propTypes.default.bool,

  /**
   * If `true`, the helper text should use focused classes key.
   */
  focused: _propTypes.default.bool,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: _propTypes.default.oneOf(['dense']),

  /**
   * If `true`, the helper text should use required classes key.
   */
  required: _propTypes.default.bool
} : {};
FormHelperText.defaultProps = {
  component: 'p'
};
FormHelperText.contextTypes = {
  muiFormControl: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiFormHelperText'
})(FormHelperText);

exports.default = _default;

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _SelectInput = _interopRequireDefault(__webpack_require__(857));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _mergeClasses = _interopRequireDefault(__webpack_require__(449));

var _ArrowDropDown = _interopRequireDefault(__webpack_require__(474));

var _Input = _interopRequireDefault(__webpack_require__(76));

var _NativeSelect = __webpack_require__(476);

var _NativeSelectInput = _interopRequireDefault(__webpack_require__(477));

// @inheritedComponent Input
var styles = _NativeSelect.styles;
exports.styles = styles;

function Select(props) {
  var autoWidth = props.autoWidth,
      children = props.children,
      classes = props.classes,
      displayEmpty = props.displayEmpty,
      IconComponent = props.IconComponent,
      input = props.input,
      inputProps = props.inputProps,
      MenuProps = props.MenuProps,
      multiple = props.multiple,
      native = props.native,
      onClose = props.onClose,
      onOpen = props.onOpen,
      open = props.open,
      renderValue = props.renderValue,
      SelectDisplayProps = props.SelectDisplayProps,
      other = (0, _objectWithoutProperties2.default)(props, ["autoWidth", "children", "classes", "displayEmpty", "IconComponent", "input", "inputProps", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps"]);
  var inputComponent = native ? _NativeSelectInput.default : _SelectInput.default;
  return _react.default.cloneElement(input, (0, _extends2.default)({
    // Most of the logic is implemented in `SelectInput`.
    // The `Select` component is a simple API wrapper to expose something better to play with.
    inputComponent: inputComponent,
    inputProps: (0, _extends2.default)({
      children: children,
      IconComponent: IconComponent,
      type: undefined
    }, native ? {} : {
      autoWidth: autoWidth,
      displayEmpty: displayEmpty,
      MenuProps: MenuProps,
      multiple: multiple,
      onClose: onClose,
      onOpen: onOpen,
      open: open,
      renderValue: renderValue,
      SelectDisplayProps: SelectDisplayProps
    }, inputProps, {
      classes: inputProps ? (0, _mergeClasses.default)({
        baseClasses: classes,
        newClasses: inputProps.classes,
        Component: Select
      }) : classes
    }, input ? input.props.inputProps : {})
  }, other));
}

Select.propTypes =  false ? {
  /**
   * If true, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: _propTypes.default.bool,

  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * If `true`, the selected item is displayed even if its value is empty.
   * You can only use it when the `native` property is `false` (default).
   */
  displayEmpty: _propTypes.default.bool,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: _propTypes.default.element,

  /**
   * Attributes applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Properties applied to the [`Menu`](/api/menu) element.
   */
  MenuProps: _propTypes.default.object,

  /**
   * If true, `value` must be an array and the menu will support multiple selections.
   * You can only use it when the `native` property is `false` (default).
   */
  multiple: _propTypes.default.bool,

  /**
   * If `true`, the component will be using a native `select` element.
   */
  native: _propTypes.default.bool,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: _propTypes.default.func,

  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback
   */
  onOpen: _propTypes.default.func,

  /**
   * Control `select` open state.
   * You can only use it when the `native` property is `false` (default).
   */
  open: _propTypes.default.bool,

  /**
   * Render the selected value.
   * You can only use it when the `native` property is `false` (default).
   *
   * @param {*} value The `value` provided to the component.
   * @returns {ReactElement}
   */
  renderValue: _propTypes.default.func,

  /**
   * Properties applied to the clickable div element.
   */
  SelectDisplayProps: _propTypes.default.object,

  /**
   * The input value.
   * This property is required when the `native` property is `false` (default).
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]))])
} : {};
Select.defaultProps = {
  autoWidth: false,
  displayEmpty: false,
  IconComponent: _ArrowDropDown.default,
  input: _react.default.createElement(_Input.default, null),
  multiple: false,
  native: false
};
Select.muiName = 'Select';

var _default = (0, _withStyles.default)(_NativeSelect.styles, {
  name: 'MuiSelect'
})(Select);

exports.default = _default;

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(222));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _keycode = _interopRequireDefault(__webpack_require__(117));

var _warning = _interopRequireDefault(__webpack_require__(37));

var _Menu = _interopRequireDefault(__webpack_require__(467));

var _Input = __webpack_require__(302);

/**
 * @ignore - internal component.
 */
var SelectInput =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(SelectInput, _React$Component);

  function SelectInput() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, SelectInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(SelectInput)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.ignoreNextBlur = false;
    _this.displayRef = null;
    _this.isOpenControlled = _this.props.open !== undefined;
    _this.state = {
      menuMinWidth: null,
      open: false
    };

    _this.update = function (_ref) {
      var event = _ref.event,
          open = _ref.open;

      if (_this.isOpenControlled) {
        if (open) {
          _this.props.onOpen(event);
        } else {
          _this.props.onClose(event);
        }

        return;
      }

      _this.setState({
        // Perfom the layout computation outside of the render method.
        menuMinWidth: _this.props.autoWidth ? null : _this.displayRef.clientWidth,
        open: open
      });
    };

    _this.handleClick = function (event) {
      // Opening the menu is going to blur the. It will be focused back when closed.
      _this.ignoreNextBlur = true;

      _this.update({
        open: true,
        event: event
      });
    };

    _this.handleClose = function (event) {
      _this.update({
        open: false,
        event: event
      });
    };

    _this.handleItemClick = function (child) {
      return function (event) {
        if (!_this.props.multiple) {
          _this.update({
            open: false,
            event: event
          });
        }

        var _this$props = _this.props,
            onChange = _this$props.onChange,
            name = _this$props.name;

        if (onChange) {
          var value;

          if (_this.props.multiple) {
            value = Array.isArray(_this.props.value) ? (0, _toConsumableArray2.default)(_this.props.value) : [];
            var itemIndex = value.indexOf(child.props.value);

            if (itemIndex === -1) {
              value.push(child.props.value);
            } else {
              value.splice(itemIndex, 1);
            }
          } else {
            value = child.props.value;
          }

          event.persist();
          event.target = {
            value: value,
            name: name
          };
          onChange(event, child);
        }
      };
    };

    _this.handleBlur = function (event) {
      if (_this.ignoreNextBlur === true) {
        // The parent components are relying on the bubbling of the event.
        event.stopPropagation();
        _this.ignoreNextBlur = false;
        return;
      }

      if (_this.props.onBlur) {
        var _this$props2 = _this.props,
            value = _this$props2.value,
            name = _this$props2.name;
        event.persist();
        event.target = {
          value: value,
          name: name
        };

        _this.props.onBlur(event);
      }
    };

    _this.handleKeyDown = function (event) {
      if (_this.props.readOnly) {
        return;
      }

      if (['space', 'up', 'down'].indexOf((0, _keycode.default)(event)) !== -1) {
        event.preventDefault(); // Opening the menu is going to blur the. It will be focused back when closed.

        _this.ignoreNextBlur = true;

        _this.update({
          open: true,
          event: event
        });
      }
    };

    _this.handleDisplayRef = function (ref) {
      _this.displayRef = ref;
    };

    _this.handleInputRef = function (ref) {
      var inputRef = _this.props.inputRef;

      if (!inputRef) {
        return;
      }

      var nodeProxy = {
        node: ref,
        // By pass the native input as we expose a rich object (array).
        value: _this.props.value
      };

      if (typeof inputRef === 'function') {
        inputRef(nodeProxy);
      } else {
        inputRef.current = nodeProxy;
      }
    };

    return _this;
  }

  (0, _createClass2.default)(SelectInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.isOpenControlled && this.props.open) {
        // Focus the display node so the focus is restored on this element once
        // the menu is closed.
        this.displayRef.focus(); // Rerender with the resolve `displayRef` reference.

        this.forceUpdate();
      }

      if (this.props.autoFocus) {
        this.displayRef.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          autoWidth = _this$props3.autoWidth,
          children = _this$props3.children,
          classes = _this$props3.classes,
          className = _this$props3.className,
          disabled = _this$props3.disabled,
          displayEmpty = _this$props3.displayEmpty,
          IconComponent = _this$props3.IconComponent,
          inputRef = _this$props3.inputRef,
          _this$props3$MenuProp = _this$props3.MenuProps,
          MenuProps = _this$props3$MenuProp === void 0 ? {} : _this$props3$MenuProp,
          multiple = _this$props3.multiple,
          name = _this$props3.name,
          onBlur = _this$props3.onBlur,
          onChange = _this$props3.onChange,
          onClose = _this$props3.onClose,
          onFocus = _this$props3.onFocus,
          onOpen = _this$props3.onOpen,
          openProp = _this$props3.open,
          readOnly = _this$props3.readOnly,
          renderValue = _this$props3.renderValue,
          required = _this$props3.required,
          SelectDisplayProps = _this$props3.SelectDisplayProps,
          tabIndexProp = _this$props3.tabIndex,
          _this$props3$type = _this$props3.type,
          type = _this$props3$type === void 0 ? 'hidden' : _this$props3$type,
          value = _this$props3.value,
          other = (0, _objectWithoutProperties2.default)(_this$props3, ["autoWidth", "children", "classes", "className", "disabled", "displayEmpty", "IconComponent", "inputRef", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "required", "SelectDisplayProps", "tabIndex", "type", "value"]);
      var open = this.isOpenControlled && this.displayRef ? openProp : this.state.open;
      delete other['aria-invalid'];
      var display;
      var displaySingle = '';
      var displayMultiple = [];
      var computeDisplay = false; // No need to display any value if the field is empty.

      if ((0, _Input.isFilled)(this.props) || displayEmpty) {
        if (renderValue) {
          display = renderValue(value);
        } else {
          computeDisplay = true;
        }
      }

      var items = _react.default.Children.map(children, function (child) {
        if (!_react.default.isValidElement(child)) {
          return null;
        }

         false ? (0, _warning.default)(child.type !== _react.default.Fragment, ["Material-UI: the Select component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n')) : void 0;
        var selected;

        if (multiple) {
          if (!Array.isArray(value)) {
            throw new Error('Material-UI: the `value` property must be an array ' + 'when using the `Select` component with `multiple`.');
          }

          selected = value.indexOf(child.props.value) !== -1;

          if (selected && computeDisplay) {
            displayMultiple.push(child.props.children);
          }
        } else {
          selected = value === child.props.value;

          if (selected && computeDisplay) {
            displaySingle = child.props.children;
          }
        }

        return _react.default.cloneElement(child, {
          onClick: _this2.handleItemClick(child),
          role: 'option',
          selected: selected,
          value: undefined,
          // The value is most likely not a valid HTML attribute.
          'data-value': child.props.value // Instead, we provide it as a data attribute.

        });
      });

      if (computeDisplay) {
        display = multiple ? displayMultiple.join(', ') : displaySingle;
      } // Avoid performing a layout computation in the render method.


      var menuMinWidth = this.state.menuMinWidth;

      if (!autoWidth && this.isOpenControlled && this.displayRef) {
        menuMinWidth = this.displayRef.clientWidth;
      }

      var tabIndex;

      if (typeof tabIndexProp !== 'undefined') {
        tabIndex = tabIndexProp;
      } else {
        tabIndex = disabled ? null : 0;
      }

      return _react.default.createElement("div", {
        className: classes.root
      }, _react.default.createElement("div", (0, _extends2.default)({
        className: (0, _classnames.default)(classes.select, classes.selectMenu, (0, _defineProperty2.default)({}, classes.disabled, disabled), className),
        ref: this.handleDisplayRef,
        "aria-pressed": open ? 'true' : 'false',
        tabIndex: tabIndex,
        role: "button",
        "aria-owns": open ? "menu-".concat(name || '') : null,
        "aria-haspopup": "true",
        onKeyDown: this.handleKeyDown,
        onBlur: this.handleBlur,
        onClick: disabled || readOnly ? null : this.handleClick,
        onFocus: onFocus
      }, SelectDisplayProps), display || _react.default.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: '&#8203;'
        }
      })), _react.default.createElement("input", (0, _extends2.default)({
        value: Array.isArray(value) ? value.join(',') : value,
        name: name,
        ref: this.handleInputRef,
        type: type
      }, other)), _react.default.createElement(IconComponent, {
        className: classes.icon
      }), _react.default.createElement(_Menu.default, (0, _extends2.default)({
        id: "menu-".concat(name || ''),
        anchorEl: this.displayRef,
        open: open,
        onClose: this.handleClose
      }, MenuProps, {
        MenuListProps: (0, _extends2.default)({
          role: 'listbox'
        }, MenuProps.MenuListProps),
        PaperProps: (0, _extends2.default)({}, MenuProps.PaperProps, {
          style: (0, _extends2.default)({
            minWidth: menuMinWidth
          }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
        })
      }), items));
    }
  }]);
  return SelectInput;
}(_react.default.Component);

SelectInput.propTypes =  false ? {
  /**
   * @ignore
   */
  autoFocus: _propTypes.default.bool,

  /**
   * If true, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: _propTypes.default.bool,

  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The CSS class name of the select element.
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the select will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: _propTypes.default.bool,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Use that property to pass a ref callback to the native select element.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * Properties applied to the [`Menu`](/api/menu) element.
   */
  MenuProps: _propTypes.default.object,

  /**
   * If true, `value` must be an array and the menu will support multiple selections.
   */
  multiple: _propTypes.default.bool,

  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: _propTypes.default.string,

  /**
   * @ignore
   */
  onBlur: _propTypes.default.func,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   * @param {object} [child] The react element that was selected.
   */
  onChange: _propTypes.default.func,

  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes.default.func,

  /**
   * @ignore
   */
  onFocus: _propTypes.default.func,

  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback
   */
  onOpen: _propTypes.default.func,

  /**
   * Control `select` open state.
   */
  open: _propTypes.default.bool,

  /**
   * @ignore
   */
  readOnly: _propTypes.default.bool,

  /**
   * Render the selected value.
   *
   * @param {*} value The `value` provided to the component.
   * @returns {ReactElement}
   */
  renderValue: _propTypes.default.func,

  /**
   * @ignore
   */
  required: _propTypes.default.bool,

  /**
   * Properties applied to the clickable div element.
   */
  SelectDisplayProps: _propTypes.default.object,

  /**
   * @ignore
   */
  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * @ignore
   */
  type: _propTypes.default.string,

  /**
   * The input value.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]))]).isRequired
} : {};
var _default = SelectInput;
exports.default = _default;

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _reactDom = _interopRequireDefault(__webpack_require__(64));

var _warning = _interopRequireDefault(__webpack_require__(37));

var _debounce = _interopRequireDefault(__webpack_require__(118));

var _reactEventListener = _interopRequireDefault(__webpack_require__(93));

var _ownerDocument = _interopRequireDefault(__webpack_require__(100));

var _ownerWindow = _interopRequireDefault(__webpack_require__(221));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _Modal = _interopRequireDefault(__webpack_require__(108));

var _Grow = _interopRequireDefault(__webpack_require__(226));

var _Paper = _interopRequireDefault(__webpack_require__(49));

// @inheritedComponent Modal
// < 1kb payload overhead when lodash/debounce is > 3kb.
function getOffsetTop(rect, vertical) {
  var offset = 0;

  if (typeof vertical === 'number') {
    offset = vertical;
  } else if (vertical === 'center') {
    offset = rect.height / 2;
  } else if (vertical === 'bottom') {
    offset = rect.height;
  }

  return offset;
}

function getOffsetLeft(rect, horizontal) {
  var offset = 0;

  if (typeof horizontal === 'number') {
    offset = horizontal;
  } else if (horizontal === 'center') {
    offset = rect.width / 2;
  } else if (horizontal === 'right') {
    offset = rect.width;
  }

  return offset;
}

function getTransformOriginValue(transformOrigin) {
  return [transformOrigin.horizontal, transformOrigin.vertical].map(function (n) {
    return typeof n === 'number' ? "".concat(n, "px") : n;
  }).join(' ');
} // Sum the scrollTop between two elements.


function getScrollParent(parent, child) {
  var element = child;
  var scrollTop = 0;

  while (element && element !== parent) {
    element = element.parentNode;
    scrollTop += element.scrollTop;
  }

  return scrollTop;
}

function getAnchorEl(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}

var styles = {
  /* Styles applied to the `Paper` component. */
  paper: {
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 'none'
  }
};
exports.styles = styles;

var Popover =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Popover, _React$Component);

  function Popover() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Popover);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Popover)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.paperRef = null;
    _this.handleGetOffsetTop = getOffsetTop;
    _this.handleGetOffsetLeft = getOffsetLeft;
    _this.handleResize = (0, _debounce.default)(function () {
      _this.setPositioningStyles(_this.paperRef);
    }, 166);

    _this.componentWillUnmount = function () {
      _this.handleResize.clear();
    };

    _this.setPositioningStyles = function (element) {
      if (element && element.style) {
        var positioning = _this.getPositioningStyle(element);

        if (positioning.top !== null) {
          element.style.top = positioning.top;
        }

        if (positioning.left !== null) {
          element.style.left = positioning.left;
        }

        element.style.transformOrigin = positioning.transformOrigin;
      }
    };

    _this.getPositioningStyle = function (element) {
      var _this$props = _this.props,
          anchorEl = _this$props.anchorEl,
          anchorReference = _this$props.anchorReference,
          marginThreshold = _this$props.marginThreshold; // Check if the parent has requested anchoring on an inner content node

      var contentAnchorOffset = _this.getContentAnchorOffset(element);

      var elemRect = {
        width: element.clientWidth,
        height: element.clientHeight
      }; // Get the transform origin point on the element itself

      var transformOrigin = _this.getTransformOrigin(elemRect, contentAnchorOffset);

      if (anchorReference === 'none') {
        return {
          top: null,
          left: null,
          transformOrigin: getTransformOriginValue(transformOrigin)
        };
      } // Get the offset of of the anchoring element


      var anchorOffset = _this.getAnchorOffset(contentAnchorOffset); // Calculate element positioning


      var top = anchorOffset.top - transformOrigin.vertical;
      var left = anchorOffset.left - transformOrigin.horizontal;
      var bottom = top + elemRect.height;
      var right = left + elemRect.width; // Use the parent window of the anchorEl if provided

      var containerWindow = (0, _ownerWindow.default)(getAnchorEl(anchorEl)); // Window thresholds taking required margin into account

      var heightThreshold = containerWindow.innerHeight - marginThreshold;
      var widthThreshold = containerWindow.innerWidth - marginThreshold; // Check if the vertical axis needs shifting

      if (top < marginThreshold) {
        var diff = top - marginThreshold;
        top -= diff;
        transformOrigin.vertical += diff;
      } else if (bottom > heightThreshold) {
        var _diff = bottom - heightThreshold;

        top -= _diff;
        transformOrigin.vertical += _diff;
      }

       false ? (0, _warning.default)(elemRect.height < heightThreshold || !elemRect.height || !heightThreshold, ['Material-UI: the popover component is too tall.', "Some part of it can not be seen on the screen (".concat(elemRect.height - heightThreshold, "px)."), 'Please consider adding a `max-height` to improve the user-experience.'].join('\n')) : void 0; // Check if the horizontal axis needs shifting

      if (left < marginThreshold) {
        var _diff2 = left - marginThreshold;

        left -= _diff2;
        transformOrigin.horizontal += _diff2;
      } else if (right > widthThreshold) {
        var _diff3 = right - widthThreshold;

        left -= _diff3;
        transformOrigin.horizontal += _diff3;
      }

      return {
        top: "".concat(top, "px"),
        left: "".concat(left, "px"),
        transformOrigin: getTransformOriginValue(transformOrigin)
      };
    };

    _this.handleEnter = function (element) {
      if (_this.props.onEnter) {
        _this.props.onEnter(element);
      }

      _this.setPositioningStyles(element);
    };

    return _this;
  }

  (0, _createClass2.default)(Popover, [{
    key: "componentDidMount",
    // Corresponds to 10 frames at 60 Hz.
    value: function componentDidMount() {
      if (this.props.action) {
        this.props.action({
          updatePosition: this.handleResize
        });
      }
    }
  }, {
    key: "getAnchorOffset",
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    value: function getAnchorOffset(contentAnchorOffset) {
      var _this$props2 = this.props,
          anchorEl = _this$props2.anchorEl,
          anchorOrigin = _this$props2.anchorOrigin,
          anchorReference = _this$props2.anchorReference,
          anchorPosition = _this$props2.anchorPosition;

      if (anchorReference === 'anchorPosition') {
         false ? (0, _warning.default)(anchorPosition, 'Material-UI: you need to provide a `anchorPosition` property when using ' + '<Popover anchorReference="anchorPosition" />.') : void 0;
        return anchorPosition;
      } // If an anchor element wasn't provided, just use the parent body element of this Popover


      var anchorElement = getAnchorEl(anchorEl) || (0, _ownerDocument.default)(this.paperRef).body;
      var anchorRect = anchorElement.getBoundingClientRect();
      var anchorVertical = contentAnchorOffset === 0 ? anchorOrigin.vertical : 'center';
      return {
        top: anchorRect.top + this.handleGetOffsetTop(anchorRect, anchorVertical),
        left: anchorRect.left + this.handleGetOffsetLeft(anchorRect, anchorOrigin.horizontal)
      };
    } // Returns the vertical offset of inner content to anchor the transform on if provided

  }, {
    key: "getContentAnchorOffset",
    value: function getContentAnchorOffset(element) {
      var _this$props3 = this.props,
          getContentAnchorEl = _this$props3.getContentAnchorEl,
          anchorReference = _this$props3.anchorReference;
      var contentAnchorOffset = 0;

      if (getContentAnchorEl && anchorReference === 'anchorEl') {
        var contentAnchorEl = getContentAnchorEl(element);

        if (contentAnchorEl && element.contains(contentAnchorEl)) {
          var scrollTop = getScrollParent(element, contentAnchorEl);
          contentAnchorOffset = contentAnchorEl.offsetTop + contentAnchorEl.clientHeight / 2 - scrollTop || 0;
        } // != the default value


         false ? (0, _warning.default)(this.props.anchorOrigin.vertical === 'top', ['Material-UI: you can not change the default `anchorOrigin.vertical` value ', 'when also providing the `getContentAnchorEl` property to the popover component.', 'Only use one of the two properties.', 'Set `getContentAnchorEl` to `null | undefined`' + ' or leave `anchorOrigin.vertical` unchanged.'].join('\n')) : void 0;
      }

      return contentAnchorOffset;
    } // Return the base transform origin using the element
    // and taking the content anchor offset into account if in use

  }, {
    key: "getTransformOrigin",
    value: function getTransformOrigin(elemRect) {
      var contentAnchorOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var transformOrigin = this.props.transformOrigin;
      return {
        vertical: this.handleGetOffsetTop(elemRect, transformOrigin.vertical) + contentAnchorOffset,
        horizontal: this.handleGetOffsetLeft(elemRect, transformOrigin.horizontal)
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          action = _this$props4.action,
          anchorEl = _this$props4.anchorEl,
          anchorOrigin = _this$props4.anchorOrigin,
          anchorPosition = _this$props4.anchorPosition,
          anchorReference = _this$props4.anchorReference,
          children = _this$props4.children,
          classes = _this$props4.classes,
          containerProp = _this$props4.container,
          elevation = _this$props4.elevation,
          getContentAnchorEl = _this$props4.getContentAnchorEl,
          marginThreshold = _this$props4.marginThreshold,
          ModalClasses = _this$props4.ModalClasses,
          onEnter = _this$props4.onEnter,
          onEntered = _this$props4.onEntered,
          onEntering = _this$props4.onEntering,
          onExit = _this$props4.onExit,
          onExited = _this$props4.onExited,
          onExiting = _this$props4.onExiting,
          open = _this$props4.open,
          PaperProps = _this$props4.PaperProps,
          role = _this$props4.role,
          transformOrigin = _this$props4.transformOrigin,
          TransitionComponent = _this$props4.TransitionComponent,
          transitionDurationProp = _this$props4.transitionDuration,
          TransitionProps = _this$props4.TransitionProps,
          other = (0, _objectWithoutProperties2.default)(_this$props4, ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "classes", "container", "elevation", "getContentAnchorEl", "marginThreshold", "ModalClasses", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "open", "PaperProps", "role", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps"]);
      var transitionDuration = transitionDurationProp;

      if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) {
        transitionDuration = undefined;
      } // If the container prop is provided, use that
      // If the anchorEl prop is provided, use its parent body element as the container
      // If neither are provided let the Modal take care of choosing the container


      var container = containerProp || (anchorEl ? (0, _ownerDocument.default)(getAnchorEl(anchorEl)).body : undefined);
      return _react.default.createElement(_Modal.default, (0, _extends2.default)({
        classes: ModalClasses,
        container: container,
        open: open,
        BackdropProps: {
          invisible: true
        }
      }, other), _react.default.createElement(TransitionComponent, (0, _extends2.default)({
        appear: true,
        in: open,
        onEnter: this.handleEnter,
        onEntered: onEntered,
        onEntering: onEntering,
        onExit: onExit,
        onExited: onExited,
        onExiting: onExiting,
        role: role,
        timeout: transitionDuration
      }, TransitionProps), _react.default.createElement(_Paper.default, (0, _extends2.default)({
        className: classes.paper,
        elevation: elevation,
        ref: function ref(_ref) {
          _this2.paperRef = _reactDom.default.findDOMNode(_ref);
        }
      }, PaperProps), _react.default.createElement(_reactEventListener.default, {
        target: "window",
        onResize: this.handleResize
      }), children)));
    }
  }]);
  return Popover;
}(_react.default.Component);

Popover.propTypes =  false ? {
  /**
   * This is callback property. It's called by the component on mount.
   * This is useful when you want to trigger an action programmatically.
   * It currently only supports updatePosition() action.
   *
   * @param {object} actions This object contains all posible actions
   * that can be triggered programmatically.
   */
  action: _propTypes.default.func,

  /**
   * This is the DOM element, or a function that returns the DOM element,
   * that may be used to set the position of the popover.
   */
  anchorEl: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   */
  anchorOrigin: _propTypes.default.shape({
    horizontal: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['left', 'center', 'right'])]).isRequired,
    vertical: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['top', 'center', 'bottom'])]).isRequired
  }),

  /**
   * This is the position that may be used
   * to set the position of the popover.
   * The coordinates are relative to
   * the application's client area.
   */
  anchorPosition: _propTypes.default.shape({
    left: _propTypes.default.number.isRequired,
    top: _propTypes.default.number.isRequired
  }),

  /*
   * This determines which anchor prop to refer to to set
   * the position of the popover.
   */
  anchorReference: _propTypes.default.oneOf(['anchorEl', 'anchorPosition', 'none']),

  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * A node, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * The elevation of the popover.
   */
  elevation: _propTypes.default.number,

  /**
   * This function is called in order to retrieve the content anchor element.
   * It's the opposite of the `anchorEl` property.
   * The content anchor element should be an element inside the popover.
   * It's used to correctly scroll and set the position of the popover.
   * The positioning strategy tries to make the content anchor element just above the
   * anchor element.
   */
  getContentAnchorEl: _propTypes.default.func,

  /**
   * Specifies how close to the edge of the window the popover can appear.
   */
  marginThreshold: _propTypes.default.number,

  /**
   * `classes` property applied to the [`Modal`](/api/modal) element.
   */
  ModalClasses: _propTypes.default.object,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired before the component is entering.
   */
  onEnter: _propTypes.default.func,

  /**
   * Callback fired when the component has entered.
   */
  onEntered: _propTypes.default.func,

  /**
   * Callback fired when the component is entering.
   */
  onEntering: _propTypes.default.func,

  /**
   * Callback fired before the component is exiting.
   */
  onExit: _propTypes.default.func,

  /**
   * Callback fired when the component has exited.
   */
  onExited: _propTypes.default.func,

  /**
   * Callback fired when the component is exiting.
   */
  onExiting: _propTypes.default.func,

  /**
   * If `true`, the popover is visible.
   */
  open: _propTypes.default.bool.isRequired,

  /**
   * Properties applied to the [`Paper`](/api/paper) element.
   */
  PaperProps: _propTypes.default.object,

  /**
   * @ignore
   */
  role: _propTypes.default.string,

  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   */
  transformOrigin: _propTypes.default.shape({
    horizontal: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['left', 'center', 'right'])]).isRequired,
    vertical: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['top', 'center', 'bottom'])]).isRequired
  }),

  /**
   * Transition component.
   */
  TransitionComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  }), _propTypes.default.oneOf(['auto'])]),

  /**
   * Properties applied to the `Transition` element.
   */
  TransitionProps: _propTypes.default.object
} : {};
Popover.defaultProps = {
  anchorReference: 'anchorEl',
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'left'
  },
  elevation: 8,
  marginThreshold: 16,
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left'
  },
  TransitionComponent: _Grow.default,
  transitionDuration: 'auto'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiPopover'
})(Popover);

exports.default = _default;

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(145));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(64));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _warning = _interopRequireDefault(__webpack_require__(37));

var _keycode = _interopRequireDefault(__webpack_require__(117));

var _ownerDocument = _interopRequireDefault(__webpack_require__(100));

var _RootRef = _interopRequireDefault(__webpack_require__(303));

var _Portal = _interopRequireDefault(__webpack_require__(304));

var _helpers = __webpack_require__(51);

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _ModalManager = _interopRequireDefault(__webpack_require__(470));

var _Backdrop = _interopRequireDefault(__webpack_require__(472));

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom.default.findDOMNode(container) || defaultContainer;
}

function getHasTransition(props) {
  return props.children ? props.children.props.hasOwnProperty('in') : false;
}

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'fixed',
      zIndex: theme.zIndex.modal,
      right: 0,
      bottom: 0,
      top: 0,
      left: 0
    },

    /* Styles applied to the root element if the `Modal` has exited. */
    hidden: {
      visibility: 'hidden'
    }
  };
};
/* istanbul ignore if */


exports.styles = styles;

if (false) {
  throw new Error('Material-UI: react@16.3.0 or greater is required.');
}
/**
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */


var Modal =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Modal, _React$Component);

  function Modal(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Modal);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Modal).call(this));
    _this.mountNode = null;
    _this.modalRef = null;
    _this.dialogRef = null;
    _this.mounted = false;

    _this.handleRendered = function () {
      _this.autoFocus(); // Fix a bug on Chrome where the scroll isn't initially 0.


      _this.modalRef.scrollTop = 0;

      if (_this.props.onRendered) {
        _this.props.onRendered();
      }
    };

    _this.handleOpen = function () {
      var doc = (0, _ownerDocument.default)(_this.mountNode);
      var container = getContainer(_this.props.container, doc.body);

      _this.props.manager.add((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), container);

      doc.addEventListener('keydown', _this.handleDocumentKeyDown);
      doc.addEventListener('focus', _this.enforceFocus, true);
    };

    _this.handleClose = function () {
      _this.props.manager.remove((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));

      var doc = (0, _ownerDocument.default)(_this.mountNode);
      doc.removeEventListener('keydown', _this.handleDocumentKeyDown);
      doc.removeEventListener('focus', _this.enforceFocus, true);

      _this.restoreLastFocus();
    };

    _this.handleExited = function () {
      _this.setState({
        exited: true
      });

      _this.handleClose();
    };

    _this.handleBackdropClick = function (event) {
      if (event.target !== event.currentTarget) {
        return;
      }

      if (_this.props.onBackdropClick) {
        _this.props.onBackdropClick(event);
      }

      if (!_this.props.disableBackdropClick && _this.props.onClose) {
        _this.props.onClose(event, 'backdropClick');
      }
    };

    _this.handleDocumentKeyDown = function (event) {
      if (!_this.isTopModal() || (0, _keycode.default)(event) !== 'esc') {
        return;
      } // Ignore events that have been `event.preventDefault()` marked.


      if (event.defaultPrevented) {
        return;
      }

      if (_this.props.onEscapeKeyDown) {
        _this.props.onEscapeKeyDown(event);
      }

      if (!_this.props.disableEscapeKeyDown && _this.props.onClose) {
        _this.props.onClose(event, 'escapeKeyDown');
      }
    };

    _this.checkForFocus = function () {
      _this.lastFocus = (0, _ownerDocument.default)(_this.mountNode).activeElement;
    };

    _this.enforceFocus = function () {
      if (_this.props.disableEnforceFocus || !_this.mounted || !_this.isTopModal()) {
        return;
      }

      var currentActiveElement = (0, _ownerDocument.default)(_this.mountNode).activeElement;

      if (_this.dialogRef && !_this.dialogRef.contains(currentActiveElement)) {
        _this.dialogRef.focus();
      }
    };

    _this.state = {
      exited: !props.open
    };
    return _this;
  }

  (0, _createClass2.default)(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;

      if (this.props.open) {
        this.handleOpen();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.open && this.props.open) {
        this.checkForFocus();
      }

      if (prevProps.open && !this.props.open && !getHasTransition(this.props)) {
        // Otherwise handleExited will call this.
        this.handleClose();
      } else if (!prevProps.open && this.props.open) {
        this.handleOpen();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;

      if (this.props.open || getHasTransition(this.props) && !this.state.exited) {
        this.handleClose();
      }
    }
  }, {
    key: "autoFocus",
    value: function autoFocus() {
      if (this.props.disableAutoFocus) {
        return;
      }

      var currentActiveElement = (0, _ownerDocument.default)(this.mountNode).activeElement;

      if (this.dialogRef && !this.dialogRef.contains(currentActiveElement)) {
        this.lastFocus = currentActiveElement;

        if (!this.dialogRef.hasAttribute('tabIndex')) {
           false ? (0, _warning.default)(false, ['Material-UI: the modal content node does not accept focus.', 'For the benefit of assistive technologies, ' + 'the tabIndex of the node is being set to "-1".'].join('\n')) : void 0;
          this.dialogRef.setAttribute('tabIndex', -1);
        }

        this.dialogRef.focus();
      }
    }
  }, {
    key: "restoreLastFocus",
    value: function restoreLastFocus() {
      if (this.props.disableRestoreFocus) {
        return;
      }

      if (this.lastFocus) {
        // Not all elements in IE11 have a focus method.
        // Because IE11 market share is low, we accept the restore focus being broken
        // and we silent the issue.
        if (this.lastFocus.focus) {
          this.lastFocus.focus();
        }

        this.lastFocus = null;
      }
    }
  }, {
    key: "isTopModal",
    value: function isTopModal() {
      return this.props.manager.isTopModal(this);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          BackdropComponent = _this$props.BackdropComponent,
          BackdropProps = _this$props.BackdropProps,
          children = _this$props.children,
          classes = _this$props.classes,
          className = _this$props.className,
          container = _this$props.container,
          disableAutoFocus = _this$props.disableAutoFocus,
          disableBackdropClick = _this$props.disableBackdropClick,
          disableEnforceFocus = _this$props.disableEnforceFocus,
          disableEscapeKeyDown = _this$props.disableEscapeKeyDown,
          disablePortal = _this$props.disablePortal,
          disableRestoreFocus = _this$props.disableRestoreFocus,
          hideBackdrop = _this$props.hideBackdrop,
          keepMounted = _this$props.keepMounted,
          manager = _this$props.manager,
          onBackdropClick = _this$props.onBackdropClick,
          onClose = _this$props.onClose,
          onEscapeKeyDown = _this$props.onEscapeKeyDown,
          onRendered = _this$props.onRendered,
          open = _this$props.open,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["BackdropComponent", "BackdropProps", "children", "classes", "className", "container", "disableAutoFocus", "disableBackdropClick", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onEscapeKeyDown", "onRendered", "open"]);
      var exited = this.state.exited;
      var hasTransition = getHasTransition(this.props);
      var childProps = {};

      if (!keepMounted && !open && (!hasTransition || exited)) {
        return null;
      } // It's a Transition like component


      if (hasTransition) {
        childProps.onExited = (0, _helpers.createChainedFunction)(this.handleExited, children.props.onExited);
      }

      if (children.props.role === undefined) {
        childProps.role = children.props.role || 'document';
      }

      if (children.props.tabIndex === undefined) {
        childProps.tabIndex = children.props.tabIndex || '-1';
      }

      return _react.default.createElement(_Portal.default, {
        ref: function ref(_ref2) {
          _this2.mountNode = _ref2 ? _ref2.getMountNode() : _ref2;
        },
        container: container,
        disablePortal: disablePortal,
        onRendered: this.handleRendered
      }, _react.default.createElement("div", (0, _extends2.default)({
        ref: function ref(_ref) {
          _this2.modalRef = _ref;
        },
        className: (0, _classnames.default)(classes.root, className, (0, _defineProperty2.default)({}, classes.hidden, exited))
      }, other), hideBackdrop ? null : _react.default.createElement(BackdropComponent, (0, _extends2.default)({
        open: open,
        onClick: this.handleBackdropClick
      }, BackdropProps)), _react.default.createElement(_RootRef.default, {
        rootRef: function rootRef(ref) {
          _this2.dialogRef = ref;
        }
      }, _react.default.cloneElement(children, childProps))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if (nextProps.open) {
        return {
          exited: false
        };
      }

      if (!getHasTransition(nextProps)) {
        // Otherwise let handleExited take care of marking exited.
        return {
          exited: true
        };
      }

      return null;
    }
  }]);
  return Modal;
}(_react.default.Component);

Modal.propTypes =  false ? {
  /**
   * A backdrop component. This property enables custom backdrop rendering.
   */
  BackdropComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Properties applied to the [`Backdrop`](/api/backdrop) element.
   */
  BackdropProps: _propTypes.default.object,

  /**
   * A single child content element.
   */
  children: _propTypes.default.element,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * A node, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   */
  container: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */
  disableAutoFocus: _propTypes.default.bool,

  /**
   * If `true`, clicking the backdrop will not fire any callback.
   */
  disableBackdropClick: _propTypes.default.bool,

  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */
  disableEnforceFocus: _propTypes.default.bool,

  /**
   * If `true`, hitting escape will not fire any callback.
   */
  disableEscapeKeyDown: _propTypes.default.bool,

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: _propTypes.default.bool,

  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden.
   */
  disableRestoreFocus: _propTypes.default.bool,

  /**
   * If `true`, the backdrop is not rendered.
   */
  hideBackdrop: _propTypes.default.bool,

  /**
   * Always keep the children in the DOM.
   * This property can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   */
  keepMounted: _propTypes.default.bool,

  /**
   * A modal manager used to track and manage the state of open
   * Modals. This enables customizing how modals interact within a container.
   */
  manager: _propTypes.default.object,

  /**
   * Callback fired when the backdrop is clicked.
   */
  onBackdropClick: _propTypes.default.func,

  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback
   * @param {string} reason Can be:`"escapeKeyDown"`, `"backdropClick"`
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired when the escape key is pressed,
   * `disableEscapeKeyDown` is false and the modal is in focus.
   */
  onEscapeKeyDown: _propTypes.default.func,

  /**
   * Callback fired once the children has been mounted into the `container`.
   * It signals that the `open={true}` property took effect.
   */
  onRendered: _propTypes.default.func,

  /**
   * If `true`, the modal is open.
   */
  open: _propTypes.default.bool.isRequired
} : {};
Modal.defaultProps = {
  disableAutoFocus: false,
  disableBackdropClick: false,
  disableEnforceFocus: false,
  disableEscapeKeyDown: false,
  disablePortal: false,
  disableRestoreFocus: false,
  hideBackdrop: false,
  keepMounted: false,
  // Modals don't open on the server so this won't conflict with concurrent requests.
  manager: new _ModalManager.default(),
  BackdropComponent: _Backdrop.default
};

var _default = (0, _withStyles.default)(styles, {
  flip: false,
  name: 'MuiModal'
})(Modal);

exports.default = _default;

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(64));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _exactProp = _interopRequireDefault(__webpack_require__(115));

function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}
/**
 * Helper component to allow attaching a ref to a
 * wrapped element to access the underlying DOM element.
 *
 * It's highly inspired by https://github.com/facebook/react/issues/11401#issuecomment-340543801.
 * For example:
 * ```jsx
 * import React from 'react';
 * import RootRef from '@material-ui/core/RootRef';
 *
 * class MyComponent extends React.Component {
 *   constructor() {
 *     super();
 *     this.domRef = React.createRef();
 *   }
 *
 *   componentDidMount() {
 *     console.log(this.domRef.current); // DOM node
 *   }
 *
 *   render() {
 *     return (
 *       <RootRef rootRef={this.domRef}>
 *         <SomeChildComponent />
 *       </RootRef>
 *     );
 *   }
 * }
 * ```
 */


var RootRef =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(RootRef, _React$Component);

  function RootRef() {
    (0, _classCallCheck2.default)(this, RootRef);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(RootRef).apply(this, arguments));
  }

  (0, _createClass2.default)(RootRef, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      setRef(this.props.rootRef, _reactDom.default.findDOMNode(this));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.rootRef !== this.props.rootRef) {
        setRef(prevProps.rootRef, null);
        setRef(this.props.rootRef, _reactDom.default.findDOMNode(this));
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      setRef(this.props.rootRef, null);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
  return RootRef;
}(_react.default.Component);

RootRef.propTypes =  false ? {
  /**
   * The wrapped element.
   */
  children: _propTypes.default.element.isRequired,

  /**
   * Provide a way to access the DOM node of the wrapped element.
   * You can provide a callback ref or a `React.createRef()` ref.
   */
  rootRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]).isRequired
} : {};
RootRef.propTypes =  false ? (0, _exactProp.default)(RootRef.propTypes) : {};
var _default = RootRef;
exports.default = _default;

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(64));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _ownerDocument = _interopRequireDefault(__webpack_require__(100));

var _exactProp = _interopRequireDefault(__webpack_require__(115));

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom.default.findDOMNode(container) || defaultContainer;
}

function getOwnerDocument(element) {
  return (0, _ownerDocument.default)(_reactDom.default.findDOMNode(element));
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */


var Portal =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Portal, _React$Component);

  function Portal() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Portal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Portal)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.getMountNode = function () {
      return _this.mountNode;
    };

    return _this;
  }

  (0, _createClass2.default)(Portal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setMountNode(this.props.container); // Only rerender if needed

      if (!this.props.disablePortal) {
        this.forceUpdate(this.props.onRendered);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.container !== this.props.container || prevProps.disablePortal !== this.props.disablePortal) {
        this.setMountNode(this.props.container); // Only rerender if needed

        if (!this.props.disablePortal) {
          this.forceUpdate(this.props.onRendered);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mountNode = null;
    }
  }, {
    key: "setMountNode",
    value: function setMountNode(container) {
      if (this.props.disablePortal) {
        this.mountNode = _reactDom.default.findDOMNode(this).parentElement;
        return;
      }

      this.mountNode = getContainer(container, getOwnerDocument(this).body);
    }
    /**
     * @public
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          disablePortal = _this$props.disablePortal;

      if (disablePortal) {
        return children;
      }

      return this.mountNode ? _reactDom.default.createPortal(children, this.mountNode) : null;
    }
  }]);
  return Portal;
}(_react.default.Component);

Portal.propTypes =  false ? {
  /**
   * The children to render into the `container`.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * A node, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: _propTypes.default.bool,

  /**
   * Callback fired once the children has been mounted into the `container`.
   */
  onRendered: _propTypes.default.func
} : {};
Portal.defaultProps = {
  disablePortal: false
};
Portal.propTypes =  false ? (0, _exactProp.default)(Portal.propTypes) : {};
var _default = Portal;
exports.default = _default;

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(120);

exports.__esModule = true;
exports.default = style;

var _camelizeStyle = _interopRequireDefault(__webpack_require__(471));

var _hyphenateStyle = _interopRequireDefault(__webpack_require__(864));

var _getComputedStyle2 = _interopRequireDefault(__webpack_require__(866));

var _removeStyle = _interopRequireDefault(__webpack_require__(867));

var _properties = __webpack_require__(868);

var _isTransform = _interopRequireDefault(__webpack_require__(869));

function style(node, property, value) {
  var css = '';
  var transforms = '';
  var props = property;

  if (typeof property === 'string') {
    if (value === undefined) {
      return node.style[(0, _camelizeStyle.default)(property)] || (0, _getComputedStyle2.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
    } else {
      (props = {})[property] = value;
    }
  }

  Object.keys(props).forEach(function (key) {
    var value = props[key];

    if (!value && value !== 0) {
      (0, _removeStyle.default)(node, (0, _hyphenateStyle.default)(key));
    } else if ((0, _isTransform.default)(key)) {
      transforms += key + "(" + value + ") ";
    } else {
      css += (0, _hyphenateStyle.default)(key) + ": " + value + ";";
    }
  });

  if (transforms) {
    css += _properties.transform + ": " + transforms + ";";
  }

  node.style.cssText += ';' + css;
}

module.exports = exports["default"];

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = camelize;
var rHyphen = /-(.)/g;

function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}

module.exports = exports["default"];

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(120);

exports.__esModule = true;
exports.default = hyphenateStyleName;

var _hyphenate = _interopRequireDefault(__webpack_require__(865));

/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */
var msPattern = /^ms-/;

function hyphenateStyleName(string) {
  return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
}

module.exports = exports["default"];

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hyphenate;
var rUpper = /([A-Z])/g;

function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}

module.exports = exports["default"];

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(120);

exports.__esModule = true;
exports.default = _getComputedStyle;

var _camelizeStyle = _interopRequireDefault(__webpack_require__(471));

var rposition = /^(top|right|bottom|left)$/;
var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;

function _getComputedStyle(node) {
  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
  var doc = node.ownerDocument;
  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
    getPropertyValue: function getPropertyValue(prop) {
      var style = node.style;
      prop = (0, _camelizeStyle.default)(prop);
      if (prop == 'float') prop = 'styleFloat';
      var current = node.currentStyle[prop] || null;
      if (current == null && style && style[prop]) current = style[prop];

      if (rnumnonpx.test(current) && !rposition.test(prop)) {
        // Remember the original values
        var left = style.left;
        var runStyle = node.runtimeStyle;
        var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out

        if (rsLeft) runStyle.left = node.currentStyle.left;
        style.left = prop === 'fontSize' ? '1em' : current;
        current = style.pixelLeft + 'px'; // Revert the changed values

        style.left = left;
        if (rsLeft) runStyle.left = rsLeft;
      }

      return current;
    }
  };
}

module.exports = exports["default"];

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = removeStyle;

function removeStyle(node, key) {
  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
}

module.exports = exports["default"];

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(120);

exports.__esModule = true;
exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(469));

var transform = 'transform';
exports.transform = transform;
var prefix, transitionEnd, animationEnd;
exports.animationEnd = animationEnd;
exports.transitionEnd = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
exports.transitionDelay = transitionDelay;
exports.transitionTiming = transitionTiming;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
exports.animationDelay = animationDelay;
exports.animationTiming = animationTiming;
exports.animationDuration = animationDuration;
exports.animationName = animationName;

if (_inDOM.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
  exports.transform = transform = prefix + "-" + transform;
  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
  exports.animationName = animationName = prefix + "-animation-name";
  exports.animationDuration = animationDuration = prefix + "-animation-duration";
  exports.animationTiming = animationTiming = prefix + "-animation-delay";
  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
}

var _default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};
exports.default = _default;

function getTransitionProperties() {
  var style = document.createElement('div').style;
  var vendorMap = {
    O: function O(e) {
      return "o" + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return "webkit" + e;
    },
    ms: function ms(e) {
      return "MS" + e;
    }
  };
  var vendors = Object.keys(vendorMap);
  var transitionEnd, animationEnd;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + "TransitionProperty" in style) {
      prefix = "-" + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
  style = null;
  return {
    animationEnd: animationEnd,
    transitionEnd: transitionEnd,
    prefix: prefix
  };
}

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isTransform;
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;

function isTransform(property) {
  return !!(property && supportedTransforms.test(property));
}

module.exports = exports["default"];

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isBody = isBody;
exports.default = isOverflowing;

var _isWindow = _interopRequireDefault(__webpack_require__(871));

var _ownerDocument = _interopRequireDefault(__webpack_require__(100));

var _ownerWindow = _interopRequireDefault(__webpack_require__(221));

function isBody(node) {
  return node && node.tagName.toLowerCase() === 'body';
} // Do we have a scroll bar?


function isOverflowing(container) {
  var doc = (0, _ownerDocument.default)(container);
  var win = (0, _ownerWindow.default)(doc);
  /* istanbul ignore next */

  if (!(0, _isWindow.default)(doc) && !isBody(container)) {
    return container.scrollHeight > container.clientHeight;
  } // Takes in account potential non zero margin on the body.


  var style = win.getComputedStyle(doc.body);
  var marginLeft = parseInt(style.getPropertyValue('margin-left'), 10);
  var marginRight = parseInt(style.getPropertyValue('margin-right'), 10);
  return marginLeft + doc.body.clientWidth + marginRight < win.innerWidth;
}

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getWindow;

function getWindow(node) {
  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
}

module.exports = exports["default"];

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ariaHidden = ariaHidden;
exports.hideSiblings = hideSiblings;
exports.showSiblings = showSiblings;
var BLACKLIST = ['template', 'script', 'style'];

function isHidable(node) {
  return node.nodeType === 1 && BLACKLIST.indexOf(node.tagName.toLowerCase()) === -1;
}

function siblings(container, mount, callback) {
  mount = [].concat(mount); // eslint-disable-line no-param-reassign

  [].forEach.call(container.children, function (node) {
    if (mount.indexOf(node) === -1 && isHidable(node)) {
      callback(node);
    }
  });
}

function ariaHidden(show, node) {
  if (!node) {
    return;
  }

  if (show) {
    node.setAttribute('aria-hidden', 'true');
  } else {
    node.removeAttribute('aria-hidden');
  }
}

function hideSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(true, node);
  });
}

function showSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(false, node);
  });
}

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _Fade = _interopRequireDefault(__webpack_require__(305));

var styles = {
  /* Styles applied to the root element. */
  root: {
    zIndex: -1,
    position: 'fixed',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    // Remove grey highlight
    WebkitTapHighlightColor: 'transparent',
    // Disable scroll capabilities.
    touchAction: 'none'
  },

  /* Styles applied to the root element if `invisible={true}`. */
  invisible: {
    backgroundColor: 'transparent'
  }
};
exports.styles = styles;

function Backdrop(props) {
  var classes = props.classes,
      className = props.className,
      invisible = props.invisible,
      open = props.open,
      transitionDuration = props.transitionDuration,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "invisible", "open", "transitionDuration"]);
  return _react.default.createElement(_Fade.default, (0, _extends2.default)({
    appear: true,
    in: open,
    timeout: transitionDuration
  }, other), _react.default.createElement("div", {
    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.invisible, invisible), className),
    "aria-hidden": "true"
  }));
}

Backdrop.propTypes =  false ? {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   */
  invisible: _propTypes.default.bool,

  /**
   * If `true`, the backdrop is open.
   */
  open: _propTypes.default.bool.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })])
} : {};
Backdrop.defaultProps = {
  invisible: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiBackdrop'
})(Backdrop);

exports.default = _default;

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _Transition = _interopRequireDefault(__webpack_require__(101));

var _transitions = __webpack_require__(99);

var _withTheme = _interopRequireDefault(__webpack_require__(90));

var _utils = __webpack_require__(148);

// @inheritedComponent Transition
var styles = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
};
/**
 * The Fade transition is used by the [Modal](/utils/modal) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Fade =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Fade, _React$Component);

  function Fade() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Fade);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Fade)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleEnter = function (node) {
      var theme = _this.props.theme;
      (0, _utils.reflow)(node); // So the animation always start from the start.

      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'enter'
      });
      node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
      node.style.transition = theme.transitions.create('opacity', transitionProps);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    };

    _this.handleExit = function (node) {
      var theme = _this.props.theme;
      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'exit'
      });
      node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
      node.style.transition = theme.transitions.create('opacity', transitionProps);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(Fade, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          onEnter = _this$props.onEnter,
          onExit = _this$props.onExit,
          styleProp = _this$props.style,
          theme = _this$props.theme,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["children", "onEnter", "onExit", "style", "theme"]);
      var style = (0, _extends2.default)({}, styleProp, _react.default.isValidElement(children) ? children.props.style : {});
      return _react.default.createElement(_Transition.default, (0, _extends2.default)({
        appear: true,
        onEnter: this.handleEnter,
        onExit: this.handleExit
      }, other), function (state, childProps) {
        return _react.default.cloneElement(children, (0, _extends2.default)({
          style: (0, _extends2.default)({
            opacity: 0,
            willChange: 'opacity'
          }, styles[state], style)
        }, childProps));
      });
    }
  }]);
  return Fade;
}(_react.default.Component);

Fade.propTypes =  false ? {
  /**
   * A single child content element.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),

  /**
   * If `true`, the component will transition in.
   */
  in: _propTypes.default.bool,

  /**
   * @ignore
   */
  onEnter: _propTypes.default.func,

  /**
   * @ignore
   */
  onExit: _propTypes.default.func,

  /**
   * @ignore
   */
  style: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })])
} : {};
Fade.defaultProps = {
  timeout: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  }
};

var _default = (0, _withTheme.default)()(Fade);

exports.default = _default;

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _Transition = _interopRequireDefault(__webpack_require__(101));

var _withTheme = _interopRequireDefault(__webpack_require__(90));

var _utils = __webpack_require__(148);

// @inheritedComponent Transition
function getScale(value) {
  return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
}

var styles = {
  entering: {
    opacity: 1,
    transform: getScale(1)
  },
  entered: {
    opacity: 1,
    // Use translateZ to scrolling issue on Chrome.
    transform: "".concat(getScale(1), " translateZ(0)")
  }
};
/**
 * The Grow transition is used by the [Tooltip](/demos/tooltips) and
 * [Popover](/utils/popover) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Grow =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Grow, _React$Component);

  function Grow() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Grow);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Grow)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.autoTimeout = null;
    _this.timer = null;

    _this.handleEnter = function (node) {
      var _this$props = _this.props,
          theme = _this$props.theme,
          timeout = _this$props.timeout;
      (0, _utils.reflow)(node); // So the animation always start from the start.

      var _getTransitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'enter'
      }),
          transitionDuration = _getTransitionProps.duration,
          delay = _getTransitionProps.delay;

      var duration = 0;

      if (timeout === 'auto') {
        duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
        _this.autoTimeout = duration;
      } else {
        duration = transitionDuration;
      }

      node.style.transition = [theme.transitions.create('opacity', {
        duration: duration,
        delay: delay
      }), theme.transitions.create('transform', {
        duration: duration * 0.666,
        delay: delay
      })].join(',');

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    };

    _this.handleExit = function (node) {
      var _this$props2 = _this.props,
          theme = _this$props2.theme,
          timeout = _this$props2.timeout;
      var duration = 0;

      var _getTransitionProps2 = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'exit'
      }),
          transitionDuration = _getTransitionProps2.duration,
          delay = _getTransitionProps2.delay;

      if (timeout === 'auto') {
        duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
        _this.autoTimeout = duration;
      } else {
        duration = transitionDuration;
      }

      node.style.transition = [theme.transitions.create('opacity', {
        duration: duration,
        delay: delay
      }), theme.transitions.create('transform', {
        duration: duration * 0.666,
        delay: delay || duration * 0.333
      })].join(',');
      node.style.opacity = '0';
      node.style.transform = getScale(0.75);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.addEndListener = function (_, next) {
      if (_this.props.timeout === 'auto') {
        _this.timer = setTimeout(next, _this.autoTimeout || 0);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(Grow, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          onEnter = _this$props3.onEnter,
          onExit = _this$props3.onExit,
          styleProp = _this$props3.style,
          theme = _this$props3.theme,
          timeout = _this$props3.timeout,
          other = (0, _objectWithoutProperties2.default)(_this$props3, ["children", "onEnter", "onExit", "style", "theme", "timeout"]);
      var style = (0, _extends2.default)({}, styleProp, _react.default.isValidElement(children) ? children.props.style : {});
      return _react.default.createElement(_Transition.default, (0, _extends2.default)({
        appear: true,
        onEnter: this.handleEnter,
        onExit: this.handleExit,
        addEndListener: this.addEndListener,
        timeout: timeout === 'auto' ? null : timeout
      }, other), function (state, childProps) {
        return _react.default.cloneElement(children, (0, _extends2.default)({
          style: (0, _extends2.default)({
            opacity: 0,
            transform: getScale(0.75)
          }, styles[state], style)
        }, childProps));
      });
    }
  }]);
  return Grow;
}(_react.default.Component);

Grow.propTypes =  false ? {
  /**
   * A single child content element.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),

  /**
   * If `true`, show the component; triggers the enter or exit animation.
   */
  in: _propTypes.default.bool,

  /**
   * @ignore
   */
  onEnter: _propTypes.default.func,

  /**
   * @ignore
   */
  onExit: _propTypes.default.func,

  /**
   * @ignore
   */
  style: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  }), _propTypes.default.oneOf(['auto'])])
} : {};
Grow.defaultProps = {
  timeout: 'auto'
};
Grow.muiSupportAuto = true;

var _default = (0, _withTheme.default)()(Grow);

exports.default = _default;

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _warning = _interopRequireDefault(__webpack_require__(37));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var styles = function styles(theme) {
  var elevations = {};
  theme.shadows.forEach(function (shadow, index) {
    elevations["elevation".concat(index)] = {
      boxShadow: shadow
    };
  });
  return (0, _extends2.default)({
    /* Styles applied to the root element. */
    root: {
      backgroundColor: theme.palette.background.paper
    },

    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: theme.shape.borderRadius
    }
  }, elevations);
};

exports.styles = styles;

function Paper(props) {
  var classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      square = props.square,
      elevation = props.elevation,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "square", "elevation"]);
   false ? (0, _warning.default)(elevation >= 0 && elevation < 25, "Material-UI: this elevation `".concat(elevation, "` is not implemented.")) : void 0;
  var className = (0, _classnames.default)(classes.root, classes["elevation".concat(elevation)], (0, _defineProperty2.default)({}, classes.rounded, !square), classNameProp);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className
  }, other));
}

Paper.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It's accepting values between 0 and 24 inclusive.
   */
  elevation: _propTypes.default.number,

  /**
   * If `true`, rounded corners are disabled.
   */
  square: _propTypes.default.bool
} : {};
Paper.defaultProps = {
  component: 'div',
  elevation: 2,
  square: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiPaper'
})(Paper);

exports.default = _default;

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _reactDom = _interopRequireDefault(__webpack_require__(64));

var _keycode = _interopRequireDefault(__webpack_require__(117));

var _warning = _interopRequireDefault(__webpack_require__(37));

var _ownerDocument = _interopRequireDefault(__webpack_require__(100));

var _List = _interopRequireDefault(__webpack_require__(178));

// @inheritedComponent List
var MenuList =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(MenuList, _React$Component);

  function MenuList() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, MenuList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(MenuList)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.listRef = null;
    _this.selectedItemRef = null;
    _this.blurTimer = null;
    _this.state = {
      currentTabIndex: null
    };

    _this.handleBlur = function (event) {
      _this.blurTimer = setTimeout(function () {
        if (_this.listRef) {
          var list = _this.listRef;
          var currentFocus = (0, _ownerDocument.default)(list).activeElement;

          if (!list.contains(currentFocus)) {
            _this.resetTabIndex();
          }
        }
      }, 30);

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    };

    _this.handleKeyDown = function (event) {
      var list = _this.listRef;
      var key = (0, _keycode.default)(event);
      var currentFocus = (0, _ownerDocument.default)(list).activeElement;

      if ((key === 'up' || key === 'down') && (!currentFocus || currentFocus && !list.contains(currentFocus))) {
        if (_this.selectedItemRef) {
          _this.selectedItemRef.focus();
        } else {
          list.firstChild.focus();
        }
      } else if (key === 'down') {
        event.preventDefault();

        if (currentFocus.nextElementSibling) {
          currentFocus.nextElementSibling.focus();
        }
      } else if (key === 'up') {
        event.preventDefault();

        if (currentFocus.previousElementSibling) {
          currentFocus.previousElementSibling.focus();
        }
      }

      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(event, key);
      }
    };

    _this.handleItemFocus = function (event) {
      var list = _this.listRef;

      if (list) {
        for (var i = 0; i < list.children.length; i += 1) {
          if (list.children[i] === event.currentTarget) {
            _this.setTabIndex(i);

            break;
          }
        }
      }
    };

    return _this;
  }

  (0, _createClass2.default)(MenuList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.resetTabIndex();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.blurTimer);
    }
  }, {
    key: "setTabIndex",
    value: function setTabIndex(index) {
      this.setState({
        currentTabIndex: index
      });
    }
  }, {
    key: "focus",
    value: function focus() {
      var currentTabIndex = this.state.currentTabIndex;
      var list = this.listRef;

      if (!list || !list.children || !list.firstChild) {
        return;
      }

      if (currentTabIndex && currentTabIndex >= 0) {
        list.children[currentTabIndex].focus();
      } else {
        list.firstChild.focus();
      }
    }
  }, {
    key: "resetTabIndex",
    value: function resetTabIndex() {
      var list = this.listRef;
      var currentFocus = (0, _ownerDocument.default)(list).activeElement;
      var items = [];

      for (var i = 0; i < list.children.length; i += 1) {
        items.push(list.children[i]);
      }

      var currentFocusIndex = items.indexOf(currentFocus);

      if (currentFocusIndex !== -1) {
        return this.setTabIndex(currentFocusIndex);
      }

      if (this.selectedItemRef) {
        return this.setTabIndex(items.indexOf(this.selectedItemRef));
      }

      return this.setTabIndex(0);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          onBlur = _this$props.onBlur,
          onKeyDown = _this$props.onKeyDown,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className", "onBlur", "onKeyDown"]);
      return _react.default.createElement(_List.default, (0, _extends2.default)({
        role: "menu",
        ref: function ref(_ref) {
          _this2.listRef = _reactDom.default.findDOMNode(_ref);
        },
        className: className,
        onKeyDown: this.handleKeyDown,
        onBlur: this.handleBlur
      }, other), _react.default.Children.map(children, function (child, index) {
        if (!_react.default.isValidElement(child)) {
          return null;
        }

         false ? (0, _warning.default)(child.type !== _react.default.Fragment, ["Material-UI: the MenuList component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n')) : void 0;
        return _react.default.cloneElement(child, {
          tabIndex: index === _this2.state.currentTabIndex ? 0 : -1,
          ref: child.props.selected ? function (ref) {
            _this2.selectedItemRef = _reactDom.default.findDOMNode(ref);
          } : undefined,
          onFocus: _this2.handleItemFocus
        });
      }));
    }
  }]);
  return MenuList;
}(_react.default.Component);

MenuList.propTypes =  false ? {
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: _propTypes.default.node,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   */
  onBlur: _propTypes.default.func,

  /**
   * @ignore
   */
  onKeyDown: _propTypes.default.func
} : {};
var _default = MenuList;
exports.default = _default;

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var styles = {
  /* Styles applied to the root element. */
  root: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative'
  },

  /* Styles applied to the root element if `disablePadding={false}`. */
  padding: {
    paddingTop: 8,
    paddingBottom: 8
  },

  /* Styles applied to the root element if `dense={true}` & `disablePadding={false}`. */
  dense: {
    paddingTop: 4,
    paddingBottom: 4
  },

  /* Styles applied to the root element if a `subheader` is provided. */
  subheader: {
    paddingTop: 0
  }
};
exports.styles = styles;

var List =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(List, _React$Component);

  function List() {
    (0, _classCallCheck2.default)(this, List);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(List).apply(this, arguments));
  }

  (0, _createClass2.default)(List, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        dense: this.props.dense
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          children = _this$props.children,
          classes = _this$props.classes,
          classNameProp = _this$props.className,
          Component = _this$props.component,
          dense = _this$props.dense,
          disablePadding = _this$props.disablePadding,
          subheader = _this$props.subheader,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["children", "classes", "className", "component", "dense", "disablePadding", "subheader"]);
      var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.dense, dense && !disablePadding), (0, _defineProperty2.default)(_classNames, classes.padding, !disablePadding), (0, _defineProperty2.default)(_classNames, classes.subheader, subheader), _classNames), classNameProp);
      return _react.default.createElement(Component, (0, _extends2.default)({
        className: className
      }, other), subheader, children);
    }
  }]);
  return List;
}(_react.default.Component);

List.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used for
   * the list and list items. The property is available to descendant components as the
   * `dense` context.
   */
  dense: _propTypes.default.bool,

  /**
   * If `true`, vertical padding will be removed from the list.
   */
  disablePadding: _propTypes.default.bool,

  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: _propTypes.default.node
} : {};
List.defaultProps = {
  component: 'ul',
  dense: false,
  disablePadding: false
};
List.childContextTypes = {
  dense: _propTypes.default.bool
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiList'
})(List);

exports.default = _default;

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(176);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(880));

var _react = __webpack_require__(0);

var _setDisplayName = _interopRequireDefault(__webpack_require__(475));

var _wrapDisplayName = _interopRequireDefault(__webpack_require__(175));

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = (0, _react.createFactory)(BaseComponent);

    var ShouldUpdate =
    /*#__PURE__*/
    function (_Component) {
      (0, _inheritsLoose2.default)(ShouldUpdate, _Component);

      function ShouldUpdate() {
        return _Component.apply(this, arguments) || this;
      }

      var _proto = ShouldUpdate.prototype;

      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test(this.props, nextProps);
      };

      _proto.render = function render() {
        return factory(this.props);
      };

      return ShouldUpdate;
    }(_react.Component);

    if (false) {
      return (0, _setDisplayName.default)((0, _wrapDisplayName.default)(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
    }

    return ShouldUpdate;
  };
};

var _default = shouldUpdate;
exports.default = _default;

/***/ }),
/* 880 */
/***/ (function(module, exports) {

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

module.exports = _inheritsLoose;

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */

    return BaseComponent;
  };
};

var _default = setStatic;
exports.default = _default;

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(176);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _shallowEqual = _interopRequireDefault(__webpack_require__(141));

var _default = _shallowEqual.default;
exports.default = _default;

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _helpers = __webpack_require__(51);

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      userSelect: 'none',
      width: '1em',
      height: '1em',
      display: 'inline-block',
      fill: 'currentColor',
      flexShrink: 0,
      fontSize: 24,
      transition: theme.transitions.create('fill', {
        duration: theme.transitions.duration.shorter
      })
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="saction"`. */
    colorAction: {
      color: theme.palette.action.active
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `color="disabled"`. */
    colorDisabled: {
      color: theme.palette.action.disabled
    },

    /* Styles applied to the root element if `fontSize="inherit"`. */
    fontSizeInherit: {
      fontSize: 'inherit'
    }
  };
};

exports.styles = styles;

function SvgIcon(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      Component = props.component,
      fontSize = props.fontSize,
      nativeColor = props.nativeColor,
      titleAccess = props.titleAccess,
      viewBox = props.viewBox,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "component", "fontSize", "nativeColor", "titleAccess", "viewBox"]);
  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.fontSizeInherit, fontSize === 'inherit'), (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'inherit'), _classNames), classNameProp);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className,
    focusable: "false",
    viewBox: viewBox,
    color: nativeColor,
    "aria-hidden": titleAccess ? 'false' : 'true'
  }, other), children, titleAccess ? _react.default.createElement("title", null, titleAccess) : null);
}

SvgIcon.propTypes =  false ? {
  /**
   * Node passed into the SVG element.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * You can use the `nativeColor` property to apply a color attribute to the SVG element.
   */
  color: _propTypes.default.oneOf(['inherit', 'primary', 'secondary', 'action', 'error', 'disabled']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   */
  fontSize: _propTypes.default.oneOf(['inherit', 'default']),

  /**
   * Applies a color attribute to the SVG element.
   */
  nativeColor: _propTypes.default.string,

  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: _propTypes.default.string,

  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   */
  viewBox: _propTypes.default.string
} : {};
SvgIcon.defaultProps = {
  color: 'inherit',
  component: 'svg',
  fontSize: 'default',
  viewBox: '0 0 24 24'
};
SvgIcon.muiName = 'SvgIcon';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiSvgIcon'
})(SvgIcon);

exports.default = _default;

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _colorManipulator = __webpack_require__(80);

var _ButtonBase = _interopRequireDefault(__webpack_require__(92));

var _helpers = __webpack_require__(51);

// @inheritedComponent ButtonBase
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: (0, _extends2.default)({}, theme.typography.button, {
      lineHeight: '1.4em',
      // Improve readability for multiline button.
      boxSizing: 'border-box',
      minWidth: 64,
      minHeight: 36,
      padding: '8px 16px',
      borderRadius: theme.shape.borderRadius,
      color: theme.palette.text.primary,
      transition: theme.transitions.create(['background-color', 'box-shadow', 'border'], {
        duration: theme.transitions.duration.short
      }),
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        },
        '&$disabled': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    }),

    /* Styles applied to the span element that wraps the children. */
    label: {
      width: '100%',
      // assure the correct width for iOS Safari
      display: 'inherit',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    },

    /* Styles applied to the root element if `variant="text"`. */
    text: {},

    /* Styles applied to the root element if `variant="text"` and `color="primary"`. */
    textPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */
    textSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element for backwards compatibility with legacy variant naming. */
    flat: {},

    /* Styles applied to the root element for backwards compatibility with legacy variant naming. */
    flatPrimary: {},

    /* Styles applied to the root element for backwards compatibility with legacy variant naming. */
    flatSecondary: {},

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)')
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
    outlinedPrimary: {
      border: "1px solid ".concat((0, _colorManipulator.fade)(theme.palette.primary.main, 0.5)),
      '&:hover': {
        border: "1px solid ".concat(theme.palette.primary.main)
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
    outlinedSecondary: {
      border: "1px solid ".concat((0, _colorManipulator.fade)(theme.palette.secondary.main, 0.5)),
      '&:hover': {
        border: "1px solid ".concat(theme.palette.secondary.main)
      }
    },

    /* Styles applied to the root element if `variant="[contained | fab]"`. */
    contained: {
      color: theme.palette.getContrastText(theme.palette.grey[300]),
      backgroundColor: theme.palette.grey[300],
      boxShadow: theme.shadows[2],
      '&$focusVisible': {
        boxShadow: theme.shadows[6]
      },
      '&:active': {
        boxShadow: theme.shadows[8]
      },
      '&$disabled': {
        color: theme.palette.action.disabled,
        boxShadow: theme.shadows[0],
        backgroundColor: theme.palette.action.disabledBackground
      },
      '&:hover': {
        backgroundColor: theme.palette.grey.A100,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.grey[300]
        },
        '&$disabled': {
          backgroundColor: theme.palette.action.disabledBackground
        }
      }
    },

    /* Styles applied to the root element if `variant="[contained | fab]"` and `color="primary"`. */
    containedPrimary: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.primary.main
        }
      }
    },

    /* Styles applied to the root element if `variant="[contained | fab]"` and `color="secondary"`. */
    containedSecondary: {
      color: theme.palette.secondary.contrastText,
      backgroundColor: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.secondary.main
        }
      }
    },

    /* Styles applied to the root element for backwards compatibility with legacy variant naming. */
    raised: {},
    // legacy

    /* Styles applied to the root element for backwards compatibility with legacy variant naming. */
    raisedPrimary: {},
    // legacy

    /* Styles applied to the root element for backwards compatibility with legacy variant naming. */
    raisedSecondary: {},
    // legacy

    /* Styles applied to the root element if `variant="[fab | extendedFab]"`. */
    fab: {
      borderRadius: '50%',
      padding: 0,
      minWidth: 0,
      width: 56,
      height: 56,
      boxShadow: theme.shadows[6],
      '&:active': {
        boxShadow: theme.shadows[12]
      }
    },

    /* Styles applied to the root element if `variant="extendedFab"`. */
    extendedFab: {
      borderRadius: 48 / 2,
      padding: '0 16px',
      width: 'auto',
      minWidth: 48,
      height: 48
    },

    /* Styles applied to the ButtonBase root element if the button is keyboard focused. */
    focusVisible: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `size="mini"` & `variant="[fab | extendedFab]"`. */
    mini: {
      width: 40,
      height: 40
    },

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      padding: '7px 8px',
      minWidth: 64,
      minHeight: 32,
      fontSize: theme.typography.pxToRem(13)
    },

    /* Styles applied to the root element if `size="large"`. */
    sizeLarge: {
      padding: '8px 24px',
      minWidth: 112,
      minHeight: 40,
      fontSize: theme.typography.pxToRem(15)
    },

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: '100%'
    }
  };
};

exports.styles = styles;

function Button(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      disabled = props.disabled,
      disableFocusRipple = props.disableFocusRipple,
      fullWidth = props.fullWidth,
      focusVisibleClassName = props.focusVisibleClassName,
      mini = props.mini,
      size = props.size,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "disabled", "disableFocusRipple", "fullWidth", "focusVisibleClassName", "mini", "size", "variant"]);
  var fab = variant === 'fab' || variant === 'extendedFab';
  var contained = variant === 'contained' || variant === 'raised';
  var text = variant === 'text' || variant === 'flat' || variant === 'outlined';
  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.fab, fab), (0, _defineProperty2.default)(_classNames, classes.mini, fab && mini), (0, _defineProperty2.default)(_classNames, classes.extendedFab, variant === 'extendedFab'), (0, _defineProperty2.default)(_classNames, classes.text, text), (0, _defineProperty2.default)(_classNames, classes.textPrimary, text && color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.textSecondary, text && color === 'secondary'), (0, _defineProperty2.default)(_classNames, classes.flat, variant === 'text' || variant === 'flat'), (0, _defineProperty2.default)(_classNames, classes.flatPrimary, (variant === 'text' || variant === 'flat') && color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.flatSecondary, (variant === 'text' || variant === 'flat') && color === 'secondary'), (0, _defineProperty2.default)(_classNames, classes.contained, contained || fab), (0, _defineProperty2.default)(_classNames, classes.containedPrimary, (contained || fab) && color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.containedSecondary, (contained || fab) && color === 'secondary'), (0, _defineProperty2.default)(_classNames, classes.raised, contained || fab), (0, _defineProperty2.default)(_classNames, classes.raisedPrimary, (contained || fab) && color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.raisedSecondary, (contained || fab) && color === 'secondary'), (0, _defineProperty2.default)(_classNames, classes.outlined, variant === 'outlined'), (0, _defineProperty2.default)(_classNames, classes.outlinedPrimary, variant === 'outlined' && color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.outlinedSecondary, variant === 'outlined' && color === 'secondary'), (0, _defineProperty2.default)(_classNames, classes["size".concat((0, _helpers.capitalize)(size))], size !== 'medium'), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.fullWidth, fullWidth), (0, _defineProperty2.default)(_classNames, classes.colorInherit, color === 'inherit'), _classNames), classNameProp);
  return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
    className: className,
    disabled: disabled,
    focusRipple: !disableFocusRipple,
    focusVisibleClassName: (0, _classnames.default)(classes.focusVisible, focusVisibleClassName)
  }, other), _react.default.createElement("span", {
    className: classes.label
  }, children));
}

Button.propTypes =  false ? {
  /**
   * The content of the button.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the button will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the  keyboard focus ripple will be disabled.
   * `disableRipple` must also be true.
   */
  disableFocusRipple: _propTypes.default.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes.default.bool,

  /**
   * @ignore
   */
  focusVisibleClassName: _propTypes.default.string,

  /**
   * If `true`, the button will take up the full width of its container.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: _propTypes.default.string,

  /**
   * If `true`, and `variant` is `'fab'`, will use mini floating action button styling.
   */
  mini: _propTypes.default.bool,

  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),

  /**
   * @ignore
   */
  type: _propTypes.default.string,

  /**
   * The variant to use.
   */
  variant: _propTypes.default.oneOf(['text', 'flat', 'outlined', 'contained', 'raised', 'fab', 'extendedFab'])
} : {};
Button.defaultProps = {
  color: 'default',
  component: 'button',
  disabled: false,
  disableFocusRipple: false,
  fullWidth: false,
  mini: false,
  size: 'medium',
  type: 'button',
  variant: 'text'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiButton'
})(Button);

exports.default = _default;

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _helpers = __webpack_require__(51);

var _Modal = _interopRequireDefault(__webpack_require__(108));

var _Fade = _interopRequireDefault(__webpack_require__(305));

var _transitions = __webpack_require__(99);

var _Paper = _interopRequireDefault(__webpack_require__(49));

// @inheritedComponent Modal
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {},

    /* Styles applied to the root element if `scroll="paper"`. */
    scrollPaper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },

    /* Styles applied to the root element if `scroll="bodyr"`. */
    scrollBody: {
      overflowY: 'auto',
      overflowX: 'hidden'
    },

    /* Styles applied to the `Paper` component. */
    paper: {
      display: 'flex',
      flexDirection: 'column',
      margin: 48,
      position: 'relative',
      overflowY: 'auto',
      // Fix IE11 issue, to remove at some point.
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 'none'
    },

    /* Styles applied to the `Paper` component if `scroll="paper"`. */
    paperScrollPaper: {
      flex: '0 1 auto',
      maxHeight: 'calc(100% - 96px)'
    },

    /* Styles applied to the `Paper` component if `scroll="body"`. */
    paperScrollBody: {
      margin: '48px auto'
    },

    /* Styles applied to the `Paper` component if `maxWidth="xs"`. */
    paperWidthXs: {
      maxWidth: Math.max(theme.breakpoints.values.xs, 360),
      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 360) + 48 * 2), {
        margin: 48
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="sm"`. */
    paperWidthSm: {
      maxWidth: theme.breakpoints.values.sm,
      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(theme.breakpoints.values.sm + 48 * 2), {
        margin: 48
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="md"`. */
    paperWidthMd: {
      maxWidth: theme.breakpoints.values.md,
      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(theme.breakpoints.values.md + 48 * 2), {
        margin: 48
      })
    },

    /* Styles applied to the `Paper` component if `fullWidth={true}`. */
    paperFullWidth: {
      width: '100%'
    },

    /* Styles applied to the `Paper` component if `fullScreen={true}`. */
    paperFullScreen: {
      margin: 0,
      width: '100%',
      maxWidth: '100%',
      height: '100%',
      maxHeight: 'none',
      borderRadius: 0
    }
  };
};
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */


exports.styles = styles;

function Dialog(props) {
  var _classNames;

  var BackdropProps = props.BackdropProps,
      children = props.children,
      classes = props.classes,
      className = props.className,
      disableBackdropClick = props.disableBackdropClick,
      disableEscapeKeyDown = props.disableEscapeKeyDown,
      fullScreen = props.fullScreen,
      fullWidth = props.fullWidth,
      maxWidth = props.maxWidth,
      onBackdropClick = props.onBackdropClick,
      onClose = props.onClose,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onEscapeKeyDown = props.onEscapeKeyDown,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      open = props.open,
      PaperProps = props.PaperProps,
      scroll = props.scroll,
      TransitionComponent = props.TransitionComponent,
      transitionDuration = props.transitionDuration,
      TransitionProps = props.TransitionProps,
      other = (0, _objectWithoutProperties2.default)(props, ["BackdropProps", "children", "classes", "className", "disableBackdropClick", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClose", "onEnter", "onEntered", "onEntering", "onEscapeKeyDown", "onExit", "onExited", "onExiting", "open", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps"]);
  return _react.default.createElement(_Modal.default, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, classes["scroll".concat((0, _helpers.capitalize)(scroll))], className),
    BackdropProps: (0, _extends2.default)({
      transitionDuration: transitionDuration
    }, BackdropProps),
    disableBackdropClick: disableBackdropClick,
    disableEscapeKeyDown: disableEscapeKeyDown,
    onBackdropClick: onBackdropClick,
    onEscapeKeyDown: onEscapeKeyDown,
    onClose: onClose,
    open: open,
    role: "dialog"
  }, other), _react.default.createElement(TransitionComponent, (0, _extends2.default)({
    appear: true,
    in: open,
    timeout: transitionDuration,
    onEnter: onEnter,
    onEntering: onEntering,
    onEntered: onEntered,
    onExit: onExit,
    onExiting: onExiting,
    onExited: onExited
  }, TransitionProps), _react.default.createElement(_Paper.default, (0, _extends2.default)({
    elevation: 24,
    className: (0, _classnames.default)(classes.paper, classes["paperScroll".concat((0, _helpers.capitalize)(scroll))], (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["paperWidth".concat(maxWidth ? (0, _helpers.capitalize)(maxWidth) : '')], maxWidth), (0, _defineProperty2.default)(_classNames, classes.paperFullScreen, fullScreen), (0, _defineProperty2.default)(_classNames, classes.paperFullWidth, fullWidth), _classNames))
  }, PaperProps), children)));
}

Dialog.propTypes =  false ? {
  /**
   * @ignore
   */
  BackdropProps: _propTypes.default.object,

  /**
   * Dialog children, usually the included sub-components.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, clicking the backdrop will not fire the `onClose` callback.
   */
  disableBackdropClick: _propTypes.default.bool,

  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   */
  disableEscapeKeyDown: _propTypes.default.bool,

  /**
   * If `true`, the dialog will be full-screen
   */
  fullScreen: _propTypes.default.bool,

  /**
   * If `true`, the dialog stretches to `maxWidth`.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * Determine the max width of the dialog.
   * The dialog width grows with the size of the screen, this property is useful
   * on the desktop where you might need some coherent different width size across your
   * application. Set to `false` to disable `maxWidth`.
   */
  maxWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', false]),

  /**
   * Callback fired when the backdrop is clicked.
   */
  onBackdropClick: _propTypes.default.func,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired before the dialog enters.
   */
  onEnter: _propTypes.default.func,

  /**
   * Callback fired when the dialog has entered.
   */
  onEntered: _propTypes.default.func,

  /**
   * Callback fired when the dialog is entering.
   */
  onEntering: _propTypes.default.func,

  /**
   * Callback fired when the escape key is pressed,
   * `disableKeyboard` is false and the modal is in focus.
   */
  onEscapeKeyDown: _propTypes.default.func,

  /**
   * Callback fired before the dialog exits.
   */
  onExit: _propTypes.default.func,

  /**
   * Callback fired when the dialog has exited.
   */
  onExited: _propTypes.default.func,

  /**
   * Callback fired when the dialog is exiting.
   */
  onExiting: _propTypes.default.func,

  /**
   * If `true`, the Dialog is open.
   */
  open: _propTypes.default.bool.isRequired,

  /**
   * Properties applied to the [`Paper`](/api/paper) element.
   */
  PaperProps: _propTypes.default.object,

  /**
   * Determine the container for scrolling the dialog.
   */
  scroll: _propTypes.default.oneOf(['body', 'paper']),

  /**
   * Transition component.
   */
  TransitionComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })]),

  /**
   * Properties applied to the `Transition` element.
   */
  TransitionProps: _propTypes.default.object
} : {};
Dialog.defaultProps = {
  disableBackdropClick: false,
  disableEscapeKeyDown: false,
  fullScreen: false,
  fullWidth: false,
  maxWidth: 'sm',
  scroll: 'paper',
  TransitionComponent: _Fade.default,
  transitionDuration: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  }
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiDialog'
})(Dialog);

exports.default = _default;

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _reactHelpers = __webpack_require__(119);

__webpack_require__(8);

// So we don't have any override priority issue.
var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flex: '0 0 auto',
    margin: '8px 4px'
  },

  /* Styles applied to the children. */
  action: {
    margin: '0 4px'
  }
};
exports.styles = styles;

function DialogActions(props) {
  var disableActionSpacing = props.disableActionSpacing,
      children = props.children,
      classes = props.classes,
      className = props.className,
      other = (0, _objectWithoutProperties2.default)(props, ["disableActionSpacing", "children", "classes", "className"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, other), disableActionSpacing ? children : (0, _reactHelpers.cloneChildrenWithClassName)(children, classes.action));
}

DialogActions.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the dialog actions do not have additional margin.
   */
  disableActionSpacing: _propTypes.default.bool
} : {};
DialogActions.defaultProps = {
  disableActionSpacing: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiDialogActions'
})(DialogActions);

exports.default = _default;

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var styles = {
  /* Styles applied to the root element. */
  root: {
    flex: '1 1 auto',
    overflowY: 'auto',
    WebkitOverflowScrolling: 'touch',
    // Add iOS momentum scrolling.
    padding: '0 24px 24px',
    '&:first-child': {
      paddingTop: 24
    }
  }
};
exports.styles = styles;

function DialogContent(props) {
  var classes = props.classes,
      children = props.children,
      className = props.className,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "children", "className"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, other), children);
}

DialogContent.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string
} : {};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiDialogContent'
})(DialogContent);

exports.default = _default;

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center'
    },

    /* Styles applied to the root element if `disableGutters={false}`. */
    gutters: theme.mixins.gutters(),

    /* Styles applied to the root element if `variant="regular"`. */
    regular: theme.mixins.toolbar,

    /* Styles applied to the root element if `variant="dense"`. */
    dense: {
      minHeight: 48
    }
  };
};

exports.styles = styles;

function Toolbar(props) {
  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      disableGutters = props.disableGutters,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disableGutters", "variant"]);
  var className = (0, _classnames.default)(classes.root, classes[variant], (0, _defineProperty2.default)({}, classes.gutters, !disableGutters), classNameProp);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: className
  }, other), children);
}

Toolbar.propTypes =  false ? {
  /**
   * Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, disables gutter padding.
   */
  disableGutters: _propTypes.default.bool,

  /**
   * The variant to use.
   */
  variant: _propTypes.default.oneOf(['regular', 'dense'])
} : {};
Toolbar.defaultProps = {
  disableGutters: false,
  variant: 'regular'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiToolbar'
})(Toolbar);

exports.default = _default;

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransition = _interopRequireDefault(__webpack_require__(890));

var _ReplaceTransition = _interopRequireDefault(__webpack_require__(894));

var _TransitionGroup = _interopRequireDefault(__webpack_require__(301));

var _Transition = _interopRequireDefault(__webpack_require__(101));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Transition: _Transition.default,
  TransitionGroup: _TransitionGroup.default,
  ReplaceTransition: _ReplaceTransition.default,
  CSSTransition: _CSSTransition.default
};

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(3));

var _addClass = _interopRequireDefault(__webpack_require__(891));

var _removeClass = _interopRequireDefault(__webpack_require__(893));

var _react = _interopRequireDefault(__webpack_require__(0));

var _Transition = _interopRequireDefault(__webpack_require__(101));

var _PropTypes = __webpack_require__(466);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass.default)(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass.default)(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
 * using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity: 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**.
 */


var CSSTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');

      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node, appearing);
      }
    };

    _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node, appearing);
      }
    };

    _this.onEntered = function (node, appearing) {
      var appearClassName = _this.getClassNames('appear').doneClassName;

      var enterClassName = _this.getClassNames('enter').doneClassName;

      var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');

      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node, appearing);
      }
    };

    _this.onExit = function (node) {
      var _this$getClassNames3 = _this.getClassNames('exit'),
          className = _this$getClassNames3.className;

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.onExiting = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames4.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    };

    _this.onExited = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames5.doneClassName;

      _this.removeClasses(node, 'exit');

      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + '-' : '';
      var className = isStringClassNames ? prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? className + '-active' : classNames[type + 'Active'];
      var doneClassName = isStringClassNames ? className + '-done' : classNames[type + 'Done'];
      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$getClassNames6 = this.getClassNames(type),
        className = _this$getClassNames6.className,
        activeClassName = _this$getClassNames6.activeClassName,
        doneClassName = _this$getClassNames6.doneClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
    doneClassName && removeClass(node, doneClassName);
  };

  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    if (className) {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
      /* eslint-enable no-unused-expressions */

      addClass(node, className);
    }
  };

  _proto.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;
    return _react.default.createElement(_Transition.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react.default.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
  /**
   * The animation classNames applied to the component as it enters, exits or
   * has finished the transition. A single name can be provided and it will be
   * suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
   * `fade-enter-done`, `fade-exit`, `fade-exit-active`, `fade-exit-done`,
   * `fade-appear`, `fade-appear-active`, and `fade-appear-done`.
   *
   * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
   * This allows you to define different behavior for when appearing is done and
   * when regular entering is done, using selectors like
   * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
   * epic entrance animation when element first appears in the DOM using
   * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   * simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
var _default = CSSTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(120);

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(892));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = __webpack_require__(64);

var _TransitionGroup = _interopRequireDefault(__webpack_require__(301));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */
var ReplaceTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.handleLifecycle('onEnter', 0, args);
    };

    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.handleLifecycle('onEntering', 0, args);
    };

    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.handleLifecycle('onEntered', 0, args);
    };

    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.handleLifecycle('onExit', 1, args);
    };

    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return _this.handleLifecycle('onExiting', 1, args);
    };

    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return _this.handleLifecycle('onExited', 1, args);
    };

    return _this;
  }

  var _proto = ReplaceTransition.prototype;

  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;

    var child = _react.default.Children.toArray(children)[idx];

    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        inProp = _this$props.in,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);

    var _React$Children$toArr = _react.default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : _react.default.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };

  return ReplaceTransition;
}(_react.default.Component);

ReplaceTransition.propTypes =  false ? {
  in: _propTypes.default.bool.isRequired,
  children: function children(props, propName) {
    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
    return null;
  }
} : {};
var _default = ReplaceTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _extends3 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _ButtonBase = _interopRequireDefault(__webpack_require__(92));

var _helpers = __webpack_require__(51);

var _unsupportedProp = _interopRequireDefault(__webpack_require__(306));

// @inheritedComponent ButtonBase
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: (0, _extends3.default)({}, theme.typography.button, (0, _defineProperty2.default)({
      maxWidth: 264,
      position: 'relative',
      minWidth: 72,
      padding: 0,
      minHeight: 48,
      flexShrink: 0,
      overflow: 'hidden'
    }, theme.breakpoints.up('md'), {
      minWidth: 160
    })),

    /* Styles applied to the root element if both `icon` and `label` are provided. */
    labelIcon: {
      minHeight: 72
    },

    /* Styles applied to the root element if `textColor="inherit"`. */
    textColorInherit: {
      color: 'inherit',
      opacity: 0.7,
      '&$selected': {
        opacity: 1
      },
      '&$disabled': {
        opacity: 0.4
      }
    },

    /* Styles applied to the root element if `textColor="primary"`. */
    textColorPrimary: {
      color: theme.palette.text.secondary,
      '&$selected': {
        color: theme.palette.primary.main
      },
      '&$disabled': {
        color: theme.palette.text.disabled
      }
    },

    /* Styles applied to the root element if `textColor="secondary"`. */
    textColorSecondary: {
      color: theme.palette.text.secondary,
      '&$selected': {
        color: theme.palette.secondary.main
      },
      '&$disabled': {
        color: theme.palette.text.disabled
      }
    },

    /* Styles applied to the root element if `selected={true}` (controlled by the Tabs component). */
    selected: {},

    /* Styles applied to the root element if `disabled={true}` (controlled by the Tabs component). */
    disabled: {},

    /* Styles applied to the root element if `fullWidth={true}` (controlled by the Tabs component). */
    fullWidth: {
      flexShrink: 1,
      flexGrow: 1,
      maxWidth: 'none'
    },

    /* Styles applied to the `icon` and `label`'s wrapper element. */
    wrapper: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      flexDirection: 'column'
    },

    /* Styles applied to the label container element if `label` is provided. */
    labelContainer: (0, _defineProperty2.default)({
      paddingTop: 6,
      paddingBottom: 6,
      paddingLeft: 12,
      paddingRight: 12
    }, theme.breakpoints.up('md'), {
      paddingLeft: 24,
      paddingRight: 24
    }),

    /* Styles applied to the label wrapper element if `label` is provided. */
    label: (0, _defineProperty2.default)({
      fontSize: theme.typography.pxToRem(14),
      whiteSpace: 'normal'
    }, theme.breakpoints.up('md'), {
      fontSize: theme.typography.pxToRem(13)
    }),

    /* Styles applied to the label wrapper element if `label` is provided and the text is wrapped. */
    labelWrapped: (0, _defineProperty2.default)({}, theme.breakpoints.down('sm'), {
      fontSize: theme.typography.pxToRem(12)
    })
  };
};

exports.styles = styles;

var Tab =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Tab, _React$Component);

  function Tab() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Tab);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Tab)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.label = null;
    _this.state = {
      labelWrapped: false
    };

    _this.handleChange = function (event) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          value = _this$props.value,
          onClick = _this$props.onClick;

      if (onChange) {
        onChange(event, value);
      }

      if (onClick) {
        onClick(event);
      }
    };

    _this.checkTextWrap = function () {
      if (_this.labelRef) {
        var labelWrapped = _this.labelRef.getClientRects().length > 1;

        if (_this.state.labelWrapped !== labelWrapped) {
          _this.setState({
            labelWrapped: labelWrapped
          });
        }
      }
    };

    return _this;
  }

  (0, _createClass2.default)(Tab, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.checkTextWrap();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.labelWrapped === prevState.labelWrapped) {
        /**
         * At certain text and tab lengths, a larger font size may wrap to two lines while the smaller
         * font size still only requires one line.  This check will prevent an infinite render loop
         * fron occurring in that scenario.
         */
        this.checkTextWrap();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
          _classNames2;

      var _this$props2 = this.props,
          classes = _this$props2.classes,
          classNameProp = _this$props2.className,
          disabled = _this$props2.disabled,
          fullWidth = _this$props2.fullWidth,
          icon = _this$props2.icon,
          indicator = _this$props2.indicator,
          labelProp = _this$props2.label,
          onChange = _this$props2.onChange,
          selected = _this$props2.selected,
          textColor = _this$props2.textColor,
          value = _this$props2.value,
          other = (0, _objectWithoutProperties2.default)(_this$props2, ["classes", "className", "disabled", "fullWidth", "icon", "indicator", "label", "onChange", "selected", "textColor", "value"]);
      var label;

      if (labelProp !== undefined) {
        label = _react.default.createElement("span", {
          className: classes.labelContainer
        }, _react.default.createElement("span", {
          className: (0, _classnames.default)(classes.label, (0, _defineProperty2.default)({}, classes.labelWrapped, this.state.labelWrapped)),
          ref: function ref(_ref) {
            _this2.labelRef = _ref;
          }
        }, labelProp));
      }

      var className = (0, _classnames.default)(classes.root, classes["textColor".concat((0, _helpers.capitalize)(textColor))], (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames2, classes.selected, selected), (0, _defineProperty2.default)(_classNames2, classes.labelIcon, icon && label), (0, _defineProperty2.default)(_classNames2, classes.fullWidth, fullWidth), _classNames2), classNameProp);
      return _react.default.createElement(_ButtonBase.default, (0, _extends3.default)({
        focusRipple: true,
        className: className,
        role: "tab",
        "aria-selected": selected,
        disabled: disabled
      }, other, {
        onClick: this.handleChange
      }), _react.default.createElement("span", {
        className: classes.wrapper
      }, icon, label), indicator);
    }
  }]);
  return Tab;
}(_react.default.Component);

Tab.propTypes =  false ? {
  /**
   * This property isn't supported.
   * Use the `component` property if you need to change the children structure.
   */
  children: _unsupportedProp.default,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the tab will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * @ignore
   */
  fullWidth: _propTypes.default.bool,

  /**
   * The icon element.
   */
  icon: _propTypes.default.node,

  /**
   * @ignore
   * For server side rendering consideration, we let the selected tab
   * render the indicator.
   */
  indicator: _propTypes.default.node,

  /**
   * The label element.
   */
  label: _propTypes.default.node,

  /**
   * @ignore
   */
  onChange: _propTypes.default.func,

  /**
   * @ignore
   */
  onClick: _propTypes.default.func,

  /**
   * @ignore
   */
  selected: _propTypes.default.bool,

  /**
   * @ignore
   */
  textColor: _propTypes.default.oneOf(['secondary', 'primary', 'inherit']),

  /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */
  value: _propTypes.default.any
} : {};
Tab.defaultProps = {
  disabled: false,
  textColor: 'inherit'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTab'
})(Tab);

exports.default = _default;

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _warning = _interopRequireDefault(__webpack_require__(37));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _reactEventListener = _interopRequireDefault(__webpack_require__(93));

var _debounce = _interopRequireDefault(__webpack_require__(118));

var _normalizeScrollLeft = __webpack_require__(897);

var _animate = _interopRequireDefault(__webpack_require__(898));

var _ScrollbarSize = _interopRequireDefault(__webpack_require__(899));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _TabIndicator = _interopRequireDefault(__webpack_require__(900));

var _TabScrollButton = _interopRequireDefault(__webpack_require__(901));

/* eslint-disable no-restricted-globals */
// < 1kb payload overhead when lodash/debounce is > 3kb.
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      overflow: 'hidden',
      minHeight: 48,
      WebkitOverflowScrolling: 'touch' // Add iOS momentum scrolling.

    },

    /* Styles applied to the flex container element. */
    flexContainer: {
      display: 'flex'
    },

    /* Styles applied to the flex container element if `centered={true}` & `scrollable={false}`. */
    centered: {
      justifyContent: 'center'
    },

    /* Styles applied to the tablist element. */
    scroller: {
      position: 'relative',
      display: 'inline-block',
      flex: '1 1 auto',
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the tablist element if `scrollable={false}`. */
    fixed: {
      overflowX: 'hidden',
      width: '100%'
    },

    /* Styles applied to the tablist element if `scrollable={true}`. */
    scrollable: {
      overflowX: 'scroll'
    },

    /* Styles applied to the `ScrollButtonComponent` component. */
    scrollButtons: {},

    /* Styles applied to the `ScrollButtonComponent` component if `sscrollButtons="auto"`. */
    scrollButtonsAuto: (0, _defineProperty2.default)({}, theme.breakpoints.down('xs'), {
      display: 'none'
    }),

    /* Styles applied to the `TabIndicator` component. */
    indicator: {}
  };
};

exports.styles = styles;

var Tabs =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Tabs, _React$Component);

  function Tabs() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Tabs);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Tabs)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.tabs = null;
    _this.valueToIndex = new Map();
    _this.handleResize = (0, _debounce.default)(function () {
      _this.updateIndicatorState(_this.props);

      _this.updateScrollButtonState();
    }, 166);
    _this.handleTabsScroll = (0, _debounce.default)(function () {
      _this.updateScrollButtonState();
    }, 166);
    _this.state = {
      indicatorStyle: {},
      scrollerStyle: {
        marginBottom: 0
      },
      showLeftScroll: false,
      showRightScroll: false,
      mounted: false
    };

    _this.getConditionalElements = function () {
      var _this$props = _this.props,
          classes = _this$props.classes,
          scrollable = _this$props.scrollable,
          ScrollButtonComponent = _this$props.ScrollButtonComponent,
          scrollButtons = _this$props.scrollButtons,
          theme = _this$props.theme;
      var conditionalElements = {};
      conditionalElements.scrollbarSizeListener = scrollable ? _react.default.createElement(_ScrollbarSize.default, {
        onLoad: _this.handleScrollbarSizeChange,
        onChange: _this.handleScrollbarSizeChange
      }) : null;
      var showScrollButtons = scrollable && (scrollButtons === 'auto' || scrollButtons === 'on');
      conditionalElements.scrollButtonLeft = showScrollButtons ? _react.default.createElement(ScrollButtonComponent, {
        direction: theme && theme.direction === 'rtl' ? 'right' : 'left',
        onClick: _this.handleLeftScrollClick,
        visible: _this.state.showLeftScroll,
        className: (0, _classnames.default)(classes.scrollButtons, (0, _defineProperty2.default)({}, classes.scrollButtonsAuto, scrollButtons === 'auto'))
      }) : null;
      conditionalElements.scrollButtonRight = showScrollButtons ? _react.default.createElement(ScrollButtonComponent, {
        direction: theme && theme.direction === 'rtl' ? 'left' : 'right',
        onClick: _this.handleRightScrollClick,
        visible: _this.state.showRightScroll,
        className: (0, _classnames.default)(classes.scrollButtons, (0, _defineProperty2.default)({}, classes.scrollButtonsAuto, scrollButtons === 'auto'))
      }) : null;
      return conditionalElements;
    };

    _this.getTabsMeta = function (value, direction) {
      var tabsMeta;

      if (_this.tabsRef) {
        var rect = _this.tabsRef.getBoundingClientRect(); // create a new object with ClientRect class props + scrollLeft


        tabsMeta = {
          clientWidth: _this.tabsRef.clientWidth,
          scrollLeft: _this.tabsRef.scrollLeft,
          scrollLeftNormalized: (0, _normalizeScrollLeft.getNormalizedScrollLeft)(_this.tabsRef, direction),
          scrollWidth: _this.tabsRef.scrollWidth,
          left: rect.left,
          right: rect.right
        };
      }

      var tabMeta;

      if (_this.tabsRef && value !== false) {
        var children = _this.tabsRef.children[0].children;

        if (children.length > 0) {
          var tab = children[_this.valueToIndex.get(value)];

           false ? (0, _warning.default)(tab, "Material-UI: the value provided `".concat(value, "` is invalid")) : void 0;
          tabMeta = tab ? tab.getBoundingClientRect() : null;
        }
      }

      return {
        tabsMeta: tabsMeta,
        tabMeta: tabMeta
      };
    };

    _this.handleLeftScrollClick = function () {
      _this.moveTabsScroll(-_this.tabsRef.clientWidth);
    };

    _this.handleRightScrollClick = function () {
      _this.moveTabsScroll(_this.tabsRef.clientWidth);
    };

    _this.handleScrollbarSizeChange = function (_ref) {
      var scrollbarHeight = _ref.scrollbarHeight;

      _this.setState({
        scrollerStyle: {
          marginBottom: -scrollbarHeight
        }
      });
    };

    _this.moveTabsScroll = function (delta) {
      var theme = _this.props.theme;
      var multiplier = theme.direction === 'rtl' ? -1 : 1;
      var nextScrollLeft = _this.tabsRef.scrollLeft + delta * multiplier; // Fix for Edge

      var invert = theme.direction === 'rtl' && (0, _normalizeScrollLeft.detectScrollType)() === 'reverse' ? -1 : 1;

      _this.scroll(invert * nextScrollLeft);
    };

    _this.scrollSelectedIntoView = function () {
      var _this$props2 = _this.props,
          theme = _this$props2.theme,
          value = _this$props2.value;

      var _this$getTabsMeta = _this.getTabsMeta(value, theme.direction),
          tabsMeta = _this$getTabsMeta.tabsMeta,
          tabMeta = _this$getTabsMeta.tabMeta;

      if (!tabMeta || !tabsMeta) {
        return;
      }

      if (tabMeta.left < tabsMeta.left) {
        // left side of button is out of view
        var nextScrollLeft = tabsMeta.scrollLeft + (tabMeta.left - tabsMeta.left);

        _this.scroll(nextScrollLeft);
      } else if (tabMeta.right > tabsMeta.right) {
        // right side of button is out of view
        var _nextScrollLeft = tabsMeta.scrollLeft + (tabMeta.right - tabsMeta.right);

        _this.scroll(_nextScrollLeft);
      }
    };

    _this.scroll = function (value) {
      (0, _animate.default)('scrollLeft', _this.tabsRef, value);
    };

    _this.updateScrollButtonState = function () {
      var _this$props3 = _this.props,
          scrollable = _this$props3.scrollable,
          scrollButtons = _this$props3.scrollButtons,
          theme = _this$props3.theme;

      if (scrollable && scrollButtons !== 'off') {
        var _this$tabsRef = _this.tabsRef,
            scrollWidth = _this$tabsRef.scrollWidth,
            clientWidth = _this$tabsRef.clientWidth;
        var scrollLeft = (0, _normalizeScrollLeft.getNormalizedScrollLeft)(_this.tabsRef, theme.direction);
        var showLeftScroll = theme.direction === 'rtl' ? scrollWidth > clientWidth + scrollLeft : scrollLeft > 0;
        var showRightScroll = theme.direction === 'rtl' ? scrollLeft > 0 : scrollWidth > clientWidth + scrollLeft;

        if (showLeftScroll !== _this.state.showLeftScroll || showRightScroll !== _this.state.showRightScroll) {
          _this.setState({
            showLeftScroll: showLeftScroll,
            showRightScroll: showRightScroll
          });
        }
      }
    };

    return _this;
  }

  (0, _createClass2.default)(Tabs, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({
        mounted: true
      });
      this.updateIndicatorState(this.props);
      this.updateScrollButtonState();

      if (this.props.action) {
        this.props.action({
          updateIndicator: this.handleResize
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      // The index might have changed at the same time.
      // We need to check again the right indicator position.
      this.updateIndicatorState(this.props);
      this.updateScrollButtonState();

      if (this.state.indicatorStyle !== prevState.indicatorStyle) {
        this.scrollSelectedIntoView();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handleResize.clear();
      this.handleTabsScroll.clear();
    }
  }, {
    key: "updateIndicatorState",
    value: function updateIndicatorState(props) {
      var theme = props.theme,
          value = props.value;

      var _this$getTabsMeta2 = this.getTabsMeta(value, theme.direction),
          tabsMeta = _this$getTabsMeta2.tabsMeta,
          tabMeta = _this$getTabsMeta2.tabMeta;

      var left = 0;

      if (tabMeta && tabsMeta) {
        var correction = theme.direction === 'rtl' ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
        left = Math.round(tabMeta.left - tabsMeta.left + correction);
      }

      var indicatorStyle = {
        left: left,
        // May be wrong until the font is loaded.
        width: tabMeta ? Math.round(tabMeta.width) : 0
      };

      if ((indicatorStyle.left !== this.state.indicatorStyle.left || indicatorStyle.width !== this.state.indicatorStyle.width) && !isNaN(indicatorStyle.left) && !isNaN(indicatorStyle.width)) {
        this.setState({
          indicatorStyle: indicatorStyle
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames4,
          _this2 = this;

      var _this$props4 = this.props,
          action = _this$props4.action,
          centered = _this$props4.centered,
          childrenProp = _this$props4.children,
          classes = _this$props4.classes,
          classNameProp = _this$props4.className,
          Component = _this$props4.component,
          fullWidth = _this$props4.fullWidth,
          indicatorColor = _this$props4.indicatorColor,
          onChange = _this$props4.onChange,
          scrollable = _this$props4.scrollable,
          ScrollButtonComponent = _this$props4.ScrollButtonComponent,
          scrollButtons = _this$props4.scrollButtons,
          _this$props4$TabIndic = _this$props4.TabIndicatorProps,
          TabIndicatorProps = _this$props4$TabIndic === void 0 ? {} : _this$props4$TabIndic,
          textColor = _this$props4.textColor,
          theme = _this$props4.theme,
          value = _this$props4.value,
          other = (0, _objectWithoutProperties2.default)(_this$props4, ["action", "centered", "children", "classes", "className", "component", "fullWidth", "indicatorColor", "onChange", "scrollable", "ScrollButtonComponent", "scrollButtons", "TabIndicatorProps", "textColor", "theme", "value"]);
       false ? (0, _warning.default)(!centered || !scrollable, 'Material-UI: you can not use the `centered={true}` and `scrollable={true}` properties ' + 'at the same time on a `Tabs` component.') : void 0;
      var className = (0, _classnames.default)(classes.root, classNameProp);
      var flexContainerClassName = (0, _classnames.default)(classes.flexContainer, (0, _defineProperty2.default)({}, classes.centered, centered && !scrollable));
      var scrollerClassName = (0, _classnames.default)(classes.scroller, (_classNames4 = {}, (0, _defineProperty2.default)(_classNames4, classes.fixed, !scrollable), (0, _defineProperty2.default)(_classNames4, classes.scrollable, scrollable), _classNames4));

      var indicator = _react.default.createElement(_TabIndicator.default, (0, _extends2.default)({
        className: classes.indicator,
        color: indicatorColor
      }, TabIndicatorProps, {
        style: (0, _extends2.default)({}, this.state.indicatorStyle, TabIndicatorProps.style)
      }));

      this.valueToIndex = new Map();
      var childIndex = 0;

      var children = _react.default.Children.map(childrenProp, function (child) {
        if (!_react.default.isValidElement(child)) {
          return null;
        }

         false ? (0, _warning.default)(child.type !== _react.default.Fragment, ["Material-UI: the Tabs component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n')) : void 0;
        var childValue = child.props.value === undefined ? childIndex : child.props.value;

        _this2.valueToIndex.set(childValue, childIndex);

        var selected = childValue === value;
        childIndex += 1;
        return _react.default.cloneElement(child, {
          fullWidth: fullWidth,
          indicator: selected && !_this2.state.mounted && indicator,
          selected: selected,
          onChange: onChange,
          textColor: textColor,
          value: childValue
        });
      });

      var conditionalElements = this.getConditionalElements();
      return _react.default.createElement(Component, (0, _extends2.default)({
        className: className
      }, other), _react.default.createElement(_reactEventListener.default, {
        target: "window",
        onResize: this.handleResize
      }), conditionalElements.scrollbarSizeListener, _react.default.createElement("div", {
        className: classes.flexContainer
      }, conditionalElements.scrollButtonLeft, _react.default.createElement("div", {
        className: scrollerClassName,
        style: this.state.scrollerStyle,
        ref: function ref(_ref2) {
          _this2.tabsRef = _ref2;
        },
        role: "tablist",
        onScroll: this.handleTabsScroll
      }, _react.default.createElement("div", {
        className: flexContainerClassName
      }, children), this.state.mounted && indicator), conditionalElements.scrollButtonRight));
    }
  }]);
  return Tabs;
}(_react.default.Component);

Tabs.propTypes =  false ? {
  /**
   * Callback fired when the component mounts.
   * This is useful when you want to trigger an action programmatically.
   * It currently only supports `updateIndicator()` action.
   *
   * @param {object} actions This object contains all possible actions
   * that can be triggered programmatically.
   */
  action: _propTypes.default.func,

  /**
   * If `true`, the tabs will be centered.
   * This property is intended for large views.
   */
  centered: _propTypes.default.bool,

  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the tabs will grow to use all the available space.
   * This property is intended for small views, like on mobile.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * Determines the color of the indicator.
   */
  indicatorColor: _propTypes.default.oneOf(['secondary', 'primary']),

  /**
   * Callback fired when the value changes.
   *
   * @param {object} event The event source of the callback
   * @param {number} value We default to the index of the child
   */
  onChange: _propTypes.default.func,

  /**
   * True invokes scrolling properties and allow for horizontally scrolling
   * (or swiping) the tab bar.
   */
  scrollable: _propTypes.default.bool,

  /**
   * The component used to render the scroll buttons.
   */
  ScrollButtonComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Determine behavior of scroll buttons when tabs are set to scroll
   * `auto` will only present them on medium and larger viewports
   * `on` will always present them
   * `off` will never present them
   */
  scrollButtons: _propTypes.default.oneOf(['auto', 'on', 'off']),

  /**
   * Properties applied to the `TabIndicator` element.
   */
  TabIndicatorProps: _propTypes.default.object,

  /**
   * Determines the color of the `Tab`.
   */
  textColor: _propTypes.default.oneOf(['secondary', 'primary', 'inherit']),

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The value of the currently selected `Tab`.
   * If you don't want any selected `Tab`, you can set this property to `false`.
   */
  value: _propTypes.default.any
} : {};
Tabs.defaultProps = {
  centered: false,
  component: 'div',
  fullWidth: false,
  indicatorColor: 'secondary',
  scrollable: false,
  ScrollButtonComponent: _TabScrollButton.default,
  scrollButtons: 'auto',
  textColor: 'inherit'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTabs',
  withTheme: true
})(Tabs);

exports.default = _default;

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// Based on https://github.com/react-bootstrap/dom-helpers/blob/master/src/util/inDOM.js
var inDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var cachedType;
function _setScrollType(type) {
    cachedType = type;
}
exports._setScrollType = _setScrollType;
// Based on the jquery plugin https://github.com/othree/jquery.rtl-scroll-type
function detectScrollType() {
    if (cachedType) {
        return cachedType;
    }
    if (!inDOM || !window.document.body) {
        return 'indeterminate';
    }
    var dummy = window.document.createElement('div');
    dummy.appendChild(document.createTextNode('ABCD'));
    dummy.dir = 'rtl';
    dummy.style.fontSize = '14px';
    dummy.style.width = '4px';
    dummy.style.height = '1px';
    dummy.style.position = 'absolute';
    dummy.style.top = '-1000px';
    dummy.style.overflow = 'scroll';
    document.body.appendChild(dummy);
    cachedType = 'reverse';
    if (dummy.scrollLeft > 0) {
        cachedType = 'default';
    }
    else {
        dummy.scrollLeft = 1;
        if (dummy.scrollLeft === 0) {
            cachedType = 'negative';
        }
    }
    document.body.removeChild(dummy);
    return cachedType;
}
exports.detectScrollType = detectScrollType;
// Based on https://stackoverflow.com/a/24394376
function getNormalizedScrollLeft(element, direction) {
    var scrollLeft = element.scrollLeft;
    // Perform the calculations only when direction is rtl to avoid messing up the ltr bahavior
    if (direction !== 'rtl') {
        return scrollLeft;
    }
    var type = detectScrollType();
    if (type === 'indeterminate') {
        return Number.NaN;
    }
    switch (type) {
        case 'negative':
            return element.scrollWidth - element.clientWidth + scrollLeft;
        case 'reverse':
            return element.scrollWidth - element.clientWidth - scrollLeft;
    }
    return scrollLeft;
}
exports.getNormalizedScrollLeft = getNormalizedScrollLeft;
function setNormalizedScrollLeft(element, scrollLeft, direction) {
    // Perform the calculations only when direction is rtl to avoid messing up the ltr bahavior
    if (direction !== 'rtl') {
        element.scrollLeft = scrollLeft;
        return;
    }
    var type = detectScrollType();
    if (type === 'indeterminate') {
        return;
    }
    switch (type) {
        case 'negative':
            element.scrollLeft = element.clientWidth - element.scrollWidth + scrollLeft;
            break;
        case 'reverse':
            element.scrollLeft = element.scrollWidth - element.clientWidth - scrollLeft;
            break;
        default:
            element.scrollLeft = scrollLeft;
            break;
    }
}
exports.setNormalizedScrollLeft = setNormalizedScrollLeft;


/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function easeInOutSin(time) {
  return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}

function animate(prop, element, to) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var cb = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};
  var _options$ease = options.ease,
      ease = _options$ease === void 0 ? easeInOutSin : _options$ease,
      _options$duration = options.duration,
      duration = _options$duration === void 0 ? 300 : _options$duration;
  var start = null;
  var from = element[prop];
  var cancelled = false;

  var cancel = function cancel() {
    cancelled = true;
  };

  var step = function step(timestamp) {
    if (cancelled) {
      cb(new Error('Animation cancelled'));
      return;
    }

    if (start === null) {
      start = timestamp;
    }

    var time = Math.min(1, (timestamp - start) / duration);
    element[prop] = ease(time) * (to - from) + from;

    if (time >= 1) {
      requestAnimationFrame(function () {
        cb(null);
      });
      return;
    }

    requestAnimationFrame(step);
  };

  if (from === to) {
    cb(new Error('Element already at target position'));
    return cancel;
  }

  requestAnimationFrame(step);
  return cancel;
}

var _default = animate;
exports.default = _default;

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _reactEventListener = _interopRequireDefault(__webpack_require__(93));

var _debounce = _interopRequireDefault(__webpack_require__(118));

// < 1kb payload overhead when lodash/debounce is > 3kb.
var styles = {
  width: 100,
  height: 100,
  position: 'absolute',
  top: -10000,
  overflow: 'scroll',
  msOverflowStyle: 'scrollbar'
};
/**
 * @ignore - internal component.
 * The component is originates from https://github.com/STORIS/react-scrollbar-size.
 * It has been moved into the core in order to minimize the bundle size.
 */

var ScrollbarSize =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ScrollbarSize, _React$Component);

  function ScrollbarSize() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, ScrollbarSize);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(ScrollbarSize)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.handleResize = (0, _debounce.default)(function () {
      var onChange = _this.props.onChange;
      var prevHeight = _this.scrollbarHeight;
      var prevWidth = _this.scrollbarWidth;

      _this.setMeasurements();

      if (prevHeight !== _this.scrollbarHeight || prevWidth !== _this.scrollbarWidth) {
        onChange({
          scrollbarHeight: _this.scrollbarHeight,
          scrollbarWidth: _this.scrollbarWidth
        });
      }
    }, 166);

    _this.setMeasurements = function () {
      var nodeRef = _this.nodeRef;

      if (!nodeRef) {
        return;
      }

      _this.scrollbarHeight = nodeRef.offsetHeight - nodeRef.clientHeight;
      _this.scrollbarWidth = nodeRef.offsetWidth - nodeRef.clientWidth;
    };

    return _this;
  }

  (0, _createClass2.default)(ScrollbarSize, [{
    key: "componentDidMount",
    // Corresponds to 10 frames at 60 Hz.
    value: function componentDidMount() {
      this.setMeasurements();
      this.props.onLoad({
        scrollbarHeight: this.scrollbarHeight,
        scrollbarWidth: this.scrollbarWidth
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handleResize.clear();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var onChange = this.props.onChange;
      return _react.default.createElement("div", null, onChange ? _react.default.createElement(_reactEventListener.default, {
        target: "window",
        onResize: this.handleResize
      }) : null, _react.default.createElement("div", {
        style: styles,
        ref: function ref(_ref) {
          _this2.nodeRef = _ref;
        }
      }));
    }
  }]);
  return ScrollbarSize;
}(_react.default.Component);

ScrollbarSize.propTypes =  false ? {
  onChange: _propTypes.default.func.isRequired,
  onLoad: _propTypes.default.func.isRequired
} : {};
var _default = ScrollbarSize;
exports.default = _default;

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _helpers = __webpack_require__(51);

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'absolute',
      height: 2,
      bottom: 0,
      width: '100%',
      transition: theme.transitions.create(),
      willChange: 'left, width'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      backgroundColor: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main
    }
  };
};
/**
 * @ignore - internal component.
 */


exports.styles = styles;

function TabIndicator(props) {
  var classes = props.classes,
      className = props.className,
      color = props.color,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color"]);
  return _react.default.createElement("span", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, classes["color".concat((0, _helpers.capitalize)(color))], className)
  }, other));
}

TabIndicator.propTypes =  false ? {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   * The color of the tab indicator.
   */
  color: _propTypes.default.oneOf(['primary', 'secondary'])
} : {};

var _default = (0, _withStyles.default)(styles)(TabIndicator);

exports.default = _default;

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _KeyboardArrowLeft = _interopRequireDefault(__webpack_require__(478));

var _KeyboardArrowRight = _interopRequireDefault(__webpack_require__(479));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _ButtonBase = _interopRequireDefault(__webpack_require__(92));

var styles = {
  /* Styles applied to the root element. */
  root: {
    color: 'inherit',
    flex: '0 0 56px'
  }
};
/**
 * @ignore - internal component.
 */

exports.styles = styles;

var _ref = _react.default.createElement(_KeyboardArrowLeft.default, null);

var _ref2 = _react.default.createElement(_KeyboardArrowRight.default, null);

function TabScrollButton(props) {
  var classes = props.classes,
      classNameProp = props.className,
      direction = props.direction,
      onClick = props.onClick,
      visible = props.visible,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "direction", "onClick", "visible"]);
  var className = (0, _classnames.default)(classes.root, classNameProp);

  if (!visible) {
    return _react.default.createElement("div", {
      className: className
    });
  }

  return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
    className: className,
    onClick: onClick,
    tabIndex: -1
  }, other), direction === 'left' ? _ref : _ref2);
}

TabScrollButton.propTypes =  false ? {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Which direction should the button indicate?
   */
  direction: _propTypes.default.oneOf(['left', 'right']),

  /**
   * Callback to execute for button press.
   */
  onClick: _propTypes.default.func,

  /**
   * Should the button be present or just consume space.
   */
  visible: _propTypes.default.bool
} : {};
TabScrollButton.defaultProps = {
  visible: true
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTabScrollButton'
})(TabScrollButton);

exports.default = _default;

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


var MomentUtils = /** @class */ (function () {
    function MomentUtils(_a) {
        var _b = _a === void 0 ? {} : _a, locale = _b.locale, moment = _b.moment;
        this.dateTime12hFormat = 'MMMM Do hh:mm a';
        this.dateTime24hFormat = 'MMMM Do HH:mm';
        this.time12hFormat = 'hh:mm A';
        this.time24hFormat = 'HH:mm';
        this.dateFormat = 'MMMM Do';
        this.moment = moment || __WEBPACK_IMPORTED_MODULE_0_moment___default.a;
        this.locale = locale;
    }
    MomentUtils.prototype.parse = function (value, format) {
        return this.moment(value, format, true);
    };
    MomentUtils.prototype.date = function (value) {
        return this.moment(value);
    };
    MomentUtils.prototype.isValid = function (date) {
        return date.isValid();
    };
    MomentUtils.prototype.isNull = function (date) {
        return date.parsingFlags().nullInput;
    };
    MomentUtils.prototype.getDiff = function (date, comparing) {
        return date.diff(comparing);
    };
    MomentUtils.prototype.isAfter = function (date, value) {
        return date.isAfter(value);
    };
    MomentUtils.prototype.isBefore = function (date, value) {
        return date.isBefore(value);
    };
    MomentUtils.prototype.isAfterDay = function (date, value) {
        return date.isAfter(value, 'day');
    };
    MomentUtils.prototype.isBeforeDay = function (date, value) {
        return date.isBefore(value, 'day');
    };
    MomentUtils.prototype.isBeforeYear = function (date, value) {
        return date.isBefore(value, 'year');
    };
    MomentUtils.prototype.isAfterYear = function (date, value) {
        return date.isAfter(value, 'year');
    };
    MomentUtils.prototype.startOfDay = function (date) {
        return date.clone().startOf('day');
    };
    MomentUtils.prototype.endOfDay = function (date) {
        return date.clone().endOf('day');
    };
    MomentUtils.prototype.format = function (date, formatString) {
        return date.format(formatString);
    };
    MomentUtils.prototype.formatNumber = function (numberToFormat) {
        return numberToFormat;
    };
    MomentUtils.prototype.getHours = function (date) {
        return date.get('hours');
    };
    MomentUtils.prototype.addDays = function (date, count) {
        return count < 0
            ? date.clone().subtract(Math.abs(count), 'days')
            : date.clone().add(count, 'days');
    };
    MomentUtils.prototype.setHours = function (date, count) {
        return date.clone().hours(count);
    };
    MomentUtils.prototype.getMinutes = function (date) {
        return date.get('minutes');
    };
    MomentUtils.prototype.setMinutes = function (date, count) {
        return date.clone().minutes(count);
    };
    MomentUtils.prototype.getSeconds = function (date) {
        return date.get('seconds');
    };
    MomentUtils.prototype.setSeconds = function (date, count) {
        return date.clone().seconds(count);
    };
    MomentUtils.prototype.getMonth = function (date) {
        return date.get('month');
    };
    MomentUtils.prototype.isSameDay = function (date, comparing) {
        return date.isSame(comparing, 'day');
    };
    MomentUtils.prototype.getMeridiemText = function (ampm) {
        return ampm === 'am' ? 'AM' : 'PM';
    };
    MomentUtils.prototype.getStartOfMonth = function (date) {
        return date.clone().startOf('month');
    };
    MomentUtils.prototype.getNextMonth = function (date) {
        return date.clone().add(1, 'month');
    };
    MomentUtils.prototype.getPreviousMonth = function (date) {
        return date.clone().subtract(1, 'month');
    };
    MomentUtils.prototype.getYear = function (date) {
        return date.get('year');
    };
    MomentUtils.prototype.setYear = function (date, year) {
        return date.clone().set('year', year);
    };
    MomentUtils.prototype.mergeDateAndTime = function (date, time) {
        return this.setMinutes(this.setHours(date, this.getHours(time)), this.getMinutes(time));
    };
    MomentUtils.prototype.getWeekdays = function () {
        var _this = this;
        return [0, 1, 2, 3, 4, 5, 6].map(function (dayOfWeek) {
            return _this.moment()
                .weekday(dayOfWeek)
                .format('dd');
        });
    };
    MomentUtils.prototype.isEqual = function (value, comparing) {
        if (value === null && comparing === null) {
            return true;
        }
        return this.moment(value).isSame(comparing);
    };
    MomentUtils.prototype.getWeekArray = function (date) {
        var start = date
            .clone()
            .startOf('month')
            .startOf('week');
        var end = date
            .clone()
            .endOf('month')
            .endOf('week');
        var count = 0;
        var current = start;
        var nestedWeeks = [];
        while (current.isBefore(end)) {
            var weekNumber = Math.floor(count / 7);
            nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
            nestedWeeks[weekNumber].push(current);
            current = current.clone().add(1, 'day');
            count += 1;
        }
        return nestedWeeks;
    };
    MomentUtils.prototype.getYearRange = function (start, end) {
        var startDate = this.moment(start).startOf('year');
        var endDate = this.moment(end).endOf('year');
        var years = [];
        var current = startDate;
        while (current.isBefore(endDate)) {
            years.push(current);
            current = current.clone().add(1, 'year');
        }
        return years;
    };
    // displaying methods
    MomentUtils.prototype.getCalendarHeaderText = function (date) {
        return date.format('MMMM YYYY');
    };
    MomentUtils.prototype.getYearText = function (date) {
        return date.format('YYYY');
    };
    MomentUtils.prototype.getDatePickerHeaderText = function (date) {
        return date.format('ddd, MMM D');
    };
    MomentUtils.prototype.getDateTimePickerHeaderText = function (date) {
        return date.format('MMM D');
    };
    MomentUtils.prototype.getDayText = function (date) {
        return date.format('D');
    };
    MomentUtils.prototype.getHourText = function (date, ampm) {
        return date.format(ampm ? 'hh' : 'HH');
    };
    MomentUtils.prototype.getMinuteText = function (date) {
        return date.format('mm');
    };
    MomentUtils.prototype.getSecondText = function (date) {
        return date.format('ss');
    };
    return MomentUtils;
}());

/* harmony default export */ __webpack_exports__["a"] = (MomentUtils);


/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Router__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Customers__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Inventory_outward__ = __webpack_require__(1083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Report__ = __webpack_require__(1091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Modules_MenuDrawer__ = __webpack_require__(1092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Modules_NavBar__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_styles__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_withWidth__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_withWidth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_withWidth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Modules_VehicleRegistartion__ = __webpack_require__(1098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Modules_VehicleRegistartion_BulkVehicleRegistration_jsx__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Modules_VehicleRegistartion_BulkVehicleDelete__ = __webpack_require__(1103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Modules_VehicleRegistartion_BulkVehicleDeactivate__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Modules_VehicleCommands__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__RegisterCustomer__ = __webpack_require__(1111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ViewCustomer__ = __webpack_require__(1113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__InventoryDevices__ = __webpack_require__(1116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__InventorySims__ = __webpack_require__(1118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__InventoryAccessories__ = __webpack_require__(1125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__EditCustomer__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__EditSubscription__ = __webpack_require__(2045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Plans__ = __webpack_require__(2047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Plans_addPlan__ = __webpack_require__(2048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Modules_AddModel__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Modules_AddDevice__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Modules_AddSim__ = __webpack_require__(2050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Modules_AddProvider__ = __webpack_require__(2051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Modules_AddPartner__ = __webpack_require__(2053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Modules_AssignDevPartner__ = __webpack_require__(2055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Subscriptions__ = __webpack_require__(2058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__ViewSubscription__ = __webpack_require__(2059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__NewSubscription__ = __webpack_require__(2060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__AssignDevices_AssignInventory_jsx__ = __webpack_require__(2062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__DeassignDevice_DeassignInventory_jsx__ = __webpack_require__(2063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__DeassignDevice_DeassignSim_jsx__ = __webpack_require__(2064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__SubscriptionDetails__ = __webpack_require__(2065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__ViewPlans__ = __webpack_require__(2066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__Modules_AddManufacturer__ = __webpack_require__(2068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__Reusable_Gst__ = __webpack_require__(2070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__Modules_VehicleRegistartion_VehicleEdit__ = __webpack_require__(2071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__Modules_BulkDeviceUpload__ = __webpack_require__(2076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__Modules_BulkSimUpload__ = __webpack_require__(2077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__Modules_BulkSimAssign__ = __webpack_require__(2078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__Modules_BulkDeviceAssign__ = __webpack_require__(2079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__InventoryDevices_RegisterBulkDevice__ = __webpack_require__(2080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__InventoryDevices_DeleteBulkDevice__ = __webpack_require__(2081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__InventorySims_RegisterBulkSim__ = __webpack_require__(2082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__InventorySims_DeleteBulkSim__ = __webpack_require__(2083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__Modules_VehcileDashboard__ = __webpack_require__(2084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__Modules_DeviceDashboard__ = __webpack_require__(2325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__InventoryAccessories_RegisterBulkAccessory__ = __webpack_require__(2327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__RegisterReseller__ = __webpack_require__(2328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__AssignLicenses__ = __webpack_require__(2332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__Modules_PullApi__ = __webpack_require__(2333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__Plans_createPlan_jsx__ = __webpack_require__(2334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__Modules_UserDashboard_index_jsx__ = __webpack_require__(2335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__Reseller__ = __webpack_require__(2336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__Reseller_ResellerView_jsx__ = __webpack_require__(2337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__Reseller_ResellerEdit_jsx__ = __webpack_require__(2338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__Partner__ = __webpack_require__(2339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__Manufacturer__ = __webpack_require__(2340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__Plans_ViewLicense_jsx__ = __webpack_require__(2341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__ManagePurchaseRequests__ = __webpack_require__(2343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__ManagePurchaseRequests_ApprovePurchaseRequest_jsx__ = __webpack_require__(2345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__ManagePurchaseRequests_AssignDevicesForPR_jsx__ = __webpack_require__(2346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__ManagePurchaseRequests_ViewPurchaseRequest_jsx__ = __webpack_require__(2347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__Modules_DeviceDashboard_ViewDevice__ = __webpack_require__(2348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__SMSPurchase_PartnerSMSPurchase__ = __webpack_require__(2351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__SMSPurchase_ClientSMSPurchase__ = __webpack_require__(2353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__SMSPurchase_Reports_PartnerClientSMSReport__ = __webpack_require__(2355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__SMSPurchase_Reports_AdminClientSMSReport__ = __webpack_require__(2356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__PanicAlertBitConfigurationSettings__ = __webpack_require__(2357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__Modules_VehcileDashboard_ViewVehicleList__ = __webpack_require__(2358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__Modules_CurrentSummary__ = __webpack_require__(2359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__InventoryDevices_ViewInventoryDevices__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__RegisterCustomer_RegisterBulkCustomer_jsx__ = __webpack_require__(2360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__Billing_InvoiceDetails__ = __webpack_require__(2361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__Billing_CreateProformaInvoice__ = __webpack_require__(2364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__SearchDevice__ = __webpack_require__(2366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__Billing_MakePayment__ = __webpack_require__(2367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__Billing_HistoryPacketReceived__ = __webpack_require__(2368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__Billing_BillingDays__ = __webpack_require__(2369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__Billing_MakeAdvanceAmount__ = __webpack_require__(2370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__Billing_BillingHistoryReport__ = __webpack_require__(2371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__Partner_PartnerView_jsx__ = __webpack_require__(2372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__Partner_PartnerEdit_jsx__ = __webpack_require__(2374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__ClearRedis__ = __webpack_require__(2375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__Modules_CurrentTrackinfo__ = __webpack_require__(2376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__FuelCalibration__ = __webpack_require__(2377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__PidsConfiguration__ = __webpack_require__(2380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__DeviceDataKpi__ = __webpack_require__(2381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__IdleReport__ = __webpack_require__(2382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__Billing_CreatePartnerProformaInvoice__ = __webpack_require__(2383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__AssignPartnerDevices_AssignPartnerInventory__ = __webpack_require__(2385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__reseller_module_License__ = __webpack_require__(2386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__reseller_module_License_ViewLicense__ = __webpack_require__(2387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__reseller_module_Customers__ = __webpack_require__(2388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__reseller_module_Customers_RegisterCustomer__ = __webpack_require__(2389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__reseller_module_Customers_ViewCustomer__ = __webpack_require__(2390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__reseller_module_Customers_EditCustomer__ = __webpack_require__(2391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__reseller_module_Subscriptions__ = __webpack_require__(2392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__reseller_module_Subscriptions_ViewSubscription__ = __webpack_require__(2393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__reseller_module_Subscriptions_NewSubscription__ = __webpack_require__(2394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__reseller_module_Subscriptions_EditSubscription__ = __webpack_require__(2396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__reseller_module_Subscriptions_AssignDevices__ = __webpack_require__(2398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__reseller_module_InventoryDevices__ = __webpack_require__(2399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__reseller_module_InventoryDevices_ViewInventoryDevices__ = __webpack_require__(2401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__reseller_module_InventoryDevices_RegisterBulkDevices__ = __webpack_require__(2402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__reseller_module_InventoryAccessories__ = __webpack_require__(2403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__reseller_module_InventoryAccessories_RegisterBulkAccessories__ = __webpack_require__(2405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__reseller_module_InventorySims__ = __webpack_require__(2406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__reseller_module_InventorySims_RegisterBulkSim__ = __webpack_require__(2411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__reseller_module_VehicleRegistartion__ = __webpack_require__(2412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__reseller_module_VehicleRegistartion_VehicleEdit__ = __webpack_require__(2413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__reseller_module_VehicleRegistartion_BulkRegistration__ = __webpack_require__(2416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__reseller_module_PurchaseRequest__ = __webpack_require__(2417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__reseller_module_PurchaseRequest_NewRequest_jsx__ = __webpack_require__(2419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__reseller_module_PurchaseRequest_ViewPendingRequest_jsx__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__reseller_module_PurchaseRequest_ViewRequest_jsx__ = __webpack_require__(2420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__reseller_module_VehcileDashboard_ViewVehicleList__ = __webpack_require__(2421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__reseller_module_VehcileDashboard__ = __webpack_require__(2422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__Modules_CurrentTrackinfo_SATrackinfo_jsx__ = __webpack_require__(2423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__CreateDemoLink__ = __webpack_require__(2424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__APIDashboard__ = __webpack_require__(2427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__SparePartReplacement__ = __webpack_require__(2440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__Partner_PartnerSubscriptionDetail__ = __webpack_require__(2441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__Partner_SubscriptionForm__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__EditPartnerSubscription__ = __webpack_require__(2442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__HereMapsDashboard_HereMapsDashboard__ = __webpack_require__(2444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__Plans_EditPlan__ = __webpack_require__(2446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__AssignDevices_bulkUploadAssignDevice__ = __webpack_require__(2447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__AssignDevices_bulkUploadAssignSim__ = __webpack_require__(2448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__DetailedAlerts__ = __webpack_require__(2449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__RefuelAndPilferageAlerts__ = __webpack_require__(2450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__DeviceTopup__ = __webpack_require__(2451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__DeviceReplacement__ = __webpack_require__(2453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__VehicleDeactivationActivation__ = __webpack_require__(2455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__VehicleUnregistration__ = __webpack_require__(2456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__SolutionWiseUnregistration__ = __webpack_require__(2457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141__DeviceShift__ = __webpack_require__(2458);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* eslint-disable */// import PaymentMethod from '../Billing/MakePayment/PaymentMethod.jsx'
// Reseller Pages
var style=function style(theme){var _mainContent,_ref;return _ref={},_defineProperty(_ref,theme.breakpoints.up('sm'),{drawerOpenMargin:{transition:theme.transitions.create('margin',{easing:theme.transitions.easing.sharp,duration:theme.transitions.duration.enteringScreen}),marginLeft:__WEBPACK_IMPORTED_MODULE_8__constants_styles__["b" /* MENU_DRAWER_WIDTH */],width:'calc(100% - '+__WEBPACK_IMPORTED_MODULE_8__constants_styles__["b" /* MENU_DRAWER_WIDTH */]+'px)'},drawerClosedMargin:{transition:theme.transitions.create('margin',{easing:theme.transitions.easing.sharp,duration:theme.transitions.duration.leavingScreen}),marginLeft:__WEBPACK_IMPORTED_MODULE_8__constants_styles__["c" /* MINI_MENU_DRAWER_WIDTH */],width:'calc(100% - '+__WEBPACK_IMPORTED_MODULE_8__constants_styles__["c" /* MINI_MENU_DRAWER_WIDTH */]+'px)'}}),_defineProperty(_ref,'mainContent',(_mainContent={flexGrow:1,backgroundColor:theme.palette.background.default},_defineProperty(_mainContent,theme.breakpoints.down('xs'),{width:'100%',boxSizing:'border-box'}),_defineProperty(_mainContent,'minHeight','calc(100vh - 48px)'),_mainContent)),_ref;};var AppShell=function(_Component){_inherits(AppShell,_Component);function AppShell(){var _ref2;var _temp,_this,_ret;_classCallCheck(this,AppShell);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref2=AppShell.__proto__||Object.getPrototypeOf(AppShell)).call.apply(_ref2,[this].concat(args))),_this),_this.state={isMenuDrawerOpen:Object(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_withWidth__["isWidthUp"])('sm',_this.props.width,true),isAlertsDrawerOpen:false},_this.handleMenuDrawerToggle=function(){_this.setState({isMenuDrawerOpen:!_this.state.isMenuDrawerOpen});},_this.handleAlertsDrawerToggle=function(){_this.setState({isAlertsDrawerOpen:!_this.state.isAlertsDrawerOpen});},_this.closeMobileMenuDrawer=function(){if(Object(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_withWidth__["isWidthDown"])('xs',_this.props.width,true)){_this.setState({isMenuDrawerOpen:false});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AppShell,[{key:'render',value:function render(){var classes=this.props.classes;var mainClasses=[classes.mainContent,this.state.isMenuDrawerOpen?classes.drawerOpenMargin:classes.drawerClosedMargin,'appbar-top-margin'];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Modules_MenuDrawer__["a" /* default */],{isMenuDrawerOpen:this.state.isMenuDrawerOpen,closeMobileMenuDrawer:this.closeMobileMenuDrawer}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Modules_NavBar__["a" /* default */],{handleMenuDrawerToggle:this.handleMenuDrawerToggle,handleAlertsDrawerToggle:this.handleAlertsDrawerToggle}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('main',{className:mainClasses.join(' ')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{path:'/home/report',component:__WEBPACK_IMPORTED_MODULE_4__Report__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/add-model',component:__WEBPACK_IMPORTED_MODULE_25__Modules_AddModel__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/add-provider',component:__WEBPACK_IMPORTED_MODULE_28__Modules_AddProvider__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/add-device',component:__WEBPACK_IMPORTED_MODULE_26__Modules_AddDevice__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/add-sim',component:__WEBPACK_IMPORTED_MODULE_27__Modules_AddSim__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/add-partner',component:__WEBPACK_IMPORTED_MODULE_29__Modules_AddPartner__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/add-manufacturer',component:__WEBPACK_IMPORTED_MODULE_39__Modules_AddManufacturer__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/AssignDevPartner',component:__WEBPACK_IMPORTED_MODULE_30__Modules_AssignDevPartner__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/customers',component:__WEBPACK_IMPORTED_MODULE_2__Customers__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/customers/view/:loginId',component:__WEBPACK_IMPORTED_MODULE_17__ViewCustomer__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/inventory/devices',component:__WEBPACK_IMPORTED_MODULE_18__InventoryDevices__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/DetailedAlerts',component:__WEBPACK_IMPORTED_MODULE_134__DetailedAlerts__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/PilRefuleAlerts',component:__WEBPACK_IMPORTED_MODULE_135__RefuelAndPilferageAlerts__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/inventory/sims',component:__WEBPACK_IMPORTED_MODULE_19__InventorySims__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/inventory/sims/bulk-upload',component:__WEBPACK_IMPORTED_MODULE_48__InventorySims_RegisterBulkSim__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/inventory/sims/bulk-delete',component:__WEBPACK_IMPORTED_MODULE_49__InventorySims_DeleteBulkSim__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/inventory/accessories',component:__WEBPACK_IMPORTED_MODULE_20__InventoryAccessories__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/inventory/outward',component:__WEBPACK_IMPORTED_MODULE_3__Inventory_outward__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/customers/edit/:loginId',component:__WEBPACK_IMPORTED_MODULE_21__EditCustomer__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/customers/add',component:__WEBPACK_IMPORTED_MODULE_16__RegisterCustomer__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/vehicle/commands',component:__WEBPACK_IMPORTED_MODULE_15__Modules_VehicleCommands__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/customer/vehicle/register/bulk',component:__WEBPACK_IMPORTED_MODULE_12__Modules_VehicleRegistartion_BulkVehicleRegistration_jsx__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/customer/vehicle/delete/bulk',component:__WEBPACK_IMPORTED_MODULE_13__Modules_VehicleRegistartion_BulkVehicleDelete__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/customer/vehicle/deactivate/bulk',component:__WEBPACK_IMPORTED_MODULE_14__Modules_VehicleRegistartion_BulkVehicleDeactivate__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/subscriptions/assign/:loginId/:subscriptionId/BulkAssignDevice',component:__WEBPACK_IMPORTED_MODULE_132__AssignDevices_bulkUploadAssignDevice__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/subscriptions/assign/:loginId/:subscriptionId/BulkAssignSim',component:__WEBPACK_IMPORTED_MODULE_133__AssignDevices_bulkUploadAssignSim__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/VehicleRegistration/:loginId',component:__WEBPACK_IMPORTED_MODULE_11__Modules_VehicleRegistartion__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/VehicleRegistration',component:__WEBPACK_IMPORTED_MODULE_11__Modules_VehicleRegistartion__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/device-topup',component:__WEBPACK_IMPORTED_MODULE_136__DeviceTopup__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/device-replacement',component:__WEBPACK_IMPORTED_MODULE_137__DeviceReplacement__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/vehicle-deactivation-activation',component:__WEBPACK_IMPORTED_MODULE_138__VehicleDeactivationActivation__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/vehicle-unregistration',component:__WEBPACK_IMPORTED_MODULE_139__VehicleUnregistration__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/solution-wise-unregistration',component:__WEBPACK_IMPORTED_MODULE_140__SolutionWiseUnregistration__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/device-shift',component:__WEBPACK_IMPORTED_MODULE_141__DeviceShift__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/Plans',component:__WEBPACK_IMPORTED_MODULE_23__Plans__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/Plans/addPlan',component:__WEBPACK_IMPORTED_MODULE_24__Plans_addPlan__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/subscriptions',component:__WEBPACK_IMPORTED_MODULE_31__Subscriptions__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/subscriptions/view',component:__WEBPACK_IMPORTED_MODULE_37__SubscriptionDetails__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/subscriptions/:subscriptionId/partnerSubscriptionDetail',component:__WEBPACK_IMPORTED_MODULE_127__Partner_PartnerSubscriptionDetail__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/subscriptions/new',component:__WEBPACK_IMPORTED_MODULE_33__NewSubscription__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/subscriptions/new/:loginId',component:__WEBPACK_IMPORTED_MODULE_33__NewSubscription__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/subscriptions/view/:loginId/:subscriptionId',component:__WEBPACK_IMPORTED_MODULE_32__ViewSubscription__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/partner/view/:loginId/:subscriptionId/subscriptionDetail',component:__WEBPACK_IMPORTED_MODULE_127__Partner_PartnerSubscriptionDetail__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/partner/view/:loginId/:subscriptionId/partnerSubscriptionEdit',component:__WEBPACK_IMPORTED_MODULE_129__EditPartnerSubscription__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/subscriptions/edit/:loginId/:subscriptionId',component:__WEBPACK_IMPORTED_MODULE_22__EditSubscription__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/Plans/view/:planId',component:__WEBPACK_IMPORTED_MODULE_38__ViewPlans__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/subscriptions/assign/:loginId/:subscriptionId',component:__WEBPACK_IMPORTED_MODULE_34__AssignDevices_AssignInventory_jsx__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/vehicles/edit/:entityId',component:__WEBPACK_IMPORTED_MODULE_41__Modules_VehicleRegistartion_VehicleEdit__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/subscriptions/deassign/:loginId/:subscriptionId',component:__WEBPACK_IMPORTED_MODULE_35__DeassignDevice_DeassignInventory_jsx__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/subscriptions/deassignSim/:loginId/:subscriptionId',component:__WEBPACK_IMPORTED_MODULE_36__DeassignDevice_DeassignSim_jsx__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/Gst',component:__WEBPACK_IMPORTED_MODULE_40__Reusable_Gst__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/DeviceInventory/BulkUpload',component:__WEBPACK_IMPORTED_MODULE_42__Modules_BulkDeviceUpload__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/DeviceInventory/DeviceBulkUpload',component:__WEBPACK_IMPORTED_MODULE_46__InventoryDevices_RegisterBulkDevice__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/SimInventory/BulkSimUpload'// for SA inv
,component:__WEBPACK_IMPORTED_MODULE_43__Modules_BulkSimUpload__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/AccessoryInventory/RegisterBulkAccessory'// for business admin inv
,component:__WEBPACK_IMPORTED_MODULE_52__InventoryAccessories_RegisterBulkAccessory__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/DeviceInventory/BulkDeviceAssign',component:__WEBPACK_IMPORTED_MODULE_45__Modules_BulkDeviceAssign__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/SimInventory/BulkSimAssign',component:__WEBPACK_IMPORTED_MODULE_44__Modules_BulkSimAssign__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/VehcileDashboard/Dashboard',component:__WEBPACK_IMPORTED_MODULE_50__Modules_VehcileDashboard__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/deviceDashboard/Dashboard',component:__WEBPACK_IMPORTED_MODULE_51__Modules_DeviceDashboard__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/RegisterReseller',component:__WEBPACK_IMPORTED_MODULE_53__RegisterReseller__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/AssignLicenses',component:__WEBPACK_IMPORTED_MODULE_54__AssignLicenses__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/device/api',component:__WEBPACK_IMPORTED_MODULE_55__Modules_PullApi__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/user/dashboard',component:__WEBPACK_IMPORTED_MODULE_57__Modules_UserDashboard_index_jsx__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/users/reseller',component:__WEBPACK_IMPORTED_MODULE_58__Reseller__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/reseller/view/:loginId',component:__WEBPACK_IMPORTED_MODULE_59__Reseller_ResellerView_jsx__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/reseller/edit/:loginId',component:__WEBPACK_IMPORTED_MODULE_60__Reseller_ResellerEdit_jsx__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/users/partner',component:__WEBPACK_IMPORTED_MODULE_61__Partner__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/users/manufacturer',component:__WEBPACK_IMPORTED_MODULE_62__Manufacturer__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/CreatePlan',component:__WEBPACK_IMPORTED_MODULE_56__Plans_createPlan_jsx__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/ViewLicense',component:__WEBPACK_IMPORTED_MODULE_63__Plans_ViewLicense_jsx__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/manage/purchase-requests',component:__WEBPACK_IMPORTED_MODULE_64__ManagePurchaseRequests__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/manage/purchase-requests/pending/:purchaseRequestId',component:__WEBPACK_IMPORTED_MODULE_65__ManagePurchaseRequests_ApprovePurchaseRequest_jsx__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/manage/purchase-requests/view/:purchaseRequestId',component:__WEBPACK_IMPORTED_MODULE_67__ManagePurchaseRequests_ViewPurchaseRequest_jsx__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/manage/purchase-requests/approved/:purchaseRequestId',component:__WEBPACK_IMPORTED_MODULE_66__ManagePurchaseRequests_AssignDevicesForPR_jsx__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/inventory/deviceview/:modelId',component:__WEBPACK_IMPORTED_MODULE_68__Modules_DeviceDashboard_ViewDevice__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/DeviceInventory/DeviceBulkDelete',component:__WEBPACK_IMPORTED_MODULE_47__InventoryDevices_DeleteBulkDevice__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/manage/purchase-SMS',component:__WEBPACK_IMPORTED_MODULE_69__SMSPurchase_PartnerSMSPurchase__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/manage/partner/purchase-SMS',component:__WEBPACK_IMPORTED_MODULE_70__SMSPurchase_ClientSMSPurchase__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/manage/partner/SalesReport',component:__WEBPACK_IMPORTED_MODULE_71__SMSPurchase_Reports_PartnerClientSMSReport__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/manage/admin/SalesReport',component:__WEBPACK_IMPORTED_MODULE_72__SMSPurchase_Reports_AdminClientSMSReport__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/VehicleDashboard/ViewVehicles:status',component:__WEBPACK_IMPORTED_MODULE_74__Modules_VehcileDashboard_ViewVehicleList__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/devices/view/:modelId',component:__WEBPACK_IMPORTED_MODULE_76__InventoryDevices_ViewInventoryDevices__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/customers/BulkRegister',component:__WEBPACK_IMPORTED_MODULE_77__RegisterCustomer_RegisterBulkCustomer_jsx__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/manage/Clear-Redis',component:__WEBPACK_IMPORTED_MODULE_88__ClearRedis__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/manage/create-demo-link',component:__WEBPACK_IMPORTED_MODULE_124__CreateDemoLink__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/manage/admin/CurrentTrackinfo',component:__WEBPACK_IMPORTED_MODULE_89__Modules_CurrentTrackinfo__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/superAdmin/CurrentTrackinfo',component:__WEBPACK_IMPORTED_MODULE_123__Modules_CurrentTrackinfo_SATrackinfo_jsx__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/settings/FuelCalibration',component:__WEBPACK_IMPORTED_MODULE_90__FuelCalibration__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/reports/IdleReport',component:__WEBPACK_IMPORTED_MODULE_93__IdleReport__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/manage/admin/PidsConfiguration',component:__WEBPACK_IMPORTED_MODULE_91__PidsConfiguration__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/manage/admin/DeviceDataKpi',component:__WEBPACK_IMPORTED_MODULE_92__DeviceDataKpi__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/partnerSubscriptions/assign/:loginId/:subscriptionId',component:__WEBPACK_IMPORTED_MODULE_95__AssignPartnerDevices_AssignPartnerInventory__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/reseller/licenses',component:__WEBPACK_IMPORTED_MODULE_96__reseller_module_License__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/reseller/licenses/view/:licenseId',component:__WEBPACK_IMPORTED_MODULE_97__reseller_module_License_ViewLicense__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/reseller/customers',component:__WEBPACK_IMPORTED_MODULE_98__reseller_module_Customers__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/reseller/customers/add',component:__WEBPACK_IMPORTED_MODULE_99__reseller_module_Customers_RegisterCustomer__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/reseller/customers/view/:loginId',component:__WEBPACK_IMPORTED_MODULE_100__reseller_module_Customers_ViewCustomer__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/reseller/customers/edit/:loginId',component:__WEBPACK_IMPORTED_MODULE_101__reseller_module_Customers_EditCustomer__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/reseller/subscriptions',component:__WEBPACK_IMPORTED_MODULE_102__reseller_module_Subscriptions__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/reseller/subscriptions/view/:loginId/:subscriptionId',component:__WEBPACK_IMPORTED_MODULE_103__reseller_module_Subscriptions_ViewSubscription__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/reseller/subscriptions/new',component:__WEBPACK_IMPORTED_MODULE_104__reseller_module_Subscriptions_NewSubscription__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/reseller/subscriptions/new/:loginId',component:__WEBPACK_IMPORTED_MODULE_104__reseller_module_Subscriptions_NewSubscription__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/reseller/subscriptions/edit/:loginId/:subscriptionId',component:__WEBPACK_IMPORTED_MODULE_105__reseller_module_Subscriptions_EditSubscription__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/reseller/subscriptions/assign/:loginId/:subscriptionId',component:__WEBPACK_IMPORTED_MODULE_106__reseller_module_Subscriptions_AssignDevices__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/reseller/devices',component:__WEBPACK_IMPORTED_MODULE_107__reseller_module_InventoryDevices__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/reseller/devices/bulk-register',component:__WEBPACK_IMPORTED_MODULE_109__reseller_module_InventoryDevices_RegisterBulkDevices__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/reseller/devices/view/:modelId',component:__WEBPACK_IMPORTED_MODULE_108__reseller_module_InventoryDevices_ViewInventoryDevices__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/reseller/accessories',component:__WEBPACK_IMPORTED_MODULE_110__reseller_module_InventoryAccessories__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/reseller/accessories/bulk-register',component:__WEBPACK_IMPORTED_MODULE_111__reseller_module_InventoryAccessories_RegisterBulkAccessories__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/reseller/sims',component:__WEBPACK_IMPORTED_MODULE_112__reseller_module_InventorySims__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/reseller/sims/bulk-register',component:__WEBPACK_IMPORTED_MODULE_113__reseller_module_InventorySims_RegisterBulkSim__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/reseller/vehicles/register',component:__WEBPACK_IMPORTED_MODULE_114__reseller_module_VehicleRegistartion__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/reseller/vehicles/edit/:entityId',component:__WEBPACK_IMPORTED_MODULE_115__reseller_module_VehicleRegistartion_VehicleEdit__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/reseller/vehicles/bulk-register',component:__WEBPACK_IMPORTED_MODULE_116__reseller_module_VehicleRegistartion_BulkRegistration__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/reseller/VehicleDashboard/ViewVehicles:status',component:__WEBPACK_IMPORTED_MODULE_121__reseller_module_VehcileDashboard_ViewVehicleList__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/reseller/VehcileDashboard/Dashboard',component:__WEBPACK_IMPORTED_MODULE_122__reseller_module_VehcileDashboard__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/reseller/purchase-request',component:__WEBPACK_IMPORTED_MODULE_117__reseller_module_PurchaseRequest__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/reseller/purchase-request/new',component:__WEBPACK_IMPORTED_MODULE_118__reseller_module_PurchaseRequest_NewRequest_jsx__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/reseller/purchase-request/pending/:purchaseRequestId',component:__WEBPACK_IMPORTED_MODULE_119__reseller_module_PurchaseRequest_ViewPendingRequest_jsx__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/reseller/purchase-request/view/:purchaseRequestId',component:__WEBPACK_IMPORTED_MODULE_120__reseller_module_PurchaseRequest_ViewRequest_jsx__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/reseller/purchase-request/view/:purchaseRequestId',component:__WEBPACK_IMPORTED_MODULE_73__PanicAlertBitConfigurationSettings__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/manage/admin/PanicAlertBitConfigurationSettings',component:__WEBPACK_IMPORTED_MODULE_73__PanicAlertBitConfigurationSettings__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/manage/admin/CurrentSummary',component:__WEBPACK_IMPORTED_MODULE_75__Modules_CurrentSummary__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/manage/admin/InvoiceDetails',component:__WEBPACK_IMPORTED_MODULE_78__Billing_InvoiceDetails__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/manage/admin/CreateProformaInvoice/:id',component:__WEBPACK_IMPORTED_MODULE_79__Billing_CreateProformaInvoice__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/manage/admin/CreatePartnerProformaInvoice/:id',component:__WEBPACK_IMPORTED_MODULE_94__Billing_CreatePartnerProformaInvoice__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/manage/search-Device',component:__WEBPACK_IMPORTED_MODULE_80__SearchDevice__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/manage/sparepart',component:__WEBPACK_IMPORTED_MODULE_126__SparePartReplacement__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/manage/makePayment/:id',component:__WEBPACK_IMPORTED_MODULE_81__Billing_MakePayment__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/manage/histroyPacketRcv',component:__WEBPACK_IMPORTED_MODULE_82__Billing_HistoryPacketReceived__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/manage/billingDays',component:__WEBPACK_IMPORTED_MODULE_83__Billing_BillingDays__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/manage/billingHistoryReport',component:__WEBPACK_IMPORTED_MODULE_85__Billing_BillingHistoryReport__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/partner/view/:loginId',component:__WEBPACK_IMPORTED_MODULE_86__Partner_PartnerView_jsx__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/partner/view/:loginId/add-subscription',component:__WEBPACK_IMPORTED_MODULE_128__Partner_SubscriptionForm__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/partner/edit/:loginId',component:__WEBPACK_IMPORTED_MODULE_87__Partner_PartnerEdit_jsx__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/manage/api-dashboard',render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_125__APIDashboard__["a" /* default */],null);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/manage/heremaps',component:__WEBPACK_IMPORTED_MODULE_130__HereMapsDashboard_HereMapsDashboard__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/Plans/editPlan/:planId',component:__WEBPACK_IMPORTED_MODULE_131__Plans_EditPlan__["a" /* default */]}))));}}]);return AppShell;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_10__material_ui_core_withWidth___default()()(Object(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles__["withStyles"])(style)(AppShell)));

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_file_saver__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_common_Loader__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_FormControlLabel__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_FormControlLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_FormControlLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_Switch__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_Switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_Switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__HOCs_withSharedSnackbar__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query allClientDetails($partnerLoginId: Int) {\n    clients: allClientDetails(partnerLoginId: $partnerLoginId) {\n      id\n      clientName\n      contactPerson\n      contactNumber\n      email\n      totalAssignedVehicle\n      plan {\n        id\n        planName\n      }\n      loginId\n      trackingDetails {\n        trackingCount\n        nonTrackingCount\n      }\n      createdAt\n      type\n      zonalManager\n      keyAccountManager\n      channelPartnerName\n      solutionMaster {\n        id\n        solutionTypeName\n      }\n      totalPotentialVehicles\n    }\n  }\n'],['\n  query allClientDetails($partnerLoginId: Int) {\n    clients: allClientDetails(partnerLoginId: $partnerLoginId) {\n      id\n      clientName\n      contactPerson\n      contactNumber\n      email\n      totalAssignedVehicle\n      plan {\n        id\n        planName\n      }\n      loginId\n      trackingDetails {\n        trackingCount\n        nonTrackingCount\n      }\n      createdAt\n      type\n      zonalManager\n      keyAccountManager\n      channelPartnerName\n      solutionMaster {\n        id\n        solutionTypeName\n      }\n      totalPotentialVehicles\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query AllClientDetailsLimited($partnerLoginId: Int) {\n    clients: allClientDetailsLimited(partnerLoginId: $partnerLoginId) {\n      id\n      clientName\n      contactPerson\n      email\n      contactNumber\n      planName\n      totalVehicles\n      createdAt\n      accountType\n      zonalManager\n      keyAccountManager\n      channelPartnerName\n      loginId\n      totalPotentialVehicles\n    }\n  }\n'],['\n  query AllClientDetailsLimited($partnerLoginId: Int) {\n    clients: allClientDetailsLimited(partnerLoginId: $partnerLoginId) {\n      id\n      clientName\n      contactPerson\n      email\n      contactNumber\n      planName\n      totalVehicles\n      createdAt\n      accountType\n      zonalManager\n      keyAccountManager\n      channelPartnerName\n      loginId\n      totalPotentialVehicles\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n'],['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query GetAdminUserDetailsByRole($roleName: [String]) {\n    getAdminUserDetailsByRole(roleName: $roleName) {\n      id\n      role\n      username\n    }\n  }\n'],['\n  query GetAdminUserDetailsByRole($roleName: [String]) {\n    getAdminUserDetailsByRole(roleName: $roleName) {\n      id\n      role\n      username\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable */var GET_CLIENTS=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject);var GET_CLIENTS_LIMITED=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject2);var GET_FILE_FORMAT=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject3);var GET_ZM_KAM_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject4);var roleNames=["Zonal Manager(ZM)","Key Account Manager(KAM)"];var style=function style(theme){var _root;return{root:(_root={padding:theme.spacing.unit*4},_defineProperty(_root,theme.breakpoints.down('sm'),{padding:theme.spacing.unit*2}),_defineProperty(_root,'flexGrow',1),_root),paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},iconSmall:{fontSize:20}};};var Customers=function(_Component){_inherits(Customers,_Component);function Customers(props){var _this2=this;_classCallCheck(this,Customers);var _this=_possibleConstructorReturn(this,(Customers.__proto__||Object.getPrototypeOf(Customers)).call(this,props));_this.state={rowsPerPage:15,viewMore:false};_this.loginId=[];_this.fullData=[];_this.columns=['CLIENT NAME','CONTACT PERSON','EMAIL','PHONE NUMBER','TOTAL VEHICLES','TRACKING VEHICLES','NONTRACKING VEHICLES','PLAN','CREATED DATE','ACCOUNT TYPE','ZONAL MANAGER','KEY ACCOUNT MANAGER','CHANNEL PARTNER',{name:'SOLUTION',options:{setCellProps:function setCellProps(){return{style:{minWidth:'250px',maxWidth:'400px',whiteSpace:'normal',wordWrap:'break-word'}};},setCellHeaderProps:function setCellHeaderProps(){return{style:{minWidth:'250px',maxWidth:'400px'}};},customBodyRender:function customBodyRender(value){if(!value)return'-';var lines=value.split(',').map(function(name){return name.trim();}).join('<br/>');return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:lines}});}}},'TOTAL POTENTIAL VEHICLES'];_this.limitedColumns=['CLIENT NAME','CONTACT PERSON','EMAIL','PHONE NUMBER','TOTAL VEHICLES','PLAN','CREATED DATE','ACCOUNT TYPE','ZONAL MANAGER','KEY ACCOUNT MANAGER','CHANNEL PARTNER','TOTAL POTENTIAL VEHICLES'];_this.options={selectableRows:false,filter:false,responsive:'scroll',rowsPerPage:15,print:false,onRowClick:function onRowClick(rowData,dataIndex,rowIndex){_this.props.history.push({pathname:'/home/customers/view/'+_this.loginId[dataIndex.dataIndex]});}};_this.onChangeRowsPerPage=function(rowsPerPage){_this.setState({rowsPerPage:rowsPerPage});};_this.handleToggleChange=function(event){_this.setState({viewMore:event.target.checked});};_this.addCustomer=function(e){_this.props.history.push({pathname:'/home/customers/add'});};_this.addBulkCustomer=function(e){_this.props.history.push({pathname:'/home/customers/BulkRegister'});};_this.downloadBulkUpload=function(client){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _ref2,data,res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.client.query({query:GET_FILE_FORMAT,variables:{bucketname:'excel-templates',filename:'clientUpload.xlsx'},errorPolicy:'all'});case 2:_ref2=_context.sent;data=_ref2.data;_context.next=6;return __WEBPACK_IMPORTED_MODULE_11_axios___default()({url:data.getPublicDownloadURL,method:'GET',headers:{Accept:'application/vnd.ms-excel'},responseType:'blob'// important
});case 6:res=_context.sent;__WEBPACK_IMPORTED_MODULE_10_file_saver___default.a.saveAs(new Blob([res.data]),'sample.xlsx');case 8:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();};_this.getFormattedDate=function(timestamp){return __WEBPACK_IMPORTED_MODULE_12_moment___default()(timestamp*1000).format('DD-MM-YYYY');};_this.classes=props;return _this;}_createClass(Customers,[{key:'mapToArr',value:function mapToArr(clients,zonalManagers,keyAccountManagers){var _this3=this;this.fullData=[];this.loginId=[];var viewMore=this.state.viewMore;clients.forEach(function(element){var rowData=[];_this3.loginId.push(element.loginId);rowData.push(element.clientName);rowData.push(element.contactPerson);rowData.push(element.email);rowData.push(element.contactNumber);if(viewMore){// Full Data mapping
var trackingCount=element.trackingDetails?element.trackingDetails.trackingCount:'NA';var nonTrackingCount=element.trackingDetails?element.trackingDetails.nonTrackingCount:'NA';rowData.push(element.totalAssignedVehicle);rowData.push(trackingCount);rowData.push(nonTrackingCount);if(element.plan){rowData.push(element.plan.planName);}else{rowData.push('NA');}rowData.push(_this3.getFormattedDate(element.createdAt));rowData.push(element.type);}else{// Limited Data mapping
rowData.push(element.totalVehicles);rowData.push(element.planName||'NA');rowData.push(_this3.getFormattedDate(element.createdAt));rowData.push(element.accountType);}if(element.zonalManager){var zm=zonalManagers.find(function(zm){return zm.id===element.zonalManager;});rowData.push(zm?zm.username:element.zonalManager||'-');}else{rowData.push('-');}if(element.keyAccountManager){var kam=keyAccountManagers.find(function(kam){return kam.id===element.keyAccountManager;});rowData.push(kam?kam.username:element.keyAccountManager||'-');}else{rowData.push('-');}if(element.channelPartnerName){rowData.push(element.channelPartnerName);}else{rowData.push("-");}if(viewMore){if(Array.isArray(element.solutionMaster)&&element.solutionMaster.length>0){var solutionNames=element.solutionMaster.map(function(s){return s.solutionTypeName;}).join(', ');rowData.push(solutionNames);}else{rowData.push('-');}rowData.push(element.totalPotentialVehicles||0);}else{rowData.push(element.totalPotentialVehicles||0);}_this3.fullData.push(rowData);});}},{key:'render',value:function render(){var _this4=this;var classes=this.props.classes;var options={selectableRows:false,filter:false,responsive:'scroll',rowsPerPage:this.state.rowsPerPage,onChangeRowsPerPage:this.onChangeRowsPerPage,onRowClick:function onRowClick(rowData,dataIndex,rowIndex){_this4.props.history.push({pathname:'/home/customers/view/'+_this4.loginId[dataIndex.dataIndex]});}};return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Grid___default.a,{container:true,justify:'space-between',spacing:16,alignItems:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'headline'},'Customers')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Grid___default.a,{container:true,spacing:8,justify:'flex-end',alignItems:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_Switch___default.a,{checked:this.state.viewMore,onChange:this.handleToggleChange,color:'primary'}),label:'View More Details'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Grid___default.a,{item:true,xs:12,sm:'auto'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{fullWidth:true,color:'secondary',onClick:this.addCustomer,variant:'raised',className:this.classes.button},'Add Customer')))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Grid___default.a,{item:true,xs:12,style:{width:'95%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["Query"],{query:this.state.viewMore?GET_CLIENTS:GET_CLIENTS_LIMITED,variables:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_9__utils_getLoginId__["a" /* default */])()},fetchPolicy:this.state.viewMore?"network-only":"cache-first"},function(_ref3){var loadingClients=_ref3.loading,errorClients=_ref3.error,_ref3$data=_ref3.data,data=_ref3$data===undefined?{}:_ref3$data;var clients=data.clients||[];return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["Query"],{query:GET_ZM_KAM_DETAILS,variables:{roleName:roleNames}// fetchPolicy="network-only"
},function(_ref4){var loadingZMKAM=_ref4.loading,errorZMKAM=_ref4.error,_ref4$data=_ref4.data;_ref4$data=_ref4$data===undefined?{}:_ref4$data;var getAdminUserDetailsByRole=_ref4$data.getAdminUserDetailsByRole;if(loadingClients||loadingZMKAM)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_common_Loader__["a" /* default */],null);if(errorClients)return'Error with clients: '+errorClients.message;if(errorZMKAM)return'Error with ZM/KAM details: '+errorZMKAM.message;// Process clients and ZM/KAM details
var zonalManagers=getAdminUserDetailsByRole?getAdminUserDetailsByRole.filter(function(user){return user.role==="Zonal Manager(ZM)";}):[];var keyAccountManagers=getAdminUserDetailsByRole?getAdminUserDetailsByRole.filter(function(user){return user.role==="Key Account Manager(KAM)";}):[];_this4.mapToArr(clients,zonalManagers,keyAccountManagers);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_mui_datatables___default.a,{data:_this4.fullData,columns:_this4.state.viewMore?_this4.columns:_this4.limitedColumns,options:options});});}))));}}]);return Customers;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_16__HOCs_withSharedSnackbar__["a" /* default */])(Customers))));

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(906);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 906 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'table',
      fontFamily: theme.typography.fontFamily,
      width: '100%',
      borderCollapse: 'collapse',
      borderSpacing: 0
    }
  };
};

exports.styles = styles;

var Table =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Table, _React$Component);

  function Table() {
    (0, _classCallCheck2.default)(this, Table);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Table).apply(this, arguments));
  }

  (0, _createClass2.default)(Table, [{
    key: "getChildContext",
    value: function getChildContext() {
      // eslint-disable-line class-methods-use-this
      return {
        table: {
          padding: this.props.padding
        }
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          className = _this$props.className,
          Component = _this$props.component,
          padding = _this$props.padding,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["classes", "className", "component", "padding"]);
      return _react.default.createElement(Component, (0, _extends2.default)({
        className: (0, _classnames.default)(classes.root, className)
      }, other));
    }
  }]);
  return Table;
}(_react.default.Component);

Table.propTypes =  false ? {
  /**
   * The content of the table, normally `TableHeader` and `TableBody`.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Allows TableCells to inherit padding of the Table.
   */
  padding: _propTypes.default.oneOf(['default', 'checkbox', 'dense', 'none'])
} : {};
Table.defaultProps = {
  component: 'table',
  padding: 'default'
};
Table.childContextTypes = {
  table: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTable'
})(Table);

exports.default = _default;

/***/ }),
/* 908 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * This method is like `_.assign` except that it accepts `customizer`
 * which is invoked to produce the assigned values. If `customizer` returns
 * `undefined`, assignment is handled by the method instead. The `customizer`
 * is invoked with five arguments: (objValue, srcValue, key, object, source).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @see _.assignInWith
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   return _.isUndefined(objValue) ? srcValue : objValue;
 * }
 *
 * var defaults = _.partialRight(_.assignWith, customizer);
 *
 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
  copyObject(source, keys(source), object, customizer);
});

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = assignWith;


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
  var result;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      if (isHostObject(value)) {
        return object ? value : {};
      }
      result = initCloneObject(isFunc ? {} : value);
      if (!isDeep) {
        return copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (!isArr) {
    var props = isFull ? getAllKeys(value) : keys(value);
  }
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
  });
  return result;
}

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(proto) {
  return isObject(proto) ? objectCreate(proto) : {};
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var result = new buffer.constructor(buffer.length);
  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, true, true);
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = cloneDeep;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(72), __webpack_require__(227)(module)))

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for comparison styles. */
var UNORDERED_COMPARE_FLAG = 1,
    PARTIAL_COMPARE_FLAG = 2;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991,
    MAX_INTEGER = 1.7976931348623157e+308,
    NAN = 0 / 0;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, customizer, bitmask, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = arrayTag,
      othTag = arrayTag;

  if (!objIsArr) {
    objTag = getTag(object);
    objTag = objTag == argsTag ? objectTag : objTag;
  }
  if (!othIsArr) {
    othTag = getTag(other);
    othTag = othTag == argsTag ? objectTag : othTag;
  }
  var objIsObj = objTag == objectTag && !isHostObject(object),
      othIsObj = othTag == objectTag && !isHostObject(other),
      isSameTag = objTag == othTag;

  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
  }
  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
  };
}

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!seen.has(othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
              return seen.add(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, customizer, bitmask, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= UNORDERED_COMPARE_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      objProps = keys(object),
      objLength = objProps.length,
      othProps = keys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = isKey(path, object) ? [path] : castPath(path);

  var result,
      index = -1,
      length = path.length;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result) {
    return result;
  }
  var length = object ? object.length : 0;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity]
 *  The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array ? array.length : 0;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity]
 *  The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = find;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(72), __webpack_require__(227)(module)))

/***/ }),
/* 911 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

module.exports = isUndefined;


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeMax = Math.max,
    nativeNow = Date.now;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = merge;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(72), __webpack_require__(227)(module)))

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'table-row-group'
  }
};
exports.styles = styles;

var TableBody =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(TableBody, _React$Component);

  function TableBody() {
    (0, _classCallCheck2.default)(this, TableBody);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TableBody).apply(this, arguments));
  }

  (0, _createClass2.default)(TableBody, [{
    key: "getChildContext",
    value: function getChildContext() {
      // eslint-disable-line class-methods-use-this
      return {
        tablelvl2: {
          variant: 'body'
        }
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          className = _this$props.className,
          Component = _this$props.component,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["classes", "className", "component"]);
      return _react.default.createElement(Component, (0, _extends2.default)({
        className: (0, _classnames.default)(classes.root, className)
      }, other));
    }
  }]);
  return TableBody;
}(_react.default.Component);

TableBody.propTypes =  false ? {
  /**
   * The content of the component, normally `TableRow`.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object])
} : {};
TableBody.defaultProps = {
  component: 'tbody'
};
TableBody.childContextTypes = {
  tablelvl2: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTableBody'
})(TableBody);

exports.default = _default;

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _helpers = __webpack_require__(51);

var _colorManipulator = __webpack_require__(80);

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'table-cell',
      verticalAlign: 'inherit',
      // Workaround for a rendering bug with spanned columns in Chrome 62.0.
      // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
      borderBottom: "1px solid\n    ".concat(theme.palette.type === 'light' ? (0, _colorManipulator.lighten)((0, _colorManipulator.fade)(theme.palette.divider, 1), 0.88) : (0, _colorManipulator.darken)((0, _colorManipulator.fade)(theme.palette.divider, 1), 0.8)),
      textAlign: 'left',
      padding: '4px 56px 4px 24px',
      '&:last-child': {
        paddingRight: 24
      }
    },

    /* Styles applied to the root element if `variant="head"` or `context.table.head`. */
    head: {
      color: theme.palette.text.secondary,
      fontSize: theme.typography.pxToRem(12),
      fontWeight: theme.typography.fontWeightMedium
    },

    /* Styles applied to the root element if `variant="body"` or `context.table.body`. */
    body: {
      color: theme.palette.text.primary,
      fontSize: theme.typography.pxToRem(13),
      fontWeight: theme.typography.fontWeightRegular
    },

    /* Styles applied to the root element if `variant="footer"` or `context.table.footer`. */
    footer: {
      borderBottom: 0,
      color: theme.palette.text.secondary,
      fontSize: theme.typography.pxToRem(12)
    },

    /* Styles applied to the root element if `numeric={true}`. */
    numeric: {
      textAlign: 'right',
      flexDirection: 'row-reverse' // can be dynamically inherited at runtime by contents

    },

    /* Styles applied to the root element if `padding="dense"`. */
    paddingDense: {
      paddingRight: 24
    },

    /* Styles applied to the root element if `padding="checkbox"`. */
    paddingCheckbox: {
      padding: '0 12px',
      '&:last-child': {
        paddingRight: 12
      }
    },

    /* Styles applied to the root element if `padding="none"`. */
    paddingNone: {
      padding: 0,
      '&:last-child': {
        padding: 0
      }
    }
  };
};

exports.styles = styles;

function TableCell(props, context) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      component = props.component,
      sortDirection = props.sortDirection,
      numeric = props.numeric,
      paddingProp = props.padding,
      scopeProp = props.scope,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "sortDirection", "numeric", "padding", "scope", "variant"]);
  var table = context.table,
      tablelvl2 = context.tablelvl2;
  var Component;

  if (component) {
    Component = component;
  } else {
    Component = tablelvl2 && tablelvl2.variant === 'head' ? 'th' : 'td';
  }

  var scope = scopeProp;

  if (!scope && tablelvl2 && tablelvl2.variant === 'head') {
    scope = 'col';
  }

  var padding = paddingProp || (table && table.padding ? table.padding : 'default');
  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.head, variant ? variant === 'head' : tablelvl2 && tablelvl2.variant === 'head'), (0, _defineProperty2.default)(_classNames, classes.body, variant ? variant === 'body' : tablelvl2 && tablelvl2.variant === 'body'), (0, _defineProperty2.default)(_classNames, classes.footer, variant ? variant === 'footer' : tablelvl2 && tablelvl2.variant === 'footer'), (0, _defineProperty2.default)(_classNames, classes.numeric, numeric), (0, _defineProperty2.default)(_classNames, classes["padding".concat((0, _helpers.capitalize)(padding))], padding !== 'default'), _classNames), classNameProp);
  var ariaSort = null;

  if (sortDirection) {
    ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
  }

  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className,
    "aria-sort": ariaSort,
    scope: scope
  }, other), children);
}

TableCell.propTypes =  false ? {
  /**
   * The table cell contents.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, content will align to the right.
   */
  numeric: _propTypes.default.bool,

  /**
   * Sets the padding applied to the cell.
   * By default, the Table parent component set the value.
   */
  padding: _propTypes.default.oneOf(['default', 'checkbox', 'dense', 'none']),

  /**
   * Set scope attribute.
   */
  scope: _propTypes.default.string,

  /**
   * Set aria-sort direction.
   */
  sortDirection: _propTypes.default.oneOf(['asc', 'desc', false]),

  /**
   * Specify the cell type.
   * By default, the TableHead, TableBody or TableFooter parent component set the value.
   */
  variant: _propTypes.default.oneOf(['head', 'body', 'footer'])
} : {};
TableCell.defaultProps = {
  numeric: false
};
TableCell.contextTypes = {
  table: _propTypes.default.object,
  tablelvl2: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTableCell'
})(TableCell);

exports.default = _default;

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: 'inherit',
      display: 'table-row',
      height: 48,
      verticalAlign: 'middle',
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 'none',
      '&$selected': {
        backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.04)' // grey[100]
        : 'rgba(255, 255, 255, 0.08)'
      },
      '&$hover:hover': {
        backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.07)' // grey[200]
        : 'rgba(255, 255, 255, 0.14)'
      }
    },

    /* Styles applied to the root element if `selected={true}`. */
    selected: {},

    /* Styles applied to the root element if `hover={true}`. */
    hover: {},

    /* Styles applied to the root element if table variant = 'head'. */
    head: {
      height: 56
    },

    /* Styles applied to the root element if table variant = 'footer'. */
    footer: {
      height: 56
    }
  };
};
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */


exports.styles = styles;

function TableRow(props, context) {
  var _classNames;

  var classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      hover = props.hover,
      selected = props.selected,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "hover", "selected"]);
  var tablelvl2 = context.tablelvl2;
  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.head, tablelvl2 && tablelvl2.variant === 'head'), (0, _defineProperty2.default)(_classNames, classes.footer, tablelvl2 && tablelvl2.variant === 'footer'), (0, _defineProperty2.default)(_classNames, classes.hover, hover), (0, _defineProperty2.default)(_classNames, classes.selected, selected), _classNames), classNameProp);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className
  }, other));
}

TableRow.propTypes =  false ? {
  /**
   * Should be valid <tr> children such as `TableCell`.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the table row will shade on hover.
   */
  hover: _propTypes.default.bool,

  /**
   * If `true`, the table row will have the selected shading.
   */
  selected: _propTypes.default.bool
} : {};
TableRow.defaultProps = {
  component: 'tr',
  hover: false,
  selected: false
};
TableRow.contextTypes = {
  tablelvl2: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTableRow'
})(TableRow);

exports.default = _default;

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _SwitchBase = _interopRequireDefault(__webpack_require__(307));

var _CheckBoxOutlineBlank = _interopRequireDefault(__webpack_require__(917));

var _CheckBox = _interopRequireDefault(__webpack_require__(918));

var _IndeterminateCheckBox = _interopRequireDefault(__webpack_require__(919));

var _helpers = __webpack_require__(51);

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: theme.palette.text.secondary
    },

    /* Styles applied to the root element if `checked={true}`. */
    checked: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      '&$checked': {
        color: theme.palette.primary.main
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      '&$checked': {
        color: theme.palette.secondary.main
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    }
  };
};

exports.styles = styles;

function Checkbox(props) {
  var checkedIcon = props.checkedIcon,
      classes = props.classes,
      color = props.color,
      icon = props.icon,
      indeterminate = props.indeterminate,
      indeterminateIcon = props.indeterminateIcon,
      other = (0, _objectWithoutProperties2.default)(props, ["checkedIcon", "classes", "color", "icon", "indeterminate", "indeterminateIcon"]);
  return _react.default.createElement(_SwitchBase.default, (0, _extends2.default)({
    type: "checkbox",
    checkedIcon: indeterminate ? indeterminateIcon : checkedIcon,
    classes: {
      root: (0, _classnames.default)(classes.root, classes["color".concat((0, _helpers.capitalize)(color))]),
      checked: classes.checked,
      disabled: classes.disabled
    },
    icon: indeterminate ? indeterminateIcon : icon
  }, other));
}

Checkbox.propTypes =  false ? {
  /**
   * If `true`, the component is checked.
   */
  checked: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['primary', 'secondary', 'default']),

  /**
   * If `true`, the switch will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes.default.bool,

  /**
   * The icon to display when the component is unchecked.
   */
  icon: _propTypes.default.node,

  /**
   * The id of the `input` element.
   */
  id: _propTypes.default.string,

  /**
   * If `true`, the component appears indeterminate.
   */
  indeterminate: _propTypes.default.bool,

  /**
   * The icon to display when the component is indeterminate.
   */
  indeterminateIcon: _propTypes.default.node,

  /**
   * Properties applied to the `input` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.checked`.
   * @param {boolean} checked The `checked` value of the switch
   */
  onChange: _propTypes.default.func,

  /**
   * The input component property `type`.
   */
  type: _propTypes.default.string,

  /**
   * The value of the component.
   */
  value: _propTypes.default.string
} : {};
Checkbox.defaultProps = {
  checkedIcon: _react.default.createElement(_CheckBox.default, null),
  color: 'secondary',
  icon: _react.default.createElement(_CheckBoxOutlineBlank.default, null),
  indeterminate: false,
  indeterminateIcon: _react.default.createElement(_IndeterminateCheckBox.default, null)
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiCheckbox'
})(Checkbox);

exports.default = _default;

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _pure = _interopRequireDefault(__webpack_require__(81));

var _SvgIcon = _interopRequireDefault(__webpack_require__(73));

var _ref = _react.default.createElement("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
});

/**
 * @ignore - internal component.
 */
var CheckBoxOutlineBlank = function CheckBoxOutlineBlank(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

CheckBoxOutlineBlank = (0, _pure.default)(CheckBoxOutlineBlank);
CheckBoxOutlineBlank.muiName = 'SvgIcon';
var _default = CheckBoxOutlineBlank;
exports.default = _default;

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _pure = _interopRequireDefault(__webpack_require__(81));

var _SvgIcon = _interopRequireDefault(__webpack_require__(73));

var _ref = _react.default.createElement("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
});

/**
 * @ignore - internal component.
 */
var CheckBox = function CheckBox(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

CheckBox = (0, _pure.default)(CheckBox);
CheckBox.muiName = 'SvgIcon';
var _default = CheckBox;
exports.default = _default;

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _pure = _interopRequireDefault(__webpack_require__(81));

var _SvgIcon = _interopRequireDefault(__webpack_require__(73));

var _ref = _react.default.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
});

/**
 * @ignore - internal component.
 */
var IndeterminateCheckBox = function IndeterminateCheckBox(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

IndeterminateCheckBox = (0, _pure.default)(IndeterminateCheckBox);
IndeterminateCheckBox.muiName = 'SvgIcon';
var _default = IndeterminateCheckBox;
exports.default = _default;

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _shouldUpdate = __webpack_require__(921);

var _shouldUpdate2 = _interopRequireDefault(_shouldUpdate);

var _shallowEqual = __webpack_require__(961);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _setDisplayName = __webpack_require__(493);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(494);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pure = function pure(BaseComponent) {
  var hoc = (0, _shouldUpdate2.default)(function (props, nextProps) {
    return !(0, _shallowEqual2.default)(props, nextProps);
  });

  if (false) {
    return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'pure'))(hoc(BaseComponent));
  }

  return hoc(BaseComponent);
};

exports.default = pure;

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(922);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(923);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(951);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _setDisplayName = __webpack_require__(493);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(494);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = (0, _react.createFactory)(BaseComponent);

    var ShouldUpdate = function (_Component) {
      (0, _inherits3.default)(ShouldUpdate, _Component);

      function ShouldUpdate() {
        (0, _classCallCheck3.default)(this, ShouldUpdate);
        return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
      }

      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test(this.props, nextProps);
      };

      ShouldUpdate.prototype.render = function render() {
        return factory(this.props);
      };

      return ShouldUpdate;
    }(_react.Component);

    if (false) {
      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
    }
    return ShouldUpdate;
  };
};

exports.default = shouldUpdate;

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(481);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(925), __esModule: true };

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(926);
__webpack_require__(937);
module.exports = __webpack_require__(318).f('iterator');


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(927)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(482)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(308);
var defined = __webpack_require__(309);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 928 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(312);
var descriptor = __webpack_require__(234);
var setToStringTag = __webpack_require__(317);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(150)(IteratorPrototype, __webpack_require__(155)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(151);
var anObject = __webpack_require__(180);
var getKeys = __webpack_require__(313);

module.exports = __webpack_require__(153) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(488);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(154);
var toLength = __webpack_require__(933);
var toAbsoluteIndex = __webpack_require__(934);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(308);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(308);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(109).document;
module.exports = document && document.documentElement;


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(122);
var toObject = __webpack_require__(489);
var IE_PROTO = __webpack_require__(314)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(938);
var global = __webpack_require__(109);
var hide = __webpack_require__(150);
var Iterators = __webpack_require__(311);
var TO_STRING_TAG = __webpack_require__(155)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(939);
var step = __webpack_require__(940);
var Iterators = __webpack_require__(311);
var toIObject = __webpack_require__(154);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(482)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 939 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 940 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(942), __esModule: true };

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(943);
__webpack_require__(948);
__webpack_require__(949);
__webpack_require__(950);
module.exports = __webpack_require__(149).Symbol;


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(109);
var has = __webpack_require__(122);
var DESCRIPTORS = __webpack_require__(153);
var $export = __webpack_require__(232);
var redefine = __webpack_require__(486);
var META = __webpack_require__(944).KEY;
var $fails = __webpack_require__(233);
var shared = __webpack_require__(315);
var setToStringTag = __webpack_require__(317);
var uid = __webpack_require__(235);
var wks = __webpack_require__(155);
var wksExt = __webpack_require__(318);
var wksDefine = __webpack_require__(319);
var enumKeys = __webpack_require__(945);
var isArray = __webpack_require__(946);
var anObject = __webpack_require__(180);
var isObject = __webpack_require__(152);
var toObject = __webpack_require__(489);
var toIObject = __webpack_require__(154);
var toPrimitive = __webpack_require__(310);
var createDesc = __webpack_require__(234);
var _create = __webpack_require__(312);
var gOPNExt = __webpack_require__(947);
var $GOPD = __webpack_require__(492);
var $GOPS = __webpack_require__(490);
var $DP = __webpack_require__(151);
var $keys = __webpack_require__(313);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(491).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(320).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(231)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(150)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(235)('meta');
var isObject = __webpack_require__(152);
var has = __webpack_require__(122);
var setDesc = __webpack_require__(151).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(233)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(313);
var gOPS = __webpack_require__(490);
var pIE = __webpack_require__(320);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(488);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(154);
var gOPN = __webpack_require__(491).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 948 */
/***/ (function(module, exports) {



/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(319)('asyncIterator');


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(319)('observable');


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(952);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(956);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(481);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(953), __esModule: true };

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(954);
module.exports = __webpack_require__(149).Object.setPrototypeOf;


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(232);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(955).set });


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(152);
var anObject = __webpack_require__(180);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(483)(Function.call, __webpack_require__(492).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(957), __esModule: true };

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(958);
var $Object = __webpack_require__(149).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(232);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(312) });


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */
    return BaseComponent;
  };
};

exports.default = setStatic;

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getDisplayName = function getDisplayName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (!Component) {
    return undefined;
  }

  return Component.displayName || Component.name || 'Component';
};

exports.default = getDisplayName;

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _shallowEqual = __webpack_require__(141);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _shallowEqual2.default;

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _keycode = _interopRequireDefault(__webpack_require__(117));

var _Cancel = _interopRequireDefault(__webpack_require__(963));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _colorManipulator = __webpack_require__(80);

var _unsupportedProp = _interopRequireDefault(__webpack_require__(306));

var _helpers = __webpack_require__(51);

__webpack_require__(495);

// So we don't have any override priority issue.
var styles = function styles(theme) {
  var height = 32;
  var backgroundColor = theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700];
  var deleteIconColor = (0, _colorManipulator.fade)(theme.palette.text.primary, 0.26);
  return {
    /* Styles applied to the root element. */
    root: {
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(13),
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: height,
      color: theme.palette.getContrastText(backgroundColor),
      backgroundColor: backgroundColor,
      borderRadius: height / 2,
      whiteSpace: 'nowrap',
      transition: theme.transitions.create(['background-color', 'box-shadow']),
      // label will inherit this from root, then `clickable` class overrides this for both
      cursor: 'default',
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 'none',
      textDecoration: 'none',
      border: 'none',
      // Remove `button` border
      padding: 0 // Remove `button` padding

    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    },

    /* Styles applied to the root element if `onClick` is defined or `clickable={true}`. */
    clickable: {
      WebkitTapHighlightColor: 'transparent',
      // Remove grey highlight
      cursor: 'pointer',
      '&:hover, &:focus': {
        backgroundColor: (0, _colorManipulator.emphasize)(backgroundColor, 0.08)
      },
      '&:active': {
        boxShadow: theme.shadows[1],
        backgroundColor: (0, _colorManipulator.emphasize)(backgroundColor, 0.12)
      }
    },

    /**
     * Styles applied to the root element if
     * `onClick` and `color="primary"` is defined or `clickable={true}`.
     */
    clickableColorPrimary: {
      '&:hover, &:focus': {
        backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.primary.main, 0.08)
      },
      '&:active': {
        backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.primary.main, 0.12)
      }
    },

    /**
     * Styles applied to the root element if
     * `onClick` and `color="secondary"` is defined or `clickable={true}`.
     */
    clickableColorSecondary: {
      '&:hover, &:focus': {
        backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.secondary.main, 0.08)
      },
      '&:active': {
        backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.secondary.main, 0.12)
      }
    },

    /* Styles applied to the root element if `onDelete` is defined. */
    deletable: {
      '&:focus': {
        backgroundColor: (0, _colorManipulator.emphasize)(backgroundColor, 0.08)
      }
    },

    /* Styles applied to the root element if `onDelete` and `color="primary"` is defined. */
    deletableColorPrimary: {
      '&:focus': {
        backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.primary.main, 0.2)
      }
    },

    /* Styles applied to the root element if `onDelete` and `color="secondary"` is defined. */
    deletableColorSecondary: {
      '&:focus': {
        backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.secondary.main, 0.2)
      }
    },

    /* Styles applied to the `avatar` element. */
    avatar: {
      marginRight: -4,
      width: height,
      height: height,
      color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
      fontSize: theme.typography.pxToRem(16)
    },

    /* Styles applied to the `avatar` element if `checked={true}` and `color="primary"` */
    avatarColorPrimary: {
      color: (0, _colorManipulator.darken)(theme.palette.primary.contrastText, 0.1),
      backgroundColor: theme.palette.primary.dark
    },

    /* Styles applied to the `avatar` element if `checked={true}` and `color="secondary"` */
    avatarColorSecondary: {
      color: (0, _colorManipulator.darken)(theme.palette.secondary.contrastText, 0.1),
      backgroundColor: theme.palette.secondary.dark
    },

    /* Styles applied to the `avatar` elements children. */
    avatarChildren: {
      width: 19,
      height: 19
    },

    /* Styles applied to the label `span` element`. */
    label: {
      display: 'flex',
      alignItems: 'center',
      paddingLeft: 12,
      paddingRight: 12,
      userSelect: 'none',
      whiteSpace: 'nowrap',
      cursor: 'inherit'
    },

    /* Styles applied to the `deleteIcon` element. */
    deleteIcon: {
      // Remove grey highlight
      WebkitTapHighlightColor: 'transparent',
      color: deleteIconColor,
      cursor: 'pointer',
      height: 'auto',
      margin: '0 4px 0 -8px',
      '&:hover': {
        color: (0, _colorManipulator.fade)(deleteIconColor, 0.4)
      }
    },

    /* Styles applied to the deleteIcon element if `color="primary"`. */
    deleteIconColorPrimary: {
      color: (0, _colorManipulator.fade)(theme.palette.primary.contrastText, 0.65),
      '&:hover, &:active': {
        color: theme.palette.primary.contrastText
      }
    },

    /* Styles applied to the deleteIcon element if `color="secondary"`. */
    deleteIconColorSecondary: {
      color: (0, _colorManipulator.fade)(theme.palette.primary.contrastText, 0.65),
      '&:hover, &:active': {
        color: theme.palette.primary.contrastText
      }
    }
  };
};
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */


exports.styles = styles;

var Chip =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Chip, _React$Component);

  function Chip() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Chip);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Chip)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.chipRef = null;

    _this.handleDeleteIconClick = function (event) {
      // Stop the event from bubbling up to the `Chip`
      event.stopPropagation();
      var onDelete = _this.props.onDelete;

      if (onDelete) {
        onDelete(event);
      }
    };

    _this.handleKeyDown = function (event) {
      // Ignore events from children of `Chip`.
      if (event.currentTarget !== event.target) {
        return;
      }

      var _this$props = _this.props,
          onClick = _this$props.onClick,
          onDelete = _this$props.onDelete,
          onKeyDown = _this$props.onKeyDown;
      var key = (0, _keycode.default)(event);

      if (onClick && (key === 'space' || key === 'enter')) {
        event.preventDefault();
        onClick(event);
      } else if (onDelete && key === 'backspace') {
        event.preventDefault();
        onDelete(event);
      } else if (key === 'esc') {
        event.preventDefault();

        if (_this.chipRef) {
          _this.chipRef.blur();
        }
      }

      if (onKeyDown) {
        onKeyDown(event);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(Chip, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          avatarProp = _this$props2.avatar,
          classes = _this$props2.classes,
          classNameProp = _this$props2.className,
          clickable = _this$props2.clickable,
          color = _this$props2.color,
          Component = _this$props2.component,
          deleteIconProp = _this$props2.deleteIcon,
          label = _this$props2.label,
          onClick = _this$props2.onClick,
          onDelete = _this$props2.onDelete,
          onKeyDown = _this$props2.onKeyDown,
          tabIndexProp = _this$props2.tabIndex,
          other = (0, _objectWithoutProperties2.default)(_this$props2, ["avatar", "classes", "className", "clickable", "color", "component", "deleteIcon", "label", "onClick", "onDelete", "onKeyDown", "tabIndex"]);
      var className = (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'default'), (0, _defineProperty2.default)({}, classes.clickable, onClick || clickable), (0, _defineProperty2.default)({}, classes["clickableColor".concat((0, _helpers.capitalize)(color))], (onClick || clickable) && color !== 'default'), (0, _defineProperty2.default)({}, classes.deletable, onDelete), (0, _defineProperty2.default)({}, classes["deletableColor".concat((0, _helpers.capitalize)(color))], onDelete && color !== 'default'), classNameProp);
      var deleteIcon = null;

      if (onDelete) {
        deleteIcon = deleteIconProp && _react.default.isValidElement(deleteIconProp) ? _react.default.cloneElement(deleteIconProp, {
          className: (0, _classnames.default)(deleteIconProp.props.className, classes.deleteIcon, (0, _defineProperty2.default)({}, classes["deleteIconColor".concat((0, _helpers.capitalize)(color))], color !== 'default')),
          onClick: this.handleDeleteIconClick
        }) : _react.default.createElement(_Cancel.default, {
          className: (0, _classnames.default)(classes.deleteIcon, (0, _defineProperty2.default)({}, classes["deleteIconColor".concat((0, _helpers.capitalize)(color))], color !== 'default')),
          onClick: this.handleDeleteIconClick
        });
      }

      var avatar = null;

      if (avatarProp && _react.default.isValidElement(avatarProp)) {
        avatar = _react.default.cloneElement(avatarProp, {
          className: (0, _classnames.default)(classes.avatar, avatarProp.props.className, (0, _defineProperty2.default)({}, classes["avatarColor".concat((0, _helpers.capitalize)(color))], color !== 'default')),
          childrenClassName: (0, _classnames.default)(classes.avatarChildren, avatarProp.props.childrenClassName)
        });
      }

      var tabIndex = tabIndexProp;

      if (!tabIndex) {
        tabIndex = onClick || onDelete || clickable ? 0 : -1;
      }

      return _react.default.createElement(Component, (0, _extends2.default)({
        role: "button",
        className: className,
        tabIndex: tabIndex,
        onClick: onClick,
        onKeyDown: this.handleKeyDown,
        ref: function ref(_ref) {
          _this2.chipRef = _ref;
        }
      }, other), avatar, _react.default.createElement("span", {
        className: classes.label
      }, label), deleteIcon);
    }
  }]);
  return Chip;
}(_react.default.Component);

Chip.propTypes =  false ? {
  /**
   * Avatar element.
   */
  avatar: _propTypes.default.element,

  /**
   * This property isn't supported.
   * Use the `component` property if you need to change the children structure.
   */
  children: _unsupportedProp.default,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If true, the chip will appear clickable, and will raise when pressed,
   * even if the onClick property is not defined. This can be used, for example,
   * along with the component property to indicate an anchor Chip is clickable.
   */
  clickable: _propTypes.default.bool,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['default', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: _propTypes.default.element,

  /**
   * The content of the label.
   */
  label: _propTypes.default.node,

  /**
   * @ignore
   */
  onClick: _propTypes.default.func,

  /**
   * Callback function fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: _propTypes.default.func,

  /**
   * @ignore
   */
  onKeyDown: _propTypes.default.func,

  /**
   * @ignore
   */
  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
} : {};
Chip.defaultProps = {
  clickable: false,
  component: 'div',
  color: 'default'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiChip'
})(Chip);

exports.default = _default;

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _pure = _interopRequireDefault(__webpack_require__(81));

var _SvgIcon = _interopRequireDefault(__webpack_require__(73));

var _ref = _react.default.createElement("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
});

/**
 * @ignore - internal component.
 */
var Cancel = function Cancel(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

Cancel = (0, _pure.default)(Cancel);
Cancel.muiName = 'SvgIcon';
var _default = Cancel;
exports.default = _default;

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'table-header-group'
  }
};
exports.styles = styles;

var TableHead =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(TableHead, _React$Component);

  function TableHead() {
    (0, _classCallCheck2.default)(this, TableHead);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TableHead).apply(this, arguments));
  }

  (0, _createClass2.default)(TableHead, [{
    key: "getChildContext",
    value: function getChildContext() {
      // eslint-disable-line class-methods-use-this
      return {
        tablelvl2: {
          variant: 'head'
        }
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          className = _this$props.className,
          Component = _this$props.component,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["classes", "className", "component"]);
      return _react.default.createElement(Component, (0, _extends2.default)({
        className: (0, _classnames.default)(classes.root, className)
      }, other));
    }
  }]);
  return TableHead;
}(_react.default.Component);

TableHead.propTypes =  false ? {
  /**
   * The content of the component, normally `TableRow`.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object])
} : {};
TableHead.defaultProps = {
  component: 'thead'
};
TableHead.childContextTypes = {
  tablelvl2: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTableHead'
})(TableHead);

exports.default = _default;

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _ArrowDownward = _interopRequireDefault(__webpack_require__(966));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _ButtonBase = _interopRequireDefault(__webpack_require__(92));

var _helpers = __webpack_require__(51);

// @inheritedComponent ButtonBase
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      cursor: 'pointer',
      display: 'inline-flex',
      justifyContent: 'flex-start',
      flexDirection: 'inherit',
      alignItems: 'center',
      '&:hover': {
        color: theme.palette.text.primary
      },
      '&:focus': {
        color: theme.palette.text.primary
      }
    },

    /* Styles applied to the root element if `active={true}`. */
    active: {
      color: theme.palette.text.primary,
      '& $icon': {
        opacity: 1
      }
    },

    /* Styles applied to the icon component. */
    icon: {
      height: 16,
      marginRight: 4,
      marginLeft: 4,
      opacity: 0,
      transition: theme.transitions.create(['opacity', 'transform'], {
        duration: theme.transitions.duration.shorter
      }),
      userSelect: 'none',
      width: 16
    },

    /* Styles applied to the icon component if `direction="desc"`. */
    iconDirectionDesc: {
      transform: 'rotate(0deg)'
    },

    /* Styles applied to the icon component if `direction="asc"`. */
    iconDirectionAsc: {
      transform: 'rotate(180deg)'
    }
  };
};
/**
 * A button based label for placing inside `TableCell` for column sorting.
 */


exports.styles = styles;

function TableSortLabel(props) {
  var active = props.active,
      classes = props.classes,
      className = props.className,
      children = props.children,
      direction = props.direction,
      other = (0, _objectWithoutProperties2.default)(props, ["active", "classes", "className", "children", "direction"]);
  return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.active, active), className),
    component: "span",
    disableRipple: true
  }, other), children, _react.default.createElement(_ArrowDownward.default, {
    className: (0, _classnames.default)(classes.icon, classes["iconDirection".concat((0, _helpers.capitalize)(direction))])
  }));
}

TableSortLabel.propTypes =  false ? {
  /**
   * If `true`, the label will have the active styling (should be true for the sorted column).
   */
  active: _propTypes.default.bool,

  /**
   * Label contents, the arrow will be appended automatically.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The current sort direction.
   */
  direction: _propTypes.default.oneOf(['asc', 'desc'])
} : {};
TableSortLabel.defaultProps = {
  active: false,
  direction: 'desc'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTableSortLabel'
})(TableSortLabel);

exports.default = _default;

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _pure = _interopRequireDefault(__webpack_require__(81));

var _SvgIcon = _interopRequireDefault(__webpack_require__(73));

var _ref = _react.default.createElement("path", {
  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
});

/**
 * @ignore - internal component.
 */
var ArrowDownward = function ArrowDownward(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

ArrowDownward = (0, _pure.default)(ArrowDownward);
ArrowDownward.muiName = 'SvgIcon';
var _default = ArrowDownward;
exports.default = _default;

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _warning = _interopRequireDefault(__webpack_require__(37));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _RootRef = _interopRequireDefault(__webpack_require__(303));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _helpers = __webpack_require__(51);

var _exactProp = _interopRequireDefault(__webpack_require__(115));

var _Grow = _interopRequireDefault(__webpack_require__(226));

var _Popper = _interopRequireDefault(__webpack_require__(496));

var styles = function styles(theme) {
  return {
    /* Styles applied to the Popper component. */
    popper: {
      zIndex: theme.zIndex.tooltip,
      opacity: 0.9
    },

    /* Styles applied to the tooltip (label wrapper) element. */
    tooltip: {
      backgroundColor: theme.palette.grey[700],
      borderRadius: theme.shape.borderRadius,
      color: theme.palette.common.white,
      fontFamily: theme.typography.fontFamily,
      padding: '4px 8px',
      fontSize: theme.typography.pxToRem(10),
      lineHeight: "".concat(theme.typography.round(14 / 10), "em"),
      maxWidth: 300
    },

    /* Styles applied to the tooltip (label wrapper) element if the tooltip is opened by touch. */
    touch: {
      padding: '8px 16px',
      fontSize: theme.typography.pxToRem(14),
      lineHeight: "".concat(theme.typography.round(16 / 14), "em")
    },

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "left". */
    tooltipPlacementLeft: (0, _defineProperty2.default)({
      transformOrigin: 'right center',
      margin: '0 24px '
    }, theme.breakpoints.up('sm'), {
      margin: '0 14px'
    }),

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "right". */
    tooltipPlacementRight: (0, _defineProperty2.default)({
      transformOrigin: 'left center',
      margin: '0 24px'
    }, theme.breakpoints.up('sm'), {
      margin: '0 14px'
    }),

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "top". */
    tooltipPlacementTop: (0, _defineProperty2.default)({
      transformOrigin: 'center bottom',
      margin: '24px 0'
    }, theme.breakpoints.up('sm'), {
      margin: '14px 0'
    }),

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "bottom". */
    tooltipPlacementBottom: (0, _defineProperty2.default)({
      transformOrigin: 'center top',
      margin: '24px 0'
    }, theme.breakpoints.up('sm'), {
      margin: '14px 0'
    })
  };
};

exports.styles = styles;

var Tooltip =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Tooltip, _React$Component);

  function Tooltip(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Tooltip);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Tooltip).call(this));
    _this.childrenRef = null;
    _this.closeTimer = null;
    _this.defaultId = null;
    _this.enterTimer = null;
    _this.focusTimer = null;
    _this.ignoreNonTouchEvents = false;
    _this.isControlled = null;
    _this.leaveTimer = null;
    _this.touchTimer = null;

    _this.onRootRef = function (ref) {
      _this.childrenRef = ref;
    };

    _this.handleFocus = function (event) {
      event.persist(); // The autoFocus of React might trigger the event before the componentDidMount.
      // We need to account for this eventuality.

      _this.focusTimer = setTimeout(function () {
        _this.handleEnter(event);
      });
    };

    _this.handleEnter = function (event) {
      var _this$props = _this.props,
          children = _this$props.children,
          enterDelay = _this$props.enterDelay;
      var childrenProps = children.props;

      if (event.type === 'focus' && childrenProps.onFocus) {
        childrenProps.onFocus(event);
      }

      if (event.type === 'mouseover' && childrenProps.onMouseOver) {
        childrenProps.onMouseOver(event);
      }

      if (_this.ignoreNonTouchEvents && event.type !== 'touchstart') {
        return;
      } // Remove the title ahead of time.
      // We don't want to wait for the next render commit.
      // We would risk displaying two tooltips at the same time (native + this one).


      _this.childrenRef.setAttribute('title', '');

      clearTimeout(_this.enterTimer);
      clearTimeout(_this.leaveTimer);

      if (enterDelay) {
        event.persist();
        _this.enterTimer = setTimeout(function () {
          _this.handleOpen(event);
        }, enterDelay);
      } else {
        _this.handleOpen(event);
      }
    };

    _this.handleOpen = function (event) {
      // The mouseover event will trigger for every nested element in the tooltip.
      // We can skip rerendering when the tooltip is already open.
      // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
      if (!_this.isControlled && !_this.state.open) {
        _this.setState({
          open: true
        });
      }

      if (_this.props.onOpen) {
        _this.props.onOpen(event);
      }
    };

    _this.handleLeave = function (event) {
      var _this$props2 = _this.props,
          children = _this$props2.children,
          leaveDelay = _this$props2.leaveDelay;
      var childrenProps = children.props;

      if (event.type === 'blur' && childrenProps.onBlur) {
        childrenProps.onBlur(event);
      }

      if (event.type === 'mouseleave' && childrenProps.onMouseLeave) {
        childrenProps.onMouseLeave(event);
      }

      clearTimeout(_this.enterTimer);
      clearTimeout(_this.leaveTimer);

      if (leaveDelay) {
        event.persist();
        _this.leaveTimer = setTimeout(function () {
          _this.handleClose(event);
        }, leaveDelay);
      } else {
        _this.handleClose(event);
      }
    };

    _this.handleClose = function (event) {
      if (!_this.isControlled) {
        _this.setState({
          open: false
        });
      }

      if (_this.props.onClose) {
        _this.props.onClose(event);
      }

      clearTimeout(_this.closeTimer);
      _this.closeTimer = setTimeout(function () {
        _this.ignoreNonTouchEvents = false;
      }, _this.props.theme.transitions.duration.shortest);
    };

    _this.handleTouchStart = function (event) {
      _this.ignoreNonTouchEvents = true;
      var _this$props3 = _this.props,
          children = _this$props3.children,
          enterTouchDelay = _this$props3.enterTouchDelay;

      if (children.props.onTouchStart) {
        children.props.onTouchStart(event);
      }

      clearTimeout(_this.leaveTimer);
      clearTimeout(_this.closeTimer);
      clearTimeout(_this.touchTimer);
      event.persist();
      _this.touchTimer = setTimeout(function () {
        _this.handleEnter(event);
      }, enterTouchDelay);
    };

    _this.handleTouchEnd = function (event) {
      var _this$props4 = _this.props,
          children = _this$props4.children,
          leaveTouchDelay = _this$props4.leaveTouchDelay;

      if (children.props.onTouchEnd) {
        children.props.onTouchEnd(event);
      }

      clearTimeout(_this.touchTimer);
      clearTimeout(_this.leaveTimer);
      event.persist();
      _this.leaveTimer = setTimeout(function () {
        _this.handleClose(event);
      }, leaveTouchDelay);
    };

    _this.isControlled = props.open != null;
    _this.state = {
      open: null
    };

    if (!_this.isControlled) {
      // not controlled, use internal state
      _this.state.open = false;
    }

    return _this;
  }

  (0, _createClass2.default)(Tooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
       false ? (0, _warning.default)(!this.childrenRef.disabled || !this.childrenRef.tagName.toLowerCase() === 'button', ['Material-UI: you are providing a disabled `button` child to the Tooltip component.', 'A disabled element does not fire events.', "Tooltip needs to listen to the child element's events to display the title.", '', 'Place a `div` container on top of the element.'].join('\n')) : void 0; // Fallback to this default id when possible.
      // Use the random value for client side rendering only.
      // We can't use it server side.

      this.defaultId = "mui-tooltip-".concat(Math.round(Math.random() * 1e5)); // Rerender with this.defaultId and this.childrenRef.

      if (this.props.open) {
        this.forceUpdate();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.closeTimer);
      clearTimeout(this.enterTimer);
      clearTimeout(this.focusTimer);
      clearTimeout(this.leaveTimer);
      clearTimeout(this.touchTimer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props5 = this.props,
          children = _this$props5.children,
          classes = _this$props5.classes,
          disableFocusListener = _this$props5.disableFocusListener,
          disableHoverListener = _this$props5.disableHoverListener,
          disableTouchListener = _this$props5.disableTouchListener,
          id = _this$props5.id,
          openProp = _this$props5.open,
          placement = _this$props5.placement,
          PopperProps = _this$props5.PopperProps,
          theme = _this$props5.theme,
          title = _this$props5.title,
          TransitionComponent = _this$props5.TransitionComponent,
          TransitionProps = _this$props5.TransitionProps;
      var open = this.isControlled ? openProp : this.state.open; // There is no point at displaying an empty tooltip.

      if (title === '') {
        open = false;
      }

      var childrenProps = {
        'aria-describedby': open ? id || this.defaultId : null,
        title: !open && typeof title === 'string' ? title : null
      };

      if (!disableTouchListener) {
        childrenProps.onTouchStart = this.handleTouchStart;
        childrenProps.onTouchEnd = this.handleTouchEnd;
      }

      if (!disableHoverListener) {
        childrenProps.onMouseOver = this.handleEnter;
        childrenProps.onMouseLeave = this.handleLeave;
      }

      if (!disableFocusListener) {
        childrenProps.onFocus = this.handleFocus;
        childrenProps.onBlur = this.handleLeave;
      }

       false ? (0, _warning.default)(!children.props.title, ['Material-UI: you have provided a `title` property to the child of <Tooltip />.', "Remove this title property `".concat(children.props.title, "` or the Tooltip component.")].join('\n')) : void 0;
      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_RootRef.default, {
        rootRef: this.onRootRef
      }, _react.default.cloneElement(children, childrenProps)), _react.default.createElement(_Popper.default, (0, _extends2.default)({
        className: classes.popper,
        placement: placement,
        anchorEl: this.childrenRef,
        open: open,
        id: childrenProps['aria-describedby'],
        transition: true
      }, PopperProps), function (_ref) {
        var placementInner = _ref.placement,
            TransitionPropsInner = _ref.TransitionProps;
        return _react.default.createElement(TransitionComponent, (0, _extends2.default)({
          timeout: theme.transitions.duration.shorter
        }, TransitionPropsInner, TransitionProps), _react.default.createElement("div", {
          className: (0, _classnames.default)(classes.tooltip, (0, _defineProperty2.default)({}, classes.touch, _this2.ignoreNonTouchEvents), classes["tooltipPlacement".concat((0, _helpers.capitalize)(placementInner.split('-')[0]))])
        }, title));
      }));
    }
  }]);
  return Tooltip;
}(_react.default.Component);

Tooltip.propTypes =  false ? {
  /**
   * Tooltip reference element.
   */
  children: _propTypes.default.element.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * Do not respond to focus events.
   */
  disableFocusListener: _propTypes.default.bool,

  /**
   * Do not respond to hover events.
   */
  disableHoverListener: _propTypes.default.bool,

  /**
   * Do not respond to long press touch events.
   */
  disableTouchListener: _propTypes.default.bool,

  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This property won't impact the enter touch delay (`enterTouchDelay`).
   */
  enterDelay: _propTypes.default.number,

  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   */
  enterTouchDelay: _propTypes.default.number,

  /**
   * The relationship between the tooltip and the wrapper component is not clear from the DOM.
   * This property is used with aria-describedby to solve the accessibility issue.
   * If you don't provide this property. It fallback to a random generated id.
   */
  id: _propTypes.default.string,

  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This property won't impact the leave touch delay (`leaveTouchDelay`).
   */
  leaveDelay: _propTypes.default.number,

  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   */
  leaveTouchDelay: _propTypes.default.number,

  /**
   * Callback fired when the tooltip requests to be closed.
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired when the tooltip requests to be open.
   *
   * @param {object} event The event source of the callback
   */
  onOpen: _propTypes.default.func,

  /**
   * If `true`, the tooltip is shown.
   */
  open: _propTypes.default.bool,

  /**
   * Tooltip placement.
   */
  placement: _propTypes.default.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),

  /**
   * Properties applied to the [`Popper`](/api/popper) element.
   */
  PopperProps: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * Tooltip title. Zero-length titles string are never displayed.
   */
  title: _propTypes.default.node.isRequired,

  /**
   * Transition component.
   */
  TransitionComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Properties applied to the `Transition` element.
   */
  TransitionProps: _propTypes.default.object
} : {};
Tooltip.propTypes =  false ? (0, _exactProp.default)(Tooltip.propTypes) : {};
Tooltip.defaultProps = {
  disableFocusListener: false,
  disableHoverListener: false,
  disableTouchListener: false,
  enterDelay: 0,
  enterTouchDelay: 1000,
  leaveDelay: 0,
  leaveTouchDelay: 1500,
  placement: 'bottom',
  TransitionComponent: _Grow.default
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTooltip',
  withTheme: true
})(Tooltip);

exports.default = _default;

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(145));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(64));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _popper = _interopRequireDefault(__webpack_require__(969));

var _withTheme = _interopRequireDefault(__webpack_require__(90));

var _Portal = _interopRequireDefault(__webpack_require__(304));

function flipPlacement(theme, placement) {
  if (theme.direction !== 'rtl') {
    return placement;
  }

  switch (placement) {
    case 'bottom-end':
      return 'bottom-start';

    case 'bottom-start':
      return 'bottom-end';

    case 'top-end':
      return 'top-start';

    case 'top-start':
      return 'top-end';

    default:
      return placement;
  }
}

function getAnchorEl(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
/**
 * Poppers rely on the 3rd party library [Popper.js](https://github.com/FezVrasta/popper.js) for positioning.
 */


var Popper =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Popper, _React$Component);

  function Popper(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Popper);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Popper).call(this));
    _this.popper = null;

    _this.handleOpen = function () {
      var _this$props = _this.props,
          anchorEl = _this$props.anchorEl,
          modifiers = _this$props.modifiers,
          open = _this$props.open,
          placement = _this$props.placement,
          _this$props$popperOpt = _this$props.popperOptions,
          popperOptions = _this$props$popperOpt === void 0 ? {} : _this$props$popperOpt,
          theme = _this$props.theme,
          disablePortal = _this$props.disablePortal;

      var popperNode = _reactDom.default.findDOMNode((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));

      if (!popperNode || !anchorEl || !open) {
        return;
      }

      if (_this.popper) {
        _this.popper.destroy();

        _this.popper = null;
      }

      _this.popper = new _popper.default(getAnchorEl(anchorEl), popperNode, (0, _extends2.default)({
        placement: flipPlacement(theme, placement)
      }, popperOptions, {
        modifiers: (0, _extends2.default)({}, disablePortal ? {} : {
          // It's using scrollParent by default, we can use the viewport when using a portal.
          preventOverflow: {
            boundariesElement: 'window'
          }
        }, modifiers, popperOptions.modifiers),
        // We could have been using a custom modifier like react-popper is doing.
        // But it seems this is the best public API for this use case.
        onCreate: _this.handlePopperUpdate,
        onUpdate: _this.handlePopperUpdate
      }));
    };

    _this.handlePopperUpdate = function (data) {
      if (data.placement !== _this.state.placement) {
        _this.setState({
          placement: data.placement
        });
      }
    };

    _this.handleExited = function () {
      _this.setState({
        exited: true
      });

      _this.handleClose();
    };

    _this.handleClose = function () {
      if (!_this.popper) {
        return;
      }

      _this.popper.destroy();

      _this.popper = null;
    };

    _this.state = {
      exited: !props.open
    };
    return _this;
  }

  (0, _createClass2.default)(Popper, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.open !== this.props.open && !this.props.open && !this.props.transition) {
        // Otherwise handleExited will call this.
        this.handleClose();
      } // Let's update the popper position.


      if (prevProps.open !== this.props.open || prevProps.anchorEl !== this.props.anchorEl || prevProps.popperOptions !== this.props.popperOptions || prevProps.modifiers !== this.props.modifiers || prevProps.disablePortal !== this.props.disablePortal || prevProps.placement !== this.props.placement) {
        this.handleOpen();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handleClose();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          anchorEl = _this$props2.anchorEl,
          children = _this$props2.children,
          container = _this$props2.container,
          disablePortal = _this$props2.disablePortal,
          keepMounted = _this$props2.keepMounted,
          modifiers = _this$props2.modifiers,
          open = _this$props2.open,
          placementProps = _this$props2.placement,
          popperOptions = _this$props2.popperOptions,
          theme = _this$props2.theme,
          transition = _this$props2.transition,
          other = (0, _objectWithoutProperties2.default)(_this$props2, ["anchorEl", "children", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "theme", "transition"]);
      var _this$state = this.state,
          exited = _this$state.exited,
          placement = _this$state.placement;

      if (!keepMounted && !open && (!transition || exited)) {
        return null;
      }

      var childProps = {
        placement: placement || flipPlacement(theme, placementProps)
      };

      if (transition) {
        childProps.TransitionProps = {
          in: open,
          onExited: this.handleExited
        };
      }

      return _react.default.createElement(_Portal.default, {
        onRendered: this.handleOpen,
        disablePortal: disablePortal,
        container: container
      }, _react.default.createElement("div", (0, _extends2.default)({
        role: "tooltip",
        style: {
          // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
          position: 'absolute'
        }
      }, other), typeof children === 'function' ? children(childProps) : children));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if (nextProps.open) {
        return {
          exited: false
        };
      }

      if (!nextProps.transition) {
        // Otherwise let handleExited take care of marking exited.
        return {
          exited: true
        };
      }

      return null;
    }
  }]);
  return Popper;
}(_react.default.Component);

Popper.propTypes =  false ? {
  /**
   * This is the DOM element, or a function that returns the DOM element,
   * that may be used to set the position of the popover.
   * The return value will passed as the reference object of the Popper
   * instance.
   */
  anchorEl: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * Popper render function or node.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]).isRequired,

  /**
   * A node, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: _propTypes.default.bool,

  /**
   * Always keep the children in the DOM.
   * This property can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   */
  keepMounted: _propTypes.default.bool,

  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://github.com/FezVrasta/popper.js/blob/master/docs/_includes/popper-documentation.md#modifiers--object).
   */
  modifiers: _propTypes.default.object,

  /**
   * If `true`, the popper is visible.
   */
  open: _propTypes.default.bool.isRequired,

  /**
   * Popper placement.
   */
  placement: _propTypes.default.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),

  /**
   * Options provided to the [`popper.js`](https://github.com/FezVrasta/popper.js) instance.
   */
  popperOptions: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * Help supporting a react-transition-group/Transition component.
   */
  transition: _propTypes.default.bool
} : {};
Popper.defaultProps = {
  disablePortal: false,
  placement: 'bottom',
  transition: false
};

var _default = (0, _withTheme.default)()(Popper);

exports.default = _default;

/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["default"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(72)))

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'table-footer-group'
  }
};
exports.styles = styles;

var TableFooter =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(TableFooter, _React$Component);

  function TableFooter() {
    (0, _classCallCheck2.default)(this, TableFooter);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TableFooter).apply(this, arguments));
  }

  (0, _createClass2.default)(TableFooter, [{
    key: "getChildContext",
    value: function getChildContext() {
      // eslint-disable-line class-methods-use-this
      return {
        tablelvl2: {
          variant: 'footer'
        }
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          className = _this$props.className,
          Component = _this$props.component,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["classes", "className", "component"]);
      return _react.default.createElement(Component, (0, _extends2.default)({
        className: (0, _classnames.default)(classes.root, className)
      }, other));
    }
  }]);
  return TableFooter;
}(_react.default.Component);

TableFooter.propTypes =  false ? {
  /**
   * The content of the component, normally `TableRow`.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object])
} : {};
TableFooter.defaultProps = {
  component: 'tfoot'
};
TableFooter.childContextTypes = {
  tablelvl2: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTableFooter'
})(TableFooter);

exports.default = _default;

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _Input = _interopRequireDefault(__webpack_require__(76));

var _MenuItem = _interopRequireDefault(__webpack_require__(23));

var _Select = _interopRequireDefault(__webpack_require__(24));

var _TableCell = _interopRequireDefault(__webpack_require__(179));

var _Toolbar = _interopRequireDefault(__webpack_require__(121));

var _Typography = _interopRequireDefault(__webpack_require__(13));

var _TablePaginationActions = _interopRequireDefault(__webpack_require__(974));

// @inheritedComponent TableCell
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      fontSize: theme.typography.pxToRem(12),
      // Increase the specificity to override TableCell.
      '&:last-child': {
        padding: 0
      }
    },

    /* Styles applied to the Toolbar component. */
    toolbar: {
      height: 56,
      minHeight: 56,
      paddingRight: 2
    },

    /* Styles applied to the spacer element. */
    spacer: {
      flex: '1 1 100%'
    },

    /* Styles applied to the caption Typography components if `variant="caption"`. */
    caption: {
      flexShrink: 0
    },

    /* Styles applied to the Select component `root` class. */
    selectRoot: {
      marginRight: 32,
      marginLeft: 8,
      color: theme.palette.text.secondary
    },

    /* Styles applied to the Select component `select` class. */
    select: {
      paddingLeft: 8,
      paddingRight: 16
    },

    /* Styles applied to the Select component `icon` class. */
    selectIcon: {
      top: 1
    },

    /* Styles applied to the Input component. */
    input: {
      fontSize: 'inherit',
      flexShrink: 0
    },

    /* Styles applied to the MenuItem component. */
    menuItem: {},

    /* Styles applied to the internal `TablePaginationActions` component. */
    actions: {
      flexShrink: 0,
      color: theme.palette.text.secondary,
      marginLeft: 20
    }
  };
};
/**
 * A `TableCell` based component for placing inside `TableFooter` for pagination.
 */


exports.styles = styles;

var TablePagination =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(TablePagination, _React$Component);

  function TablePagination() {
    (0, _classCallCheck2.default)(this, TablePagination);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TablePagination).apply(this, arguments));
  }

  (0, _createClass2.default)(TablePagination, [{
    key: "componentDidUpdate",
    // This logic would be better handled on userside.
    // However, we have it just in case.
    value: function componentDidUpdate() {
      var _this$props = this.props,
          count = _this$props.count,
          onChangePage = _this$props.onChangePage,
          page = _this$props.page,
          rowsPerPage = _this$props.rowsPerPage;
      var newLastPage = Math.max(0, Math.ceil(count / rowsPerPage) - 1);

      if (page > newLastPage) {
        onChangePage(null, newLastPage);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          ActionsComponent = _this$props2.ActionsComponent,
          backIconButtonProps = _this$props2.backIconButtonProps,
          classes = _this$props2.classes,
          colSpanProp = _this$props2.colSpan,
          Component = _this$props2.component,
          count = _this$props2.count,
          labelDisplayedRows = _this$props2.labelDisplayedRows,
          labelRowsPerPage = _this$props2.labelRowsPerPage,
          nextIconButtonProps = _this$props2.nextIconButtonProps,
          onChangePage = _this$props2.onChangePage,
          onChangeRowsPerPage = _this$props2.onChangeRowsPerPage,
          page = _this$props2.page,
          rowsPerPage = _this$props2.rowsPerPage,
          rowsPerPageOptions = _this$props2.rowsPerPageOptions,
          SelectProps = _this$props2.SelectProps,
          other = (0, _objectWithoutProperties2.default)(_this$props2, ["ActionsComponent", "backIconButtonProps", "classes", "colSpan", "component", "count", "labelDisplayedRows", "labelRowsPerPage", "nextIconButtonProps", "onChangePage", "onChangeRowsPerPage", "page", "rowsPerPage", "rowsPerPageOptions", "SelectProps"]);
      var colSpan;

      if (Component === _TableCell.default || Component === 'td') {
        colSpan = colSpanProp || 1000; // col-span over everything
      }

      return _react.default.createElement(Component, (0, _extends2.default)({
        className: classes.root,
        colSpan: colSpan
      }, other), _react.default.createElement(_Toolbar.default, {
        className: classes.toolbar
      }, _react.default.createElement("div", {
        className: classes.spacer
      }), rowsPerPageOptions.length > 1 && _react.default.createElement(_Typography.default, {
        variant: "caption",
        className: classes.caption
      }, labelRowsPerPage), rowsPerPageOptions.length > 1 && _react.default.createElement(_Select.default, (0, _extends2.default)({
        classes: {
          root: classes.selectRoot,
          select: classes.select,
          icon: classes.selectIcon
        },
        input: _react.default.createElement(_Input.default, {
          className: classes.input,
          disableUnderline: true
        }),
        value: rowsPerPage,
        onChange: onChangeRowsPerPage
      }, SelectProps), rowsPerPageOptions.map(function (rowsPerPageOption) {
        return _react.default.createElement(_MenuItem.default, {
          className: classes.menuItem,
          key: rowsPerPageOption,
          value: rowsPerPageOption
        }, rowsPerPageOption);
      })), _react.default.createElement(_Typography.default, {
        variant: "caption",
        className: classes.caption
      }, labelDisplayedRows({
        from: count === 0 ? 0 : page * rowsPerPage + 1,
        to: Math.min(count, (page + 1) * rowsPerPage),
        count: count,
        page: page
      })), _react.default.createElement(ActionsComponent, {
        className: classes.actions,
        backIconButtonProps: backIconButtonProps,
        count: count,
        nextIconButtonProps: nextIconButtonProps,
        onChangePage: onChangePage,
        page: page,
        rowsPerPage: rowsPerPage
      })));
    }
  }]);
  return TablePagination;
}(_react.default.Component);

TablePagination.propTypes =  false ? {
  /**
   * The component used for displaying the actions.
   * Either a string to use a DOM element or a component.
   */
  ActionsComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Properties applied to the back arrow [`IconButton`](/api/icon-button) component.
   */
  backIconButtonProps: _propTypes.default.object,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  colSpan: _propTypes.default.number,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * The total number of rows.
   */
  count: _propTypes.default.number.isRequired,

  /**
   * Customize the displayed rows label.
   */
  labelDisplayedRows: _propTypes.default.func,

  /**
   * Customize the rows per page label. Invoked with a `{ from, to, count, page }`
   * object.
   */
  labelRowsPerPage: _propTypes.default.node,

  /**
   * Properties applied to the next arrow [`IconButton`](/api/icon-button) element.
   */
  nextIconButtonProps: _propTypes.default.object,

  /**
   * Callback fired when the page is changed.
   *
   * @param {object} event The event source of the callback
   * @param {number} page The page selected
   */
  onChangePage: _propTypes.default.func.isRequired,

  /**
   * Callback fired when the number of rows per page is changed.
   *
   * @param {object} event The event source of the callback
   */
  onChangeRowsPerPage: _propTypes.default.func,

  /**
   * The zero-based index of the current page.
   */
  page: _propTypes.default.number.isRequired,

  /**
   * The number of rows per page.
   */
  rowsPerPage: _propTypes.default.number.isRequired,

  /**
   * Customizes the options of the rows per page select field. If less than two options are
   * available, no select field will be displayed.
   */
  rowsPerPageOptions: _propTypes.default.array,

  /**
   * Properties applied to the rows per page [`Select`](/api/select) element.
   */
  SelectProps: _propTypes.default.object
} : {};
TablePagination.defaultProps = {
  ActionsComponent: _TablePaginationActions.default,
  component: _TableCell.default,
  labelDisplayedRows: function labelDisplayedRows(_ref) {
    var from = _ref.from,
        to = _ref.to,
        count = _ref.count;
    return "".concat(from, "-").concat(to, " of ").concat(count);
  },
  labelRowsPerPage: 'Rows per page:',
  rowsPerPageOptions: [5, 10, 25]
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiTablePagination'
})(TablePagination);

exports.default = _default;

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _ListItem = _interopRequireDefault(__webpack_require__(181));

// @inheritedComponent ListItem
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: (0, _extends2.default)({}, theme.typography.subheading, {
      height: 24,
      boxSizing: 'content-box',
      width: 'auto',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      paddingLeft: 16,
      paddingRight: 16,
      '&$selected': {
        backgroundColor: theme.palette.action.selected
      }
    }),

    /* Styles applied to the root element if `selected={true}`. */
    selected: {}
  };
};

exports.styles = styles;

function MenuItem(props) {
  var classes = props.classes,
      className = props.className,
      component = props.component,
      selected = props.selected,
      role = props.role,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "selected", "role"]);
  return _react.default.createElement(_ListItem.default, (0, _extends2.default)({
    button: true,
    role: role,
    tabIndex: -1,
    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.selected, selected), className),
    component: component
  }, other));
}

MenuItem.propTypes =  false ? {
  /**
   * Menu item contents.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * @ignore
   */
  role: _propTypes.default.string,

  /**
   * Use to apply selected styling.
   */
  selected: _propTypes.default.bool
} : {};
MenuItem.defaultProps = {
  component: 'li',
  role: 'menuitem',
  selected: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiMenuItem'
})(MenuItem);

exports.default = _default;

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _ButtonBase = _interopRequireDefault(__webpack_require__(92));

var _reactHelpers = __webpack_require__(119);

var styles = function styles(theme) {
  return {
    /* Styles applied to the (normally root) `component` element. May be wrapped by a `container`. */
    root: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      position: 'relative',
      textDecoration: 'none',
      width: '100%',
      boxSizing: 'border-box',
      textAlign: 'left',
      paddingTop: 12,
      paddingBottom: 12
    },

    /* Styles applied to the `container` element if `children` includes `ListItemSecondaryAction`. */
    container: {
      position: 'relative'
    },
    // TODO: Sanity check this - why is focusVisibleClassName prop apparently applied to a div?

    /* Styles applied to the `component`'s `focusVisibleClassName` property if `button={true}`. */
    focusVisible: {
      backgroundColor: theme.palette.action.hover
    },

    /* Legacy styles applied to the root element. Use `root` instead. */
    default: {},

    /* Styles applied to the `component` element if `dense={true}` or `children` includes `Avatar`. */
    dense: {
      paddingTop: 8,
      paddingBottom: 8
    },

    /* Styles applied to the inner `component` element if `disabled={true}`. */
    disabled: {
      opacity: 0.5
    },

    /* Styles applied to the inner `component` element if `divider={true}`. */
    divider: {
      borderBottom: "1px solid ".concat(theme.palette.divider),
      backgroundClip: 'padding-box'
    },

    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
    gutters: theme.mixins.gutters(),

    /* Styles applied to the inner `component` element if `button={true}`. */
    button: {
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: theme.palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the `component` element if `children` includes `ListItemSecondaryAction`. */
    secondaryAction: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positionned.
      paddingRight: 32
    }
  };
};

exports.styles = styles;

var ListItem =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ListItem, _React$Component);

  function ListItem() {
    (0, _classCallCheck2.default)(this, ListItem);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ListItem).apply(this, arguments));
  }

  (0, _createClass2.default)(ListItem, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        dense: this.props.dense || this.context.dense || false
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          button = _this$props.button,
          childrenProp = _this$props.children,
          classes = _this$props.classes,
          classNameProp = _this$props.className,
          componentProp = _this$props.component,
          ContainerComponent = _this$props.ContainerComponent,
          _this$props$Container = _this$props.ContainerProps;
      _this$props$Container = _this$props$Container === void 0 ? {} : _this$props$Container;
      var ContainerClassName = _this$props$Container.className,
          ContainerProps = (0, _objectWithoutProperties2.default)(_this$props$Container, ["className"]),
          dense = _this$props.dense,
          disabled = _this$props.disabled,
          disableGutters = _this$props.disableGutters,
          divider = _this$props.divider,
          focusVisibleClassName = _this$props.focusVisibleClassName,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["button", "children", "classes", "className", "component", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "divider", "focusVisibleClassName"]);
      var isDense = dense || this.context.dense || false;

      var children = _react.default.Children.toArray(childrenProp);

      var hasAvatar = children.some(function (value) {
        return (0, _reactHelpers.isMuiElement)(value, ['ListItemAvatar']);
      });
      var hasSecondaryAction = children.length && (0, _reactHelpers.isMuiElement)(children[children.length - 1], ['ListItemSecondaryAction']);
      var className = (0, _classnames.default)(classes.root, classes.default, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.dense, isDense || hasAvatar), (0, _defineProperty2.default)(_classNames, classes.gutters, !disableGutters), (0, _defineProperty2.default)(_classNames, classes.divider, divider), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.button, button), (0, _defineProperty2.default)(_classNames, classes.secondaryAction, hasSecondaryAction), _classNames), classNameProp);
      var componentProps = (0, _extends2.default)({
        className: className,
        disabled: disabled
      }, other);
      var Component = componentProp || 'li';

      if (button) {
        componentProps.component = componentProp || 'div';
        componentProps.focusVisibleClassName = (0, _classnames.default)(classes.focusVisible, focusVisibleClassName);
        Component = _ButtonBase.default;
      }

      if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? 'div' : Component; // Avoid nesting of li > li.

        if (ContainerComponent === 'li') {
          if (Component === 'li') {
            Component = 'div';
          } else if (componentProps.component === 'li') {
            componentProps.component = 'div';
          }
        }

        return _react.default.createElement(ContainerComponent, (0, _extends2.default)({
          className: (0, _classnames.default)(classes.container, ContainerClassName)
        }, ContainerProps), _react.default.createElement(Component, componentProps, children), children.pop());
      }

      return _react.default.createElement(Component, componentProps, children);
    }
  }]);
  return ListItem;
}(_react.default.Component);

ListItem.propTypes =  false ? {
  /**
   * If `true`, the list item will be a button (using `ButtonBase`).
   */
  button: _propTypes.default.bool,

  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   * By default, it's a `li` when `button` is `false` and a `div` when `button` is `true`.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * The container component used when a `ListItemSecondaryAction` is rendered.
   */
  ContainerComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Properties applied to the container element when the component
   * is used to display a `ListItemSecondaryAction`.
   */
  ContainerProps: _propTypes.default.object,

  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used.
   */
  dense: _propTypes.default.bool,

  /**
   * If `true`, the list item will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the left and right padding is removed.
   */
  disableGutters: _propTypes.default.bool,

  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   */
  divider: _propTypes.default.bool,

  /**
   * @ignore
   */
  focusVisibleClassName: _propTypes.default.string
} : {};
ListItem.defaultProps = {
  button: false,
  ContainerComponent: 'li',
  dense: false,
  disabled: false,
  disableGutters: false,
  divider: false
};
ListItem.contextTypes = {
  dense: _propTypes.default.bool
};
ListItem.childContextTypes = {
  dense: _propTypes.default.bool
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiListItem'
})(ListItem);

exports.default = _default;

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _TablePaginationActions.default;
  }
});

var _TablePaginationActions = _interopRequireDefault(__webpack_require__(975));

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _KeyboardArrowLeft = _interopRequireDefault(__webpack_require__(478));

var _KeyboardArrowRight = _interopRequireDefault(__webpack_require__(479));

var _withTheme = _interopRequireDefault(__webpack_require__(90));

var _IconButton = _interopRequireDefault(__webpack_require__(71));

var _ref = _react.default.createElement(_KeyboardArrowRight.default, null);

var _ref2 = _react.default.createElement(_KeyboardArrowLeft.default, null);

var _ref3 = _react.default.createElement(_KeyboardArrowLeft.default, null);

var _ref4 = _react.default.createElement(_KeyboardArrowRight.default, null);

/**
 * @ignore - internal component.
 */
var TablePaginationActions =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(TablePaginationActions, _React$Component);

  function TablePaginationActions() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, TablePaginationActions);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(TablePaginationActions)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleBackButtonClick = function (event) {
      _this.props.onChangePage(event, _this.props.page - 1);
    };

    _this.handleNextButtonClick = function (event) {
      _this.props.onChangePage(event, _this.props.page + 1);
    };

    return _this;
  }

  (0, _createClass2.default)(TablePaginationActions, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          backIconButtonProps = _this$props.backIconButtonProps,
          count = _this$props.count,
          nextIconButtonProps = _this$props.nextIconButtonProps,
          onChangePage = _this$props.onChangePage,
          page = _this$props.page,
          rowsPerPage = _this$props.rowsPerPage,
          theme = _this$props.theme,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["backIconButtonProps", "count", "nextIconButtonProps", "onChangePage", "page", "rowsPerPage", "theme"]);
      return _react.default.createElement("div", other, _react.default.createElement(_IconButton.default, (0, _extends2.default)({
        onClick: this.handleBackButtonClick,
        disabled: page === 0
      }, backIconButtonProps), theme.direction === 'rtl' ? _ref : _ref2), _react.default.createElement(_IconButton.default, (0, _extends2.default)({
        onClick: this.handleNextButtonClick,
        disabled: page >= Math.ceil(count / rowsPerPage) - 1
      }, nextIconButtonProps), theme.direction === 'rtl' ? _ref3 : _ref4));
    }
  }]);
  return TablePaginationActions;
}(_react.default.Component);

TablePaginationActions.propTypes =  false ? {
  /**
   * Properties applied to the back arrow [`IconButton`](/api/icon-button) element.
   */
  backIconButtonProps: _propTypes.default.object,

  /**
   * The total number of rows.
   */
  count: _propTypes.default.number.isRequired,

  /**
   * Properties applied to the next arrow [`IconButton`](/api/icon-button) element.
   */
  nextIconButtonProps: _propTypes.default.object,

  /**
   * Callback fired when the page is changed.
   *
   * @param {object} event The event source of the callback
   * @param {number} page The page selected
   */
  onChangePage: _propTypes.default.func.isRequired,

  /**
   * The zero-based index of the current page.
   */
  page: _propTypes.default.number.isRequired,

  /**
   * The number of rows per page.
   */
  rowsPerPage: _propTypes.default.number.isRequired,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired
} : {};

var _default = (0, _withTheme.default)()(TablePaginationActions);

exports.default = _default;

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var purple = {
  50: '#f3e5f5',
  100: '#e1bee7',
  200: '#ce93d8',
  300: '#ba68c8',
  400: '#ab47bc',
  500: '#9c27b0',
  600: '#8e24aa',
  700: '#7b1fa2',
  800: '#6a1b9a',
  900: '#4a148c',
  A100: '#ea80fc',
  A200: '#e040fb',
  A400: '#d500f9',
  A700: '#aa00ff'
};
var _default = purple;
exports.default = _default;

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var deepPurple = {
  50: '#ede7f6',
  100: '#d1c4e9',
  200: '#b39ddb',
  300: '#9575cd',
  400: '#7e57c2',
  500: '#673ab7',
  600: '#5e35b1',
  700: '#512da8',
  800: '#4527a0',
  900: '#311b92',
  A100: '#b388ff',
  A200: '#7c4dff',
  A400: '#651fff',
  A700: '#6200ea'
};
var _default = deepPurple;
exports.default = _default;

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var blue = {
  50: '#e3f2fd',
  100: '#bbdefb',
  200: '#90caf9',
  300: '#64b5f6',
  400: '#42a5f5',
  500: '#2196f3',
  600: '#1e88e5',
  700: '#1976d2',
  800: '#1565c0',
  900: '#0d47a1',
  A100: '#82b1ff',
  A200: '#448aff',
  A400: '#2979ff',
  A700: '#2962ff'
};
var _default = blue;
exports.default = _default;

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var lightBlue = {
  50: '#e1f5fe',
  100: '#b3e5fc',
  200: '#81d4fa',
  300: '#4fc3f7',
  400: '#29b6f6',
  500: '#03a9f4',
  600: '#039be5',
  700: '#0288d1',
  800: '#0277bd',
  900: '#01579b',
  A100: '#80d8ff',
  A200: '#40c4ff',
  A400: '#00b0ff',
  A700: '#0091ea'
};
var _default = lightBlue;
exports.default = _default;

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var cyan = {
  50: '#e0f7fa',
  100: '#b2ebf2',
  200: '#80deea',
  300: '#4dd0e1',
  400: '#26c6da',
  500: '#00bcd4',
  600: '#00acc1',
  700: '#0097a7',
  800: '#00838f',
  900: '#006064',
  A100: '#84ffff',
  A200: '#18ffff',
  A400: '#00e5ff',
  A700: '#00b8d4'
};
var _default = cyan;
exports.default = _default;

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var teal = {
  50: '#e0f2f1',
  100: '#b2dfdb',
  200: '#80cbc4',
  300: '#4db6ac',
  400: '#26a69a',
  500: '#009688',
  600: '#00897b',
  700: '#00796b',
  800: '#00695c',
  900: '#004d40',
  A100: '#a7ffeb',
  A200: '#64ffda',
  A400: '#1de9b6',
  A700: '#00bfa5'
};
var _default = teal;
exports.default = _default;

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var green = {
  50: '#e8f5e9',
  100: '#c8e6c9',
  200: '#a5d6a7',
  300: '#81c784',
  400: '#66bb6a',
  500: '#4caf50',
  600: '#43a047',
  700: '#388e3c',
  800: '#2e7d32',
  900: '#1b5e20',
  A100: '#b9f6ca',
  A200: '#69f0ae',
  A400: '#00e676',
  A700: '#00c853'
};
var _default = green;
exports.default = _default;

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var lightGreen = {
  50: '#f1f8e9',
  100: '#dcedc8',
  200: '#c5e1a5',
  300: '#aed581',
  400: '#9ccc65',
  500: '#8bc34a',
  600: '#7cb342',
  700: '#689f38',
  800: '#558b2f',
  900: '#33691e',
  A100: '#ccff90',
  A200: '#b2ff59',
  A400: '#76ff03',
  A700: '#64dd17'
};
var _default = lightGreen;
exports.default = _default;

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var lime = {
  50: '#f9fbe7',
  100: '#f0f4c3',
  200: '#e6ee9c',
  300: '#dce775',
  400: '#d4e157',
  500: '#cddc39',
  600: '#c0ca33',
  700: '#afb42b',
  800: '#9e9d24',
  900: '#827717',
  A100: '#f4ff81',
  A200: '#eeff41',
  A400: '#c6ff00',
  A700: '#aeea00'
};
var _default = lime;
exports.default = _default;

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var yellow = {
  50: '#fffde7',
  100: '#fff9c4',
  200: '#fff59d',
  300: '#fff176',
  400: '#ffee58',
  500: '#ffeb3b',
  600: '#fdd835',
  700: '#fbc02d',
  800: '#f9a825',
  900: '#f57f17',
  A100: '#ffff8d',
  A200: '#ffff00',
  A400: '#ffea00',
  A700: '#ffd600'
};
var _default = yellow;
exports.default = _default;

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var amber = {
  50: '#fff8e1',
  100: '#ffecb3',
  200: '#ffe082',
  300: '#ffd54f',
  400: '#ffca28',
  500: '#ffc107',
  600: '#ffb300',
  700: '#ffa000',
  800: '#ff8f00',
  900: '#ff6f00',
  A100: '#ffe57f',
  A200: '#ffd740',
  A400: '#ffc400',
  A700: '#ffab00'
};
var _default = amber;
exports.default = _default;

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var orange = {
  50: '#fff3e0',
  100: '#ffe0b2',
  200: '#ffcc80',
  300: '#ffb74d',
  400: '#ffa726',
  500: '#ff9800',
  600: '#fb8c00',
  700: '#f57c00',
  800: '#ef6c00',
  900: '#e65100',
  A100: '#ffd180',
  A200: '#ffab40',
  A400: '#ff9100',
  A700: '#ff6d00'
};
var _default = orange;
exports.default = _default;

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var deepOrange = {
  50: '#fbe9e7',
  100: '#ffccbc',
  200: '#ffab91',
  300: '#ff8a65',
  400: '#ff7043',
  500: '#ff5722',
  600: '#f4511e',
  700: '#e64a19',
  800: '#d84315',
  900: '#bf360c',
  A100: '#ff9e80',
  A200: '#ff6e40',
  A400: '#ff3d00',
  A700: '#dd2c00'
};
var _default = deepOrange;
exports.default = _default;

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var brown = {
  50: '#efebe9',
  100: '#d7ccc8',
  200: '#bcaaa4',
  300: '#a1887f',
  400: '#8d6e63',
  500: '#795548',
  600: '#6d4c41',
  700: '#5d4037',
  800: '#4e342e',
  900: '#3e2723',
  A100: '#d7ccc8',
  A200: '#bcaaa4',
  A400: '#8d6e63',
  A700: '#5d4037'
};
var _default = brown;
exports.default = _default;

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var blueGrey = {
  50: '#eceff1',
  100: '#cfd8dc',
  200: '#b0bec5',
  300: '#90a4ae',
  400: '#78909c',
  500: '#607d8b',
  600: '#546e7a',
  700: '#455a64',
  800: '#37474f',
  900: '#263238',
  A100: '#cfd8dc',
  A200: '#b0bec5',
  A400: '#78909c',
  A700: '#455a64'
};
var _default = blueGrey;
exports.default = _default;

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _helpers = __webpack_require__(51);

var _Paper = _interopRequireDefault(__webpack_require__(49));

// @inheritedComponent Paper
var styles = function styles(theme) {
  var backgroundColorDefault = theme.palette.type === 'light' ? theme.palette.grey[100] : theme.palette.grey[900];
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      boxSizing: 'border-box',
      // Prevent padding issue with the Modal and fixed positioned AppBar.
      zIndex: theme.zIndex.appBar,
      flexShrink: 0
    },

    /* Styles applied to the root element if `position="fixed"`. */
    positionFixed: {
      position: 'fixed',
      top: 0,
      left: 'auto',
      right: 0
    },

    /* Styles applied to the root element if `position="absolute"`. */
    positionAbsolute: {
      position: 'absolute',
      top: 0,
      left: 'auto',
      right: 0
    },

    /* Styles applied to the root element if `position="sticky"`. */
    positionSticky: {
      position: 'sticky',
      top: 0,
      left: 'auto',
      right: 0
    },

    /* Styles applied to the root element if `position="static"`. */
    positionStatic: {
      position: 'static'
    },

    /* Styles applied to the root element if `color="default"`. */
    colorDefault: {
      backgroundColor: backgroundColorDefault,
      color: theme.palette.getContrastText(backgroundColorDefault)
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    }
  };
};

exports.styles = styles;

function AppBar(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      position = props.position,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "position"]);
  var className = (0, _classnames.default)(classes.root, classes["position".concat((0, _helpers.capitalize)(position))], (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'inherit'), (0, _defineProperty2.default)(_classNames, 'mui-fixed', position === 'fixed'), _classNames), classNameProp);
  return _react.default.createElement(_Paper.default, (0, _extends2.default)({
    square: true,
    component: "header",
    elevation: 4,
    className: className
  }, other), children);
}

AppBar.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['inherit', 'primary', 'secondary', 'default']),

  /**
   * The positioning type. The behavior of the different options is described
   * [here](https://developer.mozilla.org/en-US/docs/Learn/CSS/CSS_layout/Positioning).
   * Note: `sticky` is not universally supported and will fall back to `static` when unavailable.
   */
  position: _propTypes.default.oneOf(['fixed', 'absolute', 'sticky', 'static'])
} : {};
AppBar.defaultProps = {
  color: 'primary',
  position: 'fixed'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiAppBar'
})(AppBar);

exports.default = _default;

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Badge.default;
  }
});

var _Badge = _interopRequireDefault(__webpack_require__(993));

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _helpers = __webpack_require__(51);

var RADIUS = 11;

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      display: 'inline-flex',
      // For correct alignment with the text.
      verticalAlign: 'middle'
    },

    /* Styles applied to the badge `span` element. */
    badge: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      top: -RADIUS,
      right: -RADIUS,
      fontFamily: theme.typography.fontFamily,
      fontWeight: theme.typography.fontWeight,
      fontSize: theme.typography.pxToRem(12),
      width: RADIUS * 2,
      height: RADIUS * 2,
      borderRadius: '50%',
      backgroundColor: theme.palette.color,
      color: theme.palette.textColor,
      zIndex: 1 // Render the badge on top of potential ripples.

    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      backgroundColor: theme.palette.error.main,
      color: theme.palette.error.contrastText
    }
  };
};

exports.styles = styles;

function Badge(props) {
  var badgeContent = props.badgeContent,
      children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      ComponentProp = props.component,
      other = (0, _objectWithoutProperties2.default)(props, ["badgeContent", "children", "classes", "className", "color", "component"]);
  var badgeClassName = (0, _classnames.default)(classes.badge, (0, _defineProperty2.default)({}, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'default'));
  return _react.default.createElement(ComponentProp, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, classNameProp)
  }, other), children, _react.default.createElement("span", {
    className: badgeClassName
  }, badgeContent));
}

Badge.propTypes =  false ? {
  /**
   * The content rendered within the badge.
   */
  badgeContent: _propTypes.default.node.isRequired,

  /**
   * The badge will be added relative to this node.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['default', 'primary', 'secondary', 'error']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object])
} : {};
Badge.defaultProps = {
  color: 'default',
  component: 'span'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiBadge'
})(Badge);

exports.default = _default;

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _BottomNavigation.default;
  }
});

var _BottomNavigation = _interopRequireDefault(__webpack_require__(995));

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _warning = _interopRequireDefault(__webpack_require__(37));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      justifyContent: 'center',
      height: 56,
      backgroundColor: theme.palette.background.paper
    }
  };
};

exports.styles = styles;

function BottomNavigation(props) {
  var childrenProp = props.children,
      classes = props.classes,
      classNameProp = props.className,
      onChange = props.onChange,
      showLabels = props.showLabels,
      value = props.value,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "onChange", "showLabels", "value"]);
  var className = (0, _classnames.default)(classes.root, classNameProp);

  var children = _react.default.Children.map(childrenProp, function (child, childIndex) {
    if (!_react.default.isValidElement(child)) {
      return null;
    }

     false ? (0, _warning.default)(child.type !== _react.default.Fragment, ["Material-UI: the BottomNavigation component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n')) : void 0;
    var childValue = child.props.value === undefined ? childIndex : child.props.value;
    return _react.default.cloneElement(child, {
      selected: childValue === value,
      showLabel: child.props.showLabel !== undefined ? child.props.showLabel : showLabels,
      value: childValue,
      onChange: onChange
    });
  });

  return _react.default.createElement("div", (0, _extends2.default)({
    className: className
  }, other), children);
}

BottomNavigation.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Callback fired when the value changes.
   *
   * @param {object} event The event source of the callback
   * @param {any} value We default to the index of the child
   */
  onChange: _propTypes.default.func,

  /**
   * If `true`, all `BottomNavigationAction`s will show their labels.
   * By default, only the selected `BottomNavigationAction` will show its label.
   */
  showLabels: _propTypes.default.bool,

  /**
   * The value of the currently selected `BottomNavigationAction`.
   */
  value: _propTypes.default.any
} : {};
BottomNavigation.defaultProps = {
  showLabels: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiBottomNavigation'
})(BottomNavigation);

exports.default = _default;

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _BottomNavigationAction.default;
  }
});

var _BottomNavigationAction = _interopRequireDefault(__webpack_require__(997));

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _ButtonBase = _interopRequireDefault(__webpack_require__(92));

var _unsupportedProp = _interopRequireDefault(__webpack_require__(306));

// @inheritedComponent ButtonBase
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      transition: theme.transitions.create(['color', 'padding-top'], {
        duration: theme.transitions.duration.short
      }),
      paddingTop: 8,
      paddingBottom: 10,
      paddingLeft: 12,
      paddingRight: 12,
      minWidth: 80,
      maxWidth: 168,
      color: theme.palette.text.secondary,
      flex: '1',
      '&$iconOnly': {
        paddingTop: 16
      },
      '&$selected': {
        paddingTop: 6,
        color: theme.palette.primary.main
      }
    },

    /* Styles applied to the root element if selected. */
    selected: {},

    /* Styles applied to the root element if `showLabel={false}` and not selected. */
    iconOnly: {},

    /* Styles applied to the span element that wraps the icon and label. */
    wrapper: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      flexDirection: 'column'
    },

    /* Styles applied to the label's span element. */
    label: {
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(12),
      opacity: 1,
      transition: 'font-size 0.2s, opacity 0.2s',
      transitionDelay: '0.1s',
      '&$iconOnly': {
        opacity: 0,
        transitionDelay: '0s'
      },
      '&$selected': {
        fontSize: theme.typography.pxToRem(14)
      }
    }
  };
};

exports.styles = styles;

var BottomNavigationAction =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(BottomNavigationAction, _React$Component);

  function BottomNavigationAction() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, BottomNavigationAction);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(BottomNavigationAction)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleChange = function (event) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          value = _this$props.value,
          onClick = _this$props.onClick;

      if (onChange) {
        onChange(event, value);
      }

      if (onClick) {
        onClick(event);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(BottomNavigationAction, [{
    key: "render",
    value: function render() {
      var _classNames, _classNames2;

      var _this$props2 = this.props,
          classes = _this$props2.classes,
          classNameProp = _this$props2.className,
          icon = _this$props2.icon,
          label = _this$props2.label,
          onChange = _this$props2.onChange,
          onClick = _this$props2.onClick,
          selected = _this$props2.selected,
          showLabelProp = _this$props2.showLabel,
          value = _this$props2.value,
          other = (0, _objectWithoutProperties2.default)(_this$props2, ["classes", "className", "icon", "label", "onChange", "onClick", "selected", "showLabel", "value"]);
      var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.selected, selected), (0, _defineProperty2.default)(_classNames, classes.iconOnly, !showLabelProp && !selected), _classNames), classNameProp);
      var labelClassName = (0, _classnames.default)(classes.label, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.selected, selected), (0, _defineProperty2.default)(_classNames2, classes.iconOnly, !showLabelProp && !selected), _classNames2));
      return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
        className: className,
        focusRipple: true,
        onClick: this.handleChange
      }, other), _react.default.createElement("span", {
        className: classes.wrapper
      }, icon, _react.default.createElement("span", {
        className: labelClassName
      }, label)));
    }
  }]);
  return BottomNavigationAction;
}(_react.default.Component);

BottomNavigationAction.propTypes =  false ? {
  /**
   * This property isn't supported.
   * Use the `component` property if you need to change the children structure.
   */
  children: _unsupportedProp.default,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The icon element.
   */
  icon: _propTypes.default.node,

  /**
   * The label element.
   */
  label: _propTypes.default.node,

  /**
   * @ignore
   */
  onChange: _propTypes.default.func,

  /**
   * @ignore
   */
  onClick: _propTypes.default.func,

  /**
   * @ignore
   */
  selected: _propTypes.default.bool,

  /**
   * If `true`, the `BottomNavigationAction` will show its label.
   * By default, only the selected `BottomNavigationAction`
   * inside `BottomNavigation` will show its label.
   */
  showLabel: _propTypes.default.bool,

  /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */
  value: _propTypes.default.any
} : {};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiBottomNavigationAction'
})(BottomNavigationAction);

exports.default = _default;

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _Paper = _interopRequireDefault(__webpack_require__(49));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

// @inheritedComponent Paper
var styles = {
  /* Styles applied to the root element. */
  root: {
    overflow: 'hidden'
  }
};
exports.styles = styles;

function Card(props) {
  var classes = props.classes,
      className = props.className,
      raised = props.raised,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "raised"]);
  return _react.default.createElement(_Paper.default, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className),
    elevation: raised ? 8 : 1
  }, other));
}

Card.propTypes =  false ? {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the card will use raised styling.
   */
  raised: _propTypes.default.bool
} : {};
Card.defaultProps = {
  raised: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiCard'
})(Card);

exports.default = _default;

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _reactHelpers = __webpack_require__(119);

__webpack_require__(8);

// So we don't have any override priority issue.
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: (0, _defineProperty2.default)({
      display: 'flex',
      alignItems: 'center',
      boxSizing: 'border-box',
      padding: '8px 4px'
    }, theme.breakpoints.up('sm'), {
      padding: '8px 12px'
    }),

    /* Styles applied to the children. */
    action: {
      margin: '0 4px'
    }
  };
};

exports.styles = styles;

function CardActions(props) {
  var disableActionSpacing = props.disableActionSpacing,
      children = props.children,
      classes = props.classes,
      className = props.className,
      other = (0, _objectWithoutProperties2.default)(props, ["disableActionSpacing", "children", "classes", "className"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, other), disableActionSpacing ? children : (0, _reactHelpers.cloneChildrenWithClassName)(children, classes.action));
}

CardActions.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the card actions do not have additional margin.
   */
  disableActionSpacing: _propTypes.default.bool
} : {};
CardActions.defaultProps = {
  disableActionSpacing: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiCardActions'
})(CardActions);

exports.default = _default;

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: theme.mixins.gutters({
      paddingTop: 16,
      paddingBottom: 16,
      '&:last-child': {
        paddingBottom: 24
      }
    })
  };
};

exports.styles = styles;

function CardContent(props) {
  var classes = props.classes,
      className = props.className,
      Component = props.component,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component"]);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, other));
}

CardContent.propTypes =  false ? {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object])
} : {};
CardContent.defaultProps = {
  component: 'div'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiCardContent'
})(CardContent);

exports.default = _default;

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _Typography = _interopRequireDefault(__webpack_require__(13));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: theme.mixins.gutters({
      display: 'flex',
      alignItems: 'center',
      paddingTop: 16,
      paddingBottom: 16
    }),

    /* Styles applied to the avatar element. */
    avatar: {
      flex: '0 0 auto',
      marginRight: 16
    },

    /* Styles applied to the action element. */
    action: (0, _defineProperty2.default)({
      flex: '0 0 auto',
      alignSelf: 'flex-start',
      marginTop: -8,
      marginRight: -12
    }, theme.breakpoints.up('sm'), {
      marginRight: -20
    }),

    /* Styles applied to the content wrapper element. */
    content: {
      flex: '1 1 auto'
    },

    /* Styles applied to the title Typography element. */
    title: {},

    /* Styles applied to the subheader Typography element. */
    subheader: {}
  };
};

exports.styles = styles;

function CardHeader(props) {
  var action = props.action,
      avatar = props.avatar,
      classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      disableTypography = props.disableTypography,
      subheaderProp = props.subheader,
      subheaderTypographyProps = props.subheaderTypographyProps,
      titleProp = props.title,
      titleTypographyProps = props.titleTypographyProps,
      other = (0, _objectWithoutProperties2.default)(props, ["action", "avatar", "classes", "className", "component", "disableTypography", "subheader", "subheaderTypographyProps", "title", "titleTypographyProps"]);
  var title = titleProp;

  if (title != null && title.type !== _Typography.default && !disableTypography) {
    title = _react.default.createElement(_Typography.default, (0, _extends2.default)({
      variant: avatar ? 'body2' : 'headline',
      className: classes.title,
      component: "span"
    }, titleTypographyProps), title);
  }

  var subheader = subheaderProp;

  if (subheader != null && subheader.type !== _Typography.default && !disableTypography) {
    subheader = _react.default.createElement(_Typography.default, (0, _extends2.default)({
      variant: avatar ? 'body2' : 'body1',
      className: classes.subheader,
      color: "textSecondary",
      component: "span"
    }, subheaderTypographyProps), subheader);
  }

  return _react.default.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, classNameProp)
  }, other), avatar && _react.default.createElement("div", {
    className: classes.avatar
  }, avatar), _react.default.createElement("div", {
    className: classes.content
  }, title, subheader), action && _react.default.createElement("div", {
    className: classes.action
  }, action));
}

CardHeader.propTypes =  false ? {
  /**
   * The action to display in the card header.
   */
  action: _propTypes.default.node,

  /**
   * The Avatar for the Card Header.
   */
  avatar: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the children won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `title` text, and optional `subheader` text
   * with the Typography component.
   */
  disableTypography: _propTypes.default.bool,

  /**
   * The content of the component.
   */
  subheader: _propTypes.default.node,

  /**
   * These props will be forwarded to the subheader
   * (as long as disableTypography is not `true`).
   */
  subheaderTypographyProps: _propTypes.default.object,

  /**
   * The content of the Card Title.
   */
  title: _propTypes.default.node,

  /**
   * These props will be forwarded to the title
   * (as long as disableTypography is not `true`).
   */
  titleTypographyProps: _propTypes.default.object
} : {};
CardHeader.defaultProps = {
  component: 'div',
  disableTypography: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiCardHeader'
})(CardHeader);

exports.default = _default;

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _CardMedia.default;
  }
});

var _CardMedia = _interopRequireDefault(__webpack_require__(1003));

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _warning = _interopRequireDefault(__webpack_require__(37));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'block',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center'
  },

  /* Styles applied to the root element if `component="video, audio, picture, iframe, or img"`. */
  media: {
    width: '100%'
  }
};
exports.styles = styles;
var MEDIA_COMPONENTS = ['video', 'audio', 'picture', 'iframe', 'img'];

function CardMedia(props) {
  var classes = props.classes,
      className = props.className,
      Component = props.component,
      image = props.image,
      src = props.src,
      style = props.style,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "image", "src", "style"]);
   false ? (0, _warning.default)(Boolean(image || src), 'Material-UI: either `image` or `src` property must be specified.') : void 0;
  var isMediaComponent = MEDIA_COMPONENTS.indexOf(Component) !== -1;
  var composedStyle = !isMediaComponent && image ? (0, _extends2.default)({
    backgroundImage: "url(\"".concat(image, "\")")
  }, style) : style;
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.media, isMediaComponent), className),
    style: composedStyle,
    src: isMediaComponent ? image || src : undefined
  }, other));
}

CardMedia.propTypes =  false ? {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Component for rendering image.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Image to be displayed as a background image.
   * Either `image` or `src` prop must be specified.
   * Note that caller must specify height otherwise the image will not be visible.
   */
  image: _propTypes.default.string,

  /**
   * An alias for `image` property.
   * Available only with media components.
   * Media components: `video`, `audio`, `picture`, `iframe`, `img`.
   */
  src: _propTypes.default.string,

  /**
   * @ignore
   */
  style: _propTypes.default.object
} : {};
CardMedia.defaultProps = {
  component: 'div'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiCardMedia'
})(CardMedia);

exports.default = _default;

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(64));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _reactEventListener = _interopRequireDefault(__webpack_require__(93));

var _ownerDocument = _interopRequireDefault(__webpack_require__(100));

// @inheritedComponent EventListener

/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 */
var ClickAwayListener =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ClickAwayListener, _React$Component);

  function ClickAwayListener() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, ClickAwayListener);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(ClickAwayListener)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.node = null;
    _this.mounted = null;

    _this.handleClickAway = function (event) {
      // Ignore events that have been `event.preventDefault()` marked.
      if (event.defaultPrevented) {
        return;
      } // IE11 support, which trigger the handleClickAway even after the unbind


      if (!_this.mounted) {
        return;
      } // The child might render null.


      if (!_this.node) {
        return;
      }

      var doc = (0, _ownerDocument.default)(_this.node);

      if (doc.documentElement && doc.documentElement.contains(event.target) && !_this.node.contains(event.target)) {
        _this.props.onClickAway(event);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(ClickAwayListener, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Finds the first child when a component returns a fragment.
      // https://github.com/facebook/react/blob/036ae3c6e2f056adffc31dfb78d1b6f0c63272f0/packages/react-dom/src/__tests__/ReactDOMFiber-test.js#L105
      this.node = _reactDom.default.findDOMNode(this);
      this.mounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          mouseEvent = _this$props.mouseEvent,
          touchEvent = _this$props.touchEvent,
          onClickAway = _this$props.onClickAway,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["children", "mouseEvent", "touchEvent", "onClickAway"]);
      var listenerProps = {};

      if (mouseEvent !== false) {
        listenerProps[mouseEvent] = this.handleClickAway;
      }

      if (touchEvent !== false) {
        listenerProps[touchEvent] = this.handleClickAway;
      }

      return _react.default.createElement(_reactEventListener.default, (0, _extends2.default)({
        target: "document"
      }, listenerProps, other), children);
    }
  }]);
  return ClickAwayListener;
}(_react.default.Component);

ClickAwayListener.propTypes =  false ? {
  /**
   * The wrapped element.
   */
  children: _propTypes.default.element.isRequired,

  /**
   * The mouse event to listen to. You can disable the listener by providing `false`.
   */
  mouseEvent: _propTypes.default.oneOf(['onClick', 'onMouseDown', 'onMouseUp', false]),

  /**
   * Callback fired when a "click away" event is detected.
   */
  onClickAway: _propTypes.default.func.isRequired,

  /**
   * The touch event to listen to. You can disable the listener by providing `false`.
   */
  touchEvent: _propTypes.default.oneOf(['onTouchStart', 'onTouchEnd', false])
} : {};
ClickAwayListener.defaultProps = {
  mouseEvent: 'onMouseUp',
  touchEvent: 'onTouchEnd'
};
var _default = ClickAwayListener;
exports.default = _default;

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _Transition = _interopRequireDefault(__webpack_require__(101));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _transitions = __webpack_require__(99);

var _utils = __webpack_require__(148);

// @inheritedComponent Transition
var styles = function styles(theme) {
  return {
    /* Styles applied to the container element. */
    container: {
      height: 0,
      overflow: 'hidden',
      transition: theme.transitions.create('height')
    },

    /* Styles applied to the container element when the transition has entered. */
    entered: {
      height: 'auto'
    },

    /* Styles applied to the outer wrapper element. */
    wrapper: {
      // Hack to get children with a negative margin to not falsify the height computation.
      display: 'flex'
    },

    /* Styles applied to the outer wrapper element. */
    wrapperInner: {
      width: '100%'
    }
  };
};
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/demos/steppers#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */


exports.styles = styles;

var Collapse =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Collapse, _React$Component);

  function Collapse() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Collapse);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Collapse)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.wrapper = null;
    _this.autoTransitionDuration = null;
    _this.timer = null;

    _this.handleEnter = function (node) {
      node.style.height = _this.props.collapsedHeight;

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    };

    _this.handleEntering = function (node) {
      var _this$props = _this.props,
          timeout = _this$props.timeout,
          theme = _this$props.theme;
      var wrapperHeight = _this.wrapperRef ? _this.wrapperRef.clientHeight : 0;

      var _getTransitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'enter'
      }),
          transitionDuration = _getTransitionProps.duration;

      if (timeout === 'auto') {
        var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
        node.style.transitionDuration = "".concat(duration2, "ms");
        _this.autoTransitionDuration = duration2;
      } else {
        node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
      }

      node.style.height = "".concat(wrapperHeight, "px");

      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    };

    _this.handleEntered = function (node) {
      node.style.height = 'auto';

      if (_this.props.onEntered) {
        _this.props.onEntered(node);
      }
    };

    _this.handleExit = function (node) {
      var wrapperHeight = _this.wrapperRef ? _this.wrapperRef.clientHeight : 0;
      node.style.height = "".concat(wrapperHeight, "px");

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.handleExiting = function (node) {
      var _this$props2 = _this.props,
          timeout = _this$props2.timeout,
          theme = _this$props2.theme;
      var wrapperHeight = _this.wrapperRef ? _this.wrapperRef.clientHeight : 0;

      var _getTransitionProps2 = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'exit'
      }),
          transitionDuration = _getTransitionProps2.duration;

      if (timeout === 'auto') {
        var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
        node.style.transitionDuration = "".concat(duration2, "ms");
        _this.autoTransitionDuration = duration2;
      } else {
        node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
      }

      node.style.height = _this.props.collapsedHeight;

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    };

    _this.addEndListener = function (_, next) {
      if (_this.props.timeout === 'auto') {
        _this.timer = setTimeout(next, _this.autoTransitionDuration || 0);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(Collapse, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          children = _this$props3.children,
          classes = _this$props3.classes,
          className = _this$props3.className,
          collapsedHeight = _this$props3.collapsedHeight,
          Component = _this$props3.component,
          onEnter = _this$props3.onEnter,
          onEntered = _this$props3.onEntered,
          onEntering = _this$props3.onEntering,
          onExit = _this$props3.onExit,
          onExiting = _this$props3.onExiting,
          style = _this$props3.style,
          theme = _this$props3.theme,
          timeout = _this$props3.timeout,
          other = (0, _objectWithoutProperties2.default)(_this$props3, ["children", "classes", "className", "collapsedHeight", "component", "onEnter", "onEntered", "onEntering", "onExit", "onExiting", "style", "theme", "timeout"]);
      return _react.default.createElement(_Transition.default, (0, _extends2.default)({
        onEnter: this.handleEnter,
        onEntered: this.handleEntered,
        onEntering: this.handleEntering,
        onExit: this.handleExit,
        onExiting: this.handleExiting,
        addEndListener: this.addEndListener,
        timeout: timeout === 'auto' ? null : timeout
      }, other), function (state, childProps) {
        return _react.default.createElement(Component, (0, _extends2.default)({
          className: (0, _classnames.default)(classes.container, (0, _defineProperty2.default)({}, classes.entered, state === 'entered'), className),
          style: (0, _extends2.default)({}, style, {
            minHeight: collapsedHeight
          })
        }, childProps), _react.default.createElement("div", {
          className: classes.wrapper,
          ref: function ref(_ref) {
            _this2.wrapperRef = _ref;
          }
        }, _react.default.createElement("div", {
          className: classes.wrapperInner
        }, children)));
      });
    }
  }]);
  return Collapse;
}(_react.default.Component);

Collapse.propTypes =  false ? {
  /**
   * The content node to be collapsed.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The height of the container when collapsed.
   */
  collapsedHeight: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the component will transition in.
   */
  in: _propTypes.default.bool,

  /**
   * @ignore
   */
  onEnter: _propTypes.default.func,

  /**
   * @ignore
   */
  onEntered: _propTypes.default.func,

  /**
   * @ignore
   */
  onEntering: _propTypes.default.func,

  /**
   * @ignore
   */
  onExit: _propTypes.default.func,

  /**
   * @ignore
   */
  onExiting: _propTypes.default.func,

  /**
   * @ignore
   */
  style: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  }), _propTypes.default.oneOf(['auto'])])
} : {};
Collapse.defaultProps = {
  collapsedHeight: '0px',
  component: 'div',
  timeout: _transitions.duration.standard
};
Collapse.muiSupportAuto = true;

var _default = (0, _withStyles.default)(styles, {
  withTheme: true,
  name: 'MuiCollapse'
})(Collapse);

exports.default = _default;

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _Typography = _interopRequireDefault(__webpack_require__(13));

// @inheritedComponent Typography
var styles = {
  /* Styles applied to the root element. */
  root: {}
};
exports.styles = styles;

function DialogContentText(props) {
  return _react.default.createElement(_Typography.default, (0, _extends2.default)({
    component: "p",
    variant: "subheading",
    color: "textSecondary"
  }, props));
}

DialogContentText.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired
} : {};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiDialogContentText'
})(DialogContentText);

exports.default = _default;

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _Typography = _interopRequireDefault(__webpack_require__(13));

var styles = {
  /* Styles applied to the root element. */
  root: {
    margin: 0,
    padding: '24px 24px 20px',
    flex: '0 0 auto'
  }
};
exports.styles = styles;

function DialogTitle(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      disableTypography = props.disableTypography,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disableTypography"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, other), disableTypography ? children : _react.default.createElement(_Typography.default, {
    variant: "title"
  }, children));
}

DialogTitle.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the children won't be wrapped by a typography component.
   * For instance, this can be useful to render an h4 instead of the default h2.
   */
  disableTypography: _propTypes.default.bool
} : {};
DialogTitle.defaultProps = {
  disableTypography: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiDialogTitle'
})(DialogTitle);

exports.default = _default;

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _colorManipulator = __webpack_require__(80);

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      height: 1,
      margin: 0,
      // Reset browser default style.
      border: 'none',
      flexShrink: 0,
      backgroundColor: theme.palette.divider
    },

    /* Styles applied to the root element if `absolute={true}`. */
    absolute: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '100%'
    },

    /* Styles applied to the root element if `inset={true}`. */
    inset: {
      marginLeft: 72
    },

    /* Styles applied to the root element if `light={true}`. */
    light: {
      backgroundColor: (0, _colorManipulator.fade)(theme.palette.divider, 0.08)
    }
  };
};

exports.styles = styles;

function Divider(props) {
  var _classNames;

  var absolute = props.absolute,
      classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      inset = props.inset,
      light = props.light,
      other = (0, _objectWithoutProperties2.default)(props, ["absolute", "classes", "className", "component", "inset", "light"]);
  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.absolute, absolute), (0, _defineProperty2.default)(_classNames, classes.inset, inset), (0, _defineProperty2.default)(_classNames, classes.light, light), _classNames), classNameProp);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className
  }, other));
}

Divider.propTypes =  false ? {
  absolute: _propTypes.default.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the divider will be indented.
   */
  inset: _propTypes.default.bool,

  /**
   * If `true`, the divider will have a lighter color.
   */
  light: _propTypes.default.bool
} : {};
Divider.defaultProps = {
  absolute: false,
  component: 'hr',
  inset: false,
  light: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiDivider'
})(Divider);

exports.default = _default;

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setTranslateValue = setTranslateValue;
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _reactDom = _interopRequireDefault(__webpack_require__(64));

var _reactEventListener = _interopRequireDefault(__webpack_require__(93));

var _debounce = _interopRequireDefault(__webpack_require__(118));

var _Transition = _interopRequireDefault(__webpack_require__(101));

var _ownerWindow = _interopRequireDefault(__webpack_require__(221));

var _withTheme = _interopRequireDefault(__webpack_require__(90));

var _transitions = __webpack_require__(99);

var _utils = __webpack_require__(148);

// @inheritedComponent Transition
// < 1kb payload overhead when lodash/debounce is > 3kb.
var GUTTER = 24; // Translate the node so he can't be seen on the screen.
// Later, we gonna translate back the node to his original location
// with `translate3d(0, 0, 0)`.`

function getTranslateValue(props, node) {
  var direction = props.direction;
  var rect = node.getBoundingClientRect();
  var transform;

  if (node.fakeTransform) {
    transform = node.fakeTransform;
  } else {
    var computedStyle = (0, _ownerWindow.default)(node).getComputedStyle(node);
    transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
  }

  var offsetX = 0;
  var offsetY = 0;

  if (transform && transform !== 'none' && typeof transform === 'string') {
    var transformValues = transform.split('(')[1].split(')')[0].split(',');
    offsetX = parseInt(transformValues[4], 10);
    offsetY = parseInt(transformValues[5], 10);
  }

  if (direction === 'left') {
    return "translateX(100vw) translateX(-".concat(rect.left - offsetX, "px)");
  }

  if (direction === 'right') {
    return "translateX(-".concat(rect.left + rect.width + GUTTER - offsetX, "px)");
  }

  if (direction === 'up') {
    return "translateY(100vh) translateY(-".concat(rect.top - offsetY, "px)");
  } // direction === 'down'


  return "translateY(-".concat(rect.top + rect.height + GUTTER - offsetY, "px)");
}

function setTranslateValue(props, node) {
  var transform = getTranslateValue(props, node);

  if (transform) {
    node.style.webkitTransform = transform;
    node.style.transform = transform;
  }
}
/**
 * The Slide transition is used by the [Snackbar](/demos/snackbars) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */


var Slide =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Slide, _React$Component);

  function Slide() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Slide);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Slide)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.mounted = false;
    _this.transition = null;
    _this.handleResize = (0, _debounce.default)(function () {
      // Skip configuration where the position is screen size invariant.
      if (_this.props.in || _this.props.direction === 'down' || _this.props.direction === 'right') {
        return;
      }

      if (_this.transitionRef) {
        setTranslateValue(_this.props, _this.transitionRef);
      }
    }, 166);

    _this.handleEnter = function (node) {
      setTranslateValue(_this.props, node);
      (0, _utils.reflow)(node);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    };

    _this.handleEntering = function (node) {
      var theme = _this.props.theme;
      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'enter'
      });
      node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, _extends2.default)({}, transitionProps, {
        easing: theme.transitions.easing.easeOut
      }));
      node.style.transition = theme.transitions.create('transform', (0, _extends2.default)({}, transitionProps, {
        easing: theme.transitions.easing.easeOut
      }));
      node.style.webkitTransform = 'translate(0, 0)';
      node.style.transform = 'translate(0, 0)';

      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    };

    _this.handleExit = function (node) {
      var theme = _this.props.theme;
      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'exit'
      });
      node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, _extends2.default)({}, transitionProps, {
        easing: theme.transitions.easing.sharp
      }));
      node.style.transition = theme.transitions.create('transform', (0, _extends2.default)({}, transitionProps, {
        easing: theme.transitions.easing.sharp
      }));
      setTranslateValue(_this.props, node);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.handleExited = function (node) {
      // No need for transitions when the component is hidden
      node.style.webkitTransition = '';
      node.style.transition = '';

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(Slide, [{
    key: "componentDidMount",
    // Corresponds to 10 frames at 60 Hz.
    value: function componentDidMount() {
      // state.mounted handle SSR, once the component is mounted, we need
      // to properly hide it.
      if (!this.props.in) {
        // We need to set initial translate values of transition element
        // otherwise component will be shown when in=false.
        this.updatePosition();
      }

      this.mounted = true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.direction !== this.props.direction && !this.props.in) {
        // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        this.updatePosition();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handleResize.clear();
    }
  }, {
    key: "updatePosition",
    value: function updatePosition() {
      if (this.transitionRef) {
        this.transitionRef.style.visibility = 'inherit';
        setTranslateValue(this.props, this.transitionRef);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          onEnter = _this$props.onEnter,
          onEntering = _this$props.onEntering,
          onExit = _this$props.onExit,
          onExited = _this$props.onExited,
          styleProp = _this$props.style,
          theme = _this$props.theme,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["children", "onEnter", "onEntering", "onExit", "onExited", "style", "theme"]);
      var style = {}; // We use this state to handle the server-side rendering.
      // We don't know the width of the children ahead of time.
      // We need to render it.

      if (!this.props.in && !this.mounted) {
        style.visibility = 'hidden';
      }

      style = (0, _extends2.default)({}, style, styleProp, _react.default.isValidElement(children) ? children.props.style : {});
      return _react.default.createElement(_reactEventListener.default, {
        target: "window",
        onResize: this.handleResize
      }, _react.default.createElement(_Transition.default, (0, _extends2.default)({
        onEnter: this.handleEnter,
        onEntering: this.handleEntering,
        onExit: this.handleExit,
        onExited: this.handleExited,
        appear: true,
        style: style,
        ref: function ref(_ref) {
          _this2.transitionRef = _reactDom.default.findDOMNode(_ref);
        }
      }, other), children));
    }
  }]);
  return Slide;
}(_react.default.Component);

Slide.propTypes =  false ? {
  /**
   * A single child content element.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),

  /**
   * Direction the child node will enter from.
   */
  direction: _propTypes.default.oneOf(['left', 'right', 'up', 'down']),

  /**
   * If `true`, show the component; triggers the enter or exit animation.
   */
  in: _propTypes.default.bool,

  /**
   * @ignore
   */
  onEnter: _propTypes.default.func,

  /**
   * @ignore
   */
  onEntering: _propTypes.default.func,

  /**
   * @ignore
   */
  onExit: _propTypes.default.func,

  /**
   * @ignore
   */
  onExited: _propTypes.default.func,

  /**
   * @ignore
   */
  style: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })])
} : {};
Slide.defaultProps = {
  direction: 'down',
  timeout: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  }
};

var _default = (0, _withTheme.default)()(Slide);

exports.default = _default;

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _warning = _interopRequireDefault(__webpack_require__(37));

var _Collapse = _interopRequireDefault(__webpack_require__(236));

var _Paper = _interopRequireDefault(__webpack_require__(49));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _reactHelpers = __webpack_require__(119);

// @inheritedComponent Paper
// Workaround https://github.com/jsdom/jsdom/issues/2026
var edgeFix = typeof window !== 'undefined' && /jsdom/.test(window.navigator.userAgent) ? {} : {
  // Fix a rendering issue on Edge
  '@supports (-ms-ime-align: auto)': {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0
  }
};

var styles = function styles(theme) {
  var transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      transition: theme.transitions.create(['margin'], transition),
      '&:before': {
        position: 'absolute',
        left: 0,
        top: -1,
        right: 0,
        height: 1,
        content: '""',
        opacity: 1,
        backgroundColor: theme.palette.divider,
        transition: theme.transitions.create(['opacity', 'background-color'], transition)
      },
      '&:first-child': {
        borderTopLeftRadius: 2,
        borderTopRightRadius: 2,
        '&:before': {
          display: 'none'
        }
      },
      '&:last-child': (0, _extends2.default)({
        borderBottomLeftRadius: 2,
        borderBottomRightRadius: 2
      }, edgeFix),
      '&$expanded + &': {
        '&:before': {
          display: 'none'
        }
      }
    },

    /* Styles applied to the root element if `expanded={true}`. */
    expanded: {
      margin: '16px 0',
      '&:first-child': {
        marginTop: 0
      },
      '&:last-child': {
        marginBottom: 0
      },
      '&:before': {
        opacity: 0
      }
    },

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {
      backgroundColor: theme.palette.action.disabledBackground
    }
  };
};

exports.styles = styles;

var ExpansionPanel =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ExpansionPanel, _React$Component);

  function ExpansionPanel(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ExpansionPanel);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ExpansionPanel).call(this));
    _this.isControlled = null;
    _this.state = {};

    _this.handleChange = function (event) {
      var expanded = _this.isControlled ? _this.props.expanded : _this.state.expanded;

      if (!_this.isControlled) {
        _this.setState({
          expanded: !expanded
        });
      }

      if (_this.props.onChange) {
        _this.props.onChange(event, !expanded);
      }
    };

    _this.isControlled = props.expanded != null;

    if (!_this.isControlled) {
      // not controlled, use internal state
      _this.state.expanded = props.defaultExpanded !== undefined ? props.defaultExpanded : false;
    }

    return _this;
  }

  (0, _createClass2.default)(ExpansionPanel, [{
    key: "render",
    value: function render() {
      var _classNames,
          _this2 = this;

      var _this$props = this.props,
          childrenProp = _this$props.children,
          classes = _this$props.classes,
          classNameProp = _this$props.className,
          CollapsePropsProp = _this$props.CollapseProps,
          defaultExpanded = _this$props.defaultExpanded,
          disabled = _this$props.disabled,
          expandedProp = _this$props.expanded,
          onChange = _this$props.onChange,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["children", "classes", "className", "CollapseProps", "defaultExpanded", "disabled", "expanded", "onChange"]);
      var expanded = this.isControlled ? expandedProp : this.state.expanded;
      var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.expanded, expanded), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), _classNames), classNameProp);
      var summary = null;

      var children = _react.default.Children.map(childrenProp, function (child) {
        if (!_react.default.isValidElement(child)) {
          return null;
        }

         false ? (0, _warning.default)(child.type !== _react.default.Fragment, ["Material-UI: the ExpansionPanel component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n')) : void 0;

        if ((0, _reactHelpers.isMuiElement)(child, ['ExpansionPanelSummary'])) {
          summary = _react.default.cloneElement(child, {
            disabled: disabled,
            expanded: expanded,
            onChange: _this2.handleChange
          });
          return null;
        }

        return child;
      });

      var CollapseProps = !expanded ? {
        'aria-hidden': 'true'
      } : null;
      return _react.default.createElement(_Paper.default, (0, _extends2.default)({
        className: className,
        elevation: 1,
        square: true
      }, other), summary, _react.default.createElement(_Collapse.default, (0, _extends2.default)({
        in: expanded,
        timeout: "auto"
      }, CollapseProps, CollapsePropsProp), children));
    }
  }]);
  return ExpansionPanel;
}(_react.default.Component);

ExpansionPanel.propTypes =  false ? {
  /**
   * The content of the expansion panel.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Properties applied to the [`Collapse`](/api/collapse) element.
   */
  CollapseProps: _propTypes.default.object,

  /**
   * If `true`, expands the panel by default.
   */
  defaultExpanded: _propTypes.default.bool,

  /**
   * If `true`, the panel will be displayed in a disabled state.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, expands the panel, otherwise collapse it.
   * Setting this prop enables control over the panel.
   */
  expanded: _propTypes.default.bool,

  /**
   * Callback fired when the expand/collapse state is changed.
   *
   * @param {object} event The event source of the callback
   * @param {boolean} expanded The `expanded` state of the panel
   */
  onChange: _propTypes.default.func
} : {};
ExpansionPanel.defaultProps = {
  defaultExpanded: false,
  disabled: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiExpansionPanel'
})(ExpansionPanel);

exports.default = _default;

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ExpansionPanelActions.default;
  }
});

var _ExpansionPanelActions = _interopRequireDefault(__webpack_require__(1012));

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _reactHelpers = __webpack_require__(119);

__webpack_require__(8);

// So we don't have any override priority issue.
var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '16px 8px'
  },

  /* Styles applied to the children. */
  action: {
    marginLeft: 8
  }
};
exports.styles = styles;

function ExpansionPanelActions(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, other), (0, _reactHelpers.cloneChildrenWithClassName)(children, classes.action));
}

ExpansionPanelActions.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string
} : {};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiExpansionPanelActions'
})(ExpansionPanelActions);

exports.default = _default;

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    padding: '8px 24px 24px'
  }
};
exports.styles = styles;

function ExpansionPanelDetails(props) {
  var classes = props.classes,
      children = props.children,
      className = props.className,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "children", "className"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, other), children);
}

ExpansionPanelDetails.propTypes =  false ? {
  /**
   * The content of the expansion panel details.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string
} : {};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiExpansionPanelDetails'
})(ExpansionPanelDetails);

exports.default = _default;

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _ButtonBase = _interopRequireDefault(__webpack_require__(92));

var _IconButton = _interopRequireDefault(__webpack_require__(71));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

// @inheritedComponent ButtonBase
var styles = function styles(theme) {
  var transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      minHeight: 8 * 6,
      transition: theme.transitions.create(['min-height', 'background-color'], transition),
      padding: '0 24px 0 24px',
      '&:hover:not($disabled)': {
        cursor: 'pointer'
      },
      '&$expanded': {
        minHeight: 64
      },
      '&$focused': {
        backgroundColor: theme.palette.grey[300]
      },
      '&$disabled': {
        opacity: 0.38
      }
    },

    /* Styles applied to the root element if `expanded={true}`. */
    expanded: {},

    /* Styles applied to the root and children wrapper elements when focused. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the children wrapper element. */
    content: {
      display: 'flex',
      flexGrow: 1,
      transition: theme.transitions.create(['margin'], transition),
      margin: '12px 0',
      '& > :last-child': {
        paddingRight: 32
      },
      '&$expanded': {
        margin: '20px 0'
      }
    },

    /* Styles applied to the `IconButton` component when `expandIcon` is supplied. */
    expandIcon: {
      position: 'absolute',
      top: '50%',
      right: 8,
      transform: 'translateY(-50%) rotate(0deg)',
      transition: theme.transitions.create('transform', transition),
      '&:hover': {
        // Disable the hover effect for the IconButton,
        // because a hover effect should apply to the entire Expand button and
        // not only to the IconButton.
        backgroundColor: 'transparent'
      },
      '&$expanded': {
        transform: 'translateY(-50%) rotate(180deg)'
      }
    }
  };
};

exports.styles = styles;

var ExpansionPanelSummary =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ExpansionPanelSummary, _React$Component);

  function ExpansionPanelSummary() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, ExpansionPanelSummary);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(ExpansionPanelSummary)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      focused: false
    };

    _this.handleFocus = function () {
      _this.setState({
        focused: true
      });
    };

    _this.handleBlur = function () {
      _this.setState({
        focused: false
      });
    };

    _this.handleChange = function (event) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          onClick = _this$props.onClick;

      if (onChange) {
        onChange(event);
      }

      if (onClick) {
        onClick(event);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(ExpansionPanelSummary, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props2 = this.props,
          children = _this$props2.children,
          classes = _this$props2.classes,
          className = _this$props2.className,
          disabled = _this$props2.disabled,
          expanded = _this$props2.expanded,
          expandIcon = _this$props2.expandIcon,
          IconButtonProps = _this$props2.IconButtonProps,
          onChange = _this$props2.onChange,
          other = (0, _objectWithoutProperties2.default)(_this$props2, ["children", "classes", "className", "disabled", "expanded", "expandIcon", "IconButtonProps", "onChange"]);
      var focused = this.state.focused;
      return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
        focusRipple: false,
        disableRipple: true,
        disabled: disabled,
        component: "div",
        "aria-expanded": expanded,
        className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.expanded, expanded), (0, _defineProperty2.default)(_classNames, classes.focused, focused), _classNames), className)
      }, other, {
        onFocusVisible: this.handleFocus,
        onBlur: this.handleBlur,
        onClick: this.handleChange
      }), _react.default.createElement("div", {
        className: (0, _classnames.default)(classes.content, (0, _defineProperty2.default)({}, classes.expanded, expanded))
      }, children), expandIcon && _react.default.createElement(_IconButton.default, (0, _extends2.default)({
        disabled: disabled,
        className: (0, _classnames.default)(classes.expandIcon, (0, _defineProperty2.default)({}, classes.expanded, expanded)),
        component: "div",
        tabIndex: -1,
        "aria-hidden": "true"
      }, IconButtonProps), expandIcon));
    }
  }]);
  return ExpansionPanelSummary;
}(_react.default.Component);

ExpansionPanelSummary.propTypes =  false ? {
  /**
   * The content of the expansion panel summary.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   * If `true`, the summary will be displayed in a disabled state.
   */
  disabled: _propTypes.default.bool,

  /**
   * @ignore
   * If `true`, expands the summary, otherwise collapse it.
   */
  expanded: _propTypes.default.bool,

  /**
   * The icon to display as the expand indicator.
   */
  expandIcon: _propTypes.default.node,

  /**
   * Properties applied to the `TouchRipple` element wrapping the expand icon.
   */
  IconButtonProps: _propTypes.default.object,

  /**
   * @ignore
   */
  onChange: _propTypes.default.func,

  /**
   * @ignore
   */
  onClick: _propTypes.default.func
} : {};
ExpansionPanelSummary.defaultProps = {
  disabled: false
};
ExpansionPanelSummary.muiName = 'ExpansionPanelSummary';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiExpansionPanelSummary'
})(ExpansionPanelSummary);

exports.default = _default;

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _Typography = _interopRequireDefault(__webpack_require__(13));

/* eslint-disable jsx-a11y/label-has-for */
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-flex',
      alignItems: 'center',
      cursor: 'pointer',
      // For correct alignment with the text.
      verticalAlign: 'middle',
      // Remove grey highlight
      WebkitTapHighlightColor: 'transparent',
      marginLeft: -14,
      marginRight: 16,
      // used for row presentation of radio/checkbox
      '&$disabled': {
        cursor: 'default'
      }
    },

    /* Styles applied to the root element if `labelPlacement="start"`. */
    labelPlacementStart: {
      flexDirection: 'row-reverse'
    },

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the label's Typography component. */
    label: {
      '&$disabled': {
        color: theme.palette.text.disabled
      }
    }
  };
};
/**
 * Drop in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */


exports.styles = styles;

function FormControlLabel(props, context) {
  var _classNames;

  var checked = props.checked,
      classes = props.classes,
      classNameProp = props.className,
      control = props.control,
      disabledProp = props.disabled,
      inputRef = props.inputRef,
      label = props.label,
      labelPlacement = props.labelPlacement,
      name = props.name,
      onChange = props.onChange,
      value = props.value,
      other = (0, _objectWithoutProperties2.default)(props, ["checked", "classes", "className", "control", "disabled", "inputRef", "label", "labelPlacement", "name", "onChange", "value"]);
  var muiFormControl = context.muiFormControl;
  var disabled = disabledProp;

  if (typeof disabled === 'undefined' && typeof control.props.disabled !== 'undefined') {
    disabled = control.props.disabled;
  }

  if (typeof disabled === 'undefined' && muiFormControl) {
    disabled = muiFormControl.disabled;
  }

  var controlProps = {
    disabled: disabled
  };
  ['checked', 'name', 'onChange', 'value', 'inputRef'].forEach(function (key) {
    if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') {
      controlProps[key] = props[key];
    }
  });
  return _react.default.createElement("label", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.labelPlacementStart, labelPlacement === 'start'), (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), _classNames), classNameProp)
  }, other), _react.default.cloneElement(control, controlProps), _react.default.createElement(_Typography.default, {
    component: "span",
    className: (0, _classnames.default)(classes.label, (0, _defineProperty2.default)({}, classes.disabled, disabled))
  }, label));
}

FormControlLabel.propTypes =  false ? {
  /**
   * If `true`, the component appears selected.
   */
  checked: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * A control element. For instance, it can be be a `Radio`, a `Switch` or a `Checkbox`.
   */
  control: _propTypes.default.element,

  /**
   * If `true`, the control will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * The text to be used in an enclosing label element.
   */
  label: _propTypes.default.node,

  /**
   * The position of the label.
   */
  labelPlacement: _propTypes.default.oneOf(['end', 'start']),

  /*
   * @ignore
   */
  name: _propTypes.default.string,

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.checked`.
   * @param {boolean} checked The `checked` value of the switch
   */
  onChange: _propTypes.default.func,

  /**
   * The value of the component.
   */
  value: _propTypes.default.string
} : {};
FormControlLabel.defaultProps = {
  labelPlacement: 'end'
};
FormControlLabel.contextTypes = {
  muiFormControl: _propTypes.default.object
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiFormControlLabel'
})(FormControlLabel);

exports.default = _default;

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap'
  },

  /* Styles applied to the root element if `row={true}`. */
  row: {
    flexDirection: 'row'
  }
};
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */

exports.styles = styles;

function FormGroup(props) {
  var classes = props.classes,
      className = props.className,
      children = props.children,
      row = props.row,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "children", "row"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.row, row), className)
  }, other), children);
}

FormGroup.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Display group of elements in a compact row.
   */
  row: _propTypes.default.bool
} : {};
FormGroup.defaultProps = {
  row: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiFormGroup'
})(FormGroup);

exports.default = _default;

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _GridList.default;
  }
});

var _GridList = _interopRequireDefault(__webpack_require__(1018));

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _warning = _interopRequireDefault(__webpack_require__(37));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    overflowY: 'auto',
    listStyle: 'none',
    padding: 0,
    WebkitOverflowScrolling: 'touch' // Add iOS momentum scrolling.

  }
};
exports.styles = styles;

function GridList(props) {
  var cellHeight = props.cellHeight,
      children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      cols = props.cols,
      Component = props.component,
      spacing = props.spacing,
      style = props.style,
      other = (0, _objectWithoutProperties2.default)(props, ["cellHeight", "children", "classes", "className", "cols", "component", "spacing", "style"]);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, classNameProp),
    style: (0, _extends2.default)({
      margin: -spacing / 2
    }, style)
  }, other), _react.default.Children.map(children, function (child) {
    if (!_react.default.isValidElement(child)) {
      return null;
    }

     false ? (0, _warning.default)(child.type !== _react.default.Fragment, ["Material-UI: the GridList component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n')) : void 0;
    var childCols = child.props.cols || 1;
    var childRows = child.props.rows || 1;
    return _react.default.cloneElement(child, {
      style: (0, _extends2.default)({
        width: "".concat(100 / cols * childCols, "%"),
        height: cellHeight === 'auto' ? 'auto' : cellHeight * childRows + spacing,
        padding: spacing / 2
      }, child.props.style)
    });
  }));
}

GridList.propTypes =  false ? {
  /**
   * Number of px for one cell height.
   * You can set `'auto'` if you want to let the children determine the height.
   */
  cellHeight: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['auto'])]),

  /**
   * Grid Tiles that will be in Grid List.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Number of columns.
   */
  cols: _propTypes.default.number,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Number of px for the spacing between tiles.
   */
  spacing: _propTypes.default.number,

  /**
   * @ignore
   */
  style: _propTypes.default.object
} : {};
GridList.defaultProps = {
  cellHeight: 180,
  cols: 2,
  component: 'ul',
  spacing: 4
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiGridList'
})(GridList);

exports.default = _default;

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _GridListTile.default;
  }
});

var _GridListTile = _interopRequireDefault(__webpack_require__(1020));

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(222));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _reactEventListener = _interopRequireDefault(__webpack_require__(93));

var _debounce = _interopRequireDefault(__webpack_require__(118));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

// < 1kb payload overhead when lodash/debounce is > 3kb.
var styles = {
  /* Styles applied to the root element. */
  root: {
    boxSizing: 'border-box',
    flexShrink: 0
  },

  /* Styles applied to the `div` element that wraps the children. */
  tile: {
    position: 'relative',
    display: 'block',
    // In case it's not rendered with a div.
    height: '100%',
    overflow: 'hidden'
  },

  /* Styles applied to an `ing` element child, if if needed to ensure it covers the tile. */
  imgFullHeight: {
    height: '100%',
    transform: 'translateX(-50%)',
    position: 'relative',
    left: '50%'
  },

  /* Styles applied to an `ing` element child, if if needed to ensure it covers the tile. */
  imgFullWidth: {
    width: '100%',
    position: 'relative',
    transform: 'translateY(-50%)',
    top: '50%'
  }
};
exports.styles = styles;

var GridListTile =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(GridListTile, _React$Component);

  function GridListTile() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, GridListTile);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(GridListTile)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.imgElement = null;
    _this.handleResize = (0, _debounce.default)(function () {
      _this.fit();
    }, 166);

    _this.fit = function () {
      var imgElement = _this.imgElement;

      if (!imgElement || !imgElement.complete) {
        return;
      }

      if (imgElement.width / imgElement.height > imgElement.parentNode.offsetWidth / imgElement.parentNode.offsetHeight) {
        var _imgElement$classList, _imgElement$classList2;

        (_imgElement$classList = imgElement.classList).remove.apply(_imgElement$classList, (0, _toConsumableArray2.default)(_this.props.classes.imgFullWidth.split(' ')));

        (_imgElement$classList2 = imgElement.classList).add.apply(_imgElement$classList2, (0, _toConsumableArray2.default)(_this.props.classes.imgFullHeight.split(' ')));
      } else {
        var _imgElement$classList3, _imgElement$classList4;

        (_imgElement$classList3 = imgElement.classList).remove.apply(_imgElement$classList3, (0, _toConsumableArray2.default)(_this.props.classes.imgFullHeight.split(' ')));

        (_imgElement$classList4 = imgElement.classList).add.apply(_imgElement$classList4, (0, _toConsumableArray2.default)(_this.props.classes.imgFullWidth.split(' ')));
      }

      imgElement.removeEventListener('load', _this.fit);
    };

    return _this;
  }

  (0, _createClass2.default)(GridListTile, [{
    key: "componentDidMount",
    // Corresponds to 10 frames at 60 Hz.
    value: function componentDidMount() {
      this.ensureImageCover();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.ensureImageCover();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handleResize.clear();
    }
  }, {
    key: "ensureImageCover",
    value: function ensureImageCover() {
      if (!this.imgElement) {
        return;
      }

      if (this.imgElement.complete) {
        this.fit();
      } else {
        this.imgElement.addEventListener('load', this.fit);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          classes = _this$props.classes,
          className = _this$props.className,
          cols = _this$props.cols,
          Component = _this$props.component,
          rows = _this$props.rows,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["children", "classes", "className", "cols", "component", "rows"]);
      return _react.default.createElement(Component, (0, _extends2.default)({
        className: (0, _classnames.default)(classes.root, className)
      }, other), _react.default.createElement(_reactEventListener.default, {
        target: "window",
        onResize: this.handleResize
      }), _react.default.createElement("div", {
        className: classes.tile
      }, _react.default.Children.map(children, function (child) {
        if (!_react.default.isValidElement(child)) {
          return null;
        }

        if (child.type === 'img') {
          return _react.default.cloneElement(child, {
            ref: function ref(node) {
              _this2.imgElement = node;
            }
          });
        }

        return child;
      })));
    }
  }]);
  return GridListTile;
}(_react.default.Component);

GridListTile.propTypes =  false ? {
  /**
   * Theoretically you can pass any node as children, but the main use case is to pass an img,
   * in which case GridListTile takes care of making the image "cover" available space
   * (similar to `background-size: cover` or to `object-fit: cover`).
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Width of the tile in number of grid cells.
   */
  cols: _propTypes.default.number,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Height of the tile in number of grid cells.
   */
  rows: _propTypes.default.number
} : {};
GridListTile.defaultProps = {
  cols: 1,
  component: 'li',
  rows: 1
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiGridListTile'
})(GridListTile);

exports.default = _default;

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _GridListTileBar.default;
  }
});

var _GridListTileBar = _interopRequireDefault(__webpack_require__(1022));

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'absolute',
      left: 0,
      right: 0,
      height: 48,
      background: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      fontFamily: theme.typography.fontFamily
    },

    /* Styles applied to the root element if `titlePosition="bottom"`. */
    titlePositionBottom: {
      bottom: 0
    },

    /* Styles applied to the root element if `titlePosition="top"`. */
    titlePositionTop: {
      top: 0
    },

    /* Styles applied to the root element if a `subtitle` is provided. */
    rootSubtitle: {
      height: 68
    },

    /* Styles applied to the title and subtitle container element. */
    titleWrap: {
      flexGrow: 1,
      marginLeft: theme.mixins.gutters().paddingLeft,
      marginRight: theme.mixins.gutters().paddingRight,
      color: theme.palette.common.white,
      overflow: 'hidden'
    },

    /* Styles applied to the container element if `actionPosition="left"`. */
    titleWrapActionPosLeft: {
      marginLeft: 0
    },

    /* Styles applied to the container element if `actionPosition="right"`. */
    titleWrapActionPosRight: {
      marginRight: 0
    },

    /* Styles applied to the title container element. */
    title: {
      fontSize: theme.typography.pxToRem(16),
      lineHeight: '24px',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the subtitle container element. */
    subtitle: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: 1,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the actionIcon if supplied. */
    actionIcon: {},

    /* Styles applied to the actionIcon if `actionPosition="left". */
    actionIconActionPosLeft: {
      order: -1
    }
  };
};

exports.styles = styles;

function GridListTileBar(props) {
  var _classNames, _classNames2;

  var actionIcon = props.actionIcon,
      actionPosition = props.actionPosition,
      classes = props.classes,
      classNameProp = props.className,
      subtitle = props.subtitle,
      title = props.title,
      titlePosition = props.titlePosition,
      other = (0, _objectWithoutProperties2.default)(props, ["actionIcon", "actionPosition", "classes", "className", "subtitle", "title", "titlePosition"]);
  var actionPos = actionIcon && actionPosition;
  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.titlePositionBottom, titlePosition === 'bottom'), (0, _defineProperty2.default)(_classNames, classes.titlePositionTop, titlePosition === 'top'), (0, _defineProperty2.default)(_classNames, classes.rootSubtitle, subtitle), _classNames), classNameProp); // Remove the margin between the title / subtitle wrapper, and the Action Icon

  var titleWrapClassName = (0, _classnames.default)(classes.titleWrap, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.titleWrapActionPosLeft, actionPos === 'left'), (0, _defineProperty2.default)(_classNames2, classes.titleWrapActionPosRight, actionPos === 'right'), _classNames2));
  return _react.default.createElement("div", (0, _extends2.default)({
    className: className
  }, other), _react.default.createElement("div", {
    className: titleWrapClassName
  }, _react.default.createElement("div", {
    className: classes.title
  }, title), subtitle ? _react.default.createElement("div", {
    className: classes.subtitle
  }, subtitle) : null), actionIcon ? _react.default.createElement("div", {
    className: (0, _classnames.default)(classes.actionIcon, (0, _defineProperty2.default)({}, classes.actionIconActionPosLeft, actionPos === 'left'))
  }, actionIcon) : null);
}

GridListTileBar.propTypes =  false ? {
  /**
   * An IconButton element to be used as secondary action target
   * (primary action target is the tile itself).
   */
  actionIcon: _propTypes.default.node,

  /**
   * Position of secondary action IconButton.
   */
  actionPosition: _propTypes.default.oneOf(['left', 'right']),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * String or element serving as subtitle (support text).
   */
  subtitle: _propTypes.default.node,

  /**
   * Title to be displayed on tile.
   */
  title: _propTypes.default.node,

  /**
   * Position of the title bar.
   */
  titlePosition: _propTypes.default.oneOf(['top', 'bottom'])
} : {};
GridListTileBar.defaultProps = {
  actionPosition: 'right',
  titlePosition: 'bottom'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiGridListTileBar'
})(GridListTileBar);

exports.default = _default;

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _HiddenJs = _interopRequireDefault(__webpack_require__(1024));

var _HiddenCss = _interopRequireDefault(__webpack_require__(1026));

/**
 * Responsively hides children based on the selected implementation.
 */
function Hidden(props) {
  var implementation = props.implementation,
      other = (0, _objectWithoutProperties2.default)(props, ["implementation"]);

  if (implementation === 'js') {
    return _react.default.createElement(_HiddenJs.default, other);
  }

  return _react.default.createElement(_HiddenCss.default, other);
}

Hidden.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for server
   * side rendering.
   */
  implementation: _propTypes.default.oneOf(['js', 'css']),

  /**
   * You can use this property when choosing the `js` implementation with server side rendering.
   *
   * As `window.innerWidth` is unavailable on the server,
   * we default to rendering an empty componenent during the first mount.
   * In some situation you might want to use an heristic to approximate
   * the screen width of the client browser screen width.
   *
   * For instance, you could be using the user-agent or the client-hints.
   * http://caniuse.com/#search=client%20hint
   */
  initialWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),

  /**
   * If true, screens this size and down will be hidden.
   */
  lgDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  lgUp: _propTypes.default.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  mdDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  mdUp: _propTypes.default.bool,

  /**
   * Hide the given breakpoint(s).
   */
  only: _propTypes.default.oneOfType([_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes.default.arrayOf(_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),

  /**
   * If true, screens this size and down will be hidden.
   */
  smDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  smUp: _propTypes.default.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  xlDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  xlUp: _propTypes.default.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  xsDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  xsUp: _propTypes.default.bool
} : {};
Hidden.defaultProps = {
  implementation: 'js',
  lgDown: false,
  lgUp: false,
  mdDown: false,
  mdUp: false,
  smDown: false,
  smUp: false,
  xlDown: false,
  xlUp: false,
  xsDown: false,
  xsUp: false
};
var _default = Hidden;
exports.default = _default;

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(144);

var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _createBreakpoints = __webpack_require__(173);

var _withWidth = _interopRequireWildcard(__webpack_require__(238));

var _exactProp = _interopRequireDefault(__webpack_require__(115));

/**
 * @ignore - internal component.
 */
function HiddenJs(props) {
  var children = props.children,
      only = props.only,
      width = props.width;
  var visible = true; // `only` check is faster to get out sooner if used.

  if (only) {
    if (Array.isArray(only)) {
      for (var i = 0; i < only.length; i += 1) {
        var breakpoint = only[i];

        if (width === breakpoint) {
          visible = false;
          break;
        }
      }
    } else if (only && width === only) {
      visible = false;
    }
  } // Allow `only` to be combined with other props. If already hidden, no need to check others.


  if (visible) {
    // determine visibility based on the smallest size up
    for (var _i = 0; _i < _createBreakpoints.keys.length; _i += 1) {
      var _breakpoint = _createBreakpoints.keys[_i];
      var breakpointUp = props["".concat(_breakpoint, "Up")];
      var breakpointDown = props["".concat(_breakpoint, "Down")];

      if (breakpointUp && (0, _withWidth.isWidthUp)(_breakpoint, width) || breakpointDown && (0, _withWidth.isWidthDown)(_breakpoint, width)) {
        visible = false;
        break;
      }
    }
  }

  if (!visible) {
    return null;
  }

  return children;
}

HiddenJs.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for server
   * side rendering.
   */
  implementation: _propTypes.default.oneOf(['js', 'css']),

  /**
   * You can use this property when choosing the `js` implementation with server side rendering.
   *
   * As `window.innerWidth` is unavailable on the server,
   * we default to rendering an empty componenent during the first mount.
   * In some situation you might want to use an heristic to approximate
   * the screen width of the client browser screen width.
   *
   * For instance, you could be using the user-agent or the client-hints.
   * http://caniuse.com/#search=client%20hint
   */
  initialWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),

  /**
   * If true, screens this size and down will be hidden.
   */
  lgDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  lgUp: _propTypes.default.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  mdDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  mdUp: _propTypes.default.bool,

  /**
   * Hide the given breakpoint(s).
   */
  only: _propTypes.default.oneOfType([_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes.default.arrayOf(_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),

  /**
   * If true, screens this size and down will be hidden.
   */
  smDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  smUp: _propTypes.default.bool,

  /**
   * @ignore
   * width prop provided by withWidth decorator.
   */
  width: _propTypes.default.string.isRequired,

  /**
   * If true, screens this size and down will be hidden.
   */
  xlDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  xlUp: _propTypes.default.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  xsDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  xsUp: _propTypes.default.bool
};
HiddenJs.propTypes = (0, _exactProp.default)(HiddenJs.propTypes);

var _default = (0, _withWidth.default)()(HiddenJs);

exports.default = _default;

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.isWidthDown = exports.isWidthUp = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _reactEventListener = _interopRequireDefault(__webpack_require__(93));

var _debounce = _interopRequireDefault(__webpack_require__(118));

var _wrapDisplayName = _interopRequireDefault(__webpack_require__(175));

var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(94));

var _withTheme = _interopRequireDefault(__webpack_require__(90));

var _createBreakpoints = __webpack_require__(173);

var _getThemeProps = _interopRequireDefault(__webpack_require__(450));

/* eslint-disable react/no-did-mount-set-state */
// < 1kb payload overhead when lodash/debounce is > 3kb.
// By default, returns true if screen width is the same or greater than the given breakpoint.
var isWidthUp = function isWidthUp(breakpoint, width) {
  var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (inclusive) {
    return _createBreakpoints.keys.indexOf(breakpoint) <= _createBreakpoints.keys.indexOf(width);
  }

  return _createBreakpoints.keys.indexOf(breakpoint) < _createBreakpoints.keys.indexOf(width);
}; // By default, returns true if screen width is the same or less than the given breakpoint.


exports.isWidthUp = isWidthUp;

var isWidthDown = function isWidthDown(breakpoint, width) {
  var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (inclusive) {
    return _createBreakpoints.keys.indexOf(width) <= _createBreakpoints.keys.indexOf(breakpoint);
  }

  return _createBreakpoints.keys.indexOf(width) < _createBreakpoints.keys.indexOf(breakpoint);
};

exports.isWidthDown = isWidthDown;

var withWidth = function withWidth() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (Component) {
    var _options$withTheme = options.withTheme,
        withThemeOption = _options$withTheme === void 0 ? false : _options$withTheme,
        _options$noSSR = options.noSSR,
        noSSR = _options$noSSR === void 0 ? false : _options$noSSR,
        initialWidthOption = options.initialWidth,
        _options$resizeInterv = options.resizeInterval,
        resizeInterval = _options$resizeInterv === void 0 ? 166 : _options$resizeInterv;

    var WithWidth =
    /*#__PURE__*/
    function (_React$Component) {
      (0, _inherits2.default)(WithWidth, _React$Component);

      function WithWidth(props) {
        var _this;

        (0, _classCallCheck2.default)(this, WithWidth);
        _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(WithWidth).call(this, props));
        _this.handleResize = (0, _debounce.default)(function () {
          var width = _this.getWidth();

          if (width !== _this.state.width) {
            _this.setState({
              width: width
            });
          }
        }, resizeInterval);
        _this.state = {
          width: undefined
        };

        if (noSSR) {
          _this.state.width = _this.getWidth();
        }

        return _this;
      }

      (0, _createClass2.default)(WithWidth, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var width = this.getWidth();

          if (width !== this.state.width) {
            this.setState({
              width: width
            });
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.handleResize.clear();
        }
      }, {
        key: "getWidth",
        value: function getWidth() {
          var innerWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.innerWidth;
          var breakpoints = this.props.theme.breakpoints;
          var width = null;
          /**
           * Start with the slowest value as low end devices often have a small screen.
           *
           * innerWidth |xs      sm      md      lg      xl
           *            |-------|-------|-------|-------|------>
           * width      |  xs   |  sm   |  md   |  lg   |  xl
           */

          var index = 1;

          while (width === null && index < _createBreakpoints.keys.length) {
            var currentWidth = _createBreakpoints.keys[index]; // @media are inclusive, so reproduce the behavior here.

            if (innerWidth < breakpoints.values[currentWidth]) {
              width = _createBreakpoints.keys[index - 1];
              break;
            }

            index += 1;
          }

          width = width || 'xl';
          return width;
        }
      }, {
        key: "render",
        value: function render() {
          var _this$props = this.props,
              initialWidth = _this$props.initialWidth,
              theme = _this$props.theme,
              width = _this$props.width,
              other = (0, _objectWithoutProperties2.default)(_this$props, ["initialWidth", "theme", "width"]);
          var props = (0, _extends2.default)({
            width: width || this.state.width || initialWidth || initialWidthOption || (0, _getThemeProps.default)({
              theme: theme,
              name: 'MuiWithWidth'
            }).initialWidth
          }, other);
          var more = {};

          if (withThemeOption) {
            more.theme = theme;
          } // When rendering the component on the server,
          // we have no idea about the client browser screen width.
          // In order to prevent blinks and help the reconciliation of the React tree
          // we are not rendering the child component.
          //
          // An alternative is to use the `initialWidth` property.


          if (props.width === undefined) {
            return null;
          }

          return _react.default.createElement(_reactEventListener.default, {
            target: "window",
            onResize: this.handleResize
          }, _react.default.createElement(Component, (0, _extends2.default)({}, more, props)));
        }
      }]);
      return WithWidth;
    }(_react.default.Component);

    WithWidth.propTypes =  false ? {
      /**
       * As `window.innerWidth` is unavailable on the server,
       * we default to rendering an empty component during the first mount.
       * In some situation, you might want to use an heuristic to approximate
       * the screen width of the client browser screen width.
       *
       * For instance, you could be using the user-agent or the client-hints.
       * http://caniuse.com/#search=client%20hint
       */
      initialWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),

      /**
       * @ignore
       */
      theme: _propTypes.default.object.isRequired,

      /**
       * Bypass the width calculation logic.
       */
      width: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])
    } : {};

    if (false) {
      WithWidth.displayName = (0, _wrapDisplayName.default)(Component, 'WithWidth');
    }

    (0, _hoistNonReactStatics.default)(WithWidth, Component);
    return (0, _withTheme.default)()(WithWidth);
  };
};

var _default = withWidth;
exports.default = _default;

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _warning = _interopRequireDefault(__webpack_require__(37));

var _createBreakpoints = __webpack_require__(173);

var _helpers = __webpack_require__(51);

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var styles = function styles(theme) {
  var hidden = {
    display: 'none'
  };
  return _createBreakpoints.keys.reduce(function (acc, key) {
    acc["only".concat((0, _helpers.capitalize)(key))] = (0, _defineProperty2.default)({}, theme.breakpoints.only(key), hidden);
    acc["".concat(key, "Up")] = (0, _defineProperty2.default)({}, theme.breakpoints.up(key), hidden);
    acc["".concat(key, "Down")] = (0, _defineProperty2.default)({}, theme.breakpoints.down(key), hidden);
    return acc;
  }, {});
};
/**
 * @ignore - internal component.
 */


function HiddenCss(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      lgDown = props.lgDown,
      lgUp = props.lgUp,
      mdDown = props.mdDown,
      mdUp = props.mdUp,
      only = props.only,
      smDown = props.smDown,
      smUp = props.smUp,
      xlDown = props.xlDown,
      xlUp = props.xlUp,
      xsDown = props.xsDown,
      xsUp = props.xsUp,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "lgDown", "lgUp", "mdDown", "mdUp", "only", "smDown", "smUp", "xlDown", "xlUp", "xsDown", "xsUp"]);
   false ? (0, _warning.default)(Object.keys(other).length === 0 || Object.keys(other).length === 1 && other.hasOwnProperty('ref'), "Material-UI: unsupported properties received ".concat(Object.keys(other).join(', '), " by `<Hidden />`.")) : void 0;
  var classNames = [];

  if (className) {
    classNames.push(className);
  }

  for (var i = 0; i < _createBreakpoints.keys.length; i += 1) {
    var breakpoint = _createBreakpoints.keys[i];
    var breakpointUp = props["".concat(breakpoint, "Up")];
    var breakpointDown = props["".concat(breakpoint, "Down")];

    if (breakpointUp) {
      classNames.push(classes["".concat(breakpoint, "Up")]);
    }

    if (breakpointDown) {
      classNames.push(classes["".concat(breakpoint, "Down")]);
    }
  }

  if (only) {
    var onlyBreakpoints = Array.isArray(only) ? only : [only];
    onlyBreakpoints.forEach(function (breakpoint) {
      classNames.push(classes["only".concat((0, _helpers.capitalize)(breakpoint))]);
    });
  }

  return _react.default.createElement("div", {
    className: classNames.join(' ')
  }, children);
}

HiddenCss.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for server
   * side rendering.
   */
  implementation: _propTypes.default.oneOf(['js', 'css']),

  /**
   * If true, screens this size and down will be hidden.
   */
  lgDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  lgUp: _propTypes.default.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  mdDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  mdUp: _propTypes.default.bool,

  /**
   * Hide the given breakpoint(s).
   */
  only: _propTypes.default.oneOfType([_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes.default.arrayOf(_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),

  /**
   * If true, screens this size and down will be hidden.
   */
  smDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  smUp: _propTypes.default.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  xlDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  xlUp: _propTypes.default.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  xsDown: _propTypes.default.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  xsUp: _propTypes.default.bool
} : {};

var _default = (0, _withStyles.default)(styles)(HiddenCss);

exports.default = _default;

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _warning = _interopRequireDefault(__webpack_require__(37));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _colorManipulator = __webpack_require__(80);

var TRANSITION_DURATION = 4; // seconds

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      overflow: 'hidden',
      height: 5
    },

    /* Styles applied to the root & bar2 element if `color="primary"`; bar2 if `variant-"buffer"`. */
    colorPrimary: {
      backgroundColor: (0, _colorManipulator.lighten)(theme.palette.primary.light, 0.6)
    },
    // eslint-disable-next-line max-len

    /* Styles applied to the root & bar2 elements if `color="secondary"`; bar2 if `variant="buffer"`. */
    colorSecondary: {
      backgroundColor: (0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.4)
    },

    /* Styles applied to the root element if `variant="buffer"`. */
    buffer: {
      backgroundColor: 'transparent'
    },

    /* Styles applied to the root element if `variant="query"`. */
    query: {
      transform: 'rotate(180deg)'
    },

    /* Styles applied to the additional bar element if `variant="buffer"`. */
    dashed: {
      position: 'absolute',
      marginTop: 0,
      height: '100%',
      width: '100%',
      animation: 'buffer 3s infinite linear'
    },

    /* Styles applied to the additional bar element if `variant="buffer"` & `color="primary"`. */
    dashedColorPrimary: {
      backgroundImage: "radial-gradient(".concat((0, _colorManipulator.lighten)(theme.palette.primary.light, 0.6), " 0%, ").concat((0, _colorManipulator.lighten)(theme.palette.primary.light, 0.6), " 16%, transparent 42%)"),
      backgroundSize: '10px 10px',
      backgroundPosition: '0px -23px'
    },

    /* Styles applied to the additional bar element if `variant="buffer"` & `color="secondary"`. */
    dashedColorSecondary: {
      backgroundImage: "radial-gradient(".concat((0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.4), " 0%, ").concat((0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.6), " 16%, transparent 42%)"),
      backgroundSize: '10px 10px',
      backgroundPosition: '0px -23px'
    },

    /* Styles applied to the layered bar1 & bar2 elements. */
    bar: {
      width: '100%',
      position: 'absolute',
      left: 0,
      bottom: 0,
      top: 0,
      transition: 'transform 0.2s linear',
      transformOrigin: 'left'
    },

    /* Styles applied to the bar elements if `color="primary"`; bar2 if `variant` not "buffer". */
    barColorPrimary: {
      backgroundColor: theme.palette.primary.main
    },

    /* Styles applied to the bar elements if `color="secondary"`; bar2 if `variant` not "buffer". */
    barColorSecondary: {
      backgroundColor: theme.palette.secondary.main
    },

    /* Styles applied to the bar1 element if `variant="indeterminate or query"`. */
    bar1Indeterminate: {
      width: 'auto',
      willChange: 'left, right',
      animation: 'mui-indeterminate1 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite'
    },

    /* Styles applied to the bar1 element if `variant="determinate"`. */
    bar1Determinate: {
      willChange: 'transform',
      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
    },

    /* Styles applied to the bar1 element if `variant="buffer"`. */
    bar1Buffer: {
      zIndex: 1,
      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
    },

    /* Styles applied to the bar2 element if `variant="indeterminate or query"`. */
    bar2Indeterminate: {
      width: 'auto',
      willChange: 'left, right',
      animation: 'mui-indeterminate2 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite',
      animationDelay: '1.15s'
    },

    /* Styles applied to the bar2 element if `variant="determinate"`. */
    bar2Determinate: {},

    /* Styles applied to the bar2 element if `variant="buffer"`. */
    bar2Buffer: {
      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
    },
    // Legends:
    // || represents the viewport
    // -  represents a light background
    // x  represents a dark background
    '@keyframes mui-indeterminate1': {
      //  |-----|---x-||-----||-----|
      '0%': {
        left: '-35%',
        right: '100%'
      },
      //  |-----|-----||-----||xxxx-|
      '60%': {
        left: '100%',
        right: '-90%'
      },
      '100%': {
        left: '100%',
        right: '-90%'
      }
    },
    '@keyframes mui-indeterminate2': {
      //  |xxxxx|xxxxx||-----||-----|
      '0%': {
        left: '-200%',
        right: '100%'
      },
      //  |-----|-----||-----||-x----|
      '60%': {
        left: '107%',
        right: '-8%'
      },
      '100%': {
        left: '107%',
        right: '-8%'
      }
    },
    '@keyframes buffer': {
      '0%': {
        opacity: 1,
        backgroundPosition: '0px -23px'
      },
      '50%': {
        opacity: 0,
        backgroundPosition: '0px -23px'
      },
      '100%': {
        opacity: 1,
        backgroundPosition: '-200px -23px'
      }
    }
  };
};
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */


exports.styles = styles;

function LinearProgress(props) {
  var _classNames, _classNames2, _classNames3, _classNames4;

  var classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      value = props.value,
      valueBuffer = props.valueBuffer,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "value", "valueBuffer", "variant"]);
  var className = (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.colorPrimary, color === 'primary'), (0, _defineProperty2.default)(_classNames, classes.colorSecondary, color === 'secondary'), (0, _defineProperty2.default)(_classNames, classes.buffer, variant === 'buffer'), (0, _defineProperty2.default)(_classNames, classes.query, variant === 'query'), _classNames), classNameProp);
  var dashedClass = (0, _classnames.default)(classes.dashed, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.dashedColorPrimary, color === 'primary'), (0, _defineProperty2.default)(_classNames2, classes.dashedColorSecondary, color === 'secondary'), _classNames2));
  var bar1ClassName = (0, _classnames.default)(classes.bar, (_classNames3 = {}, (0, _defineProperty2.default)(_classNames3, classes.barColorPrimary, color === 'primary'), (0, _defineProperty2.default)(_classNames3, classes.barColorSecondary, color === 'secondary'), (0, _defineProperty2.default)(_classNames3, classes.bar1Indeterminate, variant === 'indeterminate' || variant === 'query'), (0, _defineProperty2.default)(_classNames3, classes.bar1Determinate, variant === 'determinate'), (0, _defineProperty2.default)(_classNames3, classes.bar1Buffer, variant === 'buffer'), _classNames3));
  var bar2ClassName = (0, _classnames.default)(classes.bar, (_classNames4 = {}, (0, _defineProperty2.default)(_classNames4, classes.barColorPrimary, color === 'primary' && variant !== 'buffer'), (0, _defineProperty2.default)(_classNames4, classes.colorPrimary, color === 'primary' && variant === 'buffer'), (0, _defineProperty2.default)(_classNames4, classes.barColorSecondary, color === 'secondary' && variant !== 'buffer'), (0, _defineProperty2.default)(_classNames4, classes.colorSecondary, color === 'secondary' && variant === 'buffer'), (0, _defineProperty2.default)(_classNames4, classes.bar2Indeterminate, variant === 'indeterminate' || variant === 'query'), (0, _defineProperty2.default)(_classNames4, classes.bar2Determinate, variant === 'determinate'), (0, _defineProperty2.default)(_classNames4, classes.bar2Buffer, variant === 'buffer'), _classNames4));
  var rootProps = {};
  var inlineStyles = {
    bar1: {},
    bar2: {}
  };

  if (variant === 'determinate' || variant === 'buffer') {
    if (value !== undefined) {
      rootProps['aria-valuenow'] = Math.round(value);
      inlineStyles.bar1.transform = "scaleX(".concat(value / 100, ")");
    } else {
       false ? (0, _warning.default)(false, 'Material-UI: you need to provide a value property ' + 'when using the determinate or buffer variant of LinearProgress .') : void 0;
    }
  }

  if (variant === 'buffer') {
    if (valueBuffer !== undefined) {
      inlineStyles.bar2.transform = "scaleX(".concat((valueBuffer || 0) / 100, ")");
    } else {
       false ? (0, _warning.default)(false, 'Material-UI: you need to provide a valueBuffer property ' + 'when using the buffer variant of LinearProgress.') : void 0;
    }
  }

  return _react.default.createElement("div", (0, _extends2.default)({
    className: className,
    role: "progressbar"
  }, rootProps, other), variant === 'buffer' ? _react.default.createElement("div", {
    className: dashedClass
  }) : null, _react.default.createElement("div", {
    className: bar1ClassName,
    style: inlineStyles.bar1
  }), variant === 'determinate' ? null : _react.default.createElement("div", {
    className: bar2ClassName,
    style: inlineStyles.bar2
  }));
}

LinearProgress.propTypes =  false ? {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['primary', 'secondary']),

  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: _propTypes.default.number,

  /**
   * The value for the buffer variant.
   * Value between 0 and 100.
   */
  valueBuffer: _propTypes.default.number,

  /**
   * The variant to use.
   * Use indeterminate or query when there is no progress value.
   */
  variant: _propTypes.default.oneOf(['determinate', 'indeterminate', 'buffer', 'query'])
} : {};
LinearProgress.defaultProps = {
  color: 'primary',
  variant: 'indeterminate'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiLinearProgress'
})(LinearProgress);

exports.default = _default;

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ListItemAvatar.default;
  }
});

var _ListItemAvatar = _interopRequireDefault(__webpack_require__(1029));

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _warning = _interopRequireDefault(__webpack_require__(37));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      width: 36,
      height: 36,
      fontSize: theme.typography.pxToRem(18),
      marginRight: 4
    },

    /* Styles applied to the children – typically the `Avatar` component. */
    icon: {
      width: 20,
      height: 20,
      fontSize: theme.typography.pxToRem(20)
    }
  };
};
/**
 * This is a simple wrapper to apply the `dense` mode styles to `Avatar`.
 */


exports.styles = styles;

function ListItemAvatar(props, context) {
  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className"]);

  if (context.dense === undefined) {
     false ? (0, _warning.default)(false, "Material-UI: <ListItemAvatar> is a simple wrapper to apply the dense styles\n      to <Avatar>. You do not need it unless you are controlling the <List> dense property.") : void 0;
    return props.children;
  }

  return _react.default.cloneElement(children, (0, _extends2.default)({
    className: (0, _classnames.default)((0, _defineProperty2.default)({}, classes.root, context.dense), classNameProp, children.props.className),
    childrenClassName: (0, _classnames.default)((0, _defineProperty2.default)({}, classes.icon, context.dense), children.props.childrenClassName)
  }, other));
}

ListItemAvatar.propTypes =  false ? {
  /**
   * The content of the component – normally `Avatar`.
   */
  children: _propTypes.default.element.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string
} : {};
ListItemAvatar.contextTypes = {
  dense: _propTypes.default.bool
};
ListItemAvatar.muiName = 'ListItemAvatar';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiListItemAvatar'
})(ListItemAvatar);

exports.default = _default;

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      marginRight: 16,
      color: theme.palette.action.active,
      flexShrink: 0
    }
  };
};
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */


exports.styles = styles;

function ListItemIcon(props) {
  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className"]);
  return _react.default.cloneElement(children, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, classNameProp, children.props.className)
  }, other));
}

ListItemIcon.propTypes =  false ? {
  /**
   * The content of the component, normally `Icon`, `SvgIcon`,
   * or a `@material-ui/icons` SVG icon element.
   */
  children: _propTypes.default.element.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string
} : {};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiListItemIcon'
})(ListItemIcon);

exports.default = _default;

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ListItemSecondaryAction.default;
  }
});

var _ListItemSecondaryAction = _interopRequireDefault(__webpack_require__(1032));

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var styles = {
  /* Styles applied to the root element. */
  root: {
    position: 'absolute',
    right: 4,
    top: '50%',
    transform: 'translateY(-50%)'
  }
};
exports.styles = styles;

function ListItemSecondaryAction(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, other), children);
}

ListItemSecondaryAction.propTypes =  false ? {
  /**
   * The content of the component, normally an `IconButton` or selection control.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string
} : {};
ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiListItemSecondaryAction'
})(ListItemSecondaryAction);

exports.default = _default;

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _Typography = _interopRequireDefault(__webpack_require__(13));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      flex: '1 1 auto',
      minWidth: 0,
      padding: '0 16px',
      '&:first-child': {
        paddingLeft: 0
      }
    },

    /* Styles applied to the root element if `inset={true}`. */
    inset: {
      '&:first-child': {
        paddingLeft: 56
      }
    },

    /* Styles applied to the root element if `context.dense` is `true`. */
    dense: {
      fontSize: theme.typography.pxToRem(13)
    },

    /* Styles applied to the primary `Typography` component. */
    primary: {
      '&$textDense': {
        fontSize: 'inherit'
      }
    },

    /* Styles applied to the secondary `Typography` component. */
    secondary: {
      '&$textDense': {
        fontSize: 'inherit'
      }
    },

    /* Styles applied to the `Typography` components if `context.dense` is `true`. */
    textDense: {}
  };
};

exports.styles = styles;

function ListItemText(props, context) {
  var _classNames3;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      disableTypography = props.disableTypography,
      inset = props.inset,
      primaryProp = props.primary,
      primaryTypographyProps = props.primaryTypographyProps,
      secondaryProp = props.secondary,
      secondaryTypographyProps = props.secondaryTypographyProps,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disableTypography", "inset", "primary", "primaryTypographyProps", "secondary", "secondaryTypographyProps"]);
  var dense = context.dense;
  var primary = primaryProp != null ? primaryProp : children;

  if (primary != null && primary.type !== _Typography.default && !disableTypography) {
    primary = _react.default.createElement(_Typography.default, (0, _extends2.default)({
      variant: "subheading",
      className: (0, _classnames.default)(classes.primary, (0, _defineProperty2.default)({}, classes.textDense, dense)),
      component: "span"
    }, primaryTypographyProps), primary);
  }

  var secondary = secondaryProp;

  if (secondary != null && secondary.type !== _Typography.default && !disableTypography) {
    secondary = _react.default.createElement(_Typography.default, (0, _extends2.default)({
      variant: "body1",
      className: (0, _classnames.default)(classes.secondary, (0, _defineProperty2.default)({}, classes.textDense, dense)),
      color: "textSecondary"
    }, secondaryTypographyProps), secondary);
  }

  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (_classNames3 = {}, (0, _defineProperty2.default)(_classNames3, classes.dense, dense), (0, _defineProperty2.default)(_classNames3, classes.inset, inset), _classNames3), classNameProp)
  }, other), primary, secondary);
}

ListItemText.propTypes =  false ? {
  /**
   * Alias for the `primary` property.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * If `true`, the children won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `children` (or `primary`) text, and optional `secondary` text
   * with the Typography component.
   */
  disableTypography: _propTypes.default.bool,

  /**
   * If `true`, the children will be indented.
   * This should be used if there is no left avatar or left icon.
   */
  inset: _propTypes.default.bool,

  /**
   * The main content element.
   */
  primary: _propTypes.default.node,

  /**
   * These props will be forwarded to the primary typography component
   * (as long as disableTypography is not `true`).
   */
  primaryTypographyProps: _propTypes.default.object,

  /**
   * The secondary content element.
   */
  secondary: _propTypes.default.node,

  /**
   * These props will be forwarded to the secondary typography component
   * (as long as disableTypography is not `true`).
   */
  secondaryTypographyProps: _propTypes.default.object
} : {};
ListItemText.defaultProps = {
  disableTypography: false,
  inset: false
};
ListItemText.contextTypes = {
  dense: _propTypes.default.bool
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiListItemText'
})(ListItemText);

exports.default = _default;

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _helpers = __webpack_require__(51);

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      boxSizing: 'border-box',
      lineHeight: '48px',
      listStyle: 'none',
      color: theme.palette.text.secondary,
      fontFamily: theme.typography.fontFamily,
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: theme.typography.pxToRem(14)
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
    gutters: theme.mixins.gutters(),

    /* Styles applied to the root element if `inset={true}`. */
    inset: {
      paddingLeft: 72
    },

    /* Styles applied to the root element if `disableSticky={false}`. */
    sticky: {
      position: 'sticky',
      top: 0,
      zIndex: 1,
      backgroundColor: 'inherit'
    }
  };
};

exports.styles = styles;

function ListSubheader(props) {
  var _classNames;

  var classes = props.classes,
      className = props.className,
      color = props.color,
      Component = props.component,
      disableGutters = props.disableGutters,
      disableSticky = props.disableSticky,
      inset = props.inset,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "component", "disableGutters", "disableSticky", "inset"]);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'default'), (0, _defineProperty2.default)(_classNames, classes.inset, inset), (0, _defineProperty2.default)(_classNames, classes.sticky, !disableSticky), (0, _defineProperty2.default)(_classNames, classes.gutters, !disableGutters), _classNames), className)
  }, other));
}

ListSubheader.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['default', 'primary', 'inherit']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the List Subheader will not have gutters.
   */
  disableGutters: _propTypes.default.bool,

  /**
   * If `true`, the List Subheader will not stick to the top during scroll.
   */
  disableSticky: _propTypes.default.bool,

  /**
   * If `true`, the List Subheader will be indented.
   */
  inset: _propTypes.default.bool
} : {};
ListSubheader.defaultProps = {
  color: 'default',
  component: 'li',
  disableGutters: false,
  disableSticky: false,
  inset: false
};
ListSubheader.muiName = 'ListSubheader';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiListSubheader'
})(ListSubheader);

exports.default = _default;

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Menu.default;
  }
});

var _Menu = _interopRequireDefault(__webpack_require__(467));

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _MobileStepper.default;
  }
});

var _MobileStepper = _interopRequireDefault(__webpack_require__(1037));

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(222));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _Paper = _interopRequireDefault(__webpack_require__(49));

var _helpers = __webpack_require__(51);

var _LinearProgress = _interopRequireDefault(__webpack_require__(506));

// @inheritedComponent Paper
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      background: theme.palette.background.default,
      padding: 8
    },

    /* Styles applied to the root element if `position="bottom"`. */
    positionBottom: {
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: theme.zIndex.mobileStepper
    },

    /* Styles applied to the root element if `position="top"`. */
    positionTop: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: theme.zIndex.mobileStepper
    },

    /* Styles applied to the root element if `position="static"`. */
    positionStatic: {},

    /* Styles applied to the dots container if `variant="dots"`. */
    dots: {
      display: 'flex',
      flexDirection: 'row'
    },

    /* Styles applied to each dot if `variant="dots"`. */
    dot: {
      backgroundColor: theme.palette.action.disabled,
      borderRadius: '50%',
      width: 8,
      height: 8,
      margin: '0 2px'
    },

    /* Styles applied to a dot if `variant="dots"` and this is the active step. */
    dotActive: {
      backgroundColor: theme.palette.primary.main
    },

    /* Styles applied to the Linear Progress component if `variant="progress"`. */
    progress: {
      width: '50%'
    }
  };
};

exports.styles = styles;

function MobileStepper(props) {
  var activeStep = props.activeStep,
      backButton = props.backButton,
      classes = props.classes,
      classNameProp = props.className,
      LinearProgressProps = props.LinearProgressProps,
      nextButton = props.nextButton,
      position = props.position,
      steps = props.steps,
      variant = props.variant,
      other = (0, _objectWithoutProperties2.default)(props, ["activeStep", "backButton", "classes", "className", "LinearProgressProps", "nextButton", "position", "steps", "variant"]);
  var className = (0, _classnames.default)(classes.root, classes["position".concat((0, _helpers.capitalize)(position))], classNameProp);
  return _react.default.createElement(_Paper.default, (0, _extends2.default)({
    square: true,
    elevation: 0,
    className: className
  }, other), backButton, variant === 'dots' && _react.default.createElement("div", {
    className: classes.dots
  }, (0, _toConsumableArray2.default)(new Array(steps)).map(function (_, step) {
    var dotClassName = (0, _classnames.default)(classes.dot, (0, _defineProperty2.default)({}, classes.dotActive, step === activeStep)); // eslint-disable-next-line react/no-array-index-key

    return _react.default.createElement("div", {
      key: step,
      className: dotClassName
    });
  })), variant === 'progress' && _react.default.createElement(_LinearProgress.default, (0, _extends2.default)({
    className: classes.progress,
    variant: "determinate",
    value: Math.ceil(activeStep / (steps - 1) * 100)
  }, LinearProgressProps)), nextButton);
}

MobileStepper.propTypes =  false ? {
  /**
   * Set the active step (zero based index).
   * Defines which dot is highlighted when the variant is 'dots'.
   */
  activeStep: _propTypes.default.number,

  /**
   * A back button element. For instance, it can be be a `Button` or a `IconButton`.
   */
  backButton: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Properties applied to the `LinearProgress` element.
   */
  LinearProgressProps: _propTypes.default.object,

  /**
   * A next button element. For instance, it can be be a `Button` or a `IconButton`.
   */
  nextButton: _propTypes.default.node,

  /**
   * Set the positioning type.
   */
  position: _propTypes.default.oneOf(['bottom', 'top', 'static']),

  /**
   * The total steps.
   */
  steps: _propTypes.default.number.isRequired,

  /**
   * The variant to use.
   */
  variant: _propTypes.default.oneOf(['text', 'dots', 'progress'])
} : {};
MobileStepper.defaultProps = {
  activeStep: 0,
  position: 'bottom',
  variant: 'dots'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiMobileStepper'
})(MobileStepper);

exports.default = _default;

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _exactProp = _interopRequireDefault(__webpack_require__(115));

/**
 * NoSsr purposely removes components from the subject of Server Side Rendering (SSR).
 *
 * This component can be useful in a variety of situations:
 * - Escape hatch for broken dependencies not supporting SSR.
 * - Improve the time-to-first paint on the client by only rendering above the fold.
 * - Reduce the rendering time on the server.
 * - Under too heavy server load, you can turn on service degradation.
 */
var NoSsr =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(NoSsr, _React$Component);

  function NoSsr() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, NoSsr);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(NoSsr)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      mounted: false
    };
    return _this;
  }

  (0, _createClass2.default)(NoSsr, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.mounted = true;

      if (this.props.defer) {
        // Wondering why we use two raf? Check this video out:
        // https://www.youtube.com/watch?v=cCOL7MC4Pl0
        requestAnimationFrame(function () {
          // The browser should be about to render the DOM that React commited at this point.
          // We don't want to interrupt. Let's wait the next raf.
          requestAnimationFrame(function () {
            if (_this2.mounted) {
              _this2.setState({
                mounted: true
              });
            }
          });
        });
      } else {
        this.setState({
          mounted: true
        }); // eslint-disable-line react/no-did-mount-set-state
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          fallback = _this$props.fallback;
      return this.state.mounted ? children : fallback;
    }
  }]);
  return NoSsr;
}(_react.default.Component);

NoSsr.propTypes =  false ? {
  children: _propTypes.default.node.isRequired,

  /**
   * If `true`, the component will not only prevent server side rendering.
   * It will also defer the rendering of the children into a different screen frame.
   */
  defer: _propTypes.default.bool,

  /**
   * The fallback content to display.
   */
  fallback: _propTypes.default.node
} : {};
NoSsr.propTypes =  false ? (0, _exactProp.default)(NoSsr.propTypes) : {};
NoSsr.defaultProps = {
  defer: false,
  fallback: null
};
var _default = NoSsr;
exports.default = _default;

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _SwitchBase = _interopRequireDefault(__webpack_require__(307));

var _RadioButtonUnchecked = _interopRequireDefault(__webpack_require__(1040));

var _RadioButtonChecked = _interopRequireDefault(__webpack_require__(1041));

var _helpers = __webpack_require__(51);

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: theme.palette.text.secondary
    },

    /* Styles applied to the root element if `checked={true}`. */
    checked: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      '&$checked': {
        color: theme.palette.primary.main
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      '&$checked': {
        color: theme.palette.secondary.main
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    }
  };
};

exports.styles = styles;

var _ref = _react.default.createElement(_RadioButtonUnchecked.default, null);

var _ref2 = _react.default.createElement(_RadioButtonChecked.default, null);

function Radio(props) {
  var classes = props.classes,
      color = props.color,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "color"]);
  return _react.default.createElement(_SwitchBase.default, (0, _extends2.default)({
    type: "radio",
    icon: _ref,
    checkedIcon: _ref2,
    classes: {
      root: (0, _classnames.default)(classes.root, classes["color".concat((0, _helpers.capitalize)(color))]),
      checked: classes.checked,
      disabled: classes.disabled
    }
  }, other));
}

Radio.propTypes =  false ? {
  /**
   * If `true`, the component is checked.
   */
  checked: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['primary', 'secondary', 'default']),

  /**
   * If `true`, the switch will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes.default.bool,

  /**
   * The icon to display when the component is unchecked.
   */
  icon: _propTypes.default.node,

  /**
   * The id of the `input` element.
   */
  id: _propTypes.default.string,

  /**
   * Attributes applied to the `input` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   * @param {boolean} checked The `checked` value of the switch
   */
  onChange: _propTypes.default.func,

  /**
   * The input component property `type`.
   */
  type: _propTypes.default.string,

  /**
   * The value of the component.
   */
  value: _propTypes.default.string
} : {};
Radio.defaultProps = {
  color: 'secondary'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiRadio'
})(Radio);

exports.default = _default;

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _pure = _interopRequireDefault(__webpack_require__(81));

var _SvgIcon = _interopRequireDefault(__webpack_require__(73));

var _ref = _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
});

/**
 * @ignore - internal component.
 */
var RadioButtonUnchecked = function RadioButtonUnchecked(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

RadioButtonUnchecked = (0, _pure.default)(RadioButtonUnchecked);
RadioButtonUnchecked.muiName = 'SvgIcon';
var _default = RadioButtonUnchecked;
exports.default = _default;

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _pure = _interopRequireDefault(__webpack_require__(81));

var _SvgIcon = _interopRequireDefault(__webpack_require__(73));

var _ref = _react.default.createElement("path", {
  d: "M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
});

/**
 * @ignore - internal component.
 */
var RadioButtonChecked = function RadioButtonChecked(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

RadioButtonChecked = (0, _pure.default)(RadioButtonChecked);
RadioButtonChecked.muiName = 'SvgIcon';
var _default = RadioButtonChecked;
exports.default = _default;

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _warning = _interopRequireDefault(__webpack_require__(37));

var _FormGroup = _interopRequireDefault(__webpack_require__(42));

var _helpers = __webpack_require__(51);

// @inheritedComponent FormGroup
var RadioGroup =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(RadioGroup, _React$Component);

  function RadioGroup() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, RadioGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(RadioGroup)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.radios = [];

    _this.focus = function () {
      if (!_this.radios || !_this.radios.length) {
        return;
      }

      var focusRadios = _this.radios.filter(function (n) {
        return !n.disabled;
      });

      if (!focusRadios.length) {
        return;
      }

      var selectedRadio = (0, _helpers.find)(focusRadios, function (n) {
        return n.checked;
      });

      if (selectedRadio) {
        selectedRadio.focus();
        return;
      }

      focusRadios[0].focus();
    };

    _this.handleRadioChange = function (event, checked) {
      if (checked && _this.props.onChange) {
        _this.props.onChange(event, event.target.value);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(RadioGroup, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          name = _this$props.name,
          value = _this$props.value,
          onChange = _this$props.onChange,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["children", "name", "value", "onChange"]);
      this.radios = [];
      return _react.default.createElement(_FormGroup.default, (0, _extends2.default)({
        role: "radiogroup"
      }, other), _react.default.Children.map(children, function (child) {
        if (!_react.default.isValidElement(child)) {
          return null;
        }

         false ? (0, _warning.default)(child.type !== _react.default.Fragment, ["Material-UI: the RadioGroup component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n')) : void 0;
        return _react.default.cloneElement(child, {
          name: name,
          inputRef: function inputRef(node) {
            if (node) {
              _this2.radios.push(node);
            }
          },
          checked: value === child.props.value,
          onChange: (0, _helpers.createChainedFunction)(child.props.onChange, _this2.handleRadioChange)
        });
      }));
    }
  }]);
  return RadioGroup;
}(_react.default.Component);

RadioGroup.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * The name used to reference the value of the control.
   */
  name: _propTypes.default.string,

  /**
   * @ignore
   */
  onBlur: _propTypes.default.func,

  /**
   * Callback fired when a radio button is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   * @param {string} value The `value` of the selected radio button
   */
  onChange: _propTypes.default.func,

  /**
   * @ignore
   */
  onKeyDown: _propTypes.default.func,

  /**
   * Value of the selected radio button.
   */
  value: _propTypes.default.string
} : {};
var _default = RadioGroup;
exports.default = _default;

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _extends8 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _reactEventListener = _interopRequireDefault(__webpack_require__(93));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _transitions = __webpack_require__(99);

var _ClickAwayListener = _interopRequireDefault(__webpack_require__(500));

var _helpers = __webpack_require__(51);

var _Slide = _interopRequireDefault(__webpack_require__(237));

var _SnackbarContent = _interopRequireDefault(__webpack_require__(509));

var styles = function styles(theme) {
  var gutter = 24;
  var top = {
    top: 0
  };
  var bottom = {
    bottom: 0
  };
  var right = {
    justifyContent: 'flex-end'
  };
  var left = {
    justifyContent: 'flex-start'
  };
  var topSpace = {
    top: gutter
  };
  var bottomSpace = {
    bottom: gutter
  };
  var rightSpace = {
    right: gutter
  };
  var leftSpace = {
    left: gutter
  };
  var center = {
    left: '50%',
    right: 'auto',
    transform: 'translateX(-50%)'
  };
  return {
    /* Styles applied to the root element. */
    root: {
      zIndex: theme.zIndex.snackbar,
      position: 'fixed',
      display: 'flex',
      left: 0,
      right: 0,
      justifyContent: 'center',
      alignItems: 'center'
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'center' }}`. */
    anchorOriginTopCenter: (0, _extends8.default)({}, top, (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), (0, _extends8.default)({}, center))),

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'center' }}`. */
    anchorOriginBottomCenter: (0, _extends8.default)({}, bottom, (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), (0, _extends8.default)({}, center))),

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }}`. */
    anchorOriginTopRight: (0, _extends8.default)({}, top, right, (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), (0, _extends8.default)({
      left: 'auto'
    }, topSpace, rightSpace))),

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }}`. */
    anchorOriginBottomRight: (0, _extends8.default)({}, bottom, right, (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), (0, _extends8.default)({
      left: 'auto'
    }, bottomSpace, rightSpace))),

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }}`. */
    anchorOriginTopLeft: (0, _extends8.default)({}, top, left, (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), (0, _extends8.default)({
      right: 'auto'
    }, topSpace, leftSpace))),

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }}`. */
    anchorOriginBottomLeft: (0, _extends8.default)({}, bottom, left, (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), (0, _extends8.default)({
      right: 'auto'
    }, bottomSpace, leftSpace)))
  };
};
/* istanbul ignore if */


exports.styles = styles;

if (false) {
  throw new Error('Material-UI: react@16.3.0 or greater is required.');
}

var Snackbar =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Snackbar, _React$Component);

  function Snackbar() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Snackbar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Snackbar)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.timerAutoHide = null;
    _this.state = {};

    _this.handleMouseEnter = function (event) {
      if (_this.props.onMouseEnter) {
        _this.props.onMouseEnter(event);
      }

      _this.handlePause();
    };

    _this.handleMouseLeave = function (event) {
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave(event);
      }

      _this.handleResume();
    };

    _this.handleClickAway = function (event) {
      if (_this.props.onClose) {
        _this.props.onClose(event, 'clickaway');
      }
    };

    _this.handlePause = function () {
      clearTimeout(_this.timerAutoHide);
    };

    _this.handleResume = function () {
      if (_this.props.autoHideDuration != null) {
        if (_this.props.resumeHideDuration != null) {
          _this.setAutoHideTimer(_this.props.resumeHideDuration);

          return;
        }

        _this.setAutoHideTimer(_this.props.autoHideDuration * 0.5);
      }
    };

    _this.handleExited = function () {
      _this.setState({
        exited: true
      });
    };

    return _this;
  }

  (0, _createClass2.default)(Snackbar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.open) {
        this.setAutoHideTimer();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.open !== this.props.open) {
        if (this.props.open) {
          this.setAutoHideTimer();
        } else {
          clearTimeout(this.timerAutoHide);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timerAutoHide);
    }
  }, {
    key: "setAutoHideTimer",
    // Timer that controls delay before snackbar auto hides
    value: function setAutoHideTimer(autoHideDuration) {
      var _this2 = this;

      var autoHideDurationBefore = autoHideDuration != null ? autoHideDuration : this.props.autoHideDuration;

      if (!this.props.onClose || autoHideDurationBefore == null) {
        return;
      }

      clearTimeout(this.timerAutoHide);
      this.timerAutoHide = setTimeout(function () {
        var autoHideDurationAfter = autoHideDuration != null ? autoHideDuration : _this2.props.autoHideDuration;

        if (!_this2.props.onClose || autoHideDurationAfter == null) {
          return;
        }

        _this2.props.onClose(null, 'timeout');
      }, autoHideDurationBefore);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          action = _this$props.action,
          _this$props$anchorOri = _this$props.anchorOrigin,
          vertical = _this$props$anchorOri.vertical,
          horizontal = _this$props$anchorOri.horizontal,
          autoHideDuration = _this$props.autoHideDuration,
          children = _this$props.children,
          classes = _this$props.classes,
          className = _this$props.className,
          ContentProps = _this$props.ContentProps,
          disableWindowBlurListener = _this$props.disableWindowBlurListener,
          message = _this$props.message,
          onClose = _this$props.onClose,
          onEnter = _this$props.onEnter,
          onEntered = _this$props.onEntered,
          onEntering = _this$props.onEntering,
          onExit = _this$props.onExit,
          onExited = _this$props.onExited,
          onExiting = _this$props.onExiting,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseLeave = _this$props.onMouseLeave,
          open = _this$props.open,
          resumeHideDuration = _this$props.resumeHideDuration,
          TransitionComponent = _this$props.TransitionComponent,
          transitionDuration = _this$props.transitionDuration,
          TransitionProps = _this$props.TransitionProps,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["action", "anchorOrigin", "autoHideDuration", "children", "classes", "className", "ContentProps", "disableWindowBlurListener", "message", "onClose", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "onMouseEnter", "onMouseLeave", "open", "resumeHideDuration", "TransitionComponent", "transitionDuration", "TransitionProps"]); // So we only render active snackbars.

      if (!open && this.state.exited) {
        return null;
      }

      return _react.default.createElement(_ClickAwayListener.default, {
        onClickAway: this.handleClickAway
      }, _react.default.createElement("div", (0, _extends8.default)({
        className: (0, _classnames.default)(classes.root, classes["anchorOrigin".concat((0, _helpers.capitalize)(vertical)).concat((0, _helpers.capitalize)(horizontal))], className),
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave
      }, other), _react.default.createElement(_reactEventListener.default, {
        target: "window",
        onFocus: disableWindowBlurListener ? undefined : this.handleResume,
        onBlur: disableWindowBlurListener ? undefined : this.handlePause
      }), _react.default.createElement(TransitionComponent, (0, _extends8.default)({
        appear: true,
        in: open,
        onEnter: onEnter,
        onEntered: onEntered,
        onEntering: onEntering,
        onExit: onExit,
        onExited: (0, _helpers.createChainedFunction)(this.handleExited, onExited),
        onExiting: onExiting,
        timeout: transitionDuration,
        direction: vertical === 'top' ? 'down' : 'up'
      }, TransitionProps), children || _react.default.createElement(_SnackbarContent.default, (0, _extends8.default)({
        message: message,
        action: action
      }, ContentProps)))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (typeof prevState.exited === 'undefined') {
        return {
          exited: !nextProps.open
        };
      }

      if (nextProps.open) {
        return {
          exited: false
        };
      }

      return null;
    }
  }]);
  return Snackbar;
}(_react.default.Component);

Snackbar.propTypes =  false ? {
  /**
   * The action to display.
   */
  action: _propTypes.default.node,

  /**
   * The anchor of the `Snackbar`.
   */
  anchorOrigin: _propTypes.default.shape({
    horizontal: _propTypes.default.oneOf(['left', 'center', 'right']).isRequired,
    vertical: _propTypes.default.oneOf(['top', 'center', 'bottom']).isRequired
  }),

  /**
   * The number of milliseconds to wait before automatically calling the
   * `onClose` function. `onClose` should then set the state of the `open`
   * prop to hide the Snackbar. This behavior is disabled by default with
   * the `null` value.
   */
  autoHideDuration: _propTypes.default.number,

  /**
   * If you wish the take control over the children of the component you can use this property.
   * When used, you replace the `SnackbarContent` component with the children.
   */
  children: _propTypes.default.element,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Properties applied to the [`SnackbarContent`](/api/snackbar-content) element.
   */
  ContentProps: _propTypes.default.object,

  /**
   * If `true`, the `autoHideDuration` timer will expire even if the window is not focused.
   */
  disableWindowBlurListener: _propTypes.default.bool,

  /**
   * When displaying multiple consecutive Snackbars from a parent rendering a single
   * <Snackbar/>, add the key property to ensure independent treatment of each message.
   * e.g. <Snackbar key={message} />, otherwise, the message may update-in-place and
   * features such as autoHideDuration may be canceled.
   */
  key: _propTypes.default.any,

  /**
   * The message to display.
   */
  message: _propTypes.default.node,

  /**
   * Callback fired when the component requests to be closed.
   * Typically `onClose` is used to set state in the parent component,
   * which is used to control the `Snackbar` `open` prop.
   * The `reason` parameter can optionally be used to control the response to `onClose`,
   * for example ignoring `clickaway`.
   *
   * @param {object} event The event source of the callback
   * @param {string} reason Can be:`"timeout"` (`autoHideDuration` expired) or: `"clickaway"`
   */
  onClose: _propTypes.default.func,

  /**
   * Callback fired before the transition is entering.
   */
  onEnter: _propTypes.default.func,

  /**
   * Callback fired when the transition has entered.
   */
  onEntered: _propTypes.default.func,

  /**
   * Callback fired when the transition is entering.
   */
  onEntering: _propTypes.default.func,

  /**
   * Callback fired before the transition is exiting.
   */
  onExit: _propTypes.default.func,

  /**
   * Callback fired when the transition has exited.
   */
  onExited: _propTypes.default.func,

  /**
   * Callback fired when the transition is exiting.
   */
  onExiting: _propTypes.default.func,

  /**
   * @ignore
   */
  onMouseEnter: _propTypes.default.func,

  /**
   * @ignore
   */
  onMouseLeave: _propTypes.default.func,

  /**
   * If true, `Snackbar` is open.
   */
  open: _propTypes.default.bool,

  /**
   * The number of milliseconds to wait before dismissing after user interaction.
   * If `autoHideDuration` property isn't specified, it does nothing.
   * If `autoHideDuration` property is specified but `resumeHideDuration` isn't,
   * we default to `autoHideDuration / 2` ms.
   */
  resumeHideDuration: _propTypes.default.number,

  /**
   * Transition component.
   */
  TransitionComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })]),

  /**
   * Properties applied to the `Transition` element.
   */
  TransitionProps: _propTypes.default.object
} : {};
Snackbar.defaultProps = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'center'
  },
  disableWindowBlurListener: false,
  TransitionComponent: _Slide.default,
  transitionDuration: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  }
};

var _default = (0, _withStyles.default)(styles, {
  flip: false,
  name: 'MuiSnackbar'
})(Snackbar);

exports.default = _default;

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _Paper = _interopRequireDefault(__webpack_require__(49));

var _Typography = _interopRequireDefault(__webpack_require__(13));

var _colorManipulator = __webpack_require__(80);

// @inheritedComponent Paper
var styles = function styles(theme) {
  var _root;

  var emphasis = theme.palette.type === 'light' ? 0.8 : 0.98;
  var backgroundColor = (0, _colorManipulator.emphasize)(theme.palette.background.default, emphasis);
  return {
    /* Styles applied to the root element. */
    root: (_root = {
      color: theme.palette.getContrastText(backgroundColor),
      backgroundColor: backgroundColor,
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      padding: '6px 24px'
    }, (0, _defineProperty2.default)(_root, theme.breakpoints.up('md'), {
      minWidth: 288,
      maxWidth: 568,
      borderRadius: theme.shape.borderRadius
    }), (0, _defineProperty2.default)(_root, theme.breakpoints.down('sm'), {
      flexGrow: 1
    }), _root),

    /* Styles applied to the message wrapper element. */
    message: {
      padding: '8px 0'
    },

    /* Styles applied to the action wrapper element if `action` is provided. */
    action: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: 'auto',
      paddingLeft: 24,
      marginRight: -8
    }
  };
};

exports.styles = styles;

function SnackbarContent(props) {
  var action = props.action,
      classes = props.classes,
      className = props.className,
      message = props.message,
      other = (0, _objectWithoutProperties2.default)(props, ["action", "classes", "className", "message"]);
  return _react.default.createElement(_Paper.default, (0, _extends2.default)({
    component: _Typography.default,
    headlineMapping: {
      body1: 'div'
    },
    role: "alertdialog",
    square: true,
    elevation: 6,
    className: (0, _classnames.default)(classes.root, className)
  }, other), _react.default.createElement("div", {
    className: classes.message
  }, message), action ? _react.default.createElement("div", {
    className: classes.action
  }, action) : null);
}

SnackbarContent.propTypes =  false ? {
  /**
   * The action to display.
   */
  action: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The message to display.
   */
  message: _propTypes.default.node
} : {};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiSnackbarContent'
})(SnackbarContent);

exports.default = _default;

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _warning = _interopRequireDefault(__webpack_require__(37));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var styles = {
  /* Styles applied to the root element. */
  root: {},

  /* Styles applied to the root element if `orientation="horizontal"`. */
  horizontal: {
    paddingLeft: 8,
    paddingRight: 8,
    '&:first-child': {
      paddingLeft: 0
    },
    '&:last-child': {
      paddingRight: 0
    }
  },

  /* Styles applied to the root element if `orientation="vertical"`. */
  vertical: {},

  /* Styles applied to the root element if `alternativeLabel={true}`. */
  alternativeLabel: {
    flex: 1,
    position: 'relative'
  },

  /* Styles applied to the root element if `completed={true}`. */
  completed: {}
};
exports.styles = styles;

function Step(props) {
  var _classNames;

  var active = props.active,
      alternativeLabel = props.alternativeLabel,
      children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      completed = props.completed,
      connector = props.connector,
      disabled = props.disabled,
      index = props.index,
      last = props.last,
      orientation = props.orientation,
      other = (0, _objectWithoutProperties2.default)(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "connector", "disabled", "index", "last", "orientation"]);
  var className = (0, _classnames.default)(classes.root, classes[orientation], (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.alternativeLabel, alternativeLabel), (0, _defineProperty2.default)(_classNames, classes.completed, completed), _classNames), classNameProp);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: className
  }, other), _react.default.Children.map(children, function (child) {
    if (!_react.default.isValidElement(child)) {
      return null;
    }

     false ? (0, _warning.default)(child.type !== _react.default.Fragment, ["Material-UI: the Step component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n')) : void 0;
    return _react.default.cloneElement(child, (0, _extends2.default)({
      active: active,
      alternativeLabel: alternativeLabel,
      completed: completed,
      disabled: disabled,
      icon: index + 1,
      last: last,
      orientation: orientation
    }, child.props));
  }), connector && alternativeLabel && !last && _react.default.cloneElement(connector, {
    orientation: orientation,
    alternativeLabel: alternativeLabel
  }));
}

Step.propTypes =  false ? {
  /**
   * Sets the step as active. Is passed to child components.
   */
  active: _propTypes.default.bool,

  /**
   * @ignore
   * Set internally by Stepper when it's supplied with the alternativeLabel property.
   */
  alternativeLabel: _propTypes.default.bool,

  /**
   * Should be `Step` sub-components such as `StepLabel`, `StepContent`.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: _propTypes.default.bool,

  /**
   * @ignore
   * Passed down from Stepper if alternativeLabel is also set.
   */
  connector: _propTypes.default.element,

  /**
   * Mark the step as disabled, will also disable the button if
   * `StepButton` is a child of `Step`. Is passed to child components.
   */
  disabled: _propTypes.default.bool,

  /**
   * @ignore
   * Used internally for numbering.
   */
  index: _propTypes.default.number,

  /**
   * @ignore
   */
  last: _propTypes.default.bool,

  /**
   * @ignore
   */
  orientation: _propTypes.default.oneOf(['horizontal', 'vertical'])
} : {};
Step.defaultProps = {
  active: false,
  completed: false,
  disabled: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiStep'
})(Step);

exports.default = _default;

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _ButtonBase = _interopRequireDefault(__webpack_require__(92));

var _StepLabel = _interopRequireDefault(__webpack_require__(512));

var _reactHelpers = __webpack_require__(119);

// @inheritedComponent ButtonBase
var styles = {
  /* Styles applied to the root element. */
  root: {
    width: '100%',
    padding: '24px 16px',
    margin: '-24px -16px',
    boxSizing: 'content-box'
  },

  /* Styles applied to the root element if `orientation="horizontal"`. */
  horizontal: {},

  /* Styles applied to the root element if `orientation="vertical"`. */
  vertical: {
    justifyContent: 'flex-start'
  },

  /* Styles applied to the `ButtonBase` touch-ripple. */
  touchRipple: {
    color: 'rgba(0, 0, 0, 0.3)'
  }
};
exports.styles = styles;

function StepButton(props) {
  var active = props.active,
      alternativeLabel = props.alternativeLabel,
      children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      completed = props.completed,
      disabled = props.disabled,
      icon = props.icon,
      last = props.last,
      optional = props.optional,
      orientation = props.orientation,
      other = (0, _objectWithoutProperties2.default)(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "disabled", "icon", "last", "optional", "orientation"]);
  var childProps = {
    active: active,
    alternativeLabel: alternativeLabel,
    completed: completed,
    disabled: disabled,
    icon: icon,
    optional: optional,
    orientation: orientation
  };
  var child = (0, _reactHelpers.isMuiElement)(children, ['StepLabel']) ? _react.default.cloneElement(children, childProps) : _react.default.createElement(_StepLabel.default, childProps, children);
  return _react.default.createElement(_ButtonBase.default, (0, _extends2.default)({
    disabled: disabled,
    TouchRippleProps: {
      className: classes.touchRipple
    },
    className: (0, _classnames.default)(classes.root, classes[orientation], classNameProp)
  }, other), child);
}

StepButton.propTypes =  false ? {
  /**
   * @ignore
   * Passed in via `Step` - passed through to `StepLabel`.
   */
  active: _propTypes.default.bool,

  /**
   * @ignore
   * Set internally by Stepper when it's supplied with the alternativeLabel property.
   */
  alternativeLabel: _propTypes.default.bool,

  /**
   * Can be a `StepLabel` or a node to place inside `StepLabel` as children.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   * Sets completed styling. Is passed to StepLabel.
   */
  completed: _propTypes.default.bool,

  /**
   * @ignore
   * Disables the button and sets disabled styling. Is passed to StepLabel.
   */
  disabled: _propTypes.default.bool,

  /**
   * The icon displayed by the step label.
   */
  icon: _propTypes.default.node,

  /**
   * @ignore
   */
  last: _propTypes.default.bool,

  /**
   * The optional node to display.
   */
  optional: _propTypes.default.node,

  /**
   * @ignore
   */
  orientation: _propTypes.default.oneOf(['horizontal', 'vertical'])
} : {};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiStepButton'
})(StepButton);

exports.default = _default;

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _Typography = _interopRequireDefault(__webpack_require__(13));

var _StepIcon = _interopRequireDefault(__webpack_require__(513));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      alignItems: 'center',
      '&$alternativeLabel': {
        flexDirection: 'column'
      },
      '&$disabled': {
        cursor: 'default'
      }
    },

    /* Styles applied to the root element if `orientation="horiizontal". */
    horizontal: {},

    /* Styles applied to the root element if `orientation="vertical". */
    vertical: {},

    /* Styles applied to the `Typography` component which wraps `children`. */
    label: {
      color: theme.palette.text.secondary,
      '&$active': {
        color: theme.palette.text.primary,
        fontWeight: 500
      },
      '&$completed': {
        color: theme.palette.text.primary,
        fontWeight: 500
      },
      '&$alternativeLabel': {
        textAlign: 'center',
        marginTop: 16
      },
      '&$error': {
        color: theme.palette.error.main
      }
    },

    /* Styles applied to the `Typography` component if `active={true}`. */
    active: {},

    /* Styles applied to the `Typography` component if `completed={true}`. */
    completed: {},

    /* Styles applied to the root element and `Typography` component if `error={true}`. */
    error: {},

    /* Styles applied to the root element and `Typography` component if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the `icon` container element. */
    iconContainer: {
      paddingRight: 8,
      '&$alternativeLabel': {
        paddingRight: 0
      }
    },

    /* Styles applied to the root & icon container and `Typography` if `alternativeLabel={true}`. */
    alternativeLabel: {},

    /* Styles applied to the container element which wraps `Typography` and `optional`. */
    labelContainer: {
      width: '100%'
    }
  };
};

exports.styles = styles;

function StepLabel(props) {
  var _classNames, _classNames3;

  var active = props.active,
      alternativeLabel = props.alternativeLabel,
      children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      completed = props.completed,
      disabled = props.disabled,
      error = props.error,
      icon = props.icon,
      last = props.last,
      optional = props.optional,
      orientation = props.orientation,
      StepIconProps = props.StepIconProps,
      other = (0, _objectWithoutProperties2.default)(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "disabled", "error", "icon", "last", "optional", "orientation", "StepIconProps"]);
  return _react.default.createElement("span", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, classes[orientation], (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.disabled, disabled), (0, _defineProperty2.default)(_classNames, classes.alternativeLabel, alternativeLabel), (0, _defineProperty2.default)(_classNames, classes.error, error), _classNames), classNameProp)
  }, other), icon && _react.default.createElement("span", {
    className: (0, _classnames.default)(classes.iconContainer, (0, _defineProperty2.default)({}, classes.alternativeLabel, alternativeLabel))
  }, _react.default.createElement(_StepIcon.default, (0, _extends2.default)({
    completed: completed,
    active: active,
    error: error,
    icon: icon
  }, StepIconProps))), _react.default.createElement("span", {
    className: classes.labelContainer
  }, _react.default.createElement(_Typography.default, {
    variant: "body1",
    component: "span",
    className: (0, _classnames.default)(classes.label, (_classNames3 = {}, (0, _defineProperty2.default)(_classNames3, classes.alternativeLabel, alternativeLabel), (0, _defineProperty2.default)(_classNames3, classes.completed, completed), (0, _defineProperty2.default)(_classNames3, classes.active, active), (0, _defineProperty2.default)(_classNames3, classes.error, error), _classNames3))
  }, children), optional));
}

StepLabel.propTypes =  false ? {
  /**
   * @ignore
   * Sets the step as active. Is passed to child components.
   */
  active: _propTypes.default.bool,

  /**
   * @ignore
   * Set internally by Stepper when it's supplied with the alternativeLabel property.
   */
  alternativeLabel: _propTypes.default.bool,

  /**
   * In most cases will simply be a string containing a title for the label.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   * Mark the step as completed. Is passed to child components.
   */
  completed: _propTypes.default.bool,

  /**
   * Mark the step as disabled, will also disable the button if
   * `StepLabelButton` is a child of `StepLabel`. Is passed to child components.
   */
  disabled: _propTypes.default.bool,

  /**
   * Mark the step as failed.
   */
  error: _propTypes.default.bool,

  /**
   * Override the default icon.
   */
  icon: _propTypes.default.node,

  /**
   * @ignore
   */
  last: _propTypes.default.bool,

  /**
   * The optional node to display.
   */
  optional: _propTypes.default.node,

  /**
   * @ignore
   */
  orientation: _propTypes.default.oneOf(['horizontal', 'vertical']),

  /**
   * Properties applied to the [`StepIcon`](/api/step-icon) element.
   */
  StepIconProps: _propTypes.default.object
} : {};
StepLabel.defaultProps = {
  active: false,
  alternativeLabel: false,
  completed: false,
  disabled: false,
  error: false,
  last: false,
  orientation: 'horizontal'
};
StepLabel.muiName = 'StepLabel';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiStepLabel'
})(StepLabel);

exports.default = _default;

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _CheckCircle = _interopRequireDefault(__webpack_require__(1049));

var _Warning = _interopRequireDefault(__webpack_require__(1050));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _SvgIcon = _interopRequireDefault(__webpack_require__(73));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'block',
      color: theme.palette.text.disabled,
      '&$active': {
        color: theme.palette.primary.main
      },
      '&$completed': {
        color: theme.palette.primary.main
      },
      '&$error': {
        color: theme.palette.error.main
      }
    },

    /* Styles applied to the SVG text element. */
    text: {
      fill: theme.palette.primary.contrastText,
      fontSize: theme.typography.caption.fontSize,
      fontFamily: theme.typography.fontFamily
    },

    /* Styles applied to the root element if `active={true}`. */
    active: {},

    /* Styles applied to the root element if `completed={true}`. */
    completed: {},

    /* Styles applied to the root element if `error={true}`. */
    error: {}
  };
};

exports.styles = styles;

var _ref = _react.default.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "12"
});

function StepIcon(props) {
  var completed = props.completed,
      icon = props.icon,
      active = props.active,
      error = props.error,
      classes = props.classes;

  if (typeof icon === 'number' || typeof icon === 'string') {
    if (error) {
      return _react.default.createElement(_Warning.default, {
        className: (0, _classnames.default)(classes.root, classes.error)
      });
    }

    if (completed) {
      return _react.default.createElement(_CheckCircle.default, {
        className: (0, _classnames.default)(classes.root, classes.completed)
      });
    }

    return _react.default.createElement(_SvgIcon.default, {
      className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.active, active))
    }, _ref, _react.default.createElement("text", {
      className: classes.text,
      x: "12",
      y: "16",
      textAnchor: "middle"
    }, icon));
  }

  return icon;
}

StepIcon.propTypes =  false ? {
  /**
   * Whether this step is active.
   */
  active: _propTypes.default.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: _propTypes.default.bool,

  /**
   * Mark the step as failed.
   */
  error: _propTypes.default.bool,

  /**
   * The icon displayed by the step label.
   */
  icon: _propTypes.default.node.isRequired
} : {};
StepIcon.defaultProps = {
  active: false,
  completed: false,
  error: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiStepIcon'
})(StepIcon);

exports.default = _default;

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _pure = _interopRequireDefault(__webpack_require__(81));

var _SvgIcon = _interopRequireDefault(__webpack_require__(73));

var _ref = _react.default.createElement("path", {
  d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
});

/**
 * @ignore - internal component.
 */
var CheckCircle = function CheckCircle(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

CheckCircle = (0, _pure.default)(CheckCircle);
CheckCircle.muiName = 'SvgIcon';
var _default = CheckCircle;
exports.default = _default;

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _pure = _interopRequireDefault(__webpack_require__(81));

var _SvgIcon = _interopRequireDefault(__webpack_require__(73));

var _ref = _react.default.createElement("path", {
  d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
});

/**
 * @ignore - internal component.
 */
var Warning = function Warning(props) {
  return _react.default.createElement(_SvgIcon.default, props, _ref);
};

Warning = (0, _pure.default)(Warning);
Warning.muiName = 'SvgIcon';
var _default = Warning;
exports.default = _default;

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      flex: '1 1 auto'
    },

    /* Styles applied to the root element if `orientation="horizontal"`. */
    horizontal: {},

    /* Styles applied to the root element if `orientation="vertical"`. */
    vertical: {
      marginLeft: 12,
      // half icon
      padding: '0 0 8px'
    },

    /* Styles applied to the root element if `alternativeLabel={true}`. */
    alternativeLabel: {
      position: 'absolute',
      top: 8 + 4,
      left: 'calc(50% + 20px)',
      right: 'calc(-50% + 20px)'
    },

    /* Styles applied to the line element. */
    line: {
      display: 'block',
      borderColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
    },

    /* Styles applied to the root element if `orientation="horizontal"`. */
    lineHorizontal: {
      borderTopStyle: 'solid',
      borderTopWidth: 1
    },

    /* Styles applied to the root element if `orientation="vertical"`. */
    lineVertical: {
      borderLeftStyle: 'solid',
      borderLeftWidth: 1,
      minHeight: 24
    }
  };
};

exports.styles = styles;

function StepConnector(props) {
  var _classNames2;

  var alternativeLabel = props.alternativeLabel,
      classNameProp = props.className,
      classes = props.classes,
      orientation = props.orientation,
      other = (0, _objectWithoutProperties2.default)(props, ["alternativeLabel", "className", "classes", "orientation"]);
  var className = (0, _classnames.default)(classes.root, classes[orientation], (0, _defineProperty2.default)({}, classes.alternativeLabel, alternativeLabel), classNameProp);
  var lineClassName = (0, _classnames.default)(classes.line, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, classes.lineHorizontal, orientation === 'horizontal'), (0, _defineProperty2.default)(_classNames2, classes.lineVertical, orientation === 'vertical'), _classNames2));
  return _react.default.createElement("div", (0, _extends2.default)({
    className: className
  }, other), _react.default.createElement("span", {
    className: lineClassName
  }));
}

StepConnector.propTypes =  false ? {
  /**
   * @ignore
   * Set internally by Step when it's supplied with the alternativeLabel property.
   */
  alternativeLabel: _propTypes.default.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   */
  orientation: _propTypes.default.oneOf(['horizontal', 'vertical'])
} : {};
StepConnector.defaultProps = {
  alternativeLabel: false,
  orientation: 'horizontal'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiStepConnector'
})(StepConnector);

exports.default = _default;

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _StepContent.default;
  }
});

var _StepContent = _interopRequireDefault(__webpack_require__(1053));

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _warning = _interopRequireDefault(__webpack_require__(37));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _Collapse = _interopRequireDefault(__webpack_require__(236));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      marginTop: 8,
      marginLeft: 12,
      // half icon
      paddingLeft: 8 + 12,
      // margin + half icon
      paddingRight: 8,
      borderLeft: "1px solid ".concat(theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600])
    },

    /* Styles applied to the root element if `last={true}` (controlled by `Step`). */
    last: {
      borderLeft: 'none'
    },

    /* Styles applied to the Transition component. */
    transition: {}
  };
};

exports.styles = styles;

function StepContent(props) {
  var active = props.active,
      alternativeLabel = props.alternativeLabel,
      children = props.children,
      classes = props.classes,
      className = props.className,
      completed = props.completed,
      last = props.last,
      optional = props.optional,
      orientation = props.orientation,
      TransitionComponent = props.TransitionComponent,
      transitionDurationProp = props.transitionDuration,
      TransitionProps = props.TransitionProps,
      other = (0, _objectWithoutProperties2.default)(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "last", "optional", "orientation", "TransitionComponent", "transitionDuration", "TransitionProps"]);
   false ? (0, _warning.default)(orientation === 'vertical', 'Material-UI: <StepContent /> is only designed for use with the vertical stepper.') : void 0;
  var transitionDuration = transitionDurationProp;

  if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) {
    transitionDuration = undefined;
  }

  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.last, last), className)
  }, other), _react.default.createElement(TransitionComponent, (0, _extends2.default)({
    in: active,
    className: classes.transition,
    timeout: transitionDuration,
    unmountOnExit: true
  }, TransitionProps), children));
}

StepContent.propTypes =  false ? {
  /**
   * @ignore
   * Expands the content.
   */
  active: _propTypes.default.bool,

  /**
   * @ignore
   * Set internally by Step when it's supplied with the alternativeLabel property.
   */
  alternativeLabel: _propTypes.default.bool,

  /**
   * Step content.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   */
  completed: _propTypes.default.bool,

  /**
   * @ignore
   */
  last: _propTypes.default.bool,

  /**
   * @ignore
   * Set internally by Step when it's supplied with the optional property.
   */
  optional: _propTypes.default.bool,

  /**
   * @ignore
   */
  orientation: _propTypes.default.oneOf(['horizontal', 'vertical']),

  /**
   * Collapse component.
   */
  TransitionComponent: _propTypes.default.func,

  /**
   * Adjust the duration of the content expand transition.
   * Passed as a property to the transition component.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  }), _propTypes.default.oneOf(['auto'])]),

  /**
   * Properties applied to the `Transition` element.
   */
  TransitionProps: _propTypes.default.object
} : {};
StepContent.defaultProps = {
  TransitionComponent: _Collapse.default,
  transitionDuration: 'auto'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiStepContent'
})(StepContent);

exports.default = _default;

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _Paper = _interopRequireDefault(__webpack_require__(49));

var _StepConnector = _interopRequireDefault(__webpack_require__(514));

// @inheritedComponent Paper
var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    padding: 24
  },

  /* Styles applied to the root element if `orientation="horizontal"`. */
  horizontal: {
    flexDirection: 'row',
    alignItems: 'center'
  },

  /* Styles applied to the root element if `orientation="vertical"`. */
  vertical: {
    flexDirection: 'column'
  },

  /* Styles applied to the root element if `alternativeLabel={true}`. */
  alternativeLabel: {
    alignItems: 'flex-start'
  }
};
exports.styles = styles;

function Stepper(props) {
  var activeStep = props.activeStep,
      alternativeLabel = props.alternativeLabel,
      children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      connectorProp = props.connector,
      nonLinear = props.nonLinear,
      orientation = props.orientation,
      other = (0, _objectWithoutProperties2.default)(props, ["activeStep", "alternativeLabel", "children", "classes", "className", "connector", "nonLinear", "orientation"]);
  var className = (0, _classnames.default)(classes.root, classes[orientation], (0, _defineProperty2.default)({}, classes.alternativeLabel, alternativeLabel), classNameProp);
  var connector = _react.default.isValidElement(connectorProp) ? _react.default.cloneElement(connectorProp, {
    orientation: orientation
  }) : null;

  var childrenArray = _react.default.Children.toArray(children);

  var steps = childrenArray.map(function (step, index) {
    var controlProps = {
      index: index,
      orientation: orientation,
      active: false,
      completed: false,
      disabled: false,
      last: index + 1 === childrenArray.length,
      alternativeLabel: alternativeLabel,
      connector: connectorProp
    };

    if (activeStep === index) {
      controlProps.active = true;
    } else if (!nonLinear && activeStep > index) {
      controlProps.completed = true;
    } else if (!nonLinear && activeStep < index) {
      controlProps.disabled = true;
    }

    return [!alternativeLabel && connector && index > 0 && _react.default.cloneElement(connector, {
      key: index // eslint-disable-line react/no-array-index-key

    }), _react.default.cloneElement(step, (0, _extends2.default)({}, controlProps, step.props))];
  });
  return _react.default.createElement(_Paper.default, (0, _extends2.default)({
    square: true,
    elevation: 0,
    className: className
  }, other), steps);
}

Stepper.propTypes =  false ? {
  /**
   * Set the active step (zero based index).
   */
  activeStep: _propTypes.default.number,

  /**
   * If set to 'true' and orientation is horizontal,
   * then the step label will be positioned under the icon.
   */
  alternativeLabel: _propTypes.default.bool,

  /**
   * Two or more `<Step />` components.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * A component to be placed between each step.
   */
  connector: _propTypes.default.element,

  /**
   * If set the `Stepper` will not assist in controlling steps for linear flow.
   */
  nonLinear: _propTypes.default.bool,

  /**
   * The stepper orientation (layout flow direction).
   */
  orientation: _propTypes.default.oneOf(['horizontal', 'vertical'])
} : {};
Stepper.defaultProps = {
  activeStep: 0,
  alternativeLabel: false,
  connector: _react.default.createElement(_StepConnector.default, null),
  nonLinear: false,
  orientation: 'horizontal'
};
Stepper.muiName = 'Stepper';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiStepper'
})(Stepper);

exports.default = _default;

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _SwipeableDrawer.default;
  }
});

var _SwipeableDrawer = _interopRequireDefault(__webpack_require__(1056));

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(144);

var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reset = reset;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(145));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _reactDom = _interopRequireDefault(__webpack_require__(64));

var _Drawer = _interopRequireWildcard(__webpack_require__(325));

var _transitions = __webpack_require__(99);

var _withTheme = _interopRequireDefault(__webpack_require__(90));

var _utils = __webpack_require__(148);

var _NoSsr = _interopRequireDefault(__webpack_require__(182));

var _SwipeArea = _interopRequireDefault(__webpack_require__(1057));

/* eslint-disable consistent-this */
// @inheritedComponent Drawer
// This value is closed to what browsers are using internally to
// trigger a native scroll.
var UNCERTAINTY_THRESHOLD = 3; // px
// We can only have one node at the time claiming ownership for handling the swipe.
// Otherwise, the UX would be confusing.
// That's why we use a singleton here.

var nodeThatClaimedTheSwipe = null; // Exported for test purposes.

function reset() {
  nodeThatClaimedTheSwipe = null;
}
/* istanbul ignore if */


if (false) {
  throw new Error('Material-UI: react@16.3.0 or greater is required.');
}

var SwipeableDrawer =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(SwipeableDrawer, _React$Component);

  function SwipeableDrawer() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, SwipeableDrawer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(SwipeableDrawer)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.backdrop = null;
    _this.paper = null;
    _this.isSwiping = null;
    _this.startX = null;
    _this.startY = null;
    _this.state = {};

    _this.handleBodyTouchStart = function (event) {
      // We are not supposed to hanlde this touch move.
      if (nodeThatClaimedTheSwipe !== null && nodeThatClaimedTheSwipe !== (0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this))) {
        return;
      }

      var _this$props = _this.props,
          disableDiscovery = _this$props.disableDiscovery,
          disableSwipeToOpen = _this$props.disableSwipeToOpen,
          open = _this$props.open,
          swipeAreaWidth = _this$props.swipeAreaWidth;
      var anchor = (0, _Drawer.getAnchor)(_this.props);
      var currentX = anchor === 'right' ? document.body.offsetWidth - event.touches[0].pageX : event.touches[0].pageX;
      var currentY = anchor === 'bottom' ? window.innerHeight - event.touches[0].clientY : event.touches[0].clientY;

      if (!open) {
        if (disableSwipeToOpen) {
          return;
        }

        if ((0, _Drawer.isHorizontal)(_this.props)) {
          if (currentX > swipeAreaWidth) {
            return;
          }
        } else if (currentY > swipeAreaWidth) {
          return;
        }
      }

      nodeThatClaimedTheSwipe = (0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this));
      _this.startX = currentX;
      _this.startY = currentY;

      _this.setState({
        maybeSwiping: true
      });

      if (!open && _this.paper) {
        // the ref may be null when a parent component updates while swiping
        _this.setPosition(_this.getMaxTranslate() + (disableDiscovery ? 20 : -swipeAreaWidth), {
          changeTransition: false
        });
      }

      document.body.addEventListener('touchmove', _this.handleBodyTouchMove, {
        passive: false
      });
      document.body.addEventListener('touchend', _this.handleBodyTouchEnd); // https://plus.google.com/+PaulIrish/posts/KTwfn1Y2238

      document.body.addEventListener('touchcancel', _this.handleBodyTouchEnd);
    };

    _this.handleBodyTouchMove = function (event) {
      // the ref may be null when a parent component updates while swiping
      if (!_this.paper) return;
      var anchor = (0, _Drawer.getAnchor)(_this.props);
      var horizontalSwipe = (0, _Drawer.isHorizontal)(_this.props);
      var currentX = anchor === 'right' ? document.body.offsetWidth - event.touches[0].pageX : event.touches[0].pageX;
      var currentY = anchor === 'bottom' ? window.innerHeight - event.touches[0].clientY : event.touches[0].clientY; // We don't know yet.

      if (_this.isSwiping == null) {
        var dx = Math.abs(currentX - _this.startX);
        var dy = Math.abs(currentY - _this.startY); // We are likely to be swiping, let's prevent the scroll event on iOS.

        if (dx > dy) {
          event.preventDefault();
        }

        var isSwiping = horizontalSwipe ? dx > dy && dx > UNCERTAINTY_THRESHOLD : dy > dx && dy > UNCERTAINTY_THRESHOLD;

        if (isSwiping === true || (horizontalSwipe ? dy > UNCERTAINTY_THRESHOLD : dx > UNCERTAINTY_THRESHOLD)) {
          _this.isSwiping = isSwiping;

          if (!isSwiping) {
            _this.handleBodyTouchEnd(event);

            return;
          } // Shift the starting point.


          _this.startX = currentX;
          _this.startY = currentY; // Compensate for the part of the drawer displayed on touch start.

          if (!_this.props.disableDiscovery && !_this.props.open) {
            if (horizontalSwipe) {
              _this.startX -= _this.props.swipeAreaWidth;
            } else {
              _this.startY -= _this.props.swipeAreaWidth;
            }
          }
        }
      }

      if (!_this.isSwiping) {
        return;
      } // We are swiping, let's prevent the scroll event on iOS.


      event.preventDefault();

      _this.setPosition(_this.getTranslate(horizontalSwipe ? currentX : currentY));
    };

    _this.handleBodyTouchEnd = function (event) {
      nodeThatClaimedTheSwipe = null;

      _this.removeBodyTouchListeners();

      _this.setState({
        maybeSwiping: false
      }); // The swipe wasn't started.


      if (!_this.isSwiping) {
        _this.isSwiping = null;
        return;
      }

      var anchor = (0, _Drawer.getAnchor)(_this.props);
      var current;

      if ((0, _Drawer.isHorizontal)(_this.props)) {
        current = anchor === 'right' ? document.body.offsetWidth - event.changedTouches[0].pageX : event.changedTouches[0].pageX;
      } else {
        current = anchor === 'bottom' ? window.innerHeight - event.changedTouches[0].clientY : event.changedTouches[0].clientY;
      }

      var translateRatio = _this.getTranslate(current) / _this.getMaxTranslate(); // We have to open or close after setting swiping to null,
      // because only then CSS transition is enabled.


      if (translateRatio > 0.5) {
        if (_this.isSwiping && !_this.props.open) {
          // Reset the position, the swipe was aborted.
          _this.setPosition(_this.getMaxTranslate(), {
            mode: 'enter'
          });
        } else {
          _this.props.onClose();
        }
      } else if (_this.isSwiping && !_this.props.open) {
        _this.props.onOpen();
      } else {
        // Reset the position, the swipe was aborted.
        _this.setPosition(0, {
          mode: 'exit'
        });
      }

      _this.isSwiping = null;
    };

    _this.handleBackdropRef = function (node) {
      _this.backdrop = node ? _reactDom.default.findDOMNode(node) : null;
    };

    _this.handlePaperRef = function (node) {
      _this.paper = node ? _reactDom.default.findDOMNode(node) : null;
    };

    return _this;
  }

  (0, _createClass2.default)(SwipeableDrawer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.variant === 'temporary') {
        this.listenTouchStart();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var variant = this.props.variant;
      var prevVariant = prevProps.variant;

      if (variant !== prevVariant) {
        if (variant === 'temporary') {
          this.listenTouchStart();
        } else if (prevVariant === 'temporary') {
          this.removeTouchStart();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeTouchStart();
      this.removeBodyTouchListeners(); // We need to release the lock.

      if (nodeThatClaimedTheSwipe === this) {
        nodeThatClaimedTheSwipe = null;
      }
    }
  }, {
    key: "getMaxTranslate",
    value: function getMaxTranslate() {
      return (0, _Drawer.isHorizontal)(this.props) ? this.paper.clientWidth : this.paper.clientHeight;
    }
  }, {
    key: "getTranslate",
    value: function getTranslate(current) {
      var start = (0, _Drawer.isHorizontal)(this.props) ? this.startX : this.startY;
      return Math.min(Math.max(this.props.open ? start - current : this.getMaxTranslate() + start - current, 0), this.getMaxTranslate());
    }
  }, {
    key: "setPosition",
    value: function setPosition(translate) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _options$mode = options.mode,
          mode = _options$mode === void 0 ? null : _options$mode,
          _options$changeTransi = options.changeTransition,
          changeTransition = _options$changeTransi === void 0 ? true : _options$changeTransi;
      var anchor = (0, _Drawer.getAnchor)(this.props);
      var rtlTranslateMultiplier = ['right', 'bottom'].indexOf(anchor) !== -1 ? 1 : -1;
      var transform = (0, _Drawer.isHorizontal)(this.props) ? "translate(".concat(rtlTranslateMultiplier * translate, "px, 0)") : "translate(0, ".concat(rtlTranslateMultiplier * translate, "px)");
      var drawerStyle = this.paper.style;
      drawerStyle.webkitTransform = transform;
      drawerStyle.transform = transform;
      var transition = '';

      if (mode) {
        transition = this.props.theme.transitions.create('all', (0, _utils.getTransitionProps)({
          timeout: this.props.transitionDuration
        }, {
          mode: mode
        }));
      }

      if (changeTransition) {
        drawerStyle.webkitTransition = transition;
        drawerStyle.transition = transition;
      }

      if (!this.props.disableBackdropTransition) {
        var backdropStyle = this.backdrop.style;
        backdropStyle.opacity = 1 - translate / this.getMaxTranslate();

        if (changeTransition) {
          backdropStyle.webkitTransition = transition;
          backdropStyle.transition = transition;
        }
      }
    }
  }, {
    key: "listenTouchStart",
    value: function listenTouchStart() {
      document.body.addEventListener('touchstart', this.handleBodyTouchStart);
    }
  }, {
    key: "removeTouchStart",
    value: function removeTouchStart() {
      document.body.removeEventListener('touchstart', this.handleBodyTouchStart);
    }
  }, {
    key: "removeBodyTouchListeners",
    value: function removeBodyTouchListeners() {
      document.body.removeEventListener('touchmove', this.handleBodyTouchMove, {
        passive: false
      });
      document.body.removeEventListener('touchend', this.handleBodyTouchEnd);
      document.body.removeEventListener('touchcancel', this.handleBodyTouchEnd);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          anchor = _this$props2.anchor,
          disableBackdropTransition = _this$props2.disableBackdropTransition,
          disableDiscovery = _this$props2.disableDiscovery,
          disableSwipeToOpen = _this$props2.disableSwipeToOpen,
          _this$props2$ModalPro = _this$props2.ModalProps;
      _this$props2$ModalPro = _this$props2$ModalPro === void 0 ? {} : _this$props2$ModalPro;
      var BackdropProps = _this$props2$ModalPro.BackdropProps,
          ModalPropsProp = (0, _objectWithoutProperties2.default)(_this$props2$ModalPro, ["BackdropProps"]),
          onOpen = _this$props2.onOpen,
          open = _this$props2.open,
          _this$props2$PaperPro = _this$props2.PaperProps,
          PaperProps = _this$props2$PaperPro === void 0 ? {} : _this$props2$PaperPro,
          swipeAreaWidth = _this$props2.swipeAreaWidth,
          variant = _this$props2.variant,
          other = (0, _objectWithoutProperties2.default)(_this$props2, ["anchor", "disableBackdropTransition", "disableDiscovery", "disableSwipeToOpen", "ModalProps", "onOpen", "open", "PaperProps", "swipeAreaWidth", "variant"]);
      var maybeSwiping = this.state.maybeSwiping;
      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Drawer.default, (0, _extends2.default)({
        open: variant === 'temporary' && maybeSwiping ? true : open,
        variant: variant,
        ModalProps: (0, _extends2.default)({
          BackdropProps: (0, _extends2.default)({}, BackdropProps, {
            ref: this.handleBackdropRef
          })
        }, ModalPropsProp),
        PaperProps: (0, _extends2.default)({}, PaperProps, {
          style: (0, _extends2.default)({
            pointerEvents: variant === 'temporary' && !open ? 'none' : ''
          }, PaperProps.style),
          ref: this.handlePaperRef
        }),
        anchor: anchor
      }, other)), !disableDiscovery && !disableSwipeToOpen && variant === 'temporary' && _react.default.createElement(_NoSsr.default, null, _react.default.createElement(_SwipeArea.default, {
        anchor: anchor,
        width: swipeAreaWidth
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (typeof prevState.maybeSwiping === 'undefined') {
        return {
          maybeSwiping: false,
          open: nextProps.open
        };
      }

      if (!nextProps.open && prevState.open) {
        return {
          maybeSwiping: false,
          open: nextProps.open
        };
      }

      return {
        open: nextProps.open
      };
    }
  }]);
  return SwipeableDrawer;
}(_react.default.Component);

SwipeableDrawer.propTypes =  false ? {
  /**
   * @ignore
   */
  anchor: _propTypes.default.oneOf(['left', 'top', 'right', 'bottom']),

  /**
   * Disable the backdrop transition.
   * This can improve the FPS on low-end devices.
   */
  disableBackdropTransition: _propTypes.default.bool,

  /**
   * If `true`, touching the screen near the edge of the drawer will not slide in the drawer a bit
   * to promote accidental discovery of the swipe gesture.
   */
  disableDiscovery: _propTypes.default.bool,

  /**
   * If `true`, swipe to open is disabled. This is useful in browsers where swiping triggers
   * navigation actions. Swipe to open is disabled on iOS browsers by default.
   */
  disableSwipeToOpen: _propTypes.default.bool,

  /**
   * @ignore
   */
  ModalProps: _propTypes.default.object,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes.default.func.isRequired,

  /**
   * Callback fired when the component requests to be opened.
   *
   * @param {object} event The event source of the callback
   */
  onOpen: _propTypes.default.func.isRequired,

  /**
   * If `true`, the drawer is open.
   */
  open: _propTypes.default.bool.isRequired,

  /**
   * @ignore
   */
  PaperProps: _propTypes.default.object,

  /**
   * The width of the left most (or right most) area in pixels where the
   * drawer can be swiped open from.
   */
  swipeAreaWidth: _propTypes.default.number,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })]),

  /**
   * @ignore
   */
  variant: _propTypes.default.oneOf(['permanent', 'persistent', 'temporary'])
} : {};
SwipeableDrawer.defaultProps = {
  anchor: 'left',
  disableBackdropTransition: false,
  disableDiscovery: false,
  disableSwipeToOpen: typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent),
  swipeAreaWidth: 20,
  transitionDuration: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  },
  variant: 'temporary' // Mobile first.

};

var _default = (0, _withTheme.default)()(SwipeableDrawer);

exports.default = _default;

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(22));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _helpers = __webpack_require__(51);

var _Drawer = __webpack_require__(325);

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'fixed',
      top: 0,
      left: 0,
      bottom: 0,
      zIndex: theme.zIndex.drawer - 1
    },
    anchorLeft: {
      right: 'auto'
    },
    anchorRight: {
      left: 'auto',
      right: 0
    },
    anchorTop: {
      bottom: 'auto',
      right: 0
    },
    anchorBottom: {
      top: 'auto',
      bottom: 0,
      right: 0
    }
  };
};
/**
 * @ignore - internal component.
 */


exports.styles = styles;

function SwipeArea(props) {
  var anchor = props.anchor,
      classes = props.classes,
      width = props.width,
      other = (0, _objectWithoutProperties2.default)(props, ["anchor", "classes", "width"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, classes["anchor".concat((0, _helpers.capitalize)(anchor))]),
    style: (0, _defineProperty2.default)({}, (0, _Drawer.isHorizontal)(props) ? 'width' : 'height', width)
  }, other));
}

SwipeArea.propTypes =  false ? {
  /**
   * Side on which to attach the discovery area.
   */
  anchor: _propTypes.default.oneOf(['left', 'top', 'right', 'bottom']).isRequired,

  /**
   * @ignore
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The width of the left most (or right most) area in pixels where the
   * drawer can be swiped open from.
   */
  width: _propTypes.default.number.isRequired
} : {};

var _default = (0, _withStyles.default)(styles)(SwipeArea);

exports.default = _default;

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _withStyles = _interopRequireDefault(__webpack_require__(17));

var _helpers = __webpack_require__(51);

var _SwitchBase = _interopRequireDefault(__webpack_require__(307));

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-flex',
      width: 62,
      position: 'relative',
      flexShrink: 0,
      // For correct alignment with the text.
      verticalAlign: 'middle'
    },

    /* Styles used to create the `icon` passed to the internal `SwitchBase` component `icon` prop. */
    icon: {
      boxShadow: theme.shadows[1],
      backgroundColor: 'currentColor',
      width: 20,
      height: 20,
      borderRadius: '50%'
    },

    /* Styles applied the icon element component if `checked={true}`. */
    iconChecked: {
      boxShadow: theme.shadows[2]
    },

    /* Styles applied to the internal `SwitchBase` component's `root` class. */
    switchBase: {
      zIndex: 1,
      color: theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[400],
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest
      })
    },

    /* Styles applied to the internal `SwitchBase` component's `checked` class. */
    checked: {
      transform: 'translateX(14px)',
      '& + $bar': {
        opacity: 0.5
      }
    },

    /* Styles applied to the internal SwitchBase component's root element if `color="primary"`. */
    colorPrimary: {
      '&$checked': {
        color: theme.palette.primary.main,
        '& + $bar': {
          backgroundColor: theme.palette.primary.main
        }
      }
    },

    /* Styles applied to the internal SwitchBase component's root element if `color="secondary"`. */
    colorSecondary: {
      '&$checked': {
        color: theme.palette.secondary.main,
        '& + $bar': {
          backgroundColor: theme.palette.secondary.main
        }
      }
    },

    /* Styles applied to the internal SwitchBase component's disabled class. */
    disabled: {
      '& + $bar': {
        opacity: theme.palette.type === 'light' ? 0.12 : 0.1
      },
      '& $icon': {
        boxShadow: theme.shadows[1]
      },
      '&$switchBase': {
        color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800],
        '& + $bar': {
          backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white
        }
      }
    },

    /* Styles applied to the bar element. */
    bar: {
      borderRadius: 14 / 2,
      display: 'block',
      position: 'absolute',
      width: 34,
      height: 14,
      top: '50%',
      left: '50%',
      marginTop: -7,
      marginLeft: -17,
      transition: theme.transitions.create(['opacity', 'background-color'], {
        duration: theme.transitions.duration.shortest
      }),
      backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white,
      opacity: theme.palette.type === 'light' ? 0.38 : 0.3
    }
  };
};

exports.styles = styles;

function Switch(props) {
  var classes = props.classes,
      className = props.className,
      color = props.color,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color"]);
  return _react.default.createElement("span", {
    className: (0, _classnames.default)(classes.root, className)
  }, _react.default.createElement(_SwitchBase.default, (0, _extends2.default)({
    type: "checkbox",
    icon: _react.default.createElement("span", {
      className: classes.icon
    }),
    classes: {
      root: (0, _classnames.default)(classes.switchBase, classes["color".concat((0, _helpers.capitalize)(color))]),
      checked: classes.checked,
      disabled: classes.disabled
    },
    checkedIcon: _react.default.createElement("span", {
      className: (0, _classnames.default)(classes.icon, classes.iconChecked)
    })
  }, other)), _react.default.createElement("span", {
    className: classes.bar
  }));
}

Switch.propTypes =  false ? {
  /**
   * If `true`, the component is checked.
   */
  checked: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(['primary', 'secondary', 'default']),

  /**
   * @ignore
   */
  defaultChecked: _propTypes.default.bool,

  /**
   * If `true`, the switch will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes.default.bool,

  /**
   * The icon to display when the component is unchecked.
   */
  icon: _propTypes.default.node,

  /**
   * The id of the `input` element.
   */
  id: _propTypes.default.string,

  /**
   * Attributes applied to the `input` element.
   */
  inputProps: _propTypes.default.object,

  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.checked`.
   * @param {boolean} checked The `checked` value of the switch
   */
  onChange: _propTypes.default.func,

  /**
   * The input component property `type`.
   */
  type: _propTypes.default.string,

  /**
   * The value of the component.
   */
  value: _propTypes.default.string
} : {};
Switch.defaultProps = {
  color: 'secondary'
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiSwitch'
})(Switch);

exports.default = _default;

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _withMobileDialog.default;
  }
});

var _withMobileDialog = _interopRequireDefault(__webpack_require__(1060));

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(144);

var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _withWidth = _interopRequireWildcard(__webpack_require__(238));

/**
 * Dialog will responsively be full screen *at or below* the given breakpoint
 * (defaults to 'sm' for mobile devices).
 * Notice that this Higher-order Component is incompatible with server side rendering.
 */
var withMobileDialog = function withMobileDialog() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (Component) {
    var _options$breakpoint = options.breakpoint,
        breakpoint = _options$breakpoint === void 0 ? 'sm' : _options$breakpoint;

    function WithMobileDialog(props) {
      return _react.default.createElement(Component, (0, _extends2.default)({
        fullScreen: (0, _withWidth.isWidthDown)(breakpoint, props.width)
      }, props));
    }

    WithMobileDialog.propTypes =  false ? {
      width: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']).isRequired
    } : {};
    return (0, _withWidth.default)()(WithMobileDialog);
  };
};

var _default = withMobileDialog;
exports.default = _default;

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Zoom.default;
  }
});

var _Zoom = _interopRequireDefault(__webpack_require__(1062));

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(4);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(11));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(14));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(27));

var _createClass2 = _interopRequireDefault(__webpack_require__(28));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));

var _getPrototypeOf3 = _interopRequireDefault(__webpack_require__(30));

var _inherits2 = _interopRequireDefault(__webpack_require__(31));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _Transition = _interopRequireDefault(__webpack_require__(101));

var _transitions = __webpack_require__(99);

var _withTheme = _interopRequireDefault(__webpack_require__(90));

var _utils = __webpack_require__(148);

// @inheritedComponent Transition
var styles = {
  entering: {
    transform: 'scale(1)'
  },
  entered: {
    transform: 'scale(1)'
  }
};
/**
 * The Zoom transition can be used for the floating variant of the
 * [Button](https://material-ui.com/demos/buttons/#floating-action-buttons) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Zoom =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Zoom, _React$Component);

  function Zoom() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Zoom);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Zoom)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleEnter = function (node) {
      var theme = _this.props.theme;
      (0, _utils.reflow)(node); // So the animation always start from the start.

      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'enter'
      });
      node.style.webkitTransition = theme.transitions.create('transform', transitionProps);
      node.style.transition = theme.transitions.create('transform', transitionProps);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    };

    _this.handleExit = function (node) {
      var theme = _this.props.theme;
      var transitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'exit'
      });
      node.style.webkitTransition = theme.transitions.create('transform', transitionProps);
      node.style.transition = theme.transitions.create('transform', transitionProps);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(Zoom, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          onEnter = _this$props.onEnter,
          onExit = _this$props.onExit,
          styleProp = _this$props.style,
          theme = _this$props.theme,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["children", "onEnter", "onExit", "style", "theme"]);
      var style = (0, _extends2.default)({}, styleProp, _react.default.isValidElement(children) ? children.props.style : {});
      return _react.default.createElement(_Transition.default, (0, _extends2.default)({
        appear: true,
        onEnter: this.handleEnter,
        onExit: this.handleExit
      }, other), function (state, childProps) {
        return _react.default.cloneElement(children, (0, _extends2.default)({
          style: (0, _extends2.default)({
            transform: 'scale(0)',
            willChange: 'transform'
          }, styles[state], style)
        }, childProps));
      });
    }
  }]);
  return Zoom;
}(_react.default.Component);

Zoom.propTypes =  false ? {
  /**
   * A single child content element.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),

  /**
   * If `true`, the component will transition in.
   */
  in: _propTypes.default.bool,

  /**
   * @ignore
   */
  onEnter: _propTypes.default.func,

  /**
   * @ignore
   */
  onExit: _propTypes.default.func,

  /**
   * @ignore
   */
  style: _propTypes.default.object,

  /**
   * @ignore
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  })])
} : {};
Zoom.defaultProps = {
  timeout: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  }
};

var _default = (0, _withTheme.default)()(Zoom);

exports.default = _default;

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(0),__webpack_require__(64)):"function"==typeof define&&define.amd?define("lib",["react","react-dom"],t):"object"==typeof exports?exports.lib=t(require("react"),require("react-dom")):e.lib=t(e.react,e["react-dom"])}("undefined"!=typeof self?self:this,(function(e,t){return function(){"use strict";var n={655:function(e,t,n){n.r(t),n.d(t,{__extends:function(){return o},__assign:function(){return i},__rest:function(){return a},__decorate:function(){return l},__param:function(){return c},__metadata:function(){return u},__awaiter:function(){return s},__generator:function(){return f},__createBinding:function(){return d},__exportStar:function(){return p},__values:function(){return h},__read:function(){return y},__spread:function(){return b},__spreadArrays:function(){return g},__spreadArray:function(){return m},__await:function(){return v},__asyncGenerator:function(){return w},__asyncDelegator:function(){return _},__asyncValues:function(){return P},__makeTemplateObject:function(){return O},__importStar:function(){return x},__importDefault:function(){return E},__classPrivateFieldGet:function(){return T},__classPrivateFieldSet:function(){return j},__classPrivateFieldIn:function(){return A}});var r=function(e,t){return r=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n])},r(e,t)};function o(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Class extends value "+String(t)+" is not a constructor or null");function n(){this.constructor=e}r(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)}var i=function(){return i=Object.assign||function(e){for(var t,n=1,r=arguments.length;n<r;n++)for(var o in t=arguments[n])Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o]);return e},i.apply(this,arguments)};function a(e,t){var n={};for(var r in e)Object.prototype.hasOwnProperty.call(e,r)&&t.indexOf(r)<0&&(n[r]=e[r]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var o=0;for(r=Object.getOwnPropertySymbols(e);o<r.length;o++)t.indexOf(r[o])<0&&Object.prototype.propertyIsEnumerable.call(e,r[o])&&(n[r[o]]=e[r[o]])}return n}function l(e,t,n,r){var o,i=arguments.length,a=i<3?t:null===r?r=Object.getOwnPropertyDescriptor(t,n):r;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)a=Reflect.decorate(e,t,n,r);else for(var l=e.length-1;l>=0;l--)(o=e[l])&&(a=(i<3?o(a):i>3?o(t,n,a):o(t,n))||a);return i>3&&a&&Object.defineProperty(t,n,a),a}function c(e,t){return function(n,r){t(n,r,e)}}function u(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)}function s(e,t,n,r){return new(n||(n=Promise))((function(o,i){function a(e){try{c(r.next(e))}catch(e){i(e)}}function l(e){try{c(r.throw(e))}catch(e){i(e)}}function c(e){var t;e.done?o(e.value):(t=e.value,t instanceof n?t:new n((function(e){e(t)}))).then(a,l)}c((r=r.apply(e,t||[])).next())}))}function f(e,t){var n,r,o,i,a={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:l(0),throw:l(1),return:l(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function l(l){return function(c){return function(l){if(n)throw new TypeError("Generator is already executing.");for(;i&&(i=0,l[0]&&(a=0)),a;)try{if(n=1,r&&(o=2&l[0]?r.return:l[0]?r.throw||((o=r.return)&&o.call(r),0):r.next)&&!(o=o.call(r,l[1])).done)return o;switch(r=0,o&&(l=[2&l[0],o.value]),l[0]){case 0:case 1:o=l;break;case 4:return a.label++,{value:l[1],done:!1};case 5:a.label++,r=l[1],l=[0];continue;case 7:l=a.ops.pop(),a.trys.pop();continue;default:if(!((o=(o=a.trys).length>0&&o[o.length-1])||6!==l[0]&&2!==l[0])){a=0;continue}if(3===l[0]&&(!o||l[1]>o[0]&&l[1]<o[3])){a.label=l[1];break}if(6===l[0]&&a.label<o[1]){a.label=o[1],o=l;break}if(o&&a.label<o[2]){a.label=o[2],a.ops.push(l);break}o[2]&&a.ops.pop(),a.trys.pop();continue}l=t.call(e,a)}catch(e){l=[6,e],r=0}finally{n=o=0}if(5&l[0])throw l[1];return{value:l[0]?l[1]:void 0,done:!0}}([l,c])}}}var d=Object.create?function(e,t,n,r){void 0===r&&(r=n);var o=Object.getOwnPropertyDescriptor(t,n);o&&!("get"in o?!t.__esModule:o.writable||o.configurable)||(o={enumerable:!0,get:function(){return t[n]}}),Object.defineProperty(e,r,o)}:function(e,t,n,r){void 0===r&&(r=n),e[r]=t[n]};function p(e,t){for(var n in e)"default"===n||Object.prototype.hasOwnProperty.call(t,n)||d(t,e,n)}function h(e){var t="function"==typeof Symbol&&Symbol.iterator,n=t&&e[t],r=0;if(n)return n.call(e);if(e&&"number"==typeof e.length)return{next:function(){return e&&r>=e.length&&(e=void 0),{value:e&&e[r++],done:!e}}};throw new TypeError(t?"Object is not iterable.":"Symbol.iterator is not defined.")}function y(e,t){var n="function"==typeof Symbol&&e[Symbol.iterator];if(!n)return e;var r,o,i=n.call(e),a=[];try{for(;(void 0===t||t-- >0)&&!(r=i.next()).done;)a.push(r.value)}catch(e){o={error:e}}finally{try{r&&!r.done&&(n=i.return)&&n.call(i)}finally{if(o)throw o.error}}return a}function b(){for(var e=[],t=0;t<arguments.length;t++)e=e.concat(y(arguments[t]));return e}function g(){for(var e=0,t=0,n=arguments.length;t<n;t++)e+=arguments[t].length;var r=Array(e),o=0;for(t=0;t<n;t++)for(var i=arguments[t],a=0,l=i.length;a<l;a++,o++)r[o]=i[a];return r}function m(e,t,n){if(n||2===arguments.length)for(var r,o=0,i=t.length;o<i;o++)!r&&o in t||(r||(r=Array.prototype.slice.call(t,0,o)),r[o]=t[o]);return e.concat(r||Array.prototype.slice.call(t))}function v(e){return this instanceof v?(this.v=e,this):new v(e)}function w(e,t,n){if(!Symbol.asyncIterator)throw new TypeError("Symbol.asyncIterator is not defined.");var r,o=n.apply(e,t||[]),i=[];return r={},a("next"),a("throw"),a("return"),r[Symbol.asyncIterator]=function(){return this},r;function a(e){o[e]&&(r[e]=function(t){return new Promise((function(n,r){i.push([e,t,n,r])>1||l(e,t)}))})}function l(e,t){try{(n=o[e](t)).value instanceof v?Promise.resolve(n.value.v).then(c,u):s(i[0][2],n)}catch(e){s(i[0][3],e)}var n}function c(e){l("next",e)}function u(e){l("throw",e)}function s(e,t){e(t),i.shift(),i.length&&l(i[0][0],i[0][1])}}function _(e){var t,n;return t={},r("next"),r("throw",(function(e){throw e})),r("return"),t[Symbol.iterator]=function(){return this},t;function r(r,o){t[r]=e[r]?function(t){return(n=!n)?{value:v(e[r](t)),done:"return"===r}:o?o(t):t}:o}}function P(e){if(!Symbol.asyncIterator)throw new TypeError("Symbol.asyncIterator is not defined.");var t,n=e[Symbol.asyncIterator];return n?n.call(e):(e=h(e),t={},r("next"),r("throw"),r("return"),t[Symbol.asyncIterator]=function(){return this},t);function r(n){t[n]=e[n]&&function(t){return new Promise((function(r,o){!function(e,t,n,r){Promise.resolve(r).then((function(t){e({value:t,done:n})}),t)}(r,o,(t=e[n](t)).done,t.value)}))}}}function O(e,t){return Object.defineProperty?Object.defineProperty(e,"raw",{value:t}):e.raw=t,e}var S=Object.create?function(e,t){Object.defineProperty(e,"default",{enumerable:!0,value:t})}:function(e,t){e.default=t};function x(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)"default"!==n&&Object.prototype.hasOwnProperty.call(e,n)&&d(t,e,n);return S(t,e),t}function E(e){return e&&e.__esModule?e:{default:e}}function T(e,t,n,r){if("a"===n&&!r)throw new TypeError("Private accessor was defined without a getter");if("function"==typeof t?e!==t||!r:!t.has(e))throw new TypeError("Cannot read private member from an object whose class did not declare it");return"m"===n?r:"a"===n?r.call(e):r?r.value:t.get(e)}function j(e,t,n,r,o){if("m"===r)throw new TypeError("Private method is not writable");if("a"===r&&!o)throw new TypeError("Private accessor was defined without a setter");if("function"==typeof t?e!==t||!o:!t.has(e))throw new TypeError("Cannot write private member to an object whose class did not declare it");return"a"===r?o.call(e,n):o?o.value=n:t.set(e,n),n}function A(e,t){if(null===t||"object"!=typeof t&&"function"!=typeof t)throw new TypeError("Cannot use 'in' operator on non-object");return"function"==typeof e?t===e:e.has(t)}},156:function(t){t.exports=e},111:function(e){e.exports=t}},r={};function o(e){var t=r[e];if(void 0!==t)return t.exports;var i=r[e]={exports:{}};return n[e](i,i.exports,o),i.exports}o.d=function(e,t){for(var n in t)o.o(t,n)&&!o.o(e,n)&&Object.defineProperty(e,n,{enumerable:!0,get:t[n]})},o.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},o.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})};var i={};return function(){var e=i;Object.defineProperty(e,"__esModule",{value:!0}),e.useReactToPrint=e.PrintContextConsumer=void 0;var t=o(655),n=o(156),r=o(111),a=Object.prototype.hasOwnProperty.call(n,"createContext"),l=Object.prototype.hasOwnProperty.call(n,"useMemo")&&Object.prototype.hasOwnProperty.call(n,"useCallback"),c=a?n.createContext({}):null;e.PrintContextConsumer=c?c.Consumer:function(){return null};var u={copyStyles:!0,pageStyle:"@page { size: auto;  margin: 0mm; } @media print { body { -webkit-print-color-adjust: exact; } }",removeAfterPrint:!1,suppressErrors:!1},s=function(e){function o(){var n=null!==e&&e.apply(this,arguments)||this;return n.startPrint=function(e){var t=n.props,r=t.onAfterPrint,o=t.onPrintError,i=t.print,a=t.documentTitle;setTimeout((function(){var t,l;if(e.contentWindow){if(e.contentWindow.focus(),i)i(e).then(n.handleRemoveIframe).catch((function(e){o?o("print",e):n.logMessages(["An error was thrown by the specified `print` function"])}));else if(e.contentWindow.print){var c=null!==(l=null===(t=e.contentDocument)||void 0===t?void 0:t.title)&&void 0!==l?l:"",u=e.ownerDocument.title;a&&(e.ownerDocument.title=a,e.contentDocument&&(e.contentDocument.title=a)),e.contentWindow.print(),a&&(e.ownerDocument.title=u,e.contentDocument&&(e.contentDocument.title=c))}else n.logMessages(["Printing for this browser is not currently possible: the browser does not have a `print` method available for iframes."]);r&&r(),n.handleRemoveIframe()}else n.logMessages(["Printing failed because the `contentWindow` of the print iframe did not load. This is possibly an error with `react-to-print`. Please file an issue: https://github.com/gregnb/react-to-print/issues/"])}),500)},n.triggerPrint=function(e){var t=n.props,r=t.onBeforePrint,o=t.onPrintError;if(r){var i=r();i&&"function"==typeof i.then?i.then((function(){n.startPrint(e)})).catch((function(e){o&&o("onBeforePrint",e)})):n.startPrint(e)}else n.startPrint(e)},n.handleClick=function(){var e=n.props,t=e.onBeforeGetContent,r=e.onPrintError;if(t){var o=t();o&&"function"==typeof o.then?o.then(n.handlePrint).catch((function(e){r&&r("onBeforeGetContent",e)})):n.handlePrint()}else n.handlePrint()},n.handlePrint=function(){var e=n.props,o=e.bodyClass,i=e.content,a=e.copyStyles,l=e.fonts,c=e.pageStyle,u=e.nonce,s=i();if(void 0!==s)if(null!==s){var f=document.createElement("iframe");f.width="".concat(document.documentElement.clientWidth,"px"),f.height="".concat(document.documentElement.clientHeight,"px"),f.style.position="absolute",f.style.top="-".concat(document.documentElement.clientHeight+100,"px"),f.style.left="-".concat(document.documentElement.clientWidth+100,"px"),f.id="printWindow",f.srcdoc="<!DOCTYPE html>";var d=(0,r.findDOMNode)(s);if(d){var p=d.cloneNode(!0),h=p instanceof Text,y=document.querySelectorAll("link[rel='stylesheet']"),b=h?[]:p.querySelectorAll("img"),g=h?[]:p.querySelectorAll("video");n.linkTotal=y.length+b.length+g.length,n.linksLoaded=[],n.linksErrored=[],n.fontsLoaded=[],n.fontsErrored=[];var m=function(e,t){t?n.linksLoaded.push(e):(n.logMessages(['"react-to-print" was unable to load a linked node. It may be invalid. "react-to-print" will continue attempting to print the page. The linked node that errored was:',e]),n.linksErrored.push(e)),n.linksLoaded.length+n.linksErrored.length+n.fontsLoaded.length+n.fontsErrored.length===n.linkTotal&&n.triggerPrint(f)};f.onload=function(){var e,r,i,s;f.onload=null;var y=f.contentDocument||(null===(r=f.contentWindow)||void 0===r?void 0:r.document);if(y){y.body.appendChild(p),l&&((null===(i=f.contentDocument)||void 0===i?void 0:i.fonts)&&(null===(s=f.contentWindow)||void 0===s?void 0:s.FontFace)?l.forEach((function(e){var t=new FontFace(e.family,e.source);f.contentDocument.fonts.add(t),t.loaded.then((function(e){n.fontsLoaded.push(e)})).catch((function(e){n.fontsErrored.push(t),n.logMessages(['"react-to-print" was unable to load a font. "react-to-print" will continue attempting to print the page. The font that failed to load is:',t,"The error from loading the font is:",e])}))})):n.logMessages(['"react-to-print" is not able to load custom fonts because the browser does not support the FontFace API']));var v="function"==typeof c?c():c;if("string"!=typeof v)n.logMessages(['"react-to-print" expected a "string" from `pageStyle` but received "'.concat(typeof v,'". Styles from `pageStyle` will not be applied.')]);else{var w=y.createElement("style");u&&(w.setAttribute("nonce",u),y.head.setAttribute("nonce",u)),w.appendChild(y.createTextNode(v)),y.head.appendChild(w)}if(o&&(e=y.body.classList).add.apply(e,(0,t.__spreadArray)([],(0,t.__read)(o.split(" ")),!1)),!h){for(var _=h?[]:d.querySelectorAll("canvas"),P=y.querySelectorAll("canvas"),O=0;O<_.length;++O){var S=_[O],x=P[O].getContext("2d");x&&x.drawImage(S,0,0)}for(O=0;O<b.length;O++){var E=b[O],T=E.getAttribute("src");T?((A=new Image).onload=m.bind(null,E,!0),A.onerror=m.bind(null,E,!1),A.src=T):(n.logMessages(['"react-to-print" encountered an <img> tag with an empty "src" attribute. It will not attempt to pre-load it. The <img> is:',E],"warning"),m(E,!1))}for(O=0;O<g.length;O++){var j=g[O];j.preload="auto";var A,k=j.getAttribute("poster");k?((A=new Image).onload=m.bind(null,j,!0),A.onerror=m.bind(null,j,!1),A.src=k):j.readyState>=2?m(j,!0):(j.onloadeddata=m.bind(null,j,!0),j.onerror=m.bind(null,j,!1),j.onstalled=m.bind(null,j,!1))}var C="input",M=d.querySelectorAll(C),R=y.querySelectorAll(C);for(O=0;O<M.length;O++)R[O].value=M[O].value;var I="input[type=checkbox],input[type=radio]",q=d.querySelectorAll(I),D=y.querySelectorAll(I);for(O=0;O<q.length;O++)D[O].checked=q[O].checked;var W="select",L=d.querySelectorAll(W),F=y.querySelectorAll(W);for(O=0;O<L.length;O++)F[O].value=L[O].value}if(a)for(var N=document.querySelectorAll("style, link[rel='stylesheet']"),B=(O=0,N.length);O<B;++O){var G=N[O];if("style"===G.tagName.toLowerCase()){var H=y.createElement(G.tagName),Y=G.sheet;if(Y){var z="";try{for(var V=Y.cssRules.length,U=0;U<V;++U)"string"==typeof Y.cssRules[U].cssText&&(z+="".concat(Y.cssRules[U].cssText,"\r\n"))}catch(e){n.logMessages(["A stylesheet could not be accessed. This is likely due to the stylesheet having cross-origin imports, and many browsers block script access to cross-origin stylesheets. See https://github.com/gregnb/react-to-print/issues/429 for details. You may be able to load the sheet by both marking the stylesheet with the cross `crossorigin` attribute, and setting the `Access-Control-Allow-Origin` header on the server serving the stylesheet. Alternatively, host the stylesheet on your domain to avoid this issue entirely.",G],"warning")}H.setAttribute("id","react-to-print-".concat(O)),u&&H.setAttribute("nonce",u),H.appendChild(y.createTextNode(z)),y.head.appendChild(H)}}else if(G.getAttribute("href"))if(G.hasAttribute("disabled"))n.logMessages(["`react-to-print` encountered a <link> tag with a `disabled` attribute and will ignore it. Note that the `disabled` attribute is deprecated, and some browsers ignore it. You should stop using it. https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link#attr-disabled. The <link> is:",G],"warning"),m(G,!0);else{H=y.createElement(G.tagName),U=0;for(var J=G.attributes.length;U<J;++U){var K=G.attributes[U];K&&H.setAttribute(K.nodeName,K.nodeValue||"")}H.onload=m.bind(null,H,!0),H.onerror=m.bind(null,H,!1),u&&H.setAttribute("nonce",u),y.head.appendChild(H)}else n.logMessages(["`react-to-print` encountered a <link> tag with an empty `href` attribute. In addition to being invalid HTML, this can cause problems in many browsers, and so the <link> was not loaded. The <link> is:",G],"warning"),m(G,!0)}}0!==n.linkTotal&&a||n.triggerPrint(f)},n.handleRemoveIframe(!0),document.body.appendChild(f)}else n.logMessages(['"react-to-print" could not locate the DOM node corresponding with the `content` prop'])}else n.logMessages(['There is nothing to print because the "content" prop returned "null". Please ensure "content" is renderable before allowing "react-to-print" to be called.']);else n.logMessages(["To print a functional component ensure it is wrapped with `React.forwardRef`, and ensure the forwarded ref is used. See the README for an example: https://github.com/gregnb/react-to-print#examples"])},n.handleRemoveIframe=function(e){var t=n.props.removeAfterPrint;if(e||t){var r=document.getElementById("printWindow");r&&document.body.removeChild(r)}},n.logMessages=function(e,t){void 0===t&&(t="error"),n.props.suppressErrors||("error"===t?console.error(e):"warning"===t?console.warn(e):"debug"===t&&console.debug(e))},n}return(0,t.__extends)(o,e),o.prototype.render=function(){var e=this.props,t=e.children,r=e.trigger;if(r)return n.cloneElement(r(),{onClick:this.handleClick});if(!c)return this.logMessages(['"react-to-print" requires React ^16.3.0 to be able to use "PrintContext"']),null;var o={handlePrint:this.handleClick};return n.createElement(c.Provider,{value:o},t)},o.defaultProps=u,o}(n.Component);e.default=s,e.useReactToPrint=function(e){if(!l)return e.suppressErrors||console.error('"react-to-print" requires React ^16.8.0 to be able to use "useReactToPrint"'),function(){throw new Error('"react-to-print" requires React ^16.8.0 to be able to use "useReactToPrint"')};var r=n.useMemo((function(){return new s((0,t.__assign)((0,t.__assign)({},u),e))}),[e]);return n.useCallback((function(){return r.handleClick()}),[r])}}(),i}()}));

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(77);
var bind = __webpack_require__(520);
var Axios = __webpack_require__(1065);
var mergeConfig = __webpack_require__(526);
var defaults = __webpack_require__(328);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(527);
axios.CancelToken = __webpack_require__(1079);
axios.isCancel = __webpack_require__(525);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(1080);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(1081);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(77);
var buildURL = __webpack_require__(521);
var InterceptorManager = __webpack_require__(1066);
var dispatchRequest = __webpack_require__(1067);
var mergeConfig = __webpack_require__(526);
var validator = __webpack_require__(1077);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      forcedJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      clarifyTimeoutError: validators.transitional(validators.boolean, '1.0.0')
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(77);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(77);
var transformData = __webpack_require__(1068);
var isCancel = __webpack_require__(525);
var defaults = __webpack_require__(328);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(77);
var defaults = __webpack_require__(328);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(77);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(524);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(77);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(1073);
var combineURLs = __webpack_require__(1074);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(77);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(77);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var pkg = __webpack_require__(1078);

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};
var currentVerArr = pkg.version.split('.');

/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */
function isOlderVersion(version, thanVersion) {
  var pkgVersionArr = thanVersion ? thanVersion.split('.') : currentVerArr;
  var destVer = version.split('.');
  for (var i = 0; i < 3; i++) {
    if (pkgVersionArr[i] > destVer[i]) {
      return true;
    } else if (pkgVersionArr[i] < destVer[i]) {
      return false;
    }
  }
  return false;
}

/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  var isDeprecated = version && isOlderVersion(version);

  function formatMessage(opt, desc) {
    return '[Axios v' + pkg.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed in ' + version));
    }

    if (isDeprecated && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

module.exports = {
  isOlderVersion: isOlderVersion,
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),
/* 1078 */
/***/ (function(module, exports) {

module.exports = {"name":"axios","version":"0.21.4","description":"Promise based HTTP client for the browser and node.js","main":"index.js","scripts":{"test":"grunt test","start":"node ./sandbox/server.js","build":"NODE_ENV=production grunt build","preversion":"npm test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json","postversion":"git push && git push --tags","examples":"node ./examples/server.js","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","fix":"eslint --fix lib/**/*.js"},"repository":{"type":"git","url":"https://github.com/axios/axios.git"},"keywords":["xhr","http","ajax","promise","node"],"author":"Matt Zabriskie","license":"MIT","bugs":{"url":"https://github.com/axios/axios/issues"},"homepage":"https://axios-http.com","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"jsdelivr":"dist/axios.min.js","unpkg":"dist/axios.min.js","typings":"./index.d.ts","dependencies":{"follow-redirects":"^1.14.0"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}]}

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(527);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};


/***/ }),
/* 1082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_IconButton__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Snackbar__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Snackbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Close__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Close__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SharedSnackbar_context__ = __webpack_require__(329);
var SharedSnackbar=function SharedSnackbar(){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__SharedSnackbar_context__["a" /* SharedSnackbarConsumer */],null,function(_ref){var snackbarIsOpen=_ref.snackbarIsOpen,message=_ref.message,closeSnackbar=_ref.closeSnackbar,duration=_ref.duration,verticalPosition=_ref.verticalPosition,horizontalPosition=_ref.horizontalPosition,autoHide=_ref.autoHide;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Snackbar___default.a,{anchorOrigin:{vertical:verticalPosition,horizontal:horizontalPosition},open:snackbarIsOpen,autoHideDuration:autoHide?duration:undefined,onClose:closeSnackbar,message:message,action:[__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_IconButton___default.a,{key:'close',color:'inherit',onClick:closeSnackbar},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Close___default.a,null))]});});};/* harmony default export */ __webpack_exports__["a"] = (SharedSnackbar);

/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Paper__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Paper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Modules_customer_autocomplete__ = __webpack_require__(1084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Table__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_TableBody__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_TableBody___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TableBody__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_TableCell__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_TableCell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_TableCell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_TableRow__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_TableRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_TableRow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Modules_device_select__ = __webpack_require__(1086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Modules_accessory_select__ = __webpack_require__(1087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Modules_sim_select__ = __webpack_require__(1088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_List__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core_ListItem__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core_ListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_ListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_core_ListItemText__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_core_ListItemText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_ListItemText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Modules_device_accessory_list__ = __webpack_require__(1089);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var style=function style(theme){return{root:{padding:theme.spacing.unit*2,flexGrow:1},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary}};};var InventoryOutward=function(_React$Component){_inherits(InventoryOutward,_React$Component);function InventoryOutward(props){_classCallCheck(this,InventoryOutward);var _this=_possibleConstructorReturn(this,(InventoryOutward.__proto__||Object.getPrototypeOf(InventoryOutward)).call(this,props));_this.openDeviceAccessoryList=function(e){console.log('DialogOpen');_this.setState({open:true});};_this.closeDeviceAccessoryList=function(e){console.log('DialogOpen');_this.setState({open:false});};_this.classes=props;_this.state={open:false};return _this;}_createClass(InventoryOutward,[{key:'render',value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'title',gutterBottom:true},'Assign Inventory')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Modules_customer_autocomplete__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Paper___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.classes.demo},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_List___default.a,{dense:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_ListItem___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_ListItemText___default.a,{primary:'Address Line 1'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_ListItem___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_ListItemText___default.a,{primary:'Address Line 2'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_ListItem___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_ListItemText___default.a,{primary:'City'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_ListItem___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_ListItemText___default.a,{primary:'PIN Code'})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Paper___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Table___default.a,{className:this.classes.table},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TableBody___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_TableRow___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_TableCell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading',gutterBottom:true},'Total Devices')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_TableCell___default.a,{numeric:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'title',gutterBottom:true},'121'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_TableRow___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_TableCell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading',gutterBottom:true},'Registered Devices')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_TableCell___default.a,{numeric:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'title',gutterBottom:true},'85'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_TableRow___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_TableCell___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading',gutterBottom:true},'Unregistered Devices')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_TableCell___default.a,{numeric:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'title',gutterBottom:true},'36'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading',color:'textSecondary',gutterBottom:true},'Devices')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Modules_device_select__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'number',type:'number',placeholder:'Quantity',className:this.classes.textField,InputLabelProps:{shrink:true}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{variant:'contained',color:'secondary',className:this.classes.button,fullWidth:true,onClick:this.openDeviceAccessoryList},'Choose Sl No')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{className:this.classes.button,margin:'normal'},'+'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading',color:'textSecondary',gutterBottom:true},'Accessories')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Divider___default.a,{inset:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Modules_accessory_select__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'number',type:'number',placeholder:'Quantity',className:this.classes.textField,InputLabelProps:{shrink:true}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{variant:'contained',color:'secondary',onClick:this.openDeviceAccessoryList,className:this.classes.button,fullWidth:true},'Choose Sl No')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{className:this.classes.button,margin:'normal'},'+'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading',color:'textSecondary',gutterBottom:true},'SIM Cards')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Divider___default.a,{inset:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Modules_sim_select__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'number',type:'number',placeholder:'Quantity',className:this.classes.textField,InputLabelProps:{shrink:true}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{variant:'contained',color:'secondary',onClick:this.openDeviceAccessoryList,className:this.classes.button,fullWidth:true},'Choose SIM No')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{className:this.classes.button,margin:'normal'},'+'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,xs:12,alignItems:'stretch'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{variant:'extendedFab','aria-label':'Delete',className:this.classes.button,color:'primary'},'Assign')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{variant:'extendedFab','aria-label':'Delete',className:this.classes.button},'Reset')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__Modules_device_accessory_list__["a" /* default */],{open:this.state.open,onClose:this.closeDeviceAccessoryList})));}}]);return InventoryOutward;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);InventoryOutward.propTypes={classes:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles__["withStyles"])(style)(InventoryOutward));

/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_NoSsr__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_NoSsr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_NoSsr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Chip__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Chip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Chip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles_colorManipulator__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles_colorManipulator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles_colorManipulator__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var suggestions=[{label:'Ola'},{label:'Uber'},{label:'GVK EMRI'},{label:'Infosys'},{label:'Wicked Ride'},{label:'Utoo Cabs'},{label:'Intertrans'}].map(function(suggestion){return{value:suggestion.label,label:suggestion.label};});var styles=function styles(theme){return{root:{flexGrow:1//  height: 250
},input:{display:'flex',padding:0},valueContainer:{display:'flex',flex:1,alignItems:'center'},chip:{margin:theme.spacing.unit/2+'px '+theme.spacing.unit/4+'px'},chipFocused:{backgroundColor:Object(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles_colorManipulator__["emphasize"])(theme.palette.type==='light'?theme.palette.grey[300]:theme.palette.grey[700],0.08)},noOptionsMessage:{fontSize:16,padding:theme.spacing.unit+'px '+theme.spacing.unit*2+'px'},singleValue:{fontSize:16},placeholder:{position:'absolute',left:2,fontSize:16}};};function NoOptionsMessage(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,Object.assign({color:'textSecondary',className:props.selectProps.classes.noOptionsMessage},props.innerProps),props.children);}function inputComponent(_ref){var inputRef=_ref.inputRef,props=_objectWithoutProperties(_ref,['inputRef']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({ref:inputRef},props));}function Control(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a,{fullWidth:true,InputProps:{inputComponent:inputComponent,inputProps:Object.assign({className:props.selectProps.classes.input,ref:props.innerRef,children:props.children},props.innerProps)}});}function Option(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default.a,Object.assign({buttonRef:props.innerRef,selected:props.isFocused,component:'div',style:{fontWeight:props.isSelected?500:400}},props.innerProps),props.children);}function Placeholder(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,Object.assign({color:'textSecondary',className:props.selectProps.classes.placeholder},props.innerProps),props.children);}function SingleValue(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,Object.assign({className:props.selectProps.classes.singleValue},props.innerProps),props.children);}function ValueContainer(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:props.selectProps.classes.valueContainer},props.children);}function MultiValue(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Chip___default.a,{tabIndex:-1,label:props.children,className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(props.selectProps.classes.chip,_defineProperty({},props.selectProps.classes.chipFocused,props.isFocused)),onDelete:function onDelete(event){props.removeProps.onClick();props.removeProps.onMouseDown(event);}});}var components={Option:Option,Control:Control,NoOptionsMessage:NoOptionsMessage,Placeholder:Placeholder,SingleValue:SingleValue,MultiValue:MultiValue,ValueContainer:ValueContainer};var CustomerAutocomplete=function(_React$Component){_inherits(CustomerAutocomplete,_React$Component);function CustomerAutocomplete(){var _ref2;var _temp,_this,_ret;_classCallCheck(this,CustomerAutocomplete);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref2=CustomerAutocomplete.__proto__||Object.getPrototypeOf(CustomerAutocomplete)).call.apply(_ref2,[this].concat(args))),_this),_this.state={single:null,multi:null},_this.handleChange=function(name){return function(value){_this.setState(_defineProperty({},name,value));};},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CustomerAutocomplete,[{key:'render',value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_NoSsr___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{classes:classes,options:suggestions,components:components,value:this.state.single,onChange:this.handleChange('single'),placeholder:'Customer Name'})));}}]);return CustomerAutocomplete;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);CustomerAutocomplete.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__["withStyles"])(styles)(CustomerAutocomplete));

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];

var cleanInputProps = function cleanInputProps(inputProps) {
	INPUT_PROPS_BLACKLIST.forEach(function (field) {
		return delete inputProps[field];
	});
	return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
	node.style.fontSize = styles.fontSize;
	node.style.fontFamily = styles.fontFamily;
	node.style.fontWeight = styles.fontWeight;
	node.style.fontStyle = styles.fontStyle;
	node.style.letterSpacing = styles.letterSpacing;
	node.style.textTransform = styles.textTransform;
};

var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;

var generateId = function generateId() {
	// we only need an auto-generated ID for stylesheet injection, which is only
	// used for IE. so if the browser is not IE, this should return undefined.
	return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: props.id || generateId()
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'UNSAFE_componentWillReceiveProps',
		value: function UNSAFE_componentWillReceiveProps(nextProps) {
			var id = nextProps.id;

			if (id !== this.props.id) {
				this.setState({ inputId: id || generateId() });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyles = this.input && window.getComputedStyle(this.input);
			if (!inputStyles) {
				return;
			}
			copyStyles(inputStyles, this.sizer);
			if (this.placeHolderSizer) {
				copyStyles(inputStyles, this.placeHolderSizer);
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
			var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
			newInputWidth += extraWidth;
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'renderStyles',
		value: function renderStyles() {
			// this method injects styles to hide IE's clear indicator, which messes
			// with input size detection. the stylesheet is only injected when the
			// browser is IE, and can also be disabled by the `injectStyles` prop.
			var injectStyles = this.props.injectStyles;

			return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
					__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
				} }) : null;
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';

			var inputStyle = _extends({
				boxSizing: 'content-box',
				width: this.state.inputWidth + 'px'
			}, this.props.inputStyle);

			var inputProps = _objectWithoutProperties(this.props, []);

			cleanInputProps(inputProps);
			inputProps.className = this.props.inputClassName;
			inputProps.id = this.state.inputId;
			inputProps.style = inputStyle;

			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				this.renderStyles(),
				_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(_react.Component);

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	extraWidth: _propTypes2.default.oneOfType([// additional width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
	injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(event) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1,
	injectStyles: true
};

exports.default = AutosizeInput;

/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Select__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles=function styles(theme){return{formControl:{margin:theme.spacing.unit}};};var DeviceSelect=function(_React$Component){_inherits(DeviceSelect,_React$Component);function DeviceSelect(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DeviceSelect);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DeviceSelect.__proto__||Object.getPrototypeOf(DeviceSelect)).call.apply(_ref,[this].concat(args))),_this),_this.state={age:'',open:false},_this.handleChange=function(event){_this.setState(_defineProperty({},event.target.name,event.target.value));},_this.handleClose=function(){_this.setState({open:false});},_this.handleOpen=function(){_this.setState({open:true});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DeviceSelect,[{key:'render',value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{autoComplete:'on'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:classes.formControl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Select___default.a,{value:this.state.age,onChange:this.handleChange,displayEmpty:true,name:'age',fullWidth:true,className:classes.selectEmpty},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'Select Device Type')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_MenuItem___default.a,{value:10},'TS101 Basic'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_MenuItem___default.a,{value:20},'S101 '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_MenuItem___default.a,{value:30},'Bharat 101'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_MenuItem___default.a,{value:30},'TS101 Advanced'))));}}]);return DeviceSelect;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);DeviceSelect.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__["withStyles"])(styles)(DeviceSelect));

/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Select__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles=function styles(theme){return{formControl:{margin:theme.spacing.unit}};};var AccessorySelect=function(_React$Component){_inherits(AccessorySelect,_React$Component);function AccessorySelect(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AccessorySelect);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AccessorySelect.__proto__||Object.getPrototypeOf(AccessorySelect)).call.apply(_ref,[this].concat(args))),_this),_this.state={age:'',open:false},_this.handleChange=function(event){_this.setState(_defineProperty({},event.target.name,event.target.value));},_this.handleClose=function(){_this.setState({open:false});},_this.handleOpen=function(){_this.setState({open:true});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AccessorySelect,[{key:'render',value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{autoComplete:'on'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:classes.formControl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Select___default.a,{value:this.state.age,onChange:this.handleChange,displayEmpty:true,name:'age',className:classes.selectEmpty},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'Select Accessory Type')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_MenuItem___default.a,{value:10},'Fuel Probe'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_MenuItem___default.a,{value:20},'Panic Button'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_MenuItem___default.a,{value:30},'Immobilizer'))));}}]);return AccessorySelect;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);AccessorySelect.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__["withStyles"])(styles)(AccessorySelect));

/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Select__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles=function styles(theme){return{formControl:{margin:theme.spacing.unit}};};var SIMSelect=function(_React$Component){_inherits(SIMSelect,_React$Component);function SIMSelect(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SIMSelect);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SIMSelect.__proto__||Object.getPrototypeOf(SIMSelect)).call.apply(_ref,[this].concat(args))),_this),_this.state={age:'',open:false},_this.handleChange=function(event){_this.setState(_defineProperty({},event.target.name,event.target.value));},_this.handleClose=function(){_this.setState({open:false});},_this.handleOpen=function(){_this.setState({open:true});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SIMSelect,[{key:'render',value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{autoComplete:'on'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:classes.formControl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Select___default.a,{value:this.state.age,onChange:this.handleChange,displayEmpty:true,name:'age',className:classes.selectEmpty},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'Select SIM Service Provider')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_MenuItem___default.a,{value:10},'Ten'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_MenuItem___default.a,{value:20},'Twenty'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_MenuItem___default.a,{value:30},'Thirty'))));}}]);return SIMSelect;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);SIMSelect.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__["withStyles"])(styles)(SIMSelect));

/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Dialog__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_DialogActions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogContent__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContentText__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContentText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContentText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogTitle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__table_list__ = __webpack_require__(1090);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DeviceAccessoryList=function(_React$Component){_inherits(DeviceAccessoryList,_React$Component);function DeviceAccessoryList(){_classCallCheck(this,DeviceAccessoryList);return _possibleConstructorReturn(this,(DeviceAccessoryList.__proto__||Object.getPrototypeOf(DeviceAccessoryList)).apply(this,arguments));}_createClass(DeviceAccessoryList,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Dialog___default.a,{open:this.props.open,onClose:this.props.onClose,'aria-labelledby':'form-dialog-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogTitle___default.a,{id:'form-dialog-title'},'Select Devices/Accessories'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContentText___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__table_list__["a" /* default */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_DialogActions___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button___default.a,{onClick:this.props.onClose,color:'primary'},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button___default.a,{onClick:this.props.onClose,color:'primary'},'Confirm'))));}}]);return DeviceAccessoryList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (DeviceAccessoryList);

/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Table__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_TableBody__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_TableBody___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TableBody__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableCell__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableCell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableCell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_TableHead__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_TableHead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TableHead__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_TablePagination__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_TablePagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_TablePagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_TableRow__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_TableRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TableRow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_TableSortLabel__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_TableSortLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TableSortLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Toolbar__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Paper__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Paper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Checkbox__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_IconButton__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_Tooltip__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_Tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_Tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_icons_Delete__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_icons_Delete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__material_ui_icons_Delete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_icons_FilterList__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_icons_FilterList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__material_ui_icons_FilterList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_core_styles_colorManipulator__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_core_styles_colorManipulator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_styles_colorManipulator__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var counter=0;function createData(name,calories){counter+=1;return{id:counter,name:name,calories:calories};}function getSorting(order,orderBy){return order==='desc'?function(a,b){return b[orderBy]-a[orderBy];}:function(a,b){return a[orderBy]-b[orderBy];};}var columnData=[{id:'name',numeric:false,disablePadding:true,label:'Device Type'},{id:'calories',numeric:true,disablePadding:false,label:'Sl No'}];var EnhancedTableHead=function(_React$Component){_inherits(EnhancedTableHead,_React$Component);function EnhancedTableHead(){var _ref;var _temp,_this,_ret;_classCallCheck(this,EnhancedTableHead);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=EnhancedTableHead.__proto__||Object.getPrototypeOf(EnhancedTableHead)).call.apply(_ref,[this].concat(args))),_this),_this.createSortHandler=function(property){return function(event){_this.props.onRequestSort(event,property);};},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(EnhancedTableHead,[{key:'render',value:function render(){var _this2=this;var _props=this.props,onSelectAllClick=_props.onSelectAllClick,order=_props.order,orderBy=_props.orderBy,numSelected=_props.numSelected,rowCount=_props.rowCount;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TableHead___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TableRow___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableCell___default.a,{padding:'checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Checkbox___default.a,{indeterminate:numSelected>0&&numSelected<rowCount,checked:numSelected===rowCount,onChange:onSelectAllClick})),columnData.map(function(column){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableCell___default.a,{key:column.id,numeric:column.numeric,padding:column.disablePadding?'none':'default',sortDirection:orderBy===column.id?order:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_Tooltip___default.a,{title:'Sort',placement:column.numeric?'bottom-end':'bottom-start',enterDelay:300},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TableSortLabel___default.a,{active:orderBy===column.id,direction:order,onClick:_this2.createSortHandler(column.id)},column.label)));},this)));}}]);return EnhancedTableHead;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);EnhancedTableHead.propTypes={numSelected:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,onRequestSort:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,onSelectAllClick:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,order:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,orderBy:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,rowCount:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired};var toolbarStyles=function toolbarStyles(theme){return{root:{paddingRight:theme.spacing.unit},highlight:{color:theme.palette.secondary.main,backgroundColor:Object(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_styles_colorManipulator__["lighten"])(theme.palette.secondary.light,0.85)},spacer:{flex:'1 1 100%'},actions:{color:theme.palette.text.secondary},title:{flex:'0 0 auto'}};};var EnhancedTableToolbar=function EnhancedTableToolbar(props){var numSelected=props.numSelected,classes=props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Toolbar___default.a,{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()(classes.root,_defineProperty({},classes.highlight,numSelected>0))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.title},numSelected>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Typography___default.a,{color:'inherit',variant:'subheading'},numSelected,' selected'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Typography___default.a,{variant:'title',id:'tableTitle'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.spacer}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.actions},numSelected>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_Tooltip___default.a,{title:'Delete'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_IconButton___default.a,{'aria-label':'Delete'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_icons_Delete___default.a,null))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_Tooltip___default.a,{title:'Filter list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_IconButton___default.a,{'aria-label':'Filter list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_icons_FilterList___default.a,null)))));};EnhancedTableToolbar.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,numSelected:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired};EnhancedTableToolbar=Object(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__["withStyles"])(toolbarStyles)(EnhancedTableToolbar);var styles=function styles(theme){return{root:{width:'100%',marginTop:theme.spacing.unit*3},table:{minWidth:300},tableWrapper:{overflowX:'auto'}};};var EnhancedTable=function(_React$Component2){_inherits(EnhancedTable,_React$Component2);function EnhancedTable(props){_classCallCheck(this,EnhancedTable);var _this3=_possibleConstructorReturn(this,(EnhancedTable.__proto__||Object.getPrototypeOf(EnhancedTable)).call(this,props));_this3.handleRequestSort=function(event,property){var orderBy=property;var order='desc';if(_this3.state.orderBy===property&&_this3.state.order==='desc'){order='asc';}_this3.setState({order:order,orderBy:orderBy});};_this3.handleSelectAllClick=function(event,checked){if(checked){_this3.setState(function(state){return{selected:state.data.map(function(n){return n.id;})};});return;}_this3.setState({selected:[]});};_this3.handleClick=function(event,id){var selected=_this3.state.selected;var selectedIndex=selected.indexOf(id);var newSelected=[];if(selectedIndex===-1){newSelected=newSelected.concat(selected,id);}else if(selectedIndex===0){newSelected=newSelected.concat(selected.slice(1));}else if(selectedIndex===selected.length-1){newSelected=newSelected.concat(selected.slice(0,-1));}else if(selectedIndex>0){newSelected=newSelected.concat(selected.slice(0,selectedIndex),selected.slice(selectedIndex+1));}_this3.setState({selected:newSelected});};_this3.handleChangePage=function(event,page){_this3.setState({page:page});};_this3.handleChangeRowsPerPage=function(event){_this3.setState({rowsPerPage:event.target.value});};_this3.isSelected=function(id){return _this3.state.selected.indexOf(id)!==-1;};_this3.state={order:'asc',orderBy:'calories',selected:[],data:[createData('Device 1',11256305),createData('Device 2',11256452),createData('Device 3',11256262),createData('Device 4',11256159),createData('Device 5',11256356),createData('Device 6',11256408),createData('Device 7',11256237)],page:0,rowsPerPage:5};return _this3;}_createClass(EnhancedTable,[{key:'render',value:function render(){var _this4=this;var classes=this.props.classes;var _state=this.state,data=_state.data,order=_state.order,orderBy=_state.orderBy,selected=_state.selected,rowsPerPage=_state.rowsPerPage,page=_state.page;var emptyRows=rowsPerPage-Math.min(rowsPerPage,data.length-page*rowsPerPage);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Paper___default.a,{className:classes.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EnhancedTableToolbar,{numSelected:selected.length}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.tableWrapper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Table___default.a,{className:classes.table,'aria-labelledby':'tableTitle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EnhancedTableHead,{numSelected:selected.length,order:order,orderBy:orderBy,onSelectAllClick:this.handleSelectAllClick,onRequestSort:this.handleRequestSort,rowCount:data.length}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TableBody___default.a,null,data.sort(getSorting(order,orderBy)).slice(page*rowsPerPage,page*rowsPerPage+rowsPerPage).map(function(n){var isSelected=_this4.isSelected(n.id);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TableRow___default.a,{hover:true,onClick:function onClick(event){return _this4.handleClick(event,n.id);},role:'checkbox','aria-checked':isSelected,tabIndex:-1,key:n.id,selected:isSelected},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableCell___default.a,{padding:'checkbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Checkbox___default.a,{checked:isSelected})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableCell___default.a,{component:'th',scope:'row',padding:'none'},n.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableCell___default.a,{numeric:true},n.calories));}),emptyRows>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TableRow___default.a,{style:{height:49*emptyRows}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TableCell___default.a,{colSpan:6}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_TablePagination___default.a,{component:'div',count:data.length,rowsPerPage:rowsPerPage,page:page,backIconButtonProps:{'aria-label':'Previous Page'},nextIconButtonProps:{'aria-label':'Next Page'},onChangePage:this.handleChangePage,onChangeRowsPerPage:this.handleChangeRowsPerPage}));}}]);return EnhancedTable;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);EnhancedTable.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__["withStyles"])(styles)(EnhancedTable));

/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Report;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function Report(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'This is report');}

/***/ }),
/* 1092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Drawer__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Drawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Drawer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_List__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_ListItem__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_ListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_ListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_ListSubheader__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_ListSubheader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_ListSubheader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_ListItemIcon__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_ListItemIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_ListItemIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_ListItemText__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_ListItemText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_ListItemText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Collapse__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Collapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Collapse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants_styles__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants_others__ = __webpack_require__(1093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants_partnerOthers__ = __webpack_require__(1094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants_reseller__ = __webpack_require__(1095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_Tooltip__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_Tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_Tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_getAccountType__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_icons_ExpandLess__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_icons_ExpandLess___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__material_ui_icons_ExpandLess__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_icons_ExpandMore__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_icons_ExpandMore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__material_ui_icons_ExpandMore__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* eslint-disable */var styles=function styles(theme){var _drawerPaperClose;return{drawerPaperHello:{width:__WEBPACK_IMPORTED_MODULE_11__constants_styles__["b" /* MENU_DRAWER_WIDTH */],overflowY:'auto',transition:theme.transitions.create('width',{easing:theme.transitions.easing.sharp,duration:theme.transitions.duration.enteringScreen})},drawer:{height:'100%',overflowX:'hidden'},drawerPaperClose:(_drawerPaperClose={},_defineProperty(_drawerPaperClose,theme.breakpoints.down('xs'),{width:'0px',marginRight:'0px',marginLeft:'0px'}),_defineProperty(_drawerPaperClose,theme.breakpoints.up('sm'),{width:__WEBPACK_IMPORTED_MODULE_11__constants_styles__["c" /* MINI_MENU_DRAWER_WIDTH */]}),_defineProperty(_drawerPaperClose,'transition',theme.transitions.create('width',{easing:theme.transitions.easing.sharp,duration:theme.transitions.duration.leavingScreen})),_drawerPaperClose),menuItem:{backgroundColor:theme.palette.secondary.main,color:theme.palette.common.white,'&:hover':{backgroundColor:theme.palette.secondary.main,color:theme.palette.common.white}}};};function MenuDrawerList(props){var isMini=props.isMini,menuItemClass=props.menuItemClass,closeMobileMenuDrawer=props.closeMobileMenuDrawer;var _React$useState=__WEBPACK_IMPORTED_MODULE_0_react___default.a.useState({}),_React$useState2=_slicedToArray(_React$useState,2),expandedItems=_React$useState2[0],setExpandedItems=_React$useState2[1];var menuListItems=[];var accountType=Object(__WEBPACK_IMPORTED_MODULE_18__utils_getAccountType__["a" /* default */])();var loginId=parseInt(Object(__WEBPACK_IMPORTED_MODULE_19__utils_getLoginId__["a" /* default */])(),10);var handleToggle=function handleToggle(itemText){setExpandedItems(function(prev){return Object.assign({},prev,_defineProperty({},itemText,!prev[itemText]));});};if(loginId===2){switch(accountType){case'SAL':menuListItems=__WEBPACK_IMPORTED_MODULE_13__constants_partnerOthers__["d" /* SALES_DRAWER_MENU_LIST_ITEMS */];break;case'SER':menuListItems=__WEBPACK_IMPORTED_MODULE_13__constants_partnerOthers__["e" /* SERVICE_DRAWER_MENU_LIST_ITEMS */];break;case'INV':menuListItems=__WEBPACK_IMPORTED_MODULE_13__constants_partnerOthers__["b" /* INVENTORY_DRAWER_MENU_LIST_ITEMS */];break;case'ACC':menuListItems=__WEBPACK_IMPORTED_MODULE_13__constants_partnerOthers__["a" /* ACCOUNT_DRAWER_MENU_LIST_ITEMS */];break;case'RES':menuListItems=__WEBPACK_IMPORTED_MODULE_14__constants_reseller__["a" /* RESELLER_DRAWER_MENU_LIST_ITEMS */];break;case'SA':menuListItems=__WEBPACK_IMPORTED_MODULE_12__constants_others__["a" /* SUPER_ADMIN_DRAWER_MENU_LIST_ITEMS */];break;default:menuListItems=__WEBPACK_IMPORTED_MODULE_13__constants_partnerOthers__["f" /* ZELIOT_DRAWER_MENU_LIST_ITEMS */];}}else{switch(accountType){case'SAL':menuListItems=__WEBPACK_IMPORTED_MODULE_13__constants_partnerOthers__["d" /* SALES_DRAWER_MENU_LIST_ITEMS */];break;case'SER':menuListItems=__WEBPACK_IMPORTED_MODULE_13__constants_partnerOthers__["e" /* SERVICE_DRAWER_MENU_LIST_ITEMS */];break;case'INV':menuListItems=__WEBPACK_IMPORTED_MODULE_13__constants_partnerOthers__["b" /* INVENTORY_DRAWER_MENU_LIST_ITEMS */];break;case'ACC':menuListItems=__WEBPACK_IMPORTED_MODULE_13__constants_partnerOthers__["a" /* ACCOUNT_DRAWER_MENU_LIST_ITEMS */];break;case'RES':menuListItems=__WEBPACK_IMPORTED_MODULE_14__constants_reseller__["a" /* RESELLER_DRAWER_MENU_LIST_ITEMS */];break;case'SA':menuListItems=__WEBPACK_IMPORTED_MODULE_12__constants_others__["a" /* SUPER_ADMIN_DRAWER_MENU_LIST_ITEMS */];break;default:menuListItems=__WEBPACK_IMPORTED_MODULE_13__constants_partnerOthers__["c" /* PARTNER_DRAWER_MENU_LIST_ITEMS */];}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_List___default.a,null,Object.keys(menuListItems).map(function(drawerMenuListItem){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:drawerMenuListItem},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_ListSubheader___default.a,{disableSticky:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RenderSubheading,{heading:drawerMenuListItem,isMini:isMini})),menuListItems[drawerMenuListItem].map(function(item,index){return window.location.host.includes('iocl')&&item.text==='Billing'?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:item.text},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_ListItem___default.a,{button:true,component:item.submenu?'div':function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* NavLink */],Object.assign({to:item.route,activeClassName:menuItemClass,onClick:closeMobileMenuDrawer},props));},dense:true,onClick:item.submenu?function(e){e.preventDefault();handleToggle(item.text);}:undefined},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_Tooltip___default.a,{title:isMini?item.text:'',placement:'right',key:item.text},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_ListItemIcon___default.a,{color:'inherit'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(item.icon,null))),!isMini&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_ListItemText___default.a,{primaryTypographyProps:{style:{whiteSpace:'normal',wordBreak:'break-word'}}},item.text),item.submenu&&(expandedItems[item.text]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_icons_ExpandLess___default.a,null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_icons_ExpandMore___default.a,null)))),item.submenu&&!isMini&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Collapse___default.a,{'in':expandedItems[item.text],timeout:'auto',unmountOnExit:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_List___default.a,{component:'div',disablePadding:true},item.submenu.map(function(subItem,subIndex){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_ListItem___default.a,{key:subItem.text,button:true,component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* NavLink */],Object.assign({to:subItem.route,activeClassName:menuItemClass,onClick:closeMobileMenuDrawer},props));},dense:true,style:{paddingLeft:32}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_ListItemText___default.a,{inset:true,primary:subItem.text,primaryTypographyProps:{style:{whiteSpace:'normal',wordBreak:'break-word'}}}));}))));}));}));}function RenderSubheading(props){var heading=props.heading;var isMini=props.isMini;if(heading==='MainMenu')return null;if(isMini===true){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_Divider___default.a,null);}else{return heading;}}var MenuDrawer=function(_Component){_inherits(MenuDrawer,_Component);function MenuDrawer(){_classCallCheck(this,MenuDrawer);return _possibleConstructorReturn(this,(MenuDrawer.__proto__||Object.getPrototypeOf(MenuDrawer)).apply(this,arguments));}_createClass(MenuDrawer,[{key:'render',value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Drawer___default.a,{anchor:'left',variant:'permanent',ModalProps:{keepMounted:true// Better open performance on mobile.
},classes:{paper:__WEBPACK_IMPORTED_MODULE_15_classnames___default()(classes.drawerPaperHello,'appbar-top-margin drawer-height-with-appbar',!this.props.isMenuDrawerOpen&&classes.drawerPaperClose)},open:this.props.isMenuDrawerOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.drawer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuDrawerList,{menuItemClass:classes.menuItem,isMini:!this.props.isMenuDrawerOpen,closeMobileMenuDrawer:this.props.closeMobileMenuDrawer})));}}]);return MenuDrawer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);MenuDrawer.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,isMenuDrawerOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,variant:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};MenuDrawer.defaultProps={variant:'persistent'};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__["withStyles"])(styles)(MenuDrawer));

/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SUPER_ADMIN_DRAWER_MENU_LIST_ITEMS; });
/* unused harmony export days */
/* unused harmony export time */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_icons_SupervisorAccount__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_icons_SupervisorAccount___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_ui_icons_SupervisorAccount__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_icons_SimCard__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_icons_SimCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_icons_SimCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons_DeveloperBoard__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons_DeveloperBoard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_DeveloperBoard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_MultilineChart__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_MultilineChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_MultilineChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Style__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_PlaylistAddCheck__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_PlaylistAddCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_PlaylistAddCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_AddShoppingCart__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_AddShoppingCart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_AddShoppingCart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Search__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Refresh__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Refresh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Refresh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Phonelink__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Phonelink___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Phonelink__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_Room__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_Room___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_Room__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Web__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Web___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Web__);
/* eslint-disable */var SUPER_ADMIN_DRAWER_MENU_LIST_ITEMS={Analytics:[{text:'Dashboard',icon:__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Style___default.a,route:'/home/dashboard'},{text:'Licenses',icon:__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_MultilineChart___default.a,route:'/home/ViewLicense'},{text:'Users',icon:__WEBPACK_IMPORTED_MODULE_0__material_ui_icons_SupervisorAccount___default.a,route:'/home/user/dashboard'}],Inventory:[{text:'Devices',icon:__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_DeveloperBoard___default.a,route:'/home/deviceDashboard/Dashboard'},{text:'Sim Provider Details',icon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons_SimCard___default.a,route:'/home/add-provider'},{text:'SIM Details',icon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons_SimCard___default.a,// route: '/home/add-sim'
route:'/home/inventory/sims'},{text:'Assign device/Sim',icon:__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_PlaylistAddCheck___default.a,route:'/home/assignDevPartner'},{text:'Purchase Request',icon:__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_AddShoppingCart___default.a,route:'/home/manage/purchase-requests'},{text:'SMS Purchase',icon:__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_AddShoppingCart___default.a,route:'/home/manage/purchase-SMS'},{text:'Search Device',icon:__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_Search___default.a,route:'/home/manage/search-Device'},{text:'Current Trackinfo',icon:__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Refresh___default.a,route:'/home/superAdmin/CurrentTrackinfo'// ,
// {
//   text: 'Spare-part Replacement',
//   icon: Search,
//   route: '/home/manage/sparepart'
// },
}],Admin:[{text:'Clear Redis',icon:__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Refresh___default.a,route:'/home/manage/Clear-Redis'},{text:'Create Demo Link',icon:__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Phonelink___default.a,route:'/home/manage/create-demo-link'},{text:'API Dashboard',icon:__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Web___default.a,route:'/home/manage/api-dashboard'},{text:'Here Maps Dashboard',icon:__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_Room___default.a,route:'/home/manage/heremaps'}]};var days=['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];var time=['12 AM','1 AM','2 AM','3 AM','4 AM','5 AM','6 AM','7 AM','8 AM','9 AM','10 AM','11 AM','12 PM','1 PM','2 PM','3 PM','4 PM','5 PM','6 PM','7 PM','8 PM','9PM','10 PM','11 PM'];

/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ZELIOT_DRAWER_MENU_LIST_ITEMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PARTNER_DRAWER_MENU_LIST_ITEMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SALES_DRAWER_MENU_LIST_ITEMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return INVENTORY_DRAWER_MENU_LIST_ITEMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SERVICE_DRAWER_MENU_LIST_ITEMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACCOUNT_DRAWER_MENU_LIST_ITEMS; });
/* unused harmony export days */
/* unused harmony export time */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_icons_SupervisorAccount__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_icons_SupervisorAccount___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_ui_icons_SupervisorAccount__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_icons_SimCard__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_icons_SimCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_icons_SimCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons_DeveloperBoard__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons_DeveloperBoard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_DeveloperBoard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_MultilineChart__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_MultilineChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_MultilineChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Style__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_DeviceHub__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_DeviceHub___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_DeviceHub__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_PlaylistAddCheck__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_PlaylistAddCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_PlaylistAddCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_AddShoppingCart__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_AddShoppingCart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_AddShoppingCart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Receipt__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Receipt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Receipt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Search__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_Build__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_Build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_Build__);
/* eslint-disable */var ZELIOT_DRAWER_MENU_LIST_ITEMS={MainMenu:[{text:'Plans',icon:__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_MultilineChart___default.a,route:'/home/Plans'// {
//   text: 'Customers',
//   icon: SupervisorAccountIcon,
//   route: '/home/customers'
// },
// {
//   text: 'Subscriptions',
//   icon: StyleIcon,
//   route: '/home/subscriptions'
// }
}],Inventory:[{text:'Devices',icon:__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_DeveloperBoard___default.a,route:'/home/inventory/devices'},// {
//   text: 'Accessories',
//   icon: DeviceHubIcon,
//   route: '/home/inventory/accessories'
// },
{text:'SIM Cards',icon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons_SimCard___default.a,route:'/home/inventory/sims'},{text:'Spare-part Replacement',icon:__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_Build___default.a,route:'/home/manage/sparepart'}],Actions:[{text:'Search Device',icon:__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Search___default.a,route:'/home/manage/search-Device'},{text:'Vehicle Onboarding',icon:__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_PlaylistAddCheck___default.a,submenu:[{text:'Vehicles',route:'/home/VehcileDashboard/Dashboard'},{text:'Register Vehicle',route:'/home/VehicleRegistration'},{text:'Solution Topup',route:'/home/device-topup'},{text:'Device Replacement',route:'/home/device-replacement'},{text:'Vehicle Deactivation/Activation',route:'/home/vehicle-deactivation-activation'},{text:'Vehicle Unregistration',route:'/home/vehicle-unregistration'},{text:'Solution-Wise Unregistration',route:'/home/solution-wise-unregistration'},{text:'Device Shift',route:'/home/device-shift'}]},{text:'SMS Purchase',icon:__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_AddShoppingCart___default.a,route:'/home/manage/partner/purchase-SMS'},{text:'Panic Settings',icon:__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_PlaylistAddCheck___default.a,route:'/home/manage/admin/PanicAlertBitConfigurationSettings'},{text:'Fuel Calibration',icon:__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_PlaylistAddCheck___default.a,route:'/home/settings/FuelCalibration'},{text:'Current Summary',icon:__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Style___default.a,route:'/home/manage/admin/CurrentSummary'},{text:'Current Trackinfo',icon:__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Style___default.a,route:'/home/manage/admin/CurrentTrackinfo'},{text:'Idle Report',icon:__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Style___default.a,route:'/home/reports/IdleReport'},// {
//   text: 'Billing',
//   icon: Receipt,
//   route: '/home/manage/admin/InvoiceDetails'
// },
{text:'PIDs configuration',icon:__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Receipt___default.a,route:'/home/manage/admin/PidsConfiguration'},{text:'Device Health Report',icon:__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Receipt___default.a,route:'/home/manage/admin/DeviceDataKpi'},{text:'Detailed Report',icon:__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Receipt___default.a,route:'/home/DetailedAlerts'},{text:'Fuel Alerts',icon:__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Receipt___default.a,route:'/home/PilRefuleAlerts'}]};var PARTNER_DRAWER_MENU_LIST_ITEMS={MainMenu:[{text:'Plans',icon:__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_MultilineChart___default.a,route:'/home/Plans'},{text:'Customers',icon:__WEBPACK_IMPORTED_MODULE_0__material_ui_icons_SupervisorAccount___default.a,route:'/home/customers'},{text:'Subscriptions',icon:__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Style___default.a,route:'/home/subscriptions'}],Inventory:[{text:'Devices',icon:__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_DeveloperBoard___default.a,route:'/home/inventory/devices'},// {
//   text: 'Accessories',
//   icon: DeviceHubIcon,
//   route: '/home/inventory/accessories'
// },
{text:'SIM Cards',icon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons_SimCard___default.a,route:'/home/inventory/sims'},{text:'Spare-part Replacement',icon:__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_Build___default.a,route:'/home/manage/sparepart'}],Actions:[{text:'Search Device',icon:__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Search___default.a,route:'/home/manage/search-Device'},{text:'Vehicle Onboarding',icon:__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_PlaylistAddCheck___default.a,submenu:[{text:'Vehicles',route:'/home/VehcileDashboard/Dashboard'},{text:'Register Vehicle',route:'/home/VehicleRegistration'},{text:'Solution Topup',route:'/home/device-topup'},{text:'Device Replacement',route:'/home/device-replacement'},{text:'Vehicle Deactivation/Activation',route:'/home/vehicle-deactivation-activation'},{text:'Vehicle Unregistration',route:'/home/vehicle-unregistration'},{text:'Solution-Wise Unregistration',route:'/home/solution-wise-unregistration'},{text:'Device Shift',route:'/home/device-shift'}]},{text:'SMS Purchase',icon:__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_AddShoppingCart___default.a,route:'/home/manage/partner/purchase-SMS'},{text:'Panic Settings',icon:__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_PlaylistAddCheck___default.a,route:'/home/manage/admin/PanicAlertBitConfigurationSettings'},{text:'Fuel Calibration',icon:__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_PlaylistAddCheck___default.a,route:'/home/settings/FuelCalibration'},{text:'Current Summary',icon:__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Style___default.a,route:'/home/manage/admin/CurrentSummary'},{text:'Current Trackinfo',icon:__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Style___default.a,route:'/home/manage/admin/CurrentTrackinfo'},{text:'Idle Report',icon:__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Style___default.a,route:'/home/reports/IdleReport'},{text:'PIDs configuration',icon:__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Receipt___default.a,route:'/home/manage/admin/PidsConfiguration'},{text:'Device Health Report',icon:__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Receipt___default.a,route:'/home/manage/admin/DeviceDataKpi'},{text:'Detailed Report',icon:__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Receipt___default.a,route:'/home/DetailedAlerts'},{text:'Fuel Alerts',icon:__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Receipt___default.a,route:'/home/PilRefuleAlerts'}]};var SALES_DRAWER_MENU_LIST_ITEMS={MainMenu:[{text:'Customers',icon:__WEBPACK_IMPORTED_MODULE_0__material_ui_icons_SupervisorAccount___default.a,route:'/home/customers'},{text:'Subscriptions',icon:__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Style___default.a,route:'/home/subscriptions'}]};var INVENTORY_DRAWER_MENU_LIST_ITEMS={MainMenu:[{text:'Subscriptions',icon:__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Style___default.a,route:'/home/subscriptions'}],Inventory:[{text:'Devices',icon:__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_DeveloperBoard___default.a,route:'/home/inventory/devices'},// {
//   text: 'Accessories',
//   icon: DeviceHubIcon,
//   route: '/home/inventory/accessories'
// },
{text:'SIM Cards',icon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons_SimCard___default.a,route:'/home/inventory/sims'}]};var SERVICE_DRAWER_MENU_LIST_ITEMS={Actions:[{text:'Vehicle Onboarding',icon:__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_PlaylistAddCheck___default.a,submenu:[{text:'Vehicles',route:'/home/VehcileDashboard/Dashboard'},{text:'Register Vehicle',route:'/home/VehicleRegistration'},{text:'Solution Topup',route:'/home/device-topup'},{text:'Device Replacement',route:'/home/device-replacement'},{text:'Vehicle Deactivation/Activation',route:'/home/vehicle-deactivation-activation'},{text:'Vehicle Unregistration',route:'/home/vehicle-unregistration'},{text:'Solution-Wise Unregistration',route:'/home/solution-wise-unregistration'},{text:'Device Shift',route:'/home/device-shift'}]},// {
//   text: 'SMS Purchase',
//   icon: AddShoppingCart,
//   route: '/home/manage/partner/purchase-SMS'
// },
{text:'Panic Settings',icon:__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_PlaylistAddCheck___default.a,route:'/home/manage/admin/PanicAlertBitConfigurationSettings'},{text:'Current Summary',icon:__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Style___default.a,route:'/home/manage/admin/CurrentSummary'// {
//   text: 'Billing',
//   icon: Receipt,
//   route: '/home/manage/admin/InvoiceDetails'
// }
}]};var ACCOUNT_DRAWER_MENU_LIST_ITEMS={Actions:[{text:'Billing',icon:__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Receipt___default.a,route:'/home/manage/admin/InvoiceDetails'},{text:'Subscriptions',icon:__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Style___default.a,route:'/home/subscriptions'}]};var days=['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];var time=['12 AM','1 AM','2 AM','3 AM','4 AM','5 AM','6 AM','7 AM','8 AM','9 AM','10 AM','11 AM','12 PM','1 PM','2 PM','3 PM','4 PM','5 PM','6 PM','7 PM','8 PM','9PM','10 PM','11 PM'];

/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RESELLER_DRAWER_MENU_LIST_ITEMS; });
/* unused harmony export days */
/* unused harmony export time */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_icons_SupervisorAccount__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_icons_SupervisorAccount___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_ui_icons_SupervisorAccount__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_icons_SimCard__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_icons_SimCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_icons_SimCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons_DeveloperBoard__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons_DeveloperBoard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_DeveloperBoard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_MultilineChart__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_MultilineChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_MultilineChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Style__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_PlaylistAddCheck__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_PlaylistAddCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_PlaylistAddCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_AddShoppingCart__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_AddShoppingCart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_AddShoppingCart__);
var RESELLER_DRAWER_MENU_LIST_ITEMS={MainMenu:[{text:'Licenses',icon:__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_MultilineChart___default.a,route:'/home/reseller/licenses'},{text:'Customers',icon:__WEBPACK_IMPORTED_MODULE_0__material_ui_icons_SupervisorAccount___default.a,route:'/home/reseller/customers'},{text:'Subscriptions',icon:__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Style___default.a,route:'/home/reseller/subscriptions'}],Inventory:[{text:'Devices',icon:__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_DeveloperBoard___default.a,route:'/home/reseller/devices'},{text:'SIM Cards',icon:__WEBPACK_IMPORTED_MODULE_1__material_ui_icons_SimCard___default.a,route:'/home/reseller/sims'}],Actions:[{text:'Vehicles',icon:__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_PlaylistAddCheck___default.a,route:'/home/reseller/VehcileDashboard/Dashboard'},{text:'Purchase Requests',icon:__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_AddShoppingCart___default.a,route:'/home/reseller/purchase-request'},{text:'SMS Purchase',icon:__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_AddShoppingCart___default.a,route:'/home/manage/partner/purchase-SMS'}]};var days=['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];var time=['12 AM','1 AM','2 AM','3 AM','4 AM','5 AM','6 AM','7 AM','8 AM','9 AM','10 AM','11 AM','12 PM','1 PM','2 PM','3 PM','4 PM','5 PM','6 PM','7 PM','8 PM','9PM','10 PM','11 PM'];

/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_AppBar__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_AppBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_AppBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Toolbar__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_IconButton__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Menu__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_AccountCircle__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_AccountCircle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_AccountCircle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AccountMenu__ = __webpack_require__(1097);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query($domain: String!) {\n    domainConfiguration(domain: $domain) {\n      header {\n        title\n      }\n    }\n  }\n'],['\n  query($domain: String!) {\n    domainConfiguration(domain: $domain) {\n      header {\n        title\n      }\n    }\n  }\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var styles=function styles(theme){return{appBar:{zIndex:theme.zIndex.drawer},flex:{flex:1},menuButton:{marginLeft:-12,marginRight:20}};};var GET_DOMAIN_CONFIG=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject);var NavBar=function(_Component){_inherits(NavBar,_Component);function NavBar(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NavBar);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NavBar.__proto__||Object.getPrototypeOf(NavBar)).call.apply(_ref,[this].concat(args))),_this),_this.state={isAccountMenuOpen:false,anchorEl:null},_this.openAccountMenu=function(e){_this.setState({isAccountMenuOpen:true,anchorEl:e.currentTarget});},_this.closeAccountMenu=function(e){_this.setState({isAccountMenuOpen:false,anchorEl:null});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NavBar,[{key:'render',value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_AppBar___default.a,{position:'fixed',color:'secondary',className:classes.appBar},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Toolbar___default.a,{variant:'dense'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_IconButton___default.a,{className:classes.menuButton,color:'inherit','aria-label':'Menu',onClick:this.props.handleMenuDrawerToggle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Menu___default.a,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{variant:'title',color:'inherit',className:classes.flex}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_IconButton___default.a,{onClick:this.openAccountMenu,color:'inherit'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_AccountCircle___default.a,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__AccountMenu__["a" /* default */],{isAccountMenuOpen:this.state.isAccountMenuOpen,anchorEl:this.state.anchorEl,onClose:this.closeAccountMenu})));}}]);return NavBar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);NavBar.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__["withStyles"])(styles)(NavBar));

/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Popover__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Card__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_CardContent__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_CardContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_CardContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__auth__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_getLoginId__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query partnerDetail($loginId: Int) {\n    partnerDetail(loginId: $loginId) {\n      businessName\n      email\n    }\n  }\n'],['\n  query partnerDetail($loginId: Int) {\n    partnerDetail(loginId: $loginId) {\n      businessName\n      email\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query getResellerDetails($loginId: Int) {\n    getResellerDetails(loginId: $loginId) {\n      resellerName\n      email\n    }\n  }\n'],['\n  query getResellerDetails($loginId: Int) {\n    getResellerDetails(loginId: $loginId) {\n      resellerName\n      email\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_PARTNER=Object(__WEBPACK_IMPORTED_MODULE_12_graphql_tag__["a" /* default */])(_templateObject);var GET_RESELLER=Object(__WEBPACK_IMPORTED_MODULE_12_graphql_tag__["a" /* default */])(_templateObject2);var styles=function styles(theme){return{accountMenuPopover:{zIndex:2200},accountCard:{width:'300px',borderRadius:'5px'},cardContent:{padding:'10px !important'},LogoutButton:{borderColor:'rgb(230, 50, 50)'}};};var AccountMenu=function(_Component){_inherits(AccountMenu,_Component);function AccountMenu(props){var _this2=this;_classCallCheck(this,AccountMenu);var _this=_possibleConstructorReturn(this,(AccountMenu.__proto__||Object.getPrototypeOf(AccountMenu)).call(this,props));_this.getLoginDetails=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var accountType,partnerDetail,ResellerDetails;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:accountType=localStorage.getItem('Account_type');if(!(accountType==='PA')){_context.next=8;break;}_context.next=4;return _this.props.client.query({query:GET_PARTNER,variables:{loginId:Object(__WEBPACK_IMPORTED_MODULE_14__utils_getLoginId__["a" /* default */])()}});case 4:partnerDetail=_context.sent;_this.setState({loginUserName:partnerDetail.data.partnerDetail.businessName,loginEmail:partnerDetail.data.partnerDetail.email});_context.next=16;break;case 8:if(!(accountType==='RES')){_context.next=15;break;}_context.next=11;return _this.props.client.query({query:GET_RESELLER,variables:{loginId:Object(__WEBPACK_IMPORTED_MODULE_14__utils_getLoginId__["a" /* default */])()}});case 11:ResellerDetails=_context.sent;_this.setState({loginUserName:ResellerDetails.data.getResellerDetails.resellerName,loginEmail:ResellerDetails.data.getResellerDetails.email});_context.next=16;break;case 15:_this.setState({loginUserName:'Zeliot',loginEmail:'contact@zeliot.in'});case 16:_context.t0=accountType;_context.next=_context.t0==='ACC'?19:_context.t0==='SAL'?21:_context.t0==='SER'?23:_context.t0==='INV'?25:_context.t0==='PA'?27:29;break;case 19:_this.setState({accountType:'ACCOUNT'});return _context.abrupt('break',30);case 21:_this.setState({accountType:'SALES'});return _context.abrupt('break',30);case 23:_this.setState({accountType:'SERVICE'});return _context.abrupt('break',30);case 25:_this.setState({accountType:'INVENTORY'});return _context.abrupt('break',30);case 27:_this.setState({accountType:'BUSINESS ADMIN'});return _context.abrupt('break',30);case 29:_this.setState({accountType:'N/A'});case 30:case'end':return _context.stop();}}},_callee,_this2);}));_this.state={loginUserName:'',loginEmail:'',accountType:''};return _this;}_createClass(AccountMenu,[{key:'componentDidMount',value:function componentDidMount(){this.getLoginDetails();}},{key:'render',value:function render(){var _props=this.props,classes=_props.classes,isAccountMenuOpen=_props.isAccountMenuOpen;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Popover___default.a,{className:classes.accountMenuPopover,anchorOrigin:{vertical:'bottom',horizontal:'center'},transformOrigin:{vertical:'top',horizontal:'right'},open:isAccountMenuOpen,anchorEl:this.props.anchorEl,onClose:this.props.onClose},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Card___default.a,{className:classes.accountCard},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_CardContent___default.a,{className:classes.cardContent},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:8},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Typography"],{variant:'body2'},this.state.accountType)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Divider___default.a,null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Typography"],{variant:'caption'},'Name')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Typography"],null,' ',this.state.loginUserName,' ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Typography"],{variant:'caption'},'Email')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Typography"],null,this.state.loginEmail)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,justify:'flex-end'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Button___default.a,{className:classes.LogoutButton,variant:'outlined',onClick:this.props.logout},'Logout')))))));}}]);return AccountMenu;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);AccountMenu.propTypes={isAccountMenuOpen:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["withApollo"])(function(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__auth__["a" /* AuthConsumer */],null,function(_ref2){var logout=_ref2.logout;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AccountMenu,Object.assign({},props,{logout:logout}));});}))));

/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__queries__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormHelperText__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormHelperText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormHelperText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ClientDetails__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControlLabel__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControlLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControlLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Checkbox__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_axios__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_file_saver__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__vehicle_css__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__vehicle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__vehicle_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_phaseOptionsArray__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__VehiclePreviewModal__ = __webpack_require__(1099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__material_ui_core_Stepper__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__material_ui_core_Stepper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__material_ui_core_Stepper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__material_ui_core_Step__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__material_ui_core_Step___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__material_ui_core_Step__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__material_ui_core_StepButton__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__material_ui_core_StepButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__material_ui_core_StepButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__VehicleInfoStep__ = __webpack_require__(1100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__InstallationSubmissionStep__ = __webpack_require__(1101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__TensionerRotationSensorReminder__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__queries__ = __webpack_require__(185);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable */var VehicleRegistration=function(_Component){_inherits(VehicleRegistration,_Component);function VehicleRegistration(props){var _this$state;_classCallCheck(this,VehicleRegistration);// Dynamically generate manufacturing year options
var _this=_possibleConstructorReturn(this,(VehicleRegistration.__proto__||Object.getPrototypeOf(VehicleRegistration)).call(this,props));_initialiseProps.call(_this);var currentYear=new Date().getFullYear();var manufacturingYearOptions=[];for(var i=0;i<=30;i++){manufacturingYearOptions.push({value:currentYear-i,label:''+(currentYear-i)});}_this.state=(_this$state={isSpeedLimitValid:true,isSeatLimitValid:false,duplicateVehicle:false,isAutoFillEntrySectionOpen:false,speedLimit:'',seatLimit:null,serialNumber:'',partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_16__utils_getLoginId__["a" /* default */])(),// partnerLoginId: 8,
isSerialNumberValid:true,modelName:'',deviceType:'',status:1,phoneNumber:'',isPhoneNoValid:true,simProvider:'',simNumber:'',vlpn:'',isVlpnValid:true,vehicleModel:'',vehicleMake:'',vehicleMakeId:'',vehicleModelId:'',isVehicleModelValid:true,isVehicleMakeValid:true,clientName:'',isClientNameValid:true,vehicleType:'',vehicleTypes:[],isVehicleTypeValid:true,speedSensor:'',isSpeedSensorValid:true,accessories:null,clientsDetails:[],deviceDetails:[],simDetails:[],accessoryDetails:[],response:false,failure:false,schoolBusEnable:false,installStatus:true,vehicleRegistrationNumberAvailableStatus:false,immobilize:false,isengineNumberValid:true,engineNumber:null,chassisNumber:null,ischassisNumberValid:true,vlpnres:'',client:'',chassisres:'',engineres:'',subscriptionId:'',mmtc:'',noOfDevices:'',subscriptionDetails:[],idlingSpeed:3,invoiceNumber:'',equipmentSerialNumber:null,equipmentName:'',commissioningDate:{date:null,unix:__WEBPACK_IMPORTED_MODULE_20_moment___default()().unix().toString()},invoiceDate:{date:null,unix:__WEBPACK_IMPORTED_MODULE_20_moment___default()().unix().toString()},deviceModelId:'',department:'',contractorName:'',fuelType:'',solutionType:'',solution_type:[],selected_solution_codes:[],isDualEngine:false,eoff_voltage:null,eon_voltage:null,hasArm:false,isElockConnection:false,isIndividualViewOrCombinedView:false,engineOnHours:'',odometerDistance:'',isengineOnHoursValid:true,isOdometerDistanceValid:true,engineSpecification:'',isEngineSpecificationValid:true,emissionRateType:'',engineSpecificationFromApi:false,emissionRateTypeFromApi:false,grossVehicleWeightFromApi:false,fuelTankCapacityFromApi:false,adblueCapacityFromApi:false,manufacturingYearFromApi:false,fuelTypeFromApi:false,makesList:[],modelsList:[],emissionList:[],makeModelsMainList:[],grossVehicleWeight:'',manufacturingYear:'',vehicleSegment:'',selectedVTM:'',videoTelematicsId:'',equipmentTypeClass:'',vehicleWheeler:'',application:'',haulageType:'',constructionVehicleType:'',tensionerConductorLength:null,tensionerRotationSensorDirection:'',isRotationSensor:false,passengerVehicleType:'',transportationVehicleType:'',vehicleNickName:'',documentUpload:null,baselineDataType:'',// baselineDataTypeFE: '',
baselineDataForFE:'',baselineDistance:'',baselineHours:null,fuelTankCapacity:'',adblueCapacity:'',vehicleCustomizedBodyType:'',istachoenabled:false,tachoidlerpm:'',tachoshifthours:'',tachoengineonmin:'',tachoengineonmax:'',errorMessage:null,errorMessageNew:null,errorMessageFuelTank:null,vtValidationError:null,fileNames:'',uploadProgress:{},// Initialize uploadProgress state
documentUploadNewData:{},// Map fileName to { solutionType, label }
equipmentTypeClassOptions:[],vehicleWheelerOptions:[],// applicationOptions: [],
haulageTypeOptions:[],constructionVehicleTypeOptions:[],equipmentTypeClassText:'',// For EVs free text input
isBaselineDataForFEValid:true,// Assume valid by default
isBaselineDistanceValid:true,isBaselineHoursValid:true,isDepartmentValid:true,isContractorNameValid:true,iseoff_voltageValid:true,iseon_voltageValid:true,isEquipmentNameValid:true,isEquipmentValid:true,isInvoiceNoValid:true,isAdblueCapacityValid:true,isEonVoltageValid:true,isEoffVoltageValid:true,manufacturingYearOptions:manufacturingYearOptions,segmentOptions:[],noOfWheelsOptions:[],noOfGearsOptions:[],baselineDataTypeFEOptions:[],kvaRatingOptions:[],dgSetTypeOptions:[],phaseOptions:__WEBPACK_IMPORTED_MODULE_22__utils_phaseOptionsArray__["a" /* phaseOptionsArray */],videoTelematicsType:[{label:'LocoNav',value:'loconav'},{label:'MettaX',value:'mettax'}],dashcamRegistrations:[],dashcamRegistrationsLoading:false,// Technician dropdowns and createdBy
assignedTechniciansTaabi:[],assignedTechniciansFreelancer:[],technicianCategory:null,// 'Taabi' or 'Freelancer'
selectedTaabiTechnician:null,selectedFreelancerTechnician:null,technicianName:'',createdBy:typeof localStorage!=='undefined'?localStorage.getItem('username')||'':'',vtidOptions:[],selectedVtid:null,selectedSimId:'',selectedMemoryCardId:'',// states for handling file upload response
fileName:'',bucketName:'',publicUploadURL:'',downloadUrl:'',isUploading:false,// To track upload status
portedVehicle:'',isTestingVehicle:'',inputParameter:16,multiplicationFactor:2,kvaRating:'',dgSetType:'',bhp:'',phase:'',engineModel:'',gensetController:'',custCode:'',custType:'',vehicleData:'',rcRegnNo:'',rcRegnDt:'',rcRegnUpto:'',rcPurchaseDt:'',rcOwnerSr:'',rcOwnerName:'',stateCd:'',rtoCd:'',rcPresentAddress:'',rcPermanentAddress:'',rcVchCatg:'',rcVhClassDesc:'',rcChasiNo:'',rcEngNo:'',rcMakerDesc:'',rcMakerModel:'',rcBodyTypeDesc:'',rcFuelDesc:'',rcColor:'',rcNormsDesc:'',rcFitUpto:'',rcNpUpto:'',rcNpIssuedBy:'',rcTaxUpto:'',rcFinancer:'',rcInsuranceComp:'',rcInsurancePolicyNo:'',rcInsuranceUpto:'',rcManuMonthYr:'',rcUnldWt:null,rcGvw:'',rcNoCyl:'',rcCubicCap:'',rcSeatCap:'',rcSleeperCap:'',rcStandCap:'',rcWheelbase:'',rcRegisteredAt:'',rcStatusAsOn:'',rcPuccUpto:'',rcPuccNo:'',rcStatus:'',rcNcrbStatus:'',rcBlacklistStatus:'',rcPermitNo:'',rcPermitIssueDt:'',rcPermitValidFrom:'',rcPermitValidUpto:'',rcPermitType:'',rcPermitCode:'',rcNocDetails:'',rcVhType:'',rcVhClass:'',rcNocDt:'',rcFuelCd:'',rcMakerCd:'',rcModelCd:'',rcNormsCd:'',rcSaleAmt:'',rcOwnCatgDesc:''},_defineProperty(_this$state,'rcVhClassDesc',''),_defineProperty(_this$state,'rcOwnerCdDesc',''),_defineProperty(_this$state,'rcCurrentaddDistrictcode',''),_defineProperty(_this$state,'rcNonUse',''),_defineProperty(_this$state,'rcPassengerTax',''),_defineProperty(_this$state,'rcGoodsTax',''),_defineProperty(_this$state,'rcNoOfAxle',null),_defineProperty(_this$state,'rcApprovalDate',''),_defineProperty(_this$state,'rcHp',''),_defineProperty(_this$state,'rcMandalDesc',''),_defineProperty(_this$state,'rcTalukCd',''),_defineProperty(_this$state,'noOfWheels',null),_defineProperty(_this$state,'noOfGears',null),_defineProperty(_this$state,'previewModalOpen',false),_defineProperty(_this$state,'previewData',null),_defineProperty(_this$state,'hasSecondaryTank',null),_defineProperty(_this$state,'calibrationLoading',false),_defineProperty(_this$state,'calibrationError',null),_defineProperty(_this$state,'availableDataTypes',null),_defineProperty(_this$state,'preferedDataType',null),_defineProperty(_this$state,'isDualSensor',null),_defineProperty(_this$state,'hasInSameTank',null),_defineProperty(_this$state,'calibration_filename',null),_defineProperty(_this$state,'fuelSensorType',null),_defineProperty(_this$state,'isSubmitAction',false),_defineProperty(_this$state,'activeStep',0),_this$state);if(_this.props.location.state){_this.setState({clientName:_this.props.location.state.clientId});}else{_this.setState({clientName:''});}return _this;}_createClass(VehicleRegistration,[{key:'computeLegacySolutionType',// Compute legacy solutionType string from new solution_type array codes
value:function computeLegacySolutionType(solutionCodes){// Mapping from internal codes to master solutionType strings
var codeToMaster={fuel:'fuel_solution',obd:'obd_solution',vt:'video_telematics',obdanalogsolution:'obd_analog_solution',basic_tracking:'basic_tracking',ais_140:'ais_140',asset_tracking:'Asset Tracking',control_tower:'control_tower',testing_vehicle:'testing_vehicle',// New combos + reverse camera 
'fuel+vt':'fuel+vt','obd+vt':'obd+vt','fuel+obd+vt':'fuel+obd+vt','reverse_camera_screen':'reverse_camera_screen'};if(!solutionCodes||solutionCodes.length===0){return'';}// Single selection -> pass as is (mapped if necessary)
if(solutionCodes.length===1){var code=solutionCodes[0];return codeToMaster[code]||code;}// Multiple selections
var hasFuel=solutionCodes.includes('fuel_solution');var hasObd=solutionCodes.includes('obd_solution');var hasVt=solutionCodes.includes('video_telematics');// Triple combo – fuel + obd + vt
if(hasFuel&&hasObd&&hasVt){return'fuel+obd+vt';}// Dual combos with VT
if(hasFuel&&hasVt){return'fuel+vt';}if(hasObd&&hasVt){return'obd+vt';}// Existing legacy combo without VT (fuel + obd)
if(hasFuel&&hasObd){return'obd_fuel+fuel_solution';}// Remaining VT cases (already handled above, but kept as safety)
if(hasVt){if(hasFuel)return'fuel+vt';if(hasObd)return'obd+vt';}// Fallback – use the first selected code’s mapping
var firstCode=solutionCodes[0];return codeToMaster[firstCode]||firstCode;}},{key:'updateDGSetData',value:function updateDGSetData(){var _this2=this;this.setState({vehicleType:'DG Set'},function(){_this2.checkVehicleTypeValidity();});this.getAllDGMakes();if(!this.state.portedVehicle){this.setState({portedVehicle:true});}if(!this.state.isTestingVehicle){this.setState({isTestingVehicle:true});}if(!this.state.speedSensor){this.setState({speedSensor:'GPS SPEED SENSOR'});}if(!this.state.idlingSpeed){this.setState({idlingSpeed:3});}if(!this.state.speedLimit){this.setState({speedLimit:40});}if(!this.state.solutionType){this.setState({solutionType:'fuel'});}if(!this.state.solution_type||this.state.solution_type.length===0){var defaultCodes=['fuel'];var legacyType=this.computeLegacySolutionType(defaultCodes);this.setState({solution_type:defaultCodes,selected_solution_codes:defaultCodes,solutionType:legacyType,selected_plan_fuel:'1 Year'});}if(!this.state.fuelType){this.setState({fuelType:'Petrol'});}}// handleChannelPartnerNameChange = event => {
//   this.setState({ channelPartnerName: event.target.value })
// }
},{key:'handleRemove',value:function handleRemove(fileName){try{var _state=this.state,uploadProgress=_state.uploadProgress,fileNames=_state.fileNames;// Remove the file from uploadProgress
delete uploadProgress[fileName];// Remove the fileName from the fileNames array
var updatedFileNames=fileNames.split(',').filter(function(name){return name!==fileName;}).join(',');// Update the state with the modified uploadProgress and fileNames
this.setState({uploadProgress:uploadProgress,fileNames:updatedFileNames});}catch(error){}}},{key:'componentDidMount',value:function componentDidMount(){this.getDashcamRegistrations();this.getMakeAndModels();this.getVehicleType();this.getAllAssignedRoles();// this.getDGSpecifications()
// this.getAllDGMakes();
this.fetchDropdownDetails();if(this.props.match.params.loginId===undefined){this.getAllClients();}else{this.getAllClients();this.handleChangeClient();}this.getZMKAMDetails();}},{key:'getStep0MissingFields',value:function getStep0MissingFields(){var _state2=this.state,isClientNameValid=_state2.isClientNameValid,showClientDetails=_state2.showClientDetails,clientName=_state2.clientName,vehicleSegment=_state2.vehicleSegment,vehicleData=_state2.vehicleData,rcRegnNo=_state2.rcRegnNo,rcMakerDesc=_state2.rcMakerDesc,rcMakerModel=_state2.rcMakerModel,transportationVehicleType=_state2.transportationVehicleType,selectedApplication=_state2.selectedApplication,haulageType=_state2.haulageType,constructionVehicleType=_state2.constructionVehicleType,passengerVehicleType=_state2.passengerVehicleType,vehicleType=_state2.vehicleType,tensionerConductorLength=_state2.tensionerConductorLength,tensionerRotationSensorDirection=_state2.tensionerRotationSensorDirection,vehicleMakeId=_state2.vehicleMakeId,vehicleModelId=_state2.vehicleModelId,fuelTankCapacity=_state2.fuelTankCapacity,kvaRating=_state2.kvaRating,dgSetType=_state2.dgSetType;var missing=[];if(!isClientNameValid||!showClientDetails||!clientName)missing.push('Customer Name');if(!vehicleSegment){missing.push('Vehicle Segment');return missing;}if(vehicleSegment!=='DG Set'){var regNo=vehicleData&&vehicleData.rcRegnNo||rcRegnNo;var maker=vehicleData&&vehicleData.rcMakerDesc||rcMakerDesc;var model=vehicleData&&vehicleData.rcMakerModel||rcMakerModel;if(!regNo)missing.push('Vehicle Number');if(!maker)missing.push('Maker');if(!model)missing.push('Model');if(vehicleSegment==='Transportation'){if(!selectedApplication)missing.push('Application');if(!haulageType)missing.push('Haulage Type');if(!transportationVehicleType)missing.push('Transportation Vehicle Type');}if(vehicleSegment==='Construction'){if(!constructionVehicleType)missing.push('Construction Type');if(constructionVehicleType==='Tensioner'&&!tensionerConductorLength)missing.push('Conductor Length');if(constructionVehicleType==='Tensioner'&&!tensionerRotationSensorDirection)missing.push('Rotation Sensor Direction');}if(vehicleSegment==='Passenger Vehicles'||vehicleSegment==='Passenger'){if(!passengerVehicleType)missing.push('Passenger Vehicle Type');}}else{// DG Set
if(!vehicleType)missing.push('Asset Type');if(!vehicleMakeId)missing.push('Make');if(!vehicleModelId)missing.push('Model');if(!kvaRating)missing.push('KVA Rating');if(!dgSetType)missing.push('DG Set Type');}return missing;}},{key:'isStep0Invalid',value:function isStep0Invalid(){return this.getStep0MissingFields().length>0;}},{key:'getStep1MissingFields',value:function getStep1MissingFields(){var _state3=this.state,isUploading=_state3.isUploading,isSerialNumberValid=_state3.isSerialNumberValid,isPhoneNoValid=_state3.isPhoneNoValid,isSpeedLimitValid=_state3.isSpeedLimitValid,isSpeedSensorValid=_state3.isSpeedSensorValid,speedLimit=_state3.speedLimit,speedSensor=_state3.speedSensor,portedVehicle=_state3.portedVehicle,isTestingVehicle=_state3.isTestingVehicle,vehicleSegment=_state3.vehicleSegment,selectedVTM=_state3.selectedVTM,videoTelematicsId=_state3.videoTelematicsId,serialNumber=_state3.serialNumber,phoneNumber=_state3.phoneNumber,deviceType=_state3.deviceType,vehicleMakeId=_state3.vehicleMakeId,vehicleModelId=_state3.vehicleModelId,vehicleMake=_state3.vehicleMake,vehicleModel=_state3.vehicleModel,isDualEngine=_state3.isDualEngine,adblueCapacity=_state3.adblueCapacity,eon_voltage=_state3.eon_voltage,eoff_voltage=_state3.eoff_voltage,fileNames=_state3.fileNames;var missing=[];if(isUploading)missing.push('File uploading in progress');if(!isSerialNumberValid||!serialNumber)missing.push('Device Serial Number');if(!isPhoneNoValid||!phoneNumber)missing.push('Phone Number');if(selectedVTM&&!videoTelematicsId)missing.push('Video Telematics ID');if(vehicleSegment!=='DG Set'){if(!isSpeedLimitValid||!speedLimit)missing.push('Speed Limit');if(!isSpeedSensorValid||!speedSensor)missing.push('Speed Sensor');if(portedVehicle==='')missing.push('Ported Vehicle status');if(isTestingVehicle==='')missing.push('Testing/Active status');}if((deviceType==='obd'||deviceType==='OBD')&&vehicleSegment!=='DG Set'){if(!vehicleMakeId||!vehicleModelId||!vehicleMake||!vehicleModel)missing.push('OBD Make/Model details');}var isAdblueCapacityValid=!(deviceType&&deviceType.toLowerCase()==='obd')||!!adblueCapacity&&adblueCapacity.toString().trim()!=='';if(!isAdblueCapacityValid)missing.push('Adblue Capacity');var isEonVoltageValid=!isDualEngine||eon_voltage!==null&&eon_voltage!==''&&!isNaN(eon_voltage);if(!isEonVoltageValid)missing.push('Engine On Voltage');var isEoffVoltageValid=!isDualEngine||eoff_voltage!==null&&eoff_voltage!==''&&!isNaN(eoff_voltage);if(!isEoffVoltageValid)missing.push('Engine Off Voltage');if(vehicleSegment==='DG Set'&&!this.state.fuelTankCapacity){missing.push('Fuel Tank Capacity');}if(!fileNames)missing.push('Document Upload');return missing;}},{key:'isStep1Invalid',value:function isStep1Invalid(){return this.getStep1MissingFields().length>0;}},{key:'getSubmitMissingFields',value:function getSubmitMissingFields(){var _state4=this.state,errorMessage=_state4.errorMessage,errorMessageNew=_state4.errorMessageNew,errorMessageFuelTank=_state4.errorMessageFuelTank,isInvoiceNoValid=_state4.isInvoiceNoValid,invoiceNumber=_state4.invoiceNumber,invoiceDate=_state4.invoiceDate,customerType=_state4.customerType,vehicleSegment=_state4.vehicleSegment,solution_type=_state4.solution_type,tachoidlerpm=_state4.tachoidlerpm,tachoshifthours=_state4.tachoshifthours;var missing=[];missing=missing.concat(this.getStep0MissingFields());missing=missing.concat(this.getStep1MissingFields());if(!solution_type||solution_type.length===0)missing.push('Solution Type');var VT_SOLUTION_TYPES=['video_telematics','fuel+vt','obd+vt','fuel+obd+vt'];var vtSolutionSelected=solution_type&&solution_type.some(function(s){return VT_SOLUTION_TYPES.includes(s);});if(vtSolutionSelected&&!this.state.videoTelematicsId&&!missing.includes('Video Telematics ID')){missing.push('Video Telematics ID');}if(this.state.istachoenabled){if(!tachoidlerpm)missing.push('Idle RPM');if(!tachoshifthours)missing.push('Shift Hours');}if(errorMessage)missing.push(errorMessage);if(errorMessageNew)missing.push(errorMessageNew);if(errorMessageFuelTank)missing.push(errorMessageFuelTank);if(customerType=='Paid'||vehicleSegment=='DG Set'){if(!isInvoiceNoValid||!invoiceNumber||!(invoiceDate&&invoiceDate.date))missing.push('Invoice Details');}return missing;}},{key:'isSubmitFormInvalid',value:function isSubmitFormInvalid(){return this.getSubmitMissingFields().length>0;}},{key:'render',value:function render(){var _this3=this;var uploadProgress=this.state.uploadProgress;var classes=this.props.classes;var allSpeedSensor=[];allSpeedSensor[0]={value:'GPS SPEED SENSOR',label:'Gps speed sensor'};allSpeedSensor[1]={value:'DELTA_DISTANCE_CALCULATION',label:'Delta Distance'};allSpeedSensor[2]={value:'ODOMETRIC',label:'Odometric'};var allIdlingSpeed=[{value:0,label:0},{value:1,label:1},{value:2,label:2},{value:3,label:3}];var allvehicleTypes=this.state.vehicleTypes.map(function(vehicle){return{value:vehicle,label:vehicle};});if(this.state.vehicleSegment=='DG Set'){allvehicleTypes=[].concat(_toConsumableArray(this.state.vehicleTypes.map(function(vehicle){return{value:vehicle,label:vehicle};})),[{value:'DG Set',label:'DG Set'}]);}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'Landing'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{variant:'outlined',color:'primary',className:'btn',onClick:function onClick(){return _this3.props.history.goBack();}},'Back'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,justify:'center',className:'full-screen',alignItems:'flex-end'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'formouter'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core_Stepper___default.a,{activeStep:this.state.activeStep,alternativeLabel:true,style:{background:'transparent'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core_Step___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__material_ui_core_StepButton___default.a,{onClick:function onClick(){return _this3.setState({activeStep:0});}},'Customer Details')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core_Step___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__material_ui_core_StepButton___default.a,{onClick:function onClick(){return _this3.setState({activeStep:1});}},'Vehicle & Device Info')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core_Step___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__material_ui_core_StepButton___default.a,{onClick:function onClick(){return _this3.setState({activeStep:2});}},'Payment Details & Submission')))),this.state.activeStep===0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'Customer Details')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,className:'searchdiv',spacing:'8'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,justify:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{style:{marginRight:'20px'}},'Customer Name :',' '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{style:{minWidth:'50%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select__["a" /* default */],{classes:classes,options:this.state.clientsDetails// components={components}
,value:this.state.clientName,onChange:this.handleChangeClient,placeholder:'Select Customer *'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isClientNameValid?'Invalid Selection':'')))),this.state.showClientDetails&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ClientDetails__["a" /* default */],{clientName:this.state.client,address:this.state.address,city:this.state.city,loginId:this.state.id}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["InputLabel"],{htmlFor:'custCode',style:{marginTop:'-10px'},shrink:!!this.state.customerCode},'Customer Code'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{style:{maxWidth:'50%'},id:'custCode',name:'custCode',className:'textfield',margin:'dense',type:'text',disabled:true,value:this.state.customerCode,onChange:this.handleInputChange('customerCode'),InputProps:{readOnly:true}//error={!this.state.isrcRegnDtValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["InputLabel"],{htmlFor:'custType',style:{marginTop:'-10px'},shrink:!!this.state.customerType},'Customer Type'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{style:{maxWidth:'50%'},id:'custType',name:'custType',className:'textfield',margin:'dense',type:'text',disabled:true,value:this.state.customerType,onChange:this.handleInputChange('customerType'),InputProps:{readOnly:true}//error={!this.state.isrcRegnDtValid}
}))))),this.state.vehicleSegment!=='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControlLabel___default.a,{style:{marginTop:'20px'},label:'Vehicle Registration Number Available',control:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Checkbox___default.a,{checked:this.state.vehicleRegistrationNumberAvailableStatus,onChange:this.handleVehicleRegistrationNumberAvailableChange('vehicleRegistrationNumberAvailableStatus'),value:'vehicleRegistrationNumberAvailableStatus',color:'primary'})}),this.state.vehicleSegment!=='DG Set'&&this.state.vehicleRegistrationNumberAvailableStatus&&(this.state.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center',alignItems:'center',height:'100px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["CircularProgress"],null)):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,justify:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{style:{marginRight:'20px'}},'Vehicle Registration Number *',' '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{style:{minWidth:'50%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{variant:'outlined',fullWidth:true,margin:'normal',value:this.state.enteredVehicleRegistrationNumber// onChange={
//   this.checkVlpnValidity
// }
,placeholder:'Enter Vehicle Registration Number *',name:'enteredVehicleRegistrationNumber',onChange:function onChange(event){return _this3.setState({enteredVehicleRegistrationNumber:event.target.value});}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{color:'default',variant:'outlined',size:'medium',margin:'normal',className:'btn',onClick:this.getDataByVehicleNumber},'Get Data'),this.state.vlpnres&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormHelperText___default.a,{className:'Error_msg'},this.state.vlpnres))),this.state.vehicleSegment!=='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["InputLabel"],{htmlFor:'rcRegnNo',style:{marginTop:'-10px'},shrink:!!(this.state.rcRegnNo||this.state.vehicleData&&this.state.vehicleData.rcRegnNo)},'Vehicle Registration Number *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'rcRegnNo',name:'rcRegnNo',className:'textfield',margin:'dense',type:'text',value:this.state.vehicleData?this.state.vehicleData.rcRegnNo:this.state.rcRegnNo,required:true,onChange:this.handleInputChange('rcRegnNo')}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["InputLabel"],{htmlFor:'rcMakerDesc',style:{marginTop:'-10px'},shrink:!!(this.state.rcMakerDesc||this.state.vehicleData&&this.state.vehicleData.rcMakerDesc)},'Maker Description *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'rcMakerDesc',name:'rcMakerDesc',className:'textfield',margin:'dense',type:'text',value:this.state.vehicleData?this.state.vehicleData.rcMakerDesc:this.state.rcMakerDesc,onChange:this.handleInputChange('rcMakerDesc')}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["InputLabel"],{htmlFor:'rcMakerModel',style:{marginTop:'-10px'},shrink:!!(this.state.rcMakerModel||this.state.vehicleData&&this.state.vehicleData.rcMakerModel)},'Maker Model *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'rcMakerModel',name:'rcMakerModel',className:'textfield',margin:'dense',type:'text',value:this.state.vehicleData?this.state.vehicleData.rcMakerModel:this.state.rcMakerModel,onChange:this.handleInputChange('rcMakerModel')})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,fullwidth:true,style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:6,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Vehicle Segment *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select__["a" /* default */]// options={this.state.segmentOptions}
,{options:Array.isArray(this.state.vehiclesegment)&&this.state.vehiclesegment.map(function(option){return{label:option,value:option};}),value:this.state.vehicleSegment,onChange:this.handleSegmentChange,placeholder:'Vehicle Segment *'}))),this.state.vehicleSegment==='Transportation'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'16px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Transportation Vehicle Type *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select__["a" /* default */]// options={this.state.constructionVehicleTypeOptions}
,{options:Array.isArray(this.state.transportationvehicletype)&&this.state.transportationvehicletype.map(function(option){return{label:option,value:option};}),value:this.state.transportationVehicleType,onChange:function onChange(selectedOption){return _this3.setState({transportationVehicleType:selectedOption?selectedOption.value:''});},placeholder:'Select Transportation Vehicle Type *'}))),this.state.vehicleSegment==='Transportation'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'16px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Application *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select__["a" /* default */]// options={this.state.applicationOptions}
,{options:Array.isArray(this.state.application)&&this.state.application.map(function(option){return{label:option,value:option};}),value:this.state.selectedApplication,onChange:function onChange(selectedOption){return _this3.setState({selectedApplication:selectedOption?selectedOption.value:''});},placeholder:'Select Application *'}))),this.state.vehicleSegment==='Transportation'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'16px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Haulage Type *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select__["a" /* default */]// options={this.state.haulageTypeOptions}
,{options:Array.isArray(this.state.haulagetype)&&this.state.haulagetype.map(function(option){return{label:option,value:option};}),value:this.state.haulageType,onChange:function onChange(selectedOption){return _this3.setState({haulageType:selectedOption?selectedOption.value:''});},placeholder:'Select Haulage Type *'}))),this.state.vehicleSegment==='Construction'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'16px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Construction Vehicle Type *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select__["a" /* default */]// options={this.state.constructionVehicleTypeOptions}
,{options:Array.isArray(this.state.constructionvehicletype)&&this.state.constructionvehicletype.map(function(option){return{label:option,value:option};}),value:this.state.constructionVehicleType,onChange:function onChange(selectedOption){return _this3.setState({constructionVehicleType:selectedOption?selectedOption.value:''});},placeholder:'Select Construction Vehicle Type *'}))),this.state.vehicleSegment==='Construction'&&this.state.constructionVehicleType==='Tensioner'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'16px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Conductor Length (in km) *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["Input"],{type:'number',placeholder:'Conductor Length (in m)',value:this.state.tensionerConductorLength,onChange:function onChange(e){_this3.setState({tensionerConductorLength:Number(e.target.value)<0?0:Number(e.target.value)});}}))),this.state.vehicleSegment==='Construction'&&this.state.constructionVehicleType==='Tensioner'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'16px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Rotation Sensor Direction *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select__["a" /* default */],{options:[{value:'clockwise',label:'Clockwise'},{value:'anticlockwise',label:'Anticlockwise'}],value:this.state.tensionerRotationSensorDirection?{value:this.state.tensionerRotationSensorDirection,label:this.state.tensionerRotationSensorDirection==='clockwise'?'Clockwise':'Anticlockwise'}:null,onChange:function onChange(selectedOption){return _this3.setState({tensionerRotationSensorDirection:selectedOption?selectedOption.value:''});},placeholder:'Select Rotation Sensor Direction *'}))),this.state.vehicleSegment==='Construction'&&this.state.constructionVehicleType==='Tensioner'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__TensionerRotationSensorReminder__["a" /* default */],null),this.state.vehicleSegment==='Passenger'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'16px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Passenger Vehicle Type *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select__["a" /* default */]// options={this.state.constructionVehicleTypeOptions}
,{options:Array.isArray(this.state.passengervehicletype)&&this.state.passengervehicletype.map(function(option){return{label:option,value:option};}),value:this.state.passengerVehicleType,onChange:function onChange(selectedOption){return _this3.setState({passengerVehicleType:selectedOption?selectedOption.value:''});},placeholder:'Select Passenger Vehicle Type *'}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{flex:1,backgroundColor:'#f2f2f2',padding:'10px',borderRadius:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',{className:'autoFillHeader',style:{cursor:'pointer'},onClick:function onClick(){return _this3.setState(function(prevState){return{isAutoFillEntrySectionOpen:!prevState.isAutoFillEntrySectionOpen};});}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:this.state.isAutoFillEntrySectionOpen?'autoFillChevron open':'autoFillChevron'}),'Auto Fill Entry Section'),this.state.isAutoFillEntrySectionOpen&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,this.state.vehicleSegment!='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{xs:12,sm:12,mt:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["InputLabel"],{htmlFor:'rcRegnDt',style:{marginTop:'-10px'}// shrink={((this.state.vehicleData && this.state.vehicleData.rcRegnDt)|| this.state.rcRegnDt)}
,shrink:!!(this.state.rcRegnDt||this.state.vehicleData&&this.state.vehicleData.rcRegnDt)},'Registration Date'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'rcRegnDt',name:'rcRegnDt',className:'textfield',margin:'dense'//label="Registration Date"
,type:'text'// type="Multi-line"
,value:this.state.vehicleData?this.state.vehicleData.rcRegnDt:this.state.rcRegnDt// value={(this.state.vehicleData && this.state.vehicleData.rcRegnDt) || ''}
,onChange:this.handleInputChange('rcRegnDt')//error={!this.state.isrcRegnDtValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["InputLabel"],{htmlFor:'rcRegnUpto',style:{marginTop:'-10px'},shrink:!!(this.state.rcRegnUpto||this.state.vehicleData&&this.state.vehicleData.rcRegnUpto)},'Registration Valid Upto'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'rcRegnUpto',name:'rcRegnUpto',className:'textfield',margin:'dense'//label="Registration Valid Upto"
,type:'text'// type="Multi-line"
,value:this.state.vehicleData?this.state.vehicleData.rcRegnUpto:this.state.rcRegnUpto,onChange:this.handleInputChange('rcRegnUpto')//error={!this.state.isrcRegnUptoValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["InputLabel"],{htmlFor:'stateCd',style:{marginTop:'-10px'},shrink:!!(this.state.stateCd||this.state.vehicleData&&this.state.vehicleData.stateCd)},'State Code'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'stateCd',name:'stateCd',className:'textfield',margin:'dense'//label="State Code"
,type:'text'// type="Multi-line"
,value:this.state.vehicleData?this.state.vehicleData.stateCd:this.state.stateCd,onChange:this.handleInputChange('stateCd')//error={!this.state.isstateCdValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["InputLabel"],{htmlFor:'rtoCd',style:{marginTop:'-10px'},shrink:!!(this.state.rtoCd||this.state.vehicleData&&this.state.vehicleData.rtoCd)},'RTO Code'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'rtoCd',name:'rtoCd',className:'textfield',margin:'dense'//label="RTO Code"
,type:'text'// type="Multi-line"
,value:this.state.vehicleData?this.state.vehicleData.rtoCd:this.state.rtoCd,onChange:this.handleInputChange('rtoCd')//error={!this.state.isrtoCdValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["InputLabel"],{htmlFor:'rcVchCatg',style:{marginTop:'-10px'},shrink:!!(this.state.rcVchCatg||this.state.vehicleData&&this.state.vehicleData.rcVchCatg)},'Vehicle Category Code'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'rcVchCatg',name:'rcVchCatg',className:'textfield',margin:'dense'//label="Vehicle Category Code"
,type:'text'// type="Multi-line"
,value:this.state.vehicleData?this.state.vehicleData.rcVchCatg:this.state.rcVchCatg,onChange:this.handleInputChange('rcVchCatg')//error={!this.state.isrcVchCatgValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["InputLabel"],{htmlFor:'rcVhClassDesc',style:{marginTop:'-10px'},shrink:!!(this.state.rcVhClassDesc||this.state.vehicleData&&this.state.vehicleData.rcVhClassDesc)},'Vehicle Class Description'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'rcVhClassDesc',name:'rcVhClassDesc',className:'textfield',margin:'dense'//label="Vehicle Class Description"
,type:'text'// type="Multi-line"
,value:this.state.vehicleData?this.state.vehicleData.rcVhClassDesc:this.state.rcVhClassDesc,onChange:this.handleInputChange('rcVhClassDesc')//error={!this.state.isrcVhClassDescValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["InputLabel"],{htmlFor:'rcChasiNo',style:{marginTop:'-10px'},shrink:!!(this.state.rcChasiNo||this.state.vehicleData&&this.state.vehicleData.rcChasiNo)},'Chassis Number'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'rcChasiNo',name:'rcChasiNo',className:'textfield',margin:'dense'//label="Chassis Number"
,type:'text'// type="Multi-line"
,value:this.state.vehicleData?this.state.vehicleData.rcChasiNo:this.state.rcChasiNo,onChange:this.handleInputChange('rcChasiNo')//error={!this.state.isrcChasiNoValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["InputLabel"],{htmlFor:'rcEngNo',style:{marginTop:'-10px'},shrink:!!(this.state.rcEngNo||this.state.vehicleData&&this.state.vehicleData.rcEngNo)},'Engine Number'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'rcEngNo',name:'rcEngNo',className:'textfield',margin:'dense'//label="Engine Number"
,type:'text'// type="Multi-line"
,value:this.state.vehicleData?this.state.vehicleData.rcEngNo:this.state.rcEngNo,onChange:this.handleInputChange('rcEngNo')//error={!this.state.isrcEngNoValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["InputLabel"],{htmlFor:'rcBodyTypeDesc',style:{marginTop:'-10px'},shrink:!!(this.state.rcBodyTypeDesc||this.state.vehicleData&&this.state.vehicleData.rcBodyTypeDesc)},'Body Type Description'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'rcBodyTypeDesc',name:'rcBodyTypeDesc',className:'textfield',margin:'dense'//label="Body Type Description"
,type:'text'// type="Multi-line"
,value:this.state.vehicleData?this.state.vehicleData.rcBodyTypeDesc:this.state.rcBodyTypeDesc,onChange:this.handleInputChange('rcBodyTypeDesc')//error={!this.state.isrcBodyTypeDescValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{xs:12,sm:12,mt:4,style:{marginTop:'20px'}},'Fuel Type'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},this.state.vehicleSegment!=='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select__["a" /* default */],{id:'rcFuelDesc',name:'rcFuelDesc',classes:classes,options:[{value:'petrol',label:'PETROL'},{value:'diesel',label:'DIESEL'},{value:'ev',label:'EV'},{value:'cng',label:'CNG'},{value:'lng',label:'LNG'}]// components={components}
// value={this.state.rcFuelDesc}
,value:this.state.vehicleData&&this.state.vehicleData.rcFuelDesc?this.state.vehicleData.rcFuelDesc.toLowerCase():this.state.rcFuelDesc,onChange:function onChange(selectedOption){_this3.setState({rcFuelDesc:selectedOption?selectedOption.value:''});},placeholder:'Fuel Type'//disabled={this.state.fuelTypeFromApi}
}),this.state.vehicleSegment==='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select__["a" /* default */],{id:'rcFuelDesc',name:'rcFuelDesc',classes:classes,options:[{value:'petrol',label:'PETROL'},{value:'diesel',label:'DIESEL'}]// components={components}
//value={this.state.fuelType}
,value:this.state.vehicleData?this.state.vehicleData.rcFuelDesc:this.state.rcFuelDesc,onChange:function onChange(selectedOption){_this3.setState({rcFuelDesc:selectedOption?selectedOption.value:''});},placeholder:'Fuel Type'//disabled={this.state.fuelTypeFromApi}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["InputLabel"],{htmlFor:'rcNormsDesc',style:{marginTop:'-10px'},shrink:!!(this.state.rcNormsDesc||this.state.vehicleData&&this.state.vehicleData.rcNormsDesc)},'Emission Norms Description'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'rcNormsDesc',name:'rcNormsDesc',className:'textfield',margin:'dense'//label="Emission Norms Description"
,type:'text'// type="Multi-line"
,value:this.state.vehicleData?this.state.vehicleData.rcNormsDesc:this.state.rcNormsDesc,onChange:this.handleInputChange('rcNormsDesc')//error={!this.state.isrcNormsDescValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["InputLabel"],{htmlFor:'rcFitUpto',style:{marginTop:'-10px'},shrink:!!(this.state.rcFitUpto||this.state.vehicleData&&this.state.vehicleData.rcFitUpto)},'Fitment Upto'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'rcFitUpto',name:'rcFitUpto',className:'textfield',margin:'dense'//label="Fitment Upto"
,type:'text'// type="Multi-line"
,value:this.state.vehicleData?this.state.vehicleData.rcFitUpto:this.state.rcFitUpto,onChange:this.handleInputChange('rcFitUpto')//error={!this.state.isrcFitUptoValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["InputLabel"],{htmlFor:'rcNpUpto',style:{marginTop:'-10px'},shrink:!!(this.state.rcNpUpto||this.state.vehicleData&&this.state.vehicleData.rcNpUpto)},'National Permit Upto'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'rcNpUpto',name:'rcNpUpto',className:'textfield',margin:'dense'//label="National Permit Upto"
,type:'text'// type="Multi-line"
,value:this.state.vehicleData?this.state.vehicleData.rcNpUpto:this.state.rcNpUpto,onChange:this.handleInputChange('rcNpUpto')//error={!this.state.isrcNpUptoValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["InputLabel"],{htmlFor:'rcTaxUpto',style:{marginTop:'-10px'},shrink:!!(this.state.rcTaxUpto||this.state.vehicleData&&this.state.vehicleData.rcTaxUpto)},'Tax Upto'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'rcTaxUpto',name:'rcTaxUpto',className:'textfield',margin:'dense'//label="Tax Upto"
,type:'text'// type="Multi-line"
,value:this.state.vehicleData?this.state.vehicleData.rcTaxUpto:this.state.rcTaxUpto,onChange:this.handleInputChange('rcTaxUpto')//error={!this.state.isrcTaxUptoValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["InputLabel"],{htmlFor:'rcInsuranceComp',style:{marginTop:'-10px'},shrink:!!(this.state.rcInsuranceComp||this.state.vehicleData&&this.state.vehicleData.rcInsuranceComp)},'Insurer Name'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'rcInsuranceComp',name:'rcInsuranceComp',className:'textfield',margin:'dense'//label="Insurer Name"
,type:'text'// type="Multi-line"
,value:this.state.vehicleData?this.state.vehicleData.rcInsuranceComp:this.state.rcInsuranceComp,onChange:this.handleInputChange('rcInsuranceComp')//error={!this.state.isrcInsuranceCompValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["InputLabel"],{htmlFor:'rcInsuranceUpto',style:{marginTop:'-10px'},shrink:!!(this.state.rcInsuranceUpto||this.state.vehicleData&&this.state.vehicleData.rcInsuranceUpto)},'Insurer Upto'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'rcInsuranceUpto',name:'rcInsuranceUpto',className:'textfield',margin:'dense'//label="Insurance Upto"
,type:'text'// type="Multi-line"
,value:this.state.vehicleData?this.state.vehicleData.rcInsuranceUpto:this.state.rcInsuranceUpto,onChange:this.handleInputChange('rcInsuranceUpto')//error={!this.state.isrcInsuranceUptoValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["InputLabel"],{htmlFor:'rcManuMonthYr',style:{marginTop:'-10px'},shrink:!!(this.state.rcManuMonthYr||this.state.vehicleData&&this.state.vehicleData.rcManuMonthYr)},'Manufacturing Month/Year'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'rcManuMonthYr',name:'rcManuMonthYr',className:'textfield',margin:'dense'//label="Manufacturing Month/Year"
,type:'text'// type="Multi-line"
,value:this.state.vehicleData?this.state.vehicleData.rcManuMonthYr:this.state.rcManuMonthYr,onChange:this.handleInputChange('rcManuMonthYr')//error={!this.state.isrcManuMonthYrValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["InputLabel"],{htmlFor:'rcUnldWt',style:{marginTop:'-10px'},shrink:!!(this.state.rcUnldWt||this.state.vehicleData&&this.state.vehicleData.rcUnldWt)},'Unladen Weight'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'rcUnldWt',name:'rcUnldWt',className:'textfield',margin:'dense'//label="Unladen Weight"
,type:'number'// type="Multi-line"
,value:this.state.vehicleData?this.state.vehicleData.rcUnldWt:this.state.rcUnldWt,onChange:this.handleInputChange('rcUnldWt')//error={!this.state.isrcUnldWtValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["InputLabel"],{htmlFor:'rcGvw',style:{marginTop:'-10px'},shrink:!!(this.state.rcGvw||this.state.vehicleData&&this.state.vehicleData.rcGvw)},'Gross Vehicle Weight (GVW)'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'rcGvw',name:'rcGvw',className:'textfield',margin:'dense',value:this.state.vehicleData?this.state.vehicleData.rcGvw:this.state.rcGvw,onChange:this.handleInputChange('rcGvw'),type:'number',inputProps:{step:'0.01'}//error={!this.state.isrcGvwValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["InputLabel"],{htmlFor:'rcRegisteredAt',style:{marginTop:'-10px'},shrink:!!(this.state.rcRegisteredAt||this.state.vehicleData&&this.state.vehicleData.rcRegisteredAt)},'Registered At'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'rcRegisteredAt',name:'rcRegisteredAt',className:'textfield',margin:'dense'//label="Registered At"
,type:'text'// type="Multi-line"
,value:this.state.vehicleData?this.state.vehicleData.rcRegisteredAt:this.state.rcRegisteredAt,onChange:this.handleInputChange('rcRegisteredAt')//error={!this.state.isrcRegisteredAtValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["InputLabel"],{htmlFor:'rcPuccUpto',style:{marginTop:'-10px'},shrink:!!(this.state.rcPuccUpto||this.state.vehicleData&&this.state.vehicleData.rcPuccUpto)},'Pollution Under Control Certificate (PUCC) Upto'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'rcPuccUpto',name:'rcPuccUpto',className:'textfield',margin:'dense'//label="Pollution Under Control Certificate (PUCC) Upto"
,type:'text'// type="Multi-line"
,value:this.state.vehicleData?this.state.vehicleData.rcPuccUpto:this.state.rcPuccUpto,onChange:this.handleInputChange('rcPuccUpto')//error={!this.state.isrcPuccUptoValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["InputLabel"],{htmlFor:'rcPermitNo',style:{marginTop:'-10px'},shrink:!!(this.state.rcPermitNo||this.state.vehicleData&&this.state.vehicleData.rcPermitNo)},'Permit Number'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'rcPermitNo',name:'rcPermitNo',className:'textfield',margin:'dense'//label="Permit Number"
,type:'text'// type="Multi-line"
,value:this.state.vehicleData?this.state.vehicleData.rcPermitNo:this.state.rcPermitNo,onChange:this.handleInputChange('rcPermitNo')//error={!this.state.isrcPermitNoValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["InputLabel"],{htmlFor:'rcPermitIssueDt',style:{marginTop:'-10px'},shrink:!!(this.state.rcPermitIssueDt||this.state.vehicleData&&this.state.vehicleData.rcPermitIssueDt)},'Permit Issue Date'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'rcPermitIssueDt',name:'rcPermitIssueDt',className:'textfield',margin:'dense'//label="Permit Issue Date"
,type:'text'// type="Multi-line"
,value:this.state.vehicleData?this.state.vehicleData.rcPermitIssueDt:this.state.rcPermitIssueDt,onChange:this.handleInputChange('rcPermitIssueDt')//error={!this.state.isrcPermitIssueDtValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["InputLabel"],{htmlFor:'rcPermitValidFrom',style:{marginTop:'-10px'},shrink:!!(this.state.rcPermitValidFrom||this.state.vehicleData&&this.state.vehicleData.rcPermitValidFrom)},'Permit Valid From'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'rcPermitValidFrom',name:'rcPermitValidFrom',className:'textfield',margin:'dense'//label="Permit Valid From"
,type:'text'// type="Multi-line"
,value:this.state.vehicleData?this.state.vehicleData.rcPermitValidFrom:this.state.rcPermitValidFrom,onChange:this.handleInputChange('rcPermitValidFrom')//error={!this.state.isrcPermitValidFromValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["InputLabel"],{htmlFor:'rcPermitValidUpto',style:{marginTop:'-10px'},shrink:!!(this.state.rcPermitValidUpto||this.state.vehicleData&&this.state.vehicleData.rcPermitValidUpto)},'Permit Valid Upto'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'rcPermitValidUpto',name:'rcPermitValidUpto',className:'textfield',margin:'dense'//label="Permit Valid Upto"
,type:'text'// type="Multi-line"
,value:this.state.vehicleData?this.state.vehicleData.rcPermitValidUpto:this.state.rcPermitValidUpto,onChange:this.handleInputChange('rcPermitValidUpto')//error={!this.state.isrcPermitValidUptoValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["InputLabel"],{htmlFor:'rcPermitType',style:{marginTop:'-10px'},shrink:!!(this.state.vehicleData&&this.state.vehicleData.rcPermitType||this.state.rcPermitType)},'Permit Type'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'rcPermitType',name:'rcPermitType',className:'textfield',margin:'dense'//label="Permit Type"
,type:'text'// type="Multi-line"
,value:this.state.vehicleData?this.state.vehicleData.rcPermitType:this.state.rcPermitType,onChange:this.handleInputChange('rcPermitType')//error={!this.state.isrcPermitTypeValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["InputLabel"],{htmlFor:'rcPermitCode',style:{marginTop:'-10px'},shrink:!!(this.state.vehicleData&&this.state.vehicleData.rcPermitCode||this.state.rcPermitCode)},'Permit Code'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'rcPermitCode',name:'rcPermitCode',className:'textfield',margin:'dense'//label="Permit Code"
,type:'text'// type="Multi-line"
,value:this.state.vehicleData?this.state.vehicleData.rcPermitCode:this.state.rcPermitCode,onChange:this.handleInputChange('rcPermitCode')//error={!this.state.isrcPermitCodeValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["InputLabel"],{htmlFor:'rcNoOfAxle',style:{marginTop:'-10px'},shrink:!!(this.state.vehicleData&&this.state.vehicleData.rcNoOfAxle||this.state.rcNoOfAxle)},'Number of Axles'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'rcNoOfAxle',name:'rcNoOfAxle',className:'textfield',margin:'dense'//label="Number of Axles"
,type:'number'// type="Multi-line"
,value:this.state.vehicleData?this.state.vehicleData.rcNoOfAxle:this.state.rcNoOfAxle,onChange:this.handleInputChange('rcNoOfAxle')//error={!this.state.isrcNoOfAxleValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["InputLabel"],{htmlFor:'rcFuelCd',style:{marginTop:'-10px'},shrink:!!(this.state.vehicleData&&this.state.vehicleData.rcFuelCd||this.state.rcFuelCd)},'Fuel Code'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'rcFuelCd',name:'rcFuelCd',className:'textfield',margin:'dense'//label="Fuel Code"
,type:'text'// type="Multi-line"
,value:this.state.vehicleData?this.state.vehicleData.rcFuelCd:this.state.rcFuelCd,onChange:this.handleInputChange('rcFuelCd')//error={!this.state.isrcFuelCdValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["InputLabel"],{htmlFor:'rcVhType',style:{marginTop:'-10px'},shrink:function(){var _state5=_this3.state,vehicleSegment=_state5.vehicleSegment,transportationVehicleType=_state5.transportationVehicleType,constructionVehicleType=_state5.constructionVehicleType,passengerVehicleType=_state5.passengerVehicleType,vehicleData=_state5.vehicleData,rcVhType=_state5.rcVhType;if(vehicleSegment==='Transportation')return!!transportationVehicleType;if(vehicleSegment==='Construction')return!!constructionVehicleType;if(vehicleSegment==='Passenger')return!!passengerVehicleType;return!!(vehicleSegment||rcVhType||vehicleData&&vehicleData.rcVhType);}()},'Vehicle Type'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'rcVhType',name:'rcVhType',className:'textfield',margin:'dense'//label="Vehicle Type"
,type:'text'// type="Multi-line"
,value:function(){var _state6=_this3.state,vehicleSegment=_state6.vehicleSegment,transportationVehicleType=_state6.transportationVehicleType,constructionVehicleType=_state6.constructionVehicleType,passengerVehicleType=_state6.passengerVehicleType,vehicleData=_state6.vehicleData,rcVhType=_state6.rcVhType;if(vehicleSegment==='Transportation')return transportationVehicleType||'';if(vehicleSegment==='Construction')return constructionVehicleType||'';if(vehicleSegment==='Passenger')return passengerVehicleType||'';return vehicleSegment||rcVhType||vehicleData&&vehicleData.rcVhType;}(),onChange:this.handleInputChange('rcVhType')//error={!this.state.isrcVhTypeValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["InputLabel"],{htmlFor:'rcVhClass',style:{marginTop:'-10px'},shrink:!!(this.state.vehicleData&&this.state.vehicleData.rcVhClass||this.state.rcVhClass)},'Vehicle Class'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'rcVhClass',name:'rcVhClass',className:'textfield',margin:'dense'//label="Vehicle Class"
,type:'text'// type="Multi-line"
,value:this.state.vehicleData?this.state.vehicleData.rcVhClass:this.state.rcVhClass,onChange:this.handleInputChange('rcVhClass')//error={!this.state.isrcVhClassValid}
})))),this.state.vehicleSegment=='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{xs:12,sm:12,mt:4,style:{marginTop:'15px'}},'Vehicle/Asset Type *',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select__["a" /* default */],{classes:classes,options:allvehicleTypes,value:this.state.vehicleType,onChange:this.handleChangeType,placeholder:'Select vehicle Type',disabled:this.state.vehicleSegment=='DG Set'?true:false}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isClientNameValid?'Invalid Selection':'')))),this.state.vehicleSegment=='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{xs:12,sm:12,mt:4},'Select Make *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select__["a" /* default */],{id:'vehicleMake',name:'vehicleMake',classes:classes,options:this.state.makesList.map(function(item){return{value:item.id,label:item.make};}),value:this.state.vehicleMakeId,onChange:this.handleChangeMake,placeholder:'Select'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isVehicleMakeValid?'Invalid Vehicle Make':'')))),this.state.vehicleSegment=='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{xs:12,sm:12,mt:4},'Select Model *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select__["a" /* default */],{id:'vehicleModel',name:'vehicleModel',classes:classes,options:this.state.modelsList.map(function(item){return{value:item.id,label:item.model};}),value:this.state.vehicleModelId,onChange:this.handleChangeModel,placeholder:'Select',error:!this.state.isVehicleModelValid}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isVehicleModelValid?'Invalid Vehicle Model':'')))),this.state.vehicleSegment=='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{xs:12,sm:12,mt:4},'KVA Rating *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select__["a" /* default */],{id:'kvaRating',name:'kvaRating',classes:classes,options:this.state.kvaRatingOptions,value:this.state.kvaRating,onChange:this.handleInputChange('kvaRating'),placeholder:'KVA Rating'// error={!this.state.isVehicleModelValid}
}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isVehicleModelValid?'Invalid Vehicle Model':'')))),this.state.vehicleSegment=='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{xs:12,sm:12,mt:4},'DG Set Type *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select__["a" /* default */],{id:'dgSetType',name:'dgSetType',classes:classes,options:this.state.dgSetTypeOptions,value:this.state.dgSetType,onChange:this.handleInputChange('dgSetType'),placeholder:'DG Set Type'// error={!this.state.isVehicleModelValid}
}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isVehicleModelValid?'Invalid Vehicle Model':'')))),this.state.vehicleSegment=='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'15px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},'Manufacturing Year',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select__["a" /* default */],{options:this.state.manufacturingYearOptions,value:this.state.manufacturingYear,onChange:this.handleInputChangeNew('manufacturingYear'),placeholder:'Manufacturing Year',name:'manufacturingYear',disabled:this.state.manufacturingYearFromApi})))),this.state.vehicleSegment=='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{xs:12,sm:12,style:{marginTop:'5px'}},'Fuel Type:'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select__["a" /* default */],{id:'rcFuelDesc',name:'rcFuelDesc',classes:classes,options:[{value:'petrol',label:'PETROL'},{value:'diesel',label:'DIESEL'}]// components={components}
//value={this.state.fuelType}
,value:this.state.vehicleData?this.state.vehicleData.rcFuelDesc:this.state.rcFuelDesc,onChange:function onChange(selectedOption){_this3.setState({rcFuelDesc:selectedOption?selectedOption.value:''});},placeholder:'Fuel Type'//disabled={this.state.fuelTypeFromApi}
}))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,fullwidth:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["InputLabel"],{htmlFor:'vehicleNickName',style:{marginTop:'-10px'},shrink:this.state.vehicleNickName||this.state.vehicleData&&this.state.vehicleData.rcRegnNo||this.state.rcRegnNo},'Vehicle Name/Number to be displayed on vehicle card (ex. Hyva Truck 08)'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'vehicleNickName',name:'vehicleNickName',className:'textfield',margin:'dense',type:'text',value:this.state.vehicleNickName||this.state.vehicleData&&this.state.vehicleData.rcRegnNo||this.state.rcRegnNo,onChange:this.handleInputChange('vehicleNickName')}))))),this.state.activeStep===1&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__VehicleInfoStep__["a" /* default */],{state:this.state,classes:classes,client:this.props.client,setState:this.setState.bind(this),handleInputChange:this.handleInputChange,checkVlpnValidity:this.checkVlpnValidity,handleChangeSpeedSensor:this.handleChangeSpeedSensor,checkSpeedSensorValidity:this.checkSpeedSensorValidity,checkSpeedLimitValidity:this.checkSpeedLimitValidity,handleFileChange:this.handleFileChange,documentUploadNewData:this.state.documentUploadNewData,handleDocumentUploadNewDataChange:this.handleDocumentUploadNewDataChange,handleDownload:this.handleDownload,handleRemove:this.handleRemove,handleDateChange:this.handleDateChange,handleChangeIdlingSpeed:this.handleChangeIdlingSpeed,handleChangeInputParameter:this.handleChangeInputParameter,handleChangeMultiplicationFactor:this.handleChangeMultiplicationFactor,handleChangeDevice:this.handleChangeDevice,handleChangePhoneNumber:this.handleChangePhoneNumber,handleChangeAccessories:this.handleChangeAccessories,handleTechnicianCategoryChange:this.handleTechnicianCategoryChange,handleTaabiSelectChange:this.handleTaabiSelectChange,handleFreelancerSelectChange:this.handleFreelancerSelectChange,handleChangeSubscription:this.handleChangeSubscription,checkItemValidity:this.checkItemValidity,handleChangeMake:this.handleChangeMake,handleChangeModelNew:this.handleChangeModelNew,checkDualEngineVoltageValidity:this.checkDualEngineVoltageValidity,checkAdblueCapacityValidity:this.checkAdblueCapacityValidity,checkBaselineDataForFEValidity:this.checkBaselineDataForFEValidity,checkBaselineDistanceValidity:this.checkBaselineDistanceValidity,checkBaselineHoursValidity:this.checkBaselineHoursValidity,handleVideoTelematicsMenuChange:this.handleVideoTelematicsMenuChange,handleVtidChange:this.handleVtidChange,handleVideoTelematicsIdChange:this.handleVideoTelematicsIdChange}),this.state.activeStep===2&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__InstallationSubmissionStep__["a" /* default */],{state:this.state,classes:classes,handleChange:this.handleChange,handleImmobilizeChange:this.handleImmobilizeChange,handleInputChange:this.handleInputChange}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,justify:'center',spacing:2,style:{marginTop:'20px',marginBottom:'20px'}},this.state.activeStep>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{variant:'outlined',color:'primary',className:'btn',onClick:this.handleBack},'Back'),this.state.activeStep<2&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["Tooltip"],{title:(this.state.activeStep===0?this.getStep0MissingFields():this.getStep1MissingFields()).join(', ')||'',disableHoverListener:!(this.state.activeStep===0?this.isStep0Invalid():this.isStep1Invalid())},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{cursor:'not-allowed'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{variant:'contained',color:'primary',className:'btn',onClick:this.handleNext,disabled:this.state.activeStep===0?this.isStep0Invalid():this.isStep1Invalid()},'Next'))),this.state.activeStep===2&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["Tooltip"],{title:this.getSubmitMissingFields().join(', ')||'',disableHoverListener:!this.isSubmitFormInvalid()},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{cursor:'not-allowed'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{variant:'contained',color:'secondary',size:'medium',margin:'normal',className:'btn',type:'button',onClick:function onClick(){if(_this3.state.solution_type&&_this3.state.solution_type.includes('vt')&&!_this3.state.videoTelematicsId){_this3.setState({vtValidationError:'Please select a Video Telematics ID before submitting.'});return;}_this3.setState({vtValidationError:null});_this3.handleOpenPreviewModal(true);},disabled:this.isSubmitFormInvalid()},'Submit'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{color:'default',variant:'outlined',size:'medium',margin:'normal',className:'btn',onClick:function onClick(){return _this3.props.history.goBack();}},'Cancel')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},this.state.vtValidationError&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{style:{color:'red',textAlign:'center',marginBottom:'8px',fontWeight:500}},this.state.vtValidationError))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__VehiclePreviewModal__["a" /* default */],{open:this.state.previewModalOpen,onClose:this.handleClosePreviewModal,vehicleData:this.state.previewData,hasSecondaryTank:this.state.hasSecondaryTank,calibrationLoading:this.state.calibrationLoading,calibrationError:this.state.calibrationError,availableDataTypes:this.state.availableDataTypes,preferedDataType:this.state.preferedDataType,isDualSensor:this.state.isDualSensor,hasInSameTank:this.state.hasInSameTank,calibrationFilename:this.state.calibration_filename,fuelSensorType:this.state.fuelSensorType,onConfirm:function onConfirm(mutationInput){_this3.handleSubmit(_this3.props.client,mutationInput)({preventDefault:function preventDefault(){}});_this3.setState({previewModalOpen:false});}}));}}]);return VehicleRegistration;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this4=this;this.handleNext=function(){_this4.setState(function(prevState){return{activeStep:prevState.activeStep+1};});};this.handleBack=function(){_this4.setState(function(prevState){return{activeStep:prevState.activeStep-1};});};this.getPreviewData=function(){var _ref;return _ref={vehicleNumber:_this4.state.vehicleNumber?_this4.state.vehicleNumber:_this4.state.vehicleSegment=='DG Set'?_this4.state.vlpn:_this4.state.vehicleData?_this4.state.vehicleData.rcRegnNo:_this4.state.rcRegnNo,solutionType:_this4.state.solutionType,uniqueDeviceId:_this4.state.serialNumber,clientLoginId:parseInt(_this4.state.clientName,10),videoTelematicsTypeFromVehicleReg:_this4.state.selectedVTM&&_this4.state.selectedVTM.value?_this4.state.selectedVTM.value:null,fuelType:(_this4.state.vehicleData&&_this4.state.vehicleData.rcFuelDesc?_this4.state.vehicleData.rcFuelDesc:_this4.state.rcFuelDesc)?(_this4.state.vehicleData&&_this4.state.vehicleData.rcFuelDesc?_this4.state.vehicleData.rcFuelDesc:_this4.state.rcFuelDesc).toLowerCase():'',vehicleMake:_this4.state.vehicleSegment=='DG Set'||_this4.state.deviceType=='obd'||_this4.state.deviceType=='OBD'?_this4.state.vehicleMake:_this4.state.vehicleData?_this4.state.vehicleData.rcMakerDesc:_this4.state.rcMakerDesc,vehicleModel:_this4.state.vehicleSegment=='DG Set'||_this4.state.deviceType=='obd'||_this4.state.deviceType=='OBD'?_this4.state.vehicleModel:_this4.state.vehicleData?_this4.state.vehicleData.rcMakerModel:_this4.state.rcMakerModel,noOfGears:parseInt(_this4.state.noOfGears),gearRatio:_this4.state.gearRatio,isDualEngine:_this4.state.isDualEngine,hasArm:_this4.state.hasArm,isElockConnection:_this4.state.isElockConnection,isRotationSensor:_this4.state.isRotationSensor},_defineProperty(_ref,'solutionType',_this4.state.solutionType),_defineProperty(_ref,'solution_type',_this4.state.vehicleTypes),_ref;};this.handleOpenPreviewModal=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var isSubmitAction=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var previewData,_ref3,vehiclesData,vehicle,hasSecondaryTank,availableDataTypes,preferedDataType,isDualSensor,hasInSameTank,calibration_filename,fuelSensorType,_ref4,calibrationData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:previewData=_this4.getPreviewData();console.log('Preview Data:',previewData);_this4.setState({calibrationLoading:true,calibrationError:null,isSubmitAction:isSubmitAction});_context.prev=3;_context.next=6;return _this4.props.client.query({query:__WEBPACK_IMPORTED_MODULE_30__queries__["h" /* GET_ALL_VEHICLES */],variables:{clientLoginId:previewData.clientLoginId},fetchPolicy:'network-only'});case 6:_ref3=_context.sent;vehiclesData=_ref3.data;// 2. Find entityId for selected vehicleNumber
vehicle=vehiclesData.getAllVehicleDetails.find(function(v){return v.vehicleNumber===previewData.vehicleNumber;});hasSecondaryTank=null;availableDataTypes=null;preferedDataType=null;isDualSensor=null;hasInSameTank=null;calibration_filename=null;fuelSensorType=null;if(!(vehicle&&vehicle.entityId)){_context.next=22;break;}_context.next=19;return _this4.props.client.query({query:__WEBPACK_IMPORTED_MODULE_30__queries__["i" /* GET_CALIBRATION_DETAILS */],variables:{entityId:vehicle.entityId},fetchPolicy:'network-only'});case 19:_ref4=_context.sent;calibrationData=_ref4.data;if(calibrationData&&calibrationData.getFuelCalibrationDetail){if(typeof calibrationData.getFuelCalibrationDetail.hasSecondaryTank!=='undefined'){hasSecondaryTank=calibrationData.getFuelCalibrationDetail.hasSecondaryTank;}if(typeof calibrationData.getFuelCalibrationDetail.availableDataTypes!=='undefined'){availableDataTypes=calibrationData.getFuelCalibrationDetail.availableDataTypes;}if(typeof calibrationData.getFuelCalibrationDetail.preferedDataType!=='undefined'){preferedDataType=calibrationData.getFuelCalibrationDetail.preferedDataType;}if(typeof calibrationData.getFuelCalibrationDetail.isDualSensor!=='undefined'){isDualSensor=calibrationData.getFuelCalibrationDetail.isDualSensor;}if(typeof calibrationData.getFuelCalibrationDetail.hasInSameTank!=='undefined'){hasInSameTank=calibrationData.getFuelCalibrationDetail.hasInSameTank;}if(typeof calibrationData.getFuelCalibrationDetail.calibration_filename!=='undefined'){calibration_filename=calibrationData.getFuelCalibrationDetail.calibration_filename;}if(typeof calibrationData.getFuelCalibrationDetail.fuelSensorType!=='undefined'){fuelSensorType=calibrationData.getFuelCalibrationDetail.fuelSensorType;}}case 22:_this4.setState({previewModalOpen:true,previewData:previewData,hasSecondaryTank:hasSecondaryTank,availableDataTypes:availableDataTypes,preferedDataType:preferedDataType,isDualSensor:isDualSensor,hasInSameTank:hasInSameTank,calibration_filename:calibration_filename,fuelSensorType:fuelSensorType,calibrationLoading:false,calibrationError:null,isSubmitAction:isSubmitAction});_context.next=28;break;case 25:_context.prev=25;_context.t0=_context['catch'](3);_this4.setState({previewModalOpen:true,previewData:previewData,hasSecondaryTank:null,availableDataTypes:null,preferedDataType:null,isDualSensor:null,hasInSameTank:null,calibration_filename:null,fuelSensorType:null,calibrationLoading:false,calibrationError:_context.t0.message||'Error fetching calibration details',isSubmitAction:isSubmitAction});case 28:case'end':return _context.stop();}}},_callee,_this4,[[3,25]]);}));this.handleClosePreviewModal=function(){_this4.setState({previewModalOpen:false,previewData:null});};this.checkBaselineDistanceValidity=function(){var baselineDistance=_this4.state.baselineDistance;// Consider an empty string as valid to reset validation state when input is cleared
var isValid=baselineDistance===''||/\d+/.test(baselineDistance)&&// Check if the input contains at least one digit
/^\d+$/.test(baselineDistance)&&// Check if the input is a positive integer
parseInt(baselineDistance)>0&&parseInt(baselineDistance)<=2000000;_this4.setState({isBaselineDistanceValid:isValid});};this.checkBaselineHoursValidity=function(){var baselineHours=_this4.state.baselineHours;// Consider an empty string as valid to reset validation state when input is cleared
var isValid=baselineHours===''||/\d+/.test(baselineHours)&&// Check if the input contains at least one digit
/^\d+$/.test(baselineHours)&&// Check if the input is a positive integer
parseInt(baselineHours)>0&&parseInt(baselineHours)<=24;_this4.setState({isBaselineHoursValid:isValid});};this.checkeoff_voltageValidity=function(){var regex=new RegExp(/^\d+(\.\d{1,2})?$/);// Allows any number of digits with optional decimal
_this4.setState({iseoff_voltageValid:regex.test(_this4.state.eoff_voltage)||_this4.state.eoff_voltage===''});};this.checkeon_voltageValidity=function(){var regex=new RegExp(/^\d+(\.\d{1,2})?$/);// Same pattern for eon voltage
_this4.setState({iseon_voltageValid:regex.test(_this4.state.eon_voltage)||_this4.state.eon_voltage===''});};this.checkBaselineDataForFEValidity=function(){var baselineDataForFE=_this4.state.baselineDataForFE;// Consider an empty string as valid to reset validation state when input is cleared
var isValid=baselineDataForFE===''||!isNaN(parseFloat(baselineDataForFE))&&parseFloat(baselineDataForFE)>=0.5&&parseFloat(baselineDataForFE)<=20&&/^(\d+(\.\d{0,2})?|\.?\d{1,2})$/.test(baselineDataForFE);_this4.setState({isBaselineDataForFEValid:isValid});};this.checkAdblueCapacityValidity=function(){var _state7=_this4.state,deviceType=_state7.deviceType,adblueCapacity=_state7.adblueCapacity;var isValid=true;if(deviceType&&deviceType.toLowerCase()==='obd'){isValid=!!adblueCapacity&&adblueCapacity.toString().trim()!=='';}_this4.setState({isAdblueCapacityValid:isValid});return isValid;};this.checkDualEngineVoltageValidity=function(){var _state8=_this4.state,isDualEngine=_state8.isDualEngine,eon_voltage=_state8.eon_voltage,eoff_voltage=_state8.eoff_voltage;var isEonVoltageValid=true;var isEoffVoltageValid=true;if(isDualEngine){isEonVoltageValid=eon_voltage!==null&&eon_voltage!==''&&!isNaN(eon_voltage);isEoffVoltageValid=eoff_voltage!==null&&eoff_voltage!==''&&!isNaN(eoff_voltage);}_this4.setState({isEonVoltageValid:isEonVoltageValid,isEoffVoltageValid:isEoffVoltageValid});return isEonVoltageValid&&isEoffVoltageValid;};this.handleSegmentChange=function(option){var selectedValue=option?option.value:'';_this4.setState({vehicleSegment:selectedValue},function(){console.log('Selected Vehicle Segment: ',selectedValue);// this.updateDependentFieldsBasedOnSegment(selectedValue);    ..
if(selectedValue==='DG Set'){_this4.updateDGSetData();}});setTimeout(function(){if(_this4.state.vehicleSegment=='DG Set'){_this4.updateDGSetData();}},500);if(_this4.state.vehicleSegment=='DG Set'){_this4.setState({vehicleRegistrationNumberAvailableStatus:false,enteredVehicleRegistrationNumber:''});_this4.flushVahaanValues();}};this.handleEquipmentTypeClassTextChange=function(event){_this4.setState({equipmentTypeClassText:event.target.value});};this.handleInputChangeNew=function(inputName){return function(event){try{var value=event.value;_this4.setState(_defineProperty({},inputName,value),function(){if(inputName==='vehicleSegment'){//  this.updateDependentFieldsBasedOnSegment()
}});}catch(error){var _value='';_this4.setState(_defineProperty({},inputName,_value),function(){if(inputName==='vehicleSegment'){//  this.updateDependentFieldsBasedOnSegment()
}});}};};this.handleDocumentUploadNewDataChange=function(fileName,field,value){_this4.setState(function(prevState){return{documentUploadNewData:Object.assign({},prevState.documentUploadNewData,_defineProperty({},fileName,Object.assign({},prevState.documentUploadNewData[fileName],_defineProperty({},field,value))))};});};this.handleFileChange=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(event){var files,maxSize,maxFiles,fileNames,uploadProgress,uploadPromises,totalSize,i,file,fileExtension,allowedTypes,response,updatedFileNames;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:files=event.target.files;// Access all uploaded files
maxSize=30*1024*1024;// 30MB in bytes
maxFiles=50;// Maximum number of files allowed
fileNames=_this4.state.fileNames||'';// Initialize fileNames to an empty string if undefined
fileNames=fileNames?fileNames.split(','):[];uploadProgress=Object.assign({},_this4.state.uploadProgress);// Copy existing upload progress
uploadPromises=[];// Array to store upload promises
totalSize=0;// Variable to track total size of files
_this4.setState({errorMessage:null,isUploading:true});if(!(files.length<=50)){_context2.next=49;break;}i=0;case 11:if(!(i<files.length)){_context2.next=36;break;}file=files[i];fileExtension=file.name.substring(file.name.lastIndexOf('.')+1).toLowerCase();allowedTypes=['jpeg','jpg','png','pdf'];if(allowedTypes.includes(fileExtension)){_context2.next=18;break;}_this4.setState({errorMessage:'File '+(i+1)+' type is not supported. Please upload JPEG, JPG, PNG, or PDF files.',isUploading:false});return _context2.abrupt('continue',33);case 18:if(!(file.size>maxSize)){_context2.next=22;break;}_this4.setState({errorMessage:'File '+(i+1)+' size exceeds the limit of 30MB.'});_context2.next=33;break;case 22:totalSize+=file.size;_context2.prev=23;_context2.next=26;return _this4.props.client.mutate({mutation:__WEBPACK_IMPORTED_MODULE_30__queries__["B" /* GET_UPLOAD_URL */],variables:{fileExtension:fileExtension}});case 26:response=_context2.sent;if(response.data&&response.data.getPublicUploadURL){(function(){var _response$data$getPub=response.data.getPublicUploadURL,publicUploadURL=_response$data$getPub.publicUploadURL,filename=_response$data$getPub.filename;uploadProgress[filename]=0;// Initialize progress for this filename
var uploadPromise=__WEBPACK_IMPORTED_MODULE_18_axios___default.a.put(publicUploadURL,file,{headers:{'x-ms-blob-type':'BlockBlob','Content-Type':file.type||'application/octet-stream'},onUploadProgress:function onUploadProgress(progressEvent){var progress=progressEvent.loaded/progressEvent.total*100;// Update progress for the filename obtained from the response
_this4.setState(function(prevState){return{uploadProgress:Object.assign({},prevState.uploadProgress,_defineProperty({},filename,progress))};});}});uploadPromises.push(uploadPromise);fileNames.push(filename);// Store filename in fileNames state
})();}_context2.next=33;break;case 30:_context2.prev=30;_context2.t0=_context2['catch'](23);console.error('Upload error:',_context2.t0);case 33:i++;_context2.next=11;break;case 36:// Update fileNames state after processing all files
updatedFileNames=fileNames.slice(0,maxFiles).join(',');_this4.setState({fileNames:updatedFileNames});// Wait for all upload promises to resolve
_context2.prev=38;_context2.next=41;return Promise.all(uploadPromises);case 41:_this4.setState({isUploading:false});_context2.next=47;break;case 44:_context2.prev=44;_context2.t1=_context2['catch'](38);console.error('Upload error:',_context2.t1);// Handle upload error
case 47:_context2.next=50;break;case 49:_this4.setState({errorMessage:'Maximum 50 files can be selected',isUploading:false});case 50:case'end':return _context2.stop();}}},_callee2,_this4,[[23,30],[38,44]]);}));return function(_x2){return _ref5.apply(this,arguments);};}();this.handleDownload=function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(fileName){var bucketName,_ref7,data,res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:bucketName='aquila-track-uploads';_context3.next=3;return _this4.props.client.query({query:__WEBPACK_IMPORTED_MODULE_30__queries__["u" /* GET_FILE_FORMAT */],variables:{bucketname:bucketName,filename:fileName},errorPolicy:'all'});case 3:_ref7=_context3.sent;data=_ref7.data;_context3.next=7;return __WEBPACK_IMPORTED_MODULE_18_axios___default()({url:data.getPublicDownloadURL,method:'GET',headers:{Accept:'application/vnd.ms-excel'},responseType:'blob'// important
});case 7:res=_context3.sent;__WEBPACK_IMPORTED_MODULE_19_file_saver___default.a.saveAs(new Blob([res.data]),fileName);case 9:case'end':return _context3.stop();}}},_callee3,_this4);}));return function(_x3){return _ref6.apply(this,arguments);};}();this.handleInputChange=function(key){return function(e){if(key=='custType'){console.log(_this4.state.customerType);}console.log();if(key==='fuelType'){if(!e){_this4.setState(_defineProperty({},key,''));return;}_this4.setState(_defineProperty({},key,e.value));}else if(key==='portedVehicle'){if(!e){_this4.setState(_defineProperty({},key,''));return;}_this4.setState(_defineProperty({},key,e.value));}else if(key==='isTestingVehicle'){if(!e){_this4.setState(_defineProperty({},key,''));return;}_this4.setState(_defineProperty({},key,e.value));}else if(key==='solutionType'){if(!e){_this4.setState(_defineProperty({},key,''));return;}_this4.setState(_defineProperty({},key,e.value));}else if(key==='solution_type'){if(!e){var _this4$setState11;_this4.setState((_this4$setState11={},_defineProperty(_this4$setState11,key,[]),_defineProperty(_this4$setState11,'solutionType',''),_this4$setState11));return;}// 1. Original codes from the dropdown selection (e.g., ["fuel+vt"])
var selectedCodes=e.map(function(opt){return opt.code;});// DEBUG: log what codes the UI passed in
try{console.debug&&console.debug('handleInputChange solution_type selectedCodes:',selectedCodes);}catch(err){}// 2. Compute legacy solutionType using the original codes
var legacySolutionType=_this4.computeLegacySolutionType(selectedCodes);// 3. Expand combo codes into individual base codes for solution_type array
var expanded=[];selectedCodes.forEach(function(code){// If the code contains '+', it's a combo – split and add parts
if(code.includes('+')){var parts=code.split('+');expanded.push.apply(expanded,_toConsumableArray(parts));}else{expanded.push(code);}});// Deduplicate (in case different combos share a base solution – unrealistic but safe)
var uniqueExpanded=[].concat(_toConsumableArray(new Set(expanded)));// 4. Build plan update objects using the ORIGINAL codes (one plan per combo)
var planUpdates={};selectedCodes.forEach(function(code){if(code!=='reverse_camera_screen'){planUpdates['selected_plan_'+code]='1 Year';// default plan
}});_this4.setState(Object.assign({solution_type:selectedCodes,// ✅ changed from uniqueExpanded to selectedCodes
selected_solution_codes:selectedCodes,// e.g., ["fuel+tacho_solution"]
solutionType:legacySolutionType},planUpdates));}else if(key=='adblueCapacity'||key=='fuelTankCapacity'){var value=parseFloat(e.target.value);if(isNaN(value)){_this4.setState(_defineProperty({},key,e.target.value));if(key=='adblueCapacity'){_this4.setState({errorMessageNew:null});}else{_this4.setState({errorMessageFuelTank:null});}return false;}if(!Number.isInteger(value)){if(key=='adblueCapacity'){_this4.setState({errorMessageNew:'Decimal values are not allowed.'});}else{_this4.setState({errorMessageFuelTank:'Decimal values are not allowed.'});}}else{if(key=='adblueCapacity'){_this4.setState({errorMessageNew:null});}else{_this4.setState({errorMessageFuelTank:null});}}_this4.setState(_defineProperty({},key,e.target.value));}else if(key=='department'||key=='contractorName'||key=='equipmentName'||key=='invoiceNumber'||key=='equipmentSerialNumber'||key=='isDualEngine'||key=='hasArm'||key=='isElockConnection'||key=='isIndividualViewOrCombinedView'||key=='duplicateVehicle'||key=='istachoenabled'){// Check if the input length exceeds 90 characters only if the field is not empty
if(key=='department'){if(e.target.value.length>90&&e.target.value.trim()!==''){var _this4$setState14;_this4.setState((_this4$setState14={},_defineProperty(_this4$setState14,key,e.target.value),_defineProperty(_this4$setState14,'isDepartmentValid',false),_this4$setState14));}else{var _this4$setState15;_this4.setState((_this4$setState15={},_defineProperty(_this4$setState15,key,e.target.value),_defineProperty(_this4$setState15,'isDepartmentValid',true),_this4$setState15));}}if(key=='contractorName'){if(e.target.value.length>90&&e.target.value.trim()!==''){var _this4$setState16;_this4.setState((_this4$setState16={},_defineProperty(_this4$setState16,key,e.target.value),_defineProperty(_this4$setState16,'isContractorNameValid',false),_this4$setState16));}else{var _this4$setState17;_this4.setState((_this4$setState17={},_defineProperty(_this4$setState17,key,e.target.value),_defineProperty(_this4$setState17,'isContractorNameValid',true),_this4$setState17));}}if(key=='equipmentName'){if(e.target.value.length>90&&e.target.value.trim()!==''){var _this4$setState18;_this4.setState((_this4$setState18={},_defineProperty(_this4$setState18,key,e.target.value),_defineProperty(_this4$setState18,'isEquipmentNameValid',false),_this4$setState18));}else{var _this4$setState19;_this4.setState((_this4$setState19={},_defineProperty(_this4$setState19,key,e.target.value),_defineProperty(_this4$setState19,'isEquipmentNameValid',true),_this4$setState19));}}if(key=='engineOnHours'){if(e.target.value.length>90&&e.target.value.trim()!==''){var _this4$setState20;_this4.setState((_this4$setState20={},_defineProperty(_this4$setState20,key,e.target.value),_defineProperty(_this4$setState20,'engineOnHours',false),_this4$setState20));}else{var _this4$setState21;_this4.setState((_this4$setState21={},_defineProperty(_this4$setState21,key,e.target.value),_defineProperty(_this4$setState21,'engineOnHours',true),_this4$setState21));}}if(key=='odometerDistance'){if(e.target.value.length>90&&e.target.value.trim()!==''){var _this4$setState22;_this4.setState((_this4$setState22={},_defineProperty(_this4$setState22,key,e.target.value),_defineProperty(_this4$setState22,'odometerDistance',false),_this4$setState22));}else{var _this4$setState23;_this4.setState((_this4$setState23={},_defineProperty(_this4$setState23,key,e.target.value),_defineProperty(_this4$setState23,'odometerDistance',true),_this4$setState23));}}if(key=='equipmentSerialNumber'){if(e.target.value.length>90&&e.target.value.trim()!==''){var _this4$setState24;_this4.setState((_this4$setState24={},_defineProperty(_this4$setState24,key,e.target.value),_defineProperty(_this4$setState24,'isEquipmentValid',false),_this4$setState24));}else{var _this4$setState25;_this4.setState((_this4$setState25={},_defineProperty(_this4$setState25,key,e.target.value),_defineProperty(_this4$setState25,'isEquipmentValid',true),_this4$setState25));}}if(key=='invoiceNumber'){if(e.target.value.length>90&&e.target.value.trim()!==''){var _this4$setState26;_this4.setState((_this4$setState26={},_defineProperty(_this4$setState26,key,e.target.value),_defineProperty(_this4$setState26,'isInvoiceNoValid',false),_this4$setState26));}else{var _this4$setState27;_this4.setState((_this4$setState27={},_defineProperty(_this4$setState27,key,e.target.value),_defineProperty(_this4$setState27,'isInvoiceNoValid',true),_this4$setState27));}}if(key=='isDualEngine'){var isChecked=e.target.checked;_this4.setState({isDualEngine:isChecked},function(){});}if(key=='hasArm'){var _isChecked=e.target.checked;_this4.setState({hasArm:_isChecked},function(){});}if(key=='isElockConnection'){var _isChecked2=e.target.checked;_this4.setState({isElockConnection:_isChecked2},function(){});}if(key=='duplicateVehicle'){var _isChecked3=e.target.checked;_this4.setState({duplicateVehicle:_isChecked3},function(){});}if(key=='isIndividualViewOrCombinedView'){var _isChecked4=e.target.checked;_this4.setState({isIndividualViewOrCombinedView:_isChecked4},function(){});}if(key=='istachoenabled'){var _isChecked5=e.target.checked;_this4.setState({istachoenabled:_isChecked5},function(){});}}else if(key==='phase'||key==='kvaRating'||key==='dgSetType'||key==='selected_plan'||key.startsWith('selected_plan_')){if(!e){_this4.setState(_defineProperty({},key,''));return;}_this4.setState(_defineProperty({},key,e.value));}else{if(key==='rcsSerialNumber'){if(!e){_this4.setState(_defineProperty({},key,''));}else{_this4.setState(_defineProperty({},key,e.value));}}else{// const { name, value } = e.target;
// this.setState({ [name]: value });
_this4.setState(_defineProperty({},key,e.target.value));}}};};this.handleDateChange=function(name){return function(date){var tempDate=_this4.state[name];tempDate.date=date;tempDate.unix=__WEBPACK_IMPORTED_MODULE_20_moment___default()(date).unix().toString();_this4.setState(_defineProperty({},name,tempDate));};};this.fetchAllPartnerSubscriptions=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){var _ref9,subscription,subscriptionError,allSubscriptions;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return _this4.props.client.query({query:__WEBPACK_IMPORTED_MODULE_30__queries__["A" /* GET_SUBSCRIPTION_BY_PARTNERID */],variables:{partnerId:Object(__WEBPACK_IMPORTED_MODULE_16__utils_getLoginId__["a" /* default */])(),deviceModelId:_this4.state.deviceModelId,status:[2,4,5]},errorPolicy:'all',fetchPolicy:'network-only'});case 2:_ref9=_context4.sent;subscription=_ref9.data;subscriptionError=_ref9.error;allSubscriptions=subscription.getAllPartnerSubscriptions.map(// (lab = subscription.mmtc + ',' + subscription.noOfDevices),
function(subscription){return{value:subscription.id,label:subscription.totalSoftwareQty+' - '+subscription.deviceTrackingCharges};});if(subscriptionError){_this4.setState({subscriptionDetails:[]});}else{_this4.setState({subscriptionDetails:allSubscriptions},function(){return console.log('subscriptionDetails',_this4.state.subscriptionDetails);});}case 7:case'end':return _context4.stop();}}},_callee4,_this4);}));this.handleChangeDevice=function(client){return function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(event){var response,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:if(!event){_context5.next=8;break;}_this4.setState({serialNumber:event.value});_context5.next=4;return client.query({query:__WEBPACK_IMPORTED_MODULE_30__queries__["w" /* GET_SELECT_DEV_DETAILS */],variables:{uniqueId:event.value},fetchPolicy:'network-only'}).catch(function(error){console.log(error.graphQLErrors[0].message);});case 4:response=_context5.sent;if(response&&response.data){data=response.data;_this4.setState({modelName:data.devicePartnerAssignDetail.deviceModel.model_name,deviceType:data.devicePartnerAssignDetail.deviceModel.devicetype,uniqueId:_this4.state.serialNumber,deviceModelId:data.devicePartnerAssignDetail.deviceModel.id},function(){_this4.fetchAllPartnerSubscriptions();});}_context5.next=9;break;case 8:_this4.setState({modelName:'',deviceType:'',uniqueId:'',serialNumber:'',subscriptionDetails:[],subscriptionId:''});case 9:case'end':return _context5.stop();}}},_callee5,_this4);}));return function(_x4){return _ref10.apply(this,arguments);};}();};this.handleChangePhoneNumber=function(client){return function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(event){var _ref12,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:if(!event){_context6.next=8;break;}_context6.next=3;return client.query({query:__WEBPACK_IMPORTED_MODULE_30__queries__["x" /* GET_SELECT_PHONE_DETAILS */],variables:{simId:event.value}});case 3:_ref12=_context6.sent;data=_ref12.data;_this4.setState({simProvider:data.simPartnerAssignDetail.serviceProvider.name,simNumber:data.simPartnerAssignDetail.sim.simNumber,phoneNumber:event.value});_context6.next=9;break;case 8:_this4.setState({simProvider:'',simNumber:'',phoneNumber:''});case 9:case'end':return _context6.stop();}}},_callee6,_this4);}));return function(_x5){return _ref11.apply(this,arguments);};}();};this.handleChangeZM=function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(event){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:if(event){_this4.setState({zmId:event.value});}else{_this4.setState({zmId:''});}case 1:case'end':return _context7.stop();}}},_callee7,_this4);}));return function(_x6){return _ref13.apply(this,arguments);};}();this.handleChangeKAM=function(){var _ref14=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(event){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:if(event){_this4.setState({kamId:event.value});}else{_this4.setState({kamId:''});}case 1:case'end':return _context8.stop();}}},_callee8,_this4);}));return function(_x7){return _ref14.apply(this,arguments);};}();this.handleVideoTelematicsMenuChange=function(selectedOption){_this4.setState({selectedVTM:selectedOption,selectedVtid:null,selectedSimId:null,selectedMemoryCardId:null,videoTelematicsId:''});};this.handleVideoTelematicsIdChange=function(event){_this4.setState({videoTelematicsId:event.target.value});};this.handleChangeClient=function(){var _ref15=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(event){var cltId,_ref16,data,_ref17,device,deviceError,allDevices,_ref18,simDetails,simError,allSims,_ref19,accessory,error,_ref20,customerData,customerError,customerCode,allAccessory;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:cltId='';if(_this4.props.match.params.loginId===undefined){if(event){cltId=parseInt(event.value,10);}}else{cltId=parseInt(_this4.props.match.params.loginId,10);_this4.props.match.params.loginId=undefined;}_this4.setState({clientName:cltId});if(!(cltId!=='')){_context9.next=37;break;}_context9.next=6;return _this4.props.client.query({query:__WEBPACK_IMPORTED_MODULE_30__queries__["l" /* GET_CLIENT_DETAILS_BYID */],variables:{clientId:cltId},errorPolicy:'all'// fetchPolicy: 'network-only'
});case 6:_ref16=_context9.sent;data=_ref16.data;_context9.next=10;return _this4.props.client.query({query:__WEBPACK_IMPORTED_MODULE_30__queries__["o" /* GET_DEVICE_DETAILS */],variables:{clientId:cltId},errorPolicy:'all',fetchPolicy:'network-only'});case 10:_ref17=_context9.sent;device=_ref17.data;deviceError=_ref17.error;allDevices=device.device.map(function(device){return{value:device.uniqueDeviceId,label:device.uniqueDeviceId};});_context9.next=16;return _this4.props.client.query({query:__WEBPACK_IMPORTED_MODULE_30__queries__["y" /* GET_SIM_DETAILS */],variables:{clientId:cltId},errorPolicy:'all',fetchPolicy:'network-only'});case 16:_ref18=_context9.sent;simDetails=_ref18.data;simError=_ref18.error;allSims=simDetails.simDetails.map(function(sim){return{value:sim.simId,label:sim.sim.phoneNumber};});_context9.next=22;return _this4.props.client.query({query:__WEBPACK_IMPORTED_MODULE_30__queries__["e" /* GET_ACCESSORY_DETAILS */],variables:{clientId:cltId},errorPolicy:'all',fetchPolicy:'network-only'});case 22:_ref19=_context9.sent;accessory=_ref19.data;error=_ref19.error;_context9.next=27;return _this4.props.client.query({query:__WEBPACK_IMPORTED_MODULE_30__queries__["m" /* GET_CUSTOMER_TYPE_AND_CODE */],variables:{clientName:data.clientDetail.clientName},errorPolicy:'all'});case 27:_ref20=_context9.sent;customerData=_ref20.data;customerError=_ref20.error;customerCode=customerData.getCustomerTypeAndCode.directCustomerSAPCode||customerData.getCustomerTypeAndCode.channelPartnerSAPCode||'';if(accessory.getAllAssignedAccessoryToClient){allAccessory=accessory.getAllAssignedAccessoryToClient.map(function(accessory1){return{value:accessory1.accessory.uniqueAccessoryId,label:accessory1.accessory.uniqueAccessoryId};});if(error){_this4.setState({accessoryDetails:[]});}else{_this4.setState({accessoryDetails:allAccessory});}}if(deviceError){_this4.setState({deviceDetails:[]});}else{_this4.setState({deviceDetails:allDevices});}if(simError){_this4.setState({simDetails:[]});}else{_this4.setState({simDetails:allSims});}_this4.setState({client:data.clientDetail.clientName,address:data.clientDetail.address,id:data.clientDetail.id,city:data.clientDetail.city,totalRegisteredVehicle:30,totalActiveDevicess:15,totalInactiveDevices:5,showClientDetails:true,customerType:customerData.getCustomerTypeAndCode.registrationType,customerCode:customerCode});_context9.next=38;break;case 37:_this4.setState({client:'',address:'',id:'',city:'',showClientDetails:false,subscriptionDetails:[],accessoryDetails:[],simDetails:[],deviceDetails:[],modelName:'',deviceType:'',uniqueId:'',serialNumber:'',simProvider:'',simNumber:'',phoneNumber:'',accessories:'',subscriptionId:'',customerType:'',customerCode:''});case 38:case'end':return _context9.stop();}}},_callee9,_this4);}));return function(_x8){return _ref15.apply(this,arguments);};}();this.handleChangeMake=function(){var _ref21=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(event){var makemodellist,models,modelsList,_makemodellist;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:_this4.setState({vehicleMake:event?event.label:null,vehicleMakeId:event?event.value:null,kvaRating:'',dgSetType:''});// console.log('this.state.vehicleSegment',this.state.vehicleSegment, event.value);
if(!(event&&_this4.state.vehicleSegment=='DG Set')){_context10.next=9;break;}_context10.next=4;return _this4.props.client.query({query:__WEBPACK_IMPORTED_MODULE_30__queries__["p" /* GET_DG_MODELS */],variables:{make:event.value},fetchPolicy:'network-only'});case 4:makemodellist=_context10.sent;models=makemodellist.data.getDgModels;modelsList=models&&models.map(function(model){return{id:model,model:model};});_this4.setState({modelsList:modelsList});return _context10.abrupt('return');case 9:if(!event){_context10.next=16;break;}_context10.next=12;return _this4.props.client.query({query:__WEBPACK_IMPORTED_MODULE_30__queries__["D" /* GET_VEHICLE_MODELS */],variables:{makeId:event.value},fetchPolicy:'network-only'});case 12:_makemodellist=_context10.sent;_this4.setState({modelsList:_makemodellist.data.getVehicleModels});_context10.next=18;break;case 16:_this4.setState({modelsList:[]});_this4.setState({emissionRateType:''});case 18:case'end':return _context10.stop();}}},_callee10,_this4);}));return function(_x9){return _ref21.apply(this,arguments);};}();this.handleChangeModelNew=function(){var _ref22=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(event){var vehicleModel,vehicleModelId;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:vehicleModel=event?event.label:null;vehicleModelId=event?event.value:null;_this4.setState({vehicleModel:vehicleModel,vehicleModelId:vehicleModelId});case 3:case'end':return _context11.stop();}}},_callee11,_this4);}));return function(_x10){return _ref22.apply(this,arguments);};}();this.handleChangeModel=function(){var _ref23=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(event){var make,dgSpecsResponse,dgSpecs,kvaRatingOptions,dgSetTypeOptions,makemodellistDetails,fuelType;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:_this4.setState({vehicleModel:event?event.label:null,vehicleModelId:event?event.value:null,emissionRateType:'',grossVehicleWeight:'',fuelTankCapacity:'',adblueCapacity:'',manufacturingYear:'',fuelType:'',engineSpecification:'',engineSpecificationFromApi:false,emissionRateTypeFromApi:false,grossVehicleWeightFromApi:false,fuelTankCapacityFromApi:false,adblueCapacityFromApi:false,manufacturingYearFromApi:false,fuelTypeFromApi:false});if(!(event&&_this4.state.vehicleSegment=='DG Set')){_context12.next=13;break;}make=_this4.state.vehicleMake;_context12.next=5;return _this4.props.client.query({query:__WEBPACK_IMPORTED_MODULE_30__queries__["q" /* GET_DG_SPECS_FROM_MODEL */],variables:{make:make,model:event.value},fetchPolicy:'network-only'});case 5:dgSpecsResponse=_context12.sent;dgSpecs=dgSpecsResponse.data.getDgspecsFromModel;kvaRatingOptions=dgSpecs&&dgSpecs.map(function(row){return{value:row.kvaRating,label:row.kvaRating};});if(kvaRatingOptions.length===1){_this4.setState({kvaRating:kvaRatingOptions[0].value});}dgSetTypeOptions=dgSpecs&&dgSpecs.map(function(row){return{value:row.dgSetType,label:row.dgSetType};});if(dgSetTypeOptions.length===1){_this4.setState({dgSetType:dgSetTypeOptions[0].value});}_this4.setState({kvaRatingOptions:kvaRatingOptions,dgSetTypeOptions:dgSetTypeOptions});return _context12.abrupt('return');case 13:if(!event){_context12.next=25;break;}_context12.prev=14;_context12.next=17;return _this4.props.client.query({query:__WEBPACK_IMPORTED_MODULE_30__queries__["E" /* GET_VEHICLE_PARAMS */],variables:{modelId:event.value},fetchPolicy:'network-only'});case 17:makemodellistDetails=_context12.sent;console.log(makemodellistDetails.data,'heyyy');if(makemodellistDetails&&makemodellistDetails.data){if(makemodellistDetails.data.getVehicleParameters.length>0){fuelType=makemodellistDetails.data.getVehicleParameters[0]['fuel_type'];if(fuelType==='Diesel'||fuelType==='diesel'){fuelType='Diesel';}if(fuelType==='Petrol'||fuelType==='petrol'){fuelType='Petrol';}_this4.setState({emissionRateType:makemodellistDetails.data.getVehicleParameters[0]['emission_type'],grossVehicleWeight:makemodellistDetails.data.getVehicleParameters[0]['gross_vehicle_weight'],fuelTankCapacity:makemodellistDetails.data.getVehicleParameters[0]['fuel_capacity'],adblueCapacity:makemodellistDetails.data.getVehicleParameters[0]['adblue_capacity'],manufacturingYear:makemodellistDetails.data.getVehicleParameters[0]['manufacturing_year'],fuelType:fuelType,engineSpecification:makemodellistDetails.data.getVehicleParameters[0]['engine_specification']});// Set the corresponding flags to true only if data is not null
if(makemodellistDetails.data.getVehicleParameters[0]['emission_type']){_this4.setState({emissionRateTypeFromApi:true});}if(makemodellistDetails.data.getVehicleParameters[0]['gross_vehicle_weight']){_this4.setState({grossVehicleWeightFromApi:true});}if(makemodellistDetails.data.getVehicleParameters[0]['fuel_capacity']){_this4.setState({fuelTankCapacityFromApi:true});}if(makemodellistDetails.data.getVehicleParameters[0]['adblue_capacity']){_this4.setState({adblueCapacityFromApi:true});}if(makemodellistDetails.data.getVehicleParameters[0]['manufacturing_year']){_this4.setState({manufacturingYearFromApi:true});}if(makemodellistDetails.data.getVehicleParameters[0]['fuel_type']){_this4.setState({fuelTypeFromApi:true});}if(makemodellistDetails.data.getVehicleParameters[0]['engine_specification']){_this4.setState({engineSpecificationFromApi:true});}}}_context12.next=25;break;case 22:_context12.prev=22;_context12.t0=_context12['catch'](14);_this4.setState({emissionRateType:'',grossVehicleWeight:'',fuelTankCapacity:'',adblueCapacity:'',manufacturingYear:'',fuelType:'',engineSpecification:'',engineSpecificationFromApi:false,emissionRateTypeFromApi:false,grossVehicleWeightFromApi:false,fuelTankCapacityFromApi:false,adblueCapacityFromApi:false,manufacturingYearFromApi:false,fuelTypeFromApi:false});case 25:case'end':return _context12.stop();}}},_callee12,_this4,[[14,22]]);}));return function(_x11){return _ref23.apply(this,arguments);};}();this.handleChangeType=function(event){var selectedVehicleType=event?event.value:null;_this4.setState({vehicleType:selectedVehicleType},function(){_this4.checkVehicleTypeValidity();});};this.handleEmissionType=function(event){_this4.setState({emissionRateType:event?event.value:null});};this.handleChangeSpeedSensor=function(event){if(event){_this4.setState({speedSensor:event.value});}else{_this4.setState({speedSensor:''});}};this.handleChangeIdlingSpeed=function(event){try{if(event){_this4.setState({idlingSpeed:event.value});}else{_this4.setState({idlingSpeed:3});}}catch(error){_this4.setState({idlingSpeed:3});}};this.handleChangeAccessories=function(event){if(!event){_this4.setState({accessories:''});}else{_this4.setState({accessories:event.value});}};this.handleChangeInputParameter=function(event){var value=event.target.value;_this4.setState({inputParameter:value?parseFloat(value):null});};this.handleChangeMultiplicationFactor=function(event){var value=event.target.value;_this4.setState({multiplicationFactor:value?parseFloat(value):null});};this.handleChangeSubscription=function(event){if(!event){_this4.setState({subscriptionId:''});}else{_this4.setState({subscriptionId:event.value});}};this.checkSerialNumberValidity=function(){// const regex = new RegExp(/^[a-zA-Z\s]+$/)
_this4.setState({isSerialNumberValid:_this4.state.serialNumber!==''});};this.checkAddressValidity=function(){var regex=new RegExp(/^[a-zA-Z0-9\s,.'-]{3,}$/);_this4.setState({isAddressValid:regex.test(_this4.state.address)&&_this4.state.address===''});};this.checkVehicleModelValidity=function(){var regex=/^[a-zA-Z][a-zA-Z0-9 -]*$/;_this4.setState({isVehicleModelValid:regex.test(_this4.state.vehicleModel)&&_this4.state.vehicleModel!==''&&_this4.state.vehicleModel.length>1&&_this4.state.vehicleModel.length<21});};this.checkVehicleMakeValidity=function(){if(_this4.state.vehicleMake!==''){var regex=/^[a-zA-Z][a-zA-Z0-9 -]*$/;_this4.setState({isVehicleMakeValid:regex.test(_this4.state.vehicleMake)&&_this4.state.vehicleMake!==''&&_this4.state.vehicleMake.length>1&&_this4.state.vehicleMake.length<70});}};this.checkItemValidity=function(key){return function(e){if(e.target.value!==''){var regex=/^[a-zA-Z0-9 .-@,]*$/;switch(key){case'engineOnHours':_this4.setState({isengineOnHoursValid:regex.test(e.target.value)&&e.target.value!==''});break;case'odometerDistance':_this4.setState({isOdometerDistanceValid:regex.test(e.target.value)&&e.target.value!==''});break;case'engineSpecification':_this4.setState({isEngineSpecificationValid:e.target.value!==''});break;default:break;}}};};this.checkSpeedLimitValidity=function(){var regex=new RegExp(/^[1-9][0-9]{0,2}$/);_this4.setState({isSpeedLimitValid:regex.test(_this4.state.speedLimit)&&_this4.state.speedLimit!==''&&_this4.state.speedLimit<=160&&_this4.state.speedLimit>=10});};this.checkSeatLimitValidity=function(){var regex=new RegExp(/^[1-9][0-9]$/);_this4.setState({isSeatLimitValid:regex.test(_this4.state.seatLimit)&&_this4.state.seatLimit!==''});};this.checkVlpnValidity=function(client){return function(){var _ref24=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(event){var _ref25,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:_context13.next=2;return client.query({query:__WEBPACK_IMPORTED_MODULE_30__queries__["H" /* GET_VLPN */],variables:{vlpn:_this4.state.vlpn}});case 2:_ref25=_context13.sent;data=_ref25.data;_this4.setState({isVlpnValid:_this4.state.vlpn!==''&&data.checkVehicleNumber==='AVAILABLE'&&_this4.state.vlpn.length>4&&_this4.state.vlpn.length<33});if(data.checkVehicleNumber!=='AVAILABLE'){_this4.setState({vlpnres:'Vehicle Number Already Exist!'});}else if(_this4.state.vlpn!==''){if(_this4.state.vlpn.length<5||_this4.state.vlpn.length>32){_this4.setState({vlpnres:'Max character length is between 5 to 32'});}else{_this4.setState({vlpnres:'Invalid Vehicle Number'});}}case 6:case'end':return _context13.stop();}}},_callee13,_this4);}));return function(_x12){return _ref24.apply(this,arguments);};}();};this.checkVlpnUnique=function(client){return function(){var _ref26=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(event){var _ref27,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:_context14.next=2;return client.query({query:__WEBPACK_IMPORTED_MODULE_30__queries__["H" /* GET_VLPN */],variables:{vlpn:_this4.state.vlpn}});case 2:_ref27=_context14.sent;data=_ref27.data;_this4.setState({isVlpnValid:data.checkVehicleNumber==='AVAILABLE'});// await this.onCountryFetched(data.allStatesByCountryId)
case 5:case'end':return _context14.stop();}}},_callee14,_this4);}));return function(_x13){return _ref26.apply(this,arguments);};}();};this.checkClientNameValidity=function(){_this4.setState({isClientNameValid:_this4.state.clientName!==''});};this.checkVehicleTypeValidity=function(){var isSchoolBus=_this4.state.vehicleType==='School Bus';_this4.setState({isVehicleTypeValid:_this4.state.vehicleType!=='',isSeatLimitValid:isSchoolBus// Update isSeatLimitValid based on selected vehicle type
});};this.checkSpeedSensorValidity=function(){_this4.setState({isSpeedSensorValid:_this4.state.speedSensor!==''});};this.handleSubmit=function(client,mutationInput){return function(){var _ref28=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(event){var commissioningDate,invoiceDate,formattedFileNames,statusOnboard,_ref29,data,errors,_this4$setState34,_currentYear,_manufacturingYearOptions,i,submitErrorMessage,mutationInputWithStatusOnboard;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:console.log('mutationInput',mutationInput);if(_this4.state.seatLimit===''){_this4.setState({seatLimit:null});}event.preventDefault();commissioningDate=_this4.state.commissioningDate.date===null?null:parseInt(_this4.state.commissioningDate.unix);invoiceDate=_this4.state.invoiceDate.date===null?null:parseInt(_this4.state.invoiceDate.unix);formattedFileNames='';try{formattedFileNames=_this4.state.fileNames.split(',').map(function(fileName){return fileName.trim();}).join(',');// Split file names by comma, trim whitespace, and join back with commas
}catch(error){}statusOnboard='failure';_context15.next=10;return client.mutate({mutation:__WEBPACK_IMPORTED_MODULE_30__queries__["a" /* ADD_VEHICLE */],variables:{vehicleNumber:_this4.state.vehicleNickName?_this4.state.vehicleNickName:_this4.state.vehicleSegment=='DG Set'?_this4.state.vlpn:_this4.state.vehicleData?_this4.state.vehicleData.rcRegnNo:_this4.state.rcRegnNo,engineNumber:_this4.state.vehicleData?_this4.state.vehicleData.rcEngNo:_this4.state.rcEngNo,chassisNumber:_this4.state.vehicleData?_this4.state.vehicleData.rcChasiNo:_this4.state.rcChasiNo,// vehicleType: (this.state.vehicleSegment == 'DG Set' ? this.state.vehicleSegment : this.state.vehicleData ? this.state.vehicleData.rcVhType : this.state.rcVhType || '') == 'T' ? "Truck" : this.state.vehicleSegment == 'DG Set' ? this.state.vehicleSegment : this.state.vehicleData ? this.state.vehicleData.rcVhType : this.state.rcVhType || 'N/A',
vehicleType:function(){var _state9=_this4.state,vehicleSegment=_state9.vehicleSegment,transportationVehicleType=_state9.transportationVehicleType,constructionVehicleType=_state9.constructionVehicleType,passengerVehicleType=_state9.passengerVehicleType,vehicleData=_state9.vehicleData,rcVhType=_state9.rcVhType;if(vehicleSegment==='Transportation')return transportationVehicleType||'N/A';if(vehicleSegment==='Construction')return constructionVehicleType||'N/A';if(vehicleSegment==='Passenger')return passengerVehicleType||'N/A';var vehicleType=vehicleData&&vehicleData.rcVhType||rcVhType;vehicleType=vehicleType==='T'?'Truck':vehicleType||'N/A';return vehicleSegment||vehicleType;}(),vehicleMake:_this4.state.vehicleSegment=='DG Set'||_this4.state.deviceType=='obd'||_this4.state.deviceType=='OBD'?_this4.state.vehicleMake:_this4.state.vehicleData?_this4.state.vehicleData.rcMakerDesc:_this4.state.rcMakerDesc,// averageMileage: Int,
vehicleModel:_this4.state.vehicleSegment=='DG Set'||_this4.state.deviceType=='obd'||_this4.state.deviceType=='OBD'?_this4.state.vehicleModel:_this4.state.vehicleData?_this4.state.vehicleData.rcMakerModel:_this4.state.rcMakerModel,baselineDataType:_this4.state.baselineDataType,// baselineDataHour:Float,
// baselineDataForFELPH: Float,
noOfGears:parseInt(_this4.state.noOfGears),gearRatio:_this4.state.gearRatio,vehicleRegistrationNumber:_this4.state.vehicleData&&_this4.state.vehicleData.rcRegnNo?_this4.state.vehicleData.rcRegnNo:_this4.state.rcRegnNo,registrationDate:_this4.state.vehicleData&&_this4.state.vehicleData.rcRegnDt?_this4.state.vehicleData.rcRegnDt:_this4.state.rcRegnDt,registrationValidUpto:_this4.state.vehicleData&&_this4.state.vehicleData.rcRegnUpto?_this4.state.vehicleData.rcRegnUpto:_this4.state.rcRegnUpto,stateCode:_this4.state.vehicleData&&_this4.state.vehicleData.stateCd?_this4.state.vehicleData.stateCd:_this4.state.stateCd,rtoCode:_this4.state.vehicleData&&_this4.state.vehicleData.rtoCd?_this4.state.vehicleData.rtoCd:_this4.state.rtoCd,vehicleCategoryCode:_this4.state.vehicleData&&_this4.state.vehicleData.rcVchCatg?_this4.state.vehicleData.rcVchCatg:_this4.state.rcVchCatg,// vehicleCategoryDescription: this.state.vehicleData ? this.state.vehicleData.rcVchCatgDesc : this.state.rcVchCatgDesc,
vehicleClassDescription:_this4.state.vehicleData&&_this4.state.vehicleData.rcVhClassDesc?_this4.state.vehicleData.rcVhClassDesc:_this4.state.rcVhClassDesc,makerDescription:_this4.state.vehicleData&&_this4.state.vehicleData.rcMakerDesc?_this4.state.vehicleData.rcMakerDesc:_this4.state.rcMakerDesc,makerModel:_this4.state.vehicleData&&_this4.state.vehicleData.rcMakerModel?_this4.state.vehicleData.rcMakerModel:_this4.state.rcMakerModel,bodyTypeDescription:_this4.state.vehicleData&&_this4.state.vehicleData.rcBodyTypeDesc?_this4.state.vehicleData.rcBodyTypeDesc:_this4.state.rcBodyTypeDesc,// fuelType: ((this.state.vehicleData && this.state.vehicleData.rcFuelDesc) ? this.state.vehicleData.rcFuelDesc : this.state.rcFuelDesc).toLowerCase(),
fuelType:(_this4.state.vehicleData&&_this4.state.vehicleData.rcFuelDesc?_this4.state.vehicleData.rcFuelDesc:_this4.state.rcFuelDesc)?(_this4.state.vehicleData&&_this4.state.vehicleData.rcFuelDesc?_this4.state.vehicleData.rcFuelDesc:_this4.state.rcFuelDesc).toLowerCase():'',emissionNormsDescription:_this4.state.vehicleData&&_this4.state.vehicleData.rcNormsDesc?_this4.state.vehicleData.rcNormsDesc:_this4.state.rcNormsDesc,fitmentUpto:_this4.state.vehicleData&&_this4.state.vehicleData.rcFitUpto?_this4.state.vehicleData.rcFitUpto:_this4.state.rcFitUpto,nationalPermitUpto:_this4.state.vehicleData&&_this4.state.vehicleData.rcNpUpto?_this4.state.vehicleData.rcNpUpto:_this4.state.rcNpUpto,taxUpto:_this4.state.vehicleData&&_this4.state.vehicleData.rcTaxUpto?_this4.state.vehicleData.rcTaxUpto:_this4.state.rcTaxUpto,insurerName:_this4.state.vehicleData&&_this4.state.vehicleData.rcInsuranceComp?_this4.state.vehicleData.rcInsuranceComp:_this4.state.rcInsuranceComp,insuranceUpto:_this4.state.vehicleData&&_this4.state.vehicleData.rcInsuranceUpto?_this4.state.vehicleData.rcInsuranceUpto:_this4.state.rcInsuranceUpto,manufacturingMonthYear:_this4.state.vehicleData&&_this4.state.vehicleData.rcManuMonthYr?_this4.state.vehicleData.rcManuMonthYr:_this4.state.rcManuMonthYr,unladenWeight:_this4.state.vehicleData&&_this4.state.vehicleData.rcUnldWt?_this4.state.vehicleData.rcUnldWt:_this4.state.rcUnldWt?_this4.state.rcUnldWt:null,registeredAt:_this4.state.vehicleData&&_this4.state.vehicleData.rcRegisteredAt?_this4.state.vehicleData.rcRegisteredAt:_this4.state.rcRegisteredAt,puccUpto:_this4.state.vehicleData&&_this4.state.vehicleData.rcPuccUpto?_this4.state.vehicleData.rcPuccUpto:_this4.state.rcPuccUpto,permitNumber:_this4.state.vehicleData&&_this4.state.vehicleData.rcPermitNo?_this4.state.vehicleData.rcPermitNo:_this4.state.rcPermitNo,permitIssueDate:_this4.state.vehicleData&&_this4.state.vehicleData.rcPermitIssueDt?_this4.state.vehicleData.rcPermitIssueDt:_this4.state.rcPermitIssueDt,permitValidFrom:_this4.state.vehicleData&&_this4.state.vehicleData.rcPermitValidFrom?_this4.state.vehicleData.rcPermitValidFrom:_this4.state.rcPermitValidFrom,permitValidUpto:_this4.state.vehicleData&&_this4.state.vehicleData.rcPermitValidUpto?_this4.state.vehicleData.rcPermitValidUpto:_this4.state.rcPermitValidUpto,permitType:_this4.state.vehicleData&&_this4.state.vehicleData.rcPermitType?_this4.state.vehicleData.rcPermitType:_this4.state.rcPermitType,permitCode:_this4.state.vehicleData&&_this4.state.vehicleData.rcPermitCode?_this4.state.vehicleData.rcPermitCode:_this4.state.rcPermitCode,numberOfAxles:parseInt(_this4.state.vehicleData&&_this4.state.vehicleData.rcNoOfAxle?_this4.state.vehicleData.rcNoOfAxle:_this4.state.rcNoOfAxle?_this4.state.rcNoOfAxle:null),fuelCode:_this4.state.vehicleData&&_this4.state.vehicleData.rcFuelCd?_this4.state.vehicleData.rcFuelCd:_this4.state.rcFuelCd,vehicleClass:_this4.state.vehicleData&&_this4.state.vehicleData.rcVhClass?_this4.state.vehicleData.rcVhClass:_this4.state.rcVhClass,clientLoginId:parseInt(_this4.state.clientName,10),uniqueDeviceId:_this4.state.serialNumber,simId:parseInt(_this4.state.phoneNumber,10),speedSensorType:_this4.state.speedSensor,speedLimit:parseInt(_this4.state.speedLimit,10),// vehicleType: this.state.vehicleType,
// vehicleModel: this.state.vehicleModel,
vehicleModelId:_this4.state.vehicleSegment=='DG Set'||_this4.state.deviceType=='obd'||_this4.state.deviceType=='OBD'?_this4.state.vehicleModelId:null,vehicleMakeId:_this4.state.vehicleSegment=='DG Set'||_this4.state.deviceType=='obd'||_this4.state.deviceType=='OBD'?_this4.state.vehicleMakeId:null,uniqueAccessoryId:_this4.state.accessories,vehicleCapacity:parseInt(_this4.state.seatLimit,10),isActivated:_this4.state.installStatus,isVehicleRegistrationNumberAvailable:_this4.state.vehicleRegistrationNumberAvailableStatus,status:_this4.state.status,// engineNumber: this.state.engineNumber,
// chassisNumber: this.state.vehicleData ? this.state.vehicleData.rcChasiNo : this.state.rcChasiNo,
accountType:'PA',partnerSubscriptionId:_this4.state.subscriptionId||50,equipmentSerialNumber:_this4.state.equipmentSerialNumber,commissioningDate:commissioningDate,invoiceDate:invoiceDate,rcsSerialNumber:_this4.state.rcsSerialNumber,idlingSpeed:_this4.state.idlingSpeed,equipmentName:_this4.state.equipmentName,invoiceNumber:_this4.state.invoiceNumber,department:_this4.state.department,contractorName:_this4.state.contractorName,solutionType:_this4.state.solutionType,solution_type:_this4.state.solution_type,isDualEngine:_this4.state.isDualEngine,eon_voltage:parseFloat(_this4.state.eon_voltage),eoff_voltage:parseFloat(_this4.state.eoff_voltage),hasArm:_this4.state.hasArm,isElockConnection:_this4.state.isElockConnection,isIndividualViewOrCombinedView:_this4.state.isIndividualViewOrCombinedView,engineOnHours:_this4.state.engineOnHours,odometerDistance:_this4.state.odometerDistance,duplicateVehicle:_this4.state.duplicateVehicle,//torquePower: this.state.torquePower,
engineSpecification:_this4.state.engineSpecification,emissionRateType:_this4.state.emissionRateType,istachoenabled:_this4.state.istachoenabled,tachoidlerpm:_this4.state.tachoidlerpm?parseInt(_this4.state.tachoidlerpm):null,tachoengineonmin:_this4.state.tachoengineonmin!==''&&_this4.state.tachoengineonmin!==null?parseInt(_this4.state.tachoengineonmin,10):null,tachoengineonmax:_this4.state.tachoengineonmax!==''&&_this4.state.tachoengineonmax!==null?parseInt(_this4.state.tachoengineonmax,10):null,tachoshifthours:_this4.state.tachoshifthours?parseInt(_this4.state.tachoshifthours):null,grossVehicleWeight:parseFloat(_this4.state.vehicleData&&_this4.state.vehicleData.rcGvw)?_this4.state.vehicleData.rcGvw:_this4.state.rcGvw?_this4.state.rcGvw:null,// manufacturingYear: parseInt(this.state.manufacturingYear),
vehicleSegment:_this4.state.vehicleSegment,equipmentTypeClass:_this4.state.equipmentTypeClass,vehicleWheeler:_this4.state.vehicleWheeler,application:_this4.state.vehicleSegment==='Transportation'?_this4.state.selectedApplication:'',transportationVehicleType:_this4.state.vehicleSegment==='Transportation'?_this4.state.transportationVehicleType:'',haulageType:_this4.state.vehicleSegment==='Transportation'?_this4.state.haulageType:'',constructionVehicleType:_this4.state.vehicleSegment==='Construction'?_this4.state.constructionVehicleType:'',passengerVehicleType:_this4.state.vehicleSegment==='Passenger'?_this4.state.passengerVehicleType:'',vehicleNickName:_this4.state.vehicleNickName,documentUpload:formattedFileNames,documentUploadNew:_this4.state.fileNames?_this4.state.fileNames.split(',').filter(Boolean).map(function(fileName){return Object.assign({fileName:fileName.trim()},_this4.state.documentUploadNewData[fileName.trim()]||{solutionType:'',label:''});}):[],baselineDataForFE:parseFloat(_this4.state.baselineDataForFE),baselineDistance:parseInt(_this4.state.baselineDistance),fuelTankCapacity:_this4.state.fuelTankCapacity?_this4.state.fuelTankCapacity.toString():null,adblueCapacity:_this4.state.adblueCapacity?_this4.state.adblueCapacity.toString():null,immobilize:_this4.state.immobilize?_this4.state.immobilize:false,portedVehicle:_this4.state.portedVehicle=='Yes'?true:false,isTestingVehicle:_this4.state.isTestingVehicle=='Testing'?true:false,kvaRating:_this4.state.kvaRating,dgSetType:_this4.state.dgSetType,bhp:_this4.state.bhp,phase:_this4.state.phase,engineModel:_this4.state.engineModel,gensetController:_this4.state.gensetController,videoTelematicsType:_this4.state.selectedVTM&&_this4.state.selectedVTM.value?_this4.state.selectedVTM.value:null,videoTelematicsId:_this4.state.selectedVTM&&_this4.state.selectedVTM.value&&_this4.state.videoTelematicsId?_this4.state.videoTelematicsId:null,inputParameter:_this4.state.inputParameter?_this4.state.inputParameter:null,multiplicationFactor:_this4.state.multiplicationFactor?_this4.state.multiplicationFactor:null,technicianName:_this4.state.technicianName||null,createdBy:_this4.state.createdBy||null,clientName:_this4.state.client,custCode:_this4.state.customerCode,custType:_this4.state.customerType,noOfWheels:_this4.state.noOfWheels?parseInt(_this4.state.noOfWheels):null,baselineHours:parseInt(_this4.state.baselineHours),vehicleCustomizedBodyType:_this4.state.vehicleCustomizedBodyType,tensionerConductorLength:_this4.state.tensionerConductorLength,tensionerRotationSensorDirection:_this4.state.tensionerRotationSensorDirection||'',isRotationSensor:_this4.state.isRotationSensor},errorPolicy:'all'});case 10:_ref29=_context15.sent;data=_ref29.data;errors=_ref29.errors;if(!data){_context15.next=48;break;}statusOnboard='success';console.log('ifffff');_context15.prev=16;_context15.next=19;return client.mutate({mutation:__WEBPACK_IMPORTED_MODULE_2__queries__["a" /* ADD_ELOCK_CONNECTION */],variables:{uniqueId:_this4.state.serialNumber,status:_this4.state.isElockConnection?1:0,deviceType:_this4.state.deviceType}});case 19:_context15.next=24;break;case 21:_context15.prev=21;_context15.t0=_context15['catch'](16);console.log('Error adding elock connection',_context15.t0);case 24:_context15.next=26;return client.resetStore();case 26:_this4.setState({response:data.addVehicleDetail});// After successful onboarding, if addVehicleDetail returned `true`, and reverse camera + screen
// was selected and an RCS serial number was provided, mark that serial as assigned in inventory.
_context15.prev=27;if(!(data.addVehicleDetail===true&&Array.isArray(_this4.state.solution_type)&&_this4.state.solution_type.includes('reverse_camera_screen')&&_this4.state.rcsSerialNumber)){_context15.next=33;break;}_context15.next=31;return client.mutate({mutation:__WEBPACK_IMPORTED_MODULE_30__queries__["J" /* UPDATE_RCS_INVENTORY */],variables:{rcsSerialNumber:_this4.state.rcsSerialNumber,input:{status:'assigned',unique_id:_this4.state.serialNumber}}});case 31:_context15.next=34;break;case 33:console.log('Skipping RCS inventory update - conditions not met',{addVehicleDetail:data.addVehicleDetail,solution_type:_this4.state.solution_type,rcsSerialNumber:_this4.state.rcsSerialNumber,uniqueDeviceId:_this4.state.serialNumber});case 34:_context15.next=40;break;case 36:_context15.prev=36;_context15.t1=_context15['catch'](27);console.error('Failed to update RCS inventory after onboarding',_context15.t1);// don't block onboarding flow on inventory update failure; surface a snackbar
_this4.props.openSnackbar('Vehicle registered but failed to mark RCS as assigned');case 40:_this4.props.openSnackbar('Registered Successfully');_this4.props.history.push('/home/VehcileDashboard/Dashboard');// Dynamically generate manufacturing year options
_currentYear=new Date().getFullYear();_manufacturingYearOptions=[];for(i=0;i<=30;i++){_manufacturingYearOptions.push({value:_currentYear-i,label:''+(_currentYear-i)});}_this4.setState((_this4$setState34={isSpeedLimitValid:true,duplicateVehicle:false,isSeatLimitValid:false,speedLimit:'',seatLimit:null,serialNumber:'',partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_16__utils_getLoginId__["a" /* default */])(),// partnerLoginId: 8,
isSerialNumberValid:true,modelName:'',deviceType:'',status:1,phoneNumber:'',isPhoneNoValid:true,simProvider:'',simNumber:'',vlpn:'',isVlpnValid:true,vehicleModel:'',vehicleMake:'',isVehicleModelValid:true,isVehicleMakeValid:true,clientName:'',isClientNameValid:true,vehicleType:'',isVehicleTypeValid:true,speedSensor:'',isSpeedSensorValid:true,accessories:null,clientsDetails:[],deviceDetails:[],simDetails:[],accessoryDetails:[],response:false,failure:false,schoolBusEnable:false,installStatus:true,vehicleRegistrationNumberAvailableStatus:false,isengineNumberValid:true,engineNumber:null,chassisNumber:null,ischassisNumberValid:true,vlpnres:'',client:'',chassisres:'',engineres:'',subscriptionId:'',mmtc:'',noOfDevices:'',subscriptionDetails:[],idlingSpeed:3,invoiceNumber:'',equipmentSerialNumber:null,equipmentName:'',commissioningDate:{date:null,unix:__WEBPACK_IMPORTED_MODULE_20_moment___default()().unix().toString()},invoiceDate:{date:null,unix:__WEBPACK_IMPORTED_MODULE_20_moment___default()().unix().toString()},deviceModelId:'',department:'',contractorName:'',fuelType:'',solutionType:'',solution_type:[],selected_solution_codes:[],isDualEngine:false,eoff_voltage:null,eon_voltage:null,// reset technician selections
technicianCategory:null,selectedTaabiTechnician:null,selectedFreelancerTechnician:null,technicianName:'',hasArm:false,isElockConnection:false,isIndividualViewOrCombinedView:false,engineOnHours:'',odometerDistance:'',isengineOnHoursValid:true,isOdometerDistanceValid:true,engineSpecification:'',isEngineSpecificationValid:true,emissionRateType:'',istachoenabled:false,tachoidlerpm:'',tachoshifthours:'',engineSpecificationFromApi:false,emissionRateTypeFromApi:false,grossVehicleWeightFromApi:false,fuelTankCapacityFromApi:false,adblueCapacityFromApi:false,manufacturingYearFromApi:false,fuelTypeFromApi:false,makesList:[],modelsList:[],emissionList:[],makeModelsMainList:[],grossVehicleWeight:'',manufacturingYear:'',vehicleSegment:'',selectedVTM:'',videoTelematicsId:'',equipmentTypeClass:'',vehicleWheeler:'',application:'',haulageType:'',constructionVehicleType:'',passengerVehicleType:'',transportationVehicleType:'',vehicleNickName:'',documentUpload:null,baselineDataType:'',// baselineDataTypeFE: '',
baselineDataForFE:'',baselineHours:null,baselineDistance:'',fuelTankCapacity:'',adblueCapacity:'',errorMessage:null,errorMessageNew:null,errorMessageFuelTank:null,fileNames:'',uploadProgress:{},// Initialize uploadProgress state
equipmentTypeClassOptions:[],vehicleWheelerOptions:[],// applicationOptions: [],
haulageTypeOptions:[],constructionVehicleTypeOptions:[],equipmentTypeClassText:'',// For EVs free text input
isBaselineDataForFEValid:true,// Assume valid by default
manufacturingYearOptions:_manufacturingYearOptions,segmentOptions:[],noOfWheelsOptions:[],noOfGearsOptions:[],baselineDataTypeFEOptions:[],phaseOptions:__WEBPACK_IMPORTED_MODULE_22__utils_phaseOptionsArray__["a" /* phaseOptionsArray */],videoTelematicsType:[{label:'LocoNav',value:'loconav'},{label:'MettaX',value:'mettax'}],inputParameter:16,multiplicationFactor:2,// states for handling file upload response
fileName:'',bucketName:'',publicUploadURL:'',downloadUrl:'',isUploading:false,// To track upload status
showClientDetails:false,address:'',id:'',city:'',totalRegisteredVehicle:'',totalActiveDevicess:'',totalInactiveDevices:'',sparePartName:'',// zmId: '',
// kamId: '',
// channelPartnerName: '',
// throughChannelPartner: false,
portedVehicle:null,isTestingVehicle:null,kvaRating:'',dgSetType:'',bhp:'',phase:'',engineModel:'',gensetController:'',custCode:'',custType:'',vehicleData:'',rcRegnNo:'',rcRegnDt:'',rcRegnUpto:'',rcPurchaseDt:'',rcOwnerSr:'',rcOwnerName:'',stateCd:'',rtoCd:'',rcPresentAddress:'',rcPermanentAddress:'',rcVchCatg:'',rcVhClassDesc:'',rcChasiNo:'',rcEngNo:'',rcMakerDesc:'',rcMakerModel:'',rcBodyTypeDesc:'',rcFuelDesc:'',rcColor:'',rcNormsDesc:'',rcFitUpto:'',rcNpUpto:'',rcNpIssuedBy:'',rcTaxUpto:'',rcFinancer:'',rcInsuranceComp:'',rcInsurancePolicyNo:'',rcInsuranceUpto:'',rcManuMonthYr:'',// rcUnldWt: null,
rcUnldWt:'',rcGvw:'',rcNoCyl:'',rcCubicCap:'',rcSeatCap:'',rcSleeperCap:'',rcStandCap:'',rcWheelbase:'',rcRegisteredAt:'',rcStatusAsOn:'',rcPuccUpto:'',rcPuccNo:'',rcStatus:'',rcNcrbStatus:'',rcBlacklistStatus:'',rcPermitNo:'',rcPermitIssueDt:'',rcPermitValidFrom:'',rcPermitValidUpto:'',rcPermitType:'',rcPermitCode:'',rcNocDetails:'',rcVhType:'',rcVhClass:'',rcNocDt:'',rcFuelCd:'',rcMakerCd:'',rcModelCd:'',rcNormsCd:'',rcSaleAmt:'',rcOwnCatgDesc:''},_defineProperty(_this4$setState34,'rcVhClassDesc',''),_defineProperty(_this4$setState34,'rcOwnerCdDesc',''),_defineProperty(_this4$setState34,'rcCurrentaddDistrictcode',''),_defineProperty(_this4$setState34,'rcNonUse',''),_defineProperty(_this4$setState34,'rcPassengerTax',''),_defineProperty(_this4$setState34,'rcGoodsTax',''),_defineProperty(_this4$setState34,'rcNoOfAxle',null),_defineProperty(_this4$setState34,'rcApprovalDate',''),_defineProperty(_this4$setState34,'rcHp',''),_defineProperty(_this4$setState34,'rcMandalDesc',''),_defineProperty(_this4$setState34,'rcTalukCd',''),_defineProperty(_this4$setState34,'noOfWheels',null),_defineProperty(_this4$setState34,'noOfGears',null),_defineProperty(_this4$setState34,'vehicleCustomizedBodyType',''),_defineProperty(_this4$setState34,'customerCode',''),_defineProperty(_this4$setState34,'customerType',''),_this4$setState34));_context15.next=53;break;case 48:statusOnboard='failure';console.log('elseeeeeee');_this4.setState({failure:true});// this.props.openSnackbar(errors[0].message)
submitErrorMessage=errors[0].message;if(submitErrorMessage&&submitErrorMessage.includes('Vehicle number is already registered')){_this4.props.openSnackbar('Vehicle number is already registered.');}else{_this4.props.openSnackbar(submitErrorMessage);}case 53:console.log('outtttt');// Use mutationInput directly if provided
if(!mutationInput){_context15.next=58;break;}// Add status to mutationInput
mutationInputWithStatusOnboard=Object.assign({},mutationInput,{statusOnboard:statusOnboard});_context15.next=58;return client.mutate({mutation:__WEBPACK_IMPORTED_MODULE_30__queries__["d" /* CONFIRM_VEHICLE_REGISTRATION */],variables:{input:mutationInputWithStatusOnboard}});case 58:case'end':return _context15.stop();}}},_callee15,_this4,[[16,21],[27,36]]);}));return function(_x14){return _ref28.apply(this,arguments);};}();};this.getAllClients=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16(){var clientsDetails,allClients;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16){while(1){switch(_context16.prev=_context16.next){case 0:_context16.next=2;return _this4.props.client.query({query:__WEBPACK_IMPORTED_MODULE_30__queries__["j" /* GET_CLIENTS */],variables:{partnerLoginId:parseInt(_this4.state.partnerLoginId,10),status:parseInt(_this4.state.status,10)},fetchPolicy:'network-only'});case 2:clientsDetails=_context16.sent;allClients=clientsDetails.data.clientsDetails.map(function(client){return{value:client.loginId,label:client.clientName};});_this4.setState({clientsDetails:allClients});case 5:case'end':return _context16.stop();}}},_callee16,_this4);}));this.getZMKAMDetails=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee17(){var zmkamDetails,zmDetails,kamDetails;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17){while(1){switch(_context17.prev=_context17.next){case 0:_context17.next=2;return _this4.props.client.query({query:__WEBPACK_IMPORTED_MODULE_30__queries__["I" /* GET_ZMKAM */],variables:{roleName:['Zonal Manager(ZM)','Key Account Manager(KAM)']},fetchPolicy:'network-only'});case 2:zmkamDetails=_context17.sent;zmDetails=zmkamDetails.data.getAdminUserDetailsByRole.filter(function(user){return user.role==='Zonal Manager(ZM)';}).map(function(user){return{value:user.id,label:user.username};});kamDetails=zmkamDetails.data.getAdminUserDetailsByRole.filter(function(user){return user.role==='Key Account Manager(KAM)';}).map(function(user){return{value:user.id,label:user.username};});_this4.setState({zmDetails:zmDetails,kamDetails:kamDetails});case 6:case'end':return _context17.stop();}}},_callee17,_this4);}));this.getAllAssignedRoles=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee18(){var _ref33,data,taabiList,freelancerList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18){while(1){switch(_context18.prev=_context18.next){case 0:_context18.prev=0;_context18.next=3;return _this4.props.client.query({query:__WEBPACK_IMPORTED_MODULE_30__queries__["f" /* GET_ALL_ASSIGNED_ROLES */],fetchPolicy:'network-only'});case 3:_ref33=_context18.sent;data=_ref33.data;if(data&&data.getAllAssignedRoles){taabiList=data.getAllAssignedRoles.filter(function(u){return u.role==='Technician - Taabi Personal';}).map(function(u){return{label:u.username||u.email||u.uuid,value:u.username||u.uuid};});freelancerList=data.getAllAssignedRoles.filter(function(u){return u.role==='Technician - Freelancer';}).map(function(u){return{label:u.mobile_number||u.username||u.uuid,value:u.mobile_number||u.uuid};});_this4.setState({assignedTechniciansTaabi:taabiList,assignedTechniciansFreelancer:freelancerList});}_context18.next=11;break;case 8:_context18.prev=8;_context18.t0=_context18['catch'](0);// swallow or log error
console.error('Error fetching assigned roles',_context18.t0);case 11:case'end':return _context18.stop();}}},_callee18,_this4,[[0,8]]);}));this.handleTechnicianCategoryChange=function(option){// option is an object from react-select
var category=option&&option.value?option.value:null;_this4.setState({technicianCategory:category,// clear selections when switching
selectedTaabiTechnician:null,selectedFreelancerTechnician:null,technicianName:''});};this.handleTaabiSelectChange=function(option){_this4.setState({selectedTaabiTechnician:option,technicianName:option?option.value:''});};this.handleFreelancerSelectChange=function(option){_this4.setState({selectedFreelancerTechnician:option,technicianName:option?option.value:''});};this.getDashcamRegistrations=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee19(){var _ref35,data,registrations,vtidOptions;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19){while(1){switch(_context19.prev=_context19.next){case 0:_this4.setState({dashcamRegistrationsLoading:true});_context19.prev=1;_context19.next=4;return _this4.props.client.query({query:__WEBPACK_IMPORTED_MODULE_30__queries__["n" /* GET_DASHCAM_REGISTRATIONS */],fetchPolicy:'network-only'});case 4:_ref35=_context19.sent;data=_ref35.data;if(data.getDashcamRegistrations.success){registrations=data.getDashcamRegistrations.data.filter(function(registrations){return registrations.status==='available';});vtidOptions=registrations.map(function(item){return{value:item.vtid,label:item.vtid,simid:item.simid,memorycardid:item.memorycardid};});_this4.setState({dashcamRegistrations:registrations,vtidOptions:vtidOptions,dashcamRegistrationsLoading:false});}else{_this4.setState({dashcamRegistrationsLoading:false});}_context19.next=13;break;case 9:_context19.prev=9;_context19.t0=_context19['catch'](1);console.error('Error fetching dashcam registrations:',_context19.t0);_this4.setState({dashcamRegistrationsLoading:false});case 13:case'end':return _context19.stop();}}},_callee19,_this4,[[1,9]]);}));this.handleVtidChange=function(selectedOption){if(selectedOption&&selectedOption.value){_this4.setState({selectedVtid:selectedOption,selectedSimId:selectedOption.simid,selectedMemoryCardId:selectedOption.memorycardid,videoTelematicsId:selectedOption.value});}else{_this4.setState({selectedVtid:null,selectedSimId:null,selectedMemoryCardId:null,videoTelematicsId:null});}};this.getMakeAndModels=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee20(){var makemodellist;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20){while(1){switch(_context20.prev=_context20.next){case 0:_context20.next=2;return _this4.props.client.query({query:__WEBPACK_IMPORTED_MODULE_30__queries__["C" /* GET_VEHICLE_MAKES */],variables:{},fetchPolicy:'network-only'});case 2:makemodellist=_context20.sent;// console.log('makemodellist',makemodellist.data.getVehicleMakes);
_this4.setState({makesList:makemodellist.data.getVehicleMakes});case 4:case'end':return _context20.stop();}}},_callee20,_this4);}));this.getAllDGMakes=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee21(){var responce,makes,makesList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21){while(1){switch(_context21.prev=_context21.next){case 0:_context21.next=2;return _this4.props.client.query({query:__WEBPACK_IMPORTED_MODULE_30__queries__["g" /* GET_ALL_DG_MAKES */],variables:{},fetchPolicy:'network-only'});case 2:responce=_context21.sent;makes=responce.data.getDgMakes;console.log('makes',makes);makesList=makes&&makes.map(function(make){return{make:make,id:make};});console.log('makesList',makesList);_this4.setState({makesList:makesList});case 8:case'end':return _context21.stop();}}},_callee21,_this4);}));this.getVehicleType=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee22(){var _ref39,data,vehicleTypes;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22){while(1){switch(_context22.prev=_context22.next){case 0:_context22.next=2;return _this4.props.client.query({query:__WEBPACK_IMPORTED_MODULE_30__queries__["F" /* GET_VEHICLE_TYPE */],variables:{},fetchPolicy:'network-only'});case 2:_ref39=_context22.sent;data=_ref39.data;vehicleTypes=data.getAllVehicleType.map(function(item){return item.vehicleType;});_this4.setState({vehicleTypes:vehicleTypes});case 6:case'end':return _context22.stop();}}},_callee22,_this4);}));this.handleChange=function(name){return function(event){_this4.setState(_defineProperty({},name,event.target.checked),function(){console.log(_this4.state.installStatus,'kk');});};};this.flushVahaanValues=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee23(){var _this4$setState36;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee23$(_context23){while(1){switch(_context23.prev=_context23.next){case 0:if(_this4.state.vehicleSegment=='DG Set'){_this4.setState((_this4$setState36={loading:false,vehicleData:null,rcRegnNo:'',rcRegnDt:'',rcRegnUpto:'',rcPurchaseDt:'',rcOwnerSr:'',rcOwnerName:'',stateCd:'',rtoCd:'',rcPresentAddress:'',rcPermanentAddress:'',rcVchCatg:'',rcVhClassDesc:'',rcChasiNo:'',rcEngNo:'',rcMakerDesc:'',rcMakerModel:'',rcBodyTypeDesc:'',rcFuelDesc:'',rcColor:'',rcNormsDesc:'',rcFitUpto:'',rcNpUpto:'',rcNpIssuedBy:'',rcTaxUpto:'',rcFinancer:'',rcInsuranceComp:'',rcInsurancePolicyNo:'',rcInsuranceUpto:'',rcManuMonthYr:'',rcUnldWt:'',rcGvw:'',rcNoCyl:'',rcCubicCap:'',rcSeatCap:'',rcSleeperCap:'',rcStandCap:'',rcWheelbase:'',rcRegisteredAt:'',rcStatusAsOn:'',rcPuccUpto:'',rcPuccNo:'',rcStatus:'',rcNcrbStatus:'',rcBlacklistStatus:'',rcPermitNo:'',rcPermitIssueDt:'',rcPermitValidFrom:'',rcPermitValidUpto:'',rcPermitType:'',rcPermitCode:'',rcNocDetails:'',rcVhType:'',rcVhClass:'',rcNocDt:'',rcFuelCd:'',rcMakerCd:'',rcModelCd:'',rcNormsCd:'',rcSaleAmt:'',rcOwnCatgDesc:''},_defineProperty(_this4$setState36,'rcVhClassDesc',''),_defineProperty(_this4$setState36,'rcOwnerCdDesc',''),_defineProperty(_this4$setState36,'rcCurrentaddDistrictcode',''),_defineProperty(_this4$setState36,'rcNonUse',''),_defineProperty(_this4$setState36,'rcPassengerTax',''),_defineProperty(_this4$setState36,'rcGoodsTax',''),_defineProperty(_this4$setState36,'rcNoOfAxle',''),_defineProperty(_this4$setState36,'rcApprovalDate',''),_defineProperty(_this4$setState36,'rcHp',''),_defineProperty(_this4$setState36,'rcMandalDesc',''),_defineProperty(_this4$setState36,'rcTalukCd',''),_this4$setState36));}case 1:case'end':return _context23.stop();}}},_callee23,_this4);}));this.handleVehicleRegistrationNumberAvailableChange=function(name){return function(event){var enteredVehicleRegistrationNumber=null;_this4.setState(_defineProperty({},name,event.target.checked),function(){if(_this4.state.vehicleRegistrationNumberAvailableStatus){console.log('Vehicle Registration Number Available');}else{var _this4$setState38;console.log('Vehicle Registration Number Unavailable');_this4.setState((_this4$setState38={loading:false,vehicleData:null,rcRegnNo:'',rcRegnDt:'',rcRegnUpto:'',rcPurchaseDt:'',rcOwnerSr:'',rcOwnerName:'',stateCd:'',rtoCd:'',rcPresentAddress:'',rcPermanentAddress:'',rcVchCatg:'',rcVhClassDesc:'',rcChasiNo:'',rcEngNo:'',rcMakerDesc:'',rcMakerModel:'',rcBodyTypeDesc:'',rcFuelDesc:'',rcColor:'',rcNormsDesc:'',rcFitUpto:'',rcNpUpto:'',rcNpIssuedBy:'',rcTaxUpto:'',rcFinancer:'',rcInsuranceComp:'',rcInsurancePolicyNo:'',rcInsuranceUpto:'',rcManuMonthYr:'',rcUnldWt:'',rcGvw:'',rcNoCyl:'',rcCubicCap:'',rcSeatCap:'',rcSleeperCap:'',rcStandCap:'',rcWheelbase:'',rcRegisteredAt:'',rcStatusAsOn:'',rcPuccUpto:'',rcPuccNo:'',rcStatus:'',rcNcrbStatus:'',rcBlacklistStatus:'',rcPermitNo:'',rcPermitIssueDt:'',rcPermitValidFrom:'',rcPermitValidUpto:'',rcPermitType:'',rcPermitCode:'',rcNocDetails:'',rcVhType:'',rcVhClass:'',rcNocDt:'',rcFuelCd:'',rcMakerCd:'',rcModelCd:'',rcNormsCd:'',rcSaleAmt:'',rcOwnCatgDesc:''},_defineProperty(_this4$setState38,'rcVhClassDesc',''),_defineProperty(_this4$setState38,'rcOwnerCdDesc',''),_defineProperty(_this4$setState38,'rcCurrentaddDistrictcode',''),_defineProperty(_this4$setState38,'rcNonUse',''),_defineProperty(_this4$setState38,'rcPassengerTax',''),_defineProperty(_this4$setState38,'rcGoodsTax',''),_defineProperty(_this4$setState38,'rcNoOfAxle',''),_defineProperty(_this4$setState38,'rcApprovalDate',''),_defineProperty(_this4$setState38,'rcHp',''),_defineProperty(_this4$setState38,'rcMandalDesc',''),_defineProperty(_this4$setState38,'rcTalukCd',''),_this4$setState38));}});};};this.getDataByVehicleNumber=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee24(){var enteredVehicleRegistrationNumber,response,vehicleData,_this4$setState39;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee24$(_context24){while(1){switch(_context24.prev=_context24.next){case 0:enteredVehicleRegistrationNumber=_this4.state.enteredVehicleRegistrationNumber;_this4.setState({vehicleData:null,vlpnres:'',loading:false});if(!(!enteredVehicleRegistrationNumber||enteredVehicleRegistrationNumber.length<5||enteredVehicleRegistrationNumber.length>32)){_context24.next=5;break;}_this4.setState({vlpnres:'Vehicle Registration Number must be between 5 to 32 characters.'});return _context24.abrupt('return');case 5:_context24.prev=5;_this4.setState({loading:true});_context24.next=9;return _this4.props.client.query({query:__WEBPACK_IMPORTED_MODULE_30__queries__["G" /* GET_VEHICLE_VAHAAN_DETAILS */],variables:{vehicleNumber:enteredVehicleRegistrationNumber}});case 9:response=_context24.sent;if(response.data&&response.data.getVehicleVahaanDetails&&response.data.getVehicleVahaanDetails.length>0){vehicleData=response.data.getVehicleVahaanDetails[0];_this4.setState({vehicleData:vehicleData});console.log('Fetched vehicle details:',vehicleData);}else{console.log('No vehicle details found.');{_this4.setState({vlpnres:'Data not available currently for the entered Vehicle Number. Please check the Vehicle Number and try again after some time.'});}}_context24.next=17;break;case 13:_context24.prev=13;_context24.t0=_context24['catch'](5);console.error('Error fetching vehicle details:',_context24.t0);_this4.setState({vlpnres:'Error occurred while fetching vehicle details. Please try again after some time.'});case 17:_context24.prev=17;_this4.setState({loading:false});return _context24.finish(17);case 20:if(_this4.state.vlpnres){_this4.setState((_this4$setState39={rcRegnNo:'',rcRegnDt:'',rcRegnUpto:'',rcPurchaseDt:'',rcOwnerSr:'',rcOwnerName:'',stateCd:'',rtoCd:'',rcPresentAddress:'',rcPermanentAddress:'',rcVchCatg:'',rcVhClassDesc:'',rcChasiNo:'',rcEngNo:'',rcMakerDesc:'',rcMakerModel:'',rcBodyTypeDesc:'',rcFuelDesc:'',rcColor:'',rcNormsDesc:'',rcFitUpto:'',rcNpUpto:'',rcNpIssuedBy:'',rcTaxUpto:'',rcFinancer:'',rcInsuranceComp:'',rcInsurancePolicyNo:'',rcInsuranceUpto:'',rcManuMonthYr:'',rcUnldWt:'',rcGvw:'',rcNoCyl:'',rcCubicCap:'',rcSeatCap:'',rcSleeperCap:'',rcStandCap:'',rcWheelbase:'',rcRegisteredAt:'',rcStatusAsOn:'',rcPuccUpto:'',rcPuccNo:'',rcStatus:'',rcNcrbStatus:'',rcBlacklistStatus:'',rcPermitNo:'',rcPermitIssueDt:'',rcPermitValidFrom:'',rcPermitValidUpto:'',rcPermitType:'',rcPermitCode:'',rcNocDetails:'',rcVhType:'',rcVhClass:'',rcNocDt:'',rcFuelCd:'',rcMakerCd:'',rcModelCd:'',rcNormsCd:'',rcSaleAmt:'',rcOwnCatgDesc:''},_defineProperty(_this4$setState39,'rcVhClassDesc',''),_defineProperty(_this4$setState39,'rcOwnerCdDesc',''),_defineProperty(_this4$setState39,'rcCurrentaddDistrictcode',''),_defineProperty(_this4$setState39,'rcNonUse',''),_defineProperty(_this4$setState39,'rcPassengerTax',''),_defineProperty(_this4$setState39,'rcGoodsTax',''),_defineProperty(_this4$setState39,'rcNoOfAxle',''),_defineProperty(_this4$setState39,'rcApprovalDate',''),_defineProperty(_this4$setState39,'rcHp',''),_defineProperty(_this4$setState39,'rcMandalDesc',''),_defineProperty(_this4$setState39,'rcTalukCd',''),_this4$setState39));}case 21:case'end':return _context24.stop();}}},_callee24,_this4,[[5,13,17,20]]);}));this.handleImmobilizeChange=function(name){return function(event){_this4.setState(_defineProperty({},name,event.target.checked),function(){console.log(_this4.state.immobilize,'kk');});};};this.checkEngineNumber=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee25(){var _ref43,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee25$(_context25){while(1){switch(_context25.prev=_context25.next){case 0:if(!(_this4.state.engineNumber!==''&&_this4.state.engineNumber!==null)){_context25.next=7;break;}_context25.next=3;return _this4.props.client.query({query:__WEBPACK_IMPORTED_MODULE_30__queries__["c" /* CHECK_ENGINE_NUMBER */],variables:{engineNumber:_this4.state.engineNumber}});case 3:_ref43=_context25.sent;data=_ref43.data;_this4.setState({isengineNumberValid:data.checkEngineNumber==='AVAILABLE'&&_this4.state.engineNumber.length>1&&_this4.state.engineNumber.length<41});if(data.checkEngineNumber!=='AVAILABLE'){_this4.setState({engineres:'Engine Number Already Exist!'});}else if(_this4.state.engineNumber!==''&&_this4.state.engineNumber!==null||_this4.state.engineNumber.length<1||_this4.state.engineNumber.length>40){_this4.setState({engineres:'Engine Number should be between 2-40 characters'});}case 7:if(_this4.state.engineNumber===''){_this4.setState({engineNumber:null});}case 8:case'end':return _context25.stop();}}},_callee25,_this4);}));this.checkChassisNumber=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee26(){var _ref45,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee26$(_context26){while(1){switch(_context26.prev=_context26.next){case 0:if(!(_this4.state.chassisNumber!==''&&_this4.state.chassisNumber!==null)){_context26.next=7;break;}_context26.next=3;return _this4.props.client.query({query:__WEBPACK_IMPORTED_MODULE_30__queries__["b" /* CHECK_CHASSIS_NUMBER */],variables:{chassisNumber:_this4.state.chassisNumber}});case 3:_ref45=_context26.sent;data=_ref45.data;_this4.setState({ischassisNumberValid:data.checkChassisNumber==='AVAILABLE'&&_this4.state.chassisNumber.length>1&&_this4.state.chassisNumber.length<41});if(data.checkChassisNumber!=='AVAILABLE'){_this4.setState({chassisres:'Chassis Number Already Exist!'});}else if(_this4.state.chassisNumber!==''&&_this4.state.chassisNumber!==null||_this4.state.chassisNumber.length<1||_this4.state.chassisNumber.length>40){_this4.setState({chassisres:'Chassis Number should be between 2-40 characters'});}case 7:if(_this4.state.chassisNumber===''){_this4.setState({chassisNumber:null});}case 8:case'end':return _context26.stop();}}},_callee26,_this4);}));this.isNumericalArray=function(array){return array.every(function(item){return!isNaN(item);});};this.sortNumericalArray=function(array){return array.sort(function(a,b){return parseInt(a)-parseInt(b);});};this.fetchDropdownDetails=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee27(){var response,dropdownData,dropdownValues;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee27$(_context27){while(1){switch(_context27.prev=_context27.next){case 0:_context27.prev=0;_context27.next=3;return _this4.props.client.query({query:__WEBPACK_IMPORTED_MODULE_30__queries__["s" /* GET_DROPDOWN_DETAILS */]});case 3:response=_context27.sent;console.log('Raw response:',response);dropdownData=JSON.parse(response.data.getDropDownDetail);console.log('Parsed dropdown data:',dropdownData);dropdownValues={};Object.keys(dropdownData).forEach(function(key){if(Array.isArray(dropdownData[key])){dropdownValues[key]=dropdownData[key].filter(function(option){return option!==null;});}if(_this4.isNumericalArray(dropdownValues[key])){dropdownValues[key]=_this4.sortNumericalArray(dropdownValues[key]);}});_this4.setState(Object.assign({},dropdownValues,{selectedApplication:''}));_context27.next=15;break;case 12:_context27.prev=12;_context27.t0=_context27['catch'](0);console.error('Error fetching dropdown details:',_context27.t0);case 15:case'end':return _context27.stop();}}},_callee27,_this4,[[0,12]]);}));this.fetchCustomerTypeAndCode=function(){var _ref47=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee28(clientName){var response,customerData,customerValues;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee28$(_context28){while(1){switch(_context28.prev=_context28.next){case 0:_context28.prev=0;_context28.next=3;return _this4.props.client.query({query:__WEBPACK_IMPORTED_MODULE_30__queries__["m" /* GET_CUSTOMER_TYPE_AND_CODE */],variables:{clientName:clientName}});case 3:response=_context28.sent;console.log('Raw response:',response);customerData=response.data.getCustomerTypeAndCode;console.log('Parsed customer data:',customerData);customerValues={id:customerData.id,clientName:customerData.clientName,registrationType:customerData.registrationType,directCustomerSAPCode:customerData.directCustomerSAPCode,channelPartnerSAPCode:customerData.channelPartnerSAPCode};_this4.setState(Object.assign({},customerValues));_context28.next=14;break;case 11:_context28.prev=11;_context28.t0=_context28['catch'](0);console.error('Error fetching customer type and code:',_context28.t0);case 14:case'end':return _context28.stop();}}},_callee28,_this4,[[0,11]]);}));return function(_x15){return _ref47.apply(this,arguments);};}();};VehicleRegistration.propTypes={classes:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_17_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_15__HOCs_withSharedSnackbar__["a" /* default */])(VehicleRegistration)));

/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__queries__ = __webpack_require__(185);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _fieldLabels;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// Mapping field keys to display labels
var fieldLabels=(_fieldLabels={vehicleNumber:'Vehicle Number',solutionType:'Solution Type',uniqueDeviceId:'Device',litemode:'Mode',planName:'Plan Name',videoTelematicsType:'Video Telematics Type',videoTelematicsTypeFromVehicleReg:'Video Telematics',fuelType:"Fuel Type",vehicleMake:'Vehicle Make',vehicleModel:'Vehicle Model',noOfGears:'No of Gears',gearRatio:'Gear Ratio',isDualEngine:'Dual Engine',hasArm:"Arm Included",isRotationSensor:"Rotation Sensor"},_defineProperty(_fieldLabels,'solutionType',"Solution Type"),_defineProperty(_fieldLabels,'hasSecondaryTank','Has Secondary Tank'),_defineProperty(_fieldLabels,'availableDataTypes','Available Data Types'),_defineProperty(_fieldLabels,'preferedDataType','Preferred Data Type'),_fieldLabels);var fuelSensorTypeLabels={1:'digital-sensor-data',2:'analog-sensor-data',3:'obd-data'};// Add a mapping for user-friendly preferred data type labels
var preferredDataTypeLabels={1:'Digital Sensor Data',2:'Analog Sensor Data',3:'OBD Data'};// Helper function to format videoTelematicsType
var formatVideoTelematicsType=function formatVideoTelematicsType(value){switch(value){case'loconav':case'API-Loconav':return'API-Loconav';case'mettax':case'API-Meta':return'API-Meta';case'lightMetrics':case'iFrame-LM':return'iFrame-LM';default:return value||'NA';}};// Helper function to format videoTelematicsType
var formatVideoTelematicsTypeFromReg=function formatVideoTelematicsTypeFromReg(value){switch(value){case'loconav':return'LocoNav';case'mettax':return'MettaX';default:return value||'NA';}};var formatFuelType=function formatFuelType(value){switch(value){case'petrol':return'PETROL';case'diesel':return'DIESEL';case'ev':return'EV';case'cng':return'CNG';case'lng':return'LNG';default:return value||'NA';}};var formatDualEngine=function formatDualEngine(value){if(value===true)return'Yes';if(value===false)return'No';return'NA';};var formatSolutionType=function formatSolutionType(value){if(!value)return'NA';// Custom mappings for vehicle categories/solution types
var customMapping={'fuel_solution':'Fuel Solution','obd_solution':'OBD Solution','obd_fuel+fuel_solution':'OBD + Fuel Solution','basic_tracking':'Basic Tracking','ais_140':'AIS 140','ais_140_obd_solution':'AIS 140 OBD Solution','ported_fuel_solution':'Ported Fuel Solution','control_tower':'Control Tower','testing_vehicle':'Testing Vehicle','dummy_vehicle':'Dummy Vehicle','video_telematics':'Video Telematics','3-Wheeler':'3-Wheeler','Ambulance':'Ambulance','BIKE':'Bike','Boom Placer':'Boom Placer','CAR':'Car','Crane':'Crane','Dual-Engine':'Dual-Engine','Excavator':'Excavator','GeneratorTanker':'GeneratorTanker','Lift':'Lift','School Bus':'School Bus','Sixseater':'Sixseater','Stacker':'Stacker','Tow':'Tow','Tower Crane':'Tower Crane','Tractor':'Tractor','Truck':'Truck','Tug':'Tug'};if(customMapping[value]){return customMapping[value];}// Fallback: format snake_case or specific strings
return value.toString().replace(/_/g,' ').replace(/\b\w/g,function(char){return char.toUpperCase();});};// Component to preview vehicle details
var VehiclePreviewModal=function VehiclePreviewModal(_ref){var open=_ref.open,onClose=_ref.onClose,vehicleData=_ref.vehicleData,hasSecondaryTank=_ref.hasSecondaryTank,calibrationLoading=_ref.calibrationLoading,calibrationError=_ref.calibrationError,availableDataTypes=_ref.availableDataTypes,preferedDataType=_ref.preferedDataType,isDualSensor=_ref.isDualSensor,hasInSameTank=_ref.hasInSameTank,calibrationFilename=_ref.calibrationFilename,fuelSensorType=_ref.fuelSensorType,_ref$showConfirm=_ref.showConfirm,showConfirm=_ref$showConfirm===undefined?false:_ref$showConfirm,zone=_ref.zone,keyAccountManager=_ref.keyAccountManager,onConfirm=_ref.onConfirm;// Enhanced: Defensive check for vehicleData
if(!vehicleData||(typeof vehicleData==='undefined'?'undefined':_typeof(vehicleData))!=='object'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Dialog"],{open:open,onClose:onClose,maxWidth:'md',fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["DialogTitle"],null,'Vehicle Registration Preview'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["DialogContent"],{dividers:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Paper"],{style:{padding:24,textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'No vehicle data available.'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["DialogActions"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Button"],{onClick:onClose,color:'primary',variant:'contained'},'Close')));}var rows=Object.entries(vehicleData).filter(function(_ref2){var _ref3=_slicedToArray(_ref2,1),key=_ref3[0];return key!=='videoTelematicsTypeFromVehicleReg'&&key!=='clientLoginId'&&key!=='fuelType'&&key!=='vehicleMake'&&key!=='vehicleModel'&&key!=='noOfGears'&&key!=='gearRatio'&&key!=='isDualEngine'&&key!=='hasArm'&&key!=='isRotationSensor'&&key!=='solutionType';}).map(function(_ref4){var _ref5=_slicedToArray(_ref4,2),key=_ref5[0],value=_ref5[1];return{label:fieldLabels[key]||key,value:value===undefined||value===null||value===''?'NA':String(value)};});var loginId=vehicleData.clientLoginId;console.log('loginId',loginId);// Map availableDataTypes array to labels
var availableDataTypesDisplay='NA';if(Array.isArray(availableDataTypes)&&availableDataTypes.length>0){availableDataTypesDisplay=availableDataTypes.map(function(type){return fuelSensorTypeLabels[type]||String(type);}).join(', ');}// Map preferedDataType to user-friendly label (single value)
var preferedDataTypeDisplay='NA';if(typeof preferedDataType!=='undefined'&&preferedDataType!==null&&preferedDataType!==''){preferedDataTypeDisplay=preferredDataTypeLabels[preferedDataType]||String(preferedDataType);}// Map isDualSensor to Yes/No/NA
var isDualSensorDisplay='NA';if(isDualSensor===true)isDualSensorDisplay='Yes';else if(isDualSensor===false)isDualSensorDisplay='No';// Map hasInSameTank to Yes/No/NA
var hasInSameTankDisplay='NA';if(hasInSameTank===true)hasInSameTankDisplay='Yes';else if(hasInSameTank===false)hasInSameTankDisplay='No';// Map fuelSensorType to user-friendly label (string, e.g., 'Digital_sensor')
var fuelSensorTypeDisplay='NA';if(typeof fuelSensorType==='string'&&fuelSensorType.trim()!==''){fuelSensorTypeDisplay=fuelSensorType.replace(/_/g,' ').replace(/\w\S*/g,function(txt){return txt.charAt(0).toUpperCase()+txt.substr(1).toLowerCase();});}else if(typeof fuelSensorType!=='undefined'&&fuelSensorType!==null&&fuelSensorType!==''){fuelSensorTypeDisplay=String(fuelSensorType);}// Calibration filename display
var calibrationFilenameDisplay=calibrationFilename||'NA';// Helper to gather all data for mutation
var getMutationInput=function getMutationInput(clientData){// Get client details from the Query component's data
var clientDetails=clientData&&clientData.clientDetail?clientData.clientDetail:{};console.log('clientDetails',clientDetails);var deviceDetails=vehicleData&&vehicleData.deviceDetail?vehicleData.deviceDetail:{};var planDetails=clientDetails&&clientDetails.plan?clientDetails.plan:{};return Object.assign({},vehicleData,{zone:clientDetails.zone||'',keyAccountManager:clientDetails.keyAccountManager||'',// Client details
litemode:clientDetails.litemode,planName:planDetails.planName,videoTelematicsType:formatVideoTelematicsType(clientDetails.videoTelematicsType),videoTelematicsTypeFromVehicleReg:formatVideoTelematicsTypeFromReg(vehicleData.videoTelematicsTypeFromVehicleReg),// Vehicle specific details
fuelType:formatFuelType(vehicleData.fuelType),vehicleMake:vehicleData.vehicleMake,vehicleModel:vehicleData.vehicleModel,noOfGears:vehicleData.noOfGears,gearRatio:vehicleData.gearRatio,isDualEngine:vehicleData.isDualEngine,hasArm:vehicleData.hasArm,isRotationSensor:vehicleData.isRotationSensor,solutionType:formatSolutionType(vehicleData.solutionType?vehicleData.solutionType:""),// Calibration details
hasSecondaryTank:hasSecondaryTank,availableDataTypes:availableDataTypes,preferedDataType:preferedDataType,isDualSensor:isDualSensor,hasInSameTank:hasInSameTank,calibrationFilename:calibrationFilename,fuelSensorType:fuelSensorType,// Additional fields from vehicleData if they exist
entityId:vehicleData.entityId,vehicleNumber:vehicleData.vehicleNumber,// deviceDetail: deviceDetails,
uniqueDeviceId:vehicleData.uniqueDeviceId||'',// Collect all selected plans
selectedPlans:Object.keys(vehicleData).filter(function(key){return key.startsWith('selected_plan_');}).reduce(function(acc,key){acc[key]=vehicleData[key];return acc;},{})});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Dialog"],{open:open,onClose:onClose,maxWidth:'md',fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["DialogTitle"],null,'Vehicle Registration Preview'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["DialogContent"],{dividers:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Paper"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Table"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableHead"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Field')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Value')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableBody"],null,rows.length===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],{colSpan:2,style:{color:'gray',textAlign:'center'}},'No vehicle details to display.')),rows.map(function(row,idx){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableRow"],{key:idx},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],null,row.label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],null,row.value));}),loginId&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["Query"],{query:__WEBPACK_IMPORTED_MODULE_3__queries__["k" /* GET_CLIENT_DETAILS */],variables:{loginId:parseInt(loginId)},fetchPolicy:'network-only'},function(_ref6){var loading=_ref6.loading,error=_ref6.error,data=_ref6.data;if(loading)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],{colSpan:2,style:{color:'gray'}},'Loading client details...'));if(error)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],{colSpan:2,style:{color:'red'}},'Error loading client details: ',error.message));if(!data||!data.clientDetail){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],{colSpan:2,style:{color:'gray'}},'Client details not found.'));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],null,fieldLabels['litemode']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],null,data.clientDetail.litemode||'NA')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],null,fieldLabels['planName']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],null,data.clientDetail.plan&&data.clientDetail.plan.planName?data.clientDetail.plan.planName:'NA')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],null,fieldLabels['videoTelematicsType']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],null,formatVideoTelematicsType(data.clientDetail.videoTelematicsType)||'NA')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],null,fieldLabels['videoTelematicsTypeFromVehicleReg']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],null,formatVideoTelematicsTypeFromReg(vehicleData.videoTelematicsTypeFromVehicleReg)||'NA')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],null,fieldLabels['fuelType']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],null,formatFuelType(vehicleData.fuelType)||'NA')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],null,fieldLabels['vehicleMake']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],null,vehicleData.vehicleMake||'NA')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],null,fieldLabels['vehicleModel']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],null,vehicleData.vehicleModel||'NA')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],null,fieldLabels['noOfGears']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],null,vehicleData.noOfGears||'NA')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],null,fieldLabels['gearRatio']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],null,vehicleData.gearRatio||'NA')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],null,fieldLabels['isDualEngine']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],null,formatDualEngine(vehicleData.isDualEngine)||'NA')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],null,fieldLabels['hasArm']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],null,formatDualEngine(vehicleData.hasArm)||'NA')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],null,fieldLabels['isRotationSensor']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],null,formatDualEngine(vehicleData.isRotationSensor)||'NA')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],null,fieldLabels['solutionType']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],null,formatSolutionType(vehicleData.solutionType)||'NA')));}),calibrationLoading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],{colSpan:2,style:{color:'gray'}},'Loading Calibration Details...')),calibrationError&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],{colSpan:2,style:{color:'red'}},'Error: ',typeof calibrationError==='string'?calibrationError:calibrationError&&calibrationError.message||'Unknown error')),calibrationLoading===false&&!calibrationError&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],null,fieldLabels['hasSecondaryTank']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],null,hasSecondaryTank===null||typeof hasSecondaryTank==='undefined'?'NA':hasSecondaryTank===true?'Yes':hasSecondaryTank===false?'No':String(hasSecondaryTank))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],null,fieldLabels['availableDataTypes']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],null,availableDataTypesDisplay)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],null,fieldLabels['preferedDataType']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],null,preferedDataTypeDisplay)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],null,'Dual Sensor Available'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],null,isDualSensorDisplay)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],null,'Is in Same Tank'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],null,hasInSameTankDisplay)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],null,'Calibration Filename'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],null,calibrationFilenameDisplay)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],null,'Fuel Sensor Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TableCell"],null,fuelSensorTypeDisplay))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["DialogActions"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Button"],{onClick:onClose,color:'primary',variant:'contained'},'Close'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["Query"],{query:__WEBPACK_IMPORTED_MODULE_3__queries__["k" /* GET_CLIENT_DETAILS */],variables:{loginId:vehicleData&&vehicleData.clientLoginId?parseInt(vehicleData.clientLoginId):null},fetchPolicy:'network-only'},function(_ref7){var clientLoading=_ref7.loading,clientError=_ref7.error,clientData=_ref7.data;if(clientLoading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Button"],{color:'secondary',variant:'contained',disabled:true},'Loading...');}if(clientError){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'red',marginLeft:16}},'Error loading client details: ',clientError.message);}if(!clientData||!clientData.clientDetail){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'gray',marginLeft:16}},'Client details not found.');}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Button"],{onClick:function onClick(){// Get the mutation input data
var mutationInput=getMutationInput(clientData);if(onConfirm)onConfirm(mutationInput);},color:'secondary',variant:'contained',disabled:clientLoading},'Confirm');})));};/* harmony default export */ __webpack_exports__["a"] = (VehiclePreviewModal);

/***/ }),
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__queries__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormHelperText__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormHelperText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormHelperText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControlLabel__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControlLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControlLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Switch__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Checkbox__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_material_ui_pickers__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_icons_Close__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_icons_Close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_icons_Close__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var SelectReact=__WEBPACK_IMPORTED_MODULE_11_react_select__["a" /* default */];var SolutionTypeOption=function SolutionTypeOption(props){var onSelect=props.onSelect,onFocus=props.onFocus,isSelected=props.isSelected,option=props.option,children=props.children,className=props.className;var handleMouseDown=function handleMouseDown(event){event.preventDefault();event.stopPropagation();onSelect(option,event);};var handleMouseEnter=function handleMouseEnter(event){onFocus(option,event);};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:className,onMouseDown:handleMouseDown,onMouseEnter:handleMouseEnter,onMouseMove:handleMouseEnter,title:option.title,style:{display:'flex',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Checkbox___default.a,{checked:!!isSelected,color:'primary'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,children));};var VehicleInfoStep=function VehicleInfoStep(props){var state=props.state,classes=props.classes,client=props.client,handleInputChange=props.handleInputChange,checkVlpnValidity=props.checkVlpnValidity,handleChangeSpeedSensor=props.handleChangeSpeedSensor,checkSpeedSensorValidity=props.checkSpeedSensorValidity,checkSpeedLimitValidity=props.checkSpeedLimitValidity,handleFileChange=props.handleFileChange,handleDownload=props.handleDownload,handleRemove=props.handleRemove,handleDateChange=props.handleDateChange,handleChangeIdlingSpeed=props.handleChangeIdlingSpeed,handleChangeInputParameter=props.handleChangeInputParameter,handleChangeMultiplicationFactor=props.handleChangeMultiplicationFactor,handleChangeDevice=props.handleChangeDevice,handleChangePhoneNumber=props.handleChangePhoneNumber,handleChangeAccessories=props.handleChangeAccessories,handleTechnicianCategoryChange=props.handleTechnicianCategoryChange,handleTaabiSelectChange=props.handleTaabiSelectChange,handleFreelancerSelectChange=props.handleFreelancerSelectChange,handleChangeSubscription=props.handleChangeSubscription,checkItemValidity=props.checkItemValidity,handleChangeMake=props.handleChangeMake,handleChangeModelNew=props.handleChangeModelNew,checkDualEngineVoltageValidity=props.checkDualEngineVoltageValidity,checkAdblueCapacityValidity=props.checkAdblueCapacityValidity,checkBaselineDataForFEValidity=props.checkBaselineDataForFEValidity,checkBaselineDistanceValidity=props.checkBaselineDistanceValidity,checkBaselineHoursValidity=props.checkBaselineHoursValidity,handleVideoTelematicsMenuChange=props.handleVideoTelematicsMenuChange,handleVtidChange=props.handleVtidChange,handleVideoTelematicsIdChange=props.handleVideoTelematicsIdChange,documentUploadNewData=props.documentUploadNewData,handleDocumentUploadNewDataChange=props.handleDocumentUploadNewDataChange;var _React$useState=__WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(false),_React$useState2=_slicedToArray(_React$useState,2),showAllManual=_React$useState2[0],setShowAllManual=_React$useState2[1];var uploadProgress=state.uploadProgress;var allSpeedSensor=[];allSpeedSensor[0]={value:'GPS SPEED SENSOR',label:'Gps speed sensor'};allSpeedSensor[1]={value:'DELTA_DISTANCE_CALCULATION',label:'Delta Distance'};allSpeedSensor[2]={value:'ODOMETRIC',label:'Odometric'};var allIdlingSpeed=[{value:0,label:0},{value:1,label:1},{value:2,label:2},{value:3,label:3}];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,fullwidth:true,style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,spacing:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,state.vehicleSegment=='DG Set'?'Vehicle/DG Info':'Vehicle Info')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Device and SIM Info'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:6,sm:6},state.vehicleSegment==='DG Set'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'vlpn',name:'vlpn',className:'textfield',margin:'dense',label:state.vehicleSegment=='DG Set'?'Vehicle/Asset Number':'Vehicle Number',value:state.vlpn,required:true,onChange:handleInputChange('vlpn'),error:!state.isVlpnValid,onBlur:checkVlpnValidity(client)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!state.isVlpnValid?state.vlpnres:''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,spacing:1},state.vehicleSegment!='DG Set'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Switch___default.a,{value:state.isDualEngine,checked:state.isDualEngine,onChange:handleInputChange('isDualEngine'),name:'dualEngineToggle',color:'primary'}),label:'Dual Engine'}),state.deviceType&&state.deviceType!='obd'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Switch___default.a,{value:state.duplicateVehicle,checked:state.duplicateVehicle,onChange:handleInputChange('duplicateVehicle'),name:'duplicateVehicleToggle',color:'primary'}),label:'Duplicate Vehicle'})),state.vehicleSegment!='DG Set'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Switch___default.a,{value:state.hasArm,checked:state.hasArm,onChange:handleInputChange('hasArm'),name:'armToggle',color:'primary'}),label:'Arm Included?'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Switch___default.a,{value:state.isRotationSensor,checked:state.isRotationSensor,onChange:function onChange(e){props.setState({isRotationSensor:!state.isRotationSensor});},name:'isRotationSensor',color:'primary'}),label:'Rotation Sensor Available'})),state.vehicleSegment!='DG Set'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Switch___default.a,{value:state.isIndividualViewOrCombinedView,checked:state.isIndividualViewOrCombinedView,onChange:handleInputChange('isIndividualViewOrCombinedView'),name:'isIndividualViewOrCombinedView',color:'primary'}),label:state.isIndividualViewOrCombinedView?'Dual Tank Combined View':'Dual Tank Individual View'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Switch___default.a,{value:state.isElockConnection,checked:state.isElockConnection,onChange:handleInputChange('isElockConnection'),name:'isElockConnectionToggle',color:'primary'}),label:'E-LOCK Connection?'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Switch___default.a,{value:state.istachoenabled,checked:state.istachoenabled,onChange:handleInputChange('istachoenabled'),name:'istachoenabledToggle',color:'primary'}),label:'Is Tachometer Enabled?'})),state.istachoenabled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,spacing:2,style:{paddingLeft:'15px',paddingRight:'15px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{label:'Idle RPM *',value:state.tachoidlerpm,onChange:handleInputChange('tachoidlerpm'),type:'number',fullWidth:true,margin:'dense'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{label:'Shift Hours *',value:state.tachoshifthours,onChange:handleInputChange('tachoshifthours'),type:'number',fullWidth:true,margin:'dense'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{label:'Engine On Voltage (min)',value:state.tachoengineonmin,onChange:handleInputChange('tachoengineonmin'),type:'number',fullWidth:true,margin:'dense'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{label:'Engine On Voltage (max)',value:state.tachoengineonmax,onChange:handleInputChange('tachoengineonmax'),type:'number',fullWidth:true,margin:'dense'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{style:{marginRight:'10px'}},'Video Telematics'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{style:{minWidth:'60%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_select__["a" /* default */],{options:state.videoTelematicsType,value:state.selectedVTM,onChange:handleVideoTelematicsMenuChange,placeholder:'Select Video Telematics'})))),state.selectedVTM&&state.selectedVTM.value&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,style:{marginTop:'10px'}},state.selectedVTM.value==='mettax'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'100%'}},state.dashcamRegistrationsLoading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["CircularProgress"],{size:30}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{style:{marginRight:'10px'}},'Mettax VT ID *'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{minWidth:'60%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_select__["a" /* default */],{options:state.vtidOptions,value:state.selectedVtid,onChange:handleVtidChange,placeholder:'Select ID'})),state.selectedVtid&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,spacing:2,style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{label:'SIM ID',disabled:true,value:state.selectedSimId,fullWidth:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{label:'Memory Card',disabled:true,value:state.selectedMemoryCardId,fullWidth:true}))))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',style:{minWidth:'60%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{label:'Video Telematics Id'+(state.selectedVTM?'*':''),value:state.videoTelematicsId,onChange:handleVideoTelematicsIdChange,fullWidth:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:'10px',borderRadius:'5px',border:'2px solid #f2f2f2',marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'15px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{style:{margin:0}},'Manual Entry Section'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'button',onClick:function onClick(){return setShowAllManual(!showAllManual);},style:{background:'transparent',border:'1px solid #ccc',borderRadius:'4px',padding:'4px 12px',cursor:'pointer',fontSize:'12px'}},showAllManual?'Show Less':'Show All Fields')),state.vehicleSegment!='DG Set'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',fullWidth:true,style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Ported Vehicle *'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_select__["a" /* default */],{options:[{value:'Yes',label:'Yes'},{value:'No',label:'No'}],value:state.portedVehicle,onChange:handleInputChange('portedVehicle'),placeholder:'Ported Vehicle *'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',fullWidth:true,style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'isTesting Vehicle *'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_select__["a" /* default */],{options:[{value:'Testing',label:'Testing'},{value:'Active',label:'Active'}],value:state.isTestingVehicle,onChange:handleInputChange('isTestingVehicle'),placeholder:'isTesting Vehicle *'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',fullWidth:true,style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Speed Sensor *'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_select__["a" /* default */],{options:allSpeedSensor,value:state.speedSensor,onChange:handleChangeSpeedSensor,placeholder:'Select Speed Sensor *'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{label:'Maximum Speed Limit *',value:state.speedLimit,onChange:handleInputChange('speedLimit'),error:!state.isSpeedLimitValid,helperText:!state.isSpeedLimitValid?'Maximum speed limit 10-160':'',onBlur:checkSpeedLimitValidity,type:'number',fullWidth:true,margin:'normal'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:'15px',padding:'10px',border:'1px solid #eee'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Document Upload * (Please upload Registration Copy or Vehicle Image of type JPEG, JPG, PNG, or PDF up to 30 Mb)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Button"],{variant:'outlined',color:'primary',component:'label',style:{fontWeight:'bold'}},'+ Add Images',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'file',multiple:true,hidden:true,accept:'.jpeg, .jpg, .png, .pdf, image/jpeg, image/png, application/pdf',onChange:handleFileChange}))),Object.keys(uploadProgress).map(function(fileName){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:fileName,style:{marginTop:'10px',padding:'10px',border:'1px solid #ddd',borderRadius:'4px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',alignItems:'center',justifyContent:'space-between'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{onClick:function onClick(){return handleDownload(fileName);},style:{cursor:'pointer',color:'blue',wordBreak:'break-all'}},fileName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_icons_Close___default.a,{onClick:function onClick(){return handleRemove(fileName);},style:{fontSize:'18px',cursor:'pointer',color:'red'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_apollo__["Query"],{query:__WEBPACK_IMPORTED_MODULE_2__queries__["r" /* GET_DROPDOWN_CATEGORIES */]},function(_ref){var catLoading=_ref.loading,catError=_ref.error,catData=_ref.data;if(catLoading)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["CircularProgress"],{size:20});if(catError||!catData||!catData.getDropdownCategories)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Error loading categories');var solCat=catData.getDropdownCategories.find(function(c){return c.category_name==='Solution Type';});var labelCat=catData.getDropdownCategories.find(function(c){return c.category_name==='Image Labels for Installation';});var solId=solCat?parseInt(solCat.id):49;var labelId=labelCat?parseInt(labelCat.id):60;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',gap:'10px',marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_apollo__["Query"],{query:__WEBPACK_IMPORTED_MODULE_2__queries__["t" /* GET_DROPDOWN_VALUES_BY_CATEGORY */],variables:{categoryId:solId}},function(_ref2){var loading=_ref2.loading,error=_ref2.error,data=_ref2.data;if(loading)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["CircularProgress"],{size:20});if(error)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Error loading solution types');var options=data.getDropdownValuesByCategory?data.getDropdownValuesByCategory.map(function(val){return{value:val.value_name,label:val.value_name};}):[];var selectedVal=documentUploadNewData&&documentUploadNewData[fileName]?options.find(function(o){return o.value===documentUploadNewData[fileName].solutionType;}):null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{flex:1}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_select__["a" /* default */],{options:options,value:selectedVal,onChange:function onChange(opt){return handleDocumentUploadNewDataChange(fileName,'solutionType',opt?opt.value:'');},placeholder:'Solution Type *'}));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_apollo__["Query"],{query:__WEBPACK_IMPORTED_MODULE_2__queries__["t" /* GET_DROPDOWN_VALUES_BY_CATEGORY */],variables:{categoryId:labelId}},function(_ref3){var loading=_ref3.loading,error=_ref3.error,data=_ref3.data;if(loading)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["CircularProgress"],{size:20});if(error)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Error loading labels');var options=data.getDropdownValuesByCategory?data.getDropdownValuesByCategory.map(function(val){return{value:val.value_name,label:val.value_name};}):[];var selectedVal=documentUploadNewData&&documentUploadNewData[fileName]?options.find(function(o){return o.value===documentUploadNewData[fileName].label;}):null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{flex:1}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_select__["a" /* default */],{options:options,value:selectedVal,onChange:function onChange(opt){return handleDocumentUploadNewDataChange(fileName,'label',opt?opt.value:'');},placeholder:'Label *'}));}));}));})),showAllManual&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,state.vehicleSegment!='DG Set'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',fullWidth:true,style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Vehicle Customized Body Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_select__["a" /* default */],{options:state.vehiclecustomizedbodytype&&state.vehiclecustomizedbodytype.map(function(o){return{label:o,value:o};}),value:state.vehicleCustomizedBodyType?{label:state.vehicleCustomizedBodyType,value:state.vehicleCustomizedBodyType}:null,onChange:function onChange(o){return props.setState({vehicleCustomizedBodyType:o?o.value:''});},placeholder:'Customize Body Type'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{label:'Equipment Serial Number',value:state.equipmentSerialNumber,onChange:handleInputChange('equipmentSerialNumber'),fullWidth:true,margin:'normal'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{label:'Equipment Name',value:state.equipmentName,onChange:handleInputChange('equipmentName'),fullWidth:true,margin:'normal'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_material_ui_pickers__["a" /* DatePicker */],{label:'Commissioning Date',format:'DD/MM/YYYY',value:state.commissioningDate.date,onChange:handleDateChange('commissioningDate'),fullWidth:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{label:'Department',value:state.department,onChange:handleInputChange('department'),fullWidth:true,margin:'normal'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{label:'Contractor Name',value:state.contractorName,onChange:handleInputChange('contractorName'),fullWidth:true,margin:'normal'})),(showAllManual||state.isDualEngine)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,spacing:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{label:'Engine on Voltage',value:state.eon_voltage,onChange:handleInputChange('eon_voltage'),required:state.isDualEngine,fullWidth:true,margin:'normal'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{label:'Engine off Voltage',value:state.eoff_voltage,onChange:handleInputChange('eoff_voltage'),required:state.isDualEngine,fullWidth:true,margin:'normal'}))),showAllManual&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{label:'Fuel Tank Capacity',value:state.fuelTankCapacity,onChange:handleInputChange('fuelTankCapacity'),required:state.vehicleSegment=='DG Set',type:'number',fullWidth:true,margin:'normal'}),(showAllManual||state.deviceType&&state.deviceType.toLowerCase()==='obd')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{label:state.deviceType&&state.deviceType.toLowerCase()==='obd'?"Adblue Capacity *":"Adblue Capacity",value:state.adblueCapacity,onChange:handleInputChange('adblueCapacity'),required:state.deviceType&&state.deviceType.toLowerCase()==='obd',error:state.isAdblueCapacityValid===false,onBlur:checkAdblueCapacityValidity,fullWidth:true,margin:'normal'}),showAllManual&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,state.vehicleSegment!='DG Set'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',fullWidth:true,style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'No. Of Gears'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_select__["a" /* default */],{options:state.noofgears&&state.noofgears.map(function(o){return{label:o,value:o};}),value:state.noOfGears?{label:state.noOfGears,value:state.noOfGears}:null,onChange:function onChange(o){return props.setState({noOfGears:o?o.value:null});}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{label:'Gear Ratio',value:state.gearRatio,onChange:handleInputChange('gearRatio'),fullWidth:true,margin:'normal'})),state.vehicleSegment=='DG Set'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{label:'BHP',value:state.bhp,onChange:handleInputChange('bhp'),fullWidth:true,margin:'normal'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{fullWidth:true,style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Phase'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_select__["a" /* default */],{options:state.phaseOptions,value:state.phase,onChange:handleInputChange('phase')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{label:'Engine Model',value:state.engineModel,onChange:handleInputChange('engineModel'),fullWidth:true,margin:'normal'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{label:'Genset Controller',value:state.gensetController,onChange:handleInputChange('gensetController'),fullWidth:true,margin:'normal'})),state.vehicleSegment!='DG Set'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{fullWidth:true,style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Idling Speed'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_select__["a" /* default */],{options:allIdlingSpeed,value:state.idlingSpeed,onChange:handleChangeIdlingSpeed})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{label:'Asset Working Hours',type:'number',value:state.inputParameter,onChange:handleChangeInputParameter,fullWidth:true,margin:'normal'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{label:'Asset Multiplication Factor',type:'number',value:state.multiplicationFactor,onChange:handleChangeMultiplicationFactor,fullWidth:true,margin:'normal'}))),(showAllManual||state.customerType=='Paid'||state.vehicleSegment=='DG Set')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,spacing:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{label:'Invoice Number',value:state.invoiceNumber,onChange:handleInputChange('invoiceNumber'),required:state.customerType=='Paid'||state.vehicleSegment=='DG Set',fullWidth:true,margin:'normal'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_material_ui_pickers__["a" /* DatePicker */],{label:'Invoice Date',value:state.invoiceDate.date,onChange:handleDateChange('invoiceDate'),required:state.customerType=='Paid'||state.vehicleSegment=='DG Set',fullWidth:true}))),showAllManual&&state.vehicleSegment!='DG Set'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{fullWidth:true,style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Baseline Data Type FE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_select__["a" /* default */],{options:state.baselinedatatypefe&&state.baselinedatatypefe.map(function(o){return{label:o,value:o.toLowerCase()};}),value:state.baselineDataType,onChange:function onChange(o){return props.setState({baselineDataType:o?o.value:'',baselineDataForFE:null});}})),state.baselineDataType&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{label:state.baselineDataType==='kmpl'?'Baseline FE (KMPL)':'Baseline FE (LPH)',value:state.baselineDataForFE,onChange:handleInputChange('baselineDataForFE'),fullWidth:true,margin:'normal'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:6,sm:6,style:{paddingLeft:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Device *'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_select__["a" /* default */],{options:state.deviceDetails,value:state.serialNumber,onChange:handleChangeDevice(client),placeholder:'Select Device *'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{label:'Model Name',value:state.modelName,disabled:true,fullWidth:true,margin:'normal'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{label:'Device Type',value:state.deviceType,disabled:true,fullWidth:true,margin:'normal'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',fullWidth:true,style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Phone No *'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_select__["a" /* default */],{options:state.simDetails,value:state.phoneNumber,onChange:handleChangePhoneNumber(client),placeholder:'Select Phone No *'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{label:'Service Provider',value:state.simProvider,disabled:true,fullWidth:true,margin:'normal'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{label:'SIM Number',value:state.simNumber,disabled:true,fullWidth:true,margin:'normal'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',fullWidth:true,style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Accessories'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_select__["a" /* default */],{options:state.accessoryDetails,value:state.accessories,onChange:handleChangeAccessories})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox',fullWidth:true,style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Technician Category'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_select__["a" /* default */],{options:[{label:'Taabi Personal',value:'Technician - Taabi Personal'},{label:'Freelancer',value:'Technician - Freelancer'}],value:state.technicianCategory?{label:state.technicianCategory,value:state.technicianCategory}:null,onChange:handleTechnicianCategoryChange})),state.technicianCategory==='Technician - Taabi Personal'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{fullWidth:true,style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_select__["a" /* default */],{options:state.assignedTechniciansTaabi,value:state.selectedTaabiTechnician,onChange:handleTaabiSelectChange,placeholder:'Select Taabi Technician'})),state.technicianCategory==='Technician - Freelancer'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{fullWidth:true,style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_select__["a" /* default */],{options:state.assignedTechniciansFreelancer,value:state.selectedFreelancerTechnician,onChange:handleFreelancerSelectChange,placeholder:'Select Freelancer Technician'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{fullWidth:true,style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Subscription'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_select__["a" /* default */],{options:state.subscriptionDetails,value:state.subscriptionId,onChange:handleChangeSubscription,placeholder:'Select Subscription'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{label:'Engine On Hours',value:state.engineOnHours,onChange:handleInputChange('engineOnHours'),fullWidth:true,margin:'normal'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{label:'Odometric Distance',value:state.odometerDistance,onChange:handleInputChange('odometerDistance'),fullWidth:true,margin:'normal'}),(state.deviceType==='obd'||state.deviceType==='OBD')&&state.vehicleSegment!=='DG Set'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:'20px',padding:'10px',backgroundColor:'#f9f9f9'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,'Gear Related Info'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',null,'Select Make *'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectReact,{options:state.makesList.map(function(item){return{value:item.id,label:item.make};}),value:state.vehicleMakeId?{value:state.vehicleMakeId,label:state.vehicleMake}:null,onChange:handleChangeMake}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{style:{marginTop:'10px',display:'block'}},'Select Model *'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectReact,{options:state.modelsList.map(function(item){return{value:item.id,label:item.model};}),value:state.vehicleModel?{value:state.vehicleModelId,label:state.vehicleModel}:null,onChange:handleChangeModelNew}))));};/* harmony default export */ __webpack_exports__["a"] = (VehicleInfoStep);

/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Checkbox__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControlLabel__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControlLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControlLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Switch__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__queries__ = __webpack_require__(185);
var SolutionTypeOption=function SolutionTypeOption(props){var onSelect=props.onSelect,onFocus=props.onFocus,isSelected=props.isSelected,option=props.option,children=props.children,className=props.className;var handleMouseDown=function handleMouseDown(event){event.preventDefault();event.stopPropagation();onSelect(option,event);};var handleMouseEnter=function handleMouseEnter(event){onFocus(option,event);};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:className,onMouseDown:handleMouseDown,onMouseEnter:handleMouseEnter,onMouseMove:handleMouseEnter,title:option.title,style:{display:'flex',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Checkbox___default.a,{checked:!!isSelected,color:'primary'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,children));};var InstallationSubmissionStep=function InstallationSubmissionStep(_ref){var state=_ref.state,classes=_ref.classes,handleInputChange=_ref.handleInputChange,handleChange=_ref.handleChange,handleImmobilizeChange=_ref.handleImmobilizeChange;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'Formheader',style:{textAlign:'left',marginBottom:'20px'}},'Payment Details & Submission')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true,fullwidth:'true',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:'20px'}},'Solution Type *'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_apollo__["Query"],{query:__WEBPACK_IMPORTED_MODULE_11__queries__["z" /* GET_SOLUTION_TYPES */]},function(_ref2){var loading=_ref2.loading,error=_ref2.error,data=_ref2.data;if(loading)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["CircularProgress"],{size:24});if(error)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Error loading solution types');var solutionTypeMultiOptions=data.getAllMasterSolutionType.map(function(type){var code=type.id;return{value:type.id,label:type.solutionTypeName,code:code};});var selectedMultiValue=solutionTypeMultiOptions.filter(function(option){return state.selected_solution_codes&&state.selected_solution_codes.includes(option.code);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */],{id:'solution_type',name:'solution_type',classes:classes,options:solutionTypeMultiOptions,value:selectedMultiValue,multi:true,optionComponent:SolutionTypeOption,closeOnSelect:false,removeSelected:false,onChange:handleInputChange('solution_type'),placeholder:'Solution Type *'});}),state.solution_type&&state.solution_type.some(function(s){return['video_telematics','fuel+vt','obd+vt','fuel+obd+vt'].includes(s);})&&!state.videoTelematicsId&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{color:'red',fontSize:'12px',margin:'4px 0 0'}},'Video Telematics ID is mandatory for the selected solution type.'),state.solution_type&&state.solution_type.includes('reverse_camera_screen')&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:'12px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_apollo__["Query"],{query:__WEBPACK_IMPORTED_MODULE_11__queries__["v" /* GET_RCS_INVENTORY */],fetchPolicy:'network-only'},function(_ref3){var loading=_ref3.loading,error=_ref3.error,data=_ref3.data;if(loading)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["CircularProgress"],{size:20});if(error)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Error loading RCS inventory');var options=data&&data.getReverseCameraAndScreenInventory&&data.getReverseCameraAndScreenInventory.data?data.getReverseCameraAndScreenInventory.data.map(function(item){return{value:item.rcs_serial_number,label:item.rcs_serial_number};}):[];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:'8px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginBottom:'6px'}},'RCS Serial Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */],{options:options,value:options.find(function(o){return o.value===state.rcsSerialNumber;})||null,onChange:handleInputChange('rcsSerialNumber'),placeholder:'Select RCS Serial Number',isClearable:true}));}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true,fullwidth:'true',style:{marginTop:'20px'}},state.solution_type&&state.solution_type.length>0&&state.solution_type.map(function(selectedSolutionCode){// Use reverse mapping for a nicer name if available, otherwise clean up the code itself
var descriptiveName=selectedSolutionCode;// Format the label nicely (e.g., 'fuel_solution' -> 'FUEL SOLUTION')
var solutionLabel=descriptiveName.toString().replace(/_/g,' ').replace(/\+/g,' & ').toUpperCase();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6,key:selectedSolutionCode},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:'20px',fontSize:'14px',fontWeight:500,color:'#555'}},solutionLabel,' Plan'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:'8px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:'12px 16px',backgroundColor:'#f8f9fa',border:'1px solid #dee2e6',borderRadius:'8px',fontWeight:600,color:'#212529',display:'flex',alignItems:'center',justifyContent:'space-between',fontSize:'14px',boxShadow:'0 1px 2px rgba(0,0,0,0.05)'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:'8px',height:'8px',backgroundColor:'#28a745',borderRadius:'50%',marginRight:'10px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'1 Year Plan Selected')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontSize:'11px',backgroundColor:'#e9ecef',padding:'2px 8px',borderRadius:'10px',color:'#6c757d',textTransform:'uppercase'}},'Auto'))))));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true,fullwidth:'true',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Checkbox___default.a,{checked:state.installStatus,onChange:handleChange('installStatus'),value:'installStatus',color:'primary'}),label:'Installation Completed'})),state.vehicleSegment!=='DG Set'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Checkbox___default.a,{checked:state.immobilize,onChange:handleImmobilizeChange('immobilize'),value:'immobilize',color:'primary'}),label:'Immobilizable'})))));};/* harmony default export */ __webpack_exports__["a"] = (InstallationSubmissionStep);

/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_FormGroup__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_FormGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_FormGroup__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query {\n    manufacturers: getAllManufacturer(status: 1) {\n      id\n      manufacturerName\n      manufacturerCode\n    }\n  }\n'],['\n  query {\n    manufacturers: getAllManufacturer(status: 1) {\n      id\n      manufacturerName\n      manufacturerCode\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query allClientDetails($partnerLoginId: Int) {\n    clientsDetails: allClientDetails(partnerLoginId: $partnerLoginId) {\n      clientName\n      loginId\n    }\n  }\n'],['\n  query allClientDetails($partnerLoginId: Int) {\n    clientsDetails: allClientDetails(partnerLoginId: $partnerLoginId) {\n      clientName\n      loginId\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation excelFileUpload(\n    $fileInfo: FileUploadInput!\n    $commonInput: CommonInput!\n  ) {\n    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {\n      failedToUpload\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedUploadList\n    }\n  }\n'],['\n  mutation excelFileUpload(\n    $fileInfo: FileUploadInput!\n    $commonInput: CommonInput!\n  ) {\n    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {\n      failedToUpload\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedUploadList\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n'],['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  query getAllPartnerSubscriptions(\n    $partnerId: Int\n    $deviceModelId: Int\n    $status: [Int]\n  ) {\n    getAllPartnerSubscriptions(\n      partnerLoginId: $partnerId\n      deviceModelId: $deviceModelId\n      status: $status\n    ) {\n      id\n      deviceTrackingCharges\n      totalSoftwareQty\n      deviceModel {\n        model_name\n      }\n    }\n  }\n'],['\n  query getAllPartnerSubscriptions(\n    $partnerId: Int\n    $deviceModelId: Int\n    $status: [Int]\n  ) {\n    getAllPartnerSubscriptions(\n      partnerLoginId: $partnerId\n      deviceModelId: $deviceModelId\n      status: $status\n    ) {\n      id\n      deviceTrackingCharges\n      totalSoftwareQty\n      deviceModel {\n        model_name\n      }\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var style=function style(theme){return{root:{padding:theme.spacing.unit*2,flexGrow:1}};};var GET_MANUFACTURERS=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject);var GET_CLIENTS=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject2);var ADD_VEHICLES=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject3);var GET_UPLOAD_URL=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject4);var GET_SUBSCRIPTION_BY_PARTNERID=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject5);var BulkVehicleRegistration=function(_Component){_inherits(BulkVehicleRegistration,_Component);function BulkVehicleRegistration(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,BulkVehicleRegistration);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BulkVehicleRegistration.__proto__||Object.getPrototypeOf(BulkVehicleRegistration)).call.apply(_ref,[this].concat(args))),_this),_this.state={clients:[],manufacturers:[],client:{value:'',label:null},manufacturer:{value:null,label:null,code:null},isUploading:false,fileName:'',bucketName:'',publicUploadURL:'',response:'',uploadSucess:true,result:false,failList:'',isLoading:false,subscriptionId:'',subscriptionDetails:[]},_this.columns=['Serial Number','Reason'],_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15// sort: false,
// filter: false,
//  search: false,
// print: false,
// download: false
// viewColumns: false,
// pagination: false
},_this.setToDefaults=function(){_this.setState({isUploading:false,fileName:'',bucketName:'',publicUploadURL:'',response:'',uploadSucess:true,result:false,failList:'',client:{value:'',label:null},manufacturer:{value:null,label:null,code:null}});},_this.handleSelectChange=function(name){return function(value){_this.setState(_defineProperty({},name,value));};},_this.onUpload=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2){var _ref2$target=_ref2.target,validity=_ref2$target.validity,_ref2$target$files=_slicedToArray(_ref2$target.files,1),file=_ref2$target$files[0];var fileExtension,response,url;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.setState({isUploading:true});if(!validity.valid){_context.next=11;break;}fileExtension=file.name.substring(file.name.lastIndexOf('.')+1);_context.next=5;return _this.props.client.mutate({mutation:GET_UPLOAD_URL,variables:{fileExtension:fileExtension}});case 5:response=_context.sent;if(!(response.data&&response.data.getPublicUploadURL)){_context.next=11;break;}url=response.data.getPublicUploadURL.publicUploadURL;_context.next=10;return __WEBPACK_IMPORTED_MODULE_11_axios___default.a.put(url,file,{headers:{"x-ms-blob-type":"BlockBlob","Content-Type":file.type||"application/octet-stream"}});case 10:_this.setState({fileName:response.data.getPublicUploadURL.filename,bucketName:response.data.getPublicUploadURL.bucketName,publicUploadURL:response.data.getPublicUploadURL.publicUploadURL});case 11:_this.setState({isUploading:false});case 12:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref3.apply(this,arguments);};}(),_this.handleSubmit=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(event){var response,data,fullData,arrList,errors;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_this.setState({isLoading:true});_context2.next=3;return _this.props.client.mutate({mutation:ADD_VEHICLES,variables:{fileInfo:{uploadFor:'VehicleUpload',bucketName:_this.state.bucketName,fileName:_this.state.fileName,operationType:'SKIP'},commonInput:{clientLoginId:_this.state.client.value,partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_12__utils_getLoginId__["a" /* default */])(),manufacturerCode:_this.state.manufacturer.code,partnerSubscriptionId:_this.state.subscriptionId}},errorPolicy:'all'});case 3:response=_context2.sent;if(response.data){data=response.data;fullData=[];arrList=data.excelFileUpload.failedUploadList;JSON.parse(arrList).forEach(function(element){var rowData=[];rowData.push(element.serialNumber);rowData.push(element.error);fullData.push(rowData);});console.log(data);_this.setState({isLoading:false,response:'Total Excel Records= '+data.excelFileUpload.totalExcelDataRecords+','+'Total Records Uploaded='+data.excelFileUpload.successfullyUploaded+', Total Records Failed To Upload='+data.excelFileUpload.failedToUpload+', Total Duplicate Records in Excel='+data.excelFileUpload.totalDuplicateRecords,uploadSucess:true,failList:fullData,result:true});}else{errors=response.errors;console.log(errors,'err');_this.props.openSnackbar(errors[0].message);_this.setState({isLoading:false,response:'Operation Failure, please try again or contact customer support for assistance ',result:false,uploadSucess:false});}case 5:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref4.apply(this,arguments);};}(),_this.handleCancel=function(event){_this.props.history.goBack();},_this.fetchAllPartnerSubscriptions=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var _ref6,subscription,subscriptionError,allSubscriptions;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return _this.props.client.query({query:GET_SUBSCRIPTION_BY_PARTNERID,variables:{partnerId:Object(__WEBPACK_IMPORTED_MODULE_12__utils_getLoginId__["a" /* default */])(),status:[2,4,5]},errorPolicy:'all',fetchPolicy:'network-only'});case 2:_ref6=_context3.sent;subscription=_ref6.data;subscriptionError=_ref6.error;console.log('subscr',subscription);allSubscriptions=subscription.getAllPartnerSubscriptions.map(// (lab = subscription.mmtc + ',' + subscription.noOfDevices),
function(subscription){return{value:subscription.id,label:subscription.deviceModel.model_name+' - '+subscription.totalSoftwareQty+' - '+subscription.deviceTrackingCharges};});if(subscriptionError){_this.setState({subscriptionDetails:[]});}else{_this.setState({subscriptionDetails:allSubscriptions},function(){return console.log('subscriptionDetails',_this.state.subscriptionDetails);});}case 8:case'end':return _context3.stop();}}},_callee3,_this2);})),_this.handleChangeSubscription=function(event){if(!event){_this.setState({subscriptionId:''});}else{_this.setState({subscriptionId:event.value});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BulkVehicleRegistration,[{key:'componentDidMount',value:function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){var data,allClients,allManufacturers;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return this.props.client.query({query:GET_CLIENTS,variables:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_12__utils_getLoginId__["a" /* default */])()}});case 2:data=_context4.sent;allClients=data.data.clientsDetails.map(function(client){return{value:client.loginId,label:client.clientName};});_context4.next=6;return this.props.client.query({query:GET_MANUFACTURERS});case 6:data=_context4.sent;allManufacturers=data.data.manufacturers.map(function(manufacturer){return{value:manufacturer.id,label:manufacturer.manufacturerName,code:manufacturer.manufacturerCode};});this.setState({clients:allClients,manufacturers:allManufacturers});this.fetchAllPartnerSubscriptions();case 10:case'end':return _context4.stop();}}},_callee4,this);}));function componentDidMount(){return _ref7.apply(this,arguments);}return componentDidMount;}()},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Typography"],{variant:'headline'},'Bulk Vehicle Registration')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true,item:true,xs:12,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select__["a" /* default */],{classes:classes,options:this.state.clients,value:this.state.client?this.state.client.value:null,onChange:this.handleSelectChange('client'),placeholder:'Select Customer'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:8,sm:8},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select__["a" /* default */],{classes:classes,options:this.state.subscriptionDetails,value:this.state.subscriptionId,onChange:this.handleChangeSubscription,placeholder:'Select Subscription(Model Name - SoftwareQty - Charges) *'})))),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true,item:true,xs:12,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select__["a" /* default */],{classes:classes,options:this.state.manufacturers,value:this.state.manufacturer?this.state.manufacturer.value:null,onChange:this.handleSelectChange('manufacturer'),placeholder:'Select Manufacturer'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{accept:'*/*',id:'contained-button-file',multiple:true,type:'file',style:{display:'none'},onChange:this.onUpload}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'contained-button-file'},'Upload excel file here \xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{variant:'contained',component:'span',color:'primary'},this.state.isUploading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_CircularProgress___default.a,{size:15}):'Upload')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{color:'secondary',variant:'raised',onClick:this.handleSubmit,disabled:!(this.state.client!==''&&this.state.manufacturer!==''&&this.state.fileName!=='')},'Submit'),this.state.isLoading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'Excel sheet upload is in progress..')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{color:'primary',variant:'raised',onClick:function onClick(){return _this3.props.history.goBack();}},'Cancel')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{color:'primary',variant:'raised',onClick:this.setToDefaults},'SET TO DEFAULTS'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Typography"],null,this.state.response),this.state.result&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',null,'Failed records list'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_mui_datatables___default.a,{data:this.state.failList,columns:this.columns,options:this.options})))));}}]);return BulkVehicleRegistration;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_8__HOCs_withSharedSnackbar__["a" /* default */])(BulkVehicleRegistration))));

/***/ }),
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_file_saver__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_router_dom__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Router__ = __webpack_require__(116);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  mutation excelFileUpload(\n    $fileInfo: FileUploadInput!\n    $commonInput: CommonInput!\n  ) {\n    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {\n      failedToUpload\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedUploadList\n    }\n  }\n'],['\n  mutation excelFileUpload(\n    $fileInfo: FileUploadInput!\n    $commonInput: CommonInput!\n  ) {\n    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {\n      failedToUpload\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedUploadList\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n'],['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n'],['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// calling server for updation
var DELETE_VEHICLE=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject);var GET_UPLOAD_URL=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject2);var GET_FILE_FORMAT=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject3);var styles=function styles(theme){return{button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{margin:theme.spacing.unit,minWidth:120},root:{flexGrow:1,padding:theme.spacing.unit*2}};};var DeleteBulkVehicle=function(_Component){_inherits(DeleteBulkVehicle,_Component);function DeleteBulkVehicle(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,DeleteBulkVehicle);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DeleteBulkVehicle.__proto__||Object.getPrototypeOf(DeleteBulkVehicle)).call.apply(_ref,[this].concat(args))),_this),_this.state={open:false,selectedFile:null,open1:false,vehicleProvider:'',uploadSucess:true,isVehicleProviderValid:false,response:'',failList:'',result:false,fileName:'',isLoading:false,disable:false},_this.columns=['Serial Number','Reason'],_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15},_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));};},_this.handleClickOpen=function(){_this.setState({open:true});},_this.handleClose=function(){_this.setState({open:false});},_this.handleChange=function(event){_this.setState(_defineProperty({},event.target.name,event.target.value));},_this.handleOpen=function(){_this.setState({open:true});},_this.handleOpenSelect=function(){_this.setState({open1:true});},_this.handleCloseSelect=function(){_this.setState({open1:false});},_this.checkVehicleProviderValidity=function(){_this.setState({isVehicleProviderValid:_this.state.vehicleProvider!==''});},_this.handleSubmit=function(client){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _ref3,data,errors,fullData,arrList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:event.preventDefault();_this.setState({isLoading:true,disable:true});_context.next=4;return client.mutate({mutation:DELETE_VEHICLE,variables:{fileInfo:{uploadFor:'deleteVehicles',bucketName:_this.state.bucketName,fileName:_this.state.fileName,operationType:'SKIP'},commonInput:{clientLoginId:Object(__WEBPACK_IMPORTED_MODULE_15__utils_getLoginId__["a" /* default */])()}},errorPolicy:'all'});case 4:_ref3=_context.sent;data=_ref3.data;errors=_ref3.errors;_this.setState({isLoading:false});// console.log("data-------->",data)
if(data!==null){fullData=[];arrList=data.excelFileUpload.failedUploadList;// console.log('arrList', JSON.parse(arrList))
JSON.parse(arrList).forEach(function(element){var rowData=[];// this.clientId.push(element.id)
rowData.push(element.serialNumber?element.serialNumber:'NA');rowData.push(element.errorMsg?element.errorMsg:'Invalid Serial Number');fullData.push(rowData);});_this.setState({vehicleProvider:'',response:'Total Excel Records= '+data.excelFileUpload.totalExcelDataRecords+','+'Total Records Uploaded='+data.excelFileUpload.successfullyUploaded+', Total Records Failed To Upload='+data.excelFileUpload.failedToUpload+', Total Duplicate Records in Excel='+data.excelFileUpload.totalDuplicateRecords,uploadSucess:true,failList:fullData,result:true});}else{_this.setState({response:errors[0].message,uploadSucess:true});}case 9:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}();},_this.onUpload=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4){var _ref4$target=_ref4.target,validity=_ref4$target.validity,_ref4$target$files=_slicedToArray(_ref4$target.files,1),file=_ref4$target$files[0];var fileExtension,response,url;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:// TODO: Handle upload errors
_this.setState({isUploading:true});if(!validity.valid){_context2.next=11;break;}fileExtension=file.name.substring(file.name.lastIndexOf('.')+1);_context2.next=5;return _this.props.client.mutate({mutation:GET_UPLOAD_URL,variables:{fileExtension:fileExtension}});case 5:response=_context2.sent;if(!(response.data&&response.data.getPublicUploadURL)){_context2.next=11;break;}url=response.data.getPublicUploadURL.publicUploadURL;_context2.next=10;return __WEBPACK_IMPORTED_MODULE_13_axios___default.a.put(url,file,{headers:{"x-ms-blob-type":"BlockBlob","Content-Type":file.type||"application/octet-stream"}});case 10:_this.setState({fileName:response.data.getPublicUploadURL.filename,bucketName:response.data.getPublicUploadURL.bucketName,publicUploadURL:response.data.getPublicUploadURL.publicUploadURL});case 11:_this.setState({isUploading:false,selectedFile:file.name});case 12:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref5.apply(this,arguments);};}(),_this.downloadBulkDeassign=function(client){return function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(event){var _ref7,data,res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return _this.props.client.query({query:GET_FILE_FORMAT,variables:{bucketname:'excel-templates',filename:'BulkDeleteVehicleTemplate .xlsx'},errorPolicy:'all'});case 2:_ref7=_context3.sent;data=_ref7.data;_context3.next=6;return __WEBPACK_IMPORTED_MODULE_13_axios___default()({url:data.getPublicDownloadURL,method:'GET',headers:{Accept:'application/vnd.ms-excel'},responseType:'blob'// important
});case 6:res=_context3.sent;__WEBPACK_IMPORTED_MODULE_16_file_saver___default.a.saveAs(new Blob([res.data]),'sample.xlsx');// FileSaver.saveAs(data.getPublicDownloadURL, 'sample.xlsx')
case 8:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x3){return _ref6.apply(this,arguments);};}();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DeleteBulkVehicle,[{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{container:true,direction:'row',justify:'flex-start',alignItems:'center',spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Typography"],{variant:'headline'},'Upload Vehicle Details For Bulk Delete')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{style:{minWidth:'40%'}},this.state.uploadSucess&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Typography"],{variant:'subheading',color:'primary'},this.state.response),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{xs:12},'Download sample template for Vehicle bulk delete'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:7},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{fullWidth:true,color:'secondary',variant:'contained',className:classes.button,onClick:this.downloadBulkDeassign(this.props.client)},'Download Bulk Delete Excel')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{accept:'*/*',id:'contained-button-file',multiple:true,type:'file',style:{display:'none'},onChange:this.onUpload}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'contained-button-file'},'Upload excel file here \xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{variant:'contained',component:'span',color:'primary'},this.state.isUploading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress___default.a,{size:15}):'Upload')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{color:'#43a146'}},this.state.selectedFile===null?'   No File Selected':'     '+this.state.selectedFile),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Typography"],{variant:'caption',color:'textSecondary',gutterBottom:true},'File Format - XLS, XLSX'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:function onClick(){return _this3.props.history.goBack();},color:'default',variant:'contained'// href={this.props.history.goBack()}
},'Cancel'),'\xA0 \xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:this.handleSubmit(this.props.client),color:'primary',type:'submit',variant:'contained',disabled:!this.state.fileName||this.state.disable},'Submit'),' ',this.state.isLoading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'Excel sheet upload is in progress..'),this.state.result&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',null,'Failed records list'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_mui_datatables___default.a,{data:this.state.failList,columns:this.columns,options:this.options})))));}}]);return DeleteBulkVehicle;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var WrappedDeleteBulkVehicle=Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["withStyles"])(styles)(__WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter___default()(Object(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["withApollo"])(DeleteBulkVehicle)));/* harmony default export */ __webpack_exports__["a"] = (function(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_router_dom__["e" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/customer/vehicle/delete/bulk',render:function render(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedDeleteBulkVehicle,props);}}));});

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoistNonReactStatics = __webpack_require__(94);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _Route = __webpack_require__(1105);

var _Route2 = _interopRequireDefault(_Route);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return _react2.default.createElement(_Route2.default, {
      children: function children(routeComponentProps) {
        return _react2.default.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: _propTypes2.default.func
  };

  return (0, _hoistNonReactStatics2.default)(C, Component);
};

exports.default = withRouter;

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(37);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(67);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _matchPath = __webpack_require__(1106);

var _matchPath2 = _interopRequireDefault(_matchPath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isEmptyChildren = function isEmptyChildren(children) {
  return _react2.default.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    (0, _invariant2.default)(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return (0, _matchPath2.default)(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    (0, _warning2.default)(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    (0, _warning2.default)(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    (0, _warning2.default)(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? _react2.default.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return _react2.default.Children.only(children);

    return null;
  };

  return Route;
}(_react2.default.Component);

Route.propTypes = {
  computedMatch: _propTypes2.default.object, // private, from <Switch>
  path: _propTypes2.default.string,
  exact: _propTypes2.default.bool,
  strict: _propTypes2.default.bool,
  sensitive: _propTypes2.default.bool,
  component: _propTypes2.default.func,
  render: _propTypes2.default.func,
  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
  location: _propTypes2.default.object
};
Route.contextTypes = {
  router: _propTypes2.default.shape({
    history: _propTypes2.default.object.isRequired,
    route: _propTypes2.default.object.isRequired,
    staticContext: _propTypes2.default.object
  })
};
Route.childContextTypes = {
  router: _propTypes2.default.object.isRequired
};
exports.default = Route;

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _pathToRegexp = __webpack_require__(299);

var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = (0, _pathToRegexp2.default)(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

exports.default = matchPath;

/***/ }),
/* 1107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_file_saver__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_router_dom__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Router__ = __webpack_require__(116);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  mutation excelFileUpload(\n    $fileInfo: FileUploadInput!\n    $commonInput: CommonInput!\n  ) {\n    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {\n      failedToUpload\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedUploadList\n    }\n  }\n'],['\n  mutation excelFileUpload(\n    $fileInfo: FileUploadInput!\n    $commonInput: CommonInput!\n  ) {\n    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {\n      failedToUpload\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedUploadList\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n'],['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n'],['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// calling server for updation
var DEACTIVATE_VEHICLE=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject);var GET_UPLOAD_URL=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject2);var GET_FILE_FORMAT=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject3);var styles=function styles(theme){return{button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{margin:theme.spacing.unit,minWidth:120},root:{flexGrow:1,padding:theme.spacing.unit*2}};};var DeactivateBulkVehicle=function(_Component){_inherits(DeactivateBulkVehicle,_Component);function DeactivateBulkVehicle(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,DeactivateBulkVehicle);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DeactivateBulkVehicle.__proto__||Object.getPrototypeOf(DeactivateBulkVehicle)).call.apply(_ref,[this].concat(args))),_this),_this.state={open:false,selectedFile:null,open1:false,vehicleProvider:'',uploadSucess:true,isVehicleProviderValid:false,response:'',failList:'',result:false,fileName:'',isLoading:false,disable:false},_this.columns=['Unique DeviceId','Reason'],_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15},_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));};},_this.handleClickOpen=function(){_this.setState({open:true});},_this.handleClose=function(){_this.setState({open:false});},_this.handleChange=function(event){_this.setState(_defineProperty({},event.target.name,event.target.value));},_this.handleOpen=function(){_this.setState({open:true});},_this.handleOpenSelect=function(){_this.setState({open1:true});},_this.handleCloseSelect=function(){_this.setState({open1:false});},_this.checkVehicleProviderValidity=function(){_this.setState({isVehicleProviderValid:_this.state.vehicleProvider!==''});},_this.handleSubmit=function(client){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _ref3,data,errors,fullData,arrList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:event.preventDefault();_this.setState({isLoading:true,disable:true});_context.next=4;return client.mutate({mutation:DEACTIVATE_VEHICLE,variables:{fileInfo:{uploadFor:'DeactivateVehicle',bucketName:_this.state.bucketName,fileName:_this.state.fileName,operationType:'SKIP'},commonInput:{clientLoginId:Object(__WEBPACK_IMPORTED_MODULE_15__utils_getLoginId__["a" /* default */])()}},errorPolicy:'all'});case 4:_ref3=_context.sent;data=_ref3.data;errors=_ref3.errors;_this.setState({isLoading:false});// console.log("data-------->",data)
if(data!==null){fullData=[];arrList=data.excelFileUpload.failedUploadList;// console.log('arrList', JSON.parse(arrList))
JSON.parse(arrList).forEach(function(element){var rowData=[];// this.clientId.push(element.id)
rowData.push(element.uniqueDeviceNumber);rowData.push(element.errorMsg?element.errorMsg:'Invalid Serial Number');fullData.push(rowData);});_this.setState({vehicleProvider:'',response:'Total Excel Records= '+data.excelFileUpload.totalExcelDataRecords+','+'Total Records Uploaded='+data.excelFileUpload.successfullyUploaded+', Total Records Failed To Upload='+data.excelFileUpload.failedToUpload+', Total Duplicate Records in Excel='+data.excelFileUpload.totalDuplicateRecords,uploadSucess:true,failList:fullData,result:true});}else{_this.setState({response:errors[0].message,uploadSucess:true});}case 9:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}();},_this.onUpload=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4){var _ref4$target=_ref4.target,validity=_ref4$target.validity,_ref4$target$files=_slicedToArray(_ref4$target.files,1),file=_ref4$target$files[0];var fileExtension,response,url;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:// TODO: Handle upload errors
_this.setState({isUploading:true});if(!validity.valid){_context2.next=11;break;}fileExtension=file.name.substring(file.name.lastIndexOf('.')+1);_context2.next=5;return _this.props.client.mutate({mutation:GET_UPLOAD_URL,variables:{fileExtension:fileExtension}});case 5:response=_context2.sent;if(!(response.data&&response.data.getPublicUploadURL)){_context2.next=11;break;}url=response.data.getPublicUploadURL.publicUploadURL;_context2.next=10;return __WEBPACK_IMPORTED_MODULE_13_axios___default.a.put(url,file,{headers:{"x-ms-blob-type":"BlockBlob","Content-Type":file.type||"application/octet-stream"}});case 10:_this.setState({fileName:response.data.getPublicUploadURL.filename,bucketName:response.data.getPublicUploadURL.bucketName,publicUploadURL:response.data.getPublicUploadURL.publicUploadURL});case 11:_this.setState({isUploading:false,selectedFile:file.name});case 12:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref5.apply(this,arguments);};}(),_this.downloadBulkDeactivate=function(client){return function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(event){var _ref7,data,res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return _this.props.client.query({query:GET_FILE_FORMAT,variables:{bucketname:'excel-templates',filename:'BulkVehicleDeactivateTemplate.xlsx'},errorPolicy:'all'});case 2:_ref7=_context3.sent;data=_ref7.data;_context3.next=6;return __WEBPACK_IMPORTED_MODULE_13_axios___default()({url:data.getPublicDownloadURL,method:'GET',headers:{Accept:'application/vnd.ms-excel'},responseType:'blob'// important
});case 6:res=_context3.sent;__WEBPACK_IMPORTED_MODULE_16_file_saver___default.a.saveAs(new Blob([res.data]),'sample.xlsx');// FileSaver.saveAs(data.getPublicDownloadURL, 'sample.xlsx')
case 8:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x3){return _ref6.apply(this,arguments);};}();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DeactivateBulkVehicle,[{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{container:true,direction:'row',justify:'flex-start',alignItems:'center',spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Typography"],{variant:'headline'},'Upload Vehicle Details For Bulk Deactivate')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{style:{minWidth:'40%'}},this.state.uploadSucess&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Typography"],{variant:'subheading',color:'primary'},this.state.response),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{xs:12},'Download sample template for Vehicle bulk deactivate'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:7},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{fullWidth:true,color:'secondary',variant:'contained',className:classes.button,onClick:this.downloadBulkDeactivate(this.props.client)},'Download Bulk Deactivate Excel')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{accept:'*/*',id:'contained-button-file',multiple:true,type:'file',style:{display:'none'},onChange:this.onUpload}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'contained-button-file'},'Upload excel file here \xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{variant:'contained',component:'span',color:'primary'},this.state.isUploading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress___default.a,{size:15}):'Upload')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{color:'#43a146'}},this.state.selectedFile===null?'   No File Selected':'     '+this.state.selectedFile),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Typography"],{variant:'caption',color:'textSecondary',gutterBottom:true},'File Format - XLS, XLSX'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:function onClick(){return _this3.props.history.goBack();},color:'default',variant:'contained'// href={this.props.history.goBack()}
},'Cancel'),'\xA0 \xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:this.handleSubmit(this.props.client),color:'primary',type:'submit',variant:'contained',disabled:!this.state.fileName||this.state.disable},'Submit'),' ',this.state.isLoading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'Excel sheet upload is in progress..'),this.state.result&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',null,'Failed records list'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_mui_datatables___default.a,{data:this.state.failList,columns:this.columns,options:this.options})))));}}]);return DeactivateBulkVehicle;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var WrappedDeactivateBulkVehicle=Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["withStyles"])(styles)(__WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter___default()(Object(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["withApollo"])(DeactivateBulkVehicle)));/* harmony default export */ __webpack_exports__["a"] = (function(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_router_dom__["e" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/customer/vehicle/deactivate/bulk',render:function render(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedDeactivateBulkVehicle,props);}}));});

/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_ArrowBack__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_ArrowBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_ArrowBack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__BulkUpload__ = __webpack_require__(1109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__VehcileDashboard_SendCommands__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_axios__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_multiselect_react_dropdown__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_multiselect_react_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_multiselect_react_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_material_ui_pickers__ = __webpack_require__(60);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getAllVehicleDetailsByStatus($loginId: Int, $status: Int) {\n    getAllVehicleDetailsByStatus(partnerLoginId: $loginId, status: $status) {\n      vehicleNumber\n      deviceDetail {\n        uniqueDeviceId\n      }\n    }\n  }\n'],['\n  query getAllVehicleDetailsByStatus($loginId: Int, $status: Int) {\n    getAllVehicleDetailsByStatus(partnerLoginId: $loginId, status: $status) {\n      vehicleNumber\n      deviceDetail {\n        uniqueDeviceId\n      }\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n'],['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query getCommandStatus(\n    $uniqueIds: [String!]!\n    $command: String\n    $from_ts: Int\n    $to_ts: Int\n  ) {\n    getCommandStatus(\n      uniqueIds: $uniqueIds\n      command: $command\n      from_ts: $from_ts\n      to_ts: $to_ts\n    ) {\n      id\n      uniqueid\n      command_display\n      status\n      create_ts\n      modified_ts\n      response\n    }\n  }\n'],['\n  query getCommandStatus(\n    $uniqueIds: [String!]!\n    $command: String\n    $from_ts: Int\n    $to_ts: Int\n  ) {\n    getCommandStatus(\n      uniqueIds: $uniqueIds\n      command: $command\n      from_ts: $from_ts\n      to_ts: $to_ts\n    ) {\n      id\n      uniqueid\n      command_display\n      status\n      create_ts\n      modified_ts\n      response\n    }\n  }\n']);function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var style=function style(theme){return{root:{padding:theme.spacing.unit*4,flexGrow:1},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},iconSmall:{fontSize:20}};};var GET_VEHICLE_LIST=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject);var GET_UPLOAD_URL=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject2);var GET_COMMAND_STATUS=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject3);var VehicleCommands=function(_Component){_inherits(VehicleCommands,_Component);function VehicleCommands(props){var _this2=this;_classCallCheck(this,VehicleCommands);var _this=_possibleConstructorReturn(this,(VehicleCommands.__proto__||Object.getPrototypeOf(VehicleCommands)).call(this,props));_this.clientId=[];_this.columns=['SLNO','COMMAND','RESPONSE','STATUS'];_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:10};_this.state={open:false,openBulkModal:false,open1:false,fromDate:null,toDate:null,toMaxDate:new Date(),vehicleNames:[],commandsList:[],selectedVehicles:[],selectedFormDate:new Date(),selectedToDate:new Date(),invalidToDate:false};_this.getvehicleDetails=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _ref2,data,allVehicles;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.client.query({query:GET_VEHICLE_LIST,variables:{loginId:parseInt(localStorage.getItem('Login_id'),10),status:1}});case 2:_ref2=_context.sent;data=_ref2.data;allVehicles=data.getAllVehicleDetailsByStatus.map(function(v){return{id:v.deviceDetail.uniqueDeviceId,name:v.vehicleNumber};});_this.setState({vehicleNames:allVehicles});_this.setState({vehicleNames:[{id:'SELECT000000ALL',name:'Select All'}].concat(_toConsumableArray(_this.state.vehicleNames))});case 7:case'end':return _context.stop();}}},_callee,_this2);}));_this.handleClickOpen=function(){_this.setState({open:true});};_this.handleBulkOpen=function(){_this.setState({openBulkModal:true});};_this.handleClose=function(){_this.setState({open:false});_this.setState({openBulkModal:false});};_this.handleToDate=function(date){_this.setState({selectedToDate:date});var endTs=__WEBPACK_IMPORTED_MODULE_11_moment___default()(date).unix();_this.setState({toDate:endTs});};_this.handleFromDate=function(date){_this.setState({selectedFormDate:date});var finalStart=__WEBPACK_IMPORTED_MODULE_11_moment___default()(date).unix();_this.setState({fromDate:finalStart});var dateNow=new Date(date);// Now
dateNow.setDate(dateNow.getDate()+30);_this.setState({toMaxDate:dateNow});};_this.onUpload=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref3){var _ref3$target=_ref3.target,validity=_ref3$target.validity,_ref3$target$files=_slicedToArray(_ref3$target.files,1),file=_ref3$target$files[0];var fileExtension,response,url;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_this.setState({isUploading:true});if(!validity.valid){_context2.next=11;break;}fileExtension=file.name.substring(file.name.lastIndexOf('.')+1);_context2.next=5;return _this.props.client.mutate({mutation:GET_UPLOAD_URL,variables:{fileExtension:fileExtension}});case 5:response=_context2.sent;if(!(response.data&&response.data.getPublicUploadURL)){_context2.next=11;break;}url=response.data.getPublicUploadURL.publicUploadURL;_context2.next=10;return __WEBPACK_IMPORTED_MODULE_17_axios___default.a.put(url,file,{headers:{"x-ms-blob-type":"BlockBlob","Content-Type":file.type||"application/octet-stream"}});case 10:_this.setState({fileName:response.data.getPublicUploadURL.filename,bucketName:response.data.getPublicUploadURL.bucketName,publicUploadURL:response.data.getPublicUploadURL.publicUploadURL});case 11:_this.setState({isUploading:false});case 12:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x){return _ref4.apply(this,arguments);};}();_this.handleSubmit=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var vehiclesList,_ref6,data,fullData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:vehiclesList=[];_this.state.selectedVehicles.forEach(function(element){if(element.id!="SELECT000000ALL")vehiclesList.push(element.id);});_context3.next=4;return _this.props.client.query({query:GET_COMMAND_STATUS,variables:{uniqueIds:vehiclesList,command:'',from_ts:parseInt(_this.state.fromDate),to_ts:parseInt(_this.state.toDate)}});case 4:_ref6=_context3.sent;data=_ref6.data;fullData=[];data.getCommandStatus.forEach(function(element,index){var rowData=[];rowData.push(index+1);rowData.push(element.command_display);rowData.push(element.response);rowData.push(element.status);fullData.push(rowData);});_this.setState({commandsList:fullData});case 9:case'end':return _context3.stop();}}},_callee3,_this2);}));_this.classes=props;return _this;}_createClass(VehicleCommands,[{key:'componentDidMount',value:function componentDidMount(){var currentDateMaxDate=new Date();currentDateMaxDate.setDate(currentDateMaxDate.getDate()+30);this.setState({toMaxDate:currentDateMaxDate});this.getvehicleDetails();}},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;var multiselectStyle={chips:{// To change css chips(Selected options)
background:'#3f3f3fd6',display:'none'},option:{padding:'12px',fontWeight:'300'}};return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,style:{marginBottom:'2em'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{variant:'outlined',color:'secondary',className:classes.button,onClick:function onClick(){return _this3.props.history.goBack();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_ArrowBack___default.a,{className:classes.iconSmall}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,style:{marginLeft:'1em'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{variant:'headline'},'Vehicle Commands'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,padding:2,style:{marginBottom:'3em'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:8},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core__["InputLabel"],{style:{fontSize:'0.8em'}},'Select Vehicles'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core__["FormControl"],{style:{width:'90%',zIndex:'150'}},this.state.vehicleNames&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_multiselect_react_dropdown___default.a,{options:this.state.vehicleNames// Options to display in the dropdown
,selectedValues:this.state.selectedVehicles// Preselected value to persist in dropdown
,onSelect:function onSelect(selectedList,selectedItem){if(selectedItem.id=='SELECT000000ALL'){_this3.setState({selectedVehicles:_this3.state.vehicleNames});}else{var selectedFiltedArray=_this3.state.vehicleNames.filter(function(obj){return obj.id!==selectedItem.id;});var selectedFiltedArrayALL=selectedFiltedArray.filter(function(obj){return obj.id!=='SELECT000000ALL';});_this3.setState({selectedVehicles:selectedList,vehicleNames:[{id:'SELECT000000ALL',name:'Select All'},selectedItem].concat(_toConsumableArray(selectedFiltedArrayALL))});}},onRemove:function onRemove(selectedList,selectedItem){if(selectedItem.id=='SELECT000000ALL'){_this3.setState({selectedVehicles:[]});}else{var selectedFiltedArray=_this3.state.vehicleNames.filter(function(obj){return obj.id!==selectedItem.id;});var selectedFiltedArrayALL=selectedList.filter(function(obj){return obj.id!=='SELECT000000ALL';});_this3.setState({selectedVehicles:selectedFiltedArrayALL,vehicleNames:[].concat(_toConsumableArray(selectedFiltedArray),[selectedItem])});}},displayValue:'name'// Property name to display in the dropdown options
,showCheckbox:true,style:multiselectStyle,avoidHighlightFirstOption:true}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xl:3,md:3,style:{marginRight:'3%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core__["InputLabel"],{style:{fontSize:'0.8em'}},'From Date'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_material_ui_pickers__["b" /* DateTimePicker */],{value:this.state.selectedFormDate,onChange:this.handleFromDate,format:'D MMM, Y hh:mm a'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xl:3,md:3,style:{marginRight:'3%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core__["InputLabel"],{style:{fontSize:'0.8em'}},'To Date'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_material_ui_pickers__["b" /* DateTimePicker */],{value:this.state.selectedToDate,onChange:this.handleToDate,format:'D MMM, Y hh:mm a',maxDate:this.state.toMaxDate,minDate:this.state.selectedFormDate,maxDateMessage:'To date should not be after maximal date (30 days from start date).'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{onClick:this.handleSubmit,type:'submit',color:'primary',variant:'contained',style:{marginTop:'1em',marginLeft:'2%'},disabled:!this.state.fromDate||!this.state.toDate||!this.state.selectedVehicles.length},'Submit')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,direction:'row',style:{alignItems:'center',display:'flex',justifyContent:'end',marginTop:'1em'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{color:'secondary',onClick:this.handleClickOpen,variant:'raised',style:{marginRight:'1em'}},'Send Commands'),' '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{color:'secondary',onClick:this.handleBulkOpen,variant:'raised',style:{marginRight:'1em'}},'Bulk Upload'),' ')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core__["Modal"],{open:this.state.openBulkModal,onClose:this.handleClose,'aria-labelledby':'modal-modal-title','aria-describedby':'modal-modal-description'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__BulkUpload__["a" /* default */],Object.assign({},this.props,{onClose:this.handleClose}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog___default.a,{open:this.state.open,onClose:this.handleClose,'aria-labelledby':'form-dialog-title'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__VehcileDashboard_SendCommands__["a" /* default */],{handleClose:this.handleClose})),this.state.commandsList&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_mui_datatables___default.a,{data:this.state.commandsList,columns:this.columns,options:this.options}))));}}]);return VehicleCommands;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_12__HOCs_withSharedSnackbar__["a" /* default */])(VehicleCommands))));

/***/ }),
/* 1109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_file_saver__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_ArrowBack__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_ArrowBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_ArrowBack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_ConfirmationDialog__ = __webpack_require__(65);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  mutation excelFileUpload(\n    $fileInfo: FileUploadInput!\n    $commonInput: CommonInput!\n  ) {\n    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {\n      failedToUpload\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedUploadList\n    }\n  }\n'],['\n  mutation excelFileUpload(\n    $fileInfo: FileUploadInput!\n    $commonInput: CommonInput!\n  ) {\n    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {\n      failedToUpload\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedUploadList\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n'],['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n'],['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/**
 * @module Commands/CommandsBulkUpload
 * @summary This module exports the CommandsBulkUpload component
 */// calling server for updation
var UPLOAD_EXCEL_FILE=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject);var GET_UPLOAD_URL=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject2);var GET_FILE_FORMAT=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject3);var modalStyle={position:'absolute',top:'40%',left:'50%',transform:'translate(-50%, -50%)',width:700,p:4,backgroundColor:'#ffffff'};var BulkUpload=function(_Component){_inherits(BulkUpload,_Component);function BulkUpload(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,BulkUpload);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BulkUpload.__proto__||Object.getPrototypeOf(BulkUpload)).call.apply(_ref,[this].concat(args))),_this),_this.state={fileName:'',bucketName:'',publicUploadURL:'',isUploading:false,uploadSucess:false,uploading:false,failedRecords:0,uploadedFileName:'',response:'',uploadErrors:false,failList:[],selectedAlertType:'',fileFormatValid:'',isSubmitBulkUpload:false/**
   * @summary The columns of the Error table
   */},_this.errorTableColumns=['Vehicle Number','Reason'],_this.errorTableOptions={selectableRows:'none',responsive:'stacked',rowsPerPage:5,print:false,download:true},_this.handleSubmit=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var response,fullData,sucessfulEntries,failedEntries,failedToUpload;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.setState({uploading:true,isSubmitBulkUpload:false});_context.next=3;return _this.props.client.mutate({mutation:UPLOAD_EXCEL_FILE,variables:{fileInfo:{uploadFor:'vehicleCommandsBulk',bucketName:_this.state.bucketName,fileName:_this.state.fileName},commonInput:{}},errorPolicy:'all'});case 3:response=_context.sent;if(response.data&&response.data.excelFileUpload){fullData=[];sucessfulEntries=response.data.excelFileUpload.successfullyUploaded;failedEntries=response.data.excelFileUpload.failedUploadList;failedToUpload=response.data.excelFileUpload.failedToUpload;JSON.parse(failedEntries).forEach(function(element){var rowData=[];rowData.push(element.vehicleNumber);rowData.push(element.error);fullData.push(rowData);});_this.setState({fileFormatValid:'',response:'Total Excel Records= '+response.data.excelFileUpload.totalExcelDataRecords+', Total Records Uploaded='+response.data.excelFileUpload.successfullyUploaded+// ', Total Duplicate Records=' +
// response.data.excelFileUpload.totalDuplicateRecords +
', Total Records Failed To Upload='+response.data.excelFileUpload.failedToUpload,uploadSucess:true,uploading:false,failList:fullData,failedRecords:response.data.excelFileUpload.failedToUpload,bucketName:'',fileName:'',publicUploadURL:'',uploadedFileName:''});if(response.data.excelFileUpload.failedToUpload!=0){_this.setState({uploadErrors:true,failList:fullData,uploading:false,bucketName:'',fileName:'',publicUploadURL:'',uploadedFileName:''});}}else if(response.data==null&&response.errors){_this.setState({fileFormatValid:response.errors[0].message,response:'',uploadErrors:false,uploading:false,bucketName:'',fileName:'',publicUploadURL:'',uploadedFileName:''});}else{}case 5:case'end':return _context.stop();}}},_callee,_this2);})),_this.onUpload=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref3){var _ref3$target=_ref3.target,validity=_ref3$target.validity,_ref3$target$files=_slicedToArray(_ref3$target.files,1),file=_ref3$target$files[0];var fileExtension,response,url;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_this.setState({isUploading:true});if(!(validity.valid&&file)){_context2.next=11;break;}fileExtension=file.name.substring(file.name.lastIndexOf('.')+1);_context2.next=5;return _this.props.client.mutate({mutation:GET_UPLOAD_URL,variables:{fileExtension:fileExtension}});case 5:response=_context2.sent;if(!(response.data&&response.data.getPublicUploadURL)){_context2.next=11;break;}url=response.data.getPublicUploadURL.publicUploadURL;_context2.next=10;return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url,file,{headers:{"x-ms-blob-type":"BlockBlob","Content-Type":file.type||"application/octet-stream"}});case 10:_this.setState({fileName:response.data.getPublicUploadURL.filename,bucketName:response.data.getPublicUploadURL.bucketName,publicUploadURL:response.data.getPublicUploadURL.publicUploadURL,uploadedFileName:file.name});case 11:_this.setState({isUploading:false});case 12:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x){return _ref4.apply(this,arguments);};}(),_this.handleDownload=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var _ref6,data,res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return _this.props.client.query({query:GET_FILE_FORMAT,variables:{bucketname:'excel-templates',filename:'vehicleCommandsTemplate.xlsx'},errorPolicy:'all'});case 2:_ref6=_context3.sent;data=_ref6.data;_context3.next=6;return __WEBPACK_IMPORTED_MODULE_3_axios___default()({url:data.getPublicDownloadURL,method:'GET',headers:{Accept:'application/vnd.ms-excel'},responseType:'blob'// important
});case 6:res=_context3.sent;__WEBPACK_IMPORTED_MODULE_6_file_saver___default.a.saveAs(new Blob([res.data]),'vehicleCommandsTemplate.xlsx');case 8:case'end':return _context3.stop();}}},_callee3,_this2);})),_temp),_possibleConstructorReturn(_this,_ret);}/**
   * @summary The options for the Error table
   *//**
   * @summary Fetches a url for uploading a file and uploads the file
   */_createClass(BulkUpload,[{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:modalStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_ConfirmationDialog__["a" /* default */],{isDialogOpen:this.state.isSubmitBulkUpload,dialogMessage:'Are you sure to bulk upload the commands?',negativeResponseHandler:this.props.onClose,positiveResponseHandler:this.handleSubmit}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["DialogTitle"],{id:'alert-dialog-title'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Grid"],{container:true,gutterBottom:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Grid"],{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_ArrowBack___default.a,{color:'primary',onClick:this.props.onClose,style:{marginRight:'0.5em'}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Grid"],{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Typography"],{variant:'h4'},' Bulk Upload')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["DialogContent"],{style:{maxHeight:'60vh',overflow:'auto'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Grid"],{container:true,gutterBottom:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Button"],{variant:'outlined',color:'secondary',style:{border:'1px solid green',marginBottom:'1em'},onClick:this.handleDownload},'Download Template')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Grid"],{container:true,spacing:2,style:{marginBottom:'2em'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Grid"],{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{accept:'*/*',id:'contained-button-file',multiple:true,type:'file',style:{display:'none'},onChange:this.onUpload}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'contained-button-file'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Button"],{variant:'outlined',component:'span'},this.state.isUploading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["CircularProgress"],{size:15}):'Choose File'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Grid"],{item:true,xs:6,style:{marginLeft:'2%',alignSelf:'center'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Grid"],{container:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Grid"],{item:true,style:{maxWidth:'30%',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'},spacing:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Typography"],{variant:'caption',color:'textSecondary',gutterBottom:true,style:{textOverflow:'ellipsis'}},this.state.uploadedFileName)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Grid"],{item:true,xs:6,spacing:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Typography"],{variant:'caption',color:'textSecondary',gutterBottom:true,style:{marginLeft:'1%'}},this.state.uploadedFileName?' | ':'',' File Format - XLS, XLSX'))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Button"],{onClick:function onClick(){if(_this3.state.isSubmitBulkUpload==false){_this3.setState({isSubmitBulkUpload:true});}else{_this3.setState({isSubmitBulkUpload:false});}},type:'submit',variant:'raised',color:'secondary',disabled:!this.state.fileName||this.state.uploading},this.state.uploading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["CircularProgress"],{size:15}):'Submit'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{padding:'1em'}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Grid"],{item:true,xs:12},this.state.fileFormatValid&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Typography"],{variant:'body2',mt:2,style:{color:'red'}},this.state.fileFormatValid)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Grid"],{item:true,xs:12},this.state.failList.length==0&&this.state.response&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Typography"],{variant:'subtitle1',style:{marginTop:'1em',marginBottom:'1em'}},'Succesfully Uploaded')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Grid"],{item:true,xs:12},this.state.response&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Typography"],{variant:'body1',style:{color:this.state.failList.length==0?'green':'red'}},this.state.response)),this.state.uploadErrors>0&&this.state.failList.length!=0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Grid"],{item:true,style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',null,'Failed records list'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_mui_datatables___default.a,{data:this.state.failList,columns:this.errorTableColumns,options:this.errorTableOptions})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null)));}}]);return BulkUpload;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (BulkUpload);

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:!0});var e,t=__webpack_require__(0),i=(e=t)&&"object"==typeof e&&"default"in e?e.default:e;function n(e,t){return(n=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(e,t){return e.__proto__=t,e})(e,t)}function s(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}!function(e,t){void 0===t&&(t={});var i=t.insertAt;if("undefined"!=typeof document){var n=document.head||document.getElementsByTagName("head")[0],s=document.createElement("style");s.type="text/css","top"===i&&n.firstChild?n.insertBefore(s,n.firstChild):n.appendChild(s),s.styleSheet?s.styleSheet.cssText=e:s.appendChild(document.createTextNode(e))}}('.multiSelectContainer,.multiSelectContainer *,.multiSelectContainer :after,.multiSelectContainer :before{box-sizing:border-box}.multiSelectContainer{position:relative;text-align:left;width:100%}.disable_ms{opacity:.5;pointer-events:none}.display-none{display:none}.searchWrapper{border:1px solid #ccc;border-radius:4px;min-height:22px;padding:5px;position:relative}.multiSelectContainer input{background:transparent;border:none;margin-top:3px}.multiSelectContainer input:focus{outline:none}.chip{align-items:center;background:#0096fb;border-radius:11px;color:#fff;display:inline-flex;font-size:13px;line-height:19px;margin-bottom:5px;margin-right:5px;padding:4px 10px}.chip,.singleChip{white-space:nowrap}.singleChip{background:none;border-radius:none;color:inherit}.singleChip i{display:none}.closeIcon{cursor:pointer;float:right;height:13px;margin-left:5px;width:13px}.optionListContainer{background:#fff;border-radius:4px;margin-top:1px;position:absolute;width:100%;z-index:2}.multiSelectContainer ul{border:1px solid #ccc;border-radius:4px;display:block;margin:0;max-height:250px;overflow-y:auto;padding:0}.multiSelectContainer li{padding:10px}.multiSelectContainer li:hover{background:#0096fb;color:#fff;cursor:pointer}.checkbox{margin-right:10px}.disableSelection{opacity:.5;pointer-events:none}.highlightOption{background:#0096fb;color:#fff}.displayBlock{display:block}.displayNone{display:none}.notFound{display:block;padding:10px}.singleSelect{padding-right:20px}li.groupHeading{color:#908e8e;padding:5px 15px;pointer-events:none}li.groupChildEle{padding-left:30px}.icon_down_dir{position:absolute;right:10px;top:50%;transform:translateY(-50%);width:14px}.icon_down_dir:before{content:"\\e803"}.custom-close{display:flex}');var o={circle:"data:image/svg+xml,%3Csvg%20height%3D%22512px%22%20id%3D%22Layer_1%22%20style%3D%22enable-background%3Anew%200%200%20512%20512%3B%22%20version%3D%221.1%22%20viewBox%3D%220%200%20512%20512%22%20width%3D%22512px%22%20xml%3Aspace%3D%22preserve%22%20%20%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20%20%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Cstyle%20type%3D%22text%2Fcss%22%3E%20%20%20%20%20%20%20%20.st0%7B%20%20%20%20%20%20%20%20%20%20%20%20fill%3A%23fff%3B%20%20%20%20%20%20%20%20%7D%20%3C%2Fstyle%3E%20%20%20%20%3Cg%3E%20%20%20%20%20%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M256%2C33C132.3%2C33%2C32%2C133.3%2C32%2C257c0%2C123.7%2C100.3%2C224%2C224%2C224c123.7%2C0%2C224-100.3%2C224-224C480%2C133.3%2C379.7%2C33%2C256%2C33z%20%20%20%20M364.3%2C332.5c1.5%2C1.5%2C2.3%2C3.5%2C2.3%2C5.6c0%2C2.1-0.8%2C4.2-2.3%2C5.6l-21.6%2C21.7c-1.6%2C1.6-3.6%2C2.3-5.6%2C2.3c-2%2C0-4.1-0.8-5.6-2.3L256%2C289.8%20%20%20l-75.4%2C75.7c-1.5%2C1.6-3.6%2C2.3-5.6%2C2.3c-2%2C0-4.1-0.8-5.6-2.3l-21.6-21.7c-1.5-1.5-2.3-3.5-2.3-5.6c0-2.1%2C0.8-4.2%2C2.3-5.6l75.7-76%20%20%20l-75.9-75c-3.1-3.1-3.1-8.2%2C0-11.3l21.6-21.7c1.5-1.5%2C3.5-2.3%2C5.6-2.3c2.1%2C0%2C4.1%2C0.8%2C5.6%2C2.3l75.7%2C74.7l75.7-74.7%20%20%20c1.5-1.5%2C3.5-2.3%2C5.6-2.3c2.1%2C0%2C4.1%2C0.8%2C5.6%2C2.3l21.6%2C21.7c3.1%2C3.1%2C3.1%2C8.2%2C0%2C11.3l-75.9%2C75L364.3%2C332.5z%22%2F%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E",circle2:"data:image/svg+xml,%3Csvg%20viewBox%3D%220%200%2096%2096%22%20%20%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%20%20%3Cstyle%20type%3D%22text%2Fcss%22%3E%20%20%20%20%20%20%20%20.st0%7B%20%20%20%20%20%20%20%20%20%20%20%20fill%3A%23fff%3B%20%20%20%20%20%20%20%20%7D%20%3C%2Fstyle%3E%20%20%20%20%3Cg%3E%20%20%20%20%20%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M48%2C0A48%2C48%2C0%2C1%2C0%2C96%2C48%2C48.0512%2C48.0512%2C0%2C0%2C0%2C48%2C0Zm0%2C84A36%2C36%2C0%2C1%2C1%2C84%2C48%2C36.0393%2C36.0393%2C0%2C0%2C1%2C48%2C84Z%22%2F%3E%20%20%20%20%20%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M64.2422%2C31.7578a5.9979%2C5.9979%2C0%2C0%2C0-8.4844%2C0L48%2C39.5156l-7.7578-7.7578a5.9994%2C5.9994%2C0%2C0%2C0-8.4844%2C8.4844L39.5156%2C48l-7.7578%2C7.7578a5.9994%2C5.9994%2C0%2C1%2C0%2C8.4844%2C8.4844L48%2C56.4844l7.7578%2C7.7578a5.9994%2C5.9994%2C0%2C0%2C0%2C8.4844-8.4844L56.4844%2C48l7.7578-7.7578A5.9979%2C5.9979%2C0%2C0%2C0%2C64.2422%2C31.7578Z%22%2F%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E",close:"data:image/svg+xml,%3Csvg%20height%3D%22135.467mm%22%20style%3D%22shape-rendering%3AgeometricPrecision%3B%20text-rendering%3AgeometricPrecision%3B%20image-rendering%3AoptimizeQuality%3B%20fill-rule%3Aevenodd%3B%20clip-rule%3Aevenodd%22%20viewBox%3D%220%200%2013547%2013547%22%20width%3D%22135.467mm%22%20xml%3Aspace%3D%22preserve%22%20%20%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20%20%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Cdefs%3E%20%20%20%20%20%20%20%20%3Cstyle%20type%3D%22text%2Fcss%22%3E%20%20%20%20%20%20%20%20%20%20%20%20.fil0%20%7Bfill%3Anone%7D%20%20%20%20%20%20%20%20%20%20%20%20.fil1%20%7Bfill%3A%23fff%7D%20%20%20%20%20%20%20%20%3C%2Fstyle%3E%20%20%20%20%3C%2Fdefs%3E%20%20%20%20%3Cg%20id%3D%22Ebene_x0020_1%22%3E%20%20%20%20%20%20%20%20%3Cpolygon%20class%3D%22fil0%22%20points%3D%220%2C0%2013547%2C0%2013547%2C13547%200%2C13547%20%22%2F%3E%20%20%20%20%20%20%20%20%3Cpath%20class%3D%22fil1%22%20d%3D%22M714%2012832l12118%200%200%20-12117%20-12118%200%200%2012117zm4188%20-2990l1871%20-1871%201871%201871%201197%20-1197%20-1871%20-1871%201871%20-1871%20-1197%20-1197%20-1871%201871%20-1871%20-1871%20-1197%201197%201871%201871%20-1871%201871%201197%201197z%22%2F%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E",cancel:"data:image/svg+xml,%3Csvg%20height%3D%22512px%22%20id%3D%22Layer_1%22%20style%3D%22enable-background%3Anew%200%200%20512%20512%3B%22%20version%3D%221.1%22%20viewBox%3D%220%200%20512%20512%22%20width%3D%22512px%22%20xml%3Aspace%3D%22preserve%22%20%20%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20%20%20%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Cstyle%20type%3D%22text%2Fcss%22%3E%20%20%20%20%20%20%20%20.st0%7B%20%20%20%20%20%20%20%20%20%20%20%20fill%3A%23fff%3B%20%20%20%20%20%20%20%20%7D%20%3C%2Fstyle%3E%20%20%20%20%3Cpath%20class%3D%22st0%22%20d%3D%22M443.6%2C387.1L312.4%2C255.4l131.5-130c5.4-5.4%2C5.4-14.2%2C0-19.6l-37.4-37.6c-2.6-2.6-6.1-4-9.8-4c-3.7%2C0-7.2%2C1.5-9.8%2C4%20%20L256%2C197.8L124.9%2C68.3c-2.6-2.6-6.1-4-9.8-4c-3.7%2C0-7.2%2C1.5-9.8%2C4L68%2C105.9c-5.4%2C5.4-5.4%2C14.2%2C0%2C19.6l131.5%2C130L68.4%2C387.1%20%20c-2.6%2C2.6-4.1%2C6.1-4.1%2C9.8c0%2C3.7%2C1.4%2C7.2%2C4.1%2C9.8l37.4%2C37.6c2.7%2C2.7%2C6.2%2C4.1%2C9.8%2C4.1c3.5%2C0%2C7.1-1.3%2C9.8-4.1L256%2C313.1l130.7%2C131.1%20%20c2.7%2C2.7%2C6.2%2C4.1%2C9.8%2C4.1c3.5%2C0%2C7.1-1.3%2C9.8-4.1l37.4-37.6c2.6-2.6%2C4.1-6.1%2C4.1-9.8C447.7%2C393.2%2C446.2%2C389.7%2C443.6%2C387.1z%22%2F%3E%3C%2Fsvg%3E"};function l(e){var n,s,o=t.useRef(null);return s=e.outsideClick,t.useEffect((function(){function e(e){n.current&&!n.current.contains(e.target)&&s()}return document.addEventListener("mousedown",e),function(){document.removeEventListener("mousedown",e)}}),[n=o]),i.createElement("div",{ref:o},e.children)}var r=function(e){var t,r;function c(t){var n;return(n=e.call(this,t)||this).state={inputValue:"",options:t.options,filteredOptions:t.options,unfilteredOptions:t.options,selectedValues:Object.assign([],t.selectedValues),preSelectedValues:Object.assign([],t.selectedValues),toggleOptionsList:!1,highlightOption:t.avoidHighlightFirstOption?-1:0,showCheckbox:t.showCheckbox,keepSearchTerm:t.keepSearchTerm,groupedObject:[],closeIconType:o[t.closeIcon]||o.circle},n.optionTimeout=null,n.searchWrapper=i.createRef(),n.searchBox=i.createRef(),n.onChange=n.onChange.bind(s(n)),n.onKeyPress=n.onKeyPress.bind(s(n)),n.onFocus=n.onFocus.bind(s(n)),n.onBlur=n.onBlur.bind(s(n)),n.renderMultiselectContainer=n.renderMultiselectContainer.bind(s(n)),n.renderSelectedList=n.renderSelectedList.bind(s(n)),n.onRemoveSelectedItem=n.onRemoveSelectedItem.bind(s(n)),n.toggelOptionList=n.toggelOptionList.bind(s(n)),n.onArrowKeyNavigation=n.onArrowKeyNavigation.bind(s(n)),n.onSelectItem=n.onSelectItem.bind(s(n)),n.filterOptionsByInput=n.filterOptionsByInput.bind(s(n)),n.removeSelectedValuesFromOptions=n.removeSelectedValuesFromOptions.bind(s(n)),n.isSelectedValue=n.isSelectedValue.bind(s(n)),n.fadeOutSelection=n.fadeOutSelection.bind(s(n)),n.isDisablePreSelectedValues=n.isDisablePreSelectedValues.bind(s(n)),n.renderGroupByOptions=n.renderGroupByOptions.bind(s(n)),n.renderNormalOption=n.renderNormalOption.bind(s(n)),n.listenerCallback=n.listenerCallback.bind(s(n)),n.resetSelectedValues=n.resetSelectedValues.bind(s(n)),n.getSelectedItems=n.getSelectedItems.bind(s(n)),n.getSelectedItemsCount=n.getSelectedItemsCount.bind(s(n)),n.hideOnClickOutside=n.hideOnClickOutside.bind(s(n)),n.onCloseOptionList=n.onCloseOptionList.bind(s(n)),n.isVisible=n.isVisible.bind(s(n)),n}r=e,(t=c).prototype=Object.create(r.prototype),t.prototype.constructor=t,n(t,r);var a=c.prototype;return a.initialSetValue=function(){var e=this.props,t=e.groupBy,i=this.state.options;e.showCheckbox||e.singleSelect||this.removeSelectedValuesFromOptions(!1),t&&this.groupByOptions(i)},a.resetSelectedValues=function(){var e=this,t=this.state.unfilteredOptions;return new Promise((function(i){e.setState({selectedValues:[],preSelectedValues:[],options:t,filteredOptions:t},(function(){i(),e.initialSetValue()}))}))},a.getSelectedItems=function(){return this.state.selectedValues},a.getSelectedItemsCount=function(){return this.state.selectedValues.length},a.componentDidMount=function(){this.initialSetValue(),this.searchWrapper.current.addEventListener("click",this.listenerCallback)},a.componentDidUpdate=function(e){var t=this.props,i=t.options,n=t.selectedValues,s=e.selectedValues;JSON.stringify(e.options)!==JSON.stringify(i)&&this.setState({options:i,filteredOptions:i,unfilteredOptions:i},this.initialSetValue),JSON.stringify(s)!==JSON.stringify(n)&&this.setState({selectedValues:Object.assign([],n),preSelectedValues:Object.assign([],n)},this.initialSetValue)},a.listenerCallback=function(){this.searchBox.current.focus()},a.componentWillUnmount=function(){this.optionTimeout&&clearTimeout(this.optionTimeout),this.searchWrapper.current.removeEventListener("click",this.listenerCallback)},a.removeSelectedValuesFromOptions=function(e){var t=this.props,i=t.isObject,n=t.displayValue,s=t.groupBy,o=this.state,l=o.selectedValues,r=void 0===l?[]:l,c=o.unfilteredOptions;if(!e&&s&&this.groupByOptions(o.options),r.length||e){if(i){var a=c.filter((function(e){return-1===r.findIndex((function(t){return t[n]===e[n]}))}));return s&&this.groupByOptions(a),void this.setState({options:a,filteredOptions:a},this.filterOptionsByInput)}var p=c.filter((function(e){return-1===r.indexOf(e)}));this.setState({options:p,filteredOptions:p},this.filterOptionsByInput)}},a.groupByOptions=function(e){var t=this.props.groupBy,i=e.reduce((function(e,i){var n=i[t]||"Others";return e[n]=e[n]||[],e[n].push(i),e}),Object.create({}));this.setState({groupedObject:i})},a.onChange=function(e){var t=this.props.onSearch;this.setState({inputValue:e.target.value},this.filterOptionsByInput),t&&t(e.target.value)},a.onKeyPress=function(e){var t=this.props.onKeyPressFn;t&&t(e,e.target.value)},a.filterOptionsByInput=function(){var e,t=this,i=this.state,n=i.inputValue,s=this.props,o=s.displayValue;e=i.filteredOptions.filter(s.isObject?function(e){return t.matchValues(e[o],n)}:function(e){return t.matchValues(e,n)}),this.groupByOptions(e),this.setState({options:e})},a.matchValues=function(e,t){return this.props.caseSensitiveSearch?e.indexOf(t)>-1:e.toLowerCase?e.toLowerCase().indexOf(t.toLowerCase())>-1:e.toString().indexOf(t)>-1},a.onArrowKeyNavigation=function(e){var t=this.state,i=t.options,n=t.highlightOption,s=t.toggleOptionsList,o=t.selectedValues;if(8!==e.keyCode||t.inputValue||this.props.disablePreSelectedValues||!o.length||this.onRemoveSelectedItem(o.length-1),i.length)if(38===e.keyCode)this.setState(n>0?function(e){return{highlightOption:e.highlightOption-1}}:{highlightOption:i.length-1});else if(40===e.keyCode)this.setState(n<i.length-1?function(e){return{highlightOption:e.highlightOption+1}}:{highlightOption:0});else if("Enter"===e.key&&i.length&&s){if(-1===n)return;this.onSelectItem(i[n])}},a.onRemoveSelectedItem=function(e){var t,i=this,n=this.state.selectedValues,s=this.props,o=s.onRemove,l=s.showCheckbox,r=s.displayValue;t=s.isObject?n.findIndex((function(t){return t[r]===e[r]})):n.indexOf(e),n.splice(t,1),o(n,e),this.setState({selectedValues:n},(function(){l||i.removeSelectedValuesFromOptions(!0)})),this.props.closeOnSelect||this.searchBox.current.focus()},a.onSelectItem=function(e){var t=this,i=this.state.selectedValues,n=this.props,s=n.selectionLimit,o=n.onSelect,l=n.singleSelect,r=n.showCheckbox;if(this.state.keepSearchTerm||this.setState({inputValue:""}),l)return this.onSingleSelect(e),void o([e],e);this.isSelectedValue(e)?this.onRemoveSelectedItem(e):s!=i.length&&(i.push(e),o(i,e),this.setState({selectedValues:i},(function(){r?t.filterOptionsByInput():t.removeSelectedValuesFromOptions(!0)})),this.props.closeOnSelect||this.searchBox.current.focus())},a.onSingleSelect=function(e){this.setState({selectedValues:[e],toggleOptionsList:!1})},a.isSelectedValue=function(e){var t=this.props,i=t.displayValue,n=this.state.selectedValues;return t.isObject?n.filter((function(t){return t[i]===e[i]})).length>0:n.filter((function(t){return t===e})).length>0},a.renderOptionList=function(){var e=this.props,t=e.groupBy,n=e.style,s=e.emptyRecordMsg,o=e.loadingMessage,l=void 0===o?"loading...":o,r=this.state.options;return e.loading?i.createElement("ul",{className:"optionContainer",style:n.optionContainer},"string"==typeof l&&i.createElement("span",{style:n.loadingMessage,className:"notFound"},l),"string"!=typeof l&&l):i.createElement("ul",{className:"optionContainer",style:n.optionContainer},0===r.length&&i.createElement("span",{style:n.notFound,className:"notFound"},s),t?this.renderGroupByOptions():this.renderNormalOption())},a.renderGroupByOptions=function(){var e=this,t=this.props,n=t.isObject,s=void 0!==n&&n,o=t.displayValue,l=t.showCheckbox,r=t.style,c=t.singleSelect,a=this.state.groupedObject;return Object.keys(a).map((function(t){return i.createElement(i.Fragment,{key:t},i.createElement("li",{className:"groupHeading",style:r.groupHeading},t),a[t].map((function(t,n){var a=e.isSelectedValue(t);return i.createElement("li",{key:"option"+n,style:r.option,className:"groupChildEle option "+(a?"selected":"")+" "+(e.fadeOutSelection(t)?"disableSelection":"")+" "+(e.isDisablePreSelectedValues(t)?"disableSelection":""),onClick:function(){return e.onSelectItem(t)}},l&&!c&&i.createElement("input",{type:"checkbox",className:"checkbox",readOnly:!0,checked:a}),e.props.optionValueDecorator(s?t[o]:(t||"").toString(),t))})))}))},a.renderNormalOption=function(){var e=this,t=this.props,n=t.isObject,s=void 0!==n&&n,o=t.displayValue,l=t.showCheckbox,r=t.style,c=t.singleSelect,a=this.state.highlightOption;return this.state.options.map((function(t,n){var p=e.isSelectedValue(t);return i.createElement("li",{key:"option"+n,style:r.option,className:"option "+(p?"selected":"")+" "+(a===n?"highlightOption highlight":"")+" "+(e.fadeOutSelection(t)?"disableSelection":"")+" "+(e.isDisablePreSelectedValues(t)?"disableSelection":""),onClick:function(){return e.onSelectItem(t)}},l&&!c&&i.createElement("input",{type:"checkbox",readOnly:!0,className:"checkbox",checked:p}),e.props.optionValueDecorator(s?t[o]:(t||"").toString(),t))}))},a.renderSelectedList=function(){var e=this,t=this.props,n=t.isObject,s=void 0!==n&&n,o=t.displayValue,l=t.style,r=t.singleSelect,c=t.customCloseIcon,a=this.state,p=a.closeIconType;return a.selectedValues.map((function(t,n){return i.createElement("span",{className:"chip  "+(r&&"singleChip")+" "+(e.isDisablePreSelectedValues(t)&&"disableSelection"),key:n,style:l.chips},e.props.selectedValueDecorator(s?t[o]:(t||"").toString(),t),!e.isDisablePreSelectedValues(t)&&(c?i.createElement("i",{className:"custom-close",onClick:function(){return e.onRemoveSelectedItem(t)}},c):i.createElement("img",{className:"icon_cancel closeIcon",src:p,onClick:function(){return e.onRemoveSelectedItem(t)}})))}))},a.isDisablePreSelectedValues=function(e){var t=this.props,i=t.displayValue,n=this.state.preSelectedValues;return!(!t.disablePreSelectedValues||!n.length)&&(t.isObject?n.filter((function(t){return t[i]===e[i]})).length>0:n.filter((function(t){return t===e})).length>0)},a.fadeOutSelection=function(e){var t=this.props,i=t.selectionLimit;if(!t.singleSelect){var n=this.state.selectedValues;return-1!=i&&i==n.length&&(i==n.length?!t.showCheckbox||!this.isSelectedValue(e):void 0)}},a.toggelOptionList=function(){this.setState({toggleOptionsList:!this.state.toggleOptionsList,highlightOption:this.props.avoidHighlightFirstOption?-1:0})},a.onCloseOptionList=function(){this.setState({toggleOptionsList:!1,highlightOption:this.props.avoidHighlightFirstOption?-1:0,inputValue:""})},a.onFocus=function(){this.state.toggleOptionsList?clearTimeout(this.optionTimeout):this.toggelOptionList()},a.onBlur=function(){this.setState({inputValue:""},this.filterOptionsByInput),this.optionTimeout=setTimeout(this.onCloseOptionList,250)},a.isVisible=function(e){return!!e&&!!(e.offsetWidth||e.offsetHeight||e.getClientRects().length)},a.hideOnClickOutside=function(){var e=this,t=document.getElementsByClassName("multiselect-container")[0];document.addEventListener("click",(function(i){t&&!t.contains(i.target)&&e.isVisible(t)&&e.toggelOptionList()}))},a.renderMultiselectContainer=function(){var e=this.state,t=e.inputValue,n=e.toggleOptionsList,s=e.selectedValues,o=this.props,l=o.placeholder,r=o.style,c=o.singleSelect,a=o.id,p=o.name,u=o.hidePlaceholder,d=o.disable,h=o.showArrow,C=o.customArrow;return i.createElement("div",{className:"multiselect-container multiSelectContainer "+(d?"disable_ms":"")+" "+(o.className||""),id:a||"multiselectContainerReact",style:r.multiselectContainer},i.createElement("div",{className:"search-wrapper searchWrapper "+(c?"singleSelect":""),ref:this.searchWrapper,style:r.searchBox,onClick:c?this.toggelOptionList:function(){}},!o.hideSelectedList&&this.renderSelectedList(),i.createElement("input",{type:"text",ref:this.searchBox,className:"searchBox "+(c&&s.length?"display-none":""),id:(a||"search")+"_input",name:(p||"search_name")+"_input",onChange:this.onChange,onKeyPress:this.onKeyPress,value:t,onFocus:this.onFocus,onBlur:this.onBlur,placeholder:c&&s.length||u&&s.length?"":l,onKeyDown:this.onArrowKeyNavigation,style:r.inputField,autoComplete:"off",disabled:c||d}),(c||h)&&i.createElement(i.Fragment,null,C?i.createElement("span",{className:"icon_down_dir"},C):i.createElement("img",{src:"data:image/svg+xml,%3Csvg%20height%3D%2232%22%20viewBox%3D%220%200%2032%2032%22%20width%3D%2232%22%20%20%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%20%20%3Cg%20id%3D%22background%22%3E%20%20%20%20%20%20%20%20%3Crect%20fill%3D%22none%22%20height%3D%2232%22%20width%3D%2232%22%2F%3E%20%20%20%20%3C%2Fg%3E%20%20%20%20%3Cg%20id%3D%22arrow_x5F_down%22%3E%20%20%20%20%20%20%20%20%3Cpolygon%20points%3D%222.002%2C10%2016.001%2C24%2030.002%2C10%20%20%22%2F%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E",className:"icon_cancel icon_down_dir"}))),i.createElement("div",{className:"optionListContainer "+(n?"displayBlock":"displayNone"),onMouseDown:function(e){e.preventDefault()}},this.renderOptionList()))},a.render=function(){return i.createElement(l,{outsideClick:this.onCloseOptionList},this.renderMultiselectContainer())},c}(i.Component);r.defaultProps={options:[],disablePreSelectedValues:!1,selectedValues:[],isObject:!0,displayValue:"model",showCheckbox:!1,selectionLimit:-1,placeholder:"Select",groupBy:"",style:{},emptyRecordMsg:"No Options Available",onSelect:function(){},onRemove:function(){},onKeyPressFn:function(){},closeIcon:"circle2",singleSelect:!1,caseSensitiveSearch:!1,id:"",name:"",closeOnSelect:!0,avoidHighlightFirstOption:!1,hidePlaceholder:!1,showArrow:!1,keepSearchTerm:!1,customCloseIcon:"",className:"",customArrow:void 0,selectedValueDecorator:function(e){return e},optionValueDecorator:function(e){return e}},exports.Multiselect=r,exports.default=r;
//# sourceMappingURL=multiselect-react-dropdown.cjs.production.min.js.map


/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_FormControlLabel__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_FormControlLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_FormControlLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormHelperText__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormHelperText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormHelperText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_RadioGroup__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_RadioGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_RadioGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_Radio__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_Radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_Radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_material_ui_pickers__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Modules_CustomTabs__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_common_Loader__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__common_ConfirmationDialog__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__material_ui_icons_ArrowBack__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__material_ui_icons_ArrowBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__material_ui_icons_ArrowBack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__material_ui_core_Card__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__material_ui_core_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__material_ui_core_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__material_ui_core_CardHeader__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__material_ui_core_CardHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__material_ui_core_CardHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__material_ui_core_CardContent__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__material_ui_core_CardContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__material_ui_core_CardContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__material_ui_core_CardActions__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__material_ui_core_CardActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__material_ui_core_CardActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Modules_Countries__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Modules_States__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__utils_conertSnakeFormat__ = __webpack_require__(540);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  mutation clientSignup(\n    $username: String!\n    $password: String!\n    $accountType: String\n    $clientName: String\n    $email: String!\n    $contactPerson: String!\n    $contactNumber: String!\n    $landlineNumber: String!\n    $address: String!\n    $city: String!\n    $state: Int!\n    $country: Int!\n    $pincode: Int!\n    $panNumber: String\n    $gst: String\n    $planId: Int\n    $solution: String\n    $billingMode: Int\n    $salesPersonId: Int\n    $clientType: String\n    $timezone: String!\n    $lat: Float\n    $long: Float\n    $partnerLoginId: Int\n    $resellerLoginId: Int\n    $licenseTypeId: Int\n    $typeOfClient: ClientPartnerType\n    $expiryDate: String\n    $registrationType: String!\n    $customerAcquisitionType: String!\n    $directCustomer: String\n    $directCustomerType: String\n    $directCustomerSAPCode: String\n    $indirectCustomerType: String\n    $channelPartnerType: String\n    $indirectCustomerName: String\n    $indirectCustomerUniqueId: String\n    $customerLocation: String!\n    $customerAddress: String!\n    $isSecondaryContact: Boolean\n    $secondaryContactName: String\n    $secondaryContactNumber: String\n    $secondaryLandlineNumber: String\n    $secondaryEmail: String\n    $additionalContactNumbers: String\n    $shippingAddress: String\n    $shippingCountry: Int\n    $shippingState: Int\n    $shippingCity: String\n    $shippingPincode: Int\n    $minimumTrackedDays: Int\n    $packetThreshold: Int\n    $prorata: Int\n    $addressEffectiveDate: String\n    $zonalManager: String!\n    $keyAccountManager: String!\n    $zone: String!\n    $serviceManager: String!\n    $customerSuccessManager: String!\n    $channelPartnerName: String\n    $channelPartnerSAPCode: String\n    $litemode: String!\n    $is_sim_tracking: Boolean\n    $customerNameToBeDisplayed: String!\n    $totalPotentialVehicles: Int!\n    $planType: String\n    $videoTelematicsType: String\n    $serviceType: String!\n    $clientCategory: String!\n    $stateManager: String!\n    $territoryManager: String\n    $salesHead: String\n    $clusterHead: String\n    $stateHead: String\n    $cityManager: String\n    $operationsManager: String\n  ) {\n    clientSignup(\n      username: $username\n      password: $password\n      accountType: $accountType\n      clientName: $clientName\n      email: $email\n      contactPerson: $contactPerson\n      contactNumber: $contactNumber\n      landlineNumber: $landlineNumber\n      address: $address\n      city: $city\n      state: $state\n      country: $country\n      pincode: $pincode\n      panNumber: $panNumber\n      gst: $gst\n      planId: $planId\n      solution: $solution\n      billingMode: $billingMode\n      salesPersonId: $salesPersonId\n      clientType: $clientType\n      timezone: $timezone\n      lat: $lat\n      long: $long\n      partnerLoginId: $partnerLoginId\n      resellerLoginId: $resellerLoginId\n      licenseTypeId: $licenseTypeId\n      typeOfClient: $typeOfClient\n      expiryDate: $expiryDate\n      registrationType: $registrationType\n      customerAcquisitionType: $customerAcquisitionType\n      directCustomer: $directCustomer\n      directCustomerType: $directCustomerType\n      directCustomerSAPCode: $directCustomerSAPCode\n      indirectCustomerType: $indirectCustomerType\n      channelPartnerType: $channelPartnerType\n      indirectCustomerName: $indirectCustomerName\n      indirectCustomerUniqueId: $indirectCustomerUniqueId\n      customerLocation: $customerLocation\n      customerAddress: $customerAddress\n      isSecondaryContact: $isSecondaryContact\n      secondaryContactName: $secondaryContactName\n      secondaryContactNumber: $secondaryContactNumber\n      secondaryLandlineNumber: $secondaryLandlineNumber\n      secondaryEmail: $secondaryEmail\n      additionalContactNumbers: $additionalContactNumbers\n      shippingAddress: $shippingAddress\n      shippingCountry: $shippingCountry\n      shippingState: $shippingState\n      shippingCity: $shippingCity\n      shippingPincode: $shippingPincode\n      minimumTrackedDays: $minimumTrackedDays\n      packetThreshold: $packetThreshold\n      prorata: $prorata\n      addressEffectiveDate: $addressEffectiveDate\n      zonalManager: $zonalManager\n      keyAccountManager: $keyAccountManager\n      zone: $zone\n      serviceManager: $serviceManager\n      customerSuccessManager: $customerSuccessManager\n      channelPartnerName: $channelPartnerName\n      channelPartnerSAPCode: $channelPartnerSAPCode\n      litemode: $litemode\n      is_sim_tracking: $is_sim_tracking\n      customerNameToBeDisplayed: $customerNameToBeDisplayed\n      totalPotentialVehicles: $totalPotentialVehicles\n      planType: $planType\n      videoTelematicsType: $videoTelematicsType\n      serviceType: $serviceType\n      clientCategory: $clientCategory\n      stateManager: $stateManager\n      territoryManager: $territoryManager\n      salesHead: $salesHead\n      clusterHead: $clusterHead\n      stateHead: $stateHead\n      cityManager: $cityManager\n      operationsManager: $operationsManager\n    )\n  }\n'],['\n  mutation clientSignup(\n    $username: String!\n    $password: String!\n    $accountType: String\n    $clientName: String\n    $email: String!\n    $contactPerson: String!\n    $contactNumber: String!\n    $landlineNumber: String!\n    $address: String!\n    $city: String!\n    $state: Int!\n    $country: Int!\n    $pincode: Int!\n    $panNumber: String\n    $gst: String\n    $planId: Int\n    $solution: String\n    $billingMode: Int\n    $salesPersonId: Int\n    $clientType: String\n    $timezone: String!\n    $lat: Float\n    $long: Float\n    $partnerLoginId: Int\n    $resellerLoginId: Int\n    $licenseTypeId: Int\n    $typeOfClient: ClientPartnerType\n    $expiryDate: String\n    $registrationType: String!\n    $customerAcquisitionType: String!\n    $directCustomer: String\n    $directCustomerType: String\n    $directCustomerSAPCode: String\n    $indirectCustomerType: String\n    $channelPartnerType: String\n    $indirectCustomerName: String\n    $indirectCustomerUniqueId: String\n    $customerLocation: String!\n    $customerAddress: String!\n    $isSecondaryContact: Boolean\n    $secondaryContactName: String\n    $secondaryContactNumber: String\n    $secondaryLandlineNumber: String\n    $secondaryEmail: String\n    $additionalContactNumbers: String\n    $shippingAddress: String\n    $shippingCountry: Int\n    $shippingState: Int\n    $shippingCity: String\n    $shippingPincode: Int\n    $minimumTrackedDays: Int\n    $packetThreshold: Int\n    $prorata: Int\n    $addressEffectiveDate: String\n    $zonalManager: String!\n    $keyAccountManager: String!\n    $zone: String!\n    $serviceManager: String!\n    $customerSuccessManager: String!\n    $channelPartnerName: String\n    $channelPartnerSAPCode: String\n    $litemode: String!\n    $is_sim_tracking: Boolean\n    $customerNameToBeDisplayed: String!\n    $totalPotentialVehicles: Int!\n    $planType: String\n    $videoTelematicsType: String\n    $serviceType: String!\n    $clientCategory: String!\n    $stateManager: String!\n    $territoryManager: String\n    $salesHead: String\n    $clusterHead: String\n    $stateHead: String\n    $cityManager: String\n    $operationsManager: String\n  ) {\n    clientSignup(\n      username: $username\n      password: $password\n      accountType: $accountType\n      clientName: $clientName\n      email: $email\n      contactPerson: $contactPerson\n      contactNumber: $contactNumber\n      landlineNumber: $landlineNumber\n      address: $address\n      city: $city\n      state: $state\n      country: $country\n      pincode: $pincode\n      panNumber: $panNumber\n      gst: $gst\n      planId: $planId\n      solution: $solution\n      billingMode: $billingMode\n      salesPersonId: $salesPersonId\n      clientType: $clientType\n      timezone: $timezone\n      lat: $lat\n      long: $long\n      partnerLoginId: $partnerLoginId\n      resellerLoginId: $resellerLoginId\n      licenseTypeId: $licenseTypeId\n      typeOfClient: $typeOfClient\n      expiryDate: $expiryDate\n      registrationType: $registrationType\n      customerAcquisitionType: $customerAcquisitionType\n      directCustomer: $directCustomer\n      directCustomerType: $directCustomerType\n      directCustomerSAPCode: $directCustomerSAPCode\n      indirectCustomerType: $indirectCustomerType\n      channelPartnerType: $channelPartnerType\n      indirectCustomerName: $indirectCustomerName\n      indirectCustomerUniqueId: $indirectCustomerUniqueId\n      customerLocation: $customerLocation\n      customerAddress: $customerAddress\n      isSecondaryContact: $isSecondaryContact\n      secondaryContactName: $secondaryContactName\n      secondaryContactNumber: $secondaryContactNumber\n      secondaryLandlineNumber: $secondaryLandlineNumber\n      secondaryEmail: $secondaryEmail\n      additionalContactNumbers: $additionalContactNumbers\n      shippingAddress: $shippingAddress\n      shippingCountry: $shippingCountry\n      shippingState: $shippingState\n      shippingCity: $shippingCity\n      shippingPincode: $shippingPincode\n      minimumTrackedDays: $minimumTrackedDays\n      packetThreshold: $packetThreshold\n      prorata: $prorata\n      addressEffectiveDate: $addressEffectiveDate\n      zonalManager: $zonalManager\n      keyAccountManager: $keyAccountManager\n      zone: $zone\n      serviceManager: $serviceManager\n      customerSuccessManager: $customerSuccessManager\n      channelPartnerName: $channelPartnerName\n      channelPartnerSAPCode: $channelPartnerSAPCode\n      litemode: $litemode\n      is_sim_tracking: $is_sim_tracking\n      customerNameToBeDisplayed: $customerNameToBeDisplayed\n      totalPotentialVehicles: $totalPotentialVehicles\n      planType: $planType\n      videoTelematicsType: $videoTelematicsType\n      serviceType: $serviceType\n      clientCategory: $clientCategory\n      stateManager: $stateManager\n      territoryManager: $territoryManager\n      salesHead: $salesHead\n      clusterHead: $clusterHead\n      stateHead: $stateHead\n      cityManager: $cityManager\n      operationsManager: $operationsManager\n    )\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query getAllPlans($partnerLoginId: Int!) {\n    allPlans: getAllPlans(partnerLoginId: $partnerLoginId) {\n      id\n      planName\n    }\n  }\n'],['\n  query getAllPlans($partnerLoginId: Int!) {\n    allPlans: getAllPlans(partnerLoginId: $partnerLoginId) {\n      id\n      planName\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query GetAllMasterSolutionType {\n    getAllMasterSolutionType {\n      id\n      solutionTypeName\n    }\n  }\n'],['\n  query GetAllMasterSolutionType {\n    getAllMasterSolutionType {\n      id\n      solutionTypeName\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query {\n    allCountries {\n      country_id\n      name\n    }\n  }\n'],['\n  query {\n    allCountries {\n      country_id\n      name\n    }\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  query getStatesByCountryId($countryId: Int!) {\n    allStatesByCountryId(country_id: $countryId) {\n      name\n      zone_id\n    }\n  }\n'],['\n  query getStatesByCountryId($countryId: Int!) {\n    allStatesByCountryId(country_id: $countryId) {\n      name\n      zone_id\n    }\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  query checkUsername($username: String!) {\n    checkUsername(username: $username)\n  }\n'],['\n  query checkUsername($username: String!) {\n    checkUsername(username: $username)\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  query checkClientName($clientName: String!) {\n    checkClientName(clientName: $clientName)\n  }\n'],['\n  query checkClientName($clientName: String!) {\n    checkClientName(clientName: $clientName)\n  }\n']),_templateObject8=_taggedTemplateLiteral(['\n  query checkClientContactNumber($contactNumber: String!) {\n    checkClientContactNumber(contactNumber: $contactNumber)\n  }\n'],['\n  query checkClientContactNumber($contactNumber: String!) {\n    checkClientContactNumber(contactNumber: $contactNumber)\n  }\n']),_templateObject9=_taggedTemplateLiteral(['\n  query checkClientEmail($email: String!) {\n    checkClientEmail(email: $email)\n  }\n'],['\n  query checkClientEmail($email: String!) {\n    checkClientEmail(email: $email)\n  }\n']),_templateObject10=_taggedTemplateLiteral(['\n  query checkClientPanNumber($pan: String!) {\n    checkClientPanNumber(panNumber: $pan)\n  }\n'],['\n  query checkClientPanNumber($pan: String!) {\n    checkClientPanNumber(panNumber: $pan)\n  }\n']),_templateObject11=_taggedTemplateLiteral(['\n  query checkClientGST($gst: String!) {\n    checkClientGST(GST: $gst)\n  }\n'],['\n  query checkClientGST($gst: String!) {\n    checkClientGST(GST: $gst)\n  }\n']),_templateObject12=_taggedTemplateLiteral(['\n  query getAllSalesPerson($partnerLoginId: Int) {\n    getAllSalesPerson(partnerLoginId: $partnerLoginId) {\n      id\n      name\n    }\n  }\n'],['\n  query getAllSalesPerson($partnerLoginId: Int) {\n    getAllSalesPerson(partnerLoginId: $partnerLoginId) {\n      id\n      name\n    }\n  }\n']),_templateObject13=_taggedTemplateLiteral(['\n  query getGstDetails($gstNumber: String!) {\n    getGstDetails(gstNumber: $gstNumber) {\n      status\n      panNumber\n      companyName\n      address\n      pinCode\n    }\n  }\n'],['\n  query getGstDetails($gstNumber: String!) {\n    getGstDetails(gstNumber: $gstNumber) {\n      status\n      panNumber\n      companyName\n      address\n      pinCode\n    }\n  }\n']),_templateObject14=_taggedTemplateLiteral(['\n  query GetAdminUserDetailsByRole($roleName: [String]) {\n    getAdminUserDetailsByRole(roleName: $roleName) {\n      id\n      role\n      username\n    }\n  }\n'],['\n  query GetAdminUserDetailsByRole($roleName: [String]) {\n    getAdminUserDetailsByRole(roleName: $roleName) {\n      id\n      role\n      username\n    }\n  }\n']),_templateObject15=_taggedTemplateLiteral(['\n  query GetStateDetailsByPincode($pincode: String) {\n    getStateDetailsByPincode(pincode: $pincode) {\n      pincode\n      taluk\n      districtname\n      statename\n    }\n  }\n'],['\n  query GetStateDetailsByPincode($pincode: String) {\n    getStateDetailsByPincode(pincode: $pincode) {\n      pincode\n      taluk\n      districtname\n      statename\n    }\n  }\n']),_templateObject16=_taggedTemplateLiteral(['\n  query GetSapDetails($directCustomerSapCode: String) {\n    getSapDetails(directCustomerSAPCode: $directCustomerSapCode) {\n      customer_name\n      pan_number\n      email_address\n      gstin_number\n      payment_term\n      posting_blk\n      city\n      street5\n      customer_no\n      cust_group3\n      cust_group4\n      distribution_channel\n      street_house_number\n      street2\n      district\n      street3\n      town\n      street4\n      shipping_plant1\n      shipping_plant2\n      customer_group1\n      postal_code\n      region_descr\n      lst_number\n      tax_code\n      bank_key\n      tax_description\n      sales_office\n      sales_group\n      sales_dist\n      sales_dist_desc\n      phone_number1\n      phone_number2\n      customer_group\n      dealer_type\n      appointment_date\n      reappointment_date\n      conversion_date\n      credit_ctrl_area\n      itr_compliance\n      risk_category\n      pan_aadhar_link\n      recovery_status\n      club_type\n      club_type_desc\n      region_code\n      order_blk\n      billing_blk\n      delivery_blk\n      payment_blk\n      attribute1\n      attribute2\n      route_plan\n      route_plan_desc\n      tcs_jtc1\n      sales_organization\n      reconciliation_account\n      attribute4\n      owner_name\n      owner_address\n      parent_customer\n      parent_customer_name\n      customer_plant\n      valid_resale_certificate\n      certificate_type\n      certificate_number\n      certificate_valid_from\n      certificate_valid_to\n      vat_registration_number\n    }\n  }\n'],['\n  query GetSapDetails($directCustomerSapCode: String) {\n    getSapDetails(directCustomerSAPCode: $directCustomerSapCode) {\n      customer_name\n      pan_number\n      email_address\n      gstin_number\n      payment_term\n      posting_blk\n      city\n      street5\n      customer_no\n      cust_group3\n      cust_group4\n      distribution_channel\n      street_house_number\n      street2\n      district\n      street3\n      town\n      street4\n      shipping_plant1\n      shipping_plant2\n      customer_group1\n      postal_code\n      region_descr\n      lst_number\n      tax_code\n      bank_key\n      tax_description\n      sales_office\n      sales_group\n      sales_dist\n      sales_dist_desc\n      phone_number1\n      phone_number2\n      customer_group\n      dealer_type\n      appointment_date\n      reappointment_date\n      conversion_date\n      credit_ctrl_area\n      itr_compliance\n      risk_category\n      pan_aadhar_link\n      recovery_status\n      club_type\n      club_type_desc\n      region_code\n      order_blk\n      billing_blk\n      delivery_blk\n      payment_blk\n      attribute1\n      attribute2\n      route_plan\n      route_plan_desc\n      tcs_jtc1\n      sales_organization\n      reconciliation_account\n      attribute4\n      owner_name\n      owner_address\n      parent_customer\n      parent_customer_name\n      customer_plant\n      valid_resale_certificate\n      certificate_type\n      certificate_number\n      certificate_valid_from\n      certificate_valid_to\n      vat_registration_number\n    }\n  }\n']),_templateObject17=_taggedTemplateLiteral(['\n  query getChannelPartnerDetails($id: ID) {\n    getChannelPartnerDetails(id: $id) {\n      id\n      channel_partner_name\n      channel_partner_type\n      channel_partner_sap_code\n    }\n  }\n'],['\n  query getChannelPartnerDetails($id: ID) {\n    getChannelPartnerDetails(id: $id) {\n      id\n      channel_partner_name\n      channel_partner_type\n      channel_partner_sap_code\n    }\n  }\n']),_templateObject18=_taggedTemplateLiteral(['\n  query Query {\n    getDropDownDetail\n  }\n'],['\n  query Query {\n    getDropDownDetail\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var styles=function styles(theme){var _root;return{root:(_root={padding:theme.spacing.unit*4},_defineProperty(_root,theme.breakpoints.down('sm'),{padding:theme.spacing.unit*2}),_defineProperty(_root,'flexGrow',1),_root),italicizedText:{fontStyle:'italic'}};};var ADD_CLIENTS=Object(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__["a" /* default */])(_templateObject);var GET_ALL_PLANS=Object(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__["a" /* default */])(_templateObject2);var GET_ALL_SOLUTION_TYPE_MASTER=Object(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__["a" /* default */])(_templateObject3);var GET_COUNTRIES=Object(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__["a" /* default */])(_templateObject4);var GET_STATES_FOR_COUNTRY=Object(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__["a" /* default */])(_templateObject5);// username validation
var GET_USERNAME=Object(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__["a" /* default */])(_templateObject6);// Business name validation
var GET_CLIENT_NAME=Object(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__["a" /* default */])(_templateObject7);// Business name validation
var GET_CONTACTNO=Object(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__["a" /* default */])(_templateObject8);// Business email validation
var GET_EMAIL=Object(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__["a" /* default */])(_templateObject9);// Business pan validation
var GET_PAN_NUMBER=Object(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__["a" /* default */])(_templateObject10);// Business gst validation
var GET_GST_NUMBER=Object(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__["a" /* default */])(_templateObject11);var GET_ALL_SALESPERSON=Object(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__["a" /* default */])(_templateObject12);var GET_GST_INFO=Object(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__["a" /* default */])(_templateObject13);var GET_ZM_KAM_SM_CSM_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__["a" /* default */])(_templateObject14);var GET_STATE_DETAILS_BY_PINCODE=Object(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__["a" /* default */])(_templateObject15);var GET_SAP_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__["a" /* default */])(_templateObject16);var GET_CHANNEL_PARTNER_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__["a" /* default */])(_templateObject17);var GET_DROPDOWN_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__["a" /* default */])(_templateObject18);var roleNames=['Key Account Manager(KAM)','Service Manager','State Manager(SM)','Sales Head','Cluster Head','State Head','City Manager','Territory Manager','Operations Manager','Customer Success Manager','Zonal Manager(ZM)'];var SOLUTION_TYPES=[{value:'API',label:'API'},{value:'PORTAL',label:'PORTAL'}];var TYPE_OF_CLIENT=[{value:'REAL',label:'COMMERCIAL'},{value:'DEMO',label:'NON-COMMERCIAL'}];// const CUSTOMER_TYPES = [
//   {
//     value: 'International',
//     label: 'International'
//   },
//   {
//     value: 'Registered',
//     label: 'Registered'
//   },
//   {
//     value: 'Unregistered',
//     label: 'Unregistered'
//   }
// ]
var CUSTOMER_TYPES=[{value:'Paid',label:'Paid'},{value:'POC',label:'POC'},{value:'R&D',label:'R&D'},{value:'Demo',label:'Demo'},{value:'Closed',label:'Closed'}];var CUSTOMER_ACQUISITION_TYPES=[{value:'Direct Customer',label:'Direct Customer'},{value:'Indirect Customer',label:'Indirect Customer'}];var DIRECT_CUSTOMER_TYPE_OPTIONS=[{value:'Fleet',label:'Fleet'},{value:'Mining Customer',label:'Mining Customer'},{value:'Construction Customer',label:'Construction Customer'},{value:'Enterprise Customer',label:'Enterprise Customer'}];var INDIRECT_CUSTOMER_TYPE_OPTIONS=[{value:'System Integrator',label:'System Integrator'},{value:'Telematics Dealer',label:'Telematics Dealer'},{value:'Non Tyre Dealer',label:'Non Tyre Dealer'},{value:'CEAT Tyre Dealer',label:'CEAT Tyre Dealer'},{value:'Non CEAT Tyre Dealer',label:'Non CEAT Tyre Dealer'},{value:'Agent',label:'Agent'}];var ZM_OPTIONS=[];var KAM_OPTIONS=[];var CHANNEL_PARTNER_OPTIONS=[];var ZONE_OPTIONS=[{value:'North',label:'North'},{value:'South',label:'South'},{value:'Central/East',label:'Central/East'},{value:'West',label:'West'}];var CUSTOMER_SUCCESS_MANAGER_OPTIONS=[];var SERVICE_MANAGER_OPTIONS=[];var CUSTOMER_LOCATIONS=[{value:'India',label:'India'},{value:'International',label:'International'}];// const BILLING_MODES = [
//   {
//     value: 1,
//     label: 'PREPAID'
//   },
//   {
//     value: 2,
//     label: 'POSTPAID'
//   }
// ]
var PORTAL_MODES=[{label:'Taabi Pro',value:'taabi_pro'},{label:'Taabi GPS Lite',value:'taabi_gps_lite'}];// const VIDEO_TELEMATICS_TYPE = [
//   { label: "LightMetrics", value: "lightMetrics" },
//   { label: "LocoNav", value: "loconav" },
//   { label: "MettaX", value: "mettax" }
// ]
var VIDEO_TELEMATICS_TYPE=[{label:'None',value:'none'},{label:'iFrame-LM',value:'iframe_lm'},{label:'API-Meta',value:'api_meta'},{label:'API-Loconav',value:'api_loconav'}];var SERVICE_TYPES=[{label:'Portal',value:'portal'},{label:'API',value:'api'}];var RegisterCustomer=function(_Component){_inherits(RegisterCustomer,_Component);function RegisterCustomer(props){var _this2=this;_classCallCheck(this,RegisterCustomer);var _this=_possibleConstructorReturn(this,(RegisterCustomer.__proto__||Object.getPrototypeOf(RegisterCustomer)).call(this,props));_this.fetchDropdownDetails=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var response,dropDownData,dropdownValues;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return _this.props.client.query({query:GET_DROPDOWN_DETAILS});case 3:response=_context.sent;console.log('Raw response:',response);dropDownData=JSON.parse(response.data.getDropDownDetail);console.log('Parsed dropdown data:',dropDownData);dropdownValues={};Object.keys(dropDownData).forEach(function(key){if(Array.isArray(dropDownData[key])){dropdownValues[key]=dropDownData[key].filter(function(option){return option!==null;});}});_this.setState(Object.assign({},dropdownValues));_context.next=15;break;case 12:_context.prev=12;_context.t0=_context['catch'](0);console.error('Error fetching dropdown details:',_context.t0);case 15:case'end':return _context.stop();}}},_callee,_this2,[[0,12]]);}));_this.componentDidMount=function(){_this.getAllSalesPersonDetails();_this.fetchDropdownDetails();_this.getChannelPartnerDetailsNew();_this.getZmKamSmCsmDetails();};_this.getZmKamSmCsmDetails=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_this.props.client.query({query:GET_ZM_KAM_SM_CSM_DETAILS,variables:{roleName:roleNames},fetchPolicy:'network-only'}).then(function(response){var data=response.data;if(data&&data.getAdminUserDetailsByRole){var zonalManagers=data.getAdminUserDetailsByRole.filter(function(user){return user.role==='Zonal Manager(ZM)';}).map(function(user){return{id:user.id,value:user.id,label:user.username};});var stateManagers=data.getAdminUserDetailsByRole.filter(function(user){return user.role==='State Manager(SM)';}).map(function(user){return{id:user.id,value:user.id,label:user.username};});var territoryManagers=data.getAdminUserDetailsByRole.filter(function(user){return user.role==='Territory Manager';}).map(function(user){return{id:user.id,value:user.id,label:user.username};});var salesHeads=data.getAdminUserDetailsByRole.filter(function(user){return user.role==='Sales Head';}).map(function(user){return{id:user.id,value:user.id,label:user.username};});var clusterHeads=data.getAdminUserDetailsByRole.filter(function(user){return user.role==='Cluster Head';}).map(function(user){return{id:user.id,value:user.id,label:user.username};});var stateHeads=data.getAdminUserDetailsByRole.filter(function(user){return user.role==='State Head';}).map(function(user){return{id:user.id,value:user.id,label:user.username};});var cityManagers=data.getAdminUserDetailsByRole.filter(function(user){return user.role==='City Manager';}).map(function(user){return{id:user.id,value:user.id,label:user.username};});var operationsManagers=data.getAdminUserDetailsByRole.filter(function(user){return user.role==='Operations Manager';}).map(function(user){return{id:user.id,value:user.id,label:user.username};});var keyAccountManagers=data.getAdminUserDetailsByRole.filter(function(user){return user.role==='Key Account Manager(KAM)';}).map(function(user){return{id:user.id,value:user.id,label:user.username};});var serviceManagers=data.getAdminUserDetailsByRole.filter(function(user){return user.role==='Service Manager';}).map(function(user){return{id:user.id,value:user.id,label:user.username};});var customerSuccessManagers=data.getAdminUserDetailsByRole.filter(function(user){return user.role==='Customer Success Manager';}).map(function(user){return{id:user.id,value:user.id,label:user.username};});_this.setState({zonalManagers:zonalManagers,stateManagers:stateManagers,territoryManagers:territoryManagers,salesHeads:salesHeads,clusterHeads:clusterHeads,stateHeads:stateHeads,cityManagers:cityManagers,operationsManagers:operationsManagers,keyAccountManagers:keyAccountManagers,serviceManagers:serviceManagers,customerSuccessManagers:customerSuccessManagers});}}).catch(function(error){console.error('Error fetching ZM, KAM, SM, CSM details:',error);});case 1:case'end':return _context2.stop();}}},_callee2,_this2);}));_this.handleInputChange=function(key){return function(e){var _e$target=e.target,name=_e$target.name,value=_e$target.value;_this.setState(_defineProperty({},name,value));};};_this.handleInputChangeIndirectCustomerName=function(key){return function(e){var _this$setState2;var _e$target2=e.target,name=_e$target2.name,value=_e$target2.value;_this.setState((_this$setState2={},_defineProperty(_this$setState2,name,value),_defineProperty(_this$setState2,'customerNameToBeDisplayed',value),_this$setState2));};};_this.handleInputChangeUsernamePassword=function(e){var regExValue=new RegExp(/^[0-9a-zA-Z]+$/);// const { value } = e.target
// console.log('input value', value)
// console.log(this.state.country)
_this.setState(_defineProperty({},e.target.name,e.target.value));};_this.handleCheckboxChange=function(e){var name=e.target.name;_this.setState(function(prev){return{isChecked:!prev.isChecked};});};_this.handleToggle=function(){_this.setState(function(prevState){return{showFields:!prevState.showFields};});};_this.handleModeChange=function(selectedOption){_this.setState({selectedMode:selectedOption});};_this.handleVideoTelematicsMenuChange=function(selectedOption){_this.setState({selectedVTM:selectedOption?selectedOption.value:''});};_this.handleServiceTypeChange=function(selectedOption){_this.setState({selectedServiceType:selectedOption?selectedOption.value:''});};_this.handleZMChange=function(selectedOption){_this.setState({selectedZM:selectedOption});};_this.handleSMChange=function(selectedOption){_this.setState({selectedSM:selectedOption});};_this.handleKAMChange=function(selectedOption){_this.setState({selectedKAM:selectedOption});};_this.handleStateManagerChange=function(selectedOption){_this.setState({selectedStateManager:selectedOption});};_this.handleTerritoryManagerChange=function(selectedOption){_this.setState({selectedTerritoryManager:selectedOption});};_this.handleSalesHeadChange=function(selectedOption){_this.setState({selectedSalesHead:selectedOption});};_this.handleClusterHeadChange=function(selectedOption){_this.setState({selectedClusterHead:selectedOption});};_this.handleStateHeadChange=function(selectedOption){_this.setState({selectedStateHead:selectedOption});};_this.handleCityManagerChange=function(selectedOption){_this.setState({selectedCityManager:selectedOption});};_this.handleOperationsManagerChange=function(selectedOption){_this.setState({selectedOperationsManager:selectedOption});};_this.handleZoneChange=function(selectedOption){_this.setState({zone:selectedOption});};_this.handleServiceManagerChange=function(selectedOption){_this.setState({serviceManager:selectedOption});};_this.handleCustomerSuccessManagerChange=function(selectedOption){_this.setState({customerSuccessManager:selectedOption});};_this.handleChannelPartnerNameChange=function(event){_this.setState({channelPartnerName:event.target.value});};_this.handleProrataCheckboxChange=function(e){_this.state.prorata?_this.setState({prorata:0}):_this.setState({prorata:1});};_this.setProrata=function(e){_this.setState({minimumTrackedDays:1,packetThreshold:1});};_this.handleShipping=function(e){_this.state.shippingmode?_this.setState({shippingmode:false}):_this.setState({shippingmode:true});// this.setState(prev => ({ shipping: !prev.shipping }))
_this.state.shippingmode?_this.setState({shippingCountry:''}):_this.setState({shippingCountry:_this.state.country});_this.state.shippingmode?_this.setState({shippingState:''}):_this.setState({shippingState:_this.state.state});_this.state.shippingmode?_this.setState({shippingAddress:''}):_this.setState({shippingAddress:_this.state.address});_this.state.shippingmode?_this.setState({shippingPincode:''}):_this.setState({shippingPincode:_this.state.pincode});_this.state.shippingmode?_this.setState({shippingCity:''}):_this.setState({shippingCity:_this.state.city});};_this.handleSimTracking=function(e){_this.state.is_sim_tracking?_this.setState({is_sim_tracking:false}):_this.setState({is_sim_tracking:true});};_this.handleProrata=function(e){var _this$setState4;_this.setState((_this$setState4={},_defineProperty(_this$setState4,e.target.name,e.target.value),_defineProperty(_this$setState4,'isStateChanged',true),_this$setState4));};_this.handleSolutionChange=function(solutionType){// console.log('solution:', solutionType)
if(!solutionType){_this.setState({solution:''});}else{_this.setState({solution:solutionType.value});}};_this.handleCustomerTypeChange=function(customer){// console.log('Customer', customer)
if(!customer){_this.setState({customerType:''});}else{_this.setState({customerType:customer.value,isGSTExists:null,isGSTValid:true,gst:'',panNumber:'',address:'',pincode:'',gstCompanyName:'',clientNameRes:'',isNameValid:true,isAddressValid:true,isPinValid:true});}};_this.handleCustomerAcquisitionTypeChange=function(selectedOption){_this.setState({customerAcquisitionType:selectedOption?selectedOption.value:''});if(_this.state.customerAcquisitionType=='Direct Customer'){_this.setState({indirectCustomerType:null,indirectCustomerName:null,channelPartnerName:null,channelPartnerSAPCode:null,channelPartnerType:null});}else if(_this.state.customerAcquisitionType=='Indirect Customer'){_this.setState({directCustomerType:null,directCustomer:null,directCustomerSAPCode:null});}};_this.handleClientType=function(clientType){if(!clientType){_this.setState({typeOfClient:''});}else{_this.setState({typeOfClient:clientType.value});}};_this.hanldeBillingModeChange=function(billingMode){if(!billingMode){_this.setState({billingMode:''});}else{_this.setState({billingMode:billingMode.value});}};_this.getAllSalesPersonDetails=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var fetchSalesPersonData,getAllSalesPerson,salesPersonsDetails;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return _this.props.client.query({query:GET_ALL_SALESPERSON,variables:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_20__utils_getLoginId__["a" /* default */])()}});case 2:fetchSalesPersonData=_context3.sent;getAllSalesPerson=fetchSalesPersonData.data.getAllSalesPerson;salesPersonsDetails=getAllSalesPerson.map(function(salesPerson){return{value:salesPerson.id,label:salesPerson.name};});_this.setState({allSalesPerson:salesPersonsDetails});case 6:case'end':return _context3.stop();}}},_callee3,_this2);}));_this.handleSalesPersonChange=function(salesPerson){// console.log('salesPerson', salesPerson)
if(!salesPerson){_this.setState({salesPerson:''});}else{_this.setState({salesPerson:salesPerson.value});}};_this.handleDateTimeChange=function(date){return _this.setState({expiryDateTime:date});};_this.handleCountryChange=function(c){if(!c){_this.setState({country:''});}else{_this.setState({country:c.value});_this.state.shipping&&_this.setState({shippingCountry:c.value});}};_this.handleSecondaryCountryChange=function(c){if(!c){_this.setState({shippingCountry:''});}else{_this.setState({shippingCountry:c.value});}};_this.handlePlanChange=function(selectedOption){_this.setState({selectedPlan:selectedOption,planId:selectedOption?selectedOption.value:null});};_this.handleTimezoneChange=function(timezone){if(!timezone){_this.setState({timezone:''});}else{_this.setState({timezone:timezone});}};_this.handleStateChange=function(state){_this.setState({state:state});};_this.handleStateChangeTwo=function(state){_this.setState({shippingState:state});};_this.checkNameValidity=function(client){return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(event){var customerNameToBeDisplayed,regex,isValidFormat,isNameAvailable,_ref5,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:console.log('inside checkName');customerNameToBeDisplayed=_this.state.customerNameToBeDisplayed;regex=new RegExp(// /^(?!\s)(?!.*\s$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9 '~?!]{5,100}$/
/^(?!\s)(?!.*\s$).{5,100}$/);isValidFormat=regex.test(_this.state.customerAcquisitionType==='Direct Customer'?_this.state.customerNameToBeDisplayed||(_this.state.directCustomer?_this.state.directCustomer.label:''):_this.state.customerAcquisitionType==='Indirect Customer'?_this.state.customerNameToBeDisplayed||_this.state.indirectCustomerName:_this.state.customerNameToBeDisplayed||'')&&(_this.state.customerAcquisitionType==='Direct Customer'?_this.state.customerNameToBeDisplayed||(_this.state.directCustomer?_this.state.directCustomer.label:''):_this.state.customerAcquisitionType==='Indirect Customer'?_this.state.customerNameToBeDisplayed||_this.state.indirectCustomerName:_this.state.customerNameToBeDisplayed||'')!=='';isNameAvailable=false;console.log('isNameAvailable: ',isNameAvailable);_context4.prev=6;_context4.next=9;return client.query({query:GET_CLIENT_NAME,variables:{clientName:_this.state.customerAcquisitionType==='Direct Customer'?_this.state.customerNameToBeDisplayed||(_this.state.directCustomer?_this.state.directCustomer.label:''):_this.state.customerAcquisitionType==='Indirect Customer'?_this.state.customerNameToBeDisplayed||_this.state.indirectCustomerName:_this.state.customerNameToBeDisplayed||''}});case 9:_ref5=_context4.sent;data=_ref5.data;isNameAvailable=data.checkClientName==='AVAILABLE';_context4.next=18;break;case 14:_context4.prev=14;_context4.t0=_context4['catch'](6);console.error('Error checking name availability',_context4.t0);isNameAvailable=false;case 18:console.log('isNameAvailable after checking: ',isNameAvailable);console.log('isValidFormat && isNameAvailable :',isValidFormat&&isNameAvailable);_this.setState({isNameValid:isValidFormat&&isNameAvailable,clientNameRes:(_this.state.customerAcquisitionType==='Direct Customer'?_this.state.customerNameToBeDisplayed||(_this.state.directCustomer?_this.state.directCustomer.label:''):_this.state.customerAcquisitionType==='Indirect Customer'?_this.state.customerNameToBeDisplayed||_this.state.indirectCustomerName:_this.state.customerNameToBeDisplayed||'').length===0?'Please enter the name':!isValidFormat?'Name must be at least 5 characters long and not contain spaces at beginning or end':!isNameAvailable?'Name already exists':''});case 21:case'end':return _context4.stop();}}},_callee4,_this2,[[6,14]]);}));return function(_x){return _ref4.apply(this,arguments);};}();};_this.checkUsernameValidity=function(client){return function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(event){var regex,_ref7,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:regex=new RegExp(/^[a-zA-Z0-9.\-_$@*!]{5,32}$/);_context5.next=3;return client.query({query:GET_USERNAME,variables:{username:_this.state.username}});case 3:_ref7=_context5.sent;data=_ref7.data;_this.setState({isUsernameUnique:data.checkUsername==='AVAILABLE',isUsernameValid:regex.test(_this.state.username)&&_this.state.username!==''&&data.checkUsername==='AVAILABLE'});if(regex.test(_this.state.username)===false){_this.setState({usernameRes:'Username Can be character number special chatcters(-_$@*!) without blank space between 5-32 charcters',isUsernameValid:false});}else if(data.checkUsername!=='AVAILABLE'){_this.setState({usernameRes:'Username already exist',isUsernameValid:false});}case 7:case'end':return _context5.stop();}}},_callee5,_this2);}));return function(_x2){return _ref6.apply(this,arguments);};}();};_this.checkContactpValidity=function(){var regex=new RegExp(/^[a-zA-Z\s]{3,32}$/);_this.setState({isContactpValid1:regex.test(_this.state.contactPerson)});};_this.checkContactpValidityTwo=function(){var regex=new RegExp(/^[a-zA-Z\s]{3,32}$/);_this.setState({isContactpValid2:regex.test(_this.state.secondaryContactName)});};_this.checkPasswordValidity=function(){// const regex = new RegExp(/^[a-zA-Z0-9.\-_$@*!#]{3,20}$/)
var regex=new RegExp(/^[a-zA-Z0-9!@#$&()\\-`.+,/"]{3,20}$/);_this.setState({isPasswordValid:_this.state.password!==''&&regex.test(_this.state.password)});};_this.checkPhonenoValidity1=function(client){return function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(event){var regex,_ref9,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:regex=new RegExp(/^(\+91[-\s]?)?[0]?(91)?[1-9]\d{8,19}$/);_context6.next=3;return client.query({query:GET_CONTACTNO,variables:{contactNumber:_this.state.contactNumber}});case 3:_ref9=_context6.sent;data=_ref9.data;_this.setState({isPhoneExists:data.checkClientContactNumber==='AVAILABLE',isPhonenoValid1:regex.test(_this.state.contactNumber)});if(_this.state.contactNumber===_this.state.secondaryContactNumber){_this.setState({phonenoRes2:'Secondary Contact Number should not be the same as Primary Contact Number',isPhonenoValid2:false});}case 7:case'end':return _context6.stop();}}},_callee6,_this2);}));return function(_x3){return _ref8.apply(this,arguments);};}();};_this.checkPhonenoValidity2=function(client){return function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(event){var regex;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:regex=new RegExp(/^(\+91[-\s]?)?[0]?(91)?[1-9]\d{8,19}$/);if(_this.state.secondaryContactNumber!==''){_this.setState({isPhonenoValid2:regex.test(_this.state.secondaryContactNumber)});if(regex.test(_this.state.secondaryContactNumber)===false){_this.setState({phonenoRes2:'Invalid phone number'});}if(_this.state.secondaryContactNumber===_this.state.contactNumber){_this.setState({phonenoRes2:'Secondary Contact Number should not be the same as Primary Contact Number',isPhonenoValid2:false});}}else{_this.setState({phonenoRes2:'Invalid phone number',isPhonenoValid2:false});}case 2:case'end':return _context7.stop();}}},_callee7,_this2);}));return function(_x4){return _ref10.apply(this,arguments);};}();};_this.checkLandlineValidity=function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(event,fieldName){var regex,landlineNumber,isValid;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:regex=new RegExp(/^\(?\d{3,4}\)?[-\s]?\d{6,8}$/);landlineNumber=_this.state[fieldName];if(landlineNumber!==''){isValid=regex.test(landlineNumber);_this.setState(_defineProperty({},fieldName+'Valid',isValid));if(!isValid){_this.setState(_defineProperty({},fieldName+'Error','Invalid landline number'));}else{_this.setState(_defineProperty({},fieldName+'Error',''));}}case 3:case'end':return _context8.stop();}}},_callee8,_this2);}));return function(_x5,_x6){return _ref11.apply(this,arguments);};}();_this.checkEmailValidity1=function(client){return function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(event){var regex,_ref13,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:regex=new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);_context9.next=3;return client.query({query:GET_EMAIL,variables:{email:_this.state.email}});case 3:_ref13=_context9.sent;data=_ref13.data;_this.setState({isEmailExists:data.checkClientEmail==='AVAILABLE',isEmailValid1:regex.test(_this.state.email)});if(_this.state.email===_this.state.secondaryEmail){_this.setState({emailRes2:'Secondary Email should not be the same as Primary Email',isEmailValid2:false});}case 7:case'end':return _context9.stop();}}},_callee9,_this2);}));return function(_x7){return _ref12.apply(this,arguments);};}();};_this.checkEmailValidity2=function(client){return function(){var _ref14=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(event){var regex;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:regex=new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);if(_this.state.secondaryEmail!==''){_this.setState({isEmailValid2:regex.test(_this.state.secondaryEmail)});if(regex.test(_this.state.secondaryEmail)===false){_this.setState({emailRes2:'Invalid Email'});}if(_this.state.secondaryEmail===_this.state.email){_this.setState({emailRes2:'Secondary Email should not be the same as Primary Email',isEmailValid2:false});}}else{_this.setState({emailRes2:'Invalid email',isEmailValid2:false});}case 2:case'end':return _context10.stop();}}},_callee10,_this2);}));return function(_x8){return _ref14.apply(this,arguments);};}();};_this.checkAddressValidity=function(){// const regex = new RegExp(/^[a-zA-Z0-9\s,.'-]{3,300}$/)
var regex=new RegExp(/^(.{5,200})$/);var regex2=new RegExp(/^[^\s]+(\s+[^\s]+)*$/);_this.setState({isAddressValid:regex.test(_this.state.address)&&regex2.test(_this.state.address)});};_this.checkShippingAddressValidity=function(){// const regex = new RegExp(/^[a-zA-Z0-9\s,.'-]{3,300}$/)
var regex=new RegExp(/^(.{5,200})$/);var regex2=new RegExp(/^[^\s]+(\s+[^\s]+)*$/);_this.setState({isShippingAddressValid:regex.test(_this.state.shippingAddress)&&regex2.test(_this.state.shippingAddress)});};_this.checkCountryValidity=function(){_this.setState({isCountryValid:_this.state.country!==''});};_this.checkCountryValidity2=function(){_this.setState({isCountryValid:_this.state.shippingCountry!==''});};_this.checkCityValidity=function(arg){var regex=new RegExp(/^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/);if(arg==='billing'){_this.setState({isCityValid:regex.test(_this.state.city)&&_this.state.city!==''});}else if(arg==='shipping'){_this.setState({isShippingCityValid:regex.test(_this.state.shippingCity)&&_this.state.city!==''});}};_this.checkPinValidity=function(){_this.setState({isPinValid:true});if(_this.state.pincode!==null&&_this.state.pincode!==''){var regex=new RegExp(/^[1-9][0-9]{5}$/);_this.setState({isPinValid:regex.test(_this.state.pincode)});}};_this.checkPinValidity2=function(){_this.setState({isShippingPinvalid:true});if(_this.state.shippingPincode!==null&&_this.state.shippingPincode!==''){var regex=new RegExp(/^[1-9][0-9]{5}$/);_this.setState({isShippingPinvalid:regex.test(_this.state.shippingPincode)});}};_this.checkPanValidity=function(client){return function(){var _ref15=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(event){var regex,_ref16,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:// console.log(this.state.pan, 'pan')
_this.setState({panNoRes:''});if(!(_this.state.pan!==null&&_this.state.pan!=='')){_context11.next=8;break;}regex=new RegExp(/([A-Z]){5}([0-9]){4}([A-Z]){1}$/);_context11.next=5;return client.query({query:GET_PAN_NUMBER,variables:{pan:_this.state.pan}});case 5:_ref16=_context11.sent;data=_ref16.data;_this.setState({isPanValid:regex.test(_this.state.pan),isPanExists:data.checkClientPanNumber==='AVAILABLE'});case 8:case'end':return _context11.stop();}}},_callee11,_this2);}));return function(_x9){return _ref15.apply(this,arguments);};}();};_this.checkGSTValidity=function(){var _ref17=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(gstNumber){var regex,_ref18,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:if(!(_this.state.gst!==null&&_this.state.gst!=='')){_context12.next=19;break;}// const regex = new RegExp(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9]{1}Z[a-zA-Z0-9]{1}$/)
regex=new RegExp(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/);_context12.next=4;return _this.props.client.query({query:GET_GST_NUMBER,variables:{gst:_this.state.gst},fetchPolicy:'network-only'});case 4:_ref18=_context12.sent;data=_ref18.data;_this.setState({isGSTExists:data.checkClientGST==='AVAILABLE',isGSTValid:regex.test(_this.state.gst)});if(!_this.state.isGSTValid){_this.setState({gstErrorFieldText:'Invalid GST Number.'});}if(_this.state.isGSTExists==false){_this.setState({gstErrorFieldText:'GST Number already registered.'});}if(!(_this.state.isGSTValid&&_this.state.isGSTExists)){_context12.next=16;break;}_this.setState({gstErrorFieldText:'',panNumber:'',gstCompanyName:'',address:'',pincode:''});_context12.next=13;return _this.getGstInfo(gstNumber);case 13:if(!_this.state.isGstInfoAvailable){_this.setState({gstErrorFieldText:'Invalid GST Number.'});}_context12.next=17;break;case 16:_this.setState({panNumber:'',gstCompanyName:'',address:'',pincode:''});case 17:_context12.next=20;break;case 19:_this.setState({panNumber:'',gstCompanyName:'',address:'',pincode:''});case 20:case'end':return _context12.stop();}}},_callee12,_this2);}));return function(_x10){return _ref17.apply(this,arguments);};}();_this.handleCancelClick=function(e){_this.setState({isCancelConfDialogOpen:true});};_this.handleBackCancelClick=function(e){if(// this.state.name === '' &&
_this.state.username===''&&_this.state.clientName===''&&_this.state.contactPerson===''&&_this.state.secondaryContactName===''&&_this.state.password===''&&_this.state.email===''&&_this.state.secondaryEmail===''&&_this.state.contactNumber===''&&_this.state.landlineNumber===''&&_this.state.secondaryContactNumber===''&&_this.state.secondaryLandlineNumber===''&&_this.state.address===''&&// this.state.address2 === '' &&
_this.state.shippingAddress===''&&_this.state.shippingAddress2===''&&_this.state.shippingCity==''&&_this.shippingCountry==''&&_this.shippingState==''&&_this.state.shippingPincode==''&&_this.state.city===''&&_this.state.state===''&&_this.state.country===''&&_this.state.countryTwo===''&&_this.state.plan===''&&_this.state.timezone===''&&_this.state.solution===''&&_this.state.pincode===''&&_this.state.pan===''&&_this.state.gst===''&&_this.state.minimumTrackedDays===''&&_this.state.prorata===''&&_this.state.addressEffectiveDate==''){_this.cancelForm();}else{_this.setState({isCancelConfDialogOpen:true});}};_this.handleSaveClick=function(){var _ref19=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(e){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:_context13.next=2;return _this.props.client.mutate({mutation:ADD_CLIENTS,// variables:{
// },
errorPolicy:'all',refetchQueries:['allClientDetails']});case 2:response=_context13.sent;_this.setState({isSaveConfDialogOpen:true});case 4:case'end':return _context13.stop();}}},_callee13,_this2);}));return function(_x11){return _ref19.apply(this,arguments);};}();_this.handleCancelNegativeResponse=function(e){_this.setState({isCancelConfDialogOpen:false});};_this.handleSaveNegativeResponse=function(e){_this.setState({isSaveConfDialogOpen:false});};_this.handleSecondaryContactAvailable=function(e){_this.state.isSecondaryContact?_this.setState({isSecondaryContact:false,isAdditionalContact:false,additionalContactNumbers:'',isAdditionalContactValid:true,additionalContactError:''}):_this.setState({isSecondaryContact:true});};_this.handleAdditionalContactAvailable=function(){_this.setState(function(prev){return{isAdditionalContact:!prev.isAdditionalContact};});};_this.handleAdditionalContactChange=function(e){var value=e.target.value;_this.setState({additionalContactNumbers:value,isAdditionalContactValid:true,additionalContactError:''});};_this.checkAdditionalContactValidity=function(){var _this$state=_this.state,additionalContactNumbers=_this$state.additionalContactNumbers,contactNumber=_this$state.contactNumber,secondaryContactNumber=_this$state.secondaryContactNumber;if(!additionalContactNumbers.trim()){_this.setState({isAdditionalContactValid:true,additionalContactError:''});return;}var numbers=additionalContactNumbers.split(',').map(function(num){return num.trim();});var regex=/^(\+91[-\s]?)?[0]?(91)?[1-9]\d{8,19}$/;// Check for invalid format
var invalidNumbers=numbers.filter(function(num){return!regex.test(num);});if(invalidNumbers.length>0){_this.setState({isAdditionalContactValid:false,additionalContactError:'Invalid phone number(s): '+invalidNumbers.join(', ')});return;}// Check for duplicates with primary or secondary numbers
var primaryNumber=contactNumber.replace(/[^0-9]/g,'');var secondaryNumber=secondaryContactNumber?secondaryContactNumber.replace(/[^0-9]/g,''):'';var duplicateNumbers=numbers.filter(function(num){var cleanNum=num.replace(/[^0-9]/g,'');return cleanNum===primaryNumber||cleanNum===secondaryNumber;});if(duplicateNumbers.length>0){_this.setState({isAdditionalContactValid:false,additionalContactError:'Cannot use primary/secondary number: '+duplicateNumbers.join(', ')});}else{_this.setState({isAdditionalContactValid:true,additionalContactError:''});}};_this.submitForm=function(){var _ref20=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(e){var variables,_ref21,data,errors;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:variables=void 0;e.preventDefault();// const planId = this.state.plan
// const kmZamorChannelPartner = {}
// if(this.state.channelPartnerName && this.state.showFields){
//   kmZamorChannelPartner.channelPartnerName=this.state.channelPartnerName,
//   kmZamorChannelPartner.zonalManager="",
//   kmZamorChannelPartner.keyAccountManager=""
// }else{
//   kmZamorChannelPartner.zonalManager=this.state.selectedZM.value,
//   kmZamorChannelPartner.keyAccountManager = this.state.selectedKAM.value,
//   kmZamorChannelPartner.channelPartnerName=""
// }
if(_this.state.customerType=='Registered'){variables={username:_this.state.username,password:_this.state.password,accountType:'CLT',// clientName: this.state.clientName,
// clientName: this.state.gstCompanyName,
clientName:_this.state.customerNameToBeDisplayed||(_this.state.customerAcquisitionType=='Direct Customer'&&_this.state.directCustomer?_this.state.directCustomer.label:_this.state.customerAcquisitionType=='Indirect Customer'?_this.state.indirectCustomerName:null),email:_this.state.email,secondaryEmail:_this.state.secondaryEmail,contactPerson:_this.state.contactPerson,secondaryContactName:_this.state.secondaryContactName,contactNumber:_this.state.contactNumber,landlineNumber:_this.state.landlineNumber,secondaryContactNumber:_this.state.secondaryContactNumber,secondaryLandlineNumber:_this.state.secondaryLandlineNumber,// address: this.state.address,
address:_this.state.address,city:_this.state.city,state:parseInt(_this.state.stateId,10),country:_this.state.country&&_this.state.country.value?parseInt(_this.state.country.value,10):99,shippingCountry:parseInt(_this.state.shippingCountry,10),shippingState:parseInt(_this.state.shippingState.value,10),// countryTwo: parseInt(this.state.countryTwo, 10),
// pincode: parseInt(this.state.pincode, 10),
pincode:parseInt(_this.state.pincode,10),// panNumber: this.state.pan,
panNumber:_this.state.panNumber,// shippingAddress:
//   this.state.shippingAddress + ' ' + this.state.shippingAddress2,
shippingAddress:_this.state.shippingAddress+' ',shippingCity:_this.state.shippingCity,shippingPincode:parseInt(_this.state.shippingPincode,10),minimumTrackedDays:parseInt(_this.state.minimumTrackedDays,10),packetThreshold:parseInt(_this.state.packetThreshold,10),prorata:_this.state.prorata,addressEffectiveDate:_this.state.addressEffectiveDate,partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_20__utils_getLoginId__["a" /* default */])(),clientType:'Live',// subscriptionPlan: 'prepaid',
// periodicity: 1,
planId:parseInt(_this.state.planId,10),timezone:_this.state.timezone?_this.state.timezone.value||_this.state.timezone:'',gst:_this.state.gst,typeOfClient:_this.state.typeOfClient,registrationType:_this.state.customerType,customerAcquisitionType:_this.state.customerAcquisitionType,directCustomer:_this.state.directCustomer.label,directCustomerType:_this.state.directCustomerType,directCustomerSAPCode:_this.state.directCustomer.value,indirectCustomerType:_this.state.indirectCustomerType,channelPartnerType:_this.state.channelPartnerType,indirectCustomerName:_this.state.indirectCustomerName,customerLocation:_this.state.customerLocation?_this.state.customerLocation.value||_this.state.customerLocation:'',customerAddress:_this.state.customerAddress,solution:_this.state.solution,billingMode:parseInt(_this.state.billingMode,10),salesPersonId:_this.state.salesPerson,zonalManager:_this.state.selectedZM&&_this.state.selectedZM.value?_this.state.selectedZM.value:'',stateManager:_this.state.selectedSM&&_this.state.selectedSM.value?_this.state.selectedSM.value:'',keyAccountManager:_this.state.selectedKAM&&_this.state.selectedKAM.value?_this.state.selectedKAM.value:'',territoryManager:_this.state.selectedTerritoryManager?_this.state.selectedTerritoryManager.value:null,salesHead:_this.state.selectedSalesHead?_this.state.selectedSalesHead.value:null,clusterHead:_this.state.selectedClusterHead?_this.state.selectedClusterHead.value:null,stateHead:_this.state.selectedStateHead?_this.state.selectedStateHead.value:null,cityManager:_this.state.selectedCityManager?_this.state.selectedCityManager.value:null,operationsManager:_this.state.selectedOperationsManager?_this.state.selectedOperationsManager.value:null,zone:_this.state.zone||'',serviceManager:_this.state.serviceManager||'',customerSuccessManager:_this.state.customerSuccessManager||'',planType:_this.state.selectedPlan&&_this.state.selectedPlan.label?_this.state.selectedPlan.label:null,// solutionId: this.state.selectedSolutionMaster && this.state.selectedSolutionMaster.value ? this.state.selectedSolutionMaster.value : null,
videoTelematicsType:_this.state.selectedVTM==='none'?null:_this.state.selectedVTM,serviceType:_this.state.selectedServiceType,// channelPartnerName: this.state.showFields
//   ? this.state.channelPartnerName
//   : null,
// channelPartnerName: this.state.channelPartnerName,
channelPartnerName:_this.state.channelPartnerName||null,channelPartnerSAPCode:_this.state.channelPartnerSAPCode||null,litemode:_this.state.selectedMode&&_this.state.selectedMode.value?Object(__WEBPACK_IMPORTED_MODULE_32__utils_conertSnakeFormat__["a" /* default */])(_this.state.selectedMode.value):null,customerNameToBeDisplayed:_this.state.customerNameToBeDisplayed||(_this.state.customerAcquisitionType=='Direct Customer'&&_this.state.directCustomer?_this.state.directCustomer.label:_this.state.customerAcquisitionType=='Indirect Customer'?_this.state.indirectCustomerName:null),totalPotentialVehicles:parseInt(_this.state.totalPotentialVehicles),is_sim_tracking:_this.state.is_sim_tracking,clientCategory:_this.state.clientCategory,isSecondaryContact:_this.state.isSecondaryContact,additionalContactNumbers:_this.state.additionalContactNumbers};}else{variables={username:_this.state.username,password:_this.state.password,accountType:'CLT',// clientName: this.state.clientName,
clientName:_this.state.customerNameToBeDisplayed,email:_this.state.email,secondaryEmail:_this.state.secondaryEmail,contactPerson:_this.state.contactPerson,secondaryContactName:_this.state.secondaryContactName,contactNumber:_this.state.contactNumber,landlineNumber:_this.state.landlineNumber,secondaryContactNumber:_this.state.secondaryContactNumber,secondaryLandlineNumber:_this.state.secondaryLandlineNumber,// address: this.state.address,
address:_this.state.address,city:_this.state.city,state:parseInt(_this.state.stateId,10),country:_this.state.country&&_this.state.country.value?parseInt(_this.state.country.value,10):99,shippingCountry:parseInt(_this.state.shippingCountry,10),shippingState:parseInt(_this.state.shippingState.value,10),// countryTwo: parseInt(this.state.countryTwo, 10),
// pincode: parseInt(this.state.pincode, 10),
pincode:parseInt(_this.state.pincode,10),// panNumber: this.state.pan,
// panNumber: this.state.panNumber,
// shippingAddress:
//   this.state.shippingAddress + ' ' + this.state.shippingAddress2,
shippingAddress:_this.state.shippingAddress+' ',shippingCity:_this.state.shippingCity,shippingPincode:parseInt(_this.state.shippingPincode,10),minimumTrackedDays:parseInt(_this.state.minimumTrackedDays,10),packetThreshold:parseInt(_this.state.packetThreshold,10),prorata:_this.state.prorata,addressEffectiveDate:_this.state.addressEffectiveDate,partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_20__utils_getLoginId__["a" /* default */])(),clientType:'Live',subscriptionPlan:'prepaid',// periodicity: 1,
planId:parseInt(_this.state.planId,10),timezone:_this.state.timezone?_this.state.timezone.value||_this.state.timezone:'',gst:_this.state.gst,typeOfClient:_this.state.typeOfClient,registrationType:_this.state.customerType,customerAcquisitionType:_this.state.customerAcquisitionType,directCustomer:_this.state.directCustomer?_this.state.directCustomer.label:null,directCustomerType:_this.state.directCustomerType,directCustomerSAPCode:_this.state.directCustomer?_this.state.directCustomer.value:null,indirectCustomerType:_this.state.indirectCustomerType,channelPartnerType:_this.state.channelPartnerType,indirectCustomerName:_this.state.indirectCustomerName,customerLocation:_this.state.customerLocation?_this.state.customerLocation.value||_this.state.customerLocation:'',customerAddress:_this.state.customerAddress,solution:_this.state.solution,billingMode:parseInt(_this.state.billingMode,10),salesPersonId:_this.state.salesPerson,zonalManager:_this.state.selectedZM&&_this.state.selectedZM.value?_this.state.selectedZM.value:'',stateManager:_this.state.selectedSM&&_this.state.selectedSM.value?_this.state.selectedSM.value:'',keyAccountManager:_this.state.selectedKAM&&_this.state.selectedKAM.value?_this.state.selectedKAM.value:'',territoryManager:_this.state.selectedTerritoryManager?_this.state.selectedTerritoryManager.value:null,salesHead:_this.state.selectedSalesHead?_this.state.selectedSalesHead.value:null,clusterHead:_this.state.selectedClusterHead?_this.state.selectedClusterHead.value:null,stateHead:_this.state.selectedStateHead?_this.state.selectedStateHead.value:null,cityManager:_this.state.selectedCityManager?_this.state.selectedCityManager.value:null,operationsManager:_this.state.selectedOperationsManager?_this.state.selectedOperationsManager.value:null,zone:_this.state.zone||'',serviceManager:_this.state.serviceManager||'',customerSuccessManager:_this.state.customerSuccessManager||'',planType:_this.state.selectedPlan&&_this.state.selectedPlan.label?_this.state.selectedPlan.label:null,// solutionId: this.state.selectedSolutionMaster && this.state.selectedSolutionMaster.value ? this.state.selectedSolutionMaster.value : null,
// videoTelematicsType:this.state.selectedVTM && this.state.selectedVTM.value?this.state.selectedVTM.value:null,
videoTelematicsType:_this.state.selectedVTM==='none'?null:_this.state.selectedVTM,serviceType:_this.state.selectedServiceType,channelPartnerName:_this.state.channelPartnerName,channelPartnerSAPCode:_this.state.channelPartnerSAPCode||null,litemode:_this.state.selectedMode&&_this.state.selectedMode.value?Object(__WEBPACK_IMPORTED_MODULE_32__utils_conertSnakeFormat__["a" /* default */])(_this.state.selectedMode.value):null,customerNameToBeDisplayed:_this.state.customerNameToBeDisplayed,totalPotentialVehicles:parseInt(_this.state.totalPotentialVehicles),is_sim_tracking:_this.state.is_sim_tracking,clientCategory:_this.state.clientCategory,additionalContactNumbers:_this.state.additionalContactNumbers};}// console.log(variables.address)
variables['is_sim_tracking']=_this.state.is_sim_tracking;if(_this.state.typeOfClient==='NON-COMMERCIAL'){variables['expiryDate']=__WEBPACK_IMPORTED_MODULE_21_moment___default()(_this.state.expiryDateTime).unix().toString();console.log("variables['expiryDate']",variables['expiryDate']);}console.log('after if');// if (!this.state.selectedPlan) {
//   this.props.openSnackbar('Select a valid plan')
// }
// if (!this.state.selectedSolutionMaster) {
//   this.props.openSnackbar('Select a valid Solution to Proceed')
// }
// else {
_context14.next=8;return _this.props.client.mutate({mutation:ADD_CLIENTS,variables:variables,errorPolicy:'all',refetchQueries:['allClientDetails']});case 8:_ref21=_context14.sent;data=_ref21.data;errors=_ref21.errors;console.log(data,errors);if(!data){_context14.next=21;break;}__WEBPACK_IMPORTED_MODULE_3_axios___default.a.post('https://n8n-dev.taabi.co/webhook/customer-created',variables).catch(function(webhookError){console.log('customer-created webhook failed',webhookError);});_context14.next=16;return _this.props.client.clearStore();case 16:_this.props.openSnackbar('Registered Successfully');_this.setState({id:'',clientName:'',username:'',contactPerson:'',secondaryContactName:'',password:'',email:'',secondaryEmail:'',contactNumber:'',landlineNumber:'',secondaryContactNumber:'',secondaryLandlineNumber:'',address1:'',// address2: '',
shippingAddress:'',// shippingAddress2: '',
channelPartnerSAPCodeNew:[],shippingPincode:'',minimumTrackedDays:'',prorata:'',addressEffectiveDate:'',city:'',shippingCity:'',state:'',country:99,secondaryCountry:'',secondaryState:'',pincode:'',pan:'',gst:'',panNumber:'',gstCompanyName:'',planType:'',planId:'',// selectedSolutionMaster: '',
timezone:{value:'Asia/Kolkata',label:'Asia/Kolkata'},typeOfClient:'REAL',// customerType: 'International',\
customerAcquisitionType:'',directCustomer:'',directCustomerType:'',directCustomerSAPCode:'',indirectCustomerType:'',channelPartnerType:'',indirectCustomerName:'',registrationType:'',customerLocation:'',customerAddress:'',response:true,expiryDateTime:__WEBPACK_IMPORTED_MODULE_21_moment___default()().add(1,'week'),solution:'',billingMode:'',salesPerson:'',showFields:false,selectedMode:{label:'Taabi Pro',value:'taabi_pro'},selectedVTM:'none',selectedServiceType:'portal',selectedZM:null,selectedSM:null,selectedKAM:null,selectedStateManager:null,selectedTerritoryManager:null,selectedSalesHead:null,selectedClusterHead:null,selectedStateHead:null,selectedCityManager:null,selectedOperationsManager:null,zone:null,serviceManager:null,customerSuccessManager:null,channelPartnerName:'',channelPartnerSAPCode:'',is_sim_tracking:false,customerNameToBeDisplayed:'',totalPotentialVehicles:''});_this.props.history.push({pathname:'/home/customers/'});_context14.next=22;break;case 21:_this.props.openSnackbar(errors[0].message);case 22:case'end':return _context14.stop();}}},_callee14,_this2);}));return function(_x12){return _ref20.apply(this,arguments);};}();_this.cancelForm=function(e){// this.setState({
//   name: '',
//   username: '',
//   person: '',
//   password: '',
//   email: '',
//   phoneno: '',
//   address1: '',
//   address2: '',
//   city: '',
//   state: '',
//   country: '',
//   pincode: '',
//   pan: '',
//   gst: '',
//   plan: '',
//   timezone: '',
//   typeOfClient: 'REAL',
//   expiryDateTime: moment().add(1, 'week')
// })
_this.props.history.goBack();};_this.getGstInfo=function(){var _ref22=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(gstNumber){var fetchGstData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:_context15.next=2;return _this.props.client.query({query:GET_GST_INFO,variables:{gstNumber:gstNumber}});case 2:fetchGstData=_context15.sent;_this.setState({isGstInfoAvailable:fetchGstData.data.getGstDetails.status==='SUCCESS',panNumber:fetchGstData.data.getGstDetails.panNumber!=null?fetchGstData.data.getGstDetails.panNumber:null,gstCompanyName:fetchGstData.data.getGstDetails.companyName!=null?fetchGstData.data.getGstDetails.companyName:null,address:fetchGstData.data.getGstDetails.address!=null?fetchGstData.data.getGstDetails.address:null,pincode:fetchGstData.data.getGstDetails.pinCode!=null?fetchGstData.data.getGstDetails.pinCode:null});case 4:case'end':return _context15.stop();}}},_callee15,_this2);}));return function(_x13){return _ref22.apply(this,arguments);};}();_this.handlePincodeChange=function(event){var enteredPincode=event.target.value;var isValid=void 0;if(_this.state.country===99){isValid=/^\d{6}$/.test(enteredPincode);}else{isValid=true;}_this.setState({pincode:enteredPincode,pincodeError:!isValid});if(isValid){_this.getStateAndCityByPin(enteredPincode);}};_this.getStateAndCityByPin=function(enteredPincode){_this.props.client.query({query:GET_STATE_DETAILS_BY_PINCODE,variables:{pincode:enteredPincode}}).then(function(response){var data=response.data;console.log('Response data:',data);if(data&&data.getStateDetailsByPincode){console.log('fetched');var stateData=data.getStateDetailsByPincode;var stateName=stateData.statename;var cityName=stateData.districtname;// this.setState({
//   state: stateData.statename,
//   city: stateData.districtname,
// });
_this.props.client.query({query:GET_STATES_FOR_COUNTRY,variables:{countryId:Number(_this.state.country)||99}}).then(function(stateResponse){var states=stateResponse.data.allStatesByCountryId;var selectedState=states.find(function(state){return state.name.toLowerCase()===stateName.toLowerCase();});if(selectedState){_this.setState({state:stateName,city:cityName,stateId:selectedState.zone_id});}else{console.error('State not found in the country list');}}).catch(function(err){console.error('Error fetching states by country:',err);});}}).catch(function(error){console.error('Error fetching state and city:',error);});};_this.fetchPlans=function(){var partnerLoginId=_this.state.partnerLoginId;_this.props.client.query({query:GET_ALL_PLANS,variables:{partnerLoginId:partnerLoginId}}).then(function(response){var data=response.data;console.log('Plans fetched:',data);if(data&&data.allPlans){console.log('Plans data:',data.allPlans);_this.setState({plans:data.allPlans});}}).catch(function(error){console.error('Error fetching plans:',error);});};_this.getChannelPartnerDetailsNew=function(){_this.props.client.query({query:GET_CHANNEL_PARTNER_DETAILS}).then(function(response){var data=response.data;if(data&&data.getChannelPartnerDetails){console.log('getChannelPartnerDetailsNew fetched:',data.getChannelPartnerDetails);_this.setState({channelPartnerSAPCodeNew:data.getChannelPartnerDetails});}}).catch(function(error){console.error('Error fetching plans:',error);});};var timezoneLists=__webpack_require__(187).getTimezones();var timezoneList=timezoneLists.map(function(timezone){return{value:timezone,label:timezone};});_this.state={clientName:'',username:'',contactPerson:'',isSecondaryContact:false,secondaryContactName:'',password:'',email:'',secondaryEmail:'',contactNumber:'',landlineNumber:'',secondaryContactNumber:'',secondaryLandlineNumber:'',address:'',// address2: '',
shippingAddress:'',// shippingAddress2: '',
shippingPincode:'',city:'',shippingCity:'',state:'',stateId:'',country:99,shippingCountry:'',shippingState:'',pincode:'',pan:'',gst:'',isGstInfoAvailable:true,panNumber:'',gstCompanyName:'',planId:'',planType:'',timezoneList:timezoneList,timezone:{value:'Asia/Kolkata',label:'Asia/Kolkata'},isEmailValid1:true,isEmailValid2:true,isPhonenoValid1:true,isPhonenoValid2:true,isLandlineNumberValid:true,isSecondaryLandlineNumberValid:true,isAddressValid:true,isShippingAddressValid:true,isCityValid:true,isShippingCityValid:true,isPinValid:true,isPanValid:true,isGSTValid:true,isUsernameValid:true,isNameValid:true,isContactpValid1:true,isContactpValid2:true,isPasswordValid:true,isUsernameUnique:true,isCancelConfDialogOpen:false,isSaveConfDialogOpen:false,response:false,clientNameRes:'',isEmailExists:'false',isPhoneExists:'false',isPanExists:'false',isGSTExists:null,emailRes2:'',phonenoRes1:'',phonenoRes2:'',landlineNumberError:'',secondaryLandlineNumberError:'',usernameRes:'',panNoRes:'',typeOfClient:'REAL',// registrationType: 'International',
registrationType:'',customerType:'',customerAcquisitionType:'',directCustomer:'',directCustomerType:'',directCustomerSAPCode:'',indirectCustomerType:'',channelPartnerType:'',indirectCustomerName:'',customerLocation:{label:'India',value:'India'},customerAddress:'',isChecked:false,shipping:false,expiryDateTime:__WEBPACK_IMPORTED_MODULE_21_moment___default()().add(1,'week'),solution:'',billingMode:'',salesPerson:0,minimumTrackedDays:0,packetThreshold:0,prorata:0,addressEffectiveDate:null,allSalesPerson:[],shippingmode:false,is_sim_tracking:false,isShippingPinvalid:true,gstErrorFieldText:'',showFields:false,selectedMode:{label:'Taabi Pro',value:'taabi_pro'},selectedZM:'',selectedSM:'',selectedKAM:'',selectedStateManager:'',selectedTerritoryManager:'',selectedSalesHead:'',selectedClusterHead:'',selectedStateHead:'',selectedCityManager:'',selectedOperationsManager:'',zone:'',serviceManager:'',customerSuccessManager:'',selectedPlan:'',zonalManagers:[],stateManagers:[],territoryManagers:[],salesHeads:[],clusterHeads:[],stateHeads:[],cityManagers:[],operationsManagers:[],keyAccountManagers:[],serviceManagers:[],customerSuccessManagers:[],// selectedSolutionMaster: '',
// selectedVTM:{ label: "None", value: "none" },
selectedVTM:'none',selectedServiceType:'portal',channelPartnerName:'',channelPartnerSAPCode:'',customerNameToBeDisplayed:'',totalPotentialVehicles:'',clientCategory:'B',clientCategoryOptions:[{value:'C',label:'Committed Customer'},{value:'B',label:'Basic Customer'}],isAdditionalContact:false,additionalContactNumbers:'',isAdditionalContactValid:true,additionalContactError:''};return _this;}// fetchDropdownData = async (type, countryId = null) => {
//   if (type === 'countries') {
//     this.setState({ allCountries: [] });
//   } else if (type === 'states') {
//     this.setState({ allStatesByCountryId: [] });
//   }
//   try {
//     let query;
//     let variables;
//     if (type === 'countries') {
//       query = GET_COUNTRIES;
//     } else if (type === 'states' && countryId) {
//       query = GET_STATES_FOR_COUNTRY;
//       variables = { countryId };
//     } else {
//       throw new Error("Invalid parameters: type must be 'countries' or 'states' with a valid countryId.");
//     }
//     const { data } = await this.props.client.query({
//       query,
//       variables,
//     });
//     if (type === 'countries') {
//       const { allCountries } = data;
//       this.setState({
//         countries: allCountries.map(country => ({
//           value: country.country_id,
//           label: country.name,
//         })),
//       });
//     } else if (type === 'states') {
//       const { allStatesByCountryId } = data;
//       this.setState({
//         states: allStatesByCountryId.map(state => ({
//           value: state.zone_id,
//           label: state.name,
//         })),
//       });
//     }
//   } catch (error) {
//     console.error(`Error fetching ${type}:`, error);
//   }
// };
// handleSolutionMasterChange = selectedOption => {
//   console.log("selectedOption",selectedOption)
//   this.setState({
//     // isStateChanged: true,
//     selectedSolutionMaster: selectedOption
//   });
// };
// checkNameValidity = client => async event => {
//   const regex = new RegExp(
//     /^(?!\s)(?!.*\s$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9 '~?!]{5,100}$/
//   )
//   const { data } = await client.query({
//     query: GET_CLIENT_NAME,
//     variables: { clientName: this.state.clientName }
//   })
//   this.setState({
//     isNameValid:
//       regex.test(this.state.name) &&
//       this.state.name !== '' &&
//       data.checkClientName === 'AVAILABLE'
//   })
//   if (this.state.name.length === 0) {
//     this.setState({
//       clientNameRes: 'Please enter the name'
//     })
//   } else if (
//     this.state.name.length !== 0 &&
//     regex.test(this.state.name) === false
//   ) {
//     this.setState({
//       clientNameRes:
//         'Name can be characters or Number between 5-32 characters'
//     })
//   } else if (data.checkClientName !== 'AVAILABLE') {
//     // console.log('availabe')
//     this.setState({ clientNameRes: 'Name already exist' })
//   }
// }
_createClass(RegisterCustomer,[{key:'isSaveFormInvalid',value:function isSaveFormInvalid(){var _state=this.state,customerType=_state.customerType,customerAcquisitionType=_state.customerAcquisitionType,directCustomerType=_state.directCustomerType,directCustomer=_state.directCustomer,indirectCustomerType=_state.indirectCustomerType,channelPartnerType=_state.channelPartnerType,channelPartnerName=_state.channelPartnerName,customerLocation=_state.customerLocation,customerAddress=_state.customerAddress,country=_state.country,pincode=_state.pincode,state=_state.state,city=_state.city,timezone=_state.timezone,zone=_state.zone,selectedZM=_state.selectedZM,selectedSM=_state.selectedSM,selectedKAM=_state.selectedKAM,serviceManager=_state.serviceManager,customerSuccessManager=_state.customerSuccessManager,isUsernameValid=_state.isUsernameValid,isPasswordValid=_state.isPasswordValid,customerNameToBeDisplayed=_state.customerNameToBeDisplayed,totalPotentialVehicles=_state.totalPotentialVehicles,contactPerson=_state.contactPerson,isContactpValid1=_state.isContactpValid1,contactNumber=_state.contactNumber,isPhonenoValid1=_state.isPhonenoValid1,isPhoneExists=_state.isPhoneExists,landlineNumberError=_state.landlineNumberError,isEmailValid1=_state.isEmailValid1,isEmailExists=_state.isEmailExists,isContactpValid2=_state.isContactpValid2,isPhonenoValid2=_state.isPhonenoValid2,secondaryLandlineNumberError=_state.secondaryLandlineNumberError,isEmailValid2=_state.isEmailValid2,selectedMode=_state.selectedMode,selectedPlan=_state.selectedPlan,planId=_state.planId,selectedServiceType=_state.selectedServiceType,isSecondaryContact=_state.isSecondaryContact,secondaryContactName=_state.secondaryContactName,secondaryContactNumber=_state.secondaryContactNumber,secondaryEmail=_state.secondaryEmail,clientNameRes=_state.clientNameRes,isAdditionalContact=_state.isAdditionalContact,additionalContactNumbers=_state.additionalContactNumbers,isAdditionalContactValid=_state.isAdditionalContactValid;return customerType===''||customerAcquisitionType===''||customerAcquisitionType==='Direct Customer'&&(directCustomerType===''||directCustomer==='')||customerAcquisitionType==='Indirect Customer'&&(channelPartnerType===''||indirectCustomerType===''||channelPartnerName==='')||customerLocation===''||customerAddress===''||country===''||pincode===''||state===''||city===''||timezone===''||// zone === '' ||
// !selectedZM ||
// !selectedSM ||
// !selectedKAM ||
// serviceManager === '' ||
// customerSuccessManager === '' ||
!isUsernameValid||!isPasswordValid||clientNameRes||(this.state.customerAcquisitionType==='Direct Customer'?this.state.customerNameToBeDisplayed||(this.state.directCustomer?this.state.directCustomer.label:''):this.state.customerAcquisitionType==='Indirect Customer'?this.state.customerNameToBeDisplayed||this.state.indirectCustomerName:this.state.customerNameToBeDisplayed||'')===''||totalPotentialVehicles===''||contactPerson===''||!isContactpValid1||contactNumber===''||!isPhonenoValid1||!isPhoneExists||landlineNumberError||!isEmailValid1||!isEmailExists||!selectedMode||// !selectedPlan ||
// (!selectedSolutionMaster || !selectedSolutionMaster.value) ||
// planId === '' ||
!selectedServiceType||isSecondaryContact&&(!secondaryContactName||!isContactpValid2||!isPhonenoValid2||secondaryLandlineNumberError||!isEmailValid2||!secondaryContactNumber||!secondaryEmail)||isAdditionalContact&&(!additionalContactNumbers||!isAdditionalContactValid);}},{key:'render',value:function render(){var _this3=this;// console.log(this.props)
var _state2=this.state,id=_state2.id,username=_state2.username,clientName=_state2.clientName,companyName=_state2.companyName,contactPerson=_state2.contactPerson,secondaryContactName=_state2.secondaryContactName,password=_state2.password,email=_state2.email,secondaryEmail=_state2.secondaryEmail,contactNumber=_state2.contactNumber,landlineNumber=_state2.landlineNumber,secondaryContactNumber=_state2.secondaryContactNumber,secondaryLandlineNumber=_state2.secondaryLandlineNumber,address=_state2.address,address2=_state2.address2,shippingAddress=_state2.shippingAddress,shippingAddres2=_state2.shippingAddres2,shippingCountry=_state2.shippingCountry,shippingState=_state2.shippingState,shippingCity=_state2.shippingCity,shippingPincode=_state2.shippingPincode,minimumTrackedDays=_state2.minimumTrackedDays,packetThreshold=_state2.packetThreshold,prorata=_state2.prorata,addressEffectiveDate=_state2.addressEffectiveDate,city=_state2.city,state=_state2.state,state2=_state2.state2,country=_state2.country,countryTwo=_state2.countryTwo,pincode=_state2.pincode,isGstInfoAvailable=_state2.isGstInfoAvailable,panNumber=_state2.panNumber,gstCompanyName=_state2.gstCompanyName,gstErrorFieldText=_state2.gstErrorFieldText,pan=_state2.pan,gst=_state2.gst,plan=_state2.plan,typeOfClient=_state2.typeOfClient,customerType=_state2.customerType,customerAcquisitionType=_state2.customerAcquisitionType,directCustomer=_state2.directCustomer,directCustomerType=_state2.directCustomerType,indirectCustomerType=_state2.indirectCustomerType,channelPartnerType=_state2.channelPartnerType,customerLocation=_state2.customerLocation,customerAddress=_state2.customerAddress,registrationType=_state2.registrationType,solution=_state2.solution,billingMode=_state2.billingMode,salesPerson=_state2.salesPerson,allSalesPerson=_state2.allSalesPerson,packetsPerDay=_state2.packetsPerDay;var classes=this.props.classes;var _state3=this.state,showFields=_state3.showFields,selectedZM=_state3.selectedZM,selectedSM=_state3.selectedSM,selectedKAM=_state3.selectedKAM,selectedTerritoryManager=_state3.selectedTerritoryManager,selectedSalesHead=_state3.selectedSalesHead,selectedClusterHead=_state3.selectedClusterHead,selectedStateHead=_state3.selectedStateHead,selectedCityManager=_state3.selectedCityManager,selectedOperationsManager=_state3.selectedOperationsManager,zone=_state3.zone,serviceManager=_state3.serviceManager,customerSuccessManager=_state3.customerSuccessManager,selectedPlan=_state3.selectedPlan,selectedVTM=_state3.selectedVTM,selectedServiceType=_state3.selectedServiceType,channelPartnerName=_state3.channelPartnerName,selectedMode=_state3.selectedMode,clientCategory=_state3.clientCategory,clientCategoryOptions=_state3.clientCategoryOptions,zonalManagers=_state3.zonalManagers,stateManagers=_state3.stateManagers,territoryManagers=_state3.territoryManagers,salesHeads=_state3.salesHeads,clusterHeads=_state3.clusterHeads,stateHeads=_state3.stateHeads,cityManagers=_state3.cityManagers,operationsManagers=_state3.operationsManagers,keyAccountManagers=_state3.keyAccountManagers,serviceManagers=_state3.serviceManagers,customerSuccessManagers=_state3.customerSuccessManagers;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_apollo__["ApolloConsumer"],null,function(client){return(// <Query
//   query={GET_ALL_PLANS} // Fetch Billing Modes here
//   variables={{
//     partnerLoginId: getLoginId()
//   }}
// >
//   {({ loading, error, data: { allPlans } }) => {
//     if (loading) return <Loader />
//     if (error) return `Error!: ${error}`
//     const plans = allPlans.map(plan => ({
//       value: plan.id,
//       label: plan.planName
//     }))
__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_apollo__["Query"],{query:GET_ALL_SOLUTION_TYPE_MASTER,fetchPolicy:'network-only'},function(_ref23){var loading=_ref23.loading,error=_ref23.error,data=_ref23.data;if(loading)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__components_common_Loader__["a" /* default */],null);if(error)return'Error!: '+error;// Map solutions to value/label format
var solutionsMaster=data.getAllMasterSolutionType.map(function(solution){return{value:solution.id,label:solution.solutionTypeName};});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__common_ConfirmationDialog__["a" /* default */],{isDialogOpen:_this3.state.isSaveConfDialogOpen,dialogMessage:"Are you sure you want to Save this customer's details?",negativeResponseHandler:_this3.handleSaveNegativeResponse,positiveResponseHandler:_this3.submitForm}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__common_ConfirmationDialog__["a" /* default */],{isDialogOpen:_this3.state.isCancelConfDialogOpen,dialogMessage:'Are you sure you want to Cancel customer registration?',negativeResponseHandler:_this3.handleCancelNegativeResponse,positiveResponseHandler:_this3.cancelForm}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,container:true,xs:12,justify:'flex-start'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{variant:'outlined',color:'secondary',className:classes.button,onClick:_this3.handleBackCancelClick},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_icons_ArrowBack___default.a,null))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core_Card___default.a,{sx:{marginTop:'400px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__material_ui_core_CardHeader___default.a,{title:'Register Customer',subheader:'All fields marked with (*) are mandatory',subheaderTypographyProps:{className:classes.italicizedText}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{zIndex:'20'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Customer Type *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */]// options={CUSTOMER_TYPES}
,{options:Array.isArray(_this3.state.customertype)&&_this3.state.customertype.map(function(option){return{label:option,value:option};}),value:_this3.state.customerType,onChange:_this3.handleCustomerTypeChange,placeholder:'Select Customer Type *'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{zIndex:'15'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Customer Acquisition Type *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */]// options={CUSTOMER_ACQUISITION_TYPES}
,{options:Array.isArray(_this3.state.customeracquisitiontype)&&_this3.state.customeracquisitiontype.map(function(option){return{label:option,value:option};}),value:_this3.state.customerAcquisitionType,onChange:_this3.handleCustomerAcquisitionTypeChange,placeholder:'Select Customer Acquisition Type *'// onBlur={(event) => {this.checkNameValidity(client)(event)}}
}))),_this3.state.customerAcquisitionType==='Direct Customer'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{zIndex:'15'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Direct Customer Type *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */]// options={DIRECT_CUSTOMER_TYPE_OPTIONS}
,{options:Array.isArray(_this3.state.directcustomertype)&&_this3.state.directcustomertype.map(function(option){return{label:option,value:option};}),value:_this3.state.directCustomerType,onChange:function onChange(selectedOption){_this3.setState({directCustomerType:selectedOption?selectedOption.value:''});},required:true,placeholder:'Select Direct Customer Type *'}))),_this3.state.customerAcquisitionType==='Direct Customer'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:6,style:{zIndex:'13',marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Direct Customer Name *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_apollo__["Query"],{query:GET_SAP_DETAILS},function(_ref24){var loading=_ref24.loading,error=_ref24.error,data=_ref24.data;if(loading)return'Loading...';if(error)return'Error!: '+error.message;var newCustomers=data.getSapDetails.map(function(customer){return{value:customer.customer_no,label:customer.customer_name};});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */],{options:newCustomers,value:_this3.state.directCustomer,onChange:function onChange(selectedOption){_this3.setState({directCustomer:selectedOption,directCustomerSAPCode:selectedOption?selectedOption.value:'',customerNameToBeDisplayed:selectedOption?selectedOption.label:''});},required:true,placeholder:'Select Direct Customer Name *',onBlur:function onBlur(event){_this3.checkNameValidity(client)(event);}}));}))),_this3.state.customerAcquisitionType==='Direct Customer'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{zIndex:'13'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Direct Customer SAP Code'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField___default.a,{id:'directCustomerSAPCode',name:'directCustomerSAPCode',className:'textfield',margin:'dense'// label="Direct Customer SAP Code"
,type:'text',value:_this3.state.directCustomerSAPCode,onChange:_this3.handleInputChange('directCustomerSAPCode'),InputProps:{readOnly:true}}))),_this3.state.customerAcquisitionType==='Indirect Customer'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{zIndex:'15'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Indirect Customer Type *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */]// options={INDIRECT_CUSTOMER_TYPE_OPTIONS}
,{options:Array.isArray(_this3.state.indirectcustomertype)&&_this3.state.indirectcustomertype.map(function(option){return{label:option,value:option};}),value:_this3.state.indirectCustomerType,onChange:function onChange(selectedOption){_this3.setState({indirectCustomerType:selectedOption?selectedOption.value:''});},required:true,placeholder:'Select Indirect Customer Type *'}))),_this3.state.customerAcquisitionType==='Indirect Customer'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{zIndex:'13',marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField___default.a,{id:'indirectCustomerName',name:'indirectCustomerName',className:'textfield',margin:'dense',label:'Indirect Customer Name',type:'text',value:_this3.state.indirectCustomerName,onChange:_this3.handleInputChangeIndirectCustomerName('indirectCustomerName'),onBlur:function onBlur(event){_this3.checkNameValidity(client)(event);}}))),_this3.state.customerAcquisitionType==='Indirect Customer'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{zIndex:'12'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Channel Partner Name *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */]// options={CHANNEL_PARTNER_OPTIONS}
// value={this.state.channelPartnerName}
// onChange={(selectedOption) => {
//   this.setState({ channelPartnerName: selectedOption ? selectedOption.value : '' });
// }}
// options={Array.isArray(this.state.channelpartners) && this.state.channelpartners.map(option => ({
//   label: option,
//   value: option
// }))}
,{options:_this3.state.channelPartnerSAPCodeNew&&_this3.state.channelPartnerSAPCodeNew.map(function(option){return{label:option.channel_partner_name,value:option.channel_partner_name};}),value:_this3.state.channelPartnerName// onChange = {(selectedOption) => {
//   this.setState({ channelPartnerName: selectedOption
//     ? selectedOption.value
//     : '',
//     channelPartnerSAPCode: this.state.channelPartnerSAPCodeNew.filter(customer =>
//       customer.customer_name === selectedOption.value
//     )
//   });
// }}
,onChange:function onChange(selectedOption){_this3.setState({channelPartnerName:selectedOption?selectedOption.value:'',channelPartnerSAPCode:selectedOption?_this3.state.channelPartnerSAPCodeNew.find(function(customer){return customer.channel_partner_name===selectedOption.value;})?_this3.state.channelPartnerSAPCodeNew.find(function(customer){return customer.channel_partner_name===selectedOption.value;}).channel_partner_sap_code:'99999999':'',channelPartnerType:selectedOption?_this3.state.channelPartnerSAPCodeNew.find(function(customer){return customer.channel_partner_name===selectedOption.value;})?_this3.state.channelPartnerSAPCodeNew.find(function(customer){return customer.channel_partner_name===selectedOption.value;}).channel_partner_type:'N/A':''});},required:true,placeholder:'Select Channel Partner Name *'}))),_this3.state.customerAcquisitionType==='Indirect Customer'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{zIndex:'2',marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Channel Partner Type'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField___default.a,{id:'channelPartnerType',name:'channelPartnerType',className:'textfield',margin:'dense'// label="Channel Partner SAP Code"
,type:'text',value:_this3.state.channelPartnerType,onChange:_this3.handleInputChange('channelPartnerType'),InputProps:{readOnly:true}}))),_this3.state.customerAcquisitionType==='Indirect Customer'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{zIndex:'2',marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Channel Partner SAP Code'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField___default.a,{id:'channelPartnerSAPCode',name:'channelPartnerSAPCode',className:'textfield',margin:'dense'// label="Channel Partner SAP Code"
,type:'text',value:_this3.state.channelPartnerSAPCode,onChange:_this3.handleInputChange('channelPartnerSAPCode'),InputProps:{readOnly:true}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{style:{fontSize:'24px'}},'Location Info')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{zIndex:'7',marginTop:'-20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Customer Location *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */]// options={CUSTOMER_LOCATIONS}
,{options:Array.isArray(_this3.state.customerlocation)&&_this3.state.customerlocation.map(function(option){return{label:option,value:option};}),value:_this3.state.customerLocation,onChange:function onChange(selectedOption){_this3.setState({customerLocation:selectedOption||''});},required:true,placeholder:'Select Customer Location *'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{marginTop:'-10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField___default.a,{name:'customerAddress',value:_this3.state.customerAddress,type:'text',onChange:_this3.handleInputChange('customerAddress'),label:'Enter Customer Address *'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:6,style:{zIndex:'6',marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Country *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_apollo__["Query"],{query:GET_COUNTRIES},function(_ref25){var loading=_ref25.loading,error=_ref25.error,allCountries=_ref25.data.allCountries;if(loading)return'Loading...';if(error)return'Error!: '+error;var sortedCountries=allCountries.map(function(country){return{value:country.country_id,label:country.name};});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */]// classes={classes}
,{options:sortedCountries// components={components}
,value:_this3.state.country,onChange:function onChange(selectedOption){_this3.setState({country:selectedOption?selectedOption.value:''});},required:true,placeholder:'Select Country *'}));}),' ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{marginTop:'15px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField___default.a,{name:'pincode',value:_this3.state.pincode,type:'text',onChange:_this3.handlePincodeChange,label:'Enter PIN Code *'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:6,style:{zIndex:'5',marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'State *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_apollo__["Query"],{query:GET_STATES_FOR_COUNTRY,variables:{countryId:Number(_this3.state.country)?_this3.state.country:99}},function(_ref26){var loading=_ref26.loading,error=_ref26.error,data=_ref26.data;if(loading)return'Loading...';if(error)return'Error!: '+error;if(data&&data.allStatesByCountryId){var sortedStates=data.allStatesByCountryId.map(function(state){return{value:state.zone_id,label:state.name};});if(sortedStates.length>0){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */],{options:sortedStates,value:sortedStates.find(function(option){return option.label.toLowerCase()===(_this3.state.state?_this3.state.state.toLowerCase():'');})||null,onChange:function onChange(selectedOption){_this3.setState({state:selectedOption?selectedOption.label:'',stateId:selectedOption?selectedOption.value:''});},required:true,placeholder:'Select State *'}));}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField___default.a,{value:'No States in this Country',type:'text'});}}return null;}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{marginTop:'15px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField___default.a,{name:'city',value:_this3.state.city,type:'text',onChange:_this3.handleInputChange('city'),label:'Enter City *'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{zIndex:'4',marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Time Zone *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */],{options:_this3.state.timezoneList,value:_this3.state.timezone,onChange:_this3.handleTimezoneChange,placeholder:'Select Time Zone *'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_apollo__["Query"],{query:GET_ZM_KAM_SM_CSM_DETAILS,variables:{roleName:roleNames},fetchPolicy:'network-only'},function(_ref27){var loading=_ref27.loading,error=_ref27.error,data=_ref27.data;if(loading)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__components_common_Loader__["a" /* default */],null);if(error)return'Error!: '+error.message;var zonalManagers=data.getAdminUserDetailsByRole.filter(function(user){return user.role==='Zonal Manager(ZM)';});var stateManagers=data.getAdminUserDetailsByRole.filter(function(user){return user.role==='State Manager(SM)';});var keyAccountManagers=data.getAdminUserDetailsByRole.filter(function(user){return user.role==='Key Account Manager(KAM)';});var serviceManagers=data.getAdminUserDetailsByRole.filter(function(user){return user.role==='Service Manager';});var customerSuccessManagers=data.getAdminUserDetailsByRole.filter(function(user){return user.role==='Customer Success Manager';});// return !showFields ? (
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{container:true,spacing:2,style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{zIndex:'3',marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Zone *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */],{options:ZONE_OPTIONS,value:_this3.state.zone,onChange:function onChange(selectedOption){_this3.setState({zone:selectedOption?selectedOption.value:''});},placeholder:'Select Zone'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{style:{marginRight:'20px'}},'Zonal Manager'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */],{options:zonalManagers.map(function(zm){return{label:zm.username,value:zm.id};})// options={Array.isArray(this.state.zonalmanager) && this.state.zonalmanager.map(option => ({
//   label: option,
//   value: option
// }))}
,value:_this3.state.selectedZM,onChange:_this3.handleZMChange,placeholder:'Select Zonal Manager'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{marginTop:'15px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{style:{marginRight:'20px'}},'State Manager'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */],{options:stateManagers.map(function(sm){return{label:sm.username,value:sm.id};})// options={Array.isArray(this.state.zonalmanager) && this.state.zonalmanager.map(option => ({
//   label: option,
//   value: option
// }))}
,value:_this3.state.selectedSM,onChange:_this3.handleSMChange,placeholder:'Select State Manager'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{marginTop:'15px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{style:{marginRight:'20px'}},'Territory Manager'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */],{options:territoryManagers,value:_this3.state.selectedTerritoryManager,onChange:_this3.handleTerritoryManagerChange,placeholder:'Select Territory Manager'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{marginTop:'15px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{style:{marginRight:'20px'}},'Sales Head'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */],{options:salesHeads,value:_this3.state.selectedSalesHead,onChange:_this3.handleSalesHeadChange,placeholder:'Select Sales Head'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{marginTop:'15px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{style:{marginRight:'20px'}},'Cluster Head'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */],{options:clusterHeads,value:_this3.state.selectedClusterHead,onChange:_this3.handleClusterHeadChange,placeholder:'Select Cluster Head'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{marginTop:'15px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{style:{marginRight:'20px'}},'State Head'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */],{options:stateHeads,value:_this3.state.selectedStateHead,onChange:_this3.handleStateHeadChange,placeholder:'Select State Head'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{marginTop:'15px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{style:{marginRight:'20px'}},'City Manager'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */],{options:cityManagers,value:_this3.state.selectedCityManager,onChange:_this3.handleCityManagerChange,placeholder:'Select City Manager'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{marginTop:'15px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{style:{marginRight:'20px'}},'Operations Manager'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */],{options:operationsManagers,value:_this3.state.selectedOperationsManager,onChange:_this3.handleOperationsManagerChange,placeholder:'Select Operations Manager'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{marginTop:'15px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{style:{marginRight:'20px'}},'Key Account Manager'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */],{options:keyAccountManagers.map(function(kam){return{label:kam.username,value:kam.id};})// options={Array.isArray(this.state.keyaccountmanager) && this.state.keyaccountmanager.map(option => ({
//   label: option,
//   value: option
// }))}
,value:_this3.state.selectedKAM,onChange:_this3.handleKAMChange,placeholder:'Select Key Account Manager'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{marginTop:'15px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{style:{marginRight:'20px'}},'Service Manager'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */]// options={SERVICE_MANAGER_OPTIONS}
// options={Array.isArray(this.state.servicemanager) && this.state.servicemanager.map(option => ({
//   label: option,
//   value: option
// }))}
,{options:serviceManagers.map(function(sm){return{label:sm.username,value:sm.id};}),value:_this3.state.serviceManager,onChange:function onChange(selectedOption){_this3.setState({serviceManager:selectedOption?selectedOption.value:''});},placeholder:'Select Service Manager'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{marginTop:'15px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{style:{marginRight:'20px'}},'Customer Success Manager'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */]// options={CUSTOMER_SUCCESS_MANAGER_OPTIONS}
// options={Array.isArray(this.state.customersuccessmanager) && this.state.customersuccessmanager.map(option => ({
//   label: option,
//   value: option
// }))}
,{options:customerSuccessManagers.map(function(csm){return{label:csm.username,value:csm.id};}),value:_this3.state.customerSuccessManager,onChange:function onChange(selectedOption){_this3.setState({customerSuccessManager:selectedOption?selectedOption.value:''});},placeholder:'Select Customer Success Manager'}))))// ) : (
//   <React.Fragment>
//     <Grid container spacing={2}>
//       <Grid item xs={12} md={6}>
//         <label style={{ marginRight: '20px' }}>
//           Zonal Manager *
//         </label>
//         <FormGroup className="form-input" style={{ marginTop: '5px' }}>
//           <Select
//             // options={zonalManagers.map(zm => ({
//             //   label: zm.username,
//             //   value: zm.id
//             // }))}
//             options={Array.isArray(this.state.zonalmanager) && this.state.zonalmanager.map(option => ({
//               label: option,
//               value: option
//             }))}
//             value={this.state.selectedZM}
//             onChange={this.handleZMChange}
//             placeholder="Select Zonal Manager *"
//           />
//         </FormGroup>
//       </Grid>
//       <Grid item xs={12} md={6}>
//         <label style={{ marginRight: '20px' }}>
//           Key Account Manager *
//         </label>
//         <FormGroup className="form-input">
//           <Select
//             // options={keyAccountManagers.map(
//             //   kam => ({
//             //     label: kam.username,
//             //     value: kam.id
//             //   })
//             // )}
//             options={Array.isArray(this.state.keyaccountmanager) && this.state.keyaccountmanager.map(option => ({
//               label: option,
//               value: option
//             }))}
//             value={selectedKAM}
//             onChange={this.handleKAMChange}
//             placeholder="Select Key Account Manager *"
//           />
//         </FormGroup>
//       </Grid>
//     </Grid>
//     {/* <Grid item xs={12} md={6}>
//       <label style={{ marginRight: '20px' }}>
//         Channel Partner Name *
//       </label>
//       <FormGroup className="form-input">
//         <TextField
//           value={channelPartnerName}
//           placeholder="Enter Channel Partner Name *"
//           fullWidth
//           onChange={
//             this.handleChannelPartnerNameChange
//           }
//         />
//       </FormGroup>
//     </Grid> */}
//   </React.Fragment>
;}),Object(__WEBPACK_IMPORTED_MODULE_20__utils_getLoginId__["a" /* default */])()===2&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */],{options:allSalesPerson,value:salesPerson,onChange:_this3.handleSalesPersonChange,placeholder:'Select Sales Person*'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField___default.a,{name:'username',value:username,type:'text',onChange:_this3.handleInputChangeUsernamePassword,required:true,error:!_this3.state.isUsernameValid,onBlur:_this3.checkUsernameValidity(client),label:'User Name'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!_this3.state.isUsernameValid?_this3.state.usernameRes:''))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField___default.a,{name:'password',value:password,type:'password',onChange:_this3.handleInputChangeUsernamePassword,label:'Password',error:!_this3.state.isPasswordValid,onBlur:_this3.checkPasswordValidity,required:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this3.state.isPasswordValid?'':'Password should contain 3-20 charcter or digit without space'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Customer Name to be displayed on Portal *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField___default.a,{name:'customerNameToBeDisplayed',value:_this3.state.customerAcquisitionType==='Direct Customer'?_this3.state.customerNameToBeDisplayed||(_this3.state.directCustomer?_this3.state.directCustomer.label:''):_this3.state.customerAcquisitionType==='Indirect Customer'?_this3.state.customerNameToBeDisplayed||_this3.state.indirectCustomerName:_this3.state.customerNameToBeDisplayed||'',type:'text',onChange:_this3.handleInputChange('customerNameToBeDisplayed'),error:!_this3.state.isNameValid// onBlur={this.checkNameValidity}
,onBlur:function onBlur(event){_this3.checkNameValidity(client)(event);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this3.state.clientNameRes))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Customer Potential *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField___default.a,{name:'totalPotentialVehicles',value:_this3.state.totalPotentialVehicles,type:'number',onChange:_this3.handleInputChange('totalPotentialVehicles'),inputProps:{name:'totalPotentialVehicles',min:1,step:1}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Client Category *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */],{options:_this3.state.clientCategoryOptions,value:_this3.state.clientCategoryOptions.find(function(option){return option.value===_this3.state.clientCategory;}),onChange:function onChange(selectedOption){_this3.setState({clientCategory:selectedOption.value});},placeholder:'Select Client Category *'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{style:{fontSize:'24px'}},'Contact Info')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField___default.a,{name:'contactPerson',value:_this3.state.contactPerson,type:'text',onChange:_this3.handleInputChange('primaryContactPersonName'),label:'Primary Contact Person Name',required:true,error:!_this3.state.isContactpValid1,onBlur:_this3.checkContactpValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this3.state.isContactpValid1?'':'Only Alphabets allowed, between 3 to 32 characters'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField___default.a,{name:'contactNumber',value:_this3.state.contactNumber,type:'text',onChange:_this3.handleInputChange('primaryContactPersonMobileNumber'),label:'Primary Mobile Number',required:true,error:!_this3.state.isPhonenoValid1,onBlur:_this3.checkPhonenoValidity1(client)}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this3.state.isPhonenoValid1?'':'Invalid Phone Number ',_this3.state.isPhoneExists?'':'Phone Number Already Exists '))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField___default.a,{name:'landlineNumber',value:_this3.state.landlineNumber,type:'text',onChange:_this3.handleInputChange('primaryContactPersonLandlineNumber'),label:'Landline Number',onBlur:function onBlur(event){return _this3.checkLandlineValidity(event,'landlineNumber');},error:_this3.state.landlineNumberError// helperText={this.state.landlineNumberError}
}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormHelperText___default.a,{id:'landline-error-text',className:'Error_msg',error:_this3.state.landlineNumberError},_this3.state.landlineNumberError))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField___default.a,{name:'email',value:email,type:'email',onChange:_this3.handleInputChange('primaryContactPersonEmail'),label:'Primary Email',required:true,error:!_this3.state.isEmailValid1,onBlur:_this3.checkEmailValidity1(client)}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this3.state.isEmailExists?'':'Email Id already exist ',_this3.state.isEmailValid1?' ':'Invalid Email '))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:12,display:'flex'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__material_ui_core__["Checkbox"],{name:'isSecondaryContact',value:_this3.state.isSecondaryContact,checked:_this3.state.isSecondaryContact,onClick:_this3.handleSecondaryContactAvailable}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{fontSize:'15px'}},'Secondary Contact Details Available?')),_this3.state.isSecondaryContact&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField___default.a,{name:'secondaryContactName',value:_this3.state.secondaryContactName,type:'text',onChange:_this3.handleInputChange('secondaryContactPersonName'),label:'Secondary Contact Person Name *',error:!_this3.state.isContactpValid2,onBlur:_this3.checkContactpValidityTwo}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this3.state.isContactpValid2?'':'Only Alphabets allowed, between 3 to 32 characters'))),_this3.state.isSecondaryContact&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField___default.a,{name:'secondaryContactNumber',value:_this3.state.secondaryContactNumber,type:'text',onChange:_this3.handleInputChange('secondaryContactPersonPhoneNumber'),label:'Secondary Phone Number *',error:!_this3.state.isPhonenoValid2,onBlur:_this3.checkPhonenoValidity2(client)}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this3.state.isPhonenoValid2?'':// : 'Invalid phone Number'}
_this3.state.phonenoRes2))),_this3.state.isSecondaryContact&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField___default.a,{name:'secondaryLandlineNumber',value:_this3.state.secondaryLandlineNumber,type:'text',onChange:_this3.handleInputChange('secondaryContactPersonLandlineNumber'),label:'Landline Number',onBlur:function onBlur(event){return _this3.checkLandlineValidity(event,'secondaryLandlineNumber');},error:!_this3.state.isSecondaryLandlineNumberValid// helperText={this.state.secondaryLandlineNumberError}
}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormHelperText___default.a,{id:'landline-error-text',className:'Error_msg',error:_this3.state.secondaryLandlineNumberError},_this3.state.secondaryLandlineNumberError))),_this3.state.isSecondaryContact&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField___default.a,{name:'secondaryEmail',value:_this3.state.secondaryEmail,type:'email',onChange:_this3.handleInputChange('secondaryContactPersonEmail'),label:'Secondary Email *',error:!_this3.state.isEmailValid2,onBlur:_this3.checkEmailValidity2(_this3.props.client)}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this3.state.isEmailValid2?'':// : 'Invalid Email'}
_this3.state.emailRes2))),_this3.state.isSecondaryContact&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:12,display:'flex'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__material_ui_core__["Checkbox"],{name:'isAdditionalContact',value:_this3.state.isAdditionalContact,checked:_this3.state.isAdditionalContact,onClick:_this3.handleAdditionalContactAvailable}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{fontSize:'15px'}},'Additional Contact Details Available?')),_this3.state.isSecondaryContact&&_this3.state.isAdditionalContact&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField___default.a,{name:'additionalContactNumbers',label:'Additional Contact Numbers (comma separated) *',value:_this3.state.additionalContactNumbers,onChange:_this3.handleAdditionalContactChange,onBlur:_this3.checkAdditionalContactValidity,fullWidth:true,error:!_this3.state.isAdditionalContactValid,helperText:_this3.state.additionalContactError}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Mode *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */],{options:Array.isArray(_this3.state.mode)&&_this3.state.mode.map(function(option){return{label:option,value:option};}),value:_this3.state.selectedMode,onChange:_this3.handleModeChange,placeholder:'Select Mode *'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Video Telematics Plan *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */]// options={Array.isArray(this.state.videotelematicsplan) && this.state.videotelematicsplan.map(option => ({
//   label: option,
//   value: option
// }))}
,{options:Array.isArray(_this3.state.videotelematicsplan)&&_this3.state.videotelematicsplan.map(function(option){return{label:option,value:option==='API-Loconav'?'loconav':option==='API-Meta'?'mettax':option==='iFrame-LM'?'lightMetrics':option==='None'?'none':option.toLowerCase()};}),value:_this3.state.selectedVTM||'none'// value={this.state.selectedVTM === 'none' ? { label: 'None', value: 'none' } : this.state.selectedVTM}
,onChange:_this3.handleVideoTelematicsMenuChange,placeholder:'Select Video Telematics Plan *',menuStyle:{height:'120px'}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Service Type *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */],{options:Array.isArray(_this3.state.servicetype)&&_this3.state.servicetype.map(function(option){return{label:option,value:option.toLowerCase()};}),value:_this3.state.selectedServiceType==='portal'?{label:'Portal',value:'portal'}:_this3.state.selectedServiceType,onChange:_this3.handleServiceTypeChange,placeholder:'Select Service Type *',menuStyle:{height:'120px'}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:12,display:'flex'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__material_ui_core__["Checkbox"],{name:'is_sim_tracking',value:_this3.state.is_sim_tracking,checked:_this3.state.is_sim_tracking,onClick:_this3.handleSimTracking}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{fontSize:'15px'}},'SIM tracking enabled?')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__material_ui_core_CardActions___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{color:'secondary',variant:'contained',onClick:_this3.submitForm,disabled:_this3.isSaveFormInvalid()// disabled={
//   this.state.isEmailValid1 === false ||
//   // this.state.isEmailValid2 === false ||
//   this.state.isContactpValid1 === false ||
//   // this.state.isContactpValid2 === false ||
//   this.state.isPhonenoValid1 === false ||
//   // this.state.isPhonenoValid2 === false ||
//   this.state.isCityValid === false ||
//   this.state.isShippingAddressValid === false ||
//   this.state.isShippingCityValid === false ||
//   this.state.isPinValid === false ||
//   this.state.isPanValid === false ||
//   this.state.isAddressValid === false ||
//   // this.state.isUsernameValid === false ||
//   // this.state.isNameValid === false ||
//   // this.state.isPasswordValid === false ||
//   // this.state.isUsernameUnique === false ||
//   this.state.isGSTValid === false ||
//   (this.state.customerType === 'Registered' &&
//     this.state.gst === '') ||
//   (this.state.customerType === 'Registered' &&
//     this.state.panNumber === '') ||
//   (this.state.customerType === 'Registered' &&
//     this.state.gstCompanyName === '') ||
//   this.state.isShippingPinvalid === false ||
//   solution === '' ||
//   // clientName === '' ||
//   username === '' ||
//   // contactPerson === '' ||
//   // secondaryContactName === '' ||
//   salesPerson === '' ||
//   password === '' ||
//   email === '' ||
//   packetThreshold === '' ||
//   minimumTrackedDays === '' ||
//   // packetThreshold === null ||
//   // minimumTrackedDays === null
//   // secondaryEmail === '' ||
//   // secondaryContactNumber === '' ||
//   // contactNumber === '' ||
//   typeOfClient === '' ||
//   pincode === '' ||
//   address === '' ||
//   city === '' ||
//   state === '' ||
//   country === '' ||
//   // this.state.shippingmode === false ||
//   // plan === '' ||
//   this.state.shippingAddress === '' ||
//   this.state.shippingState === null ||
//   state === null ||
//   this.state.shippingCity === '' ||
//   this.state.shippingState === '' ||
//   this.state.shippingCountry === '' ||
//   this.state.shippingPincode === '' ||
//   this.state.timezone === '' ||
//   billingMode === '' ||
//   this.state.selectedZM === '' ||
//   this.state.selectedZM === null ||
//   this.state.selectedMode === '' ||
//   this.state.selectedMode === null ||
//   this.state.selectedKAM === '' ||
//   this.state.selectedKAM === null ||
//   this.state.zone === '' ||
//   this.state.serviceManager === '' ||
//   this.state.customerSuccessManager === '' ||
//   (showFields &&
//     this.state.channelPartnerName === '') ||
//   (showFields &&
//     this.state.channelPartnerName === null)
// }
},'Save'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{color:'secondary',onClick:_this3.handleCancelClick},'Cancel'))))));}));});}}]);return RegisterCustomer;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);RegisterCustomer.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_5_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_19__HOCs_withSharedSnackbar__["a" /* default */])(RegisterCustomer))));

/***/ }),
/* 1112 */
/***/ (function(module, exports) {

module.exports = {"countries":{"AD":{"name":"Andorra","abbr":"AD","zones":["Europe/Andorra"]},"AE":{"name":"United Arab Emirates","abbr":"AE","zones":["Asia/Dubai"]},"AF":{"name":"Afghanistan","abbr":"AF","zones":["Asia/Kabul"]},"AG":{"name":"Antigua & Barbuda","abbr":"AG","zones":["America/Port_of_Spain"]},"AI":{"name":"Anguilla","abbr":"AI","zones":["America/Port_of_Spain"]},"AL":{"name":"Albania","abbr":"AL","zones":["Europe/Tirane"]},"AM":{"name":"Armenia","abbr":"AM","zones":["Asia/Yerevan"]},"AO":{"name":"Angola","abbr":"AO","zones":["Africa/Lagos"]},"AQ":{"name":"Antarctica","abbr":"AQ","zones":["Antarctica/Casey","Antarctica/Davis","Antarctica/DumontDUrville","Antarctica/Mawson","Antarctica/Palmer","Antarctica/Rothera","Antarctica/Syowa","Antarctica/Troll","Antarctica/Vostok","Pacific/Auckland"]},"AR":{"name":"Argentina","abbr":"AR","zones":["America/Argentina/Buenos_Aires","America/Argentina/Cordoba","America/Argentina/Salta","America/Argentina/Jujuy","America/Argentina/Tucuman","America/Argentina/Catamarca","America/Argentina/La_Rioja","America/Argentina/San_Juan","America/Argentina/Mendoza","America/Argentina/San_Luis","America/Argentina/Rio_Gallegos","America/Argentina/Ushuaia"]},"AS":{"name":"Samoa (American)","abbr":"AS","zones":["Pacific/Pago_Pago"]},"AT":{"name":"Austria","abbr":"AT","zones":["Europe/Vienna"]},"AU":{"name":"Australia","abbr":"AU","zones":["Australia/Lord_Howe","Antarctica/Macquarie","Australia/Hobart","Australia/Currie","Australia/Melbourne","Australia/Sydney","Australia/Broken_Hill","Australia/Brisbane","Australia/Lindeman","Australia/Adelaide","Australia/Darwin","Australia/Perth","Australia/Eucla"]},"AW":{"name":"Aruba","abbr":"AW","zones":["America/Curacao"]},"AX":{"name":"Åland Islands","abbr":"AX","zones":["Europe/Helsinki"]},"AZ":{"name":"Azerbaijan","abbr":"AZ","zones":["Asia/Baku"]},"BA":{"name":"Bosnia & Herzegovina","abbr":"BA","zones":["Europe/Belgrade"]},"BB":{"name":"Barbados","abbr":"BB","zones":["America/Barbados"]},"BD":{"name":"Bangladesh","abbr":"BD","zones":["Asia/Dhaka"]},"BE":{"name":"Belgium","abbr":"BE","zones":["Europe/Brussels"]},"BF":{"name":"Burkina Faso","abbr":"BF","zones":["Africa/Abidjan"]},"BG":{"name":"Bulgaria","abbr":"BG","zones":["Europe/Sofia"]},"BH":{"name":"Bahrain","abbr":"BH","zones":["Asia/Qatar"]},"BI":{"name":"Burundi","abbr":"BI","zones":["Africa/Maputo"]},"BJ":{"name":"Benin","abbr":"BJ","zones":["Africa/Lagos"]},"BL":{"name":"St Barthelemy","abbr":"BL","zones":["America/Port_of_Spain"]},"BM":{"name":"Bermuda","abbr":"BM","zones":["Atlantic/Bermuda"]},"BN":{"name":"Brunei","abbr":"BN","zones":["Asia/Brunei"]},"BO":{"name":"Bolivia","abbr":"BO","zones":["America/La_Paz"]},"BQ":{"name":"Caribbean NL","abbr":"BQ","zones":["America/Curacao"]},"BR":{"name":"Brazil","abbr":"BR","zones":["America/Noronha","America/Belem","America/Fortaleza","America/Recife","America/Araguaina","America/Maceio","America/Bahia","America/Sao_Paulo","America/Campo_Grande","America/Cuiaba","America/Santarem","America/Porto_Velho","America/Boa_Vista","America/Manaus","America/Eirunepe","America/Rio_Branco"]},"BS":{"name":"Bahamas","abbr":"BS","zones":["America/Nassau"]},"BT":{"name":"Bhutan","abbr":"BT","zones":["Asia/Thimphu"]},"BW":{"name":"Botswana","abbr":"BW","zones":["Africa/Maputo"]},"BY":{"name":"Belarus","abbr":"BY","zones":["Europe/Minsk"]},"BZ":{"name":"Belize","abbr":"BZ","zones":["America/Belize"]},"CA":{"name":"Canada","abbr":"CA","zones":["America/St_Johns","America/Halifax","America/Glace_Bay","America/Moncton","America/Goose_Bay","America/Blanc-Sablon","America/Toronto","America/Nipigon","America/Thunder_Bay","America/Iqaluit","America/Pangnirtung","America/Atikokan","America/Winnipeg","America/Rainy_River","America/Resolute","America/Rankin_Inlet","America/Regina","America/Swift_Current","America/Edmonton","America/Cambridge_Bay","America/Yellowknife","America/Inuvik","America/Creston","America/Dawson_Creek","America/Fort_Nelson","America/Vancouver","America/Whitehorse","America/Dawson"]},"CC":{"name":"Cocos (Keeling) Islands","abbr":"CC","zones":["Indian/Cocos"]},"CD":{"name":"Congo (Dem. Rep.)","abbr":"CD","zones":["Africa/Maputo","Africa/Lagos"]},"CF":{"name":"Central African Rep.","abbr":"CF","zones":["Africa/Lagos"]},"CG":{"name":"Congo (Rep.)","abbr":"CG","zones":["Africa/Lagos"]},"CH":{"name":"Switzerland","abbr":"CH","zones":["Europe/Zurich"]},"CI":{"name":"Côte d'Ivoire","abbr":"CI","zones":["Africa/Abidjan"]},"CK":{"name":"Cook Islands","abbr":"CK","zones":["Pacific/Rarotonga"]},"CL":{"name":"Chile","abbr":"CL","zones":["America/Santiago","Pacific/Easter"]},"CM":{"name":"Cameroon","abbr":"CM","zones":["Africa/Lagos"]},"CN":{"name":"China","abbr":"CN","zones":["Asia/Shanghai","Asia/Urumqi"]},"CO":{"name":"Colombia","abbr":"CO","zones":["America/Bogota"]},"CR":{"name":"Costa Rica","abbr":"CR","zones":["America/Costa_Rica"]},"CU":{"name":"Cuba","abbr":"CU","zones":["America/Havana"]},"CV":{"name":"Cape Verde","abbr":"CV","zones":["Atlantic/Cape_Verde"]},"CW":{"name":"Curacao","abbr":"CW","zones":["America/Curacao"]},"CX":{"name":"Christmas Island","abbr":"CX","zones":["Indian/Christmas"]},"CY":{"name":"Cyprus","abbr":"CY","zones":["Asia/Nicosia"]},"CZ":{"name":"Czech Republic","abbr":"CZ","zones":["Europe/Prague"]},"DE":{"name":"Germany","abbr":"DE","zones":["Europe/Zurich","Europe/Berlin"]},"DJ":{"name":"Djibouti","abbr":"DJ","zones":["Africa/Nairobi"]},"DK":{"name":"Denmark","abbr":"DK","zones":["Europe/Copenhagen"]},"DM":{"name":"Dominica","abbr":"DM","zones":["America/Port_of_Spain"]},"DO":{"name":"Dominican Republic","abbr":"DO","zones":["America/Santo_Domingo"]},"DZ":{"name":"Algeria","abbr":"DZ","zones":["Africa/Algiers"]},"EC":{"name":"Ecuador","abbr":"EC","zones":["America/Guayaquil","Pacific/Galapagos"]},"EE":{"name":"Estonia","abbr":"EE","zones":["Europe/Tallinn"]},"EG":{"name":"Egypt","abbr":"EG","zones":["Africa/Cairo"]},"EH":{"name":"Western Sahara","abbr":"EH","zones":["Africa/El_Aaiun"]},"ER":{"name":"Eritrea","abbr":"ER","zones":["Africa/Nairobi"]},"ES":{"name":"Spain","abbr":"ES","zones":["Europe/Madrid","Africa/Ceuta","Atlantic/Canary"]},"ET":{"name":"Ethiopia","abbr":"ET","zones":["Africa/Nairobi"]},"FI":{"name":"Finland","abbr":"FI","zones":["Europe/Helsinki"]},"FJ":{"name":"Fiji","abbr":"FJ","zones":["Pacific/Fiji"]},"FK":{"name":"Falkland Islands","abbr":"FK","zones":["Atlantic/Stanley"]},"FM":{"name":"Micronesia","abbr":"FM","zones":["Pacific/Chuuk","Pacific/Pohnpei","Pacific/Kosrae"]},"FO":{"name":"Faroe Islands","abbr":"FO","zones":["Atlantic/Faroe"]},"FR":{"name":"France","abbr":"FR","zones":["Europe/Paris"]},"GA":{"name":"Gabon","abbr":"GA","zones":["Africa/Lagos"]},"GB":{"name":"Britain (UK)","abbr":"GB","zones":["Europe/London"]},"GD":{"name":"Grenada","abbr":"GD","zones":["America/Port_of_Spain"]},"GE":{"name":"Georgia","abbr":"GE","zones":["Asia/Tbilisi"]},"GF":{"name":"French Guiana","abbr":"GF","zones":["America/Cayenne"]},"GG":{"name":"Guernsey","abbr":"GG","zones":["Europe/London"]},"GH":{"name":"Ghana","abbr":"GH","zones":["Africa/Accra"]},"GI":{"name":"Gibraltar","abbr":"GI","zones":["Europe/Gibraltar"]},"GL":{"name":"Greenland","abbr":"GL","zones":["America/Godthab","America/Danmarkshavn","America/Scoresbysund","America/Thule"]},"GM":{"name":"Gambia","abbr":"GM","zones":["Africa/Abidjan"]},"GN":{"name":"Guinea","abbr":"GN","zones":["Africa/Abidjan"]},"GP":{"name":"Guadeloupe","abbr":"GP","zones":["America/Port_of_Spain"]},"GQ":{"name":"Equatorial Guinea","abbr":"GQ","zones":["Africa/Lagos"]},"GR":{"name":"Greece","abbr":"GR","zones":["Europe/Athens"]},"GS":{"name":"South Georgia & the South Sandwich Islands","abbr":"GS","zones":["Atlantic/South_Georgia"]},"GT":{"name":"Guatemala","abbr":"GT","zones":["America/Guatemala"]},"GU":{"name":"Guam","abbr":"GU","zones":["Pacific/Guam"]},"GW":{"name":"Guinea-Bissau","abbr":"GW","zones":["Africa/Bissau"]},"GY":{"name":"Guyana","abbr":"GY","zones":["America/Guyana"]},"HK":{"name":"Hong Kong","abbr":"HK","zones":["Asia/Hong_Kong"]},"HN":{"name":"Honduras","abbr":"HN","zones":["America/Tegucigalpa"]},"HR":{"name":"Croatia","abbr":"HR","zones":["Europe/Belgrade"]},"HT":{"name":"Haiti","abbr":"HT","zones":["America/Port-au-Prince"]},"HU":{"name":"Hungary","abbr":"HU","zones":["Europe/Budapest"]},"ID":{"name":"Indonesia","abbr":"ID","zones":["Asia/Jakarta","Asia/Pontianak","Asia/Makassar","Asia/Jayapura"]},"IE":{"name":"Ireland","abbr":"IE","zones":["Europe/Dublin"]},"IL":{"name":"Israel","abbr":"IL","zones":["Asia/Jerusalem"]},"IM":{"name":"Isle of Man","abbr":"IM","zones":["Europe/London"]},"IN":{"name":"India","abbr":"IN","zones":["Asia/Kolkata"]},"IO":{"name":"British Indian Ocean Territory","abbr":"IO","zones":["Indian/Chagos"]},"IQ":{"name":"Iraq","abbr":"IQ","zones":["Asia/Baghdad"]},"IR":{"name":"Iran","abbr":"IR","zones":["Asia/Tehran"]},"IS":{"name":"Iceland","abbr":"IS","zones":["Atlantic/Reykjavik"]},"IT":{"name":"Italy","abbr":"IT","zones":["Europe/Rome"]},"JE":{"name":"Jersey","abbr":"JE","zones":["Europe/London"]},"JM":{"name":"Jamaica","abbr":"JM","zones":["America/Jamaica"]},"JO":{"name":"Jordan","abbr":"JO","zones":["Asia/Amman"]},"JP":{"name":"Japan","abbr":"JP","zones":["Asia/Tokyo"]},"KE":{"name":"Kenya","abbr":"KE","zones":["Africa/Nairobi"]},"KG":{"name":"Kyrgyzstan","abbr":"KG","zones":["Asia/Bishkek"]},"KH":{"name":"Cambodia","abbr":"KH","zones":["Asia/Bangkok"]},"KI":{"name":"Kiribati","abbr":"KI","zones":["Pacific/Tarawa","Pacific/Enderbury","Pacific/Kiritimati"]},"KM":{"name":"Comoros","abbr":"KM","zones":["Africa/Nairobi"]},"KN":{"name":"St Kitts & Nevis","abbr":"KN","zones":["America/Port_of_Spain"]},"KP":{"name":"Korea (North)","abbr":"KP","zones":["Asia/Pyongyang"]},"KR":{"name":"Korea (South)","abbr":"KR","zones":["Asia/Seoul"]},"KW":{"name":"Kuwait","abbr":"KW","zones":["Asia/Riyadh"]},"KY":{"name":"Cayman Islands","abbr":"KY","zones":["America/Panama"]},"KZ":{"name":"Kazakhstan","abbr":"KZ","zones":["Asia/Almaty","Asia/Qyzylorda","Asia/Aqtobe","Asia/Aqtau","Asia/Oral"]},"LA":{"name":"Laos","abbr":"LA","zones":["Asia/Bangkok"]},"LB":{"name":"Lebanon","abbr":"LB","zones":["Asia/Beirut"]},"LC":{"name":"St Lucia","abbr":"LC","zones":["America/Port_of_Spain"]},"LI":{"name":"Liechtenstein","abbr":"LI","zones":["Europe/Zurich"]},"LK":{"name":"Sri Lanka","abbr":"LK","zones":["Asia/Colombo"]},"LR":{"name":"Liberia","abbr":"LR","zones":["Africa/Monrovia"]},"LS":{"name":"Lesotho","abbr":"LS","zones":["Africa/Johannesburg"]},"LT":{"name":"Lithuania","abbr":"LT","zones":["Europe/Vilnius"]},"LU":{"name":"Luxembourg","abbr":"LU","zones":["Europe/Luxembourg"]},"LV":{"name":"Latvia","abbr":"LV","zones":["Europe/Riga"]},"LY":{"name":"Libya","abbr":"LY","zones":["Africa/Tripoli"]},"MA":{"name":"Morocco","abbr":"MA","zones":["Africa/Casablanca"]},"MC":{"name":"Monaco","abbr":"MC","zones":["Europe/Monaco"]},"MD":{"name":"Moldova","abbr":"MD","zones":["Europe/Chisinau"]},"ME":{"name":"Montenegro","abbr":"ME","zones":["Europe/Belgrade"]},"MF":{"name":"St Martin (French)","abbr":"MF","zones":["America/Port_of_Spain"]},"MG":{"name":"Madagascar","abbr":"MG","zones":["Africa/Nairobi"]},"MH":{"name":"Marshall Islands","abbr":"MH","zones":["Pacific/Majuro","Pacific/Kwajalein"]},"MK":{"name":"Macedonia","abbr":"MK","zones":["Europe/Belgrade"]},"ML":{"name":"Mali","abbr":"ML","zones":["Africa/Abidjan"]},"MM":{"name":"Myanmar (Burma)","abbr":"MM","zones":["Asia/Rangoon"]},"MN":{"name":"Mongolia","abbr":"MN","zones":["Asia/Ulaanbaatar","Asia/Hovd","Asia/Choibalsan"]},"MO":{"name":"Macau","abbr":"MO","zones":["Asia/Macau"]},"MP":{"name":"Northern Mariana Islands","abbr":"MP","zones":["Pacific/Guam"]},"MQ":{"name":"Martinique","abbr":"MQ","zones":["America/Martinique"]},"MR":{"name":"Mauritania","abbr":"MR","zones":["Africa/Abidjan"]},"MS":{"name":"Montserrat","abbr":"MS","zones":["America/Port_of_Spain"]},"MT":{"name":"Malta","abbr":"MT","zones":["Europe/Malta"]},"MU":{"name":"Mauritius","abbr":"MU","zones":["Indian/Mauritius"]},"MV":{"name":"Maldives","abbr":"MV","zones":["Indian/Maldives"]},"MW":{"name":"Malawi","abbr":"MW","zones":["Africa/Maputo"]},"MX":{"name":"Mexico","abbr":"MX","zones":["America/Mexico_City","America/Cancun","America/Merida","America/Monterrey","America/Matamoros","America/Mazatlan","America/Chihuahua","America/Ojinaga","America/Hermosillo","America/Tijuana","America/Bahia_Banderas"]},"MY":{"name":"Malaysia","abbr":"MY","zones":["Asia/Kuala_Lumpur","Asia/Kuching"]},"MZ":{"name":"Mozambique","abbr":"MZ","zones":["Africa/Maputo"]},"NA":{"name":"Namibia","abbr":"NA","zones":["Africa/Windhoek"]},"NC":{"name":"New Caledonia","abbr":"NC","zones":["Pacific/Noumea"]},"NE":{"name":"Niger","abbr":"NE","zones":["Africa/Lagos"]},"NF":{"name":"Norfolk Island","abbr":"NF","zones":["Pacific/Norfolk"]},"NG":{"name":"Nigeria","abbr":"NG","zones":["Africa/Lagos"]},"NI":{"name":"Nicaragua","abbr":"NI","zones":["America/Managua"]},"NL":{"name":"Netherlands","abbr":"NL","zones":["Europe/Amsterdam"]},"NO":{"name":"Norway","abbr":"NO","zones":["Europe/Oslo"]},"NP":{"name":"Nepal","abbr":"NP","zones":["Asia/Kathmandu"]},"NR":{"name":"Nauru","abbr":"NR","zones":["Pacific/Nauru"]},"NU":{"name":"Niue","abbr":"NU","zones":["Pacific/Niue"]},"NZ":{"name":"New Zealand","abbr":"NZ","zones":["Pacific/Auckland","Pacific/Chatham"]},"OM":{"name":"Oman","abbr":"OM","zones":["Asia/Dubai"]},"PA":{"name":"Panama","abbr":"PA","zones":["America/Panama"]},"PE":{"name":"Peru","abbr":"PE","zones":["America/Lima"]},"PF":{"name":"French Polynesia","abbr":"PF","zones":["Pacific/Tahiti","Pacific/Marquesas","Pacific/Gambier"]},"PG":{"name":"Papua New Guinea","abbr":"PG","zones":["Pacific/Port_Moresby","Pacific/Bougainville"]},"PH":{"name":"Philippines","abbr":"PH","zones":["Asia/Manila"]},"PK":{"name":"Pakistan","abbr":"PK","zones":["Asia/Karachi"]},"PL":{"name":"Poland","abbr":"PL","zones":["Europe/Warsaw"]},"PM":{"name":"St Pierre & Miquelon","abbr":"PM","zones":["America/Miquelon"]},"PN":{"name":"Pitcairn","abbr":"PN","zones":["Pacific/Pitcairn"]},"PR":{"name":"Puerto Rico","abbr":"PR","zones":["America/Puerto_Rico"]},"PS":{"name":"Palestine","abbr":"PS","zones":["Asia/Gaza","Asia/Hebron"]},"PT":{"name":"Portugal","abbr":"PT","zones":["Europe/Lisbon","Atlantic/Madeira","Atlantic/Azores"]},"PW":{"name":"Palau","abbr":"PW","zones":["Pacific/Palau"]},"PY":{"name":"Paraguay","abbr":"PY","zones":["America/Asuncion"]},"QA":{"name":"Qatar","abbr":"QA","zones":["Asia/Qatar"]},"RE":{"name":"Réunion","abbr":"RE","zones":["Indian/Reunion"]},"RO":{"name":"Romania","abbr":"RO","zones":["Europe/Bucharest"]},"RS":{"name":"Serbia","abbr":"RS","zones":["Europe/Belgrade"]},"RU":{"name":"Russia","abbr":"RU","zones":["Europe/Kaliningrad","Europe/Moscow","Europe/Simferopol","Europe/Volgograd","Europe/Astrakhan","Europe/Samara","Europe/Ulyanovsk","Asia/Yekaterinburg","Asia/Omsk","Asia/Novosibirsk","Asia/Barnaul","Asia/Novokuznetsk","Asia/Krasnoyarsk","Asia/Irkutsk","Asia/Chita","Asia/Yakutsk","Asia/Khandyga","Asia/Vladivostok","Asia/Ust-Nera","Asia/Magadan","Asia/Sakhalin","Asia/Srednekolymsk","Asia/Kamchatka","Asia/Anadyr"]},"RW":{"name":"Rwanda","abbr":"RW","zones":["Africa/Maputo"]},"SA":{"name":"Saudi Arabia","abbr":"SA","zones":["Asia/Riyadh"]},"SB":{"name":"Solomon Islands","abbr":"SB","zones":["Pacific/Guadalcanal"]},"SC":{"name":"Seychelles","abbr":"SC","zones":["Indian/Mahe"]},"SD":{"name":"Sudan","abbr":"SD","zones":["Africa/Khartoum"]},"SE":{"name":"Sweden","abbr":"SE","zones":["Europe/Stockholm"]},"SG":{"name":"Singapore","abbr":"SG","zones":["Asia/Singapore"]},"SH":{"name":"St Helena","abbr":"SH","zones":["Africa/Abidjan"]},"SI":{"name":"Slovenia","abbr":"SI","zones":["Europe/Belgrade"]},"SJ":{"name":"Svalbard & Jan Mayen","abbr":"SJ","zones":["Europe/Oslo"]},"SK":{"name":"Slovakia","abbr":"SK","zones":["Europe/Prague"]},"SL":{"name":"Sierra Leone","abbr":"SL","zones":["Africa/Abidjan"]},"SM":{"name":"San Marino","abbr":"SM","zones":["Europe/Rome"]},"SN":{"name":"Senegal","abbr":"SN","zones":["Africa/Abidjan"]},"SO":{"name":"Somalia","abbr":"SO","zones":["Africa/Nairobi"]},"SR":{"name":"Suriname","abbr":"SR","zones":["America/Paramaribo"]},"SS":{"name":"South Sudan","abbr":"SS","zones":["Africa/Khartoum"]},"ST":{"name":"Sao Tome & Principe","abbr":"ST","zones":["Africa/Abidjan"]},"SV":{"name":"El Salvador","abbr":"SV","zones":["America/El_Salvador"]},"SX":{"name":"St Maarten (Dutch)","abbr":"SX","zones":["America/Curacao"]},"SY":{"name":"Syria","abbr":"SY","zones":["Asia/Damascus"]},"SZ":{"name":"Swaziland","abbr":"SZ","zones":["Africa/Johannesburg"]},"TC":{"name":"Turks & Caicos Is","abbr":"TC","zones":["America/Grand_Turk"]},"TD":{"name":"Chad","abbr":"TD","zones":["Africa/Ndjamena"]},"TF":{"name":"French Southern & Antarctic Lands","abbr":"TF","zones":["Indian/Reunion","Indian/Kerguelen"]},"TG":{"name":"Togo","abbr":"TG","zones":["Africa/Abidjan"]},"TH":{"name":"Thailand","abbr":"TH","zones":["Asia/Bangkok"]},"TJ":{"name":"Tajikistan","abbr":"TJ","zones":["Asia/Dushanbe"]},"TK":{"name":"Tokelau","abbr":"TK","zones":["Pacific/Fakaofo"]},"TL":{"name":"East Timor","abbr":"TL","zones":["Asia/Dili"]},"TM":{"name":"Turkmenistan","abbr":"TM","zones":["Asia/Ashgabat"]},"TN":{"name":"Tunisia","abbr":"TN","zones":["Africa/Tunis"]},"TO":{"name":"Tonga","abbr":"TO","zones":["Pacific/Tongatapu"]},"TR":{"name":"Turkey","abbr":"TR","zones":["Europe/Istanbul"]},"TT":{"name":"Trinidad & Tobago","abbr":"TT","zones":["America/Port_of_Spain"]},"TV":{"name":"Tuvalu","abbr":"TV","zones":["Pacific/Funafuti"]},"TW":{"name":"Taiwan","abbr":"TW","zones":["Asia/Taipei"]},"TZ":{"name":"Tanzania","abbr":"TZ","zones":["Africa/Nairobi"]},"UA":{"name":"Ukraine","abbr":"UA","zones":["Europe/Kiev","Europe/Uzhgorod","Europe/Zaporozhye"]},"UG":{"name":"Uganda","abbr":"UG","zones":["Africa/Nairobi"]},"UM":{"name":"US minor outlying islands","abbr":"UM","zones":["Pacific/Pago_Pago","Pacific/Wake","Pacific/Honolulu"]},"US":{"name":"United States","abbr":"US","zones":["America/New_York","America/Detroit","America/Kentucky/Louisville","America/Kentucky/Monticello","America/Indiana/Indianapolis","America/Indiana/Vincennes","America/Indiana/Winamac","America/Indiana/Marengo","America/Indiana/Petersburg","America/Indiana/Vevay","America/Chicago","America/Indiana/Tell_City","America/Indiana/Knox","America/Menominee","America/North_Dakota/Center","America/North_Dakota/New_Salem","America/North_Dakota/Beulah","America/Denver","America/Boise","America/Phoenix","America/Los_Angeles","America/Anchorage","America/Juneau","America/Sitka","America/Metlakatla","America/Yakutat","America/Nome","America/Adak","Pacific/Honolulu"]},"UY":{"name":"Uruguay","abbr":"UY","zones":["America/Montevideo"]},"UZ":{"name":"Uzbekistan","abbr":"UZ","zones":["Asia/Samarkand","Asia/Tashkent"]},"VA":{"name":"Vatican City","abbr":"VA","zones":["Europe/Rome"]},"VC":{"name":"St Vincent","abbr":"VC","zones":["America/Port_of_Spain"]},"VE":{"name":"Venezuela","abbr":"VE","zones":["America/Caracas"]},"VG":{"name":"Virgin Islands (UK)","abbr":"VG","zones":["America/Port_of_Spain"]},"VI":{"name":"Virgin Islands (US)","abbr":"VI","zones":["America/Port_of_Spain"]},"VN":{"name":"Vietnam","abbr":"VN","zones":["Asia/Bangkok","Asia/Ho_Chi_Minh"]},"VU":{"name":"Vanuatu","abbr":"VU","zones":["Pacific/Efate"]},"WF":{"name":"Wallis & Futuna","abbr":"WF","zones":["Pacific/Wallis"]},"WS":{"name":"Samoa (western)","abbr":"WS","zones":["Pacific/Apia"]},"YE":{"name":"Yemen","abbr":"YE","zones":["Asia/Riyadh"]},"YT":{"name":"Mayotte","abbr":"YT","zones":["Africa/Nairobi"]},"ZA":{"name":"South Africa","abbr":"ZA","zones":["Africa/Johannesburg"]},"ZM":{"name":"Zambia","abbr":"ZM","zones":["Africa/Maputo"]},"ZW":{"name":"Zimbabwe","abbr":"ZW","zones":["Africa/Maputo"]}},"zones":{"Europe/Andorra":{"name":"Europe/Andorra","lat":42.5,"long":1.5167,"countries":["AD"],"comments":""},"Asia/Dubai":{"name":"Asia/Dubai","lat":25.3,"long":55.3,"countries":["AE","OM"],"comments":""},"Asia/Kabul":{"name":"Asia/Kabul","lat":34.5167,"long":69.2,"countries":["AF"],"comments":""},"Europe/Tirane":{"name":"Europe/Tirane","lat":41.3333,"long":19.8333,"countries":["AL"],"comments":""},"Asia/Yerevan":{"name":"Asia/Yerevan","lat":40.1833,"long":44.5,"countries":["AM"],"comments":""},"Antarctica/Casey":{"name":"Antarctica/Casey","lat":-65.7167,"long":110.5167,"countries":["AQ"],"comments":"Casey"},"Antarctica/Davis":{"name":"Antarctica/Davis","lat":-67.4167,"long":77.9667,"countries":["AQ"],"comments":"Davis"},"Antarctica/DumontDUrville":{"name":"Antarctica/DumontDUrville","lat":-65.3333,"long":140.0167,"countries":["AQ"],"comments":"Dumont-d'Urville"},"Antarctica/Mawson":{"name":"Antarctica/Mawson","lat":-66.4,"long":62.8833,"countries":["AQ"],"comments":"Mawson"},"Antarctica/Palmer":{"name":"Antarctica/Palmer","lat":-63.2,"long":-63.9,"countries":["AQ"],"comments":"Palmer"},"Antarctica/Rothera":{"name":"Antarctica/Rothera","lat":-66.4333,"long":-67.8667,"countries":["AQ"],"comments":"Rothera"},"Antarctica/Syowa":{"name":"Antarctica/Syowa","lat":-68.9939,"long":39.59,"countries":["AQ"],"comments":"Syowa"},"Antarctica/Troll":{"name":"Antarctica/Troll","lat":-71.9886,"long":2.535,"countries":["AQ"],"comments":"Troll"},"Antarctica/Vostok":{"name":"Antarctica/Vostok","lat":-77.6,"long":106.9,"countries":["AQ"],"comments":"Vostok"},"America/Argentina/Buenos_Aires":{"name":"America/Argentina/Buenos_Aires","lat":-33.4,"long":-57.55,"countries":["AR"],"comments":"Buenos Aires (BA, CF)"},"America/Argentina/Cordoba":{"name":"America/Argentina/Cordoba","lat":-30.6,"long":-63.8167,"countries":["AR"],"comments":"Argentina (most areas: CB, CC, CN, ER, FM, MN, SE, SF)"},"America/Argentina/Salta":{"name":"America/Argentina/Salta","lat":-23.2167,"long":-64.5833,"countries":["AR"],"comments":"Salta (SA, LP, NQ, RN)"},"America/Argentina/Jujuy":{"name":"America/Argentina/Jujuy","lat":-23.8167,"long":-64.7,"countries":["AR"],"comments":"Jujuy (JY)"},"America/Argentina/Tucuman":{"name":"America/Argentina/Tucuman","lat":-25.1833,"long":-64.7833,"countries":["AR"],"comments":"Tucumán (TM)"},"America/Argentina/Catamarca":{"name":"America/Argentina/Catamarca","lat":-27.5333,"long":-64.2167,"countries":["AR"],"comments":"Catamarca (CT); Chubut (CH)"},"America/Argentina/La_Rioja":{"name":"America/Argentina/La_Rioja","lat":-28.5667,"long":-65.15,"countries":["AR"],"comments":"La Rioja (LR)"},"America/Argentina/San_Juan":{"name":"America/Argentina/San_Juan","lat":-30.4667,"long":-67.4833,"countries":["AR"],"comments":"San Juan (SJ)"},"America/Argentina/Mendoza":{"name":"America/Argentina/Mendoza","lat":-31.1167,"long":-67.1833,"countries":["AR"],"comments":"Mendoza (MZ)"},"America/Argentina/San_Luis":{"name":"America/Argentina/San_Luis","lat":-32.6833,"long":-65.65,"countries":["AR"],"comments":"San Luis (SL)"},"America/Argentina/Rio_Gallegos":{"name":"America/Argentina/Rio_Gallegos","lat":-50.3667,"long":-68.7833,"countries":["AR"],"comments":"Santa Cruz (SC)"},"America/Argentina/Ushuaia":{"name":"America/Argentina/Ushuaia","lat":-53.2,"long":-67.7,"countries":["AR"],"comments":"Tierra del Fuego (TF)"},"Pacific/Pago_Pago":{"name":"Pacific/Pago_Pago","lat":-13.7333,"long":-169.3,"countries":["AS","UM"],"comments":"Samoa, Midway"},"Europe/Vienna":{"name":"Europe/Vienna","lat":48.2167,"long":16.3333,"countries":["AT"],"comments":""},"Australia/Lord_Howe":{"name":"Australia/Lord_Howe","lat":-30.45,"long":159.0833,"countries":["AU"],"comments":"Lord Howe Island"},"Antarctica/Macquarie":{"name":"Antarctica/Macquarie","lat":-53.5,"long":158.95,"countries":["AU"],"comments":"Macquarie Island"},"Australia/Hobart":{"name":"Australia/Hobart","lat":-41.1167,"long":147.3167,"countries":["AU"],"comments":"Tasmania (most areas)"},"Australia/Currie":{"name":"Australia/Currie","lat":-38.0667,"long":143.8667,"countries":["AU"],"comments":"Tasmania (King Island)"},"Australia/Melbourne":{"name":"Australia/Melbourne","lat":-36.1833,"long":144.9667,"countries":["AU"],"comments":"Victoria"},"Australia/Sydney":{"name":"Australia/Sydney","lat":-32.1333,"long":151.2167,"countries":["AU"],"comments":"New South Wales (most areas)"},"Australia/Broken_Hill":{"name":"Australia/Broken_Hill","lat":-30.05,"long":141.45,"countries":["AU"],"comments":"New South Wales (Yancowinna)"},"Australia/Brisbane":{"name":"Australia/Brisbane","lat":-26.5333,"long":153.0333,"countries":["AU"],"comments":"Queensland (most areas)"},"Australia/Lindeman":{"name":"Australia/Lindeman","lat":-19.7333,"long":149,"countries":["AU"],"comments":"Queensland (Whitsunday Islands)"},"Australia/Adelaide":{"name":"Australia/Adelaide","lat":-33.0833,"long":138.5833,"countries":["AU"],"comments":"South Australia"},"Australia/Darwin":{"name":"Australia/Darwin","lat":-11.5333,"long":130.8333,"countries":["AU"],"comments":"Northern Territory"},"Australia/Perth":{"name":"Australia/Perth","lat":-30.05,"long":115.85,"countries":["AU"],"comments":"Western Australia (most areas)"},"Australia/Eucla":{"name":"Australia/Eucla","lat":-30.2833,"long":128.8667,"countries":["AU"],"comments":"Western Australia (Eucla)"},"Asia/Baku":{"name":"Asia/Baku","lat":40.3833,"long":49.85,"countries":["AZ"],"comments":""},"America/Barbados":{"name":"America/Barbados","lat":13.1,"long":-58.3833,"countries":["BB"],"comments":""},"Asia/Dhaka":{"name":"Asia/Dhaka","lat":23.7167,"long":90.4167,"countries":["BD"],"comments":""},"Europe/Brussels":{"name":"Europe/Brussels","lat":50.8333,"long":4.3333,"countries":["BE"],"comments":""},"Europe/Sofia":{"name":"Europe/Sofia","lat":42.6833,"long":23.3167,"countries":["BG"],"comments":""},"Atlantic/Bermuda":{"name":"Atlantic/Bermuda","lat":32.2833,"long":-63.2333,"countries":["BM"],"comments":""},"Asia/Brunei":{"name":"Asia/Brunei","lat":4.9333,"long":114.9167,"countries":["BN"],"comments":""},"America/La_Paz":{"name":"America/La_Paz","lat":-15.5,"long":-67.85,"countries":["BO"],"comments":""},"America/Noronha":{"name":"America/Noronha","lat":-2.15,"long":-31.5833,"countries":["BR"],"comments":"Atlantic islands"},"America/Belem":{"name":"America/Belem","lat":-0.55,"long":-47.5167,"countries":["BR"],"comments":"Pará (east); Amapá"},"America/Fortaleza":{"name":"America/Fortaleza","lat":-2.2833,"long":-37.5,"countries":["BR"],"comments":"Brazil (northeast: MA, PI, CE, RN, PB)"},"America/Recife":{"name":"America/Recife","lat":-7.95,"long":-33.1,"countries":["BR"],"comments":"Pernambuco"},"America/Araguaina":{"name":"America/Araguaina","lat":-6.8,"long":-47.8,"countries":["BR"],"comments":"Tocantins"},"America/Maceio":{"name":"America/Maceio","lat":-8.3333,"long":-34.2833,"countries":["BR"],"comments":"Alagoas, Sergipe"},"America/Bahia":{"name":"America/Bahia","lat":-11.0167,"long":-37.4833,"countries":["BR"],"comments":"Bahia"},"America/Sao_Paulo":{"name":"America/Sao_Paulo","lat":-22.4667,"long":-45.3833,"countries":["BR"],"comments":"Brazil (southeast: GO, DF, MG, ES, RJ, SP, PR, SC, RS)"},"America/Campo_Grande":{"name":"America/Campo_Grande","lat":-19.55,"long":-53.3833,"countries":["BR"],"comments":"Mato Grosso do Sul"},"America/Cuiaba":{"name":"America/Cuiaba","lat":-14.4167,"long":-55.9167,"countries":["BR"],"comments":"Mato Grosso"},"America/Santarem":{"name":"America/Santarem","lat":-1.5667,"long":-53.1333,"countries":["BR"],"comments":"Pará (west)"},"America/Porto_Velho":{"name":"America/Porto_Velho","lat":-7.2333,"long":-62.1,"countries":["BR"],"comments":"Rondônia"},"America/Boa_Vista":{"name":"America/Boa_Vista","lat":2.8167,"long":-59.3333,"countries":["BR"],"comments":"Roraima"},"America/Manaus":{"name":"America/Manaus","lat":-2.8667,"long":-59.9833,"countries":["BR"],"comments":"Amazonas (east)"},"America/Eirunepe":{"name":"America/Eirunepe","lat":-5.3333,"long":-68.1333,"countries":["BR"],"comments":"Amazonas (west)"},"America/Rio_Branco":{"name":"America/Rio_Branco","lat":-8.0333,"long":-66.2,"countries":["BR"],"comments":"Acre"},"America/Nassau":{"name":"America/Nassau","lat":25.0833,"long":-76.65,"countries":["BS"],"comments":""},"Asia/Thimphu":{"name":"Asia/Thimphu","lat":27.4667,"long":89.65,"countries":["BT"],"comments":""},"Europe/Minsk":{"name":"Europe/Minsk","lat":53.9,"long":27.5667,"countries":["BY"],"comments":""},"America/Belize":{"name":"America/Belize","lat":17.5,"long":-87.8,"countries":["BZ"],"comments":""},"America/St_Johns":{"name":"America/St_Johns","lat":47.5667,"long":-51.2833,"countries":["CA"],"comments":"Newfoundland; Labrador (southeast)"},"America/Halifax":{"name":"America/Halifax","lat":44.65,"long":-62.4,"countries":["CA"],"comments":"Atlantic - NS (most areas); PE"},"America/Glace_Bay":{"name":"America/Glace_Bay","lat":46.2,"long":-58.05,"countries":["CA"],"comments":"Atlantic - NS (Cape Breton)"},"America/Moncton":{"name":"America/Moncton","lat":46.1,"long":-63.2167,"countries":["CA"],"comments":"Atlantic - New Brunswick"},"America/Goose_Bay":{"name":"America/Goose_Bay","lat":53.3333,"long":-59.5833,"countries":["CA"],"comments":"Atlantic - Labrador (most areas)"},"America/Blanc-Sablon":{"name":"America/Blanc-Sablon","lat":51.4167,"long":-56.8833,"countries":["CA"],"comments":"AST - QC (Lower North Shore)"},"America/Toronto":{"name":"America/Toronto","lat":43.65,"long":-78.6167,"countries":["CA"],"comments":"Eastern - ON, QC (most areas)"},"America/Nipigon":{"name":"America/Nipigon","lat":49.0167,"long":-87.7333,"countries":["CA"],"comments":"Eastern - ON, QC (no DST 1967-73)"},"America/Thunder_Bay":{"name":"America/Thunder_Bay","lat":48.3833,"long":-88.75,"countries":["CA"],"comments":"Eastern - ON (Thunder Bay)"},"America/Iqaluit":{"name":"America/Iqaluit","lat":63.7333,"long":-67.5333,"countries":["CA"],"comments":"Eastern - NU (most east areas)"},"America/Pangnirtung":{"name":"America/Pangnirtung","lat":66.1333,"long":-64.2667,"countries":["CA"],"comments":"Eastern - NU (Pangnirtung)"},"America/Atikokan":{"name":"America/Atikokan","lat":48.7586,"long":-90.3783,"countries":["CA"],"comments":"EST - ON (Atikokan); NU (Coral H)"},"America/Winnipeg":{"name":"America/Winnipeg","lat":49.8833,"long":-96.85,"countries":["CA"],"comments":"Central - ON (west); Manitoba"},"America/Rainy_River":{"name":"America/Rainy_River","lat":48.7167,"long":-93.4333,"countries":["CA"],"comments":"Central - ON (Rainy R, Ft Frances)"},"America/Resolute":{"name":"America/Resolute","lat":74.6956,"long":-93.1708,"countries":["CA"],"comments":"Central - NU (Resolute)"},"America/Rankin_Inlet":{"name":"America/Rankin_Inlet","lat":62.8167,"long":-91.9169,"countries":["CA"],"comments":"Central - NU (central)"},"America/Regina":{"name":"America/Regina","lat":50.4,"long":-103.35,"countries":["CA"],"comments":"CST - SK (most areas)"},"America/Swift_Current":{"name":"America/Swift_Current","lat":50.2833,"long":-106.1667,"countries":["CA"],"comments":"CST - SK (midwest)"},"America/Edmonton":{"name":"America/Edmonton","lat":53.55,"long":-112.5333,"countries":["CA"],"comments":"Mountain - AB; BC (E); SK (W)"},"America/Cambridge_Bay":{"name":"America/Cambridge_Bay","lat":69.1139,"long":-104.9472,"countries":["CA"],"comments":"Mountain - NU (west)"},"America/Yellowknife":{"name":"America/Yellowknife","lat":62.45,"long":-113.65,"countries":["CA"],"comments":"Mountain - NT (central)"},"America/Inuvik":{"name":"America/Inuvik","lat":68.3497,"long":-132.2833,"countries":["CA"],"comments":"Mountain - NT (west)"},"America/Creston":{"name":"America/Creston","lat":49.1,"long":-115.4833,"countries":["CA"],"comments":"MST - BC (Creston)"},"America/Dawson_Creek":{"name":"America/Dawson_Creek","lat":59.7667,"long":-119.7667,"countries":["CA"],"comments":"MST - BC (Dawson Cr, Ft St John)"},"America/Fort_Nelson":{"name":"America/Fort_Nelson","lat":58.8,"long":-121.3,"countries":["CA"],"comments":"MST - BC (Ft Nelson)"},"America/Vancouver":{"name":"America/Vancouver","lat":49.2667,"long":-122.8833,"countries":["CA"],"comments":"Pacific - BC (most areas)"},"America/Whitehorse":{"name":"America/Whitehorse","lat":60.7167,"long":-134.95,"countries":["CA"],"comments":"Pacific - Yukon (south)"},"America/Dawson":{"name":"America/Dawson","lat":64.0667,"long":-138.5833,"countries":["CA"],"comments":"Pacific - Yukon (north)"},"Indian/Cocos":{"name":"Indian/Cocos","lat":-11.8333,"long":96.9167,"countries":["CC"],"comments":""},"Europe/Zurich":{"name":"Europe/Zurich","lat":47.3833,"long":8.5333,"countries":["CH","DE","LI"],"comments":"Swiss time"},"Africa/Abidjan":{"name":"Africa/Abidjan","lat":5.3167,"long":-3.9667,"countries":["CI","BF","GM","GN","ML","MR","SH","SL","SN","ST","TG"],"comments":""},"Pacific/Rarotonga":{"name":"Pacific/Rarotonga","lat":-20.7667,"long":-158.2333,"countries":["CK"],"comments":""},"America/Santiago":{"name":"America/Santiago","lat":-32.55,"long":-69.3333,"countries":["CL"],"comments":"Chile (most areas)"},"Pacific/Easter":{"name":"Pacific/Easter","lat":-26.85,"long":-108.5667,"countries":["CL"],"comments":"Easter Island"},"Asia/Shanghai":{"name":"Asia/Shanghai","lat":31.2333,"long":121.4667,"countries":["CN"],"comments":"Beijing Time"},"Asia/Urumqi":{"name":"Asia/Urumqi","lat":43.8,"long":87.5833,"countries":["CN"],"comments":"Xinjiang Time"},"America/Bogota":{"name":"America/Bogota","lat":4.6,"long":-73.9167,"countries":["CO"],"comments":""},"America/Costa_Rica":{"name":"America/Costa_Rica","lat":9.9333,"long":-83.9167,"countries":["CR"],"comments":""},"America/Havana":{"name":"America/Havana","lat":23.1333,"long":-81.6333,"countries":["CU"],"comments":""},"Atlantic/Cape_Verde":{"name":"Atlantic/Cape_Verde","lat":14.9167,"long":-22.4833,"countries":["CV"],"comments":""},"America/Curacao":{"name":"America/Curacao","lat":12.1833,"long":-69,"countries":["CW","AW","BQ","SX"],"comments":""},"Indian/Christmas":{"name":"Indian/Christmas","lat":-9.5833,"long":105.7167,"countries":["CX"],"comments":""},"Asia/Nicosia":{"name":"Asia/Nicosia","lat":35.1667,"long":33.3667,"countries":["CY"],"comments":""},"Europe/Prague":{"name":"Europe/Prague","lat":50.0833,"long":14.4333,"countries":["CZ","SK"],"comments":""},"Europe/Berlin":{"name":"Europe/Berlin","lat":52.5,"long":13.3667,"countries":["DE"],"comments":"Germany (most areas)"},"Europe/Copenhagen":{"name":"Europe/Copenhagen","lat":55.6667,"long":12.5833,"countries":["DK"],"comments":""},"America/Santo_Domingo":{"name":"America/Santo_Domingo","lat":18.4667,"long":-68.1,"countries":["DO"],"comments":""},"Africa/Algiers":{"name":"Africa/Algiers","lat":36.7833,"long":3.05,"countries":["DZ"],"comments":""},"America/Guayaquil":{"name":"America/Guayaquil","lat":-1.8333,"long":-78.1667,"countries":["EC"],"comments":"Ecuador (mainland)"},"Pacific/Galapagos":{"name":"Pacific/Galapagos","lat":0.9,"long":-88.4,"countries":["EC"],"comments":"Galápagos Islands"},"Europe/Tallinn":{"name":"Europe/Tallinn","lat":59.4167,"long":24.75,"countries":["EE"],"comments":""},"Africa/Cairo":{"name":"Africa/Cairo","lat":30.05,"long":31.25,"countries":["EG"],"comments":""},"Africa/El_Aaiun":{"name":"Africa/El_Aaiun","lat":27.15,"long":-12.8,"countries":["EH"],"comments":""},"Europe/Madrid":{"name":"Europe/Madrid","lat":40.4,"long":-2.3167,"countries":["ES"],"comments":"Spain (mainland)"},"Africa/Ceuta":{"name":"Africa/Ceuta","lat":35.8833,"long":-4.6833,"countries":["ES"],"comments":"Ceuta, Melilla"},"Atlantic/Canary":{"name":"Atlantic/Canary","lat":28.1,"long":-14.6,"countries":["ES"],"comments":"Canary Islands"},"Europe/Helsinki":{"name":"Europe/Helsinki","lat":60.1667,"long":24.9667,"countries":["FI","AX"],"comments":""},"Pacific/Fiji":{"name":"Pacific/Fiji","lat":-17.8667,"long":178.4167,"countries":["FJ"],"comments":""},"Atlantic/Stanley":{"name":"Atlantic/Stanley","lat":-50.3,"long":-56.15,"countries":["FK"],"comments":""},"Pacific/Chuuk":{"name":"Pacific/Chuuk","lat":7.4167,"long":151.7833,"countries":["FM"],"comments":"Chuuk/Truk, Yap"},"Pacific/Pohnpei":{"name":"Pacific/Pohnpei","lat":6.9667,"long":158.2167,"countries":["FM"],"comments":"Pohnpei/Ponape"},"Pacific/Kosrae":{"name":"Pacific/Kosrae","lat":5.3167,"long":162.9833,"countries":["FM"],"comments":"Kosrae"},"Atlantic/Faroe":{"name":"Atlantic/Faroe","lat":62.0167,"long":-5.2333,"countries":["FO"],"comments":""},"Europe/Paris":{"name":"Europe/Paris","lat":48.8667,"long":2.3333,"countries":["FR"],"comments":""},"Europe/London":{"name":"Europe/London","lat":51.5083,"long":0.1253,"countries":["GB","GG","IM","JE"],"comments":""},"Asia/Tbilisi":{"name":"Asia/Tbilisi","lat":41.7167,"long":44.8167,"countries":["GE"],"comments":""},"America/Cayenne":{"name":"America/Cayenne","lat":4.9333,"long":-51.6667,"countries":["GF"],"comments":""},"Africa/Accra":{"name":"Africa/Accra","lat":5.55,"long":0.2167,"countries":["GH"],"comments":""},"Europe/Gibraltar":{"name":"Europe/Gibraltar","lat":36.1333,"long":-4.65,"countries":["GI"],"comments":""},"America/Godthab":{"name":"America/Godthab","lat":64.1833,"long":-50.2667,"countries":["GL"],"comments":"Greenland (most areas)"},"America/Danmarkshavn":{"name":"America/Danmarkshavn","lat":76.7667,"long":-17.3333,"countries":["GL"],"comments":"National Park (east coast)"},"America/Scoresbysund":{"name":"America/Scoresbysund","lat":70.4833,"long":-20.0333,"countries":["GL"],"comments":"Scoresbysund/Ittoqqortoormiit"},"America/Thule":{"name":"America/Thule","lat":76.5667,"long":-67.2167,"countries":["GL"],"comments":"Thule/Pituffik"},"Europe/Athens":{"name":"Europe/Athens","lat":37.9667,"long":23.7167,"countries":["GR"],"comments":""},"Atlantic/South_Georgia":{"name":"Atlantic/South_Georgia","lat":-53.7333,"long":-35.4667,"countries":["GS"],"comments":""},"America/Guatemala":{"name":"America/Guatemala","lat":14.6333,"long":-89.4833,"countries":["GT"],"comments":""},"Pacific/Guam":{"name":"Pacific/Guam","lat":13.4667,"long":144.75,"countries":["GU","MP"],"comments":""},"Africa/Bissau":{"name":"Africa/Bissau","lat":11.85,"long":-14.4167,"countries":["GW"],"comments":""},"America/Guyana":{"name":"America/Guyana","lat":6.8,"long":-57.8333,"countries":["GY"],"comments":""},"Asia/Hong_Kong":{"name":"Asia/Hong_Kong","lat":22.2833,"long":114.15,"countries":["HK"],"comments":""},"America/Tegucigalpa":{"name":"America/Tegucigalpa","lat":14.1,"long":-86.7833,"countries":["HN"],"comments":""},"America/Port-au-Prince":{"name":"America/Port-au-Prince","lat":18.5333,"long":-71.6667,"countries":["HT"],"comments":""},"Europe/Budapest":{"name":"Europe/Budapest","lat":47.5,"long":19.0833,"countries":["HU"],"comments":""},"Asia/Jakarta":{"name":"Asia/Jakarta","lat":-5.8333,"long":106.8,"countries":["ID"],"comments":"Java, Sumatra"},"Asia/Pontianak":{"name":"Asia/Pontianak","lat":0.0333,"long":109.3333,"countries":["ID"],"comments":"Borneo (west, central)"},"Asia/Makassar":{"name":"Asia/Makassar","lat":-4.8833,"long":119.4,"countries":["ID"],"comments":"Borneo (east, south); Sulawesi/Celebes, Bali, Nusa Tengarra; Timor (west)"},"Asia/Jayapura":{"name":"Asia/Jayapura","lat":-1.4667,"long":140.7,"countries":["ID"],"comments":"New Guinea (West Papua / Irian Jaya); Malukus/Moluccas"},"Europe/Dublin":{"name":"Europe/Dublin","lat":53.3333,"long":-5.75,"countries":["IE"],"comments":""},"Asia/Jerusalem":{"name":"Asia/Jerusalem","lat":31.7806,"long":35.2239,"countries":["IL"],"comments":""},"Asia/Kolkata":{"name":"Asia/Kolkata","lat":22.5333,"long":88.3667,"countries":["IN"],"comments":""},"Indian/Chagos":{"name":"Indian/Chagos","lat":-6.6667,"long":72.4167,"countries":["IO"],"comments":""},"Asia/Baghdad":{"name":"Asia/Baghdad","lat":33.35,"long":44.4167,"countries":["IQ"],"comments":""},"Asia/Tehran":{"name":"Asia/Tehran","lat":35.6667,"long":51.4333,"countries":["IR"],"comments":""},"Atlantic/Reykjavik":{"name":"Atlantic/Reykjavik","lat":64.15,"long":-20.15,"countries":["IS"],"comments":""},"Europe/Rome":{"name":"Europe/Rome","lat":41.9,"long":12.4833,"countries":["IT","SM","VA"],"comments":""},"America/Jamaica":{"name":"America/Jamaica","lat":17.9681,"long":-75.2067,"countries":["JM"],"comments":""},"Asia/Amman":{"name":"Asia/Amman","lat":31.95,"long":35.9333,"countries":["JO"],"comments":""},"Asia/Tokyo":{"name":"Asia/Tokyo","lat":35.6544,"long":139.7447,"countries":["JP"],"comments":""},"Africa/Nairobi":{"name":"Africa/Nairobi","lat":-0.7167,"long":36.8167,"countries":["KE","DJ","ER","ET","KM","MG","SO","TZ","UG","YT"],"comments":""},"Asia/Bishkek":{"name":"Asia/Bishkek","lat":42.9,"long":74.6,"countries":["KG"],"comments":""},"Pacific/Tarawa":{"name":"Pacific/Tarawa","lat":1.4167,"long":173,"countries":["KI"],"comments":"Gilbert Islands"},"Pacific/Enderbury":{"name":"Pacific/Enderbury","lat":-2.8667,"long":-170.9167,"countries":["KI"],"comments":"Phoenix Islands"},"Pacific/Kiritimati":{"name":"Pacific/Kiritimati","lat":1.8667,"long":-156.6667,"countries":["KI"],"comments":"Line Islands"},"Asia/Pyongyang":{"name":"Asia/Pyongyang","lat":39.0167,"long":125.75,"countries":["KP"],"comments":""},"Asia/Seoul":{"name":"Asia/Seoul","lat":37.55,"long":126.9667,"countries":["KR"],"comments":""},"Asia/Almaty":{"name":"Asia/Almaty","lat":43.25,"long":76.95,"countries":["KZ"],"comments":"Kazakhstan (most areas)"},"Asia/Qyzylorda":{"name":"Asia/Qyzylorda","lat":44.8,"long":65.4667,"countries":["KZ"],"comments":"Qyzylorda/Kyzylorda/Kzyl-Orda"},"Asia/Aqtobe":{"name":"Asia/Aqtobe","lat":50.2833,"long":57.1667,"countries":["KZ"],"comments":"Aqtobe/Aktobe"},"Asia/Aqtau":{"name":"Asia/Aqtau","lat":44.5167,"long":50.2667,"countries":["KZ"],"comments":"Atyrau/Atirau/Gur'yev, Mangghystau/Mankistau"},"Asia/Oral":{"name":"Asia/Oral","lat":51.2167,"long":51.35,"countries":["KZ"],"comments":"West Kazakhstan"},"Asia/Beirut":{"name":"Asia/Beirut","lat":33.8833,"long":35.5,"countries":["LB"],"comments":""},"Asia/Colombo":{"name":"Asia/Colombo","lat":6.9333,"long":79.85,"countries":["LK"],"comments":""},"Africa/Monrovia":{"name":"Africa/Monrovia","lat":6.3,"long":-9.2167,"countries":["LR"],"comments":""},"Europe/Vilnius":{"name":"Europe/Vilnius","lat":54.6833,"long":25.3167,"countries":["LT"],"comments":""},"Europe/Luxembourg":{"name":"Europe/Luxembourg","lat":49.6,"long":6.15,"countries":["LU"],"comments":""},"Europe/Riga":{"name":"Europe/Riga","lat":56.95,"long":24.1,"countries":["LV"],"comments":""},"Africa/Tripoli":{"name":"Africa/Tripoli","lat":32.9,"long":13.1833,"countries":["LY"],"comments":""},"Africa/Casablanca":{"name":"Africa/Casablanca","lat":33.65,"long":-6.4167,"countries":["MA"],"comments":""},"Europe/Monaco":{"name":"Europe/Monaco","lat":43.7,"long":7.3833,"countries":["MC"],"comments":""},"Europe/Chisinau":{"name":"Europe/Chisinau","lat":47,"long":28.8333,"countries":["MD"],"comments":""},"Pacific/Majuro":{"name":"Pacific/Majuro","lat":7.15,"long":171.2,"countries":["MH"],"comments":"Marshall Islands (most areas)"},"Pacific/Kwajalein":{"name":"Pacific/Kwajalein","lat":9.0833,"long":167.3333,"countries":["MH"],"comments":"Kwajalein"},"Asia/Rangoon":{"name":"Asia/Rangoon","lat":16.7833,"long":96.1667,"countries":["MM"],"comments":""},"Asia/Ulaanbaatar":{"name":"Asia/Ulaanbaatar","lat":47.9167,"long":106.8833,"countries":["MN"],"comments":"Mongolia (most areas)"},"Asia/Hovd":{"name":"Asia/Hovd","lat":48.0167,"long":91.65,"countries":["MN"],"comments":"Bayan-Ölgii, Govi-Altai, Hovd, Uvs, Zavkhan"},"Asia/Choibalsan":{"name":"Asia/Choibalsan","lat":48.0667,"long":114.5,"countries":["MN"],"comments":"Dornod, Sükhbaatar"},"Asia/Macau":{"name":"Asia/Macau","lat":22.2333,"long":113.5833,"countries":["MO"],"comments":""},"America/Martinique":{"name":"America/Martinique","lat":14.6,"long":-60.9167,"countries":["MQ"],"comments":""},"Europe/Malta":{"name":"Europe/Malta","lat":35.9,"long":14.5167,"countries":["MT"],"comments":""},"Indian/Mauritius":{"name":"Indian/Mauritius","lat":-19.8333,"long":57.5,"countries":["MU"],"comments":""},"Indian/Maldives":{"name":"Indian/Maldives","lat":4.1667,"long":73.5,"countries":["MV"],"comments":""},"America/Mexico_City":{"name":"America/Mexico_City","lat":19.4,"long":-98.85,"countries":["MX"],"comments":"Central Time"},"America/Cancun":{"name":"America/Cancun","lat":21.0833,"long":-85.2333,"countries":["MX"],"comments":"Eastern Standard Time - Quintana Roo"},"America/Merida":{"name":"America/Merida","lat":20.9667,"long":-88.3833,"countries":["MX"],"comments":"Central Time - Campeche, Yucatán"},"America/Monterrey":{"name":"America/Monterrey","lat":25.6667,"long":-99.6833,"countries":["MX"],"comments":"Central Time - Durango; Coahuila, Nuevo León, Tamaulipas (most areas)"},"America/Matamoros":{"name":"America/Matamoros","lat":25.8333,"long":-96.5,"countries":["MX"],"comments":"Central Time US - Coahuila, Nuevo León, Tamaulipas (US border)"},"America/Mazatlan":{"name":"America/Mazatlan","lat":23.2167,"long":-105.5833,"countries":["MX"],"comments":"Mountain Time - Baja California Sur, Nayarit, Sinaloa"},"America/Chihuahua":{"name":"America/Chihuahua","lat":28.6333,"long":-105.9167,"countries":["MX"],"comments":"Mountain Time - Chihuahua (most areas)"},"America/Ojinaga":{"name":"America/Ojinaga","lat":29.5667,"long":-103.5833,"countries":["MX"],"comments":"Mountain Time US - Chihuahua (US border)"},"America/Hermosillo":{"name":"America/Hermosillo","lat":29.0667,"long":-109.0333,"countries":["MX"],"comments":"Mountain Standard Time - Sonora"},"America/Tijuana":{"name":"America/Tijuana","lat":32.5333,"long":-116.9833,"countries":["MX"],"comments":"Pacific Time US - Baja California"},"America/Bahia_Banderas":{"name":"America/Bahia_Banderas","lat":20.8,"long":-104.75,"countries":["MX"],"comments":"Central Time - Bahía de Banderas"},"Asia/Kuala_Lumpur":{"name":"Asia/Kuala_Lumpur","lat":3.1667,"long":101.7,"countries":["MY"],"comments":"Malaysia (peninsula)"},"Asia/Kuching":{"name":"Asia/Kuching","lat":1.55,"long":110.3333,"countries":["MY"],"comments":"Sabah, Sarawak"},"Africa/Maputo":{"name":"Africa/Maputo","lat":-24.0333,"long":32.5833,"countries":["MZ","BI","BW","CD","MW","RW","ZM","ZW"],"comments":"Central Africa Time"},"Africa/Windhoek":{"name":"Africa/Windhoek","lat":-21.4333,"long":17.1,"countries":["NA"],"comments":""},"Pacific/Noumea":{"name":"Pacific/Noumea","lat":-21.7333,"long":166.45,"countries":["NC"],"comments":""},"Pacific/Norfolk":{"name":"Pacific/Norfolk","lat":-28.95,"long":167.9667,"countries":["NF"],"comments":""},"Africa/Lagos":{"name":"Africa/Lagos","lat":6.45,"long":3.4,"countries":["NG","AO","BJ","CD","CF","CG","CM","GA","GQ","NE"],"comments":"West Africa Time"},"America/Managua":{"name":"America/Managua","lat":12.15,"long":-85.7167,"countries":["NI"],"comments":""},"Europe/Amsterdam":{"name":"Europe/Amsterdam","lat":52.3667,"long":4.9,"countries":["NL"],"comments":""},"Europe/Oslo":{"name":"Europe/Oslo","lat":59.9167,"long":10.75,"countries":["NO","SJ"],"comments":""},"Asia/Kathmandu":{"name":"Asia/Kathmandu","lat":27.7167,"long":85.3167,"countries":["NP"],"comments":""},"Pacific/Nauru":{"name":"Pacific/Nauru","lat":0.5167,"long":166.9167,"countries":["NR"],"comments":""},"Pacific/Niue":{"name":"Pacific/Niue","lat":-18.9833,"long":-168.0833,"countries":["NU"],"comments":""},"Pacific/Auckland":{"name":"Pacific/Auckland","lat":-35.1333,"long":174.7667,"countries":["NZ","AQ"],"comments":"New Zealand time"},"Pacific/Chatham":{"name":"Pacific/Chatham","lat":-42.05,"long":-175.45,"countries":["NZ"],"comments":"Chatham Islands"},"America/Panama":{"name":"America/Panama","lat":8.9667,"long":-78.4667,"countries":["PA","KY"],"comments":""},"America/Lima":{"name":"America/Lima","lat":-11.95,"long":-76.95,"countries":["PE"],"comments":""},"Pacific/Tahiti":{"name":"Pacific/Tahiti","lat":-16.4667,"long":-148.4333,"countries":["PF"],"comments":"Society Islands"},"Pacific/Marquesas":{"name":"Pacific/Marquesas","lat":-9,"long":-138.5,"countries":["PF"],"comments":"Marquesas Islands"},"Pacific/Gambier":{"name":"Pacific/Gambier","lat":-22.8667,"long":-133.05,"countries":["PF"],"comments":"Gambier Islands"},"Pacific/Port_Moresby":{"name":"Pacific/Port_Moresby","lat":-8.5,"long":147.1667,"countries":["PG"],"comments":"Papua New Guinea (most areas)"},"Pacific/Bougainville":{"name":"Pacific/Bougainville","lat":-5.7833,"long":155.5667,"countries":["PG"],"comments":"Bougainville"},"Asia/Manila":{"name":"Asia/Manila","lat":14.5833,"long":121,"countries":["PH"],"comments":""},"Asia/Karachi":{"name":"Asia/Karachi","lat":24.8667,"long":67.05,"countries":["PK"],"comments":""},"Europe/Warsaw":{"name":"Europe/Warsaw","lat":52.25,"long":21,"countries":["PL"],"comments":""},"America/Miquelon":{"name":"America/Miquelon","lat":47.05,"long":-55.6667,"countries":["PM"],"comments":""},"Pacific/Pitcairn":{"name":"Pacific/Pitcairn","lat":-24.9333,"long":-129.9167,"countries":["PN"],"comments":""},"America/Puerto_Rico":{"name":"America/Puerto_Rico","lat":18.4683,"long":-65.8939,"countries":["PR"],"comments":""},"Asia/Gaza":{"name":"Asia/Gaza","lat":31.5,"long":34.4667,"countries":["PS"],"comments":"Gaza Strip"},"Asia/Hebron":{"name":"Asia/Hebron","lat":31.5333,"long":35.095,"countries":["PS"],"comments":"West Bank"},"Europe/Lisbon":{"name":"Europe/Lisbon","lat":38.7167,"long":-8.8667,"countries":["PT"],"comments":"Portugal (mainland)"},"Atlantic/Madeira":{"name":"Atlantic/Madeira","lat":32.6333,"long":-15.1,"countries":["PT"],"comments":"Madeira Islands"},"Atlantic/Azores":{"name":"Atlantic/Azores","lat":37.7333,"long":-24.3333,"countries":["PT"],"comments":"Azores"},"Pacific/Palau":{"name":"Pacific/Palau","lat":7.3333,"long":134.4833,"countries":["PW"],"comments":""},"America/Asuncion":{"name":"America/Asuncion","lat":-24.7333,"long":-56.3333,"countries":["PY"],"comments":""},"Asia/Qatar":{"name":"Asia/Qatar","lat":25.2833,"long":51.5333,"countries":["QA","BH"],"comments":""},"Indian/Reunion":{"name":"Indian/Reunion","lat":-19.1333,"long":55.4667,"countries":["RE","TF"],"comments":"Réunion, Crozet, Scattered Islands"},"Europe/Bucharest":{"name":"Europe/Bucharest","lat":44.4333,"long":26.1,"countries":["RO"],"comments":""},"Europe/Belgrade":{"name":"Europe/Belgrade","lat":44.8333,"long":20.5,"countries":["RS","BA","HR","ME","MK","SI"],"comments":""},"Europe/Kaliningrad":{"name":"Europe/Kaliningrad","lat":54.7167,"long":20.5,"countries":["RU"],"comments":"MSK-01 - Kaliningrad"},"Europe/Moscow":{"name":"Europe/Moscow","lat":55.7558,"long":37.6178,"countries":["RU"],"comments":"MSK+00 - Moscow area"},"Europe/Simferopol":{"name":"Europe/Simferopol","lat":44.95,"long":34.1,"countries":["RU"],"comments":"MSK+00 - Crimea"},"Europe/Volgograd":{"name":"Europe/Volgograd","lat":48.7333,"long":44.4167,"countries":["RU"],"comments":"MSK+00 - Volgograd, Kirov, Saratov"},"Europe/Astrakhan":{"name":"Europe/Astrakhan","lat":46.35,"long":48.05,"countries":["RU"],"comments":"MSK+01 - Astrakhan"},"Europe/Samara":{"name":"Europe/Samara","lat":53.2,"long":50.15,"countries":["RU"],"comments":"MSK+01 - Samara, Udmurtia"},"Europe/Ulyanovsk":{"name":"Europe/Ulyanovsk","lat":54.3333,"long":48.4,"countries":["RU"],"comments":"MSK+01 - Ulyanovsk"},"Asia/Yekaterinburg":{"name":"Asia/Yekaterinburg","lat":56.85,"long":60.6,"countries":["RU"],"comments":"MSK+02 - Urals"},"Asia/Omsk":{"name":"Asia/Omsk","lat":55,"long":73.4,"countries":["RU"],"comments":"MSK+03 - Omsk"},"Asia/Novosibirsk":{"name":"Asia/Novosibirsk","lat":55.0333,"long":82.9167,"countries":["RU"],"comments":"MSK+03 - Novosibirsk, Tomsk"},"Asia/Barnaul":{"name":"Asia/Barnaul","lat":53.3667,"long":83.75,"countries":["RU"],"comments":"MSK+04 - Altai"},"Asia/Novokuznetsk":{"name":"Asia/Novokuznetsk","lat":53.75,"long":87.1167,"countries":["RU"],"comments":"MSK+04 - Kemerovo"},"Asia/Krasnoyarsk":{"name":"Asia/Krasnoyarsk","lat":56.0167,"long":92.8333,"countries":["RU"],"comments":"MSK+04 - Krasnoyarsk area"},"Asia/Irkutsk":{"name":"Asia/Irkutsk","lat":52.2667,"long":104.3333,"countries":["RU"],"comments":"MSK+05 - Irkutsk, Buryatia"},"Asia/Chita":{"name":"Asia/Chita","lat":52.05,"long":113.4667,"countries":["RU"],"comments":"MSK+06 - Zabaykalsky"},"Asia/Yakutsk":{"name":"Asia/Yakutsk","lat":62,"long":129.6667,"countries":["RU"],"comments":"MSK+06 - Lena River"},"Asia/Khandyga":{"name":"Asia/Khandyga","lat":62.6564,"long":135.5539,"countries":["RU"],"comments":"MSK+06 - Tomponsky, Ust-Maysky"},"Asia/Vladivostok":{"name":"Asia/Vladivostok","lat":43.1667,"long":131.9333,"countries":["RU"],"comments":"MSK+07 - Amur River"},"Asia/Ust-Nera":{"name":"Asia/Ust-Nera","lat":64.5603,"long":143.2267,"countries":["RU"],"comments":"MSK+07 - Oymyakonsky"},"Asia/Magadan":{"name":"Asia/Magadan","lat":59.5667,"long":150.8,"countries":["RU"],"comments":"MSK+07 - Magadan"},"Asia/Sakhalin":{"name":"Asia/Sakhalin","lat":46.9667,"long":142.7,"countries":["RU"],"comments":"MSK+08 - Sakhalin Island"},"Asia/Srednekolymsk":{"name":"Asia/Srednekolymsk","lat":67.4667,"long":153.7167,"countries":["RU"],"comments":"MSK+08 - Sakha (E); North Kuril Is"},"Asia/Kamchatka":{"name":"Asia/Kamchatka","lat":53.0167,"long":158.65,"countries":["RU"],"comments":"MSK+09 - Kamchatka"},"Asia/Anadyr":{"name":"Asia/Anadyr","lat":64.75,"long":177.4833,"countries":["RU"],"comments":"MSK+09 - Bering Sea"},"Asia/Riyadh":{"name":"Asia/Riyadh","lat":24.6333,"long":46.7167,"countries":["SA","KW","YE"],"comments":""},"Pacific/Guadalcanal":{"name":"Pacific/Guadalcanal","lat":-8.4667,"long":160.2,"countries":["SB"],"comments":""},"Indian/Mahe":{"name":"Indian/Mahe","lat":-3.3333,"long":55.4667,"countries":["SC"],"comments":""},"Africa/Khartoum":{"name":"Africa/Khartoum","lat":15.6,"long":32.5333,"countries":["SD","SS"],"comments":""},"Europe/Stockholm":{"name":"Europe/Stockholm","lat":59.3333,"long":18.05,"countries":["SE"],"comments":""},"Asia/Singapore":{"name":"Asia/Singapore","lat":1.2833,"long":103.85,"countries":["SG"],"comments":""},"America/Paramaribo":{"name":"America/Paramaribo","lat":5.8333,"long":-54.8333,"countries":["SR"],"comments":""},"America/El_Salvador":{"name":"America/El_Salvador","lat":13.7,"long":-88.8,"countries":["SV"],"comments":""},"Asia/Damascus":{"name":"Asia/Damascus","lat":33.5,"long":36.3,"countries":["SY"],"comments":""},"America/Grand_Turk":{"name":"America/Grand_Turk","lat":21.4667,"long":-70.8667,"countries":["TC"],"comments":""},"Africa/Ndjamena":{"name":"Africa/Ndjamena","lat":12.1167,"long":15.05,"countries":["TD"],"comments":""},"Indian/Kerguelen":{"name":"Indian/Kerguelen","lat":-48.6472,"long":70.2175,"countries":["TF"],"comments":"Kerguelen, St Paul Island, Amsterdam Island"},"Asia/Bangkok":{"name":"Asia/Bangkok","lat":13.75,"long":100.5167,"countries":["TH","KH","LA","VN"],"comments":"Indochina (most areas)"},"Asia/Dushanbe":{"name":"Asia/Dushanbe","lat":38.5833,"long":68.8,"countries":["TJ"],"comments":""},"Pacific/Fakaofo":{"name":"Pacific/Fakaofo","lat":-8.6333,"long":-170.7667,"countries":["TK"],"comments":""},"Asia/Dili":{"name":"Asia/Dili","lat":-7.45,"long":125.5833,"countries":["TL"],"comments":""},"Asia/Ashgabat":{"name":"Asia/Ashgabat","lat":37.95,"long":58.3833,"countries":["TM"],"comments":""},"Africa/Tunis":{"name":"Africa/Tunis","lat":36.8,"long":10.1833,"countries":["TN"],"comments":""},"Pacific/Tongatapu":{"name":"Pacific/Tongatapu","lat":-20.8333,"long":-174.8333,"countries":["TO"],"comments":""},"Europe/Istanbul":{"name":"Europe/Istanbul","lat":41.0167,"long":28.9667,"countries":["TR"],"comments":""},"America/Port_of_Spain":{"name":"America/Port_of_Spain","lat":10.65,"long":-60.4833,"countries":["TT","AG","AI","BL","DM","GD","GP","KN","LC","MF","MS","VC","VG","VI"],"comments":""},"Pacific/Funafuti":{"name":"Pacific/Funafuti","lat":-7.4833,"long":179.2167,"countries":["TV"],"comments":""},"Asia/Taipei":{"name":"Asia/Taipei","lat":25.05,"long":121.5,"countries":["TW"],"comments":""},"Europe/Kiev":{"name":"Europe/Kiev","lat":50.4333,"long":30.5167,"countries":["UA"],"comments":"Ukraine (most areas)"},"Europe/Uzhgorod":{"name":"Europe/Uzhgorod","lat":48.6167,"long":22.3,"countries":["UA"],"comments":"Ruthenia"},"Europe/Zaporozhye":{"name":"Europe/Zaporozhye","lat":47.8333,"long":35.1667,"countries":["UA"],"comments":"Zaporozh'ye/Zaporizhia; Lugansk/Luhansk (east)"},"Pacific/Wake":{"name":"Pacific/Wake","lat":19.2833,"long":166.6167,"countries":["UM"],"comments":"Wake Island"},"America/New_York":{"name":"America/New_York","lat":40.7142,"long":-73.9936,"countries":["US"],"comments":"Eastern (most areas)"},"America/Detroit":{"name":"America/Detroit","lat":42.3314,"long":-82.9542,"countries":["US"],"comments":"Eastern - MI (most areas)"},"America/Kentucky/Louisville":{"name":"America/Kentucky/Louisville","lat":38.2542,"long":-84.2406,"countries":["US"],"comments":"Eastern - KY (Louisville area)"},"America/Kentucky/Monticello":{"name":"America/Kentucky/Monticello","lat":36.8297,"long":-83.1508,"countries":["US"],"comments":"Eastern - KY (Wayne)"},"America/Indiana/Indianapolis":{"name":"America/Indiana/Indianapolis","lat":39.7683,"long":-85.8419,"countries":["US"],"comments":"Eastern - IN (most areas)"},"America/Indiana/Vincennes":{"name":"America/Indiana/Vincennes","lat":38.6772,"long":-86.4714,"countries":["US"],"comments":"Eastern - IN (Da, Du, K, Mn)"},"America/Indiana/Winamac":{"name":"America/Indiana/Winamac","lat":41.0514,"long":-85.3969,"countries":["US"],"comments":"Eastern - IN (Pulaski)"},"America/Indiana/Marengo":{"name":"America/Indiana/Marengo","lat":38.3756,"long":-85.6553,"countries":["US"],"comments":"Eastern - IN (Crawford)"},"America/Indiana/Petersburg":{"name":"America/Indiana/Petersburg","lat":38.4919,"long":-86.7214,"countries":["US"],"comments":"Eastern - IN (Pike)"},"America/Indiana/Vevay":{"name":"America/Indiana/Vevay","lat":38.7478,"long":-84.9328,"countries":["US"],"comments":"Eastern - IN (Switzerland)"},"America/Chicago":{"name":"America/Chicago","lat":41.85,"long":-86.35,"countries":["US"],"comments":"Central (most areas)"},"America/Indiana/Tell_City":{"name":"America/Indiana/Tell_City","lat":37.9531,"long":-85.2386,"countries":["US"],"comments":"Central - IN (Perry)"},"America/Indiana/Knox":{"name":"America/Indiana/Knox","lat":41.2958,"long":-85.375,"countries":["US"],"comments":"Central - IN (Starke)"},"America/Menominee":{"name":"America/Menominee","lat":45.1078,"long":-86.3858,"countries":["US"],"comments":"Central - MI (Wisconsin border)"},"America/North_Dakota/Center":{"name":"America/North_Dakota/Center","lat":47.1164,"long":-100.7008,"countries":["US"],"comments":"Central - ND (Oliver)"},"America/North_Dakota/New_Salem":{"name":"America/North_Dakota/New_Salem","lat":46.845,"long":-100.5892,"countries":["US"],"comments":"Central - ND (Morton rural)"},"America/North_Dakota/Beulah":{"name":"America/North_Dakota/Beulah","lat":47.2642,"long":-100.2222,"countries":["US"],"comments":"Central - ND (Mercer)"},"America/Denver":{"name":"America/Denver","lat":39.7392,"long":-103.0158,"countries":["US"],"comments":"Mountain (most areas)"},"America/Boise":{"name":"America/Boise","lat":43.6136,"long":-115.7975,"countries":["US"],"comments":"Mountain - ID (south); OR (east)"},"America/Phoenix":{"name":"America/Phoenix","lat":33.4483,"long":-111.9267,"countries":["US"],"comments":"MST - Arizona (except Navajo)"},"America/Los_Angeles":{"name":"America/Los_Angeles","lat":34.0522,"long":-117.7572,"countries":["US"],"comments":"Pacific"},"America/Anchorage":{"name":"America/Anchorage","lat":61.2181,"long":-148.0997,"countries":["US"],"comments":"Alaska (most areas)"},"America/Juneau":{"name":"America/Juneau","lat":58.3019,"long":-133.5803,"countries":["US"],"comments":"Alaska - Juneau area"},"America/Sitka":{"name":"America/Sitka","lat":57.1764,"long":-134.6981,"countries":["US"],"comments":"Alaska - Sitka area"},"America/Metlakatla":{"name":"America/Metlakatla","lat":55.1269,"long":-130.4236,"countries":["US"],"comments":"Alaska - Annette Island"},"America/Yakutat":{"name":"America/Yakutat","lat":59.5469,"long":-138.2728,"countries":["US"],"comments":"Alaska - Yakutat"},"America/Nome":{"name":"America/Nome","lat":64.5011,"long":-164.5936,"countries":["US"],"comments":"Alaska (west)"},"America/Adak":{"name":"America/Adak","lat":51.88,"long":-175.3419,"countries":["US"],"comments":"Aleutian Islands"},"Pacific/Honolulu":{"name":"Pacific/Honolulu","lat":21.3069,"long":-156.1417,"countries":["US","UM"],"comments":"Hawaii"},"America/Montevideo":{"name":"America/Montevideo","lat":-33.1167,"long":-55.8167,"countries":["UY"],"comments":""},"Asia/Samarkand":{"name":"Asia/Samarkand","lat":39.6667,"long":66.8,"countries":["UZ"],"comments":"Uzbekistan (west)"},"Asia/Tashkent":{"name":"Asia/Tashkent","lat":41.3333,"long":69.3,"countries":["UZ"],"comments":"Uzbekistan (east)"},"America/Caracas":{"name":"America/Caracas","lat":10.5,"long":-65.0667,"countries":["VE"],"comments":""},"Asia/Ho_Chi_Minh":{"name":"Asia/Ho_Chi_Minh","lat":10.75,"long":106.6667,"countries":["VN"],"comments":"Vietnam (south)"},"Pacific/Efate":{"name":"Pacific/Efate","lat":-16.3333,"long":168.4167,"countries":["VU"],"comments":""},"Pacific/Wallis":{"name":"Pacific/Wallis","lat":-12.7,"long":-175.8333,"countries":["WF"],"comments":""},"Pacific/Apia":{"name":"Pacific/Apia","lat":-12.1667,"long":-170.2667,"countries":["WS"],"comments":""},"Africa/Johannesburg":{"name":"Africa/Johannesburg","lat":-25.75,"long":28,"countries":["ZA","LS","SZ"],"comments":""}}}

/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Card__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_ArrowBack__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_ArrowBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_ArrowBack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ViewSubscription_subscriptionDetails_jsx__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_getAccountType__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_fetchClientPublicIp__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_Dialog__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ChangeClientPassword__ = __webpack_require__(1115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_common_Loader__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Modules_CustomerDetailsCard_index_jsx__ = __webpack_require__(112);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query clientDetail($loginId: Int) {\n    clientDetail(loginId: $loginId) {\n      id\n      clientName\n      contactPerson\n      address\n      city\n      pincode\n      state {\n        name\n      }\n      country {\n        name\n      }\n      email\n      contactNumber\n      plan {\n        id\n        planName\n      }\n      loginId\n      login {\n        status\n      }\n      totalRegisteredDevices\n      totalUnregisteredDevices\n      totalDevices\n      expiryDate\n      type\n      status\n      solution\n      zonalManager\n      keyAccountManager\n      channelPartnerName\n      totalPotentialVehicles\n      videoTelematicsType\n    }\n  }\n'],['\n  query clientDetail($loginId: Int) {\n    clientDetail(loginId: $loginId) {\n      id\n      clientName\n      contactPerson\n      address\n      city\n      pincode\n      state {\n        name\n      }\n      country {\n        name\n      }\n      email\n      contactNumber\n      plan {\n        id\n        planName\n      }\n      loginId\n      login {\n        status\n      }\n      totalRegisteredDevices\n      totalUnregisteredDevices\n      totalDevices\n      expiryDate\n      type\n      status\n      solution\n      zonalManager\n      keyAccountManager\n      channelPartnerName\n      totalPotentialVehicles\n      videoTelematicsType\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query getAllSubscriptions($partnerLoginId: Int!, $clientLoginId: Int) {\n    allSubscriptions: getAllSubscriptions(\n      partnerLoginId: $partnerLoginId\n      clientLoginId: $clientLoginId\n    ) {\n      id\n      client {\n        loginId\n        clientName\n      }\n      billingMode {\n        id\n        billingMode\n      }\n      billingFrequency {\n        id\n        frequency\n      }\n      deviceQuantity\n      plan\n      amount\n      createdAt\n    }\n  }\n'],['\n  query getAllSubscriptions($partnerLoginId: Int!, $clientLoginId: Int) {\n    allSubscriptions: getAllSubscriptions(\n      partnerLoginId: $partnerLoginId\n      clientLoginId: $clientLoginId\n    ) {\n      id\n      client {\n        loginId\n        clientName\n      }\n      billingMode {\n        id\n        billingMode\n      }\n      billingFrequency {\n        id\n        frequency\n      }\n      deviceQuantity\n      plan\n      amount\n      createdAt\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query getClientLoginToken(\n    $clientid: Int!\n    $clientIp: String\n    $source: String\n    $performedByLoginId: Int\n    $performedByUsername: String\n  ) {\n    getClientLoginToken(\n      id: $clientid\n      clientIp: $clientIp\n      source: $source\n      performedByLoginId: $performedByLoginId\n      performedByUsername: $performedByUsername\n    ) {\n      token\n    }\n  }\n'],['\n  query getClientLoginToken(\n    $clientid: Int!\n    $clientIp: String\n    $source: String\n    $performedByLoginId: Int\n    $performedByUsername: String\n  ) {\n    getClientLoginToken(\n      id: $clientid\n      clientIp: $clientIp\n      source: $source\n      performedByLoginId: $performedByLoginId\n      performedByUsername: $performedByUsername\n    ) {\n      token\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query getPartnerDomainConfig($loginId: Int!) {\n    domain: getPartnerDomainConfig(loginId: $loginId)\n  }\n'],['\n  query getPartnerDomainConfig($loginId: Int!) {\n    domain: getPartnerDomainConfig(loginId: $loginId)\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  mutation clientDeactivationAndActivation(\n    $clientLoginId: Int!\n    $activate: Boolean!\n    $accountType: String!\n  ) {\n    clientDeactivationAndActivation(\n      clientLoginId: $clientLoginId\n      activate: $activate\n      accountType: $accountType\n    )\n  }\n'],['\n  mutation clientDeactivationAndActivation(\n    $clientLoginId: Int!\n    $activate: Boolean!\n    $accountType: String!\n  ) {\n    clientDeactivationAndActivation(\n      clientLoginId: $clientLoginId\n      activate: $activate\n      accountType: $accountType\n    )\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_CLIENTS=Object(__WEBPACK_IMPORTED_MODULE_8_graphql_tag__["a" /* default */])(_templateObject);var GET_ALL_SUBCRIPTIONS=Object(__WEBPACK_IMPORTED_MODULE_8_graphql_tag__["a" /* default */])(_templateObject2);var GET_LOGIN_TOKEN=Object(__WEBPACK_IMPORTED_MODULE_8_graphql_tag__["a" /* default */])(_templateObject3);var GET_CLIENT_DOMAIN=Object(__WEBPACK_IMPORTED_MODULE_8_graphql_tag__["a" /* default */])(_templateObject4);// const GENRATE_DEMO_LINK = gql`
//   query createTimeLimitedLogin(
//     $username: String!
//     $password: String!
//     $portalURL: String!
//     $hours: Int!
//   ) {
//     createTimeLimitedLogin(
//       username: $username
//       password: $password
//       portalURL: $portalURL
//       hours: $hours
//     ) {
//       token
//     }
//   }
// `
// calling server for updation
var UPDATE_STATUS=Object(__WEBPACK_IMPORTED_MODULE_8_graphql_tag__["a" /* default */])(_templateObject5);var styles=function styles(theme){var _root;return{root:(_root={padding:theme.spacing.unit*4},_defineProperty(_root,theme.breakpoints.down('sm'),{padding:theme.spacing.unit*2}),_defineProperty(_root,'flexGrow',1),_root),statusCard:{padding:theme.spacing.unit*2,textAlign:'center'},statusCardRoot:{height:'100%',display:'flex',alignItems:'center',justifyContent:'center'},statusCardCount:{color:'red',fontSize:'20px',marginBottom:'5px'},statusCardText:{fontSize:'15px',color:'black'},statusCardContainer:_defineProperty({},theme.breakpoints.up('sm'),{height:'100%'}),layoutChange:_defineProperty({},theme.breakpoints.down('xs'),{flexWrap:'wrap-reverse'})};};var ViewCustomer=function(_Component){_inherits(ViewCustomer,_Component);function ViewCustomer(props){var _this2=this;_classCallCheck(this,ViewCustomer);var _this=_possibleConstructorReturn(this,(ViewCustomer.__proto__||Object.getPrototypeOf(ViewCustomer)).call(this,props));_this.state={open:false,demoURL:'',openDemo:false,allSubscriptionsData:[],isFromCustomer:true};_this.editCustomer=function(loginId){return function(e){_this.props.history.push({pathname:'/home/customers/edit/'+_this.loginId});};};_this.loginCustomer=function(clientId){return _asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var clientIp,_ref2,data,_ref3,domain,clienturl,win;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_14__utils_fetchClientPublicIp__["a" /* default */])();case 2:clientIp=_context.sent;_context.next=5;return _this.props.client.query({query:GET_LOGIN_TOKEN,variables:{clientid:clientId,clientIp:clientIp,source:'admin-frontend',performedByLoginId:Object(__WEBPACK_IMPORTED_MODULE_12__utils_getLoginId__["a" /* default */])(),performedByUsername:localStorage.getItem('username')}});case 5:_ref2=_context.sent;data=_ref2.data;if(!data){_context.next=15;break;}_context.next=10;return _this.props.client.query({query:GET_CLIENT_DOMAIN,variables:{loginId:Object(__WEBPACK_IMPORTED_MODULE_12__utils_getLoginId__["a" /* default */])()}});case 10:_ref3=_context.sent;domain=_ref3.data;clienturl='https://'+domain.domain+'/?token='+data.getClientLoginToken.token;win=window.open(clienturl,'_blank');win.focus();case 15:case'end':return _context.stop();}}},_callee,_this2);}));};_this.handleRegistration=function(e){_this.props.history.push({pathname:'/home/VehicleRegistration/'+_this.props.match.params.loginId});};_this.showSubscription=function(subscriptionId){return function(e){_this.props.history.push({pathname:'/home/subscriptions/view/'+_this.loginId+'/'+subscriptionId});};};_this.allCustomer=function(e){// console.log('er=', e)
_this.props.history.push({pathname:e,state:{from:_this.props.location.pathname}});};_this.createNewSubscription=function(e){_this.props.history.push({pathname:'/home/subscriptions/new/'+_this.loginId});};_this.handleClickOpen=function(){_this.setState({open:true});};_this.handleClose=function(){_this.setState({open:false});};_this.handleDemoClose=function(){_this.setState({openDemo:false,demoURL:''});};_this.handleActivateDeactivate=function(clientStatus){return _asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var status,_ref5,data,errors;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:status='';if(clientStatus===1){status=false;}else{status=true;}_context2.next=4;return _this.props.client.mutate({mutation:UPDATE_STATUS,variables:{clientLoginId:parseInt(_this.loginId,10),activate:status,accountType:'CLT'},refetchQueries:['clientDetail']});case 4:_ref5=_context2.sent;data=_ref5.data;errors=_ref5.errors;console.log(data,'data',errors);if(data===null){_this.props.openSnackbar(errors[0].message);}else{_this.props.openSnackbar(data.clientDeactivationAndActivation);}case 9:case'end':return _context2.stop();}}},_callee2,_this2);}));};_this.getAllSubscriptionDetails=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var _ref7,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:console.log('calling all subcription');_context3.next=3;return _this.props.client.query({query:GET_ALL_SUBCRIPTIONS,variables:{partnerLoginId:parseInt(Object(__WEBPACK_IMPORTED_MODULE_12__utils_getLoginId__["a" /* default */])(),10),clientLoginId:parseInt(_this.loginId,10)}// fetchPolicy: 'network-only'
});case 3:_ref7=_context3.sent;data=_ref7.data;console.log('data.allSubscriptions',data);if(data&&data.allSubscriptions){_this.setState({allSubscriptionsData:data.allSubscriptions},function(){console.log('allSubscriptionsData',_this.state.allSubscriptionsData);});}case 7:case'end':return _context3.stop();}}},_callee3,_this2);}));_this.componentDidMount=function(){console.log('component did mount');_this.getAllSubscriptionDetails();};_this.loginId=_this.props.match.params.loginId;return _this;}// demoLink = async event => {
//   const { data } = await this.props.client.query({
//     query: GENRATE_DEMO_LINK,
//     variables: {
//       username: 'democlient',
//       password: 'democlient',
//       portalURL: 'web.aquilatrack.com',
//       hours: 168
//     }
//   })
//   let clienturl =
//     'https://web.aquilatrack.com' +
//     // domain.domain +
//     '/?token=' +
//     data.createTimeLimitedLogin.token
//   // console.log('clienturl', clienturl)
//   this.setState({ demoURL: clienturl, openDemo: true })
//   // var win = window.open(clienturl, '_blank')
//   // win.focus()
// }
_createClass(ViewCustomer,[{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;var allSubscriptionsData=this.state.allSubscriptionsData;console.log('props',this.props);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_apollo__["Query"],{query:GET_CLIENTS,variables:{loginId:parseInt(this.loginId,10)}// fetchPolicy="network-only"
},function(_ref8){var loading=_ref8.loading,error=_ref8.error,clientDetail=_ref8.data.clientDetail;if(loading)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_common_Loader__["a" /* default */],null);if(error)return'Error!: '+error;// console.log('Client Detail is ', clientDetail)
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root,style:{padding:'15px 15px 15px 15px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,spacing:16,justify:'space-between'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,sm:'auto'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{variant:'outlined',color:'secondary',className:classes.button,onClick:function onClick(){return _this3.props.history.goBack();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_ArrowBack___default.a,{className:classes.iconSmall}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,sm:'auto'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,justify:'flex-end'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,justify:'space-between',alignItems:'stretch',spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,sm:'auto'},!['SAL'].includes(Object(__WEBPACK_IMPORTED_MODULE_13__utils_getAccountType__["a" /* default */])())&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{fullWidth:true,color:'secondary',variant:'raised',className:classes.button,onClick:_this3.handleRegistration},'Register Vehicle')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,sm:'auto'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{fullWidth:true,variant:'outlined',color:'primary',className:classes.button,onClick:_this3.editCustomer(clientDetail.loginId)},'Edit')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,sm:'auto'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{fullWidth:true,variant:'outlined',color:'primary',className:classes.button,onClick:_this3.loginCustomer(clientDetail.id)},'Login Preview'))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,spacing:16,className:classes.layoutChange},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,sm:9},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Modules_CustomerDetailsCard_index_jsx__["a" /* default */],{clientDetail:clientDetail,actions:function actions(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{color:'secondary',className:classes.button,onClick:_this3.handleActivateDeactivate(clientDetail.login.status)},clientDetail.login.status===1?'Deactivate':'Activate'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{color:'secondary',className:classes.button,onClick:_this3.handleClickOpen},'Change Password'));}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,justify:'space-between',spacing:8,className:classes.statusCardContainer},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Card___default.a,{className:classes.statusCardRoot},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.statusCard},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.statusCardCount},clientDetail.totalDevices),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.statusCardText},'Total Devices')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Card___default.a,{className:classes.statusCardRoot},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.statusCard},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.statusCardCount},clientDetail.totalRegisteredDevices),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.statusCardText},'Registered Devices')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Card___default.a,{className:classes.statusCardRoot},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.statusCard},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.statusCardCount},clientDetail.totalUnregisteredDevices),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.statusCardText},'Unregistered Devices'))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_Dialog___default.a,{open:_this3.state.open,onClose:_this3.handleClose,'aria-labelledby':'form-dialog-title'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__ChangeClientPassword__["a" /* default */],{handleClose:_this3.handleClose,clientLoginId:_this3.loginId}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},console.log('subcriptions length',allSubscriptionsData.length),allSubscriptionsData.length===0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'sub-heading',color:'error',align:'left'},'No Subscriptions Created! \xA0\xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{color:'secondary',onClick:_this3.createNewSubscription,variant:'contained',className:classes.button},'Create New Subscription')):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,spacing:16},allSubscriptionsData.map(function(subscription,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,key:index},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ViewSubscription_subscriptionDetails_jsx__["a" /* default */],{clientDetail:clientDetail,clientLoginId:_this3.loginId,showSubscription:_this3.showSubscription,subscriptionId:subscription.id,viewVehicles:true,isDisabled:false,backUrl:_this3.backUrl,disableLoader:true,isFromCustomer:_this3.state.isFromCustomer}));})))));});}}]);return ViewCustomer;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);ViewCustomer.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_9_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_17__HOCs_withSharedSnackbar__["a" /* default */])(ViewCustomer))));

/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Card__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_CardHeader__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_CardHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_CardHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_CardContent__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_CardContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_CardContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_CardActions__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_CardActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_CardActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui_pickers__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_getAccountType__ = __webpack_require__(68);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable */var styles=function styles(theme){return{rowStyle:{margin:'16px 0'},textFieldStyle:{width:'55%'},dateStyle:{width:'50%'},subHeadingStyle:{marginLeft:'1.9vw',marginBottom:'10px',fontSize:'1rem',fontWeight:'bold'},cardAction:{marginLeft:'-1.9vw'}};};var BillingDetails=function(_Component){_inherits(BillingDetails,_Component);function BillingDetails(){_classCallCheck(this,BillingDetails);return _possibleConstructorReturn(this,(BillingDetails.__proto__||Object.getPrototypeOf(BillingDetails)).apply(this,arguments));}_createClass(BillingDetails,[{key:'render',value:function render(){var _props=this.props,classes=_props.classes,subcriptionData=_props.subcriptionData;var _ref=subcriptionData.subscription?subcriptionData.subscription:'',billingDetails=_ref.billingDetails;var _props2=this.props,hardwarePaymentMade=_props2.hardwarePaymentMade,softwarePaymentMade=_props2.softwarePaymentMade,accessoryPaymentMade=_props2.accessoryPaymentMade,simPaymentMade=_props2.simPaymentMade,hardwareBalance=_props2.hardwareBalance,softwareBalance=_props2.softwareBalance,accessoryBalance=_props2.accessoryBalance,simBalance=_props2.simBalance,hardwareRemarks=_props2.hardwareRemarks,softwareRemarks=_props2.softwareRemarks,accessoryRemarks=_props2.accessoryRemarks,simRemarks=_props2.simRemarks,expectedHardwareDueDate=_props2.expectedHardwareDueDate,expectedSoftwareDueDate=_props2.expectedSoftwareDueDate,expectedAccessoryDueDate=_props2.expectedAccessoryDueDate,expectedSimsDueDate=_props2.expectedSimsDueDate,handlePaymentMade=_props2.handlePaymentMade,handleRemarksChange=_props2.handleRemarksChange,handleExpectedDateChange=_props2.handleExpectedDateChange;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,billingDetails&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Card___default.a,{raised:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_CardHeader___default.a,{className:classes.cardAction,title:'Billing Details'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,justify:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,style:{marginRight:'7vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,direction:'column',alignContent:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},'PARTICULARS')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},' Quantity')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},' Price/item')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},' ','Amount paid(Incl. GST)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},' ','Amount to be paid(Incl. GST)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},!['SAL'].includes(Object(__WEBPACK_IMPORTED_MODULE_13__utils_getAccountType__["a" /* default */])())&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},' Payment Made')))),billingDetails.hardwareBill&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,direction:'column',alignContent:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},' HARDWARE ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},' ',billingDetails.hardwareBill.quantity)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9 ',billingDetails.hardwareBill.rate)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9 ',billingDetails.hardwareBill.amountPaidGST)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9 ',billingDetails.hardwareBill.amountToBePaid)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},!['SAL'].includes(Object(__WEBPACK_IMPORTED_MODULE_13__utils_getAccountType__["a" /* default */])())&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField___default.a// disabled={['SAL'].includes(getAccountType())}
,{id:'amount',type:'Number',className:classes.textFieldStyle,label:'Paid Amount *',inputProps:{min:0},value:hardwarePaymentMade,onChange:handlePaymentMade('hardwarePaymentMade'),margin:'none'})))),billingDetails.softwareBill&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,direction:'column',alignContent:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},' SOFTWARE')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},' ',billingDetails.softwareBill.quantity)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9 ',billingDetails.softwareBill.rate)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9 ',billingDetails.softwareBill.amountPaidGST)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9 ',billingDetails.softwareBill.amountToBePaid)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},!['SAL'].includes(Object(__WEBPACK_IMPORTED_MODULE_13__utils_getAccountType__["a" /* default */])())&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField___default.a// disabled={['SAL'].includes(getAccountType())}
,{id:'amount',type:'Number',className:classes.textFieldStyle,label:'Paid Amount *',inputProps:{min:0},value:softwarePaymentMade,onChange:handlePaymentMade('softwarePaymentMade'),margin:'none'})))),billingDetails.accessoryBill&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,direction:'column',alignContent:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},' ACCESSORY')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},' ',billingDetails.accessoryBill.quantity)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9 ',billingDetails.accessoryBill.rate)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9 ',billingDetails.accessoryBill.amountPaidGST)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9 ',billingDetails.accessoryBill.amountToBePaid)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},!['SAL'].includes(Object(__WEBPACK_IMPORTED_MODULE_13__utils_getAccountType__["a" /* default */])())&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField___default.a// disabled={['SAL'].includes(getAccountType())}
,{id:'amount',type:'Number',className:classes.textFieldStyle,label:'Paid Amount *',inputProps:{min:0},value:accessoryPaymentMade,onChange:handlePaymentMade('accessoryPaymentMade'),margin:'none'})))),billingDetails.simBill&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,direction:'column',alignContent:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},' SIMS')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},' ',billingDetails.simBill.quantity)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9 ',billingDetails.simBill.rate)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9 ',billingDetails.simBill.amountPaidGST)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9 ',billingDetails.simBill.amountToBePaid)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},!['SAL'].includes(Object(__WEBPACK_IMPORTED_MODULE_13__utils_getAccountType__["a" /* default */])())&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField___default.a// disabled={['SAL'].includes(getAccountType())}
,{id:'amount',type:'Number',className:classes.textFieldStyle,label:'Paid Amount *',inputProps:{min:0},value:simPaymentMade,onChange:handlePaymentMade('simPaymentMade'),margin:'none'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),billingDetails&&['ACC'].includes(Object(__WEBPACK_IMPORTED_MODULE_13__utils_getAccountType__["a" /* default */])())&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Card___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_CardHeader___default.a,{className:classes.cardAction,title:'Credit Notes'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,justify:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,style:{marginRight:'7vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,direction:'column',alignContent:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},' Balance')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,style:{margin:'25px 0'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},' ','Expected Due Date')))),billingDetails.hardwareBill?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,disabled:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,direction:'column',alignContent:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9 ',hardwareBalance)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_material_ui_pickers__["a" /* DatePicker */],{disabled:hardwareBalance===0,className:classes.dateStyle,label:'Due Date',value:expectedHardwareDueDate// views={['year', 'month', 'date']}
,format:'DD/MM/YYYY',onChange:handleExpectedDateChange('expectedHardwareDueDate')})))):null,billingDetails.softwareBill?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,direction:'column',alignContent:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9 ',softwareBalance)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_material_ui_pickers__["a" /* DatePicker */],{disabled:softwareBalance===0,className:classes.dateStyle,label:'Due Date',value:expectedSoftwareDueDate,onChange:handleExpectedDateChange('expectedSoftwareDueDate'),format:'DD/MM/YYYY'// inputProps={{
//   name: 'expiryDateTime'
// }}
})))):null,billingDetails.accessoryBill?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,direction:'column',alignContent:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9 ',accessoryBalance)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_material_ui_pickers__["a" /* DatePicker */],{disabled:accessoryBalance===0,className:classes.dateStyle,label:'Due Date',value:expectedAccessoryDueDate,onChange:handleExpectedDateChange('expectedAccessoryDueDate'),format:'DD/MM/YYYY'// inputProps={{
//   name: 'expiryDateTime'
// }}
})))):null,billingDetails.simBill?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,direction:'column',alignContent:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9 ',simBalance)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_material_ui_pickers__["a" /* DatePicker */],{disabled:simBalance===0,className:classes.dateStyle,label:'Due Date',value:expectedSimsDueDate,onChange:handleExpectedDateChange('expectedSimsDueDate'),format:'DD/MM/YYYY'// inputProps={{
//   name: 'expiryDateTime'
// }}
})))):null))));}}]);return BillingDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_1_react_apollo__["withApollo"])(BillingDetails)));

/***/ }),
/* 1115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormHelperText__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormHelperText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormHelperText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_fetchClientPublicIp__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_getLoginId__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  mutation changeUsernamePassword(\n    $newPassword: String!\n    $loginId: Int!\n    $clientIp: String\n    $source: String\n    $performedByLoginId: Int\n    $performedByUsername: String\n  ) {\n    changeUsernamePassword(\n      newPassword: $newPassword\n      loginId: $loginId\n      clientIp: $clientIp\n      source: $source\n      performedByLoginId: $performedByLoginId\n      performedByUsername: $performedByUsername\n    )\n  }\n'],['\n  mutation changeUsernamePassword(\n    $newPassword: String!\n    $loginId: Int!\n    $clientIp: String\n    $source: String\n    $performedByLoginId: Int\n    $performedByUsername: String\n  ) {\n    changeUsernamePassword(\n      newPassword: $newPassword\n      loginId: $loginId\n      clientIp: $clientIp\n      source: $source\n      performedByLoginId: $performedByLoginId\n      performedByUsername: $performedByUsername\n    )\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// calling server for updation
var CHANGE_PASSWORD=Object(__WEBPACK_IMPORTED_MODULE_11_graphql_tag__["a" /* default */])(_templateObject);var styles=function styles(theme){return{button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{margin:theme.spacing.unit,minWidth:120}};};var ChangeClientPassword=function(_Component){_inherits(ChangeClientPassword,_Component);function ChangeClientPassword(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,ChangeClientPassword);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ChangeClientPassword.__proto__||Object.getPrototypeOf(ChangeClientPassword)).call.apply(_ref,[this].concat(args))),_this),_this.state={password:'',confirmPassword:'',isPasswordValid:true,isConfirmPasswordValid:true},_this.checkPasswordValidity=function(){// const regex = new RegExp(/^((?!.*[\s])(?=.*[A-Z])(?=.*\d).{8,15})/)
// const regex = new RegExp(/^[a-zA-Z0-9.\-_$@*!]{3,20}$/)
var regex=new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,15}$/);console.log('pass=',regex.test(_this.state.password));_this.setState({isPasswordValid:_this.state.password!==''&&regex.test(_this.state.password)});},_this.checkConfirmPasswordValidity=function(){_this.setState({isConfirmPasswordValid:true});console.log('pass',_this.state.password,_this.state.confirmPassword);if(_this.state.password!==_this.state.confirmPassword){_this.setState({isConfirmPasswordValid:false});}},_this.handleInputChange=function(e){_this.setState(_defineProperty({},e.target.name,e.target.value));},_this.handleSubmit=function(client){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(e){var clientIp,_ref3,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:e.preventDefault();if(!(_this.state.password!==_this.state.confirmPassword)){_context.next=5;break;}_this.props.openSnackbar('New Password and confirm passwords are not matching');_context.next=13;break;case 5:_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_16__utils_fetchClientPublicIp__["a" /* default */])();case 7:clientIp=_context.sent;_context.next=10;return client.mutate({mutation:CHANGE_PASSWORD,variables:{newPassword:_this.state.password,loginId:parseInt(_this.props.clientLoginId,10),clientIp:clientIp,source:'admin-frontend',performedByLoginId:Object(__WEBPACK_IMPORTED_MODULE_17__utils_getLoginId__["a" /* default */])(),performedByUsername:localStorage.getItem('username')},refetchQueries:['allClientDetails']});case 10:_ref3=_context.sent;data=_ref3.data;// console.log(data, 'data')
if(data.changeUsernamePassword){_this.props.openSnackbar('Password Changed Successfully');_this.props.handleClose();_this.setState({password:'',confirmPassword:''});}else{_this.setState({password:'',confirmPassword:''});_this.props.openSnackbar('Password Reset Failed');}case 13:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ChangeClientPassword,[{key:'render',value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle___default.a,{id:'form-dialog-title'},'Change Password :'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Divider___default.a,{light:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText___default.a,null,'* Marked fields are mandatory'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField___default.a// autoComplete="username"
,{name:'password',value:this.state.password,type:'password',onChange:this.handleInputChange,label:'New Password *',error:!this.state.isPasswordValid,onBlur:this.checkPasswordValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},this.state.isPasswordValid?'':'Password should be :  8 to 15 characters, one uppercase letter, one lowercase letter, one special character (@ $ ! % * ? & ) and one number.')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField___default.a// autoComplete="username"
,{name:'confirmPassword',value:this.state.confirmPassword,type:'password',onChange:this.handleInputChange,label:'Confirm Password *',error:!this.state.isConfirmPasswordValid,onBlur:this.checkConfirmPasswordValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},this.state.isConfirmPasswordValid?'':'Password Not Matching'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:this.props.handleClose,color:'default',variant:'contained'},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:this.handleSubmit(this.props.client),type:'submit',color:'primary',variant:'contained',disabled:!(this.state.isPasswordValid&&this.state.isConfirmPasswordValid&&this.state.confirmPassword!==''&&this.state.password!=='')},'Submit'))));}}]);return ChangeClientPassword;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);ChangeClientPassword.propTypes={classes:__WEBPACK_IMPORTED_MODULE_15_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_12_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_14__HOCs_withSharedSnackbar__["a" /* default */])(ChangeClientPassword))));

/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_DialogTitle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_DialogTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_DialogTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_DialogContent__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_DialogActions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormControlLabel__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormControlLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormControlLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Checkbox__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__RegisterDevice__ = __webpack_require__(1117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_file_saver__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_axios__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__common_Loader__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_getAccountType_js__ = __webpack_require__(68);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getPartnerDeviceStockByDeviceModel($partnerLoginId: Int!) {\n    devices: getPartnerDeviceStockByDeviceModel(\n      partnerLoginId: $partnerLoginId\n    ) {\n      modelId\n      modelName\n      totalAssignedDevice\n      availableStock\n      totalAssignedDeviceToClient\n      totalRegisteredDevice\n    }\n  }\n'],['\n  query getPartnerDeviceStockByDeviceModel($partnerLoginId: Int!) {\n    devices: getPartnerDeviceStockByDeviceModel(\n      partnerLoginId: $partnerLoginId\n    ) {\n      modelId\n      modelName\n      totalAssignedDevice\n      availableStock\n      totalAssignedDeviceToClient\n      totalRegisteredDevice\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n'],['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* eslint-disable */var style=function style(theme){var _root;return{root:(_root={padding:theme.spacing.unit*4},_defineProperty(_root,theme.breakpoints.down('sm'),{padding:theme.spacing.unit*2}),_defineProperty(_root,'flexGrow',1),_root),paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},iconSmall:{fontSize:20}};};var GET_DEVICE_STOCK=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject);var GET_FILE_FORMAT=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject2);var InventoryDevices=function(_Component){_inherits(InventoryDevices,_Component);function InventoryDevices(props){var _this2=this;_classCallCheck(this,InventoryDevices);var _this=_possibleConstructorReturn(this,(InventoryDevices.__proto__||Object.getPrototypeOf(InventoryDevices)).call(this,props));_this.clientId=[];_this.columns=['MODEL NAME','TOTAL ASSIGNED DEVICES','TOTAL DEVICES ASSIGNED TO CLIENT','TOTAL REGISTERED DEVICES','TOTAL STOCK'];_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15,onRowClick:function onRowClick(rowData,dataIndex,rowIndex){_this.setState({fetchOptionsDialogOpen:true,selectedModelId:_this.modelId[dataIndex.dataIndex],includeClientVehicleDetails:false});},filter:false};_this.state={open:false,open1:false,fetchOptionsDialogOpen:false,selectedModelId:null,includeClientVehicleDetails:false};_this.handleCloseFetchOptionsDialog=function(){_this.setState({fetchOptionsDialogOpen:false,selectedModelId:null});};_this.handleFetchData=function(){_this.props.history.push({pathname:'/home/devices/view/'+_this.state.selectedModelId,state:{includeClientVehicleDetails:_this.state.includeClientVehicleDetails}});_this.setState({fetchOptionsDialogOpen:false});};_this.handleClickOpen=function(){_this.setState({open:true});};_this.handleClose=function(){_this.setState({open:false});};_this.handleClickBulkOpen=function(){_this.setState({open1:true});};_this.handleBulkClose=function(){_this.setState({open1:false});};_this.addBulkUpload=function(e){console.log('bulk');_this.props.history.push({pathname:'/home/DeviceInventory/DeviceBulkUpload'});};_this.addBulkDelete=function(e){console.log('bulk');_this.props.history.push({pathname:'/home/DeviceInventory/DeviceBulkDelete'});};_this.deviceDashboard=function(e){console.log('bulk');_this.props.history.push({pathname:'/home/deviceDashboard/Dashboard'});};_this.downloadBulkUpload=function(client){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _ref2,data,res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:console.log('click fun');_context.next=3;return _this.props.client.query({query:GET_FILE_FORMAT,variables:{bucketname:'excel-templates',filename:'deviceUpload.xlsx'},errorPolicy:'all'});case 3:_ref2=_context.sent;data=_ref2.data;console.log('file',data.getPublicDownloadURL);_context.next=8;return __WEBPACK_IMPORTED_MODULE_18_axios___default()({url:data.getPublicDownloadURL,method:'GET',headers:{Accept:'application/vnd.ms-excel'},responseType:'blob'// important
});case 8:res=_context.sent;__WEBPACK_IMPORTED_MODULE_16_file_saver___default.a.saveAs(new Blob([res.data]),'sample.xlsx');// FileSaver.saveAs(data.getPublicDownloadURL, 'sample.xlsx')
case 10:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();};_this.handleMakePayment=function(){var url=Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_SERVER_HTTP_URI":"https://uat-api-dtwin.taabi.ai/graphql","REACT_APP_SERVER_WS_URI":"wss://uat-api-dtwin.taabi.ai"}).REACT_APP_PAYMENT_LINK;window.open(url,'_blank');};_this.classes=props;return _this;}_createClass(InventoryDevices,[{key:'mapToArr',value:function mapToArr(devices){var _this3=this;var rowData=[];var fullData=[];this.modelId=[];devices.forEach(function(element){rowData=[];_this3.modelId.push(element.modelId);rowData.push(element.modelName);rowData.push(element.totalAssignedDevice);rowData.push(element.totalAssignedDeviceToClient);rowData.push(element.totalRegisteredDevice);rowData.push(element.availableStock);fullData.push(rowData);});return fullData;}//razorPay payment functionality
},{key:'render',value:function render(){var _this4=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog___default.a,{open:this.state.open,onClose:this.handleClose,'aria-labelledby':'form-dialog-title'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__RegisterDevice__["a" /* default */],{handleClose:this.handleClose})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog___default.a,{open:this.state.fetchOptionsDialogOpen,onClose:this.handleCloseFetchOptionsDialog,'aria-labelledby':'fetch-options-dialog'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_DialogTitle___default.a,{id:'fetch-options-dialog-title'},'Fetch Device Details'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{variant:'body1',gutterBottom:true},'Choose how you want to fetch the Device data:'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Checkbox___default.a,{checked:this.state.includeClientVehicleDetails,onChange:function onChange(e){return _this4.setState({includeClientVehicleDetails:e.target.checked});},color:'primary'}),label:'Include Client and Vehicle Details'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_DialogActions___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{onClick:this.handleCloseFetchOptionsDialog,color:'default'},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{onClick:this.handleFetchData,color:'primary',variant:'contained'},'Fetch Data'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:16,justify:'space-between'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{variant:'headline'},'Devices ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:8,justify:'flex-end'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12,sm:'auto'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{fullWidth:true,color:'secondary',variant:'contained',className:classes.button,onClick:this.handleClickOpen},'New Device')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12,sm:'auto'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{fullWidth:true,color:'secondary',variant:'contained',className:classes.button,onClick:this.addBulkUpload},'Bulk Upload')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12,sm:'auto'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{fullWidth:true,color:'secondary',variant:'contained',className:classes.button,onClick:this.addBulkDelete},'Bulk Delete')))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["Query"],{query:GET_DEVICE_STOCK,variables:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_17__utils_getLoginId__["a" /* default */])()},fetchPolicy:'network-only'},function(_ref3){var loading=_ref3.loading,error=_ref3.error,data=_ref3.data;if(loading)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__common_Loader__["a" /* default */],null);if(error)return'Error!: '+error;var tableData=data.devices?_this4.mapToArr(data.devices):[];return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_mui_datatables___default.a,{data:tableData,columns:_this4.columns,options:_this4.options});}))));}}]);return InventoryDevices;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["withApollo"])(InventoryDevices)));

/***/ }),
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core_FormHelperText__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core_FormHelperText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_FormHelperText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core_Checkbox__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Checkbox__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query {\n    models: allDeviceModels(status: 1) {\n      id\n      model_name\n    }\n  }\n'],['\n  query {\n    models: allDeviceModels(status: 1) {\n      id\n      model_name\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query {\n    manufacturers: getAllManufacturer(status: 1) {\n      id\n      manufacturerName\n      manufacturerCode\n    }\n  }\n'],['\n  query {\n    manufacturers: getAllManufacturer(status: 1) {\n      id\n      manufacturerName\n      manufacturerCode\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query deviceModel($modelId: Int) {\n    deviceModel(id: $modelId) {\n      devicetype\n    }\n  }\n'],['\n  query deviceModel($modelId: Int) {\n    deviceModel(id: $modelId) {\n      devicetype\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  mutation addDeviceDetailsFromPartnerAdmin(\n    $serial_num: String!\n    $imei_num: String!\n    $device_model_id: Int!\n    $uniqueSerialNumber: String!\n    $manufacturerId: Int!\n    $ownerLoginId: Int!\n    $is_panic_enabled: Boolean\n  ) {\n    addDeviceDetailsFromPartnerAdmin(\n      serial_num: $serial_num\n      imei_num: $imei_num\n      deviceModelId: $device_model_id\n      uniqueDeviceId: $uniqueSerialNumber\n      manufacturerId: $manufacturerId\n      ownerLoginId: $ownerLoginId\n      is_panic_enabled :$is_panic_enabled\n    )\n  }\n'],['\n  mutation addDeviceDetailsFromPartnerAdmin(\n    $serial_num: String!\n    $imei_num: String!\n    $device_model_id: Int!\n    $uniqueSerialNumber: String!\n    $manufacturerId: Int!\n    $ownerLoginId: Int!\n    $is_panic_enabled: Boolean\n  ) {\n    addDeviceDetailsFromPartnerAdmin(\n      serial_num: $serial_num\n      imei_num: $imei_num\n      deviceModelId: $device_model_id\n      uniqueDeviceId: $uniqueSerialNumber\n      manufacturerId: $manufacturerId\n      ownerLoginId: $ownerLoginId\n      is_panic_enabled :$is_panic_enabled\n    )\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_MODELS=Object(__WEBPACK_IMPORTED_MODULE_14_graphql_tag__["a" /* default */])(_templateObject);var GET_MANUFACTURER=Object(__WEBPACK_IMPORTED_MODULE_14_graphql_tag__["a" /* default */])(_templateObject2);var GET_MODEL_TYPE=Object(__WEBPACK_IMPORTED_MODULE_14_graphql_tag__["a" /* default */])(_templateObject3);// calling server for updation
var ADD_DEVICE=Object(__WEBPACK_IMPORTED_MODULE_14_graphql_tag__["a" /* default */])(_templateObject4);var styles=function styles(theme){return{button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{// margin: theme.spacing.unit,
width:'100%'}};};var RegisterDevice=function(_Component){_inherits(RegisterDevice,_Component);function RegisterDevice(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,RegisterDevice);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RegisterDevice.__proto__||Object.getPrototypeOf(RegisterDevice)).call.apply(_ref,[this].concat(args))),_this),_this.state={open1:false,modelname:'',serialno:'',imeino:'',uniqueSerialNumber:'',isModelNameValid:true,isSerialnoValid:true,isImeinoValid:true,isManufacturerNameValid:true,manufacturerName:'',open_man:false,manufacturerCode:'',manufacturerId:'',errorMessage:'',models:[],checked:false},_this.handleInputChange=function(key){return function(e){if(_this.state.manufacturerName===''||_this.state.modelname===''){_this.props.openSnackbar('Please select Manufacturer and Model before entering serial or IMEI no');_this.setState({errorMessage:'Please select Manufacturer and Model before entering serial or IMEI no'});}else{_this.setState(_defineProperty({},key,e.target.value));}};},_this.handleChange=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _ref3,models;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.setState(_defineProperty({},event.target.name,event.target.value));_context.next=3;return _this.props.client.query({query:GET_MODELS,variables:{manufacturerId:event.target.value}});case 3:_ref3=_context.sent;models=_ref3.data;_this.setState({models:models.models});case 6:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}(),_this.handleModelChange=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(event){var _ref5,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_this.setState(_defineProperty({},event.target.name,event.target.value));_context2.next=3;return _this.props.client.query({query:GET_MODEL_TYPE,variables:{modelId:event.target.value},fetchPolicy:'network-only'});case 3:_ref5=_context2.sent;data=_ref5.data;// console.log(data, 'modelType')
_this.setState({deviceType:data.deviceModel.devicetype});case 6:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref4.apply(this,arguments);};}(),_this.handleOpen=function(){_this.setState({open:true});},_this.handleOpenSelect=function(){_this.setState({open1:true});},_this.handleCloseSelect=function(){_this.setState({open1:false});},_this.handleOpenSelectMan=function(){_this.setState({open_man:true});},_this.handleCloseSelectMan=function(){_this.setState({open_man:false});},_this.checkImeinoValidity=function(){// const regex = new RegExp(/^[0-9]{15}$/)
var regex=new RegExp(/^[a-zA-Z0-9]{4,20}$/);_this.setState({errorMessage:''});var code=[];code=_this.state.manufacturerName.split('*');if(code[0]===''){_this.setState({isImeinoValid:_this.state.imeino!==''&&regex.test(_this.state.imeino)});}else{_this.setState({isImeinoValid:_this.state.imeino!==''&&regex.test(_this.state.imeino)});if(_this.state.deviceType==='AS140'){_this.setState({uniqueSerialNumber:code[1]+'_'+_this.state.imeino});}}},_this.checkSerialnoValidity=function(){_this.setState({errorMessage:''});// const regex = new RegExp(/^[0-9]{5,15}$/)
var regex=new RegExp(/^[a-zA-Z0-9]{4,20}$/);var code=[];code=_this.state.manufacturerName.split('*');if(code[0]===''){_this.setState({isSerialnoValid:_this.state.serialno!==''&&regex.test(_this.state.serialno)});}else{_this.setState({isSerialnoValid:_this.state.serialno!==''&&regex.test(_this.state.serialno)// uniqueSerialNumber: code[1] + '_' + this.state.serialno
});if(_this.state.deviceType!=='AS140'){// var code = this.state.manufacturerName.split('*')
_this.setState({uniqueSerialNumber:code[1]+'_'+_this.state.serialno});}}},_this.checkModelNameValidity=function(){_this.setState({isModelNameValid:_this.state.modelname!==''});},_this.checkManufacturerNameValidity=function(){var code=[];code=_this.state.manufacturerName.split('*');if(code[0]===''){_this.setState({isManufacturerNameValid:_this.state.manufacturerName!=='',// manufacturerCode:this
uniqueSerialNumber:code[1]+'_'+_this.state.serialno,manufacturerId:code[0]});}else{_this.setState({isManufacturerNameValid:_this.state.manufacturerName!=='',// manufacturerCode:this
uniqueSerialNumber:'',manufacturerId:code[0]});}},_this.handleSubmit=function(addDevice){return function(e){e.preventDefault();addDevice({variables:{serial_num:_this.state.serialno,imei_num:_this.state.imeino,device_model_id:parseInt(_this.state.modelname,10),uniqueSerialNumber:_this.state.uniqueSerialNumber,manufacturerId:parseInt(_this.state.manufacturerId,10),ownerLoginId:Object(__WEBPACK_IMPORTED_MODULE_17__utils_getLoginId__["a" /* default */])(),is_panic_enabled:_this.state.checked},refetchQueries:['getPartnerDeviceStockByDeviceModel']});// console.log(this.data, 'addDevice')
// this.state.simprovider = ''
_this.setState({serialno:'',imeino:'',// device_model_id: '',
uniqueSerialNumber:''// manufacturerId: ''
});};},_this.handleCheckboxChange=function(event){_this.setState({checked:event.target.checked},function(){console.log('Checkbox state:',_this.state.checked);});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RegisterDevice,[{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;return(// <Query query={GET_MODELS} fetchPolicy="network-only">
//   {({ loading: isModelsLoading, error, data: { models } }) => (
__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_apollo__["Query"],{query:GET_MANUFACTURER,fetchPolicy:'network-only'},function(_ref6){var isManufacturersLoading=_ref6.loading,error=_ref6.error,manufacturers=_ref6.data.manufacturers;if(isManufacturersLoading)return null;if(error)return'Error!: '+error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_apollo__["Mutation"],{mutation:ADD_DEVICE,onCompleted:function onCompleted(){_this3.props.openSnackbar('Device Added Successfully');_this3.props.handleClose();}},function(addDevice,_ref7){var data=_ref7.data,error=_ref7.error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle___default.a,{id:'form-dialog-title'},'Add Device Details :'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core__["Typography"],{variant:'subheading',gutterBottom:true,style:{color:'red',marginLeft:'25px'}},error&&error.graphQLErrors.map(function(_ref8,i){var message=_ref8.message;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{key:i},message);}),_this3.state.errorMessage&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,_this3.state.errorMessage)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core__["Typography"],{variant:'subheading',gutterBottom:true,style:{color:'green',marginLeft:'25px'}},data&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Sucessfully Added')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Divider___default.a,{light:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{onSubmit:_this3.handleSubmit(addDevice)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText___default.a,null,'* Marked fields are mandatory'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel___default.a,{htmlFor:'demo-controlled-open-select'},'Select Manufacturer *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select___default.a,{open:_this3.state.open_man,fullWidth:true,onClose:_this3.handleCloseSelectMan,onOpen:_this3.handleOpenSelectMan,value:_this3.state.manufacturerName,onChange:_this3.handleChange,onBlur:_this3.checkManufacturerNameValidity,inputProps:{name:'manufacturerName',id:'manufacturerName'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),manufacturers.map(function(manufacturer){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{value:manufacturer.id+'*'+manufacturer.manufacturerCode,key:manufacturer.id},manufacturer.manufacturerName);}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel___default.a,{htmlFor:'demo-controlled-open-select'},'Select Model *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select___default.a,{open:_this3.state.open1,fullWidth:true,onClose:_this3.handleCloseSelect,onOpen:_this3.handleOpenSelect,value:_this3.state.modelname,onChange:_this3.handleModelChange,onBlur:_this3.checkModelNameValidity,inputProps:{name:'modelname',id:'modelname'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),_this3.state.models.map(function(allDeviceModelsByStatus){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{value:allDeviceModelsByStatus.id,key:allDeviceModelsByStatus.id},allDeviceModelsByStatus.model_name);}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField___default.a,{margin:'dense',id:'serialno',name:'serialno',label:'Serial No',type:'text',required:true,value:_this3.state.serialno,fullWidth:true,onChange:_this3.handleInputChange('serialno'),error:!_this3.state.isSerialnoValid,onBlur:_this3.checkSerialnoValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this3.state.isSerialnoValid?'':'Serial Number should be between 4-20 characters')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField___default.a,{margin:'dense',id:'imeino',name:'imeino',label:'IMEI No',type:'text',required:true,fullWidth:true,value:_this3.state.imeino,onChange:_this3.handleInputChange('imeino'),error:!_this3.state.isImeinoValid,onBlur:_this3.checkImeinoValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this3.state.isImeinoValid?'':'IMEI Number should be between 4-20 characters')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'uniqueSerialNumber',name:'uniqueSerialNumber',label:'Unique Id',type:'text',disabled:true,required:true,fullWidth:true,value:_this3.state.uniqueSerialNumber,onChange:_this3.handleInputChange('uniqueSerialNumber')// error={!this.state.isImeinoValid}
// onBlur={this.checkImeinoValidity}
})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core__["FormControlLabel"],{label:'Enable Panic Button ?',control:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Checkbox___default.a,{checked:_this3.state.checked,onChange:_this3.handleCheckboxChange,inputProps:{'aria-label':'controlled'}})})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:_this3.props.handleClose,color:'default',variant:'contained'},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a// onClick={this.handleClose}
,{type:'submit',color:'primary',variant:'contained',disabled:!(_this3.state.isModelNameValid&&_this3.state.isSerialnoValid&&_this3.state.isImeinoValid&&_this3.state.serialno!==''&&_this3.state.imeino!==''&&_this3.state.manufacturerName!==''&&_this3.state.uniqueSerialNumber!==''&&_this3.state.modelname!=='')},'Submit'))));});})//   )}
// </Query>
);}}]);return RegisterDevice;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_15_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_19__HOCs_withSharedSnackbar__["a" /* default */])(RegisterDevice))));

/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_DialogTitle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_DialogTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_DialogTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_DialogContent__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_DialogActions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormControlLabel__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormControlLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormControlLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Checkbox__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_Paper__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_Paper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__RegisterSIM__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_file_saver__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__DetailsCard__ = __webpack_require__(1120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ProviderSims__ = __webpack_require__(1121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__EditStatus__ = __webpack_require__(1122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_axios__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__EditSim__ = __webpack_require__(1123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__EditSimAdmin__ = __webpack_require__(1124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__common_Loader__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__utils_getAccountType_js__ = __webpack_require__(68);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getPartnerSimStockByServiceProvider($partnerLoginId: Int!) {\n    sims: getPartnerSimStockByServiceProvider(partnerLoginId: $partnerLoginId) {\n      serviceProviderName\n      totalAssignedSim\n      availableStock\n      simProviderId\n    }\n  }\n'],['\n  query getPartnerSimStockByServiceProvider($partnerLoginId: Int!) {\n    sims: getPartnerSimStockByServiceProvider(partnerLoginId: $partnerLoginId) {\n      serviceProviderName\n      totalAssignedSim\n      availableStock\n      simProviderId\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n'],['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query allSimDetails($partnerLoginId: Int!) {\n    simStock: allSimDetails(ownerLoginId: $partnerLoginId) {\n      id\n      phoneNumber\n      simNumber\n      monthlyCharges\n      status\n\n\n      serviceProvider {\n        name\n        id\n      }\n    }\n  }\n'],['\n  query allSimDetails($partnerLoginId: Int!) {\n    simStock: allSimDetails(ownerLoginId: $partnerLoginId) {\n      id\n      phoneNumber\n      simNumber\n      monthlyCharges\n      status\n\n\n      serviceProvider {\n        name\n        id\n      }\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query allSimDetails($partnerLoginId: Int!, $providerId: Int) {\n    simList: allSimDetails(\n      ownerLoginId: $partnerLoginId\n      serviceProviderId: $providerId\n    ) {\n      id\n      phoneNumber\n      simNumber\n      monthlyCharges\n      status\n      serviceProvider {\n        name\n        id\n      }\n    }\n  }\n'],['\n  query allSimDetails($partnerLoginId: Int!, $providerId: Int) {\n    simList: allSimDetails(\n      ownerLoginId: $partnerLoginId\n      serviceProviderId: $providerId\n    ) {\n      id\n      phoneNumber\n      simNumber\n      monthlyCharges\n      status\n      serviceProvider {\n        name\n        id\n      }\n    }\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  query allSimDetails($partnerLoginId: Int!, $providerId: Int) {\n    simList: allSimDetails(\n      ownerLoginId: $partnerLoginId\n      serviceProviderId: $providerId\n    ) {\n      id\n      phoneNumber\n      simNumber\n      monthlyCharges\n      status\n      clientName\n      vehicleDetails {\n        vehicleNumber\n\n      }\n\n      serviceProvider {\n        name\n        id\n      }\n    }\n  }\n'],['\n  query allSimDetails($partnerLoginId: Int!, $providerId: Int) {\n    simList: allSimDetails(\n      ownerLoginId: $partnerLoginId\n      serviceProviderId: $providerId\n    ) {\n      id\n      phoneNumber\n      simNumber\n      monthlyCharges\n      status\n      clientName\n      vehicleDetails {\n        vehicleNumber\n\n      }\n\n      serviceProvider {\n        name\n        id\n      }\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* eslint-disable */var style=function style(theme){var _root;return{root:(_root={padding:theme.spacing.unit*4},_defineProperty(_root,theme.breakpoints.down('sm'),{padding:theme.spacing.unit*2}),_defineProperty(_root,'flexGrow',1),_root),paper:{padding:theme.spacing.unit*2,color:theme.palette.text.secondary},iconSmall:{fontSize:20}};};var GET_SIM_STOCK=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject);var GET_FILE_FORMAT=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject2);var ALL_SIM_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject3);var GET_SIM_LIST_BASIC=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject4);var GET_SIM_LIST_WITH_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject5);var InventoryDevices=function(_Component){_inherits(InventoryDevices,_Component);function InventoryDevices(props){var _this2=this;_classCallCheck(this,InventoryDevices);var _this=_possibleConstructorReturn(this,(InventoryDevices.__proto__||Object.getPrototypeOf(InventoryDevices)).call(this,props));_this.tableOptions={selectableRows:false,responsive:'scroll',rowsPerPage:5,onRowClick:function onRowClick(rowData,dataIndex,rowIndex){if(rowData.length===5){var installationStatus=void 0;if(rowData[4]==='Yes'){installationStatus='Installed';}else{installationStatus='Not Installed';}_this.setState({editStatusOpen:true,serviceProvider:rowData[0],simNumber:rowData[1],phoneNumber:rowData[2],monthlyCharges:parseInt(rowData[3],10),isInstalled:installationStatus,currentSimId:_this.state.currentSimIds[dataIndex.dataIndex],// prettier-ignore
currentServiceProviderId:_this.state.currentServiceProviderIds[dataIndex.dataIndex]});}else if(rowData.length===4){_this.setState({editStatusOpen:true,serviceProvider:rowData[0],simNumber:rowData[1],phoneNumber:rowData[2],monthlyCharges:parseInt(rowData[3],10),isInstalled:'NA',currentSimId:_this.state.currentSimIds[dataIndex.dataIndex],// prettier-ignore
currentServiceProviderId:_this.state.currentServiceProviderIds[dataIndex.dataIndex]});}}};_this.tableOptions2={selectableRows:false,responsive:'scroll',rowsPerPage:5,onRowClick:function onRowClick(rowData,dataIndex,rowIndex){console.log(_this.status[dataIndex.dataIndex],'di');if(_this.status[dataIndex.dataIndex]===2){if(localStorage.getItem('Account_type')==='SA'||localStorage.getItem('Account_type')==='PA'||localStorage.getItem('Account_type')==='INV')_this.editSim(_this.simId[dataIndex.dataIndex]);}else{_this.props.openSnackbar('Sim cannot be edited');}}};_this.state={open:false,tableColumns:[],tableData:null,tableOptions:[],enableButton:false,editStatusOpen:false,serviceProvider:'',simNumber:'',phoneNumber:'',monthlyCharges:'',selectedCategory:'',isInstalled:'',currentSimIds:[],currentServiceProviderIds:[],currentSimId:'',currentServiceProviderId:'',clickStatus:{Activated:false,Deactivated:false,'Safe Custody':false,Unknown:false},simStock:[],sims:[],selSimId:'',openEdit:false,openEdit2:false,tableVisible:false,tableLoading:false,fetchOptionsDialogOpen:false,selectedProviderId:null,includeClientVehicleDetails:false};_this.handleClickOpen=function(){_this.setState({open:true});};_this.handleClose=function(){_this.setState({open:false,editStatusOpen:false,tableVisible:false,tableData:null});};_this.handleOpenFetchOptionsDialog=function(providerId){_this.setState({fetchOptionsDialogOpen:true,selectedProviderId:providerId,includeClientVehicleDetails:false// Reset checkbox to unchecked
});};_this.handleCloseFetchOptionsDialog=function(){_this.setState({fetchOptionsDialogOpen:false,selectedProviderId:null,includeClientVehicleDetails:false});};_this.handleFetchData=function(){var _this$state=_this.state,selectedProviderId=_this$state.selectedProviderId,includeClientVehicleDetails=_this$state.includeClientVehicleDetails;_this.setState({fetchOptionsDialogOpen:false,tableLoading:true,tableVisible:true},function(){_this.getProviderData(selectedProviderId,includeClientVehicleDetails);});};_this.editSim=function(simId){// console.log(uniqueDeviceId, 'demo')
_this.setState({selSimId:simId},function(){// console.log(this.state.selSimId, 'uid')
});_this.handleClickOpenEdit();};_this.editSimSuperAdmin=function(simId){// console.log(uniqueDeviceId, 'demo')
_this.setState({selSimId:simId},function(){// console.log(this.state.selSimId, 'uid')
});_this.handleClickOpenEditAdmin();};_this.handleClickOpenEditAdmin=function(){_this.setState({openEdit2:true});};_this.handleCloseEditAdmin=function(){_this.setState({openEdit2:false});};_this.handleClickOpenEdit=function(){_this.setState({openEdit:true});};_this.handleCloseEdit=function(){_this.setState({openEdit:false});};_this.addBulkUpload=function(e){_this.props.history.push({pathname:'/home/inventory/sims/bulk-upload'});};_this.addBulkDelete=function(e){_this.props.history.push({pathname:'/home/inventory/sims/bulk-delete'});};_this.downloadBulkUpload=function(client){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _ref2,data,res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.client.query({query:GET_FILE_FORMAT,variables:{bucketname:'excel-templates',filename:'simUpload.xlsx'},errorPolicy:'all'});case 2:_ref2=_context.sent;data=_ref2.data;_context.next=6;return __WEBPACK_IMPORTED_MODULE_23_axios___default()({url:data.getPublicDownloadURL,method:'GET',headers:{Accept:'application/vnd.ms-excel'},responseType:'blob'// important
});case 6:res=_context.sent;__WEBPACK_IMPORTED_MODULE_18_file_saver___default.a.saveAs(new Blob([res.data]),'sample.xlsx');// FileSaver.saveAs(data.getPublicDownloadURL, 'sample.xlsx')
case 8:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();};_this.downloadBulkDelete=function(client){return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(event){var _ref4,data,res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this.props.client.query({query:GET_FILE_FORMAT,variables:{bucketname:'excel-templates',filename:'simDeleteTemplate.xlsx'},errorPolicy:'all'});case 2:_ref4=_context2.sent;data=_ref4.data;_context2.next=6;return __WEBPACK_IMPORTED_MODULE_23_axios___default()({url:data.getPublicDownloadURL,method:'GET',headers:{Accept:'application/vnd.ms-excel'},responseType:'blob'// important
});case 6:res=_context2.sent;__WEBPACK_IMPORTED_MODULE_18_file_saver___default.a.saveAs(new Blob([res.data]),'sample.xlsx');// FileSaver.saveAs(data.getPublicDownloadURL, 'sample.xlsx')
case 8:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref3.apply(this,arguments);};}();};_this.getAllSimDetails=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var simStock;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return _this.props.client.query({query:ALL_SIM_DETAILS,variables:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_22__utils_getLoginId__["a" /* default */])()},fetchPolicy:'cache-and-network'});case 2:simStock=_context3.sent;console.log('simStock',simStock);_this.setState({simStock:simStock.data.simStock});case 5:case'end':return _context3.stop();}}},_callee3,_this2);}));_this.getSimStock=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){var sims;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return _this.props.client.query({query:GET_SIM_STOCK,variables:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_22__utils_getLoginId__["a" /* default */])()},fetchPolicy:'network-only'});case 2:sims=_context4.sent;// console.log('sims', sims)
_this.setState({sims:sims.data.sims});case 4:case'end':return _context4.stop();}}},_callee4,_this2);}));_this.handleClick=function(status){console.log('status',status);var columns=[];var data=[];var category=void 0;var simProviderIds=[];var simIds=[];var clickStatus={Activated:false,Deactivated:false,'Safe Custody':false,Unknown:false};if(status===1){if([1].includes(Object(__WEBPACK_IMPORTED_MODULE_22__utils_getLoginId__["a" /* default */])())){columns=['SERVICE PROVIDER','SIM NUMBER','PHONE NUMBER','COST (in Rs)','INSTALLED','CLIENT NAME','PARTNER NAME','VEHICLE NO'];}else if([2].includes(Object(__WEBPACK_IMPORTED_MODULE_22__utils_getLoginId__["a" /* default */])())){columns=['SERVICE PROVIDER','SIM NUMBER','PHONE NUMBER','COST (in Rs)','INSTALLED','CLIENT NAME','VEHICLE NO'];}category='Activated';clickStatus={Activated:true,Deactivated:false,'Safe Custody':false,Unknown:false};_this.simData.forEach(function(sim){var tempData=[];// make a check for statuses
if(sim.status===4||sim.status===2||sim.status===3){simProviderIds.push(sim.serviceProvider.id);simIds.push(sim.id);tempData.push(sim.serviceProvider.name.toString());tempData.push(sim.simNumber.toString());tempData.push(sim.phoneNumber.toString());tempData.push(sim.monthlyCharges.toString());tempData.push('No');if(sim.clientName===null){tempData.push('NA');}else{tempData.push(sim.clientName);}if([1].includes(Object(__WEBPACK_IMPORTED_MODULE_22__utils_getLoginId__["a" /* default */])())){tempData.push("Taabi Mobility Private Limited");}// to optimise the sim details 29th dec temp change
sim.vehicleDetails?tempData.push(sim.vehicleDetails.vehicleNumber.toString()):tempData.push('N/A');data.push(tempData);}else if(sim.status===4){simProviderIds.push(sim.serviceProvider.id);simIds.push(sim.id);tempData.push(sim.serviceProvider.name.toString());tempData.push(sim.simNumber.toString());tempData.push(sim.phoneNumber.toString());tempData.push(sim.monthlyCharges.toString());tempData.push('Yes');if(sim.clientName===null){tempData.push('NA');}else{tempData.push(sim.clientName);}if([1].includes(Object(__WEBPACK_IMPORTED_MODULE_22__utils_getLoginId__["a" /* default */])())){tempData.push("Taabi Mobility Private Limited");}// to optimise the sim details 29th dec temp change
sim.vehicleDetails?tempData.push(sim.vehicleDetails.vehicleNumber.toString()):tempData.push('N/A');data.push(tempData);data.push(tempData);}});}else{// console.log('else columns')
columns=['SERVICE PROVIDER','SIM NUMBER','PHONE NUMBER','COST (in Rs)','CLIENT NAME'];if(status===0){category='Deactivated';clickStatus={Activated:false,Deactivated:true,'Safe Custody':false,Unknown:false};_this.simData.forEach(function(sim){var tempData=[];// make a check for statuses
if(sim.status===0){simProviderIds.push(sim.serviceProvider.id);simIds.push(sim.id);tempData.push(sim.serviceProvider.name.toString());tempData.push(sim.simNumber.toString());tempData.push(sim.phoneNumber.toString());tempData.push(sim.monthlyCharges.toString());if(sim.clientName===null){tempData.push('NA');}else{tempData.push(sim.clientName);}data.push(tempData);}});}else if(status===99){category='Safe Custody';clickStatus={Activated:false,Deactivated:false,'Safe Custody':true,Unknown:false};_this.simData.forEach(function(sim){var tempData=[];// make a check for statuses
if(sim.status===99){simProviderIds.push(sim.serviceProvider.id);simIds.push(sim.id);tempData.push(sim.serviceProvider.name.toString());tempData.push(sim.simNumber.toString());tempData.push(sim.phoneNumber.toString());tempData.push(sim.monthlyCharges.toString());if(sim.clientName===null){tempData.push('NA');}else{tempData.push(sim.clientName);}data.push(tempData);}});}else if(status===-1){category='Unknown';clickStatus={Activated:false,Deactivated:false,'Safe Custody':false,Unknown:true};_this.simData.forEach(function(sim){var tempData=[];// make a check for statuses
if(sim.status===-1){simProviderIds.push(sim.serviceProvider.id);simIds.push(sim.id);tempData.push(sim.serviceProvider.name.toString());tempData.push(sim.simNumber.toString());tempData.push(sim.phoneNumber.toString());tempData.push(sim.monthlyCharges.toString());if(sim.clientName===null){tempData.push('NA');}else{tempData.push(sim.clientName);}data.push(tempData);}});}}console.log('columns, data',columns,data);_this.setState({tableData:data,tableColumns:columns,// selectedCategory: category,
currentSimIds:simIds,currentServiceProviderIds:simProviderIds,tableOptions:_this.tableOptions2});};_this.handleProviderClick=function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(providerId){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:console.log(providerId,'providerId');_this.handleOpenFetchOptionsDialog(providerId);case 2:case'end':return _context5.stop();}}},_callee5,_this2);}));return function(_x3){return _ref7.apply(this,arguments);};}();_this.getProviderData=function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(providerId){var includeClientVehicleDetails=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var query,simList,columns,data,simProviderIds,simIds;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:query=includeClientVehicleDetails?GET_SIM_LIST_WITH_DETAILS:GET_SIM_LIST_BASIC;_context6.next=3;return _this.props.client.query({query:query,variables:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_22__utils_getLoginId__["a" /* default */])(),providerId:parseInt(providerId,10)},fetchPolicy:'network-only'});case 3:simList=_context6.sent;console.log('sims',simList);columns=[];data=[];_this.status=[];_this.simId=[];simProviderIds=[];simIds=[];// Build columns based on includeClientVehicleDetails
if(includeClientVehicleDetails){// WITH client and vehicle details
if(localStorage.getItem('Account_type')==='SA'){columns=['SERVICE PROVIDER','SIM NUMBER','PHONE NUMBER','COST (in Rs)','INSTALLED','CLIENT NAME','PARTNER NAME','VEHICLE NO'];}else if(localStorage.getItem('Account_type')==='PA'){columns=['SERVICE PROVIDER','SIM NUMBER','PHONE NUMBER','COST (in Rs)','STATUS','CLIENT NAME','VEHICLE NUMBER'];}else{columns=['SERVICE PROVIDER','SIM NUMBER','PHONE NUMBER','COST (in Rs)','STATUS','CLIENT NAME','VEHICLE NUMBER'];}}else{// WITHOUT client and vehicle details
columns=['SERVICE PROVIDER','SIM NUMBER','PHONE NUMBER','COST (in Rs)','STATUS'];}simList.data.simList.forEach(function(sim){console.log(sim);var tempData=[];simProviderIds.push(sim.serviceProvider.id);simIds.push(sim.id);_this.status.push(sim.status);_this.simId.push(sim.id);// Always add these fields
tempData.push(sim.serviceProvider.name.toString());tempData.push(sim.simNumber.toString());tempData.push(sim.phoneNumber.toString());tempData.push(sim.monthlyCharges.toString());tempData.push(_this.getSimStatus(sim.status));// Conditionally add client and vehicle details
if(includeClientVehicleDetails){// Add CLIENT NAME
if(sim.clientName===null){tempData.push('NA');}else{tempData.push(sim.clientName);}// Add PARTNER NAME (only for SA)
if([1].includes(Object(__WEBPACK_IMPORTED_MODULE_22__utils_getLoginId__["a" /* default */])())){tempData.push('Taabi Mobility Private Limited');}// to optimise the sim details 29th dec temp change
// Add VEHICLE NUMBER
sim.vehicleDetails?tempData.push(sim.vehicleDetails.vehicleNumber.toString()):tempData.push('N/A');}data.push(tempData);});console.log('on click data',data,columns);_this.setState({tableData:data,tableColumns:columns,// selectedCategory: category,
currentSimIds:simIds,currentServiceProviderIds:simProviderIds,tableOptions:_this.tableOptions2,tableLoading:false});case 15:case'end':return _context6.stop();}}},_callee6,_this2);}));return function(_x5){return _ref8.apply(this,arguments);};}();_this.getSimStatus=function(status){if(status===2){return'Instock';}else if(status===3){return'Assigned to Client';}else if(status===4){return'Registered to vehicle';}else if(status===0){return'Deactivated';}else if(status===99){return'safe Custody';}else if(status===1){return'Added by super-admin';}};_this.classes=props;_this.simData=[];return _this;}_createClass(InventoryDevices,[{key:'componentDidMount',value:function componentDidMount(){this.handleClick(1);// this.getAllSimDetails()
// this.getSimStock()
}},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;console.log(this.state);// SIM Card categories
var simCategories=[{category:'Activated',status:1,count:0,installed:0,uninstalled:0},{category:'Deactivated',status:0,count:0,installed:0,uninstalled:0},{category:'Safe Custody',status:99,count:0,installed:0,uninstalled:0},{category:'Unknown',status:-1,count:0,installed:0,uninstalled:0}];// set currently selected
var currentlySelected=void 0;if(this.state.clickStatus['Activated']===true){currentlySelected='Activated SIMs';}else if(this.state.clickStatus['Deactivated']===true){currentlySelected='Deactivated SIMs';}else if(this.state.clickStatus['Safe Custody']===true){currentlySelected='Safe Custody SIMs';}else if(this.state.clickStatus['Unknown']===true){currentlySelected='Unknown SIMs';}console.log(this.state.tableOptions);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog___default.a,{open:this.state.open,'aria-labelledby':'form-dialog-title'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__RegisterSIM__["a" /* default */],{handleClose:this.handleClose})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog___default.a,{open:this.state.editStatusOpen,'aria-labelledby':'edit-status-dialog'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__EditStatus__["a" /* default */],{handleClose:this.handleClose,category:this.state.selectedCategory,serviceProvider:this.state.serviceProvider,simNumber:this.state.simNumber,phoneNumber:this.state.phoneNumber,monthlyCharges:this.state.monthlyCharges,isInstalled:this.state.isInstalled,simId:this.state.currentSimId,serviceProviderId:this.state.currentServiceProviderId})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog___default.a,{open:this.state.fetchOptionsDialogOpen,onClose:this.handleCloseFetchOptionsDialog,'aria-labelledby':'fetch-options-dialog'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_DialogTitle___default.a,{id:'fetch-options-dialog-title'},'Fetch SIM Details'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{variant:'body1',gutterBottom:true},'Choose how you want to fetch the SIM data:'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Checkbox___default.a,{checked:this.state.includeClientVehicleDetails,onChange:function onChange(e){return _this3.setState({includeClientVehicleDetails:e.target.checked});},color:'primary'}),label:'Include Client and Vehicle Details'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_DialogActions___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{onClick:this.handleCloseFetchOptionsDialog,color:'default'},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{onClick:this.handleFetchData,color:'primary',variant:'contained'},'Fetch Data'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog___default.a,{open:this.state.openEdit,onClose:this.handleCloseEdit,'aria-labelledby':'form-dialog-title'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__EditSim__["a" /* default */],{handleClose:this.handleCloseEdit,selSimId:this.state.selSimId})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog___default.a,{open:this.state.openEdit2,onClose:this.handleCloseEditAdmin,'aria-labelledby':'form-dialog-title'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__EditSimAdmin__["a" /* default */],{handleClose:this.handleCloseEditAdmin,selSimId:this.state.selSimId})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:16,justify:'space-between'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{variant:'headline'},'SIM Card Management')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},localStorage.getItem('Account_type')==='SA'&&window.location.host.includes('iocl')?null:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:8,justify:'flex-end'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12,sm:'auto'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{fullWidth:true,color:'secondary',variant:'contained',className:classes.button// href="/home/customers/add"
,onClick:this.handleClickOpen},'Add SIM Card')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12,sm:'auto'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{fullWidth:true,color:'secondary',variant:'contained',className:classes.button,onClick:this.addBulkUpload},'Bulk SIM Upload')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12,sm:'auto'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{fullWidth:true,color:'secondary',variant:'contained',className:classes.button,onClick:this.addBulkDelete},'Bulk SIM Delete')))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:8},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{variant:'subheading',color:'textSecondary'},'SIM Provider(s)')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["Query"],{query:GET_SIM_STOCK,variables:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_22__utils_getLoginId__["a" /* default */])()},fetchPolicy:'network-only'},function(_ref9){var loading=_ref9.loading,error=_ref9.error,data=_ref9.data;if(loading)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__common_Loader__["a" /* default */],null);if(error)return'Error!: '+error;var sims=data.sims;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:12},sims.map(function(sim){console.log(sim,'sim');return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3,key:sim.simProviderId},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__ProviderSims__["a" /* default */],{provider:sim.serviceProviderName,noOfSims:sim.totalAssignedSim,handleProviderClick:function handleProviderClick(){return _this3.handleProviderClick(sim.simProviderId);},providerId:sim.simProviderId}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_Divider___default.a,null));}));})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:8},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{variant:'subheading',color:'textSecondary'},'Sim Card Details')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},this.state.tableVisible?this.state.tableLoading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__common_Loader__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_mui_datatables___default.a,{data:this.state.tableData,columns:this.state.tableColumns,options:this.state.tableOptions}):null)))));}}]);return InventoryDevices;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_24__HOCs_withSharedSnackbar__["a" /* default */])(InventoryDevices))));

/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_DialogActions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogContent__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContentText__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContentText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContentText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogTitle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_FormHelperText__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_FormHelperText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_FormHelperText__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query {\n    allServiceProviders(status: 1) {\n      id\n      name\n    }\n  }\n'],['\n  query {\n    allServiceProviders(status: 1) {\n      id\n      name\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  mutation addSimDetailsFromPartnerAdmin(\n    $phoneNumber: String!\n    $simNumber: String!\n    $service_provider_id: Int!\n    $ownerLoginId: Int!\n    $monthlyCharges: Int!\n  ) {\n    addSimDetailsFromPartnerAdmin(\n      phoneNumber: $phoneNumber\n      simNumber: $simNumber\n      service_provider_id: $service_provider_id\n      ownerLoginId: $ownerLoginId\n      monthlyCharges: $monthlyCharges\n    )\n  }\n'],['\n  mutation addSimDetailsFromPartnerAdmin(\n    $phoneNumber: String!\n    $simNumber: String!\n    $service_provider_id: Int!\n    $ownerLoginId: Int!\n    $monthlyCharges: Int!\n  ) {\n    addSimDetailsFromPartnerAdmin(\n      phoneNumber: $phoneNumber\n      simNumber: $simNumber\n      service_provider_id: $service_provider_id\n      ownerLoginId: $ownerLoginId\n      monthlyCharges: $monthlyCharges\n    )\n  }\n']);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// graph ql querries
var GET_PROVIDER=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject);// calling server for updation
var ADD_SIM=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject2);var styles=function styles(theme){return{button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{margin:theme.spacing.unit,minWidth:120}};};var AddSim=function(_Component){_inherits(AddSim,_Component);function AddSim(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AddSim);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AddSim.__proto__||Object.getPrototypeOf(AddSim)).call.apply(_ref,[this].concat(args))),_this),_this.state={open1:false,simprovider:'',phoneno:'',simno:'',simPrice:'',isSimProviderValid:true,isphonenoValid:true,isSimnoValid:true,isSimPriceValid:true},_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));};},_this.handleChange=function(event){_this.setState(_defineProperty({},event.target.name,event.target.value));},_this.handleOpenSelect=function(){_this.setState({open1:true});},_this.handleCloseSelect=function(){_this.setState({open1:false});},_this.checkSimnoValidity=function(){var regex=new RegExp(// eslint-disable-next-line
/^[0-9]{10,25}$/);// console.log('a', this.state.imeino)
console.log(regex.test(_this.state.simno));_this.setState({isSimnoValid:regex.test(_this.state.simno)||_this.state.simno===''// this.state.modelname === ''
});// console.log(this.state.isModelNameValid)
},_this.checkPhonenoValidity=function(){var regex=new RegExp(/^[0-9]{9,14}$/);_this.setState({isPhonenoValid:regex.test(_this.state.phoneno)||_this.state.phoneno===''});},_this.checkSimPriceValidity=function(){var regex=new RegExp(/^[0-9]+$/);_this.setState({isSimPriceValid:regex.test(_this.state.simPrice)||_this.state.simPrice===''});if(parseInt(_this.state.simPrice,10)<1||parseInt(_this.state.simPrice,10)>500){_this.setState({isSimPriceValid:false});}},_this.checkSimProviderValidity=function(){_this.setState({isSimProviderValid:_this.state.simprovider!==''});},_this.handleSubmit=function(addSim){return function(e){console.log('click fun');e.preventDefault();addSim({variables:{phoneNumber:_this.state.phoneno,simNumber:_this.state.simno,service_provider_id:parseInt(_this.state.simprovider,10),ownerLoginId:Object(__WEBPACK_IMPORTED_MODULE_15__utils_getLoginId__["a" /* default */])(),monthlyCharges:parseInt(_this.state.simPrice,10)},refetchQueries:['getPartnerSimStockByServiceProvider']}).then(function(){// Close dialog on successful SIM addition
_this.props.handleClose();}).catch(function(err){_this.setState({err:err});});_this.setState({phoneno:'',simno:'',simprovider:'',simPrice:''});};},_temp),_possibleConstructorReturn(_this,_ret);}// handleSubmit = addProvider => e => {
//   e.preventDefault()
//   addProvider({
//     variables: { type: this.state.simprovider },
//     refetchQueries: [`allSimDetails`]
//   })
//   // this.state.simprovider = ''
//   this.setState({
//     simprovider: ''
//   })
// }
_createClass(AddSim,[{key:'render',value:function render(){var _this2=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_apollo__["Query"],{query:GET_PROVIDER,fetchPolicy:'network-only'},function(_ref2){var loading=_ref2.loading,error=_ref2.error,data=_ref2.data;var queriedData=data;if(loading)return'Loading...';if(error)return'Error!: '+error;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_apollo__["Mutation"],{mutation:ADD_SIM},function(addSim,_ref3){var data=_ref3.data,simError=_ref3.error;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogTitle___default.a,{id:'form-dialog-title'},'Add SIM Details :',' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core__["Typography"],{variant:'subheading',gutterBottom:true,style:{color:'red',marginLeft:'25px'}},console.log(simError,'simError'),simError&&simError.graphQLErrors.map(function(_ref4,i){var message=_ref4.message;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:i},message);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core__["Typography"],{variant:'subheading',gutterBottom:true,style:{color:'green',marginLeft:'25px'}},data&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Sucessfully Added')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:_this2.handleSubmit(addSim)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContentText___default.a,null,'* Marked fields are mandatory'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel___default.a,{htmlFor:'demo-controlled-open-select'},'Sim Provider'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select___default.a,{open:_this2.state.open1,fullWidth:true,onClose:_this2.handleCloseSelect,onOpen:_this2.handleOpenSelect,value:_this2.state.simprovider,onChange:_this2.handleChange,onBlur:_this2.checkSimProviderValidity,inputProps:{name:'simprovider',id:'simprovider'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'None')),queriedData.allServiceProviders.map(function(allServiceProvidersByStatus){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default.a,{value:allServiceProvidersByStatus.id,key:allServiceProvidersByStatus.id},allServiceProvidersByStatus.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'phoneno',name:'phoneno',label:'Phone No',type:'text',required:true,value:_this2.state.phoneno,fullWidth:true,onChange:_this2.handleInputChange('phoneno'),error:!_this2.state.isPhonenoValid,onBlur:_this2.checkPhonenoValidity}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this2.state.isPhonenoValid?'':'Phone Number should be between 9-15 digits')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'simno',name:'simno',label:'SIM No',type:'text',required:true,fullWidth:true,value:_this2.state.simno,onChange:_this2.handleInputChange('simno'),error:!_this2.state.isSimnoValid,onBlur:_this2.checkSimnoValidity}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this2.state.isSimnoValid?'':'Sim Number should be between 10-25 digits')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'simPrice',name:'simPrice',label:'SIM Price per Month',type:'text',required:true,fullWidth:true,value:_this2.state.simPrice,onChange:_this2.handleInputChange('simPrice'),error:!_this2.state.isSimPriceValid,onBlur:_this2.checkSimPriceValidity}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this2.state.isSimPriceValid?'':'Sim Price should be between 1-500'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_DialogActions___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button___default.a,{onClick:_this2.props.handleClose,color:'default',variant:'contained'},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button___default.a// onClick={this.handleClose}
,{color:'primary',type:'submit',variant:'contained',disabled:!(_this2.state.isSimProviderValid&&_this2.state.isSimnoValid&&_this2.state.isPhonenoValid&&_this2.state.phoneno!==''&&_this2.state.simno!==''&&_this2.state.isSimPriceValid&&_this2.state.simPrice!==''&&_this2.state.simprovider!=='')},'Submit'))));});});}}]);return AddSim;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__["withStyles"])(styles)(AddSim));

/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Card__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_CardContent__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_CardContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_CardContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var style=function style(theme){return{title:{fontSize:14},card:{width:'100%',height:'100%',textAlign:'center'},buttonBase:{width:'100%',height:'100%',textAlign:'left'},pos:{marginBottom:12}};};var DetailsCard=function(_Component){_inherits(DetailsCard,_Component);function DetailsCard(){_classCallCheck(this,DetailsCard);return _possibleConstructorReturn(this,(DetailsCard.__proto__||Object.getPrototypeOf(DetailsCard)).apply(this,arguments));}_createClass(DetailsCard,[{key:'render',value:function render(){var _this2=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core__["ButtonBase"],{className:classes.buttonBase,onClick:function onClick(){return _this2.props.handleClick(_this2.props.status);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Card___default.a,{className:classes.card,raised:!this.props.isClicked},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body2'},this.props.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'title',color:'error'},this.props.count))));}}]);return DetailsCard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles__["withStyles"])(style)(DetailsCard));

/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Avatar__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Paper__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Paper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Card__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_CardContent__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_CardContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_CardContent__);
// import ListItemIcon from '@material-ui/core/ListItemIcon'
// import ListItemText from '@material-ui/core/ListItemText'
// import {  } from '@material-ui/core'
var styles=function styles(theme){return{avatar:{margin:10,width:60,height:60},root:{backgroundColor:theme.palette.background.paper},paper:{padding:theme.spacing.unit*2,color:theme.palette.text.secondary,wordBreak:'break-all','&:hover':{cursor:'pointer'}},listItem:{width:'100%',textAlign:'left'},inlineItem:{display:'inline-block',paddingRight:'10px'}};};function ProviderSims(props){var classes=props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["ButtonBase"],{className:classes.buttonBase,onClick:function onClick(){return props.handleProviderClick(props.providerId,props.simStock);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Card___default.a,{className:classes.card},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true,spacing:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Avatar___default.a,{className:classes.avatar},props.provider.charAt(0).toUpperCase())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true,spacing:8// onClick={() => this.props.handleProviderClick(props.providerId)}
},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Typography"],{variant:'display1'},props.provider.charAt(0).toUpperCase()+props.provider.substr(1))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Typography"],{className:classes.inlineItem,variant:'body2'},'Total SIMs:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Typography"],{className:classes.inlineItem,variant:'body1'},props.noOfSims)))))))));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles__["withStyles"])(styles)(ProviderSims));

/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_DialogActions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogContent__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogTitle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Radio__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__HOCs_withSharedSnackbar__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  mutation updateSimDetail(\n    $id: Int!\n    $phoneNumber: String!\n    $simNumber: String!\n    $ownerLoginId: Int!\n    $monthlyCharges: Int!\n    $status: Int!\n    $service_provider_id: Int!\n  ) {\n    updateSimDetail(\n      id: $id\n      phoneNumber: $phoneNumber\n      simNumber: $simNumber\n      ownerLoginId: $ownerLoginId\n      monthlyCharges: $monthlyCharges\n      status: $status\n      service_provider_id: $service_provider_id\n    )\n  }\n'],['\n  mutation updateSimDetail(\n    $id: Int!\n    $phoneNumber: String!\n    $simNumber: String!\n    $ownerLoginId: Int!\n    $monthlyCharges: Int!\n    $status: Int!\n    $service_provider_id: Int!\n  ) {\n    updateSimDetail(\n      id: $id\n      phoneNumber: $phoneNumber\n      simNumber: $simNumber\n      ownerLoginId: $ownerLoginId\n      monthlyCharges: $monthlyCharges\n      status: $status\n      service_provider_id: $service_provider_id\n    )\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// calling server for updation
var UPDATE_SIM_STATUS=Object(__WEBPACK_IMPORTED_MODULE_7_graphql_tag__["a" /* default */])(_templateObject);var styles=function styles(theme){return{button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{margin:theme.spacing.unit,minWidth:120},root:{padding:theme.spacing.unit*2,flexGrow:1}};};var EditStatus=function(_Component){_inherits(EditStatus,_Component);function EditStatus(props){var _this2=this;_classCallCheck(this,EditStatus);var _this=_possibleConstructorReturn(this,(EditStatus.__proto__||Object.getPrototypeOf(EditStatus)).call(this,props));_this.state={newStatusSelected:false,selectedValue:'',simStatus:'',updateSuccess:false};_this.handleChange=function(event){if(event.target.value!==_this.props.category){_this.setState({selectedValue:event.target.value,newStatusSelected:true,simStatus:event.target.name});}else{_this.setState({selectedValue:event.target.value,newStatusSelected:false,simStatus:event.target.name});}};_this.updateSimStatus=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _ref2,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.client.mutate({mutation:UPDATE_SIM_STATUS,variables:{id:parseInt(_this.props.simId,10),phoneNumber:_this.props.phoneNumber,simNumber:_this.props.simNumber,ownerLoginId:Object(__WEBPACK_IMPORTED_MODULE_12__utils_getLoginId__["a" /* default */])(),monthlyCharges:parseInt(_this.props.monthlyCharges,10),status:parseInt(_this.state.simStatus,10),service_provider_id:parseInt(_this.props.serviceProviderId,10)},refetchQueries:['allSimDetails']});case 2:_ref2=_context.sent;data=_ref2.data;if(data.updateSimDetail===true){_this.setState({updateSuccess:true,newStatusSelected:false});_this.props.openSnackbar('Updated Successfully');_this.props.handleClose();}case 5:case'end':return _context.stop();}}},_callee,_this2);}));_this.classes=props;return _this;}_createClass(EditStatus,[{key:'componentDidMount',value:function componentDidMount(){this.setState({selectedValue:this.props.category});}},{key:'render',value:function render(){var _this3=this;// SIM Card categories
var simCategories=[{category:'Activated',status:1,count:0,installed:0,uninstalled:0},{category:'Deactivated',status:0,count:0,installed:0,uninstalled:0},{category:'Safe Custody',status:99,count:0,installed:0,uninstalled:0}];var activeCategories=['Activate','Deactivate','Safe Custody'];var status=void 0;if(this.state.updateSuccess===true){status=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Typography"],{variant:'body2',color:'primary'},'Update Successful'));}else{status=null;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogTitle___default.a,{id:'form-dialog-title'},'Edit SIM Status'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Typography"],{variant:'body1'},'Service Provider:')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:8},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Typography"],{variant:'body2'},this.props.serviceProvider)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Typography"],{variant:'body1'},'SIM Number:')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:8},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Typography"],{variant:'body2'},this.props.simNumber)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Typography"],{variant:'body1'},'Phone Number:')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:8},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Typography"],{variant:'body2'},this.props.phoneNumber)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Typography"],{variant:'body1'},'Cost per month:')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:8},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Typography"],{variant:'body2'},this.props.monthlyCharges)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Typography"],{variant:'body1'},'Current Status:')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:8},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Typography"],{variant:'body2'},this.props.category)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Typography"],{variant:'body1'},'Installation Status:')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:8},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Typography"],{variant:'body2'},this.props.isInstalled)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Typography"],{variant:'subheading'},'Update SIM Status')),activeCategories.map(function(category){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:4,alignItems:'center',justify:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Typography"],{variant:'body1'},category));}),simCategories.map(function(sim){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:4,alignItems:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Radio___default.a,{checked:_this3.state.selectedValue===sim.category,onChange:_this3.handleChange,value:sim.category,name:sim.status,'aria-label':sim.category}));}),status)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_DialogActions___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:this.props.handleClose,color:'default',variant:'contained'},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:this.updateSimStatus,color:'primary',type:'submit',variant:'contained',disabled:!this.state.newStatusSelected},'Update')));}}]);return EditStatus;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var withApolloClient=function withApolloClient(Component){return function(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_apollo__["ApolloConsumer"],null,function(client){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component,Object.assign({client:client},props));});};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__["withStyles"])(styles)(withApolloClient(Object(__WEBPACK_IMPORTED_MODULE_13__HOCs_withSharedSnackbar__["a" /* default */])(EditStatus))));

/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core_FormHelperText__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core_FormHelperText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_FormHelperText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_icons_DeleteForever__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_icons_DeleteForever___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__material_ui_icons_DeleteForever__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_core_Tooltip__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_core_Tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__material_ui_core_Grid__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query {\n    allServiceProviders(status: 1) {\n      id\n      name\n    }\n  }\n'],['\n  query {\n    allServiceProviders(status: 1) {\n      id\n      name\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query simDetail($simId: Int) {\n    simDetail(id: $simId) {\n      phoneNumber\n      simNumber\n      monthlyCharges\n      serviceProvider {\n        id\n        name\n      }\n    }\n  }\n'],['\n  query simDetail($simId: Int) {\n    simDetail(id: $simId) {\n      phoneNumber\n      simNumber\n      monthlyCharges\n      serviceProvider {\n        id\n        name\n      }\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation updateSimDetail(\n    $id: Int!\n    $phoneNumber: String!\n    $simNumber: String!\n    $ownerLoginId: Int!\n    $monthlyCharges: Int!\n    $status: Int!\n    $service_provider_id: Int!\n  ) {\n    updateSimDetail(\n      id: $id\n      phoneNumber: $phoneNumber\n      simNumber: $simNumber\n      ownerLoginId: $ownerLoginId\n      monthlyCharges: $monthlyCharges\n      status: $status\n      service_provider_id: $service_provider_id\n    )\n  }\n'],['\n  mutation updateSimDetail(\n    $id: Int!\n    $phoneNumber: String!\n    $simNumber: String!\n    $ownerLoginId: Int!\n    $monthlyCharges: Int!\n    $status: Int!\n    $service_provider_id: Int!\n  ) {\n    updateSimDetail(\n      id: $id\n      phoneNumber: $phoneNumber\n      simNumber: $simNumber\n      ownerLoginId: $ownerLoginId\n      monthlyCharges: $monthlyCharges\n      status: $status\n      service_provider_id: $service_provider_id\n    )\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  mutation deleteSim(\n    $phoneNumber: String!\n    $simNumber: String!\n    $ownerLoginId: Int!\n  ) {\n    deleteSim(\n      phoneNumber: $phoneNumber\n      simNumber: $simNumber\n      ownerLoginId: $ownerLoginId\n    )\n  }\n'],['\n  mutation deleteSim(\n    $phoneNumber: String!\n    $simNumber: String!\n    $ownerLoginId: Int!\n  ) {\n    deleteSim(\n      phoneNumber: $phoneNumber\n      simNumber: $simNumber\n      ownerLoginId: $ownerLoginId\n    )\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_PROVIDER=Object(__WEBPACK_IMPORTED_MODULE_14_graphql_tag__["a" /* default */])(_templateObject);var GET_SIM_DETAIL=Object(__WEBPACK_IMPORTED_MODULE_14_graphql_tag__["a" /* default */])(_templateObject2);// calling server for updation
var UPDATE_SIM=Object(__WEBPACK_IMPORTED_MODULE_14_graphql_tag__["a" /* default */])(_templateObject3);var DELETE_SIM=Object(__WEBPACK_IMPORTED_MODULE_14_graphql_tag__["a" /* default */])(_templateObject4);var styles=function styles(theme){return{button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{margin:theme.spacing.unit,minWidth:120}};};var EditSim=function(_Component){_inherits(EditSim,_Component);function EditSim(props){var _this2=this;_classCallCheck(this,EditSim);var _this=_possibleConstructorReturn(this,(EditSim.__proto__||Object.getPrototypeOf(EditSim)).call(this,props));_this.state={open1:false,simprovider:'',phoneno:'',simno:'',simPrice:'',isSimProviderValid:true,isphonenoValid:true,isSimnoValid:true,isSimPriceValid:true};_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));};};_this.handleChange=function(event){_this.setState(_defineProperty({},event.target.name,event.target.value));};_this.handleOpen=function(){_this.setState({open:true});};_this.handleOpenSelect=function(){_this.setState({open1:true});};_this.handleCloseSelect=function(){_this.setState({open1:false});};_this.checkSimnoValidity=function(){var regex=new RegExp(// eslint-disable-next-line
/^[0-9]{10,25}$/);// console.log('a', this.state.imeino)
console.log(regex.test(_this.state.simno));_this.setState({isSimnoValid:regex.test(_this.state.simno)||_this.state.simno===''// this.state.modelname === ''
});// console.log(this.state.isModelNameValid)
};_this.checkPhonenoValidity=function(){var regex=new RegExp(/^[0-9]{9,14}$/);_this.setState({isPhonenoValid:regex.test(_this.state.phoneno)||_this.state.phoneno===''});};_this.checkSimPriceValidity=function(){var regex=new RegExp(/^[0-9]+$/);_this.setState({isSimPriceValid:regex.test(_this.state.simPrice)||_this.state.simPrice===''});if(parseInt(_this.state.simPrice,10)<1||parseInt(_this.state.simPrice,10)>500){_this.setState({isSimPriceValid:false});}};_this.checkSimProviderValidity=function(){_this.setState({isSimProviderValid:_this.state.simprovider!==''});};_this.handleSubmit=function(updateDevice){return function(e){e.preventDefault();updateDevice({variables:{phoneNumber:_this.state.phoneno,simNumber:_this.state.simno,monthlyCharges:parseInt(_this.state.simPrice,10),service_provider_id:_this.state.simprovider,status:2,id:parseInt(_this.props.selSimId,10),ownerLoginId:Object(__WEBPACK_IMPORTED_MODULE_17__utils_getLoginId__["a" /* default */])()},refetchQueries:['getPartnerSimStockByServiceProvider']});// console.log(this.data, 'addDevice')
// this.state.simprovider = ''
_this.setState({phoneno:'',simno:'',// device_model_id: '',
simPrice:'',simprovider:''});};};_this.deleteSim=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _ref2,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:event.preventDefault();_context.next=3;return _this.props.client.mutate({mutation:DELETE_SIM,variables:{phoneNumber:_this.state.phoneno,simNumber:_this.state.simno,ownerLoginId:Object(__WEBPACK_IMPORTED_MODULE_17__utils_getLoginId__["a" /* default */])()},refetchQueries:['getPartnerSimStockByServiceProvider','allSimDetails'],errorPolicy:'all'});case 3:_ref2=_context.sent;data=_ref2.data;// console.log('submit', data.deleteDeviceInStock)
if(data.deleteSim===true){_this.props.handleClose();_this.props.openSnackbar('Sim Deleted Successfully');}else{_this.props.openSnackbar('Error in deleting Sim');}case 6:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.getSimDetails=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var _ref4,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this.props.client.query({query:GET_SIM_DETAIL,variables:{simId:_this.existingSimId},fetchPolicy:'network-only'});case 2:_ref4=_context2.sent;data=_ref4.data;_this.setDetails(data.simDetail);case 5:case'end':return _context2.stop();}}},_callee2,_this2);}));_this.setDetails=function(simDetail){_this.setState({phoneno:simDetail.phoneNumber,simno:simDetail.simNumber,simPrice:simDetail.monthlyCharges,simprovider:simDetail.serviceProvider.id});};_this.classes=props;_this.existingSimId=_this.props.selSimId;return _this;}_createClass(EditSim,[{key:'componentDidMount',value:function componentDidMount(){this.getSimDetails();}},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;return(// <Query query={GET_MODELS} fetchPolicy="network-only">
//   {({ loading: isModelsLoading, error, data: { models } }) => (
__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_apollo__["Query"],{query:GET_PROVIDER,fetchPolicy:'network-only'},function(_ref5){var loading=_ref5.loading,error=_ref5.error,data=_ref5.data;var queriedData=data;if(loading)return null;if(error)return'Error!: '+error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_apollo__["Mutation"],{mutation:UPDATE_SIM},function(updateSim,_ref6){var data=_ref6.data,error=_ref6.error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{variant:'outlined',color:'secondary',className:classes.button,style:{float:'right'},onClick:_this3.deleteSim},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Tooltip___default.a,{title:'Delete SIM'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_icons_DeleteForever___default.a,{className:classes.icon}))),' '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle___default.a,{id:'form-dialog-title'},'Edit SIM Details :'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core__["Typography"],{variant:'subheading',gutterBottom:true,style:{color:'red',marginLeft:'25px'}},error&&error.graphQLErrors.map(function(_ref7,i){var message=_ref7.message;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{key:i},message);}),_this3.state.errorMessage&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,_this3.state.errorMessage)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core__["Typography"],{variant:'subheading',gutterBottom:true,style:{color:'green',marginLeft:'25px'}},data&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Sucessfully Updated')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Divider___default.a,{light:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{onSubmit:_this3.handleSubmit(updateSim)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText___default.a,null,'* Marked fields are mandatory'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel___default.a,{htmlFor:'demo-controlled-open-select'},'Select SIm Provider *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select___default.a,{open:_this3.state.open1,fullWidth:true,onClose:_this3.handleCloseSelect,onOpen:_this3.handleOpenSelect,value:_this3.state.simprovider,onChange:_this3.handleChange,onBlur:_this3.checkSimProviderValidity,inputProps:{name:'simprovider',id:'simprovider'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),queriedData.allServiceProviders.map(function(allServiceProvidersByStatus){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{value:allServiceProvidersByStatus.id,key:allServiceProvidersByStatus.id},allServiceProvidersByStatus.name);}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'phoneno',name:'phoneno',label:'Phone No',type:'text',required:true,value:_this3.state.phoneno,fullWidth:true,onChange:_this3.handleInputChange('phoneno'),error:!_this3.state.isPhonenoValid,onBlur:_this3.checkPhonenoValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this3.state.isPhonenoValid?'':'Phone Number should be between 9-15 digits')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'simno',name:'simno',label:'SIM No',type:'text',required:true,fullWidth:true,value:_this3.state.simno,onChange:_this3.handleInputChange('simno'),error:!_this3.state.isSimnoValid,onBlur:_this3.checkSimnoValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this3.state.isSimnoValid?'':'Sim Number should be between 10-25 digits')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'simPrice',name:'simPrice',label:'SIM Price per Month',type:'text',required:true,fullWidth:true,value:_this3.state.simPrice,onChange:_this3.handleInputChange('simPrice'),error:!_this3.state.isSimPriceValid,onBlur:_this3.checkSimPriceValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this3.state.isSimPriceValid?'':'Sim Price should be between 1-500'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:_this3.props.handleClose,color:'default',variant:'contained'},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a// onClick={this.handleClose}
,{type:'submit',color:'primary',variant:'contained',disabled:!(_this3.state.isSimProviderValid&&_this3.state.isSimnoValid&&_this3.state.isPhonenoValid&&_this3.state.phoneno!==''&&_this3.state.simno!==''&&_this3.state.isSimPriceValid&&_this3.state.simPrice!==''&&_this3.state.simprovider!=='')},'Submit'))));});})//   )}
// </Query>
);}}]);return EditSim;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_15_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_19__HOCs_withSharedSnackbar__["a" /* default */])(EditSim))));

/***/ }),
/* 1124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core_FormHelperText__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core_FormHelperText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_FormHelperText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_icons_DeleteForever__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_icons_DeleteForever___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__material_ui_icons_DeleteForever__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_core_Tooltip__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_core_Tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__material_ui_core_Grid__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query {\n    allServiceProviders(status: 1) {\n      id\n      name\n    }\n  }\n'],['\n  query {\n    allServiceProviders(status: 1) {\n      id\n      name\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query simDetail($simId: Int) {\n    simDetail(id: $simId) {\n      phoneNumber\n      simNumber\n      monthlyCharges\n      serviceProvider {\n        id\n        name\n\t  }\n\t  partnerDetails {\n\t\tid\n\t\tbusinessName\n\t  }\n    }\n  }\n'],['\n  query simDetail($simId: Int) {\n    simDetail(id: $simId) {\n      phoneNumber\n      simNumber\n      monthlyCharges\n      serviceProvider {\n        id\n        name\n\t  }\n\t  partnerDetails {\n\t\tid\n\t\tbusinessName\n\t  }\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query allPartnerDetails {\n    clients: allPartnerDetails {\n\t\tid\n      businessName\n      email\n      contactNumber\n      contactPerson\n      login {\n        loginId\n      }\n    }\n  }\n'],['\n  query allPartnerDetails {\n    clients: allPartnerDetails {\n\t\tid\n      businessName\n      email\n      contactNumber\n      contactPerson\n      login {\n        loginId\n      }\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  mutation updateSimDetail(\n    $id: Int!\n    $phoneNumber: String!\n    $simNumber: String!\n    $ownerLoginId: Int!\n    $monthlyCharges: Int!\n    $status: Int!\n\t$service_provider_id: Int!\n  ) {\n    updateSimDetail(\n      id: $id\n      phoneNumber: $phoneNumber\n      simNumber: $simNumber\n      ownerLoginId: $ownerLoginId\n      monthlyCharges: $monthlyCharges\n      status: $status\n\t  service_provider_id: $service_provider_id\n    )\n  }\n'],['\n  mutation updateSimDetail(\n    $id: Int!\n    $phoneNumber: String!\n    $simNumber: String!\n    $ownerLoginId: Int!\n    $monthlyCharges: Int!\n    $status: Int!\n\t$service_provider_id: Int!\n  ) {\n    updateSimDetail(\n      id: $id\n      phoneNumber: $phoneNumber\n      simNumber: $simNumber\n      ownerLoginId: $ownerLoginId\n      monthlyCharges: $monthlyCharges\n      status: $status\n\t  service_provider_id: $service_provider_id\n    )\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  mutation deleteSim(\n    $phoneNumber: String!\n    $simNumber: String!\n    $ownerLoginId: Int!\n  ) {\n    deleteSim(\n      phoneNumber: $phoneNumber\n      simNumber: $simNumber\n      ownerLoginId: $ownerLoginId\n    )\n  }\n'],['\n  mutation deleteSim(\n    $phoneNumber: String!\n    $simNumber: String!\n    $ownerLoginId: Int!\n  ) {\n    deleteSim(\n      phoneNumber: $phoneNumber\n      simNumber: $simNumber\n      ownerLoginId: $ownerLoginId\n    )\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable */var GET_PROVIDER=Object(__WEBPACK_IMPORTED_MODULE_14_graphql_tag__["a" /* default */])(_templateObject);var GET_SIM_DETAIL=Object(__WEBPACK_IMPORTED_MODULE_14_graphql_tag__["a" /* default */])(_templateObject2);var GET_PARTNER=Object(__WEBPACK_IMPORTED_MODULE_14_graphql_tag__["a" /* default */])(_templateObject3);// calling server for updation
var UPDATE_SIM=Object(__WEBPACK_IMPORTED_MODULE_14_graphql_tag__["a" /* default */])(_templateObject4);var DELETE_SIM=Object(__WEBPACK_IMPORTED_MODULE_14_graphql_tag__["a" /* default */])(_templateObject5);var styles=function styles(theme){return{button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{margin:theme.spacing.unit,minWidth:120}};};var EditSimAdmin=function(_Component){_inherits(EditSimAdmin,_Component);function EditSimAdmin(props){var _this2=this;_classCallCheck(this,EditSimAdmin);var _this=_possibleConstructorReturn(this,(EditSimAdmin.__proto__||Object.getPrototypeOf(EditSimAdmin)).call(this,props));_this.state={open1:false,open2:false,simprovider:'',phoneno:'',simno:'',simPrice:'',isSimProviderValid:true,isphonenoValid:true,isSimnoValid:true,isSimPriceValid:true,clients:[],partnerName:''};_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));};};_this.handleChange=function(event){_this.setState(_defineProperty({},event.target.name,event.target.value));};_this.handleOpen=function(){_this.setState({open:true});};_this.handleOpenSelect=function(){_this.setState({open1:true});};_this.handleCloseSelect=function(){_this.setState({open1:false});};_this.handleOpenSelectPartner=function(){_this.setState({open2:true});};_this.handleCloseSelectPartner=function(){_this.setState({open2:false});};_this.checkSimnoValidity=function(){var regex=new RegExp(// eslint-disable-next-line
/^[0-9]{10,25}$/);// console.log('a', this.state.imeino)
console.log(regex.test(_this.state.simno));_this.setState({isSimnoValid:regex.test(_this.state.simno)||_this.state.simno===''// this.state.modelname === ''
});// console.log(this.state.isModelNameValid)
};_this.checkPhonenoValidity=function(){var regex=new RegExp(/^[0-9]{9,14}$/);_this.setState({isPhonenoValid:regex.test(_this.state.phoneno)||_this.state.phoneno===''});};_this.checkSimPriceValidity=function(){var regex=new RegExp(/^[0-9]+$/);_this.setState({isSimPriceValid:regex.test(_this.state.simPrice)||_this.state.simPrice===''});if(parseInt(_this.state.simPrice,10)<1||parseInt(_this.state.simPrice,10)>500){_this.setState({isSimPriceValid:false});}};_this.checkSimProviderValidity=function(){_this.setState({isSimProviderValid:_this.state.simprovider!==''});};_this.handleSubmit=function(updateDevice){return function(e){// console.log('this.state.partnerName', this.state.partnerName)
// console.log('clients', this.state.clients)
var localPartner=null;_this.state.clients.forEach(function(el){if(el.id==_this.state.partnerName){localPartner=el.login.loginId;// console.log('elll', localPartner)
}});e.preventDefault();updateDevice({variables:{phoneNumber:_this.state.phoneno,simNumber:_this.state.simno,monthlyCharges:parseInt(_this.state.simPrice,10),service_provider_id:_this.state.simprovider,status:2,id:parseInt(_this.props.selSimId,10),ownerLoginId:parseInt(localPartner,10)// partnerLoginId: parseInt(localPartner, 10)
},refetchQueries:['getPartnerSimStockByServiceProvider']});// console.log(this.data, 'addDevice')
// this.state.simprovider = ''
_this.setState({phoneno:'',simno:'',// device_model_id: '',
simPrice:'',simprovider:'',partnerName:''});};};_this.deleteSim=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _ref2,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:event.preventDefault();_context.next=3;return _this.props.client.mutate({mutation:DELETE_SIM,variables:{phoneNumber:_this.state.phoneno,simNumber:_this.state.simno,ownerLoginId:Object(__WEBPACK_IMPORTED_MODULE_17__utils_getLoginId__["a" /* default */])()},refetchQueries:['getPartnerSimStockByServiceProvider','allSimDetails'],errorPolicy:'all'});case 3:_ref2=_context.sent;data=_ref2.data;// console.log('submit', data.deleteDeviceInStock)
if(data.deleteSim===true){_this.props.handleClose();_this.props.openSnackbar('Sim Deleted Successfully');}else{_this.props.openSnackbar('Error in deleting Sim');}case 6:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.getSimDetails=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var _ref4,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this.props.client.query({query:GET_SIM_DETAIL,variables:{simId:_this.existingSimId},fetchPolicy:'network-only'});case 2:_ref4=_context2.sent;data=_ref4.data;_this.setDetails(data.simDetail);case 5:case'end':return _context2.stop();}}},_callee2,_this2);}));_this.GetPartnerDetails=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var _ref6,clients;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return _this.props.client.query({query:GET_PARTNER,fetchPolicy:'network-only'});case 2:_ref6=_context3.sent;clients=_ref6.data;console.log('client:',clients);_this.setState({clients:clients.clients});case 6:case'end':return _context3.stop();}}},_callee3,_this2);}));_this.setDetails=function(simDetail){console.log(simDetail);_this.setState({phoneno:simDetail.phoneNumber,simno:simDetail.simNumber,simPrice:simDetail.monthlyCharges,simprovider:simDetail.serviceProvider.id,partnerName:simDetail.partnerDetails.id});};_this.classes=props;_this.existingSimId=_this.props.selSimId;return _this;}_createClass(EditSimAdmin,[{key:'componentDidMount',value:function componentDidMount(){this.getSimDetails();this.GetPartnerDetails();}},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;return(// <Query query={GET_MODELS} fetchPolicy="network-only">
//   {({ loading: isModelsLoading, error, data: { models } }) => (
__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_apollo__["Query"],{query:GET_PROVIDER,fetchPolicy:'network-only'},function(_ref7){var loading=_ref7.loading,error=_ref7.error,data=_ref7.data;var queriedData=data;if(loading)return null;if(error)return'Error!: '+error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_apollo__["Mutation"],{mutation:UPDATE_SIM},function(updateSim,_ref8){var data=_ref8.data,error=_ref8.error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{variant:'outlined',color:'secondary',className:classes.button,style:{float:'right'},onClick:_this3.deleteSim},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Tooltip___default.a,{title:'Delete SIM'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_icons_DeleteForever___default.a,{className:classes.icon}))),' '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle___default.a,{id:'form-dialog-title'},'Edit SIM Details :'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core__["Typography"],{variant:'subheading',gutterBottom:true,style:{color:'red',marginLeft:'25px'}},error&&error.graphQLErrors.map(function(_ref9,i){var message=_ref9.message;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{key:i},message);}),_this3.state.errorMessage&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,_this3.state.errorMessage)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core__["Typography"],{variant:'subheading',gutterBottom:true,style:{color:'green',marginLeft:'25px'}},data&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Sucessfully Updated')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Divider___default.a,{light:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{onSubmit:_this3.handleSubmit(updateSim)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText___default.a,null,'* Marked fields are mandatory'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel___default.a,{htmlFor:'demo-controlled-open-select'},'Select SIm Provider *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select___default.a,{open:_this3.state.open1,fullWidth:true,onClose:_this3.handleCloseSelect,onOpen:_this3.handleOpenSelect,value:_this3.state.simprovider,onChange:_this3.handleChange,onBlur:_this3.checkSimProviderValidity,inputProps:{name:'simprovider',id:'simprovider'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),queriedData.allServiceProviders.map(function(allServiceProvidersByStatus){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{value:allServiceProvidersByStatus.id,key:allServiceProvidersByStatus.id},allServiceProvidersByStatus.name);}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel___default.a,{htmlFor:'demo-controlled-open-select'},'Select Partner *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select___default.a,{open:_this3.state.open2,fullWidth:true,onClose:_this3.handleCloseSelectPartner,onOpen:_this3.handleOpenSelectPartner,value:_this3.state.partnerName,onChange:_this3.handleChange,inputProps:{name:'partnerName',id:'partnerName'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),_this3.state.clients.map(function(client){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{value:client.id,key:client.id},client.businessName);}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'phoneno',name:'phoneno',label:'Phone No',type:'text',required:true,value:_this3.state.phoneno,fullWidth:true,onChange:_this3.handleInputChange('phoneno'),error:!_this3.state.isPhonenoValid,onBlur:_this3.checkPhonenoValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this3.state.isPhonenoValid?'':'Phone Number should be between 9-15 digits')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'simno',name:'simno',label:'SIM No',type:'text',required:true,fullWidth:true,value:_this3.state.simno,onChange:_this3.handleInputChange('simno'),error:!_this3.state.isSimnoValid,onBlur:_this3.checkSimnoValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this3.state.isSimnoValid?'':'Sim Number should be between 10-25 digits')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'simPrice',name:'simPrice',label:'SIM Price per Month',type:'text',required:true,fullWidth:true,value:_this3.state.simPrice,onChange:_this3.handleInputChange('simPrice'),error:!_this3.state.isSimPriceValid,onBlur:_this3.checkSimPriceValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this3.state.isSimPriceValid?'':'Sim Price should be between 1-500'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:_this3.props.handleClose,color:'default',variant:'contained'},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a// onClick={this.handleClose}
,{type:'submit',color:'primary',variant:'contained',disabled:!(_this3.state.isSimProviderValid&&_this3.state.isSimnoValid&&_this3.state.isPhonenoValid&&_this3.state.phoneno!==''&&_this3.state.simno!==''&&_this3.state.isSimPriceValid&&_this3.state.simPrice!==''&&_this3.state.simprovider!==''&&_this3.state.partnerName!=='')},'Submit'))));});})//   )}
// </Query>
);}}]);return EditSimAdmin;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_15_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_19__HOCs_withSharedSnackbar__["a" /* default */])(EditSimAdmin))));

/***/ }),
/* 1125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__RegisterAccessory__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_file_saver__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_Loader__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_getAccountType_js__ = __webpack_require__(68);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getPartnerAccessoryStockByAccessoryType($partnerLoginId: Int!) {\n    accessory: getPartnerAccessoryStockByAccessoryType(\n      partnerLoginId: $partnerLoginId\n    ) {\n      accessoryTypeName\n      availableStock\n      totalAssignedAccessory\n    }\n  }\n'],['\n  query getPartnerAccessoryStockByAccessoryType($partnerLoginId: Int!) {\n    accessory: getPartnerAccessoryStockByAccessoryType(\n      partnerLoginId: $partnerLoginId\n    ) {\n      accessoryTypeName\n      availableStock\n      totalAssignedAccessory\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n'],['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* eslint-disable */var style=function style(theme){var _root;return{root:(_root={padding:theme.spacing.unit*4},_defineProperty(_root,theme.breakpoints.down('sm'),{padding:theme.spacing.unit*2}),_defineProperty(_root,'flexGrow',1),_root),paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},iconSmall:{fontSize:20}};};var GET_ACCESSORY_STOCK=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject);var GET_FILE_FORMAT=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject2);var InventoryDevices=function(_Component){_inherits(InventoryDevices,_Component);function InventoryDevices(props){var _this2=this;_classCallCheck(this,InventoryDevices);var _this=_possibleConstructorReturn(this,(InventoryDevices.__proto__||Object.getPrototypeOf(InventoryDevices)).call(this,props));_this.clientId=[];_this.columns=['MODEL NAME','TOTAL QUANTITY','AVAILABLE STOCK'];_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15};_this.state={open:false};_this.handleClickOpen=function(){_this.setState({open:true});};_this.handleClose=function(){_this.setState({open:false});};_this.addBulkUpload=function(e){console.log('bulk');_this.props.history.push({pathname:'/home/AccessoryInventory/RegisterBulkAccessory'});};_this.downloadBulkUpload=function(client){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _ref2,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:console.log('click fun');_context.next=3;return _this.props.client.query({query:GET_FILE_FORMAT,variables:{bucketname:'excel-templates',filename:'accessoryUpload.xlsx'},errorPolicy:'all'});case 3:_ref2=_context.sent;data=_ref2.data;console.log('file',data.getPublicDownloadURL);__WEBPACK_IMPORTED_MODULE_11_file_saver___default.a.saveAs(data.getPublicDownloadURL,'accessoryUpload.xlsx');case 7:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();};_this.classes=props;return _this;}_createClass(InventoryDevices,[{key:'mapToArr',value:function mapToArr(devices){var rowData=[];var fullData=[];// this.clientId = []
devices.forEach(function(element){rowData=[];// this.clientId.push(element.id)
rowData.push(element.accessoryTypeName);rowData.push(element.totalAssignedAccessory);rowData.push(element.availableStock);fullData.push(rowData);});return fullData;}},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["Query"],{query:GET_ACCESSORY_STOCK,variables:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_12__utils_getLoginId__["a" /* default */])()},fetchPolicy:'network-only'},function(_ref3){var loading=_ref3.loading,error=_ref3.error,accessory=_ref3.data.accessory;if(loading)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__common_Loader__["a" /* default */],null);if(error)return'Error!: '+error;var data=_this3.mapToArr(accessory);// const data = [
//   ['Fuel Probe Sensor', '121', '85'],
//   ['Panic Button', '355', '20'],
//   ['Immobilizer', '65', '50']
// ]
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog___default.a,{open:_this3.state.open,onClose:_this3.handleClose,'aria-labelledby':'form-dialog-title'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__RegisterAccessory__["a" /* default */],{handleClose:_this3.handleClose})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:16,justify:'space-between'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{variant:'headline'},'Accessories')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},Object(__WEBPACK_IMPORTED_MODULE_12__utils_getLoginId__["a" /* default */])().toString()==Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_SERVER_HTTP_URI":"https://uat-api-dtwin.taabi.ai/graphql","REACT_APP_SERVER_WS_URI":"wss://uat-api-dtwin.taabi.ai"}).REACT_APP_ZELIOT_PARTNER_LOGIN_ID&&['PA'].includes(Object(__WEBPACK_IMPORTED_MODULE_14__utils_getAccountType_js__["a" /* default */])())?null:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:8,justify:'flex-end'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12,sm:'auto'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{fullWidth:true,color:'secondary',variant:'contained',className:classes.button,onClick:_this3.handleClickOpen},'New Accessory')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12,sm:'auto'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{fullWidth:true,color:'secondary',variant:'contained',className:classes.button,onClick:_this3.addBulkUpload},'Bulk Upload')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12,sm:'auto'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{fullWidth:true,color:'secondary',variant:'contained',className:classes.button,onClick:_this3.downloadBulkUpload(_this3.props.client)},'Download Format')))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_mui_datatables___default.a,{data:data,columns:_this3.columns,options:_this3.options}))));});}}]);return InventoryDevices;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["withApollo"])(InventoryDevices)));

/***/ }),
/* 1126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormHelperText__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormHelperText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormHelperText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_getLoginId__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query {\n    accessory: getAllAccessoryTypes(status: 1) {\n      id\n      accessoryName\n      version\n    }\n  }\n'],['\n  query {\n    accessory: getAllAccessoryTypes(status: 1) {\n      id\n      accessoryName\n      version\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query {\n    manufacturers: getAllManufacturer(status: 1) {\n      id\n      manufacturerName\n      manufacturerCode\n    }\n  }\n'],['\n  query {\n    manufacturers: getAllManufacturer(status: 1) {\n      id\n      manufacturerName\n      manufacturerCode\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation addAccessoryDetailsFromPartnerAdmin(\n    $serial_num: Int!\n    $device_model_id: Int!\n    $uniqueSerialNumber: String!\n    $manufacturerId: Int!\n    $ownerLoginId: Int!\n  ) {\n    addAccessoryDetailsFromPartnerAdmin(\n      serialNumber: $serial_num\n      accessoryTypeId: $device_model_id\n      uniqueAccessoryId: $uniqueSerialNumber\n      manufacturerId: $manufacturerId\n      ownerLoginId: $ownerLoginId\n    )\n  }\n'],['\n  mutation addAccessoryDetailsFromPartnerAdmin(\n    $serial_num: Int!\n    $device_model_id: Int!\n    $uniqueSerialNumber: String!\n    $manufacturerId: Int!\n    $ownerLoginId: Int!\n  ) {\n    addAccessoryDetailsFromPartnerAdmin(\n      serialNumber: $serial_num\n      accessoryTypeId: $device_model_id\n      uniqueAccessoryId: $uniqueSerialNumber\n      manufacturerId: $manufacturerId\n      ownerLoginId: $ownerLoginId\n    )\n  }\n']);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_ACCESSORY=Object(__WEBPACK_IMPORTED_MODULE_14_graphql_tag__["a" /* default */])(_templateObject);var GET_MANUFACTURER=Object(__WEBPACK_IMPORTED_MODULE_14_graphql_tag__["a" /* default */])(_templateObject2);// calling server for updation
var ADD_ACCESSORY=Object(__WEBPACK_IMPORTED_MODULE_14_graphql_tag__["a" /* default */])(_templateObject3);var styles=function styles(theme){return{button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{width:'100%'}};};var RegisterAccessory=function(_Component){_inherits(RegisterAccessory,_Component);function RegisterAccessory(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RegisterAccessory);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RegisterAccessory.__proto__||Object.getPrototypeOf(RegisterAccessory)).call.apply(_ref,[this].concat(args))),_this),_this.state={open1:false,modelname:'',serialno:'',imeino:'',uniqueSerialNumber:'',isModelNameValid:true,isSerialnoValid:true,isImeinoValid:true,isManufacturerNameValid:true,manufacturerName:'',open_man:false,manufacturerCode:'',manufacturerId:''},_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));};},_this.handleChange=function(event){_this.setState(_defineProperty({},event.target.name,event.target.value));},_this.handleOpen=function(){_this.setState({open:true});},_this.handleOpenSelect=function(){_this.setState({open1:true});},_this.handleCloseSelect=function(){_this.setState({open1:false});},_this.handleOpenSelectMan=function(){_this.setState({open_man:true});},_this.handleCloseSelectMan=function(){_this.setState({open_man:false});},_this.checkImeinoValidity=function(){var regex=new RegExp(// eslint-disable-next-line
/^[0-9]{15}$/);// console.log('a', this.state.imeino)
// console.log(regex.test(this.state.imeino))
_this.setState({isImeinoValid:regex.test(_this.state.imeino)||_this.state.imeino===''// this.state.modelname === ''
});// console.log(this.state.isModelNameValid)
},_this.checkSerialnoValidity=function(){var regex=new RegExp(/^[0-9]{9}$/);var code=_this.state.manufacturerName.split('*');_this.setState({isSerialnoValid:regex.test(_this.state.serialno)||_this.state.serialno==='',uniqueSerialNumber:code[1]+'_'+_this.state.serialno});},_this.checkModelNameValidity=function(){_this.setState({isModelNameValid:_this.state.modelname!==''});},_this.checkManufacturerNameValidity=function(){// console.log(this.state.manufacturerName)
var code=_this.state.manufacturerName.split('*');// console.log('man', code[0])
_this.setState({isManufacturerNameValid:_this.state.manufacturerName!=='',// manufacturerCode:this
uniqueSerialNumber:code[1]+'_'+_this.state.serialno,manufacturerId:code[0]});},_this.handleSubmit=function(addDevice){return function(e){// console.log('click fun')
e.preventDefault();addDevice({variables:{serial_num:parseInt(_this.state.serialno,10),device_model_id:parseInt(_this.state.modelname,10),uniqueSerialNumber:_this.state.uniqueSerialNumber,manufacturerId:parseInt(_this.state.manufacturerId,10),ownerLoginId:Object(__WEBPACK_IMPORTED_MODULE_17__utils_getLoginId__["a" /* default */])()},refetchQueries:['getPartnerAccessoryStockByAccessoryType']});// this.state.simprovider = ''
_this.setState({serialno:'',// modelname: '',
// device_model_id: '',
uniqueSerialNumber:''// manufacturerId: ''
});};},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RegisterAccessory,[{key:'render',value:function render(){var _this2=this;var classes=this.props.classes;// console.log(
//   'MID=',
//   this.state.manufacturerId,
//   this.state.uniqueSerialNumber
// )
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_apollo__["Query"],{query:GET_ACCESSORY,fetchPolicy:'network-only'},function(_ref2){var isModelsLoading=_ref2.loading,error=_ref2.error,accessory=_ref2.data.accessory;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_apollo__["Query"],{query:GET_MANUFACTURER,fetchPolicy:'network-only'},function(_ref3){var isManufacturersLoading=_ref3.loading,error=_ref3.error,manufacturers=_ref3.data.manufacturers;if(isModelsLoading||isManufacturersLoading)return null;if(error)return'Error!: '+error;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_apollo__["Mutation"],{mutation:ADD_ACCESSORY},function(addDevice,_ref4){var data=_ref4.data,error=_ref4.error;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle___default.a,{id:'form-dialog-title'},'Add Accessory Details'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core__["Typography"],{variant:'subheading',gutterBottom:true,style:{color:'red',marginLeft:'25px'}},error&&error.graphQLErrors.map(function(_ref5,i){var message=_ref5.message;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:i},message);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core__["Typography"],{variant:'subheading',gutterBottom:true,style:{color:'green',marginLeft:'25px'}},data&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Sucessfully Added')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Divider___default.a,{light:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:_this2.handleSubmit(addDevice)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText___default.a,null,'* Marked fields are mandatory'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel___default.a,{htmlFor:'demo-controlled-open-select'},'Select Manufacturer'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select___default.a,{open:_this2.state.open_man,fullWidth:true,onClose:_this2.handleCloseSelectMan,onOpen:_this2.handleOpenSelectMan,value:_this2.state.manufacturerName,onChange:_this2.handleChange,onBlur:_this2.checkManufacturerNameValidity,inputProps:{name:'manufacturerName',id:'manufacturerName'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'None')),manufacturers.map(function(manufacturer){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{value:manufacturer.id+'*'+manufacturer.manufacturerCode,key:manufacturer.id},manufacturer.manufacturerName);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel___default.a,{htmlFor:'demo-controlled-open-select'},'Select Accessory Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select___default.a,{open:_this2.state.open1,fullWidth:true,onClose:_this2.handleCloseSelect,onOpen:_this2.handleOpenSelect,value:_this2.state.modelname,onChange:_this2.handleChange,onBlur:_this2.checkModelNameValidity,inputProps:{name:'modelname',id:'modelname'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'None')),accessory.map(function(allDeviceModelsByStatus){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{value:allDeviceModelsByStatus.id,key:allDeviceModelsByStatus.id},allDeviceModelsByStatus.accessoryName+' '+allDeviceModelsByStatus.version);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'serialno',name:'serialno',label:'Serial No',type:'text',required:true,value:_this2.state.serialno,fullWidth:true,onChange:_this2.handleInputChange('serialno'),error:!_this2.state.isSerialnoValid,onBlur:_this2.checkSerialnoValidity}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this2.state.isSerialnoValid?'':'Serial Number should be 9 digit')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'uniqueSerialNumber',name:'uniqueSerialNumber',label:'Unique Accessory Id',type:'text',disabled:true,required:true,fullWidth:true,value:_this2.state.uniqueSerialNumber,onChange:_this2.handleInputChange('uniqueSerialNumber')// error={!this.state.isImeinoValid}
// onBlur={this.checkImeinoValidity}
}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button___default.a,{onClick:_this2.props.handleClose,color:'secondary'},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button___default.a// onClick={this.handleClose}
,{type:'submit',color:'secondary',variant:'contained',disabled:!(_this2.state.isModelNameValid&&_this2.state.isSerialnoValid&&_this2.state.isImeinoValid&&_this2.state.serialno!=='')},'Submit'))));});});});}}]);return RegisterAccessory;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__["withStyles"])(styles)(RegisterAccessory));

/***/ }),
/* 1127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControlLabel__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControlLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControlLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_RadioGroup__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_RadioGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_RadioGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Radio__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_FormHelperText__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_FormHelperText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_FormHelperText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_material_ui_pickers__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_common_Loader__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__common_ConfirmationDialog__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__material_ui_icons_ArrowBack__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__material_ui_icons_ArrowBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__material_ui_icons_ArrowBack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__material_ui_core_Card__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__material_ui_core_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__material_ui_core_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__material_ui_core_CardHeader__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__material_ui_core_CardHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__material_ui_core_CardHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__material_ui_core_CardContent__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__material_ui_core_CardContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__material_ui_core_CardContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__material_ui_core_CardActions__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__material_ui_core_CardActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__material_ui_core_CardActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Modules_Countries__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__utils_conertSnakeFormat__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__utils_videoTelimatricsValues__ = __webpack_require__(1128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__material_ui_icons__ = __webpack_require__(1129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__material_ui_core_InputLabel__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query clientDetail($loginId: Int) {\n    clientDetail(loginId: $loginId) {\n      id\n      loginId\n      clientName\n      prorata\n      contactPerson\n      secondaryContactName\n      secondaryEmail\n      secondaryContactNumber\n      additionalContactNumbers\n      address\n      clientType\n      registrationType\n      shippingAddress\n      shippingCity\n      shippingPincode\n      city\n      timezone\n      minimumTrackedDays\n      packetThreshold\n      gst\n      state {\n        zone_id\n      }\n      country {\n        country_id\n      }\n      shippingState {\n        zone_id\n      }\n      shippingCountry {\n        country_id\n      }\n      email\n      contactNumber\n      login {\n        username\n      }\n      plan {\n        id\n        planName\n      }\n      pincode\n      panNumber\n      type\n      expiryDate\n      solution\n\n      billingMode {\n        id\n        billingMode\n      }\n      salesPerson {\n        id\n        name\n      }\n      zonalManager\n      stateManager\n      territoryManager\n      salesHead\n      clusterHead\n      stateHead\n      cityManager\n      operationsManager\n      keyAccountManager\n      channelPartnerName\n      litemode\n      is_sim_tracking\n      totalPotentialVehicles\n      videoTelematicsType\n      customerAcquisitionType\n      directCustomer\n      directCustomerType\n      directCustomerSAPCode\n      indirectCustomerType\n      channelPartnerType\n      indirectCustomerName\n      indirectCustomerUniqueId\n      customerLocation\n      secondaryLandlineNumber\n      channelPartnerSAPCode\n      customerNameToBeDisplayed\n      zone\n      serviceManager\n      customerSuccessManager\n      serviceType\n      # solutionId\n      isSecondaryContact\n      clientCategory\n    }\n  }\n'],['\n  query clientDetail($loginId: Int) {\n    clientDetail(loginId: $loginId) {\n      id\n      loginId\n      clientName\n      prorata\n      contactPerson\n      secondaryContactName\n      secondaryEmail\n      secondaryContactNumber\n      additionalContactNumbers\n      address\n      clientType\n      registrationType\n      shippingAddress\n      shippingCity\n      shippingPincode\n      city\n      timezone\n      minimumTrackedDays\n      packetThreshold\n      gst\n      state {\n        zone_id\n      }\n      country {\n        country_id\n      }\n      shippingState {\n        zone_id\n      }\n      shippingCountry {\n        country_id\n      }\n      email\n      contactNumber\n      login {\n        username\n      }\n      plan {\n        id\n        planName\n      }\n      pincode\n      panNumber\n      type\n      expiryDate\n      solution\n\n      billingMode {\n        id\n        billingMode\n      }\n      salesPerson {\n        id\n        name\n      }\n      zonalManager\n      stateManager\n      territoryManager\n      salesHead\n      clusterHead\n      stateHead\n      cityManager\n      operationsManager\n      keyAccountManager\n      channelPartnerName\n      litemode\n      is_sim_tracking\n      totalPotentialVehicles\n      videoTelematicsType\n      customerAcquisitionType\n      directCustomer\n      directCustomerType\n      directCustomerSAPCode\n      indirectCustomerType\n      channelPartnerType\n      indirectCustomerName\n      indirectCustomerUniqueId\n      customerLocation\n      secondaryLandlineNumber\n      channelPartnerSAPCode\n      customerNameToBeDisplayed\n      zone\n      serviceManager\n      customerSuccessManager\n      serviceType\n      # solutionId\n      isSecondaryContact\n      clientCategory\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  mutation(\n    $id: Int!\n    $clientName: String!\n    $login_id: Int!\n    $email: String!\n    $contactPerson: String!\n    $contactNumber: String!\n    $secondaryContactName: String\n    $secondaryContactNumber: String\n    $secondaryEmail: String\n    $additionalContactNumbers: String\n    $address: String!\n    $city: String!\n    $state_id: Int!\n    $country_id: Int!\n    $pincode: Int\n    $panNumber: String\n    $clientType: String!\n    $status: Int!\n    $partnerLoginId: Int\n    $registrationType: String\n    $timezone: String!\n    $gst: String\n    $plan: Int\n    $username: String!\n    $shippingAddress: String\n    $shippingCountry: Int\n    $shippingState: Int\n    $shippingCity: String\n    $shippingPincode: Int\n    $expiryDate: String\n    $solution: String!\n    $billingMode: Int!\n    $salesPersonId: Int\n    $prorata: Int!\n    $minimumTrackedDays: Int!\n    $packetThreshold: Int\n    $zonalManager: String!\n    $keyAccountManager: String!\n    $channelPartnerName: String\n    $litemode: String!\n    $is_sim_tracking: Boolean\n    $totalPotentialVehicles: Int!\n    $videoTelematicsType: String\n    $typeOfClient: ClientPartnerType\n    $customerAcquisitionType: String!\n    $directCustomer: String\n    $directCustomerType: String\n    $directCustomerSAPCode: String\n    $indirectCustomerType: String\n    $channelPartnerType: String\n    $indirectCustomerName: String\n    $indirectCustomerUniqueId: String\n    $customerLocation: String!\n    $zone: String!\n    $secondaryLandlineNumber: String\n    $serviceManager: String!\n    $customerSuccessManager: String!\n    $channelPartnerSAPCode: String\n    $customerNameToBeDisplayed: String!\n    $serviceType: String!\n    $isSecondaryContact: Boolean\n    $clientCategory: String!\n    $stateManager: String!\n    $territoryManager: String\n    $salesHead: String\n    $clusterHead: String\n    $stateHead: String\n    $cityManager: String\n    $operationsManager: String\n  ) {\n    updateClientDetail(\n      id: $id\n      clientName: $clientName\n      login_id: $login_id\n      email: $email\n      contactPerson: $contactPerson\n      contactNumber: $contactNumber\n      secondaryContactName: $secondaryContactName\n      secondaryContactNumber: $secondaryContactNumber\n      secondaryEmail: $secondaryEmail\n      additionalContactNumbers: $additionalContactNumbers\n      address: $address\n      city: $city\n      state_id: $state_id\n      country_id: $country_id\n      pincode: $pincode\n      panNumber: $panNumber\n      clientType: $clientType\n      status: $status\n      partnerLoginId: $partnerLoginId\n      timezone: $timezone\n      gst: $gst\n      plan_id: $plan\n      loginUsername: $username\n      typeOfClient: $typeOfClient\n      shippingAddress: $shippingAddress\n      shippingCountry: $shippingCountry\n      shippingState: $shippingState\n      registrationType: $registrationType\n      shippingCity: $shippingCity\n      shippingPincode: $shippingPincode\n      expiryDate: $expiryDate\n      solution: $solution\n      billingMode: $billingMode\n      salesPersonId: $salesPersonId\n      minimumTrackedDays: $minimumTrackedDays\n      packetThreshold: $packetThreshold\n      prorata: $prorata\n      zonalManager: $zonalManager\n      keyAccountManager: $keyAccountManager\n      channelPartnerName: $channelPartnerName\n      litemode: $litemode\n      is_sim_tracking: $is_sim_tracking\n      totalPotentialVehicles: $totalPotentialVehicles\n      videoTelematicsType: $videoTelematicsType\n      customerAcquisitionType: $customerAcquisitionType\n      directCustomer: $directCustomer\n      directCustomerType: $directCustomerType\n      directCustomerSAPCode: $directCustomerSAPCode\n      indirectCustomerType: $indirectCustomerType\n      channelPartnerType: $channelPartnerType\n      indirectCustomerName: $indirectCustomerName\n      indirectCustomerUniqueId: $indirectCustomerUniqueId\n      customerLocation: $customerLocation\n      secondaryLandlineNumber: $secondaryLandlineNumber\n      channelPartnerSAPCode: $channelPartnerSAPCode\n      customerNameToBeDisplayed: $customerNameToBeDisplayed\n      zone: $zone\n      serviceManager: $serviceManager\n      customerSuccessManager: $customerSuccessManager\n      serviceType: $serviceType\n      isSecondaryContact: $isSecondaryContact\n      clientCategory: $clientCategory\n      stateManager: $stateManager\n      territoryManager: $territoryManager\n      salesHead: $salesHead\n      clusterHead: $clusterHead\n      stateHead: $stateHead\n      cityManager: $cityManager\n      operationsManager: $operationsManager\n    )\n  }\n'],['\n  mutation(\n    $id: Int!\n    $clientName: String!\n    $login_id: Int!\n    $email: String!\n    $contactPerson: String!\n    $contactNumber: String!\n    $secondaryContactName: String\n    $secondaryContactNumber: String\n    $secondaryEmail: String\n    $additionalContactNumbers: String\n    $address: String!\n    $city: String!\n    $state_id: Int!\n    $country_id: Int!\n    $pincode: Int\n    $panNumber: String\n    $clientType: String!\n    $status: Int!\n    $partnerLoginId: Int\n    $registrationType: String\n    $timezone: String!\n    $gst: String\n    $plan: Int\n    $username: String!\n    $shippingAddress: String\n    $shippingCountry: Int\n    $shippingState: Int\n    $shippingCity: String\n    $shippingPincode: Int\n    $expiryDate: String\n    $solution: String!\n    $billingMode: Int!\n    $salesPersonId: Int\n    $prorata: Int!\n    $minimumTrackedDays: Int!\n    $packetThreshold: Int\n    $zonalManager: String!\n    $keyAccountManager: String!\n    $channelPartnerName: String\n    $litemode: String!\n    $is_sim_tracking: Boolean\n    $totalPotentialVehicles: Int!\n    $videoTelematicsType: String\n    $typeOfClient: ClientPartnerType\n    $customerAcquisitionType: String!\n    $directCustomer: String\n    $directCustomerType: String\n    $directCustomerSAPCode: String\n    $indirectCustomerType: String\n    $channelPartnerType: String\n    $indirectCustomerName: String\n    $indirectCustomerUniqueId: String\n    $customerLocation: String!\n    $zone: String!\n    $secondaryLandlineNumber: String\n    $serviceManager: String!\n    $customerSuccessManager: String!\n    $channelPartnerSAPCode: String\n    $customerNameToBeDisplayed: String!\n    $serviceType: String!\n    $isSecondaryContact: Boolean\n    $clientCategory: String!\n    $stateManager: String!\n    $territoryManager: String\n    $salesHead: String\n    $clusterHead: String\n    $stateHead: String\n    $cityManager: String\n    $operationsManager: String\n  ) {\n    updateClientDetail(\n      id: $id\n      clientName: $clientName\n      login_id: $login_id\n      email: $email\n      contactPerson: $contactPerson\n      contactNumber: $contactNumber\n      secondaryContactName: $secondaryContactName\n      secondaryContactNumber: $secondaryContactNumber\n      secondaryEmail: $secondaryEmail\n      additionalContactNumbers: $additionalContactNumbers\n      address: $address\n      city: $city\n      state_id: $state_id\n      country_id: $country_id\n      pincode: $pincode\n      panNumber: $panNumber\n      clientType: $clientType\n      status: $status\n      partnerLoginId: $partnerLoginId\n      timezone: $timezone\n      gst: $gst\n      plan_id: $plan\n      loginUsername: $username\n      typeOfClient: $typeOfClient\n      shippingAddress: $shippingAddress\n      shippingCountry: $shippingCountry\n      shippingState: $shippingState\n      registrationType: $registrationType\n      shippingCity: $shippingCity\n      shippingPincode: $shippingPincode\n      expiryDate: $expiryDate\n      solution: $solution\n      billingMode: $billingMode\n      salesPersonId: $salesPersonId\n      minimumTrackedDays: $minimumTrackedDays\n      packetThreshold: $packetThreshold\n      prorata: $prorata\n      zonalManager: $zonalManager\n      keyAccountManager: $keyAccountManager\n      channelPartnerName: $channelPartnerName\n      litemode: $litemode\n      is_sim_tracking: $is_sim_tracking\n      totalPotentialVehicles: $totalPotentialVehicles\n      videoTelematicsType: $videoTelematicsType\n      customerAcquisitionType: $customerAcquisitionType\n      directCustomer: $directCustomer\n      directCustomerType: $directCustomerType\n      directCustomerSAPCode: $directCustomerSAPCode\n      indirectCustomerType: $indirectCustomerType\n      channelPartnerType: $channelPartnerType\n      indirectCustomerName: $indirectCustomerName\n      indirectCustomerUniqueId: $indirectCustomerUniqueId\n      customerLocation: $customerLocation\n      secondaryLandlineNumber: $secondaryLandlineNumber\n      channelPartnerSAPCode: $channelPartnerSAPCode\n      customerNameToBeDisplayed: $customerNameToBeDisplayed\n      zone: $zone\n      serviceManager: $serviceManager\n      customerSuccessManager: $customerSuccessManager\n      serviceType: $serviceType\n      isSecondaryContact: $isSecondaryContact\n      clientCategory: $clientCategory\n      stateManager: $stateManager\n      territoryManager: $territoryManager\n      salesHead: $salesHead\n      clusterHead: $clusterHead\n      stateHead: $stateHead\n      cityManager: $cityManager\n      operationsManager: $operationsManager\n    )\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query getAllPlans($partnerLoginId: Int!) {\n    allPlans: getAllPlans(partnerLoginId: $partnerLoginId) {\n      id\n      planName\n    }\n  }\n'],['\n  query getAllPlans($partnerLoginId: Int!) {\n    allPlans: getAllPlans(partnerLoginId: $partnerLoginId) {\n      id\n      planName\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query GetAllMasterSolutionType {\n    getAllMasterSolutionType {\n      id\n      solutionTypeName\n    }\n  }\n'],['\n  query GetAllMasterSolutionType {\n    getAllMasterSolutionType {\n      id\n      solutionTypeName\n    }\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  query checkClientName($businessname: String!, $id: Int) {\n    checkClientName(clientName: $businessname, id: $id)\n  }\n'],['\n  query checkClientName($businessname: String!, $id: Int) {\n    checkClientName(clientName: $businessname, id: $id)\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  query checkClientContactNumber($phoneno: String!, $id: Int) {\n    checkClientContactNumber(contactNumber: $phoneno, id: $id)\n  }\n'],['\n  query checkClientContactNumber($phoneno: String!, $id: Int) {\n    checkClientContactNumber(contactNumber: $phoneno, id: $id)\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  query checkClientEmail($email: String!, $id: Int) {\n    checkClientEmail(email: $email, id: $id)\n  }\n'],['\n  query checkClientEmail($email: String!, $id: Int) {\n    checkClientEmail(email: $email, id: $id)\n  }\n']),_templateObject8=_taggedTemplateLiteral(['\n  query checkClientPanNumber($pan: String!, $id: Int) {\n    checkClientPanNumber(panNumber: $pan, id: $id)\n  }\n'],['\n  query checkClientPanNumber($pan: String!, $id: Int) {\n    checkClientPanNumber(panNumber: $pan, id: $id)\n  }\n']),_templateObject9=_taggedTemplateLiteral(['\n  query checkClientGST($gst: String!) {\n    checkClientGST(GST: $gst)\n  }\n'],['\n  query checkClientGST($gst: String!) {\n    checkClientGST(GST: $gst)\n  }\n']),_templateObject10=_taggedTemplateLiteral(['\n  query checkUsername($username: String!, $id: Int) {\n    checkUsername(username: $username, loginId: $id)\n  }\n'],['\n  query checkUsername($username: String!, $id: Int) {\n    checkUsername(username: $username, loginId: $id)\n  }\n']),_templateObject11=_taggedTemplateLiteral(['\n  query getAllSalesPerson($partnerLoginId: Int) {\n    getAllSalesPerson(partnerLoginId: $partnerLoginId) {\n      id\n      name\n    }\n  }\n'],['\n  query getAllSalesPerson($partnerLoginId: Int) {\n    getAllSalesPerson(partnerLoginId: $partnerLoginId) {\n      id\n      name\n    }\n  }\n']),_templateObject12=_taggedTemplateLiteral(['\n  query {\n    allCountries {\n      country_id\n      name\n    }\n  }\n'],['\n  query {\n    allCountries {\n      country_id\n      name\n    }\n  }\n']),_templateObject13=_taggedTemplateLiteral(['\n  query getStatesByCountryId($countryId: Int!) {\n    allStatesByCountryId(country_id: $countryId) {\n      name\n      zone_id\n    }\n  }\n'],['\n  query getStatesByCountryId($countryId: Int!) {\n    allStatesByCountryId(country_id: $countryId) {\n      name\n      zone_id\n    }\n  }\n']),_templateObject14=_taggedTemplateLiteral(['\n  query GetStateDetailsByPincode($pincode: String) {\n    getStateDetailsByPincode(pincode: $pincode) {\n      pincode\n      taluk\n      districtname\n      statename\n    }\n  }\n'],['\n  query GetStateDetailsByPincode($pincode: String) {\n    getStateDetailsByPincode(pincode: $pincode) {\n      pincode\n      taluk\n      districtname\n      statename\n    }\n  }\n']),_templateObject15=_taggedTemplateLiteral(['\n  query getGstDetails($gstNumber: String!) {\n    getGstDetails(gstNumber: $gstNumber) {\n      status\n      panNumber\n      companyName\n      address\n      pinCode\n    }\n  }\n'],['\n  query getGstDetails($gstNumber: String!) {\n    getGstDetails(gstNumber: $gstNumber) {\n      status\n      panNumber\n      companyName\n      address\n      pinCode\n    }\n  }\n']),_templateObject16=_taggedTemplateLiteral(['\n  query GetSapDetails($directCustomerSapCode: String) {\n    getSapDetails(directCustomerSAPCode: $directCustomerSapCode) {\n      customer_name\n      pan_number\n      email_address\n      gstin_number\n      payment_term\n      posting_blk\n      city\n      street5\n      customer_no\n      cust_group3\n      cust_group4\n      distribution_channel\n      street_house_number\n      street2\n      district\n      street3\n      town\n      street4\n      shipping_plant1\n      shipping_plant2\n      customer_group1\n      postal_code\n      region_descr\n      lst_number\n      tax_code\n      bank_key\n      tax_description\n      sales_office\n      sales_group\n      sales_dist\n      sales_dist_desc\n      phone_number1\n      phone_number2\n      customer_group\n      dealer_type\n      appointment_date\n      reappointment_date\n      conversion_date\n      credit_ctrl_area\n      itr_compliance\n      risk_category\n      pan_aadhar_link\n      recovery_status\n      club_type\n      club_type_desc\n      region_code\n      order_blk\n      billing_blk\n      delivery_blk\n      payment_blk\n      attribute1\n      attribute2\n      route_plan\n      route_plan_desc\n      tcs_jtc1\n      sales_organization\n      reconciliation_account\n      attribute4\n      owner_name\n      owner_address\n      parent_customer\n      parent_customer_name\n      customer_plant\n      valid_resale_certificate\n      certificate_type\n      certificate_number\n      certificate_valid_from\n      certificate_valid_to\n      vat_registration_number\n    }\n  }\n'],['\n  query GetSapDetails($directCustomerSapCode: String) {\n    getSapDetails(directCustomerSAPCode: $directCustomerSapCode) {\n      customer_name\n      pan_number\n      email_address\n      gstin_number\n      payment_term\n      posting_blk\n      city\n      street5\n      customer_no\n      cust_group3\n      cust_group4\n      distribution_channel\n      street_house_number\n      street2\n      district\n      street3\n      town\n      street4\n      shipping_plant1\n      shipping_plant2\n      customer_group1\n      postal_code\n      region_descr\n      lst_number\n      tax_code\n      bank_key\n      tax_description\n      sales_office\n      sales_group\n      sales_dist\n      sales_dist_desc\n      phone_number1\n      phone_number2\n      customer_group\n      dealer_type\n      appointment_date\n      reappointment_date\n      conversion_date\n      credit_ctrl_area\n      itr_compliance\n      risk_category\n      pan_aadhar_link\n      recovery_status\n      club_type\n      club_type_desc\n      region_code\n      order_blk\n      billing_blk\n      delivery_blk\n      payment_blk\n      attribute1\n      attribute2\n      route_plan\n      route_plan_desc\n      tcs_jtc1\n      sales_organization\n      reconciliation_account\n      attribute4\n      owner_name\n      owner_address\n      parent_customer\n      parent_customer_name\n      customer_plant\n      valid_resale_certificate\n      certificate_type\n      certificate_number\n      certificate_valid_from\n      certificate_valid_to\n      vat_registration_number\n    }\n  }\n']),_templateObject17=_taggedTemplateLiteral(['\n  query getChannelPartnerDetails($id: ID) {\n    getChannelPartnerDetails(id: $id) {\n      id\n      channel_partner_name\n      channel_partner_type\n      channel_partner_sap_code\n    }\n  }\n'],['\n  query getChannelPartnerDetails($id: ID) {\n    getChannelPartnerDetails(id: $id) {\n      id\n      channel_partner_name\n      channel_partner_type\n      channel_partner_sap_code\n    }\n  }\n']),_templateObject18=_taggedTemplateLiteral(['\n  query GetAdminUserDetailsByRole($roleName: [String]) {\n    getAdminUserDetailsByRole(roleName: $roleName) {\n      id\n      role\n      username\n    }\n  }\n'],['\n  query GetAdminUserDetailsByRole($roleName: [String]) {\n    getAdminUserDetailsByRole(roleName: $roleName) {\n      id\n      role\n      username\n    }\n  }\n']),_templateObject19=_taggedTemplateLiteral(['\n  query Query {\n    getDropDownDetail\n  }\n'],['\n  query Query {\n    getDropDownDetail\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var styles=function styles(theme){var _root;return{root:(_root={padding:theme.spacing.unit*4},_defineProperty(_root,theme.breakpoints.down('sm'),{padding:theme.spacing.unit*2}),_defineProperty(_root,'flexGrow',1),_root),italicizedText:{fontStyle:'italic'}};};var GET_CLIENT=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject);var UPDATE_CLIENT=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject2);var GET_ALL_PLANS=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject3);var GET_ALL_SOLUTION_TYPE_MASTER=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject4);// Business name validation
var GET_CLIENT_NAME=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject5);// Business name validation
var GET_CONTACTNO=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject6);// Business email validation
var GET_EMAIL=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject7);// Business pan validation
var GET_PAN_NUMBER=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject8);// Checking GST Number exist in DB or not
var GET_GST_NUMBER=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject9);// username validation
var GET_USERNAME=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject10);var GET_ALL_SALESPERSON=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject11);var GET_COUNTRIES=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject12);var GET_STATES_FOR_COUNTRY=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject13);var GET_STATE_DETAILS_BY_PINCODE=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject14);var GET_GST_INFO=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject15);var GET_SAP_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject16);var GET_CHANNEL_PARTNER_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject17);var GET_ZM_KAM_SM_CSM_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject18);var GET_DROPDOWN_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject19);var roleNames=['Key Account Manager(KAM)','Service Manager','State Manager(SM)','Sales Head','Cluster Head','State Head','City Manager','Territory Manager','Operations Manager','Customer Success Manager','Zonal Manager(ZM)'];var ZONE_OPTIONS=[{value:'North',label:'North'},{value:'South',label:'South'},{value:'Central/East',label:'Central/East'},{value:'West',label:'West'}];var SOLUTION_TYPES=[{value:'API',label:'API'},{value:'PORTAL',label:'PORTAL'}];var TYPE_OF_CLIENT=[{value:'REAL',label:'COMMERCIAL'},{value:'DEMO',label:'NON-COMMERCIAL'}];var CUSTOMER_TYPES=[{value:'Paid',label:'Paid'},{value:'POC',label:'POC'},{value:'R&D',label:'R&D'},{value:'Demo',label:'Demo'},{value:'Closed',label:'Closed'}];var BILLING_MODES=[{value:1,label:'PREPAID'},{value:2,label:'POSTPAID'}];var CUSTOMER_LOCATIONS=[{value:'India',label:'India'},{value:'International',label:'International'}];var CUSTOMER_ACQUISITION_TYPES=[{value:'Direct Customer',label:'Direct Customer'},{value:'Indirect Customer',label:'Indirect Customer'}];var CHANNEL_PARTNER_OPTIONS=[];var DIRECT_CUSTOMER_TYPE_OPTIONS=[{value:'Fleet',label:'Fleet'},{value:'Mining Customer',label:'Mining Customer'},{value:'Construction Customer',label:'Construction Customer'},{value:'Enterprise Customer',label:'Enterprise Customer'}];var INDIRECT_CUSTOMER_TYPE_OPTIONS=[{value:'System Integrator',label:'System Integrator'},{value:'Telematics Dealer',label:'Telematics Dealer'},{value:'Non Tyre Dealer',label:'Non Tyre Dealer'},{value:'CEAT Tyre Dealer',label:'CEAT Tyre Dealer'},{value:'Non CEAT Tyre Dealer',label:'Non CEAT Tyre Dealer'},{value:'Agent',label:'Agent'}];var PORTAL_MODES=[{label:'Taabi Pro',value:'taabi_pro'},{label:'Taabi GPS Lite',value:'taabi_gps_lite'}];var VIDEO_TELEMATICS_TYPE=[{label:'LightMetrics',value:'lightMetrics'},{label:'LocoNav',value:'loconav'},{label:'MettaX',value:'mettax'}];var EditCustomer=function(_Component){_inherits(EditCustomer,_Component);function EditCustomer(props){var _this2=this;_classCallCheck(this,EditCustomer);var _this=_possibleConstructorReturn(this,(EditCustomer.__proto__||Object.getPrototypeOf(EditCustomer)).call(this,props));_this.handlePincodeChange=function(event){var enteredPincode=event.target.value;var isValid=void 0;if(_this.state.country===99){isValid=/^\d{6}$/.test(enteredPincode);}else{isValid=true;}_this.setState({pincode:enteredPincode,pincodeError:!isValid});if(isValid){_this.getStateAndCityByPin(enteredPincode);}};_this.getStateAndCityByPin=function(enteredPincode){_this.props.client.query({query:GET_STATE_DETAILS_BY_PINCODE,variables:{pincode:enteredPincode}}).then(function(response){var data=response.data;if(data&&data.getStateDetailsByPincode){var stateData=data.getStateDetailsByPincode;var stateName=stateData.statename;var cityName=stateData.districtname;// this.setState({
//   state: stateData.statename,
//   city: stateData.districtname,
// });
_this.props.client.query({query:GET_STATES_FOR_COUNTRY,variables:{countryId:Number(_this.state.country)||99}}).then(function(stateResponse){var states=stateResponse.data.allStatesByCountryId;var selectedState=states.find(function(state){return state.name.toLowerCase()===stateName.toLowerCase();});if(selectedState){_this.setState({state:selectedState.zone_id,city:cityName// stateId: selectedState.zone_id,
});}else{console.error('State not found in the country list');}}).catch(function(err){console.error('Error fetching states by country:',err);});}}).catch(function(error){console.error('Error fetching state and city:',error);});};_this.getClients=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _ref2,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.client.query({query:GET_CLIENT,variables:{loginId:parseInt(_this.loginId,10)},fetchPolicy:'network-only'});case 2:_ref2=_context.sent;data=_ref2.data;// console.log('clientDetails', data.clientDetail)
// console.log(data.address)
_this.setDetails(data.clientDetail);case 5:case'end':return _context.stop();}}},_callee,_this2);}));_this.setZmKamSmCsmValues=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var _ref4,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this.props.client.query({query:GET_CLIENT,variables:{loginId:parseInt(_this.loginId,10)},fetchPolicy:'network-only'});case 2:_ref4=_context2.sent;data=_ref4.data;_this.setState({selectedSM:_this.state.stateManagers.find(function(sm){return sm.id===data.clientDetail.stateManager;})?_this.state.stateManagers.find(function(sm){return sm.id===data.clientDetail.stateManager;}).id:null,selectedZM:_this.state.zonalManagers.find(function(zm){return zm.id===data.clientDetail.zonalManager;})?_this.state.zonalManagers.find(function(zm){return zm.id===data.clientDetail.zonalManager;}).id:null,selectedStateManager:_this.state.stateManagers.find(function(sm){return sm.id===data.clientDetail.stateManager;})?_this.state.stateManagers.find(function(sm){return sm.id===data.clientDetail.stateManager;}).id:null,selectedKAM:_this.state.keyAccountManagers.find(function(kam){return kam.id===data.clientDetail.keyAccountManager;})?_this.state.keyAccountManagers.find(function(kam){return kam.id===data.clientDetail.keyAccountManager;}).id:null,serviceManager:_this.state.serviceManagers.find(function(sm){return sm.id===data.clientDetail.serviceManager;})?_this.state.serviceManagers.find(function(sm){return sm.id===data.clientDetail.serviceManager;}).id:null,customerSuccessManager:_this.state.customerSuccessManagers.find(function(csm){return csm.id===data.clientDetail.customerSuccessManager;})?_this.state.customerSuccessManagers.find(function(csm){return csm.id===data.clientDetail.customerSuccessManager;}).id:null});case 5:case'end':return _context2.stop();}}},_callee2,_this2);}));_this.getChannelPartnerDetailsNew=function(){_this.props.client.query({query:GET_CHANNEL_PARTNER_DETAILS}).then(function(response){var data=response.data;if(data&&data.getChannelPartnerDetails){console.log('getChannelPartnerDetailsNew fetched:',data.getChannelPartnerDetails);_this.setState({channelPartnerSAPCodeNew:data.getChannelPartnerDetails});}}).catch(function(error){console.error('Error fetching plans:',error);});};_this.handleDateTimeChange=function(date){return _this.setState({expiryDateTime:date,isStateChanged:true});};_this.getZmKamSmCsmDetails=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_this.props.client.query({query:GET_ZM_KAM_SM_CSM_DETAILS,variables:{roleName:roleNames},fetchPolicy:'network-only'}).then(function(response){var zonalManagers=response.data.getAdminUserDetailsByRole.filter(function(user){return user.role==='Zonal Manager(ZM)';});var keyAccountManagers=response.data.getAdminUserDetailsByRole.filter(function(user){return user.role==='Key Account Manager(KAM)';});var serviceManagers=response.data.getAdminUserDetailsByRole.filter(function(user){return user.role==='Service Manager';});var customerSuccessManagers=response.data.getAdminUserDetailsByRole.filter(function(user){return user.role==='Customer Success Manager';});var stateManagers=response.data.getAdminUserDetailsByRole.filter(function(user){return user.role==='State Manager(SM)';});var territoryManagers=response.data.getAdminUserDetailsByRole.filter(function(user){return user.role==='Territory Manager';});var salesHeads=response.data.getAdminUserDetailsByRole.filter(function(user){return user.role==='Sales Head';});var clusterHeads=response.data.getAdminUserDetailsByRole.filter(function(user){return user.role==='Cluster Head';});var stateHeads=response.data.getAdminUserDetailsByRole.filter(function(user){return user.role==='State Head';});var cityManagers=response.data.getAdminUserDetailsByRole.filter(function(user){return user.role==='City Manager';});var operationsManagers=response.data.getAdminUserDetailsByRole.filter(function(user){return user.role==='Operations Manager';});_this.setState({zonalManagers:zonalManagers,stateManagers:stateManagers,territoryManagers:territoryManagers,salesHeads:salesHeads,clusterHeads:clusterHeads,stateHeads:stateHeads,cityManagers:cityManagers,operationsManagers:operationsManagers,keyAccountManagers:keyAccountManagers,serviceManagers:serviceManagers,customerSuccessManagers:customerSuccessManagers});}).catch(function(error){console.error('Error fetching ZM/KAM/SM/CSM details:',error);});case 1:case'end':return _context3.stop();}}},_callee3,_this2);}));_this.handleInputChangeIndirectCustomerName=function(key){return function(e){var _this$setState;var _e$target=e.target,name=_e$target.name,value=_e$target.value;_this.setState((_this$setState={},_defineProperty(_this$setState,name,value),_defineProperty(_this$setState,'customerNameToBeDisplayed',value),_this$setState));};};_this.handleProrata=function(e){var _this$setState2;_this.setState((_this$setState2={},_defineProperty(_this$setState2,e.target.name,e.target.value),_defineProperty(_this$setState2,'isStateChanged',true),_this$setState2));};_this.setProrata=function(e){_this.setState({minimumTrackedDays:1,packetThreshold:1});};_this.handleCheckboxChange=function(e){_this.state.prorata?_this.setState({prorata:0}):_this.setState({prorata:1});};_this.handleSecondaryContactAvailable=function(e){_this.state.isSecondaryContact?_this.setState({isSecondaryContact:false}):_this.setState({isSecondaryContact:true});};_this.handleAdditionalContactAvailable=function(e){_this.state.isAdditionalContact?_this.setState({isAdditionalContact:false,additionalContactNumbers:'',isAdditionalContactValid:true,additionalContactError:''}):_this.setState({isAdditionalContact:true});};_this.handleAdditionalContactChange=function(e){var value=e.target.value;_this.setState({additionalContactNumbers:value,isAdditionalContactValid:true,additionalContactError:''});};_this.checkAdditionalContactValidity=function(){var _this$state=_this.state,additionalContactNumbers=_this$state.additionalContactNumbers,contactNumber=_this$state.contactNumber,secondaryContactNumber=_this$state.secondaryContactNumber;if(!additionalContactNumbers.trim()){_this.setState({isAdditionalContactValid:false,additionalContactError:'Additional contact numbers are required'});return;}var numbers=additionalContactNumbers.split(',').map(function(num){return num.trim();});var regex=/^(\+91[-\s]?)?[0]?(91)?[1-9]\d{8,19}$/;// Check for invalid format
var invalidNumbers=numbers.filter(function(num){return!regex.test(num);});if(invalidNumbers.length>0){_this.setState({isAdditionalContactValid:false,additionalContactError:'Invalid phone number(s): '+invalidNumbers.join(', ')});return;}// Check for duplicates with primary or secondary numbers
var primaryNumber=contactNumber?contactNumber.replace(/[^0-9]/g,''):'';var secondaryNumber=secondaryContactNumber?secondaryContactNumber.replace(/[^0-9]/g,''):'';var duplicateNumbers=numbers.filter(function(num){var cleanNum=num.replace(/[^0-9]/g,'');return primaryNumber&&cleanNum===primaryNumber||secondaryNumber&&cleanNum===secondaryNumber;});if(duplicateNumbers.length>0){_this.setState({isAdditionalContactValid:false,additionalContactError:'Cannot use primary/secondary number: '+duplicateNumbers.join(', ')});}else{_this.setState({isAdditionalContactValid:true,additionalContactError:''});}};_this.handleToggle=function(){_this.setState(function(prevState){return{showFields:!prevState.showFields};});};_this.handleModeChange=function(selectedOption){_this.setState({selectedMode:selectedOption});};_this.handleVideoTelematicsMenuChange=function(selectedOption){_this.setState({selectedVTM:selectedOption?selectedOption.value:''});};_this.handleZMChange=function(selectedOption){if(!selectedOption||!selectedOption.value){_this.setState({selectedZM:null});}else{if(!_this.state.zonalManagers.some(function(zm){return zm.id===selectedOption.value;})){_this.setState({selectedZM:null});}else{_this.setState({selectedZM:selectedOption.value});}}};_this.handleStateManagerChange=function(selectedOption){if(!selectedOption||!selectedOption.value){_this.setState({selectedStateManager:null});}else{if(!_this.state.stateManagers.some(function(sm){return sm.id===selectedOption.value;})){_this.setState({selectedStateManager:null});}else{_this.setState({selectedStateManager:selectedOption.value});}}};_this.handleTerritoryManagerChange=function(selectedOption){if(!selectedOption||!selectedOption.value){_this.setState({selectedTerritoryManager:null});}else{if(!_this.state.territoryManagers.some(function(tm){return tm.id===selectedOption.value;})){console.warn('Selected territory manager not found in territory manager list');}else{_this.setState({selectedTerritoryManager:selectedOption.value});}}};_this.handleSalesHeadChange=function(selectedOption){if(!selectedOption||!selectedOption.value){_this.setState({selectedSalesHead:null});}else{if(!_this.state.salesHeads.some(function(sh){return sh.id===selectedOption.value;})){console.warn('Selected sales head not found in sales head list');}else{_this.setState({selectedSalesHead:selectedOption.value});}}};_this.handleClusterHeadChange=function(selectedOption){if(!selectedOption||!selectedOption.value){_this.setState({selectedClusterHead:null});}else{if(!_this.state.clusterHeads.some(function(ch){return ch.id===selectedOption.value;})){console.warn('Selected cluster head not found in cluster head list');}else{_this.setState({selectedClusterHead:selectedOption.value});}}};_this.handleStateHeadChange=function(selectedOption){if(!selectedOption||!selectedOption.value){_this.setState({selectedStateHead:null});}else{if(!_this.state.stateHeads.some(function(sh){return sh.id===selectedOption.value;})){console.warn('Selected state head not found in state head list');}else{_this.setState({selectedStateHead:selectedOption.value});}}};_this.handleCityManagerChange=function(selectedOption){if(!selectedOption||!selectedOption.value){_this.setState({selectedCityManager:null});}else{if(!_this.state.cityManagers.some(function(cm){return cm.id===selectedOption.value;})){console.warn('Selected city manager not found in city manager list');}else{_this.setState({selectedCityManager:selectedOption.value});}}};_this.handleOperationsManagerChange=function(selectedOption){if(!selectedOption||!selectedOption.value){_this.setState({selectedOperationsManager:null});}else{if(!_this.state.operationsManagers.some(function(om){return om.id===selectedOption.value;})){console.warn('Selected operations manager not found in operations manager list');}else{_this.setState({selectedOperationsManager:selectedOption.value});}}};_this.handleKAMChange=function(selectedOption){if(!selectedOption||!selectedOption.value){_this.setState({selectedKAM:null});}else{if(!_this.state.keyAccountManagers.some(function(kam){return kam.id===selectedOption.value;})){_this.setState({selectedKAM:null});}else{_this.setState({selectedKAM:selectedOption.value});}}};_this.handleSMChange=function(selectedOption){if(!selectedOption||!selectedOption.value){_this.setState({serviceManager:null});}else{if(!_this.state.serviceManagers.some(function(sm){return sm.id===selectedOption.value;})){_this.setState({serviceManager:null});}else{_this.setState({serviceManager:selectedOption.value});}}};_this.handleCSMChange=function(selectedOption){if(!selectedOption||!selectedOption.value){_this.setState({customerSuccessManager:null});}else{if(!_this.state.customerSuccessManagers.some(function(csm){return csm.id===selectedOption.value;})){_this.setState({customerSuccessManager:null});}else{_this.setState({customerSuccessManager:selectedOption.value});}}};_this.handleServiceTypeChange=function(selectedOption){_this.setState({selectedServiceType:selectedOption?selectedOption.value:''});};_this.handleChannelPartnerNameChange=function(event){_this.setState({channelPartnerName:event.target.value});};_this.functionTakeAndGiveModeValue=function(input){var value=input&&input.value?input.value:input;if(value=='taabi_pro'||value=='Taabi Pro'){return'Taabi Pro';}else if(value=='Taabi GPS Lite'||value=='taabi_gps_lite'){return'Taabi GPS Lite';}else{return'Taabi GPS Lite';}};_this.functionTakeAndGiveVideoTeleValueInCaps=function(input){var value=input&&input.value?input.value:input;console.log('Input Value:',value);switch(value){case'loconav':case'API-Loconav':return'API-Loconav';case'mettax':case'API-Meta':return'API-Meta';case'lightMetrics':case'iFrame-LM':return'iFrame-LM';default:return null;// Return null for unmatched cases.
}};_this.setDetails=function(clientDetail){console.log('clientDetail : ',clientDetail);if(clientDetail.channelPartnerName){_this.state.showFields=true;}var simTracking=false;if(clientDetail.is_sim_tracking){simTracking=clientDetail.is_sim_tracking;}_this.setState({clientId:clientDetail.id,companyName:clientDetail.clientName.toUpperCase(),username:clientDetail.login.username,existingUsername:clientDetail.login.username,contactPerson:clientDetail.contactPerson,secondaryContactName:clientDetail.secondaryContactName,secondaryContactNumber:clientDetail.secondaryContactNumber,secondaryEmail:clientDetail.secondaryEmail,isAdditionalContact:!!clientDetail.additionalContactNumbers,additionalContactNumbers:clientDetail.additionalContactNumbers,email:clientDetail.email,existingEmail:clientDetail.email,clientType:clientDetail.clientType,contactNumber:clientDetail.contactNumber,existingContactNumber:clientDetail.contactNumber,address:clientDetail.address,shippingAddress:clientDetail.shippingAddress,shippingCity:clientDetail.shippingCity,shippingPincode:clientDetail.shippingPincode,city:clientDetail.city,state:clientDetail.state.zone_id,shippingState:clientDetail.shippingState?clientDetail.shippingState.zone_id:null,country:clientDetail.country.country_id?clientDetail.country.country_id:99,shippingCountry:clientDetail.shippingCountry?clientDetail.shippingCountry.country_id:null,pincode:clientDetail.pincode,customerAddress:clientDetail.address,pan:clientDetail.panNumber,selectedPlan:clientDetail.plan?clientDetail.plan.id:null,// selectedSolutionMaster: clientDetail.solutionId ? clientDetail.solutionId : null,
// selectedPlan: clientDetail.plan,
timezone:clientDetail.timezone?clientDetail.timezone:{value:'Asia/Kolkata',label:'Asia/Kolkata'},prorata:clientDetail.prorata,minimumTrackedDays:clientDetail.minimumTrackedDays,packetThreshold:clientDetail.packetThreshold,gst:clientDetail.gst,clientLoginId:clientDetail.loginId,customerType:clientDetail.registrationType,typeOfClient:clientDetail.type,expiryDateTime:clientDetail.expiryDate?__WEBPACK_IMPORTED_MODULE_18_moment___default.a.unix(clientDetail.expiryDate):_this.state.expiryDateTime,solution:clientDetail.solution,billingMode:clientDetail.billingMode.id,salesPerson:clientDetail.salesPerson&&clientDetail.salesPerson.id,// selectedZM: clientDetail.zonalManager,
// selectedKAM: clientDetail.keyAccountManager,
selectedZM:_this.state.zonalManagers.find(function(zm){return zm.id===clientDetail.zonalManager;})?_this.state.zonalManagers.find(function(zm){return zm.id===clientDetail.zonalManager;}).id:null,selectedStateManager:_this.state.stateManagers.find(function(sm){return sm.id===clientDetail.stateManager;})?_this.state.stateManagers.find(function(sm){return sm.id===clientDetail.stateManager;}).id:null,selectedTerritoryManager:_this.state.territoryManagers.find(function(tm){return tm.id===clientDetail.territoryManager;})?_this.state.territoryManagers.find(function(tm){return tm.id===clientDetail.territoryManager;}).id:null,selectedSalesHead:_this.state.salesHeads.find(function(sh){return sh.id===clientDetail.salesHead;})?_this.state.salesHeads.find(function(sh){return sh.id===clientDetail.salesHead;}).id:null,selectedClusterHead:_this.state.clusterHeads.find(function(ch){return ch.id===clientDetail.clusterHead;})?_this.state.clusterHeads.find(function(ch){return ch.id===clientDetail.clusterHead;}).id:null,selectedStateHead:_this.state.stateHeads.find(function(sh){return sh.id===clientDetail.stateHead;})?_this.state.stateHeads.find(function(sh){return sh.id===clientDetail.stateHead;}).id:null,selectedCityManager:_this.state.cityManagers.find(function(cm){return cm.id===clientDetail.cityManager;})?_this.state.cityManagers.find(function(cm){return cm.id===clientDetail.cityManager;}).id:null,selectedOperationsManager:_this.state.operationsManagers.find(function(om){return om.id===clientDetail.operationsManager;})?_this.state.operationsManagers.find(function(om){return om.id===clientDetail.operationsManager;}).id:null,selectedKAM:_this.state.keyAccountManagers.find(function(kam){return kam.id===clientDetail.keyAccountManager;})?_this.state.keyAccountManagers.find(function(kam){return kam.id===clientDetail.keyAccountManager;}).id:null,channelPartnerName:clientDetail.channelPartnerName,selectedVTM:clientDetail.videoTelematicsType,selectedServiceType:clientDetail.serviceType?clientDetail.serviceType.toLowerCase():clientDetail.solution?clientDetail.solution.toLowerCase():'portal',selectedMode:clientDetail.litemode?_this.functionTakeAndGiveModeValue(clientDetail.litemode):'taabi_pro',is_sim_tracking:simTracking,totalPotentialVehicles:clientDetail.totalPotentialVehicles,customerAcquisitionType:clientDetail.customerAcquisitionType||null,directCustomer:clientDetail.directCustomer?{label:clientDetail.directCustomer,value:clientDetail.directCustomerSAPCode}:null,directCustomerType:clientDetail.directCustomerType||null,directCustomerSAPCode:clientDetail.directCustomerSAPCode||null,existingDirectCustomerSAPCode:clientDetail.directCustomerSAPCode||null,indirectCustomerType:clientDetail.indirectCustomerType||null,channelPartnerType:clientDetail.channelPartnerType||null,indirectCustomerName:clientDetail.indirectCustomerName||null,indirectCustomerUniqueId:clientDetail.indirectCustomerUniqueId||null,customerLocation:clientDetail.customerLocation?clientDetail.customerLocation:'India'||null,secondaryLandlineNumber:clientDetail.secondaryLandlineNumber||null,channelPartnerSAPCode:clientDetail.channelPartnerSAPCode||null,customerNameToBeDisplayed:clientDetail.customerNameToBeDisplayed||null,existingCustomerNameToBeDisplayed:clientDetail.customerNameToBeDisplayed||null,zone:clientDetail.zone||null,// serviceManager: clientDetail.serviceManager || null,
// customerSuccessManager: clientDetail.customerSuccessManager || null,
serviceManager:_this.state.serviceManagers.find(function(sm){return sm.id===clientDetail.serviceManager;})?_this.state.serviceManagers.find(function(sm){return sm.id===clientDetail.serviceManager;}).id:null,customerSuccessManager:_this.state.customerSuccessManagers.find(function(csm){return csm.id===clientDetail.customerSuccessManager;})?_this.state.customerSuccessManagers.find(function(csm){return csm.id===clientDetail.customerSuccessManager;}).id:null,isSecondaryContact:clientDetail.isSecondaryContact||!!clientDetail.secondaryContactPerson,videoTelematicsType:_this.functionTakeAndGiveVideoTeleValueInCaps(clientDetail.videoTelematicsType)||null,clientCategory:clientDetail.clientCategory||'B'});};_this.handleSolutionChange=function(solutionType){_this.setState({isStateChanged:true});console.log('solution:',solutionType);if(!solutionType){_this.setState({solution:''});}else{_this.setState({solution:solutionType.value});}};_this.hanldeBillingModeChange=function(billingMode){_this.setState({isStateChanged:true});console.log('biiling Mode',billingMode);if(!billingMode){_this.setState({billingMode:''});}else{_this.setState({billingMode:billingMode.value});}};_this.getAllSalesPersonDetails=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){var fetchSalesPersonData,getAllSalesPerson,salesPersonsDetails;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return _this.props.client.query({query:GET_ALL_SALESPERSON,variables:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_15__utils_getLoginId__["a" /* default */])()}});case 2:fetchSalesPersonData=_context4.sent;getAllSalesPerson=fetchSalesPersonData.data.getAllSalesPerson;salesPersonsDetails=getAllSalesPerson.map(function(salesPerson){return{value:salesPerson.id,label:salesPerson.name};});// console.log('Edit customer getAllsataperson :', salesPersonsDetails)
_this.setState({allSalesPerson:salesPersonsDetails});case 6:case'end':return _context4.stop();}}},_callee4,_this2);}));_this.handleSalesPersonChange=function(salesPerson){_this.setState({isStateChanged:true});console.log('salesPerson',salesPerson);if(!salesPerson){_this.setState({salesPerson:''});}else{_this.setState({salesPerson:salesPerson.value});}};_this.handleInputChange=function(e){var _this$setState3;_this.setState((_this$setState3={},_defineProperty(_this$setState3,e.target.name,e.target.value),_defineProperty(_this$setState3,'isStateChanged',true),_this$setState3));};_this.handleInputChangeNew=function(key){return function(e){var _e$target2=e.target,name=_e$target2.name,value=_e$target2.value;_this.setState(_defineProperty({},name,value));if(key==='indirectCustomerName'){_this.setState({customerNameToBeDisplayed:value});}};};_this.handleInputChangeUsernamePassword=function(e){// regex removed (unused)
_this.setState(_defineProperty({},e.target.name,e.target.value));};_this.handleSimTracking=function(e){_this.state.is_sim_tracking?_this.setState({is_sim_tracking:false}):_this.setState({is_sim_tracking:true});};_this.handleCountryChange=function(country){_this.setState({isStateChanged:true});if(!country){_this.setState({state:'',country:''});}else{_this.setState({state:'',country:country.value});}};_this.handleShippingCountryChange=function(country){_this.setState({isStateChanged:true});if(!country){_this.setState({shippingState:'',shippingCountry:''});}else{_this.setState({shippingState:'',shippingCountry:country.value});}};_this.handleStateChange=function(state){// console.log(state, 'state')
_this.setState({isStateChanged:true});_this.setState({state:state&&state.value});};_this.handleShippingStateChange=function(state){// console.log(state, 'state')
_this.setState({isStateChanged:true});_this.setState({shippingState:state&&state.value});};_this.handlePlanChange=function(selectedOption){_this.setState({isStateChanged:true,// selectedPlan: selectedOption,
selectedPlan:selectedOption?selectedOption.value:null});// if (!plan) {
//   this.setState({ plan: '' })
// } else {
//   this.setState({ plan: plan.value })
// }
};_this.handleTimezoneChange=function(timezone){_this.setState({isStateChanged:true});if(!timezone){_this.setState({timezone:''});}else{_this.setState({timezone:timezone.value});}};_this.handleCustomerTypeChange=function(customer){// console.log('Customer', customer)
if(!customer){_this.setState({customerType:''});}else{_this.setState({customerType:customer.value,isGSTExists:null,isGSTValid:true,gst:'',panNumber:'',address:'',pincode:'',gstCompanyName:'',clientNameRes:'',isNameValid:true,isAddressValid:true,isPinValid:true});}};_this.handleCustomerAcquisitionTypeChange=function(customer){_this.setState({customerAcquisitionType:customer?customer.value:''});if(_this.state.customerAcquisitionType==='Direct Customer'){_this.setState({indirectCustomerType:null,indirectCustomerName:null,channelPartnerName:null,channelPartnerSAPCode:null,channelPartnerType:null});}else if(_this.state.customerAcquisitionType==='Indirect Customer'){_this.setState({directCustomerType:null,directCustomer:null,directCustomerSAPCode:null});}};_this.checkNameValidity=function(client){return function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(event){var name,regex,isValidFormat,isNameAvailable,_ref8,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:name=_this.state.customerAcquisitionType==='Direct Customer'?_this.state.customerNameToBeDisplayed||(_this.state.directCustomer?_this.state.directCustomer.label:''):_this.state.customerAcquisitionType==='Indirect Customer'?_this.state.customerNameToBeDisplayed||_this.state.indirectCustomerName:_this.state.customerNameToBeDisplayed||'';if(!(name.toLowerCase()===_this.state.existingCustomerNameToBeDisplayed.toLowerCase())){_context5.next=4;break;}_this.setState({isNameValid:true,clientNameRes:''});return _context5.abrupt('return');case 4:regex=new RegExp(// /^(?!\s)(?!.*\s$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9 '~?!]{5,100}$/
/^(?!\s)(?!.*\s$).{5,100}$/);isValidFormat=regex.test(name)&&name!=='';isNameAvailable=false;_context5.prev=7;_context5.next=10;return client.query({query:GET_CLIENT_NAME,variables:{businessname:name}});case 10:_ref8=_context5.sent;data=_ref8.data;isNameAvailable=data.checkClientName==='AVAILABLE';_context5.next=19;break;case 15:_context5.prev=15;_context5.t0=_context5['catch'](7);console.error('Error checking name availability',_context5.t0);isNameAvailable=false;case 19:console.log('isValidFormat && isNameAvailable :',isValidFormat&&isNameAvailable);_this.setState({isNameValid:isValidFormat&&isNameAvailable,clientNameRes:name.length===0?'Please enter the name':!isValidFormat?'Name must be at least 5 characters not contain spaces at beginning or end':!isNameAvailable?'Name already exists':''});case 21:case'end':return _context5.stop();}}},_callee5,_this2,[[7,15]]);}));return function(_x){return _ref7.apply(this,arguments);};}();};_this.checkUsernameValidity=function(client){return function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(event){var regex,_ref10,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:if(!(_this.state.username===_this.state.existingUsername)){_context6.next=3;break;}_this.setState({usernameRes:'',isUsernameValid:true});return _context6.abrupt('return');case 3:regex=new RegExp(/^[a-zA-Z0-9.\-_$@*!]{5,32}$/);_context6.next=6;return client.query({query:GET_USERNAME,variables:{username:_this.state.username}});case 6:_ref10=_context6.sent;data=_ref10.data;_this.setState({isUsernameUnique:data.checkUsername==='AVAILABLE',isUsernameValid:regex.test(_this.state.username)&&_this.state.username!==''&&data.checkUsername==='AVAILABLE'});if(regex.test(_this.state.username)===false){_this.setState({usernameRes:'Username Can be character number special chatcters(-_$@*!) without blank space between 5-32 charcters',isUsernameValid:false});}else if(data.checkUsername!=='AVAILABLE'){_this.setState({usernameRes:'Username already exist',isUsernameValid:false});}case 10:case'end':return _context6.stop();}}},_callee6,_this2);}));return function(_x2){return _ref9.apply(this,arguments);};}();};_this.checkContactpValidity=function(){var regex=new RegExp(/^[a-zA-Z\s]{3,32}$/);_this.setState({isContactpValid1:regex.test(_this.state.contactPerson)});};_this.checkContactpValidityTwo=function(){var regex=new RegExp(/^[a-zA-Z\s]{3,32}$/);_this.setState({isContactpValid2:regex.test(_this.state.secondaryContactName)});};_this.checkPasswordValidity=function(){// const regex = new RegExp(/^[a-zA-Z0-9.\-_$@*!#]{3,20}$/)
var regex=new RegExp(/^[a-zA-Z0-9!@#$&()\\-`.+,/"]{3,20}$/);_this.setState({isPasswordValid:_this.state.password!==''&&regex.test(_this.state.password)});};_this.checkPhonenoValidity1=function(client){return function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(event){var regex,_ref12,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:if(!(_this.state.contactNumber!==_this.state.existingContactNumber)){_context7.next=8;break;}regex=new RegExp(/^(\+91[-\s]?)?[0]?(91)?[1-9]\d{8,19}$/);_context7.next=4;return client.query({query:GET_CONTACTNO,variables:{phoneno:_this.state.contactNumber}});case 4:_ref12=_context7.sent;data=_ref12.data;_this.setState({isPhoneExists:data.checkClientContactNumber==='AVAILABLE',isPhonenoValid1:regex.test(_this.state.contactNumber)});if(_this.state.contactNumber===_this.state.secondaryContactNumber){_this.setState({phonenoRes2:'Secondary Contact Number should not be the same as Primary Contact Number',isPhonenoValid2:false});}case 8:case'end':return _context7.stop();}}},_callee7,_this2);}));return function(_x3){return _ref11.apply(this,arguments);};}();};_this.checkPhonenoValidity2=function(client){return function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(event){var regex;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:regex=new RegExp(/^(\+91[-\s]?)?[0]?(91)?[1-9]\d{8,19}$/);if(_this.state.secondaryContactNumber!==''){_this.setState({isPhonenoValid2:regex.test(_this.state.secondaryContactNumber)});if(regex.test(_this.state.secondaryContactNumber)===false){_this.setState({phonenoRes2:'Invalid phone number'});}if(_this.state.secondaryContactNumber===_this.state.contactNumber){_this.setState({phonenoRes2:'Secondary Contact Number should not be the same as Primary Contact Number',isPhonenoValid2:false});}}else{_this.setState({phonenoRes2:'Invalid phone number',isPhonenoValid2:false});}case 2:case'end':return _context8.stop();}}},_callee8,_this2);}));return function(_x4){return _ref13.apply(this,arguments);};}();};_this.checkLandlineValidity=function(){var _ref14=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(event,fieldName){var regex,landlineNumber,isValid;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_this.setState(_defineProperty({},fieldName+'Error',''));regex=new RegExp(/^\(?\d{3,4}\)?[-\s]?\d{6,8}$/);landlineNumber=_this.state[fieldName];if(landlineNumber){isValid=regex.test(landlineNumber);_this.setState(_defineProperty({},fieldName+'Valid',isValid));if(!isValid&&landlineNumber){_this.setState(_defineProperty({},fieldName+'Error','Invalid landline number'));}else{_this.setState(_defineProperty({},fieldName+'Error',''));}}case 4:case'end':return _context9.stop();}}},_callee9,_this2);}));return function(_x5,_x6){return _ref14.apply(this,arguments);};}();_this.checkEmailValidity1=function(client){return function(){var _ref15=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(event){var regex,_ref16,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:if(!(_this.state.email!==_this.state.existingEmail)){_context10.next=8;break;}regex=new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);_context10.next=4;return client.query({query:GET_EMAIL,variables:{email:_this.state.email}});case 4:_ref16=_context10.sent;data=_ref16.data;_this.setState({isEmailExists:data.checkClientEmail==='AVAILABLE',isEmailValid1:regex.test(_this.state.email)});if(_this.state.email===_this.state.secondaryEmail){_this.setState({emailRes2:'Secondary Email should not be the same as Primary Email',isEmailValid2:false});}case 8:case'end':return _context10.stop();}}},_callee10,_this2);}));return function(_x7){return _ref15.apply(this,arguments);};}();};_this.checkEmailValidity2=function(client){return function(){var _ref17=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(event){var regex;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:regex=new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);if(_this.state.secondaryEmail!==''){_this.setState({isEmailValid2:regex.test(_this.state.secondaryEmail)});if(regex.test(_this.state.secondaryEmail)===false){_this.setState({emailRes2:'Invalid Email'});}if(_this.state.secondaryEmail===_this.state.email){_this.setState({emailRes2:'Secondary Email should not be the same as Primary Email',isEmailValid2:false});}}else{_this.setState({emailRes2:'Invalid email',isEmailValid2:false});}case 2:case'end':return _context11.stop();}}},_callee11,_this2);}));return function(_x8){return _ref17.apply(this,arguments);};}();};_this.checkAddressValidity=function(){// const regex = new RegExp(/^[a-zA-Z0-9\s,.'-]{3,300}$/)
var regex=new RegExp(/^(.{5,200})$/);var regex2=new RegExp(/^[^\s]+(\s+[^\s]+)*$/);_this.setState({isAddressValid:regex.test(_this.state.address)&&regex2.test(_this.state.address)});};_this.checkShippingAddressValidity=function(){// const regex = new RegExp(/^[a-zA-Z0-9\s,.'-]{3,300}$/)
var regex=new RegExp(/^(.{5,200})$/);var regex2=new RegExp(/^[^\s]+(\s+[^\s]+)*$/);_this.setState({isShippingAddressValid:regex.test(_this.state.shippingAddress)&&regex2.test(_this.state.shippingAddress)});};_this.checkCountryValidity=function(){_this.setState({isCountryValid:_this.state.country!==''});};_this.checkCountryValidity2=function(){_this.setState({isCountryValid:_this.state.shippingCountry!==''});};_this.checkCityValidity=function(arg){var regex=new RegExp(/^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/);if(arg==='billing'){_this.setState({isCityValid:regex.test(_this.state.city)&&_this.state.city!==''});}else if(arg==='shipping'){_this.setState({isShippingCityValid:regex.test(_this.state.shippingCity)&&_this.state.city!==''});}};_this.checkPinValidity=function(){_this.setState({isPinValid:true});if(_this.state.pincode!==null&&_this.state.pincode!==''){var regex=new RegExp(/^[1-9][0-9]{5}$/);_this.setState({isPinValid:regex.test(_this.state.pincode)});}};_this.checkPinValidity2=function(){_this.setState({isShippingPinvalid:true});if(_this.state.shippingPincode!==null&&_this.state.shippingPincode!==''){var regex=new RegExp(/^[1-9][0-9]{5}$/);_this.setState({isShippingPinvalid:regex.test(_this.state.shippingPincode)});}};_this.checkPanValidity=function(client){return function(){var _ref18=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(event){var regex,_ref19,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:// console.log(this.state.pan, 'pan')
_this.setState({panNoRes:''});if(!(_this.state.pan!==null&&_this.state.pan!=='')){_context12.next=8;break;}regex=new RegExp(/([A-Z]){5}([0-9]){4}([A-Z]){1}$/);_context12.next=5;return client.query({query:GET_PAN_NUMBER,variables:{pan:_this.state.pan}});case 5:_ref19=_context12.sent;data=_ref19.data;_this.setState({isPanValid:regex.test(_this.state.pan),isPanExists:data.checkClientPanNumber==='AVAILABLE'});case 8:case'end':return _context12.stop();}}},_callee12,_this2);}));return function(_x9){return _ref18.apply(this,arguments);};}();};_this.checkGSTValidity=function(){var _ref20=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(gstNumber){var regex,_ref21,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:if(!(_this.state.gst!==null&&_this.state.gst!=='')){_context13.next=19;break;}// const regex = new RegExp(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9]{1}Z[a-zA-Z0-9]{1}$/)
regex=new RegExp(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/);_context13.next=4;return _this.props.client.query({query:GET_GST_NUMBER,variables:{gst:_this.state.gst},fetchPolicy:'network-only'});case 4:_ref21=_context13.sent;data=_ref21.data;_this.setState({isGSTExists:data.checkClientGST==='AVAILABLE',isGSTValid:regex.test(_this.state.gst)});if(!_this.state.isGSTValid){_this.setState({gstErrorFieldText:'Invalid GST Number.'});}if(_this.state.isGSTExists===false){_this.setState({gstErrorFieldText:'GST Number already registered.'});}if(!(_this.state.isGSTValid&&_this.state.isGSTExists)){_context13.next=16;break;}_this.setState({gstErrorFieldText:'',panNumber:'',gstCompanyName:'',address:'',pincode:''});_context13.next=13;return _this.getGstInfo(gstNumber);case 13:if(!_this.state.isGstInfoAvailable){_this.setState({gstErrorFieldText:'Invalid GST Number.'});}_context13.next=17;break;case 16:_this.setState({panNumber:'',gstCompanyName:'',address:'',pincode:''});case 17:_context13.next=20;break;case 19:_this.setState({panNumber:'',gstCompanyName:'',address:'',pincode:''});case 20:case'end':return _context13.stop();}}},_callee13,_this2);}));return function(_x10){return _ref20.apply(this,arguments);};}();_this.handleCancelClick=function(e){if(_this.state.isStateChanged){_this.setState({isCancelConfDialogOpen:true});}else{_this.cancelForm();}};_this.handleSaveClick=function(e){_this.setState({isSaveConfDialogOpen:true});};_this.handleCancelNegativeResponse=function(e){_this.setState({isCancelConfDialogOpen:false});};_this.handleSaveNegativeResponse=function(e){_this.setState({isSaveConfDialogOpen:false});};_this.handleShippingAddressCheckbox=function(){_this.setState({isShippingAddressValid:true,isShippingCityValid:true,isShippingPinvalid:true,shippingAddress:'',shippingCity:'',shippingPincode:'',shippingCountry:'',shippingState:''});_this.setState({isShippingAddressChecked:!_this.state.isShippingAddressChecked},function(){if(_this.state.isShippingAddressChecked===true){_this.setState({shippingAddress:_this.state.address,shippingCity:_this.state.city,shippingPincode:_this.state.pincode,shippingCountry:_this.state.country,shippingState:_this.state.state});}else{_this.setState({shippingAddress:'',shippingCity:'',shippingPincode:'',shippingCountry:'',shippingState:''});}});};_this.fetchDropdownDetails=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(){var response,dropDownData,dropdownValues,dropdownStateManagers,mergedStateManagers;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:_context14.prev=0;_context14.next=3;return _this.props.client.query({query:GET_DROPDOWN_DETAILS});case 3:response=_context14.sent;dropDownData=JSON.parse(response.data.getDropDownDetail);dropdownValues={};Object.keys(dropDownData).forEach(function(key){if(Array.isArray(dropDownData[key])){dropdownValues[key]=dropDownData[key].filter(function(option){return option!==null;});}});// Map state manager strings (if present) into objects for Select options
dropdownStateManagers=dropdownValues.statemanager?dropdownValues.statemanager.map(function(sm){return{label:sm,value:sm};}):[];// Do not overwrite stateManagers fetched from admin API (getZmKamSmCsmDetails)
mergedStateManagers=_this.state.stateManagers&&_this.state.stateManagers.length?_this.state.stateManagers:dropdownStateManagers;_this.setState(Object.assign({},dropdownValues,{stateManagers:mergedStateManagers}));_context14.next=15;break;case 12:_context14.prev=12;_context14.t0=_context14['catch'](0);console.error('Error fetching dropdown details:',_context14.t0);case 15:case'end':return _context14.stop();}}},_callee14,_this2,[[0,12]]);}));_this.submitForm=function(client){return function(){var _ref23=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(e){var zonalManager,litemode,keyAccountManager,channelPartnerName,variables,_ref24,data,errors;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:e.preventDefault();zonalManager=_this.state.selectedZM||'';// let litemode =  this.state.selectedMode && this.state.selectedMode.value ? convertToSnakeCase(this.state.selectedMode.value) : ''
litemode=_this.state.selectedMode?_this.state.selectedMode.value?Object(__WEBPACK_IMPORTED_MODULE_29__utils_conertSnakeFormat__["a" /* default */])(_this.state.selectedMode.value):Object(__WEBPACK_IMPORTED_MODULE_29__utils_conertSnakeFormat__["a" /* default */])(_this.state.selectedMode):'';console.log('litemode: ',litemode);// let videoTelematicsType = this.state.selectedVTM && this.state.selectedVTM.value ? functionTakeAndGiveVideoTeleValue(this.state.selectedVTM.value) : null
keyAccountManager=_this.state.selectedKAM||'';channelPartnerName=_this.state.channelPartnerName||'';console.log('serviceType: ',_this.state.selectedServiceType&&_this.state.selectedServiceType.value?_this.state.selectedServiceType.value:_this.state.selectedServiceType.label?_this.state.selectedServiceType.label:'');// let serviceType = this.state.selectedServiceType &&  this.state.selectedServiceType.value ? this.state.selectedServiceType.value : this.state.selectedServiceType.label ? this.state.selectedServiceType.label : ''
// console.log('videoTelematicsType : ',videoTelematicsType,serviceType);
variables={id:parseInt(_this.state.clientId,10),clientName:_this.state.customerNameToBeDisplayed||(_this.state.customerAcquisitionType==='Direct Customer'&&_this.state.directCustomer?_this.state.directCustomer.label:_this.state.customerAcquisitionType==='Indirect Customer'?_this.state.indirectCustomerName:null),login_id:parseInt(_this.loginId,10),email:_this.state.email,contactPerson:_this.state.contactPerson,contactNumber:_this.state.contactNumber,secondaryEmail:_this.state.isSecondaryContact?_this.state.secondaryEmail:null,secondaryContactName:_this.state.isSecondaryContact?_this.state.secondaryContactName:null,secondaryContactNumber:_this.state.isSecondaryContact?_this.state.secondaryContactNumber:null,address:_this.state.customerAddress||_this.state.address,shippingAddress:_this.state.shippingAddress,shippingCountry:_this.state.shippingCountry,shippingState:_this.state.shippingState,shippingCity:_this.state.shippingCity,shippingPincode:parseInt(_this.state.shippingPincode,10),city:_this.state.city,state_id:parseInt(_this.state.state,10),state:parseInt(_this.state.state,10),country_id:parseInt(_this.state.country,10),pincode:parseInt(_this.state.pincode,10),panNumber:_this.state.pan,clientType:_this.state.clientType,customerType:_this.state.customerType,subscriptionPlan:'prepaid',periodicity:1,status:1,partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_15__utils_getLoginId__["a" /* default */])(),plan:parseInt(_this.state.selectedPlan,10),// solutionId: this.state.selectedSolutionMaster,
timezone:_this.state.timezone,gst:_this.state.gst,username:_this.state.username,typeOfClient:_this.state.typeOfClient,solution:_this.state.solution,billingMode:_this.state.billingMode,prorata:_this.state.prorata,packetThreshold:parseInt(_this.state.packetThreshold,10),salesPersonId:_this.state.salesPerson,minimumTrackedDays:parseInt(_this.state.minimumTrackedDays,10),zonalManager:zonalManager,stateManager:_this.state.selectedStateManager||'',territoryManager:_this.state.selectedTerritoryManager||null,salesHead:_this.state.selectedSalesHead||null,clusterHead:_this.state.selectedClusterHead||null,stateHead:_this.state.selectedStateHead||null,cityManager:_this.state.selectedCityManager||null,operationsManager:_this.state.selectedOperationsManager||null,litemode:litemode,// videoTelematicsType: videoTelematicsType|| null,
videoTelematicsType:_this.state.selectedVTM==='none'?null:_this.state.selectedVTM,keyAccountManager:keyAccountManager,channelPartnerName:_this.state.customerAcquisitionType==='Indirect Customer'?channelPartnerName:null,is_sim_tracking:_this.state.is_sim_tracking,isSecondaryContact:_this.state.isSecondaryContact||false,totalPotentialVehicles:parseInt(_this.state.totalPotentialVehicles,10),customerAcquisitionType:_this.state.customerAcquisitionType||null,directCustomer:_this.state.customerAcquisitionType==='Direct Customer'?_this.state.directCustomer?_this.state.directCustomer.label:null:null,directCustomerType:_this.state.customerAcquisitionType==='Direct Customer'?_this.state.directCustomerType:null,directCustomerSAPCode:_this.state.customerAcquisitionType==='Direct Customer'?_this.state.directCustomerSAPCode:null,indirectCustomerType:_this.state.customerAcquisitionType==='Indirect Customer'?_this.state.indirectCustomerType:null,channelPartnerType:_this.state.customerAcquisitionType==='Indirect Customer'?_this.state.channelPartnerType:null,indirectCustomerName:_this.state.customerAcquisitionType==='Indirect Customer'?_this.state.indirectCustomerName:null,indirectCustomerUniqueId:_this.state.customerAcquisitionType==='Indirect Customer'?_this.state.indirectCustomerUniqueId:null,customerLocation:_this.state.customerLocation||null,secondaryLandlineNumber:_this.state.isSecondaryContact?_this.state.secondaryLandlineNumber:null,channelPartnerSAPCode:_this.state.customerAcquisitionType==='Indirect Customer'?_this.state.channelPartnerSAPCode:null,customerNameToBeDisplayed:_this.state.customerNameToBeDisplayed||(_this.state.customerAcquisitionType=='Direct Customer'&&_this.state.directCustomer?_this.state.directCustomer.label:_this.state.customerAcquisitionType=='Indirect Customer'?_this.state.indirectCustomerName:null),zone:_this.state.zone||'',// serviceManager: clientDetail.serviceManager || null,
// customerSuccessManager: clientDetail.customerSuccessManager || null,
serviceManager:_this.state.serviceManager||'',customerSuccessManager:_this.state.customerSuccessManager||'',serviceType:_this.state.selectedServiceType,registrationType:_this.state.customerType,clientCategory:_this.state.clientCategory,additionalContactNumbers:_this.state.isAdditionalContact?_this.state.additionalContactNumbers:''};if(_this.state.typeOfClient==='NON-COMMERCIAL'){variables['expiryDate']=__WEBPACK_IMPORTED_MODULE_18_moment___default()(_this.state.expiryDateTime).unix().toString();}_context15.next=11;return client.mutate({mutation:UPDATE_CLIENT,variables:variables,errorPolicy:'all',refetchQueries:['allClientDetails']});case 11:_ref24=_context15.sent;data=_ref24.data;errors=_ref24.errors;if(!data){_context15.next=22;break;}_context15.next=17;return client.clearStore();case 17:_this.props.openSnackbar('Updated Successfully');_this.setState({clientId:'',companyName:'',username:'',person:'',secondaryContactNumber:'',secondaryEmail:'',secondaryContactName:'',password:'',clientType:'',email:'',phoneno:'',address:'',// billingAddress2: '',
// shippingAddress2: '',
city:'',// customerAddress:'',
// address:'',
state:'',country:'',shippingState:'',shippingCountry:'',pincode:'',shippingAddress:'',shippingCity:'',shippingPincode:'',pan:'',gst:'',selectedPlan:'',// selectedSolutionMaster: '',
timezone:'',prorata:0,packetThreshold:0,minimumTrackedDays:0,typeOfClient:'REAL',expiryDateTime:__WEBPACK_IMPORTED_MODULE_18_moment___default()().add(1,'week'),totalPotentialVehicles:0});_this.props.history.push({pathname:'/home/customers'});_context15.next=23;break;case 22:_this.props.openSnackbar(errors[0].message);case 23:case'end':return _context15.stop();}}},_callee15,_this2);}));return function(_x11){return _ref23.apply(this,arguments);};}();};_this.cancelForm=function(e){// this.setState({
//   clientId: '',
//   companyName: '',
//   username: '',
//   person: '',
//   password: '',
//   email: '',
//   phoneno: '',
//   address: '',
//   billingAddress2: '',
//   city: '',
//   state: '',
//   country: '',
//   pincode: '',
//   pan: '',
//   gst: '',
//   plan: '',
//   timezone: '',
//   typeOfClient: 'REAL',
//   expiryDateTime: moment().add(1, 'week')
// })
_this.props.history.goBack();};_this.handleTypeChange=function(e){var value=e.target.value;console.log('typeof client :',value);_this.setState({typeOfClient:e.target.value,isStateChanged:true});if(value==='DEMO'){_this.setState({expiryDateTime:__WEBPACK_IMPORTED_MODULE_18_moment___default()().add(1,'month'),isStateChanged:true});}else{_this.setState({expiryDateTime:__WEBPACK_IMPORTED_MODULE_18_moment___default()().add(1,'week'),isStateChanged:true});}};_this.getGstInfo=function(){var _ref25=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16(gstNumber){var fetchGstData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16){while(1){switch(_context16.prev=_context16.next){case 0:_context16.next=2;return _this.props.client.query({query:GET_GST_INFO,variables:{gstNumber:gstNumber}});case 2:fetchGstData=_context16.sent;_this.setState({isGstInfoAvailable:fetchGstData.data.getGstDetails.status==='SUCCESS',pan:fetchGstData.data.getGstDetails.panNumber!=null?fetchGstData.data.getGstDetails.panNumber:null,companyName:fetchGstData.data.getGstDetails.companyName!=null?fetchGstData.data.getGstDetails.companyName:null,address:fetchGstData.data.getGstDetails.address!=null?fetchGstData.data.getGstDetails.address:null,pincode:fetchGstData.data.getGstDetails.pinCode!=null?fetchGstData.data.getGstDetails.pinCode:null});case 4:case'end':return _context16.stop();}}},_callee16,_this2);}));return function(_x12){return _ref25.apply(this,arguments);};}();_this.loginId=parseInt(_this.props.match.params.loginId,10);var timezoneLists=__webpack_require__(187).getTimezones();var timezoneList=timezoneLists.map(function(timezone){return{value:timezone,label:timezone};});_this.state={clientId:'',companyName:'',username:'',person:'',password:'',clientType:'',registrationType:'',email:'',secondaryEmail:'',phoneno:'',secondaryContactNumber:'',address:'',// billingAddress2: '',
city:'',state:'',shippingAddress:'',shippingCity:'',shippingPincode:'',country:'',shippingCountry:'',shippingState:'',pincode:'',pan:'',gst:'',isGstEdited:false,isGstInfoAvailable:true,// plan: null,
timezoneList:timezoneList,timezone:'',isEmailValid:true,isEmailValid2:true,isPhonenoValid:true,isPhonenoValid2:true,isContactpValid2:true,isAddressValid:true,isShippingAddressValid:true,isCityValid:true,isShippingCityValid:true,isContactpValid1:true,isPhonenoValid1:true,isEmailExists:'false',isPhoneExists:'false',isChecked:false,isPinValid:true,isPanValid:true,isGSTValid:true,isUsernameValid:true,isNameValid:true,isSecondaryLandlineNumberValid:true,secondaryLandlineNumberError:'',customerType:'',isContactpValid:true,isContactSValid:true,isPasswordValid:true,isUsernameUnique:true,isCancelConfDialogOpen:false,isSaveConfDialogOpen:false,response:false,clientLoginId:'',clientNameRes:'',stateId:'',emailRes:'',phonenoRes:'',usernameRes:'',panNoRes:'',typeOfClient:'REAL',expiryDateTime:__WEBPACK_IMPORTED_MODULE_18_moment___default()().add(1,'week'),solution:'',prorata:0,secondaryLandlineNumber:'',isSecondaryContact:false,isEmailValid1:true,selectedServiceType:'',minimumTrackedDays:0,packetThreshold:0,billingMode:'',salesPerson:'',allSalesPerson:[],isStateChanged:false,// isShippingAddressChecked: false
isShippingAddressChecked:false,isShippingPinvalid:true,is_sim_tracking:false,gstErrorFieldText:'',showFields:false,selectedMode:null,selectedPlan:null,// selectedSolutionMaster: null,
selectedZM:null,selectedStateManager:null,selectedTerritoryManager:null,selectedSalesHead:null,selectedClusterHead:null,selectedStateHead:null,selectedCityManager:null,selectedOperationsManager:null,selectedVTM:null,selectedKAM:null,channelPartnerName:'',channelPartnerSAPCode:'',totalPotentialVehicles:0,zonalManagers:[],stateManagers:[],territoryManagers:[],salesHeads:[],clusterHeads:[],stateHeads:[],cityManagers:[],operationsManagers:[],keyAccountManagers:[],serviceManagers:[],customerSuccessManagers:[],indirectCustomerType:'',channelPartnerType:'',channelPartnerSAPCodeNew:[],clientCategory:'B',clientCategoryOptions:[{value:'C',label:'Committed Customer'},{value:'B',label:'Basic Customer'}],isAdditionalContact:false,additionalContactNumbers:'',isAdditionalContactValid:true,additionalContactError:''};return _this;}_createClass(EditCustomer,[{key:'componentDidMount',value:function(){var _ref26=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee17(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17){while(1){switch(_context17.prev=_context17.next){case 0:_context17.prev=0;_context17.next=3;return this.getZmKamSmCsmDetails();case 3:_context17.next=5;return this.setZmKamSmCsmValues();case 5:_context17.next=10;break;case 7:_context17.prev=7;_context17.t0=_context17['catch'](0);console.error('Error in getZmKamSmCsmDetails:',_context17.t0);case 10:this.getClients();this.getAllSalesPersonDetails();this.getAllSalesPersonDetails();this.fetchDropdownDetails();this.getChannelPartnerDetailsNew();case 15:case'end':return _context17.stop();}}},_callee17,this,[[0,7]]);}));function componentDidMount(){return _ref26.apply(this,arguments);}return componentDidMount;}()// handleCheckboxChange = e => {
//   const name = e.target.name
//   this.setState(prev => ({
//     // isChecked: !prev.isChecked
//     prorata: prev ? 0 : 1
//   }))
// }
// handleZMChange = selectedOption => {
//   if (selectedOption) {
//     this.setState({ selectedZM: selectedOption.value || '' })
//   } else {
//     this.setState({ selectedZM: '' })
//   }
// }
// handleKAMChange = selectedOption => {
//   if (selectedOption) {
//     this.setState({ selectedKAM: selectedOption.value || '' })
//   } else {
//     this.setState({ selectedKAM: '' })
//   }
// }
// handleCheckboxChange = e => {
//   const name = e.target.name
//   this.setState(prev => ({
//     isChecked: !prev.isChecked
//   }))
// }
// handleSolutionMasterChange = selectedOption => {
//   this.setState({
//     isStateChanged: true,
//     selectedSolutionMaster: selectedOption ? selectedOption.value : null
//   });
// };
// handleCustomerTypeChange = customer => {
//   console.log('Customer', customer)
//   if (!customer) {
//     this.setState({ registrationType: '' })
//   } else {
//     this.setState({
//       registrationType: customer.value,
//       gst: '',
//       pan: '',
//       companyName: '',
//       address: '',
//       pincode: ''
//     })
//   }
// }
//   checkNameValidity = client => async event => {
//     console.log("inside checkName");
//     const { customerNameToBeDisplayed } = this.state;
//     const regex = new RegExp(
//       /^(?!\s)(?!.*\s$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9 '~?!]{5,100}$/
//     );
//     const isValidFormat = regex.test(customerNameToBeDisplayed) && customerNameToBeDisplayed !== '';
//     let isNameAvailable = false;
//     try {
//       const { data } = await client.query({
//         query: GET_CLIENT_NAME,
//         variables: { clientName: customerNameToBeDisplayed }
//       });
//       isNameAvailable = data.checkClientName === 'AVAILABLE';
//     } catch (error) {
//       console.error('Error checking name availability', error);
//       isNameAvailable = false;
//     }
//     console.log("isValidFormat && isNameAvailable :", isValidFormat && isNameAvailable);
//     this.setState({
//       isNameValid: isValidFormat && isNameAvailable,
//       clientNameRes: customerNameToBeDisplayed.length === 0
//         ? 'Please enter the name'
//         : !isValidFormat
//         ? 'Name can be characters or Number between 5-32 characters'
//         : !isNameAvailable
//         ? 'Name already exists'
//         : ''
//     });
// }
},{key:'isSaveFormInvalid',value:function isSaveFormInvalid(){var _state=this.state,customerType=_state.customerType,customerAcquisitionType=_state.customerAcquisitionType,directCustomerType=_state.directCustomerType,directCustomer=_state.directCustomer,indirectCustomerType=_state.indirectCustomerType,channelPartnerType=_state.channelPartnerType,channelPartnerName=_state.channelPartnerName,customerLocation=_state.customerLocation,customerAddress=_state.customerAddress,country=_state.country,pincode=_state.pincode,state=_state.state,city=_state.city,timezone=_state.timezone,zone=_state.zone,selectedZM=_state.selectedZM,selectedStateManager=_state.selectedStateManager,selectedTerritoryManager=_state.selectedTerritoryManager,selectedSalesHead=_state.selectedSalesHead,selectedClusterHead=_state.selectedClusterHead,selectedStateHead=_state.selectedStateHead,selectedCityManager=_state.selectedCityManager,selectedOperationsManager=_state.selectedOperationsManager,selectedKAM=_state.selectedKAM,serviceManager=_state.serviceManager,customerSuccessManager=_state.customerSuccessManager,isUsernameValid=_state.isUsernameValid,isPasswordValid=_state.isPasswordValid,customerNameToBeDisplayed=_state.customerNameToBeDisplayed,totalPotentialVehicles=_state.totalPotentialVehicles,contactPerson=_state.contactPerson,isContactpValid1=_state.isContactpValid1,contactNumber=_state.contactNumber,isPhonenoValid1=_state.isPhonenoValid1,isPhoneExists=_state.isPhoneExists,landlineNumberError=_state.landlineNumberError,isEmailValid1=_state.isEmailValid1,isEmailExists=_state.isEmailExists,isContactpValid2=_state.isContactpValid2,isPhonenoValid2=_state.isPhonenoValid2,secondaryLandlineNumberError=_state.secondaryLandlineNumberError,isEmailValid2=_state.isEmailValid2,selectedMode=_state.selectedMode,selectedPlan=_state.selectedPlan,selectedVTM=_state.selectedVTM,selectedServiceType=_state.selectedServiceType,isSecondaryContact=_state.isSecondaryContact,secondaryContactName=_state.secondaryContactName,secondaryContactNumber=_state.secondaryContactNumber,secondaryEmail=_state.secondaryEmail,isAdditionalContact=_state.isAdditionalContact,additionalContactNumbers=_state.additionalContactNumbers,isAdditionalContactValid=_state.isAdditionalContactValid,clientNameRes=_state.clientNameRes,clientCategory=_state.clientCategory;return!customerType||!customerAcquisitionType||customerAcquisitionType==='Direct Customer'&&(!directCustomerType||!directCustomer)||customerAcquisitionType==='Indirect Customer'&&(!indirectCustomerType||!channelPartnerName||!channelPartnerType)||!customerLocation||!customerAddress||!country||!pincode||!state||!city||!timezone||// !zone ||
// !selectedZM ||
// !selectedStateManager ||
// !selectedTerritoryManager ||
// !selectedSalesHead ||
// !selectedClusterHead ||
// !selectedStateHead ||
// !selectedCityManager ||
// !selectedOperationsManager ||
// !selectedKAM ||
// !serviceManager ||
// !customerSuccessManager ||
!isUsernameValid||!isPasswordValid||clientNameRes||(this.state.customerAcquisitionType==='Direct Customer'?this.state.customerNameToBeDisplayed||(this.state.directCustomer?this.state.directCustomer.label:''):this.state.customerAcquisitionType==='Indirect Customer'?this.state.customerNameToBeDisplayed||this.state.indirectCustomerName:this.state.customerNameToBeDisplayed||'')===''||!totalPotentialVehicles||!contactPerson||!isContactpValid1||!contactNumber||!isPhonenoValid1||!isPhoneExists||landlineNumberError||!isEmailValid1||!isEmailExists||!selectedMode||// commenting Selected plan as we are moving from plan to Solution Based
// !selectedPlan ||
// !selectedSolutionMaster ||
!selectedServiceType||isSecondaryContact&&(!secondaryContactName||!isContactpValid2||!isPhonenoValid2||secondaryLandlineNumberError||!isEmailValid2||!secondaryContactNumber||!secondaryEmail)||isAdditionalContact&&(!additionalContactNumbers||!isAdditionalContactValid)||!clientCategory;}},{key:'render',value:function render(){var _this3=this;var _state2=this.state,companyName=_state2.companyName,username=_state2.username,person=_state2.person,clientType=_state2.clientType,registrationType=_state2.registrationType,customerAcquisitionType=_state2.customerAcquisitionType,secondaryContactName=_state2.secondaryContactName,isSecondaryContact=_state2.isSecondaryContact,secondaryContactNumber=_state2.secondaryContactNumber,secondaryEmail=_state2.secondaryEmail,email=_state2.email,phoneno=_state2.phoneno,address=_state2.address,shippingAddress=_state2.shippingAddress,shippingCity=_state2.shippingCity,shippingPincode=_state2.shippingPincode,city=_state2.city,state=_state2.state,country=_state2.country,shippingCountry=_state2.shippingCountry,shippingState=_state2.shippingState,pincode=_state2.pincode,pan=_state2.pan,gst=_state2.gst,isGstEdited=_state2.isGstEdited,gstErrorFieldText=_state2.gstErrorFieldText,selectedPlan=_state2.selectedPlan,typeOfClient=_state2.typeOfClient,solution=_state2.solution,billingMode=_state2.billingMode,prorata=_state2.prorata,minimumTrackedDays=_state2.minimumTrackedDays,packetThreshold=_state2.packetThreshold,salesPerson=_state2.salesPerson,allSalesPerson=_state2.allSalesPerson,showFields=_state2.showFields,selectedMode=_state2.selectedMode,selectedVTM=_state2.selectedVTM,selectedServiceType=_state2.selectedServiceType,secondaryLandlineNumber=_state2.secondaryLandlineNumber,selectedZM=_state2.selectedZM,selectedStateManager=_state2.selectedStateManager,selectedTerritoryManager=_state2.selectedTerritoryManager,selectedSalesHead=_state2.selectedSalesHead,selectedClusterHead=_state2.selectedClusterHead,selectedStateHead=_state2.selectedStateHead,selectedCityManager=_state2.selectedCityManager,selectedOperationsManager=_state2.selectedOperationsManager,selectedKAM=_state2.selectedKAM,indirectCustomerName=_state2.indirectCustomerName,directCustomerType=_state2.directCustomerType,directCustomerSAPCode=_state2.directCustomerSAPCode,directCustomer=_state2.directCustomer,indirectCustomerType=_state2.indirectCustomerType,channelPartnerType=_state2.channelPartnerType,channelPartnerName=_state2.channelPartnerName,channelPartnerNameSAPCode=_state2.channelPartnerNameSAPCode,customerLocation=_state2.customerLocation,customerAddress=_state2.customerAddress,timezone=_state2.timezone,customerNameToBeDisplayed=_state2.customerNameToBeDisplayed,zone=_state2.zone,serviceManager=_state2.serviceManager,customerSuccessManager=_state2.customerSuccessManager,landlineNumber=_state2.landlineNumber,contactNumber=_state2.contactNumber,contactPerson=_state2.contactPerson,clientCategory=_state2.clientCategory,clientCategoryOptions=_state2.clientCategoryOptions;var classes=this.props.classes;return(// <Query
//   query={GET_ALL_PLANS}
//   variables={{
//     partnerLoginId: getLoginId()
//   }}
//   fetchPolicy="network-only"
// >
//   {({ loading, error, data: { allPlans } }) => {
//     if (loading) return <Loader />
//     if (error) return `Error!: ${error}`
//     const plans = allPlans.map(plan => ({
//       value: plan.id,
//       label: plan.planName
//     }))
__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["Query"],{query:GET_ALL_SOLUTION_TYPE_MASTER,fetchPolicy:'network-only'},function(_ref27){var loading=_ref27.loading,error=_ref27.error,data=_ref27.data;if(loading)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_common_Loader__["a" /* default */],null);if(error)return'Error!: '+error;// Map solutions to value/label format
var solutionsMaster=data.getAllMasterSolutionType.map(function(solution){return{value:solution.id,label:solution.solutionTypeName};});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__common_ConfirmationDialog__["a" /* default */],{isDialogOpen:_this3.state.isSaveConfDialogOpen,dialogMessage:"Are you sure you want to Save this customer's details?",negativeResponseHandler:_this3.handleSaveNegativeResponse,positiveResponseHandler:_this3.submitForm(_this3.props.client)}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__common_ConfirmationDialog__["a" /* default */],{isDialogOpen:_this3.state.isCancelConfDialogOpen,dialogMessage:'Are you sure you want to Cancel new customer creation?',negativeResponseHandler:_this3.handleCancelNegativeResponse,positiveResponseHandler:_this3.cancelForm}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,justify:'flex-start'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Button___default.a,{variant:'outlined',color:'secondary',className:classes.button,onClick:_this3.handleCancelClick},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__material_ui_icons_ArrowBack___default.a,null))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core_Card___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core_CardHeader___default.a,{title:'Edit Customer',subheader:'All fields marked with (*) are mandatory',subheaderTypographyProps:{className:classes.italicizedText}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{zIndex:'20'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Customer Type *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_select__["a" /* default */],{options:Array.isArray(_this3.state.customertype)&&_this3.state.customertype.map(function(option){return{label:option,value:option};}),value:_this3.state.customerType,onChange:_this3.handleCustomerTypeChange,placeholder:'Select Customer Type *'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{zIndex:'15'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Customer Acquisition Type *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_select__["a" /* default */],{options:Array.isArray(_this3.state.customeracquisitiontype)&&_this3.state.customeracquisitiontype.map(function(option){return{label:option,value:option};}),value:customerAcquisitionType,onChange:_this3.handleCustomerAcquisitionTypeChange,placeholder:'Select Customer Acquisition Type *'}))),customerAcquisitionType==='Direct Customer'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{zIndex:'15'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Direct Customer Type *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_select__["a" /* default */],{options:Array.isArray(_this3.state.directcustomertype)&&_this3.state.directcustomertype.map(function(option){return{label:option,value:option};}),value:directCustomerType,onChange:function onChange(selectedOption){_this3.setState({directCustomerType:selectedOption?selectedOption.value:''});},required:true,placeholder:'Select Direct Customer Type *'}))),customerAcquisitionType==='Direct Customer'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6,style:{zIndex:'13',marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Direct Customer Name *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["Query"],{query:GET_SAP_DETAILS,variables:{directCustomerSapCode:_this3.state.existingDirectCustomerSAPCode}},function(_ref28){var loading=_ref28.loading,error=_ref28.error,data=_ref28.data;if(loading)return'Loading...';if(error)return'Error!: '+error.message;var newCustomers=data.getSapDetails.map(function(customer){return{value:customer.customer_no,label:customer.customer_name};});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_select__["a" /* default */],{options:newCustomers,value:directCustomer,onChange:function onChange(selectedOption){_this3.setState({directCustomer:selectedOption,directCustomerSAPCode:selectedOption?selectedOption.value:'',customerNameToBeDisplayed:selectedOption?selectedOption.label:''});},required:true,placeholder:'Select Direct Customer Name *',onBlur:function onBlur(event){_this3.checkNameValidity(_this3.props.client)(event);}}));}))),customerAcquisitionType==='Direct Customer'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{zIndex:'13'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Direct Customer SAP Code'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'directCustomerSAPCode',name:'directCustomerSAPCode',className:'textfield',margin:'dense',type:'text',value:directCustomerSAPCode,onChange:_this3.handleInputChangeNew('directCustomerSAPCode'),InputProps:{readOnly:true}}))),customerAcquisitionType==='Indirect Customer'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{zIndex:'15'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Indirect Customer Type *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_select__["a" /* default */]// options={INDIRECT_CUSTOMER_TYPE_OPTIONS}
,{options:Array.isArray(_this3.state.indirectcustomertype)&&_this3.state.indirectcustomertype.map(function(option){return{label:option,value:option};}),value:indirectCustomerType,onChange:function onChange(selectedOption){_this3.setState({indirectCustomerType:selectedOption?selectedOption.value:''});},required:true,placeholder:'Select Indirect Customer Type *'}))),customerAcquisitionType==='Indirect Customer'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{zIndex:'13',marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'indirectCustomerName',name:'indirectCustomerName',className:'textfield',margin:'dense',label:'Indirect Customer Name',type:'text',value:indirectCustomerName,onChange:_this3.handleInputChangeIndirectCustomerName('indirectCustomerName'),onBlur:function onBlur(event){_this3.checkNameValidity(_this3.props.client)(event);}}))),customerAcquisitionType==='Indirect Customer'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{zIndex:'12'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Channel Partner Name *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_select__["a" /* default */],{options:_this3.state.channelPartnerSAPCodeNew&&_this3.state.channelPartnerSAPCodeNew.map(function(option){return{label:option.channel_partner_name,value:option.channel_partner_name};}),value:channelPartnerName,onChange:function onChange(selectedOption){_this3.setState({channelPartnerName:selectedOption?selectedOption.value:'',channelPartnerSAPCode:selectedOption?_this3.state.channelPartnerSAPCodeNew.find(function(customer){return customer.channel_partner_name===selectedOption.value;})?_this3.state.channelPartnerSAPCodeNew.find(function(customer){return customer.channel_partner_name===selectedOption.value;}).channel_partner_sap_code:'99999999':'',channelPartnerType:selectedOption?_this3.state.channelPartnerSAPCodeNew.find(function(customer){return customer.channel_partner_name===selectedOption.value;})?_this3.state.channelPartnerSAPCodeNew.find(function(customer){return customer.channel_partner_name===selectedOption.value;}).channel_partner_type:'N/A':''});},required:true,placeholder:'Select Channel Partner Name *'}))),customerAcquisitionType==='Indirect Customer'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{zIndex:'2',marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Channel Partner Type'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'channelPartnerType',name:'channelPartnerType',className:'textfield',margin:'dense',type:'text',value:_this3.state.channelPartnerType,onChange:_this3.handleInputChangeNew('channelPartnerType'),InputProps:{readOnly:true}}))),customerAcquisitionType==='Indirect Customer'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{zIndex:'2',marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Channel Partner SAP Code'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'channelPartnerSAPCode',name:'channelPartnerSAPCode',className:'textfield',margin:'dense',type:'text',value:_this3.state.channelPartnerSAPCode,onChange:_this3.handleInputChangeNew('channelPartnerSAPCode'),InputProps:{readOnly:true}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{style:{fontSize:'24px'}},'Location Info')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{zIndex:'7',marginTop:'-20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Customer Location *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_select__["a" /* default */],{options:Array.isArray(_this3.state.customerlocation)&&_this3.state.customerlocation.map(function(option){return{label:option,value:option};}),value:customerLocation,onChange:function onChange(selectedOption){_this3.setState({customerLocation:selectedOption?selectedOption.value:'India'});},required:true,placeholder:'Select Customer Location *'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{marginTop:'-10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Customer Address *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{name:'customerAddress',value:customerAddress,type:'text',onChange:_this3.handleInputChangeNew('customerAddress')}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6,style:{zIndex:'6',marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Country *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["Query"],{query:GET_COUNTRIES},function(_ref29){var loading=_ref29.loading,error=_ref29.error,allCountries=_ref29.data.allCountries;if(loading)return'Loading...';if(error)return'Error!: '+error;var sortedCountries=allCountries.map(function(country){return{value:country.country_id,label:country.name};});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_select__["a" /* default */],{options:sortedCountries,value:country,onChange:function onChange(selectedOption){_this3.setState({country:selectedOption?selectedOption.value:''});},required:true,placeholder:'Select Country *'}));}),' ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{marginTop:'15px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{name:'pincode',value:pincode,type:'text',onChange:_this3.handlePincodeChange,label:'Enter PIN Code *'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6,style:{zIndex:'5',marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'State *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["Query"],{query:GET_STATES_FOR_COUNTRY,variables:{countryId:Number(_this3.state.country)?_this3.state.country:99}},function(_ref30){var loading=_ref30.loading,error=_ref30.error,data=_ref30.data;if(loading)return'Loading...';if(error)return'Error!: '+error;if(data&&data.allStatesByCountryId){var sortedStates=data.allStatesByCountryId.map(function(state){return{value:state.zone_id,label:state.name};});if(sortedStates.length>0){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_select__["a" /* default */],{options:sortedStates,value:sortedStates.find(function(option){return option.value===_this3.state.state;})||null,onChange:function onChange(selectedOption){_this3.setState({state:selectedOption?selectedOption.value:''});},required:true,placeholder:'Select State *'}));}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{value:'No States in this Country',type:'text'});}}return null;}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{marginTop:'15px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{name:'city',value:city,type:'text',onChange:_this3.handleInputChangeNew('city'),label:'Enter City *'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{zIndex:'4',marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Time Zone *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_select__["a" /* default */],{options:_this3.state.timezoneList,value:timezone,onChange:_this3.handleTimezoneChange,placeholder:'Select Time Zone *'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,spacing:2,style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{zIndex:'3',marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Zone *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_select__["a" /* default */],{options:ZONE_OPTIONS,value:zone,onChange:function onChange(selectedOption){_this3.setState({zone:selectedOption?selectedOption.value:''});},placeholder:'Select Zone *'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{style:{marginRight:'20px'}},'Zonal Manager'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_select__["a" /* default */],{options:_this3.state.zonalManagers.map(function(zm){return{label:zm.username,value:zm.id};}),value:selectedZM,onChange:_this3.handleZMChange,placeholder:'Select Zonal Manager'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{marginTop:'15px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{style:{marginRight:'20px'}},'State Manager'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_select__["a" /* default */],{options:_this3.state.stateManagers.map(function(sm){return{label:sm.username,value:sm.id};}),value:_this3.state.selectedStateManager,onChange:_this3.handleStateManagerChange,placeholder:'Select State Manager'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{marginTop:'15px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{style:{marginRight:'20px'}},'Territory Manager'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_select__["a" /* default */],{options:_this3.state.territoryManagers.map(function(tm){return{label:tm.username,value:tm.id};}),value:selectedTerritoryManager,onChange:_this3.handleTerritoryManagerChange,placeholder:'Select Territory Manager'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{marginTop:'15px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{style:{marginRight:'20px'}},'Sales Head'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_select__["a" /* default */],{options:_this3.state.salesHeads.map(function(sh){return{label:sh.username,value:sh.id};}),value:selectedSalesHead,onChange:_this3.handleSalesHeadChange,placeholder:'Select Sales Head'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{marginTop:'15px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{style:{marginRight:'20px'}},'Cluster Head'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_select__["a" /* default */],{options:_this3.state.clusterHeads.map(function(ch){return{label:ch.username,value:ch.id};}),value:selectedClusterHead,onChange:_this3.handleClusterHeadChange,placeholder:'Select Cluster Head'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{marginTop:'15px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{style:{marginRight:'20px'}},'State Head'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_select__["a" /* default */],{options:_this3.state.stateHeads.map(function(sh){return{label:sh.username,value:sh.id};}),value:selectedStateHead,onChange:_this3.handleStateHeadChange,placeholder:'Select State Head'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{marginTop:'15px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{style:{marginRight:'20px'}},'City Manager'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_select__["a" /* default */],{options:_this3.state.cityManagers.map(function(cm){return{label:cm.username,value:cm.id};}),value:selectedCityManager,onChange:_this3.handleCityManagerChange,placeholder:'Select City Manager'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{marginTop:'15px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{style:{marginRight:'20px'}},'Operations Manager'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_select__["a" /* default */],{options:_this3.state.operationsManagers.map(function(om){return{label:om.username,value:om.id};}),value:selectedOperationsManager,onChange:_this3.handleOperationsManagerChange,placeholder:'Select Operations Manager'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{marginTop:'15px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{style:{marginRight:'20px'}},'Key Account Manager'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_select__["a" /* default */],{options:_this3.state.keyAccountManagers.map(function(kam){return{label:kam.username,value:kam.id};}),value:selectedKAM,onChange:_this3.handleKAMChange,placeholder:'Select Key Account Manager'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{marginTop:'15px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{style:{marginRight:'20px'}},'Service Manager'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_select__["a" /* default */],{options:_this3.state.serviceManagers.map(function(sm){return{label:sm.username,value:sm.id};}),value:serviceManager,onChange:_this3.handleSMChange,placeholder:'Select Service Manager'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{marginTop:'15px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{style:{marginRight:'20px'}},'Customer Success Manager'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_select__["a" /* default */],{options:_this3.state.customerSuccessManagers.map(function(csm){return{label:csm.username,value:csm.id};}),value:customerSuccessManager,onChange:_this3.handleCSMChange,placeholder:'Select Customer Success Manager'})))),Object(__WEBPACK_IMPORTED_MODULE_15__utils_getLoginId__["a" /* default */])()===2&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_select__["a" /* default */],{options:allSalesPerson,value:salesPerson,onChange:_this3.handleSalesPersonChange,placeholder:'Select Sales Person*'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{name:'username',value:username,type:'text',onChange:_this3.handleInputChangeUsernamePassword,required:true,error:!_this3.state.isUsernameValid,onBlur:_this3.checkUsernameValidity(_this3.props.client),label:'User Name'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!_this3.state.isUsernameValid?_this3.state.usernameRes:''))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{name:'password',value:'password',type:'password',onChange:_this3.handleInputChangeUsernamePassword,label:'Password',error:!_this3.state.isPasswordValid,onBlur:_this3.checkPasswordValidity// required
,disabled:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this3.state.isPasswordValid?'':'Password should contain 3-20 charcter or digit without space'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Customer Name to be displayed on Portal *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{name:'customerNameToBeDisplayed',value:customerAcquisitionType==='Direct Customer'?customerNameToBeDisplayed||(_this3.state.directCustomer?directCustomer.label:''):customerAcquisitionType==='Indirect Customer'?customerNameToBeDisplayed||indirectCustomerName:customerNameToBeDisplayed||'',type:'text',onChange:_this3.handleInputChangeNew('customerNameToBeDisplayed'),error:!_this3.state.isNameValid,onBlur:function onBlur(event){_this3.checkNameValidity(_this3.props.client)(event);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this3.state.clientNameRes))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Customer Potential *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{name:'totalPotentialVehicles',value:_this3.state.totalPotentialVehicles,type:'number',onChange:_this3.handleInputChangeNew('totalPotentialVehicles'),inputProps:{name:'totalPotentialVehicles',min:1,step:1}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{style:{fontSize:'24px'}},'Contact Info')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__material_ui_core_InputLabel___default.a,{htmlFor:'contactPerson',style:{marginTop:'-10px'},shrink:contactPerson},'Primary Contact Person Name *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{name:'contactPerson',value:contactPerson,type:'text',onChange:_this3.handleInputChangeNew('primaryContactPersonName'),required:true,error:!_this3.state.isContactpValid1,onBlur:_this3.checkContactpValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this3.state.isContactpValid1?'':'Only Alphabets allowed, between 3 to 32 characters'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__material_ui_core_InputLabel___default.a,{htmlFor:'contactPerson',style:{marginTop:'-10px'},shrink:contactPerson},'Primary Mobile Number *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{name:'contactNumber',value:_this3.state.contactNumber,type:'text',onChange:_this3.handleInputChangeNew('primaryContactPersonMobileNumber'),required:true,error:!_this3.state.isPhonenoValid1,onBlur:_this3.checkPhonenoValidity1(_this3.props.client)}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this3.state.isPhonenoValid1?'':'Invalid Phone Number ',_this3.state.isPhoneExists?'':'Phone Number Already Exists '))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{name:'landlineNumber',value:landlineNumber,type:'text',onChange:_this3.handleInputChangeNew('primaryContactPersonLandlineNumber'),label:'Landline Number',onBlur:function onBlur(event){return _this3.checkLandlineValidity(event,'landlineNumber');},error:_this3.state.landlineNumberError}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_FormHelperText___default.a,{id:'landline-error-text',className:'Error_msg',error:_this3.state.landlineNumberError},_this3.state.landlineNumberError))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{name:'email',value:email,type:'email',onChange:_this3.handleInputChangeNew('primaryContactPersonEmail'),label:'Primary Email',required:true,error:!_this3.state.isEmailValid1,onBlur:_this3.checkEmailValidity1(_this3.props.client)}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this3.state.isEmailExists?'':'Email Id already exist ',_this3.state.isEmailValid1?' ':'Invalid Email '))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:12,display:'flex'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["Checkbox"],{name:'isSecondaryContact',value:isSecondaryContact,checked:isSecondaryContact,onClick:_this3.handleSecondaryContactAvailable}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{fontSize:'15px'}},'Secondary Contact Details Available?')),isSecondaryContact&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{name:'secondaryContactName',value:secondaryContactName,type:'text',onChange:_this3.handleInputChangeNew('secondaryContactPersonName'),label:'Secondary Contact Person Name *',error:!_this3.state.isContactpValid2,onBlur:_this3.checkContactpValidityTwo}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this3.state.isContactpValid2?'':'Only Alphabets allowed, between 3 to 32 characters'))),isSecondaryContact&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{name:'secondaryContactNumber',value:secondaryContactNumber,type:'text',onChange:_this3.handleInputChangeNew('secondaryContactPersonPhoneNumber'),label:'Secondary Phone Number *',error:!_this3.state.isPhonenoValid2,onBlur:_this3.checkPhonenoValidity2(_this3.props.client)}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this3.state.isPhonenoValid2?'':// : 'Invalid phone Number'}
_this3.state.phonenoRes2))),isSecondaryContact&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{name:'secondaryLandlineNumber',value:secondaryLandlineNumber,type:'text',onChange:_this3.handleInputChangeNew('secondaryContactPersonLandlineNumber'),label:'Landline Number',onBlur:function onBlur(event){return _this3.checkLandlineValidity(event,'secondaryLandlineNumber');},error:!_this3.state.isSecondaryLandlineNumberValid}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_FormHelperText___default.a,{id:'landline-error-text',className:'Error_msg',error:_this3.state.secondaryLandlineNumberError},_this3.state.secondaryLandlineNumberError))),isSecondaryContact&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{name:'secondaryEmail',value:secondaryEmail,type:'email',onChange:_this3.handleInputChangeNew('secondaryContactPersonEmail'),label:'Secondary Email *',error:!_this3.state.isEmailValid2,onBlur:_this3.checkEmailValidity2(_this3.props.client)}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this3.state.isEmailValid2?'':// : 'Invalid Email'}
_this3.state.emailRes2))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:12,display:'flex'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["Checkbox"],{name:'isAdditionalContact',value:_this3.state.isAdditionalContact,checked:_this3.state.isAdditionalContact,onClick:_this3.handleAdditionalContactAvailable}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{fontSize:'15px'}},'Additional Contact Details Available?')),_this3.state.isAdditionalContact&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{name:'additionalContactNumbers',label:'Additional Contact Numbers (comma separated) *',value:_this3.state.additionalContactNumbers,onChange:_this3.handleAdditionalContactChange,onBlur:_this3.checkAdditionalContactValidity,fullWidth:true,error:!_this3.state.isAdditionalContactValid,helperText:_this3.state.additionalContactError}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Mode *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_select__["a" /* default */],{options:Array.isArray(_this3.state.mode)&&_this3.state.mode.map(function(option){return{label:option,value:option};}),value:selectedMode,onChange:_this3.handleModeChange,placeholder:'Select Mode *'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Video Telematics Plan *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_select__["a" /* default */],{options:Array.isArray(_this3.state.videotelematicsplan)&&_this3.state.videotelematicsplan.map(function(option){return{label:option,value:option==='API-Loconav'?'loconav':option==='API-Meta'?'mettax':option==='iFrame-LM'?'lightMetrics':option==='None'?'none':option.toLowerCase()};}),value:selectedVTM||'none',onChange:_this3.handleVideoTelematicsMenuChange,placeholder:'Select Video Telematics Plan *',menuStyle:{height:'120px'}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Service Type *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_select__["a" /* default */],{options:Array.isArray(_this3.state.servicetype)&&_this3.state.servicetype.map(function(option){return{label:option,value:option.toLowerCase()};}),value:selectedServiceType,onChange:_this3.handleServiceTypeChange,placeholder:'Select Service Type *',menuStyle:{height:'120px'}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:12,display:'flex'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core__["Checkbox"],{name:'is_sim_tracking',value:_this3.state.is_sim_tracking,checked:_this3.state.is_sim_tracking,onClick:_this3.handleSimTracking}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{fontSize:'15px'}},'SIM tracking enabled?')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6,style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Client Category *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_select__["a" /* default */],{options:clientCategoryOptions,value:clientCategoryOptions.find(function(option){return option.value===clientCategory;}),onChange:function onChange(selectedOption){_this3.setState({clientCategory:selectedOption.value});},placeholder:'Select Client Category *'}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_core_CardActions___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Button___default.a,{color:'secondary',variant:'contained',onClick:_this3.handleSaveClick,disabled:_this3.isSaveFormInvalid()},'Save'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Button___default.a,{color:'secondary',onClick:_this3.handleCancelClick},'Cancel'))))));}));}}]);return EditCustomer;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);EditCustomer.propTypes={classes:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_16__HOCs_withSharedSnackbar__["a" /* default */])(EditCustomer))));

/***/ }),
/* 1128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function functionTakeAndGiveVideoTeleValue(input){if(input=="API-Loconav"){return"loconav";}else if(input=="API-Meta"){return"mettax";}else if(input=="iFrame-LM"){return"lightMetrics";}else{return null;}}/* unused harmony default export */ var _unused_webpack_default_export = (functionTakeAndGiveVideoTeleValue);

/***/ }),
/* 1129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AccessAlarm__ = __webpack_require__(1130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AccessAlarm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__AccessAlarm__);
/* unused harmony reexport AccessAlarm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AccessAlarms__ = __webpack_require__(1131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AccessAlarms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__AccessAlarms__);
/* unused harmony reexport AccessAlarms */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Accessibility__ = __webpack_require__(1132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Accessibility___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Accessibility__);
/* unused harmony reexport Accessibility */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Accessible__ = __webpack_require__(1133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Accessible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Accessible__);
/* unused harmony reexport Accessible */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AccessTime__ = __webpack_require__(1134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AccessTime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__AccessTime__);
/* unused harmony reexport AccessTime */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AccountBalance__ = __webpack_require__(1135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AccountBalance___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__AccountBalance__);
/* unused harmony reexport AccountBalance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AccountBalanceWallet__ = __webpack_require__(1136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AccountBalanceWallet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__AccountBalanceWallet__);
/* unused harmony reexport AccountBalanceWallet */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AccountBox__ = __webpack_require__(1137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AccountBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__AccountBox__);
/* unused harmony reexport AccountBox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AccountCircle__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AccountCircle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__AccountCircle__);
/* unused harmony reexport AccountCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AcUnit__ = __webpack_require__(1138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AcUnit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__AcUnit__);
/* unused harmony reexport AcUnit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Adb__ = __webpack_require__(1139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Adb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Adb__);
/* unused harmony reexport Adb */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Add__ = __webpack_require__(1140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Add___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__Add__);
/* unused harmony reexport Add */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AddAlarm__ = __webpack_require__(1141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AddAlarm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__AddAlarm__);
/* unused harmony reexport AddAlarm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AddAlert__ = __webpack_require__(1142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AddAlert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__AddAlert__);
/* unused harmony reexport AddAlert */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__AddAPhoto__ = __webpack_require__(1143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__AddAPhoto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__AddAPhoto__);
/* unused harmony reexport AddAPhoto */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__AddBox__ = __webpack_require__(1144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__AddBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__AddBox__);
/* unused harmony reexport AddBox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__AddCircle__ = __webpack_require__(1145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__AddCircle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__AddCircle__);
/* unused harmony reexport AddCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__AddCircleOutline__ = __webpack_require__(1146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__AddCircleOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__AddCircleOutline__);
/* unused harmony reexport AddCircleOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__AddLocation__ = __webpack_require__(1147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__AddLocation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__AddLocation__);
/* unused harmony reexport AddLocation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__AddShoppingCart__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__AddShoppingCart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__AddShoppingCart__);
/* unused harmony reexport AddShoppingCart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__AddToPhotos__ = __webpack_require__(1148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__AddToPhotos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__AddToPhotos__);
/* unused harmony reexport AddToPhotos */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__AddToQueue__ = __webpack_require__(1149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__AddToQueue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__AddToQueue__);
/* unused harmony reexport AddToQueue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Adjust__ = __webpack_require__(1150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Adjust___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__Adjust__);
/* unused harmony reexport Adjust */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__AirlineSeatFlat__ = __webpack_require__(1151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__AirlineSeatFlat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__AirlineSeatFlat__);
/* unused harmony reexport AirlineSeatFlat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__AirlineSeatFlatAngled__ = __webpack_require__(1152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__AirlineSeatFlatAngled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__AirlineSeatFlatAngled__);
/* unused harmony reexport AirlineSeatFlatAngled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__AirlineSeatIndividualSuite__ = __webpack_require__(1153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__AirlineSeatIndividualSuite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__AirlineSeatIndividualSuite__);
/* unused harmony reexport AirlineSeatIndividualSuite */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__AirlineSeatLegroomExtra__ = __webpack_require__(1154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__AirlineSeatLegroomExtra___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__AirlineSeatLegroomExtra__);
/* unused harmony reexport AirlineSeatLegroomExtra */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__AirlineSeatLegroomNormal__ = __webpack_require__(1155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__AirlineSeatLegroomNormal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__AirlineSeatLegroomNormal__);
/* unused harmony reexport AirlineSeatLegroomNormal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__AirlineSeatLegroomReduced__ = __webpack_require__(1156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__AirlineSeatLegroomReduced___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__AirlineSeatLegroomReduced__);
/* unused harmony reexport AirlineSeatLegroomReduced */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__AirlineSeatReclineExtra__ = __webpack_require__(1157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__AirlineSeatReclineExtra___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__AirlineSeatReclineExtra__);
/* unused harmony reexport AirlineSeatReclineExtra */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__AirlineSeatReclineNormal__ = __webpack_require__(1158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__AirlineSeatReclineNormal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__AirlineSeatReclineNormal__);
/* unused harmony reexport AirlineSeatReclineNormal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__AirplanemodeActive__ = __webpack_require__(1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__AirplanemodeActive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__AirplanemodeActive__);
/* unused harmony reexport AirplanemodeActive */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__AirplanemodeInactive__ = __webpack_require__(1160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__AirplanemodeInactive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__AirplanemodeInactive__);
/* unused harmony reexport AirplanemodeInactive */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Airplay__ = __webpack_require__(1161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Airplay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__Airplay__);
/* unused harmony reexport Airplay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__AirportShuttle__ = __webpack_require__(1162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__AirportShuttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__AirportShuttle__);
/* unused harmony reexport AirportShuttle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__Alarm__ = __webpack_require__(1163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__Alarm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__Alarm__);
/* unused harmony reexport Alarm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__AlarmAdd__ = __webpack_require__(1164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__AlarmAdd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__AlarmAdd__);
/* unused harmony reexport AlarmAdd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__AlarmOff__ = __webpack_require__(1165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__AlarmOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__AlarmOff__);
/* unused harmony reexport AlarmOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__AlarmOn__ = __webpack_require__(1166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__AlarmOn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__AlarmOn__);
/* unused harmony reexport AlarmOn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__Album__ = __webpack_require__(1167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__Album___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__Album__);
/* unused harmony reexport Album */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__AllInclusive__ = __webpack_require__(1168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__AllInclusive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__AllInclusive__);
/* unused harmony reexport AllInclusive */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__AllOut__ = __webpack_require__(1169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__AllOut___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__AllOut__);
/* unused harmony reexport AllOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__Android__ = __webpack_require__(1170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__Android___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__Android__);
/* unused harmony reexport Android */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__Announcement__ = __webpack_require__(1171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__Announcement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__Announcement__);
/* unused harmony reexport Announcement */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__Apps__ = __webpack_require__(1172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__Apps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__Apps__);
/* unused harmony reexport Apps */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__Archive__ = __webpack_require__(1173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__Archive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__Archive__);
/* unused harmony reexport Archive */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__ArrowBack__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__ArrowBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__ArrowBack__);
/* unused harmony reexport ArrowBack */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__ArrowDownward__ = __webpack_require__(1174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__ArrowDownward___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__ArrowDownward__);
/* unused harmony reexport ArrowDownward */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__ArrowDropDown__ = __webpack_require__(1175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__ArrowDropDown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__ArrowDropDown__);
/* unused harmony reexport ArrowDropDown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__ArrowDropDownCircle__ = __webpack_require__(1176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__ArrowDropDownCircle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__ArrowDropDownCircle__);
/* unused harmony reexport ArrowDropDownCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__ArrowDropUp__ = __webpack_require__(1177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__ArrowDropUp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__ArrowDropUp__);
/* unused harmony reexport ArrowDropUp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__ArrowForward__ = __webpack_require__(1178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__ArrowForward___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__ArrowForward__);
/* unused harmony reexport ArrowForward */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__ArrowUpward__ = __webpack_require__(1179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__ArrowUpward___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__ArrowUpward__);
/* unused harmony reexport ArrowUpward */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__ArtTrack__ = __webpack_require__(1180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__ArtTrack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__ArtTrack__);
/* unused harmony reexport ArtTrack */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__AspectRatio__ = __webpack_require__(1181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__AspectRatio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__AspectRatio__);
/* unused harmony reexport AspectRatio */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__Assessment__ = __webpack_require__(1182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__Assessment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__Assessment__);
/* unused harmony reexport Assessment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__Assignment__ = __webpack_require__(1183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__Assignment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__Assignment__);
/* unused harmony reexport Assignment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__AssignmentInd__ = __webpack_require__(1184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__AssignmentInd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__AssignmentInd__);
/* unused harmony reexport AssignmentInd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__AssignmentLate__ = __webpack_require__(1185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__AssignmentLate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__AssignmentLate__);
/* unused harmony reexport AssignmentLate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__AssignmentReturn__ = __webpack_require__(1186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__AssignmentReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__AssignmentReturn__);
/* unused harmony reexport AssignmentReturn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__AssignmentReturned__ = __webpack_require__(1187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__AssignmentReturned___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60__AssignmentReturned__);
/* unused harmony reexport AssignmentReturned */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__AssignmentTurnedIn__ = __webpack_require__(1188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__AssignmentTurnedIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61__AssignmentTurnedIn__);
/* unused harmony reexport AssignmentTurnedIn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__Assistant__ = __webpack_require__(1189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__Assistant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62__Assistant__);
/* unused harmony reexport Assistant */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__AssistantPhoto__ = __webpack_require__(1190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__AssistantPhoto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63__AssistantPhoto__);
/* unused harmony reexport AssistantPhoto */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__AttachFile__ = __webpack_require__(1191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__AttachFile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64__AttachFile__);
/* unused harmony reexport AttachFile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__Attachment__ = __webpack_require__(1192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__Attachment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65__Attachment__);
/* unused harmony reexport Attachment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__AttachMoney__ = __webpack_require__(1193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__AttachMoney___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66__AttachMoney__);
/* unused harmony reexport AttachMoney */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__Audiotrack__ = __webpack_require__(1194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__Audiotrack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67__Audiotrack__);
/* unused harmony reexport Audiotrack */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__Autorenew__ = __webpack_require__(1195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__Autorenew___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68__Autorenew__);
/* unused harmony reexport Autorenew */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__AvTimer__ = __webpack_require__(1196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__AvTimer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69__AvTimer__);
/* unused harmony reexport AvTimer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__Backspace__ = __webpack_require__(1197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__Backspace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70__Backspace__);
/* unused harmony reexport Backspace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__Backup__ = __webpack_require__(1198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__Backup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71__Backup__);
/* unused harmony reexport Backup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__Battery20__ = __webpack_require__(1199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__Battery20___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72__Battery20__);
/* unused harmony reexport Battery20 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__Battery30__ = __webpack_require__(1200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__Battery30___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73__Battery30__);
/* unused harmony reexport Battery30 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__Battery50__ = __webpack_require__(1201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__Battery50___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74__Battery50__);
/* unused harmony reexport Battery50 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__Battery60__ = __webpack_require__(1202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__Battery60___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75__Battery60__);
/* unused harmony reexport Battery60 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__Battery80__ = __webpack_require__(1203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__Battery80___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76__Battery80__);
/* unused harmony reexport Battery80 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__Battery90__ = __webpack_require__(1204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__Battery90___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77__Battery90__);
/* unused harmony reexport Battery90 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__BatteryAlert__ = __webpack_require__(1205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__BatteryAlert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78__BatteryAlert__);
/* unused harmony reexport BatteryAlert */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__BatteryCharging20__ = __webpack_require__(1206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__BatteryCharging20___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79__BatteryCharging20__);
/* unused harmony reexport BatteryCharging20 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__BatteryCharging30__ = __webpack_require__(1207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__BatteryCharging30___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80__BatteryCharging30__);
/* unused harmony reexport BatteryCharging30 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__BatteryCharging50__ = __webpack_require__(1208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__BatteryCharging50___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81__BatteryCharging50__);
/* unused harmony reexport BatteryCharging50 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__BatteryCharging60__ = __webpack_require__(1209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__BatteryCharging60___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82__BatteryCharging60__);
/* unused harmony reexport BatteryCharging60 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__BatteryCharging80__ = __webpack_require__(1210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__BatteryCharging80___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83__BatteryCharging80__);
/* unused harmony reexport BatteryCharging80 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__BatteryCharging90__ = __webpack_require__(1211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__BatteryCharging90___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_84__BatteryCharging90__);
/* unused harmony reexport BatteryCharging90 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__BatteryChargingFull__ = __webpack_require__(1212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__BatteryChargingFull___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_85__BatteryChargingFull__);
/* unused harmony reexport BatteryChargingFull */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__BatteryFull__ = __webpack_require__(1213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__BatteryFull___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_86__BatteryFull__);
/* unused harmony reexport BatteryFull */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__BatteryStd__ = __webpack_require__(1214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__BatteryStd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_87__BatteryStd__);
/* unused harmony reexport BatteryStd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__BatteryUnknown__ = __webpack_require__(1215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__BatteryUnknown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_88__BatteryUnknown__);
/* unused harmony reexport BatteryUnknown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__BeachAccess__ = __webpack_require__(1216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__BeachAccess___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_89__BeachAccess__);
/* unused harmony reexport BeachAccess */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__Beenhere__ = __webpack_require__(1217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__Beenhere___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_90__Beenhere__);
/* unused harmony reexport Beenhere */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__Block__ = __webpack_require__(1218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__Block___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_91__Block__);
/* unused harmony reexport Block */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__Bluetooth__ = __webpack_require__(1219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__Bluetooth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_92__Bluetooth__);
/* unused harmony reexport Bluetooth */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__BluetoothAudio__ = __webpack_require__(1220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__BluetoothAudio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_93__BluetoothAudio__);
/* unused harmony reexport BluetoothAudio */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__BluetoothConnected__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__BluetoothConnected___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_94__BluetoothConnected__);
/* unused harmony reexport BluetoothConnected */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__BluetoothDisabled__ = __webpack_require__(1222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__BluetoothDisabled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_95__BluetoothDisabled__);
/* unused harmony reexport BluetoothDisabled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__BluetoothSearching__ = __webpack_require__(1223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__BluetoothSearching___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_96__BluetoothSearching__);
/* unused harmony reexport BluetoothSearching */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__BlurCircular__ = __webpack_require__(1224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__BlurCircular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_97__BlurCircular__);
/* unused harmony reexport BlurCircular */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__BlurLinear__ = __webpack_require__(1225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__BlurLinear___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_98__BlurLinear__);
/* unused harmony reexport BlurLinear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__BlurOff__ = __webpack_require__(1226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__BlurOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_99__BlurOff__);
/* unused harmony reexport BlurOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__BlurOn__ = __webpack_require__(1227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__BlurOn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_100__BlurOn__);
/* unused harmony reexport BlurOn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__Book__ = __webpack_require__(1228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__Book___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_101__Book__);
/* unused harmony reexport Book */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__Bookmark__ = __webpack_require__(1229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__Bookmark___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_102__Bookmark__);
/* unused harmony reexport Bookmark */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__BookmarkBorder__ = __webpack_require__(1230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__BookmarkBorder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_103__BookmarkBorder__);
/* unused harmony reexport BookmarkBorder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__BorderAll__ = __webpack_require__(1231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__BorderAll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_104__BorderAll__);
/* unused harmony reexport BorderAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__BorderBottom__ = __webpack_require__(1232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__BorderBottom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_105__BorderBottom__);
/* unused harmony reexport BorderBottom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__BorderClear__ = __webpack_require__(1233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__BorderClear___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_106__BorderClear__);
/* unused harmony reexport BorderClear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__BorderColor__ = __webpack_require__(1234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__BorderColor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_107__BorderColor__);
/* unused harmony reexport BorderColor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__BorderHorizontal__ = __webpack_require__(1235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__BorderHorizontal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_108__BorderHorizontal__);
/* unused harmony reexport BorderHorizontal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__BorderInner__ = __webpack_require__(1236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__BorderInner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_109__BorderInner__);
/* unused harmony reexport BorderInner */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__BorderLeft__ = __webpack_require__(1237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__BorderLeft___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_110__BorderLeft__);
/* unused harmony reexport BorderLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__BorderOuter__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__BorderOuter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_111__BorderOuter__);
/* unused harmony reexport BorderOuter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__BorderRight__ = __webpack_require__(1239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__BorderRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_112__BorderRight__);
/* unused harmony reexport BorderRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__BorderStyle__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__BorderStyle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_113__BorderStyle__);
/* unused harmony reexport BorderStyle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__BorderTop__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__BorderTop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_114__BorderTop__);
/* unused harmony reexport BorderTop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__BorderVertical__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__BorderVertical___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_115__BorderVertical__);
/* unused harmony reexport BorderVertical */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__BrandingWatermark__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__BrandingWatermark___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_116__BrandingWatermark__);
/* unused harmony reexport BrandingWatermark */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__Brightness1__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__Brightness1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_117__Brightness1__);
/* unused harmony reexport Brightness1 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__Brightness2__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__Brightness2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_118__Brightness2__);
/* unused harmony reexport Brightness2 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__Brightness3__ = __webpack_require__(1246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__Brightness3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_119__Brightness3__);
/* unused harmony reexport Brightness3 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__Brightness4__ = __webpack_require__(1247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__Brightness4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_120__Brightness4__);
/* unused harmony reexport Brightness4 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__Brightness5__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__Brightness5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_121__Brightness5__);
/* unused harmony reexport Brightness5 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__Brightness6__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__Brightness6___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_122__Brightness6__);
/* unused harmony reexport Brightness6 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__Brightness7__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__Brightness7___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_123__Brightness7__);
/* unused harmony reexport Brightness7 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__BrightnessAuto__ = __webpack_require__(1251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__BrightnessAuto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_124__BrightnessAuto__);
/* unused harmony reexport BrightnessAuto */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__BrightnessHigh__ = __webpack_require__(1252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__BrightnessHigh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_125__BrightnessHigh__);
/* unused harmony reexport BrightnessHigh */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__BrightnessLow__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__BrightnessLow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_126__BrightnessLow__);
/* unused harmony reexport BrightnessLow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__BrightnessMedium__ = __webpack_require__(1254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__BrightnessMedium___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_127__BrightnessMedium__);
/* unused harmony reexport BrightnessMedium */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__BrokenImage__ = __webpack_require__(1255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__BrokenImage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_128__BrokenImage__);
/* unused harmony reexport BrokenImage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__Brush__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__Brush___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_129__Brush__);
/* unused harmony reexport Brush */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__BubbleChart__ = __webpack_require__(1257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__BubbleChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_130__BubbleChart__);
/* unused harmony reexport BubbleChart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__BugReport__ = __webpack_require__(1258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__BugReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_131__BugReport__);
/* unused harmony reexport BugReport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__Build__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__Build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_132__Build__);
/* unused harmony reexport Build */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__BurstMode__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__BurstMode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_133__BurstMode__);
/* unused harmony reexport BurstMode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__Business__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__Business___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_134__Business__);
/* unused harmony reexport Business */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__BusinessCenter__ = __webpack_require__(1260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__BusinessCenter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_135__BusinessCenter__);
/* unused harmony reexport BusinessCenter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__Cached__ = __webpack_require__(1261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__Cached___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_136__Cached__);
/* unused harmony reexport Cached */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__Cake__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__Cake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_137__Cake__);
/* unused harmony reexport Cake */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__Call__ = __webpack_require__(1263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__Call___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_138__Call__);
/* unused harmony reexport Call */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__CallEnd__ = __webpack_require__(1264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__CallEnd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_139__CallEnd__);
/* unused harmony reexport CallEnd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__CallMade__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__CallMade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_140__CallMade__);
/* unused harmony reexport CallMade */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141__CallMerge__ = __webpack_require__(1266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141__CallMerge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_141__CallMerge__);
/* unused harmony reexport CallMerge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142__CallMissed__ = __webpack_require__(1267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142__CallMissed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_142__CallMissed__);
/* unused harmony reexport CallMissed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143__CallMissedOutgoing__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143__CallMissedOutgoing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_143__CallMissedOutgoing__);
/* unused harmony reexport CallMissedOutgoing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144__CallReceived__ = __webpack_require__(1269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144__CallReceived___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_144__CallReceived__);
/* unused harmony reexport CallReceived */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_145__CallSplit__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_145__CallSplit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_145__CallSplit__);
/* unused harmony reexport CallSplit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_146__CallToAction__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_146__CallToAction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_146__CallToAction__);
/* unused harmony reexport CallToAction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_147__Camera__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_147__Camera___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_147__Camera__);
/* unused harmony reexport Camera */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_148__CameraAlt__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_148__CameraAlt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_148__CameraAlt__);
/* unused harmony reexport CameraAlt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_149__CameraEnhance__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_149__CameraEnhance___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_149__CameraEnhance__);
/* unused harmony reexport CameraEnhance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_150__CameraFront__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_150__CameraFront___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_150__CameraFront__);
/* unused harmony reexport CameraFront */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_151__CameraRear__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_151__CameraRear___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_151__CameraRear__);
/* unused harmony reexport CameraRear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_152__CameraRoll__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_152__CameraRoll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_152__CameraRoll__);
/* unused harmony reexport CameraRoll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_153__Cancel__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_153__Cancel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_153__Cancel__);
/* unused harmony reexport Cancel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_154__CardGiftcard__ = __webpack_require__(1279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_154__CardGiftcard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_154__CardGiftcard__);
/* unused harmony reexport CardGiftcard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_155__CardMembership__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_155__CardMembership___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_155__CardMembership__);
/* unused harmony reexport CardMembership */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_156__CardTravel__ = __webpack_require__(1281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_156__CardTravel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_156__CardTravel__);
/* unused harmony reexport CardTravel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_157__Casino__ = __webpack_require__(1282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_157__Casino___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_157__Casino__);
/* unused harmony reexport Casino */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_158__Cast__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_158__Cast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_158__Cast__);
/* unused harmony reexport Cast */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_159__CastConnected__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_159__CastConnected___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_159__CastConnected__);
/* unused harmony reexport CastConnected */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_160__CenterFocusStrong__ = __webpack_require__(1285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_160__CenterFocusStrong___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_160__CenterFocusStrong__);
/* unused harmony reexport CenterFocusStrong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_161__CenterFocusWeak__ = __webpack_require__(1286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_161__CenterFocusWeak___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_161__CenterFocusWeak__);
/* unused harmony reexport CenterFocusWeak */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_162__ChangeHistory__ = __webpack_require__(1287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_162__ChangeHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_162__ChangeHistory__);
/* unused harmony reexport ChangeHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_163__Chat__ = __webpack_require__(1288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_163__Chat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_163__Chat__);
/* unused harmony reexport Chat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_164__ChatBubble__ = __webpack_require__(1289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_164__ChatBubble___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_164__ChatBubble__);
/* unused harmony reexport ChatBubble */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_165__ChatBubbleOutline__ = __webpack_require__(1290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_165__ChatBubbleOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_165__ChatBubbleOutline__);
/* unused harmony reexport ChatBubbleOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_166__Check__ = __webpack_require__(1291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_166__Check___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_166__Check__);
/* unused harmony reexport Check */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_167__CheckBox__ = __webpack_require__(1292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_167__CheckBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_167__CheckBox__);
/* unused harmony reexport CheckBox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_168__CheckBoxOutlineBlank__ = __webpack_require__(1293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_168__CheckBoxOutlineBlank___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_168__CheckBoxOutlineBlank__);
/* unused harmony reexport CheckBoxOutlineBlank */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_169__CheckCircle__ = __webpack_require__(1294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_169__CheckCircle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_169__CheckCircle__);
/* unused harmony reexport CheckCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_170__ChevronLeft__ = __webpack_require__(1295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_170__ChevronLeft___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_170__ChevronLeft__);
/* unused harmony reexport ChevronLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_171__ChevronRight__ = __webpack_require__(1296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_171__ChevronRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_171__ChevronRight__);
/* unused harmony reexport ChevronRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_172__ChildCare__ = __webpack_require__(1297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_172__ChildCare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_172__ChildCare__);
/* unused harmony reexport ChildCare */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_173__ChildFriendly__ = __webpack_require__(1298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_173__ChildFriendly___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_173__ChildFriendly__);
/* unused harmony reexport ChildFriendly */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_174__ChromeReaderMode__ = __webpack_require__(1299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_174__ChromeReaderMode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_174__ChromeReaderMode__);
/* unused harmony reexport ChromeReaderMode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_175__Class__ = __webpack_require__(1300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_175__Class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_175__Class__);
/* unused harmony reexport Class */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_176__Clear__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_176__Clear___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_176__Clear__);
/* unused harmony reexport Clear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_177__ClearAll__ = __webpack_require__(1301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_177__ClearAll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_177__ClearAll__);
/* unused harmony reexport ClearAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_178__Close__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_178__Close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_178__Close__);
/* unused harmony reexport Close */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_179__ClosedCaption__ = __webpack_require__(1302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_179__ClosedCaption___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_179__ClosedCaption__);
/* unused harmony reexport ClosedCaption */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_180__Cloud__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_180__Cloud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_180__Cloud__);
/* unused harmony reexport Cloud */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_181__CloudCircle__ = __webpack_require__(1304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_181__CloudCircle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_181__CloudCircle__);
/* unused harmony reexport CloudCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_182__CloudDone__ = __webpack_require__(1305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_182__CloudDone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_182__CloudDone__);
/* unused harmony reexport CloudDone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_183__CloudDownload__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_183__CloudDownload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_183__CloudDownload__);
/* unused harmony reexport CloudDownload */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_184__CloudOff__ = __webpack_require__(1306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_184__CloudOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_184__CloudOff__);
/* unused harmony reexport CloudOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_185__CloudQueue__ = __webpack_require__(1307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_185__CloudQueue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_185__CloudQueue__);
/* unused harmony reexport CloudQueue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_186__CloudUpload__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_186__CloudUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_186__CloudUpload__);
/* unused harmony reexport CloudUpload */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_187__Code__ = __webpack_require__(1308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_187__Code___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_187__Code__);
/* unused harmony reexport Code */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_188__Collections__ = __webpack_require__(1309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_188__Collections___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_188__Collections__);
/* unused harmony reexport Collections */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_189__CollectionsBookmark__ = __webpack_require__(1310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_189__CollectionsBookmark___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_189__CollectionsBookmark__);
/* unused harmony reexport CollectionsBookmark */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_190__Colorize__ = __webpack_require__(1311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_190__Colorize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_190__Colorize__);
/* unused harmony reexport Colorize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_191__ColorLens__ = __webpack_require__(1312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_191__ColorLens___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_191__ColorLens__);
/* unused harmony reexport ColorLens */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_192__Comment__ = __webpack_require__(1313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_192__Comment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_192__Comment__);
/* unused harmony reexport Comment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_193__Compare__ = __webpack_require__(1314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_193__Compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_193__Compare__);
/* unused harmony reexport Compare */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_194__CompareArrows__ = __webpack_require__(1315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_194__CompareArrows___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_194__CompareArrows__);
/* unused harmony reexport CompareArrows */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_195__Computer__ = __webpack_require__(1316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_195__Computer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_195__Computer__);
/* unused harmony reexport Computer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_196__ConfirmationNumber__ = __webpack_require__(1317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_196__ConfirmationNumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_196__ConfirmationNumber__);
/* unused harmony reexport ConfirmationNumber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_197__ContactMail__ = __webpack_require__(1318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_197__ContactMail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_197__ContactMail__);
/* unused harmony reexport ContactMail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_198__ContactPhone__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_198__ContactPhone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_198__ContactPhone__);
/* unused harmony reexport ContactPhone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_199__Contacts__ = __webpack_require__(1319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_199__Contacts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_199__Contacts__);
/* unused harmony reexport Contacts */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_200__ContentCopy__ = __webpack_require__(1320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_200__ContentCopy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_200__ContentCopy__);
/* unused harmony reexport ContentCopy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_201__ContentCut__ = __webpack_require__(1321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_201__ContentCut___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_201__ContentCut__);
/* unused harmony reexport ContentCut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_202__ContentPaste__ = __webpack_require__(1322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_202__ContentPaste___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_202__ContentPaste__);
/* unused harmony reexport ContentPaste */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_203__ControlPoint__ = __webpack_require__(1323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_203__ControlPoint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_203__ControlPoint__);
/* unused harmony reexport ControlPoint */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_204__ControlPointDuplicate__ = __webpack_require__(1324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_204__ControlPointDuplicate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_204__ControlPointDuplicate__);
/* unused harmony reexport ControlPointDuplicate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_205__Copyright__ = __webpack_require__(1325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_205__Copyright___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_205__Copyright__);
/* unused harmony reexport Copyright */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_206__Create__ = __webpack_require__(1326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_206__Create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_206__Create__);
/* unused harmony reexport Create */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_207__CreateNewFolder__ = __webpack_require__(1327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_207__CreateNewFolder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_207__CreateNewFolder__);
/* unused harmony reexport CreateNewFolder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_208__CreditCard__ = __webpack_require__(1328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_208__CreditCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_208__CreditCard__);
/* unused harmony reexport CreditCard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_209__Crop__ = __webpack_require__(1329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_209__Crop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_209__Crop__);
/* unused harmony reexport Crop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_210__Crop169__ = __webpack_require__(1330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_210__Crop169___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_210__Crop169__);
/* unused harmony reexport Crop169 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_211__Crop32__ = __webpack_require__(1331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_211__Crop32___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_211__Crop32__);
/* unused harmony reexport Crop32 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_212__Crop54__ = __webpack_require__(1332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_212__Crop54___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_212__Crop54__);
/* unused harmony reexport Crop54 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_213__Crop75__ = __webpack_require__(1333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_213__Crop75___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_213__Crop75__);
/* unused harmony reexport Crop75 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_214__CropDin__ = __webpack_require__(1334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_214__CropDin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_214__CropDin__);
/* unused harmony reexport CropDin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_215__CropFree__ = __webpack_require__(1335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_215__CropFree___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_215__CropFree__);
/* unused harmony reexport CropFree */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_216__CropLandscape__ = __webpack_require__(1336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_216__CropLandscape___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_216__CropLandscape__);
/* unused harmony reexport CropLandscape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_217__CropOriginal__ = __webpack_require__(1337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_217__CropOriginal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_217__CropOriginal__);
/* unused harmony reexport CropOriginal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_218__CropPortrait__ = __webpack_require__(1338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_218__CropPortrait___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_218__CropPortrait__);
/* unused harmony reexport CropPortrait */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_219__CropRotate__ = __webpack_require__(1339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_219__CropRotate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_219__CropRotate__);
/* unused harmony reexport CropRotate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_220__CropSquare__ = __webpack_require__(1340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_220__CropSquare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_220__CropSquare__);
/* unused harmony reexport CropSquare */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_221__Dashboard__ = __webpack_require__(1341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_221__Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_221__Dashboard__);
/* unused harmony reexport Dashboard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_222__DataUsage__ = __webpack_require__(1342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_222__DataUsage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_222__DataUsage__);
/* unused harmony reexport DataUsage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_223__DateRange__ = __webpack_require__(1343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_223__DateRange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_223__DateRange__);
/* unused harmony reexport DateRange */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_224__Dehaze__ = __webpack_require__(1344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_224__Dehaze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_224__Dehaze__);
/* unused harmony reexport Dehaze */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_225__Delete__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_225__Delete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_225__Delete__);
/* unused harmony reexport Delete */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_226__DeleteForever__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_226__DeleteForever___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_226__DeleteForever__);
/* unused harmony reexport DeleteForever */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_227__DeleteSweep__ = __webpack_require__(1345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_227__DeleteSweep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_227__DeleteSweep__);
/* unused harmony reexport DeleteSweep */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_228__Description__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_228__Description___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_228__Description__);
/* unused harmony reexport Description */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_229__DesktopMac__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_229__DesktopMac___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_229__DesktopMac__);
/* unused harmony reexport DesktopMac */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_230__DesktopWindows__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_230__DesktopWindows___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_230__DesktopWindows__);
/* unused harmony reexport DesktopWindows */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_231__Details__ = __webpack_require__(1349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_231__Details___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_231__Details__);
/* unused harmony reexport Details */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_232__DeveloperBoard__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_232__DeveloperBoard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_232__DeveloperBoard__);
/* unused harmony reexport DeveloperBoard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_233__DeveloperMode__ = __webpack_require__(1350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_233__DeveloperMode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_233__DeveloperMode__);
/* unused harmony reexport DeveloperMode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_234__DeviceHub__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_234__DeviceHub___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_234__DeviceHub__);
/* unused harmony reexport DeviceHub */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_235__Devices__ = __webpack_require__(1351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_235__Devices___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_235__Devices__);
/* unused harmony reexport Devices */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_236__DevicesOther__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_236__DevicesOther___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_236__DevicesOther__);
/* unused harmony reexport DevicesOther */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_237__DialerSip__ = __webpack_require__(1353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_237__DialerSip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_237__DialerSip__);
/* unused harmony reexport DialerSip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_238__Dialpad__ = __webpack_require__(1354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_238__Dialpad___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_238__Dialpad__);
/* unused harmony reexport Dialpad */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_239__Directions__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_239__Directions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_239__Directions__);
/* unused harmony reexport Directions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_240__DirectionsBike__ = __webpack_require__(1356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_240__DirectionsBike___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_240__DirectionsBike__);
/* unused harmony reexport DirectionsBike */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_241__DirectionsBoat__ = __webpack_require__(1357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_241__DirectionsBoat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_241__DirectionsBoat__);
/* unused harmony reexport DirectionsBoat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_242__DirectionsBus__ = __webpack_require__(1358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_242__DirectionsBus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_242__DirectionsBus__);
/* unused harmony reexport DirectionsBus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_243__DirectionsCar__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_243__DirectionsCar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_243__DirectionsCar__);
/* unused harmony reexport DirectionsCar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_244__DirectionsRailway__ = __webpack_require__(1359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_244__DirectionsRailway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_244__DirectionsRailway__);
/* unused harmony reexport DirectionsRailway */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_245__DirectionsRun__ = __webpack_require__(1360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_245__DirectionsRun___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_245__DirectionsRun__);
/* unused harmony reexport DirectionsRun */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_246__DirectionsSubway__ = __webpack_require__(1361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_246__DirectionsSubway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_246__DirectionsSubway__);
/* unused harmony reexport DirectionsSubway */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_247__DirectionsTransit__ = __webpack_require__(1362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_247__DirectionsTransit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_247__DirectionsTransit__);
/* unused harmony reexport DirectionsTransit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_248__DirectionsWalk__ = __webpack_require__(1363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_248__DirectionsWalk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_248__DirectionsWalk__);
/* unused harmony reexport DirectionsWalk */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_249__DiscFull__ = __webpack_require__(1364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_249__DiscFull___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_249__DiscFull__);
/* unused harmony reexport DiscFull */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_250__Dns__ = __webpack_require__(1365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_250__Dns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_250__Dns__);
/* unused harmony reexport Dns */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_251__Dock__ = __webpack_require__(1366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_251__Dock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_251__Dock__);
/* unused harmony reexport Dock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_252__Domain__ = __webpack_require__(1367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_252__Domain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_252__Domain__);
/* unused harmony reexport Domain */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_253__Done__ = __webpack_require__(1368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_253__Done___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_253__Done__);
/* unused harmony reexport Done */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_254__DoneAll__ = __webpack_require__(1369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_254__DoneAll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_254__DoneAll__);
/* unused harmony reexport DoneAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_255__DoNotDisturb__ = __webpack_require__(1370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_255__DoNotDisturb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_255__DoNotDisturb__);
/* unused harmony reexport DoNotDisturb */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_256__DoNotDisturbAlt__ = __webpack_require__(1371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_256__DoNotDisturbAlt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_256__DoNotDisturbAlt__);
/* unused harmony reexport DoNotDisturbAlt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_257__DoNotDisturbOff__ = __webpack_require__(1372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_257__DoNotDisturbOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_257__DoNotDisturbOff__);
/* unused harmony reexport DoNotDisturbOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_258__DoNotDisturbOn__ = __webpack_require__(1373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_258__DoNotDisturbOn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_258__DoNotDisturbOn__);
/* unused harmony reexport DoNotDisturbOn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_259__DonutLarge__ = __webpack_require__(1374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_259__DonutLarge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_259__DonutLarge__);
/* unused harmony reexport DonutLarge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_260__DonutSmall__ = __webpack_require__(1375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_260__DonutSmall___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_260__DonutSmall__);
/* unused harmony reexport DonutSmall */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_261__Drafts__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_261__Drafts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_261__Drafts__);
/* unused harmony reexport Drafts */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_262__DragHandle__ = __webpack_require__(1377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_262__DragHandle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_262__DragHandle__);
/* unused harmony reexport DragHandle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_263__DriveEta__ = __webpack_require__(1378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_263__DriveEta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_263__DriveEta__);
/* unused harmony reexport DriveEta */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_264__Dvr__ = __webpack_require__(1379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_264__Dvr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_264__Dvr__);
/* unused harmony reexport Dvr */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_265__Edit__ = __webpack_require__(1380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_265__Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_265__Edit__);
/* unused harmony reexport Edit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_266__EditLocation__ = __webpack_require__(1381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_266__EditLocation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_266__EditLocation__);
/* unused harmony reexport EditLocation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_267__Eject__ = __webpack_require__(1382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_267__Eject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_267__Eject__);
/* unused harmony reexport Eject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_268__Email__ = __webpack_require__(1383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_268__Email___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_268__Email__);
/* unused harmony reexport Email */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_269__EnhancedEncryption__ = __webpack_require__(1384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_269__EnhancedEncryption___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_269__EnhancedEncryption__);
/* unused harmony reexport EnhancedEncryption */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_270__Equalizer__ = __webpack_require__(1385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_270__Equalizer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_270__Equalizer__);
/* unused harmony reexport Equalizer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_271__Error__ = __webpack_require__(1386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_271__Error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_271__Error__);
/* unused harmony reexport Error */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_272__ErrorOutline__ = __webpack_require__(1387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_272__ErrorOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_272__ErrorOutline__);
/* unused harmony reexport ErrorOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_273__EuroSymbol__ = __webpack_require__(1388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_273__EuroSymbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_273__EuroSymbol__);
/* unused harmony reexport EuroSymbol */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_274__Event__ = __webpack_require__(1389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_274__Event___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_274__Event__);
/* unused harmony reexport Event */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_275__EventAvailable__ = __webpack_require__(1390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_275__EventAvailable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_275__EventAvailable__);
/* unused harmony reexport EventAvailable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_276__EventBusy__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_276__EventBusy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_276__EventBusy__);
/* unused harmony reexport EventBusy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_277__EventNote__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_277__EventNote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_277__EventNote__);
/* unused harmony reexport EventNote */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_278__EventSeat__ = __webpack_require__(1393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_278__EventSeat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_278__EventSeat__);
/* unused harmony reexport EventSeat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_279__EvStation__ = __webpack_require__(1394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_279__EvStation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_279__EvStation__);
/* unused harmony reexport EvStation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_280__ExitToApp__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_280__ExitToApp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_280__ExitToApp__);
/* unused harmony reexport ExitToApp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_281__ExpandLess__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_281__ExpandLess___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_281__ExpandLess__);
/* unused harmony reexport ExpandLess */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_282__ExpandMore__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_282__ExpandMore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_282__ExpandMore__);
/* unused harmony reexport ExpandMore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_283__Explicit__ = __webpack_require__(1396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_283__Explicit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_283__Explicit__);
/* unused harmony reexport Explicit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_284__Explore__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_284__Explore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_284__Explore__);
/* unused harmony reexport Explore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_285__Exposure__ = __webpack_require__(1398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_285__Exposure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_285__Exposure__);
/* unused harmony reexport Exposure */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_286__ExposureNeg1__ = __webpack_require__(1399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_286__ExposureNeg1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_286__ExposureNeg1__);
/* unused harmony reexport ExposureNeg1 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_287__ExposureNeg2__ = __webpack_require__(1400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_287__ExposureNeg2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_287__ExposureNeg2__);
/* unused harmony reexport ExposureNeg2 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_288__ExposurePlus1__ = __webpack_require__(1401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_288__ExposurePlus1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_288__ExposurePlus1__);
/* unused harmony reexport ExposurePlus1 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_289__ExposurePlus2__ = __webpack_require__(1402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_289__ExposurePlus2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_289__ExposurePlus2__);
/* unused harmony reexport ExposurePlus2 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_290__ExposureZero__ = __webpack_require__(1403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_290__ExposureZero___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_290__ExposureZero__);
/* unused harmony reexport ExposureZero */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_291__Extension__ = __webpack_require__(1404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_291__Extension___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_291__Extension__);
/* unused harmony reexport Extension */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_292__Face__ = __webpack_require__(1405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_292__Face___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_292__Face__);
/* unused harmony reexport Face */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_293__FastForward__ = __webpack_require__(1406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_293__FastForward___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_293__FastForward__);
/* unused harmony reexport FastForward */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_294__FastRewind__ = __webpack_require__(1407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_294__FastRewind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_294__FastRewind__);
/* unused harmony reexport FastRewind */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_295__Favorite__ = __webpack_require__(1408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_295__Favorite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_295__Favorite__);
/* unused harmony reexport Favorite */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_296__FavoriteBorder__ = __webpack_require__(1409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_296__FavoriteBorder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_296__FavoriteBorder__);
/* unused harmony reexport FavoriteBorder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_297__FeaturedPlayList__ = __webpack_require__(1410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_297__FeaturedPlayList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_297__FeaturedPlayList__);
/* unused harmony reexport FeaturedPlayList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_298__FeaturedVideo__ = __webpack_require__(1411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_298__FeaturedVideo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_298__FeaturedVideo__);
/* unused harmony reexport FeaturedVideo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_299__Feedback__ = __webpack_require__(1412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_299__Feedback___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_299__Feedback__);
/* unused harmony reexport Feedback */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_300__FiberDvr__ = __webpack_require__(1413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_300__FiberDvr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_300__FiberDvr__);
/* unused harmony reexport FiberDvr */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_301__FiberManualRecord__ = __webpack_require__(1414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_301__FiberManualRecord___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_301__FiberManualRecord__);
/* unused harmony reexport FiberManualRecord */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_302__FiberNew__ = __webpack_require__(1415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_302__FiberNew___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_302__FiberNew__);
/* unused harmony reexport FiberNew */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_303__FiberPin__ = __webpack_require__(1416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_303__FiberPin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_303__FiberPin__);
/* unused harmony reexport FiberPin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_304__FiberSmartRecord__ = __webpack_require__(1417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_304__FiberSmartRecord___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_304__FiberSmartRecord__);
/* unused harmony reexport FiberSmartRecord */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_305__FileDownload__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_305__FileDownload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_305__FileDownload__);
/* unused harmony reexport FileDownload */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_306__FileUpload__ = __webpack_require__(1418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_306__FileUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_306__FileUpload__);
/* unused harmony reexport FileUpload */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_307__Filter__ = __webpack_require__(1419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_307__Filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_307__Filter__);
/* unused harmony reexport Filter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_308__Filter1__ = __webpack_require__(1420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_308__Filter1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_308__Filter1__);
/* unused harmony reexport Filter1 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_309__Filter2__ = __webpack_require__(1421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_309__Filter2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_309__Filter2__);
/* unused harmony reexport Filter2 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_310__Filter3__ = __webpack_require__(1422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_310__Filter3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_310__Filter3__);
/* unused harmony reexport Filter3 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_311__Filter4__ = __webpack_require__(1423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_311__Filter4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_311__Filter4__);
/* unused harmony reexport Filter4 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_312__Filter5__ = __webpack_require__(1424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_312__Filter5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_312__Filter5__);
/* unused harmony reexport Filter5 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_313__Filter6__ = __webpack_require__(1425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_313__Filter6___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_313__Filter6__);
/* unused harmony reexport Filter6 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_314__Filter7__ = __webpack_require__(1426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_314__Filter7___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_314__Filter7__);
/* unused harmony reexport Filter7 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_315__Filter8__ = __webpack_require__(1427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_315__Filter8___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_315__Filter8__);
/* unused harmony reexport Filter8 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_316__Filter9__ = __webpack_require__(1428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_316__Filter9___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_316__Filter9__);
/* unused harmony reexport Filter9 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_317__Filter9Plus__ = __webpack_require__(1429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_317__Filter9Plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_317__Filter9Plus__);
/* unused harmony reexport Filter9Plus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_318__FilterBAndW__ = __webpack_require__(1430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_318__FilterBAndW___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_318__FilterBAndW__);
/* unused harmony reexport FilterBAndW */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_319__FilterCenterFocus__ = __webpack_require__(1431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_319__FilterCenterFocus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_319__FilterCenterFocus__);
/* unused harmony reexport FilterCenterFocus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_320__FilterDrama__ = __webpack_require__(1432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_320__FilterDrama___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_320__FilterDrama__);
/* unused harmony reexport FilterDrama */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_321__FilterFrames__ = __webpack_require__(1433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_321__FilterFrames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_321__FilterFrames__);
/* unused harmony reexport FilterFrames */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_322__FilterHdr__ = __webpack_require__(1434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_322__FilterHdr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_322__FilterHdr__);
/* unused harmony reexport FilterHdr */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_323__FilterList__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_323__FilterList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_323__FilterList__);
/* unused harmony reexport FilterList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_324__FilterNone__ = __webpack_require__(1435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_324__FilterNone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_324__FilterNone__);
/* unused harmony reexport FilterNone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_325__FilterTiltShift__ = __webpack_require__(1436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_325__FilterTiltShift___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_325__FilterTiltShift__);
/* unused harmony reexport FilterTiltShift */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_326__FilterVintage__ = __webpack_require__(1437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_326__FilterVintage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_326__FilterVintage__);
/* unused harmony reexport FilterVintage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_327__FindInPage__ = __webpack_require__(1438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_327__FindInPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_327__FindInPage__);
/* unused harmony reexport FindInPage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_328__FindReplace__ = __webpack_require__(1439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_328__FindReplace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_328__FindReplace__);
/* unused harmony reexport FindReplace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_329__Fingerprint__ = __webpack_require__(1440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_329__Fingerprint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_329__Fingerprint__);
/* unused harmony reexport Fingerprint */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_330__FirstPage__ = __webpack_require__(1441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_330__FirstPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_330__FirstPage__);
/* unused harmony reexport FirstPage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_331__FitnessCenter__ = __webpack_require__(1442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_331__FitnessCenter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_331__FitnessCenter__);
/* unused harmony reexport FitnessCenter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_332__Flag__ = __webpack_require__(1443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_332__Flag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_332__Flag__);
/* unused harmony reexport Flag */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_333__Flare__ = __webpack_require__(1444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_333__Flare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_333__Flare__);
/* unused harmony reexport Flare */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_334__FlashAuto__ = __webpack_require__(1445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_334__FlashAuto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_334__FlashAuto__);
/* unused harmony reexport FlashAuto */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_335__FlashOff__ = __webpack_require__(1446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_335__FlashOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_335__FlashOff__);
/* unused harmony reexport FlashOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_336__FlashOn__ = __webpack_require__(1447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_336__FlashOn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_336__FlashOn__);
/* unused harmony reexport FlashOn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_337__Flight__ = __webpack_require__(1448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_337__Flight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_337__Flight__);
/* unused harmony reexport Flight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_338__FlightLand__ = __webpack_require__(1449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_338__FlightLand___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_338__FlightLand__);
/* unused harmony reexport FlightLand */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_339__FlightTakeoff__ = __webpack_require__(1450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_339__FlightTakeoff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_339__FlightTakeoff__);
/* unused harmony reexport FlightTakeoff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_340__Flip__ = __webpack_require__(1451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_340__Flip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_340__Flip__);
/* unused harmony reexport Flip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_341__FlipToBack__ = __webpack_require__(1452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_341__FlipToBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_341__FlipToBack__);
/* unused harmony reexport FlipToBack */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_342__FlipToFront__ = __webpack_require__(1453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_342__FlipToFront___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_342__FlipToFront__);
/* unused harmony reexport FlipToFront */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_343__Folder__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_343__Folder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_343__Folder__);
/* unused harmony reexport Folder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_344__FolderOpen__ = __webpack_require__(1454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_344__FolderOpen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_344__FolderOpen__);
/* unused harmony reexport FolderOpen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_345__FolderShared__ = __webpack_require__(1455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_345__FolderShared___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_345__FolderShared__);
/* unused harmony reexport FolderShared */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_346__FolderSpecial__ = __webpack_require__(1456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_346__FolderSpecial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_346__FolderSpecial__);
/* unused harmony reexport FolderSpecial */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_347__FontDownload__ = __webpack_require__(1457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_347__FontDownload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_347__FontDownload__);
/* unused harmony reexport FontDownload */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_348__FormatAlignCenter__ = __webpack_require__(1458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_348__FormatAlignCenter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_348__FormatAlignCenter__);
/* unused harmony reexport FormatAlignCenter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_349__FormatAlignJustify__ = __webpack_require__(1459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_349__FormatAlignJustify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_349__FormatAlignJustify__);
/* unused harmony reexport FormatAlignJustify */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_350__FormatAlignLeft__ = __webpack_require__(1460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_350__FormatAlignLeft___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_350__FormatAlignLeft__);
/* unused harmony reexport FormatAlignLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_351__FormatAlignRight__ = __webpack_require__(1461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_351__FormatAlignRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_351__FormatAlignRight__);
/* unused harmony reexport FormatAlignRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_352__FormatBold__ = __webpack_require__(1462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_352__FormatBold___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_352__FormatBold__);
/* unused harmony reexport FormatBold */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_353__FormatClear__ = __webpack_require__(1463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_353__FormatClear___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_353__FormatClear__);
/* unused harmony reexport FormatClear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_354__FormatColorFill__ = __webpack_require__(1464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_354__FormatColorFill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_354__FormatColorFill__);
/* unused harmony reexport FormatColorFill */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_355__FormatColorReset__ = __webpack_require__(1465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_355__FormatColorReset___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_355__FormatColorReset__);
/* unused harmony reexport FormatColorReset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_356__FormatColorText__ = __webpack_require__(1466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_356__FormatColorText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_356__FormatColorText__);
/* unused harmony reexport FormatColorText */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_357__FormatIndentDecrease__ = __webpack_require__(1467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_357__FormatIndentDecrease___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_357__FormatIndentDecrease__);
/* unused harmony reexport FormatIndentDecrease */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_358__FormatIndentIncrease__ = __webpack_require__(1468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_358__FormatIndentIncrease___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_358__FormatIndentIncrease__);
/* unused harmony reexport FormatIndentIncrease */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_359__FormatItalic__ = __webpack_require__(1469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_359__FormatItalic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_359__FormatItalic__);
/* unused harmony reexport FormatItalic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_360__FormatLineSpacing__ = __webpack_require__(1470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_360__FormatLineSpacing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_360__FormatLineSpacing__);
/* unused harmony reexport FormatLineSpacing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_361__FormatListBulleted__ = __webpack_require__(1471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_361__FormatListBulleted___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_361__FormatListBulleted__);
/* unused harmony reexport FormatListBulleted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_362__FormatListNumbered__ = __webpack_require__(1472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_362__FormatListNumbered___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_362__FormatListNumbered__);
/* unused harmony reexport FormatListNumbered */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_363__FormatPaint__ = __webpack_require__(1473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_363__FormatPaint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_363__FormatPaint__);
/* unused harmony reexport FormatPaint */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_364__FormatQuote__ = __webpack_require__(1474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_364__FormatQuote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_364__FormatQuote__);
/* unused harmony reexport FormatQuote */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_365__FormatShapes__ = __webpack_require__(1475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_365__FormatShapes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_365__FormatShapes__);
/* unused harmony reexport FormatShapes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_366__FormatSize__ = __webpack_require__(1476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_366__FormatSize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_366__FormatSize__);
/* unused harmony reexport FormatSize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_367__FormatStrikethrough__ = __webpack_require__(1477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_367__FormatStrikethrough___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_367__FormatStrikethrough__);
/* unused harmony reexport FormatStrikethrough */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_368__FormatTextdirectionLToR__ = __webpack_require__(1478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_368__FormatTextdirectionLToR___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_368__FormatTextdirectionLToR__);
/* unused harmony reexport FormatTextdirectionLToR */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_369__FormatTextdirectionRToL__ = __webpack_require__(1479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_369__FormatTextdirectionRToL___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_369__FormatTextdirectionRToL__);
/* unused harmony reexport FormatTextdirectionRToL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_370__FormatUnderlined__ = __webpack_require__(1480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_370__FormatUnderlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_370__FormatUnderlined__);
/* unused harmony reexport FormatUnderlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_371__Forum__ = __webpack_require__(1481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_371__Forum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_371__Forum__);
/* unused harmony reexport Forum */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_372__Forward__ = __webpack_require__(1482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_372__Forward___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_372__Forward__);
/* unused harmony reexport Forward */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_373__Forward10__ = __webpack_require__(1483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_373__Forward10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_373__Forward10__);
/* unused harmony reexport Forward10 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_374__Forward30__ = __webpack_require__(1484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_374__Forward30___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_374__Forward30__);
/* unused harmony reexport Forward30 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_375__Forward5__ = __webpack_require__(1485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_375__Forward5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_375__Forward5__);
/* unused harmony reexport Forward5 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_376__FreeBreakfast__ = __webpack_require__(1486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_376__FreeBreakfast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_376__FreeBreakfast__);
/* unused harmony reexport FreeBreakfast */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_377__Fullscreen__ = __webpack_require__(1487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_377__Fullscreen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_377__Fullscreen__);
/* unused harmony reexport Fullscreen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_378__FullscreenExit__ = __webpack_require__(1488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_378__FullscreenExit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_378__FullscreenExit__);
/* unused harmony reexport FullscreenExit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_379__Functions__ = __webpack_require__(1489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_379__Functions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_379__Functions__);
/* unused harmony reexport Functions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_380__Gamepad__ = __webpack_require__(1490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_380__Gamepad___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_380__Gamepad__);
/* unused harmony reexport Gamepad */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_381__Games__ = __webpack_require__(1491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_381__Games___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_381__Games__);
/* unused harmony reexport Games */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_382__Gavel__ = __webpack_require__(1492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_382__Gavel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_382__Gavel__);
/* unused harmony reexport Gavel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_383__Gesture__ = __webpack_require__(1493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_383__Gesture___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_383__Gesture__);
/* unused harmony reexport Gesture */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_384__GetApp__ = __webpack_require__(1494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_384__GetApp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_384__GetApp__);
/* unused harmony reexport GetApp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_385__Gif__ = __webpack_require__(1495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_385__Gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_385__Gif__);
/* unused harmony reexport Gif */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_386__GolfCourse__ = __webpack_require__(1496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_386__GolfCourse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_386__GolfCourse__);
/* unused harmony reexport GolfCourse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_387__GpsFixed__ = __webpack_require__(1497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_387__GpsFixed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_387__GpsFixed__);
/* unused harmony reexport GpsFixed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_388__GpsNotFixed__ = __webpack_require__(1498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_388__GpsNotFixed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_388__GpsNotFixed__);
/* unused harmony reexport GpsNotFixed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_389__GpsOff__ = __webpack_require__(1499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_389__GpsOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_389__GpsOff__);
/* unused harmony reexport GpsOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_390__Grade__ = __webpack_require__(1500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_390__Grade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_390__Grade__);
/* unused harmony reexport Grade */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_391__Gradient__ = __webpack_require__(1501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_391__Gradient___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_391__Gradient__);
/* unused harmony reexport Gradient */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_392__Grain__ = __webpack_require__(1502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_392__Grain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_392__Grain__);
/* unused harmony reexport Grain */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_393__GraphicEq__ = __webpack_require__(1503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_393__GraphicEq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_393__GraphicEq__);
/* unused harmony reexport GraphicEq */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_394__GridOff__ = __webpack_require__(1504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_394__GridOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_394__GridOff__);
/* unused harmony reexport GridOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_395__GridOn__ = __webpack_require__(1505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_395__GridOn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_395__GridOn__);
/* unused harmony reexport GridOn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_396__Group__ = __webpack_require__(1506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_396__Group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_396__Group__);
/* unused harmony reexport Group */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_397__GroupAdd__ = __webpack_require__(1507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_397__GroupAdd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_397__GroupAdd__);
/* unused harmony reexport GroupAdd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_398__GroupWork__ = __webpack_require__(1508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_398__GroupWork___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_398__GroupWork__);
/* unused harmony reexport GroupWork */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_399__GTranslate__ = __webpack_require__(1509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_399__GTranslate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_399__GTranslate__);
/* unused harmony reexport GTranslate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_400__Hd__ = __webpack_require__(1510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_400__Hd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_400__Hd__);
/* unused harmony reexport Hd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_401__HdrOff__ = __webpack_require__(1511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_401__HdrOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_401__HdrOff__);
/* unused harmony reexport HdrOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_402__HdrOn__ = __webpack_require__(1512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_402__HdrOn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_402__HdrOn__);
/* unused harmony reexport HdrOn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_403__HdrStrong__ = __webpack_require__(1513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_403__HdrStrong___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_403__HdrStrong__);
/* unused harmony reexport HdrStrong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_404__HdrWeak__ = __webpack_require__(1514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_404__HdrWeak___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_404__HdrWeak__);
/* unused harmony reexport HdrWeak */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_405__Headset__ = __webpack_require__(1515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_405__Headset___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_405__Headset__);
/* unused harmony reexport Headset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_406__HeadsetMic__ = __webpack_require__(1516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_406__HeadsetMic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_406__HeadsetMic__);
/* unused harmony reexport HeadsetMic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_407__Healing__ = __webpack_require__(1517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_407__Healing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_407__Healing__);
/* unused harmony reexport Healing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_408__Hearing__ = __webpack_require__(1518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_408__Hearing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_408__Hearing__);
/* unused harmony reexport Hearing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_409__Help__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_409__Help___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_409__Help__);
/* unused harmony reexport Help */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_410__HelpOutline__ = __webpack_require__(1519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_410__HelpOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_410__HelpOutline__);
/* unused harmony reexport HelpOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_411__Highlight__ = __webpack_require__(1520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_411__Highlight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_411__Highlight__);
/* unused harmony reexport Highlight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_412__HighlightOff__ = __webpack_require__(1521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_412__HighlightOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_412__HighlightOff__);
/* unused harmony reexport HighlightOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_413__HighQuality__ = __webpack_require__(1522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_413__HighQuality___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_413__HighQuality__);
/* unused harmony reexport HighQuality */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_414__History__ = __webpack_require__(1523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_414__History___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_414__History__);
/* unused harmony reexport History */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_415__Home__ = __webpack_require__(1524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_415__Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_415__Home__);
/* unused harmony reexport Home */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_416__Hotel__ = __webpack_require__(1525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_416__Hotel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_416__Hotel__);
/* unused harmony reexport Hotel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_417__HotTub__ = __webpack_require__(1526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_417__HotTub___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_417__HotTub__);
/* unused harmony reexport HotTub */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_418__HourglassEmpty__ = __webpack_require__(1527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_418__HourglassEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_418__HourglassEmpty__);
/* unused harmony reexport HourglassEmpty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_419__HourglassFull__ = __webpack_require__(1528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_419__HourglassFull___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_419__HourglassFull__);
/* unused harmony reexport HourglassFull */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_420__Http__ = __webpack_require__(1529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_420__Http___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_420__Http__);
/* unused harmony reexport Http */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_421__Https__ = __webpack_require__(1530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_421__Https___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_421__Https__);
/* unused harmony reexport Https */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_422__Image__ = __webpack_require__(1531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_422__Image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_422__Image__);
/* unused harmony reexport Image */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_423__ImageAspectRatio__ = __webpack_require__(1532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_423__ImageAspectRatio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_423__ImageAspectRatio__);
/* unused harmony reexport ImageAspectRatio */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_424__ImportantDevices__ = __webpack_require__(1533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_424__ImportantDevices___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_424__ImportantDevices__);
/* unused harmony reexport ImportantDevices */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_425__ImportContacts__ = __webpack_require__(1534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_425__ImportContacts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_425__ImportContacts__);
/* unused harmony reexport ImportContacts */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_426__ImportExport__ = __webpack_require__(1535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_426__ImportExport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_426__ImportExport__);
/* unused harmony reexport ImportExport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_427__Inbox__ = __webpack_require__(1536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_427__Inbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_427__Inbox__);
/* unused harmony reexport Inbox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_428__IndeterminateCheckBox__ = __webpack_require__(1537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_428__IndeterminateCheckBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_428__IndeterminateCheckBox__);
/* unused harmony reexport IndeterminateCheckBox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_429__Info__ = __webpack_require__(1538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_429__Info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_429__Info__);
/* unused harmony reexport Info */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_430__InfoOutline__ = __webpack_require__(1539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_430__InfoOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_430__InfoOutline__);
/* unused harmony reexport InfoOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_431__Input__ = __webpack_require__(1540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_431__Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_431__Input__);
/* unused harmony reexport Input */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_432__InsertChart__ = __webpack_require__(1541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_432__InsertChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_432__InsertChart__);
/* unused harmony reexport InsertChart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_433__InsertComment__ = __webpack_require__(1542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_433__InsertComment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_433__InsertComment__);
/* unused harmony reexport InsertComment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_434__InsertDriveFile__ = __webpack_require__(1543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_434__InsertDriveFile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_434__InsertDriveFile__);
/* unused harmony reexport InsertDriveFile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_435__InsertEmoticon__ = __webpack_require__(1544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_435__InsertEmoticon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_435__InsertEmoticon__);
/* unused harmony reexport InsertEmoticon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_436__InsertInvitation__ = __webpack_require__(1545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_436__InsertInvitation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_436__InsertInvitation__);
/* unused harmony reexport InsertInvitation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_437__InsertLink__ = __webpack_require__(1546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_437__InsertLink___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_437__InsertLink__);
/* unused harmony reexport InsertLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_438__InsertPhoto__ = __webpack_require__(1547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_438__InsertPhoto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_438__InsertPhoto__);
/* unused harmony reexport InsertPhoto */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_439__InvertColors__ = __webpack_require__(1548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_439__InvertColors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_439__InvertColors__);
/* unused harmony reexport InvertColors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_440__InvertColorsOff__ = __webpack_require__(1549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_440__InvertColorsOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_440__InvertColorsOff__);
/* unused harmony reexport InvertColorsOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_441__Iso__ = __webpack_require__(1550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_441__Iso___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_441__Iso__);
/* unused harmony reexport Iso */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_442__Keyboard__ = __webpack_require__(1551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_442__Keyboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_442__Keyboard__);
/* unused harmony reexport Keyboard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_443__KeyboardArrowDown__ = __webpack_require__(1552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_443__KeyboardArrowDown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_443__KeyboardArrowDown__);
/* unused harmony reexport KeyboardArrowDown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_444__KeyboardArrowLeft__ = __webpack_require__(1553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_444__KeyboardArrowLeft___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_444__KeyboardArrowLeft__);
/* unused harmony reexport KeyboardArrowLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_445__KeyboardArrowRight__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_445__KeyboardArrowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_445__KeyboardArrowRight__);
/* unused harmony reexport KeyboardArrowRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_446__KeyboardArrowUp__ = __webpack_require__(1554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_446__KeyboardArrowUp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_446__KeyboardArrowUp__);
/* unused harmony reexport KeyboardArrowUp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_447__KeyboardBackspace__ = __webpack_require__(1555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_447__KeyboardBackspace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_447__KeyboardBackspace__);
/* unused harmony reexport KeyboardBackspace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_448__KeyboardCapslock__ = __webpack_require__(1556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_448__KeyboardCapslock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_448__KeyboardCapslock__);
/* unused harmony reexport KeyboardCapslock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_449__KeyboardHide__ = __webpack_require__(1557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_449__KeyboardHide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_449__KeyboardHide__);
/* unused harmony reexport KeyboardHide */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_450__KeyboardReturn__ = __webpack_require__(1558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_450__KeyboardReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_450__KeyboardReturn__);
/* unused harmony reexport KeyboardReturn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_451__KeyboardTab__ = __webpack_require__(1559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_451__KeyboardTab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_451__KeyboardTab__);
/* unused harmony reexport KeyboardTab */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_452__KeyboardVoice__ = __webpack_require__(1560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_452__KeyboardVoice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_452__KeyboardVoice__);
/* unused harmony reexport KeyboardVoice */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_453__Kitchen__ = __webpack_require__(1561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_453__Kitchen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_453__Kitchen__);
/* unused harmony reexport Kitchen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_454__Label__ = __webpack_require__(1562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_454__Label___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_454__Label__);
/* unused harmony reexport Label */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_455__LabelOutline__ = __webpack_require__(1563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_455__LabelOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_455__LabelOutline__);
/* unused harmony reexport LabelOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_456__Landscape__ = __webpack_require__(1564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_456__Landscape___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_456__Landscape__);
/* unused harmony reexport Landscape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_457__Language__ = __webpack_require__(1565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_457__Language___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_457__Language__);
/* unused harmony reexport Language */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_458__Laptop__ = __webpack_require__(1566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_458__Laptop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_458__Laptop__);
/* unused harmony reexport Laptop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_459__LaptopChromebook__ = __webpack_require__(1567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_459__LaptopChromebook___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_459__LaptopChromebook__);
/* unused harmony reexport LaptopChromebook */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_460__LaptopMac__ = __webpack_require__(1568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_460__LaptopMac___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_460__LaptopMac__);
/* unused harmony reexport LaptopMac */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_461__LaptopWindows__ = __webpack_require__(1569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_461__LaptopWindows___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_461__LaptopWindows__);
/* unused harmony reexport LaptopWindows */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_462__LastPage__ = __webpack_require__(1570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_462__LastPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_462__LastPage__);
/* unused harmony reexport LastPage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_463__Launch__ = __webpack_require__(1571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_463__Launch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_463__Launch__);
/* unused harmony reexport Launch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_464__Layers__ = __webpack_require__(1572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_464__Layers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_464__Layers__);
/* unused harmony reexport Layers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_465__LayersClear__ = __webpack_require__(1573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_465__LayersClear___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_465__LayersClear__);
/* unused harmony reexport LayersClear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_466__LeakAdd__ = __webpack_require__(1574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_466__LeakAdd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_466__LeakAdd__);
/* unused harmony reexport LeakAdd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_467__LeakRemove__ = __webpack_require__(1575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_467__LeakRemove___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_467__LeakRemove__);
/* unused harmony reexport LeakRemove */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_468__Lens__ = __webpack_require__(1576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_468__Lens___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_468__Lens__);
/* unused harmony reexport Lens */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_469__LibraryAdd__ = __webpack_require__(1577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_469__LibraryAdd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_469__LibraryAdd__);
/* unused harmony reexport LibraryAdd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_470__LibraryBooks__ = __webpack_require__(1578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_470__LibraryBooks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_470__LibraryBooks__);
/* unused harmony reexport LibraryBooks */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_471__LibraryMusic__ = __webpack_require__(1579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_471__LibraryMusic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_471__LibraryMusic__);
/* unused harmony reexport LibraryMusic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_472__LightbulbOutline__ = __webpack_require__(1580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_472__LightbulbOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_472__LightbulbOutline__);
/* unused harmony reexport LightbulbOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_473__LinearScale__ = __webpack_require__(1581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_473__LinearScale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_473__LinearScale__);
/* unused harmony reexport LinearScale */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_474__LineStyle__ = __webpack_require__(1582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_474__LineStyle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_474__LineStyle__);
/* unused harmony reexport LineStyle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_475__LineWeight__ = __webpack_require__(1583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_475__LineWeight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_475__LineWeight__);
/* unused harmony reexport LineWeight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_476__Link__ = __webpack_require__(1584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_476__Link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_476__Link__);
/* unused harmony reexport Link */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_477__LinkedCamera__ = __webpack_require__(1585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_477__LinkedCamera___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_477__LinkedCamera__);
/* unused harmony reexport LinkedCamera */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_478__List__ = __webpack_require__(1586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_478__List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_478__List__);
/* unused harmony reexport List */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_479__LiveHelp__ = __webpack_require__(1587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_479__LiveHelp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_479__LiveHelp__);
/* unused harmony reexport LiveHelp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_480__LiveTv__ = __webpack_require__(1588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_480__LiveTv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_480__LiveTv__);
/* unused harmony reexport LiveTv */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_481__LocalActivity__ = __webpack_require__(1589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_481__LocalActivity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_481__LocalActivity__);
/* unused harmony reexport LocalActivity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_482__LocalAirport__ = __webpack_require__(1590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_482__LocalAirport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_482__LocalAirport__);
/* unused harmony reexport LocalAirport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_483__LocalAtm__ = __webpack_require__(1591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_483__LocalAtm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_483__LocalAtm__);
/* unused harmony reexport LocalAtm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_484__LocalBar__ = __webpack_require__(1592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_484__LocalBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_484__LocalBar__);
/* unused harmony reexport LocalBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_485__LocalCafe__ = __webpack_require__(1593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_485__LocalCafe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_485__LocalCafe__);
/* unused harmony reexport LocalCafe */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_486__LocalCarWash__ = __webpack_require__(1594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_486__LocalCarWash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_486__LocalCarWash__);
/* unused harmony reexport LocalCarWash */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_487__LocalConvenienceStore__ = __webpack_require__(1595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_487__LocalConvenienceStore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_487__LocalConvenienceStore__);
/* unused harmony reexport LocalConvenienceStore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_488__LocalDining__ = __webpack_require__(1596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_488__LocalDining___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_488__LocalDining__);
/* unused harmony reexport LocalDining */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_489__LocalDrink__ = __webpack_require__(1597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_489__LocalDrink___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_489__LocalDrink__);
/* unused harmony reexport LocalDrink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_490__LocalFlorist__ = __webpack_require__(1598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_490__LocalFlorist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_490__LocalFlorist__);
/* unused harmony reexport LocalFlorist */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_491__LocalGasStation__ = __webpack_require__(1599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_491__LocalGasStation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_491__LocalGasStation__);
/* unused harmony reexport LocalGasStation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_492__LocalGroceryStore__ = __webpack_require__(1600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_492__LocalGroceryStore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_492__LocalGroceryStore__);
/* unused harmony reexport LocalGroceryStore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_493__LocalHospital__ = __webpack_require__(1601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_493__LocalHospital___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_493__LocalHospital__);
/* unused harmony reexport LocalHospital */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_494__LocalHotel__ = __webpack_require__(1602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_494__LocalHotel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_494__LocalHotel__);
/* unused harmony reexport LocalHotel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_495__LocalLaundryService__ = __webpack_require__(1603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_495__LocalLaundryService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_495__LocalLaundryService__);
/* unused harmony reexport LocalLaundryService */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_496__LocalLibrary__ = __webpack_require__(1604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_496__LocalLibrary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_496__LocalLibrary__);
/* unused harmony reexport LocalLibrary */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_497__LocalMall__ = __webpack_require__(1605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_497__LocalMall___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_497__LocalMall__);
/* unused harmony reexport LocalMall */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_498__LocalMovies__ = __webpack_require__(1606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_498__LocalMovies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_498__LocalMovies__);
/* unused harmony reexport LocalMovies */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_499__LocalOffer__ = __webpack_require__(1607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_499__LocalOffer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_499__LocalOffer__);
/* unused harmony reexport LocalOffer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_500__LocalParking__ = __webpack_require__(1608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_500__LocalParking___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_500__LocalParking__);
/* unused harmony reexport LocalParking */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_501__LocalPharmacy__ = __webpack_require__(1609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_501__LocalPharmacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_501__LocalPharmacy__);
/* unused harmony reexport LocalPharmacy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_502__LocalPhone__ = __webpack_require__(1610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_502__LocalPhone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_502__LocalPhone__);
/* unused harmony reexport LocalPhone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_503__LocalPizza__ = __webpack_require__(1611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_503__LocalPizza___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_503__LocalPizza__);
/* unused harmony reexport LocalPizza */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_504__LocalPlay__ = __webpack_require__(1612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_504__LocalPlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_504__LocalPlay__);
/* unused harmony reexport LocalPlay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_505__LocalPostOffice__ = __webpack_require__(1613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_505__LocalPostOffice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_505__LocalPostOffice__);
/* unused harmony reexport LocalPostOffice */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_506__LocalPrintshop__ = __webpack_require__(1614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_506__LocalPrintshop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_506__LocalPrintshop__);
/* unused harmony reexport LocalPrintshop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_507__LocalSee__ = __webpack_require__(1615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_507__LocalSee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_507__LocalSee__);
/* unused harmony reexport LocalSee */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_508__LocalShipping__ = __webpack_require__(1616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_508__LocalShipping___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_508__LocalShipping__);
/* unused harmony reexport LocalShipping */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_509__LocalTaxi__ = __webpack_require__(1617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_509__LocalTaxi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_509__LocalTaxi__);
/* unused harmony reexport LocalTaxi */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_510__LocationCity__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_510__LocationCity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_510__LocationCity__);
/* unused harmony reexport LocationCity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_511__LocationDisabled__ = __webpack_require__(1618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_511__LocationDisabled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_511__LocationDisabled__);
/* unused harmony reexport LocationDisabled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_512__LocationOff__ = __webpack_require__(1619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_512__LocationOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_512__LocationOff__);
/* unused harmony reexport LocationOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_513__LocationOn__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_513__LocationOn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_513__LocationOn__);
/* unused harmony reexport LocationOn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_514__LocationSearching__ = __webpack_require__(1620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_514__LocationSearching___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_514__LocationSearching__);
/* unused harmony reexport LocationSearching */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_515__Lock__ = __webpack_require__(1621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_515__Lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_515__Lock__);
/* unused harmony reexport Lock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_516__LockOpen__ = __webpack_require__(1622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_516__LockOpen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_516__LockOpen__);
/* unused harmony reexport LockOpen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_517__LockOutline__ = __webpack_require__(1623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_517__LockOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_517__LockOutline__);
/* unused harmony reexport LockOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_518__Looks__ = __webpack_require__(1624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_518__Looks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_518__Looks__);
/* unused harmony reexport Looks */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_519__Looks3__ = __webpack_require__(1625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_519__Looks3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_519__Looks3__);
/* unused harmony reexport Looks3 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_520__Looks4__ = __webpack_require__(1626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_520__Looks4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_520__Looks4__);
/* unused harmony reexport Looks4 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_521__Looks5__ = __webpack_require__(1627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_521__Looks5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_521__Looks5__);
/* unused harmony reexport Looks5 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_522__Looks6__ = __webpack_require__(1628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_522__Looks6___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_522__Looks6__);
/* unused harmony reexport Looks6 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_523__LooksOne__ = __webpack_require__(1629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_523__LooksOne___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_523__LooksOne__);
/* unused harmony reexport LooksOne */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_524__LooksTwo__ = __webpack_require__(1630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_524__LooksTwo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_524__LooksTwo__);
/* unused harmony reexport LooksTwo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_525__Loop__ = __webpack_require__(1631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_525__Loop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_525__Loop__);
/* unused harmony reexport Loop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_526__Loupe__ = __webpack_require__(1632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_526__Loupe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_526__Loupe__);
/* unused harmony reexport Loupe */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_527__LowPriority__ = __webpack_require__(1633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_527__LowPriority___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_527__LowPriority__);
/* unused harmony reexport LowPriority */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_528__Loyalty__ = __webpack_require__(1634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_528__Loyalty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_528__Loyalty__);
/* unused harmony reexport Loyalty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_529__Mail__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_529__Mail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_529__Mail__);
/* unused harmony reexport Mail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_530__MailOutline__ = __webpack_require__(1635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_530__MailOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_530__MailOutline__);
/* unused harmony reexport MailOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_531__Map__ = __webpack_require__(1636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_531__Map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_531__Map__);
/* unused harmony reexport Map */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_532__Markunread__ = __webpack_require__(1637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_532__Markunread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_532__Markunread__);
/* unused harmony reexport Markunread */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_533__MarkunreadMailbox__ = __webpack_require__(1638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_533__MarkunreadMailbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_533__MarkunreadMailbox__);
/* unused harmony reexport MarkunreadMailbox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_534__Memory__ = __webpack_require__(1639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_534__Memory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_534__Memory__);
/* unused harmony reexport Memory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_535__Menu__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_535__Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_535__Menu__);
/* unused harmony reexport Menu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_536__MergeType__ = __webpack_require__(1640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_536__MergeType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_536__MergeType__);
/* unused harmony reexport MergeType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_537__Message__ = __webpack_require__(1641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_537__Message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_537__Message__);
/* unused harmony reexport Message */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_538__Mic__ = __webpack_require__(1642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_538__Mic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_538__Mic__);
/* unused harmony reexport Mic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_539__MicNone__ = __webpack_require__(1643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_539__MicNone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_539__MicNone__);
/* unused harmony reexport MicNone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_540__MicOff__ = __webpack_require__(1644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_540__MicOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_540__MicOff__);
/* unused harmony reexport MicOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_541__Mms__ = __webpack_require__(1645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_541__Mms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_541__Mms__);
/* unused harmony reexport Mms */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_542__ModeComment__ = __webpack_require__(1646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_542__ModeComment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_542__ModeComment__);
/* unused harmony reexport ModeComment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_543__ModeEdit__ = __webpack_require__(1647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_543__ModeEdit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_543__ModeEdit__);
/* unused harmony reexport ModeEdit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_544__MonetizationOn__ = __webpack_require__(1648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_544__MonetizationOn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_544__MonetizationOn__);
/* unused harmony reexport MonetizationOn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_545__MoneyOff__ = __webpack_require__(1649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_545__MoneyOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_545__MoneyOff__);
/* unused harmony reexport MoneyOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_546__MonochromePhotos__ = __webpack_require__(1650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_546__MonochromePhotos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_546__MonochromePhotos__);
/* unused harmony reexport MonochromePhotos */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_547__Mood__ = __webpack_require__(1651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_547__Mood___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_547__Mood__);
/* unused harmony reexport Mood */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_548__MoodBad__ = __webpack_require__(1652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_548__MoodBad___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_548__MoodBad__);
/* unused harmony reexport MoodBad */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_549__More__ = __webpack_require__(1653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_549__More___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_549__More__);
/* unused harmony reexport More */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_550__MoreHoriz__ = __webpack_require__(1654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_550__MoreHoriz___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_550__MoreHoriz__);
/* unused harmony reexport MoreHoriz */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_551__MoreVert__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_551__MoreVert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_551__MoreVert__);
/* unused harmony reexport MoreVert */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_552__Motorcycle__ = __webpack_require__(1655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_552__Motorcycle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_552__Motorcycle__);
/* unused harmony reexport Motorcycle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_553__Mouse__ = __webpack_require__(1656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_553__Mouse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_553__Mouse__);
/* unused harmony reexport Mouse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_554__MoveToInbox__ = __webpack_require__(1657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_554__MoveToInbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_554__MoveToInbox__);
/* unused harmony reexport MoveToInbox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_555__Movie__ = __webpack_require__(1658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_555__Movie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_555__Movie__);
/* unused harmony reexport Movie */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_556__MovieCreation__ = __webpack_require__(1659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_556__MovieCreation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_556__MovieCreation__);
/* unused harmony reexport MovieCreation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_557__MovieFilter__ = __webpack_require__(1660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_557__MovieFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_557__MovieFilter__);
/* unused harmony reexport MovieFilter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_558__MultilineChart__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_558__MultilineChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_558__MultilineChart__);
/* unused harmony reexport MultilineChart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_559__MusicNote__ = __webpack_require__(1661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_559__MusicNote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_559__MusicNote__);
/* unused harmony reexport MusicNote */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_560__MusicVideo__ = __webpack_require__(1662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_560__MusicVideo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_560__MusicVideo__);
/* unused harmony reexport MusicVideo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_561__MyLocation__ = __webpack_require__(1663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_561__MyLocation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_561__MyLocation__);
/* unused harmony reexport MyLocation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_562__Nature__ = __webpack_require__(1664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_562__Nature___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_562__Nature__);
/* unused harmony reexport Nature */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_563__NaturePeople__ = __webpack_require__(1665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_563__NaturePeople___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_563__NaturePeople__);
/* unused harmony reexport NaturePeople */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_564__NavigateBefore__ = __webpack_require__(1666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_564__NavigateBefore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_564__NavigateBefore__);
/* unused harmony reexport NavigateBefore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_565__NavigateNext__ = __webpack_require__(1667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_565__NavigateNext___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_565__NavigateNext__);
/* unused harmony reexport NavigateNext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_566__Navigation__ = __webpack_require__(1668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_566__Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_566__Navigation__);
/* unused harmony reexport Navigation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_567__NearMe__ = __webpack_require__(1669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_567__NearMe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_567__NearMe__);
/* unused harmony reexport NearMe */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_568__NetworkCell__ = __webpack_require__(1670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_568__NetworkCell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_568__NetworkCell__);
/* unused harmony reexport NetworkCell */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_569__NetworkCheck__ = __webpack_require__(1671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_569__NetworkCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_569__NetworkCheck__);
/* unused harmony reexport NetworkCheck */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_570__NetworkLocked__ = __webpack_require__(1672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_570__NetworkLocked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_570__NetworkLocked__);
/* unused harmony reexport NetworkLocked */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_571__NetworkWifi__ = __webpack_require__(1673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_571__NetworkWifi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_571__NetworkWifi__);
/* unused harmony reexport NetworkWifi */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_572__NewReleases__ = __webpack_require__(1674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_572__NewReleases___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_572__NewReleases__);
/* unused harmony reexport NewReleases */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_573__NextWeek__ = __webpack_require__(1675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_573__NextWeek___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_573__NextWeek__);
/* unused harmony reexport NextWeek */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_574__Nfc__ = __webpack_require__(1676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_574__Nfc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_574__Nfc__);
/* unused harmony reexport Nfc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_575__NoEncryption__ = __webpack_require__(1677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_575__NoEncryption___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_575__NoEncryption__);
/* unused harmony reexport NoEncryption */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_576__NoSim__ = __webpack_require__(1678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_576__NoSim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_576__NoSim__);
/* unused harmony reexport NoSim */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_577__Note__ = __webpack_require__(1679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_577__Note___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_577__Note__);
/* unused harmony reexport Note */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_578__NoteAdd__ = __webpack_require__(1680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_578__NoteAdd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_578__NoteAdd__);
/* unused harmony reexport NoteAdd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_579__Notifications__ = __webpack_require__(1681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_579__Notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_579__Notifications__);
/* unused harmony reexport Notifications */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_580__NotificationsActive__ = __webpack_require__(1682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_580__NotificationsActive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_580__NotificationsActive__);
/* unused harmony reexport NotificationsActive */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_581__NotificationsNone__ = __webpack_require__(1683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_581__NotificationsNone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_581__NotificationsNone__);
/* unused harmony reexport NotificationsNone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_582__NotificationsOff__ = __webpack_require__(1684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_582__NotificationsOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_582__NotificationsOff__);
/* unused harmony reexport NotificationsOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_583__NotificationsPaused__ = __webpack_require__(1685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_583__NotificationsPaused___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_583__NotificationsPaused__);
/* unused harmony reexport NotificationsPaused */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_584__NotInterested__ = __webpack_require__(1686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_584__NotInterested___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_584__NotInterested__);
/* unused harmony reexport NotInterested */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_585__OfflinePin__ = __webpack_require__(1687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_585__OfflinePin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_585__OfflinePin__);
/* unused harmony reexport OfflinePin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_586__OndemandVideo__ = __webpack_require__(1688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_586__OndemandVideo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_586__OndemandVideo__);
/* unused harmony reexport OndemandVideo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_587__Opacity__ = __webpack_require__(1689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_587__Opacity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_587__Opacity__);
/* unused harmony reexport Opacity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_588__OpenInBrowser__ = __webpack_require__(1690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_588__OpenInBrowser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_588__OpenInBrowser__);
/* unused harmony reexport OpenInBrowser */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_589__OpenInNew__ = __webpack_require__(1691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_589__OpenInNew___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_589__OpenInNew__);
/* unused harmony reexport OpenInNew */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_590__OpenWith__ = __webpack_require__(1692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_590__OpenWith___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_590__OpenWith__);
/* unused harmony reexport OpenWith */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_591__Pages__ = __webpack_require__(1693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_591__Pages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_591__Pages__);
/* unused harmony reexport Pages */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_592__Pageview__ = __webpack_require__(1694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_592__Pageview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_592__Pageview__);
/* unused harmony reexport Pageview */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_593__Palette__ = __webpack_require__(1695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_593__Palette___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_593__Palette__);
/* unused harmony reexport Palette */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_594__Panorama__ = __webpack_require__(1696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_594__Panorama___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_594__Panorama__);
/* unused harmony reexport Panorama */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_595__PanoramaFishEye__ = __webpack_require__(1697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_595__PanoramaFishEye___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_595__PanoramaFishEye__);
/* unused harmony reexport PanoramaFishEye */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_596__PanoramaHorizontal__ = __webpack_require__(1698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_596__PanoramaHorizontal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_596__PanoramaHorizontal__);
/* unused harmony reexport PanoramaHorizontal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_597__PanoramaVertical__ = __webpack_require__(1699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_597__PanoramaVertical___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_597__PanoramaVertical__);
/* unused harmony reexport PanoramaVertical */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_598__PanoramaWideAngle__ = __webpack_require__(1700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_598__PanoramaWideAngle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_598__PanoramaWideAngle__);
/* unused harmony reexport PanoramaWideAngle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_599__PanTool__ = __webpack_require__(1701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_599__PanTool___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_599__PanTool__);
/* unused harmony reexport PanTool */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_600__PartyMode__ = __webpack_require__(1702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_600__PartyMode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_600__PartyMode__);
/* unused harmony reexport PartyMode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_601__Pause__ = __webpack_require__(1703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_601__Pause___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_601__Pause__);
/* unused harmony reexport Pause */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_602__PauseCircleFilled__ = __webpack_require__(1704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_602__PauseCircleFilled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_602__PauseCircleFilled__);
/* unused harmony reexport PauseCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_603__PauseCircleOutline__ = __webpack_require__(1705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_603__PauseCircleOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_603__PauseCircleOutline__);
/* unused harmony reexport PauseCircleOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_604__Payment__ = __webpack_require__(1706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_604__Payment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_604__Payment__);
/* unused harmony reexport Payment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_605__People__ = __webpack_require__(1707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_605__People___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_605__People__);
/* unused harmony reexport People */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_606__PeopleOutline__ = __webpack_require__(1708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_606__PeopleOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_606__PeopleOutline__);
/* unused harmony reexport PeopleOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_607__PermCameraMic__ = __webpack_require__(1709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_607__PermCameraMic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_607__PermCameraMic__);
/* unused harmony reexport PermCameraMic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_608__PermContactCalendar__ = __webpack_require__(1710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_608__PermContactCalendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_608__PermContactCalendar__);
/* unused harmony reexport PermContactCalendar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_609__PermDataSetting__ = __webpack_require__(1711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_609__PermDataSetting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_609__PermDataSetting__);
/* unused harmony reexport PermDataSetting */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_610__PermDeviceInformation__ = __webpack_require__(1712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_610__PermDeviceInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_610__PermDeviceInformation__);
/* unused harmony reexport PermDeviceInformation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_611__PermIdentity__ = __webpack_require__(1713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_611__PermIdentity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_611__PermIdentity__);
/* unused harmony reexport PermIdentity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_612__PermMedia__ = __webpack_require__(1714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_612__PermMedia___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_612__PermMedia__);
/* unused harmony reexport PermMedia */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_613__PermPhoneMsg__ = __webpack_require__(1715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_613__PermPhoneMsg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_613__PermPhoneMsg__);
/* unused harmony reexport PermPhoneMsg */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_614__PermScanWifi__ = __webpack_require__(1716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_614__PermScanWifi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_614__PermScanWifi__);
/* unused harmony reexport PermScanWifi */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_615__Person__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_615__Person___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_615__Person__);
/* unused harmony reexport Person */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_616__PersonAdd__ = __webpack_require__(1717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_616__PersonAdd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_616__PersonAdd__);
/* unused harmony reexport PersonAdd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_617__PersonalVideo__ = __webpack_require__(1718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_617__PersonalVideo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_617__PersonalVideo__);
/* unused harmony reexport PersonalVideo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_618__PersonOutline__ = __webpack_require__(1719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_618__PersonOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_618__PersonOutline__);
/* unused harmony reexport PersonOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_619__PersonPin__ = __webpack_require__(1720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_619__PersonPin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_619__PersonPin__);
/* unused harmony reexport PersonPin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_620__PersonPinCircle__ = __webpack_require__(1721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_620__PersonPinCircle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_620__PersonPinCircle__);
/* unused harmony reexport PersonPinCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_621__Pets__ = __webpack_require__(1722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_621__Pets___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_621__Pets__);
/* unused harmony reexport Pets */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_622__Phone__ = __webpack_require__(1723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_622__Phone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_622__Phone__);
/* unused harmony reexport Phone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_623__PhoneAndroid__ = __webpack_require__(1724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_623__PhoneAndroid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_623__PhoneAndroid__);
/* unused harmony reexport PhoneAndroid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_624__PhoneBluetoothSpeaker__ = __webpack_require__(1725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_624__PhoneBluetoothSpeaker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_624__PhoneBluetoothSpeaker__);
/* unused harmony reexport PhoneBluetoothSpeaker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_625__PhoneForwarded__ = __webpack_require__(1726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_625__PhoneForwarded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_625__PhoneForwarded__);
/* unused harmony reexport PhoneForwarded */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_626__PhoneInTalk__ = __webpack_require__(1727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_626__PhoneInTalk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_626__PhoneInTalk__);
/* unused harmony reexport PhoneInTalk */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_627__PhoneIphone__ = __webpack_require__(1728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_627__PhoneIphone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_627__PhoneIphone__);
/* unused harmony reexport PhoneIphone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_628__Phonelink__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_628__Phonelink___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_628__Phonelink__);
/* unused harmony reexport Phonelink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_629__PhonelinkErase__ = __webpack_require__(1729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_629__PhonelinkErase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_629__PhonelinkErase__);
/* unused harmony reexport PhonelinkErase */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_630__PhonelinkLock__ = __webpack_require__(1730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_630__PhonelinkLock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_630__PhonelinkLock__);
/* unused harmony reexport PhonelinkLock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_631__PhonelinkOff__ = __webpack_require__(1731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_631__PhonelinkOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_631__PhonelinkOff__);
/* unused harmony reexport PhonelinkOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_632__PhonelinkRing__ = __webpack_require__(1732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_632__PhonelinkRing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_632__PhonelinkRing__);
/* unused harmony reexport PhonelinkRing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_633__PhonelinkSetup__ = __webpack_require__(1733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_633__PhonelinkSetup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_633__PhonelinkSetup__);
/* unused harmony reexport PhonelinkSetup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_634__PhoneLocked__ = __webpack_require__(1734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_634__PhoneLocked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_634__PhoneLocked__);
/* unused harmony reexport PhoneLocked */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_635__PhoneMissed__ = __webpack_require__(1735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_635__PhoneMissed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_635__PhoneMissed__);
/* unused harmony reexport PhoneMissed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_636__PhonePaused__ = __webpack_require__(1736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_636__PhonePaused___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_636__PhonePaused__);
/* unused harmony reexport PhonePaused */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_637__Photo__ = __webpack_require__(1737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_637__Photo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_637__Photo__);
/* unused harmony reexport Photo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_638__PhotoAlbum__ = __webpack_require__(1738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_638__PhotoAlbum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_638__PhotoAlbum__);
/* unused harmony reexport PhotoAlbum */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_639__PhotoCamera__ = __webpack_require__(1739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_639__PhotoCamera___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_639__PhotoCamera__);
/* unused harmony reexport PhotoCamera */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_640__PhotoFilter__ = __webpack_require__(1740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_640__PhotoFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_640__PhotoFilter__);
/* unused harmony reexport PhotoFilter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_641__PhotoLibrary__ = __webpack_require__(1741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_641__PhotoLibrary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_641__PhotoLibrary__);
/* unused harmony reexport PhotoLibrary */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_642__PhotoSizeSelectActual__ = __webpack_require__(1742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_642__PhotoSizeSelectActual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_642__PhotoSizeSelectActual__);
/* unused harmony reexport PhotoSizeSelectActual */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_643__PhotoSizeSelectLarge__ = __webpack_require__(1743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_643__PhotoSizeSelectLarge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_643__PhotoSizeSelectLarge__);
/* unused harmony reexport PhotoSizeSelectLarge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_644__PhotoSizeSelectSmall__ = __webpack_require__(1744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_644__PhotoSizeSelectSmall___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_644__PhotoSizeSelectSmall__);
/* unused harmony reexport PhotoSizeSelectSmall */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_645__PictureAsPdf__ = __webpack_require__(1745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_645__PictureAsPdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_645__PictureAsPdf__);
/* unused harmony reexport PictureAsPdf */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_646__PictureInPicture__ = __webpack_require__(1746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_646__PictureInPicture___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_646__PictureInPicture__);
/* unused harmony reexport PictureInPicture */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_647__PictureInPictureAlt__ = __webpack_require__(1747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_647__PictureInPictureAlt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_647__PictureInPictureAlt__);
/* unused harmony reexport PictureInPictureAlt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_648__PieChart__ = __webpack_require__(1748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_648__PieChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_648__PieChart__);
/* unused harmony reexport PieChart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_649__PieChartOutlined__ = __webpack_require__(1749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_649__PieChartOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_649__PieChartOutlined__);
/* unused harmony reexport PieChartOutlined */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_650__PinDrop__ = __webpack_require__(1750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_650__PinDrop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_650__PinDrop__);
/* unused harmony reexport PinDrop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_651__Place__ = __webpack_require__(1751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_651__Place___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_651__Place__);
/* unused harmony reexport Place */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_652__PlayArrow__ = __webpack_require__(1752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_652__PlayArrow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_652__PlayArrow__);
/* unused harmony reexport PlayArrow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_653__PlayCircleFilled__ = __webpack_require__(1753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_653__PlayCircleFilled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_653__PlayCircleFilled__);
/* unused harmony reexport PlayCircleFilled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_654__PlayCircleOutline__ = __webpack_require__(1754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_654__PlayCircleOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_654__PlayCircleOutline__);
/* unused harmony reexport PlayCircleOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_655__PlayForWork__ = __webpack_require__(1755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_655__PlayForWork___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_655__PlayForWork__);
/* unused harmony reexport PlayForWork */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_656__PlaylistAdd__ = __webpack_require__(1756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_656__PlaylistAdd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_656__PlaylistAdd__);
/* unused harmony reexport PlaylistAdd */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_657__PlaylistAddCheck__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_657__PlaylistAddCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_657__PlaylistAddCheck__);
/* unused harmony reexport PlaylistAddCheck */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_658__PlaylistPlay__ = __webpack_require__(1757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_658__PlaylistPlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_658__PlaylistPlay__);
/* unused harmony reexport PlaylistPlay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_659__PlusOne__ = __webpack_require__(1758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_659__PlusOne___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_659__PlusOne__);
/* unused harmony reexport PlusOne */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_660__Poll__ = __webpack_require__(1759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_660__Poll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_660__Poll__);
/* unused harmony reexport Poll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_661__Polymer__ = __webpack_require__(1760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_661__Polymer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_661__Polymer__);
/* unused harmony reexport Polymer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_662__Pool__ = __webpack_require__(1761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_662__Pool___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_662__Pool__);
/* unused harmony reexport Pool */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_663__PortableWifiOff__ = __webpack_require__(1762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_663__PortableWifiOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_663__PortableWifiOff__);
/* unused harmony reexport PortableWifiOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_664__Portrait__ = __webpack_require__(1763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_664__Portrait___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_664__Portrait__);
/* unused harmony reexport Portrait */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_665__Power__ = __webpack_require__(1764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_665__Power___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_665__Power__);
/* unused harmony reexport Power */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_666__PowerInput__ = __webpack_require__(1765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_666__PowerInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_666__PowerInput__);
/* unused harmony reexport PowerInput */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_667__PowerSettingsNew__ = __webpack_require__(1766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_667__PowerSettingsNew___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_667__PowerSettingsNew__);
/* unused harmony reexport PowerSettingsNew */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_668__PregnantWoman__ = __webpack_require__(1767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_668__PregnantWoman___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_668__PregnantWoman__);
/* unused harmony reexport PregnantWoman */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_669__PresentToAll__ = __webpack_require__(1768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_669__PresentToAll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_669__PresentToAll__);
/* unused harmony reexport PresentToAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_670__Print__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_670__Print___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_670__Print__);
/* unused harmony reexport Print */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_671__PriorityHigh__ = __webpack_require__(1769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_671__PriorityHigh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_671__PriorityHigh__);
/* unused harmony reexport PriorityHigh */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_672__Public__ = __webpack_require__(1770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_672__Public___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_672__Public__);
/* unused harmony reexport Public */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_673__Publish__ = __webpack_require__(1771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_673__Publish___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_673__Publish__);
/* unused harmony reexport Publish */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_674__QueryBuilder__ = __webpack_require__(1772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_674__QueryBuilder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_674__QueryBuilder__);
/* unused harmony reexport QueryBuilder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_675__QuestionAnswer__ = __webpack_require__(1773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_675__QuestionAnswer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_675__QuestionAnswer__);
/* unused harmony reexport QuestionAnswer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_676__Queue__ = __webpack_require__(1774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_676__Queue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_676__Queue__);
/* unused harmony reexport Queue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_677__QueueMusic__ = __webpack_require__(1775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_677__QueueMusic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_677__QueueMusic__);
/* unused harmony reexport QueueMusic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_678__QueuePlayNext__ = __webpack_require__(1776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_678__QueuePlayNext___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_678__QueuePlayNext__);
/* unused harmony reexport QueuePlayNext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_679__Radio__ = __webpack_require__(1777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_679__Radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_679__Radio__);
/* unused harmony reexport Radio */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_680__RadioButtonChecked__ = __webpack_require__(1778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_680__RadioButtonChecked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_680__RadioButtonChecked__);
/* unused harmony reexport RadioButtonChecked */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_681__RadioButtonUnchecked__ = __webpack_require__(1779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_681__RadioButtonUnchecked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_681__RadioButtonUnchecked__);
/* unused harmony reexport RadioButtonUnchecked */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_682__RateReview__ = __webpack_require__(1780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_682__RateReview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_682__RateReview__);
/* unused harmony reexport RateReview */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_683__Receipt__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_683__Receipt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_683__Receipt__);
/* unused harmony reexport Receipt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_684__RecentActors__ = __webpack_require__(1781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_684__RecentActors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_684__RecentActors__);
/* unused harmony reexport RecentActors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_685__RecordVoiceOver__ = __webpack_require__(1782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_685__RecordVoiceOver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_685__RecordVoiceOver__);
/* unused harmony reexport RecordVoiceOver */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_686__Redeem__ = __webpack_require__(1783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_686__Redeem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_686__Redeem__);
/* unused harmony reexport Redeem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_687__Redo__ = __webpack_require__(1784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_687__Redo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_687__Redo__);
/* unused harmony reexport Redo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_688__Refresh__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_688__Refresh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_688__Refresh__);
/* unused harmony reexport Refresh */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_689__Remove__ = __webpack_require__(1785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_689__Remove___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_689__Remove__);
/* unused harmony reexport Remove */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_690__RemoveCircle__ = __webpack_require__(1786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_690__RemoveCircle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_690__RemoveCircle__);
/* unused harmony reexport RemoveCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_691__RemoveCircleOutline__ = __webpack_require__(1787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_691__RemoveCircleOutline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_691__RemoveCircleOutline__);
/* unused harmony reexport RemoveCircleOutline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_692__RemoveFromQueue__ = __webpack_require__(1788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_692__RemoveFromQueue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_692__RemoveFromQueue__);
/* unused harmony reexport RemoveFromQueue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_693__RemoveRedEye__ = __webpack_require__(1789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_693__RemoveRedEye___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_693__RemoveRedEye__);
/* unused harmony reexport RemoveRedEye */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_694__RemoveShoppingCart__ = __webpack_require__(1790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_694__RemoveShoppingCart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_694__RemoveShoppingCart__);
/* unused harmony reexport RemoveShoppingCart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_695__Reorder__ = __webpack_require__(1791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_695__Reorder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_695__Reorder__);
/* unused harmony reexport Reorder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_696__Repeat__ = __webpack_require__(1792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_696__Repeat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_696__Repeat__);
/* unused harmony reexport Repeat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_697__RepeatOne__ = __webpack_require__(1793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_697__RepeatOne___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_697__RepeatOne__);
/* unused harmony reexport RepeatOne */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_698__Replay__ = __webpack_require__(1794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_698__Replay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_698__Replay__);
/* unused harmony reexport Replay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_699__Replay10__ = __webpack_require__(1795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_699__Replay10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_699__Replay10__);
/* unused harmony reexport Replay10 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_700__Replay30__ = __webpack_require__(1796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_700__Replay30___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_700__Replay30__);
/* unused harmony reexport Replay30 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_701__Replay5__ = __webpack_require__(1797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_701__Replay5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_701__Replay5__);
/* unused harmony reexport Replay5 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_702__Reply__ = __webpack_require__(1798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_702__Reply___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_702__Reply__);
/* unused harmony reexport Reply */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_703__ReplyAll__ = __webpack_require__(1799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_703__ReplyAll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_703__ReplyAll__);
/* unused harmony reexport ReplyAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_704__Report__ = __webpack_require__(1800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_704__Report___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_704__Report__);
/* unused harmony reexport Report */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_705__ReportProblem__ = __webpack_require__(1801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_705__ReportProblem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_705__ReportProblem__);
/* unused harmony reexport ReportProblem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_706__Restaurant__ = __webpack_require__(1802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_706__Restaurant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_706__Restaurant__);
/* unused harmony reexport Restaurant */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_707__RestaurantMenu__ = __webpack_require__(1803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_707__RestaurantMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_707__RestaurantMenu__);
/* unused harmony reexport RestaurantMenu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_708__Restore__ = __webpack_require__(1804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_708__Restore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_708__Restore__);
/* unused harmony reexport Restore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_709__RestorePage__ = __webpack_require__(1805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_709__RestorePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_709__RestorePage__);
/* unused harmony reexport RestorePage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_710__RingVolume__ = __webpack_require__(1806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_710__RingVolume___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_710__RingVolume__);
/* unused harmony reexport RingVolume */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_711__Room__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_711__Room___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_711__Room__);
/* unused harmony reexport Room */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_712__RoomService__ = __webpack_require__(1807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_712__RoomService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_712__RoomService__);
/* unused harmony reexport RoomService */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_713__Rotate90DegreesCcw__ = __webpack_require__(1808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_713__Rotate90DegreesCcw___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_713__Rotate90DegreesCcw__);
/* unused harmony reexport Rotate90DegreesCcw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_714__RotateLeft__ = __webpack_require__(1809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_714__RotateLeft___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_714__RotateLeft__);
/* unused harmony reexport RotateLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_715__RotateRight__ = __webpack_require__(1810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_715__RotateRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_715__RotateRight__);
/* unused harmony reexport RotateRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_716__RoundedCorner__ = __webpack_require__(1811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_716__RoundedCorner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_716__RoundedCorner__);
/* unused harmony reexport RoundedCorner */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_717__Router__ = __webpack_require__(1812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_717__Router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_717__Router__);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_718__Rowing__ = __webpack_require__(1813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_718__Rowing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_718__Rowing__);
/* unused harmony reexport Rowing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_719__RssFeed__ = __webpack_require__(1814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_719__RssFeed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_719__RssFeed__);
/* unused harmony reexport RssFeed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_720__RvHookup__ = __webpack_require__(1815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_720__RvHookup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_720__RvHookup__);
/* unused harmony reexport RvHookup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_721__Satellite__ = __webpack_require__(1816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_721__Satellite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_721__Satellite__);
/* unused harmony reexport Satellite */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_722__Save__ = __webpack_require__(1817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_722__Save___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_722__Save__);
/* unused harmony reexport Save */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_723__Scanner__ = __webpack_require__(1818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_723__Scanner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_723__Scanner__);
/* unused harmony reexport Scanner */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_724__Schedule__ = __webpack_require__(1819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_724__Schedule___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_724__Schedule__);
/* unused harmony reexport Schedule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_725__School__ = __webpack_require__(1820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_725__School___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_725__School__);
/* unused harmony reexport School */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_726__ScreenLockLandscape__ = __webpack_require__(1821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_726__ScreenLockLandscape___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_726__ScreenLockLandscape__);
/* unused harmony reexport ScreenLockLandscape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_727__ScreenLockPortrait__ = __webpack_require__(1822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_727__ScreenLockPortrait___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_727__ScreenLockPortrait__);
/* unused harmony reexport ScreenLockPortrait */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_728__ScreenLockRotation__ = __webpack_require__(1823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_728__ScreenLockRotation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_728__ScreenLockRotation__);
/* unused harmony reexport ScreenLockRotation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_729__ScreenRotation__ = __webpack_require__(1824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_729__ScreenRotation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_729__ScreenRotation__);
/* unused harmony reexport ScreenRotation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_730__ScreenShare__ = __webpack_require__(1825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_730__ScreenShare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_730__ScreenShare__);
/* unused harmony reexport ScreenShare */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_731__SdCard__ = __webpack_require__(1826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_731__SdCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_731__SdCard__);
/* unused harmony reexport SdCard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_732__SdStorage__ = __webpack_require__(1827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_732__SdStorage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_732__SdStorage__);
/* unused harmony reexport SdStorage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_733__Search__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_733__Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_733__Search__);
/* unused harmony reexport Search */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_734__Security__ = __webpack_require__(1828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_734__Security___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_734__Security__);
/* unused harmony reexport Security */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_735__SelectAll__ = __webpack_require__(1829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_735__SelectAll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_735__SelectAll__);
/* unused harmony reexport SelectAll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_736__Send__ = __webpack_require__(1830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_736__Send___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_736__Send__);
/* unused harmony reexport Send */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_737__SentimentDissatisfied__ = __webpack_require__(1831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_737__SentimentDissatisfied___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_737__SentimentDissatisfied__);
/* unused harmony reexport SentimentDissatisfied */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_738__SentimentNeutral__ = __webpack_require__(1832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_738__SentimentNeutral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_738__SentimentNeutral__);
/* unused harmony reexport SentimentNeutral */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_739__SentimentSatisfied__ = __webpack_require__(1833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_739__SentimentSatisfied___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_739__SentimentSatisfied__);
/* unused harmony reexport SentimentSatisfied */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_740__SentimentVeryDissatisfied__ = __webpack_require__(1834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_740__SentimentVeryDissatisfied___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_740__SentimentVeryDissatisfied__);
/* unused harmony reexport SentimentVeryDissatisfied */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_741__SentimentVerySatisfied__ = __webpack_require__(1835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_741__SentimentVerySatisfied___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_741__SentimentVerySatisfied__);
/* unused harmony reexport SentimentVerySatisfied */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_742__Settings__ = __webpack_require__(1836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_742__Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_742__Settings__);
/* unused harmony reexport Settings */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_743__SettingsApplications__ = __webpack_require__(1837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_743__SettingsApplications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_743__SettingsApplications__);
/* unused harmony reexport SettingsApplications */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_744__SettingsBackupRestore__ = __webpack_require__(1838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_744__SettingsBackupRestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_744__SettingsBackupRestore__);
/* unused harmony reexport SettingsBackupRestore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_745__SettingsBluetooth__ = __webpack_require__(1839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_745__SettingsBluetooth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_745__SettingsBluetooth__);
/* unused harmony reexport SettingsBluetooth */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_746__SettingsBrightness__ = __webpack_require__(1840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_746__SettingsBrightness___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_746__SettingsBrightness__);
/* unused harmony reexport SettingsBrightness */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_747__SettingsCell__ = __webpack_require__(1841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_747__SettingsCell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_747__SettingsCell__);
/* unused harmony reexport SettingsCell */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_748__SettingsEthernet__ = __webpack_require__(1842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_748__SettingsEthernet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_748__SettingsEthernet__);
/* unused harmony reexport SettingsEthernet */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_749__SettingsInputAntenna__ = __webpack_require__(1843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_749__SettingsInputAntenna___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_749__SettingsInputAntenna__);
/* unused harmony reexport SettingsInputAntenna */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_750__SettingsInputComponent__ = __webpack_require__(1844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_750__SettingsInputComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_750__SettingsInputComponent__);
/* unused harmony reexport SettingsInputComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_751__SettingsInputComposite__ = __webpack_require__(1845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_751__SettingsInputComposite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_751__SettingsInputComposite__);
/* unused harmony reexport SettingsInputComposite */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_752__SettingsInputHdmi__ = __webpack_require__(1846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_752__SettingsInputHdmi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_752__SettingsInputHdmi__);
/* unused harmony reexport SettingsInputHdmi */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_753__SettingsInputSvideo__ = __webpack_require__(1847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_753__SettingsInputSvideo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_753__SettingsInputSvideo__);
/* unused harmony reexport SettingsInputSvideo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_754__SettingsOverscan__ = __webpack_require__(1848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_754__SettingsOverscan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_754__SettingsOverscan__);
/* unused harmony reexport SettingsOverscan */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_755__SettingsPhone__ = __webpack_require__(1849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_755__SettingsPhone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_755__SettingsPhone__);
/* unused harmony reexport SettingsPhone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_756__SettingsPower__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_756__SettingsPower___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_756__SettingsPower__);
/* unused harmony reexport SettingsPower */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_757__SettingsRemote__ = __webpack_require__(1850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_757__SettingsRemote___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_757__SettingsRemote__);
/* unused harmony reexport SettingsRemote */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_758__SettingsSystemDaydream__ = __webpack_require__(1851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_758__SettingsSystemDaydream___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_758__SettingsSystemDaydream__);
/* unused harmony reexport SettingsSystemDaydream */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_759__SettingsVoice__ = __webpack_require__(1852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_759__SettingsVoice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_759__SettingsVoice__);
/* unused harmony reexport SettingsVoice */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_760__Share__ = __webpack_require__(1853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_760__Share___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_760__Share__);
/* unused harmony reexport Share */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_761__Shop__ = __webpack_require__(1854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_761__Shop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_761__Shop__);
/* unused harmony reexport Shop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_762__ShoppingBasket__ = __webpack_require__(1855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_762__ShoppingBasket___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_762__ShoppingBasket__);
/* unused harmony reexport ShoppingBasket */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_763__ShoppingCart__ = __webpack_require__(1856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_763__ShoppingCart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_763__ShoppingCart__);
/* unused harmony reexport ShoppingCart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_764__ShopTwo__ = __webpack_require__(1857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_764__ShopTwo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_764__ShopTwo__);
/* unused harmony reexport ShopTwo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_765__ShortText__ = __webpack_require__(1858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_765__ShortText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_765__ShortText__);
/* unused harmony reexport ShortText */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_766__ShowChart__ = __webpack_require__(1859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_766__ShowChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_766__ShowChart__);
/* unused harmony reexport ShowChart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_767__Shuffle__ = __webpack_require__(1860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_767__Shuffle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_767__Shuffle__);
/* unused harmony reexport Shuffle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_768__SignalCellular0Bar__ = __webpack_require__(1861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_768__SignalCellular0Bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_768__SignalCellular0Bar__);
/* unused harmony reexport SignalCellular0Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_769__SignalCellular1Bar__ = __webpack_require__(1862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_769__SignalCellular1Bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_769__SignalCellular1Bar__);
/* unused harmony reexport SignalCellular1Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_770__SignalCellular2Bar__ = __webpack_require__(1863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_770__SignalCellular2Bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_770__SignalCellular2Bar__);
/* unused harmony reexport SignalCellular2Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_771__SignalCellular3Bar__ = __webpack_require__(1864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_771__SignalCellular3Bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_771__SignalCellular3Bar__);
/* unused harmony reexport SignalCellular3Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_772__SignalCellular4Bar__ = __webpack_require__(1865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_772__SignalCellular4Bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_772__SignalCellular4Bar__);
/* unused harmony reexport SignalCellular4Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_773__SignalCellularConnectedNoInternet0Bar__ = __webpack_require__(1866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_773__SignalCellularConnectedNoInternet0Bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_773__SignalCellularConnectedNoInternet0Bar__);
/* unused harmony reexport SignalCellularConnectedNoInternet0Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_774__SignalCellularConnectedNoInternet1Bar__ = __webpack_require__(1867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_774__SignalCellularConnectedNoInternet1Bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_774__SignalCellularConnectedNoInternet1Bar__);
/* unused harmony reexport SignalCellularConnectedNoInternet1Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_775__SignalCellularConnectedNoInternet2Bar__ = __webpack_require__(1868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_775__SignalCellularConnectedNoInternet2Bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_775__SignalCellularConnectedNoInternet2Bar__);
/* unused harmony reexport SignalCellularConnectedNoInternet2Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_776__SignalCellularConnectedNoInternet3Bar__ = __webpack_require__(1869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_776__SignalCellularConnectedNoInternet3Bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_776__SignalCellularConnectedNoInternet3Bar__);
/* unused harmony reexport SignalCellularConnectedNoInternet3Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_777__SignalCellularConnectedNoInternet4Bar__ = __webpack_require__(1870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_777__SignalCellularConnectedNoInternet4Bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_777__SignalCellularConnectedNoInternet4Bar__);
/* unused harmony reexport SignalCellularConnectedNoInternet4Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_778__SignalCellularNoSim__ = __webpack_require__(1871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_778__SignalCellularNoSim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_778__SignalCellularNoSim__);
/* unused harmony reexport SignalCellularNoSim */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_779__SignalCellularNull__ = __webpack_require__(1872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_779__SignalCellularNull___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_779__SignalCellularNull__);
/* unused harmony reexport SignalCellularNull */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_780__SignalCellularOff__ = __webpack_require__(1873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_780__SignalCellularOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_780__SignalCellularOff__);
/* unused harmony reexport SignalCellularOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_781__SignalWifi0Bar__ = __webpack_require__(1874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_781__SignalWifi0Bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_781__SignalWifi0Bar__);
/* unused harmony reexport SignalWifi0Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_782__SignalWifi1Bar__ = __webpack_require__(1875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_782__SignalWifi1Bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_782__SignalWifi1Bar__);
/* unused harmony reexport SignalWifi1Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_783__SignalWifi1BarLock__ = __webpack_require__(1876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_783__SignalWifi1BarLock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_783__SignalWifi1BarLock__);
/* unused harmony reexport SignalWifi1BarLock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_784__SignalWifi2Bar__ = __webpack_require__(1877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_784__SignalWifi2Bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_784__SignalWifi2Bar__);
/* unused harmony reexport SignalWifi2Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_785__SignalWifi2BarLock__ = __webpack_require__(1878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_785__SignalWifi2BarLock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_785__SignalWifi2BarLock__);
/* unused harmony reexport SignalWifi2BarLock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_786__SignalWifi3Bar__ = __webpack_require__(1879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_786__SignalWifi3Bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_786__SignalWifi3Bar__);
/* unused harmony reexport SignalWifi3Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_787__SignalWifi3BarLock__ = __webpack_require__(1880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_787__SignalWifi3BarLock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_787__SignalWifi3BarLock__);
/* unused harmony reexport SignalWifi3BarLock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_788__SignalWifi4Bar__ = __webpack_require__(1881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_788__SignalWifi4Bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_788__SignalWifi4Bar__);
/* unused harmony reexport SignalWifi4Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_789__SignalWifi4BarLock__ = __webpack_require__(1882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_789__SignalWifi4BarLock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_789__SignalWifi4BarLock__);
/* unused harmony reexport SignalWifi4BarLock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_790__SignalWifiOff__ = __webpack_require__(1883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_790__SignalWifiOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_790__SignalWifiOff__);
/* unused harmony reexport SignalWifiOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_791__SimCard__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_791__SimCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_791__SimCard__);
/* unused harmony reexport SimCard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_792__SimCardAlert__ = __webpack_require__(1884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_792__SimCardAlert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_792__SimCardAlert__);
/* unused harmony reexport SimCardAlert */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_793__SkipNext__ = __webpack_require__(1885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_793__SkipNext___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_793__SkipNext__);
/* unused harmony reexport SkipNext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_794__SkipPrevious__ = __webpack_require__(1886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_794__SkipPrevious___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_794__SkipPrevious__);
/* unused harmony reexport SkipPrevious */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_795__Slideshow__ = __webpack_require__(1887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_795__Slideshow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_795__Slideshow__);
/* unused harmony reexport Slideshow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_796__SlowMotionVideo__ = __webpack_require__(1888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_796__SlowMotionVideo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_796__SlowMotionVideo__);
/* unused harmony reexport SlowMotionVideo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_797__Smartphone__ = __webpack_require__(1889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_797__Smartphone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_797__Smartphone__);
/* unused harmony reexport Smartphone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_798__SmokeFree__ = __webpack_require__(1890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_798__SmokeFree___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_798__SmokeFree__);
/* unused harmony reexport SmokeFree */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_799__SmokingRooms__ = __webpack_require__(1891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_799__SmokingRooms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_799__SmokingRooms__);
/* unused harmony reexport SmokingRooms */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_800__Sms__ = __webpack_require__(1892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_800__Sms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_800__Sms__);
/* unused harmony reexport Sms */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_801__SmsFailed__ = __webpack_require__(1893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_801__SmsFailed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_801__SmsFailed__);
/* unused harmony reexport SmsFailed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_802__Snooze__ = __webpack_require__(1894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_802__Snooze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_802__Snooze__);
/* unused harmony reexport Snooze */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_803__Sort__ = __webpack_require__(1895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_803__Sort___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_803__Sort__);
/* unused harmony reexport Sort */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_804__SortByAlpha__ = __webpack_require__(1896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_804__SortByAlpha___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_804__SortByAlpha__);
/* unused harmony reexport SortByAlpha */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_805__Spa__ = __webpack_require__(1897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_805__Spa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_805__Spa__);
/* unused harmony reexport Spa */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_806__SpaceBar__ = __webpack_require__(1898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_806__SpaceBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_806__SpaceBar__);
/* unused harmony reexport SpaceBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_807__Speaker__ = __webpack_require__(1899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_807__Speaker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_807__Speaker__);
/* unused harmony reexport Speaker */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_808__SpeakerGroup__ = __webpack_require__(1900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_808__SpeakerGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_808__SpeakerGroup__);
/* unused harmony reexport SpeakerGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_809__SpeakerNotes__ = __webpack_require__(1901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_809__SpeakerNotes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_809__SpeakerNotes__);
/* unused harmony reexport SpeakerNotes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_810__SpeakerNotesOff__ = __webpack_require__(1902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_810__SpeakerNotesOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_810__SpeakerNotesOff__);
/* unused harmony reexport SpeakerNotesOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_811__SpeakerPhone__ = __webpack_require__(1903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_811__SpeakerPhone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_811__SpeakerPhone__);
/* unused harmony reexport SpeakerPhone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_812__Spellcheck__ = __webpack_require__(1904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_812__Spellcheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_812__Spellcheck__);
/* unused harmony reexport Spellcheck */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_813__Star__ = __webpack_require__(1905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_813__Star___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_813__Star__);
/* unused harmony reexport Star */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_814__StarBorder__ = __webpack_require__(1906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_814__StarBorder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_814__StarBorder__);
/* unused harmony reexport StarBorder */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_815__StarHalf__ = __webpack_require__(1907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_815__StarHalf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_815__StarHalf__);
/* unused harmony reexport StarHalf */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_816__Stars__ = __webpack_require__(1908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_816__Stars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_816__Stars__);
/* unused harmony reexport Stars */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_817__StayCurrentLandscape__ = __webpack_require__(1909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_817__StayCurrentLandscape___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_817__StayCurrentLandscape__);
/* unused harmony reexport StayCurrentLandscape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_818__StayCurrentPortrait__ = __webpack_require__(1910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_818__StayCurrentPortrait___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_818__StayCurrentPortrait__);
/* unused harmony reexport StayCurrentPortrait */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_819__StayPrimaryLandscape__ = __webpack_require__(1911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_819__StayPrimaryLandscape___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_819__StayPrimaryLandscape__);
/* unused harmony reexport StayPrimaryLandscape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_820__StayPrimaryPortrait__ = __webpack_require__(1912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_820__StayPrimaryPortrait___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_820__StayPrimaryPortrait__);
/* unused harmony reexport StayPrimaryPortrait */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_821__Stop__ = __webpack_require__(1913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_821__Stop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_821__Stop__);
/* unused harmony reexport Stop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_822__StopScreenShare__ = __webpack_require__(1914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_822__StopScreenShare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_822__StopScreenShare__);
/* unused harmony reexport StopScreenShare */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_823__Storage__ = __webpack_require__(1915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_823__Storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_823__Storage__);
/* unused harmony reexport Storage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_824__Store__ = __webpack_require__(1916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_824__Store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_824__Store__);
/* unused harmony reexport Store */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_825__StoreMallDirectory__ = __webpack_require__(1917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_825__StoreMallDirectory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_825__StoreMallDirectory__);
/* unused harmony reexport StoreMallDirectory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_826__Straighten__ = __webpack_require__(1918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_826__Straighten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_826__Straighten__);
/* unused harmony reexport Straighten */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_827__Streetview__ = __webpack_require__(1919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_827__Streetview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_827__Streetview__);
/* unused harmony reexport Streetview */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_828__StrikethroughS__ = __webpack_require__(1920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_828__StrikethroughS___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_828__StrikethroughS__);
/* unused harmony reexport StrikethroughS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_829__Style__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_829__Style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_829__Style__);
/* unused harmony reexport Style */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_830__SubdirectoryArrowLeft__ = __webpack_require__(1921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_830__SubdirectoryArrowLeft___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_830__SubdirectoryArrowLeft__);
/* unused harmony reexport SubdirectoryArrowLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_831__SubdirectoryArrowRight__ = __webpack_require__(1922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_831__SubdirectoryArrowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_831__SubdirectoryArrowRight__);
/* unused harmony reexport SubdirectoryArrowRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_832__Subject__ = __webpack_require__(1923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_832__Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_832__Subject__);
/* unused harmony reexport Subject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_833__Subscriptions__ = __webpack_require__(1924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_833__Subscriptions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_833__Subscriptions__);
/* unused harmony reexport Subscriptions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_834__Subtitles__ = __webpack_require__(1925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_834__Subtitles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_834__Subtitles__);
/* unused harmony reexport Subtitles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_835__Subway__ = __webpack_require__(1926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_835__Subway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_835__Subway__);
/* unused harmony reexport Subway */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_836__SupervisorAccount__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_836__SupervisorAccount___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_836__SupervisorAccount__);
/* unused harmony reexport SupervisorAccount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_837__SurroundSound__ = __webpack_require__(1927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_837__SurroundSound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_837__SurroundSound__);
/* unused harmony reexport SurroundSound */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_838__SwapCalls__ = __webpack_require__(1928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_838__SwapCalls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_838__SwapCalls__);
/* unused harmony reexport SwapCalls */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_839__SwapHoriz__ = __webpack_require__(1929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_839__SwapHoriz___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_839__SwapHoriz__);
/* unused harmony reexport SwapHoriz */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_840__SwapVert__ = __webpack_require__(1930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_840__SwapVert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_840__SwapVert__);
/* unused harmony reexport SwapVert */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_841__SwapVerticalCircle__ = __webpack_require__(1931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_841__SwapVerticalCircle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_841__SwapVerticalCircle__);
/* unused harmony reexport SwapVerticalCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_842__SwitchCamera__ = __webpack_require__(1932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_842__SwitchCamera___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_842__SwitchCamera__);
/* unused harmony reexport SwitchCamera */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_843__SwitchVideo__ = __webpack_require__(1933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_843__SwitchVideo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_843__SwitchVideo__);
/* unused harmony reexport SwitchVideo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_844__Sync__ = __webpack_require__(1934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_844__Sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_844__Sync__);
/* unused harmony reexport Sync */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_845__SyncDisabled__ = __webpack_require__(1935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_845__SyncDisabled___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_845__SyncDisabled__);
/* unused harmony reexport SyncDisabled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_846__SyncProblem__ = __webpack_require__(1936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_846__SyncProblem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_846__SyncProblem__);
/* unused harmony reexport SyncProblem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_847__SystemUpdate__ = __webpack_require__(1937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_847__SystemUpdate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_847__SystemUpdate__);
/* unused harmony reexport SystemUpdate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_848__SystemUpdateAlt__ = __webpack_require__(1938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_848__SystemUpdateAlt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_848__SystemUpdateAlt__);
/* unused harmony reexport SystemUpdateAlt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_849__Tab__ = __webpack_require__(1939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_849__Tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_849__Tab__);
/* unused harmony reexport Tab */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_850__Tablet__ = __webpack_require__(1940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_850__Tablet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_850__Tablet__);
/* unused harmony reexport Tablet */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_851__TabletAndroid__ = __webpack_require__(1941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_851__TabletAndroid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_851__TabletAndroid__);
/* unused harmony reexport TabletAndroid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_852__TabletMac__ = __webpack_require__(1942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_852__TabletMac___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_852__TabletMac__);
/* unused harmony reexport TabletMac */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_853__TabUnselected__ = __webpack_require__(1943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_853__TabUnselected___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_853__TabUnselected__);
/* unused harmony reexport TabUnselected */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_854__TagFaces__ = __webpack_require__(1944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_854__TagFaces___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_854__TagFaces__);
/* unused harmony reexport TagFaces */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_855__TapAndPlay__ = __webpack_require__(1945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_855__TapAndPlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_855__TapAndPlay__);
/* unused harmony reexport TapAndPlay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_856__Terrain__ = __webpack_require__(1946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_856__Terrain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_856__Terrain__);
/* unused harmony reexport Terrain */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_857__TextFields__ = __webpack_require__(1947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_857__TextFields___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_857__TextFields__);
/* unused harmony reexport TextFields */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_858__TextFormat__ = __webpack_require__(1948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_858__TextFormat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_858__TextFormat__);
/* unused harmony reexport TextFormat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_859__Textsms__ = __webpack_require__(1949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_859__Textsms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_859__Textsms__);
/* unused harmony reexport Textsms */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_860__Texture__ = __webpack_require__(1950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_860__Texture___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_860__Texture__);
/* unused harmony reexport Texture */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_861__Theaters__ = __webpack_require__(1951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_861__Theaters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_861__Theaters__);
/* unused harmony reexport Theaters */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_862__ThreeDRotation__ = __webpack_require__(1952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_862__ThreeDRotation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_862__ThreeDRotation__);
/* unused harmony reexport ThreeDRotation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_863__ThumbDown__ = __webpack_require__(1953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_863__ThumbDown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_863__ThumbDown__);
/* unused harmony reexport ThumbDown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_864__ThumbsUpDown__ = __webpack_require__(1954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_864__ThumbsUpDown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_864__ThumbsUpDown__);
/* unused harmony reexport ThumbsUpDown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_865__ThumbUp__ = __webpack_require__(1955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_865__ThumbUp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_865__ThumbUp__);
/* unused harmony reexport ThumbUp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_866__Timelapse__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_866__Timelapse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_866__Timelapse__);
/* unused harmony reexport Timelapse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_867__Timeline__ = __webpack_require__(1956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_867__Timeline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_867__Timeline__);
/* unused harmony reexport Timeline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_868__Timer__ = __webpack_require__(1957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_868__Timer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_868__Timer__);
/* unused harmony reexport Timer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_869__Timer10__ = __webpack_require__(1958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_869__Timer10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_869__Timer10__);
/* unused harmony reexport Timer10 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_870__Timer3__ = __webpack_require__(1959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_870__Timer3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_870__Timer3__);
/* unused harmony reexport Timer3 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_871__TimerOff__ = __webpack_require__(1960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_871__TimerOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_871__TimerOff__);
/* unused harmony reexport TimerOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_872__TimeToLeave__ = __webpack_require__(1961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_872__TimeToLeave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_872__TimeToLeave__);
/* unused harmony reexport TimeToLeave */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_873__Title__ = __webpack_require__(1962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_873__Title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_873__Title__);
/* unused harmony reexport Title */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_874__Toc__ = __webpack_require__(1963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_874__Toc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_874__Toc__);
/* unused harmony reexport Toc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_875__Today__ = __webpack_require__(1964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_875__Today___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_875__Today__);
/* unused harmony reexport Today */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_876__Toll__ = __webpack_require__(1965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_876__Toll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_876__Toll__);
/* unused harmony reexport Toll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_877__Tonality__ = __webpack_require__(1966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_877__Tonality___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_877__Tonality__);
/* unused harmony reexport Tonality */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_878__TouchApp__ = __webpack_require__(1967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_878__TouchApp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_878__TouchApp__);
/* unused harmony reexport TouchApp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_879__Toys__ = __webpack_require__(1968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_879__Toys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_879__Toys__);
/* unused harmony reexport Toys */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_880__TrackChanges__ = __webpack_require__(1969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_880__TrackChanges___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_880__TrackChanges__);
/* unused harmony reexport TrackChanges */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_881__Traffic__ = __webpack_require__(1970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_881__Traffic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_881__Traffic__);
/* unused harmony reexport Traffic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_882__Train__ = __webpack_require__(1971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_882__Train___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_882__Train__);
/* unused harmony reexport Train */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_883__Tram__ = __webpack_require__(1972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_883__Tram___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_883__Tram__);
/* unused harmony reexport Tram */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_884__TransferWithinAStation__ = __webpack_require__(1973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_884__TransferWithinAStation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_884__TransferWithinAStation__);
/* unused harmony reexport TransferWithinAStation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_885__Transform__ = __webpack_require__(1974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_885__Transform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_885__Transform__);
/* unused harmony reexport Transform */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_886__Translate__ = __webpack_require__(1975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_886__Translate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_886__Translate__);
/* unused harmony reexport Translate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_887__TrendingDown__ = __webpack_require__(1976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_887__TrendingDown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_887__TrendingDown__);
/* unused harmony reexport TrendingDown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_888__TrendingFlat__ = __webpack_require__(1977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_888__TrendingFlat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_888__TrendingFlat__);
/* unused harmony reexport TrendingFlat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_889__TrendingUp__ = __webpack_require__(1978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_889__TrendingUp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_889__TrendingUp__);
/* unused harmony reexport TrendingUp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_890__Tune__ = __webpack_require__(1979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_890__Tune___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_890__Tune__);
/* unused harmony reexport Tune */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_891__TurnedIn__ = __webpack_require__(1980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_891__TurnedIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_891__TurnedIn__);
/* unused harmony reexport TurnedIn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_892__TurnedInNot__ = __webpack_require__(1981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_892__TurnedInNot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_892__TurnedInNot__);
/* unused harmony reexport TurnedInNot */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_893__Tv__ = __webpack_require__(1982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_893__Tv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_893__Tv__);
/* unused harmony reexport Tv */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_894__Unarchive__ = __webpack_require__(1983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_894__Unarchive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_894__Unarchive__);
/* unused harmony reexport Unarchive */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_895__Undo__ = __webpack_require__(1984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_895__Undo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_895__Undo__);
/* unused harmony reexport Undo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_896__UnfoldLess__ = __webpack_require__(1985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_896__UnfoldLess___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_896__UnfoldLess__);
/* unused harmony reexport UnfoldLess */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_897__UnfoldMore__ = __webpack_require__(1986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_897__UnfoldMore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_897__UnfoldMore__);
/* unused harmony reexport UnfoldMore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_898__Update__ = __webpack_require__(1987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_898__Update___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_898__Update__);
/* unused harmony reexport Update */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_899__Usb__ = __webpack_require__(1988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_899__Usb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_899__Usb__);
/* unused harmony reexport Usb */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_900__VerifiedUser__ = __webpack_require__(1989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_900__VerifiedUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_900__VerifiedUser__);
/* unused harmony reexport VerifiedUser */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_901__VerticalAlignBottom__ = __webpack_require__(1990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_901__VerticalAlignBottom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_901__VerticalAlignBottom__);
/* unused harmony reexport VerticalAlignBottom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_902__VerticalAlignCenter__ = __webpack_require__(1991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_902__VerticalAlignCenter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_902__VerticalAlignCenter__);
/* unused harmony reexport VerticalAlignCenter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_903__VerticalAlignTop__ = __webpack_require__(1992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_903__VerticalAlignTop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_903__VerticalAlignTop__);
/* unused harmony reexport VerticalAlignTop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_904__Vibration__ = __webpack_require__(1993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_904__Vibration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_904__Vibration__);
/* unused harmony reexport Vibration */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_905__VideoCall__ = __webpack_require__(1994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_905__VideoCall___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_905__VideoCall__);
/* unused harmony reexport VideoCall */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_906__Videocam__ = __webpack_require__(1995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_906__Videocam___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_906__Videocam__);
/* unused harmony reexport Videocam */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_907__VideocamOff__ = __webpack_require__(1996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_907__VideocamOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_907__VideocamOff__);
/* unused harmony reexport VideocamOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_908__VideogameAsset__ = __webpack_require__(1997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_908__VideogameAsset___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_908__VideogameAsset__);
/* unused harmony reexport VideogameAsset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_909__VideoLabel__ = __webpack_require__(1998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_909__VideoLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_909__VideoLabel__);
/* unused harmony reexport VideoLabel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_910__VideoLibrary__ = __webpack_require__(1999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_910__VideoLibrary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_910__VideoLibrary__);
/* unused harmony reexport VideoLibrary */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_911__ViewAgenda__ = __webpack_require__(2000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_911__ViewAgenda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_911__ViewAgenda__);
/* unused harmony reexport ViewAgenda */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_912__ViewArray__ = __webpack_require__(2001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_912__ViewArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_912__ViewArray__);
/* unused harmony reexport ViewArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_913__ViewCarousel__ = __webpack_require__(2002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_913__ViewCarousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_913__ViewCarousel__);
/* unused harmony reexport ViewCarousel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_914__ViewColumn__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_914__ViewColumn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_914__ViewColumn__);
/* unused harmony reexport ViewColumn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_915__ViewComfy__ = __webpack_require__(2003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_915__ViewComfy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_915__ViewComfy__);
/* unused harmony reexport ViewComfy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_916__ViewCompact__ = __webpack_require__(2004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_916__ViewCompact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_916__ViewCompact__);
/* unused harmony reexport ViewCompact */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_917__ViewDay__ = __webpack_require__(2005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_917__ViewDay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_917__ViewDay__);
/* unused harmony reexport ViewDay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_918__ViewHeadline__ = __webpack_require__(2006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_918__ViewHeadline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_918__ViewHeadline__);
/* unused harmony reexport ViewHeadline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_919__ViewList__ = __webpack_require__(2007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_919__ViewList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_919__ViewList__);
/* unused harmony reexport ViewList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_920__ViewModule__ = __webpack_require__(2008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_920__ViewModule___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_920__ViewModule__);
/* unused harmony reexport ViewModule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_921__ViewQuilt__ = __webpack_require__(2009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_921__ViewQuilt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_921__ViewQuilt__);
/* unused harmony reexport ViewQuilt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_922__ViewStream__ = __webpack_require__(2010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_922__ViewStream___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_922__ViewStream__);
/* unused harmony reexport ViewStream */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_923__ViewWeek__ = __webpack_require__(2011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_923__ViewWeek___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_923__ViewWeek__);
/* unused harmony reexport ViewWeek */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_924__Vignette__ = __webpack_require__(2012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_924__Vignette___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_924__Vignette__);
/* unused harmony reexport Vignette */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_925__Visibility__ = __webpack_require__(2013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_925__Visibility___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_925__Visibility__);
/* unused harmony reexport Visibility */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_926__VisibilityOff__ = __webpack_require__(2014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_926__VisibilityOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_926__VisibilityOff__);
/* unused harmony reexport VisibilityOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_927__VoiceChat__ = __webpack_require__(2015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_927__VoiceChat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_927__VoiceChat__);
/* unused harmony reexport VoiceChat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_928__Voicemail__ = __webpack_require__(2016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_928__Voicemail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_928__Voicemail__);
/* unused harmony reexport Voicemail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_929__VolumeDown__ = __webpack_require__(2017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_929__VolumeDown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_929__VolumeDown__);
/* unused harmony reexport VolumeDown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_930__VolumeMute__ = __webpack_require__(2018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_930__VolumeMute___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_930__VolumeMute__);
/* unused harmony reexport VolumeMute */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_931__VolumeOff__ = __webpack_require__(2019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_931__VolumeOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_931__VolumeOff__);
/* unused harmony reexport VolumeOff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_932__VolumeUp__ = __webpack_require__(2020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_932__VolumeUp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_932__VolumeUp__);
/* unused harmony reexport VolumeUp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_933__VpnKey__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_933__VpnKey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_933__VpnKey__);
/* unused harmony reexport VpnKey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_934__VpnLock__ = __webpack_require__(2021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_934__VpnLock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_934__VpnLock__);
/* unused harmony reexport VpnLock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_935__Wallpaper__ = __webpack_require__(2022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_935__Wallpaper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_935__Wallpaper__);
/* unused harmony reexport Wallpaper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_936__Warning__ = __webpack_require__(2023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_936__Warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_936__Warning__);
/* unused harmony reexport Warning */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_937__Watch__ = __webpack_require__(2024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_937__Watch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_937__Watch__);
/* unused harmony reexport Watch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_938__WatchLater__ = __webpack_require__(2025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_938__WatchLater___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_938__WatchLater__);
/* unused harmony reexport WatchLater */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_939__WbAuto__ = __webpack_require__(2026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_939__WbAuto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_939__WbAuto__);
/* unused harmony reexport WbAuto */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_940__WbCloudy__ = __webpack_require__(2027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_940__WbCloudy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_940__WbCloudy__);
/* unused harmony reexport WbCloudy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_941__WbIncandescent__ = __webpack_require__(2028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_941__WbIncandescent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_941__WbIncandescent__);
/* unused harmony reexport WbIncandescent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_942__WbIridescent__ = __webpack_require__(2029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_942__WbIridescent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_942__WbIridescent__);
/* unused harmony reexport WbIridescent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_943__WbSunny__ = __webpack_require__(2030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_943__WbSunny___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_943__WbSunny__);
/* unused harmony reexport WbSunny */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_944__Wc__ = __webpack_require__(2031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_944__Wc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_944__Wc__);
/* unused harmony reexport Wc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_945__Web__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_945__Web___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_945__Web__);
/* unused harmony reexport Web */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_946__WebAsset__ = __webpack_require__(2032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_946__WebAsset___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_946__WebAsset__);
/* unused harmony reexport WebAsset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_947__Weekend__ = __webpack_require__(2033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_947__Weekend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_947__Weekend__);
/* unused harmony reexport Weekend */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_948__Whatshot__ = __webpack_require__(2034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_948__Whatshot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_948__Whatshot__);
/* unused harmony reexport Whatshot */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_949__Widgets__ = __webpack_require__(2035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_949__Widgets___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_949__Widgets__);
/* unused harmony reexport Widgets */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_950__Wifi__ = __webpack_require__(2036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_950__Wifi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_950__Wifi__);
/* unused harmony reexport Wifi */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_951__WifiLock__ = __webpack_require__(2037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_951__WifiLock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_951__WifiLock__);
/* unused harmony reexport WifiLock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_952__WifiTethering__ = __webpack_require__(2038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_952__WifiTethering___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_952__WifiTethering__);
/* unused harmony reexport WifiTethering */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_953__Work__ = __webpack_require__(2039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_953__Work___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_953__Work__);
/* unused harmony reexport Work */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_954__WrapText__ = __webpack_require__(2040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_954__WrapText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_954__WrapText__);
/* unused harmony reexport WrapText */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_955__YoutubeSearchedFor__ = __webpack_require__(2041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_955__YoutubeSearchedFor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_955__YoutubeSearchedFor__);
/* unused harmony reexport YoutubeSearchedFor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_956__ZoomIn__ = __webpack_require__(2042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_956__ZoomIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_956__ZoomIn__);
/* unused harmony reexport ZoomIn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_957__ZoomOut__ = __webpack_require__(2043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_957__ZoomOut___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_957__ZoomOut__);
/* unused harmony reexport ZoomOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_958__ZoomOutMap__ = __webpack_require__(2044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_958__ZoomOutMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_958__ZoomOutMap__);
/* unused harmony reexport ZoomOutMap */
/** @license Material-UI v1.1.1
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
})), 'AccessAlarm');

exports.default = _default;

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 5.7l-4.6-3.9-1.3 1.5 4.6 3.9L22 5.7zM7.9 3.4L6.6 1.9 2 5.7l1.3 1.5 4.6-3.8zM12.5 8H11v6l4.7 2.9.8-1.2-4-2.4V8zM12 4c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm0 16c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7z"
})), 'AccessAlarms');

exports.default = _default;

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 7h-6v13h-2v-6h-2v6H9V9H3V7h18v2z"
})), 'Accessibility');

exports.default = _default;

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("circle", {
  cx: "12",
  cy: "4",
  r: "2"
}), _react.default.createElement("path", {
  d: "M19 13v-2c-1.54.02-3.09-.75-4.07-1.83l-1.29-1.43c-.17-.19-.38-.34-.61-.45-.01 0-.01-.01-.02-.01H13c-.35-.2-.75-.3-1.19-.26C10.76 7.11 10 8.04 10 9.09V15c0 1.1.9 2 2 2h5v5h2v-5.5c0-1.1-.9-2-2-2h-3v-3.45c1.29 1.07 3.25 1.94 5 1.95zm-6.17 5c-.41 1.16-1.52 2-2.83 2-1.66 0-3-1.34-3-3 0-1.31.84-2.41 2-2.83V12.1c-2.28.46-4 2.48-4 4.9 0 2.76 2.24 5 5 5 2.42 0 4.44-1.72 4.9-4h-2.07z"
})), 'Accessible');

exports.default = _default;

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"
})), 'AccessTime');

exports.default = _default;

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 10v7h3v-7H4zm6 0v7h3v-7h-3zM2 22h19v-3H2v3zm14-12v7h3v-7h-3zm-4.5-9L2 6v2h19V6l-9.5-5z"
})), 'AccountBalance');

exports.default = _default;

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 18v1c0 1.1-.9 2-2 2H5c-1.11 0-2-.9-2-2V5c0-1.1.89-2 2-2h14c1.1 0 2 .9 2 2v1h-9c-1.11 0-2 .9-2 2v8c0 1.1.89 2 2 2h9zm-9-2h10V8H12v8zm4-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
})), 'AccountBalanceWallet');

exports.default = _default;

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 5v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.11 0-2 .9-2 2zm12 4c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3zm-9 8c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1H6v-1z"
})), 'AccountBox');

exports.default = _default;

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 11h-4.17l3.24-3.24-1.41-1.42L15 11h-2V9l4.66-4.66-1.42-1.41L13 6.17V2h-2v4.17L7.76 2.93 6.34 4.34 11 9v2H9L4.34 6.34 2.93 7.76 6.17 11H2v2h4.17l-3.24 3.24 1.41 1.42L9 13h2v2l-4.66 4.66 1.42 1.41L11 17.83V22h2v-4.17l3.24 3.24 1.42-1.41L13 15v-2h2l4.66 4.66 1.41-1.42L17.83 13H22z"
})), 'AcUnit');

exports.default = _default;

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M5 16c0 3.87 3.13 7 7 7s7-3.13 7-7v-4H5v4zM16.12 4.37l2.1-2.1-.82-.83-2.3 2.31C14.16 3.28 13.12 3 12 3s-2.16.28-3.09.75L6.6 1.44l-.82.83 2.1 2.1C6.14 5.64 5 7.68 5 10v1h14v-1c0-2.32-1.14-4.36-2.88-5.63zM9 9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
})), 'Adb');

exports.default = _default;

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
})), 'Add');

exports.default = _default;

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm1-11h-2v3H8v2h3v3h2v-3h3v-2h-3V9z"
})), 'AddAlarm');

exports.default = _default;

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10.01 21.01c0 1.1.89 1.99 1.99 1.99s1.99-.89 1.99-1.99h-3.98zm8.87-4.19V11c0-3.25-2.25-5.97-5.29-6.69v-.72C13.59 2.71 12.88 2 12 2s-1.59.71-1.59 1.59v.72C7.37 5.03 5.12 7.75 5.12 11v5.82L3 18.94V20h18v-1.06l-2.12-2.12zM16 13.01h-3v3h-2v-3H8V11h3V8h2v3h3v2.01z"
})), 'AddAlert');

exports.default = _default;

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 4V1h2v3h3v2H5v3H3V6H0V4h3zm3 6V7h3V4h7l1.83 2H21c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V10h3zm7 9c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-3.2-5c0 1.77 1.43 3.2 3.2 3.2s3.2-1.43 3.2-3.2-1.43-3.2-3.2-3.2-3.2 1.43-3.2 3.2z"
})), 'AddAPhoto');

exports.default = _default;

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
})), 'AddBox');

exports.default = _default;

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
})), 'AddCircle');

exports.default = _default;

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
})), 'AddCircleOutline');

exports.default = _default;

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm4 8h-3v3h-2v-3H8V8h3V5h2v3h3v2z"
})), 'AddLocation');

exports.default = _default;

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z"
})), 'AddToPhotos');

exports.default = _default;

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12zm-5-7v2h-3v3h-2v-3H8v-2h3V7h2v3h3z"
})), 'AddToQueue');

exports.default = _default;

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3-8c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3z"
})), 'Adjust');

exports.default = _default;

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 11v2H9V7h9c2.21 0 4 1.79 4 4zM2 14v2h6v2h8v-2h6v-2H2zm5.14-1.9c1.16-1.19 1.14-3.08-.04-4.24-1.19-1.16-3.08-1.14-4.24.04-1.16 1.19-1.14 3.08.04 4.24 1.19 1.16 3.08 1.14 4.24-.04z"
})), 'AirlineSeatFlat');

exports.default = _default;

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22.25 14.29l-.69 1.89L9.2 11.71l2.08-5.66 8.56 3.09c2.1.76 3.18 3.06 2.41 5.15zM1.5 12.14L8 14.48V19h8v-1.63L20.52 19l.69-1.89-19.02-6.86-.69 1.89zm5.8-1.94c1.49-.72 2.12-2.51 1.41-4C7.99 4.71 6.2 4.08 4.7 4.8c-1.49.71-2.12 2.5-1.4 4 .71 1.49 2.5 2.12 4 1.4z"
})), 'AirlineSeatFlatAngled');

exports.default = _default;

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 13c1.65 0 3-1.35 3-3S8.65 7 7 7s-3 1.35-3 3 1.35 3 3 3zm12-6h-8v7H3V7H1v10h22v-6c0-2.21-1.79-4-4-4z"
})), 'AirlineSeatIndividualSuite');

exports.default = _default;

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 12V3H2v9c0 2.76 2.24 5 5 5h6v-2H7c-1.66 0-3-1.34-3-3zm18.83 5.24c-.38-.72-1.29-.97-2.03-.63l-1.09.5-3.41-6.98c-.34-.68-1.03-1.12-1.79-1.12L11 9V3H5v8c0 1.66 1.34 3 3 3h7l3.41 7 3.72-1.7c.77-.36 1.1-1.3.7-2.06z"
})), 'AirlineSeatLegroomExtra');

exports.default = _default;

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M5 12V3H3v9c0 2.76 2.24 5 5 5h6v-2H8c-1.66 0-3-1.34-3-3zm15.5 6H19v-7c0-1.1-.9-2-2-2h-5V3H6v8c0 1.65 1.35 3 3 3h7v7h4.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5z"
})), 'AirlineSeatLegroomNormal');

exports.default = _default;

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.97 19.2c.18.96-.55 1.8-1.47 1.8H14v-3l1-4H9c-1.65 0-3-1.35-3-3V3h6v6h5c1.1 0 2 .9 2 2l-2 7h1.44c.73 0 1.39.49 1.53 1.2zM5 12V3H3v9c0 2.76 2.24 5 5 5h4v-2H8c-1.66 0-3-1.34-3-3z"
})), 'AirlineSeatLegroomReduced');

exports.default = _default;

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M5.35 5.64c-.9-.64-1.12-1.88-.49-2.79.63-.9 1.88-1.12 2.79-.49.9.64 1.12 1.88.49 2.79-.64.9-1.88 1.12-2.79.49zM16 19H8.93c-1.48 0-2.74-1.08-2.96-2.54L4 7H2l1.99 9.76C4.37 19.2 6.47 21 8.94 21H16v-2zm.23-4h-4.88l-1.03-4.1c1.58.89 3.28 1.54 5.15 1.22V9.99c-1.63.31-3.44-.27-4.69-1.25L9.14 7.47c-.23-.18-.49-.3-.76-.38-.32-.09-.66-.12-.99-.06h-.02c-1.23.22-2.05 1.39-1.84 2.61l1.35 5.92C7.16 16.98 8.39 18 9.83 18h6.85l3.82 3 1.5-1.5-5.77-4.5z"
})), 'AirlineSeatReclineExtra');

exports.default = _default;

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7.59 5.41c-.78-.78-.78-2.05 0-2.83.78-.78 2.05-.78 2.83 0 .78.78.78 2.05 0 2.83-.79.79-2.05.79-2.83 0zM6 16V7H4v9c0 2.76 2.24 5 5 5h6v-2H9c-1.66 0-3-1.34-3-3zm14 4.07L14.93 15H11.5v-3.68c1.4 1.15 3.6 2.16 5.5 2.16v-2.16c-1.66.02-3.61-.87-4.67-2.04l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.29-.14-.62-.23-.96-.23h-.03C8.01 7 7 8.01 7 9.25V15c0 1.66 1.34 3 3 3h5.07l3.5 3.5L20 20.07z"
})), 'AirlineSeatReclineNormal');

exports.default = _default;

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10.18 9"
}), _react.default.createElement("path", {
  d: "M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"
})), 'AirplanemodeActive');

exports.default = _default;

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13 9V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5v3.68l7.83 7.83L21 16v-2l-8-5zM3 5.27l4.99 4.99L2 14v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-3.73L18.73 21 20 19.73 4.27 4 3 5.27z"
})), 'AirplanemodeInactive');

exports.default = _default;

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6 22h12l-6-6zM21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V5h18v12h-4v2h4c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
})), 'Airplay');

exports.default = _default;

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 5H3c-1.1 0-2 .89-2 2v9h2c0 1.65 1.34 3 3 3s3-1.35 3-3h5.5c0 1.65 1.34 3 3 3s3-1.35 3-3H23v-5l-6-6zM3 11V7h4v4H3zm3 6.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm7-6.5H9V7h4v4zm4.5 6.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM15 11V7h1l4 4h-5z"
})), 'AirportShuttle');

exports.default = _default;

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
})), 'Alarm');

exports.default = _default;

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm1-11h-2v3H8v2h3v3h2v-3h3v-2h-3V9z"
})), 'AlarmAdd');

exports.default = _default;

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 6c3.87 0 7 3.13 7 7 0 .84-.16 1.65-.43 2.4l1.52 1.52c.58-1.19.91-2.51.91-3.92 0-4.97-4.03-9-9-9-1.41 0-2.73.33-3.92.91L9.6 6.43C10.35 6.16 11.16 6 12 6zm10-.28l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM2.92 2.29L1.65 3.57 2.98 4.9l-1.11.93 1.42 1.42 1.11-.94.8.8C3.83 8.69 3 10.75 3 13c0 4.97 4.02 9 9 9 2.25 0 4.31-.83 5.89-2.2l2.2 2.2 1.27-1.27L3.89 3.27l-.97-.98zm13.55 16.1C15.26 19.39 13.7 20 12 20c-3.87 0-7-3.13-7-7 0-1.7.61-3.26 1.61-4.47l9.86 9.86zM8.02 3.28L6.6 1.86l-.86.71 1.42 1.42.86-.71z"
})), 'AlarmOff');

exports.default = _default;

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm-1.46-5.47L8.41 12.4l-1.06 1.06 3.18 3.18 6-6-1.06-1.06-4.93 4.95z"
})), 'AlarmOn');

exports.default = _default;

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 14.5c-2.49 0-4.5-2.01-4.5-4.5S9.51 7.5 12 7.5s4.5 2.01 4.5 4.5-2.01 4.5-4.5 4.5zm0-5.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
})), 'Album');

exports.default = _default;

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18.6 6.62c-1.44 0-2.8.56-3.77 1.53L12 10.66 10.48 12h.01L7.8 14.39c-.64.64-1.49.99-2.4.99-1.87 0-3.39-1.51-3.39-3.38S3.53 8.62 5.4 8.62c.91 0 1.76.35 2.44 1.03l1.13 1 1.51-1.34L9.22 8.2C8.2 7.18 6.84 6.62 5.4 6.62 2.42 6.62 0 9.04 0 12s2.42 5.38 5.4 5.38c1.44 0 2.8-.56 3.77-1.53l2.83-2.5.01.01L13.52 12h-.01l2.69-2.39c.64-.64 1.49-.99 2.4-.99 1.87 0 3.39 1.51 3.39 3.38s-1.52 3.38-3.39 3.38c-.9 0-1.76-.35-2.44-1.03l-1.14-1.01-1.51 1.34 1.27 1.12c1.02 1.01 2.37 1.57 3.82 1.57 2.98 0 5.4-2.41 5.4-5.38s-2.42-5.37-5.4-5.37z"
})), 'AllInclusive');

exports.default = _default;

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16.21 4.16l4 4v-4zm4 12l-4 4h4zm-12 4l-4-4v4zm-4-12l4-4h-4zm12.95-.95c-2.73-2.73-7.17-2.73-9.9 0s-2.73 7.17 0 9.9 7.17 2.73 9.9 0 2.73-7.16 0-9.9zm-1.1 8.8c-2.13 2.13-5.57 2.13-7.7 0s-2.13-5.57 0-7.7 5.57-2.13 7.7 0 2.13 5.57 0 7.7z"
})), 'AllOut');

exports.default = _default;

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6 18c0 .55.45 1 1 1h1v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h2v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h1c.55 0 1-.45 1-1V8H6v10zM3.5 8C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5S5 17.33 5 16.5v-7C5 8.67 4.33 8 3.5 8zm17 0c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zm-4.97-5.84l1.3-1.3c.2-.2.2-.51 0-.71-.2-.2-.51-.2-.71 0l-1.48 1.48C13.85 1.23 12.95 1 12 1c-.96 0-1.86.23-2.66.63L7.85.15c-.2-.2-.51-.2-.71 0-.2.2-.2.51 0 .71l1.31 1.31C6.97 3.26 6 5.01 6 7h12c0-1.99-.97-3.75-2.47-4.84zM10 5H9V4h1v1zm5 0h-1V4h1v1z"
})), 'Android');

exports.default = _default;

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 9h-2V5h2v6zm0 4h-2v-2h2v2z"
})), 'Announcement');

exports.default = _default;

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z"
})), 'Apps');

exports.default = _default;

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20.54 5.23l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27zM12 17.5L6.5 12H10v-2h4v2h3.5L12 17.5zM5.12 5l.81-1h12l.94 1H5.12z"
})), 'Archive');

exports.default = _default;

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
})), 'ArrowDownward');

exports.default = _default;

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 10l5 5 5-5z"
})), 'ArrowDropDown');

exports.default = _default;

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 12l-4-4h8l-4 4z"
})), 'ArrowDropDownCircle');

exports.default = _default;

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 14l5-5 5 5z"
})), 'ArrowDropUp');

exports.default = _default;

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
})), 'ArrowForward');

exports.default = _default;

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
})), 'ArrowUpward');

exports.default = _default;

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 13h-8v-2h8v2zm0-6h-8v2h8V7zm-8 10h8v-2h-8v2zm-2-8v6c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2zm-1.5 6l-2.25-3-1.75 2.26-1.25-1.51L3.5 15h7z"
})), 'ArtTrack');

exports.default = _default;

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 12h-2v3h-3v2h5v-5zM7 9h3V7H5v5h2V9zm14-6H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z"
})), 'AspectRatio');

exports.default = _default;

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"
})), 'Assessment');

exports.default = _default;

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"
})), 'Assignment');

exports.default = _default;

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 4c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1.4c0-2 4-3.1 6-3.1s6 1.1 6 3.1V19z"
})), 'AssignmentInd');

exports.default = _default;

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-6 15h-2v-2h2v2zm0-4h-2V8h2v6zm-1-9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
})), 'AssignmentLate');

exports.default = _default;

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm4 12h-4v3l-5-5 5-5v3h4v4z"
})), 'AssignmentReturn');

exports.default = _default;

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 15l-5-5h3V9h4v4h3l-5 5z"
})), 'AssignmentReturned');

exports.default = _default;

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-2 14l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"
})), 'AssignmentTurnedIn');

exports.default = _default;

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5.12 10.88L12 17l-1.88-4.12L6 11l4.12-1.88L12 5l1.88 4.12L18 11l-4.12 1.88z"
})), 'Assistant');

exports.default = _default;

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z"
})), 'AssistantPhoto');

exports.default = _default;

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z"
})), 'AttachFile');

exports.default = _default;

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M2 12.5C2 9.46 4.46 7 7.5 7H18c2.21 0 4 1.79 4 4s-1.79 4-4 4H9.5C8.12 15 7 13.88 7 12.5S8.12 10 9.5 10H17v2H9.41c-.55 0-.55 1 0 1H18c1.1 0 2-.9 2-2s-.9-2-2-2H7.5C5.57 9 4 10.57 4 12.5S5.57 16 7.5 16H17v2H7.5C4.46 18 2 15.54 2 12.5z"
})), 'Attachment');

exports.default = _default;

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"
})), 'AttachMoney');

exports.default = _default;

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 3v9.28c-.47-.17-.97-.28-1.5-.28C8.01 12 6 14.01 6 16.5S8.01 21 10.5 21c2.31 0 4.2-1.75 4.45-4H15V6h4V3h-7z"
})), 'Audiotrack');

exports.default = _default;

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z"
})), 'Autorenew');

exports.default = _default;

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11 17c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1zm0-14v4h2V5.08c3.39.49 6 3.39 6 6.92 0 3.87-3.13 7-7 7s-7-3.13-7-7c0-1.68.59-3.22 1.58-4.42L12 13l1.41-1.41-6.8-6.8v.02C4.42 6.45 3 9.05 3 12c0 4.97 4.02 9 9 9 4.97 0 9-4.03 9-9s-4.03-9-9-9h-1zm7 9c0-.55-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1zM6 12c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1z"
})), 'AvTimer');

exports.default = _default;

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.9.89 1.59.89h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-3 12.59L17.59 17 14 13.41 10.41 17 9 15.59 12.59 12 9 8.41 10.41 7 14 10.59 17.59 7 19 8.41 15.41 12 19 15.59z"
})), 'Backspace');

exports.default = _default;

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"
})), 'Backup');

exports.default = _default;

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 17v3.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V17H7z"
}), _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V17h10V5.33z"
})), 'Battery20');

exports.default = _default;

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V15h10V5.33z"
}), _react.default.createElement("path", {
  d: "M7 15v5.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V15H7z"
})), 'Battery30');

exports.default = _default;

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V13h10V5.33z"
}), _react.default.createElement("path", {
  d: "M7 13v7.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V13H7z"
})), 'Battery50');

exports.default = _default;

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V11h10V5.33z"
}), _react.default.createElement("path", {
  d: "M7 11v9.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V11H7z"
})), 'Battery60');

exports.default = _default;

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V9h10V5.33z"
}), _react.default.createElement("path", {
  d: "M7 9v11.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V9H7z"
})), 'Battery80');

exports.default = _default;

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V8h10V5.33z"
}), _react.default.createElement("path", {
  d: "M7 8v12.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V8H7z"
})), 'Battery90');

exports.default = _default;

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM13 18h-2v-2h2v2zm0-4h-2V9h2v5z"
})), 'BatteryAlert');

exports.default = _default;

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11 20v-3H7v3.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V17h-4.4L11 20z"
}), _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V17h4v-2.5H9L13 7v5.5h2L12.6 17H17V5.33C17 4.6 16.4 4 15.67 4z"
})), 'BatteryCharging20');

exports.default = _default;

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v9.17h2L13 7v5.5h2l-1.07 2H17V5.33C17 4.6 16.4 4 15.67 4z"
}), _react.default.createElement("path", {
  d: "M11 20v-5.5H7v6.17C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V14.5h-3.07L11 20z"
})), 'BatteryCharging30');

exports.default = _default;

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M14.47 13.5L11 20v-5.5H9l.53-1H7v7.17C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V13.5h-2.53z"
}), _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v8.17h2.53L13 7v5.5h2l-.53 1H17V5.33C17 4.6 16.4 4 15.67 4z"
})), 'BatteryCharging50');

exports.default = _default;

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V11h3.87L13 7v4h4V5.33C17 4.6 16.4 4 15.67 4z"
}), _react.default.createElement("path", {
  d: "M13 12.5h2L11 20v-5.5H9l1.87-3.5H7v9.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V11h-4v1.5z"
})), 'BatteryCharging60');

exports.default = _default;

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V9h4.93L13 7v2h4V5.33C17 4.6 16.4 4 15.67 4z"
}), _react.default.createElement("path", {
  d: "M13 12.5h2L11 20v-5.5H9L11.93 9H7v11.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V9h-4v3.5z"
})), 'BatteryCharging80');

exports.default = _default;

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V8h5.47L13 7v1h4V5.33C17 4.6 16.4 4 15.67 4z"
}), _react.default.createElement("path", {
  d: "M13 12.5h2L11 20v-5.5H9L12.47 8H7v12.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V8h-4v4.5z"
})), 'BatteryCharging90');

exports.default = _default;

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM11 20v-5.5H9L13 7v5.5h2L11 20z"
})), 'BatteryChargingFull');

exports.default = _default;

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z"
})), 'BatteryFull');

exports.default = _default;

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z"
})), 'BatteryStd');

exports.default = _default;

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zm-2.72 13.95h-1.9v-1.9h1.9v1.9zm1.35-5.26s-.38.42-.67.71c-.48.48-.83 1.15-.83 1.6h-1.6c0-.83.46-1.52.93-2l.93-.94c.27-.27.44-.65.44-1.06 0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5H9c0-1.66 1.34-3 3-3s3 1.34 3 3c0 .66-.27 1.26-.7 1.69z"
})), 'BatteryUnknown');

exports.default = _default;

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13.127 14.56l1.43-1.43 6.44 6.443L19.57 21zm4.293-5.73l2.86-2.86c-3.95-3.95-10.35-3.96-14.3-.02 3.93-1.3 8.31-.25 11.44 2.88zM5.95 5.98c-3.94 3.95-3.93 10.35.02 14.3l2.86-2.86C5.7 14.29 4.65 9.91 5.95 5.98zm.02-.02l-.01.01c-.38 3.01 1.17 6.88 4.3 10.02l5.73-5.73c-3.13-3.13-7.01-4.68-10.02-4.3z"
})), 'BeachAccess');

exports.default = _default;

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 1H5c-1.1 0-1.99.9-1.99 2L3 15.93c0 .69.35 1.3.88 1.66L12 23l8.11-5.41c.53-.36.88-.97.88-1.66L21 3c0-1.1-.9-2-2-2zm-9 15l-5-5 1.41-1.41L10 13.17l7.59-7.59L19 7l-9 9z"
})), 'Beenhere');

exports.default = _default;

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9C4.63 15.55 4 13.85 4 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1C19.37 8.45 20 10.15 20 12c0 4.42-3.58 8-8 8z"
})), 'Block');

exports.default = _default;

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17.71 7.71L12 2h-1v7.59L6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 5.83l1.88 1.88L13 9.59V5.83zm1.88 10.46L13 18.17v-3.76l1.88 1.88z"
})), 'Bluetooth');

exports.default = _default;

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M14.24 12.01l2.32 2.32c.28-.72.44-1.51.44-2.33 0-.82-.16-1.59-.43-2.31l-2.33 2.32zm5.29-5.3l-1.26 1.26c.63 1.21.98 2.57.98 4.02s-.36 2.82-.98 4.02l1.2 1.2c.97-1.54 1.54-3.36 1.54-5.31-.01-1.89-.55-3.67-1.48-5.19zm-3.82 1L10 2H9v7.59L4.41 5 3 6.41 8.59 12 3 17.59 4.41 19 9 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM11 5.83l1.88 1.88L11 9.59V5.83zm1.88 10.46L11 18.17v-3.76l1.88 1.88z"
})), 'BluetoothAudio');

exports.default = _default;

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 12l-2-2-2 2 2 2 2-2zm10.71-4.29L12 2h-1v7.59L6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 5.83l1.88 1.88L13 9.59V5.83zm1.88 10.46L13 18.17v-3.76l1.88 1.88zM19 10l-2 2 2 2 2-2-2-2z"
})), 'BluetoothConnected');

exports.default = _default;

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13 5.83l1.88 1.88-1.6 1.6 1.41 1.41 3.02-3.02L12 2h-1v5.03l2 2v-3.2zM5.41 4L4 5.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l4.29-4.29 2.3 2.29L20 18.59 5.41 4zM13 18.17v-3.76l1.88 1.88L13 18.17z"
})), 'BluetoothDisabled');

exports.default = _default;

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M14.24 12.01l2.32 2.32c.28-.72.44-1.51.44-2.33 0-.82-.16-1.59-.43-2.31l-2.33 2.32zm5.29-5.3l-1.26 1.26c.63 1.21.98 2.57.98 4.02s-.36 2.82-.98 4.02l1.2 1.2c.97-1.54 1.54-3.36 1.54-5.31-.01-1.89-.55-3.67-1.48-5.19zm-3.82 1L10 2H9v7.59L4.41 5 3 6.41 8.59 12 3 17.59 4.41 19 9 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM11 5.83l1.88 1.88L11 9.59V5.83zm1.88 10.46L11 18.17v-3.76l1.88 1.88z"
})), 'BluetoothSearching');

exports.default = _default;

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM7 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm3 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-3-3c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm3-6c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-1.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm3 6c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-4c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm2-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-3.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
})), 'BlurCircular');

exports.default = _default;

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M5 17.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM9 13c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zM3 21h18v-2H3v2zM5 9.5c.83 0 1.5-.67 1.5-1.5S5.83 6.5 5 6.5 3.5 7.17 3.5 8 4.17 9.5 5 9.5zm0 4c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM9 17c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm8-.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM3 3v2h18V3H3zm14 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm0 4c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM13 9c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1z"
})), 'BlurLinear');

exports.default = _default;

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm-.2 4.48l.2.02c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5l.02.2c.09.67.61 1.19 1.28 1.28zM14 3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-4 0c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm11 7c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm8 8c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm-4 13.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM2.5 5.27l3.78 3.78L6 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.03-.19-.06-.28l2.81 2.81c-.71.11-1.25.73-1.25 1.47 0 .83.67 1.5 1.5 1.5.74 0 1.36-.54 1.47-1.25l2.81 2.81c-.09-.03-.18-.06-.28-.06-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.03-.19-.06-.28l3.78 3.78L20 20.23 3.77 4 2.5 5.27zM10 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm11-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM3 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 11c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-3-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"
})), 'BlurOff');

exports.default = _default;

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-3 .5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm15 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-11 10c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-17c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 5.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm8 .5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm3 8.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM14 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-4-12c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0 8.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4-4.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-4c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"
})), 'BlurOn');

exports.default = _default;

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z"
})), 'Book');

exports.default = _default;

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z"
})), 'Bookmark');

exports.default = _default;

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z"
})), 'BookmarkBorder');

exports.default = _default;

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 3v18h18V3H3zm8 16H5v-6h6v6zm0-8H5V5h6v6zm8 8h-6v-6h6v6zm0-8h-6V5h6v6z"
})), 'BorderAll');

exports.default = _default;

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9 11H7v2h2v-2zm4 4h-2v2h2v-2zM9 3H7v2h2V3zm4 8h-2v2h2v-2zM5 3H3v2h2V3zm8 4h-2v2h2V7zm4 4h-2v2h2v-2zm-4-8h-2v2h2V3zm4 0h-2v2h2V3zm2 10h2v-2h-2v2zm0 4h2v-2h-2v2zM5 7H3v2h2V7zm14-4v2h2V3h-2zm0 6h2V7h-2v2zM5 11H3v2h2v-2zM3 21h18v-2H3v2zm2-6H3v2h2v-2z"
})), 'BorderBottom');

exports.default = _default;

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 5h2V3H7v2zm0 8h2v-2H7v2zm0 8h2v-2H7v2zm4-4h2v-2h-2v2zm0 4h2v-2h-2v2zm-8 0h2v-2H3v2zm0-4h2v-2H3v2zm0-4h2v-2H3v2zm0-4h2V7H3v2zm0-4h2V3H3v2zm8 8h2v-2h-2v2zm8 4h2v-2h-2v2zm0-4h2v-2h-2v2zm0 8h2v-2h-2v2zm0-12h2V7h-2v2zm-8 0h2V7h-2v2zm8-6v2h2V3h-2zm-8 2h2V3h-2v2zm4 16h2v-2h-2v2zm0-8h2v-2h-2v2zm0-8h2V3h-2v2z"
})), 'BorderClear');

exports.default = _default;

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17.75 7L14 3.25l-10 10V17h3.75l10-10zm2.96-2.96c.39-.39.39-1.02 0-1.41L18.37.29c-.39-.39-1.02-.39-1.41 0L15 2.25 18.75 6l1.96-1.96z"
}), _react.default.createElement("path", {
  fillOpacity: ".36",
  d: "M0 20h24v4H0z"
})), 'BorderColor');

exports.default = _default;

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 21h2v-2H3v2zM5 7H3v2h2V7zM3 17h2v-2H3v2zm4 4h2v-2H7v2zM5 3H3v2h2V3zm4 0H7v2h2V3zm8 0h-2v2h2V3zm-4 4h-2v2h2V7zm0-4h-2v2h2V3zm6 14h2v-2h-2v2zm-8 4h2v-2h-2v2zm-8-8h18v-2H3v2zM19 3v2h2V3h-2zm0 6h2V7h-2v2zm-8 8h2v-2h-2v2zm4 4h2v-2h-2v2zm4 0h2v-2h-2v2z"
})), 'BorderHorizontal');

exports.default = _default;

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 21h2v-2H3v2zm4 0h2v-2H7v2zM5 7H3v2h2V7zM3 17h2v-2H3v2zM9 3H7v2h2V3zM5 3H3v2h2V3zm12 0h-2v2h2V3zm2 6h2V7h-2v2zm0-6v2h2V3h-2zm-4 18h2v-2h-2v2zM13 3h-2v8H3v2h8v8h2v-8h8v-2h-8V3zm6 18h2v-2h-2v2zm0-4h2v-2h-2v2z"
})), 'BorderInner');

exports.default = _default;

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11 21h2v-2h-2v2zm0-4h2v-2h-2v2zm0-12h2V3h-2v2zm0 4h2V7h-2v2zm0 4h2v-2h-2v2zm-4 8h2v-2H7v2zM7 5h2V3H7v2zm0 8h2v-2H7v2zm-4 8h2V3H3v18zM19 9h2V7h-2v2zm-4 12h2v-2h-2v2zm4-4h2v-2h-2v2zm0-14v2h2V3h-2zm0 10h2v-2h-2v2zm0 8h2v-2h-2v2zm-4-8h2v-2h-2v2zm0-8h2V3h-2v2z"
})), 'BorderLeft');

exports.default = _default;

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13 7h-2v2h2V7zm0 4h-2v2h2v-2zm4 0h-2v2h2v-2zM3 3v18h18V3H3zm16 16H5V5h14v14zm-6-4h-2v2h2v-2zm-4-4H7v2h2v-2z"
})), 'BorderOuter');

exports.default = _default;

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 21h2v-2H7v2zM3 5h2V3H3v2zm4 0h2V3H7v2zm0 8h2v-2H7v2zm-4 8h2v-2H3v2zm8 0h2v-2h-2v2zm-8-8h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm8 8h2v-2h-2v2zm4-4h2v-2h-2v2zm4-10v18h2V3h-2zm-4 18h2v-2h-2v2zm0-16h2V3h-2v2zm-4 8h2v-2h-2v2zm0-8h2V3h-2v2zm0 4h2V7h-2v2z"
})), 'BorderRight');

exports.default = _default;

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15 21h2v-2h-2v2zm4 0h2v-2h-2v2zM7 21h2v-2H7v2zm4 0h2v-2h-2v2zm8-4h2v-2h-2v2zm0-4h2v-2h-2v2zM3 3v18h2V5h16V3H3zm16 6h2V7h-2v2z"
})), 'BorderStyle');

exports.default = _default;

/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 21h2v-2H7v2zm0-8h2v-2H7v2zm4 0h2v-2h-2v2zm0 8h2v-2h-2v2zm-8-4h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2v-2H3v2zm0-4h2V7H3v2zm8 8h2v-2h-2v2zm8-8h2V7h-2v2zm0 4h2v-2h-2v2zM3 3v2h18V3H3zm16 14h2v-2h-2v2zm-4 4h2v-2h-2v2zM11 9h2V7h-2v2zm8 12h2v-2h-2v2zm-4-8h2v-2h-2v2z"
})), 'BorderTop');

exports.default = _default;

/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 9h2V7H3v2zm0-4h2V3H3v2zm4 16h2v-2H7v2zm0-8h2v-2H7v2zm-4 0h2v-2H3v2zm0 8h2v-2H3v2zm0-4h2v-2H3v2zM7 5h2V3H7v2zm12 12h2v-2h-2v2zm-8 4h2V3h-2v18zm8 0h2v-2h-2v2zm0-8h2v-2h-2v2zm0-10v2h2V3h-2zm0 6h2V7h-2v2zm-4-4h2V3h-2v2zm0 16h2v-2h-2v2zm0-8h2v-2h-2v2z"
})), 'BorderVertical');

exports.default = _default;

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16h-9v-6h9v6z"
})), 'BrandingWatermark');

exports.default = _default;

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "10"
})), 'Brightness1');

exports.default = _default;

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 2c-1.82 0-3.53.5-5 1.35C7.99 5.08 10 8.3 10 12s-2.01 6.92-5 8.65C6.47 21.5 8.18 22 10 22c5.52 0 10-4.48 10-10S15.52 2 10 2z"
})), 'Brightness2');

exports.default = _default;

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9 2c-1.05 0-2.05.16-3 .46 4.06 1.27 7 5.06 7 9.54 0 4.48-2.94 8.27-7 9.54.95.3 1.95.46 3 .46 5.52 0 10-4.48 10-10S14.52 2 9 2z"
})), 'Brightness3');

exports.default = _default;

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-.89 0-1.74-.2-2.5-.55C11.56 16.5 13 14.42 13 12s-1.44-4.5-3.5-5.45C10.26 6.2 11.11 6 12 6c3.31 0 6 2.69 6 6s-2.69 6-6 6z"
})), 'Brightness4');

exports.default = _default;

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
})), 'Brightness5');

exports.default = _default;

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18V6c3.31 0 6 2.69 6 6s-2.69 6-6 6z"
})), 'Brightness6');

exports.default = _default;

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"
})), 'Brightness7');

exports.default = _default;

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10.85 12.65h2.3L12 9l-1.15 3.65zM20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM14.3 16l-.7-2h-3.2l-.7 2H7.8L11 7h2l3.2 9h-1.9z"
})), 'BrightnessAuto');

exports.default = _default;

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"
})), 'BrightnessHigh');

exports.default = _default;

/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
})), 'BrightnessLow');

exports.default = _default;

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18V6c3.31 0 6 2.69 6 6s-2.69 6-6 6z"
})), 'BrightnessMedium');

exports.default = _default;

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 5v6.59l-3-3.01-4 4.01-4-4-4 4-3-3.01V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2zm-3 6.42l3 3.01V19c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-6.58l3 2.99 4-4 4 4 4-3.99z"
})), 'BrokenImage');

exports.default = _default;

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 14c-1.66 0-3 1.34-3 3 0 1.31-1.16 2-2 2 .92 1.22 2.49 2 4 2 2.21 0 4-1.79 4-4 0-1.66-1.34-3-3-3zm13.71-9.37l-1.34-1.34c-.39-.39-1.02-.39-1.41 0L9 12.25 11.75 15l8.96-8.96c.39-.39.39-1.02 0-1.41z"
})), 'Brush');

exports.default = _default;

/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("circle", {
  cx: "7.2",
  cy: "14.4",
  r: "3.2"
}), _react.default.createElement("circle", {
  cx: "14.8",
  cy: "18",
  r: "2"
}), _react.default.createElement("circle", {
  cx: "15.2",
  cy: "8.8",
  r: "4.8"
})), 'BubbleChart');

exports.default = _default;

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 8h-2.81c-.45-.78-1.07-1.45-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.49 5 12 5c-.49 0-.96.06-1.41.17L8.41 3 7 4.41l1.62 1.63C7.88 6.55 7.26 7.22 6.81 8H4v2h2.09c-.05.33-.09.66-.09 1v1H4v2h2v1c0 .34.04.67.09 1H4v2h2.81c1.04 1.79 2.97 3 5.19 3s4.15-1.21 5.19-3H20v-2h-2.09c.05-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.04-.67-.09-1H20V8zm-6 8h-4v-2h4v2zm0-4h-4v-2h4v2z"
})), 'BugReport');

exports.default = _default;

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M1 5h2v14H1zm4 0h2v14H5zm17 0H10c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zM11 17l2.5-3.15L15.29 16l2.5-3.22L21 17H11z"
})), 'BurstMode');

exports.default = _default;

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 16v-1H3.01L3 19c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2v-4h-7v1h-4zm10-9h-4.01V5l-2-2h-4l-2 2v2H4c-1.1 0-2 .9-2 2v3c0 1.11.89 2 2 2h6v-2h4v2h6c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm-6 0h-4V5h4v2z"
})), 'BusinessCenter');

exports.default = _default;

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 8l-4 4h3c0 3.31-2.69 6-6 6-1.01 0-1.97-.25-2.8-.7l-1.46 1.46C8.97 19.54 10.43 20 12 20c4.42 0 8-3.58 8-8h3l-4-4zM6 12c0-3.31 2.69-6 6-6 1.01 0 1.97.25 2.8.7l1.46-1.46C15.03 4.46 13.57 4 12 4c-4.42 0-8 3.58-8 8H1l4 4 4-4H6z"
})), 'Cached');

exports.default = _default;

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 6c1.11 0 2-.9 2-2 0-.38-.1-.73-.29-1.03L12 0l-1.71 2.97c-.19.3-.29.65-.29 1.03 0 1.1.9 2 2 2zm4.6 9.99l-1.07-1.07-1.08 1.07c-1.3 1.3-3.58 1.31-4.89 0l-1.07-1.07-1.09 1.07C6.75 16.64 5.88 17 4.96 17c-.73 0-1.4-.23-1.96-.61V21c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-4.61c-.56.38-1.23.61-1.96.61-.92 0-1.79-.36-2.44-1.01zM18 9h-5V7h-2v2H6c-1.66 0-3 1.34-3 3v1.54c0 1.08.88 1.96 1.96 1.96.52 0 1.02-.2 1.38-.57l2.14-2.13 2.13 2.13c.74.74 2.03.74 2.77 0l2.14-2.13 2.13 2.13c.37.37.86.57 1.38.57 1.08 0 1.96-.88 1.96-1.96V12C21 10.34 19.66 9 18 9z"
})), 'Cake');

exports.default = _default;

/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
})), 'Call');

exports.default = _default;

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 9c-1.6 0-3.15.25-4.6.72v3.1c0 .39-.23.74-.56.9-.98.49-1.87 1.12-2.66 1.85-.18.18-.43.28-.7.28-.28 0-.53-.11-.71-.29L.29 13.08c-.18-.17-.29-.42-.29-.7 0-.28.11-.53.29-.71C3.34 8.78 7.46 7 12 7s8.66 1.78 11.71 4.67c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-2.48 2.48c-.18.18-.43.29-.71.29-.27 0-.52-.11-.7-.28-.79-.74-1.69-1.36-2.67-1.85-.33-.16-.56-.5-.56-.9v-3.1C15.15 9.25 13.6 9 12 9z"
})), 'CallEnd');

exports.default = _default;

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5z"
})), 'CallMade');

exports.default = _default;

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z"
})), 'CallMerge');

exports.default = _default;

/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.59 7L12 14.59 6.41 9H11V7H3v8h2v-4.59l7 7 9-9z"
})), 'CallMissed');

exports.default = _default;

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 8.41l9 9 7-7V15h2V7h-8v2h4.59L12 14.59 4.41 7 3 8.41z"
})), 'CallMissedOutgoing');

exports.default = _default;

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 5.41L18.59 4 7 15.59V9H5v10h10v-2H8.41z"
})), 'CallReceived');

exports.default = _default;

/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M14 4l2.29 2.29-2.88 2.88 1.42 1.42 2.88-2.88L20 10V4zm-4 0H4v6l2.29-2.29 4.71 4.7V20h2v-8.41l-5.29-5.3z"
})), 'CallSplit');

exports.default = _default;

/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3v-3h18v3z"
})), 'CallToAction');

exports.default = _default;

/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9.4 10.5l4.77-8.26C13.47 2.09 12.75 2 12 2c-2.4 0-4.6.85-6.32 2.25l3.66 6.35.06-.1zM21.54 9c-.92-2.92-3.15-5.26-6-6.34L11.88 9h9.66zm.26 1h-7.49l.29.5 4.76 8.25C21 16.97 22 14.61 22 12c0-.69-.07-1.35-.2-2zM8.54 12l-3.9-6.75C3.01 7.03 2 9.39 2 12c0 .69.07 1.35.2 2h7.49l-1.15-2zm-6.08 3c.92 2.92 3.15 5.26 6 6.34L12.12 15H2.46zm11.27 0l-3.9 6.76c.7.15 1.42.24 2.17.24 2.4 0 4.6-.85 6.32-2.25l-3.66-6.35-.93 1.6z"
})), 'Camera');

exports.default = _default;

/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "3.2"
}), _react.default.createElement("path", {
  d: "M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
})), 'CameraAlt');

exports.default = _default;

/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9 3L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2h-3.17L15 3H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-1l1.25-2.75L16 13l-2.75-1.25L12 9l-1.25 2.75L8 13l2.75 1.25z"
})), 'CameraEnhance');

exports.default = _default;

/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 20H5v2h5v2l3-3-3-3v2zm4 0v2h5v-2h-5zM12 8c1.1 0 2-.9 2-2s-.9-2-2-2-1.99.9-1.99 2S10.9 8 12 8zm5-8H7C5.9 0 5 .9 5 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zM7 2h10v10.5c0-1.67-3.33-2.5-5-2.5s-5 .83-5 2.5V2z"
})), 'CameraFront');

exports.default = _default;

/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 20H5v2h5v2l3-3-3-3v2zm4 0v2h5v-2h-5zm3-20H7C5.9 0 5 .9 5 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm-5 6c-1.11 0-2-.9-2-2s.89-2 1.99-2 2 .9 2 2C14 5.1 13.1 6 12 6z"
})), 'CameraRear');

exports.default = _default;

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M14 5c0-1.1-.9-2-2-2h-1V2c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v1H4c-1.1 0-2 .9-2 2v15c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2h8V5h-8zm-2 13h-2v-2h2v2zm0-9h-2V7h2v2zm4 9h-2v-2h2v2zm0-9h-2V7h2v2zm4 9h-2v-2h2v2zm0-9h-2V7h2v2z"
})), 'CameraRoll');

exports.default = _default;

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
})), 'Cancel');

exports.default = _default;

/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z"
})), 'CardGiftcard');

exports.default = _default;

/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h4v5l4-2 4 2v-5h4c1.11 0 2-.89 2-2V4c0-1.11-.89-2-2-2zm0 13H4v-2h16v2zm0-5H4V4h16v6z"
})), 'CardMembership');

exports.default = _default;

/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 6h-3V4c0-1.11-.89-2-2-2H9c-1.11 0-2 .89-2 2v2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zM9 4h6v2H9V4zm11 15H4v-2h16v2zm0-5H4V8h3v2h2V8h6v2h2V8h3v6z"
})), 'CardTravel');

exports.default = _default;

/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM7.5 18c-.83 0-1.5-.67-1.5-1.5S6.67 15 7.5 15s1.5.67 1.5 1.5S8.33 18 7.5 18zm0-9C6.67 9 6 8.33 6 7.5S6.67 6 7.5 6 9 6.67 9 7.5 8.33 9 7.5 9zm4.5 4.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5 4.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm0-9c-.83 0-1.5-.67-1.5-1.5S15.67 6 16.5 6s1.5.67 1.5 1.5S17.33 9 16.5 9z"
})), 'Casino');

exports.default = _default;

/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 3H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0-4v2c4.97 0 9 4.03 9 9h2c0-6.08-4.93-11-11-11z"
})), 'Cast');

exports.default = _default;

/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm18-7H5v1.63c3.96 1.28 7.09 4.41 8.37 8.37H19V7zM1 10v2c4.97 0 9 4.03 9 9h2c0-6.08-4.93-11-11-11zm20-7H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
})), 'CastConnected');

exports.default = _default;

/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm-7 7H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4z"
})), 'CenterFocusStrong');

exports.default = _default;

/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M5 15H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
})), 'CenterFocusWeak');

exports.default = _default;

/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 7.77L18.39 18H5.61L12 7.77M12 4L2 20h20L12 4z"
})), 'ChangeHistory');

exports.default = _default;

/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z"
})), 'Chat');

exports.default = _default;

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"
})), 'ChatBubble');

exports.default = _default;

/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z"
})), 'ChatBubbleOutline');

exports.default = _default;

/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
})), 'Check');

exports.default = _default;

/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
})), 'CheckBox');

exports.default = _default;

/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
})), 'CheckBoxOutlineBlank');

exports.default = _default;

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
})), 'CheckCircle');

exports.default = _default;

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
})), 'ChevronLeft');

exports.default = _default;

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
})), 'ChevronRight');

exports.default = _default;

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("circle", {
  cx: "14.5",
  cy: "10.5",
  r: "1.25"
}), _react.default.createElement("circle", {
  cx: "9.5",
  cy: "10.5",
  r: "1.25"
}), _react.default.createElement("path", {
  d: "M22.94 12.66c.04-.21.06-.43.06-.66s-.02-.45-.06-.66c-.25-1.51-1.36-2.74-2.81-3.17-.53-1.12-1.28-2.1-2.19-2.91C16.36 3.85 14.28 3 12 3s-4.36.85-5.94 2.26c-.92.81-1.67 1.8-2.19 2.91-1.45.43-2.56 1.65-2.81 3.17-.04.21-.06.43-.06.66s.02.45.06.66c.25 1.51 1.36 2.74 2.81 3.17.52 1.11 1.27 2.09 2.17 2.89C7.62 20.14 9.71 21 12 21s4.38-.86 5.97-2.28c.9-.8 1.65-1.79 2.17-2.89 1.44-.43 2.55-1.65 2.8-3.17zM19 14c-.1 0-.19-.02-.29-.03-.2.67-.49 1.29-.86 1.86C16.6 17.74 14.45 19 12 19s-4.6-1.26-5.85-3.17c-.37-.57-.66-1.19-.86-1.86-.1.01-.19.03-.29.03-1.1 0-2-.9-2-2s.9-2 2-2c.1 0 .19.02.29.03.2-.67.49-1.29.86-1.86C7.4 6.26 9.55 5 12 5s4.6 1.26 5.85 3.17c.37.57.66 1.19.86 1.86.1-.01.19-.03.29-.03 1.1 0 2 .9 2 2s-.9 2-2 2zM7.5 14c.76 1.77 2.49 3 4.5 3s3.74-1.23 4.5-3h-9z"
})), 'ChildCare');

exports.default = _default;

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13 2v8h8c0-4.42-3.58-8-8-8zm6.32 13.89C20.37 14.54 21 12.84 21 11H6.44l-.95-2H2v2h2.22s1.89 4.07 2.12 4.42c-1.1.59-1.84 1.75-1.84 3.08C4.5 20.43 6.07 22 8 22c1.76 0 3.22-1.3 3.46-3h2.08c.24 1.7 1.7 3 3.46 3 1.93 0 3.5-1.57 3.5-3.5 0-1.04-.46-1.97-1.18-2.61zM8 20c-.83 0-1.5-.67-1.5-1.5S7.17 17 8 17s1.5.67 1.5 1.5S8.83 20 8 20zm9 0c-.83 0-1.5-.67-1.5-1.5S16.17 17 17 17s1.5.67 1.5 1.5S17.83 20 17 20z"
})), 'ChildFriendly');

exports.default = _default;

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13 12h7v1.5h-7zm0-2.5h7V11h-7zm0 5h7V16h-7zM21 4H3c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 15h-9V6h9v13z"
})), 'ChromeReaderMode');

exports.default = _default;

/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z"
})), 'Class');

exports.default = _default;

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M5 13h14v-2H5v2zm-2 4h14v-2H3v2zM7 7v2h14V7H7z"
})), 'ClearAll');

exports.default = _default;

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 7H9.5v-.5h-2v3h2V13H11v1c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1zm7 0h-1.5v-.5h-2v3h2V13H18v1c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1z"
})), 'ClosedCaption');

exports.default = _default;

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96z"
})), 'Cloud');

exports.default = _default;

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.5 14H8c-1.66 0-3-1.34-3-3s1.34-3 3-3l.14.01C8.58 8.28 10.13 7 12 7c2.21 0 4 1.79 4 4h.5c1.38 0 2.5 1.12 2.5 2.5S17.88 16 16.5 16z"
})), 'CloudCircle');

exports.default = _default;

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM10 17l-3.5-3.5 1.41-1.41L10 14.17 15.18 9l1.41 1.41L10 17z"
})), 'CloudDone');

exports.default = _default;

/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4c-1.48 0-2.85.43-4.01 1.17l1.46 1.46C10.21 6.23 11.08 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3 0 1.13-.64 2.11-1.56 2.62l1.45 1.45C23.16 18.16 24 16.68 24 15c0-2.64-2.05-4.78-4.65-4.96zM3 5.27l2.75 2.74C2.56 8.15 0 10.77 0 14c0 3.31 2.69 6 6 6h11.73l2 2L21 20.73 4.27 4 3 5.27zM7.73 10l8 8H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h1.73z"
})), 'CloudOff');

exports.default = _default;

/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h.71C7.37 7.69 9.48 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3s-1.34 3-3 3z"
})), 'CloudQueue');

exports.default = _default;

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"
})), 'Code');

exports.default = _default;

/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zm-11-4l2.03 2.71L16 11l4 5H8l3-4zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z"
})), 'Collections');

exports.default = _default;

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 10l-2.5-1.5L15 12V4h5v8z"
})), 'CollectionsBookmark');

exports.default = _default;

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20.71 5.63l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-3.12 3.12-1.93-1.91-1.41 1.41 1.42 1.42L3 16.25V21h4.75l8.92-8.92 1.42 1.42 1.41-1.41-1.92-1.92 3.12-3.12c.4-.4.4-1.03.01-1.42zM6.92 19L5 17.08l8.06-8.06 1.92 1.92L6.92 19z"
})), 'Colorize');

exports.default = _default;

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
})), 'ColorLens');

exports.default = _default;

/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18zM18 14H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"
})), 'Comment');

exports.default = _default;

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h5v2h2V1h-2v2zm0 15H5l5-6v6zm9-15h-5v2h5v13l-5-6v9h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
})), 'Compare');

exports.default = _default;

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9.01 14H2v2h7.01v3L13 15l-3.99-4v3zm5.98-1v-3H22V8h-7.01V5L11 9l3.99 4z"
})), 'CompareArrows');

exports.default = _default;

/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z"
})), 'Computer');

exports.default = _default;

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 10V6c0-1.11-.9-2-2-2H4c-1.1 0-1.99.89-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2zm-9 7.5h-2v-2h2v2zm0-4.5h-2v-2h2v2zm0-4.5h-2v-2h2v2z"
})), 'ConfirmationNumber');

exports.default = _default;

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 8V7l-3 2-3-2v1l3 2 3-2zm1-5H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zM8 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1zm8-6h-8V6h8v6z"
})), 'ContactMail');

exports.default = _default;

/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 0H4v2h16V0zM4 24h16v-2H4v2zM20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 2.75c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25S9.75 10.24 9.75 9 10.76 6.75 12 6.75zM17 17H7v-1.5c0-1.67 3.33-2.5 5-2.5s5 .83 5 2.5V17z"
})), 'Contacts');

exports.default = _default;

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"
})), 'ContentCopy');

exports.default = _default;

/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9.64 7.64c.23-.5.36-1.05.36-1.64 0-2.21-1.79-4-4-4S2 3.79 2 6s1.79 4 4 4c.59 0 1.14-.13 1.64-.36L10 12l-2.36 2.36C7.14 14.13 6.59 14 6 14c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4c0-.59-.13-1.14-.36-1.64L12 14l7 7h3v-1L9.64 7.64zM6 8c-1.1 0-2-.89-2-2s.9-2 2-2 2 .89 2 2-.9 2-2 2zm0 12c-1.1 0-2-.89-2-2s.9-2 2-2 2 .89 2 2-.9 2-2 2zm6-7.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5zM19 3l-6 6 2 2 7-7V3z"
})), 'ContentCut');

exports.default = _default;

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 2h-4.18C14.4.84 13.3 0 12 0c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm7 18H5V4h2v3h10V4h2v16z"
})), 'ContentPaste');

exports.default = _default;

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
})), 'ControlPoint');

exports.default = _default;

/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16 8h-2v3h-3v2h3v3h2v-3h3v-2h-3zM2 12c0-2.79 1.64-5.2 4.01-6.32V3.52C2.52 4.76 0 8.09 0 12s2.52 7.24 6.01 8.48v-2.16C3.64 17.2 2 14.79 2 12zm13-9c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"
})), 'ControlPointDuplicate');

exports.default = _default;

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10.08 10.86c.05-.33.16-.62.3-.87s.34-.46.59-.62c.24-.15.54-.22.91-.23.23.01.44.05.63.13.2.09.38.21.52.36s.25.33.34.53.13.42.14.64h1.79c-.02-.47-.11-.9-.28-1.29s-.4-.73-.7-1.01-.66-.5-1.08-.66-.88-.23-1.39-.23c-.65 0-1.22.11-1.7.34s-.88.53-1.2.92-.56.84-.71 1.36S8 11.29 8 11.87v.27c0 .58.08 1.12.23 1.64s.39.97.71 1.35.72.69 1.2.91 1.05.34 1.7.34c.47 0 .91-.08 1.32-.23s.77-.36 1.08-.63.56-.58.74-.94.29-.74.3-1.15h-1.79c-.01.21-.06.4-.15.58s-.21.33-.36.46-.32.23-.52.3c-.19.07-.39.09-.6.1-.36-.01-.66-.08-.89-.23-.25-.16-.45-.37-.59-.62s-.25-.55-.3-.88-.08-.67-.08-1v-.27c0-.35.03-.68.08-1.01zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
})), 'Copyright');

exports.default = _default;

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
})), 'Create');

exports.default = _default;

/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 6h-8l-2-2H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-1 8h-3v3h-2v-3h-3v-2h3V9h2v3h3v2z"
})), 'CreateNewFolder');

exports.default = _default;

/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
})), 'CreditCard');

exports.default = _default;

/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 15h2V7c0-1.1-.9-2-2-2H9v2h8v8zM7 17V1H5v4H1v2h4v10c0 1.1.9 2 2 2h10v4h2v-4h4v-2H7z"
})), 'Crop');

exports.default = _default;

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 6H5c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H5V8h14v8z"
})), 'Crop169');

exports.default = _default;

/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 4H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H5V6h14v12z"
})), 'Crop32');

exports.default = _default;

/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10z"
})), 'Crop54');

exports.default = _default;

/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 7H5c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm0 8H5V9h14v6z"
})), 'Crop75');

exports.default = _default;

/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
})), 'CropDin');

exports.default = _default;

/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 5v4h2V5h4V3H5c-1.1 0-2 .9-2 2zm2 10H3v4c0 1.1.9 2 2 2h4v-2H5v-4zm14 4h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zm0-16h-4v2h4v4h2V5c0-1.1-.9-2-2-2z"
})), 'CropFree');

exports.default = _default;

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10z"
})), 'CropLandscape');

exports.default = _default;

/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-5.04-6.71l-2.75 3.54-1.96-2.36L6.5 17h11l-3.54-4.71z"
})), 'CropOriginal');

exports.default = _default;

/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 3H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H7V5h10v14z"
})), 'CropPortrait');

exports.default = _default;

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7.47 21.49C4.2 19.93 1.86 16.76 1.5 13H0c.51 6.16 5.66 11 11.95 11 .23 0 .44-.02.66-.03L8.8 20.15l-1.33 1.34zM12.05 0c-.23 0-.44.02-.66.04l3.81 3.81 1.33-1.33C19.8 4.07 22.14 7.24 22.5 11H24c-.51-6.16-5.66-11-11.95-11zM16 14h2V8c0-1.11-.9-2-2-2h-6v2h6v6zm-8 2V4H6v2H4v2h2v8c0 1.1.89 2 2 2h8v2h2v-2h2v-2H8z"
})), 'CropRotate');

exports.default = _default;

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 4H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H6V6h12v12z"
})), 'CropSquare');

exports.default = _default;

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"
})), 'Dashboard');

exports.default = _default;

/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13 2.05v3.03c3.39.49 6 3.39 6 6.92 0 .9-.18 1.75-.48 2.54l2.6 1.53c.56-1.24.88-2.62.88-4.07 0-5.18-3.95-9.45-9-9.95zM12 19c-3.87 0-7-3.13-7-7 0-3.53 2.61-6.43 6-6.92V2.05c-5.06.5-9 4.76-9 9.95 0 5.52 4.47 10 9.99 10 3.31 0 6.24-1.61 8.06-4.09l-2.6-1.53C16.17 17.98 14.21 19 12 19z"
})), 'DataUsage');

exports.default = _default;

/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
})), 'DateRange');

exports.default = _default;

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M2 15.5v2h20v-2H2zm0-5v2h20v-2H2zm0-5v2h20v-2H2z"
})), 'Dehaze');

exports.default = _default;

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15 16h4v2h-4zm0-8h7v2h-7zm0 4h6v2h-6zM3 18c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V8H3v10zM14 5h-3l-1-1H6L5 5H2v2h12z"
})), 'DeleteSweep');

exports.default = _default;

/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"
})), 'Description');

exports.default = _default;

/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7l-2 3v1h8v-1l-2-3h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 12H3V4h18v10z"
})), 'DesktopMac');

exports.default = _default;

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v2H8v2h8v-2h-2v-2h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H3V4h18v12z"
})), 'DesktopWindows');

exports.default = _default;

/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 4l9 16 9-16H3zm3.38 2h11.25L12 16 6.38 6z"
})), 'Details');

exports.default = _default;

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 5h10v2h2V3c0-1.1-.9-1.99-2-1.99L7 1c-1.1 0-2 .9-2 2v4h2V5zm8.41 11.59L20 12l-4.59-4.59L14 8.83 17.17 12 14 15.17l1.41 1.42zM10 15.17L6.83 12 10 8.83 8.59 7.41 4 12l4.59 4.59L10 15.17zM17 19H7v-2H5v4c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-4h-2v2z"
})), 'DeveloperMode');

exports.default = _default;

/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 6h18V4H4c-1.1 0-2 .9-2 2v11H0v3h14v-3H4V6zm19 2h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 9h-4v-7h4v7z"
})), 'Devices');

exports.default = _default;

/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 6h18V4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V6zm10 6H9v1.78c-.61.55-1 1.33-1 2.22s.39 1.67 1 2.22V20h4v-1.78c.61-.55 1-1.34 1-2.22s-.39-1.67-1-2.22V12zm-2 5.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM22 8h-6c-.5 0-1 .5-1 1v10c0 .5.5 1 1 1h6c.5 0 1-.5 1-1V9c0-.5-.5-1-1-1zm-1 10h-4v-8h4v8z"
})), 'DevicesOther');

exports.default = _default;

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 3h-1v5h1V3zm-2 2h-2V4h2V3h-3v3h2v1h-2v1h3V5zm3-2v5h1V6h2V3h-3zm2 2h-1V4h1v1zm0 10.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.01.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.27-.26.35-.65.24-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z"
})), 'DialerSip');

exports.default = _default;

/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 19c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
})), 'Dialpad');

exports.default = _default;

/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21.71 11.29l-9-9c-.39-.39-1.02-.39-1.41 0l-9 9c-.39.39-.39 1.02 0 1.41l9 9c.39.39 1.02.39 1.41 0l9-9c.39-.38.39-1.01 0-1.41zM14 14.5V12h-4v3H8v-4c0-.55.45-1 1-1h5V7.5l3.5 3.5-3.5 3.5z"
})), 'Directions');

exports.default = _default;

/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5zm5.8-10l2.4-2.4.8.8c1.3 1.3 3 2.1 5.1 2.1V9c-1.5 0-2.7-.6-3.6-1.5l-1.9-1.9c-.5-.4-1-.6-1.6-.6s-1.1.2-1.4.6L7.8 8.4c-.4.4-.6.9-.6 1.4 0 .6.2 1.1.6 1.4L11 14v5h2v-6.2l-2.2-2.3zM19 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5z"
})), 'DirectionsBike');

exports.default = _default;

/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 21c-1.39 0-2.78-.47-4-1.32-2.44 1.71-5.56 1.71-8 0C6.78 20.53 5.39 21 4 21H2v2h2c1.38 0 2.74-.35 4-.99 2.52 1.29 5.48 1.29 8 0 1.26.65 2.62.99 4 .99h2v-2h-2zM3.95 19H4c1.6 0 3.02-.88 4-2 .98 1.12 2.4 2 4 2s3.02-.88 4-2c.98 1.12 2.4 2 4 2h.05l1.89-6.68c.08-.26.06-.54-.06-.78s-.34-.42-.6-.5L20 10.62V6c0-1.1-.9-2-2-2h-3V1H9v3H6c-1.1 0-2 .9-2 2v4.62l-1.29.42c-.26.08-.48.26-.6.5s-.15.52-.06.78L3.95 19zM6 6h12v3.97L12 8 6 9.97V6z"
})), 'DirectionsBoat');

exports.default = _default;

/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 16c0 .88.39 1.67 1 2.22V20c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1.78c.61-.55 1-1.34 1-2.22V6c0-3.5-3.58-4-8-4s-8 .5-8 4v10zm3.5 1c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm9 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6H6V6h12v5z"
})), 'DirectionsBus');

exports.default = _default;

/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 15.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V5c0-3.5-3.58-4-8-4s-8 .5-8 4v10.5zm8 1.5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm6-7H6V5h12v5z"
})), 'DirectionsRailway');

exports.default = _default;

/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13.49 5.48c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-3.6 13.9l1-4.4 2.1 2v6h2v-7.5l-2.1-2 .6-3c1.3 1.5 3.3 2.5 5.5 2.5v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1l-5.2 2.2v4.7h2v-3.4l1.8-.7-1.6 8.1-4.9-1-.4 2 7 1.4z"
})), 'DirectionsRun');

exports.default = _default;

/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2c-4.42 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-6H6V6h5v5zm5.5 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6h-5V6h5v5z"
})), 'DirectionsSubway');

exports.default = _default;

/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2c-4.42 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-6H6V6h5v5zm5.5 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6h-5V6h5v5z"
})), 'DirectionsTransit');

exports.default = _default;

/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM9.8 8.9L7 23h2.1l1.8-8 2.1 2v6h2v-7.5l-2.1-2 .6-3C14.8 12 16.8 13 19 13v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1L6 8.3V13h2V9.6l1.8-.7"
})), 'DirectionsWalk');

exports.default = _default;

/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 16h2v-2h-2v2zm0-9v5h2V7h-2zM10 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 10c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
})), 'DiscFull');

exports.default = _default;

/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 13H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zM7 19c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM20 3H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zM7 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
})), 'Dns');

exports.default = _default;

/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M8 23h8v-2H8v2zm8-21.99L8 1c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM16 15H8V5h8v10z"
})), 'Dock');

exports.default = _default;

/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
})), 'Domain');

exports.default = _default;

/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"
})), 'Done');

exports.default = _default;

/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 7l-1.41-1.41-6.34 6.34 1.41 1.41L18 7zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12-1.42-1.41zM.41 13.41L6 19l1.41-1.41L1.83 12 .41 13.41z"
})), 'DoneAll');

exports.default = _default;

/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z"
})), 'DoNotDisturb');

exports.default = _default;

/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zM4 12c0-4.4 3.6-8 8-8 1.8 0 3.5.6 4.9 1.7L5.7 16.9C4.6 15.5 4 13.8 4 12zm8 8c-1.8 0-3.5-.6-4.9-1.7L18.3 7.1C19.4 8.5 20 10.2 20 12c0 4.4-3.6 8-8 8z"
})), 'DoNotDisturbAlt');

exports.default = _default;

/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 11v2h-1.46l4.68 4.68C21.34 16.07 22 14.11 22 12c0-5.52-4.48-10-10-10-2.11 0-4.07.66-5.68 1.78L13.54 11H17zM2.27 2.27L1 3.54l2.78 2.78C2.66 7.93 2 9.89 2 12c0 5.52 4.48 10 10 10 2.11 0 4.07-.66 5.68-1.78L20.46 23l1.27-1.27L11 11 2.27 2.27zM7 13v-2h1.46l2 2H7z"
})), 'DoNotDisturbOff');

exports.default = _default;

/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z"
})), 'DoNotDisturbOn');

exports.default = _default;

/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11 5.08V2c-5 .5-9 4.81-9 10s4 9.5 9 10v-3.08c-3-.48-6-3.4-6-6.92s3-6.44 6-6.92zM18.97 11H22c-.47-5-4-8.53-9-9v3.08C16 5.51 18.54 8 18.97 11zM13 18.92V22c5-.47 8.53-4 9-9h-3.03c-.43 3-2.97 5.49-5.97 5.92z"
})), 'DonutLarge');

exports.default = _default;

/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11 9.16V2c-5 .5-9 4.79-9 10s4 9.5 9 10v-7.16c-1-.41-2-1.52-2-2.84s1-2.43 2-2.84zM14.86 11H22c-.48-4.75-4-8.53-9-9v7.16c1 .3 1.52.98 1.86 1.84zM13 14.84V22c5-.47 8.52-4.25 9-9h-7.14c-.34.86-.86 1.54-1.86 1.84z"
})), 'DonutSmall');

exports.default = _default;

/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21.99 8c0-.72-.37-1.35-.94-1.7L12 1 2.95 6.3C2.38 6.65 2 7.28 2 8v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2l-.01-10zM12 13L3.74 7.84 12 3l8.26 4.84L12 13z"
})), 'Drafts');

exports.default = _default;

/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 9H4v2h16V9zM4 15h16v-2H4v2z"
})), 'DragHandle');

exports.default = _default;

/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18.92 5.01C18.72 4.42 18.16 4 17.5 4h-11c-.66 0-1.21.42-1.42 1.01L3 11v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 15c-.83 0-1.5-.67-1.5-1.5S5.67 12 6.5 12s1.5.67 1.5 1.5S7.33 15 6.5 15zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 10l1.5-4.5h11L19 10H5z"
})), 'DriveEta');

exports.default = _default;

/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12zm-2-9H8v2h11V8zm0 4H8v2h11v-2zM7 8H5v2h2V8zm0 4H5v2h2v-2z"
})), 'Dvr');

exports.default = _default;

/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
})), 'Edit');

exports.default = _default;

/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm-1.56 10H9v-1.44l3.35-3.34 1.43 1.43L10.44 12zm4.45-4.45l-.7.7-1.44-1.44.7-.7c.15-.15.39-.15.54 0l.9.9c.15.15.15.39 0 .54z"
})), 'EditLocation');

exports.default = _default;

/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M5 17h14v2H5zm7-12L5.33 15h13.34z"
})), 'Eject');

exports.default = _default;

/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
})), 'Email');

exports.default = _default;

/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H8.9V6zM16 16h-3v3h-2v-3H8v-2h3v-3h2v3h3v2z"
})), 'EnhancedEncryption');

exports.default = _default;

/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 20h4V4h-4v16zm-6 0h4v-8H4v8zM16 9v11h4V9h-4z"
})), 'Equalizer');

exports.default = _default;

/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
})), 'Error');

exports.default = _default;

/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
})), 'ErrorOutline');

exports.default = _default;

/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15 18.5c-2.51 0-4.68-1.42-5.76-3.5H15v-2H8.58c-.05-.33-.08-.66-.08-1s.03-.67.08-1H15V9H9.24C10.32 6.92 12.5 5.5 15 5.5c1.61 0 3.09.59 4.23 1.57L21 5.3C19.41 3.87 17.3 3 15 3c-3.92 0-7.24 2.51-8.48 6H3v2h3.06c-.04.33-.06.66-.06 1 0 .34.02.67.06 1H3v2h3.52c1.24 3.49 4.56 6 8.48 6 2.31 0 4.41-.87 6-2.3l-1.78-1.77c-1.13.98-2.6 1.57-4.22 1.57z"
})), 'EuroSymbol');

exports.default = _default;

/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
})), 'Event');

exports.default = _default;

/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16.53 11.06L15.47 10l-4.88 4.88-2.12-2.12-1.06 1.06L10.59 17l5.94-5.94zM19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11z"
})), 'EventAvailable');

exports.default = _default;

/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9.31 17l2.44-2.44L14.19 17l1.06-1.06-2.44-2.44 2.44-2.44L14.19 10l-2.44 2.44L9.31 10l-1.06 1.06 2.44 2.44-2.44 2.44L9.31 17zM19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11z"
})), 'EventBusy');

exports.default = _default;

/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 10H7v2h10v-2zm2-7h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zm-5-5H7v2h7v-2z"
})), 'EventNote');

exports.default = _default;

/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 18v3h3v-3h10v3h3v-6H4zm15-8h3v3h-3zM2 10h3v3H2zm15 3H7V5c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2v8z"
})), 'EventSeat');

exports.default = _default;

/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33 0 1.38 1.12 2.5 2.5 2.5.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V9c0-.69-.28-1.32-.73-1.77zM18 10c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM8 18v-4.5H6L10 6v5h2l-4 7z"
})), 'EvStation');

exports.default = _default;

/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
})), 'ExitToApp');

exports.default = _default;

/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 6h-4v2h4v2h-4v2h4v2H9V7h6v2z"
})), 'Explicit');

exports.default = _default;

/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 10.9c-.61 0-1.1.49-1.1 1.1s.49 1.1 1.1 1.1c.61 0 1.1-.49 1.1-1.1s-.49-1.1-1.1-1.1zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm2.19 12.19L6 18l3.81-8.19L18 6l-3.81 8.19z"
})), 'Explore');

exports.default = _default;

/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15 17v2h2v-2h2v-2h-2v-2h-2v2h-2v2h2zm5-15H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM5 5h6v2H5V5zm15 15H4L20 4v16z"
})), 'Exposure');

exports.default = _default;

/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 11v2h8v-2H4zm15 7h-2V7.38L14 8.4V6.7L18.7 5h.3v13z"
})), 'ExposureNeg1');

exports.default = _default;

/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15.05 16.29l2.86-3.07c.38-.39.72-.79 1.04-1.18.32-.39.59-.78.82-1.17.23-.39.41-.78.54-1.17s.19-.79.19-1.18c0-.53-.09-1.02-.27-1.46-.18-.44-.44-.81-.78-1.11-.34-.31-.77-.54-1.26-.71-.51-.16-1.08-.24-1.72-.24-.69 0-1.31.11-1.85.32-.54.21-1 .51-1.36.88-.37.37-.65.8-.84 1.3-.18.47-.27.97-.28 1.5h2.14c.01-.31.05-.6.13-.87.09-.29.23-.54.4-.75.18-.21.41-.37.68-.49.27-.12.6-.18.96-.18.31 0 .58.05.81.15.23.1.43.25.59.43.16.18.28.4.37.65.08.25.13.52.13.81 0 .22-.03.43-.08.65-.06.22-.15.45-.29.7-.14.25-.32.53-.56.83-.23.3-.52.65-.88 1.03l-4.17 4.55V18H21v-1.71h-5.95zM2 11v2h8v-2H2z"
})), 'ExposureNeg2');

exports.default = _default;

/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 7H8v4H4v2h4v4h2v-4h4v-2h-4V7zm10 11h-2V7.38L15 8.4V6.7L19.7 5h.3v13z"
})), 'ExposurePlus1');

exports.default = _default;

/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16.05 16.29l2.86-3.07c.38-.39.72-.79 1.04-1.18.32-.39.59-.78.82-1.17.23-.39.41-.78.54-1.17.13-.39.19-.79.19-1.18 0-.53-.09-1.02-.27-1.46-.18-.44-.44-.81-.78-1.11-.34-.31-.77-.54-1.26-.71-.51-.16-1.08-.24-1.72-.24-.69 0-1.31.11-1.85.32-.54.21-1 .51-1.36.88-.37.37-.65.8-.84 1.3-.18.47-.27.97-.28 1.5h2.14c.01-.31.05-.6.13-.87.09-.29.23-.54.4-.75.18-.21.41-.37.68-.49.27-.12.6-.18.96-.18.31 0 .58.05.81.15.23.1.43.25.59.43.16.18.28.4.37.65.08.25.13.52.13.81 0 .22-.03.43-.08.65-.06.22-.15.45-.29.7-.14.25-.32.53-.56.83-.23.3-.52.65-.88 1.03l-4.17 4.55V18H22v-1.71h-5.95zM8 7H6v4H2v2h4v4h2v-4h4v-2H8V7z"
})), 'ExposurePlus2');

exports.default = _default;

/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16.14 12.5c0 1-.1 1.85-.3 2.55-.2.7-.48 1.27-.83 1.7-.36.44-.79.75-1.3.95-.51.2-1.07.3-1.7.3-.62 0-1.18-.1-1.69-.3-.51-.2-.95-.51-1.31-.95-.36-.44-.65-1.01-.85-1.7-.2-.7-.3-1.55-.3-2.55v-2.04c0-1 .1-1.85.3-2.55.2-.7.48-1.26.84-1.69.36-.43.8-.74 1.31-.93C10.81 5.1 11.38 5 12 5c.63 0 1.19.1 1.7.29.51.19.95.5 1.31.93.36.43.64.99.84 1.69.2.7.3 1.54.3 2.55v2.04zm-2.11-2.36c0-.64-.05-1.18-.13-1.62-.09-.44-.22-.79-.4-1.06-.17-.27-.39-.46-.64-.58-.25-.13-.54-.19-.86-.19-.32 0-.61.06-.86.18s-.47.31-.64.58c-.17.27-.31.62-.4 1.06s-.13.98-.13 1.62v2.67c0 .64.05 1.18.14 1.62.09.45.23.81.4 1.09s.39.48.64.61.54.19.87.19c.33 0 .62-.06.87-.19s.46-.33.63-.61c.17-.28.3-.64.39-1.09.09-.45.13-.99.13-1.62v-2.66z"
})), 'ExposureZero');

exports.default = _default;

/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20.5 11H19V7c0-1.1-.9-2-2-2h-4V3.5C13 2.12 11.88 1 10.5 1S8 2.12 8 3.5V5H4c-1.1 0-1.99.9-1.99 2v3.8H3.5c1.49 0 2.7 1.21 2.7 2.7s-1.21 2.7-2.7 2.7H2V20c0 1.1.9 2 2 2h3.8v-1.5c0-1.49 1.21-2.7 2.7-2.7 1.49 0 2.7 1.21 2.7 2.7V22H17c1.1 0 2-.9 2-2v-4h1.5c1.38 0 2.5-1.12 2.5-2.5S21.88 11 20.5 11z"
})), 'Extension');

exports.default = _default;

/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9 11.75c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zm6 0c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-.29.02-.58.05-.86 2.36-1.05 4.23-2.98 5.21-5.37C11.07 8.33 14.05 10 17.42 10c.78 0 1.53-.09 2.25-.26.21.71.33 1.47.33 2.26 0 4.41-3.59 8-8 8z"
})), 'Face');

exports.default = _default;

/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 18l8.5-6L4 6v12zm9-12v12l8.5-6L13 6z"
})), 'FastForward');

exports.default = _default;

/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11 18V6l-8.5 6 8.5 6zm.5-6l8.5 6V6l-8.5 6z"
})), 'FastRewind');

exports.default = _default;

/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
})), 'Favorite');

exports.default = _default;

/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"
})), 'FavoriteBorder');

exports.default = _default;

/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 8H3V9h9v2zm0-4H3V5h9v2z"
})), 'FeaturedPlayList');

exports.default = _default;

/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 9H3V5h9v7z"
})), 'FeaturedVideo');

exports.default = _default;

/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 12h-2v-2h2v2zm0-4h-2V6h2v4z"
})), 'Feedback');

exports.default = _default;

/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17.5 10.5h2v1h-2zm-13 0h2v3h-2zM21 3H3c-1.11 0-2 .89-2 2v14c0 1.1.89 2 2 2h18c1.11 0 2-.9 2-2V5c0-1.11-.89-2-2-2zM8 13.5c0 .85-.65 1.5-1.5 1.5H3V9h3.5c.85 0 1.5.65 1.5 1.5v3zm4.62 1.5h-1.5L9.37 9h1.5l1 3.43 1-3.43h1.5l-1.75 6zM21 11.5c0 .6-.4 1.15-.9 1.4L21 15h-1.5l-.85-2H17.5v2H16V9h3.5c.85 0 1.5.65 1.5 1.5v1z"
})), 'FiberDvr');

exports.default = _default;

/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "8"
})), 'FiberManualRecord');

exports.default = _default;

/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zM8.5 15H7.3l-2.55-3.5V15H3.5V9h1.25l2.5 3.5V9H8.5v6zm5-4.74H11v1.12h2.5v1.26H11v1.11h2.5V15h-4V9h4v1.26zm7 3.74c0 .55-.45 1-1 1h-4c-.55 0-1-.45-1-1V9h1.25v4.51h1.13V9.99h1.25v3.51h1.12V9h1.25v5z"
})), 'FiberNew');

exports.default = _default;

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M5.5 10.5h2v1h-2zM20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zM9 11.5c0 .85-.65 1.5-1.5 1.5h-2v2H4V9h3.5c.85 0 1.5.65 1.5 1.5v1zm3.5 3.5H11V9h1.5v6zm7.5 0h-1.2l-2.55-3.5V15H15V9h1.25l2.5 3.5V9H20v6z"
})), 'FiberPin');

exports.default = _default;

/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("g", null, _react.default.createElement("circle", {
  cx: "9",
  cy: "12",
  r: "8"
}), _react.default.createElement("path", {
  d: "M17 4.26v2.09c2.33.82 4 3.04 4 5.65s-1.67 4.83-4 5.65v2.09c3.45-.89 6-4.01 6-7.74s-2.55-6.85-6-7.74z"
}))), 'FiberSmartRecord');

exports.default = _default;

/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z"
})), 'FileUpload');

exports.default = _default;

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15.96 10.29l-2.75 3.54-1.96-2.36L8.5 15h11l-3.54-4.71zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"
})), 'Filter');

exports.default = _default;

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm11 10h2V5h-4v2h2v8zm7-14H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"
})), 'Filter1');

exports.default = _default;

/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-4-4h-4v-2h2c1.1 0 2-.89 2-2V7c0-1.11-.9-2-2-2h-4v2h4v2h-2c-1.1 0-2 .89-2 2v4h6v-2z"
})), 'Filter2');

exports.default = _default;

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm14 8v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V7c0-1.11-.9-2-2-2h-4v2h4v2h-2v2h2v2h-4v2h4c1.1 0 2-.89 2-2z"
})), 'Filter3');

exports.default = _default;

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm12 10h2V5h-2v4h-2V5h-2v6h4v4zm6-14H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"
})), 'Filter4');

exports.default = _default;

/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm14 8v-2c0-1.11-.9-2-2-2h-2V7h4V5h-6v6h4v2h-4v2h4c1.1 0 2-.89 2-2z"
})), 'Filter5');

exports.default = _default;

/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2h2c1.1 0 2-.89 2-2v-2c0-1.11-.9-2-2-2h-2V7h4V5h-4c-1.1 0-2 .89-2 2v6c0 1.11.9 2 2 2zm0-4h2v2h-2v-2z"
})), 'Filter6');

exports.default = _default;

/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2l4-8V5h-6v2h4l-4 8h2z"
})), 'Filter7');

exports.default = _default;

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2h2c1.1 0 2-.89 2-2v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V7c0-1.11-.9-2-2-2h-2c-1.1 0-2 .89-2 2v1.5c0 .83.67 1.5 1.5 1.5-.83 0-1.5.67-1.5 1.5V13c0 1.11.9 2 2 2zm0-8h2v2h-2V7zm0 4h2v2h-2v-2z"
})), 'Filter8');

exports.default = _default;

/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM15 5h-2c-1.1 0-2 .89-2 2v2c0 1.11.9 2 2 2h2v2h-4v2h4c1.1 0 2-.89 2-2V7c0-1.11-.9-2-2-2zm0 4h-2V7h2v2z"
})), 'Filter9');

exports.default = _default;

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm11 7V8c0-1.11-.9-2-2-2h-1c-1.1 0-2 .89-2 2v1c0 1.11.9 2 2 2h1v1H9v2h3c1.1 0 2-.89 2-2zm-3-3V8h1v1h-1zm10-8H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 8h-2V7h-2v2h-2v2h2v2h2v-2h2v6H7V3h14v6z"
})), 'Filter9Plus');

exports.default = _default;

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16l-7-8v8H5l7-8V5h7v14z"
})), 'FilterBAndW');

exports.default = _default;

/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M5 15H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zM12 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
})), 'FilterCenterFocus');

exports.default = _default;

/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.61 5.64 5.36 8.04 2.35 8.36 0 10.9 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4h2c0-2.76-1.86-5.08-4.4-5.78C8.61 6.88 10.2 6 12 6c3.03 0 5.5 2.47 5.5 5.5v.5H19c1.65 0 3 1.35 3 3s-1.35 3-3 3z"
})), 'FilterDrama');

exports.default = _default;

/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 4h-4l-4-4-4 4H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H4V6h4.52l3.52-3.5L15.52 6H20v14zM18 8H6v10h12"
})), 'FilterFrames');

exports.default = _default;

/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z"
})), 'FilterHdr');

exports.default = _default;

/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"
})), 'FilterNone');

exports.default = _default;

/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11 4.07V2.05c-2.01.2-3.84 1-5.32 2.21L7.1 5.69c1.11-.86 2.44-1.44 3.9-1.62zm7.32.19C16.84 3.05 15.01 2.25 13 2.05v2.02c1.46.18 2.79.76 3.9 1.62l1.42-1.43zM19.93 11h2.02c-.2-2.01-1-3.84-2.21-5.32L18.31 7.1c.86 1.11 1.44 2.44 1.62 3.9zM5.69 7.1L4.26 5.68C3.05 7.16 2.25 8.99 2.05 11h2.02c.18-1.46.76-2.79 1.62-3.9zM4.07 13H2.05c.2 2.01 1 3.84 2.21 5.32l1.43-1.43c-.86-1.1-1.44-2.43-1.62-3.89zM15 12c0-1.66-1.34-3-3-3s-3 1.34-3 3 1.34 3 3 3 3-1.34 3-3zm3.31 4.9l1.43 1.43c1.21-1.48 2.01-3.32 2.21-5.32h-2.02c-.18 1.45-.76 2.78-1.62 3.89zM13 19.93v2.02c2.01-.2 3.84-1 5.32-2.21l-1.43-1.43c-1.1.86-2.43 1.44-3.89 1.62zm-7.32-.19C7.16 20.95 9 21.75 11 21.95v-2.02c-1.46-.18-2.79-.76-3.9-1.62l-1.42 1.43z"
})), 'FilterTiltShift');

exports.default = _default;

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18.7 12.4c-.28-.16-.57-.29-.86-.4.29-.11.58-.24.86-.4 1.92-1.11 2.99-3.12 3-5.19-1.79-1.03-4.07-1.11-6 0-.28.16-.54.35-.78.54.05-.31.08-.63.08-.95 0-2.22-1.21-4.15-3-5.19C10.21 1.85 9 3.78 9 6c0 .32.03.64.08.95-.24-.2-.5-.39-.78-.55-1.92-1.11-4.2-1.03-6 0 0 2.07 1.07 4.08 3 5.19.28.16.57.29.86.4-.29.11-.58.24-.86.4-1.92 1.11-2.99 3.12-3 5.19 1.79 1.03 4.07 1.11 6 0 .28-.16.54-.35.78-.54-.05.32-.08.64-.08.96 0 2.22 1.21 4.15 3 5.19 1.79-1.04 3-2.97 3-5.19 0-.32-.03-.64-.08-.95.24.2.5.38.78.54 1.92 1.11 4.2 1.03 6 0-.01-2.07-1.08-4.08-3-5.19zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
})), 'FilterVintage');

exports.default = _default;

/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 19.59V8l-6-6H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c.45 0 .85-.15 1.19-.4l-4.43-4.43c-.8.52-1.74.83-2.76.83-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5c0 1.02-.31 1.96-.83 2.75L20 19.59zM9 13c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3z"
})), 'FindInPage');

exports.default = _default;

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11 6c1.38 0 2.63.56 3.54 1.46L12 10h6V4l-2.05 2.05C14.68 4.78 12.93 4 11 4c-3.53 0-6.43 2.61-6.92 6H6.1c.46-2.28 2.48-4 4.9-4zm5.64 9.14c.66-.9 1.12-1.97 1.28-3.14H15.9c-.46 2.28-2.48 4-4.9 4-1.38 0-2.63-.56-3.54-1.46L10 12H4v6l2.05-2.05C7.32 17.22 9.07 18 11 18c1.55 0 2.98-.51 4.14-1.36L20 21.49 21.49 20l-4.85-4.86z"
})), 'FindReplace');

exports.default = _default;

/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17.81 4.47c-.08 0-.16-.02-.23-.06C15.66 3.42 14 3 12.01 3c-1.98 0-3.86.47-5.57 1.41-.24.13-.54.04-.68-.2-.13-.24-.04-.55.2-.68C7.82 2.52 9.86 2 12.01 2c2.13 0 3.99.47 6.03 1.52.25.13.34.43.21.67-.09.18-.26.28-.44.28zM3.5 9.72c-.1 0-.2-.03-.29-.09-.23-.16-.28-.47-.12-.7.99-1.4 2.25-2.5 3.75-3.27C9.98 4.04 14 4.03 17.15 5.65c1.5.77 2.76 1.86 3.75 3.25.16.22.11.54-.12.7-.23.16-.54.11-.7-.12-.9-1.26-2.04-2.25-3.39-2.94-2.87-1.47-6.54-1.47-9.4.01-1.36.7-2.5 1.7-3.4 2.96-.08.14-.23.21-.39.21zm6.25 12.07c-.13 0-.26-.05-.35-.15-.87-.87-1.34-1.43-2.01-2.64-.69-1.23-1.05-2.73-1.05-4.34 0-2.97 2.54-5.39 5.66-5.39s5.66 2.42 5.66 5.39c0 .28-.22.5-.5.5s-.5-.22-.5-.5c0-2.42-2.09-4.39-4.66-4.39-2.57 0-4.66 1.97-4.66 4.39 0 1.44.32 2.77.93 3.85.64 1.15 1.08 1.64 1.85 2.42.19.2.19.51 0 .71-.11.1-.24.15-.37.15zm7.17-1.85c-1.19 0-2.24-.3-3.1-.89-1.49-1.01-2.38-2.65-2.38-4.39 0-.28.22-.5.5-.5s.5.22.5.5c0 1.41.72 2.74 1.94 3.56.71.48 1.54.71 2.54.71.24 0 .64-.03 1.04-.1.27-.05.53.13.58.41.05.27-.13.53-.41.58-.57.11-1.07.12-1.21.12zM14.91 22c-.04 0-.09-.01-.13-.02-1.59-.44-2.63-1.03-3.72-2.1-1.4-1.39-2.17-3.24-2.17-5.22 0-1.62 1.38-2.94 3.08-2.94 1.7 0 3.08 1.32 3.08 2.94 0 1.07.93 1.94 2.08 1.94s2.08-.87 2.08-1.94c0-3.77-3.25-6.83-7.25-6.83-2.84 0-5.44 1.58-6.61 4.03-.39.81-.59 1.76-.59 2.8 0 .78.07 2.01.67 3.61.1.26-.03.55-.29.64-.26.1-.55-.04-.64-.29-.49-1.31-.73-2.61-.73-3.96 0-1.2.23-2.29.68-3.24 1.33-2.79 4.28-4.6 7.51-4.6 4.55 0 8.25 3.51 8.25 7.83 0 1.62-1.38 2.94-3.08 2.94s-3.08-1.32-3.08-2.94c0-1.07-.93-1.94-2.08-1.94s-2.08.87-2.08 1.94c0 1.71.66 3.31 1.87 4.51.95.94 1.86 1.46 3.27 1.85.27.07.42.35.35.61-.05.23-.26.38-.47.38z"
})), 'Fingerprint');

exports.default = _default;

/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
})), 'FirstPage');

exports.default = _default;

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20.57 14.86L22 13.43 20.57 12 17 15.57 8.43 7 12 3.43 10.57 2 9.14 3.43 7.71 2 5.57 4.14 4.14 2.71 2.71 4.14l1.43 1.43L2 7.71l1.43 1.43L2 10.57 3.43 12 7 8.43 15.57 17 12 20.57 13.43 22l1.43-1.43L16.29 22l2.14-2.14 1.43 1.43 1.43-1.43-1.43-1.43L22 16.29z"
})), 'FitnessCenter');

exports.default = _default;

/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z"
})), 'Flag');

exports.default = _default;

/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 11H1v2h6v-2zm2.17-3.24L7.05 5.64 5.64 7.05l2.12 2.12 1.41-1.41zM13 1h-2v6h2V1zm5.36 6.05l-1.41-1.41-2.12 2.12 1.41 1.41 2.12-2.12zM17 11v2h6v-2h-6zm-5-2c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm2.83 7.24l2.12 2.12 1.41-1.41-2.12-2.12-1.41 1.41zm-9.19.71l1.41 1.41 2.12-2.12-1.41-1.41-2.12 2.12zM11 23h2v-6h-2v6z"
})), 'Flare');

exports.default = _default;

/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 2v12h3v9l7-12H9l4-9H3zm16 0h-2l-3.2 9h1.9l.7-2h3.2l.7 2h1.9L19 2zm-2.15 5.65L18 4l1.15 3.65h-2.3z"
})), 'FlashAuto');

exports.default = _default;

/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3.27 3L2 4.27l5 5V13h3v9l3.58-6.14L17.73 20 19 18.73 3.27 3zM17 10h-4l4-8H7v2.18l8.46 8.46L17 10z"
})), 'FlashOff');

exports.default = _default;

/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 2v11h3v9l7-12h-4l4-8z"
})), 'FlashOn');

exports.default = _default;

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10.18 9"
}), _react.default.createElement("path", {
  d: "M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"
})), 'Flight');

exports.default = _default;

/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M2.5 19h19v2h-19zm7.18-5.73l4.35 1.16 5.31 1.42c.8.21 1.62-.26 1.84-1.06.21-.8-.26-1.62-1.06-1.84l-5.31-1.42-2.76-9.02L10.12 2v8.28L5.15 8.95l-.93-2.32-1.45-.39v5.17l1.6.43 5.31 1.43z"
})), 'FlightLand');

exports.default = _default;

/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M2.5 19h19v2h-19zm19.57-9.36c-.21-.8-1.04-1.28-1.84-1.06L14.92 10l-6.9-6.43-1.93.51 4.14 7.17-4.97 1.33-1.97-1.54-1.45.39 1.82 3.16.77 1.33 1.6-.43 5.31-1.42 4.35-1.16L21 11.49c.81-.23 1.28-1.05 1.07-1.85z"
})), 'FlightTakeoff');

exports.default = _default;

/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15 21h2v-2h-2v2zm4-12h2V7h-2v2zM3 5v14c0 1.1.9 2 2 2h4v-2H5V5h4V3H5c-1.1 0-2 .9-2 2zm16-2v2h2c0-1.1-.9-2-2-2zm-8 20h2V1h-2v22zm8-6h2v-2h-2v2zM15 5h2V3h-2v2zm4 8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2z"
})), 'Flip');

exports.default = _default;

/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9 7H7v2h2V7zm0 4H7v2h2v-2zm0-8c-1.11 0-2 .9-2 2h2V3zm4 12h-2v2h2v-2zm6-12v2h2c0-1.1-.9-2-2-2zm-6 0h-2v2h2V3zM9 17v-2H7c0 1.1.89 2 2 2zm10-4h2v-2h-2v2zm0-4h2V7h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zM5 7H3v12c0 1.1.89 2 2 2h12v-2H5V7zm10-2h2V3h-2v2zm0 12h2v-2h-2v2z"
})), 'FlipToBack');

exports.default = _default;

/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 13h2v-2H3v2zm0 4h2v-2H3v2zm2 4v-2H3c0 1.1.89 2 2 2zM3 9h2V7H3v2zm12 12h2v-2h-2v2zm4-18H9c-1.11 0-2 .9-2 2v10c0 1.1.89 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12H9V5h10v10zm-8 6h2v-2h-2v2zm-4 0h2v-2H7v2z"
})), 'FlipToFront');

exports.default = _default;

/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10z"
})), 'FolderOpen');

exports.default = _default;

/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-5 3c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm4 8h-8v-1c0-1.33 2.67-2 4-2s4 .67 4 2v1z"
})), 'FolderShared');

exports.default = _default;

/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-2.06 11L15 15.28 12.06 17l.78-3.33-2.59-2.24 3.41-.29L15 8l1.34 3.14 3.41.29-2.59 2.24.78 3.33z"
})), 'FolderSpecial');

exports.default = _default;

/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9.93 13.5h4.14L12 7.98zM20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-4.05 16.5l-1.14-3H9.17l-1.12 3H5.96l5.11-13h1.86l5.11 13h-2.09z"
})), 'FontDownload');

exports.default = _default;

/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 15v2h10v-2H7zm-4 6h18v-2H3v2zm0-8h18v-2H3v2zm4-6v2h10V7H7zM3 3v2h18V3H3z"
})), 'FormatAlignCenter');

exports.default = _default;

/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 21h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18V7H3v2zm0-6v2h18V3H3z"
})), 'FormatAlignJustify');

exports.default = _default;

/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15 15H3v2h12v-2zm0-8H3v2h12V7zM3 13h18v-2H3v2zm0 8h18v-2H3v2zM3 3v2h18V3H3z"
})), 'FormatAlignLeft');

exports.default = _default;

/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 21h18v-2H3v2zm6-4h12v-2H9v2zm-6-4h18v-2H3v2zm6-4h12V7H9v2zM3 3v2h18V3H3z"
})), 'FormatAlignRight');

exports.default = _default;

/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15.6 10.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42zM10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z"
})), 'FormatBold');

exports.default = _default;

/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3.27 5L2 6.27l6.97 6.97L6.5 19h3l1.57-3.66L16.73 21 18 19.73 3.55 5.27 3.27 5zM6 5v.18L8.82 8h2.4l-.72 1.68 2.1 2.1L14.21 8H20V5H6z"
})), 'FormatClear');

exports.default = _default;

/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16.56 8.94L7.62 0 6.21 1.41l2.38 2.38-5.15 5.15c-.59.59-.59 1.54 0 2.12l5.5 5.5c.29.29.68.44 1.06.44s.77-.15 1.06-.44l5.5-5.5c.59-.58.59-1.53 0-2.12zM5.21 10L10 5.21 14.79 10H5.21zM19 11.5s-2 2.17-2 3.5c0 1.1.9 2 2 2s2-.9 2-2c0-1.33-2-3.5-2-3.5z"
}), _react.default.createElement("path", {
  fillOpacity: ".36",
  d: "M0 20h24v4H0z"
})), 'FormatColorFill');

exports.default = _default;

/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 14c0-4-6-10.8-6-10.8s-1.33 1.51-2.73 3.52l8.59 8.59c.09-.42.14-.86.14-1.31zm-.88 3.12L12.5 12.5 5.27 5.27 4 6.55l3.32 3.32C6.55 11.32 6 12.79 6 14c0 3.31 2.69 6 6 6 1.52 0 2.9-.57 3.96-1.5l2.63 2.63 1.27-1.27-2.74-2.74z"
})), 'FormatColorReset');

exports.default = _default;

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".36",
  d: "M0 20h24v4H0z"
}), _react.default.createElement("path", {
  d: "M11 3L5.5 17h2.25l1.12-3h6.25l1.12 3h2.25L13 3h-2zm-1.38 9L12 5.67 14.38 12H9.62z"
})), 'FormatColorText');

exports.default = _default;

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11 17h10v-2H11v2zm-8-5l4 4V8l-4 4zm0 9h18v-2H3v2zM3 3v2h18V3H3zm8 6h10V7H11v2zm0 4h10v-2H11v2z"
})), 'FormatIndentDecrease');

exports.default = _default;

/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 21h18v-2H3v2zM3 8v8l4-4-4-4zm8 9h10v-2H11v2zM3 3v2h18V3H3zm8 6h10V7H11v2zm0 4h10v-2H11v2z"
})), 'FormatIndentIncrease');

exports.default = _default;

/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4z"
})), 'FormatItalic');

exports.default = _default;

/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6 7h2.5L5 3.5 1.5 7H4v10H1.5L5 20.5 8.5 17H6V7zm4-2v2h12V5H10zm0 14h12v-2H10v2zm0-6h12v-2H10v2z"
})), 'FormatLineSpacing');

exports.default = _default;

/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z"
})), 'FormatListBulleted');

exports.default = _default;

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M2 17h2v.5H3v1h1v.5H2v1h3v-4H2v1zm1-9h1V4H2v1h1v3zm-1 3h1.8L2 13.1v.9h3v-1H3.2L5 10.9V10H2v1zm5-6v2h14V5H7zm0 14h14v-2H7v2zm0-6h14v-2H7v2z"
})), 'FormatListNumbered');

exports.default = _default;

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 4V3c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6h1v4H9v11c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-9h8V4h-3z"
})), 'FormatPaint');

exports.default = _default;

/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z"
})), 'FormatQuote');

exports.default = _default;

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M23 7V1h-6v2H7V1H1v6h2v10H1v6h6v-2h10v2h6v-6h-2V7h2zM3 3h2v2H3V3zm2 18H3v-2h2v2zm12-2H7v-2H5V7h2V5h10v2h2v10h-2v2zm4 2h-2v-2h2v2zM19 5V3h2v2h-2zm-5.27 9h-3.49l-.73 2H7.89l3.4-9h1.4l3.41 9h-1.63l-.74-2zm-3.04-1.26h2.61L12 8.91l-1.31 3.83z"
})), 'FormatShapes');

exports.default = _default;

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9 4v3h5v12h3V7h5V4H9zm-6 8h3v7h3v-7h3V9H3v3z"
})), 'FormatSize');

exports.default = _default;

/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 19h4v-3h-4v3zM5 4v3h5v3h4V7h5V4H5zM3 14h18v-2H3v2z"
})), 'FormatStrikethrough');

exports.default = _default;

/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9 10v5h2V4h2v11h2V4h2V2H9C6.79 2 5 3.79 5 6s1.79 4 4 4zm12 8l-4-4v3H5v2h12v3l4-4z"
})), 'FormatTextdirectionLToR');

exports.default = _default;

/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 10v5h2V4h2v11h2V4h2V2h-8C7.79 2 6 3.79 6 6s1.79 4 4 4zm-2 7v-3l-4 4 4 4v-3h12v-2H8z"
})), 'FormatTextdirectionRToL');

exports.default = _default;

/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 17c3.31 0 6-2.69 6-6V3h-2.5v8c0 1.93-1.57 3.5-3.5 3.5S8.5 12.93 8.5 11V3H6v8c0 3.31 2.69 6 6 6zm-7 2v2h14v-2H5z"
})), 'FormatUnderlined');

exports.default = _default;

/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z"
})), 'Forum');

exports.default = _default;

/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 8V4l8 8-8 8v-4H4V8z"
})), 'Forward');

exports.default = _default;

/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 13c0 4.4 3.6 8 8 8s8-3.6 8-8h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6v4l5-5-5-5v4c-4.4 0-8 3.6-8 8zm6.8 3H10v-3.3L9 13v-.7l1.8-.6h.1V16zm4.3-1.8c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1.3.2.5.3.2.3.3.6.1.5.1.8v.7zm-.8-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z"
})), 'Forward10');

exports.default = _default;

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9.6 13.5h.4c.2 0 .4-.1.5-.2s.2-.2.2-.4v-.2s-.1-.1-.1-.2-.1-.1-.2-.1h-.5s-.1.1-.2.1-.1.1-.1.2v.2h-1c0-.2 0-.3.1-.5s.2-.3.3-.4.3-.2.4-.2.4-.1.5-.1c.2 0 .4 0 .6.1s.3.1.5.2.2.2.3.4.1.3.1.5v.3s-.1.2-.1.3-.1.2-.2.2-.2.1-.3.2c.2.1.4.2.5.4s.2.4.2.6c0 .2 0 .4-.1.5s-.2.3-.3.4-.3.2-.5.2-.4.1-.6.1c-.2 0-.4 0-.5-.1s-.3-.1-.5-.2-.2-.2-.3-.4-.1-.4-.1-.6h.8v.2s.1.1.1.2.1.1.2.1h.5s.1-.1.2-.1.1-.1.1-.2v-.5s-.1-.1-.1-.2-.1-.1-.2-.1h-.6v-.7zm5.7.7c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1.3.2.5.3.2.3.3.6.1.5.1.8v.7zm-.9-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5zM4 13c0 4.4 3.6 8 8 8s8-3.6 8-8h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6v4l5-5-5-5v4c-4.4 0-8 3.6-8 8z"
})), 'Forward30');

exports.default = _default;

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 13c0 4.4 3.6 8 8 8s8-3.6 8-8h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6v4l5-5-5-5v4c-4.4 0-8 3.6-8 8zm6.7.9l.2-2.2h2.4v.7h-1.7l-.1.9s.1 0 .1-.1.1 0 .1-.1.1 0 .2 0h.2c.2 0 .4 0 .5.1s.3.2.4.3.2.3.3.5.1.4.1.6c0 .2 0 .4-.1.5s-.1.3-.3.5-.3.2-.5.3-.4.1-.6.1c-.2 0-.4 0-.5-.1s-.3-.1-.5-.2-.2-.2-.3-.4-.1-.3-.1-.5h.8c0 .2.1.3.2.4s.2.1.4.1c.1 0 .2 0 .3-.1l.2-.2s.1-.2.1-.3v-.6l-.1-.2-.2-.2s-.2-.1-.3-.1h-.2s-.1 0-.2.1-.1 0-.1.1-.1.1-.1.1h-.6z"
})), 'Forward5');

exports.default = _default;

/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.11 0 2-.9 2-2V5c0-1.11-.89-2-2-2zm0 5h-2V5h2v3zM4 19h16v2H4z"
})), 'FreeBreakfast');

exports.default = _default;

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"
})), 'Fullscreen');

exports.default = _default;

/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"
})), 'FullscreenExit');

exports.default = _default;

/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 4H6v2l6.5 6L6 18v2h12v-3h-7l5-5-5-5h7z"
})), 'Functions');

exports.default = _default;

/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15 7.5V2H9v5.5l3 3 3-3zM7.5 9H2v6h5.5l3-3-3-3zM9 16.5V22h6v-5.5l-3-3-3 3zM16.5 9l-3 3 3 3H22V9h-5.5z"
})), 'Gamepad');

exports.default = _default;

/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15 7.5V2H9v5.5l3 3 3-3zM7.5 9H2v6h5.5l3-3-3-3zM9 16.5V22h6v-5.5l-3-3-3 3zM16.5 9l-3 3 3 3H22V9h-5.5z"
})), 'Games');

exports.default = _default;

/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M1 21h12v2H1zM5.245 8.07l2.83-2.827 14.14 14.142-2.828 2.828zM12.317 1l5.657 5.656-2.83 2.83-5.654-5.66zM3.825 9.485l5.657 5.657-2.828 2.828-5.657-5.657z"
})), 'Gavel');

exports.default = _default;

/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4.59 6.89c.7-.71 1.4-1.35 1.71-1.22.5.2 0 1.03-.3 1.52-.25.42-2.86 3.89-2.86 6.31 0 1.28.48 2.34 1.34 2.98.75.56 1.74.73 2.64.46 1.07-.31 1.95-1.4 3.06-2.77 1.21-1.49 2.83-3.44 4.08-3.44 1.63 0 1.65 1.01 1.76 1.79-3.78.64-5.38 3.67-5.38 5.37 0 1.7 1.44 3.09 3.21 3.09 1.63 0 4.29-1.33 4.69-6.1H21v-2.5h-2.47c-.15-1.65-1.09-4.2-4.03-4.2-2.25 0-4.18 1.91-4.94 2.84-.58.73-2.06 2.48-2.29 2.72-.25.3-.68.84-1.11.84-.45 0-.72-.83-.36-1.92.35-1.09 1.4-2.86 1.85-3.52.78-1.14 1.3-1.92 1.3-3.28C8.95 3.69 7.31 3 6.44 3 5.12 3 3.97 4 3.72 4.25c-.36.36-.66.66-.88.93l1.75 1.71zm9.29 11.66c-.31 0-.74-.26-.74-.72 0-.6.73-2.2 2.87-2.76-.3 2.69-1.43 3.48-2.13 3.48z"
})), 'Gesture');

exports.default = _default;

/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"
})), 'GetApp');

exports.default = _default;

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11.5 9H13v6h-1.5zM9 9H6c-.6 0-1 .5-1 1v4c0 .5.4 1 1 1h3c.6 0 1-.5 1-1v-2H8.5v1.5h-2v-3H10V10c0-.5-.4-1-1-1zm10 1.5V9h-4.5v6H16v-2h2v-1.5h-2v-1z"
})), 'Gif');

exports.default = _default;

/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("circle", {
  cx: "19.5",
  cy: "19.5",
  r: "1.5"
}), _react.default.createElement("path", {
  d: "M17 5.92L9 2v18H7v-1.73c-1.79.35-3 .99-3 1.73 0 1.1 2.69 2 6 2s6-.9 6-2c0-.99-2.16-1.81-5-1.97V8.98l6-3.06z"
})), 'GolfCourse');

exports.default = _default;

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
})), 'GpsFixed');

exports.default = _default;

/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
})), 'GpsNotFixed');

exports.default = _default;

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06c-1.13.12-2.19.46-3.16.97l1.5 1.5C10.16 5.19 11.06 5 12 5c3.87 0 7 3.13 7 7 0 .94-.19 1.84-.52 2.65l1.5 1.5c.5-.96.84-2.02.97-3.15H23v-2h-2.06zM3 4.27l2.04 2.04C3.97 7.62 3.25 9.23 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c1.77-.2 3.38-.91 4.69-1.98L19.73 21 21 19.73 4.27 3 3 4.27zm13.27 13.27C15.09 18.45 13.61 19 12 19c-3.87 0-7-3.13-7-7 0-1.61.55-3.09 1.46-4.27l9.81 9.81z"
})), 'GpsOff');

exports.default = _default;

/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
})), 'Grade');

exports.default = _default;

/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11 9h2v2h-2zm-2 2h2v2H9zm4 0h2v2h-2zm2-2h2v2h-2zM7 9h2v2H7zm12-6H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 18H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm2-7h-2v2h2v2h-2v-2h-2v2h-2v-2h-2v2H9v-2H7v2H5v-2h2v-2H5V5h14v6z"
})), 'Gradient');

exports.default = _default;

/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-4 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
})), 'Grain');

exports.default = _default;

/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 18h2V6H7v12zm4 4h2V2h-2v20zm-8-8h2v-4H3v4zm12 4h2V6h-2v12zm4-8v4h2v-4h-2z"
})), 'GraphicEq');

exports.default = _default;

/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M8 4v1.45l2 2V4h4v4h-3.45l2 2H14v1.45l2 2V10h4v4h-3.45l2 2H20v1.45l2 2V4c0-1.1-.9-2-2-2H4.55l2 2H8zm8 0h4v4h-4V4zM1.27 1.27L0 2.55l2 2V20c0 1.1.9 2 2 2h15.46l2 2 1.27-1.27L1.27 1.27zM10 12.55L11.45 14H10v-1.45zm-6-6L5.45 8H4V6.55zM8 20H4v-4h4v4zm0-6H4v-4h3.45l.55.55V14zm6 6h-4v-4h3.45l.55.54V20zm2 0v-1.46L17.46 20H16z"
})), 'GridOff');

exports.default = _default;

/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 20H4v-4h4v4zm0-6H4v-4h4v4zm0-6H4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4z"
})), 'GridOn');

exports.default = _default;

/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
})), 'Group');

exports.default = _default;

/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M8 10H5V7H3v3H0v2h3v3h2v-3h3v-2zm10 1c1.66 0 2.99-1.34 2.99-3S19.66 5 18 5c-.32 0-.63.05-.91.14.57.81.9 1.79.9 2.86s-.34 2.04-.9 2.86c.28.09.59.14.91.14zm-5 0c1.66 0 2.99-1.34 2.99-3S14.66 5 13 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm6.62 2.16c.83.73 1.38 1.66 1.38 2.84v2h3v-2c0-1.54-2.37-2.49-4.38-2.84zM13 13c-2 0-6 1-6 3v2h12v-2c0-2-4-3-6-3z"
})), 'GroupAdd');

exports.default = _default;

/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM8 17.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5zM9.5 8c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5S9.5 9.38 9.5 8zm6.5 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
})), 'GroupWork');

exports.default = _default;

/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 5h-9.12L10 2H4c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h7l1 3h8c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zM7.17 14.59c-2.25 0-4.09-1.83-4.09-4.09s1.83-4.09 4.09-4.09c1.04 0 1.99.37 2.74 1.07l.07.06-1.23 1.18-.06-.05c-.29-.27-.78-.59-1.52-.59-1.31 0-2.38 1.09-2.38 2.42s1.07 2.42 2.38 2.42c1.37 0 1.96-.87 2.12-1.46H7.08V9.91h3.95l.01.07c.04.21.05.4.05.61 0 2.35-1.61 4-3.92 4zm6.03-1.71c.33.6.74 1.18 1.19 1.7l-.54.53-.65-2.23zm.77-.76h-.99l-.31-1.04h3.99s-.34 1.31-1.56 2.74c-.52-.62-.89-1.23-1.13-1.7zM21 20c0 .55-.45 1-1 1h-7l2-2-.81-2.77.92-.92L17.79 18l.73-.73-2.71-2.68c.9-1.03 1.6-2.25 1.92-3.51H19v-1.04h-3.64V9h-1.04v1.04h-1.96L11.18 6H20c.55 0 1 .45 1 1v13z"
})), 'GTranslate');

exports.default = _default;

/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8 12H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6zm2-6h4c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1h-4V9zm1.5 4.5h2v-3h-2v3z"
})), 'Hd');

exports.default = _default;

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17.5 15v-2h1.1l.9 2H21l-.9-2.1c.5-.2.9-.8.9-1.4v-1c0-.8-.7-1.5-1.5-1.5H16v4.9l1.1 1.1h.4zm0-4.5h2v1h-2v-1zm-4.5 0v.4l1.5 1.5v-1.9c0-.8-.7-1.5-1.5-1.5h-1.9l1.5 1.5h.4zm-3.5-1l-7-7-1.1 1L6.9 9h-.4v2h-2V9H3v6h1.5v-2.5h2V15H8v-4.9l1.5 1.5V15h3.4l7.6 7.6 1.1-1.1-12.1-12z"
})), 'HdrOff');

exports.default = _default;

/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 11.5v-1c0-.8-.7-1.5-1.5-1.5H16v6h1.5v-2h1.1l.9 2H21l-.9-2.1c.5-.3.9-.8.9-1.4zm-1.5 0h-2v-1h2v1zm-13-.5h-2V9H3v6h1.5v-2.5h2V15H8V9H6.5v2zM13 9H9.5v6H13c.8 0 1.5-.7 1.5-1.5v-3c0-.8-.7-1.5-1.5-1.5zm0 4.5h-2v-3h2v3z"
})), 'HdrOn');

exports.default = _default;

/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zM5 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
})), 'HdrStrong');

exports.default = _default;

/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M5 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm12-2c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
})), 'HdrWeak');

exports.default = _default;

/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 1c-4.97 0-9 4.03-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h3c1.66 0 3-1.34 3-3v-7c0-4.97-4.03-9-9-9z"
})), 'Headset');

exports.default = _default;

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 1c-4.97 0-9 4.03-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h4v1h-7v2h6c1.66 0 3-1.34 3-3V10c0-4.97-4.03-9-9-9z"
})), 'HeadsetMic');

exports.default = _default;

/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17.73 12.02l3.98-3.98c.39-.39.39-1.02 0-1.41l-4.34-4.34c-.39-.39-1.02-.39-1.41 0l-3.98 3.98L8 2.29C7.8 2.1 7.55 2 7.29 2c-.25 0-.51.1-.7.29L2.25 6.63c-.39.39-.39 1.02 0 1.41l3.98 3.98L2.25 16c-.39.39-.39 1.02 0 1.41l4.34 4.34c.39.39 1.02.39 1.41 0l3.98-3.98 3.98 3.98c.2.2.45.29.71.29.26 0 .51-.1.71-.29l4.34-4.34c.39-.39.39-1.02 0-1.41l-3.99-3.98zM12 9c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-4.71 1.96L3.66 7.34l3.63-3.63 3.62 3.62-3.62 3.63zM10 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2 2c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2.66 9.34l-3.63-3.62 3.63-3.63 3.62 3.62-3.62 3.63z"
})), 'Healing');

exports.default = _default;

/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 20c-.29 0-.56-.06-.76-.15-.71-.37-1.21-.88-1.71-2.38-.51-1.56-1.47-2.29-2.39-3-.79-.61-1.61-1.24-2.32-2.53C9.29 10.98 9 9.93 9 9c0-2.8 2.2-5 5-5s5 2.2 5 5h2c0-3.93-3.07-7-7-7S7 5.07 7 9c0 1.26.38 2.65 1.07 3.9.91 1.65 1.98 2.48 2.85 3.15.81.62 1.39 1.07 1.71 2.05.6 1.82 1.37 2.84 2.73 3.55.51.23 1.07.35 1.64.35 2.21 0 4-1.79 4-4h-2c0 1.1-.9 2-2 2zM7.64 2.64L6.22 1.22C4.23 3.21 3 5.96 3 9s1.23 5.79 3.22 7.78l1.41-1.41C6.01 13.74 5 11.49 5 9s1.01-4.74 2.64-6.36zM11.5 9c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5-1.12-2.5-2.5-2.5-2.5 1.12-2.5 2.5z"
})), 'Hearing');

exports.default = _default;

/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"
})), 'HelpOutline');

exports.default = _default;

/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6 14l3 3v5h6v-5l3-3V9H6zm5-12h2v3h-2zM3.5 5.875L4.914 4.46l2.12 2.122L5.62 7.997zm13.46.71l2.123-2.12 1.414 1.414L18.375 8z"
})), 'Highlight');

exports.default = _default;

/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
})), 'HighlightOff');

exports.default = _default;

/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 11H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6zm7-1c0 .55-.45 1-1 1h-.75v1.5h-1.5V15H14c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v4zm-3.5-.5h2v-3h-2v3z"
})), 'HighQuality');

exports.default = _default;

/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"
})), 'History');

exports.default = _default;

/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"
})), 'Home');

exports.default = _default;

/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z"
})), 'Hotel');

exports.default = _default;

/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("circle", {
  cx: "7",
  cy: "6",
  r: "2"
}), _react.default.createElement("path", {
  d: "M11.15 12c-.31-.22-.59-.46-.82-.72l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.29-.14-.62-.23-.96-.23h-.03C6.01 9 5 10.01 5 11.25V12H2v8c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-8H11.15zM7 20H5v-6h2v6zm4 0H9v-6h2v6zm4 0h-2v-6h2v6zm4 0h-2v-6h2v6zm-.35-14.14l-.07-.07c-.57-.62-.82-1.41-.67-2.2L18 3h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71zm-4 0l-.07-.07c-.57-.62-.82-1.41-.67-2.2L14 3h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71z"
})), 'HotTub');

exports.default = _default;

/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6zm10 14.5V20H8v-3.5l4-4 4 4zm-4-5l-4-4V4h8v3.5l-4 4z"
})), 'HourglassEmpty');

exports.default = _default;

/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6z"
})), 'HourglassFull');

exports.default = _default;

/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4.5 11h-2V9H1v6h1.5v-2.5h2V15H6V9H4.5v2zm2.5-.5h1.5V15H10v-4.5h1.5V9H7v1.5zm5.5 0H14V15h1.5v-4.5H17V9h-4.5v1.5zm9-1.5H18v6h1.5v-2h2c.8 0 1.5-.7 1.5-1.5v-1c0-.8-.7-1.5-1.5-1.5zm0 2.5h-2v-1h2v1z"
})), 'Http');

exports.default = _default;

/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
})), 'Https');

exports.default = _default;

/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
})), 'Image');

exports.default = _default;

/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16 10h-2v2h2v-2zm0 4h-2v2h2v-2zm-8-4H6v2h2v-2zm4 0h-2v2h2v-2zm8-6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z"
})), 'ImageAspectRatio');

exports.default = _default;

/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M23 11.01L18 11c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-9c0-.55-.45-.99-1-.99zM23 20h-5v-7h5v7zM20 2H2C.89 2 0 2.89 0 4v12c0 1.1.89 2 2 2h7v2H7v2h8v-2h-2v-2h2v-2H2V4h18v5h2V4c0-1.11-.9-2-2-2zm-8.03 7L11 6l-.97 3H7l2.47 1.76-.94 2.91 2.47-1.8 2.47 1.8-.94-2.91L15 9h-3.03z"
})), 'ImportantDevices');

exports.default = _default;

/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z"
})), 'ImportContacts');

exports.default = _default;

/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9 3L5 6.99h3V14h2V6.99h3L9 3zm7 14.01V10h-2v7.01h-3L15 21l4-3.99h-3z"
})), 'ImportExport');

exports.default = _default;

/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3H4.99c-1.11 0-1.98.89-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.11-.9-2-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10z"
})), 'Inbox');

exports.default = _default;

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
})), 'IndeterminateCheckBox');

exports.default = _default;

/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
})), 'Info');

exports.default = _default;

/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z"
})), 'InfoOutline');

exports.default = _default;

/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 3.01H3c-1.1 0-2 .9-2 2V9h2V4.99h18v14.03H3V15H1v4.01c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98v-14c0-1.11-.9-2-2-2zM11 16l4-4-4-4v3H1v2h10v3z"
})), 'Input');

exports.default = _default;

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"
})), 'InsertChart');

exports.default = _default;

/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"
})), 'InsertComment');

exports.default = _default;

/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6H6zm7 7V3.5L18.5 9H13z"
})), 'InsertDriveFile');

exports.default = _default;

/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
})), 'InsertEmoticon');

exports.default = _default;

/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
})), 'InsertInvitation');

exports.default = _default;

/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"
})), 'InsertLink');

exports.default = _default;

/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
})), 'InsertPhoto');

exports.default = _default;

/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17.66 7.93L12 2.27 6.34 7.93c-3.12 3.12-3.12 8.19 0 11.31C7.9 20.8 9.95 21.58 12 21.58c2.05 0 4.1-.78 5.66-2.34 3.12-3.12 3.12-8.19 0-11.31zM12 19.59c-1.6 0-3.11-.62-4.24-1.76C6.62 16.69 6 15.19 6 13.59s.62-3.11 1.76-4.24L12 5.1v14.49z"
})), 'InvertColors');

exports.default = _default;

/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20.65 20.87l-2.35-2.35-6.3-6.29-3.56-3.57-1.42-1.41L4.27 4.5 3 5.77l2.78 2.78c-2.55 3.14-2.36 7.76.56 10.69C7.9 20.8 9.95 21.58 12 21.58c1.79 0 3.57-.59 5.03-1.78l2.7 2.7L21 21.23l-.35-.36zM12 19.59c-1.6 0-3.11-.62-4.24-1.76C6.62 16.69 6 15.19 6 13.59c0-1.32.43-2.57 1.21-3.6L12 14.77v4.82zM12 5.1v4.58l7.25 7.26c1.37-2.96.84-6.57-1.6-9.01L12 2.27l-3.7 3.7 1.41 1.41L12 5.1z"
})), 'InvertColorsOff');

exports.default = _default;

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5.5 7.5h2v-2H9v2h2V9H9v2H7.5V9h-2V7.5zM19 19H5L19 5v14zm-2-2v-1.5h-5V17h5z"
})), 'Iso');

exports.default = _default;

/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 5H4c-1.1 0-1.99.9-1.99 2L2 17c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-9 3h2v2h-2V8zm0 3h2v2h-2v-2zM8 8h2v2H8V8zm0 3h2v2H8v-2zm-1 2H5v-2h2v2zm0-3H5V8h2v2zm9 7H8v-2h8v2zm0-4h-2v-2h2v2zm0-3h-2V8h2v2zm3 3h-2v-2h2v2zm0-3h-2V8h2v2z"
})), 'Keyboard');

exports.default = _default;

/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"
})), 'KeyboardArrowDown');

exports.default = _default;

/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
})), 'KeyboardArrowLeft');

exports.default = _default;

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"
})), 'KeyboardArrowUp');

exports.default = _default;

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21z"
})), 'KeyboardBackspace');

exports.default = _default;

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 8.41L16.59 13 18 11.59l-6-6-6 6L7.41 13 12 8.41zM6 18h12v-2H6v2z"
})), 'KeyboardCapslock');

exports.default = _default;

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 3H4c-1.1 0-1.99.9-1.99 2L2 15c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 3h2v2h-2V6zm0 3h2v2h-2V9zM8 6h2v2H8V6zm0 3h2v2H8V9zm-1 2H5V9h2v2zm0-3H5V6h2v2zm9 7H8v-2h8v2zm0-4h-2V9h2v2zm0-3h-2V6h2v2zm3 3h-2V9h2v2zm0-3h-2V6h2v2zm-7 15l4-4H8l4 4z"
})), 'KeyboardHide');

exports.default = _default;

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 7v4H5.83l3.58-3.59L8 6l-6 6 6 6 1.41-1.41L5.83 13H21V7z"
})), 'KeyboardReturn');

exports.default = _default;

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11.59 7.41L15.17 11H1v2h14.17l-3.59 3.59L13 18l6-6-6-6-1.41 1.41zM20 6v12h2V6h-2z"
})), 'KeyboardTab');

exports.default = _default;

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 15c1.66 0 2.99-1.34 2.99-3L15 6c0-1.66-1.34-3-3-3S9 4.34 9 6v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 15 6.7 12H5c0 3.42 2.72 6.23 6 6.72V22h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"
})), 'KeyboardVoice');

exports.default = _default;

/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 2.01L6 2c-1.1 0-2 .89-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.11-.9-1.99-2-1.99zM18 20H6v-9.02h12V20zm0-11H6V4h12v5zM8 5h2v3H8zm0 7h2v5H8z"
})), 'Kitchen');

exports.default = _default;

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16z"
})), 'Label');

exports.default = _default;

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16zM16 17H5V7h11l3.55 5L16 17z"
})), 'LabelOutline');

exports.default = _default;

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z"
})), 'Landscape');

exports.default = _default;

/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z"
})), 'Language');

exports.default = _default;

/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z"
})), 'Laptop');

exports.default = _default;

/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 18V3H2v15H0v2h24v-2h-2zm-8 0h-4v-1h4v1zm6-3H4V5h16v10z"
})), 'LaptopChromebook');

exports.default = _default;

/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 18c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2H0c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2h-4zM4 5h16v11H4V5zm8 14c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
})), 'LaptopMac');

exports.default = _default;

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 18v-1c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2v1H0v2h24v-2h-4zM4 5h16v10H4V5z"
})), 'LaptopWindows');

exports.default = _default;

/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
})), 'LastPage');

exports.default = _default;

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
})), 'Launch');

exports.default = _default;

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11.99 18.54l-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27-7.38 5.74zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16z"
})), 'Layers');

exports.default = _default;

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.81 14.99l1.19-.92-1.43-1.43-1.19.92 1.43 1.43zm-.45-4.72L21 9l-9-7-2.91 2.27 7.87 7.88 2.4-1.88zM3.27 1L2 2.27l4.22 4.22L3 9l1.63 1.27L12 16l2.1-1.63 1.43 1.43L12 18.54l-7.37-5.73L3 14.07l9 7 4.95-3.85L20.73 21 22 19.73 3.27 1z"
})), 'LayersClear');

exports.default = _default;

/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6 3H3v3c1.66 0 3-1.34 3-3zm8 0h-2c0 4.97-4.03 9-9 9v2c6.08 0 11-4.93 11-11zm-4 0H8c0 2.76-2.24 5-5 5v2c3.87 0 7-3.13 7-7zm0 18h2c0-4.97 4.03-9 9-9v-2c-6.07 0-11 4.93-11 11zm8 0h3v-3c-1.66 0-3 1.34-3 3zm-4 0h2c0-2.76 2.24-5 5-5v-2c-3.87 0-7 3.13-7 7z"
})), 'LeakAdd');

exports.default = _default;

/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 3H8c0 .37-.04.72-.12 1.06l1.59 1.59C9.81 4.84 10 3.94 10 3zM3 4.27l2.84 2.84C5.03 7.67 4.06 8 3 8v2c1.61 0 3.09-.55 4.27-1.46L8.7 9.97C7.14 11.24 5.16 12 3 12v2c2.71 0 5.19-.99 7.11-2.62l2.5 2.5C10.99 15.81 10 18.29 10 21h2c0-2.16.76-4.14 2.03-5.69l1.43 1.43C14.55 17.91 14 19.39 14 21h2c0-1.06.33-2.03.89-2.84L19.73 21 21 19.73 4.27 3 3 4.27zM14 3h-2c0 1.5-.37 2.91-1.02 4.16l1.46 1.46C13.42 6.98 14 5.06 14 3zm5.94 13.12c.34-.08.69-.12 1.06-.12v-2c-.94 0-1.84.19-2.66.52l1.6 1.6zm-4.56-4.56l1.46 1.46C18.09 12.37 19.5 12 21 12v-2c-2.06 0-3.98.58-5.62 1.56z"
})), 'LeakRemove');

exports.default = _default;

/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"
})), 'Lens');

exports.default = _default;

/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z"
})), 'LibraryAdd');

exports.default = _default;

/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9H9V9h10v2zm-4 4H9v-2h6v2zm4-8H9V5h10v2z"
})), 'LibraryBooks');

exports.default = _default;

/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 5h-3v5.5c0 1.38-1.12 2.5-2.5 2.5S10 13.88 10 12.5s1.12-2.5 2.5-2.5c.57 0 1.08.19 1.5.51V5h4v2zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z"
})), 'LibraryMusic');

exports.default = _default;

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1zm3-19C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7zm2.85 11.1l-.85.6V16h-4v-2.3l-.85-.6C7.8 12.16 7 10.63 7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.63-.8 3.16-2.15 4.1z"
})), 'LightbulbOutline');

exports.default = _default;

/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.5 9.5c-1.03 0-1.9.62-2.29 1.5h-2.92c-.39-.88-1.26-1.5-2.29-1.5s-1.9.62-2.29 1.5H6.79c-.39-.88-1.26-1.5-2.29-1.5C3.12 9.5 2 10.62 2 12s1.12 2.5 2.5 2.5c1.03 0 1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5s1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5 1.38 0 2.5-1.12 2.5-2.5s-1.12-2.5-2.5-2.5z"
})), 'LinearScale');

exports.default = _default;

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 16h5v-2H3v2zm6.5 0h5v-2h-5v2zm6.5 0h5v-2h-5v2zM3 20h2v-2H3v2zm4 0h2v-2H7v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zM3 12h8v-2H3v2zm10 0h8v-2h-8v2zM3 4v4h18V4H3z"
})), 'LineStyle');

exports.default = _default;

/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 17h18v-2H3v2zm0 3h18v-1H3v1zm0-7h18v-3H3v3zm0-9v4h18V4H3z"
})), 'LineWeight');

exports.default = _default;

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"
})), 'Link');

exports.default = _default;

/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("circle", {
  cx: "12",
  cy: "14",
  r: "3.2"
}), _react.default.createElement("path", {
  d: "M16 3.33c2.58 0 4.67 2.09 4.67 4.67H22c0-3.31-2.69-6-6-6v1.33M16 6c1.11 0 2 .89 2 2h1.33c0-1.84-1.49-3.33-3.33-3.33V6"
}), _react.default.createElement("path", {
  d: "M17 9c0-1.11-.89-2-2-2V4H9L7.17 6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9h-5zm-5 10c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
})), 'LinkedCamera');

exports.default = _default;

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"
})), 'List');

exports.default = _default;

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 16h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 11.9 13 12.5 13 14h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
})), 'LiveHelp');

exports.default = _default;

/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 6h-7.59l3.29-3.29L16 2l-4 4-4-4-.71.71L10.59 6H3c-1.1 0-2 .89-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.11-.9-2-2-2zm0 14H3V8h18v12zM9 10v8l7-4z"
})), 'LiveTv');

exports.default = _default;

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 12c0-1.1.9-2 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2zm-4.42 4.8L12 14.5l-3.58 2.3 1.08-4.12-3.29-2.69 4.24-.25L12 5.8l1.54 3.95 4.24.25-3.29 2.69 1.09 4.11z"
})), 'LocalActivity');

exports.default = _default;

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"
})), 'LocalAirport');

exports.default = _default;

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11 17h2v-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1h-3v-1h4V8h-2V7h-2v1h-1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3v1H9v2h2v1zm9-13H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4V6h16v12z"
})), 'LocalAtm');

exports.default = _default;

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 5V3H3v2l8 9v5H6v2h12v-2h-5v-5l8-9zM7.43 7L5.66 5h12.69l-1.78 2H7.43z"
})), 'LocalBar');

exports.default = _default;

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2zm0 5h-2V5h2v3zM2 21h18v-2H2v2z"
})), 'LocalCafe');

exports.default = _default;

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 5c.83 0 1.5-.67 1.5-1.5 0-1-1.5-2.7-1.5-2.7s-1.5 1.7-1.5 2.7c0 .83.67 1.5 1.5 1.5zm-5 0c.83 0 1.5-.67 1.5-1.5 0-1-1.5-2.7-1.5-2.7s-1.5 1.7-1.5 2.7c0 .83.67 1.5 1.5 1.5zM7 5c.83 0 1.5-.67 1.5-1.5C8.5 2.5 7 .8 7 .8S5.5 2.5 5.5 3.5C5.5 4.33 6.17 5 7 5zm11.92 3.01C18.72 7.42 18.16 7 17.5 7h-11c-.66 0-1.21.42-1.42 1.01L3 14v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 18c-.83 0-1.5-.67-1.5-1.5S5.67 15 6.5 15s1.5.67 1.5 1.5S7.33 18 6.5 18zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 13l1.5-4.5h11L19 13H5z"
})), 'LocalCarWash');

exports.default = _default;

/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 7V4H5v3H2v13h8v-4h4v4h8V7h-3zm-8 3H9v1h2v1H8V9h2V8H8V7h3v3zm5 2h-1v-2h-2V7h1v2h1V7h1v5z"
})), 'LocalConvenienceStore');

exports.default = _default;

/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M8.1 13.34l2.83-2.83L3.91 3.5c-1.56 1.56-1.56 4.09 0 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z"
})), 'LocalDining');

exports.default = _default;

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 2l2.01 18.23C5.13 21.23 5.97 22 7 22h10c1.03 0 1.87-.77 1.99-1.77L21 2H3zm9 17c-1.66 0-3-1.34-3-3 0-2 3-5.4 3-5.4s3 3.4 3 5.4c0 1.66-1.34 3-3 3zm6.33-11H5.67l-.44-4h13.53l-.43 4z"
})), 'LocalDrink');

exports.default = _default;

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 22c4.97 0 9-4.03 9-9-4.97 0-9 4.03-9 9zM5.6 10.25c0 1.38 1.12 2.5 2.5 2.5.53 0 1.01-.16 1.42-.44l-.02.19c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5l-.02-.19c.4.28.89.44 1.42.44 1.38 0 2.5-1.12 2.5-2.5 0-1-.59-1.85-1.43-2.25.84-.4 1.43-1.25 1.43-2.25 0-1.38-1.12-2.5-2.5-2.5-.53 0-1.01.16-1.42.44l.02-.19C14.5 2.12 13.38 1 12 1S9.5 2.12 9.5 3.5l.02.19c-.4-.28-.89-.44-1.42-.44-1.38 0-2.5 1.12-2.5 2.5 0 1 .59 1.85 1.43 2.25-.84.4-1.43 1.25-1.43 2.25zM12 5.5c1.38 0 2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5S9.5 9.38 9.5 8s1.12-2.5 2.5-2.5zM3 13c0 4.97 4.03 9 9 9 0-4.97-4.03-9-9-9z"
})), 'LocalFlorist');

exports.default = _default;

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33 0 1.38 1.12 2.5 2.5 2.5.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V9c0-.69-.28-1.32-.73-1.77zM12 10H6V5h6v5zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
})), 'LocalGasStation');

exports.default = _default;

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"
})), 'LocalGroceryStore');

exports.default = _default;

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3H5c-1.1 0-1.99.9-1.99 2L3 19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 11h-4v4h-4v-4H6v-4h4V6h4v4h4v4z"
})), 'LocalHospital');

exports.default = _default;

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z"
})), 'LocalHotel');

exports.default = _default;

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9.17 16.83c1.56 1.56 4.1 1.56 5.66 0 1.56-1.56 1.56-4.1 0-5.66l-5.66 5.66zM18 2.01L6 2c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V4c0-1.11-.89-1.99-2-1.99zM10 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM7 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm5 16c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
})), 'LocalLaundryService');

exports.default = _default;

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 11.55C9.64 9.35 6.48 8 3 8v11c3.48 0 6.64 1.35 9 3.55 2.36-2.19 5.52-3.55 9-3.55V8c-3.48 0-6.64 1.35-9 3.55zM12 8c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3z"
})), 'LocalLibrary');

exports.default = _default;

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 6h-2c0-2.76-2.24-5-5-5S7 3.24 7 6H5c-1.1 0-1.99.9-1.99 2L3 20c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-7-3c1.66 0 3 1.34 3 3H9c0-1.66 1.34-3 3-3zm0 10c-2.76 0-5-2.24-5-5h2c0 1.66 1.34 3 3 3s3-1.34 3-3h2c0 2.76-2.24 5-5 5z"
})), 'LocalMall');

exports.default = _default;

/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm10 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z"
})), 'LocalMovies');

exports.default = _default;

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z"
})), 'LocalOffer');

exports.default = _default;

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13 3H6v18h4v-6h3c3.31 0 6-2.69 6-6s-2.69-6-6-6zm.2 8H10V7h3.2c1.1 0 2 .9 2 2s-.9 2-2 2z"
})), 'LocalParking');

exports.default = _default;

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 5h-2.64l1.14-3.14L17.15 1l-1.46 4H3v2l2 6-2 6v2h18v-2l-2-6 2-6V5zm-5 9h-3v3h-2v-3H8v-2h3V9h2v3h3v2z"
})), 'LocalPharmacy');

exports.default = _default;

/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
})), 'LocalPhone');

exports.default = _default;

/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C8.43 2 5.23 3.54 3.01 6L12 22l8.99-16C18.78 3.55 15.57 2 12 2zM7 7c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm5 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
})), 'LocalPizza');

exports.default = _default;

/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 12c0-1.1.9-2 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2zm-4.42 4.8L12 14.5l-3.58 2.3 1.08-4.12-3.29-2.69 4.24-.25L12 5.8l1.54 3.95 4.24.25-3.29 2.69 1.09 4.11z"
})), 'LocalPlay');

exports.default = _default;

/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
})), 'LocalPostOffice');

exports.default = _default;

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z"
})), 'LocalPrintshop');

exports.default = _default;

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "3.2"
}), _react.default.createElement("path", {
  d: "M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
})), 'LocalSee');

exports.default = _default;

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
})), 'LocalShipping');

exports.default = _default;

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18.92 6.01C18.72 5.42 18.16 5 17.5 5H15V3H9v2H6.5c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"
})), 'LocalTaxi');

exports.default = _default;

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06c-1.13.12-2.19.46-3.16.97l1.5 1.5C10.16 5.19 11.06 5 12 5c3.87 0 7 3.13 7 7 0 .94-.19 1.84-.52 2.65l1.5 1.5c.5-.96.84-2.02.97-3.15H23v-2h-2.06zM3 4.27l2.04 2.04C3.97 7.62 3.25 9.23 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c1.77-.2 3.38-.91 4.69-1.98L19.73 21 21 19.73 4.27 3 3 4.27zm13.27 13.27C15.09 18.45 13.61 19 12 19c-3.87 0-7-3.13-7-7 0-1.61.55-3.09 1.46-4.27l9.81 9.81z"
})), 'LocationDisabled');

exports.default = _default;

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 6.5c1.38 0 2.5 1.12 2.5 2.5 0 .74-.33 1.39-.83 1.85l3.63 3.63c.98-1.86 1.7-3.8 1.7-5.48 0-3.87-3.13-7-7-7-1.98 0-3.76.83-5.04 2.15l3.19 3.19c.46-.52 1.11-.84 1.85-.84zm4.37 9.6l-4.63-4.63-.11-.11L3.27 3 2 4.27l3.18 3.18C5.07 7.95 5 8.47 5 9c0 5.25 7 13 7 13s1.67-1.85 3.38-4.35L18.73 21 20 19.73l-3.63-3.63z"
})), 'LocationOff');

exports.default = _default;

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
})), 'LocationSearching');

exports.default = _default;

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
})), 'Lock');

exports.default = _default;

/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h1.9c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 12H6V10h12v10z"
})), 'LockOpen');

exports.default = _default;

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H8.9V6zM18 20H6V10h12v10z"
})), 'LockOutline');

exports.default = _default;

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 10c-3.86 0-7 3.14-7 7h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.86-3.14-7-7-7zm0-4C5.93 6 1 10.93 1 17h2c0-4.96 4.04-9 9-9s9 4.04 9 9h2c0-6.07-4.93-11-11-11z"
})), 'Looks');

exports.default = _default;

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.01 3h-14c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 7.5c0 .83-.67 1.5-1.5 1.5.83 0 1.5.67 1.5 1.5V15c0 1.11-.9 2-2 2h-4v-2h4v-2h-2v-2h2V9h-4V7h4c1.1 0 2 .89 2 2v1.5z"
})), 'Looks3');

exports.default = _default;

/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 14h-2v-4H9V7h2v4h2V7h2v10z"
})), 'Looks4');

exports.default = _default;

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 6h-4v2h2c1.1 0 2 .89 2 2v2c0 1.11-.9 2-2 2H9v-2h4v-2H9V7h6v2z"
})), 'Looks5');

exports.default = _default;

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11 15h2v-2h-2v2zm8-12H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 6h-4v2h2c1.1 0 2 .89 2 2v2c0 1.11-.9 2-2 2h-2c-1.1 0-2-.89-2-2V9c0-1.11.9-2 2-2h4v2z"
})), 'Looks6');

exports.default = _default;

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14h-2V9h-2V7h4v10z"
})), 'LooksOne');

exports.default = _default;

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 8c0 1.11-.9 2-2 2h-2v2h4v2H9v-4c0-1.11.9-2 2-2h2V9H9V7h4c1.1 0 2 .89 2 2v2z"
})), 'LooksTwo');

exports.default = _default;

/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
})), 'Loop');

exports.default = _default;

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.49 2 2 6.49 2 12s4.49 10 10 10h8c1.1 0 2-.9 2-2v-8c0-5.51-4.49-10-10-10zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
})), 'Loupe');

exports.default = _default;

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M14 5h8v2h-8zm0 5.5h8v2h-8zm0 5.5h8v2h-8zM2 11.5C2 15.08 4.92 18 8.5 18H9v2l3-3-3-3v2h-.5C6.02 16 4 13.98 4 11.5S6.02 7 8.5 7H12V5H8.5C4.92 5 2 7.92 2 11.5z"
})), 'LowPriority');

exports.default = _default;

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7zm11.77 8.27L13 19.54l-4.27-4.27C8.28 14.81 8 14.19 8 13.5c0-1.38 1.12-2.5 2.5-2.5.69 0 1.32.28 1.77.74l.73.72.73-.73c.45-.45 1.08-.73 1.77-.73 1.38 0 2.5 1.12 2.5 2.5 0 .69-.28 1.32-.73 1.77z"
})), 'Loyalty');

exports.default = _default;

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"
})), 'MailOutline');

exports.default = _default;

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20.5 3l-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5zM15 19l-6-2.11V5l6 2.11V19z"
})), 'Map');

exports.default = _default;

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
})), 'Markunread');

exports.default = _default;

/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 6H10v6H8V4h6V0H6v6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2z"
})), 'MarkunreadMailbox');

exports.default = _default;

/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15 9H9v6h6V9zm-2 4h-2v-2h2v2zm8-2V9h-2V7c0-1.1-.9-2-2-2h-2V3h-2v2h-2V3H9v2H7c-1.1 0-2 .9-2 2v2H3v2h2v2H3v2h2v2c0 1.1.9 2 2 2h2v2h2v-2h2v2h2v-2h2c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2zm-4 6H7V7h10v10z"
})), 'Memory');

exports.default = _default;

/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z"
})), 'MergeType');

exports.default = _default;

/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"
})), 'Message');

exports.default = _default;

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"
})), 'Mic');

exports.default = _default;

/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm-1.2-9.1c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2l-.01 6.2c0 .66-.53 1.2-1.19 1.2-.66 0-1.2-.54-1.2-1.2V4.9zm6.5 6.1c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"
})), 'MicNone');

exports.default = _default;

/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 11h-1.7c0 .74-.16 1.43-.43 2.05l1.23 1.23c.56-.98.9-2.09.9-3.28zm-4.02.17c0-.06.02-.11.02-.17V5c0-1.66-1.34-3-3-3S9 3.34 9 5v.18l5.98 5.99zM4.27 3L3 4.27l6.01 6.01V11c0 1.66 1.33 3 2.99 3 .22 0 .44-.03.65-.08l1.66 1.66c-.71.33-1.5.52-2.31.52-2.76 0-5.3-2.1-5.3-5.1H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c.91-.13 1.77-.45 2.54-.9L19.73 21 21 19.73 4.27 3z"
})), 'MicOff');

exports.default = _default;

/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM5 14l3.5-4.5 2.5 3.01L14.5 8l4.5 6H5z"
})), 'Mms');

exports.default = _default;

/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18z"
})), 'ModeComment');

exports.default = _default;

/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
})), 'ModeEdit');

exports.default = _default;

/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16z"
})), 'MonetizationOn');

exports.default = _default;

/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12.5 6.9c1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-.53.12-1.03.3-1.48.54l1.47 1.47c.41-.17.91-.27 1.51-.27zM5.33 4.06L4.06 5.33 7.5 8.77c0 2.08 1.56 3.21 3.91 3.91l3.51 3.51c-.34.48-1.05.91-2.42.91-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c.96-.18 1.82-.55 2.45-1.12l2.22 2.22 1.27-1.27L5.33 4.06z"
})), 'MoneyOff');

exports.default = _default;

/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 5h-3.2L15 3H9L7.2 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 14h-8v-1c-2.8 0-5-2.2-5-5s2.2-5 5-5V7h8v12zm-3-6c0-2.8-2.2-5-5-5v1.8c1.8 0 3.2 1.4 3.2 3.2s-1.4 3.2-3.2 3.2V18c2.8 0 5-2.2 5-5zm-8.2 0c0 1.8 1.4 3.2 3.2 3.2V9.8c-1.8 0-3.2 1.4-3.2 3.2z"
})), 'MonochromePhotos');

exports.default = _default;

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
})), 'Mood');

exports.default = _default;

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 3c-2.33 0-4.31 1.46-5.11 3.5h10.22c-.8-2.04-2.78-3.5-5.11-3.5z"
})), 'MoodBad');

exports.default = _default;

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.97.89 1.66.89H22c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 13.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
})), 'More');

exports.default = _default;

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
})), 'MoreHoriz');

exports.default = _default;

/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.44 9.03L15.41 5H11v2h3.59l2 2H5c-2.8 0-5 2.2-5 5s2.2 5 5 5c2.46 0 4.45-1.69 4.9-4h1.65l2.77-2.77c-.21.54-.32 1.14-.32 1.77 0 2.8 2.2 5 5 5s5-2.2 5-5c0-2.65-1.97-4.77-4.56-4.97zM7.82 15C7.4 16.15 6.28 17 5 17c-1.63 0-3-1.37-3-3s1.37-3 3-3c1.28 0 2.4.85 2.82 2H5v2h2.82zM19 17c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
})), 'Motorcycle');

exports.default = _default;

/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13 1.07V9h7c0-4.08-3.05-7.44-7-7.93zM4 15c0 4.42 3.58 8 8 8s8-3.58 8-8v-4H4v4zm7-13.93C7.05 1.56 4 4.92 4 9h7V1.07z"
})), 'Mouse');

exports.default = _default;

/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3H4.99c-1.11 0-1.98.9-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10zm-3-5h-2V7h-4v3H8l4 4 4-4z"
})), 'MoveToInbox');

exports.default = _default;

/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z"
})), 'Movie');

exports.default = _default;

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z"
})), 'MovieCreation');

exports.default = _default;

/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 4l2 3h-3l-2-3h-2l2 3h-3l-2-3H8l2 3H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4zm-6.75 11.25L10 18l-1.25-2.75L6 14l2.75-1.25L10 10l1.25 2.75L14 14l-2.75 1.25zm5.69-3.31L16 14l-.94-2.06L13 11l2.06-.94L16 8l.94 2.06L19 11l-2.06.94z"
})), 'MovieFilter');

exports.default = _default;

/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z"
})), 'MusicNote');

exports.default = _default;

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM8 15c0-1.66 1.34-3 3-3 .35 0 .69.07 1 .18V6h5v2h-3v7.03c-.02 1.64-1.35 2.97-3 2.97-1.66 0-3-1.34-3-3z"
})), 'MusicVideo');

exports.default = _default;

/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
})), 'MyLocation');

exports.default = _default;

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13 16.12c3.47-.41 6.17-3.36 6.17-6.95 0-3.87-3.13-7-7-7s-7 3.13-7 7c0 3.47 2.52 6.34 5.83 6.89V20H5v2h14v-2h-6v-3.88z"
})), 'Nature');

exports.default = _default;

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22.17 9.17c0-3.87-3.13-7-7-7s-7 3.13-7 7c0 3.47 2.52 6.34 5.83 6.89V20H6v-3h1v-4c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v4h1v5h16v-2h-3v-3.88c3.47-.41 6.17-3.36 6.17-6.95zM4.5 11c.83 0 1.5-.67 1.5-1.5S5.33 8 4.5 8 3 8.67 3 9.5 3.67 11 4.5 11z"
})), 'NaturePeople');

exports.default = _default;

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
})), 'NavigateBefore');

exports.default = _default;

/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
})), 'NavigateNext');

exports.default = _default;

/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2L4.5 20.29l.71.71L12 18l6.79 3 .71-.71z"
})), 'Navigation');

exports.default = _default;

/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 3L3 10.53v.98l6.84 2.65L12.48 21h.98L21 3z"
})), 'NearMe');

exports.default = _default;

/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M2 22h20V2z"
}), _react.default.createElement("path", {
  d: "M17 7L2 22h15z"
})), 'NetworkCell');

exports.default = _default;

/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15.9 5c-.17 0-.32.09-.41.23l-.07.15-5.18 11.65c-.16.29-.26.61-.26.96 0 1.11.9 2.01 2.01 2.01.96 0 1.77-.68 1.96-1.59l.01-.03L16.4 5.5c0-.28-.22-.5-.5-.5zM1 9l2 2c2.88-2.88 6.79-4.08 10.53-3.62l1.19-2.68C9.89 3.84 4.74 5.27 1 9zm20 2l2-2c-1.64-1.64-3.55-2.82-5.59-3.57l-.53 2.82c1.5.62 2.9 1.53 4.12 2.75zm-4 4l2-2c-.8-.8-1.7-1.42-2.66-1.89l-.55 2.92c.42.27.83.59 1.21.97zM5 13l2 2c1.13-1.13 2.56-1.79 4.03-2l1.28-2.88c-2.63-.08-5.3.87-7.31 2.88z"
})), 'NetworkCheck');

exports.default = _default;

/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.5 10c.17 0 .33.03.5.05V1L1 20h13v-3c0-.89.39-1.68 1-2.23v-.27c0-2.48 2.02-4.5 4.5-4.5zm2.5 6v-1.5c0-1.38-1.12-2.5-2.5-2.5S17 13.12 17 14.5V16c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-1 0h-3v-1.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V16z"
})), 'NetworkLocked');

exports.default = _default;

/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"
}), _react.default.createElement("path", {
  d: "M3.53 10.95l8.46 10.54.01.01.01-.01 8.46-10.54C20.04 10.62 16.81 8 12 8c-4.81 0-8.04 2.62-8.47 2.95z"
})), 'NetworkWifi');

exports.default = _default;

/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M23 12l-2.44-2.78.34-3.68-3.61-.82-1.89-3.18L12 3 8.6 1.54 6.71 4.72l-3.61.81.34 3.68L1 12l2.44 2.78-.34 3.69 3.61.82 1.89 3.18L12 21l3.4 1.46 1.89-3.18 3.61-.82-.34-3.68L23 12zm-10 5h-2v-2h2v2zm0-4h-2V7h2v6z"
})), 'NewReleases');

exports.default = _default;

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 7h-4V5c0-.55-.22-1.05-.59-1.41C15.05 3.22 14.55 3 14 3h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zM10 5h4v2h-4V5zm1 13.5l-1-1 3-3-3-3 1-1 4 4-4 4z"
})), 'NextWeek');

exports.default = _default;

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H4V4h16v16zM18 6h-5c-1.1 0-2 .9-2 2v2.28c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V8h3v8H8V8h2V6H6v12h12V6z"
})), 'Nfc');

exports.default = _default;

/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 21.78L4.22 5 3 6.22l2.04 2.04C4.42 8.6 4 9.25 4 10v10c0 1.1.9 2 2 2h12c.23 0 .45-.05.66-.12L19.78 23 21 21.78zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H9.66L20 18.34V10c0-1.1-.9-2-2-2h-1V6c0-2.76-2.24-5-5-5-2.56 0-4.64 1.93-4.94 4.4L8.9 7.24V6z"
})), 'NoEncryption');

exports.default = _default;

/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18.99 5c0-1.1-.89-2-1.99-2h-7L7.66 5.34 19 16.68 18.99 5zM3.65 3.88L2.38 5.15 5 7.77V19c0 1.1.9 2 2 2h10.01c.35 0 .67-.1.96-.26l1.88 1.88 1.27-1.27L3.65 3.88z"
})), 'NoSim');

exports.default = _default;

/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 10l-6-6H4c-1.1 0-2 .9-2 2v12.01c0 1.1.9 1.99 2 1.99l16-.01c1.1 0 2-.89 2-1.99v-8zm-7-4.5l5.5 5.5H15V5.5z"
})), 'Note');

exports.default = _default;

/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 14h-3v3h-2v-3H8v-2h3v-3h2v3h3v2zm-3-7V3.5L18.5 9H13z"
})), 'NoteAdd');

exports.default = _default;

/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"
})), 'Notifications');

exports.default = _default;

/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7.58 4.08L6.15 2.65C3.75 4.48 2.17 7.3 2.03 10.5h2c.15-2.65 1.51-4.97 3.55-6.42zm12.39 6.42h2c-.15-3.2-1.73-6.02-4.12-7.85l-1.42 1.43c2.02 1.45 3.39 3.77 3.54 6.42zM18 11c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2v-5zm-6 11c.14 0 .27-.01.4-.04.65-.14 1.18-.58 1.44-1.18.1-.24.15-.5.15-.78h-4c.01 1.1.9 2 2.01 2z"
})), 'NotificationsActive');

exports.default = _default;

/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z"
})), 'NotificationsNone');

exports.default = _default;

/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 18.69L7.84 6.14 5.27 3.49 4 4.76l2.8 2.8v.01c-.52.99-.8 2.16-.8 3.42v5l-2 2v1h13.73l2 2L21 19.72l-1-1.03zM12 22c1.11 0 2-.89 2-2h-4c0 1.11.89 2 2 2zm6-7.32V11c0-3.08-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68c-.15.03-.29.08-.42.12-.1.03-.2.07-.3.11h-.01c-.01 0-.01 0-.02.01-.23.09-.46.2-.68.31 0 0-.01 0-.01.01L18 14.68z"
})), 'NotificationsOff');

exports.default = _default;

/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.93 6 11v5l-2 2v1h16v-1l-2-2zm-3.5-6.2l-2.8 3.4h2.8V15h-5v-1.8l2.8-3.4H9.5V8h5v1.8z"
})), 'NotificationsPaused');

exports.default = _default;

/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z"
})), 'NotInterested');

exports.default = _default;

/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm5 16H7v-2h10v2zm-6.7-4L7 10.7l1.4-1.4 1.9 1.9 5.3-5.3L17 7.3 10.3 14z"
})), 'OfflinePin');

exports.default = _default;

/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12zm-5-6l-7 4V7z"
})), 'OndemandVideo');

exports.default = _default;

/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17.66 8L12 2.35 6.34 8C4.78 9.56 4 11.64 4 13.64s.78 4.11 2.34 5.67 3.61 2.35 5.66 2.35 4.1-.79 5.66-2.35S20 15.64 20 13.64 19.22 9.56 17.66 8zM6 14c.01-2 .62-3.27 1.76-4.4L12 5.27l4.24 4.38C17.38 10.77 17.99 12 18 14H6z"
})), 'Opacity');

exports.default = _default;

/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h4v-2H5V8h14v10h-4v2h4c1.1 0 2-.9 2-2V6c0-1.1-.89-2-2-2zm-7 6l-4 4h3v6h2v-6h3l-4-4z"
})), 'OpenInBrowser');

exports.default = _default;

/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
})), 'OpenInNew');

exports.default = _default;

/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"
})), 'OpenWith');

exports.default = _default;

/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 5v6h5L7 7l4 1V3H5c-1.1 0-2 .9-2 2zm5 8H3v6c0 1.1.9 2 2 2h6v-5l-4 1 1-4zm9 4l-4-1v5h6c1.1 0 2-.9 2-2v-6h-5l1 4zm2-14h-6v5l4-1-1 4h5V5c0-1.1-.9-2-2-2z"
})), 'Pages');

exports.default = _default;

/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11.5 9C10.12 9 9 10.12 9 11.5s1.12 2.5 2.5 2.5 2.5-1.12 2.5-2.5S12.88 9 11.5 9zM20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-3.21 14.21l-2.91-2.91c-.69.44-1.51.7-2.39.7C9.01 16 7 13.99 7 11.5S9.01 7 11.5 7 16 9.01 16 11.5c0 .88-.26 1.69-.7 2.39l2.91 2.9-1.42 1.42z"
})), 'Pageview');

exports.default = _default;

/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
})), 'Palette');

exports.default = _default;

/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M23 18V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zM8.5 12.5l2.5 3.01L14.5 11l4.5 6H5l3.5-4.5z"
})), 'Panorama');

exports.default = _default;

/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
})), 'PanoramaFishEye');

exports.default = _default;

/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 6.54v10.91c-2.6-.77-5.28-1.16-8-1.16-2.72 0-5.4.39-8 1.16V6.54c2.6.77 5.28 1.16 8 1.16 2.72.01 5.4-.38 8-1.16M21.43 4c-.1 0-.2.02-.31.06C18.18 5.16 15.09 5.7 12 5.7c-3.09 0-6.18-.55-9.12-1.64-.11-.04-.22-.06-.31-.06-.34 0-.57.23-.57.63v14.75c0 .39.23.62.57.62.1 0 .2-.02.31-.06 2.94-1.1 6.03-1.64 9.12-1.64 3.09 0 6.18.55 9.12 1.64.11.04.21.06.31.06.33 0 .57-.23.57-.63V4.63c0-.4-.24-.63-.57-.63z"
})), 'PanoramaHorizontal');

exports.default = _default;

/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.94 21.12c-1.1-2.94-1.64-6.03-1.64-9.12 0-3.09.55-6.18 1.64-9.12.04-.11.06-.22.06-.31 0-.34-.23-.57-.63-.57H4.63c-.4 0-.63.23-.63.57 0 .1.02.2.06.31C5.16 5.82 5.71 8.91 5.71 12c0 3.09-.55 6.18-1.64 9.12-.05.11-.07.22-.07.31 0 .33.23.57.63.57h14.75c.39 0 .63-.24.63-.57-.01-.1-.03-.2-.07-.31zM6.54 20c.77-2.6 1.16-5.28 1.16-8 0-2.72-.39-5.4-1.16-8h10.91c-.77 2.6-1.16 5.28-1.16 8 0 2.72.39 5.4 1.16 8H6.54z"
})), 'PanoramaVertical');

exports.default = _default;

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 6c2.45 0 4.71.2 7.29.64.47 1.78.71 3.58.71 5.36 0 1.78-.24 3.58-.71 5.36-2.58.44-4.84.64-7.29.64s-4.71-.2-7.29-.64C4.24 15.58 4 13.78 4 12c0-1.78.24-3.58.71-5.36C7.29 6.2 9.55 6 12 6m0-2c-2.73 0-5.22.24-7.95.72l-.93.16-.25.9C2.29 7.85 2 9.93 2 12s.29 4.15.87 6.22l.25.89.93.16c2.73.49 5.22.73 7.95.73s5.22-.24 7.95-.72l.93-.16.25-.89c.58-2.08.87-4.16.87-6.23s-.29-4.15-.87-6.22l-.25-.89-.93-.16C17.22 4.24 14.73 4 12 4z"
})), 'PanoramaWideAngle');

exports.default = _default;

/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M23 5.5V20c0 2.2-1.8 4-4 4h-7.3c-1.08 0-2.1-.43-2.85-1.19L1 14.83s1.26-1.23 1.3-1.25c.22-.19.49-.29.79-.29.22 0 .42.06.6.16.04.01 4.31 2.46 4.31 2.46V4c0-.83.67-1.5 1.5-1.5S11 3.17 11 4v7h1V1.5c0-.83.67-1.5 1.5-1.5S15 .67 15 1.5V11h1V2.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V11h1V5.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5z"
})), 'PanTool');

exports.default = _default;

/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 3c1.63 0 3.06.79 3.98 2H12c-1.66 0-3 1.34-3 3 0 .35.07.69.18 1H7.1c-.06-.32-.1-.66-.1-1 0-2.76 2.24-5 5-5zm0 10c-1.63 0-3.06-.79-3.98-2H12c1.66 0 3-1.34 3-3 0-.35-.07-.69-.18-1h2.08c.07.32.1.66.1 1 0 2.76-2.24 5-5 5z"
})), 'PartyMode');

exports.default = _default;

/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6 19h4V5H6v14zm8-14v14h4V5h-4z"
})), 'Pause');

exports.default = _default;

/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z"
})), 'PauseCircleFilled');

exports.default = _default;

/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9 16h2V8H9v8zm3-14C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm1-4h2V8h-2v8z"
})), 'PauseCircleOutline');

exports.default = _default;

/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
})), 'Payment');

exports.default = _default;

/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
})), 'People');

exports.default = _default;

/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16.5 13c-1.2 0-3.07.34-4.5 1-1.43-.67-3.3-1-4.5-1C5.33 13 1 14.08 1 16.25V19h22v-2.75c0-2.17-4.33-3.25-6.5-3.25zm-4 4.5h-10v-1.25c0-.54 2.56-1.75 5-1.75s5 1.21 5 1.75v1.25zm9 0H14v-1.25c0-.46-.2-.86-.52-1.22.88-.3 1.96-.53 3.02-.53 2.44 0 5 1.21 5 1.75v1.25zM7.5 12c1.93 0 3.5-1.57 3.5-3.5S9.43 5 7.5 5 4 6.57 4 8.5 5.57 12 7.5 12zm0-5.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 5.5c1.93 0 3.5-1.57 3.5-3.5S18.43 5 16.5 5 13 6.57 13 8.5s1.57 3.5 3.5 3.5zm0-5.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z"
})), 'PeopleOutline');

exports.default = _default;

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 5h-3.17L15 3H9L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v-2.09c-2.83-.48-5-2.94-5-5.91h2c0 2.21 1.79 4 4 4s4-1.79 4-4h2c0 2.97-2.17 5.43-5 5.91V21h7c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-6 8c0 1.1-.9 2-2 2s-2-.9-2-2V9c0-1.1.9-2 2-2s2 .9 2 2v4z"
})), 'PermCameraMic');

exports.default = _default;

/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1z"
})), 'PermContactCalendar');

exports.default = _default;

/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18.99 11.5c.34 0 .67.03 1 .07L20 0 0 20h11.56c-.04-.33-.07-.66-.07-1 0-4.14 3.36-7.5 7.5-7.5zm3.71 7.99c.02-.16.04-.32.04-.49 0-.17-.01-.33-.04-.49l1.06-.83c.09-.08.12-.21.06-.32l-1-1.73c-.06-.11-.19-.15-.31-.11l-1.24.5c-.26-.2-.54-.37-.85-.49l-.19-1.32c-.01-.12-.12-.21-.24-.21h-2c-.12 0-.23.09-.25.21l-.19 1.32c-.3.13-.59.29-.85.49l-1.24-.5c-.11-.04-.24 0-.31.11l-1 1.73c-.06.11-.04.24.06.32l1.06.83c-.02.16-.03.32-.03.49 0 .17.01.33.03.49l-1.06.83c-.09.08-.12.21-.06.32l1 1.73c.06.11.19.15.31.11l1.24-.5c.26.2.54.37.85.49l.19 1.32c.02.12.12.21.25.21h2c.12 0 .23-.09.25-.21l.19-1.32c.3-.13.59-.29.84-.49l1.25.5c.11.04.24 0 .31-.11l1-1.73c.06-.11.03-.24-.06-.32l-1.07-.83zm-3.71 1.01c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
})), 'PermDataSetting');

exports.default = _default;

/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13 7h-2v2h2V7zm0 4h-2v6h2v-6zm4-9.99L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
})), 'PermDeviceInformation');

exports.default = _default;

/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"
})), 'PermIdentity');

exports.default = _default;

/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M2 6H0v5h.01L0 20c0 1.1.9 2 2 2h18v-2H2V6zm20-2h-8l-2-2H6c-1.1 0-1.99.9-1.99 2L4 16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7 15l4.5-6 3.5 4.51 2.5-3.01L21 15H7z"
})), 'PermMedia');

exports.default = _default;

/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.58l2.2-2.21c.28-.27.36-.66.25-1.01C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM12 3v10l3-3h6V3h-9z"
})), 'PermPhoneMsg');

exports.default = _default;

/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 3C6.95 3 3.15 4.85 0 7.23L12 22 24 7.25C20.85 4.87 17.05 3 12 3zm1 13h-2v-6h2v6zm-2-8V6h2v2h-2z"
})), 'PermScanWifi');

exports.default = _default;

/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
})), 'PersonAdd');

exports.default = _default;

/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12z"
})), 'PersonalVideo');

exports.default = _default;

/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"
})), 'PersonOutline');

exports.default = _default;

/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 3.3c1.49 0 2.7 1.21 2.7 2.7 0 1.49-1.21 2.7-2.7 2.7-1.49 0-2.7-1.21-2.7-2.7 0-1.49 1.21-2.7 2.7-2.7zM18 16H6v-.9c0-2 4-3.1 6-3.1s6 1.1 6 3.1v.9z"
})), 'PersonPin');

exports.default = _default;

/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm0 2c1.1 0 2 .9 2 2 0 1.11-.9 2-2 2s-2-.89-2-2c0-1.1.9-2 2-2zm0 10c-1.67 0-3.14-.85-4-2.15.02-1.32 2.67-2.05 4-2.05s3.98.73 4 2.05c-.86 1.3-2.33 2.15-4 2.15z"
})), 'PersonPinCircle');

exports.default = _default;

/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("circle", {
  cx: "4.5",
  cy: "9.5",
  r: "2.5"
}), _react.default.createElement("circle", {
  cx: "9",
  cy: "5.5",
  r: "2.5"
}), _react.default.createElement("circle", {
  cx: "15",
  cy: "5.5",
  r: "2.5"
}), _react.default.createElement("circle", {
  cx: "19.5",
  cy: "9.5",
  r: "2.5"
}), _react.default.createElement("path", {
  d: "M17.34 14.86c-.87-1.02-1.6-1.89-2.48-2.91-.46-.54-1.05-1.08-1.75-1.32-.11-.04-.22-.07-.33-.09-.25-.04-.52-.04-.78-.04s-.53 0-.79.05c-.11.02-.22.05-.33.09-.7.24-1.28.78-1.75 1.32-.87 1.02-1.6 1.89-2.48 2.91-1.31 1.31-2.92 2.76-2.62 4.79.29 1.02 1.02 2.03 2.33 2.32.73.15 3.06-.44 5.54-.44h.18c2.48 0 4.81.58 5.54.44 1.31-.29 2.04-1.31 2.33-2.32.31-2.04-1.3-3.49-2.61-4.8z"
})), 'Pets');

exports.default = _default;

/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
})), 'Phone');

exports.default = _default;

/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16 1H8C6.34 1 5 2.34 5 4v16c0 1.66 1.34 3 3 3h8c1.66 0 3-1.34 3-3V4c0-1.66-1.34-3-3-3zm-2 20h-4v-1h4v1zm3.25-3H6.75V4h10.5v14z"
})), 'PhoneAndroid');

exports.default = _default;

/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M14.71 9.5L17 7.21V11h.5l2.85-2.85L18.21 6l2.15-2.15L17.5 1H17v3.79L14.71 2.5l-.71.71L16.79 6 14 8.79l.71.71zM18 2.91l.94.94-.94.94V2.91zm0 4.3l.94.94-.94.94V7.21zm2 8.29c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z"
})), 'PhoneBluetoothSpeaker');

exports.default = _default;

/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 11l5-5-5-5v3h-4v4h4v3zm2 4.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z"
})), 'PhoneForwarded');

exports.default = _default;

/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM19 12h2c0-4.97-4.03-9-9-9v2c3.87 0 7 3.13 7 7zm-4 0h2c0-2.76-2.24-5-5-5v2c1.66 0 3 1.34 3 3z"
})), 'PhoneInTalk');

exports.default = _default;

/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15.5 1h-8C6.12 1 5 2.12 5 3.5v17C5 21.88 6.12 23 7.5 23h8c1.38 0 2.5-1.12 2.5-2.5v-17C18 2.12 16.88 1 15.5 1zm-4 21c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5-4H7V4h9v14z"
})), 'PhoneIphone');

exports.default = _default;

/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13 8.2l-1-1-4 4-4-4-1 1 4 4-4 4 1 1 4-4 4 4 1-1-4-4 4-4zM19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z"
})), 'PhonelinkErase');

exports.default = _default;

/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm-8.2 10V9.5C10.8 8.1 9.4 7 8 7S5.2 8.1 5.2 9.5V11c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3zm-1.3 0h-3V9.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3V11z"
})), 'PhonelinkLock');

exports.default = _default;

/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 6V4H6.82l2 2H22zM1.92 1.65L.65 2.92l1.82 1.82C2.18 5.08 2 5.52 2 6v11H0v3h17.73l2.35 2.35 1.27-1.27L3.89 3.62 1.92 1.65zM4 6.27L14.73 17H4V6.27zM23 8h-6c-.55 0-1 .45-1 1v4.18l2 2V10h4v7h-2.18l3 3H23c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1z"
})), 'PhonelinkOff');

exports.default = _default;

/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20.1 7.7l-1 1c1.8 1.8 1.8 4.6 0 6.5l1 1c2.5-2.3 2.5-6.1 0-8.5zM18 9.8l-1 1c.5.7.5 1.6 0 2.3l1 1c1.2-1.2 1.2-3 0-4.3zM14 1H4c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 19H4V4h10v16z"
})), 'PhonelinkRing');

exports.default = _default;

/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11.8 12.5v-1l1.1-.8c.1-.1.1-.2.1-.3l-1-1.7c-.1-.1-.2-.2-.3-.1l-1.3.4c-.3-.2-.6-.4-.9-.5l-.2-1.3c0-.1-.1-.2-.3-.2H7c-.1 0-.2.1-.3.2l-.2 1.3c-.3.1-.6.3-.9.5l-1.3-.5c-.1 0-.2 0-.3.1l-1 1.7c-.1.1 0 .2.1.3l1.1.8v1l-1.1.8c-.1.2-.1.3-.1.4l1 1.7c.1.1.2.2.3.1l1.4-.4c.3.2.6.4.9.5l.2 1.3c-.1.1.1.2.2.2h2c.1 0 .2-.1.3-.2l.2-1.3c.3-.1.6-.3.9-.5l1.3.5c.1 0 .2 0 .3-.1l1-1.7c.1-.1 0-.2-.1-.3l-1.1-.9zM8 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z"
})), 'PhonelinkSetup');

exports.default = _default;

/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM20 4v-.5C20 2.12 18.88 1 17.5 1S15 2.12 15 3.5V4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-.8 0h-3.4v-.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V4z"
})), 'PhoneLocked');

exports.default = _default;

/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6.5 5.5L12 11l7-7-1-1-6 6-4.5-4.5H11V3H5v6h1.5V5.5zm17.21 11.17C20.66 13.78 16.54 12 12 12 7.46 12 3.34 13.78.29 16.67c-.18.18-.29.43-.29.71s.11.53.29.71l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73 1.6 0 3.15.25 4.6.72v3.1c0 .39.23.74.56.9.98.49 1.87 1.12 2.67 1.85.18.18.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71s-.12-.52-.3-.7z"
})), 'PhoneMissed');

exports.default = _default;

/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 3h-2v7h2V3zm3 12.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM19 3v7h2V3h-2z"
})), 'PhonePaused');

exports.default = _default;

/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
})), 'Photo');

exports.default = _default;

/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4zm0 15l3-3.86 2.14 2.58 3-3.86L18 19H6z"
})), 'PhotoAlbum');

exports.default = _default;

/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "3.2"
}), _react.default.createElement("path", {
  d: "M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
})), 'PhotoCamera');

exports.default = _default;

/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.02 10v9H5V5h9V3H5.02c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-9h-2zM17 10l.94-2.06L20 7l-2.06-.94L17 4l-.94 2.06L14 7l2.06.94zm-3.75.75L12 8l-1.25 2.75L8 12l2.75 1.25L12 16l1.25-2.75L16 12z"
})), 'PhotoFilter');

exports.default = _default;

/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zm-11-4l2.03 2.71L16 11l4 5H8l3-4zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z"
})), 'PhotoLibrary');

exports.default = _default;

/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 3H3C2 3 1 4 1 5v14c0 1.1.9 2 2 2h18c1 0 2-1 2-2V5c0-1-1-2-2-2zM5 17l3.5-4.5 2.5 3.01L14.5 11l4.5 6H5z"
})), 'PhotoSizeSelectActual');

exports.default = _default;

/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 15h2v2h-2v-2zm0-4h2v2h-2v-2zm2 8h-2v2c1 0 2-1 2-2zM13 3h2v2h-2V3zm8 4h2v2h-2V7zm0-4v2h2c0-1-1-2-2-2zM1 7h2v2H1V7zm16-4h2v2h-2V3zm0 16h2v2h-2v-2zM3 3C2 3 1 4 1 5h2V3zm6 0h2v2H9V3zM5 3h2v2H5V3zm-4 8v8c0 1.1.9 2 2 2h12V11H1zm2 8l2.5-3.21 1.79 2.15 2.5-3.22L13 19H3z"
})), 'PhotoSizeSelectLarge');

exports.default = _default;

/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M23 15h-2v2h2v-2zm0-4h-2v2h2v-2zm0 8h-2v2c1 0 2-1 2-2zM15 3h-2v2h2V3zm8 4h-2v2h2V7zm-2-4v2h2c0-1-1-2-2-2zM3 21h8v-6H1v4c0 1.1.9 2 2 2zM3 7H1v2h2V7zm12 12h-2v2h2v-2zm4-16h-2v2h2V3zm0 16h-2v2h2v-2zM3 3C2 3 1 4 1 5h2V3zm0 8H1v2h2v-2zm8-8H9v2h2V3zM7 3H5v2h2V3z"
})), 'PhotoSizeSelectSmall');

exports.default = _default;

/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 7.5c0 .83-.67 1.5-1.5 1.5H9v2H7.5V7H10c.83 0 1.5.67 1.5 1.5v1zm5 2c0 .83-.67 1.5-1.5 1.5h-2.5V7H15c.83 0 1.5.67 1.5 1.5v3zm4-3H19v1h1.5V11H19v2h-1.5V7h3v1.5zM9 9.5h1v-1H9v1zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm10 5.5h1v-3h-1v3z"
})), 'PictureAsPdf');

exports.default = _default;

/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 7h-8v6h8V7zm2-4H3c-1.1 0-2 .9-2 2v14c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98V5c0-1.1-.9-2-2-2zm0 16.01H3V4.98h18v14.03z"
})), 'PictureInPicture');

exports.default = _default;

/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 11h-8v6h8v-6zm4 8V4.98C23 3.88 22.1 3 21 3H3c-1.1 0-2 .88-2 1.98V19c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zm-2 .02H3V4.97h18v14.05z"
})), 'PictureInPictureAlt');

exports.default = _default;

/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11 2v20c-5.07-.5-9-4.79-9-10s3.93-9.5 9-10zm2.03 0v8.99H22c-.47-4.74-4.24-8.52-8.97-8.99zm0 11.01V22c4.74-.47 8.5-4.25 8.97-8.99h-8.97z"
})), 'PieChart');

exports.default = _default;

/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm1 2.07c3.61.45 6.48 3.33 6.93 6.93H13V4.07zM4 12c0-4.06 3.07-7.44 7-7.93v15.87c-3.93-.5-7-3.88-7-7.94zm9 7.93V13h6.93c-.45 3.61-3.32 6.48-6.93 6.93z"
})), 'PieChartOutlined');

exports.default = _default;

/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 8c0-3.31-2.69-6-6-6S6 4.69 6 8c0 4.5 6 11 6 11s6-6.5 6-11zm-8 0c0-1.1.9-2 2-2s2 .9 2 2-.89 2-2 2c-1.1 0-2-.9-2-2zM5 20v2h14v-2H5z"
})), 'PinDrop');

exports.default = _default;

/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
})), 'Place');

exports.default = _default;

/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M8 5v14l11-7z"
})), 'PlayArrow');

exports.default = _default;

/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z"
})), 'PlayCircleFilled');

exports.default = _default;

/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
})), 'PlayCircleOutline');

exports.default = _default;

/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11 5v5.59H7.5l4.5 4.5 4.5-4.5H13V5h-2zm-5 9c0 3.31 2.69 6 6 6s6-2.69 6-6h-2c0 2.21-1.79 4-4 4s-4-1.79-4-4H6z"
})), 'PlayForWork');

exports.default = _default;

/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M14 10H2v2h12v-2zm0-4H2v2h12V6zm4 8v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zM2 16h8v-2H2v2z"
})), 'PlaylistAdd');

exports.default = _default;

/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 9H2v2h17V9zm0-4H2v2h17V5zM2 15h13v-2H2v2zm15-2v6l5-3-5-3z"
})), 'PlaylistPlay');

exports.default = _default;

/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 8H8v4H4v2h4v4h2v-4h4v-2h-4zm4.5-1.92V7.9l2.5-.5V18h2V5z"
})), 'PlusOne');

exports.default = _default;

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"
})), 'Poll');

exports.default = _default;

/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 4h-4L7.11 16.63 4.5 12 9 4H5L.5 12 5 20h4l7.89-12.63L19.5 12 15 20h4l4.5-8z"
})), 'Polymer');

exports.default = _default;

/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 21c-1.11 0-1.73-.37-2.18-.64-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.46.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.46.27-1.08.64-2.19.64-1.11 0-1.73-.37-2.18-.64-.37-.23-.6-.36-1.15-.36s-.78.13-1.15.36c-.46.27-1.08.64-2.19.64v-2c.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64s1.73.37 2.18.64c.37.23.59.36 1.15.36.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64 1.11 0 1.73.37 2.18.64.37.22.6.36 1.15.36s.78-.13 1.15-.36c.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.23.59.36 1.15.36v2zm0-4.5c-1.11 0-1.73-.37-2.18-.64-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.45.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.45.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36s-.78.13-1.15.36c-.47.27-1.09.64-2.2.64v-2c.56 0 .78-.13 1.15-.36.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36.56 0 .78-.13 1.15-.36.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36s.78-.13 1.15-.36c.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36v2zM8.67 12c.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64 1.11 0 1.73.37 2.18.64.37.22.6.36 1.15.36s.78-.13 1.15-.36c.12-.07.26-.15.41-.23L10.48 5C8.93 3.45 7.5 2.99 5 3v2.5c1.82-.01 2.89.39 4 1.5l1 1-3.25 3.25c.31.12.56.27.77.39.37.23.59.36 1.15.36z"
}), _react.default.createElement("circle", {
  cx: "16.5",
  cy: "5.5",
  r: "2.5"
})), 'Pool');

exports.default = _default;

/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17.56 14.24c.28-.69.44-1.45.44-2.24 0-3.31-2.69-6-6-6-.79 0-1.55.16-2.24.44l1.62 1.62c.2-.03.41-.06.62-.06 2.21 0 4 1.79 4 4 0 .21-.02.42-.05.63l1.61 1.61zM12 4c4.42 0 8 3.58 8 8 0 1.35-.35 2.62-.95 3.74l1.47 1.47C21.46 15.69 22 13.91 22 12c0-5.52-4.48-10-10-10-1.91 0-3.69.55-5.21 1.47l1.46 1.46C9.37 4.34 10.65 4 12 4zM3.27 2.5L2 3.77l2.1 2.1C2.79 7.57 2 9.69 2 12c0 3.7 2.01 6.92 4.99 8.65l1-1.73C5.61 17.53 4 14.96 4 12c0-1.76.57-3.38 1.53-4.69l1.43 1.44C6.36 9.68 6 10.8 6 12c0 2.22 1.21 4.15 3 5.19l1-1.74c-1.19-.7-2-1.97-2-3.45 0-.65.17-1.25.44-1.79l1.58 1.58L10 12c0 1.1.9 2 2 2l.21-.02.01.01 7.51 7.51L21 20.23 4.27 3.5l-1-1z"
})), 'PortableWifiOff');

exports.default = _default;

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 12.25c1.24 0 2.25-1.01 2.25-2.25S13.24 7.75 12 7.75 9.75 8.76 9.75 10s1.01 2.25 2.25 2.25zm4.5 4c0-1.5-3-2.25-4.5-2.25s-4.5.75-4.5 2.25V17h9v-.75zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
})), 'Portrait');

exports.default = _default;

/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16.01 7L16 3h-2v4h-4V3H8v4h-.01C7 6.99 6 7.99 6 8.99v5.49L9.5 18v3h5v-3l3.5-3.51v-5.5c0-1-1-2-1.99-1.99z"
})), 'Power');

exports.default = _default;

/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M2 9v2h19V9H2zm0 6h5v-2H2v2zm7 0h5v-2H9v2zm7 0h5v-2h-5v2z"
})), 'PowerInput');

exports.default = _default;

/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13 3h-2v10h2V3zm4.83 2.17l-1.42 1.42C17.99 7.86 19 9.81 19 12c0 3.87-3.13 7-7 7s-7-3.13-7-7c0-2.19 1.01-4.14 2.58-5.42L6.17 5.17C4.23 6.82 3 9.26 3 12c0 4.97 4.03 9 9 9s9-4.03 9-9c0-2.74-1.23-5.18-3.17-6.83z"
})), 'PowerSettingsNew');

exports.default = _default;

/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm7 9c-.01-1.34-.83-2.51-2-3 0-1.66-1.34-3-3-3s-3 1.34-3 3v7h2v5h3v-5h3v-4z"
})), 'PregnantWoman');

exports.default = _default;

/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 3H3c-1.11 0-2 .89-2 2v14c0 1.11.89 2 2 2h18c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2zm0 16.02H3V4.98h18v14.04zM10 12H8l4-4 4 4h-2v4h-4v-4z"
})), 'PresentToAll');

exports.default = _default;

/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("circle", {
  cx: "12",
  cy: "19",
  r: "2"
}), _react.default.createElement("path", {
  d: "M10 3h4v12h-4z"
})), 'PriorityHigh');

exports.default = _default;

/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"
})), 'Public');

exports.default = _default;

/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M5 4v2h14V4H5zm0 10h4v6h6v-6h4l-7-7-7 7z"
})), 'Publish');

exports.default = _default;

/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"
})), 'QueryBuilder');

exports.default = _default;

/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z"
})), 'QuestionAnswer');

exports.default = _default;

/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z"
})), 'Queue');

exports.default = _default;

/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15 6H3v2h12V6zm0 4H3v2h12v-2zM3 16h8v-2H3v2zM17 6v8.18c-.31-.11-.65-.18-1-.18-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3V8h3V6h-5z"
})), 'QueueMusic');

exports.default = _default;

/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h2v-2H3V5h18v8h2V5c0-1.11-.9-2-2-2zm-8 7V7h-2v3H8v2h3v3h2v-3h3v-2h-3zm11 8l-4.5 4.5L18 21l3-3-3-3 1.5-1.5L24 18z"
})), 'QueuePlayNext');

exports.default = _default;

/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3.24 6.15C2.51 6.43 2 7.17 2 8v12c0 1.1.89 2 2 2h16c1.11 0 2-.9 2-2V8c0-1.11-.89-2-2-2H8.3l8.26-3.34L15.88 1 3.24 6.15zM7 20c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm13-8h-2v-2h-2v2H4V8h16v4z"
})), 'Radio');

exports.default = _default;

/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
})), 'RadioButtonChecked');

exports.default = _default;

/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
})), 'RadioButtonUnchecked');

exports.default = _default;

/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 14v-2.47l6.88-6.88c.2-.2.51-.2.71 0l1.77 1.77c.2.2.2.51 0 .71L8.47 14H6zm12 0h-7.5l2-2H18v2z"
})), 'RateReview');

exports.default = _default;

/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 5v14h2V5h-2zm-4 14h2V5h-2v14zM14 5H2c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zM8 7.75c1.24 0 2.25 1.01 2.25 2.25S9.24 12.25 8 12.25 5.75 11.24 5.75 10 6.76 7.75 8 7.75zM12.5 17h-9v-.75c0-1.5 3-2.25 4.5-2.25s4.5.75 4.5 2.25V17z"
})), 'RecentActors');

exports.default = _default;

/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("circle", {
  cx: "9",
  cy: "9",
  r: "4"
}), _react.default.createElement("path", {
  d: "M9 15c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm7.76-9.64l-1.68 1.69c.84 1.18.84 2.71 0 3.89l1.68 1.69c2.02-2.02 2.02-5.07 0-7.27zM20.07 2l-1.63 1.63c2.77 3.02 2.77 7.56 0 10.74L20.07 16c3.9-3.89 3.91-9.95 0-14z"
})), 'RecordVoiceOver');

exports.default = _default;

/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z"
})), 'Redeem');

exports.default = _default;

/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16c1.05-3.19 4.05-5.5 7.6-5.5 1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6z"
})), 'Redo');

exports.default = _default;

/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 13H5v-2h14v2z"
})), 'Remove');

exports.default = _default;

/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z"
})), 'RemoveCircle');

exports.default = _default;

/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
})), 'RemoveCircleOutline');

exports.default = _default;

/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12zm-5-7v2H8v-2h8z"
})), 'RemoveFromQueue');

exports.default = _default;

/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
})), 'RemoveRedEye');

exports.default = _default;

/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22.73 22.73L2.77 2.77 2 2l-.73-.73L0 2.54l4.39 4.39 2.21 4.66-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h7.46l1.38 1.38c-.5.36-.83.95-.83 1.62 0 1.1.89 2 1.99 2 .67 0 1.26-.33 1.62-.84L21.46 24l1.27-1.27zM7.42 15c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h2.36l2 2H7.42zm8.13-2c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H6.54l9.01 9zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2z"
})), 'RemoveShoppingCart');

exports.default = _default;

/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 15h18v-2H3v2zm0 4h18v-2H3v2zm0-8h18V9H3v2zm0-6v2h18V5H3z"
})), 'Reorder');

exports.default = _default;

/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4z"
})), 'Repeat');

exports.default = _default;

/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4zm-4-2V9h-1l-2 1v1h1.5v4H13z"
})), 'RepeatOne');

exports.default = _default;

/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"
})), 'Replay');

exports.default = _default;

/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8zm-1.1 11H10v-3.3L9 13v-.7l1.8-.6h.1V16zm4.3-1.8c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1c.2.1.3.2.5.3s.2.3.3.6.1.5.1.8v.7zm-.9-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z"
})), 'Replay10');

exports.default = _default;

/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8zm-2.4 8.5h.4c.2 0 .4-.1.5-.2s.2-.2.2-.4v-.2s-.1-.1-.1-.2-.1-.1-.2-.1h-.5s-.1.1-.2.1-.1.1-.1.2v.2h-1c0-.2 0-.3.1-.5s.2-.3.3-.4.3-.2.4-.2.4-.1.5-.1c.2 0 .4 0 .6.1s.3.1.5.2.2.2.3.4.1.3.1.5v.3s-.1.2-.1.3-.1.2-.2.2-.2.1-.3.2c.2.1.4.2.5.4s.2.4.2.6c0 .2 0 .4-.1.5s-.2.3-.3.4-.3.2-.5.2-.4.1-.6.1c-.2 0-.4 0-.5-.1s-.3-.1-.5-.2-.2-.2-.3-.4-.1-.4-.1-.6h.8v.2s.1.1.1.2.1.1.2.1h.5s.1-.1.2-.1.1-.1.1-.2v-.5s-.1-.1-.1-.2-.1-.1-.2-.1h-.6v-.7zm5.7.7c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1.3.2.5.3.2.3.3.6.1.5.1.8v.7zm-.8-.8v-.5c0-.1-.1-.2-.1-.3s-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z"
})), 'Replay30');

exports.default = _default;

/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8zm-1.3 8.9l.2-2.2h2.4v.7h-1.7l-.1.9s.1 0 .1-.1.1 0 .1-.1.1 0 .2 0h.2c.2 0 .4 0 .5.1s.3.2.4.3.2.3.3.5.1.4.1.6c0 .2 0 .4-.1.5s-.1.3-.3.5-.3.2-.4.3-.4.1-.6.1c-.2 0-.4 0-.5-.1s-.3-.1-.5-.2-.2-.2-.3-.4-.1-.3-.1-.5h.8c0 .2.1.3.2.4s.2.1.4.1c.1 0 .2 0 .3-.1l.2-.2s.1-.2.1-.3v-.6l-.1-.2-.2-.2s-.2-.1-.3-.1h-.2s-.1 0-.2.1-.1 0-.1.1-.1.1-.1.1h-.7z"
})), 'Replay5');

exports.default = _default;

/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"
})), 'Reply');

exports.default = _default;

/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 8V5l-7 7 7 7v-3l-4-4 4-4zm6 1V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"
})), 'ReplyAll');

exports.default = _default;

/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM12 17.3c-.72 0-1.3-.58-1.3-1.3 0-.72.58-1.3 1.3-1.3.72 0 1.3.58 1.3 1.3 0 .72-.58 1.3-1.3 1.3zm1-4.3h-2V7h2v6z"
})), 'Report');

exports.default = _default;

/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
})), 'ReportProblem');

exports.default = _default;

/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11 9H9V2H7v7H5V2H3v7c0 2.12 1.66 3.84 3.75 3.97V22h2.5v-9.03C11.34 12.84 13 11.12 13 9V2h-2v7zm5-3v8h2.5v8H21V2c-2.76 0-5 2.24-5 4z"
})), 'Restaurant');

exports.default = _default;

/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M8.1 13.34l2.83-2.83L3.91 3.5c-1.56 1.56-1.56 4.09 0 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z"
})), 'RestaurantMenu');

exports.default = _default;

/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"
})), 'Restore');

exports.default = _default;

/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm-2 16c-2.05 0-3.81-1.24-4.58-3h1.71c.63.9 1.68 1.5 2.87 1.5 1.93 0 3.5-1.57 3.5-3.5S13.93 9.5 12 9.5c-1.35 0-2.52.78-3.1 1.9l1.6 1.6h-4V9l1.3 1.3C8.69 8.92 10.23 8 12 8c2.76 0 5 2.24 5 5s-2.24 5-5 5z"
})), 'RestorePage');

exports.default = _default;

/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M23.71 16.67C20.66 13.78 16.54 12 12 12 7.46 12 3.34 13.78.29 16.67c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73s3.15.25 4.6.72v3.1c0 .39.23.74.56.9.98.49 1.87 1.12 2.66 1.85.18.18.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71 0-.27-.11-.52-.29-.7zM21.16 6.26l-1.41-1.41-3.56 3.55 1.41 1.41s3.45-3.52 3.56-3.55zM13 2h-2v5h2V2zM6.4 9.81L7.81 8.4 4.26 4.84 2.84 6.26c.11.03 3.56 3.55 3.56 3.55z"
})), 'RingVolume');

exports.default = _default;

/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M2 17h20v2H2zm11.84-9.21c.1-.24.16-.51.16-.79 0-1.1-.9-2-2-2s-2 .9-2 2c0 .28.06.55.16.79C6.25 8.6 3.27 11.93 3 16h18c-.27-4.07-3.25-7.4-7.16-8.21z"
})), 'RoomService');

exports.default = _default;

/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7.34 6.41L.86 12.9l6.49 6.48 6.49-6.48-6.5-6.49zM3.69 12.9l3.66-3.66L11 12.9l-3.66 3.66-3.65-3.66zm15.67-6.26C17.61 4.88 15.3 4 13 4V.76L8.76 5 13 9.24V6c1.79 0 3.58.68 4.95 2.05 2.73 2.73 2.73 7.17 0 9.9C16.58 19.32 14.79 20 13 20c-.97 0-1.94-.21-2.84-.61l-1.49 1.49C10.02 21.62 11.51 22 13 22c2.3 0 4.61-.88 6.36-2.64 3.52-3.51 3.52-9.21 0-12.72z"
})), 'Rotate90DegreesCcw');

exports.default = _default;

/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7.11 8.53L5.7 7.11C4.8 8.27 4.24 9.61 4.07 11h2.02c.14-.87.49-1.72 1.02-2.47zM6.09 13H4.07c.17 1.39.72 2.73 1.62 3.89l1.41-1.42c-.52-.75-.87-1.59-1.01-2.47zm1.01 5.32c1.16.9 2.51 1.44 3.9 1.61V17.9c-.87-.15-1.71-.49-2.46-1.03L7.1 18.32zM13 4.07V1L8.45 5.55 13 10V6.09c2.84.48 5 2.94 5 5.91s-2.16 5.43-5 5.91v2.02c3.95-.49 7-3.85 7-7.93s-3.05-7.44-7-7.93z"
})), 'RotateLeft');

exports.default = _default;

/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15.55 5.55L11 1v3.07C7.06 4.56 4 7.92 4 12s3.05 7.44 7 7.93v-2.02c-2.84-.48-5-2.94-5-5.91s2.16-5.43 5-5.91V10l4.55-4.45zM19.93 11c-.17-1.39-.72-2.73-1.62-3.89l-1.42 1.42c.54.75.88 1.6 1.02 2.47h2.02zM13 17.9v2.02c1.39-.17 2.74-.71 3.9-1.61l-1.44-1.44c-.75.54-1.59.89-2.46 1.03zm3.89-2.42l1.42 1.41c.9-1.16 1.45-2.5 1.62-3.89h-2.02c-.14.87-.48 1.72-1.02 2.48z"
})), 'RotateRight');

exports.default = _default;

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 19h2v2h-2v-2zm0-2h2v-2h-2v2zM3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm0-4h2V3H3v2zm4 0h2V3H7v2zm8 16h2v-2h-2v2zm-4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm-8 0h2v-2H7v2zm-4 0h2v-2H3v2zM21 8c0-2.76-2.24-5-5-5h-5v2h5c1.65 0 3 1.35 3 3v5h2V8z"
})), 'RoundedCorner');

exports.default = _default;

/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20.2 5.9l.8-.8C19.6 3.7 17.8 3 16 3s-3.6.7-5 2.1l.8.8C13 4.8 14.5 4.2 16 4.2s3 .6 4.2 1.7zm-.9.8c-.9-.9-2.1-1.4-3.3-1.4s-2.4.5-3.3 1.4l.8.8c.7-.7 1.6-1 2.5-1 .9 0 1.8.3 2.5 1l.8-.8zM19 13h-2V9h-2v4H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2zM8 18H6v-2h2v2zm3.5 0h-2v-2h2v2zm3.5 0h-2v-2h2v2z"
})), 'Router');

exports.default = _default;

/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M8.5 14.5L4 19l1.5 1.5L9 17h2l-2.5-2.5zM15 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 20.01L18 24l-2.99-3.01V19.5l-7.1-7.09c-.31.05-.61.07-.91.07v-2.16c1.66.03 3.61-.87 4.67-2.04l1.4-1.55c.19-.21.43-.38.69-.5.29-.14.62-.23.96-.23h.03C15.99 6.01 17 7.02 17 8.26v5.75c0 .84-.35 1.61-.92 2.16l-3.58-3.58v-2.27c-.63.52-1.43 1.02-2.29 1.39L16.5 18H18l3 3.01z"
})), 'Rowing');

exports.default = _default;

/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("circle", {
  cx: "6.18",
  cy: "17.82",
  r: "2.18"
}), _react.default.createElement("path", {
  d: "M4 4.44v2.83c7.03 0 12.73 5.7 12.73 12.73h2.83c0-8.59-6.97-15.56-15.56-15.56zm0 5.66v2.83c3.9 0 7.07 3.17 7.07 7.07h2.83c0-5.47-4.43-9.9-9.9-9.9z"
})), 'RssFeed');

exports.default = _default;

/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 17v-6c0-1.1-.9-2-2-2H7V7l-3 3 3 3v-2h4v3H4v3c0 1.1.9 2 2 2h2c0 1.66 1.34 3 3 3s3-1.34 3-3h8v-2h-2zm-9 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm7-6h-4v-3h4v3zM17 2v2H9v2h8v2l3-3z"
})), 'RvHookup');

exports.default = _default;

/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 4.99h3C8 6.65 6.66 8 5 8V4.99zM5 12v-2c2.76 0 5-2.25 5-5.01h2C12 8.86 8.87 12 5 12zm0 6l3.5-4.5 2.5 3.01L14.5 12l4.5 6H5z"
})), 'Satellite');

exports.default = _default;

/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z"
})), 'Save');

exports.default = _default;

/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.8 10.7L4.2 5l-.7 1.9L17.6 12H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-5.5c0-.8-.5-1.6-1.2-1.8zM7 17H5v-2h2v2zm12 0H9v-2h10v2z"
})), 'Scanner');

exports.default = _default;

/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"
})), 'Schedule');

exports.default = _default;

/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z"
})), 'School');

exports.default = _default;

/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 5H3c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-2 12H5V7h14v10zm-9-1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1v-1c0-1.11-.9-2-2-2-1.11 0-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm.8-6c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2v1h-2.4v-1z"
})), 'ScreenLockLandscape');

exports.default = _default;

/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 16h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1v-1c0-1.11-.9-2-2-2-1.11 0-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm.8-6c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2v1h-2.4v-1zM17 1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 18H7V5h10v14z"
})), 'ScreenLockPortrait');

exports.default = _default;

/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M23.25 12.77l-2.57-2.57-1.41 1.41 2.22 2.22-5.66 5.66L4.51 8.17l5.66-5.66 2.1 2.1 1.41-1.41L11.23.75c-.59-.59-1.54-.59-2.12 0L2.75 7.11c-.59.59-.59 1.54 0 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12zM8.47 20.48C5.2 18.94 2.86 15.76 2.5 12H1c.51 6.16 5.66 11 11.95 11l.66-.03-3.81-3.82-1.33 1.33zM16 9h5c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1v-.5C21 1.12 19.88 0 18.5 0S16 1.12 16 2.5V3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.8-6.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V3h-3.4v-.5z"
})), 'ScreenLockRotation');

exports.default = _default;

/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16.48 2.52c3.27 1.55 5.61 4.72 5.97 8.48h1.5C23.44 4.84 18.29 0 12 0l-.66.03 3.81 3.81 1.33-1.32zm-6.25-.77c-.59-.59-1.54-.59-2.12 0L1.75 8.11c-.59.59-.59 1.54 0 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12L10.23 1.75zm4.6 19.44L2.81 9.17l6.36-6.36 12.02 12.02-6.36 6.36zm-7.31.29C4.25 19.94 1.91 16.76 1.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.81-1.33 1.32z"
})), 'ScreenRotation');

exports.default = _default;

/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.11-.9-2-2-2H4c-1.11 0-2 .89-2 2v10c0 1.1.89 2 2 2H0v2h24v-2h-4zm-7-3.53v-2.19c-2.78 0-4.61.85-6 2.72.56-2.67 2.11-5.33 6-5.87V7l4 3.73-4 3.74z"
})), 'ScreenShare');

exports.default = _default;

/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 6h-2V4h2v4zm3 0h-2V4h2v4zm3 0h-2V4h2v4z"
})), 'SdCard');

exports.default = _default;

/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 6h-2V4h2v4zm3 0h-2V4h2v4zm3 0h-2V4h2v4z"
})), 'SdStorage');

exports.default = _default;

/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"
})), 'Security');

exports.default = _default;

/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 5h2V3c-1.1 0-2 .9-2 2zm0 8h2v-2H3v2zm4 8h2v-2H7v2zM3 9h2V7H3v2zm10-6h-2v2h2V3zm6 0v2h2c0-1.1-.9-2-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zM9 3H7v2h2V3zm2 18h2v-2h-2v2zm8-8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zm0-12h2V7h-2v2zm0 8h2v-2h-2v2zm-4 4h2v-2h-2v2zm0-16h2V3h-2v2zM7 17h10V7H7v10zm2-8h6v6H9V9z"
})), 'SelectAll');

exports.default = _default;

/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"
})), 'Send');

exports.default = _default;

/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("circle", {
  cx: "15.5",
  cy: "9.5",
  r: "1.5"
}), _react.default.createElement("circle", {
  cx: "8.5",
  cy: "9.5",
  r: "1.5"
}), _react.default.createElement("path", {
  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-6c-2.33 0-4.32 1.45-5.12 3.5h1.67c.69-1.19 1.97-2 3.45-2s2.75.81 3.45 2h1.67c-.8-2.05-2.79-3.5-5.12-3.5z"
})), 'SentimentDissatisfied');

exports.default = _default;

/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9 14h6v1.5H9z"
}), _react.default.createElement("circle", {
  cx: "15.5",
  cy: "9.5",
  r: "1.5"
}), _react.default.createElement("circle", {
  cx: "8.5",
  cy: "9.5",
  r: "1.5"
}), _react.default.createElement("path", {
  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
})), 'SentimentNeutral');

exports.default = _default;

/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("circle", {
  cx: "15.5",
  cy: "9.5",
  r: "1.5"
}), _react.default.createElement("circle", {
  cx: "8.5",
  cy: "9.5",
  r: "1.5"
}), _react.default.createElement("path", {
  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-4c-1.48 0-2.75-.81-3.45-2H6.88c.8 2.05 2.79 3.5 5.12 3.5s4.32-1.45 5.12-3.5h-1.67c-.7 1.19-1.97 2-3.45 2z"
})), 'SentimentSatisfied');

exports.default = _default;

/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11.99 2C6.47 2 2 6.47 2 12s4.47 10 9.99 10S22 17.53 22 12 17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm4.18-12.24l-1.06 1.06-1.06-1.06L13 8.82l1.06 1.06L13 10.94 14.06 12l1.06-1.06L16.18 12l1.06-1.06-1.06-1.06 1.06-1.06zM7.82 12l1.06-1.06L9.94 12 11 10.94 9.94 9.88 11 8.82 9.94 7.76 8.88 8.82 7.82 7.76 6.76 8.82l1.06 1.06-1.06 1.06zM12 14c-2.33 0-4.31 1.46-5.11 3.5h10.22c-.8-2.04-2.78-3.5-5.11-3.5z"
})), 'SentimentVeryDissatisfied');

exports.default = _default;

/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11.99 2C6.47 2 2 6.47 2 12s4.47 10 9.99 10S22 17.53 22 12 17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm1-10.06L14.06 11l1.06-1.06L16.18 11l1.06-1.06-2.12-2.12zm-4.12 0L9.94 11 11 9.94 8.88 7.82 6.76 9.94 7.82 11zM12 17.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
})), 'SentimentVerySatisfied');

exports.default = _default;

/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"
})), 'Settings');

exports.default = _default;

/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7-7H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-1.75 9c0 .23-.02.46-.05.68l1.48 1.16c.13.11.17.3.08.45l-1.4 2.42c-.09.15-.27.21-.43.15l-1.74-.7c-.36.28-.76.51-1.18.69l-.26 1.85c-.03.17-.18.3-.35.3h-2.8c-.17 0-.32-.13-.35-.29l-.26-1.85c-.43-.18-.82-.41-1.18-.69l-1.74.7c-.16.06-.34 0-.43-.15l-1.4-2.42c-.09-.15-.05-.34.08-.45l1.48-1.16c-.03-.23-.05-.46-.05-.69 0-.23.02-.46.05-.68l-1.48-1.16c-.13-.11-.17-.3-.08-.45l1.4-2.42c.09-.15.27-.21.43-.15l1.74.7c.36-.28.76-.51 1.18-.69l.26-1.85c.03-.17.18-.3.35-.3h2.8c.17 0 .32.13.35.29l.26 1.85c.43.18.82.41 1.18.69l1.74-.7c.16-.06.34 0 .43.15l1.4 2.42c.09.15.05.34-.08.45l-1.48 1.16c.03.23.05.46.05.69z"
})), 'SettingsApplications');

exports.default = _default;

/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M14 12c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2zm-2-9c-4.97 0-9 4.03-9 9H0l4 4 4-4H5c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.51 0-2.91-.49-4.06-1.3l-1.42 1.44C8.04 20.3 9.94 21 12 21c4.97 0 9-4.03 9-9s-4.03-9-9-9z"
})), 'SettingsBackupRestore');

exports.default = _default;

/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11 24h2v-2h-2v2zm-4 0h2v-2H7v2zm8 0h2v-2h-2v2zm2.71-18.29L12 0h-1v7.59L6.41 3 5 4.41 10.59 10 5 15.59 6.41 17 11 12.41V20h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 3.83l1.88 1.88L13 7.59V3.83zm1.88 10.46L13 16.17v-3.76l1.88 1.88z"
})), 'SettingsBluetooth');

exports.default = _default;

/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02zM8 16h2.5l1.5 1.5 1.5-1.5H16v-2.5l1.5-1.5-1.5-1.5V8h-2.5L12 6.5 10.5 8H8v2.5L6.5 12 8 13.5V16zm4-7c1.66 0 3 1.34 3 3s-1.34 3-3 3V9z"
})), 'SettingsBrightness');

exports.default = _default;

/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 24h2v-2H7v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zM16 .01L8 0C6.9 0 6 .9 6 2v16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V2c0-1.1-.9-1.99-2-1.99zM16 16H8V4h8v12z"
})), 'SettingsCell');

exports.default = _default;

/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7.77 6.76L6.23 5.48.82 12l5.41 6.52 1.54-1.28L3.42 12l4.35-5.24zM7 13h2v-2H7v2zm10-2h-2v2h2v-2zm-6 2h2v-2h-2v2zm6.77-7.52l-1.54 1.28L20.58 12l-4.35 5.24 1.54 1.28L23.18 12l-5.41-6.52z"
})), 'SettingsEthernet');

exports.default = _default;

/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 5c-3.87 0-7 3.13-7 7h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.87-3.13-7-7-7zm1 9.29c.88-.39 1.5-1.26 1.5-2.29 0-1.38-1.12-2.5-2.5-2.5S9.5 10.62 9.5 12c0 1.02.62 1.9 1.5 2.29v3.3L7.59 21 9 22.41l3-3 3 3L16.41 21 13 17.59v-3.3zM12 1C5.93 1 1 5.93 1 12h2c0-4.97 4.03-9 9-9s9 4.03 9 9h2c0-6.07-4.93-11-11-11z"
})), 'SettingsInputAntenna');

exports.default = _default;

/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M5 2c0-.55-.45-1-1-1s-1 .45-1 1v4H1v6h6V6H5V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2H9v2zm-8 0c0 1.3.84 2.4 2 2.82V23h2v-4.18C6.16 18.4 7 17.3 7 16v-2H1v2zM21 6V2c0-.55-.45-1-1-1s-1 .45-1 1v4h-2v6h6V6h-2zm-8-4c0-.55-.45-1-1-1s-1 .45-1 1v4H9v6h6V6h-2V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2h-6v2z"
})), 'SettingsInputComponent');

exports.default = _default;

/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M5 2c0-.55-.45-1-1-1s-1 .45-1 1v4H1v6h6V6H5V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2H9v2zm-8 0c0 1.3.84 2.4 2 2.82V23h2v-4.18C6.16 18.4 7 17.3 7 16v-2H1v2zM21 6V2c0-.55-.45-1-1-1s-1 .45-1 1v4h-2v6h6V6h-2zm-8-4c0-.55-.45-1-1-1s-1 .45-1 1v4H9v6h6V6h-2V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2h-6v2z"
})), 'SettingsInputComposite');

exports.default = _default;

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 7V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v3H5v6l3 6v3h8v-3l3-6V7h-1zM8 4h8v3h-2V5h-1v2h-2V5h-1v2H8V4z"
})), 'SettingsInputHdmi');

exports.default = _default;

/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M8 11.5c0-.83-.67-1.5-1.5-1.5S5 10.67 5 11.5 5.67 13 6.5 13 8 12.33 8 11.5zm7-5c0-.83-.67-1.5-1.5-1.5h-3C9.67 5 9 5.67 9 6.5S9.67 8 10.5 8h3c.83 0 1.5-.67 1.5-1.5zM8.5 15c-.83 0-1.5.67-1.5 1.5S7.67 18 8.5 18s1.5-.67 1.5-1.5S9.33 15 8.5 15zM12 1C5.93 1 1 5.93 1 12s4.93 11 11 11 11-4.93 11-11S18.07 1 12 1zm0 20c-4.96 0-9-4.04-9-9s4.04-9 9-9 9 4.04 9 9-4.04 9-9 9zm5.5-11c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm-2 5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"
})), 'SettingsInputSvideo');

exports.default = _default;

/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12.01 5.5L10 8h4l-1.99-2.5zM18 10v4l2.5-1.99L18 10zM6 10l-2.5 2.01L6 14v-4zm8 6h-4l2.01 2.5L14 16zm7-13H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z"
})), 'SettingsOverscan');

exports.default = _default;

/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13 9h-2v2h2V9zm4 0h-2v2h2V9zm3 6.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.58l2.2-2.21c.28-.27.36-.66.25-1.01C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM19 9v2h2V9h-2z"
})), 'SettingsPhone');

exports.default = _default;

/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15 9H9c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V10c0-.55-.45-1-1-1zm-3 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM7.05 6.05l1.41 1.41C9.37 6.56 10.62 6 12 6s2.63.56 3.54 1.46l1.41-1.41C15.68 4.78 13.93 4 12 4s-3.68.78-4.95 2.05zM12 0C8.96 0 6.21 1.23 4.22 3.22l1.41 1.41C7.26 3.01 9.51 2 12 2s4.74 1.01 6.36 2.64l1.41-1.41C17.79 1.23 15.04 0 12 0z"
})), 'SettingsRemote');

exports.default = _default;

/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9 16h6.5c1.38 0 2.5-1.12 2.5-2.5S16.88 11 15.5 11h-.05c-.24-1.69-1.69-3-3.45-3-1.4 0-2.6.83-3.16 2.02h-.16C7.17 10.18 6 11.45 6 13c0 1.66 1.34 3 3 3zM21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z"
})), 'SettingsSystemDaydream');

exports.default = _default;

/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 24h2v-2H7v2zm5-11c1.66 0 2.99-1.34 2.99-3L15 4c0-1.66-1.34-3-3-3S9 2.34 9 4v6c0 1.66 1.34 3 3 3zm-1 11h2v-2h-2v2zm4 0h2v-2h-2v2zm4-14h-1.7c0 3-2.54 5.1-5.3 5.1S6.7 13 6.7 10H5c0 3.41 2.72 6.23 6 6.72V20h2v-3.28c3.28-.49 6-3.31 6-6.72z"
})), 'SettingsVoice');

exports.default = _default;

/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z"
})), 'Share');

exports.default = _default;

/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16 6V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H2v13c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6h-6zm-6-2h4v2h-4V4zM9 18V9l7.5 4L9 18z"
})), 'Shop');

exports.default = _default;

/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17.21 9l-4.38-6.56c-.19-.28-.51-.42-.83-.42-.32 0-.64.14-.83.43L6.79 9H2c-.55 0-1 .45-1 1 0 .09.01.18.04.27l2.54 9.27c.23.84 1 1.46 1.92 1.46h13c.92 0 1.69-.62 1.93-1.46l2.54-9.27L23 10c0-.55-.45-1-1-1h-4.79zM9 9l3-4.4L15 9H9zm3 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
})), 'ShoppingBasket');

exports.default = _default;

/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"
})), 'ShoppingCart');

exports.default = _default;

/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 9H1v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2H3V9zm15-4V3c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H5v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2V5h-5zm-6-2h4v2h-4V3zm0 12V8l5.5 3-5.5 4z"
})), 'ShopTwo');

exports.default = _default;

/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 9h16v2H4zm0 4h10v2H4z"
})), 'ShortText');

exports.default = _default;

/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3.5 18.49l6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99z"
})), 'ShowChart');

exports.default = _default;

/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10.59 9.17L5.41 4 4 5.41l5.17 5.17 1.42-1.41zM14.5 4l2.04 2.04L4 18.59 5.41 20 17.96 7.46 20 9.5V4h-5.5zm.33 9.41l-1.41 1.41 3.13 3.13L14.5 20H20v-5.5l-2.04 2.04-3.13-3.13z"
})), 'Shuffle');

exports.default = _default;

/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M2 22h20V2z"
})), 'SignalCellular0Bar');

exports.default = _default;

/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M2 22h20V2z"
}), _react.default.createElement("path", {
  d: "M12 12L2 22h10z"
})), 'SignalCellular1Bar');

exports.default = _default;

/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M2 22h20V2z"
}), _react.default.createElement("path", {
  d: "M14 10L2 22h12z"
})), 'SignalCellular2Bar');

exports.default = _default;

/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M2 22h20V2z"
}), _react.default.createElement("path", {
  d: "M17 7L2 22h15z"
})), 'SignalCellular3Bar');

exports.default = _default;

/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M2 22h20V2z"
})), 'SignalCellular4Bar');

exports.default = _default;

/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M22 8V2L2 22h16V8z"
}), _react.default.createElement("path", {
  d: "M20 22h2v-2h-2v2zm0-12v8h2v-8h-2z"
})), 'SignalCellularConnectedNoInternet0Bar');

exports.default = _default;

/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M22 8V2L2 22h16V8z"
}), _react.default.createElement("path", {
  d: "M20 10v8h2v-8h-2zm-8 12V12L2 22h10zm8 0h2v-2h-2v2z"
})), 'SignalCellularConnectedNoInternet1Bar');

exports.default = _default;

/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M22 8V2L2 22h16V8z"
}), _react.default.createElement("path", {
  d: "M14 22V10L2 22h12zm6-12v8h2v-8h-2zm0 12h2v-2h-2v2z"
})), 'SignalCellularConnectedNoInternet2Bar');

exports.default = _default;

/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M22 8V2L2 22h16V8z"
}), _react.default.createElement("path", {
  d: "M17 22V7L2 22h15zm3-12v8h2v-8h-2zm0 12h2v-2h-2v2z"
})), 'SignalCellularConnectedNoInternet3Bar');

exports.default = _default;

/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 18h2v-8h-2v8zm0 4h2v-2h-2v2zM2 22h16V8h4V2L2 22z"
})), 'SignalCellularConnectedNoInternet4Bar');

exports.default = _default;

/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18.99 5c0-1.1-.89-2-1.99-2h-7L7.66 5.34 19 16.68 18.99 5zM3.65 3.88L2.38 5.15 5 7.77V19c0 1.1.9 2 2 2h10.01c.35 0 .67-.1.96-.26l1.88 1.88 1.27-1.27L3.65 3.88z"
})), 'SignalCellularNoSim');

exports.default = _default;

/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 6.83V20H6.83L20 6.83M22 2L2 22h20V2z"
})), 'SignalCellularNull');

exports.default = _default;

/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 1l-8.59 8.59L21 18.18V1zM4.77 4.5L3.5 5.77l6.36 6.36L1 21h17.73l2 2L22 21.73 4.77 4.5z"
})), 'SignalCellularOff');

exports.default = _default;

/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"
})), 'SignalWifi0Bar');

exports.default = _default;

/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"
}), _react.default.createElement("path", {
  d: "M6.67 14.86L12 21.49v.01l.01-.01 5.33-6.63C17.06 14.65 15.03 13 12 13s-5.06 1.65-5.33 1.86z"
})), 'SignalWifi1Bar');

exports.default = _default;

/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16z"
}), _react.default.createElement("path", {
  d: "M15.5 14.5c0-2.8 2.2-5 5-5 .4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4C5.3 3 .8 6.7.4 7L12 21.5l3.5-4.3v-2.7z",
  opacity: ".3"
}), _react.default.createElement("path", {
  d: "M6.7 14.9l5.3 6.6 3.5-4.3v-2.6c0-.2 0-.5.1-.7-.9-.5-2.2-.9-3.6-.9-3 0-5.1 1.7-5.3 1.9z"
})), 'SignalWifi1BarLock');

exports.default = _default;

/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"
}), _react.default.createElement("path", {
  d: "M4.79 12.52l7.2 8.98H12l.01-.01 7.2-8.98C18.85 12.24 16.1 10 12 10s-6.85 2.24-7.21 2.52z"
})), 'SignalWifi2Bar');

exports.default = _default;

/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16z"
}), _react.default.createElement("path", {
  d: "M15.5 14.5c0-2.8 2.2-5 5-5 .4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4C5.3 3 .8 6.7.4 7L12 21.5l3.5-4.3v-2.7z",
  opacity: ".3"
}), _react.default.createElement("path", {
  d: "M4.8 12.5l7.2 9 3.5-4.4v-2.6c0-1.3.5-2.5 1.4-3.4C15.6 10.5 14 10 12 10c-4.1 0-6.8 2.2-7.2 2.5z"
})), 'SignalWifi2BarLock');

exports.default = _default;

/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  fillOpacity: ".3",
  d: "M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"
}), _react.default.createElement("path", {
  d: "M3.53 10.95l8.46 10.54.01.01.01-.01 8.46-10.54C20.04 10.62 16.81 8 12 8c-4.81 0-8.04 2.62-8.47 2.95z"
})), 'SignalWifi3Bar');

exports.default = _default;

/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  opacity: ".3",
  d: "M12 3C5.3 3 .8 6.7.4 7l3.2 3.9L12 21.5l3.5-4.3v-2.6c0-2.2 1.4-4 3.3-4.7.3-.1.5-.2.8-.2.3-.1.6-.1.9-.1.4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4z"
}), _react.default.createElement("path", {
  d: "M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16zm-10 5.5l3.5-4.3v-2.6c0-2.2 1.4-4 3.3-4.7C17.3 9 14.9 8 12 8c-4.8 0-8 2.6-8.5 2.9"
})), 'SignalWifi3BarLock');

exports.default = _default;

/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"
})), 'SignalWifi4Bar');

exports.default = _default;

/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16zm-6.5-1.5c0-2.8 2.2-5 5-5 .4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4C5.3 3 .8 6.7.4 7L12 21.5l3.5-4.4v-2.6z"
})), 'SignalWifi4BarLock');

exports.default = _default;

/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M23.64 7c-.45-.34-4.93-4-11.64-4-1.5 0-2.89.19-4.15.48L18.18 13.8 23.64 7zm-6.6 8.22L3.27 1.44 2 2.72l2.05 2.06C1.91 5.76.59 6.82.36 7l11.63 14.49.01.01.01-.01 3.9-4.86 3.32 3.32 1.27-1.27-3.46-3.46z"
})), 'SignalWifiOff');

exports.default = _default;

/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5 15h-2v-2h2v2zm0-4h-2V8h2v5z"
})), 'SimCardAlert');

exports.default = _default;

/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z"
})), 'SkipNext');

exports.default = _default;

/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6 6h2v12H6zm3.5 6l8.5 6V6z"
})), 'SkipPrevious');

exports.default = _default;

/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 8v8l5-4-5-4zm9-5H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
})), 'Slideshow');

exports.default = _default;

/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13.05 9.79L10 7.5v9l3.05-2.29L16 12zm0 0L10 7.5v9l3.05-2.29L16 12zm0 0L10 7.5v9l3.05-2.29L16 12zM11 4.07V2.05c-2.01.2-3.84 1-5.32 2.21L7.1 5.69c1.11-.86 2.44-1.44 3.9-1.62zM5.69 7.1L4.26 5.68C3.05 7.16 2.25 8.99 2.05 11h2.02c.18-1.46.76-2.79 1.62-3.9zM4.07 13H2.05c.2 2.01 1 3.84 2.21 5.32l1.43-1.43c-.86-1.1-1.44-2.43-1.62-3.89zm1.61 6.74C7.16 20.95 9 21.75 11 21.95v-2.02c-1.46-.18-2.79-.76-3.9-1.62l-1.42 1.43zM22 12c0 5.16-3.92 9.42-8.95 9.95v-2.02C16.97 19.41 20 16.05 20 12s-3.03-7.41-6.95-7.93V2.05C18.08 2.58 22 6.84 22 12z"
})), 'SlowMotionVideo');

exports.default = _default;

/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
})), 'Smartphone');

exports.default = _default;

/***/ }),
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M2 6l6.99 7H2v3h9.99l7 7 1.26-1.25-17-17zm18.5 7H22v3h-1.5zM18 13h1.5v3H18zm.85-8.12c.62-.61 1-1.45 1-2.38h-1.5c0 1.02-.83 1.85-1.85 1.85v1.5c2.24 0 4 1.83 4 4.07V12H22V9.92c0-2.23-1.28-4.15-3.15-5.04zM14.5 8.7h1.53c1.05 0 1.97.74 1.97 2.05V12h1.5v-1.59c0-1.8-1.6-3.16-3.47-3.16H14.5c-1.02 0-1.85-.98-1.85-2s.83-1.75 1.85-1.75V2c-1.85 0-3.35 1.5-3.35 3.35s1.5 3.35 3.35 3.35zm2.5 7.23V13h-2.93z"
})), 'SmokeFree');

exports.default = _default;

/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M2 16h15v3H2zm18.5 0H22v3h-1.5zM18 16h1.5v3H18zm.85-8.27c.62-.61 1-1.45 1-2.38C19.85 3.5 18.35 2 16.5 2v1.5c1.02 0 1.85.83 1.85 1.85S17.52 7.2 16.5 7.2v1.5c2.24 0 4 1.83 4 4.07V15H22v-2.24c0-2.22-1.28-4.14-3.15-5.03zm-2.82 2.47H14.5c-1.02 0-1.85-.98-1.85-2s.83-1.75 1.85-1.75v-1.5c-1.85 0-3.35 1.5-3.35 3.35s1.5 3.35 3.35 3.35h1.53c1.05 0 1.97.74 1.97 2.05V15h1.5v-1.64c0-1.81-1.6-3.16-3.47-3.16z"
})), 'SmokingRooms');

exports.default = _default;

/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z"
})), 'Sms');

exports.default = _default;

/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 12h-2v-2h2v2zm0-4h-2V6h2v4z"
})), 'SmsFailed');

exports.default = _default;

/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm-3-9h3.63L9 15.2V17h6v-2h-3.63L15 10.8V9H9v2z"
})), 'Snooze');

exports.default = _default;

/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 18h6v-2H3v2zM3 6v2h18V6H3zm0 7h12v-2H3v2z"
})), 'Sort');

exports.default = _default;

/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M14.94 4.66h-4.72l2.36-2.36zm-4.69 14.71h4.66l-2.33 2.33zM6.1 6.27L1.6 17.73h1.84l.92-2.45h5.11l.92 2.45h1.84L7.74 6.27H6.1zm-1.13 7.37l1.94-5.18 1.94 5.18H4.97zm10.76 2.5h6.12v1.59h-8.53v-1.29l5.92-8.56h-5.88v-1.6h8.3v1.26l-5.93 8.6z"
})), 'SortByAlpha');

exports.default = _default;

/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M8.55 12c-1.07-.71-2.25-1.27-3.53-1.61 1.28.34 2.46.9 3.53 1.61zm10.43-1.61c-1.29.34-2.49.91-3.57 1.64 1.08-.73 2.28-1.3 3.57-1.64z"
}), _react.default.createElement("path", {
  d: "M15.49 9.63c-.18-2.79-1.31-5.51-3.43-7.63-2.14 2.14-3.32 4.86-3.55 7.63 1.28.68 2.46 1.56 3.49 2.63 1.03-1.06 2.21-1.94 3.49-2.63zm-6.5 2.65c-.14-.1-.3-.19-.45-.29.15.11.31.19.45.29zm6.42-.25c-.13.09-.27.16-.4.26.13-.1.27-.17.4-.26zM12 15.45C9.85 12.17 6.18 10 2 10c0 5.32 3.36 9.82 8.03 11.49.63.23 1.29.4 1.97.51.68-.12 1.33-.29 1.97-.51C18.64 19.82 22 15.32 22 10c-4.18 0-7.85 2.17-10 5.45z"
})), 'Spa');

exports.default = _default;

/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 9v4H6V9H4v6h16V9z"
})), 'SpaceBar');

exports.default = _default;

/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 2H7c-1.1 0-2 .9-2 2v16c0 1.1.9 1.99 2 1.99L17 22c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5 2c1.1 0 2 .9 2 2s-.9 2-2 2c-1.11 0-2-.9-2-2s.89-2 2-2zm0 16c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
})), 'Speaker');

exports.default = _default;

/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18.2 1H9.8C8.81 1 8 1.81 8 2.8v14.4c0 .99.81 1.79 1.8 1.79l8.4.01c.99 0 1.8-.81 1.8-1.8V2.8c0-.99-.81-1.8-1.8-1.8zM14 3c1.1 0 2 .89 2 2s-.9 2-2 2-2-.89-2-2 .9-2 2-2zm0 13.5c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
}), _react.default.createElement("circle", {
  cx: "14",
  cy: "12.5",
  r: "2.5"
}), _react.default.createElement("path", {
  d: "M6 5H4v16c0 1.1.89 2 2 2h10v-2H6V5z"
})), 'SpeakerGroup');

exports.default = _default;

/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 14H6v-2h2v2zm0-3H6V9h2v2zm0-3H6V6h2v2zm7 6h-5v-2h5v2zm3-3h-8V9h8v2zm0-3h-8V6h8v2z"
})), 'SpeakerNotes');

exports.default = _default;

/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10.54 11l-.54-.54L7.54 8 6 6.46 2.38 2.84 1.27 1.73 0 3l2.01 2.01L2 22l4-4h9l5.73 5.73L22 22.46 17.54 18l-7-7zM8 14H6v-2h2v2zm-2-3V9l2 2H6zm14-9H4.08L10 7.92V6h8v2h-7.92l1 1H18v2h-4.92l6.99 6.99C21.14 17.95 22 17.08 22 16V4c0-1.1-.9-2-2-2z"
})), 'SpeakerNotesOff');

exports.default = _default;

/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 7.07L8.43 8.5c.91-.91 2.18-1.48 3.57-1.48s2.66.57 3.57 1.48L17 7.07C15.72 5.79 13.95 5 12 5s-3.72.79-5 2.07zM12 1C8.98 1 6.24 2.23 4.25 4.21l1.41 1.41C7.28 4 9.53 3 12 3s4.72 1 6.34 2.62l1.41-1.41C17.76 2.23 15.02 1 12 1zm2.86 9.01L9.14 10C8.51 10 8 10.51 8 11.14v9.71c0 .63.51 1.14 1.14 1.14h5.71c.63 0 1.14-.51 1.14-1.14v-9.71c.01-.63-.5-1.13-1.13-1.13zM15 20H9v-8h6v8z"
})), 'SpeakerPhone');

exports.default = _default;

/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12.45 16h2.09L9.43 3H7.57L2.46 16h2.09l1.12-3h5.64l1.14 3zm-6.02-5L8.5 5.48 10.57 11H6.43zm15.16.59l-8.09 8.09L9.83 16l-1.41 1.41 5.09 5.09L23 13l-1.41-1.41z"
})), 'Spellcheck');

exports.default = _default;

/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
})), 'Star');

exports.default = _default;

/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
})), 'StarBorder');

exports.default = _default;

/***/ }),
/* 1907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4V6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
})), 'StarHalf');

exports.default = _default;

/***/ }),
/* 1908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm4.24 16L12 15.45 7.77 18l1.12-4.81-3.73-3.23 4.92-.42L12 5l1.92 4.53 4.92.42-3.73 3.23L16.23 18z"
})), 'Stars');

exports.default = _default;

/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M1.01 7L1 17c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H3c-1.1 0-1.99.9-1.99 2zM19 7v10H5V7h14z"
})), 'StayCurrentLandscape');

exports.default = _default;

/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
})), 'StayCurrentPortrait');

exports.default = _default;

/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M1.01 7L1 17c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H3c-1.1 0-1.99.9-1.99 2zM19 7v10H5V7h14z"
})), 'StayPrimaryLandscape');

exports.default = _default;

/***/ }),
/* 1912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
})), 'StayPrimaryPortrait');

exports.default = _default;

/***/ }),
/* 1913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6 6h12v12H6z"
})), 'Stop');

exports.default = _default;

/***/ }),
/* 1914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21.22 18.02l2 2H24v-2h-2.78zm.77-2l.01-10c0-1.11-.9-2-2-2H7.22l5.23 5.23c.18-.04.36-.07.55-.1V7.02l4 3.73-1.58 1.47 5.54 5.54c.61-.33 1.03-.99 1.03-1.74zM2.39 1.73L1.11 3l1.54 1.54c-.4.36-.65.89-.65 1.48v10c0 1.1.89 2 2 2H0v2h18.13l2.71 2.71 1.27-1.27L2.39 1.73zM7 15.02c.31-1.48.92-2.95 2.07-4.06l1.59 1.59c-1.54.38-2.7 1.18-3.66 2.47z"
})), 'StopScreenShare');

exports.default = _default;

/***/ }),
/* 1915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M2 20h20v-4H2v4zm2-3h2v2H4v-2zM2 4v4h20V4H2zm4 3H4V5h2v2zm-4 7h20v-4H2v4zm2-3h2v2H4v-2z"
})), 'Storage');

exports.default = _default;

/***/ }),
/* 1916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z"
})), 'Store');

exports.default = _default;

/***/ }),
/* 1917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z"
})), 'StoreMallDirectory');

exports.default = _default;

/***/ }),
/* 1918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H3V8h2v4h2V8h2v4h2V8h2v4h2V8h2v4h2V8h2v8z"
})), 'Straighten');

exports.default = _default;

/***/ }),
/* 1919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12.56 14.33c-.34.27-.56.7-.56 1.17V21h7c1.1 0 2-.9 2-2v-5.98c-.94-.33-1.95-.52-3-.52-2.03 0-3.93.7-5.44 1.83z"
}), _react.default.createElement("circle", {
  cx: "18",
  cy: "6",
  r: "5"
}), _react.default.createElement("path", {
  d: "M11.5 6c0-1.08.27-2.1.74-3H5c-1.1 0-2 .9-2 2v14c0 .55.23 1.05.59 1.41l9.82-9.82C12.23 9.42 11.5 7.8 11.5 6z"
})), 'Streetview');

exports.default = _default;

/***/ }),
/* 1920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7.24 8.75c-.26-.48-.39-1.03-.39-1.67 0-.61.13-1.16.4-1.67.26-.5.63-.93 1.11-1.29.48-.35 1.05-.63 1.7-.83.66-.19 1.39-.29 2.18-.29.81 0 1.54.11 2.21.34.66.22 1.23.54 1.69.94.47.4.83.88 1.08 1.43.25.55.38 1.15.38 1.81h-3.01c0-.31-.05-.59-.15-.85-.09-.27-.24-.49-.44-.68-.2-.19-.45-.33-.75-.44-.3-.1-.66-.16-1.06-.16-.39 0-.74.04-1.03.13-.29.09-.53.21-.72.36-.19.16-.34.34-.44.55-.1.21-.15.43-.15.66 0 .48.25.88.74 1.21.38.25.77.48 1.41.7H7.39c-.05-.08-.11-.17-.15-.25zM21 12v-2H3v2h9.62c.18.07.4.14.55.2.37.17.66.34.87.51.21.17.35.36.43.57.07.2.11.43.11.69 0 .23-.05.45-.14.66-.09.2-.23.38-.42.53-.19.15-.42.26-.71.35-.29.08-.63.13-1.01.13-.43 0-.83-.04-1.18-.13s-.66-.23-.91-.42c-.25-.19-.45-.44-.59-.75-.14-.31-.25-.76-.25-1.21H6.4c0 .55.08 1.13.24 1.58.16.45.37.85.65 1.21.28.35.6.66.98.92.37.26.78.48 1.22.65.44.17.9.3 1.38.39.48.08.96.13 1.44.13.8 0 1.53-.09 2.18-.28s1.21-.45 1.67-.79c.46-.34.82-.77 1.07-1.27s.38-1.07.38-1.71c0-.6-.1-1.14-.31-1.61-.05-.11-.11-.23-.17-.33H21z"
})), 'StrikethroughS');

exports.default = _default;

/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11 9l1.42 1.42L8.83 14H18V4h2v12H8.83l3.59 3.58L11 21l-6-6 6-6z"
})), 'SubdirectoryArrowLeft');

exports.default = _default;

/***/ }),
/* 1922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 15l-6 6-1.42-1.42L15.17 16H4V4h2v10h9.17l-3.59-3.58L13 9l6 6z"
})), 'SubdirectoryArrowRight');

exports.default = _default;

/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M14 17H4v2h10v-2zm6-8H4v2h16V9zM4 15h16v-2H4v2zM4 5v2h16V5H4z"
})), 'Subject');

exports.default = _default;

/***/ }),
/* 1924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 8H4V6h16v2zm-2-6H6v2h12V2zm4 10v8c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-8c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2zm-6 4l-6-3.27v6.53L16 16z"
})), 'Subscriptions');

exports.default = _default;

/***/ }),
/* 1925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 12h4v2H4v-2zm10 6H4v-2h10v2zm6 0h-4v-2h4v2zm0-4H10v-2h10v2z"
})), 'Subtitles');

exports.default = _default;

/***/ }),
/* 1926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("circle", {
  cx: "15.5",
  cy: "16",
  r: "1"
}), _react.default.createElement("circle", {
  cx: "8.5",
  cy: "16",
  r: "1"
}), _react.default.createElement("path", {
  d: "M7.01 9h10v5h-10zM17.8 2.8C16 2.09 13.86 2 12 2c-1.86 0-4 .09-5.8.8C3.53 3.84 2 6.05 2 8.86V22h20V8.86c0-2.81-1.53-5.02-4.2-6.06zm.2 13.08c0 1.45-1.18 2.62-2.63 2.62l1.13 1.12V20H15l-1.5-1.5h-2.83L9.17 20H7.5v-.38l1.12-1.12C7.18 18.5 6 17.32 6 15.88V9c0-2.63 3-3 6-3 3.32 0 6 .38 6 3v6.88z"
})), 'Subway');

exports.default = _default;

/***/ }),
/* 1927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7.76 16.24l-1.41 1.41C4.78 16.1 4 14.05 4 12c0-2.05.78-4.1 2.34-5.66l1.41 1.41C6.59 8.93 6 10.46 6 12s.59 3.07 1.76 4.24zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm5.66 1.66l-1.41-1.41C17.41 15.07 18 13.54 18 12s-.59-3.07-1.76-4.24l1.41-1.41C19.22 7.9 20 9.95 20 12c0 2.05-.78 4.1-2.34 5.66zM12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
})), 'SurroundSound');

exports.default = _default;

/***/ }),
/* 1928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 4l-4 4h3v7c0 1.1-.9 2-2 2s-2-.9-2-2V8c0-2.21-1.79-4-4-4S5 5.79 5 8v7H2l4 4 4-4H7V8c0-1.1.9-2 2-2s2 .9 2 2v7c0 2.21 1.79 4 4 4s4-1.79 4-4V8h3l-4-4z"
})), 'SwapCalls');

exports.default = _default;

/***/ }),
/* 1929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z"
})), 'SwapHoriz');

exports.default = _default;

/***/ }),
/* 1930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z"
})), 'SwapVert');

exports.default = _default;

/***/ }),
/* 1931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM6.5 9L10 5.5 13.5 9H11v4H9V9H6.5zm11 6L14 18.5 10.5 15H13v-4h2v4h2.5z"
})), 'SwapVerticalCircle');

exports.default = _default;

/***/ }),
/* 1932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 11.5V13H9v2.5L5.5 12 9 8.5V11h6V8.5l3.5 3.5-3.5 3.5z"
})), 'SwitchCamera');

exports.default = _default;

/***/ }),
/* 1933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 9.5V6c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-3.5l4 4v-13l-4 4zm-5 6V13H7v2.5L3.5 12 7 8.5V11h6V8.5l3.5 3.5-3.5 3.5z"
})), 'SwitchVideo');

exports.default = _default;

/***/ }),
/* 1934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
})), 'Sync');

exports.default = _default;

/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 6.35V4.26c-.8.21-1.55.54-2.23.96l1.46 1.46c.25-.12.5-.24.77-.33zm-7.14-.94l2.36 2.36C4.45 8.99 4 10.44 4 12c0 2.21.91 4.2 2.36 5.64L4 20h6v-6l-2.24 2.24C6.68 15.15 6 13.66 6 12c0-1 .25-1.94.68-2.77l8.08 8.08c-.25.13-.5.25-.77.34v2.09c.8-.21 1.55-.54 2.23-.96l2.36 2.36 1.27-1.27L4.14 4.14 2.86 5.41zM20 4h-6v6l2.24-2.24C17.32 8.85 18 10.34 18 12c0 1-.25 1.94-.68 2.77l1.46 1.46C19.55 15.01 20 13.56 20 12c0-2.21-.91-4.2-2.36-5.64L20 4z"
})), 'SyncDisabled');

exports.default = _default;

/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 12c0 2.21.91 4.2 2.36 5.64L3 20h6v-6l-2.24 2.24C5.68 15.15 5 13.66 5 12c0-2.61 1.67-4.83 4-5.65V4.26C5.55 5.15 3 8.27 3 12zm8 5h2v-2h-2v2zM21 4h-6v6l2.24-2.24C18.32 8.85 19 10.34 19 12c0 2.61-1.67 4.83-4 5.65v2.09c3.45-.89 6-4.01 6-7.74 0-2.21-.91-4.2-2.36-5.64L21 4zm-10 9h2V7h-2v6z"
})), 'SyncProblem');

exports.default = _default;

/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14zm-1-6h-3V8h-2v5H8l4 4 4-4z"
})), 'SystemUpdate');

exports.default = _default;

/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 16.5l4-4h-3v-9h-2v9H8l4 4zm9-13h-6v1.99h6v14.03H3V5.49h6V3.5H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2z"
})), 'SystemUpdateAlt');

exports.default = _default;

/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h10v4h8v10z"
})), 'Tab');

exports.default = _default;

/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 1.99-.9 1.99-2L23 6c0-1.1-.9-2-2-2zm-2 14H5V6h14v12z"
})), 'Tablet');

exports.default = _default;

/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 0H6C4.34 0 3 1.34 3 3v18c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V3c0-1.66-1.34-3-3-3zm-4 22h-4v-1h4v1zm5.25-3H4.75V3h14.5v16z"
})), 'TabletAndroid');

exports.default = _default;

/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18.5 0h-14C3.12 0 2 1.12 2 2.5v19C2 22.88 3.12 24 4.5 24h14c1.38 0 2.5-1.12 2.5-2.5v-19C21 1.12 19.88 0 18.5 0zm-7 23c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm7.5-4H4V3h15v16z"
})), 'TabletMac');

exports.default = _default;

/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M1 9h2V7H1v2zm0 4h2v-2H1v2zm0-8h2V3c-1.1 0-2 .9-2 2zm8 16h2v-2H9v2zm-8-4h2v-2H1v2zm2 4v-2H1c0 1.1.9 2 2 2zM21 3h-8v6h10V5c0-1.1-.9-2-2-2zm0 14h2v-2h-2v2zM9 5h2V3H9v2zM5 21h2v-2H5v2zM5 5h2V3H5v2zm16 16c1.1 0 2-.9 2-2h-2v2zm0-8h2v-2h-2v2zm-8 8h2v-2h-2v2zm4 0h2v-2h-2v2z"
})), 'TabUnselected');

exports.default = _default;

/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
})), 'TagFaces');

exports.default = _default;

/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M2 16v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0 4v3h3c0-1.66-1.34-3-3-3zm0-8v2c4.97 0 9 4.03 9 9h2c0-6.08-4.92-11-11-11zM17 1.01L7 1c-1.1 0-2 .9-2 2v7.37c.69.16 1.36.37 2 .64V5h10v13h-3.03c.52 1.25.84 2.59.95 4H17c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99z"
})), 'TapAndPlay');

exports.default = _default;

/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z"
})), 'Terrain');

exports.default = _default;

/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M2.5 4v3h5v12h3V7h5V4h-13zm19 5h-9v3h3v7h3v-7h3V9z"
})), 'TextFields');

exports.default = _default;

/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M5 17v2h14v-2H5zm4.5-4.2h5l.9 2.2h2.1L12.75 4h-1.5L6.5 15h2.1l.9-2.2zM12 5.98L13.87 11h-3.74L12 5.98z"
})), 'TextFormat');

exports.default = _default;

/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z"
})), 'Textsms');

exports.default = _default;

/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.51 3.08L3.08 19.51c.09.34.27.65.51.9.25.24.56.42.9.51L20.93 4.49c-.19-.69-.73-1.23-1.42-1.41zM11.88 3L3 11.88v2.83L14.71 3h-2.83zM5 3c-1.1 0-2 .9-2 2v2l4-4H5zm14 18c.55 0 1.05-.22 1.41-.59.37-.36.59-.86.59-1.41v-2l-4 4h2zm-9.71 0h2.83L21 12.12V9.29L9.29 21z"
})), 'Texture');

exports.default = _default;

/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm10 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z"
})), 'Theaters');

exports.default = _default;

/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7.52 21.48C4.25 19.94 1.91 16.76 1.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.81-1.33 1.32zm.89-6.52c-.19 0-.37-.03-.52-.08-.16-.06-.29-.13-.4-.24-.11-.1-.2-.22-.26-.37-.06-.14-.09-.3-.09-.47h-1.3c0 .36.07.68.21.95.14.27.33.5.56.69.24.18.51.32.82.41.3.1.62.15.96.15.37 0 .72-.05 1.03-.15.32-.1.6-.25.83-.44s.42-.43.55-.72c.13-.29.2-.61.2-.97 0-.19-.02-.38-.07-.56-.05-.18-.12-.35-.23-.51-.1-.16-.24-.3-.4-.43-.17-.13-.37-.23-.61-.31.2-.09.37-.2.52-.33.15-.13.27-.27.37-.42.1-.15.17-.3.22-.46.05-.16.07-.32.07-.48 0-.36-.06-.68-.18-.96-.12-.28-.29-.51-.51-.69-.2-.19-.47-.33-.77-.43C9.1 8.05 8.76 8 8.39 8c-.36 0-.69.05-1 .16-.3.11-.57.26-.79.45-.21.19-.38.41-.51.67-.12.26-.18.54-.18.85h1.3c0-.17.03-.32.09-.45s.14-.25.25-.34c.11-.09.23-.17.38-.22.15-.05.3-.08.48-.08.4 0 .7.1.89.31.19.2.29.49.29.86 0 .18-.03.34-.08.49-.05.15-.14.27-.25.37-.11.1-.25.18-.41.24-.16.06-.36.09-.58.09H7.5v1.03h.77c.22 0 .42.02.6.07s.33.13.45.23c.12.11.22.24.29.4.07.16.1.35.1.57 0 .41-.12.72-.35.93-.23.23-.55.33-.95.33zm8.55-5.92c-.32-.33-.7-.59-1.14-.77-.43-.18-.92-.27-1.46-.27H12v8h2.3c.55 0 1.06-.09 1.51-.27.45-.18.84-.43 1.16-.76.32-.33.57-.73.74-1.19.17-.47.26-.99.26-1.57v-.4c0-.58-.09-1.1-.26-1.57-.18-.47-.43-.87-.75-1.2zm-.39 3.16c0 .42-.05.79-.14 1.13-.1.33-.24.62-.43.85-.19.23-.43.41-.71.53-.29.12-.62.18-.99.18h-.91V9.12h.97c.72 0 1.27.23 1.64.69.38.46.57 1.12.57 1.99v.4zM12 0l-.66.03 3.81 3.81 1.33-1.33c3.27 1.55 5.61 4.72 5.96 8.48h1.5C23.44 4.84 18.29 0 12 0z"
})), 'ThreeDRotation');

exports.default = _default;

/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v1.91l.01.01L1 14c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2zm4 0v12h4V3h-4z"
})), 'ThumbDown');

exports.default = _default;

/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 6c0-.55-.45-1-1-1H5.82l.66-3.18.02-.23c0-.31-.13-.59-.33-.8L5.38 0 .44 4.94C.17 5.21 0 5.59 0 6v6.5c0 .83.67 1.5 1.5 1.5h6.75c.62 0 1.15-.38 1.38-.91l2.26-5.29c.07-.17.11-.36.11-.55V6zm10.5 4h-6.75c-.62 0-1.15.38-1.38.91l-2.26 5.29c-.07.17-.11.36-.11.55V18c0 .55.45 1 1 1h5.18l-.66 3.18-.02.24c0 .31.13.59.33.8l.79.78 4.94-4.94c.27-.27.44-.65.44-1.06v-6.5c0-.83-.67-1.5-1.5-1.5z"
})), 'ThumbsUpDown');

exports.default = _default;

/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-1.91l-.01-.01L23 10z"
})), 'ThumbUp');

exports.default = _default;

/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M23 8c0 1.1-.9 2-2 2-.18 0-.35-.02-.51-.07l-3.56 3.55c.05.16.07.34.07.52 0 1.1-.9 2-2 2s-2-.9-2-2c0-.18.02-.36.07-.52l-2.55-2.55c-.16.05-.34.07-.52.07s-.36-.02-.52-.07l-4.55 4.56c.05.16.07.33.07.51 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.18 0 .35.02.51.07l4.56-4.55C8.02 9.36 8 9.18 8 9c0-1.1.9-2 2-2s2 .9 2 2c0 .18-.02.36-.07.52l2.55 2.55c.16-.05.34-.07.52-.07s.36.02.52.07l3.55-3.56C19.02 8.35 19 8.18 19 8c0-1.1.9-2 2-2s2 .9 2 2z"
})), 'Timeline');

exports.default = _default;

/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15 1H9v2h6V1zm-4 13h2V8h-2v6zm8.03-6.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42C16.07 4.74 14.12 4 12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9 9-4.03 9-9c0-2.12-.74-4.07-1.97-5.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
})), 'Timer');

exports.default = _default;

/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M0 7.72V9.4l3-1V18h2V6h-.25L0 7.72zm23.78 6.65c-.14-.28-.35-.53-.63-.74-.28-.21-.61-.39-1.01-.53s-.85-.27-1.35-.38c-.35-.07-.64-.15-.87-.23-.23-.08-.41-.16-.55-.25-.14-.09-.23-.19-.28-.3-.05-.11-.08-.24-.08-.39 0-.14.03-.28.09-.41.06-.13.15-.25.27-.34.12-.1.27-.18.45-.24s.4-.09.64-.09c.25 0 .47.04.66.11.19.07.35.17.48.29.13.12.22.26.29.42.06.16.1.32.1.49h1.95c0-.39-.08-.75-.24-1.09-.16-.34-.39-.63-.69-.88-.3-.25-.66-.44-1.09-.59C21.49 9.07 21 9 20.46 9c-.51 0-.98.07-1.39.21-.41.14-.77.33-1.06.57-.29.24-.51.52-.67.84-.16.32-.23.65-.23 1.01s.08.69.23.96c.15.28.36.52.64.73.27.21.6.38.98.53.38.14.81.26 1.27.36.39.08.71.17.95.26s.43.19.57.29c.13.1.22.22.27.34.05.12.07.25.07.39 0 .32-.13.57-.4.77-.27.2-.66.29-1.17.29-.22 0-.43-.02-.64-.08-.21-.05-.4-.13-.56-.24-.17-.11-.3-.26-.41-.44-.11-.18-.17-.41-.18-.67h-1.89c0 .36.08.71.24 1.05.16.34.39.65.7.93.31.27.69.49 1.15.66.46.17.98.25 1.58.25.53 0 1.01-.06 1.44-.19.43-.13.8-.31 1.11-.54.31-.23.54-.51.71-.83.17-.32.25-.67.25-1.06-.02-.4-.09-.74-.24-1.02zm-9.96-7.32c-.34-.4-.75-.7-1.23-.88-.47-.18-1.01-.27-1.59-.27-.58 0-1.11.09-1.59.27-.48.18-.89.47-1.23.88-.34.41-.6.93-.79 1.59-.18.65-.28 1.45-.28 2.39v1.92c0 .94.09 1.74.28 2.39.19.66.45 1.19.8 1.6.34.41.75.71 1.23.89.48.18 1.01.28 1.59.28.59 0 1.12-.09 1.59-.28.48-.18.88-.48 1.22-.89.34-.41.6-.94.78-1.6.18-.65.28-1.45.28-2.39v-1.92c0-.94-.09-1.74-.28-2.39-.18-.66-.44-1.19-.78-1.59zm-.92 6.17c0 .6-.04 1.11-.12 1.53-.08.42-.2.76-.36 1.02-.16.26-.36.45-.59.57-.23.12-.51.18-.82.18-.3 0-.58-.06-.82-.18s-.44-.31-.6-.57c-.16-.26-.29-.6-.38-1.02-.09-.42-.13-.93-.13-1.53v-2.5c0-.6.04-1.11.13-1.52.09-.41.21-.74.38-1 .16-.25.36-.43.6-.55.24-.11.51-.17.81-.17.31 0 .58.06.81.17.24.11.44.29.6.55.16.25.29.58.37.99.08.41.13.92.13 1.52v2.51z"
})), 'Timer10');

exports.default = _default;

/***/ }),
/* 1959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M11.61 12.97c-.16-.24-.36-.46-.62-.65-.25-.19-.56-.35-.93-.48.3-.14.57-.3.8-.5.23-.2.42-.41.57-.64.15-.23.27-.46.34-.71.08-.24.11-.49.11-.73 0-.55-.09-1.04-.28-1.46-.18-.42-.44-.77-.78-1.06-.33-.28-.73-.5-1.2-.64-.45-.13-.97-.2-1.53-.2-.55 0-1.06.08-1.52.24-.47.17-.87.4-1.2.69-.33.29-.6.63-.78 1.03-.2.39-.29.83-.29 1.29h1.98c0-.26.05-.49.14-.69.09-.2.22-.38.38-.52.17-.14.36-.25.58-.33.22-.08.46-.12.73-.12.61 0 1.06.16 1.36.47.3.31.44.75.44 1.32 0 .27-.04.52-.12.74-.08.22-.21.41-.38.57-.17.16-.38.28-.63.37-.25.09-.55.13-.89.13H6.72v1.57H7.9c.34 0 .64.04.91.11.27.08.5.19.69.35.19.16.34.36.44.61.1.24.16.54.16.87 0 .62-.18 1.09-.53 1.42-.35.33-.84.49-1.45.49-.29 0-.56-.04-.8-.13-.24-.08-.44-.2-.61-.36-.17-.16-.3-.34-.39-.56-.09-.22-.14-.46-.14-.72H4.19c0 .55.11 1.03.32 1.45.21.42.5.77.86 1.05s.77.49 1.24.63.96.21 1.48.21c.57 0 1.09-.08 1.58-.23.49-.15.91-.38 1.26-.68.36-.3.64-.66.84-1.1.2-.43.3-.93.3-1.48 0-.29-.04-.58-.11-.86-.08-.25-.19-.51-.35-.76zm9.26 1.4c-.14-.28-.35-.53-.63-.74-.28-.21-.61-.39-1.01-.53s-.85-.27-1.35-.38c-.35-.07-.64-.15-.87-.23-.23-.08-.41-.16-.55-.25-.14-.09-.23-.19-.28-.3-.05-.11-.08-.24-.08-.39s.03-.28.09-.41c.06-.13.15-.25.27-.34.12-.1.27-.18.45-.24s.4-.09.64-.09c.25 0 .47.04.66.11.19.07.35.17.48.29.13.12.22.26.29.42.06.16.1.32.1.49h1.95c0-.39-.08-.75-.24-1.09-.16-.34-.39-.63-.69-.88-.3-.25-.66-.44-1.09-.59-.43-.15-.92-.22-1.46-.22-.51 0-.98.07-1.39.21-.41.14-.77.33-1.06.57-.29.24-.51.52-.67.84-.16.32-.23.65-.23 1.01s.08.68.23.96c.15.28.37.52.64.73.27.21.6.38.98.53.38.14.81.26 1.27.36.39.08.71.17.95.26s.43.19.57.29c.13.1.22.22.27.34.05.12.07.25.07.39 0 .32-.13.57-.4.77-.27.2-.66.29-1.17.29-.22 0-.43-.02-.64-.08-.21-.05-.4-.13-.56-.24-.17-.11-.3-.26-.41-.44-.11-.18-.17-.41-.18-.67h-1.89c0 .36.08.71.24 1.05.16.34.39.65.7.93.31.27.69.49 1.15.66.46.17.98.25 1.58.25.53 0 1.01-.06 1.44-.19.43-.13.8-.31 1.11-.54.31-.23.54-.51.71-.83.17-.32.25-.67.25-1.06-.02-.4-.09-.74-.24-1.02z"
})), 'Timer3');

exports.default = _default;

/***/ }),
/* 1960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.04 4.55l-1.42 1.42C16.07 4.74 14.12 4 12 4c-1.83 0-3.53.55-4.95 1.48l1.46 1.46C9.53 6.35 10.73 6 12 6c3.87 0 7 3.13 7 7 0 1.27-.35 2.47-.94 3.49l1.45 1.45C20.45 16.53 21 14.83 21 13c0-2.12-.74-4.07-1.97-5.61l1.42-1.42-1.41-1.42zM15 1H9v2h6V1zm-4 8.44l2 2V8h-2v1.44zM3.02 4L1.75 5.27 4.5 8.03C3.55 9.45 3 11.16 3 13c0 4.97 4.02 9 9 9 1.84 0 3.55-.55 4.98-1.5l2.5 2.5 1.27-1.27-7.71-7.71L3.02 4zM12 20c-3.87 0-7-3.13-7-7 0-1.28.35-2.48.95-3.52l9.56 9.56c-1.03.61-2.23.96-3.51.96z"
})), 'TimerOff');

exports.default = _default;

/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18.92 5.01C18.72 4.42 18.16 4 17.5 4h-11c-.66 0-1.21.42-1.42 1.01L3 11v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 15c-.83 0-1.5-.67-1.5-1.5S5.67 12 6.5 12s1.5.67 1.5 1.5S7.33 15 6.5 15zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 10l1.5-4.5h11L19 10H5z"
})), 'TimeToLeave');

exports.default = _default;

/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M5 4v3h5.5v12h3V7H19V4z"
})), 'Title');

exports.default = _default;

/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 9h14V7H3v2zm0 4h14v-2H3v2zm0 4h14v-2H3v2zm16 0h2v-2h-2v2zm0-10v2h2V7h-2zm0 6h2v-2h-2v2z"
})), 'Toc');

exports.default = _default;

/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z"
})), 'Today');

exports.default = _default;

/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zM3 12c0-2.61 1.67-4.83 4-5.65V4.26C3.55 5.15 1 8.27 1 12s2.55 6.85 6 7.74v-2.09c-2.33-.82-4-3.04-4-5.65z"
})), 'Toll');

exports.default = _default;

/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93s3.05-7.44 7-7.93v15.86zm2-15.86c1.03.13 2 .45 2.87.93H13v-.93zM13 7h5.24c.25.31.48.65.68 1H13V7zm0 3h6.74c.08.33.15.66.19 1H13v-1zm0 9.93V19h2.87c-.87.48-1.84.8-2.87.93zM18.24 17H13v-1h5.92c-.2.35-.43.69-.68 1zm1.5-3H13v-1h6.93c-.04.34-.11.67-.19 1z"
})), 'Tonality');

exports.default = _default;

/***/ }),
/* 1967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M9 11.24V7.5C9 6.12 10.12 5 11.5 5S14 6.12 14 7.5v3.74c1.21-.81 2-2.18 2-3.74C16 5.01 13.99 3 11.5 3S7 5.01 7 7.5c0 1.56.79 2.93 2 3.74zm9.84 4.63l-4.54-2.26c-.17-.07-.35-.11-.54-.11H13v-6c0-.83-.67-1.5-1.5-1.5S10 6.67 10 7.5v10.74l-3.43-.72c-.08-.01-.15-.03-.24-.03-.31 0-.59.13-.79.33l-.79.8 4.94 4.94c.27.27.65.44 1.06.44h6.79c.75 0 1.33-.55 1.44-1.28l.75-5.27c.01-.07.02-.14.02-.2 0-.62-.38-1.16-.91-1.38z"
})), 'TouchApp');

exports.default = _default;

/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 12c0-3 2.5-5.5 5.5-5.5S23 9 23 12H12zm0 0c0 3-2.5 5.5-5.5 5.5S1 15 1 12h11zm0 0c-3 0-5.5-2.5-5.5-5.5S9 1 12 1v11zm0 0c3 0 5.5 2.5 5.5 5.5S15 23 12 23V12z"
})), 'Toys');

exports.default = _default;

/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.07 4.93l-1.41 1.41C19.1 7.79 20 9.79 20 12c0 4.42-3.58 8-8 8s-8-3.58-8-8c0-4.08 3.05-7.44 7-7.93v2.02C8.16 6.57 6 9.03 6 12c0 3.31 2.69 6 6 6s6-2.69 6-6c0-1.66-.67-3.16-1.76-4.24l-1.41 1.41C15.55 9.9 16 10.9 16 12c0 2.21-1.79 4-4 4s-4-1.79-4-4c0-1.86 1.28-3.41 3-3.86v2.14c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V2h-1C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c0-2.76-1.12-5.26-2.93-7.07z"
})), 'TrackChanges');

exports.default = _default;

/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 10h-3V8.86c1.72-.45 3-2 3-3.86h-3V4c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v1H4c0 1.86 1.28 3.41 3 3.86V10H4c0 1.86 1.28 3.41 3 3.86V15H4c0 1.86 1.28 3.41 3 3.86V20c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-1.14c1.72-.45 3-2 3-3.86h-3v-1.14c1.72-.45 3-2 3-3.86zm-8 9c-1.11 0-2-.9-2-2s.89-2 2-2c1.1 0 2 .9 2 2s-.89 2-2 2zm0-5c-1.11 0-2-.9-2-2s.89-2 2-2c1.1 0 2 .9 2 2s-.89 2-2 2zm0-5c-1.11 0-2-.9-2-2 0-1.11.89-2 2-2 1.1 0 2 .89 2 2 0 1.1-.89 2-2 2z"
})), 'Traffic');

exports.default = _default;

/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h2.23l2-2H14l2 2h2v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-7H6V6h5v4zm2 0V6h5v4h-5zm3.5 7c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
})), 'Train');

exports.default = _default;

/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 16.94V8.5c0-2.79-2.61-3.4-6.01-3.49l.76-1.51H17V2H7v1.5h4.75l-.76 1.52C7.86 5.11 5 5.73 5 8.5v8.44c0 1.45 1.19 2.66 2.59 2.97L6 21.5v.5h2.23l2-2H14l2 2h2v-.5L16.5 20h-.08c1.69 0 2.58-1.37 2.58-3.06zm-7 1.56c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5-4.5H7V9h10v5z"
})), 'Tram');

exports.default = _default;

/***/ }),
/* 1973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16.49 15.5v-1.75L14 16.25l2.49 2.5V17H22v-1.5zm3.02 4.25H14v1.5h5.51V23L22 20.5 19.51 18zM9.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5.75 8.9L3 23h2.1l1.75-8L9 17v6h2v-7.55L8.95 13.4l.6-3C10.85 12 12.8 13 15 13v-2c-1.85 0-3.45-1-4.35-2.45l-.95-1.6C9.35 6.35 8.7 6 8 6c-.25 0-.5.05-.75.15L2 8.3V13h2V9.65l1.75-.75"
})), 'TransferWithinAStation');

exports.default = _default;

/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 18v-2H8V4h2L7 1 4 4h2v2H2v2h4v8c0 1.1.9 2 2 2h8v2h-2l3 3 3-3h-2v-2h4zM10 8h6v6h2V8c0-1.1-.9-2-2-2h-6v2z"
})), 'Transform');

exports.default = _default;

/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12.87 15.07l-2.54-2.51.03-.03c1.74-1.94 2.98-4.17 3.71-6.53H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z"
})), 'Translate');

exports.default = _default;

/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16 18l2.29-2.29-4.88-4.88-4 4L2 7.41 3.41 6l6 6 4-4 6.3 6.29L22 12v6z"
})), 'TrendingDown');

exports.default = _default;

/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 12l-4-4v3H3v2h15v3z"
})), 'TrendingFlat');

exports.default = _default;

/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"
})), 'TrendingUp');

exports.default = _default;

/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z"
})), 'Tune');

exports.default = _default;

/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z"
})), 'TurnedIn');

exports.default = _default;

/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z"
})), 'TurnedInNot');

exports.default = _default;

/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12z"
})), 'Tv');

exports.default = _default;

/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20.55 5.22l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.15.55L3.46 5.22C3.17 5.57 3 6.01 3 6.5V19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.49-.17-.93-.45-1.28zM12 9.5l5.5 5.5H14v2h-4v-2H6.5L12 9.5zM5.12 5l.82-1h12l.93 1H5.12z"
})), 'Unarchive');

exports.default = _default;

/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z"
})), 'Undo');

exports.default = _default;

/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7.41 18.59L8.83 20 12 16.83 15.17 20l1.41-1.41L12 14l-4.59 4.59zm9.18-13.18L15.17 4 12 7.17 8.83 4 7.41 5.41 12 10l4.59-4.59z"
})), 'UnfoldLess');

exports.default = _default;

/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z"
})), 'UnfoldMore');

exports.default = _default;

/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 10.12h-6.78l2.74-2.82c-2.73-2.7-7.15-2.8-9.88-.1-2.73 2.71-2.73 7.08 0 9.79 2.73 2.71 7.15 2.71 9.88 0C18.32 15.65 19 14.08 19 12.1h2c0 1.98-.88 4.55-2.64 6.29-3.51 3.48-9.21 3.48-12.72 0-3.5-3.47-3.53-9.11-.02-12.58 3.51-3.47 9.14-3.47 12.65 0L21 3v7.12zM12.5 8v4.25l3.5 2.08-.72 1.21L11 13V8h1.5z"
})), 'Update');

exports.default = _default;

/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15 7v4h1v2h-3V5h2l-3-4-3 4h2v8H8v-2.07c.7-.37 1.2-1.08 1.2-1.93 0-1.21-.99-2.2-2.2-2.2-1.21 0-2.2.99-2.2 2.2 0 .85.5 1.56 1.2 1.93V13c0 1.11.89 2 2 2h3v3.05c-.71.37-1.2 1.1-1.2 1.95 0 1.22.99 2.2 2.2 2.2 1.21 0 2.2-.98 2.2-2.2 0-.85-.49-1.58-1.2-1.95V15h3c1.11 0 2-.89 2-2v-2h1V7h-4z"
})), 'Usb');

exports.default = _default;

/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"
})), 'VerifiedUser');

exports.default = _default;

/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16 13h-3V3h-2v10H8l4 4 4-4zM4 19v2h16v-2H4z"
})), 'VerticalAlignBottom');

exports.default = _default;

/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z"
})), 'VerticalAlignCenter');

exports.default = _default;

/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M8 11h3v10h2V11h3l-4-4-4 4zM4 3v2h16V3H4z"
})), 'VerticalAlignTop');

exports.default = _default;

/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M0 15h2V9H0v6zm3 2h2V7H3v10zm19-8v6h2V9h-2zm-3 8h2V7h-2v10zM16.5 3h-9C6.67 3 6 3.67 6 4.5v15c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-15c0-.83-.67-1.5-1.5-1.5zM16 19H8V5h8v14z"
})), 'Vibration');

exports.default = _default;

/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4zM14 13h-3v3H9v-3H6v-2h3V8h2v3h3v2z"
})), 'VideoCall');

exports.default = _default;

/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"
})), 'Videocam');

exports.default = _default;

/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 6.5l-4 4V7c0-.55-.45-1-1-1H9.82L21 17.18V6.5zM3.27 2L2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.54-.18L19.73 21 21 19.73 3.27 2z"
})), 'VideocamOff');

exports.default = _default;

/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-10 7H8v3H6v-3H3v-2h3V8h2v3h3v2zm4.5 2c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4-3c-.83 0-1.5-.67-1.5-1.5S18.67 9 19.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
})), 'VideogameAsset');

exports.default = _default;

/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 13H3V5h18v11z"
})), 'VideoLabel');

exports.default = _default;

/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8 12.5v-9l6 4.5-6 4.5z"
})), 'VideoLibrary');

exports.default = _default;

/***/ }),
/* 2000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 13H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zm0-10H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"
})), 'ViewAgenda');

exports.default = _default;

/***/ }),
/* 2001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 18h3V5H4v13zM18 5v13h3V5h-3zM8 18h9V5H8v13z"
})), 'ViewArray');

exports.default = _default;

/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 19h10V4H7v15zm-5-2h4V6H2v11zM18 6v11h4V6h-4z"
})), 'ViewCarousel');

exports.default = _default;

/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 9h4V5H3v4zm0 5h4v-4H3v4zm5 0h4v-4H8v4zm5 0h4v-4h-4v4zM8 9h4V5H8v4zm5-4v4h4V5h-4zm5 9h4v-4h-4v4zM3 19h4v-4H3v4zm5 0h4v-4H8v4zm5 0h4v-4h-4v4zm5 0h4v-4h-4v4zm0-14v4h4V5h-4z"
})), 'ViewComfy');

exports.default = _default;

/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 19h6v-7H3v7zm7 0h12v-7H10v7zM3 5v6h19V5H3z"
})), 'ViewCompact');

exports.default = _default;

/***/ }),
/* 2005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M2 21h19v-3H2v3zM20 8H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zM2 3v3h19V3H2z"
})), 'ViewDay');

exports.default = _default;

/***/ }),
/* 2006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z"
})), 'ViewHeadline');

exports.default = _default;

/***/ }),
/* 2007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 14h4v-4H4v4zm0 5h4v-4H4v4zM4 9h4V5H4v4zm5 5h12v-4H9v4zm0 5h12v-4H9v4zM9 5v4h12V5H9z"
})), 'ViewList');

exports.default = _default;

/***/ }),
/* 2008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 11h5V5H4v6zm0 7h5v-6H4v6zm6 0h5v-6h-5v6zm6 0h5v-6h-5v6zm-6-7h5V5h-5v6zm6-6v6h5V5h-5z"
})), 'ViewModule');

exports.default = _default;

/***/ }),
/* 2009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M10 18h5v-6h-5v6zm-6 0h5V5H4v13zm12 0h5v-6h-5v6zM10 5v6h11V5H10z"
})), 'ViewQuilt');

exports.default = _default;

/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 18h17v-6H4v6zM4 5v6h17V5H4z"
})), 'ViewStream');

exports.default = _default;

/***/ }),
/* 2011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6 5H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm14 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-7 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z"
})), 'ViewWeek');

exports.default = _default;

/***/ }),
/* 2012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 15c-4.42 0-8-2.69-8-6s3.58-6 8-6 8 2.69 8 6-3.58 6-8 6z"
})), 'Vignette');

exports.default = _default;

/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
})), 'Visibility');

exports.default = _default;

/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
})), 'VisibilityOff');

exports.default = _default;

/***/ }),
/* 2015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12l-4-3.2V14H6V6h8v3.2L18 6v8z"
})), 'VoiceChat');

exports.default = _default;

/***/ }),
/* 2016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18.5 6C15.46 6 13 8.46 13 11.5c0 1.33.47 2.55 1.26 3.5H9.74c.79-.95 1.26-2.17 1.26-3.5C11 8.46 8.54 6 5.5 6S0 8.46 0 11.5 2.46 17 5.5 17h13c3.04 0 5.5-2.46 5.5-5.5S21.54 6 18.5 6zm-13 9C3.57 15 2 13.43 2 11.5S3.57 8 5.5 8 9 9.57 9 11.5 7.43 15 5.5 15zm13 0c-1.93 0-3.5-1.57-3.5-3.5S16.57 8 18.5 8 22 9.57 22 11.5 20.43 15 18.5 15z"
})), 'Voicemail');

exports.default = _default;

/***/ }),
/* 2017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M18.5 12c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM5 9v6h4l5 5V4L9 9H5z"
})), 'VolumeDown');

exports.default = _default;

/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M7 9v6h4l5 5V4l-5 5H7z"
})), 'VolumeMute');

exports.default = _default;

/***/ }),
/* 2019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"
})), 'VolumeOff');

exports.default = _default;

/***/ }),
/* 2020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"
})), 'VolumeUp');

exports.default = _default;

/***/ }),
/* 2021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M22 4v-.5C22 2.12 20.88 1 19.5 1S17 2.12 17 3.5V4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-.8 0h-3.4v-.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V4zm-2.28 8c.04.33.08.66.08 1 0 2.08-.8 3.97-2.1 5.39-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H7v-2h2c.55 0 1-.45 1-1V8h2c1.1 0 2-.9 2-2V3.46c-.95-.3-1.95-.46-3-.46C5.48 3 1 7.48 1 13s4.48 10 10 10 10-4.48 10-10c0-.34-.02-.67-.05-1h-2.03zM10 20.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L8 16v1c0 1.1.9 2 2 2v1.93z"
})), 'VpnLock');

exports.default = _default;

/***/ }),
/* 2022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 4h7V2H4c-1.1 0-2 .9-2 2v7h2V4zm6 9l-4 5h12l-3-4-2.03 2.71L10 13zm7-4.5c0-.83-.67-1.5-1.5-1.5S14 7.67 14 8.5s.67 1.5 1.5 1.5S17 9.33 17 8.5zM20 2h-7v2h7v7h2V4c0-1.1-.9-2-2-2zm0 18h-7v2h7c1.1 0 2-.9 2-2v-7h-2v7zM4 13H2v7c0 1.1.9 2 2 2h7v-2H4v-7z"
})), 'Wallpaper');

exports.default = _default;

/***/ }),
/* 2023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
})), 'Warning');

exports.default = _default;

/***/ }),
/* 2024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 12c0-2.54-1.19-4.81-3.04-6.27L16 0H8l-.95 5.73C5.19 7.19 4 9.45 4 12s1.19 4.81 3.05 6.27L8 24h8l.96-5.73C18.81 16.81 20 14.54 20 12zM6 12c0-3.31 2.69-6 6-6s6 2.69 6 6-2.69 6-6 6-6-2.69-6-6z"
})), 'Watch');

exports.default = _default;

/***/ }),
/* 2025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm4.2 14.2L11 13V7h1.5v5.2l4.5 2.7-.8 1.3z"
})), 'WatchLater');

exports.default = _default;

/***/ }),
/* 2026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6.85 12.65h2.3L8 9l-1.15 3.65zM22 7l-1.2 6.29L19.3 7h-1.6l-1.49 6.29L15 7h-.76C12.77 5.17 10.53 4 8 4c-4.42 0-8 3.58-8 8s3.58 8 8 8c3.13 0 5.84-1.81 7.15-4.43l.1.43H17l1.5-6.1L20 16h1.75l2.05-9H22zm-11.7 9l-.7-2H6.4l-.7 2H3.8L7 7h2l3.2 9h-1.9z"
})), 'WbAuto');

exports.default = _default;

/***/ }),
/* 2027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19.36 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.64-4.96z"
})), 'WbCloudy');

exports.default = _default;

/***/ }),
/* 2028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M3.55 18.54l1.41 1.41 1.79-1.8-1.41-1.41-1.79 1.8zM11 22.45h2V19.5h-2v2.95zM4 10.5H1v2h3v-2zm11-4.19V1.5H9v4.81C7.21 7.35 6 9.28 6 11.5c0 3.31 2.69 6 6 6s6-2.69 6-6c0-2.22-1.21-4.15-3-5.19zm5 4.19v2h3v-2h-3zm-2.76 7.66l1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4z"
})), 'WbIncandescent');

exports.default = _default;

/***/ }),
/* 2029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M5 14.5h14v-6H5v6zM11 .55V3.5h2V.55h-2zm8.04 2.5l-1.79 1.79 1.41 1.41 1.8-1.79-1.42-1.41zM13 22.45V19.5h-2v2.95h2zm7.45-3.91l-1.8-1.79-1.41 1.41 1.79 1.8 1.42-1.42zM3.55 4.46l1.79 1.79 1.41-1.41-1.79-1.79-1.41 1.41zm1.41 15.49l1.79-1.8-1.41-1.41-1.79 1.79 1.41 1.42z"
})), 'WbIridescent');

exports.default = _default;

/***/ }),
/* 2030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6.76 4.84l-1.8-1.79-1.41 1.41 1.79 1.79 1.42-1.41zM4 10.5H1v2h3v-2zm9-9.95h-2V3.5h2V.55zm7.45 3.91l-1.41-1.41-1.79 1.79 1.41 1.41 1.79-1.79zm-3.21 13.7l1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4zM20 10.5v2h3v-2h-3zm-8-5c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm-1 16.95h2V19.5h-2v2.95zm-7.45-3.91l1.41 1.41 1.79-1.8-1.41-1.41-1.79 1.8z"
})), 'WbSunny');

exports.default = _default;

/***/ }),
/* 2031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M5.5 22v-7.5H4V9c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2v5.5H9.5V22h-4zM18 22v-6h3l-2.54-7.63C18.18 7.55 17.42 7 16.56 7h-.12c-.86 0-1.63.55-1.9 1.37L12 16h3v6h3zM7.5 6c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2zm9 0c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2z"
})), 'Wc');

exports.default = _default;

/***/ }),
/* 2032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.89-2-2-2zm0 14H5V8h14v10z"
})), 'WebAsset');

exports.default = _default;

/***/ }),
/* 2033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M21 10c-1.1 0-2 .9-2 2v3H5v-3c0-1.1-.9-2-2-2s-2 .9-2 2v5c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-5c0-1.1-.9-2-2-2zm-3-5H6c-1.1 0-2 .9-2 2v2.15c1.16.41 2 1.51 2 2.82V14h12v-2.03c0-1.3.84-2.4 2-2.82V7c0-1.1-.9-2-2-2z"
})), 'Weekend');

exports.default = _default;

/***/ }),
/* 2034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67zM11.71 19c-1.78 0-3.22-1.4-3.22-3.14 0-1.62 1.05-2.76 2.81-3.12 1.77-.36 3.6-1.21 4.62-2.58.39 1.29.59 2.65.59 4.04 0 2.65-2.15 4.8-4.8 4.8z"
})), 'Whatshot');

exports.default = _default;

/***/ }),
/* 2035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M13 13v8h8v-8h-8zM3 21h8v-8H3v8zM3 3v8h8V3H3zm13.66-1.31L11 7.34 16.66 13l5.66-5.66-5.66-5.65z"
})), 'Widgets');

exports.default = _default;

/***/ }),
/* 2036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M1 9l2 2c4.97-4.97 13.03-4.97 18 0l2-2C16.93 2.93 7.08 2.93 1 9zm8 8l3 3 3-3c-1.65-1.66-4.34-1.66-6 0zm-4-4l2 2c2.76-2.76 7.24-2.76 10 0l2-2C15.14 9.14 8.87 9.14 5 13z"
})), 'Wifi');

exports.default = _default;

/***/ }),
/* 2037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20.5 9.5c.28 0 .55.04.81.08L24 6c-3.34-2.51-7.5-4-12-4S3.34 3.49 0 6l12 16 3.5-4.67V14.5c0-2.76 2.24-5 5-5zM23 16v-1.5c0-1.38-1.12-2.5-2.5-2.5S18 13.12 18 14.5V16c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-1 0h-3v-1.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V16z"
})), 'WifiLock');

exports.default = _default;

/***/ }),
/* 2038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 11c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 2c0-3.31-2.69-6-6-6s-6 2.69-6 6c0 2.22 1.21 4.15 3 5.19l1-1.74c-1.19-.7-2-1.97-2-3.45 0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.48-.81 2.75-2 3.45l1 1.74c1.79-1.04 3-2.97 3-5.19zM12 3C6.48 3 2 7.48 2 13c0 3.7 2.01 6.92 4.99 8.65l1-1.73C5.61 18.53 4 15.96 4 13c0-4.42 3.58-8 8-8s8 3.58 8 8c0 2.96-1.61 5.53-4 6.92l1 1.73c2.99-1.73 5-4.95 5-8.65 0-5.52-4.48-10-10-10z"
})), 'WifiTethering');

exports.default = _default;

/***/ }),
/* 2039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z"
})), 'Work');

exports.default = _default;

/***/ }),
/* 2040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M4 19h6v-2H4v2zM20 5H4v2h16V5zm-3 6H4v2h13.25c1.1 0 2 .9 2 2s-.9 2-2 2H15v-2l-3 3 3 3v-2h2c2.21 0 4-1.79 4-4s-1.79-4-4-4z"
})), 'WrapText');

exports.default = _default;

/***/ }),
/* 2041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M17.01 14h-.8l-.27-.27c.98-1.14 1.57-2.61 1.57-4.23 0-3.59-2.91-6.5-6.5-6.5s-6.5 3-6.5 6.5H2l3.84 4 4.16-4H6.51C6.51 7 8.53 5 11.01 5s4.5 2.01 4.5 4.5c0 2.48-2.02 4.5-4.5 4.5-.65 0-1.26-.14-1.82-.38L7.71 15.1c.97.57 2.09.9 3.3.9 1.61 0 3.08-.59 4.22-1.57l.27.27v.79l5.01 4.99L22 19l-4.99-5z"
})), 'YoutubeSearchedFor');

exports.default = _default;

/***/ }),
/* 2042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zm2.5-4h-2v2H9v-2H7V9h2V7h1v2h2v1z"
})), 'ZoomIn');

exports.default = _default;

/***/ }),
/* 2043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z"
})), 'ZoomOut');

exports.default = _default;

/***/ }),
/* 2044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M15 3l2.3 2.3-2.89 2.87 1.42 1.42L18.7 6.7 21 9V3zM3 9l2.3-2.3 2.87 2.89 1.42-1.42L6.7 5.3 9 3H3zm6 12l-2.3-2.3 2.89-2.87-1.42-1.42L5.3 17.3 3 15v6zm12-6l-2.3 2.3-2.87-2.89-1.42 1.42 2.89 2.87L15 21h6z"
})), 'ZoomOutMap');

exports.default = _default;

/***/ }),
/* 2045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_ArrowBack__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_ArrowBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_ArrowBack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Modules_CustomerDetailsCard__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__subscriptionDetails__ = __webpack_require__(2046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_common_Loader__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_ConfirmationDialog__ = __webpack_require__(65);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query allClientDetails($partnerLoginId: Int) {\n    clients: allClientDetails(partnerLoginId: $partnerLoginId) {\n      id\n      clientName\n      loginId\n    }\n  }\n'],['\n  query allClientDetails($partnerLoginId: Int) {\n    clients: allClientDetails(partnerLoginId: $partnerLoginId) {\n      id\n      clientName\n      loginId\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query clientDetail($id: Int) {\n    clientDetail(loginId: $id) {\n      id\n      clientName\n      contactPerson\n      address\n      city\n      state {\n        zone_id\n        name\n      }\n      country {\n        country_id\n        name\n      }\n      email\n      contactNumber\n      login {\n        username\n      }\n      pincode\n      panNumber\n      status\n      type\n    }\n  }\n'],['\n  query clientDetail($id: Int) {\n    clientDetail(loginId: $id) {\n      id\n      clientName\n      contactPerson\n      address\n      city\n      state {\n        zone_id\n        name\n      }\n      country {\n        country_id\n        name\n      }\n      email\n      contactNumber\n      login {\n        username\n      }\n      pincode\n      panNumber\n      status\n      type\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation updateSubscriptions(\n    $id: Int!\n    $clientLoginId: Int!\n    $partnerLoginId: Int!\n    $billingFrequencyId: Int!\n    $deviceQuantity: Int!\n    $softwareQuantity: Int!\n    $accessoryQuantity: Int\n    $simQuantity: Int\n  ) {\n    updateSubscriptions(\n      id: $id\n      clientLoginId: $clientLoginId\n      partnerLoginId: $partnerLoginId\n      billingFrequencyId: $billingFrequencyId\n      deviceQuantity: $deviceQuantity\n      softwareQuantity: $softwareQuantity\n      accessoryQuantity: $accessoryQuantity\n      simQuantity: $simQuantity\n    )\n  }\n'],['\n  mutation updateSubscriptions(\n    $id: Int!\n    $clientLoginId: Int!\n    $partnerLoginId: Int!\n    $billingFrequencyId: Int!\n    $deviceQuantity: Int!\n    $softwareQuantity: Int!\n    $accessoryQuantity: Int\n    $simQuantity: Int\n  ) {\n    updateSubscriptions(\n      id: $id\n      clientLoginId: $clientLoginId\n      partnerLoginId: $partnerLoginId\n      billingFrequencyId: $billingFrequencyId\n      deviceQuantity: $deviceQuantity\n      softwareQuantity: $softwareQuantity\n      accessoryQuantity: $accessoryQuantity\n      simQuantity: $simQuantity\n    )\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query getSubscriptions($subscriptionId: Int) {\n    getSubscriptions(id: $subscriptionId) {\n      id\n      status\n      client {\n        loginId\n        clientName\n      }\n      billingMode {\n        id\n        billingMode\n      }\n      billingFrequency {\n        id\n        frequency\n      }\n      plan\n      amount\n      createdAt\n      nextPaymentDate\n      unAssignedDeviceQuantity\n      unAssignedAccessoryQuantity\n      unAssignedSimQuantity\n      minimumAmountDue\n      salesRemarks\n      invoiceDownloadLink\n      deviceModel {\n        model_name\n      }\n      accessoryType {\n        accessoryName\n      }\n      serviceProvider {\n        name\n      }\n      billingDetails {\n        paymentId\n        totalAmount\n        totalAmountWithGST\n        softwareBill {\n          quantity\n          rate\n          amountWithGST\n        }\n        hardwareBill {\n          quantity\n          rate\n          amountWithGST\n        }\n        accessoryBill {\n          quantity\n          rate\n          amountWithGST\n        }\n        simBill {\n          quantity\n          rate\n          amountWithGST\n        }\n      }\n    }\n  }\n'],['\n  query getSubscriptions($subscriptionId: Int) {\n    getSubscriptions(id: $subscriptionId) {\n      id\n      status\n      client {\n        loginId\n        clientName\n      }\n      billingMode {\n        id\n        billingMode\n      }\n      billingFrequency {\n        id\n        frequency\n      }\n      plan\n      amount\n      createdAt\n      nextPaymentDate\n      unAssignedDeviceQuantity\n      unAssignedAccessoryQuantity\n      unAssignedSimQuantity\n      minimumAmountDue\n      salesRemarks\n      invoiceDownloadLink\n      deviceModel {\n        model_name\n      }\n      accessoryType {\n        accessoryName\n      }\n      serviceProvider {\n        name\n      }\n      billingDetails {\n        paymentId\n        totalAmount\n        totalAmountWithGST\n        softwareBill {\n          quantity\n          rate\n          amountWithGST\n        }\n        hardwareBill {\n          quantity\n          rate\n          amountWithGST\n        }\n        accessoryBill {\n          quantity\n          rate\n          amountWithGST\n        }\n        simBill {\n          quantity\n          rate\n          amountWithGST\n        }\n      }\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_CLIENTS=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject);var GET_CLIENT=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject2);var UPDATE_SUBSCRIPTION=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject3);var GET_SUBSCRIPTION_DETAIL=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject4);var style=function style(theme){var _root;return{root:(_root={padding:theme.spacing.unit*4},_defineProperty(_root,theme.breakpoints.down('sm'),{padding:theme.spacing.unit*2}),_defineProperty(_root,'flexGrow',1),_root),input:{display:'flex',padding:0}};};function ClientSelected(props){var isClientSelected=props.isClientSelected;if(isClientSelected){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Modules_CustomerDetailsCard__["a" /* default */],{clientDetail:props.clientDetails})));}return null;}function ShowSubDetails(props){var isClientSelected=props.isClientSelected;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__common_ConfirmationDialog__["a" /* default */],{isDialogOpen:props.isUpdateConfDialogOpen,dialogMessage:'Are you sure you want to Update this subscription?',negativeResponseHandler:props.updateNegativeResponseHandler,positiveResponseHandler:props.updatePositiveResponseHandler,isSaveBtnDisabled:props.isSaveBtnDisabled}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__common_ConfirmationDialog__["a" /* default */],{isDialogOpen:props.isCancelConfDialogOpen,dialogMessage:'Are you sure you want to Cancel the changes?',negativeResponseHandler:props.cancelNegativeResponseHandler,positiveResponseHandler:props.cancelPositiveResponseHandler}),isClientSelected&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__subscriptionDetails__["a" /* default */],{subscriptionData:props.subscriptionData,isClientSelected:props.isClientSelected,billingFrequencyId:props.billingFrequencyId,nextPaymentDate:props.nextPaymentDate,totalQuantity:props.totalQuantity,deviceQuantity:props.deviceQuantity,accessoryQuantity:props.accessoryQuantity,simQuantity:props.simQuantity,softwareQuantity:props.softwareQuantity,deviceTotalAmount:props.deviceTotalAmount,softwareTotalAmount:props.softwareTotalAmount,accessoryTotalAmount:props.accessoryTotalAmount,simTotalAmount:props.simTotalAmount,handleSelectChange:props.handleSelectChange,handleSelectDayChange:props.handleSelectDayChange,handleSelectGstChange:props.handleSelectGstChange,handleChange:props.handleChange,handleSelectBillingModeChange:props.handleSelectBillingModeChange,handleCancelClick:props.handleCancelClick,handleUpdateClick:props.handleUpdateClick}));}var EditSubscription=function(_Component){_inherits(EditSubscription,_Component);function EditSubscription(props){var _this2=this;_classCallCheck(this,EditSubscription);var _this=_possibleConstructorReturn(this,(EditSubscription.__proto__||Object.getPrototypeOf(EditSubscription)).call(this,props));_this.handleChange=function(name){return function(event){_this.setState({isStateChanged:true});console.log('change values');var _this$state$subscript=_this.state.subscriptionData.billingDetails,softwareBill=_this$state$subscript.softwareBill,hardwareBill=_this$state$subscript.hardwareBill,accessoryBill=_this$state$subscript.accessoryBill,simBill=_this$state$subscript.simBill;if(!(event.target.value<_this.state.initStatus[name])&&event.target.value>=0){console.log(name);if(name==='softwareQuantity'){var total=event.target.value*softwareBill.rate;_this.setState({softwareTotalAmount:total,softwareQuantity:event.target.value});}else if(name==='deviceQuantity'){console.log(event.target.value);var _total=event.target.value*hardwareBill.rate;_this.setState(_defineProperty({deviceTotalAmount:_total},name,event.target.value));}else if(name==='accessoryQuantity'){var _total2=event.target.value*accessoryBill.rate;_this.setState(_defineProperty({accessoryTotalAmount:_total2},name,event.target.value));}else if(name==='simQuantity'){var _total3=event.target.value*simBill.rate;_this.setState(_defineProperty({simTotalAmount:_total3},name,event.target.value));}}};};_this.handleCancelClick=function(e){if(_this.state.isStateChanged){_this.setState({isCancelConfDialogOpen:true});}else{_this.handleCancelSubscription();}};_this.handleUpdateClick=function(e){_this.setState({isUpdateConfDialogOpen:true});};_this.handleCancelNegativeResponse=function(e){_this.setState({isCancelConfDialogOpen:false});};_this.handleUpdateNegativeResponse=function(e){_this.setState({isSaveBtnDisabled:false});_this.setState({isUpdateConfDialogOpen:false});};_this.handleCancelSubscription=function(e){_this.props.history.goBack();};_this.handleUpdateSubscription=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _ref2,data,errors;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.setState({isSaveBtnDisabled:true});if(!(parseInt(_this.state.deviceQuantity,10)!==parseInt(_this.state.softwareQuantity,10))){_context.next=5;break;}_this.props.openSnackbar('Device total quantity and device quantity should be equal');_context.next=19;break;case 5:_context.next=7;return _this.props.client.mutate({mutation:UPDATE_SUBSCRIPTION,variables:{id:parseInt(_this.subscriptionId,10),clientLoginId:parseInt(_this.loginId,10),partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_14__utils_getLoginId__["a" /* default */])(),billingFrequencyId:parseInt(_this.state.billingFrequencyId,10),deviceQuantity:parseInt(_this.state.deviceQuantity,10),softwareQuantity:parseInt(_this.state.softwareQuantity,10),accessoryQuantity:parseInt(_this.state.accessoryQuantity,10),simQuantity:parseInt(_this.state.simQuantity,10)},errorPolicy:'all'});case 7:_ref2=_context.sent;data=_ref2.data;errors=_ref2.errors;if(!errors){_context.next=14;break;}_this.props.openSnackbar(errors[0].message,{type:'error'});_context.next=19;break;case 14:if(!(data.updateSubscriptions===true)){_context.next=19;break;}_context.next=17;return _this.props.client.clearStore();case 17:_this.props.openSnackbar('Subscription Updation Successful');_this.props.history.push({pathname:'/home/subscriptions/'});case 19:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.getAllDetails=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var initStatus,clientDetails,fetchedSubscriptionData,getSubscriptions,_getSubscriptions$bil,softwareBill,hardwareBill,accessoryBill,simBill,fields;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:initStatus={deviceQuantity:0,accessoryQuantity:0,simQuantity:0,softwareQuantity:0};_context2.next=3;return _this.props.client.query({query:GET_CLIENT,variables:{id:parseInt(_this.loginId,10)},fetchPolicy:'network-only'});case 3:clientDetails=_context2.sent;_context2.next=6;return _this.props.client.query({query:GET_SUBSCRIPTION_DETAIL,variables:{subscriptionId:parseInt(_this.subscriptionId,10)},fetchPolicy:'network-only'});case 6:fetchedSubscriptionData=_context2.sent;getSubscriptions=fetchedSubscriptionData.data.getSubscriptions;_this.setState({subscriptionData:getSubscriptions});console.log('Edit subscription data:',fetchedSubscriptionData);// Maintain initial settings
if(getSubscriptions.billingDetails){_getSubscriptions$bil=getSubscriptions.billingDetails,softwareBill=_getSubscriptions$bil.softwareBill,hardwareBill=_getSubscriptions$bil.hardwareBill,accessoryBill=_getSubscriptions$bil.accessoryBill,simBill=_getSubscriptions$bil.simBill;if(hardwareBill){initStatus['deviceQuantity']=hardwareBill.quantity;_this.setState({deviceQuantity:hardwareBill.quantity,deviceTotalAmount:hardwareBill.quantity*hardwareBill.rate});}if(softwareBill){initStatus['softwareQuantity']=softwareBill.quantity;_this.setState({softwareQuantity:softwareBill.quantity,softwareTotalAmount:softwareBill.quantity*softwareBill.rate});}if(accessoryBill){initStatus['accessoryQuantity']=accessoryBill.quantity;_this.setState({accessoryQuantity:accessoryBill.quantity,accessoryTotalAmount:accessoryBill.quantity*accessoryBill.rate});}if(simBill){initStatus['simQuantity']=simBill.quantity;_this.setState({simQuantity:simBill.quantity,simTotalAmount:simBill.quantity*simBill.rate});}}// Take care of non mandatory fields
// TODO: Explore handling this in the query
// console.log(fetchedSubscriptionData.data.getSubscriptions.nextPaymentDate, 'nextpay')
fields={initStatus:initStatus,clientDetails:clientDetails.data.clientDetail,clientId:_this.loginId,isClientSelected:true,billingFrequencyId:fetchedSubscriptionData.data.getSubscriptions.billingFrequency.id};_this.setState(fields);case 13:case'end':return _context2.stop();}}},_callee2,_this2);}));_this.subscriptionId=_this.props.match.params.subscriptionId;_this.loginId=_this.props.match.params.loginId;_this.state={clientId:null,subscriptionData:null,isUpdateConfDialogOpen:false,isCancelConfDialogOpen:false,isSaveBtnDisabled:false,clientDetails:null,isClientSelected:false,billingFrequencyId:null,nextPaymentDate:null,totalQuantity:null,deviceQuantity:0,softwareQuantity:0,accessoryQuantity:0,simQuantity:0,deviceTotalAmount:0,softwareTotalAmount:0,accessoryTotalAmount:0,simTotalAmount:0,grandTotalAmount:null,isStateChanged:false,initStatus:{deviceQuantity:0,accessoryQuantity:0,simQuantity:0,softwareQuantity:0}};return _this;}_createClass(EditSubscription,[{key:'componentDidMount',value:function componentDidMount(){this.getAllDetails();}},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_apollo__["Query"],{query:GET_CLIENTS,variables:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_14__utils_getLoginId__["a" /* default */])()},fetchPolicy:'network-only'},function(_ref4){var loading=_ref4.loading,error=_ref4.error,clients=_ref4.data.clients;if(loading)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_common_Loader__["a" /* default */],null);if(error)return'Error!: '+error;var allClients=clients.map(function(client){return{value:client.loginId,label:client.clientName};});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button___default.a,{variant:'outlined',color:'secondary',className:classes.button,onClick:_this3.handleCancelClick},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_ArrowBack___default.a,{className:classes.iconSmall}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'headline'},'Edit Subscription')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_select__["a" /* default */],{classes:classes,options:allClients,value:_this3.state.clientId,disabled:true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ClientSelected,{isClientSelected:_this3.state.isClientSelected,clientDetails:_this3.state.clientDetails})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ShowSubDetails,{isSaveBtnDisabled:_this3.state.isSaveBtnDisabled,subscriptionData:_this3.state.subscriptionData,isClientSelected:_this3.state.isClientSelected,isUpdateConfDialogOpen:_this3.state.isUpdateConfDialogOpen,isCancelConfDialogOpen:_this3.state.isCancelConfDialogOpen,billingFrequencyId:_this3.state.billingFrequencyId,totalQuantity:_this3.state.totalQuantity,deviceQuantity:_this3.state.deviceQuantity,accessoryQuantity:_this3.state.accessoryQuantity,simQuantity:_this3.state.simQuantity,softwareQuantity:_this3.state.softwareQuantity,deviceTotalAmount:_this3.state.deviceTotalAmount,softwareTotalAmount:_this3.state.softwareTotalAmount,accessoryTotalAmount:_this3.state.accessoryTotalAmount,simTotalAmount:_this3.state.simTotalAmount,handleChange:_this3.handleChange,handleCancelSubscription:_this3.handleCancelSubscription,handleUpdateSubscription:_this3.handleUpdateSubscription,handleCancelClick:_this3.handleCancelClick,handleUpdateClick:_this3.handleUpdateClick,cancelNegativeResponseHandler:_this3.handleCancelNegativeResponse,updateNegativeResponseHandler:_this3.handleUpdateNegativeResponse,cancelPositiveResponseHandler:_this3.handleCancelSubscription,updatePositiveResponseHandler:_this3.handleUpdateSubscription})))));});}}]);return EditSubscription;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);EditSubscription.propTypes={classes:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired};var withApolloClient=function withApolloClient(Component){return function(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_apollo__["ApolloConsumer"],null,function(client){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component,Object.assign({client:client},props));});};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__["withStyles"])(style)(withApolloClient(Object(__WEBPACK_IMPORTED_MODULE_13__HOCs_withSharedSnackbar__["a" /* default */])(EditSubscription))));

/***/ }),
/* 2046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Card__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_CardHeader__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_CardHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_CardHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_CardContent__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_CardContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_CardContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_CardActions__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_CardActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_CardActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_apollo__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var style=function style(theme){return{card:{overflow:'visible'},root:{padding:theme.spacing.unit*2,flexGrow:1},input:{display:'flex',padding:0},italicizedText:{fontStyle:'italic'},fileDownloadIcon:{marginLeft:theme.spacing.unit,marginRight:-theme.spacing.unit},wrapFileName:{overflow:'hidden',whiteSpace:'nowrap',textOverflow:'ellipsis',maxWidth:'250px'},cardHeaderAction:{marginTop:'0px',marginRight:'-8px'},selectSytle:{width:'80%'},dividerStyle:{margin:'10px 0px 0 0'},subHeading:{margin:'5px 0'}};};var SubscriptionDetails=function(_Component){_inherits(SubscriptionDetails,_Component);function SubscriptionDetails(){_classCallCheck(this,SubscriptionDetails);return _possibleConstructorReturn(this,(SubscriptionDetails.__proto__||Object.getPrototypeOf(SubscriptionDetails)).apply(this,arguments));}_createClass(SubscriptionDetails,[{key:'render',value:function render(){var _props=this.props,classes=_props.classes,subscriptionData=_props.subscriptionData;var billingDetails=subscriptionData.billingDetails,deviceModel=subscriptionData.deviceModel,accessoryType=subscriptionData.accessoryType,serviceProvider=subscriptionData.serviceProvider;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Card___default.a,{className:classes.card},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_CardHeader___default.a,{title:'Subscription Details'}),billingDetails?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true,spacing:16},billingDetails.softwareBill?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true,alignItems:'baseline',spacing:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{gutterBottom:true,variant:'h3',component:'h3'},'Software')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true,justify:'flex-start',alignItems:'flex-end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'h3',component:'h4'},'AquilaTrack Software')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{id:'softwareQuantity',label:'Software Quantity *',value:this.props.softwareQuantity,inputProps:{min:billingDetails.softwareBill.quantity},onChange:this.props.handleChange('softwareQuantity'),type:'number',margin:'none'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{gutterBottom:true,variant:'h3',component:'body2'},'Software Charges'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'h3',component:'h4'},billingDetails.softwareBill.rate)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body1'},'Total Amount per month (excl GST): \xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body2'},isNaN(parseInt(this.props.softwareTotalAmount,10))?'-':this.props.softwareTotalAmount))))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Divider___default.a,{className:classes.dividerStyle})),billingDetails.hardwareBill?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true,alignItems:'baseline',spacing:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{gutterBottom:true,variant:'h3',component:'h3'},'Devices')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true,justify:'flex-start',alignItems:'flex-end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'h3',component:'h4'},deviceModel.model_name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{id:'quantity',label:'Device Quantity *',value:this.props.deviceQuantity,onChange:this.props.handleChange('deviceQuantity'),type:'number',inputProps:{min:billingDetails.hardwareBill.quantity},margin:'none'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{gutterBottom:true,variant:'h3',component:'body2'},'Device Charges'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'h3',component:'h4'},billingDetails.hardwareBill.rate)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body1'},'Total Amount per month (excl GST): \xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body2'},isNaN(parseInt(this.props.deviceTotalAmount,10))?'-':this.props.deviceTotalAmount))))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Divider___default.a,{className:classes.dividerStyle})),billingDetails.accessoryBill?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true,alignItems:'baseline',spacing:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{gutterBottom:true,variant:'h3',component:'h3'},'Accessory')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true,justify:'flex-start',alignItems:'flex-end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{gutterBottom:true,variant:'h3',component:'body2'},'Accessory Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'h3',component:'h4'},accessoryType&&accessoryType.accessoryName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{id:'accessoryQuantity',label:'Quantity',disabled:this.props.accessoryQuantity===0&&true,value:this.props.accessoryQuantity,onChange:this.props.handleChange('accessoryQuantity'),type:'number',inputProps:{min:billingDetails.accessoryBill.quantity},margin:'none'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{gutterBottom:true,variant:'h3',component:'body2'},'Accessory Charges'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'h3',component:'h4'},billingDetails.accessoryBill.rate)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body1'},'Total Amount per month (excl GST): \xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body2'},isNaN(parseInt(this.props.accessoryTotalAmount,10))?'-':this.props.accessoryTotalAmount))))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Divider___default.a,{className:classes.dividerStyle})),billingDetails.simBill?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true,alignItems:'baseline',spacing:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{gutterBottom:true,variant:'h3',component:'h3'},'Service Provider')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true,justify:'flex-start',alignItems:'flex-end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'h3',component:'h4'},serviceProvider&&serviceProvider.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{id:'simQuantity',label:'Quantity',disabled:this.props.simQuantity===0&&true,value:this.props.simQuantity,onChange:this.props.handleChange('simQuantity'),type:'number',inputProps:{min:billingDetails.simBill.quantity},margin:'none'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{gutterBottom:true,variant:'h3',component:'body2'},'Sim Charges'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'h3',component:'h4'},billingDetails.simBill.rate)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body1'},'Total Amount per month (excl GST): \xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body2'},isNaN(parseInt(this.props.simTotalAmount,10))?'-':this.props.simTotalAmount))))):null)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{gutterBottom:true,color:'error',variant:'sub-heading',component:'body2'},'Sorry! No Subscriptions are available.')),billingDetails?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_CardActions___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button___default.a,{color:'secondary',variant:'raised',onClick:this.props.handleUpdateClick},'Update'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button___default.a,{color:'secondary',onClick:this.props.handleCancelClick},'Cancel')):null);}}]);return SubscriptionDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SubscriptionDetails.propTypes={classes:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_12_react_apollo__["withApollo"])(SubscriptionDetails)));

/***/ }),
/* 2047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Card__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_CardHeader__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_CardHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_CardHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_CardContent__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_CardContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_CardContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_CardActions__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_CardActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_CardActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_common_Loader__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_ConfirmationDialog__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__HOCs_withSharedSnackbar__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getAllPlans($partnerLoginId: Int!) {\n    allplans: getAllPlans(partnerLoginId: $partnerLoginId) {\n      id\n      planName\n      description\n      costPerAsset\n      numberOfAssociatedClient\n      partnerLoginId\n    }\n  }\n'],['\n  query getAllPlans($partnerLoginId: Int!) {\n    allplans: getAllPlans(partnerLoginId: $partnerLoginId) {\n      id\n      planName\n      description\n      costPerAsset\n      numberOfAssociatedClient\n      partnerLoginId\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  mutation deletePlan($id: Int!, $partnerLoginId: Int) {\n    deletePlan(id: $id, partnerLoginId: $partnerLoginId)\n  }\n'],['\n  mutation deletePlan($id: Int!, $partnerLoginId: Int) {\n    deletePlan(id: $id, partnerLoginId: $partnerLoginId)\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// import MenuIcon from '@material-ui/icons/Menu'
// import PieChart from '../../Reusable/Charts/PieChart'
// import ItemCard from '../../Reusable/ItemCard'
// import PullApi from '../../Modules/PullApi'
var GET_ALLPLANS=Object(__WEBPACK_IMPORTED_MODULE_9_graphql_tag__["a" /* default */])(_templateObject);var DELETE_PLAN=Object(__WEBPACK_IMPORTED_MODULE_9_graphql_tag__["a" /* default */])(_templateObject2);var styles=function styles(theme){var _root;return{root:(_root={padding:theme.spacing.unit*4},_defineProperty(_root,theme.breakpoints.down('sm'),{padding:theme.spacing.unit*2}),_defineProperty(_root,'flexGrow',1),_root),planCostPerAsset:{color:'black'},card:{height:'100%',display:'flex',flexDirection:'column',justifyContent:'space-between'}};};var Plans=function(_Component){_inherits(Plans,_Component);function Plans(props){var _this2=this;_classCallCheck(this,Plans);var _this=_possibleConstructorReturn(this,(Plans.__proto__||Object.getPrototypeOf(Plans)).call(this,props));_this.columns=['PLAN NAME','COST PER UNIT','DESCRIPTION','ACTIVE CUSTOMER'// 'FEATURE LIST'
];_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15,onRowClick:function onRowClick(rowData,dataIndex,rowIndex){// console.log('planid=', this.planId[rowIndex])
_this.props.history.push({// pathname: '/home/plans/view',
pathname:'/home/plans/view/'+_this.planId[dataIndex.dataIndex]// state: {
//   clientId: this.clientId[rowIndex],
//   clientName: this.fullData[rowIndex][0],
//   planId: this.planId[rowIndex]
// }
});}// sort: false,
// filter: false,
// search: false,
// print: false,
// download: false,
// viewColumns: false,
// pagination: false
};_this.viewPlan=function(e){// console.log('onlcick viewplan: ', e)
_this.props.history.push({pathname:'/home/plans/view/'+e});};_this.addPlan=function(e){_this.props.history.push({pathname:'/home/Plans/addPlan'});};_this.pullApi=function(e){_this.props.history.push({pathname:'/home/device/api'});};_this.editPlan=function(e){_this.props.history.push({pathname:'/home/Plans/editPlan/'+e});};_this.getPlans=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var responce;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.client.query({query:GET_ALLPLANS,variables:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__["a" /* default */])()},fetchPolicy:'network-only'});case 2:responce=_context.sent;_this.setState({Plan:responce.data.allplans});// this.state.Plan.map(plan => console.log(plan.id, '===plan'))
case 4:case'end':return _context.stop();}}},_callee,_this2);}));_this.handleSubmitClick=function(e){console.log('calling this function');_this.setState({selectedPlanId:e});_this.setState({isSubmitConfDialogOpen:true});};_this.handleCancelNegativeResponse=function(e){console.log('calling close....');_this.setState({isSubmitConfDialogOpen:false});};_this.handleSubmit=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(e){var _ref3,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:console.log('selectedPlanId',e);_context2.next=3;return _this.props.client.mutate({mutation:DELETE_PLAN,variables:{id:_this.state.selectedPlanId,partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__["a" /* default */])()},refetchQueries:['getAllPlans'],errorPolicy:'all'});case 3:_ref3=_context2.sent;data=_ref3.data;if(data.deletePlan===true){_this.setState({isSubmitConfDialogOpen:false});_this.props.openSnackbar('Plan Deleted Successfully');_this.getPlans();}else{_this.props.openSnackbar('Error in deleting Plan');}case 6:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}();console.log('props=',props);_this.state={isSubmitConfDialogOpen:false,Plan:[],selectedPlanId:''};return _this;}_createClass(Plans,[{key:'componentDidMount',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return this.getPlans();case 2:case'end':return _context3.stop();}}},_callee3,this);}));function componentDidMount(){return _ref4.apply(this,arguments);}return componentDidMount;}()// mapToArr = allplans => {
//   let pieChartArr = []
//   let fullData = []
//   allplans.forEach(element => {
//     pieChartArr = []
//     console.log(element.numberOfAssociatedClient)
//     pieChartArr['value'] = element.numberOfAssociatedClient + Math.random() // To be removed random function
//     pieChartArr['label'] = element.planName
//     pieChartArr['id'] = element.id
//     fullData.push(pieChartArr)
//   })
//   return fullData
// }
},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__common_ConfirmationDialog__["a" /* default */],{isDialogOpen:this.state.isSubmitConfDialogOpen,dialogMessage:'Are you sure you want to Delete this Plan ?',negativeResponseHandler:this.handleCancelNegativeResponse,positiveResponseHandler:function positiveResponseHandler(){return _this3.handleSubmit(_this3.state.selectedPlanId);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{container:true,justify:'space-between'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{variant:'headline'},'Plans')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button___default.a,{color:'secondary',variant:'contained',className:classes.button,onClick:this.addPlan},'Create Plan')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{container:true,spacing:16},this.state.Plan.map(function(plan){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6,md:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Card___default.a,{className:classes.card},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_CardHeader___default.a,{title:plan.planName,subheader:'$'+plan.costPerAsset,subheaderTypographyProps:{variant:'subheading',className:classes.planCostPerAsset}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{variant:'body1'},plan.description)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{component:'p',variant:'body2'},'Associated Clients:\xA0',plan.numberOfAssociatedClient)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_CardActions___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button___default.a,{size:'small',color:'secondary',onClick:function onClick(){return _this3.viewPlan(plan.id);}},'Plan Details'),plan.planName==='Basic'||plan.planName==='Value'||plan.planName==='Enterprise'||plan.planName==='OBD'||plan.planName==='Activity Test Plan'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,null):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button___default.a,{size:'small',color:'secondary',onClick:function onClick(){return _this3.editPlan(plan.id);}},'Edit Plan'),plan.numberOfAssociatedClient!==0||plan.planName==='Basic'||plan.planName==='Value'||plan.planName==='Enterprise'||plan.planName==='OBD'||plan.planName==='Activity Test Plan'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,null):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button___default.a,{size:'small',color:'secondary',onClick:function onClick(){return _this3.handleSubmitClick(plan.id);}},'Delete Plan'))));})// return <div />
))));}}]);return Plans;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);Plans.propTypes={classes:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_10_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_16__HOCs_withSharedSnackbar__["a" /* default */])(Plans))));

/***/ }),
/* 2048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormHelperText__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormHelperText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormHelperText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__plans_css__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__plans_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__plans_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Basic__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AllFeatures__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_icons_ArrowBack__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_icons_ArrowBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__material_ui_icons_ArrowBack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_core_Card__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_core_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core_CardHeader__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core_CardHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_CardHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_core_CardContent__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_core_CardContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_CardContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__common_ConfirmationDialog__ = __webpack_require__(65);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query {\n    features: allFeatures(status: 1) {\n      id\n      featureName\n      costPerAssetPerMonth\n      featureDescription\n    }\n  }\n'],['\n  query {\n    features: allFeatures(status: 1) {\n      id\n      featureName\n      costPerAssetPerMonth\n      featureDescription\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query getPlans($planid: Int!) {\n    getPlans(id: $planid) {\n      planName\n      description\n      featureList {\n        id\n        featureName\n        costPerAssetPerMonth\n        featureDescription\n      }\n    }\n  }\n'],['\n  query getPlans($planid: Int!) {\n    getPlans(id: $planid) {\n      planName\n      description\n      featureList {\n        id\n        featureName\n        costPerAssetPerMonth\n        featureDescription\n      }\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation addPlans(\n    $planName: String!\n    $description: String!\n    $featureList: String!\n    $costPerAsset: Int!\n    $partnerLoginId: Int!\n  ) {\n    addPlans(\n      planName: $planName\n      description: $description\n      featureList: $featureList\n      costPerAsset: $costPerAsset\n      partnerLoginId: $partnerLoginId\n    )\n  }\n'],['\n  mutation addPlans(\n    $planName: String!\n    $description: String!\n    $featureList: String!\n    $costPerAsset: Int!\n    $partnerLoginId: Int!\n  ) {\n    addPlans(\n      planName: $planName\n      description: $description\n      featureList: $featureList\n      costPerAsset: $costPerAsset\n      partnerLoginId: $partnerLoginId\n    )\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var styles=function styles(theme){var _root;return{root:(_root={padding:theme.spacing.unit*4},_defineProperty(_root,theme.breakpoints.down('sm'),{padding:theme.spacing.unit*2}),_defineProperty(_root,'flexGrow',1),_root),italicizedText:{fontStyle:'italic'},fullWidth:{width:'100%'}};};var GET_ALL_FEATURES=Object(__WEBPACK_IMPORTED_MODULE_15_graphql_tag__["a" /* default */])(_templateObject);var GET_FEATURE_BY_PLAN=Object(__WEBPACK_IMPORTED_MODULE_15_graphql_tag__["a" /* default */])(_templateObject2);var ADD_PLANS=Object(__WEBPACK_IMPORTED_MODULE_15_graphql_tag__["a" /* default */])(_templateObject3);var AddPlan=function(_Component){_inherits(AddPlan,_Component);function AddPlan(props){var _this2=this;_classCallCheck(this,AddPlan);// console.log('out', featuresList)
var _this=_possibleConstructorReturn(this,(AddPlan.__proto__||Object.getPrototypeOf(AddPlan)).call(this,props));_this.handleChangeChecked=function(name,price){return function(event){// console.log(name, event.target.value, event.target.checked)
var tempState=_this.state.tempState;var a=Object.assign({},tempState);var p=Object.assign({},_this.state.tempPrice);// console.log('mee', a)
if(event.target.checked===true){_this.setState(_defineProperty({},name,event.target.checked));a[name]=true;p[name]=price;}if(event.target.checked===false){_this.setState(_defineProperty({},name,event.target.checked));a[name]=false;p[name]=0;}_this.setState({tempState:a,tempPrice:p});// console.log('lastS', this.state.tempState)
// console.log('lastP', this.state.tempPrice)
var tempcost=0;// console.log('ll', this.state.tempPrice[1])
Object.values(_this.state.tempPrice).map(function(price){return tempcost=tempcost+price;});_this.setState({cost:tempcost});// console.log('last=', a)
// console.log('2p', this.state.cost)
};};_this.handleTermsChangeChecked=function(name){return function(event){var _this$setState3;// console.log('terms1', this.state.terms)
// console.log('tt', event.target.checked)
var val=void 0;if(event.target.checked){val=true;}else{val=false;}_this.setState((_this$setState3={},_defineProperty(_this$setState3,name,event.target.checked),_defineProperty(_this$setState3,'terms',val),_this$setState3));// console.log('terms2', this.state.terms)
};};_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));// if (e.target.value != '') {
// }
};};_this.handleChangePlan=function(event){_this.setState({clientPlan:event.target.value});};_this.handleChange=function(tempState){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _ref2,data,a,p,tempcost;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.client.query({query:GET_FEATURE_BY_PLAN,variables:{planid:parseInt(event.target.value,10)}});case 2:_ref2=_context.sent;data=_ref2.data;// console.log('res=', data)
// console.log('tempState=', tempState)
a=Object.assign({},tempState);p=Object.assign({},_this.state.tempPrice);// console.log('all=', this.state.featuresList.features)
_this.state.featuresList.features.forEach(function(allFeatures){a[allFeatures.id]=false;p[allFeatures.id]=0;});data.getPlans.featureList.forEach(function(defaultFeature){a[defaultFeature.id]=true;p[defaultFeature.id]=defaultFeature.costPerAssetPerMonth;// console.log('uuuu', this.state.tempState[[defaultFeature.id]])
});_this.setState({plan:event.target.value,defaultFeatures:data,tempState:a,tempPrice:p});tempcost=0;// console.log('ll', this.state.tempPrice[1])
Object.values(_this.state.tempPrice).map(function(price){return tempcost=tempcost+price;});_this.setState({cost:tempcost});// console.log('last=', a)
// console.log('2p', this.state.cost)
case 12:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();};_this.handleCancelClick=function(e){_this.setState({isCancelConfDialogOpen:true});};_this.handleSubmitClick=function(e){_this.setState({isSubmitConfDialogOpen:true});};_this.handleCancelNegativeResponse=function(e){_this.setState({isCancelConfDialogOpen:false});};_this.handleSaveNegativeResponse=function(e){_this.setState({isSubmitConfDialogOpen:false});};_this.cancelNewPlan=function(e){_this.props.history.goBack();};_this.handleSubmit=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(event){var checkedlist,selCost,_ref4,data,errors;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:checkedlist=[];Object.keys(_this.state.tempState).forEach(function(price){if(_this.state.tempState[price]){var temp={};temp['featureId']=price;checkedlist.push(temp);}});selCost=0;if(_this.state.featuresList){_this.state.featuresList.features.map(function(featuresList){return selCost=selCost+_this.state.tempPrice[featuresList.id];});}if(!(_this.state.tempState[8]&&_this.state.tempState[24])){_context2.next=8;break;}_this.props.openSnackbar('Select Any one map');_context2.next=19;break;case 8:if(!(_this.state.terms===true&&_this.state.planName!==''&&_this.state.description!==''&&checkedlist.length!==0)){_context2.next=18;break;}_context2.next=11;return _this.props.client.mutate({mutation:ADD_PLANS,variables:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_16__utils_getLoginId__["a" /* default */])(),planName:_this.state.planName,description:_this.state.description,featureList:JSON.stringify(checkedlist),costPerAsset:parseInt(selCost,10)},errorPolicy:'all'});case 11:_ref4=_context2.sent;data=_ref4.data;errors=_ref4.errors;console.log(errors,data,'result');if(data){_this.setState({planName:'',description:'',featureList:'',costPerAsset:''});_this.props.openSnackbar('Plan Created Sucessfully');_this.props.history.goBack();}else if(errors){_this.props.openSnackbar(errors[0].message);}_context2.next=19;break;case 18:if(_this.state.terms===false&&_this.state.planName!==''&&_this.state.description!==''){_this.props.openSnackbar('Accept terms and conditions');}else if(_this.state.isPlanValid===false){_this.props.openSnackbar('Invalid Plan Name');}else{_this.props.openSnackbar('Fill details');}case 19:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref3.apply(this,arguments);};}();_this.getAllFeatures=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var response,tempState,tempPrice,tempcost;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return _this.props.client.query({query:GET_ALL_FEATURES});case 2:response=_context3.sent;if(response.data&&response.data.features){tempState={};tempPrice={};response.data.features.forEach(function(feature){tempState[feature.id]=false;tempPrice[feature.id]=0;});_this.setState({tempState:tempState,featuresList:response.data,tempPrice:tempPrice});tempcost=0;response.data.features.map(function(featuresList){return tempcost=tempcost+_this.state.tempPrice[featuresList.id];});_this.setState({cost:tempcost});}case 4:case'end':return _context3.stop();}}},_callee3,_this2);}));_this.checkPlanValidity=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){var regex;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:regex=new RegExp(/^[a-zA-Z0-9\s-_"]{4,20}$/);_this.setState({isPlanValid:regex.test(_this.state.planName)&&_this.state.planName!==''});case 2:case'end':return _context4.stop();}}},_callee4,_this2);}));_this.state={isSpeedLimitValid:true,planName:'',description:'',tempState:{},plan:'',featuresList:'',tempPrice:{},terms:false,message:'',isPlanValid:true,// basic: '',
partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_16__utils_getLoginId__["a" /* default */])()};return _this;}_createClass(AddPlan,[{key:'componentDidMount',value:function componentDidMount(){this.getAllFeatures();}},{key:'render',value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__common_ConfirmationDialog__["a" /* default */],{isDialogOpen:this.state.isSubmitConfDialogOpen,dialogMessage:'Are you sure you want to Save this new plan?',negativeResponseHandler:this.handleSaveNegativeResponse,positiveResponseHandler:this.handleSubmit}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__common_ConfirmationDialog__["a" /* default */],{isDialogOpen:this.state.isCancelConfDialogOpen,dialogMessage:'Are you sure you want to Cancel new plan creation?',negativeResponseHandler:this.handleCancelNegativeResponse,positiveResponseHandler:this.cancelNewPlan}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__material_ui_core_Button___default.a,{variant:'outlined',color:'secondary',className:classes.button,onClick:this.handleCancelClick},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_icons_ArrowBack___default.a,null))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Card___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_CardHeader___default.a,{title:'New Plan',subheader:'All fields marked with (*) are mandatory',subheaderTypographyProps:{className:classes.italicizedText}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,spacing:8},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:classes.fullWidth},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{fullWidth:true,id:'planName',name:'planName',margin:'none',label:'Plan Name',type:'text'// type="Multi-line"
,value:this.state.planName,required:true,onChange:this.handleInputChange('planName'),error:!this.state.isSpeedLimitValid,onBlur:this.checkSpeedLimitValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isSpeedLimitValid?'Invalid Speed Limit':'')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:classes.fullWidth},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{fullWidth:true,id:'description',name:'description',margin:'none',label:'Description',type:'text',value:this.state.description,required:true,onChange:this.handleInputChange('description'),error:!this.state.isSpeedLimitValid,onBlur:this.checkSpeedLimitValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isSpeedLimitValid?'Invalid Speed Limit':'')))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__material_ui_core_Divider___default.a,null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,spacing:8},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:classes.fullWidth},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel___default.a,{htmlFor:'plan-native-simple'},'Select from other plan'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Select___default.a,{fullWidth:true,value:this.state.plan,onChange:this.handleChange(this.state.tempState),inputProps:{name:'plan',id:'plan-native-simple'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default.a,{value:'1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'Basic')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default.a,{value:'2'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'Value')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default.a,{value:'3'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'Enterprise'))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__AllFeatures__["a" /* default */],{allFeaturesList:this.state.featuresList,tempState:this.state.tempState,handleChangeChecked:this.handleChangeChecked})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__material_ui_core_Divider___default.a,null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,spacing:8},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Basic__["a" /* default */],{allFeaturesList:this.state.featuresList,tempPrice:this.state.tempPrice,terms:this.state.terms,message:this.state.message,plan:this.state.plan,description:this.state.description,handleSubmit:this.handleSubmitClick,handleCancel:this.handleCancelClick,handleTermsChangeChecked:this.handleTermsChangeChecked}))))))))));}}]);return AddPlan;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_14_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_17__HOCs_withSharedSnackbar__["a" /* default */])(AddPlan))));

/***/ }),
/* 2049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Button__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles=function styles(theme){return{close:{width:theme.spacing.unit*4,height:theme.spacing.unit*4}};};var SimpleSnackbar=function(_React$Component){_inherits(SimpleSnackbar,_React$Component);function SimpleSnackbar(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SimpleSnackbar);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SimpleSnackbar.__proto__||Object.getPrototypeOf(SimpleSnackbar)).call.apply(_ref,[this].concat(args))),_this),_this.state={open:false},_this.handleClick=function(){return _this.props.handleSubmit();},_this.handleClose=function(event,reason){if(reason==='clickaway'){return;}_this.setState({open:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SimpleSnackbar,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Button___default.a,{onClick:this.props.handleSubmit,color:'secondary',variant:'contained'},'Submit'),'\xA0\xA0\xA0\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Button___default.a,{onClick:this.props.handleCancel,color:'secondary'},'Cancel'));}}]);return SimpleSnackbar;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);SimpleSnackbar.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__["withStyles"])(styles)(SimpleSnackbar));

/***/ }),
/* 2050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Dialog__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query {\n    allServiceProviders(status: 1) {\n      id\n      name\n    }\n  }\n'],['\n  query {\n    allServiceProviders(status: 1) {\n      id\n      name\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  mutation addSimDetail(\n    $phoneNumber: String!\n    $simNumber: String!\n    $service_provider_id: Int!\n  ) {\n    addSimDetail(\n      phoneNumber: $phoneNumber\n      simNumber: $simNumber\n      service_provider_id: $service_provider_id\n    )\n  }\n'],['\n  mutation addSimDetail(\n    $phoneNumber: String!\n    $simNumber: String!\n    $service_provider_id: Int!\n  ) {\n    addSimDetail(\n      phoneNumber: $phoneNumber\n      simNumber: $simNumber\n      service_provider_id: $service_provider_id\n    )\n  }\n']);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_PROVIDER=Object(__WEBPACK_IMPORTED_MODULE_11_graphql_tag__["a" /* default */])(_templateObject);// calling server for updation
var ADD_SIM=Object(__WEBPACK_IMPORTED_MODULE_11_graphql_tag__["a" /* default */])(_templateObject2);var styles=function styles(theme){return{button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{margin:theme.spacing.unit,minWidth:120}};};var AddSim=function(_Component){_inherits(AddSim,_Component);function AddSim(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AddSim);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AddSim.__proto__||Object.getPrototypeOf(AddSim)).call.apply(_ref,[this].concat(args))),_this),_this.state={open:false,open1:false,simprovider:'',phoneno:'',simno:'',isSimProviderValid:true,isphonenoValid:true,isSimnoValid:true},_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));};},_this.handleClickOpen=function(){_this.setState({open:true});},_this.handleClose=function(){_this.setState({open:false});},_this.handleChange=function(event){_this.setState(_defineProperty({},event.target.name,event.target.value));},_this.handleOpen=function(){_this.setState({open:true});},_this.handleOpenSelect=function(){_this.setState({open1:true});},_this.handleCloseSelect=function(){_this.setState({open1:false});},_this.checkSimnoValidity=function(){var regex=new RegExp(// eslint-disable-next-line
/^[0-9]+$/);// console.log('a', this.state.imeino)
// console.log(regex.test(this.state.imeino))
_this.setState({isSimnoValid:regex.test(_this.state.simno)||_this.state.simno===''// this.state.modelname === ''
});// console.log(this.state.isModelNameValid)
},_this.checkPhonenoValidity=function(){var regex=new RegExp(/^[0-9]+$/);_this.setState({isPhonenoValid:regex.test(_this.state.phoneno)||_this.state.phoneno===''});},_this.checkSimProviderValidity=function(){_this.setState({isSimProviderValid:_this.state.simprovider!==''});},_this.handleSubmit=function(addProvider){return function(e){e.preventDefault();addProvider({variables:{type:_this.state.simprovider}});// this.state.simprovider = ''
_this.setState({simprovider:''});};},_this.addBulkUpload=function(e){console.log('bulk');_this.props.history.push({pathname:'/home/SimInventory/BulkSimUpload'});},_this.assignBulkUpload=function(e){console.log('bulk');_this.props.history.push({pathname:'/home/SimInventory/BulkSimAssign'});},_this.createPlan=function(e){_this.props.history.push({pathname:'/home/CreatePlan'});},_this.viewLicense=function(e){_this.props.history.push({pathname:'/home/ViewLicense'});},_this.handleSubmit=function(addSim){return function(e){console.log('click fun');e.preventDefault();addSim({variables:{phoneNumber:_this.state.phoneno,simNumber:_this.state.simno,service_provider_id:parseInt(_this.state.simprovider,10)}});// this.state.simprovider = ''
_this.setState({phoneNumber:'',simNumber:'',service_provider_id:''});};},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AddSim,[{key:'render',value:function render(){var _this2=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_apollo__["Query"],{query:GET_PROVIDER},function(_ref2){var loading=_ref2.loading,error=_ref2.error,data=_ref2.data;var queriedData=data;if(loading)return'Loading...';if(error)return'Error!: '+error;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_apollo__["Mutation"],{mutation:ADD_SIM},function(addSim,_ref3){var data=_ref3.data,error=_ref3.error;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button___default.a,{onClick:_this2.handleClickOpen},'Add SIM'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button___default.a,{onClick:_this2.addBulkUpload},'Bulk Sim Upload'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button___default.a,{onClick:_this2.assignBulkUpload},'Assign Sim Upload'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button___default.a,{onClick:_this2.createPlan},'Create License'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button___default.a,{onClick:_this2.viewLicense},'View License'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Dialog___default.a,{open:_this2.state.open,onClose:_this2.handleClose,'aria-labelledby':'form-dialog-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle___default.a,{id:'form-dialog-title'},'Add SIM Details :',' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["Typography"],{variant:'subheading',gutterBottom:true,style:{color:'red',marginLeft:'25px'}},error&&error.graphQLErrors.map(function(_ref4,i){var message=_ref4.message;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:i},message);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["Typography"],{variant:'subheading',gutterBottom:true,style:{color:'green',marginLeft:'25px'}},data&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Sucessfully Added')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:_this2.handleSubmit(addSim)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText___default.a,null,'* Marked fields are mandatory'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_InputLabel___default.a,{htmlFor:'demo-controlled-open-select'},'Sim Provider'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select___default.a,{open:_this2.state.open1,fullWidth:true,onClose:_this2.handleCloseSelect,onOpen:_this2.handleOpenSelect,value:_this2.state.simprovider,onChange:_this2.handleChange,onBlur:_this2.checkSimProviderValidity,inputProps:{name:'simprovider',id:'simprovider'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'None')),queriedData.allServiceProviders.map(function(allServiceProvidersByStatus){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{value:allServiceProvidersByStatus.id,key:allServiceProvidersByStatus.id},allServiceProvidersByStatus.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'phoneno',name:'phoneno',label:'Phone No',type:'text',required:true,value:_this2.state.phoneno,fullWidth:true,onChange:_this2.handleInputChange('phoneno'),error:!_this2.state.isphonenoValid,onBlur:_this2.checkPhonenoValidity})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'simno',name:'simno',label:'SIM No',type:'text',required:true,fullWidth:true,value:_this2.state.simno,onChange:_this2.handleInputChange('simno'),error:!_this2.state.isSimnoValid,onBlur:_this2.checkSimnoValidity}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button___default.a,{onClick:_this2.handleClose,color:'primary'},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button___default.a// onClick={this.handleClose}
,{color:'primary',type:'submit',disabled:!(_this2.state.isSimProviderValid&&_this2.state.isSimnoValid&&_this2.state.isphonenoValid&&_this2.state.phoneno!==''&&_this2.state.simno!=='')},'Submit')))));});});}}]);return AddSim;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles__["withStyles"])(styles)(AddSim));

/***/ }),
/* 2051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Dialog__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogActions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContent__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__EditProvider_jsx__ = __webpack_require__(2052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_styles__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  mutation addServiceProvider($name: String!) {\n    addServiceProvider(name: $name)\n  }\n'],['\n  mutation addServiceProvider($name: String!) {\n    addServiceProvider(name: $name)\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query {\n    provider: allServiceProviders(status: 1) {\n      id\n      name\n    }\n  }\n'],['\n  query {\n    provider: allServiceProviders(status: 1) {\n      id\n      name\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query serviceProvider($id: Int) {\n    serviceProvider(id: $id) {\n      name\n    }\n  }\n'],['\n  query serviceProvider($id: Int) {\n    serviceProvider(id: $id) {\n      name\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// calling server for updation
var ADD_PROVIDER=Object(__WEBPACK_IMPORTED_MODULE_9_graphql_tag__["a" /* default */])(_templateObject);var GET_PROVIDER=Object(__WEBPACK_IMPORTED_MODULE_9_graphql_tag__["a" /* default */])(_templateObject2);var GET_PROVIDER_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_9_graphql_tag__["a" /* default */])(_templateObject3);var styles=function styles(theme){return{button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{margin:theme.spacing.unit,minWidth:120}};};var AddProvider=function(_Component){_inherits(AddProvider,_Component);function AddProvider(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,AddProvider);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AddProvider.__proto__||Object.getPrototypeOf(AddProvider)).call.apply(_ref,[this].concat(args))),_this),_this.state={open:false,open1:false,open2:false,provider:'',isProviderValid:true,providerDetails:[],providerStatus:false,pId:''},_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));};},_this.handleClickOpen=function(){_this.setState({open:true});},_this.handleClose=function(){_this.setState({open:false});},_this.handleChange=function(event){_this.setState(_defineProperty({},event.target.name,event.target.value));},_this.handleOpen=function(){_this.setState({open:true});},_this.checkProviderValidity=function(){var regex=new RegExp(// eslint-disable-next-line
/^(?!\s)(?!.*\s$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9 '~?!]{2,}$/);console.log('a',_this.state.provider);console.log(regex.test(_this.state.provider));_this.setState({isProviderValid:regex.test(_this.state.provider)||_this.state.provider===''// this.state.modelname === ''
});console.log(_this.state.isProviderValid);},_this.handleSubmit=function(addProvider){return function(e){// console.log('click fun', addProvider)
// console.log(this.state.simprovider)
e.preventDefault();addProvider({variables:{name:_this.state.provider}});// this.state.simprovider = ''
// this.setState({
//   simprovider: ''
// })
};},_this.clientId=[],_this.fullData=[],_this.columns=['Sl.No','Provider Name','Edit'],_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15},_this.getProviderDetails=function(providerId){return _asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _ref3,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:console.log('providerId',providerId);_context.next=3;return _this.props.client.query({query:GET_PROVIDER_DETAILS,variables:{id:parseInt(providerId,10)}});case 3:_ref3=_context.sent;data=_ref3.data;_this.setState({providerDetails:data,providerStatus:true,pId:parseInt(providerId,10)});console.log('data',data,_this.state.providerDetails);case 7:case'end':return _context.stop();}}},_callee,_this2);}));},_this.closeEditProvider=function(){_this.setState({providerStatus:false});},_this.providerEditForm=function(pid){alert(pid);_this.setState({open2:true});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AddProvider,[{key:'mapToArr',value:function mapToArr(provider){var _this3=this;var rowData=[];this.fullData=[];this.simId=[];var i=1;console.log('mee=',provider);provider.forEach(function(element){rowData=[];rowData.push(i);rowData.push(element.name);rowData.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:_this3.getProviderDetails(element.id)},'Edit'));_this3.fullData.push(rowData);i++;});// console.log('rowDta=', rowData)
}},{key:'render',value:function render(){var _this4=this;// const { classes } = this.props
console.log('render=',this.state.providerDetails);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_apollo__["Query"],{query:GET_PROVIDER},function(_ref4){var loading=_ref4.loading,error=_ref4.error,allServiceProviders=_ref4.data.provider;if(loading)return'Loading...';if(error)return'Error! '+error.message;console.log('allServiceProviders',allServiceProviders);var columnData=allServiceProviders;_this4.mapToArr(columnData);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,_this4.state.providerStatus===true&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__EditProvider_jsx__["a" /* default */],{providerInfo:_this4.state.providerDetails.serviceProvider,openStatus:_this4.state.providerStatus,closeEditProviderFunction:_this4.closeEditProvider,selectedId:_this4.state.pId}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_apollo__["Mutation"],{mutation:ADD_PROVIDER},function(addProvider,_ref5){var data=_ref5.data,error=_ref5.error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'list_items'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{color:'primary',onClick:_this4.handleClickOpen,variant:'contained',className:_this4.props.classes.button},'Add Service Provider'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_mui_datatables___default.a,{title:'SIM Provider Details',data:_this4.fullData,columns:_this4.columns,options:_this4.options}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Dialog___default.a,{open:_this4.state.open,onClose:_this4.handleClose,'aria-labelledby':'form-dialog-title'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle___default.a,{id:'form-dialog-title'},'Add Service Provider :'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["Typography"],{variant:'subheading',gutterBottom:true,style:{color:'red',marginLeft:'25px'}},error&&error.graphQLErrors.map(function(_ref6,i){var message=_ref6.message;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{key:i},message);})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["Typography"],{variant:'subheading',gutterBottom:true,style:{color:'green',marginLeft:'25px'}},data&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Sucessfully Added')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{onSubmit:_this4.handleSubmit(addProvider)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'provider',name:'provider',label:'SIM Provider',type:'text',required:true,value:_this4.state.provider// fullWidth
,onChange:_this4.handleInputChange('provider'),error:!_this4.state.isProviderValid,onBlur:_this4.checkProviderValidity}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogActions___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:_this4.handleClose,color:'default',variant:'contained'},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a// onClick={this.handleClose}
,{type:'submit',color:'primary',variant:'contained',disabled:!(_this4.state.isProviderValid&&_this4.state.provider!=='')},'Submit')))));}));});}}]);return AddProvider;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_10_react_apollo__["withApollo"])(AddProvider)));

/***/ }),
/* 2052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Modal__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogActions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_DialogContent__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_DialogContentText__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_DialogContentText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_DialogContentText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__HOCs_withSharedSnackbar__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  mutation updateServiceProvider($providerName: String!) {\n    updateServiceProvider(providerName: $providerName)\n  }\n'],['\n  mutation updateServiceProvider($providerName: String!) {\n    updateServiceProvider(providerName: $providerName)\n  }\n']);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var UPDATE_PROVIDER=Object(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__["a" /* default */])(_templateObject);function getModalStyle(){var top=50;var left=50;return{top:top+'%',left:left+'%',transform:'translate(-'+top+'%, -'+left+'%)'};}var styles=function styles(theme){return{paper:{position:'absolute',width:theme.spacing.unit*50,backgroundColor:theme.palette.background.paper,boxShadow:theme.shadows[5],padding:theme.spacing.unit*4}};};var EditProvider=function(_React$Component){_inherits(EditProvider,_React$Component);function EditProvider(props){_classCallCheck(this,EditProvider);var _this=_possibleConstructorReturn(this,(EditProvider.__proto__||Object.getPrototypeOf(EditProvider)).call(this,props));_this.handleSubmit=function(EditModel){return function(e){// console.log('this.modelId=', this.state.modelId, this.state.modelname, this.state.version, this.state.devicetype, this.state.description, this.state.maxPrice)
e.preventDefault();EditModel({variables:{id:parseInt(_this.state.providerId,10),providerName:_this.state.providerName}});_this.setState({providerName:'',providerId:''});_this.props.closeEditProviderFunction();_this.props.openSnackbar('Provider Updated Successfully');};};_this.checkProviderValidity=function(){var regex=new RegExp(// eslint-disable-next-line
/^(?!\s)(?!.*\s$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9 '~?!]{2,}$/);console.log('a',_this.state.provider);console.log(regex.test(_this.state.provider));_this.setState({isProviderValid:regex.test(_this.state.provider)||_this.state.provider===''// this.state.modelname === ''
});console.log(_this.state.isProviderValid);};_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));};};_this.handleOpenSelect=function(){_this.setState({open1:true});};_this.handleCloseSelect=function(){_this.setState({open1:false});};_this.handleChange=function(event){_this.setState(_defineProperty({},event.target.name,event.target.value));};_this.providerInformation=_this.props.providerInfo;console.log('this.props.selectedId= ',_this.props.providerInfo);_this.state={providerName:_this.providerInformation.name,providerId:_this.props.selectedId,open1:false,isProviderValid:true};return _this;}_createClass(EditProvider,[{key:'render',value:function render(){var _this2=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,null,'Edit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Modal___default.a,{'aria-labelledby':'simple-modal-title','aria-describedby':'simple-modal-description',open:this.props.openStatus// onClose={this.handleClose}
},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:getModalStyle(),className:classes.paper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["Mutation"],{mutation:UPDATE_PROVIDER,errorPolicy:'all'},function(EditProvider,_ref){var data=_ref.data,loading=_ref.loading,error=_ref.error;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:_this2.handleSubmit(EditProvider)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_DialogContentText___default.a,null,'* Marked fields are mandatory'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'provider',name:'provider',label:'SIM Provider',type:'text',required:true,value:_this2.state.providerName,fullWidth:true,onChange:_this2.handleInputChange('providerName'),error:!_this2.state.isProviderValid,onBlur:_this2.checkProviderValidity}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogActions___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{onClick:_this2.props.closeEditProviderFunction,color:'default',variant:'contained'},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a// onClick={this.handleClose}
,{color:'primary',variant:'contained',type:'submit'// disabled={
//   !(
//     this.state.isVersionValid &&
//     this.state.isDeviceTypeValid &&
//     this.state.modelname !== '' &&
//     this.state.version !== '' &&
//     this.state.maxPrice !== '' &&
//     this.state.ismaxPriceValid
//   )
// }
},'Submit')));}))));}}]);return EditProvider;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);EditProvider.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired// We need an intermediary variable for handling the recursive nesting.
};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_12__HOCs_withSharedSnackbar__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["withApollo"])(EditProvider))));

/***/ }),
/* 2053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormHelperText__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormHelperText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormHelperText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Input__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__AddPartner_css__ = __webpack_require__(2054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__AddPartner_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__AddPartner_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Countries__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__States__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_core_Card__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_core_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core_CardHeader__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core_CardHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_CardHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_core_CardContent__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_core_CardContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_CardContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__material_ui_core_CardActions__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__material_ui_core_CardActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__material_ui_core_CardActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__common_ConfirmationDialog__ = __webpack_require__(65);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getStatesByCountryId($countryId: Int!) {\n    allStatesByCountryId(country_id: $countryId) {\n      name\n      zone_id\n    }\n  }\n'],['\n  query getStatesByCountryId($countryId: Int!) {\n    allStatesByCountryId(country_id: $countryId) {\n      name\n      zone_id\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query checkUsername($username: String!) {\n    checkUsername(username: $username)\n  }\n'],['\n  query checkUsername($username: String!) {\n    checkUsername(username: $username)\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query($businessname: String!) {\n    checkBusinessName(businessName: $businessname)\n  }\n'],['\n  query($businessname: String!) {\n    checkBusinessName(businessName: $businessname)\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query checkPartnerContactNumber($phoneno: String!) {\n    checkPartnerContactNumber(contactNumber: $phoneno)\n  }\n'],['\n  query checkPartnerContactNumber($phoneno: String!) {\n    checkPartnerContactNumber(contactNumber: $phoneno)\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  query checkPartnerEmail($email: String!) {\n    checkPartnerEmail(email: $email)\n  }\n'],['\n  query checkPartnerEmail($email: String!) {\n    checkPartnerEmail(email: $email)\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  query checkPartnerPanNumber($pan: String!) {\n    checkPartnerPanNumber(panNumber: $pan)\n  }\n'],['\n  query checkPartnerPanNumber($pan: String!) {\n    checkPartnerPanNumber(panNumber: $pan)\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  mutation partnerSignup(\n    $username: String!\n    $password: String!\n    $accountType: String!\n    $businessName: String!\n    $email: String!\n    $contactPerson: String!\n    $contactNumber: String!\n    $billingMode: Int!\n    $address: String!\n    $city: String!\n    $state: Int!\n    $country: Int!\n    $pincode: Int!\n    $panNumber: String!\n    $partnerType: String!\n    $typeOfPartner: ClientPartnerType!\n    $salesPersonId: Int!\n    $solution: Solution!\n  ) {\n    partnerSignup(\n      username: $username\n      password: $password\n      accountType: $accountType\n      businessName: $businessName\n      email: $email\n      contactPerson: $contactPerson\n      contactNumber: $contactNumber\n      billingMode: $billingMode\n      address: $address\n      city: $city\n      state: $state\n      country: $country\n      pincode: $pincode\n      panNumber: $panNumber\n      partnerType: $partnerType\n      typeOfPartner: $typeOfPartner\n      salesPersonId: $salesPersonId\n      solution: $solution\n    )\n  }\n'],['\n  mutation partnerSignup(\n    $username: String!\n    $password: String!\n    $accountType: String!\n    $businessName: String!\n    $email: String!\n    $contactPerson: String!\n    $contactNumber: String!\n    $billingMode: Int!\n    $address: String!\n    $city: String!\n    $state: Int!\n    $country: Int!\n    $pincode: Int!\n    $panNumber: String!\n    $partnerType: String!\n    $typeOfPartner: ClientPartnerType!\n    $salesPersonId: Int!\n    $solution: Solution!\n  ) {\n    partnerSignup(\n      username: $username\n      password: $password\n      accountType: $accountType\n      businessName: $businessName\n      email: $email\n      contactPerson: $contactPerson\n      contactNumber: $contactNumber\n      billingMode: $billingMode\n      address: $address\n      city: $city\n      state: $state\n      country: $country\n      pincode: $pincode\n      panNumber: $panNumber\n      partnerType: $partnerType\n      typeOfPartner: $typeOfPartner\n      salesPersonId: $salesPersonId\n      solution: $solution\n    )\n  }\n']),_templateObject8=_taggedTemplateLiteral(['\n  query getAllSalesPerson($partnerLoginId: Int) {\n    getAllSalesPerson(partnerLoginId: $partnerLoginId) {\n      id\n      name\n    }\n  }\n'],['\n  query getAllSalesPerson($partnerLoginId: Int) {\n    getAllSalesPerson(partnerLoginId: $partnerLoginId) {\n      id\n      name\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_STATES_FOR_COUNTRY=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject);// username validation
var GET_USERNAME=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject2);// Business name validation
var GET_BUSINESSNAME=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject3);// Business name validation
var GET_CONTACTNO=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject4);// Business email validation
var GET_EMAIL=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject5);// Business pan validation
var GET_PAN_NUMBER=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject6);// calling server for updation
var ADD_PARTNER=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject7);var GET_ALL_SALESPERSON=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject8);var BILLING_MODES=[{value:1,label:'PREPAID'},{value:2,label:'POSTPAID'}];var AddPartner=function(_Component){_inherits(AddPartner,_Component);function AddPartner(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,AddPartner);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AddPartner.__proto__||Object.getPrototypeOf(AddPartner)).call.apply(_ref,[this].concat(args))),_this),_this.state={businessname:'',country:'',email:'',phoneno:'',contactp:'',address:'',city:'',state:'',pin:'',pan:'',clttype:'',username:'',isEmailValid:true,isBusinessNameValid:true,isPhonenoValid:true,isContactpValid:true,isAddressValid:true,isCityValid:true,isCountryValid:true,isStateValid:true,isPinValid:true,isPanValid:true,isUsernameValid:true,isCltTypeValid:true,isCancelConfDialogOpen:false,isSaveConfDialogOpen:false,getCountryId:'',getStatesId:[],password:'Tracking123',isUsernameAvailable:'',typeOfPartner:'REAL',billingMode:'',allSalesPerson:[],salesPerson:'',domainName:'',panNoRes:'',phoneNoRes:'',nameRes:'',emailRes:'',userNameRes:'',allSolution:[{value:'API',label:'API'},{value:'PORTAL',label:'PORTAL'}],solution:''},_this.handleSaveClick=function(e){_this.setState({isSaveConfDialogOpen:true});},_this.handleCancelNegativeResponse=function(e){_this.setState({isCancelConfDialogOpen:false});},_this.handleSaveNegativeResponse=function(e){_this.setState({isSaveConfDialogOpen:false});},_this.cancelForm=function(e){_this.props.history.goBack();},_this.handleCancelClick=function(e){_this.setState({isCancelConfDialogOpen:true});},_this.handleInputChange=function(name){return function(e){return _this.setState(_defineProperty({},name,e.target.value));};},_this.handleChange=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _ref3,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:// console.log(event.target.value)
_this.setState({country:event.target.value});_context.next=3;return _this.props.client.query({query:GET_STATES_FOR_COUNTRY,variables:{countryId:event.target.value}});case 3:_ref3=_context.sent;data=_ref3.data;_context.next=7;return _this.onCountryFetched(data.allStatesByCountryId);case 7:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}(),_this.handleStateChange=function(state){_this.setState({state:state.value},function(){return console.log('state',_this.state.state);});},_this.handleCountryChange=function(country){// console.log('counter', country)
if(!country){_this.setState({state:'',country:''});}else{_this.setState({state:'',country:country.value});}},_this.handleChangeState=function(event){return _this.setState({state:event.target.value});},_this.handleChangeclt=function(event){return _this.setState({clttype:event.target.value});},_this.checkBusinessNameValidity=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(event){var regex,_ref5,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:console.log('gggg');regex=new RegExp(/^(?!\s)(?!.*\s$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9 '~?!]{5,32}$/);_context2.next=4;return _this.props.client.query({query:GET_BUSINESSNAME,variables:{businessname:_this.state.businessname}});case 4:_ref5=_context2.sent;data=_ref5.data;_this.setState({isBusinessNameValid:regex.test(_this.state.businessname)&&_this.state.businessname!==''&&data.checkBusinessName==='AVAILABLE'});if(regex.test(_this.state.businessname)===false){_this.setState({nameRes:'Invalid Business Name'});}else if(data.checkBusinessName!=='AVAILABLE'){_this.setState({nameRes:'Business name already exist'});}case 8:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref4.apply(this,arguments);};}(),_this.checkEmailValidity=function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(event){var regex,_ref7,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:regex=new RegExp(// eslint-disable-next-line
/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);_context3.next=3;return _this.props.client.query({query:GET_EMAIL,variables:{email:_this.state.email}});case 3:_ref7=_context3.sent;data=_ref7.data;_this.setState({isEmailValid:regex.test(_this.state.email)&&_this.state.email!==''&&data.checkPartnerEmail==='AVAILABLE'});if(regex.test(_this.state.email)===false){_this.setState({emailRes:'Invalid email id'});}else if(data.checkPartnerEmail!=='AVAILABLE'){_this.setState({emailRes:'Email already exist'});}case 7:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x3){return _ref6.apply(this,arguments);};}(),_this.checkPhonenoValidity=function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(event){var regex,_ref9,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:// const regex = new RegExp(
//   // eslint-disable-next-line
//   /^(\+91[-\s]?)?[0]?(91)?[789]\d{9}$/
// )
console.log('hgfjagf');regex=new RegExp(/^(\+91[-\s]?)?[0]?(91)?[1-9]\d{9,10}$/);_context4.next=4;return _this.props.client.query({query:GET_CONTACTNO,variables:{phoneno:_this.state.phoneno}});case 4:_ref9=_context4.sent;data=_ref9.data;_this.setState({isPhonenoValid:regex.test(_this.state.phoneno)&&_this.state.phoneno!==''&&data.checkPartnerContactNumber==='AVAILABLE'});if(regex.test(_this.state.phoneno)===false){_this.setState({phoneNoRes:'Invalid phone number'});}else if(data.checkPartnerContactNumber!=='AVAILABLE'){_this.setState({phoneNoRes:'Phone number already exist'});}case 8:case'end':return _context4.stop();}}},_callee4,_this2);}));return function(_x4){return _ref8.apply(this,arguments);};}(),_this.checkContactpValidity=function(){var regex=new RegExp(/^[a-zA-Z\s]{5,32}$/);_this.setState({isContactpValid:regex.test(_this.state.contactp)||_this.state.contactp===''});},_this.checkAddressValidity=function(){var regex=new RegExp(/^[a-zA-Z0-9\s,.'-]{3,300}$/);_this.setState({isAddressValid:regex.test(_this.state.address)||_this.state.address!==''});},_this.checkCityValidity=function(){var regex=new RegExp(/^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/);_this.setState({isCityValid:regex.test(_this.state.city)&&_this.state.city!==''&&parseInt(_this.state.city.length,10)<16});},_this.checkPinValidity=function(){var regex=new RegExp(/^[1-9][0-9]{5}$/);_this.setState({isPinValid:regex.test(_this.state.pin)||_this.state.pin!==''});},_this.checkPanValidity=function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(event){var regex,_ref11,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:regex=new RegExp(/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/);_this.setState({panNoRes:''});_context5.next=4;return _this.props.client.query({query:GET_PAN_NUMBER,variables:{pan:_this.state.pan}});case 4:_ref11=_context5.sent;data=_ref11.data;_this.setState({isPanValid:regex.test(_this.state.pan)&&_this.state.pan!==''&&data.checkPartnerPanNumber==='AVAILABLE'});if(regex.test(_this.state.pan)===false){_this.setState({panNoRes:'Invalid pan number'});}else if(data.checkClientPanNumber!=='AVAILABLE'){_this.setState({panNoRes:'Pan number already exist'});}case 8:case'end':return _context5.stop();}}},_callee5,_this2);}));return function(_x5){return _ref10.apply(this,arguments);};}(),_this.checkUsernameValidity=function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(event){var regex,_ref13,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_this.setState({userNameRes:''});// const regex = new RegExp(/^[a-zA-Z0-9.\-_$@*!]{3,30}$/)
regex=new RegExp(/^[a-zA-Z0-9.\-_$@*!]{5,32}$/);_context6.next=4;return _this.props.client.query({query:GET_USERNAME,variables:{username:_this.state.username}});case 4:_ref13=_context6.sent;data=_ref13.data;_this.setState({isUsernameValid:regex.test(_this.state.username)&&_this.state.username!==''&&data.checkUsername==='AVAILABLE'});_this.setState({isUsernameAvailable:data.checkUsername});if(regex.test(_this.state.username)===false){_this.setState({userNameRes:'Invalid user name'});}else if(data.checkUsername!=='AVAILABLE'){_this.setState({userNameRes:'User name already exist'});}console.log('un',_this.state.isUsernameValid);if(_this.state.isUsernameValid&&_this.state.isUsernameAvailable==='AVAILABLE'){_this.setState({inventoryUsername:_this.state.username+'_INV',accountsUsername:_this.state.username+'_ACC',serviceUsername:_this.state.username+'_SER',salesUsername:_this.state.username+'_SAL',inventoryPassword:_this.state.username+'@INV',accountsPassword:_this.state.username+'@ACC',servicePassword:_this.state.username+'@SER',salesPassword:_this.state.username+'@SAL'});}else{_this.setState({inventoryUsername:'',accountsUsername:'',serviceUsername:'',salesUsername:'',inventoryPassword:'',accountsPassword:'',servicePassword:'',salesPassword:''});}case 11:case'end':return _context6.stop();}}},_callee6,_this2);}));return function(_x6){return _ref12.apply(this,arguments);};}(),_this.checkCountryValidity=function(){_this.setState({isCountryValid:_this.state.country!==''});},_this.checkStateValidity=function(){_this.setState({isStateValid:_this.state.state!==''});},_this.checkCltTypeValidity=function(){_this.setState({isCltTypeValid:_this.state.clttype!==''});},_this.onCountryFetched=function(){var _ref14=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(getStatesId){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:return _context7.abrupt('return',_this.setState({getStatesId:getStatesId}));case 1:case'end':return _context7.stop();}}},_callee7,_this2);}));return function(_x7){return _ref14.apply(this,arguments);};}(),_this.hanldeBillingModeChange=function(event){_this.setState({billingMode:event.target.value});},_this.handleSalesPersonChange=function(event){if(!event){_this.setState({salesPerson:''});}else{_this.setState({salesPerson:event.target.value});}},_this.handleSolutionChange=function(event){if(!event){_this.setState({solution:''});}else{_this.setState({solution:event.target.value});}},_this.handleSubmit=function(){var _ref15=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(e){var _ref16,data,errors;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:e.preventDefault();_context8.next=3;return _this.props.client.mutate({mutation:ADD_PARTNER,variables:{username:_this.state.username,password:_this.state.password,accountType:'PA',businessName:_this.state.businessname,email:_this.state.email,contactPerson:_this.state.contactp,contactNumber:_this.state.phoneno,address:_this.state.address,city:_this.state.city,state:parseInt(_this.state.state,10),country:parseInt(_this.state.country,10),pincode:parseInt(_this.state.pin,10),panNumber:_this.state.pan,partnerType:_this.state.clttype,typeOfPartner:_this.state.typeOfPartner,billingMode:_this.state.billingMode,salesPersonId:_this.state.salesPerson,solution:_this.state.solution},refetchQueries:['allPartnerDetails']});case 3:_ref16=_context8.sent;data=_ref16.data;errors=_ref16.errors;if(data.partnerSignup){// console.log('registration successful')
_this.props.openSnackbar('Registered Successfully');_this.props.history.push({pathname:'/home/users/partner'});}else{_this.props.openSnackbar('Registartion Failed');}_this.setState({username:'',businessname:'',contactNumber:'',email:'',contactPerson:'',address:'',city:'',state:'',country:'',pincode:'',panNumber:'',partnerType:'',billingMode:'',salesPerson:'',typeOfPartner:'REAL',solution:''});// if (data.partnerSignup && this.state.domainName !== '') {
//   const { data: whiteLabel } = await this.props.client.mutate({
//     mutation: ADD_DOMAIN_CONFIGURATION,
//     variables: {
//       domainName: this.state.domainName,
//       header: {
//         title: this.state.pageTitle,
//         shortcutIcon: this.state.faviconLink
//       },
//       page: {
//         logo: this.state.logo
//       },
//       customPage: false
//     }
//   })
//   //   if (whiteLabel.addDomainConfiguration.domain) {
//   //     this.props.openSnackbar('Registered Successfully')
//   //   } else {
//   //     this.props.openSnackbar(errors[0].message)
//   //   }
//   //   this.setState({
//   //     username: '',
//   //     businessname: '',
//   //     contactNumber: '',
//   //     email: '',
//   //     contactPerson: '',
//   //     address: '',
//   //     city: '',
//   //     state: '',
//   //     country: '',
//   //     pincode: '',
//   //     panNumber: '',
//   //     partnerType: '',
//   //     billingMode: '',
//   //     salesPerson: '',
//   //     typeOfPartner: 'REAL'
//   //   })
//   // } else {
//   // if (data.partnerSignup) {
//   //   console.log('registration successful')
//   //   this.props.openSnackbar('Registered Successfully')
//   // } else {
//   //   this.props.openSnackbar('Registartion Failed')
//   // }
//   // this.setState({
//   //   username: '',
//   //   businessname: '',
//   //   contactNumber: '',
//   //   email: '',
//   //   contactPerson: '',
//   //   address: '',
//   //   city: '',
//   //   state: '',
//   //   country: '',
//   //   pincode: '',
//   //   panNumber: '',
//   //   partnerType: '',
//   //   billingMode: '',
//   //   salesPerson: '',
//   //   typeOfPartner: 'REAL'
//   // })
// }
case 8:case'end':return _context8.stop();}}},_callee8,_this2);}));return function(_x8){return _ref15.apply(this,arguments);};}(),_this.getAllSalesPersonDetails=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(){var fetchSalesPersonData,getAllSalesPerson,salesPersonsDetails;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.next=2;return _this.props.client.query({query:GET_ALL_SALESPERSON,variables:{// partnerLoginId: getLoginId()
partnerLoginId:2}});case 2:fetchSalesPersonData=_context9.sent;getAllSalesPerson=fetchSalesPersonData.data.getAllSalesPerson;salesPersonsDetails=getAllSalesPerson.map(function(salesPerson){return{value:salesPerson.id,label:salesPerson.name};});_this.setState({allSalesPerson:salesPersonsDetails},function(){console.log('all sales person',_this.state.allSalesPerson,Object(__WEBPACK_IMPORTED_MODULE_12__utils_getLoginId__["a" /* default */])());});case 6:case'end':return _context9.stop();}}},_callee9,_this2);})),_this.componentDidMount=function(){_this.getAllSalesPersonDetails();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AddPartner,[{key:'handleStateRender',value:function handleStateRender(){if(this.state.country){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__States__["a" /* default */],{countryId:this.state.country,zoneId:this.state.state,handleStateChange:this.handleStateChange})));}}},{key:'render',value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'Landing'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__common_ConfirmationDialog__["a" /* default */],{isDialogOpen:this.state.isSaveConfDialogOpen,dialogMessage:"Are you sure you want to Save this customer's details?",negativeResponseHandler:this.handleSaveNegativeResponse,positiveResponseHandler:this.handleSubmit}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__common_ConfirmationDialog__["a" /* default */],{isDialogOpen:this.state.isCancelConfDialogOpen,dialogMessage:'Are you sure you want to Cancel customer registration?',negativeResponseHandler:this.handleCancelNegativeResponse,positiveResponseHandler:this.cancelForm}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,justify:'center',className:'full-screen',alignItems:'flex-end'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Card___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_CardHeader___default.a,{title:'Register Partner',subheader:'All fields marked with (*) are mandatory'// subheaderTypographyProps={{
//   className: classes.italicizedText
// }}
}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'formouter'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,md:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'businessname',name:'businessname',className:'textfield',margin:'dense',label:'Business Name',value:this.state.businessname,required:true,onChange:this.handleInputChange('businessname'),error:!this.state.isBusinessNameValid,onBlur:this.checkBusinessNameValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isBusinessNameValid?this.state.nameRes:''))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,md:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core__["RadioGroup"],{'aria-label':'position',name:'position',value:this.state.typeOfPartner,onChange:this.handleInputChange('typeOfPartner'),row:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core__["FormControlLabel"],{value:'REAL',control:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core__["Radio"],{color:'primary'}),label:'Billable',labelPlacement:'end'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core__["FormControlLabel"],{value:'DEMO',control:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core__["Radio"],{color:'primary'}),label:'Non-Billable',labelPlacement:'end'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core__["InputLabel"],{htmlFor:'selectLabel'},'Select Type'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Select___default.a,{value:this.state.clttype,onChange:this.handleChangeclt,name:'Select Type',error:!this.state.isCltTypeValid,onBlur:this.checkCltTypeValidity,input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Input___default.a,{name:'clttype',id:'age-helper'})},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_MenuItem___default.a,{value:'Franchise'},'Franchisee'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_MenuItem___default.a,{value:'Assosciates'},'Associate'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_MenuItem___default.a,{value:'Channel Partner'},'Channel Partner')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isCltTypeValid?'Invalid Selection':''))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'email',name:'email',className:'textfield',margin:'dense',label:'Primary Email',type:'email',value:this.state.email,required:true,onChange:this.handleInputChange('email')// placeholder="Email"
,error:!this.state.isEmailValid,onBlur:this.checkEmailValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isEmailValid?this.state.emailRes:''))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'phoneno',name:'phoneno',className:'textfield',margin:'dense',label:'Contact No',type:'text',value:this.state.phoneno,required:true,onChange:this.handleInputChange('phoneno'),error:!this.state.isPhonenoValid,onBlur:this.checkPhonenoValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isPhonenoValid?this.state.phoneNoRes:''))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'contactp',name:'contactp',className:'textfield',margin:'dense',label:'Contact Person',type:'text',value:this.state.contactp,required:true,onChange:this.handleInputChange('contactp'),error:!this.state.isContactpValid,onBlur:this.checkContactpValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isContactpValid?'Invalid Contact Person Name':''))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'address',name:'address',className:'textfield',margin:'dense',label:'Address',type:'Multi-line',value:this.state.address,required:true,onChange:this.handleInputChange('address'),error:!this.state.isAddressValid,onBlur:this.checkAddressValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isAddressValid?'Invalid Address':''))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'city',name:'city',className:'textfield',margin:'dense',label:'City'// type="Multi-line"
,value:this.state.city,required:true,onChange:this.handleInputChange('city'),error:!this.state.isCityValid,onBlur:this.checkCityValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isCityValid?'Invalid City':''))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Countries__["a" /* default */],{countryId:this.state.country,handleCountryChange:this.handleCountryChange}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},this.handleStateRender()),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'pin',name:'pin',className:'textfield',margin:'dense',label:'Pin Code'// type="Multi-line"
,value:this.state.pin,required:true,onChange:this.handleInputChange('pin'),error:!this.state.isPinValid,onBlur:this.checkPinValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isPinValid?'Invalid Pin Number':''))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'pan',name:'pan',className:'textfield',margin:'dense',label:'PAN No'// type="Multi-line"
,value:this.state.pan,required:true,onChange:this.handleInputChange('pan'),error:!this.state.isPanValid,onBlur:this.checkPanValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},this.state.isPanValid?'':this.state.panNoRes))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'username',name:'username',className:'textfield',margin:'dense',label:'Username'// type="Multi-line"
,value:this.state.username,required:true,onChange:this.handleInputChange('username'),error:!this.state.isUsernameValid,onBlur:this.checkUsernameValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isUsernameValid?this.state.userNameRes:''))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'domainName',name:'domainName',className:'textfield',margin:'dense',label:'Domain Name',value:this.state.domainName,onChange:this.handleInputChange('domainName')}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'pageTitle',name:'pageTitle',className:'textfield',margin:'dense',label:'Page Title',value:this.state.pageTitle}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'faviconLink',name:'faviconLink',className:'textfield',margin:'dense',label:'Favicon Link',value:this.state.faviconLink}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'logo',name:'logo',className:'textfield',margin:'dense',label:'Logo',value:this.state.logo,onChange:this.handleInputChange('logo')}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core__["InputLabel"],{htmlFor:'selectLabel'},'Select Billing Mode *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Select___default.a,{value:this.state.billingMode,onChange:this.hanldeBillingModeChange,name:'billingMode'// error={!this.state.isCltTypeValid}
// onBlur={this.checkCltTypeValidity}
,input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Input___default.a,{name:'billingMode'})},BILLING_MODES.map(function(billingMode){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_MenuItem___default.a,{value:billingMode.value,key:billingMode.value},billingMode.label);})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core__["InputLabel"],{htmlFor:'selectLabel'},'Select SalesPerson *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Select___default.a,{value:this.state.salesPerson,onChange:this.handleSalesPersonChange,name:'salesPerson'// error={!this.state.isCltTypeValid}
// onBlur={this.checkCltTypeValidity}
,input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Input___default.a,{name:'salesPerson'})},this.state.allSalesPerson.map(function(billingMode){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_MenuItem___default.a,{value:billingMode.value,key:billingMode.value},billingMode.label);})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core__["InputLabel"],{htmlFor:'selectLabel'},'Select Solution *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Select___default.a,{value:this.state.solution,onChange:this.handleSolutionChange,name:'solution',input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Input___default.a,{name:'solution'})},this.state.allSolution.map(function(solutions){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_MenuItem___default.a,{value:solutions.value,key:solutions.value},solutions.label);})))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__material_ui_core_CardActions___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{justify:'center',container:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{color:'default',variant:'outlined',size:'medium',margin:'normal',className:'btn',onClick:this.handleCancelClick},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{variant:'contained',color:'primary',size:'medium',margin:'normal',className:'btn'// onClick={this.handleSubmit}
,onClick:this.handleSaveClick,type:'submit',disabled:!(this.state.isEmailValid&&this.state.isBusinessNameValid&&this.state.email!==''&&this.state.businessname!==''&&this.state.contactp!==''&&this.state.isContactpValid&&this.state.phoneno!==''&&this.state.isPhonenoValid&&this.state.address!==''&&this.state.isAddressValid&&this.state.city!==''&&this.state.isCityValid&&this.state.state!==''&&this.state.country!==''&&this.state.username!==''&&this.state.isUsernameValid&&this.state.clttype!==''&&this.state.pin!==''&&this.state.isPinValid&&this.state.pan!==''&&this.state.isPanValid&&this.state.billingMode!==''&&this.state.salesPerson!==''&&this.state.isUsernameAvailable==='AVAILABLE')},'Submit')))))))));}}]);return AddPartner;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);AddPartner.propTypes={classes:__WEBPACK_IMPORTED_MODULE_23_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_13__HOCs_withSharedSnackbar__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_15_react_apollo__["withApollo"])(AddPartner)));

/***/ }),
/* 2054 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AssignDevPartner_css__ = __webpack_require__(2056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AssignDevPartner_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__AssignDevPartner_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select_dist_react_select_css__ = __webpack_require__(2057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select_dist_react_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_select_dist_react_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Reusable_ItemCard__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Dialog__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_AppBar__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_AppBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_AppBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Toolbar__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Slide__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Slide___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Slide__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_icons_Close__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_icons_Close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_icons_Close__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_IconButton__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core_FormGroup__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core_FormGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_FormGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core_FormHelperText__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core_FormHelperText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_FormHelperText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_react_apollo__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query {\n    allPartnerDetails(status: 1) {\n      id\n      businessName\n      login {\n        loginId\n      }\n    }\n  }\n'],['\n  query {\n    allPartnerDetails(status: 1) {\n      id\n      businessName\n      login {\n        loginId\n      }\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query partnerDetail($partnerId: Int!) {\n    partnerDetail(loginId: $partnerId) {\n      businessName\n      contactPerson\n      address\n      id\n      login {\n        loginId\n      }\n    }\n  }\n'],['\n  query partnerDetail($partnerId: Int!) {\n    partnerDetail(loginId: $partnerId) {\n      businessName\n      contactPerson\n      address\n      id\n      login {\n        loginId\n      }\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query deviceDetail($deviceId: String!) {\n    deviceDetail(uniqueDeviceId: $deviceId) {\n      serial_num\n      imei_num\n      uniqueDeviceId\n      deviceModelId {\n        model_name\n      }\n    }\n  }\n'],['\n  query deviceDetail($deviceId: String!) {\n    deviceDetail(uniqueDeviceId: $deviceId) {\n      serial_num\n      imei_num\n      uniqueDeviceId\n      deviceModelId {\n        model_name\n      }\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  mutation addDevicePartnerAssignDetail($deviceId: String!, $partnerId: Int!) {\n    addDevicePartnerAssignDetail(\n      uniqueDeviceId: $deviceId\n      partnerLoginId: $partnerId\n    )\n  }\n'],['\n  mutation addDevicePartnerAssignDetail($deviceId: String!, $partnerId: Int!) {\n    addDevicePartnerAssignDetail(\n      uniqueDeviceId: $deviceId\n      partnerLoginId: $partnerId\n    )\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  query simDetail($phoneno: String, $status: Int) {\n    simDetail(phoneNumber: $phoneno, status: $status) {\n      id\n      phoneNumber\n      simNumber\n      serviceProvider {\n        name\n      }\n    }\n  }\n'],['\n  query simDetail($phoneno: String, $status: Int) {\n    simDetail(phoneNumber: $phoneno, status: $status) {\n      id\n      phoneNumber\n      simNumber\n      serviceProvider {\n        name\n      }\n    }\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  mutation addSimPartnerAssignDetail($simId: Int!, $partnerId: Int!) {\n    addSimPartnerAssignDetail(simId: $simId, partnerLoginId: $partnerId)\n  }\n'],['\n  mutation addSimPartnerAssignDetail($simId: Int!, $partnerId: Int!) {\n    addSimPartnerAssignDetail(simId: $simId, partnerLoginId: $partnerId)\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_PARTNER_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_21_graphql_tag__["a" /* default */])(_templateObject);var GET_PARTNER_DETAILS_BYID=Object(__WEBPACK_IMPORTED_MODULE_21_graphql_tag__["a" /* default */])(_templateObject2);var GET_DEVICE_DETAILS_BYID=Object(__WEBPACK_IMPORTED_MODULE_21_graphql_tag__["a" /* default */])(_templateObject3);var ASS_DEVICE_TO_PARTNER=Object(__WEBPACK_IMPORTED_MODULE_21_graphql_tag__["a" /* default */])(_templateObject4);var GET_SIM_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_21_graphql_tag__["a" /* default */])(_templateObject5);var ASS_SIM_TO_PARTNER=Object(__WEBPACK_IMPORTED_MODULE_21_graphql_tag__["a" /* default */])(_templateObject6);function Transition(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Slide___default.a,Object.assign({direction:'up'},props));}// const ITEM_HEIGHT = 48
var styles=function styles(theme){return{appBar:{position:'relative'},flex:{flex:1},root:{flexGrow:1// height: 250250
},chip:{margin:theme.spacing.unit/4}};};var AssignDevPartner=function(_Component){_inherits(AssignDevPartner,_Component);function AssignDevPartner(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,AssignDevPartner);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AssignDevPartner.__proto__||Object.getPrototypeOf(AssignDevPartner)).call.apply(_ref,[this].concat(args))),_this),_this.state={single:null,multi:null,multiLabel:null,open:false,showDetails:false,isModelNameValid:true,serialno:'',isSerialnoValid:true,modelName:'',open1:false,isPartnerNameValid:'',partnerName1:'',comapnyName:'',address:'',showDeviceDetails:'',showErrorDetails:'',serialNumber:'',imeiNumber:'',uniqueID:'',deviceId:'',partnerId:'',openSim:false,phoneno:'',isPhonenoValid:true,phoneNumber:'',simNumber:'',providerName:'',simId:'',showSimDetails:false,searchError:''},_this.handleChange=function(name){return function(value){_this.setState(_defineProperty({},name,value));};},_this.handleChangeSelect=function(event){_this.setState(_defineProperty({},event.target.name,event.target.value));},_this.handleClickOpen=function(){_this.setState({open:true});},_this.handleClose=function(){_this.setState({open:false});},_this.handleChangemodel=function(event){_this.setState({modelName:event.target.value});},_this.checkModelNameValidity=function(){_this.setState({isModelNameValid:_this.state.modelName!==''});},_this.handleOpenSelect=function(){_this.setState({open1:true});},_this.handleCloseSelect=function(){_this.setState({open1:false});},_this.handleOpenSelectSim=function(){_this.setState({openSim:true});// console.log('dpenstatus', this.state.openSim)
},_this.handleCloseSelectSim=function(){_this.setState({openSim:false});},_this.checkSerialnoValidity=function(){// const regex = new RegExp(
//   // /^[1-9][0-9]{9}$/
//   /^[0-9]+$/
// )
// console.log('meena')
// console.log(regex.test(this.state.serialno) || this.state.serialno === '')
_this.setState({isSerialnoValid:// regex.test(this.state.serialno) && this.state.serialno !== ''
_this.state.serialno!==''});},_this.checkPhonenoValidity=function(){var regex=new RegExp(// /^[1-9][0-9]{9}$/
/^[0-9]+$/);_this.setState({isPhonenoValid:regex.test(_this.state.phoneno)&&_this.state.phoneno!==''});},_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));};},_this.checkPartnerNameValidity=function(){_this.setState({isPartnerNameValid:_this.state.partnername!==''});},_this.showPartnerDetails=function(client){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _ref3,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:console.log('ploginid=',_this.state.partnername);_context.next=3;return client.query({query:GET_PARTNER_DETAILS_BYID,variables:{partnerId:_this.state.partnername}});case 3:_ref3=_context.sent;data=_ref3.data;console.log('data=',data);_this.setState({partnerName1:data.partnerDetail.contactPerson,comapnyName:data.partnerDetail.businessName,address:data.partnerDetail.address,partnerId:data.partnerDetail.login.loginId,showDetails:true});// await this.onCountryFetched(data.allStatesByCountryId)
case 7:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}();},_this.displayDeviceDetails=function(client){return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(event){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:console.log('HELLO');_context2.next=3;return client.query({query:GET_DEVICE_DETAILS_BYID,errorPolicy:'all',variables:{deviceId:_this.state.serialno}});case 3:response=_context2.sent;console.log('data=',response.data);console.log('error',response.error);if(response.data.deviceDetail){_this.setState({serialNumber:response.data.deviceDetail.serial_num,imeiNumber:response.data.deviceDetail.imei_num,uniqueID:response.data.deviceDetail.uniqueDeviceId,modelName:response.data.deviceDetail.deviceModelId.model_name,// deviceId: data.deviceDetail.id,
showDeviceDetails:true});}else{console.log('error',response.error);_this.setState({showErrorDetails:true,searchError:'Unique Id does not exist'});}// await this.onCountryFetched(data.allStatesByCountryId)
case 7:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref4.apply(this,arguments);};}();},_this.handleFormSubmit=function(client){return function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(event){var _ref6,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return client.mutate({mutation:ASS_DEVICE_TO_PARTNER,variables:{deviceId:_this.state.uniqueID,partnerId:_this.state.partnerId}});case 2:_ref6=_context3.sent;data=_ref6.data;console.log('ADD=',data);case 5:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x3){return _ref5.apply(this,arguments);};}();},_this.displaySimDetails=function(client){return function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(event){var _ref8,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:console.log('Hi',_this.state.phoneno);_context4.next=3;return client.query({query:GET_SIM_DETAILS,variables:{phoneno:_this.state.phoneno,status:1}});case 3:_ref8=_context4.sent;data=_ref8.data;console.log('Simdata=',data);_this.setState({phoneNumber:data.simDetail.phoneNumber,simNumber:data.simDetail.simNumber,providerName:data.simDetail.serviceProvider.name,simId:data.simDetail.id,showSimDetails:true});// await this.onCountryFetched(data.allStatesByCountryId)
case 7:case'end':return _context4.stop();}}},_callee4,_this2);}));return function(_x4){return _ref7.apply(this,arguments);};}();},_this.handleSimFormSubmit=function(client){return function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(event){var _ref10,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return client.mutate({mutation:ASS_SIM_TO_PARTNER,variables:{simId:_this.state.simId,partnerId:_this.state.partnerId}});case 2:_ref10=_context5.sent;data=_ref10.data;console.log('ADDSIM=',data);case 5:case'end':return _context5.stop();}}},_callee5,_this2);}));return function(_x5){return _ref9.apply(this,arguments);};}();},_temp),_possibleConstructorReturn(_this,_ret);}// Sim details
_createClass(AssignDevPartner,[{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_react_apollo__["ApolloConsumer"],null,function(client){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_react_apollo__["Query"],{query:GET_PARTNER_DETAILS},function(_ref11){var loading=_ref11.loading,error=_ref11.error,data=_ref11.data;var queriedData=data;if(loading)return'Loading...';if(error)return'Error!: '+error;console.log('Data=',queriedData.allPartnerDetails);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'Landing'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{container:true,justify:'center'//   alignments="flex-end"
,className:'full-screen'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:10},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Reusable_ItemCard__["a" /* default */],{className:'form_layout'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'title',color:'primary'},'Assign Devices To Partner'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{container:true,style:{margin:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'searchrow'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'100%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select___default.a,{open:_this3.state.open1,onClose:_this3.handleCloseSelect,onOpen:_this3.handleOpenSelect,fullWidth:true,placeholder:'a',name:'Select Partner',value:_this3.state.partnername,onChange:_this3.handleChangeSelect,error:!_this3.state.isPartnerNameValid,onBlur:_this3.checkPartnerNameValidity,inputProps:{name:'partnername',id:'partnername'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),queriedData.allPartnerDetails.map(function(allPartnerDetailsByStatus){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem___default.a,{value:allPartnerDetailsByStatus.login.loginId,key:allPartnerDetailsByStatus.login.loginId},allPartnerDetailsByStatus.businessName);})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'searchrow'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button___default.a,{variant:'contained',color:'primary',size:'small',margin:'normal',className:'btn'// onClick={() => {
//   this.setState({ showDetails: true })
// }}
,onClick:_this3.showPartnerDetails(client),disabled:!_this3.state.isPartnerNameValid},'Go'))),_this3.state.showDetails&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clientDetails'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'headline',color:'secondary'},'Partner Details:'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'body2'},'Partner Name:'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'body1'},_this3.state.partnerName1),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'body2'},'Company Name :'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'body1'},_this3.state.comapnyName),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'body2'},'Address:'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'body1'},_this3.state.address),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button___default.a,{color:'secondary',size:'small',variant:'contained',margin:'normal',onClick:_this3.handleClickOpen},'Add Device'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button___default.a,{color:'secondary',size:'small',variant:'contained',margin:'normal',onClick:_this3.handleOpenSelectSim},'Add SIM'))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Dialog___default.a,{fullScreen:true,open:_this3.state.open,onClose:_this3.handleClose,TransitionComponent:Transition},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_AppBar___default.a,{className:classes.appBar},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Toolbar___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_IconButton___default.a,{color:'inherit',onClick:_this3.handleClose,'aria-label':'Close'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_icons_Close___default.a,null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'title',color:'inherit',className:classes.flex},'Add Device'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button___default.a,{color:'inherit',onClick:_this3.handleClose},'save'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{container:true,spacing:8},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading',gutterBottom:true,style:{color:'red',marginLeft:'25px'}},error&&error.graphQLErrors.map(function(_ref12,i){var message=_ref12.message;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{key:i},message);})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading',gutterBottom:true,style:{color:'green',marginLeft:'25px'}},data&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Sucessfully Added')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_FormControl___default.a,{style:{minWidth:'60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_TextField___default.a,{id:'serialno',name:'serialno',className:'textfield',margin:'dense',label:'Unique Id',type:'text',value:_this3.state.serialno,required:true,onChange:_this3.handleInputChange('serialno'),error:!_this3.state.isSerialnoValid,onBlur:_this3.checkSerialnoValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!_this3.state.isSerialnoValid?'Invalid Serial No':'')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_FormControl___default.a,{style:{minWidth:'60%',margin:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button___default.a,{variant:'contained',color:'primary',size:'medium',margin:'normal',className:'btn',onClick:_this3.displayDeviceDetails(client),disabled:// console.log(this.state.isSerialnoValid)
!_this3.state.isSerialnoValid},'Process')))),_this3.state.showErrorDetails&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'headline',color:'secondary'},'Unique Id does not exist!'),_this3.state.showDeviceDetails&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clientDetails'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'headline',color:'secondary'},'Device Details:'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'body2'},'Serial No:'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'body1'},_this3.state.serialNumber),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'body2'},'Model Name :'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'body1'},_this3.state.modelName),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'body2'},'Imei No:'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'body1'},_this3.state.imeiNumber),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'body2'},'Unique No:'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'body1'},_this3.state.uniqueID),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button___default.a,{color:'secondary',size:'small',variant:'contained',margin:'normal',onClick:_this3.handleFormSubmit(client)},'Assign'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button___default.a,{color:'default',size:'small',variant:'contained',margin:'normal',onClick:_this3.handleClickOpen},'Cancel'))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Dialog___default.a,{fullScreen:true,open:_this3.state.openSim,onClose:_this3.handleCloseSelectSim,TransitionComponent:Transition},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_AppBar___default.a,{className:classes.appBar},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Toolbar___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_IconButton___default.a,{color:'inherit',onClick:_this3.handleCloseSelectSim,'aria-label':'Close'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_icons_Close___default.a,null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'title',color:'inherit',className:classes.flex},'Add SIM'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button___default.a,{color:'inherit',onClick:_this3.handleCloseSelectSim},'save'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{container:true,spacing:8},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading',gutterBottom:true,style:{color:'red',marginLeft:'25px'}},error&&error.graphQLErrors.map(function(_ref13,i){var message=_ref13.message;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{key:i},message);})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading',gutterBottom:true,style:{color:'green',marginLeft:'25px'}},data&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Sucessfully Added')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_FormControl___default.a,{style:{minWidth:'60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_TextField___default.a,{id:'phoneno',name:'phoneno',className:'textfield',margin:'dense',label:'Phone No',type:'text',value:_this3.state.phoneno,required:true,onChange:_this3.handleInputChange('phoneno'),error:!_this3.state.isPhonenoValid,onBlur:_this3.checkPhonenoValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!_this3.state.isSerialnoValid?'Invalid Phone No':'')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_FormControl___default.a,{style:{minWidth:'60%',margin:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button___default.a,{variant:'contained',color:'primary',size:'medium',margin:'normal',className:'btn',onClick:_this3.displaySimDetails(client),disabled:// console.log(this.state.isSerialnoValid)
!_this3.state.isPhonenoValid},'Process')))),_this3.state.showSimDetails&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'clientDetails'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'headline',color:'secondary'},'SIM Details:'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'body2'},'Phone No:'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'body1'},_this3.state.phoneNumber),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'body2'},'Provider Name :'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'body1'},_this3.state.providerName),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'body2'},'SIM No:'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'body1'},_this3.state.simNumber),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button___default.a,{color:'secondary',size:'small',variant:'contained',margin:'normal',onClick:_this3.handleSimFormSubmit(client)},'Assign'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button___default.a,{color:'default',size:'small',variant:'contained',margin:'normal',onClick:_this3.handleClickOpen},'Cancel'))))));});});}}]);return AssignDevPartner;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__["withStyles"])(styles)(AssignDevPartner));

/***/ }),
/* 2056 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2057 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_getAccountType__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_common_Loader__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getAllSubscriptions($partnerLoginId: Int!, $status: [Int!]) {\n    allClientSubscriptions: getAllSubscriptions(\n      partnerLoginId: $partnerLoginId\n      status: $status\n    ) {\n      id\n      client {\n        loginId\n        clientName\n      }\n      billingMode {\n        id\n        billingMode\n      }\n      billingFrequency {\n        id\n        frequency\n      }\n      deviceModel {\n        model_name\n      }\n      serviceProvider {\n        name\n      }\n      deviceQuantity\n      plan\n      amount\n      status\n      createdAt\n      nextPaymentDate\n    }\n  }\n'],['\n  query getAllSubscriptions($partnerLoginId: Int!, $status: [Int!]) {\n    allClientSubscriptions: getAllSubscriptions(\n      partnerLoginId: $partnerLoginId\n      status: $status\n    ) {\n      id\n      client {\n        loginId\n        clientName\n      }\n      billingMode {\n        id\n        billingMode\n      }\n      billingFrequency {\n        id\n        frequency\n      }\n      deviceModel {\n        model_name\n      }\n      serviceProvider {\n        name\n      }\n      deviceQuantity\n      plan\n      amount\n      status\n      createdAt\n      nextPaymentDate\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query getAllPartnerSubscriptions($partnerLoginId: Int, $status: [Int!]) {\n    allPartnerSubscriptions: getAllPartnerSubscriptions(\n      partnerLoginId: $partnerLoginId\n      status: $status\n    ) {\n      id\n      status\n      partnerLoginId\n      gst\n      amount\n      totalDeviceQty\n      unassignedDeviceQuantity\n      billingFrequencyId\n      hardwareCharges\n      totalSoftwareQty\n      unbilledSoftware\n      totalSoftwareQty\n      unbilledSoftware\n      noOfDevices\n      deviceTrackingCharges\n      simQty\n      unbilledSims\n      unassignedSimQty\n      unassignedSimQty\n      simCharges\n      accessoryQty\n      unbilledAccessory\n      unassignedAccessoryQty\n      unbilledDeviceQty\n      nextPaymentDate\n      accessoryCharges\n      unassignedAccessoryQty\n      nextPaymentDate\n      deviceModel {\n        model_name\n      }\n      serviceProvider {\n        name\n      }\n      createdAt\n      partnerDetail {\n        id\n        businessName\n      }\n      billingMode {\n        id\n        billingMode\n      }\n      billingFrequency {\n        id\n        frequency\n        numberOfMonths\n      }\n    }\n  }\n'],['\n  query getAllPartnerSubscriptions($partnerLoginId: Int, $status: [Int!]) {\n    allPartnerSubscriptions: getAllPartnerSubscriptions(\n      partnerLoginId: $partnerLoginId\n      status: $status\n    ) {\n      id\n      status\n      partnerLoginId\n      gst\n      amount\n      totalDeviceQty\n      unassignedDeviceQuantity\n      billingFrequencyId\n      hardwareCharges\n      totalSoftwareQty\n      unbilledSoftware\n      totalSoftwareQty\n      unbilledSoftware\n      noOfDevices\n      deviceTrackingCharges\n      simQty\n      unbilledSims\n      unassignedSimQty\n      unassignedSimQty\n      simCharges\n      accessoryQty\n      unbilledAccessory\n      unassignedAccessoryQty\n      unbilledDeviceQty\n      nextPaymentDate\n      accessoryCharges\n      unassignedAccessoryQty\n      nextPaymentDate\n      deviceModel {\n        model_name\n      }\n      serviceProvider {\n        name\n      }\n      createdAt\n      partnerDetail {\n        id\n        businessName\n      }\n      billingMode {\n        id\n        billingMode\n      }\n      billingFrequency {\n        id\n        frequency\n        numberOfMonths\n      }\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_ALL_CLIENT_SUBSCRIPTION=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject);var GET_ALL_PARTNER_SUBSCRIPTION=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject2);var style=function style(theme){var _root;return{root:(_root={padding:theme.spacing.unit*4},_defineProperty(_root,theme.breakpoints.down('sm'),{padding:theme.spacing.unit*2}),_defineProperty(_root,'flexGrow',1),_root),paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},iconSmall:{fontSize:20}};};var Subscriptions=function(_Component){_inherits(Subscriptions,_Component);function Subscriptions(props){var _this2=this;_classCallCheck(this,Subscriptions);var _this=_possibleConstructorReturn(this,(Subscriptions.__proto__||Object.getPrototypeOf(Subscriptions)).call(this,props));_this.clientId=[];_this.fullData=[];_this.columnsClient=['CUSTOMER NAME','PLAN',{name:'DEVICE COUNT',options:{filter:false}},'MODEL NAME','SERVICE PROVIDER','BILLING MODE','BILLING FREQUENCY',{name:'SOFTWARE MMTC ( in Rs )',options:{filter:false}},'STATUS','CREATION DATE','NEXT BILLING DATE'];_this.columnsPartner=['CUSTOMER NAME','DEVICE COUNT','MODEL NAME','SERVICE PROVIDER','BILLING MODE','BILLING FREQUENCY',{name:'SOFTWARE MMTC ( in Rs )',options:{filter:false}},'STATUS','CREATION DATE','NEXT BILLING DATE'];_this.optionsClient={filterType:'dropdown',print:false,selectableRows:false,responsive:'scroll',rowsPerPage:10,onRowClick:function onRowClick(rowData,dataIndex,rowIndex){// console.log('data Index', dataIndex, rowData)
_this.props.history.push({pathname:'/home/subscriptions/view/'+_this.clientId[dataIndex.dataIndex]+'/'+_this.subcriptionIdClient[dataIndex.dataIndex]});},onChangeRowsPerPage:function onChangeRowsPerPage(numberOfRows){console.log('current page',numberOfRows);}// onChangePage: (currentPage) => {
//   this.SetCurrentPageNumber(currentPage)
// }
};_this.optionsPartner={filterType:'dropdown',print:false,selectableRows:false,responsive:'scroll',rowsPerPage:15,onRowClick:function onRowClick(rowData,dataIndex,rowIndex){_this.props.history.push({pathname:'/home/subscriptions'+'/'+_this.subcriptionIdPartner[dataIndex.dataIndex]+'/partnerSubscriptionDetail'});}};_this.handleTabChange=function(event,value){// console.log('on tab change', event, value)
switch(value){case'CLIENT':// console.log('call Client Subscriptions')
_this.getAllClientSubscriptions();break;case'PARTNER':// console.log('call Partner Subscription')
_this.getAllPartnerSubsciptions();break;default:console.log('call client');break;}_this.setState({currentTab:value});};_this.createNewSubscription=function(e){_this.props.history.push({pathname:'/home/subscriptions/new'});};_this.epochToDate=function(date1){var d1=parseInt(date1,10);var unixEpochTimeMS=d1*1000;var d=new Date(unixEpochTimeMS);// Careful, the string output here can vary by implementation...
var strDate=d.toLocaleDateString();return strDate;};_this.setClientQueryVariables=function(){var queryVariables={partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_10__utils_getLoginId__["a" /* default */])()};if(['SAL','PA'].includes(Object(__WEBPACK_IMPORTED_MODULE_11__utils_getAccountType__["a" /* default */])())){queryVariables['status']=[1,2,4,5];}if(['ACC'].includes(Object(__WEBPACK_IMPORTED_MODULE_11__utils_getAccountType__["a" /* default */])())){queryVariables['status']=[1,4];}if(['INV'].includes(Object(__WEBPACK_IMPORTED_MODULE_11__utils_getAccountType__["a" /* default */])())){queryVariables['status']=[2,4,5];}return queryVariables;};_this.setPartnerQueryVariables=function(){var queryVariables={partnerLoginId:null};if(['SAL'].includes(Object(__WEBPACK_IMPORTED_MODULE_11__utils_getAccountType__["a" /* default */])())){queryVariables['status']=[1,2,4,5];}if(['ACC'].includes(Object(__WEBPACK_IMPORTED_MODULE_11__utils_getAccountType__["a" /* default */])())){queryVariables['status']=[1,4];}if(['INV'].includes(Object(__WEBPACK_IMPORTED_MODULE_11__utils_getAccountType__["a" /* default */])())){queryVariables['status']=[2];}return queryVariables;};_this.getAllClientSubscriptions=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _ref2,data,loading,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.client.query({query:GET_ALL_CLIENT_SUBSCRIPTION,variables:_this.state.clientQueryVariables// fetchPolicy: 'network-only'
});case 2:_ref2=_context.sent;data=_ref2.data;loading=_ref2.loading;error=_ref2.error;if(!loading){_context.next=8;break;}return _context.abrupt('return',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_common_Loader__["a" /* default */],null));case 8:if(!error){_context.next=10;break;}return _context.abrupt('return','Error!: '+error);case 10:// console.log(
//   'all subscription data',
//   data.allClientSubscriptions[0].serviceProvider.name
// )
_this.setState({isLoading:loading});// console.log('loading status', loading)
_this.mapToArrClient(data.allClientSubscriptions);case 12:case'end':return _context.stop();}}},_callee,_this2);}));_this.getAllPartnerSubsciptions=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var partnerQueryVariables,_ref4,data,loading,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:console.log('account type',Object(__WEBPACK_IMPORTED_MODULE_11__utils_getAccountType__["a" /* default */])());if(!(Object(__WEBPACK_IMPORTED_MODULE_11__utils_getAccountType__["a" /* default */])()!=='PA')){_context2.next=15;break;}partnerQueryVariables=_this.setPartnerQueryVariables();_context2.next=5;return _this.props.client.query({query:GET_ALL_PARTNER_SUBSCRIPTION,variables:partnerQueryVariables// fetchPolicy: 'network-only'
});case 5:_ref4=_context2.sent;data=_ref4.data;loading=_ref4.loading;error=_ref4.error;if(!loading){_context2.next=11;break;}return _context2.abrupt('return',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_common_Loader__["a" /* default */],null));case 11:if(!error){_context2.next=13;break;}return _context2.abrupt('return','Error!: '+error);case 13:console.log('all subscription data',data);_this.mapToArrPartner(data.allPartnerSubscriptions);case 15:case'end':return _context2.stop();}}},_callee2,_this2);}));_this.componentDidMount=function(){var clientQueryVariables=_this.setClientQueryVariables();// console.log('clientQueryVariables', clientQueryVariables)
_this.setState({clientQueryVariables:clientQueryVariables},function(){_this.getAllClientSubscriptions();});};_this.classes=props;_this.state={isLoading:true,currentTab:'CLIENT',query:GET_ALL_CLIENT_SUBSCRIPTION,clientQueryVariables:null,tableRowDataClient:[],tableRowDataPartner:[]};return _this;}// SetCurrentPageNumber = pageNumber => {
//   console.log('page number', pageNumber)
//   let pageNumber1 = pageNumber
//   sessionStorage.setItem('currentPageNumber', pageNumber1)
//   let sessionvar = sessionStorage.getItem('currentPageNumber')
//   if (sessionvar < ) {
//     sessionStorage.clear()
//   }
//   // let sessionvar = sessionStorage.getItem('currentPageNumber')
//   console.log('session var', sessionvar)
// }
// epoch to human readable date format
_createClass(Subscriptions,[{key:'mapToArrPartner',// *********TableStatus of subscription master ***********************
// ********* 1 - Pending
// ********* 2 - Approved and partial payment
// ********* 3 - Rejected
// ********* 4 - Pending of already approved subscription.
// ********* 5 - Approved and fully paid
//  for Partner subcription query Status value is not passing. This bug will be fixed once fixed in backend
value:function mapToArrPartner(allSubscriptions){var _this3=this;// let rs = &#8377;
var rowData=[];this.fullData=[];this.clientId=[];this.subcriptionIdPartner=[];allSubscriptions.forEach(function(element){rowData=[];_this3.subcriptionIdPartner.push(element.id);rowData.push(element.partnerDetail.businessName);rowData.push(element.totalSoftwareQty);rowData.push(element.deviceModel.model_name);if(element.serviceProvider===null||element.serviceProvider===undefined){rowData.push('NA');}else{rowData.push(element.serviceProvider.name);}if(element.billingMode){rowData.push(element.billingMode.billingMode);}else{rowData.push('N/A');}rowData.push(element.billingFrequency.frequency);rowData.push(element.deviceTrackingCharges);if(element.status===1||element.status===4){rowData.push('Pending');}else if(element.status===2||element.status===5){rowData.push('Approved');}else if(element.status===3){rowData.push('Rejected');}rowData.push(_this3.epochToDate(element.createdAt));rowData.push(_this3.epochToDate(element.nextPaymentDate));_this3.fullData.push(rowData);});// console.log('subscription table data', this.fullData)
this.setState({tableRowDataPartner:this.fullData});}},{key:'mapToArrClient',value:function mapToArrClient(allSubscriptions){var _this4=this;var rowData=[];this.fullData=[];this.clientId=[];this.subcriptionIdClient=[];allSubscriptions.forEach(function(element){console.log('element.serviceProvider',element.serviceProvider);rowData=[];_this4.clientId.push(element.client.loginId);_this4.subcriptionIdClient.push(element.id);rowData.push(element.client.clientName);if(element.plan){rowData.push(element.plan);}else{rowData.push('NA');}rowData.push(element.deviceQuantity);rowData.push(element.deviceModel.model_name);if(element.serviceProvider===null||element.serviceProvider===undefined){rowData.push('NA');}else{rowData.push(element.serviceProvider.name);}rowData.push(element.billingMode.billingMode);rowData.push(element.billingFrequency.frequency);rowData.push(element.amount);if(element.status===1||element.status===4){rowData.push('Pending');}else if(element.status===2||element.status===5){rowData.push('Approved');}else if(element.status===3){rowData.push('Rejected');}rowData.push(_this4.epochToDate(element.createdAt));rowData.push(_this4.epochToDate(element.nextPaymentDate));// rowData.push(element.createdAt)
_this4.fullData.push(rowData);});// console.log('subscription table data', this.fullData)
this.setState({tableRowDataClient:this.fullData});}},{key:'render',value:function render(){var classes=this.props.classes;var currentTab=this.state.currentTab;// loader display before data loading for better ui experience
if(this.state.isLoading){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_common_Loader__["a" /* default */],null);}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:16,justify:'space-between'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'headline'},'All Subscriptions')),!['INV','ACC'].includes(Object(__WEBPACK_IMPORTED_MODULE_11__utils_getAccountType__["a" /* default */])())&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12,sm:'auto'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{fullWidth:true,color:'secondary',onClick:this.createNewSubscription,variant:'contained',className:classes.button},'New Subscription'))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},!['SAL'].includes(Object(__WEBPACK_IMPORTED_MODULE_11__utils_getAccountType__["a" /* default */])())&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["AppBar"],{position:'static'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["Tabs"],{value:currentTab,onChange:this.handleTabChange},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["Tab"],{value:'CLIENT',label:'Clients'}),Object(__WEBPACK_IMPORTED_MODULE_10__utils_getLoginId__["a" /* default */])()===2?!['INV'].includes(Object(__WEBPACK_IMPORTED_MODULE_11__utils_getAccountType__["a" /* default */])())?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["Tab"],{value:'PARTNER',label:'Partners'}):null:null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_mui_datatables___default.a,{data:currentTab==='CLIENT'?this.state.tableRowDataClient:this.state.tableRowDataPartner,columns:// this.columnsClient
currentTab==='CLIENT'?this.columnsClient:this.columnsPartner,options:currentTab==='CLIENT'?this.optionsClient:this.optionsPartner})));}}}]);return Subscriptions;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);Subscriptions.propTypes={classes:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["withApollo"])(Subscriptions)));

/***/ }),
/* 2059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__subscriptionDetails_jsx__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_ArrowBack__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_ArrowBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_ArrowBack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_getAccountType_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_common_Loader__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Dialog__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_DialogActions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_DialogContent__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_DialogContentText__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_DialogContentText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_DialogContentText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core_DialogTitle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core_DialogTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_DialogTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__HOCs_withSharedSnackbar__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query clientDetail($loginId: Int) {\n    clientDetail(loginId: $loginId) {\n      id\n      clientName\n      contactPerson\n      address\n      city\n      gst\n      state {\n        name\n      }\n      country {\n        name\n      }\n      email\n      contactNumber\n      loginId\n      totalAssignedVehicle\n      type\n      solution\n    }\n  }\n'],['\n  query clientDetail($loginId: Int) {\n    clientDetail(loginId: $loginId) {\n      id\n      clientName\n      contactPerson\n      address\n      city\n      gst\n      state {\n        name\n      }\n      country {\n        name\n      }\n      email\n      contactNumber\n      loginId\n      totalAssignedVehicle\n      type\n      solution\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query getSubscriptions($subscriptionId: Int) {\n    subscription: getSubscriptions(id: $subscriptionId) {\n      id\n      status\n      billingDetails {\n        paymentId\n      }\n    }\n  }\n'],['\n  query getSubscriptions($subscriptionId: Int) {\n    subscription: getSubscriptions(id: $subscriptionId) {\n      id\n      status\n      billingDetails {\n        paymentId\n      }\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query getSubscriptionInventoryAssign($subscriptionId: Int!,$clientLoginId:Int) {\n    subscription: getSubscriptionInventoryAssign(\n      subscriptionId: $subscriptionId\n      clientLoginId: $clientLoginId\n    ) {\n      id\n      assignedDeviceDetails {\n        serial_num\n        imei_num\n        uniqueDeviceId\n        vehicleDetails {\n          vehiclenumber\n        }\n        status\n      }\n      asignedSimDetails {\n        phoneNumber\n        simNumber\n        vehicleDetails {\n          vehiclenumber\n        }\n        status\n      }\n    }\n  }\n'],['\n  query getSubscriptionInventoryAssign($subscriptionId: Int!,$clientLoginId:Int) {\n    subscription: getSubscriptionInventoryAssign(\n      subscriptionId: $subscriptionId\n      clientLoginId: $clientLoginId\n    ) {\n      id\n      assignedDeviceDetails {\n        serial_num\n        imei_num\n        uniqueDeviceId\n        vehicleDetails {\n          vehiclenumber\n        }\n        status\n      }\n      asignedSimDetails {\n        phoneNumber\n        simNumber\n        vehicleDetails {\n          vehiclenumber\n        }\n        status\n      }\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  mutation deassignSimFromSubscription(\n    $phoneNumber: String!\n    $simNumber: String!\n    $subscriptionId: Int!\n  ) {\n    deassignSimFromSubscription(\n      phoneNumber: $phoneNumber\n      simNumber: $simNumber\n      subscriptionId: $subscriptionId\n    )\n  }\n'],['\n  mutation deassignSimFromSubscription(\n    $phoneNumber: String!\n    $simNumber: String!\n    $subscriptionId: Int!\n  ) {\n    deassignSimFromSubscription(\n      phoneNumber: $phoneNumber\n      simNumber: $simNumber\n      subscriptionId: $subscriptionId\n    )\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  mutation deassignDeviceFromSubscription(\n    $serial_num: String!\n    $imei_num: String!\n    $subscriptionId: Int!\n  ) {\n    deassignDeviceFromSubscription(\n      serial_num: $serial_num\n      imei_num: $imei_num\n      subscriptionId: $subscriptionId\n    )\n  }\n'],['\n  mutation deassignDeviceFromSubscription(\n    $serial_num: String!\n    $imei_num: String!\n    $subscriptionId: Int!\n  ) {\n    deassignDeviceFromSubscription(\n      serial_num: $serial_num\n      imei_num: $imei_num\n      subscriptionId: $subscriptionId\n    )\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable */var GET_CLIENT=Object(__WEBPACK_IMPORTED_MODULE_6_graphql_tag__["a" /* default */])(_templateObject);var GET_SUBSCRIPTION=Object(__WEBPACK_IMPORTED_MODULE_6_graphql_tag__["a" /* default */])(_templateObject2);var GET_SUBSCRIPTION_INVENTORY=Object(__WEBPACK_IMPORTED_MODULE_6_graphql_tag__["a" /* default */])(_templateObject3);// const GET_SUBSCRIPTION = gql`
// query(){
//   getSubscriptions
// }
// `
var DEASSIGNSIM_FROM_SUBSCRIPTION=Object(__WEBPACK_IMPORTED_MODULE_6_graphql_tag__["a" /* default */])(_templateObject4);var DEASSIGN_DEVICE_FROM_SUBSCRIPTION=Object(__WEBPACK_IMPORTED_MODULE_6_graphql_tag__["a" /* default */])(_templateObject5);var styles=function styles(theme){var _root;return{root:(_root={padding:theme.spacing.unit*4},_defineProperty(_root,theme.breakpoints.down('sm'),{padding:theme.spacing.unit*2}),_defineProperty(_root,'flexGrow',1),_root),paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},input:{display:'none'},breakWord:{wordBreak:'break-all'}};};var ViewSubscription=function(_Component){_inherits(ViewSubscription,_Component);function ViewSubscription(props){var _this2=this;_classCallCheck(this,ViewSubscription);var _this=_possibleConstructorReturn(this,(ViewSubscription.__proto__||Object.getPrototypeOf(ViewSubscription)).call(this,props));_this.columns1=['SERIAL NUMBER','IMEI NUMBER','UNIQUE DEVICE ID','VEHICLE NUMBER',{name:'Status',options:{display:false}}];_this.columns2=['PHONE NUMBER','SIM NUMBER','VEHICLE NUMBER',{name:'Status',options:{display:false}}];_this.options1={selectableRows:false,responsive:'scroll',rowsPerPage:5,onRowClick:function onRowClick(rowData,dataIndex,rowIndex){if(['INV','PA'].includes(Object(__WEBPACK_IMPORTED_MODULE_12__utils_getAccountType_js__["a" /* default */])())){if(rowData[4]&&rowData[4]===3){_this.handleClickOpenEditDevice();_this.setState({serialNum:rowData[0],imeiNum:rowData[1]});}}}};_this.options2={selectableRows:false,responsive:'scroll',rowsPerPage:5,onRowClick:function onRowClick(rowData,dataIndex,rowIndex){if(['INV','PA'].includes(Object(__WEBPACK_IMPORTED_MODULE_12__utils_getAccountType_js__["a" /* default */])())){if(rowData[3]&&rowData[3]===3){_this.handleClickOpenEdit();_this.setState({simNo:rowData[1],phoneNo:rowData[0]});}}}};_this.handleClickOpenEdit=function(){_this.setState({openEdit:true});};_this.handleClickOpenEditDevice=function(){_this.setState({openEditDevice:true});};_this.handleCloseEdit=function(){_this.setState({openEdit:false});};_this.handleCloseEditDevice=function(){_this.setState({openEditDevice:false});};_this.editCustomer=function(loginId){return function(e){_this.props.history.push({pathname:'/home/customers/edit/'+loginId});};};_this.editSubscription=function(e){_this.props.history.push({pathname:'/home/subscriptions/edit/'+_this.loginId+'/'+_this.subscriptionId});};_this.getSubscriptionData=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _ref2,data,subscription,status,billingDetails;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.client.query({query:GET_SUBSCRIPTION,variables:{subscriptionId:_this.subscriptionId}// fetchPolicy: 'network-only'
});case 2:_ref2=_context.sent;data=_ref2.data;console.log('subcription data is called',data.subscription);subscription=data.subscription;if(subscription!==null){status=subscription.status,billingDetails=subscription.billingDetails;_this.setState({paymentId:billingDetails?billingDetails.paymentId:0});if(status==2||status==5){_this.setState({isEditButton:true});}else{_this.setState({isEditButton:false});}}case 7:case'end':return _context.stop();}}},_callee,_this2);}));_this.showSubscription=function(value){return function(e){// this.props.history.push({
//   pathname: '/home/subscriptions/view-detail/' + this.subscriptionId
// })
};};_this.mapToArr=function(data){var rowData=[];var fullData=[];_this.entityId=[];data.forEach(function(element){rowData=[];// this.entityId.push(element.entityId)
rowData.push(element.serial_num);rowData.push(element.imei_num);rowData.push(element.uniqueDeviceId);if(element.vehicleDetails!==null){rowData.push(element.vehicleDetails.vehiclenumber);}else{rowData.push('NA');}rowData.push(element.status);fullData.push(rowData);});_this.setState({deviceList:fullData});return fullData;};_this.mapToSimArr=function(data){var rowData=[];var fullData=[];data.forEach(function(element){rowData=[];rowData.push(element.phoneNumber);rowData.push(element.simNumber);if(element.vehicleDetails!==null){rowData.push(element.vehicleDetails.vehiclenumber);}else{rowData.push('NA');}rowData.push(element.status);fullData.push(rowData);});_this.setState({simList:fullData});return fullData;};_this.getSubscriptionInventory=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var _ref4,data,errorMessage;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_context2.next=3;return _this.props.client.query({query:GET_SUBSCRIPTION_INVENTORY,variables:{subscriptionId:parseInt(_this.subscriptionId,10),clientLoginId:parseInt(_this.loginId,10)}// fetchPolicy: 'network-only'
});case 3:_ref4=_context2.sent;data=_ref4.data;_this.setDetails(data.subscription);_context2.next=12;break;case 8:_context2.prev=8;_context2.t0=_context2['catch'](0);errorMessage=_context2.t0.message.split(":");_this.props.openSnackbar(errorMessage[1]);case 12:case'end':return _context2.stop();}}},_callee2,_this2,[[0,8]]);}));_this.deassignSim=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(event){var _ref6,data,errors;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:event.preventDefault();console.log('deassign sims states',_this.state.phoneNo,_this.state.simNo,_this.subscriptionId);_context3.next=4;return _this.props.client.mutate({mutation:DEASSIGNSIM_FROM_SUBSCRIPTION,variables:{phoneNumber:_this.state.phoneNo,simNumber:_this.state.simNo,subscriptionId:_this.subscriptionId},errorPolicy:'all'});case 4:_ref6=_context3.sent;data=_ref6.data;errors=_ref6.errors;console.log('submit',errors);if(data!=null&&data.deassignSimFromSubscription===true){_this.handleCloseEdit();_this.props.openSnackbar('Sim Deassigned Successfully');_this.getSubscriptionInventory();}else{_this.props.openSnackbar(errors[0].message);}case 9:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x){return _ref5.apply(this,arguments);};}();_this.deassignDevice=function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(event){var _ref8,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:event.preventDefault();_context4.next=3;return _this.props.client.mutate({mutation:DEASSIGN_DEVICE_FROM_SUBSCRIPTION,variables:{serial_num:_this.state.serialNum,imei_num:_this.state.imeiNum,subscriptionId:_this.subscriptionId},errorPolicy:'all'});case 3:_ref8=_context4.sent;data=_ref8.data;// console.log('submit', data)
if(data!=null&&data.deassignDeviceFromSubscription===true){_this.handleCloseEditDevice();_this.props.openSnackbar('Device Deassigned Successfully');_this.getSubscriptionInventory();}else{_this.props.openSnackbar('Error in deassigning Device');}case 6:case'end':return _context4.stop();}}},_callee4,_this2);}));return function(_x2){return _ref7.apply(this,arguments);};}();_this.setDetails=function(inventoryDetails){if(inventoryDetails){if(inventoryDetails.assignedDeviceDetails.length>0){_this.mapToArr(inventoryDetails.assignedDeviceDetails);}if(inventoryDetails.asignedSimDetails.length>0){_this.mapToSimArr(inventoryDetails.asignedSimDetails);}}};_this.loginId=parseInt(_this.props.match.params.loginId,10);_this.subscriptionId=parseInt(_this.props.match.params.subscriptionId,10);_this.state={deviceList:[],simList:[],openEdit:false,openEditDevice:false,simNo:'',phoneNo:'',serialNum:'',imeiNum:''};return _this;}/*
  ##### For Statu Code 1, 3, and 4 Edit button will be invisisble.
      CODE  STATUS
        1 - Pending
        2 - Approved and partial payment
        3 - Rejected
        4 - Pending of already approved subscription.
        5 - Approved and fully paid
  #####
  */_createClass(ViewSubscription,[{key:'componentDidMount',value:function componentDidMount(){this.getSubscriptionInventory();this.getSubscriptionData();}},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;var isEditButton=this.state.isEditButton;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_apollo__["Query"],{query:GET_CLIENT,variables:{loginId:parseInt(this.loginId,10)}// fetchPolicy="network-only"
},function(_ref9){var loading=_ref9.loading,error=_ref9.error,data=_ref9.data;if(loading)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_common_Loader__["a" /* default */],null);if(error)return'Error!: '+error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,justify:'space-between'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{variant:'outlined',color:'secondary',className:classes.button,onClick:function onClick(){return _this3.props.history.goBack();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_ArrowBack___default.a,{className:classes.iconSmall}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true},!['INV','ACC'].includes(Object(__WEBPACK_IMPORTED_MODULE_12__utils_getAccountType_js__["a" /* default */])())&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,spacing:8,justify:'flex-end'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,sm:'auto'},_this3.state.isEditButton&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{variant:'raised',color:'secondary',className:classes.button,onClick:_this3.editSubscription},'Edit')))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'display1',gutterBottom:true},'\xA0',data.clientDetail.clientName,console.log(data.subscription))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__subscriptionDetails_jsx__["a" /* default */],{clientDetail:data.clientDetail,showSubscription:_this3.showSubscription,subscriptionId:_this3.subscriptionId,clientLoginId:_this3.loginId,isDisabled:true,paymentId:_this3.state.paymentId})),['SAL','PA','INV'].includes(Object(__WEBPACK_IMPORTED_MODULE_12__utils_getAccountType_js__["a" /* default */])())&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},_this3.state.deviceList&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_mui_datatables___default.a,{title:'Assigned Devices',data:_this3.state.deviceList,columns:_this3.columns1,options:_this3.options1})),['SAL','PA','INV'].includes(Object(__WEBPACK_IMPORTED_MODULE_12__utils_getAccountType_js__["a" /* default */])())&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},_this3.state.simList&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_mui_datatables___default.a,{title:'Assigned SIMs',data:_this3.state.simList,columns:_this3.columns2,options:_this3.options2})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Dialog___default.a,{open:_this3.state.openEditDevice,onClose:_this3.handleCloseEditDevice,'aria-labelledby':'form-dialog-title'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_DialogTitle___default.a,{id:'alert-dialog-title'},'Are you sure you want to Deassign this Device from the Subscription?'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_DialogActions___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{onClick:_this3.handleCloseEditDevice,color:'primary'},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{onClick:_this3.deassignDevice,color:'primary',autoFocus:true},'Deassign')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Dialog___default.a,{open:_this3.state.openEdit,onClose:_this3.handleCloseEdit,'aria-labelledby':'form-dialog-title'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_DialogTitle___default.a,{id:'alert-dialog-title'},'Are you sure you want to Deassign this sim from the Subscription?'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_DialogActions___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{onClick:_this3.handleCloseEdit,color:'primary'},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{onClick:_this3.deassignSim,color:'primary',autoFocus:true},'Deassign'))))));}));}}]);return ViewSubscription;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);ViewSubscription.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_7_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_19__HOCs_withSharedSnackbar__["a" /* default */])(ViewSubscription))));

/***/ }),
/* 2060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Modules_CustomerDetailsCard__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__subscriptionDetails_jsx__ = __webpack_require__(2061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_axios__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_ConfirmationDialog__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_icons_ArrowBack__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_icons_ArrowBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__material_ui_icons_ArrowBack__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query allClientDetails($partnerLoginId: Int) {\n    clients: allClientDetails(partnerLoginId: $partnerLoginId) {\n      id\n      clientName\n      loginId\n    }\n  }\n'],['\n  query allClientDetails($partnerLoginId: Int) {\n    clients: allClientDetails(partnerLoginId: $partnerLoginId) {\n      id\n      clientName\n      loginId\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query clientDetail($id: Int) {\n    clientDetail(loginId: $id) {\n      id\n      clientName\n      contactPerson\n      address\n      city\n      expiryDate\n      status\n      state {\n        zone_id\n      }\n      country {\n        country_id\n      }\n      email\n      contactNumber\n      login {\n        username\n      }\n      billingMode {\n        id\n      }\n      pincode\n      panNumber\n      type\n    }\n  }\n'],['\n  query clientDetail($id: Int) {\n    clientDetail(loginId: $id) {\n      id\n      clientName\n      contactPerson\n      address\n      city\n      expiryDate\n      status\n      state {\n        zone_id\n      }\n      country {\n        country_id\n      }\n      email\n      contactNumber\n      login {\n        username\n      }\n      billingMode {\n        id\n      }\n      pincode\n      panNumber\n      type\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation addSubscriptions(\n    $clientLoginId: Int!\n    $partnerLoginId: Int!\n    $billingFrequencyId: Int!\n    $deviceModelId: Int!\n    $deviceQuantity: Int!\n    $accessoryTypeId: Int\n    $accessoryQuantity: Int\n    $serviceProviderId: Int\n    $simQuantity: Int\n    $softwareQuantity: Int!\n    $salesRemarks: String\n    $hardwareCharges: Int!\n    $accessoryCharges: Int\n    $simCharges: Int\n    $deviceTrackingCharges: Int!\n    $billingStartFrom: String\n    $billingPayTill: String\n    $bucketName: String\n    $fileName: String\n    $GST: Float!\n  ) {\n    addSubscriptions(\n      clientLoginId: $clientLoginId\n      partnerLoginId: $partnerLoginId\n      billingFrequencyId: $billingFrequencyId\n      deviceModelId: $deviceModelId\n      deviceQuantity: $deviceQuantity\n      accessoryTypeId: $accessoryTypeId\n      accessoryQuantity: $accessoryQuantity\n      serviceProviderId: $serviceProviderId\n      simQuantity: $simQuantity\n      softwareQuantity: $softwareQuantity\n      salesRemarks: $salesRemarks\n      hardwareCharges: $hardwareCharges\n      accessoryCharges: $accessoryCharges\n      simCharges: $simCharges\n      deviceTrackingCharges: $deviceTrackingCharges\n      billingStartedFrom: $billingStartFrom\n      billingPayTill: $billingPayTill\n      bucketName: $bucketName\n      fileName: $fileName\n      GST: $GST\n    )\n  }\n'],['\n  mutation addSubscriptions(\n    $clientLoginId: Int!\n    $partnerLoginId: Int!\n    $billingFrequencyId: Int!\n    $deviceModelId: Int!\n    $deviceQuantity: Int!\n    $accessoryTypeId: Int\n    $accessoryQuantity: Int\n    $serviceProviderId: Int\n    $simQuantity: Int\n    $softwareQuantity: Int!\n    $salesRemarks: String\n    $hardwareCharges: Int!\n    $accessoryCharges: Int\n    $simCharges: Int\n    $deviceTrackingCharges: Int!\n    $billingStartFrom: String\n    $billingPayTill: String\n    $bucketName: String\n    $fileName: String\n    $GST: Float!\n  ) {\n    addSubscriptions(\n      clientLoginId: $clientLoginId\n      partnerLoginId: $partnerLoginId\n      billingFrequencyId: $billingFrequencyId\n      deviceModelId: $deviceModelId\n      deviceQuantity: $deviceQuantity\n      accessoryTypeId: $accessoryTypeId\n      accessoryQuantity: $accessoryQuantity\n      serviceProviderId: $serviceProviderId\n      simQuantity: $simQuantity\n      softwareQuantity: $softwareQuantity\n      salesRemarks: $salesRemarks\n      hardwareCharges: $hardwareCharges\n      accessoryCharges: $accessoryCharges\n      simCharges: $simCharges\n      deviceTrackingCharges: $deviceTrackingCharges\n      billingStartedFrom: $billingStartFrom\n      billingPayTill: $billingPayTill\n      bucketName: $bucketName\n      fileName: $fileName\n      GST: $GST\n    )\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n'],['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_CLIENTS=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject);var GET_CLIENT=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject2);var ADD_SUBSCRIPTION=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject3);var GET_UPLOAD_URL=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject4);var style=function style(theme){var _root;return{root:(_root={padding:theme.spacing.unit*4},_defineProperty(_root,theme.breakpoints.down('sm'),{padding:theme.spacing.unit*2}),_defineProperty(_root,'flexGrow',1),_root),input:{display:'flex',padding:0}};};function ClientSelected(props){var isClientSelected=props.isClientSelected;if(isClientSelected){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Modules_CustomerDetailsCard__["a" /* default */],{clientDetail:props.clientDetails})));}return null;}function ShowSubDetails(props){var isClientSelected=props.isClientSelected;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__common_ConfirmationDialog__["a" /* default */],{isDialogOpen:props.isSaveConfDialogOpen,dialogMessage:'Are you sure you want to Save this subscription?',negativeResponseHandler:props.saveNegativeResponseHandler,positiveResponseHandler:props.savePositiveResponseHandler,isSaveBtnDisabled:props.isSaveBtnDisabled}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__common_ConfirmationDialog__["a" /* default */],{isDialogOpen:props.isCancelConfDialogOpen,dialogMessage:'Are you sure you want to Cancel new subscription creation?',negativeResponseHandler:props.cancelNegativeResponseHandler,positiveResponseHandler:props.cancelPositiveResponseHandler}),isClientSelected&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__subscriptionDetails_jsx__["a" /* default */],{isClientSelected:props.isClientSelected,clientDetails:props.clientDetails,isSaveButtonDisabled:props.billingFrequency===null||props.salesRemarks===null||props.billingDate===null||props.totalQuantity===null||props.deviceModel===null||props.deviceQuantity===null||props.softwareQuantity===null||props.accessoryCharges===''||props.accessoryCharges===null||parseInt(props.softwareQuantity,10)===0||parseInt(props.deviceQuantity,10)===0||props.gstRate===null||props.hardwareCharges===null||props.hardwareCharges===''||// parseInt(props.hardwareCharges, 10) === 0 ||
props.deviceTrackingCharges===null||props.deviceTrackingCharges===''||parseInt(props.deviceTrackingCharges,10)===0||props.gstRate===''||props.billingMode===''||props.billingFrequency===''||props.billingLogic===''||props.deviceModel===''||props.deviceQuantity==='',isPIUploading:props.isPIUploading,PIFileName:props.PIFileName,billingMode:props.billingMode,billingFrequency:props.billingFrequency,billingFrequencies:props.billingFrequencies,perpetual:props.perpetual,billingDate:props.billingDate,billingDates:props.billingDates,gstRate:props.gstRate,gstRates:props.gstRates,deviceTrackingCharges:props.deviceTrackingCharges,totalAmountSoftware:props.totalAmountSoftware,totalAmountHardware:props.totalAmountHardware,totalAmountSim:props.totalAmountSim,totalAmountAccessory:props.totalAmountAccessory,billingStartFrom:props.billingStartFrom,billingPayTill:props.billingPayTill,deviceModel:props.deviceModel,deviceQuantity:props.deviceQuantity,softwareQuantity:props.softwareQuantity,accessoryModel:props.accessoryModel,accessoryQuantity:props.accessoryQuantity,simModel:props.simModel,simQuantity:props.simQuantity,salesRemarks:props.salesRemarks,simCharges:props.simCharges,hardwareCharges:props.hardwareCharges,accessoryCharges:props.accessoryCharges,handleDateChange:props.handleDateChange,handleChange:props.handleChange,handlePerptualCheckbox:props.handlePerptualCheckbox,handleSalesRemarksChange:props.handleSalesRemarksChange,handleSelectChange:props.handleSelectChange,handleSelectBillingModeChange:props.handleSelectBillingModeChange,handleSaveClick:props.handleSaveClick,handleCancelClick:props.handleCancelClick,handlePIUpload:props.handlePIUpload,handleAnnualSimChargesChange:props.handleAnnualSimChargesChange,handleHardwareChargesChange:props.handleHardwareChargesChange,handleAccessoryChargesChange:props.handleAccessoryChargesChange,handleGSTRateChange:props.handleGSTRateChange}))));}var NewSubscription=function(_Component){_inherits(NewSubscription,_Component);function NewSubscription(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,NewSubscription);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NewSubscription.__proto__||Object.getPrototypeOf(NewSubscription)).call.apply(_ref,[this].concat(args))),_this),_this.state={clientId:null,isClientSelected:false,clientDetails:null,billingMode:null,billingFrequency:null,billingFrequencies:null,totalAmountSoftware:null,totalAmountHardware:null,totalAmountSim:null,totalAmountAccessory:null,deviceModel:null,deviceQuantity:null,softwareQuantity:null,perpetual:true,accessoryModel:null,accessoryQuantity:null,simModel:null,simQuantity:null,salesRemarks:null,deviceTrackingCharges:0,simCharges:0,hardwareCharges:0,accessoryCharges:0,isPIUploading:false,PIBucketName:null,PIFileName:null,// billingDates: null,
// billingDate: null,
gstRates:null,gstRate:null,clientsDetails:null,showTotalAmount:false,isSaveConfDialogOpen:false,isSaveBtnDisabled:false,isCancelConfDialogOpen:false,billingStartFrom:{date:__WEBPACK_IMPORTED_MODULE_13_moment___default()(),unix:__WEBPACK_IMPORTED_MODULE_13_moment___default()().unix().toString()},billingPayTill:{date:__WEBPACK_IMPORTED_MODULE_13_moment___default()(),unix:__WEBPACK_IMPORTED_MODULE_13_moment___default()().unix().toString()}},_this.handlePIUpload=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2){var _ref2$target=_ref2.target,validity=_ref2$target.validity,_ref2$target$files=_slicedToArray(_ref2$target.files,1),file=_ref2$target$files[0];var fileExtension,response,url,res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:// TODO: Handle upload errors
_this.setState({isPIUploading:true});if(!validity.valid){_context.next=13;break;}fileExtension=file.name.substring(file.name.lastIndexOf('.')+1);_context.next=5;return _this.props.client.mutate({mutation:GET_UPLOAD_URL,variables:{fileExtension:fileExtension}});case 5:response=_context.sent;if(!(response.data&&response.data.getPublicUploadURL)){_context.next=13;break;}url=response.data.getPublicUploadURL.publicUploadURL;_context.next=10;return __WEBPACK_IMPORTED_MODULE_15_axios___default.a.put(url,file,{headers:{"x-ms-blob-type":"BlockBlob","Content-Type":file.type||"application/octet-stream"}});case 10:res=_context.sent;console.log('upload',res);_this.setState({PIFileName:response.data.getPublicUploadURL.filename,PIBucketName:response.data.getPublicUploadURL.bucketName});case 13:console.log('final',_this.state.PIBucketName,_this.state.PIFileName);_this.setState({isPIUploading:false});case 15:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref3.apply(this,arguments);};}(),_this.handleDateChange=function(name){return function(date){var tempDate=_this.state[name];tempDate.date=date;tempDate.unix=__WEBPACK_IMPORTED_MODULE_13_moment___default()(date).unix().toString();_this.setState(_defineProperty({},name,tempDate));};},_this.handleSalesRemarksChange=function(event){_this.setState({salesRemarks:event.target.value});},_this.handleAnnualSimChargesChange=function(e){_this.setState({simCharges:e.target.value});},_this.handleHardwareChargesChange=function(e){_this.setState({hardwareCharges:e.target.value});},_this.handleAccessoryChargesChange=function(e){_this.setState({accessoryCharges:e.target.value});},_this.handlePerptualCheckbox=function(e){console.log('heeyyyeyey');_this.setState(function(prev){return{perpetual:!prev.perpetual};});},_this.handleChange=function(name){return function(event){if(event.target.value>=0){_this.setState(_defineProperty({},name,event.target.value),function(){if(name==='softwareQuantity'||name==='deviceTrackingCharges'){var _this$state=_this.state,softwareQuantity=_this$state.softwareQuantity,deviceTrackingCharges=_this$state.deviceTrackingCharges;_this.calculateAmount(softwareQuantity,deviceTrackingCharges,name);}if(name==='deviceQuantity'||name==='hardwareCharges'){var _this$state2=_this.state,deviceQuantity=_this$state2.deviceQuantity,hardwareCharges=_this$state2.hardwareCharges;_this.calculateAmount(deviceQuantity,hardwareCharges,name);}if(name==='accessoryQuantity'||name==='accessoryCharges'){var _this$state3=_this.state,accessoryQuantity=_this$state3.accessoryQuantity,accessoryCharges=_this$state3.accessoryCharges;_this.calculateAmount(accessoryQuantity,accessoryCharges,name);}if(name==='simQuantity'||name==='simCharges'){var _this$state4=_this.state,simQuantity=_this$state4.simQuantity,simCharges=_this$state4.simCharges;_this.calculateAmount(simQuantity,simCharges,name);}});}else if(!event.target.value){if(name==='softwareQuantity'||name==='deviceTrackingCharges'){var _this$setState3;_this.setState((_this$setState3={},_defineProperty(_this$setState3,name,null),_defineProperty(_this$setState3,'totalAmountSoftware',null),_this$setState3));}if(name==='deviceQuantity'||name==='hardwareCharges'){var _this$setState4;_this.setState((_this$setState4={},_defineProperty(_this$setState4,name,null),_defineProperty(_this$setState4,'totalAmountHardware',null),_this$setState4));}if(name==='accessoryQuantity'||name==='accessoryCharges'){var _this$setState5;_this.setState((_this$setState5={},_defineProperty(_this$setState5,name,null),_defineProperty(_this$setState5,'totalAmountAccessory',null),_this$setState5));}if(name==='simQuantity'||name==='simCharges'){var _this$setState6;_this.setState((_this$setState6={},_defineProperty(_this$setState6,name,null),_defineProperty(_this$setState6,'totalAmountSim',null),_this$setState6));}}};},_this.handleSelectChange=function(name){return function(value){if(value){_this.setState(_defineProperty({},name,value.value),function(){});}else{_this.setState(_defineProperty({},name,0),function(){});}};},_this.setGstRateAndBillingDates=function(){var arrayDates=[5,10,15,20];var billingDates=arrayDates.map(function(days){return{value:days,label:days+'th'};});var gstRates=[5,10,12,15,18];var billingGst=gstRates.map(function(gst){return{value:gst,label:gst};});_this.setState({billingDates:billingDates,gstRates:billingGst});},_this.handleClientChange=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(customer){var cltId,_ref5,data,_ref6,_data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:cltId='';if(!(_this.props.match.params.loginId===undefined||_this.props.match.params.loginId==='')){_context2.next=14;break;}cltId=customer.value;if(customer){_context2.next=7;break;}_this.setState({clientId:null,isClientSelected:false,clientDetails:null});_context2.next=12;break;case 7:_context2.next=9;return _this.props.client.query({query:GET_CLIENT,variables:{id:parseInt(cltId,10)}});case 9:_ref5=_context2.sent;data=_ref5.data;_this.setState({clientDetails:data.clientDetail,clientId:cltId,isClientSelected:true});case 12:_context2.next=21;break;case 14:cltId=_this.props.match.params.loginId;_this.props.match.params.loginId='';_context2.next=18;return _this.props.client.query({query:GET_CLIENT,variables:{id:parseInt(cltId,10)}});case 18:_ref6=_context2.sent;_data=_ref6.data;_this.setState({clientDetails:_data.clientDetail,clientId:cltId,isClientSelected:true});case 21:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref4.apply(this,arguments);};}(),_this.handleCancelSubscription=function(e){// this.setState({
//   billingMode: null,
//   billingFrequency: null,
//   billingFrequencies: null,
//   totalQuantity: null,
//   totalAmount: null,
//   deviceModel: null,
//   deviceQuantity: null,
//   accessoryModel: null,
//   accessoryQuantity: null,
//   simModel: null,
//   simQuantity: null,
//   grandTotalAmount: null,
//   PIBucketName: null,
//   PIFileName: null
// })
_this.props.history.goBack();},_this.handleCancelClick=function(e){_this.setState({isCancelConfDialogOpen:true});},_this.handleBackCancelClick=function(e){console.log(_this.state.clientId);// if (
//   this.state.clientId === null
// ) {
//   this.props.history.goBack()
// } else {
//   this.setState({ isCancelConfDialogOpen: true })
// }
_this.state.clientId===null?_this.props.history.goBack():_this.setState({isCancelConfDialogOpen:true});},_this.handleSaveClick=function(e){_this.setState({isSaveConfDialogOpen:true});},_this.handleCancelNegativeResponse=function(e){_this.setState({isCancelConfDialogOpen:false});},_this.handleSaveNegativeResponse=function(e){_this.setState({isSaveConfDialogOpen:false});_this.setState({isSaveBtnDisabled:false});},_this.handleSaveSubscription=function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(event){var _ref8,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_this.setState({isSaveBtnDisabled:true});// console.log(this.state.simModel, 'acc')
if(!(parseInt(_this.state.deviceQuantity,10)!==parseInt(_this.state.softwareQuantity,10))){_context3.next=5;break;}_this.props.openSnackbar('The Software Quantity and Device Quantity Should Be Equal');_context3.next=37;break;case 5:if(!(_this.state.deviceQuantity<1)){_context3.next=9;break;}_this.props.openSnackbar('Device quantity should be greater than 0');_context3.next=37;break;case 9:if(!(_this.state.simModel!==null&&_this.state.simModel!==''&&(_this.state.simQuantity<1||_this.state.simQuantity===null||_this.state.simQuantity===''))){_context3.next=13;break;}_this.props.openSnackbar('Select valid quantity for Sim');_context3.next=37;break;case 13:if(!(_this.state.accessoryModel!==null&&_this.state.accessoryModel!==''&&(_this.state.accessoryQuantity<1||_this.state.accessoryQuantity===null||_this.state.accessoryQuantity===''))){_context3.next=17;break;}_this.props.openSnackbar('Select valid quantity for Accessory');// } else if (
//   this.state.simModel !== 0 &&
//   this.state.simModel !== '' &&
//   this.state.simQuantity > 0 &&
//   (this.state.simCharges === 0 || this.state.simCharges === '')
// ) {
//   this.props.openSnackbar('Select valid Price for Sim')
// }
_context3.next=37;break;case 17:if(!((_this.state.simModel===null||_this.state.simModel==='')&&(_this.state.simQuantity>0||_this.state.simQuantity!==null&&_this.state.simQuantity!==''))){_context3.next=21;break;}_this.props.openSnackbar('Please Select Sim Provider');_context3.next=37;break;case 21:if(!((_this.state.accessoryModel===null||_this.state.accessoryModel==='')&&(_this.state.accessoryQuantity>0||_this.state.accessoryQuantity!==null&&_this.state.accessoryQuantity!==''))){_context3.next=25;break;}_this.props.openSnackbar('Please Select Accessory Model');_context3.next=37;break;case 25:_context3.next=27;return _this.props.client.mutate({mutation:ADD_SUBSCRIPTION,variables:{clientLoginId:parseInt(_this.state.clientId,10),partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_14__utils_getLoginId__["a" /* default */])(),billingFrequencyId:parseInt(_this.state.billingFrequency,10),deviceModelId:parseInt(_this.state.deviceModel,10),accessoryTypeId:parseInt(_this.state.accessoryModel,10),serviceProviderId:parseInt(_this.state.simModel,10),deviceQuantity:parseInt(_this.state.deviceQuantity,10),accessoryQuantity:parseInt(_this.state.accessoryQuantity,10),simQuantity:parseInt(_this.state.simQuantity,10),softwareQuantity:parseInt(_this.state.softwareQuantity,10),salesRemarks:_this.state.salesRemarks,deviceTrackingCharges:parseInt(_this.state.deviceTrackingCharges,10),simCharges:parseInt(_this.state.simCharges,10),hardwareCharges:parseInt(_this.state.hardwareCharges,10),accessoryCharges:parseInt(_this.state.accessoryCharges,10),billingStartFrom:_this.state.billingStartFrom.unix,billingPayTill:_this.state.billingPayTill.unix,bucketName:_this.state.PIBucketName,fileName:_this.state.PIFileName,GST:parseFloat(_this.state.gstRate,10)}});case 27:_ref8=_context3.sent;data=_ref8.data;if(!(data.addSubscriptions===true)){_context3.next=36;break;}_context3.next=32;return _this.props.client.clearStore();case 32:_this.props.openSnackbar('Subscription Creation Successful');_this.props.history.push({pathname:'/home/subscriptions/'});_context3.next=37;break;case 36:_this.props.openSnackbar('Subscription Creation Failed');case 37:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x3){return _ref7.apply(this,arguments);};}(),_this.getAllClients=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){var clientsDetails,allClients;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return _this.props.client.query({query:GET_CLIENTS,variables:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_14__utils_getLoginId__["a" /* default */])()},fetchPolicy:['network-only']});case 2:clientsDetails=_context4.sent;allClients=clientsDetails.data.clients.map(function(client){return{value:client.loginId,label:client.clientName};});_this.setState({clientsDetails:allClients});case 5:case'end':return _context4.stop();}}},_callee4,_this2);})),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NewSubscription,[{key:'calculateAmount',value:function calculateAmount(quantity,charges,productPerticular){var totalAmount=0;totalAmount=parseFloat(quantity,10)*parseFloat(charges,10);if(productPerticular==='softwareQuantity'||productPerticular==='deviceTrackingCharges'){if(!isNaN(totalAmount)){this.setState({totalAmountSoftware:Math.round(totalAmount)});}else{this.setState({totalAmountSoftware:''});}}if(productPerticular==='deviceQuantity'||productPerticular==='hardwareCharges'){if(!isNaN(totalAmount)){this.setState({totalAmountHardware:Math.round(totalAmount)});}else{this.setState({totalAmountHardware:''});}}if(productPerticular==='accessoryQuantity'||productPerticular==='accessoryCharges'){if(!isNaN(totalAmount)){this.setState({totalAmountAccessory:Math.round(totalAmount)});}else{this.setState({totalAmountAccessory:''});}}if(productPerticular==='simQuantity'||productPerticular==='simCharges'){if(!isNaN(totalAmount)){this.setState({totalAmountSim:Math.round(totalAmount)});}else{this.setState({totalAmountSim:''});}}}// handleSelectBillingModeChange = name => async value => {
//   if (!value) {
//     this.setState({
//       [name]: null,
//       billingFrequency: null,
//       billingFrequencies: null,
//       gstRates: null,
//       gstRate: null,
//       billingDate: null
//     })
//   } else {
//     const billId = value
//     const { data } = await this.props.client.query({
//       query: GET_BILLING_FREQUENCY,
//       variables: { billingModeId: parseInt(billId.value, 10) }
//     })
//     const billingFrequencies = data.getAllBillingFrequency.map(billFrq => ({
//       value: billFrq.id,
//       label: billFrq.frequency
//     }))
//     let arrayDates = [5, 10, 15, 20]
//     const billingDates = arrayDates.map(days => ({
//       value: days,
//       label: days + 'th'
//     }))
//     let gstRates = [5, 10, 12, 15, 18]
//     const billingGst = gstRates.map(gst => ({
//       value: gst / 100,
//       label: gst
//     }))
//     this.setState({
//       [name]: value.value,
//       billingFrequency: null,
//       billingFrequencies: billingFrequencies,
//       billingDates: billingDates,
//       gstRates: billingGst
//     })
//   }
// }
},{key:'componentDidMount',value:function componentDidMount(){if(this.props.match.params.loginId===undefined){this.getAllClients();}else{this.getAllClients();this.handleClientChange();}this.setGstRateAndBillingDates();}},{key:'render',value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{variant:'outlined',color:'secondary',className:classes.button,onClick:this.handleBackCancelClick},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_icons_ArrowBack___default.a,null))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'headline'},'Create Subscription')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6,lg:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */],{classes:classes,options:this.state.clientsDetails,value:this.state.clientId,onChange:this.handleClientChange,placeholder:'Select Customer *'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ClientSelected,{isClientSelected:this.state.isClientSelected,clientDetails:this.state.clientDetails})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ShowSubDetails,{isClientSelected:this.state.isClientSelected,clientDetails:this.state.clientDetails,isPIUploading:this.state.isPIUploading,isSaveConfDialogOpen:this.state.isSaveConfDialogOpen,isSaveBtnDisabled:this.state.isSaveBtnDisabled,isCancelConfDialogOpen:this.state.isCancelConfDialogOpen,PIFileName:this.state.PIFileName,billingMode:this.state.billingMode,billingFrequency:this.state.billingFrequency,billingFrequencies:this.state.billingFrequencies,billingDate:this.state.billingDate,billingDates:this.state.billingDates,gstRate:this.state.gstRate,gstRates:this.state.gstRates,deviceTrackingCharges:this.state.deviceTrackingCharges,totalAmountSoftware:this.state.totalAmountSoftware,totalAmountHardware:this.state.totalAmountHardware,totalAmountSim:this.state.totalAmountSim,totalAmountAccessory:this.state.totalAmountAccessory,billingStartFrom:this.state.billingStartFrom,billingPayTill:this.state.billingPayTill,deviceModel:this.state.deviceModel,deviceQuantity:this.state.deviceQuantity,softwareQuantity:this.state.softwareQuantity,perpetual:this.state.perpetual,accessoryModel:this.state.accessoryModel,accessoryQuantity:this.state.accessoryQuantity,simModel:this.state.simModel,simQuantity:this.state.simQuantity,salesRemarks:this.state.salesRemarks,handleDateChange:this.handleDateChange,handleSelectChange:this.handleSelectChange,handleChange:this.handleChange,handleSalesRemarksChange:this.handleSalesRemarksChange,simCharges:this.state.simCharges,hardwareCharges:this.state.hardwareCharges,accessoryCharges:this.state.accessoryCharges,handleAnnualSimChargesChange:this.handleAnnualSimChargesChange,handlePerptualCheckbox:this.handlePerptualCheckbox,handleHardwareChargesChange:this.handleHardwareChargesChange,handleAccessoryChargesChange:this.handleAccessoryChargesChange,handleGSTRateChange:this.handleGSTRateChange// handleCancelSubscription={this.handleCancelSubscription}
// handleSaveSubscription={this.handleSaveSubscription}
,handleSelectBillingModeChange:this.handleSelectBillingModeChange,handlePIUpload:this.handlePIUpload,handleCancelClick:this.handleCancelClick,handleSaveClick:this.handleSaveClick,cancelNegativeResponseHandler:this.handleCancelNegativeResponse,saveNegativeResponseHandler:this.handleSaveNegativeResponse,savePositiveResponseHandler:this.handleSaveSubscription,cancelPositiveResponseHandler:this.handleCancelSubscription,client:this.props.client})))));}}]);return NewSubscription;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);NewSubscription.propTypes={classes:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_12__HOCs_withSharedSnackbar__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6_react_apollo__["withApollo"])(NewSubscription))));

/***/ }),
/* 2061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_FileDownload__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_FileDownload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_FileDownload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Card__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_CardHeader__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_CardHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_CardHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_CardContent__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_CardContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_CardContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_CardActions__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_CardActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_CardActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_getLoginId__ = __webpack_require__(12);
var _templateObject=_taggedTemplateLiteral(['\n  query {\n    billingMode: getAllBillingMode {\n      id\n      billingMode\n    }\n  }\n'],['\n  query {\n    billingMode: getAllBillingMode {\n      id\n      billingMode\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query {\n    deviceModel: allDeviceModels {\n      id\n      model_name\n    }\n  }\n'],['\n  query {\n    deviceModel: allDeviceModels {\n      id\n      model_name\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query {\n    accessoryDetails: getAllAccessoryTypes {\n      id\n      accessoryName\n    }\n  }\n'],['\n  query {\n    accessoryDetails: getAllAccessoryTypes {\n      id\n      accessoryName\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query {\n    simDetails: allServiceProviders {\n      id\n      name\n    }\n  }\n'],['\n  query {\n    simDetails: allServiceProviders {\n      id\n      name\n    }\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  query getAllBillingFrequency($billingModeId: Int!) {\n    getAllBillingFrequency(billingModeId: $billingModeId) {\n      id\n      frequency\n      billingModeId\n      numberOfMonths\n    }\n  }\n'],['\n  query getAllBillingFrequency($billingModeId: Int!) {\n    getAllBillingFrequency(billingModeId: $billingModeId) {\n      id\n      frequency\n      billingModeId\n      numberOfMonths\n    }\n  }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// import React, { Fragment, useState } from 'react'
// import Grid from '@material-ui/core/Grid'
// import { withStyles } from '@material-ui/core/styles'
// import PropTypes from 'prop-types'
// import Typography from '@material-ui/core/Typography'
// import CircularProgress from '@material-ui/core/CircularProgress'
// import FileDownloadIcon from '@material-ui/icons/FileDownload'
// import Select from 'react-select'
// import TextField from '@material-ui/core/TextField'
// import Button from '@material-ui/core/Button'
// import Card from '@material-ui/core/Card'
// import CardHeader from '@material-ui/core/CardHeader'
// import CardContent from '@material-ui/core/CardContent'
// import CardActions from '@material-ui/core/CardActions'
// import Divider from '@material-ui/core/Divider'
// import { Checkbox } from '@material-ui/core'
// import gql from 'graphql-tag'
// import { Query, withApollo } from 'react-apollo'
// import getLoginId from '../../../utils/getLoginId'
// const GET_BILLING_MODE = gql`
//   query {
//     billingMode: getAllBillingMode {
//       id
//       billingMode
//     }
//   }
// `
// const GET_DEVICE_MODELS = gql`
//   query {
//     deviceModel: allDeviceModels {
//       id
//       model_name
//     }
//   }
// `
// const GET_ACCESSORY = gql`
//   query {
//     accessoryDetails: getAllAccessoryTypes {
//       id
//       accessoryName
//     }
//   }
// `
// const GET_SIM_PROVIDER = gql`
//   query {
//     simDetails: allServiceProviders {
//       id
//       name
//     }
//   }
// `
// const GET_BILLING_FREQUENCY = gql`
//   query getAllBillingFrequency($billingModeId: Int!) {
//     getAllBillingFrequency(billingModeId: $billingModeId) {
//       id
//       frequency
//       billingModeId
//       numberOfMonths
//     }
//   }
// `
// const style = theme => ({
//   // textField: {
//   //   marginLeft: theme.spacing.unit * 2,
//   //   marginRight: theme.spacing.unit * 2,
//   //   width: '100%'
//   // }
//   // root: {
//   //   padding: theme.spacing.unit * 1,
//   //   flexGrow: 1
//   // },
//   // input: {
//   //   display: 'flex',
//   //   padding: 0
//   // }
//   card: {
//     overflow: 'visible'
//   },
//   italicizedText: {
//     fontStyle: 'italic'
//   },
//   fileDownloadIcon: {
//     marginLeft: theme.spacing.unit,
//     marginRight: -theme.spacing.unit
//   },
//   wrapFileName: {
//     overflow: 'hidden',
//     whiteSpace: 'nowrap',
//     textOverflow: 'ellipsis',
//     maxWidth: '250px'
//   },
//   cardHeaderAction: {
//     marginTop: '0px',
//     marginRight: '-8px'
//   },
//   selectSytle: {
//     width: '80%'
//   },
//   dividerStyle: {
//     margin: '10px 0px 0 0'
//   }
// })
// function SubscriptionDetails(props) {
//   const { classes, clientDetails } = props
//   const {
//     billingMode: { id }
//   } = clientDetails
//   console.log('client deatails from :', id, clientDetails)
//   console.log('thththht', props)
//   return (
//     <Query
//       query={GET_BILLING_FREQUENCY}
//       variables={{
//         billingModeId: id
//       }}
//     >
//       {({ loading, error, data }) => {
//         if (loading) return 'Loading...'
//         if (error) return `Error!: ${error}`
//         const billingFrequencies = data.getAllBillingFrequency.map(billFrq => ({
//           value: billFrq.id,
//           label: billFrq.frequency
//         }))
//         return (
//           <Query query={GET_BILLING_MODE}>
//             {({ loading, error, data: { billingMode } }) => {
//               if (loading) return 'Loading...'
//               if (error) return `Error!: ${error}`
//               const billingModes = billingMode.map(billingMode => ({
//                 value: billingMode.id,
//                 label: billingMode.billingMode
//               }))
//               return (
//                 <Query query={GET_DEVICE_MODELS}>
//                   {({ loading, error, data: { deviceModel } }) => {
//                     if (loading) return 'Loading...'
//                     if (error) return `Error!: ${error}`
//                     const deviceModels = deviceModel.map(deviceModel => ({
//                       value: deviceModel.id,
//                       label: deviceModel.model_name
//                     }))
//                     return (
//                       <Query query={GET_ACCESSORY}>
//                         {({ loading, error, data: { accessoryDetails } }) => {
//                           if (loading) return 'Loading...'
//                           if (error) return `Error!: ${error}`
//                           const accessoryModels = accessoryDetails.map(
//                             accessoryDetails => ({
//                               value: accessoryDetails.id,
//                               label: accessoryDetails.accessoryName
//                             })
//                           )
//                           return (
//                             <Query query={GET_SIM_PROVIDER}>
//                               {({ loading, error, data: { simDetails } }) => {
//                                 if (loading) return 'Loading...'
//                                 if (error) return `Error!: ${error}`
//                                 const simProviders = simDetails.map(
//                                   simDetails => ({
//                                     value: simDetails.id,
//                                     label: simDetails.name
//                                   })
//                                 )
//                                 return (
//                                   <Card className={classes.card}>
//                                     <CardHeader
//                                       title="Subscription Details"
//                                       subheader="All fields marked with (*) are mandatory"
//                                       subheaderTypographyProps={{
//                                         className: classes.italicizedText
//                                       }}
//                                       classes={{
//                                         action: classes.cardHeaderAction
//                                       }}
//                                       action={
//                                         <Fragment>
//                                           <input
//                                             accept=".pdf"
//                                             id="contained-button-pi-upload"
//                                             type="file"
//                                             style={{
//                                               display: 'none'
//                                             }}
//                                             onChange={props.handlePIUpload}
//                                           />
//                                           {/* eslint-disable */}
//                                           <label htmlFor="contained-button-pi-upload">
//                                             <Button
//                                               variant="contained"
//                                               color="secondary"
//                                               component="span"
//                                               // disabled
//                                             >
//                                               {props.isPIUploading ? (
//                                                 <CircularProgress
//                                                   size={15}
//                                                   color="inherit"
//                                                 />
//                                               ) : (
//                                                 <span
//                                                   className={
//                                                     classes.wrapFileName
//                                                   }
//                                                 >
//                                                   {props.PIFileName === null
//                                                     ? 'Upload PI'
//                                                     : props.PIFileName}
//                                                 </span>
//                                               )}
//                                               {props.isPIUploading ||
//                                               props.PIFileName ? null : (
//                                                 <FileDownloadIcon
//                                                   className={
//                                                     classes.fileDownloadIcon
//                                                   }
//                                                 />
//                                               )}
//                                             </Button>
//                                           </label>
//                                         </Fragment>
//                                       }
//                                     />
//                                     <CardContent>
//                                       <Grid container spacing={16}>
//                                         {/* <Grid item xs={12}>
//                                     <Grid container alignItems="center">
//                                       <Grid item xs={12} md={3}>
//                                         <Select
//                                           className={classes.selectSytle}
//                                           options={billingFrequencies}
//                                           value={props.billingFrequency}
//                                           onChange={props.handleSelectChange(
//                                             'billingFrequency'
//                                           )}
//                                           placeholder="Billing Frequency *"
//                                         />
//                                       </Grid>
//                                       <Grid item xs={12} md={3}>
//                                         <TextField
//                                           required
//                                           id="salesRemarks"
//                                           label="Sales Remarks"
//                                           value={props.salesRemarks}
//                                           onChange={
//                                             props.handleSalesRemarksChange
//                                           }
//                                           margin="none"
//                                         />
//                                       </Grid>
//                                       <Grid item xs={12} md={3}>
//                                         <Select
//                                           className={classes.selectSytle}
//                                           options={props.gstRates}
//                                           value={props.gstRate}
//                                           onChange={props.handleSelectChange(
//                                             'gstRate'
//                                           )}
//                                           placeholder="Select GST Rate *"
//                                         />
//                                       </Grid>
//                                     </Grid>
//                                   </Grid> */}
//                                         {/* Divider Line */}
//                                         {/* <Grid item xs={12}>
//                                     <Divider className={classes.dividerStyle} />
//                                   </Grid> */}
//                                         {/* Software Row */}
//                                         <Grid item xs={12}>
//                                           <Grid
//                                             container
//                                             alignItems="baseline"
//                                             spacing={8}
//                                           >
//                                             <Grid item xs={12}>
//                                               <Typography variant="body1">
//                                                 Software
//                                               </Typography>
//                                             </Grid>
//                                             <Grid
//                                               container
//                                               justify="flex-start"
//                                               alignItems="flex-end"
//                                             >
//                                               <Grid item xs={12} sm={3}>
//                                                 <TextField
//                                                   disabled
//                                                   label="AquilaTrack Software"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} sm={3}>
//                                                 <TextField
//                                                   id="softwareQuantity"
//                                                   label="Software Quantity *"
//                                                   value={props.softwareQuantity}
//                                                   onChange={props.handleChange(
//                                                     'softwareQuantity'
//                                                   )}
//                                                   type="number"
//                                                   inputProps={{ min: 0 }}
//                                                   margin="none"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} sm={3}>
//                                                 <TextField
//                                                   id="amount"
//                                                   type="number"
//                                                   label="Software charges*"
//                                                   value={
//                                                     props.deviceTrackingCharges
//                                                   }
//                                                   onChange={props.handleChange(
//                                                     'deviceTrackingCharges'
//                                                   )}
//                                                   inputProps={{ min: 0 }}
//                                                   margin="none"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} sm={3}>
//                                                 <Select
//                                                   className={
//                                                     classes.selectSytle
//                                                   }
//                                                   options={billingModes}
//                                                   value={props.billingMode}
//                                                   onChange={props.handleSelectChange(
//                                                     'billingMode'
//                                                   )}
//                                                   placeholder="Billing Mode *"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} md={3}>
//                                                 <Select
//                                                   className={
//                                                     classes.selectSytle
//                                                   }
//                                                   options={billingFrequencies}
//                                                   value={props.billingFrequency}
//                                                   onChange={props.handleSelectChange(
//                                                     'billingFrequency'
//                                                   )}
//                                                   placeholder="Billing Frequency *"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} sm={3}>
//                                                 <TextField
//                                                   id="warrantyPeriod"
//                                                   label="Warranty Period *"
//                                                   value={props.softwareQuantity}
//                                                   // onChange={props.handleChange(
//                                                   //   'softwareQuantity'
//                                                   // )}
//                                                   type="number"
//                                                   inputProps={{ min: 0 }}
//                                                   margin="none"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} sm={3}>
//                                                 <TextField
//                                                   id="creditPeriod"
//                                                   label="Credit Period *"
//                                                   value={props.softwareQuantity}
//                                                   // onChange={props.handleChange(
//                                                   //   'softwareQuantity'
//                                                   // )}
//                                                   type="number"
//                                                   inputProps={{ min: 0 }}
//                                                   margin="none"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} sm={3}>
//                                                 <TextField
//                                                   id="creditPeriod"
//                                                   label="Billed Upto *"
//                                                   value={props.softwareQuantity}
//                                                   // onChange={props.handleChange(
//                                                   //   'softwareQuantity'
//                                                   // )}
//                                                   type="text"
//                                                   // inputProps={{ min: 0 }}
//                                                   margin="none"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} md={12}>
//                                                 <label>
//                                                   <Checkbox
//                                                     name="perpetual"
//                                                     defaultChecked={true}
//                                                     value={props.perpetual}
//                                                     onClick={
//                                                       props.handlePerptualCheckbox
//                                                     }
//                                                   />
//                                                   <span
//                                                   // style={{
//                                                   //   fontSize: '20px'
//                                                   // }}
//                                                   >
//                                                     Perptual Billing
//                                                   </span>
//                                                 </label>
//                                               </Grid>
//                                               {props.perpetual && (
//                                                 <Grid item xs={12} sm={3}>
//                                                   <TextField
//                                                     // id="creditPeriod"
//                                                     label="Period *"
//                                                     value={
//                                                       props.softwareQuantity
//                                                     }
//                                                     // onChange={props.handleChange(
//                                                     //   'softwareQuantity'
//                                                     // )}
//                                                     type="number"
//                                                     // inputProps={{ min: 0 }}
//                                                     margin="none"
//                                                   />
//                                                 </Grid>
//                                               )}
//                                               <Button
//                                                 variant="contained"
//                                                 color="secondary"
//                                                 component="span"
//                                               >
//                                                 Add +
//                                               </Button>
//                                               {/* <Grid item xs={12} sm={3}>
//                                                 <Typography variant="body1">
//                                                   Total Amount per month (excl
//                                                   GST): &nbsp;
//                                                 </Typography>
//                                                 <Typography variant="body2">
//                                                   &#8377;{' '}
//                                                   {console.log(
//                                                     props.totalAmountSoftware
//                                                   )}
//                                                   {isNaN(
//                                                     parseInt(
//                                                       props.totalAmountSoftware,
//                                                       10
//                                                     )
//                                                   )
//                                                     ? '-'
//                                                     : props.totalAmountSoftware}
//                                                 </Typography>
//                                               </Grid> */}
//                                             </Grid>
//                                           </Grid>
//                                         </Grid>
//                                         {/* Divider Line */}
//                                         <Grid item xs={12}>
//                                           <Divider
//                                             className={classes.dividerStyle}
//                                           />
//                                         </Grid>
//                                         {/* Device Row */}
//                                         <Grid item xs={12}>
//                                           <Grid
//                                             container
//                                             alignItems="baseline"
//                                             spacing={8}
//                                           >
//                                             <Grid item xs={12}>
//                                               <Typography variant="body1">
//                                                 Devices
//                                               </Typography>
//                                             </Grid>
//                                             <Grid
//                                               container
//                                               justify="flex-start"
//                                               alignItems="flex-end"
//                                             >
//                                               <Grid item xs={12} sm={3}>
//                                                 <Select
//                                                   className={
//                                                     classes.selectSytle
//                                                   }
//                                                   options={deviceModels}
//                                                   value={props.deviceModel}
//                                                   onChange={props.handleSelectChange(
//                                                     'deviceModel'
//                                                   )}
//                                                   placeholder="Select Model *"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} sm={3}>
//                                                 <TextField
//                                                   id="quantity"
//                                                   label="Device Quantity *"
//                                                   value={props.totalQuantity}
//                                                   onChange={props.handleChange(
//                                                     'deviceQuantity'
//                                                   )}
//                                                   type="number"
//                                                   inputProps={{ min: 0 }}
//                                                   margin="none"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} sm={3}>
//                                                 <TextField
//                                                   id="hardwareCharges"
//                                                   type="number"
//                                                   label="Hardware Charges *"
//                                                   value={props.hardwareCharges}
//                                                   onChange={props.handleChange(
//                                                     'hardwareCharges'
//                                                   )}
//                                                   inputProps={{ min: 0 }}
//                                                   margin="none"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} sm={3}>
//                                                 <Select
//                                                   className={
//                                                     classes.selectSytle
//                                                   }
//                                                   options={billingModes}
//                                                   value={props.billingMode}
//                                                   onChange={props.handleSelectChange(
//                                                     'billingMode'
//                                                   )}
//                                                   placeholder="Billing Mode *"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} md={3}>
//                                                 <Select
//                                                   className={
//                                                     classes.selectSytle
//                                                   }
//                                                   options={billingFrequencies}
//                                                   value={props.billingFrequency}
//                                                   onChange={props.handleSelectChange(
//                                                     'billingFrequency'
//                                                   )}
//                                                   placeholder="Billing Frequency *"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} sm={3}>
//                                                 <TextField
//                                                   id="warrantyPeriod"
//                                                   label="Warranty Period *"
//                                                   value={props.softwareQuantity}
//                                                   // onChange={props.handleChange(
//                                                   //   'softwareQuantity'
//                                                   // )}
//                                                   type="number"
//                                                   inputProps={{ min: 0 }}
//                                                   margin="none"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} sm={3}>
//                                                 <TextField
//                                                   id="creditPeriod"
//                                                   label="Credit Period *"
//                                                   value={props.softwareQuantity}
//                                                   // onChange={props.handleChange(
//                                                   //   'softwareQuantity'
//                                                   // )}
//                                                   type="number"
//                                                   inputProps={{ min: 0 }}
//                                                   margin="none"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} sm={3}>
//                                                 <TextField
//                                                   id="creditPeriod"
//                                                   label="Billed Upto *"
//                                                   value={props.softwareQuantity}
//                                                   // onChange={props.handleChange(
//                                                   //   'softwareQuantity'
//                                                   // )}
//                                                   type="text"
//                                                   // inputProps={{ min: 0 }}
//                                                   margin="none"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} md={12}>
//                                                 <label>
//                                                   <Checkbox
//                                                     name="perpetual"
//                                                     defaultChecked={true}
//                                                     value={props.perpetual}
//                                                     onClick={
//                                                       props.handlePerptualCheckbox
//                                                     }
//                                                   />
//                                                   <span
//                                                   // style={{
//                                                   //   fontSize: '20px'
//                                                   // }}
//                                                   >
//                                                     Perptual Billing
//                                                   </span>
//                                                 </label>
//                                               </Grid>
//                                               {props.perpetual && (
//                                                 <Grid item xs={12} sm={3}>
//                                                   <TextField
//                                                     // id="creditPeriod"
//                                                     label="Period *"
//                                                     value={
//                                                       props.softwareQuantity
//                                                     }
//                                                     // onChange={props.handleChange(
//                                                     //   'softwareQuantity'
//                                                     // )}
//                                                     type="number"
//                                                     // inputProps={{ min: 0 }}
//                                                     margin="none"
//                                                   />
//                                                 </Grid>
//                                               )}
//                                               <Button
//                                                 variant="contained"
//                                                 color="secondary"
//                                                 component="span"
//                                               >
//                                                 Add +
//                                               </Button>
//                                               {/* <Grid item xs={12} sm={3}>
//                                                 <Typography variant="body1">
//                                                   Total Amount (excl GST):
//                                                   &nbsp;
//                                                 </Typography>
//                                                 <Typography variant="body2">
//                                                   &#8377;{' '}
//                                                   {console.log(
//                                                     props.totalAmountHardware
//                                                   )}
//                                                   {isNaN(
//                                                     parseInt(
//                                                       props.totalAmountHardware,
//                                                       10
//                                                     )
//                                                   )
//                                                     ? '-'
//                                                     : props.totalAmountHardware}
//                                                 </Typography>
//                                               </Grid> */}
//                                             </Grid>
//                                           </Grid>
//                                         </Grid>
//                                         {/* Divider Line */}
//                                         <Grid item xs={12}>
//                                           <Divider
//                                             className={classes.dividerStyle}
//                                           />
//                                         </Grid>
//                                         {/* Accessories Row */}
//                                         <Grid item xs={12}>
//                                           <Grid
//                                             container
//                                             alignItems="baseline"
//                                             spacing={8}
//                                           >
//                                             <Grid item xs={12}>
//                                               <Typography variant="body1">
//                                                 Accessories
//                                               </Typography>
//                                             </Grid>
//                                             <Grid
//                                               container
//                                               justify="flex-start"
//                                               alignItems="flex-end"
//                                             >
//                                               <Grid item xs={12} sm={3}>
//                                                 <Select
//                                                   className={
//                                                     classes.selectSytle
//                                                   }
//                                                   options={accessoryModels}
//                                                   value={props.accessoryModel}
//                                                   onChange={props.handleSelectChange(
//                                                     'accessoryModel'
//                                                   )}
//                                                   placeholder="Select Type"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} sm={3}>
//                                                 <TextField
//                                                   id="accessoryQuantity"
//                                                   label="Quantity"
//                                                   value={
//                                                     props.accessoryQuantity
//                                                   }
//                                                   onChange={props.handleChange(
//                                                     'accessoryQuantity'
//                                                   )}
//                                                   type="number"
//                                                   inputProps={{ min: 0 }}
//                                                   margin="none"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} sm={3}>
//                                                 <TextField
//                                                   id="accessoryCharges"
//                                                   label="Accessory Charges"
//                                                   type="number"
//                                                   value={props.accessoryCharges}
//                                                   onChange={props.handleChange(
//                                                     'accessoryCharges'
//                                                   )}
//                                                   inputProps={{ min: 0 }}
//                                                   margin="none"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} sm={3}>
//                                                 <Select
//                                                   className={
//                                                     classes.selectSytle
//                                                   }
//                                                   options={billingModes}
//                                                   value={props.billingMode}
//                                                   onChange={props.handleSelectChange(
//                                                     'billingMode'
//                                                   )}
//                                                   placeholder="Billing Mode *"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} md={3}>
//                                                 <Select
//                                                   className={
//                                                     classes.selectSytle
//                                                   }
//                                                   options={billingFrequencies}
//                                                   value={props.billingFrequency}
//                                                   onChange={props.handleSelectChange(
//                                                     'billingFrequency'
//                                                   )}
//                                                   placeholder="Billing Frequency *"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} sm={3}>
//                                                 <TextField
//                                                   id="warrantyPeriod"
//                                                   label="Warranty Period *"
//                                                   value={props.softwareQuantity}
//                                                   // onChange={props.handleChange(
//                                                   //   'softwareQuantity'
//                                                   // )}
//                                                   type="number"
//                                                   inputProps={{ min: 0 }}
//                                                   margin="none"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} sm={3}>
//                                                 <TextField
//                                                   id="creditPeriod"
//                                                   label="Credit Period *"
//                                                   value={props.softwareQuantity}
//                                                   // onChange={props.handleChange(
//                                                   //   'softwareQuantity'
//                                                   // )}
//                                                   type="number"
//                                                   inputProps={{ min: 0 }}
//                                                   margin="none"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} sm={3}>
//                                                 <TextField
//                                                   id="creditPeriod"
//                                                   label="Billed Upto *"
//                                                   value={props.softwareQuantity}
//                                                   // onChange={props.handleChange(
//                                                   //   'softwareQuantity'
//                                                   // )}
//                                                   type="text"
//                                                   // inputProps={{ min: 0 }}
//                                                   margin="none"
//                                                 />
//                                               </Grid>
//                                               <Grid item xs={12} md={12}>
//                                                 <label>
//                                                   <Checkbox
//                                                     name="perpetual"
//                                                     defaultChecked={true}
//                                                     value={props.perpetual}
//                                                     onClick={
//                                                       props.handlePerptualCheckbox
//                                                     }
//                                                   />
//                                                   <span
//                                                   // style={{
//                                                   //   fontSize: '20px'
//                                                   // }}
//                                                   >
//                                                     Perptual Billing
//                                                   </span>
//                                                 </label>
//                                               </Grid>
//                                               {props.perpetual && (
//                                                 <Grid item xs={12} sm={3}>
//                                                   <TextField
//                                                     // id="creditPeriod"
//                                                     label="Period *"
//                                                     value={
//                                                       props.softwareQuantity
//                                                     }
//                                                     // onChange={props.handleChange(
//                                                     //   'softwareQuantity'
//                                                     // )}
//                                                     type="number"
//                                                     // inputProps={{ min: 0 }}
//                                                     margin="none"
//                                                   />
//                                                 </Grid>
//                                               )}
//                                               <Button
//                                                 variant="contained"
//                                                 color="secondary"
//                                                 component="span"
//                                               >
//                                                 Add +
//                                               </Button>
//                                               {/* <Grid item xs={12} sm={3}>
//                                                 <Typography variant="body1">
//                                                   Total Amount (excl GST):
//                                                   &nbsp;
//                                                 </Typography>
//                                                 <Typography variant="body2">
//                                                   &#8377;{' '}
//                                                   {console.log(
//                                                     props.totalAmountAccessory
//                                                   )}
//                                                   {isNaN(
//                                                     parseInt(
//                                                       props.totalAmountAccessory,
//                                                       10
//                                                     )
//                                                   )
//                                                     ? '-'
//                                                     : props.totalAmountAccessory}
//                                                 </Typography>
//                                               </Grid> */}
//                                             </Grid>
//                                           </Grid>
//                                         </Grid>
//                                         {/* Divider Line */}
//                                         <Grid item xs={12}>
//                                           <Divider
//                                             className={classes.dividerStyle}
//                                           />
//                                         </Grid>
//                                         {/* Sims Row */}
//                                         <Grid item xs={12}>
//                                           <Grid
//                                             container
//                                             alignItems="baseline"
//                                             spacing={8}
//                                           >
//                                             <Grid item xs={12}>
//                                               <Typography variant="body1">
//                                                 SIM Cards
//                                               </Typography>
//                                             </Grid>
//                                             <Grid item xs={12} sm={3}>
//                                               <Select
//                                                 className={classes.selectSytle}
//                                                 options={simProviders}
//                                                 value={props.simModel}
//                                                 onChange={props.handleSelectChange(
//                                                   'simModel'
//                                                 )}
//                                                 placeholder="Select Provider"
//                                               />
//                                             </Grid>
//                                             <Grid item xs={12} sm={3}>
//                                               <TextField
//                                                 id="simQuantity"
//                                                 label="Quantity"
//                                                 value={props.simQuantity}
//                                                 onChange={props.handleChange(
//                                                   'simQuantity'
//                                                 )}
//                                                 type="number"
//                                                 inputProps={{ min: 0 }}
//                                                 margin="none"
//                                               />
//                                             </Grid>
//                                             <Grid item xs={12} sm={3}>
//                                               <TextField
//                                                 id="simCharges"
//                                                 type="number"
//                                                 label="Annual Sim Charges"
//                                                 value={props.simCharges}
//                                                 onChange={props.handleChange(
//                                                   'simCharges'
//                                                 )}
//                                                 inputProps={{ min: 0 }}
//                                                 margin="none"
//                                               />
//                                             </Grid>
//                                             <Grid item xs={12} sm={3}>
//                                               <Select
//                                                 className={classes.selectSytle}
//                                                 options={billingModes}
//                                                 value={props.billingMode}
//                                                 onChange={props.handleSelectChange(
//                                                   'billingMode'
//                                                 )}
//                                                 placeholder="Billing Mode *"
//                                               />
//                                             </Grid>
//                                             <Grid item xs={12} md={3}>
//                                               <Select
//                                                 className={classes.selectSytle}
//                                                 options={billingFrequencies}
//                                                 value={props.billingFrequency}
//                                                 onChange={props.handleSelectChange(
//                                                   'billingFrequency'
//                                                 )}
//                                                 placeholder="Billing Frequency *"
//                                               />
//                                             </Grid>
//                                             <Grid item xs={12} sm={3}>
//                                               <TextField
//                                                 id="warrantyPeriod"
//                                                 label="Warranty Period *"
//                                                 value={props.softwareQuantity}
//                                                 // onChange={props.handleChange(
//                                                 //   'softwareQuantity'
//                                                 // )}
//                                                 type="number"
//                                                 inputProps={{ min: 0 }}
//                                                 margin="none"
//                                               />
//                                             </Grid>
//                                             <Grid item xs={12} sm={3}>
//                                               <TextField
//                                                 id="creditPeriod"
//                                                 label="Credit Period *"
//                                                 value={props.softwareQuantity}
//                                                 // onChange={props.handleChange(
//                                                 //   'softwareQuantity'
//                                                 // )}
//                                                 type="number"
//                                                 inputProps={{ min: 0 }}
//                                                 margin="none"
//                                               />
//                                             </Grid>
//                                             <Grid item xs={12} sm={3}>
//                                               <TextField
//                                                 id="creditPeriod"
//                                                 label="Billed Upto *"
//                                                 value={props.softwareQuantity}
//                                                 // onChange={props.handleChange(
//                                                 //   'softwareQuantity'
//                                                 // )}
//                                                 type="text"
//                                                 // inputProps={{ min: 0 }}
//                                                 margin="none"
//                                               />
//                                             </Grid>
//                                             <Grid item xs={12} md={12}>
//                                               <label>
//                                                 <Checkbox
//                                                   name="perpetual"
//                                                   defaultChecked={true}
//                                                   value={props.perpetual}
//                                                   onClick={
//                                                     props.handlePerptualCheckbox
//                                                   }
//                                                 />
//                                                 <span
//                                                 // style={{
//                                                 //   fontSize: '20px'
//                                                 // }}
//                                                 >
//                                                   Perptual Billing
//                                                 </span>
//                                               </label>
//                                             </Grid>
//                                             {props.perpetual && (
//                                               <Grid item xs={12} sm={3}>
//                                                 <TextField
//                                                   // id="creditPeriod"
//                                                   label="Period *"
//                                                   value={props.softwareQuantity}
//                                                   // onChange={props.handleChange(
//                                                   //   'softwareQuantity'
//                                                   // )}
//                                                   type="number"
//                                                   // inputProps={{ min: 0 }}
//                                                   margin="none"
//                                                 />
//                                               </Grid>
//                                             )}
//                                             <Button
//                                               variant="contained"
//                                               color="secondary"
//                                               component="span"
//                                             >
//                                               Add +
//                                             </Button>
//                                             {/* <Grid item xs={12} sm={3}>
//                                               <Typography variant="body1">
//                                                 Total Amount per annum (excl
//                                                 GST): &nbsp;
//                                               </Typography>
//                                               <Typography variant="body2">
//                                                 &#8377;{' '}
//                                                 {console.log(
//                                                   props.totalAmountSim
//                                                 )}
//                                                 {isNaN(
//                                                   parseInt(
//                                                     props.totalAmountSim,
//                                                     10
//                                                   )
//                                                 )
//                                                   ? '-'
//                                                   : props.totalAmountSim}
//                                               </Typography>
//                                             </Grid> */}
//                                           </Grid>
//                                         </Grid>
//                                       </Grid>
//                                     </CardContent>
//                                     <CardActions>
//                                       <Button
//                                         color="secondary"
//                                         variant="raised"
//                                         onClick={props.handleSaveClick}
//                                         disabled={props.isSaveButtonDisabled}
//                                       >
//                                         Save
//                                       </Button>
//                                       <Button
//                                         color="secondary"
//                                         onClick={props.handleCancelClick}
//                                       >
//                                         Cancel
//                                       </Button>
//                                     </CardActions>
//                                   </Card>
//                                 )
//                               }}
//                             </Query>
//                           )
//                         }}
//                       </Query>
//                     )
//                   }}
//                 </Query>
//               )
//             }}
//           </Query>
//         )
//       }}
//     </Query>
//   )
// }
// SubscriptionDetails.propTypes = {
//   classes: PropTypes.object.isRequired
// }
// export default withStyles(style)(withApollo(SubscriptionDetails))
var GET_BILLING_MODE=Object(__WEBPACK_IMPORTED_MODULE_15_graphql_tag__["a" /* default */])(_templateObject);var GET_DEVICE_MODELS=Object(__WEBPACK_IMPORTED_MODULE_15_graphql_tag__["a" /* default */])(_templateObject2);var GET_ACCESSORY=Object(__WEBPACK_IMPORTED_MODULE_15_graphql_tag__["a" /* default */])(_templateObject3);var GET_SIM_PROVIDER=Object(__WEBPACK_IMPORTED_MODULE_15_graphql_tag__["a" /* default */])(_templateObject4);var GET_BILLING_FREQUENCY=Object(__WEBPACK_IMPORTED_MODULE_15_graphql_tag__["a" /* default */])(_templateObject5);var style=function style(theme){return{// textField: {
//   marginLeft: theme.spacing.unit * 2,
//   marginRight: theme.spacing.unit * 2,
//   width: '100%'
// }
// root: {
//   padding: theme.spacing.unit * 1,
//   flexGrow: 1
// },
// input: {
//   display: 'flex',
//   padding: 0
// }
card:{overflow:'visible'},italicizedText:{fontStyle:'italic'},fileDownloadIcon:{marginLeft:theme.spacing.unit,marginRight:-theme.spacing.unit},wrapFileName:{overflow:'hidden',whiteSpace:'nowrap',textOverflow:'ellipsis',maxWidth:'250px'},cardHeaderAction:{marginTop:'0px',marginRight:'-8px'},selectSytle:{width:'80%'},dividerStyle:{margin:'10px 0px 0 0'}};};function SubscriptionDetails(props){var classes=props.classes,clientDetails=props.clientDetails;var id=clientDetails.billingMode.id;console.log('client deatails from :',id,clientDetails);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_apollo__["Query"],{query:GET_BILLING_FREQUENCY,variables:{billingModeId:id}},function(_ref){var loading=_ref.loading,error=_ref.error,data=_ref.data;if(loading)return'Loading...';if(error)return'Error!: '+error;var billingFrequencies=data.getAllBillingFrequency.map(function(billFrq){return{value:billFrq.id,label:billFrq.frequency};});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_apollo__["Query"],{query:GET_DEVICE_MODELS},function(_ref2){var loading=_ref2.loading,error=_ref2.error,deviceModel=_ref2.data.deviceModel;if(loading)return'Loading...';if(error)return'Error!: '+error;var deviceModels=deviceModel.map(function(deviceModel){return{value:deviceModel.id,label:deviceModel.model_name};});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_apollo__["Query"],{query:GET_ACCESSORY},function(_ref3){var loading=_ref3.loading,error=_ref3.error,accessoryDetails=_ref3.data.accessoryDetails;if(loading)return'Loading...';if(error)return'Error!: '+error;var accessoryModels=accessoryDetails.map(function(accessoryDetails){return{value:accessoryDetails.id,label:accessoryDetails.accessoryName};});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_apollo__["Query"],{query:GET_SIM_PROVIDER},function(_ref4){var loading=_ref4.loading,error=_ref4.error,simDetails=_ref4.data.simDetails;if(loading)return'Loading...';if(error)return'Error!: '+error;var simProviders=simDetails.map(function(simDetails){return{value:simDetails.id,label:simDetails.name};});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Card___default.a,{className:classes.card},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_CardHeader___default.a,{title:'Subscription Details',subheader:'All fields marked with (*) are mandatory',subheaderTypographyProps:{className:classes.italicizedText},classes:{action:classes.cardHeaderAction},action:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{accept:'.pdf',id:'contained-button-pi-upload',type:'file',style:{display:'none'},onChange:props.handlePIUpload}))}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true,alignItems:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */],{className:classes.selectSytle,options:billingFrequencies,value:props.billingFrequency,onChange:props.handleSelectChange('billingFrequency'),placeholder:'Billing Frequency *'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField___default.a,{required:true,id:'salesRemarks',label:'Sales Remarks',value:props.salesRemarks,onChange:props.handleSalesRemarksChange,margin:'none'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */],{className:classes.selectSytle,options:props.gstRates,value:props.gstRate,onChange:props.handleSelectChange('gstRate'),placeholder:'Select GST Rate *'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Divider___default.a,{className:classes.dividerStyle})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true,alignItems:'baseline',spacing:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body1'},'Software')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true,justify:'flex-start',alignItems:'flex-end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField___default.a,{disabled:true,label:'AquilaTrack Software'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField___default.a,{id:'softwareQuantity',label:'Software Quantity *',value:props.softwareQuantity,onChange:props.handleChange('softwareQuantity'),type:'number',inputProps:{min:0},margin:'none'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField___default.a,{id:'amount',type:'number',label:'Software charges*',value:props.deviceTrackingCharges,onChange:props.handleChange('deviceTrackingCharges'),inputProps:{min:0},margin:'none'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body1'},'Total Amount per month (excl GST): \xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body2'},'\u20B9',' ',console.log(props.totalAmountSoftware),isNaN(parseInt(props.totalAmountSoftware,10))?'-':props.totalAmountSoftware))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Divider___default.a,{className:classes.dividerStyle})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true,alignItems:'baseline',spacing:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body1'},'Devices')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true,justify:'flex-start',alignItems:'flex-end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */],{className:classes.selectSytle,options:deviceModels,value:props.deviceModel,onChange:props.handleSelectChange('deviceModel'),placeholder:'Select Model *'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField___default.a,{id:'quantity',label:'Device Quantity *',value:props.totalQuantity,onChange:props.handleChange('deviceQuantity'),type:'number',inputProps:{min:0},margin:'none'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField___default.a,{id:'hardwareCharges',type:'number',label:'Hardware Charges *',value:props.hardwareCharges,onChange:props.handleChange('hardwareCharges'),inputProps:{min:0},margin:'none'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body1'},'Total Amount (excl GST): \xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body2'},'\u20B9',' ',console.log(props.totalAmountHardware),isNaN(parseInt(props.totalAmountHardware,10))?'-':props.totalAmountHardware))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Divider___default.a,{className:classes.dividerStyle})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true,alignItems:'baseline',spacing:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body1'},'Accessories')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true,justify:'flex-start',alignItems:'flex-end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */],{className:classes.selectSytle,options:accessoryModels,value:props.accessoryModel,onChange:props.handleSelectChange('accessoryModel'),placeholder:'Select Type'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField___default.a,{id:'accessoryQuantity',label:'Quantity',value:props.accessoryQuantity,onChange:props.handleChange('accessoryQuantity'),type:'number',inputProps:{min:0},margin:'none'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField___default.a,{id:'accessoryCharges',label:'Accessory Charges',type:'number',value:props.accessoryCharges,onChange:props.handleChange('accessoryCharges'),inputProps:{min:0},margin:'none'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body1'},'Total Amount (excl GST): \xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body2'},'\u20B9',' ',console.log(props.totalAmountAccessory),isNaN(parseInt(props.totalAmountAccessory,10))?'-':props.totalAmountAccessory))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Divider___default.a,{className:classes.dividerStyle})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true,alignItems:'baseline',spacing:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body1'},'SIM Cards')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */],{className:classes.selectSytle,options:simProviders,value:props.simModel,onChange:props.handleSelectChange('simModel'),placeholder:'Select Provider'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField___default.a,{id:'simQuantity',label:'Quantity',value:props.simQuantity,onChange:props.handleChange('simQuantity'),type:'number',inputProps:{min:0},margin:'none'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField___default.a,{id:'simCharges',type:'number',label:'Annual Sim Charges',value:props.simCharges,onChange:props.handleChange('simCharges'),inputProps:{min:0},margin:'none'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body1'},'Total Amount per annum (excl GST): \xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body2'},'\u20B9',' ',console.log(props.totalAmountSim),isNaN(parseInt(props.totalAmountSim,10))?'-':props.totalAmountSim)))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_CardActions___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{color:'secondary',variant:'raised',onClick:props.handleSaveClick,disabled:props.isSaveButtonDisabled||props.gstRate===0||props.gstRate===null||!props.salesRemarks},'Save'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{color:'secondary',onClick:props.handleCancelClick},'Cancel')));});});});});}SubscriptionDetails.propTypes={classes:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_16_react_apollo__["withApollo"])(SubscriptionDetails)));

/***/ }),
/* 2062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Card__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_CardContent__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_CardContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_CardContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_ArrowBack__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_ArrowBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_ArrowBack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_icons_CloudUpload__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_icons_CloudUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_icons_CloudUpload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_colors__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_colors__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query clientDetail($loginId: Int) {\n    clientDetail(loginId: $loginId) {\n      id\n      clientName\n      contactPerson\n      address\n      city\n      state {\n        zone_id\n      }\n      country {\n        country_id\n      }\n      email\n      contactNumber\n      login {\n        username\n      }\n      pincode\n      panNumber\n      type\n    }\n  }\n'],['\n  query clientDetail($loginId: Int) {\n    clientDetail(loginId: $loginId) {\n      id\n      clientName\n      contactPerson\n      address\n      city\n      state {\n        zone_id\n      }\n      country {\n        country_id\n      }\n      email\n      contactNumber\n      login {\n        username\n      }\n      pincode\n      panNumber\n      type\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query checkDeviceAvailableForSubscription(\n    $partnerLoginId: Int!\n    $serial_num: [DeviceListInput!]!\n    $deviceModelId: Int!\n  ) {\n    validation: checkDeviceAvailableForSubscription(\n      partnerLoginId: $partnerLoginId\n      deviceList: $serial_num\n      deviceModelId: $deviceModelId\n    ) {\n      serial_num\n      uniqueDeviceId\n    }\n  }\n'],['\n  query checkDeviceAvailableForSubscription(\n    $partnerLoginId: Int!\n    $serial_num: [DeviceListInput!]!\n    $deviceModelId: Int!\n  ) {\n    validation: checkDeviceAvailableForSubscription(\n      partnerLoginId: $partnerLoginId\n      deviceList: $serial_num\n      deviceModelId: $deviceModelId\n    ) {\n      serial_num\n      uniqueDeviceId\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query checkSimAvailableForSubscription(\n    $partnerLoginId: Int!\n    $simNumber: [SimListInput!]!\n    $serviceProviderId: Int!\n  ) {\n    validation: checkSimAvailableForSubscription(\n      partnerLoginId: $partnerLoginId\n      simList: $simNumber\n      serviceProviderId: $serviceProviderId\n    ) {\n      simNumber\n    }\n  }\n'],['\n  query checkSimAvailableForSubscription(\n    $partnerLoginId: Int!\n    $simNumber: [SimListInput!]!\n    $serviceProviderId: Int!\n  ) {\n    validation: checkSimAvailableForSubscription(\n      partnerLoginId: $partnerLoginId\n      simList: $simNumber\n      serviceProviderId: $serviceProviderId\n    ) {\n      simNumber\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query getSubscriptions(\n    $subscriptionId: Int\n    $clientLoginId: Int\n    $partnerLoginId: Int\n  ) {\n    getSubscriptions(\n      id: $subscriptionId\n      clientLoginId: $clientLoginId\n      partnerLoginId: $partnerLoginId\n    ) {\n      deviceModel {\n        model_name\n        manufacturer {\n          manufacturerCode\n        }\n      }\n      accessoryType {\n        accessoryName\n        manufacturer {\n          manufacturerCode\n        }\n      }\n      serviceProvider {\n        name\n      }\n      deviceModelId\n      accessoryTypeId\n      serviceProviderId\n      unAssignedDeviceQuantity\n      unAssignedSimQuantity\n      unAssignedAccessoryQuantity\n    }\n  }\n'],['\n  query getSubscriptions(\n    $subscriptionId: Int\n    $clientLoginId: Int\n    $partnerLoginId: Int\n  ) {\n    getSubscriptions(\n      id: $subscriptionId\n      clientLoginId: $clientLoginId\n      partnerLoginId: $partnerLoginId\n    ) {\n      deviceModel {\n        model_name\n        manufacturer {\n          manufacturerCode\n        }\n      }\n      accessoryType {\n        accessoryName\n        manufacturer {\n          manufacturerCode\n        }\n      }\n      serviceProvider {\n        name\n      }\n      deviceModelId\n      accessoryTypeId\n      serviceProviderId\n      unAssignedDeviceQuantity\n      unAssignedSimQuantity\n      unAssignedAccessoryQuantity\n    }\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  query checkAccessoryAvailableForSubscription(\n    $partnerLoginId: Int!\n    $serialNumber: [AccessoryListInput!]!\n    $accessoryTypeId: Int!\n  ) {\n    validation: checkAccessoryAvailableForSubscription(\n      partnerLoginId: $partnerLoginId\n      serialNumberList: $serialNumber\n      accessoryTypeId: $accessoryTypeId\n    ) {\n      serialNumber\n      uniqueAccessoryId\n    }\n  }\n'],['\n  query checkAccessoryAvailableForSubscription(\n    $partnerLoginId: Int!\n    $serialNumber: [AccessoryListInput!]!\n    $accessoryTypeId: Int!\n  ) {\n    validation: checkAccessoryAvailableForSubscription(\n      partnerLoginId: $partnerLoginId\n      serialNumberList: $serialNumber\n      accessoryTypeId: $accessoryTypeId\n    ) {\n      serialNumber\n      uniqueAccessoryId\n    }\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  mutation setSubscriptionInventoryAssignment(\n    $uniqueDeviceIdList: [uniqueDeviceIdListInput!]\n    $uniqueAccessoryIdList: [uniqueAccessoryIdListInput!]\n    $simIdList: [simListInput!]\n    $deviceModelId: Int!\n    $accessoryTypeId: Int\n    $serviceProviderId: Int\n    $unAssignedDeviceQuantity: Int!\n    $unAssignedAccessoryQuantity: Int!\n    $unAssignedSimQuantity: Int!\n    $partnerLoginId: Int!\n    $clientLoginId: Int!\n    $subscriptionId: Int!\n  ) {\n    setSubscriptionInventoryAssignment(\n      uniqueDeviceIdList: $uniqueDeviceIdList\n      uniqueAccessoryIdList: $uniqueAccessoryIdList\n      simList: $simIdList\n      deviceModelId: $deviceModelId\n      accessoryTypeId: $accessoryTypeId\n      serviceProviderId: $serviceProviderId\n      unAssignedDeviceQuantity: $unAssignedDeviceQuantity\n      unAssignedAccessoryQuantity: $unAssignedAccessoryQuantity\n      unAssignedSimQuantity: $unAssignedSimQuantity\n      partnerLoginId: $partnerLoginId\n      clientLoginId: $clientLoginId\n      subscriptionId: $subscriptionId\n    )\n  }\n'],['\n  mutation setSubscriptionInventoryAssignment(\n    $uniqueDeviceIdList: [uniqueDeviceIdListInput!]\n    $uniqueAccessoryIdList: [uniqueAccessoryIdListInput!]\n    $simIdList: [simListInput!]\n    $deviceModelId: Int!\n    $accessoryTypeId: Int\n    $serviceProviderId: Int\n    $unAssignedDeviceQuantity: Int!\n    $unAssignedAccessoryQuantity: Int!\n    $unAssignedSimQuantity: Int!\n    $partnerLoginId: Int!\n    $clientLoginId: Int!\n    $subscriptionId: Int!\n  ) {\n    setSubscriptionInventoryAssignment(\n      uniqueDeviceIdList: $uniqueDeviceIdList\n      uniqueAccessoryIdList: $uniqueAccessoryIdList\n      simList: $simIdList\n      deviceModelId: $deviceModelId\n      accessoryTypeId: $accessoryTypeId\n      serviceProviderId: $serviceProviderId\n      unAssignedDeviceQuantity: $unAssignedDeviceQuantity\n      unAssignedAccessoryQuantity: $unAssignedAccessoryQuantity\n      unAssignedSimQuantity: $unAssignedSimQuantity\n      partnerLoginId: $partnerLoginId\n      clientLoginId: $clientLoginId\n      subscriptionId: $subscriptionId\n    )\n  }\n']);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable */var GET_CLIENT=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject);var VERIFY_DEVICE=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject2);var VERIFY_SIM=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject3);var GET_SUBSCRIPTION=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject4);var VERIFY_ACCESSORY=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject5);var SAVE_SUBSCRIPTION=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject6);var styles=function styles(theme){return{root:{padding:theme.spacing.unit*2,flexGrow:1},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},input:{display:'none'}};};var AssignDevices=function(_Component){_inherits(AssignDevices,_Component);function AssignDevices(props){var _this2=this;_classCallCheck(this,AssignDevices);var _this=_possibleConstructorReturn(this,(AssignDevices.__proto__||Object.getPrototypeOf(AssignDevices)).call(this,props));_this.getSubscriptions=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _ref2,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.client.query({query:GET_SUBSCRIPTION,variables:{subscriptionId:parseInt(_this.subscriptionId,10),clientLoginId:parseInt(_this.loginId,10),partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__["a" /* default */])()},fetchPolicy:'network-only'});case 2:_ref2=_context.sent;data=_ref2.data;// console.log('sub call')
if(data.getSubscriptions.unAssignedDeviceQuantity>0){_this.setState({deviceStatus:false});}else{_this.setState({simStatus:false,accssoryStatus:false});}_this.setState({deviceModelName:data.getSubscriptions.deviceModel.model_name,deviceQuantity:data.getSubscriptions.unAssignedDeviceQuantity,deviceModelId:data.getSubscriptions.deviceModelId,manufacturerCode:data.getSubscriptions.deviceModel.manufacturer.manufacturerCode});if(data.getSubscriptions.accessoryType!==null){_this.setState({accessoryType:data.getSubscriptions.accessoryType.accessoryName,accessoryTypeId:data.getSubscriptions.accessoryTypeId,accessoryQuantity:data.getSubscriptions.unAssignedAccessoryQuantity,accManufacturerCode:data.getSubscriptions.accessoryType.manufacturer.manufacturerCode});}if(data.getSubscriptions.serviceProvider!==null){_this.setState({simProviderName:data.getSubscriptions.serviceProvider.name,simProviderId:data.getSubscriptions.serviceProviderId,simQuantity:data.getSubscriptions.unAssignedSimQuantity});}case 8:case'end':return _context.stop();}}},_callee,_this2);}));_this.addBulkUploadDevices=function(e){console.log('bulk');_this.props.history.push({pathname:'/home/subscriptions/assign/'+_this.props.match.params.loginId+'/'+_this.props.match.params.subscriptionId+'/BulkAssignDevice'});};_this.addBulkUploadSim=function(e){_this.props.history.push({pathname:'/home/subscriptions/assign/'+_this.props.match.params.loginId+'/'+_this.props.match.params.subscriptionId+'/BulkAssignSim'});};_this.handleDeviceDuplicate=function(type){return _asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var deviceArr,duplicateDeviceList,deviceArrl;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:deviceArr=_this.state.deviceSerialNo;console.log('1st',deviceArr);deviceArr=deviceArr.split(',').map(Number);console.log('2nd',deviceArr);duplicateDeviceList=_this.state.duplicateDeviceList;// console.log('3rd', this.state.duplicateDeviceList)
duplicateDeviceList=duplicateDeviceList.split(' ').map(Number);deviceArrl=deviceArr.filter(function(el){return!duplicateDeviceList.includes(el);});console.log('4deviceArr',deviceArrl.toString());_this.setState({duplicateDeviceList:'',deviceSerialNo:deviceArrl.toString(),duplicateDeviceError:''});case 9:case'end':return _context2.stop();}}},_callee2,_this2);}));};_this.handleSimDuplicate=function(type){return _asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var simArr,duplicateSimList,simArrl;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:simArr=_this.state.simSerialNo;// console.log('1st', simArr)
simArr=simArr.split(',').map(function(e){return e.trim();});// console.log('2nd', simArr)
duplicateSimList=_this.state.duplicateSimList;duplicateSimList=duplicateSimList.split(' ').map(function(e){return e.trim();});// console.log('3rd', duplicateSimList)
simArrl=simArr.filter(function(el){// console.log(el, duplicateSimList)
return!duplicateSimList.includes(el);});// console.log('4deviceArr', simArrl)
_this.setState({duplicateSimList:'',duplicateSimError:'',simSerialNo:simArrl.toString()});case 6:case'end':return _context3.stop();}}},_callee3,_this2);}));};_this.handleDeviceValidate=function(type){return _asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){var deviceArr,tempArr,verifiedSerialNumbers,_ref6,data,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:console.log('function is calling');_this.setState({duplicateDeviceError:''});deviceArr=_this.state.deviceSerialNo.trim().replace(/[^A-Za-z0-9,]/g,'').replace(/\s/g,'').replace(/,{1,}$/,'').replace(/^,{1,}/,'').replace(/,+/g,',').split(',');// Remove Duplicates
deviceArr=[].concat(_toConsumableArray(new Set(deviceArr)));tempArr=[];verifiedSerialNumbers='';deviceArr.forEach(function(serialno){verifiedSerialNumbers=verifiedSerialNumbers+serialno+', ';var temp={};temp.serial_num=serialno;temp.uniqueDeviceId=_this.state.manufacturerCode+'_'+serialno;tempArr.push(temp);});verifiedSerialNumbers=verifiedSerialNumbers.slice(0,verifiedSerialNumbers.length-2);_this.setState({deviceSerialNo:verifiedSerialNumbers},function(){console.log('deviceSerialNo',_this.state.deviceSerialNo);});_context4.next=11;return _this.props.client.query({query:VERIFY_DEVICE,variables:{serial_num:tempArr,deviceModelId:parseInt(_this.state.deviceModelId,10),partnerLoginId:parseInt(localStorage.getItem('Login_id'),10)},fetchPolicy:'network-only'});case 11:_ref6=_context4.sent;data=_ref6.data;console.log(data,'query called');response='';Object.values(data.validation).map(function(res){return response=response+res['serial_num']+' ';});if(deviceArr.length>_this.state.deviceQuantity){_this.setState({duplicateDeviceList:'You cannot assign devices more than requested quantity'});}else{_this.setState({duplicateDeviceList:response});if(response!==''){_this.setState({duplicateDeviceError:'Remove Invalid Serial nos:'});}}if(data.validation.length===0&&deviceArr.length!==0&&deviceArr.length<=_this.state.deviceQuantity){_this.setState({deviceStatus:true});}case 18:case'end':return _context4.stop();}}},_callee4,_this2);}));};_this.handleSimValidate=function(type){return _asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(){var simArr,tempArr,verifiedSerialNumbers,_ref8,data,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_this.setState({duplicateSimError:''});simArr=_this.state.simSerialNo.trim().replace(/[^A-Za-z0-9,]/g,'').replace(/\s/g,'').replace(/,{1,}$/,'').replace(/^,{1,}/,'').replace(/,+/g,',').split(',');// Remove Duplicates
simArr=[].concat(_toConsumableArray(new Set(simArr)));tempArr=[];verifiedSerialNumbers='';if(!(simArr.length>0)){_context5.next=17;break;}simArr.forEach(function(serialno){verifiedSerialNumbers=verifiedSerialNumbers+serialno+', ';var temp={};temp.simNumber=serialno;tempArr.push(temp);});verifiedSerialNumbers=verifiedSerialNumbers.slice(0,verifiedSerialNumbers.length-2);_this.setState({simSerialNo:verifiedSerialNumbers});_context5.next=11;return _this.props.client.query({query:VERIFY_SIM,variables:{simNumber:tempArr,serviceProviderId:parseInt(_this.state.simProviderId,10),partnerLoginId:parseInt(localStorage.getItem('Login_id'),10)},fetchPolicy:'network-only'});case 11:_ref8=_context5.sent;data=_ref8.data;response='';Object.values(data.validation).map(function(res){return response=response+res['simNumber']+' ';});if(simArr.length>_this.state.simQuantity){_this.setState({duplicateSimList:'You cannot assign sim more than requested quantity'});}else{_this.setState({duplicateSimList:response});if(response!==''){_this.setState({duplicateSimError:'Remove Invalid Sim nos:'});}}if(data.validation.length===0&&simArr.length!==0&&simArr.length<=_this.state.simQuantity){_this.setState({simStatus:true});}case 17:case'end':return _context5.stop();}}},_callee5,_this2);}));};_this.handleAccessoryValidate=function(type){return _asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(){var accArr,tempArr,verifiedSerialNumbers,_ref10,data,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:accArr=_this.state.accessorySerialNo.trim().replace(/[^A-Za-z0-9,]/g,'').replace(/\s/g,'').replace(/,{1,}$/,'').replace(/^,{1,}/,'').replace(/,+/g,',').split(',');// Remove Duplicates
accArr=[].concat(_toConsumableArray(new Set(accArr)));tempArr=[];verifiedSerialNumbers='';if(!(accArr.length>0)){_context6.next=16;break;}accArr.forEach(function(serialno){verifiedSerialNumbers=verifiedSerialNumbers+serialno+', ';var temp={};temp.serialNumber=parseInt(serialno,10);temp.uniqueAccessoryId=_this.state.accManufacturerCode+'_'+serialno;tempArr.push(temp);});verifiedSerialNumbers=verifiedSerialNumbers.slice(0,verifiedSerialNumbers.length-2);_this.setState({accessorySerialNo:verifiedSerialNumbers});_context6.next=10;return _this.props.client.query({query:VERIFY_ACCESSORY,variables:{serialNumber:tempArr,accessoryTypeId:parseInt(_this.state.accessoryTypeId,10),partnerLoginId:parseInt(localStorage.getItem('Login_id'),10)}});case 10:_ref10=_context6.sent;data=_ref10.data;response='';Object.values(data.validation).map(function(res){return response=response+res['serialNumber']+' ';});if(accArr.length>_this.state.accessoryQuantity){_this.setState({duplicateAccessoryList:'You cannot assign Accessory more than requested quantity'});}else{_this.setState({duplicateAccessoryList:response});}if(data.validation.length===0&&accArr.length!==0&&accArr.length<=_this.state.accessoryQuantity){_this.setState({accessoryStatus:true});}case 16:case'end':return _context6.stop();}}},_callee6,_this2);}));};_this.handleChange=function(name){return function(event){_this.setState(_defineProperty({},name,event.target.value));};};_this.handleReset=function(type){return function(event){if(type==='device'){_this.setState({deviceSerialNo:'',deviceUniqueNo:'',deviceStatus:false,duplicateDeviceList:''});}if(type==='sim'){_this.setState({simSerialNo:'',simStatus:false,duplicateSimList:''});}if(type==='accessory'){_this.setState({accessorySerialNo:'',accessoryUniqueNo:'',accessoryStatus:false,duplicateAccessoryList:''});}};};_this.handleSaveAssignment=function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(e){var devices,accessories,sims,deviceArr,simArr,accArr,_ref12,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:devices=[];accessories=[];sims=[];deviceArr=[];simArr=[];accArr=[];if(_this.state.deviceSerialNo!==''){deviceArr=_this.state.deviceSerialNo.replace(/\s/g,'').split(',');deviceArr.forEach(function(serialno){var temp={};temp.uniqueDeviceId=_this.state.manufacturerCode+'_'+serialno;devices.push(temp);});}if(_this.state.simSerialNo!==''){simArr=_this.state.simSerialNo.replace(/\s/g,'').split(',');simArr.forEach(function(serialno){var temp={};temp.simNumber=serialno;sims.push(temp);});}if(_this.state.accessorySerialNo!==''){accArr=_this.state.accessorySerialNo.replace(/\s/g,'').split(',');accArr.forEach(function(serialno){var temp={};temp.uniqueAccessoryId=_this.state.accManufacturerCode+'_'+serialno;accessories.push(temp);});}if(!(deviceArr.length>_this.state.deviceQuantity)){_context7.next=13;break;}_this.props.openSnackbar('Device list exceeds Device Quantity');_context7.next=45;break;case 13:if(!(simArr.length>_this.state.simQuantity)){_context7.next=17;break;}_this.props.openSnackbar('Sim list exceeds Sim Quantity');_context7.next=45;break;case 17:if(!(accArr.length>_this.state.accessoryQuantity)){_context7.next=21;break;}_this.props.openSnackbar('Accessory list exceeds Accessory Quantity');_context7.next=45;break;case 21:if(!(_this.state.duplicateDeviceError!=='')){_context7.next=25;break;}_this.props.openSnackbar('Invalid Device list');_context7.next=45;break;case 25:if(!(_this.state.duplicateSimError!=='')){_context7.next=29;break;}_this.props.openSnackbar('Invalid Sim list');_context7.next=45;break;case 29:_this.setState({loadingSave:true});_context7.next=32;return _this.props.client.mutate({mutation:SAVE_SUBSCRIPTION,variables:{uniqueDeviceIdList:devices,uniqueAccessoryIdList:accessories,simIdList:sims,deviceModelId:_this.state.deviceModelId,accessoryTypeId:_this.state.accessoryTypeId,serviceProviderId:_this.state.simProviderId,unAssignedDeviceQuantity:_this.state.deviceQuantity-deviceArr.length,unAssignedAccessoryQuantity:_this.state.accessoryQuantity-accArr.length,unAssignedSimQuantity:_this.state.simQuantity-simArr.length,partnerLoginId:parseInt(localStorage.getItem('Login_id'),10),clientLoginId:parseInt(_this.loginId,10),subscriptionId:parseInt(_this.subscriptionId,10)},refetchQueries:[{query:GET_SUBSCRIPTION,variables:{subscriptionId:parseInt(_this.subscriptionId,10),loginId:parseInt(_this.loginId,10),partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__["a" /* default */])()}}]});case 32:_ref12=_context7.sent;data=_ref12.data;if(!(data.setSubscriptionInventoryAssignment===true)){_context7.next=43;break;}_context7.next=37;return _this.props.client.clearStore();case 37:_this.setState({loadingSave:false});_this.props.openSnackbar('Inventory Assignment Successful');_this.setState({deviceSerialNo:'',deviceUniqueNo:'',deviceStatus:false,duplicateDeviceList:'',simSerialNo:'',simStatus:false,duplicateSimList:'',accessorySerialNo:'',accessoryUniqueNo:'',accessoryStatus:false,duplicateAccessoryList:''},function(){_this.getSubscriptions();});_this.props.history.goBack();_context7.next=45;break;case 43:_this.setState({loadingSave:false});_this.props.openSnackbar('Inventory Assignment Failed');case 45:case'end':return _context7.stop();}}},_callee7,_this2);}));return function(_x){return _ref11.apply(this,arguments);};}();_this.loginId=_this.props.match.params.loginId;_this.subscriptionId=_this.props.match.params.subscriptionId;_this.state={deviceSerialNo:'',deviceUniqueNo:'',deviceModelId:null,deviceModelName:'',deviceQuantity:'',manufacturerCode:'',duplicateDeviceList:'',simSerialNo:'',simProviderName:'',simProviderId:null,simQuantity:'',duplicateSimList:'',accessorySerialNo:'',accessoryType:'',accessoryTypeId:null,accessoryQuantity:'',accManufacturerCode:'',deviceStatus:true,simStatus:true,accessoryStatus:true,duplicateDeviceError:'',duplicateSimError:'',loadingSave:false};return _this;}_createClass(AssignDevices,[{key:'componentDidMount',value:function componentDidMount(){this.getSubscriptions();}},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_apollo__["Query"],{query:GET_CLIENT,variables:{loginId:parseInt(this.loginId,10)},fetchPolicy:'network-only'},function(_ref13){var loading=_ref13.loading,error=_ref13.error,clientDetail=_ref13.data.clientDetail;if(loading)return'Loading...';if(error)return'Error!: '+error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Button"],{variant:'outlined',color:'secondary',className:classes.button,onClick:function onClick(){return _this3.props.history.goBack();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_ArrowBack___default.a,{className:classes.iconSmall})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'display3'},clientDetail.clientName.charAt(0).toUpperCase()+clientDetail.clientName.slice(1)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],null,'Subscription Id: ',_this3.subscriptionId)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'subheading'},'Assign Inventory',' ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Card___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_CardContent___default.a,null,_this3.state.deviceModelId?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row',alignItems:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'title'},'Device(s)')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'body1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',null,'Model:'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'body2'},_this3.state.deviceModelName)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'body1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',null,'Quantity:'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'body2'},_this3.state.deviceQuantity)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_TextField___default.a,{fullWidth:true,id:'outlined-multiline-flexible',label:'Enter Comma Separated Serial Numbers',rowsMax:'4',multiline:true,value:/* eslint-disable */_this3.state.deviceSerialNo/* eslint-enable */,onChange:_this3.handleChange('deviceSerialNo'),onBlur:_this3.handleDeviceValidate('device'),className:classes.textField,margin:'normal',helperText:_this3.state.duplicateDeviceError+_this3.state.duplicateDeviceList,error:_this3.state.duplicateDeviceList,variant:'outlined'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Button"],{variant:'raised',color:'secondary',className:classes.button,onClick:_this3.handleDeviceValidate('device')},'Validate')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Button"],{variant:'raised',color:'secondary',className:classes.button,onClick:_this3.handleDeviceDuplicate('device')},'Remove')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Button"],{variant:'raised',color:'primary',className:classes.button,onClick:_this3.handleReset('device')},'Reset')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Tooltip"],{title:'Bulk Upload Device'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Button"],{'aria-label':'Upload',onClick:_this3.addBulkUploadDevices},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_icons_CloudUpload___default.a,{style:{color:'green'}}))))):null,_this3.state.simProviderId?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row',alignItems:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'title'},'SIM(s)')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'body1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',null,'SIM Provider:'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'body2'},_this3.state.simProviderName)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'body1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',null,'Quantity:'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'body2'},_this3.state.simQuantity)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_TextField___default.a,{fullWidth:true,id:'outlined-multiline-flexible',label:'Enter Comma Separated SIM Numbers',multiline:true,rowsMax:'4',value:/* eslint-disable */_this3.state.simSerialNo/* eslint-enable */,onChange:_this3.handleChange('simSerialNo'),onBlur:_this3.handleSimValidate('sim'),className:classes.textField,margin:'normal',helperText:_this3.state.duplicateSimError+_this3.state.duplicateSimList,error:_this3.state.duplicateSimList,variant:'outlined'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Button"],{variant:'raised',color:'secondary',className:classes.button,onClick:_this3.handleSimValidate('sim')},'Validate')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Button"],{variant:'raised',color:'secondary',className:classes.button,onClick:_this3.handleSimDuplicate('sim')},'Remove')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Button"],{variant:'raised',color:'primary',className:classes.button,onClick:_this3.handleReset('sim')},'Reset')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Tooltip"],{title:'Bulk Upload SIM'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Button"],{'aria-label':'Upload',onClick:_this3.addBulkUploadSim},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_icons_CloudUpload___default.a,{style:{color:'green'}}))))):null,_this3.state.accessoryTypeId?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row',alignItems:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'title'},'Accessory')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'body1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',null,'Accessory Type:'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'body2'},_this3.state.accessoryType)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'body1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',null,'Quantity:'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'body2'},_this3.state.accessoryQuantity)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_TextField___default.a,{fullWidth:true,id:'outlined-multiline-flexible',label:'Enter Comma Separated Serial Numbers',multiline:true,rowsMax:'4',value:/* eslint-disable */_this3.state.accessorySerialNo/* eslint-enable */,onChange:_this3.handleChange('accessorySerialNo'),onBlur:_this3.handleAccessoryValidate('accessory'),className:classes.textField,margin:'normal',helperText:_this3.state.duplicateAccessoryList,error:_this3.state.duplicateAccessoryList,variant:'outlined'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Button"],{variant:'raised',color:'secondary',className:classes.button,onClick:_this3.handleAccessoryValidate('accessory')},'Validate')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Button"],{variant:'raised',color:'primary',className:classes.button,onClick:_this3.handleReset('accessory')},'Reset'))):null))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,justify:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Button"],{color:'secondary',variant:'raised',onClick:_this3.handleSaveAssignment,disabled:(_this3.state.deviceSerialNo===''||_this3.state.duplicateDeviceError!=='')&&(_this3.state.simSerialNo===''||_this3.state.duplicateSimError!=='')&&_this3.state.accessorySerialNo===''||_this3.state.loadingSave},'Save')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Button"],{color:'primary',variant:'raised',href:'../../'},'Cancel')))));});}}]);return AssignDevices;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);AssignDevices.propTypes={classes:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired};var withApolloClient=function withApolloClient(Component){return function(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_apollo__["ApolloConsumer"],null,function(client){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component,Object.assign({client:client},props));});};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__["withStyles"])(styles)(withApolloClient(Object(__WEBPACK_IMPORTED_MODULE_12__HOCs_withSharedSnackbar__["a" /* default */])(AssignDevices))));

/***/ }),
/* 2063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_file_saver__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_file_saver__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query {\n    models: allDeviceModels(status: 1) {\n      id\n      model_name\n    }\n  }\n'],['\n  query {\n    models: allDeviceModels(status: 1) {\n      id\n      model_name\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n'],['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query {\n    manufacturers: getAllManufacturer(status: 1) {\n      id\n      manufacturerName\n      manufacturerCode\n    }\n  }\n'],['\n  query {\n    manufacturers: getAllManufacturer(status: 1) {\n      id\n      manufacturerName\n      manufacturerCode\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  mutation excelFileUpload(\n    $fileInfo: FileUploadInput!\n    $commonInput: CommonInput!\n  ) {\n    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {\n      failedToUpload\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedUploadList\n    }\n  }\n'],['\n  mutation excelFileUpload(\n    $fileInfo: FileUploadInput!\n    $commonInput: CommonInput!\n  ) {\n    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {\n      failedToUpload\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedUploadList\n    }\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n'],['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable */var GET_MODELS=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject);var GET_FILE_FORMAT=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject2);var GET_MANUFACTURER=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject3);var DEASSIGN_DEVICE=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject4);var GET_UPLOAD_URL=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject5);var styles=function styles(theme){return{button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{margin:theme.spacing.unit,minWidth:120},root:{flexGrow:1,padding:theme.spacing.unit*2}};};var DeassignDevices=function(_Component){_inherits(DeassignDevices,_Component);function DeassignDevices(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,DeassignDevices);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DeassignDevices.__proto__||Object.getPrototypeOf(DeassignDevices)).call.apply(_ref,[this].concat(args))),_this),_this.state={open:false,open1:false,modelname:'',isModelNameValid:false,isManufacturerNameValid:false,manufacturerName:'',open_man:false,manufacturerCode:'',manufacturerId:'',publicUploadURL:'',fileName:'',bucketName:'',isUploading:false,uploadSucess:true,response:'',failList:'',result:false,isLoading:false,disable:false},_this.columns=['Serial Number','IMEI Number','Reason'],_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15// sort: false,
// filter: false,
//  search: false,
// print: false,
// download: false
// viewColumns: false,
// pagination: false
},_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));};},_this.setToDefaults=function(){_this.setState({response:'',failList:'',result:false,isLoading:false,publicUploadURL:'',fileName:'',bucketName:'',disable:false});},_this.handleChange=function(event){_this.setState(_defineProperty({},event.target.name,event.target.value));},_this.handleOpen=function(){_this.setState({open:true});},_this.handleOpenSelect=function(){_this.setState({open1:true});},_this.handleCloseSelect=function(){_this.setState({open1:false});},_this.handleOpenSelectMan=function(){_this.setState({open_man:true});},_this.handleCloseSelectMan=function(){_this.setState({open_man:false});},_this.checkModelNameValidity=function(){_this.setState({isModelNameValid:_this.state.modelname!==''});},_this.downloadBulkDeassign=function(client){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _ref3,data,res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:console.log('click fun');_context.next=3;return _this.props.client.query({query:GET_FILE_FORMAT,variables:{bucketname:'excel-templates',filename:'deAssignDeviceTemplate.xlsx'},errorPolicy:'all'});case 3:_ref3=_context.sent;data=_ref3.data;console.log('file',data.getPublicDownloadURL);_context.next=8;return __WEBPACK_IMPORTED_MODULE_13_axios___default()({url:data.getPublicDownloadURL,method:'GET',headers:{Accept:'application/vnd.ms-excel'},responseType:'blob'// important
});case 8:res=_context.sent;__WEBPACK_IMPORTED_MODULE_17_file_saver___default.a.saveAs(new Blob([res.data]),'sample.xlsx');// FileSaver.saveAs(data.getPublicDownloadURL, 'sample.xlsx')
case 10:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}();},_this.handleSubmit=function(client){return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(event){var manarr,_ref5,data,errors,fullData,arrList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:event.preventDefault();_this.setState({isLoading:true,disable:true});manarr=_this.state.manufacturerName.split('*');// console.log(
//   'click fun',
//   this.state.bucketName,
//   this.state.fileName,
//   manarr[0],
//   manarr[1],
//   this.state.modelname
// )
_context2.next=5;return client.mutate({mutation:DEASSIGN_DEVICE,variables:{fileInfo:{uploadFor:'deAssignDeviceFromSubscription',bucketName:_this.state.bucketName,fileName:_this.state.fileName,operationType:'SKIP'},commonInput:{clientLoginId:parseInt(_this.props.match.params.loginId,10),subscriptionId:parseInt(_this.props.match.params.subscriptionId,10)}},errorPolicy:'all'});case 5:_ref5=_context2.sent;data=_ref5.data;errors=_ref5.errors;_this.setState({isLoading:false});if(data!==null){console.log('data files',data);fullData=[];arrList=data.excelFileUpload.failedUploadList;console.log('arr_list',JSON.parse(arrList));JSON.parse(arrList).forEach(function(element){var rowData=[];// this.clientId.push(element.id)
rowData.push(element.serialNum);rowData.push(element.imeiNum);rowData.push(element.errorMsg);// console.log('rowdata', toString(element.serialNumber))
fullData.push(rowData);});// this.state.simprovider = ''
_this.setState({response:'Total Excel Records= '+data.excelFileUpload.totalExcelDataRecords+','+'Total Records Uploaded='+data.excelFileUpload.successfullyUploaded+', Total Records Failed To Upload='+data.excelFileUpload.failedToUpload+', Total Duplicate Records in Excel='+data.excelFileUpload.totalDuplicateRecords,uploadSucess:true,failList:fullData,result:true});}else{_this.setState({response:errors[0].message,uploadSucess:true});}console.log('res=',_this.state.failList);case 11:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref4.apply(this,arguments);};}();},_this.onUpload=function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(_ref6){var _ref6$target=_ref6.target,validity=_ref6$target.validity,_ref6$target$files=_slicedToArray(_ref6$target.files,1),file=_ref6$target$files[0];var fileExtension,response,url;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:// TODO: Handle upload errors
_this.setState({isUploading:true});if(!validity.valid){_context3.next=11;break;}fileExtension=file.name.substring(file.name.lastIndexOf('.')+1);_context3.next=5;return _this.props.client.mutate({mutation:GET_UPLOAD_URL,variables:{fileExtension:fileExtension}});case 5:response=_context3.sent;if(!(response.data&&response.data.getPublicUploadURL)){_context3.next=11;break;}url=response.data.getPublicUploadURL.publicUploadURL;_context3.next=10;return __WEBPACK_IMPORTED_MODULE_13_axios___default.a.put(url,file,{headers:{"x-ms-blob-type":"BlockBlob","Content-Type":file.type||"application/octet-stream"}});case 10:// console.log('upload', res)
_this.setState({fileName:response.data.getPublicUploadURL.filename,bucketName:response.data.getPublicUploadURL.bucketName,publicUploadURL:response.data.getPublicUploadURL.publicUploadURL});case 11:_this.setState({isUploading:false});case 12:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x3){return _ref7.apply(this,arguments);};}(),_temp),_possibleConstructorReturn(_this,_ret);}// checkManufacturerNameValidity = () => {
//   console.log(this.state.manufacturerName)
//   const code = this.state.manufacturerName.split('*')
//   console.log('man', code[0])
//   this.setState({
//     isManufacturerNameValid: this.state.manufacturerName !== '',
//     // manufacturerCode:this
//     uniqueSerialNumber: code[1] + '_' + this.state.serialno,
//     manufacturerId: code[0]
//   })
// }
// handleSubmit = addDevice => e => {
_createClass(DeassignDevices,[{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;// console.log('clients', this.props.match.params.subscriptionId)
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{container:true,direction:'row',justify:'flex-start',spacing:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Typography"],{variant:'title'},' Deassign Device Bulk')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12,sm:'6'},' ','Download sample template for device deassign bulk'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12,sm:'6'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{color:'secondary',variant:'contained',className:classes.button,onClick:this.downloadBulkDeassign(this.props.client)},'Download Excel'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},this.state.uploadSucess&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Typography"],{variant:'subheading',color:'primary'},this.state.response)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider___default.a,{light:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{style:{minWidth:'40%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{accept:'*/*',id:'contained-button-file',multiple:true,type:'file',style:{display:'none'},onChange:this.onUpload}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'contained-button-file'},'Upload excel file here \xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{variant:'contained',component:'span',color:'primary'},this.state.isUploading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress___default.a,{size:15}):'Upload')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{color:'default',variant:'contained',onClick:this.setToDefaults},'SET TO DEFAULTS'),'       ','       ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{color:'default',variant:'contained',onClick:function onClick(){return _this3.props.history.goBack();}},'Cancel'),'       ','       ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:this.handleSubmit(this.props.client),type:'submit',color:'primary',variant:'contained',disabled:!this.state.fileName||this.state.disable},'Submit'),' ',this.state.isLoading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'Excel sheet upload is in progress..')),this.state.result&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',null,'Failed records list'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_mui_datatables___default.a,{data:this.state.failList,columns:this.columns,options:this.options})))));}}]);return DeassignDevices;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["withStyles"])(styles)(__WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter___default()(Object(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["withApollo"])(DeassignDevices))));

/***/ }),
/* 2064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_file_saver__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_file_saver__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query {\n    models: allDeviceModels(status: 1) {\n      id\n      model_name\n    }\n  }\n'],['\n  query {\n    models: allDeviceModels(status: 1) {\n      id\n      model_name\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n'],['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query {\n    manufacturers: getAllManufacturer(status: 1) {\n      id\n      manufacturerName\n      manufacturerCode\n    }\n  }\n'],['\n  query {\n    manufacturers: getAllManufacturer(status: 1) {\n      id\n      manufacturerName\n      manufacturerCode\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  mutation excelFileUpload(\n    $fileInfo: FileUploadInput!\n    $commonInput: CommonInput!\n  ) {\n    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {\n      failedToUpload\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedUploadList\n    }\n  }\n'],['\n  mutation excelFileUpload(\n    $fileInfo: FileUploadInput!\n    $commonInput: CommonInput!\n  ) {\n    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {\n      failedToUpload\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedUploadList\n    }\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n'],['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable */var GET_MODELS=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject);var GET_FILE_FORMAT=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject2);var GET_MANUFACTURER=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject3);var DEASSIGN_SIM=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject4);var GET_UPLOAD_URL=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject5);var styles=function styles(theme){return{button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{margin:theme.spacing.unit,minWidth:120},root:{flexGrow:1,padding:theme.spacing.unit*2}};};var DeassignSim=function(_Component){_inherits(DeassignSim,_Component);function DeassignSim(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,DeassignSim);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DeassignSim.__proto__||Object.getPrototypeOf(DeassignSim)).call.apply(_ref,[this].concat(args))),_this),_this.state={open:false,open1:false,modelname:'',isModelNameValid:false,isManufacturerNameValid:false,manufacturerName:'',open_man:false,manufacturerCode:'',manufacturerId:'',publicUploadURL:'',fileName:'',bucketName:'',isUploading:false,uploadSucess:true,response:'',failList:'',result:false,isLoading:false,disable:false},_this.columns=['Phone Number','Sim Number','Reason'],_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15// sort: false,
// filter: false,
//  search: false,
// print: false,
// download: false
// viewColumns: false,
// pagination: false
},_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));};},_this.setToDefaults=function(){_this.setState({response:'',failList:'',result:false,isLoading:false,publicUploadURL:'',fileName:'',bucketName:'',disable:false});},_this.handleChange=function(event){_this.setState(_defineProperty({},event.target.name,event.target.value));},_this.handleOpen=function(){_this.setState({open:true});},_this.handleOpenSelect=function(){_this.setState({open1:true});},_this.handleCloseSelect=function(){_this.setState({open1:false});},_this.handleOpenSelectMan=function(){_this.setState({open_man:true});},_this.handleCloseSelectMan=function(){_this.setState({open_man:false});},_this.checkModelNameValidity=function(){_this.setState({isModelNameValid:_this.state.modelname!==''});},_this.checkManufacturerNameValidity=function(){console.log(_this.state.manufacturerName);var code=_this.state.manufacturerName.split('*');console.log('man',code[0]);_this.setState({isManufacturerNameValid:_this.state.manufacturerName!=='',// manufacturerCode:this
uniqueSerialNumber:code[1]+'_'+_this.state.serialno,manufacturerId:code[0]});},_this.downloadBulkDeassign=function(client){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _ref3,data,res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:console.log('click funny');_context.next=3;return _this.props.client.query({query:GET_FILE_FORMAT,variables:{bucketname:'excel-templates',filename:'deAssignSimTemplate.xlsx'},errorPolicy:'all'});case 3:_ref3=_context.sent;data=_ref3.data;console.log('file',data.getPublicDownloadURL);_context.next=8;return __WEBPACK_IMPORTED_MODULE_13_axios___default()({url:data.getPublicDownloadURL,method:'GET',headers:{Accept:'application/vnd.ms-excel'},responseType:'blob'// important
});case 8:res=_context.sent;__WEBPACK_IMPORTED_MODULE_17_file_saver___default.a.saveAs(new Blob([res.data]),'sample.xlsx');// FileSaver.saveAs(data.getPublicDownloadURL, 'sample.xlsx')
case 10:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}();},_this.handleSubmit=function(client){return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(event){var manarr,_ref5,data,errors,fullData,arrList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:event.preventDefault();_this.setState({isLoading:true,disable:true});manarr=_this.state.manufacturerName.split('*');// console.log(
//   'click fun',
//   this.state.bucketName,
//   this.state.fileName,
//   manarr[0],
//   manarr[1],
//   this.state.modelname
// )
_context2.next=5;return client.mutate({mutation:DEASSIGN_SIM,variables:{fileInfo:{uploadFor:'deAssignSimFromSubscription',bucketName:_this.state.bucketName,fileName:_this.state.fileName,operationType:'SKIP'},commonInput:{clientLoginId:parseInt(_this.props.match.params.loginId,10),subscriptionId:parseInt(_this.props.match.params.subscriptionId,10)}},errorPolicy:'all'});case 5:_ref5=_context2.sent;data=_ref5.data;errors=_ref5.errors;_this.setState({isLoading:false});if(data!==null){console.log('data files',data);fullData=[];arrList=data.excelFileUpload.failedUploadList;console.log('arr_list',JSON.parse(arrList));JSON.parse(arrList).forEach(function(element){var rowData=[];// this.clientId.push(element.id)
rowData.push(element.phoneNumber);rowData.push(element.simNumber);rowData.push(element.errorMsg);console.log('rowdata',toString(element.serialNumber));fullData.push(rowData);});// this.state.simprovider = ''
_this.setState({device_model_id:'',manufacturerId:'',response:'Total Excel Records= '+data.excelFileUpload.totalExcelDataRecords+','+'Total Records Uploaded='+data.excelFileUpload.successfullyUploaded+', Total Records Failed To Upload='+data.excelFileUpload.failedToUpload+', Total Duplicate Records in Excel='+data.excelFileUpload.totalDuplicateRecords,uploadSucess:true,failList:fullData,result:true});}else{_this.setState({response:errors[0].message,uploadSucess:true});}console.log('res=',_this.state.failList);case 11:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref4.apply(this,arguments);};}();},_this.onUpload=function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(_ref6){var _ref6$target=_ref6.target,validity=_ref6$target.validity,_ref6$target$files=_slicedToArray(_ref6$target.files,1),file=_ref6$target$files[0];var fileExtension,response,url;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:// TODO: Handle upload errors
_this.setState({isUploading:true});if(!validity.valid){_context3.next=11;break;}fileExtension=file.name.substring(file.name.lastIndexOf('.')+1);_context3.next=5;return _this.props.client.mutate({mutation:GET_UPLOAD_URL,variables:{fileExtension:fileExtension}});case 5:response=_context3.sent;if(!(response.data&&response.data.getPublicUploadURL)){_context3.next=11;break;}url=response.data.getPublicUploadURL.publicUploadURL;_context3.next=10;return __WEBPACK_IMPORTED_MODULE_13_axios___default.a.put(url,file,{headers:{"x-ms-blob-type":"BlockBlob","Content-Type":file.type||"application/octet-stream"}});case 10:// console.log('upload', res)
_this.setState({fileName:response.data.getPublicUploadURL.filename,bucketName:response.data.getPublicUploadURL.bucketName,publicUploadURL:response.data.getPublicUploadURL.publicUploadURL});case 11:_this.setState({isUploading:false});case 12:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x3){return _ref7.apply(this,arguments);};}(),_temp),_possibleConstructorReturn(_this,_ret);}// handleSubmit = addDevice => e => {
_createClass(DeassignSim,[{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;// console.log('client', this.props)
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{container:true,direction:'row',justify:'flex-start',spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Typography"],{variant:'title'},' Deassign Sims Bulk')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12,sm:'6'},' ','Download sample template for sim deassign bulk'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12,sm:'6'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{color:'secondary',variant:'contained',className:classes.button,onClick:this.downloadBulkDeassign(this.props.client)},'Download Excel'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},this.state.uploadSucess&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Typography"],{variant:'subheading',color:'primary'},this.state.response)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider___default.a,{light:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{style:{minWidth:'40%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{accept:'*/*',id:'contained-button-file',multiple:true,type:'file',style:{display:'none'},onChange:this.onUpload}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'contained-button-file'},'Upload excel file here \xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{variant:'contained',component:'span',color:'primary'},this.state.isUploading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress___default.a,{size:15}):'Upload')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{color:'default',variant:'contained',onClick:this.setToDefaults},'SET TO DEFAULTS'),'       ','       ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{color:'default',variant:'contained',onClick:function onClick(){return _this3.props.history.goBack();}},'Cancel'),'       ','       ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:this.handleSubmit(this.props.client),type:'submit',color:'primary',variant:'contained',disabled:!this.state.fileName||this.state.disable},'Submit'),' ',this.state.isLoading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'Excel sheet upload is in progress..')),this.state.result&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',null,'Failed records list'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_mui_datatables___default.a,{data:this.state.failList,columns:this.columns,options:this.options})))));}}]);return DeassignSim;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["withStyles"])(styles)(__WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter___default()(Object(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["withApollo"])(DeassignSim))));

/***/ }),
/* 2065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Card__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_CardContent__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_CardContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_CardContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_common_Loader__ = __webpack_require__(47);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getPartnerDeviceStockByDeviceModel($partnerLoginId: Int!) {\n    devices: getPartnerDeviceStockByDeviceModel(\n      partnerLoginId: $partnerLoginId\n    ) {\n      modelName\n      totalAssignedDevice\n      availableStock\n    }\n  }\n'],['\n  query getPartnerDeviceStockByDeviceModel($partnerLoginId: Int!) {\n    devices: getPartnerDeviceStockByDeviceModel(\n      partnerLoginId: $partnerLoginId\n    ) {\n      modelName\n      totalAssignedDevice\n      availableStock\n    }\n  }\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_DEVICE_STOCK=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject);var style=function style(theme){return{root:{padding:theme.spacing.unit*2,flexGrow:1},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},card:{minWidth:900}};};var SubscriptionDetails=function(_Component){_inherits(SubscriptionDetails,_Component);function SubscriptionDetails(props){_classCallCheck(this,SubscriptionDetails);var _this=_possibleConstructorReturn(this,(SubscriptionDetails.__proto__||Object.getPrototypeOf(SubscriptionDetails)).call(this,props));_this.clientId=[];_this.columns=['Vehicle Number','Sim No','Status'];_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15// onCellClick: (colIndex, rowIndex) => {
//   this.props.history.push({
//     pathname: '/home/customers/view',
//     state: { clientId: this.clientId[rowIndex] }
//   })
// }
};_this.classes=props;// console.log('testttttt:', this.props.location.state.clientId)
return _this;}_createClass(SubscriptionDetails,[{key:'mapToArr',value:function mapToArr(devices){var rowData=[];var fullData=[];// this.clientId = []
devices.forEach(function(element){rowData=[];// this.clientId.push(element.id)
rowData.push(element.modelName);rowData.push(element.totalAssignedDevice);rowData.push(element.availableStock);fullData.push(rowData);});return fullData;}// ViewCustomer = loginId => e => {
//   this.props.history.push({
//     pathname: '/home/customers/view',
//     state: {
//       clientId: this.clientId,
//       loginId: loginId
//     }
//   })
// }
},{key:'render',value:function render(){var _this2=this;var classes=this.props.classes;// const { alignItems, direction, justify } = this.state
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["Query"],{query:GET_DEVICE_STOCK,variables:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_11__utils_getLoginId__["a" /* default */])()},fetchPolicy:'network-only'},function(_ref){var loading=_ref.loading,error=_ref.error,devices=_ref.data.devices;if(loading)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_common_Loader__["a" /* default */],null);if(error)return'Error!: '+error;var data=_this2.mapToArr(devices);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:24},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,container:true,spacing:12,direction:'row-reverse'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default.a,{variant:'flat',color:'primary',className:classes.button,href:'/home/customers/view'// onClick={this.ViewCustomer(
//   this.props.location.state.loginId
// )}
},'Back'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Card___default.a,{className:classes.card},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,container:true,spacing:12,direction:'row',justify:'flex-start',alignItems:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Typography___default.a// className={classes.title}
,{color:'textSecondary',variant:'caption'},'Customer Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Typography___default.a,{variant:'subheading',component:'h4'},'Ola Cabs'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Typography___default.a,{className:classes.title,color:'textSecondary'},'Plan'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Typography___default.a,{variant:'subheading',component:'h4'},'Basic Plan'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Typography___default.a,{className:classes.title,color:'textSecondary'},'Subscription'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Typography___default.a,{variant:'subheading',component:'h4'},'Bi-Monthly')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_mui_datatables___default.a,{title:'Subscription Details',data:data,columns:_this2.columns,options:_this2.options}))));});}}]);return SubscriptionDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SubscriptionDetails.propTypes={classes:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles__["withStyles"])(style)(SubscriptionDetails));

/***/ }),
/* 2066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_ArrowBack__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_ArrowBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_ArrowBack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PlanDetails___ = __webpack_require__(2067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_common_Loader__ = __webpack_require__(47);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query allClientDetails($partnerLoginId: Int, $planId: Int) {\n    clients: allClientDetails(\n      partnerLoginId: $partnerLoginId\n      planId: $planId\n    ) {\n      id\n      clientName\n      contactPerson\n      contactNumber\n      email\n      totalAssignedVehicle\n    }\n  }\n'],['\n  query allClientDetails($partnerLoginId: Int, $planId: Int) {\n    clients: allClientDetails(\n      partnerLoginId: $partnerLoginId\n      planId: $planId\n    ) {\n      id\n      clientName\n      contactPerson\n      contactNumber\n      email\n      totalAssignedVehicle\n    }\n  }\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_CLIENTS=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject);var style=function style(theme){var _root;return{root:(_root={padding:theme.spacing.unit*4},_defineProperty(_root,theme.breakpoints.down('sm'),{padding:theme.spacing.unit*2}),_defineProperty(_root,'flexGrow',1),_root),paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},card:{minWidth:900}};};var ViewPlans=function(_Component){_inherits(ViewPlans,_Component);function ViewPlans(props){_classCallCheck(this,ViewPlans);var _this=_possibleConstructorReturn(this,(ViewPlans.__proto__||Object.getPrototypeOf(ViewPlans)).call(this,props));_this.clientId=[];_this.fullData=[];_this.columns=['CLIENT NAME','CONTACT PERSON','EMAIL','CONTACT NUMBER','TOTAL VEHICLES'];_this.options={selectableRows:false,filter:false,responsive:'scroll',rowsPerPage:15};_this.mapToArr=function(data){var rowData=[];var fullData=[];data.forEach(function(element){rowData=[];rowData.push(element.clientName);rowData.push(element.contactPerson);rowData.push(element.email);rowData.push(element.contactNumber);rowData.push(element.totalAssignedVehicle);fullData.push(rowData);});return fullData;};_this.viewPlansPage=function(e){_this.props.history.push({pathname:'/home/plans'});};_this.classes=props;_this.planId=_this.props.match.params.planId;console.log('ViewPlans=',_this.planId);return _this;}_createClass(ViewPlans,[{key:'render',value:function render(){var _this2=this;var classes=this.props.classes;// console.log('insideclass', this.planId)
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["Query"],{query:GET_CLIENTS,variables:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_11__utils_getLoginId__["a" /* default */])(),planId:parseInt(this.planId,10)},errorPolicy:'all'},function(_ref){var loading=_ref.loading,error=_ref.error,data=_ref.data;if(loading)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_common_Loader__["a" /* default */],null);// if (error) return `Error!: ${error}`
// console.log(data, 'data')
var rowData=void 0;var temp=[];if(data){rowData=_this2.mapToArr(data.clients);}else{rowData=_this2.mapToArr(temp);}// console.log(rowData)
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default.a,{variant:'outlined',color:'secondary',className:classes.button,onClick:_this2.viewPlansPage},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_ArrowBack___default.a,{className:classes.iconSmall}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__PlanDetails___["a" /* default */],{planId:_this2.planId})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},data.clients.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_mui_datatables___default.a,{title:'Customers',data:rowData,columns:_this2.columns,options:_this2.options}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Typography"],{variant:'subheading',color:'error',align:'center'},'No Clients are assigned to this plan',' '))));});}}]);return ViewPlans;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ViewPlans.propTypes={classes:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles__["withStyles"])(style)(ViewPlans));

/***/ }),
/* 2067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_ListItem__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_ListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_ListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_ListItemText__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_ListItemText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_ListItemText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_ListItemIcon__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_ListItemIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_ListItemIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Folder__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Folder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Folder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_List__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_ExpansionPanel__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_ExpansionPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_ExpansionPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_ExpansionPanelSummary__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_ExpansionPanelSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_ExpansionPanelSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_ExpansionPanelDetails__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_ExpansionPanelDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_ExpansionPanelDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_icons_ExpandMore__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_icons_ExpandMore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_icons_ExpandMore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_common_Loader__ = __webpack_require__(47);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getPlans($id: Int!) {\n    planinfo: getPlans(id: $id) {\n      id\n      planName\n      description\n      costPerAsset\n      featureList {\n        featureName\n        costPerAssetPerMonth\n      }\n    }\n  }\n'],['\n  query getPlans($id: Int!) {\n    planinfo: getPlans(id: $id) {\n      id\n      planName\n      description\n      costPerAsset\n      featureList {\n        featureName\n        costPerAssetPerMonth\n      }\n    }\n  }\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_PLAN_INFO=Object(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__["a" /* default */])(_templateObject);var style=function style(theme){return{root:{flexGrow:1},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},button:{margin:theme.spacing.unit},input:{display:'none'}};};var PlanDetails=function(_Component){_inherits(PlanDetails,_Component);function PlanDetails(props){_classCallCheck(this,PlanDetails);var _this=_possibleConstructorReturn(this,(PlanDetails.__proto__||Object.getPrototypeOf(PlanDetails)).call(this,props));_this.mapToArr=function(data){var FeatureList=data.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_ListItem___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_ListItemIcon___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Folder___default.a,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_ListItemText___default.a,null,''+item.featureName));});return FeatureList;};_this.classes=props;console.log(_this.props);return _this;}_createClass(PlanDetails,[{key:'render',value:function render(){var _this2=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["Query"],{query:GET_PLAN_INFO,variables:{id:parseInt(this.props.planId,10)},fetchPolicy:'network-only'},function(_ref){var loading=_ref.loading,error=_ref.error,planinfo=_ref.data.planinfo;if(loading)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_common_Loader__["a" /* default */],null);if(error)return'Error!: '+error;var retarr=_this2.mapToArr(planinfo.featureList);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Typography___default.a,{variant:'headline'},planinfo.planName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_ExpansionPanel___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_ExpansionPanelSummary___default.a,{expandIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_icons_ExpandMore___default.a,null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Typography___default.a,{className:classes.heading},'Feature List')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_ExpansionPanelDetails___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_List___default.a,{dense:'false'},retarr)))));});}}]);return PlanDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);PlanDetails.propTypes={classes:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__["withStyles"])(style)(PlanDetails));

/***/ }),
/* 2068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormHelperText__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormHelperText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormHelperText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__manufacturer_css__ = __webpack_require__(2069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__manufacturer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__manufacturer_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query {\n    allCountries {\n      country_id\n      name\n    }\n  }\n'],['\n  query {\n    allCountries {\n      country_id\n      name\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query getStatesByCountryId($countryId: Int!) {\n    allStatesByCountryId(country_id: $countryId) {\n      name\n      zone_id\n    }\n  }\n'],['\n  query getStatesByCountryId($countryId: Int!) {\n    allStatesByCountryId(country_id: $countryId) {\n      name\n      zone_id\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query checkManufacturerName($manufacturername: String!) {\n    checkManufacturerName(manufacturerName: $manufacturername)\n  }\n'],['\n  query checkManufacturerName($manufacturername: String!) {\n    checkManufacturerName(manufacturerName: $manufacturername)\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query checkManufacturerContactNumber($phoneno: String!) {\n    checkManufacturerContactNumber(contactNumber: $phoneno)\n  }\n'],['\n  query checkManufacturerContactNumber($phoneno: String!) {\n    checkManufacturerContactNumber(contactNumber: $phoneno)\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  query checkManufacturerEmail($email: String!) {\n    checkManufacturerEmail(email: $email)\n  }\n'],['\n  query checkManufacturerEmail($email: String!) {\n    checkManufacturerEmail(email: $email)\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  mutation addManufacturerDetail(\n    $manufacturerName: String!\n    $email: String!\n    $contactPerson: String!\n    $contactNumber: String!\n    $address: String!\n    $city: String!\n    $state: Int!\n    $country: Int!\n    $pincode: Int!\n    $manufacturerCode: String!\n  ) {\n    addManufacturerDetail(\n      manufacturerName: $manufacturerName\n      email: $email\n      contactPerson: $contactPerson\n      contactNumber: $contactNumber\n      address: $address\n      city: $city\n      state_id: $state\n      country_id: $country\n      pincode: $pincode\n      manufacturerCode: $manufacturerCode\n    )\n  }\n'],['\n  mutation addManufacturerDetail(\n    $manufacturerName: String!\n    $email: String!\n    $contactPerson: String!\n    $contactNumber: String!\n    $address: String!\n    $city: String!\n    $state: Int!\n    $country: Int!\n    $pincode: Int!\n    $manufacturerCode: String!\n  ) {\n    addManufacturerDetail(\n      manufacturerName: $manufacturerName\n      email: $email\n      contactPerson: $contactPerson\n      contactNumber: $contactNumber\n      address: $address\n      city: $city\n      state_id: $state\n      country_id: $country\n      pincode: $pincode\n      manufacturerCode: $manufacturerCode\n    )\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_COUNTRY=Object(__WEBPACK_IMPORTED_MODULE_9_graphql_tag__["a" /* default */])(_templateObject);var GET_STATES_FOR_COUNTRY=Object(__WEBPACK_IMPORTED_MODULE_9_graphql_tag__["a" /* default */])(_templateObject2);// Manufacturer name validation
var GET_MANUFACTURER_NAME=Object(__WEBPACK_IMPORTED_MODULE_9_graphql_tag__["a" /* default */])(_templateObject3);// Business name validation
var GET_CONTACTNO=Object(__WEBPACK_IMPORTED_MODULE_9_graphql_tag__["a" /* default */])(_templateObject4);// Business email validation
var GET_EMAIL=Object(__WEBPACK_IMPORTED_MODULE_9_graphql_tag__["a" /* default */])(_templateObject5);// calling server for updation
var ADD_MANUFACTURER=Object(__WEBPACK_IMPORTED_MODULE_9_graphql_tag__["a" /* default */])(_templateObject6);var AddManufacturer=function(_Component){_inherits(AddManufacturer,_Component);function AddManufacturer(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,AddManufacturer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AddManufacturer.__proto__||Object.getPrototypeOf(AddManufacturer)).call.apply(_ref,[this].concat(args))),_this),_this.state={businessname:'',country:'',email:'',phoneno:'',contactp:'',address:'',city:'',statename:'',pin:'',manufacturerCode:'',clttype:'',username:'',isEmailValid:true,isBusinessNameValid:true,isPhonenoValid:true,isContactpValid:true,isAddressValid:true,isCityValid:true,isCountryValid:true,isStateValid:true,isPinValid:true,isCodeValid:true,isUsernameValid:true,isCltTypeValid:true,getCountryId:'',getStatesId:[],password:'Tracking123',sortedStates:''},_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));};},_this.handleChange=function(client){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _ref3,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:// console.log(event.target.value)
_this.setState({country:event.target.value});_context.next=3;return client.query({query:GET_STATES_FOR_COUNTRY,variables:{countryId:event.target.value}});case 3:_ref3=_context.sent;data=_ref3.data;_context.next=7;return _this.onCountryFetched(data.allStatesByCountryId);case 7:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}();},_this.handleChangeState=function(state){_this.setState({statename:state.value});},_this.handleChangeclt=function(event){_this.setState({clttype:event.target.value});},_this.checkBusinessNameValidity=function(client){return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(event){var regex,_ref5,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:regex=new RegExp(/^(?!\s)(?!.*\s$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9 '~?!]{2,}$/);_context2.next=3;return client.query({query:GET_MANUFACTURER_NAME,variables:{manufacturername:_this.state.businessname}});case 3:_ref5=_context2.sent;data=_ref5.data;// await this.onCountryFetched(data.allStatesByCountryId)
_this.setState({isBusinessNameValid:regex.test(_this.state.businessname)&&_this.state.businessname!==''&&data.checkBusinessName==='AVAILABLE'});console.log('replay',data.checkBusinessName,_this.state.isBusinessNameValid);case 7:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref4.apply(this,arguments);};}();},_this.checkEmailValidity=function(client){return function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(event){var regex,_ref7,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:regex=new RegExp(// eslint-disable-next-line
/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);_context3.next=3;return client.query({query:GET_EMAIL,variables:{email:_this.state.email}});case 3:_ref7=_context3.sent;data=_ref7.data;_this.setState({isEmailValid:regex.test(_this.state.email)&&_this.state.email!==''&&data.checkEmail==='AVAILABLE'});case 6:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x3){return _ref6.apply(this,arguments);};}();},_this.checkPhonenoValidity=function(client){return function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(event){var regex,_ref9,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:regex=new RegExp(// eslint-disable-next-line
// /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/ For USA NUM
/^(\+91[-\s]?)?[0]?(91)?[789]\d{9}$/);_context4.next=3;return client.query({query:GET_CONTACTNO,variables:{phoneno:_this.state.phoneno}});case 3:_ref9=_context4.sent;data=_ref9.data;_this.setState({isPhonenoValid:regex.test(_this.state.phoneno)&&_this.state.phoneno!==''&&data.checkContactNumber==='AVAILABLE'});console.log('replay',data,data.checkContactNumber,_this.state.isPhonenoValid);case 7:case'end':return _context4.stop();}}},_callee4,_this2);}));return function(_x4){return _ref8.apply(this,arguments);};}();},_this.checkContactpValidity=function(){var regex=new RegExp(/^[a-zA-Z\s]+$/);_this.setState({isContactpValid:regex.test(_this.state.contactp)||_this.state.contactp===''});},_this.checkAddressValidity=function(){var regex=new RegExp(/^[a-zA-Z0-9\s,.'-]{3,}$/);_this.setState({isAddressValid:regex.test(_this.state.address)||_this.state.address!==''});},_this.checkCityValidity=function(){var regex=new RegExp(/^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/);_this.setState({isCityValid:regex.test(_this.state.city)||_this.state.city!==''});},_this.checkPinValidity=function(){var regex=new RegExp(/^[1-9][0-9]{5}$/);_this.setState({isPinValid:regex.test(_this.state.pin)||_this.state.pin!==''});},_this.checkCountryValidity=function(){_this.setState({isCountryValid:_this.state.country!==''});},_this.checkStateValidity=function(){_this.setState({isStateValid:_this.state.statename!==''});},_this.checkCltTypeValidity=function(){_this.setState({isCltTypeValid:_this.state.clttype!==''});},_this.onCountryFetched=function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(getStatesId){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_this.setState({getStatesId:getStatesId});console.log('"arpit"',getStatesId);console.log('StateName=',getStatesId[0].name);case 3:case'end':return _context5.stop();}}},_callee5,_this2);}));return function(_x5){return _ref10.apply(this,arguments);};}(),_this.handleCountryChange=function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(country){var countryId,_ref12,data,sortedStates;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:// handleCountryChange = async event => {
// alert(event.target.value)
console.log('country',country);countryId=country;if(!country){_this.setState({state:'',country:''});}else{_this.setState({state:'',country:countryId.value});}_context6.next=5;return _this.props.client.query({query:GET_STATES_FOR_COUNTRY,variables:{countryId:countryId.value}});case 5:_ref12=_context6.sent;data=_ref12.data;sortedStates=data.allStatesByCountryId.map(function(state){return{value:state.zone_id,label:state.name};});_this.setState({sortedStates:sortedStates});console.log('sortedStates',_this.state.sortedStates);case 10:case'end':return _context6.stop();}}},_callee6,_this2);}));return function(_x6){return _ref11.apply(this,arguments);};}(),_this.handleSubmit=function(client){return function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(event){var _ref14,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:console.log('click fun',_this.state.manufacturerCode);event.preventDefault();_context7.next=4;return client.mutate({mutation:ADD_MANUFACTURER,variables:{manufacturerName:_this.state.businessname,email:_this.state.email,contactPerson:_this.state.contactp,contactNumber:_this.state.phoneno,address:_this.state.address,city:_this.state.city,state:parseInt(_this.state.statename,10),country:parseInt(_this.state.country,10),pincode:parseInt(_this.state.pin,10),manufacturerCode:_this.state.manufacturerCode},errorPolicy:'all'});case 4:_ref14=_context7.sent;data=_ref14.data;// this.state.simprovider = ''
_this.setState({businessname:'',contactNumber:'',email:'',contactPerson:'',address:'',city:'',state:'',country:'',pincode:'',manufacturerCode:''});if(data!==null){_this.setState({response:data.addVehicleDetail});}else{_this.setState({failure:true});}case 8:case'end':return _context7.stop();}}},_callee7,_this2);}));return function(_x7){return _ref13.apply(this,arguments);};}();},_this.getAllCountries=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(){var allCountries,sortedCountries;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return _this.props.client.query({query:GET_COUNTRY});case 2:allCountries=_context8.sent;sortedCountries=allCountries.data.allCountries.map(function(country){return{value:country.country_id,label:country.name};});_this.setState({sortedCountries:sortedCountries});case 5:case'end':return _context8.stop();}}},_callee8,_this2);})),_temp),_possibleConstructorReturn(_this,_ret);}// checkBusinessNameValidity = () => {
// checkPhonenoValidity = () => {
_createClass(AddManufacturer,[{key:'componentDidMount',value:function componentDidMount(){this.getAllCountries();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'Landing'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',{className:'Formheader'},'Manufacturer Registartion Form'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'formouter'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl___default.a,{className:'form-box'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{id:'businessname',name:'businessname',className:'textfield',margin:'dense',label:'Manufacturer Name',value:this.state.businessname,required:true,onChange:this.handleInputChange('businessname'),error:!this.state.isBusinessNameValid,onBlur:this.checkBusinessNameValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isBusinessNameValid?'Invalid BusinessName':'')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl___default.a,{className:'form-box'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{id:'email',name:'email',className:'textfield',margin:'dense',label:'Primary Email',type:'email',value:this.state.email,required:true,onChange:this.handleInputChange('email')// placeholder="Email"
,error:!this.state.isEmailValid,onBlur:this.checkEmailValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isEmailValid?'Invalid Email':'')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl___default.a,{className:'form-box'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{id:'phoneno',name:'phoneno',className:'textfield',margin:'dense',label:'Contact No',type:'text',value:this.state.phoneno,required:true,onChange:this.handleInputChange('phoneno'),error:!this.state.isPhonenoValid,onBlur:this.checkPhonenoValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isPhonenoValid?'Invalid Contact No':'')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl___default.a,{className:'form-box'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{id:'contactp',name:'contactp',className:'textfield',margin:'dense',label:'Contact Person',type:'text',value:this.state.contactp,required:true,onChange:this.handleInputChange('contactp'),error:!this.state.isContactpValid,onBlur:this.checkContactpValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isContactpValid?'Invalid Contact Person Name':'')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl___default.a,{className:'form-box'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{id:'address',name:'address',className:'textfield',margin:'dense',label:'Address',type:'Multi-line',value:this.state.address,required:true,onChange:this.handleInputChange('address'),error:!this.state.isAddressValid,onBlur:this.checkAddressValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isAddressValid?'Invalid Address':'')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl___default.a,{className:'form-box'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{id:'city',name:'city',className:'textfield',margin:'dense',label:'City'// type="Multi-line"
,value:this.state.city,required:true,onChange:this.handleInputChange('city'),error:!this.state.isCityValid,onBlur:this.checkCityValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isCityValid?'Invalid City':'')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */]// classes={state
,{options:this.state.sortedCountries// components={components}
,value:this.state.country,onChange:this.handleCountryChange,placeholder:'Select Country'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isCountryValid?'Invalid Selection':''))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */],{value:this.state.statename,onChange:this.handleChangeState,error:!this.state.isStateValid,onBlur:this.checkStateValidity,options:this.state.sortedStates,placeholder:'Select States'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isStateValid?'Invalid Selection':'')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl___default.a,{className:'form-box'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{id:'pin',name:'pin',className:'textfield',margin:'dense',label:'Pin Code'// type="Multi-line"
,value:this.state.pin,required:true,onChange:this.handleInputChange('pin'),error:!this.state.isPinValid,onBlur:this.checkPinValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isPinValid?'Invalid Pin Number':'')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl___default.a,{className:'form-box'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{id:'code',name:'code',className:'textfield',margin:'dense',label:'Manufacturer Code',value:this.state.manufacturerCode,required:true,onChange:this.handleInputChange('manufacturerCode'),error:!this.state.isCodeValid// onBlur={this.checkCodeValidity}
}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isCodeValid?'Invalid Manufacturer':''))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{justify:'center',container:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button___default.a,{color:'default',variant:'outlined',size:'medium',margin:'normal',className:'btn'},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button___default.a,{variant:'contained',color:'primary',size:'medium',margin:'normal',className:'btn',type:'submit',onClick:this.handleSubmit(this.props.client),disabled:!(this.state.isEmailValid&&this.state.isBusinessNameValid&&this.state.email!==''&&this.state.businessname!==''&&this.state.contactp!==''&&this.state.isContactpValid&&this.state.phoneno!==''&&this.state.isPhonenoValid&&this.state.address!==''&&this.state.isAddressValid&&this.state.city!==''&&this.state.isCityValid&&this.state.statename!==''&&this.state.country!==''&&this.state.pin!==''&&this.state.isPinValid)},'Submit'))))))));}}]);return AddManufacturer;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_apollo__["withApollo"])(AddManufacturer));

/***/ }),
/* 2069 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import { withStyles } from '@material-ui/core/styles'
var Gst=function(_Component){_inherits(Gst,_Component);//   handleSelectGstChange = name => value => {
//     console.log('On slelect Day change ', name, ' ', value)
//     this.setState({ [name]: value })
//   }
function Gst(props){_classCallCheck(this,Gst);var _this=_possibleConstructorReturn(this,(Gst.__proto__||Object.getPrototypeOf(Gst)).call(this,props));_this.state={gstRates:'',gstRate:''};var gstRates=['5','10','12','15'];var billingGst=gstRates.map(function(gst){return{value:gst,label:gst};});_this.setState({gstRates:billingGst});console.log(_this.state.gstRates);// const { classes } = this.props
return _this;}_createClass(Gst,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_select__["a" /* default */]// classes={classes}
,{options:this.state.gstRates// components={components}
,value:this.props.gstRate// onChange={this.handleSelectGstChange('gstRate')}
,placeholder:'Gst'});}}]);return Gst;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);// export default withStyles(Gst)
/* harmony default export */ __webpack_exports__["a"] = (Gst);

/***/ }),
/* 2071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__queries__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__queries__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormHelperText__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormHelperText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormHelperText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Switch__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Input__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ClientDetails__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_core_FormControlLabel__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_core_FormControlLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_FormControlLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core_Checkbox__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_icons_ArrowBack__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_icons_ArrowBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__material_ui_icons_ArrowBack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__material_ui_core_Dialog__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__material_ui_core_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__material_ui_core_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__ChangeVehicleStatus__ = __webpack_require__(2072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__DecoupleDevices__ = __webpack_require__(2073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__vehicle_css__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__vehicle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__vehicle_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__material_ui_icons_DeleteForever__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__material_ui_icons_DeleteForever___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__material_ui_icons_DeleteForever__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__material_ui_core_Tooltip__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__material_ui_core_Tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__material_ui_core_Tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__SwapClient__ = __webpack_require__(2074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__DeleteVehicle__ = __webpack_require__(2075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__material_ui_core_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__material_ui_core_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__material_ui_core_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_material_ui_pickers__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__material_ui_icons_Close__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__material_ui_icons_Close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__material_ui_icons_Close__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_axios__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_file_saver__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__TensionerRotationSensorReminder__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__utils_phaseOptionsArray__ = __webpack_require__(537);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n'],['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query checkVehicleNumber($vlpn: String!) {\n    checkVehicleNumber(vehicleNumber: $vlpn)\n  }\n'],['\n  query checkVehicleNumber($vlpn: String!) {\n    checkVehicleNumber(vehicleNumber: $vlpn)\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation updateVehicleDetail(\n    $entityId: Int!\n    $vehicleNumber: String!\n    $engineNumber: String\n    $chassisNumber: String\n    $clientLoginId: Int!\n    $speedSensorType: String!\n    $speedLimit: Int!\n    $vehicleType: String!\n    $vehicleModel: String!\n    $vehicleMake: String\n    $vehicleModelId: String\n    $vehicleMakeId: String\n    $vehicleCapacity: Int\n    $equipmentSerialNumber: String\n    $equipmentName: String\n    $commissioningDate: Int\n    $invoiceDate: Int\n    $department: String\n    $idlingSpeed: Int\n    $invoiceNumber: String\n    $isActivated: Boolean\n    $status: Int!\n    $contractorName: String\n    $engineTorque: String\n    $engineLoad: String\n    $fuelType: String\n    $torquePower: String\n    $engineSpecification: String\n    $emissionRateType: String\n    $grossVehicleWeight: Float\n    $manufacturingYear: Int\n    $vehicleSegment: String\n    $equipmentTypeClass: String\n    $vehicleWheeler: String\n    $application: String\n    $haulageType: String\n    $constructionVehicleType: String\n    $passengerVehicleType: String\n    $transportationVehicleType: String\n    $vehicleNickName: String\n    $documentUpload: String\n    $documentUploadNew: JSON\n    $baselineDataForFE: Float\n    $baselineDataForFELPH: Float\n    $baselineDataType: String\n    $fuelTankCapacity: String\n    $adblueCapacity: String\n    $baselineDistance: Float\n    $immobilize: Boolean\n    $solutionType: String\n    $solution_type: [String]\n    $zonalManager: String\n    $keyAccountManager: String\n    $channelPartnerName: String\n    $isDualEngine: Boolean\n    $eoff_voltage: Float\n    $eon_voltage: Float\n    $hasArm: Boolean\n    $isElockConnection: Boolean\n    $duplicateVehicle: Boolean\n    $portedVehicle: Boolean\n    $isTestingVehicle: Boolean\n    $kvaRating: String\n    $dgSetType: String\n    $bhp: String\n    $phase: String\n    $engineModel: String\n    $gensetController: String\n    $videoTelematicsType: String\n    $videoTelematicsId: String\n    $inputParameter: Float\n    $multiplicationFactor: Float\n    $engineOnHours: String\n    $odometerDistance: String\n    $noOfGears: Int\n    $vehicleCustomizedBodyType: String\n    $isIndividualViewOrCombinedView: Boolean\n    $baselineHours: Int\n    $noOfWheels: Int\n    $custType: String\n    $custCode: String\n    $clientName: String\n    $vehicleClass: String\n    $fuelCode: String\n    $numberOfAxles: Int\n    $permitCode: String\n    $insurerName: String\n    $insuranceUpto: String\n    $permitType: String\n    $permitValidUpto: String\n    $permitValidFrom: String\n    $permitNumber: String\n    $permitIssueDate: String\n    $puccUpto: String\n    $registeredAt: String\n    $unladenWeight: Int\n    $manufacturingMonthYear: String\n    $taxUpto: String\n    $nationalPermitUpto: String\n    $fitmentUpto: String\n    $emissionNormsDescription: String\n    $bodyTypeDescription: String\n    $makerModel: String\n    $makerDescription: String\n    $vehicleClassDescription: String\n    $vehicleCategoryDescription: String\n    $vehicleRegistrationNumber: String\n    $registrationDate: String\n    $registrationValidUpto: String\n    $stateCode: String\n    $rtoCode: String\n    $vehicleCategoryCode: String\n    $gearRatio: String\n    $tensionerConductorLength: Float\n    $tensionerRotationSensorDirection: String\n    $isRotationSensor: Boolean\n    $technicianName: String\n    $updatedBy: String\n    $rcsSerialNumber: String\n    $istachoenabled: Boolean\n    $tachoidlerpm: Int\n    $tachoshifthours: Int\n    $tachoengineonmin: Int\n    $tachoengineonmax: Int\n  ) {\n    updateVehicleDetail(\n      entityId: $entityId\n      vehicleNumber: $vehicleNumber\n      engineNumber: $engineNumber\n      chassisNumber: $chassisNumber\n      clientLoginId: $clientLoginId\n      speedSensorType: $speedSensorType\n      speedLimit: $speedLimit\n      vehicleType: $vehicleType\n      vehicleModel: $vehicleModel\n      vehicleMake: $vehicleMake\n      vehicleModelId: $vehicleModelId\n      vehicleMakeId: $vehicleMakeId\n      vehicleCapacity: $vehicleCapacity\n      equipmentSerialNumber: $equipmentSerialNumber\n      equipmentName: $equipmentName\n      commissioningDate: $commissioningDate\n      invoiceDate: $invoiceDate\n      department: $department\n      idlingSpeed: $idlingSpeed\n      invoiceNumber: $invoiceNumber\n      isActivated: $isActivated\n      immobilize: $immobilize\n      status: $status\n      contractorName: $contractorName\n      engineTorque: $engineTorque\n      engineLoad: $engineLoad\n      fuelType: $fuelType\n      torquePower: $torquePower\n      engineSpecification: $engineSpecification\n      emissionRateType: $emissionRateType\n      engineOnHours: $engineOnHours\n      odometerDistance: $odometerDistance\n      grossVehicleWeight: $grossVehicleWeight\n      manufacturingYear: $manufacturingYear\n      vehicleSegment: $vehicleSegment\n      equipmentTypeClass: $equipmentTypeClass\n      vehicleWheeler: $vehicleWheeler\n      application: $application\n      haulageType: $haulageType\n      constructionVehicleType: $constructionVehicleType\n      passengerVehicleType: $passengerVehicleType\n      transportationVehicleType: $transportationVehicleType\n      vehicleNickName: $vehicleNickName\n      documentUpload: $documentUpload\n      documentUploadNew: $documentUploadNew\n      baselineDataForFE: $baselineDataForFE\n      baselineDataForFELPH: $baselineDataForFELPH\n      baselineDataType: $baselineDataType\n      fuelTankCapacity: $fuelTankCapacity\n      adblueCapacity: $adblueCapacity\n      baselineDistance: $baselineDistance\n      solutionType: $solutionType\n      solution_type: $solution_type\n      zonalManager: $zonalManager\n      keyAccountManager: $keyAccountManager\n      channelPartnerName: $channelPartnerName\n      isDualEngine: $isDualEngine\n      eoff_voltage: $eoff_voltage\n      eon_voltage: $eon_voltage\n      hasArm: $hasArm\n      isElockConnection: $isElockConnection\n      duplicateVehicle: $duplicateVehicle\n      portedVehicle: $portedVehicle\n      isTestingVehicle: $isTestingVehicle\n\n      kvaRating: $kvaRating\n      dgSetType: $dgSetType\n      bhp: $bhp\n      phase: $phase\n      engineModel: $engineModel\n      gensetController: $gensetController\n      videoTelematicsType: $videoTelematicsType\n      inputParameter: $inputParameter\n      multiplicationFactor: $multiplicationFactor\n      videoTelematicsId: $videoTelematicsId\n\n      rcsSerialNumber: $rcsSerialNumber\n\n      technicianName: $technicianName\n      updatedBy: $updatedBy\n\n      noOfGears: $noOfGears\n\n      vehicleCustomizedBodyType: $vehicleCustomizedBodyType\n\n      isIndividualViewOrCombinedView: $isIndividualViewOrCombinedView\n\n      baselineHours: $baselineHours\n\n      noOfWheels: $noOfWheels\n\n      custType: $custType\n\n      custCode: $custCode\n\n      clientName: $clientName\n\n      vehicleClass: $vehicleClass\n\n      fuelCode: $fuelCode\n\n      numberOfAxles: $numberOfAxles\n\n      permitCode: $permitCode\n\n      insurerName: $insurerName\n\n      insuranceUpto: $insuranceUpto\n\n      permitType: $permitType\n\n      permitValidUpto: $permitValidUpto\n\n      permitValidFrom: $permitValidFrom\n\n      permitNumber: $permitNumber\n\n      permitIssueDate: $permitIssueDate\n\n      puccUpto: $puccUpto\n\n      registeredAt: $registeredAt\n\n      unladenWeight: $unladenWeight\n\n      manufacturingMonthYear: $manufacturingMonthYear\n\n      taxUpto: $taxUpto\n\n      nationalPermitUpto: $nationalPermitUpto\n\n      fitmentUpto: $fitmentUpto\n\n      emissionNormsDescription: $emissionNormsDescription\n\n      bodyTypeDescription: $bodyTypeDescription\n\n      makerModel: $makerModel\n\n      makerDescription: $makerDescription\n\n      vehicleClassDescription: $vehicleClassDescription\n\n      vehicleCategoryDescription: $vehicleCategoryDescription\n\n      vehicleRegistrationNumber: $vehicleRegistrationNumber\n\n      registrationDate: $registrationDate\n\n      registrationValidUpto: $registrationValidUpto\n\n      stateCode: $stateCode\n\n      rtoCode: $rtoCode\n\n      vehicleCategoryCode: $vehicleCategoryCode\n\n      gearRatio: $gearRatio\n\n      tensionerConductorLength: $tensionerConductorLength\n      tensionerRotationSensorDirection: $tensionerRotationSensorDirection\n      isRotationSensor: $isRotationSensor\n      istachoenabled: $istachoenabled\n      tachoidlerpm: $tachoidlerpm\n      tachoengineonmin: $tachoengineonmin\n      tachoengineonmax: $tachoengineonmax\n      tachoshifthours: $tachoshifthours\n    )\n  }\n'],['\n  mutation updateVehicleDetail(\n    $entityId: Int!\n    $vehicleNumber: String!\n    $engineNumber: String\n    $chassisNumber: String\n    $clientLoginId: Int!\n    $speedSensorType: String!\n    $speedLimit: Int!\n    $vehicleType: String!\n    $vehicleModel: String!\n    $vehicleMake: String\n    $vehicleModelId: String\n    $vehicleMakeId: String\n    $vehicleCapacity: Int\n    $equipmentSerialNumber: String\n    $equipmentName: String\n    $commissioningDate: Int\n    $invoiceDate: Int\n    $department: String\n    $idlingSpeed: Int\n    $invoiceNumber: String\n    $isActivated: Boolean\n    $status: Int!\n    $contractorName: String\n    $engineTorque: String\n    $engineLoad: String\n    $fuelType: String\n    $torquePower: String\n    $engineSpecification: String\n    $emissionRateType: String\n    $grossVehicleWeight: Float\n    $manufacturingYear: Int\n    $vehicleSegment: String\n    $equipmentTypeClass: String\n    $vehicleWheeler: String\n    $application: String\n    $haulageType: String\n    $constructionVehicleType: String\n    $passengerVehicleType: String\n    $transportationVehicleType: String\n    $vehicleNickName: String\n    $documentUpload: String\n    $documentUploadNew: JSON\n    $baselineDataForFE: Float\n    $baselineDataForFELPH: Float\n    $baselineDataType: String\n    $fuelTankCapacity: String\n    $adblueCapacity: String\n    $baselineDistance: Float\n    $immobilize: Boolean\n    $solutionType: String\n    $solution_type: [String]\n    $zonalManager: String\n    $keyAccountManager: String\n    $channelPartnerName: String\n    $isDualEngine: Boolean\n    $eoff_voltage: Float\n    $eon_voltage: Float\n    $hasArm: Boolean\n    $isElockConnection: Boolean\n    $duplicateVehicle: Boolean\n    $portedVehicle: Boolean\n    $isTestingVehicle: Boolean\n    $kvaRating: String\n    $dgSetType: String\n    $bhp: String\n    $phase: String\n    $engineModel: String\n    $gensetController: String\n    $videoTelematicsType: String\n    $videoTelematicsId: String\n    $inputParameter: Float\n    $multiplicationFactor: Float\n    $engineOnHours: String\n    $odometerDistance: String\n    $noOfGears: Int\n    $vehicleCustomizedBodyType: String\n    $isIndividualViewOrCombinedView: Boolean\n    $baselineHours: Int\n    $noOfWheels: Int\n    $custType: String\n    $custCode: String\n    $clientName: String\n    $vehicleClass: String\n    $fuelCode: String\n    $numberOfAxles: Int\n    $permitCode: String\n    $insurerName: String\n    $insuranceUpto: String\n    $permitType: String\n    $permitValidUpto: String\n    $permitValidFrom: String\n    $permitNumber: String\n    $permitIssueDate: String\n    $puccUpto: String\n    $registeredAt: String\n    $unladenWeight: Int\n    $manufacturingMonthYear: String\n    $taxUpto: String\n    $nationalPermitUpto: String\n    $fitmentUpto: String\n    $emissionNormsDescription: String\n    $bodyTypeDescription: String\n    $makerModel: String\n    $makerDescription: String\n    $vehicleClassDescription: String\n    $vehicleCategoryDescription: String\n    $vehicleRegistrationNumber: String\n    $registrationDate: String\n    $registrationValidUpto: String\n    $stateCode: String\n    $rtoCode: String\n    $vehicleCategoryCode: String\n    $gearRatio: String\n    $tensionerConductorLength: Float\n    $tensionerRotationSensorDirection: String\n    $isRotationSensor: Boolean\n    $technicianName: String\n    $updatedBy: String\n    $rcsSerialNumber: String\n    $istachoenabled: Boolean\n    $tachoidlerpm: Int\n    $tachoshifthours: Int\n    $tachoengineonmin: Int\n    $tachoengineonmax: Int\n  ) {\n    updateVehicleDetail(\n      entityId: $entityId\n      vehicleNumber: $vehicleNumber\n      engineNumber: $engineNumber\n      chassisNumber: $chassisNumber\n      clientLoginId: $clientLoginId\n      speedSensorType: $speedSensorType\n      speedLimit: $speedLimit\n      vehicleType: $vehicleType\n      vehicleModel: $vehicleModel\n      vehicleMake: $vehicleMake\n      vehicleModelId: $vehicleModelId\n      vehicleMakeId: $vehicleMakeId\n      vehicleCapacity: $vehicleCapacity\n      equipmentSerialNumber: $equipmentSerialNumber\n      equipmentName: $equipmentName\n      commissioningDate: $commissioningDate\n      invoiceDate: $invoiceDate\n      department: $department\n      idlingSpeed: $idlingSpeed\n      invoiceNumber: $invoiceNumber\n      isActivated: $isActivated\n      immobilize: $immobilize\n      status: $status\n      contractorName: $contractorName\n      engineTorque: $engineTorque\n      engineLoad: $engineLoad\n      fuelType: $fuelType\n      torquePower: $torquePower\n      engineSpecification: $engineSpecification\n      emissionRateType: $emissionRateType\n      engineOnHours: $engineOnHours\n      odometerDistance: $odometerDistance\n      grossVehicleWeight: $grossVehicleWeight\n      manufacturingYear: $manufacturingYear\n      vehicleSegment: $vehicleSegment\n      equipmentTypeClass: $equipmentTypeClass\n      vehicleWheeler: $vehicleWheeler\n      application: $application\n      haulageType: $haulageType\n      constructionVehicleType: $constructionVehicleType\n      passengerVehicleType: $passengerVehicleType\n      transportationVehicleType: $transportationVehicleType\n      vehicleNickName: $vehicleNickName\n      documentUpload: $documentUpload\n      documentUploadNew: $documentUploadNew\n      baselineDataForFE: $baselineDataForFE\n      baselineDataForFELPH: $baselineDataForFELPH\n      baselineDataType: $baselineDataType\n      fuelTankCapacity: $fuelTankCapacity\n      adblueCapacity: $adblueCapacity\n      baselineDistance: $baselineDistance\n      solutionType: $solutionType\n      solution_type: $solution_type\n      zonalManager: $zonalManager\n      keyAccountManager: $keyAccountManager\n      channelPartnerName: $channelPartnerName\n      isDualEngine: $isDualEngine\n      eoff_voltage: $eoff_voltage\n      eon_voltage: $eon_voltage\n      hasArm: $hasArm\n      isElockConnection: $isElockConnection\n      duplicateVehicle: $duplicateVehicle\n      portedVehicle: $portedVehicle\n      isTestingVehicle: $isTestingVehicle\n\n      kvaRating: $kvaRating\n      dgSetType: $dgSetType\n      bhp: $bhp\n      phase: $phase\n      engineModel: $engineModel\n      gensetController: $gensetController\n      videoTelematicsType: $videoTelematicsType\n      inputParameter: $inputParameter\n      multiplicationFactor: $multiplicationFactor\n      videoTelematicsId: $videoTelematicsId\n\n      rcsSerialNumber: $rcsSerialNumber\n\n      technicianName: $technicianName\n      updatedBy: $updatedBy\n\n      noOfGears: $noOfGears\n\n      vehicleCustomizedBodyType: $vehicleCustomizedBodyType\n\n      isIndividualViewOrCombinedView: $isIndividualViewOrCombinedView\n\n      baselineHours: $baselineHours\n\n      noOfWheels: $noOfWheels\n\n      custType: $custType\n\n      custCode: $custCode\n\n      clientName: $clientName\n\n      vehicleClass: $vehicleClass\n\n      fuelCode: $fuelCode\n\n      numberOfAxles: $numberOfAxles\n\n      permitCode: $permitCode\n\n      insurerName: $insurerName\n\n      insuranceUpto: $insuranceUpto\n\n      permitType: $permitType\n\n      permitValidUpto: $permitValidUpto\n\n      permitValidFrom: $permitValidFrom\n\n      permitNumber: $permitNumber\n\n      permitIssueDate: $permitIssueDate\n\n      puccUpto: $puccUpto\n\n      registeredAt: $registeredAt\n\n      unladenWeight: $unladenWeight\n\n      manufacturingMonthYear: $manufacturingMonthYear\n\n      taxUpto: $taxUpto\n\n      nationalPermitUpto: $nationalPermitUpto\n\n      fitmentUpto: $fitmentUpto\n\n      emissionNormsDescription: $emissionNormsDescription\n\n      bodyTypeDescription: $bodyTypeDescription\n\n      makerModel: $makerModel\n\n      makerDescription: $makerDescription\n\n      vehicleClassDescription: $vehicleClassDescription\n\n      vehicleCategoryDescription: $vehicleCategoryDescription\n\n      vehicleRegistrationNumber: $vehicleRegistrationNumber\n\n      registrationDate: $registrationDate\n\n      registrationValidUpto: $registrationValidUpto\n\n      stateCode: $stateCode\n\n      rtoCode: $rtoCode\n\n      vehicleCategoryCode: $vehicleCategoryCode\n\n      gearRatio: $gearRatio\n\n      tensionerConductorLength: $tensionerConductorLength\n      tensionerRotationSensorDirection: $tensionerRotationSensorDirection\n      isRotationSensor: $isRotationSensor\n      istachoenabled: $istachoenabled\n      tachoidlerpm: $tachoidlerpm\n      tachoengineonmin: $tachoengineonmin\n      tachoengineonmax: $tachoengineonmax\n      tachoshifthours: $tachoshifthours\n    )\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query getAllVehicleType {\n    getAllVehicleType {\n      vehicleTypeId\n      vehicleType\n    }\n  }\n'],['\n  query getAllVehicleType {\n    getAllVehicleType {\n      vehicleTypeId\n      vehicleType\n    }\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  query getVehicleDetail($entityId: Int) {\n    getVehicleDetail(entityId: $entityId) {\n      vehicleNumber\n      speedSensorType\n      speedLimit\n      vehicleType\n      vehicleModel\n      vehicleMake\n      vehicleCapacity\n      engineNumber\n      chassisNumber\n      status\n      equipmentSerialNumber\n      commissioningDate\n      invoiceNumber\n      invoiceDate\n      idlingSpeed\n      department\n      contractorName\n      equipmentName\n      certificatePath\n      client {\n        id\n        clientName\n        contactPerson\n        address\n        city\n        email\n        contactNumber\n        loginId\n      }\n      device {\n        serial_num\n        imei_num\n        uniqueDeviceId\n        deviceModelId {\n          model_name\n          devicetype\n        }\n      }\n      sim {\n        id\n        phoneNumber\n        simNumber\n        serviceProvider {\n          name\n        }\n      }\n      engineTorque\n      engineLoad\n      fuelType\n      torquePower\n      engineSpecification\n      emissionRateType\n      engineOnHours\n      odometerDistance\n      grossVehicleWeight\n      manufacturingYear\n      vehicleSegment\n      equipmentTypeClass\n      vehicleWheeler\n      application\n      documentUpload\n      documentUploadNew\n      baselineDataForFE\n      fuelTankCapacity\n      adblueCapacity\n\n      vehicleModelId\n      vehicleMakeId\n\n      baselineDistance\n      immobilize\n      solutionType\n      solution_type\n      zonalManager\n      keyAccountManager\n      channelPartnerName\n      isDualEngine\n      eoff_voltage\n      eon_voltage\n      isDuplicated\n      portedVehicle\n      isTestingVehicle\n      hasArm\n      isElockConnection\n\n      kvaRating\n      dgSetType\n      bhp\n      phase\n      engineModel\n      gensetController\n      videoTelematicsType\n      videoTelematicsId\n      rcsSerialNumber\n      inputParameter\n      multiplicationFactor\n      createdAt\n      updatedAt\n      activatedAt\n      constructionVehicleType\n      passengerVehicleType\n      transportationVehicleType\n      vehicleNickName\n      haulageType\n      baselineDataForFELPH\n      baselineDataType\n      noOfGears\n      gearRatio\n      vehicleRegistrationNumber\n      registrationDate\n      registrationValidUpto\n      stateCode\n      rtoCode\n      vehicleCategoryCode\n      vehicleCategoryDescription\n      vehicleClassDescription\n      makerDescription\n      makerModel\n      bodyTypeDescription\n      emissionNormsDescription\n      fitmentUpto\n      nationalPermitUpto\n      taxUpto\n      insurerName\n      insuranceUpto\n      manufacturingMonthYear\n      unladenWeight\n      registeredAt\n      puccUpto\n      permitNumber\n      permitIssueDate\n      permitValidFrom\n      permitValidUpto\n      permitType\n      permitCode\n      numberOfAxles\n      fuelCode\n      vehicleClass\n      clientName\n      custCode\n      custType\n      noOfWheels\n      baselineHours\n      isIndividualViewOrCombinedView\n      vehicleCustomizedBodyType\n      kvaRating\n      dgSetType\n      bhp\n      phase\n      engineModel\n      gensetController\n      videoTelematicsType\n      videoTelematicsId\n      engineOnHours\n      odometerDistance\n      tensionerConductorLength\n      tensionerRotationSensorDirection\n      isRotationSensor\n      istachoenabled\n      tachoidlerpm\n      tachoshifthours\n      tachoengineonmin\n      tachoengineonmax\n    }\n  }\n'],['\n  query getVehicleDetail($entityId: Int) {\n    getVehicleDetail(entityId: $entityId) {\n      vehicleNumber\n      speedSensorType\n      speedLimit\n      vehicleType\n      vehicleModel\n      vehicleMake\n      vehicleCapacity\n      engineNumber\n      chassisNumber\n      status\n      equipmentSerialNumber\n      commissioningDate\n      invoiceNumber\n      invoiceDate\n      idlingSpeed\n      department\n      contractorName\n      equipmentName\n      certificatePath\n      client {\n        id\n        clientName\n        contactPerson\n        address\n        city\n        email\n        contactNumber\n        loginId\n      }\n      device {\n        serial_num\n        imei_num\n        uniqueDeviceId\n        deviceModelId {\n          model_name\n          devicetype\n        }\n      }\n      sim {\n        id\n        phoneNumber\n        simNumber\n        serviceProvider {\n          name\n        }\n      }\n      engineTorque\n      engineLoad\n      fuelType\n      torquePower\n      engineSpecification\n      emissionRateType\n      engineOnHours\n      odometerDistance\n      grossVehicleWeight\n      manufacturingYear\n      vehicleSegment\n      equipmentTypeClass\n      vehicleWheeler\n      application\n      documentUpload\n      documentUploadNew\n      baselineDataForFE\n      fuelTankCapacity\n      adblueCapacity\n\n      vehicleModelId\n      vehicleMakeId\n\n      baselineDistance\n      immobilize\n      solutionType\n      solution_type\n      zonalManager\n      keyAccountManager\n      channelPartnerName\n      isDualEngine\n      eoff_voltage\n      eon_voltage\n      isDuplicated\n      portedVehicle\n      isTestingVehicle\n      hasArm\n      isElockConnection\n\n      kvaRating\n      dgSetType\n      bhp\n      phase\n      engineModel\n      gensetController\n      videoTelematicsType\n      videoTelematicsId\n      rcsSerialNumber\n      inputParameter\n      multiplicationFactor\n      createdAt\n      updatedAt\n      activatedAt\n      constructionVehicleType\n      passengerVehicleType\n      transportationVehicleType\n      vehicleNickName\n      haulageType\n      baselineDataForFELPH\n      baselineDataType\n      noOfGears\n      gearRatio\n      vehicleRegistrationNumber\n      registrationDate\n      registrationValidUpto\n      stateCode\n      rtoCode\n      vehicleCategoryCode\n      vehicleCategoryDescription\n      vehicleClassDescription\n      makerDescription\n      makerModel\n      bodyTypeDescription\n      emissionNormsDescription\n      fitmentUpto\n      nationalPermitUpto\n      taxUpto\n      insurerName\n      insuranceUpto\n      manufacturingMonthYear\n      unladenWeight\n      registeredAt\n      puccUpto\n      permitNumber\n      permitIssueDate\n      permitValidFrom\n      permitValidUpto\n      permitType\n      permitCode\n      numberOfAxles\n      fuelCode\n      vehicleClass\n      clientName\n      custCode\n      custType\n      noOfWheels\n      baselineHours\n      isIndividualViewOrCombinedView\n      vehicleCustomizedBodyType\n      kvaRating\n      dgSetType\n      bhp\n      phase\n      engineModel\n      gensetController\n      videoTelematicsType\n      videoTelematicsId\n      engineOnHours\n      odometerDistance\n      tensionerConductorLength\n      tensionerRotationSensorDirection\n      isRotationSensor\n      istachoenabled\n      tachoidlerpm\n      tachoshifthours\n      tachoengineonmin\n      tachoengineonmax\n    }\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  query generatePDF($entityId: Int!) {\n    generatePDF(entityId: $entityId) {\n      bucketName\n      filename\n      filePublicDownloadURL\n    }\n  }\n'],['\n  query generatePDF($entityId: Int!) {\n    generatePDF(entityId: $entityId) {\n      bucketName\n      filename\n      filePublicDownloadURL\n    }\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  query sendVehicleCertificate($email: String, $pdfLink: String) {\n    sendVehicleCertificate(email: $email, pdfLink: $pdfLink)\n  }\n'],['\n  query sendVehicleCertificate($email: String, $pdfLink: String) {\n    sendVehicleCertificate(email: $email, pdfLink: $pdfLink)\n  }\n']),_templateObject8=_taggedTemplateLiteral(['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n'],['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n']),_templateObject9=_taggedTemplateLiteral(['\n  query {\n    getVehicleMakes {\n      make\n      id\n    }\n  }\n'],['\n  query {\n    getVehicleMakes {\n      make\n      id\n    }\n  }\n']),_templateObject10=_taggedTemplateLiteral(['\n  query GetDgSpecsDetails {\n    getDgSpecsDetails {\n      id\n      kvaRating\n      phase\n    }\n  }\n'],['\n  query GetDgSpecsDetails {\n    getDgSpecsDetails {\n      id\n      kvaRating\n      phase\n    }\n  }\n']),_templateObject11=_taggedTemplateLiteral(['\n  query GetDgMakes {\n    getDgMakes\n  }\n'],['\n  query GetDgMakes {\n    getDgMakes\n  }\n']),_templateObject12=_taggedTemplateLiteral(['\n  query GetDgModels($make: String!) {\n    getDgModels(make: $make)\n  }\n'],['\n  query GetDgModels($make: String!) {\n    getDgModels(make: $make)\n  }\n']),_templateObject13=_taggedTemplateLiteral(['\n  query GetDgSpecsFromModel($make: String!, $model: String!) {\n    getDgspecsFromModel(make: $make, model: $model) {\n      id\n      make\n      model\n      kvaRating\n      dgSetType\n    }\n  }\n'],['\n  query GetDgSpecsFromModel($make: String!, $model: String!) {\n    getDgspecsFromModel(make: $make, model: $model) {\n      id\n      make\n      model\n      kvaRating\n      dgSetType\n    }\n  }\n']),_templateObject14=_taggedTemplateLiteral(['\n  query GetVehicleModels($makeId: String!) {\n    getVehicleModels(makeId: $makeId) {\n      id\n      model\n    }\n  }\n'],['\n  query GetVehicleModels($makeId: String!) {\n    getVehicleModels(makeId: $makeId) {\n      id\n      model\n    }\n  }\n']),_templateObject15=_taggedTemplateLiteral(['\n  query GetVehicleParameters($modelId: String!) {\n    getVehicleParameters(modelId: $modelId) {\n      id\n      emission_type\n      status\n      model_id\n      fuel_capacity\n      adblue_capacity\n      manufacturing_year\n      fuel_type\n      gross_vehicle_weight\n      engine_specification\n    }\n  }\n'],['\n  query GetVehicleParameters($modelId: String!) {\n    getVehicleParameters(modelId: $modelId) {\n      id\n      emission_type\n      status\n      model_id\n      fuel_capacity\n      adblue_capacity\n      manufacturing_year\n      fuel_type\n      gross_vehicle_weight\n      engine_specification\n    }\n  }\n']),_templateObject16=_taggedTemplateLiteral(['\n  query {\n    getMakeAndModelMasterData {\n      vehicleMake\n      vehicleModel\n      emissionRateType\n    }\n  }\n'],['\n  query {\n    getMakeAndModelMasterData {\n      vehicleMake\n      vehicleModel\n      emissionRateType\n    }\n  }\n']),_templateObject17=_taggedTemplateLiteral(['\n  query getAllPartnerSubscriptions(\n    $partnerId: Int\n    $deviceModelId: Int\n    $status: [Int]\n  ) {\n    getAllPartnerSubscriptions(\n      partnerLoginId: $partnerId\n      deviceModelId: $deviceModelId\n      status: $status\n    ) {\n      id\n      deviceTrackingCharges\n      totalSoftwareQty\n    }\n  }\n'],['\n  query getAllPartnerSubscriptions(\n    $partnerId: Int\n    $deviceModelId: Int\n    $status: [Int]\n  ) {\n    getAllPartnerSubscriptions(\n      partnerLoginId: $partnerId\n      deviceModelId: $deviceModelId\n      status: $status\n    ) {\n      id\n      deviceTrackingCharges\n      totalSoftwareQty\n    }\n  }\n']),_templateObject18=_taggedTemplateLiteral(['\n  query clientDetail($clientId: Int!) {\n    clientDetail(loginId: $clientId) {\n      clientName\n      address\n      city\n    }\n  }\n'],['\n  query clientDetail($clientId: Int!) {\n    clientDetail(loginId: $clientId) {\n      clientName\n      address\n      city\n    }\n  }\n']),_templateObject19=_taggedTemplateLiteral(['\n  query getAdminUserDetailsByRole($roleName: [String]) {\n    getAdminUserDetailsByRole(roleName: $roleName) {\n      id\n      username\n      role\n    }\n  }\n'],['\n  query getAdminUserDetailsByRole($roleName: [String]) {\n    getAdminUserDetailsByRole(roleName: $roleName) {\n      id\n      username\n      role\n    }\n  }\n']),_templateObject20=_taggedTemplateLiteral(['\n  query GetVehicleVahaanDetails($vehicleNumber: String!) {\n    getVehicleVahaanDetails(vehicleNumber: $vehicleNumber) {\n      id\n      rcRegnNo\n      rcRegnDt\n      rcRegnUpto\n      rcPurchaseDt\n      rcOwnerSr\n      rcOwnerName\n      stateCd\n      rtoCd\n      rcPresentAddress\n      rcPermanentAddress\n      rcVchCatg\n      rcVhClassDesc\n      rcChasiNo\n      rcEngNo\n      rcMakerDesc\n      rcMakerModel\n      rcBodyTypeDesc\n      rcFuelDesc\n      rcColor\n      rcNormsDesc\n      rcFitUpto\n      rcNpUpto\n      rcNpIssuedBy\n      rcTaxUpto\n      rcFinancer\n      rcInsuranceComp\n      rcInsurancePolicyNo\n      rcInsuranceUpto\n      rcManuMonthYr\n      rcUnldWt\n      rcGvw\n      rcNoCyl\n      rcCubicCap\n      rcSeatCap\n      rcSleeperCap\n      rcStandCap\n      rcWheelbase\n      rcRegisteredAt\n      rcStatusAsOn\n      rcPuccUpto\n      rcPuccNo\n      rcStatus\n      rcNcrbStatus\n      rcBlacklistStatus\n      rcPermitNo\n      rcPermitIssueDt\n      rcPermitValidFrom\n      rcPermitValidUpto\n      rcPermitType\n      rcPermitCode\n      rcNocDetails\n      rcVhType\n      rcVhClass\n      rcNocDt\n      rcFuelCd\n      rcMakerCd\n      rcModelCd\n      rcNormsCd\n      rcSaleAmt\n      rcOwnCatgDesc\n      rcVchCatgDesc\n      rcOwnerCdDesc\n      rcCurrentaddDistrictcode\n      rcNonUse\n      rcPassengerTax\n      rcGoodsTax\n      rcNoOfAxle\n      rcApprovalDate\n      rcHp\n      rcMandalDesc\n      rcTalukCd\n    }\n  }\n'],['\n  query GetVehicleVahaanDetails($vehicleNumber: String!) {\n    getVehicleVahaanDetails(vehicleNumber: $vehicleNumber) {\n      id\n      rcRegnNo\n      rcRegnDt\n      rcRegnUpto\n      rcPurchaseDt\n      rcOwnerSr\n      rcOwnerName\n      stateCd\n      rtoCd\n      rcPresentAddress\n      rcPermanentAddress\n      rcVchCatg\n      rcVhClassDesc\n      rcChasiNo\n      rcEngNo\n      rcMakerDesc\n      rcMakerModel\n      rcBodyTypeDesc\n      rcFuelDesc\n      rcColor\n      rcNormsDesc\n      rcFitUpto\n      rcNpUpto\n      rcNpIssuedBy\n      rcTaxUpto\n      rcFinancer\n      rcInsuranceComp\n      rcInsurancePolicyNo\n      rcInsuranceUpto\n      rcManuMonthYr\n      rcUnldWt\n      rcGvw\n      rcNoCyl\n      rcCubicCap\n      rcSeatCap\n      rcSleeperCap\n      rcStandCap\n      rcWheelbase\n      rcRegisteredAt\n      rcStatusAsOn\n      rcPuccUpto\n      rcPuccNo\n      rcStatus\n      rcNcrbStatus\n      rcBlacklistStatus\n      rcPermitNo\n      rcPermitIssueDt\n      rcPermitValidFrom\n      rcPermitValidUpto\n      rcPermitType\n      rcPermitCode\n      rcNocDetails\n      rcVhType\n      rcVhClass\n      rcNocDt\n      rcFuelCd\n      rcMakerCd\n      rcModelCd\n      rcNormsCd\n      rcSaleAmt\n      rcOwnCatgDesc\n      rcVchCatgDesc\n      rcOwnerCdDesc\n      rcCurrentaddDistrictcode\n      rcNonUse\n      rcPassengerTax\n      rcGoodsTax\n      rcNoOfAxle\n      rcApprovalDate\n      rcHp\n      rcMandalDesc\n      rcTalukCd\n    }\n  }\n']),_templateObject21=_taggedTemplateLiteral(['\n  query GetAllAssignedRoles {\n    getAllAssignedRoles {\n      id\n      uuid\n      username\n      email\n      mobile_number\n      role\n      client_ids\n      createdAt\n      updatedAt\n    }\n  }\n'],['\n  query GetAllAssignedRoles {\n    getAllAssignedRoles {\n      id\n      uuid\n      username\n      email\n      mobile_number\n      role\n      client_ids\n      createdAt\n      updatedAt\n    }\n  }\n']),_templateObject22=_taggedTemplateLiteral(['\n  query Query {\n    getDropDownDetail\n  }\n'],['\n  query Query {\n    getDropDownDetail\n  }\n']),_templateObject23=_taggedTemplateLiteral(['\n  query GetAllMasterSolutionType {\n    getAllMasterSolutionType {\n      id\n      solutionTypeName\n    }\n  }\n'],['\n  query GetAllMasterSolutionType {\n    getAllMasterSolutionType {\n      id\n      solutionTypeName\n    }\n  }\n']),_templateObject24=_taggedTemplateLiteral(['\n  query GetCustomerTypeAndCode($clientName: String!) {\n    getCustomerTypeAndCode(clientName: $clientName) {\n      id\n      clientName\n      registrationType\n      directCustomerSAPCode\n      channelPartnerSAPCode\n    }\n  }\n'],['\n  query GetCustomerTypeAndCode($clientName: String!) {\n    getCustomerTypeAndCode(clientName: $clientName) {\n      id\n      clientName\n      registrationType\n      directCustomerSAPCode\n      channelPartnerSAPCode\n    }\n  }\n']),_templateObject25=_taggedTemplateLiteral(['\n  query GetDashcamRegistrations {\n    getDashcamRegistrations {\n      success\n      message\n      data {\n        uuid\n        simid\n        memorycardid\n        uniqueid\n        vtid\n        status\n        createdat\n        updatedat\n      }\n    }\n  }\n'],['\n  query GetDashcamRegistrations {\n    getDashcamRegistrations {\n      success\n      message\n      data {\n        uuid\n        simid\n        memorycardid\n        uniqueid\n        vtid\n        status\n        createdat\n        updatedat\n      }\n    }\n  }\n']),_templateObject26=_taggedTemplateLiteral(['\n                query GetReverseCameraAndScreenInventory {\n                  getReverseCameraAndScreenInventory {\n                    data {\n                      rcs_serial_number\n                    }\n                  }\n                }\n              '],['\n                query GetReverseCameraAndScreenInventory {\n                  getReverseCameraAndScreenInventory {\n                    data {\n                      rcs_serial_number\n                    }\n                  }\n                }\n              ']);function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// import SwapHoriz from '@material-ui/icons/SwapHoriz'
var GET_UPLOAD_URL=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject);var SolutionTypeOption=function SolutionTypeOption(props){var onSelect=props.onSelect,onFocus=props.onFocus,isSelected=props.isSelected,option=props.option,children=props.children,className=props.className;var handleMouseDown=function handleMouseDown(event){event.preventDefault();event.stopPropagation();onSelect(option,event);};var handleMouseEnter=function handleMouseEnter(event){onFocus(option,event);};return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:className,onMouseDown:handleMouseDown,onMouseEnter:handleMouseEnter,onMouseMove:handleMouseEnter,title:option.title,style:{display:'flex',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Checkbox___default.a,{checked:!!isSelected,color:'primary'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,children));};var GET_VLPN=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject2);/* eslint-disable */// calling server for updation
var UPDATE_VEHICLE=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject3);var GET_VEHICLE_TYPE=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject4);var GET_VEHICLE_DETAIL=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject5);// portedVehicle
// isTestingVehicle
var GENERATE_CERTIFICATE=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject6);var SEND_MAIL=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject7);var GET_FILE_FORMAT=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject8);// const DOWNLOAD_FILE = gql`
//   query getMinioFileURL($bucketName: String!, $fileName: String!) {
//     getMinioFileURL(bucketName: $bucketName, fileName: $fileName) {
//       url
//     }
//   }
// `
// const UPDATE_VEHICLE_STATUS = gql`
//   mutation addDeviceService(
//     $uniqueDeviceId: String!
//     $isActivated: Boolean!
//   ) {
//     addDeviceService(
//       uniqueDeviceId: $uniqueDeviceId
//       isActivated: $isActivated
//     )
//   }
// `
var GET_VEHICLE_MAKES=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject9);var GET_DG_SPECS=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject10);var GET_ALL_DG_MAKES=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject11);var GET_DG_MODELS=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject12);var GET_DG_SPECS_FROM_MODEL=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject13);var GET_VEHICLE_MODELS=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject14);var GET_VEHICLE_PARAMS=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject15);var GET_MAKE_AND_MODELS_MASTER=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject16);var GET_SUBSCRIPTION_BY_PARTNERID=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject17);var GET_CLIENT_DETAILS_BYID=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject18);var GET_ZMKAM=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject19);var GET_VEHICLE_VAHAAN_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject20);var GET_ALL_ASSIGNED_ROLES=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject21);var GET_DROPDOWN_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject22);var GET_SOLUTION_TYPES=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject23);var GET_CUSTOMER_TYPE_AND_CODE=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject24);var GET_DASHCAM_REGISTRATIONS=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject25);var styles=function styles(theme){return{root:{padding:theme.spacing.unit*4,flexGrow:1},textField:{marginLeft:theme.spacing.unit,marginRight:theme.spacing.unit,width:'200px'},container:{display:'flex',flexWrap:'wrap'},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},iconSmall:{fontSize:20}};};var allEmissionRateType=[{label:'BS3',value:'BS3'},{label:'BS4',value:'BS4'},{label:'BS6',value:'BS6'}];var VehicleRegistration=function(_Component){_inherits(VehicleRegistration,_Component);function VehicleRegistration(props){var _this2=this,_this$state4;_classCallCheck(this,VehicleRegistration);var _this=_possibleConstructorReturn(this,(VehicleRegistration.__proto__||Object.getPrototypeOf(VehicleRegistration)).call(this,props));_this._isMounted=false;_this.clearDate=function(){_this.setState({commissioningDate:{date:null,unix:__WEBPACK_IMPORTED_MODULE_41_moment___default()().unix().toString()}});};_this.handleChangeIdlingSpeed=function(event){if(event){_this.setState({idlingSpeed:event.value});}else{_this.setState({idlingSpeed:3});}};_this.handleToggleChange=function(event){_this.setState({throughChannelPartner:event.target.checked});};_this.handleDateChange=function(name){return function(date){var tempDate=_this.state[name];tempDate.date=date;tempDate.unix=__WEBPACK_IMPORTED_MODULE_41_moment___default()(date).unix().toString();_this.setState(_defineProperty({},name,tempDate));};};_this.getVehicleType=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _ref2,data,vehicleTypes;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.client.query({query:GET_VEHICLE_TYPE// fetchPolicy: 'network-only'
});case 2:_ref2=_context.sent;data=_ref2.data;vehicleTypes=data.getAllVehicleType.map(function(item){return item.vehicleType;});_this.setState({vehicleTypes:vehicleTypes});case 6:case'end':return _context.stop();}}},_callee,_this2);}));_this.getVehicleDetails=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var _ref4,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this.props.client.query({query:GET_VEHICLE_DETAIL,variables:{entityId:parseInt(_this.entityId,10)// fetchPolicy: 'network-only'
}});case 2:_ref4=_context2.sent;data=_ref4.data;_this.setDetails(data.getVehicleDetail);_this.fetchCustomerTypeAndCode();case 6:case'end':return _context2.stop();}}},_callee2,_this2);}));_this.getFormattedDate=function(timestamp){return __WEBPACK_IMPORTED_MODULE_41_moment___default()(timestamp*1000).format('MMM Do YYYY, h:mm a');};_this.getZMKAMDetails=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var zmkamDetails,zmDetails,kamDetails;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return _this.props.client.query({query:GET_ZMKAM,variables:{roleName:['Zonal Manager(ZM)','Key Account Manager(KAM)']// fetchPolicy: 'network-only'
}});case 2:zmkamDetails=_context3.sent;zmDetails=zmkamDetails.data.getAdminUserDetailsByRole.filter(function(user){return user.role==='Zonal Manager(ZM)';}).map(function(user){return{value:user.id,label:user.username};});kamDetails=zmkamDetails.data.getAdminUserDetailsByRole.filter(function(user){return user.role==='Key Account Manager(KAM)';}).map(function(user){return{value:user.id,label:user.username};});_this.setState({zmDetails:zmDetails,kamDetails:kamDetails});case 6:case'end':return _context3.stop();}}},_callee3,_this2);}));_this.getAllAssignedRoles=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){var _ref7,data,taabiList,freelancerList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.prev=0;_context4.next=3;return _this.props.client.query({query:GET_ALL_ASSIGNED_ROLES,fetchPolicy:'network-only'});case 3:_ref7=_context4.sent;data=_ref7.data;if(data&&data.getAllAssignedRoles){taabiList=data.getAllAssignedRoles.filter(function(u){return u.role==='Technician - Taabi Personal';}).map(function(u){return{label:u.username||u.email||u.uuid,value:u.username||u.uuid};});freelancerList=data.getAllAssignedRoles.filter(function(u){return u.role==='Technician - Freelancer';}).map(function(u){return{label:u.mobile_number||u.username||u.uuid,value:u.mobile_number||u.uuid};});_this.setState({assignedTechniciansTaabi:taabiList,assignedTechniciansFreelancer:freelancerList},function(){// If a technicianName was passed via navigation state, initialize selection now
var propTech=_this.props.location&&_this.props.location.state&&_this.props.location.state.technicianName;if(propTech){_this.initializeTechnicianFromValue(propTech);}});}_context4.next=11;break;case 8:_context4.prev=8;_context4.t0=_context4['catch'](0);console.error('Error fetching assigned roles',_context4.t0);case 11:case'end':return _context4.stop();}}},_callee4,_this2,[[0,8]]);}));_this.initializeTechnicianFromValue=function(value){if(!value)return;var isNumeric=/^\d+$/.test(String(value));var category=isNumeric?'Technician - Freelancer':'Technician - Taabi Personal';// set basic fields
_this.setState({technicianCategory:category,technicianName:value});// attempt to set the selected option from the already-fetched lists
if(category==='Technician - Taabi Personal'){var opt=_this.state.assignedTechniciansTaabi.find(function(o){return String(o.value)===String(value);});if(opt)_this.setState({selectedTaabiTechnician:opt});}else{var _opt=_this.state.assignedTechniciansFreelancer.find(function(o){return String(o.value)===String(value);});if(_opt)_this.setState({selectedFreelancerTechnician:_opt});}};_this.handleTechnicianCategoryChange=function(option){var category=option&&option.value?option.value:null;_this.setState({technicianCategory:category,selectedTaabiTechnician:null,selectedFreelancerTechnician:null,technicianName:''});};_this.handleTaabiSelectChange=function(option){_this.setState({selectedTaabiTechnician:option,technicianName:option?option.value:''});};_this.handleFreelancerSelectChange=function(option){_this.setState({selectedFreelancerTechnician:option,technicianName:option?option.value:''});};_this.getDashcamRegistrations=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(){var _ref9,data,registrations,vtidOptions;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_this.setState({dashcamRegistrationsLoading:true});// Set specific loading state
_context5.prev=1;_context5.next=4;return _this.props.client.query({query:GET_DASHCAM_REGISTRATIONS,fetchPolicy:'network-only'});case 4:_ref9=_context5.sent;data=_ref9.data;if(data.getDashcamRegistrations.success){// Keep the full set of registrations (including non-available) so we can
// still show the originalVtid in edit mode even if its status isn't
// 'available'. The SelectReact options will later filter to show only
// available ones or the originalVtid.
registrations=data.getDashcamRegistrations.data;vtidOptions=registrations.map(function(item){return{value:item.vtid,label:item.vtid,simid:item.simid,memorycardid:item.memorycardid,status:item.status};});_this.setState({dashcamRegistrations:registrations,vtidOptions:vtidOptions,dashcamRegistrationsLoading:false});}else{_this.setState({dashcamRegistrationsLoading:false});}_context5.next=13;break;case 9:_context5.prev=9;_context5.t0=_context5['catch'](1);console.error('Error fetching dashcam registrations:',_context5.t0);_this.setState({dashcamRegistrationsLoading:false});case 13:case'end':return _context5.stop();}}},_callee5,_this2,[[1,9]]);}));_this.handleVtidChange=function(selectedOption){if(selectedOption&&selectedOption.value){_this.setState({selectedVtid:selectedOption,selectedSimId:selectedOption.simid,selectedMemoryCardId:selectedOption.memorycardid,videoTelematicsId:selectedOption.value});}else{_this.setState({selectedVtid:null,selectedSimId:null,selectedMemoryCardId:null,videoTelematicsId:null});}};_this.handleChangeInputParameter=function(event){var value=event.target.value;_this.setState({inputParameter:value?parseFloat(value):null});};_this.handleChangeMultiplicationFactor=function(event){var value=event.target.value;_this.setState({multiplicationFactor:value?parseFloat(value):null});};_this.handleChangeAccessories=function(event){if(!event){_this.setState({accessories:''});}else{_this.setState({accessories:event.value});}};_this.handleChangeSubscription=function(event){if(!event){_this.setState({subscriptionId:''});}else{_this.setState({subscriptionId:event.value});}};_this.setDetails=function(vehicleDetail){var _this$setState2;if(!vehicleDetail)return;var commissioningDate={date:null,unix:__WEBPACK_IMPORTED_MODULE_41_moment___default()().unix()};if(vehicleDetail.commissioningDate){commissioningDate={date:__WEBPACK_IMPORTED_MODULE_41_moment___default.a.unix(vehicleDetail.commissioningDate).format('YYYY-MM-DD'),unix:vehicleDetail.commissioningDate};}var invoiceDate={date:null,unix:__WEBPACK_IMPORTED_MODULE_41_moment___default()().unix()};if(vehicleDetail.invoiceDate){invoiceDate={date:__WEBPACK_IMPORTED_MODULE_41_moment___default.a.unix(vehicleDetail.invoiceDate).format('YYYY-MM-DD'),unix:vehicleDetail.invoiceDate};}if(_this.state.makeModelsMainList){var filtertedModels=_this.state.makeModelsMainList.filter(function(item){if(item.vehicleMake==vehicleDetail.vehicleMake)return item.vehicleModel;});var allModels=filtertedModels.map(function(item){return{value:item.vehicleModel,label:item.vehicleModel};});_this.setState({modelsList:allModels});}var fuelType=vehicleDetail.fuelType?vehicleDetail.fuelType:'';// Normalize to lowercase so it matches the fuel-type option values
// (petrol, diesel, ev, cng, lng) regardless of the casing the API returns.
fuelType=fuelType?fuelType.toLowerCase():'';var isArmVal=false;if(vehicleDetail.hasArm){isArmVal=vehicleDetail.hasArm?vehicleDetail.hasArm:false;}var isElock=false;if(vehicleDetail.isElockConnection){isElock=vehicleDetail.isElockConnection?vehicleDetail.isElockConnection:false;}var kvaRatingVal='';var dgSetTypeVal='';var bhpVal='';var phaseVal='';var engineModelVal='';var gensetControllerVal='';if(vehicleDetail.kvaRating){kvaRatingVal=vehicleDetail.kvaRating;}if(vehicleDetail.dgSetType){dgSetTypeVal=vehicleDetail.dgSetType;}if(vehicleDetail.bhp){bhpVal=vehicleDetail.bhp;}if(vehicleDetail.phase){phaseVal=vehicleDetail.phase;}if(vehicleDetail.engineModel){engineModelVal=vehicleDetail.engineModel;}if(vehicleDetail.gensetController){gensetControllerVal=vehicleDetail.gensetController;}// console.log(this.state.portedVehicle, 'ported Vehicle1')
_this.setState((_this$setState2={vehicleDetails:vehicleDetail,address:vehicleDetail.client.address,city:vehicleDetail.client.city,clientName:vehicleDetail.client.clientName,contactPerson:vehicleDetail.client.contactPerson,email:vehicleDetail.client.email,id:vehicleDetail.client.id,contactNumber:vehicleDetail.client.contactNumber,existingVehicleNumber:vehicleDetail.vehicleNumber,vlpn:vehicleDetail.vehicleNumber,speedSensor:vehicleDetail.speedSensorType,speedLimit:vehicleDetail.speedLimit,vehicleType:vehicleDetail.vehicleType,vehicleModel:vehicleDetail.vehicleModel,vehicleMake:vehicleDetail.vehicleMake,// vehicleMakeId: vehicleDetail.vehicleMakeId,
vehicleMakeId:vehicleDetail.vehicleSegment=='DG Set'?vehicleDetail.vehicleMake:vehicleDetail.vehicleMakeId,// vehicleModelId: vehicleDetail.vehicleModelId,
vehicleModelId:vehicleDetail.vehicleSegment=='DG Set'?vehicleDetail.vehicleModel:vehicleDetail.vehicleModelId,vehicleCapacity:vehicleDetail.vehicleCapacity,status:vehicleDetail.status,serialNumber:vehicleDetail.device.serial_num,modelName:vehicleDetail.device.deviceModelId.model_name,deviceType:vehicleDetail.device.deviceModelId.devicetype,phoneNumber:vehicleDetail.sim.phoneNumber,simProvider:vehicleDetail.sim.serviceProvider.name,simNumber:vehicleDetail.sim.simNumber,uniqueDeviceId:vehicleDetail.device.uniqueDeviceId,clientLoginId:vehicleDetail.client.loginId,engineNumber:vehicleDetail.engineNumber,chassisNumber:vehicleDetail.chassisNumber,simId:vehicleDetail.sim.id,equipmentSerialNumber:vehicleDetail.equipmentSerialNumber?vehicleDetail.equipmentSerialNumber:null,commissioningDate:commissioningDate,invoiceDate:invoiceDate,invoiceNumber:vehicleDetail.invoiceNumber?vehicleDetail.invoiceNumber:null,idlingSpeed:vehicleDetail.idlingSpeed,department:vehicleDetail.department?vehicleDetail.department:'',equipmentName:vehicleDetail.equipmentName?vehicleDetail.equipmentName:null,contractorName:vehicleDetail.contractorName?vehicleDetail.contractorName:'',engineTorque:vehicleDetail.engineTorque?vehicleDetail.engineTorque:'',engineLoad:vehicleDetail.engineLoad?vehicleDetail.engineLoad:'',fuelType:fuelType,// Seed rcFuelDesc with the saved fuel type so the dropdown reflects the
// persisted value (e.g. CNG) instead of falling back to the RC/VAHAN
// descriptor, which would otherwise mask a manually edited fuel type.
rcFuelDesc:fuelType,solutionType:vehicleDetail.solutionType?vehicleDetail.solutionType:'',solution_type:vehicleDetail.solution_type?vehicleDetail.solution_type:[],isDualEngine:vehicleDetail.isDualEngine?vehicleDetail.isDualEngine:false,// FIXED: was missing from this populate-on-load block, so the toggle always fell back to
// the constructor's default (false) after a refresh even when the saved value was true.
isIndividualViewOrCombinedView:vehicleDetail.isIndividualViewOrCombinedView?vehicleDetail.isIndividualViewOrCombinedView:false,eon_voltage:vehicleDetail.eon_voltage?vehicleDetail.eon_voltage:null,eoff_voltage:vehicleDetail.eoff_voltage?vehicleDetail.eoff_voltage:null,hasArm:isArmVal,isElockConnection:isElock,portedVehicle:vehicleDetail.portedVehicle,isTestingVehicle:vehicleDetail.isTestingVehicle,isDuplicatedDBValue:vehicleDetail.isDuplicated?vehicleDetail.isDuplicated:false,duplicateVehicle:vehicleDetail.isDuplicated?vehicleDetail.isDuplicated:false,torquePower:vehicleDetail.torquePower?vehicleDetail.torquePower:'',engineOnHours:vehicleDetail.engineOnHours?vehicleDetail.engineOnHours:'',odometerDistance:vehicleDetail.odometerDistance?vehicleDetail.odometerDistance:'',engineSpecification:vehicleDetail.engineSpecification?vehicleDetail.engineSpecification:'',emissionRateType:vehicleDetail.emissionRateType?vehicleDetail.emissionRateType:'',grossVehicleWeight:vehicleDetail.grossVehicleWeight?vehicleDetail.grossVehicleWeight:'',manufacturingYear:vehicleDetail.manufacturingYear?vehicleDetail.manufacturingYear:'',vehicleSegment:vehicleDetail.vehicleSegment?vehicleDetail.vehicleSegment:'',equipmentTypeClass:vehicleDetail.equipmentTypeClass?vehicleDetail.equipmentTypeClass:'',vehicleWheeler:vehicleDetail.vehicleWheeler?vehicleDetail.vehicleWheeler:'',selectedApplication:vehicleDetail.application?vehicleDetail.application:'',haulageType:vehicleDetail.haulageType?vehicleDetail.haulageType:'',constructionVehicleType:vehicleDetail.constructionVehicleType?vehicleDetail.constructionVehicleType:'',tensionerConductorLength:vehicleDetail.tensionerConductorLength,tensionerRotationSensorDirection:vehicleDetail.tensionerRotationSensorDirection||'',isRotationSensor:vehicleDetail.isRotationSensor?vehicleDetail.isRotationSensor:false,passengerVehicleType:vehicleDetail.passengerVehicleType?vehicleDetail.passengerVehicleType:'',transportationVehicleType:vehicleDetail.transportationVehicleType?vehicleDetail.transportationVehicleType:'',vehicleNickName:vehicleDetail.vehicleNickName?vehicleDetail.vehicleNickName:'',baselineDataForFE:vehicleDetail.baselineDataForFE?vehicleDetail.baselineDataForFE:'',baselineDistance:vehicleDetail.baselineDistance?vehicleDetail.baselineDistance:'',baselineHours:vehicleDetail.baselineHours?vehicleDetail.baselineHours:'',fuelTankCapacity:vehicleDetail.fuelTankCapacity?vehicleDetail.fuelTankCapacity:'',adblueCapacity:vehicleDetail.adblueCapacity?vehicleDetail.adblueCapacity:'',equipmentTypeClassText:vehicleDetail.equipmentTypeClassText?vehicleDetail.equipmentTypeClassText:''},_defineProperty(_this$setState2,'vehicleWheeler',vehicleDetail.vehicleWheeler?vehicleDetail.vehicleWheeler:''),_defineProperty(_this$setState2,'vehicleType',vehicleDetail.vehicleType?vehicleDetail.vehicleType:''),_defineProperty(_this$setState2,'subscriptionId',vehicleDetail.subscriptionId?vehicleDetail.subscriptionId:''),_defineProperty(_this$setState2,'immobilize',vehicleDetail.immobilize?vehicleDetail.immobilize:false),_defineProperty(_this$setState2,'zmId',vehicleDetail.zonalManager),_defineProperty(_this$setState2,'kamId',vehicleDetail.keyAccountManager),_defineProperty(_this$setState2,'channelPartnerName',vehicleDetail.channelPartnerName),_defineProperty(_this$setState2,'throughChannelPartner',vehicleDetail.channelPartnerName?true:false),_defineProperty(_this$setState2,'kvaRating',kvaRatingVal),_defineProperty(_this$setState2,'dgSetType',dgSetTypeVal),_defineProperty(_this$setState2,'bhp',bhpVal),_defineProperty(_this$setState2,'phase',phaseVal),_defineProperty(_this$setState2,'engineModel',engineModelVal),_defineProperty(_this$setState2,'gensetController',gensetControllerVal),_defineProperty(_this$setState2,'selectedVTM',vehicleDetail.videoTelematicsType?vehicleDetail.videoTelematicsType:null),_defineProperty(_this$setState2,'videoTelematicsId',vehicleDetail.videoTelematicsId?vehicleDetail.videoTelematicsId:null),_defineProperty(_this$setState2,'selectedVtid',vehicleDetail.videoTelematicsId?vehicleDetail.videoTelematicsId:null),_defineProperty(_this$setState2,'originalVtid',vehicleDetail.videoTelematicsType&&vehicleDetail.videoTelematicsType==='mettax'&&vehicleDetail.videoTelematicsId?vehicleDetail.videoTelematicsId:null),_defineProperty(_this$setState2,'inputParameter',vehicleDetail.inputParameter?vehicleDetail.inputParameter:null),_defineProperty(_this$setState2,'multiplicationFactor',vehicleDetail.multiplicationFactor?vehicleDetail.multiplicationFactor:null),_defineProperty(_this$setState2,'vehicleRegistrationNumber',vehicleDetail.vehicleRegistrationNumber?vehicleDetail.vehicleRegistrationNumber:''),_defineProperty(_this$setState2,'rcsSerialNumber',vehicleDetail.rcsSerialNumber?vehicleDetail.rcsSerialNumber:''),_defineProperty(_this$setState2,'registrationDate',vehicleDetail.registrationDate?vehicleDetail.registrationDate:''),_defineProperty(_this$setState2,'registrationValidUpto',vehicleDetail.registrationValidUpto?vehicleDetail.registrationValidUpto:''),_defineProperty(_this$setState2,'stateCode',vehicleDetail.stateCode?vehicleDetail.stateCode:''),_defineProperty(_this$setState2,'rtoCode',vehicleDetail.rtoCode?vehicleDetail.rtoCode:''),_defineProperty(_this$setState2,'vehicleCategoryCode',vehicleDetail.vehicleCategoryCode?vehicleDetail.vehicleCategoryCode:''),_defineProperty(_this$setState2,'vehicleClassDescription',vehicleDetail.vehicleClassDescription?vehicleDetail.vehicleClassDescription:''),_defineProperty(_this$setState2,'makerDescription',vehicleDetail.makerDescription?vehicleDetail.makerDescription:''),_defineProperty(_this$setState2,'makerModel',vehicleDetail.makerModel?vehicleDetail.makerModel:''),_defineProperty(_this$setState2,'bodyTypeDescription',vehicleDetail.bodyTypeDescription?vehicleDetail.bodyTypeDescription:''),_defineProperty(_this$setState2,'emissionNormsDescription',vehicleDetail.emissionNormsDescription?vehicleDetail.emissionNormsDescription:''),_defineProperty(_this$setState2,'fitmentUpto',vehicleDetail.fitmentUpto?vehicleDetail.fitmentUpto:''),_defineProperty(_this$setState2,'nationalPermitUpto',vehicleDetail.nationalPermitUpto?vehicleDetail.nationalPermitUpto:''),_defineProperty(_this$setState2,'taxUpto',vehicleDetail.taxUpto?vehicleDetail.taxUpto:''),_defineProperty(_this$setState2,'insurerName',vehicleDetail.insurerName?vehicleDetail.insurerName:''),_defineProperty(_this$setState2,'insuranceUpto',vehicleDetail.insuranceUpto?vehicleDetail.insuranceUpto:''),_defineProperty(_this$setState2,'manufacturingMonthYear',vehicleDetail.manufacturingMonthYear?vehicleDetail.manufacturingMonthYear:''),_defineProperty(_this$setState2,'unladenWeight',vehicleDetail.unladenWeight?vehicleDetail.unladenWeight:''),_defineProperty(_this$setState2,'registeredAt',vehicleDetail.registeredAt?vehicleDetail.registeredAt:''),_defineProperty(_this$setState2,'puccUpto',vehicleDetail.puccUpto?vehicleDetail.puccUpto:''),_defineProperty(_this$setState2,'permitNumber',vehicleDetail.permitNumber?vehicleDetail.permitNumber:''),_defineProperty(_this$setState2,'permitIssueDate',vehicleDetail.permitIssueDate?vehicleDetail.permitIssueDate:''),_defineProperty(_this$setState2,'permitValidFrom',vehicleDetail.permitValidFrom?vehicleDetail.permitValidFrom:''),_defineProperty(_this$setState2,'permitValidUpto',vehicleDetail.permitValidUpto?vehicleDetail.permitValidUpto:''),_defineProperty(_this$setState2,'permitType',vehicleDetail.permitType?vehicleDetail.permitType:''),_defineProperty(_this$setState2,'permitCode',vehicleDetail.permitCode?vehicleDetail.permitCode:''),_defineProperty(_this$setState2,'numberOfAxles',vehicleDetail.numberOfAxles?vehicleDetail.numberOfAxles:null),_defineProperty(_this$setState2,'fuelCode',vehicleDetail.fuelCode?vehicleDetail.fuelCode:''),_defineProperty(_this$setState2,'vehicleClass',vehicleDetail.vehicleClass?vehicleDetail.vehicleClass:''),_defineProperty(_this$setState2,'noOfWheels',vehicleDetail.noOfWheels?vehicleDetail.noOfWheels:null),_defineProperty(_this$setState2,'vehicleCustomizedBodyType',vehicleDetail.vehicleCustomizedBodyType?vehicleDetail.vehicleCustomizedBodyType:null),_defineProperty(_this$setState2,'baselineDataType',vehicleDetail.baselineDataType?vehicleDetail.baselineDataType.toLowerCase():null),_defineProperty(_this$setState2,'noOfGears',vehicleDetail.noOfGears?vehicleDetail.noOfGears:null),_defineProperty(_this$setState2,'gearRatio',vehicleDetail.gearRatio?vehicleDetail.gearRatio:null),_defineProperty(_this$setState2,'istachoenabled',vehicleDetail.istachoenabled||false),_defineProperty(_this$setState2,'tachoidlerpm',vehicleDetail.tachoidlerpm||''),_defineProperty(_this$setState2,'tachoshifthours',vehicleDetail.tachoshifthours||''),_defineProperty(_this$setState2,'tachoengineonmin',vehicleDetail.tachoengineonmin||''),_defineProperty(_this$setState2,'tachoengineonmax',vehicleDetail.tachoengineonmax||''),_this$setState2));// If technicianName was passed via navigation state, initialize category/selection
var propTech=_this.props.location&&_this.props.location.state&&_this.props.location.state.technicianName;if(propTech){// initialize but don't depend on assigned lists being available yet
var isNumeric=/^\d+$/.test(String(propTech));var category=isNumeric?'Technician - Freelancer':'Technician - Taabi Personal';_this.setState({technicianCategory:category,technicianName:propTech});}try{if(vehicleDetail.documentUpload){var documentUpload=vehicleDetail.documentUpload;var fileNames=documentUpload.split(',');var uploadProgress={};fileNames.forEach(function(fileName){uploadProgress[fileName]=100;// Set progress to 100 since these are pre-uploaded files
});var documentUploadNewData={};if(vehicleDetail.documentUploadNew&&Array.isArray(vehicleDetail.documentUploadNew)){vehicleDetail.documentUploadNew.forEach(function(doc){if(doc.fileName){documentUploadNewData[doc.fileName]={solutionType:doc.solutionType||'',label:doc.label||''};}});}_this.setState({documentUpload:documentUpload,fileNames:fileNames.join(','),uploadProgress:uploadProgress,documentUploadNewData:documentUploadNewData});}}catch(error){}try{if(_this.state.vehicleMakeId){var eventObj={label:_this.state.vehicleMake?_this.state.vehicleMake:null,value:_this.state.vehicleMakeId?_this.state.vehicleMakeId:null};_this.handleChangeMake(eventObj);}}catch(error){}try{if(_this.state.vehicleModelId){var _eventObj={label:_this.state.vehicleModel?_this.state.vehicleModel:null,value:_this.state.vehicleModelId?_this.state.vehicleModelId:null};_this.fetchModelDetails(_eventObj);}if(_this.state.vehicleMakeId&&_this.state.vehicleModelId){_this.getDgspecsFromModel(_this.state.vehicleMakeId,_this.state.vehicleModelId);}}catch(error){}if(_this.state.uniqueDeviceId){_this.fetchAllPartnerSubscriptions();}if(_this.state.vehicleSegment){_this.updateDependentFieldsBasedOnSegment(_this.state.vehicleSegment);if(_this.state.vehicleSegment=='DG Set'){_this.updateDGSetData();}}if(vehicleDetail.certificatePath){var x=vehicleDetail.certificatePath.split('/');var len=x.length;_this.setState({fileName:x[len-1]});}if(vehicleDetail.status!==2){_this.setState({installStatus:true});}if(_this.state.vehicleCapacity!==null){_this.setState({isSeatLimitValid:true,seatLimit:_this.state.vehicleCapacity});}else{_this.setState({// isSeatLimitValid: false,
seatLimit:null});}};_this.checkBaselineDistanceValidity=function(){var baselineDistance=_this.state.baselineDistance;// Consider an empty string as valid to reset validation state when input is cleared
var isValid=baselineDistance===''||/^\d+$/.test(baselineDistance)&&// Check if the input is a positive integer
parseInt(baselineDistance)>0&&parseInt(baselineDistance)<=2000000;_this.setState({isBaselineDistanceValid:isValid});};_this.checkBaselineHoursValidity=function(){var baselineHours=_this.state.baselineHours;// Consider an empty string as valid to reset validation state when input is cleared
var isValid=baselineHours===''||/\d+/.test(baselineHours)&&// Check if the input contains at least one digit
/^\d+$/.test(baselineHours)&&// Check if the input is a positive integer
parseInt(baselineHours)>0&&parseInt(baselineHours)<=24;_this.setState({isBaselineHoursValid:isValid});};_this.checkeoff_voltageValidity=function(){var regex=new RegExp(/^\d+(\.\d{1,2})?$/);// Allows any number of digits with optional decimal
_this.setState({iseoff_voltageValid:regex.test(_this.state.eoff_voltage)||_this.state.eoff_voltage===''});};_this.checkeon_voltageValidity=function(){var regex=new RegExp(/^\d+(\.\d{1,2})?$/);// Same pattern for eon voltage
_this.setState({iseon_voltageValid:regex.test(_this.state.eon_voltage)||_this.state.eon_voltage===''});};_this.checkBaselineDataForFEValidity=function(){var baselineDataForFE=_this.state.baselineDataForFE;// Consider an empty string as valid to reset validation state when input is cleared
var isValid=baselineDataForFE===''||!isNaN(parseFloat(baselineDataForFE))&&parseFloat(baselineDataForFE)>=0.5&&parseFloat(baselineDataForFE)<=20&&/^(\d+(\.\d{0,2})?|\.?\d{1,2})$/.test(baselineDataForFE);_this.setState({isBaselineDataForFEValid:isValid});};_this.updateDependentFieldsBasedOnSegment=function(selectedSegment){// Reset options first
_this.setState({equipmentTypeClassOptions:[],vehicleWheelerOptions:[],applicationOptions:[]});if(selectedSegment==='Transportation'){_this.setState({equipmentTypeClassOptions:['M&HCV','LM','PC','2W','3W','LCV'].map(function(value){return{value:value,label:value};}),vehicleWheelerOptions:['6W','10W','12W','14W','16W','18W','22W','22W+'].map(function(value){return{value:value,label:value};}),applicationOptions:['E-Com','Cement','General Goods','Dumper','Trailers (Flat Bed)','Buses','Automobile Carrier','Tipper'].map(function(value){return{value:value,label:value};})});}else if(selectedSegment==='Construction'){_this.setState({equipmentTypeClassOptions:['Excavator','Crane','Gantry','Grader'].map(function(value){return{value:value,label:value};})});}else if(selectedSegment==='EVs'){// Handle EVs segment with a free text input
_this.setState({equipmentTypeClassText:''// Reset or handle as needed
});}// Add additional conditions for other segments if necessary
};_this.handleSegmentChange=function(option){try{if(option.value){_this.setState({vehicleSegment:option.value},function(){_this.updateDependentFieldsBasedOnSegment(option.value);});}else{_this.setState({vehicleSegment:''},function(){_this.updateDependentFieldsBasedOnSegment('');});}}catch(error){_this.setState({vehicleSegment:''},function(){_this.updateDependentFieldsBasedOnSegment('');});}setTimeout(function(){if(_this.state.vehicleSegment=='DG Set'){_this.updateDGSetData();}},500);if(_this.state.vehicleSegment=='DG Set'){_this.setState({vehicleRegistrationNumberAvailableStatus:false,enteredVehicleRegistrationNumber:''});_this.flushVahaanValues();}};_this.handleEquipmentTypeClassTextChange=function(event){_this.setState({equipmentTypeClassText:event.target.value});};_this.handleVideoTelematicsMenuChange=function(selectedOption){if(selectedOption&&selectedOption.value){_this.setState({selectedVTM:selectedOption.value,selectedVtid:null,selectedSimId:null,selectedMemoryCardId:null,videoTelematicsId:''});}else{_this.setState({selectedVTM:null,selectedVtid:null,selectedSimId:null,selectedMemoryCardId:null,videoTelematicsId:''});}};_this.handleVideoTelematicsIdChange=function(event){_this.setState({videoTelematicsId:event.target.value});};_this.handleInputChangeNew=function(inputName){return function(event){try{var value=event.value;_this.setState(_defineProperty({},inputName,value),function(){if(inputName==='vehicleSegment'){_this.updateDependentFieldsBasedOnSegment();}});}catch(error){var _value='';_this.setState(_defineProperty({},inputName,_value),function(){if(inputName==='vehicleSegment'){_this.updateDependentFieldsBasedOnSegment();}});}};};_this.fetchAllPartnerSubscriptions=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(){var _ref11,subscription,subscriptionError,allSubscriptions;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return _this.props.client.query({query:GET_SUBSCRIPTION_BY_PARTNERID,variables:{partnerId:Object(__WEBPACK_IMPORTED_MODULE_24__utils_getLoginId__["a" /* default */])(),deviceModelId:_this.state.deviceModelId,status:[2,4,5]},errorPolicy:'all'// fetchPolicy: 'network-only'
});case 2:_ref11=_context6.sent;subscription=_ref11.data;subscriptionError=_ref11.error;allSubscriptions=subscription.getAllPartnerSubscriptions.map(// (lab = subscription.mmtc + ',' + subscription.noOfDevices),
function(subscription){return{value:subscription.id,label:subscription.totalSoftwareQty+' - '+subscription.deviceTrackingCharges};});if(subscriptionError){_this.setState({subscriptionDetails:[]});}else{_this.setState({subscriptionDetails:allSubscriptions},function(){return console.log('subscriptionDetails',_this.state.subscriptionDetails);});}case 7:case'end':return _context6.stop();}}},_callee6,_this2);}));_this.handleChangeDevice=function(client){return function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(event){var response,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:if(!event){_context7.next=8;break;}_this.setState({serialNumber:event.value});_context7.next=4;return client.query({query:GET_SELECT_DEV_DETAILS,variables:{uniqueId:event.value// fetchPolicy: 'network-only'
}}).catch(function(error){});case 4:response=_context7.sent;if(response&&response.data){data=response.data;_this.setState({modelName:data.devicePartnerAssignDetail.deviceModel.model_name,deviceType:data.devicePartnerAssignDetail.deviceModel.devicetype,uniqueId:_this.state.serialNumber,deviceModelId:data.devicePartnerAssignDetail.deviceModel.id},function(){_this.fetchAllPartnerSubscriptions();});}_context7.next=9;break;case 8:_this.setState({modelName:'',deviceType:'',uniqueId:'',serialNumber:'',subscriptionDetails:[],subscriptionId:''});case 9:case'end':return _context7.stop();}}},_callee7,_this2);}));return function(_x){return _ref12.apply(this,arguments);};}();};_this.handleDocumentUploadNewDataChange=function(fileName,field,value){_this.setState(function(prevState){return{documentUploadNewData:Object.assign({},prevState.documentUploadNewData,_defineProperty({},fileName,Object.assign({},prevState.documentUploadNewData[fileName],_defineProperty({},field,value))))};});};_this.handleFileChange=function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(event){var files,maxSize,maxFiles,fileNames,uploadProgress,uploadPromises,totalSize,i,file,fileExtension,allowedTypes,response,updatedFileNames;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:files=event.target.files;// Access all uploaded files
maxSize=30*1024*1024;// 30MB in bytes
maxFiles=50;// Maximum number of files allowed
fileNames=_this.state.fileNames||'';// Initialize fileNames to an empty string if undefined
fileNames=fileNames?fileNames.split(','):[];uploadProgress=Object.assign({},_this.state.uploadProgress);// Copy existing upload progress
uploadPromises=[];// Array to store upload promises
totalSize=0;// Variable to track total size of files
_this.setState({errorMessage:null,isUploading:true});if(!(files.length<=50)){_context8.next=49;break;}i=0;case 11:if(!(i<files.length)){_context8.next=36;break;}file=files[i];fileExtension=file.name.substring(file.name.lastIndexOf('.')+1).toLowerCase();allowedTypes=['jpeg','jpg','png','pdf'];if(allowedTypes.includes(fileExtension)){_context8.next=18;break;}_this.setState({errorMessage:'File '+(i+1)+' type is not supported. Please upload JPEG, JPG, PNG, or PDF files.',isUploading:false});return _context8.abrupt('continue',33);case 18:if(!(file.size>maxSize)){_context8.next=22;break;}_this.setState({errorMessage:'File '+(i+1)+' size exceeds the limit of 30MB.'});_context8.next=33;break;case 22:totalSize+=file.size;_context8.prev=23;_context8.next=26;return _this.props.client.mutate({mutation:GET_UPLOAD_URL,variables:{fileExtension:fileExtension}});case 26:response=_context8.sent;if(response.data&&response.data.getPublicUploadURL){(function(){var _response$data$getPub=response.data.getPublicUploadURL,publicUploadURL=_response$data$getPub.publicUploadURL,filename=_response$data$getPub.filename;uploadProgress[filename]=0;// Initialize progress for this filename
var uploadPromise=__WEBPACK_IMPORTED_MODULE_36_axios___default.a.put(publicUploadURL,file,{headers:{'x-ms-blob-type':'BlockBlob','Content-Type':file.type||'application/octet-stream'},onUploadProgress:function onUploadProgress(progressEvent){var progress=progressEvent.loaded/progressEvent.total*100;// Update progress for the filename obtained from the response
_this.setState(function(prevState){return{uploadProgress:Object.assign({},prevState.uploadProgress,_defineProperty({},filename,progress))};});}});uploadPromises.push(uploadPromise);fileNames.push(filename);// Store filename in fileNames state
})();}_context8.next=33;break;case 30:_context8.prev=30;_context8.t0=_context8['catch'](23);console.error('Upload error:',_context8.t0);case 33:i++;_context8.next=11;break;case 36:// Update fileNames state after processing all files
updatedFileNames=fileNames.slice(0,maxFiles).join(',');_this.setState({fileNames:updatedFileNames});// Wait for all upload promises to resolve
_context8.prev=38;_context8.next=41;return Promise.all(uploadPromises);case 41:_this.setState({isUploading:false});_context8.next=47;break;case 44:_context8.prev=44;_context8.t1=_context8['catch'](38);console.error('Upload error:',_context8.t1);// Handle upload error
case 47:_context8.next=50;break;case 49:_this.setState({errorMessage:'Maximum 50 files can be selected',isUploading:false});case 50:case'end':return _context8.stop();}}},_callee8,_this2,[[23,30],[38,44]]);}));return function(_x2){return _ref13.apply(this,arguments);};}();_this.handleDownload=function(){var _ref14=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(fileName){var bucketName,_ref15,data,res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:bucketName='aquila-track-uploads';_context9.next=3;return _this.props.client.query({query:GET_FILE_FORMAT,variables:{bucketname:bucketName,filename:fileName},errorPolicy:'all'});case 3:_ref15=_context9.sent;data=_ref15.data;_context9.next=7;return __WEBPACK_IMPORTED_MODULE_36_axios___default()({url:data.getPublicDownloadURL,method:'GET',headers:{Accept:'application/vnd.ms-excel'},responseType:'blob'// important
});case 7:res=_context9.sent;__WEBPACK_IMPORTED_MODULE_37_file_saver___default.a.saveAs(new Blob([res.data]),fileName);case 9:case'end':return _context9.stop();}}},_callee9,_this2);}));return function(_x3){return _ref14.apply(this,arguments);};}();_this.handleInputChange=function(key){return function(e){if(key==='fuelType'){if(!e){_this.setState(_defineProperty({},key,''));return;}_this.setState(_defineProperty({},key,e.value));}else if(key==='portedVehicle'){if(!e){_this.setState(_defineProperty({},key,''));return;}_this.setState(_defineProperty({},key,e.value));}else if(key==='isTestingVehicle'){if(!e){_this.setState(_defineProperty({},key,''));return;}_this.setState(_defineProperty({},key,e.value));}else if(key==='solutionType'){if(!e){_this.setState(_defineProperty({},key,''));return;}_this.setState(_defineProperty({},key,e.value));}else if(key==='solution_type'){var _this$setState14;if(!e){var _this$setState13;_this.setState((_this$setState13={},_defineProperty(_this$setState13,key,[]),_defineProperty(_this$setState13,'solutionType',''),_this$setState13));return;}// ✅ FIXED: use value instead of code
var selectedValues=e.map(function(option){return option.value;});// Keep solutionType (legacy string) in sync with solution_type (array) the same way Vehicle
// Registration does, instead of leaving the legacy field stale/inconsistent.
var legacySolutionType=_this.computeLegacySolutionType(selectedValues);_this.setState((_this$setState14={},_defineProperty(_this$setState14,key,selectedValues),_defineProperty(_this$setState14,'solutionType',legacySolutionType),_this$setState14));}else if(key=='adblueCapacity'||key=='fuelTankCapacity'){var value=parseFloat(e.target.value);if(isNaN(value)){_this.setState(_defineProperty({},key,e.target.value));if(key=='adblueCapacity'){_this.setState({errorMessageNew:null});}else{_this.setState({errorMessageFuelTank:null});}return false;}if(!Number.isInteger(value)){if(key=='adblueCapacity'){_this.setState({errorMessageNew:'Decimal values are not allowed.'});}else{_this.setState({errorMessageFuelTank:'Decimal values are not allowed.'});}}else{if(key=='adblueCapacity'){_this.setState({errorMessageNew:null});}else{_this.setState({errorMessageFuelTank:null});}}_this.setState(_defineProperty({},key,e.target.value));}else if(key=='department'||key=='contractorName'||key=='equipmentName'||key=='invoiceNumber'||key=='equipmentSerialNumber'||key=='isDualEngine'||key=='hasArm'||key=='isElockConnection'||key=='isIndividualViewOrCombinedView'||key=='duplicateVehicle'||key=='istachoenabled'){// Check if the input length exceeds 90 characters only if the field is not empty
if(key=='department'){if(e.target.value.length>90&&e.target.value.trim()!==''){var _this$setState17;_this.setState((_this$setState17={},_defineProperty(_this$setState17,key,e.target.value),_defineProperty(_this$setState17,'isDepartmentValid',false),_this$setState17));}else{var _this$setState18;_this.setState((_this$setState18={},_defineProperty(_this$setState18,key,e.target.value),_defineProperty(_this$setState18,'isDepartmentValid',true),_this$setState18));}}if(key=='contractorName'){if(e.target.value.length>90&&e.target.value.trim()!==''){var _this$setState19;_this.setState((_this$setState19={},_defineProperty(_this$setState19,key,e.target.value),_defineProperty(_this$setState19,'isContractorNameValid',false),_this$setState19));}else{var _this$setState20;_this.setState((_this$setState20={},_defineProperty(_this$setState20,key,e.target.value),_defineProperty(_this$setState20,'isContractorNameValid',true),_this$setState20));}}if(key=='equipmentName'){if(e.target.value.length>90&&e.target.value.trim()!==''){var _this$setState21;_this.setState((_this$setState21={},_defineProperty(_this$setState21,key,e.target.value),_defineProperty(_this$setState21,'isEquipmentNameValid',false),_this$setState21));}else{var _this$setState22;_this.setState((_this$setState22={},_defineProperty(_this$setState22,key,e.target.value),_defineProperty(_this$setState22,'isEquipmentNameValid',true),_this$setState22));}}if(key=='equipmentSerialNumber'){if(e.target.value.length>90&&e.target.value.trim()!==''){var _this$setState23;_this.setState((_this$setState23={},_defineProperty(_this$setState23,key,e.target.value),_defineProperty(_this$setState23,'isEquipmentValid',false),_this$setState23));}else{var _this$setState24;_this.setState((_this$setState24={},_defineProperty(_this$setState24,key,e.target.value),_defineProperty(_this$setState24,'isEquipmentValid',true),_this$setState24));}}if(key=='invoiceNumber'){if(e.target.value.length>90&&e.target.value.trim()!==''){var _this$setState25;_this.setState((_this$setState25={},_defineProperty(_this$setState25,key,e.target.value),_defineProperty(_this$setState25,'isInvoiceNoValid',false),_this$setState25));}else{var _this$setState26;_this.setState((_this$setState26={},_defineProperty(_this$setState26,key,e.target.value),_defineProperty(_this$setState26,'isInvoiceNoValid',true),_this$setState26));}}if(key=='isDualEngine'){var isChecked=e.target.checked;_this.setState({isDualEngine:isChecked},function(){});}if(key=='isElockConnection'){var _isChecked=e.target.checked;_this.setState({isElockConnection:_isChecked},function(){});}if(key=='hasArm'){var _isChecked2=e.target.checked;_this.setState({hasArm:_isChecked2},function(){});}if(key=='duplicateVehicle'){var _isChecked3=e.target.checked;_this.setState({duplicateVehicle:_isChecked3},function(){});}if(key=='isIndividualViewOrCombinedView'){var _isChecked4=e.target.checked;_this.setState({isIndividualViewOrCombinedView:_isChecked4},function(){});}if(key=='istachoenabled'){var _isChecked5=e.target.checked;_this.setState({istachoenabled:_isChecked5},function(){});}}else if(key==='phase'||key==='kvaRating'||key==='dgSetType'){if(!e){_this.setState(_defineProperty({},key,''));return;}_this.setState(_defineProperty({},key,e.value));}else{_this.setState(_defineProperty({},key,e.target.value));}};};_this.handleChangeType=function(event){var selectedVehicleType=event?event.value:null;_this.setState({vehicleType:selectedVehicleType},function(){_this.checkVehicleTypeValidity();});};_this.handleChangeSpeedSensor=function(event){if(event){_this.setState({speedSensor:event.value});}else{_this.setState({speedSensor:''});}};_this.handleMailChange=function(event){_this.setState({mail:event.target.value});};_this.checkMail=function(){var regex=new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);_this.setState({ismailValid:regex.test(_this.state.mail)&&_this.state.mail!==''});};_this.checkVehicleModelValidity=function(){var regex=/^[a-zA-Z][a-zA-Z0-9 -]*$/;_this.setState({isVehicleModelValid:regex.test(_this.state.vehicleModel)&&_this.state.vehicleModel!==''&&_this.state.vehicleModel.length>1&&_this.state.vehicleModel.length<21});};_this.checkVehicleMakeValidity=function(){var regex=/^[a-zA-Z][a-zA-Z0-9 -]*$/;if(_this.state.vehicleMake!=='')_this.setState({isVehicleMakeValid:regex.test(_this.state.vehicleMake)&&_this.state.vehicleMake!==''&&_this.state.vehicleMake.length>1&&_this.state.vehicleMake.length<70});};_this.checkSpeedLimitValidity=function(){var regex=new RegExp(/^[1-9][0-9]{0,2}$/);_this.setState({isSpeedLimitValid:regex.test(_this.state.speedLimit)&&_this.state.speedLimit!==''&&_this.state.speedLimit<=160&&_this.state.speedLimit>=10});};_this.checkSeatLimitValidity=function(){var regex=new RegExp(/^[1-9][0-9]$/);_this.setState({isSeatLimitValid:regex.test(_this.state.seatLimit)&&_this.state.seatLimit!==''});};_this.checkVlpnValidity=function(client){return function(){var _ref16=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(event){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:if(!(_this.state.vlpn===_this.state.existingVehicleNumber)){_context10.next=2;break;}return _context10.abrupt('return');case 2:_context10.next=4;return client.query({query:GET_VLPN,variables:{vlpn:_this.state.vlpn}});case 4:_this.setState({isVlpnValid:_this.state.vlpn!==''&&_this.state.vlpn.length>4&&_this.state.vlpn.length<33});if(_this.state.vlpn!==''){if(_this.state.vlpn.length<5||_this.state.vlpn.length>32){_this.setState({vlpnres:'Max character length is between 5 to 32'});}else{_this.setState({vlpnres:'Invalid Vehicle Number'});}}case 6:case'end':return _context10.stop();}}},_callee10,_this2);}));return function(_x4){return _ref16.apply(this,arguments);};}();};_this.checkVehicleTypeValidity=function(){var isSchoolBus=_this.state.vehicleType==='School Bus';_this.setState({isVehicleTypeValid:_this.state.vehicleType!=='',isSeatLimitValid:isSchoolBus// Update isSeatLimitValid based on selected vehicle type
});};_this.checkItemValidity=function(key){return function(e){if(e.target.value!==''){var regex=/^[a-zA-Z0-9 .-@,]*$/;switch(key){case'engineTorque':_this.setState({isEngineTorqueValid:regex.test(e.target.value)&&e.target.value!==''});break;case'engineLoad':_this.setState({isEngineLoadValid:regex.test(e.target.value)&&e.target.value!==''});break;case'fuelType':_this.setState({isFuelTypeValid:e.target.value!==''});break;case'torquePower':_this.setState({istTorquePowerValid:regex.test(e.target.value)&&e.target.value!==''});break;case'engineOnHours':_this.setState({isengineOnHoursValid:regex.test(e.target.value)&&e.target.value!==''});break;case'odometerDistance':_this.setState({isOdometerDistanceValid:regex.test(e.target.value)&&e.target.value!==''});break;case'engineSpecification':_this.setState({isEngineSpecificationValid:e.target.value!==''});break;default:break;}}};};_this.checkSpeedSensorValidity=function(){_this.setState({isSpeedSensorValid:_this.state.speedSensor!==''});};_this.checkAdblueCapacityValidity=function(){var _this$state=_this.state,deviceType=_this$state.deviceType,adblueCapacity=_this$state.adblueCapacity;var isValid=true;if(deviceType&&deviceType.toLowerCase()==='obd'){isValid=!!adblueCapacity&&adblueCapacity.toString().trim()!=='';}_this.setState({isAdblueCapacityValid:isValid});return isValid;};_this.checkDualEngineVoltageValidity=function(){var _this$state2=_this.state,isDualEngine=_this$state2.isDualEngine,eon_voltage=_this$state2.eon_voltage,eoff_voltage=_this$state2.eoff_voltage;var isEonVoltageValid=true;var isEoffVoltageValid=true;if(isDualEngine){isEonVoltageValid=eon_voltage!==null&&eon_voltage!==''&&!isNaN(eon_voltage);isEoffVoltageValid=eoff_voltage!==null&&eoff_voltage!==''&&!isNaN(eoff_voltage);}_this.setState({isEonVoltageValid:isEonVoltageValid,isEoffVoltageValid:isEoffVoltageValid});return isEonVoltageValid&&isEoffVoltageValid;};_this.handleSubmit=function(client){return function(){var _ref17=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(event){var _variables;var initialSolution,isOnlyVtInitial,hasChangedFromVtOnly,installationStatus,commissioningDate,invoiceDate,formattedFileNames,_ref18,data,errors;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:if(_this.state.seatLimit===''){_this.setState({seatLimit:null});}event.preventDefault();// Determine if vehicle initially had ONLY 'vt' solution_type
initialSolution=_this.state.vehicleDetails&&_this.state.vehicleDetails.solution_type?_this.state.vehicleDetails.solution_type:[];isOnlyVtInitial=initialSolution.length===1&&initialSolution.includes('vt');// Check if the user has mutated it away from purely 'vt'
hasChangedFromVtOnly=isOnlyVtInitial&&(!_this.state.solution_type||_this.state.solution_type.length!==1||!_this.state.solution_type.includes('vt'));if(!hasChangedFromVtOnly){_context11.next=8;break;}_this.setState({vtValidationError:'you cant edit more solution_type as you have vt instattled only remove that and submit...'});return _context11.abrupt('return');case 8:if(!(_this.state.solution_type&&_this.state.solution_type.includes('vt')&&!_this.state.videoTelematicsId)){_context11.next=11;break;}_this.setState({vtValidationError:'Please select a Video Telematics ID before submitting.'});return _context11.abrupt('return');case 11:_this.setState({vtValidationError:null});installationStatus=void 0;if(_this.state.installStatus&&_this.state.status===2){installationStatus=1;}else{installationStatus=_this.state.status;}if(_this.state.engineNumber===''){_this.setState({engineNumber:null});}if(_this.state.chassisNumber===''){_this.setState({chassisNumber:null});}commissioningDate=_this.state.commissioningDate.date===null?null:parseInt(_this.state.commissioningDate.unix);invoiceDate=_this.state.invoiceDate.date===null?null:parseInt(_this.state.invoiceDate.unix);formattedFileNames='';try{formattedFileNames=_this.state.fileNames.split(',').map(function(fileName){return fileName.trim();}).join(',');// Split file names by comma, trim whitespace, and join back with commas
}catch(error){}_context11.next=22;return client.mutate({mutation:UPDATE_VEHICLE,variables:(_variables={vehicleNumber:_this.state.vehicleNickName?_this.state.vehicleNickName:_this.state.vehicleSegment=='DG Set'?_this.state.vlpn:_this.state.rcRegnNo||_this.state.vehicleData&&_this.state.vehicleData.rcRegnNo||_this.state.vehicleRegistrationNumber||_this.state.vlpn,entityId:parseInt(_this.entityId,10),clientLoginId:parseInt(_this.state.clientLoginId,10),speedSensorType:_this.state.speedSensor,speedLimit:parseInt(_this.state.speedLimit,10),// vehicleType: this.state.vehicleSegment == 'DG Set' ? this.state.vehicleSegment : this.state.rcVhType || (this.state.vehicleData && this.state.vehicleData.rcVhType) || this.state.vehicleType || 'N/A',
vehicleType:function(){var _this$state3=_this.state,vehicleSegment=_this$state3.vehicleSegment,transportationVehicleType=_this$state3.transportationVehicleType,constructionVehicleType=_this$state3.constructionVehicleType,passengerVehicleType=_this$state3.passengerVehicleType,vehicleData=_this$state3.vehicleData,rcVhType=_this$state3.rcVhType;if(vehicleSegment==='Transportation')return transportationVehicleType||'N/A';if(vehicleSegment==='Construction')return constructionVehicleType||'N/A';if(vehicleSegment==='Passenger')return passengerVehicleType||'N/A';var vehicleType=vehicleData&&vehicleData.rcVhType||rcVhType;vehicleType=vehicleType==='T'?'Truck':vehicleType||'N/A';return vehicleSegment||vehicleType;}(),rcsSerialNumber:_this.state.rcsSerialNumber,vehicleModel:_this.state.vehicleSegment=='DG Set'||_this.state.deviceType=='obd'||_this.state.deviceType=='OBD'?_this.state.vehicleModel:_this.state.rcMakerModel||_this.state.vehicleData&&_this.state.vehicleData.rcMakerModel||_this.state.makerModel,vehicleModelId:_this.state.vehicleSegment=='DG Set'||_this.state.deviceType=='obd'||_this.state.deviceType=='OBD'?_this.state.vehicleModelId:null,vehicleMakeId:_this.state.vehicleSegment=='DG Set'||_this.state.deviceType=='obd'||_this.state.deviceType=='OBD'?_this.state.vehicleMakeId:null,vehicleCapacity:parseInt(_this.state.seatLimit,10),isActivated:_this.state.installStatus,immobilize:_this.state.immobilize,status:parseInt(installationStatus,10),engineNumber:_this.state.engineNumber,chassisNumber:_this.state.chassisNumber,equipmentSerialNumber:_this.state.equipmentSerialNumber,commissioningDate:commissioningDate,invoiceDate:invoiceDate,idlingSpeed:_this.state.idlingSpeed,equipmentName:_this.state.equipmentName,invoiceNumber:_this.state.invoiceNumber,department:_this.state.department,contractorName:_this.state.contractorName,vehicleMake:_this.state.vehicleSegment=='DG Set'||_this.state.deviceType=='obd'||_this.state.deviceType=='OBD'?_this.state.vehicleMake:_this.state.rcMakerDesc||_this.state.vehicleData&&_this.state.vehicleData.rcMakerDesc||_this.state.makerDescription,engineTorque:_this.state.engineTorque,engineLoad:_this.state.engineLoad,// fuelType: this.state.fuelType,
solutionType:_this.state.solutionType,solution_type:_this.state.solution_type,duplicateVehicle:_this.state.isDuplicatedDBValue?false:_this.state.duplicateVehicle,torquePower:_this.state.torquePower,engineOnHours:_this.state.engineOnHours,odometerDistance:_this.state.odometerDistance,engineSpecification:_this.state.engineSpecification,emissionRateType:_this.state.emissionRateType,grossVehicleWeight:parseFloat(_this.state.grossVehicleWeight),manufacturingYear:parseInt(_this.state.manufacturingYear),vehicleSegment:_this.state.vehicleSegment,equipmentTypeClass:_this.state.equipmentTypeClass,vehicleWheeler:_this.state.vehicleWheeler,application:_this.state.vehicleSegment==='Transportation'?_this.state.selectedApplication:'',haulageType:_this.state.vehicleSegment==='Transportation'?_this.state.haulageType:'',transportationVehicleType:_this.state.vehicleSegment==='Transportation'?_this.state.transportationVehicleType:'',constructionVehicleType:_this.state.vehicleSegment==='Construction'?_this.state.constructionVehicleType:'',passengerVehicleType:_this.state.vehicleSegment==='Passenger'?_this.state.passengerVehicleType:'',isDualEngine:_this.state.isDualEngine,eoff_voltage:parseFloat(_this.state.eoff_voltage),eon_voltage:parseFloat(_this.state.eon_voltage),hasArm:_this.state.hasArm,isElockConnection:_this.state.isElockConnection,vehicleNickName:_this.state.vehicleNickName,documentUpload:formattedFileNames,documentUploadNew:_this.state.fileNames?_this.state.fileNames.split(',').filter(Boolean).map(function(fileName){return Object.assign({fileName:fileName.trim()},_this.state.documentUploadNewData[fileName.trim()]||{solutionType:'',label:''});}):[],baselineDataType:_this.state.baselineDataType,baselineDataForFE:parseFloat(_this.state.baselineDataForFE),baselineDistance:parseInt(_this.state.baselineDistance),fuelTankCapacity:_this.state.fuelTankCapacity?_this.state.fuelTankCapacity.toString():null,adblueCapacity:_this.state.adblueCapacity?_this.state.adblueCapacity.toString():null,zonalManager:_this.state.zmId?_this.state.zmId:null,keyAccountManager:_this.state.kamId?_this.state.kamId:null,channelPartnerName:_this.state.throughChannelPartner&&_this.state.channelPartnerName?_this.state.channelPartnerName:null,portedVehicle:_this.state.portedVehicle,isTestingVehicle:_this.state.isTestingVehicle,kvaRating:_this.state.kvaRating,dgSetType:_this.state.dgSetType,bhp:_this.state.bhp,phase:_this.state.phase,engineModel:_this.state.engineModel,gensetController:_this.state.gensetController,videoTelematicsType:_this.state.selectedVTM?_this.state.selectedVTM:null,videoTelematicsId:_this.state.selectedVTM&&_this.state.videoTelematicsId?_this.state.videoTelematicsId:null,inputParameter:_this.state.inputParameter?_this.state.inputParameter:null,multiplicationFactor:_this.state.multiplicationFactor?_this.state.multiplicationFactor:null,vehicleRegistrationNumber:_this.state.rcRegnNo||_this.state.vehicleData&&_this.state.vehicleData.rcRegnNo||_this.state.vehicleRegistrationNumber||_this.state.vlpn,registrationDate:_this.state.rcRegnDt||_this.state.vehicleData&&_this.state.vehicleData.rcRegnDt||_this.state.registrationDate||'',registrationValidUpto:_this.state.rcRegnUpto||_this.state.vehicleData&&_this.state.vehicleData.rcRegnUpto||_this.state.registrationValidUpto||'',stateCode:_this.state.stateCd||_this.state.vehicleData&&_this.state.vehicleData.stateCd||_this.state.stateCode||'',rtoCode:_this.state.rtoCd||_this.state.vehicleData&&_this.state.vehicleData.rtoCd||_this.state.rtoCode||'',vehicleCategoryCode:_this.state.rcVchCatg||_this.state.vehicleData&&_this.state.vehicleData.rcVchCatg||_this.state.vehicleCategoryCode||'',vehicleClassDescription:_this.state.rcVhClassDesc||_this.state.vehicleData&&_this.state.vehicleData.rcVhClassDesc||_this.state.vehicleClassDescription||''},_defineProperty(_variables,'chassisNumber',_this.state.rcChasiNo||_this.state.vehicleData&&_this.state.vehicleData.rcChasiNo||_this.state.chassisNumber||''),_defineProperty(_variables,'engineNumber',_this.state.rcEngNo||_this.state.vehicleData&&_this.state.vehicleData.rcEngNo||_this.state.engineNumber||''),_defineProperty(_variables,'makerDescription',_this.state.rcMakerDesc||_this.state.vehicleData&&_this.state.vehicleData.rcMakerDesc||_this.state.makerDescription),_defineProperty(_variables,'makerModel',_this.state.rcMakerModel||_this.state.vehicleData&&_this.state.vehicleData.rcMakerModel||_this.state.makerModel),_defineProperty(_variables,'bodyTypeDescription',_this.state.rcBodyTypeDesc||_this.state.vehicleData&&_this.state.vehicleData.rcBodyTypeDesc||_this.state.bodyTypeDescription||''),_defineProperty(_variables,'fuelType',_this.state.rcFuelDesc||_this.state.vehicleData&&_this.state.vehicleData.rcFuelDesc||_this.state.fuelType?_this.state.rcFuelDesc||_this.state.vehicleData&&_this.state.vehicleData.rcFuelDesc||_this.state.fuelType:''),_defineProperty(_variables,'emissionNormsDescription',_this.state.rcNormsDesc||_this.state.vehicleData&&_this.state.vehicleData.rcNormsDesc||_this.state.emissionNormsDescription||''),_defineProperty(_variables,'fitmentUpto',_this.state.rcFitUpto||_this.state.vehicleData&&_this.state.vehicleData.rcFitUpto||_this.state.fitmentUpto||''),_defineProperty(_variables,'nationalPermitUpto',_this.state.rcNpUpto||_this.state.vehicleData&&_this.state.vehicleData.rcNpUpto||_this.state.nationalPermitUpto||''),_defineProperty(_variables,'taxUpto',_this.state.rcTaxUpto||_this.state.vehicleData&&_this.state.vehicleData.rcTaxUpto||_this.state.taxUpto||''),_defineProperty(_variables,'insurerName',_this.state.rcInsuranceComp||_this.state.vehicleData&&_this.state.vehicleData.rcInsuranceComp||_this.state.insurerName||''),_defineProperty(_variables,'insuranceUpto',_this.state.rcInsuranceComp||_this.state.vehicleData&&_this.state.vehicleData.rcInsuranceComp||_this.state.insuranceUpto||''),_defineProperty(_variables,'manufacturingMonthYear',_this.state.rcManuMonthYr||_this.state.vehicleData&&_this.state.vehicleData.rcManuMonthYr||_this.state.manufacturingMonthYear||''),_defineProperty(_variables,'unladenWeight',_this.state.rcUnldWt||_this.state.vehicleData&&_this.state.vehicleData.rcUnldWt||_this.state.unladenWeight||null),_defineProperty(_variables,'grossVehicleWeight',parseFloat(_this.state.rcGvw||_this.state.vehicleData&&_this.state.vehicleData.rcGvw||_this.state.grossVehicleWeight)),_defineProperty(_variables,'registeredAt',_this.state.rcRegisteredAt||_this.state.vehicleData&&_this.state.vehicleData.rcRegisteredAt||_this.state.registeredAt||''),_defineProperty(_variables,'puccUpto',_this.state.rcPuccUpto||_this.state.vehicleData&&_this.state.vehicleData.rcPuccUpto||_this.state.puccUpto||''),_defineProperty(_variables,'permitNumber',_this.state.rcPermitNo||_this.state.vehicleData&&_this.state.vehicleData.rcPermitNo||_this.state.permitNumber||''),_defineProperty(_variables,'permitIssueDate',_this.state.rcPermitIssueDt||_this.state.vehicleData&&_this.state.vehicleData.rcPermitIssueDt||_this.state.permitIssueDate||''),_defineProperty(_variables,'permitValidFrom',_this.state.rcPermitValidFrom||_this.state.vehicleData&&_this.state.vehicleData.rcPermitValidFrom||_this.state.permitValidFrom||''),_defineProperty(_variables,'permitValidUpto',_this.state.rcPermitValidUpto||_this.state.vehicleData&&_this.state.vehicleData.rcPermitValidUpto||_this.state.permitValidUpto||''),_defineProperty(_variables,'permitType',_this.state.rcPermitType||_this.state.vehicleData&&_this.state.vehicleData.rcPermitType||_this.state.permitType||''),_defineProperty(_variables,'permitCode',_this.state.rcPermitCode||_this.state.vehicleData&&_this.state.vehicleData.rcPermitCode||_this.state.permitCode||''),_defineProperty(_variables,'numberOfAxles',_this.state.rcNoOfAxle||_this.state.vehicleData&&_this.state.vehicleData.rcNoOfAxle||_this.state.numberOfAxles||null),_defineProperty(_variables,'fuelCode',_this.state.rcFuelCd||_this.state.vehicleData&&_this.state.vehicleData.rcFuelCd||_this.state.fuelCode||''),_defineProperty(_variables,'vehicleType',_this.state.vehicleSegment==='DG Set'?'DG Set':_this.state.vehicleSegment==='Transportation'?_this.state.transportationVehicleType:_this.state.vehicleSegment==='Construction'?_this.state.constructionVehicleType:_this.state.vehicleSegment==='Passenger'?_this.state.passengerVehicleType:_this.state.vehicleData&&_this.state.vehicleData.rcVhType?_this.state.vehicleData.rcVhType==='T'?'Truck':_this.state.vehicleData.rcVhType:_this.state.rcVhType||'N/A'),_defineProperty(_variables,'vehicleClass',_this.state.rcVhClass||_this.state.vehicleData&&_this.state.vehicleData.rcVhClass||_this.state.vehicleClass||''),_defineProperty(_variables,'clientName',_this.state.client),_defineProperty(_variables,'custCode',_this.state.customerCode),_defineProperty(_variables,'custType',_this.state.customerType),_defineProperty(_variables,'noOfWheels',_this.state.noOfWheels?parseInt(_this.state.noOfWheels):null),_defineProperty(_variables,'baselineHours',parseInt(_this.state.baselineHours)),_defineProperty(_variables,'vehicleCustomizedBodyType',_this.state.vehicleCustomizedBodyType),_defineProperty(_variables,'noOfGears',parseInt(_this.state.noOfGears)),_defineProperty(_variables,'gearRatio',_this.state.gearRatio),_defineProperty(_variables,'isIndividualViewOrCombinedView',_this.state.isIndividualViewOrCombinedView),_defineProperty(_variables,'tensionerConductorLength',_this.state.tensionerConductorLength),_defineProperty(_variables,'tensionerRotationSensorDirection',_this.state.tensionerRotationSensorDirection||''),_defineProperty(_variables,'isRotationSensor',_this.state.isRotationSensor),_defineProperty(_variables,'istachoenabled',_this.state.istachoenabled),_defineProperty(_variables,'tachoidlerpm',_this.state.tachoidlerpm?parseInt(_this.state.tachoidlerpm):null),_defineProperty(_variables,'tachoengineonmin',_this.state.tachoengineonmin!==''&&_this.state.tachoengineonmin!==null?parseInt(_this.state.tachoengineonmin,10):null),_defineProperty(_variables,'tachoengineonmax',_this.state.tachoengineonmax!==''&&_this.state.tachoengineonmax!==null?parseInt(_this.state.tachoengineonmax,10):null),_defineProperty(_variables,'tachoshifthours',_this.state.tachoshifthours?parseInt(_this.state.tachoshifthours):null),_defineProperty(_variables,'technicianName',_this.state.technicianName||null),_defineProperty(_variables,'updatedBy',_this.state.updatedBy||null),_variables),errorPolicy:'all'});case 22:_ref18=_context11.sent;data=_ref18.data;errors=_ref18.errors;if(!data){_context11.next=41;break;}_context11.next=28;return client.clearStore();case 28:_context11.prev=28;_context11.next=31;return client.mutate({mutation:__WEBPACK_IMPORTED_MODULE_3__queries__["a" /* ADD_ELOCK_CONNECTION */],variables:{uniqueId:_this.state.uniqueDeviceId,status:_this.state.isElockConnection?1:0,deviceType:_this.state.deviceType}});case 31:_context11.next=36;break;case 33:_context11.prev=33;_context11.t0=_context11['catch'](28);console.log('Error adding elock connection',_context11.t0);case 36:_this.setState({response:data.addVehicleDetail});_this.props.openSnackbar('Vehicle Details Updated Successfully');_this.props.history.goBack();_context11.next=43;break;case 41:_this.setState({failure:true});_this.props.openSnackbar(errors[0].message);case 43:case'end':return _context11.stop();}}},_callee11,_this2,[[28,33]]);}));return function(_x5){return _ref17.apply(this,arguments);};}();};_this.handleChange=function(name){return function(event){var _this$setState30;_this.setState((_this$setState30={},_defineProperty(_this$setState30,name,event.target.checked),_defineProperty(_this$setState30,'installStatus',event.target.checked),_this$setState30),function(){console.log('int',_this.state.installStatus);});};};_this.flushVahaanValues=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(){var _this$setState31;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:if(_this.state.vehicleSegment=='DG Set'){_this.setState((_this$setState31={loading:false,vehicleData:null,rcRegnNo:'',rcRegnDt:'',rcRegnUpto:'',rcPurchaseDt:'',rcOwnerSr:'',rcOwnerName:'',stateCd:'',rtoCd:'',rcPresentAddress:'',rcPermanentAddress:'',rcVchCatg:'',rcVhClassDesc:'',rcChasiNo:'',rcEngNo:'',rcMakerDesc:'',rcMakerModel:'',rcBodyTypeDesc:'',rcFuelDesc:'',rcColor:'',rcNormsDesc:'',rcFitUpto:'',rcNpUpto:'',rcNpIssuedBy:'',rcTaxUpto:'',rcFinancer:'',rcInsuranceComp:'',rcInsurancePolicyNo:'',rcInsuranceUpto:'',rcManuMonthYr:'',rcUnldWt:'',rcGvw:'',rcNoCyl:'',rcCubicCap:'',rcSeatCap:'',rcSleeperCap:'',rcStandCap:'',rcWheelbase:'',rcRegisteredAt:'',rcStatusAsOn:'',rcPuccUpto:'',rcPuccNo:'',rcStatus:'',rcNcrbStatus:'',rcBlacklistStatus:'',rcPermitNo:'',rcPermitIssueDt:'',rcPermitValidFrom:'',rcPermitValidUpto:'',rcPermitType:'',rcPermitCode:'',rcNocDetails:'',rcVhType:'',rcVhClass:'',rcNocDt:'',rcFuelCd:'',rcMakerCd:'',rcModelCd:'',rcNormsCd:'',rcSaleAmt:'',rcOwnCatgDesc:''},_defineProperty(_this$setState31,'rcVhClassDesc',''),_defineProperty(_this$setState31,'rcOwnerCdDesc',''),_defineProperty(_this$setState31,'rcCurrentaddDistrictcode',''),_defineProperty(_this$setState31,'rcNonUse',''),_defineProperty(_this$setState31,'rcPassengerTax',''),_defineProperty(_this$setState31,'rcGoodsTax',''),_defineProperty(_this$setState31,'rcNoOfAxle',''),_defineProperty(_this$setState31,'rcApprovalDate',''),_defineProperty(_this$setState31,'rcHp',''),_defineProperty(_this$setState31,'rcMandalDesc',''),_defineProperty(_this$setState31,'rcTalukCd',''),_this$setState31));}case 1:case'end':return _context12.stop();}}},_callee12,_this2);}));_this.handleVehicleRegistrationNumberAvailableChange=function(name){return function(event){var enteredVehicleRegistrationNumber=null;_this.setState(_defineProperty({},name,event.target.checked),function(){if(_this.state.vehicleRegistrationNumberAvailableStatus){console.log('Vehicle Registration Number Available');}else{console.log('Vehicle Registration Number Unavailable');_this.setState({loading:false,vehicleData:null,rcRegnNo:'',rcRegnDt:'',rcRegnUpto:'',rcPurchaseDt:'',rcOwnerSr:'',rcOwnerName:'',stateCd:'',rtoCd:'',rcPresentAddress:'',rcPermanentAddress:'',rcVchCatg:'',rcVhClassDesc:'',rcChasiNo:'',rcEngNo:'',rcMakerDesc:'',rcMakerModel:'',rcBodyTypeDesc:'',rcFuelDesc:'',rcColor:'',rcNormsDesc:'',rcFitUpto:'',rcNpUpto:'',rcNpIssuedBy:'',rcTaxUpto:'',rcFinancer:'',rcInsuranceComp:'',rcInsurancePolicyNo:'',rcInsuranceUpto:'',rcManuMonthYr:'',rcUnldWt:'',rcGvw:'',rcNoCyl:'',rcCubicCap:'',rcSeatCap:'',rcSleeperCap:'',rcStandCap:'',rcWheelbase:'',rcRegisteredAt:'',rcStatusAsOn:'',rcPuccUpto:'',rcPuccNo:'',rcStatus:'',rcNcrbStatus:'',rcBlacklistStatus:'',rcPermitNo:'',rcPermitIssueDt:'',rcPermitValidFrom:'',rcPermitValidUpto:'',rcPermitType:'',rcPermitCode:'',rcNocDetails:'',rcVhType:'',rcVhClass:'',rcNocDt:'',rcFuelCd:'',rcMakerCd:'',rcModelCd:'',rcNormsCd:'',rcSaleAmt:'',rcOwnCatgDesc:'',rcVchCatgDesc:'',rcOwnerCdDesc:'',rcCurrentaddDistrictcode:'',rcNonUse:'',rcPassengerTax:'',rcGoodsTax:'',rcNoOfAxle:'',rcApprovalDate:'',rcHp:'',rcMandalDesc:'',rcTalukCd:''});}});};};_this.getDataByVehicleNumber=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(){var enteredVehicleRegistrationNumber,response,vehicleData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:enteredVehicleRegistrationNumber=_this.state.enteredVehicleRegistrationNumber;_this.setState({vehicleData:null,vlpnres:'',loading:false});if(!(!enteredVehicleRegistrationNumber||enteredVehicleRegistrationNumber.length<5||enteredVehicleRegistrationNumber.length>32)){_context13.next=5;break;}_this.setState({vlpnres:'Vehicle Registration Number must be between 5 to 32 characters.'});return _context13.abrupt('return');case 5:_context13.prev=5;// const { data } = await this.props.client.query({
//   query: GET_VLPN,
//   variables: { vlpn: enteredVehicleRegistrationNumber }
// })
// if (data.checkVehicleNumber === 'AVAILABLE') {this.setState({ vlpnres: 'Data not available for the entered Vehicle Number' })};
_this.setState({loading:true});_context13.next=9;return _this.props.client.query({query:GET_VEHICLE_VAHAAN_DETAILS,variables:{vehicleNumber:enteredVehicleRegistrationNumber}});case 9:response=_context13.sent;if(response.data&&response.data.getVehicleVahaanDetails&&response.data.getVehicleVahaanDetails.length>0){vehicleData=response.data.getVehicleVahaanDetails[0];_this.setState({vehicleData:vehicleData});console.log('Fetched vehicle details:',vehicleData);}else{console.log('No vehicle details found.');{_this.setState({vlpnres:'Data not available currently for the entered Vehicle Number. Please check the Vehicle Number and try again after some time.'});}}_context13.next=17;break;case 13:_context13.prev=13;_context13.t0=_context13['catch'](5);console.error('Error fetching vehicle details:',_context13.t0);_this.setState({vlpnres:'Error occurred while fetching vehicle details. Please try again after some time.'});case 17:_context13.prev=17;_this.setState({loading:false});return _context13.finish(17);case 20:if(_this.state.vlpnres){_this.setState({rcRegnNo:'',rcRegnDt:'',rcRegnUpto:'',rcPurchaseDt:'',rcOwnerSr:'',rcOwnerName:'',stateCd:'',rtoCd:'',rcPresentAddress:'',rcPermanentAddress:'',rcVchCatg:'',rcVhClassDesc:'',rcChasiNo:'',rcEngNo:'',rcMakerDesc:'',rcMakerModel:'',rcBodyTypeDesc:'',rcFuelDesc:'',rcColor:'',rcNormsDesc:'',rcFitUpto:'',rcNpUpto:'',rcNpIssuedBy:'',rcTaxUpto:'',rcFinancer:'',rcInsuranceComp:'',rcInsurancePolicyNo:'',rcInsuranceUpto:'',rcManuMonthYr:'',rcUnldWt:'',rcGvw:'',rcNoCyl:'',rcCubicCap:'',rcSeatCap:'',rcSleeperCap:'',rcStandCap:'',rcWheelbase:'',rcRegisteredAt:'',rcStatusAsOn:'',rcPuccUpto:'',rcPuccNo:'',rcStatus:'',rcNcrbStatus:'',rcBlacklistStatus:'',rcPermitNo:'',rcPermitIssueDt:'',rcPermitValidFrom:'',rcPermitValidUpto:'',rcPermitType:'',rcPermitCode:'',rcNocDetails:'',rcVhType:'',rcVhClass:'',rcNocDt:'',rcFuelCd:'',rcMakerCd:'',rcModelCd:'',rcNormsCd:'',rcSaleAmt:'',rcOwnCatgDesc:'',rcVchCatgDesc:'',rcOwnerCdDesc:'',rcCurrentaddDistrictcode:'',rcNonUse:'',rcPassengerTax:'',rcGoodsTax:'',rcNoOfAxle:'',rcApprovalDate:'',rcHp:'',rcMandalDesc:'',rcTalukCd:''});}case 21:case'end':return _context13.stop();}}},_callee13,_this2,[[5,13,17,20]]);}));_this.handleImmobilizeChange=function(status){return function(eve){var _this$setState33;_this.setState((_this$setState33={},_defineProperty(_this$setState33,status,eve.target.checked),_defineProperty(_this$setState33,'immobilize',eve.target.checked),_this$setState33),function(){console.log('immobilizeStatus',_this.state.immobilize);});};};_this.handleEmissionType=function(event){if(event)_this.setState({emissionRateType:event.target.value});else _this.setState({emissionRateType:''});};_this.handleChangeMake=function(){var _ref21=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(event){var makemodellist,models,modelsList,_makemodellist;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:_this.setState({vehicleMake:event?event.label:null,vehicleMakeId:event?event.value:null,kvaRating:'',dgSetType:''});if(!(event&&_this.state.vehicleSegment=='DG Set')){_context14.next=9;break;}_context14.next=4;return _this.props.client.query({query:GET_DG_MODELS,variables:{make:event.value// fetchPolicy: 'network-only'
}});case 4:makemodellist=_context14.sent;models=makemodellist.data.getDgModels;modelsList=models&&models.map(function(model){return{id:model,model:model};});_this.setState({modelsList:modelsList});return _context14.abrupt('return');case 9:if(!event){_context14.next=16;break;}_context14.next=12;return _this.props.client.query({query:GET_VEHICLE_MODELS,variables:{makeId:event.value// fetchPolicy: 'network-only'
}});case 12:_makemodellist=_context14.sent;_this.setState({modelsList:_makemodellist.data.getVehicleModels});_context14.next=18;break;case 16:_this.setState({modelsList:[]});_this.setState({emissionRateType:''});case 18:case'end':return _context14.stop();}}},_callee14,_this2);}));return function(_x6){return _ref21.apply(this,arguments);};}();_this.handleChangeModelNew=function(){var _ref22=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(event){var vehicleModel,vehicleModelId;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:vehicleModel=event?event.label:null;vehicleModelId=event?event.value:null;_this.setState({vehicleModel:vehicleModel,vehicleModelId:vehicleModelId});case 3:case'end':return _context15.stop();}}},_callee15,_this2);}));return function(_x7){return _ref22.apply(this,arguments);};}();_this.fetchModelDetails=function(){var _ref23=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16(event){var makemodellistDetails,fuelType;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16){while(1){switch(_context16.prev=_context16.next){case 0:_this.setState({vehicleModel:event?event.label:null,vehicleModelId:event?event.value:null,emissionRateType:_this.state.emissionRateType,grossVehicleWeight:_this.state.grossVehicleWeight,fuelTankCapacity:_this.state.fuelTankCapacity,adblueCapacity:_this.state.adblueCapacity,manufacturingYear:_this.state.manufacturingYear,fuelType:_this.state.fuelType,engineSpecification:_this.state.engineSpecification,engineSpecificationFromApi:false,emissionRateTypeFromApi:false,grossVehicleWeightFromApi:false,fuelTankCapacityFromApi:false,adblueCapacityFromApi:false,manufacturingYearFromApi:false,fuelTypeFromApi:false});if(!(event&&_this.state.vehicleSegment=='DG Set')){_context16.next=3;break;}return _context16.abrupt('return');case 3:if(!event){_context16.next=15;break;}_context16.prev=4;_context16.next=7;return _this.props.client.query({query:GET_VEHICLE_PARAMS,variables:{modelId:event.value// fetchPolicy: 'network-only'
}});case 7:makemodellistDetails=_context16.sent;console.log(makemodellistDetails.data,'heyyy');if(makemodellistDetails&&makemodellistDetails.data){if(makemodellistDetails.data.getVehicleParameters.length>0){fuelType=makemodellistDetails.data.getVehicleParameters[0]['fuel_type']?makemodellistDetails.data.getVehicleParameters[0]['fuel_type']:_this.state.fuelType;if(fuelType==='Diesel'||fuelType==='diesel'||fuelType==='DIESEL'){fuelType='diesel';}if(fuelType==='Petrol'||fuelType==='petrol'||fuelType==='PETROL'){fuelType='petrol';}_this.setState({emissionRateType:makemodellistDetails.data.getVehicleParameters[0]['emission_type']?makemodellistDetails.data.getVehicleParameters[0]['emission_type']:_this.state.emissionRateType,grossVehicleWeight:makemodellistDetails.data.getVehicleParameters[0]['gross_vehicle_weight']?makemodellistDetails.data.getVehicleParameters[0]['gross_vehicle_weight']:_this.state.grossVehicleWeight,fuelTankCapacity:makemodellistDetails.data.getVehicleParameters[0]['fuel_capacity']?makemodellistDetails.data.getVehicleParameters[0]['fuel_capacity']:_this.state.fuelTankCapacity,adblueCapacity:_this.state.adblueCapacity?_this.state.adblueCapacity:makemodellistDetails.data.getVehicleParameters[0]['adblue_capacity'],//added
// ? makemodellistDetails.data.getVehicleParameters[0][
//     'adblue_capacity'
//   ]
// : this.state.adblueCapacity,
manufacturingYear:makemodellistDetails.data.getVehicleParameters[0]['manufacturing_year']?makemodellistDetails.data.getVehicleParameters[0]['manufacturing_year']:_this.state.manufacturingYear,fuelType:fuelType,engineSpecification:makemodellistDetails.data.getVehicleParameters[0]['engine_specification']?makemodellistDetails.data.getVehicleParameters[0]['engine_specification']:_this.state.engineSpecification});// Set the corresponding flags to true only if data is not null
if(makemodellistDetails.data.getVehicleParameters[0]['emission_type']){_this.setState({emissionRateTypeFromApi:true});}if(makemodellistDetails.data.getVehicleParameters[0]['gross_vehicle_weight']){_this.setState({grossVehicleWeightFromApi:true});}if(makemodellistDetails.data.getVehicleParameters[0]['fuel_capacity']){_this.setState({fuelTankCapacityFromApi:true});}if(makemodellistDetails.data.getVehicleParameters[0]['adblue_capacity']){_this.setState({adblueCapacityFromApi:true});}if(makemodellistDetails.data.getVehicleParameters[0]['manufacturing_year']){_this.setState({manufacturingYearFromApi:true});}if(makemodellistDetails.data.getVehicleParameters[0]['fuel_type']){_this.setState({fuelTypeFromApi:true});}if(makemodellistDetails.data.getVehicleParameters[0]['engine_specification']){_this.setState({engineSpecificationFromApi:true});}}}_context16.next=15;break;case 12:_context16.prev=12;_context16.t0=_context16['catch'](4);_this.setState({emissionRateType:'',// grossVehicleWeight: '',
fuelTankCapacity:'',adblueCapacity:'',manufacturingYear:'',// fuelType: '',
engineSpecification:'',engineSpecificationFromApi:false,emissionRateTypeFromApi:false,grossVehicleWeightFromApi:false,fuelTankCapacityFromApi:false,adblueCapacityFromApi:false,manufacturingYearFromApi:false,fuelTypeFromApi:false});case 15:case'end':return _context16.stop();}}},_callee16,_this2,[[4,12]]);}));return function(_x8){return _ref23.apply(this,arguments);};}();_this.handleChangeModel=function(){var _ref24=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee17(event){var tempId,vehicleDetails,vehicleModel,vehicleModelId,fuelType,make,dgSpecsResponse,dgSpecs,kvaRatingOptions,dgSetTypeOptions,makemodellistDetails,firstElement,_fuelType;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17){while(1){switch(_context17.prev=_context17.next){case 0:tempId=_this.state.vehicleDetails.vehicleModelId;vehicleDetails=_this.state.vehicleDetails;vehicleModel=event?event.label:null;vehicleModelId=event?event.value:null;_this.setState({vehicleModel:vehicleModel,vehicleModelId:vehicleModelId});fuelType=tempId===vehicleModelId&&vehicleDetails.fuelType?vehicleDetails.fuelType:'';if(fuelType==='Diesel'||fuelType==='diesel'||fuelType==='DIESEL'){fuelType='diesel';}if(fuelType==='Petrol'||fuelType==='petrol'||fuelType==='PETROL'){fuelType='petrol';}if(!(event&&_this.state.vehicleSegment=='DG Set')){_context17.next=20;break;}// console.log('state in handleChangeModel',this.state);
make=_this.state.vehicleMakeId;_context17.next=12;return _this.props.client.query({query:GET_DG_SPECS_FROM_MODEL,variables:{make:make,model:event.value// fetchPolicy: 'network-only'
}});case 12:dgSpecsResponse=_context17.sent;dgSpecs=dgSpecsResponse.data.getDgspecsFromModel;kvaRatingOptions=dgSpecs&&dgSpecs.map(function(row){return{value:row.kvaRating,label:row.kvaRating};});if(kvaRatingOptions.length===1){_this.setState({kvaRating:kvaRatingOptions[0].value});}dgSetTypeOptions=dgSpecs&&dgSpecs.map(function(row){return{value:row.dgSetType,label:row.dgSetType};});if(dgSetTypeOptions.length===1){_this.setState({dgSetType:dgSetTypeOptions[0].value});}_this.setState({kvaRatingOptions:kvaRatingOptions,dgSetTypeOptions:dgSetTypeOptions});return _context17.abrupt('return');case 20:_this.setState({emissionRateType:tempId===vehicleModelId&&vehicleDetails.emissionRateType?vehicleDetails.emissionRateType:'',grossVehicleWeight:tempId===vehicleModelId&&vehicleDetails.grossVehicleWeight?vehicleDetails.grossVehicleWeight:'',fuelTankCapacity:tempId===vehicleModelId&&vehicleDetails.fuelTankCapacity?vehicleDetails.fuelTankCapacity:'',adblueCapacity:tempId===vehicleModelId&&vehicleDetails.adblueCapacity?vehicleDetails.adblueCapacity:'',manufacturingYear:tempId===vehicleModelId&&vehicleDetails.manufacturingYear?vehicleDetails.manufacturingYear:'',fuelType:fuelType,engineSpecification:tempId===vehicleModelId&&vehicleDetails.engineSpecification?vehicleDetails.engineSpecification:'',engineSpecificationFromApi:false,emissionRateTypeFromApi:false,grossVehicleWeightFromApi:false,fuelTankCapacityFromApi:false,adblueCapacityFromApi:false,manufacturingYearFromApi:false,fuelTypeFromApi:false});if(!event){_context17.next=33;break;}_context17.prev=22;_context17.next=25;return _this.props.client.query({query:GET_VEHICLE_PARAMS,variables:{modelId:vehicleModelId// fetchPolicy: 'network-only'
}});case 25:makemodellistDetails=_context17.sent;console.log(makemodellistDetails.data,'heyyy');if(makemodellistDetails&&makemodellistDetails.data){if(makemodellistDetails.data.getVehicleParameters.length>0){firstElement=makemodellistDetails.data.getVehicleParameters[0];_fuelType=firstElement['fuel_type']?firstElement['fuel_type']:tempId===vehicleModelId?vehicleDetails.fuelType:'';if(_fuelType==='Diesel'||_fuelType==='diesel'||_fuelType==='DIESEL'){_fuelType='diesel';}if(_fuelType==='Petrol'||_fuelType==='petrol'||_fuelType==='PETROL'){_fuelType='petrol';}_this.setState({emissionRateType:firstElement['emission_type']?firstElement['emission_type']:tempId===vehicleModelId?vehicleDetails.emissionRateType:'',grossVehicleWeight:firstElement['gross_vehicle_weight']?firstElement['gross_vehicle_weight']:tempId===vehicleModelId?vehicleDetails.grossVehicleWeight:'',fuelTankCapacity:firstElement['fuel_capacity']?firstElement['fuel_capacity']:tempId===vehicleModelId?vehicleDetails.fuelTankCapacity:'',adblueCapacity:firstElement['adblue_capacity']?firstElement['adblue_capacity']:tempId===vehicleModelId?vehicleDetails.adblueCapacity:'',manufacturingYear:firstElement['manufacturing_year']?firstElement['manufacturing_year']:tempId===vehicleModelId?vehicleDetails.manufacturingYear:'',fuelType:_fuelType,engineSpecification:firstElement['engine_specification']?firstElement['engine_specification']:tempId===vehicleModelId?vehicleDetails.engineSpecification:''});// Set the corresponding flags to true only if data is not null
if(firstElement['emission_type']){_this.setState({emissionRateTypeFromApi:true});}if(firstElement['gross_vehicle_weight']){_this.setState({grossVehicleWeightFromApi:true});}if(firstElement['fuel_capacity']){_this.setState({fuelTankCapacityFromApi:true});}if(firstElement['adblue_capacity']){_this.setState({adblueCapacityFromApi:true});}if(firstElement['manufacturing_year']){_this.setState({manufacturingYearFromApi:true});}if(firstElement['fuel_type']){_this.setState({fuelTypeFromApi:true});}if(firstElement['engine_specification']){_this.setState({engineSpecificationFromApi:true});}}}_context17.next=33;break;case 30:_context17.prev=30;_context17.t0=_context17['catch'](22);_this.setState({emissionRateType:'',grossVehicleWeight:'',fuelTankCapacity:'',adblueCapacity:'',manufacturingYear:'',fuelType:'',engineSpecification:'',engineSpecificationFromApi:false,emissionRateTypeFromApi:false,grossVehicleWeightFromApi:false,fuelTankCapacityFromApi:false,adblueCapacityFromApi:false,manufacturingYearFromApi:false,fuelTypeFromApi:false});case 33:case'end':return _context17.stop();}}},_callee17,_this2,[[22,30]]);}));return function(_x9){return _ref24.apply(this,arguments);};}();_this.getMakeAndModels=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee18(){var makemodellist;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18){while(1){switch(_context18.prev=_context18.next){case 0:_context18.next=2;return _this.props.client.query({query:GET_VEHICLE_MAKES,variables:{}// fetchPolicy: 'network-only'
});case 2:makemodellist=_context18.sent;_this.setState({makesList:makemodellist.data.getVehicleMakes});case 4:case'end':return _context18.stop();}}},_callee18,_this2);}));_this.getAllDGMakes=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee19(){var responce,makes,makesList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19){while(1){switch(_context19.prev=_context19.next){case 0:_context19.next=2;return _this.props.client.query({query:GET_ALL_DG_MAKES,variables:{}// fetchPolicy: 'network-only'
});case 2:responce=_context19.sent;makes=responce.data.getDgMakes;// console.log('makes',makes);
makesList=makes&&makes.map(function(make){return{make:make,id:make};});// console.log('makesList',makesList);
_this.setState({makesList:makesList});case 6:case'end':return _context19.stop();}}},_callee19,_this2);}));_this.getDgspecsFromModel=function(){var _ref27=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee20(make,model){var dgSpecsResponse,dgSpecs,kvaRatingOptions,dgSetTypeOptions;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20){while(1){switch(_context20.prev=_context20.next){case 0:_context20.prev=0;_context20.next=3;return _this.props.client.query({query:GET_DG_SPECS_FROM_MODEL,variables:{make:make,model:model// fetchPolicy: 'network-only'
}});case 3:dgSpecsResponse=_context20.sent;dgSpecs=dgSpecsResponse.data.getDgspecsFromModel;kvaRatingOptions=dgSpecs&&dgSpecs.map(function(row){return{value:row.kvaRating,label:row.kvaRating};});if(kvaRatingOptions.length===1){_this.setState({kvaRating:kvaRatingOptions[0].value});}dgSetTypeOptions=dgSpecs&&dgSpecs.map(function(row){return{value:row.dgSetType,label:row.dgSetType};});if(dgSetTypeOptions.length===1){_this.setState({dgSetType:dgSetTypeOptions[0].value});}_this.setState({kvaRatingOptions:kvaRatingOptions,dgSetTypeOptions:dgSetTypeOptions});return _context20.abrupt('return');case 13:_context20.prev=13;_context20.t0=_context20['catch'](0);console.log('error in getDgspecsFromModel',_context20.t0);case 16:case'end':return _context20.stop();}}},_callee20,_this2,[[0,13]]);}));return function(_x10,_x11){return _ref27.apply(this,arguments);};}();_this.isNumericalArray=function(array){return array.every(function(item){return!isNaN(item);});};_this.sortNumericalArray=function(array){return array.sort(function(a,b){return parseInt(a)-parseInt(b);});};_this.fetchDropdownDetails=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee21(){var response,dropdownData,dropdownValues;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21){while(1){switch(_context21.prev=_context21.next){case 0:_context21.prev=0;_context21.next=3;return _this.props.client.query({query:GET_DROPDOWN_DETAILS});case 3:response=_context21.sent;console.log('Raw response:',response);dropdownData=JSON.parse(response.data.getDropDownDetail);console.log('Parsed dropdown data:',dropdownData);dropdownValues={};Object.keys(dropdownData).forEach(function(key){if(Array.isArray(dropdownData[key])){dropdownValues[key]=dropdownData[key].filter(function(option){return option!==null;});}if(_this.isNumericalArray(dropdownValues[key])){dropdownValues[key]=_this.sortNumericalArray(dropdownValues[key]);}});_this.setState(Object.assign({},dropdownValues)// selectedApplication: this.state.application
);_context21.next=15;break;case 12:_context21.prev=12;_context21.t0=_context21['catch'](0);console.error('Error fetching dropdown details:',_context21.t0);case 15:case'end':return _context21.stop();}}},_callee21,_this2,[[0,12]]);}));_this.fetchCustomerTypeAndCode=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee22(){var response,customerData,customerValues,customerCode;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22){while(1){switch(_context22.prev=_context22.next){case 0:_context22.prev=0;_context22.next=3;return _this.props.client.query({query:GET_CUSTOMER_TYPE_AND_CODE,variables:{clientName:_this.state.clientName}});case 3:response=_context22.sent;console.log('Raw response:',response);customerData=response.data.getCustomerTypeAndCode;console.log('Parsed customer data:',customerData);customerValues={id:customerData.id,clientName:customerData.clientName,registrationType:customerData.registrationType,directCustomerSAPCode:customerData.directCustomerSAPCode,channelPartnerSAPCode:customerData.channelPartnerSAPCode};customerCode=customerData.directCustomerSAPCode||customerData.channelPartnerSAPCode||'';_this.setState(Object.assign({},customerValues,{customerType:customerData.registrationType,customerCode:customerCode}));_context22.next=15;break;case 12:_context22.prev=12;_context22.t0=_context22['catch'](0);console.error('Error fetching customer type and code:',_context22.t0);case 15:case'end':return _context22.stop();}}},_callee22,_this2,[[0,12]]);}));_this.handleClickOpen=function(){_this.setState({open:true});};_this.handleClose=function(status){_this.setState({open:false});};_this.handleDecoupleOpen=function(){_this.setState({open2:true});};_this.handleDecoupleClose=function(){_this.setState({open2:false});};_this.handleChannelPartnerNameChange=function(event){_this.setState({channelPartnerName:event.target.value});};_this.handleChangeZM=function(){var _ref30=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee23(event){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee23$(_context23){while(1){switch(_context23.prev=_context23.next){case 0:if(event){_this.setState({zmId:event.value});}else{_this.setState({zmId:''});}case 1:case'end':return _context23.stop();}}},_callee23,_this2);}));return function(_x12){return _ref30.apply(this,arguments);};}();_this.handleChangeKAM=function(){var _ref31=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee24(event){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee24$(_context24){while(1){switch(_context24.prev=_context24.next){case 0:if(event){_this.setState({kamId:event.value});}else{_this.setState({kamId:''});}case 1:case'end':return _context24.stop();}}},_callee24,_this2);}));return function(_x13){return _ref31.apply(this,arguments);};}();_this.handleMailClose=function(){_this.setState({open3:false,ismailValid:true,mail:''});};_this.handleSwapClose=function(){_this.setState({swapOpen:false});};_this.handleDeleteClose=function(){_this.setState({deleteOpen:false});};_this.handleSucessDeleteClose=function(){_this.setState({deleteOpen:false});_this.props.history.push({pathname:'/home/VehcileDashboard/Dashboard'});};_this.swapClient=function(){_this.setState({swapOpen:true});};_this.deleteVehicle=function(){_this.setState({deleteOpen:true});};_this.handleGenerate=function(){var _ref32=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee25(event){var _ref33,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee25$(_context25){while(1){switch(_context25.prev=_context25.next){case 0:_context25.next=2;return _this.props.client.query({query:GENERATE_CERTIFICATE,variables:{entityId:parseInt(_this.entityId,10)},fetchPolicy:'network-only'});case 2:_ref33=_context25.sent;data=_ref33.data;if(data.generatePDF){_this.setState({PDFLink:data.generatePDF.filePublicDownloadURL});_this.setState({open3:true});}else{_this.props.openSnackbar('Error in generating Certificate');}case 5:case'end':return _context25.stop();}}},_callee25,_this2);}));return function(_x14){return _ref32.apply(this,arguments);};}();_this.handleSendMail=function(){var _ref34=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee26(event){var responce;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee26$(_context26){while(1){switch(_context26.prev=_context26.next){case 0:_context26.next=2;return _this.props.client.query({query:SEND_MAIL,variables:{email:_this.state.mail,pdfLink:_this.state.PDFLink},fetchPolicy:'network-only'});case 2:responce=_context26.sent;if(responce.data){_this.setState({open3:false,ismailValid:true,mail:''});_this.props.openSnackbar('Link Sent to email Address');}else{_this.props.openSnackbar(responce.error);}case 4:case'end':return _context26.stop();}}},_callee26,_this2);}));return function(_x15){return _ref34.apply(this,arguments);};}();_this.downloadCertificate=function(){var _ref35=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee27(event){var _ref36,data,link;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee27$(_context27){while(1){switch(_context27.prev=_context27.next){case 0:_context27.next=2;return _this.props.client.query({query:GENERATE_CERTIFICATE,variables:{entityId:parseInt(_this.entityId,10)},fetchPolicy:'network-only'});case 2:_ref36=_context27.sent;data=_ref36.data;if(data.generatePDF){_this.setState({PDFLink:data.generatePDF.filePublicDownloadURL});link=document.createElement('a');link.href=_this.state.PDFLink;link.click();URL.revokeObjectURL(link.href);}else{_this.props.openSnackbar('Error in Downloading Certificate');}case 5:case'end':return _context27.stop();}}},_callee27,_this2);}));return function(_x16){return _ref35.apply(this,arguments);};}();_this.entityId=_this.props.match.params.entityId;// Dynamically generate manufacturing year options
var currentYear=new Date().getFullYear();var manufacturingYearOptions=[];for(var i=0;i<=30;i++){manufacturingYearOptions.push({value:currentYear-i,label:''+(currentYear-i)});}// allow admin to edit fields that are otherwise disabled
_this.isAdmin=function(){try{return typeof localStorage!=='undefined'&&localStorage.getItem('role')==='admin';}catch(e){return false;}};_this.state=(_this$state4={/* eslint-disable */duplicateVehicle:false,isDuplicatedDBValue:false,isSpeedLimitValid:true,isSeatLimitValid:false,speedLimit:'',serialNumber:'',rcsSerialNumber:'',partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_24__utils_getLoginId__["a" /* default */])(),// partnerLoginId: 8,
isSerialNumberValid:true,modelName:'',deviceType:'',status:1,phoneNumber:'',isPhoneNoValid:true,simProvider:'',simNumber:'',vlpn:'',isVlpnValid:true,vlpnres:'',vehicleModel:'',vehicleModelId:'',vehicleMake:'',vehicleMakeId:''},_defineProperty(_this$state4,'vehicleModelId',''),_defineProperty(_this$state4,'isVehicleModelValid',true),_defineProperty(_this$state4,'isVehicleMakeValid',true),_defineProperty(_this$state4,'clientName',''),_defineProperty(_this$state4,'isClientNameValid',true),_defineProperty(_this$state4,'vehicleType',''),_defineProperty(_this$state4,'isVehicleTypeValid',true),_defineProperty(_this$state4,'speedSensor',''),_defineProperty(_this$state4,'isSpeedSensorValid',true),_defineProperty(_this$state4,'accessories',null),_defineProperty(_this$state4,'clientsDetails',[]),_defineProperty(_this$state4,'deviceDetails',[]),_defineProperty(_this$state4,'simDetails',[]),_defineProperty(_this$state4,'accessoryDetails',[]),_defineProperty(_this$state4,'response',false),_defineProperty(_this$state4,'failure',false),_defineProperty(_this$state4,'schoolBusEnable',false),_defineProperty(_this$state4,'clientLoginId',''),_defineProperty(_this$state4,'installStatus',false),_defineProperty(_this$state4,'immobilize',false),_defineProperty(_this$state4,'open',false),_defineProperty(_this$state4,'open2',false),_defineProperty(_this$state4,'simId',''),_defineProperty(_this$state4,'engineNumber',''),_defineProperty(_this$state4,'chassisNumber',''),_defineProperty(_this$state4,'seatLimit',''),_defineProperty(_this$state4,'swapOpen',false),_defineProperty(_this$state4,'deleteOpen',false),_defineProperty(_this$state4,'fileResponse',''),_defineProperty(_this$state4,'fileName',''),_defineProperty(_this$state4,'uploadError',''),_defineProperty(_this$state4,'subscriptionDetails',[]),_defineProperty(_this$state4,'idlingSpeed',3),_defineProperty(_this$state4,'invoiceNumber',''),_defineProperty(_this$state4,'equipmentSerialNumber',''),_defineProperty(_this$state4,'equipmentName',''),_defineProperty(_this$state4,'commissioningDate',{date:null,unix:__WEBPACK_IMPORTED_MODULE_41_moment___default()().unix().toString()}),_defineProperty(_this$state4,'invoiceDate',{date:null,unix:__WEBPACK_IMPORTED_MODULE_41_moment___default()().unix().toString()}),_defineProperty(_this$state4,'department',''),_defineProperty(_this$state4,'contractorName',''),_defineProperty(_this$state4,'PDFLink',''),_defineProperty(_this$state4,'open3',false),_defineProperty(_this$state4,'mail',''),_defineProperty(_this$state4,'ismailValid',true),_defineProperty(_this$state4,'vehicleTypes',[]),_defineProperty(_this$state4,'engineTorque',''),_defineProperty(_this$state4,'isEngineTorqueValid',true),_defineProperty(_this$state4,'engineLoad',''),_defineProperty(_this$state4,'isEngineLoadValid',true),_defineProperty(_this$state4,'fuelType',''),_defineProperty(_this$state4,'solutionType',''),_defineProperty(_this$state4,'solution_type',[]),_defineProperty(_this$state4,'isDualEngine',false),_defineProperty(_this$state4,'eoff_voltage',null),_defineProperty(_this$state4,'eon_voltage',null),_defineProperty(_this$state4,'isEonVoltageValid',true),_defineProperty(_this$state4,'isEoffVoltageValid',true),_defineProperty(_this$state4,'hasArm',false),_defineProperty(_this$state4,'isElockConnection',false),_defineProperty(_this$state4,'isFuelTypeValid',true),_defineProperty(_this$state4,'torquePower',''),_defineProperty(_this$state4,'istTorquePowerValid',true),_defineProperty(_this$state4,'engineOnHours',''),_defineProperty(_this$state4,'odometerDistance',''),_defineProperty(_this$state4,'isengineOnHoursValid',true),_defineProperty(_this$state4,'isOdometerDistanceValid',true),_defineProperty(_this$state4,'isEngineSpecificationValid',true),_defineProperty(_this$state4,'emissionRateType',''),_defineProperty(_this$state4,'engineSpecificationFromApi',false),_defineProperty(_this$state4,'emissionRateTypeFromApi',false),_defineProperty(_this$state4,'grossVehicleWeightFromApi',false),_defineProperty(_this$state4,'fuelTankCapacityFromApi',false),_defineProperty(_this$state4,'adblueCapacityFromApi',false),_defineProperty(_this$state4,'manufacturingYearFromApi',false),_defineProperty(_this$state4,'fuelTypeFromApi',false),_defineProperty(_this$state4,'makesList',[]),_defineProperty(_this$state4,'kvaRatingOptions',[]),_defineProperty(_this$state4,'phaseOptions',__WEBPACK_IMPORTED_MODULE_42__utils_phaseOptionsArray__["a" /* phaseOptionsArray */]),_defineProperty(_this$state4,'modelsList',[]),_defineProperty(_this$state4,'emissionList',[]),_defineProperty(_this$state4,'makeModelsMainList',[]),_defineProperty(_this$state4,'grossVehicleWeight',''),_defineProperty(_this$state4,'manufacturingYear',''),_defineProperty(_this$state4,'vehicleSegment',''),_defineProperty(_this$state4,'selectedVTM',''),_defineProperty(_this$state4,'videoTelematicsId',''),_defineProperty(_this$state4,'equipmentTypeClass',''),_defineProperty(_this$state4,'vehicleWheeler',''),_defineProperty(_this$state4,'application',''),_defineProperty(_this$state4,'documentUpload',null),_defineProperty(_this$state4,'baselineDataForFE',''),_defineProperty(_this$state4,'baselineDistance',''),_defineProperty(_this$state4,'baselineHours',null),_defineProperty(_this$state4,'fuelTankCapacity',''),_defineProperty(_this$state4,'adblueCapacity',''),_defineProperty(_this$state4,'isAdblueCapacityValid',true),_defineProperty(_this$state4,'errorMessage',null),_defineProperty(_this$state4,'errorMessageNew',null),_defineProperty(_this$state4,'errorMessageFuelTank',null),_defineProperty(_this$state4,'vtValidationError',null),_defineProperty(_this$state4,'fileNames',''),_defineProperty(_this$state4,'documentUploadNewData',{}),_defineProperty(_this$state4,'uploadProgress',{}),_defineProperty(_this$state4,'equipmentTypeClassOptions',[]),_defineProperty(_this$state4,'vehicleWheelerOptions',[]),_defineProperty(_this$state4,'applicationOptions',[]),_defineProperty(_this$state4,'equipmentTypeClassText',''),_defineProperty(_this$state4,'isBaselineDataForFEValid',true),_defineProperty(_this$state4,'isBaselineDistanceValid',true),_defineProperty(_this$state4,'isBaselineHoursValid',true),_defineProperty(_this$state4,'isDepartmentValid',true),_defineProperty(_this$state4,'isContractorNameValid',true),_defineProperty(_this$state4,'iseoff_voltageValid',true),_defineProperty(_this$state4,'iseon_voltageValid',true),_defineProperty(_this$state4,'isEquipmentNameValid',true),_defineProperty(_this$state4,'isEquipmentValid',true),_defineProperty(_this$state4,'isInvoiceNoValid',true),_defineProperty(_this$state4,'manufacturingYearOptions',manufacturingYearOptions),_defineProperty(_this$state4,'segmentOptions',[{value:'Transportation',label:'Transportation'},{value:'Construction',label:'Construction'},{value:'EVs',label:'EVs'},{value:'Passenger Vehicles',label:'Passenger Vehicles'},{value:'LMs',label:'LMs'},{value:'DG Set',label:'DG Set'}]),_defineProperty(_this$state4,'videoTelematicsType',[{label:'LocoNav',value:'loconav'},{label:'MettaX',value:'mettax'}]),_defineProperty(_this$state4,'dashcamRegistrations',[]),_defineProperty(_this$state4,'dashcamRegistrationsLoading',false),_defineProperty(_this$state4,'assignedTechniciansTaabi',[]),_defineProperty(_this$state4,'assignedTechniciansFreelancer',[]),_defineProperty(_this$state4,'technicianCategory',null),_defineProperty(_this$state4,'selectedTaabiTechnician',null),_defineProperty(_this$state4,'selectedFreelancerTechnician',null),_defineProperty(_this$state4,'technicianName',''),_defineProperty(_this$state4,'updatedBy',typeof localStorage!=='undefined'?localStorage.getItem('username')||'':''),_defineProperty(_this$state4,'vtidOptions',[]),_defineProperty(_this$state4,'selectedVtid',null),_defineProperty(_this$state4,'selectedSimId',''),_defineProperty(_this$state4,'selectedMemoryCardId',''),_defineProperty(_this$state4,'originalVtid',null),_defineProperty(_this$state4,'fileName',''),_defineProperty(_this$state4,'bucketName',''),_defineProperty(_this$state4,'publicUploadURL',''),_defineProperty(_this$state4,'downloadUrl',''),_defineProperty(_this$state4,'isUploading',false),_defineProperty(_this$state4,'vehicleDetails',{}),_defineProperty(_this$state4,'throughChannelPartner',false),_defineProperty(_this$state4,'zmDetails',[]),_defineProperty(_this$state4,'kamDetails',[]),_defineProperty(_this$state4,'zmId',''),_defineProperty(_this$state4,'kamId',''),_defineProperty(_this$state4,'channelPartnerName',''),_defineProperty(_this$state4,'portedVehicle',null),_defineProperty(_this$state4,'isTestingVehicle',null),_defineProperty(_this$state4,'inputParameter',null),_defineProperty(_this$state4,'multiplicationFactor',null),_defineProperty(_this$state4,'kvaRating',''),_defineProperty(_this$state4,'dgSetType',''),_defineProperty(_this$state4,'bhp',''),_defineProperty(_this$state4,'phase',''),_defineProperty(_this$state4,'engineModel',''),_defineProperty(_this$state4,'gensetController',''),_defineProperty(_this$state4,'custCode',''),_defineProperty(_this$state4,'custType',''),_defineProperty(_this$state4,'vehicleData',''),_defineProperty(_this$state4,'rcRegnNo',''),_defineProperty(_this$state4,'rcRegnDt',''),_defineProperty(_this$state4,'rcRegnUpto',''),_defineProperty(_this$state4,'rcPurchaseDt',''),_defineProperty(_this$state4,'rcOwnerSr',''),_defineProperty(_this$state4,'rcOwnerName',''),_defineProperty(_this$state4,'stateCd',''),_defineProperty(_this$state4,'rtoCd',''),_defineProperty(_this$state4,'rcPresentAddress',''),_defineProperty(_this$state4,'rcPermanentAddress',''),_defineProperty(_this$state4,'rcVchCatg',''),_defineProperty(_this$state4,'rcVhClassDesc',''),_defineProperty(_this$state4,'rcChasiNo',''),_defineProperty(_this$state4,'rcEngNo',''),_defineProperty(_this$state4,'rcMakerDesc',''),_defineProperty(_this$state4,'rcMakerModel',''),_defineProperty(_this$state4,'rcBodyTypeDesc',''),_defineProperty(_this$state4,'rcFuelDesc',''),_defineProperty(_this$state4,'rcColor',''),_defineProperty(_this$state4,'rcNormsDesc',''),_defineProperty(_this$state4,'rcFitUpto',''),_defineProperty(_this$state4,'rcNpUpto',''),_defineProperty(_this$state4,'rcNpIssuedBy',''),_defineProperty(_this$state4,'rcTaxUpto',''),_defineProperty(_this$state4,'rcFinancer',''),_defineProperty(_this$state4,'rcInsuranceComp',''),_defineProperty(_this$state4,'rcInsurancePolicyNo',''),_defineProperty(_this$state4,'rcInsuranceUpto',''),_defineProperty(_this$state4,'rcManuMonthYr',''),_defineProperty(_this$state4,'rcUnldWt',null),_defineProperty(_this$state4,'rcGvw',''),_defineProperty(_this$state4,'rcNoCyl',''),_defineProperty(_this$state4,'rcCubicCap',''),_defineProperty(_this$state4,'rcSeatCap',''),_defineProperty(_this$state4,'rcSleeperCap',''),_defineProperty(_this$state4,'rcStandCap',''),_defineProperty(_this$state4,'rcWheelbase',''),_defineProperty(_this$state4,'rcRegisteredAt',''),_defineProperty(_this$state4,'rcStatusAsOn',''),_defineProperty(_this$state4,'rcPuccUpto',''),_defineProperty(_this$state4,'rcPuccNo',''),_defineProperty(_this$state4,'rcStatus',''),_defineProperty(_this$state4,'rcNcrbStatus',''),_defineProperty(_this$state4,'rcBlacklistStatus',''),_defineProperty(_this$state4,'rcPermitNo',''),_defineProperty(_this$state4,'rcPermitIssueDt',''),_defineProperty(_this$state4,'rcPermitValidFrom',''),_defineProperty(_this$state4,'rcPermitValidUpto',''),_defineProperty(_this$state4,'rcPermitType',''),_defineProperty(_this$state4,'rcPermitCode',''),_defineProperty(_this$state4,'rcNocDetails',''),_defineProperty(_this$state4,'rcVhType',''),_defineProperty(_this$state4,'rcVhClass',''),_defineProperty(_this$state4,'rcNocDt',''),_defineProperty(_this$state4,'rcFuelCd',''),_defineProperty(_this$state4,'rcMakerCd',''),_defineProperty(_this$state4,'rcModelCd',''),_defineProperty(_this$state4,'rcNormsCd',''),_defineProperty(_this$state4,'rcSaleAmt',''),_defineProperty(_this$state4,'rcOwnCatgDesc',''),_defineProperty(_this$state4,'rcVchCatgDesc',''),_defineProperty(_this$state4,'rcOwnerCdDesc',''),_defineProperty(_this$state4,'rcCurrentaddDistrictcode',''),_defineProperty(_this$state4,'rcNonUse',''),_defineProperty(_this$state4,'rcPassengerTax',''),_defineProperty(_this$state4,'rcGoodsTax',''),_defineProperty(_this$state4,'rcNoOfAxle',null),_defineProperty(_this$state4,'rcApprovalDate',''),_defineProperty(_this$state4,'rcHp',''),_defineProperty(_this$state4,'rcMandalDesc',''),_defineProperty(_this$state4,'rcTalukCd',''),_defineProperty(_this$state4,'noOfWheels',null),_defineProperty(_this$state4,'noOfGears',null),_defineProperty(_this$state4,'vehicleData',''),_defineProperty(_this$state4,'vehicleRegistrationNumber',''),_defineProperty(_this$state4,'registrationDate',''),_defineProperty(_this$state4,'registrationValidUpto',''),_defineProperty(_this$state4,'stateCode',''),_defineProperty(_this$state4,'rtoCode',''),_defineProperty(_this$state4,'vehicleCategoryCode',''),_defineProperty(_this$state4,'vehicleCategoryDescription',''),_defineProperty(_this$state4,'vehicleClassDescription',''),_defineProperty(_this$state4,'makerDescription',''),_defineProperty(_this$state4,'makerModel',''),_defineProperty(_this$state4,'bodyTypeDescription',''),_defineProperty(_this$state4,'emissionNormsDescription',''),_defineProperty(_this$state4,'fitmentUpto',''),_defineProperty(_this$state4,'nationalPermitUpto',''),_defineProperty(_this$state4,'taxUpto',''),_defineProperty(_this$state4,'insurerName',''),_defineProperty(_this$state4,'insuranceUpto',''),_defineProperty(_this$state4,'manufacturingMonthYear',''),_defineProperty(_this$state4,'unladenWeight',''),_defineProperty(_this$state4,'registeredAt',''),_defineProperty(_this$state4,'puccUpto',''),_defineProperty(_this$state4,'permitNumber',''),_defineProperty(_this$state4,'permitIssueDate',''),_defineProperty(_this$state4,'permitValidFrom',''),_defineProperty(_this$state4,'permitValidUpto',''),_defineProperty(_this$state4,'permitType',''),_defineProperty(_this$state4,'permitCode',''),_defineProperty(_this$state4,'numberOfAxles',''),_defineProperty(_this$state4,'fuelCode',''),_defineProperty(_this$state4,'vehicleClass',''),_defineProperty(_this$state4,'isIndividualViewOrCombinedView',false),_defineProperty(_this$state4,'tensionerConductorLength',null),_defineProperty(_this$state4,'tensionerRotationSensorDirection',''),_defineProperty(_this$state4,'isRotationSensor',false),_defineProperty(_this$state4,'istachoenabled',false),_defineProperty(_this$state4,'tachoidlerpm',''),_defineProperty(_this$state4,'tachoshifthours',''),_defineProperty(_this$state4,'tachoengineonmin',''),_defineProperty(_this$state4,'tachoengineonmax',''),_this$state4);if(_this.props.location.state){_this.setState({clientName:_this.props.location.state.clientId});}else{_this.setState({clientName:''});}return _this;}// Method to update dependent fields based on segment selection
_createClass(VehicleRegistration,[{key:'updateDGSetData',value:function updateDGSetData(){var _this3=this;this.getAllDGMakes();this.setState({vehicleType:'DG Set'},function(){_this3.checkVehicleTypeValidity();});if(!this.state.portedVehicle){this.setState({portedVehicle:true});}if(!this.state.isTestingVehicle){this.setState({isTestingVehicle:true});}if(!this.state.speedSensor){this.setState({speedSensor:'GPS SPEED SENSOR'});}if(!this.state.idlingSpeed){this.setState({idlingSpeed:3});}if(!this.state.speedLimit){this.setState({speedLimit:40});}if(!this.state.solutionType){this.setState({solutionType:'fuel_solution'});}if(!this.state.solution_type){this.setState({solution_type:['fuel']});}}// handleVideoTelematicsMenuChange = selectedOption => {
//   if (selectedOption && selectedOption.value) {
//     this.setState({ selectedVTM: selectedOption.value });
//   } else {
//     this.setState({ selectedVTM: null });
//   }
// }
},{key:'handleRemove',value:function handleRemove(fileName){try{var _state=this.state,uploadProgress=_state.uploadProgress,fileNames=_state.fileNames;// Remove the file from uploadProgress
delete uploadProgress[fileName];// Remove the fileName from the fileNames array
var updatedFileNames=fileNames.split(',').filter(function(name){return name!==fileName;}).join(',');// Update the state with the modified uploadProgress and fileNames
this.setState({uploadProgress:uploadProgress,fileNames:updatedFileNames});}catch(error){}}},{key:'computeLegacySolutionType',// Compute legacy solutionType string from the multi-select solution_type array codes - ported
// verbatim from Vehicle Registration (VehicleRegistartion/index.jsx computeLegacySolutionType)
// so editing a vehicle's solution_type keeps solutionType in sync the same way registration does,
// instead of the two fields drifting apart.
value:function computeLegacySolutionType(solutionCodes){var codeToMaster={fuel:'fuel_solution',obd:'obd_solution',vt:'video_telematics',obdanalogsolution:'obd_analog_solution',basic_tracking:'basic_tracking',ais_140:'ais_140',asset_tracking:'Asset Tracking',control_tower:'control_tower',testing_vehicle:'testing_vehicle','fuel+vt':'fuel+vt','obd+vt':'obd+vt','fuel+obd+vt':'fuel+obd+vt',reverse_camera_screen:'reverse_camera_screen'};if(!solutionCodes||solutionCodes.length===0){return'';}if(solutionCodes.length===1){var code=solutionCodes[0];return codeToMaster[code]||code;}var hasFuel=solutionCodes.includes('fuel_solution');var hasObd=solutionCodes.includes('obd_solution');var hasVt=solutionCodes.includes('video_telematics');if(hasFuel&&hasObd&&hasVt){return'fuel+obd+vt';}if(hasFuel&&hasVt){return'fuel+vt';}if(hasObd&&hasVt){return'obd+vt';}if(hasFuel&&hasObd){return'obd_fuel+fuel_solution';}if(hasVt){if(hasFuel)return'fuel+vt';if(hasObd)return'obd+vt';}var firstCode=solutionCodes[0];return codeToMaster[firstCode]||firstCode;}},{key:'componentDidMount',value:function componentDidMount(){this.getDashcamRegistrations();this.getMakeAndModels();this.getVehicleDetails();this.getZMKAMDetails();this.getAllAssignedRoles();// this.getDGSpecifications()
// this.handleClickOpen()
this.getVehicleType();this.fetchDropdownDetails();this._isMounted=true;}},{key:'componentWillUnmount',value:function componentWillUnmount(){this._isMounted=false;}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState){var _state2=this.state,dashcamRegistrations=_state2.dashcamRegistrations,selectedVtid=_state2.selectedVtid,selectedSimId=_state2.selectedSimId,selectedMemoryCardId=_state2.selectedMemoryCardId;// Ensure we wait for both API responses
if(dashcamRegistrations.length>0&&selectedVtid){// Only proceed if data changed
if(prevState.dashcamRegistrations!==dashcamRegistrations||prevState.selectedVtid!==selectedVtid){var matchedDashcam=dashcamRegistrations.find(function(el){return el.vtid===selectedVtid;});if(matchedDashcam&&this._isMounted&&(prevState.selectedVtid!==matchedDashcam.vtid||prevState.selectedSimId!==matchedDashcam.simid||prevState.selectedMemoryCardId!==matchedDashcam.memorycardid)){this.setState({selectedVtid:matchedDashcam.vtid,selectedSimId:matchedDashcam.simid,selectedMemoryCardId:matchedDashcam.memorycardid});}}}}// Activate deactivate function
// handleClickButtonAction = client => async currentStatus => {
//   let updateStatus
//   if (currentStatus === 0) {
//     updateStatus = true
//   } else {
//     updateStatus = false
//   }
//   const { data, Error } = await client.mutate({
//     mutation: UPDATE_VEHICLE_STATUS,
//     variables: {
//       uniqueDeviceId: this.state.uniqueDeviceId,
//       isActivated: updateStatus
//     },
//     errorPolicy: 'all'
//   })
//   this.setState({
//     currentStatus: ''
//   })
// }
// onUpload = async ({
//   target: {
//     validity,
//     files: [file]
//   }
// }) => {
//   /* eslint-disable */
//   // TODO: Handle upload errors
//   this.setState({ isUploading: true })
//   if (validity.valid) {
//     this.setState({ fileName: file.name })
//     var formdata = new FormData()
//     formdata.append('certificateFile', file, file.name)
//     formdata.append('vehicleNumber', this.state.vlpn)
//     var requestOptions = {
//       method: 'POST',
//       body: formdata,
//       redirect: 'follow'
//     }
//     fetch(process.env.REACT_APP_FILE_UPLOAD_URL, requestOptions)
//       .then(response => response.text())
//       .then(result => this.setState({ fileResponse: result }))
//       .catch(error => this.setState({ uploadError: error }))
//   }
//   this.setState({ isUploading: false })
// }
// Todo function for generate PDF
},{key:'isSubmitFormInvalid',value:function isSubmitFormInvalid(){var _state3=this.state,errorMessage=_state3.errorMessage,errorMessageNew=_state3.errorMessageNew,errorMessageFuelTank=_state3.errorMessageFuelTank,isUploading=_state3.isUploading,isInvoiceNoValid=_state3.isInvoiceNoValid,invoiceNumber=_state3.invoiceNumber,invoiceDate=_state3.invoiceDate,isSerialNumberValid=_state3.isSerialNumberValid,isPhoneNoValid=_state3.isPhoneNoValid,isClientNameValid=_state3.isClientNameValid,isSpeedLimitValid=_state3.isSpeedLimitValid,isSpeedSensorValid=_state3.isSpeedSensorValid,speedLimit=_state3.speedLimit,speedSensor=_state3.speedSensor,showClientDetails=_state3.showClientDetails,subscriptionId=_state3.subscriptionId,vehicleData=_state3.vehicleData,rcMakerDesc=_state3.rcMakerDesc,rcMakerModel=_state3.rcMakerModel,portedVehicle=_state3.portedVehicle,isTestingVehicle=_state3.isTestingVehicle,solutionType=_state3.solutionType,solution_type=_state3.solution_type,vehicleSegment=_state3.vehicleSegment,fuelTankCapacity=_state3.fuelTankCapacity,kvaRating=_state3.kvaRating,dgSetType=_state3.dgSetType,rcRegnNo=_state3.rcRegnNo,noOfWheels=_state3.noOfWheels,selectedApplication=_state3.selectedApplication,haulageType=_state3.haulageType,constructionVehicleType=_state3.constructionVehicleType,passengerVehicleType=_state3.passengerVehicleType,transportationVehicleType=_state3.transportationVehicleType,customerType=_state3.customerType,selectedVTM=_state3.selectedVTM,videoTelematicsId=_state3.videoTelematicsId,vehicleMakeId=_state3.vehicleMakeId,vehicleModelId=_state3.vehicleModelId,serialNumber=_state3.serialNumber,phoneNumber=_state3.phoneNumber,deviceType=_state3.deviceType,vehicleMake=_state3.vehicleMake,vehicleModel=_state3.vehicleModel,adblueCapacity=_state3.adblueCapacity,isAdblueCapacityValid=_state3.isAdblueCapacityValid,isDualEngine=_state3.isDualEngine,eon_voltage=_state3.eon_voltage,eoff_voltage=_state3.eoff_voltage,isEonVoltageValid=_state3.isEonVoltageValid,isEoffVoltageValid=_state3.isEoffVoltageValid;return errorMessage||errorMessageNew||errorMessageFuelTank||isUploading||(customerType=='Paid'||vehicleSegment=='DG Set')&&(!isInvoiceNoValid||!invoiceNumber||!(invoiceDate&&invoiceDate.date))||!isSerialNumberValid||!isPhoneNoValid||!isClientNameValid||!vehicleSegment||!serialNumber||!phoneNumber||!solutionType||!solution_type.length>0||selectedVTM&&!videoTelematicsId||vehicleSegment!='DG Set'&&(// !baselineDataType ||
// !isBaselineDataForFEValid ||
// !baselineDataForFE ||
// (baselineDataType == 'kmpl' && (!baselineDistance || !isBaselineDistanceValid)) ||
// (baselineDataType == 'lph' && (!baselineHours || !isBaselineHoursValid)) ||
!isSpeedLimitValid||!isSpeedSensorValid||!speedLimit||!speedSensor||// !subscriptionId ||
!(this.state.rcRegnNo||this.state.vehicleData&&this.state.vehicleData.rcRegnNo||this.state.vehicleRegistrationNumber||this.state.vlpn)||!(this.state.rcMakerDesc||this.state.vehicleData&&this.state.vehicleData.rcMakerDesc||this.state.makerDescription)||!(this.state.rcMakerModel||this.state.vehicleData&&this.state.vehicleData.rcMakerModel||this.state.makerModel)||portedVehicle===''||isTestingVehicle===''||vehicleSegment=='Transportation'&&(!selectedApplication||!haulageType||!transportationVehicleType)||vehicleSegment=='Construction'&&!constructionVehicleType||vehicleSegment=='Passenger'&&!passengerVehicleType||!(this.state.rcVhType||this.state.vehicleData&&this.state.vehicleData.rcVhType||this.state.vehicleType))||vehicleSegment=='DG Set'&&(!vehicleMakeId||!vehicleModelId||!fuelTankCapacity||!kvaRating||!dgSetType)||(deviceType=='obd'||deviceType=='OBD')&&(!vehicleMakeId||!vehicleModelId||!vehicleMake||!vehicleModel)||deviceType&&deviceType.toLowerCase()==='obd'&&(!adblueCapacity||!isAdblueCapacityValid)||isDualEngine&&(!eon_voltage||!eoff_voltage||!isEonVoltageValid||!isEoffVoltageValid)||this.state.vehicleSegment==='Construction'&&this.state.constructionVehicleType==='Tensioner'&&(!this.state.tensionerConductorLength||!this.state.tensionerRotationSensorDirection);}},{key:'render',value:function render(){var _this4=this;var uploadProgress=this.state.uploadProgress;var classes=this.props;var allSpeedSensor=[];allSpeedSensor[0]={value:'GPS SPEED SENSOR',label:'Gps speed sensor'};allSpeedSensor[1]={value:'DELTA_DISTANCE_CALCULATION',label:'Delta Distance'};allSpeedSensor[2]={value:'ODOMETRIC',label:'Odometric'};var allIdlingSpeed=[{value:0,label:0},{value:1,label:1},{value:2,label:2},{value:3,label:3}];// let vehiclearr = [
//   'Car',
//   'Truck',
//   'Ambulance',
//   'School Bus',
//   'Bike',
//   'Sixseater',
//   'Stacker',
//   'Tow',
//   'Tug',
//   'Tractor',
//   'Excavator',
//   '3-Wheeler',
//   'GeneratorTanker'
// ]
var allvehicleTypes=this.state.vehicleTypes.map(function(vehicle){return{value:vehicle,label:vehicle};});if(this.state.vehicleSegment=='DG Set'){allvehicleTypes=[].concat(_toConsumableArray(this.state.vehicleTypes.map(function(vehicle){return{value:vehicle,label:vehicle};})),[{value:'DG Set',label:'DG Set'}]);}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'Landing'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button___default.a,{variant:'outlined',color:'primary',className:'btn',onClick:function onClick(){return _this4.props.history.goBack();}},'Back'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,justify:'center',className:'full-screen',alignItems:'flex-end'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',{className:'Formheader'},'Edit Vehicle Detail'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'formouter'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'Customer Details')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,className:'searchdiv',spacing:'8'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__ClientDetails__["a" /* default */],{clientName:this.state.clientName,address:this.state.address,city:this.state.city,loginId:this.state.id})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,justify:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{style:{marginRight:'20px'}},'Video Telematics'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{style:{minWidth:'50%',marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40_react_select__["a" /* default */],{options:this.state.videoTelematicsType,value:this.state.selectedVTM,disabled:!this.isAdmin(),onChange:this.handleVideoTelematicsMenuChange,placeholder:'Select Video Telematics Type'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isClientNameValid?'Invalid Selection':'')))),this.state.selectedVTM?this.state.selectedVTM==='mettax'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,justify:'center',style:{width:'50%'}},this.state.dashcamRegistrationsLoading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center',padding:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core_CircularProgress___default.a,{size:40})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{style:{marginRight:'20px'}},'Mettax VT ID *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40_react_select__["a" /* default */]// show available options, and also include the
// originalVtid (if present) so it appears in
// edit mode even when it's not 'available'
,{options:this.state.vtidOptions.filter(function(el){return el.status==='available'||_this4.state.originalVtid&&el.value==_this4.state.originalVtid;}),value:this.state.selectedVtid,onChange:this.handleVtidChange,placeholder:'Select Video Telematics ID',className:'select-input',disabled:!this.isAdmin()}))),this.state.originalVtid&&!this.state.vtidOptions.some(function(el){return el.value==_this4.state.originalVtid;})&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{style:{color:'red',fontSize:'12px',marginTop:'5px'}},'VT ID',' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('strong',null,this.state.originalVtid),' ','is not registered in Dashcam Registration Page.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'simId',className:'textfield',margin:'dense',label:'Unregistered VT ID',type:'text',disabled:!this.isAdmin(),value:this.state.originalVtid})),this.state.selectedVtid&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:2,style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'simId',className:'textfield',margin:'dense',label:'SIM ID',type:'text',disabled:!this.isAdmin(),value:this.state.selectedSimId})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'memoryCardId',className:'textfield',margin:'dense',label:'Memory Card Memory',type:'text',disabled:!this.isAdmin(),value:this.state.selectedMemoryCardId}))))))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,justify:'center',style:{width:'50%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,null,this.state.dashcamRegistrationsLoading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center',padding:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core_CircularProgress___default.a,{size:30})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{className:'textfield',margin:'dense',label:'Video Telematics Id'+(this.state.selectedVTM?'*':''),value:this.state.videoTelematicsId,onChange:this.handleVideoTelematicsIdChange})))):null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_InputLabel___default.a,{htmlFor:'custCode',style:{marginTop:'-10px'},shrink:!!this.state.customerCode},'Customer Code'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{style:{maxWidth:'50%'},id:'custCode',name:'custCode',className:'textfield',margin:'dense',type:'text',value:this.state.customerCode,onChange:this.handleInputChange('customerCode'),InputProps:{readOnly:!this.isAdmin()}//error={!this.state.isrcRegnDtValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_InputLabel___default.a,{htmlFor:'custType',style:{marginTop:'-10px'},shrink:!!this.state.customerType},'Customer Type'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{style:{maxWidth:'50%'},id:'custType',name:'custType',className:'textfield',margin:'dense',type:'text',value:this.state.customerType,onChange:this.handleInputChange('customerType'),InputProps:{readOnly:!this.isAdmin()}//error={!this.state.isrcRegnDtValid}
})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,fullwidth:true,style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:6,sm:6,style:{marginTop:'2px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Segment *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40_react_select__["a" /* default */]// options={this.state.segmentOptions}
,{options:Array.isArray(this.state.vehiclesegment)&&this.state.vehiclesegment.map(function(option){return{label:option,value:option};}),value:this.state.vehicleSegment,onChange:this.handleSegmentChange,placeholder:'Segment *'}))),this.state.vehicleSegment==='Transportation'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'16px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Transportation Vehicle Type *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40_react_select__["a" /* default */]// options={this.state.constructionVehicleTypeOptions}
,{options:Array.isArray(this.state.transportationvehicletype)&&this.state.transportationvehicletype.map(function(option){return{label:option,value:option};}),value:this.state.transportationVehicleType,onChange:function onChange(selectedOption){return _this4.setState({transportationVehicleType:selectedOption?selectedOption.value:''});},placeholder:'Select Transportation Vehicle Type *'}))),this.state.vehicleSegment==='Transportation'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'16px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Application *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40_react_select__["a" /* default */]// options={this.state.applicationOptions}
,{options:Array.isArray(this.state.application)&&this.state.application.map(function(option){return{label:option,value:option};}),value:this.state.selectedApplication,onChange:function onChange(selectedOption){return _this4.setState({selectedApplication:selectedOption?selectedOption.value:''});},placeholder:'Select Application *'}))),this.state.vehicleSegment==='Transportation'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'16px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Haulage Type *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40_react_select__["a" /* default */]// options={this.state.haulageTypeOptions}
,{options:Array.isArray(this.state.haulagetype)&&this.state.haulagetype.map(function(option){return{label:option,value:option};}),value:this.state.haulageType,onChange:function onChange(selectedOption){return _this4.setState({haulageType:selectedOption?selectedOption.value:''});},placeholder:'Select Haulage Type *'}))),this.state.vehicleSegment==='Construction'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'16px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Construction Vehicle Type *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40_react_select__["a" /* default */]// options={this.state.constructionVehicleTypeOptions}
,{options:Array.isArray(this.state.constructionvehicletype)&&this.state.constructionvehicletype.map(function(option){return{label:option,value:option};}),value:this.state.constructionVehicleType,onChange:function onChange(selectedOption){return _this4.setState({constructionVehicleType:selectedOption?selectedOption.value:''});},placeholder:'Select Construction Vehicle Type *'}))),this.state.vehicleSegment==='Construction'&&this.state.constructionVehicleType==='Tensioner'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__TensionerRotationSensorReminder__["a" /* default */],null),this.state.vehicleSegment==='Construction'&&this.state.constructionVehicleType==='Tensioner'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'16px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Conductor Length (in km) *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Input___default.a,{type:'number',placeholder:'Conductor Length (in m)',value:this.state.tensionerConductorLength,onChange:function onChange(e){_this4.setState({tensionerConductorLength:Number(e.target.value)<0?0:Number(e.target.value)});}}))),this.state.vehicleSegment==='Construction'&&this.state.constructionVehicleType==='Tensioner'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'16px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Rotation Sensor Direction *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40_react_select__["a" /* default */],{options:[{value:'clockwise',label:'Clockwise'},{value:'anticlockwise',label:'Anticlockwise'}],value:this.state.tensionerRotationSensorDirection?{value:this.state.tensionerRotationSensorDirection,label:this.state.tensionerRotationSensorDirection==='clockwise'?'Clockwise':'Anticlockwise'}:null,onChange:function onChange(selectedOption){return _this4.setState({tensionerRotationSensorDirection:selectedOption?selectedOption.value:''});},placeholder:'Select Rotation Sensor Direction *'}))),this.state.vehicleSegment==='Passenger'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'16px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Passenger Vehicle Type *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40_react_select__["a" /* default */]// options={this.state.constructionVehicleTypeOptions}
,{options:Array.isArray(this.state.passengervehicletype)&&this.state.passengervehicletype.map(function(option){return{label:option,value:option};}),value:this.state.passengerVehicleType,onChange:function onChange(selectedOption){return _this4.setState({passengerVehicleType:selectedOption?selectedOption.value:''});},placeholder:'Select Passenger Vehicle Type *'}))),this.state.vehicleSegment!=='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_FormControlLabel___default.a,{style:{marginTop:'20px'},label:'Vehicle Registration Number Available',control:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Checkbox___default.a,{checked:this.state.vehicleRegistrationNumberAvailableStatus,onChange:this.handleVehicleRegistrationNumberAvailableChange('vehicleRegistrationNumberAvailableStatus'),value:'vehicleRegistrationNumberAvailableStatus',color:'primary'})}))),this.state.vehicleSegment!=='DG Set'&&this.state.vehicleRegistrationNumberAvailableStatus&&(this.state.loading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'center',alignItems:'center',height:'100px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core_CircularProgress___default.a,null)):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,justify:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{style:{marginRight:'20px'}},'Vehicle Registration Number *',' '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{style:{minWidth:'19.5%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{variant:'outlined',fullWidth:true,margin:'normal',value:this.state.enteredVehicleRegistrationNumber// onChange={
//   this.checkVlpnValidity
// }
,placeholder:'Enter Vehicle Registration Number *',name:'enteredVehicleRegistrationNumber',onChange:function onChange(event){return _this4.setState({enteredVehicleRegistrationNumber:event.target.value});}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button___default.a,{color:'default',variant:'outlined',size:'medium',margin:'normal',className:'btn',onClick:this.getDataByVehicleNumber},'Get Data'),this.state.vlpnres&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormHelperText___default.a,{className:'Error_msg'},this.state.vlpnres))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,fullwidth:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_InputLabel___default.a,{htmlFor:'vehicleNickName',style:{marginTop:'-10px'},shrink:this.state.vehicleNickName||this.state.vehicleData&&this.state.vehicleData.rcRegnNo||this.state.rcRegnNo||this.state.vehicleRegistrationNumber||this.state.vlpn},'Vehicle Name/Number to be displayed on vehicle card (ex. Hyva Truck 08)'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'vehicleNickName',name:'vehicleNickName',className:'textfield',margin:'dense',type:'text',value:this.state.vehicleNickName||this.state.vehicleData&&this.state.vehicleData.rcRegnNo||this.state.rcRegnNo||this.state.vehicleRegistrationNumber||this.state.vlpn,onChange:this.handleInputChange('vehicleNickName')})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,fullwidth:true,style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{xs:6,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,this.state.vehicleSegment=='DG Set'?'Vehicle/DG Info':'Vehicle Info')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{xs:6,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'Device and SIM Info')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:6,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'vlpn',name:'vlpn',className:'textfield',margin:'dense',disabled:!this.isAdmin(),label:this.state.vehicleSegment=='DG Set'?'Vehicle/Asset Number':'Vehicle Number'// type="Multi-line"
,value:this.state.vehicleData&&this.state.vehicleData.rcRegnNo||this.state.vlpn,required:true,onChange:this.handleInputChange('vlpn'),error:!this.state.isVlpnValid,onBlur:this.checkVlpnValidity(this.props.client)}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isVlpnValid?this.state.vlpnres:''))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{backgroundColor:'#f2f2f2',padding:'10px',borderRadius:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',null,'Auto Fill Entry Section'),this.state.vehicleSegment!='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{xs:12,sm:12,mt:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_InputLabel___default.a,{htmlFor:'rcRegnNo',style:{marginTop:'-10px'},shrink:this.state.rcRegnNo||this.state.vehicleData&&this.state.vehicleData.rcRegnNo||this.state.vehicleRegistrationNumber||this.state.vlpn},'Vehicle Registration Number *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'rcRegnNo',name:'rcRegnNo',disabled:!this.isAdmin(),className:'textfield',margin:'dense'//label={"Vehicle Registration Number"}
,type:'text'// type="Multi-line"
// value={this.state.rcRegnNo}
// value={this.state.vehicleData ? this.state.vehicleData.rcRegnNo : this.state.vehicleRegistrationNumber || this.state.vlpn}
,value:this.state.rcRegnNo||this.state.vehicleData&&this.state.vehicleData.rcRegnNo||this.state.vehicleRegistrationNumber||this.state.vlpn,required:true,onChange:this.handleInputChange('rcRegnNo')// onChange={this.handleInputChange('vlpn')}
// error={!this.state.isVlpnValid}
// onBlur={this.checkVlpnValidity(this.props.client)}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_InputLabel___default.a,{htmlFor:'rcRegnDt',style:{marginTop:'-10px'}// shrink={((this.state.vehicleData && this.state.vehicleData.rcRegnDt)|| this.state.rcRegnDt)}
,shrink:this.state.rcRegnDt||this.state.vehicleData&&this.state.vehicleData.rcRegnDt||this.state.registrationDate||''},'Registration Date'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'rcRegnDt',name:'rcRegnDt',className:'textfield',margin:'dense'//label="Registration Date"
,type:'text'// type="Multi-line"
,value:this.state.rcRegnDt||this.state.vehicleData&&this.state.vehicleData.rcRegnDt||this.state.registrationDate||''// value={(this.state.vehicleData && this.state.vehicleData.rcRegnDt) || ''}
,onChange:this.handleInputChange('rcRegnDt')//error={!this.state.isrcRegnDtValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_InputLabel___default.a,{htmlFor:'rcRegnUpto',style:{marginTop:'-10px'},shrink:this.state.rcRegnUpto||this.state.vehicleData&&this.state.vehicleData.rcRegnUpto||this.state.registrationValidUpto||''},'Registration Valid Upto'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'rcRegnUpto',name:'rcRegnUpto',className:'textfield',margin:'dense'//label="Registration Valid Upto"
,type:'text'// type="Multi-line"
,value:this.state.rcRegnUpto||this.state.vehicleData&&this.state.vehicleData.rcRegnUpto||this.state.registrationValidUpto||'',onChange:this.handleInputChange('rcRegnUpto')//error={!this.state.isrcRegnUptoValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_InputLabel___default.a,{htmlFor:'stateCd',style:{marginTop:'-10px'},shrink:this.state.stateCd||this.state.vehicleData&&this.state.vehicleData.stateCd||this.state.stateCode||''},'State Code'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'stateCd',name:'stateCd',className:'textfield',margin:'dense'//label="State Code"
,type:'text'// type="Multi-line"
,value:this.state.stateCd||this.state.vehicleData&&this.state.vehicleData.stateCd||this.state.stateCode||'',onChange:this.handleInputChange('stateCd')//error={!this.state.isstateCdValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_InputLabel___default.a,{htmlFor:'rtoCd',style:{marginTop:'-10px'},shrink:this.state.rtoCd||this.state.vehicleData&&this.state.vehicleData.rtoCd||this.state.rtoCode||''},'RTO Code'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'rtoCd',name:'rtoCd',className:'textfield',margin:'dense'//label="RTO Code"
,type:'text'// type="Multi-line"
,value:this.state.rtoCd||this.state.vehicleData&&this.state.vehicleData.rtoCd||this.state.rtoCode||'',onChange:this.handleInputChange('rtoCd')//error={!this.state.isrtoCdValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_InputLabel___default.a,{htmlFor:'rcVchCatg',style:{marginTop:'-10px'},shrink:this.state.rcVchCatg||this.state.vehicleData&&this.state.vehicleData.rcVchCatg||this.state.vehicleCategoryCode||''},'Vehicle Category Code'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'rcVchCatg',name:'rcVchCatg',className:'textfield',margin:'dense'//label="Vehicle Category Code"
,type:'text'// type="Multi-line"
,value:this.state.rcVchCatg||this.state.vehicleData&&this.state.vehicleData.rcVchCatg||this.state.vehicleCategoryCode||'',onChange:this.handleInputChange('rcVchCatg')//error={!this.state.isrcVchCatgValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_InputLabel___default.a,{htmlFor:'rcVhClassDesc',style:{marginTop:'-10px'},shrink:this.state.rcVhClassDesc||this.state.vehicleData&&this.state.vehicleData.rcVhClassDesc||this.state.vehicleClassDescription||''},'Vehicle Class Description'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'rcVhClassDesc',name:'rcVhClassDesc',className:'textfield',margin:'dense'//label="Vehicle Class Description"
,type:'text'// type="Multi-line"
,value:this.state.rcVhClassDesc||this.state.vehicleData&&this.state.vehicleData.rcVhClassDesc||this.state.vehicleClassDescription||'',onChange:this.handleInputChange('rcVhClassDesc')//error={!this.state.isrcVhClassDescValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_InputLabel___default.a,{htmlFor:'rcChasiNo',style:{marginTop:'-10px'},shrink:this.state.rcChasiNo||this.state.vehicleData&&this.state.vehicleData.rcChasiNo||this.state.chassisNumber||''},'Chassis Number'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'rcChasiNo',name:'rcChasiNo',className:'textfield',margin:'dense'//label="Chassis Number"
,type:'text'// type="Multi-line"
,value:this.state.rcChasiNo||this.state.vehicleData&&this.state.vehicleData.rcChasiNo||this.state.chassisNumber||'',onChange:this.handleInputChange('rcChasiNo')//error={!this.state.isrcChasiNoValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_InputLabel___default.a,{htmlFor:'rcEngNo',style:{marginTop:'-10px'},shrink:this.state.rcEngNo||this.state.vehicleData&&this.state.vehicleData.rcEngNo||this.state.engineNumber||''},'Engine Number'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'rcEngNo',name:'rcEngNo',className:'textfield',margin:'dense'//label="Engine Number"
,type:'text'// type="Multi-line"
,value:this.state.rcEngNo||this.state.vehicleData&&this.state.vehicleData.rcEngNo||this.state.engineNumber||'',onChange:this.handleInputChange('rcEngNo')//error={!this.state.isrcEngNoValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_InputLabel___default.a,{htmlFor:'rcMakerDesc',style:{marginTop:'-10px'},shrink:this.state.rcMakerDesc||this.state.vehicleData&&this.state.vehicleData.rcMakerDesc||this.state.makerDescription||''},'Maker Description *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'rcMakerDesc',name:'rcMakerDesc',className:'textfield',margin:'dense'//label="Maker Description"
,type:'text'// type="Multi-line"
,value:this.state.rcMakerDesc||this.state.vehicleData&&this.state.vehicleData.rcMakerDesc||this.state.makerDescription||'',onChange:this.handleInputChange('rcMakerDesc')//error={!this.state.isrcMakerDescValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_InputLabel___default.a,{htmlFor:'rcMakerModel',style:{marginTop:'-10px'},shrink:this.state.rcMakerModel||this.state.vehicleData&&this.state.vehicleData.rcMakerModel||this.state.makerModel||''},'Maker Model *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'rcMakerModel',name:'rcMakerModel',className:'textfield',margin:'dense'//label="Maker Model"
,type:'text'// type="Multi-line"
,value:this.state.rcMakerModel||this.state.vehicleData&&this.state.vehicleData.rcMakerModel||this.state.makerModel||'',onChange:this.handleInputChange('rcMakerModel')//error={!this.state.isrcMakerModelValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_InputLabel___default.a,{htmlFor:'rcBodyTypeDesc',style:{marginTop:'-10px'},shrink:this.state.rcBodyTypeDesc||this.state.vehicleData&&this.state.vehicleData.rcBodyTypeDesc||this.state.bodyTypeDescription||''},'Body Type Description'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'rcBodyTypeDesc',name:'rcBodyTypeDesc',className:'textfield',margin:'dense'//label="Body Type Description"
,type:'text'// type="Multi-line"
,value:this.state.rcBodyTypeDesc||this.state.vehicleData&&this.state.vehicleData.rcBodyTypeDesc||this.state.bodyTypeDescription||'',onChange:this.handleInputChange('rcBodyTypeDesc')//error={!this.state.isrcBodyTypeDescValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{xs:12,sm:12,mt:4,style:{marginTop:'20px'}},'Fuel Type'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},this.state.vehicleSegment!=='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40_react_select__["a" /* default */],{id:'rcFuelDesc',name:'rcFuelDesc',classes:classes,options:[{value:'petrol',label:'PETROL'},{value:'diesel',label:'DIESEL'},{value:'ev',label:'EV'},{value:'cng',label:'CNG'},{value:'lng',label:'LNG'}]// components={components}
// value={this.state.rcFuelDesc}
,value:this.state.rcFuelDesc||(this.state.vehicleData&&this.state.vehicleData.rcFuelDesc?(this.state.vehicleData&&this.state.vehicleData.rcFuelDesc).toLowerCase():null)||this.state.fuelType||'',onChange:function onChange(selectedOption){_this4.setState({rcFuelDesc:selectedOption?selectedOption.value:''});},placeholder:'Fuel Type'//disabled={this.state.fuelTypeFromApi}
}),this.state.vehicleSegment==='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40_react_select__["a" /* default */],{id:'rcFuelDesc',name:'rcFuelDesc',classes:classes,options:[{value:'petrol',label:'PETROL'},{value:'diesel',label:'DIESEL'}]// components={components}
//value={this.state.fuelType}
,value:this.state.rcFuelDesc||this.state.vehicleData&&this.state.vehicleData.rcFuelDesc||this.state.fuelType||'',onChange:function onChange(selectedOption){_this4.setState({rcFuelDesc:selectedOption?selectedOption.value:''});},placeholder:'Fuel Type'//disabled={this.state.fuelTypeFromApi}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_InputLabel___default.a,{htmlFor:'rcNormsDesc',style:{marginTop:'-10px'},shrink:this.state.rcNormsDesc||this.state.vehicleData&&this.state.vehicleData.rcNormsDesc||this.state.emissionNormsDescription||''},'Emission Norms Description'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'rcNormsDesc',name:'rcNormsDesc',className:'textfield',margin:'dense'//label="Emission Norms Description"
,type:'text'// type="Multi-line"
,value:this.state.rcNormsDesc||this.state.vehicleData&&this.state.vehicleData.rcNormsDesc||this.state.emissionNormsDescription||'',onChange:this.handleInputChange('rcNormsDesc')//error={!this.state.isrcNormsDescValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_InputLabel___default.a,{htmlFor:'rcFitUpto',style:{marginTop:'-10px'},shrink:this.state.rcFitUpto||this.state.vehicleData&&this.state.vehicleData.rcFitUpto||this.state.fitmentUpto||''},'Fitment Upto'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'rcFitUpto',name:'rcFitUpto',className:'textfield',margin:'dense'//label="Fitment Upto"
,type:'text'// type="Multi-line"
,value:this.state.rcFitUpto||this.state.vehicleData&&this.state.vehicleData.rcFitUpto||this.state.fitmentUpto||'',onChange:this.handleInputChange('rcFitUpto')//error={!this.state.isrcFitUptoValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_InputLabel___default.a,{htmlFor:'rcNpUpto',style:{marginTop:'-10px'},shrink:this.state.rcNpUpto||this.state.vehicleData&&this.state.vehicleData.rcNpUpto||this.state.nationalPermitUpto||''},'National Permit Upto'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'rcNpUpto',name:'rcNpUpto',className:'textfield',margin:'dense'//label="National Permit Upto"
,type:'text'// type="Multi-line"
,value:this.state.rcNpUpto||this.state.vehicleData&&this.state.vehicleData.rcNpUpto||this.state.nationalPermitUpto||'',onChange:this.handleInputChange('rcNpUpto')//error={!this.state.isrcNpUptoValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_InputLabel___default.a,{htmlFor:'rcTaxUpto',style:{marginTop:'-10px'},shrink:this.state.rcTaxUpto||this.state.vehicleData&&this.state.vehicleData.rcTaxUpto||this.state.taxUpto||''},'Tax Upto'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'rcTaxUpto',name:'rcTaxUpto',className:'textfield',margin:'dense'//label="Tax Upto"
,type:'text'// type="Multi-line"
,value:this.state.rcTaxUpto||this.state.vehicleData&&this.state.vehicleData.rcTaxUpto||this.state.taxUpto||'',onChange:this.handleInputChange('rcTaxUpto')//error={!this.state.isrcTaxUptoValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_InputLabel___default.a,{htmlFor:'rcInsuranceComp',style:{marginTop:'-10px'},shrink:this.state.rcInsuranceComp||this.state.vehicleData&&this.state.vehicleData.rcInsuranceComp||this.state.insurerName||''},'Insurer Name'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'rcInsuranceComp',name:'rcInsuranceComp',className:'textfield',margin:'dense'//label="Insurer Name"
,type:'text'// type="Multi-line"
,value:this.state.rcInsuranceComp||this.state.vehicleData&&this.state.vehicleData.rcInsuranceComp||this.state.insurerName||'',onChange:this.handleInputChange('rcInsuranceComp')//error={!this.state.isrcInsuranceCompValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_InputLabel___default.a,{htmlFor:'rcInsuranceUpto',style:{marginTop:'-10px'},shrink:this.state.rcInsuranceComp||this.state.vehicleData&&this.state.vehicleData.rcInsuranceComp||this.state.insuranceUpto||''},'Insurer Upto'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'rcInsuranceUpto',name:'rcInsuranceUpto',className:'textfield',margin:'dense'//label="Insurance Upto"
,type:'text'// type="Multi-line"
,value:this.state.rcInsuranceComp||this.state.vehicleData&&this.state.vehicleData.rcInsuranceComp||this.state.insuranceUpto||'',onChange:this.handleInputChange('rcInsuranceUpto')//error={!this.state.isrcInsuranceUptoValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_InputLabel___default.a,{htmlFor:'rcManuMonthYr',style:{marginTop:'-10px'},shrink:this.state.rcManuMonthYr||this.state.vehicleData&&this.state.vehicleData.rcManuMonthYr||this.state.manufacturingMonthYear||''},'Manufacturing Month/Year'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'rcManuMonthYr',name:'rcManuMonthYr',className:'textfield',margin:'dense'//label="Manufacturing Month/Year"
,type:'text'// type="Multi-line"
,value:this.state.rcManuMonthYr||this.state.vehicleData&&this.state.vehicleData.rcManuMonthYr||this.state.manufacturingMonthYear||'',onChange:this.handleInputChange('rcManuMonthYr')//error={!this.state.isrcManuMonthYrValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_InputLabel___default.a,{htmlFor:'rcUnldWt',style:{marginTop:'-10px'},shrink:this.state.rcUnldWt||this.state.vehicleData&&this.state.vehicleData.rcUnldWt||this.state.unladenWeight||''},'Unladen Weight'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'rcUnldWt',name:'rcUnldWt',className:'textfield',margin:'dense'//label="Unladen Weight"
,type:'number'// type="Multi-line"
,value:this.state.rcUnldWt||this.state.vehicleData&&this.state.vehicleData.rcUnldWt||this.state.unladenWeight||'',onChange:this.handleInputChange('rcUnldWt')//error={!this.state.isrcUnldWtValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_InputLabel___default.a,{htmlFor:'rcGvw',style:{marginTop:'-10px'},shrink:this.state.rcGvw||this.state.vehicleData&&this.state.vehicleData.rcGvw||this.state.grossVehicleWeight||''},'Gross Vehicle Weight (GVW)'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'rcGvw',name:'rcGvw',className:'textfield',margin:'dense'//label="Gross Vehicle Weight (GVW)"
//type="text"
// type="Multi-line"
,value:this.state.rcGvw||this.state.vehicleData&&this.state.vehicleData.rcGvw||this.state.grossVehicleWeight||'',onChange:this.handleInputChange('rcGvw'),type:'number',inputProps:{step:'0.01'}//error={!this.state.isrcGvwValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_InputLabel___default.a,{htmlFor:'rcRegisteredAt',style:{marginTop:'-10px'},shrink:this.state.rcRegisteredAt||this.state.vehicleData&&this.state.vehicleData.rcRegisteredAt||this.state.registeredAt||''},'Registered At'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'rcRegisteredAt',name:'rcRegisteredAt',className:'textfield',margin:'dense'//label="Registered At"
,type:'text'// type="Multi-line"
,value:this.state.rcRegisteredAt||this.state.vehicleData&&this.state.vehicleData.rcRegisteredAt||this.state.registeredAt||'',onChange:this.handleInputChange('rcRegisteredAt')//error={!this.state.isrcRegisteredAtValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_InputLabel___default.a,{htmlFor:'rcPuccUpto',style:{marginTop:'-10px'},shrink:this.state.rcPuccUpto||this.state.vehicleData&&this.state.vehicleData.rcPuccUpto||this.state.puccUpto||''},'Pollution Under Control Certificate (PUCC) Upto'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'rcPuccUpto',name:'rcPuccUpto',className:'textfield',margin:'dense'//label="Pollution Under Control Certificate (PUCC) Upto"
,type:'text'// type="Multi-line"
,value:this.state.rcPuccUpto||this.state.vehicleData&&this.state.vehicleData.rcPuccUpto||this.state.puccUpto||'',onChange:this.handleInputChange('rcPuccUpto')//error={!this.state.isrcPuccUptoValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_InputLabel___default.a,{htmlFor:'rcPermitNo',style:{marginTop:'-10px'},shrink:this.state.rcPermitNo||this.state.vehicleData&&this.state.vehicleData.rcPermitNo||this.state.permitNumber||''},'Permit Number'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'rcPermitNo',name:'rcPermitNo',className:'textfield',margin:'dense'//label="Permit Number"
,type:'text'// type="Multi-line"
,value:this.state.rcPermitNo||this.state.vehicleData&&this.state.vehicleData.rcPermitNo||this.state.permitNumber||'',onChange:this.handleInputChange('rcPermitNo')//error={!this.state.isrcPermitNoValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_InputLabel___default.a,{htmlFor:'rcPermitIssueDt',style:{marginTop:'-10px'},shrink:this.state.rcPermitIssueDt||this.state.vehicleData&&this.state.vehicleData.rcPermitIssueDt||this.state.permitIssueDate||''},'Permit Issue Date'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'rcPermitIssueDt',name:'rcPermitIssueDt',className:'textfield',margin:'dense'//label="Permit Issue Date"
,type:'text'// type="Multi-line"
,value:this.state.rcPermitIssueDt||this.state.vehicleData&&this.state.vehicleData.rcPermitIssueDt||this.state.permitIssueDate||'',onChange:this.handleInputChange('rcPermitIssueDt')//error={!this.state.isrcPermitIssueDtValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_InputLabel___default.a,{htmlFor:'rcPermitValidFrom',style:{marginTop:'-10px'},shrink:this.state.rcPermitValidFrom||this.state.vehicleData&&this.state.vehicleData.rcPermitValidFrom||this.state.permitValidFrom||''},'Permit Valid From'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'rcPermitValidFrom',name:'rcPermitValidFrom',className:'textfield',margin:'dense'//label="Permit Valid From"
,type:'text'// type="Multi-line"
,value:this.state.rcPermitValidFrom||this.state.vehicleData&&this.state.vehicleData.rcPermitValidFrom||this.state.permitValidFrom||'',onChange:this.handleInputChange('rcPermitValidFrom')//error={!this.state.isrcPermitValidFromValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_InputLabel___default.a,{htmlFor:'rcPermitValidUpto',style:{marginTop:'-10px'},shrink:this.state.rcPermitValidUpto||this.state.vehicleData&&this.state.vehicleData.rcPermitValidUpto||this.state.permitValidUpto||''},'Permit Valid Upto'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'rcPermitValidUpto',name:'rcPermitValidUpto',className:'textfield',margin:'dense'//label="Permit Valid Upto"
,type:'text'// type="Multi-line"
,value:this.state.rcPermitValidUpto||this.state.vehicleData&&this.state.vehicleData.rcPermitValidUpto||this.state.permitValidUpto||'',onChange:this.handleInputChange('rcPermitValidUpto')//error={!this.state.isrcPermitValidUptoValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_InputLabel___default.a,{htmlFor:'rcPermitType',style:{marginTop:'-10px'},shrink:this.state.rcPermitType||this.state.vehicleData&&this.state.vehicleData.rcPermitType||this.state.permitType||''},'Permit Type'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'rcPermitType',name:'rcPermitType',className:'textfield',margin:'dense'//label="Permit Type"
,type:'text'// type="Multi-line"
,value:this.state.rcPermitType||this.state.vehicleData&&this.state.vehicleData.rcPermitType||this.state.permitType||'',onChange:this.handleInputChange('rcPermitType')//error={!this.state.isrcPermitTypeValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_InputLabel___default.a,{htmlFor:'rcPermitCode',style:{marginTop:'-10px'},shrink:this.state.rcPermitCode||this.state.vehicleData&&this.state.vehicleData.rcPermitCode||this.state.permitCode||''},'Permit Code'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'rcPermitCode',name:'rcPermitCode',className:'textfield',margin:'dense'//label="Permit Code"
,type:'text'// type="Multi-line"
,value:this.state.rcPermitCode||this.state.vehicleData&&this.state.vehicleData.rcPermitCode||this.state.permitCode||'',onChange:this.handleInputChange('rcPermitCode')//error={!this.state.isrcPermitCodeValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_InputLabel___default.a,{htmlFor:'rcNoOfAxle',style:{marginTop:'-10px'},shrink:this.state.rcNoOfAxle||this.state.vehicleData&&this.state.vehicleData.rcNoOfAxle||this.state.numberOfAxles||''},'Number of Axles'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'rcNoOfAxle',name:'rcNoOfAxle',className:'textfield',margin:'dense'//label="Number of Axles"
,type:'number'// type="Multi-line"
,value:this.state.rcNoOfAxle||this.state.vehicleData&&this.state.vehicleData.rcNoOfAxle||this.state.numberOfAxles||'',onChange:this.handleInputChange('rcNoOfAxle')//error={!this.state.isrcNoOfAxleValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_InputLabel___default.a,{htmlFor:'rcFuelCd',style:{marginTop:'-10px'},shrink:this.state.rcFuelCd||this.state.vehicleData&&this.state.vehicleData.rcFuelCd||this.state.fuelCode||''},'Fuel Code'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'rcFuelCd',name:'rcFuelCd',className:'textfield',margin:'dense'//label="Fuel Code"
,type:'text'// type="Multi-line"
,value:this.state.rcFuelCd||this.state.vehicleData&&this.state.vehicleData.rcFuelCd||this.state.fuelCode||'',onChange:this.handleInputChange('rcFuelCd')//error={!this.state.isrcFuelCdValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_InputLabel___default.a,{htmlFor:'rcVhType',style:{marginTop:'-10px'},shrink:function(){var _state4=_this4.state,vehicleSegment=_state4.vehicleSegment,transportationVehicleType=_state4.transportationVehicleType,constructionVehicleType=_state4.constructionVehicleType,passengerVehicleType=_state4.passengerVehicleType,vehicleData=_state4.vehicleData,rcVhType=_state4.rcVhType,vehicleType=_state4.vehicleType;if(vehicleSegment==='Transportation')return!!transportationVehicleType;if(vehicleSegment==='Construction')return!!constructionVehicleType;if(vehicleSegment==='Passenger')return!!passengerVehicleType;return!!(vehicleSegment||rcVhType||vehicleData&&vehicleData.rcVhType||vehicleType);}()},'Vehicle Type'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'rcVhType',name:'rcVhType',className:'textfield',margin:'dense'//label="Vehicle Type"
,type:'text'// type="Multi-line"
,value:function(){var _state5=_this4.state,vehicleSegment=_state5.vehicleSegment,transportationVehicleType=_state5.transportationVehicleType,constructionVehicleType=_state5.constructionVehicleType,passengerVehicleType=_state5.passengerVehicleType,vehicleData=_state5.vehicleData,rcVhType=_state5.rcVhType,vehicleType=_state5.vehicleType;if(vehicleSegment==='Transportation')return transportationVehicleType||'';if(vehicleSegment==='Construction')return constructionVehicleType||'';if(vehicleSegment==='Passenger')return passengerVehicleType||'';return vehicleSegment||rcVhType||vehicleData&&vehicleData.rcVhType||vehicleType;}(),onChange:this.handleInputChange('rcVhType')//error={!this.state.isrcVhTypeValid}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_InputLabel___default.a,{htmlFor:'rcVhClass',style:{marginTop:'-10px'},shrink:this.state.rcVhClass||this.state.vehicleData&&this.state.vehicleData.rcVhClass||this.state.vehicleClass||''},'Vehicle Class'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'rcVhClass',name:'rcVhClass',className:'textfield',margin:'dense'//label="Vehicle Class"
,type:'text'// type="Multi-line"
,value:this.state.rcVhClass||this.state.vehicleData&&this.state.vehicleData.rcVhClass||this.state.vehicleClass||'',onChange:this.handleInputChange('rcVhClass')//error={!this.state.isrcVhClassValid}
})))),this.state.vehicleSegment=='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{xs:12,sm:12,mt:4},'Vehicle/Asset Type *',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40_react_select__["a" /* default */],{classes:classes,options:allvehicleTypes// components={components}
,value:this.state.vehicleType,onChange:this.handleChangeType,placeholder:'Select vehicle Type *',disabled:this.state.vehicleSegment=='DG Set'?true:false}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isClientNameValid?'Invalid Selection':'')))),this.state.vehicleSegment=='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{xs:12,sm:12,mt:4},'Select Make *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40_react_select__["a" /* default */],{id:'vehicleMake',name:'vehicleMake',classes:classes,options:this.state.makesList.map(function(item){return{value:item.id,label:item.make};}),value:this.state.vehicleMakeId,onChange:this.handleChangeMake,placeholder:'Select'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isVehicleMakeValid?'Invalid Vehicle Make':'')))),this.state.vehicleSegment=='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{xs:12,sm:12,mt:4},'Select Model *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40_react_select__["a" /* default */],{id:'vehicleModel',name:'vehicleModel',classes:classes,options:this.state.modelsList.map(function(item){return{value:item.id,label:item.model};}),value:this.state.vehicleModelId,onChange:this.handleChangeModel,placeholder:'Select',error:!this.state.isVehicleModelValid}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isVehicleModelValid?'Invalid Vehicle Model':'')))),this.state.vehicleSegment=='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{xs:12,sm:12,mt:4},'KVA Rating *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40_react_select__["a" /* default */],{id:'kvaRating',name:'kvaRating',classes:classes,options:this.state.kvaRatingOptions,value:this.state.kvaRating,onChange:this.handleInputChange('kvaRating'),placeholder:'KVA Rating'// error={!this.state.isVehicleModelValid}
}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isVehicleModelValid?'Invalid Vehicle Model':'')))),this.state.vehicleSegment=='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{xs:12,sm:12,mt:4},'DG Set Type *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40_react_select__["a" /* default */],{id:'dgSetType',name:'dgSetType',classes:classes,options:this.state.dgSetTypeOptions,value:this.state.dgSetType,onChange:this.handleInputChange('dgSetType'),placeholder:'DG Set Type'// error={!this.state.isVehicleModelValid}
}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isVehicleModelValid?'Invalid Vehicle Model':'')))),this.state.vehicleSegment=='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},'Manufacturing Year',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40_react_select__["a" /* default */],{options:this.state.manufacturingYearOptions,value:this.state.manufacturingYear,onChange:this.handleInputChangeNew('manufacturingYear'),placeholder:'Manufacturing Year',name:'manufacturingYear',disabled:!this.isAdmin()&&this.state.manufacturingYearFromApi})))),this.state.vehicleSegment=='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{xs:12,sm:12,style:{marginTop:'20px'}},'Fuel Type:'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox'// style={{ marginTop: '5px' }}
},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40_react_select__["a" /* default */],{id:'fuelType',name:'fuelType',classes:classes,options:[{value:'petrol',label:'PETROL'},{value:'diesel',label:'DIESEL'}]// components={components}
,value:this.state.fuelType,onChange:this.handleInputChange('fuelType'),placeholder:'Fuel Type'// disabled={this.state.fuelTypeFromApi}
}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{padding:'5px',borderRadius:'5px',border:'2px solid #f2f2f2',marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',{style:{marginBottom:'0px'}},'Manual Entry Section'),this.state.vehicleSegment!='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Vehicle Customized Body Type'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40_react_select__["a" /* default */],{style:{marginTop:'5px'}// options={this.state.noOfGears}
,options:Array.isArray(this.state.vehiclecustomizedbodytype)&&this.state.vehiclecustomizedbodytype.map(function(option){return{label:option,value:option};}),value:this.state.vehicleCustomizedBodyType,onChange:function onChange(selectedOption){_this4.setState({vehicleCustomizedBodyType:selectedOption?selectedOption.value:''});},placeholder:'Vehicle Customized Body Type'}))),this.state.vehicleSegment=='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{label:'BHP (Break Horse Power)',variant:'outlined',fullWidth:true,margin:'normal',name:'bhp',type:'text',inputProps:{step:'1'}// Allow decimal values
,value:this.state.bhp,onChange:this.handleInputChange('bhp')}))),this.state.vehicleSegment=='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input',style:{marginTop:'12px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Phase'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40_react_select__["a" /* default */],{options:this.state.phaseOptions,placeholder:'Phase',value:this.state.phase,onChange:this.handleInputChange('phase')}))),this.state.vehicleSegment=='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{label:'Engine Model',variant:'outlined',fullWidth:true,margin:'normal',name:'engineModel',type:'text',value:this.state.engineModel,onChange:this.handleInputChange('engineModel')}))),this.state.vehicleSegment=='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{label:'Genset Controller',variant:'outlined',fullWidth:true,margin:'normal',name:'gensetController',type:'text',value:this.state.gensetController,onChange:this.handleInputChange('gensetController')}))),this.state.vehicleSegment!='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'equipmentSerialNumber',name:'equipmentSerialNumber',className:'textfield',margin:'dense',label:'Equipment Serial Number',type:'text'// type="Multi-line"
,value:this.state.equipmentSerialNumber,error:!this.state.isEquipmentValid,onChange:this.handleInputChange('equipmentSerialNumber')}),!this.state.isEquipmentValid&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},'Maximum length is 90 characters.'))),this.state.vehicleSegment!='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'equipmentName',name:'equipmentName',className:'textfield',margin:'dense',label:'Equipment Name',type:'text'// type="Multi-line"
,value:this.state.equipmentName,onChange:this.handleInputChange('equipmentName'),error:!this.state.isEquipmentNameValid}),!this.state.isEquipmentNameValid&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},'Maximum length is 90 characters.'))),this.state.vehicleSegment!='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34_material_ui_pickers__["a" /* DatePicker */],{format:'DD/MM/YYYY',maxDate:new Date(),value:this.state.commissioningDate.date,onChange:this.handleDateChange('commissioningDate'),label:'Commissioning Date'}))),this.state.vehicleSegment!='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'department',name:'department',className:'textfield',margin:'dense',label:'Department',type:'text'// type="Multi-line"
,value:this.state.department,onChange:this.handleInputChange('department'),error:!this.state.isDepartmentValid}),!this.state.isDepartmentValid&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},'Maximum length is 90 characters.'))),this.state.vehicleSegment!='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'contractorName',name:'contractorName',className:'textfield',margin:'dense',label:'Contractor Name',type:'text'// type="Multi-line"
,value:this.state.contractorName,onChange:this.handleInputChange('contractorName'),error:!this.state.isContractorNameValid}),!this.state.isContractorNameValid&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},'Maximum length is 90 characters.'))),this.state.vehicleSegment!='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{xs:12,sm:12,mt:4,style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Switch___default.a,{value:this.state.isDualEngine,checked:this.state.isDualEngine,onChange:this.handleInputChange('isDualEngine'),name:'dualEngineToggle',color:'primary'}),label:'Dual Engine'})),this.state.vehicleSegment!='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{xs:12,sm:12,mt:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Switch___default.a,{value:this.state.hasArm,checked:this.state.hasArm,onChange:this.handleInputChange('hasArm'),name:'armToggle',color:'primary'}),label:'Arm Included?'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{xs:12,sm:12,mt:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Switch___default.a,{value:this.state.isElockConnection,checked:this.state.isElockConnection,onChange:this.handleInputChange('isElockConnection'),name:'isElockConnectionToggle',color:'primary'}),label:'E-LOCK Connection?'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{xs:12,sm:12,mt:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Switch___default.a,{value:this.state.istachoenabled,checked:this.state.istachoenabled,onChange:this.handleInputChange('istachoenabled'),name:'istachoenabledToggle',color:'primary'}),label:'Is Tachometer Enabled?'})),this.state.istachoenabled&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:2,style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{label:'Idle RPM *',value:this.state.tachoidlerpm,onChange:this.handleInputChange('tachoidlerpm'),type:'number',fullWidth:true,margin:'dense',variant:'outlined'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{label:'Shift Hours *',value:this.state.tachoshifthours,onChange:this.handleInputChange('tachoshifthours'),type:'number',fullWidth:true,margin:'dense',variant:'outlined'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{label:'Engine On Voltage (min)',value:this.state.tachoengineonmin,onChange:this.handleInputChange('tachoengineonmin'),type:'number',fullWidth:true,margin:'dense',variant:'outlined'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{label:'Engine On Voltage (max)',value:this.state.tachoengineonmax,onChange:this.handleInputChange('tachoengineonmax'),type:'number',fullWidth:true,margin:'dense',variant:'outlined'}))),// this.state.vehicleSegment != 'DG Set' &&
__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{xs:12,sm:12,mt:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Switch___default.a,{value:this.state.isRotationSensor,checked:this.state.isRotationSensor,onChange:function onChange(e){_this4.setState({isRotationSensor:!_this4.state.isRotationSensor});},name:'isRotationSensor',color:'primary'}),label:'Rotation Sensor Available'})),this.state.vehicleSegment!='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{xs:12,sm:12,mt:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Switch___default.a,{value:this.state.isIndividualViewOrCombinedView,checked:this.state.isIndividualViewOrCombinedView,onChange:this.handleInputChange('isIndividualViewOrCombinedView'),name:'isIndividualViewOrCombinedView',color:'primary'}),label:this.state.isIndividualViewOrCombinedView?'Dual Tank Combined View':'Dual Tank Individual View'//labelPlacement={this.state.isIndividualViewOrCombinedView ? 'end' : 'start'}
})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,fullwidth:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{style:{minWidth:'70%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'eon_voltage',name:'eon_voltage',className:'textfield',margin:'dense',label:'Engine on Voltage :',value:this.state.eon_voltage===null?'':this.state.eon_voltage,onChange:function onChange(e){_this4.setState({eon_voltage:e.target.value},_this4.checkDualEngineVoltageValidity);},error:this.state.isDualEngine&&(!this.state.eon_voltage||!this.state.isEonVoltageValid),onBlur:this.checkeon_voltageValidity,required:this.state.isDualEngine}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg',error:!this.state.iseon_voltageValid},!this.state.iseon_voltageValid&&'Min capacity should be an integer or Float (Allows up to 2 digits after decimal)')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,fullwidth:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{style:{minWidth:'70%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'eoff_voltage',name:'eoff_voltage',className:'textfield',margin:'dense',label:'Engine off Voltage :',value:this.state.eoff_voltage===null?'':this.state.eoff_voltage,onChange:function onChange(e){_this4.setState({eoff_voltage:e.target.value},_this4.checkDualEngineVoltageValidity);},error:this.state.isDualEngine&&(!this.state.eoff_voltage||!this.state.isEoffVoltageValid),onBlur:this.checkeoff_voltageValidity,required:this.state.isDualEngine}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg',error:!this.state.iseoff_voltageValid},!this.state.iseoff_voltageValid&&'Max capacity should be an integer or Float (Allows up to 2 digits after decimal)')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'-10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{label:'Fuel Tank Capacity',variant:'outlined',fullWidth:true,margin:'normal',name:'fuelTankCapacity',value:this.state.fuelTankCapacity,onChange:this.handleInputChange('fuelTankCapacity'),type:'number',inputProps:{step:'1'}// Allow decimal values
// disabled={this.state.vehicleSegment == 'DG Set' ? false : this.state.fuelTankCapacityFromApi}
,required:this.state.vehicleSegment=='DG Set'?true:false}))),this.state.errorMessageFuelTank&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},this.state.errorMessageFuelTank),this.state.vehicleSegment!='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'-10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{label:'Adblue Capacity',variant:'outlined',fullWidth:true,margin:'normal',name:'adblueCapacity',value:this.state.adblueCapacity,onChange:function onChange(e){_this4.setState({adblueCapacity:e.target.value},_this4.checkAdblueCapacityValidity);},type:'number',inputProps:{step:'1'}// Allow decimal values
// disabled={this.state.adblueCapacityFromApi}
,required:this.state.deviceType&&this.state.deviceType.toLowerCase()==='obd'}))),this.state.vehicleSegment!='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'No. Of Gears'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40_react_select__["a" /* default */],{style:{marginTop:'5px'}// options={this.state.noOfGears}
,options:Array.isArray(this.state.noofgears)&&this.state.noofgears.map(function(option){return{label:option,value:option};}),value:this.state.noOfGears,onChange:function onChange(selectedOption){_this4.setState({noOfGears:selectedOption?selectedOption.value:null});},placeholder:'No. Of Gears'}))),this.state.vehicleSegment!='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'10px'}// shrink={this.state.gearRatio}
},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_InputLabel___default.a,{htmlFor:'gearRatio'// style={{ marginTop: '-10px' }}
,shrink:this.state.gearRatio},'Gear Ratio'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a// label="Gear Ratio"
,{variant:'outlined',fullWidth:true,margin:'normal',name:'gearRatio',value:this.state.gearRatio,onChange:this.handleInputChange('gearRatio')// type="number"
// inputProps={{ step: '1' }}
// disabled={this.state.adblueCapacityFromApi}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginTop:'20px',display:'flex',alignItems:'center',gap:'6px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Solution Type *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__material_ui_core_Tooltip___default.a,{title:'These fields are disabled',arrow:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{cursor:'pointer',fontSize:'14px'}},'\u2139\uFE0F'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_apollo__["Query"],{query:GET_SOLUTION_TYPES},function(_ref37){var loading=_ref37.loading,error=_ref37.error,data=_ref37.data;if(loading)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core_CircularProgress___default.a,{size:24});if(error)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Error loading solution types');var solutionTypeMultiOptions=data.getAllMasterSolutionType.map(function(type){var code=type.id;return{value:code,label:type.solutionTypeName};});var selectedMultiValue=solutionTypeMultiOptions.filter(function(option){return _this4.state.solution_type&&_this4.state.solution_type.includes(option.value);});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40_react_select__["a" /* default */],{id:'solution_type',name:'solution_type',classes:classes,options:solutionTypeMultiOptions,value:selectedMultiValue,multi:true,disabled:!_this4.isAdmin(),optionComponent:SolutionTypeOption,closeOnSelect:false,removeSelected:false,onChange:_this4.handleInputChange('solution_type'),placeholder:'Solution Type *'}));}),this.state.solution_type&&this.state.solution_type.includes('reverse_camera_screen')&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginTop:'12px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_apollo__["Query"],{query:Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject26),fetchPolicy:'network-only'},function(_ref38){var loading=_ref38.loading,error=_ref38.error,data=_ref38.data;if(loading)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core_CircularProgress___default.a,{size:20});if(error)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Error loading RCS inventory');var options=data&&data.getReverseCameraAndScreenInventory&&data.getReverseCameraAndScreenInventory.data?data.getReverseCameraAndScreenInventory.data.map(function(item){return{value:item.rcs_serial_number,label:item.rcs_serial_number};}):[];return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginTop:'8px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginBottom:'6px'}},'RCS Serial Number'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40_react_select__["a" /* default */],{options:options,value:options.find(function(o){return o.value===_this4.state.rcsSerialNumber;})||null,onChange:_this4.handleInputChange('rcsSerialNumber'),placeholder:'Select RCS Serial Number',isClearable:true}));}))))),this.state.vehicleSegment!='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{xs:12,sm:12,style:{marginTop:'20px'}},'Ported Vehicle *'),this.state.vehicleSegment!='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40_react_select__["a" /* default */],{id:'portedVehicle',name:'portedVehicle',classes:classes,options:[{value:true,label:'Yes'},{value:false,label:'No'}]// components={components}
,value:this.state.portedVehicle,onChange:this.handleInputChange('portedVehicle'),placeholder:'Ported Vehicle *'}))),this.state.vehicleSegment!='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{xs:12,sm:12,style:{marginTop:'20px'}},'isTesting Vehicle *'),this.state.vehicleSegment!='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40_react_select__["a" /* default */],{id:'isTestingVehicle',name:'isTestingVehicle',classes:classes,options:[{value:true,label:'Testing'},{value:false,label:'Active'}]// components={components}
,value:this.state.isTestingVehicle,onChange:this.handleInputChange('isTestingVehicle'),placeholder:'isTesting Vehicle *'}))),this.state.errorMessageNew&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},this.state.errorMessageNew),this.state.vehicleSegment!='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{xs:12,sm:12,mt:4,style:{marginTop:'20px'}},'Speed Sensor *'),this.state.vehicleSegment!='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40_react_select__["a" /* default */],{classes:classes,options:allSpeedSensor// components={components}
,value:this.state.speedSensor,onChange:this.handleChangeSpeedSensor,onBlur:this.checkSpeedSensorValidity,placeholder:'Select Speed Sensor *'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isSpeedSensorValid?'Invalid Selection':''))),this.state.vehicleSegment!='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'speedLimit',name:'speedLimit',className:'textfield',margin:'dense',label:'Maximum Speed Limit',value:this.state.speedLimit,required:true,onChange:this.handleInputChange('speedLimit'),error:!this.state.isSpeedLimitValid,onBlur:this.checkSpeedLimitValidity,type:'number',inputProps:{pattern:'[0-9]*'},onKeyDown:function onKeyDown(e){var isCopyKeyCombination=(e.ctrlKey||e.metaKey)&&(e.key==='c'||e.key==='x'||e.key==='v');var isSelectAll=(e.ctrlKey||e.metaKey)&&e.key==='a';var isTabKey=e.key==='Tab';if(!isCopyKeyCombination&&!isSelectAll&&!isTabKey){var isNumber=/^[0-9]*$/.test(e.key);var isAllowedKey=e.key==='Delete'||e.key==='Backspace'||e.key==='ArrowLeft'||e.key==='ArrowRight';if(!isNumber&&!isAllowedKey){e.preventDefault();}}},onPaste:function onPaste(e){var pastedText=e.clipboardData.getData('text/plain');if(!/^\d*$/.test(pastedText)){e.preventDefault();}}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isSpeedLimitValid?'Maximum speed limit 10-160':''))),this.state.vehicleSegment!='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{xs:12,sm:12,style:{marginTop:'5px'}},'Idling Speed:'),this.state.vehicleSegment!='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40_react_select__["a" /* default */],{classes:classes,options:allIdlingSpeed// components={components}
,value:this.state.idlingSpeed,onChange:this.handleChangeIdlingSpeed,placeholder:'Select Idling Speed '}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'}))),this.state.vehicleSegment!=='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{xs:12,sm:12,style:{marginTop:'5px'}},'Asset Working Hours:'),this.state.vehicleSegment!=='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{classes:classes,type:'number',value:this.state.inputParameter||'',onChange:this.handleChangeInputParameter,placeholder:'Enter Asset Working Hours',fullWidth:true,variant:'outlined',InputProps:{inputProps:{}}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'}))),this.state.vehicleSegment!=='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{xs:12,sm:12,style:{marginTop:'5px'}},'Asset Multiplication Factor:'),this.state.vehicleSegment!=='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{classes:classes,type:'number',value:this.state.multiplicationFactor||'',onChange:this.handleChangeMultiplicationFactor,placeholder:'Enter Asset Multiplication Factor',fullWidth:true,variant:'outlined',InputProps:{inputProps:{}}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'invoiceNumber',name:'invoiceNumber',className:'textfield',margin:'dense',label:this.state.customerType=='Paid'||this.state.vehicleSegment=='DG Set'?'Invoice Number *':'Invoice Number',type:'text'// type="Multi-line"
,value:this.state.invoiceNumber,onChange:this.handleInputChange('invoiceNumber'),error:!this.state.isInvoiceNoValid}),!this.state.isInvoiceNoValid&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},'Maximum length is 90 characters.'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34_material_ui_pickers__["a" /* DatePicker */],{format:'DD/MM/YYYY',maxDate:new Date(),value:this.state.invoiceDate.date,onChange:this.handleDateChange('invoiceDate'),label:this.state.customerType=='Paid'?'Invoice Date *':'Invoice Date'}))),this.state.vehicleSegment!=='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'25px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',null,'Baseline Data Type FE'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40_react_select__["a" /* default */],{style:{marginTop:'5px'}// options={this.state.baselineDataTypeFEOptions}
,options:Array.isArray(this.state.baselinedatatypefe)&&this.state.baselinedatatypefe.map(function(option){return{label:option,value:option.toLowerCase()};}),value:this.state.baselineDataType,onChange:function onChange(selectedOption){_this4.setState({baselineDataType:selectedOption?selectedOption.value:''});},placeholder:'Baseline Data Type FE'}))),this.state.baselineDataType&&this.state.vehicleSegment!='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'6px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'baselineDataForFE',name:'baselineDataForFE',className:'textfield',margin:'dense',label:this.state.baselineDataType==='kmpl'?'Baseline FE (KMPL):':'Baseline FE (LPH ):'// label="Baseline FE (KMPL):"
,value:this.state.baselineDataForFE,onChange:this.handleInputChange('baselineDataForFE'),onBlur:this.checkBaselineDataForFEValidity,error:!this.state.isBaselineDataForFEValid,type:'number',inputProps:{step:'0.1'}// Allow decimal values to one decimal place
,onKeyDown:function onKeyDown(e){var isCopyKeyCombination=(e.ctrlKey||e.metaKey)&&(e.key==='c'||e.key==='x'||e.key==='v');var isSelectAll=(e.ctrlKey||e.metaKey)&&e.key==='a';var isTabKey=e.key==='Tab';if(!isCopyKeyCombination&&!isSelectAll&&!isTabKey){var isNumberOrDecimal=/^[0-9.]*$/.test(e.key);var isAllowedKey=e.key==='Delete'||e.key==='Backspace'||e.key==='ArrowLeft'||e.key==='ArrowRight'||e.key==='.';if(!isNumberOrDecimal&&!isAllowedKey){e.preventDefault();}}},onPaste:function onPaste(e){var pastedText=e.clipboardData.getData('text/plain');if(!/^\d*$/.test(pastedText)){e.preventDefault();}}}),!this.state.isBaselineDataForFEValid&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},'Range must be 0.5 to 20 with up to 2 decimal place'))),this.state.baselineDataType=='kmpl'&&this.state.vehicleSegment!='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'6px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'baselineDistance',name:'baselineDistance',className:'textfield',margin:'dense',label:'Baseline Distance (KM):',value:this.state.baselineDistance,onChange:this.handleInputChange('baselineDistance'),onBlur:this.checkBaselineDistanceValidity,error:!this.state.isBaselineDistanceValid,type:'number',inputProps:{pattern:'[0-9]*'},onKeyDown:function onKeyDown(e){var isCopyKeyCombination=(e.ctrlKey||e.metaKey)&&(e.key==='c'||e.key==='x'||e.key==='v');var isSelectAll=(e.ctrlKey||e.metaKey)&&e.key==='a';var isTabKey=e.key==='Tab';if(!isCopyKeyCombination&&!isSelectAll&&!isTabKey){var isNumber=/^[0-9]*$/.test(e.key);var isAllowedKey=e.key==='Delete'||e.key==='Backspace'||e.key==='ArrowLeft'||e.key==='ArrowRight';if(!isNumber&&!isAllowedKey){e.preventDefault();}}},onPaste:function onPaste(e){var pastedText=e.clipboardData.getData('text/plain');if(!/^\d*$/.test(pastedText)){e.preventDefault();}}}),!this.state.isBaselineDistanceValid&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},'Baseline Distance must be a positive integer between 1 and 2000000\''))),this.state.baselineDataType=='lph'&&this.state.vehicleSegment!='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'6px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'baselineHours',name:'baselineHours',className:'textfield',margin:'dense',label:'Baseline Hours:',value:this.state.baselineHours,onChange:this.handleInputChange('baselineHours'),onBlur:this.checkBaselineHoursValidity,error:!this.state.isBaselineHoursValid,type:'number',inputProps:{pattern:'[0-9]*'},onKeyDown:function onKeyDown(e){var isCopyKeyCombination=(e.ctrlKey||e.metaKey)&&(e.key==='c'||e.key==='x'||e.key==='v');var isSelectAll=(e.ctrlKey||e.metaKey)&&e.key==='a';var isTabKey=e.key==='Tab';if(!isCopyKeyCombination&&!isSelectAll&&!isTabKey){var isNumber=/^[0-9]*$/.test(e.key);var isAllowedKey=e.key==='Delete'||e.key==='Backspace'||e.key==='ArrowLeft'||e.key==='ArrowRight';if(!isNumber&&!isAllowedKey){e.preventDefault();}}},onPaste:function onPaste(e){var pastedText=e.clipboardData.getData('text/plain');if(!/^\d*$/.test(pastedText)){e.preventDefault();}}}),!this.state.isBaselineHoursValid&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},'Baseline Hours must be a positive integer between 1 and 24')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{padding:'10px',borderRadius:'5px',border:'2px solid #f2f2f2',marginTop:'15px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{xs:6,sm:6,style:{marginTop:'15px'}},'Document Upload',' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('small',null,'(Please upload Registration Copy or Vehicle Image of type JPEG, JPG, PNG, or PDF up to 30 Mb)')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'12px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button___default.a,{variant:'outlined',color:'primary',component:'label',style:{fontWeight:'bold'}},'+ Add Images',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'file',multiple:true,hidden:true,accept:'.jpeg, .jpg, .png, .pdf, image/jpeg, image/png, application/pdf',onChange:this.handleFileChange})))),this.state.errorMessage&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormHelperText___default.a,{error:true},this.state.errorMessage)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'16px'}},Object.keys(uploadProgress).map(function(fileName){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input',key:fileName,style:{marginBottom:'16px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{display:'flex',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{flex:'1'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('small',{style:{cursor:'pointer'},onClick:function onClick(){return _this4.handleDownload(fileName);}},fileName)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{onClick:function onClick(){return _this4.handleRemove(fileName);},style:{cursor:'pointer'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__material_ui_icons_Close___default.a,null)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_apollo__["Query"],{query:__WEBPACK_IMPORTED_MODULE_4__queries__["r" /* GET_DROPDOWN_CATEGORIES */]},function(_ref39){var catLoading=_ref39.loading,catError=_ref39.error,catData=_ref39.data;if(catLoading)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core_CircularProgress___default.a,{size:20});if(catError||!catData||!catData.getDropdownCategories)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Error');var solCat=catData.getDropdownCategories.find(function(c){return c.category_name==='Solution Type';});var labelCat=catData.getDropdownCategories.find(function(c){return c.category_name==='Image Labels for Installation';});var solId=solCat?parseInt(solCat.id):49;var labelId=labelCat?parseInt(labelCat.id):60;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{display:'flex',gap:'10px',marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_apollo__["Query"],{query:__WEBPACK_IMPORTED_MODULE_4__queries__["t" /* GET_DROPDOWN_VALUES_BY_CATEGORY */],variables:{categoryId:solId}},function(_ref40){var loading=_ref40.loading,error=_ref40.error,data=_ref40.data;if(loading)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core_CircularProgress___default.a,{size:20});if(error)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Error');var options=data.getDropdownValuesByCategory?data.getDropdownValuesByCategory.map(function(val){return{value:val.value_name,label:val.value_name};}):[];var selectedVal=_this4.state.documentUploadNewData&&_this4.state.documentUploadNewData[fileName]?options.find(function(o){return o.value===_this4.state.documentUploadNewData[fileName].solutionType;}):null;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{flex:1}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40_react_select__["a" /* default */],{options:options,value:selectedVal,onChange:function onChange(opt){return _this4.handleDocumentUploadNewDataChange(fileName,'solutionType',opt?opt.value:'');},placeholder:'Solution Type *'}));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_apollo__["Query"],{query:__WEBPACK_IMPORTED_MODULE_4__queries__["t" /* GET_DROPDOWN_VALUES_BY_CATEGORY */],variables:{categoryId:labelId}},function(_ref41){var loading=_ref41.loading,error=_ref41.error,data=_ref41.data;if(loading)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__material_ui_core_CircularProgress___default.a,{size:20});if(error)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Error');var options=data.getDropdownValuesByCategory?data.getDropdownValuesByCategory.map(function(val){return{value:val.value_name,label:val.value_name};}):[];var selectedVal=_this4.state.documentUploadNewData&&_this4.state.documentUploadNewData[fileName]?options.find(function(o){return o.value===_this4.state.documentUploadNewData[fileName].label;}):null;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{flex:1}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40_react_select__["a" /* default */],{options:options,value:selectedVal,onChange:function onChange(opt){return _this4.handleDocumentUploadNewDataChange(fileName,'label',opt?opt.value:'');},placeholder:'Label *'}));}));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('progress',{value:uploadProgress[fileName],max:'100',style:{width:'100%',height:'8px',// thinner height
backgroundColor:'#fff',// white background color
border:'1px solid #ccc',marginTop:'5px'// add some space between filename and progress bar
}}));})))),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:6,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{xs:12,sm:12,mt:4},'Device *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'serialNumber',name:'serialNumber',className:'textfield',margin:'dense'// label="Serial Number"
,type:'text',disabled:!this.isAdmin(),value:this.state.uniqueDeviceId}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'modelName',name:'modelName',className:'textfield',margin:'dense',label:'Model Name',type:'text',disabled:!this.isAdmin(),value:this.state.modelName,onChange:this.handleInputChange('modelName')}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'deviceType',name:'deviceType',className:'textfield',margin:'dense',label:'Device Type',type:'text',disabled:!this.isAdmin(),value:this.state.deviceType,onChange:this.handleInputChange('deviceType')}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'22px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'phoneNumber',name:'phoneNumber',className:'textfield',margin:'dense',label:'Phone Number',type:'text',disabled:!this.isAdmin(),value:this.state.phoneNumber}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'simProvider',name:'simProvider',className:'textfield',margin:'dense',label:'Service Provider',type:'text',disabled:!this.isAdmin(),value:this.state.simProvider,onChange:this.handleInputChange('simProvider')}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'simNumber',name:'simNumber',className:'textfield',margin:'dense',label:'SIM Number'// type="Multi-line"
,value:this.state.simNumber,disabled:!this.isAdmin(),onChange:this.handleInputChange('simNumber')})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'engineOnHours',name:'engineOnHours',className:'textfield',margin:'dense',label:'Engine On Hours',value:this.state.engineOnHours,onChange:this.handleInputChange('engineOnHours'),error:!this.state.isengineOnHoursValid,onBlur:this.checkItemValidity('engineOnHours'),inputProps:{pattern:'[0-9]*'},onKeyDown:function onKeyDown(e){var isCopyKeyCombination=(e.ctrlKey||e.metaKey)&&(e.key==='c'||e.key==='x'||e.key==='v');var isSelectAll=(e.ctrlKey||e.metaKey)&&e.key==='a';var isTabKey=e.key==='Tab';if(!isCopyKeyCombination&&!isSelectAll&&!isTabKey){var isNumber=/^[0-9]*$/.test(e.key);var isAllowedKey=e.key==='Delete'||e.key==='Backspace'||e.key==='ArrowLeft'||e.key==='ArrowRight';if(!isNumber&&!isAllowedKey){e.preventDefault();}}},onPaste:function onPaste(e){var pastedText=e.clipboardData.getData('text/plain');if(!/^\d*$/.test(pastedText)){e.preventDefault();}}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isengineOnHoursValid?'Invalid Engine On Hours':'')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'odometerDistance',name:'odometerDistance',className:'textfield',margin:'dense',label:'Odometer Distance',value:this.state.odometerDistance,onChange:this.handleInputChange('odometerDistance'),error:!this.state.isOdometerDistanceValid,onBlur:this.checkItemValidity('odometerDistance'),inputProps:{pattern:'[0-9]*'},onKeyDown:function onKeyDown(e){var isCopyKeyCombination=(e.ctrlKey||e.metaKey)&&(e.key==='c'||e.key==='x'||e.key==='v');var isSelectAll=(e.ctrlKey||e.metaKey)&&e.key==='a';var isTabKey=e.key==='Tab';if(!isCopyKeyCombination&&!isSelectAll&&!isTabKey){var isNumber=/^[0-9]*$/.test(e.key);var isAllowedKey=e.key==='Delete'||e.key==='Backspace'||e.key==='ArrowLeft'||e.key==='ArrowRight';if(!isNumber&&!isAllowedKey){e.preventDefault();}}},onPaste:function onPaste(e){var pastedText=e.clipboardData.getData('text/plain');if(!/^\d*$/.test(pastedText)){e.preventDefault();}}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isOdometerDistanceValid?'Invalid Odometer Distance':'')),(this.state.deviceType==='obd'||this.state.deviceType==='OBD')&&this.state.vehicleSegment!=='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'Gear Related Info'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{xs:12,sm:12,mt:4},'Select Make *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40_react_select__["a" /* default */],{id:'vehicleMake',name:'vehicleMake',classes:classes,options:this.state.makesList.map(function(item){return{value:item.id,label:item.make};}),value:this.state.vehicleMakeId?{value:this.state.vehicleMakeId,label:this.state.vehicleMake}:null,onChange:this.handleChangeMake,placeholder:'Select'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isVehicleMakeValid?'Invalid Vehicle Make':''))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{xs:12,sm:12,mt:4},'Select Model *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40_react_select__["a" /* default */],{id:'vehicleModel',name:'vehicleModel',classes:classes,options:this.state.modelsList.map(function(item){return{value:item.id,label:item.model};}),value:this.state.vehicleModel?{value:this.state.vehicleModelId,label:this.state.vehicleModel}:null,onChange:this.handleChangeModelNew,placeholder:'Select',error:!this.state.isVehicleModelValid}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isVehicleModelValid?'Invalid Vehicle Model':''))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{xs:12,sm:12,style:{marginTop:'12px'}},'Technician'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40_react_select__["a" /* default */],{classes:classes,options:[{label:'Technician - Taabi Personal',value:'Technician - Taabi Personal'},{label:'Technician - Freelancer',value:'Technician - Freelancer'}],value:this.state.technicianCategory?{label:this.state.technicianCategory,value:this.state.technicianCategory}:null,onChange:this.handleTechnicianCategoryChange,placeholder:'Select Technician Category',isSearchable:true}))),this.state.technicianCategory==='Technician - Taabi Personal'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'8px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40_react_select__["a" /* default */],{classes:classes,options:this.state.assignedTechniciansTaabi,value:this.state.selectedTaabiTechnician,onChange:this.handleTaabiSelectChange,placeholder:'Select Technician - Taabi Personal',isSearchable:true}))),this.state.technicianCategory==='Technician - Freelancer'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControl___default.a,{className:'selectbox',style:{marginTop:'8px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40_react_select__["a" /* default */],{classes:classes,options:this.state.assignedTechniciansFreelancer,value:this.state.selectedFreelancerTechnician,onChange:this.handleFreelancerSelectChange,placeholder:'Select Technician - Freelancer',isSearchable:true}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button___default.a,{variant:'contained',component:'span',onClick:function onClick(){return _this4.handleGenerate();},style:{marginTop:'20px'}},'Generate Certificate'),'\xA0\xA0\xA0\xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button___default.a,{variant:'contained',component:'span',onClick:function onClick(){return _this4.downloadCertificate();},style:{marginTop:'20px'}},'Download Certificate')),' '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,fullwidth:true,style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},this.state.status!==2&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Checkbox___default.a,{checked:this.state.installStatus,onChange:this.handleChange('installStatus'),value:'installStatus',color:'primary',disabled:this.state.installStatus}),label:'Installation Completed'}),this.state.status===2&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Checkbox___default.a,{checked:this.state.installStatus,onClick:this.handleChange('installStatus'),value:'installStatus',color:'primary'// disabled={this.state.installStatus}
}),label:'Installation Completed'})),this.state.vehicleSegment!='DG Set'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Checkbox___default.a,{checked:this.state.immobilize,onClick:this.handleImmobilizeChange('immobilize'),value:'immobilize',color:'primary'// disabled={this.state.installStatus}
}),label:'Immobilizable'}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormGroup___default.a,{className:'form-input'},this.state.vtValidationError&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{style:{color:'red',textAlign:'center',marginBottom:'8px',fontWeight:500}},this.state.vtValidationError),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{justify:'center',container:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button___default.a,{color:'default',variant:'outlined',size:'medium',margin:'normal',className:'btn',href:'../../VehcileDashboard/Dashboard'},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button___default.a,{variant:'contained',color:'secondary',size:'medium',margin:'normal',className:'btn',type:'button',onClick:this.handleSubmit(this.props.client),disabled:this.isSubmitFormInvalid()// disabled={
//   this.state.errorMessage !== null ||
//   this.state.errorMessageNew !== null ||
//   this.state.errorMessageFuelTank !== null ||
//   this.state.isUploading ||
//   !this.state.isBaselineDataForFEValid ||
//   !this.state.isBaselineDistanceValid ||
//   !this.state.isDepartmentValid ||
//   !this.state.isContractorNameValid ||
//   !this.state.isEquipmentNameValid ||
//   !this.state.isEquipmentValid ||
//   !this.state.isInvoiceNoValid ||
//   !this.state.invoiceNumber||
//   !this.state.invoiceDate.date||
//   !(
//     this.state.isVlpnValid &&
//     this.state.vlpn !== '' &&
//     this.state.isSpeedLimitValid &&
//     this.state.isVehicleModelValid &&
//     this.state.isVehicleMakeValid &&
//     this.state.isVehicleTypeValid &&
//     this.state.isSpeedSensorValid &&
//     this.state.speedSensorType !== '' &&
//     this.state.speedLimit !== '' &&
//     this.state.vehicleType !== '' &&
//     this.state.vehicleModel &&
//     this.state.vehicleMake &&
//     this.state.isBaselineDataForFEValid
//   ) ||
//   this.state.portedVehicle ==='' ||
//    this.state.portedVehicle ===null||
//   this.state.isTestingVehicle ==='' ||
//    this.state.isTestingVehicle ===null||
//   this.state.solutionType === '' ||
//   (this.state.throughChannelPartner &&
//     this.state.channelPartnerName === '') ||
//   (this.state.throughChannelPartner &&
//     this.state.channelPartnerName === null) ||
//   this.state.zmId === '' ||
//   this.state.zmId === null ||
//   this.state.kamId === '' ||
//   this.state.kamId === null ||
//   (this.state.vehicleSegment === null ||
//     this.state.vehicleSegment === '') ||
//   (this.state.vehicleSegment === 'Transportation' &&
//     (!this.state.application ||
//       !['M&HCV', 'LM', 'PC', '2W', '3W', 'LCV'].includes(
//         this.state.equipmentTypeClass
//       ) ||
//       !this.state.vehicleWheeler)) ||
//   (this.state.vehicleSegment === 'EVs' &&
//     !this.state.equipmentTypeClassText) ||
//   (this.state.vehicleSegment === 'Construction' &&
//     !['Excavator', 'Crane', 'Gantry', 'Grader'].includes(
//       this.state.equipmentTypeClass
//     )) ||
//   (
//     this.state.vehicleSegment == 'DG Set' && !this.state.fuelTankCapacity
//   ) ||
//   (
//     this.state.vehicleSegment == 'DG Set' && !this.state.kvaRating
//   ) ||
//   (
//     this.state.vehicleSegment == 'DG Set' && !this.state.dgSetType
//   ) ||
//   (this.state.selectedVTM && !this.state.videoTelematicsId)
// }
},'Submit')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__material_ui_core_Dialog___default.a,{open:this.state.open,keepMounted:true,onClose:this.handleClose,'aria-labelledby':'alert-dialog-slide-title','aria-describedby':'alert-dialog-slide-description'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__ChangeVehicleStatus__["a" /* default */],{handleClose:this.handleClose,vehicleStatus:this.state.status,uniqueDeviceId:this.state.uniqueDeviceId})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__material_ui_core_Dialog___default.a,{open:this.state.open3,onClose:this.handleMailClose// keepMounted
,'aria-labelledby':'alert-dialog-slide-title','aria-describedby':'alert-dialog-slide-description'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__material_ui_core__["DialogTitle"],{id:'alert-dialog-title'},'Enter Your Mail Address'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__material_ui_core__["DialogContent"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__material_ui_core__["DialogContentText"],{id:'alert-dialog-description'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{id:'email',name:'email',className:'textfield',margin:'dense',label:'Email',onChange:this.handleMailChange,error:!this.state.ismailValid,onBlur:this.checkMail,value:this.state.mail}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.ismailValid?'Mail is not Valid':''),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__material_ui_core__["DialogActions"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button___default.a,{onClick:this.handleMailClose,color:'default',variant:'contained'},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Button___default.a,{type:'submit',color:'primary',variant:'contained',disabled:!(this.state.mail!==''&&this.state.ismailValid),onClick:function onClick(){return _this4.handleSendMail();}},'Submit')))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__material_ui_core_Dialog___default.a,{open:this.state.open2,onClose:this.handleDecoupleClose,'aria-labelledby':'alert-dialog-slide-title','aria-describedby':'alert-dialog-slide-description'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__DecoupleDevices__["a" /* default */],{handleClose:this.handleDecoupleClose,vehicleStatus:this.state.status,uniqueDeviceId:this.state.uniqueDeviceId,simId:this.state.simId,clientLoginId:this.state.clientLoginId})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__material_ui_core_Dialog___default.a,{open:this.state.swapOpen,keepMounted:true,onClose:this.handleSwapClose,'aria-labelledby':'alert-dialog-slide-title','aria-describedby':'alert-dialog-slide-description'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__SwapClient__["a" /* default */],{handleClose:this.handleSwapClose,clientLoginId:this.state.clientLoginId,clientName:this.state.clientName,vlpn:this.state.vlpn})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__material_ui_core_Dialog___default.a,{open:this.state.deleteOpen,keepMounted:true,onClose:this.handleDeleteClose,'aria-labelledby':'alert-dialog-slide-title','aria-describedby':'alert-dialog-slide-description'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__DeleteVehicle__["a" /* default */],{handleClose:this.handleDeleteClose,uniqueDeviceId:this.state.uniqueDeviceId,handleSucessDeleteClose:this.handleSucessDeleteClose}))))))));}}]);return VehicleRegistration;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_23__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_5_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_27__HOCs_withSharedSnackbar__["a" /* default */])(VehicleRegistration))));

/***/ }),
/* 2072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vehicle_css__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vehicle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__vehicle_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Input__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_DialogActions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_DialogContent__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_DialogContentText__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_DialogContentText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_DialogContentText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_DialogTitle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_DialogTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_DialogTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__HOCs_withSharedSnackbar__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  mutation deviceActivateDeactivateService(\n    $uniqueDeviceId: String!\n    $type: String!\n    $reason: String!\n  ) {\n    deviceActivateDeactivateService(\n      uniqueDeviceId: $uniqueDeviceId\n      type: $type\n      reason: $reason\n    )\n  }\n'],['\n  mutation deviceActivateDeactivateService(\n    $uniqueDeviceId: String!\n    $type: String!\n    $reason: String!\n  ) {\n    deviceActivateDeactivateService(\n      uniqueDeviceId: $uniqueDeviceId\n      type: $type\n      reason: $reason\n    )\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var styles=function styles(theme){return{root:{padding:theme.spacing.unit*2,flexGrow:1},textField:{marginLeft:theme.spacing.unit,marginRight:theme.spacing.unit,width:'200px'},container:{display:'flex',flexWrap:'wrap'}};};// calling server for updation
var UPDATE_DEVICE_STATUS=Object(__WEBPACK_IMPORTED_MODULE_11_graphql_tag__["a" /* default */])(_templateObject);var ChangeVehicleStatus=function(_Component){_inherits(ChangeVehicleStatus,_Component);function ChangeVehicleStatus(props){var _this2=this;_classCallCheck(this,ChangeVehicleStatus);var _this=_possibleConstructorReturn(this,(ChangeVehicleStatus.__proto__||Object.getPrototypeOf(ChangeVehicleStatus)).call(this,props));_this.handleChangeType=function(event){_this.setState({vehicleStatus:event.target.value});};_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));};};_this.handleSubmit=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _ref2,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:// console.log('submit')
event.preventDefault();_context.next=3;return _this.props.client.mutate({mutation:UPDATE_DEVICE_STATUS,variables:{uniqueDeviceId:_this.props.uniqueDeviceId,type:_this.state.vehicleStatus,reason:_this.state.reason},refetchQueries:['getVehicleDetail']// errorPolicy: 'all'
});case 3:_ref2=_context.sent;data=_ref2.data;_this.setState({reason:'',vehicleStatus:'',type:'',response:data.deviceActivateDeactivateService});if(_this.state.response==='Success'){_this.props.handleClose();// this.props.history.push({
//   pathname: '/home/VehcileDashboard/Dashboard'
// })
// this.props.history.goBack()
_this.props.openSnackbar('Vehicle Status Updated Successfully');}// console.log('Success', data.deviceActivateDeactivateService, Error)
case 7:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();console.log('vehicleStatus=',_this.props.vehicleStatus);_this.uniqueDeviceId=_this.props.uniqueDeviceId;_this.state={open1:false,vehicleStatus:'Activate',response:'',reason:''};return _this;}_createClass(ChangeVehicleStatus,[{key:'render',value:function render(){var classes=this.props;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{className:classes.container},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_DialogTitle___default.a,{id:'alert-dialog-slide-title'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_DialogContentText___default.a,{id:'alert-dialog-slide-description'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:'body2',gutterBottom:true},this.props.vehicleStatus===0?'Do you want to Activate this vehicle!':'Do you want to De-activate this vehicle!'),this.state.response==='Success'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:'subheading',gutterBottom:true,style:{color:'green',marginLeft:'25px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Sucessfully Updated')),this.state.response!=='Success'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Typography___default.a,{variant:'subheading',gutterBottom:true,style:{color:'red',marginLeft:'25px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,this.state.response)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_InputLabel___default.a,{htmlFor:'selectLabel'},'Select Status'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select___default.a,{value:this.state.vehicleStatus,onChange:this.handleChangeType,onBlur:this.checkVehicleTypeValidity,name:'Select Status',input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Input___default.a,{name:'vehicleStatus',id:'age-helper'})},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default.a,{value:'Activate'},'Activate'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default.a,{value:'Deactivate'},'Deactivate'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default.a,{value:'Service'},'Service')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{id:'reason',name:'reason',className:'textfield',margin:'dense',label:'Reason for updation!',type:'Multi-line',value:this.state.reason,onChange:this.handleInputChange('reason')})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_DialogActions___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button___default.a,{onClick:this.handleSubmit,color:'primary',variant:'contained',disabled:!(this.state.vehicleStatus!==''&&this.state.reason!=='')},'Submit'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button___default.a,{onClick:this.props.handleClose,color:'default',variant:'contained'},'Cancel')));}}]);return ChangeVehicleStatus;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_12_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_19__HOCs_withSharedSnackbar__["a" /* default */])(ChangeVehicleStatus))));

/***/ }),
/* 2073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__HOCs_withSharedSnackbar__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getAllAssignedDevicesToClient($clientId: Int!) {\n    device: getAllAssignedDevicesToClient(clientLoginId: $clientId) {\n      uniqueDeviceId\n      deviceModel {\n        model_name\n      }\n    }\n  }\n'],['\n  query getAllAssignedDevicesToClient($clientId: Int!) {\n    device: getAllAssignedDevicesToClient(clientLoginId: $clientId) {\n      uniqueDeviceId\n      deviceModel {\n        model_name\n      }\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query getAllAssignedSimToClient($clientId: Int!) {\n    simDetails: getAllAssignedSimToClient(clientLoginId: $clientId) {\n      id\n      simId\n      sim {\n        phoneNumber\n      }\n    }\n  }\n'],['\n  query getAllAssignedSimToClient($clientId: Int!) {\n    simDetails: getAllAssignedSimToClient(clientLoginId: $clientId) {\n      id\n      simId\n      sim {\n        phoneNumber\n      }\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation decoupleDeviceSim(\n    $newDeviceUniqueId: String\n    $existingDeviceUniqueId: String\n    $newSimId: Int\n    $existingSimId: Int\n    $decoupleType: String!\n    $loginType: String!\n  ) {\n    decoupleDeviceSim(\n      newDeviceUniqueId: $newDeviceUniqueId\n      existingDeviceUniqueId: $existingDeviceUniqueId\n      newSimId: $newSimId\n      existingSimId: $existingSimId\n      decoupleType: $decoupleType\n      loginType: $loginType\n    )\n  }\n'],['\n  mutation decoupleDeviceSim(\n    $newDeviceUniqueId: String\n    $existingDeviceUniqueId: String\n    $newSimId: Int\n    $existingSimId: Int\n    $decoupleType: String!\n    $loginType: String!\n  ) {\n    decoupleDeviceSim(\n      newDeviceUniqueId: $newDeviceUniqueId\n      existingDeviceUniqueId: $existingDeviceUniqueId\n      newSimId: $newSimId\n      existingSimId: $existingSimId\n      decoupleType: $decoupleType\n      loginType: $loginType\n    )\n  }\n']);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_DEVICE_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_12_graphql_tag__["a" /* default */])(_templateObject);var GET_SIM_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_12_graphql_tag__["a" /* default */])(_templateObject2);// calling server for updation
var DECOUPLE_DEVICESIM=Object(__WEBPACK_IMPORTED_MODULE_12_graphql_tag__["a" /* default */])(_templateObject3);var styles=function styles(theme){return{button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{margin:theme.spacing.unit,minWidth:120}};};var DecoupleDevices=function(_Component){_inherits(DecoupleDevices,_Component);function DecoupleDevices(props){var _this2=this;_classCallCheck(this,DecoupleDevices);var _this=_possibleConstructorReturn(this,(DecoupleDevices.__proto__||Object.getPrototypeOf(DecoupleDevices)).call(this,props));_this.handleChangeType=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var clientLoginId,_ref2,device,deviceError,allDevices,_ref3,simDetails,simError,allSims,_ref4,_device,_deviceError,_allDevices,_ref5,_simDetails,_simError,_allSims;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:// console.log('type', event)
_this.setState({vehicleStatus:event.value,deviceDecouple:false,simDecouple:false,deviceSimDecouple:false});clientLoginId=parseInt(_this.props.clientLoginId,10);if(!(event.value==='Device')){_context.next=12;break;}_context.next=5;return _this.props.client.query({query:GET_DEVICE_DETAILS,variables:{clientId:clientLoginId},errorPolicy:'all'});case 5:_ref2=_context.sent;device=_ref2.data;deviceError=_ref2.error;allDevices=device.device.map(function(device){return{value:device.uniqueDeviceId,label:device.uniqueDeviceId};});if(deviceError){_this.setState({deviceDetails:[]});}else{// console.log('alldevices', allDevices)
_this.setState({deviceDetails:allDevices,deviceDecouple:true});}_context.next=36;break;case 12:if(!(event.value==='Sim')){_context.next=22;break;}_context.next=15;return _this.props.client.query({query:GET_SIM_DETAILS,variables:{clientId:clientLoginId},errorPolicy:'all'});case 15:_ref3=_context.sent;simDetails=_ref3.data;simError=_ref3.error;allSims=simDetails.simDetails.map(function(sim){return{value:sim.simId,label:sim.sim.phoneNumber};});if(simError){_this.setState({simDetails:[]});}else{_this.setState({simDetails:allSims,simDecouple:true});}_context.next=36;break;case 22:_context.next=24;return _this.props.client.query({query:GET_DEVICE_DETAILS,variables:{clientId:clientLoginId},errorPolicy:'all'});case 24:_ref4=_context.sent;_device=_ref4.data;_deviceError=_ref4.error;_allDevices=_device.device.map(function(device){return{value:device.uniqueDeviceId,label:device.uniqueDeviceId};});_context.next=30;return _this.props.client.query({query:GET_SIM_DETAILS,variables:{clientId:clientLoginId},errorPolicy:'all'});case 30:_ref5=_context.sent;_simDetails=_ref5.data;_simError=_ref5.error;_allSims=_simDetails.simDetails.map(function(sim){return{value:sim.simId,label:sim.sim.phoneNumber};});if(_deviceError){_this.setState({deviceDetails:[]});}else{_this.setState({deviceDetails:_allDevices,deviceDecouple:true});}if(_simError){_this.setState({simDetails:[]});}else{_this.setState({simDetails:_allSims,simDecouple:true});}case 36:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.handleSubmit=function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(event){var _ref7,data,Error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:console.log('submit',_this.props.uniqueDeviceId);event.preventDefault();_context2.next=4;return _this.props.client.mutate({mutation:DECOUPLE_DEVICESIM,variables:{existingDeviceUniqueId:_this.props.uniqueDeviceId,newDeviceUniqueId:_this.state.serialNumber,newSimId:_this.state.phoneNumber,existingSimId:_this.props.simId,decoupleType:_this.state.vehicleStatus,loginType:localStorage.getItem('Account_type')},refetchQueries:['getVehicleDetail']// errorPolicy: 'all'
});case 4:_ref7=_context2.sent;data=_ref7.data;Error=_ref7.Error;console.log('res=',data,Error);_this.setState({response:data.decoupleDeviceSim});if(_this.state.response==='Success'){_this.props.openSnackbar('Vehicle Decoupled Successfully');_this.props.handleClose();}else{_this.props.openSnackbar('Vehicle Decouple unsuccessful');}case 10:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref6.apply(this,arguments);};}();_this.handleChangeDevice=function(event){_this.setState({serialNumber:event.value});};_this.handleChangePhoneNumber=function(event){_this.setState({phoneNumber:event.value});};_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));};};_this.entityId=_this.props.entityId;// console.log('sjhfskjdg')
_this.state={vehicleStatus:_this.props.vehicleStatus,deviceDetails:[],simDetails:[],serialNumber:null,phoneNumber:null,deviceDecouple:false,simDecouple:false,deviceSimDecouple:false,response:'',reason:''// console.log('client', this.props.clientLoginId)
};return _this;}_createClass(DecoupleDevices,[{key:'render',value:function render(){var classes=this.props;var arr1=['Device','Sim','DeviceAndSim'];var allTypes=arr1.map(function(a1){return{value:a1,label:a1};});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{width:'400px',height:'500px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle___default.a,{id:'form-dialog-title'},'Decouple Device/Sim'),this.state.response==='Success'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core__["Typography"],{variant:'subheading',gutterBottom:true,style:{color:'green',marginLeft:'25px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Decoupled Successfully')),this.state.response!=='Success'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core__["Typography"],{variant:'subheading',gutterBottom:true,style:{color:'red',marginLeft:'25px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,this.state.response)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Divider___default.a,{light:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{onSubmit:this.handleSubmit,style:{height:'250px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent___default.a,{style:{height:'250px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText___default.a,null,'* Marked fields are mandatory'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'100%',marginTop:'5%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */],{classes:classes,options:allTypes// components={components}
,value:this.state.vehicleStatus,onChange:this.handleChangeType,placeholder:'Select Decouple Type'})),(this.state.deviceDecouple||this.state.deviceSimDecouple)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'100%',marginTop:'5%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */],{classes:classes,options:this.state.deviceDetails//  components={components}
,value:this.state.serialNumber,onChange:this.handleChangeDevice,placeholder:'Select Device *'})),(this.state.simDecouple||this.state.deviceSimDecouple)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'100%',marginTop:'5%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */],{classes:classes,options:this.state.simDetails// components={components}
,value:this.state.phoneNumber,onChange:this.handleChangePhoneNumber,placeholder:'Select Phoneno *'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 100%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'reason',name:'reason',label:'Reason For Decouple!',type:'Multi-line',required:true,value:this.state.reason,fullWidth:true,onChange:this.handleInputChange('reason')// error={!this.state.isSerialnoValid}
// onBlur={this.checkSerialnoValidity}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:this.props.handleClose,color:'default',variant:'contained'},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a// onClick={this.handleClose}
,{type:'submit',color:'primary',variant:'contained',disabled:!(this.state.vehicleStatus!==''&&this.state.reason!=='')},'Submit'))))//   )}
// </Mutation>
;}}]);return DecoupleDevices;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_13_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_15__HOCs_withSharedSnackbar__["a" /* default */])(DecoupleDevices))));

/***/ }),
/* 2074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vehicle_css__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vehicle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__vehicle_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_DialogActions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_DialogContent__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_DialogContentText__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_DialogContentText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_DialogContentText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_DialogTitle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_DialogTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_DialogTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__HOCs_withSharedSnackbar__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  mutation deviceActivateDeactivateService(\n    $uniqueDeviceId: String!\n    $type: String!\n    $reason: String!\n  ) {\n    deviceActivateDeactivateService(\n      uniqueDeviceId: $uniqueDeviceId\n      type: $type\n      reason: $reason\n    )\n  }\n'],['\n  mutation deviceActivateDeactivateService(\n    $uniqueDeviceId: String!\n    $type: String!\n    $reason: String!\n  ) {\n    deviceActivateDeactivateService(\n      uniqueDeviceId: $uniqueDeviceId\n      type: $type\n      reason: $reason\n    )\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query allClientDetails($partnerLoginId: Int) {\n    clients: allClientDetails(partnerLoginId: $partnerLoginId) {\n      loginId\n      clientName\n    }\n  }\n'],['\n  query allClientDetails($partnerLoginId: Int) {\n    clients: allClientDetails(partnerLoginId: $partnerLoginId) {\n      loginId\n      clientName\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// import getLoginId from '../../../../utils/getLoginId'
var styles=function styles(theme){return{root:{padding:theme.spacing.unit*2,flexGrow:1},textField:{marginLeft:theme.spacing.unit,marginRight:theme.spacing.unit,width:'200px'},container:{display:'flex',flexWrap:'wrap'}};};// calling server for updation
var UPDATE_DEVICE_STATUS=Object(__WEBPACK_IMPORTED_MODULE_8_graphql_tag__["a" /* default */])(_templateObject);var GET_PARTNER_CLIENT_LIST=Object(__WEBPACK_IMPORTED_MODULE_8_graphql_tag__["a" /* default */])(_templateObject2);var SwapClient=function(_Component){_inherits(SwapClient,_Component);function SwapClient(props){var _this2=this;_classCallCheck(this,SwapClient);var _this=_possibleConstructorReturn(this,(SwapClient.__proto__||Object.getPrototypeOf(SwapClient)).call(this,props));_this.handleChangeType=function(event){_this.setState({vehicleStatus:event.target.value});};_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));};};_this.handleSubmit=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _ref2,data,Error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:console.log('submit');event.preventDefault();_context.next=4;return _this.props.client.mutate({mutation:UPDATE_DEVICE_STATUS,variables:{uniqueDeviceId:_this.props.uniqueDeviceId,type:_this.state.vehicleStatus,reason:_this.state.reason},refetchQueries:['getVehicleDetail']// errorPolicy: 'all'
});case 4:_ref2=_context.sent;data=_ref2.data;Error=_ref2.Error;_this.setState({reason:'',vehicleStatus:'',type:'',response:data.deviceActivateDeactivateService});if(_this.state.response==='Success'){_this.props.handleClose();// this.props.history.push({
//   pathname: '/home/VehcileDashboard/Dashboard'
// })
_this.props.openSnackbar('Vehicle Status Updated Successfully');}console.log('Success',data.deviceActivateDeactivateService,Error);case 10:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.handleChange=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(event){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_this.setState({clientname:event.value});case 1:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref3.apply(this,arguments);};}();_this.getClients=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var _ref5,data,allClients;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return _this.props.client.query({query:GET_PARTNER_CLIENT_LIST,variables:{partnerLoginId:parseInt(localStorage.getItem('Login_id'),10)}});case 2:_ref5=_context3.sent;data=_ref5.data;allClients=data.clients.map(function(client){return{value:client.loginId,label:client.clientName};});_this.setState({clientNames:allClients});case 6:case'end':return _context3.stop();}}},_callee3,_this2);}));console.log('vehicleStatus=',_this.props.vehicleStatus);_this.uniqueDeviceId=_this.props.uniqueDeviceId;_this.state={open1:false,clientname:'',clientNames:[],response:'',reason:''};return _this;}_createClass(SwapClient,[{key:'componentDidMount',value:function componentDidMount(){// console.log('hello')
this.getClients(this.props.client);}},{key:'render',value:function render(){var classes=this.props;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{className:classes.container},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_DialogTitle___default.a,{id:'alert-dialog-slide-title'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_DialogContentText___default.a,{id:'alert-dialog-slide-description'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body2',gutterBottom:true},'Do you want to assign this vehicle to other client!\''))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{id:'vehicleNumber',name:'vehicleNumber',className:'textfield',margin:'dense',label:'vehicle Number',value:this.props.vlpn,disabled:true}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{id:'existingClient',name:'existingClient',className:'textfield',margin:'dense',label:'Existing Client Name',value:this.props.clientName,disabled:true}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */],{classes:classes,options:this.state.clientNames// components={components}
,value:this.state.clientname,onChange:this.handleChange,placeholder:'Select Customer'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{id:'reason',name:'reason',className:'textfield',margin:'dense',label:'Reason for Swaping!',type:'Multi-line',value:this.state.reason,onChange:this.handleInputChange('reason')})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_DialogActions___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button___default.a,{onClick:this.handleSubmit,color:'primary',variant:'contained',disabled:!(this.state.clientname!==''&&this.state.reason!=='')},'Submit'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button___default.a,{onClick:this.props.handleClose,color:'default',variant:'contained'},'Cancel')));}}]);return SwapClient;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_10_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_16__HOCs_withSharedSnackbar__["a" /* default */])(SwapClient))));

/***/ }),
/* 2075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vehicle_css__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vehicle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__vehicle_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_DialogActions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_DialogContent__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_DialogContentText__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_DialogContentText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_DialogContentText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_DialogTitle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_DialogTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_DialogTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__HOCs_withSharedSnackbar__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  mutation deAssignVehicleAndSImFromCLient($uniqueDeviceId: String!) {\n    deAssignVehicleAndSImFromCLient(deviceUniqueId: $uniqueDeviceId)\n  }\n'],['\n  mutation deAssignVehicleAndSImFromCLient($uniqueDeviceId: String!) {\n    deAssignVehicleAndSImFromCLient(deviceUniqueId: $uniqueDeviceId)\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var styles=function styles(theme){return{root:{padding:theme.spacing.unit*2,flexGrow:1},textField:{marginLeft:theme.spacing.unit,marginRight:theme.spacing.unit,width:'200px'},container:{display:'flex',flexWrap:'wrap'}};};// calling server for updation
var DELETE_DEVICE=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject);var DeleteVehicle=function(_Component){_inherits(DeleteVehicle,_Component);function DeleteVehicle(props){var _this2=this;_classCallCheck(this,DeleteVehicle);var _this=_possibleConstructorReturn(this,(DeleteVehicle.__proto__||Object.getPrototypeOf(DeleteVehicle)).call(this,props));_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));};};_this.handleSubmit=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _ref2,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:event.preventDefault();_context.next=3;return _this.props.client.mutate({mutation:DELETE_DEVICE,variables:{uniqueDeviceId:_this.props.uniqueDeviceId,reason:_this.state.reason},refetchQueries:['getVehicleDetail']// errorPolicy: 'all'
});case 3:_ref2=_context.sent;data=_ref2.data;console.log('submit',data);_this.setState({reason:'',vehicleStatus:'',type:'',response:data.deAssignVehicleAndSImFromCLient});if(_this.state.response==='Successfully deassigned vehicle'){_this.props.handleSucessDeleteClose();_this.props.openSnackbar('Vehicle Deleted Successfully');// this.props.history.push({
//   pathname: '/home/VehcileDashboard/Dashboard'
// })
}else{_this.props.openSnackbar(data.deAssignVehicleAndSImFromCLient);}case 8:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();console.log('vehicleStatus=',_this.props.vehicleStatus);_this.uniqueDeviceId=_this.props.uniqueDeviceId;_this.state={open1:false,vehicleStatus:'Activate',response:'',reason:''};return _this;}_createClass(DeleteVehicle,[{key:'render',value:function render(){var classes=this.props;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{className:classes.container},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_DialogTitle___default.a,{id:'alert-dialog-slide-title'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_DialogContentText___default.a,{id:'alert-dialog-slide-description'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body2',gutterBottom:true},'Do you really want to Delete this vehicle!'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField___default.a,{id:'reason',name:'reason',className:'textfield',margin:'dense',label:'Reason for Deletion!',type:'Multi-line',value:this.state.reason,onChange:this.handleInputChange('reason')})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_DialogActions___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default.a,{onClick:this.handleSubmit,color:'primary',variant:'contained',disabled:!(this.state.reason!=='')},'Submit'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default.a,{onClick:this.props.handleClose,color:'default',variant:'contained'},'Cancel')));}}]);return DeleteVehicle;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_7_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_13__HOCs_withSharedSnackbar__["a" /* default */])(DeleteVehicle))));

/***/ }),
/* 2076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_mui_datatables__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query {\n    models: allDeviceModels(status: 1) {\n      id\n      model_name\n    }\n  }\n'],['\n  query {\n    models: allDeviceModels(status: 1) {\n      id\n      model_name\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query {\n    manufacturers: getAllManufacturer(status: 1) {\n      id\n      manufacturerName\n      manufacturerCode\n    }\n  }\n'],['\n  query {\n    manufacturers: getAllManufacturer(status: 1) {\n      id\n      manufacturerName\n      manufacturerCode\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation excelFileUpload(\n    $fileInfo: FileUploadInput!\n    $commonInput: CommonInput!\n  ) {\n    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {\n      failedToUpload\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedUploadList\n    }\n  }\n'],['\n  mutation excelFileUpload(\n    $fileInfo: FileUploadInput!\n    $commonInput: CommonInput!\n  ) {\n    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {\n      failedToUpload\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedUploadList\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n'],['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_MODELS=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject);var GET_MANUFACTURER=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject2);// calling server for updation
var ADD_DEVICE=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject3);var GET_UPLOAD_URL=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject4);var styles=function styles(theme){return{button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{margin:theme.spacing.unit,minWidth:120}};};var BulkDeviceUpload=function(_Component){_inherits(BulkDeviceUpload,_Component);function BulkDeviceUpload(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,BulkDeviceUpload);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BulkDeviceUpload.__proto__||Object.getPrototypeOf(BulkDeviceUpload)).call.apply(_ref,[this].concat(args))),_this),_this.state={open:false,open1:false,modelname:'',isModelNameValid:true,isManufacturerNameValid:true,manufacturerName:'',open_man:false,manufacturerCode:'',manufacturerId:'',publicUploadURL:'',fileName:'',bucketName:'',isUploading:false,uploadSucess:true,response:'',failList:'',result:false},_this.columns=['Serial Number','IMEI Number'],_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15,// sort: false,
// filter: false,
//  search: false,
print:false,download:false// viewColumns: false,
// pagination: false
},_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));};},_this.handleChange=function(event){_this.setState(_defineProperty({},event.target.name,event.target.value));},_this.handleOpen=function(){_this.setState({open:true});},_this.handleOpenSelect=function(){_this.setState({open1:true});},_this.handleCloseSelect=function(){_this.setState({open1:false});},_this.handleOpenSelectMan=function(){_this.setState({open_man:true});},_this.handleCloseSelectMan=function(){_this.setState({open_man:false});},_this.checkModelNameValidity=function(){_this.setState({isModelNameValid:_this.state.modelname!==''});},_this.checkManufacturerNameValidity=function(){console.log(_this.state.manufacturerName);var code=_this.state.manufacturerName.split('*');console.log('man',code[0]);_this.setState({isManufacturerNameValid:_this.state.manufacturerName!=='',// manufacturerCode:this
uniqueSerialNumber:code[1]+'_'+_this.state.serialno,manufacturerId:code[0]});},_this.handleSubmit=function(client){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var manarr,_ref3,data,fullData,arrList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:event.preventDefault();manarr=_this.state.manufacturerName.split('*');console.log('click fun',_this.state.bucketName,_this.state.fileName,manarr[0],manarr[1],_this.state.modelname);_context.next=5;return client.mutate({mutation:ADD_DEVICE,variables:{fileInfo:{uploadFor:'DeviceUploadBySuperAdmin',bucketName:_this.state.bucketName,fileName:_this.state.fileName,operationType:'SKIP'},commonInput:{superAdminLoginId:1,manufacturerId:manarr[0],manufacturerCode:manarr[1],deviceModelId:_this.state.modelname}}});case 5:_ref3=_context.sent;data=_ref3.data;fullData=[];arrList=data.excelFileUpload.failedUploadList;console.log('arr_list',JSON.parse(arrList));JSON.parse(arrList).forEach(function(element){var rowData=[];// this.clientId.push(element.id)
rowData.push(element.Serial_Number);rowData.push(element.IMEI);fullData.push(rowData);});// this.state.simprovider = ''
_this.setState({device_model_id:'',manufacturerId:'',response:'Total Excel Records= '+data.excelFileUpload.totalExcelDataRecords+','+'Total Records Uploaded='+data.excelFileUpload.successfullyUploaded+', Total Records Failed To Upload='+data.excelFileUpload.failedToUpload+', Total Duplicate Records in Excel='+data.excelFileUpload.totalDuplicateRecords,uploadSucess:true,failList:fullData,result:true});console.log('res=',data);case 13:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}();},_this.onUpload=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4){var _ref4$target=_ref4.target,validity=_ref4$target.validity,_ref4$target$files=_slicedToArray(_ref4$target.files,1),file=_ref4$target$files[0];var fileExtension,response,url,res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:// TODO: Handle upload errors
_this.setState({isUploading:true});if(!validity.valid){_context2.next=14;break;}fileExtension=file.name.substring(file.name.lastIndexOf('.')+1);_context2.next=5;return _this.props.client.mutate({mutation:GET_UPLOAD_URL,variables:{fileExtension:fileExtension}});case 5:response=_context2.sent;console.log('response',response);if(!(response.data&&response.data.getPublicUploadURL)){_context2.next=14;break;}url=response.data.getPublicUploadURL.publicUploadURL;_context2.next=11;return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(url,file,{headers:{"x-ms-blob-type":"BlockBlob","Content-Type":file.type||"application/octet-stream"}});case 11:res=_context2.sent;console.log('upload',res);_this.setState({fileName:response.data.getPublicUploadURL.filename,bucketName:response.data.getPublicUploadURL.bucketName,publicUploadURL:response.data.getPublicUploadURL.publicUploadURL});case 14:// console.log('final',
//   this.state.bucketName,
//   this.state.fileName,
//   this.state.publicUploadURL
// )
_this.setState({isUploading:false});case 15:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref5.apply(this,arguments);};}(),_temp),_possibleConstructorReturn(_this,_ret);}// handleSubmit = addDevice => e => {
_createClass(BulkDeviceUpload,[{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;console.log('MIDhere=');return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["Query"],{query:GET_MODELS},function(_ref6){var isModelsLoading=_ref6.loading,error=_ref6.error,models=_ref6.data.models;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["Query"],{query:GET_MANUFACTURER},function(_ref7){var isManufacturersLoading=_ref7.loading,error=_ref7.error,manufacturers=_ref7.data.manufacturers;if(isModelsLoading||isManufacturersLoading)return null;if(error)return'Error!: '+error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Add Device Details :',_this3.state.uploadSucess&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["Typography"],{variant:'subheading',color:'primary'},_this3.state.response),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Divider___default.a,{light:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_InputLabel___default.a,{htmlFor:'demo-controlled-open-select'},'Select Manufacturer'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select___default.a,{open:_this3.state.open_man,fullWidth:true,onClose:_this3.handleCloseSelectMan,onOpen:_this3.handleOpenSelectMan,value:_this3.state.manufacturerName,onChange:_this3.handleChange,onBlur:_this3.checkManufacturerNameValidity,inputProps:{name:'manufacturerName',id:'manufacturerName'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),manufacturers.map(function(manufacturer){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default.a,{value:manufacturer.id+'*'+manufacturer.manufacturerCode,key:manufacturer.id},manufacturer.manufacturerName);}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_InputLabel___default.a,{htmlFor:'demo-controlled-open-select'},'Select Model'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select___default.a,{open:_this3.state.open1,fullWidth:true,onClose:_this3.handleCloseSelect,onOpen:_this3.handleOpenSelect,value:_this3.state.modelname,onChange:_this3.handleChange,onBlur:_this3.checkModelNameValidity,inputProps:{name:'modelname',id:'modelname'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),models.map(function(allDeviceModelsByStatus){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default.a,{value:allDeviceModelsByStatus.id,key:allDeviceModelsByStatus.id},allDeviceModelsByStatus.model_name);}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{accept:'*/*',id:'contained-button-file',multiple:true,type:'file',style:{display:'none'},onChange:_this3.onUpload}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'contained-button-file'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{variant:'contained',component:'span'},_this3.state.isUploading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_CircularProgress___default.a,{size:15}):'Upload')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{onClick:_this3.handleClose,color:'default',variant:'contained'},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{onClick:_this3.handleSubmit(_this3.props.client),type:'submit',color:'primary',variant:'contained',disabled:!_this3.state.isModelNameValid},'Submit')),_this3.state.result&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',null,'Failed records list'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_mui_datatables___default.a,{data:_this3.state.failList,columns:_this3.columns,options:_this3.options}))));});});}}]);return BulkDeviceUpload;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__["withStyles"])(styles)(__WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter___default()(Object(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["withApollo"])(BulkDeviceUpload))));

/***/ }),
/* 2077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query {\n    allServiceProviders(status: 1) {\n      id\n      name\n    }\n  }\n'],['\n  query {\n    allServiceProviders(status: 1) {\n      id\n      name\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  mutation excelFileUpload(\n    $fileInfo: FileUploadInput!\n    $commonInput: CommonInput!\n  ) {\n    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {\n      failedToUpload\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedUploadList\n    }\n  }\n'],['\n  mutation excelFileUpload(\n    $fileInfo: FileUploadInput!\n    $commonInput: CommonInput!\n  ) {\n    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {\n      failedToUpload\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedUploadList\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n'],['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_PROVIDER=Object(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__["a" /* default */])(_templateObject);// calling server for updation
var ADD_SIM=Object(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__["a" /* default */])(_templateObject2);var GET_UPLOAD_URL=Object(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__["a" /* default */])(_templateObject3);var styles=function styles(theme){return{button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{margin:theme.spacing.unit,minWidth:120}};};var BulkSimUpload=function(_Component){_inherits(BulkSimUpload,_Component);function BulkSimUpload(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,BulkSimUpload);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BulkSimUpload.__proto__||Object.getPrototypeOf(BulkSimUpload)).call.apply(_ref,[this].concat(args))),_this),_this.state={open:false,open1:false,simprovider:'',uploadSucess:true,isSimProviderValid:false,response:'',failList:'',result:false},_this.columns=['Phone Number','SIM Number','Monthly Charges'],_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15,// sort: false,
// filter: false,
//  search: false,
print:false,download:false// viewColumns: false,
// pagination: false
},_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));};},_this.handleClickOpen=function(){_this.setState({open:true});},_this.handleClose=function(){_this.setState({open:false});},_this.handleChange=function(event){_this.setState(_defineProperty({},event.target.name,event.target.value));},_this.handleOpen=function(){_this.setState({open:true});},_this.handleOpenSelect=function(){_this.setState({open1:true});},_this.handleCloseSelect=function(){_this.setState({open1:false});},_this.checkSimProviderValidity=function(){_this.setState({isSimProviderValid:_this.state.simprovider!==''});},_this.handleSubmit=function(client){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _ref3,data,Error,fullData,arrList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:event.preventDefault();console.log('provider details',_this.state.simprovider,_this.state.bucketName,_this.state.fileName);_context.next=4;return client.mutate({mutation:ADD_SIM,variables:{fileInfo:{uploadFor:'SimUploadBySuperAdmin',bucketName:_this.state.bucketName,fileName:_this.state.fileName,operationType:'SKIP'},commonInput:{superAdminLoginId:1,serviceProviderId:parseInt(_this.state.simprovider,10)}}});case 4:_ref3=_context.sent;data=_ref3.data;Error=_ref3.Error;// this.state.simprovider = ''
fullData=[];arrList=data.excelFileUpload.failedUploadList;console.log('arr_list',JSON.parse(arrList));JSON.parse(arrList).forEach(function(element){var rowData=[];// this.clientId.push(element.id)
rowData.push(element.Phone_Number);rowData.push(element.Phone_Number);rowData.push(element.Monthly_Charges);fullData.push(rowData);});console.log('fail',fullData);_this.setState({simprovider:'',response:'Total Excel Records= '+data.excelFileUpload.totalExcelDataRecords+','+'Total Records Uploaded='+data.excelFileUpload.successfullyUploaded+', Total Records Failed To Upload='+data.excelFileUpload.failedToUpload+', Total Duplicate Records in Excel='+data.excelFileUpload.totalDuplicateRecords,uploadSucess:true,failList:fullData,result:true});console.log('res=',data,Error);case 14:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}();},_this.onUpload=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4){var _ref4$target=_ref4.target,validity=_ref4$target.validity,_ref4$target$files=_slicedToArray(_ref4$target.files,1),file=_ref4$target$files[0];var fileExtension,response,url,res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:// TODO: Handle upload errors
_this.setState({isUploading:true});console.log('uploaded');if(!validity.valid){_context2.next=15;break;}fileExtension=file.name.substring(file.name.lastIndexOf('.')+1);_context2.next=6;return _this.props.client.mutate({mutation:GET_UPLOAD_URL,variables:{fileExtension:fileExtension}});case 6:response=_context2.sent;console.log('response',response);if(!(response.data&&response.data.getPublicUploadURL)){_context2.next=15;break;}url=response.data.getPublicUploadURL.publicUploadURL;_context2.next=12;return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url,file,{headers:{"x-ms-blob-type":"BlockBlob","Content-Type":file.type||"application/octet-stream"}});case 12:res=_context2.sent;console.log('upload',res);_this.setState({fileName:response.data.getPublicUploadURL.filename,bucketName:response.data.getPublicUploadURL.bucketName,publicUploadURL:response.data.getPublicUploadURL.publicUploadURL});case 15:// console.log('final',
//   this.state.bucketName,
//   this.state.fileName,
//   this.state.publicUploadURL
// )
_this.setState({isUploading:false});case 16:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref5.apply(this,arguments);};}(),_temp),_possibleConstructorReturn(_this,_ret);}// handleSubmit = addDevice => e => {
_createClass(BulkSimUpload,[{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;console.log('sim=');return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_apollo__["Query"],{query:GET_PROVIDER},function(_ref6){var loading=_ref6.loading,error=_ref6.error,data=_ref6.data;var queriedData=data;if(loading)return'Loading...';if(error)return'Error!: '+error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'Upload Sim Details'),_this3.state.uploadSucess&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["Typography"],{variant:'subheading',color:'primary'},_this3.state.response),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_InputLabel___default.a,{htmlFor:'demo-controlled-open-select'},'Sim Provider'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select___default.a,{open:_this3.state.open1,fullWidth:true,onClose:_this3.handleCloseSelect,onOpen:_this3.handleOpenSelect,value:_this3.state.simprovider,onChange:_this3.handleChange,onBlur:_this3.checkSimProviderValidity,inputProps:{name:'simprovider',id:'simprovider'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),queriedData.allServiceProviders.map(function(allServiceProvidersByStatus){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default.a,{value:allServiceProvidersByStatus.id,key:allServiceProvidersByStatus.id},allServiceProvidersByStatus.name);}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{accept:'*/*',id:'contained-button-file',multiple:true,type:'file',style:{display:'none'},onChange:_this3.onUpload}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'contained-button-file'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{variant:'contained',component:'span'},_this3.state.isUploading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_CircularProgress___default.a,{size:15}):'Upload')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:_this3.handleClose,color:'primary'},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:_this3.handleSubmit(_this3.props.client),color:'primary',type:'submit',disabled:!_this3.state.isSimProviderValid},'Submit'),_this3.state.result&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',null,'Failed records list'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_mui_datatables___default.a,{data:_this3.state.failList,columns:_this3.columns,options:_this3.options})));});}}]);return BulkSimUpload;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__["withStyles"])(styles)(__WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter___default()(Object(__WEBPACK_IMPORTED_MODULE_5_react_apollo__["withApollo"])(BulkSimUpload))));

/***/ }),
/* 2078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query {\n    allServiceProviders(status: 1) {\n      id\n      name\n    }\n  }\n'],['\n  query {\n    allServiceProviders(status: 1) {\n      id\n      name\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  mutation excelFileUpload(\n    $fileInfo: FileUploadInput!\n    $commonInput: CommonInput!\n  ) {\n    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {\n      failedToUpload\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedUploadList\n    }\n  }\n'],['\n  mutation excelFileUpload(\n    $fileInfo: FileUploadInput!\n    $commonInput: CommonInput!\n  ) {\n    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {\n      failedToUpload\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedUploadList\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n'],['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query {\n    allPartnerDetails(status: 1) {\n      id\n      businessName\n      login {\n        loginId\n      }\n    }\n  }\n'],['\n  query {\n    allPartnerDetails(status: 1) {\n      id\n      businessName\n      login {\n        loginId\n      }\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_PROVIDER=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject);// calling server for updation
var ASSIGN_SIM=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject2);var GET_UPLOAD_URL=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject3);var GET_PARTNER_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject4);var styles=function styles(theme){return{button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{margin:theme.spacing.unit,minWidth:120}};};var BulkSimAssign=function(_Component){_inherits(BulkSimAssign,_Component);function BulkSimAssign(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,BulkSimAssign);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BulkSimAssign.__proto__||Object.getPrototypeOf(BulkSimAssign)).call.apply(_ref,[this].concat(args))),_this),_this.state={open:false,open1:false,open2:false,simprovider:'',isPartnerNameValid:true,isSimProviderValid:true,partnername:'',response:'',uploadSucess:false,failList:'',result:false},_this.columns=['Phone Number'],_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15,// sort: false,
filter:false,//  search: false,
print:false,download:false// viewColumns: false,
// pagination: false
},_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));};},_this.handleClickOpen=function(){_this.setState({open:true});},_this.handleClose=function(){_this.setState({open:false});},_this.handleChange=function(event){_this.setState(_defineProperty({},event.target.name,event.target.value));},_this.handleOpen=function(){_this.setState({open:true});},_this.handleOpenSelect=function(){_this.setState({open1:true});},_this.handleCloseSelect=function(){_this.setState({open1:false});},_this.handleOpenSelect2=function(){_this.setState({open2:true});},_this.handleCloseSelect2=function(){_this.setState({open2:false});},_this.checkSimProviderValidity=function(){_this.setState({isSimProviderValid:_this.state.simprovider!==''});},_this.handleSubmit=function(client){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _ref3,data,Error,fullData,arrList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:event.preventDefault();_context.next=3;return client.mutate({mutation:ASSIGN_SIM,variables:{fileInfo:{uploadFor:'SimAssignToPartnerUploadBySuperAdmin',bucketName:_this.state.bucketName,fileName:_this.state.fileName,operationType:'SKIP'},commonInput:{partnerLoginId:_this.state.partnername,serviceProviderId:_this.state.simprovider}}});case 3:_ref3=_context.sent;data=_ref3.data;Error=_ref3.Error;fullData=[];arrList=data.excelFileUpload.failedUploadList;console.log('arr_list',JSON.parse(arrList));JSON.parse(arrList).forEach(function(element){var rowData=[];// this.clientId.push(element.id)
rowData.push(element.Phone_Number);fullData.push(rowData);});// this.state.simprovider = ''
_this.setState({simprovider:'',response:'Total Excel Records= '+data.excelFileUpload.totalExcelDataRecords+','+'Total Records Uploaded='+data.excelFileUpload.successfullyUploaded+', Total Records Failed To Upload='+data.excelFileUpload.failedToUpload+', Total Duplicate Records in Excel='+data.excelFileUpload.totalDuplicateRecords,uploadSucess:true,failList:fullData,result:true});console.log('res=',data,Error);case 12:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}();},_this.onUpload=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4){var _ref4$target=_ref4.target,validity=_ref4$target.validity,_ref4$target$files=_slicedToArray(_ref4$target.files,1),file=_ref4$target$files[0];var fileExtension,response,url,res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:// TODO: Handle upload errors
_this.setState({isUploading:true});if(!validity.valid){_context2.next=14;break;}fileExtension=file.name.substring(file.name.lastIndexOf('.')+1);_context2.next=5;return _this.props.client.mutate({mutation:GET_UPLOAD_URL,variables:{fileExtension:fileExtension}});case 5:response=_context2.sent;console.log('response',response);if(!(response.data&&response.data.getPublicUploadURL)){_context2.next=14;break;}url=response.data.getPublicUploadURL.publicUploadURL;_context2.next=11;return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(url,file,{headers:{"x-ms-blob-type":"BlockBlob","Content-Type":file.type||"application/octet-stream"}});case 11:res=_context2.sent;console.log('upload',res);_this.setState({fileName:response.data.getPublicUploadURL.filename,bucketName:response.data.getPublicUploadURL.bucketName,publicUploadURL:response.data.getPublicUploadURL.publicUploadURL});case 14:// console.log('final',
//   this.state.bucketName,
//   this.state.fileName,
//   this.state.publicUploadURL
// )
_this.setState({isUploading:false});case 15:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref5.apply(this,arguments);};}(),_temp),_possibleConstructorReturn(_this,_ret);}// handleSubmit = addDevice => e => {
_createClass(BulkSimAssign,[{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;console.log('sim=');return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["Query"],{query:GET_PROVIDER},function(_ref6){var loading=_ref6.loading,error=_ref6.error,data=_ref6.data;var queriedData=data;if(loading)return'Loading...';if(error)return'Error!: '+error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["Query"],{query:GET_PARTNER_DETAILS},function(_ref7){var loading=_ref7.loading,error=_ref7.error,data=_ref7.data;var queriedData1=data;if(loading)return'Loading...';if(error)return'Error!: '+error;console.log('Data=',queriedData.allPartnerDetails);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'Upload Sim Details'),_this3.state.uploadSucess&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["Typography"],{variant:'subheading',color:'primary'},_this3.state.response),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 50%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_InputLabel___default.a,{htmlFor:'demo-controlled-open-select'},'Sim Provider'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select___default.a,{open:_this3.state.open1,fullWidth:true,onClose:_this3.handleCloseSelect,onOpen:_this3.handleOpenSelect,value:_this3.state.simprovider,onChange:_this3.handleChange,onBlur:_this3.checkSimProviderValidity,inputProps:{name:'simprovider',id:'simprovider'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),queriedData.allServiceProviders.map(function(allServiceProvidersByStatus){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default.a,{value:allServiceProvidersByStatus.id,key:allServiceProvidersByStatus.id},allServiceProvidersByStatus.name);}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'50%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_InputLabel___default.a,{htmlFor:'demo-controlled-open-select'},'Select Partner'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select___default.a,{open:_this3.state.open2,onClose:_this3.handleCloseSelect2,onOpen:_this3.handleOpenSelect2,fullWidth:true,placeholder:'a',name:'Select Partner',value:_this3.state.partnername,onChange:_this3.handleChange,error:!_this3.state.isPartnerNameValid,onBlur:_this3.checkPartnerNameValidity,inputProps:{name:'partnername',id:'partnername'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),queriedData1.allPartnerDetails.map(function(allPartnerDetailsByStatus){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default.a,{value:allPartnerDetailsByStatus.login.loginId,key:allPartnerDetailsByStatus.login.loginId},allPartnerDetailsByStatus.businessName);}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{accept:'*/*',id:'contained-button-file',multiple:true,type:'file',style:{display:'none'},onChange:_this3.onUpload}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'contained-button-file'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{variant:'contained',component:'span'},_this3.state.isUploading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_CircularProgress___default.a,{size:15}):'Upload')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{onClick:_this3.handleClose,color:'primary'},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{onClick:_this3.handleSubmit(_this3.props.client),color:'primary'// type="submit"
,disabled:!_this3.state.isSimProviderValid},'Submit'),_this3.state.result&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',null,'Failed records list'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_mui_datatables___default.a,{data:_this3.state.failList,columns:_this3.columns,options:_this3.options})));});});}}]);return BulkSimAssign;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__["withStyles"])(styles)(__WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter___default()(Object(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["withApollo"])(BulkSimAssign))));

/***/ }),
/* 2079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_mui_datatables__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query {\n    models: allDeviceModels(status: 1) {\n      id\n      model_name\n    }\n  }\n'],['\n  query {\n    models: allDeviceModels(status: 1) {\n      id\n      model_name\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query {\n    manufacturers: getAllManufacturer(status: 1) {\n      id\n      manufacturerName\n      manufacturerCode\n    }\n  }\n'],['\n  query {\n    manufacturers: getAllManufacturer(status: 1) {\n      id\n      manufacturerName\n      manufacturerCode\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation excelFileUpload(\n    $fileInfo: FileUploadInput!\n    $commonInput: CommonInput!\n  ) {\n    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {\n      failedToUpload\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedUploadList\n    }\n  }\n'],['\n  mutation excelFileUpload(\n    $fileInfo: FileUploadInput!\n    $commonInput: CommonInput!\n  ) {\n    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {\n      failedToUpload\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedUploadList\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n'],['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  query {\n    allPartnerDetails(status: 1) {\n      id\n      businessName\n      login {\n        loginId\n      }\n    }\n  }\n'],['\n  query {\n    allPartnerDetails(status: 1) {\n      id\n      businessName\n      login {\n        loginId\n      }\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_MODELS=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject);var GET_MANUFACTURER=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject2);// calling server for updation
var ASSIGN_DEVICE=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject3);var GET_UPLOAD_URL=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject4);var GET_PARTNER_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject5);var styles=function styles(theme){return{button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{margin:theme.spacing.unit,minWidth:120}};};var BulkDeviceAssign=function(_Component){_inherits(BulkDeviceAssign,_Component);function BulkDeviceAssign(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,BulkDeviceAssign);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BulkDeviceAssign.__proto__||Object.getPrototypeOf(BulkDeviceAssign)).call.apply(_ref,[this].concat(args))),_this),_this.state={open:false,open1:false,modelname:'',isModelNameValid:true,isManufacturerNameValid:true,manufacturerName:'',open_man:false,manufacturerCode:'',manufacturerId:'',publicUploadURL:'',fileName:'',bucketName:'',isUploading:false,partnername:'',open2:false,uploadSucess:true,response:'',failList:'',result:false},_this.columns=['Serial Number'],_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15,// sort: false,
filter:false,//  search: false,
print:false,download:false// viewColumns: false,
// pagination: false
},_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));};},_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));};},_this.handleChange=function(event){_this.setState(_defineProperty({},event.target.name,event.target.value));},_this.handleOpen=function(){_this.setState({open:true});},_this.handleOpenSelect=function(){_this.setState({open1:true});},_this.handleCloseSelect=function(){_this.setState({open1:false});},_this.handleOpenSelectMan=function(){_this.setState({open_man:true});},_this.handleCloseSelectMan=function(){_this.setState({open_man:false});},_this.handleOpenSelect2=function(){_this.setState({open2:true});},_this.handleCloseSelect2=function(){_this.setState({open2:false});},_this.checkModelNameValidity=function(){_this.setState({isModelNameValid:_this.state.modelname!==''});},_this.checkManufacturerNameValidity=function(){console.log(_this.state.manufacturerName);var code=_this.state.manufacturerName.split('*');console.log('man',code[0]);_this.setState({isManufacturerNameValid:_this.state.manufacturerName!=='',// manufacturerCode:this
uniqueSerialNumber:code[1]+'_'+_this.state.serialno,manufacturerId:code[0]});},_this.handleSubmit=function(client){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _ref3,data,Error,fullData,arrList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:event.preventDefault();console.log('click fun',_this.state.manufacturerName,_this.state.manufacturerCode,_this.state.modelname);// let manarr = this.state.manufacturerName.split('*')
_context.next=4;return client.mutate({mutation:ASSIGN_DEVICE,variables:{fileInfo:{uploadFor:'DeviceAssignToPartnerUploadBySuperAdmin',bucketName:_this.state.bucketName,fileName:_this.state.fileName,operationType:'SKIP'},commonInput:{partnerLoginId:_this.state.partnername,deviceModelId:_this.state.modelname}}});case 4:_ref3=_context.sent;data=_ref3.data;Error=_ref3.Error;fullData=[];arrList=data.excelFileUpload.failedUploadList;console.log('arr_list',JSON.parse(arrList));JSON.parse(arrList).forEach(function(element){var rowData=[];// this.clientId.push(element.id)
rowData.push(element.Device_Serial_Number);fullData.push(rowData);});// this.state.simprovider = ''
_this.setState({device_model_id:'',manufacturerId:'',response:'Total Excel Records= '+data.excelFileUpload.totalExcelDataRecords+','+'Total Records Uploaded='+data.excelFileUpload.successfullyUploaded+', Total Records Failed To Upload='+data.excelFileUpload.failedToUpload+', Total Duplicate Records in Excel='+data.excelFileUpload.totalDuplicateRecords,uploadSucess:true,failList:fullData,result:true});console.log('res=',data,Error);case 13:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}();},_this.onUpload=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4){var _ref4$target=_ref4.target,validity=_ref4$target.validity,_ref4$target$files=_slicedToArray(_ref4$target.files,1),file=_ref4$target$files[0];var fileExtension,response,url,res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:// TODO: Handle upload errors
_this.setState({isUploading:true});if(!validity.valid){_context2.next=14;break;}fileExtension=file.name.substring(file.name.lastIndexOf('.')+1);_context2.next=5;return _this.props.client.mutate({mutation:GET_UPLOAD_URL,variables:{fileExtension:fileExtension}});case 5:response=_context2.sent;console.log('response',response);if(!(response.data&&response.data.getPublicUploadURL)){_context2.next=14;break;}url=response.data.getPublicUploadURL.publicUploadURL;_context2.next=11;return __WEBPACK_IMPORTED_MODULE_13_axios___default.a.put(url,file,{headers:{"x-ms-blob-type":"BlockBlob","Content-Type":file.type||"application/octet-stream"}});case 11:res=_context2.sent;console.log('upload',res);_this.setState({fileName:response.data.getPublicUploadURL.filename,bucketName:response.data.getPublicUploadURL.bucketName,publicUploadURL:response.data.getPublicUploadURL.publicUploadURL});case 14:// console.log('final',
//   this.state.bucketName,
//   this.state.fileName,
//   this.state.publicUploadURL
// )
_this.setState({isUploading:false});case 15:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref5.apply(this,arguments);};}(),_temp),_possibleConstructorReturn(_this,_ret);}// handleSubmit = addDevice => e => {
_createClass(BulkDeviceAssign,[{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;console.log('MIDhere=');return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["Query"],{query:GET_MODELS},function(_ref6){var isModelsLoading=_ref6.loading,error=_ref6.error,models=_ref6.data.models;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["Query"],{query:GET_MANUFACTURER},function(_ref7){var isManufacturersLoading=_ref7.loading,error=_ref7.error,manufacturers=_ref7.data.manufacturers;if(isModelsLoading||isManufacturersLoading)return null;if(error)return'Error!: '+error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["Query"],{query:GET_PARTNER_DETAILS},function(_ref8){var loading=_ref8.loading,error=_ref8.error,data=_ref8.data;var queriedData1=data;if(loading)return'Loading...';if(error)return'Error!: '+error;console.log('Data=',queriedData1.allPartnerDetails);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Assign Device Details :',_this3.state.uploadSucess&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Typography"],{variant:'subheading',color:'primary'},_this3.state.response),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider___default.a,{light:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel___default.a,{htmlFor:'demo-controlled-open-select'},'Select Model'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select___default.a,{open:_this3.state.open1,fullWidth:true,onClose:_this3.handleCloseSelect,onOpen:_this3.handleOpenSelect,value:_this3.state.modelname,onChange:_this3.handleChange,onBlur:_this3.checkModelNameValidity,inputProps:{name:'modelname',id:'modelname'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),models.map(function(allDeviceModelsByStatus){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem___default.a,{value:allDeviceModelsByStatus.id,key:allDeviceModelsByStatus.id},allDeviceModelsByStatus.model_name);}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'50%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel___default.a,{htmlFor:'demo-controlled-open-select'},'Select Partner'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select___default.a,{open:_this3.state.open2,onClose:_this3.handleCloseSelect2,onOpen:_this3.handleOpenSelect2,fullWidth:true,placeholder:'a',name:'Select Partner',value:_this3.state.partnername,onChange:_this3.handleChange,error:!_this3.state.isPartnerNameValid,onBlur:_this3.checkPartnerNameValidity,inputProps:{name:'partnername',id:'partnername'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),queriedData1.allPartnerDetails.map(function(allPartnerDetailsByStatus){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem___default.a,{value:allPartnerDetailsByStatus.login.loginId,key:allPartnerDetailsByStatus.login.loginId},allPartnerDetailsByStatus.businessName);}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{accept:'*/*',id:'contained-button-file',multiple:true,type:'file',style:{display:'none'},onChange:_this3.onUpload}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'contained-button-file'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{variant:'contained',component:'span'},_this3.state.isUploading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress___default.a,{size:15}):'Upload')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:_this3.handleClose,color:'default',variant:'contained'},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:_this3.handleSubmit(_this3.props.client),type:'submit',color:'primary',variant:'contained',disabled:!_this3.state.isModelNameValid},'Submit')),_this3.state.result&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',null,'Failed records list'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_mui_datatables___default.a,{data:_this3.state.failList,columns:_this3.columns,options:_this3.options}))));});});});}}]);return BulkDeviceAssign;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["withStyles"])(styles)(__WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter___default()(Object(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["withApollo"])(BulkDeviceAssign))));

/***/ }),
/* 2080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_file_saver__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_file_saver__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query {\n    models: allDeviceModels(status: 1) {\n      id\n      model_name\n    }\n  }\n'],['\n  query {\n    models: allDeviceModels(status: 1) {\n      id\n      model_name\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query {\n    manufacturers: getAllManufacturer(status: 1) {\n      id\n      manufacturerName\n      manufacturerCode\n    }\n  }\n'],['\n  query {\n    manufacturers: getAllManufacturer(status: 1) {\n      id\n      manufacturerName\n      manufacturerCode\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation excelFileUpload(\n    $fileInfo: FileUploadInput!\n    $commonInput: CommonInput!\n  ) {\n    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {\n      failedToUpload\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedUploadList\n    }\n  }\n'],['\n  mutation excelFileUpload(\n    $fileInfo: FileUploadInput!\n    $commonInput: CommonInput!\n  ) {\n    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {\n      failedToUpload\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedUploadList\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n'],['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n'],['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable */var GET_MODELS=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject);var GET_MANUFACTURER=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject2);var ADD_DEVICE=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject3);var GET_UPLOAD_URL=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject4);var GET_FILE_FORMAT=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject5);var styles=function styles(theme){return{button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{margin:theme.spacing.unit,minWidth:120},root:{flexGrow:1,padding:theme.spacing.unit*2}};};var RegisterBulkDevice=function(_Component){_inherits(RegisterBulkDevice,_Component);function RegisterBulkDevice(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,RegisterBulkDevice);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RegisterBulkDevice.__proto__||Object.getPrototypeOf(RegisterBulkDevice)).call.apply(_ref,[this].concat(args))),_this),_this.state={open:false,open1:false,modelname:'',isModelNameValid:false,isManufacturerNameValid:false,manufacturerName:'',open_man:false,manufacturerCode:'',manufacturerId:'',publicUploadURL:'',fileName:'',bucketName:'',isUploading:false,uploadSucess:true,response:'',failList:'',result:false,isLoading:false,disable:false},_this.columns=['Serial Number','Reason'],_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15// sort: false,
// filter: false,
//  search: false,
// print: false,
// download: false
// viewColumns: false,
// pagination: false
},_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));};},_this.handleChange=function(event){_this.setState(_defineProperty({},event.target.name,event.target.value));},_this.handleOpen=function(){_this.setState({open:true});},_this.handleOpenSelect=function(){_this.setState({open1:true});},_this.handleCloseSelect=function(){_this.setState({open1:false});},_this.handleOpenSelectMan=function(){_this.setState({open_man:true});},_this.handleCloseSelectMan=function(){_this.setState({open_man:false});},_this.checkModelNameValidity=function(){_this.setState({isModelNameValid:_this.state.modelname!==''});},_this.checkManufacturerNameValidity=function(){console.log(_this.state.manufacturerName);var code=_this.state.manufacturerName.split('*');console.log('man',code[0]);_this.setState({isManufacturerNameValid:_this.state.manufacturerName!=='',// manufacturerCode:this
uniqueSerialNumber:code[1]+'_'+_this.state.serialno,manufacturerId:code[0]});},_this.setToDefaults=function(){_this.setState({open:false,open1:false,modelname:'',isModelNameValid:false,isManufacturerNameValid:false,manufacturerName:'',open_man:false,manufacturerCode:'',manufacturerId:'',publicUploadURL:'',fileName:'',bucketName:'',isUploading:false,uploadSucess:true,response:'',failList:'',result:false,isLoading:false,disable:false});},_this.handleSubmit=function(client){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var manarr,_ref3,data,errors,fullData,arrList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:event.preventDefault();_this.setState({isLoading:true,disable:true});manarr=_this.state.manufacturerName.split('*');// console.log(
//   'click fun',
//   this.state.bucketName,
//   this.state.fileName,
//   manarr[0],
//   manarr[1],
//   this.state.modelname
// )
_context.next=5;return client.mutate({mutation:ADD_DEVICE,variables:{fileInfo:{uploadFor:'DeviceUploadByPartner',bucketName:_this.state.bucketName,fileName:_this.state.fileName,operationType:'SKIP'},commonInput:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_16__utils_getLoginId__["a" /* default */])(),manufacturerId:parseInt(manarr[0],10),manufacturerCode:manarr[1],deviceModelId:parseInt(_this.state.modelname,10)}},errorPolicy:'all'});case 5:_ref3=_context.sent;data=_ref3.data;errors=_ref3.errors;_this.setState({isLoading:false});if(data!==null){fullData=[];arrList=data.excelFileUpload.failedUploadList;// console.log('arr_list', JSON.parse(arrList))
JSON.parse(arrList).forEach(function(element){var rowData=[];// this.clientId.push(element.id)
rowData.push(element.serialNumber);rowData.push(element.error);// console.log('rowdata', toString(element.serialNumber))
fullData.push(rowData);});// this.state.simprovider = ''
_this.setState({device_model_id:'',manufacturerId:'',response:'Total Excel Records= '+data.excelFileUpload.totalExcelDataRecords+','+'Total Records Uploaded='+data.excelFileUpload.successfullyUploaded+', Total Records Failed To Upload='+data.excelFileUpload.failedToUpload+', Total Duplicate Records in Excel='+data.excelFileUpload.totalDuplicateRecords,uploadSucess:true,failList:fullData,result:true});}else{_this.setState({response:errors[0].message,uploadSucess:true});}// console.log('res=', this.state.failList)
case 10:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}();},_this.onUpload=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4){var _ref4$target=_ref4.target,validity=_ref4$target.validity,_ref4$target$files=_slicedToArray(_ref4$target.files,1),file=_ref4$target$files[0];var fileExtension,response,url;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:// TODO: Handle upload errors
_this.setState({isUploading:true});if(!validity.valid){_context2.next=11;break;}fileExtension=file.name.substring(file.name.lastIndexOf('.')+1);_context2.next=5;return _this.props.client.mutate({mutation:GET_UPLOAD_URL,variables:{fileExtension:fileExtension}});case 5:response=_context2.sent;if(!(response.data&&response.data.getPublicUploadURL)){_context2.next=11;break;}url=response.data.getPublicUploadURL.publicUploadURL;_context2.next=10;return __WEBPACK_IMPORTED_MODULE_13_axios___default.a.put(url,file,{headers:{"x-ms-blob-type":"BlockBlob","Content-Type":file.type||"application/octet-stream"}});case 10:// console.log('upload', res)
_this.setState({fileName:response.data.getPublicUploadURL.filename,bucketName:response.data.getPublicUploadURL.bucketName,publicUploadURL:response.data.getPublicUploadURL.publicUploadURL});case 11:_this.setState({isUploading:false});case 12:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref5.apply(this,arguments);};}(),_this.downloadBulkUpload=function(client){return function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(event){var _ref7,data,res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:console.log('click fun');_context3.next=3;return _this.props.client.query({query:GET_FILE_FORMAT,variables:{bucketname:'excel-templates',filename:'deviceUpload.xlsx'},errorPolicy:'all'});case 3:_ref7=_context3.sent;data=_ref7.data;console.log('file',data.getPublicDownloadURL);_context3.next=8;return __WEBPACK_IMPORTED_MODULE_13_axios___default()({url:data.getPublicDownloadURL,method:'GET',headers:{Accept:'application/vnd.ms-excel'},responseType:'blob'// important
});case 8:res=_context3.sent;__WEBPACK_IMPORTED_MODULE_17_file_saver___default.a.saveAs(new Blob([res.data]),'sample.xlsx');// FileSaver.saveAs(data.getPublicDownloadURL, 'sample.xlsx')
case 10:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x3){return _ref6.apply(this,arguments);};}();},_temp),_possibleConstructorReturn(_this,_ret);}// handleSubmit = addDevice => e => {
_createClass(RegisterBulkDevice,[{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;// console.log('MIDhere=')
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["Query"],{query:GET_MODELS,fetchPolicy:'network-only'},function(_ref8){var isModelsLoading=_ref8.loading,error=_ref8.error,models=_ref8.data.models;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["Query"],{query:GET_MANUFACTURER,fetchPolicy:'network-only'},function(_ref9){var isManufacturersLoading=_ref9.loading,error=_ref9.error,manufacturers=_ref9.data.manufacturers;if(isModelsLoading||isManufacturersLoading)return null;if(error)return'Error!: '+error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{container:true,direction:'row',justify:'flex-start',alignItems:'center',spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Typography"],{variant:'title'},' ','Add Device Details')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},_this3.state.uploadSucess&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Typography"],{variant:'subheading',color:'primary'},_this3.state.response)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider___default.a,{light:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{style:{minWidth:'40%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'100%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel___default.a,{htmlFor:'demo-controlled-open-select'},'Select Manufacturer'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select___default.a,{open:_this3.state.open_man,fullWidth:true,onClose:_this3.handleCloseSelectMan,onOpen:_this3.handleOpenSelectMan,value:_this3.state.manufacturerName,onChange:_this3.handleChange,onBlur:_this3.checkManufacturerNameValidity,inputProps:{name:'manufacturerName',id:'manufacturerName'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),manufacturers.map(function(manufacturer){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem___default.a,{value:manufacturer.id+'*'+manufacturer.manufacturerCode,key:manufacturer.id},manufacturer.manufacturerName);}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'100%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel___default.a,{htmlFor:'demo-controlled-open-select'},'Select Model'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select___default.a,{open:_this3.state.open1,fullWidth:true,onClose:_this3.handleCloseSelect,onOpen:_this3.handleOpenSelect,value:_this3.state.modelname,onChange:_this3.handleChange,onBlur:_this3.checkModelNameValidity,inputProps:{name:'modelname',id:'modelname'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),models.map(function(allDeviceModelsByStatus){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem___default.a,{value:allDeviceModelsByStatus.id,key:allDeviceModelsByStatus.id},allDeviceModelsByStatus.model_name);}))),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),'Download sample template for device upload in bulk'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{color:'secondary',variant:'contained',className:classes.button,onClick:_this3.downloadBulkUpload(_this3.props.client)},'Download Excel')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{accept:'*/*',id:'contained-button-file',multiple:true,type:'file',style:{display:'none'},onChange:_this3.onUpload}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'contained-button-file'},'Upload excel file here \xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{variant:'contained',component:'span',color:'primary'},_this3.state.isUploading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress___default.a,{size:15}):'Upload')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{color:'default',variant:'contained',onClick:_this3.setToDefaults},'SET TO DEFAULTS'),'       ','       ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{color:'default',variant:'contained',onClick:function onClick(){return _this3.props.history.goBack();}},'Cancel'),'       ','       ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:_this3.handleSubmit(_this3.props.client),type:'submit',color:'primary',variant:'contained',disabled:!(_this3.state.isModelNameValid&&_this3.state.fileName!==''&&_this3.state.isManufacturerNameValid)||_this3.state.disable},'Submit'),' ',_this3.state.isLoading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'Excel sheet upload is in progress..')),_this3.state.result&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',null,'Failed records list'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_mui_datatables___default.a,{data:_this3.state.failList,columns:_this3.columns,options:_this3.options})))));});});}}]);return RegisterBulkDevice;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["withStyles"])(styles)(__WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter___default()(Object(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["withApollo"])(RegisterBulkDevice))));

/***/ }),
/* 2081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_file_saver__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_router_dom__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Router__ = __webpack_require__(116);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query {\n    models: allDeviceModels(status: 1) {\n      id\n      model_name\n    }\n  }\n'],['\n  query {\n    models: allDeviceModels(status: 1) {\n      id\n      model_name\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query {\n    manufacturers: getAllManufacturer(status: 1) {\n      id\n      manufacturerName\n      manufacturerCode\n    }\n  }\n'],['\n  query {\n    manufacturers: getAllManufacturer(status: 1) {\n      id\n      manufacturerName\n      manufacturerCode\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation($fileInfo: FileUploadInput!, $commonInput: CommonInput!) {\n    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedToUpload\n      failedUploadList\n      __typename\n    }\n  }\n'],['\n  mutation($fileInfo: FileUploadInput!, $commonInput: CommonInput!) {\n    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedToUpload\n      failedUploadList\n      __typename\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n'],['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n'],['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable */var GET_MODELS=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject);var GET_MANUFACTURER=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject2);// const ADD_DEVICE = gql`
//   mutation excelFileUpload(
//     $fileInfo: FileUploadInput!
//     $commonInput: CommonInput!
//   ) {
//     excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {
//       failedToUpload
//       totalExcelDataRecords
//       totalDuplicateRecords
//       successfullyUploaded
//       failedUploadList
//     }
//   }
// `
var DELETE_DEVICE=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject3);var GET_UPLOAD_URL=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject4);var GET_FILE_FORMAT=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject5);var styles=function styles(theme){return{button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{margin:theme.spacing.unit,minWidth:120},root:{flexGrow:1,padding:theme.spacing.unit*2}};};var DeleteBulkDevice=function(_Component){_inherits(DeleteBulkDevice,_Component);function DeleteBulkDevice(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,DeleteBulkDevice);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DeleteBulkDevice.__proto__||Object.getPrototypeOf(DeleteBulkDevice)).call.apply(_ref,[this].concat(args))),_this),_this.state={open:false,open1:false,modelname:'',isModelNameValid:false,isManufacturerNameValid:false,manufacturerName:'',open_man:false,manufacturerCode:'',manufacturerId:'',publicUploadURL:'',fileName:'',bucketName:'',isUploading:false,uploadSucess:true,response:'',failList:'',result:false,isLoading:false,disable:false},_this.columns=['Serial Number','IMEI Number','Reason'],_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15// sort: false,
// filter: false,
//  search: false,
// print: false,
// download: false
// viewColumns: false,
// pagination: false
},_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));};},_this.handleChange=function(event){_this.setState(_defineProperty({},event.target.name,event.target.value));},_this.handleOpen=function(){_this.setState({open:true});},_this.handleOpenSelect=function(){_this.setState({open1:true});},_this.handleCloseSelect=function(){_this.setState({open1:false});},_this.handleOpenSelectMan=function(){_this.setState({open_man:true});},_this.handleCloseSelectMan=function(){_this.setState({open_man:false});},_this.checkModelNameValidity=function(){_this.setState({isModelNameValid:_this.state.modelname!==''});},_this.checkManufacturerNameValidity=function(){console.log(_this.state.manufacturerName);var code=_this.state.manufacturerName.split('*');console.log('man',code[0]);_this.setState({isManufacturerNameValid:_this.state.manufacturerName!=='',// manufacturerCode:this
uniqueSerialNumber:code[1]+'_'+_this.state.serialno,manufacturerId:code[0]});},_this.handleSubmit=function(client){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var manarr,_ref3,data,errors,fullData,arrList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:event.preventDefault();_this.setState({isLoading:true,disable:true});manarr=_this.state.manufacturerName.split('*');// console.log(
//   'click fun',
//   this.state.bucketName,
//   this.state.fileName,
//   manarr[0],
//   manarr[1],
//   this.state.modelname
// )
_context.next=5;return client.mutate({mutation:DELETE_DEVICE,variables:{fileInfo:{uploadFor:'DeleteDevice',bucketName:_this.state.bucketName,fileName:_this.state.fileName,operationType:'SKIP'},commonInput:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_16__utils_getLoginId__["a" /* default */])(),manufacturerId:parseInt(manarr[0],10),manufacturerCode:manarr[1],deviceModelId:parseInt(_this.state.modelname,10)}},errorPolicy:'all'});case 5:_ref3=_context.sent;data=_ref3.data;errors=_ref3.errors;_this.setState({isLoading:false});if(data!==null){fullData=[];arrList=data.excelFileUpload.failedUploadList;console.log('arr_list',JSON.parse(arrList));JSON.parse(arrList).forEach(function(element){var rowData=[];// this.clientId.push(element.id)
rowData.push(element.serial_num?element.serial_num:'Na');rowData.push(element.imei_num?element.imei_num:'Na');rowData.push(element.errorMsg?element.errorMsg:'Na');// console.log('rowdata', toString(element.serialNumber))
fullData.push(rowData);});// this.state.simprovider = ''
_this.setState({device_model_id:'',manufacturerId:'',response:'Total Excel Records= '+data.excelFileUpload.totalExcelDataRecords+','+'Total Records Uploaded='+data.excelFileUpload.successfullyUploaded+', Total Records Failed To Upload='+data.excelFileUpload.failedToUpload+', Total Duplicate Records in Excel='+data.excelFileUpload.totalDuplicateRecords,uploadSucess:true,failList:fullData,result:true});}else{_this.setState({response:errors[0].message,uploadSucess:true});}// console.log('res=', this.state.failList)
case 10:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}();},_this.onUpload=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4){var _ref4$target=_ref4.target,validity=_ref4$target.validity,_ref4$target$files=_slicedToArray(_ref4$target.files,1),file=_ref4$target$files[0];var fileExtension,response,url;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:// TODO: Handle upload errors
_this.setState({isUploading:true});if(!validity.valid){_context2.next=11;break;}fileExtension=file.name.substring(file.name.lastIndexOf('.')+1);_context2.next=5;return _this.props.client.mutate({mutation:GET_UPLOAD_URL,variables:{fileExtension:fileExtension}});case 5:response=_context2.sent;if(!(response.data&&response.data.getPublicUploadURL)){_context2.next=11;break;}url=response.data.getPublicUploadURL.publicUploadURL;_context2.next=10;return __WEBPACK_IMPORTED_MODULE_13_axios___default.a.put(url,file,{headers:{"x-ms-blob-type":"BlockBlob","Content-Type":file.type||"application/octet-stream"}});case 10:// console.log('upload', res)
_this.setState({fileName:response.data.getPublicUploadURL.filename,bucketName:response.data.getPublicUploadURL.bucketName,publicUploadURL:response.data.getPublicUploadURL.publicUploadURL});case 11:_this.setState({isUploading:false});case 12:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref5.apply(this,arguments);};}(),_this.downloadBulkDelete=function(client){return function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(event){var _ref7,data,res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:console.log('click fun');_context3.next=3;return _this.props.client.query({query:GET_FILE_FORMAT,variables:{bucketname:'excel-templates',filename:'deviceDeleteTemplate.xlsx'},errorPolicy:'all'});case 3:_ref7=_context3.sent;data=_ref7.data;console.log('file',data.getPublicDownloadURL);_context3.next=8;return __WEBPACK_IMPORTED_MODULE_13_axios___default()({url:data.getPublicDownloadURL,method:'GET',headers:{Accept:'application/vnd.ms-excel'},responseType:'blob'// important
});case 8:res=_context3.sent;__WEBPACK_IMPORTED_MODULE_17_file_saver___default.a.saveAs(new Blob([res.data]),'deviceDeleteTemplate.xlsx');// FileSaver.saveAs(data.getPublicDownloadURL, 'sample.xlsx')
case 10:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x3){return _ref6.apply(this,arguments);};}();},_temp),_possibleConstructorReturn(_this,_ret);}// handleSubmit = addDevice => e => {
_createClass(DeleteBulkDevice,[{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["Query"],{query:GET_MODELS,fetchPolicy:'network-only'},function(_ref8){var isModelsLoading=_ref8.loading,error=_ref8.error,models=_ref8.data.models;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["Query"],{query:GET_MANUFACTURER,fetchPolicy:'network-only'},function(_ref9){var isManufacturersLoading=_ref9.loading,error=_ref9.error,manufacturers=_ref9.data.manufacturers;if(isModelsLoading||isManufacturersLoading)return null;if(error)return'Error!: '+error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{container:true,direction:'row',justify:'flex-start',alignItems:'center',spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Typography"],{variant:'title'},' ','Add Device Details For Bulk Delete')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},_this3.state.uploadSucess&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Typography"],{variant:'subheading',color:'primary'},_this3.state.response)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider___default.a,{light:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12,sm:'6'},' ','Download sample template for device delete in bulk'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12,sm:'6'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{color:'secondary',variant:'contained',className:classes.button,onClick:_this3.downloadBulkDelete(_this3.props.client)},'Download Excel'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{style:{minWidth:'40%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{accept:'*/*',id:'contained-button-file',multiple:true,type:'file',style:{display:'none'},onChange:_this3.onUpload}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'contained-button-file'},'Upload excel file here \xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{variant:'contained',component:'span',color:'primary'},_this3.state.isUploading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress___default.a,{size:15}):'Upload')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{color:'default',variant:'contained',onClick:function onClick(){return _this3.props.history.goBack();}},'Cancel'),'       ','       ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:_this3.handleSubmit(_this3.props.client),type:'submit',color:'primary',variant:'contained',disabled:!_this3.state.fileName||_this3.state.disable},'Submit'),' ',_this3.state.isLoading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'Excel sheet upload is in progress..')),_this3.state.result&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',null,'Failed records list'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_mui_datatables___default.a,{data:_this3.state.failList,columns:_this3.columns,options:_this3.options})))));});});}}]);return DeleteBulkDevice;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var WrappedDeleteBulkDevice=Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["withStyles"])(styles)(__WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter___default()(Object(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["withApollo"])(DeleteBulkDevice)));/* harmony default export */ __webpack_exports__["a"] = (function(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_router_dom__["e" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/DeviceInventory/DeviceBulkDelete',render:function render(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedDeleteBulkDevice,props);}}));});

/***/ }),
/* 2082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_file_saver__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_file_saver__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query {\n    allServiceProviders(status: 1) {\n      id\n      name\n    }\n  }\n'],['\n  query {\n    allServiceProviders(status: 1) {\n      id\n      name\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  mutation excelFileUpload(\n    $fileInfo: FileUploadInput!\n    $commonInput: CommonInput!\n  ) {\n    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {\n      failedToUpload\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedUploadList\n    }\n  }\n'],['\n  mutation excelFileUpload(\n    $fileInfo: FileUploadInput!\n    $commonInput: CommonInput!\n  ) {\n    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {\n      failedToUpload\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedUploadList\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n'],['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n'],['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable */var GET_PROVIDER=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject);// calling server for updation
var ADD_SIM=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject2);var GET_UPLOAD_URL=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject3);var GET_FILE_FORMAT=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject4);var styles=function styles(theme){return{button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{margin:theme.spacing.unit,minWidth:120},root:{flexGrow:1,padding:theme.spacing.unit*2}};};var RegisterBulkSim=function(_Component){_inherits(RegisterBulkSim,_Component);function RegisterBulkSim(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,RegisterBulkSim);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RegisterBulkSim.__proto__||Object.getPrototypeOf(RegisterBulkSim)).call.apply(_ref,[this].concat(args))),_this),_this.state={open:false,open1:false,simprovider:'',uploadSucess:true,isSimProviderValid:false,response:'',failList:'',result:false,fileName:'',isLoading:false,disable:false},_this.columns=['Phone Number','Reason'],_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15// sort: false,
// filter: false,
//  search: false,
// print: false,
// download: false
// viewColumns: false,
// pagination: false
},_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));};},_this.handleClickOpen=function(){_this.setState({open:true});},_this.handleClose=function(){_this.setState({open:false});},_this.handleChange=function(event){_this.setState(_defineProperty({},event.target.name,event.target.value));},_this.handleOpen=function(){_this.setState({open:true});},_this.handleOpenSelect=function(){_this.setState({open1:true});},_this.handleCloseSelect=function(){_this.setState({open1:false});},_this.checkSimProviderValidity=function(){_this.setState({isSimProviderValid:_this.state.simprovider!==''});},_this.handleSubmit=function(client){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _ref3,data,errors,fullData,arrList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:event.preventDefault();_this.setState({isLoading:true,disable:true});_context.next=4;return client.mutate({mutation:ADD_SIM,variables:{fileInfo:{uploadFor:'SimUploadByPartner',bucketName:_this.state.bucketName,fileName:_this.state.fileName,operationType:'SKIP'},commonInput:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_15__utils_getLoginId__["a" /* default */])(),serviceProviderId:parseInt(_this.state.simprovider,10)}},errorPolicy:'all'});case 4:_ref3=_context.sent;data=_ref3.data;errors=_ref3.errors;_this.setState({isLoading:false});if(data!==null){fullData=[];arrList=data.excelFileUpload.failedUploadList;// console.log('arrList', JSON.parse(arrList))
JSON.parse(arrList).forEach(function(element){var rowData=[];// this.clientId.push(element.id)
rowData.push(element.phoneNumber);rowData.push(element.error);// console.log(element.phoneNumber)
fullData.push(rowData);});_this.setState({simprovider:'',response:'Total Excel Records= '+data.excelFileUpload.totalExcelDataRecords+','+'Total Records Uploaded='+data.excelFileUpload.successfullyUploaded+', Total Records Failed To Upload='+data.excelFileUpload.failedToUpload+', Total Duplicate Records in Excel='+data.excelFileUpload.totalDuplicateRecords,uploadSucess:true,failList:fullData,result:true});}else{_this.setState({response:errors[0].message,uploadSucess:true});}// console.log('failList', this.state.failList)
case 9:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}();},_this.onUpload=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4){var _ref4$target=_ref4.target,validity=_ref4$target.validity,_ref4$target$files=_slicedToArray(_ref4$target.files,1),file=_ref4$target$files[0];var fileExtension,response,url;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:// TODO: Handle upload errors
_this.setState({isUploading:true});if(!validity.valid){_context2.next=11;break;}fileExtension=file.name.substring(file.name.lastIndexOf('.')+1);_context2.next=5;return _this.props.client.mutate({mutation:GET_UPLOAD_URL,variables:{fileExtension:fileExtension}});case 5:response=_context2.sent;if(!(response.data&&response.data.getPublicUploadURL)){_context2.next=11;break;}url=response.data.getPublicUploadURL.publicUploadURL;_context2.next=10;return __WEBPACK_IMPORTED_MODULE_13_axios___default.a.put(url,file,{headers:{"x-ms-blob-type":"BlockBlob","Content-Type":file.type||"application/octet-stream"}});case 10:_this.setState({fileName:response.data.getPublicUploadURL.filename,bucketName:response.data.getPublicUploadURL.bucketName,publicUploadURL:response.data.getPublicUploadURL.publicUploadURL});case 11:_this.setState({isUploading:false});case 12:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref5.apply(this,arguments);};}(),_this.downloadBulkUpload=function(client){return function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(event){var _ref7,data,res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return _this.props.client.query({query:GET_FILE_FORMAT,variables:{bucketname:'excel-templates',filename:'simUpload.xlsx'},errorPolicy:'all'});case 2:_ref7=_context3.sent;data=_ref7.data;_context3.next=6;return __WEBPACK_IMPORTED_MODULE_13_axios___default()({url:data.getPublicDownloadURL,method:'GET',headers:{Accept:'application/vnd.ms-excel'},responseType:'blob'// important
});case 6:res=_context3.sent;__WEBPACK_IMPORTED_MODULE_16_file_saver___default.a.saveAs(new Blob([res.data]),'sample.xlsx');// FileSaver.saveAs(data.getPublicDownloadURL, 'sample.xlsx')
case 8:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x3){return _ref6.apply(this,arguments);};}();},_this.setToDefaults=function(){_this.setState({open:false,open1:false,simprovider:'',uploadSucess:true,isSimProviderValid:false,response:'',failList:'',result:false,fileName:'',isLoading:false,disable:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RegisterBulkSim,[{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["Query"],{query:GET_PROVIDER,fetchPolicy:'network-only'},function(_ref8){var loading=_ref8.loading,error=_ref8.error,data=_ref8.data;var queriedData=data;if(loading)return'Loading...';if(error)return'Error!: '+error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{container:true,direction:'row',justify:'flex-start',alignItems:'center',spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Typography"],{variant:'headline'},'Select SIM Details')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{style:{minWidth:'40%'}},_this3.state.uploadSucess&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Typography"],{variant:'subheading',color:'primary'},_this3.state.response),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel___default.a,{htmlFor:'demo-controlled-open-select'},'Sim Provider'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select___default.a,{open:_this3.state.open1,fullWidth:true,onClose:_this3.handleCloseSelect,onOpen:_this3.handleOpenSelect,value:_this3.state.simprovider,onChange:_this3.handleChange,onBlur:_this3.checkSimProviderValidity,inputProps:{name:'simprovider',id:'simprovider'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),queriedData.allServiceProviders.map(function(allServiceProvidersByStatus){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem___default.a,{value:allServiceProvidersByStatus.id,key:allServiceProvidersByStatus.id},allServiceProvidersByStatus.name);}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{xs:12},'Download sample template for sim bulk upload'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:7},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{fullWidth:true,color:'secondary',variant:'contained',className:classes.button,onClick:_this3.downloadBulkUpload(_this3.props.client)},'Download Bulk Upload Excel')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{accept:'*/*',id:'contained-button-file',multiple:true,type:'file',style:{display:'none'},onChange:_this3.onUpload}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'contained-button-file'},'Upload excel file here \xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{variant:'contained',component:'span',color:'primary'},_this3.state.isUploading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress___default.a,{size:15}):'Upload')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:_this3.setToDefaults,color:'default',variant:'contained'// href={this.props.history.goBack()}
},'SET TO DEFAULTS'),'\xA0 \xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:function onClick(){return _this3.props.history.goBack();},color:'default',variant:'contained'// href={this.props.history.goBack()}
},'Cancel'),'\xA0 \xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:_this3.handleSubmit(_this3.props.client),color:'primary',type:'submit',variant:'contained',disabled:!(_this3.state.isSimProviderValid&&_this3.state.fileName!=='')||_this3.state.disable},'Submit'),' ',_this3.state.isLoading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'Excel sheet upload is in progress..'),_this3.state.result&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',null,'Failed records list'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_mui_datatables___default.a,{data:_this3.state.failList,columns:_this3.columns,options:_this3.options})))));});}}]);return RegisterBulkSim;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["withStyles"])(styles)(__WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter___default()(Object(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["withApollo"])(RegisterBulkSim))));

/***/ }),
/* 2083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_file_saver__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_router_dom__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Router__ = __webpack_require__(116);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query {\n    allServiceProviders(status: 1) {\n      id\n      name\n    }\n  }\n'],['\n  query {\n    allServiceProviders(status: 1) {\n      id\n      name\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  mutation excelFileUpload(\n    $fileInfo: FileUploadInput!\n    $commonInput: CommonInput!\n  ) {\n    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {\n      failedToUpload\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedUploadList\n    }\n  }\n'],['\n  mutation excelFileUpload(\n    $fileInfo: FileUploadInput!\n    $commonInput: CommonInput!\n  ) {\n    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {\n      failedToUpload\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedUploadList\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n'],['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n'],['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable */var GET_PROVIDER=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject);// calling server for updation
var ADD_SIM=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject2);var GET_UPLOAD_URL=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject3);var GET_FILE_FORMAT=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject4);var styles=function styles(theme){return{button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{margin:theme.spacing.unit,minWidth:120},root:{flexGrow:1,padding:theme.spacing.unit*2}};};var DeleteBulkSim=function(_Component){_inherits(DeleteBulkSim,_Component);function DeleteBulkSim(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,DeleteBulkSim);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DeleteBulkSim.__proto__||Object.getPrototypeOf(DeleteBulkSim)).call.apply(_ref,[this].concat(args))),_this),_this.state={open:false,open1:false,simprovider:'',uploadSucess:true,isSimProviderValid:false,response:'',failList:'',result:false,fileName:'',isLoading:false,disable:false},_this.columns=['Phone Number','Sim Number','Reason'],_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15// sort: false,
// filter: false,
//  search: false,
// print: false,
// download: false
// viewColumns: false,
// pagination: false
},_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));};},_this.handleClickOpen=function(){_this.setState({open:true});},_this.handleClose=function(){_this.setState({open:false});},_this.handleChange=function(event){_this.setState(_defineProperty({},event.target.name,event.target.value));},_this.handleOpen=function(){_this.setState({open:true});},_this.handleOpenSelect=function(){_this.setState({open1:true});},_this.handleCloseSelect=function(){_this.setState({open1:false});},_this.checkSimProviderValidity=function(){_this.setState({isSimProviderValid:_this.state.simprovider!==''});},_this.handleSubmit=function(client){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _ref3,data,errors,fullData,arrList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:event.preventDefault();_this.setState({isLoading:true,disable:true});_context.next=4;return client.mutate({mutation:ADD_SIM,variables:{fileInfo:{uploadFor:'DeleteSims',bucketName:_this.state.bucketName,fileName:_this.state.fileName,operationType:'SKIP'},commonInput:{clientLoginId:Object(__WEBPACK_IMPORTED_MODULE_15__utils_getLoginId__["a" /* default */])()// serviceProviderId: parseInt(this.state.simprovider, 10)
}},errorPolicy:'all'});case 4:_ref3=_context.sent;data=_ref3.data;errors=_ref3.errors;_this.setState({isLoading:false});if(data!==null){fullData=[];arrList=data.excelFileUpload.failedUploadList;// console.log('arrList', JSON.parse(arrList))
JSON.parse(arrList).forEach(function(element){var rowData=[];// this.clientId.push(element.id)
rowData.push(element.phoneNumber?element.phoneNumber:'Na');rowData.push(element.simNumber?element.simNumber:'Na');rowData.push(element.errorMsg?element.errorMsg:'Na');// console.log(element.phoneNumber)
fullData.push(rowData);});_this.setState({simprovider:'',response:'Total Excel Records= '+data.excelFileUpload.totalExcelDataRecords+','+'Total Records Uploaded='+data.excelFileUpload.successfullyUploaded+', Total Records Failed To Upload='+data.excelFileUpload.failedToUpload+', Total Duplicate Records in Excel='+data.excelFileUpload.totalDuplicateRecords,uploadSucess:true,failList:fullData,result:true});}else{_this.setState({response:errors[0].message,uploadSucess:true});}// console.log('failList', this.state.failList)
case 9:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}();},_this.onUpload=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4){var _ref4$target=_ref4.target,validity=_ref4$target.validity,_ref4$target$files=_slicedToArray(_ref4$target.files,1),file=_ref4$target$files[0];var fileExtension,response,url;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:// TODO: Handle upload errors
_this.setState({isUploading:true});if(!validity.valid){_context2.next=11;break;}fileExtension=file.name.substring(file.name.lastIndexOf('.')+1);_context2.next=5;return _this.props.client.mutate({mutation:GET_UPLOAD_URL,variables:{fileExtension:fileExtension}});case 5:response=_context2.sent;if(!(response.data&&response.data.getPublicUploadURL)){_context2.next=11;break;}url=response.data.getPublicUploadURL.publicUploadURL;_context2.next=10;return __WEBPACK_IMPORTED_MODULE_13_axios___default.a.put(url,file,{headers:{"x-ms-blob-type":"BlockBlob","Content-Type":file.type||"application/octet-stream"}});case 10:_this.setState({fileName:response.data.getPublicUploadURL.filename,bucketName:response.data.getPublicUploadURL.bucketName,publicUploadURL:response.data.getPublicUploadURL.publicUploadURL});case 11:_this.setState({isUploading:false});case 12:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref5.apply(this,arguments);};}(),_this.downloadBulkDeassign=function(client){return function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(event){var _ref7,data,res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:console.log('click fun');_context3.next=3;return _this.props.client.query({query:GET_FILE_FORMAT,variables:{bucketname:'excel-templates',filename:'simDeleteTemplate.xlsx'},errorPolicy:'all'});case 3:_ref7=_context3.sent;data=_ref7.data;console.log('file',data.getPublicDownloadURL);_context3.next=8;return __WEBPACK_IMPORTED_MODULE_13_axios___default()({url:data.getPublicDownloadURL,method:'GET',headers:{Accept:'application/vnd.ms-excel'},responseType:'blob'// important
});case 8:res=_context3.sent;__WEBPACK_IMPORTED_MODULE_16_file_saver___default.a.saveAs(new Blob([res.data]),'sample.xlsx');// FileSaver.saveAs(data.getPublicDownloadURL, 'sample.xlsx')
case 10:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x3){return _ref6.apply(this,arguments);};}();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DeleteBulkSim,[{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["Query"],{query:GET_PROVIDER,fetchPolicy:'network-only'},function(_ref8){var loading=_ref8.loading,error=_ref8.error,data=_ref8.data;var queriedData=data;if(loading)return'Loading...';if(error)return'Error!: '+error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{container:true,direction:'row',justify:'flex-start',alignItems:'center',spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Typography"],{variant:'headline'},'Select SIM Details For Bulk Delete')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{style:{minWidth:'40%'}},_this3.state.uploadSucess&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Typography"],{variant:'subheading',color:'primary'},_this3.state.response),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{xs:12},'Download sample template for sim bulk delete'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:7},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{fullWidth:true,color:'secondary',variant:'contained',className:classes.button,onClick:_this3.downloadBulkDeassign(_this3.props.client)},'Download Bulk Delete Excel')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{accept:'*/*',id:'contained-button-file',multiple:true,type:'file',style:{display:'none'},onChange:_this3.onUpload}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'contained-button-file'},'Upload excel file here \xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{variant:'contained',component:'span',color:'primary'},_this3.state.isUploading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress___default.a,{size:15}):'Upload')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:function onClick(){return _this3.props.history.goBack();},color:'default',variant:'contained'// href={this.props.history.goBack()}
},'Cancel'),'\xA0 \xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:_this3.handleSubmit(_this3.props.client),color:'primary',type:'submit',variant:'contained',disabled:!_this3.state.fileName||_this3.state.disable},'Submit'),' ',_this3.state.isLoading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'Excel sheet upload is in progress..'),_this3.state.result&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',null,'Failed records list'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_mui_datatables___default.a,{data:_this3.state.failList,columns:_this3.columns,options:_this3.options})))));});}}]);return DeleteBulkSim;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var WrappedDeleteBulkSim=Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["withStyles"])(styles)(__WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter___default()(Object(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["withApollo"])(DeleteBulkSim)));/* harmony default export */ __webpack_exports__["a"] = (function(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_router_dom__["e" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/inventory/sims/bulk-delete',render:function render(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedDeleteBulkSim,props);}}));});

/***/ }),
/* 2084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Card__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_CardContent__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_CardContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_CardContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_CardActions__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_CardActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_CardActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Reusable_Charts_PieChart__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Reusable_ItemCard__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_file_saver__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_axios__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_Dialog__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__SendCommands__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_getAccountType_js__ = __webpack_require__(68);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getVehicleCountByStatus($partnerLoginId: Int!) {\n    allvehicle: getVehicleCountByStatus(partnerLoginId: $partnerLoginId) {\n      totalRegisteredVehicle\n      totalActiveVehicle\n      totalInActiveVehicle\n      totalServicedVehicle\n      totalDeactiveVehicle\n      totalUatProcessVehicle\n    }\n  }\n'],['\n  query getVehicleCountByStatus($partnerLoginId: Int!) {\n    allvehicle: getVehicleCountByStatus(partnerLoginId: $partnerLoginId) {\n      totalRegisteredVehicle\n      totalActiveVehicle\n      totalInActiveVehicle\n      totalServicedVehicle\n      totalDeactiveVehicle\n      totalUatProcessVehicle\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n'],['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable */var GET_ALL_VEHICLE_STATUS=Object(__WEBPACK_IMPORTED_MODULE_7_graphql_tag__["a" /* default */])(_templateObject);var GET_FILE_FORMAT=Object(__WEBPACK_IMPORTED_MODULE_7_graphql_tag__["a" /* default */])(_templateObject2);var styles=function styles(theme){return{root:{flexGrow:1,padding:theme.spacing.unit*2},paper:{height:140,width:100},control:{padding:theme.spacing.unit*2}};};var vechicleType=['Active','De-active','Service','UAT','Not Registered','Inactive'];var VehcileDashboard=function(_Component){_inherits(VehcileDashboard,_Component);function VehcileDashboard(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,VehcileDashboard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=VehcileDashboard.__proto__||Object.getPrototypeOf(VehcileDashboard)).call.apply(_ref,[this].concat(args))),_this),_this.state={open:false},_this.viewPlan=function(e){_this.props.history.push({pathname:'/home/plans/view/'+e});},_this.addPlan=function(e){_this.props.history.push({pathname:'/home/Plans/addPlan'});},_this.mapToArr=function(vechicleType,allvehicle){// console.log('vechicleType', vechicleType, allvehicle)
var pieChartArr=[];var fullData=[];vechicleType.forEach(function(element){pieChartArr=[];pieChartArr['value']=Math.random();// To be removed random function
pieChartArr['label']=element;pieChartArr['id']=element;fullData.push(pieChartArr);});return fullData;},_this.showClientwise=function(vehType){return _asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:// console.log('vehType', vehType)
if(vehType==='unregistred'){_this.props.history.push({pathname:'/home/VehicleDashboard/ViewDevices/'+2});}else{// console.log('hi', vehType)
_this.props.history.push({pathname:'/home/VehicleDashboard/ViewVehicles'+vehType});}case 1:case'end':return _context.stop();}}},_callee,_this2);}));},_this.addVehicle=function(e){_this.props.history.push({pathname:'/home/VehicleRegistration'});},_this.bulkRegister=function(event){_this.props.history.push({pathname:'/home/customer/vehicle/register/bulk'});},_this.bulkVehicleDelete=function(event){_this.props.history.push({pathname:'/home/customer/vehicle/delete/bulk'});},_this.bulkVehicleDeactivate=function(event){_this.props.history.push({pathname:'/home/customer/vehicle/deactivate/bulk'});},_this.handleVehicleCommands=function(event){_this.props.history.push({pathname:'/home/vehicle/commands'});},_this.downloadBulkUpload=function(client){return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(event){var _ref4,data,res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this.props.client.query({query:GET_FILE_FORMAT,variables:{bucketname:'excel-templates',filename:'vehicleUpload.xlsx'},errorPolicy:'all'});case 2:_ref4=_context2.sent;data=_ref4.data;_context2.next=6;return __WEBPACK_IMPORTED_MODULE_15_axios___default()({url:data.getPublicDownloadURL,method:'GET',headers:{Accept:'application/vnd.ms-excel'},responseType:'blob'// important
});case 6:res=_context2.sent;__WEBPACK_IMPORTED_MODULE_14_file_saver___default.a.saveAs(new Blob([res.data]),'vehicleUpload.xlsx');// FileSaver.saveAs(data.getPublicDownloadURL, 'sample.xlsx')
case 8:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x){return _ref3.apply(this,arguments);};}();},_this.handleClickOpen=function(){_this.setState({open:true});},_this.handleClose=function(){_this.setState({open:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(VehcileDashboard,[{key:'componentDidMount',value:function componentDidMount(){console.log(Object(__WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__["a" /* default */])().toString(),Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_SERVER_HTTP_URI":"https://uat-api-dtwin.taabi.ai/graphql","REACT_APP_SERVER_WS_URI":"wss://uat-api-dtwin.taabi.ai"}).REACT_APP_ZELIOT_PARTNER_LOGIN_ID);}},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row-reverse',justify:'space-between',alignItems:'flex-end'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},Object(__WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__["a" /* default */])().toString()==Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_SERVER_HTTP_URI":"https://uat-api-dtwin.taabi.ai/graphql","REACT_APP_SERVER_WS_URI":"wss://uat-api-dtwin.taabi.ai"}).REACT_APP_ZELIOT_PARTNER_LOGIN_ID&&(['SER'].includes(Object(__WEBPACK_IMPORTED_MODULE_18__utils_getAccountType_js__["a" /* default */])())||['PA'].includes(Object(__WEBPACK_IMPORTED_MODULE_18__utils_getAccountType_js__["a" /* default */])()))?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{color:'secondary',onClick:this.handleVehicleCommands,variant:'contained',size:'medium',className:'btn'},'Vehicle Commands'),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{color:'secondary',onClick:this.addVehicle,variant:'contained',size:'medium',className:'btn'// className={this.classes.button}
},'Register Vehicle'),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{color:'secondary',variant:'contained',size:'medium',className:'btn',onClick:this.bulkRegister},'Bulk Registration'),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{color:'secondary',variant:'contained',size:'medium',margin:'normal',className:'btn',onClick:this.bulkVehicleDelete},'Bulk Vehicle Delete'),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{color:'secondary',variant:'contained',size:'medium',margin:'normal',className:'btn',onClick:this.bulkVehicleDeactivate},'Bulk Vehicle Deactivate'),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{color:'secondary',variant:'contained',size:'medium',className:'btn'// className={classes.button}
,onClick:this.downloadBulkUpload(this.props.client)},'Download Format')):Object(__WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__["a" /* default */])().toString()!=Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_SERVER_HTTP_URI":"https://uat-api-dtwin.taabi.ai/graphql","REACT_APP_SERVER_WS_URI":"wss://uat-api-dtwin.taabi.ai"}).REACT_APP_ZELIOT_PARTNER_LOGIN_ID?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{color:'secondary',onClick:this.handleVehicleCommands,variant:'contained',size:'medium',className:'btn'},'Vehicle Commands'),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{color:'secondary',onClick:this.addVehicle,variant:'raised'// className={this.classes.button}
},'Register Vehicle'),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{color:'secondary',variant:'contained',size:'medium',margin:'normal',className:'btn',onClick:this.bulkRegister},'Bulk Registration'),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{color:'secondary',variant:'contained',size:'medium',margin:'normal',className:'btn',onClick:this.bulkVehicleDelete},'Bulk Vehicle Delete'),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{color:'secondary',variant:'contained',size:'medium',margin:'normal',className:'btn',onClick:this.bulkVehicleDeactivate},'Bulk Vehicle Deactivate'),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{color:'secondary',variant:'contained',className:classes.button,onClick:this.downloadBulkUpload(this.props.client)},'Download Format')):null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'headline'},'Vehicle Dashboard')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_apollo__["Query"],{query:GET_ALL_VEHICLE_STATUS,variables:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__["a" /* default */])()}// fetchPolicy="network-only"
},function(_ref5){var loading=_ref5.loading,error=_ref5.error,allvehicle=_ref5.data.allvehicle;if(loading)return'Loading...';if(error)return'Error!: '+error;var rowData=allvehicle&&_this3.mapToArr(vechicleType,allvehicle);// console.log('rowdata', allvehicle)
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row',justify:'flex-start',alignItems:'flex-start',className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:8},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row',justify:'flex-start',alignItems:'flex-start'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Card___default.a,{className:classes.card},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{gutterBottom:true,variant:'headline',component:'h2'},'Active'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{component:'p'},allvehicle.totalActiveVehicle)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_CardActions___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{color:'primary',variant:'outlined',onClick:_this3.showClientwise(1)},'View Vehicles')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Card___default.a,{className:classes.card},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{gutterBottom:true,variant:'headline',component:'h2'},'Deactive'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{component:'p'},allvehicle.totalDeactiveVehicle)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_CardActions___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{color:'primary',variant:'outlined',onClick:_this3.showClientwise(0)},'View Vehicles')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Card___default.a,{className:classes.card},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{gutterBottom:true,variant:'headline',component:'h2'},'Inactive'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{component:'p'},allvehicle.totalInActiveVehicle)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_CardActions___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{color:'primary',variant:'outlined',onClick:_this3.showClientwise(2)},'View Vehicles')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Card___default.a,{className:classes.card},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{gutterBottom:true,variant:'headline',component:'h2'},'Service'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{component:'p'},allvehicle.totalServicedVehicle)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_CardActions___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{color:'primary',variant:'outlined',onClick:_this3.showClientwise(3)},'View Vehicles')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Card___default.a,{className:classes.card},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{gutterBottom:true,variant:'headline',component:'h2'},'UAT Status'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{component:'p'},allvehicle.totalUatProcessVehicle)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_CardActions___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{color:'primary',variant:'outlined',onClick:_this3.showClientwise(4)},'View Vehicles')))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Reusable_ItemCard__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'body2'},'Vehicle Chart!'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Reusable_Charts_PieChart__["a" /* default */],{data:rowData}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_Dialog___default.a,{open:_this3.state.open,onClose:_this3.handleClose,'aria-labelledby':'form-dialog-title'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__SendCommands__["a" /* default */],{handleClose:_this3.handleClose}))));})));}}]);return VehcileDashboard;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_8_react_apollo__["withApollo"])(VehcileDashboard)));

/***/ }),
/* 2085 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plot_series_abstract_series__ = __webpack_require__(48);
/* unused harmony reexport AbstractSeries */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plot_series_arc_series__ = __webpack_require__(356);
/* unused harmony reexport ArcSeries */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plot_series_area_series__ = __webpack_require__(2202);
/* unused harmony reexport AreaSeries */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plot_borders__ = __webpack_require__(2203);
/* unused harmony reexport Borders */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plot_chart_label__ = __webpack_require__(2204);
/* unused harmony reexport ChartLabel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plot_circular_grid_lines__ = __webpack_require__(2205);
/* unused harmony reexport CircularGridLines */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plot_series_contour_series__ = __webpack_require__(2206);
/* unused harmony reexport ContourSeries */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__plot_crosshair__ = __webpack_require__(2243);
/* unused harmony reexport Crosshair */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plot_series_custom_svg_series__ = __webpack_require__(2244);
/* unused harmony reexport CustomSVGSeries */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__plot_axis_decorative_axis__ = __webpack_require__(366);
/* unused harmony reexport DecorativeAxis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__plot_gradient_defs__ = __webpack_require__(2246);
/* unused harmony reexport GradientDefs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__plot_grid_lines__ = __webpack_require__(367);
/* unused harmony reexport GridLines */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__plot_series_heatmap_series__ = __webpack_require__(2247);
/* unused harmony reexport HeatmapSeries */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__plot_series_hexbin_series__ = __webpack_require__(2248);
/* unused harmony reexport HexbinSeries */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__plot_highlight__ = __webpack_require__(618);
/* unused harmony reexport Highlight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__plot_hint__ = __webpack_require__(2251);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_15__plot_hint__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__plot_series_horizontal_bar_series__ = __webpack_require__(2252);
/* unused harmony reexport HorizontalBarSeries */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__plot_series_horizontal_bar_series_canvas__ = __webpack_require__(2253);
/* unused harmony reexport HorizontalBarSeriesCanvas */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__plot_horizontal_grid_lines__ = __webpack_require__(2254);
/* unused harmony reexport HorizontalGridLines */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__plot_series_horizontal_rect_series__ = __webpack_require__(2255);
/* unused harmony reexport HorizontalRectSeries */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__plot_series_horizontal_rect_series_canvas__ = __webpack_require__(2256);
/* unused harmony reexport HorizontalRectSeriesCanvas */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__plot_series_label_series__ = __webpack_require__(134);
/* unused harmony reexport LabelSeries */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__plot_series_line_mark_series__ = __webpack_require__(621);
/* unused harmony reexport LineMarkSeries */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__plot_series_line_mark_series_canvas__ = __webpack_require__(2257);
/* unused harmony reexport LineMarkSeriesCanvas */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__plot_series_line_series__ = __webpack_require__(370);
/* unused harmony reexport LineSeries */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__plot_series_line_series_canvas__ = __webpack_require__(623);
/* unused harmony reexport LineSeriesCanvas */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__plot_series_mark_series__ = __webpack_require__(265);
/* unused harmony reexport MarkSeries */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__plot_series_mark_series_canvas__ = __webpack_require__(622);
/* unused harmony reexport MarkSeriesCanvas */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__plot_series_polygon_series__ = __webpack_require__(371);
/* unused harmony reexport PolygonSeries */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__plot_series_vertical_bar_series__ = __webpack_require__(2258);
/* unused harmony reexport VerticalBarSeries */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__plot_series_vertical_bar_series_canvas__ = __webpack_require__(2259);
/* unused harmony reexport VerticalBarSeriesCanvas */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__plot_vertical_grid_lines__ = __webpack_require__(2260);
/* unused harmony reexport VerticalGridLines */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__plot_series_vertical_rect_series__ = __webpack_require__(624);
/* unused harmony reexport VerticalRectSeries */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__plot_series_vertical_rect_series_canvas__ = __webpack_require__(2261);
/* unused harmony reexport VerticalRectSeriesCanvas */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__plot_voronoi__ = __webpack_require__(625);
/* unused harmony reexport Voronoi */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__plot_series_rect_series__ = __webpack_require__(368);
/* unused harmony reexport RectSeries */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__plot_series_rect_series_canvas__ = __webpack_require__(369);
/* unused harmony reexport RectSeriesCanvas */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__plot_series_whisker_series__ = __webpack_require__(2262);
/* unused harmony reexport WhiskerSeries */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__plot_xy_plot__ = __webpack_require__(114);
/* unused harmony reexport XYPlot */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__plot_axis_x_axis__ = __webpack_require__(2278);
/* unused harmony reexport XAxis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__plot_axis_y_axis__ = __webpack_require__(2282);
/* unused harmony reexport YAxis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__legends_continuous_color_legend__ = __webpack_require__(2283);
/* unused harmony reexport ContinuousColorLegend */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__legends_continuous_size_legend__ = __webpack_require__(2284);
/* unused harmony reexport ContinuousSizeLegend */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__legends_discrete_color_legend__ = __webpack_require__(635);
/* unused harmony reexport DiscreteColorLegend */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__legends_searchable_discrete_color_legend__ = __webpack_require__(2286);
/* unused harmony reexport SearchableDiscreteColorLegend */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__parallel_coordinates__ = __webpack_require__(2287);
/* unused harmony reexport ParallelCoordinates */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__radar_chart__ = __webpack_require__(2288);
/* unused harmony reexport RadarChart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__radial_chart__ = __webpack_require__(2289);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_47__radial_chart__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__sankey__ = __webpack_require__(2290);
/* unused harmony reexport Sankey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__sunburst__ = __webpack_require__(2296);
/* unused harmony reexport Sunburst */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__treemap__ = __webpack_require__(2318);
/* unused harmony reexport Treemap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__make_vis_flexible__ = __webpack_require__(2322);
/* unused harmony reexport makeHeightFlexible */
/* unused harmony reexport makeVisFlexible */
/* unused harmony reexport makeWidthFlexible */
/* unused harmony reexport FlexibleXYPlot */
/* unused harmony reexport FlexibleWidthXYPlot */
/* unused harmony reexport FlexibleHeightXYPlot */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__utils_axis_utils__ = __webpack_require__(82);
/* unused harmony reexport AxisUtils */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__utils_scales_utils__ = __webpack_require__(69);
/* unused harmony reexport ScaleUtils */
// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
















































































































/***/ }),
/* 2087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(2088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__point__ = __webpack_require__(2089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Diagram__ = __webpack_require__(191);




/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x = __WEBPACK_IMPORTED_MODULE_1__point__["a" /* x */],
      y = __WEBPACK_IMPORTED_MODULE_1__point__["b" /* y */],
      extent = null;

  function voronoi(data) {
    return new __WEBPACK_IMPORTED_MODULE_2__Diagram__["d" /* default */](data.map(function(d, i) {
      var s = [Math.round(x(d, i, data) / __WEBPACK_IMPORTED_MODULE_2__Diagram__["f" /* epsilon */]) * __WEBPACK_IMPORTED_MODULE_2__Diagram__["f" /* epsilon */], Math.round(y(d, i, data) / __WEBPACK_IMPORTED_MODULE_2__Diagram__["f" /* epsilon */]) * __WEBPACK_IMPORTED_MODULE_2__Diagram__["f" /* epsilon */]];
      s.index = i;
      s.data = d;
      return s;
    }), extent);
  }

  voronoi.polygons = function(data) {
    return voronoi(data).polygons();
  };

  voronoi.links = function(data) {
    return voronoi(data).links();
  };

  voronoi.triangles = function(data) {
    return voronoi(data).triangles();
  };

  voronoi.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), voronoi) : x;
  };

  voronoi.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), voronoi) : y;
  };

  voronoi.extent = function(_) {
    return arguments.length ? (extent = _ == null ? null : [[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]], voronoi) : extent && [[extent[0][0], extent[0][1]], [extent[1][0], extent[1][1]]];
  };

  voronoi.size = function(_) {
    return arguments.length ? (extent = _ == null ? null : [[0, 0], [+_[0], +_[1]]], voronoi) : extent && [extent[1][0] - extent[0][0], extent[1][1] - extent[0][1]];
  };

  return voronoi;
});


/***/ }),
/* 2088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 2089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = x;
/* harmony export (immutable) */ __webpack_exports__["b"] = y;
function x(d) {
  return d[0];
}

function y(d) {
  return d[1];
}


/***/ }),
/* 2090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = removeBeach;
/* harmony export (immutable) */ __webpack_exports__["a"] = addBeach;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RedBlackTree__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Cell__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Circle__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Edge__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Diagram__ = __webpack_require__(191);






var beachPool = [];

function Beach() {
  Object(__WEBPACK_IMPORTED_MODULE_0__RedBlackTree__["a" /* RedBlackNode */])(this);
  this.edge =
  this.site =
  this.circle = null;
}

function createBeach(site) {
  var beach = beachPool.pop() || new Beach;
  beach.site = site;
  return beach;
}

function detachBeach(beach) {
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(beach);
  __WEBPACK_IMPORTED_MODULE_4__Diagram__["a" /* beaches */].remove(beach);
  beachPool.push(beach);
  Object(__WEBPACK_IMPORTED_MODULE_0__RedBlackTree__["a" /* RedBlackNode */])(beach);
}

function removeBeach(beach) {
  var circle = beach.circle,
      x = circle.x,
      y = circle.cy,
      vertex = [x, y],
      previous = beach.P,
      next = beach.N,
      disappearing = [beach];

  detachBeach(beach);

  var lArc = previous;
  while (lArc.circle
      && Math.abs(x - lArc.circle.x) < __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]
      && Math.abs(y - lArc.circle.cy) < __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]) {
    previous = lArc.P;
    disappearing.unshift(lArc);
    detachBeach(lArc);
    lArc = previous;
  }

  disappearing.unshift(lArc);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(lArc);

  var rArc = next;
  while (rArc.circle
      && Math.abs(x - rArc.circle.x) < __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]
      && Math.abs(y - rArc.circle.cy) < __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]) {
    next = rArc.N;
    disappearing.push(rArc);
    detachBeach(rArc);
    rArc = next;
  }

  disappearing.push(rArc);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(rArc);

  var nArcs = disappearing.length,
      iArc;
  for (iArc = 1; iArc < nArcs; ++iArc) {
    rArc = disappearing[iArc];
    lArc = disappearing[iArc - 1];
    Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["d" /* setEdgeEnd */])(rArc.edge, lArc.site, rArc.site, vertex);
  }

  lArc = disappearing[0];
  rArc = disappearing[nArcs - 1];
  rArc.edge = Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["c" /* createEdge */])(lArc.site, rArc.site, null, vertex);

  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* attachCircle */])(lArc);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* attachCircle */])(rArc);
}

function addBeach(site) {
  var x = site[0],
      directrix = site[1],
      lArc,
      rArc,
      dxl,
      dxr,
      node = __WEBPACK_IMPORTED_MODULE_4__Diagram__["a" /* beaches */]._;

  while (node) {
    dxl = leftBreakPoint(node, directrix) - x;
    if (dxl > __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]) node = node.L; else {
      dxr = x - rightBreakPoint(node, directrix);
      if (dxr > __WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]) {
        if (!node.R) {
          lArc = node;
          break;
        }
        node = node.R;
      } else {
        if (dxl > -__WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]) {
          lArc = node.P;
          rArc = node;
        } else if (dxr > -__WEBPACK_IMPORTED_MODULE_4__Diagram__["f" /* epsilon */]) {
          lArc = node;
          rArc = node.N;
        } else {
          lArc = rArc = node;
        }
        break;
      }
    }
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__Cell__["c" /* createCell */])(site);
  var newArc = createBeach(site);
  __WEBPACK_IMPORTED_MODULE_4__Diagram__["a" /* beaches */].insert(lArc, newArc);

  if (!lArc && !rArc) return;

  if (lArc === rArc) {
    Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(lArc);
    rArc = createBeach(lArc.site);
    __WEBPACK_IMPORTED_MODULE_4__Diagram__["a" /* beaches */].insert(newArc, rArc);
    newArc.edge = rArc.edge = Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["c" /* createEdge */])(lArc.site, newArc.site);
    Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* attachCircle */])(lArc);
    Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* attachCircle */])(rArc);
    return;
  }

  if (!rArc) { // && lArc
    newArc.edge = Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["c" /* createEdge */])(lArc.site, newArc.site);
    return;
  }

  // else lArc !== rArc
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(lArc);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["b" /* detachCircle */])(rArc);

  var lSite = lArc.site,
      ax = lSite[0],
      ay = lSite[1],
      bx = site[0] - ax,
      by = site[1] - ay,
      rSite = rArc.site,
      cx = rSite[0] - ax,
      cy = rSite[1] - ay,
      d = 2 * (bx * cy - by * cx),
      hb = bx * bx + by * by,
      hc = cx * cx + cy * cy,
      vertex = [(cy * hb - by * hc) / d + ax, (bx * hc - cx * hb) / d + ay];

  Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["d" /* setEdgeEnd */])(rArc.edge, lSite, rSite, vertex);
  newArc.edge = Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["c" /* createEdge */])(lSite, site, null, vertex);
  rArc.edge = Object(__WEBPACK_IMPORTED_MODULE_3__Edge__["c" /* createEdge */])(site, rSite, null, vertex);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* attachCircle */])(lArc);
  Object(__WEBPACK_IMPORTED_MODULE_2__Circle__["a" /* attachCircle */])(rArc);
}

function leftBreakPoint(arc, directrix) {
  var site = arc.site,
      rfocx = site[0],
      rfocy = site[1],
      pby2 = rfocy - directrix;

  if (!pby2) return rfocx;

  var lArc = arc.P;
  if (!lArc) return -Infinity;

  site = lArc.site;
  var lfocx = site[0],
      lfocy = site[1],
      plby2 = lfocy - directrix;

  if (!plby2) return lfocx;

  var hl = lfocx - rfocx,
      aby2 = 1 / pby2 - 1 / plby2,
      b = hl / plby2;

  if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;

  return (rfocx + lfocx) / 2;
}

function rightBreakPoint(arc, directrix) {
  var rArc = arc.N;
  if (rArc) return leftBreakPoint(rArc, directrix);
  var site = arc.site;
  return site[1] === directrix ? site[0] : Infinity;
}


/***/ }),
/* 2091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gray */
/* harmony export (immutable) */ __webpack_exports__["a"] = lab;
/* unused harmony export Lab */
/* unused harmony export lch */
/* harmony export (immutable) */ __webpack_exports__["b"] = hcl;
/* unused harmony export Hcl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define_js__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color_js__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math_js__ = __webpack_require__(554);




// https://observablehq.com/@mbostock/lab-and-rgb
var K = 18,
    Xn = 0.96422,
    Yn = 1,
    Zn = 0.82521,
    t0 = 4 / 29,
    t1 = 6 / 29,
    t2 = 3 * t1 * t1,
    t3 = t1 * t1 * t1;

function labConvert(o) {
  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl) return hcl2lab(o);
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color_js__["b" /* Rgb */])) o = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["h" /* rgbConvert */])(o);
  var r = rgb2lrgb(o.r),
      g = rgb2lrgb(o.g),
      b = rgb2lrgb(o.b),
      y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
  if (r === g && g === b) x = z = y; else {
    x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
    z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
  }
  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}

function gray(l, opacity) {
  return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
}

function lab(l, a, b, opacity) {
  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}

function Lab(l, a, b, opacity) {
  this.l = +l;
  this.a = +a;
  this.b = +b;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define_js__["a" /* default */])(Lab, lab, Object(__WEBPACK_IMPORTED_MODULE_0__define_js__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* Color */], {
  brighter: function(k) {
    return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  darker: function(k) {
    return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  rgb: function() {
    var y = (this.l + 16) / 116,
        x = isNaN(this.a) ? y : y + this.a / 500,
        z = isNaN(this.b) ? y : y - this.b / 200;
    x = Xn * lab2xyz(x);
    y = Yn * lab2xyz(y);
    z = Zn * lab2xyz(z);
    return new __WEBPACK_IMPORTED_MODULE_1__color_js__["b" /* Rgb */](
      lrgb2rgb( 3.1338561 * x - 1.6168667 * y - 0.4906146 * z),
      lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z),
      lrgb2rgb( 0.0719453 * x - 0.2289914 * y + 1.4052427 * z),
      this.opacity
    );
  }
}));

function xyz2lab(t) {
  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}

function lab2xyz(t) {
  return t > t1 ? t * t * t : t2 * (t - t0);
}

function lrgb2rgb(x) {
  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}

function rgb2lrgb(x) {
  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}

function hclConvert(o) {
  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab)) o = labConvert(o);
  if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
  var h = Math.atan2(o.b, o.a) * __WEBPACK_IMPORTED_MODULE_2__math_js__["b" /* rad2deg */];
  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}

function lch(l, c, h, opacity) {
  return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function hcl(h, c, l, opacity) {
  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function Hcl(h, c, l, opacity) {
  this.h = +h;
  this.c = +c;
  this.l = +l;
  this.opacity = +opacity;
}

function hcl2lab(o) {
  if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
  var h = o.h * __WEBPACK_IMPORTED_MODULE_2__math_js__["a" /* deg2rad */];
  return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}

Object(__WEBPACK_IMPORTED_MODULE_0__define_js__["a" /* default */])(Hcl, hcl, Object(__WEBPACK_IMPORTED_MODULE_0__define_js__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* Color */], {
  brighter: function(k) {
    return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
  },
  darker: function(k) {
    return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
  },
  rgb: function() {
    return hcl2lab(this).rgb();
  }
}));


/***/ }),
/* 2092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cubehelix;
/* unused harmony export Cubehelix */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define_js__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color_js__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math_js__ = __webpack_require__(554);




var A = -0.14861,
    B = +1.78277,
    C = -0.29227,
    D = -0.90649,
    E = +1.97294,
    ED = E * D,
    EB = E * B,
    BC_DA = B * C - D * A;

function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color_js__["b" /* Rgb */])) o = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["h" /* rgbConvert */])(o);
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
      bl = b - l,
      k = (E * (g - l) - C * bl) / D,
      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
      h = s ? Math.atan2(k, bl) * __WEBPACK_IMPORTED_MODULE_2__math_js__["b" /* rad2deg */] - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}

function cubehelix(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}

function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define_js__["a" /* default */])(Cubehelix, cubehelix, Object(__WEBPACK_IMPORTED_MODULE_0__define_js__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* Color */], {
  brighter: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color_js__["c" /* brighter */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color_js__["c" /* brighter */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color_js__["d" /* darker */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color_js__["d" /* darker */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * __WEBPACK_IMPORTED_MODULE_2__math_js__["a" /* deg2rad */],
        l = +this.l,
        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
        cosh = Math.cos(h),
        sinh = Math.sin(h);
    return new __WEBPACK_IMPORTED_MODULE_1__color_js__["b" /* Rgb */](
      255 * (l + a * (A * cosh + B * sinh)),
      255 * (l + a * (C * cosh + D * sinh)),
      255 * (l + a * (E * cosh)),
      this.opacity
    );
  }
}));


/***/ }),
/* 2093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(range) {
  var n = range.length;
  return function(t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
});


/***/ }),
/* 2094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color_js__ = __webpack_require__(161);


/* unused harmony default export */ var _unused_webpack_default_export = (function(a, b) {
  var i = Object(__WEBPACK_IMPORTED_MODULE_0__color_js__["c" /* hue */])(+a, +b);
  return function(t) {
    var x = i(t);
    return x - 360 * Math.floor(x / 360);
  };
});


/***/ }),
/* 2095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b = +b, function(t) {
    return Math.round(a * (1 - t) + b * t);
  };
});


/***/ }),
/* 2096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export interpolateTransformCss */
/* unused harmony export interpolateTransformSvg */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number_js__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse_js__ = __webpack_require__(2097);



function interpolateTransform(parse, pxComma, pxParen, degParen) {

  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }

  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({i: i - 4, x: Object(__WEBPACK_IMPORTED_MODULE_0__number_js__["a" /* default */])(xa, xb)}, {i: i - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number_js__["a" /* default */])(ya, yb)});
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }

  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number_js__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }

  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number_js__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }

  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({i: i - 4, x: Object(__WEBPACK_IMPORTED_MODULE_0__number_js__["a" /* default */])(xa, xb)}, {i: i - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number_js__["a" /* default */])(ya, yb)});
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }

  return function(a, b) {
    var s = [], // string constants and placeholders
        q = []; // number interpolators
    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null; // gc
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  };
}

var interpolateTransformCss = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse_js__["a" /* parseCss */], "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse_js__["b" /* parseSvg */], ", ", ")", ")");


/***/ }),
/* 2097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseCss;
/* harmony export (immutable) */ __webpack_exports__["b"] = parseSvg;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__decompose_js__ = __webpack_require__(2098);


var cssNode,
    cssRoot,
    cssView,
    svgNode;

function parseCss(value) {
  if (value === "none") return __WEBPACK_IMPORTED_MODULE_0__decompose_js__["b" /* identity */];
  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
  cssNode.style.transform = value;
  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
  cssRoot.removeChild(cssNode);
  value = value.slice(7, -1).split(",");
  return Object(__WEBPACK_IMPORTED_MODULE_0__decompose_js__["a" /* default */])(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}

function parseSvg(value) {
  if (value == null) return __WEBPACK_IMPORTED_MODULE_0__decompose_js__["b" /* identity */];
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return __WEBPACK_IMPORTED_MODULE_0__decompose_js__["b" /* identity */];
  value = value.matrix;
  return Object(__WEBPACK_IMPORTED_MODULE_0__decompose_js__["a" /* default */])(value.a, value.b, value.c, value.d, value.e, value.f);
}


/***/ }),
/* 2098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return identity; });
var degrees = 180 / Math.PI;

var identity = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};

/* harmony default export */ __webpack_exports__["a"] = (function(a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees,
    skewX: Math.atan(skewX) * degrees,
    scaleX: scaleX,
    scaleY: scaleY
  };
});


/***/ }),
/* 2099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var rho = Math.SQRT2,
    rho2 = 2,
    rho4 = 4,
    epsilon2 = 1e-12;

function cosh(x) {
  return ((x = Math.exp(x)) + 1 / x) / 2;
}

function sinh(x) {
  return ((x = Math.exp(x)) - 1 / x) / 2;
}

function tanh(x) {
  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}

// p0 = [ux0, uy0, w0]
// p1 = [ux1, uy1, w1]
/* unused harmony default export */ var _unused_webpack_default_export = (function(p0, p1) {
  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
      dx = ux1 - ux0,
      dy = uy1 - uy0,
      d2 = dx * dx + dy * dy,
      i,
      S;

  // Special case for u0 ≅ u1.
  if (d2 < epsilon2) {
    S = Math.log(w1 / w0) / rho;
    i = function(t) {
      return [
        ux0 + t * dx,
        uy0 + t * dy,
        w0 * Math.exp(rho * t * S)
      ];
    }
  }

  // General case.
  else {
    var d1 = Math.sqrt(d2),
        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
    S = (r1 - r0) / rho;
    i = function(t) {
      var s = t * S,
          coshr0 = cosh(r0),
          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
      return [
        ux0 + u * dx,
        uy0 + u * dy,
        w0 * coshr0 / cosh(rho * s + r0)
      ];
    }
  }

  i.duration = S * 1000;

  return i;
});


/***/ }),
/* 2100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hslLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color_js__ = __webpack_require__(161);



function hsl(hue) {
  return function(start, end) {
    var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d" /* hsl */])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d" /* hsl */])(end)).h),
        s = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.s, end.s),
        l = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.l, end.l),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.s = s(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (hsl(__WEBPACK_IMPORTED_MODULE_1__color_js__["c" /* hue */]));
var hslLong = hsl(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */]);


/***/ }),
/* 2101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color_js__ = __webpack_require__(161);



function lab(start, end) {
  var l = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* lab */])(start)).l, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* lab */])(end)).l),
      a = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.a, end.a),
      b = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.b, end.b),
      opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.opacity, end.opacity);
  return function(t) {
    start.l = l(t);
    start.a = a(t);
    start.b = b(t);
    start.opacity = opacity(t);
    return start + "";
  };
}


/***/ }),
/* 2102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hclLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color_js__ = __webpack_require__(161);



function hcl(hue) {
  return function(start, end) {
    var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["c" /* hcl */])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["c" /* hcl */])(end)).h),
        c = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.c, end.c),
        l = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.l, end.l),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.c = c(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (hcl(__WEBPACK_IMPORTED_MODULE_1__color_js__["c" /* hue */]));
var hclLong = hcl(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */]);


/***/ }),
/* 2103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cubehelixLong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color_js__ = __webpack_require__(161);



function cubehelix(hue) {
  return (function cubehelixGamma(y) {
    y = +y;

    function cubehelix(start, end) {
      var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(end)).h),
          s = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.s, end.s),
          l = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.l, end.l),
          opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.opacity, end.opacity);
      return function(t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(Math.pow(t, y));
        start.opacity = opacity(t);
        return start + "";
      };
    }

    cubehelix.gamma = cubehelixGamma;

    return cubehelix;
  })(1);
}

/* unused harmony default export */ var _unused_webpack_default_export = (cubehelix(__WEBPACK_IMPORTED_MODULE_1__color_js__["c" /* hue */]));
var cubehelixLong = cubehelix(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */]);


/***/ }),
/* 2104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
function piecewise(interpolate, values) {
  var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
  while (i < n) I[i] = interpolate(v, v = values[++i]);
  return function(t) {
    var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
    return I[i](t - i);
  };
}


/***/ }),
/* 2105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(interpolator, n) {
  var samples = new Array(n);
  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
  return samples;
});


/***/ }),
/* 2106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }

var _Motion = __webpack_require__(2107);

exports.Motion = _interopRequire(_Motion);

var _StaggeredMotion = __webpack_require__(2109);

exports.StaggeredMotion = _interopRequire(_StaggeredMotion);

var _TransitionMotion = __webpack_require__(2110);

exports.TransitionMotion = _interopRequire(_TransitionMotion);

var _spring = __webpack_require__(2112);

exports.spring = _interopRequire(_spring);

var _presets = __webpack_require__(562);

exports.presets = _interopRequire(_presets);

var _stripStyle = __webpack_require__(254);

exports.stripStyle = _interopRequire(_stripStyle);

// deprecated, dummy warning function

var _reorderKeys = __webpack_require__(2113);

exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ }),
/* 2107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__(344);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(254);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(345);

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__(346);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(347);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(348);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

var Motion = (function (_React$Component) {
  _inherits(Motion, _React$Component);

  _createClass(Motion, null, [{
    key: 'propTypes',
    value: {
      // TOOD: warn against putting a config in here
      defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
      children: _propTypes2['default'].func.isRequired,
      onRest: _propTypes2['default'].func
    },
    enumerable: true
  }]);

  function Motion(props) {
    var _this = this;

    _classCallCheck(this, Motion);

    _React$Component.call(this, props);
    this.wasAnimating = false;
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyle = null;

    this.clearUnreadPropStyle = function (destStyle) {
      var dirty = false;
      var _state = _this.state;
      var currentStyle = _state.currentStyle;
      var currentVelocity = _state.currentVelocity;
      var lastIdealStyle = _state.lastIdealStyle;
      var lastIdealVelocity = _state.lastIdealVelocity;

      for (var key in destStyle) {
        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
          continue;
        }

        var styleValue = destStyle[key];
        if (typeof styleValue === 'number') {
          if (!dirty) {
            dirty = true;
            currentStyle = _extends({}, currentStyle);
            currentVelocity = _extends({}, currentVelocity);
            lastIdealStyle = _extends({}, lastIdealStyle);
            lastIdealVelocity = _extends({}, lastIdealVelocity);
          }

          currentStyle[key] = styleValue;
          currentVelocity[key] = 0;
          lastIdealStyle[key] = styleValue;
          lastIdealVelocity[key] = 0;
        }
      }

      if (dirty) {
        _this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
      }
    };

    this.startAnimationIfNecessary = function () {
      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        // check if we need to animate in the first place
        var propsStyle = _this.props.style;
        if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
          if (_this.wasAnimating && _this.props.onRest) {
            _this.props.onRest();
          }

          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.wasAnimating = false;
          _this.accumulatedTime = 0;
          return;
        }

        _this.wasAnimating = true;

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var newLastIdealStyle = {};
        var newLastIdealVelocity = {};
        var newCurrentStyle = {};
        var newCurrentVelocity = {};

        for (var key in propsStyle) {
          if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
            continue;
          }

          var styleValue = propsStyle[key];
          if (typeof styleValue === 'number') {
            newCurrentStyle[key] = styleValue;
            newCurrentVelocity[key] = 0;
            newLastIdealStyle[key] = styleValue;
            newLastIdealVelocity[key] = 0;
          } else {
            var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
            var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
            for (var i = 0; i < framesToCatchUp; i++) {
              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              newLastIdealStyleValue = _stepper[0];
              newLastIdealVelocityValue = _stepper[1];
            }

            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

            var nextIdealX = _stepper2[0];
            var nextIdealV = _stepper2[1];

            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
            newLastIdealStyle[key] = newLastIdealStyleValue;
            newLastIdealVelocity[key] = newLastIdealVelocityValue;
          }
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyle: newCurrentStyle,
          currentVelocity: newCurrentVelocity,
          lastIdealStyle: newLastIdealStyle,
          lastIdealVelocity: newLastIdealVelocity
        });

        _this.unreadPropStyle = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  Motion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyle = _props.defaultStyle;
    var style = _props.style;

    var currentStyle = defaultStyle || _stripStyle2['default'](style);
    var currentVelocity = _mapToZero2['default'](currentStyle);
    return {
      currentStyle: currentStyle,
      currentVelocity: currentVelocity,
      lastIdealStyle: currentStyle,
      lastIdealVelocity: currentVelocity
    };
  };

  // it's possible that currentStyle's value is stale: if props is immediately
  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
  // at 0 (didn't have time to tick and interpolate even once). If we naively
  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
  // In reality currentStyle should be 400

  Motion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyle != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyle);
    }

    this.unreadPropStyle = props.style;
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  Motion.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  Motion.prototype.render = function render() {
    var renderedChildren = this.props.children(this.state.currentStyle);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return Motion;
})(_react2['default'].Component);

exports['default'] = Motion;
module.exports = exports['default'];

// after checking for unreadPropStyle != null, we manually go set the
// non-interpolating values (those that are a number, without a spring
// config)

/***/ }),
/* 2108 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(137)))

/***/ }),
/* 2109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__(344);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(254);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(345);

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__(346);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(347);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(348);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
  for (var i = 0; i < currentStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
      return false;
    }
  }
  return true;
}

var StaggeredMotion = (function (_React$Component) {
  _inherits(StaggeredMotion, _React$Component);

  _createClass(StaggeredMotion, null, [{
    key: 'propTypes',
    value: {
      // TOOD: warn against putting a config in here
      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
      styles: _propTypes2['default'].func.isRequired,
      children: _propTypes2['default'].func.isRequired
    },
    enumerable: true
  }]);

  function StaggeredMotion(props) {
    var _this = this;

    _classCallCheck(this, StaggeredMotion);

    _React$Component.call(this, props);
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyles = null;

    this.clearUnreadPropStyle = function (unreadPropStyles) {
      var _state = _this.state;
      var currentStyles = _state.currentStyles;
      var currentVelocities = _state.currentVelocities;
      var lastIdealStyles = _state.lastIdealStyles;
      var lastIdealVelocities = _state.lastIdealVelocities;

      var someDirty = false;
      for (var i = 0; i < unreadPropStyles.length; i++) {
        var unreadPropStyle = unreadPropStyles[i];
        var dirty = false;

        for (var key in unreadPropStyle) {
          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
            continue;
          }

          var styleValue = unreadPropStyle[key];
          if (typeof styleValue === 'number') {
            if (!dirty) {
              dirty = true;
              someDirty = true;
              currentStyles[i] = _extends({}, currentStyles[i]);
              currentVelocities[i] = _extends({}, currentVelocities[i]);
              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
            }
            currentStyles[i][key] = styleValue;
            currentVelocities[i][key] = 0;
            lastIdealStyles[i][key] = styleValue;
            lastIdealVelocities[i][key] = 0;
          }
        }
      }

      if (someDirty) {
        _this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
      }
    };

    this.startAnimationIfNecessary = function () {
      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        var destStyles = _this.props.styles(_this.state.lastIdealStyles);

        // check if we need to animate in the first place
        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.accumulatedTime = 0;
          return;
        }

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var newLastIdealStyles = [];
        var newLastIdealVelocities = [];
        var newCurrentStyles = [];
        var newCurrentVelocities = [];

        for (var i = 0; i < destStyles.length; i++) {
          var destStyle = destStyles[i];
          var newCurrentStyle = {};
          var newCurrentVelocity = {};
          var newLastIdealStyle = {};
          var newLastIdealVelocity = {};

          for (var key in destStyle) {
            if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
              continue;
            }

            var styleValue = destStyle[key];
            if (typeof styleValue === 'number') {
              newCurrentStyle[key] = styleValue;
              newCurrentVelocity[key] = 0;
              newLastIdealStyle[key] = styleValue;
              newLastIdealVelocity[key] = 0;
            } else {
              var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
              var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
              for (var j = 0; j < framesToCatchUp; j++) {
                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

                newLastIdealStyleValue = _stepper[0];
                newLastIdealVelocityValue = _stepper[1];
              }

              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              var nextIdealX = _stepper2[0];
              var nextIdealV = _stepper2[1];

              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
              newLastIdealStyle[key] = newLastIdealStyleValue;
              newLastIdealVelocity[key] = newLastIdealVelocityValue;
            }
          }

          newCurrentStyles[i] = newCurrentStyle;
          newCurrentVelocities[i] = newCurrentVelocity;
          newLastIdealStyles[i] = newLastIdealStyle;
          newLastIdealVelocities[i] = newLastIdealVelocity;
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyles: newCurrentStyles,
          currentVelocities: newCurrentVelocities,
          lastIdealStyles: newLastIdealStyles,
          lastIdealVelocities: newLastIdealVelocities
        });

        _this.unreadPropStyles = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  StaggeredMotion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;

    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
    var currentVelocities = currentStyles.map(function (currentStyle) {
      return _mapToZero2['default'](currentStyle);
    });
    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: currentStyles,
      lastIdealVelocities: currentVelocities
    };
  };

  StaggeredMotion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  StaggeredMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyles != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  StaggeredMotion.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  StaggeredMotion.prototype.render = function render() {
    var renderedChildren = this.props.children(this.state.currentStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return StaggeredMotion;
})(_react2['default'].Component);

exports['default'] = StaggeredMotion;
module.exports = exports['default'];

// it's possible that currentStyle's value is stale: if props is immediately
// changed from 0 to 400 to spring(0) again, the async currentStyle is still
// at 0 (didn't have time to tick and interpolate even once). If we naively
// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
// In reality currentStyle should be 400

// after checking for unreadPropStyles != null, we manually go set the
// non-interpolating values (those that are a number, without a spring
// config)

/***/ }),
/* 2110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__(344);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(254);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(345);

var _stepper4 = _interopRequireDefault(_stepper3);

var _mergeDiff = __webpack_require__(2111);

var _mergeDiff2 = _interopRequireDefault(_mergeDiff);

var _performanceNow = __webpack_require__(346);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(347);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(348);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

// the children function & (potential) styles function asks as param an
// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
// {key: string, data?: any, style: PlainStyle}. However, the way we keep
// internal states doesn't contain such a data structure (check the state and
// TransitionMotionState). So when children function and others ask for such
// data we need to generate them on the fly by combining mergedPropsStyles and
// currentStyles/lastIdealStyles
function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
  // Copy the value to a `const` so that Flow understands that the const won't
  // change and will be non-nullable in the callback below.
  var cUnreadPropStyles = unreadPropStyles;
  if (cUnreadPropStyles == null) {
    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
      return {
        key: mergedPropsStyle.key,
        data: mergedPropsStyle.data,
        style: plainStyles[i]
      };
    });
  }
  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
    for (var j = 0; j < cUnreadPropStyles.length; j++) {
      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
        return {
          key: cUnreadPropStyles[j].key,
          data: cUnreadPropStyles[j].data,
          style: plainStyles[i]
        };
      }
    }
    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
  });
}

function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
  if (mergedPropsStyles.length !== destStyles.length) {
    return false;
  }

  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (mergedPropsStyles[i].key !== destStyles[i].key) {
      return false;
    }
  }

  // we have the invariant that mergedPropsStyles and
  // currentStyles/currentVelocities/last* are synced in terms of cells, see
  // mergeAndSync comment for more info
  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
      return false;
    }
  }

  return true;
}

// core key merging logic

// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
// c}, previous current (interpolating) style is {a, b}
// **invariant**: current[i] corresponds to merged[i] in terms of key

// steps:
// turn merged style into {a?, b, c}
//    add c, value of c is destStyles.c
//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
// turn current (interpolating) style from {a, b} into {a?, b, c}
//    maybe remove a
//    certainly add c, value of c is willEnter(c)
// loop over merged and construct new current
// dest doesn't change, that's owner's
function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
    var leavingStyle = willLeave(oldMergedPropsStyle);
    if (leavingStyle == null) {
      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
      return null;
    }
    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
      return null;
    }
    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
  });

  var newCurrentStyles = [];
  var newCurrentVelocities = [];
  var newLastIdealStyles = [];
  var newLastIdealVelocities = [];
  for (var i = 0; i < newMergedPropsStyles.length; i++) {
    var newMergedPropsStyleCell = newMergedPropsStyles[i];
    var foundOldIndex = null;
    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
        foundOldIndex = j;
        break;
      }
    }
    // TODO: key search code
    if (foundOldIndex == null) {
      var plainStyle = willEnter(newMergedPropsStyleCell);
      newCurrentStyles[i] = plainStyle;
      newLastIdealStyles[i] = plainStyle;

      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
      newCurrentVelocities[i] = velocity;
      newLastIdealVelocities[i] = velocity;
    } else {
      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
    }
  }

  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
}

var TransitionMotion = (function (_React$Component) {
  _inherits(TransitionMotion, _React$Component);

  _createClass(TransitionMotion, null, [{
    key: 'propTypes',
    value: {
      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
        key: _propTypes2['default'].string.isRequired,
        data: _propTypes2['default'].any,
        style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
      })),
      styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
        key: _propTypes2['default'].string.isRequired,
        data: _propTypes2['default'].any,
        style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
      }))]).isRequired,
      children: _propTypes2['default'].func.isRequired,
      willEnter: _propTypes2['default'].func,
      willLeave: _propTypes2['default'].func,
      didLeave: _propTypes2['default'].func
    },
    enumerable: true
  }, {
    key: 'defaultProps',
    value: {
      willEnter: function willEnter(styleThatEntered) {
        return _stripStyle2['default'](styleThatEntered.style);
      },
      // recall: returning null makes the current unmounting TransitionStyle
      // disappear immediately
      willLeave: function willLeave() {
        return null;
      },
      didLeave: function didLeave() {}
    },
    enumerable: true
  }]);

  function TransitionMotion(props) {
    var _this = this;

    _classCallCheck(this, TransitionMotion);

    _React$Component.call(this, props);
    this.unmounting = false;
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyles = null;

    this.clearUnreadPropStyle = function (unreadPropStyles) {
      var _mergeAndSync = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

      var mergedPropsStyles = _mergeAndSync[0];
      var currentStyles = _mergeAndSync[1];
      var currentVelocities = _mergeAndSync[2];
      var lastIdealStyles = _mergeAndSync[3];
      var lastIdealVelocities = _mergeAndSync[4];

      for (var i = 0; i < unreadPropStyles.length; i++) {
        var unreadPropStyle = unreadPropStyles[i].style;
        var dirty = false;

        for (var key in unreadPropStyle) {
          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
            continue;
          }

          var styleValue = unreadPropStyle[key];
          if (typeof styleValue === 'number') {
            if (!dirty) {
              dirty = true;
              currentStyles[i] = _extends({}, currentStyles[i]);
              currentVelocities[i] = _extends({}, currentVelocities[i]);
              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
              mergedPropsStyles[i] = {
                key: mergedPropsStyles[i].key,
                data: mergedPropsStyles[i].data,
                style: _extends({}, mergedPropsStyles[i].style)
              };
            }
            currentStyles[i][key] = styleValue;
            currentVelocities[i][key] = 0;
            lastIdealStyles[i][key] = styleValue;
            lastIdealVelocities[i][key] = 0;
            mergedPropsStyles[i].style[key] = styleValue;
          }
        }
      }

      // unlike the other 2 components, we can't detect staleness and optionally
      // opt out of setState here. each style object's data might contain new
      // stuff we're not/cannot compare
      _this.setState({
        currentStyles: currentStyles,
        currentVelocities: currentVelocities,
        mergedPropsStyles: mergedPropsStyles,
        lastIdealStyles: lastIdealStyles,
        lastIdealVelocities: lastIdealVelocities
      });
    };

    this.startAnimationIfNecessary = function () {
      if (_this.unmounting) {
        return;
      }

      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        // https://github.com/chenglou/react-motion/pull/420
        // > if execution passes the conditional if (this.unmounting), then
        // executes async defaultRaf and after that component unmounts and after
        // that the callback of defaultRaf is called, then setState will be called
        // on unmounted component.
        if (_this.unmounting) {
          return;
        }

        var propStyles = _this.props.styles;
        var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;

        // check if we need to animate in the first place
        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.accumulatedTime = 0;
          return;
        }

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var _mergeAndSync2 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

        var newMergedPropsStyles = _mergeAndSync2[0];
        var newCurrentStyles = _mergeAndSync2[1];
        var newCurrentVelocities = _mergeAndSync2[2];
        var newLastIdealStyles = _mergeAndSync2[3];
        var newLastIdealVelocities = _mergeAndSync2[4];

        for (var i = 0; i < newMergedPropsStyles.length; i++) {
          var newMergedPropsStyle = newMergedPropsStyles[i].style;
          var newCurrentStyle = {};
          var newCurrentVelocity = {};
          var newLastIdealStyle = {};
          var newLastIdealVelocity = {};

          for (var key in newMergedPropsStyle) {
            if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
              continue;
            }

            var styleValue = newMergedPropsStyle[key];
            if (typeof styleValue === 'number') {
              newCurrentStyle[key] = styleValue;
              newCurrentVelocity[key] = 0;
              newLastIdealStyle[key] = styleValue;
              newLastIdealVelocity[key] = 0;
            } else {
              var newLastIdealStyleValue = newLastIdealStyles[i][key];
              var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
              for (var j = 0; j < framesToCatchUp; j++) {
                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

                newLastIdealStyleValue = _stepper[0];
                newLastIdealVelocityValue = _stepper[1];
              }

              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              var nextIdealX = _stepper2[0];
              var nextIdealV = _stepper2[1];

              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
              newLastIdealStyle[key] = newLastIdealStyleValue;
              newLastIdealVelocity[key] = newLastIdealVelocityValue;
            }
          }

          newLastIdealStyles[i] = newLastIdealStyle;
          newLastIdealVelocities[i] = newLastIdealVelocity;
          newCurrentStyles[i] = newCurrentStyle;
          newCurrentVelocities[i] = newCurrentVelocity;
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyles: newCurrentStyles,
          currentVelocities: newCurrentVelocities,
          lastIdealStyles: newLastIdealStyles,
          lastIdealVelocities: newLastIdealVelocities,
          mergedPropsStyles: newMergedPropsStyles
        });

        _this.unreadPropStyles = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  TransitionMotion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;
    var willEnter = _props.willEnter;
    var willLeave = _props.willLeave;
    var didLeave = _props.didLeave;

    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;

    // this is special. for the first time around, we don't have a comparison
    // between last (no last) and current merged props. we'll compute last so:
    // say default is {a, b} and styles (dest style) is {b, c}, we'll
    // fabricate last as {a, b}
    var oldMergedPropsStyles = undefined;
    if (defaultStyles == null) {
      oldMergedPropsStyles = destStyles;
    } else {
      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
        // TODO: key search code
        for (var i = 0; i < destStyles.length; i++) {
          if (destStyles[i].key === defaultStyleCell.key) {
            return destStyles[i];
          }
        }
        return defaultStyleCell;
      });
    }
    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    });
    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    });

    var _mergeAndSync3 = mergeAndSync(
    // Because this is an old-style createReactClass component, Flow doesn't
    // understand that the willEnter and willLeave props have default values
    // and will always be present.
    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
    oldCurrentVelocities);

    var mergedPropsStyles = _mergeAndSync3[0];
    var currentStyles = _mergeAndSync3[1];
    var currentVelocities = _mergeAndSync3[2];
    var lastIdealStyles = _mergeAndSync3[3];
    var lastIdealVelocities = _mergeAndSync3[4];
    // oldLastIdealVelocities really

    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: lastIdealStyles,
      lastIdealVelocities: lastIdealVelocities,
      mergedPropsStyles: mergedPropsStyles
    };
  };

  // after checking for unreadPropStyles != null, we manually go set the
  // non-interpolating values (those that are a number, without a spring
  // config)

  TransitionMotion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  TransitionMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyles) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    var styles = props.styles;
    if (typeof styles === 'function') {
      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
    } else {
      this.unreadPropStyles = styles;
    }

    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  TransitionMotion.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounting = true;
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  TransitionMotion.prototype.render = function render() {
    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
    var renderedChildren = this.props.children(hydratedStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return TransitionMotion;
})(_react2['default'].Component);

exports['default'] = TransitionMotion;
module.exports = exports['default'];

// list of styles, each containing interpolating values. Part of what's passed
// to children function. Notice that this is
// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
// contains the key & data info (so that we only have a single source of truth
// for these, and to save space). Check the comment for `rehydrateStyles` to
// see how we regenerate the entirety of what's passed to children function

// the array that keeps track of currently rendered stuff! Including stuff
// that you've unmounted but that's still animating. This is where it lives

// it's possible that currentStyle's value is stale: if props is immediately
// changed from 0 to 400 to spring(0) again, the async currentStyle is still
// at 0 (didn't have time to tick and interpolate even once). If we naively
// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
// In reality currentStyle should be 400

/***/ }),
/* 2111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// core keys merging algorithm. If previous render's keys are [a, b], and the
// next render's [c, b, d], what's the final merged keys and ordering?

// - c and a must both be before b
// - b before d
// - ordering between a and c ambiguous

// this reduces to merging two partially ordered lists (e.g. lists where not
// every item has a definite ordering, like comparing a and c above). For the
// ambiguous ordering we deterministically choose to place the next render's
// item after the previous'; so c after a

// this is called a topological sorting. Except the existing algorithms don't
// work well with js bc of the amount of allocation, and isn't optimized for our
// current use-case bc the runtime is linear in terms of edges (see wiki for
// meaning), which is huge when two lists have many common elements


exports.__esModule = true;
exports['default'] = mergeDiff;

function mergeDiff(prev, next, onRemove) {
  // bookkeeping for easier access of a key's index below. This is 2 allocations +
  // potentially triggering chrome hash map mode for objs (so it might be faster

  var prevKeyIndex = {};
  for (var i = 0; i < prev.length; i++) {
    prevKeyIndex[prev[i].key] = i;
  }
  var nextKeyIndex = {};
  for (var i = 0; i < next.length; i++) {
    nextKeyIndex[next[i].key] = i;
  }

  // first, an overly elaborate way of merging prev and next, eliminating
  // duplicates (in terms of keys). If there's dupe, keep the item in next).
  // This way of writing it saves allocations
  var ret = [];
  for (var i = 0; i < next.length; i++) {
    ret[i] = next[i];
  }
  for (var i = 0; i < prev.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
      // merge in keys that the user desires to kill
      var fill = onRemove(i, prev[i]);
      if (fill != null) {
        ret.push(fill);
      }
    }
  }

  // now all the items all present. Core sorting logic to have the right order
  return ret.sort(function (a, b) {
    var nextOrderA = nextKeyIndex[a.key];
    var nextOrderB = nextKeyIndex[b.key];
    var prevOrderA = prevKeyIndex[a.key];
    var prevOrderB = prevKeyIndex[b.key];

    if (nextOrderA != null && nextOrderB != null) {
      // both keys in next
      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
    } else if (prevOrderA != null && prevOrderB != null) {
      // both keys in prev
      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
    } else if (nextOrderA != null) {
      // key a in next, key b in prev

      // how to determine the order between a and b? We find a "pivot" (term
      // abuse), a key present in both prev and next, that is sandwiched between
      // a and b. In the context of our above example, if we're comparing a and
      // d, b's (the only) pivot
      for (var i = 0; i < next.length; i++) {
        var pivot = next[i].key;
        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
          continue;
        }

        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
          return -1;
        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
          return 1;
        }
      }
      // pluggable. default to: next bigger than prev
      return 1;
    }
    // prevOrderA, nextOrderB
    for (var i = 0; i < next.length; i++) {
      var pivot = next[i].key;
      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
        continue;
      }
      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
        return 1;
      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
        return -1;
      }
    }
    // pluggable. default to: next bigger than prev
    return -1;
  });
}

module.exports = exports['default'];
// to loop through and find a key's index each time), but I no longer care

/***/ }),
/* 2112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = spring;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _presets = __webpack_require__(562);

var _presets2 = _interopRequireDefault(_presets);

var defaultConfig = _extends({}, _presets2['default'].noWobble, {
  precision: 0.01
});

function spring(val, config) {
  return _extends({}, defaultConfig, config, { val: val });
}

module.exports = exports['default'];

/***/ }),
/* 2113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = reorderKeys;

var hasWarned = false;

function reorderKeys() {
  if (false) {
    if (!hasWarned) {
      hasWarned = true;
      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
    }
  }
}

module.exports = exports['default'];

/***/ }),
/* 2114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony export (immutable) */ __webpack_exports__["a"] = point;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ordinal__ = __webpack_require__(575);



function band() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_1__ordinal__["a" /* default */])().unknown(undefined),
      domain = scale.domain,
      ordinalRange = scale.range,
      range = [0, 1],
      step,
      bandwidth,
      round = false,
      paddingInner = 0,
      paddingOuter = 0,
      align = 0.5;

  delete scale.unknown;

  function rescale() {
    var n = domain().length,
        reverse = range[1] < range[0],
        start = range[reverse - 0],
        stop = range[1 - reverse];
    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start += (stop - start - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["i" /* range */])(n).map(function(i) { return start + step * i; });
    return ordinalRange(reverse ? values.reverse() : values);
  }

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.range = function(_) {
    return arguments.length ? (range = [+_[0], +_[1]], rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = [+_[0], +_[1]], round = true, rescale();
  };

  scale.bandwidth = function() {
    return bandwidth;
  };

  scale.step = function() {
    return step;
  };

  scale.round = function(_) {
    return arguments.length ? (round = !!_, rescale()) : round;
  };

  scale.padding = function(_) {
    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingInner = function(_) {
    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingOuter = function(_) {
    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
  };

  scale.align = function(_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };

  scale.copy = function() {
    return band()
        .domain(domain())
        .range(range)
        .round(round)
        .paddingInner(paddingInner)
        .paddingOuter(paddingOuter)
        .align(align);
  };

  return rescale();
}

function pointish(scale) {
  var copy = scale.copy;

  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;

  scale.copy = function() {
    return pointish(copy());
  };

  return scale;
}

function point() {
  return pointish(band().paddingInner(1));
}


/***/ }),
/* 2115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pairs__ = __webpack_require__(565);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values0, values1, reduce) {
  var n0 = values0.length,
      n1 = values1.length,
      values = new Array(n0 * n1),
      i0,
      i1,
      i,
      value0;

  if (reduce == null) reduce = __WEBPACK_IMPORTED_MODULE_0__pairs__["a" /* pair */];

  for (i0 = i = 0; i0 < n0; ++i0) {
    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
      values[i] = reduce(value0, values1[i1]);
    }
  }

  return values;
});


/***/ }),
/* 2116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});


/***/ }),
/* 2117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisect__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(2118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extent__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__identity__ = __webpack_require__(2119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__range__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ticks__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__ = __webpack_require__(572);









/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var value = __WEBPACK_IMPORTED_MODULE_4__identity__["a" /* default */],
      domain = __WEBPACK_IMPORTED_MODULE_3__extent__["a" /* default */],
      threshold = __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__["a" /* default */];

  function histogram(data) {
    var i,
        n = data.length,
        x,
        values = new Array(n);

    for (i = 0; i < n; ++i) {
      values[i] = value(data[i], i, data);
    }

    var xz = domain(values),
        x0 = xz[0],
        x1 = xz[1],
        tz = threshold(values, x0, x1);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      tz = Object(__WEBPACK_IMPORTED_MODULE_6__ticks__["c" /* tickStep */])(x0, x1, tz);
      tz = Object(__WEBPACK_IMPORTED_MODULE_5__range__["a" /* default */])(Math.ceil(x0 / tz) * tz, x1, tz); // exclusive
    }

    // Remove any thresholds outside the domain.
    var m = tz.length;
    while (tz[0] <= x0) tz.shift(), --m;
    while (tz[m - 1] > x1) tz.pop(), --m;

    var bins = new Array(m + 1),
        bin;

    // Initialize bins.
    for (i = 0; i <= m; ++i) {
      bin = bins[i] = [];
      bin.x0 = i > 0 ? tz[i - 1] : x0;
      bin.x1 = i < m ? tz[i] : x1;
    }

    // Assign data to bins by value, ignoring any outside the domain.
    for (i = 0; i < n; ++i) {
      x = values[i];
      if (x0 <= x && x <= x1) {
        bins[Object(__WEBPACK_IMPORTED_MODULE_1__bisect__["a" /* default */])(tz, x, 0, m)].push(data[i]);
      }
    }

    return bins;
  }

  histogram.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : value;
  };

  histogram.domain = function(_) {
    return arguments.length ? (domain = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])([_[0], _[1]]), histogram) : domain;
  };

  histogram.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["b" /* slice */].call(_)) : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : threshold;
  };

  return histogram;
});


/***/ }),
/* 2118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 2119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 2120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__quantile__ = __webpack_require__(349);





/* unused harmony default export */ var _unused_webpack_default_export = (function(values, min, max) {
  values = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(values, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]).sort(__WEBPACK_IMPORTED_MODULE_1__ascending__["a" /* default */]);
  return Math.ceil((max - min) / (2 * (Object(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.75) - Object(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.25)) * Math.pow(values.length, -1 / 3)));
});


/***/ }),
/* 2121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__deviation__ = __webpack_require__(566);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values, min, max) {
  return Math.ceil((max - min) / (3.5 * Object(__WEBPACK_IMPORTED_MODULE_0__deviation__["a" /* default */])(values) * Math.pow(values.length, -1 / 3)));
});


/***/ }),
/* 2122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  return max;
});


/***/ }),
/* 2123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(192);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      m = n,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) sum += value;
      else --m;
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) sum += value;
      else --m;
    }
  }

  if (m) return sum / m;
});


/***/ }),
/* 2124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__number__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__quantile__ = __webpack_require__(349);




/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      numbers = [];

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(values[i]))) {
        numbers.push(value);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(valueof(values[i], i, values)))) {
        numbers.push(value);
      }
    }
  }

  return Object(__WEBPACK_IMPORTED_MODULE_2__quantile__["a" /* default */])(numbers.sort(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]), 0.5);
});


/***/ }),
/* 2125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(arrays) {
  var n = arrays.length,
      m,
      i = -1,
      j = 0,
      merged,
      array;

  while (++i < n) j += arrays[i].length;
  merged = new Array(j);

  while (--n >= 0) {
    array = arrays[n];
    m = array.length;
    while (--m >= 0) {
      merged[--j] = array[m];
    }
  }

  return merged;
});


/***/ }),
/* 2126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(array, indexes) {
  var i = indexes.length, permutes = new Array(i);
  while (i--) permutes[i] = array[indexes[i]];
  return permutes;
});


/***/ }),
/* 2127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(162);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values, compare) {
  if (!(n = values.length)) return;
  var n,
      i = 0,
      j = 0,
      xi,
      xj = values[j];

  if (compare == null) compare = __WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */];

  while (++i < n) {
    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
      xj = xi, j = i;
    }
  }

  if (compare(xj, xj) === 0) return j;
});


/***/ }),
/* 2128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(array, i0, i1) {
  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m + i0];
    array[m + i0] = array[i + i0];
    array[i + i0] = t;
  }

  return array;
});


/***/ }),
/* 2129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    }
  }

  else {
    while (++i < n) {
      if (value = +valueof(values[i], i, values)) sum += value;
    }
  }

  return sum;
});


/***/ }),
/* 2130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transpose__ = __webpack_require__(574);


/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__transpose__["a" /* default */])(arguments);
});


/***/ }),
/* 2131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(351);


/* harmony default export */ __webpack_exports__["a"] = (function() {
  var keys = [],
      sortKeys = [],
      sortValues,
      rollup,
      nest;

  function apply(array, depth, createResult, setResult) {
    if (depth >= keys.length) {
      if (sortValues != null) array.sort(sortValues);
      return rollup != null ? rollup(array) : array;
    }

    var i = -1,
        n = array.length,
        key = keys[depth++],
        keyValue,
        value,
        valuesByKey = Object(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */])(),
        values,
        result = createResult();

    while (++i < n) {
      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
        values.push(value);
      } else {
        valuesByKey.set(keyValue, [value]);
      }
    }

    valuesByKey.each(function(values, key) {
      setResult(result, key, apply(values, depth, createResult, setResult));
    });

    return result;
  }

  function entries(map, depth) {
    if (++depth > keys.length) return map;
    var array, sortKey = sortKeys[depth - 1];
    if (rollup != null && depth >= keys.length) array = map.entries();
    else array = [], map.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
  }

  return nest = {
    object: function(array) { return apply(array, 0, createObject, setObject); },
    map: function(array) { return apply(array, 0, createMap, setMap); },
    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
    key: function(d) { keys.push(d); return nest; },
    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
    sortValues: function(order) { sortValues = order; return nest; },
    rollup: function(f) { rollup = f; return nest; }
  };
});

function createObject() {
  return {};
}

function setObject(object, key, value) {
  object[key] = value;
}

function createMap() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */])();
}

function setMap(map, key, value) {
  map.set(key, value);
}


/***/ }),
/* 2132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(351);


function Set() {}

var proto = __WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */].prototype;

Set.prototype = set.prototype = {
  constructor: Set,
  has: proto.has,
  add: function(value) {
    value += "";
    this[__WEBPACK_IMPORTED_MODULE_0__map__["b" /* prefix */] + value] = value;
    return this;
  },
  remove: proto.remove,
  clear: proto.clear,
  values: proto.keys,
  size: proto.size,
  empty: proto.empty,
  each: proto.each
};

function set(object, f) {
  var set = new Set;

  // Copy constructor.
  if (object instanceof Set) object.each(function(value) { set.add(value); });

  // Otherwise, assume it’s an array.
  else if (object) {
    var i = -1, n = object.length;
    if (f == null) while (++i < n) set.add(object[i]);
    else while (++i < n) set.add(f(object[i], i, object));
  }

  return set;
}

/* harmony default export */ __webpack_exports__["a"] = (set);


/***/ }),
/* 2133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(map) {
  var keys = [];
  for (var key in map) keys.push(key);
  return keys;
});


/***/ }),
/* 2134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(map) {
  var values = [];
  for (var key in map) values.push(map[key]);
  return values;
});


/***/ }),
/* 2135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(map) {
  var entries = [];
  for (var key in map) entries.push({key: key, value: map[key]});
  return entries;
});


/***/ }),
/* 2136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(576);




function identity() {
  var domain = [0, 1];

  function scale(x) {
    return +x;
  }

  scale.invert = scale;

  scale.domain = scale.range = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]), scale) : domain.slice();
  };

  scale.copy = function() {
    return identity().domain(domain);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_1__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 2137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(194);



/* harmony default export */ __webpack_exports__["a"] = (function(domain, count, specifier) {
  var start = domain[0],
      stop = domain[domain.length - 1],
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["m" /* tickStep */])(start, stop, count == null ? 10 : count),
      precision;
  specifier = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["c" /* formatSpecifier */])(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["e" /* precisionPrefix */])(step, value))) specifier.precision = precision;
      return Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["b" /* formatPrefix */])(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["f" /* precisionRound */])(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["d" /* precisionFixed */])(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["a" /* format */])(specifier);
});


/***/ }),
/* 2138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return format; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatPrefix; });
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_js__ = __webpack_require__(577);


var locale;
var format;
var formatPrefix;

defaultLocale({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""],
  minus: "-"
});

function defaultLocale(definition) {
  locale = Object(__WEBPACK_IMPORTED_MODULE_0__locale_js__["a" /* default */])(definition);
  format = locale.format;
  formatPrefix = locale.formatPrefix;
  return locale;
}


/***/ }),
/* 2139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(grouping, thousands) {
  return function(value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
});


/***/ }),
/* 2140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
});


/***/ }),
/* 2141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
/* harmony default export */ __webpack_exports__["a"] = (function(s) {
  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (s[i]) {
      case ".": i0 = i1 = i; break;
      case "0": if (i0 === 0) i0 = i; i1 = i; break;
      default: if (!+s[i]) break out; if (i0 > 0) i0 = 0; break;
    }
  }
  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
});


/***/ }),
/* 2142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatPrefixAuto_js__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatRounded_js__ = __webpack_require__(2143);




/* harmony default export */ __webpack_exports__["a"] = ({
  "%": function(x, p) { return (x * 100).toFixed(p); },
  "b": function(x) { return Math.round(x).toString(2); },
  "c": function(x) { return x + ""; },
  "d": __WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__["a" /* default */],
  "e": function(x, p) { return x.toExponential(p); },
  "f": function(x, p) { return x.toFixed(p); },
  "g": function(x, p) { return x.toPrecision(p); },
  "o": function(x) { return Math.round(x).toString(8); },
  "p": function(x, p) { return Object(__WEBPACK_IMPORTED_MODULE_2__formatRounded_js__["a" /* default */])(x * 100, p); },
  "r": __WEBPACK_IMPORTED_MODULE_2__formatRounded_js__["a" /* default */],
  "s": __WEBPACK_IMPORTED_MODULE_1__formatPrefixAuto_js__["a" /* default */],
  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
  "x": function(x) { return Math.round(x).toString(16); }
});


/***/ }),
/* 2143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__ = __webpack_require__(257);


/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  var d = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__["b" /* formatDecimalParts */])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
});


/***/ }),
/* 2144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 2145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent_js__ = __webpack_require__(256);


/* harmony default export */ __webpack_exports__["a"] = (function(step) {
  return Math.max(0, -Object(__WEBPACK_IMPORTED_MODULE_0__exponent_js__["a" /* default */])(Math.abs(step)));
});


/***/ }),
/* 2146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent_js__ = __webpack_require__(256);


/* harmony default export */ __webpack_exports__["a"] = (function(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(Object(__WEBPACK_IMPORTED_MODULE_0__exponent_js__["a" /* default */])(value) / 3))) * 3 - Object(__WEBPACK_IMPORTED_MODULE_0__exponent_js__["a" /* default */])(Math.abs(step)));
});


/***/ }),
/* 2147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent_js__ = __webpack_require__(256);


/* harmony default export */ __webpack_exports__["a"] = (function(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, Object(__WEBPACK_IMPORTED_MODULE_0__exponent_js__["a" /* default */])(max) - Object(__WEBPACK_IMPORTED_MODULE_0__exponent_js__["a" /* default */])(step)) + 1;
});


/***/ }),
/* 2148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = log;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nice__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__continuous__ = __webpack_require__(255);






function deinterpolate(a, b) {
  return (b = Math.log(b / a))
      ? function(x) { return Math.log(x / a) / b; }
      : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(b);
}

function reinterpolate(a, b) {
  return a < 0
      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
}

function pow10(x) {
  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}

function powp(base) {
  return base === 10 ? pow10
      : base === Math.E ? Math.exp
      : function(x) { return Math.pow(base, x); };
}

function logp(base) {
  return base === Math.E ? Math.log
      : base === 10 && Math.log10
      || base === 2 && Math.log2
      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
}

function reflect(f) {
  return function(x) {
    return -f(-x);
  };
}

function log() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_4__continuous__["b" /* default */])(deinterpolate, reinterpolate).domain([1, 10]),
      domain = scale.domain,
      base = 10,
      logs = logp(10),
      pows = powp(10);

  function rescale() {
    logs = logp(base), pows = powp(base);
    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
    return scale;
  }

  scale.base = function(_) {
    return arguments.length ? (base = +_, rescale()) : base;
  };

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.ticks = function(count) {
    var d = domain(),
        u = d[0],
        v = d[d.length - 1],
        r;

    if (r = v < u) i = u, u = v, v = i;

    var i = logs(u),
        j = logs(v),
        p,
        k,
        t,
        n = count == null ? 10 : +count,
        z = [];

    if (!(base % 1) && j - i < n) {
      i = Math.round(i) - 1, j = Math.round(j) + 1;
      if (u > 0) for (; i < j; ++i) {
        for (k = 1, p = pows(i); k < base; ++k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      } else for (; i < j; ++i) {
        for (k = base - 1, p = pows(i); k >= 1; --k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      }
    } else {
      z = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["n" /* ticks */])(i, j, Math.min(j - i, n)).map(pows);
    }

    return r ? z.reverse() : z;
  };

  scale.tickFormat = function(count, specifier) {
    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
    if (typeof specifier !== "function") specifier = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["a" /* format */])(specifier);
    if (count === Infinity) return specifier;
    if (count == null) count = 10;
    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
    return function(d) {
      var i = d / pows(Math.round(logs(d)));
      if (i * base < base - 0.5) i *= base;
      return i <= k ? specifier(d) : "";
    };
  };

  scale.nice = function() {
    return domain(Object(__WEBPACK_IMPORTED_MODULE_3__nice__["a" /* default */])(domain(), {
      floor: function(x) { return pows(Math.floor(logs(x))); },
      ceil: function(x) { return pows(Math.ceil(logs(x))); }
    }));
  };

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_4__continuous__["a" /* copy */])(scale, log().base(base));
  };

  return scale;
}


/***/ }),
/* 2149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony export (immutable) */ __webpack_exports__["a"] = sqrt;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__continuous__ = __webpack_require__(255);




function raise(x, exponent) {
  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
}

function pow() {
  var exponent = 1,
      scale = Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["b" /* default */])(deinterpolate, reinterpolate),
      domain = scale.domain;

  function deinterpolate(a, b) {
    return (b = raise(b, exponent) - (a = raise(a, exponent)))
        ? function(x) { return (raise(x, exponent) - a) / b; }
        : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(b);
  }

  function reinterpolate(a, b) {
    b = raise(b, exponent) - (a = raise(a, exponent));
    return function(t) { return raise(a + b * t, 1 / exponent); };
  }

  scale.exponent = function(_) {
    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
  };

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["a" /* copy */])(scale, pow().exponent(exponent));
  };

  return Object(__WEBPACK_IMPORTED_MODULE_1__linear__["b" /* linearish */])(scale);
}

function sqrt() {
  return pow().exponent(0.5);
}


/***/ }),
/* 2150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(131);



function quantile() {
  var domain = [],
      range = [],
      thresholds = [];

  function rescale() {
    var i = 0, n = Math.max(1, range.length);
    thresholds = new Array(n - 1);
    while (++i < n) thresholds[i - 1] = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["h" /* quantile */])(domain, i / n);
    return scale;
  }

  function scale(x) {
    if (!isNaN(x = +x)) return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* bisect */])(thresholds, x)];
  }

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN] : [
      i > 0 ? thresholds[i - 1] : domain[0],
      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
    ];
  };

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
    domain.sort(__WEBPACK_IMPORTED_MODULE_0_d3_array__["a" /* ascending */]);
    return rescale();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.quantiles = function() {
    return thresholds.slice();
  };

  scale.copy = function() {
    return quantile()
        .domain(domain)
        .range(range);
  };

  return scale;
}


/***/ }),
/* 2151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linear__ = __webpack_require__(193);




function quantize() {
  var x0 = 0,
      x1 = 1,
      n = 1,
      domain = [0.5],
      range = [0, 1];

  function scale(x) {
    if (x <= x) return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* bisect */])(domain, x, 0, n)];
  }

  function rescale() {
    var i = -1;
    domain = new Array(n);
    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
    return scale;
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
  };

  scale.range = function(_) {
    return arguments.length ? (n = (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_)).length - 1, rescale()) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN]
        : i < 1 ? [x0, domain[0]]
        : i >= n ? [domain[n - 1], x1]
        : [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return quantize()
        .domain([x0, x1])
        .range(range);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_2__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 2152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(131);



function threshold() {
  var domain = [0.5],
      range = [0, 1],
      n = 1;

  function scale(x) {
    if (x <= x) return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* bisect */])(domain, x, 0, n)];
  }

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return threshold()
        .domain(domain)
        .range(range);
  };

  return scale;
}


/***/ }),
/* 2153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export milliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(74);


var millisecond = Object(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function() {
  // noop
}, function(date, step) {
  date.setTime(+date + step);
}, function(start, end) {
  return end - start;
});

// An optimized implementation for this simple case.
millisecond.every = function(k) {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0)) return null;
  if (!(k > 1)) return millisecond;
  return Object(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
    date.setTime(Math.floor(date / k) * k);
  }, function(date, step) {
    date.setTime(+date + step * k);
  }, function(start, end) {
    return (end - start) / k;
  });
};

/* harmony default export */ __webpack_exports__["a"] = (millisecond);
var milliseconds = millisecond.range;


/***/ }),
/* 2154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export seconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration_js__ = __webpack_require__(103);



var second = Object(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
  date.setTime(date - date.getMilliseconds());
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration_js__["d" /* durationSecond */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration_js__["d" /* durationSecond */];
}, function(date) {
  return date.getUTCSeconds();
});

/* harmony default export */ __webpack_exports__["a"] = (second);
var seconds = second.range;


/***/ }),
/* 2155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export minutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration_js__ = __webpack_require__(103);



var minute = Object(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
  date.setTime(date - date.getMilliseconds() - date.getSeconds() * __WEBPACK_IMPORTED_MODULE_1__duration_js__["d" /* durationSecond */]);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration_js__["c" /* durationMinute */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration_js__["c" /* durationMinute */];
}, function(date) {
  return date.getMinutes();
});

/* harmony default export */ __webpack_exports__["a"] = (minute);
var minutes = minute.range;


/***/ }),
/* 2156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration_js__ = __webpack_require__(103);



var hour = Object(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
  date.setTime(date - date.getMilliseconds() - date.getSeconds() * __WEBPACK_IMPORTED_MODULE_1__duration_js__["d" /* durationSecond */] - date.getMinutes() * __WEBPACK_IMPORTED_MODULE_1__duration_js__["c" /* durationMinute */]);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration_js__["b" /* durationHour */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration_js__["b" /* durationHour */];
}, function(date) {
  return date.getHours();
});

/* harmony default export */ __webpack_exports__["a"] = (hour);
var hours = hour.range;


/***/ }),
/* 2157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export days */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration_js__ = __webpack_require__(103);



var day = Object(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setDate(date.getDate() + step);
}, function(start, end) {
  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_1__duration_js__["c" /* durationMinute */]) / __WEBPACK_IMPORTED_MODULE_1__duration_js__["a" /* durationDay */];
}, function(date) {
  return date.getDate() - 1;
});

/* harmony default export */ __webpack_exports__["a"] = (day);
var days = day.range;


/***/ }),
/* 2158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sunday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return monday; });
/* unused harmony export tuesday */
/* unused harmony export wednesday */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return thursday; });
/* unused harmony export friday */
/* unused harmony export saturday */
/* unused harmony export sundays */
/* unused harmony export mondays */
/* unused harmony export tuesdays */
/* unused harmony export wednesdays */
/* unused harmony export thursdays */
/* unused harmony export fridays */
/* unused harmony export saturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration_js__ = __webpack_require__(103);



function weekday(i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setDate(date.getDate() + step * 7);
  }, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_1__duration_js__["c" /* durationMinute */]) / __WEBPACK_IMPORTED_MODULE_1__duration_js__["e" /* durationWeek */];
  });
}

var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);

var sundays = sunday.range;
var mondays = monday.range;
var tuesdays = tuesday.range;
var wednesdays = wednesday.range;
var thursdays = thursday.range;
var fridays = friday.range;
var saturdays = saturday.range;


/***/ }),
/* 2159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export months */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(74);


var month = Object(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setMonth(date.getMonth() + step);
}, function(start, end) {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
  return date.getMonth();
});

/* harmony default export */ __webpack_exports__["a"] = (month);
var months = month.range;


/***/ }),
/* 2160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export years */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(74);


var year = Object(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
  return end.getFullYear() - start.getFullYear();
}, function(date) {
  return date.getFullYear();
});

// An optimized implementation for this simple case.
year.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : Object(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setFullYear(date.getFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (year);
var years = year.range;


/***/ }),
/* 2161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration_js__ = __webpack_require__(103);



var utcMinute = Object(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
  date.setUTCSeconds(0, 0);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration_js__["c" /* durationMinute */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration_js__["c" /* durationMinute */];
}, function(date) {
  return date.getUTCMinutes();
});

/* harmony default export */ __webpack_exports__["a"] = (utcMinute);
var utcMinutes = utcMinute.range;


/***/ }),
/* 2162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration_js__ = __webpack_require__(103);



var utcHour = Object(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
  date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration_js__["b" /* durationHour */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration_js__["b" /* durationHour */];
}, function(date) {
  return date.getUTCHours();
});

/* harmony default export */ __webpack_exports__["a"] = (utcHour);
var utcHours = utcHour.range;


/***/ }),
/* 2163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration_js__ = __webpack_require__(103);



var utcDay = Object(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration_js__["a" /* durationDay */];
}, function(date) {
  return date.getUTCDate() - 1;
});

/* harmony default export */ __webpack_exports__["a"] = (utcDay);
var utcDays = utcDay.range;


/***/ }),
/* 2164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcSunday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return utcMonday; });
/* unused harmony export utcTuesday */
/* unused harmony export utcWednesday */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return utcThursday; });
/* unused harmony export utcFriday */
/* unused harmony export utcSaturday */
/* unused harmony export utcSundays */
/* unused harmony export utcMondays */
/* unused harmony export utcTuesdays */
/* unused harmony export utcWednesdays */
/* unused harmony export utcThursdays */
/* unused harmony export utcFridays */
/* unused harmony export utcSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration_js__ = __webpack_require__(103);



function utcWeekday(i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, function(start, end) {
    return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration_js__["e" /* durationWeek */];
  });
}

var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);

var utcSundays = utcSunday.range;
var utcMondays = utcMonday.range;
var utcTuesdays = utcTuesday.range;
var utcWednesdays = utcWednesday.range;
var utcThursdays = utcThursday.range;
var utcFridays = utcFriday.range;
var utcSaturdays = utcSaturday.range;


/***/ }),
/* 2165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(74);


var utcMonth = Object(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
  return date.getUTCMonth();
});

/* harmony default export */ __webpack_exports__["a"] = (utcMonth);
var utcMonths = utcMonth.range;


/***/ }),
/* 2166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(74);


var utcYear = Object(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
  return date.getUTCFullYear();
});

// An optimized implementation for this simple case.
utcYear.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : Object(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (utcYear);
var utcYears = utcYear.range;


/***/ }),
/* 2167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isoFormat_js__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaultLocale_js__ = __webpack_require__(354);



function parseIsoNative(string) {
  var date = new Date(string);
  return isNaN(date) ? null : date;
}

var parseIso = +new Date("2000-01-01T00:00:00.000Z")
    ? parseIsoNative
    : Object(__WEBPACK_IMPORTED_MODULE_1__defaultLocale_js__["c" /* utcParse */])(__WEBPACK_IMPORTED_MODULE_0__isoFormat_js__["a" /* isoSpecifier */]);

/* unused harmony default export */ var _unused_webpack_default_export = (parseIso);


/***/ }),
/* 2168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__time__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_time_format__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__(353);




/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__time__["a" /* calendar */])(__WEBPACK_IMPORTED_MODULE_2_d3_time__["v" /* utcYear */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["q" /* utcMonth */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["u" /* utcWeek */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["l" /* utcDay */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["m" /* utcHour */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["o" /* utcMinute */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["r" /* utcSecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["n" /* utcMillisecond */], __WEBPACK_IMPORTED_MODULE_1_d3_time_format__["b" /* utcFormat */]).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
});


/***/ }),
/* 2169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(195);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf"));


/***/ }),
/* 2170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(195);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6"));


/***/ }),
/* 2171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(195);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9"));


/***/ }),
/* 2172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(195);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5"));


/***/ }),
/* 2173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(129);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["b" /* interpolateCubehelixLong */])(Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(300, 0.5, 0.0), Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(-240, 0.5, 1.0)));


/***/ }),
/* 2174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export warm */
/* unused harmony export cool */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(129);



var warm = Object(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["b" /* interpolateCubehelixLong */])(Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(-100, 0.75, 0.35), Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(80, 1.50, 0.8));

var cool = Object(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["b" /* interpolateCubehelixLong */])(Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(260, 0.75, 0.35), Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(80, 1.50, 0.8));

var rainbow = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])();

/* unused harmony default export */ var _unused_webpack_default_export = (function(t) {
  if (t < 0 || t > 1) t -= Math.floor(t);
  var ts = Math.abs(t - 0.5);
  rainbow.h = 360 * t - 100;
  rainbow.s = 1.5 - 1.5 * ts;
  rainbow.l = 0.8 - 0.9 * ts;
  return rainbow + "";
});


/***/ }),
/* 2175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export magma */
/* unused harmony export inferno */
/* unused harmony export plasma */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(195);


function ramp(range) {
  var n = range.length;
  return function(t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = (ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725")));

var magma = ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));

var inferno = ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));

var plasma = ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));


/***/ }),
/* 2176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(193);


function sequential(interpolator) {
  var x0 = 0,
      x1 = 1,
      clamp = false;

  function scale(x) {
    var t = (x - x0) / (x1 - x0);
    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };

  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  scale.copy = function() {
    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 2177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant_js__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math_js__ = __webpack_require__(198);




function arcInnerRadius(d) {
  return d.innerRadius;
}

function arcOuterRadius(d) {
  return d.outerRadius;
}

function arcStartAngle(d) {
  return d.startAngle;
}

function arcEndAngle(d) {
  return d.endAngle;
}

function arcPadAngle(d) {
  return d && d.padAngle; // Note: optional!
}

function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
  var x10 = x1 - x0, y10 = y1 - y0,
      x32 = x3 - x2, y32 = y3 - y2,
      t = y32 * x10 - x32 * y10;
  if (t * t < __WEBPACK_IMPORTED_MODULE_2__math_js__["f" /* epsilon */]) return;
  t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
  return [x0 + t * x10, y0 + t * y10];
}

// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
  var x01 = x0 - x1,
      y01 = y0 - y1,
      lo = (cw ? rc : -rc) / Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["l" /* sqrt */])(x01 * x01 + y01 * y01),
      ox = lo * y01,
      oy = -lo * x01,
      x11 = x0 + ox,
      y11 = y0 + oy,
      x10 = x1 + ox,
      y10 = y1 + oy,
      x00 = (x11 + x10) / 2,
      y00 = (y11 + y10) / 2,
      dx = x10 - x11,
      dy = y10 - y11,
      d2 = dx * dx + dy * dy,
      r = r1 - rc,
      D = x11 * y10 - x10 * y11,
      d = (dy < 0 ? -1 : 1) * Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["l" /* sqrt */])(Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["h" /* max */])(0, r * r * d2 - D * D)),
      cx0 = (D * dy - dx * d) / d2,
      cy0 = (-D * dx - dy * d) / d2,
      cx1 = (D * dy + dx * d) / d2,
      cy1 = (-D * dx + dy * d) / d2,
      dx0 = cx0 - x00,
      dy0 = cy0 - y00,
      dx1 = cx1 - x00,
      dy1 = cy1 - y00;

  // Pick the closer of the two intersection points.
  // TODO Is there a faster way to determine which intersection to use?
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;

  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r - 1),
    y11: cy0 * (r1 / r - 1)
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var innerRadius = arcInnerRadius,
      outerRadius = arcOuterRadius,
      cornerRadius = Object(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(0),
      padRadius = null,
      startAngle = arcStartAngle,
      endAngle = arcEndAngle,
      padAngle = arcPadAngle,
      context = null;

  function arc() {
    var buffer,
        r,
        r0 = +innerRadius.apply(this, arguments),
        r1 = +outerRadius.apply(this, arguments),
        a0 = startAngle.apply(this, arguments) - __WEBPACK_IMPORTED_MODULE_2__math_js__["g" /* halfPi */],
        a1 = endAngle.apply(this, arguments) - __WEBPACK_IMPORTED_MODULE_2__math_js__["g" /* halfPi */],
        da = Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["a" /* abs */])(a1 - a0),
        cw = a1 > a0;

    if (!context) context = buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();

    // Ensure that the outer radius is always larger than the inner radius.
    if (r1 < r0) r = r1, r1 = r0, r0 = r;

    // Is it a point?
    if (!(r1 > __WEBPACK_IMPORTED_MODULE_2__math_js__["f" /* epsilon */])) context.moveTo(0, 0);

    // Or is it a circle or annulus?
    else if (da > __WEBPACK_IMPORTED_MODULE_2__math_js__["m" /* tau */] - __WEBPACK_IMPORTED_MODULE_2__math_js__["f" /* epsilon */]) {
      context.moveTo(r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["e" /* cos */])(a0), r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["k" /* sin */])(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > __WEBPACK_IMPORTED_MODULE_2__math_js__["f" /* epsilon */]) {
        context.moveTo(r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["e" /* cos */])(a1), r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["k" /* sin */])(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    }

    // Or is it a circular or annular sector?
    else {
      var a01 = a0,
          a11 = a1,
          a00 = a0,
          a10 = a1,
          da0 = da,
          da1 = da,
          ap = padAngle.apply(this, arguments) / 2,
          rp = (ap > __WEBPACK_IMPORTED_MODULE_2__math_js__["f" /* epsilon */]) && (padRadius ? +padRadius.apply(this, arguments) : Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["l" /* sqrt */])(r0 * r0 + r1 * r1)),
          rc = Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["i" /* min */])(Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["a" /* abs */])(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
          rc0 = rc,
          rc1 = rc,
          t0,
          t1;

      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
      if (rp > __WEBPACK_IMPORTED_MODULE_2__math_js__["f" /* epsilon */]) {
        var p0 = Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["c" /* asin */])(rp / r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["k" /* sin */])(ap)),
            p1 = Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["c" /* asin */])(rp / r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["k" /* sin */])(ap));
        if ((da0 -= p0 * 2) > __WEBPACK_IMPORTED_MODULE_2__math_js__["f" /* epsilon */]) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > __WEBPACK_IMPORTED_MODULE_2__math_js__["f" /* epsilon */]) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }

      var x01 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["e" /* cos */])(a01),
          y01 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["k" /* sin */])(a01),
          x10 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["e" /* cos */])(a10),
          y10 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["k" /* sin */])(a10);

      // Apply rounded corners?
      if (rc > __WEBPACK_IMPORTED_MODULE_2__math_js__["f" /* epsilon */]) {
        var x11 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["e" /* cos */])(a11),
            y11 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["k" /* sin */])(a11),
            x00 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["e" /* cos */])(a00),
            y00 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["k" /* sin */])(a00),
            oc;

        // Restrict the corner radius according to the sector angle.
        if (da < __WEBPACK_IMPORTED_MODULE_2__math_js__["j" /* pi */] && (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
          var ax = x01 - oc[0],
              ay = y01 - oc[1],
              bx = x11 - oc[0],
              by = y11 - oc[1],
              kc = 1 / Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["k" /* sin */])(Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["b" /* acos */])((ax * bx + ay * by) / (Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["l" /* sqrt */])(ax * ax + ay * ay) * Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["l" /* sqrt */])(bx * bx + by * by))) / 2),
              lc = Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["l" /* sqrt */])(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["i" /* min */])(rc, (r0 - lc) / (kc - 1));
          rc1 = Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["i" /* min */])(rc, (r1 - lc) / (kc + 1));
        }
      }

      // Is the sector collapsed to a line?
      if (!(da1 > __WEBPACK_IMPORTED_MODULE_2__math_js__["f" /* epsilon */])) context.moveTo(x01, y01);

      // Does the sector’s outer ring have rounded corners?
      else if (rc1 > __WEBPACK_IMPORTED_MODULE_2__math_js__["f" /* epsilon */]) {
        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);

        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["d" /* atan2 */])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["d" /* atan2 */])(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc1, Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["d" /* atan2 */])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["d" /* atan2 */])(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r1, Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["d" /* atan2 */])(t0.cy + t0.y11, t0.cx + t0.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["d" /* atan2 */])(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
          context.arc(t1.cx, t1.cy, rc1, Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["d" /* atan2 */])(t1.y11, t1.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["d" /* atan2 */])(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the outer ring just a circular arc?
      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);

      // Is there no inner ring, and it’s a circular sector?
      // Or perhaps it’s an annular sector collapsed due to padding?
      if (!(r0 > __WEBPACK_IMPORTED_MODULE_2__math_js__["f" /* epsilon */]) || !(da0 > __WEBPACK_IMPORTED_MODULE_2__math_js__["f" /* epsilon */])) context.lineTo(x10, y10);

      // Does the sector’s inner ring (or point) have rounded corners?
      else if (rc0 > __WEBPACK_IMPORTED_MODULE_2__math_js__["f" /* epsilon */]) {
        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);

        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["d" /* atan2 */])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["d" /* atan2 */])(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc0, Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["d" /* atan2 */])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["d" /* atan2 */])(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r0, Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["d" /* atan2 */])(t0.cy + t0.y11, t0.cx + t0.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["d" /* atan2 */])(t1.cy + t1.y11, t1.cx + t1.x11), cw);
          context.arc(t1.cx, t1.cy, rc0, Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["d" /* atan2 */])(t1.y11, t1.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["d" /* atan2 */])(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the inner ring just a circular arc?
      else context.arc(0, 0, r0, a10, a00, cw);
    }

    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  arc.centroid = function() {
    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - __WEBPACK_IMPORTED_MODULE_2__math_js__["j" /* pi */] / 2;
    return [Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["e" /* cos */])(a) * r, Object(__WEBPACK_IMPORTED_MODULE_2__math_js__["k" /* sin */])(a) * r];
  };

  arc.innerRadius = function(_) {
    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(+_), arc) : innerRadius;
  };

  arc.outerRadius = function(_) {
    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(+_), arc) : outerRadius;
  };

  arc.cornerRadius = function(_) {
    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(+_), arc) : cornerRadius;
  };

  arc.padRadius = function(_) {
    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(+_), arc) : padRadius;
  };

  arc.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(+_), arc) : startAngle;
  };

  arc.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(+_), arc) : endAngle;
  };

  arc.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(+_), arc) : padAngle;
  };

  arc.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
  };

  return arc;
});


/***/ }),
/* 2178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var pi = Math.PI,
    tau = 2 * pi,
    epsilon = 1e-6,
    tauEpsilon = tau - epsilon;

function Path() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null; // end of current subpath
  this._ = "";
}

function path() {
  return new Path;
}

Path.prototype = path.prototype = {
  constructor: Path,
  moveTo: function(x, y) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
  },
  closePath: function() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._ += "Z";
    }
  },
  lineTo: function(x, y) {
    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  quadraticCurveTo: function(x1, y1, x, y) {
    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  arcTo: function(x1, y1, x2, y2, r) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
    var x0 = this._x1,
        y0 = this._y1,
        x21 = x2 - x1,
        y21 = y2 - y1,
        x01 = x0 - x1,
        y01 = y0 - y1,
        l01_2 = x01 * x01 + y01 * y01;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x1,y1).
    if (this._x1 === null) {
      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
    else if (!(l01_2 > epsilon));

    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
    // Equivalently, is (x1,y1) coincident with (x2,y2)?
    // Or, is the radius zero? Line to (x1,y1).
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Otherwise, draw an arc!
    else {
      var x20 = x2 - x0,
          y20 = y2 - y0,
          l21_2 = x21 * x21 + y21 * y21,
          l20_2 = x20 * x20 + y20 * y20,
          l21 = Math.sqrt(l21_2),
          l01 = Math.sqrt(l01_2),
          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
          t01 = l / l01,
          t21 = l / l21;

      // If the start tangent is not coincident with (x0,y0), line to.
      if (Math.abs(t01 - 1) > epsilon) {
        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
      }

      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
    }
  },
  arc: function(x, y, r, a0, a1, ccw) {
    x = +x, y = +y, r = +r, ccw = !!ccw;
    var dx = r * Math.cos(a0),
        dy = r * Math.sin(a0),
        x0 = x + dx,
        y0 = y + dy,
        cw = 1 ^ ccw,
        da = ccw ? a0 - a1 : a1 - a0;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x0,y0).
    if (this._x1 === null) {
      this._ += "M" + x0 + "," + y0;
    }

    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
      this._ += "L" + x0 + "," + y0;
    }

    // Is this arc empty? We’re done.
    if (!r) return;

    // Does the angle go the wrong way? Flip the direction.
    if (da < 0) da = da % tau + tau;

    // Is this a complete circle? Draw two arcs to complete the circle.
    if (da > tauEpsilon) {
      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
    }

    // Is this arc non-empty? Draw an arc!
    else if (da > epsilon) {
      this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    }
  },
  rect: function(x, y, w, h) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
  },
  toString: function() {
    return this._;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (path);


/***/ }),
/* 2179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant_js__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__descending_js__ = __webpack_require__(2180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity_js__ = __webpack_require__(2181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__math_js__ = __webpack_require__(198);





/* harmony default export */ __webpack_exports__["a"] = (function() {
  var value = __WEBPACK_IMPORTED_MODULE_2__identity_js__["a" /* default */],
      sortValues = __WEBPACK_IMPORTED_MODULE_1__descending_js__["a" /* default */],
      sort = null,
      startAngle = Object(__WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */])(0),
      endAngle = Object(__WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__math_js__["m" /* tau */]),
      padAngle = Object(__WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */])(0);

  function pie(data) {
    var i,
        n = data.length,
        j,
        k,
        sum = 0,
        index = new Array(n),
        arcs = new Array(n),
        a0 = +startAngle.apply(this, arguments),
        da = Math.min(__WEBPACK_IMPORTED_MODULE_3__math_js__["m" /* tau */], Math.max(-__WEBPACK_IMPORTED_MODULE_3__math_js__["m" /* tau */], endAngle.apply(this, arguments) - a0)),
        a1,
        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
        pa = p * (da < 0 ? -1 : 1),
        v;

    for (i = 0; i < n; ++i) {
      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
        sum += v;
      }
    }

    // Optionally sort the arcs by previously-computed values or by data.
    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });

    // Compute the arcs! They are stored in the original data's order.
    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
        data: data[j],
        index: i,
        value: v,
        startAngle: a0,
        endAngle: a1,
        padAngle: p
      };
    }

    return arcs;
  }

  pie.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */])(+_), pie) : value;
  };

  pie.sortValues = function(_) {
    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
  };

  pie.sort = function(_) {
    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
  };

  pie.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */])(+_), pie) : startAngle;
  };

  pie.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */])(+_), pie) : endAngle;
  };

  pie.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */])(+_), pie) : padAngle;
  };

  return pie;
});


/***/ }),
/* 2180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});


/***/ }),
/* 2181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(d) {
  return d;
});


/***/ }),
/* 2182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curve_radial_js__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__area_js__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lineRadial_js__ = __webpack_require__(587);




/* harmony default export */ __webpack_exports__["a"] = (function() {
  var a = Object(__WEBPACK_IMPORTED_MODULE_1__area_js__["a" /* default */])().curve(__WEBPACK_IMPORTED_MODULE_0__curve_radial_js__["a" /* curveRadialLinear */]),
      c = a.curve,
      x0 = a.lineX0,
      x1 = a.lineX1,
      y0 = a.lineY0,
      y1 = a.lineY1;

  a.angle = a.x, delete a.x;
  a.startAngle = a.x0, delete a.x0;
  a.endAngle = a.x1, delete a.x1;
  a.radius = a.y, delete a.y;
  a.innerRadius = a.y0, delete a.y0;
  a.outerRadius = a.y1, delete a.y1;
  a.lineStartAngle = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__lineRadial_js__["b" /* lineRadial */])(x0()); }, delete a.lineX0;
  a.lineEndAngle = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__lineRadial_js__["b" /* lineRadial */])(x1()); }, delete a.lineX1;
  a.lineInnerRadius = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__lineRadial_js__["b" /* lineRadial */])(y0()); }, delete a.lineY0;
  a.lineOuterRadius = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__lineRadial_js__["b" /* lineRadial */])(y1()); }, delete a.lineY1;

  a.curve = function(_) {
    return arguments.length ? c(Object(__WEBPACK_IMPORTED_MODULE_0__curve_radial_js__["b" /* default */])(_)) : c()._curve;
  };

  return a;
});


/***/ }),
/* 2183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = linkHorizontal;
/* harmony export (immutable) */ __webpack_exports__["c"] = linkVertical;
/* harmony export (immutable) */ __webpack_exports__["b"] = linkRadial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array_js__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant_js__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__point_js__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pointRadial_js__ = __webpack_require__(588);






function linkSource(d) {
  return d.source;
}

function linkTarget(d) {
  return d.target;
}

function link(curve) {
  var source = linkSource,
      target = linkTarget,
      x = __WEBPACK_IMPORTED_MODULE_3__point_js__["a" /* x */],
      y = __WEBPACK_IMPORTED_MODULE_3__point_js__["b" /* y */],
      context = null;

  function link() {
    var buffer, argv = __WEBPACK_IMPORTED_MODULE_1__array_js__["a" /* slice */].call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
    if (!context) context = buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();
    curve(context, +x.apply(this, (argv[0] = s, argv)), +y.apply(this, argv), +x.apply(this, (argv[0] = t, argv)), +y.apply(this, argv));
    if (buffer) return context = null, buffer + "" || null;
  }

  link.source = function(_) {
    return arguments.length ? (source = _, link) : source;
  };

  link.target = function(_) {
    return arguments.length ? (target = _, link) : target;
  };

  link.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant_js__["a" /* default */])(+_), link) : x;
  };

  link.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant_js__["a" /* default */])(+_), link) : y;
  };

  link.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), link) : context;
  };

  return link;
}

function curveHorizontal(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
}

function curveVertical(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
}

function curveRadial(context, x0, y0, x1, y1) {
  var p0 = Object(__WEBPACK_IMPORTED_MODULE_4__pointRadial_js__["a" /* default */])(x0, y0),
      p1 = Object(__WEBPACK_IMPORTED_MODULE_4__pointRadial_js__["a" /* default */])(x0, y0 = (y0 + y1) / 2),
      p2 = Object(__WEBPACK_IMPORTED_MODULE_4__pointRadial_js__["a" /* default */])(x1, y0),
      p3 = Object(__WEBPACK_IMPORTED_MODULE_4__pointRadial_js__["a" /* default */])(x1, y1);
  context.moveTo(p0[0], p0[1]);
  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
}

function linkHorizontal() {
  return link(curveHorizontal);
}

function linkVertical() {
  return link(curveVertical);
}

function linkRadial() {
  var l = link(curveRadial);
  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;
  return l;
}


/***/ }),
/* 2184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return symbols; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__symbol_circle_js__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__symbol_cross_js__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__symbol_diamond_js__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__symbol_star_js__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__symbol_square_js__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__symbol_triangle_js__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__symbol_wye_js__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constant_js__ = __webpack_require__(132);










var symbols = [
  __WEBPACK_IMPORTED_MODULE_1__symbol_circle_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_2__symbol_cross_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_3__symbol_diamond_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_5__symbol_square_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_4__symbol_star_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_6__symbol_triangle_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_7__symbol_wye_js__["a" /* default */]
];

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var type = Object(__WEBPACK_IMPORTED_MODULE_8__constant_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__symbol_circle_js__["a" /* default */]),
      size = Object(__WEBPACK_IMPORTED_MODULE_8__constant_js__["a" /* default */])(64),
      context = null;

  function symbol() {
    var buffer;
    if (!context) context = buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();
    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
    if (buffer) return context = null, buffer + "" || null;
  }

  symbol.type = function(_) {
    return arguments.length ? (type = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_8__constant_js__["a" /* default */])(_), symbol) : type;
  };

  symbol.size = function(_) {
    return arguments.length ? (size = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_8__constant_js__["a" /* default */])(+_), symbol) : size;
  };

  symbol.context = function(_) {
    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
  };

  return symbol;
});


/***/ }),
/* 2185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop_js__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis_js__ = __webpack_require__(260);



function BasisClosed(context) {
  this._context = context;
}

BasisClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop_js__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop_js__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2);
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
      default: Object(__WEBPACK_IMPORTED_MODULE_1__basis_js__["c" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new BasisClosed(context);
});


/***/ }),
/* 2186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis_js__ = __webpack_require__(260);


function BasisOpen(context) {
  this._context = context;
}

BasisOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
      case 3: this._point = 4; // proceed
      default: Object(__WEBPACK_IMPORTED_MODULE_0__basis_js__["c" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new BasisOpen(context);
});


/***/ }),
/* 2187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis_js__ = __webpack_require__(260);


function Bundle(context, beta) {
  this._basis = new __WEBPACK_IMPORTED_MODULE_0__basis_js__["a" /* Basis */](context);
  this._beta = beta;
}

Bundle.prototype = {
  lineStart: function() {
    this._x = [];
    this._y = [];
    this._basis.lineStart();
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        j = x.length - 1;

    if (j > 0) {
      var x0 = x[0],
          y0 = y[0],
          dx = x[j] - x0,
          dy = y[j] - y0,
          i = -1,
          t;

      while (++i <= j) {
        t = i / j;
        this._basis.point(
          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
        );
      }
    }

    this._x = this._y = null;
    this._basis.lineEnd();
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ((function custom(beta) {

  function bundle(context) {
    return beta === 1 ? new __WEBPACK_IMPORTED_MODULE_0__basis_js__["a" /* Basis */](context) : new Bundle(context, beta);
  }

  bundle.beta = function(beta) {
    return custom(+beta);
  };

  return bundle;
})(0.85));


/***/ }),
/* 2188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinalClosed_js__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noop_js__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__catmullRom_js__ = __webpack_require__(359);




function CatmullRomClosed(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_1__noop_js__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_1__noop_js__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: Object(__WEBPACK_IMPORTED_MODULE_2__catmullRom_js__["b" /* point */])(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomClosed(context, alpha) : new __WEBPACK_IMPORTED_MODULE_0__cardinalClosed_js__["a" /* CardinalClosed */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 2189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinalOpen_js__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__catmullRom_js__ = __webpack_require__(359);



function CatmullRomOpen(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: Object(__WEBPACK_IMPORTED_MODULE_1__catmullRom_js__["b" /* point */])(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomOpen(context, alpha) : new __WEBPACK_IMPORTED_MODULE_0__cardinalOpen_js__["a" /* CardinalOpen */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 2190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop_js__ = __webpack_require__(259);


function LinearClosed(context) {
  this._context = context;
}

LinearClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop_js__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop_js__["a" /* default */],
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._point) this._context.closePath();
  },
  point: function(x, y) {
    x = +x, y = +y;
    if (this._point) this._context.lineTo(x, y);
    else this._point = 1, this._context.moveTo(x, y);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new LinearClosed(context);
});


/***/ }),
/* 2191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = monotoneX;
/* harmony export (immutable) */ __webpack_exports__["b"] = monotoneY;
function sign(x) {
  return x < 0 ? -1 : 1;
}

// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
  var h0 = that._x1 - that._x0,
      h1 = x2 - that._x1,
      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
      p = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}

// Calculate a one-sided slope.
function slope2(that, t) {
  var h = that._x1 - that._x0;
  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}

// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point(that, t0, t1) {
  var x0 = that._x0,
      y0 = that._y0,
      x1 = that._x1,
      y1 = that._y1,
      dx = (x1 - x0) / 3;
  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}

function MonotoneX(context) {
  this._context = context;
}

MonotoneX.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 =
    this._t0 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x1, this._y1); break;
      case 3: point(this, this._t0, slope2(this, this._t0)); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    var t1 = NaN;

    x = +x, y = +y;
    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; point(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
      default: point(this, this._t0, t1 = slope3(this, x, y)); break;
    }

    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
    this._t0 = t1;
  }
}

function MonotoneY(context) {
  this._context = new ReflectContext(context);
}

(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
  MonotoneX.prototype.point.call(this, y, x);
};

function ReflectContext(context) {
  this._context = context;
}

ReflectContext.prototype = {
  moveTo: function(x, y) { this._context.moveTo(y, x); },
  closePath: function() { this._context.closePath(); },
  lineTo: function(x, y) { this._context.lineTo(y, x); },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
};

function monotoneX(context) {
  return new MonotoneX(context);
}

function monotoneY(context) {
  return new MonotoneY(context);
}


/***/ }),
/* 2192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function Natural(context) {
  this._context = context;
}

Natural.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [];
    this._y = [];
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        n = x.length;

    if (n) {
      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
      if (n === 2) {
        this._context.lineTo(x[1], y[1]);
      } else {
        var px = controlPoints(x),
            py = controlPoints(y);
        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
        }
      }
    }

    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
    this._line = 1 - this._line;
    this._x = this._y = null;
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
  var i,
      n = x.length - 1,
      m,
      a = new Array(n),
      b = new Array(n),
      r = new Array(n);
  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
  a[n - 1] = r[n - 1] / b[n - 1];
  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
  b[n - 1] = (x[n] + a[n - 1]) / 2;
  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
  return [a, b];
}

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new Natural(context);
});


/***/ }),
/* 2193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = stepBefore;
/* harmony export (immutable) */ __webpack_exports__["b"] = stepAfter;
function Step(context, t) {
  this._context = context;
  this._t = t;
}

Step.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: {
        if (this._t <= 0) {
          this._context.lineTo(this._x, y);
          this._context.lineTo(x, y);
        } else {
          var x1 = this._x * (1 - this._t) + x * this._t;
          this._context.lineTo(x1, this._y);
          this._context.lineTo(x1, y);
        }
        break;
      }
    }
    this._x = x, this._y = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new Step(context, 0.5);
});

function stepBefore(context) {
  return new Step(context, 0);
}

function stepAfter(context) {
  return new Step(context, 1);
}


/***/ }),
/* 2194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array_js__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant_js__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__offset_none_js__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__order_none_js__ = __webpack_require__(200);





function stackValue(d, key) {
  return d[key];
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var keys = Object(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])([]),
      order = __WEBPACK_IMPORTED_MODULE_3__order_none_js__["a" /* default */],
      offset = __WEBPACK_IMPORTED_MODULE_2__offset_none_js__["a" /* default */],
      value = stackValue;

  function stack(data) {
    var kz = keys.apply(this, arguments),
        i,
        m = data.length,
        n = kz.length,
        sz = new Array(n),
        oz;

    for (i = 0; i < n; ++i) {
      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
        si[j] = sij = [0, +value(data[j], ki, j, data)];
        sij.data = data[j];
      }
      si.key = ki;
    }

    for (i = 0, oz = order(sz); i < n; ++i) {
      sz[oz[i]].index = i;
    }

    offset(sz, oz);
    return sz;
  }

  stack.keys = function(_) {
    return arguments.length ? (keys = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* slice */].call(_)), stack) : keys;
  };

  stack.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(+_), stack) : value;
  };

  stack.order = function(_) {
    return arguments.length ? (order = _ == null ? __WEBPACK_IMPORTED_MODULE_3__order_none_js__["a" /* default */] : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* slice */].call(_)), stack) : order;
  };

  stack.offset = function(_) {
    return arguments.length ? (offset = _ == null ? __WEBPACK_IMPORTED_MODULE_2__offset_none_js__["a" /* default */] : _, stack) : offset;
  };

  return stack;
});


/***/ }),
/* 2195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none_js__ = __webpack_require__(199);


/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__none_js__["a" /* default */])(series, order);
});


/***/ }),
/* 2196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
    for (yp = yn = 0, i = 0; i < n; ++i) {
      if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) {
        d[0] = yp, d[1] = yp += dy;
      } else if (dy < 0) {
        d[1] = yn, d[0] = yn += dy;
      } else {
        d[0] = 0, d[1] = dy;
      }
    }
  }
});


/***/ }),
/* 2197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none_js__ = __webpack_require__(199);


/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
    s0[j][1] += s0[j][0] = -y / 2;
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__none_js__["a" /* default */])(series, order);
});


/***/ }),
/* 2198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none_js__ = __webpack_require__(199);


/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
      var si = series[order[i]],
          sij0 = si[j][1] || 0,
          sij1 = si[j - 1][1] || 0,
          s3 = (sij0 - sij1) / 2;
      for (var k = 0; k < i; ++k) {
        var sk = series[order[k]],
            skj0 = sk[j][1] || 0,
            skj1 = sk[j - 1][1] || 0;
        s3 += skj0 - skj1;
      }
      s1 += sij0, s2 += s3 * sij0;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    if (s1) y -= s2 / s1;
  }
  s0[j - 1][1] += s0[j - 1][0] = y;
  Object(__WEBPACK_IMPORTED_MODULE_0__none_js__["a" /* default */])(series, order);
});


/***/ }),
/* 2199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending_js__ = __webpack_require__(360);


/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__ascending_js__["a" /* default */])(series).reverse();
});


/***/ }),
/* 2200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appearance_js__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending_js__ = __webpack_require__(360);



/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  var n = series.length,
      i,
      j,
      sums = series.map(__WEBPACK_IMPORTED_MODULE_1__ascending_js__["b" /* sum */]),
      order = Object(__WEBPACK_IMPORTED_MODULE_0__appearance_js__["a" /* default */])(series),
      top = 0,
      bottom = 0,
      tops = [],
      bottoms = [];

  for (i = 0; i < n; ++i) {
    j = order[i];
    if (top < bottom) {
      top += sums[j];
      tops.push(j);
    } else {
      bottom += sums[j];
      bottoms.push(j);
    }
  }

  return bottoms.reverse().concat(tops);
});


/***/ }),
/* 2201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none_js__ = __webpack_require__(200);


/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__none_js__["a" /* default */])(series).reverse();
});


/***/ }),
/* 2202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_shape__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__animation__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__theme__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_series_utils__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_react_utils__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__abstract_series__ = __webpack_require__(48);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.












var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--line';

var AreaSeries = function (_AbstractSeries) {
  _inherits(AreaSeries, _AbstractSeries);

  function AreaSeries() {
    _classCallCheck(this, AreaSeries);

    return _possibleConstructorReturn(this, (AreaSeries.__proto__ || Object.getPrototypeOf(AreaSeries)).apply(this, arguments));
  }

  _createClass(AreaSeries, [{
    key: '_renderArea',
    value: function _renderArea(data, x, y0, y, curve, getNull) {
      var area = __WEBPACK_IMPORTED_MODULE_2_d3_shape__["area"]();
      if (curve !== null) {
        if (typeof curve === 'string' && __WEBPACK_IMPORTED_MODULE_2_d3_shape__[curve]) {
          area = area.curve(__WEBPACK_IMPORTED_MODULE_2_d3_shape__[curve]);
        } else if (typeof curve === 'function') {
          area = area.curve(curve);
        }
      }
      area = area.defined(getNull);
      area = area.x(x).y0(y0).y1(y);
      return area(data);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          animation = _props.animation,
          className = _props.className,
          curve = _props.curve,
          data = _props.data,
          marginLeft = _props.marginLeft,
          marginTop = _props.marginTop,
          style = _props.style;


      if (this.props.nullAccessor) {
        Object(__WEBPACK_IMPORTED_MODULE_6__utils_react_utils__["b" /* warning */])('nullAccessor has been renamed to getNull', true);
      }

      if (!data) {
        return null;
      }

      if (animation) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__animation__["b" /* default */],
          _extends({}, this.props, { animatedProps: __WEBPACK_IMPORTED_MODULE_5__utils_series_utils__["a" /* ANIMATED_SERIES_PROPS */] }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AreaSeries, _extends({}, this.props, { animation: null }))
        );
      }

      var x = this._getAttributeFunctor('x');
      var y = this._getAttributeFunctor('y');
      var y0 = this._getAttr0Functor('y');
      var stroke = this._getAttributeValue('stroke') || this._getAttributeValue('color');
      var fill = this._getAttributeValue('fill') || this._getAttributeValue('color');
      var newOpacity = this._getAttributeValue('opacity');
      var opacity = Number.isFinite(newOpacity) ? newOpacity : __WEBPACK_IMPORTED_MODULE_4__theme__["c" /* DEFAULT_OPACITY */];
      var getNull = this.props.nullAccessor || this.props.getNull;
      var d = this._renderArea(data, x, y0, y, curve, getNull);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
        d: d,
        className: predefinedClassName + ' ' + className,
        transform: 'translate(' + marginLeft + ',' + marginTop + ')',
        onMouseOver: this._seriesMouseOverHandler,
        onMouseOut: this._seriesMouseOutHandler,
        onClick: this._seriesClickHandler,
        onContextMenu: this._seriesRightClickHandler,
        style: _extends({
          opacity: opacity,
          stroke: stroke,
          fill: fill
        }, style)
      });
    }
  }]);

  return AreaSeries;
}(__WEBPACK_IMPORTED_MODULE_7__abstract_series__["a" /* default */]);

AreaSeries.displayName = 'AreaSeries';
AreaSeries.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_7__abstract_series__["a" /* default */].propTypes, {
  getNull: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
});
AreaSeries.defaultProps = _extends({}, __WEBPACK_IMPORTED_MODULE_7__abstract_series__["a" /* default */].defaultProps, {
  getNull: function getNull() {
    return true;
  }
});

/* unused harmony default export */ var _unused_webpack_default_export = (AreaSeries);

/***/ }),
/* 2203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.





var propTypes = {
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    bottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    left: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    right: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }),
  // supplied by xyplot
  marginTop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  marginBottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  marginLeft: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  marginRight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  innerWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  innerHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

var CLASSES = {
  bottom: 'rv-xy-plot__borders-bottom',
  container: 'rv-xy-plot__borders',
  left: 'rv-xy-plot__borders-left',
  right: 'rv-xy-plot__borders-right',
  top: 'rv-xy-plot__borders-top'
};

function Borders(props) {
  var marginTop = props.marginTop,
      marginBottom = props.marginBottom,
      marginLeft = props.marginLeft,
      marginRight = props.marginRight,
      innerWidth = props.innerWidth,
      innerHeight = props.innerHeight,
      style = props.style,
      className = props.className;

  var height = innerHeight + marginTop + marginBottom;
  var width = innerWidth + marginLeft + marginRight;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'g',
    { className: CLASSES.container + ' ' + className },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', {
      className: CLASSES.bottom + ' ' + className + '-bottom',
      style: _extends({}, style.all, style.bottom),
      x: 0,
      y: height - marginBottom,
      width: width,
      height: marginBottom
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', {
      className: CLASSES.left + ' ' + className + '-left',
      style: _extends({}, style.all, style.left),
      x: 0,
      y: 0,
      width: marginLeft,
      height: height
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', {
      className: CLASSES.right + ' ' + className + '-right',
      style: _extends({}, style.all, style.right),
      x: width - marginRight,
      y: 0,
      width: marginRight,
      height: height
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', {
      className: CLASSES.top + ' ' + className + '-top',
      style: _extends({}, style.all, style.top),
      x: 0,
      y: 0,
      width: width,
      height: marginTop
    })
  );
}

Borders.displayName = 'Borders';
Borders.defaultProps = {
  className: '',
  style: {
    all: {},
    bottom: {},
    left: {},
    right: {},
    top: {}
  }
};
Borders.propTypes = propTypes;
Borders.requiresSVG = true;

/* unused harmony default export */ var _unused_webpack_default_export = (Borders);

/***/ }),
/* 2204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2018 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.





var ChartLabel = function (_React$PureComponent) {
  _inherits(ChartLabel, _React$PureComponent);

  function ChartLabel() {
    _classCallCheck(this, ChartLabel);

    return _possibleConstructorReturn(this, (ChartLabel.__proto__ || Object.getPrototypeOf(ChartLabel)).apply(this, arguments));
  }

  _createClass(ChartLabel, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          innerHeight = _props.innerHeight,
          innerWidth = _props.innerWidth,
          marginBottom = _props.marginBottom,
          marginLeft = _props.marginLeft,
          marginRight = _props.marginRight,
          marginTop = _props.marginTop,
          className = _props.className,
          includeMargin = _props.includeMargin,
          style = _props.style,
          text = _props.text,
          xPercent = _props.xPercent,
          yPercent = _props.yPercent;

      var width = innerWidth + (includeMargin ? marginLeft + marginRight : 0);
      var height = innerHeight + (includeMargin ? marginTop + marginBottom : 0);
      var xPos = width * xPercent + (includeMargin ? 0 : marginLeft);
      var yPos = height * yPercent + (includeMargin ? marginLeft : 0);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        {
          transform: 'translate(' + xPos + ', ' + yPos + ')',
          className: 'rv-xy-plot__axis__title ' + className },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'text',
          style,
          text
        )
      );
    }
  }], [{
    key: 'requiresSVG',
    get: function get() {
      return true;
    }
  }]);

  return ChartLabel;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

ChartLabel.displayName = 'ChartLabel';
ChartLabel.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  includeMargin: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  xPercent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  yPercent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};
ChartLabel.defaultProps = {
  className: '',
  includeMargin: true,
  text: '',
  xPercent: 0,
  yPercent: 0,
  style: {}
};
/* unused harmony default export */ var _unused_webpack_default_export = (ChartLabel);

/***/ }),
/* 2205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_scales_utils__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__animation__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_axis_utils__ = __webpack_require__(82);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.










var animatedProps = ['xRange', 'yRange', 'xDomain', 'yDomain', 'width', 'height', 'marginLeft', 'marginTop', 'marginRight', 'marginBottom', 'tickTotal'];

var CircularGridLines = function (_PureComponent) {
  _inherits(CircularGridLines, _PureComponent);

  function CircularGridLines() {
    _classCallCheck(this, CircularGridLines);

    return _possibleConstructorReturn(this, (CircularGridLines.__proto__ || Object.getPrototypeOf(CircularGridLines)).apply(this, arguments));
  }

  _createClass(CircularGridLines, [{
    key: '_getDefaultProps',
    value: function _getDefaultProps() {
      var _props = this.props,
          innerWidth = _props.innerWidth,
          innerHeight = _props.innerHeight,
          marginTop = _props.marginTop,
          marginLeft = _props.marginLeft;

      return {
        left: marginLeft,
        top: marginTop,
        width: innerWidth,
        height: innerHeight,
        style: {},
        tickTotal: Object(__WEBPACK_IMPORTED_MODULE_4__utils_axis_utils__["f" /* getTicksTotalFromSize */])(Math.min(innerWidth, innerHeight))
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          animation = _props2.animation,
          centerX = _props2.centerX,
          centerY = _props2.centerY;

      if (animation) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__animation__["b" /* default */],
          _extends({}, this.props, { animatedProps: animatedProps }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CircularGridLines, _extends({}, this.props, { animation: null }))
        );
      }

      var props = _extends({}, this._getDefaultProps(), this.props);

      var tickTotal = props.tickTotal,
          tickValues = props.tickValues,
          marginLeft = props.marginLeft,
          marginTop = props.marginTop,
          rRange = props.rRange,
          style = props.style;


      var xScale = Object(__WEBPACK_IMPORTED_MODULE_2__utils_scales_utils__["d" /* getAttributeScale */])(props, 'x');
      var yScale = Object(__WEBPACK_IMPORTED_MODULE_2__utils_scales_utils__["d" /* getAttributeScale */])(props, 'y');
      var values = Object(__WEBPACK_IMPORTED_MODULE_4__utils_axis_utils__["e" /* getTickValues */])(xScale, tickTotal, tickValues);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        {
          transform: 'translate(' + (xScale(centerX) + marginLeft) + ',' + (yScale(centerY) + marginTop) + ')',
          className: 'rv-xy-plot__circular-grid-lines'
        },
        values.reduce(function (res, value, index) {
          var radius = xScale(value);
          if (rRange && (radius < rRange[0] || radius > rRange[1])) {
            return res;
          }
          return res.concat([__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle', _extends({ cx: 0, cy: 0, r: radius }, {
            key: index,
            className: 'rv-xy-plot__circular-grid-lines__line',
            style: style
          }))]);
        }, [])
      );
    }
  }]);

  return CircularGridLines;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

CircularGridLines.displayName = 'CircularGridLines';
CircularGridLines.propTypes = {
  centerX: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  centerY: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  left: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  rRange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number),

  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  tickValues: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number),
  tickTotal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  animation: __WEBPACK_IMPORTED_MODULE_3__animation__["a" /* AnimationPropType */],
  // generally supplied by xyplot
  marginTop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  marginBottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  marginLeft: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  marginRight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  innerWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  innerHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};
CircularGridLines.defaultProps = {
  centerX: 0,
  centerY: 0
};
CircularGridLines.requiresSVG = true;

/* unused harmony default export */ var _unused_webpack_default_export = (CircularGridLines);

/***/ }),
/* 2206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_contour__ = __webpack_require__(2207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_geo__ = __webpack_require__(2214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_scale__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__abstract_series__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__animation__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_series_utils__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__theme__ = __webpack_require__(63);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.












var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--contour';

function getDomain(data) {
  return data.reduce(function (acc, row) {
    return {
      min: Math.min(acc.min, row.value),
      max: Math.max(acc.max, row.value)
    };
  }, { min: Infinity, max: -Infinity });
}

var ContourSeries = function (_AbstractSeries) {
  _inherits(ContourSeries, _AbstractSeries);

  function ContourSeries() {
    _classCallCheck(this, ContourSeries);

    return _possibleConstructorReturn(this, (ContourSeries.__proto__ || Object.getPrototypeOf(ContourSeries)).apply(this, arguments));
  }

  _createClass(ContourSeries, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          animation = _props.animation,
          bandwidth = _props.bandwidth,
          className = _props.className,
          colorRange = _props.colorRange,
          data = _props.data,
          innerHeight = _props.innerHeight,
          innerWidth = _props.innerWidth,
          marginLeft = _props.marginLeft,
          marginTop = _props.marginTop,
          style = _props.style;


      if (!data || !innerWidth || !innerHeight) {
        return null;
      }

      if (animation) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6__animation__["b" /* default */],
          _extends({}, this.props, { animatedProps: __WEBPACK_IMPORTED_MODULE_7__utils_series_utils__["a" /* ANIMATED_SERIES_PROPS */] }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContourSeries, _extends({}, this.props, { animation: null }))
        );
      }

      var x = this._getAttributeFunctor('x');
      var y = this._getAttributeFunctor('y');

      var contouredData = Object(__WEBPACK_IMPORTED_MODULE_2_d3_contour__["a" /* contourDensity */])().x(function (d) {
        return x(d);
      }).y(function (d) {
        return y(d);
      }).size([innerWidth, innerHeight]).bandwidth(bandwidth)(data);

      var geo = Object(__WEBPACK_IMPORTED_MODULE_3_d3_geo__["a" /* geoPath */])();

      var _getDomain = getDomain(contouredData),
          min = _getDomain.min,
          max = _getDomain.max;

      var colorScale = Object(__WEBPACK_IMPORTED_MODULE_4_d3_scale__["a" /* scaleLinear */])().domain([min, max]).range(colorRange || __WEBPACK_IMPORTED_MODULE_8__theme__["a" /* CONTINUOUS_COLOR_RANGE */]);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        {
          className: predefinedClassName + ' ' + className,
          transform: 'translate(' + marginLeft + ',' + marginTop + ')'
        },
        contouredData.map(function (polygon, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
            className: 'rv-xy-plot__series--contour-line',
            key: 'rv-xy-plot__series--contour-line-' + index,
            d: geo(polygon),
            style: _extends({
              fill: colorScale(polygon.value)
            }, style)
          });
        })
      );
    }
  }]);

  return ContourSeries;
}(__WEBPACK_IMPORTED_MODULE_5__abstract_series__["a" /* default */]);

ContourSeries.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_5__abstract_series__["a" /* default */].propTypes, {
  animation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  bandwidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  marginLeft: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  marginTop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
});

ContourSeries.defaultProps = _extends({}, __WEBPACK_IMPORTED_MODULE_5__abstract_series__["a" /* default */].defaultProps, {
  bandwidth: 40,
  style: {}
});

/* unused harmony default export */ var _unused_webpack_default_export = (ContourSeries);

/***/ }),
/* 2207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contours__ = __webpack_require__(600);
/* unused harmony reexport contours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__density__ = __webpack_require__(2212);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__density__["a"]; });




/***/ }),
/* 2208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a - b;
});


/***/ }),
/* 2209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(ring) {
  var i = 0, n = ring.length, area = ring[n - 1][1] * ring[0][0] - ring[n - 1][0] * ring[0][1];
  while (++i < n) area += ring[i - 1][1] * ring[i][0] - ring[i - 1][0] * ring[i][1];
  return area;
});


/***/ }),
/* 2210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(ring, hole) {
  var i = -1, n = hole.length, c;
  while (++i < n) if (c = ringContains(ring, hole[i])) return c;
  return 0;
});

function ringContains(ring, point) {
  var x = point[0], y = point[1], contains = -1;
  for (var i = 0, n = ring.length, j = n - 1; i < n; j = i++) {
    var pi = ring[i], xi = pi[0], yi = pi[1], pj = ring[j], xj = pj[0], yj = pj[1];
    if (segmentContains(pi, pj, point)) return 0;
    if (((yi > y) !== (yj > y)) && ((x < (xj - xi) * (y - yi) / (yj - yi) + xi))) contains = -contains;
  }
  return contains;
}

function segmentContains(a, b, c) {
  var i; return collinear(a, b, c) && within(a[i = +(a[0] === b[0])], c[i], b[i]);
}

function collinear(a, b, c) {
  return (b[0] - a[0]) * (c[1] - a[1]) === (c[0] - a[0]) * (b[1] - a[1]);
}

function within(p, q, r) {
  return p <= q && q <= r || r <= q && q <= p;
}


/***/ }),
/* 2211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {});


/***/ }),
/* 2212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__blur__ = __webpack_require__(2213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__contours__ = __webpack_require__(600);






function defaultX(d) {
  return d[0];
}

function defaultY(d) {
  return d[1];
}

function defaultWeight() {
  return 1;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x = defaultX,
      y = defaultY,
      weight = defaultWeight,
      dx = 960,
      dy = 500,
      r = 20, // blur radius
      k = 2, // log2(grid cell size)
      o = r * 3, // grid offset, to pad for blur
      n = (dx + o * 2) >> k, // grid width
      m = (dy + o * 2) >> k, // grid height
      threshold = Object(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(20);

  function density(data) {
    var values0 = new Float32Array(n * m),
        values1 = new Float32Array(n * m);

    data.forEach(function(d, i, data) {
      var xi = (+x(d, i, data) + o) >> k,
          yi = (+y(d, i, data) + o) >> k,
          wi = +weight(d, i, data);
      if (xi >= 0 && xi < n && yi >= 0 && yi < m) {
        values0[xi + yi * n] += wi;
      }
    });

    // TODO Optimize.
    Object(__WEBPACK_IMPORTED_MODULE_2__blur__["a" /* blurX */])({width: n, height: m, data: values0}, {width: n, height: m, data: values1}, r >> k);
    Object(__WEBPACK_IMPORTED_MODULE_2__blur__["b" /* blurY */])({width: n, height: m, data: values1}, {width: n, height: m, data: values0}, r >> k);
    Object(__WEBPACK_IMPORTED_MODULE_2__blur__["a" /* blurX */])({width: n, height: m, data: values0}, {width: n, height: m, data: values1}, r >> k);
    Object(__WEBPACK_IMPORTED_MODULE_2__blur__["b" /* blurY */])({width: n, height: m, data: values1}, {width: n, height: m, data: values0}, r >> k);
    Object(__WEBPACK_IMPORTED_MODULE_2__blur__["a" /* blurX */])({width: n, height: m, data: values0}, {width: n, height: m, data: values1}, r >> k);
    Object(__WEBPACK_IMPORTED_MODULE_2__blur__["b" /* blurY */])({width: n, height: m, data: values1}, {width: n, height: m, data: values0}, r >> k);

    var tz = threshold(values0);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      var stop = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["e" /* max */])(values0);
      tz = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["m" /* tickStep */])(0, stop, tz);
      tz = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["i" /* range */])(0, Math.floor(stop / tz) * tz, tz);
      tz.shift();
    }

    return Object(__WEBPACK_IMPORTED_MODULE_4__contours__["a" /* default */])()
        .thresholds(tz)
        .size([n, m])
      (values0)
        .map(transform);
  }

  function transform(geometry) {
    geometry.value *= Math.pow(2, -2 * k); // Density in points per square pixel.
    geometry.coordinates.forEach(transformPolygon);
    return geometry;
  }

  function transformPolygon(coordinates) {
    coordinates.forEach(transformRing);
  }

  function transformRing(coordinates) {
    coordinates.forEach(transformPoint);
  }

  // TODO Optimize.
  function transformPoint(coordinates) {
    coordinates[0] = coordinates[0] * Math.pow(2, k) - o;
    coordinates[1] = coordinates[1] * Math.pow(2, k) - o;
  }

  function resize() {
    o = r * 3;
    n = (dx + o * 2) >> k;
    m = (dy + o * 2) >> k;
    return density;
  }

  density.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(+_), density) : x;
  };

  density.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(+_), density) : y;
  };

  density.weight = function(_) {
    return arguments.length ? (weight = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(+_), density) : weight;
  };

  density.size = function(_) {
    if (!arguments.length) return [dx, dy];
    var _0 = Math.ceil(_[0]), _1 = Math.ceil(_[1]);
    if (!(_0 >= 0) && !(_0 >= 0)) throw new Error("invalid size");
    return dx = _0, dy = _1, resize();
  };

  density.cellSize = function(_) {
    if (!arguments.length) return 1 << k;
    if (!((_ = +_) >= 1)) throw new Error("invalid cell size");
    return k = Math.floor(Math.log(_) / Math.LN2), resize();
  };

  density.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? Object(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__array__["a" /* slice */].call(_)) : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(_), density) : threshold;
  };

  density.bandwidth = function(_) {
    if (!arguments.length) return Math.sqrt(r * (r + 1));
    if (!((_ = +_) >= 0)) throw new Error("invalid bandwidth");
    return r = Math.round((Math.sqrt(4 * _ * _ + 1) - 1) / 2), resize();
  };

  return density;
});


/***/ }),
/* 2213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = blurX;
/* harmony export (immutable) */ __webpack_exports__["b"] = blurY;
// TODO Optimize edge cases.
// TODO Optimize index calculation.
// TODO Optimize arguments.
function blurX(source, target, r) {
  var n = source.width,
      m = source.height,
      w = (r << 1) + 1;
  for (var j = 0; j < m; ++j) {
    for (var i = 0, sr = 0; i < n + r; ++i) {
      if (i < n) {
        sr += source.data[i + j * n];
      }
      if (i >= r) {
        if (i >= w) {
          sr -= source.data[i - w + j * n];
        }
        target.data[i - r + j * n] = sr / Math.min(i + 1, n - 1 + w - i, w);
      }
    }
  }
}

// TODO Optimize edge cases.
// TODO Optimize index calculation.
// TODO Optimize arguments.
function blurY(source, target, r) {
  var n = source.width,
      m = source.height,
      w = (r << 1) + 1;
  for (var i = 0; i < n; ++i) {
    for (var j = 0, sr = 0; j < m + r; ++j) {
      if (j < m) {
        sr += source.data[i + j * n];
      }
      if (j >= r) {
        if (j >= w) {
          sr -= source.data[i + (j - w) * n];
        }
        target.data[i + (j - r) * n] = sr / Math.min(j + 1, m - 1 + w - j, w);
      }
    }
  }
}


/***/ }),
/* 2214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__area_js__ = __webpack_require__(603);
/* unused harmony reexport geoArea */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bounds_js__ = __webpack_require__(2215);
/* unused harmony reexport geoBounds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__centroid_js__ = __webpack_require__(2216);
/* unused harmony reexport geoCentroid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__circle_js__ = __webpack_require__(604);
/* unused harmony reexport geoCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__clip_antimeridian_js__ = __webpack_require__(606);
/* unused harmony reexport geoClipAntimeridian */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__clip_circle_js__ = __webpack_require__(612);
/* unused harmony reexport geoClipCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__clip_extent_js__ = __webpack_require__(2218);
/* unused harmony reexport geoClipExtent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__clip_rectangle_js__ = __webpack_require__(263);
/* unused harmony reexport geoClipRectangle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__contains_js__ = __webpack_require__(2220);
/* unused harmony reexport geoContains */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__distance_js__ = __webpack_require__(613);
/* unused harmony reexport geoDistance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__graticule_js__ = __webpack_require__(2221);
/* unused harmony reexport geoGraticule */
/* unused harmony reexport geoGraticule10 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__interpolate_js__ = __webpack_require__(2222);
/* unused harmony reexport geoInterpolate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__length_js__ = __webpack_require__(614);
/* unused harmony reexport geoLength */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__path_index_js__ = __webpack_require__(2223);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_13__path_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__projection_albers_js__ = __webpack_require__(616);
/* unused harmony reexport geoAlbers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__projection_albersUsa_js__ = __webpack_require__(2231);
/* unused harmony reexport geoAlbersUsa */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__projection_azimuthalEqualArea_js__ = __webpack_require__(2232);
/* unused harmony reexport geoAzimuthalEqualArea */
/* unused harmony reexport geoAzimuthalEqualAreaRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__projection_azimuthalEquidistant_js__ = __webpack_require__(2233);
/* unused harmony reexport geoAzimuthalEquidistant */
/* unused harmony reexport geoAzimuthalEquidistantRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__projection_conicConformal_js__ = __webpack_require__(2234);
/* unused harmony reexport geoConicConformal */
/* unused harmony reexport geoConicConformalRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__projection_conicEqualArea_js__ = __webpack_require__(362);
/* unused harmony reexport geoConicEqualArea */
/* unused harmony reexport geoConicEqualAreaRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__projection_conicEquidistant_js__ = __webpack_require__(2235);
/* unused harmony reexport geoConicEquidistant */
/* unused harmony reexport geoConicEquidistantRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__projection_equalEarth_js__ = __webpack_require__(2236);
/* unused harmony reexport geoEqualEarth */
/* unused harmony reexport geoEqualEarthRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__projection_equirectangular_js__ = __webpack_require__(617);
/* unused harmony reexport geoEquirectangular */
/* unused harmony reexport geoEquirectangularRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__projection_gnomonic_js__ = __webpack_require__(2237);
/* unused harmony reexport geoGnomonic */
/* unused harmony reexport geoGnomonicRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__projection_identity_js__ = __webpack_require__(2238);
/* unused harmony reexport geoIdentity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__projection_index_js__ = __webpack_require__(86);
/* unused harmony reexport geoProjection */
/* unused harmony reexport geoProjectionMutator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__projection_mercator_js__ = __webpack_require__(365);
/* unused harmony reexport geoMercator */
/* unused harmony reexport geoMercatorRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__projection_naturalEarth1_js__ = __webpack_require__(2239);
/* unused harmony reexport geoNaturalEarth1 */
/* unused harmony reexport geoNaturalEarth1Raw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__projection_orthographic_js__ = __webpack_require__(2240);
/* unused harmony reexport geoOrthographic */
/* unused harmony reexport geoOrthographicRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__projection_stereographic_js__ = __webpack_require__(2241);
/* unused harmony reexport geoStereographic */
/* unused harmony reexport geoStereographicRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__projection_transverseMercator_js__ = __webpack_require__(2242);
/* unused harmony reexport geoTransverseMercator */
/* unused harmony reexport geoTransverseMercatorRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__rotation_js__ = __webpack_require__(262);
/* unused harmony reexport geoRotation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__stream_js__ = __webpack_require__(133);
/* unused harmony reexport geoStream */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__transform_js__ = __webpack_require__(264);
/* unused harmony reexport geoTransform */






 // DEPRECATED! Use d3.geoIdentity().clipExtent(…).





























/***/ }),
/* 2215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder_js__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__area_js__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cartesian_js__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__math_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stream_js__ = __webpack_require__(133);






var lambda0, phi0, lambda1, phi1, // bounds
    lambda2, // previous lambda-coordinate
    lambda00, phi00, // first point
    p0, // previous 3D point
    deltaSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder_js__["a" /* default */])(),
    ranges,
    range;

var boundsStream = {
  point: boundsPoint,
  lineStart: boundsLineStart,
  lineEnd: boundsLineEnd,
  polygonStart: function() {
    boundsStream.point = boundsRingPoint;
    boundsStream.lineStart = boundsRingStart;
    boundsStream.lineEnd = boundsRingEnd;
    deltaSum.reset();
    __WEBPACK_IMPORTED_MODULE_1__area_js__["b" /* areaStream */].polygonStart();
  },
  polygonEnd: function() {
    __WEBPACK_IMPORTED_MODULE_1__area_js__["b" /* areaStream */].polygonEnd();
    boundsStream.point = boundsPoint;
    boundsStream.lineStart = boundsLineStart;
    boundsStream.lineEnd = boundsLineEnd;
    if (__WEBPACK_IMPORTED_MODULE_1__area_js__["a" /* areaRingSum */] < 0) lambda0 = -(lambda1 = 180), phi0 = -(phi1 = 90);
    else if (deltaSum > __WEBPACK_IMPORTED_MODULE_3__math_js__["i" /* epsilon */]) phi1 = 90;
    else if (deltaSum < -__WEBPACK_IMPORTED_MODULE_3__math_js__["i" /* epsilon */]) phi0 = -90;
    range[0] = lambda0, range[1] = lambda1;
  },
  sphere: function() {
    lambda0 = -(lambda1 = 180), phi0 = -(phi1 = 90);
  }
};

function boundsPoint(lambda, phi) {
  ranges.push(range = [lambda0 = lambda, lambda1 = lambda]);
  if (phi < phi0) phi0 = phi;
  if (phi > phi1) phi1 = phi;
}

function linePoint(lambda, phi) {
  var p = Object(__WEBPACK_IMPORTED_MODULE_2__cartesian_js__["a" /* cartesian */])([lambda * __WEBPACK_IMPORTED_MODULE_3__math_js__["r" /* radians */], phi * __WEBPACK_IMPORTED_MODULE_3__math_js__["r" /* radians */]]);
  if (p0) {
    var normal = Object(__WEBPACK_IMPORTED_MODULE_2__cartesian_js__["c" /* cartesianCross */])(p0, p),
        equatorial = [normal[1], -normal[0], 0],
        inflection = Object(__WEBPACK_IMPORTED_MODULE_2__cartesian_js__["c" /* cartesianCross */])(equatorial, normal);
    Object(__WEBPACK_IMPORTED_MODULE_2__cartesian_js__["e" /* cartesianNormalizeInPlace */])(inflection);
    inflection = Object(__WEBPACK_IMPORTED_MODULE_2__cartesian_js__["g" /* spherical */])(inflection);
    var delta = lambda - lambda2,
        sign = delta > 0 ? 1 : -1,
        lambdai = inflection[0] * __WEBPACK_IMPORTED_MODULE_3__math_js__["h" /* degrees */] * sign,
        phii,
        antimeridian = Object(__WEBPACK_IMPORTED_MODULE_3__math_js__["a" /* abs */])(delta) > 180;
    if (antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
      phii = inflection[1] * __WEBPACK_IMPORTED_MODULE_3__math_js__["h" /* degrees */];
      if (phii > phi1) phi1 = phii;
    } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
      phii = -inflection[1] * __WEBPACK_IMPORTED_MODULE_3__math_js__["h" /* degrees */];
      if (phii < phi0) phi0 = phii;
    } else {
      if (phi < phi0) phi0 = phi;
      if (phi > phi1) phi1 = phi;
    }
    if (antimeridian) {
      if (lambda < lambda2) {
        if (angle(lambda0, lambda) > angle(lambda0, lambda1)) lambda1 = lambda;
      } else {
        if (angle(lambda, lambda1) > angle(lambda0, lambda1)) lambda0 = lambda;
      }
    } else {
      if (lambda1 >= lambda0) {
        if (lambda < lambda0) lambda0 = lambda;
        if (lambda > lambda1) lambda1 = lambda;
      } else {
        if (lambda > lambda2) {
          if (angle(lambda0, lambda) > angle(lambda0, lambda1)) lambda1 = lambda;
        } else {
          if (angle(lambda, lambda1) > angle(lambda0, lambda1)) lambda0 = lambda;
        }
      }
    }
  } else {
    ranges.push(range = [lambda0 = lambda, lambda1 = lambda]);
  }
  if (phi < phi0) phi0 = phi;
  if (phi > phi1) phi1 = phi;
  p0 = p, lambda2 = lambda;
}

function boundsLineStart() {
  boundsStream.point = linePoint;
}

function boundsLineEnd() {
  range[0] = lambda0, range[1] = lambda1;
  boundsStream.point = boundsPoint;
  p0 = null;
}

function boundsRingPoint(lambda, phi) {
  if (p0) {
    var delta = lambda - lambda2;
    deltaSum.add(Object(__WEBPACK_IMPORTED_MODULE_3__math_js__["a" /* abs */])(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
  } else {
    lambda00 = lambda, phi00 = phi;
  }
  __WEBPACK_IMPORTED_MODULE_1__area_js__["b" /* areaStream */].point(lambda, phi);
  linePoint(lambda, phi);
}

function boundsRingStart() {
  __WEBPACK_IMPORTED_MODULE_1__area_js__["b" /* areaStream */].lineStart();
}

function boundsRingEnd() {
  boundsRingPoint(lambda00, phi00);
  __WEBPACK_IMPORTED_MODULE_1__area_js__["b" /* areaStream */].lineEnd();
  if (Object(__WEBPACK_IMPORTED_MODULE_3__math_js__["a" /* abs */])(deltaSum) > __WEBPACK_IMPORTED_MODULE_3__math_js__["i" /* epsilon */]) lambda0 = -(lambda1 = 180);
  range[0] = lambda0, range[1] = lambda1;
  p0 = null;
}

// Finds the left-right distance between two longitudes.
// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
// the distance between ±180° to be 360°.
function angle(lambda0, lambda1) {
  return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
}

function rangeCompare(a, b) {
  return a[0] - b[0];
}

function rangeContains(range, x) {
  return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(feature) {
  var i, n, a, b, merged, deltaMax, delta;

  phi1 = lambda1 = -(lambda0 = phi0 = Infinity);
  ranges = [];
  Object(__WEBPACK_IMPORTED_MODULE_4__stream_js__["a" /* default */])(feature, boundsStream);

  // First, sort ranges by their minimum longitudes.
  if (n = ranges.length) {
    ranges.sort(rangeCompare);

    // Then, merge any ranges that overlap.
    for (i = 1, a = ranges[0], merged = [a]; i < n; ++i) {
      b = ranges[i];
      if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
        if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
        if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
      } else {
        merged.push(a = b);
      }
    }

    // Finally, find the largest gap between the merged ranges.
    // The final bounding box will be the inverse of this gap.
    for (deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i) {
      b = merged[i];
      if ((delta = angle(a[1], b[0])) > deltaMax) deltaMax = delta, lambda0 = b[0], lambda1 = a[1];
    }
  }

  ranges = range = null;

  return lambda0 === Infinity || phi0 === Infinity
      ? [[NaN, NaN], [NaN, NaN]]
      : [[lambda0, phi0], [lambda1, phi1]];
});


/***/ }),
/* 2216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noop_js__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stream_js__ = __webpack_require__(133);




var W0, W1,
    X0, Y0, Z0,
    X1, Y1, Z1,
    X2, Y2, Z2,
    lambda00, phi00, // first point
    x0, y0, z0; // previous point

var centroidStream = {
  sphere: __WEBPACK_IMPORTED_MODULE_1__noop_js__["a" /* default */],
  point: centroidPoint,
  lineStart: centroidLineStart,
  lineEnd: centroidLineEnd,
  polygonStart: function() {
    centroidStream.lineStart = centroidRingStart;
    centroidStream.lineEnd = centroidRingEnd;
  },
  polygonEnd: function() {
    centroidStream.lineStart = centroidLineStart;
    centroidStream.lineEnd = centroidLineEnd;
  }
};

// Arithmetic mean of Cartesian vectors.
function centroidPoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math_js__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math_js__["r" /* radians */];
  var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["g" /* cos */])(phi);
  centroidPointCartesian(cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["g" /* cos */])(lambda), cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["t" /* sin */])(lambda), Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["t" /* sin */])(phi));
}

function centroidPointCartesian(x, y, z) {
  ++W0;
  X0 += (x - X0) / W0;
  Y0 += (y - Y0) / W0;
  Z0 += (z - Z0) / W0;
}

function centroidLineStart() {
  centroidStream.point = centroidLinePointFirst;
}

function centroidLinePointFirst(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math_js__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math_js__["r" /* radians */];
  var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["g" /* cos */])(phi);
  x0 = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["g" /* cos */])(lambda);
  y0 = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["t" /* sin */])(lambda);
  z0 = Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["t" /* sin */])(phi);
  centroidStream.point = centroidLinePoint;
  centroidPointCartesian(x0, y0, z0);
}

function centroidLinePoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math_js__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math_js__["r" /* radians */];
  var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["g" /* cos */])(phi),
      x = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["g" /* cos */])(lambda),
      y = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["t" /* sin */])(lambda),
      z = Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["t" /* sin */])(phi),
      w = Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["e" /* atan2 */])(Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["u" /* sqrt */])((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
  W1 += w;
  X1 += w * (x0 + (x0 = x));
  Y1 += w * (y0 + (y0 = y));
  Z1 += w * (z0 + (z0 = z));
  centroidPointCartesian(x0, y0, z0);
}

function centroidLineEnd() {
  centroidStream.point = centroidPoint;
}

// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
// J. Applied Mechanics 42, 239 (1975).
function centroidRingStart() {
  centroidStream.point = centroidRingPointFirst;
}

function centroidRingEnd() {
  centroidRingPoint(lambda00, phi00);
  centroidStream.point = centroidPoint;
}

function centroidRingPointFirst(lambda, phi) {
  lambda00 = lambda, phi00 = phi;
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math_js__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math_js__["r" /* radians */];
  centroidStream.point = centroidRingPoint;
  var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["g" /* cos */])(phi);
  x0 = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["g" /* cos */])(lambda);
  y0 = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["t" /* sin */])(lambda);
  z0 = Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["t" /* sin */])(phi);
  centroidPointCartesian(x0, y0, z0);
}

function centroidRingPoint(lambda, phi) {
  lambda *= __WEBPACK_IMPORTED_MODULE_0__math_js__["r" /* radians */], phi *= __WEBPACK_IMPORTED_MODULE_0__math_js__["r" /* radians */];
  var cosPhi = Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["g" /* cos */])(phi),
      x = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["g" /* cos */])(lambda),
      y = cosPhi * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["t" /* sin */])(lambda),
      z = Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["t" /* sin */])(phi),
      cx = y0 * z - z0 * y,
      cy = z0 * x - x0 * z,
      cz = x0 * y - y0 * x,
      m = Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["u" /* sqrt */])(cx * cx + cy * cy + cz * cz),
      w = Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["c" /* asin */])(m), // line weight = angle
      v = m && -w / m; // area weight multiplier
  X2 += v * cx;
  Y2 += v * cy;
  Z2 += v * cz;
  W1 += w;
  X1 += w * (x0 + (x0 = x));
  Y1 += w * (y0 + (y0 = y));
  Z1 += w * (z0 + (z0 = z));
  centroidPointCartesian(x0, y0, z0);
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(object) {
  W0 = W1 =
  X0 = Y0 = Z0 =
  X1 = Y1 = Z1 =
  X2 = Y2 = Z2 = 0;
  Object(__WEBPACK_IMPORTED_MODULE_2__stream_js__["a" /* default */])(object, centroidStream);

  var x = X2,
      y = Y2,
      z = Z2,
      m = x * x + y * y + z * z;

  // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
  if (m < __WEBPACK_IMPORTED_MODULE_0__math_js__["j" /* epsilon2 */]) {
    x = X1, y = Y1, z = Z1;
    // If the feature has zero length, fall back to arithmetic mean of point vectors.
    if (W1 < __WEBPACK_IMPORTED_MODULE_0__math_js__["i" /* epsilon */]) x = X0, y = Y0, z = Z0;
    m = x * x + y * y + z * z;
    // If the feature still has an undefined ccentroid, then return.
    if (m < __WEBPACK_IMPORTED_MODULE_0__math_js__["j" /* epsilon2 */]) return [NaN, NaN];
  }

  return [Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["e" /* atan2 */])(y, x) * __WEBPACK_IMPORTED_MODULE_0__math_js__["h" /* degrees */], Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["c" /* asin */])(z / Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["u" /* sqrt */])(m)) * __WEBPACK_IMPORTED_MODULE_0__math_js__["h" /* degrees */]];
});


/***/ }),
/* 2217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 2218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rectangle_js__ = __webpack_require__(263);


/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var x0 = 0,
      y0 = 0,
      x1 = 960,
      y1 = 500,
      cache,
      cacheStream,
      clip;

  return clip = {
    stream: function(stream) {
      return cache && cacheStream === stream ? cache : cache = Object(__WEBPACK_IMPORTED_MODULE_0__rectangle_js__["a" /* default */])(x0, y0, x1, y1)(cacheStream = stream);
    },
    extent: function(_) {
      return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [[x0, y0], [x1, y1]];
    }
  };
});


/***/ }),
/* 2219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b, x0, y0, x1, y1) {
  var ax = a[0],
      ay = a[1],
      bx = b[0],
      by = b[1],
      t0 = 0,
      t1 = 1,
      dx = bx - ax,
      dy = by - ay,
      r;

  r = x0 - ax;
  if (!dx && r > 0) return;
  r /= dx;
  if (dx < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dx > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = x1 - ax;
  if (!dx && r < 0) return;
  r /= dx;
  if (dx < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dx > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  r = y0 - ay;
  if (!dy && r > 0) return;
  r /= dy;
  if (dy < 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  } else if (dy > 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  }

  r = y1 - ay;
  if (!dy && r < 0) return;
  r /= dy;
  if (dy < 0) {
    if (r > t1) return;
    if (r > t0) t0 = r;
  } else if (dy > 0) {
    if (r < t0) return;
    if (r < t1) t1 = r;
  }

  if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
  if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
  return true;
});


/***/ }),
/* 2220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polygonContains_js__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__distance_js__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math_js__ = __webpack_require__(36);




var containsObjectType = {
  Feature: function(object, point) {
    return containsGeometry(object.geometry, point);
  },
  FeatureCollection: function(object, point) {
    var features = object.features, i = -1, n = features.length;
    while (++i < n) if (containsGeometry(features[i].geometry, point)) return true;
    return false;
  }
};

var containsGeometryType = {
  Sphere: function() {
    return true;
  },
  Point: function(object, point) {
    return containsPoint(object.coordinates, point);
  },
  MultiPoint: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsPoint(coordinates[i], point)) return true;
    return false;
  },
  LineString: function(object, point) {
    return containsLine(object.coordinates, point);
  },
  MultiLineString: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsLine(coordinates[i], point)) return true;
    return false;
  },
  Polygon: function(object, point) {
    return containsPolygon(object.coordinates, point);
  },
  MultiPolygon: function(object, point) {
    var coordinates = object.coordinates, i = -1, n = coordinates.length;
    while (++i < n) if (containsPolygon(coordinates[i], point)) return true;
    return false;
  },
  GeometryCollection: function(object, point) {
    var geometries = object.geometries, i = -1, n = geometries.length;
    while (++i < n) if (containsGeometry(geometries[i], point)) return true;
    return false;
  }
};

function containsGeometry(geometry, point) {
  return geometry && containsGeometryType.hasOwnProperty(geometry.type)
      ? containsGeometryType[geometry.type](geometry, point)
      : false;
}

function containsPoint(coordinates, point) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__distance_js__["a" /* default */])(coordinates, point) === 0;
}

function containsLine(coordinates, point) {
  var ao, bo, ab;
  for (var i = 0, n = coordinates.length; i < n; i++) {
    bo = Object(__WEBPACK_IMPORTED_MODULE_1__distance_js__["a" /* default */])(coordinates[i], point);
    if (bo === 0) return true;
    if (i > 0) {
      ab = Object(__WEBPACK_IMPORTED_MODULE_1__distance_js__["a" /* default */])(coordinates[i], coordinates[i - 1]);
      if (
        ab > 0 &&
        ao <= ab &&
        bo <= ab &&
        (ao + bo - ab) * (1 - Math.pow((ao - bo) / ab, 2)) < __WEBPACK_IMPORTED_MODULE_2__math_js__["j" /* epsilon2 */] * ab
      )
        return true;
    }
    ao = bo;
  }
  return false;
}

function containsPolygon(coordinates, point) {
  return !!Object(__WEBPACK_IMPORTED_MODULE_0__polygonContains_js__["a" /* default */])(coordinates.map(ringRadians), pointRadians(point));
}

function ringRadians(ring) {
  return ring = ring.map(pointRadians), ring.pop(), ring;
}

function pointRadians(point) {
  return [point[0] * __WEBPACK_IMPORTED_MODULE_2__math_js__["r" /* radians */], point[1] * __WEBPACK_IMPORTED_MODULE_2__math_js__["r" /* radians */]];
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(object, point) {
  return (object && containsObjectType.hasOwnProperty(object.type)
      ? containsObjectType[object.type]
      : containsGeometry)(object, point);
});


/***/ }),
/* 2221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export graticule10 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math_js__ = __webpack_require__(36);



function graticuleX(y0, y1, dy) {
  var y = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["i" /* range */])(y0, y1 - __WEBPACK_IMPORTED_MODULE_1__math_js__["i" /* epsilon */], dy).concat(y1);
  return function(x) { return y.map(function(y) { return [x, y]; }); };
}

function graticuleY(x0, x1, dx) {
  var x = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["i" /* range */])(x0, x1 - __WEBPACK_IMPORTED_MODULE_1__math_js__["i" /* epsilon */], dx).concat(x1);
  return function(y) { return x.map(function(x) { return [x, y]; }); };
}

function graticule() {
  var x1, x0, X1, X0,
      y1, y0, Y1, Y0,
      dx = 10, dy = dx, DX = 90, DY = 360,
      x, y, X, Y,
      precision = 2.5;

  function graticule() {
    return {type: "MultiLineString", coordinates: lines()};
  }

  function lines() {
    return Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["i" /* range */])(Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["f" /* ceil */])(X0 / DX) * DX, X1, DX).map(X)
        .concat(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["i" /* range */])(Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["f" /* ceil */])(Y0 / DY) * DY, Y1, DY).map(Y))
        .concat(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["i" /* range */])(Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["f" /* ceil */])(x0 / dx) * dx, x1, dx).filter(function(x) { return Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["a" /* abs */])(x % DX) > __WEBPACK_IMPORTED_MODULE_1__math_js__["i" /* epsilon */]; }).map(x))
        .concat(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["i" /* range */])(Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["f" /* ceil */])(y0 / dy) * dy, y1, dy).filter(function(y) { return Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["a" /* abs */])(y % DY) > __WEBPACK_IMPORTED_MODULE_1__math_js__["i" /* epsilon */]; }).map(y));
  }

  graticule.lines = function() {
    return lines().map(function(coordinates) { return {type: "LineString", coordinates: coordinates}; });
  };

  graticule.outline = function() {
    return {
      type: "Polygon",
      coordinates: [
        X(X0).concat(
        Y(Y1).slice(1),
        X(X1).reverse().slice(1),
        Y(Y0).reverse().slice(1))
      ]
    };
  };

  graticule.extent = function(_) {
    if (!arguments.length) return graticule.extentMinor();
    return graticule.extentMajor(_).extentMinor(_);
  };

  graticule.extentMajor = function(_) {
    if (!arguments.length) return [[X0, Y0], [X1, Y1]];
    X0 = +_[0][0], X1 = +_[1][0];
    Y0 = +_[0][1], Y1 = +_[1][1];
    if (X0 > X1) _ = X0, X0 = X1, X1 = _;
    if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
    return graticule.precision(precision);
  };

  graticule.extentMinor = function(_) {
    if (!arguments.length) return [[x0, y0], [x1, y1]];
    x0 = +_[0][0], x1 = +_[1][0];
    y0 = +_[0][1], y1 = +_[1][1];
    if (x0 > x1) _ = x0, x0 = x1, x1 = _;
    if (y0 > y1) _ = y0, y0 = y1, y1 = _;
    return graticule.precision(precision);
  };

  graticule.step = function(_) {
    if (!arguments.length) return graticule.stepMinor();
    return graticule.stepMajor(_).stepMinor(_);
  };

  graticule.stepMajor = function(_) {
    if (!arguments.length) return [DX, DY];
    DX = +_[0], DY = +_[1];
    return graticule;
  };

  graticule.stepMinor = function(_) {
    if (!arguments.length) return [dx, dy];
    dx = +_[0], dy = +_[1];
    return graticule;
  };

  graticule.precision = function(_) {
    if (!arguments.length) return precision;
    precision = +_;
    x = graticuleX(y0, y1, 90);
    y = graticuleY(x0, x1, precision);
    X = graticuleX(Y0, Y1, 90);
    Y = graticuleY(X0, X1, precision);
    return graticule;
  };

  return graticule
      .extentMajor([[-180, -90 + __WEBPACK_IMPORTED_MODULE_1__math_js__["i" /* epsilon */]], [180, 90 - __WEBPACK_IMPORTED_MODULE_1__math_js__["i" /* epsilon */]]])
      .extentMinor([[-180, -80 - __WEBPACK_IMPORTED_MODULE_1__math_js__["i" /* epsilon */]], [180, 80 + __WEBPACK_IMPORTED_MODULE_1__math_js__["i" /* epsilon */]]]);
}

function graticule10() {
  return graticule()();
}


/***/ }),
/* 2222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math_js__ = __webpack_require__(36);


/* unused harmony default export */ var _unused_webpack_default_export = (function(a, b) {
  var x0 = a[0] * __WEBPACK_IMPORTED_MODULE_0__math_js__["r" /* radians */],
      y0 = a[1] * __WEBPACK_IMPORTED_MODULE_0__math_js__["r" /* radians */],
      x1 = b[0] * __WEBPACK_IMPORTED_MODULE_0__math_js__["r" /* radians */],
      y1 = b[1] * __WEBPACK_IMPORTED_MODULE_0__math_js__["r" /* radians */],
      cy0 = Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["g" /* cos */])(y0),
      sy0 = Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["t" /* sin */])(y0),
      cy1 = Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["g" /* cos */])(y1),
      sy1 = Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["t" /* sin */])(y1),
      kx0 = cy0 * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["g" /* cos */])(x0),
      ky0 = cy0 * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["t" /* sin */])(x0),
      kx1 = cy1 * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["g" /* cos */])(x1),
      ky1 = cy1 * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["t" /* sin */])(x1),
      d = 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["c" /* asin */])(Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["u" /* sqrt */])(Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["m" /* haversin */])(y1 - y0) + cy0 * cy1 * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["m" /* haversin */])(x1 - x0))),
      k = Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["t" /* sin */])(d);

  var interpolate = d ? function(t) {
    var B = Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["t" /* sin */])(t *= d) / k,
        A = Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["t" /* sin */])(d - t) / k,
        x = A * kx0 + B * kx1,
        y = A * ky0 + B * ky1,
        z = A * sy0 + B * sy1;
    return [
      Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["e" /* atan2 */])(y, x) * __WEBPACK_IMPORTED_MODULE_0__math_js__["h" /* degrees */],
      Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["e" /* atan2 */])(z, Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["u" /* sqrt */])(x * x + y * y)) * __WEBPACK_IMPORTED_MODULE_0__math_js__["h" /* degrees */]
    ];
  } : function() {
    return [x0 * __WEBPACK_IMPORTED_MODULE_0__math_js__["h" /* degrees */], y0 * __WEBPACK_IMPORTED_MODULE_0__math_js__["h" /* degrees */]];
  };

  interpolate.distance = d;

  return interpolate;
});


/***/ }),
/* 2223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity_js__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stream_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__area_js__ = __webpack_require__(2224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bounds_js__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__centroid_js__ = __webpack_require__(2225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__context_js__ = __webpack_require__(2226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__measure_js__ = __webpack_require__(2227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__string_js__ = __webpack_require__(2228);









/* harmony default export */ __webpack_exports__["a"] = (function(projection, context) {
  var pointRadius = 4.5,
      projectionStream,
      contextStream;

  function path(object) {
    if (object) {
      if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
      Object(__WEBPACK_IMPORTED_MODULE_1__stream_js__["a" /* default */])(object, projectionStream(contextStream));
    }
    return contextStream.result();
  }

  path.area = function(object) {
    Object(__WEBPACK_IMPORTED_MODULE_1__stream_js__["a" /* default */])(object, projectionStream(__WEBPACK_IMPORTED_MODULE_2__area_js__["a" /* default */]));
    return __WEBPACK_IMPORTED_MODULE_2__area_js__["a" /* default */].result();
  };

  path.measure = function(object) {
    Object(__WEBPACK_IMPORTED_MODULE_1__stream_js__["a" /* default */])(object, projectionStream(__WEBPACK_IMPORTED_MODULE_6__measure_js__["a" /* default */]));
    return __WEBPACK_IMPORTED_MODULE_6__measure_js__["a" /* default */].result();
  };

  path.bounds = function(object) {
    Object(__WEBPACK_IMPORTED_MODULE_1__stream_js__["a" /* default */])(object, projectionStream(__WEBPACK_IMPORTED_MODULE_3__bounds_js__["a" /* default */]));
    return __WEBPACK_IMPORTED_MODULE_3__bounds_js__["a" /* default */].result();
  };

  path.centroid = function(object) {
    Object(__WEBPACK_IMPORTED_MODULE_1__stream_js__["a" /* default */])(object, projectionStream(__WEBPACK_IMPORTED_MODULE_4__centroid_js__["a" /* default */]));
    return __WEBPACK_IMPORTED_MODULE_4__centroid_js__["a" /* default */].result();
  };

  path.projection = function(_) {
    return arguments.length ? (projectionStream = _ == null ? (projection = null, __WEBPACK_IMPORTED_MODULE_0__identity_js__["a" /* default */]) : (projection = _).stream, path) : projection;
  };

  path.context = function(_) {
    if (!arguments.length) return context;
    contextStream = _ == null ? (context = null, new __WEBPACK_IMPORTED_MODULE_7__string_js__["a" /* default */]) : new __WEBPACK_IMPORTED_MODULE_5__context_js__["a" /* default */](context = _);
    if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
    return path;
  };

  path.pointRadius = function(_) {
    if (!arguments.length) return pointRadius;
    pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
    return path;
  };

  return path.projection(projection).context(context);
});


/***/ }),
/* 2224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder_js__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__noop_js__ = __webpack_require__(113);




var areaSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder_js__["a" /* default */])(),
    areaRingSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder_js__["a" /* default */])(),
    x00,
    y00,
    x0,
    y0;

var areaStream = {
  point: __WEBPACK_IMPORTED_MODULE_2__noop_js__["a" /* default */],
  lineStart: __WEBPACK_IMPORTED_MODULE_2__noop_js__["a" /* default */],
  lineEnd: __WEBPACK_IMPORTED_MODULE_2__noop_js__["a" /* default */],
  polygonStart: function() {
    areaStream.lineStart = areaRingStart;
    areaStream.lineEnd = areaRingEnd;
  },
  polygonEnd: function() {
    areaStream.lineStart = areaStream.lineEnd = areaStream.point = __WEBPACK_IMPORTED_MODULE_2__noop_js__["a" /* default */];
    areaSum.add(Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["a" /* abs */])(areaRingSum));
    areaRingSum.reset();
  },
  result: function() {
    var area = areaSum / 2;
    areaSum.reset();
    return area;
  }
};

function areaRingStart() {
  areaStream.point = areaPointFirst;
}

function areaPointFirst(x, y) {
  areaStream.point = areaPoint;
  x00 = x0 = x, y00 = y0 = y;
}

function areaPoint(x, y) {
  areaRingSum.add(y0 * x - x0 * y);
  x0 = x, y0 = y;
}

function areaRingEnd() {
  areaPoint(x00, y00);
}

/* harmony default export */ __webpack_exports__["a"] = (areaStream);


/***/ }),
/* 2225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math_js__ = __webpack_require__(36);


// TODO Enforce positive area for exterior, negative area for interior?

var X0 = 0,
    Y0 = 0,
    Z0 = 0,
    X1 = 0,
    Y1 = 0,
    Z1 = 0,
    X2 = 0,
    Y2 = 0,
    Z2 = 0,
    x00,
    y00,
    x0,
    y0;

var centroidStream = {
  point: centroidPoint,
  lineStart: centroidLineStart,
  lineEnd: centroidLineEnd,
  polygonStart: function() {
    centroidStream.lineStart = centroidRingStart;
    centroidStream.lineEnd = centroidRingEnd;
  },
  polygonEnd: function() {
    centroidStream.point = centroidPoint;
    centroidStream.lineStart = centroidLineStart;
    centroidStream.lineEnd = centroidLineEnd;
  },
  result: function() {
    var centroid = Z2 ? [X2 / Z2, Y2 / Z2]
        : Z1 ? [X1 / Z1, Y1 / Z1]
        : Z0 ? [X0 / Z0, Y0 / Z0]
        : [NaN, NaN];
    X0 = Y0 = Z0 =
    X1 = Y1 = Z1 =
    X2 = Y2 = Z2 = 0;
    return centroid;
  }
};

function centroidPoint(x, y) {
  X0 += x;
  Y0 += y;
  ++Z0;
}

function centroidLineStart() {
  centroidStream.point = centroidPointFirstLine;
}

function centroidPointFirstLine(x, y) {
  centroidStream.point = centroidPointLine;
  centroidPoint(x0 = x, y0 = y);
}

function centroidPointLine(x, y) {
  var dx = x - x0, dy = y - y0, z = Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["u" /* sqrt */])(dx * dx + dy * dy);
  X1 += z * (x0 + x) / 2;
  Y1 += z * (y0 + y) / 2;
  Z1 += z;
  centroidPoint(x0 = x, y0 = y);
}

function centroidLineEnd() {
  centroidStream.point = centroidPoint;
}

function centroidRingStart() {
  centroidStream.point = centroidPointFirstRing;
}

function centroidRingEnd() {
  centroidPointRing(x00, y00);
}

function centroidPointFirstRing(x, y) {
  centroidStream.point = centroidPointRing;
  centroidPoint(x00 = x0 = x, y00 = y0 = y);
}

function centroidPointRing(x, y) {
  var dx = x - x0,
      dy = y - y0,
      z = Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["u" /* sqrt */])(dx * dx + dy * dy);

  X1 += z * (x0 + x) / 2;
  Y1 += z * (y0 + y) / 2;
  Z1 += z;

  z = y0 * x - x0 * y;
  X2 += z * (x0 + x);
  Y2 += z * (y0 + y);
  Z2 += z * 3;
  centroidPoint(x0 = x, y0 = y);
}

/* harmony default export */ __webpack_exports__["a"] = (centroidStream);


/***/ }),
/* 2226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PathContext;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noop_js__ = __webpack_require__(113);



function PathContext(context) {
  this._context = context;
}

PathContext.prototype = {
  _radius: 4.5,
  pointRadius: function(_) {
    return this._radius = _, this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line === 0) this._context.closePath();
    this._point = NaN;
  },
  point: function(x, y) {
    switch (this._point) {
      case 0: {
        this._context.moveTo(x, y);
        this._point = 1;
        break;
      }
      case 1: {
        this._context.lineTo(x, y);
        break;
      }
      default: {
        this._context.moveTo(x + this._radius, y);
        this._context.arc(x, y, this._radius, 0, __WEBPACK_IMPORTED_MODULE_0__math_js__["w" /* tau */]);
        break;
      }
    }
  },
  result: __WEBPACK_IMPORTED_MODULE_1__noop_js__["a" /* default */]
};


/***/ }),
/* 2227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adder_js__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__noop_js__ = __webpack_require__(113);




var lengthSum = Object(__WEBPACK_IMPORTED_MODULE_0__adder_js__["a" /* default */])(),
    lengthRing,
    x00,
    y00,
    x0,
    y0;

var lengthStream = {
  point: __WEBPACK_IMPORTED_MODULE_2__noop_js__["a" /* default */],
  lineStart: function() {
    lengthStream.point = lengthPointFirst;
  },
  lineEnd: function() {
    if (lengthRing) lengthPoint(x00, y00);
    lengthStream.point = __WEBPACK_IMPORTED_MODULE_2__noop_js__["a" /* default */];
  },
  polygonStart: function() {
    lengthRing = true;
  },
  polygonEnd: function() {
    lengthRing = null;
  },
  result: function() {
    var length = +lengthSum;
    lengthSum.reset();
    return length;
  }
};

function lengthPointFirst(x, y) {
  lengthStream.point = lengthPoint;
  x00 = x0 = x, y00 = y0 = y;
}

function lengthPoint(x, y) {
  x0 -= x, y0 -= y;
  lengthSum.add(Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["u" /* sqrt */])(x0 * x0 + y0 * y0));
  x0 = x, y0 = y;
}

/* harmony default export */ __webpack_exports__["a"] = (lengthStream);


/***/ }),
/* 2228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PathString;
function PathString() {
  this._string = [];
}

PathString.prototype = {
  _radius: 4.5,
  _circle: circle(4.5),
  pointRadius: function(_) {
    if ((_ = +_) !== this._radius) this._radius = _, this._circle = null;
    return this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line === 0) this._string.push("Z");
    this._point = NaN;
  },
  point: function(x, y) {
    switch (this._point) {
      case 0: {
        this._string.push("M", x, ",", y);
        this._point = 1;
        break;
      }
      case 1: {
        this._string.push("L", x, ",", y);
        break;
      }
      default: {
        if (this._circle == null) this._circle = circle(this._radius);
        this._string.push("M", x, ",", y, this._circle);
        break;
      }
    }
  },
  result: function() {
    if (this._string.length) {
      var result = this._string.join("");
      this._string = [];
      return result;
    } else {
      return null;
    }
  }
};

function circle(radius) {
  return "m0," + radius
      + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius
      + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius
      + "z";
}


/***/ }),
/* 2229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cartesian_js__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__transform_js__ = __webpack_require__(264);




var maxDepth = 16, // maximum depth of subdivision
    cosMinDistance = Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["g" /* cos */])(30 * __WEBPACK_IMPORTED_MODULE_1__math_js__["r" /* radians */]); // cos(minimum angular distance)

/* harmony default export */ __webpack_exports__["a"] = (function(project, delta2) {
  return +delta2 ? resample(project, delta2) : resampleNone(project);
});

function resampleNone(project) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__transform_js__["a" /* transformer */])({
    point: function(x, y) {
      x = project(x, y);
      this.stream.point(x[0], x[1]);
    }
  });
}

function resample(project, delta2) {

  function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
    var dx = x1 - x0,
        dy = y1 - y0,
        d2 = dx * dx + dy * dy;
    if (d2 > 4 * delta2 && depth--) {
      var a = a0 + a1,
          b = b0 + b1,
          c = c0 + c1,
          m = Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["u" /* sqrt */])(a * a + b * b + c * c),
          phi2 = Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["c" /* asin */])(c /= m),
          lambda2 = Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["a" /* abs */])(Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["a" /* abs */])(c) - 1) < __WEBPACK_IMPORTED_MODULE_1__math_js__["i" /* epsilon */] || Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["a" /* abs */])(lambda0 - lambda1) < __WEBPACK_IMPORTED_MODULE_1__math_js__["i" /* epsilon */] ? (lambda0 + lambda1) / 2 : Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["e" /* atan2 */])(b, a),
          p = project(lambda2, phi2),
          x2 = p[0],
          y2 = p[1],
          dx2 = x2 - x0,
          dy2 = y2 - y0,
          dz = dy * dx2 - dx * dy2;
      if (dz * dz / d2 > delta2 // perpendicular projected distance
          || Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["a" /* abs */])((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
          || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) { // angular distance
        resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
        stream.point(x2, y2);
        resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
      }
    }
  }
  return function(stream) {
    var lambda00, x00, y00, a00, b00, c00, // first point
        lambda0, x0, y0, a0, b0, c0; // previous point

    var resampleStream = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() { stream.polygonStart(); resampleStream.lineStart = ringStart; },
      polygonEnd: function() { stream.polygonEnd(); resampleStream.lineStart = lineStart; }
    };

    function point(x, y) {
      x = project(x, y);
      stream.point(x[0], x[1]);
    }

    function lineStart() {
      x0 = NaN;
      resampleStream.point = linePoint;
      stream.lineStart();
    }

    function linePoint(lambda, phi) {
      var c = Object(__WEBPACK_IMPORTED_MODULE_0__cartesian_js__["a" /* cartesian */])([lambda, phi]), p = project(lambda, phi);
      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
      stream.point(x0, y0);
    }

    function lineEnd() {
      resampleStream.point = point;
      stream.lineEnd();
    }

    function ringStart() {
      lineStart();
      resampleStream.point = ringPoint;
      resampleStream.lineEnd = ringEnd;
    }

    function ringPoint(lambda, phi) {
      linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
      resampleStream.point = linePoint;
    }

    function ringEnd() {
      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream);
      resampleStream.lineEnd = lineEnd;
      lineEnd();
    }

    return resampleStream;
  };
}


/***/ }),
/* 2230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cylindricalEqualAreaRaw;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math_js__ = __webpack_require__(36);


function cylindricalEqualAreaRaw(phi0) {
  var cosPhi0 = Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["g" /* cos */])(phi0);

  function forward(lambda, phi) {
    return [lambda * cosPhi0, Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["t" /* sin */])(phi) / cosPhi0];
  }

  forward.invert = function(x, y) {
    return [x / cosPhi0, Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["c" /* asin */])(y * cosPhi0)];
  };

  return forward;
}


/***/ }),
/* 2231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__albers_js__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__conicEqualArea_js__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fit_js__ = __webpack_require__(364);





// The projections must have mutually exclusive clip regions on the sphere,
// as this will avoid emitting interleaving lines and polygons.
function multiplex(streams) {
  var n = streams.length;
  return {
    point: function(x, y) { var i = -1; while (++i < n) streams[i].point(x, y); },
    sphere: function() { var i = -1; while (++i < n) streams[i].sphere(); },
    lineStart: function() { var i = -1; while (++i < n) streams[i].lineStart(); },
    lineEnd: function() { var i = -1; while (++i < n) streams[i].lineEnd(); },
    polygonStart: function() { var i = -1; while (++i < n) streams[i].polygonStart(); },
    polygonEnd: function() { var i = -1; while (++i < n) streams[i].polygonEnd(); }
  };
}

// A composite projection for the United States, configured by default for
// 960×500. The projection also works quite well at 960×600 if you change the
// scale to 1285 and adjust the translate accordingly. The set of standard
// parallels for each region comes from USGS, which is published here:
// http://egsc.usgs.gov/isb/pubs/MapProjections/projections.html#albers
/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var cache,
      cacheStream,
      lower48 = Object(__WEBPACK_IMPORTED_MODULE_1__albers_js__["a" /* default */])(), lower48Point,
      alaska = Object(__WEBPACK_IMPORTED_MODULE_2__conicEqualArea_js__["a" /* default */])().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), alaskaPoint, // EPSG:3338
      hawaii = Object(__WEBPACK_IMPORTED_MODULE_2__conicEqualArea_js__["a" /* default */])().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), hawaiiPoint, // ESRI:102007
      point, pointStream = {point: function(x, y) { point = [x, y]; }};

  function albersUsa(coordinates) {
    var x = coordinates[0], y = coordinates[1];
    return point = null,
        (lower48Point.point(x, y), point)
        || (alaskaPoint.point(x, y), point)
        || (hawaiiPoint.point(x, y), point);
  }

  albersUsa.invert = function(coordinates) {
    var k = lower48.scale(),
        t = lower48.translate(),
        x = (coordinates[0] - t[0]) / k,
        y = (coordinates[1] - t[1]) / k;
    return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska
        : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii
        : lower48).invert(coordinates);
  };

  albersUsa.stream = function(stream) {
    return cache && cacheStream === stream ? cache : cache = multiplex([lower48.stream(cacheStream = stream), alaska.stream(stream), hawaii.stream(stream)]);
  };

  albersUsa.precision = function(_) {
    if (!arguments.length) return lower48.precision();
    lower48.precision(_), alaska.precision(_), hawaii.precision(_);
    return reset();
  };

  albersUsa.scale = function(_) {
    if (!arguments.length) return lower48.scale();
    lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
    return albersUsa.translate(lower48.translate());
  };

  albersUsa.translate = function(_) {
    if (!arguments.length) return lower48.translate();
    var k = lower48.scale(), x = +_[0], y = +_[1];

    lower48Point = lower48
        .translate(_)
        .clipExtent([[x - 0.455 * k, y - 0.238 * k], [x + 0.455 * k, y + 0.238 * k]])
        .stream(pointStream);

    alaskaPoint = alaska
        .translate([x - 0.307 * k, y + 0.201 * k])
        .clipExtent([[x - 0.425 * k + __WEBPACK_IMPORTED_MODULE_0__math_js__["i" /* epsilon */], y + 0.120 * k + __WEBPACK_IMPORTED_MODULE_0__math_js__["i" /* epsilon */]], [x - 0.214 * k - __WEBPACK_IMPORTED_MODULE_0__math_js__["i" /* epsilon */], y + 0.234 * k - __WEBPACK_IMPORTED_MODULE_0__math_js__["i" /* epsilon */]]])
        .stream(pointStream);

    hawaiiPoint = hawaii
        .translate([x - 0.205 * k, y + 0.212 * k])
        .clipExtent([[x - 0.214 * k + __WEBPACK_IMPORTED_MODULE_0__math_js__["i" /* epsilon */], y + 0.166 * k + __WEBPACK_IMPORTED_MODULE_0__math_js__["i" /* epsilon */]], [x - 0.115 * k - __WEBPACK_IMPORTED_MODULE_0__math_js__["i" /* epsilon */], y + 0.234 * k - __WEBPACK_IMPORTED_MODULE_0__math_js__["i" /* epsilon */]]])
        .stream(pointStream);

    return reset();
  };

  albersUsa.fitExtent = function(extent, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__fit_js__["a" /* fitExtent */])(albersUsa, extent, object);
  };

  albersUsa.fitSize = function(size, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__fit_js__["c" /* fitSize */])(albersUsa, size, object);
  };

  albersUsa.fitWidth = function(width, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__fit_js__["d" /* fitWidth */])(albersUsa, width, object);
  };

  albersUsa.fitHeight = function(height, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__fit_js__["b" /* fitHeight */])(albersUsa, height, object);
  };

  function reset() {
    cache = cacheStream = null;
    return albersUsa;
  }

  return albersUsa.scale(1070);
});


/***/ }),
/* 2232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export azimuthalEqualAreaRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal_js__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_js__ = __webpack_require__(86);




var azimuthalEqualAreaRaw = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal_js__["b" /* azimuthalRaw */])(function(cxcy) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["u" /* sqrt */])(2 / (1 + cxcy));
});

azimuthalEqualAreaRaw.invert = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal_js__["a" /* azimuthalInvert */])(function(z) {
  return 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["c" /* asin */])(z / 2);
});

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_2__index_js__["a" /* default */])(azimuthalEqualAreaRaw)
      .scale(124.75)
      .clipAngle(180 - 1e-3);
});


/***/ }),
/* 2233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export azimuthalEquidistantRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal_js__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_js__ = __webpack_require__(86);




var azimuthalEquidistantRaw = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal_js__["b" /* azimuthalRaw */])(function(c) {
  return (c = Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["b" /* acos */])(c)) && c / Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["t" /* sin */])(c);
});

azimuthalEquidistantRaw.invert = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal_js__["a" /* azimuthalInvert */])(function(z) {
  return z;
});

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_2__index_js__["a" /* default */])(azimuthalEquidistantRaw)
      .scale(79.4188)
      .clipAngle(180 - 1e-3);
});


/***/ }),
/* 2234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export conicConformalRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conic_js__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mercator_js__ = __webpack_require__(365);




function tany(y) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["v" /* tan */])((__WEBPACK_IMPORTED_MODULE_0__math_js__["l" /* halfPi */] + y) / 2);
}

function conicConformalRaw(y0, y1) {
  var cy0 = Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["g" /* cos */])(y0),
      n = y0 === y1 ? Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["t" /* sin */])(y0) : Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["n" /* log */])(cy0 / Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["g" /* cos */])(y1)) / Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["n" /* log */])(tany(y1) / tany(y0)),
      f = cy0 * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["p" /* pow */])(tany(y0), n) / n;

  if (!n) return __WEBPACK_IMPORTED_MODULE_2__mercator_js__["b" /* mercatorRaw */];

  function project(x, y) {
    if (f > 0) { if (y < -__WEBPACK_IMPORTED_MODULE_0__math_js__["l" /* halfPi */] + __WEBPACK_IMPORTED_MODULE_0__math_js__["i" /* epsilon */]) y = -__WEBPACK_IMPORTED_MODULE_0__math_js__["l" /* halfPi */] + __WEBPACK_IMPORTED_MODULE_0__math_js__["i" /* epsilon */]; }
    else { if (y > __WEBPACK_IMPORTED_MODULE_0__math_js__["l" /* halfPi */] - __WEBPACK_IMPORTED_MODULE_0__math_js__["i" /* epsilon */]) y = __WEBPACK_IMPORTED_MODULE_0__math_js__["l" /* halfPi */] - __WEBPACK_IMPORTED_MODULE_0__math_js__["i" /* epsilon */]; }
    var r = f / Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["p" /* pow */])(tany(y), n);
    return [r * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["t" /* sin */])(n * x), f - r * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["g" /* cos */])(n * x)];
  }

  project.invert = function(x, y) {
    var fy = f - y, r = Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["s" /* sign */])(n) * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["u" /* sqrt */])(x * x + fy * fy),
      l = Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["e" /* atan2 */])(x, Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["a" /* abs */])(fy)) * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["s" /* sign */])(fy);
    if (fy * n < 0)
      l -= __WEBPACK_IMPORTED_MODULE_0__math_js__["o" /* pi */] * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["s" /* sign */])(x) * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["s" /* sign */])(fy);
    return [l / n, 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["d" /* atan */])(Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["p" /* pow */])(f / r, 1 / n)) - __WEBPACK_IMPORTED_MODULE_0__math_js__["l" /* halfPi */]];
  };

  return project;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__conic_js__["a" /* conicProjection */])(conicConformalRaw)
      .scale(109.5)
      .parallels([30, 30]);
});


/***/ }),
/* 2235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export conicEquidistantRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__conic_js__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__equirectangular_js__ = __webpack_require__(617);




function conicEquidistantRaw(y0, y1) {
  var cy0 = Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["g" /* cos */])(y0),
      n = y0 === y1 ? Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["t" /* sin */])(y0) : (cy0 - Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["g" /* cos */])(y1)) / (y1 - y0),
      g = cy0 / n + y0;

  if (Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["a" /* abs */])(n) < __WEBPACK_IMPORTED_MODULE_0__math_js__["i" /* epsilon */]) return __WEBPACK_IMPORTED_MODULE_2__equirectangular_js__["a" /* equirectangularRaw */];

  function project(x, y) {
    var gy = g - y, nx = n * x;
    return [gy * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["t" /* sin */])(nx), g - gy * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["g" /* cos */])(nx)];
  }

  project.invert = function(x, y) {
    var gy = g - y,
        l = Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["e" /* atan2 */])(x, Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["a" /* abs */])(gy)) * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["s" /* sign */])(gy);
    if (gy * n < 0)
      l -= __WEBPACK_IMPORTED_MODULE_0__math_js__["o" /* pi */] * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["s" /* sign */])(x) * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["s" /* sign */])(gy);
    return [l / n, g - Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["s" /* sign */])(n) * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["u" /* sqrt */])(x * x + gy * gy)];
  };

  return project;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__conic_js__["a" /* conicProjection */])(conicEquidistantRaw)
      .scale(131.154)
      .center([0, 13.9389]);
});


/***/ }),
/* 2236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export equalEarthRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_js__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math_js__ = __webpack_require__(36);



var A1 = 1.340264,
    A2 = -0.081106,
    A3 = 0.000893,
    A4 = 0.003796,
    M = Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["u" /* sqrt */])(3) / 2,
    iterations = 12;

function equalEarthRaw(lambda, phi) {
  var l = Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["c" /* asin */])(M * Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["t" /* sin */])(phi)), l2 = l * l, l6 = l2 * l2 * l2;
  return [
    lambda * Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["g" /* cos */])(l) / (M * (A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2))),
    l * (A1 + A2 * l2 + l6 * (A3 + A4 * l2))
  ];
}

equalEarthRaw.invert = function(x, y) {
  var l = y, l2 = l * l, l6 = l2 * l2 * l2;
  for (var i = 0, delta, fy, fpy; i < iterations; ++i) {
    fy = l * (A1 + A2 * l2 + l6 * (A3 + A4 * l2)) - y;
    fpy = A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2);
    l -= delta = fy / fpy, l2 = l * l, l6 = l2 * l2 * l2;
    if (Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["a" /* abs */])(delta) < __WEBPACK_IMPORTED_MODULE_1__math_js__["j" /* epsilon2 */]) break;
  }
  return [
    M * x * (A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2)) / Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["g" /* cos */])(l),
    Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["c" /* asin */])(Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["t" /* sin */])(l) / M)
  ];
};

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__index_js__["a" /* default */])(equalEarthRaw)
      .scale(177.158);
});


/***/ }),
/* 2237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gnomonicRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal_js__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_js__ = __webpack_require__(86);




function gnomonicRaw(x, y) {
  var cy = Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["g" /* cos */])(y), k = Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["g" /* cos */])(x) * cy;
  return [cy * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["t" /* sin */])(x) / k, Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["t" /* sin */])(y) / k];
}

gnomonicRaw.invert = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal_js__["a" /* azimuthalInvert */])(__WEBPACK_IMPORTED_MODULE_0__math_js__["d" /* atan */]);

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_2__index_js__["a" /* default */])(gnomonicRaw)
      .scale(144.049)
      .clipAngle(60);
});


/***/ }),
/* 2238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__clip_rectangle_js__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__identity_js__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__transform_js__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fit_js__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__math_js__ = __webpack_require__(36);






/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, // scale, translate and reflect
      alpha = 0, ca, sa, // angle
      x0 = null, y0, x1, y1, // clip extent
      kx = 1, ky = 1,
      transform = Object(__WEBPACK_IMPORTED_MODULE_2__transform_js__["a" /* transformer */])({
        point: function(x, y) {
          var p = projection([x, y])
          this.stream.point(p[0], p[1]);
        }
      }),
      postclip = __WEBPACK_IMPORTED_MODULE_1__identity_js__["a" /* default */],
      cache,
      cacheStream;

  function reset() {
    kx = k * sx;
    ky = k * sy;
    cache = cacheStream = null;
    return projection;
  }

  function projection (p) {
    var x = p[0] * kx, y = p[1] * ky;
    if (alpha) {
      var t = y * ca - x * sa;
      x = x * ca + y * sa;
      y = t;
    }    
    return [x + tx, y + ty];
  }
  projection.invert = function(p) {
    var x = p[0] - tx, y = p[1] - ty;
    if (alpha) {
      var t = y * ca + x * sa;
      x = x * ca - y * sa;
      y = t;
    }
    return [x / kx, y / ky];
  };
  projection.stream = function(stream) {
    return cache && cacheStream === stream ? cache : cache = transform(postclip(cacheStream = stream));
  };
  projection.postclip = function(_) {
    return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
  };
  projection.clipExtent = function(_) {
    return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, __WEBPACK_IMPORTED_MODULE_1__identity_js__["a" /* default */]) : Object(__WEBPACK_IMPORTED_MODULE_0__clip_rectangle_js__["a" /* default */])(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
  };
  projection.scale = function(_) {
    return arguments.length ? (k = +_, reset()) : k;
  };
  projection.translate = function(_) {
    return arguments.length ? (tx = +_[0], ty = +_[1], reset()) : [tx, ty];
  }
  projection.angle = function(_) {
    return arguments.length ? (alpha = _ % 360 * __WEBPACK_IMPORTED_MODULE_4__math_js__["r" /* radians */], sa = Object(__WEBPACK_IMPORTED_MODULE_4__math_js__["t" /* sin */])(alpha), ca = Object(__WEBPACK_IMPORTED_MODULE_4__math_js__["g" /* cos */])(alpha), reset()) : alpha * __WEBPACK_IMPORTED_MODULE_4__math_js__["h" /* degrees */];
  };
  projection.reflectX = function(_) {
    return arguments.length ? (sx = _ ? -1 : 1, reset()) : sx < 0;
  };
  projection.reflectY = function(_) {
    return arguments.length ? (sy = _ ? -1 : 1, reset()) : sy < 0;
  };
  projection.fitExtent = function(extent, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__fit_js__["a" /* fitExtent */])(projection, extent, object);
  };
  projection.fitSize = function(size, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__fit_js__["c" /* fitSize */])(projection, size, object);
  };
  projection.fitWidth = function(width, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__fit_js__["d" /* fitWidth */])(projection, width, object);
  };
  projection.fitHeight = function(height, object) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__fit_js__["b" /* fitHeight */])(projection, height, object);
  };

  return projection;
});


/***/ }),
/* 2239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export naturalEarth1Raw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_js__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__math_js__ = __webpack_require__(36);



function naturalEarth1Raw(lambda, phi) {
  var phi2 = phi * phi, phi4 = phi2 * phi2;
  return [
    lambda * (0.8707 - 0.131979 * phi2 + phi4 * (-0.013791 + phi4 * (0.003971 * phi2 - 0.001529 * phi4))),
    phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4)))
  ];
}

naturalEarth1Raw.invert = function(x, y) {
  var phi = y, i = 25, delta;
  do {
    var phi2 = phi * phi, phi4 = phi2 * phi2;
    phi -= delta = (phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4))) - y) /
        (1.007226 + phi2 * (0.015085 * 3 + phi4 * (-0.044475 * 7 + 0.028874 * 9 * phi2 - 0.005916 * 11 * phi4)));
  } while (Object(__WEBPACK_IMPORTED_MODULE_1__math_js__["a" /* abs */])(delta) > __WEBPACK_IMPORTED_MODULE_1__math_js__["i" /* epsilon */] && --i > 0);
  return [
    x / (0.8707 + (phi2 = phi * phi) * (-0.131979 + phi2 * (-0.013791 + phi2 * phi2 * phi2 * (0.003971 - 0.001529 * phi2)))),
    phi
  ];
};

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__index_js__["a" /* default */])(naturalEarth1Raw)
      .scale(175.295);
});


/***/ }),
/* 2240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export orthographicRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal_js__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_js__ = __webpack_require__(86);




function orthographicRaw(x, y) {
  return [Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["g" /* cos */])(y) * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["t" /* sin */])(x), Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["t" /* sin */])(y)];
}

orthographicRaw.invert = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal_js__["a" /* azimuthalInvert */])(__WEBPACK_IMPORTED_MODULE_0__math_js__["c" /* asin */]);

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_2__index_js__["a" /* default */])(orthographicRaw)
      .scale(249.5)
      .clipAngle(90 + __WEBPACK_IMPORTED_MODULE_0__math_js__["i" /* epsilon */]);
});


/***/ }),
/* 2241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export stereographicRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__azimuthal_js__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_js__ = __webpack_require__(86);




function stereographicRaw(x, y) {
  var cy = Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["g" /* cos */])(y), k = 1 + Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["g" /* cos */])(x) * cy;
  return [cy * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["t" /* sin */])(x) / k, Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["t" /* sin */])(y) / k];
}

stereographicRaw.invert = Object(__WEBPACK_IMPORTED_MODULE_1__azimuthal_js__["a" /* azimuthalInvert */])(function(z) {
  return 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["d" /* atan */])(z);
});

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_2__index_js__["a" /* default */])(stereographicRaw)
      .scale(250)
      .clipAngle(142);
});


/***/ }),
/* 2242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export transverseMercatorRaw */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mercator_js__ = __webpack_require__(365);



function transverseMercatorRaw(lambda, phi) {
  return [Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["n" /* log */])(Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["v" /* tan */])((__WEBPACK_IMPORTED_MODULE_0__math_js__["l" /* halfPi */] + phi) / 2)), -lambda];
}

transverseMercatorRaw.invert = function(x, y) {
  return [-y, 2 * Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["d" /* atan */])(Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["k" /* exp */])(x)) - __WEBPACK_IMPORTED_MODULE_0__math_js__["l" /* halfPi */]];
};

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var m = Object(__WEBPACK_IMPORTED_MODULE_1__mercator_js__["a" /* mercatorProjection */])(transverseMercatorRaw),
      center = m.center,
      rotate = m.rotate;

  m.center = function(_) {
    return arguments.length ? center([-_[1], _[0]]) : (_ = center(), [_[1], -_[0]]);
  };

  m.rotate = function(_) {
    return arguments.length ? rotate([_[0], _[1], _.length > 2 ? _[2] + 90 : 90]) : (_ = rotate(), [_[0], _[1], _[2] - 90]);
  };

  return rotate([0, 0, 90])
      .scale(159.155);
});


/***/ }),
/* 2243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_data_utils__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__ = __webpack_require__(69);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.









/**
 * Format title by detault.
 * @param {Array} values List of values.
 * @returns {*} Formatted value or undefined.
 */
function defaultTitleFormat(values) {
  var value = getFirstNonEmptyValue(values);
  if (value) {
    return {
      title: 'x',
      value: Object(__WEBPACK_IMPORTED_MODULE_2__utils_data_utils__["c" /* transformValueToString */])(value.x)
    };
  }
}

/**
 * Format items by default.
 * @param {Array} values Array of values.
 * @returns {*} Formatted list of items.
 */
function defaultItemsFormat(values) {
  return values.map(function (v, i) {
    if (v) {
      return { value: v.y, title: i };
    }
  });
}

/**
 * Get the first non-empty item from an array.
 * @param {Array} values Array of values.
 * @returns {*} First non-empty value or undefined.
 */
function getFirstNonEmptyValue(values) {
  return (values || []).find(function (v) {
    return Boolean(v);
  });
}

var Crosshair = function (_PureComponent) {
  _inherits(Crosshair, _PureComponent);

  function Crosshair() {
    _classCallCheck(this, Crosshair);

    return _possibleConstructorReturn(this, (Crosshair.__proto__ || Object.getPrototypeOf(Crosshair)).apply(this, arguments));
  }

  _createClass(Crosshair, [{
    key: '_renderCrosshairItems',


    /**
     * Render crosshair items (title + value for each series).
     * @returns {*} Array of React classes with the crosshair values.
     * @private
     */
    value: function _renderCrosshairItems() {
      var _props = this.props,
          values = _props.values,
          itemsFormat = _props.itemsFormat;

      var items = itemsFormat(values);
      if (!items) {
        return null;
      }
      return items.filter(function (i) {
        return i;
      }).map(function renderValue(item, i) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'rv-crosshair__item', key: 'item' + i },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'rv-crosshair__item__title' },
            item.title
          ),
          ': ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'rv-crosshair__item__value' },
            item.value
          )
        );
      });
    }

    /**
     * Render crosshair title.
     * @returns {*} Container with the crosshair title.
     * @private
     */

  }, {
    key: '_renderCrosshairTitle',
    value: function _renderCrosshairTitle() {
      var _props2 = this.props,
          values = _props2.values,
          titleFormat = _props2.titleFormat,
          style = _props2.style;

      var titleItem = titleFormat(values);
      if (!titleItem) {
        return null;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'rv-crosshair__title', key: 'title', style: style.title },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'rv-crosshair__title__title' },
          titleItem.title
        ),
        ': ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'rv-crosshair__title__value' },
          titleItem.value
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          children = _props3.children,
          className = _props3.className,
          values = _props3.values,
          marginTop = _props3.marginTop,
          marginLeft = _props3.marginLeft,
          innerWidth = _props3.innerWidth,
          innerHeight = _props3.innerHeight,
          style = _props3.style;

      var value = getFirstNonEmptyValue(values);
      if (!value) {
        return null;
      }
      var x = Object(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["c" /* getAttributeFunctor */])(this.props, 'x');
      var innerLeft = x(value);

      var _props$orientation = this.props.orientation,
          orientation = _props$orientation === undefined ? innerLeft > innerWidth / 2 ? 'left' : 'right' : _props$orientation;

      var left = marginLeft + innerLeft;
      var top = marginTop;
      var innerClassName = 'rv-crosshair__inner rv-crosshair__inner--' + orientation;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: 'rv-crosshair ' + className,
          style: { left: left + 'px', top: top + 'px' }
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
          className: 'rv-crosshair__line',
          style: _extends({ height: innerHeight + 'px' }, style.line)
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: innerClassName },
          children ? children : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'rv-crosshair__inner__content', style: style.box },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              this._renderCrosshairTitle(),
              this._renderCrosshairItems()
            )
          )
        )
      );
    }
  }], [{
    key: 'defaultProps',
    get: function get() {
      return {
        titleFormat: defaultTitleFormat,
        itemsFormat: defaultItemsFormat,
        style: {
          line: {},
          title: {},
          box: {}
        }
      };
    }
  }, {
    key: 'propTypes',
    get: function get() {
      return {
        className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        values: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object])),
        series: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
        innerWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
        innerHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
        marginLeft: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
        marginTop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
        orientation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['left', 'right']),
        itemsFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
        titleFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
        style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
          line: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
          title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
          box: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
        })
      };
    }
  }]);

  return Crosshair;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Crosshair.displayName = 'Crosshair';

/* unused harmony default export */ var _unused_webpack_default_export = (Crosshair);

/***/ }),
/* 2244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__abstract_series__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__animation__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_series_utils__ = __webpack_require__(66);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// Copyright (c) 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.








var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--custom-svg-wrapper';

var DEFAULT_STYLE = {
  stroke: 'blue',
  fill: 'blue'
};

function predefinedComponents(type) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var style = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_STYLE;

  switch (type) {
    case 'diamond':
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon', {
        style: style,
        points: '0 0 ' + size / 2 + ' ' + size / 2 + ' 0 ' + size + ' ' + -size / 2 + ' ' + size / 2 + ' 0 0'
      });
    case 'star':
      var starPoints = [].concat(_toConsumableArray(new Array(5))).map(function (c, index) {
        var angle = index / 5 * Math.PI * 2;
        var innerAngle = angle + Math.PI / 10;
        var outerAngle = angle - Math.PI / 10;
        // ratio of inner polygon to outer polgyon
        var innerRadius = size / 2.61;
        return '\n        ' + Math.cos(outerAngle) * size + ' ' + Math.sin(outerAngle) * size + '\n        ' + Math.cos(innerAngle) * innerRadius + ' ' + Math.sin(innerAngle) * innerRadius + '\n      ';
      }).join(' ');
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon', {
        points: starPoints,
        x: '0',
        y: '0',
        height: size,
        width: size,
        style: style
      });
    case 'square':
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', {
        x: '' + -size / 2,
        y: '' + -size / 2,
        height: size,
        width: size,
        style: style
      });
    default:
    case 'circle':
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle', { cx: '0', cy: '0', r: size / 2, style: style });
  }
}

function getInnerComponent(_ref) {
  var customComponent = _ref.customComponent,
      defaultType = _ref.defaultType,
      positionInPixels = _ref.positionInPixels,
      positionFunctions = _ref.positionFunctions,
      style = _ref.style,
      propsSize = _ref.propsSize;
  var size = customComponent.size;

  var aggStyle = _extends({}, style, customComponent.style || {});
  var innerComponent = customComponent.customComponent;
  if (!innerComponent && typeof defaultType === 'string') {
    return predefinedComponents(defaultType, size || propsSize, aggStyle);
  }
  // if default component is a function
  if (!innerComponent) {
    return defaultType(customComponent, positionInPixels, aggStyle);
  }
  if (typeof innerComponent === 'string') {
    return predefinedComponents(innerComponent || defaultType, size, aggStyle);
  }
  // if inner component is a function
  return innerComponent(customComponent, positionInPixels, aggStyle);
}

var CustomSVGSeries = function (_AbstractSeries) {
  _inherits(CustomSVGSeries, _AbstractSeries);

  function CustomSVGSeries() {
    _classCallCheck(this, CustomSVGSeries);

    return _possibleConstructorReturn(this, (CustomSVGSeries.__proto__ || Object.getPrototypeOf(CustomSVGSeries)).apply(this, arguments));
  }

  _createClass(CustomSVGSeries, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          animation = _props.animation,
          className = _props.className,
          customComponent = _props.customComponent,
          data = _props.data,
          innerHeight = _props.innerHeight,
          innerWidth = _props.innerWidth,
          marginLeft = _props.marginLeft,
          marginTop = _props.marginTop,
          style = _props.style,
          size = _props.size;


      if (!data || !innerWidth || !innerHeight) {
        return null;
      }

      if (animation) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3__animation__["b" /* default */],
          _extends({}, this.props, { animatedProps: __WEBPACK_IMPORTED_MODULE_4__utils_series_utils__["a" /* ANIMATED_SERIES_PROPS */] }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CustomSVGSeries, _extends({}, this.props, { animation: false }))
        );
      }

      var x = this._getAttributeFunctor('x');
      var y = this._getAttributeFunctor('y');
      var contents = data.map(function (seriesComponent, index) {
        var positionInPixels = {
          x: x(seriesComponent),
          y: y(seriesComponent)
        };
        var innerComponent = getInnerComponent({
          customComponent: seriesComponent,
          positionInPixels: positionInPixels,
          defaultType: customComponent,
          positionFunctions: { x: x, y: y },
          style: style,
          propsSize: size
        });
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          {
            className: 'rv-xy-plot__series--custom-svg',
            key: 'rv-xy-plot__series--custom-svg-' + index,
            transform: 'translate(' + positionInPixels.x + ',' + positionInPixels.y + ')',
            onMouseEnter: function onMouseEnter(e) {
              return _this2._valueMouseOverHandler(seriesComponent, e);
            },
            onMouseLeave: function onMouseLeave(e) {
              return _this2._valueMouseOutHandler(seriesComponent, e);
            }
          },
          innerComponent
        );
      });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        {
          className: predefinedClassName + ' ' + className,
          transform: 'translate(' + marginLeft + ',' + marginTop + ')'
        },
        contents
      );
    }
  }]);

  return CustomSVGSeries;
}(__WEBPACK_IMPORTED_MODULE_2__abstract_series__["a" /* default */]);

CustomSVGSeries.propTypes = {
  animation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  customComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]).isRequired,
    y: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]).isRequired
  })).isRequired,
  marginLeft: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  marginTop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onValueMouseOver: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onValueMouseOut: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

CustomSVGSeries.defaultProps = _extends({}, __WEBPACK_IMPORTED_MODULE_2__abstract_series__["a" /* default */].defaultProps, {
  animation: false,
  customComponent: 'circle',
  style: {},
  size: 2
});

/* unused harmony default export */ var _unused_webpack_default_export = (CustomSVGSeries);

/***/ }),
/* 2245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = decorativeAxisTick;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_axis_utils__ = __webpack_require__(82);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Copyright (c) 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.




/**
 * Generate the actual polygons to be plotted
 * @param {Object} props
 - props.animation {Boolean}
 - props.axisDomain {Array} a pair of values specifying the domain of the axis
 - props.numberOfTicks{Number} the number of ticks on the axis
 - props.axisStart {Object} a object specify in cartesian space the start of the axis
 example: {x: 0, y: 0}
 - props.axisEnd {Object} a object specify in cartesian space the start of the axis
 - props.tickValue {Func} a formatting function for the tick values
 - props.tickSize {Number} a pixel size of the axis
 - props.style {Object} The style object for the axis
 * @return {Component} the plotted axis
 */
function decorativeAxisTick(props) {
  var axisDomain = props.axisDomain,
      numberOfTicks = props.numberOfTicks,
      axisStart = props.axisStart,
      axisEnd = props.axisEnd,
      tickValue = props.tickValue,
      tickSize = props.tickSize,
      style = props.style;

  var _generatePoints = Object(__WEBPACK_IMPORTED_MODULE_1__utils_axis_utils__["c" /* generatePoints */])({
    axisStart: axisStart,
    axisEnd: axisEnd,
    numberOfTicks: numberOfTicks,
    axisDomain: axisDomain
  }),
      points = _generatePoints.points;
  // add a quarter rotation to make ticks orthogonal to axis


  var tickAngle = Object(__WEBPACK_IMPORTED_MODULE_1__utils_axis_utils__["d" /* getAxisAngle */])(axisStart, axisEnd) + Math.PI / 2;
  return points.map(function (point, index) {
    var tickProps = _extends({
      x1: 0,
      y1: 0,
      x2: tickSize * Math.cos(tickAngle),
      y2: tickSize * Math.sin(tickAngle)
    }, style.ticks);

    var textProps = _extends({
      x: tickSize * Math.cos(tickAngle),
      y: tickSize * Math.sin(tickAngle),
      textAnchor: 'start'
    }, style.text);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      {
        key: index,
        transform: 'translate(' + point.x + ', ' + point.y + ')',
        className: 'rv-xy-plot__axis__tick'
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line', _extends({}, tickProps, { className: 'rv-xy-plot__axis__tick__line' })),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'text',
        _extends({}, textProps, { className: 'rv-xy-plot__axis__tick__text' }),
        tickValue(point.text)
      )
    );
  });
}

/***/ }),
/* 2246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.




var predefinedClassName = 'rv-gradient-defs';

function GradientDefs(props) {
  var className = props.className;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'defs',
    { className: predefinedClassName + ' ' + className },
    props.children
  );
}

GradientDefs.displayName = 'GradientDefs';
GradientDefs.requiresSVG = true;
GradientDefs.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
GradientDefs.defaultProps = {
  className: ''
};

/* unused harmony default export */ var _unused_webpack_default_export = (GradientDefs);

/***/ }),
/* 2247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__animation__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_series_utils__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__abstract_series__ = __webpack_require__(48);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.








var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--heatmap';

var HeatmapSeries = function (_AbstractSeries) {
  _inherits(HeatmapSeries, _AbstractSeries);

  function HeatmapSeries() {
    _classCallCheck(this, HeatmapSeries);

    return _possibleConstructorReturn(this, (HeatmapSeries.__proto__ || Object.getPrototypeOf(HeatmapSeries)).apply(this, arguments));
  }

  _createClass(HeatmapSeries, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          animation = _props.animation,
          className = _props.className,
          data = _props.data,
          marginLeft = _props.marginLeft,
          marginTop = _props.marginTop,
          style = _props.style;

      if (!data) {
        return null;
      }
      if (animation) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1__animation__["b" /* default */],
          _extends({}, this.props, { animatedProps: __WEBPACK_IMPORTED_MODULE_2__utils_series_utils__["a" /* ANIMATED_SERIES_PROPS */] }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeatmapSeries, _extends({}, this.props, { animation: null }))
        );
      }

      var _rectStyle$style = _extends({ rectStyle: {} }, style),
          rectStyle = _rectStyle$style.rectStyle;

      var x = this._getAttributeFunctor('x');
      var y = this._getAttributeFunctor('y');
      var opacity = this._getAttributeFunctor('opacity');
      var fill = this._getAttributeFunctor('fill') || this._getAttributeFunctor('color');
      var stroke = this._getAttributeFunctor('stroke') || this._getAttributeFunctor('color');
      var xDistance = this._getScaleDistance('x');
      var yDistance = this._getScaleDistance('y');
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        {
          className: predefinedClassName + ' ' + className,
          transform: 'translate(' + marginLeft + ',' + marginTop + ')'
        },
        data.map(function (d, i) {
          var attrs = _extends({
            style: _extends({
              stroke: stroke && stroke(d),
              fill: fill && fill(d),
              opacity: opacity && opacity(d)
            }, style)
          }, rectStyle, {
            x: x(d) - xDistance / 2,
            y: y(d) - yDistance / 2,
            width: xDistance,
            height: yDistance,
            key: i,
            onClick: function onClick(e) {
              return _this2._valueClickHandler(d, e);
            },
            onContextMenu: function onContextMenu(e) {
              return _this2._valueRightClickHandler(d, e);
            },
            onMouseOver: function onMouseOver(e) {
              return _this2._valueMouseOverHandler(d, e);
            },
            onMouseOut: function onMouseOut(e) {
              return _this2._valueMouseOutHandler(d, e);
            }
          });
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', attrs);
        })
      );
    }
  }], [{
    key: 'getParentConfig',
    value: function getParentConfig(attr) {
      var isDomainAdjustmentNeeded = attr === 'x' || attr === 'y';
      return { isDomainAdjustmentNeeded: isDomainAdjustmentNeeded };
    }
  }]);

  return HeatmapSeries;
}(__WEBPACK_IMPORTED_MODULE_3__abstract_series__["a" /* default */]);

HeatmapSeries.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_3__abstract_series__["a" /* default */].propTypes);

HeatmapSeries.displayName = 'HeatmapSeries';

/* unused harmony default export */ var _unused_webpack_default_export = (HeatmapSeries);

/***/ }),
/* 2248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__animation__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_hexbin__ = __webpack_require__(2249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_scale__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_series_utils__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__theme__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__abstract_series__ = __webpack_require__(48);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.











var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--hexbin';

function getColorDomain(_ref, hexes) {
  var countDomain = _ref.countDomain;

  if (countDomain) {
    return countDomain;
  }
  return [0, Math.max.apply(Math, _toConsumableArray(hexes.map(function (row) {
    return row.length;
  })))];
}

var HexbinSeries = function (_AbstractSeries) {
  _inherits(HexbinSeries, _AbstractSeries);

  function HexbinSeries() {
    _classCallCheck(this, HexbinSeries);

    return _possibleConstructorReturn(this, (HexbinSeries.__proto__ || Object.getPrototypeOf(HexbinSeries)).apply(this, arguments));
  }

  _createClass(HexbinSeries, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          animation = _props.animation,
          className = _props.className,
          colorRange = _props.colorRange,
          data = _props.data,
          innerHeight = _props.innerHeight,
          innerWidth = _props.innerWidth,
          marginLeft = _props.marginLeft,
          marginTop = _props.marginTop,
          radius = _props.radius,
          sizeHexagonsWithCount = _props.sizeHexagonsWithCount,
          style = _props.style,
          xOffset = _props.xOffset,
          yOffset = _props.yOffset;


      if (!data) {
        return null;
      }

      if (animation) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__animation__["b" /* default */],
          _extends({}, this.props, { animatedProps: __WEBPACK_IMPORTED_MODULE_5__utils_series_utils__["a" /* ANIMATED_SERIES_PROPS */] }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HexbinSeries, _extends({}, this.props, { animation: null }))
        );
      }
      var x = this._getAttributeFunctor('x');
      var y = this._getAttributeFunctor('y');

      var hex = Object(__WEBPACK_IMPORTED_MODULE_3_d3_hexbin__["a" /* hexbin */])().x(function (d) {
        return x(d) + xOffset;
      }).y(function (d) {
        return y(d) + yOffset;
      }).radius(radius).size([innerWidth, innerHeight]);

      var hexagonPath = hex.hexagon();
      var hexes = hex(data);

      var countDomain = getColorDomain(this.props, hexes);
      var color = Object(__WEBPACK_IMPORTED_MODULE_4_d3_scale__["a" /* scaleLinear */])().domain(countDomain).range(colorRange);
      var size = Object(__WEBPACK_IMPORTED_MODULE_4_d3_scale__["a" /* scaleLinear */])().domain(countDomain).range([0, radius]);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        {
          className: predefinedClassName + ' ' + className,
          transform: 'translate(' + marginLeft + ',' + marginTop + ')'
        },
        hexes.map(function (d, i) {
          var attrs = {
            style: style,
            d: sizeHexagonsWithCount ? hex.hexagon(size(d.length)) : hexagonPath,
            fill: color(d.length),
            transform: 'translate(' + d.x + ', ' + d.y + ')',
            key: i,
            onClick: function onClick(e) {
              return _this2._valueClickHandler(d, e);
            },
            onContextMenu: function onContextMenu(e) {
              return _this2._valueRightClickHandler(d, e);
            },
            onMouseOver: function onMouseOver(e) {
              return _this2._valueMouseOverHandler(d, e);
            },
            onMouseOut: function onMouseOut(e) {
              return _this2._valueMouseOutHandler(d, e);
            }
          };
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', attrs);
        })
      );
    }
  }]);

  return HexbinSeries;
}(__WEBPACK_IMPORTED_MODULE_7__abstract_series__["a" /* default */]);

HexbinSeries.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_7__abstract_series__["a" /* default */].propTypes, {
  radius: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
});

HexbinSeries.defaultProps = {
  radius: 20,
  colorRange: __WEBPACK_IMPORTED_MODULE_6__theme__["a" /* CONTINUOUS_COLOR_RANGE */],
  xOffset: 0,
  yOffset: 0
};

HexbinSeries.displayName = 'HexbinSeries';

/* unused harmony default export */ var _unused_webpack_default_export = (HexbinSeries);

/***/ }),
/* 2249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_hexbin__ = __webpack_require__(2250);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_hexbin__["a"]; });



/***/ }),
/* 2250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var thirdPi = Math.PI / 3,
    angles = [0, thirdPi, 2 * thirdPi, 3 * thirdPi, 4 * thirdPi, 5 * thirdPi];

function pointX(d) {
  return d[0];
}

function pointY(d) {
  return d[1];
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x0 = 0,
      y0 = 0,
      x1 = 1,
      y1 = 1,
      x = pointX,
      y = pointY,
      r,
      dx,
      dy;

  function hexbin(points) {
    var binsById = {}, bins = [], i, n = points.length;

    for (i = 0; i < n; ++i) {
      if (isNaN(px = +x.call(null, point = points[i], i, points))
          || isNaN(py = +y.call(null, point, i, points))) continue;

      var point,
          px,
          py,
          pj = Math.round(py = py / dy),
          pi = Math.round(px = px / dx - (pj & 1) / 2),
          py1 = py - pj;

      if (Math.abs(py1) * 3 > 1) {
        var px1 = px - pi,
            pi2 = pi + (px < pi ? -1 : 1) / 2,
            pj2 = pj + (py < pj ? -1 : 1),
            px2 = px - pi2,
            py2 = py - pj2;
        if (px1 * px1 + py1 * py1 > px2 * px2 + py2 * py2) pi = pi2 + (pj & 1 ? 1 : -1) / 2, pj = pj2;
      }

      var id = pi + "-" + pj, bin = binsById[id];
      if (bin) bin.push(point);
      else {
        bins.push(bin = binsById[id] = [point]);
        bin.x = (pi + (pj & 1) / 2) * dx;
        bin.y = pj * dy;
      }
    }

    return bins;
  }

  function hexagon(radius) {
    var x0 = 0, y0 = 0;
    return angles.map(function(angle) {
      var x1 = Math.sin(angle) * radius,
          y1 = -Math.cos(angle) * radius,
          dx = x1 - x0,
          dy = y1 - y0;
      x0 = x1, y0 = y1;
      return [dx, dy];
    });
  }

  hexbin.hexagon = function(radius) {
    return "m" + hexagon(radius == null ? r : +radius).join("l") + "z";
  };

  hexbin.centers = function() {
    var centers = [],
        j = Math.round(y0 / dy),
        i = Math.round(x0 / dx);
    for (var y = j * dy; y < y1 + r; y += dy, ++j) {
      for (var x = i * dx + (j & 1) * dx / 2; x < x1 + dx / 2; x += dx) {
        centers.push([x, y]);
      }
    }
    return centers;
  };

  hexbin.mesh = function() {
    var fragment = hexagon(r).slice(0, 4).join("l");
    return hexbin.centers().map(function(p) { return "M" + p + "m" + fragment; }).join("");
  };

  hexbin.x = function(_) {
    return arguments.length ? (x = _, hexbin) : x;
  };

  hexbin.y = function(_) {
    return arguments.length ? (y = _, hexbin) : y;
  };

  hexbin.radius = function(_) {
    return arguments.length ? (r = +_, dx = r * 2 * Math.sin(thirdPi), dy = r * 1.5, hexbin) : r;
  };

  hexbin.size = function(_) {
    return arguments.length ? (x0 = y0 = 0, x1 = +_[0], y1 = +_[1], hexbin) : [x1 - x0, y1 - y0];
  };

  hexbin.extent = function(_) {
    return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], hexbin) : [[x0, y0], [x1, y1]];
  };

  return hexbin.radius(1);
});


/***/ }),
/* 2251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_data_utils__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__ = __webpack_require__(69);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.









/*
 * Hint provides two options for placement of hint:
 * a) around a data point in one of four quadrants (imagine the point bisected
 *    by two axes -vertical, horizontal- creating 4 quadrants around a data
 *    point).
 * b) **New** pin to an edge of chart/plot area and position along that edge
 *    using data point's other dimension value.
 *
 * To support these two options, deprecate one Hint props (orientation) with two
 * new Hint align prop object (horizontal, vertical) with following values:
 *
 *   horizontal: auto, left, right, leftEdge, rightEdge
 *   vertical: auto, bottom, top, bottomEdge, topEdge
 *
 * Thus, the following ALIGN constants are the values for horizontal
 * and vertical
 */
var ALIGN = {
  AUTO: 'auto',
  LEFT: 'left',
  RIGHT: 'right',
  LEFT_EDGE: 'leftEdge',
  RIGHT_EDGE: 'rightEdge',
  BOTTOM: 'bottom',
  TOP: 'top',
  BOTTOM_EDGE: 'bottomEdge',
  TOP_EDGE: 'topEdge'
};

/**
 * For backwards support, retain the ORIENTATION prop constants
 */
var ORIENTATION = {
  BOTTOM_LEFT: 'bottomleft',
  BOTTOM_RIGHT: 'bottomright',
  TOP_LEFT: 'topleft',
  TOP_RIGHT: 'topright'
};

/**
 * Default format function for the value.
 * @param {Object} value Value.
 * @returns {Array} title-value pairs.
 */
function defaultFormat(value) {
  return Object.keys(value).map(function getProp(key) {
    return { title: key, value: Object(__WEBPACK_IMPORTED_MODULE_2__utils_data_utils__["c" /* transformValueToString */])(value[key]) };
  });
}

var Hint = function (_PureComponent) {
  _inherits(Hint, _PureComponent);

  function Hint() {
    _classCallCheck(this, Hint);

    return _possibleConstructorReturn(this, (Hint.__proto__ || Object.getPrototypeOf(Hint)).apply(this, arguments));
  }

  _createClass(Hint, [{
    key: '_getAlign',


    /**
     * Obtain align object with horizontal and vertical settings
     * but convert any AUTO values to the non-auto ALIGN depending on the
     * values of x and y.
     * @param {number} x X value.
     * @param {number} y Y value.
     * @returns {Object} Align object w/ horizontal, vertical prop strings.
     * @private
     */
    value: function _getAlign(x, y) {
      var _props = this.props,
          innerWidth = _props.innerWidth,
          innerHeight = _props.innerHeight,
          orientation = _props.orientation,
          _props$align = _props.align,
          horizontal = _props$align.horizontal,
          vertical = _props$align.vertical;

      var align = orientation ? this._mapOrientationToAlign(orientation) : { horizontal: horizontal, vertical: vertical };
      if (horizontal === ALIGN.AUTO) {
        align.horizontal = x > innerWidth / 2 ? ALIGN.LEFT : ALIGN.RIGHT;
      }
      if (vertical === ALIGN.AUTO) {
        align.vertical = y > innerHeight / 2 ? ALIGN.TOP : ALIGN.BOTTOM;
      }
      return align;
    }

    /**
     * Get the class names from align values.
     * @param {Object} align object with horizontal and vertical prop strings.
     * @returns {string} Class names.
     * @private
     */

  }, {
    key: '_getAlignClassNames',
    value: function _getAlignClassNames(align) {
      var orientation = this.props.orientation;

      var orientationClass = orientation ? 'rv-hint--orientation-' + orientation : '';
      return orientationClass + ' rv-hint--horizontalAlign-' + align.horizontal + '\n     rv-hint--verticalAlign-' + align.vertical;
    }

    /**
     * Get a CSS mixin for a proper positioning of the element.
     * @param {Object} align object with horizontal and vertical prop strings.
     * @param {number} x X position.
     * @param {number} y Y position.
     * @returns {Object} Object, that may contain `left` or `right, `top` or
     * `bottom` properties.
     * @private
     */

  }, {
    key: '_getAlignStyle',
    value: function _getAlignStyle(align, x, y) {
      return _extends({}, this._getXCSS(align.horizontal, x), this._getYCSS(align.vertical, y));
    }

    /**
     * Get the bottom coordinate of the hint.
     * When y undefined or null, edge case, pin bottom.
     * @param {number} y Y.
     * @returns {{bottom: *}} Mixin.
     * @private
     */

  }, {
    key: '_getCSSBottom',
    value: function _getCSSBottom(y) {
      if (y === undefined || y === null) {
        return {
          bottom: 0
        };
      }

      var _props2 = this.props,
          innerHeight = _props2.innerHeight,
          marginBottom = _props2.marginBottom;

      return {
        bottom: marginBottom + innerHeight - y
      };
    }

    /**
     * Get the left coordinate of the hint.
     * When x undefined or null, edge case, pin left.
     * @param {number} x X.
     * @returns {{left: *}} Mixin.
     * @private
     */

  }, {
    key: '_getCSSLeft',
    value: function _getCSSLeft(x) {
      if (x === undefined || x === null) {
        return {
          left: 0
        };
      }

      var marginLeft = this.props.marginLeft;

      return {
        left: marginLeft + x
      };
    }

    /**
     * Get the right coordinate of the hint.
     * When x undefined or null, edge case, pin right.
     * @param {number} x X.
     * @returns {{right: *}} Mixin.
     * @private
     */

  }, {
    key: '_getCSSRight',
    value: function _getCSSRight(x) {
      if (x === undefined || x === null) {
        return {
          right: 0
        };
      }

      var _props3 = this.props,
          innerWidth = _props3.innerWidth,
          marginRight = _props3.marginRight;

      return {
        right: marginRight + innerWidth - x
      };
    }

    /**
     * Get the top coordinate of the hint.
     * When y undefined or null, edge case, pin top.
     * @param {number} y Y.
     * @returns {{top: *}} Mixin.
     * @private
     */

  }, {
    key: '_getCSSTop',
    value: function _getCSSTop(y) {
      if (y === undefined || y === null) {
        return {
          top: 0
        };
      }

      var marginTop = this.props.marginTop;

      return {
        top: marginTop + y
      };
    }

    /**
     * Get the position for the hint and the appropriate class name.
     * @returns {{style: Object, positionClassName: string}} Style and className for the
     * hint.
     * @private
     */

  }, {
    key: '_getPositionInfo',
    value: function _getPositionInfo() {
      var _props4 = this.props,
          value = _props4.value,
          getAlignStyle = _props4.getAlignStyle;


      var x = Object(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["c" /* getAttributeFunctor */])(this.props, 'x')(value);
      var y = Object(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["c" /* getAttributeFunctor */])(this.props, 'y')(value);

      var align = this._getAlign(x, y);

      return {
        position: getAlignStyle ? getAlignStyle(align, x, y) : this._getAlignStyle(align, x, y),
        positionClassName: this._getAlignClassNames(align)
      };
    }
  }, {
    key: '_getXCSS',
    value: function _getXCSS(horizontal, x) {
      // obtain xCSS
      switch (horizontal) {
        case ALIGN.LEFT_EDGE:
          // this pins x to left edge
          return this._getCSSLeft(null);
        case ALIGN.RIGHT_EDGE:
          // this pins x to left edge
          return this._getCSSRight(null);
        case ALIGN.LEFT:
          // this places hint text to the left of center, so set its right edge
          return this._getCSSRight(x);
        case ALIGN.RIGHT:
        default:
          // this places hint text to the right of center, so set its left edge
          // default case should not be possible but if it happens set to RIGHT
          return this._getCSSLeft(x);
      }
    }
  }, {
    key: '_getYCSS',
    value: function _getYCSS(verticalAlign, y) {
      // obtain yCSS
      switch (verticalAlign) {
        case ALIGN.TOP_EDGE:
          // this pins x to top edge
          return this._getCSSTop(null);
        case ALIGN.BOTTOM_EDGE:
          // this pins x to bottom edge
          return this._getCSSBottom(null);
        case ALIGN.BOTTOM:
          // this places hint text to the bottom of center, so set its top edge
          return this._getCSSTop(y);
        case ALIGN.TOP:
        default:
          // this places hint text to the top of center, so set its bottom edge
          // default case should not be possible but if it happens set to BOTTOM
          return this._getCSSBottom(y);
      }
    }
  }, {
    key: '_mapOrientationToAlign',
    value: function _mapOrientationToAlign(orientation) {
      // TODO: print warning that this feature is deprecated and support will be
      // removed in next major release.
      switch (orientation) {
        case ORIENTATION.BOTTOM_LEFT:
          return {
            horizontal: ALIGN.LEFT,
            vertical: ALIGN.BOTTOM
          };
        case ORIENTATION.BOTTOM_RIGHT:
          return {
            horizontal: ALIGN.RIGHT,
            vertical: ALIGN.BOTTOM
          };
        case ORIENTATION.TOP_LEFT:
          return {
            horizontal: ALIGN.LEFT,
            vertical: ALIGN.TOP
          };
        case ORIENTATION.TOP_RIGHT:
          return {
            horizontal: ALIGN.RIGHT,
            vertical: ALIGN.TOP
          };
        default:
          // fall back to horizontalAlign, verticalAlign that are either
          // provided or defaulted to AUTO.  So, don't change things
          break;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props5 = this.props,
          value = _props5.value,
          format = _props5.format,
          children = _props5.children,
          style = _props5.style,
          className = _props5.className;

      var _getPositionInfo2 = this._getPositionInfo(),
          position = _getPositionInfo2.position,
          positionClassName = _getPositionInfo2.positionClassName;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: 'rv-hint ' + positionClassName + ' ' + className,
          style: _extends({}, style, position, {
            position: 'absolute'
          })
        },
        children ? children : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'rv-hint__content', style: style.content },
          format(value).map(function (formattedProp, i) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { key: 'rv-hint' + i, style: style.row },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'rv-hint__title', style: style.title },
                formattedProp.title
              ),
              ': ',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'rv-hint__value', style: style.value },
                formattedProp.value
              )
            );
          })
        )
      );
    }
  }], [{
    key: 'defaultProps',
    get: function get() {
      return {
        format: defaultFormat,
        align: {
          horizontal: ALIGN.AUTO,
          vertical: ALIGN.AUTO
        },
        style: {}
      };
    }
  }, {
    key: 'propTypes',
    get: function get() {
      return {
        marginTop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
        marginLeft: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
        innerWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
        innerHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
        scales: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
        value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
        format: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
        style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
        className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
        align: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
          horizontal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([ALIGN.AUTO, ALIGN.LEFT, ALIGN.RIGHT, ALIGN.LEFT_EDGE, ALIGN.RIGHT_EDGE]),
          vertical: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([ALIGN.AUTO, ALIGN.BOTTOM, ALIGN.TOP, ALIGN.BOTTOM_EDGE, ALIGN.TOP_EDGE])
        }),
        getAlignStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
        orientation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([ORIENTATION.BOTTOM_LEFT, ORIENTATION.BOTTOM_RIGHT, ORIENTATION.TOP_LEFT, ORIENTATION.TOP_RIGHT])
      };
    }
  }]);

  return Hint;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Hint.displayName = 'Hint';
Hint.ORIENTATION = ORIENTATION;
Hint.ALIGN = ALIGN;

/* harmony default export */ __webpack_exports__["a"] = (Hint);

/***/ }),
/* 2252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__abstract_series__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bar_series__ = __webpack_require__(619);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.






var HorizontalBarSeries = function (_AbstractSeries) {
  _inherits(HorizontalBarSeries, _AbstractSeries);

  function HorizontalBarSeries() {
    _classCallCheck(this, HorizontalBarSeries);

    return _possibleConstructorReturn(this, (HorizontalBarSeries.__proto__ || Object.getPrototypeOf(HorizontalBarSeries)).apply(this, arguments));
  }

  _createClass(HorizontalBarSeries, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bar_series__["a" /* default */], _extends({}, this.props, {
        linePosAttr: 'y',
        valuePosAttr: 'x',
        lineSizeAttr: 'height',
        valueSizeAttr: 'width'
      }));
    }
  }], [{
    key: 'getParentConfig',
    value: function getParentConfig(attr) {
      var isDomainAdjustmentNeeded = attr === 'y';
      var zeroBaseValue = attr === 'x';
      return {
        isDomainAdjustmentNeeded: isDomainAdjustmentNeeded,
        zeroBaseValue: zeroBaseValue
      };
    }
  }]);

  return HorizontalBarSeries;
}(__WEBPACK_IMPORTED_MODULE_1__abstract_series__["a" /* default */]);

HorizontalBarSeries.displayName = 'HorizontalBarSeries';

/* unused harmony default export */ var _unused_webpack_default_export = (HorizontalBarSeries);

/***/ }),
/* 2253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__abstract_series__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bar_series_canvas__ = __webpack_require__(620);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.




var HorizontalBarSeriesCanvas = function (_AbstractSeries) {
  _inherits(HorizontalBarSeriesCanvas, _AbstractSeries);

  function HorizontalBarSeriesCanvas() {
    _classCallCheck(this, HorizontalBarSeriesCanvas);

    return _possibleConstructorReturn(this, (HorizontalBarSeriesCanvas.__proto__ || Object.getPrototypeOf(HorizontalBarSeriesCanvas)).apply(this, arguments));
  }

  _createClass(HorizontalBarSeriesCanvas, [{
    key: 'render',
    value: function render() {
      return null;
    }
  }], [{
    key: 'getParentConfig',
    value: function getParentConfig(attr) {
      var isDomainAdjustmentNeeded = attr === 'y';
      var zeroBaseValue = attr === 'x';
      return {
        isDomainAdjustmentNeeded: isDomainAdjustmentNeeded,
        zeroBaseValue: zeroBaseValue
      };
    }
  }, {
    key: 'renderLayer',
    value: function renderLayer(props, ctx) {
      __WEBPACK_IMPORTED_MODULE_1__bar_series_canvas__["a" /* default */].renderLayer(_extends({}, props, {
        linePosAttr: 'y',
        valuePosAttr: 'x',
        lineSizeAttr: 'height',
        valueSizeAttr: 'width'
      }), ctx);
    }
  }, {
    key: 'requiresSVG',
    get: function get() {
      return false;
    }
  }, {
    key: 'isCanvas',
    get: function get() {
      return true;
    }
  }]);

  return HorizontalBarSeriesCanvas;
}(__WEBPACK_IMPORTED_MODULE_0__abstract_series__["a" /* default */]);

HorizontalBarSeriesCanvas.displayName = 'HorizontalBarSeriesCanvas';
HorizontalBarSeriesCanvas.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_0__abstract_series__["a" /* default */].propTypes);

/* unused harmony default export */ var _unused_webpack_default_export = (HorizontalBarSeriesCanvas);

/***/ }),
/* 2254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__grid_lines__ = __webpack_require__(367);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.








var HORIZONTAL = __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__["a" /* DIRECTION */].HORIZONTAL;


var propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_3__grid_lines__["a" /* default */].propTypes, {
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([HORIZONTAL])
});

var defaultProps = {
  direction: HORIZONTAL,
  attr: 'y'
};

function HorizontalGridLines(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__grid_lines__["a" /* default */], props);
}

HorizontalGridLines.displayName = 'HorizontalGridLines';
HorizontalGridLines.propTypes = propTypes;
HorizontalGridLines.defaultProps = defaultProps;
HorizontalGridLines.requiresSVG = true;

/* unused harmony default export */ var _unused_webpack_default_export = (HorizontalGridLines);

/***/ }),
/* 2255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__abstract_series__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rect_series__ = __webpack_require__(368);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.






var HorizontalRectSeries = function (_AbstractSeries) {
  _inherits(HorizontalRectSeries, _AbstractSeries);

  function HorizontalRectSeries() {
    _classCallCheck(this, HorizontalRectSeries);

    return _possibleConstructorReturn(this, (HorizontalRectSeries.__proto__ || Object.getPrototypeOf(HorizontalRectSeries)).apply(this, arguments));
  }

  _createClass(HorizontalRectSeries, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__rect_series__["a" /* default */], _extends({}, this.props, {
        linePosAttr: 'y',
        valuePosAttr: 'x',
        lineSizeAttr: 'height',
        valueSizeAttr: 'width'
      }));
    }
  }], [{
    key: 'getParentConfig',
    value: function getParentConfig(attr) {
      var isDomainAdjustmentNeeded = false;
      var zeroBaseValue = attr === 'x';
      return {
        isDomainAdjustmentNeeded: isDomainAdjustmentNeeded,
        zeroBaseValue: zeroBaseValue
      };
    }
  }]);

  return HorizontalRectSeries;
}(__WEBPACK_IMPORTED_MODULE_1__abstract_series__["a" /* default */]);

HorizontalRectSeries.displayName = 'HorizontalRectSeries';

/* unused harmony default export */ var _unused_webpack_default_export = (HorizontalRectSeries);

/***/ }),
/* 2256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__abstract_series__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rect_series_canvas__ = __webpack_require__(369);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.




var HorizontalRectSeriesCanvas = function (_AbstractSeries) {
  _inherits(HorizontalRectSeriesCanvas, _AbstractSeries);

  function HorizontalRectSeriesCanvas() {
    _classCallCheck(this, HorizontalRectSeriesCanvas);

    return _possibleConstructorReturn(this, (HorizontalRectSeriesCanvas.__proto__ || Object.getPrototypeOf(HorizontalRectSeriesCanvas)).apply(this, arguments));
  }

  _createClass(HorizontalRectSeriesCanvas, [{
    key: 'render',
    value: function render() {
      return null;
    }
  }], [{
    key: 'getParentConfig',
    value: function getParentConfig(attr) {
      var isDomainAdjustmentNeeded = false;
      var zeroBaseValue = attr === 'x';
      return {
        isDomainAdjustmentNeeded: isDomainAdjustmentNeeded,
        zeroBaseValue: zeroBaseValue
      };
    }
  }, {
    key: 'renderLayer',
    value: function renderLayer(props, ctx) {
      __WEBPACK_IMPORTED_MODULE_1__rect_series_canvas__["a" /* default */].renderLayer(_extends({}, props, {
        linePosAttr: 'y',
        valuePosAttr: 'x',
        lineSizeAttr: 'height',
        valueSizeAttr: 'width'
      }), ctx);
    }
  }, {
    key: 'requiresSVG',
    get: function get() {
      return false;
    }
  }, {
    key: 'isCanvas',
    get: function get() {
      return true;
    }
  }]);

  return HorizontalRectSeriesCanvas;
}(__WEBPACK_IMPORTED_MODULE_0__abstract_series__["a" /* default */]);

HorizontalRectSeriesCanvas.displayName = 'HorizontalRectSeriesCanvas';
HorizontalRectSeriesCanvas.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_0__abstract_series__["a" /* default */].propTypes);

/* unused harmony default export */ var _unused_webpack_default_export = (HorizontalRectSeriesCanvas);

/***/ }),
/* 2257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__abstract_series__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mark_series_canvas__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__line_series_canvas__ = __webpack_require__(623);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.





var LineMarkSeriesCanvas = function (_AbstractSeries) {
  _inherits(LineMarkSeriesCanvas, _AbstractSeries);

  function LineMarkSeriesCanvas() {
    _classCallCheck(this, LineMarkSeriesCanvas);

    return _possibleConstructorReturn(this, (LineMarkSeriesCanvas.__proto__ || Object.getPrototypeOf(LineMarkSeriesCanvas)).apply(this, arguments));
  }

  _createClass(LineMarkSeriesCanvas, [{
    key: 'render',
    value: function render() {
      return null;
    }
  }], [{
    key: 'renderLayer',
    value: function renderLayer(props, ctx) {
      __WEBPACK_IMPORTED_MODULE_2__line_series_canvas__["a" /* default */].renderLayer(props, ctx);
      __WEBPACK_IMPORTED_MODULE_1__mark_series_canvas__["a" /* default */].renderLayer(props, ctx);
    }
  }, {
    key: 'requiresSVG',
    get: function get() {
      return false;
    }
  }, {
    key: 'isCanvas',
    get: function get() {
      return true;
    }
  }]);

  return LineMarkSeriesCanvas;
}(__WEBPACK_IMPORTED_MODULE_0__abstract_series__["a" /* default */]);

LineMarkSeriesCanvas.displayName = 'LineMarkSeriesCanvas';
LineMarkSeriesCanvas.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_0__abstract_series__["a" /* default */].propTypes);

/* unused harmony default export */ var _unused_webpack_default_export = (LineMarkSeriesCanvas);

/***/ }),
/* 2258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__abstract_series__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bar_series__ = __webpack_require__(619);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.






var VerticalBarSeries = function (_AbstractSeries) {
  _inherits(VerticalBarSeries, _AbstractSeries);

  function VerticalBarSeries() {
    _classCallCheck(this, VerticalBarSeries);

    return _possibleConstructorReturn(this, (VerticalBarSeries.__proto__ || Object.getPrototypeOf(VerticalBarSeries)).apply(this, arguments));
  }

  _createClass(VerticalBarSeries, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bar_series__["a" /* default */], _extends({}, this.props, {
        linePosAttr: 'x',
        valuePosAttr: 'y',
        lineSizeAttr: 'width',
        valueSizeAttr: 'height'
      }));
    }
  }], [{
    key: 'getParentConfig',
    value: function getParentConfig(attr) {
      var isDomainAdjustmentNeeded = attr === 'x';
      var zeroBaseValue = attr === 'y';
      return {
        isDomainAdjustmentNeeded: isDomainAdjustmentNeeded,
        zeroBaseValue: zeroBaseValue
      };
    }
  }]);

  return VerticalBarSeries;
}(__WEBPACK_IMPORTED_MODULE_1__abstract_series__["a" /* default */]);

VerticalBarSeries.displayName = 'VerticalBarSeries';

/* unused harmony default export */ var _unused_webpack_default_export = (VerticalBarSeries);

/***/ }),
/* 2259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__abstract_series__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bar_series_canvas__ = __webpack_require__(620);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.




var HorizontalBarSeriesCanvas = function (_AbstractSeries) {
  _inherits(HorizontalBarSeriesCanvas, _AbstractSeries);

  function HorizontalBarSeriesCanvas() {
    _classCallCheck(this, HorizontalBarSeriesCanvas);

    return _possibleConstructorReturn(this, (HorizontalBarSeriesCanvas.__proto__ || Object.getPrototypeOf(HorizontalBarSeriesCanvas)).apply(this, arguments));
  }

  _createClass(HorizontalBarSeriesCanvas, [{
    key: 'render',
    value: function render() {
      return null;
    }
  }], [{
    key: 'getParentConfig',
    value: function getParentConfig(attr) {
      var isDomainAdjustmentNeeded = attr === 'x';
      var zeroBaseValue = attr === 'y';
      return {
        isDomainAdjustmentNeeded: isDomainAdjustmentNeeded,
        zeroBaseValue: zeroBaseValue
      };
    }
  }, {
    key: 'renderLayer',
    value: function renderLayer(props, ctx) {
      __WEBPACK_IMPORTED_MODULE_1__bar_series_canvas__["a" /* default */].renderLayer(_extends({}, props, {
        linePosAttr: 'x',
        valuePosAttr: 'y',
        lineSizeAttr: 'width',
        valueSizeAttr: 'height'
      }), ctx);
    }
  }, {
    key: 'requiresSVG',
    get: function get() {
      return false;
    }
  }, {
    key: 'isCanvas',
    get: function get() {
      return true;
    }
  }]);

  return HorizontalBarSeriesCanvas;
}(__WEBPACK_IMPORTED_MODULE_0__abstract_series__["a" /* default */]);

HorizontalBarSeriesCanvas.displayName = 'HorizontalBarSeriesCanvas';
HorizontalBarSeriesCanvas.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_0__abstract_series__["a" /* default */].propTypes);

/* unused harmony default export */ var _unused_webpack_default_export = (HorizontalBarSeriesCanvas);

/***/ }),
/* 2260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__grid_lines__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_axis_utils__ = __webpack_require__(82);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.








var VERTICAL = __WEBPACK_IMPORTED_MODULE_3__utils_axis_utils__["a" /* DIRECTION */].VERTICAL;


var propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_2__grid_lines__["a" /* default */].propTypes, {
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([VERTICAL])
});

var defaultProps = {
  direction: VERTICAL,
  attr: 'x'
};

function VerticalGridLines(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__grid_lines__["a" /* default */], props);
}

VerticalGridLines.displayName = 'VerticalGridLines';
VerticalGridLines.propTypes = propTypes;
VerticalGridLines.defaultProps = defaultProps;
VerticalGridLines.requiresSVG = true;

/* unused harmony default export */ var _unused_webpack_default_export = (VerticalGridLines);

/***/ }),
/* 2261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__abstract_series__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rect_series_canvas__ = __webpack_require__(369);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.




var HorizontalRectSeriesCanvas = function (_AbstractSeries) {
  _inherits(HorizontalRectSeriesCanvas, _AbstractSeries);

  function HorizontalRectSeriesCanvas() {
    _classCallCheck(this, HorizontalRectSeriesCanvas);

    return _possibleConstructorReturn(this, (HorizontalRectSeriesCanvas.__proto__ || Object.getPrototypeOf(HorizontalRectSeriesCanvas)).apply(this, arguments));
  }

  _createClass(HorizontalRectSeriesCanvas, [{
    key: 'render',
    value: function render() {
      return null;
    }
  }], [{
    key: 'getParentConfig',
    value: function getParentConfig(attr) {
      var isDomainAdjustmentNeeded = false;
      var zeroBaseValue = attr === 'y';
      return {
        isDomainAdjustmentNeeded: isDomainAdjustmentNeeded,
        zeroBaseValue: zeroBaseValue
      };
    }
  }, {
    key: 'renderLayer',
    value: function renderLayer(props, ctx) {
      __WEBPACK_IMPORTED_MODULE_1__rect_series_canvas__["a" /* default */].renderLayer(_extends({}, props, {
        linePosAttr: 'x',
        valuePosAttr: 'y',
        lineSizeAttr: 'width',
        valueSizeAttr: 'height'
      }), ctx);
    }
  }, {
    key: 'requiresSVG',
    get: function get() {
      return false;
    }
  }, {
    key: 'isCanvas',
    get: function get() {
      return true;
    }
  }]);

  return HorizontalRectSeriesCanvas;
}(__WEBPACK_IMPORTED_MODULE_0__abstract_series__["a" /* default */]);

HorizontalRectSeriesCanvas.displayName = 'HorizontalRectSeriesCanvas';
HorizontalRectSeriesCanvas.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_0__abstract_series__["a" /* default */].propTypes);

/* unused harmony default export */ var _unused_webpack_default_export = (HorizontalRectSeriesCanvas);

/***/ }),
/* 2262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__animation__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_series_utils__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__theme__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__abstract_series__ = __webpack_require__(48);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.











var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--whisker';
var DEFAULT_STROKE_WIDTH = 1;
var DEFAULT_CROSS_BAR_WIDTH = 6;

/**
 * Render whisker lines for a data point.
 * @param {Object} whiskerMarkProps All the properties of the whisker mark.
 * @private
 */
var renderWhiskerMark = function renderWhiskerMark(whiskerMarkProps) {
  return function (d, i) {
    var crossBarWidth = whiskerMarkProps.crossBarWidth,
        opacityFunctor = whiskerMarkProps.opacityFunctor,
        sizeFunctor = whiskerMarkProps.sizeFunctor,
        strokeFunctor = whiskerMarkProps.strokeFunctor,
        strokeWidth = whiskerMarkProps.strokeWidth,
        style = whiskerMarkProps.style,
        valueClickHandler = whiskerMarkProps.valueClickHandler,
        valueMouseOutHandler = whiskerMarkProps.valueMouseOutHandler,
        valueMouseOverHandler = whiskerMarkProps.valueMouseOverHandler,
        valueRightClickHandler = whiskerMarkProps.valueRightClickHandler,
        xFunctor = whiskerMarkProps.xFunctor,
        yFunctor = whiskerMarkProps.yFunctor;


    var r = sizeFunctor ? sizeFunctor(d) : 0;
    var cx = xFunctor(d);
    var cy = yFunctor(d);
    var positiveXVariance = xFunctor({ x: d.x + d.xVariance / 2 });
    var negativeXVariance = xFunctor({ x: d.x - d.xVariance / 2 });
    var positiveYVariance = yFunctor({ y: d.y + d.yVariance / 2 });
    var negativeYVariance = yFunctor({ y: d.y - d.yVariance / 2 });
    /**
     * Determine whether on not we should draw whiskers in each direction.
     * We need to see an actual variance value, and also have that value extend past the
     * radius "buffer" region in which we won't be drawing (if any).
     */
    var hasXWhiskers = positiveXVariance && cx + r < positiveXVariance;
    var hasYWhiskers = positiveYVariance && cy - r > positiveYVariance;
    if (!hasXWhiskers && !hasYWhiskers) {
      return null;
    }

    var styleAttr = _extends({
      opacity: opacityFunctor ? opacityFunctor(d) : __WEBPACK_IMPORTED_MODULE_4__theme__["c" /* DEFAULT_OPACITY */],
      stroke: strokeFunctor && strokeFunctor(d),
      strokeWidth: strokeWidth || DEFAULT_STROKE_WIDTH
    }, style);
    var crossBarExtension = crossBarWidth / 2;

    var rightLineAttrs = {
      x1: cx + r,
      y1: cy,
      x2: positiveXVariance,
      y2: cy,
      style: styleAttr
    };
    var leftLineAttrs = {
      x1: cx - r,
      y1: cy,
      x2: negativeXVariance,
      y2: cy,
      style: styleAttr
    };
    var rightCrossBarAttrs = {
      x1: positiveXVariance,
      y1: cy - crossBarExtension,
      x2: positiveXVariance,
      y2: cy + crossBarExtension,
      style: styleAttr
    };
    var leftCrossBarAttrs = {
      x1: negativeXVariance,
      y1: cy - crossBarExtension,
      x2: negativeXVariance,
      y2: cy + crossBarExtension,
      style: styleAttr
    };

    var upperLineAttrs = {
      x1: cx,
      y1: cy - r,
      x2: cx,
      y2: positiveYVariance,
      style: styleAttr
    };
    var lowerLineAttrs = {
      x1: cx,
      y1: cy + r,
      x2: cx,
      y2: negativeYVariance,
      style: styleAttr
    };
    var upperCrossBarAttrs = {
      x1: cx - crossBarExtension,
      y1: positiveYVariance,
      x2: cx + crossBarExtension,
      y2: positiveYVariance,
      style: styleAttr
    };
    var lowerCrossBarAttrs = {
      x1: cx - crossBarExtension,
      y1: negativeYVariance,
      x2: cx + crossBarExtension,
      y2: negativeYVariance,
      style: styleAttr
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      {
        className: 'mark-whiskers',
        key: i,
        onClick: function onClick(e) {
          return valueClickHandler(d, e);
        },
        onContextMenu: function onContextMenu(e) {
          return valueRightClickHandler(d, e);
        },
        onMouseOver: function onMouseOver(e) {
          return valueMouseOverHandler(d, e);
        },
        onMouseOut: function onMouseOut(e) {
          return valueMouseOutHandler(d, e);
        }
      },
      hasXWhiskers ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        { className: 'x-whiskers' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line', rightLineAttrs),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line', leftLineAttrs),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line', rightCrossBarAttrs),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line', leftCrossBarAttrs)
      ) : null,
      hasYWhiskers ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        { className: 'y-whiskers' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line', upperLineAttrs),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line', lowerLineAttrs),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line', upperCrossBarAttrs),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line', lowerCrossBarAttrs)
      ) : null
    );
  };
};

var WhiskerSeries = function (_AbstractSeries) {
  _inherits(WhiskerSeries, _AbstractSeries);

  function WhiskerSeries() {
    _classCallCheck(this, WhiskerSeries);

    return _possibleConstructorReturn(this, (WhiskerSeries.__proto__ || Object.getPrototypeOf(WhiskerSeries)).apply(this, arguments));
  }

  _createClass(WhiskerSeries, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          animation = _props.animation,
          className = _props.className,
          crossBarWidth = _props.crossBarWidth,
          data = _props.data,
          marginLeft = _props.marginLeft,
          marginTop = _props.marginTop,
          strokeWidth = _props.strokeWidth,
          style = _props.style;

      if (!data) {
        return null;
      }
      if (animation) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__animation__["b" /* default */],
          _extends({}, this.props, { animatedProps: __WEBPACK_IMPORTED_MODULE_3__utils_series_utils__["a" /* ANIMATED_SERIES_PROPS */] }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WhiskerSeries, _extends({}, this.props, { animation: null }))
        );
      }

      var whiskerMarkProps = {
        crossBarWidth: crossBarWidth,
        opacityFunctor: this._getAttributeFunctor('opacity'),
        sizeFunctor: this._getAttributeFunctor('size'),
        strokeFunctor: this._getAttributeFunctor('stroke') || this._getAttributeFunctor('color'),
        strokeWidth: strokeWidth,
        style: style,
        xFunctor: this._getAttributeFunctor('x'),
        yFunctor: this._getAttributeFunctor('y'),
        valueClickHandler: this._valueClickHandler,
        valueRightClickHandler: this._valueRightClickHandler,
        valueMouseOverHandler: this._valueMouseOverHandler,
        valueMouseOutHandler: this._valueMouseOutHandler
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        {
          className: predefinedClassName + ' ' + className,
          transform: 'translate(' + marginLeft + ',' + marginTop + ')'
        },
        data.map(renderWhiskerMark(whiskerMarkProps))
      );
    }
  }]);

  return WhiskerSeries;
}(__WEBPACK_IMPORTED_MODULE_5__abstract_series__["a" /* default */]);

WhiskerSeries.displayName = 'WhiskerSeries';
WhiskerSeries.propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_5__abstract_series__["a" /* default */].propTypes, {
  strokeWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
});
WhiskerSeries.defaultProps = _extends({}, __WEBPACK_IMPORTED_MODULE_5__abstract_series__["a" /* default */].defaultProps, {
  crossBarWidth: DEFAULT_CROSS_BAR_WIDTH,
  size: 0,
  strokeWidth: DEFAULT_STROKE_WIDTH
});
/* unused harmony default export */ var _unused_webpack_default_export = (WhiskerSeries);

/***/ }),
/* 2263 */
/***/ (function(module, exports, __webpack_require__) {

var objectKeys = __webpack_require__(626);
var isArguments = __webpack_require__(2265);
var is = __webpack_require__(2269);
var isRegex = __webpack_require__(2272);
var flags = __webpack_require__(2273);
var isDate = __webpack_require__(2276);

var getTime = Date.prototype.getTime;

function deepEqual(actual, expected, options) {
  var opts = options || {};

  // 7.1. All identical values are equivalent, as determined by ===.
  if (opts.strict ? is(actual, expected) : actual === expected) {
    return true;
  }

  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
  if (!actual || !expected || (typeof actual !== 'object' && typeof expected !== 'object')) {
    return opts.strict ? is(actual, expected) : actual == expected;
  }

  /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */
  // eslint-disable-next-line no-use-before-define
  return objEquiv(actual, expected, opts);
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer(x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
    return false;
  }
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') {
    return false;
  }
  return true;
}

function objEquiv(a, b, opts) {
  /* eslint max-statements: [2, 50] */
  var i, key;
  if (typeof a !== typeof b) { return false; }
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) { return false; }

  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) { return false; }

  if (isArguments(a) !== isArguments(b)) { return false; }

  var aIsRegex = isRegex(a);
  var bIsRegex = isRegex(b);
  if (aIsRegex !== bIsRegex) { return false; }
  if (aIsRegex || bIsRegex) {
    return a.source === b.source && flags(a) === flags(b);
  }

  if (isDate(a) && isDate(b)) {
    return getTime.call(a) === getTime.call(b);
  }

  var aIsBuffer = isBuffer(a);
  var bIsBuffer = isBuffer(b);
  if (aIsBuffer !== bIsBuffer) { return false; }
  if (aIsBuffer || bIsBuffer) { // && would work too, because both are true or both false here
    if (a.length !== b.length) { return false; }
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) { return false; }
    }
    return true;
  }

  if (typeof a !== typeof b) { return false; }

  try {
    var ka = objectKeys(a);
    var kb = objectKeys(b);
  } catch (e) { // happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates hasOwnProperty)
  if (ka.length !== kb.length) { return false; }

  // the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  // ~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i]) { return false; }
  }
  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) { return false; }
  }

  return true;
}

module.exports = deepEqual;


/***/ }),
/* 2264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = __webpack_require__(627); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;


/***/ }),
/* 2265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasToStringTag = __webpack_require__(372)();
var callBound = __webpack_require__(629);

var $toString = callBound('Object.prototype.toString');

var isStandardArguments = function isArguments(value) {
	if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
		return false;
	}
	return $toString(value) === '[object Arguments]';
};

var isLegacyArguments = function isArguments(value) {
	if (isStandardArguments(value)) {
		return true;
	}
	return value !== null &&
		typeof value === 'object' &&
		typeof value.length === 'number' &&
		value.length >= 0 &&
		$toString(value) !== '[object Array]' &&
		$toString(value.callee) === '[object Function]';
};

var supportsStandardArguments = (function () {
	return isStandardArguments(arguments);
}());

isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ }),
/* 2266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(628);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),
/* 2267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),
/* 2268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(374);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),
/* 2269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(203);
var callBind = __webpack_require__(375);

var implementation = __webpack_require__(630);
var getPolyfill = __webpack_require__(631);
var shim = __webpack_require__(2271);

var polyfill = callBind(getPolyfill(), Object);

define(polyfill, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = polyfill;


/***/ }),
/* 2270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(373);

var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);

var hasPropertyDescriptors = function hasPropertyDescriptors() {
	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
			return true;
		} catch (e) {
			// IE 8 has a broken defineProperty
			return false;
		}
	}
	return false;
};

hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
	// node v0.6 has a bug where array lengths can be Set but not Defined
	if (!hasPropertyDescriptors()) {
		return null;
	}
	try {
		return $defineProperty([], 'length', { value: 1 }).length !== 1;
	} catch (e) {
		// In Firefox 4-22, defining length on an array throws an exception.
		return true;
	}
};

module.exports = hasPropertyDescriptors;


/***/ }),
/* 2271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getPolyfill = __webpack_require__(631);
var define = __webpack_require__(203);

module.exports = function shimObjectIs() {
	var polyfill = getPolyfill();
	define(Object, { is: polyfill }, {
		is: function testObjectIs() {
			return Object.is !== polyfill;
		}
	});
	return polyfill;
};


/***/ }),
/* 2272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var callBound = __webpack_require__(629);
var hasToStringTag = __webpack_require__(372)();
var has;
var $exec;
var isRegexMarker;
var badStringifier;

if (hasToStringTag) {
	has = callBound('Object.prototype.hasOwnProperty');
	$exec = callBound('RegExp.prototype.exec');
	isRegexMarker = {};

	var throwRegexMarker = function () {
		throw isRegexMarker;
	};
	badStringifier = {
		toString: throwRegexMarker,
		valueOf: throwRegexMarker
	};

	if (typeof Symbol.toPrimitive === 'symbol') {
		badStringifier[Symbol.toPrimitive] = throwRegexMarker;
	}
}

var $toString = callBound('Object.prototype.toString');
var gOPD = Object.getOwnPropertyDescriptor;
var regexClass = '[object RegExp]';

module.exports = hasToStringTag
	// eslint-disable-next-line consistent-return
	? function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}

		var descriptor = gOPD(value, 'lastIndex');
		var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
		if (!hasLastIndexDataProperty) {
			return false;
		}

		try {
			$exec(value, badStringifier);
		} catch (e) {
			return e === isRegexMarker;
		}
	}
	: function isRegex(value) {
		// In older browsers, typeof regex incorrectly returns 'function'
		if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
			return false;
		}

		return $toString(value) === regexClass;
	};


/***/ }),
/* 2273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(203);
var callBind = __webpack_require__(375);

var implementation = __webpack_require__(632);
var getPolyfill = __webpack_require__(633);
var shim = __webpack_require__(2275);

var flagsBound = callBind(getPolyfill());

define(flagsBound, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = flagsBound;


/***/ }),
/* 2274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var functionsHaveNames = function functionsHaveNames() {
	return typeof function f() {}.name === 'string';
};

var gOPD = Object.getOwnPropertyDescriptor;
if (gOPD) {
	try {
		gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		gOPD = null;
	}
}

functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
	if (!functionsHaveNames() || !gOPD) {
		return false;
	}
	var desc = gOPD(function () {}, 'name');
	return !!desc && !!desc.configurable;
};

var $bind = Function.prototype.bind;

functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
	return functionsHaveNames() && typeof $bind === 'function' && function f() {}.bind().name !== '';
};

module.exports = functionsHaveNames;


/***/ }),
/* 2275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var supportsDescriptors = __webpack_require__(203).supportsDescriptors;
var getPolyfill = __webpack_require__(633);
var gOPD = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var TypeErr = TypeError;
var getProto = Object.getPrototypeOf;
var regex = /a/;

module.exports = function shimFlags() {
	if (!supportsDescriptors || !getProto) {
		throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
	}
	var polyfill = getPolyfill();
	var proto = getProto(regex);
	var descriptor = gOPD(proto, 'flags');
	if (!descriptor || descriptor.get !== polyfill) {
		defineProperty(proto, 'flags', {
			configurable: true,
			enumerable: false,
			get: polyfill
		});
	}
	return polyfill;
};


/***/ }),
/* 2276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateGetDayCall(value) {
	try {
		getDay.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag = __webpack_require__(372)();

module.exports = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) {
		return false;
	}
	return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};


/***/ }),
/* 2277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_interpolate__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__animation__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_series_utils__ = __webpack_require__(66);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.








var MAX_DRAWS = 30;

/**
 * Draw loop draws each of the layers until it should draw more
 * @param {CanvasContext} ctx - the context where the drawing will take place
 * @param {Number} height - height of the canvas
 * @param {Number} width - width of the canvas
 * @param {Array} layers - the layer objects to render
 */
function engageDrawLoop(ctx, height, width, layers) {
  var drawIteration = 0;
  // using setInterval because request animation frame goes too fast
  var drawCycle = setInterval(function () {
    if (!ctx) {
      clearInterval(drawCycle);
      return;
    }
    drawLayers(ctx, height, width, layers, drawIteration);
    if (drawIteration > MAX_DRAWS) {
      clearInterval(drawCycle);
    }
    drawIteration += 1;
  }, 1);
}

/**
 * Loops across each of the layers to be drawn and draws them
 * @param {CanvasContext} ctx - the context where the drawing will take place
 * @param {Number} height - height of the canvas
 * @param {Number} width - width of the canvas
 * @param {Array} layers - the layer objects to render
 * @param {Number} drawIteration - width of the canvas
 */
function drawLayers(ctx, height, width, layers, drawIteration) {
  ctx.clearRect(0, 0, width, height);
  layers.forEach(function (layer) {
    var interpolator = layer.interpolator,
        newProps = layer.newProps,
        animation = layer.animation;
    // return an empty object if dont need to be animating

    var interpolatedProps = animation ? interpolator ? interpolator(drawIteration / MAX_DRAWS) : interpolator : function () {
      return {};
    };
    layer.renderLayer(_extends({}, newProps, interpolatedProps), ctx);
  });
}

/**
 * Build an array of layer of objects the contain the method for drawing each series
 * as well as an interpolar (specifically a d3-interpolate interpolator)
 * @param {Object} newChildren the new children to be rendered.
 * @param {Object} oldChildren the old children to be rendered.
 * @returns {Array} Object for rendering
 */
function buildLayers(newChildren, oldChildren) {
  return newChildren.map(function (child, index) {
    var oldProps = oldChildren[index] ? oldChildren[index].props : {};
    var newProps = child.props;

    var oldAnimatedProps = Object(__WEBPACK_IMPORTED_MODULE_3__animation__["c" /* extractAnimatedPropValues */])(_extends({}, oldProps, {
      animatedProps: __WEBPACK_IMPORTED_MODULE_4__utils_series_utils__["a" /* ANIMATED_SERIES_PROPS */]
    }));
    var newAnimatedProps = newProps ? Object(__WEBPACK_IMPORTED_MODULE_3__animation__["c" /* extractAnimatedPropValues */])(_extends({}, newProps, {
      animatedProps: __WEBPACK_IMPORTED_MODULE_4__utils_series_utils__["a" /* ANIMATED_SERIES_PROPS */]
    })) : null;
    var interpolator = Object(__WEBPACK_IMPORTED_MODULE_2_d3_interpolate__["a" /* interpolate */])(oldAnimatedProps, newAnimatedProps);

    return {
      renderLayer: child.type.renderLayer,
      newProps: child.props,
      animation: child.props.animation,
      interpolator: interpolator
    };
  });
}

var CanvasWrapper = function (_Component) {
  _inherits(CanvasWrapper, _Component);

  function CanvasWrapper() {
    _classCallCheck(this, CanvasWrapper);

    return _possibleConstructorReturn(this, (CanvasWrapper.__proto__ || Object.getPrototypeOf(CanvasWrapper)).apply(this, arguments));
  }

  _createClass(CanvasWrapper, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var ctx = this.canvas.getContext('2d');
      if (!ctx) {
        return;
      }
      var pixelRatio = this.props.pixelRatio;

      if (!ctx) {
        return;
      }
      ctx.scale(pixelRatio, pixelRatio);

      this.drawChildren(null, this.props, ctx);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(oldProps) {
      this.drawChildren(oldProps, this.props, this.canvas.getContext('2d'));
    }

    /**
     * Check that we can and should be animating, then kick off animations as apporpriate
     * @param {Object} newProps the new props to be interpolated to
     * @param {Object} oldProps the old props to be interpolated against
     * @param {DomRef} ctx the canvas context to be drawn on.
     * @returns {Array} Object for rendering
     */

  }, {
    key: 'drawChildren',
    value: function drawChildren(oldProps, newProps, ctx) {
      var children = newProps.children,
          innerHeight = newProps.innerHeight,
          innerWidth = newProps.innerWidth,
          marginBottom = newProps.marginBottom,
          marginLeft = newProps.marginLeft,
          marginRight = newProps.marginRight,
          marginTop = newProps.marginTop;

      if (!ctx) {
        return;
      }

      var childrenShouldAnimate = children.find(function (child) {
        return child.props.animation;
      });

      var height = innerHeight + marginTop + marginBottom;
      var width = innerWidth + marginLeft + marginRight;
      var layers = buildLayers(newProps.children, oldProps ? oldProps.children : []);
      // if we don't need to be animating, dont! cut short
      if (!childrenShouldAnimate) {
        drawLayers(ctx, height, width, layers);
        return;
      }

      engageDrawLoop(ctx, height, width, layers);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          innerHeight = _props.innerHeight,
          innerWidth = _props.innerWidth,
          marginBottom = _props.marginBottom,
          marginLeft = _props.marginLeft,
          marginRight = _props.marginRight,
          marginTop = _props.marginTop,
          pixelRatio = _props.pixelRatio;


      var height = innerHeight + marginTop + marginBottom;
      var width = innerWidth + marginLeft + marginRight;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { left: 0, top: 0 }, className: 'rv-xy-canvas' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('canvas', {
          className: 'rv-xy-canvas-element',
          height: height * pixelRatio,
          width: width * pixelRatio,
          style: {
            height: height + 'px',
            width: width + 'px'
          },
          ref: function ref(_ref) {
            return _this2.canvas = _ref;
          }
        }),
        this.props.children
      );
    }
  }], [{
    key: 'defaultProps',
    get: function get() {
      return {
        pixelRatio: window && window.devicePixelRatio || 1
      };
    }
  }]);

  return CanvasWrapper;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

CanvasWrapper.displayName = 'CanvasWrapper';
CanvasWrapper.propTypes = {
  marginBottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  marginLeft: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  marginRight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  marginTop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  innerHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  innerWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  pixelRatio: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (CanvasWrapper);

/***/ }),
/* 2278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__axis__ = __webpack_require__(634);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.









var TOP = __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__["b" /* ORIENTATION */].TOP,
    BOTTOM = __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__["b" /* ORIENTATION */].BOTTOM;


var propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_3__axis__["a" /* default */].propTypes, {
  orientation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([TOP, BOTTOM])
});

var defaultProps = {
  orientation: BOTTOM,
  attr: 'x',
  attrAxis: 'y'
};

function XAxis(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__axis__["a" /* default */], props);
}

XAxis.displayName = 'XAxis';
XAxis.propTypes = propTypes;
XAxis.defaultProps = defaultProps;
XAxis.requiresSVG = true;

/* unused harmony default export */ var _unused_webpack_default_export = (XAxis);

/***/ }),
/* 2279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__ = __webpack_require__(82);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.







var LEFT = __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__["b" /* ORIENTATION */].LEFT,
    RIGHT = __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__["b" /* ORIENTATION */].RIGHT,
    TOP = __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__["b" /* ORIENTATION */].TOP,
    BOTTOM = __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__["b" /* ORIENTATION */].BOTTOM;


var propTypes = {
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  orientation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([LEFT, RIGHT, TOP, BOTTOM]).isRequired,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};

var defaultProps = {
  style: {}
};

function AxisLine(_ref) {
  var orientation = _ref.orientation,
      width = _ref.width,
      height = _ref.height,
      style = _ref.style;

  var lineProps = void 0;
  if (orientation === LEFT) {
    lineProps = {
      x1: width,
      x2: width,
      y1: 0,
      y2: height
    };
  } else if (orientation === RIGHT) {
    lineProps = {
      x1: 0,
      x2: 0,
      y1: 0,
      y2: height
    };
  } else if (orientation === TOP) {
    lineProps = {
      x1: 0,
      x2: width,
      y1: height,
      y2: height
    };
  } else {
    lineProps = {
      x1: 0,
      x2: width,
      y1: 0,
      y2: 0
    };
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line', _extends({}, lineProps, { className: 'rv-xy-plot__axis__line', style: style }));
}

AxisLine.defaultProps = defaultProps;
AxisLine.displayName = 'AxisLine';
AxisLine.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (AxisLine);

/***/ }),
/* 2280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__ = __webpack_require__(69);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.








var LEFT = __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__["b" /* ORIENTATION */].LEFT,
    RIGHT = __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__["b" /* ORIENTATION */].RIGHT,
    TOP = __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__["b" /* ORIENTATION */].TOP,
    BOTTOM = __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__["b" /* ORIENTATION */].BOTTOM;


var propTypes = {
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  orientation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([LEFT, RIGHT, TOP, BOTTOM]).isRequired,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};

var defaultProps = {
  style: {}
};

function _getTickFormatFn(scale, tickTotal, tickFormat) {
  return !tickFormat ? scale.tickFormat ? scale.tickFormat(tickTotal) : function (v) {
    return v;
  } : tickFormat;
}

var AxisTicks = function (_React$Component) {
  _inherits(AxisTicks, _React$Component);

  function AxisTicks() {
    _classCallCheck(this, AxisTicks);

    return _possibleConstructorReturn(this, (AxisTicks.__proto__ || Object.getPrototypeOf(AxisTicks)).apply(this, arguments));
  }

  _createClass(AxisTicks, [{
    key: '_areTicksWrapped',

    /**
     * Check if axis ticks should be mirrored (for the right and top positions.
     * @returns {boolean} True if mirrored.
     * @private
     */
    value: function _areTicksWrapped() {
      var orientation = this.props.orientation;

      return orientation === LEFT || orientation === TOP;
    }
  }, {
    key: '_getTickContainerPropsGetterFn',
    value: function _getTickContainerPropsGetterFn() {
      if (this._isAxisVertical()) {
        return function (pos) {
          return { transform: 'translate(0, ' + pos + ')' };
        };
      }
      return function (pos) {
        return { transform: 'translate(' + pos + ', 0)' };
      };
    }

    /**
     * Get attributes for the label of the tick.
     * @returns {Object} Object with properties.
     * @private
     */

  }, {
    key: '_getTickLabelProps',
    value: function _getTickLabelProps() {
      var _props = this.props,
          orientation = _props.orientation,
          tickLabelAngle = _props.tickLabelAngle,
          tickSize = _props.tickSize,
          _props$tickSizeOuter = _props.tickSizeOuter,
          tickSizeOuter = _props$tickSizeOuter === undefined ? tickSize : _props$tickSizeOuter,
          _props$tickPadding = _props.tickPadding,
          tickPadding = _props$tickPadding === undefined ? tickSize : _props$tickPadding;

      // Assign the text orientation inside the label of the tick mark.

      var textAnchor = void 0;
      if (orientation === LEFT || orientation === BOTTOM && tickLabelAngle) {
        textAnchor = 'end';
      } else if (orientation === RIGHT || orientation === TOP && tickLabelAngle) {
        textAnchor = 'start';
      } else {
        textAnchor = 'middle';
      }

      // The label's position is translated to the given padding and then the
      // label is rotated to the given angle.
      var isVertical = this._isAxisVertical();
      var wrap = this._areTicksWrapped() ? -1 : 1;

      var labelOffset = wrap * (tickSizeOuter + tickPadding);
      var transform = (isVertical ? 'translate(' + labelOffset + ', 0)' : 'translate(0, ' + labelOffset + ')') + (tickLabelAngle ? ' rotate(' + tickLabelAngle + ')' : '');

      // Set the vertical offset of the label according to the position of
      // the axis.
      var dy = orientation === TOP || tickLabelAngle ? '0' : orientation === BOTTOM ? '0.72em' : '0.32em';

      return {
        textAnchor: textAnchor,
        dy: dy,
        transform: transform
      };
    }

    /**
     * Get the props of the tick line.
     * @returns {Object} Props.
     * @private
     */

  }, {
    key: '_getTickLineProps',
    value: function _getTickLineProps() {
      var _ref;

      var _props2 = this.props,
          tickSize = _props2.tickSize,
          _props2$tickSizeOuter = _props2.tickSizeOuter,
          tickSizeOuter = _props2$tickSizeOuter === undefined ? tickSize : _props2$tickSizeOuter,
          _props2$tickSizeInner = _props2.tickSizeInner,
          tickSizeInner = _props2$tickSizeInner === undefined ? tickSize : _props2$tickSizeInner;

      var isVertical = this._isAxisVertical();
      var tickXAttr = isVertical ? 'y' : 'x';
      var tickYAttr = isVertical ? 'x' : 'y';
      var wrap = this._areTicksWrapped() ? -1 : 1;
      return _ref = {}, _defineProperty(_ref, tickXAttr + '1', 0), _defineProperty(_ref, tickXAttr + '2', 0), _defineProperty(_ref, tickYAttr + '1', -wrap * tickSizeInner), _defineProperty(_ref, tickYAttr + '2', wrap * tickSizeOuter), _ref;
    }

    /**
     * Gets if the axis is vertical.
     * @returns {boolean} True if vertical.
     * @private
     */

  }, {
    key: '_isAxisVertical',
    value: function _isAxisVertical() {
      var orientation = this.props.orientation;

      return orientation === LEFT || orientation === RIGHT;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          attr = _props3.attr,
          orientation = _props3.orientation,
          width = _props3.width,
          height = _props3.height,
          style = _props3.style,
          tickFormat = _props3.tickFormat,
          tickTotal = _props3.tickTotal,
          tickValues = _props3.tickValues;


      var x = orientation === LEFT ? width : 0;
      var y = orientation === TOP ? height : 0;

      var scale = Object(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["d" /* getAttributeScale */])(this.props, attr);

      var values = Object(__WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__["e" /* getTickValues */])(scale, tickTotal, tickValues);
      var tickFormatFn = _getTickFormatFn(scale, tickTotal, tickFormat);

      var translateFn = this._getTickContainerPropsGetterFn();
      var pathProps = this._getTickLineProps();
      var textProps = this._getTickLabelProps();

      var ticks = values.map(function (v, i) {
        var pos = scale(v);
        var labelNode = tickFormatFn(v, i, scale, tickTotal);
        var shouldRenderAsOwnNode = __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(labelNode) && !['tspan', 'textPath'].includes(labelNode.type);
        var shouldAddProps = labelNode && typeof labelNode.type !== 'string';
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          _extends({
            key: i
          }, translateFn(pos, 0), {
            className: 'rv-xy-plot__axis__tick',
            style: style
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line', _extends({}, pathProps, {
            className: 'rv-xy-plot__axis__tick__line',
            style: _extends({}, style, style.line)
          })),
          shouldRenderAsOwnNode ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(labelNode, shouldAddProps ? _extends({}, textProps, {
            containerWidth: width,
            tickCount: values.length
          }) : undefined) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'text',
            _extends({}, textProps, {
              className: 'rv-xy-plot__axis__tick__text',
              style: _extends({}, style, style.text)
            }),
            labelNode
          )
        );
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'g',
        {
          transform: 'translate(' + x + ', ' + y + ')',
          className: 'rv-xy-plot__axis__ticks'
        },
        ticks
      );
    }
  }]);

  return AxisTicks;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

AxisTicks.defaultProps = defaultProps;
AxisTicks.displayName = 'AxisTicks';
AxisTicks.propTypes = propTypes;
AxisTicks.requiresSVG = true;

/* harmony default export */ __webpack_exports__["a"] = (AxisTicks);

/***/ }),
/* 2281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__ = __webpack_require__(82);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.







// Assuming that 16px = 1em
var ADJUSTMENT_FOR_TEXT_SIZE = 16;
var MARGIN = 6;
var LEFT = __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__["b" /* ORIENTATION */].LEFT,
    RIGHT = __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__["b" /* ORIENTATION */].RIGHT,
    TOP = __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__["b" /* ORIENTATION */].TOP,
    BOTTOM = __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__["b" /* ORIENTATION */].BOTTOM;

var defaultProps = {
  position: 'end'
};

/**
 * Compute transformations, keyed by orientation
 * @param {number} width - width of axis
 * @param {number} height - height of axis
 * @returns {Object} Object of transformations, keyed by orientation
 */
var transformation = function transformation(width, height) {
  var _ref;

  return _ref = {}, _defineProperty(_ref, LEFT, {
    end: {
      x: ADJUSTMENT_FOR_TEXT_SIZE,
      y: MARGIN,
      rotation: -90,
      textAnchor: 'end'
    },
    middle: {
      x: ADJUSTMENT_FOR_TEXT_SIZE,
      y: height / 2 - MARGIN,
      rotation: -90,
      textAnchor: 'middle'
    },
    start: {
      x: ADJUSTMENT_FOR_TEXT_SIZE,
      y: height - MARGIN,
      rotation: -90,
      textAnchor: 'start'
    }
  }), _defineProperty(_ref, RIGHT, {
    end: {
      x: ADJUSTMENT_FOR_TEXT_SIZE * -0.5,
      y: MARGIN,
      rotation: -90,
      textAnchor: 'end'
    },
    middle: {
      x: ADJUSTMENT_FOR_TEXT_SIZE * -0.5,
      y: height / 2 - MARGIN,
      rotation: -90,
      textAnchor: 'middle'
    },
    start: {
      x: ADJUSTMENT_FOR_TEXT_SIZE * -0.5,
      y: height - MARGIN,
      rotation: -90,
      textAnchor: 'start'
    }
  }), _defineProperty(_ref, TOP, {
    start: {
      x: MARGIN,
      y: ADJUSTMENT_FOR_TEXT_SIZE,
      rotation: 0,
      textAnchor: 'start'
    },
    middle: {
      x: width / 2 - MARGIN,
      y: ADJUSTMENT_FOR_TEXT_SIZE,
      rotation: 0,
      textAnchor: 'middle'
    },
    end: {
      x: width - MARGIN,
      y: ADJUSTMENT_FOR_TEXT_SIZE,
      rotation: 0,
      textAnchor: 'end'
    }
  }), _defineProperty(_ref, BOTTOM, {
    start: {
      x: MARGIN,
      y: -MARGIN,
      rotation: 0,
      textAnchor: 'start'
    },
    middle: {
      x: width / 2 - MARGIN,
      y: -MARGIN,
      rotation: 0,
      textAnchor: 'middle'
    },
    end: {
      x: width - MARGIN,
      y: -MARGIN,
      rotation: 0,
      textAnchor: 'end'
    }
  }), _ref;
};

var propTypes = {
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  orientation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([LEFT, RIGHT, TOP, BOTTOM]).isRequired,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
};

function AxisTitle(_ref2) {
  var orientation = _ref2.orientation,
      position = _ref2.position,
      width = _ref2.width,
      height = _ref2.height,
      style = _ref2.style,
      title = _ref2.title;

  var outerGroupTranslateX = orientation === LEFT ? width : 0;
  var outerGroupTranslateY = orientation === TOP ? height : 0;
  var outerGroupTransform = 'translate(' + outerGroupTranslateX + ', ' + outerGroupTranslateY + ')';
  var _transformation$orien = transformation(width, height)[orientation][position],
      x = _transformation$orien.x,
      y = _transformation$orien.y,
      rotation = _transformation$orien.rotation,
      textAnchor = _transformation$orien.textAnchor;

  var innerGroupTransform = 'translate(' + x + ', ' + y + ') rotate(' + rotation + ')';

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'g',
    { transform: outerGroupTransform, className: 'rv-xy-plot__axis__title' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'g',
      { style: _extends({ textAnchor: textAnchor }, style), transform: innerGroupTransform },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'text',
        { style: style },
        title
      )
    )
  );
}

AxisTitle.displayName = 'AxisTitle';
AxisTitle.propTypes = propTypes;
AxisTitle.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (AxisTitle);

/***/ }),
/* 2282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__axis__ = __webpack_require__(634);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.









var LEFT = __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__["b" /* ORIENTATION */].LEFT,
    RIGHT = __WEBPACK_IMPORTED_MODULE_2__utils_axis_utils__["b" /* ORIENTATION */].RIGHT;


var propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_3__axis__["a" /* default */].propTypes, {
  orientation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([LEFT, RIGHT])
});

var defaultProps = {
  orientation: LEFT,
  attr: 'y',
  attrAxis: 'x'
};

function YAxis(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__axis__["a" /* default */], props);
}

YAxis.displayName = 'YAxis';
YAxis.propTypes = propTypes;
YAxis.defaultProps = defaultProps;
YAxis.requiresSVG = true;

/* unused harmony default export */ var _unused_webpack_default_export = (YAxis);

/***/ }),
/* 2283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__theme__ = __webpack_require__(63);
// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.







var propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  endColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  endTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired,
  midColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  midTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  startColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  startTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

var defaultProps = {
  className: '',
  startColor: __WEBPACK_IMPORTED_MODULE_2__theme__["a" /* CONTINUOUS_COLOR_RANGE */][0],
  endColor: __WEBPACK_IMPORTED_MODULE_2__theme__["a" /* CONTINUOUS_COLOR_RANGE */][1]
};

function ContinuousColorLegend(_ref) {
  var startColor = _ref.startColor,
      midColor = _ref.midColor,
      endColor = _ref.endColor,
      startTitle = _ref.startTitle,
      midTitle = _ref.midTitle,
      endTitle = _ref.endTitle,
      height = _ref.height,
      width = _ref.width,
      className = _ref.className;

  var colors = [startColor];
  if (midColor) {
    colors.push(midColor);
  }
  colors.push(endColor);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      className: 'rv-continuous-color-legend ' + className,
      style: { width: width, height: height }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
      className: 'rv-gradient',
      style: { background: 'linear-gradient(to right, ' + colors.join(',') + ')' }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'rv-legend-titles' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'rv-legend-titles__left' },
        startTitle
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'rv-legend-titles__right' },
        endTitle
      ),
      midTitle ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'rv-legend-titles__center' },
        midTitle
      ) : null
    )
  );
}

ContinuousColorLegend.displayName = 'ContinuousColorLegend';
ContinuousColorLegend.propTypes = propTypes;
ContinuousColorLegend.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (ContinuousColorLegend);

/***/ }),
/* 2284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.





var propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  circlesTotal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  endSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  endTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  startSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  startTitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};

var defaultProps = {
  circlesTotal: 10,
  className: '',
  endSize: 20,
  startSize: 2
};

function ContinuousSizeLegend(_ref) {
  var startTitle = _ref.startTitle,
      endTitle = _ref.endTitle,
      startSize = _ref.startSize,
      endSize = _ref.endSize,
      circlesTotal = _ref.circlesTotal,
      height = _ref.height,
      width = _ref.width,
      className = _ref.className;

  var circles = [];
  var step = (endSize - startSize) / (circlesTotal - 1);

  for (var i = 0; i < circlesTotal; i++) {
    var size = step * i + startSize;
    circles.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
      key: i,
      className: 'rv-bubble',
      style: {
        width: size,
        height: size,
        borderRadius: size / 2
      }
    }));
    // Add the separator in order to justify the content (otherwise the tags
    // will be stacked together without any margins around).
    circles.push(' ');
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      className: 'rv-continuous-size-legend ' + className,
      style: { width: width, height: height }
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'rv-bubbles', style: { height: endSize } },
      circles,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'rv-spacer' })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'rv-legend-titles' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'rv-legend-titles__left' },
        startTitle
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'rv-legend-titles__right' },
        endTitle
      )
    )
  );
}

ContinuousSizeLegend.displayName = 'ContinuousSizeLegend';
ContinuousSizeLegend.propTypes = propTypes;
ContinuousSizeLegend.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (ContinuousSizeLegend);

/***/ }),
/* 2285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.





var STROKE_STYLES = {
  dashed: '6, 2',
  solid: null
};

function DiscreteColorLegendItem(_ref) {
  var color = _ref.color,
      strokeDasharray = _ref.strokeDasharray,
      strokeStyle = _ref.strokeStyle,
      strokeWidth = _ref.strokeWidth,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      orientation = _ref.orientation,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave,
      title = _ref.title;

  var className = 'rv-discrete-color-legend-item ' + orientation;
  if (disabled) {
    className += ' disabled';
  }
  if (onClick) {
    className += ' clickable';
  }
  var strokeDasharrayStyle = STROKE_STYLES[strokeStyle] || strokeDasharray;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: className, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'svg',
      { className: 'rv-discrete-color-legend-item__color', height: 2, width: 14 },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', {
        className: 'rv-discrete-color-legend-item__color__path',
        d: 'M 0, 1 L 14, 1',
        style: _extends({}, strokeWidth ? { strokeWidth: strokeWidth } : {}, strokeDasharrayStyle ? { strokeDasharray: strokeDasharrayStyle } : {}, {
          stroke: disabled ? null : color
        })

      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { className: 'rv-discrete-color-legend-item__title' },
      title
    )
  );
}

DiscreteColorLegendItem.propTypes = {
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element]).isRequired,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  orientation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['vertical', 'horizontal']).isRequired,
  strokeDasharray: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  strokeWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  strokeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(Object.keys(STROKE_STYLES))
};
DiscreteColorLegendItem.defaultProps = {
  disabled: false,
  strokeStyle: 'solid'
};
DiscreteColorLegendItem.displayName = 'DiscreteColorLegendItem';

/* harmony default export */ __webpack_exports__["a"] = (DiscreteColorLegendItem);

/***/ }),
/* 2286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__discrete_color_legend__ = __webpack_require__(635);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.







var propTypes = _extends({}, __WEBPACK_IMPORTED_MODULE_2__discrete_color_legend__["a" /* default */].propTypes, {
  searchText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onSearchChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  searchPlaceholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  searchFn: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
});

var defaultProps = {
  className: '',
  searchText: '',
  searchFn: function searchFn(items, s) {
    return items.filter(function (item) {
      return String(item.title || item).toLowerCase().indexOf(s) !== -1;
    });
  }
};

function SearchableDiscreteColorLegend(props) {
  var className = props.className,
      colors = props.colors,
      height = props.height,
      items = props.items,
      onItemClick = props.onItemClick,
      onSearchChange = props.onSearchChange,
      orientation = props.orientation,
      searchFn = props.searchFn,
      searchPlaceholder = props.searchPlaceholder,
      searchText = props.searchText,
      width = props.width;

  var onChange = onSearchChange ? function (_ref) {
    var value = _ref.target.value;
    return onSearchChange(value);
  } : null;
  var filteredItems = searchFn(items, searchText);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'rv-search-wrapper ' + className, style: { width: width, height: height } },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'form',
      { className: 'rv-search-wrapper__form' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
        type: 'search',
        placeholder: searchPlaceholder,
        className: 'rv-search-wrapper__form__input',
        value: searchText,
        onChange: onChange
      })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'rv-search-wrapper__contents' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__discrete_color_legend__["a" /* default */], {
        colors: colors,
        items: filteredItems,
        onItemClick: onItemClick,
        orientation: orientation
      })
    )
  );
}

SearchableDiscreteColorLegend.propTypes = propTypes;
SearchableDiscreteColorLegend.defaultProps = defaultProps;
SearchableDiscreteColorLegend.displayName = 'SearchableDiscreteColorLegend';

/* unused harmony default export */ var _unused_webpack_default_export = (SearchableDiscreteColorLegend);

/***/ }),
/* 2287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_scale__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_format__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__animation__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plot_xy_plot__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__theme__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_chart_utils__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plot_series_line_series__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__plot_series_line_mark_series__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__plot_series_label_series__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__plot_axis_decorative_axis__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__plot_highlight__ = __webpack_require__(618);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

















var predefinedClassName = 'rv-parallel-coordinates-chart';
var DEFAULT_FORMAT = Object(__WEBPACK_IMPORTED_MODULE_3_d3_format__["a" /* format */])('.2r');
/**
 * Generate axes for each of the domains
 * @param {Object} props
 - props.animation {Boolean}
 - props.domains {Array} array of object specifying the way each axis is to be plotted
 - props.style {object} style object for the whole chart
 - props.tickFormat {Function} formatting function for axes
 * @return {Array} the plotted axis components
 */
function getAxes(props) {
  var animation = props.animation,
      domains = props.domains,
      style = props.style,
      tickFormat = props.tickFormat;

  return domains.map(function (domain, index) {
    var sortedDomain = domain.domain;

    var domainTickFormat = function domainTickFormat(t) {
      return domain.tickFormat ? domain.tickFormat(t) : tickFormat(t);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__plot_axis_decorative_axis__["a" /* default */], {
      animation: animation,
      key: index + '-axis',
      axisStart: { x: domain.name, y: 0 },
      axisEnd: { x: domain.name, y: 1 },
      axisDomain: sortedDomain,
      numberOfTicks: 5,
      tickValue: domainTickFormat,
      style: style.axes
    });
  });
}

/**
 * Generate labels for the ends of the axes
 * @param {Object} props
 - props.domains {Array} array of object specifying the way each axis is to be plotted
 - props.style {object} style object for just the labels
 * @return {Array} the prepped data for the labelSeries
 */
function getLabels(props) {
  var domains = props.domains,
      style = props.style;

  return domains.map(function (domain, index) {
    return {
      x: domain.name,
      y: 1.1,
      label: domain.name,
      style: style
    };
  });
}

/**
 * Generate the actual lines to be plotted
 * @param {Object} props
 - props.animation {Boolean}
 - props.data {Array} array of object specifying what values are to be plotted
 - props.domains {Array} array of object specifying the way each axis is to be plotted
 - props.style {object} style object for the whole chart
 - props.showMarks {Bool} whether or not to use the line mark series
 * @return {Array} the plotted axis components
 */
function getLines(props) {
  var animation = props.animation,
      brushFilters = props.brushFilters,
      colorRange = props.colorRange,
      domains = props.domains,
      data = props.data,
      style = props.style,
      showMarks = props.showMarks;

  var scales = domains.reduce(function (acc, _ref) {
    var domain = _ref.domain,
        name = _ref.name;

    acc[name] = Object(__WEBPACK_IMPORTED_MODULE_2_d3_scale__["a" /* scaleLinear */])().domain(domain).range([0, 1]);
    return acc;
  }, {});
  // const

  return data.map(function (row, rowIndex) {
    var withinFilteredRange = true;
    var mappedData = domains.map(function (domain, index) {
      var getValue = domain.getValue,
          name = domain.name;

      // watch out! Gotcha afoot
      // yVal after being scale is in [0, 1] range

      var yVal = scales[name](getValue ? getValue(row) : row[name]);
      var filter = brushFilters[name];
      // filter value after being scale back from pixel space is also in [0, 1]
      if (filter && (yVal < filter.min || yVal > filter.max)) {
        withinFilteredRange = false;
      }
      return { x: name, y: yVal };
    });
    var selectedName = predefinedClassName + '-line';
    var unselectedName = selectedName + ' ' + predefinedClassName + '-line-unselected';
    var lineProps = {
      animation: animation,
      className: withinFilteredRange ? selectedName : unselectedName,
      key: rowIndex + '-polygon',
      data: mappedData,
      color: row.color || colorRange[rowIndex % colorRange.length],
      style: _extends({}, style.lines, row.style || {})
    };
    if (!withinFilteredRange) {
      lineProps.style = _extends({}, lineProps.style, style.deselectedLineStyle);
    }
    return showMarks ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__plot_series_line_mark_series__["a" /* default */], lineProps) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__plot_series_line_series__["a" /* default */], lineProps);
  });
}

var ParallelCoordinates = function (_Component) {
  _inherits(ParallelCoordinates, _Component);

  function ParallelCoordinates() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, ParallelCoordinates);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = ParallelCoordinates.__proto__ || Object.getPrototypeOf(ParallelCoordinates)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      brushFilters: {}
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ParallelCoordinates, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var brushFilters = this.state.brushFilters;
      var _props = this.props,
          animation = _props.animation,
          brushing = _props.brushing,
          className = _props.className,
          children = _props.children,
          colorRange = _props.colorRange,
          data = _props.data,
          domains = _props.domains,
          height = _props.height,
          hideInnerMostValues = _props.hideInnerMostValues,
          margin = _props.margin,
          onMouseLeave = _props.onMouseLeave,
          onMouseEnter = _props.onMouseEnter,
          showMarks = _props.showMarks,
          style = _props.style,
          tickFormat = _props.tickFormat,
          width = _props.width;


      var axes = getAxes({
        domains: domains,
        animation: animation,
        hideInnerMostValues: hideInnerMostValues,
        style: style,
        tickFormat: tickFormat
      });

      var lines = getLines({
        animation: animation,
        brushFilters: brushFilters,
        colorRange: colorRange,
        domains: domains,
        data: data,
        showMarks: showMarks,
        style: style
      });
      var labelSeries = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__plot_series_label_series__["a" /* default */], {
        animation: true,
        key: className,
        className: predefinedClassName + '-label',
        data: getLabels({ domains: domains, style: style.labels })
      });

      var _getInnerDimensions = Object(__WEBPACK_IMPORTED_MODULE_7__utils_chart_utils__["c" /* getInnerDimensions */])(this.props, __WEBPACK_IMPORTED_MODULE_7__utils_chart_utils__["a" /* DEFAULT_MARGINS */]),
          marginLeft = _getInnerDimensions.marginLeft,
          marginRight = _getInnerDimensions.marginRight;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__plot_xy_plot__["a" /* default */],
        {
          height: height,
          width: width,
          margin: margin,
          dontCheckIfEmpty: true,
          className: className + ' ' + predefinedClassName,
          onMouseLeave: onMouseLeave,
          onMouseEnter: onMouseEnter,
          xType: 'ordinal',
          yDomain: [0, 1]
        },
        children,
        axes.concat(lines).concat(labelSeries),
        brushing && domains.map(function (d) {
          var trigger = function trigger(row) {
            _this2.setState({
              brushFilters: _extends({}, brushFilters, _defineProperty({}, d.name, row ? { min: row.bottom, max: row.top } : null))
            });
          };
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__plot_highlight__["a" /* default */], {
            key: d.name,
            drag: true,
            highlightX: d.name,
            onBrushEnd: trigger,
            onDragEnd: trigger,
            highlightWidth: (width - marginLeft - marginRight) / domains.length,
            enableX: false
          });
        })
      );
    }
  }]);

  return ParallelCoordinates;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ParallelCoordinates.displayName = 'ParallelCoordinates';
ParallelCoordinates.propTypes = {
  animation: __WEBPACK_IMPORTED_MODULE_4__animation__["a" /* AnimationPropType */],
  brushing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  colorType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  colorRange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,
  domains: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    domain: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number).isRequired,
    tickFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  })).isRequired,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  margin: __WEBPACK_IMPORTED_MODULE_7__utils_chart_utils__["b" /* MarginPropType */],
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    axes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    labels: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    lines: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }),
  showMarks: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tickFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};
ParallelCoordinates.defaultProps = {
  className: '',
  colorType: 'category',
  colorRange: __WEBPACK_IMPORTED_MODULE_6__theme__["e" /* DISCRETE_COLOR_RANGE */],
  style: {
    axes: {
      line: {},
      ticks: {},
      text: {}
    },
    labels: {
      fontSize: 10,
      textAnchor: 'middle'
    },
    lines: {
      strokeWidth: 1,
      strokeOpacity: 1
    },
    deselectedLineStyle: {
      strokeOpacity: 0.1
    }
  },
  tickFormat: DEFAULT_FORMAT
};

/* unused harmony default export */ var _unused_webpack_default_export = (ParallelCoordinates);

/***/ }),
/* 2288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_scale__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_format__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__animation__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plot_xy_plot__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__theme__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_chart_utils__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plot_series_mark_series__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__plot_series_polygon_series__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__plot_series_label_series__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__plot_axis_decorative_axis__ = __webpack_require__(366);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.















var predefinedClassName = 'rv-radar-chart';
var DEFAULT_FORMAT = Object(__WEBPACK_IMPORTED_MODULE_3_d3_format__["a" /* format */])('.2r');
/**
 * Generate axes for each of the domains
 * @param {Object} props
 - props.animation {Boolean}
 - props.domains {Array} array of object specifying the way each axis is to be plotted
 - props.style {object} style object for the whole chart
 - props.tickFormat {Function} formatting function for axes
 - props.startingAngle {number} the initial angle offset
 * @return {Array} the plotted axis components
 */
function getAxes(props) {
  var animation = props.animation,
      domains = props.domains,
      startingAngle = props.startingAngle,
      style = props.style,
      tickFormat = props.tickFormat,
      hideInnerMostValues = props.hideInnerMostValues;

  return domains.map(function (domain, index) {
    var angle = index / domains.length * Math.PI * 2 + startingAngle;
    var sortedDomain = domain.domain;

    var domainTickFormat = function domainTickFormat(t) {
      if (hideInnerMostValues && t === sortedDomain[0]) {
        return '';
      }
      return domain.tickFormat ? domain.tickFormat(t) : tickFormat(t);
    };

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__plot_axis_decorative_axis__["a" /* default */], {
      animation: animation,
      key: index + '-axis',
      axisStart: { x: 0, y: 0 },
      axisEnd: {
        x: getCoordinate(Math.cos(angle)),
        y: getCoordinate(Math.sin(angle))
      },
      axisDomain: sortedDomain,
      numberOfTicks: 5,
      tickValue: domainTickFormat,
      style: style.axes
    });
  });
}

/**
 * Generate x or y coordinate for axisEnd
 * @param {Number} axisEndPoint
 - epsilon is an arbitrarily chosen small number to approximate axisEndPoints
 - to true values resulting from trigonometry functions (sin, cos) on angles
 * @return {Number} the x or y coordinate accounting for exact trig values
 */
function getCoordinate(axisEndPoint) {
  var epsilon = 10e-13;
  if (Math.abs(axisEndPoint) <= epsilon) {
    axisEndPoint = 0;
  } else if (axisEndPoint > 0) {
    if (Math.abs(axisEndPoint - 0.5) <= epsilon) {
      axisEndPoint = 0.5;
    }
  } else if (axisEndPoint < 0) {
    if (Math.abs(axisEndPoint + 0.5) <= epsilon) {
      axisEndPoint = -0.5;
    }
  }
  return axisEndPoint;
}

/**
 * Generate labels for the ends of the axes
 * @param {Object} props
 - props.domains {Array} array of object specifying the way each axis is to be plotted
  - props.startingAngle {number} the initial angle offset
 - props.style {object} style object for just the labels
 * @return {Array} the prepped data for the labelSeries
 */
function getLabels(props) {
  var domains = props.domains,
      startingAngle = props.startingAngle,
      style = props.style;

  return domains.map(function (_ref, index) {
    var name = _ref.name;

    var angle = index / domains.length * Math.PI * 2 + startingAngle;
    var radius = 1.2;
    return {
      x: radius * Math.cos(angle),
      y: radius * Math.sin(angle),
      label: name,
      style: style
    };
  });
}

/**
 * Generate the actual polygons to be plotted
 * @param {Object} props
 - props.animation {Boolean}
 - props.data {Array} array of object specifying what values are to be plotted
 - props.domains {Array} array of object specifying the way each axis is to be plotted
 - props.startingAngle {number} the initial angle offset
 - props.style {object} style object for the whole chart
 * @return {Array} the plotted axis components
 */
function getPolygons(props) {
  var animation = props.animation,
      colorRange = props.colorRange,
      domains = props.domains,
      data = props.data,
      style = props.style,
      startingAngle = props.startingAngle,
      onSeriesMouseOver = props.onSeriesMouseOver,
      onSeriesMouseOut = props.onSeriesMouseOut;

  var scales = domains.reduce(function (acc, _ref2) {
    var domain = _ref2.domain,
        name = _ref2.name;

    acc[name] = Object(__WEBPACK_IMPORTED_MODULE_2_d3_scale__["a" /* scaleLinear */])().domain(domain).range([0, 1]);
    return acc;
  }, {});

  return data.map(function (row, rowIndex) {
    var mappedData = domains.map(function (_ref3, index) {
      var name = _ref3.name,
          getValue = _ref3.getValue;

      var dataPoint = getValue ? getValue(row) : row[name];
      // error handling if point doesn't exist
      var angle = index / domains.length * Math.PI * 2 + startingAngle;
      // dont let the radius become negative
      var radius = Math.max(scales[name](dataPoint), 0);
      return { x: radius * Math.cos(angle), y: radius * Math.sin(angle), name: row.name };
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__plot_series_polygon_series__["a" /* default */], {
      animation: animation,
      className: predefinedClassName + '-polygon',
      key: rowIndex + '-polygon',
      data: mappedData,
      style: _extends({
        stroke: row.color || row.stroke || colorRange[rowIndex % colorRange.length],
        fill: row.color || row.fill || colorRange[rowIndex % colorRange.length]
      }, style.polygons),
      onSeriesMouseOver: onSeriesMouseOver,
      onSeriesMouseOut: onSeriesMouseOut
    });
  });
}

/**
 * Generate circles at the polygon points for Hover functionality
 * @param {Object} props
 - props.animation {Boolean}
 - props.data {Array} array of object specifying what values are to be plotted
 - props.domains {Array} array of object specifying the way each axis is to be plotted
 - props.startingAngle {number} the initial angle offset
 - props.style {object} style object for the whole chart
 - props.onValueMouseOver {function} function to call on mouse over a polygon point
 - props.onValueMouseOver {function} function to call when mouse leaves a polygon point
 * @return {Array} the plotted axis components
 */
function getPolygonPoints(props) {
  var animation = props.animation,
      domains = props.domains,
      data = props.data,
      startingAngle = props.startingAngle,
      style = props.style,
      onValueMouseOver = props.onValueMouseOver,
      onValueMouseOut = props.onValueMouseOut;

  if (!onValueMouseOver) {
    return;
  }
  var scales = domains.reduce(function (acc, _ref4) {
    var domain = _ref4.domain,
        name = _ref4.name;

    acc[name] = Object(__WEBPACK_IMPORTED_MODULE_2_d3_scale__["a" /* scaleLinear */])().domain(domain).range([0, 1]);
    return acc;
  }, {});
  return data.map(function (row, rowIndex) {
    var mappedData = domains.map(function (_ref5, index) {
      var name = _ref5.name,
          getValue = _ref5.getValue;

      var dataPoint = getValue ? getValue(row) : row[name];
      // error handling if point doesn't exist
      var angle = index / domains.length * Math.PI * 2 + startingAngle;
      // dont let the radius become negative
      var radius = Math.max(scales[name](dataPoint), 0);
      return {
        x: radius * Math.cos(angle),
        y: radius * Math.sin(angle),
        domain: name,
        value: dataPoint,
        dataName: row.name
      };
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__plot_series_mark_series__["a" /* default */], {
      animation: animation,
      className: predefinedClassName + '-polygonPoint',
      key: rowIndex + '-polygonPoint',
      data: mappedData,
      size: 10,
      style: _extends({}, style.polygons, {
        fill: 'transparent',
        stroke: 'transparent'
      }),
      onValueMouseOver: onValueMouseOver,
      onValueMouseOut: onValueMouseOut
    });
  });
}

function RadarChart(props) {
  var animation = props.animation,
      className = props.className,
      children = props.children,
      colorRange = props.colorRange,
      data = props.data,
      domains = props.domains,
      height = props.height,
      hideInnerMostValues = props.hideInnerMostValues,
      margin = props.margin,
      onMouseLeave = props.onMouseLeave,
      onMouseEnter = props.onMouseEnter,
      startingAngle = props.startingAngle,
      style = props.style,
      tickFormat = props.tickFormat,
      width = props.width,
      renderAxesOverPolygons = props.renderAxesOverPolygons,
      onValueMouseOver = props.onValueMouseOver,
      onValueMouseOut = props.onValueMouseOut,
      onSeriesMouseOver = props.onSeriesMouseOver,
      onSeriesMouseOut = props.onSeriesMouseOut;


  var axes = getAxes({
    domains: domains,
    animation: animation,
    hideInnerMostValues: hideInnerMostValues,
    startingAngle: startingAngle,
    style: style,
    tickFormat: tickFormat
  });

  var polygons = getPolygons({
    animation: animation,
    colorRange: colorRange,
    domains: domains,
    data: data,
    startingAngle: startingAngle,
    style: style,
    onSeriesMouseOver: onSeriesMouseOver,
    onSeriesMouseOut: onSeriesMouseOut
  });

  var polygonPoints = getPolygonPoints({
    animation: animation,
    colorRange: colorRange,
    domains: domains,
    data: data,
    startingAngle: startingAngle,
    style: style,
    onValueMouseOver: onValueMouseOver,
    onValueMouseOut: onValueMouseOut
  });

  var labelSeries = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__plot_series_label_series__["a" /* default */], {
    animation: animation,
    key: className,
    className: predefinedClassName + '-label',
    data: getLabels({ domains: domains, style: style.labels, startingAngle: startingAngle }) });
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_5__plot_xy_plot__["a" /* default */],
    {
      height: height,
      width: width,
      margin: margin,
      dontCheckIfEmpty: true,
      className: className + ' ' + predefinedClassName,
      onMouseLeave: onMouseLeave,
      onMouseEnter: onMouseEnter,
      xDomain: [-1, 1],
      yDomain: [-1, 1] },
    children,
    !renderAxesOverPolygons && axes.concat(polygons).concat(labelSeries).concat(polygonPoints),
    renderAxesOverPolygons && polygons.concat(labelSeries).concat(axes).concat(polygonPoints)
  );
}

RadarChart.displayName = 'RadarChart';
RadarChart.propTypes = {
  animation: __WEBPACK_IMPORTED_MODULE_4__animation__["a" /* AnimationPropType */],
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  colorType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  colorRange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,
  domains: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    domain: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number).isRequired,
    tickFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  })).isRequired,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  hideInnerMostValues: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  margin: __WEBPACK_IMPORTED_MODULE_7__utils_chart_utils__["b" /* MarginPropType */],
  startingAngle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    axes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    labels: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    polygons: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }),
  tickFormat: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  renderAxesOverPolygons: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onValueMouseOver: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onValueMouseOut: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onSeriesMouseOver: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onSeriesMouseOut: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
RadarChart.defaultProps = {
  className: '',
  colorType: 'category',
  colorRange: __WEBPACK_IMPORTED_MODULE_6__theme__["e" /* DISCRETE_COLOR_RANGE */],
  hideInnerMostValues: true,
  startingAngle: Math.PI / 2,
  style: {
    axes: {
      line: {},
      ticks: {},
      text: {}
    },
    labels: {
      fontSize: 10,
      textAnchor: 'middle'
    },
    polygons: {
      strokeWidth: 0.5,
      strokeOpacity: 1,
      fillOpacity: 0.1
    }
  },
  tickFormat: DEFAULT_FORMAT,
  renderAxesOverPolygons: false
};

/* unused harmony default export */ var _unused_webpack_default_export = (RadarChart);

/***/ }),
/* 2289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_shape__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__animation__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plot_series_arc_series__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plot_series_label_series__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plot_xy_plot__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__theme__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_chart_utils__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_series_utils__ = __webpack_require__(66);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.













var predefinedClassName = 'rv-radial-chart';

var DEFAULT_RADIUS_MARGIN = 15;

/**
 * Create the list of wedges to render.
 * @param {Object} props
   props.data {Object} - tree structured data (each node has a name anc an array of children)
 * @returns {Array} Array of nodes.
 */
function getWedgesToRender(_ref) {
  var data = _ref.data,
      getAngle = _ref.getAngle;

  var pie = Object(__WEBPACK_IMPORTED_MODULE_2_d3_shape__["pie"])().sort(null).value(getAngle);
  var pieData = pie(data).reverse();
  return pieData.map(function (row, index) {
    return _extends({}, row.data, {
      angle0: row.startAngle,
      angle: row.endAngle,
      radius0: row.data.innerRadius || 0,
      radius: row.data.radius || 1,
      color: row.data.color || index
    });
  });
}

function generateLabels(mappedData, accessors) {
  var labelsRadiusMultiplier = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1.1;
  var getLabel = accessors.getLabel,
      getSubLabel = accessors.getSubLabel;

  return mappedData.reduce(function (res, row) {
    var angle = row.angle,
        angle0 = row.angle0,
        radius = row.radius;

    var centeredAngle = (angle + angle0) / 2;

    // unfortunate, but true fact: d3 starts its radians at 12 oclock rather than 3
    // and move clockwise rather than counter clockwise. why why why!
    var updatedAngle = -1 * centeredAngle + Math.PI / 2;
    var newLabels = [];
    if (getLabel(row)) {
      newLabels.push({
        angle: updatedAngle,
        radius: radius * labelsRadiusMultiplier,
        label: getLabel(row)
      });
    }

    if (getSubLabel(row)) {
      newLabels.push({
        angle: updatedAngle,
        radius: radius * labelsRadiusMultiplier,
        label: getSubLabel(row),
        style: { fontSize: 10 },
        yOffset: 12
      });
    }
    return res.concat(newLabels);
  }, []);
  // could add force direction here to make sure the labels dont overlap
}

/**
 * Get the max radius so the chart can extend to the margin.
 * @param  {Number} width - container width
 * @param  {Number} height - container height
 * @return {Number} radius
 */
function getMaxRadius(width, height) {
  return Math.min(width, height) / 2 - DEFAULT_RADIUS_MARGIN;
}

function RadialChart(props) {
  var animation = props.animation,
      className = props.className,
      children = props.children,
      colorType = props.colorType,
      data = props.data,
      getAngle = props.getAngle,
      getLabel = props.getLabel,
      getSubLabel = props.getSubLabel,
      height = props.height,
      hideRootNode = props.hideRootNode,
      innerRadius = props.innerRadius,
      labelsAboveChildren = props.labelsAboveChildren,
      labelsRadiusMultiplier = props.labelsRadiusMultiplier,
      labelsStyle = props.labelsStyle,
      margin = props.margin,
      onMouseLeave = props.onMouseLeave,
      onMouseEnter = props.onMouseEnter,
      radius = props.radius,
      showLabels = props.showLabels,
      style = props.style,
      width = props.width;

  var mappedData = getWedgesToRender({
    data: data,
    height: height,
    hideRootNode: hideRootNode,
    width: width,
    getAngle: getAngle
  });
  var radialDomain = Object(__WEBPACK_IMPORTED_MODULE_9__utils_series_utils__["b" /* getRadialDomain */])(mappedData);
  var arcProps = _extends({
    colorType: colorType
  }, props, {
    animation: animation,
    radiusDomain: [0, radialDomain],
    data: mappedData,
    radiusNoFallBack: true,
    style: style,
    arcClassName: 'rv-radial-chart__series--pie__slice'
  });
  if (radius) {
    arcProps.radiusDomain = [0, 1];
    arcProps.radiusRange = [innerRadius || 0, radius];
    arcProps.radiusType = 'linear';
  }
  var maxRadius = radius ? radius : getMaxRadius(width, height);
  var defaultMargin = Object(__WEBPACK_IMPORTED_MODULE_8__utils_chart_utils__["d" /* getRadialLayoutMargin */])(width, height, maxRadius);

  var labels = generateLabels(mappedData, {
    getLabel: getLabel,
    getSubLabel: getSubLabel
  }, labelsRadiusMultiplier);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__plot_xy_plot__["a" /* default */],
    {
      height: height,
      width: width,
      margin: _extends({}, margin, defaultMargin),
      className: className + ' ' + predefinedClassName,
      onMouseLeave: onMouseLeave,
      onMouseEnter: onMouseEnter,
      xDomain: [-radialDomain, radialDomain],
      yDomain: [-radialDomain, radialDomain]
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__plot_series_arc_series__["a" /* default */], _extends({}, arcProps, { getAngle: function getAngle(d) {
        return d.angle;
      } })),
    showLabels && !labelsAboveChildren && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__plot_series_label_series__["a" /* default */], { data: labels, style: labelsStyle }),
    children,
    showLabels && labelsAboveChildren && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__plot_series_label_series__["a" /* default */], { data: labels, style: labelsStyle })
  );
}

RadialChart.displayName = 'RadialChart';
RadialChart.propTypes = {
  animation: __WEBPACK_IMPORTED_MODULE_3__animation__["a" /* AnimationPropType */],
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  colorType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    angle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    radius: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  })).isRequired,
  getAngle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  getAngle0: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  padAngle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  getRadius: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  getRadius0: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  getLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  labelsAboveChildren: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  labelsStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  margin: __WEBPACK_IMPORTED_MODULE_8__utils_chart_utils__["b" /* MarginPropType */],
  onValueClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onValueMouseOver: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onValueMouseOut: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  showLabels: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  subLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};
RadialChart.defaultProps = {
  className: '',
  colorType: 'category',
  colorRange: __WEBPACK_IMPORTED_MODULE_7__theme__["e" /* DISCRETE_COLOR_RANGE */],
  padAngle: 0,
  getAngle: function getAngle(d) {
    return d.angle;
  },
  getAngle0: function getAngle0(d) {
    return d.angle0;
  },
  getRadius: function getRadius(d) {
    return d.radius;
  },
  getRadius0: function getRadius0(d) {
    return d.radius0;
  },
  getLabel: function getLabel(d) {
    return d.label;
  },
  getSubLabel: function getSubLabel(d) {
    return d.subLabel;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (RadialChart);

/***/ }),
/* 2290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_sankey__ = __webpack_require__(2291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plot_xy_plot__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_chart_utils__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plot_series_vertical_rect_series__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plot_series_label_series__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__plot_voronoi__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__theme__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__sankey_link__ = __webpack_require__(2295);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }













var NOOP = function NOOP(f) {
  return f;
};

var ALIGNMENTS = {
  justify: __WEBPACK_IMPORTED_MODULE_2_d3_sankey__["c" /* sankeyJustify */],
  center: __WEBPACK_IMPORTED_MODULE_2_d3_sankey__["b" /* sankeyCenter */],
  left: __WEBPACK_IMPORTED_MODULE_2_d3_sankey__["d" /* sankeyLeft */],
  right: __WEBPACK_IMPORTED_MODULE_2_d3_sankey__["f" /* sankeyRight */]
};

var DEFAULT_MARGINS = {
  top: 20,
  left: 20,
  right: 20,
  bottom: 20
};

function Sankey(props) {
  var align = props.align,
      animation = props.animation,
      children = props.children,
      className = props.className,
      hasVoronoi = props.hasVoronoi,
      height = props.height,
      hideLabels = props.hideLabels,
      labelRotation = props.labelRotation,
      layout = props.layout,
      links = props.links,
      linkOpacity = props.linkOpacity,
      margin = props.margin,
      nodePadding = props.nodePadding,
      nodes = props.nodes,
      nodeWidth = props.nodeWidth,
      onValueClick = props.onValueClick,
      onValueMouseOver = props.onValueMouseOver,
      onValueMouseOut = props.onValueMouseOut,
      onLinkClick = props.onLinkClick,
      onLinkMouseOver = props.onLinkMouseOver,
      onLinkMouseOut = props.onLinkMouseOut,
      style = props.style,
      width = props.width;

  var nodesCopy = [].concat(_toConsumableArray(new Array(nodes.length))).map(function (e, i) {
    return _extends({}, nodes[i]);
  });
  var linksCopy = [].concat(_toConsumableArray(new Array(links.length))).map(function (e, i) {
    return _extends({}, links[i]);
  });

  var _getInnerDimensions = Object(__WEBPACK_IMPORTED_MODULE_4__utils_chart_utils__["c" /* getInnerDimensions */])({
    margin: margin,
    height: height,
    width: width
  }, DEFAULT_MARGINS),
      marginLeft = _getInnerDimensions.marginLeft,
      marginTop = _getInnerDimensions.marginTop,
      marginRight = _getInnerDimensions.marginRight,
      marginBottom = _getInnerDimensions.marginBottom;

  var sankeyInstance = Object(__WEBPACK_IMPORTED_MODULE_2_d3_sankey__["a" /* sankey */])().extent([[marginLeft, marginTop], [width - marginRight, height - marginBottom - marginTop]]).nodeWidth(nodeWidth).nodePadding(nodePadding).nodes(nodesCopy).links(linksCopy).nodeAlign(ALIGNMENTS[align]).iterations(layout);
  sankeyInstance(nodesCopy);

  var nWidth = sankeyInstance.nodeWidth();
  var path = Object(__WEBPACK_IMPORTED_MODULE_2_d3_sankey__["e" /* sankeyLinkHorizontal */])();

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__plot_xy_plot__["a" /* default */],
    _extends({}, props, { yType: 'literal', className: 'rv-sankey ' + className }),
    linksCopy.map(function (link, i) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__sankey_link__["a" /* default */], {
        style: style.links,
        data: path(link),
        opacity: link.opacity || linkOpacity,
        color: link.color,
        onLinkClick: onLinkClick,
        onLinkMouseOver: onLinkMouseOver,
        onLinkMouseOut: onLinkMouseOut,
        strokeWidth: Math.max(link.width, 1),
        node: link,
        nWidth: nWidth,
        key: 'link-' + i
      });
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__plot_series_vertical_rect_series__["a" /* default */], {
      animation: animation,
      className: className + ' rv-sankey__node',
      data: nodesCopy.map(function (node) {
        return _extends({}, node, {
          y: node.y1 - marginTop,
          y0: node.y0 - marginTop,
          x: node.x1,
          x0: node.x0,
          color: node.color || __WEBPACK_IMPORTED_MODULE_8__theme__["e" /* DISCRETE_COLOR_RANGE */][0],
          sourceLinks: null,
          targetLinks: null
        });
      }),
      style: style.rects,
      onValueClick: onValueClick,
      onValueMouseOver: onValueMouseOver,
      onValueMouseOut: onValueMouseOut,
      colorType: 'literal'
    }),
    !hideLabels && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__plot_series_label_series__["a" /* default */], {
      animation: animation,
      className: className,
      rotation: labelRotation,
      labelAnchorY: 'text-before-edge',
      data: nodesCopy.map(function (node, i) {
        return _extends({
          x: node.x0 + (node.x0 < width / 2 ? nWidth + 10 : -10),
          y: (node.y0 + node.y1) / 2 - marginTop,
          label: node.name,
          style: _extends({
            textAnchor: node.x0 < width / 2 ? 'start' : 'end',
            dy: '-.5em'
          }, style.labels)
        }, nodes[i]);
      })
    }),
    hasVoronoi && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__plot_voronoi__["a" /* default */], {
      className: 'rv-sankey__voronoi',
      extent: [[-marginLeft, -marginTop], [width + marginRight, height + marginBottom]],
      nodes: nodesCopy,
      onClick: onValueClick,
      onHover: onValueMouseOver,
      onBlur: onValueMouseOut,
      x: function x(d) {
        return d.x0 + (d.x1 - d.x0) / 2;
      },
      y: function y(d) {
        return d.y0 + (d.y1 - d.y0) / 2;
      }
    }),
    children
  );
}

Sankey.defaultProps = {
  align: 'justify',
  className: '',
  hasVoronoi: false,
  hideLabels: false,
  labelRotation: 0,
  layout: 50,
  margin: DEFAULT_MARGINS,
  nodePadding: 10,
  nodeWidth: 10,
  onValueMouseOver: NOOP,
  onValueClick: NOOP,
  onValueMouseOut: NOOP,
  onLinkClick: NOOP,
  onLinkMouseOver: NOOP,
  onLinkMouseOut: NOOP,
  style: {
    links: {},
    rects: {},
    labels: {}
  }
};

Sankey.propTypes = {
  align: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['justify', 'left', 'right', 'center']),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  hasVoronoi: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  hideLabels: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  labelRotation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  layout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  links: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    source: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
    target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
  })).isRequired,
  margin: __WEBPACK_IMPORTED_MODULE_4__utils_chart_utils__["b" /* MarginPropType */],
  nodePadding: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  nodes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,
  nodeWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onValueMouseOver: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onValueClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onValueMouseOut: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onLinkClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onLinkMouseOver: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onLinkMouseOut: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    links: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    rects: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    labels: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }),
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};
/* unused harmony default export */ var _unused_webpack_default_export = (Sankey);

/***/ }),
/* 2291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_sankey__ = __webpack_require__(2292);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_sankey__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_align__ = __webpack_require__(636);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_align__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__src_align__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__src_align__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__src_align__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_sankeyLinkHorizontal__ = __webpack_require__(2294);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__src_sankeyLinkHorizontal__["a"]; });





/***/ }),
/* 2292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_collection__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__align__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant__ = __webpack_require__(2293);





function ascendingSourceBreadth(a, b) {
  return ascendingBreadth(a.source, b.source) || a.index - b.index;
}

function ascendingTargetBreadth(a, b) {
  return ascendingBreadth(a.target, b.target) || a.index - b.index;
}

function ascendingBreadth(a, b) {
  return a.y0 - b.y0;
}

function value(d) {
  return d.value;
}

function nodeCenter(node) {
  return (node.y0 + node.y1) / 2;
}

function weightedSource(link) {
  return nodeCenter(link.source) * link.value;
}

function weightedTarget(link) {
  return nodeCenter(link.target) * link.value;
}

function defaultId(d) {
  return d.index;
}

function defaultNodes(graph) {
  return graph.nodes;
}

function defaultLinks(graph) {
  return graph.links;
}

function find(nodeById, id) {
  var node = nodeById.get(id);
  if (!node) throw new Error("missing: " + id);
  return node;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x0 = 0, y0 = 0, x1 = 1, y1 = 1, // extent
      dx = 24, // nodeWidth
      py = 8, // nodePadding
      id = defaultId,
      align = __WEBPACK_IMPORTED_MODULE_2__align__["b" /* justify */],
      nodes = defaultNodes,
      links = defaultLinks,
      iterations = 32;

  function sankey() {
    var graph = {nodes: nodes.apply(null, arguments), links: links.apply(null, arguments)};
    computeNodeLinks(graph);
    computeNodeValues(graph);
    computeNodeDepths(graph);
    computeNodeBreadths(graph, iterations);
    computeLinkBreadths(graph);
    return graph;
  }

  sankey.update = function(graph) {
    computeLinkBreadths(graph);
    return graph;
  };

  sankey.nodeId = function(_) {
    return arguments.length ? (id = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(_), sankey) : id;
  };

  sankey.nodeAlign = function(_) {
    return arguments.length ? (align = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(_), sankey) : align;
  };

  sankey.nodeWidth = function(_) {
    return arguments.length ? (dx = +_, sankey) : dx;
  };

  sankey.nodePadding = function(_) {
    return arguments.length ? (py = +_, sankey) : py;
  };

  sankey.nodes = function(_) {
    return arguments.length ? (nodes = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(_), sankey) : nodes;
  };

  sankey.links = function(_) {
    return arguments.length ? (links = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(_), sankey) : links;
  };

  sankey.size = function(_) {
    return arguments.length ? (x0 = y0 = 0, x1 = +_[0], y1 = +_[1], sankey) : [x1 - x0, y1 - y0];
  };

  sankey.extent = function(_) {
    return arguments.length ? (x0 = +_[0][0], x1 = +_[1][0], y0 = +_[0][1], y1 = +_[1][1], sankey) : [[x0, y0], [x1, y1]];
  };

  sankey.iterations = function(_) {
    return arguments.length ? (iterations = +_, sankey) : iterations;
  };

  // Populate the sourceLinks and targetLinks for each node.
  // Also, if the source and target are not objects, assume they are indices.
  function computeNodeLinks(graph) {
    graph.nodes.forEach(function(node, i) {
      node.index = i;
      node.sourceLinks = [];
      node.targetLinks = [];
    });
    var nodeById = Object(__WEBPACK_IMPORTED_MODULE_1_d3_collection__["a" /* map */])(graph.nodes, id);
    graph.links.forEach(function(link, i) {
      link.index = i;
      var source = link.source, target = link.target;
      if (typeof source !== "object") source = link.source = find(nodeById, source);
      if (typeof target !== "object") target = link.target = find(nodeById, target);
      source.sourceLinks.push(link);
      target.targetLinks.push(link);
    });
  }

  // Compute the value (size) of each node by summing the associated links.
  function computeNodeValues(graph) {
    graph.nodes.forEach(function(node) {
      node.value = Math.max(
        Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["j" /* sum */])(node.sourceLinks, value),
        Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["j" /* sum */])(node.targetLinks, value)
      );
    });
  }

  // Iteratively assign the depth (x-position) for each node.
  // Nodes are assigned the maximum depth of incoming neighbors plus one;
  // nodes with no incoming links are assigned depth zero, while
  // nodes with no outgoing links are assigned the maximum depth.
  function computeNodeDepths(graph) {
    var nodes, next, x;

    for (nodes = graph.nodes, next = [], x = 0; nodes.length; ++x, nodes = next, next = []) {
      nodes.forEach(function(node) {
        node.depth = x;
        node.sourceLinks.forEach(function(link) {
          if (next.indexOf(link.target) < 0) {
            next.push(link.target);
          }
        });
      });
    }

    for (nodes = graph.nodes, next = [], x = 0; nodes.length; ++x, nodes = next, next = []) {
      nodes.forEach(function(node) {
        node.height = x;
        node.targetLinks.forEach(function(link) {
          if (next.indexOf(link.source) < 0) {
            next.push(link.source);
          }
        });
      });
    }

    var kx = (x1 - x0 - dx) / (x - 1);
    graph.nodes.forEach(function(node) {
      node.x1 = (node.x0 = x0 + Math.max(0, Math.min(x - 1, Math.floor(align.call(null, node, x)))) * kx) + dx;
    });
  }

  function computeNodeBreadths(graph) {
    var columns = Object(__WEBPACK_IMPORTED_MODULE_1_d3_collection__["b" /* nest */])()
        .key(function(d) { return d.x0; })
        .sortKeys(__WEBPACK_IMPORTED_MODULE_0_d3_array__["a" /* ascending */])
        .entries(graph.nodes)
        .map(function(d) { return d.values; });

    //
    initializeNodeBreadth();
    resolveCollisions();
    for (var alpha = 1, n = iterations; n > 0; --n) {
      relaxRightToLeft(alpha *= 0.99);
      resolveCollisions();
      relaxLeftToRight(alpha);
      resolveCollisions();
    }

    function initializeNodeBreadth() {
      var ky = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["g" /* min */])(columns, function(nodes) {
        return (y1 - y0 - (nodes.length - 1) * py) / Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["j" /* sum */])(nodes, value);
      });

      columns.forEach(function(nodes) {
        nodes.forEach(function(node, i) {
          node.y1 = (node.y0 = i) + node.value * ky;
        });
      });

      graph.links.forEach(function(link) {
        link.width = link.value * ky;
      });
    }

    function relaxLeftToRight(alpha) {
      columns.forEach(function(nodes) {
        nodes.forEach(function(node) {
          if (node.targetLinks.length) {
            var dy = (Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["j" /* sum */])(node.targetLinks, weightedSource) / Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["j" /* sum */])(node.targetLinks, value) - nodeCenter(node)) * alpha;
            node.y0 += dy, node.y1 += dy;
          }
        });
      });
    }

    function relaxRightToLeft(alpha) {
      columns.slice().reverse().forEach(function(nodes) {
        nodes.forEach(function(node) {
          if (node.sourceLinks.length) {
            var dy = (Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["j" /* sum */])(node.sourceLinks, weightedTarget) / Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["j" /* sum */])(node.sourceLinks, value) - nodeCenter(node)) * alpha;
            node.y0 += dy, node.y1 += dy;
          }
        });
      });
    }

    function resolveCollisions() {
      columns.forEach(function(nodes) {
        var node,
            dy,
            y = y0,
            n = nodes.length,
            i;

        // Push any overlapping nodes down.
        nodes.sort(ascendingBreadth);
        for (i = 0; i < n; ++i) {
          node = nodes[i];
          dy = y - node.y0;
          if (dy > 0) node.y0 += dy, node.y1 += dy;
          y = node.y1 + py;
        }

        // If the bottommost node goes outside the bounds, push it back up.
        dy = y - py - y1;
        if (dy > 0) {
          y = (node.y0 -= dy), node.y1 -= dy;

          // Push any overlapping nodes back up.
          for (i = n - 2; i >= 0; --i) {
            node = nodes[i];
            dy = node.y1 + py - y;
            if (dy > 0) node.y0 -= dy, node.y1 -= dy;
            y = node.y0;
          }
        }
      });
    }
  }

  function computeLinkBreadths(graph) {
    graph.nodes.forEach(function(node) {
      node.sourceLinks.sort(ascendingTargetBreadth);
      node.targetLinks.sort(ascendingSourceBreadth);
    });
    graph.nodes.forEach(function(node) {
      var y0 = node.y0, y1 = y0;
      node.sourceLinks.forEach(function(link) {
        link.y0 = y0 + link.width / 2, y0 += link.width;
      });
      node.targetLinks.forEach(function(link) {
        link.y1 = y1 + link.width / 2, y1 += link.width;
      });
    });
  }

  return sankey;
});


/***/ }),
/* 2293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = constant;
function constant(x) {
  return function() {
    return x;
  };
}


/***/ }),
/* 2294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_shape__ = __webpack_require__(163);


function horizontalSource(d) {
  return [d.source.x1, d.y0];
}

function horizontalTarget(d) {
  return [d.target.x0, d.y1];
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_d3_shape__["linkHorizontal"])()
      .source(horizontalSource)
      .target(horizontalTarget);
});


/***/ }),
/* 2295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__theme__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__animation__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_series_utils__ = __webpack_require__(66);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.






var DEFAULT_LINK_COLOR = __WEBPACK_IMPORTED_MODULE_1__theme__["e" /* DISCRETE_COLOR_RANGE */][1];
var DEFAULT_LINK_OPACITY = 0.7;

function SankeyLink(props) {
  var animation = props.animation,
      data = props.data,
      node = props.node,
      opacity = props.opacity,
      color = props.color,
      strokeWidth = props.strokeWidth,
      style = props.style,
      onLinkClick = props.onLinkClick,
      onLinkMouseOver = props.onLinkMouseOver,
      onLinkMouseOut = props.onLinkMouseOut;

  if (animation) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__animation__["b" /* default */],
      _extends({}, props, { animatedProps: __WEBPACK_IMPORTED_MODULE_3__utils_series_utils__["a" /* ANIMATED_SERIES_PROPS */] }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SankeyLink, _extends({}, props, { animation: null }))
    );
  }
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', _extends({
    d: data
  }, style, {
    className: 'rv-sankey__link',
    opacity: Number.isFinite(opacity) ? opacity : DEFAULT_LINK_OPACITY,
    stroke: color || DEFAULT_LINK_COLOR,
    onClick: function onClick(e) {
      return onLinkClick(node, e);
    },
    onMouseOver: function onMouseOver(e) {
      return onLinkMouseOver(node, e);
    },
    onMouseOut: function onMouseOut(e) {
      return onLinkMouseOut(node, e);
    },
    strokeWidth: strokeWidth,
    fill: 'none'
  }));
}

SankeyLink.displayName = 'SankeyLink';
SankeyLink.requiresSVG = true;
/* harmony default export */ __webpack_exports__["a"] = (SankeyLink);

/***/ }),
/* 2296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_hierarchy__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_scale__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__animation__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plot_series_label_series__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plot_series_arc_series__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__plot_xy_plot__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_series_utils__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_chart_utils__ = __webpack_require__(135);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.














var predefinedClassName = 'rv-sunburst';

var LISTENERS_TO_OVERWRITE = ['onValueMouseOver', 'onValueMouseOut', 'onValueClick', 'onValueRightClick', 'onSeriesMouseOver', 'onSeriesMouseOut', 'onSeriesClick', 'onSeriesRightClick'];

/**
 * Create the list of nodes to render.
 * @param {Object} props
   props.data {Object} - tree structured data (each node has a name anc an array of children)
   props.height {number} - the height of the graphic to be rendered
   props.hideRootNode {boolean} - whether or not to hide the root node
   props.width {number} - the width of the graphic to be rendered
   props.getSize {function} - accessor for the size
 * @returns {Array} Array of nodes.
 */
function getNodesToRender(_ref) {
  var data = _ref.data,
      height = _ref.height,
      hideRootNode = _ref.hideRootNode,
      width = _ref.width,
      getSize = _ref.getSize;

  var partitionFunction = Object(__WEBPACK_IMPORTED_MODULE_2_d3_hierarchy__["c" /* partition */])();
  var structuredInput = Object(__WEBPACK_IMPORTED_MODULE_2_d3_hierarchy__["a" /* hierarchy */])(data).sum(getSize);
  var radius = Math.min(width, height) / 2 - 10;
  var x = Object(__WEBPACK_IMPORTED_MODULE_3_d3_scale__["a" /* scaleLinear */])().range([0, 2 * Math.PI]);
  var y = Object(__WEBPACK_IMPORTED_MODULE_3_d3_scale__["e" /* scaleSqrt */])().range([0, radius]);

  return partitionFunction(structuredInput).descendants().reduce(function (res, cell, index) {
    if (hideRootNode && index === 0) {
      return res;
    }

    return res.concat([_extends({
      angle0: Math.max(0, Math.min(2 * Math.PI, x(cell.x0))),
      angle: Math.max(0, Math.min(2 * Math.PI, x(cell.x1))),
      radius0: Math.max(0, y(cell.y0)),
      radius: Math.max(0, y(cell.y1)),
      depth: cell.depth,
      parent: cell.parent
    }, cell.data)]);
  }, []);
}

/**
 * Convert arc nodes into label rows.
 * Important to use mappedData rather than regular data, bc it is already unrolled
 * @param {Array} mappedData - Array of nodes.
 * @param {Object} accessors - object of accessors
 * @returns {Array} array of node for rendering as labels
 */
function buildLabels(mappedData, accessors) {
  var getAngle = accessors.getAngle,
      getAngle0 = accessors.getAngle0,
      getLabel = accessors.getLabel,
      getRadius0 = accessors.getRadius0;


  return mappedData.filter(getLabel).map(function (row) {
    var truedAngle = -1 * getAngle(row) + Math.PI / 2;
    var truedAngle0 = -1 * getAngle0(row) + Math.PI / 2;
    var angle = (truedAngle0 + truedAngle) / 2;
    var rotateLabels = !row.dontRotateLabel;
    var rotAngle = -angle / (2 * Math.PI) * 360;

    return _extends({}, row, {
      children: null,
      angle: null,
      radius: null,
      x: getRadius0(row) * Math.cos(angle),
      y: getRadius0(row) * Math.sin(angle),
      style: _extends({
        textAnchor: rotAngle > 90 ? 'end' : 'start'
      }, row.labelStyle),
      rotation: rotateLabels ? rotAngle > 90 ? rotAngle + 180 : rotAngle === 90 ? 90 : rotAngle : null
    });
  });
}

var NOOP = function NOOP() {};

function Sunburst(props) {
  var getAngle = props.getAngle,
      getAngle0 = props.getAngle0,
      animation = props.animation,
      className = props.className,
      children = props.children,
      data = props.data,
      height = props.height,
      hideRootNode = props.hideRootNode,
      getLabel = props.getLabel,
      width = props.width,
      getSize = props.getSize,
      colorType = props.colorType;

  var mappedData = getNodesToRender({
    data: data,
    height: height,
    hideRootNode: hideRootNode,
    width: width,
    getSize: getSize
  });
  var radialDomain = Object(__WEBPACK_IMPORTED_MODULE_8__utils_series_utils__["b" /* getRadialDomain */])(mappedData);
  var margin = Object(__WEBPACK_IMPORTED_MODULE_9__utils_chart_utils__["d" /* getRadialLayoutMargin */])(width, height, radialDomain);

  var labelData = buildLabels(mappedData, {
    getAngle: getAngle,
    getAngle0: getAngle0,
    getLabel: getLabel,
    getRadius0: function getRadius0(d) {
      return d.radius0;
    }
  });

  var hofBuilder = function hofBuilder(f) {
    return function (e, i) {
      return f ? f(mappedData[e.index], i) : NOOP;
    };
  };
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_7__plot_xy_plot__["a" /* default */],
    {
      height: height,
      hasTreeStructure: true,
      width: width,
      className: predefinedClassName + ' ' + className,
      margin: margin,
      xDomain: [-radialDomain, radialDomain],
      yDomain: [-radialDomain, radialDomain]
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__plot_series_arc_series__["a" /* default */], _extends({
      colorType: colorType
    }, props, {
      animation: animation,
      radiusDomain: [0, radialDomain],
      // need to present a stripped down version for interpolation
      data: animation ? mappedData.map(function (row, index) {
        return _extends({}, row, {
          parent: null,
          children: null,
          index: index
        });
      }) : mappedData,
      _data: animation ? mappedData : null,
      arcClassName: predefinedClassName + '__series--radial__arc'
    }, LISTENERS_TO_OVERWRITE.reduce(function (acc, propName) {
      var prop = props[propName];
      acc[propName] = animation ? hofBuilder(prop) : prop;
      return acc;
    }, {}))),
    labelData.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__plot_series_label_series__["a" /* default */], { data: labelData, getLabel: getLabel }),
    children
  );
}

Sunburst.displayName = 'Sunburst';
Sunburst.propTypes = {
  animation: __WEBPACK_IMPORTED_MODULE_4__animation__["a" /* AnimationPropType */],
  getAngle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  getAngle0: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  colorType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  hideRootNode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  getLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onValueClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onValueMouseOver: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onValueMouseOut: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  getSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  padAngle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])
};
Sunburst.defaultProps = {
  getAngle: function getAngle(d) {
    return d.angle;
  },
  getAngle0: function getAngle0(d) {
    return d.angle0;
  },
  className: '',
  colorType: 'literal',
  getColor: function getColor(d) {
    return d.color;
  },
  hideRootNode: false,
  getLabel: function getLabel(d) {
    return d.label;
  },
  getSize: function getSize(d) {
    return d.size;
  },
  padAngle: 0
};

/* unused harmony default export */ var _unused_webpack_default_export = (Sunburst);

/***/ }),
/* 2297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function defaultSeparation(a, b) {
  return a.parent === b.parent ? 1 : 2;
}

function meanX(children) {
  return children.reduce(meanXReduce, 0) / children.length;
}

function meanXReduce(x, c) {
  return x + c.x;
}

function maxY(children) {
  return 1 + children.reduce(maxYReduce, 0);
}

function maxYReduce(y, c) {
  return Math.max(y, c.y);
}

function leafLeft(node) {
  var children;
  while (children = node.children) node = children[0];
  return node;
}

function leafRight(node) {
  var children;
  while (children = node.children) node = children[children.length - 1];
  return node;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var separation = defaultSeparation,
      dx = 1,
      dy = 1,
      nodeSize = false;

  function cluster(root) {
    var previousNode,
        x = 0;

    // First walk, computing the initial x & y values.
    root.eachAfter(function(node) {
      var children = node.children;
      if (children) {
        node.x = meanX(children);
        node.y = maxY(children);
      } else {
        node.x = previousNode ? x += separation(node, previousNode) : 0;
        node.y = 0;
        previousNode = node;
      }
    });

    var left = leafLeft(root),
        right = leafRight(root),
        x0 = left.x - separation(left, right) / 2,
        x1 = right.x + separation(right, left) / 2;

    // Second walk, normalizing x & y to the desired size.
    return root.eachAfter(nodeSize ? function(node) {
      node.x = (node.x - root.x) * dx;
      node.y = (root.y - node.y) * dy;
    } : function(node) {
      node.x = (node.x - x0) / (x1 - x0) * dx;
      node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
    });
  }

  cluster.separation = function(x) {
    return arguments.length ? (separation = x, cluster) : separation;
  };

  cluster.size = function(x) {
    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? null : [dx, dy]);
  };

  cluster.nodeSize = function(x) {
    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? [dx, dy] : null);
  };

  return cluster;
});


/***/ }),
/* 2298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function count(node) {
  var sum = 0,
      children = node.children,
      i = children && children.length;
  if (!i) sum = 1;
  else while (--i >= 0) sum += children[i].value;
  node.value = sum;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return this.eachAfter(count);
});


/***/ }),
/* 2299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(callback) {
  var node = this, current, next = [node], children, i, n;
  do {
    current = next.reverse(), next = [];
    while (node = current.pop()) {
      callback(node), children = node.children;
      if (children) for (i = 0, n = children.length; i < n; ++i) {
        next.push(children[i]);
      }
    }
  } while (next.length);
  return this;
});


/***/ }),
/* 2300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(callback) {
  var node = this, nodes = [node], children, i;
  while (node = nodes.pop()) {
    callback(node), children = node.children;
    if (children) for (i = children.length - 1; i >= 0; --i) {
      nodes.push(children[i]);
    }
  }
  return this;
});


/***/ }),
/* 2301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(callback) {
  var node = this, nodes = [node], next = [], children, i, n;
  while (node = nodes.pop()) {
    next.push(node), children = node.children;
    if (children) for (i = 0, n = children.length; i < n; ++i) {
      nodes.push(children[i]);
    }
  }
  while (node = next.pop()) {
    callback(node);
  }
  return this;
});


/***/ }),
/* 2302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(value) {
  return this.eachAfter(function(node) {
    var sum = +value(node.data) || 0,
        children = node.children,
        i = children && children.length;
    while (--i >= 0) sum += children[i].value;
    node.value = sum;
  });
});


/***/ }),
/* 2303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(compare) {
  return this.eachBefore(function(node) {
    if (node.children) {
      node.children.sort(compare);
    }
  });
});


/***/ }),
/* 2304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(end) {
  var start = this,
      ancestor = leastCommonAncestor(start, end),
      nodes = [start];
  while (start !== ancestor) {
    start = start.parent;
    nodes.push(start);
  }
  var k = nodes.length;
  while (end !== ancestor) {
    nodes.splice(k, 0, end);
    end = end.parent;
  }
  return nodes;
});

function leastCommonAncestor(a, b) {
  if (a === b) return a;
  var aNodes = a.ancestors(),
      bNodes = b.ancestors(),
      c = null;
  a = aNodes.pop();
  b = bNodes.pop();
  while (a === b) {
    c = a;
    a = aNodes.pop();
    b = bNodes.pop();
  }
  return c;
}


/***/ }),
/* 2305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var node = this, nodes = [node];
  while (node = node.parent) {
    nodes.push(node);
  }
  return nodes;
});


/***/ }),
/* 2306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var nodes = [];
  this.each(function(node) {
    nodes.push(node);
  });
  return nodes;
});


/***/ }),
/* 2307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var leaves = [];
  this.eachBefore(function(node) {
    if (!node.children) {
      leaves.push(node);
    }
  });
  return leaves;
});


/***/ }),
/* 2308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {
  var root = this, links = [];
  root.each(function(node) {
    if (node !== root) { // Don’t include the root’s parent, if any.
      links.push({source: node.parent, target: node});
    }
  });
  return links;
});


/***/ }),
/* 2309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__siblings_js__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessors_js__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant_js__ = __webpack_require__(640);




function defaultRadius(d) {
  return Math.sqrt(d.value);
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var radius = null,
      dx = 1,
      dy = 1,
      padding = __WEBPACK_IMPORTED_MODULE_2__constant_js__["a" /* constantZero */];

  function pack(root) {
    root.x = dx / 2, root.y = dy / 2;
    if (radius) {
      root.eachBefore(radiusLeaf(radius))
          .eachAfter(packChildren(padding, 0.5))
          .eachBefore(translateChild(1));
    } else {
      root.eachBefore(radiusLeaf(defaultRadius))
          .eachAfter(packChildren(__WEBPACK_IMPORTED_MODULE_2__constant_js__["a" /* constantZero */], 1))
          .eachAfter(packChildren(padding, root.r / Math.min(dx, dy)))
          .eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
    }
    return root;
  }

  pack.radius = function(x) {
    return arguments.length ? (radius = Object(__WEBPACK_IMPORTED_MODULE_1__accessors_js__["a" /* optional */])(x), pack) : radius;
  };

  pack.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [dx, dy];
  };

  pack.padding = function(x) {
    return arguments.length ? (padding = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_2__constant_js__["b" /* default */])(+x), pack) : padding;
  };

  return pack;
});

function radiusLeaf(radius) {
  return function(node) {
    if (!node.children) {
      node.r = Math.max(0, +radius(node) || 0);
    }
  };
}

function packChildren(padding, k) {
  return function(node) {
    if (children = node.children) {
      var children,
          i,
          n = children.length,
          r = padding(node) * k || 0,
          e;

      if (r) for (i = 0; i < n; ++i) children[i].r += r;
      e = Object(__WEBPACK_IMPORTED_MODULE_0__siblings_js__["a" /* packEnclose */])(children);
      if (r) for (i = 0; i < n; ++i) children[i].r -= r;
      node.r = e + r;
    }
  };
}

function translateChild(k) {
  return function(node) {
    var parent = node.parent;
    node.r *= k;
    if (parent) {
      node.x = parent.x + k * node.x;
      node.y = parent.y + k * node.y;
    }
  };
}


/***/ }),
/* 2310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
/* harmony export (immutable) */ __webpack_exports__["a"] = shuffle;
var slice = Array.prototype.slice;

function shuffle(array) {
  var m = array.length,
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m];
    array[m] = array[i];
    array[i] = t;
  }

  return array;
}


/***/ }),
/* 2311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__treemap_round_js__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__treemap_dice_js__ = __webpack_require__(204);



/* harmony default export */ __webpack_exports__["a"] = (function() {
  var dx = 1,
      dy = 1,
      padding = 0,
      round = false;

  function partition(root) {
    var n = root.height + 1;
    root.x0 =
    root.y0 = padding;
    root.x1 = dx;
    root.y1 = dy / n;
    root.eachBefore(positionNode(dy, n));
    if (round) root.eachBefore(__WEBPACK_IMPORTED_MODULE_0__treemap_round_js__["a" /* default */]);
    return root;
  }

  function positionNode(dy, n) {
    return function(node) {
      if (node.children) {
        Object(__WEBPACK_IMPORTED_MODULE_1__treemap_dice_js__["a" /* default */])(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
      }
      var x0 = node.x0,
          y0 = node.y0,
          x1 = node.x1 - padding,
          y1 = node.y1 - padding;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      node.x0 = x0;
      node.y0 = y0;
      node.x1 = x1;
      node.y1 = y1;
    };
  }

  partition.round = function(x) {
    return arguments.length ? (round = !!x, partition) : round;
  };

  partition.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [dx, dy];
  };

  partition.padding = function(x) {
    return arguments.length ? (padding = +x, partition) : padding;
  };

  return partition;
});


/***/ }),
/* 2312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__accessors_js__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hierarchy_index_js__ = __webpack_require__(376);



var keyPrefix = "$", // Protect against keys like “__proto__”.
    preroot = {depth: -1},
    ambiguous = {};

function defaultId(d) {
  return d.id;
}

function defaultParentId(d) {
  return d.parentId;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var id = defaultId,
      parentId = defaultParentId;

  function stratify(data) {
    var d,
        i,
        n = data.length,
        root,
        parent,
        node,
        nodes = new Array(n),
        nodeId,
        nodeKey,
        nodeByKey = {};

    for (i = 0; i < n; ++i) {
      d = data[i], node = nodes[i] = new __WEBPACK_IMPORTED_MODULE_1__hierarchy_index_js__["a" /* Node */](d);
      if ((nodeId = id(d, i, data)) != null && (nodeId += "")) {
        nodeKey = keyPrefix + (node.id = nodeId);
        nodeByKey[nodeKey] = nodeKey in nodeByKey ? ambiguous : node;
      }
    }

    for (i = 0; i < n; ++i) {
      node = nodes[i], nodeId = parentId(data[i], i, data);
      if (nodeId == null || !(nodeId += "")) {
        if (root) throw new Error("multiple roots");
        root = node;
      } else {
        parent = nodeByKey[keyPrefix + nodeId];
        if (!parent) throw new Error("missing: " + nodeId);
        if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
        if (parent.children) parent.children.push(node);
        else parent.children = [node];
        node.parent = parent;
      }
    }

    if (!root) throw new Error("no root");
    root.parent = preroot;
    root.eachBefore(function(node) { node.depth = node.parent.depth + 1; --n; }).eachBefore(__WEBPACK_IMPORTED_MODULE_1__hierarchy_index_js__["b" /* computeHeight */]);
    root.parent = null;
    if (n > 0) throw new Error("cycle");

    return root;
  }

  stratify.id = function(x) {
    return arguments.length ? (id = Object(__WEBPACK_IMPORTED_MODULE_0__accessors_js__["b" /* required */])(x), stratify) : id;
  };

  stratify.parentId = function(x) {
    return arguments.length ? (parentId = Object(__WEBPACK_IMPORTED_MODULE_0__accessors_js__["b" /* required */])(x), stratify) : parentId;
  };

  return stratify;
});


/***/ }),
/* 2313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hierarchy_index_js__ = __webpack_require__(376);


function defaultSeparation(a, b) {
  return a.parent === b.parent ? 1 : 2;
}

// function radialSeparation(a, b) {
//   return (a.parent === b.parent ? 1 : 2) / a.depth;
// }

// This function is used to traverse the left contour of a subtree (or
// subforest). It returns the successor of v on this contour. This successor is
// either given by the leftmost child of v or by the thread of v. The function
// returns null if and only if v is on the highest level of its subtree.
function nextLeft(v) {
  var children = v.children;
  return children ? children[0] : v.t;
}

// This function works analogously to nextLeft.
function nextRight(v) {
  var children = v.children;
  return children ? children[children.length - 1] : v.t;
}

// Shifts the current subtree rooted at w+. This is done by increasing
// prelim(w+) and mod(w+) by shift.
function moveSubtree(wm, wp, shift) {
  var change = shift / (wp.i - wm.i);
  wp.c -= change;
  wp.s += shift;
  wm.c += change;
  wp.z += shift;
  wp.m += shift;
}

// All other shifts, applied to the smaller subtrees between w- and w+, are
// performed by this function. To prepare the shifts, we have to adjust
// change(w+), shift(w+), and change(w-).
function executeShifts(v) {
  var shift = 0,
      change = 0,
      children = v.children,
      i = children.length,
      w;
  while (--i >= 0) {
    w = children[i];
    w.z += shift;
    w.m += shift;
    shift += w.s + (change += w.c);
  }
}

// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
// returns the specified (default) ancestor.
function nextAncestor(vim, v, ancestor) {
  return vim.a.parent === v.parent ? vim.a : ancestor;
}

function TreeNode(node, i) {
  this._ = node;
  this.parent = null;
  this.children = null;
  this.A = null; // default ancestor
  this.a = this; // ancestor
  this.z = 0; // prelim
  this.m = 0; // mod
  this.c = 0; // change
  this.s = 0; // shift
  this.t = null; // thread
  this.i = i; // number
}

TreeNode.prototype = Object.create(__WEBPACK_IMPORTED_MODULE_0__hierarchy_index_js__["a" /* Node */].prototype);

function treeRoot(root) {
  var tree = new TreeNode(root, 0),
      node,
      nodes = [tree],
      child,
      children,
      i,
      n;

  while (node = nodes.pop()) {
    if (children = node._.children) {
      node.children = new Array(n = children.length);
      for (i = n - 1; i >= 0; --i) {
        nodes.push(child = node.children[i] = new TreeNode(children[i], i));
        child.parent = node;
      }
    }
  }

  (tree.parent = new TreeNode(null, 0)).children = [tree];
  return tree;
}

// Node-link tree diagram using the Reingold-Tilford "tidy" algorithm
/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var separation = defaultSeparation,
      dx = 1,
      dy = 1,
      nodeSize = null;

  function tree(root) {
    var t = treeRoot(root);

    // Compute the layout using Buchheim et al.’s algorithm.
    t.eachAfter(firstWalk), t.parent.m = -t.z;
    t.eachBefore(secondWalk);

    // If a fixed node size is specified, scale x and y.
    if (nodeSize) root.eachBefore(sizeNode);

    // If a fixed tree size is specified, scale x and y based on the extent.
    // Compute the left-most, right-most, and depth-most nodes for extents.
    else {
      var left = root,
          right = root,
          bottom = root;
      root.eachBefore(function(node) {
        if (node.x < left.x) left = node;
        if (node.x > right.x) right = node;
        if (node.depth > bottom.depth) bottom = node;
      });
      var s = left === right ? 1 : separation(left, right) / 2,
          tx = s - left.x,
          kx = dx / (right.x + s + tx),
          ky = dy / (bottom.depth || 1);
      root.eachBefore(function(node) {
        node.x = (node.x + tx) * kx;
        node.y = node.depth * ky;
      });
    }

    return root;
  }

  // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
  // applied recursively to the children of v, as well as the function
  // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
  // node v is placed to the midpoint of its outermost children.
  function firstWalk(v) {
    var children = v.children,
        siblings = v.parent.children,
        w = v.i ? siblings[v.i - 1] : null;
    if (children) {
      executeShifts(v);
      var midpoint = (children[0].z + children[children.length - 1].z) / 2;
      if (w) {
        v.z = w.z + separation(v._, w._);
        v.m = v.z - midpoint;
      } else {
        v.z = midpoint;
      }
    } else if (w) {
      v.z = w.z + separation(v._, w._);
    }
    v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
  }

  // Computes all real x-coordinates by summing up the modifiers recursively.
  function secondWalk(v) {
    v._.x = v.z + v.parent.m;
    v.m += v.parent.m;
  }

  // The core of the algorithm. Here, a new subtree is combined with the
  // previous subtrees. Threads are used to traverse the inside and outside
  // contours of the left and right subtree up to the highest common level. The
  // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
  // superscript o means outside and i means inside, the subscript - means left
  // subtree and + means right subtree. For summing up the modifiers along the
  // contour, we use respective variables si+, si-, so-, and so+. Whenever two
  // nodes of the inside contours conflict, we compute the left one of the
  // greatest uncommon ancestors using the function ANCESTOR and call MOVE
  // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
  // Finally, we add a new thread (if necessary).
  function apportion(v, w, ancestor) {
    if (w) {
      var vip = v,
          vop = v,
          vim = w,
          vom = vip.parent.children[0],
          sip = vip.m,
          sop = vop.m,
          sim = vim.m,
          som = vom.m,
          shift;
      while (vim = nextRight(vim), vip = nextLeft(vip), vim && vip) {
        vom = nextLeft(vom);
        vop = nextRight(vop);
        vop.a = v;
        shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
        if (shift > 0) {
          moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
          sip += shift;
          sop += shift;
        }
        sim += vim.m;
        sip += vip.m;
        som += vom.m;
        sop += vop.m;
      }
      if (vim && !nextRight(vop)) {
        vop.t = vim;
        vop.m += sim - sop;
      }
      if (vip && !nextLeft(vom)) {
        vom.t = vip;
        vom.m += sip - som;
        ancestor = v;
      }
    }
    return ancestor;
  }

  function sizeNode(node) {
    node.x *= dx;
    node.y = node.depth * dy;
  }

  tree.separation = function(x) {
    return arguments.length ? (separation = x, tree) : separation;
  };

  tree.size = function(x) {
    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : (nodeSize ? null : [dx, dy]);
  };

  tree.nodeSize = function(x) {
    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : (nodeSize ? [dx, dy] : null);
  };

  return tree;
});


/***/ }),
/* 2314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__round_js__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__squarify_js__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__accessors_js__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant_js__ = __webpack_require__(640);





/* harmony default export */ __webpack_exports__["a"] = (function() {
  var tile = __WEBPACK_IMPORTED_MODULE_1__squarify_js__["a" /* default */],
      round = false,
      dx = 1,
      dy = 1,
      paddingStack = [0],
      paddingInner = __WEBPACK_IMPORTED_MODULE_3__constant_js__["a" /* constantZero */],
      paddingTop = __WEBPACK_IMPORTED_MODULE_3__constant_js__["a" /* constantZero */],
      paddingRight = __WEBPACK_IMPORTED_MODULE_3__constant_js__["a" /* constantZero */],
      paddingBottom = __WEBPACK_IMPORTED_MODULE_3__constant_js__["a" /* constantZero */],
      paddingLeft = __WEBPACK_IMPORTED_MODULE_3__constant_js__["a" /* constantZero */];

  function treemap(root) {
    root.x0 =
    root.y0 = 0;
    root.x1 = dx;
    root.y1 = dy;
    root.eachBefore(positionNode);
    paddingStack = [0];
    if (round) root.eachBefore(__WEBPACK_IMPORTED_MODULE_0__round_js__["a" /* default */]);
    return root;
  }

  function positionNode(node) {
    var p = paddingStack[node.depth],
        x0 = node.x0 + p,
        y0 = node.y0 + p,
        x1 = node.x1 - p,
        y1 = node.y1 - p;
    if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
    if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
    node.x0 = x0;
    node.y0 = y0;
    node.x1 = x1;
    node.y1 = y1;
    if (node.children) {
      p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
      x0 += paddingLeft(node) - p;
      y0 += paddingTop(node) - p;
      x1 -= paddingRight(node) - p;
      y1 -= paddingBottom(node) - p;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      tile(node, x0, y0, x1, y1);
    }
  }

  treemap.round = function(x) {
    return arguments.length ? (round = !!x, treemap) : round;
  };

  treemap.size = function(x) {
    return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [dx, dy];
  };

  treemap.tile = function(x) {
    return arguments.length ? (tile = Object(__WEBPACK_IMPORTED_MODULE_2__accessors_js__["b" /* required */])(x), treemap) : tile;
  };

  treemap.padding = function(x) {
    return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
  };

  treemap.paddingInner = function(x) {
    return arguments.length ? (paddingInner = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant_js__["b" /* default */])(+x), treemap) : paddingInner;
  };

  treemap.paddingOuter = function(x) {
    return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
  };

  treemap.paddingTop = function(x) {
    return arguments.length ? (paddingTop = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant_js__["b" /* default */])(+x), treemap) : paddingTop;
  };

  treemap.paddingRight = function(x) {
    return arguments.length ? (paddingRight = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant_js__["b" /* default */])(+x), treemap) : paddingRight;
  };

  treemap.paddingBottom = function(x) {
    return arguments.length ? (paddingBottom = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant_js__["b" /* default */])(+x), treemap) : paddingBottom;
  };

  treemap.paddingLeft = function(x) {
    return arguments.length ? (paddingLeft = typeof x === "function" ? x : Object(__WEBPACK_IMPORTED_MODULE_3__constant_js__["b" /* default */])(+x), treemap) : paddingLeft;
  };

  return treemap;
});


/***/ }),
/* 2315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      i, n = nodes.length,
      sum, sums = new Array(n + 1);

  for (sums[0] = sum = i = 0; i < n; ++i) {
    sums[i + 1] = sum += nodes[i].value;
  }

  partition(0, n, parent.value, x0, y0, x1, y1);

  function partition(i, j, value, x0, y0, x1, y1) {
    if (i >= j - 1) {
      var node = nodes[i];
      node.x0 = x0, node.y0 = y0;
      node.x1 = x1, node.y1 = y1;
      return;
    }

    var valueOffset = sums[i],
        valueTarget = (value / 2) + valueOffset,
        k = i + 1,
        hi = j - 1;

    while (k < hi) {
      var mid = k + hi >>> 1;
      if (sums[mid] < valueTarget) k = mid + 1;
      else hi = mid;
    }

    if ((valueTarget - sums[k - 1]) < (sums[k] - valueTarget) && i + 1 < k) --k;

    var valueLeft = sums[k] - valueOffset,
        valueRight = value - valueLeft;

    if ((x1 - x0) > (y1 - y0)) {
      var xk = (x0 * valueRight + x1 * valueLeft) / value;
      partition(i, k, valueLeft, x0, y0, xk, y1);
      partition(k, j, valueRight, xk, y0, x1, y1);
    } else {
      var yk = (y0 * valueRight + y1 * valueLeft) / value;
      partition(i, k, valueLeft, x0, y0, x1, yk);
      partition(k, j, valueRight, x0, yk, x1, y1);
    }
  }
});


/***/ }),
/* 2316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dice_js__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slice_js__ = __webpack_require__(266);



/* harmony default export */ __webpack_exports__["a"] = (function(parent, x0, y0, x1, y1) {
  (parent.depth & 1 ? __WEBPACK_IMPORTED_MODULE_1__slice_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_0__dice_js__["a" /* default */])(parent, x0, y0, x1, y1);
});


/***/ }),
/* 2317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dice_js__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slice_js__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__squarify_js__ = __webpack_require__(378);




/* harmony default export */ __webpack_exports__["a"] = ((function custom(ratio) {

  function resquarify(parent, x0, y0, x1, y1) {
    if ((rows = parent._squarify) && (rows.ratio === ratio)) {
      var rows,
          row,
          nodes,
          i,
          j = -1,
          n,
          m = rows.length,
          value = parent.value;

      while (++j < m) {
        row = rows[j], nodes = row.children;
        for (i = row.value = 0, n = nodes.length; i < n; ++i) row.value += nodes[i].value;
        if (row.dice) Object(__WEBPACK_IMPORTED_MODULE_0__dice_js__["a" /* default */])(row, x0, y0, x1, y0 += (y1 - y0) * row.value / value);
        else Object(__WEBPACK_IMPORTED_MODULE_1__slice_js__["a" /* default */])(row, x0, y0, x0 += (x1 - x0) * row.value / value, y1);
        value -= row.value;
      }
    } else {
      parent._squarify = rows = Object(__WEBPACK_IMPORTED_MODULE_2__squarify_js__["c" /* squarifyRatio */])(ratio, parent, x0, y0, x1, y1);
      rows.ratio = ratio;
    }
  }

  resquarify.ratio = function(x) {
    return custom((x = +x) > 1 ? x : 1);
  };

  return resquarify;
})(__WEBPACK_IMPORTED_MODULE_2__squarify_js__["b" /* phi */]));


/***/ }),
/* 2318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_hierarchy__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__theme__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__animation__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_scales_utils__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_chart_utils__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__treemap_dom__ = __webpack_require__(2319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__treemap_svg__ = __webpack_require__(2321);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.













var TREEMAP_TILE_MODES = {
  squarify: __WEBPACK_IMPORTED_MODULE_2_d3_hierarchy__["j" /* treemapSquarify */],
  resquarify: __WEBPACK_IMPORTED_MODULE_2_d3_hierarchy__["g" /* treemapResquarify */],
  slice: __WEBPACK_IMPORTED_MODULE_2_d3_hierarchy__["h" /* treemapSlice */],
  dice: __WEBPACK_IMPORTED_MODULE_2_d3_hierarchy__["f" /* treemapDice */],
  slicedice: __WEBPACK_IMPORTED_MODULE_2_d3_hierarchy__["i" /* treemapSliceDice */],
  binary: __WEBPACK_IMPORTED_MODULE_2_d3_hierarchy__["e" /* treemapBinary */]
};

var TREEMAP_LAYOUT_MODES = ['circlePack', 'partition', 'partition-pivot'];

var NOOP = function NOOP(d) {
  return d;
};

var ATTRIBUTES = ['opacity', 'color'];

var DEFAULT_MARGINS = {
  left: 40,
  right: 10,
  top: 10,
  bottom: 40
};

/**
 * Get the map of scale functions from the given props.
 * @param {Object} props Props for the component.
 * @returns {Object} Map of scale functions.
 * @private
 */
function _getScaleFns(props) {
  var data = props.data;

  var allData = data.children || [];

  // Adding _allData property to the object to reuse the existing
  // getAttributeFunctor function.
  var compatibleProps = _extends({}, props, Object(__WEBPACK_IMPORTED_MODULE_5__utils_scales_utils__["g" /* getMissingScaleProps */])(props, allData, ATTRIBUTES), {
    _allData: allData
  });
  return {
    opacity: Object(__WEBPACK_IMPORTED_MODULE_5__utils_scales_utils__["c" /* getAttributeFunctor */])(compatibleProps, 'opacity'),
    color: Object(__WEBPACK_IMPORTED_MODULE_5__utils_scales_utils__["c" /* getAttributeFunctor */])(compatibleProps, 'color')
  };
}

var Treemap = function (_React$Component) {
  _inherits(Treemap, _React$Component);

  function Treemap(props) {
    _classCallCheck(this, Treemap);

    var _this = _possibleConstructorReturn(this, (Treemap.__proto__ || Object.getPrototypeOf(Treemap)).call(this, props));

    _this.state = _extends({
      scales: _getScaleFns(props)
    }, Object(__WEBPACK_IMPORTED_MODULE_6__utils_chart_utils__["c" /* getInnerDimensions */])(props, props.margin));
    return _this;
  }

  _createClass(Treemap, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.setState(_extends({
        scales: _getScaleFns(props)
      }, Object(__WEBPACK_IMPORTED_MODULE_6__utils_chart_utils__["c" /* getInnerDimensions */])(props, props.margin)));
    }

    /**
     * Create the list of nodes to render.
     * @returns {Array} Array of nodes.
     * @private
     */

  }, {
    key: '_getNodesToRender',
    value: function _getNodesToRender() {
      var _state = this.state,
          innerWidth = _state.innerWidth,
          innerHeight = _state.innerHeight;
      var _props = this.props,
          data = _props.data,
          mode = _props.mode,
          padding = _props.padding,
          sortFunction = _props.sortFunction,
          getSize = _props.getSize;

      if (!data) {
        return [];
      }

      if (mode === 'partition' || mode === 'partition-pivot') {
        var partitionFunction = Object(__WEBPACK_IMPORTED_MODULE_2_d3_hierarchy__["c" /* partition */])().size(mode === 'partition-pivot' ? [innerHeight, innerWidth] : [innerWidth, innerHeight]).padding(padding);
        var _structuredInput = Object(__WEBPACK_IMPORTED_MODULE_2_d3_hierarchy__["a" /* hierarchy */])(data).sum(getSize).sort(function (a, b) {
          return sortFunction(a, b, getSize);
        });
        var mappedNodes = partitionFunction(_structuredInput).descendants();
        if (mode === 'partition-pivot') {
          return mappedNodes.map(function (node) {
            return _extends({}, node, {
              x0: node.y0,
              x1: node.y1,
              y0: node.x0,
              y1: node.x1
            });
          });
        }
        return mappedNodes;
      }
      if (mode === 'circlePack') {
        var packingFunction = Object(__WEBPACK_IMPORTED_MODULE_2_d3_hierarchy__["b" /* pack */])().size([innerWidth, innerHeight]).padding(padding);
        var _structuredInput2 = Object(__WEBPACK_IMPORTED_MODULE_2_d3_hierarchy__["a" /* hierarchy */])(data).sum(getSize).sort(function (a, b) {
          return sortFunction(a, b, getSize);
        });
        return packingFunction(_structuredInput2).descendants();
      }

      var tileFn = TREEMAP_TILE_MODES[mode];
      var treemapingFunction = Object(__WEBPACK_IMPORTED_MODULE_2_d3_hierarchy__["d" /* treemap */])(tileFn).tile(tileFn).size([innerWidth, innerHeight]).padding(padding);
      var structuredInput = Object(__WEBPACK_IMPORTED_MODULE_2_d3_hierarchy__["a" /* hierarchy */])(data).sum(getSize).sort(function (a, b) {
        return sortFunction(a, b, getSize);
      });
      return treemapingFunction(structuredInput).descendants();
    }
  }, {
    key: 'render',
    value: function render() {
      var renderMode = this.props.renderMode;
      var scales = this.state.scales;

      var nodes = this._getNodesToRender();
      var TreemapElement = renderMode === 'SVG' ? __WEBPACK_IMPORTED_MODULE_8__treemap_svg__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_7__treemap_dom__["a" /* default */];
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TreemapElement, _extends({}, this.props, { nodes: nodes, scales: scales }));
    }
  }]);

  return Treemap;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Treemap.displayName = 'Treemap';
Treemap.propTypes = {
  animation: __WEBPACK_IMPORTED_MODULE_4__animation__["a" /* AnimationPropType */],
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  hideRootNode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  margin: __WEBPACK_IMPORTED_MODULE_6__utils_chart_utils__["b" /* MarginPropType */],
  mode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(Object.keys(TREEMAP_TILE_MODES).concat(TREEMAP_LAYOUT_MODES)),
  onLeafClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onLeafMouseOver: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onLeafMouseOut: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  useCirclePacking: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  padding: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  sortFunction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  getSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  getColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

Treemap.defaultProps = {
  className: '',
  colorRange: __WEBPACK_IMPORTED_MODULE_3__theme__["a" /* CONTINUOUS_COLOR_RANGE */],
  _colorValue: __WEBPACK_IMPORTED_MODULE_3__theme__["b" /* DEFAULT_COLOR */],
  data: {
    children: []
  },
  hideRootNode: false,
  margin: DEFAULT_MARGINS,
  mode: 'squarify',
  onLeafClick: NOOP,
  onLeafMouseOver: NOOP,
  onLeafMouseOut: NOOP,
  opacityType: __WEBPACK_IMPORTED_MODULE_3__theme__["g" /* OPACITY_TYPE */],
  _opacityValue: __WEBPACK_IMPORTED_MODULE_3__theme__["c" /* DEFAULT_OPACITY */],
  padding: 1,
  sortFunction: function sortFunction(a, b, accessor) {
    if (!accessor) {
      return 0;
    }
    return accessor(a) - accessor(b);
  },
  getSize: function getSize(d) {
    return d.size;
  },
  getColor: function getColor(d) {
    return d.color;
  },
  getLabel: function getLabel(d) {
    return d.title;
  }
};
/* unused harmony default export */ var _unused_webpack_default_export = (Treemap);

/***/ }),
/* 2319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__treemap_leaf__ = __webpack_require__(2320);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.




function TreemapDOM(props) {
  var animation = props.animation,
      className = props.className,
      height = props.height,
      hideRootNode = props.hideRootNode,
      getLabel = props.getLabel,
      mode = props.mode,
      nodes = props.nodes,
      width = props.width,
      scales = props.scales,
      style = props.style;

  var useCirclePacking = mode === 'circlePack';
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      className: 'rv-treemap ' + (useCirclePacking ? 'rv-treemap-circle-packed' : '') + ' ' + className,
      style: { height: height, width: width }
    },
    nodes.map(function (node, index) {
      // throw out the rootest node
      if (hideRootNode && !index) {
        return null;
      }

      var nodeProps = _extends({
        animation: animation,
        node: node,
        getLabel: getLabel
      }, props, {
        x0: useCirclePacking ? node.x : node.x0,
        x1: useCirclePacking ? node.x : node.x1,
        y0: useCirclePacking ? node.y : node.y0,
        y1: useCirclePacking ? node.y : node.y1,
        r: useCirclePacking ? node.r : 1,
        scales: scales,
        style: style
      });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__treemap_leaf__["a" /* default */], _extends({}, nodeProps, { key: 'leaf-' + index }));
    })
  );
}

TreemapDOM.displayName = 'TreemapDOM';
/* harmony default export */ __webpack_exports__["a"] = (TreemapDOM);

/***/ }),
/* 2320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__animation__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__ = __webpack_require__(69);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.








var ANIMATED_PROPS = ['colorRange', 'colorDomain', 'color', 'opacityRange', 'opacityDomain', 'opacity', 'x0', 'x1', 'y0', 'y1', 'r'];

function TreemapLeaf(props) {
  var animation = props.animation,
      getLabel = props.getLabel,
      mode = props.mode,
      node = props.node,
      onLeafClick = props.onLeafClick,
      onLeafMouseOver = props.onLeafMouseOver,
      onLeafMouseOut = props.onLeafMouseOut,
      r = props.r,
      scales = props.scales,
      x0 = props.x0,
      x1 = props.x1,
      y0 = props.y0,
      y1 = props.y1,
      style = props.style;


  if (animation) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__animation__["b" /* default */],
      _extends({}, props, { animatedProps: ANIMATED_PROPS }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TreemapLeaf, _extends({}, props, { animation: null }))
    );
  }
  var useCirclePacking = mode === 'circlePack';
  var background = scales.color(node);
  var opacity = scales.opacity(node);
  var color = Object(__WEBPACK_IMPORTED_MODULE_3__utils_scales_utils__["f" /* getFontColorFromBackground */])(background);
  var data = node.data;

  var title = getLabel(data);
  var leafStyle = _extends({
    top: useCirclePacking ? y0 - r : y0,
    left: useCirclePacking ? x0 - r : x0,
    width: useCirclePacking ? r * 2 : x1 - x0,
    height: useCirclePacking ? r * 2 : y1 - y0,
    background: background,
    opacity: opacity,
    color: color
  }, style, node.data.style);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    {
      className: 'rv-treemap__leaf ' + (useCirclePacking ? 'rv-treemap__leaf--circle' : ''),
      onMouseEnter: function onMouseEnter(event) {
        return onLeafMouseOver(node, event);
      },
      onMouseLeave: function onMouseLeave(event) {
        return onLeafMouseOut(node, event);
      },
      onClick: function onClick(event) {
        return onLeafClick(node, event);
      },
      style: leafStyle
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: 'rv-treemap__leaf__content' },
      title
    )
  );
}

TreemapLeaf.propTypes = {
  animation: __WEBPACK_IMPORTED_MODULE_2__animation__["a" /* AnimationPropType */],
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  mode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  onLeafClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onLeafMouseOver: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onLeafMouseOut: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  scales: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  r: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  x0: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  x1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  y0: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  y1: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (TreemapLeaf);

/***/ }),
/* 2321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plot_xy_plot__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plot_series_polygon_series__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plot_series_mark_series__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plot_series_label_series__ = __webpack_require__(134);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.








var MARGIN_ADJUST = 1.2;

var TreemapSVG = function (_React$Component) {
  _inherits(TreemapSVG, _React$Component);

  function TreemapSVG() {
    _classCallCheck(this, TreemapSVG);

    return _possibleConstructorReturn(this, (TreemapSVG.__proto__ || Object.getPrototypeOf(TreemapSVG)).apply(this, arguments));
  }

  _createClass(TreemapSVG, [{
    key: 'getCircularNodes',
    value: function getCircularNodes() {
      var _props = this.props,
          animation = _props.animation,
          hideRootNode = _props.hideRootNode,
          nodes = _props.nodes,
          onLeafMouseOver = _props.onLeafMouseOver,
          onLeafMouseOut = _props.onLeafMouseOut,
          onLeafClick = _props.onLeafClick,
          scales = _props.scales,
          style = _props.style;

      var _nodes$reduce = nodes.reduce(function (acc, node, index) {
        if (!index && hideRootNode) {
          return acc;
        }
        var x = node.x,
            y = node.y,
            r = node.r;

        return {
          maxY: Math.max(y + r, acc.maxY),
          minY: Math.min(y - r, acc.minY),
          maxX: Math.max(x + MARGIN_ADJUST * r, acc.maxX),
          minX: Math.min(x - MARGIN_ADJUST * r, acc.minX),
          rows: acc.rows.concat([{
            x: x,
            y: y,
            size: r,
            color: scales.color(node)
          }])
        };
      }, {
        rows: [],
        maxY: -Infinity,
        minY: Infinity,
        maxX: -Infinity,
        minX: Infinity
      }),
          rows = _nodes$reduce.rows,
          minY = _nodes$reduce.minY,
          maxY = _nodes$reduce.maxY,
          minX = _nodes$reduce.minX,
          maxX = _nodes$reduce.maxX;

      return {
        updatedNodes: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__plot_series_mark_series__["a" /* default */], {
          animation: animation,
          className: 'rv-treemap__leaf rv-treemap__leaf--circle',
          onSeriesMouseEnter: onLeafMouseOver,
          onSeriesMouseLeave: onLeafMouseOut,
          onSeriesClick: onLeafClick,
          data: rows,
          colorType: 'literal',
          getColor: function getColor(d) {
            return d.color;
          },
          sizeType: 'literal',
          getSize: function getSize(d) {
            return d.size;
          },
          style: style
        }),
        minY: minY,
        maxY: maxY,
        minX: minX,
        maxX: maxX
      };
    }
  }, {
    key: 'getNonCircularNodes',
    value: function getNonCircularNodes() {
      var _props2 = this.props,
          animation = _props2.animation,
          hideRootNode = _props2.hideRootNode,
          nodes = _props2.nodes,
          onLeafMouseOver = _props2.onLeafMouseOver,
          onLeafMouseOut = _props2.onLeafMouseOut,
          onLeafClick = _props2.onLeafClick,
          scales = _props2.scales,
          style = _props2.style;
      var color = scales.color;

      return nodes.reduce(function (acc, node, index) {
        if (!index && hideRootNode) {
          return acc;
        }
        var x0 = node.x0,
            x1 = node.x1,
            y1 = node.y1,
            y0 = node.y0;

        var x = x0;
        var y = y0;
        var nodeHeight = y1 - y0;
        var nodeWidth = x1 - x0;

        acc.maxY = Math.max(y + nodeHeight, acc.maxY);
        acc.minY = Math.min(y, acc.minY);
        acc.maxX = Math.max(x + nodeWidth, acc.maxX);
        acc.minX = Math.min(x, acc.minX);

        var data = [{ x: x, y: y }, { x: x, y: y + nodeHeight }, { x: x + nodeWidth, y: y + nodeHeight }, { x: x + nodeWidth, y: y }];

        acc.updatedNodes = acc.updatedNodes.concat([__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__plot_series_polygon_series__["a" /* default */], {
          animation: animation,
          className: 'rv-treemap__leaf',
          key: index,
          color: color(node),
          type: 'literal',
          onSeriesMouseEnter: onLeafMouseOver,
          onSeriesMouseLeave: onLeafMouseOut,
          onSeriesClick: onLeafClick,
          data: data,
          style: _extends({}, style, node.style)
        })]);
        return acc;
      }, {
        updatedNodes: [],
        maxY: -Infinity,
        minY: Infinity,
        maxX: -Infinity,
        minX: Infinity
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          className = _props3.className,
          height = _props3.height,
          mode = _props3.mode,
          nodes = _props3.nodes,
          width = _props3.width;

      var useCirclePacking = mode === 'circlePack';

      var _ref = useCirclePacking ? this.getCircularNodes() : this.getNonCircularNodes(),
          minY = _ref.minY,
          maxY = _ref.maxY,
          minX = _ref.minX,
          maxX = _ref.maxX,
          updatedNodes = _ref.updatedNodes;

      var labels = nodes.reduce(function (acc, node) {
        if (!node.data.title) {
          return acc;
        }
        return acc.concat(_extends({}, node.data, {
          x: node.x0 || node.x,
          y: node.y0 || node.y,
          label: '' + node.data.title
        }));
      }, []);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1__plot_xy_plot__["a" /* default */],
        _extends({
          className: 'rv-treemap ' + (useCirclePacking ? 'rv-treemap-circle-packed' : '') + ' ' + className,
          width: width,
          height: height,
          yDomain: [maxY, minY],
          xDomain: [minX, maxX],
          colorType: 'literal',
          hasTreeStructure: true
        }, this.props),
        updatedNodes,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__plot_series_label_series__["a" /* default */], { data: labels })
      );
    }
  }]);

  return TreemapSVG;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

TreemapSVG.displayName = 'TreemapSVG';

/* harmony default export */ __webpack_exports__["a"] = (TreemapSVG);

/***/ }),
/* 2322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export makeHeightFlexible */
/* unused harmony export makeVisFlexible */
/* unused harmony export makeWidthFlexible */
/* unused harmony export FlexibleWidthXYPlot */
/* unused harmony export FlexibleHeightXYPlot */
/* unused harmony export FlexibleXYPlot */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_global_window__ = __webpack_require__(2323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_global_window___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_global_window__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plot_xy_plot__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_react_utils__ = __webpack_require__(196);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.







var CONTAINER_REF = 'container';

// As a performance enhancement, we want to only listen once
var resizeSubscribers = [];
var DEBOUNCE_DURATION = 100;
var timeoutId = null;

/**
 * Calls each subscriber, debounced to the
 */
function debounceEmitResize() {
  __WEBPACK_IMPORTED_MODULE_1_global_window___default.a.clearTimeout(timeoutId);
  timeoutId = __WEBPACK_IMPORTED_MODULE_1_global_window___default.a.setTimeout(emitResize, DEBOUNCE_DURATION);
}

/**
 * Calls each subscriber once syncronously.
 */
function emitResize() {
  resizeSubscribers.forEach(function (cb) {
    return cb();
  });
}

/**
 * Add the given callback to the list of subscribers to be caled when the
 * window resizes. Returns a function that, when called, removes the given
 * callback from the list of subscribers. This function is also resposible for
 * adding and removing the resize listener on `window`.
 *
 * @param {Function} cb - Subscriber callback function
 * @returns {Function} Unsubscribe function
 */
function subscribeToDebouncedResize(cb) {
  resizeSubscribers.push(cb);

  // if we go from zero to one Flexible components instances, add the listener
  if (resizeSubscribers.length === 1) {
    __WEBPACK_IMPORTED_MODULE_1_global_window___default.a.addEventListener('resize', debounceEmitResize);
  }
  return function unsubscribe() {
    removeSubscriber(cb);

    // if we have no Flexible components, remove the listener
    if (resizeSubscribers.length === 0) {
      __WEBPACK_IMPORTED_MODULE_1_global_window___default.a.clearTimeout(timeoutId);
      __WEBPACK_IMPORTED_MODULE_1_global_window___default.a.removeEventListener('resize', debounceEmitResize);
    }
  };
}

/**
 * Helper for removing the given callback from the list of subscribers.
 *
 * @param {Function} cb - Subscriber callback function
 */
function removeSubscriber(cb) {
  var index = resizeSubscribers.indexOf(cb);
  if (index > -1) {
    resizeSubscribers.splice(index, 1);
  }
}

/**
 * Helper for getting a display name for the child component
 * @param {*} Component React class for the child component.
 * @returns {String} The child components name
 */
function getDisplayName(Component) {
  return Component.displayName || Component.name || 'Component';
}

/**
 * Add the ability to stretch the visualization on window resize.
 * @param {*} Component React class for the child component.
 * @returns {*} Flexible component.
 */

function makeFlexible(Component, isWidthFlexible, isHeightFlexible) {
  var ResultClass = function (_React$Component) {
    _inherits(ResultClass, _React$Component);

    _createClass(ResultClass, null, [{
      key: 'propTypes',
      get: function get() {
        var _Component$propTypes = Component.propTypes,
            height = _Component$propTypes.height,
            width = _Component$propTypes.width,
            otherPropTypes = _objectWithoutProperties(_Component$propTypes, ['height', 'width']); // eslint-disable-line no-unused-vars


        return otherPropTypes;
      }
    }]);

    function ResultClass(props) {
      _classCallCheck(this, ResultClass);

      var _this = _possibleConstructorReturn(this, (ResultClass.__proto__ || Object.getPrototypeOf(ResultClass)).call(this, props));

      _this._onResize = function () {
        var containerElement = Object(__WEBPACK_IMPORTED_MODULE_3__utils_react_utils__["a" /* getDOMNode */])(_this[CONTAINER_REF]);
        var offsetHeight = containerElement.offsetHeight,
            offsetWidth = containerElement.offsetWidth;


        var newHeight = _this.state.height === offsetHeight ? {} : { height: offsetHeight };

        var newWidth = _this.state.width === offsetWidth ? {} : { width: offsetWidth };

        _this.setState(_extends({}, newHeight, newWidth));
      };

      _this.state = {
        height: 0,
        width: 0
      };
      return _this;
    }

    /**
     * Get the width of the container and assign the width.
     * @private
     */


    _createClass(ResultClass, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this._onResize();
        this.cancelSubscription = subscribeToDebouncedResize(this._onResize);
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps() {
        this._onResize();
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.cancelSubscription();
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _state = this.state,
            height = _state.height,
            width = _state.width;

        var props = _extends({}, this.props, {
          animation: height === 0 && width === 0 ? null : this.props.animation
        });

        var updatedDimensions = _extends({}, isHeightFlexible ? { height: height } : {}, isWidthFlexible ? { width: width } : {});

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            ref: function ref(_ref) {
              return _this2[CONTAINER_REF] = _ref;
            },
            style: { width: '100%', height: '100%' }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, updatedDimensions, props))
        );
      }
    }]);

    return ResultClass;
  }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

  ResultClass.displayName = 'Flexible' + getDisplayName(Component);

  return ResultClass;
}

function makeHeightFlexible(component) {
  return makeFlexible(component, false, true);
}

function makeVisFlexible(component) {
  return makeFlexible(component, true, true);
}

function makeWidthFlexible(component) {
  return makeFlexible(component, true, false);
}

var FlexibleWidthXYPlot = makeWidthFlexible(__WEBPACK_IMPORTED_MODULE_2__plot_xy_plot__["a" /* default */]);
var FlexibleHeightXYPlot = makeHeightFlexible(__WEBPACK_IMPORTED_MODULE_2__plot_xy_plot__["a" /* default */]);
var FlexibleXYPlot = makeVisFlexible(__WEBPACK_IMPORTED_MODULE_2__plot_xy_plot__["a" /* default */]);

/***/ }),
/* 2323 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var win;

if (typeof window !== "undefined") {
    win = window;
} else if (typeof global !== "undefined") {
    win = global;
} else if (typeof self !== "undefined"){
    win = self;
} else {
    win = {};
}

module.exports = win;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(72)))

/***/ }),
/* 2324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RADIAL_CHART_STYLE; });
/* unused harmony export HEATMAP_CHART_STYLE */
var RADIAL_CHART_STYLE={'chart-hint':{background:'rgba(137, 170, 181, 0.9)',color:'black',borderRadius:'3px',padding:'5px',boxShadow:'0px 5px 10px 1px rgba(10, 10, 10, 0.4)',textAlign:'center',stroke:'white !important',strokeWidth:'2px'},'highlight-arc':{stroke:'black !important',strokeWidth:'2px'},'arc':{stroke:'#fafafa !important',strokeWidth:'2px'}};var HEATMAP_CHART_STYLE={'chart-hint':{background:'rgba(137, 170, 181, 0.9)',color:'black',borderRadius:'3px',padding:'5px',boxShadow:'0px 5px 10px 1px rgba(10, 10, 10, 0.4)',textAlign:'center',stroke:'white !important',strokeWidth:'2px'}};

/***/ }),
/* 2325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Card__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_CardContent__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_CardContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_CardContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_Menu__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_Menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_CardActions__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_CardActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_CardActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Reusable_Charts_PieChart__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Reusable_ItemCard__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__AddModel_EditModel_jsx__ = __webpack_require__(2326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__AddModel__ = __webpack_require__(550);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getDeviceCountByDeviceModel($superAdminLoginId: Int!) {\n    devices: getDeviceCountByDeviceModel(\n      superAdminLoginId: $superAdminLoginId\n    ) {\n      id\n      model_name\n      version\n      devicetype\n      deviceCount\n    }\n  }\n'],['\n  query getDeviceCountByDeviceModel($superAdminLoginId: Int!) {\n    devices: getDeviceCountByDeviceModel(\n      superAdminLoginId: $superAdminLoginId\n    ) {\n      id\n      model_name\n      version\n      devicetype\n      deviceCount\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query deviceModel($id: Int) {\n    deviceModel(id: $id) {\n      model_name\n      devicetype\n      description\n      version\n      maxPrice\n      status\n    }\n  }\n'],['\n  query deviceModel($id: Int) {\n    deviceModel(id: $id) {\n      model_name\n      devicetype\n      description\n      version\n      maxPrice\n      status\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_MODELS_STOCK=Object(__WEBPACK_IMPORTED_MODULE_7_graphql_tag__["a" /* default */])(_templateObject);var GET_MODEL_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_7_graphql_tag__["a" /* default */])(_templateObject2);var styles=function styles(theme){return{root:{flexGrow:1,padding:theme.spacing.unit*2},paper:{height:140,width:100},control:{padding:theme.spacing.unit*2}};};var DeviceDashboard=function(_Component){_inherits(DeviceDashboard,_Component);function DeviceDashboard(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,DeviceDashboard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DeviceDashboard.__proto__||Object.getPrototypeOf(DeviceDashboard)).call.apply(_ref,[this].concat(args))),_this),_this.state={modelStatus:false,mId:'',addModelStatus:false},_this.viewdevices=function(modelId){return function(e){e.preventDefault();console.log('hi');_this.props.history.push({pathname:'/home/inventory/deviceview/'+modelId});};},_this.addModel=function(e){_this.setState({addModelStatus:true},function(){console.log('model details2222',_this.state.addModelStatus);});},_this.mapToArr=function(vechicleType){var pieChartArr=[];var fullData=[];var sum=0;vechicleType.forEach(function(e){sum=sum+e.deviceCount;// console.log('ff', sum, e.deviceCount)
});// console.log(sum, 'sum')
vechicleType.forEach(function(element){pieChartArr=[];pieChartArr['value']=element.deviceCount/sum*100;// To be removed random function
pieChartArr['label']=element.model_name;pieChartArr['id']=element.id;fullData.push(pieChartArr);});return fullData;},_this.getModelDetails=function(modelId){return _asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _ref3,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:console.log('modelId',modelId);_context.next=3;return _this.props.client.query({query:GET_MODEL_DETAILS,variables:{id:parseInt(modelId,10)}});case 3:_ref3=_context.sent;data=_ref3.data;_this.setState({modelDetails:data,modelStatus:true,mId:modelId},function(){console.log(_this.state.modelDetails,_this.state.modelStatus);console.log('model details2222',_this.state.modelDetails);});case 6:case'end':return _context.stop();}}},_callee,_this2);}));},_this.closeEditModel=function(){_this.setState({modelStatus:false});},_this.closeAddModel=function(){_this.setState({addModelStatus:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DeviceDashboard,[{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},this.state.modelStatus===true&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__AddModel_EditModel_jsx__["a" /* default */],{modelInfo:this.state.modelDetails.deviceModel,openStatus:this.state.modelStatus,closeEditModelFunction:this.closeEditModel,selectedId:this.state.mId}),this.state.addModelStatus===true&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__AddModel__["a" /* default */],{openStatus:this.state.addModelStatus,closeAddModelFunction:this.closeAddModel}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row-reverse',justify:'space-between',alignItems:'flex-end'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{color:'secondary',variant:'contained',className:classes.button,onClick:this.addModel},'Add Model'),'  ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{variant:'outlined',className:classes.button},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_Menu___default.a,{className:classes.iconSmall}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'headline'},'Device Dashboard')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_apollo__["Query"],{query:GET_MODELS_STOCK,variables:{superAdminLoginId:Object(__WEBPACK_IMPORTED_MODULE_14__utils_getLoginId__["a" /* default */])()}},function(_ref4){var loading=_ref4.loading,error=_ref4.error,devices=_ref4.data.devices;if(loading)return'Loading...';if(error)return'Error!: '+error;console.log('devices',devices);var rowData=devices&&_this3.mapToArr(devices);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row',justify:'flex-start',alignItems:'flex-start',className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:8},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row',justify:'flex-start',alignItems:'flex-start'},devices.map(function(devices){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Card___default.a,{className:classes.card},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{gutterBottom:true,variant:'subheading',component:'h2'},devices.model_name+' '+devices.version),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'body2',gutterBottom:true},devices.devicetype.toUpperCase()),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{component:'p',variant:'title'},devices.deviceCount)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_CardActions___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{color:'primary',variant:'outlined',onClick:_this3.viewdevices(devices.id)},'View'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{color:'primary',variant:'outlined',onClick:_this3.getModelDetails(devices.id)},'Edit'))));}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Reusable_ItemCard__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'body2'},'Inventory Details'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Reusable_Charts_PieChart__["a" /* default */],{data:rowData})))));})));}}]);return DeviceDashboard;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_8_react_apollo__["withApollo"])(DeviceDashboard)));

/***/ }),
/* 2326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Modal__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogActions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogContent__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_DialogContentText__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_DialogContentText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_DialogContentText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_FormHelperText__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_FormHelperText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_FormHelperText__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  mutation updateDeviceModels(\n    $id: Int!\n    $model_name: String!\n    $version: Float!\n    $devicetype: String!\n    $description: String\n    $maxPrice: Int!\n    $status: Int!\n  ) {\n    updateDeviceModels(\n      id: $id\n      model_name: $model_name\n      version: $version\n      devicetype: $devicetype\n      description: $description\n      maxPrice: $maxPrice\n      status: $status\n    )\n  }\n'],['\n  mutation updateDeviceModels(\n    $id: Int!\n    $model_name: String!\n    $version: Float!\n    $devicetype: String!\n    $description: String\n    $maxPrice: Int!\n    $status: Int!\n  ) {\n    updateDeviceModels(\n      id: $id\n      model_name: $model_name\n      version: $version\n      devicetype: $devicetype\n      description: $description\n      maxPrice: $maxPrice\n      status: $status\n    )\n  }\n']);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var UPDATE_MODEL=Object(__WEBPACK_IMPORTED_MODULE_13_graphql_tag__["a" /* default */])(_templateObject);function getModalStyle(){var top=50;var left=50;return{top:top+'%',left:left+'%',transform:'translate(-'+top+'%, -'+left+'%)'};}var styles=function styles(theme){return{paper:{position:'absolute',width:theme.spacing.unit*50,backgroundColor:theme.palette.background.paper,boxShadow:theme.shadows[5],padding:theme.spacing.unit*4}};};var EditModel=function(_React$Component){_inherits(EditModel,_React$Component);function EditModel(props){_classCallCheck(this,EditModel);var _this=_possibleConstructorReturn(this,(EditModel.__proto__||Object.getPrototypeOf(EditModel)).call(this,props));_this.handleSubmit=function(EditModel){return function(e){// console.log('this.modelId=', this.state.modelId, this.state.modelname, this.state.version, this.state.devicetype, this.state.description, this.state.maxPrice)
e.preventDefault();EditModel({variables:{id:_this.state.modelId,model_name:_this.state.modelname,version:_this.state.version,devicetype:_this.state.devicetype,description:_this.state.description,maxPrice:parseInt(_this.state.maxPrice,10),status:parseInt(_this.state.status,10)}});_this.setState({modelname:'',version:'',devicetype:'',description:'',manufacturerId:'',maxPrice:'',status:'',modelId:''});_this.props.closeEditModelFunction();_this.props.openSnackbar('Model Updated Successfully');};};_this.checkModelNameValidity=function(){var regex=new RegExp(// eslint-disable-next-line
/^(?!\s)(?!.*\s$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9 '~?!]{2,}$/);_this.setState({isModelNameValid:regex.test(_this.state.modelname)||_this.state.modelname!==''});};_this.checkmaxPriceValidity=function(){var regex=new RegExp(/^[0-9]{4,5}$/);_this.setState({ismaxPriceValid:regex.test(_this.state.maxPrice)&&_this.state.maxPrice!==''&&// parseInt(this.state.maxPrice, 10) > 1000 ||
parseInt(_this.state.maxPrice,10)!==0});// console.log('pp', this.state.ismaxPriceValid)
};_this.checkVersionValidity=function(){var regex=new RegExp(// eslint-disable-next-line
// 1-3 dot-separated components, each numeric except that the last one may be *
/^(\d+\.)?(\d+\.)?(\*|\d+)$/);_this.setState({isVersionValid:regex.test(_this.state.version)||_this.state.version===''});};_this.checkDeviceTypeValidity=function(){_this.setState({isDeviceTypeValid:_this.state.devicetype!==''});};_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));};};_this.handleOpenSelect=function(){_this.setState({open1:true});};_this.handleCloseSelect=function(){_this.setState({open1:false});};_this.handleChange=function(event){_this.setState(_defineProperty({},event.target.name,event.target.value));};_this.modelInformation=_this.props.modelInfo;console.log('this.props.selectedId= ',_this.props.selectedId);_this.state={devicetype:_this.modelInformation.devicetype,modelname:_this.modelInformation.model_name,version:_this.modelInformation.version,description:_this.modelInformation.description,modelId:_this.props.selectedId,maxPrice:_this.modelInformation.maxPrice,status:_this.modelInformation.status,open1:false,isModelNameValid:true,isDeviceTypeValid:true,isVersionValid:true,ismaxPriceValid:true};return _this;}_createClass(EditModel,[{key:'render',value:function render(){var _this2=this;var classes=this.props.classes;console.log('------------');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default.a,null,'Edit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Modal___default.a,{'aria-labelledby':'simple-modal-title','aria-describedby':'simple-modal-description',open:this.props.openStatus// onClose={this.handleClose}
},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:getModalStyle(),className:classes.paper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_apollo__["Mutation"],{mutation:UPDATE_MODEL,errorPolicy:'all'},function(EditModel,_ref){var data=_ref.data,loading=_ref.loading,error=_ref.error;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:_this2.handleSubmit(EditModel)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_DialogContentText___default.a,null,'* Marked fields are mandatory'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'modelname',name:'modelname',label:'Model Name',type:'text',required:true,value:_this2.state.modelname,fullWidth:true,onChange:_this2.handleInputChange('modelname'),onBlur:_this2.checkModelNameValidity}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!_this2.state.isModelNameValid?'Invalid ModelName':'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'version',label:'Version',type:'text',required:true// fullWidth
,value:_this2.state.version,onChange:_this2.handleInputChange('version'),onBlur:_this2.checkVersionValidity}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!_this2.state.isVersionValid?'Invalid Version':'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_FormControl___default.a// className={classes.formControl}
,{style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel___default.a,{htmlFor:'demo-controlled-open-select'},'Device Type *'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Select___default.a,{open:_this2.state.open1,onClose:_this2.handleCloseSelect,onOpen:_this2.handleOpenSelect,value:_this2.state.devicetype,onChange:_this2.handleChange,onBlur:_this2.checkDeviceTypeValidity,inputProps:{name:'devicetype',id:'devicetype'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'None')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_MenuItem___default.a,{value:'nonobd'},'Non OBD'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_MenuItem___default.a,{value:'obd'},'OBD')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!_this2.state.isDeviceTypeValid?'Invalid Selection':'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'description',name:'description',label:'Description',type:'text',value:_this2.state.description,onChange:_this2.handleInputChange('description')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'maxPrice',label:'Max Price',type:'text',required:true// fullWidth
,value:_this2.state.maxPrice,onChange:_this2.handleInputChange('maxPrice'),error:!_this2.state.maxPrice,onBlur:_this2.checkmaxPriceValidity}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!_this2.state.ismaxPriceValid?'Max price should be between 1000 and 10000':''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogActions___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default.a,{onClick:_this2.props.closeEditModelFunction,color:'default',variant:'contained'},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default.a// onClick={this.handleClose}
,{color:'primary',variant:'contained',type:'submit',disabled:!(_this2.state.isVersionValid&&_this2.state.isDeviceTypeValid&&_this2.state.modelname!==''&&_this2.state.version!==''&&_this2.state.maxPrice!==''&&_this2.state.ismaxPriceValid)},'Submit')));}))));}}]);return EditModel;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);EditModel.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired// We need an intermediary variable for handling the recursive nesting.
};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_15__HOCs_withSharedSnackbar__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_14_react_apollo__["withApollo"])(EditModel))));

/***/ }),
/* 2327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_getLoginId__ = __webpack_require__(12);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query {\n    accessory: getAllAccessoryTypes(status: 1) {\n      id\n      accessoryName\n      version\n    }\n  }\n'],['\n  query {\n    accessory: getAllAccessoryTypes(status: 1) {\n      id\n      accessoryName\n      version\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query {\n    manufacturers: getAllManufacturer(status: 1) {\n      id\n      manufacturerName\n      manufacturerCode\n    }\n  }\n'],['\n  query {\n    manufacturers: getAllManufacturer(status: 1) {\n      id\n      manufacturerName\n      manufacturerCode\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation excelFileUpload(\n    $fileInfo: FileUploadInput!\n    $commonInput: CommonInput!\n  ) {\n    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {\n      failedToUpload\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedUploadList\n    }\n  }\n'],['\n  mutation excelFileUpload(\n    $fileInfo: FileUploadInput!\n    $commonInput: CommonInput!\n  ) {\n    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {\n      failedToUpload\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedUploadList\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n'],['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_ACCESSORY=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject);var GET_MANUFACTURER=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject2);// calling server for updation
var ADD_ACCESSORY=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject3);var GET_UPLOAD_URL=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject4);var styles=function styles(theme){return{button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{margin:theme.spacing.unit,minWidth:120},root:{flexGrow:1,padding:theme.spacing.unit*2}};};var RegisterBulkAccessory=function(_Component){_inherits(RegisterBulkAccessory,_Component);function RegisterBulkAccessory(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,RegisterBulkAccessory);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RegisterBulkAccessory.__proto__||Object.getPrototypeOf(RegisterBulkAccessory)).call.apply(_ref,[this].concat(args))),_this),_this.state={open:false,open1:false,modelname:'',isModelNameValid:false,isManufacturerNameValid:false,manufacturerName:'',open_man:false,manufacturerCode:'',manufacturerId:'',publicUploadURL:'',fileName:'',bucketName:'',isUploading:false,uploadSucess:true,response:'',failList:'',result:false,isLoading:false},_this.columns=['Serial Number'],_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15,print:false,download:false},_this.setToDefaults=function(){_this.setState({open:false,open1:false,modelname:'',isModelNameValid:false,isManufacturerNameValid:false,manufacturerName:'',open_man:false,manufacturerCode:'',manufacturerId:'',publicUploadURL:'',fileName:'',bucketName:'',isUploading:false,uploadSucess:true,response:'',failList:'',result:false,isLoading:false});},_this.handleInputChange=function(key){return function(e){return _this.setState(_defineProperty({},key,e.target.value));};},_this.handleChange=function(event){return _this.setState(_defineProperty({},event.target.name,event.target.value));},_this.handleOpen=function(){return _this.setState({open:true});},_this.handleOpenSelect=function(){return _this.setState({open1:true});},_this.handleCloseSelect=function(){return _this.setState({open1:false});},_this.handleOpenSelectMan=function(){return _this.setState({open_man:true});},_this.handleCloseSelectMan=function(){return _this.setState({open_man:false});},_this.checkModelNameValidity=function(){return _this.setState({isModelNameValid:_this.state.modelname!==''});},_this.checkManufacturerNameValidity=function(){var code=_this.state.manufacturerName.split('*');_this.setState({isManufacturerNameValid:_this.state.manufacturerName!=='',uniqueSerialNumber:code[1]+'_'+_this.state.serialno,manufacturerId:code[0]});},_this.handleSubmit=function(client){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var manarr,_ref3,data,errors,fullData,arrList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:event.preventDefault();_this.setState({isLoading:true});manarr=_this.state.manufacturerName.split('*');_context.next=5;return client.mutate({mutation:ADD_ACCESSORY,variables:{fileInfo:{uploadFor:'AccessoryUploadByPartner',bucketName:_this.state.bucketName,fileName:_this.state.fileName,operationType:'SKIP'},commonInput:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_16__utils_getLoginId__["a" /* default */])(),manufacturerId:parseInt(manarr[0],10),manufacturerCode:manarr[1],accessoryTypeId:parseInt(_this.state.modelname,10)}}});case 5:_ref3=_context.sent;data=_ref3.data;errors=_ref3.errors;_this.setState({isLoading:false});fullData=[];if(data!==null){arrList=data.excelFileUpload.failedUploadList;JSON.parse(arrList).forEach(function(element){var rowData=[];rowData.push(element.Serial_Number);fullData.push(rowData);});_this.setState({device_model_id:'',manufacturerId:'',response:'Total Excel Records= '+data.excelFileUpload.totalExcelDataRecords+','+'Total Records Uploaded='+data.excelFileUpload.successfullyUploaded+', Total Records Failed To Upload='+data.excelFileUpload.failedToUpload+', Total Duplicate Records in Excel='+data.excelFileUpload.totalDuplicateRecords,uploadSucess:true,failList:fullData,result:true});}else{_this.setState({response:errors[0].message,uploadSucess:true});}case 11:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}();},_this.onUpload=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4){var _ref4$target=_ref4.target,validity=_ref4$target.validity,_ref4$target$files=_slicedToArray(_ref4$target.files,1),file=_ref4$target$files[0];var fileExtension,response,url;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:// TODO: Handle upload errors
_this.setState({isUploading:true});if(!validity.valid){_context2.next=11;break;}fileExtension=file.name.substring(file.name.lastIndexOf('.')+1);_context2.next=5;return _this.props.client.mutate({mutation:GET_UPLOAD_URL,variables:{fileExtension:fileExtension}});case 5:response=_context2.sent;if(!(response.data&&response.data.getPublicUploadURL)){_context2.next=11;break;}url=response.data.getPublicUploadURL.publicUploadURL;_context2.next=10;return __WEBPACK_IMPORTED_MODULE_13_axios___default.a.put(url,file,{headers:{"x-ms-blob-type":"BlockBlob","Content-Type":file.type||"application/octet-stream"}});case 10:_this.setState({fileName:response.data.getPublicUploadURL.filename,bucketName:response.data.getPublicUploadURL.bucketName,publicUploadURL:response.data.getPublicUploadURL.publicUploadURL});case 11:_this.setState({isUploading:false});case 12:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref5.apply(this,arguments);};}(),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RegisterBulkAccessory,[{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["Query"],{query:GET_ACCESSORY,fetchPolicy:'network-only'},function(_ref6){var isModelsLoading=_ref6.loading,error=_ref6.error,accessory=_ref6.data.accessory;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["Query"],{query:GET_MANUFACTURER,fetchPolicy:'network-only'},function(_ref7){var isManufacturersLoading=_ref7.loading,error=_ref7.error,manufacturers=_ref7.data.manufacturers;if(isModelsLoading||isManufacturersLoading)return null;if(error)return'Error!: '+error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{container:true,direction:'row',justify:'flex-start',alignItems:'center',spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Typography"],{variant:'title'},' ','Add Acessory Details')),_this3.state.uploadSucess&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Typography"],{variant:'subheading',color:'primary'},_this3.state.response),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider___default.a,{light:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{style:{minWidth:'40%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'100%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel___default.a,{htmlFor:'demo-controlled-open-select'},'Select Manufacturer'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select___default.a,{open:_this3.state.open_man,fullWidth:true,onClose:_this3.handleCloseSelectMan,onOpen:_this3.handleOpenSelectMan,value:_this3.state.manufacturerName,onChange:_this3.handleChange,onBlur:_this3.checkManufacturerNameValidity,inputProps:{name:'manufacturerName',id:'manufacturerName'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),manufacturers.map(function(manufacturer){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem___default.a,{value:manufacturer.id+'*'+manufacturer.manufacturerCode,key:manufacturer.id},manufacturer.manufacturerName);}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'100%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel___default.a,{htmlFor:'demo-controlled-open-select'},'Select Accessory Type'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select___default.a,{open:_this3.state.open1,fullWidth:true,onClose:_this3.handleCloseSelect,onOpen:_this3.handleOpenSelect,value:_this3.state.modelname,onChange:_this3.handleChange,onBlur:_this3.checkModelNameValidity,inputProps:{name:'modelname',id:'modelname'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),accessory.map(function(allDeviceModelsByStatus){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem___default.a,{value:allDeviceModelsByStatus.id,key:allDeviceModelsByStatus.id},allDeviceModelsByStatus.accessoryName);}))),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{accept:'*/*',id:'contained-button-file',multiple:true,type:'file',style:{display:'none'},onChange:_this3.onUpload}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'contained-button-file'},'Upload excel file here \xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{variant:'contained',component:'span',color:'primary'},_this3.state.isUploading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress___default.a,{size:15}):'Upload')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:_this3.setToDefaults,color:'default',variant:'contained'},'SET TO DEFAULTS'),'       ','       ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:function onClick(){return _this3.props.history.goBack();},color:'default',variant:'contained'},'Cancel'),'       ','       ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:_this3.handleSubmit(_this3.props.client),type:'submit',color:'primary',variant:'contained',disabled:!(_this3.state.isModelNameValid&&_this3.state.fileName!==''&&_this3.state.isManufacturerNameValid)},'Submit')),' ',_this3.state.isLoading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'Excel sheet upload is in progress..'),_this3.state.result&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',null,'Failed records list'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_mui_datatables___default.a,{data:_this3.state.failList,columns:_this3.columns,options:_this3.options})))));});});}}]);return RegisterBulkAccessory;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["withStyles"])(styles)(__WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter___default()(Object(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["withApollo"])(RegisterBulkAccessory))));

/***/ }),
/* 2328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Modules_CustomTabs__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormHelperText__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormHelperText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormHelperText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_icons_ArrowBack__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_icons_ArrowBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_icons_ArrowBack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__multiSelector_css__ = __webpack_require__(2329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__multiSelector_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__multiSelector_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Modules_LicensesList__ = __webpack_require__(642);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  mutation setResellerDetails(\n    $username: String!\n    $password: String!\n    $accountType: String!\n    $businessName: String!\n    $email: String!\n    $contactPerson: String!\n    $contactNumber: String!\n    $address: String!\n    $city: String!\n    $state: Int!\n    $country: Int!\n    $pincode: Int!\n    $panNumber: String!\n    $licenseExpiryPeriod: Int!\n    $assignedDeviceModel: [AssignDeviceModelToReseller!]!\n    $assignedLicenseType: [AssignLicenseTypeToReseller!]!\n    $gst: String!\n    $freePeriod: Int!\n    $bufferPeriod: Int!\n    $discount: Int!\n    $billingFrequency: Int!\n    $status: Int!\n  ) {\n    setResellerDetails(\n      username: $username\n      password: $password\n      accountType: $accountType\n      resellerName: $businessName\n      email: $email\n      contactPerson: $contactPerson\n      contactNumber: $contactNumber\n      address: $address\n      city: $city\n      stateId: $state\n      countryId: $country\n      pincode: $pincode\n      panNumber: $panNumber\n      licenseExpiryPeriod: $licenseExpiryPeriod\n      assignedDeviceModel: $assignedDeviceModel\n      assignedLicenseType: $assignedLicenseType\n      gst: $gst\n      freePeriod: $freePeriod\n      bufferPeriod: $bufferPeriod\n      discountPercentage: $discount\n      defaultBillingFrequency: $billingFrequency\n      status: $status\n    )\n  }\n'],['\n  mutation setResellerDetails(\n    $username: String!\n    $password: String!\n    $accountType: String!\n    $businessName: String!\n    $email: String!\n    $contactPerson: String!\n    $contactNumber: String!\n    $address: String!\n    $city: String!\n    $state: Int!\n    $country: Int!\n    $pincode: Int!\n    $panNumber: String!\n    $licenseExpiryPeriod: Int!\n    $assignedDeviceModel: [AssignDeviceModelToReseller!]!\n    $assignedLicenseType: [AssignLicenseTypeToReseller!]!\n    $gst: String!\n    $freePeriod: Int!\n    $bufferPeriod: Int!\n    $discount: Int!\n    $billingFrequency: Int!\n    $status: Int!\n  ) {\n    setResellerDetails(\n      username: $username\n      password: $password\n      accountType: $accountType\n      resellerName: $businessName\n      email: $email\n      contactPerson: $contactPerson\n      contactNumber: $contactNumber\n      address: $address\n      city: $city\n      stateId: $state\n      countryId: $country\n      pincode: $pincode\n      panNumber: $panNumber\n      licenseExpiryPeriod: $licenseExpiryPeriod\n      assignedDeviceModel: $assignedDeviceModel\n      assignedLicenseType: $assignedLicenseType\n      gst: $gst\n      freePeriod: $freePeriod\n      bufferPeriod: $bufferPeriod\n      discountPercentage: $discount\n      defaultBillingFrequency: $billingFrequency\n      status: $status\n    )\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query checkUsername($username: String!) {\n    checkUsername(username: $username)\n  }\n'],['\n  query checkUsername($username: String!) {\n    checkUsername(username: $username)\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query checkResellerName($businessname: String!) {\n    checkResellerName(resellerName: $businessname)\n  }\n'],['\n  query checkResellerName($businessname: String!) {\n    checkResellerName(resellerName: $businessname)\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query checkResellerContactNumber($phoneno: String!) {\n    checkResellerContactNumber(contactNumber: $phoneno)\n  }\n'],['\n  query checkResellerContactNumber($phoneno: String!) {\n    checkResellerContactNumber(contactNumber: $phoneno)\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  query checkResellerEmail($email: String!) {\n    checkResellerEmail(email: $email)\n  }\n'],['\n  query checkResellerEmail($email: String!) {\n    checkResellerEmail(email: $email)\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  query checkResellerPanNumber($pan: String!) {\n    checkResellerPanNumber(panNumber: $pan)\n  }\n'],['\n  query checkResellerPanNumber($pan: String!) {\n    checkResellerPanNumber(panNumber: $pan)\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  query getAllBillingFrequency($billingModeId: Int!) {\n    billing: getAllBillingFrequency(billingModeId: $billingModeId) {\n      id\n      frequency\n      billingModeId\n      numberOfMonths\n    }\n  }\n'],['\n  query getAllBillingFrequency($billingModeId: Int!) {\n    billing: getAllBillingFrequency(billingModeId: $billingModeId) {\n      id\n      frequency\n      billingModeId\n      numberOfMonths\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var styles=function styles(theme){return{root:{flexGrow:1,padding:theme.spacing.unit*2},chips:{display:'flex',flexWrap:'wrap'},chip:{margin:theme.spacing.unit/4}};};var ADD_RESELLER=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject);// username validation
var GET_USERNAME=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject2);// Business name validation
var GET_RESELLER_NAME=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject3);// Business name validation
var GET_CONTACTNO=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject4);// Business email validation
var GET_EMAIL=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject5);// Business pan validation
var GET_PAN_NUMBER=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject6);var GET_BILLING_FREQUENCY=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject7);var RegisterReseller=function(_Component){_inherits(RegisterReseller,_Component);function RegisterReseller(props){var _this2=this;_classCallCheck(this,RegisterReseller);var _this=_possibleConstructorReturn(this,(RegisterReseller.__proto__||Object.getPrototypeOf(RegisterReseller)).call(this,props));_this.handleInputChange=function(e){_this.setState(_defineProperty({},e.target.name,e.target.value));};_this.handleCountryChange=function(country){if(!country){_this.setState({state:'',country:''});}else{_this.setState({state:'',country:country.value});}};_this.handleChangeLicense=function(event){_this.setState({licenseId:event.target.value});};_this.handleChangeModels=function(event){_this.setState({modelName:event.target.value});};_this.handlePlanChange=function(plan){if(!plan){_this.setState({plan:''});}else{_this.setState({plan:plan.value});}};_this.handleTimezoneChange=function(timezone){if(!timezone){_this.setState({timezone:''});}else{_this.setState({timezone:timezone.value});}};_this.handleStateChange=function(state){_this.setState({state:state});};_this.checkNameValidity=function(client){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var regex,_ref2,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:regex=new RegExp(/^(?!\s)(?!.*\s$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9 '~?!]{3,30}$/);_context.next=3;return client.query({query:GET_RESELLER_NAME,variables:{businessname:_this.state.name}});case 3:_ref2=_context.sent;data=_ref2.data;// console.log('name', data)
_this.setState({isNameValid:regex.test(_this.state.name)&&_this.state.name!==''&&data.checkResellerName==='AVAILABLE'});case 6:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();};_this.checkUsernameValidity=function(client){return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(event){var regex,_ref4,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:// checkUsernameValidity = () => {
regex=new RegExp(/^[a-zA-Z0-9.\-_$@*!]{3,30}$/);_context2.next=3;return client.query({query:GET_USERNAME,variables:{username:_this.state.username}});case 3:_ref4=_context2.sent;data=_ref4.data;_this.setState({isUsernameUnique:data.checkUsername==='AVAILABLE',isUsernameValid:regex.test(_this.state.username)&&_this.state.username!==''&&data.checkUsername==='AVAILABLE'});case 6:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref3.apply(this,arguments);};}();};_this.checkContactpValidity=function(){var regex=new RegExp(/^[a-zA-Z\s]+$/);_this.setState({isContactpValid:regex.test(_this.state.person)&&_this.state.person!==''});};_this.checkPasswordValidity=function(){// const regex = new RegExp(/^((?!.*[\s])(?=.*[A-Z])(?=.*\d).{5,10})/)
var regex=new RegExp(/^[a-zA-Z0-9.\-_$@*!]{3,20}$/);console.log('pass=',regex.test(_this.state.password));_this.setState({isPasswordValid:_this.state.password!==''&&regex.test(_this.state.password)});};_this.checkPhonenoValidity=function(client){return function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(event){var regex,_ref6,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:regex=new RegExp(/^(\+91[-\s]?)?[0]?(91)?[1-9]\d{9,12}$/);_context3.next=3;return client.query({query:GET_CONTACTNO,variables:{phoneno:_this.state.phoneno}});case 3:_ref6=_context3.sent;data=_ref6.data;console.log('phoneno',data);_this.setState({isPhonenoValid:regex.test(_this.state.phoneno)&&_this.state.phoneno!==''&&data.checkResellerContactNumber==='AVAILABLE'});case 7:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x3){return _ref5.apply(this,arguments);};}();};_this.checkEmailValidity=function(client){return function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(event){var regex,_ref8,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:regex=new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);_context4.next=3;return client.query({query:GET_EMAIL,variables:{email:_this.state.email}});case 3:_ref8=_context4.sent;data=_ref8.data;_this.setState({isEmailValid:regex.test(_this.state.email)&&_this.state.email!==''&&data.checkResellerEmail==='AVAILABLE'});case 6:case'end':return _context4.stop();}}},_callee4,_this2);}));return function(_x4){return _ref7.apply(this,arguments);};}();};_this.checkAddressValidity=function(){var regex=new RegExp(/^[a-zA-Z0-9\s,.'-]{3,150}$/);_this.setState({isAddressValid:regex.test(_this.state.address1)&&_this.state.address1!==''});};_this.checkCountryValidity=function(){_this.setState({isCountryValid:_this.state.country!==''});};_this.checkCityValidity=function(){var regex=new RegExp(/^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/);_this.setState({isCityValid:regex.test(_this.state.city)&&_this.state.city!==''});};_this.checkPinValidity=function(){var regex=new RegExp(/^[1-9][0-9]{4}$/);_this.setState({isPinValid:regex.test(_this.state.pincode)&&_this.state.pincode!==''});};_this.checkPanValidity=function(client){return function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(event){var regex,_ref10,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:if(!(_this.state.pan!=='')){_context5.next=9;break;}regex=new RegExp(/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/);_context5.next=4;return client.query({query:GET_PAN_NUMBER,variables:{pan:_this.state.pan}});case 4:_ref10=_context5.sent;data=_ref10.data;_this.setState({isPanValid:regex.test(_this.state.pan)&&data.checkResellerPanNumber==='AVAILABLE'});_context5.next=10;break;case 9:_this.setState({isPanValid:true});case 10:case'end':return _context5.stop();}}},_callee5,_this2);}));return function(_x5){return _ref9.apply(this,arguments);};}();};_this.checkGSTValidity=function(){var regex=new RegExp(/\d{2}[A-Z]{5}\d{4}[A-Z]{1}\d[Z]{1}[A-Z\d]{1}/);if(_this.state.gst!==''){_this.setState({isGSTValid:regex.test(_this.state.gst)});}else{_this.setState({isGSTValid:true});}};_this.handleSelectChange=function(name){return function(value){_this.setState(_defineProperty({},name,value.value));};};_this.handleChangeFreePeriod=function(name){return function(value){var _this$setState3;var total=parseInt(value.target.value,10)+parseInt(_this.state.bufferPeriod,10);_this.setState((_this$setState3={},_defineProperty(_this$setState3,name,value.target.value),_defineProperty(_this$setState3,'totalPeriod',total),_this$setState3));};};_this.handleChangeBufferPeriod=function(name){return function(value){var _this$setState4;var total=parseInt(_this.state.freePeriod,10)+parseInt(value.target.value,10);_this.setState((_this$setState4={},_defineProperty(_this$setState4,name,value.target.value),_defineProperty(_this$setState4,'totalPeriod',total),_this$setState4));};};_this.handleChangeDiscount=function(name){return function(value){_this.setState(_defineProperty({},name,value.target.value));};};_this.submitForm=function(client){return function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(e){var assignedDeviceModel,assignedLicenseType,_ref12,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:e.preventDefault();// console.log('licenseId', this.state.licenseId)
assignedDeviceModel=[];_this.state.modelName.forEach(function(m){var temp={};temp['deviceModelId']=m.id;// temp['manufacturerId'] = 2
assignedDeviceModel.push(temp);});assignedLicenseType=[];_this.state.licenseId.forEach(function(l){var temp={};temp['licenseTypeId']=l.id;assignedLicenseType.push(temp);});_context6.next=7;return client.mutate({mutation:ADD_RESELLER,variables:{username:_this.state.username,password:_this.state.password,accountType:'RES',businessName:_this.state.name,email:_this.state.email,contactPerson:_this.state.person,contactNumber:_this.state.phoneno,address:_this.state.address1+' '+_this.state.address2,city:_this.state.city,state:parseInt(_this.state.state.value,10),country:parseInt(_this.state.country,10),pincode:parseInt(_this.state.pincode,10),panNumber:_this.state.pan,assignedDeviceModel:assignedDeviceModel,assignedLicenseType:assignedLicenseType,licenseExpiryPeriod:parseInt(_this.state.totalPeriod,10),freePeriod:parseInt(_this.state.freePeriod,10),bufferPeriod:parseInt(_this.state.bufferPeriod,10),billingFrequency:parseInt(_this.state.billingFrequency,10),gst:_this.state.gst,discount:parseInt(_this.state.discount,10),status:1}});case 7:_ref12=_context6.sent;data=_ref12.data;if(data.setResellerDetails){_this.props.openSnackbar('Registered Successfully');}else{_this.props.openSnackbar('Registartion Failed');}_this.setState({name:'',username:'',person:'',password:'',email:'',phoneno:'',address1:'',address2:'',city:'',state:'',country:'',pincode:'',pan:'',gst:'',plan:'',timezone:'',response:true});case 11:case'end':return _context6.stop();}}},_callee6,_this2);}));return function(_x6){return _ref11.apply(this,arguments);};}();};_this.cancelForm=function(e){_this.setState({name:'',username:'',person:'',password:'',email:'',phoneno:'',address1:'',address2:'',city:'',state:'',country:'',pincode:'',pan:'',gst:'',plan:'',timezone:'',billingFrequency:'',licenseId:'',modelName:'',freePeriod:'',bufferPeriod:'',totalPeriod:''});};_this.testing=function(e){_this.props.history.push({pathname:'/home/LicensesList'});};_this.getBillingFrequency=function(billing){var billingFrequencies=billing.map(function(billFrq){return{value:billFrq.id,label:billFrq.frequency};});console.log('billingFrequencies',billingFrequencies);_this.setState({billingFrequencies:billingFrequencies});};var timezoneLists=__webpack_require__(187).getTimezones();var timezoneList=timezoneLists.map(function(timezone){return{value:timezone,label:timezone};});_this.state={name:'',username:'',person:'',password:'',email:'',phoneno:'',address1:'',address2:'',city:'',state:'',country:'',pincode:'',pan:'',gst:'',plan:'',timezoneList:timezoneList,timezone:'',isEmailValid:true,isPhonenoValid:true,isAddressValid:true,isCityValid:true,isPinValid:true,isPanValid:true,isGSTValid:true,isUsernameValid:true,isNameValid:true,isContactpValid:true,isPasswordValid:true,isUsernameUnique:true,response:false,modelName:[],licenseId:[],billingFrequencies:'',billingFrequency:'',freePeriod:'',bufferPeriod:'',totalPeriod:'',discount:''// console.log('timezone', this.state.timezoneList)
};return _this;}// submitForm = addClient => e => {
_createClass(RegisterReseller,[{key:'render',value:function render(){var _this3=this;var _state=this.state,name=_state.name,username=_state.username,person=_state.person,password=_state.password,email=_state.email,phoneno=_state.phoneno,address1=_state.address1,address2=_state.address2,city=_state.city,state=_state.state,country=_state.country,pincode=_state.pincode,pan=_state.pan,gst=_state.gst;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_apollo__["ApolloConsumer"],null,function(client){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_apollo__["Query"],{query:GET_BILLING_FREQUENCY,variables:{billingModeId:1}},function(_ref13){var isBillingLoading=_ref13.loading,error=_ref13.error,billing=_ref13.data.billing;if(isBillingLoading)return'Loading';if(error)return'Error!: '+error;var billingFrequencies=billing.map(function(billFrq){return{value:billFrq.id,label:billFrq.frequency};});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_apollo__["Mutation"],{mutation:ADD_RESELLER},function(addClient,_ref14){var data=_ref14.data,error=_ref14.error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Button___default.a,{variant:'outlined',color:'secondary',className:classes.button// onClick={() => this.viewSubscription(this.backUrl)}
,onClick:function onClick(){return _this3.props.history.goBack();}// href={'/home/customers/view/' + this.loginId}
},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_icons_ArrowBack___default.a,{className:classes.iconSmall})),' ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'title'},'Register Reseller')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a// autoComplete="Full Name"
,{name:'name',value:name,type:'text',onChange:_this3.handleInputChange,label:'Full Name',required:true,error:!_this3.state.isNameValid,onBlur:_this3.checkNameValidity(client)}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this3.state.isNameValid?'':'Invalid name'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a// autoComplete="username"
,{name:'username',value:username,type:'text',onChange:_this3.handleInputChange,required:true,error:!_this3.state.isUsernameValid,onBlur:_this3.checkUsernameValidity(client),label:'User Name'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!_this3.state.isUsernameValid?'Username Can be character number special chatcters(-_$@*!) without blank space':'',!_this3.state.isUsernameUnique?'Username Already Exist!':''))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a// autoComplete="username"
,{name:'person',value:person,type:'text',onChange:_this3.handleInputChange,label:'Contact Person',required:true,error:!_this3.state.isContactpValid,onBlur:_this3.checkContactpValidity// label={!isUsernameValid ? 'Invalid Username' : ''}
}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this3.state.isContactpValid?'':'Name should contain only charcters'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a// autoComplete="username"
,{name:'password',value:password,type:'password',onChange:_this3.handleInputChange,label:'Password',error:!_this3.state.isPasswordValid,onBlur:_this3.checkPasswordValidity,required:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this3.state.isPasswordValid?'':'Password should contain 3-10 charcter or digit without space.'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a// autoComplete="username"
,{name:'email',value:email,type:'text',onChange:_this3.handleInputChange,label:'Email',required:true,error:!_this3.state.isEmailValid,onBlur:_this3.checkEmailValidity(client)}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this3.state.isEmailValid?'':'Invalid Email'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_select__["a" /* default */],{classes:classes,options:billingFrequencies,value:_this3.state.billingFrequency,onChange:_this3.handleSelectChange('billingFrequency'),placeholder:'Billing Frequency *'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a// autoComplete="username"
,{name:'phoneno',value:phoneno,type:'text',onChange:_this3.handleInputChange,label:'Phone Number',required:true,error:!_this3.state.isPhonenoValid,onBlur:_this3.checkPhonenoValidity(client)}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Modules_LicensesList__["a" /* default */],{handleChangeLicense:_this3.handleChangeLicense,licenseId:_this3.state.licenseId,handleChangeModels:_this3.handleChangeModels,modelName:_this3.state.modelName})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Modules_CustomTabs__["a" /* default */],{address1:address1,address2:address2,city:city,state:state,country:country,pincode:pincode,pan:pan,gst:gst,isAddressValid:_this3.state.isAddressValid,isCityValid:_this3.state.isCityValid,isPinValid:_this3.state.isPinValid,isPanValid:_this3.state.isPanValid,isGSTValid:_this3.state.isGSTValid,handleInputChange:_this3.handleInputChange,handleCountryChange:_this3.handleCountryChange,handleStateChange:_this3.handleStateChange,checkAddressValidity:_this3.checkAddressValidity,checkCityValidity:_this3.checkCityValidity,checkPinValidity:_this3.checkPinValidity,checkPanValidity:_this3.checkPanValidity(client),checkGSTValidity:_this3.checkGSTValidity})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a,{id:'standard-number',label:'Free Period (Months)*',value:_this3.state.freePeriod,onChange:_this3.handleChangeFreePeriod('freePeriod'),type:'number',className:classes.textField,margin:'normal'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a,{id:'standard-number',label:'Buffer Period (Months)*',value:_this3.state.bufferPeriod,onChange:_this3.handleChangeBufferPeriod('bufferPeriod'),type:'number',className:classes.textField,margin:'normal'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a,{id:'standard-number',label:'Total No of Months',value:_this3.state.totalPeriod,type:'text',disabled:true,className:classes.textField,margin:'normal'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a,{id:'standard-number',label:'Discount in % *',value:_this3.state.discount,onChange:_this3.handleChangeDiscount('discount'),type:'number',className:classes.textField,margin:'normal'})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,container:true,spacing:8,xs:12,justify:'space-evenly'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Button___default.a,{color:'secondary',variant:'contained'// className={this.classes.button}
,onClick:_this3.submitForm(client),disabled:_this3.state.isEmailValid===false||_this3.state.isPhoneValid===false||_this3.state.isCityValid===false||_this3.state.isPinValid===false||_this3.state.isPanValid===false||_this3.state.isUsernameValid===false||_this3.state.isNameValid===false||_this3.state.isContactpValid===false||_this3.state.isPasswordValid===false||_this3.state.isUsernameUnique===false||_this3.state.isGSTValid===false||name===''||username===''||person===''||password===''||email===''||phoneno===''||address1===''||city===''||state===''||country===''||pincode===''||_this3.state.freePeriod===''||_this3.state.bufferPeriod===''||_this3.state.billingFrequency===''||_this3.state.licenseId===''||_this3.state.modelName===''||_this3.state.discount===''},'Save')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Button___default.a,{color:'primary'// className={this.classes.button}
,onClick:_this3.cancelForm,variant:'contained'},'Cancel',' ')))));});});});}}]);return RegisterReseller;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);RegisterReseller.propTypes={classes:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__["withStyles"])(styles,{withTheme:true})(Object(__WEBPACK_IMPORTED_MODULE_15__HOCs_withSharedSnackbar__["a" /* default */])(RegisterReseller)));

/***/ }),
/* 2329 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apollo_client__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parser__ = __webpack_require__(2331);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};




var shallowEqual = __webpack_require__(141);
var invariant = __webpack_require__(67);
function compact(obj) {
    return Object.keys(obj).reduce(function (acc, key) {
        if (obj[key] !== undefined) {
            acc[key] = obj[key];
        }
        return acc;
    }, {});
}
function observableQueryFields(observable) {
    var fields = {
        variables: observable.variables,
        refetch: observable.refetch.bind(observable),
        fetchMore: observable.fetchMore.bind(observable),
        updateQuery: observable.updateQuery.bind(observable),
        startPolling: observable.startPolling.bind(observable),
        stopPolling: observable.stopPolling.bind(observable),
        subscribeToMore: observable.subscribeToMore.bind(observable),
    };
    return fields;
}
var Query = (function (_super) {
    __extends(Query, _super);
    function Query(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.previousData = {};
        _this.hasMounted = false;
        _this.startQuerySubscription = function () {
            if (_this.querySubscription)
                return;
            var current = _this.getQueryResult();
            _this.querySubscription = _this.queryObservable.subscribe({
                next: function () {
                    if (current && current.networkStatus === 7) {
                        current = undefined;
                        return;
                    }
                    _this.updateCurrentData();
                },
                error: function (error) {
                    _this.resubscribeToQuery();
                    if (!error.hasOwnProperty('graphQLErrors'))
                        throw error;
                    _this.updateCurrentData();
                },
            });
        };
        _this.removeQuerySubscription = function () {
            if (_this.querySubscription) {
                _this.querySubscription.unsubscribe();
                delete _this.querySubscription;
            }
        };
        _this.updateCurrentData = function () {
            var _a = _this.props, onCompleted = _a.onCompleted, onError = _a.onError;
            if (onCompleted || onError) {
                var currentResult = _this.queryObservable.currentResult();
                var loading = currentResult.loading, error = currentResult.error, data = currentResult.data;
                if (onCompleted && !loading && !error) {
                    onCompleted(data);
                }
                else if (onError && !loading && error) {
                    onError(error);
                }
            }
            if (_this.hasMounted)
                _this.forceUpdate();
        };
        _this.getQueryResult = function () {
            var data = { data: Object.create(null) };
            Object.assign(data, observableQueryFields(_this.queryObservable));
            var currentResult = _this.queryObservable.currentResult();
            var loading = currentResult.loading, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
            var error = currentResult.error;
            if (errors && errors.length > 0) {
                error = new __WEBPACK_IMPORTED_MODULE_2_apollo_client__["ApolloError"]({ graphQLErrors: errors });
            }
            Object.assign(data, { loading: loading, networkStatus: networkStatus, error: error });
            if (loading) {
                Object.assign(data.data, _this.previousData, currentResult.data);
            }
            else if (error) {
                Object.assign(data, {
                    data: (_this.queryObservable.getLastResult() || {}).data,
                });
            }
            else {
                Object.assign(data.data, currentResult.data);
                _this.previousData = currentResult.data;
            }
            if (!_this.querySubscription) {
                var oldRefetch_1 = data.refetch;
                data.refetch = function (args) {
                    if (_this.querySubscription) {
                        return oldRefetch_1(args);
                    }
                    else {
                        return new Promise(function (r, f) {
                            _this.refetcherQueue = { resolve: r, reject: f, args: args };
                        });
                    }
                };
            }
            data.client = _this.client;
            return data;
        };
        _this.client = props.client || context.client;
        invariant(!!_this.client, "Could not find \"client\" in the context of Query or as passed props. Wrap the root component in an <ApolloProvider>");
        _this.initializeQueryObservable(props);
        return _this;
    }
    Query.prototype.fetchData = function () {
        if (this.props.skip)
            return false;
        var _a = this.props, children = _a.children, ssr = _a.ssr, displayName = _a.displayName, skip = _a.skip, client = _a.client, onCompleted = _a.onCompleted, onError = _a.onError, opts = __rest(_a, ["children", "ssr", "displayName", "skip", "client", "onCompleted", "onError"]);
        var fetchPolicy = opts.fetchPolicy;
        if (ssr === false)
            return false;
        if (fetchPolicy === 'network-only' || fetchPolicy === 'cache-and-network') {
            fetchPolicy = 'cache-first';
        }
        var observable = this.client.watchQuery(__assign({}, opts, { fetchPolicy: fetchPolicy }));
        var result = this.queryObservable.currentResult();
        return result.loading ? observable.result() : false;
    };
    Query.prototype.componentDidMount = function () {
        this.hasMounted = true;
        if (this.props.skip)
            return;
        this.startQuerySubscription();
        if (this.refetcherQueue) {
            var _a = this.refetcherQueue, args = _a.args, resolve = _a.resolve, reject = _a.reject;
            this.queryObservable.refetch(args)
                .then(resolve)
                .catch(reject);
        }
    };
    Query.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
        if (nextProps.skip && !this.props.skip) {
            this.removeQuerySubscription();
            return;
        }
        var client = nextProps.client;
        if (shallowEqual(this.props, nextProps) &&
            (this.client === client || this.client === nextContext.client)) {
            return;
        }
        if (this.client !== client && this.client !== nextContext.client) {
            if (client) {
                this.client = client;
            }
            else {
                this.client = nextContext.client;
            }
            this.removeQuerySubscription();
            this.queryObservable = null;
            this.previousData = {};
            this.updateQuery(nextProps);
        }
        if (this.props.query !== nextProps.query) {
            this.removeQuerySubscription();
        }
        this.updateQuery(nextProps);
        if (nextProps.skip)
            return;
        this.startQuerySubscription();
    };
    Query.prototype.componentWillUnmount = function () {
        this.removeQuerySubscription();
        this.hasMounted = false;
    };
    Query.prototype.render = function () {
        var children = this.props.children;
        var queryResult = this.getQueryResult();
        return children(queryResult);
    };
    Query.prototype.extractOptsFromProps = function (props) {
        var variables = props.variables, pollInterval = props.pollInterval, fetchPolicy = props.fetchPolicy, errorPolicy = props.errorPolicy, notifyOnNetworkStatusChange = props.notifyOnNetworkStatusChange, query = props.query, _a = props.displayName, displayName = _a === void 0 ? 'Query' : _a, _b = props.context, context = _b === void 0 ? {} : _b;
        this.operation = Object(__WEBPACK_IMPORTED_MODULE_3__parser__["b" /* parser */])(query);
        invariant(this.operation.type === __WEBPACK_IMPORTED_MODULE_3__parser__["a" /* DocumentType */].Query, "The <Query /> component requires a graphql query, but got a " + (this.operation.type === __WEBPACK_IMPORTED_MODULE_3__parser__["a" /* DocumentType */].Mutation ? 'mutation' : 'subscription') + ".");
        return compact({
            variables: variables,
            pollInterval: pollInterval,
            query: query,
            fetchPolicy: fetchPolicy,
            errorPolicy: errorPolicy,
            notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
            metadata: { reactComponent: { displayName: displayName } },
            context: context,
        });
    };
    Query.prototype.initializeQueryObservable = function (props) {
        var opts = this.extractOptsFromProps(props);
        if (this.context.operations) {
            this.context.operations.set(this.operation.name, {
                query: opts.query,
                variables: opts.variables,
            });
        }
        this.queryObservable = this.client.watchQuery(opts);
    };
    Query.prototype.updateQuery = function (props) {
        if (!this.queryObservable)
            this.initializeQueryObservable(props);
        this.queryObservable.setOptions(this.extractOptsFromProps(props))
            .catch(function () { return null; });
    };
    Query.prototype.resubscribeToQuery = function () {
        this.removeQuerySubscription();
        var lastError = this.queryObservable.getLastError();
        var lastResult = this.queryObservable.getLastResult();
        this.queryObservable.resetLastResults();
        this.startQuerySubscription();
        Object.assign(this.queryObservable, { lastError: lastError, lastResult: lastResult });
    };
    Query.contextTypes = {
        client: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"].isRequired,
        operations: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    };
    Query.propTypes = {
        children: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"].isRequired,
        fetchPolicy: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
        notifyOnNetworkStatusChange: __WEBPACK_IMPORTED_MODULE_1_prop_types__["bool"],
        onCompleted: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
        onError: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
        pollInterval: __WEBPACK_IMPORTED_MODULE_1_prop_types__["number"],
        query: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"].isRequired,
        variables: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
        ssr: __WEBPACK_IMPORTED_MODULE_1_prop_types__["bool"],
    };
    return Query;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
/* harmony default export */ __webpack_exports__["a"] = (Query);
//# sourceMappingURL=Query.js.map

/***/ }),
/* 2331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DocumentType; });
/* harmony export (immutable) */ __webpack_exports__["b"] = parser;
var invariant = __webpack_require__(67);
var DocumentType;
(function (DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})(DocumentType || (DocumentType = {}));
var cache = new Map();
function parser(document) {
    var cached = cache.get(document);
    if (cached)
        return cached;
    var variables, type, name;
    invariant(!!document && !!document.kind, "Argument of " + document + " passed to parser was not a valid GraphQL " +
        "DocumentNode. You may need to use 'graphql-tag' or another method " +
        "to convert your operation into a document");
    var fragments = document.definitions.filter(function (x) { return x.kind === 'FragmentDefinition'; });
    var queries = document.definitions.filter(function (x) { return x.kind === 'OperationDefinition' && x.operation === 'query'; });
    var mutations = document.definitions.filter(function (x) { return x.kind === 'OperationDefinition' && x.operation === 'mutation'; });
    var subscriptions = document.definitions.filter(function (x) { return x.kind === 'OperationDefinition' && x.operation === 'subscription'; });
    invariant(!fragments.length || (queries.length || mutations.length || subscriptions.length), "Passing only a fragment to 'graphql' is not yet supported. " +
        "You must include a query, subscription or mutation as well");
    invariant(queries.length + mutations.length + subscriptions.length <= 1, "react-apollo only supports a query, subscription, or a mutation per HOC. " +
        (document + " had " + queries.length + " queries, " + subscriptions.length + " ") +
        ("subscriptions and " + mutations.length + " mutations. ") +
        "You can use 'compose' to join multiple operation types to a component");
    type = queries.length ? DocumentType.Query : DocumentType.Mutation;
    if (!queries.length && !mutations.length)
        type = DocumentType.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    invariant(definitions.length === 1, "react-apollo only supports one defintion per HOC. " + document + " had " +
        (definitions.length + " definitions. ") +
        "You can use 'compose' to join multiple operation types to a component");
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') {
        name = definition.name.value;
    }
    else {
        name = 'data';
    }
    var payload = { name: name, type: type, variables: variables };
    cache.set(document, payload);
    return payload;
}
//# sourceMappingURL=parser.js.map

/***/ }),
/* 2332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Modules_CustomerDetailsCard__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Card__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_CardContent__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_CardContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_CardContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_ArrowBack__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_ArrowBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_ArrowBack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query clientDetail($loginId: Int) {\n    clientDetail(loginId: $loginId) {\n      id\n      clientName\n      contactPerson\n      address\n      city\n      state {\n        zone_id\n      }\n      country {\n        country_id\n      }\n      email\n      contactNumber\n      login {\n        username\n      }\n      pincode\n      panNumber\n      type\n    }\n  }\n'],['\n  query clientDetail($loginId: Int) {\n    clientDetail(loginId: $loginId) {\n      id\n      clientName\n      contactPerson\n      address\n      city\n      state {\n        zone_id\n      }\n      country {\n        country_id\n      }\n      email\n      contactNumber\n      login {\n        username\n      }\n      pincode\n      panNumber\n      type\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query checkDeviceAvailableForSubscription(\n    $partnerLoginId: Int!\n    $serial_num: [DeviceListInput!]!\n    $deviceModelId: Int!\n  ) {\n    validation: checkDeviceAvailableForSubscription(\n      partnerLoginId: $partnerLoginId\n      deviceList: $serial_num\n      deviceModelId: $deviceModelId\n    ) {\n      serial_num\n      uniqueDeviceId\n    }\n  }\n'],['\n  query checkDeviceAvailableForSubscription(\n    $partnerLoginId: Int!\n    $serial_num: [DeviceListInput!]!\n    $deviceModelId: Int!\n  ) {\n    validation: checkDeviceAvailableForSubscription(\n      partnerLoginId: $partnerLoginId\n      deviceList: $serial_num\n      deviceModelId: $deviceModelId\n    ) {\n      serial_num\n      uniqueDeviceId\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query checkSimAvailableForSubscription(\n    $partnerLoginId: Int!\n    $simNumber: [SimListInput!]!\n    $serviceProviderId: Int!\n  ) {\n    validation: checkSimAvailableForSubscription(\n      partnerLoginId: $partnerLoginId\n      simList: $simNumber\n      serviceProviderId: $serviceProviderId\n    ) {\n      simNumber\n    }\n  }\n'],['\n  query checkSimAvailableForSubscription(\n    $partnerLoginId: Int!\n    $simNumber: [SimListInput!]!\n    $serviceProviderId: Int!\n  ) {\n    validation: checkSimAvailableForSubscription(\n      partnerLoginId: $partnerLoginId\n      simList: $simNumber\n      serviceProviderId: $serviceProviderId\n    ) {\n      simNumber\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query getSubscriptions(\n    $subscriptionId: Int\n    $clientLoginId: Int\n    $partnerLoginId: Int\n  ) {\n    getSubscriptions(\n      id: $subscriptionId\n      clientLoginId: $clientLoginId\n      partnerLoginId: $partnerLoginId\n    ) {\n      deviceModel {\n        model_name\n        manufacturer {\n          manufacturerCode\n        }\n      }\n      accessoryType {\n        accessoryName\n        manufacturer {\n          manufacturerCode\n        }\n      }\n      serviceProvider {\n        name\n      }\n      deviceModelId\n      accessoryTypeId\n      serviceProviderId\n      unAssignedDeviceQuantity\n      unAssignedSimQuantity\n      unAssignedAccessoryQuantity\n    }\n  }\n'],['\n  query getSubscriptions(\n    $subscriptionId: Int\n    $clientLoginId: Int\n    $partnerLoginId: Int\n  ) {\n    getSubscriptions(\n      id: $subscriptionId\n      clientLoginId: $clientLoginId\n      partnerLoginId: $partnerLoginId\n    ) {\n      deviceModel {\n        model_name\n        manufacturer {\n          manufacturerCode\n        }\n      }\n      accessoryType {\n        accessoryName\n        manufacturer {\n          manufacturerCode\n        }\n      }\n      serviceProvider {\n        name\n      }\n      deviceModelId\n      accessoryTypeId\n      serviceProviderId\n      unAssignedDeviceQuantity\n      unAssignedSimQuantity\n      unAssignedAccessoryQuantity\n    }\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  query checkAccessoryAvailableForSubscription(\n    $partnerLoginId: Int!\n    $serialNumber: [AccessoryListInput!]!\n    $accessoryTypeId: Int!\n  ) {\n    validation: checkAccessoryAvailableForSubscription(\n      partnerLoginId: $partnerLoginId\n      serialNumberList: $serialNumber\n      accessoryTypeId: $accessoryTypeId\n    ) {\n      serialNumber\n      uniqueAccessoryId\n    }\n  }\n'],['\n  query checkAccessoryAvailableForSubscription(\n    $partnerLoginId: Int!\n    $serialNumber: [AccessoryListInput!]!\n    $accessoryTypeId: Int!\n  ) {\n    validation: checkAccessoryAvailableForSubscription(\n      partnerLoginId: $partnerLoginId\n      serialNumberList: $serialNumber\n      accessoryTypeId: $accessoryTypeId\n    ) {\n      serialNumber\n      uniqueAccessoryId\n    }\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  mutation setSubscriptionInventoryAssignment(\n    $uniqueDeviceIdList: [uniqueDeviceIdListInput!]\n    $uniqueAccessoryIdList: [uniqueAccessoryIdListInput!]\n    $simIdList: [simListInput!]\n    $deviceModelId: Int!\n    $accessoryTypeId: Int\n    $serviceProviderId: Int\n    $unAssignedDeviceQuantity: Int!\n    $unAssignedAccessoryQuantity: Int!\n    $unAssignedSimQuantity: Int!\n    $partnerLoginId: Int!\n    $clientLoginId: Int!\n    $subscriptionId: Int!\n  ) {\n    setSubscriptionInventoryAssignment(\n      uniqueDeviceIdList: $uniqueDeviceIdList\n      uniqueAccessoryIdList: $uniqueAccessoryIdList\n      simList: $simIdList\n      deviceModelId: $deviceModelId\n      accessoryTypeId: $accessoryTypeId\n      serviceProviderId: $serviceProviderId\n      unAssignedDeviceQuantity: $unAssignedDeviceQuantity\n      unAssignedAccessoryQuantity: $unAssignedAccessoryQuantity\n      unAssignedSimQuantity: $unAssignedSimQuantity\n      partnerLoginId: $partnerLoginId\n      clientLoginId: $clientLoginId\n      subscriptionId: $subscriptionId\n    )\n  }\n'],['\n  mutation setSubscriptionInventoryAssignment(\n    $uniqueDeviceIdList: [uniqueDeviceIdListInput!]\n    $uniqueAccessoryIdList: [uniqueAccessoryIdListInput!]\n    $simIdList: [simListInput!]\n    $deviceModelId: Int!\n    $accessoryTypeId: Int\n    $serviceProviderId: Int\n    $unAssignedDeviceQuantity: Int!\n    $unAssignedAccessoryQuantity: Int!\n    $unAssignedSimQuantity: Int!\n    $partnerLoginId: Int!\n    $clientLoginId: Int!\n    $subscriptionId: Int!\n  ) {\n    setSubscriptionInventoryAssignment(\n      uniqueDeviceIdList: $uniqueDeviceIdList\n      uniqueAccessoryIdList: $uniqueAccessoryIdList\n      simList: $simIdList\n      deviceModelId: $deviceModelId\n      accessoryTypeId: $accessoryTypeId\n      serviceProviderId: $serviceProviderId\n      unAssignedDeviceQuantity: $unAssignedDeviceQuantity\n      unAssignedAccessoryQuantity: $unAssignedAccessoryQuantity\n      unAssignedSimQuantity: $unAssignedSimQuantity\n      partnerLoginId: $partnerLoginId\n      clientLoginId: $clientLoginId\n      subscriptionId: $subscriptionId\n    )\n  }\n']);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_CLIENT=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject);var VERIFY_DEVICE=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject2);var VERIFY_SIM=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject3);var GET_SUBSCRIPTION=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject4);var VERIFY_ACCESSORY=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject5);var SAVE_SUBSCRIPTION=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject6);var styles=function styles(theme){return{root:{padding:theme.spacing.unit*2,flexGrow:1},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},input:{display:'none'}};};var AssignLicenses=function(_Component){_inherits(AssignLicenses,_Component);function AssignLicenses(props){var _this2=this;_classCallCheck(this,AssignLicenses);var _this=_possibleConstructorReturn(this,(AssignLicenses.__proto__||Object.getPrototypeOf(AssignLicenses)).call(this,props));_this.getSubscriptions=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _ref2,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.client.query({query:GET_SUBSCRIPTION,variables:{subscriptionId:_this.subscriptionId,loginId:_this.loginId,partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__["a" /* default */])()},fetchPolicy:'network-only'});case 2:_ref2=_context.sent;data=_ref2.data;// console.log('sub=', data)
if(data.getSubscriptions.unAssignedDeviceQuantity>0){_this.setState({deviceStatus:false});}else{_this.setState({simStatus:false,accssoryStatus:false});}_this.setState({deviceModelName:data.getSubscriptions.deviceModel.model_name,deviceQuantity:data.getSubscriptions.unAssignedDeviceQuantity,deviceModelId:data.getSubscriptions.deviceModelId,manufacturerCode:data.getSubscriptions.deviceModel.manufacturer.manufacturerCode});if(data.getSubscriptions.accessoryType!==null){_this.setState({accessoryType:data.getSubscriptions.accessoryType.accessoryName,accessoryTypeId:data.getSubscriptions.accessoryTypeId,accessoryQuantity:data.getSubscriptions.unAssignedAccessoryQuantity,accManufacturerCode:data.getSubscriptions.accessoryType.manufacturer.manufacturerCode});}if(data.getSubscriptions.serviceProvider!==null){_this.setState({simProviderName:data.getSubscriptions.serviceProvider.name,// simProviderId: data.getSubscriptions.serviceProvider.id,
simProviderId:data.getSubscriptions.serviceProviderId,simQuantity:data.getSubscriptions.unAssignedSimQuantity});}// console.log(
//   this.state.deviceStatus,
//   this.state.simStatus,
//   this.state.accessoryStatus
// )
case 8:case'end':return _context.stop();}}},_callee,_this2);}));_this.handleDeviceValidate=function(type){return _asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var deviceArr,tempArr,_ref4,data,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:deviceArr=_this.state.deviceSerialNo.split(',');tempArr=[];deviceArr.forEach(function(serialno){var temp={};temp.serial_num=serialno;temp.uniqueDeviceId=_this.state.manufacturerCode+'_'+serialno;tempArr.push(temp);});// console.log('tempArr', tempArr)
_context2.next=5;return _this.props.client.query({query:VERIFY_DEVICE,variables:{serial_num:tempArr,deviceModelId:_this.state.deviceModelId,partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__["a" /* default */])()}});case 5:_ref4=_context2.sent;data=_ref4.data;// console.log(data)
response='';Object.values(data.validation).map(function(res){return response=response+','+res['serial_num'];});// console.log(
//   'input=',
//   deviceArr.length,
//   'devqty=',
//   this.state.deviceQuantity
// )
if(deviceArr.length>_this.state.deviceQuantity){_this.setState({duplicateDeviceList:'You cannot assign devices more than requested quantity'});}else{_this.setState({duplicateDeviceList:response});}if(data.validation.length===0&&deviceArr.length!==0&&deviceArr.length<=_this.state.deviceQuantity){_this.setState({deviceStatus:true});}case 11:case'end':return _context2.stop();}}},_callee2,_this2);}));};_this.handleSimValidate=function(type){return _asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var simArr,tempArr,_ref6,data,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:simArr=_this.state.simSerialNo.split(',');tempArr=[];if(!(simArr.length>0)){_context3.next=12;break;}simArr.forEach(function(serialno){var temp={};temp.simNumber=serialno;tempArr.push(temp);});// console.log('tempArr', tempArr)
_context3.next=6;return _this.props.client.query({query:VERIFY_SIM,variables:{simNumber:tempArr,serviceProviderId:_this.state.simProviderId,partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__["a" /* default */])()}});case 6:_ref6=_context3.sent;data=_ref6.data;// console.log(data)
response='';Object.values(data.validation).map(function(res){return response=response+','+res['simNumber'];});if(simArr.length>_this.state.simQuantity){_this.setState({duplicateSimList:'You cannot assign sim more than requested quantity'});}else{_this.setState({duplicateSimList:response});}// console.log('Sim=', data.validation.length, simArr.length)
if(data.validation.length===0&&simArr.length!==0&&simArr.length<=_this.state.simQuantity){_this.setState({simStatus:true});}case 12:case'end':return _context3.stop();}}},_callee3,_this2);}));};_this.handleAccessoryValidate=function(type){return _asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){var accArr,tempArr,_ref8,data,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:accArr=_this.state.accessorySerialNo.split(',');tempArr=[];if(!(accArr.length>0)){_context4.next=12;break;}accArr.forEach(function(serialno){var temp={};temp.serialNumber=serialno;temp.uniqueAccessoryId=_this.state.accManufacturerCode+'_'+serialno;tempArr.push(temp);});// console.log('tempArr', tempArr)
_context4.next=6;return _this.props.client.query({query:VERIFY_ACCESSORY,variables:{serialNumber:tempArr,accessoryTypeId:_this.state.accessoryTypeId,partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__["a" /* default */])()}});case 6:_ref8=_context4.sent;data=_ref8.data;// console.log(data)
response='';Object.values(data.validation).map(function(res){return response=response+','+res['serialNumber'];});if(accArr.length>_this.state.accessoryQuantity){_this.setState({duplicateAccessoryList:'You cannot assign Accessory more than requested quantity'});}else{_this.setState({duplicateAccessoryList:response});}// console.log('list=', this.state.duplicateAccessoryList)
// console.log('accArr=', data.validation.length, accArr.length)
if(data.validation.length===0&&accArr.length!==0&&accArr.length<=_this.state.accessoryQuantity){_this.setState({accessoryStatus:true});}case 12:case'end':return _context4.stop();}}},_callee4,_this2);}));};_this.viewSubscription=function(e){_this.props.history.push({pathname:'/home/customers/view/'+_this.loginId,state:{from:_this.props.location.pathname}});};_this.handleChange=function(name){return function(event){_this.setState(_defineProperty({},name,event.target.value));};};_this.handleReset=function(type){return function(event){// console.log('type', type)
if(type==='device'){_this.setState({deviceSerialNo:'',deviceUniqueNo:'',deviceStatus:false,duplicateDeviceList:''});}if(type==='sim'){_this.setState({simSerialNo:'',simStatus:false,duplicateSimList:''});}if(type==='accessory'){_this.setState({accessorySerialNo:'',accessoryUniqueNo:'',accessoryStatus:false,duplicateAccessoryList:''});}};};_this.handleSaveAssignment=function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(e){var devices,accessories,sims,deviceArr,simArr,accArr,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:devices=[];accessories=[];sims=[];deviceArr=[];simArr=[];accArr=[];if(_this.state.deviceSerialNo!==''){deviceArr=_this.state.deviceSerialNo.split(',');deviceArr.forEach(function(serialno){var temp={};temp.uniqueDeviceId=_this.state.manufacturerCode+'_'+serialno;devices.push(temp);});}if(_this.state.simSerialNo!==''){simArr=_this.state.simSerialNo.split(',');simArr.forEach(function(serialno){var temp={};temp.simNumber=serialno;sims.push(temp);});}if(_this.state.accessorySerialNo!==''){accArr=_this.state.accessorySerialNo.split(',');accArr.forEach(function(serialno){var temp={};temp.uniqueAccessoryId=_this.state.accManufacturerCode+'_'+serialno;accessories.push(temp);});}// console.log('all3=', devices, sims, accessories)
_context5.next=11;return _this.props.client.mutate({mutation:SAVE_SUBSCRIPTION,variables:{uniqueDeviceIdList:devices,uniqueAccessoryIdList:accessories,simIdList:sims,deviceModelId:_this.state.deviceModelId,accessoryTypeId:_this.state.accessoryTypeId,serviceProviderId:_this.state.simProviderId,unAssignedDeviceQuantity:_this.state.deviceQuantity-deviceArr.length,unAssignedAccessoryQuantity:_this.state.accessoryQuantity-accArr.length,unAssignedSimQuantity:_this.state.simQuantity-simArr.length,partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__["a" /* default */])(),clientLoginId:_this.loginId,subscriptionId:_this.subscriptionId}});case 11:response=_context5.sent;_this.setState({deviceSerialNo:'',simSerialNo:'',accessorySerialNo:'',duplicateDeviceList:'',duplicateAccessoryList:'',duplicateSimList:''});console.log('response=',response);case 14:case'end':return _context5.stop();}}},_callee5,_this2);}));return function(_x){return _ref9.apply(this,arguments);};}();_this.loginId=_this.props.match.params.loginId;_this.subscriptionId=_this.props.match.params.subscriptionId;_this.state={deviceSerialNo:'',deviceUniqueNo:'',deviceModelId:'',deviceModelName:'',deviceQuantity:'',manufacturerCode:'',duplicateDeviceList:'',simSerialNo:'',simProviderName:'',simProviderId:'',simQuantity:'',duplicateSimList:'',accessorySerialNo:'',accessoryType:'',accessoryTypeId:null,accessoryQuantity:'',accManufacturerCode:'',deviceStatus:true,simStatus:true,accessoryStatus:true// assignedDeviceList: null,
// assignedAccessoryList: null,
// assignedSimList: null
};return _this;}_createClass(AssignLicenses,[{key:'componentDidMount',value:function componentDidMount(){this.getSubscriptions();}},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;var models=['S101','TS101'];return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_apollo__["Query"],{query:GET_CLIENT,variables:{loginId:this.loginId},fetchPolicy:'network-only'},function(_ref10){var loading=_ref10.loading,error=_ref10.error,clientDetail=_ref10.data.clientDetail;if(loading)return'Loading...';if(error)return'Error!: '+error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Button"],{variant:'outlined',color:'secondary',className:classes.button// onClick={this.viewSubscription}
// onClick={() => this.viewSubscription(this.backUrl)}
,onClick:function onClick(){return _this3.props.history.goBack();}// href={'/home/customers/view/' + this.loginId}
},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_ArrowBack___default.a,{className:classes.iconSmall})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Modules_CustomerDetailsCard__["a" /* default */],{clientDetail:clientDetail}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'subheading'},'Process Purchase Request',' ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Card___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row',alignItems:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'subheading'},'Device :')),models.map(function(inventoryDetail){return inventoryDetail.id!==null?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row',alignItems:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'subheading'},inventoryDetail.type)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'body1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',null,'Model:'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'body2'},inventoryDetail)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'body1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',null,'Quantity:'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'body2'},inventoryDetail.quantity)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:5},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_TextField___default.a,{fullWidth:true,id:'outlined-multiline-flexible',label:'Enter Serial Number With Comma Seprate',multiline:true,value:/* eslint-disable */_this3.state.deviceSerialNo/* eslint-enable */,onChange:_this3.handleChange('deviceSerialNo'),onBlur:_this3.handleDeviceValidate('device'),className:classes.textField,margin:'normal',helperText:_this3.state.duplicateDeviceList,error:_this3.state.duplicateDeviceList,variant:'outlined'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Button"],{variant:'raised',color:'secondary',className:classes.button,onClick:_this3.handleReset(inventoryDetail.type)},'Validate')),'\xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Button"],{variant:'raised',color:'primary',className:classes.button,onClick:_this3.handleReset(inventoryDetail.type)},'Reset'))):null;})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row',alignItems:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'subheading'},'Licenses :')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'body1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',null,'License:'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'body2'},_this3.state.simProviderName)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'body1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',null,'Quantity:'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'body2'},_this3.state.simQuantity)))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,justify:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Button"],{color:'primary',variant:'raised',onClick:_this3.handleSaveAssignment,disabled:!(_this3.state.deviceStatus&&_this3.state.simStatus)},'Save')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Button"],{color:'secondary',variant:'raised',onClick:_this3.handleCancelAssignment},'Cancel')))));});}}]);return AssignLicenses;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);AssignLicenses.propTypes={classes:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired};var withApolloClient=function withApolloClient(Component){return function(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_apollo__["ApolloConsumer"],null,function(client){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component,Object.assign({client:client},props));});};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__["withStyles"])(styles)(withApolloClient(AssignLicenses)));

/***/ }),
/* 2333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PullApi=function(_Component){_inherits(PullApi,_Component);function PullApi(props){_classCallCheck(this,PullApi);var _this=_possibleConstructorReturn(this,(PullApi.__proto__||Object.getPrototypeOf(PullApi)).call(this,props));_this.state={error:null,isLoaded:false,items:[],posts:[]};return _this;}_createClass(PullApi,[{key:'fetchFirst',value:function fetchFirst(url){var that=this;if(url){fetch('https://www.reddit.com/r/'+url+'.json')// fetch('http://104.211.217.189/aquila_api/fuel_alert/' + url + '.php')
.then(function(response){return response.json();}).then(function(result){that.setState({items:result.data.children,lastPostName:result.data.children[result.data.children.length-1].data.name});console.log('sssss',that.state.items);});}}},{key:'componentDidMount',value:function componentDidMount(){this.fetchFirst('reactjs');}},{key:'render',value:function render(){var _state=this.state,error=_state.error,items=_state.items;if(error){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Error: ',error.message);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,items.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:item.kind},item.data.author_fullname);}));}}}]);return PullApi;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PullApi);

/***/ }),
/* 2334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormHelperText__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormHelperText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormHelperText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_FormControlLabel__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_FormControlLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_FormControlLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__plans_css__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__plans_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__plans_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_common_Loader__ = __webpack_require__(47);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query {\n    features: allFeatures(status: 1) {\n      id\n      featureName\n      costPerAssetPerMonth\n      featureDescription\n    }\n  }\n'],['\n  query {\n    features: allFeatures(status: 1) {\n      id\n      featureName\n      costPerAssetPerMonth\n      featureDescription\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query getPlans($planid: Int!) {\n    getPlans(id: $planid) {\n      planName\n      description\n      featureList {\n        id\n        featureName\n        costPerAssetPerMonth\n        featureDescription\n      }\n    }\n  }\n'],['\n  query getPlans($planid: Int!) {\n    getPlans(id: $planid) {\n      planName\n      description\n      featureList {\n        id\n        featureName\n        costPerAssetPerMonth\n        featureDescription\n      }\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation addLicenseType(\n    $licenseType: String!\n    $description: String!\n    $featureList: String!\n    $maxPrice: Int!\n  ) {\n    addLicenseType(\n      licenseType: $licenseType\n      description: $description\n      featureList: $featureList\n      maxPrice: $maxPrice\n    )\n  }\n'],['\n  mutation addLicenseType(\n    $licenseType: String!\n    $description: String!\n    $featureList: String!\n    $maxPrice: Int!\n  ) {\n    addLicenseType(\n      licenseType: $licenseType\n      description: $description\n      featureList: $featureList\n      maxPrice: $maxPrice\n    )\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_ALL_FEATURES=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject);var GET_FEATURE_BY_PLAN=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject2);var ADD_LICENSE_TYPE=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject3);var styles=function styles(theme){return{root:{flexGrow:1,padding:theme.spacing.unit*2},paper:{width:'100%'},control:{padding:theme.spacing.unit*1}};};var createPlan=function(_Component){_inherits(createPlan,_Component);function createPlan(props){var _this2=this;_classCallCheck(this,createPlan);var _this=_possibleConstructorReturn(this,(createPlan.__proto__||Object.getPrototypeOf(createPlan)).call(this,props));_this.handleSubmit=function(addLicenseType){return function(e){e.preventDefault();addLicenseType({variables:{licenseType:_this.state.planName,description:_this.state.description,featureList:JSON.stringify(_this.state.selectedFeaturesList),maxPrice:parseInt(_this.state.maxPrice,10)}});_this.setState({licenseType:'',description:'',featureList:'',maxPrice:''});_this.props.openSnackbar('License created Successfully');_this.props.history.push({pathname:'/home/ViewLicense'});};};_this.handleInputChange=function(key){return function(e){return _this.setState(_defineProperty({},key,e.target.value));};};_this.handleChange=function(event){return _this.setState(_defineProperty({},event.target.name,event.target.value));};_this.handleChangeChecked=function(name){return function(event){var check1={};var check2=[];var temState=_this.state.selectedFeaturesList;if(event.target.checked===true){if(temState&&temState.length){temState.forEach(function(v){if(temState.indexOf(v.feature)!==-1){_this.setState({temp:event.target.value});}});if(_this.state.temp===null){check1['featureid']=parseInt(event.target.value,10);temState.push(check1);}}else{check1['featureid']=parseInt(event.target.value,10);temState.push(check1);}}else{var tempObject={featureid:parseInt(event.target.value,10)};var keys=Object.keys(tempObject);temState.splice(// get the index of the element
temState.findIndex(function(obj){// check all property values are equal
return keys.every(function(k){return tempObject[k]===obj[k];});}),1);}temState.forEach(function(v){check2[v.featureid]=true;});_this.setState({checkListArr:check2});_this.setState({selectedFeaturesList:temState});};};_this.handleChangelicenseType=function(tempState){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var check,check1,check2,_ref2,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:check=[];check1={};check2=[];if(!(event.target.value!=='')){_context.next=12;break;}_context.next=6;return _this.props.client.query({query:GET_FEATURE_BY_PLAN,variables:{planid:parseInt(event.target.value,10)}});case 6:_ref2=_context.sent;data=_ref2.data;data.getPlans.featureList.forEach(function(allFeatures){check1={};check2[allFeatures.id]=true;check1['featureid']=allFeatures.id;check.push(check1);});_this.setState({licenseType:event.target.value,defaultFeatures:data,tempState:check,selectedFeaturesList:check,checkListArr:check2});_context.next=14;break;case 12:tempState.forEach(function(v){check2[v.featureid]=false;});_this.setState({licenseType:event.target.value,tempState:check,selectedFeaturesList:check,checkListArr:check2});case 14:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();};_this.state={isSpeedLimitValid:true,planName:'',description:'',tempState:{},plan:'',terms:false,message:'',maxPrice:'',partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_17__utils_getLoginId__["a" /* default */])(),licenseType:'',featuresList:[],selectedFeaturesList:[],temp:null,default:[],checkListArr:[]};return _this;}_createClass(createPlan,[{key:'getIndex',value:function getIndex(value,arr){for(var i=0;i<arr.length;i++){if(arr[i]['feature']===value){return i;}}return-1;}},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_apollo__["Mutation"],{mutation:ADD_LICENSE_TYPE,errorPolicy:'all'},function(createPlan,_ref3){var data=_ref3.data,loading=_ref3.loading,error=_ref3.error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',{className:'Formheader'},'New Plan'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{onSubmit:_this3.handleSubmit(createPlan)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row',justify:'center',alignItems:'flex-start'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'planName',name:'planName',className:'textfield',margin:'dense',label:'Plan Name',type:'text',value:_this3.state.planName,required:true,onChange:_this3.handleInputChange('planName'),error:!_this3.state.isSpeedLimitValid,onBlur:_this3.checkSpeedLimitValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!_this3.state.isSpeedLimitValid?'Invalid Speed Limit':''))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'description',name:'description',className:'textfield',margin:'dense',label:'Description',type:'text'// type="Multi-line"
,value:_this3.state.description,required:true,onChange:_this3.handleInputChange('description'),error:!_this3.state.isSpeedLimitValid,onBlur:_this3.checkSpeedLimitValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!_this3.state.isSpeedLimitValid?'Invalid Speed Limit':''))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel___default.a,{htmlFor:'plan-native-simple'},'Select from other plan'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Select___default.a,{value:_this3.state.licenseType,onChange:_this3.handleChangelicenseType(_this3.state.tempState),inputProps:{name:'licenseType',id:'plan-native-simple'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default.a,{value:'1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'Basic')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default.a,{value:'2'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'Value')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default.a,{value:'3'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'Enterprise'))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'maxPrice',name:'maxPrice',label:'Maximum Price',type:'number',className:classes.textField,value:_this3.state.maxPrice,required:true,onChange:_this3.handleInputChange('maxPrice'),error:!_this3.state.isSpeedLimitValid,onBlur:_this3.checkSpeedLimitValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!_this3.state.isSpeedLimitValid?'Invalid Speed Limit':''))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button___default.a,{variant:'contained',className:classes.button},'Cancel'),'\xA0\xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button___default.a,{color:'primary',variant:'contained',type:'submit',className:classes.button},'Submit')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_apollo__["Query"],{query:GET_ALL_FEATURES},function(_ref4){var loading=_ref4.loading,error=_ref4.error,features=_ref4.data.features;if(loading)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_common_Loader__["a" /* default */],null);if(error)return'Error!: '+error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row',justify:'flex-start',alignItems:'flex-start'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},features&&features.map(function(featuresList){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["Checkbox"],{checked:/* eslint-disable */_this3.state.checkListArr[featuresList.id]||false/* eslint-enable */,onChange:_this3.handleChangeChecked(featuresList.id),value:featuresList.id}),label:featuresList.featureName});})))));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,null,_this3.state.featuresList.features&&_this3.state.featuresList.features.map(function(featList){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["Checkbox"],null)});}))))));});}}]);return createPlan;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_16__HOCs_withSharedSnackbar__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_15_react_apollo__["withApollo"])(createPlan))));

/***/ }),
/* 2335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Card__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_CardContent__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_CardContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_CardContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_CardActions__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_CardActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_CardActions__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles=function styles(theme){return{root:{flexGrow:1,padding:theme.spacing.unit*2},paper:{height:140,width:100},control:{padding:theme.spacing.unit*2}};};var UserDashboard=function(_Component){_inherits(UserDashboard,_Component);function UserDashboard(){var _ref;var _temp,_this,_ret;_classCallCheck(this,UserDashboard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UserDashboard.__proto__||Object.getPrototypeOf(UserDashboard)).call.apply(_ref,[this].concat(args))),_this),_this.viewDetails=function(usertype){var path='';console.log('usertype',usertype);if(usertype==='reseller'){path='/home/users/reseller';}else if(usertype==='partner'){path='/home/users/partner';}else if(usertype==='manufacturer'){path='/home/users/manufacturer';}_this.props.history.push({pathname:path});},_this.addPlan=function(e){_this.props.history.push({pathname:'/home/Plans/addPlan'});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UserDashboard,[{key:'render',value:function render(){var _this2=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row-reverse',justify:'space-between',alignItems:'flex-end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'headline'},'User\'s Dashboard')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row',justify:'flex-start',alignItems:'flex-start',className:classes.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row',justify:'flex-start',alignItems:'flex-start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:16},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Card___default.a,{className:classes.card},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{gutterBottom:true,variant:'headline',component:'h2'},'Reseller'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body2',gutterBottom:true},'2012'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{component:'p'},'Reseller')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_CardActions___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button___default.a,{color:'primary',variant:'outlined',onClick:function onClick(){return _this2.viewDetails('reseller');}},'View')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:16},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Card___default.a,{className:classes.card},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{gutterBottom:true,variant:'headline',component:'h2'},'Business Admin'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body2',gutterBottom:true},'2012'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{component:'p'},'Reseller')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_CardActions___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button___default.a,{color:'primary',variant:'outlined',onClick:function onClick(){return _this2.viewDetails('partner');},type:'button'},'View')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:16},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Card___default.a,{className:classes.card},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{gutterBottom:true,variant:'headline',component:'h2'},'Manufacturer'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body2',gutterBottom:true},'2012'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{component:'p'},'Reseller')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_CardActions___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button___default.a,{color:'primary',variant:'outlined',onClick:function onClick(){return _this2.viewDetails('manufacturer');}},'View'))))))))));}}]);return UserDashboard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles__["withStyles"])(styles)(UserDashboard));

/***/ }),
/* 2336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Menu__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Menu__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getAllResellerDetails {\n    getAllResellerDetails {\n      resellerName\n      email\n      contactNumber\n      contactPerson\n      licenseExpiryPeriod\n      login {\n        loginId\n      }\n    }\n  }\n'],['\n  query getAllResellerDetails {\n    getAllResellerDetails {\n      resellerName\n      email\n      contactNumber\n      contactPerson\n      licenseExpiryPeriod\n      login {\n        loginId\n      }\n    }\n  }\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_RESELLER=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject);var style=function style(theme){return{root:{padding:theme.spacing.unit*4,flexGrow:1},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},iconSmall:{fontSize:20}};};var Reseller=function(_Component){_inherits(Reseller,_Component);function Reseller(props){_classCallCheck(this,Reseller);var _this=_possibleConstructorReturn(this,(Reseller.__proto__||Object.getPrototypeOf(Reseller)).call(this,props));_this.loginId=[];_this.fullData=[];_this.columns=['COMPANY NAME','CONTACT PERSON','EMAIL','PHONE NUMBER','OFFER PERIOD'];_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15,onRowClick:function onRowClick(rowData,dataIndex,rowIndex){_this.props.history.push({pathname:'/home/reseller/view/'+_this.loginId[dataIndex.dataIndex]});}};_this.addCustomer=function(e){_this.props.history.push({pathname:'/home/RegisterReseller'});};_this.classes=props;return _this;}_createClass(Reseller,[{key:'mapToArr',value:function mapToArr(clients){var _this2=this;var rowData=[];this.fullData=[];this.loginId=[];console.log('sss',clients.getAllResellerDetails.length,clients);if(clients.getAllResellerDetails.length>0){clients.getAllResellerDetails.forEach(function(element){rowData=[];_this2.loginId.push(element.login.loginId);rowData.push(element.resellerName);rowData.push(element.contactPerson);rowData.push(element.email);rowData.push(element.contactNumber);rowData.push(element.licenseExpiryPeriod);_this2.fullData.push(rowData);});}}},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["Query"],{query:GET_RESELLER,errorPolicy:'all'},function(_ref){var loading=_ref.loading,error=_ref.error,data=_ref.data;if(loading)return'Loading...';if(error)return'Error!: '+error;_this3.mapToArr(data);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row-reverse',justify:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default.a,{color:'secondary',onClick:_this3.addCustomer,variant:'raised',className:_this3.classes.button},'Add Reseller'),'  ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default.a,{variant:'outlined',className:classes.button},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Menu___default.a,{className:classes.iconSmall}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'headline'},'Reseller'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_mui_datatables___default.a,{data:_this3.fullData,columns:_this3.columns,options:_this3.options}))));});}}]);return Reseller;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["withStyles"])(style)(Reseller));

/***/ }),
/* 2337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Paper__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Paper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Card__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_CardContent__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_CardContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_CardContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_IconButton__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Mail__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Mail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Mail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_icons_ContactPhone__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_icons_ContactPhone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_icons_ContactPhone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_icons_Person__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_icons_Person___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_icons_Person__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_icons_LocationOn__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_icons_LocationOn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_icons_LocationOn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_icons_LocationCity__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_icons_LocationCity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__material_ui_icons_LocationCity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_icons_Business__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_icons_Business___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__material_ui_icons_Business__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_icons_ArrowBack__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_icons_ArrowBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__material_ui_icons_ArrowBack__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getResellerDetails($loginId: Int) {\n    getResellerDetails(loginId: $loginId) {\n      id\n      resellerName\n      contactPerson\n      address\n      city\n      state {\n        name\n      }\n      country {\n        name\n      }\n      email\n      contactNumber\n      login {\n        loginId\n      }\n    }\n  }\n'],['\n  query getResellerDetails($loginId: Int) {\n    getResellerDetails(loginId: $loginId) {\n      id\n      resellerName\n      contactPerson\n      address\n      city\n      state {\n        name\n      }\n      country {\n        name\n      }\n      email\n      contactNumber\n      login {\n        loginId\n      }\n    }\n  }\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_RESELLER=Object(__WEBPACK_IMPORTED_MODULE_9_graphql_tag__["a" /* default */])(_templateObject);var styles=function styles(theme){return{root:{flexGrow:1},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},button:{margin:theme.spacing.unit},input:{display:'none'}};};var ResellerView=function(_Component){_inherits(ResellerView,_Component);function ResellerView(props){_classCallCheck(this,ResellerView);var _this=_possibleConstructorReturn(this,(ResellerView.__proto__||Object.getPrototypeOf(ResellerView)).call(this,props));_this.editCustomer=function(loginId){return function(e){_this.props.history.push({pathname:'/home/reseller/edit/'+_this.loginId});};};_this.handleRegistration=function(e){_this.props.history.push({pathname:'/home/VehicleRegistration'});};_this.showSubscription=function(subscriptionId){return function(e){_this.props.history.push({pathname:'/home/subscriptions/view/'+_this.loginId+'/'+subscriptionId});};};_this.allCustomer=function(e){console.log('er=',e);_this.props.history.push({pathname:e,state:{from:_this.props.location.pathname}});};_this.createNewSubscription=function(e){_this.props.history.push({pathname:'/home/subscriptions/new/'+_this.loginId});};_this.loginId=parseInt(_this.props.match.params.loginId,10);return _this;}_createClass(ResellerView,[{key:'render',value:function render(){var _this2=this;var classes=this.props;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_apollo__["Query"],{query:GET_RESELLER,variables:{loginId:this.loginId}},function(_ref){var loading=_ref.loading,error=_ref.error,data=_ref.data;if(loading)return'Loading...';if(error)return'Error!: '+error;console.log('Client Detail is ',data);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.root,style:{padding:'15px 15px 15px 15px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:'left'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button___default.a,{variant:'outlined',color:'secondary',className:classes.button// href="/home/customers"
// onClick={() => this.allCustomer(this.backUrl)}
,onClick:function onClick(){return _this2.props.history.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_icons_ArrowBack___default.a,{className:classes.iconSmall}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:'right'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button___default.a,{color:'secondary',variant:'raised',className:classes.button,onClick:_this2.handleRegistration},'Assign Devices'),'\xA0\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button___default.a,{variant:'outlined',color:'primary',className:classes.button,onClick:_this2.editCustomer(data.getResellerDetails.login.loginId)},'Edit'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{color:'red',fontSize:'10px',textAlign:'left'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,spacing:24},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:9,style:{color:'red',fontSize:'10px',float:'left'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Card___default.a,{className:classes.card,style:{color:'red',fontSize:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'headline',component:'h2',color:'primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_IconButton___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_icons_Business___default.a,{color:'primary'})),data.getResellerDetails.resellerName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{component:'p'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_IconButton___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_icons_Person___default.a,{color:'primary'})),data.getResellerDetails.contactPerson),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{component:'p'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_IconButton___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_icons_LocationOn___default.a,{color:'primary'})),data.getResellerDetails.address),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{component:'p'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_IconButton___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_icons_LocationCity___default.a,{color:'primary'})),data.getResellerDetails.city,' ',data.getResellerDetails.state.name,' ',data.getResellerDetails.country.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{component:'p',style:{padding:'45px 0 0 0 '}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_IconButton___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Mail___default.a,{color:'primary'})),data.getResellerDetails.email),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{component:'p'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_IconButton___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_icons_ContactPhone___default.a,{color:'primary'})),data.getResellerDetails.contactNumber))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Card___default.a,{className:classes.card,style:{color:'red',fontSize:'10px',textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Paper___default.a,{className:classes.paper,style:{padding:'3px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'red',fontSize:'20px'}},'100'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontSize:'15px',color:'black'}},'Total Devices'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Card___default.a,{className:classes.card,style:{color:'red',fontSize:'10px',textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Paper___default.a,{className:classes.paper,style:{padding:'3px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'red',fontSize:'20px',textAlign:'center'}},'100'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontSize:'15px',color:'black'}},'Assign Devices ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Card___default.a,{className:classes.card,style:{color:'red',fontSize:'10px',textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Paper___default.a,{className:classes.paper,style:{padding:'3px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'red',fontSize:'20px',textAlign:'center'}},'100'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontSize:'15px',color:'black'}},' ','Unregistered Devices'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null));});}}]);return ResellerView;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ResellerView.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__["withStyles"])(styles)(ResellerView));

/***/ }),
/* 2338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Modules_CustomTabs__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_icons_ArrowBack__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_icons_ArrowBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_icons_ArrowBack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Modules_LicensesList__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__HOCs_withSharedSnackbar__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getResellerDetails($loginId: Int) {\n    getResellerDetails(loginId: $loginId) {\n      id\n      resellerName\n      contactPerson\n      address\n      city\n\n      state {\n        zone_id\n      }\n      country {\n        country_id\n      }\n      email\n      contactNumber\n      pincode\n      panNumber\n      gst\n      freePeriod\n      bufferPeriod\n      discountPercentage\n      defaultBillingFrequency {\n        frequency\n        id\n      }\n      licenseExpiryPeriod\n      login {\n        loginId\n        username\n      }\n      assignedLicenseType {\n        id\n        licenseType\n      }\n      assignedDeviceModels {\n        id\n        model_name\n      }\n    }\n  }\n'],['\n  query getResellerDetails($loginId: Int) {\n    getResellerDetails(loginId: $loginId) {\n      id\n      resellerName\n      contactPerson\n      address\n      city\n\n      state {\n        zone_id\n      }\n      country {\n        country_id\n      }\n      email\n      contactNumber\n      pincode\n      panNumber\n      gst\n      freePeriod\n      bufferPeriod\n      discountPercentage\n      defaultBillingFrequency {\n        frequency\n        id\n      }\n      licenseExpiryPeriod\n      login {\n        loginId\n        username\n      }\n      assignedLicenseType {\n        id\n        licenseType\n      }\n      assignedDeviceModels {\n        id\n        model_name\n      }\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  mutation setResellerDetails(\n    $resellerName: String!\n    $email: String!\n    $contactPerson: String!\n    $contactNumber: String!\n    $address: String!\n    $city: String!\n    $state: Int!\n    $country: Int!\n    $pincode: Int!\n    $panNumber: String!\n    $licenseExpiryPeriod: Int!\n    $assignedDeviceModel: [AssignDeviceModelToReseller!]!\n    $assignedLicenseType: [AssignLicenseTypeToReseller!]!\n    $gst: String!\n    $freePeriod: Int!\n    $bufferPeriod: Int!\n    $discount: Int!\n    $billingFrequency: Int!\n    $loginId: Int\n    $status: Int!\n    $accountType: String\n    $id: Int\n  ) {\n    setResellerDetails(\n      resellerName: $resellerName\n      email: $email\n      contactPerson: $contactPerson\n      contactNumber: $contactNumber\n      address: $address\n      city: $city\n      stateId: $state\n      countryId: $country\n      pincode: $pincode\n      panNumber: $panNumber\n      licenseExpiryPeriod: $licenseExpiryPeriod\n      assignedDeviceModel: $assignedDeviceModel\n      assignedLicenseType: $assignedLicenseType\n      gst: $gst\n      freePeriod: $freePeriod\n      bufferPeriod: $bufferPeriod\n      discountPercentage: $discount\n      defaultBillingFrequency: $billingFrequency\n      loginId: $loginId\n      status: $status\n      accountType: $accountType\n      id: $id\n    )\n  }\n'],['\n  mutation setResellerDetails(\n    $resellerName: String!\n    $email: String!\n    $contactPerson: String!\n    $contactNumber: String!\n    $address: String!\n    $city: String!\n    $state: Int!\n    $country: Int!\n    $pincode: Int!\n    $panNumber: String!\n    $licenseExpiryPeriod: Int!\n    $assignedDeviceModel: [AssignDeviceModelToReseller!]!\n    $assignedLicenseType: [AssignLicenseTypeToReseller!]!\n    $gst: String!\n    $freePeriod: Int!\n    $bufferPeriod: Int!\n    $discount: Int!\n    $billingFrequency: Int!\n    $loginId: Int\n    $status: Int!\n    $accountType: String\n    $id: Int\n  ) {\n    setResellerDetails(\n      resellerName: $resellerName\n      email: $email\n      contactPerson: $contactPerson\n      contactNumber: $contactNumber\n      address: $address\n      city: $city\n      stateId: $state\n      countryId: $country\n      pincode: $pincode\n      panNumber: $panNumber\n      licenseExpiryPeriod: $licenseExpiryPeriod\n      assignedDeviceModel: $assignedDeviceModel\n      assignedLicenseType: $assignedLicenseType\n      gst: $gst\n      freePeriod: $freePeriod\n      bufferPeriod: $bufferPeriod\n      discountPercentage: $discount\n      defaultBillingFrequency: $billingFrequency\n      loginId: $loginId\n      status: $status\n      accountType: $accountType\n      id: $id\n    )\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query getAllBillingFrequency($billingModeId: Int!) {\n    billing: getAllBillingFrequency(billingModeId: $billingModeId) {\n      id\n      frequency\n      billingModeId\n      numberOfMonths\n    }\n  }\n'],['\n  query getAllBillingFrequency($billingModeId: Int!) {\n    billing: getAllBillingFrequency(billingModeId: $billingModeId) {\n      id\n      frequency\n      billingModeId\n      numberOfMonths\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query checkResellerName($id: Int, $businessname: String!) {\n    checkResellerName(id: $id, resellerName: $businessname)\n  }\n'],['\n  query checkResellerName($id: Int, $businessname: String!) {\n    checkResellerName(id: $id, resellerName: $businessname)\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  query checkUsername($id: Int, $username: String!) {\n    checkUsername(id: $id, username: $username)\n  }\n'],['\n  query checkUsername($id: Int, $username: String!) {\n    checkUsername(id: $id, username: $username)\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  query checkClientContactNumber($id: Int, $phoneno: String!) {\n    checkClientContactNumber(id: $id, contactNumber: $phoneno)\n  }\n'],['\n  query checkClientContactNumber($id: Int, $phoneno: String!) {\n    checkClientContactNumber(id: $id, contactNumber: $phoneno)\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  query checkClientEmail($id: Int, $email: String!) {\n    checkClientEmail(id: $id, email: $email)\n  }\n'],['\n  query checkClientEmail($id: Int, $email: String!) {\n    checkClientEmail(id: $id, email: $email)\n  }\n']);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var styles=function styles(theme){return{root:{flexGrow:1,padding:theme.spacing.unit*2}};};var GET_RESELLER=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject);var UPDATE_RESELLER=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject2);var GET_BILLING_FREQUENCY=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject3);// Business name validation
var GET_RESELLER_NAME=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject4);// username validation
var GET_USERNAME=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject5);// Business name validation
var GET_CONTACTNO=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject6);// Business email validation
var GET_EMAIL=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject7);var ResellerEdit=function(_Component){_inherits(ResellerEdit,_Component);function ResellerEdit(props){var _this2=this;_classCallCheck(this,ResellerEdit);var _this=_possibleConstructorReturn(this,(ResellerEdit.__proto__||Object.getPrototypeOf(ResellerEdit)).call(this,props));_this.getClients=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _ref2,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.client.query({query:GET_RESELLER,variables:{loginId:parseInt(_this.loginId,10)}});case 2:_ref2=_context.sent;data=_ref2.data;console.log('details',data);_this.setDetails(data.getResellerDetails);case 6:case'end':return _context.stop();}}},_callee,_this2);}));_this.setDetails=function(clientDetail){console.log('details',clientDetail);_this.setState({clientId:clientDetail.id,name:clientDetail.resellerName,username:clientDetail.login.username,person:clientDetail.contactPerson,email:clientDetail.email,phoneno:clientDetail.contactNumber,address1:clientDetail.address,city:clientDetail.city,state:clientDetail.state.zone_id,country:clientDetail.country.country_id,pincode:clientDetail.pincode,pan:clientDetail.panNumber,gst:clientDetail.gst,freePeriod:clientDetail.freePeriod,bufferPeriod:clientDetail.bufferPeriod,totalPeriod:clientDetail.licenseExpiryPeriod,discount:clientDetail.discountPercentage,loginId:clientDetail.login.loginId,licenseId:clientDetail.assignedLicenseType,modelName:clientDetail.assignedDeviceModels,existingLicenses:clientDetail.assignedLicenseType,existingModels:clientDetail.assignedDeviceModels});if(clientDetail.defaultBillingFrequency!==null){_this.setState({billingFrequency:{value:clientDetail.defaultBillingFrequency.id,label:clientDetail.defaultBillingFrequency.frequency}});}console.log('billingFrequency=',_this.state.billingFrequency);};_this.handleInputChange=function(e){_this.setState(_defineProperty({},e.target.name,e.target.value));};_this.handleCountryChange=function(country){if(!country){_this.setState({state:'',country:''});}else{_this.setState({state:'',country:country.value});}};_this.handleStateChange=function(state){_this.setState({state:state});};_this.handlePlanChange=function(plan){console.log('plan',plan);if(!plan){_this.setState({plan:''});}else{_this.setState({plan:plan.value});}};_this.handleChangeLicense=function(event){_this.setState({licenseId:event.target.value});// console.log(this.state.licenseId)
};_this.handleChangeModels=function(event){_this.setState({modelName:event.target.value});};_this.handleTimezoneChange=function(timezone){if(!timezone){_this.setState({timezone:''});}else{_this.setState({timezone:timezone.value});}console.log('p',timezone);};_this.handleChangeFreePeriod=function(name){return function(value){var _this$setState2;var total=parseInt(value.target.value,10)+parseInt(_this.state.bufferPeriod,10);_this.setState((_this$setState2={},_defineProperty(_this$setState2,name,value.target.value),_defineProperty(_this$setState2,'totalPeriod',total),_this$setState2));};};_this.handleChangeBufferPeriod=function(name){return function(value){var _this$setState3;var total=parseInt(_this.state.freePeriod,10)+parseInt(value.target.value,10);_this.setState((_this$setState3={},_defineProperty(_this$setState3,name,value.target.value),_defineProperty(_this$setState3,'totalPeriod',total),_this$setState3));};};_this.handleChangeDiscount=function(name){return function(value){_this.setState(_defineProperty({},name,value.target.value));};};_this.handleSelectChange=function(name){return function(value){console.log(value,'value');_this.setState(_defineProperty({},name,value));};};_this.checkNameValidity=function(client){return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(event){var regex,_ref4,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:regex=new RegExp(/^(?!\s)(?!.*\s$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9 '~?!]{2,}$/);_context2.next=3;return client.query({query:GET_RESELLER_NAME,variables:{id:parseInt(_this.state.clientId,10),businessname:_this.state.name}});case 3:_ref4=_context2.sent;data=_ref4.data;// console.log('name', data)
_this.setState({isNameValid:regex.test(_this.state.name)&&_this.state.name!==''&&data.checkResellerName==='AVAILABLE'});case 6:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x){return _ref3.apply(this,arguments);};}();};_this.checkUsernameValidity=function(client){return function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(event){var regex,_ref6,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:// checkUsernameValidity = () => {
regex=new RegExp(/^[a-zA-Z0-9.\-_$@*!]{3,30}$/);_context3.next=3;return client.query({query:GET_USERNAME,variables:{id:parseInt(_this.state.login_id,10),username:_this.state.username}});case 3:_ref6=_context3.sent;data=_ref6.data;_this.setState({isUsernameUnique:data.checkUsername==='AVAILABLE',isUsernameValid:regex.test(_this.state.username)&&_this.state.username!==''&&data.checkUsername==='AVAILABLE'});case 6:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x2){return _ref5.apply(this,arguments);};}();};_this.checkContactpValidity=function(){var regex=new RegExp(/^[a-zA-Z\s]+$/);_this.setState({isContactpValid:regex.test(_this.state.person)&&_this.state.person!==''});};_this.checkPasswordValidity=function(){// const regex = new RegExp(/^((?!.*[\s])(?=.*[A-Z])(?=.*\d).{5,10})/)
var regex=new RegExp(/^[a-zA-Z0-9.\-_$@*!]{3,20}$/);console.log('pass=',regex.test(_this.state.password));_this.setState({isPasswordValid:_this.state.password!==''&&regex.test(_this.state.password)});};_this.checkPhonenoValidity=function(client){return function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(event){var regex,_ref8,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:regex=new RegExp(/^(\+91[-\s]?)?[0]?(91)?[1-9]\d{9,12}$/);_context4.next=3;return client.query({query:GET_CONTACTNO,variables:{id:parseInt(_this.state.clientId,10),phoneno:_this.state.phoneno}});case 3:_ref8=_context4.sent;data=_ref8.data;console.log('phoneno',data);_this.setState({isPhonenoValid:regex.test(_this.state.phoneno)&&_this.state.phoneno!==''&&data.checkResellerContactNumber==='AVAILABLE'});case 7:case'end':return _context4.stop();}}},_callee4,_this2);}));return function(_x3){return _ref7.apply(this,arguments);};}();};_this.checkEmailValidity=function(client){return function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(event){var regex,_ref10,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:regex=new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);_context5.next=3;return client.query({query:GET_EMAIL,variables:{id:parseInt(_this.state.clientId,10),email:_this.state.email}});case 3:_ref10=_context5.sent;data=_ref10.data;_this.setState({isEmailValid:regex.test(_this.state.email)&&_this.state.email!==''&&data.checkResellerEmail==='AVAILABLE'});case 6:case'end':return _context5.stop();}}},_callee5,_this2);}));return function(_x4){return _ref9.apply(this,arguments);};}();};_this.checkAddressValidity=function(){var regex=new RegExp(/^[a-zA-Z0-9\s,.'-]{3,}$/);_this.setState({isAddressValid:regex.test(_this.state.address1)&&_this.state.address1!==''});};_this.submitForm=function(client){return function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(e){var assignedDeviceModel,assignedmodels,assignedLicenseType,assignedlicenses,_ref12,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:e.preventDefault();console.log('this.state.billingFrequency',_this.state.billingFrequency.value);assignedDeviceModel=[];assignedmodels=[];_this.state.modelName.forEach(function(m){var temp={};temp['deviceModelId']=m.id;// temp['manufacturerId'] = 2
assignedDeviceModel.push(temp);assignedmodels.push(m.id);});assignedLicenseType=[];assignedlicenses=[];_this.state.licenseId.forEach(function(l){var temp={};temp['licenseTypeId']=l.id;assignedLicenseType.push(temp);assignedlicenses.push(l.id);});_this.state.existingLicenses.forEach(function(l){if(assignedlicenses.includes(l)){}else{_this.setState({lflag:0});}});_this.state.existingModels.forEach(function(l){if(assignedmodels.includes(l)){}else{_this.setState({mflag:0});}});if(!(_this.state.mflag===0)){_context6.next=14;break;}_this.props.openSnackbar('You cant deassign already assigned models');_context6.next=24;break;case 14:if(!(_this.state.lflag===0)){_context6.next=18;break;}_this.props.openSnackbar('You cant deassign already assigned licenses');_context6.next=24;break;case 18:_context6.next=20;return client.mutate({mutation:UPDATE_RESELLER,variables:{id:parseInt(_this.state.clientId,10),resellerName:_this.state.name,login_id:parseInt(_this.loginId,10),email:_this.state.email,contactPerson:_this.state.person,contactNumber:_this.state.phoneno,address:_this.state.address1+' '+_this.state.address2,city:_this.state.city,state:parseInt(_this.state.state,10),country:parseInt(_this.state.country,10),pincode:parseInt(_this.state.pincode,10),panNumber:_this.state.pan,status:1,loginId:parseInt(_this.state.loginId,10),assignedLicenseType:assignedLicenseType,assignedDeviceModel:assignedDeviceModel,licenseExpiryPeriod:parseInt(_this.state.totalPeriod,10),freePeriod:parseInt(_this.state.freePeriod,10),bufferPeriod:parseInt(_this.state.bufferPeriod,10),billingFrequency:parseInt(_this.state.billingFrequency.value,10),gst:_this.state.gst,discount:parseInt(_this.state.discount,10),username:_this.state.username,password:_this.state.password,accountType:'RES'}});case 20:_ref12=_context6.sent;data=_ref12.data;if(data.setResellerDetails){_this.props.openSnackbar('Updated Successfully');}else{_this.props.openSnackbar('Updation Failed');}_this.setState({clientId:'',name:'',username:'',person:'',password:'',email:'',phoneno:'',address1:'',address2:'',city:'',state:'',country:'',pincode:'',pan:'',gst:'',plan:'',timezone:''});case 24:case'end':return _context6.stop();}}},_callee6,_this2);}));return function(_x5){return _ref11.apply(this,arguments);};}();};_this.cancelForm=function(e){_this.setState({clientId:'',name:'',username:'',person:'',password:'',email:'',phoneno:'',address1:'',address2:'',city:'',state:'',country:'',pincode:'',pan:'',gst:'',plan:'',timezone:''});};_this.loginId=_this.props.match.params.loginId;_this.state={clientId:'',name:'',username:'',person:'',password:'',email:'',phoneno:'',address1:'',address2:'',city:'',state:'',country:'',pincode:'',pan:'',gst:'',plan:'',timezone:'',isEmailValid:true,isPhonenoValid:true,isAddressValid:true,isCityValid:true,isPinValid:true,isPanValid:true,isGSTValid:true,isUsernameValid:true,isNameValid:true,isContactpValid:true,isPasswordValid:true,isUsernameUnique:true,response:false,modelName:[],licenseId:[],billingFrequencies:'',billingFrequency:'',freePeriod:'',bufferPeriod:'',totalPeriod:'',discount:'',loginId:'',existingModels:[],existingLicenses:[],lflag:1,mflag:1};return _this;}_createClass(ResellerEdit,[{key:'componentDidMount',value:function componentDidMount(){this.getClients();}// submitForm = addClient => e => {
},{key:'render',value:function render(){var _this3=this;var _state=this.state,name=_state.name,username=_state.username,person=_state.person,password=_state.password,email=_state.email,phoneno=_state.phoneno,address1=_state.address1,address2=_state.address2,city=_state.city,state=_state.state,country=_state.country,pincode=_state.pincode,pan=_state.pan,gst=_state.gst;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_apollo__["ApolloConsumer"],null,function(client){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_apollo__["Query"],{query:GET_BILLING_FREQUENCY,variables:{billingModeId:1}},function(_ref13){var isBillingLoading=_ref13.loading,error=_ref13.error,billing=_ref13.data.billing;if(isBillingLoading)return'Loading';if(error)return'Error!: '+error;var billingFrequencies=billing.map(function(billFrq){return{value:billFrq.id,label:billFrq.frequency};});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_apollo__["Mutation"],{mutation:UPDATE_RESELLER},function(addClient,_ref14){var data=_ref14.data,error=_ref14.error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Button___default.a,{variant:'outlined',color:'secondary',className:classes.button// onClick={() => this.viewSubscription(this.backUrl)}
,onClick:function onClick(){return _this3.props.history.goBack();}// href={'/home/customers/view/' + this.loginId}
},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_icons_ArrowBack___default.a,{className:classes.iconSmall})),' ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'title'},'Edit Reseller')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a// autoComplete="username"
,{name:'name',value:name,type:'text',onChange:_this3.handleInputChange,label:'Full Name',required:true// error={!isUsernameValid}
// onBlur={this.checkUsernameValidity}
// label={!isUsernameValid ? 'Invalid Username' : ''}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a// autoComplete="username"
,{name:'username',value:username,type:'text',onChange:_this3.handleInputChange,label:'Username',required:true// error={!isUsernameValid}
// onBlur={this.checkUsernameValidity}
// label={!isUsernameValid ? 'Invalid Username' : ''}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a// autoComplete="username"
,{name:'person',value:person,type:'text',onChange:_this3.handleInputChange,label:'Contact Person',required:true// error={!isUsernameValid}
// onBlur={this.checkUsernameValidity}
// label={!isUsernameValid ? 'Invalid Username' : ''}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a// autoComplete="username"
,{name:'password',value:password,type:'password',onChange:_this3.handleInputChange,label:'Password',error:!_this3.state.isNameValid,onBlur:_this3.checkNameValidity(client)}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a// autoComplete="username"
,{name:'email',value:email,type:'text',onChange:_this3.handleInputChange,label:'Email',required:true// error={!isUsernameValid}
// onBlur={this.checkUsernameValidity}
// label={!isUsernameValid ? 'Invalid Username' : ''}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_select__["a" /* default */],{classes:classes,options:billingFrequencies,value:_this3.state.billingFrequency,onChange:_this3.handleSelectChange('billingFrequency'),placeholder:'Billing Frequency'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a// autoComplete="username"
,{name:'phoneno',value:phoneno,type:'text',onChange:_this3.handleInputChange,label:'Phone Number',required:true// error={!isUsernameValid}
// onBlur={this.checkUsernameValidity}
// label={!isUsernameValid ? 'Invalid Username' : ''}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Modules_LicensesList__["a" /* default */],{handleChangeLicense:_this3.handleChangeLicense,licenseId:_this3.state.licenseId,handleChangeModels:_this3.handleChangeModels,modelName:_this3.state.modelName})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Modules_CustomTabs__["a" /* default */],{address1:address1,address2:address2,city:city,state:state,country:country,pincode:pincode,pan:pan,gst:gst,handleInputChange:_this3.handleInputChange,handleCountryChange:_this3.handleCountryChange,handleStateChange:_this3.handleStateChange,isAddressValid:_this3.state.isAddressValid,isCityValid:_this3.state.isCityValid,isPinValid:_this3.state.isPinValid,isPanValid:_this3.state.isPanValid,isGSTValid:_this3.state.isGSTValid})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a,{id:'standard-number',label:'Free Period (Months)',value:_this3.state.freePeriod,onChange:_this3.handleChangeFreePeriod('freePeriod'),type:'number',className:classes.textField,margin:'normal'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a,{id:'standard-number',label:'Buffer Period (Months)',value:_this3.state.bufferPeriod,onChange:_this3.handleChangeBufferPeriod('bufferPeriod'),type:'number',className:classes.textField,margin:'normal'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a,{id:'standard-number',label:'Total No of Months',value:_this3.state.totalPeriod,type:'text',disabled:true,className:classes.textField,margin:'normal'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a,{id:'standard-number',label:'Discount in %',value:_this3.state.discount,onChange:_this3.handleChangeDiscount('discount'),type:'number',className:classes.textField,margin:'normal'})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,xs:12,justify:'space-evenly'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Button___default.a,{color:'primary',variant:'flat'// className={this.classes.button}
,onClick:_this3.submitForm(client)},'Save',' ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Button___default.a,{color:'inherit'// className={this.classes.button}
,onClick:_this3.cancelForm},'Cancel',' ')))));});});});}}]);return ResellerEdit;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var withApolloClient=function withApolloClient(Component){return function(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_apollo__["ApolloConsumer"],null,function(client){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component,Object.assign({client:client},props));});};};ResellerEdit.propTypes={classes:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__["withStyles"])(styles)(withApolloClient(Object(__WEBPACK_IMPORTED_MODULE_15__HOCs_withSharedSnackbar__["a" /* default */])(ResellerEdit))));

/***/ }),
/* 2339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Menu__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Menu__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query allPartnerDetails($status: Int) {\n    clients: allPartnerDetails(status: $status) {\n      businessName\n      email\n      contactNumber\n      contactPerson\n      login {\n        loginId\n      }\n    }\n  }\n'],['\n  query allPartnerDetails($status: Int) {\n    clients: allPartnerDetails(status: $status) {\n      businessName\n      email\n      contactNumber\n      contactPerson\n      login {\n        loginId\n      }\n    }\n  }\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_PARTNER=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject);var style=function style(theme){return{root:{padding:theme.spacing.unit*4,flexGrow:1},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},iconSmall:{fontSize:20}};};var Partner=function(_Component){_inherits(Partner,_Component);function Partner(props){_classCallCheck(this,Partner);var _this=_possibleConstructorReturn(this,(Partner.__proto__||Object.getPrototypeOf(Partner)).call(this,props));_this.loginId=[];_this.fullData=[];_this.columns=['COMPANY NAME','CONTACT PERSON','EMAIL','PHONE NUMBER'];_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15,onRowClick:function onRowClick(rowData,dataIndex,rowIndex){console.log('login Id',_this.loginId);_this.props.history.push({pathname:'/home/partner/view/'+_this.loginId[dataIndex.dataIndex]});}};_this.addCustomer=function(e){_this.props.history.push({pathname:'/home/add-partner'});};_this.classes=props;return _this;}_createClass(Partner,[{key:'mapToArr',value:function mapToArr(clients){var _this2=this;var rowData=[];this.fullData=[];this.loginId=[];clients.forEach(function(element){rowData=[];_this2.loginId.push(element.login.loginId);rowData.push(element.businessName);rowData.push(element.contactPerson);rowData.push(element.email);rowData.push(element.contactNumber);_this2.fullData.push(rowData);});}},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["Query"],{query:GET_PARTNER,variables:{status:1},fetchPolicy:'network-only'},function(_ref){var loading=_ref.loading,error=_ref.error,clients=_ref.data.clients;if(loading)return'Loading...';if(error)return'Error!: '+error;_this3.mapToArr(clients);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row-reverse',justify:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default.a,{color:'secondary',onClick:_this3.addCustomer,variant:'raised',className:_this3.classes.button},'Add Partner'),'  ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default.a,{variant:'outlined',className:classes.button},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Menu___default.a,{className:classes.iconSmall}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'headline'},'Partner Details'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_mui_datatables___default.a,{data:_this3.fullData,columns:_this3.columns,options:_this3.options}))));});}}]);return Partner;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["withStyles"])(style)(Partner));

/***/ }),
/* 2340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Menu__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Menu__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getAllManufacturer {\n    clients: getAllManufacturer {\n      manufacturerName\n      email\n      contactNumber\n      contactPerson\n      id\n    }\n  }\n'],['\n  query getAllManufacturer {\n    clients: getAllManufacturer {\n      manufacturerName\n      email\n      contactNumber\n      contactPerson\n      id\n    }\n  }\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_MANUFACTURER=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject);var style=function style(theme){return{root:{padding:theme.spacing.unit*4,flexGrow:1},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},iconSmall:{fontSize:20}};};var Manufacturer=function(_Component){_inherits(Manufacturer,_Component);function Manufacturer(props){_classCallCheck(this,Manufacturer);var _this=_possibleConstructorReturn(this,(Manufacturer.__proto__||Object.getPrototypeOf(Manufacturer)).call(this,props));_this.loginId=[];_this.fullData=[];_this.columns=['COMPANY NAME','CONTACT PERSON','EMAIL','PHONE NUMBER'];_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15,onRowClick:function onRowClick(rowData,dataIndex,rowIndex){_this.props.history.push({pathname:'/home/reseller/view/'+_this.loginId[dataIndex.dataIndex]});}};_this.addCustomer=function(e){_this.props.history.push({pathname:'/home/add-manufacturer'});};_this.classes=props;return _this;}_createClass(Manufacturer,[{key:'mapToArr',value:function mapToArr(clients){var _this2=this;var rowData=[];this.fullData=[];this.loginId=[];clients.forEach(function(element){rowData=[];_this2.loginId.push(element.id);rowData.push(element.manufacturerName);rowData.push(element.contactPerson);rowData.push(element.email);rowData.push(element.contactNumber);_this2.fullData.push(rowData);});}},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["Query"],{query:GET_MANUFACTURER},function(_ref){var loading=_ref.loading,error=_ref.error,clients=_ref.data.clients;if(loading)return'Loading...';if(error)return'Error!: '+error;console.log('man',clients);_this3.mapToArr(clients);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row-reverse',justify:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default.a,{color:'secondary',onClick:_this3.addCustomer,variant:'raised',className:_this3.classes.button},'Add Manufacturer'),'  ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default.a,{variant:'outlined',className:classes.button},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Menu___default.a,{className:classes.iconSmall}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'headline'},'Manufacturer Details'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_mui_datatables___default.a,{data:_this3.fullData,columns:_this3.columns,options:_this3.options}))));});}}]);return Manufacturer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["withStyles"])(style)(Manufacturer));

/***/ }),
/* 2341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__EditLicense_jsx__ = __webpack_require__(2342);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getAllLicenseType($status: Int) {\n    getAllLicenseType(status: $status) {\n      id\n      licenseType\n      description\n      featureList {\n        id\n        featureName\n        costPerAssetPerMonth\n        featureDescription\n      }\n      maxPrice\n    }\n  }\n'],['\n  query getAllLicenseType($status: Int) {\n    getAllLicenseType(status: $status) {\n      id\n      licenseType\n      description\n      featureList {\n        id\n        featureName\n        costPerAssetPerMonth\n        featureDescription\n      }\n      maxPrice\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query getLicenseType($id: Int!) {\n    getLicenseType(id: $id) {\n      licenseType\n      description\n      maxPrice\n      featureList {\n        id\n      }\n    }\n  }\n'],['\n  query getLicenseType($id: Int!) {\n    getLicenseType(id: $id) {\n      licenseType\n      description\n      maxPrice\n      featureList {\n        id\n      }\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var styles=function styles(theme){return{root:{flexGrow:1,padding:theme.spacing.unit*2},paper:{width:'100%'},control:{padding:theme.spacing.unit*1},button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{margin:theme.spacing.unit,minWidth:120}};};var GET_ALL_LICENSE_TYPE=Object(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__["a" /* default */])(_templateObject);var GET_LICENCE_BY_ID=Object(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__["a" /* default */])(_templateObject2);var ViewLicense=function(_Component){_inherits(ViewLicense,_Component);function ViewLicense(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,ViewLicense);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ViewLicense.__proto__||Object.getPrototypeOf(ViewLicense)).call.apply(_ref,[this].concat(args))),_this),_this.state={licenceArr:[],renderArr:[],licenseDetails:[],modelStatus:false,lId:''},_this.getAllLicenses=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var licenses;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:console.log('hi');_context.next=3;return _this.props.client.query({query:GET_ALL_LICENSE_TYPE,variables:{status:1}});case 3:licenses=_context.sent;if(licenses&&licenses.data){_this.mapToArr(licenses.data.getAllLicenseType);}case 5:case'end':return _context.stop();}}},_callee,_this2);})),_this.columns=['LICENSE NAME','DESCRIPTION','MAX PRICE ( in Rs )','EDIT'],_this.createPlan=function(e){_this.props.history.push({pathname:'/home/CreatePlan'});},_this.editLicenceInfo=function(licenseId){return _asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var _ref4,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:console.log('licenseId=',licenseId);_context2.next=3;return _this.props.client.query({query:GET_LICENCE_BY_ID,variables:{id:parseInt(licenseId,10)}});case 3:_ref4=_context2.sent;data=_ref4.data;console.log(data);_this.setState({licenseDetails:data,modelStatus:true,lId:licenseId},function(){console.log(_this.state.licenseDetails,_this.state.modelStatus);console.log('lId4=',_this.state.lId);// this.state.modelDetails.deviceModel.map(element =>
//   console.log('sdsdsds= ', element.model_name)
// )
});case 7:case'end':return _context2.stop();}}},_callee2,_this2);}));},_this.closeEditModel=function(){_this.setState({modelStatus:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ViewLicense,[{key:'componentDidMount',value:function componentDidMount(){this.getAllLicenses();}},{key:'mapToArr',value:function mapToArr(licenses){var _this3=this;var rowData=[];this.fullData=[];this.loginId=[];licenses.forEach(function(element){rowData=[];rowData.push(element.licenseType);rowData.push(element.description);rowData.push(element.maxPrice);rowData.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:_this3.editLicenceInfo(element.id)},'Edit'));_this3.fullData.push(rowData);});this.setState({renderArr:this.fullData});}},{key:'render',value:function render(){console.log('this.state.licenseDetails1=',this.state.licenseDetails);var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row-reverse',justify:'space-between'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:this.createPlan,variant:'raised',color:'secondary'},'Create License'),'  '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Typography"],{variant:'headline'},'Licences'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_mui_datatables___default.a,{data:this.state.renderArr,columns:this.columns// options={this.options}
})),this.state.modelStatus===true&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__EditLicense_jsx__["a" /* default */],{licenseInfo:this.state.licenseDetails,openStatus:this.state.modelStatus,closeEditModelFunction:this.closeEditModel,selectedId:this.state.lId}))));}}]);return ViewLicense;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_5_react_apollo__["withApollo"])(ViewLicense)));

/***/ }),
/* 2342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Modal__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogActions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogContent__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_DialogContentText__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_DialogContentText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_DialogContentText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__HOCs_withSharedSnackbar__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  mutation updateLicenseType(\n    $id: Int!\n    $licenseType: String!\n    $description: String!\n    $featureList: String!\n    $maxPrice: Int!\n    $status: Int!\n  ) {\n    updateLicenseType(\n      id: $id\n      licenseType: $licenseType\n      description: $description\n      featureList: $featureList\n      maxPrice: $maxPrice\n      status: $status\n    )\n  }\n'],['\n  mutation updateLicenseType(\n    $id: Int!\n    $licenseType: String!\n    $description: String!\n    $featureList: String!\n    $maxPrice: Int!\n    $status: Int!\n  ) {\n    updateLicenseType(\n      id: $id\n      licenseType: $licenseType\n      description: $description\n      featureList: $featureList\n      maxPrice: $maxPrice\n      status: $status\n    )\n  }\n']);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var UPDATE_LICENSE_TYPE=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject);function getModalStyle(){var top=50;var left=50;return{top:top+'%',left:left+'%',transform:'translate(-'+top+'%, -'+left+'%)'};}var styles=function styles(theme){return{paper:{position:'absolute',width:theme.spacing.unit*50,backgroundColor:theme.palette.background.paper,boxShadow:theme.shadows[5],padding:theme.spacing.unit*4}};};var EditLicense=function(_React$Component){_inherits(EditLicense,_React$Component);function EditLicense(props){_classCallCheck(this,EditLicense);var _this=_possibleConstructorReturn(this,(EditLicense.__proto__||Object.getPrototypeOf(EditLicense)).call(this,props));_this.checkedlist=[];_this.handleSubmit=function(EditModel){return function(e){e.preventDefault();EditModel({variables:{id:parseInt(_this.state.licenseId,10),licenseType:_this.state.licenseType,description:_this.state.description,featureList:JSON.stringify(_this.checkedlist),maxPrice:parseInt(_this.state.maxPrice,10),status:1}});_this.setState({id:'',licenseType:'',description:'',featureList:'',maxPrice:''});_this.props.closeEditModelFunction();_this.props.openSnackbar('License Updated Successfully');};};_this.checkModelNameValidity=function(){var regex=new RegExp(// eslint-disable-next-line
/^(?!\s)(?!.*\s$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9 '~?!]{2,}$/);_this.setState({isModelNameValid:regex.test(_this.state.modelname)||_this.state.modelname===''});};_this.checkmaxPriceValidity=function(){var regex=new RegExp(/^[0-9]{2,4}$/);_this.setState({ismaxPriceValid:regex.test(_this.state.maxPrice)||_this.state.maxPrice===''});};_this.checkVersionValidity=function(){var regex=new RegExp(// eslint-disable-next-line
// 1-3 dot-separated components, each numeric except that the last one may be *
/^(\d+\.)?(\d+\.)?(\*|\d+)$/);_this.setState({isVersionValid:regex.test(_this.state.version)||_this.state.version===''});};_this.checkDeviceTypeValidity=function(){return _this.setState({isDeviceTypeValid:_this.state.devicetype!==''});};_this.handleInputChange=function(key){return function(e){return _this.setState(_defineProperty({},key,e.target.value));};};_this.handleOpenSelect=function(){return _this.setState({open1:true});};_this.handleCloseSelect=function(){return _this.setState({open1:false});};_this.handleChange=function(event){return _this.setState(_defineProperty({},event.target.name,event.target.value));};_this.licenseInformation=_this.props.licenseInfo.getLicenseType;_this.state={licenseType:_this.licenseInformation.licenseType,description:_this.licenseInformation.description,maxPrice:_this.licenseInformation.maxPrice,licenseId:_this.props.selectedId,open1:false,isLicenseNameValid:true,featureList:_this.licenseInformation.featureList,returnFeatureList:''};return _this;}_createClass(EditLicense,[{key:'mapToArr',value:function mapToArr(feature){var _this2=this;// let checkedlist = []
feature.forEach(function(element){// console.log('s=function', element)
var temp={};temp['featureId']=element.id;_this2.checkedlist.push(temp);});}},{key:'componentDidMount',value:function componentDidMount(){this.mapToArr(this.state.featureList);}},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default.a,null,'Edit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Modal___default.a,{'aria-labelledby':'simple-modal-title','aria-describedby':'simple-modal-description',open:this.props.openStatus},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:getModalStyle(),className:classes.paper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["Mutation"],{mutation:UPDATE_LICENSE_TYPE,errorPolicy:'all'},function(EditLicense,_ref){var data=_ref.data,loading=_ref.loading,error=_ref.error;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:_this3.handleSubmit(EditLicense)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_DialogContentText___default.a,null,'* Marked fields are mandatory'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'licenseType',name:'licenseType',label:'License Name',type:'text',required:true,value:_this3.state.licenseType,fullWidth:true,onChange:_this3.handleInputChange('licenseType')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'description',label:'Description',type:'text',required:true,value:_this3.state.description,onChange:_this3.handleInputChange('description')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'maxPrice',label:'Max Price',type:'text',required:true,value:_this3.state.maxPrice,onChange:_this3.handleInputChange('maxPrice'),error:!_this3.state.maxPrice,onBlur:_this3.checkmaxPriceValidity}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogActions___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default.a,{onClick:_this3.props.closeEditModelFunction,color:'default',variant:'contained'},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default.a,{color:'primary',variant:'contained',type:'submit'},'Submit')));}))));}}]);return EditLicense;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);EditLicense.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired// We need an intermediary variable for handling the recursive nesting.
};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_12__HOCs_withSharedSnackbar__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["withApollo"])(EditLicense))));

/***/ }),
/* 2343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StatusCard_jsx__ = __webpack_require__(2344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_apollo__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getAllPurchaseRequestInfo {\n    allPrs: getAllPurchaseRequestInfo {\n      id\n      status\n      reseller {\n        resellerName\n      }\n      licenseTypeList {\n        id\n        maxPrice\n      }\n      deviceModelList {\n        id\n        model_name\n      }\n      createdAt\n    }\n  }\n'],['\n  query getAllPurchaseRequestInfo {\n    allPrs: getAllPurchaseRequestInfo {\n      id\n      status\n      reseller {\n        resellerName\n      }\n      licenseTypeList {\n        id\n        maxPrice\n      }\n      deviceModelList {\n        id\n        model_name\n      }\n      createdAt\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ALL_PURCHASE_REQUESTS=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject);var style=function style(theme){return{root:{padding:theme.spacing.unit*2,flexGrow:1}};};var ManagePurchaseRequests=function(_Component){_inherits(ManagePurchaseRequests,_Component);function ManagePurchaseRequests(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ManagePurchaseRequests);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ManagePurchaseRequests.__proto__||Object.getPrototypeOf(ManagePurchaseRequests)).call.apply(_ref,[this].concat(args))),_this),_this.handleClick=function(title){var clickStatus={Pending:false,Processed:false,Approved:false,Cancelled:false,'Partially Executed':false,Completed:false};clickStatus[title]=true;_this.setState({clickStatus:clickStatus,currentlySelected:title});},_this.columns=['RESELLER','MODEL TYPES','LICENSE TYPES','RAISED ON'],_this.tableOptions={selectableRows:false,responsive:'scroll',rowsPerPage:5,onRowClick:function onRowClick(rowData,dataIndex){var index=dataIndex.dataIndex;if(_this.state.currentlySelected==='Pending'){_this.props.history.push({pathname:'/home/manage/purchase-requests/pending/'+_this.state.data[_this.state.currentlySelected].ids[index]});}else if(_this.state.currentlySelected==='Approved'||_this.state.currentlySelected==='Partially Executed'){_this.props.history.push({pathname:'/home/manage/purchase-requests/approved/'+_this.state.data[_this.state.currentlySelected].ids[index]});}else{_this.props.history.push({pathname:'/home/manage/purchase-requests/view/'+_this.state.data[_this.state.currentlySelected].ids[index]});}}},_this.state={clickStatus:{Pending:false,Processed:false,Approved:false,Cancelled:false,'Partially Executed':false,Completed:false},data:{Pending:{ids:[],data:[]},Processed:{ids:[],data:[]},Approved:{ids:[],data:[]},Cancelled:{ids:[],data:[]},'Partially Executed':{ids:[],data:[]},Completed:{ids:[],data:[]}},currentlySelected:'Pending'},_this.getTableData=function(purchaseReq){var tempArr=[];tempArr.push(purchaseReq.reseller.resellerName.toString());tempArr.push(purchaseReq.deviceModelList.length.toString());tempArr.push(purchaseReq.licenseTypeList.length.toString());tempArr.push(__WEBPACK_IMPORTED_MODULE_9_moment___default.a.unix(purchaseReq.createdAt).format('DD/MM/YYYY').toString());return tempArr;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ManagePurchaseRequests,[{key:'componentDidMount',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _this2=this;var _ref3,data,prData,clickStatus;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return this.props.client.query({query:ALL_PURCHASE_REQUESTS});case 2:_ref3=_context.sent;data=_ref3.data;data=data.allPrs;// init final data
prData={Pending:{ids:[],data:[]},Processed:{ids:[],data:[]},Approved:{ids:[],data:[]},Cancelled:{ids:[],data:[]},'Partially Executed':{ids:[],data:[]},Completed:{ids:[],data:[]}// prep data in the format required
};data.forEach(function(purchaseReq){switch(purchaseReq.status){case 1:prData['Pending'].ids.push(purchaseReq.id);prData['Pending'].data.push(_this2.getTableData(purchaseReq));break;case 2:prData['Processed'].ids.push(purchaseReq.id);prData['Processed'].data.push(_this2.getTableData(purchaseReq));break;case 3:prData['Approved'].ids.push(purchaseReq.id);prData['Approved'].data.push(_this2.getTableData(purchaseReq));break;case-1:prData['Cancelled'].ids.push(purchaseReq.id);prData['Cancelled'].data.push(_this2.getTableData(purchaseReq));break;case 4:prData['Partially Executed'].ids.push(purchaseReq.id);prData['Partially Executed'].data.push(_this2.getTableData(purchaseReq));break;case 5:prData['Completed'].ids.push(purchaseReq.id);prData['Completed'].data.push(_this2.getTableData(purchaseReq));break;default:break;}});// initialize click status
clickStatus={Pending:true,Processed:false,Approved:false,Cancelled:false,'Partially Executed':false,Completed:false};this.setState({clickStatus:clickStatus,data:prData,currentlySelected:'Pending'});case 9:case'end':return _context.stop();}}},_callee,this);}));function componentDidMount(){return _ref2.apply(this,arguments);}return componentDidMount;}()},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;var categories=[{title:'Pending',description:'Shows a list of purchase requests sent by the reseller'},{title:'Processed',description:'Shows a list of purchase requests to be approved by the super admin'},{title:'Approved',description:'Shows a list of purchase requests approved by the reseller'},{title:'Cancelled',description:'Shows a list of all purchase requests which have been cancelled by the reseller'},{title:'Partially Executed',description:'Shows a list of all purchase requests which have been partially serviced by the super admin'},{title:'Completed',description:'Shows a list of all purchase requests which have been completely serviced by the super admin'}];return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'headline'},'Purchase Requests'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'caption'},'Manage all purchase requests received from resellers')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12,container:true,spacing:16,direction:'row'},categories.map(function(category){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__StatusCard_jsx__["a" /* default */],{title:category.title,tooltip:category.description,handleClick:_this3.handleClick,isClicked:_this3.state.clickStatus[category.title],count:_this3.state.data[category.title].ids.length}));})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},this.state.currentlySelected!==null?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_mui_datatables___default.a,{data:this.state.data[this.state.currentlySelected].data,columns:this.columns,options:this.tableOptions,title:this.state.currentlySelected}):null)));}}]);return ManagePurchaseRequests;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_10_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_6__HOCs_withSharedSnackbar__["a" /* default */])(ManagePurchaseRequests))));

/***/ }),
/* 2344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Card__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_CardContent__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_CardContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_CardContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Tooltip__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Tooltip__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var style=function style(theme){return{title:{fontSize:14},card:{width:'100%',textAlign:'center'},customWidth:{maxWidth:300},buttonBase:{width:'100%',textAlign:'left'},pos:{marginBottom:12}};};var StatusCard=function(_Component){_inherits(StatusCard,_Component);function StatusCard(){_classCallCheck(this,StatusCard);return _possibleConstructorReturn(this,(StatusCard.__proto__||Object.getPrototypeOf(StatusCard)).apply(this,arguments));}_createClass(StatusCard,[{key:'render',value:function render(){var _this2=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["ButtonBase"],{className:classes.buttonBase,onClick:function onClick(){return _this2.props.handleClick(_this2.props.title);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Tooltip___default.a,{title:this.props.tooltip,classes:{tooltip:classes.customWidth}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Card___default.a,{className:classes.card,raised:!this.props.isClicked},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'body2'},this.props.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'title',color:'error'},this.props.count)))));}}]);return StatusCard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__["withStyles"])(style)(StatusCard));

/***/ }),
/* 2345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Checkbox__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_apollo__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getPurchaseRequestInfo($id: Int!) {\n    prInfo: getPurchaseRequestInfo(id: $id) {\n      reseller {\n        resellerName\n      }\n      licenseTypeList {\n        id\n        licenseType\n        maxPrice\n        requestedQuantity\n        finalPrice\n        gst\n        totalPrice\n      }\n      deviceModelList {\n        id\n        model_name\n        maxPrice\n        requestedQuantity\n        finalPrice\n        gst\n        totalPrice\n      }\n    }\n  }\n'],['\n  query getPurchaseRequestInfo($id: Int!) {\n    prInfo: getPurchaseRequestInfo(id: $id) {\n      reseller {\n        resellerName\n      }\n      licenseTypeList {\n        id\n        licenseType\n        maxPrice\n        requestedQuantity\n        finalPrice\n        gst\n        totalPrice\n      }\n      deviceModelList {\n        id\n        model_name\n        maxPrice\n        requestedQuantity\n        finalPrice\n        gst\n        totalPrice\n      }\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  mutation revertPurchaseRequestWithFinalPrice(\n    $purchaseRequestId: Int!\n    $licenseTypeList: [LicenseTypeRequest!]!\n    $deviceModelList: [DeviceModelRequest!]!\n    $isPreApproved: Boolean!\n  ) {\n    revertPurchaseRequestWithFinalPrice(\n      purchaseRequestId: $purchaseRequestId\n      licenseTypeList: $licenseTypeList\n      deviceModelList: $deviceModelList\n      isPreApproved: $isPreApproved\n    )\n  }\n'],['\n  mutation revertPurchaseRequestWithFinalPrice(\n    $purchaseRequestId: Int!\n    $licenseTypeList: [LicenseTypeRequest!]!\n    $deviceModelList: [DeviceModelRequest!]!\n    $isPreApproved: Boolean!\n  ) {\n    revertPurchaseRequestWithFinalPrice(\n      purchaseRequestId: $purchaseRequestId\n      licenseTypeList: $licenseTypeList\n      deviceModelList: $deviceModelList\n      isPreApproved: $isPreApproved\n    )\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_PURCHASE_REQUEST=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject);var REVERT_WITH_PRICE=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject2);var style=function style(theme){return{root:{padding:theme.spacing.unit*2,flexGrow:1}};};var ApprovePurchaseRequest=function(_Component){_inherits(ApprovePurchaseRequest,_Component);function ApprovePurchaseRequest(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,ApprovePurchaseRequest);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ApprovePurchaseRequest.__proto__||Object.getPrototypeOf(ApprovePurchaseRequest)).call.apply(_ref,[this].concat(args))),_this),_this.state={models:[],licenses:[],preApproved:false,purchaseRequestId:null},_this.handleSelectChange=function(type,index){return function(value){if(type==='model'){var currModels=_this.state.models;if(value){currModels[index].gst=value.value;}else{currModels[index].gst=null;}_this.setState({models:currModels},function(){_this.calculateTotalPrice('model',index);});}else if(type==='license'){var currLicenses=_this.state.licenses;if(value){currLicenses[index].gst=value.value;}else{currLicenses[index].gst=null;}_this.setState({licenses:currLicenses},function(){_this.calculateTotalPrice('license',index);});}};},_this.handleChange=function(type,index){return function(event){var value=event.target.value;if(type==='model'){var currModels=_this.state.models;if(value>=0){currModels[index].finalPrice=value;}_this.setState({models:currModels},function(){_this.calculateTotalPrice('model',index);});}else if(type==='license'){var currLicenses=_this.state.licenses;if(value>=0){currLicenses[index].finalPrice=value;}_this.setState({licenses:currLicenses},function(){_this.calculateTotalPrice('license',index);});}};},_this.handlePreApproval=function(event){_this.setState({preApproved:event.target.checked});},_this.handleBack=function(event){_this.props.history.goBack();},_this.handleSubmit=function(name){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var errorModel,errorLicense,i,j,finalModels,finalLicenses,_ref3,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:// check if all fields are filled
errorModel=false;errorLicense=false;for(i=0;i<_this.state.models.length;i++){if(!(_this.state.models[i].gst&&_this.state.models[i].finalPrice)){errorModel=true;}}for(j=0;j<_this.state.licenses.length;j++){if(!(_this.state.licenses[j].gst&&_this.state.licenses[j].finalPrice)){errorLicense=true;}}if(!(errorLicense||errorModel)){_context.next=8;break;}_this.props.openSnackbar('All details should be filled');_context.next=17;break;case 8:// Prep data in the necessary format
finalModels=[];finalLicenses=[];_this.state.models.forEach(function(model){var tempModel={};tempModel.deviceModelId=parseInt(model.id,10);tempModel.quantity=parseInt(model.qty,10);tempModel.assignedQuantity=0;tempModel.finalPrice=parseInt(model.finalPrice,10);tempModel.gst=model.gst;tempModel.totalPrice=parseInt(model.totalPrice,10);finalModels.push(tempModel);});_this.state.licenses.forEach(function(license){var tempLicense={};tempLicense.licenseTypeId=license.id;tempLicense.quantity=parseInt(license.qty,10);tempLicense.assignedQuantity=0;tempLicense.finalPrice=parseInt(license.finalPrice,10);tempLicense.gst=license.gst;tempLicense.totalPrice=parseInt(license.totalPrice,10);finalLicenses.push(tempLicense);});// Mutation here
_context.next=14;return _this.props.client.mutate({mutation:REVERT_WITH_PRICE,variables:{purchaseRequestId:parseInt(_this.state.purchaseRequestId,10),licenseTypeList:finalLicenses,deviceModelList:finalModels,isPreApproved:_this.state.preApproved}});case 14:_ref3=_context.sent;data=_ref3.data;if(data.revertPurchaseRequestWithFinalPrice===true){if(_this.state.preApproved===true){_this.props.openSnackbar('Purchase Request Pre Approval Successful');_this.props.history.push({pathname:'/home/manage/purchase-requests/approved/'+_this.state.purchaseRequestId});}else{_this.props.openSnackbar('Purchase Request Submission Successful');_this.props.history.push({pathname:'/home/manage/purchase-requests'});}}else{_this.props.openSnackbar('Purchase Request Submission Failed. Try Again');}case 17:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ApprovePurchaseRequest,[{key:'componentDidMount',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var purchaseRequestId,_ref5,data,deviceDetails,licenseDetails;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:purchaseRequestId=this.props.match.params.purchaseRequestId;// Query to get all relevant information of purchase request
_context2.next=3;return this.props.client.query({query:GET_PURCHASE_REQUEST,variables:{id:parseInt(purchaseRequestId,10)}});case 3:_ref5=_context2.sent;data=_ref5.data;data=data.prInfo;deviceDetails=[];licenseDetails=[];data.deviceModelList.forEach(function(device){var tempObject={};tempObject.id=device.id;tempObject.name=device.model_name;tempObject.maxPrice=device.maxPrice;tempObject.qty=device.requestedQuantity;tempObject.finalPrice=device.finalPrice;tempObject.gst=device.gst;tempObject.totalPrice=device.totalPrice;deviceDetails.push(tempObject);});data.licenseTypeList.forEach(function(license){var tempObject={};tempObject.id=license.id;tempObject.name=license.licenseType;tempObject.maxPrice=license.maxPrice;tempObject.qty=license.requestedQuantity;tempObject.finalPrice=license.finalPrice;tempObject.gst=license.gst;tempObject.totalPrice=license.totalPrice;licenseDetails.push(tempObject);});this.setState({models:deviceDetails,licenses:licenseDetails,purchaseRequestId:purchaseRequestId});case 11:case'end':return _context2.stop();}}},_callee2,this);}));function componentDidMount(){return _ref4.apply(this,arguments);}return componentDidMount;}()},{key:'calculateTotalPrice',value:function calculateTotalPrice(type,index){if(type==='model'){var currModels=this.state.models;var finalPrice=parseInt(currModels[index].finalPrice,10);if(finalPrice>0&&currModels[index].gst){currModels[index].totalPrice=finalPrice*currModels[index].gst+finalPrice;}else{currModels[index].totalPrice=null;}this.setState({models:currModels});}else if(type==='license'){var currLicenses=this.state.licenses;var _finalPrice=parseInt(currLicenses[index].finalPrice,10);if(_finalPrice>0&&currLicenses[index].gst){currLicenses[index].totalPrice=_finalPrice*currLicenses[index].gst+_finalPrice;}else{currLicenses[index].totalPrice=null;}this.setState({license:currLicenses});}}},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;var gstRates=[{value:0.05,label:'5%'},{value:0.1,label:'10%'},{value:0.15,label:'15%'},{value:0.18,label:'18%'}];return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{color:'primary',variant:'raised',onClick:this.handleBack},'Back')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'headline'},'Purchase Request')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'title'},'Device Model(s)')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,xs:12,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading'},'Model')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading'},'Maximum Price')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading'},'Quantity')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading'},'Final Price')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading'},'GST')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading'},'Total Price'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Divider___default.a,null)),this.state.models.map(function(model,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,xs:12,spacing:24,direction:'row',key:index},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading'},model.name)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading'},model.maxPrice)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading'},model.qty)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a,{placeholder:'Final Price',value:model.finalPrice,onChange:_this3.handleChange('model',index),type:'number'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:1}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_select__["a" /* default */],{placeholder:'Select GST %',classes:classes,options:gstRates,value:model.gst,onChange:_this3.handleSelectChange('model',index)})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading'},model.totalPrice)));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'title'},'License(s)')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,xs:12,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading'},'License')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading'},'Maximum Price')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading'},'Quantity')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading'},'Final Price')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading'},'GST')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading'},'Total Price'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Divider___default.a,null)),this.state.licenses.map(function(license,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,xs:12,spacing:16,direction:'row',key:index},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading'},license.name)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading'},license.maxPrice)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading'},license.qty)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a,{placeholder:'Final Price',value:license.finalPrice,onChange:_this3.handleChange('license',index),type:'number'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:1}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_select__["a" /* default */],{placeholder:'Select GST %',classes:classes,options:gstRates,value:license.gst,onChange:_this3.handleSelectChange('license',index)})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading'},license.totalPrice)));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12,container:true,spacing:16,direction:'row',alignItems:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Checkbox___default.a,{checked:this.state.preApproved,onChange:this.handlePreApproval,value:'pre-approved'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading'},'Pre approve this purchase request'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,xs:12,spacing:16,direction:'row',justify:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{color:'secondary',variant:'raised',onClick:this.handleSubmit('Submit'),disabled:this.state.preApproved},'Submit for Approval')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{color:'primary',variant:'raised',onClick:this.handleCancel},'Cancel')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{color:'secondary',variant:'raised',onClick:this.handleSubmit('Assign'),disabled:!this.state.preApproved},'Proceed to device assignment')))));}}]);return ApprovePurchaseRequest;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_12_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_6__HOCs_withSharedSnackbar__["a" /* default */])(ApprovePurchaseRequest))));

/***/ }),
/* 2346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_apollo__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getPurchaseRequestInfo($id: Int!) {\n    prInfo: getPurchaseRequestInfo(id: $id) {\n      reseller {\n        resellerName\n        licenseExpiryPeriod\n        login {\n          loginId\n        }\n      }\n      licenseTypeList {\n        id\n        licenseType\n        maxPrice\n        requestedQuantity\n        assignedQuantity\n        finalPrice\n        gst\n        totalPrice\n      }\n      deviceModelList {\n        id\n        model_name\n        maxPrice\n        manufacturerId\n        manufacturerCode\n        requestedQuantity\n        assignedQuantity\n        finalPrice\n        gst\n        totalPrice\n      }\n    }\n  }\n'],['\n  query getPurchaseRequestInfo($id: Int!) {\n    prInfo: getPurchaseRequestInfo(id: $id) {\n      reseller {\n        resellerName\n        licenseExpiryPeriod\n        login {\n          loginId\n        }\n      }\n      licenseTypeList {\n        id\n        licenseType\n        maxPrice\n        requestedQuantity\n        assignedQuantity\n        finalPrice\n        gst\n        totalPrice\n      }\n      deviceModelList {\n        id\n        model_name\n        maxPrice\n        manufacturerId\n        manufacturerCode\n        requestedQuantity\n        assignedQuantity\n        finalPrice\n        gst\n        totalPrice\n      }\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query checkDeviceAvailableForAssignment(\n    $deviceModelId: Int!\n    $deviceList: [DeviceListInput!]!\n  ) {\n    checkDeviceAvailableForAssignment(\n      deviceModelId: $deviceModelId\n      deviceList: $deviceList\n    ) {\n      serial_num\n      uniqueDeviceId\n    }\n  }\n'],['\n  query checkDeviceAvailableForAssignment(\n    $deviceModelId: Int!\n    $deviceList: [DeviceListInput!]!\n  ) {\n    checkDeviceAvailableForAssignment(\n      deviceModelId: $deviceModelId\n      deviceList: $deviceList\n    ) {\n      serial_num\n      uniqueDeviceId\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation processPurchaseRequest(\n    $resellerLoginId: Int!\n    $licenseExpiryPeriod: Int!\n    $purchaseRequestId: Int!\n    $processedDeviceList: [processedDeviceList!]!\n    $processedLicenseTypeList: [processedLicenseTypeList!]!\n    $licenseTypeList: [LicenseTypeRequest!]!\n    $deviceModelList: [DeviceModelRequest!]!\n    $isPartialProcessed: Boolean!\n  ) {\n    processPurchaseRequest(\n      resellerLoginId: $resellerLoginId\n      licenseExpiryPeriod: $licenseExpiryPeriod\n      purchaseRequestId: $purchaseRequestId\n      processedDeviceList: $processedDeviceList\n      processedLicenseTypeList: $processedLicenseTypeList\n      licenseTypeList: $licenseTypeList\n      deviceModelList: $deviceModelList\n      isPartialProcessed: $isPartialProcessed\n    )\n  }\n'],['\n  mutation processPurchaseRequest(\n    $resellerLoginId: Int!\n    $licenseExpiryPeriod: Int!\n    $purchaseRequestId: Int!\n    $processedDeviceList: [processedDeviceList!]!\n    $processedLicenseTypeList: [processedLicenseTypeList!]!\n    $licenseTypeList: [LicenseTypeRequest!]!\n    $deviceModelList: [DeviceModelRequest!]!\n    $isPartialProcessed: Boolean!\n  ) {\n    processPurchaseRequest(\n      resellerLoginId: $resellerLoginId\n      licenseExpiryPeriod: $licenseExpiryPeriod\n      purchaseRequestId: $purchaseRequestId\n      processedDeviceList: $processedDeviceList\n      processedLicenseTypeList: $processedLicenseTypeList\n      licenseTypeList: $licenseTypeList\n      deviceModelList: $deviceModelList\n      isPartialProcessed: $isPartialProcessed\n    )\n  }\n']);function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_PURCHASE_REQUEST=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject);var VALIDATE_DEVICES=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject2);var PROCESS_PURCHASE_REQUEST=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject3);var style=function style(theme){return{root:{padding:theme.spacing.unit*2,flexGrow:1}};};function TypeHeader(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'title'},props.header));}function SubHeader(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,xs:12,spacing:16,direction:'row'},props.headers.map(function(header,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2,key:index},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading'},header));}));}function DeviceDetails(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,xs:12,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading'},props.details.name)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading'},props.details.totalQty)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading'},props.details.assignedQty)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a,{placeholder:props.details.name+' Serial Numbers',multiline:true,rowsMax:'4',value:props.details.deviceSerialNos,onChange:props.handleSerialNumbers(props.index)}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'caption'},props.details.caption)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{color:'secondary',variant:'raised',onClick:props.handleValidate(props.index)},'Validate')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{color:'primary',variant:'raised',onClick:props.handleCancel(props.index)},'Clear')));}function LicenseDetails(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,xs:12,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading'},props.details.name)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading'},props.details.totalQty)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a,{value:props.details.assignedQty,onChange:props.handleLicenses(props.index),type:'number'})));}var AssignDevicesForPR=function(_Component){_inherits(AssignDevicesForPR,_Component);function AssignDevicesForPR(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,AssignDevicesForPR);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AssignDevicesForPR.__proto__||Object.getPrototypeOf(AssignDevicesForPR)).call.apply(_ref,[this].concat(args))),_this),_this.state={models:[],licenses:[],purchaseRequestId:null,reseller:'',licenseExpiry:null,resellerLoginId:''},_this.handleSerialNumbers=function(index){return function(event){var currModels=_this.state.models;currModels[index].deviceSerialNos=event.target.value;currModels[index].validated=false;currModels[index].caption='Enter comma separated serial numbers';_this.setState({models:currModels});};},_this.handleLicenses=function(index){return function(event){var currLicenses=_this.state.licenses;if(event.target.value>=currLicenses[index].initialQty&&event.target.value<=currLicenses[index].totalQty&&event.target.value>=0){currLicenses[index].assignedQty=event.target.value;_this.setState({licenses:currLicenses});}};},_this.handleValidate=function(index){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var currModels,serialNumberArray,finalDeviceArray,verifiedSerialNumbers,_ref3,data,caption;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:currModels=_this.state.models;if(!(currModels[index].deviceSerialNos!=='')){_context.next=16;break;}// Mutation to validate serial numbers here
// Prep data in the required format
serialNumberArray=currModels[index].deviceSerialNos.trim().replace(/[^A-Za-z0-9,]/g,'').replace(/\s/g,'').replace(/,{1,}$/,'').replace(/^,{1,}/,'').replace(/,+/g,',').split(',');finalDeviceArray=[];verifiedSerialNumbers='';serialNumberArray=[].concat(_toConsumableArray(new Set(serialNumberArray)));serialNumberArray.forEach(function(serialNo){verifiedSerialNumbers=verifiedSerialNumbers+serialNo+', ';var tempObject={};tempObject.serial_num=serialNo;tempObject.uniqueDeviceId=currModels[index].manufacturerCode+'_'+serialNo;finalDeviceArray.push(tempObject);});verifiedSerialNumbers=verifiedSerialNumbers.slice(0,verifiedSerialNumbers.length-2);currModels[index].deviceSerialNos=verifiedSerialNumbers;_context.next=11;return _this.props.client.query({query:VALIDATE_DEVICES,variables:{deviceModelId:parseInt(currModels[index].id,10),deviceList:finalDeviceArray}});case 11:_ref3=_context.sent;data=_ref3.data;if(data.checkDeviceAvailableForAssignment.length===0){// Make sure number of devices are not greater than those applicable for this purchase request
if(finalDeviceArray.length>currModels[index].totalQty-currModels[index].assignedQty){currModels[index].validated=false;currModels[index].caption='Cannot assign more than '+(currModels[index].totalQty-currModels[index].assignedQty)+' devices in this purchase request';}else{currModels[index].validated=true;if(finalDeviceArray.length===1){currModels[index].caption=finalDeviceArray.length+' device is valid';}else{currModels[index].caption=finalDeviceArray.length+' devices are valid';}}}else{currModels[index].validated=false;caption='';if(data.checkDeviceAvailableForAssignment.length>1){caption='Serial numbers ';}else{caption='Serial number ';}data.checkDeviceAvailableForAssignment.forEach(function(device){caption=caption+device.serial_num+' ';});if(data.checkDeviceAvailableForAssignment.length>1){caption=caption+'are invalid';}else{caption=caption+'is invalid';}currModels[index].caption=caption;}_context.next=18;break;case 16:currModels[index].validated=true;currModels[index].caption='No devices assigned';case 18:_this.setState({models:currModels});case 19:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}();},_this.handleCancel=function(index){return function(event){var currModels=_this.state.models;currModels[index].deviceSerialNos='';currModels[index].validated=false;currModels[index].caption='Enter comma separated serial numbers';_this.setState({models:currModels});};},_this.handleBack=function(event){_this.props.history.goBack();},_this.handleSubmit=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(event){var allValidated,finalDevices,finalLicenses,finalDeviceType,finalLicenseType,totalNewDevices,totalNewLicenses,tempObject,tempType,isPartial,_ref5,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:allValidated=true;// Check if all fields are validated
_this.state.models.forEach(function(model){if(model.validated===false){allValidated=false;return-1;}});if(!(allValidated===true)){_context2.next=27;break;}// Mutation to complete the assignment
finalDevices=[];finalLicenses=[];finalDeviceType=[];finalLicenseType=[];totalNewDevices=0;totalNewLicenses=0;// Prep data first
tempObject={};tempType={};isPartial=false;console.log('models',_this.state.models);_this.state.models.forEach(function(model){var serialNoArr=model.deviceSerialNos.trim().replace(/\s/g,'').split(',');if(isPartial===false){if(serialNoArr.length+model.assignedQty!==model.totalQty){isPartial=true;}}// Form final device type list
tempType={};tempType.deviceModelId=parseInt(model.id,10);tempType.quantity=parseInt(model.totalQty,10);tempType.assignedQuantity=parseInt(model.initialQty+serialNoArr.length,10);finalDeviceType.push(tempType);totalNewDevices+=serialNoArr.length;serialNoArr.forEach(function(serialNo){tempObject={};tempObject.deviceModelId=parseInt(model.id,10);tempObject.uniqueDeviceId=model.manufacturerCode+'_'+serialNo;finalDevices.push(tempObject);});});console.log('finalDevices',finalDevices);_this.state.licenses.forEach(function(license){// Form final license type list
tempType={};tempType.licenseTypeId=parseInt(license.id,10);tempType.quantity=parseInt(license.totalQty,10);tempType.assignedQuantity=parseInt(license.assignedQty,10);finalLicenseType.push(tempType);totalNewLicenses+=license.assignedQty-license.initialQty;tempObject={};tempObject.licenseTypeId=parseInt(license.id,10);tempObject.approvedQuantity=parseInt(license.assignedQty-license.initialQty,10);finalLicenses.push(tempObject);});if(!(totalNewDevices===totalNewLicenses)){_context2.next=24;break;}_context2.next=19;return _this.props.client.mutate({mutation:PROCESS_PURCHASE_REQUEST,variables:{resellerLoginId:parseInt(_this.state.resellerLoginId,10),licenseExpiryPeriod:parseInt(_this.state.licenseExpiry,10),purchaseRequestId:parseInt(_this.state.purchaseRequestId,10),processedDeviceList:finalDevices,processedLicenseTypeList:finalLicenses,licenseTypeList:finalLicenseType,deviceModelList:finalDeviceType,isPartialProcessed:isPartial}});case 19:_ref5=_context2.sent;data=_ref5.data;if(data.processPurchaseRequest===true){_this.props.openSnackbar('Device and License Assignment Successful');_this.props.history.goBack();}else{_this.props.openSnackbar('Assignment Failed. Try Again!');}_context2.next=25;break;case 24:_this.props.openSnackbar('Assigned Device and License Quantity must match');case 25:_context2.next=28;break;case 27:_this.props.openSnackbar('Ensure all fields are validated');case 28:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref4.apply(this,arguments);};}(),_this.handleCancelAssignment=function(event){_this.props.openSnackbar('Device and License Assignment Cancelled');_this.props.history.goBack();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AssignDevicesForPR,[{key:'componentDidMount',value:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var purchaseRequestId,_ref7,data,deviceDetails,licenseDetails,reseller,resellerLoginId,licenseExpiry;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:purchaseRequestId=this.props.match.params.purchaseRequestId;// Query to get all relevant information of purchase request
_context3.next=3;return this.props.client.query({query:GET_PURCHASE_REQUEST,variables:{id:parseInt(purchaseRequestId,10)}});case 3:_ref7=_context3.sent;data=_ref7.data;console.log('model',data);data=data.prInfo;deviceDetails=[];licenseDetails=[];reseller=void 0;resellerLoginId=void 0;licenseExpiry=void 0;reseller=data.reseller.resellerName;licenseExpiry=data.reseller.licenseExpiryPeriod;resellerLoginId=data.reseller.login.loginId;data.deviceModelList.forEach(function(device){var tempObject={};tempObject.id=device.id;tempObject.name=device.model_name;tempObject.totalQty=device.requestedQuantity;tempObject.assignedQty=device.assignedQuantity;tempObject.initialQty=tempObject.assignedQty;tempObject.deviceSerialNos='';tempObject.validated=false;tempObject.caption='Enter comma separated serial numbers';tempObject.manufacturerId=device.manufacturerId;tempObject.manufacturerCode=device.manufacturerCode;deviceDetails.push(tempObject);});data.licenseTypeList.forEach(function(license){var tempObject={};tempObject.id=license.id;tempObject.name=license.licenseType;tempObject.totalQty=license.requestedQuantity;tempObject.assignedQty=license.assignedQuantity;tempObject.initialQty=tempObject.assignedQty;licenseDetails.push(tempObject);});this.setState({models:deviceDetails,licenses:licenseDetails,purchaseRequestId:purchaseRequestId,reseller:reseller,licenseExpiry:licenseExpiry,resellerLoginId:resellerLoginId});case 18:case'end':return _context3.stop();}}},_callee3,this);}));function componentDidMount(){return _ref6.apply(this,arguments);}return componentDidMount;}()},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;var _state=this.state,reseller=_state.reseller,models=_state.models,licenses=_state.licenses,purchaseRequestId=_state.purchaseRequestId;var allValidated=true;// Check if all fields are validated
models.forEach(function(model){if(model.validated===false){allValidated=false;return-1;}});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{color:'primary',variant:'raised',onClick:this.handleBack},'Back')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'display3'},reseller.charAt(0).toUpperCase()+reseller.slice(1)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,null,'Purchase Request Id: ',purchaseRequestId)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,xs:12,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TypeHeader,{header:'Device Model(s)'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',null,'* All fields have to be validated before assignment'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,xs:12,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SubHeader,{headers:['Model','Total Quantity','Assigned Quantity','Device Serial Numbers']})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Divider___default.a,null)),models.map(function(model,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,xs:12,spacing:16,direction:'row',key:index},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(DeviceDetails,{details:model,handleSerialNumbers:_this3.handleSerialNumbers,handleValidate:_this3.handleValidate,handleCancel:_this3.handleCancel,index:index}));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,xs:12,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TypeHeader,{header:'License(s)'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,xs:12,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SubHeader,{headers:['License','Total Quantity','Assigned Quantity']})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Divider___default.a,null)),licenses.map(function(license,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,xs:12,spacing:16,direction:'row',key:index},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(LicenseDetails,{details:license,handleLicenses:_this3.handleLicenses,index:index}));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,xs:12,spacing:16,direction:'row',justify:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{color:'secondary',variant:'raised',onClick:this.handleSubmit,disabled:!allValidated},'Assign')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{color:'primary',variant:'raised',onClick:this.handleCancelAssignment},'Clear')))));}}]);return AssignDevicesForPR;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_10_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_6__HOCs_withSharedSnackbar__["a" /* default */])(AssignDevicesForPR))));

/***/ }),
/* 2347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_apollo__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getPurchaseRequestInfo($id: Int!) {\n    prInfo: getPurchaseRequestInfo(id: $id) {\n      reseller {\n        resellerName\n      }\n      licenseTypeList {\n        id\n        licenseType\n        maxPrice\n        requestedQuantity\n        finalPrice\n        gst\n        totalPrice\n      }\n      deviceModelList {\n        id\n        model_name\n        maxPrice\n        requestedQuantity\n        finalPrice\n        gst\n        totalPrice\n      }\n    }\n  }\n'],['\n  query getPurchaseRequestInfo($id: Int!) {\n    prInfo: getPurchaseRequestInfo(id: $id) {\n      reseller {\n        resellerName\n      }\n      licenseTypeList {\n        id\n        licenseType\n        maxPrice\n        requestedQuantity\n        finalPrice\n        gst\n        totalPrice\n      }\n      deviceModelList {\n        id\n        model_name\n        maxPrice\n        requestedQuantity\n        finalPrice\n        gst\n        totalPrice\n      }\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_PURCHASE_REQUEST=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject);var style=function style(theme){return{root:{padding:theme.spacing.unit*2,flexGrow:1}};};function TypeHeader(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'title'},props.header));}function SubHeader(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,container:true,xs:12,spacing:16,direction:'row'},props.headers.map(function(header,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:2,key:index},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading'},header));}));}function Details(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,container:true,xs:12,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading'},props.details.name)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading'},props.details.maxPrice)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading'},props.details.qty)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading'},props.details.finalPrice)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading'},props.details.gst)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'subheading'},props.details.totalPrice)));}var ViewPurchaseRequest=function(_Component){_inherits(ViewPurchaseRequest,_Component);function ViewPurchaseRequest(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ViewPurchaseRequest);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ViewPurchaseRequest.__proto__||Object.getPrototypeOf(ViewPurchaseRequest)).call.apply(_ref,[this].concat(args))),_this),_this.state={reseller:'',models:[],licenses:[],purchaseRequestId:null},_this.handleBack=function(event){_this.props.history.goBack();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ViewPurchaseRequest,[{key:'componentDidMount',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var purchaseRequestId,_ref3,data,deviceDetails,licenseDetails,reseller;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:purchaseRequestId=void 0;purchaseRequestId=this.props.match.params.purchaseRequestId;// Query to get all relevant information of purchase request
_context.next=4;return this.props.client.query({query:GET_PURCHASE_REQUEST,variables:{id:parseInt(purchaseRequestId,10)}});case 4:_ref3=_context.sent;data=_ref3.data;data=data.prInfo;deviceDetails=[];licenseDetails=[];reseller=void 0;reseller=data.reseller.resellerName;data.deviceModelList.forEach(function(device){var tempObject={};tempObject.id=device.id;tempObject.name=device.model_name;tempObject.maxPrice=device.maxPrice;tempObject.qty=device.requestedQuantity;tempObject.finalPrice=device.finalPrice?device.finalPrice:'NA';tempObject.gst=device.gst?(device.gst*100).toString():'NA';tempObject.totalPrice=device.totalPrice?device.totalPrice:'NA';deviceDetails.push(tempObject);});data.licenseTypeList.forEach(function(license){var tempObject={};tempObject.id=license.id;tempObject.name=license.licenseType;tempObject.maxPrice=license.maxPrice;tempObject.qty=license.requestedQuantity;tempObject.finalPrice=license.finalPrice?license.finalPrice:'NA';tempObject.gst=license.gst?(license.gst*100).toString():'NA';tempObject.totalPrice=license.totalPrice?license.totalPrice:'NA';licenseDetails.push(tempObject);});this.setState({models:deviceDetails,licenses:licenseDetails,purchaseRequestId:purchaseRequestId,reseller:reseller});case 14:case'end':return _context.stop();}}},_callee,this);}));function componentDidMount(){return _ref2.apply(this,arguments);}return componentDidMount;}()},{key:'render',value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button___default.a,{color:'primary',variant:'raised',onClick:this.handleBack},'Back')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'display3'},this.state.reseller.charAt(0).toUpperCase()+this.state.reseller.slice(1)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,null,'Purchase Request Id: ',this.state.purchaseRequestId)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,container:true,xs:12,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TypeHeader,{header:'Device Model(s)'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,container:true,xs:12,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SubHeader,{headers:['Model','Maximum Price','Quantity','Final Price','GST','Total Price']})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Divider___default.a,null)),this.state.models.map(function(model,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,container:true,xs:12,spacing:16,direction:'row',key:index},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Details,{details:model}));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,container:true,xs:12,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TypeHeader,{header:'License(s)'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,container:true,xs:12,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SubHeader,{headers:['License','Maximum Price','Quantity','Final Price','GST','Total Price']})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Divider___default.a,null)),this.state.licenses.map(function(license,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,container:true,xs:12,spacing:16,direction:'row',key:index},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Details,{details:license}));})));}}]);return ViewPurchaseRequest;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_9_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_6__HOCs_withSharedSnackbar__["a" /* default */])(ViewPurchaseRequest))));

/***/ }),
/* 2348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Menu__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Dialog__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AddDevice__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__EditDevice__ = __webpack_require__(2349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_file_saver__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_getLoginId__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getAllDeviceDetailsByLoginId(\n    $loginId: Int!\n    $accountType: String!\n    $deviceModelId: Int!\n  ) {\n    devices: getAllDeviceDetailsByLoginId(\n      loginId: $loginId\n      accountType: $accountType\n      deviceModelId: $deviceModelId\n    ) {\n      serial_num\n      imei_num\n      uniqueDeviceId\n      status\n      vehicleDetail {\n        vehicleNumber\n      }\n      clientName\n      partnerDetails {\n        businessName\n      }\n    }\n  }\n'],['\n  query getAllDeviceDetailsByLoginId(\n    $loginId: Int!\n    $accountType: String!\n    $deviceModelId: Int!\n  ) {\n    devices: getAllDeviceDetailsByLoginId(\n      loginId: $loginId\n      accountType: $accountType\n      deviceModelId: $deviceModelId\n    ) {\n      serial_num\n      imei_num\n      uniqueDeviceId\n      status\n      vehicleDetail {\n        vehicleNumber\n      }\n      clientName\n      partnerDetails {\n        businessName\n      }\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n'],['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable */var style=function style(theme){return{root:{padding:theme.spacing.unit*4,flexGrow:1},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},iconSmall:{fontSize:20}};};var GET_DEVICE_LIST=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject);var GET_FILE_FORMAT=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject2);var ViewDevice=function(_Component){_inherits(ViewDevice,_Component);function ViewDevice(props){var _this2=this;_classCallCheck(this,ViewDevice);var _this=_possibleConstructorReturn(this,(ViewDevice.__proto__||Object.getPrototypeOf(ViewDevice)).call(this,props));_this.clientId=[];_this.columns=['SERIAL NO','IMEI NO','UNIQUE ID','STATUS','VEHICLE NO','CLIENT NAME','PARTNER NAME'];_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15,onRowClick:function onRowClick(rowData,dataIndex,rowIndex){if(_this.status[dataIndex.dataIndex]===2||_this.status[dataIndex.dataIndex]===1){_this.editDevice(_this.uniqueDeviceId[dataIndex.dataIndex]);}else{_this.props.openSnackbar('Device cannot be edited');}}};_this.state={open:false,open1:false};_this.getStatus=function(status){if(status===1){return'Instock';}else if(status===2){return'Assigned to Partner';}else if(status===3){return'Assigned to Client';}else if(status===4){return'Registered to vehicle';}};_this.editDevice=function(uniqueDeviceId){// console.log(uniqueDeviceId, 'demo')
_this.setState({selUniqueDeviceId:uniqueDeviceId},function(){console.log(_this.state.selUniqueDeviceId,'uid');});_this.handleClickEditOpen();};_this.handleClickOpen=function(){_this.setState({open:true});};_this.handleClose=function(){_this.setState({open:false});};_this.handleClickEditOpen=function(){_this.setState({open1:true});};_this.handleEditClose=function(){_this.setState({open1:false});};_this.addBulkUpload=function(e){_this.props.history.push({pathname:'/home/DeviceInventory/BulkUpload'});};_this.assignBulkUpload=function(e){console.log('bulk');_this.props.history.push({pathname:'/home/DeviceInventory/BulkDeviceAssign'});};_this.downloadBulkUpload=function(client){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _ref2,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.client.query({query:GET_FILE_FORMAT,variables:{bucketname:'excel-templates',filename:'deviceUpload.xlsx'},errorPolicy:'all'});case 2:_ref2=_context.sent;data=_ref2.data;__WEBPACK_IMPORTED_MODULE_13_file_saver___default.a.saveAs(data.getPublicDownloadURL,'sample.xlsx');case 5:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();};_this.classes=props;return _this;}_createClass(ViewDevice,[{key:'mapToArr',value:function mapToArr(devices){var _this3=this;var rowData=[];var fullData=[];this.status=[];this.uniqueDeviceId=[];// this.clientId = []
console.log('devicese inside columns',devices);devices.forEach(function(element){rowData=[];// this.clientId.push(element.id)
_this3.status.push(element.status);_this3.uniqueDeviceId.push(element.uniqueDeviceId);rowData.push(element.serial_num);rowData.push(element.imei_num);rowData.push(element.uniqueDeviceId);rowData.push(_this3.getStatus(element.status));element.vehicleDetail?rowData.push(element.vehicleDetail.vehicleNumber):rowData.push('N/A');element.clientName?rowData.push(element.clientName):rowData.push('N/A');element.partnerDetails?rowData.push(element.partnerDetails.businessName):rowData.push('N/A');fullData.push(rowData);});return fullData;}},{key:'render',value:function render(){var _this4=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["Query"],{query:GET_DEVICE_LIST,variables:{loginId:Object(__WEBPACK_IMPORTED_MODULE_14__utils_getLoginId__["a" /* default */])(),accountType:localStorage.getItem('Account_type'),deviceModelId:parseInt(this.props.match.params.modelId,10)}},function(_ref3){var loading=_ref3.loading,error=_ref3.error,devices=_ref3.data.devices;if(loading)return'Loading...';if(error)return'Error!: '+error;var data=_this4.mapToArr(devices);console.log('devices',devices);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16//   direction="row-reverse"
,justify:'space-between'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{variant:'headline'},'Devices')),localStorage.getItem('Account_type')==='SA'&&window.location.host.includes('iocl')?null:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{color:'secondary'// href="/home/customers/add"
,variant:'contained',className:classes.button,onClick:_this4.handleClickOpen},'New Device'),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{color:'secondary',variant:'contained',className:classes.button,onClick:_this4.addBulkUpload},'Bulk Upload'),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{color:'secondary',variant:'contained',className:classes.button,onClick:_this4.downloadBulkUpload(_this4.props.client)},'Download Format'),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{color:'secondary',variant:'contained',onClick:_this4.assignBulkUpload},'Assign Device Upload'),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{variant:'outlined',className:classes.button},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Menu___default.a,{className:classes.iconSmall})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Dialog___default.a,{open:_this4.state.open,onClose:_this4.handleClose,'aria-labelledby':'form-dialog-title'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__AddDevice__["a" /* default */],{handleClose:_this4.handleClose})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Dialog___default.a,{open:_this4.state.open1,onClose:_this4.handleEditClose,'aria-labelledby':'form-dialog-title'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__EditDevice__["a" /* default */],{handleClose:_this4.handleEditClose,selUniqueDecviceId:_this4.state.selUniqueDeviceId})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_mui_datatables___default.a,{data:data,columns:_this4.columns,options:_this4.options}))));});}}]);return ViewDevice;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["withApollo"])(ViewDevice)));

/***/ }),
/* 2349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core_FormHelperText__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core_FormHelperText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_FormHelperText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_icons_DeleteForever__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_icons_DeleteForever___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__material_ui_icons_DeleteForever__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_core_Tooltip__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_core_Tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Pages_InventoryDevices_ViewInventoryDevices___ = __webpack_require__(643);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query {\n    models: allDeviceModels(status: 1) {\n      id\n      model_name\n    }\n  }\n'],['\n  query {\n    models: allDeviceModels(status: 1) {\n      id\n      model_name\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query allPartnerDetails {\n    clients: allPartnerDetails {\n      id\n      businessName\n      email\n      contactNumber\n      contactPerson\n      login {\n        loginId\n      }\n    }\n  }\n'],['\n  query allPartnerDetails {\n    clients: allPartnerDetails {\n      id\n      businessName\n      email\n      contactNumber\n      contactPerson\n      login {\n        loginId\n      }\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query {\n    manufacturers: getAllManufacturer(status: 1) {\n      id\n      manufacturerName\n      manufacturerCode\n    }\n  }\n'],['\n  query {\n    manufacturers: getAllManufacturer(status: 1) {\n      id\n      manufacturerName\n      manufacturerCode\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query deviceModel($modelId: Int) {\n    deviceModel(id: $modelId) {\n      devicetype\n    }\n  }\n'],['\n  query deviceModel($modelId: Int) {\n    deviceModel(id: $modelId) {\n      devicetype\n    }\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  query deviceDetail($uniqueDeviceId: String) {\n    deviceDetail(uniqueDeviceId: $uniqueDeviceId) {\n      serial_num\n      imei_num\n      uniqueDeviceId\n      deviceModelId {\n        id\n        model_name\n        version\n      }\n      manufacturer {\n        id\n        manufacturerName\n        manufacturerCode\n      }\n      partnerDetails {\n        id\n      }\n    }\n  }\n'],['\n  query deviceDetail($uniqueDeviceId: String) {\n    deviceDetail(uniqueDeviceId: $uniqueDeviceId) {\n      serial_num\n      imei_num\n      uniqueDeviceId\n      deviceModelId {\n        id\n        model_name\n        version\n      }\n      manufacturer {\n        id\n        manufacturerName\n        manufacturerCode\n      }\n      partnerDetails {\n        id\n      }\n    }\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  mutation updateDeviceDetail(\n    $serial_num: String!\n    $imei_num: String!\n    $device_model_id: Int!\n    $uniqueSerialNumber: String!\n    $manufacturerId: Int!\n    $ownerLoginId: Int!\n    $oldUniqueDeviceId: String!\n    $status: Int!\n    $is_panic_enabled:Boolean\n  ) {\n    updateDeviceDetail(\n      serial_num: $serial_num\n      imei_num: $imei_num\n      deviceModelId: $device_model_id\n      uniqueDeviceId: $uniqueSerialNumber\n      manufacturerId: $manufacturerId\n      ownerLoginId: $ownerLoginId\n      oldUniqueDeviceId: $oldUniqueDeviceId\n      status: $status\n      is_panic_enabled:$is_panic_enabled\n    )\n  }\n'],['\n  mutation updateDeviceDetail(\n    $serial_num: String!\n    $imei_num: String!\n    $device_model_id: Int!\n    $uniqueSerialNumber: String!\n    $manufacturerId: Int!\n    $ownerLoginId: Int!\n    $oldUniqueDeviceId: String!\n    $status: Int!\n    $is_panic_enabled:Boolean\n  ) {\n    updateDeviceDetail(\n      serial_num: $serial_num\n      imei_num: $imei_num\n      deviceModelId: $device_model_id\n      uniqueDeviceId: $uniqueSerialNumber\n      manufacturerId: $manufacturerId\n      ownerLoginId: $ownerLoginId\n      oldUniqueDeviceId: $oldUniqueDeviceId\n      status: $status\n      is_panic_enabled:$is_panic_enabled\n    )\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  mutation deleteDeviceInStock($uniqueDeviceid: String!) {\n    deleteDeviceInStock(deviceUniqueId: $uniqueDeviceid)\n  }\n'],['\n  mutation deleteDeviceInStock($uniqueDeviceid: String!) {\n    deleteDeviceInStock(deviceUniqueId: $uniqueDeviceid)\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable */var GET_MODELS=Object(__WEBPACK_IMPORTED_MODULE_14_graphql_tag__["a" /* default */])(_templateObject);var GET_PARTNER=Object(__WEBPACK_IMPORTED_MODULE_14_graphql_tag__["a" /* default */])(_templateObject2);var GET_MANUFACTURER=Object(__WEBPACK_IMPORTED_MODULE_14_graphql_tag__["a" /* default */])(_templateObject3);var GET_MODEL_TYPE=Object(__WEBPACK_IMPORTED_MODULE_14_graphql_tag__["a" /* default */])(_templateObject4);var GET_DEVICE_DETAIL=Object(__WEBPACK_IMPORTED_MODULE_14_graphql_tag__["a" /* default */])(_templateObject5);// calling server for updation
var UPDATE_DEVICE=Object(__WEBPACK_IMPORTED_MODULE_14_graphql_tag__["a" /* default */])(_templateObject6);var DELETE_DEVICE=Object(__WEBPACK_IMPORTED_MODULE_14_graphql_tag__["a" /* default */])(_templateObject7);var styles=function styles(theme){return{button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{margin:theme.spacing.unit,minWidth:120}};};var EditDevice=function(_Component){_inherits(EditDevice,_Component);function EditDevice(props){var _this2=this;_classCallCheck(this,EditDevice);var _this=_possibleConstructorReturn(this,(EditDevice.__proto__||Object.getPrototypeOf(EditDevice)).call(this,props));_this.state={open1:false,open2:false,modelname:'',serialno:'',imeino:'',uniqueSerialNumber:'',isModelNameValid:true,isSerialnoValid:true,isImeinoValid:true,isManufacturerNameValid:true,manufacturerName:'',open_man:false,manufacturerCode:'',manufacturerId:'',errorMessage:'',models:[],clients:[],partnerName:''};_this.handleInputChange=function(key){return function(e){if(_this.state.manufacturerName===''||_this.state.modelname===''){_this.props.openSnackbar('Please select Manufacturer and Model before entering serial or IMEI no');_this.setState({errorMessage:'Please select Manufacturer and Model before entering serial or IMEI no'});}else{_this.setState(_defineProperty({},key,e.target.value));}};};_this.handleChange=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _ref2,models;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.setState(_defineProperty({},event.target.name,event.target.value),function(){//   console.log('partner name', this.state.partnerName)
});_context.next=3;return _this.props.client.query({query:GET_MODELS,variables:{manufacturerId:event.target.value}});case 3:_ref2=_context.sent;models=_ref2.data;_this.setState({models:models.models});case 6:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.handleModelChange=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(event){var _ref4,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:console.log('mname',event.target.value);_this.setState(_defineProperty({},event.target.name,event.target.value));_context2.next=4;return _this.props.client.query({query:GET_MODEL_TYPE,variables:{modelId:event.target.value},fetchPolicy:'network-only'});case 4:_ref4=_context2.sent;data=_ref4.data;// console.log(data, 'modelType')
_this.setState({deviceType:data.deviceModel.devicetype});case 7:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref3.apply(this,arguments);};}();_this.handleOpen=function(){_this.setState({open:true});};_this.handleOpenSelect=function(){_this.setState({open1:true});};_this.handleCloseSelect=function(){_this.setState({open1:false});};_this.handleOpenSelectPartner=function(){_this.setState({open2:true});};_this.handleCloseSelectPartner=function(){_this.setState({open2:false});};_this.handleOpenSelectMan=function(){_this.setState({open_man:true});};_this.handleCloseSelectMan=function(){_this.setState({open_man:false});};_this.checkImeinoValidity=function(){// const regex = new RegExp(/^[0-9]{15}$/)
var regex=new RegExp(/^[a-zA-Z0-9]{4,20}$/);_this.setState({errorMessage:''});var code=[];code=_this.state.manufacturerName.split('*');if(code[0]===''){_this.setState({isImeinoValid:_this.state.imeino!==''&&regex.test(_this.state.imeino)});}else{_this.setState({isImeinoValid:_this.state.imeino!==''&&regex.test(_this.state.imeino)});if(_this.state.deviceType==='AS140'){_this.setState({uniqueSerialNumber:code[1]+'_'+_this.state.imeino});}}};_this.checkSerialnoValidity=function(){_this.setState({errorMessage:''});// const regex = new RegExp(/^[0-9]{5,15}$/)
var regex=new RegExp(/^[a-zA-Z0-9]{4,20}$/);var code=[];code=_this.state.manufacturerName.split('*');if(code[0]===''){_this.setState({isSerialnoValid:_this.state.serialno!==''&&regex.test(_this.state.serialno)});}else{_this.setState({isSerialnoValid:_this.state.serialno!==''&&regex.test(_this.state.serialno)// uniqueSerialNumber: code[1] + '_' + this.state.serialno
});if(_this.state.deviceType!=='AS140'){// var code = this.state.manufacturerName.split('*')
_this.setState({uniqueSerialNumber:code[1]+'_'+_this.state.serialno});}}};_this.checkModelNameValidity=function(){_this.setState({isModelNameValid:_this.state.modelname!==''});};_this.checkManufacturerNameValidity=function(){var code=[];code=_this.state.manufacturerName.split('*');if(code[0]===''){_this.setState({isManufacturerNameValid:_this.state.manufacturerName!=='',// manufacturerCode:this
uniqueSerialNumber:code[1]+'_'+_this.state.serialno,manufacturerId:code[0]});}else{_this.setState({isManufacturerNameValid:_this.state.manufacturerName!=='',// manufacturerCode:this
uniqueSerialNumber:'',manufacturerId:code[0]});}};_this.handleCancel=function(){console.log(_this.props);_this.props.fetchDevicesData();_this.props.handleClose();};_this.handleSubmit=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(e){var localPartner,_ref6,data,errors;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:localPartner=null;_this.state.clients.forEach(function(el){if(el.id==_this.state.partnerName){localPartner=el.login.loginId;// console.log('elll', localPartner)
}});e.preventDefault();_context3.next=5;return _this.props.client.mutate({mutation:UPDATE_DEVICE,variables:{serial_num:_this.state.serialno,imei_num:_this.state.imeino,device_model_id:parseInt(_this.state.modelname,10),uniqueSerialNumber:_this.state.uniqueSerialNumber,manufacturerId:parseInt(_this.state.manufacturerId,10),status:2,ownerLoginId:parseInt(localPartner,10),oldUniqueDeviceId:_this.existingUniqueId// partnerLoginId: parseInt(localPartner, 10)
},errorPolicy:'all'});case 5:_ref6=_context3.sent;data=_ref6.data;errors=_ref6.errors;if(data){_this.setState({serialno:'',imeino:'',uniqueSerialNumber:'',manufacturerId:'',simprovider:''});}// updateDevice({
//   variables: {
//     serial_num: this.state.serialno,
//     imei_num: this.state.imeino,
//     device_model_id: parseInt(this.state.modelname, 10),
//     uniqueSerialNumber: this.state.uniqueSerialNumber,
//     manufacturerId: parseInt(this.state.manufacturerId, 10),
//     status: 2,
//     ownerLoginId: parseInt(localPartner, 10),
//     oldUniqueDeviceId: this.existingUniqueId,
// // partnerLoginId: parseInt(localPartner, 10)
//   },
//   refetchQueries: [{query:GET_DEVICE_LIST, variables: {loginId: getLoginId(),
//     accountType: localStorage.getItem('Account_type'),
//     deviceModelId: this.props.deviceModelId} }]
// })
// console.log(this.data, 'addDevice')
// this.state.simprovider = ''
case 9:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x3){return _ref5.apply(this,arguments);};}();_this.deleteDevice=function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(event){var _ref8,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:event.preventDefault();_context4.next=3;return _this.props.client.mutate({mutation:DELETE_DEVICE,variables:{uniqueDeviceid:_this.existingUniqueId},refetchQueries:['getAllDeviceDetailsByLoginId'],errorPolicy:'all'});case 3:_ref8=_context4.sent;data=_ref8.data;// console.log('submit', data.deleteDeviceInStock)
if(data.deleteDeviceInStock===true){_this.props.handleClose();_this.props.openSnackbar('Device Deleted Successfully');}else{_this.props.openSnackbar('Error in deleting device');}case 6:case'end':return _context4.stop();}}},_callee4,_this2);}));return function(_x4){return _ref7.apply(this,arguments);};}();_this.getDeviceDetails=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(){var _ref10,data,_ref11,models;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return _this.props.client.query({query:GET_DEVICE_DETAIL,variables:{uniqueDeviceId:_this.existingUniqueId},fetchPolicy:'network-only'});case 2:_ref10=_context5.sent;data=_ref10.data;_context5.next=6;return _this.props.client.query({query:GET_MODELS,variables:{manufacturerId:data.deviceDetail.manufacturer.id}});case 6:_ref11=_context5.sent;models=_ref11.data;_this.setState({models:models.models});_this.setDetails(data.deviceDetail);case 10:case'end':return _context5.stop();}}},_callee5,_this2);}));_this.GetPartnerDetails=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(){var _ref13,clients;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return _this.props.client.query({query:GET_PARTNER,fetchPolicy:'network-only'});case 2:_ref13=_context6.sent;clients=_ref13.data;_this.setState({clients:clients.clients});case 5:case'end':return _context6.stop();}}},_callee6,_this2);}));_this.setDetails=function(DeviceDetail){// console.log('details', clientDetail.state.zone_id)
var mafName=DeviceDetail.manufacturer.id+'*'+DeviceDetail.manufacturer.manufacturerCode;_this.setState({modelname:DeviceDetail.deviceModelId.id,serialno:DeviceDetail.serial_num,imeino:DeviceDetail.imei_num,uniqueSerialNumber:DeviceDetail.uniqueDeviceId,manufacturerName:mafName,manufacturerId:DeviceDetail.manufacturer.id,partnerName:DeviceDetail.partnerDetails.id});console.log('this.state',_this.state.modelname,_this.state.manufacturerName,DeviceDetail);};_this.classes=props;_this.existingUniqueId=_this.props.selUniqueDecviceId;return _this;}_createClass(EditDevice,[{key:'componentDidMount',value:function componentDidMount(){this.getDeviceDetails();this.GetPartnerDetails();}},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;return(// <Query query={GET_MODELS} fetchPolicy="network-only">
//   {({ loading: isModelsLoading, error, data: { models } }) => (
__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_apollo__["Query"],{query:GET_MANUFACTURER,fetchPolicy:'network-only'},function(_ref14){var isManufacturersLoading=_ref14.loading,error=_ref14.error,manufacturers=_ref14.data.manufacturers;if(isManufacturersLoading)return null;if(error)return'Error!: '+error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{variant:'outlined',color:'secondary',className:classes.button,style:{float:'right'},onClick:_this3.deleteDevice},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Tooltip___default.a,{title:'Delete Device'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_icons_DeleteForever___default.a,{className:classes.icon}))),' '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle___default.a,{id:'form-dialog-title'},'Update Device Details :'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core__["Typography"],{variant:'subheading',gutterBottom:true,style:{color:'red',marginLeft:'25px'}},error&&error.graphQLErrors.map(function(_ref15,i){var message=_ref15.message;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{key:i},message);}),_this3.state.errorMessage&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,_this3.state.errorMessage)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core__["Typography"],{variant:'subheading',gutterBottom:true,style:{color:'green',marginLeft:'25px'}},data&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Sucessfully Updated')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Divider___default.a,{light:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{onSubmit:_this3.handleSubmit()},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText___default.a,null,'* Marked fields are mandatory'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel___default.a,{htmlFor:'demo-controlled-open-select'},'Select Manufacturer *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select___default.a,{open:_this3.state.open_man,fullWidth:true,onClose:_this3.handleCloseSelectMan,onOpen:_this3.handleOpenSelectMan,value:_this3.state.manufacturerName,onChange:_this3.handleChange,onBlur:_this3.checkManufacturerNameValidity,inputProps:{name:'manufacturerName',id:'manufacturerName'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),manufacturers.map(function(manufacturer){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{value:manufacturer.id+'*'+manufacturer.manufacturerCode,key:manufacturer.id},manufacturer.manufacturerName);}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel___default.a,{htmlFor:'demo-controlled-open-select'},'Select Partner *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select___default.a,{open:_this3.state.open2,fullWidth:true,onClose:_this3.handleCloseSelectPartner,onOpen:_this3.handleOpenSelectPartner,value:_this3.state.partnerName,onChange:_this3.handleChange,inputProps:{name:'partnerName',id:'partnerName'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),_this3.state.clients.map(function(client){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{value:client.id,key:client.id},client.businessName);}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel___default.a,{htmlFor:'demo-controlled-open-select'},'Select Model *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select___default.a,{open:_this3.state.open1,fullWidth:true,onClose:_this3.handleCloseSelect,onOpen:_this3.handleOpenSelect,value:_this3.state.modelname,onChange:_this3.handleModelChange,onBlur:_this3.checkModelNameValidity,inputProps:{name:'modelname',id:'modelname'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),_this3.state.models.map(function(allDeviceModelsByStatus){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{value:allDeviceModelsByStatus.id,key:allDeviceModelsByStatus.id},allDeviceModelsByStatus.model_name);}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField___default.a,{margin:'dense',id:'serialno',name:'serialno',label:'Serial No',type:'text',required:true,value:_this3.state.serialno,fullWidth:true,onChange:_this3.handleInputChange('serialno'),error:!_this3.state.isSerialnoValid,onBlur:_this3.checkSerialnoValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this3.state.isSerialnoValid?'':'Serial Number should be between 4-20 characters')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField___default.a,{margin:'dense',id:'imeino',name:'imeino',label:'IMEI No',type:'text',required:true,fullWidth:true,value:_this3.state.imeino,onChange:_this3.handleInputChange('imeino'),error:!_this3.state.isImeinoValid,onBlur:_this3.checkImeinoValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this3.state.isImeinoValid?'':'IMEI Number should be between 4-20 characters')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'uniqueSerialNumber',name:'uniqueSerialNumber',label:'Unique Id',type:'text',disabled:true,required:true,fullWidth:true,value:_this3.state.uniqueSerialNumber,onChange:_this3.handleInputChange('uniqueSerialNumber')// error={!this.state.isImeinoValid}
// onBlur={this.checkImeinoValidity}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:function onClick(){return _this3.handleCancel();},color:'default',variant:'contained'},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a// onClick={this.handleClose}
,{type:'submit',color:'primary',variant:'contained',disabled:!(_this3.state.isModelNameValid&&_this3.state.isSerialnoValid&&_this3.state.isImeinoValid&&_this3.state.serialno!==''&&_this3.state.imeino!==''&&_this3.state.manufacturerName!==''&&_this3.state.uniqueSerialNumber!==''&&_this3.state.modelname!==''&&_this3.state.partnerName!=='')},'Submit'))));})//   )}
// </Query>
);}}]);return EditDevice;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_15_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_19__HOCs_withSharedSnackbar__["a" /* default */])(EditDevice))));

/***/ }),
/* 2350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core_FormHelperText__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core_FormHelperText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_FormHelperText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_icons_DeleteForever__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_icons_DeleteForever___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__material_ui_icons_DeleteForever__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_core_Tooltip__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_core_Tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__material_ui_core_Checkbox__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__material_ui_core_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__material_ui_core_Checkbox__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query {\n    models: allDeviceModels(status: 1) {\n      id\n      model_name\n    }\n  }\n'],['\n  query {\n    models: allDeviceModels(status: 1) {\n      id\n      model_name\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query {\n    manufacturers: getAllManufacturer(status: 1) {\n      id\n      manufacturerName\n      manufacturerCode\n    }\n  }\n'],['\n  query {\n    manufacturers: getAllManufacturer(status: 1) {\n      id\n      manufacturerName\n      manufacturerCode\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query deviceModel($modelId: Int) {\n    deviceModel(id: $modelId) {\n      devicetype\n    }\n  }\n'],['\n  query deviceModel($modelId: Int) {\n    deviceModel(id: $modelId) {\n      devicetype\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query deviceDetail($uniqueDeviceId: String) {\n    deviceDetail(uniqueDeviceId: $uniqueDeviceId) {\n      serial_num\n      imei_num\n      uniqueDeviceId\n      deviceModelId {\n        id\n        model_name\n        version\n      }\n      manufacturer {\n        id\n        manufacturerName\n        manufacturerCode\n      }\n      is_panic_enabled\n    }\n  }\n'],['\n  query deviceDetail($uniqueDeviceId: String) {\n    deviceDetail(uniqueDeviceId: $uniqueDeviceId) {\n      serial_num\n      imei_num\n      uniqueDeviceId\n      deviceModelId {\n        id\n        model_name\n        version\n      }\n      manufacturer {\n        id\n        manufacturerName\n        manufacturerCode\n      }\n      is_panic_enabled\n    }\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  mutation updateDeviceDetail(\n    $serial_num: String!\n    $imei_num: String!\n    $device_model_id: Int!\n    $uniqueSerialNumber: String!\n    $manufacturerId: Int!\n    $ownerLoginId: Int!\n    $oldUniqueDeviceId: String!\n    $status: Int!\n    $is_panic_enabled: Boolean\n  ) {\n    updateDeviceDetail(\n      serial_num: $serial_num\n      imei_num: $imei_num\n      deviceModelId: $device_model_id\n      uniqueDeviceId: $uniqueSerialNumber\n      manufacturerId: $manufacturerId\n      ownerLoginId: $ownerLoginId\n      oldUniqueDeviceId: $oldUniqueDeviceId\n      status: $status\n      is_panic_enabled: $is_panic_enabled\n    )\n  }\n'],['\n  mutation updateDeviceDetail(\n    $serial_num: String!\n    $imei_num: String!\n    $device_model_id: Int!\n    $uniqueSerialNumber: String!\n    $manufacturerId: Int!\n    $ownerLoginId: Int!\n    $oldUniqueDeviceId: String!\n    $status: Int!\n    $is_panic_enabled: Boolean\n  ) {\n    updateDeviceDetail(\n      serial_num: $serial_num\n      imei_num: $imei_num\n      deviceModelId: $device_model_id\n      uniqueDeviceId: $uniqueSerialNumber\n      manufacturerId: $manufacturerId\n      ownerLoginId: $ownerLoginId\n      oldUniqueDeviceId: $oldUniqueDeviceId\n      status: $status\n      is_panic_enabled: $is_panic_enabled\n    )\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  mutation deleteDeviceInStock($uniqueDeviceid: String!) {\n    deleteDeviceInStock(deviceUniqueId: $uniqueDeviceid)\n  }\n'],['\n  mutation deleteDeviceInStock($uniqueDeviceid: String!) {\n    deleteDeviceInStock(deviceUniqueId: $uniqueDeviceid)\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_MODELS=Object(__WEBPACK_IMPORTED_MODULE_14_graphql_tag__["a" /* default */])(_templateObject);var GET_MANUFACTURER=Object(__WEBPACK_IMPORTED_MODULE_14_graphql_tag__["a" /* default */])(_templateObject2);var GET_MODEL_TYPE=Object(__WEBPACK_IMPORTED_MODULE_14_graphql_tag__["a" /* default */])(_templateObject3);var GET_DEVICE_DETAIL=Object(__WEBPACK_IMPORTED_MODULE_14_graphql_tag__["a" /* default */])(_templateObject4);// calling server for updation
var UPDATE_DEVICE=Object(__WEBPACK_IMPORTED_MODULE_14_graphql_tag__["a" /* default */])(_templateObject5);var DELETE_DEVICE=Object(__WEBPACK_IMPORTED_MODULE_14_graphql_tag__["a" /* default */])(_templateObject6);var styles=function styles(theme){return{button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{margin:theme.spacing.unit,minWidth:120}};};var EditDevice=function(_Component){_inherits(EditDevice,_Component);function EditDevice(props){var _this2=this;_classCallCheck(this,EditDevice);var _this=_possibleConstructorReturn(this,(EditDevice.__proto__||Object.getPrototypeOf(EditDevice)).call(this,props));_this.state={open1:false,modelname:'',serialno:'',imeino:'',uniqueSerialNumber:'',isModelNameValid:true,isSerialnoValid:true,isImeinoValid:true,isManufacturerNameValid:true,manufacturerName:'',open_man:false,manufacturerCode:'',manufacturerId:'',errorMessage:'',models:[],is_panic_enabled:false};_this.handleInputChange=function(key){return function(e){if(_this.state.manufacturerName===''||_this.state.modelname===''){_this.props.openSnackbar('Please select Manufacturer and Model before entering serial or IMEI no');_this.setState({errorMessage:'Please select Manufacturer and Model before entering serial or IMEI no'});}else{_this.setState(_defineProperty({},key,e.target.value));}};};_this.handleChange=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _ref2,models;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.setState(_defineProperty({},event.target.name,event.target.value));_context.next=3;return _this.props.client.query({query:GET_MODELS,variables:{manufacturerId:event.target.value}});case 3:_ref2=_context.sent;models=_ref2.data;_this.setState({models:models.models});case 6:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.handleModelChange=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(event){var _ref4,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_this.setState(_defineProperty({},event.target.name,event.target.value));_context2.next=3;return _this.props.client.query({query:GET_MODEL_TYPE,variables:{modelId:event.target.value},fetchPolicy:'network-only'});case 3:_ref4=_context2.sent;data=_ref4.data;_this.setState({deviceType:data.deviceModel.devicetype});case 6:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref3.apply(this,arguments);};}();_this.handleOpen=function(){_this.setState({open:true});};_this.handleOpenSelect=function(){_this.setState({open1:true});};_this.handleCloseSelect=function(){_this.setState({open1:false});};_this.handleOpenSelectMan=function(){_this.setState({open_man:true});};_this.handleCloseSelectMan=function(){_this.setState({open_man:false});};_this.checkImeinoValidity=function(){// const regex = new RegExp(/^[0-9]{15}$/)
var regex=new RegExp(/^[a-zA-Z0-9]{4,20}$/);_this.setState({errorMessage:''});var code=[];code=_this.state.manufacturerName.split('*');if(code[0]===''){_this.setState({isImeinoValid:_this.state.imeino!==''&&regex.test(_this.state.imeino)});}else{_this.setState({isImeinoValid:_this.state.imeino!==''&&regex.test(_this.state.imeino)});if(_this.state.deviceType==='AS140'){_this.setState({uniqueSerialNumber:code[1]+'_'+_this.state.imeino});}}};_this.checkSerialnoValidity=function(){_this.setState({errorMessage:''});// const regex = new RegExp(/^[0-9]{5,15}$/)
var regex=new RegExp(/^[a-zA-Z0-9]{4,20}$/);var code=[];code=_this.state.manufacturerName.split('*');if(code[0]===''){_this.setState({isSerialnoValid:_this.state.serialno!==''&&regex.test(_this.state.serialno)});}else{_this.setState({isSerialnoValid:_this.state.serialno!==''&&regex.test(_this.state.serialno)// uniqueSerialNumber: code[1] + '_' + this.state.serialno
});if(_this.state.deviceType!=='AS140'){// var code = this.state.manufacturerName.split('*')
_this.setState({uniqueSerialNumber:code[1]+'_'+_this.state.serialno});}}};_this.checkModelNameValidity=function(){_this.setState({isModelNameValid:_this.state.modelname!==''});};_this.checkManufacturerNameValidity=function(){var code=[];code=_this.state.manufacturerName.split('*');if(code[0]===''){_this.setState({isManufacturerNameValid:_this.state.manufacturerName!=='',// manufacturerCode:this
uniqueSerialNumber:code[1]+'_'+_this.state.serialno,manufacturerId:code[0]});}else{_this.setState({isManufacturerNameValid:_this.state.manufacturerName!=='',// manufacturerCode:this
uniqueSerialNumber:'',manufacturerId:code[0]});}};_this.handleCheckboxChange=function(event){_this.setState({is_panic_enabled:event.target.checked});};_this.handleSubmit=function(updateDevice){return function(e){e.preventDefault();updateDevice({variables:{serial_num:_this.state.serialno,imei_num:_this.state.imeino,device_model_id:parseInt(_this.state.modelname,10),uniqueSerialNumber:_this.state.uniqueSerialNumber,manufacturerId:parseInt(_this.state.manufacturerId,10),status:2,ownerLoginId:Object(__WEBPACK_IMPORTED_MODULE_17__utils_getLoginId__["a" /* default */])(),oldUniqueDeviceId:_this.existingUniqueId,is_panic_enabled:_this.state.is_panic_enabled},refetchQueries:['getPartnerDeviceStockByDeviceModel']});// this.state.simprovider = ''
_this.setState({serialno:'',imeino:'',// device_model_id: '',
uniqueSerialNumber:'',manufacturerId:'',is_panic_enabled:false});};};_this.deleteDevice=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(event){var _ref6,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:event.preventDefault();_context3.next=3;return _this.props.client.mutate({mutation:DELETE_DEVICE,variables:{uniqueDeviceid:_this.existingUniqueId},refetchQueries:['getAllDeviceDetailsByLoginId'],errorPolicy:'all'});case 3:_ref6=_context3.sent;data=_ref6.data;if(data.deleteDeviceInStock===true){_this.props.handleClose();_this.props.openSnackbar('Device Deleted Successfully');}else{_this.props.openSnackbar('Error in deleting device');}case 6:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x3){return _ref5.apply(this,arguments);};}();_this.getDeviceDetails=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){var _ref8,data,_ref9,models;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return _this.props.client.query({query:GET_DEVICE_DETAIL,variables:{uniqueDeviceId:_this.existingUniqueId},fetchPolicy:'network-only'});case 2:_ref8=_context4.sent;data=_ref8.data;_context4.next=6;return _this.props.client.query({query:GET_MODELS,variables:{manufacturerId:data.deviceDetail.manufacturer.id}});case 6:_ref9=_context4.sent;models=_ref9.data;_this.setState({models:models.models,is_panic_enabled:data.deviceDetail.is_panic_enabled});_this.setDetails(data.deviceDetail);case 10:case'end':return _context4.stop();}}},_callee4,_this2);}));_this.setDetails=function(DeviceDetail){var mafName=DeviceDetail.manufacturer.id+'*'+DeviceDetail.manufacturer.manufacturerCode;_this.setState({modelname:DeviceDetail.deviceModelId.id,serialno:DeviceDetail.serial_num,imeino:DeviceDetail.imei_num,uniqueSerialNumber:DeviceDetail.uniqueDeviceId,manufacturerName:mafName,manufacturerId:DeviceDetail.manufacturer.id,is_panic_enabled:DeviceDetail.is_panic_enabled// manufacturerId: DeviceDetail.manufacturer.id
});};_this.classes=props;_this.existingUniqueId=_this.props.selUniqueDecviceId;return _this;}_createClass(EditDevice,[{key:'componentDidMount',value:function componentDidMount(){this.getDeviceDetails();}},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;return(// <Query query={GET_MODELS} fetchPolicy="network-only">
//   {({ loading: isModelsLoading, error, data: { models } }) => (
__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_apollo__["Query"],{query:GET_MANUFACTURER,fetchPolicy:'network-only'},function(_ref10){var isManufacturersLoading=_ref10.loading,error=_ref10.error,manufacturers=_ref10.data.manufacturers;if(isManufacturersLoading)return null;if(error)return'Error!: '+error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_apollo__["Mutation"],{mutation:UPDATE_DEVICE},function(updateDevice,_ref11){var data=_ref11.data,error=_ref11.error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle___default.a,{id:'form-dialog-title'},'Add Device Details :'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core__["Typography"],{variant:'subheading',gutterBottom:true,style:{color:'red',marginLeft:'25px'}},error&&error.graphQLErrors.map(function(_ref12,i){var message=_ref12.message;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{key:i},message);}),_this3.state.errorMessage&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,_this3.state.errorMessage)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core__["Typography"],{variant:'subheading',gutterBottom:true,style:{color:'green',marginLeft:'25px'}},data&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Sucessfully Updated')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Divider___default.a,{light:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{onSubmit:_this3.handleSubmit(updateDevice)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText___default.a,null,'* Marked fields are mandatory'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel___default.a,{htmlFor:'demo-controlled-open-select'},'Select Manufacturer *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select___default.a,{open:_this3.state.open_man,fullWidth:true,onClose:_this3.handleCloseSelectMan,onOpen:_this3.handleOpenSelectMan,value:_this3.state.manufacturerName,onChange:_this3.handleChange,onBlur:_this3.checkManufacturerNameValidity,inputProps:{name:'manufacturerName',id:'manufacturerName'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),manufacturers.map(function(manufacturer){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{value:manufacturer.id+'*'+manufacturer.manufacturerCode,key:manufacturer.id},manufacturer.manufacturerName);}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel___default.a,{htmlFor:'demo-controlled-open-select'},'Select Model *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select___default.a,{open:_this3.state.open1,fullWidth:true,onClose:_this3.handleCloseSelect,onOpen:_this3.handleOpenSelect,value:_this3.state.modelname,onChange:_this3.handleModelChange,onBlur:_this3.checkModelNameValidity,inputProps:{name:'modelname',id:'modelname'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),_this3.state.models.map(function(allDeviceModelsByStatus){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{value:allDeviceModelsByStatus.id,key:allDeviceModelsByStatus.id},allDeviceModelsByStatus.model_name);}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField___default.a,{margin:'dense',id:'serialno',name:'serialno',label:'Serial No',type:'text',required:true,value:_this3.state.serialno,fullWidth:true,onChange:_this3.handleInputChange('serialno'),error:!_this3.state.isSerialnoValid,onBlur:_this3.checkSerialnoValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this3.state.isSerialnoValid?'':'Serial Number should be between 4-20 characters')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField___default.a,{margin:'dense',id:'imeino',name:'imeino',label:'IMEI No',type:'text',required:true,fullWidth:true,value:_this3.state.imeino,onChange:_this3.handleInputChange('imeino'),error:!_this3.state.isImeinoValid,onBlur:_this3.checkImeinoValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this3.state.isImeinoValid?'':'IMEI Number should be between 4-20 characters')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{width:'100%',paddingRight:'14rem'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'uniqueSerialNumber',name:'uniqueSerialNumber',label:'Unique Id',type:'text',disabled:true,required:true,fullWidth:true,value:_this3.state.uniqueSerialNumber,onChange:_this3.handleInputChange('uniqueSerialNumber')// error={!this.state.isImeinoValid}
// onBlur={this.checkImeinoValidity}
})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core__["FormControlLabel"],{label:'Enable Panic Button ?',control:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__material_ui_core_Checkbox___default.a,{checked:_this3.state.is_panic_enabled,onChange:_this3.handleCheckboxChange,inputProps:{'aria-label':'controlled'}})})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:_this3.props.handleClose,color:'default',variant:'contained'},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a// onClick={this.handleClose}
,{type:'submit',color:'primary',variant:'contained',disabled:!(_this3.state.isModelNameValid&&_this3.state.isSerialnoValid&&_this3.state.isImeinoValid&&_this3.state.serialno!==''&&_this3.state.imeino!==''&&_this3.state.manufacturerName!==''&&_this3.state.uniqueSerialNumber!==''&&_this3.state.modelname!=='')},'Submit'))));});})//   )}
// </Query>
);}}]);return EditDevice;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_15_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_19__HOCs_withSharedSnackbar__["a" /* default */])(EditDevice))));

/***/ }),
/* 2351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Dialog__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AddSMSToPartner___ = __webpack_require__(2352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_getLoginId__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getAllSMSBalanceDetails($partnerLoginId: Int!) {\n    sms: getAllSMSBalanceDetails(fromLoginId: $partnerLoginId) {\n      resellerName\n      businessName\n      smsBalance\n      totalSMS\n      key\n      clientId\n      toAccountType\n    }\n  }\n'],['\n  query getAllSMSBalanceDetails($partnerLoginId: Int!) {\n    sms: getAllSMSBalanceDetails(fromLoginId: $partnerLoginId) {\n      resellerName\n      businessName\n      smsBalance\n      totalSMS\n      key\n      clientId\n      toAccountType\n    }\n  }\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var style=function style(theme){return{root:{padding:theme.spacing.unit*4,flexGrow:1},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},iconSmall:{fontSize:20}};};var GET_SMS_STOCK=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject);var PartnerSMSPurchase=function(_Component){_inherits(PartnerSMSPurchase,_Component);function PartnerSMSPurchase(props){_classCallCheck(this,PartnerSMSPurchase);var _this=_possibleConstructorReturn(this,(PartnerSMSPurchase.__proto__||Object.getPrototypeOf(PartnerSMSPurchase)).call(this,props));_this.clientId=[];_this.columns=['PARTNER NAME','TOTAL PURCHASE','AVAILABLE BALANCE'];_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15,filter:false};_this.state={open:false,open1:false};_this.handleClickOpen=function(){_this.setState({open:true});console.log('rr',_this.state.open);};_this.handleClose=function(){_this.setState({open:false});};_this.salesReportAdmin=function(){_this.props.history.push({pathname:'/home/manage/admin/SalesReport'});};_this.classes=props;return _this;}_createClass(PartnerSMSPurchase,[{key:'mapToArr',value:function mapToArr(sms){var rowData=[];var fullData=[];// this.clientId = []
sms.forEach(function(element){rowData=[];// this.clientId.push(element.id)
if(element.toAccountType==='RES'){rowData.push(element.resellerName);}else{rowData.push(element.businessName);}rowData.push(element.totalSMS);rowData.push(element.smsBalance);fullData.push(rowData);});return fullData;}},{key:'render',value:function render(){var _this2=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["Query"],{query:GET_SMS_STOCK,variables:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_10__utils_getLoginId__["a" /* default */])()}},function(_ref){var loading=_ref.loading,error=_ref.error,sms=_ref.data.sms;if(loading)return'Loading...';if(error)return'Error!: '+error;var data=_this2.mapToArr(sms);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row-reverse',justify:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default.a,{color:'secondary'// href="/home/customers/add"
,variant:'contained',className:classes.button,onClick:_this2.handleClickOpen},'Add SMS Count'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default.a,{color:'secondary'// href="/home/customers/add"
,variant:'contained',className:classes.button,onClick:_this2.salesReportAdmin},'Sales Report')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'headline'},'SMS Count Details'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Dialog___default.a,{open:_this2.state.open,onClose:_this2.handleClose,'aria-labelledby':'form-dialog-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__AddSMSToPartner___["a" /* default */],{handleClose:_this2.handleClose})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_mui_datatables___default.a,{data:data,columns:_this2.columns,options:_this2.options}))));});}}]);return PartnerSMSPurchase;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["withApollo"])(PartnerSMSPurchase)));

/***/ }),
/* 2352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogActions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogContent__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_DialogContentText__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_DialogContentText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_DialogContentText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_DialogTitle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_DialogTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_DialogTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__HOCs_withSharedSnackbar__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query {\n    reseller: getAllResellerDetails(status: 1) {\n      login {\n        loginId\n      }\n      resellerName\n    }\n  }\n'],['\n  query {\n    reseller: getAllResellerDetails(status: 1) {\n      login {\n        loginId\n      }\n      resellerName\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query {\n    parter: allPartnerDetails(status: 1) {\n      businessName\n      login {\n        loginId\n      }\n    }\n  }\n'],['\n  query {\n    parter: allPartnerDetails(status: 1) {\n      businessName\n      login {\n        loginId\n      }\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query getSMSBalanceDetails($partnerLoginId: Int!) {\n    getSMSBalanceDetails(toLoginId: $partnerLoginId) {\n      smsBalance\n      key\n      clientId\n      sms_gateway\n      username\n      password\n    }\n  }\n'],['\n  query getSMSBalanceDetails($partnerLoginId: Int!) {\n    getSMSBalanceDetails(toLoginId: $partnerLoginId) {\n      smsBalance\n      key\n      clientId\n      sms_gateway\n      username\n      password\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  mutation addsmsPurchaseHistorySuperAdmin(\n    $fromLoginId: Int!\n    $fromAccountType: String!\n    $toLoginId: Int!\n    $toAccountType: String!\n    $transactionType: String!\n    $status: Int\n    $smsCount: Int!\n    $key: String\n    $clientId: String\n    $smsType: smsGateways!\n    $username: String\n    $password: String\n  ) {\n    addsmsPurchaseHistorySuperAdmin(\n      fromLoginId: $fromLoginId\n      fromAccountType: $fromAccountType\n      toLoginId: $toLoginId\n      toAccountType: $toAccountType\n      transactionType: $transactionType\n      status: $status\n      smsCount: $smsCount\n      key: $key\n      clientId: $clientId\n      sms_gateway: $smsType\n      username: $username\n      password: $password\n    )\n  }\n'],['\n  mutation addsmsPurchaseHistorySuperAdmin(\n    $fromLoginId: Int!\n    $fromAccountType: String!\n    $toLoginId: Int!\n    $toAccountType: String!\n    $transactionType: String!\n    $status: Int\n    $smsCount: Int!\n    $key: String\n    $clientId: String\n    $smsType: smsGateways!\n    $username: String\n    $password: String\n  ) {\n    addsmsPurchaseHistorySuperAdmin(\n      fromLoginId: $fromLoginId\n      fromAccountType: $fromAccountType\n      toLoginId: $toLoginId\n      toAccountType: $toAccountType\n      transactionType: $transactionType\n      status: $status\n      smsCount: $smsCount\n      key: $key\n      clientId: $clientId\n      sms_gateway: $smsType\n      username: $username\n      password: $password\n    )\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_RESELLER_LIST=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject);var GET_PARTNER_LIST=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject2);var GET_SMS_STOCK=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject3);// calling server for updation
var ADD_SMS=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject4);var styles=function styles(theme){return{button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{margin:theme.spacing.unit,minWidth:120}};};var AddSMSToPartner=function(_Component){_inherits(AddSMSToPartner,_Component);function AddSMSToPartner(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,AddSMSToPartner);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AddSMSToPartner.__proto__||Object.getPrototypeOf(AddSMSToPartner)).call.apply(_ref,[this].concat(args))),_this),_this.state={open1:false,partnername:'',partnerNames:[],accountType:'',key:'',clientid:'',credit:'',isPartnerNameValid:true,iskeyValid:true,isClientidValid:true,isAccountTypeValid:true,isCreditValid:true,open_man:false,availableBalance:0,smsType:'',username:'',password:'',isusernameValid:true,isPasswordValid:true},_this.handleInputChange=function(key){return function(e){return _this.setState(_defineProperty({},key,e.target.value));};},_this.handleChange=function(client){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _ref3,data,_ref4,_data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.setState(_defineProperty({},event.target.name,event.target.value));if(!(event.target.value==='RES')){_context.next=9;break;}_context.next=4;return client.query({query:GET_RESELLER_LIST,variables:{businessname:_this.state.name},refetchQueries:['getAllSMSBalanceDetails']});case 4:_ref3=_context.sent;data=_ref3.data;_this.setState({partnerNames:data.reseller});_context.next=14;break;case 9:_context.next=11;return client.query({query:GET_PARTNER_LIST,variables:{businessname:_this.state.name}});case 11:_ref4=_context.sent;_data=_ref4.data;_this.setState({partnerNames:_data.parter});case 14:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}();},_this.handleChangePartner=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(event){var _ref6,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_this.setState(_defineProperty({},event.target.name,event.target.value));_context2.next=3;return _this.props.client.query({query:GET_SMS_STOCK,variables:{partnerLoginId:parseInt(event.target.value,10)},errorPolicy:'all'});case 3:_ref6=_context2.sent;data=_ref6.data;if(data.getSMSBalanceDetails){_this.setState({key:data.getSMSBalanceDetails.key,clientid:data.getSMSBalanceDetails.clientId,availableBalance:data.getSMSBalanceDetails.smsBalance,username:data.getSMSBalanceDetails.username,password:data.getSMSBalanceDetails.password,smsType:data.getSMSBalanceDetails.sms_gateway});}else{_this.setState({key:'',clientid:'',availableBalance:0});}case 6:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref5.apply(this,arguments);};}(),_this.handleOpen=function(){return _this.setState({open:true});},_this.handleOpenSelect=function(){return _this.setState({open1:true});},_this.handleCloseSelect=function(){return _this.setState({open1:false});},_this.handleOpenSelectMan=function(){return _this.setState({open_man:true});},_this.handleCloseSelectMan=function(){return _this.setState({open_man:false});},_this.handleOpenSelectType=function(){return _this.setState({open_type:true});},_this.handleCloseSelectType=function(){return _this.setState({open_type:false});},_this.checkCreditValidity=function(){var regex=new RegExp(/^[0-9]*[1-9][0-9]*$/);_this.setState({isCreditValid:regex.test(_this.state.credit)&&_this.state.credit!==''});},_this.handleChangeType=function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(event){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:return _context3.abrupt('return',_this.setState(_defineProperty({},event.target.name,event.target.value)));case 1:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x3){return _ref7.apply(this,arguments);};}(),_this.handleSubmit=function(type){return function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(e){var _ref9,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:e.preventDefault();if(!(_this.state.availableBalance>=_this.state.credit&&type==='Debit'||type==='Credit')){_context4.next=10;break;}_context4.next=4;return _this.props.client.mutate({mutation:ADD_SMS,variables:{fromLoginId:Object(__WEBPACK_IMPORTED_MODULE_16__utils_getLoginId__["a" /* default */])(),fromAccountType:localStorage.getItem('Account_type'),toLoginId:parseInt(_this.state.partnername,10),toAccountType:_this.state.accountType,transactionType:type,status:1,smsCount:parseInt(_this.state.credit,10),key:_this.state.key,clientId:_this.state.clientid,username:_this.state.username,password:_this.state.password,smsType:_this.state.smsType}});case 4:_ref9=_context4.sent;data=_ref9.data;_this.setState({serial_num:'',imei_num:'',device_model_id:'',uniqueSerialNumber:'',manufacturerId:''});if(data){_this.props.openSnackbar('SMS Updated Successfully');_this.props.handleClose();}else{_this.props.openSnackbar('Updation Failed');}_context4.next=11;break;case 10:_this.props.openSnackbar('Insufficient Balance');case 11:case'end':return _context4.stop();}}},_callee4,_this2);}));return function(_x4){return _ref8.apply(this,arguments);};}();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AddSMSToPartner,[{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_DialogTitle___default.a,{id:'form-dialog-title'},'Add SMS Credits :'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_Divider___default.a,{light:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_DialogContentText___default.a,null,'* Marked fields are mandatory'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_InputLabel___default.a,{htmlFor:'demo-controlled-open-select'},'Select AccountType *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Select___default.a,{open:this.state.open_man,fullWidth:true,onClose:this.handleCloseSelectMan,onOpen:this.handleOpenSelectMan,value:this.state.accountType,onChange:this.handleChange(this.props.client),inputProps:{name:'accountType',id:'accountType'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_MenuItem___default.a,{value:'RES'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'Reseller')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_MenuItem___default.a,{value:'PA'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'Business Admin')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_InputLabel___default.a,{htmlFor:'demo-controlled-open-select'},'Select Partner *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Select___default.a,{open:this.state.open1,fullWidth:true,onClose:this.handleCloseSelect,onOpen:this.handleOpenSelect,value:this.state.partnername,onChange:this.handleChangePartner,inputProps:{name:'partnername',id:'partnername'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),this.state.partnerNames.map(function(allPartners){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_MenuItem___default.a,{value:allPartners.login.loginId,key:allPartners.login.loginId},_this3.state.accountType==='RES'?allPartners.resellerName:allPartners.businessName);}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_InputLabel___default.a,{htmlFor:'demo-controlled-open-select'},'Select SMS Type *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Select___default.a,{open:this.state.open_type,fullWidth:true,onClose:this.handleCloseSelectType,onOpen:this.handleOpenSelectType,value:this.state.smsType,onChange:this.handleChangeType,inputProps:{name:'smsType',id:'smsType'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_MenuItem___default.a,{value:'GUPSHUP'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'GUPSHUP')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_MenuItem___default.a,{value:'SMSINFINY'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'SMSINFINY')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_MenuItem___default.a,{value:'ETECH_KEYS'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'ETECH_KEYS')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_MenuItem___default.a,{value:'BOSCH_SMS_API'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'BOSCH_SMS_API')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'availableBalance',name:'availableBalance',label:'availableBalance',type:'text',required:true,value:this.state.availableBalance,fullWidth:true,disabled:true})),this.state.smsType==='SMSINFINY'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'key',name:'key',label:'Key',type:'text',required:true,value:this.state.key,fullWidth:true,onChange:this.handleInputChange('key'),error:!this.state.iskeyValid,onBlur:this.checkkeyValidity})),(this.state.smsType==='SMSINFINY'||this.state.smsType==='ETECH_KEYS')&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'clientid',name:'clientid',label:this.state.smsType==='ETECH_KEYS'?'Sender Id':'Client Id',type:'text',required:true,fullWidth:true,value:this.state.clientid,onChange:this.handleInputChange('clientid'),error:!this.state.isClientidValid,onBlur:this.checkClientidValidity})),(this.state.smsType==='GUPSHUP'||this.state.smsType==='ETECH_KEYS')&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'username',name:'username',label:'Username',type:'text',required:true,value:this.state.username,fullWidth:true,onChange:this.handleInputChange('username'),error:!this.state.isusernameValid,onBlur:this.checkUsernameValidity})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'password',name:'password',label:'Password',type:'password',required:true,fullWidth:true,value:this.state.password,onChange:this.handleInputChange('password'),error:!this.state.isPasswordValid,onBlur:this.checkPasswordValidity}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'credit',name:'credit',label:'Credit',type:'text',required:true,fullWidth:true,value:this.state.credit,onChange:this.handleInputChange('credit'),error:!this.state.isCreditValid,onBlur:this.checkCreditValidity}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogActions___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default.a,{onClick:this.props.handleClose,color:'default',variant:'contained'},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default.a,{onClick:this.handleSubmit('Debit'),type:'submit',color:'primary',variant:'contained',disabled:!(this.state.isPartnerNameValid&&this.state.iskeyValid&&this.state.isClientidValid&&(this.state.key!==''||this.state.username!=='')&&(this.state.clientid!==''||this.state.password!=='')&&this.state.partnername!==''&&this.state.credit!==''&&this.state.isCreditValid&&this.state.accountType!==''&&this.state.smsType!==''&&this.state.availableBalance>0)},'Debit'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default.a,{onClick:this.handleSubmit('Credit'),type:'submit',color:'primary',variant:'contained',disabled:!(this.state.isPartnerNameValid&&this.state.iskeyValid&&this.state.isClientidValid&&// this.state.key !== '' &&
// this.state.clientid !== '' &&
this.state.partnername!==''&&this.state.credit!==''&&this.state.isCreditValid&&this.state.accountType!=='')},'Credit'))));}}]);return AddSMSToPartner;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_17__HOCs_withSharedSnackbar__["a" /* default */])(AddSMSToPartner))));

/***/ }),
/* 2353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Dialog__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AddSMSToClient__ = __webpack_require__(2354);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getAllSMSBalanceDetails($partnerLoginId: Int!) {\n    sms: getAllSMSBalanceDetails(fromLoginId: $partnerLoginId) {\n      clientName\n      smsBalance\n      totalSMS\n      key\n      clientId\n    }\n  }\n'],['\n  query getAllSMSBalanceDetails($partnerLoginId: Int!) {\n    sms: getAllSMSBalanceDetails(fromLoginId: $partnerLoginId) {\n      clientName\n      smsBalance\n      totalSMS\n      key\n      clientId\n    }\n  }\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var style=function style(theme){return{root:{padding:theme.spacing.unit*4,flexGrow:1},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},iconSmall:{fontSize:20}};};var GET_SMS_STOCK=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject);var ClientSMSPurchase=function(_Component){_inherits(ClientSMSPurchase,_Component);function ClientSMSPurchase(props){_classCallCheck(this,ClientSMSPurchase);var _this=_possibleConstructorReturn(this,(ClientSMSPurchase.__proto__||Object.getPrototypeOf(ClientSMSPurchase)).call(this,props));_this.clientId=[];_this.columns=['CLIENT NAME','TOTAL PURCHASE','AVAILABLE BALANCE'];_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15,filter:false};_this.state={open:false,open1:false};_this.handleClickOpen=function(){_this.setState({open:true});console.log('rr',_this.state.open);};_this.handleClose=function(){_this.setState({open:false});};_this.handleClickBulkOpen=function(){_this.setState({open1:true});};_this.handleBulkClose=function(){_this.setState({open1:false});};_this.salesReportReseller=function(){_this.props.history.push({pathname:'/home/manage/partner/SalesReport'});};_this.panicAlertBitSet=function(){_this.props.history.push({pathname:'/home/manage/admin/PanicAlertBitConfigurationSettings'});};_this.currentSummary=function(){_this.props.history.push({pathname:'/home/manage/admin/CurrentSummary'});};_this.createInvoice=function(){_this.props.history.push({pathname:'/home/manage/admin/InvoiceDetails'});};_this.classes=props;return _this;}_createClass(ClientSMSPurchase,[{key:'mapToArr',value:function mapToArr(sms){var rowData=[];var fullData=[];// this.clientId = []
sms.forEach(function(element){rowData=[];// this.clientId.push(element.id)
rowData.push(element.clientName);rowData.push(element.totalSMS);rowData.push(element.smsBalance);fullData.push(rowData);});return fullData;}},{key:'render',value:function render(){var _this2=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["Query"],{query:GET_SMS_STOCK,variables:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_9__utils_getLoginId__["a" /* default */])()},fetchPolicy:'cache-and-network'},function(_ref){var loading=_ref.loading,error=_ref.error,sms=_ref.data.sms;if(loading)return'Loading...';if(error)return'Error!: '+error;console.log('data',sms);var data=_this2.mapToArr(sms);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row-reverse',justify:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default.a,{color:'secondary'// href="/home/customers/add"
,variant:'contained',className:classes.button,onClick:_this2.handleClickOpen},'Add SMS Count'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default.a,{color:'secondary'// href="/home/customers/add"
,variant:'contained',className:classes.button,onClick:_this2.salesReportReseller},'Sales Report'),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'headline'},'SMS Count Details'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Dialog___default.a,{open:_this2.state.open,onClose:_this2.handleClose,'aria-labelledby':'form-dialog-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__AddSMSToClient__["a" /* default */],{handleClose:_this2.handleClose})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_mui_datatables___default.a,{data:data,columns:_this2.columns,options:_this2.options}))));});}}]);return ClientSMSPurchase;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["withApollo"])(ClientSMSPurchase)));

/***/ }),
/* 2354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogActions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_DialogContent__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_DialogContentText__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_DialogContentText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_DialogContentText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_DialogTitle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_DialogTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_DialogTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__HOCs_withSharedSnackbar__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query allClientDetails($partnerLoginId: Int) {\n    clients: allClientDetails(partnerLoginId: $partnerLoginId) {\n      loginId\n      clientName\n    }\n  }\n'],['\n  query allClientDetails($partnerLoginId: Int) {\n    clients: allClientDetails(partnerLoginId: $partnerLoginId) {\n      loginId\n      clientName\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query allClientDetails($resellerLoginId: Int) {\n    clients: allClientDetails(resellerLoginId: $resellerLoginId) {\n      loginId\n      clientName\n    }\n  }\n'],['\n  query allClientDetails($resellerLoginId: Int) {\n    clients: allClientDetails(resellerLoginId: $resellerLoginId) {\n      loginId\n      clientName\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query getSMSBalanceDetails($partnerLoginId: Int!) {\n    getSMSBalanceDetails(toLoginId: $partnerLoginId) {\n      smsBalance\n      totalSMS\n      key\n      clientId\n      sms_gateway\n      username\n      password\n    }\n  }\n'],['\n  query getSMSBalanceDetails($partnerLoginId: Int!) {\n    getSMSBalanceDetails(toLoginId: $partnerLoginId) {\n      smsBalance\n      totalSMS\n      key\n      clientId\n      sms_gateway\n      username\n      password\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  mutation addsmsPurchaseHistoryRESAndPRT(\n    $fromLoginId: Int!\n    $fromAccountType: String!\n    $toLoginId: Int!\n    $toAccountType: String!\n    $key: String!\n    $clientId: String!\n    $transactionType: String!\n    $status: Int!\n    $smsCount: Int!\n    $sms_gateway: smsGateways!\n    $username: String\n    $password: String\n  ) {\n    addsmsPurchaseHistoryRESAndPRT(\n      fromLoginId: $fromLoginId\n      fromAccountType: $fromAccountType\n      toLoginId: $toLoginId\n      toAccountType: $toAccountType\n      key: $key\n      clientId: $clientId\n      transactionType: $transactionType\n      status: $status\n      smsCount: $smsCount\n      sms_gateway: $sms_gateway\n      username: $username\n      password: $password\n    )\n  }\n'],['\n  mutation addsmsPurchaseHistoryRESAndPRT(\n    $fromLoginId: Int!\n    $fromAccountType: String!\n    $toLoginId: Int!\n    $toAccountType: String!\n    $key: String!\n    $clientId: String!\n    $transactionType: String!\n    $status: Int!\n    $smsCount: Int!\n    $sms_gateway: smsGateways!\n    $username: String\n    $password: String\n  ) {\n    addsmsPurchaseHistoryRESAndPRT(\n      fromLoginId: $fromLoginId\n      fromAccountType: $fromAccountType\n      toLoginId: $toLoginId\n      toAccountType: $toAccountType\n      key: $key\n      clientId: $clientId\n      transactionType: $transactionType\n      status: $status\n      smsCount: $smsCount\n      sms_gateway: $sms_gateway\n      username: $username\n      password: $password\n    )\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_PARTNER_CLIENT_LIST=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject);var GET_RESELLER_CLIENT_LIST=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject2);var GET_SMS_STOCK=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject3);// calling server for updation
var ADD_SMS=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject4);var styles=function styles(theme){return{button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{margin:theme.spacing.unit,minWidth:120}};};var AddSMSToClient=function(_Component){_inherits(AddSMSToClient,_Component);function AddSMSToClient(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,AddSMSToClient);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AddSMSToClient.__proto__||Object.getPrototypeOf(AddSMSToClient)).call.apply(_ref,[this].concat(args))),_this),_this.state={open1:false,clientname:'',clientNames:[],smsTypes:[],credit:'',isClientNameValid:true,isCreditValid:true,open_man:false,smsBalance:0,clientid:'',key:'',smsType:'',username:'',password:'',availableBalance:0,isusernameValid:true,isPasswordValid:true,iskeyValid:true,isClientidValid:true,partnerClientId:'',partnerkey:'',partnerGateWay:'',partnerUsername:'',PartnerPassword:''},_this.handleInputChange=function(key){return function(e){return _this.setState(_defineProperty({},key,e.target.value));};},_this.handleChange=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _ref3,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.setState({clientname:event.value});_context.next=3;return _this.props.client.query({query:GET_SMS_STOCK,variables:{partnerLoginId:event.value},errorPolicy:'all',fetchPolicy:'network-only'});case 3:_ref3=_context.sent;data=_ref3.data;// console.log('prt', data.getSMSBalanceDetails)
if(data.getSMSBalanceDetails){_this.setState({availableBalance:data.getSMSBalanceDetails.smsBalance,key:data.getSMSBalanceDetails.key,clientid:data.getSMSBalanceDetails.clientId,username:data.getSMSBalanceDetails.username,password:data.getSMSBalanceDetails.password,smsType:data.getSMSBalanceDetails.sms_gateway});}else{_this.setState({key:_this.state.partnerkey,clientid:_this.state.partnerClientId,smsType:_this.state.partnerGateWay,username:_this.state.partnerUsername,password:_this.state.PartnerPassword,availableBalance:0});}case 6:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}(),_this.handleOpen=function(){return _this.setState({open:true});},_this.checkImeinoValidity=function(){_this.setState({isImeinoValid:_this.state.imeino!==''});},_this.checkSerialnoValidity=function(){return _this.setState({isSerialnoValid:_this.state.serialno!==''});},_this.checkModelNameValidity=function(){return _this.setState({isModelNameValid:_this.state.modelname!==''});},_this.checkCreditValidity=function(){var regex=new RegExp(/^[0-9]*[1-9][0-9]*$/);_this.setState({isCreditValid:regex.test(_this.state.credit)&&_this.state.credit!==''});},_this.handleSubmit=function(type){return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(e){var credited,_ref5,data,_ref6,_data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:e.preventDefault();console.log(_this.state.smsBalance,parseInt(_this.state.credit),type);credited=parseInt(_this.state.credit);if(!(type==='Credit')){_context2.next=18;break;}console.log('inside if of credit');if(!(_this.state.smsBalance>=credited)){_context2.next=15;break;}console.log('inside if  his.state.smsBalance >= credited');_context2.next=9;return _this.props.client.mutate({mutation:ADD_SMS,variables:{fromLoginId:Object(__WEBPACK_IMPORTED_MODULE_14__utils_getLoginId__["a" /* default */])(),fromAccountType:localStorage.getItem('Account_type'),toLoginId:parseInt(_this.state.clientname,10),toAccountType:'CLT',key:_this.state.key,clientId:_this.state.clientid,transactionType:type,status:1,smsCount:parseInt(_this.state.credit,10),username:_this.state.username,password:_this.state.password,sms_gateway:_this.state.smsType},refetchQueries:['getAllSMSBalanceDetails','getSMSBalanceDetails']});case 9:_ref5=_context2.sent;data=_ref5.data;_this.setState({credit:'',clientid:'',availableBalance:'',smsBalance:''});if(data){_this.props.openSnackbar('SMS Updated Successfully');_this.props.handleClose();}else{_this.props.openSnackbar('Updation Failed');}_context2.next=16;break;case 15:_this.props.openSnackbar('Insufficient Balance to Credit');case 16:_context2.next=31;break;case 18:if(!(type==='Debit')){_context2.next=31;break;}console.log('inside if of debit');if(!(_this.state.availableBalance>=_this.state.credit)){_context2.next=30;break;}console.log('inside if of this.state.availableBalance >= debit');_context2.next=24;return _this.props.client.mutate({mutation:ADD_SMS,variables:{fromLoginId:Object(__WEBPACK_IMPORTED_MODULE_14__utils_getLoginId__["a" /* default */])(),fromAccountType:localStorage.getItem('Account_type'),toLoginId:parseInt(_this.state.clientname,10),toAccountType:'CLT',key:_this.state.key,clientId:_this.state.clientid,transactionType:type,status:1,smsCount:parseInt(_this.state.credit,10),username:_this.state.username,password:_this.state.password,sms_gateway:_this.state.smsType},refetchQueries:['getAllSMSBalanceDetails','getSMSBalanceDetails']});case 24:_ref6=_context2.sent;_data=_ref6.data;_this.setState({credit:'',clientid:'',availableBalance:'',smsBalance:''});if(_data){_this.props.openSnackbar('SMS Updated Successfully');_this.props.handleClose();}else{_this.props.openSnackbar('Updation Failed');}_context2.next=31;break;case 30:_this.props.openSnackbar('Insufficient Balance to Debit');case 31:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref4.apply(this,arguments);};}();},_this.getClients=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var _ref8,data,allClients,_ref9,_data2,_allClients;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:if(!(localStorage.getItem('Account_type')==='RES')){_context3.next=9;break;}_context3.next=3;return _this.props.client.query({query:GET_RESELLER_CLIENT_LIST,variables:{resellerLoginId:parseInt(localStorage.getItem('Login_id'),10)},fetchPolicy:'network-only'});case 3:_ref8=_context3.sent;data=_ref8.data;allClients=data.clients.map(function(client){return{value:client.loginId,label:client.clientName};});_this.setState({clientNames:allClients});_context3.next=15;break;case 9:_context3.next=11;return _this.props.client.query({query:GET_PARTNER_CLIENT_LIST,variables:{partnerLoginId:parseInt(localStorage.getItem('Login_id'),10)}});case 11:_ref9=_context3.sent;_data2=_ref9.data;_allClients=_data2.clients.map(function(client){return{value:client.loginId,label:client.clientName};});_this.setState({clientNames:_allClients});case 15:case'end':return _context3.stop();}}},_callee3,_this2);})),_this.getSmsDetails=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){var _ref11,sms;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return _this.props.client.query({query:GET_SMS_STOCK,variables:{partnerLoginId:parseInt(localStorage.getItem('Login_id'),10)},fetchPolicy:'network-only'});case 2:_ref11=_context4.sent;sms=_ref11.data;_this.setState({smsBalance:sms.getSMSBalanceDetails.smsBalance,partnerkey:sms.getSMSBalanceDetails.key,partnerClientId:sms.getSMSBalanceDetails.clientId,partnerGateWay:sms.getSMSBalanceDetails.sms_gateway,partnerUsername:sms.getSMSBalanceDetails.username,PartnerPassword:sms.getSMSBalanceDetails.password});case 5:case'end':return _context4.stop();}}},_callee4,_this2);})),_this.handleChangeType=function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(event){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:if(event){_this.setState({smsType:event.value});}case 1:case'end':return _context5.stop();}}},_callee5,_this2);}));return function(_x3){return _ref12.apply(this,arguments);};}(),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AddSMSToClient,[{key:'componentDidMount',value:function componentDidMount(){this.getClients(this.props.client);this.getSmsDetails(this.props.client);}},{key:'render',value:function render(){var classes=this.props.classes;var smsGateways=['GUPSHUP','SMSINFINY','ETECH_KEYS','DBENT','BOSCH_SMS_API'];var smsTypes=smsGateways.map(function(smsGateway){return{value:smsGateway,label:smsGateway};});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_DialogTitle___default.a,{id:'form-dialog-title'},'Add SMS Credits :'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Divider___default.a,{light:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_DialogContentText___default.a,null,'* Marked fields are mandatory'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'smsBalance',name:'smsBalance',label:'Total Credit',type:'text',required:true,value:this.state.smsBalance,fullWidth:true,disabled:true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */],{classes:classes,options:this.state.clientNames,value:this.state.clientname,onChange:this.handleChange,placeholder:'Select Customer'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */],{classes:classes,options:smsTypes,value:this.state.smsType,onChange:this.handleChangeType,placeholder:'Select SMS Gateway'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'availableBalance',name:'availableBalance',label:'availableBalance',type:'text',required:true,value:this.state.availableBalance,fullWidth:true,disabled:true})),this.state.smsType==='SMSINFINY'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'key',name:'key',label:'Key',type:'text',required:true,value:this.state.key,fullWidth:true,onChange:this.handleInputChange('key'),error:!this.state.iskeyValid,onBlur:this.checkkeyValidity})),(this.state.smsType==='SMSINFINY'||this.state.smsType==='ETECH_KEYS')&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'clientid',name:'clientid',label:this.state.smsType==='ETECH_KEYS'?'Sender Id':'Client Id',type:'text',required:true,fullWidth:true,value:this.state.clientid,onChange:this.handleInputChange('clientid'),error:!this.state.isClientidValid,onBlur:this.checkClientidValidity})),(this.state.smsType==='GUPSHUP'||this.state.smsType==='ETECH_KEYS'||this.state.smsType==='DBENT')&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'username',name:'username',label:'Username',type:'text',required:true,value:this.state.username,fullWidth:true,onChange:this.handleInputChange('username'),error:!this.state.isusernameValid,onBlur:this.checkUsernameValidity})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'password',name:'password',label:'Password',type:'password',required:true,fullWidth:true,value:this.state.password,onChange:this.handleInputChange('password'),error:!this.state.isPasswordValid,onBlur:this.checkPasswordValidity}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{margin:'dense',id:'credit',name:'credit',label:'Credit',type:'text',required:true,fullWidth:true,value:this.state.credit,onChange:this.handleInputChange('credit'),error:!this.state.isCreditValid,onBlur:this.checkCreditValidity}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogActions___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{onClick:this.props.handleClose,color:'default',variant:'contained'},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{onClick:this.handleSubmit('Debit'),type:'submit',color:'primary',variant:'contained',disabled:!(this.state.clientname!==''&&this.state.credit!==''&&this.state.isCreditValid&&this.state.availableBalance>0)},'Debit'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{onClick:this.handleSubmit('Credit'),type:'submit',color:'primary',variant:'contained',disabled:!(this.state.clientname!==''&&this.state.credit!==''&&this.state.isCreditValid&&this.state.smsBalance>0)},'Credit'))));}}]);return AddSMSToClient;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_15__HOCs_withSharedSnackbar__["a" /* default */])(AddSMSToClient))));

/***/ }),
/* 2355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_pickers__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_ListItemText__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_ListItemText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_ListItemText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_icons_ArrowBack__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_icons_ArrowBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_icons_ArrowBack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__HOCs_withSharedSnackbar__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getallSMSPurchaseHistory(\n    $toLoginId: [Int!]!\n    $fromTimestamp: String!\n    $toTimestamp: String!\n  ) {\n    getallSMSPurchaseHistory(\n      toLoginId: $toLoginId\n      fromTimestamp: $fromTimestamp\n      toTimestamp: $toTimestamp\n    ) {\n      fromLoginId\n      fromAccountType\n      toLoginId\n      toAccountType\n      transactionType\n      smsCount\n      createdAt\n    }\n  }\n'],['\n  query getallSMSPurchaseHistory(\n    $toLoginId: [Int!]!\n    $fromTimestamp: String!\n    $toTimestamp: String!\n  ) {\n    getallSMSPurchaseHistory(\n      toLoginId: $toLoginId\n      fromTimestamp: $fromTimestamp\n      toTimestamp: $toTimestamp\n    ) {\n      fromLoginId\n      fromAccountType\n      toLoginId\n      toAccountType\n      transactionType\n      smsCount\n      createdAt\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query allClientDetails($partnerLoginId: Int) {\n    clients: allClientDetails(partnerLoginId: $partnerLoginId) {\n      id\n      clientName\n      loginId\n    }\n  }\n'],['\n  query allClientDetails($partnerLoginId: Int) {\n    clients: allClientDetails(partnerLoginId: $partnerLoginId) {\n      id\n      clientName\n      loginId\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_SMS_SALES_HISTORY=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject);var GET_CLIENTS=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject2);var style=function style(theme){return{root:{padding:theme.spacing.unit*4,flexGrow:1},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},iconSmall:{fontSize:20},selstyle:{maxHeight:ITEM_HEIGHT*4.5+ITEM_PADDING_TOP,width:250}};};var ITEM_HEIGHT=48;var ITEM_PADDING_TOP=8;var MenuProps={PaperProps:{style:{maxHeight:ITEM_HEIGHT*4.5+ITEM_PADDING_TOP,width:250}}};var PartnerClientSMSReport=function(_Component){_inherits(PartnerClientSMSReport,_Component);function PartnerClientSMSReport(props){var _this2=this;_classCallCheck(this,PartnerClientSMSReport);var _this=_possibleConstructorReturn(this,(PartnerClientSMSReport.__proto__||Object.getPrototypeOf(PartnerClientSMSReport)).call(this,props));_this.state={spacing:'16',smsSalesReportFrom:{date:__WEBPACK_IMPORTED_MODULE_10_moment___default()(),unix:__WEBPACK_IMPORTED_MODULE_10_moment___default()().unix().toString()},smsSalesReportTo:{date:__WEBPACK_IMPORTED_MODULE_10_moment___default()(),unix:__WEBPACK_IMPORTED_MODULE_10_moment___default()().unix().toString()},name:[],fullData:[],clientNameInfo:[],clientName:[],clientLoginId:[],clientNameLoginId:[],reportView:false};_this.columns=['CLIENT NAME','TRANSACTION TYPE','SMS COUNT','DATE TIME'];_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15,filter:false};_this.handleDateChange=function(name){return function(date){var tempDate=_this.state[name];tempDate.date=date;tempDate.unix=__WEBPACK_IMPORTED_MODULE_10_moment___default()(date).unix().toString();_this.setState(_defineProperty({},name,tempDate));};};_this.handleChange=function(event){var loginIdArr=[];event.target.value.forEach(function(val){var key=_this.state.clientNameInfo.indexOf(val);loginIdArr.push(_this.state.clientLoginIdInfo[key]);});_this.setState({clientName:event.target.value,clientLoginId:loginIdArr});};_this.viewSMSsalesReport=function(val){return _asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _ref2,data,rowDataLast;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!(_this.state.smsSalesReportFrom.unix>_this.state.smsSalesReportTo.unix)){_context.next=4;break;}// console.log('big')
_this.props.openSnackbar('From date should be less than or equal to ToDate');_context.next=12;break;case 4:_context.next=6;return _this.props.client.query({query:GET_SMS_SALES_HISTORY,variables:{toLoginId:_this.state.clientLoginId,fromTimestamp:_this.state.smsSalesReportFrom.unix,toTimestamp:_this.state.smsSalesReportTo.unix}});case 6:_ref2=_context.sent;data=_ref2.data;console.log('dRr',data.getallSMSPurchaseHistory);rowDataLast=[];data.getallSMSPurchaseHistory.forEach(function(element){var rowData=[];rowData.push(_this.state.clientNameLoginId[element.toLoginId]);rowData.push(element.transactionType);rowData.push(element.smsCount);rowData.push(_this.getFormattedDate(element.createdAt));rowDataLast.push(rowData);});_this.setState({fullData:rowDataLast,reportView:true});// console.log(this.state.fullData)
case 12:case'end':return _context.stop();}}},_callee,_this2);}));};_this.getFormattedDate=function(timestamp){return __WEBPACK_IMPORTED_MODULE_10_moment___default()(timestamp*1000).format('MMM Do YYYY, h:mm a');};_this.getAllCustomers=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var customers,clientName,clientLoginId,clientNameLoginIdArr;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this.props.client.query({query:GET_CLIENTS,variables:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_8__utils_getLoginId__["a" /* default */])()}});case 2:customers=_context2.sent;if(customers&&customers.data){console.log(customers.data);clientName=[];clientLoginId=[];clientNameLoginIdArr=[];customers.data.clients.forEach(function(element){clientNameLoginIdArr[element.loginId]=element.clientName;clientName.push(element.clientName);clientLoginId.push(element.loginId);});_this.setState({clientNameInfo:clientName,clientLoginIdInfo:clientLoginId,clientNameLoginId:clientNameLoginIdArr});}case 4:case'end':return _context2.stop();}}},_callee2,_this2);}));_this.class=props;return _this;}_createClass(PartnerClientSMSReport,[{key:'componentDidMount',value:function componentDidMount(){this.getAllCustomers();}},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;var spacing=this.state.spacing;// console.log('statefullData', this.state.fullData)
// console.log('clientNameInfo', this.state.clientNameInfo)
// console.log('clientName', this.state.clientName)
// console.log('clientLoginId', this.state.clientLoginId)
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{variant:'outlined',color:'secondary',className:classes.button,onClick:function onClick(){return _this3.props.history.goBack();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_icons_ArrowBack___default.a,{className:classes.iconSmall})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'Sales Report'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row',justify:'center',alignItems:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,justify:'center',spacing:Number(spacing)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Select___default.a,{multiple:true,value:this.state.clientName,onChange:this.handleChange,renderValue:function renderValue(selected){return selected.join(', ');},MenuProps:MenuProps,className:classes.selstyle,label:'Select Clients'},this.state.clientNameInfo.map(function(clientName){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_MenuItem___default.a,{key:// eslint-disable-next-line standard/computed-property-even-spacing
_this3.state.clientLoginIdInfo[_this3.state.clientNameInfo.indexOf(clientName)],value:clientName},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_ListItemText___default.a,{primary:clientName}));}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_pickers__["a" /* DatePicker */],{value:this.state.smsSalesReportFrom.date,onChange:this.handleDateChange('smsSalesReportFrom'),label:'From Date',format:'DD/MM/YYYY'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_pickers__["a" /* DatePicker */],{value:this.state.smsSalesReportTo.date,onChange:this.handleDateChange('smsSalesReportTo'),label:'To Date',format:'DD/MM/YYYY'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{color:'secondary',variant:'contained',className:classes.button,onClick:this.viewSMSsalesReport('hai'),disabled:this.state.clientLoginId.length===0||this.state.smsSalesReportTo.date===''||this.state.smsSalesReportFrom.date===''},'View')))),this.state.reportView&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_mui_datatables___default.a,{data:this.state.fullData,columns:this.columns,options:this.options}))));}}]);return PartnerClientSMSReport;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_15__HOCs_withSharedSnackbar__["a" /* default */])(PartnerClientSMSReport))));

/***/ }),
/* 2356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_pickers__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_ListItemText__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_ListItemText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_ListItemText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__HOCs_withSharedSnackbar__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getallSMSPurchaseHistory(\n    $toLoginId: [Int!]!\n    $fromTimestamp: String!\n    $toTimestamp: String!\n  ) {\n    getallSMSPurchaseHistory(\n      toLoginId: $toLoginId\n      fromTimestamp: $fromTimestamp\n      toTimestamp: $toTimestamp\n    ) {\n      fromLoginId\n      fromAccountType\n      toLoginId\n      toAccountType\n      transactionType\n      smsCount\n      createdAt\n    }\n  }\n'],['\n  query getallSMSPurchaseHistory(\n    $toLoginId: [Int!]!\n    $fromTimestamp: String!\n    $toTimestamp: String!\n  ) {\n    getallSMSPurchaseHistory(\n      toLoginId: $toLoginId\n      fromTimestamp: $fromTimestamp\n      toTimestamp: $toTimestamp\n    ) {\n      fromLoginId\n      fromAccountType\n      toLoginId\n      toAccountType\n      transactionType\n      smsCount\n      createdAt\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query allPartnerDetails($status: Int) {\n    allPartnerDetails(status: $status) {\n      businessName\n      login {\n        loginId\n      }\n    }\n  }\n'],['\n  query allPartnerDetails($status: Int) {\n    allPartnerDetails(status: $status) {\n      businessName\n      login {\n        loginId\n      }\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query getAllResellerDetails($status: Int) {\n    getAllResellerDetails(status: $status) {\n      resellerName\n      login {\n        loginId\n      }\n    }\n  }\n'],['\n  query getAllResellerDetails($status: Int) {\n    getAllResellerDetails(status: $status) {\n      resellerName\n      login {\n        loginId\n      }\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_SMS_SALES_HISTORY=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject);var GET_ALL_PARTNERS=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject2);var GET_ALL_RESELLERS=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject3);var style=function style(theme){return{root:{padding:theme.spacing.unit*4,flexGrow:1},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},iconSmall:{fontSize:20},selstyle:{maxHeight:ITEM_HEIGHT*4.5+ITEM_PADDING_TOP,width:250}};};var ITEM_HEIGHT=48;var ITEM_PADDING_TOP=8;var MenuProps={PaperProps:{style:{maxHeight:ITEM_HEIGHT*4.5+ITEM_PADDING_TOP,width:250}}};var AdminClientSMSReport=function(_Component){_inherits(AdminClientSMSReport,_Component);function AdminClientSMSReport(props){var _this2=this;_classCallCheck(this,AdminClientSMSReport);var _this=_possibleConstructorReturn(this,(AdminClientSMSReport.__proto__||Object.getPrototypeOf(AdminClientSMSReport)).call(this,props));_this.state={spacing:'16',smsSalesReportFrom:{date:__WEBPACK_IMPORTED_MODULE_9_moment___default()(),unix:__WEBPACK_IMPORTED_MODULE_9_moment___default()().unix().toString()},smsSalesReportTo:{date:__WEBPACK_IMPORTED_MODULE_9_moment___default()(),unix:__WEBPACK_IMPORTED_MODULE_9_moment___default()().unix().toString()},name:[],fullData:[],clientNameInfo:[],clientName:[],clientLoginId:[],partrner:[],clientNameLoginId:[]};_this.columns=['CLIENT NAME','TRASACTION TYPE','SMS COUNT','DATE TIME'];_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15};_this.handleDateChange=function(name){return function(date){var tempDate=_this.state[name];tempDate.date=date;tempDate.unix=__WEBPACK_IMPORTED_MODULE_9_moment___default()(date).unix().toString();_this.setState(_defineProperty({},name,tempDate));};};_this.handleChangeType=function(partner){return function(event){console.log('event.target.value',event.target.value);_this.setState(_defineProperty({},partner,event.target.value));console.log('hhhhh=',partner);if(event.target.value==='RES'){_this.setState({clientName:[],clientLoginId:[],clientNameLoginId:[]});_this.getAllResellerDetails();}else{_this.setState({clientName:[],clientLoginId:[],clientNameLoginId:[]});_this.getAllPartnerDetails();}};};_this.handleChange=function(event){var loginIdArr=[];event.target.value.forEach(function(val){var key=_this.state.clientNameInfo.indexOf(val);loginIdArr.push(_this.state.clientLoginIdInfo[key]);});_this.setState({clientName:event.target.value,clientLoginId:loginIdArr});};_this.getAllPartnerDetails=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var customers,clientName,clientLoginId,clientNameLoginIdArr;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.client.query({query:GET_ALL_PARTNERS,variables:{status:1}});case 2:customers=_context.sent;if(customers&&customers.data){clientName=[];clientLoginId=[];clientNameLoginIdArr=[];customers.data.allPartnerDetails.forEach(function(element){clientNameLoginIdArr[element.login.loginId]=element.businessName;clientName.push(element.businessName);clientLoginId.push(element.login.loginId);});_this.setState({clientNameInfo:clientName,clientLoginIdInfo:clientLoginId,clientNameLoginId:clientNameLoginIdArr});}console.log('clientNameLoginIdsdsdsds',_this.state.clientNameLoginId);case 5:case'end':return _context.stop();}}},_callee,_this2);}));_this.getAllResellerDetails=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var _ref3,data,clientName,clientLoginId,clientNameLoginIdArr;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this.props.client.query({query:GET_ALL_RESELLERS,variables:{status:1}});case 2:_ref3=_context2.sent;data=_ref3.data;if(data&&data.getAllResellerDetails){clientName=[];clientLoginId=[];clientNameLoginIdArr=[];data.getAllResellerDetails.forEach(function(element){clientNameLoginIdArr[element.login.loginId]=element.resellerName;clientName.push(element.resellerName);clientLoginId.push(element.login.loginId);});_this.setState({clientNameInfo:clientName,clientLoginIdInfo:clientLoginId,clientNameLoginId:clientNameLoginIdArr});}// console.log('clientNameLoginIdsdsdsdsooooooo', this.state.clientNameLoginId)
case 5:case'end':return _context2.stop();}}},_callee2,_this2);}));_this.viewSMSsalesReport=function(val){return _asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var _ref5,data,rowDataLast;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:if(!(parseInt(_this.state.smsSalesReportFrom.unix,10)>parseInt(_this.state.smsSalesReportTo.unix,10))){_context3.next=4;break;}_this.props.openSnackbar('From date should be less than or equal to ToDate');_context3.next=11;break;case 4:_context3.next=6;return _this.props.client.query({query:GET_SMS_SALES_HISTORY,variables:{toLoginId:_this.state.clientLoginId,fromTimestamp:_this.state.smsSalesReportFrom.unix,toTimestamp:_this.state.smsSalesReportTo.unix}});case 6:_ref5=_context3.sent;data=_ref5.data;// console.log('dRr', data.getallSMSPurchaseHistory)
rowDataLast=[];data.getallSMSPurchaseHistory.forEach(function(element){var rowData=[];rowData.push(_this.state.clientNameLoginId[element.toLoginId]);rowData.push(element.transactionType);rowData.push(element.smsCount);rowData.push(element.smsCount);rowDataLast.push(rowData);});_this.setState({fullData:rowDataLast});// console.log(this.state.fullData)
case 11:case'end':return _context3.stop();}}},_callee3,_this2);}));};_this.class=props;return _this;}_createClass(AdminClientSMSReport,[{key:'componentDidMount',value:function componentDidMount(){this.getAllPartnerDetails();}},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;var spacing=this.state.spacing;// console.log('statefullData', this.state.fullData)
// console.log('clientNameInfo', this.state.clientNameInfo)
// console.log('clientName', this.state.clientName)
// console.log('clientLoginId', this.state.clientLoginId)
// console.log('ClientType', this.state.partner)
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'Sales Report'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row',justify:'center',alignItems:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,justify:'center',spacing:Number(spacing)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Select___default.a,{native:true,value:this.state.partner,onChange:this.handleChangeType('partner'),inputProps:{name:'partner',id:'age-native-simple'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{value:'BA'},'Business Admin'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{value:'RES'},'Reseller'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Select___default.a,{multiple:true,value:this.state.clientName,onChange:this.handleChange,renderValue:function renderValue(selected){return selected.join(',');},MenuProps:MenuProps,className:classes.selstyle},this.state.clientNameInfo.map(function(clientName){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_MenuItem___default.a,{key:/* eslint-disable standard/computed-property-even-spacing */_this3.state.clientLoginIdInfo[_this3.state.clientNameInfo.indexOf(clientName)]/* eslint-enable standard/computed-property-even-spacing */,value:clientName},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_ListItemText___default.a,{primary:clientName}));}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_pickers__["a" /* DatePicker */],{value:this.state.smsSalesReportFrom.date,onChange:this.handleDateChange('smsSalesReportFrom'),format:'DD/MM/YYYY'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_pickers__["a" /* DatePicker */],{value:this.state.smsSalesReportTo.date,onChange:this.handleDateChange('smsSalesReportTo'),format:'DD/MM/YYYY'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{color:'secondary',variant:'contained',className:classes.button,onClick:this.viewSMSsalesReport('hai')},'View')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_mui_datatables___default.a,{data:this.state.fullData,columns:this.columns,options:this.options}))));}}]);return AdminClientSMSReport;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_13__HOCs_withSharedSnackbar__["a" /* default */])(AdminClientSMSReport))));

/***/ }),
/* 2357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_RadioGroup__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_RadioGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_RadioGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControlLabel__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControlLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControlLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Radio__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_FormLabel__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_FormLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_FormLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query allClientDetails($partnerLoginId: Int) {\n    clients: allClientDetails(partnerLoginId: $partnerLoginId) {\n      id\n      clientName\n      loginId\n    }\n  }\n'],['\n  query allClientDetails($partnerLoginId: Int) {\n    clients: allClientDetails(partnerLoginId: $partnerLoginId) {\n      id\n      clientName\n      loginId\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query getAllVehicleDetails($clientLoginId: Int) {\n    getAllVehicleDetails(clientLoginId: $clientLoginId) {\n      entityId\n      vehicleType\n      vehicleModel\n      vehicleNumber\n      deviceDetail {\n        uniqueDeviceId\n        is_panic_enabled\n      }\n      panicType\n    }\n  }\n'],['\n  query getAllVehicleDetails($clientLoginId: Int) {\n    getAllVehicleDetails(clientLoginId: $clientLoginId) {\n      entityId\n      vehicleType\n      vehicleModel\n      vehicleNumber\n      deviceDetail {\n        uniqueDeviceId\n        is_panic_enabled\n      }\n      panicType\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation setMultiDeviceAlertConfigs(\n    $clientLoginId: Int!\n    $alertType: String!\n    $alertConfigs: [AlertConfigInput!]\n    $isFromAdmin:Boolean\n  ) {\n    setMultiDeviceAlertConfigs(\n      clientLoginId: $clientLoginId\n      alertType: $alertType\n      alertConfigs: $alertConfigs\n      isFromAdmin:$isFromAdmin\n    )\n  }\n'],['\n  mutation setMultiDeviceAlertConfigs(\n    $clientLoginId: Int!\n    $alertType: String!\n    $alertConfigs: [AlertConfigInput!]\n    $isFromAdmin:Boolean\n  ) {\n    setMultiDeviceAlertConfigs(\n      clientLoginId: $clientLoginId\n      alertType: $alertType\n      alertConfigs: $alertConfigs\n      isFromAdmin:$isFromAdmin\n    )\n  }\n']);function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_CLIENTS=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject);var GET_ALL_VEHICLES=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject2);var ADD_PANIC_BIT_CONFIGURATION=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject3);var style=function style(theme){return{root:{padding:theme.spacing.unit*4,flexGrow:1},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary,height:140,width:100},iconSmall:{fontSize:20},selstyle:{maxHeight:ITEM_HEIGHT*4.5+ITEM_PADDING_TOP,width:250},formControl:{margin:theme.spacing.unit*3},group:{margin:theme.spacing.unit+'px 0'}};};var ITEM_HEIGHT=48;var ITEM_PADDING_TOP=8;var rows=[{id:'vlpn',numeric:false,disablePadding:true,label:'VEHICLE NUMBER'},{id:'bit',numeric:true,disablePadding:false,label:'PANIC BIT'},{id:'type',numeric:true,disablePadding:false,label:'TYPE'}];var EnhancedTableHead=function(_React$Component){_inherits(EnhancedTableHead,_React$Component);function EnhancedTableHead(){var _ref;var _temp,_this,_ret;_classCallCheck(this,EnhancedTableHead);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=EnhancedTableHead.__proto__||Object.getPrototypeOf(EnhancedTableHead)).call.apply(_ref,[this].concat(args))),_this),_this.createSortHandler=function(property){return function(event){_this.props.onRequestSort(event,property);};},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(EnhancedTableHead,[{key:'render',value:function render(){var _props=this.props,onSelectAllClick=_props.onSelectAllClick,numSelected=_props.numSelected,rowCount=_props.rowCount;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["TableHead"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["TableCell"],{padding:'checkbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["Checkbox"],{indeterminate:numSelected>0&&numSelected<rowCount,checked:numSelected===rowCount,onChange:onSelectAllClick})),rows.map(function(row){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["TableCell"],{key:row.id,align:row.numeric?'right':'inherit',padding:row.disablePadding?'none':'default'},row.label);},this)));}}]);return EnhancedTableHead;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);EnhancedTableHead.propTypes={numSelected:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.number.isRequired,onSelectAllClick:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.func.isRequired,rowCount:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.number.isRequired};var EnhancedTableToolbar=function EnhancedTableToolbar(props){var numSelected=props.numSelected,classes=props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["Toolbar"],{className:__WEBPACK_IMPORTED_MODULE_12_classnames___default()(classes.root,_defineProperty({},classes.highlight,numSelected>0))});};EnhancedTableToolbar.propTypes={classes:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.object.isRequired,numSelected:__WEBPACK_IMPORTED_MODULE_14_prop_types___default.a.number.isRequired};var PanicAlertBitConfigurationSettings=function(_Component){_inherits(PanicAlertBitConfigurationSettings,_Component);function PanicAlertBitConfigurationSettings(){var _ref2,_this3=this;var _temp2,_this2,_ret2;_classCallCheck(this,PanicAlertBitConfigurationSettings);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this2=_possibleConstructorReturn(this,(_ref2=PanicAlertBitConfigurationSettings.__proto__||Object.getPrototypeOf(PanicAlertBitConfigurationSettings)).call.apply(_ref2,[this].concat(args))),_this2),_this2.state={spacing:'16',name:[],fullData:[],clientNameInfo:[],clientNames:[],clientName:'',clientLoginId:'',clientNameLoginId:[],bitPosition:[],entityId:[],panicSettingsDetails:[],bits:[null,null],panic:'none',ac:'none',entityIdTemp:[],alertType:'',alertConfigs:{},uniqueDeviceId:[],vehicleNumber:[],selected:[],page:0,rowsPerPage:5,searchValue:'',vlpnArr:[],panicType:[],vehicleModel:[]},_this2.columns=['SELECT','VEHICLE NUMBER','PANIC BIT','TYPE'],_this2.panicBitArr={Panic:['none','1','256','2048','222'],AC:['none','1','256','2048']},_this2.options={selectableRows:false,responsive:'scroll',rowsPerPage:5,filter:false,download:false,print:false},_this2.getAllCustomers=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var customers,clientName,clientLoginId,allClients;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this2.props.client.query({query:GET_CLIENTS,variables:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_4__utils_getLoginId__["a" /* default */])()},fetchPolicy:'network-only'});case 2:customers=_context.sent;if(customers&&customers.data){clientName=[];clientLoginId=[];customers.data.clients.forEach(function(element){clientName.push(element.clientName);clientLoginId.push(element.loginId);});_this2.setState({clientNameInfo:clientName,clientLoginIdInfo:clientLoginId});allClients=customers.data.clients.map(function(client){return{value:client.loginId,label:client.clientName};});_this2.setState({clientNames:allClients});}case 4:case'end':return _context.stop();}}},_callee,_this3);})),_this2.clientLoginIdTemp='',_this2.handleChange=function(event){if(event&&event.label&&event.value){_this2.setState({clientName:event.label,clientLoginId:event.value},function(){_this2.getAllVehicleDetails(_this2.state.clientLoginId)();});}},_this2.onBitChange=function(index){return function(bit){return _this2.setState(function(_ref4){var bits=_ref4.bits;var originalBits=[].concat(_toConsumableArray(bits));originalBits[index]=bit;return{bits:originalBits};});};},_this2.getAllVehicleDetails=function(val){return _asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var _ref6,data,vehicleNumber,uniqueDeviceId,vehicleModel,panicType;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this2.props.client.query({query:GET_ALL_VEHICLES,variables:{clientLoginId:val},fetchPolicy:'network-only'});case 2:_ref6=_context2.sent;data=_ref6.data;// let rowDataLast = []
vehicleNumber=[];uniqueDeviceId=[];vehicleModel=[];panicType=[];data.getAllVehicleDetails.forEach(function(element,index){if(element.deviceDetail.is_panic_enabled){// var rowData = []
// rowData.push(
//   <Checkbox
//     onChange={() =>
//       this.selectVehicle(element.deviceDetail.uniqueDeviceId)
//     }
//   />
// )
// rowData.push(element.vehicleNumber)
// rowData.push(element.panicType)
// rowData.push(element.vehicleModel)
// rowDataLast.push(rowData)
vehicleNumber.push(element.vehicleNumber);uniqueDeviceId.push(element.deviceDetail.uniqueDeviceId);vehicleModel.push(element.vehicleModel);panicType.push(element.panicType);}});_this2.setState({// fullData: rowDataLast,
uniqueDeviceId:uniqueDeviceId,vehicleNumber:vehicleNumber,vehicleModel:vehicleModel,panicType:panicType},function(){_this2.convertArraytoObject();});case 10:case'end':return _context2.stop();}}},_callee2,_this3);}));},_this2.panicSettingsArr=[],_this2.onPanicChange=function(event){_this2.setState({panic:event.target.value});},_this2.onAcChange=function(event){_this2.setState({ac:event.target.value});},_this2.vehicleIdArr=[],_this2.selectVehicle=function(value){var entityArr=[];if(_this2.vehicleIdArr.length>0){var indexTemp=_this2.vehicleIdArr.indexOf(value);if(indexTemp<0){_this2.vehicleIdArr.push(value);_this2.vehicleIdArr.forEach(function(val){entityArr.push(val);});_this2.setState({entityId:entityArr});}else{_this2.vehicleIdArr.splice(indexTemp,1);_this2.vehicleIdArr.forEach(function(val){entityArr.push(val);});_this2.setState({entityId:entityArr});}}else{_this2.vehicleIdArr.push(value);_this2.vehicleIdArr.forEach(function(val){entityArr.push(val);});_this2.setState({entityId:entityArr});}},_this2.alertConfigs=[],_this2.handleSubmit=function(client){return function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(event){var _ref8,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:event.preventDefault();_this2.state.selected.forEach(function(val){var entityArr={};entityArr.panicType=parseInt(_this2.state.panic,10);entityArr.uniqueDeviceId=val;entityArr.fromTimestamp=Math.floor(Date.now()/1000+19800).toString();entityArr.toTimestamp=Math.floor(Date.now()/1000+19800).toString();entityArr.isAlertEnable=false;_this2.alertConfigs.push(entityArr);});_context3.next=4;return client.mutate({mutation:ADD_PANIC_BIT_CONFIGURATION,variables:{clientLoginId:parseInt(_this2.state.clientLoginId,10),alertType:'panic',alertConfigs:_this2.alertConfigs,isFromAdmin:true},refetchQueries:['getAllVehicleDetails']});case 4:_ref8=_context3.sent;data=_ref8.data;_this2.alertConfigs=[];_this2.setState({alertConfigs:[]});if(data!==null){_this2.setState({response:data});_this2.props.openSnackbar('Panic Bit Configured Successfully');_this2.getAllVehicleDetails(_this2.state.clientLoginId)();}else{_this2.setState({failure:true});_this2.props.openSnackbar('Failed to configure');}case 9:case'end':return _context3.stop();}}},_callee3,_this3);}));return function(_x){return _ref7.apply(this,arguments);};}();},_this2.handleClick=function(event,id){var selected=_this2.state.selected;var selectedIndex=selected.indexOf(id);var newSelected=[];if(selectedIndex===-1){newSelected=newSelected.concat(selected,id);}else if(selectedIndex===0){newSelected=newSelected.concat(selected.slice(1));}else if(selectedIndex===selected.length-1){newSelected=newSelected.concat(selected.slice(0,-1));}else if(selectedIndex>0){newSelected=newSelected.concat(selected.slice(0,selectedIndex),selected.slice(selectedIndex+1));}_this2.setState({selected:newSelected},function(){console.log(_this2.state.selected,'selected');});},_this2.handleChangePage=function(event,page){_this2.setState({page:page});},_this2.handleChangeRowsPerPage=function(event){_this2.setState({rowsPerPage:event.target.value});},_this2.isSelected=function(id){return _this2.state.selected.indexOf(id)!==-1;},_this2.handleSearchChange=function(e){return _this2.setState({searchValue:e.target.value});},_this2.findArrayElementByTitle=function(array,title){var assignedArr=[];array.forEach(function(n){assignedArr.push(n);});var status=assignedArr.includes(title);return status;},_this2.handleSelectAllClick=function(event){if(event.target.checked){_this2.setState(function(state){return{selected:_this2.state.vlpnArr.map(function(n){return n.uniqueDeviceId;})};},function(){console.log(_this2.state.selected,'selected');});}else{_this2.setState({selected:[]});}},_this2.convertArraytoObject=function(){// console.log('sdhbfjd')
var vlpnObj=[];for(var i=0;i<_this2.state.vehicleNumber.length;i++){if(_this2.state.vehicleNumber[i]!==''){vlpnObj.push({vlpn:_this2.state.vehicleNumber[i],panicType:_this2.state.panicType[i],vehicleModel:_this2.state.vehicleModel[i],uniqueDeviceId:_this2.state.uniqueDeviceId[i]});}}_this2.setState({vlpnArr:vlpnObj});},_temp2),_possibleConstructorReturn(_this2,_ret2);}_createClass(PanicAlertBitConfigurationSettings,[{key:'componentDidMount',value:function componentDidMount(){this.getAllCustomers();}// new
},{key:'render',// new ends
value:function render(){var _this4=this;var classes=this.props.classes;var _state=this.state,spacing=_state.spacing,selected=_state.selected,rowsPerPage=_state.rowsPerPage,page=_state.page;var emptyRows=rowsPerPage-Math.min(rowsPerPage,(this.state.vehicleNumber.length-page)*rowsPerPage);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'Panic Configuration'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["Grid"],{container:true,spacing:16,direction:'row',justify:'center',alignItems:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["Grid"],{container:true,justify:'center',spacing:Number(spacing)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["Grid"],{item:true,style:{minWidth:'30%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */],{classes:classes,options:this.state.clientNames// components={components}
,value:this.state.clientLoginId,onChange:this.handleChange,placeholder:'Select Customer'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["Grid"],{item:true}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["Grid"],{item:true,xs:12,container:true,direction:'column',justify:'flex-start',alignItems:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["Grid"],{container:true,className:classes.demo,justify:'center',spacing:Number(spacing)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_FormLabel___default.a,{component:'legend'},'Panic'),this.panicBitArr.Panic.map(function(val){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["Grid"],{key:val,item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["Grid"],{item:true,xs:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl___default.a,{component:'fieldset',className:classes.formControl},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_RadioGroup___default.a,{'aria-label':'Panic',name:'Panic',value:_this4.state.panic,onChange:_this4.onPanicChange},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormControlLabel___default.a,{value:val,control:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Radio___default.a,null),label:val})))));}))),this.state.clientName&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["Grid"],{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["Input"],{value:this.state.searchValue,onChange:this.handleSearchChange,placeholder:'Search Vehicle'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["Table"],{className:classes.table,'aria-labelledby':'tableTitle'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(EnhancedTableHead,{numSelected:selected.length,onSelectAllClick:this.handleSelectAllClick,rowCount:this.state.vehicleNumber.length}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["TableBody"],null,this.state.vlpnArr.filter(function(vlpn){return vlpn.vlpn.includes(_this4.state.searchValue);}).slice(page*rowsPerPage,page*rowsPerPage+rowsPerPage).map(function(n){var isSelected=_this4.isSelected(n.uniqueDeviceId);isSelected=_this4.findArrayElementByTitle(selected,n.uniqueDeviceId);// this.state.description.map(d => {
// console.log(n, 'pids')
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["TableRow"],{hover:true,onClick:function onClick(event){return _this4.handleClick(event,n.uniqueDeviceId);},role:'checkbox','aria-checked':isSelected,tabIndex:-1,key:n,selected:isSelected},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["TableCell"],{padding:'checkbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["Checkbox"],{checked:isSelected})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["TableCell"],{component:'th',scope:'row',padding:'none'},n.vlpn),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["TableCell"],{align:'right'},n.panicType),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["TableCell"],{align:'right'},n.vehicleModel));// })
}),emptyRows>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["TableRow"],{style:{height:'auto'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["TableCell"],{colSpan:6})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["TablePagination"],{component:'div',count:this.state.uniqueDeviceId.length,rowsPerPage:rowsPerPage,page:page,backIconButtonProps:{'aria-label':'Previous Page'},nextIconButtonProps:{'aria-label':'Next Page'},onChangePage:this.handleChangePage,onChangeRowsPerPage:this.handleChangeRowsPerPage})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["Button"],{variant:'contained',color:'secondary',size:'medium',margin:'normal',className:'btn',type:'button',onClick:this.handleSubmit(this.props.client),disabled:this.state.clientName===''},'Submit')));}}]);return PanicAlertBitConfigurationSettings;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_13__material_ui_core__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_11__HOCs_withSharedSnackbar__["a" /* default */])(PanicAlertBitConfigurationSettings))));

/***/ }),
/* 2358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AddDevice__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_icons_ArrowBack__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_icons_ArrowBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_ArrowBack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_getAccountType_js__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_Loader_Loader__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_axios__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_file_saver__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_core_FormControlLabel__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_core_FormControlLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_FormControlLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core_Switch__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core_Switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Switch__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getAllVehicleDetailsByStatus($loginId: Int, $status: Int) {\n    vehicles: getAllVehicleDetailsByStatus(\n      partnerLoginId: $loginId\n      status: $status\n    ) {\n      entityId\n      vehicleNumber\n      chassisNumber\n      clientName\n      deviceDetail {\n        serial_num\n        uniqueDeviceId\n        deviceModelId {\n          model_name\n          devicetype\n        }\n      }\n      simDetail {\n        phoneNumber\n      }\n      vehicleType\n      vehicleModel\n      firmwareVersion\n      createdAt\n\n      grossVehicleWeight\n      manufacturingYear\n      vehicleSegment\n      equipmentTypeClass\n      vehicleWheeler\n      application\n      documentUpload\n      baselineDataForFE\n      fuelTankCapacity\n      adblueCapacity\n      baselineDistance\n      solutionType\n      zonalManager\n      keyAccountManager\n      channelPartnerName\n      technicianName\n      isDualEngine\n      solution_type\n\n      kvaRating\n      bhp\n      phase\n      engineModel\n      gensetController\n    }\n  }\n'],['\n  query getAllVehicleDetailsByStatus($loginId: Int, $status: Int) {\n    vehicles: getAllVehicleDetailsByStatus(\n      partnerLoginId: $loginId\n      status: $status\n    ) {\n      entityId\n      vehicleNumber\n      chassisNumber\n      clientName\n      deviceDetail {\n        serial_num\n        uniqueDeviceId\n        deviceModelId {\n          model_name\n          devicetype\n        }\n      }\n      simDetail {\n        phoneNumber\n      }\n      vehicleType\n      vehicleModel\n      firmwareVersion\n      createdAt\n\n      grossVehicleWeight\n      manufacturingYear\n      vehicleSegment\n      equipmentTypeClass\n      vehicleWheeler\n      application\n      documentUpload\n      baselineDataForFE\n      fuelTankCapacity\n      adblueCapacity\n      baselineDistance\n      solutionType\n      zonalManager\n      keyAccountManager\n      channelPartnerName\n      technicianName\n      isDualEngine\n      solution_type\n\n      kvaRating\n      bhp\n      phase\n      engineModel\n      gensetController\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query GetAllVehicleDetailsbyStatusLimited($partnerLoginId: Int, $status: Int, $type: String) {\n    vehicles: getAllVehicleDetailsbyStatusLimited(partnerLoginId: $partnerLoginId, status: $status, type: $type) {\n      entityId\n      vehicleNumber\n      uniqueId\n      vehicleType\n      vehicleModel\n      clientName\n      vehCreatedOn\n      grossVehicleWeight\n      vehicleSegment\n      fuelTankCapacity\n      adblueCapacity\n      solutionType\n      isDualEngine\n      solution_type\n    }\n  }\n'],['\n  query GetAllVehicleDetailsbyStatusLimited($partnerLoginId: Int, $status: Int, $type: String) {\n    vehicles: getAllVehicleDetailsbyStatusLimited(partnerLoginId: $partnerLoginId, status: $status, type: $type) {\n      entityId\n      vehicleNumber\n      uniqueId\n      vehicleType\n      vehicleModel\n      clientName\n      vehCreatedOn\n      grossVehicleWeight\n      vehicleSegment\n      fuelTankCapacity\n      adblueCapacity\n      solutionType\n      isDualEngine\n      solution_type\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n'],['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query getAdminUserDetailsByRole($roleName: [String]) {\n    getAdminUserDetailsByRole(\n      roleName: $roleName\n    ) {\n     id\n     username\n     role\n    }\n  }\n'],['\n  query getAdminUserDetailsByRole($roleName: [String]) {\n    getAdminUserDetailsByRole(\n      roleName: $roleName\n    ) {\n     id\n     username\n     role\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var style=function style(theme){return{root:{padding:theme.spacing.unit*4,flexGrow:1},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},iconSmall:{fontSize:20}};};var GET_VEHICLE_LIST=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject);var GET_VEHICLE_LIST_LIMITED=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject2);var GET_FILE_FORMAT=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject3);var GET_ZMKAM=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject4);var ViewVehicleList=function(_Component){_inherits(ViewVehicleList,_Component);function ViewVehicleList(props){var _this2=this;_classCallCheck(this,ViewVehicleList);var _this=_possibleConstructorReturn(this,(ViewVehicleList.__proto__||Object.getPrototypeOf(ViewVehicleList)).call(this,props));_this.clientId=[];_this.columns=['VEHICLE NO','CHASSIS NO','UNIQUE ID','PHONE NO','DEVICE TYPE','MODEL','CLIENT NAME','CREATED DATE TIME','FIRMWARE VERSION','GROSS VEHICLE WEIGHT','MANUFACTURING YEAR','VEHICLE SEGMENT','EQUIPMENT TYPE CLASS','VEHICLE WHEELER','APPLICATION','BASELINE DATA FOR FE(kmpl)','BASELINE DISTANCE (km)','FUEL TANK CAPACITY','ADBLUE CAPACITY','SOLUTION TYPE','ZONAL MANAGER','KEY ACCOUNT MANAGER','CHANNEL PARTNER','TECHNICIAN','DOUBLE ENGINE','KVA RATING','BHP (BREAK HORSE POWER)','PHASE','ENGINE MODEL','GENSET CONTROLLER'];_this.limitedColumns=['VEHICLE NO','UNIQUE ID','VEHICLE TYPE','MODEL','CLIENT NAME','CREATED DATE TIME','GROSS VEHICLE WEIGHT','VEHICLE SEGMENT','FUEL TANK CAPACITY','ADBLUE CAPACITY','SOLUTION TYPE','DOUBLE ENGINE'];_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15,onRowClick:function onRowClick(rowData,dataIndex,rowIndex){if(['SER'].includes(Object(__WEBPACK_IMPORTED_MODULE_14__utils_getAccountType_js__["a" /* default */])())||![2].includes(Object(__WEBPACK_IMPORTED_MODULE_11__utils_getLoginId__["a" /* default */])())){var vehicleIndex=dataIndex.dataIndex;var vehicle=_this.currentVehicles&&_this.currentVehicles[vehicleIndex]?_this.currentVehicles[vehicleIndex]:null;_this.props.history.push({pathname:'/home/vehicles/edit/'+_this.entityId[vehicleIndex],state:{technicianName:vehicle?vehicle.technicianName:null,vehicleData:vehicle}});}else{_this.props.openSnackbar('Vehicle cannot be edited');}}};_this.state={open:false,open1:false,zmDetails:[],kamDetails:[],viewMore:false};_this.handleToggleChange=function(event){_this.setState({viewMore:event.target.checked});};_this.handleDownload=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event,fileName){var bucketName,_ref2,data,res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:event.stopPropagation();// Prevent default button behavior
bucketName='aquila-track-uploads';_context.next=4;return _this.props.client.query({query:GET_FILE_FORMAT,variables:{bucketname:bucketName,filename:fileName},errorPolicy:'all'});case 4:_ref2=_context.sent;data=_ref2.data;_context.next=8;return __WEBPACK_IMPORTED_MODULE_17_axios___default()({url:data.getPublicDownloadURL,method:'GET',headers:{Accept:'application/vnd.ms-excel'},responseType:'blob'// important
});case 8:res=_context.sent;__WEBPACK_IMPORTED_MODULE_18_file_saver___default.a.saveAs(new Blob([res.data]),fileName);case 10:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x,_x2){return _ref.apply(this,arguments);};}();_this.getStatus=function(status){if(status===1){return'Instock';}else if(status===2){return'Assigned to Partner';}else if(status===3){return'Assigned to Client';}else if(status===4){return'Registered to vehicle';}};_this.getZMKAMDetails=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var zmkamDetails,zmDetails,kamDetails;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this.props.client.query({query:GET_ZMKAM,variables:{roleName:["Zonal Manager(ZM)","Key Account Manager(KAM)"]}// fetchPolicy: 'network-only'
});case 2:zmkamDetails=_context2.sent;zmDetails=zmkamDetails.data.getAdminUserDetailsByRole.filter(function(user){return user.role==="Zonal Manager(ZM)";}).map(function(user){return{value:user.id,label:user.username};});kamDetails=zmkamDetails.data.getAdminUserDetailsByRole.filter(function(user){return user.role==="Key Account Manager(KAM)";}).map(function(user){return{value:user.id,label:user.username};});_this.setState({zmDetails:zmDetails,kamDetails:kamDetails});case 6:case'end':return _context2.stop();}}},_callee2,_this2);}));_this.handleClickOpen=function(){_this.setState({open:true});};_this.handleClose=function(){_this.setState({open:false});};_this.handleClickBulkOpen=function(){_this.setState({open1:true});};_this.handleBulkClose=function(){_this.setState({open1:false});};_this.addBulkUpload=function(e){_this.props.history.push({pathname:'/home/DeviceInventory/BulkUpload'});};_this.assignBulkUpload=function(e){console.log('bulk');_this.props.history.push({pathname:'/home/DeviceInventory/BulkDeviceAssign'});};_this.getFormattedDate=function(timestamp){return __WEBPACK_IMPORTED_MODULE_13_moment___default()(timestamp*1000).format('DD-MM-YYYY HH:mm:ss');};_this.classes=props;return _this;}_createClass(ViewVehicleList,[{key:'mapToArr',value:function mapToArr(devices){var _this3=this;var rowData=[];var fullData=[];this.entityId=[];var viewMore=this.state.viewMore;devices.forEach(function(element){rowData=[];if(viewMore){var zmName='-';var kamName='-';if(element.zonalManager)zmName=_this3.state.zmDetails.find(function(zm){return zm.value==element.zonalManager;})?_this3.state.zmDetails.find(function(zm){return zm.value==element.zonalManager;}).label:'-';if(element.keyAccountManager)kamName=_this3.state.kamDetails.find(function(zm){return zm.value==element.keyAccountManager;})?_this3.state.kamDetails.find(function(zm){return zm.value==element.keyAccountManager;}).label:'-';_this3.entityId.push(element.entityId);rowData.push(element.vehicleNumber);rowData.push(element.chassisNumber);rowData.push(element.deviceDetail.uniqueDeviceId);rowData.push(element.simDetail&&element.simDetail.phoneNumber);rowData.push(element.deviceDetail.deviceModelId.devicetype);rowData.push(element.deviceDetail.deviceModelId.model_name);rowData.push(element.clientName);rowData.push(_this3.getFormattedDate(element.createdAt));rowData.push(element.firmwareVersion);rowData.push(element.grossVehicleWeight||'-');rowData.push(element.manufacturingYear||'-');rowData.push(element.vehicleSegment||'-');rowData.push(element.equipmentTypeClass||'-');rowData.push(element.vehicleWheeler||'-');rowData.push(element.application||'-');rowData.push(element.baselineDataForFE||'-');rowData.push(element.baselineDistance||'-');rowData.push(element.fuelTankCapacity||'-');rowData.push(element.adblueCapacity||'-');var solutionTypeValue='-';if(Array.isArray(element.solution_type)&&element.solution_type.length>0){solutionTypeValue=element.solution_type.join(', ');// ["fuel"] → "fuel"
}else if(element.solutionType){solutionTypeValue=element.solutionType;}rowData.push(solutionTypeValue);rowData.push(zmName||'-');rowData.push(kamName||'-');rowData.push(element.channelPartnerName||'-');rowData.push(element.technicianName||'-');var valueToPush=void 0;if(element.isDualEngine===true){valueToPush='True';}else if(element.isDualEngine===false){valueToPush='False';}else{valueToPush='-';}rowData.push(valueToPush);rowData.push(element.kvaRating||'-');rowData.push(element.bhp||'-');rowData.push(element.phase||'-');rowData.push(element.engineModel||'-');rowData.push(element.gensetController||'-');}else{// Limited Data mapping
_this3.entityId.push(element.entityId);rowData.push(element.vehicleNumber);rowData.push(element.uniqueId);rowData.push(element.vehicleType||'-');rowData.push(element.vehicleModel||'-');rowData.push(element.clientName||'-');rowData.push(_this3.getFormattedDate(element.vehCreatedOn));rowData.push(element.grossVehicleWeight||'-');rowData.push(element.vehicleSegment||'-');rowData.push(element.fuelTankCapacity||'-');rowData.push(element.adblueCapacity||'-');var _solutionTypeValue='-';if(Array.isArray(element.solution_type)&&element.solution_type.length>0){_solutionTypeValue=element.solution_type.join(', ');}else if(element.solutionType){_solutionTypeValue=element.solutionType;}rowData.push(_solutionTypeValue);var dualEngineVal=void 0;if(element.isDualEngine===true)dualEngineVal='True';else if(element.isDualEngine===false)dualEngineVal='False';else dualEngineVal='-';rowData.push(dualEngineVal);}fullData.push(rowData);});return fullData;}},{key:'componentDidMount',value:function componentDidMount(){this.getZMKAMDetails();}},{key:'render',value:function render(){var _this4=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,justify:'space-between',spacing:16,alignItems:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:8,alignItems:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{variant:'outlined',color:'secondary',className:classes.button,onClick:function onClick(){return _this4.props.history.goBack();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_ArrowBack___default.a,{className:classes.iconSmall}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{variant:'headline'},'Vehicles')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Switch___default.a,{checked:this.state.viewMore,onChange:this.handleToggleChange,color:'primary'}),label:'View More Details'})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog___default.a,{open:this.state.open,onClose:this.handleClose,'aria-labelledby':'form-dialog-title'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__AddDevice__["a" /* default */],{handleClose:this.handleClose})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["Query"],{query:this.state.viewMore?GET_VEHICLE_LIST:GET_VEHICLE_LIST_LIMITED,variables:this.state.viewMore?{loginId:Object(__WEBPACK_IMPORTED_MODULE_11__utils_getLoginId__["a" /* default */])(),status:parseInt(this.props.match.params.status,10)}:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_11__utils_getLoginId__["a" /* default */])(),accountType:localStorage.getItem('Account_type'),status:parseInt(this.props.match.params.status,10),type:'db'},fetchPolicy:this.state.viewMore?"network-only":"cache-first"},function(_ref4){var loading=_ref4.loading,error=_ref4.error,data=_ref4.data;if(loading)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__common_Loader_Loader__["a" /* default */],null);if(error)return'Error!: '+error;var vehicles=data.vehicles||[];// keep a reference to full vehicle objects so onRowClick can pass props/state
_this4.currentVehicles=vehicles;var tableData=_this4.mapToArr(vehicles);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_mui_datatables___default.a,{data:tableData,columns:_this4.state.viewMore?_this4.columns:_this4.limitedColumns,options:_this4.options});}))));}}]);return ViewVehicleList;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_15__HOCs_withSharedSnackbar__["a" /* default */])(ViewVehicleList))));

/***/ }),
/* 2359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_getLoginId__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getDevices($partnerLoginId: Int) {\n    getCurrentSummaryDetails(partnerLoginId: $partnerLoginId) {\n      uniqueid\n      startTime\n      startLoc\n      endTime\n      endLoc\n      distance\n      speed\n      maxSpeed\n      avgSpeed\n      startAddress\n      endAddress\n      clientName\n      driverName\n      vehicleGroupAssign\n      vehicleNumber\n      trackingStatus\n      batteryStatus\n    }\n  }\n'],['\n  query getDevices($partnerLoginId: Int) {\n    getCurrentSummaryDetails(partnerLoginId: $partnerLoginId) {\n      uniqueid\n      startTime\n      startLoc\n      endTime\n      endLoc\n      distance\n      speed\n      maxSpeed\n      avgSpeed\n      startAddress\n      endAddress\n      clientName\n      driverName\n      vehicleGroupAssign\n      vehicleNumber\n      trackingStatus\n      batteryStatus\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var style=function style(theme){return{root:{padding:theme.spacing.unit*4,flexGrow:1},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},iconSmall:{fontSize:20}};};var GET_ALL_VEHICLE_SUMMARY=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject);var currentSummary=function(_Component){_inherits(currentSummary,_Component);function currentSummary(props){var _this2=this;_classCallCheck(this,currentSummary);var _this=_possibleConstructorReturn(this,(currentSummary.__proto__||Object.getPrototypeOf(currentSummary)).call(this,props));_this.clientId=[];_this.columns=['VEHICLE NO','UNIQUE ID','START TIME','START LOCATION','LAST TRACK TIME','LAST TRACK LOCATION','DISTANCE','SPEED','MAX SPEED','AVG SPEED','START ADDRESS','LAST TRACK ADDRESS','CLIENT NAME','DRIVER NAME','GROUP NAME','TRACKING STATUS','BATTERY STATUS'];_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15,filter:false,print:false};_this.state={open:false,open1:false,vehicleInfo:[],userLoginId:'',vehicleInfoTemp:[],isLoading:false};_this.fullData=[];_this.getAllVehicles=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _ref2,vehicles,rowData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:// console.log('clients', clients)
_this.setState({isLoading:true});_context.next=3;return _this.props.client.query({query:GET_ALL_VEHICLE_SUMMARY,variables:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_9__utils_getLoginId__["a" /* default */])()},fetchPolicy:'network-only'}).catch(function(error){console.log(error);});case 3:_ref2=_context.sent;vehicles=_ref2.data;_this.setState({isLoading:false});if(vehicles&&vehicles.getCurrentSummaryDetails){rowData=[];vehicles.getCurrentSummaryDetails.forEach(function(element){rowData=[];rowData.push(element.vehicleNumber);rowData.push(element.uniqueid);if(element&&element.startTime){rowData.push(_this.getFormattedDate(element.startTime));}else rowData.push('---');rowData.push(element.startLoc);if(element&&element.endTime){rowData.push(_this.getFormattedDate(element.endTime));}else rowData.push('---');rowData.push(element.endLoc);rowData.push(element.distance);rowData.push(element.speed);rowData.push(element.maxSpeed);rowData.push(element.avgSpeed);rowData.push(element.startAddress);rowData.push(element.endAddress);rowData.push(element.clientName);rowData.push(element.driverName);rowData.push(element.vehicleGroupAssign);rowData.push(element.trackingStatus);rowData.push(element.batteryStatus);_this.fullData.push(rowData);});}// console.log('fullData vehicleInfo', this.fullData)
_this.setState({vehicleInfo:_this.fullData});case 8:case'end':return _context.stop();}}},_callee,_this2);}));_this.getFormattedDate=function(timestamp){return __WEBPACK_IMPORTED_MODULE_4_moment___default()(timestamp*1000).format('DD-MM-YYYY HH:mm:ss');};_this.classes=props;return _this;}_createClass(currentSummary,[{key:'componentDidMount',value:function componentDidMount(){this.getAllVehicles();}},{key:'render',value:function render(){var classes=this.props.classes;// console.log('log', this.fullData)
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},this.state.isLoading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,justify:'space-between'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{variant:'headline'},'Loading.....')):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_mui_datatables___default.a,{data:this.state.vehicleInfo,columns:this.columns,options:this.options,title:'Current Summary'}))));}}]);return currentSummary;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_5_react_apollo__["withApollo"])(currentSummary)));

/***/ }),
/* 2360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_router_dom_withRouter__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_router_dom_withRouter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_router_dom_withRouter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_common_Loader__ = __webpack_require__(47);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getAllPlans($partnerLoginId: Int!) {\n    allPlans: getAllPlans(partnerLoginId: $partnerLoginId) {\n      id\n      planName\n    }\n  }\n'],['\n  query getAllPlans($partnerLoginId: Int!) {\n    allPlans: getAllPlans(partnerLoginId: $partnerLoginId) {\n      id\n      planName\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  mutation excelFileUpload(\n    $fileInfo: FileUploadInput!\n    $commonInput: CommonInput!\n  ) {\n    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {\n      failedToUpload\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedUploadList\n    }\n  }\n'],['\n  mutation excelFileUpload(\n    $fileInfo: FileUploadInput!\n    $commonInput: CommonInput!\n  ) {\n    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {\n      failedToUpload\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedUploadList\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n'],['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_ALL_PLANS=Object(__WEBPACK_IMPORTED_MODULE_8_graphql_tag__["a" /* default */])(_templateObject);// calling server for updation
var ADD_CUSTOMER=Object(__WEBPACK_IMPORTED_MODULE_8_graphql_tag__["a" /* default */])(_templateObject2);var GET_UPLOAD_URL=Object(__WEBPACK_IMPORTED_MODULE_8_graphql_tag__["a" /* default */])(_templateObject3);var styles=function styles(theme){return{button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{margin:theme.spacing.unit,minWidth:120},root:{flexGrow:1,padding:theme.spacing.unit*2}};};var RegisterBulkCustomer=function(_Component){_inherits(RegisterBulkCustomer,_Component);function RegisterBulkCustomer(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,RegisterBulkCustomer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RegisterBulkCustomer.__proto__||Object.getPrototypeOf(RegisterBulkCustomer)).call.apply(_ref,[this].concat(args))),_this),_this.state={open:false,open1:false,simprovider:'',uploadSucess:true,isSimProviderValid:false,response:'',failList:'',result:false,plan:'',fileName:'',isLoading:false},_this.columns=['User Name','Reason'],_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15// sort: false,
// filter: false,
//  search: false,
// print: false,
// download: false
// viewColumns: false,
// pagination: false
},_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));};},_this.handleClickOpen=function(){_this.setState({open:true});},_this.handleClose=function(){_this.setState({open:false});},_this.handleChange=function(event){_this.setState(_defineProperty({},event.target.name,event.target.value));},_this.handleOpen=function(){_this.setState({open:true});},_this.setToDefaults=function(){_this.setState({response:'',failList:'',result:false,plan:'',fileName:''});},_this.handleOpenSelect=function(){_this.setState({open1:true});},_this.handleCloseSelect=function(){_this.setState({open1:false});},_this.checkSimProviderValidity=function(){_this.setState({isSimProviderValid:_this.state.simprovider!==''});},_this.handlePlanChange=function(plan){if(!plan){_this.setState({plan:''});}else{_this.setState({plan:plan.value});}},_this.handleSubmit=function(client){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _ref3,data,errors,fullData,arrList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:event.preventDefault();_this.setState({isLoading:true});_context.next=4;return client.mutate({mutation:ADD_CUSTOMER,variables:{fileInfo:{uploadFor:'ClientRegistration',bucketName:_this.state.bucketName,fileName:_this.state.fileName,operationType:'SKIP'},commonInput:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__["a" /* default */])(),planId:parseInt(_this.state.plan,10)}}});case 4:_ref3=_context.sent;data=_ref3.data;errors=_ref3.errors;_this.setState({isLoading:false});if(data!==null){fullData=[];arrList=data.excelFileUpload.failedUploadList;console.log('arrList',JSON.parse(arrList),data);JSON.parse(arrList).forEach(function(element){var rowData=[];// this.clientId.push(element.id)
rowData.push(element.username);rowData.push(element.error);fullData.push(rowData);});_this.setState({plan:'',response:'Total Excel Records= '+data.excelFileUpload.totalExcelDataRecords+','+'Total Records Uploaded='+data.excelFileUpload.successfullyUploaded+', Total Records Failed To Upload='+data.excelFileUpload.failedToUpload+', Total Duplicate Records in Excel='+data.excelFileUpload.totalDuplicateRecords,uploadSucess:true,failList:fullData,result:true});}else{_this.setState({response:errors[0].message,uploadSucess:true});}case 9:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}();},_this.onUpload=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4){var _ref4$target=_ref4.target,validity=_ref4$target.validity,_ref4$target$files=_slicedToArray(_ref4$target.files,1),file=_ref4$target$files[0];var fileExtension,response,url;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:// TODO: Handle upload errors
_this.setState({isUploading:true});if(!validity.valid){_context2.next=11;break;}fileExtension=file.name.substring(file.name.lastIndexOf('.')+1);_context2.next=5;return _this.props.client.mutate({mutation:GET_UPLOAD_URL,variables:{fileExtension:fileExtension}});case 5:response=_context2.sent;if(!(response.data&&response.data.getPublicUploadURL)){_context2.next=11;break;}url=response.data.getPublicUploadURL.publicUploadURL;_context2.next=10;return __WEBPACK_IMPORTED_MODULE_11_axios___default.a.put(url,file,{headers:{"x-ms-blob-type":"BlockBlob","Content-Type":file.type||"application/octet-stream"}});case 10:_this.setState({fileName:response.data.getPublicUploadURL.filename,bucketName:response.data.getPublicUploadURL.bucketName,publicUploadURL:response.data.getPublicUploadURL.publicUploadURL});case 11:_this.setState({isUploading:false});case 12:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref5.apply(this,arguments);};}(),_temp),_possibleConstructorReturn(_this,_ret);}// handleSubmit = addDevice => e => {
_createClass(RegisterBulkCustomer,[{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_apollo__["Query"],{query:GET_ALL_PLANS,variables:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__["a" /* default */])()}},function(_ref6){var loading=_ref6.loading,error=_ref6.error,allPlans=_ref6.data.allPlans;if(loading)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_common_Loader__["a" /* default */],null);if(error)return'Error!: '+error;var plans=allPlans.map(function(plan){return{value:plan.id,label:plan.planName};});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Grid"],{container:true,direction:'row',justify:'flex-start',alignItems:'center',spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Typography"],{variant:'headline'},'Customers Bulk Registration')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{style:{minWidth:'40%'}},_this3.state.uploadSucess&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Typography"],{variant:'subheading',color:'primary'},_this3.state.response),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */],{options:plans,value:_this3.state.plan,onChange:_this3.handlePlanChange,placeholder:'Select Plan *'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{accept:'*/*',id:'contained-button-file',multiple:true,type:'file',style:{display:'none'},onChange:_this3.onUpload}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'contained-button-file'},'Upload excel file here \xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{variant:'contained',component:'span',color:'primary'},_this3.state.isUploading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress___default.a,{size:15}):'Upload')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:_this3.setToDefaults,color:'default',variant:'contained'},'SET TO DEFAULTS'),'\xA0 \xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:function onClick(){return _this3.props.history.goBack();},color:'default',variant:'contained'},'Cancel'),'\xA0 \xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:_this3.handleSubmit(_this3.props.client),color:'primary',type:'submit',variant:'contained',disabled:!(_this3.state.plan!==''&&_this3.state.fileName!=='')},'Submit'),' ',_this3.state.isLoading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'Excel sheet upload is in progress..'),_this3.state.result&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',null,'Failed records list'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_mui_datatables___default.a,{data:_this3.state.failList,columns:_this3.columns,options:_this3.options})))));});}}]);return RegisterBulkCustomer;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__["withStyles"])(styles)(__WEBPACK_IMPORTED_MODULE_12_react_router_dom_withRouter___default()(Object(__WEBPACK_IMPORTED_MODULE_9_react_apollo__["withApollo"])(RegisterBulkCustomer))));

/***/ }),
/* 2361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_AppBar__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_AppBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_AppBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Tabs__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Tab__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_getAccountType__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_common_Loader__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Invoices_jsx__ = __webpack_require__(2362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__partnerInvoices_jsx__ = __webpack_require__(2363);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getAllPIAndInvoice($clientLoginId: Int, $paymentStatus: [Int!]) {\n    allInvoiceData: getAllPIAndInvoice(\n      clientLoginId: $clientLoginId\n      paymentStatus: $paymentStatus\n    ) {\n      paymentMasterDetails {\n        id\n        paymentStatus\n        proFormaInvoiceId\n        invoiceId\n        billedDate\n      }\n      clientDetails {\n        clientName\n        contactPerson\n        contactNumber\n        wallet\n      }\n      partnerDetails {\n        id\n        businessName\n      }\n      billingDetails {\n        totalAmount\n        totalAmountGST\n        totalAmountToBePaidGST\n        totalAmountPaidGST\n      }\n      subscriptionBillDetails {\n        subscriptionId\n      }\n    }\n  }\n'],['\n  query getAllPIAndInvoice($clientLoginId: Int, $paymentStatus: [Int!]) {\n    allInvoiceData: getAllPIAndInvoice(\n      clientLoginId: $clientLoginId\n      paymentStatus: $paymentStatus\n    ) {\n      paymentMasterDetails {\n        id\n        paymentStatus\n        proFormaInvoiceId\n        invoiceId\n        billedDate\n      }\n      clientDetails {\n        clientName\n        contactPerson\n        contactNumber\n        wallet\n      }\n      partnerDetails {\n        id\n        businessName\n      }\n      billingDetails {\n        totalAmount\n        totalAmountGST\n        totalAmountToBePaidGST\n        totalAmountPaidGST\n      }\n      subscriptionBillDetails {\n        subscriptionId\n      }\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  mutation($id: Int!, $status: Int!) {\n    updateAndRaiseInvoice(id: $id, paymentStatus: $status)\n  }\n'],['\n  mutation($id: Int!, $status: Int!) {\n    updateAndRaiseInvoice(id: $id, paymentStatus: $status)\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_ALL_BILLS=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject);var CREATE_INVOICE=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject2);var style=function style(theme){return{root:{padding:theme.spacing.unit*4,flexGrow:1,backgroundColor:theme.palette.background.paper},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},iconSmall:{fontSize:20}};};function TabContainer(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Typography___default.a,{component:'div'},props.children);}TabContainer.propTypes={children:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.node.isRequired};var InvoiceDetails=function(_Component){_inherits(InvoiceDetails,_Component);function InvoiceDetails(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,InvoiceDetails);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=InvoiceDetails.__proto__||Object.getPrototypeOf(InvoiceDetails)).call.apply(_ref,[this].concat(args))),_this),_this.state={allInvoiceData:null,paymentStatus:[0],currentTab:'',tableRowData:[],isDataLoading:true/**
   * @summary Handles payment status value
   *  0 - default - Not paid
   *  1 - PI raised
   *  2-  accounts approval
   *  3-  accounts rejected
   *  4 - payment Done - Full payment
   *  5 - on hold
   *  6 - partial payment
   * **/},_this.handleTabChange=function(event,value){_this.setState({currentTab:value},function(){_this.setLocalStorageVariables();_this.clearLocalVariables();});},_this.getClolumns=function(getClolumns){if(_this.state.currentTab==='FULL_PAID'){return _this.columns=['PI No','Client Name','Amount Paid(Incl. GST)','Billing Date'];}else if(_this.state.currentTab==='PARTIAL_PAID'){return _this.columns=['PI No','Client Name','Amount To Be Paid(Incl. GST)','Amount Paid(Incl. GST)','Billing Date'];}else{return _this.columns=['PI No','Client Name','Amount To Be Paid(Incl. GST)','Billing Date'];}},_this.options={print:false,filterType:'dropdown',selectableRows:false,responsive:'scroll',rowsPerPage:15,onRowClick:function onRowClick(rowData,_ref2){var rowIndex=_ref2.rowIndex,dataIndex=_ref2.dataIndex;console.log('row click data:',rowData,rowIndex,dataIndex);console.log('all incoice data',_this.state.allInvoiceData[dataIndex]);// if([])
if(['UN_PAID','PARTIAL_PAID','FULL_PAID'].includes(_this.state.currentTab)){console.log('allInvoiceData index',_this.state.allInvoiceData[dataIndex].paymentMasterDetails.id);_this.createProformaInvoice(_this.state.allInvoiceData[dataIndex].paymentMasterDetails.id);}}// textLabels: {
//   body: {
//     noMatch: this.state.isDataLoading
//       ? <Loader />
//       : 'Sorry, there is no matching data to display'
//   }
// }
},_this.makePayment=function(id){console.log('id is',id);_this.props.history.push({pathname:'/home/manage/makePayment/'+id});},_this.handleButtonClick=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(id,paymentStatus){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.client.mutate({mutation:CREATE_INVOICE,variables:{id:parseInt(id,10),status:paymentStatus},errorPolicy:'all',update:function update(cache,_ref4){var updateAndRaiseInvoice=_ref4.data.updateAndRaiseInvoice;if(updateAndRaiseInvoice){var _cache$readQuery=cache.readQuery({query:GET_ALL_BILLS,variables:{paymentStatus:_this.state.paymentStatus}}),bills=_cache$readQuery.getAllPIAndInvoice;if(paymentStatus===3){bills=bills.filter(function(bill){return bill.id!==id;});}else if(paymentStatus===5){bills=bills.map(function(bill){if(bill.id===id){bill.paymentStatus=5;}return bill;});}cache.writeQuery({query:GET_ALL_BILLS,variables:{paymentStatus:_this.state.paymentStatus},data:{getAllPIAndInvoice:bills}});}}});case 2:_this.setState({invoiceAmount:'',paymentStatus:'',discount:'',remarks:''});_this.props.history.push({pathname:'/home/manage/admin/InvoiceDetails'});case 4:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x,_x2){return _ref3.apply(this,arguments);};}(),_this.getFormattedDate=function(timestamp){__WEBPACK_IMPORTED_MODULE_13_moment___default()(parseInt(timestamp,10)).format('MMM Do YY');// .unix()
// .toString()
},_this.epochToDate=function(date1){var d1=parseInt(date1,10);var unixEpochTimeMS=d1*1000;var d=new Date(unixEpochTimeMS);// Careful, the string output here can vary by implementation...
var strDate=d.toLocaleDateString();return strDate;},_this.createProformaInvoice=function(id){_this.props.history.push({pathname:'/home/manage/admin/CreateProformaInvoice/'+id});},_this.histroyPacketRcv=function(){_this.props.history.push({pathname:'/home/manage/histroyPacketRcv'});},_this.billingDays=function(){_this.props.history.push({pathname:'/home/manage/billingDays'});},_this.makeAdvanceAmount=function(){_this.props.history.push({pathname:'/home/manage/makeAdvanceAmount'});},_this.billingHistoryReport=function(){_this.props.history.push({pathname:'/home/manage/billingHistoryReport'});},_this.getAllBills=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var _ref6,loading,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this.props.client.query({query:GET_ALL_BILLS,variables:{// clientLoginId: getLoginId(),
// clientLoginId: 20,
paymentStatus:_this.state.paymentStatus},fetchPolicy:'network-only'});case 2:_ref6=_context2.sent;loading=_ref6.loading;data=_ref6.data;_this.setState({isDataLoading:loading,allInvoiceData:data.allInvoiceData},function(){console.log('lodaing',loading);});_this.mapToArr(data.allInvoiceData);case 7:case'end':return _context2.stop();}}},_callee2,_this2);})),_this.setLocalStorageVariables=function(){sessionStorage.setItem('mainTabValue',_this.state.currentTab);},_this.getLocalStorageVariables=function(){var _tabvalue=sessionStorage.getItem('mainTabValue');_this.setState({currentTab:_tabvalue});},_this.clearLocalVariables=function(){sessionStorage.removeItem('clientSubTabValue');sessionStorage.removeItem('partnerSubTabValue');},_this.componentDidMount=function(){_this.getAllBills();if(!sessionStorage.getItem('mainTabValue')){_this.setState({currentTab:'CLIENT'},function(){_this.setLocalStorageVariables();});}else{_this.getLocalStorageVariables();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(InvoiceDetails,[{key:'mapToArr',/**
   * @summary Reduce query data to Table Row Data
   *  0 - default - Not paid
   *  1 - PI raised
   *  2-  accounts approval
   *  3-  accounts rejected
   *  4 - payment Done - Full payment
   *  5 - on hold
   *  6 - partial payment
   * **/value:function mapToArr(allInvoiceData){var _this3=this;var rowData=[];var tableRowData=[];allInvoiceData.forEach(function(element){rowData=[];rowData.push(element.paymentMasterDetails.proFormaInvoiceId);element.clientDetails?rowData.push(element.clientDetails.clientName):rowData.push(element.partnerDetails.businessName);if(_this3.state.currentTab==='PARTIAL_PAID'||_this3.state.currentTab==='UN_PAID'){rowData.push(element.billingDetails.totalAmountToBePaidGST);}else if(_this3.state.currentTab==='FULL_PAID'){rowData.push(element.billingDetails.totalAmountPaidGST);}if(_this3.state.currentTab==='PARTIAL_PAID'){rowData.push(element.billingDetails.totalAmountPaidGST);}// rowData.push(element.paymentMasterDetails.billedDate)
rowData.push(_this3.epochToDate(element.paymentMasterDetails.billedDate));// rowData.push(this.getFormattedDate(element.paymentMasterDetails.billedDate))
// if (element.paymentMasterDetails.paymentStatus === 0) {
//   const status = 'Unpaid'
//   rowData.push(status)
// }
// if (element.paymentMasterDetails.paymentStatus === 6) {
//   const status = 'Partially Paid'
//   rowData.push(status)
// }
// if (element.paymentMasterDetails.paymentStatus === 4) {
//   const status = 'Paid'
//   rowData.push(status)
// }
// rowData.push(element.totalVehicles)
// rowData.push(element.totalPI)
// rowData.push(element.clientCredit)
// rowData.push(this.getFormattedDate(element.billGeneratedDate))
//   if (element.paymentStatus === 3) {
//     rowData.push(
//       <Button
//         onClick={e => {
//           e.stopPropagation()
//           this.makePayment(element.id)
//         }}
//       >
//         PAY
//       </Button>
//     )
//   } else if (element.paymentStatus === 4) {
//     rowData.push('Paid')
//   } else if (element.paymentStatus === 5) {
//     rowData.push('On Hold')
//   } else {
//     rowData.push(
//       <Button
//         variant="outlined"
//         onClick={e => {
//           e.stopPropagation()
//           const status = !['SER'].includes(getAccountType()) ? 3 : 5
//           this.handleButtonClick(element.id, status)
//         }}
//       >
//         {!['SER'].includes(getAccountType()) ? 'RAISE' : 'HOLD'}
//       </Button>
//     )
//   }
tableRowData.push(rowData);});console.log('table row data',tableRowData,_typeof(__WEBPACK_IMPORTED_MODULE_13_moment___default()(parseInt('1577711247',10)).format('MMM Do YY')));this.setState({tableRowData:tableRowData});}},{key:'render',value:function render(){var classes=this.props.classes;var _state=this.state,currentTab=_state.currentTab,tableRowData=_state.tableRowData,isDataLoading=_state.isDataLoading;if(isDataLoading){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_common_Loader__["a" /* default */],null);}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},console.log('data loader',isDataLoading),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row',justify:'space-between'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Typography___default.a,{variant:'headline'},'PI and Invoices')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true,spacing:16},!['ACC'].includes(Object(__WEBPACK_IMPORTED_MODULE_14__utils_getAccountType__["a" /* default */])())&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{color:'secondary',variant:'contained',className:classes.button,onClick:this.histroyPacketRcv},'History Of Packet Received')),!['ACC'].includes(Object(__WEBPACK_IMPORTED_MODULE_14__utils_getAccountType__["a" /* default */])())&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{color:'secondary',variant:'contained',className:classes.button,onClick:this.billingDays},'No. Of Billing Days')),!['ACC'].includes(Object(__WEBPACK_IMPORTED_MODULE_14__utils_getAccountType__["a" /* default */])())&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{color:'secondary',variant:'contained',className:classes.button,onClick:this.makeAdvanceAmount},'Make Advance Amount')),!['ACC'].includes(Object(__WEBPACK_IMPORTED_MODULE_14__utils_getAccountType__["a" /* default */])())&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{color:'secondary',variant:'contained',className:classes.button,onClick:this.billingHistoryReport},'Billing History Reports'))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_AppBar___default.a,{position:'static'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Tabs___default.a,{value:currentTab,onChange:this.handleTabChange},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Tab___default.a,{value:'CLIENT',label:'Clients'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Tab___default.a,{value:'PARTNER',label:'Partners'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TabContainer,null,this.state.currentTab==='CLIENT'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Invoices_jsx__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__partnerInvoices_jsx__["a" /* default */],null))));}}}]);return InvoiceDetails;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["withApollo"])(InvoiceDetails)));

/***/ }),
/* 2362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_AppBar__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_AppBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_AppBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Tabs__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Tab__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_getAccountType__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_common_Loader__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_router__ = __webpack_require__(188);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getAllPIAndInvoice($clientLoginId: Int, $paymentStatus: [Int!]) {\n    allInvoiceData: getAllPIAndInvoice(\n      clientLoginId: $clientLoginId\n      paymentStatus: $paymentStatus\n    ) {\n      paymentMasterDetails {\n        id\n        paymentStatus\n        proFormaInvoiceId\n        invoiceId\n        billedDate\n      }\n      clientDetails {\n        clientName\n        contactPerson\n        contactNumber\n        wallet\n      }\n      partnerDetails {\n        id\n        businessName\n      }\n      billingDetails {\n        totalAmount\n        totalAmountGST\n        totalAmountToBePaidGST\n        totalAmountPaidGST\n      }\n      subscriptionBillDetails {\n        subscriptionId\n      }\n    }\n  }\n'],['\n  query getAllPIAndInvoice($clientLoginId: Int, $paymentStatus: [Int!]) {\n    allInvoiceData: getAllPIAndInvoice(\n      clientLoginId: $clientLoginId\n      paymentStatus: $paymentStatus\n    ) {\n      paymentMasterDetails {\n        id\n        paymentStatus\n        proFormaInvoiceId\n        invoiceId\n        billedDate\n      }\n      clientDetails {\n        clientName\n        contactPerson\n        contactNumber\n        wallet\n      }\n      partnerDetails {\n        id\n        businessName\n      }\n      billingDetails {\n        totalAmount\n        totalAmountGST\n        totalAmountToBePaidGST\n        totalAmountPaidGST\n      }\n      subscriptionBillDetails {\n        subscriptionId\n      }\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  mutation($id: Int!, $status: Int!) {\n    updateAndRaiseInvoice(id: $id, paymentStatus: $status)\n  }\n'],['\n  mutation($id: Int!, $status: Int!) {\n    updateAndRaiseInvoice(id: $id, paymentStatus: $status)\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_ALL_BILLS=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject);var CREATE_INVOICE=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject2);var style=function style(theme){return{root:{padding:theme.spacing.unit*4,flexGrow:1,backgroundColor:theme.palette.background.paper},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},iconSmall:{fontSize:20}};};function TabContainer(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Typography___default.a,{component:'div'},props.children);}TabContainer.propTypes={children:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.node.isRequired};var Invoices=function(_Component){_inherits(Invoices,_Component);function Invoices(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,Invoices);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Invoices.__proto__||Object.getPrototypeOf(Invoices)).call.apply(_ref,[this].concat(args))),_this),_this.state={allInvoiceData:null,paymentStatus:[0],currentTab:'UN_PAID',tableRowData:[],isDataLoading:true/**
   * @summary Handles payment status value
   *  0 - default - Not paid
   *  1 - PI raised
   *  2-  accounts approval
   *  3-  accounts rejected
   *  4 - payment Done - Full payment
   *  5 - on hold
   *  6 - partial payment
   * **/},_this.handleTabChange=function(event,value){var paymentStatus=void 0;switch(value){case'UN_PAID':paymentStatus=[0];break;case'PARTIAL_PAID':paymentStatus=[6];break;case'FULL_PAID':paymentStatus=[4];break;default:paymentStatus=[0];}_this.setState({currentTab:value,isDataLoading:false,paymentStatus:paymentStatus},function(){_this.getAllBills();_this.setLocalStorageVariables();});},_this.getClolumns=function(getClolumns){if(_this.state.currentTab==='FULL_PAID'){return _this.columns=['PI No','Client Name','Amount Paid(Incl. GST in Rs)','Billing Date'];}else if(_this.state.currentTab==='PARTIAL_PAID'){return _this.columns=['PI No','Client Name','Amount To Be Paid(Incl. GST in Rs)','Amount Paid(Incl. GST in Rs)','Billing Date'];}else{return _this.columns=['PI No','Client Name','Amount To Be Paid(Incl. GST in Rs)','Billing Date'];}},_this.options={print:false,filterType:'dropdown',selectableRows:false,responsive:'scroll',rowsPerPage:15,onRowClick:function onRowClick(rowData,_ref2){var rowIndex=_ref2.rowIndex,dataIndex=_ref2.dataIndex;console.log('row click data:',rowData,rowIndex,dataIndex);console.log('all incoice data',_this.state.allInvoiceData[dataIndex]);// if([])
if(['UN_PAID','PARTIAL_PAID','FULL_PAID'].includes(_this.state.currentTab)){console.log('allInvoiceData index',_this.state.allInvoiceData[dataIndex].paymentMasterDetails.id);_this.createProformaInvoice(_this.state.allInvoiceData[dataIndex].paymentMasterDetails.id);}}// textLabels: {
//   body: {
//     noMatch: this.state.isDataLoading
//       ? <Loader />
//       : 'Sorry, there is no matching data to display'
//   }
// }
},_this.makePayment=function(id){console.log('id is',id);_this.props.history.push({pathname:'/home/manage/makePayment/'+id});},_this.handleButtonClick=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(id,paymentStatus){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.client.mutate({mutation:CREATE_INVOICE,variables:{id:parseInt(id,10),status:paymentStatus},errorPolicy:'all',update:function update(cache,_ref4){var updateAndRaiseInvoice=_ref4.data.updateAndRaiseInvoice;if(updateAndRaiseInvoice){var _cache$readQuery=cache.readQuery({query:GET_ALL_BILLS,variables:{paymentStatus:_this.state.paymentStatus}}),bills=_cache$readQuery.getAllPIAndInvoice;if(paymentStatus===3){bills=bills.filter(function(bill){return bill.id!==id;});}else if(paymentStatus===5){bills=bills.map(function(bill){if(bill.id===id){bill.paymentStatus=5;}return bill;});}cache.writeQuery({query:GET_ALL_BILLS,variables:{paymentStatus:_this.state.paymentStatus},data:{getAllPIAndInvoice:bills}});}}});case 2:_this.setState({invoiceAmount:'',paymentStatus:'',discount:'',remarks:''});_this.props.history.push({pathname:'/home/manage/admin/InvoiceDetails'});case 4:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x,_x2){return _ref3.apply(this,arguments);};}(),_this.getFormattedDate=function(timestamp){__WEBPACK_IMPORTED_MODULE_13_moment___default()(parseInt(timestamp,10)).format('MMM Do YY');// .unix()
// .toString()
},_this.epochToDate=function(date1){var d1=parseInt(date1,10);var unixEpochTimeMS=d1*1000;var d=new Date(unixEpochTimeMS);// Careful, the string output here can vary by implementation...
var strDate=d.toLocaleDateString();return strDate;},_this.createProformaInvoice=function(id){_this.props.history.push({pathname:'/home/manage/admin/CreateProformaInvoice/'+id});},_this.histroyPacketRcv=function(){_this.props.history.push({pathname:'/home/manage/histroyPacketRcv'});},_this.billingDays=function(){_this.props.history.push({pathname:'/home/manage/billingDays'});},_this.makeAdvanceAmount=function(){_this.props.history.push({pathname:'/home/manage/makeAdvanceAmount'});},_this.billingHistoryReport=function(){_this.props.history.push({pathname:'/home/manage/billingHistoryReport'});},_this.getAllBills=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var _ref6,loading,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:console.log('call get all bills');_context2.next=3;return _this.props.client.query({query:GET_ALL_BILLS,variables:{// clientLoginId: getLoginId(),
// clientLoginId: 20,
paymentStatus:_this.state.paymentStatus},fetchPolicy:'network-only'});case 3:_ref6=_context2.sent;loading=_ref6.loading;data=_ref6.data;_this.setState({isDataLoading:loading,allInvoiceData:data.allInvoiceData},function(){// console.log('lodaing', loading)
});_this.mapToArr(data.allInvoiceData);case 8:case'end':return _context2.stop();}}},_callee2,_this2);})),_this.setLocalStorageVariables=function(){sessionStorage.setItem('clientSubTabValue',_this.state.currentTab);},_this.getLocalStorageVariables=function(){var _tabvalue=sessionStorage.getItem('clientSubTabValue');// console.log('get from local', _tabvalue)
_this.setState({currentTab:_tabvalue},function(){_this.handleTabChange(null,_this.state.currentTab);// console.log('sub tab vlaue:', this.state.currentTab)
});},_this.componentDidMount=function(){_this.getAllBills();if(!sessionStorage.getItem('clientSubTabValue')){_this.setState({currentTab:'UN_PAID'},function(){_this.setLocalStorageVariables();});}else{_this.getLocalStorageVariables();}},_temp),_possibleConstructorReturn(_this,_ret);}// getClolumns = getClolumns => {
//   if (this.state.currentTab === 'FULL_PAID') {
//     return (
//       this.columns = [
//         'PI No',
//         'Client Name',
//         'Amount Paid(Incl. GST)',
//         'Billing Date'
//       ]
//     )
//   } else {
//     return (
//       this.columns = [
//         'PI No',
//         'Client Name',
//         'Amount To Be Paid(Incl. GST)',
//         'Billing Date'
//       ]
//     )
//   }
// }
// this function is added to load columns based on the current tabs for mui data table
// columns = [
//   'PI No',
//   'Client Name',
//   'Amount To Be Paid(Incl. GST)',
//   'Billing Date'
// ]
// fullypaidcolumns = [
//   'PI No',
//   'Client Name',
//   'Amount Paid(Incl. GST)',
//   'Billing Date'
// ]
_createClass(Invoices,[{key:'mapToArr',/**
   * @summary Reduce query data to Table Row Data
   *  0 - default - Not paid
   *  1 - PI raised
   *  2-  accounts approval
   *  3-  accounts rejected
   *  4 - payment Done - Full payment
   *  5 - on hold
   *  6 - partial payment
   * **/value:function mapToArr(allInvoiceData){var _this3=this;var rowData=[];var tableRowData=[];allInvoiceData.forEach(function(element){rowData=[];rowData.push(element.paymentMasterDetails.proFormaInvoiceId);element.clientDetails?rowData.push(element.clientDetails.clientName):rowData.push(element.partnerDetails.businessName);if(_this3.state.currentTab==='PARTIAL_PAID'||_this3.state.currentTab==='UN_PAID'){rowData.push(element.billingDetails.totalAmountToBePaidGST);}else if(_this3.state.currentTab==='FULL_PAID'){rowData.push(element.billingDetails.totalAmountPaidGST);}if(_this3.state.currentTab==='PARTIAL_PAID'){rowData.push(element.billingDetails.totalAmountPaidGST);}// rowData.push(element.paymentMasterDetails.billedDate)
rowData.push(_this3.epochToDate(element.paymentMasterDetails.billedDate));// rowData.push(this.getFormattedDate(element.paymentMasterDetails.billedDate))
// if (element.paymentMasterDetails.paymentStatus === 0) {
//   const status = 'Unpaid'
//   rowData.push(status)
// }
// if (element.paymentMasterDetails.paymentStatus === 6) {
//   const status = 'Partially Paid'
//   rowData.push(status)
// }
// if (element.paymentMasterDetails.paymentStatus === 4) {
//   const status = 'Paid'
//   rowData.push(status)
// }
// rowData.push(element.totalVehicles)
// rowData.push(element.totalPI)
// rowData.push(element.clientCredit)
// rowData.push(this.getFormattedDate(element.billGeneratedDate))
//   if (element.paymentStatus === 3) {
//     rowData.push(
//       <Button
//         onClick={e => {
//           e.stopPropagation()
//           this.makePayment(element.id)
//         }}
//       >
//         PAY
//       </Button>
//     )
//   } else if (element.paymentStatus === 4) {
//     rowData.push('Paid')
//   } else if (element.paymentStatus === 5) {
//     rowData.push('On Hold')
//   } else {
//     rowData.push(
//       <Button
//         variant="outlined"
//         onClick={e => {
//           e.stopPropagation()
//           const status = !['SER'].includes(getAccountType()) ? 3 : 5
//           this.handleButtonClick(element.id, status)
//         }}
//       >
//         {!['SER'].includes(getAccountType()) ? 'RAISE' : 'HOLD'}
//       </Button>
//     )
//   }
tableRowData.push(rowData);});console.log('table row data',tableRowData,_typeof(__WEBPACK_IMPORTED_MODULE_13_moment___default()(parseInt('1577711247',10)).format('MMM Do YY')));this.setState({tableRowData:tableRowData});}},{key:'render',value:function render(){var classes=this.props.classes;var _state=this.state,currentTab=_state.currentTab,tableRowData=_state.tableRowData,isDataLoading=_state.isDataLoading;if(isDataLoading){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_common_Loader__["a" /* default */],null);}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row',justify:'space-between'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true,spacing:16},!['ACC'].includes(Object(__WEBPACK_IMPORTED_MODULE_14__utils_getAccountType__["a" /* default */])())&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{color:'secondary',variant:'contained',className:classes.button,onClick:this.histroyPacketRcv},'History Of Packet Received')),!['ACC'].includes(Object(__WEBPACK_IMPORTED_MODULE_14__utils_getAccountType__["a" /* default */])())&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{color:'secondary',variant:'contained',className:classes.button,onClick:this.billingDays},'No. Of Billing Days')),!['ACC'].includes(Object(__WEBPACK_IMPORTED_MODULE_14__utils_getAccountType__["a" /* default */])())&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{color:'secondary',variant:'contained',className:classes.button,onClick:this.makeAdvanceAmount},'Make Advance Amount')),!['ACC'].includes(Object(__WEBPACK_IMPORTED_MODULE_14__utils_getAccountType__["a" /* default */])())&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{color:'secondary',variant:'contained',className:classes.button,onClick:this.billingHistoryReport},'Billing History Reports'))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_AppBar___default.a,{position:'static'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Tabs___default.a,{value:currentTab,onChange:this.handleTabChange},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Tab___default.a,{value:'UN_PAID',label:'UnPaid Invoices'}),!['SER'].includes(Object(__WEBPACK_IMPORTED_MODULE_14__utils_getAccountType__["a" /* default */])())&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Tab___default.a,{value:'PARTIAL_PAID',label:'Partially Paid Invoices'}),!['SER'].includes(Object(__WEBPACK_IMPORTED_MODULE_14__utils_getAccountType__["a" /* default */])())&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Tab___default.a,{value:'FULL_PAID',label:'Fully Paid Invoices'}))),this.state.isDataLoading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_common_Loader__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TabContainer,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_mui_datatables___default.a,{data:tableRowData,columns:this.getClolumns(),options:this.options}))));}}}]);return Invoices;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);// export default withStyles(style)(withApollo(InvoiceDetails))
Invoices.PropTypes={classes:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_17_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["withApollo"])(Invoices))));

/***/ }),
/* 2363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_AppBar__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_AppBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_AppBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Tabs__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Tab__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_getAccountType__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_common_Loader__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_router__ = __webpack_require__(188);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getAllPartnerPIAndInvoice($clientLoginId: Int, $paymentStatus: [Int!]) {\n    allInvoiceData: getAllPartnerPIAndInvoice(\n      partnerLoginId: $clientLoginId\n      paymentStatus: $paymentStatus\n    ) {\n      paymentMasterDetails {\n        id\n        paymentStatus\n        proFormaInvoiceId\n        invoiceId\n        billedDate\n      }\n      clientDetails {\n        clientName\n        contactPerson\n        contactNumber\n        wallet\n      }\n      partnerDetails {\n        id\n        businessName\n      }\n      billingDetails {\n        totalAmount\n        totalAmountGST\n        totalAmountToBePaidGST\n        totalAmountPaidGST\n      }\n      subscriptionBillDetails {\n        subscriptionId\n      }\n    }\n  }\n'],['\n  query getAllPartnerPIAndInvoice($clientLoginId: Int, $paymentStatus: [Int!]) {\n    allInvoiceData: getAllPartnerPIAndInvoice(\n      partnerLoginId: $clientLoginId\n      paymentStatus: $paymentStatus\n    ) {\n      paymentMasterDetails {\n        id\n        paymentStatus\n        proFormaInvoiceId\n        invoiceId\n        billedDate\n      }\n      clientDetails {\n        clientName\n        contactPerson\n        contactNumber\n        wallet\n      }\n      partnerDetails {\n        id\n        businessName\n      }\n      billingDetails {\n        totalAmount\n        totalAmountGST\n        totalAmountToBePaidGST\n        totalAmountPaidGST\n      }\n      subscriptionBillDetails {\n        subscriptionId\n      }\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  mutation($id: Int!, $status: Int!) {\n    updateAndRaiseInvoice(id: $id, paymentStatus: $status)\n  }\n'],['\n  mutation($id: Int!, $status: Int!) {\n    updateAndRaiseInvoice(id: $id, paymentStatus: $status)\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_ALL_BILLS=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject);var CREATE_INVOICE=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject2);var style=function style(theme){return{root:{padding:theme.spacing.unit*4,flexGrow:1,backgroundColor:theme.palette.background.paper},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},iconSmall:{fontSize:20}};};function TabContainer(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Typography___default.a,{component:'div'},props.children);}TabContainer.propTypes={children:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.node.isRequired};var partnerInvoices=function(_Component){_inherits(partnerInvoices,_Component);function partnerInvoices(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,partnerInvoices);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=partnerInvoices.__proto__||Object.getPrototypeOf(partnerInvoices)).call.apply(_ref,[this].concat(args))),_this),_this.state={allInvoiceData:null,paymentStatus:[0],currentTab:'UN_PAID',tableRowData:[],isDataLoading:true/**
   * @summary Handles payment status value
   *  0 - default - Not paid
   *  1 - PI raised
   *  2-  accounts approval
   *  3-  accounts rejected
   *  4 - payment Done - Full payment
   *  5 - on hold
   *  6 - partial payment
   * **/},_this.handleTabChange=function(event,value){var paymentStatus=void 0;switch(value){case'UN_PAID':paymentStatus=[0];break;case'PARTIAL_PAID':paymentStatus=[6];break;case'FULL_PAID':paymentStatus=[4];break;default:paymentStatus=[0];}_this.setState({currentTab:value,isDataLoading:false,paymentStatus:paymentStatus},function(){_this.getAllBills();_this.setLocalStorageVariables();});},_this.getClolumns=function(getClolumns){if(_this.state.currentTab==='FULL_PAID'){return _this.columns=['PI No','Client Name','Amount Paid(Incl. GST in Rs)','Billing Date'];}else if(_this.state.currentTab==='PARTIAL_PAID'){return _this.columns=['PI No','Client Name','Amount To Be Paid(Incl. GST in Rs)','Amount Paid(Incl. GST in Rs)','Billing Date'];}else{return _this.columns=['PI No','Client Name','Amount To Be Paid(Incl. GST in Rs)','Billing Date'];}},_this.options={print:false,filterType:'dropdown',selectableRows:false,responsive:'scroll',rowsPerPage:15,onRowClick:function onRowClick(rowData,_ref2){var rowIndex=_ref2.rowIndex,dataIndex=_ref2.dataIndex;console.log('row click data:',rowData,rowIndex,dataIndex);console.log('all incoice data',_this.state.allInvoiceData[dataIndex]);// if([])
if(['UN_PAID','PARTIAL_PAID','FULL_PAID'].includes(_this.state.currentTab)){console.log('allInvoiceData index',_this.state.allInvoiceData[dataIndex].paymentMasterDetails.id);_this.createProformaInvoice(_this.state.allInvoiceData[dataIndex].paymentMasterDetails.id);}}// textLabels: {
//   body: {
//     noMatch: this.state.isDataLoading
//       ? <Loader />
//       : 'Sorry, there is no matching data to display'
//   }
// }
},_this.makePayment=function(id){console.log('id is',id);_this.props.history.push({pathname:'/home/manage/makePayment/'+id});},_this.handleButtonClick=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(id,paymentStatus){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.client.mutate({mutation:CREATE_INVOICE,variables:{id:parseInt(id,10),status:paymentStatus},errorPolicy:'all',update:function update(cache,_ref4){var updateAndRaiseInvoice=_ref4.data.updateAndRaiseInvoice;if(updateAndRaiseInvoice){var _cache$readQuery=cache.readQuery({query:GET_ALL_BILLS,variables:{paymentStatus:_this.state.paymentStatus}}),bills=_cache$readQuery.getAllPIAndInvoice;if(paymentStatus===3){bills=bills.filter(function(bill){return bill.id!==id;});}else if(paymentStatus===5){bills=bills.map(function(bill){if(bill.id===id){bill.paymentStatus=5;}return bill;});}cache.writeQuery({query:GET_ALL_BILLS,variables:{paymentStatus:_this.state.paymentStatus},data:{getAllPIAndInvoice:bills}});}}});case 2:_this.setState({invoiceAmount:'',paymentStatus:'',discount:'',remarks:''});_this.props.history.push({pathname:'/home/manage/admin/InvoiceDetails'});case 4:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x,_x2){return _ref3.apply(this,arguments);};}(),_this.getFormattedDate=function(timestamp){__WEBPACK_IMPORTED_MODULE_13_moment___default()(parseInt(timestamp,10)).format('MMM Do YY');// .unix()
// .toString()
},_this.epochToDate=function(date1){var d1=parseInt(date1,10);var unixEpochTimeMS=d1*1000;var d=new Date(unixEpochTimeMS);// Careful, the string output here can vary by implementation...
var strDate=d.toLocaleDateString();return strDate;},_this.createProformaInvoice=function(id){console.log('id===',id);_this.props.history.push({pathname:'/home/manage/admin/CreatePartnerProformaInvoice/'+id});},_this.histroyPacketRcv=function(){_this.props.history.push({pathname:'/home/manage/histroyPacketRcv'});},_this.billingDays=function(){_this.props.history.push({pathname:'/home/manage/billingDays'});},_this.makeAdvanceAmount=function(){_this.props.history.push({pathname:'/home/manage/makeAdvanceAmount'});},_this.billingHistoryReport=function(){_this.props.history.push({pathname:'/home/manage/billingHistoryReport'});},_this.getAllBills=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var _ref6,loading,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this.props.client.query({query:GET_ALL_BILLS,variables:{// clientLoginId: getLoginId(),
// clientLoginId: 20,
paymentStatus:_this.state.paymentStatus// clientLoginId: null
},fetchPolicy:'network-only'});case 2:_ref6=_context2.sent;loading=_ref6.loading;data=_ref6.data;_this.setState({isDataLoading:loading,allInvoiceData:data.allInvoiceData},function(){console.log('lodaing',loading);});_this.mapToArr(data.allInvoiceData);case 7:case'end':return _context2.stop();}}},_callee2,_this2);})),_this.setLocalStorageVariables=function(){sessionStorage.setItem('partnerSubTabValue',_this.state.currentTab);},_this.getLocalStorageVariables=function(){var _tabvalue=sessionStorage.getItem('partnerSubTabValue');// console.log('get from local', _tabvalue)
_this.setState({currentTab:_tabvalue},function(){_this.handleTabChange(null,_this.state.currentTab);// console.log('sub tab vlaue:', this.state.currentTab)
});},_this.componentDidMount=function(){_this.getAllBills();if(!sessionStorage.getItem('partnerSubTabValue')){_this.setState({currentTab:'UN_PAID'},function(){_this.setLocalStorageVariables();});}else{_this.getLocalStorageVariables();}},_temp),_possibleConstructorReturn(_this,_ret);}// getClolumns = getClolumns => {
//   if (this.state.currentTab === 'FULL_PAID') {
//     return (
//       this.columns = [
//         'PI No',
//         'Client Name',
//         'Amount Paid(Incl. GST)',
//         'Billing Date'
//       ]
//     )
//   } else {
//     return (
//       this.columns = [
//         'PI No',
//         'Client Name',
//         'Amount To Be Paid(Incl. GST)',
//         'Billing Date'
//       ]
//     )
//   }
// }
// this function is added to load columns based on the current tabs for mui data table
// columns = [
//   'PI No',
//   'Client Name',
//   'Amount To Be Paid(Incl. GST)',
//   'Billing Date'
// ]
// fullypaidcolumns = [
//   'PI No',
//   'Client Name',
//   'Amount Paid(Incl. GST)',
//   'Billing Date'
// ]
_createClass(partnerInvoices,[{key:'mapToArr',/**
   * @summary Reduce query data to Table Row Data
   *  0 - default - Not paid
   *  1 - PI raised
   *  2-  accounts approval
   *  3-  accounts rejected
   *  4 - payment Done - Full payment
   *  5 - on hold
   *  6 - partial payment
   * **/value:function mapToArr(allInvoiceData){var _this3=this;var rowData=[];var tableRowData=[];allInvoiceData.forEach(function(element){rowData=[];rowData.push(element.paymentMasterDetails.proFormaInvoiceId);element.clientDetails?rowData.push(element.clientDetails.clientName):rowData.push(element.partnerDetails.businessName);if(_this3.state.currentTab==='PARTIAL_PAID'||_this3.state.currentTab==='UN_PAID'){rowData.push(element.billingDetails.totalAmountToBePaidGST);}else if(_this3.state.currentTab==='FULL_PAID'){rowData.push(element.billingDetails.totalAmountPaidGST);}if(_this3.state.currentTab==='PARTIAL_PAID'){rowData.push(element.billingDetails.totalAmountPaidGST);}// rowData.push(element.paymentMasterDetails.billedDate)
rowData.push(_this3.epochToDate(element.paymentMasterDetails.billedDate));// rowData.push(this.getFormattedDate(element.paymentMasterDetails.billedDate))
// if (element.paymentMasterDetails.paymentStatus === 0) {
//   const status = 'Unpaid'
//   rowData.push(status)
// }
// if (element.paymentMasterDetails.paymentStatus === 6) {
//   const status = 'Partially Paid'
//   rowData.push(status)
// }
// if (element.paymentMasterDetails.paymentStatus === 4) {
//   const status = 'Paid'
//   rowData.push(status)
// }
// rowData.push(element.totalVehicles)
// rowData.push(element.totalPI)
// rowData.push(element.clientCredit)
// rowData.push(this.getFormattedDate(element.billGeneratedDate))
//   if (element.paymentStatus === 3) {
//     rowData.push(
//       <Button
//         onClick={e => {
//           e.stopPropagation()
//           this.makePayment(element.id)
//         }}
//       >
//         PAY
//       </Button>
//     )
//   } else if (element.paymentStatus === 4) {
//     rowData.push('Paid')
//   } else if (element.paymentStatus === 5) {
//     rowData.push('On Hold')
//   } else {
//     rowData.push(
//       <Button
//         variant="outlined"
//         onClick={e => {
//           e.stopPropagation()
//           const status = !['SER'].includes(getAccountType()) ? 3 : 5
//           this.handleButtonClick(element.id, status)
//         }}
//       >
//         {!['SER'].includes(getAccountType()) ? 'RAISE' : 'HOLD'}
//       </Button>
//     )
//   }
tableRowData.push(rowData);});console.log('table row data',tableRowData,_typeof(__WEBPACK_IMPORTED_MODULE_13_moment___default()(parseInt('1577711247',10)).format('MMM Do YY')));this.setState({tableRowData:tableRowData});}},{key:'render',value:function render(){var classes=this.props.classes;var _state=this.state,currentTab=_state.currentTab,tableRowData=_state.tableRowData,isDataLoading=_state.isDataLoading;if(isDataLoading){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_common_Loader__["a" /* default */],null);}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row',justify:'space-between'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true,spacing:16},!['ACC'].includes(Object(__WEBPACK_IMPORTED_MODULE_14__utils_getAccountType__["a" /* default */])())&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{color:'secondary',variant:'contained',className:classes.button,onClick:this.histroyPacketRcv},'History Of Packet Received')),!['ACC'].includes(Object(__WEBPACK_IMPORTED_MODULE_14__utils_getAccountType__["a" /* default */])())&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{color:'secondary',variant:'contained',className:classes.button,onClick:this.billingDays},'No. Of Billing Days')),!['ACC'].includes(Object(__WEBPACK_IMPORTED_MODULE_14__utils_getAccountType__["a" /* default */])())&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{color:'secondary',variant:'contained',className:classes.button,onClick:this.makeAdvanceAmount},'Make Advance Amount')),!['ACC'].includes(Object(__WEBPACK_IMPORTED_MODULE_14__utils_getAccountType__["a" /* default */])())&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{color:'secondary',variant:'contained',className:classes.button,onClick:this.billingHistoryReport},'Billing History Reports'))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_AppBar___default.a,{position:'static'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Tabs___default.a,{value:currentTab,onChange:this.handleTabChange},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Tab___default.a,{value:'UN_PAID',label:'UnPaid Invoices'}),!['SER'].includes(Object(__WEBPACK_IMPORTED_MODULE_14__utils_getAccountType__["a" /* default */])())&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Tab___default.a,{value:'PARTIAL_PAID',label:'Partially Paid Invoices'}),!['SER'].includes(Object(__WEBPACK_IMPORTED_MODULE_14__utils_getAccountType__["a" /* default */])())&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Tab___default.a,{value:'FULL_PAID',label:'Fully Paid Invoices'}))),this.state.isDataLoading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_common_Loader__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TabContainer,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_mui_datatables___default.a,{data:tableRowData,columns:this.getClolumns(),options:this.options}))));}}}]);return partnerInvoices;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);partnerInvoices.PropTypes={classes:__WEBPACK_IMPORTED_MODULE_12_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_17_react_router__["a" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["withApollo"])(partnerInvoices))));// export default withStyles(style)(withApollo(InvoiceDetails))

/***/ }),
/* 2364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Paper__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Paper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_getAccountType__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_file_saver__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__BillingDetailsProformaInvoice__ = __webpack_require__(2365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_Card__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core_CardHeader__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core_CardHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_CardHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_core_CardContent__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_core_CardContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_CardContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core_CardActions__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core_CardActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_CardActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ViewSubscription_PaymentMethod__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__material_ui_icons_ArrowBack__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__material_ui_icons_ArrowBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__material_ui_icons_ArrowBack__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query($id: Int!) {\n    getPIAndInvoiceDetail(id: $id) {\n      noOfSubscriptions\n      paymentMasterDetails {\n        id\n        invoiceId\n        serviceRemarks\n        paidMoney\n        invoiceAmountWithGST\n        paymentStatus\n      }\n      clientDetails {\n        id\n        clientName\n        wallet\n        simWallet\n      }\n      partnerDetails {\n        id\n        businessName\n        wallet\n        simWallet\n      }\n      billingDetails {\n        totalAmountToBePaidGST\n        hardwareBillDetails {\n          quantity\n          amount\n          amountGST\n          amountPaidGST\n          amountToBePaidGST\n          creditDate\n        }\n        softwareBillDetails {\n          quantity\n          amount\n          amountGST\n          amountPaidGST\n          amountToBePaidGST\n          creditDate\n        }\n        accessoryBillDetails {\n          quantity\n          amount\n          amountGST\n          amountPaidGST\n          amountToBePaidGST\n          creditDate\n        }\n        simBillDetails {\n          quantity\n          amount\n          amountGST\n          amountPaidGST\n          amountToBePaidGST\n          creditDate\n        }\n      }\n      subscriptionBillDetails {\n        invoiceAmount\n      }\n      paymentHitoryDetails {\n        noOfSubscription\n        accountRemarks\n      }\n    }\n  }\n'],['\n  query($id: Int!) {\n    getPIAndInvoiceDetail(id: $id) {\n      noOfSubscriptions\n      paymentMasterDetails {\n        id\n        invoiceId\n        serviceRemarks\n        paidMoney\n        invoiceAmountWithGST\n        paymentStatus\n      }\n      clientDetails {\n        id\n        clientName\n        wallet\n        simWallet\n      }\n      partnerDetails {\n        id\n        businessName\n        wallet\n        simWallet\n      }\n      billingDetails {\n        totalAmountToBePaidGST\n        hardwareBillDetails {\n          quantity\n          amount\n          amountGST\n          amountPaidGST\n          amountToBePaidGST\n          creditDate\n        }\n        softwareBillDetails {\n          quantity\n          amount\n          amountGST\n          amountPaidGST\n          amountToBePaidGST\n          creditDate\n        }\n        accessoryBillDetails {\n          quantity\n          amount\n          amountGST\n          amountPaidGST\n          amountToBePaidGST\n          creditDate\n        }\n        simBillDetails {\n          quantity\n          amount\n          amountGST\n          amountPaidGST\n          amountToBePaidGST\n          creditDate\n        }\n      }\n      subscriptionBillDetails {\n        invoiceAmount\n      }\n      paymentHitoryDetails {\n        noOfSubscription\n        accountRemarks\n      }\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  mutation makePayment(\n    $paymentId: Int!\n    $totalAmountPaid: Int!\n    $simAmountPaid: Int!\n    $softwareAmountPaid: Int!\n    $accessoryAmountPaid: Int!\n    $hardwareAmountPaid: Int!\n    $accountRemarks: String\n    $paymentMode: paymentMode!\n    $paymentStatus: Int!\n    $bankName: String\n    $referenceNumber: String\n    $chequeDate: String\n    $simExpectedDate: String\n    $softwareExpectedDate: String\n    $hardwareExpectedDate: String\n    $accessoryExpectedDate: String\n  ) {\n    makePayment(\n      paymentId: $paymentId\n      totalAmountPaid: $totalAmountPaid\n      simAmountPaid: $simAmountPaid\n      softwareAmountPaid: $softwareAmountPaid\n      accessoryAmountPaid: $accessoryAmountPaid\n      hardwareAmountPaid: $hardwareAmountPaid\n      accountRemarks: $accountRemarks\n      paymentMode: $paymentMode\n      paymentStatus: $paymentStatus\n      bankName: $bankName\n      referenceNumber: $referenceNumber\n      chequeDate: $chequeDate\n      simExpectedDate: $simExpectedDate\n      accessoryExpectedDate: $accessoryExpectedDate\n      softwareExpectedDate: $softwareExpectedDate\n      hardwareExpectedDate: $hardwareExpectedDate\n    )\n  }\n'],['\n  mutation makePayment(\n    $paymentId: Int!\n    $totalAmountPaid: Int!\n    $simAmountPaid: Int!\n    $softwareAmountPaid: Int!\n    $accessoryAmountPaid: Int!\n    $hardwareAmountPaid: Int!\n    $accountRemarks: String\n    $paymentMode: paymentMode!\n    $paymentStatus: Int!\n    $bankName: String\n    $referenceNumber: String\n    $chequeDate: String\n    $simExpectedDate: String\n    $softwareExpectedDate: String\n    $hardwareExpectedDate: String\n    $accessoryExpectedDate: String\n  ) {\n    makePayment(\n      paymentId: $paymentId\n      totalAmountPaid: $totalAmountPaid\n      simAmountPaid: $simAmountPaid\n      softwareAmountPaid: $softwareAmountPaid\n      accessoryAmountPaid: $accessoryAmountPaid\n      hardwareAmountPaid: $hardwareAmountPaid\n      accountRemarks: $accountRemarks\n      paymentMode: $paymentMode\n      paymentStatus: $paymentStatus\n      bankName: $bankName\n      referenceNumber: $referenceNumber\n      chequeDate: $chequeDate\n      simExpectedDate: $simExpectedDate\n      accessoryExpectedDate: $accessoryExpectedDate\n      softwareExpectedDate: $softwareExpectedDate\n      hardwareExpectedDate: $hardwareExpectedDate\n    )\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation(\n    $id: Int!\n    $paymentStatus: Int!\n    $invoiceAmount: Int\n    $discount: Int\n    $serviceRemarks: String\n    $accountRemarks: String\n  ) {\n    updateAndRaiseInvoice(\n      id: $id\n      paymentStatus: $paymentStatus\n      invoiceAmount: $invoiceAmount\n      discount: $discount\n      serviceRemarks: $serviceRemarks\n      accountRemarks: $accountRemarks\n    )\n  }\n'],['\n  mutation(\n    $id: Int!\n    $paymentStatus: Int!\n    $invoiceAmount: Int\n    $discount: Int\n    $serviceRemarks: String\n    $accountRemarks: String\n  ) {\n    updateAndRaiseInvoice(\n      id: $id\n      paymentStatus: $paymentStatus\n      invoiceAmount: $invoiceAmount\n      discount: $discount\n      serviceRemarks: $serviceRemarks\n      accountRemarks: $accountRemarks\n    )\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query($id: Int!, $isInvoice: Boolean!) {\n    getInvoiceDownloadDetails(id: $id, isInvoice: $isInvoice)\n  }\n'],['\n  query($id: Int!, $isInvoice: Boolean!) {\n    getInvoiceDownloadDetails(id: $id, isInvoice: $isInvoice)\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  query getPIAndInvoiceDetail($id: Int!) {\n    getPIAndInvoiceDetail(id: $id) {\n      paymentMasterDetails {\n        id\n        invoiceId\n      }\n      paymentHitoryDetails {\n        id\n        paidMoney\n        paymentMode\n        referenceNumber\n        createdAt\n        accountRemarks\n        bank\n      }\n    }\n  }\n'],['\n  query getPIAndInvoiceDetail($id: Int!) {\n    getPIAndInvoiceDetail(id: $id) {\n      paymentMasterDetails {\n        id\n        invoiceId\n      }\n      paymentHitoryDetails {\n        id\n        paidMoney\n        paymentMode\n        referenceNumber\n        createdAt\n        accountRemarks\n        bank\n      }\n    }\n  }\n']);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_PI_INFO=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject);var MAKE_PAYMENT=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject2);var CREATE_INVOICE=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject3);var GET_PDF_DOWNLOAD_LINK=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject4);var GET_PI_AND_INVOICE=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject5);var style=function style(theme){return{root:{padding:theme.spacing.unit*4,flexGrow:1,backgroundColor:theme.palette.background.paper},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},iconSmall:{fontSize:20},selectStyle:{margin:theme.spacing.unit,minWidth:250},textField:{marginLeft:theme.spacing.unit,marginRight:theme.spacing.unit,minWidth:250},pad:{padding:theme.spacing.unit*2},redButton:{backgroundColor:theme.palette.error.main,'&:hover':{backgroundColor:theme.palette.error.dark}}};};var paymentOption=['CASH','ONLINE','CHEQUE','DD'];var columns=['Payment Id','Payment Made','Mode of Payment','Reference Number','Bank','Date of Payment','Payment Remarks'];var CreateProformaInvoice=function(_Component){_inherits(CreateProformaInvoice,_Component);function CreateProformaInvoice(props){var _this2=this;_classCallCheck(this,CreateProformaInvoice);var _this=_possibleConstructorReturn(this,(CreateProformaInvoice.__proto__||Object.getPrototypeOf(CreateProformaInvoice)).call(this,props));_this.state={labelWidth:0,piInfo:'',paymentType:'',invoiceAmount:0,paymentStatus:'',discount:0,remarks:'',error:true,isDownloading:false,paymentMode:'',paymentId:0,referenceNumber:null,bankName:'',paidMoney:'',accountRemarks:'',validation:false,hardwarePaymentMade:0,softwarePaymentMade:0,accessoryPaymentMade:0,simPaymentMade:0,totalAmountPaid:0,hardwareBalance:0,softwareBalance:0,accessoryBalance:0,simBalance:0,paymentMadeFieldValidation:false,hardwareRemarks:null,softwareRemarks:null,accessoryRemarks:null,simRemarks:null,checkDate:null,expectedHardwareDueDate:__WEBPACK_IMPORTED_MODULE_15_moment___default()().add(1,'weeks'),expectedSoftwareDueDate:__WEBPACK_IMPORTED_MODULE_15_moment___default()().add(1,'weeks'),expectedAccessoryDueDate:__WEBPACK_IMPORTED_MODULE_15_moment___default()().add(1,'weeks'),expectedSimsDueDate:__WEBPACK_IMPORTED_MODULE_15_moment___default()().add(1,'weeks'),approveOrReject:null,allInvoiceData:[],paymentStatusShow:'',saveBtnDisabled:false};_this.getMuiTheme=function(){return Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__["createMuiTheme"])({overrides:{MUIDataTableToolbar:{root:{display:'none'}}}});};_this.options={filterType:'dropdown',filter:false,search:false,download:false,print:false,disableToolbarSelect:false,viewColumns:false,selectableRows:false,responsive:'scroll',rowsPerPage:5,rowHover:false// onRowClick: (rowData, dataIndex, rowIndex) => {
//   this.props.history.push({
//     pathname:
//       '/home/subscriptions' +
//       '/' +
//       this.subcriptionIdPartner[dataIndex.dataIndex] +
//       '/partnerSubscriptionDetail'
//   })
// }
// makePayment = () => {
//   this.props.history.push({
//     pathname: '/home/manage/makePayment'
//   })
// }
// handleChangeDiscount = event => {
//   this.setState(
//     {
//       discount: event.target.value,
//       invoiceAmount: this.state.piInfo.totalPI - event.target.value
//     },
//     () => this.checkTotalInvoice()
//   )
// }
// checkTotalInvoice() {
//   if (
//     this.state.piInfo.totalPI < this.state.invoiceAmount ||
//     this.state.invoiceAmount < 0
//   ) {
//     this.props.openSnackbar(
//       'Discount should not be more than Invoice amount!'
//     )
//     this.setState({
//       error: false,
//       discount: 0,
//       invoiceAmount: 0
//     })
//   }
// }
};_this.handleChangeRemarks=function(event){_this.setState({remarks:event.target.value});};_this.handleSaveMutation=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _ref2,data,errors;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.client.mutate({mutation:MAKE_PAYMENT,variables:{paymentId:parseInt(_this.state.paymentId,10),totalAmountPaid:parseInt(_this.state.totalAmountPaid,10),simAmountPaid:parseInt(_this.state.simPaymentMade,10),softwareAmountPaid:parseInt(_this.state.softwarePaymentMade,10),accessoryAmountPaid:parseInt(_this.state.accessoryPaymentMade,10),hardwareAmountPaid:parseInt(_this.state.hardwarePaymentMade,10),accountRemarks:_this.state.accountRemarks,paymentMode:_this.state.paymentMode,paymentStatus:parseInt(_this.state.paymentStatus,10),bankName:_this.state.bankName,referenceNumber:_this.state.referenceNumber?_this.state.referenceNumber.toString():_this.state.referenceNumber,chequeDate:__WEBPACK_IMPORTED_MODULE_15_moment___default()(parseInt(_this.state.checkDate,10)),simExpectedDate:__WEBPACK_IMPORTED_MODULE_15_moment___default()(_this.state.expectedSimsDueDate).unix().toString(),accessoryExpectedDate:__WEBPACK_IMPORTED_MODULE_15_moment___default()(_this.state.expectedAccessoryDueDate).unix().toString(),softwareExpectedDate:__WEBPACK_IMPORTED_MODULE_15_moment___default()(_this.state.expectedHardwareDueDate).unix().toString(),hardwareExpectedDate:__WEBPACK_IMPORTED_MODULE_15_moment___default()(_this.state.expectedSoftwareDueDate).unix().toString()},errorPolicy:'all'});case 2:_ref2=_context.sent;data=_ref2.data;errors=_ref2.errors;if(errors){_this.props.openSnackbar(errors[0].message,{type:'error'});_this.setState({saveBtnDisabled:false});}else if(data.makePayment){_this.props.openSnackbar('Successfully Details Saved');_this.props.history.goBack();}case 6:case'end':return _context.stop();}}},_callee,_this2);}));_this.validateFields=function(){var regExValue=new RegExp(/^([a-zA-Z0-9_-]){5,25}$/);var regExValueBank=new RegExp(/^[A-Za-z\s]{3,30}$/);if(_this.state.paymentMode==='ONLINE'){if(_this.state.referenceNumber!==''&&regExValue.test(_this.state.referenceNumber)){_this.setState({validation:true});return true;}else{_this.props.openSnackbar('Reference Number length Should between 5 to 25 and Alphanumeric');_this.setState({validation:false});return false;}}else if(_this.state.accountRemarks.length>100){_this.props.openSnackbar('Remarks should be less than 100 Characters!');return false;}else if(_this.state.paymentMode==='DD'||_this.state.paymentMode==='CHEQUE'){if(!regExValue.test(_this.state.referenceNumber)){console.log('reference in valid');_this.props.openSnackbar('Reference Number length Should between 5 to 25 and Alphanumeric');_this.setState({validation:false});return false;}else if(!regExValueBank.test(_this.state.bankName)||_this.state.bankName===null){_this.props.openSnackbar('Bank Name length Should be between 3 to 30 and only alphabets');_this.setState({validation:false});return false;}else{_this.setState({validation:true});return true;}}else{_this.setState({validation:true});return true;}};_this.handleSave=function(){if(_this.validateFields()){_this.setState({saveBtnDisabled:true});_this.handleSaveMutation();}};_this.handleCancel=function(loginId){console.log('this.props',_this.props);_this.props.history.goBack();// this.props.history.push({
//   pathname: '/home/manage/admin/InvoiceDetails'
// })
};_this.calculateBalance=function(perticularName){var billingDetails=_this.state.piInfo.billingDetails;if(perticularName==='hardwarePaymentMade'){if(billingDetails.hardwareBillDetails){var amountToBePaidGST=billingDetails.hardwareBillDetails.amountToBePaidGST;var hardwarePaymentMade=_this.state.hardwarePaymentMade;_this.setState({hardwareBalance:amountToBePaidGST-hardwarePaymentMade});}}else if(perticularName==='softwarePaymentMade'){if(billingDetails.softwareBillDetails){var _amountToBePaidGST=billingDetails.softwareBillDetails.amountToBePaidGST;var softwarePaymentMade=_this.state.softwarePaymentMade;_this.setState({softwareBalance:_amountToBePaidGST-softwarePaymentMade});}}else if(perticularName==='accessoryPaymentMade'){if(billingDetails.accessoryBillDetails){var _amountToBePaidGST2=billingDetails.accessoryBillDetails.amountToBePaidGST;var accessoryPaymentMade=_this.state.accessoryPaymentMade;_this.setState({accessoryBalance:_amountToBePaidGST2-accessoryPaymentMade});}}else{var _amountToBePaidGST3=billingDetails.simBillDetails.amountToBePaidGST;var simPaymentMade=_this.state.simPaymentMade;_this.setState({simBalance:_amountToBePaidGST3-simPaymentMade});}};_this.handlePaymentMade=function(name){return function(event){console.log('handlepayment made',name);_this.setState(_defineProperty({},name,event.target.value),function(){_this.calculateBalance(name);_this.handleTotalAmountPaid();});};};_this.handleExpectedDateChange=function(name){return function(date){_this.setState(_defineProperty({},name,date),function(){});};};_this.handleRemarksChange=function(name){return function(event){};};_this.paymentModeAndModeValidation=function(){var _this$state=_this.state,totalAmountPaid=_this$state.totalAmountPaid,paymentMode=_this$state.paymentMode;if(totalAmountPaid>0&&paymentMode){_this.setState({paymentMadeFieldValidation:true});}else{_this.setState({paymentMadeFieldValidation:false});}};_this.handleTotalAmountPaid=function(){var total=0;var _this$state2=_this.state,hardwarePaymentMade=_this$state2.hardwarePaymentMade,softwarePaymentMade=_this$state2.softwarePaymentMade,accessoryPaymentMade=_this$state2.accessoryPaymentMade,simPaymentMade=_this$state2.simPaymentMade;total=parseInt(hardwarePaymentMade,10)+parseInt(softwarePaymentMade,10)+parseInt(accessoryPaymentMade,10)+parseInt(simPaymentMade,10);_this.setState({totalAmountPaid:total},function(){_this.paymentModeAndModeValidation();});};_this.handleChangePaymentType=function(event){_this.setState({paymentMode:event.target.value},function(){_this.paymentModeAndModeValidation();});};_this.handleChangeReferenceNumber=function(event){// console.log('event', event.target.value)
_this.setState({referenceNumber:event.target.value});// console.log('referenceNumber', this.state.referenceNumber)
};_this.handleChangeBankName=function(event){_this.setState({bankName:event.target.value});};_this.handleAccountRemarksChange=function(event){_this.setState({accountRemarks:event.target.value});};_this.getClientPIInfo=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var _ref4,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this.props.client.query({query:GET_PI_INFO,variables:{id:parseInt(_this.id,10)},fetchPolicy:'network-only'});case 2:_ref4=_context2.sent;data=_ref4.data;if(data.getPIAndInvoiceDetail){_this.setState({piInfo:data.getPIAndInvoiceDetail},function(){console.log('piInfo',_this.state.piInfo);_this.setInitialData();_this.getPaymentStatusValue();});}case 5:case'end':return _context2.stop();}}},_callee2,_this2);}));_this.setInitialData=function(){var piInfo=_this.state.piInfo;if(piInfo.paymentMasterDetails){_this.setState({paymentId:piInfo.paymentMasterDetails.id,paymentStatus:piInfo.paymentMasterDetails.paymentStatus});}if(piInfo.billingDetails){var _piInfo$billingDetail=piInfo.billingDetails,hardwareBillDetails=_piInfo$billingDetail.hardwareBillDetails,softwareBillDetails=_piInfo$billingDetail.softwareBillDetails,accessoryBillDetails=_piInfo$billingDetail.accessoryBillDetails,simBillDetails=_piInfo$billingDetail.simBillDetails;if(hardwareBillDetails){_this.setState({hardwareBalance:hardwareBillDetails.amountToBePaidGST});}if(softwareBillDetails){_this.setState({softwareBalance:softwareBillDetails.amountToBePaidGST});}if(accessoryBillDetails){_this.setState({accessoryBalance:accessoryBillDetails.amountToBePaidGST});}if(simBillDetails){_this.setState({simBalance:simBillDetails.amountToBePaidGST});}}};_this.mapToArray=function(data){console.log('invoice data',data);var paymentMasterDetails=data.paymentMasterDetails,paymentHitoryDetails=data.paymentHitoryDetails;var mappedArray=paymentHitoryDetails.reduce(function(acc,item){var tableData=[];tableData.push(paymentMasterDetails.invoiceId);item.paidMoney>=0?tableData.push(item.paidMoney):tableData.push('N/A');item.paymentMode?tableData.push(item.paymentMode):tableData.push('N/A');item.referenceNumber?tableData.push(item.referenceNumber):tableData.push('N/A');item.bank?tableData.push(item.bank):tableData.push('N/A');/* eslint-disable indent */item.createdAt?tableData.push(__WEBPACK_IMPORTED_MODULE_15_moment___default.a.unix(parseInt(item.createdAt,10)).format('L')):tableData.push('N/A');/* eslint-enable indent */item.accountRemarks?tableData.push(item.accountRemarks):tableData.push('N/A');acc.push(tableData);return acc;},[]);_this.setState({allInvoiceData:mappedArray},function(){console.log('all Invoive data',_this.state.allInvoiceData);});};_this.getPIandInvoice=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var _ref6,data,loading,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return _this.props.client.query({query:GET_PI_AND_INVOICE,variables:{id:parseInt(_this.props.match.params.id,10)},fetchPolicy:'network-only'});case 2:_ref6=_context3.sent;data=_ref6.data;loading=_ref6.loading;error=_ref6.error;console.log('all PI data',data);if(data&&data.getPIAndInvoiceDetail){_this.mapToArray(data.getPIAndInvoiceDetail);}case 8:case'end':return _context3.stop();}}},_callee3,_this2);}));_this.getPaymentStatusValue=function(){if(_this.state.piInfo){console.log('payment status',_this.state.piInfo.paymentMasterDetails.paymentStatus);switch(_this.state.piInfo.paymentMasterDetails.paymentStatus){case 0:_this.setState({paymentStatusShow:'Unpaid'});break;case 1:_this.setState({paymentStatusShow:'Pending for approval'});break;case 2:_this.setState({paymentStatusShow:'Subscription approved'});break;case 3:_this.setState({paymentStatusShow:'Subscription Rejected'});break;case 4:_this.setState({paymentStatusShow:'Full payment'});break;case 5:_this.setState({paymentStatusShow:'On hold'});break;case 6:_this.setState({paymentStatusShow:'Partial payment'});break;default:_this.setState({paymentStatusShow:'N/A'});break;}}};_this.id=_this.props.match.params.id;return _this;}// handleReject = async () => {
//   await this.props.client.mutate({
//     mutation: CREATE_INVOICE,
//     variables: {
//       id: parseInt(this.id, 10),
//       invoiceAmount: parseInt(this.state.piInfo.totalPI, 10),
//       paymentStatus: 3,
//       discount: 0,
//       ...(!['SER'].includes(getAccountType())
//         ? { accountRemarks: this.state.remarks }
//         : { serviceRemarks: this.state.remarks })
//     },
//     errorPolicy: 'all'
//   })
//   this.setState({
//     invoiceAmount: '',
//     paymentStatus: '',
//     discount: '',
//     remarks: ''
//   })
//   this.props.history.push({
//     pathname: '/home/manage/admin/InvoiceDetails'
//   })
// }
// downloadPdf = async () => {
//   this.setState({ isDownloading: true })
//   const isInvoice = [3, 4].includes(this.state.piInfo.paymentStatus)
//   const { data } = await this.props.client.query({
//     query: GET_PDF_DOWNLOAD_LINK,
//     variables: {
//       id: parseInt(this.id, 10),
//       isInvoice
//     },
//     errorPolicy: 'all'
//   })
//   if (data && data.getInvoiceDownloadDetails) {
//     const res = await axios({
//       url: data.getInvoiceDownloadDetails,
//       method: 'GET',
//       headers: { Accept: 'application/pdf' },
//       responseType: 'blob' // important
//     })
//     FileSaver.saveAs(new Blob([res.data]), 'Invoice.pdf')
//   }
//   this.setState({ isDownloading: false })
// }
_createClass(CreateProformaInvoice,[{key:'componentDidMount',value:function componentDidMount(){this.getClientPIInfo();this.getPIandInvoice();}},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;var _state=this.state,piInfo=_state.piInfo,paymentMadeFieldValidation=_state.paymentMadeFieldValidation,allInvoiceData=_state.allInvoiceData;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.gridItemHorizontal},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{variant:'outlined',color:'secondary',className:classes.button,onClick:function onClick(){return _this3.props.history.goBack();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_icons_ArrowBack___default.a,{className:classes.iconSmall}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,justify:'space-between',alignItems:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'display1',gutterBottom:true},'Invoice Details')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,spacing:16},[3,4].includes(this.state.piInfo.paymentStatus)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{variant:'raised',color:'primary',onClick:function onClick(){return _this3.downloadPdf(true);}},this.state.isDownloading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["CircularProgress"],{size:24}):'Download Invoice'))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_Card___default.a,{className:classes.card,raised:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_CardHeader___default.a,{title:'Client Details'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body1',color:'textSecondary'},'Client Name'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body2'},piInfo.clientDetails&&piInfo.clientDetails.clientName))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body1',color:'textSecondary'},'Invoice Number'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body2'},piInfo.paymentMasterDetails&&piInfo.paymentMasterDetails.invoiceId)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body1',color:'textSecondary'},'Payment Status'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body2'},piInfo.paymentMasterDetails&&this.state.paymentStatusShow)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body1',color:'textSecondary'},'Total Subscriptions'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body2'},piInfo.noOfSubscriptions&&piInfo.noOfSubscriptions?piInfo.noOfSubscriptions:'N/A'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body1',color:'textSecondary'},'Pending amount(incl GST)'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body2'},'\u20B9',' ',piInfo.clientDetails&&piInfo.billingDetails.totalAmountToBePaidGST)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body1',color:'textSecondary'},'Invoice Amount (Incl GST)'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body2'},'\u20B9',' ',piInfo.paymentMasterDetails&&piInfo.paymentMasterDetails.invoiceAmountWithGST)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body1',color:'textSecondary'},'Sim Wallet'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body2'},'\u20B9',' ',piInfo.clientDetails&&piInfo.clientDetails.simWallet)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body1',color:'textSecondary'},'software Wallet'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body2'},'\u20B9',' ',piInfo.clientDetails&&piInfo.clientDetails.wallet)),(this.state.piInfo.paymentStatus===3||this.state.piInfo.paymentStatus===4)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,md:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body1',color:'textSecondary'},'Account Remarks'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body2'},this.state.piInfo.accountRemarks||'-')),this.state.piInfo.paymentStatus===4&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,md:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body1',color:'textSecondary'},'Discount'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body2'},'\u20B9',' ',this.state.piInfo.totalPI-this.state.piInfo.totalInvoice)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,md:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body1',color:'textSecondary'},'Final amount'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body2'},'\u20B9 ',this.state.piInfo.totalInvoice))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),['ACC'].includes(Object(__WEBPACK_IMPORTED_MODULE_10__utils_getAccountType__["a" /* default */])())&&piInfo.paymentMasterDetails&&[0,6].includes(piInfo.paymentMasterDetails.paymentStatus)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__BillingDetailsProformaInvoice__["a" /* default */],{piInfoData:piInfo,hardwarePaymentMade:this.state.hardwarePaymentMade,paymentStatus:this.state.paymentStatus,softwarePaymentMade:this.state.softwarePaymentMade,accessoryPaymentMade:this.state.accessoryPaymentMade,simPaymentMade:this.state.simPaymentMade,hardwareBalance:this.state.hardwareBalance,softwareBalance:this.state.softwareBalance,accessoryBalance:this.state.accessoryBalance,simBalance:this.state.simBalance,hardwareRemarks:this.state.hardwareRemarks,softwareRemarks:this.state.softwareRemarks,accessoryRemarks:this.state.accessoryRemarks,simRemarks:this.state.simRemarks,expectedHardwareDueDate:this.state.expectedHardwareDueDate,expectedSoftwareDueDate:this.state.expectedSoftwareDueDate,expectedAccessoryDueDate:this.state.expectedAccessoryDueDate,expectedSimsDueDate:this.state.expectedSimsDueDate,handlePaymentMade:this.handlePaymentMade,handleRemarksChange:this.handleRemarksChange,handleExpectedDateChange:this.handleExpectedDateChange})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},['ACC'].includes(Object(__WEBPACK_IMPORTED_MODULE_10__utils_getAccountType__["a" /* default */])())&&piInfo.paymentMasterDetails&&[0,6,4].includes(piInfo.paymentMasterDetails.paymentStatus)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_Card___default.a,{raised:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_CardHeader___default.a,{className:classes.cardAction,title:'Payment History'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,justify:'space-between'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__["MuiThemeProvider"],{theme:this.getMuiTheme()},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_mui_datatables___default.a,{data:allInvoiceData,columns:columns,options:this.options}))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),['ACC'].includes(Object(__WEBPACK_IMPORTED_MODULE_10__utils_getAccountType__["a" /* default */])())&&piInfo.paymentMasterDetails&&[0,6].includes(piInfo.paymentMasterDetails.paymentStatus)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_Card___default.a,{className:classes.card,raised:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_CardHeader___default.a,{title:'Record Payment'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core_FormControl___default.a,{className:classes.formControl},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core_InputLabel___default.a,{id:'payment-helper'},'Payment Type'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__material_ui_core_Select___default.a,{value:this.state.paymentMode,onChange:this.handleChangePaymentType,className:classes.selectStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_MenuItem___default.a,{value:'CASH'},'Cash'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_MenuItem___default.a,{value:'ONLINE'},'Online'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_MenuItem___default.a,{value:'CHEQUE'},'Cheque'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_MenuItem___default.a,{value:'DD'},'DD')))),paymentOption.includes(this.state.paymentMode)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__ViewSubscription_PaymentMethod__["a" /* default */],{paymentThrough:this.state.paymentMode,handleChangereferenceNumber:this.handleChangeReferenceNumber,handleChangeBankName:this.handleChangeBankName,handleChangePaidMoney:this.handleChangePaidMoney// paidMoney={this.state.paidMoney}
,referenceNumber:this.state.referenceNumber,bankName:this.state.bankName})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField___default.a,{multiline:true,rows:2,label:'Remarks',variant:'contained',onChange:this.handleAccountRemarksChange,value:this.state.accountRemarks})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_CardActions___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{variant:'contained',color:'secondary',classes:{root:classes.redButton},onClick:this.handleCancel},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{disabled:!paymentMadeFieldValidation||this.state.saveBtnDisabled,variant:'contained',color:'secondary',type:'submit',onClick:this.handleSave},'Save'))))));}}]);return CreateProformaInvoice;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_9__HOCs_withSharedSnackbar__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["withApollo"])(CreateProformaInvoice))));

/***/ }),
/* 2365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Card__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_CardHeader__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_CardHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_CardHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_CardContent__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_CardContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_CardContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_CardActions__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_CardActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_CardActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui_pickers__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles=function styles(theme){return{rowStyle:{margin:'15px 0'},textFieldStyle:{width:'55%'},dateStyle:{width:'50%'},subHeadingStyle:{marginLeft:'1.9vw',marginBottom:'10px',fontSize:'1rem',fontWeight:'bold'},cardAction:{marginLeft:'-1.9vw'}};};var BillingDetailsProformaInvoice=function(_Component){_inherits(BillingDetailsProformaInvoice,_Component);function BillingDetailsProformaInvoice(){_classCallCheck(this,BillingDetailsProformaInvoice);return _possibleConstructorReturn(this,(BillingDetailsProformaInvoice.__proto__||Object.getPrototypeOf(BillingDetailsProformaInvoice)).apply(this,arguments));}_createClass(BillingDetailsProformaInvoice,[{key:'render',value:function render(){var _props=this.props,classes=_props.classes,piInfoData=_props.piInfoData;var billingDetails=piInfoData.billingDetails;var _props2=this.props,paymentStatus=_props2.paymentStatus,hardwarePaymentMade=_props2.hardwarePaymentMade,softwarePaymentMade=_props2.softwarePaymentMade,accessoryPaymentMade=_props2.accessoryPaymentMade,simPaymentMade=_props2.simPaymentMade,hardwareBalance=_props2.hardwareBalance,softwareBalance=_props2.softwareBalance,accessoryBalance=_props2.accessoryBalance,simBalance=_props2.simBalance,hardwareRemarks=_props2.hardwareRemarks,softwareRemarks=_props2.softwareRemarks,accessoryRemarks=_props2.accessoryRemarks,simRemarks=_props2.simRemarks,expectedHardwareDueDate=_props2.expectedHardwareDueDate,expectedSoftwareDueDate=_props2.expectedSoftwareDueDate,expectedAccessoryDueDate=_props2.expectedAccessoryDueDate,expectedSimsDueDate=_props2.expectedSimsDueDate,handlePaymentMade=_props2.handlePaymentMade,handleRemarksChange=_props2.handleRemarksChange,handleExpectedDateChange=_props2.handleExpectedDateChange;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,billingDetails&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Card___default.a,{raised:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_CardHeader___default.a,{className:classes.cardAction,title:'Billing Details'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,justify:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,style:{marginRight:'7vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,direction:'column',alignContent:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},'PARTICULARS')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},' Quantity')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},' ','Total Bill(Incl. GST)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},' Total Paid')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},' Total Payable')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},' Payment Made')))),billingDetails.hardwareBillDetails&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,direction:'column',alignContent:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},' HARDWARE')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},billingDetails.hardwareBillDetails.quantity)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9 ',billingDetails.hardwareBillDetails.amountGST)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9',' ',billingDetails.hardwareBillDetails.amountPaidGST)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9',' ',billingDetails.hardwareBillDetails.amountToBePaidGST)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},'\u20B9',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField___default.a,{type:'Number',className:classes.textFieldStyle,label:'Paid Amount *',inputProps:{min:0},value:hardwarePaymentMade,onChange:handlePaymentMade('hardwarePaymentMade'),margin:'none',disabled:billingDetails.hardwareBillDetails.amountToBePaidGST<=0})))),billingDetails.softwareBillDetails&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,direction:'column',alignContent:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},' SOFTWARE ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},billingDetails.softwareBillDetails.quantity)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9 ',billingDetails.softwareBillDetails.amountGST)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9',' ',billingDetails.softwareBillDetails.amountPaidGST)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9',' ',billingDetails.softwareBillDetails.amountToBePaidGST)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},'\u20B9',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField___default.a,{type:'Number',className:classes.textFieldStyle,label:'Paid Amount *',inputProps:{min:0},value:softwarePaymentMade,onChange:handlePaymentMade('softwarePaymentMade'),margin:'none'})))),billingDetails.accessoryBillDetails&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,direction:'column',alignContent:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},' ACCESSORY')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},' ',billingDetails.accessoryBillDetails.quantity)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9',' ',billingDetails.accessoryBillDetails.amountGST)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},'\u20B9',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},billingDetails.accessoryBillDetails.amountPaidGST)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9',' ',billingDetails.accessoryBillDetails.amountToBePaidGST)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},'\u20B9',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField___default.a,{type:'Number',className:classes.textFieldStyle,label:'Paid Amount *',inputProps:{min:0},value:accessoryPaymentMade,onChange:handlePaymentMade('accessoryPaymentMade'),margin:'none'})))),billingDetails.simBillDetails&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,direction:'column',alignContent:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},' SIM ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},billingDetails.simBillDetails.quantity)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9 ',billingDetails.simBillDetails.amountGST)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9 ',billingDetails.simBillDetails.amountPaidGST)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9',' ',billingDetails.simBillDetails.amountToBePaidGST)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},'\u20B9',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField___default.a,{type:'Number',className:classes.textFieldStyle,label:'Paid Amount *',inputProps:{min:0},value:simPaymentMade,onChange:handlePaymentMade('simPaymentMade'),margin:'none'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),billingDetails&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Card___default.a,{raised:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_CardHeader___default.a,{className:classes.cardAction,title:'Credit Note'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,justify:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,style:{marginRight:'7vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,direction:'column',alignContent:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},'Balance')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},'Credit Date')),[0].includes(paymentStatus)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,style:{margin:'25px 0'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},' ','Expected Due Date')))),billingDetails.hardwareBillDetails&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,disabled:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,direction:'column',alignContent:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},'\u20B9 ',hardwareBalance)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2',style:{marginRight:'100px'}},__WEBPACK_IMPORTED_MODULE_13_moment___default.a.unix(parseInt(piInfoData.billingDetails.hardwareBillDetails.creditDate,10)).format('DD/MM/YYYY'))),[0].includes(paymentStatus)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_material_ui_pickers__["a" /* DatePicker */],{disabled:hardwareBalance===0,className:classes.dateStyle,label:'Due Date',value:expectedHardwareDueDate// views={['year', 'month', 'date']}
,format:'DD/MM/YYYY',onChange:handleExpectedDateChange('expectedHardwareDueDate')})))),billingDetails.softwareBillDetails&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,direction:'column',alignContent:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},'\u20B9 ',softwareBalance)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2',style:{marginRight:'100px'}},__WEBPACK_IMPORTED_MODULE_13_moment___default.a.unix(parseInt(piInfoData.billingDetails.softwareBillDetails.creditDate,10)).format('DD/MM/YYYY'))),[0].includes(paymentStatus)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_material_ui_pickers__["a" /* DatePicker */],{disabled:softwareBalance===0,className:classes.dateStyle,label:'Due Date',value:expectedSoftwareDueDate,onChange:handleExpectedDateChange('expectedSoftwareDueDate'),format:'DD/MM/YYYY'})))),billingDetails.accessoryBillDetails&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,direction:'column',alignContent:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},'\u20B9 ',accessoryBalance)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2',style:{marginRight:'100px'}},__WEBPACK_IMPORTED_MODULE_13_moment___default.a.unix(parseInt(piInfoData.billingDetails.accessoryBillDetails.creditDate,10)).format('DD/MM/YYYY'))),[0].includes(paymentStatus)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_material_ui_pickers__["a" /* DatePicker */],{disabled:accessoryBalance===0,className:classes.dateStyle,label:'Due Date',value:expectedAccessoryDueDate,onChange:handleExpectedDateChange('expectedAccessoryDueDate'),format:'DD/MM/YYYY'})))),billingDetails.simBillDetails?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,direction:'column',alignContent:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},'\u20B9 ',simBalance)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2',style:{marginRight:'100px'}},__WEBPACK_IMPORTED_MODULE_13_moment___default.a.unix(parseInt(piInfoData.billingDetails.simBillDetails.creditDate,10)).format('DD/MM/YYYY'))),[0].includes(paymentStatus)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_material_ui_pickers__["a" /* DatePicker */],{disabled:simBalance===0,className:classes.dateStyle,label:'Due Date',value:expectedSimsDueDate,onChange:handleExpectedDateChange('expectedSimsDueDate'),format:'DD/MM/YYYY'})))):null))));}}]);return BillingDetailsProformaInvoice;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_1_react_apollo__["withApollo"])(BillingDetailsProformaInvoice)));

/***/ }),
/* 2366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getLatestLocation($uniqueId: String!) {\n    getLatestLocation(uniqueId: $uniqueId) {\n      timestamp\n      latitude\n      longitude\n      speed\n      eventFlag\n    }\n  }\n'],['\n  query getLatestLocation($uniqueId: String!) {\n    getLatestLocation(uniqueId: $uniqueId) {\n      timestamp\n      latitude\n      longitude\n      speed\n      eventFlag\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_LATEST_INFO=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject);var style=function style(theme){return{root:{padding:theme.spacing.unit*4,flexGrow:1,backgroundColor:theme.palette.background.paper},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},iconSmall:{fontSize:20},textField:{marginLeft:theme.spacing.unit,marginRight:theme.spacing.unit},dense:{marginTop:16}};};var SearchDevice=function(_Component){_inherits(SearchDevice,_Component);function SearchDevice(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,SearchDevice);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SearchDevice.__proto__||Object.getPrototypeOf(SearchDevice)).call.apply(_ref,[this].concat(args))),_this),_this.state={uniqueId:'',latestTrackInfo:[]},_this.columns=['TIMESTAMP','LATITUDE','LONGITUDE','SPEED'],_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15},_this.handleChange=function(event){_this.setState({uniqueId:event.target.value});},_this.getLatestTackInfo=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var latestInfo;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.client.query({query:GET_LATEST_INFO,variables:{uniqueId:'it_'+_this.state.uniqueId}});case 2:latestInfo=_context.sent;if(latestInfo&&latestInfo.data){// this.mapToArr(latestInfo.data.getLatestLocation)
console.log('allBills.data',latestInfo.data.getLatestLocation);_this.setState({latestTrackInfo:latestInfo.data.getLatestLocation});// console.log('allBills.data', this.state.latestTrackInfo)
}case 4:case'end':return _context.stop();}}},_callee,_this2);})),_this.getFormattedDate=function(timestamp){return __WEBPACK_IMPORTED_MODULE_9_moment___default()(timestamp*1000).format('MMM Do YYYY, h:mm a');},_this.getIgnitionStatus=function(){var status='OFF';if(_this.state.latestTrackInfo.eventFlag){status=(Number(_this.state.latestTrackInfo.eventFlag)&Number(1024))===Number(1024)?'ON':'OFF';}console.log('Ignition status',status);return status;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SearchDevice,[{key:'render',value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{variant:'subtitle1',gutterBottom:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',null,'Search Device')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField___default.a,{id:'outlined-dense',label:'Enter Serial/IMEI No.',margin:'dense',variant:'outlined',onChange:this.handleChange,value:this.state.uniqueId})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button___default.a,{variant:'contained',color:'primary',className:classes.button,onClick:this.getLatestTackInfo},'Search'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,spacing:24},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'Timestamp :'),this.state.latestTrackInfo.timestamp?this.getFormattedDate(this.state.latestTrackInfo.timestamp):'No Data'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'Latitude :'),' ',this.state.latestTrackInfo.latitude),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'Longitude :'),' ',this.state.latestTrackInfo.longitude),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'Speed :'),' ',this.state.latestTrackInfo.speed),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'Ignition Status :'),' ',this.getIgnitionStatus())));}}]);return SearchDevice;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["withApollo"])(SearchDevice)));

/***/ }),
/* 2367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Paper__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Paper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PaymentMethod_jsx__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_axios__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_file_saver__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_file_saver__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getPIAndInvoiceDetail($id: Int!) {\n    getPIAndInvoiceDetail(id: $id) {\n      id\n      PIId\n      invoiceId\n      clientName\n      totalInvoice\n      totalVehicles\n      totalSubscriptions\n      clientCredit\n      totalPI\n      discount\n      clientLoginId\n      createdAt\n      paymentStatus\n      GST\n      noOfSubscriptions\n    }\n  }\n'],['\n  query getPIAndInvoiceDetail($id: Int!) {\n    getPIAndInvoiceDetail(id: $id) {\n      id\n      PIId\n      invoiceId\n      clientName\n      totalInvoice\n      totalVehicles\n      totalSubscriptions\n      clientCredit\n      totalPI\n      discount\n      clientLoginId\n      createdAt\n      paymentStatus\n      GST\n      noOfSubscriptions\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  mutation updatePaymentDetails(\n    $id: Int!\n    $invoiceId: String!\n    $paymentId: String!\n    $clientLoginId: Int!\n    $paidMoney: Int!\n    $paymentMode: String!\n    $bankName: String\n    $chequeDate: String\n    $referenceNumber: Int\n    $remarks: String\n    $noOfSubscription: Int!\n    $noOfDevices: Int!\n    $billPaidDate: String!\n    $billGeneratedDate: String!\n    $invoiceAmount: Int!\n    $piAmount: Int!\n    $GST: Float!\n    $discount: Int\n    $clientCredit: Int!\n  ) {\n    updatePaymentDetails(\n      id: $id\n      invoiceId: $invoiceId\n      paymentId: $paymentId\n      clientLoginId: $clientLoginId\n      paidMoney: $paidMoney\n      paymentMode: $paymentMode\n      bankName: $bankName\n      chequeDate: $chequeDate\n      referenceNumber: $referenceNumber\n      remarks: $remarks\n      noOfSubscription: $noOfSubscription\n      noOfDevices: $noOfDevices\n      billPaidDate: $billPaidDate\n      billGeneratedDate: $billGeneratedDate\n      invoiceAmount: $invoiceAmount\n      piAmount: $piAmount\n      GST: $GST\n      discount: $discount\n      clientCredit: $clientCredit\n    )\n  }\n'],['\n  mutation updatePaymentDetails(\n    $id: Int!\n    $invoiceId: String!\n    $paymentId: String!\n    $clientLoginId: Int!\n    $paidMoney: Int!\n    $paymentMode: String!\n    $bankName: String\n    $chequeDate: String\n    $referenceNumber: Int\n    $remarks: String\n    $noOfSubscription: Int!\n    $noOfDevices: Int!\n    $billPaidDate: String!\n    $billGeneratedDate: String!\n    $invoiceAmount: Int!\n    $piAmount: Int!\n    $GST: Float!\n    $discount: Int\n    $clientCredit: Int!\n  ) {\n    updatePaymentDetails(\n      id: $id\n      invoiceId: $invoiceId\n      paymentId: $paymentId\n      clientLoginId: $clientLoginId\n      paidMoney: $paidMoney\n      paymentMode: $paymentMode\n      bankName: $bankName\n      chequeDate: $chequeDate\n      referenceNumber: $referenceNumber\n      remarks: $remarks\n      noOfSubscription: $noOfSubscription\n      noOfDevices: $noOfDevices\n      billPaidDate: $billPaidDate\n      billGeneratedDate: $billGeneratedDate\n      invoiceAmount: $invoiceAmount\n      piAmount: $piAmount\n      GST: $GST\n      discount: $discount\n      clientCredit: $clientCredit\n    )\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query($id: Int!, $isInvoice: Boolean!) {\n    getInvoiceDownloadDetails(id: $id, isInvoice: $isInvoice)\n  }\n'],['\n  query($id: Int!, $isInvoice: Boolean!) {\n    getInvoiceDownloadDetails(id: $id, isInvoice: $isInvoice)\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_PI_INFO=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject);var UPDATE_PAYMENT_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject2);var GET_PDF_DOWNLOAD_LINK=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject3);var style=function style(theme){return{root:{padding:theme.spacing.unit*4,flexGrow:1,backgroundColor:theme.palette.background.paper},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},iconSmall:{fontSize:20},selectStyle:{margin:theme.spacing.unit,minWidth:250},textField:{marginLeft:theme.spacing.unit,marginRight:theme.spacing.unit,minWidth:250},pad:{padding:theme.spacing.unit*2}};};var paymentOption=['CASH','ONLINE','CHEQUE','DD'];var makePayment=function(_Component){_inherits(makePayment,_Component);function makePayment(props){var _this2=this;_classCallCheck(this,makePayment);var _this=_possibleConstructorReturn(this,(makePayment.__proto__||Object.getPrototypeOf(makePayment)).call(this,props));_this.state={paymentType:'',piInfo:'',paymentStatus:'',error:true,referenceNumber:'',bankName:'',paidMoney:'',validation:false};_this.handleChange=function(event){_this.setState({paymentType:event.target.value});};_this.getClientInfo=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var piDetails;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.client.query({query:GET_PI_INFO,variables:{id:parseInt(_this.id,10)}});case 2:piDetails=_context.sent;if(piDetails&&piDetails.data){// console.log('piDetails.dta', piDetails.data)
_this.setState({piInfo:piDetails.data.getPIAndInvoiceDetail});console.log('piInfo.data',_this.state.piInfo);}case 4:case'end':return _context.stop();}}},_callee,_this2);}));_this.handleChangereferenceNumber=function(event){_this.setState({referenceNumber:event.target.value},function(){return _this.validateFields();});};_this.handleChangePaidMoney=function(event){_this.setState({paidMoney:event.target.value},function(){return _this.validateFields();});};_this.handleChangeBankName=function(event){_this.setState({bankName:event.target.value},function(){return _this.validateFields();});};_this.cancelRaise=function(loginId){_this.props.history.push({pathname:'/home/manage/admin/InvoiceDetails'});};_this.validateFields=function(){console.log('this.state.paymentTypeff',_this.state.paymentType);if(_this.state.paymentType==='ONLINE'){if(_this.state.referenceNumber===''){_this.props.openSnackbar('Reference Number Should not blank');_this.setState({validation:false});}else if(_this.state.paidMoney!==_this.state.piInfo.totalInvoice){_this.props.openSnackbar('Amount Should be equal to Invoice Amount!');_this.setState({validation:false});}else{_this.setState({validation:true});}}else if(_this.state.paymentType==='DD'||_this.state.paymentType==='CHEQUE'){if(_this.state.referenceNumber===''){_this.props.openSnackbar('Reference Number Should not blank!');_this.setState({validation:false});}else if(_this.state.bankName===''){_this.props.openSnackbar('Bank Name Should not blank!');_this.setState({validation:false});}else if(_this.state.paidMoney!==_this.state.piInfo.totalInvoice){_this.props.openSnackbar('Amount Should be equal to Invoice Amount!');_this.setState({validation:false});}else{_this.setState({validation:true});}}else{_this.setState({validation:true});}};_this.handleSubmit=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(event){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:event.preventDefault();_context2.next=3;return _this.props.client.mutate({mutation:UPDATE_PAYMENT_DETAILS,variables:{id:parseInt(_this.id,10),invoiceId:_this.state.piInfo.invoiceId,paymentId:_this.state.piInfo.PIId,clientLoginId:parseInt(_this.state.piInfo.clientLoginId,10),paidMoney:parseInt(_this.state.paidMoney,10),paymentMode:_this.state.paymentType,bankName:_this.state.bankName,chequeDate:_this.state.TransactionDate,// Need to Change
referenceNumber:parseInt(_this.state.referenceNumber,10),remarks:_this.state.remarks,noOfSubscription:parseInt(_this.state.piInfo.totalSubscriptions,10),noOfDevices:parseInt(_this.state.piInfo.totalVehicles,10),billPaidDate:_this.state.piInfo.createdAt,// Need to Change
billGeneratedDate:_this.state.piInfo.createdAt,invoiceAmount:parseInt(_this.state.piInfo.totalInvoice,10),piAmount:_this.state.piInfo.totalPI,GST:parseFloat(_this.state.piInfo.GST),discount:parseInt(_this.state.piInfo.discount,10),clientCredit:parseInt(_this.state.piInfo.clientCredit,10)},errorPolicy:'all'});case 3:_this.setState({invoiceId:'',paymentId:'',clientLoginId:'',paidMoney:'',paymentMode:'',bankName:'',chequeDate:'',referenceNumber:'',remarks:'',noOfSubscription:'',noOfDevices:'',billPaidDate:'',billGeneratedDate:'',invoiceAmount:'',piAmount:'',GST:'',discount:'',clientCredit:''});_this.props.openSnackbar('Updated Successfuly...');_this.props.history.push({pathname:'/home/manage/admin/InvoiceDetails'});case 6:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}();_this.downloadPdf=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(isInvoice){var _ref4,data,res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_this.setState({isDownloading:true});_context3.next=3;return _this.props.client.query({query:GET_PDF_DOWNLOAD_LINK,variables:{id:parseInt(_this.id,10),isInvoice:isInvoice},errorPolicy:'all'});case 3:_ref4=_context3.sent;data=_ref4.data;if(!(data&&data.getInvoiceDownloadDetails)){_context3.next=10;break;}_context3.next=8;return __WEBPACK_IMPORTED_MODULE_16_axios___default()({url:data.getInvoiceDownloadDetails,method:'GET',headers:{Accept:'application/pdf'},responseType:'blob'// important
});case 8:res=_context3.sent;__WEBPACK_IMPORTED_MODULE_17_file_saver___default.a.saveAs(new Blob([res.data]),'Invoice.pdf');case 10:_this.setState({isDownloading:false});case 11:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x2){return _ref3.apply(this,arguments);};}();_this.id=_this.props.match.params.id;return _this;}_createClass(makePayment,[{key:'componentDidMount',value:function componentDidMount(){this.getClientInfo();}},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,justify:'space-between',alignItems:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'subtitle1',gutterBottom:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',null,'Make Payment'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{variant:'outlined',onClick:function onClick(){return _this3.downloadPdf(false);}},this.state.isDownloading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["CircularProgress"],{size:24}):'Download PI')),[3,4].includes(this.state.piInfo.paymentStatus)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{variant:'raised',color:'primary',onClick:function onClick(){return _this3.downloadPdf(true);}},this.state.isDownloading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["CircularProgress"],{size:24}):'Download Invoice'))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Paper___default.a,{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'subtitle1',color:'textSecondary'},'Client Name'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{component:'h3',variant:'h3'},this.state.piInfo.clientName))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'subtitle1',color:'textSecondary'},'Proforma Invoice Number'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{component:'h3',variant:'h3'},this.state.piInfo.PIId)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'subtitle1',color:'textSecondary'},'Invoice Number'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{component:'h3',variant:'h3'},this.state.piInfo.invoiceId)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'subtitle1',color:'textSecondary'},'Total Subscriptions'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{component:'h3',variant:'h3'},this.state.piInfo.totalSubscriptions))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'subtitle1',color:'textSecondary'},'Total Devices'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{component:'h3',variant:'h3'},this.state.piInfo.totalVehicles)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'subtitle1',color:'textSecondary'},'Credit Amount'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{component:'h3',variant:'h3'},this.state.piInfo.clientCredit)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'subtitle1',color:'textSecondary'},'Invoice Amount'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{component:'h3',variant:'h3'},this.state.piInfo.totalPI)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,md:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'subtitle1',color:'textSecondary'},'Service Remarks'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{component:'h3',variant:'h3'},this.state.piInfo.serviceRemarks||'-')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,md:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'subtitle1',color:'textSecondary'},'Account Remarks'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{component:'h3',variant:'h3'},this.state.piInfo.accountRemarks||'-')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,md:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'subtitle1',color:'textSecondary'},'Discount'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{component:'h3',variant:'h3'},this.state.piInfo.totalPI-this.state.piInfo.totalInvoice)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,md:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'subtitle1',color:'textSecondary'},'Final Amount'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{component:'h3',variant:'h3'},this.state.piInfo.totalInvoice)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row',justify:'flex-start',alignItems:'flex-start'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_InputLabel___default.a,{htmlFor:'age-helper'},'Payment Type'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Select___default.a,{value:this.state.paymentType,onChange:this.handleChange,input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Input"],{name:'paymentType',id:'paymentType-helper'}),className:classes.selectStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_MenuItem___default.a,{value:'CASH'},'CASH'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_MenuItem___default.a,{value:'ONLINE'},'ONLINE'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_MenuItem___default.a,{value:'CHEQUE'},'CHEQUE'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_MenuItem___default.a,{value:'DD'},'DD'))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,spacing:16},paymentOption.includes(this.state.paymentType)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__PaymentMethod_jsx__["a" /* default */],{paymentThrough:this.state.paymentType,handleChangereferenceNumber:this.handleChangereferenceNumber,handleChangeBankName:this.handleChangeBankName,handleChangePaidMoney:this.handleChangePaidMoney,paidMoney:this.state.paidMoney,referenceNumber:this.state.referenceNumber,bankName:this.state.bankName}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row',justify:'center',alignItems:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:0},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{variant:'contained',color:'primary',className:classes.button,onClick:this.cancelRaise},'Cancel')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:0},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{variant:'contained',color:'primary',type:'submit',className:classes.button,onClick:this.handleSubmit,disabled:parseInt(this.state.paidMoney,10)!==parseInt(this.state.piInfo.totalInvoice,10)||this.state.validation===false},'Confirm Payment'))))));}}]);return makePayment;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_15__HOCs_withSharedSnackbar__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_14_react_apollo__["withApollo"])(makePayment))));

/***/ }),
/* 2368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_pickers__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_ArrowBack__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_ArrowBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_ArrowBack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_select__ = __webpack_require__(25);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query allClientDetails($partnerLoginId: Int) {\n    clients: allClientDetails(partnerLoginId: $partnerLoginId) {\n      id\n      clientName\n      loginId\n    }\n  }\n'],['\n  query allClientDetails($partnerLoginId: Int) {\n    clients: allClientDetails(partnerLoginId: $partnerLoginId) {\n      id\n      clientName\n      loginId\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query getAllVehicleDetails($clientLoginId: Int) {\n    getAllVehicleDetails(clientLoginId: $clientLoginId) {\n      vehicleNumber\n      entityId\n      deviceDetail {\n        uniqueDeviceId\n      }\n    }\n  }\n'],['\n  query getAllVehicleDetails($clientLoginId: Int) {\n    getAllVehicleDetails(clientLoginId: $clientLoginId) {\n      vehicleNumber\n      entityId\n      deviceDetail {\n        uniqueDeviceId\n      }\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query getAllDevicePackets(\n    $deviceUniqueId: [String!]!\n    $clientLoginId: Int!\n    $fromDate: String!\n    $toDate: String!\n  ) {\n    getAllDevicePackets(\n      deviceUniqueId: $deviceUniqueId\n      clientLoginId: $clientLoginId\n      fromDate: $fromDate\n      toDate: $toDate\n    ) {\n      deviceUniqueId\n      clientLoginId\n      noOfPackets\n      dateOfPackets\n      vehicleNumber\n    }\n  }\n'],['\n  query getAllDevicePackets(\n    $deviceUniqueId: [String!]!\n    $clientLoginId: Int!\n    $fromDate: String!\n    $toDate: String!\n  ) {\n    getAllDevicePackets(\n      deviceUniqueId: $deviceUniqueId\n      clientLoginId: $clientLoginId\n      fromDate: $fromDate\n      toDate: $toDate\n    ) {\n      deviceUniqueId\n      clientLoginId\n      noOfPackets\n      dateOfPackets\n      vehicleNumber\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_CLIENTS=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject);var GET_ALL_VEHICLES=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject2);var GET_DEVICE_PACKETS=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject3);var style=function style(theme){return{root:{padding:theme.spacing.unit*4,flexGrow:1},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},iconSmall:{fontSize:20},selstyle:{maxHeight:ITEM_HEIGHT*4.5+ITEM_PADDING_TOP,width:250}};};var ITEM_HEIGHT=48;var ITEM_PADDING_TOP=8;var HistoryPacketReceived=function(_Component){_inherits(HistoryPacketReceived,_Component);function HistoryPacketReceived(props){var _this2=this;_classCallCheck(this,HistoryPacketReceived);var _this=_possibleConstructorReturn(this,(HistoryPacketReceived.__proto__||Object.getPrototypeOf(HistoryPacketReceived)).call(this,props));_this.state={spacing:'16',clientNames:[],smsSalesReportFrom:{date:__WEBPACK_IMPORTED_MODULE_10_moment___default()(),unix:__WEBPACK_IMPORTED_MODULE_10_moment___default()().unix().toString()},smsSalesReportTo:{date:__WEBPACK_IMPORTED_MODULE_10_moment___default()(),unix:__WEBPACK_IMPORTED_MODULE_10_moment___default()().unix().toString()},name:[],fullData:[],clientNameInfo:[],clientName:'',clientLoginId:[],clientNameLoginId:[],reportView:false,vehicleNumber:[],clientID:'',vehicleDetails:[]};_this.columns=['VEHICLE NUMBER','DATE','PACKET COUNT'];_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15,filter:false};_this.handleDateChange=function(vehicleNumber){return function(date){var tempDate=_this.state[vehicleNumber];tempDate.date=date;tempDate.unix=__WEBPACK_IMPORTED_MODULE_10_moment___default()(date).unix().toString();_this.setState(_defineProperty({},vehicleNumber,tempDate));};};_this.handleChange=function(event){console.log('event',event.value);_this.setState({clientName:event.value,clientID:event.value,vehicleNumber:[]},function(){return _this.getAllVehicleInfo();});};_this.handleChangeVlpn=function(event){_this.setState({vehicleNumber:event.value},function(){return console.log('arr=',_this.state.vehicleNumber);});};_this.getAllVehicleInfo=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var vehicles,allvehicles;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.client.query({query:GET_ALL_VEHICLES,variables:{clientLoginId:parseInt(_this.state.clientID,10)}});case 2:vehicles=_context.sent;if(vehicles&&vehicles.data){// console.log('customers.data', vehicles.data)
allvehicles=vehicles.data.getAllVehicleDetails.map(function(vehicle){return{value:vehicle.deviceDetail.uniqueDeviceId,label:vehicle.vehicleNumber};});_this.setState({vehicleDetails:allvehicles});// console.log(this.state.vehicleDetails, 'vehicles')
}case 4:case'end':return _context.stop();}}},_callee,_this2);}));_this.viewHistoryPacketReport=function(val){return _asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var _ref3,data,rowDataLast;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this.props.client.query({query:GET_DEVICE_PACKETS,variables:{deviceUniqueId:_this.state.vehicleNumber,clientLoginId:parseInt(_this.state.clientID,10),fromDate:_this.state.smsSalesReportFrom.unix,toDate:_this.state.smsSalesReportTo.unix}});case 2:_ref3=_context2.sent;data=_ref3.data;console.log('dRr',data);rowDataLast=[];data.getAllDevicePackets.forEach(function(element){var rowData=[];rowData.push(element.vehicleNumber);rowData.push(_this.getFormattedDate(element.dateOfPackets));rowData.push(element.noOfPackets);rowDataLast.push(rowData);});_this.setState({fullData:rowDataLast,reportView:true});case 8:case'end':return _context2.stop();}}},_callee2,_this2);}));};_this.getFormattedDate=function(timestamp){return __WEBPACK_IMPORTED_MODULE_10_moment___default()(timestamp*1000).format('MMM Do YYYY, h:mm a');};_this.getAllCustomers=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var customers,allClients;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return _this.props.client.query({query:GET_CLIENTS,variables:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_8__utils_getLoginId__["a" /* default */])()}});case 2:customers=_context3.sent;if(customers&&customers.data){console.log('customers.data',customers.data);allClients=customers.data.clients.map(function(client){return{value:client.loginId,label:client.clientName};});_this.setState({clientNames:allClients});}case 4:case'end':return _context3.stop();}}},_callee3,_this2);}));_this.class=props;return _this;}_createClass(HistoryPacketReceived,[{key:'componentDidMount',value:function componentDidMount(){this.getAllCustomers();}},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;var spacing=this.state.spacing;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{variant:'outlined',color:'secondary',className:classes.button,onClick:function onClick(){return _this3.props.history.goBack();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_ArrowBack___default.a,{className:classes.iconSmall})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'History Of Packet Receiving'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row',justify:'center',alignItems:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,justify:'center',spacing:Number(spacing)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,style:{width:'20%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_select__["a" /* default */],{classes:classes,options:this.state.clientNames// components={components}
,value:this.state.clientName,onChange:this.handleChange,placeholder:'Select Customer'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,style:{width:'20%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_select__["a" /* default */],{classes:classes,isMulti:true,options:this.state.vehicleDetails// components={components}
,value:this.state.vehicleNumber,onChange:this.handleChangeVlpn,placeholder:'Select Vehicles'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_pickers__["a" /* DatePicker */],{value:this.state.smsSalesReportFrom.date,onChange:this.handleDateChange('smsSalesReportFrom'),label:'From Date',format:'DD/MM/YYYY'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_pickers__["a" /* DatePicker */],{value:this.state.smsSalesReportTo.date,onChange:this.handleDateChange('smsSalesReportTo'),label:'To Date',format:'DD/MM/YYYY'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{color:'secondary',variant:'contained',className:classes.button,onClick:this.viewHistoryPacketReport('hai'),disabled:this.state.vehicleNumber.length===0&&this.state.clientName.length===0||this.state.smsSalesReportTo.date===''||this.state.smsSalesReportFrom.date===''},'View')))),this.state.reportView&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_mui_datatables___default.a,{data:this.state.fullData,columns:this.columns,options:this.options}))));}}]);return HistoryPacketReceived;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["withApollo"])(HistoryPacketReceived)));

/***/ }),
/* 2369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_icons_ArrowBack__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_icons_ArrowBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_icons_ArrowBack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_NativeSelect__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_NativeSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_NativeSelect__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query allClientDetails($partnerLoginId: Int) {\n    clients: allClientDetails(partnerLoginId: $partnerLoginId) {\n      id\n      clientName\n      loginId\n    }\n  }\n'],['\n  query allClientDetails($partnerLoginId: Int) {\n    clients: allClientDetails(partnerLoginId: $partnerLoginId) {\n      id\n      clientName\n      loginId\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query getAllVehicleDetails($clientLoginId: Int) {\n    getAllVehicleDetails(clientLoginId: $clientLoginId) {\n      vehicleNumber\n      entityId\n      deviceDetail {\n        uniqueDeviceId\n      }\n    }\n  }\n'],['\n  query getAllVehicleDetails($clientLoginId: Int) {\n    getAllVehicleDetails(clientLoginId: $clientLoginId) {\n      vehicleNumber\n      entityId\n      deviceDetail {\n        uniqueDeviceId\n      }\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query getNoOfDaysOfAllDevices(\n    $deviceUniqueId: [String!]!\n    $clientLoginId: Int!\n    $year: Int!\n    $month: Int!\n  ) {\n    getNoOfDaysOfAllDevices(\n      deviceUniqueId: $deviceUniqueId\n      clientLoginId: $clientLoginId\n      year: $year\n      month: $month\n    ) {\n      deviceUniqueId\n      clientLoginId\n      noOfDays\n      vehicleNumber\n    }\n  }\n'],['\n  query getNoOfDaysOfAllDevices(\n    $deviceUniqueId: [String!]!\n    $clientLoginId: Int!\n    $year: Int!\n    $month: Int!\n  ) {\n    getNoOfDaysOfAllDevices(\n      deviceUniqueId: $deviceUniqueId\n      clientLoginId: $clientLoginId\n      year: $year\n      month: $month\n    ) {\n      deviceUniqueId\n      clientLoginId\n      noOfDays\n      vehicleNumber\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_CLIENTS=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject);var GET_ALL_VEHICLES=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject2);var GET_NO_OF_BILLING_DAYS=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject3);var style=function style(theme){return{root:{padding:theme.spacing.unit*4,flexGrow:1},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},iconSmall:{fontSize:20},selstyle:{maxHeight:ITEM_HEIGHT*4.5+ITEM_PADDING_TOP,width:250}};};var ITEM_HEIGHT=48;var ITEM_PADDING_TOP=8;var MenuProps={PaperProps:{style:{// maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
width:250}}};var BillingDays=function(_Component){_inherits(BillingDays,_Component);function BillingDays(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,BillingDays);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BillingDays.__proto__||Object.getPrototypeOf(BillingDays)).call.apply(_ref,[this].concat(args))),_this),_this.state={spacing:'16',smsSalesReportFrom:{date:__WEBPACK_IMPORTED_MODULE_10_moment___default()(),unix:__WEBPACK_IMPORTED_MODULE_10_moment___default()().unix().toString()},smsSalesReportTo:{date:__WEBPACK_IMPORTED_MODULE_10_moment___default()(),unix:__WEBPACK_IMPORTED_MODULE_10_moment___default()().unix().toString()},name:[],fullData:[],clientNameInfo:[],clientName:'',clientLoginId:[],clientNameLoginId:[],reportView:false,vehicleNumber:[],clientID:'',vehicleDetails:[],year:'',month:''},_this.columns=['VEHICLE NUMBER','NUMBER OF DAYS BILLED'],_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15,filter:false},_this.handleChangeMonth=function(event){return _this.setState({month:event.target.value});},_this.handleChangeYear=function(event){return _this.setState({year:event.target.value});},_this.viewBillingDays=function(val){return _asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _ref3,data,rowDataLast;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.client.query({query:GET_NO_OF_BILLING_DAYS,variables:{deviceUniqueId:_this.state.vehicleNumber,clientLoginId:parseInt(_this.state.clientID,10),year:parseInt(_this.state.year,10),month:parseInt(_this.state.month,10)}});case 2:_ref3=_context.sent;data=_ref3.data;console.log('dRr',data);rowDataLast=[];data.getNoOfDaysOfAllDevices.forEach(function(element){var rowData=[];rowData.push(element.vehicleNumber);rowData.push(element.noOfDays);rowDataLast.push(rowData);});_this.setState({fullData:rowDataLast,reportView:true});case 8:case'end':return _context.stop();}}},_callee,_this2);}));},_this.getFormattedDate=function(timestamp){return __WEBPACK_IMPORTED_MODULE_10_moment___default()(timestamp*1000).format('MMM Do YYYY, h:mm a');},_this.getAllCustomers=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var customers;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this.props.client.query({query:GET_CLIENTS,variables:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_8__utils_getLoginId__["a" /* default */])()}});case 2:customers=_context2.sent;if(customers&&customers.data){console.log('customers.data',customers.data);_this.setState({clientNameLoginId:customers.data.clients});}case 4:case'end':return _context2.stop();}}},_callee2,_this2);})),_this.handleChange=function(event){console.log('event',event.target.value);_this.setState({clientName:event.target.value,clientID:event.target.value,vehicleNumber:[]},function(){return _this.getAllVehicleInfo();});},_this.handleChangeVlpn=function(event){_this.setState({vehicleNumber:event.target.value},function(){return console.log('arr=',_this.state.vehicleNumber);});},_this.getAllVehicleInfo=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var vehicles;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return _this.props.client.query({query:GET_ALL_VEHICLES,variables:{clientLoginId:parseInt(_this.state.clientID,10)}});case 2:vehicles=_context3.sent;if(vehicles&&vehicles.data){// console.log('customers.data', vehicles.data)
_this.setState({vehicleDetails:vehicles.data.getAllVehicleDetails});}case 4:case'end':return _context3.stop();}}},_callee3,_this2);})),_this.yearArr=[2016,2017,2018,2019],_this.monthArr=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BillingDays,[{key:'componentDidMount',value:function componentDidMount(){this.getAllCustomers();}},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;var spacing=this.state.spacing;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{variant:'outlined',color:'secondary',className:classes.button,onClick:function onClick(){return _this3.props.history.goBack();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_icons_ArrowBack___default.a,{className:classes.iconSmall})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'No Of Billing Days'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row',justify:'center',alignItems:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,justify:'center',spacing:Number(spacing)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_NativeSelect___default.a,{value:this.state.clientName,onChange:this.handleChange,input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["Input"],{name:'clientID',id:'clientID-native-label-placeholder'}),className:classes.selstyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{value:''},'Select Client'),this.state.clientNameLoginId.map(function(client){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{value:client.loginId},client.clientName);}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Select___default.a,{multiple:true,value:this.state.vehicleNumber,onChange:this.handleChangeVlpn,input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["Input"],{id:'select-multiple'}),MenuProps:MenuProps,className:classes.selstyle},this.state.vehicleDetails.map(function(vehicle){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_MenuItem___default.a,{key:vehicle.entityId,value:vehicle.deviceDetail.uniqueDeviceId},vehicle.vehicleNumber);}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_NativeSelect___default.a,{value:this.state.year,onChange:this.handleChangeYear,input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["Input"],{name:'clientID',id:'clientID-native-label-placeholder'}),className:classes.selstyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{value:''},'Select Year'),this.yearArr.map(function(year){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{value:year},year);}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_NativeSelect___default.a,{value:this.state.month,onChange:this.handleChangeMonth,input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["Input"],{name:'clientID',id:'clientID-native-label-placeholder'}),className:classes.selstyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{value:''},'Select Month'),this.monthArr.map(function(item,key){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{value:parseInt(key,10)+1},item);}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{color:'secondary',variant:'contained',className:classes.button,onClick:this.viewBillingDays('hai'),disabled:this.state.vehicleNumber.length===0||this.state.smsSalesReportTo.date===''||this.state.smsSalesReportFrom.date===''},'View')))),this.state.reportView&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_mui_datatables___default.a,{data:this.state.fullData,columns:this.columns,options:this.options}))));}}]);return BillingDays;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["withApollo"])(BillingDays)));

/***/ }),
/* 2370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_icons_ArrowBack__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_icons_ArrowBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_ArrowBack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_NativeSelect__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_NativeSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_NativeSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__MakePayment_PaymentMethod_jsx__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__HOCs_withSharedSnackbar__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query allClientDetails($partnerLoginId: Int) {\n    clients: allClientDetails(partnerLoginId: $partnerLoginId) {\n      id\n      clientName\n      loginId\n    }\n  }\n'],['\n  query allClientDetails($partnerLoginId: Int) {\n    clients: allClientDetails(partnerLoginId: $partnerLoginId) {\n      id\n      clientName\n      loginId\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  mutation addUpdateClientCredits(\n    $clientLoginId: Int!\n    $updatedCredit: Int!\n    $paidMoney: Int!\n    $paymentMode: String!\n    $bankName: String\n    $referenceNumber: Int\n  ) {\n    addUpdateClientCredits(\n      clientLoginId: $clientLoginId\n      updatedCredit: $updatedCredit\n      paidMoney: $paidMoney\n      paymentMode: $paymentMode\n      bankName: $bankName\n      referenceNumber: $referenceNumber\n    )\n  }\n'],['\n  mutation addUpdateClientCredits(\n    $clientLoginId: Int!\n    $updatedCredit: Int!\n    $paidMoney: Int!\n    $paymentMode: String!\n    $bankName: String\n    $referenceNumber: Int\n  ) {\n    addUpdateClientCredits(\n      clientLoginId: $clientLoginId\n      updatedCredit: $updatedCredit\n      paidMoney: $paidMoney\n      paymentMode: $paymentMode\n      bankName: $bankName\n      referenceNumber: $referenceNumber\n    )\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query getClientCredit($clientLoginId: Int!) {\n    getClientCredit(clientLoginId: $clientLoginId) {\n      credit\n    }\n  }\n'],['\n  query getClientCredit($clientLoginId: Int!) {\n    getClientCredit(clientLoginId: $clientLoginId) {\n      credit\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_CLIENTS=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject);var ADD_UPDATE_CREDIT=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject2);var GET_CLIENT_CREDIT=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject3);var style=function style(theme){return{root:{padding:theme.spacing.unit*4,flexGrow:1},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},iconSmall:{fontSize:20},selstyle:{maxHeight:ITEM_HEIGHT*4.5+ITEM_PADDING_TOP,width:250},selectStyle:{maxHeight:ITEM_HEIGHT*4.5+ITEM_PADDING_TOP,width:250}};};var ITEM_HEIGHT=48;var ITEM_PADDING_TOP=8;var paymentOption=['CASH','ONLINE','CHEQUE','DD'];var MakeAdvanceAmount=function(_Component){_inherits(MakeAdvanceAmount,_Component);function MakeAdvanceAmount(props){var _this2=this;_classCallCheck(this,MakeAdvanceAmount);var _this=_possibleConstructorReturn(this,(MakeAdvanceAmount.__proto__||Object.getPrototypeOf(MakeAdvanceAmount)).call(this,props));_this.state={spacing:'16',name:[],fullData:[],clientNameInfo:[],clientName:'',clientLoginId:[],clientNameLoginId:[],reportView:false,vehicleNumber:[],clientID:'',vehicleDetails:[],paymentType:'',piInfo:'',paymentStatus:'',referenceNumber:'',bankName:'',paidMoney:'',clientCredit:0,validation:false};_this.columns=['VEHICLE NUMBER','NUMBER OF DAYS BILLED'];_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15,filter:false};_this.handleChangeMonth=function(event){console.log('handleChangeMonth',event.target.value);_this.setState({month:event.target.value});};_this.handleChangeYear=function(event){console.log('handleChangeYear',event.target.value);_this.setState({year:event.target.value});};_this.getFormattedDate=function(timestamp){return __WEBPACK_IMPORTED_MODULE_9_moment___default()(timestamp*1000).format('MMM Do YYYY, h:mm a');};_this.getAllCustomers=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var customers;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.client.query({query:GET_CLIENTS,variables:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_7__utils_getLoginId__["a" /* default */])()}});case 2:customers=_context.sent;if(customers&&customers.data){console.log('customers.data',customers.data);_this.setState({clientNameLoginId:customers.data.clients});}case 4:case'end':return _context.stop();}}},_callee,_this2);}));_this.handleChange=function(event){console.log('event',event.target.value);_this.setState({clientName:event.target.value,clientID:event.target.value,vehicleNumber:[]},function(){return _this.getClientCredit();});};_this.getClientCredit=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var credits;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this.props.client.query({query:GET_CLIENT_CREDIT,variables:{clientLoginId:parseInt(_this.state.clientID,10)}});case 2:credits=_context2.sent;if(credits&&credits.data){console.log('credits.data',credits.data.getClientCredit);_this.setState({clientCredit:credits.data.getClientCredit.credit});}case 4:case'end':return _context2.stop();}}},_callee2,_this2);}));_this.handleChangePayment=function(event){_this.setState({paymentType:event.target.value});};_this.handleChangereferenceNumber=function(event){_this.setState({referenceNumber:event.target.value},function(){return _this.validateFields();});};_this.handleChangePaidMoney=function(event){_this.setState({paidMoney:event.target.value},function(){return _this.validateFields();});};_this.handleChangeBankName=function(event){_this.setState({bankName:event.target.value},function(){return _this.validateFields();});};_this.handleSubmit=function(client,pType){return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(event){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:event.preventDefault();_context3.next=3;return client.mutate({mutation:ADD_UPDATE_CREDIT,variables:{clientLoginId:parseInt(_this.state.clientID,10),updatedCredit:parseInt(_this.state.clientCredit,10)+parseInt(_this.state.paidMoney,10),paidMoney:parseInt(_this.state.paidMoney,10),paymentMode:_this.state.paymentType,bankName:_this.state.bankName,referenceNumber:parseInt(_this.state.referenceNumber,10)},errorPolicy:'all'});case 3:// this.state.simprovider = ''
_this.setState({paymentMode:'',bankName:'',referenceNumber:''});_this.props.openSnackbar('Updated Successfuly...');// this.props.history.push({
//   pathname: '/home/manage/makeAdvanceAmount'
// })
case 5:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x){return _ref3.apply(this,arguments);};}();};_this.validateFields=function(){console.log('this.state.paymentTypeff',_this.state.paymentType);if(_this.state.paymentType==='ONLINE'){if(_this.state.referenceNumber===''){_this.props.openSnackbar('Reference Number Should not blank');_this.setState({validation:false});}else{_this.setState({validation:true});}}else if(_this.state.paymentType==='DD'||_this.state.paymentType==='CHEQUE'){if(_this.state.referenceNumber===''){_this.props.openSnackbar('Reference Number Should not blank!');_this.setState({validation:false});}else if(_this.state.bankName===''){_this.props.openSnackbar('Bank Name Should not blank!');_this.setState({validation:false});}else{_this.setState({validation:true});}}else{_this.setState({validation:true});}};_this.cancelRaise=function(loginId){_this.props.history.push({pathname:'/home/manage/admin/InvoiceDetails'});};_this.class=props;return _this;}_createClass(MakeAdvanceAmount,[{key:'componentDidMount',value:function componentDidMount(){this.getAllCustomers();}},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;var spacing=this.state.spacing;console.log('referenceNumber',this.state.referenceNumber,'paidMoney',this.state.paidMoney,'bankName',this.state.bankName);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default.a,{variant:'outlined',color:'secondary',className:classes.button,onClick:function onClick(){return _this3.props.history.goBack();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_ArrowBack___default.a,{className:classes.iconSmall})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'Enter Advance Amount'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row',justify:'center',alignItems:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true,justify:'center',spacing:Number(spacing)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_NativeSelect___default.a,{value:this.state.clientName,onChange:this.handleChange,input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Input"],{name:'clientID',id:'clientID-native-label-placeholder'}),className:classes.selstyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{value:''},'Select Client'),this.state.clientNameLoginId.map(function(client){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{value:client.loginId},client.clientName);})),' ','Credit Amount:',' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_TextField___default.a,{id:'outlined-uncontrolled'// label="Credit Amount"
,className:classes.textField,margin:'normal',variant:'outlined',value:this.state.clientCredit+' Rs',disabled:true}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row',justify:'flex-start',alignItems:'flex-start'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_FormControl___default.a,{className:classes.formControl},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_InputLabel___default.a,{htmlFor:'age-helper'},'Payment Type'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Select___default.a,{value:this.state.paymentType,onChange:this.handleChangePayment,input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Input"],{name:'paymentType',id:'paymentType-helper'}),className:classes.selectStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_MenuItem___default.a,{value:'CASH'},'Cash'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_MenuItem___default.a,{value:'ONLINE'},'Online'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_MenuItem___default.a,{value:'CHEQUE'},'Cheque'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_MenuItem___default.a,{value:'DD'},'DD'))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true,spacing:16},paymentOption.includes(this.state.paymentType)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__MakePayment_PaymentMethod_jsx__["a" /* default */],{paymentThrough:this.state.paymentType,handleChangereferenceNumber:this.handleChangereferenceNumber,handleChangeBankName:this.handleChangeBankName,handleChangePaidMoney:this.handleChangePaidMoney,paidMoney:this.state.paidMoney,referenceNumber:this.state.referenceNumber,bankName:this.state.bankName})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row',justify:'center',alignItems:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:0},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default.a,{variant:'contained',color:'primary',className:classes.button,onClick:this.cancelRaise},'Cancel')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:0},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default.a,{variant:'contained',color:'primary',type:'submit',className:classes.button,onClick:this.handleSubmit(this.props.client),disabled:this.state.validation===false},'Add Amount')))))))));}}]);return MakeAdvanceAmount;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_18__HOCs_withSharedSnackbar__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["withApollo"])(MakeAdvanceAmount))));

/***/ }),
/* 2371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_ArrowBack__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_ArrowBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_ArrowBack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_NativeSelect__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_NativeSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_NativeSelect__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query allClientDetails($partnerLoginId: Int) {\n    clients: allClientDetails(partnerLoginId: $partnerLoginId) {\n      id\n      clientName\n      loginId\n    }\n  }\n'],['\n  query allClientDetails($partnerLoginId: Int) {\n    clients: allClientDetails(partnerLoginId: $partnerLoginId) {\n      id\n      clientName\n      loginId\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query getAllBillingHistory($clientLoginId: Int!, $year: Int!) {\n    getAllBillingHistory(clientLoginId: $clientLoginId, year: $year) {\n      clientName\n      discount\n      GST\n      creditAmount\n      invoiceAmount\n      paidAmount\n      billGenerated\n      billpaidDate\n      paidDate\n      noOfDevices\n      noOfsubscrription\n    }\n  }\n'],['\n  query getAllBillingHistory($clientLoginId: Int!, $year: Int!) {\n    getAllBillingHistory(clientLoginId: $clientLoginId, year: $year) {\n      clientName\n      discount\n      GST\n      creditAmount\n      invoiceAmount\n      paidAmount\n      billGenerated\n      billpaidDate\n      paidDate\n      noOfDevices\n      noOfsubscrription\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_CLIENTS=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject);var GET_BILLING_HISTORY=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject2);var style=function style(theme){return{root:{padding:theme.spacing.unit*4,flexGrow:1},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},iconSmall:{fontSize:20},selstyle:{maxHeight:ITEM_HEIGHT*4.5+ITEM_PADDING_TOP,width:250}};};var ITEM_HEIGHT=48;var ITEM_PADDING_TOP=8;var BillingHistoryReport=function(_Component){_inherits(BillingHistoryReport,_Component);function BillingHistoryReport(props){var _this2=this;_classCallCheck(this,BillingHistoryReport);var _this=_possibleConstructorReturn(this,(BillingHistoryReport.__proto__||Object.getPrototypeOf(BillingHistoryReport)).call(this,props));_this.state={spacing:'16',name:[],fullData:[],clientNameInfo:[],clientName:'',clientLoginId:[],clientNameLoginId:[],reportView:false,vehicleNumber:[],clientID:'',vehicleDetails:[],year:'',month:''};_this.columns=['CLIENT NAME','DISCOUNT','GST','CREDIT AMOUNT','BILLING AMT','PAID AMOUNT','BILLED_DATE','BILL_PAID_DATE','PAYMENT_ENTRY_DATE','NO OF DEVICES','NO OF SUBSCRIPTIONS'];_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15,filter:false};_this.handleChangeMonth=function(event){console.log('handleChangeMonth',event.target.value);_this.setState({month:event.target.value});};_this.handleChangeYear=function(event){console.log('handleChangeYear',event.target.value);_this.setState({year:event.target.value});};_this.viewBillingHistory=function(val){return _asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _ref2,data,rowDataLast;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.client.query({query:GET_BILLING_HISTORY,variables:{clientLoginId:parseInt(_this.state.clientID,10),year:parseInt(_this.state.year,10)}});case 2:_ref2=_context.sent;data=_ref2.data;console.log('dRr',data);rowDataLast=[];data.getAllBillingHistory.forEach(function(element){var rowData=[];rowData.push(element.clientName);rowData.push(element.discount);rowData.push(element.GST);rowData.push(element.creditAmount);rowData.push(element.invoiceAmount);rowData.push(element.paidAmount);rowData.push(_this.getFormattedDate(element.billGenerated));rowData.push(_this.getFormattedDate(element.billpaidDate));rowData.push(_this.getFormattedDate(element.paidDate));rowData.push(element.noOfDevices);rowData.push(element.noOfsubscrription);rowDataLast.push(rowData);});_this.setState({fullData:rowDataLast,reportView:true});case 8:case'end':return _context.stop();}}},_callee,_this2);}));};_this.getFormattedDate=function(timestamp){return __WEBPACK_IMPORTED_MODULE_10_moment___default()(timestamp*1000).format('MMM Do YYYY, h:mm a');};_this.getAllCustomers=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var customers;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this.props.client.query({query:GET_CLIENTS,variables:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_8__utils_getLoginId__["a" /* default */])()}});case 2:customers=_context2.sent;if(customers&&customers.data){console.log('customers.data',customers.data);_this.setState({clientNameLoginId:customers.data.clients});}case 4:case'end':return _context2.stop();}}},_callee2,_this2);}));_this.handleChange=function(event){console.log('event',event.target.value);_this.setState({clientName:event.target.value,clientID:event.target.value,vehicleNumber:[]});};_this.yearArr=[2016,2017,2018,2019];_this.class=props;return _this;}_createClass(BillingHistoryReport,[{key:'componentDidMount',value:function componentDidMount(){this.getAllCustomers();}},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;var spacing=this.state.spacing;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{variant:'outlined',color:'secondary',className:classes.button,onClick:function onClick(){return _this3.props.history.goBack();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_ArrowBack___default.a,{className:classes.iconSmall})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'Billing History Report'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row',justify:'center',alignItems:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,justify:'center',spacing:Number(spacing)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_NativeSelect___default.a,{value:this.state.clientName,onChange:this.handleChange,input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["Input"],{name:'clientID',id:'clientID-native-label-placeholder'}),className:classes.selstyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{value:''},'Select Client'),this.state.clientNameLoginId.map(function(client){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{value:client.loginId},client.clientName);}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_NativeSelect___default.a,{value:this.state.year,onChange:this.handleChangeYear,input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["Input"],{name:'clientID',id:'clientID-native-label-placeholder'}),className:classes.selstyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{value:''},'Select Year'),this.yearArr.map(function(year){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{value:year},year);}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{color:'secondary',variant:'contained',className:classes.button,onClick:this.viewBillingHistory('hai'),disabled:this.state.clientName.length===0||this.state.year.length===0},'View')))),this.state.reportView&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_mui_datatables___default.a,{data:this.state.fullData,columns:this.columns,options:this.options})))));}}]);return BillingHistoryReport;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["withApollo"])(BillingHistoryReport)));

/***/ }),
/* 2372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Paper__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Paper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Card__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_icons_Mail__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_icons_Mail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_icons_Mail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_icons_ContactPhone__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_icons_ContactPhone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_icons_ContactPhone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_icons_Person__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_icons_Person___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_icons_Person__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_icons_LocationOn__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_icons_LocationOn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__material_ui_icons_LocationOn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_icons_LocationCity__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_icons_LocationCity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__material_ui_icons_LocationCity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_icons_Business__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_icons_Business___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__material_ui_icons_Business__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_icons_ArrowBack__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_icons_ArrowBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__material_ui_icons_ArrowBack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Subscriptions__ = __webpack_require__(2373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Router__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__SubscriptionForm__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_fetchClientPublicIp__ = __webpack_require__(166);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query partnerDetail($loginId: Int) {\n    partnerDetail(loginId: $loginId) {\n      id\n      businessName\n      contactPerson\n      address\n      city\n      state {\n        name\n      }\n      country {\n        name\n      }\n      email\n      contactNumber\n      login {\n        loginId\n      }\n      deviceCount {\n        totalDevices\n        inStockDevices\n        assignedToClientDevices\n        registeredDevices\n      }\n      simCount {\n        totalSims\n        inStockSims\n        assignedToClientSims\n        registeredSims\n      }\n    }\n  }\n'],['\n  query partnerDetail($loginId: Int) {\n    partnerDetail(loginId: $loginId) {\n      id\n      businessName\n      contactPerson\n      address\n      city\n      state {\n        name\n      }\n      country {\n        name\n      }\n      email\n      contactNumber\n      login {\n        loginId\n      }\n      deviceCount {\n        totalDevices\n        inStockDevices\n        assignedToClientDevices\n        registeredDevices\n      }\n      simCount {\n        totalSims\n        inStockSims\n        assignedToClientSims\n        registeredSims\n      }\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query getClientLoginToken(\n    $clientid: Int!\n    $clientIp: String\n    $source: String\n    $performedByLoginId: Int\n    $performedByUsername: String\n  ) {\n    getClientLoginToken(\n      id: $clientid\n      clientIp: $clientIp\n      source: $source\n      performedByLoginId: $performedByLoginId\n      performedByUsername: $performedByUsername\n    ) {\n      token\n    }\n  }\n'],['\n  query getClientLoginToken(\n    $clientid: Int!\n    $clientIp: String\n    $source: String\n    $performedByLoginId: Int\n    $performedByUsername: String\n  ) {\n    getClientLoginToken(\n      id: $clientid\n      clientIp: $clientIp\n      source: $source\n      performedByLoginId: $performedByLoginId\n      performedByUsername: $performedByUsername\n    ) {\n      token\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query getPartnerDomainConfig($loginId: Int!) {\n    getPartnerDomainConfig(loginId: $loginId)\n  }\n'],['\n  query getPartnerDomainConfig($loginId: Int!) {\n    getPartnerDomainConfig(loginId: $loginId)\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_PARTNER=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject);var GET_LOGIN_TOKEN=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject2);var GET_PARTNER_DOMAIN=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject3);var styles=function styles(theme){return{gridItem:{padding:theme.spacing.unit*2},containerPadding:{padding:theme.spacing.unit},gridItemHorizontal:{paddingLeft:theme.spacing.unit*2,paddingRight:theme.spacing.unit*2,'&:first-child':{paddingLeft:0},'&:last-child':{paddingRight:0}},gridItemVertical:{paddingTop:theme.spacing.unit,paddingBottom:theme.spacing.unit,'&:first-child':{paddingTop:0},'&:last-child':{paddingBottom:0}},cardItemIcon:{margin:theme.spacing.unit},paper:{padding:theme.spacing.unit*1,textAlign:'center',color:theme.palette.text.secondary},button:{margin:theme.spacing.unit},input:{display:'none'},alignCenter:{display:'flex',alignItems:'center'},valueNumber:{color:'red',fontSize:'1.2rem'}};};var PartnerView=function(_Component){_inherits(PartnerView,_Component);function PartnerView(props){var _this2=this;_classCallCheck(this,PartnerView);var _this=_possibleConstructorReturn(this,(PartnerView.__proto__||Object.getPrototypeOf(PartnerView)).call(this,props));_this.editCustomer=function(loginId){return function(e){console.log('edit');_this.props.history.push({pathname:'/home/partner/edit/'+_this.loginId});};};_this.handleRegistration=function(e){_this.props.history.push({pathname:'/home/VehicleRegistration'});};_this.showSubscription=function(subscriptionId){return function(e){_this.props.history.push({pathname:'/home/subscriptions/view/'+_this.loginId+'/'+subscriptionId});};};_this.allCustomer=function(e){_this.props.history.push({pathname:e,state:{from:_this.props.location.pathname}});};_this.createNewSubscription=function(e){_this.props.history.push({pathname:'/home/subscriptions/new/'+_this.loginId});};_this.loginCustomer=function(clientId){return _asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var clientIp,_ref2,data,_ref3,domain,clienturl,win;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_24__utils_fetchClientPublicIp__["a" /* default */])();case 2:clientIp=_context.sent;_context.next=5;return _this.props.client.query({query:GET_LOGIN_TOKEN,variables:{clientid:clientId,clientIp:clientIp,source:'admin-frontend',performedByLoginId:Object(__WEBPACK_IMPORTED_MODULE_23__utils_getLoginId__["a" /* default */])(),performedByUsername:localStorage.getItem('username')}});case 5:_ref2=_context.sent;data=_ref2.data;if(!data){_context.next=15;break;}_context.next=10;return _this.props.client.query({query:GET_PARTNER_DOMAIN,variables:{loginId:clientId}});case 10:_ref3=_context.sent;domain=_ref3.data;clienturl='https://preview-devba.aquilatrack.com/?token='+data.getClientLoginToken.token;win=window.open(clienturl,'_blank');win.focus();case 15:case'end':return _context.stop();}}},_callee,_this2);}));};_this.loginId=parseInt(_this.props.match.params.loginId,10);return _this;}_createClass(PartnerView,[{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["Query"],{query:GET_PARTNER,variables:{loginId:this.loginId},fetchPolicy:'network-only'},function(_ref4){var loading=_ref4.loading,error=_ref4.error,data=_ref4.data;if(loading)return'Loading...';if(error)return'Error!: '+error;// console.log(' partner detail', data)
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,data&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{container:true,justify:'space-between'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,className:classes.gridItemHorizontal},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button___default.a,{variant:'outlined',color:'secondary',className:classes.button,onClick:function onClick(){return _this3.props.history.goBack();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_icons_ArrowBack___default.a,{className:classes.iconSmall}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,className:classes.gridItemHorizontal},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button___default.a,{color:'secondary',variant:'raised',className:classes.button,onClick:_this3.handleRegistration},'Assign Devices'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button___default.a,{variant:'outlined',color:'primary',className:classes.button// onClick={() =>
//   this.editCustomer(data.partnerDetail.login.loginId)
// }
,onClick:_this3.editCustomer(data.partnerDetail.login.loginId)},'Edit'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Button___default.a,{variant:'outlined',color:'primary',className:classes.button,onClick:_this3.loginCustomer(data.partnerDetail.login.loginId)},'Login Preview')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{container:true,className:classes.containerPadding},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:8,className:classes.gridItemHorizontal},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Card___default.a,{className:classes.card},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["CardContent"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{container:true,alignItems:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,className:classes.alignCenter},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_icons_Business___default.a,{color:'primary',className:classes.cardItemIcon})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'headline',color:'primary'},data.partnerDetail.businessName)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{container:true,alignItems:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,className:classes.alignCenter},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_icons_Person___default.a,{color:'primary',className:classes.cardItemIcon})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{color:'primary'},data.partnerDetail.contactPerson)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{container:true,alignItems:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,className:classes.alignCenter},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_icons_LocationOn___default.a,{color:'primary',className:classes.cardItemIcon})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{color:'primary'},data.partnerDetail.address)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{container:true,alignItems:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,className:classes.alignCenter},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_icons_LocationCity___default.a,{color:'primary',className:classes.cardItemIcon})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{color:'primary'},data.partnerDetail.city+' '+data.partnerDetail.state.name+' '+data.partnerDetail.country.name)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{container:true,alignItems:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,className:classes.alignCenter},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_icons_Mail___default.a,{color:'primary',className:classes.cardItemIcon})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{color:'primary'},data.partnerDetail.email)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{container:true,alignItems:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,className:classes.alignCenter},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_icons_ContactPhone___default.a,{color:'primary',className:classes.cardItemIcon})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{color:'primary'},data.partnerDetail.contactNumber)))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:2,className:classes.gridItemHorizontal},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,className:classes.gridItemVertical},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Paper___default.a,{className:classes.paper},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:classes.valueNumber},data.partnerDetail.deviceCount.totalDevices),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Total Devices'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,className:classes.gridItemVertical},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Paper___default.a,{className:classes.paper},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:classes.valueNumber},data.partnerDetail.deviceCount.assignedToClientDevices),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Assigned Devices ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,className:classes.gridItemVertical},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Paper___default.a,{className:classes.paper},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:classes.valueNumber},data.partnerDetail.deviceCount.registeredDevices),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Registered Devices'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,className:classes.gridItemVertical},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Paper___default.a,{className:classes.paper},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:classes.valueNumber},data.partnerDetail.deviceCount.inStockDevices),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Unregistered Devices'))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,md:2,className:classes.gridItemHorizontal,style:{paddingRight:'15px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,className:classes.gridItemVertical},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Paper___default.a,{className:classes.paper},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:classes.valueNumber},data.partnerDetail.simCount.totalSims),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Total Sims'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,className:classes.gridItemVertical},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Paper___default.a,{className:classes.paper},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:classes.valueNumber},data.partnerDetail.simCount.assignedToClientSims),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Assigned Sims ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,className:classes.gridItemVertical},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Paper___default.a,{className:classes.paper},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:classes.valueNumber},data.partnerDetail.simCount.registeredSims),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Registered Sims'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,className:classes.gridItemVertical},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Paper___default.a,{className:classes.paper},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:classes.valueNumber},data.partnerDetail.simCount.inStockSims),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Unregistered Sims')))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{container:true,className:classes.containerPadding},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12,className:classes.gridItemVertical},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__Subscriptions__["a" /* default */],{partnerLoginId:parseInt(_this3.props.match.params.loginId,10)}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{container:true,className:classes.containerPadding})))))));});}}]);return PartnerView;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);PartnerView.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired};var WrappedPartnerView=Object(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__["withStyles"])(styles)(PartnerView));/* harmony default export */ __webpack_exports__["a"] = (function(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["e" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Router__["a" /* PrivateRoute */],{exact:true,path:'/home/partner/view/:loginId/edit-subscription',render:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__SubscriptionForm__["a" /* default */],props);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Router__["a" /* PrivateRoute */],{path:'/home/partner/view/:loginId',render:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedPartnerView,props);}}));});

/***/ }),
/* 2373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_Loader__ = __webpack_require__(47);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getAllPartnerSubscriptions($partnerLoginId: Int) {\n    getAllPartnerSubscriptions(partnerLoginId: $partnerLoginId) {\n      id\n      partnerLoginId\n      status\n      gst\n      amount\n      totalDeviceQty\n      unassignedDeviceQuantity\n      billingFrequencyId\n      hardwareCharges\n      totalSoftwareQty\n      unbilledSoftware\n      totalSoftwareQty\n      unbilledSoftware\n      noOfDevices\n      deviceTrackingCharges\n      simQty\n      unbilledSims\n      unassignedSimQty\n      unassignedSimQty\n      simCharges\n      accessoryQty\n      unbilledAccessory\n      unassignedAccessoryQty\n      unbilledDeviceQty\n      nextPaymentDate\n      accessoryCharges\n      unassignedAccessoryQty\n      partnerDetail {\n        id\n        businessName\n      }\n      billingMode {\n        id\n        billingMode\n      }\n      billingFrequency {\n        id\n        frequency\n        numberOfMonths\n      }\n      deviceModel {\n        model_name\n      }\n      serviceProvider{\n        name\n      }\n    }\n  }\n'],['\n  query getAllPartnerSubscriptions($partnerLoginId: Int) {\n    getAllPartnerSubscriptions(partnerLoginId: $partnerLoginId) {\n      id\n      partnerLoginId\n      status\n      gst\n      amount\n      totalDeviceQty\n      unassignedDeviceQuantity\n      billingFrequencyId\n      hardwareCharges\n      totalSoftwareQty\n      unbilledSoftware\n      totalSoftwareQty\n      unbilledSoftware\n      noOfDevices\n      deviceTrackingCharges\n      simQty\n      unbilledSims\n      unassignedSimQty\n      unassignedSimQty\n      simCharges\n      accessoryQty\n      unbilledAccessory\n      unassignedAccessoryQty\n      unbilledDeviceQty\n      nextPaymentDate\n      accessoryCharges\n      unassignedAccessoryQty\n      partnerDetail {\n        id\n        businessName\n      }\n      billingMode {\n        id\n        billingMode\n      }\n      billingFrequency {\n        id\n        frequency\n        numberOfMonths\n      }\n      deviceModel {\n        model_name\n      }\n      serviceProvider{\n        name\n      }\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// import moment from 'moment'
var GET_ALL_PARTNER_SUBSCRIPTION=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject);var styles={tableRow:{cursor:'pointer','&:hover':{background:'rgb(245, 245, 245)'}}// class SubscriptionsTable extends Component {
//   state = {
//     page: 0,
//     rowsPerPage: 5
//   }
//   handleChangePage = (event, newPage) => {
//     this.setState({ page: newPage })
//   }
//   handleChangeRowsPerPage = event => {
//     this.setState({ rowsPerPage: +event.target.value })
//   }
//   handleEdit = subscription => {
//     this.props.history.push(
//       this.props.location.pathname + '/edit-subscription',
//       {
//         edit: true,
//         subscriptionDetails: {
//           id: subscription.subscriptionId,
//           selectedBillingMode: subscription.billingMode.id,
//           selectedBillingFrequency: subscription.billingFrequency.id,
//           deviceQuantity: subscription.noOfDevices,
//           deviceRate: subscription.mmtc,
//           gst: subscription.gst
//         }
//       }
//     )
//   }
//   render() {
//     const { rows, classes } = this.props
//     const { page, rowsPerPage } = this.state
//     return (
//       <Fragment>
//         <Table>
//           <TableHead>
//             <TableRow>
//               <TableCell>Billing Mode</TableCell>
//               <TableCell>Billing Frequency</TableCell>
//               <TableCell>Device Quantity</TableCell>
//               <TableCell>MMTC</TableCell>
//               <TableCell>GST</TableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {rows
//               .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
//               .map(subscription => (
//                 <TableRow
//                   key={subscription.subscriptionId}
//                   onClick={() => this.handleEdit(subscription)}
//                   className={classes.tableRow}
//                 >
//                   <TableCell>{subscription.billingMode.billingMode}</TableCell>
//                   <TableCell>
//                     {subscription.billingFrequency.frequency}
//                   </TableCell>
//                   <TableCell>{subscription.noOfDevices}</TableCell>
//                   <TableCell>{subscription.mmtc}</TableCell>
//                   <TableCell>{subscription.gst}</TableCell>
//                   {/* <TableCell>
//                     {moment
//                       .unix(subscription.nextPaymentDate)
//                       .format('MMM Do YYYY')}
//                   </TableCell> */}
//                 </TableRow>
//               ))}
//           </TableBody>
//         </Table>
//         <TablePagination
//           rowsPerPageOptions={[5, 10, 25]}
//           component="div"
//           count={rows.length}
//           rowsPerPage={rowsPerPage}
//           page={page}
//           backIconButtonProps={{
//             'aria-label': 'Previous Page'
//           }}
//           nextIconButtonProps={{
//             'aria-label': 'Next Page'
//           }}
//           onChangePage={this.handleChangePage}
//           onChangeRowsPerPage={this.handleChangeRowsPerPage}
//         />
//       </Fragment>
//     )
//   }
// }
// const WrappedSubscriptionsTable = withStyles(styles)(SubscriptionsTable)
// const SubscriptionsQuery = props => {
//   return (
//     <Query
//       query={GET_SUBSCRIPTIONS}
//       variables={{
//         partnerLoginId: props.partnerLoginId
//       }}
//       fetchPolicy="cache-and-network"
//     >
//       {({ loading, error, data }) => {
//         if (loading) return <Loader />
//         if (error) return 'Error'
//         const rows = data.subscriptions
//         return (
//           <WrappedSubscriptionsTable
//             rows={rows}
//             location={props.location}
//             history={props.history}
//           />
//         )
//       }}
//     </Query>
//   )
// }
};var Subscriptions=function(_Component){_inherits(Subscriptions,_Component);function Subscriptions(props){var _this2=this;_classCallCheck(this,Subscriptions);var _this=_possibleConstructorReturn(this,(Subscriptions.__proto__||Object.getPrototypeOf(Subscriptions)).call(this,props));_this.subscriptionIdArray=[];_this.columns=['MODEL','SERVICE PROVIDER','DEVICE COUNT','BILLING MODE','BILLING FREQUENCY','MMTC','STATUS'];_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15,onRowClick:function onRowClick(rowData,dataIndex,rowIndex){_this.props.history.push({pathname:'/home/partner/view'+'/'+_this.props.partnerLoginId+'/'+_this.subscriptionIdArray[dataIndex.dataIndex]+'/subscriptionDetail'});}};_this.handleNewSubscriptionClick=function(){// console.log('hi', this.props.location.pathname)
_this.props.history.push({pathname:_this.props.location.pathname+'/add-subscription'});};_this.mapToArray=function(allSubscriptionData){var mappedSubscription=allSubscriptionData.reduce(function(acc,subscription){var rowData=[];_this.subscriptionIdArray.push(parseInt(subscription.id,10));rowData.push(subscription.deviceModel.model_name);if(subscription.serviceProvider===null||subscription.serviceProvider===undefined){rowData.push('NA');}else{rowData.push(subscription.serviceProvider.name);}rowData.push(parseInt(subscription.totalDeviceQty,10));rowData.push(subscription.billingMode.billingMode);rowData.push(subscription.billingFrequency.frequency);rowData.push(parseInt(subscription.deviceTrackingCharges,10));console.log('status',subscription.status);if(subscription.status===1||subscription.status===4){rowData.push('Pending');}else if(subscription.status===2||subscription.status===5){rowData.push('Approved');}else if(subscription.status===3){rowData.push('Rejected');}acc.push(rowData);return acc;},[]);_this.setState({subscriptionTableData:mappedSubscription});// console.log('mapped data', mappedSubscription)
// console.log('subscriptio arr', this.subscriptionIdArray)
};_this.getAllPartnerSubcriptions=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _ref2,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.client.query({query:GET_ALL_PARTNER_SUBSCRIPTION,variables:{partnerLoginId:_this.partnerLoginId},fetchPolicy:'network-only'});case 2:_ref2=_context.sent;data=_ref2.data;console.log(' data.getAllPartnerSubscriptions',data.getAllPartnerSubscriptions);if(data&&data.getAllPartnerSubscriptions){_this.setState({getAllPartnerSubcriptionsData:data.getAllPartnerSubscriptions},function(){_this.mapToArray(_this.state.getAllPartnerSubcriptionsData);});}case 6:case'end':return _context.stop();}}},_callee,_this2);}));_this.componentDidMount=function(){_this.getAllPartnerSubcriptions();};_this.partnerLoginId=parseInt(_this.props.match.params.loginId,10);_this.state={getAllPartnerSubcriptionsData:[],subscriptionTableData:[]};return _this;}_createClass(Subscriptions,[{key:'render',value:function render(){var subscriptionTableData=this.state.subscriptionTableData;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{container:true,justify:'flex-end'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Button"],{variant:'contained',color:'secondary',onClick:this.handleNewSubscriptionClick},'Create Subscription')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Paper"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_mui_datatables___default.a,{data:subscriptionTableData,columns:this.columns,options:this.options}))));}}]);return Subscriptions;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_4_react_router__["a" /* withRouter */])(Subscriptions))));

/***/ }),
/* 2374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Modules_CustomTabs__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_icons_ArrowBack__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_icons_ArrowBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_ArrowBack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_Card__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_CardHeader__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_CardHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_CardHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core_CardContent__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core_CardContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_CardContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_core_CardActions__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_core_CardActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_CardActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__common_ConfirmationDialog__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_core_FormHelperText__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_core_FormHelperText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_FormHelperText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Modules_Countries__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Modules_States__ = __webpack_require__(250);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query partnerDetail($loginId: Int) {\n    partnerDetail(loginId: $loginId) {\n      id\n      billingMode {\n        id\n        billingMode\n      }\n      businessName\n      contactPerson\n      address\n      city\n      SalesPerson {\n        id\n        name\n      }\n      state {\n        zone_id\n      }\n      country {\n        country_id\n      }\n      login {\n        username\n      }\n      email\n      contactNumber\n      pincode\n      panNumber\n      partnerType\n      solution\n    }\n  }\n'],['\n  query partnerDetail($loginId: Int) {\n    partnerDetail(loginId: $loginId) {\n      id\n      billingMode {\n        id\n        billingMode\n      }\n      businessName\n      contactPerson\n      address\n      city\n      SalesPerson {\n        id\n        name\n      }\n      state {\n        zone_id\n      }\n      country {\n        country_id\n      }\n      login {\n        username\n      }\n      email\n      contactNumber\n      pincode\n      panNumber\n      partnerType\n      solution\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  mutation updatePartnerDetail(\n    $businessName: String!\n    $email: String!\n    $contactPerson: String!\n    $contactNumber: String!\n    $address: String!\n    $city: String!\n    $state: Int!\n    $country: Int!\n    $pincode: Int!\n    $panNumber: String!\n    $login_id: Int!\n    $status: Int!\n    $id: Int!\n    $billingMode: Int!\n    $partnerType: String!\n    $salesPersonId: Int!\n    $solution: String!\n  ) {\n    updatePartnerDetail(\n      businessName: $businessName\n      email: $email\n      contactPerson: $contactPerson\n      contactNumber: $contactNumber\n      address: $address\n      city: $city\n      state_id: $state\n      country_id: $country\n      pincode: $pincode\n      panNumber: $panNumber\n      login_id: $login_id\n      status: $status\n      id: $id\n      partnerType: $partnerType\n      billingMode: $billingMode\n      salesPersonId: $salesPersonId\n      solution: $solution\n    )\n  }\n'],['\n  mutation updatePartnerDetail(\n    $businessName: String!\n    $email: String!\n    $contactPerson: String!\n    $contactNumber: String!\n    $address: String!\n    $city: String!\n    $state: Int!\n    $country: Int!\n    $pincode: Int!\n    $panNumber: String!\n    $login_id: Int!\n    $status: Int!\n    $id: Int!\n    $billingMode: Int!\n    $partnerType: String!\n    $salesPersonId: Int!\n    $solution: String!\n  ) {\n    updatePartnerDetail(\n      businessName: $businessName\n      email: $email\n      contactPerson: $contactPerson\n      contactNumber: $contactNumber\n      address: $address\n      city: $city\n      state_id: $state\n      country_id: $country\n      pincode: $pincode\n      panNumber: $panNumber\n      login_id: $login_id\n      status: $status\n      id: $id\n      partnerType: $partnerType\n      billingMode: $billingMode\n      salesPersonId: $salesPersonId\n      solution: $solution\n    )\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query checkBusinessName($id: Int, $businessname: String!) {\n    checkBusinessName(id: $id, businessName: $businessname)\n  }\n'],['\n  query checkBusinessName($id: Int, $businessname: String!) {\n    checkBusinessName(id: $id, businessName: $businessname)\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query checkUsername($id: Int, $username: String!) {\n    checkUsername(id: $id, username: $username)\n  }\n'],['\n  query checkUsername($id: Int, $username: String!) {\n    checkUsername(id: $id, username: $username)\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  query checkPartnerContactNumber($id: Int, $phoneno: String!) {\n    checkPartnerContactNumber(id: $id, contactNumber: $phoneno)\n  }\n'],['\n  query checkPartnerContactNumber($id: Int, $phoneno: String!) {\n    checkPartnerContactNumber(id: $id, contactNumber: $phoneno)\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  query checkPartnerEmail($id: Int, $email: String!) {\n    checkPartnerEmail(id: $id, email: $email)\n  }\n'],['\n  query checkPartnerEmail($id: Int, $email: String!) {\n    checkPartnerEmail(id: $id, email: $email)\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  query checkPartnerPanNumber($id: Int, $pan: String!) {\n    checkPartnerPanNumber(id: $id, panNumber: $pan)\n  }\n'],['\n  query checkPartnerPanNumber($id: Int, $pan: String!) {\n    checkPartnerPanNumber(id: $id, panNumber: $pan)\n  }\n']),_templateObject8=_taggedTemplateLiteral(['\n  query getAllSalesPerson($partnerLoginId: Int) {\n    getAllSalesPerson(partnerLoginId: $partnerLoginId) {\n      id\n      name\n    }\n  }\n'],['\n  query getAllSalesPerson($partnerLoginId: Int) {\n    getAllSalesPerson(partnerLoginId: $partnerLoginId) {\n      id\n      name\n    }\n  }\n']);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var styles=function styles(theme){return{root:{flexGrow:1,padding:theme.spacing.unit*2}};};var GET_PARTNER=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject);var UPDATE_PARTNER=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject2);// Business name validation
var GET_BUSINESSNAME=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject3);// username validation
var GET_USERNAME=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject4);// Business name validation
var GET_CONTACTNO=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject5);// Business email validation
var GET_EMAIL=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject6);// Business pan validation
var GET_PAN_NUMBER=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject7);var GET_ALL_SALESPERSON=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject8);var BILLING_MODES=[{value:1,label:'PREPAID'},{value:2,label:'POSTPAID'}];var PartnerEdit=function(_Component){_inherits(PartnerEdit,_Component);function PartnerEdit(props){var _this2=this;_classCallCheck(this,PartnerEdit);var _this=_possibleConstructorReturn(this,(PartnerEdit.__proto__||Object.getPrototypeOf(PartnerEdit)).call(this,props));_this.getClients=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _ref2,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.client.query({query:GET_PARTNER,variables:{loginId:parseInt(_this.loginId,10)},fetchPolicy:'network-only'});case 2:_ref2=_context.sent;data=_ref2.data;// console.log('details', data)
_this.setDetails(data.partnerDetail);case 5:case'end':return _context.stop();}}},_callee,_this2);}));_this.getAllSalesPersonDetails=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var fetchSalesPersonData,getAllSalesPerson,salesPersonsDetails;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this.props.client.query({query:GET_ALL_SALESPERSON,variables:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_15__utils_getLoginId__["a" /* default */])()}});case 2:fetchSalesPersonData=_context2.sent;getAllSalesPerson=fetchSalesPersonData.data.getAllSalesPerson;salesPersonsDetails=getAllSalesPerson.map(function(salesPerson){return{value:salesPerson.id,label:salesPerson.name};});// console.log('Edit customer getAllsataperson :', salesPersonsDetails)
_this.setState({allSalesPerson:salesPersonsDetails});case 6:case'end':return _context2.stop();}}},_callee2,_this2);}));_this.setDetails=function(partnerDetail){console.log('details',partnerDetail,partnerDetail.salesPerson);_this.setState({clientId:partnerDetail.id,name:partnerDetail.businessName,username:partnerDetail.login.username,person:partnerDetail.contactPerson,email:partnerDetail.email,phoneno:partnerDetail.contactNumber,address1:partnerDetail.address,city:partnerDetail.city,state:partnerDetail.state.zone_id,country:partnerDetail.country.country_id,pincode:partnerDetail.pincode,pan:partnerDetail.panNumber,loginId:partnerDetail.login.loginId,partnerType:partnerDetail.partnerType,billingMode:partnerDetail.billingMode.id,salesPerson:partnerDetail.SalesPerson.name&&partnerDetail.SalesPerson.id,solution:partnerDetail.solution});};_this.handleInputChange=function(name){return function(e){return _this.setState(_defineProperty({},name,e.target.value)// console.log('name=', [name], e.target.value)
);};};_this.handleBillingModeChange=function(billingMode){_this.setState({isStateChanged:true});if(billingMode){_this.setState({billingMode:billingMode.value});}else{_this.setState({billingMode:''});}};_this.handleSalesPersonChange=function(salesPerson){console.log('salesp',salesPerson);_this.setState({isStateChanged:true});if(salesPerson){_this.setState({salesPerson:salesPerson.value});}else{_this.setState({salesPerson:''});}};_this.handleCountryChange=function(country){_this.setState({isStateChanged:true});if(!country){_this.setState({state:null,country:null});// this.props.openSnackbar('Please select a Country')
}else{_this.setState({state:null,country:country.value});}};_this.handleStateChange=function(state){_this.setState({isStateChanged:true});if(state){_this.setState({state:state.value});}else{// this.props.openSnackbar('Please select a state')
_this.setState({state:null});}};_this.handlePlanChange=function(plan){_this.setState({isStateChanged:true});if(!plan){_this.setState({plan:''});}else{_this.setState({plan:plan.value});}};_this.handleChangeLicense=function(event){_this.setState({licenseId:event.target.value});// console.log(this.state.licenseId)
};_this.handleChangeModels=function(event){_this.setState({modelName:event.target.value});};_this.handleTimezoneChange=function(timezone){if(!timezone){_this.setState({timezone:''});}else{_this.setState({timezone:timezone.value});}console.log('p',timezone);};_this.handleChangeFreePeriod=function(name){return function(value){var _this$setState2;var total=parseInt(value.target.value,10)+parseInt(_this.state.bufferPeriod,10);_this.setState((_this$setState2={},_defineProperty(_this$setState2,name,value.target.value),_defineProperty(_this$setState2,'totalPeriod',total),_this$setState2));};};_this.handleChangeBufferPeriod=function(name){return function(value){var _this$setState3;var total=parseInt(_this.state.freePeriod,10)+parseInt(value.target.value,10);_this.setState((_this$setState3={},_defineProperty(_this$setState3,name,value.target.value),_defineProperty(_this$setState3,'totalPeriod',total),_this$setState3));};};_this.handleChangeDiscount=function(name){return function(value){_this.setState(_defineProperty({},name,value.target.value));};};_this.handleSelectChange=function(name){return function(value){_this.setState(_defineProperty({},name,value));};};_this.checkBusinessNameValidity=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(event){var regex,_ref5,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:console.log('gggg');regex=new RegExp(/^(?!\s)(?!.*\s$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9 '~?!]{5,32}$/);_context3.next=4;return _this.props.client.query({query:GET_BUSINESSNAME,variables:{id:parseInt(_this.state.clientId,10),businessname:_this.state.name}});case 4:_ref5=_context3.sent;data=_ref5.data;console.log('hh',data.checkBusinessName);_this.setState({isNameValid:regex.test(_this.state.name)&&_this.state.name!==''&&data.checkBusinessName==='AVAILABLE'});if(regex.test(_this.state.name)===false){_this.setState({nameRes:'Invalid Business Name'});}else if(data.checkBusinessName!=='AVAILABLE'){_this.setState({nameRes:'Business name already exist'});}case 9:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x){return _ref4.apply(this,arguments);};}();_this.checkUsernameValidity=function(client){return function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(event){var regex,_ref7,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:// checkUsernameValidity = () => {
regex=new RegExp(/^[a-zA-Z0-9.\-_$@*!]{3,30}$/);_context4.next=3;return client.query({query:GET_USERNAME,variables:{id:parseInt(_this.state.login_id,10),username:_this.state.username}});case 3:_ref7=_context4.sent;data=_ref7.data;_this.setState({isUsernameUnique:data.checkUsername==='AVAILABLE',isUsernameValid:regex.test(_this.state.username)&&_this.state.username!==''&&data.checkUsername==='AVAILABLE'});case 6:case'end':return _context4.stop();}}},_callee4,_this2);}));return function(_x2){return _ref6.apply(this,arguments);};}();};_this.checkContactpValidity=function(){var regex=new RegExp(/^[a-zA-Z\s]{5,32}$/);_this.setState({isContactpValid:regex.test(_this.state.person)&&_this.state.person!==''});};_this.checkPasswordValidity=function(){// const regex = new RegExp(/^((?!.*[\s])(?=.*[A-Z])(?=.*\d).{5,10})/)
var regex=new RegExp(/^[a-zA-Z0-9.\-_$@*!]{3,20}$/);console.log('pass=',regex.test(_this.state.password));_this.setState({isPasswordValid:_this.state.password!==''&&regex.test(_this.state.password)});};_this.checkPhonenoValidity=function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(event){var regex,_ref9,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:console.log('pp');regex=new RegExp(/^(\+91[-\s]?)?[0]?(91)?[1-9]\d{9,12}$/);_context5.next=4;return _this.props.client.query({query:GET_CONTACTNO,variables:{id:parseInt(_this.state.clientId,10),phoneno:_this.state.phoneno}});case 4:_ref9=_context5.sent;data=_ref9.data;console.log('phoneno',data,_this.state.phoneno);_this.setState({isPhonenoValid:regex.test(_this.state.phoneno)&&_this.state.phoneno!==''&&data.checkPartnerContactNumber==='AVAILABLE'});if(regex.test(_this.state.phoneno)===false){_this.setState({phoneNoRes:'Invalid phone number'});}else if(data.checkPartnerContactNumber!=='AVAILABLE'){_this.setState({phoneNoRes:'Phone number already exist'});}case 9:case'end':return _context5.stop();}}},_callee5,_this2);}));return function(_x3){return _ref8.apply(this,arguments);};}();_this.checkEmailValidity=function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(event){var regex,_ref11,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:regex=new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);_context6.next=3;return _this.props.client.query({query:GET_EMAIL,variables:{id:parseInt(_this.state.clientId,10),email:_this.state.email}});case 3:_ref11=_context6.sent;data=_ref11.data;console.log('email',data,_this.state.email);_this.setState({isEmailValid:regex.test(_this.state.email)&&_this.state.email!==''&&data.checkPartnerEmail==='AVAILABLE'});if(regex.test(_this.state.email)===false){_this.setState({emailRes:'Invalid email id'});}else if(data.checkPartnerEmail!=='AVAILABLE'){_this.setState({emailRes:'Email already exist'});}case 8:case'end':return _context6.stop();}}},_callee6,_this2);}));return function(_x4){return _ref10.apply(this,arguments);};}();_this.checkAddressValidity=function(){// const regex = new RegExp(/^[a-zA-Z0-9\s,.'-]{3,300}$/)
var regex=new RegExp(/^(.{5,200})$/);var regex2=new RegExp(/^[^\s]+(\s+[^\s]+)*$/);_this.setState({isAddressValid:// regex.test(this.state.address1) && this.state.address1 !== ''
regex.test(_this.state.address1)&&regex2.test(_this.state.address1)});};_this.checkCityValidity=function(){var regex=new RegExp(/^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/);_this.setState({isCityValid:regex.test(_this.state.city)&&_this.state.city!==''&&parseInt(_this.state.city.length,10)<32});console.log('city',_this.state.city.length,_this.state.isCityValid);};_this.checkPinValidity=function(){var regex=new RegExp(/^[1-9][0-9]{5}$/);_this.setState({isPinValid:regex.test(_this.state.pincode)&&_this.state.pincode!==''});};_this.checkPanValidity=function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(event){var regex,_ref13,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:regex=new RegExp(/([A-Z]){5}([0-9]){4}([A-Z]){1}$/);_this.setState({panNoRes:''});_context7.next=4;return _this.props.client.query({query:GET_PAN_NUMBER,variables:{id:parseInt(_this.state.clientId,10),pan:_this.state.pan}});case 4:_ref13=_context7.sent;data=_ref13.data;_this.setState({isPanValid:regex.test(_this.state.pan)&&_this.state.pan!==''&&data.checkPartnerPanNumber==='AVAILABLE'});if(regex.test(_this.state.pan)===false){_this.setState({panNoRes:'Invalid pan number'});}else if(data.checkPartnerPanNumber!=='AVAILABLE'){_this.setState({panNoRes:'Pan number already exist'});}case 8:case'end':return _context7.stop();}}},_callee7,_this2);}));return function(_x5){return _ref12.apply(this,arguments);};}();_this.checkCountryValidity=function(){_this.setState({isCountryValid:_this.state.country!==''});};_this.checkStateValidity=function(){_this.setState({isStateValid:_this.state.state!==''});};_this.checkCltTypeValidity=function(){_this.setState({isCltTypeValid:_this.state.clttype!==''});};_this.onCountryFetched=function(){var _ref14=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(getStatesId){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:return _context8.abrupt('return',_this.setState({getStatesId:getStatesId}));case 1:case'end':return _context8.stop();}}},_callee8,_this2);}));return function(_x6){return _ref14.apply(this,arguments);};}();_this.handleSaveClick=function(e){_this.setState({isSaveConfDialogOpen:true});};_this.submitForm=function(client){return function(){var _ref15=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(e){var _ref16,data,errors;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:console.log("this.state.country",_this.state.country);e.preventDefault();_context9.next=4;return _this.props.client.mutate({mutation:UPDATE_PARTNER,variables:{id:parseInt(_this.state.clientId,10),businessName:_this.state.name,login_id:parseInt(_this.loginId,10),email:_this.state.email,contactPerson:_this.state.person,contactNumber:_this.state.phoneno,address:_this.state.address1+' '+_this.state.address2,city:_this.state.city,state:parseInt(_this.state.state,10),country:parseInt(_this.state.country,10),pincode:parseInt(_this.state.pincode,10),panNumber:_this.state.pan,status:1,// loginId: parseInt(this.state.loginId, 10),
partnerType:_this.state.partnerType,billingMode:parseInt(_this.state.billingMode,10),salesPersonId:parseInt(_this.state.salesPerson,10),solution:_this.state.solution},errorPolicy:'all',refetchQueries:['allPartnerDetails','partnerDetail']});case 4:_ref16=_context9.sent;data=_ref16.data;errors=_ref16.errors;// console.log('+++++++++++', data)
if(data&&data.updatePartnerDetail){_this.props.openSnackbar('Updated Successfully');_this.props.history.push({pathname:'/home/partner/view/'+_this.loginId});}else{_this.props.openSnackbar(errors[0].message);_this.setState({isSaveConfDialogOpen:false});}case 8:case'end':return _context9.stop();}}},_callee9,_this2);}));return function(_x7){return _ref15.apply(this,arguments);};}();};_this.handleCancelClick=function(e){console.log('hhh',_this.state.isStateChanged);if(_this.state.isStateChanged){_this.setState({isCancelConfDialogOpen:true});}else{_this.cancelForm();}};_this.handleCancelNegativeResponse=function(e){_this.setState({isCancelConfDialogOpen:false});};_this.handleSaveNegativeResponse=function(e){_this.setState({isSaveConfDialogOpen:false});};_this.cancelForm=function(e){_this.setState({clientId:'',name:'',username:'',person:'',password:'',email:'',phoneno:'',address1:'',address2:'',city:'',state:'',country:'',pincode:'',pan:'',gst:'',plan:'',timezone:''});_this.props.history.goBack();};_this.loginId=_this.props.match.params.loginId;_this.state={clientId:'',name:'',username:'',person:'',password:'123345',email:'',phoneno:'',address1:'',address2:'',city:'',state:'',country:'',pincode:'',pan:'',gst:'',plan:'',timezone:'',isEmailValid:true,isPhonenoValid:true,isAddressValid:true,isCityValid:true,isPinValid:true,isPanValid:true,isGSTValid:true,isUsernameValid:true,isNameValid:true,isContactpValid:true,isPasswordValid:true,isUsernameUnique:true,response:false,modelName:[],licenseId:[],billingFrequencies:'',billingFrequency:'',freePeriod:'',bufferPeriod:'',totalPeriod:'',discount:'',loginId:'',existingModels:[],existingLicenses:[],lflag:1,mflag:1,partnerType:'',billingMode:'',allSalesPerson:[],salesPerson:'',panNoRes:'',phoneNoRes:'',nameRes:'',emailRes:'',userNameRes:'',isCancelConfDialogOpen:false,isSaveConfDialogOpen:false,isStateChanged:false,solution:''};return _this;}_createClass(PartnerEdit,[{key:'componentDidMount',value:function componentDidMount(){this.getClients();this.getAllSalesPersonDetails();}},{key:'handleStateRender',value:function handleStateRender(){if(this.state.country){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__Modules_States__["a" /* default */],{countryId:this.state.country,zoneId:this.state.state,handleStateChange:this.handleStateChange})));}}// submitForm = addClient => e => {
},{key:'render',value:function render(){var _this3=this;var _state=this.state,name=_state.name,username=_state.username,person=_state.person,password=_state.password,email=_state.email,phoneno=_state.phoneno,address1=_state.address1,address2=_state.address2,city=_state.city,state=_state.state,country=_state.country,pincode=_state.pincode,pan=_state.pan,gst=_state.gst,billingMode=_state.billingMode,allSalesPerson=_state.allSalesPerson,salesPerson=_state.salesPerson;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__common_ConfirmationDialog__["a" /* default */],{isDialogOpen:this.state.isSaveConfDialogOpen,dialogMessage:"Are you sure you want to Save this customer's details?",negativeResponseHandler:this.handleSaveNegativeResponse,positiveResponseHandler:this.submitForm(this.props.client)}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__common_ConfirmationDialog__["a" /* default */],{isDialogOpen:this.state.isCancelConfDialogOpen,dialogMessage:'Are you sure you want to Cancel new customer creation?',negativeResponseHandler:this.handleCancelNegativeResponse,positiveResponseHandler:this.cancelForm}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,justify:'flex-start'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Button___default.a,{variant:'outlined',color:'secondary',className:classes.button// onClick={() => this.viewSubscription(this.backUrl)}
,onClick:function onClick(){return _this3.props.history.goBack();}// href={'/home/customers/view/' + this.loginId}
},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_ArrowBack___default.a,{className:classes.iconSmall})),' '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_Card___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_CardHeader___default.a,{title:'Edit Partner',subheader:'All fields marked with (*) are mandatory',subheaderTypographyProps:{className:classes.italicizedText}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,md:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a// autoComplete="username"
,{name:'name',value:this.state.name,type:'text',label:'Business Name',required:true,onChange:this.handleInputChange('name'),error:!this.state.isNameValid,onBlur:this.checkBusinessNameValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isNameValid?this.state.nameRes:''))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a// autoComplete="username"
,{name:'username',value:username,type:'text',onChange:this.handleInputChange('username'),label:'Username',required:true,disabled:true// error={!isUsernameValid}
// onBlur={this.checkUsernameValidity}
// label={!isUsernameValid ? 'Invalid Username' : ''}
}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a// autoComplete="username"
,{name:'person',value:person,type:'text',label:'Contact Person',required:true,onChange:this.handleInputChange('person'),error:!this.state.isContactpValid,onBlur:this.checkContactpValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isContactpValid?'Invalid Contact Person Name':''))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a// autoComplete="username"
,{name:'password',value:password,type:'password',onChange:this.handleInputChange('password'),label:'Password',error:!this.state.isPasswordValid,disabled:true}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a// autoComplete="username"
,{name:'email',value:this.state.email,type:'text'// onChange={this.handleInputChange}
,label:'Email',required:true,onChange:this.handleInputChange('email')// placeholder="Email"
,error:!this.state.isEmailValid,onBlur:this.checkEmailValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isEmailValid?this.state.emailRes:''))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a// autoComplete="username"
,{name:'phoneno',value:this.state.phoneno,type:'text',label:'Phone Number',required:true,onChange:this.handleInputChange('phoneno'),error:!this.state.isPhonenoValid,onBlur:this.checkPhonenoValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isPhonenoValid?this.state.phoneNoRes:''))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6,md:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_select__["a" /* default */],{options:BILLING_MODES,value:billingMode,name:'billingMode',onChange:this.handleBillingModeChange,placeholder:'Select Billing Mode*'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6,md:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_select__["a" /* default */],{options:allSalesPerson,value:this.state.salesPerson,onChange:this.handleSalesPersonChange,placeholder:'Select Sales Person*'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a,{id:'address1',name:'address1',className:'textfield',margin:'dense',label:'Address',type:'Multi-line',value:this.state.address1,required:true,onChange:this.handleInputChange('address1'),error:!this.state.isAddressValid,onBlur:this.checkAddressValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isAddressValid?'Invalid Address':''))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a,{id:'city',name:'city',className:'textfield',margin:'dense',label:'City'// type="Multi-line"
,value:this.state.city,required:true,onChange:this.handleInputChange('city'),error:!this.state.isCityValid,onBlur:this.checkCityValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isCityValid?'Invalid City':''))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__Modules_Countries__["a" /* default */],{countryId:this.state.country,handleCountryChange:this.handleCountryChange}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},this.handleStateRender()),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a,{id:'pincode',name:'pincode',className:'textfield',margin:'dense',label:'Pin Code'// type="Multi-line"
,value:this.state.pincode,required:true,onChange:this.handleInputChange('pincode'),error:!this.state.isPinValid,onBlur:this.checkPinValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isPinValid?'Invalid Pin Number':''))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a,{id:'pan',name:'pan',className:'textfield',margin:'dense',label:'PAN No'// type="Multi-line"
,value:this.state.pan,required:true,onChange:this.handleInputChange('pan'),error:!this.state.isPanValid,onBlur:this.checkPanValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},this.state.isPanValid?'':this.state.panNoRes))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_CardActions___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Button___default.a,{color:'secondary',variant:'contained'// className={this.classes.button}
// onClick={this.submitForm}
,onClick:this.handleSaveClick,disabled:this.state.country==null||this.state.state==null||this.state.salesPerson==""||this.state.billingMode==""||!this.state.isPinValid||!this.state.isPanValid||this.state.name==""||this.state.person==""||this.state.phoneno==""||this.state.address1==""||this.state.city==""||this.state.email==""||!this.state.isAddressValid||!this.state.isPhonenoValid||!this.state.isCityValid||!this.state.isEmailValid||!this.state.isContactpValid},'Save',' '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Button___default.a,{color:'secondary'// className={this.classes.button}
,onClick:this.handleCancelClick},'Cancel',' '))))));}}]);return PartnerEdit;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var withApolloClient=function withApolloClient(Component){return function(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_apollo__["ApolloConsumer"],null,function(client){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component,Object.assign({client:client},props));});};};PartnerEdit.propTypes={classes:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__["withStyles"])(styles)(withApolloClient(Object(__WEBPACK_IMPORTED_MODULE_13__HOCs_withSharedSnackbar__["a" /* default */])(PartnerEdit))));

/***/ }),
/* 2375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__HOCs_withSharedSnackbar__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query allClientDetails($status: Int, $superAdmin: Boolean) {\n    clients: allClientDetails(status: $status, superAdmin: $superAdmin) {\n      loginId\n      clientName\n    }\n  }\n'],['\n  query allClientDetails($status: Int, $superAdmin: Boolean) {\n    clients: allClientDetails(status: $status, superAdmin: $superAdmin) {\n      loginId\n      clientName\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query publishMQTTUsingClientLoginId($clientLoginId: Int!) {\n    publishMQTTUsingClientLoginId(clientLoginId: $clientLoginId)\n  }\n'],['\n  query publishMQTTUsingClientLoginId($clientLoginId: Int!) {\n    publishMQTTUsingClientLoginId(clientLoginId: $clientLoginId)\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_PARTNER_CLIENT_LIST=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject);var CLEAR_CACHE=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject2);var style=function style(theme){return{root:{padding:theme.spacing.unit*4,flexGrow:1,backgroundColor:theme.palette.background.paper},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},iconSmall:{fontSize:20},textField:{marginLeft:theme.spacing.unit,marginRight:theme.spacing.unit},dense:{marginTop:16}};};var ClearRedis=function(_Component){_inherits(ClearRedis,_Component);function ClearRedis(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,ClearRedis);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ClearRedis.__proto__||Object.getPrototypeOf(ClearRedis)).call.apply(_ref,[this].concat(args))),_this),_this.state={clientname:'',response:'',clientNames:[]},_this.clearCache=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _ref3,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.client.query({query:CLEAR_CACHE,variables:{clientLoginId:parseInt(_this.state.clientname,10)}});case 2:_ref3=_context.sent;data=_ref3.data;if(data.publishMQTTUsingClientLoginId===true){_this.setState({response:'Cache Cleared Successfully'});}else{_this.setState({response:'Request Failed'});}_this.props.openSnackbar(_this.state.response);case 6:case'end':return _context.stop();}}},_callee,_this2);})),_this.getFormattedDate=function(timestamp){return __WEBPACK_IMPORTED_MODULE_8_moment___default()(timestamp*1000).format('MMM Do YYYY, h:mm a');},_this.handleChange=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(event){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_this.setState({clientname:event.value});case 1:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x){return _ref4.apply(this,arguments);};}(),_this.getClients=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var _ref6,data,allClients;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return _this.props.client.query({query:GET_PARTNER_CLIENT_LIST,variables:{status:1,superAdmin:true},fetchPolicy:'network-only'});case 2:_ref6=_context3.sent;data=_ref6.data;allClients=data.clients.map(function(client){return{value:client.loginId,label:client.clientName};});_this.setState({clientNames:allClients});case 6:case'end':return _context3.stop();}}},_callee3,_this2);})),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ClearRedis,[{key:'componentDidMount',value:function componentDidMount(){this.getClients(this.props.client);}},{key:'render',value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{variant:'subtitle1',gutterBottom:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',null,'Clear Redis')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select__["a" /* default */],{classes:classes,options:this.state.clientNames// components={components}
,value:this.state.clientname,onChange:this.handleChange,placeholder:'Select Client'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button___default.a,{variant:'contained',color:'primary',className:classes.button,onClick:this.clearCache,disabled:this.state.clientname===''},'Clear'))));}}]);return ClearRedis;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_10__HOCs_withSharedSnackbar__["a" /* default */])(ClearRedis))));

/***/ }),
/* 2376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_getLoginId__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getDevices($partnerLoginId: Int!) {\n    getCurrentTrackinfo(partnerLoginId: $partnerLoginId) {\n      vehicleNumber\n      deviceSlNumber\n      phoneNumber\n      imeiNumber\n      simNumber\n      deviceVersion\n      vehicleModel\n      clientName\n      gpsSpeed\n      coordinates\n      address\n      vehicleGroup\n      timestamp\n      trackingStatus\n      batteryStatus\n    }\n  }\n'],['\n  query getDevices($partnerLoginId: Int!) {\n    getCurrentTrackinfo(partnerLoginId: $partnerLoginId) {\n      vehicleNumber\n      deviceSlNumber\n      phoneNumber\n      imeiNumber\n      simNumber\n      deviceVersion\n      vehicleModel\n      clientName\n      gpsSpeed\n      coordinates\n      address\n      vehicleGroup\n      timestamp\n      trackingStatus\n      batteryStatus\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var style=function style(theme){return{root:{padding:theme.spacing.unit*4,flexGrow:1},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},iconSmall:{fontSize:20}};};var GET_ALL_VEHICLE_SUMMARY=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject);var CurrentTrackinfo=function(_Component){_inherits(CurrentTrackinfo,_Component);function CurrentTrackinfo(props){var _this2=this;_classCallCheck(this,CurrentTrackinfo);var _this=_possibleConstructorReturn(this,(CurrentTrackinfo.__proto__||Object.getPrototypeOf(CurrentTrackinfo)).call(this,props));_this.clientId=[];_this.columns=['VHEICLE NO','DEVICE Sl NUMBER','IMEI NUMBER','PHONE NUMBER','SIM NUMBER','DEVICE VERSION','VEHICLE MODEL','CLIENT NAME','TIMESTAMP','SPEED','COORDINATES','ADDRESS','VEHICLE GROUP','TRACKING STATUS','BATTERY STATUS'];_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15,filter:false,print:false};_this.state={open:false,open1:false,vehicleInfo:[],userLoginId:'',vehicleInfoTemp:[],isLoading:false};_this.fullData=[];_this.getAllVehicles=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var vehicles,rowData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.setState({isLoading:true});_context.next=3;return _this.props.client.query({query:GET_ALL_VEHICLE_SUMMARY,variables:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_9__utils_getLoginId__["a" /* default */])()},fetchPolicy:'network-only'});case 3:vehicles=_context.sent;_this.setState({isLoading:false});if(vehicles&&vehicles.data&&vehicles.data.getCurrentTrackinfo){//   console.log('vehi Data', vehicles.data.getCurrentTrackinfo)
rowData=[];vehicles.data.getCurrentTrackinfo.map(function(element){rowData=[];rowData.push(element.vehicleNumber);rowData.push(element.deviceSlNumber);rowData.push(element.imeiNumber);rowData.push(element.phoneNumber);rowData.push(element.simNumber);rowData.push(element.deviceVersion);rowData.push(element.vehicleModel);rowData.push(element.clientName);if(element&&element.timestamp){rowData.push(_this.getFormattedDate(element.timestamp));}else rowData.push('---');if(element&&element.gpsSpeed!==null)rowData.push(element.gpsSpeed);else rowData.push('---');if(element&&element.coordinates)rowData.push(element.coordinates);else rowData.push('---');if(element&&element.address)rowData.push(element.address);else rowData.push('---');rowData.push(element.vehicleGroup);rowData.push(element.trackingStatus);rowData.push(element.batteryStatus);_this.fullData.push(rowData);});}_this.setState({vehicleInfo:_this.fullData});// console.log('fullData vehicleInfo', this.fullData)
case 7:case'end':return _context.stop();}}},_callee,_this2);}));_this.getFormattedDate=function(timestamp){return __WEBPACK_IMPORTED_MODULE_4_moment___default()(timestamp*1000).format('DD-MM-YYYY HH:mm:ss');};_this.classes=props;return _this;}_createClass(CurrentTrackinfo,[{key:'componentDidMount',value:function componentDidMount(){this.getAllVehicles();}},{key:'render',value:function render(){var classes=this.props.classes;// console.log('log', this.fullData)
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},this.state.isLoading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,justify:'space-between'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{variant:'headline'},'Loading.....')):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_mui_datatables___default.a,{data:this.state.vehicleInfo,columns:this.columns,options:this.options,title:'Current Trackinfo'}))));}}]);return CurrentTrackinfo;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_5_react_apollo__["withApollo"])(CurrentTrackinfo)));

/***/ }),
/* 2377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_file_saver__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Radio__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_RadioGroup__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_RadioGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_RadioGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_FormLabel__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_FormLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_FormLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_FormControlLabel__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_FormControlLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_FormControlLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_multiselect_react_dropdown__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_multiselect_react_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_multiselect_react_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__queries__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__TankCard__ = __webpack_require__(2378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__TankConfigHeader__ = __webpack_require__(2379);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable */var style=function style(theme){return{root:{padding:theme.spacing.unit*4,flexGrow:1,backgroundColor:theme.palette.background.paper},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},iconSmall:{fontSize:20},textField:{marginLeft:theme.spacing.unit,marginRight:theme.spacing.unit},dense:{marginTop:16}};};var FuelCalibration=function(_Component){_inherits(FuelCalibration,_Component);function FuelCalibration(){var _ref,_this2=this,_this$state;var _temp,_this,_ret;_classCallCheck(this,FuelCalibration);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FuelCalibration.__proto__||Object.getPrototypeOf(FuelCalibration)).call.apply(_ref,[this].concat(args))),_this),_this.handleTankDataChange=function(tankIndex,field,value){_this.setState(function(prevState){var updatedTanks=[].concat(_toConsumableArray(prevState.tanks));var actualIndex=tankIndex-3;// tank 3 = index 0
updatedTanks[actualIndex]=Object.assign({},updatedTanks[actualIndex],_defineProperty({},field,value));// Validation
if(field==='minCapacity'){var regex=new RegExp(/^[0-9]{1,3}$/);updatedTanks[actualIndex].isMinCapacityValid=regex.test(value)||value==='';}else if(field==='maxCapacity'){var _regex=new RegExp(/^[0-9]{2,5}$/);updatedTanks[actualIndex].isMaxCapacityValid=_regex.test(value)||value==='';}else if(field==='totalFuelTank'){var _regex2=new RegExp(/^[0-9]{2,5}$/);updatedTanks[actualIndex].isTotalFuelTankValid=_regex2.test(value)||value==='';}return{tanks:updatedTanks};});},_this.handleAddTank=function(){_this.setState(function(prevState){return{tanks:[].concat(_toConsumableArray(prevState.tanks),[{tankNumber:prevState.tanks.length+3,minValue:'',maxValue:'',minCapacity:'',maxCapacity:'',totalFuelTank:'',isMinCapacityValid:true,isMaxCapacityValid:true,isTotalFuelTankValid:true,fileName:'',bucketName:'',downloadUrl:'',isUploading:false}])};});},_this.handleRemoveTank=function(tankIndex){_this.setState(function(prevState){var actualIndex=tankIndex-3;var updatedTanks=prevState.tanks.filter(function(_,idx){return idx!==actualIndex;});// Reassign tank numbers
var reNumbered=updatedTanks.map(function(tank,idx){return Object.assign({},tank,{tankNumber:idx+3});});return{tanks:reNumbered};});},_this.handleTankFileUpload=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(tankIndex,file){var fileExtension,client,_ref3,data,_data$getPublicUpload,bucketName,filename,publicUploadURL,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.setState(function(prevState){var updatedTanks=[].concat(_toConsumableArray(prevState.tanks));var actualIndex=tankIndex-3;updatedTanks[actualIndex]=Object.assign({},updatedTanks[actualIndex],{isUploading:true});return{tanks:updatedTanks};});_context.prev=1;fileExtension=file.name.split('.').pop();client=_this.props.client;_context.next=6;return client.mutate({mutation:__WEBPACK_IMPORTED_MODULE_18__queries__["i" /* GET_UPLOAD_URL */],variables:{fileExtension:fileExtension}});case 6:_ref3=_context.sent;data=_ref3.data;_data$getPublicUpload=data.getPublicUploadURL,bucketName=_data$getPublicUpload.bucketName,filename=_data$getPublicUpload.filename,publicUploadURL=_data$getPublicUpload.publicUploadURL;_context.next=11;return __WEBPACK_IMPORTED_MODULE_9_axios___default.a.put(publicUploadURL,file,{headers:{// 'Content-Type': file.type,
"x-ms-blob-type":"BlockBlob","Content-Type":file.type||"application/octet-stream"}});case 11:_context.next=13;return client.query({query:__WEBPACK_IMPORTED_MODULE_18__queries__["e" /* GET_FILE_FORMAT */],variables:{bucketname:bucketName,filename:filename},errorPolicy:'all'});case 13:result=_context.sent;_this.setState(function(prevState){var updatedTanks=[].concat(_toConsumableArray(prevState.tanks));var actualIndex=tankIndex-3;updatedTanks[actualIndex]=Object.assign({},updatedTanks[actualIndex],{fileName:filename,bucketName:bucketName,downloadUrl:result.data.getPublicDownloadURL,isUploading:false});return{tanks:updatedTanks};});if(_this.props.handleSnackbar){_this.props.handleSnackbar({message:'File uploaded successfully',severity:'success'});}_context.next=22;break;case 18:_context.prev=18;_context.t0=_context['catch'](1);_this.setState(function(prevState){var updatedTanks=[].concat(_toConsumableArray(prevState.tanks));var actualIndex=tankIndex-3;updatedTanks[actualIndex]=Object.assign({},updatedTanks[actualIndex],{isUploading:false});return{tanks:updatedTanks};});if(_this.props.handleSnackbar){_this.props.handleSnackbar({message:'Failed to upload file',severity:'error'});}case 22:case'end':return _context.stop();}}},_callee,_this2,[[1,18]]);}));return function(_x,_x2){return _ref2.apply(this,arguments);};}(),_this.handlePrimaryTankChange=function(index,field,value){_this.setState(_defineProperty({},field,value),function(){if(field==='minCapacity')_this.checkMinCapacityValidity();if(field==='maxCapacity')_this.checkMaxCapacityValidity();if(field==='totalFuelTank')_this.checkTotalFuelTankValidity();if(field==='minValue')_this.checkMinValueValidity();if(field==='maxValue')_this.checkMaxValueValidity();});},_this.handlePrimaryTankFileUpload=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(tankIndex,file){var fileExtension,client,_ref5,data,_data$getPublicUpload2,bucketName,filename,publicUploadURL,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_this.setState({isUploading:true});_context2.prev=1;fileExtension=file.name.split('.').pop();client=_this.props.client;_context2.next=6;return client.mutate({mutation:__WEBPACK_IMPORTED_MODULE_18__queries__["i" /* GET_UPLOAD_URL */],variables:{fileExtension:fileExtension}});case 6:_ref5=_context2.sent;data=_ref5.data;_data$getPublicUpload2=data.getPublicUploadURL,bucketName=_data$getPublicUpload2.bucketName,filename=_data$getPublicUpload2.filename,publicUploadURL=_data$getPublicUpload2.publicUploadURL;console.log("Uploading to URL with headers: ",publicUploadURL,{// 'Content-Type': file.type,
"x-ms-blob-type":"BlockBlob","Content-Type":file.type||"application/octet-stream"});_context2.next=12;return __WEBPACK_IMPORTED_MODULE_9_axios___default.a.put(publicUploadURL,file,{headers:_defineProperty({'Content-Type':file.type,"x-ms-blob-type":"BlockBlob"},'Content-Type',file.type||"application/octet-stream")});case 12:_context2.next=14;return client.query({query:__WEBPACK_IMPORTED_MODULE_18__queries__["e" /* GET_FILE_FORMAT */],variables:{bucketname:bucketName,filename:filename},errorPolicy:'all'});case 14:result=_context2.sent;_this.setState({fileName:filename,bucketName:bucketName,downloadUrl:result.data.getPublicDownloadURL,isUploading:false});if(_this.props.handleSnackbar){_this.props.handleSnackbar({message:'File uploaded successfully',severity:'success'});}_context2.next=23;break;case 19:_context2.prev=19;_context2.t0=_context2['catch'](1);_this.setState({isUploading:false});if(_this.props.handleSnackbar){_this.props.handleSnackbar({message:'Failed to upload file',severity:'error'});}case 23:case'end':return _context2.stop();}}},_callee2,_this2,[[1,19]]);}));return function(_x3,_x4){return _ref4.apply(this,arguments);};}(),_this.handleSecondaryTankChange=function(index,field,value){var stateFieldMap={minValue:'secondaryTankMinValue',maxValue:'secondaryTankMaxValue',minCapacity:'secondaryTankMinCapacity',maxCapacity:'secondaryTankMaxCapacity',totalFuelTank:'secondaryTankTotalFuelTank'};var stateField=stateFieldMap[field];if(stateField){_this.setState(_defineProperty({},stateField,value),function(){if(field==='minCapacity')_this.checkSecondaryTankMinCapacityValidity();if(field==='maxCapacity')_this.checkSecondaryTankMaxCapacityValidity();if(field==='totalFuelTank')_this.checkSecondaryTankTotalFuelTankValidity();if(field==='minValue')_this.checkSecondaryTankMinValueValidity();if(field==='maxValue')_this.checkSecondaryTankMaxValueValidity();});}},_this.handleSecondaryTankFileUpload=function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(tankIndex,file){var fileExtension,client,_ref7,data,_data$getPublicUpload3,bucketName,filename,publicUploadURL,result;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_this.setState({isUploadingSecondary:true});_context3.prev=1;fileExtension=file.name.split('.').pop();client=_this.props.client;_context3.next=6;return client.mutate({mutation:__WEBPACK_IMPORTED_MODULE_18__queries__["i" /* GET_UPLOAD_URL */],variables:{fileExtension:fileExtension}});case 6:_ref7=_context3.sent;data=_ref7.data;_data$getPublicUpload3=data.getPublicUploadURL,bucketName=_data$getPublicUpload3.bucketName,filename=_data$getPublicUpload3.filename,publicUploadURL=_data$getPublicUpload3.publicUploadURL;_context3.next=11;return __WEBPACK_IMPORTED_MODULE_9_axios___default.a.put(publicUploadURL,file,{headers:{// 'Content-Type': file.type,
"x-ms-blob-type":"BlockBlob","Content-Type":file.type||"application/octet-stream"}});case 11:_context3.next=13;return client.query({query:__WEBPACK_IMPORTED_MODULE_18__queries__["e" /* GET_FILE_FORMAT */],variables:{bucketname:bucketName,filename:filename},errorPolicy:'all'});case 13:result=_context3.sent;_this.setState({secondaryFileName:filename,secondaryBucketName:bucketName,secondaryDownloadUrl:result.data.getPublicDownloadURL,isUploadingSecondary:false});if(_this.props.handleSnackbar){_this.props.handleSnackbar({message:'File uploaded successfully',severity:'success'});}_context3.next=22;break;case 18:_context3.prev=18;_context3.t0=_context3['catch'](1);_this.setState({isUploadingSecondary:false});if(_this.props.handleSnackbar){_this.props.handleSnackbar({message:'Failed to upload file',severity:'error'});}case 22:case'end':return _context3.stop();}}},_callee3,_this2,[[1,18]]);}));return function(_x5,_x6){return _ref6.apply(this,arguments);};}(),_this.areDynamicTanksInvalid=function(){if(_this.state.hasSecondaryTank&&_this.state.showMultiTankConfig){return _this.state.tanks.some(function(tank){return tank.minValue===''||tank.maxValue===''||tank.minCapacity===''||tank.maxCapacity===''||tank.totalFuelTank===''||tank.fileName==='';});}return false;},_this.state=(_this$state={// Multi-tank feature flag
multiTankConfigV2:true,// Set to true to enable new multi-tank config
showMultiTankConfig:false,// Multi-tank configuration state (tanks 3 onwards)
tanks:[{tankNumber:3,minValue:'',maxValue:'',minCapacity:'',maxCapacity:'',totalFuelTank:'',isMinCapacityValid:true,isMaxCapacityValid:true,isTotalFuelTankValid:true,fileName:'',bucketName:'',downloadUrl:'',isUploading:false}],availableDataTypes:[],fuelSensorDetails:[],selectedFuelSensors:[],allFuelSensorAssignments:[],selectedIMEIs:{},preferedDataType:null,// fuelSensorName: '',
fuelSensorNames:[],availableDataTypeOptions:[],preferedDataTypeOptions:[],client:{value:null,label:null},isUploading:false,fileName:'',bucketName:'',publicUploadURL:'',response:'',uploadSucess:true,result:false,errorMessage:false,failList:'',isLoading:false},_defineProperty(_this$state,'response',''),_defineProperty(_this$state,'clientNames',[]),_defineProperty(_this$state,'clientname',''),_defineProperty(_this$state,'vehicleDetails',[]),_defineProperty(_this$state,'vehicleNumber',''),_defineProperty(_this$state,'minValue',''),_defineProperty(_this$state,'maxValue',''),_defineProperty(_this$state,'minCapacity',''),_defineProperty(_this$state,'maxCapacity',''),_defineProperty(_this$state,'totalFuelTank',''),_defineProperty(_this$state,'sensorType',''),_defineProperty(_this$state,'isminCapacityValid',true),_defineProperty(_this$state,'ismaxCapacityValid',true),_defineProperty(_this$state,'isTotalFuelTankValid',true),_defineProperty(_this$state,'isminValueValid',true),_defineProperty(_this$state,'ismaxValueValid',true),_defineProperty(_this$state,'isUploadingSecondary',false),_defineProperty(_this$state,'secondaryFileName',''),_defineProperty(_this$state,'hasSecondaryTank',false),_defineProperty(_this$state,'hasInSameTank',false),_defineProperty(_this$state,'isDualSensor',false),_defineProperty(_this$state,'secondaryBucketName',''),_defineProperty(_this$state,'secondaryPublicUploadURL',''),_defineProperty(_this$state,'secondaryDownloadUrl',''),_defineProperty(_this$state,'secondaryTankMinValue',''),_defineProperty(_this$state,'secondaryTankMaxValue',''),_defineProperty(_this$state,'secondaryTankMinCapacity',''),_defineProperty(_this$state,'secondaryTankMaxCapacity',''),_defineProperty(_this$state,'secondaryTankTotalFuelTank',''),_defineProperty(_this$state,'secondaryTankSensorType','Digital_sensor'),_defineProperty(_this$state,'isMinSecondaryTankCapacityValid',true),_defineProperty(_this$state,'isMaxSecondaryTankCapacityValid',true),_defineProperty(_this$state,'isSecondaryTotalFuelTankValid',true),_defineProperty(_this$state,'isMinSecondaryTankValueValid',true),_defineProperty(_this$state,'isMaxSecondaryTankValueValid',true),_defineProperty(_this$state,'calibrationDataExists',false),_defineProperty(_this$state,'pilferageTolerance','10'),_defineProperty(_this$state,'userType','0'),_defineProperty(_this$state,'downloadUrl',''),_defineProperty(_this$state,'useTaabiAlgo',false),_defineProperty(_this$state,'resetKey',0),_this$state),_this.handleClientChange=function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(event){var _ref9,vehicle,vehicleError,allVehicles;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_this.resetFields();if(!(event&&event.value)){_context4.next=12;break;}_this.setState({clientname:event?event.value:''});_context4.next=5;return _this.props.client.query({query:__WEBPACK_IMPORTED_MODULE_18__queries__["c" /* GET_ALL_VEHICLES */],variables:{clientLoginId:event?event.value:''},errorPolicy:'all',fetchPolicy:'network-only'});case 5:_ref9=_context4.sent;vehicle=_ref9.data;vehicleError=_ref9.error;allVehicles=vehicle.getAllVehicleDetails.map(function(vehicle){return{value:vehicle.entityId,label:vehicle.vehicleNumber};});if(vehicleError){_this.setState({vehicleDetails:[]});}else{_this.setState({vehicleDetails:allVehicles});}_context4.next=15;break;case 12:// Clear all fields if vehicle field is cleared
_this.setState({clientname:''});_this.setState({vehicleDetails:[]});_this.resetFields();case 15:case'end':return _context4.stop();}}},_callee4,_this2);}));return function(_x7){return _ref8.apply(this,arguments);};}(),_this.handleChange=function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(event){var vehicleNumber,_ref11,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:if(!(event&&event.value)){_context5.next=9;break;}vehicleNumber=event.value;_context5.next=4;return _this.props.client.query({query:__WEBPACK_IMPORTED_MODULE_18__queries__["d" /* GET_CALIBRATION_DETAILS */],variables:{entityId:parseInt(vehicleNumber,10)},fetchPolicy:'network-only'});case 4:_ref11=_context5.sent;data=_ref11.data;if(data.getFuelCalibrationDetail){// If vehicle is in the database, set the vehicle number and details
_this.setState({vehicleNumber:vehicleNumber,calibrationDataExists:true});// this.setState({ fuelSensorNames: [] });
_this.setDetails(data.getFuelCalibrationDetail);}else{// If vehicle is not in the database, reset all fields except the vehicle number
_this.resetFields();// Set the vehicle number without clearing it from the input field
_this.setState({vehicleNumber:vehicleNumber,calibrationDataExists:false});}_context5.next=11;break;case 9:// Clear all fields if vehicle field is cleared
_this.resetFields();_this.setState({calibrationDataExists:false});case 11:case'end':return _context5.stop();}}},_callee5,_this2);}));return function(_x8){return _ref10.apply(this,arguments);};}(),_this.setDetails=function(vehicleDetail){console.log('details',vehicleDetail);var fileName='';var bucketName='';var url='';var secondaryFileName='';var secondaryBucketName='';var secondaryUrl='';if(vehicleDetail.calibration_filename!==null||vehicleDetail.calibration_filename!==undefined){fileName=vehicleDetail.calibration_filename;bucketName='aquila-track-uploads';}if(vehicleDetail.secondary_tank_calibration_filename!==null||vehicleDetail.secondary_tank_calibration_filename!==undefined){secondaryFileName=vehicleDetail.secondary_tank_calibration_filename;secondaryBucketName='aquila-track-uploads';}if(vehicleDetail.url!==null||vehicleDetail.url!==undefined){url=vehicleDetail.url;}if(vehicleDetail.secondaryUrl!==null||vehicleDetail.secondaryUrl!==undefined){secondaryUrl=vehicleDetail.secondaryUrl;}if(vehicleDetail.fuelSensorNames&&vehicleDetail.fuelSensorNames.length&&vehicleDetail.fuelSensorIMEIs&&vehicleDetail.fuelSensorIMEIs.length){var incomingUUIDs=vehicleDetail.fuelSensorIMEIs;var selectedFuelSensorIds=vehicleDetail.fuelSensorNames;var selectedIMEIs={};selectedFuelSensorIds.forEach(function(sensorId,index){var uuid=incomingUUIDs[index];if(uuid){var matchedIMEI=_this.state.allFuelSensorAssignments.find(function(item){return item.uuid===uuid;});if(matchedIMEI){selectedIMEIs[matchedIMEI.fuelSensorId]={value:matchedIMEI.uuid,label:matchedIMEI.imeiNumber};}}});_this.setState({selectedFuelSensors:selectedFuelSensorIds,selectedIMEIs:selectedIMEIs});}else{_this.setState({selectedFuelSensors:[],selectedIMEIs:{}});}// Multi-tank config: set tanks and showMultiTankConfig from API response
if(vehicleDetail.tanks&&Array.isArray(vehicleDetail.tanks)&&vehicleDetail.tanks.length>0){var additionalTanks=vehicleDetail.tanks.map(function(tank){return{tankNumber:tank.tankNumber,minValue:tank.minValue!==undefined&&tank.minValue!==null?tank.minValue:'',maxValue:tank.maxValue!==undefined&&tank.maxValue!==null?tank.maxValue:'',minCapacity:tank.minTankCapacity!==undefined&&tank.minTankCapacity!==null?tank.minTankCapacity:'',maxCapacity:tank.maxTankCapacity!==undefined&&tank.maxTankCapacity!==null?tank.maxTankCapacity:'',totalFuelTank:tank.totalFuelTank!==undefined&&tank.totalFuelTank!==null?tank.totalFuelTank:'',isMinCapacityValid:true,isMaxCapacityValid:true,isTotalFuelTankValid:true,fileName:tank.calibration_filename||'',bucketName:tank.bucketName||'',downloadUrl:tank.url||'',isUploading:false};});_this.setState({tanks:additionalTanks,showMultiTankConfig:true});}else{_this.setState({tanks:[{tankNumber:3,minValue:'',maxValue:'',minCapacity:'',maxCapacity:'',totalFuelTank:'',isMinCapacityValid:true,isMaxCapacityValid:true,isTotalFuelTankValid:true,fileName:'',bucketName:'',downloadUrl:'',isUploading:false}],showMultiTankConfig:false});}// ...existing code...
_this.setState({pilferageTolerance:vehicleDetail.pilferageTolerance,// minimumPilferageDuration: vehicleDetail.minimumPilferageDuration,
userType:JSON.stringify(vehicleDetail.fuelUserType),sensorType:vehicleDetail.fuelSensorType,minValue:vehicleDetail.minValue,maxValue:vehicleDetail.maxValue,// overallThreshold: vehicleDetail.overallThreshold,
minCapacity:vehicleDetail.minTankCapacity,maxCapacity:vehicleDetail.maxTankCapacity,totalFuelTank:vehicleDetail.totalFuelTank,fileName:fileName,bucketName:bucketName,publicUploadURL:url,downloadUrl:url,// secondary tank
hasSecondaryTank:!!vehicleDetail.hasSecondaryTank,hasInSameTank:!!vehicleDetail.hasInSameTank,isDualSensor:!!vehicleDetail.isDualSensor,// fuelSensorAlgo: vehicleDetail.fuelSensorAlgo || null,
useTaabiAlgo:vehicleDetail.useTaabiAlgo||null,// useObdAlgo: vehicleDetail.obdAlgo || null,
availableDataTypes:vehicleDetail.availableDataTypes||[],fuelSensorNames:vehicleDetail.fuelSensorNames||[],preferedDataType:vehicleDetail.preferedDataType||null,// fuelSensorName: vehicleDetail.fuelSensorName || null,
secondaryTankMinCapacity:vehicleDetail.secondaryTankMinCapacity===0?'0':vehicleDetail.secondaryTankMinCapacity||'',secondaryTankMaxCapacity:vehicleDetail.secondaryTankMaxCapacity||'',secondaryTankTotalFuelTank:vehicleDetail.secondaryTankTotalFuel||'',secondaryTankMinValue:vehicleDetail.secondaryTankMinValue===0?'0':vehicleDetail.secondaryTankMinValue||'',secondaryTankMaxValue:vehicleDetail.secondaryTankMaxValue||'',secondaryFileName:secondaryFileName||'',secondaryBucketName:secondaryBucketName||'',secondaryPublicUploadURL:secondaryUrl||'',secondaryDownloadUrl:secondaryUrl||''});},_this.handleClose=function(){_this.setState({result:false});},_this.handleCloseError=function(){_this.setState({errorMessage:false});},_this.handleInputChange=function(key){return function(e){var value=e.target.value===''?null:e.target.value;_this.setState(_defineProperty({},key,e.target.value));};},_this.handleChangeType=function(event){//console.log(event.target.value, 'typ')
_this.setState({sensorType:event.target.value});// console.log(this.state.sensorType, event.target.value, 'typ')
},_this.handleChangeSecondartTankType=function(event){//console.log(event.target.value, 'typ')
_this.setState({secondaryTankSensorType:event.target.value});// console.log(this.state.sensorType, event.target.value, 'typ')
},_this.handleUserChangeType=function(event){_this.setState({userType:event.target.value});// console.log(this.state.userType, event.target.value, 'typ')
},_this.getClients=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(){var data,allClients;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return _this.props.client.query({query:__WEBPACK_IMPORTED_MODULE_18__queries__["h" /* GET_PARTNER_CLIENT_LIST */],variables:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_10__utils_getLoginId__["a" /* default */])()},fetchPolicy:'network-only'});case 2:data=_context6.sent;allClients=data.data.clientsDetails.map(function(client){return{value:client.loginId,label:client.clientName};});_this.setState({clientNames:allClients});case 5:case'end':return _context6.stop();}}},_callee6,_this2);})),_this.getFuelSensorDetails=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(){var data,sensorDetails;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return _this.props.client.query({query:__WEBPACK_IMPORTED_MODULE_18__queries__["g" /* GET_FUEL_SENSOR_DETAILS */],fetchPolicy:'network-only'});case 2:data=_context7.sent;sensorDetails=data.data.getFuelSensorDetails.map(function(row){return{value:row.fuelSensorId,label:row.fuelSensorName};});_this.setState({fuelSensorDetails:sensorDetails});case 5:case'end':return _context7.stop();}}},_callee7,_this2);})),_this.getFuelSensorAssignments=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.prev=0;_context8.next=3;return _this.props.client.query({query:__WEBPACK_IMPORTED_MODULE_18__queries__["f" /* GET_FUEL_SENSOR_ASSIGNMENTS */],fetchPolicy:'network-only'});case 3:response=_context8.sent;_this.setState({allFuelSensorAssignments:response.data.getFuelSensorAssignments});_context8.next=10;break;case 7:_context8.prev=7;_context8.t0=_context8['catch'](0);console.error('Error fetching fuel sensor assignments:',_context8.t0);case 10:case'end':return _context8.stop();}}},_callee8,_this2,[[0,7]]);})),_this.getAvailableDataTypesOptions=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(){var tempData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:try{tempData=[{value:1,label:'digital-sensor-data'},{value:2,label:'analog-sensor-data'},{value:3,label:'obd-data'}];_this.setState({availableDataTypeOptions:tempData});}catch(error){console.log(error,'API Error');}case 1:case'end':return _context9.stop();}}},_callee9,_this2);})),_this.validateSecondary=function(){var isValid=true;if(_this.state.hasSecondaryTank){if(// this.state.hasInSameTank === false ||
_this.state.secondaryTankMinValue===''||_this.state.secondaryTankMinCapacity===''||_this.state.secondaryTankMaxValue===''||_this.state.secondaryTankMaxCapacity===''||_this.state.secondaryTankTotalFuelTank===''||_this.state.secondaryFileName===''||_this.state.secondaryBucketName===''||_this.state.secondaryDownloadUrl===''){isValid=false;}}return isValid;},_this.handleSubmit=function(){var _ref16=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(event){var imeiUUIDs,DYNAMIC_TANK_PAYLOAD_KEYS,additionalTanks,_ref18,data,errors,fullData,arrList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:console.log(_this.state);_this.setState({isLoading:true});imeiUUIDs=Object.values(_this.state.selectedIMEIs).filter(function(item){return item&&item.value;}).map(function(item){return item.value;});// Multi-tank payload mapping
DYNAMIC_TANK_PAYLOAD_KEYS={tankNumber:'tankNumber',minValue:'minValue',maxValue:'maxValue',minCapacity:'minTankCapacity',maxCapacity:'maxTankCapacity',totalFuelTank:'totalFuelTank',fileName:'calibration_filename',bucketName:'bucketName'};additionalTanks=_this.state.hasSecondaryTank&&_this.state.showMultiTankConfig?_this.state.tanks.map(function(tank){var _ref17;return _ref17={},_defineProperty(_ref17,DYNAMIC_TANK_PAYLOAD_KEYS.tankNumber,tank.tankNumber),_defineProperty(_ref17,DYNAMIC_TANK_PAYLOAD_KEYS.minValue,parseInt(tank.minValue,10)),_defineProperty(_ref17,DYNAMIC_TANK_PAYLOAD_KEYS.maxValue,parseInt(tank.maxValue,10)),_defineProperty(_ref17,DYNAMIC_TANK_PAYLOAD_KEYS.minCapacity,parseInt(tank.minCapacity,10)),_defineProperty(_ref17,DYNAMIC_TANK_PAYLOAD_KEYS.maxCapacity,parseInt(tank.maxCapacity,10)),_defineProperty(_ref17,DYNAMIC_TANK_PAYLOAD_KEYS.totalFuelTank,parseInt(tank.totalFuelTank,10)),_defineProperty(_ref17,DYNAMIC_TANK_PAYLOAD_KEYS.fileName,tank.fileName),_defineProperty(_ref17,DYNAMIC_TANK_PAYLOAD_KEYS.bucketName,tank.bucketName),_ref17;}):[];_context10.next=7;return _this.props.client.mutate({mutation:__WEBPACK_IMPORTED_MODULE_18__queries__["b" /* ADD_VEHICLES */],variables:{fileInfo:{uploadFor:'uploadFileToFuelCalibrationTable',bucketName:_this.state.bucketName,fileName:_this.state.fileName,operationType:'SKIP'},secondaryFileInfo:{uploadFor:'uploadFileToFuelCalibrationTable',bucketName:_this.state.secondaryBucketName,fileName:_this.state.secondaryFileName,operationType:'SKIP'},commonInput:{clientLoginId:parseInt(_this.state.clientname,10),//partnerLoginId: getLoginId(),
// manufacturerCode: this.state.manufacturer.code
fuelInputs:{vehicleId:parseInt(_this.state.vehicleNumber,10),fuelSensorType:_this.state.sensorType,minTankCapacity:parseInt(_this.state.minCapacity,10),minValue:parseInt(_this.state.minValue,10),maxTankCapacity:parseInt(_this.state.maxCapacity,10),totalFuelTank:parseInt(_this.state.totalFuelTank,10),maxValue:parseInt(_this.state.maxValue,10),// overallThreshold: parseFloat(this.state.overallThreshold, 10),
availableDataTypes:_this.state.availableDataTypes?_this.state.availableDataTypes:[],preferedDataType:_this.state.preferedDataType?_this.state.preferedDataType.value:null,fuelSensorNames:_this.state.fuelSensorNames?_this.state.fuelSensorNames:null,fuelSensorIMEIs:imeiUUIDs.length>0?imeiUUIDs:null,// secondary tank
hasSecondaryTank:_this.state.hasSecondaryTank,hasInSameTank:_this.state.hasInSameTank,isDualSensor:_this.state.isDualSensor,useTaabiAlgo:_this.state.useTaabiAlgo?_this.state.useTaabiAlgo:null,secondaryTankFuelSensorType:_this.state.sensorType,secondaryTankMinCapacity:parseInt(_this.state.secondaryTankMinCapacity,10),secondaryTankMaxCapacity:parseInt(_this.state.secondaryTankMaxCapacity,10),secondaryTankTotalFuel:parseInt(_this.state.secondaryTankTotalFuelTank,10),secondaryTankMinValue:parseInt(_this.state.secondaryTankMinValue,10),secondaryTankMaxValue:parseInt(_this.state.secondaryTankMaxValue,10),fuelUserType:1,pilferageTolerance:parseFloat(_this.state.pilferageTolerance,10)}},// Multi-tank config
tanks:additionalTanks.length>0?additionalTanks:null},errorPolicy:'all'});case 7:_ref18=_context10.sent;data=_ref18.data;errors=_ref18.errors;_this.setState({isLoading:false});if(data){fullData=[];arrList=data.excelFileUpload.failedUploadList;JSON.parse(arrList).forEach(function(element){var rowData=[];rowData.push(element.serialNumber);rowData.push(element.error);fullData.push(rowData);});_this.setState({response:'Total Excel Records= '+data.excelFileUpload.totalExcelDataRecords+','+'Total Records Uploaded='+data.excelFileUpload.successfullyUploaded+', Total Records Failed To Upload='+data.excelFileUpload.failedToUpload+', Total Duplicate Records in Excel='+data.excelFileUpload.totalDuplicateRecords,uploadSucess:true,errorMessage:false,failList:fullData,result:true});}else{_this.setState({response:errors[0].message,errorMessage:true,uploadSucess:true});}case 12:case'end':return _context10.stop();}}},_callee10,_this2);}));return function(_x9){return _ref16.apply(this,arguments);};}(),_this.checkMinCapacityValidity=function(){var regex=new RegExp(/^[0-9]{1,3}$/);_this.setState({isminCapacityValid:regex.test(_this.state.minCapacity)||_this.state.minCapacity===''});},_this.checkMaxCapacityValidity=function(){var regex=new RegExp(/^[0-9]{2,5}$/);_this.setState({ismaxCapacityValid:regex.test(_this.state.maxCapacity)||_this.state.maxCapacity===''});},_this.checkTotalFuelTankValidity=function(){var regex=new RegExp(/^[0-9]{2,5}$/);_this.setState({isTotalFuelTankValid:regex.test(_this.state.totalFuelTank)||_this.state.totalFuelTank===''});},_this.checkMinValueValidity=function(){var regex=new RegExp(/^[0-9]{1,3}$/);_this.setState({isminValueValid:regex.test(_this.state.minValue)||_this.state.minValue===''});},_this.checkMaxValueValidity=function(){var regex=new RegExp(/^[0-9]{2,5}$/);_this.setState({ismaxValueValid:regex.test(_this.state.maxValue)||_this.state.maxValue===''});},_this.checkSecondaryTankMinCapacityValidity=function(){var regex=new RegExp(/^[0-9]{1,3}$/);_this.setState({isMinSecondaryTankCapacityValid:regex.test(_this.state.secondaryTankMinCapacity)||_this.state.secondaryTankMinCapacity===''});},_this.checkSecondaryTankMaxCapacityValidity=function(){var regex=new RegExp(/^[0-9]{2,5}$/);_this.setState({isMaxSecondaryTankCapacityValid:regex.test(_this.state.secondaryTankMaxCapacity)||_this.state.secondaryTankMaxCapacity===''});},_this.checkSecondaryTankTotalFuelTankValidity=function(){var regex=new RegExp(/^[0-9]{2,5}$/);_this.setState({isSecondaryTotalFuelTankValid:regex.test(_this.state.secondaryTankTotalFuelTank)||_this.state.secondaryTankTotalFuelTank===''});},_this.checkSecondaryTankMinValueValidity=function(){var regex=new RegExp(/^[0-9]{1,3}$/);_this.setState({isMinSecondaryTankValueValid:regex.test(_this.state.secondaryTankMinValue)||_this.state.secondaryTankMinValue===''});},_this.checkSecondaryTankMaxValueValidity=function(){var regex=new RegExp(/^[0-9]{2,5}$/);_this.setState({isMaxSecondaryTankValueValid:regex.test(_this.state.secondaryTankMaxValue)||_this.state.secondaryTankMaxValue===''});},_this.downloadBulkUpload=function(client){return function(){var _ref19=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(event){var _ref20,data,res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:_context11.next=2;return _this.props.client.query({query:__WEBPACK_IMPORTED_MODULE_18__queries__["e" /* GET_FILE_FORMAT */],variables:{bucketname:'excel-templates',filename:'Fuelcalibration.xlsx'},errorPolicy:'all'});case 2:_ref20=_context11.sent;data=_ref20.data;_context11.next=6;return __WEBPACK_IMPORTED_MODULE_9_axios___default()({url:data.getPublicDownloadURL,method:'GET',headers:{Accept:'application/vnd.ms-excel'},responseType:'blob'// important
});case 6:res=_context11.sent;__WEBPACK_IMPORTED_MODULE_12_file_saver___default.a.saveAs(new Blob([res.data]),'sample.xlsx');// FileSaver.saveAs(data.getPublicDownloadURL, 'sample.xlsx')
case 8:case'end':return _context11.stop();}}},_callee11,_this2);}));return function(_x10){return _ref19.apply(this,arguments);};}();},_this.isSelected=function(optionValue){return _this.state.availableDataTypes.includes(optionValue);},_this.handleAvailableDataTypeChange=function(selectedDataTypeOption){var selectedValues=selectedDataTypeOption.map(function(option){return option.value;});_this.setState({availableDataTypes:selectedValues});},_this.handlefuelSensorNameChange=function(selectedFuelSensorNames){var fuelSensorNames=selectedFuelSensorNames.map(function(option){return option.value;});var selectedFuelSensors=[].concat(_toConsumableArray(fuelSensorNames));// Reset selected IMEIs for removed fuel sensors
var selectedIMEIs=Object.keys(_this.state.selectedIMEIs).filter(function(sensorId){return selectedFuelSensors.includes(sensorId);}).reduce(function(result,sensorId){result[sensorId]=_this.state.selectedIMEIs[sensorId];return result;},{});_this.setState({fuelSensorNames:fuelSensorNames});_this.setState({selectedFuelSensors:selectedFuelSensors,selectedIMEIs:selectedIMEIs});},_this.handleIMEISelection=function(fuelSensorId,imeiUUID){_this.setState(function(prevState){return{selectedIMEIs:Object.assign({},prevState.selectedIMEIs,_defineProperty({},fuelSensorId,imeiUUID))};});},_this.getSelectedFuelNames=function(){var selectedOptions=_this.state.fuelSensorDetails.filter(function(option){return _this.state.fuelSensorNames.includes(option.value);});return selectedOptions;},_this.handlePreferedDataTypeChange=function(selectedDataTypeOption){_this.setState({preferedDataType:selectedDataTypeOption});},_temp),_possibleConstructorReturn(_this,_ret);}// Multi-tank configuration handlers
_createClass(FuelCalibration,[{key:'resetFields',value:function resetFields(){// Reset multi-tank config
this.setState({tanks:[{tankNumber:3,minValue:'',maxValue:'',minCapacity:'',maxCapacity:'',totalFuelTank:'',isMinCapacityValid:true,isMaxCapacityValid:true,isTotalFuelTankValid:true,fileName:'',bucketName:'',downloadUrl:'',isUploading:false}],showMultiTankConfig:false,refuelThreshold:'3',vehicleNumber:'',drainThreshold:'0.5',medianFilter:'10',pfPerMin:'3',pilferageTolerance:'10',minimumPilferageDuration:'30',userType:'0',sensorType:'',minValue:'',maxValue:'',minCapacity:'',maxCapacity:'',totalFuelTank:'',fileName:'',bucketName:'',publicUploadURL:'',downloadUrl:'',overallThreshold:'',// secondary tank
hasSecondaryTank:false,hasInSameTank:false,isDualSensor:false,secondaryTankMinCapacity:'',secondaryTankMaxCapacity:'',secondaryTankTotalFuelTank:'',secondaryTankMinValue:'',secondaryTankMaxValue:'',secondaryFileName:'',secondaryBucketName:'',secondaryPublicUploadURL:'',secondaryDownloadUrl:'',useTaabiAlgo:false,useObdAlgo:'',availableDataTypes:[],fuelSensorNames:[],selectedFuelSensors:[],selectedIMEIs:{},// fuelSensorDetails: [],
preferedDataType:null,// fuelSensorName: '',
fuelSensorAlgo:'',calibrationDataExists:false});this.setState(function(prevState){return{resetKey:prevState.resetKey+1};});}// secondary tank
},{key:'componentDidMount',value:function componentDidMount(){this.getClients(this.props.client);this.getFuelSensorAssignments();this.getFuelSensorDetails();// this.getTaabiOptions()
// this.getObdOptions()
this.getAvailableDataTypesOptions();// this.getPreferedDataTypesOptions()
}},{key:'render',value:function render(){var _this3=this;var dataTypeLabels={1:'Digital Sensor Data',2:'Analog sensor Data',3:'OBD Data'};var preferedDataTypeOptions=Array.from(new Set(this.state.availableDataTypes.flat())).map(function(value){return{label:dataTypeLabels[value],value:value};});var classes=this.props.classes;// console.log(this.state.clientNames, '///')
var isFormIncomplete=this.state.clientname===''||this.state.vehicleNumber===''||this.state.refuelThreshold===''||this.state.drainThreshold===''||this.state.medianFilter===''||this.state.pfPerMin===''||this.state.pilferageTolerance===''||this.state.minimumPilferageDuration===''||this.state.userType===''||this.state.minValue===''||this.state.minCapacity===''||this.state.maxValue===''||this.state.maxCapacity===''||this.state.totalFuelTank===''||this.state.fileName===''||this.state.bucketName===''||this.state.downloadUrl===''||this.state.sensorType===''||this.state.availableDataTypes.length===0||this.getSelectedFuelNames().length===0||this.state.preferedDataType===null||// overallThreshold === '' ||
!this.validateSecondary()||this.areDynamicTanksInvalid();return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Typography"],{variant:'subtitle1',gutterBottom:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',null,'Fuel Caliberation')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6},'Available Clients *',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default.a,{style:{minWidth:'70%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */],{classes:classes,options:this.state.clientNames// components={components}
,value:this.state.clientname,onChange:this.handleClientChange,placeholder:'Select Client *',menuContainerStyle:{zIndex:9}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:8,style:{marginTop:10}},'Available Data Types *',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_multiselect_react_dropdown___default.a,{key:this.state.resetKey,displayValue:'label',onKeyPressFn:function noRefCheck(){},onSearch:function noRefCheck(){},onRemove:this.state.calibrationDataExists?function(){}:this.handleAvailableDataTypeChange,onSelect:this.state.calibrationDataExists?function(){}:this.handleAvailableDataTypeChange,selectedValues:this.state.availableDataTypeOptions.filter(function(option){return _this3.isSelected(option.value);}),onChange:this.state.calibrationDataExists?function(){}:this.handleAvailableDataTypeChange,options:this.state.availableDataTypeOptions,placeholder:this.state.calibrationDataExists?'Cannot edit':'select option',disable:this.state.calibrationDataExists,required:true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:8,style:{marginTop:10}},'Preferred Data Type *',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{pointerEvents:this.state.calibrationDataExists?'none':'auto',position:'relative'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */],{value:this.state.preferedDataType,onChange:this.state.calibrationDataExists?function(){}:this.handlePreferedDataTypeChange,options:preferedDataTypeOptions,placeholder:this.state.calibrationDataExists?'Cannot edit':'select option',isDisabled:this.state.calibrationDataExists,styles:{control:function control(provided,state){return Object.assign({},provided,{opacity:state.isDisabled?0.6:1,pointerEvents:state.isDisabled?'none':'auto'});}},menuContainerStyle:{zIndex:9},required:true}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6},'Available Vehicles *',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default.a,{style:{minWidth:'70%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */],{classes:classes,options:this.state.vehicleDetails// components={components}
,value:this.state.vehicleNumber,onChange:this.handleChange,placeholder:'Select Vehicle *'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:8,style:{marginTop:10}},'Fuel Sensor Name *',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_multiselect_react_dropdown___default.a,{key:this.state.resetKey,displayValue:'label',onKeyPressFn:function noRefCheck(){},onSearch:function noRefCheck(){},onRemove:this.state.calibrationDataExists?function(){}:this.handlefuelSensorNameChange,onSelect:this.state.calibrationDataExists?function(){}:this.handlefuelSensorNameChange,selectedValues:this.getSelectedFuelNames(),onChange:this.state.calibrationDataExists?function(){}:this.handlefuelSensorNameChange,options:this.state.fuelSensorDetails,placeholder:this.state.calibrationDataExists?'Cannot edit':'select option',disable:this.state.calibrationDataExists,required:true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:8,style:{marginTop:10}},this.state.selectedFuelSensors.length>0&&'Fuel Sensor IMEI Associations*',this.state.selectedFuelSensors.length>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{border:'1px solid #c9c9c9',padding:'20px',borderRadius:'5px',marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,spacing:8},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Typography"],{variant:'h6',component:'div',style:{fontWeight:'bold',color:'#3f3f3f',marginBottom:'10px'}},'FUEL SENSOR NAME')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6,style:{textAlign:'right'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Typography"],{variant:'h6',component:'div',style:{fontWeight:'bold',color:'#3f3f3f',marginBottom:'10px'}},'IMEI'))),this.state.selectedFuelSensors.map(function(sensorId){var imeiOptions=_this3.state.allFuelSensorAssignments.filter(function(item){return item.fuelSensorId===sensorId&&item.status==='available';}).map(function(item){return{value:item.uuid,label:item.imeiNumber};});var sensorName=(_this3.state.fuelSensorDetails.find(function(item){return item.value===sensorId;})||{}).label||'';return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,spacing:8,key:sensorId,style:{marginTop:'10px',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6,style:{display:'flex',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Typography"],{variant:'body1'},sensorName)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */],{options:imeiOptions,value:_this3.state.selectedIMEIs[sensorId]||null,onChange:_this3.state.calibrationDataExists?function(){}:function(selectedOption){return _this3.handleIMEISelection(sensorId,selectedOption);},placeholder:_this3.state.calibrationDataExists?'Cannot edit':'Select IMEI *',isClearable:true,disabled:_this3.state.calibrationDataExists})));})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,alignItems:'stretch',className:'multitank',style:{marginTop:'20px',marginBottom:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6,md:4,style:{paddingRight:'16px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Card"],{style:{display:'flex',flexDirection:'column',height:'100%',backgroundColor:'#f8f8f8'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["CardContent"],{style:{flexGrow:1}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Typography"],{variant:'h6',component:'h2',style:{fontWeight:'bold'}},'Tank Configuration'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Typography"],{color:'textSecondary',gutterBottom:true},'Manage secondary tank and sensor settings.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Divider"],{style:{margin:'8px 0'}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,alignItems:'center',justify:'space-between'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Typography"],null,'Secondary Tank Available')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Switch"],{checked:this.state.hasSecondaryTank,onChange:function onChange(){if(!_this3.state.calibrationDataExists){var nextHasSecondary=!_this3.state.hasSecondaryTank;_this3.setState({hasSecondaryTank:nextHasSecondary,// Reset multi-tank config when disabling secondary
showMultiTankConfig:nextHasSecondary?false:false,hasInSameTank:nextHasSecondary?_this3.state.hasInSameTank:false});}},disabled:this.state.calibrationDataExists,title:this.state.calibrationDataExists?'Cannot modify when calibration data exists':''}))),this.state.hasSecondaryTank&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,alignItems:'center',justify:'space-between',style:{marginTop:'8px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Typography"],null,'Is In SameTank')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Switch"],{checked:this.state.hasInSameTank,onChange:function onChange(){if(!_this3.state.calibrationDataExists){_this3.setState({hasInSameTank:!_this3.state.hasInSameTank});}},disabled:this.state.calibrationDataExists}))),this.state.hasSecondaryTank&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,alignItems:'center',justify:'space-between',style:{marginTop:'8px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Typography"],null,'Multi-Tank Configuration Available')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Switch"],{checked:this.state.showMultiTankConfig,onChange:function onChange(){if(!_this3.state.calibrationDataExists){_this3.setState({showMultiTankConfig:!_this3.state.showMultiTankConfig});}},disabled:this.state.calibrationDataExists,title:this.state.calibrationDataExists?'Cannot modify when calibration data exists':''})))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6,md:4,style:{paddingRight:'16px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Card"],{style:{display:'flex',flexDirection:'column',height:'100%',backgroundColor:'#f8f8f8'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["CardContent"],{style:{flexGrow:1}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Typography"],{variant:'h6',component:'h2',style:{fontWeight:'bold'}},'Sensor Type'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Typography"],{color:'textSecondary',gutterBottom:true},'Select the appropriate fuel sensor type.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Divider"],{style:{margin:'8px 0'}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default.a,{component:'fieldset',disabled:this.state.calibrationDataExists},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_FormLabel___default.a,{component:'legend'},'Fuel Sensor Type:*'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_RadioGroup___default.a,{'aria-label':'sensorType',name:'sensorType',value:this.state.sensorType,onChange:this.handleChangeType,row:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_FormControlLabel___default.a,{value:'Digital_sensor',control:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Radio___default.a,null),label:'Digital Sensor'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_FormControlLabel___default.a,{value:'Analog_sensor',control:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Radio___default.a,null),label:'Analog Sensor'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Typography"],{variant:'caption',color:'textSecondary',style:{marginTop:'8px',display:'block'}},'*Cannot change if calibration data exists.')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6,md:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Card"],{style:{display:'flex',flexDirection:'column',height:'100%',backgroundColor:'#f8f8f8'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["CardContent"],{style:{flexGrow:1,display:'flex',flexDirection:'column'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Typography"],{variant:'h6',component:'h2',style:{fontWeight:'bold'}},'Calibration Data'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Typography"],{color:'textSecondary',gutterBottom:true},'Download sample to generate a fuel calibration equation.'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Divider"],{style:{margin:'8px 0'}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{flexGrow:1,display:'flex',alignItems:'center',justifyContent:'center'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{color:'secondary',variant:'contained',onClick:this.downloadBulkUpload(this.props.client),style:{width:'auto'}},'Download Sample Excel')))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__TankConfigHeader__["a" /* default */],{title:'Primary and Secondary Tank Configuration',description:'Set up and manage your primary and secondary fuel tanks. To configure the secondary tank, first enable the \'Secondary Tank Available\' toggle under Tank Configuration.',gradientType:'primary'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{justifyContent:'space-around',alignItems:'center',display:'flex',gap:'50px',flexWrap:'wrap'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__TankCard__["a" /* default */],{tankIndex:1,title:'Primary Tank',tankData:{minValue:this.state.minValue,maxValue:this.state.maxValue,minCapacity:this.state.minCapacity,maxCapacity:this.state.maxCapacity,totalFuelTank:this.state.totalFuelTank,isMinCapacityValid:this.state.isminCapacityValid,isMaxCapacityValid:this.state.ismaxCapacityValid,isTotalFuelTankValid:this.state.isTotalFuelTankValid},onTankDataChange:this.handlePrimaryTankChange,onFileUpload:this.handlePrimaryTankFileUpload,isUploading:this.state.isUploading,fileName:this.state.fileName,downloadUrl:this.state.downloadUrl,disabled:this.state.calibrationDataExists,showDeleteButton:false}),this.state.hasSecondaryTank&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__TankCard__["a" /* default */],{tankIndex:2,title:'Secondary Tank',tankData:{minValue:this.state.secondaryTankMinValue,maxValue:this.state.secondaryTankMaxValue,minCapacity:this.state.secondaryTankMinCapacity,maxCapacity:this.state.secondaryTankMaxCapacity,totalFuelTank:this.state.secondaryTankTotalFuelTank,isMinCapacityValid:this.state.isMinSecondaryTankCapacityValid,isMaxCapacityValid:this.state.isMaxSecondaryTankCapacityValid,isTotalFuelTankValid:this.state.isSecondaryTotalFuelTankValid},onTankDataChange:this.handleSecondaryTankChange,onFileUpload:this.handleSecondaryTankFileUpload,isUploading:this.state.isUploadingSecondary,fileName:this.state.secondaryFileName,downloadUrl:this.state.secondaryDownloadUrl,disabled:this.state.calibrationDataExists,showDeleteButton:false})),this.state.hasSecondaryTank&&this.state.showMultiTankConfig&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__TankConfigHeader__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,style:{marginBottom:24}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{display:'grid',gridTemplateColumns:'repeat(3, 1fr)',gridGap:'14px'}},this.state.tanks.map(function(tank,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__TankCard__["a" /* default */],{tankIndex:tank.tankNumber,tankData:tank,onTankDataChange:_this3.handleTankDataChange,onRemoveTank:_this3.handleRemoveTank,onFileUpload:_this3.handleTankFileUpload,isUploading:tank.isUploading,fileName:tank.fileName,downloadUrl:tank.downloadUrl,disabled:(_this3.state.selectedCurClientsVehicleValue?_this3.state.selectedCurClientsVehicleValue.length===0:false)||(_this3.state.curClientVehicles?_this3.state.curClientVehicles.length===0:false)||_this3.state.calibrationDataExists,permissions:_this3.state.permissions,userId:_this3.state.userId});}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,marginBottom:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{variant:'contained',onClick:this.handleAddTank,disabled:this.state.calibrationDataExists,sx:{backgroundColor:'#1b9cd5',color:'white',px:3,py:1.5,borderRadius:2,textTransform:'none',fontSize:'1rem',fontWeight:600,boxShadow:'0 4px 12px rgba(27, 156, 213, 0.3)','&:hover':{backgroundColor:'#137aa1',boxShadow:'0 6px 16px rgba(27, 156, 213, 0.4)',transform:'translateY(-1px)'},transition:'all 0.3s ease'}},'+ Add Tank'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{variant:'contained',color:'primary',className:classes.button,onClick:this.handleSubmit,disabled:isFormIncomplete||this.state.calibrationDataExists||this.state.selectedFuelSensors.some(function(sensorId){return!_this3.state.selectedIMEIs[sensorId];})},'Submit'),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{color:'default',variant:'outlined',size:'medium',margin:'normal',className:'btn',onClick:function onClick(){return _this3.props.history.goBack();}},'Cancel')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},this.state.result===true&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Dialog"],{open:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["DialogTitle"],null,'Alert'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["DialogContent"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Typography"],{variant:'subtitle1',gutterBottom:true},'Data has been saved successfully.')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["DialogActions"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:this.handleClose,color:'primary'},'Close'))),this.state.errorMessage&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Dialog"],{open:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["DialogTitle"],null,'Alert'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["DialogContent"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Typography"],{variant:'subtitle1',gutterBottom:true},this.state.response==='Something went wrong please check the file header name'?'Check the fuel calibration file uploaded':this.state.response)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["DialogActions"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:this.handleCloseError,color:'primary'},'Close'))))));}}]);return FuelCalibration;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_7__HOCs_withSharedSnackbar__["a" /* default */])(FuelCalibration))));

/***/ }),
/* 2378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Delete__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Delete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Delete__);
var styles=function styles(theme){return{// Primary Tank Styles - greyish with green hint
primaryCard:{minWidth:340,maxWidth:440,borderRadius:16,background:'linear-gradient(135deg, #f5f5f5 0%, #dfe8e2 100%)',boxShadow:'0 2px 12px rgba(0,0,0,0.12)',border:'1px solid rgba(0,0,0,0.1)',transition:'all 0.3s ease',position:'relative',margin:'12px','&:hover':{transform:'translateY(-2px)',boxShadow:'0 4px 16px rgba(0,0,0,0.2)'}},// Secondary Tank Styles - greyish with blue hint
secondaryCard:{minWidth:340,maxWidth:440,borderRadius:16,background:'linear-gradient(135deg, #f5f5f5 0%, #e2e6f0 100%)',boxShadow:'0 2px 12px rgba(0,0,0,0.12)',border:'1px solid rgba(0,0,0,0.1)',transition:'all 0.3s ease',position:'relative',margin:'12px','&:hover':{transform:'translateY(-2px)',boxShadow:'0 4px 16px rgba(0,0,0,0.2)'}},// Numbered Tank Styles (unchanged)
numberedCard:{minWidth:340,maxWidth:440,borderRadius:16,background:'linear-gradient(135deg, #f5f6f7 0%, #e9ecef 100%)',boxShadow:'0 2px 12px rgba(0,0,0,0.05)',border:'1px solid rgba(0,0,0,0.08)',transition:'all 0.3s ease',position:'relative',margin:'12px','&:hover':{transform:'translateY(-2px)',boxShadow:'0 4px 16px rgba(0,0,0,0.08)'}},// Add breathing space inside cards
cardContent:{padding:24},gridContainer:{spacing:4},disabledCard:{'&:hover':{transform:'none',boxShadow:'0 2px 8px rgba(0,0,0,0.08)'}},// Header Styles
premiumHeader:{borderBottom:'2px solid rgba(255,255,255,0.2)',background:'rgba(255,255,255,0.1)',borderRadius:'12px 12px 0 0',margin:'-16px -16px 16px -16px',padding:'16px 16px 12px 16px',backdropFilter:'blur(10px)',display:'flex',justifyContent:'space-between',alignItems:'center'},standardHeader:{borderBottom:'2px solid rgba(0,0,0,0.08)',background:'rgba(255,255,255,0.7)',borderRadius:'12px 12px 0 0',margin:'-16px -16px 16px -16px',padding:'16px 16px 12px 16px',display:'flex',justifyContent:'space-between',alignItems:'center'},headerLeft:{display:'flex',alignItems:'center',gap:12},// Typography Styles
primaryTitle:{fontWeight:700,fontSize:'1.1rem',color:'#2c3e50'},secondaryTitle:{fontWeight:700,fontSize:'1.1rem',color:'#2c3e50'},numberedTitle:{fontWeight:700,fontSize:'1.1rem',color:'#2c3e50'},// Chip Styles
primaryChip:{backgroundColor:'rgba(67,160,71,0.15)',color:'#2c3e50',fontWeight:600,fontSize:'0.8rem',// ⬆️ larger text
height:28,// ⬆️ slightly taller
borderRadius:6,// ⬇️ less round, more rectangular
padding:'0 12px',// ⬆️ more horizontal padding
display:'inline-flex',alignItems:'center'},secondaryChip:{backgroundColor:'rgba(100,149,237,0.15)',color:'#2c3e50',fontWeight:600,fontSize:'0.8rem',height:28,borderRadius:6,padding:'0 12px',display:'inline-flex',alignItems:'center'},numberedChip:{backgroundColor:'rgba(252, 182, 159, 0.2)',color:'#8B4513',fontWeight:600,fontSize:'0.8rem',height:28,borderRadius:6,padding:'0 12px',border:'1px solid rgba(252, 182, 159, 0.4)',display:'inline-flex',alignItems:'center'},// Button Styles
deleteButton:{backgroundColor:'rgba(255,255,255,0.1)',padding:8,transition:'all 0.3s ease','&:hover':{backgroundColor:'rgba(231, 76, 60, 0.1)',transform:'scale(1.1)'}},primaryDeleteButton:{color:'#2c3e50'},secondaryDeleteButton:{color:'#2c3e50'},numberedDeleteButton:{color:'#e74c3c'},// TextField Styles
textFieldRoot:{'& .MuiOutlinedInput-root':{borderRadius:12,transition:'all 0.3s ease',backgroundColor:'rgba(255,255,255,0.9)','&:hover .MuiOutlinedInput-notchedOutline':{borderWidth:2},'&.Mui-focused':{backgroundColor:'rgba(255,255,255,1)','& .MuiOutlinedInput-notchedOutline':{borderWidth:2}}},'& .MuiInputLabel-outlined':{fontWeight:500,color:'rgba(0,0,0,0.8)'},'& .MuiOutlinedInput-input':{color:'#2c3e50',fontWeight:500}},primaryTextField:{'& .MuiOutlinedInput-root':{'&:hover .MuiOutlinedInput-notchedOutline':{borderColor:'#43A047'},'&.Mui-focused .MuiOutlinedInput-notchedOutline':{borderColor:'#43A047'}}},secondaryTextField:{'& .MuiOutlinedInput-root':{'&:hover .MuiOutlinedInput-notchedOutline':{borderColor:'#1E88E5'},'&.Mui-focused .MuiOutlinedInput-notchedOutline':{borderColor:'#1E88E5'}}},numberedTextField:{'& .MuiOutlinedInput-root':{'&:hover .MuiOutlinedInput-notchedOutline':{borderColor:'#fcb69f'},'&.Mui-focused .MuiOutlinedInput-notchedOutline':{borderColor:'#fcb69f'}}},// Upload Section Styles
uploadSection:{borderRadius:16,padding:20,border:'2px dashed #e9ecef',transition:'all 0.3s ease'},premiumUploadSection:{background:'linear-gradient(145deg, #ffffff, #f8f9fa)'},standardUploadSection:{background:'linear-gradient(145deg, #ffffff, #f8f9fa)'},uploadTitle:{fontWeight:600,marginBottom:16,display:'flex',alignItems:'center'},premiumUploadTitle:{// color: 'rgba(255,255,255,0.9)'
color:'#495057'},standardUploadTitle:{color:'#495057'},uploadButton:{borderRadius:12,padding:'12px 24px',fontWeight:600,textTransform:'none',fontSize:'0.95rem',boxShadow:'0 4px 12px rgba(0,0,0,0.15)',color:'white',transition:'all 0.3s ease','&:hover':{transform:'translateY(-1px)',boxShadow:'0 6px 16px rgba(0,0,0,0.2)'}},primaryUploadButton:{backgroundColor:'#43A047','&:hover':{backgroundColor:'#388E3C'}},secondaryUploadButton:{backgroundColor:'#1E88E5','&:hover':{backgroundColor:'#1565C0'}},numberedUploadButton:{backgroundColor:'#fcb69f','&:hover':{backgroundColor:'#f4a688'}},fileStatus:{marginTop:16,textAlign:'center'},noFileText:{fontSize:'0.8rem'},premiumNoFileText:{color:'rgba(255,255,255,0.7)'},standardNoFileText:{color:'#6c757d'},successBox:{display:'flex',alignItems:'center',justifyContent:'center',backgroundColor:'rgba(40, 167, 69, 0.1)',borderRadius:8,padding:'8px 16px'},inputAdornment:{marginRight:8,fontSize:'0.9rem',fontWeight:600},primaryAdornment:{color:'#43A047'},secondaryAdornment:{color:'#1E88E5'},numberedAdornment:{color:'#fcb69f'}};};var TankCard=function TankCard(_ref){var classes=_ref.classes,tankIndex=_ref.tankIndex,tankData=_ref.tankData,onTankDataChange=_ref.onTankDataChange,onRemoveTank=_ref.onRemoveTank,onFileUpload=_ref.onFileUpload,isUploading=_ref.isUploading,fileName=_ref.fileName,downloadUrl=_ref.downloadUrl,_ref$disabled=_ref.disabled,disabled=_ref$disabled===undefined?false:_ref$disabled,title=_ref.title,_ref$showDeleteButton=_ref.showDeleteButton,showDeleteButton=_ref$showDeleteButton===undefined?true:_ref$showDeleteButton;var handleInputChange=function handleInputChange(field,value){onTankDataChange(tankIndex,field,value);};var handleFileUpload=function handleFileUpload(event){var file=event.target.files[0];if(file)onFileUpload(tankIndex,file);};// Determine tank type
var isPrimary=title==='Primary Tank';var isSecondary=title==='Secondary Tank';var isNumbered=!isPrimary&&!isSecondary;// Get appropriate class names
var getCardClass=function getCardClass(){var cardClass='';if(isPrimary)cardClass=classes.primaryCard;else if(isSecondary)cardClass=classes.secondaryCard;else cardClass=classes.numberedCard;return disabled?cardClass+' '+classes.disabledCard:cardClass;};var getTextFieldClass=function getTextFieldClass(){var baseClass=classes.textFieldRoot;if(isPrimary)return baseClass+' '+classes.primaryTextField;else if(isSecondary)return baseClass+' '+classes.secondaryTextField;else return baseClass+' '+classes.numberedTextField;};var getTitleClass=function getTitleClass(){if(isPrimary)return classes.primaryTitle;else if(isSecondary)return classes.secondaryTitle;else return classes.numberedTitle;};var getChipClass=function getChipClass(){if(isPrimary)return classes.primaryChip;else if(isSecondary)return classes.secondaryChip;else return classes.numberedChip;};var getDeleteButtonClass=function getDeleteButtonClass(){var baseClass=classes.deleteButton;if(isPrimary)return baseClass+' '+classes.primaryDeleteButton;else if(isSecondary)return baseClass+' '+classes.secondaryDeleteButton;else return baseClass+' '+classes.numberedDeleteButton;};var getAdornmentClass=function getAdornmentClass(){if(isPrimary)return classes.inputAdornment+' '+classes.primaryAdornment;else if(isSecondary)return classes.inputAdornment+' '+classes.secondaryAdornment;else return classes.inputAdornment+' '+classes.numberedAdornment;};var getUploadButtonClass=function getUploadButtonClass(){var baseClass=classes.uploadButton;if(isPrimary)return baseClass+' '+classes.primaryUploadButton;else if(isSecondary)return baseClass+' '+classes.secondaryUploadButton;else return baseClass+' '+classes.numberedUploadButton;};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Card"],{className:getCardClass()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["CardContent"],{style:{padding:16}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:isPrimary||isSecondary?classes.premiumHeader:classes.standardHeader},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.headerLeft},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:getChipClass()},isPrimary?'PRIMARY TANK':isSecondary?'SECONDARY TANK':'TANK - '+(tankData.tankNumber||tankIndex+1))),showDeleteButton&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["IconButton"],{onClick:function onClick(){return onRemoveTank(tankIndex);},disabled:disabled,className:getDeleteButtonClass(),style:{padding:8}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Delete___default.a,{fontSize:'small'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Grid"],{container:true,spacing:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Grid"],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TextField"],{label:'Minimum Value',variant:'outlined',value:tankData.minValue!==undefined&&tankData.minValue!==null?tankData.minValue:'',onChange:function onChange(e){return handleInputChange('minValue',e.target.value);},fullWidth:true,type:'number',required:true,disabled:disabled,className:getTextFieldClass(),InputProps:{startAdornment:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MinLevelIcon,{style:{color:isPrimary?'#43A047':isSecondary?'#1E88E5':'#fcb69f',marginRight:8,fontSize:'1.2rem'}})}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Grid"],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TextField"],{label:'Maximum Value',variant:'outlined',value:tankData.maxValue!==undefined&&tankData.maxValue!==null?tankData.maxValue:'',onChange:function onChange(e){return handleInputChange('maxValue',e.target.value);},fullWidth:true,type:'number',required:true,disabled:disabled,className:getTextFieldClass(),InputProps:{startAdornment:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MaxLevelIcon,{style:{color:isPrimary?'#43A047':isSecondary?'#1E88E5':'#fcb69f',marginRight:8,fontSize:'1.2rem'}})}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Grid"],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TextField"],{label:'Min Tank Capacity',variant:'outlined',value:tankData.minCapacity!==undefined&&tankData.minCapacity!==null?tankData.minCapacity:'',onChange:function onChange(e){return handleInputChange('minCapacity',e.target.value);},fullWidth:true,type:'number',required:true,disabled:disabled,error:!tankData.isMinCapacityValid,helperText:!tankData.isMinCapacityValid?'Min capacity: 1-999':'',className:getTextFieldClass(),InputProps:{startAdornment:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TankIcon,{style:{color:isPrimary?'#43A047':isSecondary?'#1E88E5':'#fcb69f',marginRight:8,fontSize:'1.2rem'}})}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Grid"],{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TextField"],{label:'Max Tank Capacity',variant:'outlined',value:tankData.maxCapacity!==undefined&&tankData.maxCapacity!==null?tankData.maxCapacity:'',onChange:function onChange(e){return handleInputChange('maxCapacity',e.target.value);},fullWidth:true,type:'number',required:true,disabled:disabled,error:!tankData.isMaxCapacityValid,helperText:!tankData.isMaxCapacityValid?'Max capacity: 10-99,999':'',className:getTextFieldClass(),InputProps:{startAdornment:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TankMaxIcon,{style:{color:isPrimary?'#43A047':isSecondary?'#1E88E5':'#fcb69f',marginRight:8,fontSize:'1.2rem'}})}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["TextField"],{label:'Total Fuel Tank Capacity',variant:'outlined',value:tankData.totalFuelTank!==undefined&&tankData.totalFuelTank!==null?tankData.totalFuelTank:'',onChange:function onChange(e){return handleInputChange('totalFuelTank',e.target.value);},fullWidth:true,type:'number',required:true,disabled:disabled,error:!tankData.isTotalFuelTankValid,helperText:!tankData.isTotalFuelTankValid?'Total capacity: 10-99,999':'',className:getTextFieldClass(),InputProps:{startAdornment:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FuelIcon,{style:{color:isPrimary?'#43A047':isSecondary?'#1E88E5':'#fcb69f',marginRight:8,fontSize:'1.2rem'}})}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.uploadSection+' '+(isPrimary||isSecondary?classes.premiumUploadSection:classes.standardUploadSection)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Typography"],{variant:'subtitle2',className:classes.uploadTitle+' '+(isPrimary||isSecondary?classes.premiumUploadTitle:classes.standardUploadTitle)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DocumentIcon,{style:{fontSize:'1.1rem',marginRight:8}}),'Upload Calibration File'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{accept:'.xlsx,.xls',style:{display:'none'},id:'tank-file-'+tankIndex,type:'file',onChange:handleFileUpload,disabled:disabled}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:'tank-file-'+tankIndex},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Button"],{variant:'contained',component:'span',disabled:disabled||isUploading,fullWidth:true,className:getUploadButtonClass()},isUploading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["CircularProgress"],{size:20,style:{marginRight:12,color:'white'}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CloudUploadIcon,{style:{marginRight:12,fontSize:'1.2rem'}}),isUploading?'Uploading File...':'Choose Calibration File')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.fileStatus},!fileName?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Typography"],{variant:'caption',className:classes.noFileText+' '+(isPrimary||isSecondary?classes.premiumNoFileText:classes.standardNoFileText)},'Supported formats: XLS, XLSX \u2022 Max size: 10MB'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.successBox},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CheckIcon,{style:{color:'#28a745',fontSize:'1rem',marginRight:8}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Typography"],{style:{color:'#28a745',fontWeight:600,marginRight:8}},'File uploaded successfully'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Button"],{size:'small',href:downloadUrl,target:'_blank',style:{color:'#007bff',textTransform:'none',fontWeight:600,fontSize:'0.8rem',padding:'2px 8px',minWidth:'auto'}},'View File'))))))));};// Custom Icons (compatible with Material-UI v1)
function CloudUploadIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["SvgIcon"],props,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14 0 17.31 2.69 20 6 20h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z'}));}function TankIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["SvgIcon"],Object.assign({},props,{viewBox:'0 0 24 24'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M12 2C10.34 2 9 3.34 9 5V6H7C5.34 6 4 7.34 4 9V19C4 20.66 5.34 22 7 22H17C18.66 22 20 20.66 20 19V9C20 7.34 18.66 6 17 6H15V5C15 3.34 13.66 2 12 2ZM12 4C12.55 4 13 4.45 13 5V6H11V5C11 4.45 11.45 4 12 4ZM7 8H17C17.55 8 18 8.45 18 9V19C18 19.55 17.55 20 17 20H7C6.45 20 6 19.55 6 19V9C6 8.45 6.45 8 7 8Z'}));}function FuelIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["SvgIcon"],Object.assign({},props,{viewBox:'0 0 24 24'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M19.77 7.23L19.78 7.22L16.06 3.5C15.67 3.11 15.04 3.11 14.65 3.5C14.26 3.89 14.26 4.52 14.65 4.91L16.73 7H8C6.9 7 6 7.9 6 9V15C6 16.1 6.9 17 8 17H9V19C9 20.1 9.9 21 11 21H13C14.1 21 15 20.1 15 19V17H16C17.1 17 18 16.1 18 15V10.27L19.78 8.49C20.17 8.1 20.17 7.47 19.77 7.23Z'}));}function DocumentIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["SvgIcon"],Object.assign({},props,{viewBox:'0 0 24 24'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20Z'}));}function CheckIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["SvgIcon"],Object.assign({},props,{viewBox:'0 0 24 24'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z'}));}// New icons for MIN/MAX level and Max Tank Capacity
function MinLevelIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["SvgIcon"],Object.assign({},props,{viewBox:'0 0 24 24'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M12 20l-4-4h8l-4 4zM4 4h16v2H4z'}));}function MaxLevelIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["SvgIcon"],Object.assign({},props,{viewBox:'0 0 24 24'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M12 4l4 4H8l4-4zM4 18h16v2H4z'}));}function TankMaxIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["SvgIcon"],Object.assign({},props,{viewBox:'0 0 24 24'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M12 2C10.34 2 9 3.34 9 5V6H7C5.34 6 4 7.34 4 9V19C4 20.66 5.34 22 7 22H17C18.66 22 20 20.66 20 19V9C20 7.34 18.66 6 17 6H15V5C15 3.34 13.66 2 12 2Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M6 15H18V19C18 19.55 17.55 20 17 20H7C6.45 20 6 19.55 6 19V15Z'}));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__["withStyles"])(styles)(TankCard));

/***/ }),
/* 2379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var TankConfigHeader=function TankConfigHeader(_ref){var title=_ref.title,description=_ref.description,gradientType=_ref.gradientType;var primaryGradient='linear-gradient(135deg, #A5D6A7 0%, #ffffff 100%)';var secondaryGradient='linear-gradient(135deg, #F4A688 0%, #ffffff 100%)';var selectedGradient=gradientType==='primary'?primaryGradient:secondaryGradient;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{background:selectedGradient,borderRadius:8,padding:24,border:'1px solid #e0e0e0'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:8}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Typography"],{variant:'h5',color:'primary',style:{fontWeight:'bold'}},title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Typography"],{variant:'body2',color:'textSecondary',gutterBottom:true},description)));};TankConfigHeader.propTypes={title:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,description:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,gradientType:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['primary','secondary'])};TankConfigHeader.defaultProps={title:'Additional Tanks Configuration',description:'Configure additional fuel tanks (Tank 3 onwards) with individual calibration files.',gradientType:'secondary'};/* harmony default export */ __webpack_exports__["a"] = (TankConfigHeader);

/***/ }),
/* 2380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query allClientDetails($partnerLoginId: Int) {\n    clients: allClientDetails(partnerLoginId: $partnerLoginId) {\n      id\n      clientName\n      loginId\n    }\n  }\n'],['\n  query allClientDetails($partnerLoginId: Int) {\n    clients: allClientDetails(partnerLoginId: $partnerLoginId) {\n      id\n      clientName\n      loginId\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query getAllVehicleDetails($clientLoginId: Int, $obdOnly: Boolean) {\n    getAllVehicleDetails(clientLoginId: $clientLoginId, obdOnly: $obdOnly) {\n      entityId\n      vehicleNumber\n      deviceDetail {\n        uniqueDeviceId\n      }\n    }\n  }\n'],['\n  query getAllVehicleDetails($clientLoginId: Int, $obdOnly: Boolean) {\n    getAllVehicleDetails(clientLoginId: $clientLoginId, obdOnly: $obdOnly) {\n      entityId\n      vehicleNumber\n      deviceDetail {\n        uniqueDeviceId\n      }\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation updateDevicePidCommandsTable(\n    $uniqueId: String!\n    $device_password: String!\n  ) {\n    updateDevicePidCommandsTable(\n      device_uniqueId: $uniqueId\n      device_command: $device_password\n    ) {\n      message\n    }\n  }\n'],['\n  mutation updateDevicePidCommandsTable(\n    $uniqueId: String!\n    $device_password: String!\n  ) {\n    updateDevicePidCommandsTable(\n      device_uniqueId: $uniqueId\n      device_command: $device_password\n    ) {\n      message\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query getConfigureCommandStatus($uniqueId: String!, $responseId: Int!) {\n    getConfigureCommandStatus(uniqueid: $uniqueId, id: $responseId) {\n      status\n      pids\n      description\n    }\n  }\n'],['\n  query getConfigureCommandStatus($uniqueId: String!, $responseId: Int!) {\n    getConfigureCommandStatus(uniqueid: $uniqueId, id: $responseId) {\n      status\n      pids\n      description\n    }\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  mutation updatePidsToDeviceCommandsTable(\n    $uniqueId: String!\n    $device_password: String!\n    $pids: [String!]\n  ) {\n    updatePidsToDeviceCommandsTable(\n      uniqueId: $uniqueId\n      device_password: $device_password\n      pids: $pids\n    ) {\n      message\n    }\n  }\n'],['\n  mutation updatePidsToDeviceCommandsTable(\n    $uniqueId: String!\n    $device_password: String!\n    $pids: [String!]\n  ) {\n    updatePidsToDeviceCommandsTable(\n      uniqueId: $uniqueId\n      device_password: $device_password\n      pids: $pids\n    ) {\n      message\n    }\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  query getPidsConfigureStatus($uniqueId: String!, $pidResponseId: Int!) {\n    getPidsConfigureStatus(uniqueid: $uniqueId, id: $pidResponseId) {\n      status\n    }\n  }\n'],['\n  query getPidsConfigureStatus($uniqueId: String!, $pidResponseId: Int!) {\n    getPidsConfigureStatus(uniqueid: $uniqueId, id: $pidResponseId) {\n      status\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// import { lighten } from '@material-ui/core/styles/colorManipulator'
var GET_CLIENTS=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject);var GET_ALL_VEHICLES=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject2);var PUSH_DEVICE_COMMAND=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject3);var GET_ALL_PIDS=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject4);var PUSH_PIDS_DEVICE=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject5);var GET_PIDS_RESPONSE=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject6);var style=function style(theme){return{root:{width:'100%',padding:theme.spacing.unit*4,flexGrow:1},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary,height:140,width:100},iconSmall:{fontSize:20},selstyle:{maxHeight:ITEM_HEIGHT*4.5+ITEM_PADDING_TOP,width:250},formControl:{margin:theme.spacing.unit*3},group:{margin:theme.spacing.unit+'px 0'}};};var ITEM_HEIGHT=48;var ITEM_PADDING_TOP=8;var rows=[{id:'pid',numeric:false,disablePadding:true,label:'PID'},{id:'Description',numeric:true,disablePadding:false,label:'DESCRIPTION'}];var EnhancedTableHead=function(_React$Component){_inherits(EnhancedTableHead,_React$Component);function EnhancedTableHead(){var _ref;var _temp,_this,_ret;_classCallCheck(this,EnhancedTableHead);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=EnhancedTableHead.__proto__||Object.getPrototypeOf(EnhancedTableHead)).call.apply(_ref,[this].concat(args))),_this),_this.createSortHandler=function(property){return function(event){_this.props.onRequestSort(event,property);};},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(EnhancedTableHead,[{key:'render',value:function render(){var _props=this.props,onSelectAllClick=_props.onSelectAllClick,numSelected=_props.numSelected,rowCount=_props.rowCount;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["TableHead"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["TableRow"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["TableCell"],{padding:'checkbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["Checkbox"],{indeterminate:numSelected>0&&numSelected<rowCount,checked:numSelected===rowCount,onChange:onSelectAllClick})),console.log(rows,'rows'),rows.map(function(row){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["TableCell"],{key:row.id,align:row.numeric?'right':'inherit',padding:row.disablePadding?'none':'default'},row.label);},this)));}}]);return EnhancedTableHead;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);EnhancedTableHead.propTypes={numSelected:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number.isRequired,onSelectAllClick:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,rowCount:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number.isRequired// const toolbarStyles = theme => ({
//   root: {
//     paddingRight: theme.spacing.unit
//   },
//   highlight: {
//     color: theme.palette.secondary.main,
//     backgroundColor: lighten(theme.palette.secondary.light, 0.85)
//   },
//   spacer: {
//     flex: '1 1 100%'
//   },
//   actions: {
//     color: theme.palette.text.secondary
//   },
//   title: {
//     flex: '0 0 auto'
//   }
// })
};var EnhancedTableToolbar=function EnhancedTableToolbar(props){var numSelected=props.numSelected,classes=props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["Toolbar"],{className:__WEBPACK_IMPORTED_MODULE_8_classnames___default()(classes.root,_defineProperty({},classes.highlight,numSelected>0))});};EnhancedTableToolbar.propTypes={classes:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired,numSelected:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number.isRequired// const WrappedEnhancedTableToolbar = withStyles(toolbarStyles)(
//   EnhancedTableToolbar
// )
};var PidsConfiguration=function(_Component){_inherits(PidsConfiguration,_Component);function PidsConfiguration(){var _ref2,_this3=this;var _temp2,_this2,_ret2;_classCallCheck(this,PidsConfiguration);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this2=_possibleConstructorReturn(this,(_ref2=PidsConfiguration.__proto__||Object.getPrototypeOf(PidsConfiguration)).call.apply(_ref2,[this].concat(args))),_this2),_this2.state={spacing:'16',name:[],fullData:[],clientNameInfo:[],clientNames:[],clientName:'',clientLoginId:'',vehiclenames:'',deviceUniqueId:'',responseId:'',clientNameLoginId:[],entityIdTemp:[],loading:false,pids:[],description:[],responseStatus:'',selPids:[],pidResponseId:'',responsePidStatus:'',loadingPid:false,selected:[],page:0,rowsPerPage:5,searchValue:'',pidsArr:[]},_this2.getAllCustomers=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var customers,clientName,clientLoginId,allClients;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this2.props.client.query({query:GET_CLIENTS,variables:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_4__utils_getLoginId__["a" /* default */])()},fetchPolicy:'network-only'});case 2:customers=_context.sent;if(customers&&customers.data){clientName=[];clientLoginId=[];customers.data.clients.forEach(function(element){clientName.push(element.clientName);clientLoginId.push(element.loginId);});_this2.setState({clientNameInfo:clientName,clientLoginIdInfo:clientLoginId});allClients=customers.data.clients.map(function(client){return{value:client.loginId,label:client.clientName};});_this2.setState({clientNames:allClients});}case 4:case'end':return _context.stop();}}},_callee,_this3);})),_this2.clientLoginIdTemp='',_this2.handleChange=function(event){// let key = this.state.clientNameInfo.indexOf(event.target.value)
// console.log(event, 'event')
_this2.setState({clientName:event.label,clientLoginId:event.value},function(){_this2.getAllVehicleDetails(_this2.state.clientLoginId)();// iife
// console.log(this.state.clientName, 'client')
});},_this2.handleChangeVehicle=function(event){_this2.setState({deviceUniqueId:event.value,vehicleName:event.label});},_this2.getAllVehicleDetails=function(val){return _asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var _ref5,data,vehicleName,uniqueDeviceId,allVehicles;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this2.props.client.query({query:GET_ALL_VEHICLES,variables:{clientLoginId:val,obdOnly:true},fetchPolicy:'network-only'});case 2:_ref5=_context2.sent;data=_ref5.data;if(data&&data.getAllVehicleDetails){vehicleName=[];uniqueDeviceId=[];data.getAllVehicleDetails.forEach(function(element){vehicleName.push(element.vehicleNumber);uniqueDeviceId.push(element.deviceDetail.uniqueDeviceId);});allVehicles=data.getAllVehicleDetails.map(function(vlpn){return{value:vlpn.deviceDetail.uniqueDeviceId,label:vlpn.vehicleNumber};});// console.log(allVehicles, 'allvehi')
_this2.setState({vehiclenames:allVehicles});}case 5:case'end':return _context2.stop();}}},_callee2,_this3);}));},_this2.handleSubmit=function(client){return function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(event){var _ref7,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:event.preventDefault();_context3.next=3;return client.mutate({mutation:PUSH_DEVICE_COMMAND,variables:{uniqueId:_this2.state.deviceUniqueId,device_password:'aquila123'// refetchQueries: [`getAllVehicleDetails`]
}});case 3:_ref7=_context3.sent;data=_ref7.data;// console.log(data, 'data')
if(data!==null){_this2.setState({responseId:data.updateDevicePidCommandsTable.message});_this2.setupPolling();_this2.startPolling();}else{_this2.setState({failure:true});_this2.props.openSnackbar('Failed to push the command');}case 6:case'end':return _context3.stop();}}},_callee3,_this3);}));return function(_x){return _ref6.apply(this,arguments);};}();},_this2.handleConfigure=function(client){return function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(event){var _ref9,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:event.preventDefault();_context4.next=3;return client.mutate({mutation:PUSH_PIDS_DEVICE,variables:{uniqueId:_this2.state.deviceUniqueId,device_password:'aquila123',pids:_this2.state.selected// refetchQueries: [`getAllVehicleDetails`]
}});case 3:_ref9=_context4.sent;data=_ref9.data;// console.log(data, 'data')
if(data!==null){_this2.setState({pidResponseId:data.updatePidsToDeviceCommandsTable.message});_this2.setupPidsPolling();_this2.startPidsPolling();}else{_this2.setState({failure:true});_this2.props.openSnackbar('Failed to push Pids');}case 6:case'end':return _context4.stop();}}},_callee4,_this3);}));return function(_x2){return _ref8.apply(this,arguments);};}();},_this2.setupPolling=function(){_this2.allpids=_this2.props.client.watchQuery({query:GET_ALL_PIDS,variables:{responseId:parseInt(_this2.state.responseId,10),uniqueId:_this2.state.deviceUniqueId},pollInterval:30000,fetchPolicy:'network-only'});},_this2.startPolling=function(){_this2.allpids.subscribe({next:function next(_ref10){var data=_ref10.data,loading=_ref10.loading;if(loading){_this2.setState({loading:true});}else{_this2.setState({responseStatus:data.getConfigureCommandStatus[0].status},function(){// this.mapToArr()
// console.log(data.getConfigureCommandStatus[0].pids, 'pidssdata')
if(data.getConfigureCommandStatus[0].status==='Success'){_this2.stopPolling();_this2.setState({pids:data.getConfigureCommandStatus[0].pids,description:data.getConfigureCommandStatus[0].description,loading:false},function(){// console.log(this.state.description, 'kat')
// this.mapToArr()
_this2.convertArraytoObject();});}else{_this2.setState({loading:true});if(_this2.state.responseStatus==='Active'){_this2.setState({responseStatus:'Command inserted into DB'});}else if(_this2.state.responseStatus==='Inprogress'){_this2.setState({responseStatus:'Command pushed to device'});}else if(_this2.state.responseStatus==='Timed Out'||_this2.state.responseStatus==='Failure'){_this2.stopPolling();_this2.props.openSnackbar('Failed to push command, please try again');}}});}}});},_this2.stopPolling=function(){return _this2.allpids.stopPolling();},_this2.setupPidsPolling=function(){_this2.pushPids=_this2.props.client.watchQuery({query:GET_PIDS_RESPONSE,variables:{pidResponseId:parseInt(_this2.state.pidResponseId,10),uniqueId:_this2.state.deviceUniqueId},pollInterval:30000,fetchPolicy:'network-only'});},_this2.startPidsPolling=function(){_this2.pushPids.subscribe({next:function next(_ref11){var data=_ref11.data,loading=_ref11.loading;if(loading){_this2.setState({loadingPid:true});}else{_this2.setState({responsePidStatus:data.getPidsConfigureStatus[0].status},function(){// this.mapToArr()
// console.log(this.state.pidsData, 'pidssdata')
if(data.getPidsConfigureStatus[0].status==='Success'){_this2.setState({loadingPid:false});_this2.stopPidsPolling();_this2.props.openSnackbar('Pids configured Successfuly');}else{_this2.setState({loadingPid:true});if(_this2.state.responsePidStatus==='Active'){_this2.setState({responsePidStatus:'Command inserted into DB'});}else if(_this2.state.responsePidStatus==='Inprogress'){_this2.setState({responsePidStatus:'Command pushed to device'});}else if(_this2.state.responsePidStatus==='Timed Out'||_this2.state.responsePidStatus==='Failure'){_this2.stopPidsPolling();_this2.props.openSnackbar('Failed configure pids, please try again');}}});}}});},_this2.stopPidsPolling=function(){return _this2.pushPids.stopPolling();},_this2.componentWillUnmount=function(){if(_this2.allpids!==undefined){_this2.stopPolling();}if(_this2.pushPids!==undefined){_this2.stopPidsPolling();}},_this2.mapToArr=function(){var rowDataLast=[];// this.state.pids.forEach((element, index) => {
// console.log('table', this.state.pids, this.state.description)
for(var i=0;i<=_this2.state.pids.length;i++){if(_this2.state.pids[i]!==''&&_this2.state.pids[i]!==undefined){var rowData;(function(){// console.log('table', this.state.pids[i], this.state.description[i])
rowData=[];var pid=_this2.state.pids[i];rowData.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["Checkbox"],{onClick:function onClick(){_this2.selectVehicle(pid);}}));rowData.push(_this2.state.pids[i]);rowData.push(_this2.state.description[i].toString());rowDataLast.push(rowData);})();}}_this2.setState({fullData:rowDataLast});},_this2.pidsArr=[],_this2.selectVehicle=function(value){// console.log(value, 'value')
var selPidArr=[];if(_this2.pidsArr.length>0){var indexTemp=_this2.pidsArr.indexOf(value);if(indexTemp<0){_this2.pidsArr.push(value);_this2.pidsArr.forEach(function(val){selPidArr.push(val);});_this2.setState({selPids:selPidArr},function(){// console.log('selPids', this.state.selPids)
});}else{_this2.pidsArr.splice(indexTemp,1);_this2.pidsArr.forEach(function(val){selPidArr.push(val);});_this2.setState({selPids:selPidArr},function(){// console.log('selPids', this.state.selPids)
});}}else{_this2.pidsArr.push(value);_this2.pidsArr.forEach(function(val){selPidArr.push(val);});_this2.setState({selPids:selPidArr},function(){console.log('selPids',_this2.state.selPids);});}// console.log('selPids', this.state.selPids)
},_this2.convertArraytoObject=function(){// console.log('sdhbfjd')
var pidObj=[];for(var i=0;i<_this2.state.pids.length;i++){if(_this2.state.pids[i]!==''){pidObj.push({pid:_this2.state.pids[i],desc:_this2.state.description[i]});}}// console.log('mee', pidObj)
_this2.setState({pidsArr:pidObj});},_this2.handleClick=function(event,id){var selected=_this2.state.selected;var selectedIndex=selected.indexOf(id);var newSelected=[];if(selectedIndex===-1){newSelected=newSelected.concat(selected,id);}else if(selectedIndex===0){newSelected=newSelected.concat(selected.slice(1));}else if(selectedIndex===selected.length-1){newSelected=newSelected.concat(selected.slice(0,-1));}else if(selectedIndex>0){newSelected=newSelected.concat(selected.slice(0,selectedIndex),selected.slice(selectedIndex+1));}_this2.setState({selected:newSelected},function(){console.log(_this2.state.selected,'selected');});},_this2.handleChangePage=function(event,page){_this2.setState({page:page});},_this2.handleChangeRowsPerPage=function(event){_this2.setState({rowsPerPage:event.target.value});},_this2.isSelected=function(id){return _this2.state.selected.indexOf(id)!==-1;},_this2.handleSearchChange=function(e){return _this2.setState({searchValue:e.target.value});},_this2.findArrayElementByTitle=function(array,title){var assignedArr=[];array.forEach(function(n){assignedArr.push(n);});var status=assignedArr.includes(title);return status;},_this2.handleSelectAllClick=function(event){if(event.target.checked){_this2.setState(function(state){return{selected:_this2.state.pidsArr.map(function(n){return n.pid;})};});}else{_this2.setState({selected:[]});}},_temp2),_possibleConstructorReturn(_this2,_ret2);}_createClass(PidsConfiguration,[{key:'componentDidMount',value:function componentDidMount(){this.getAllCustomers();}// pushing pids to db and device
// new
},{key:'render',// new ends
value:function render(){var _this4=this;var classes=this.props.classes;var _state=this.state,spacing=_state.spacing,selected=_state.selected,rowsPerPage=_state.rowsPerPage,page=_state.page;var emptyRows=rowsPerPage-Math.min(rowsPerPage,this.state.pids.length-page*rowsPerPage);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'Pid\'s Configuration'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["Grid"],{container:true,spacing:16,direction:'row',justify:'center',alignItems:'center',style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["Grid"],{container:true,justify:'center',spacing:Number(spacing)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["Grid"],{item:true,style:{minWidth:'30%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */],{classes:classes,options:this.state.clientNames// components={components}
,value:this.state.clientLoginId,onChange:this.handleChange,placeholder:'Select Customer'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["Grid"],{item:true,style:{minWidth:'30%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */],{classes:classes,options:this.state.vehiclenames// components={components}
,value:this.state.deviceUniqueId,onChange:this.handleChangeVehicle,placeholder:'Select Vehicle'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["Grid"],{item:true}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["Button"],{variant:'contained',color:'secondary',size:'medium',margin:'normal',className:'btn',type:'button',onClick:this.handleSubmit(this.props.client),disabled:this.state.deviceUniqueId===''||this.state.clientLoginId===''},'Submit'),this.state.loading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["Typography"],{color:'error',variant:'subtitle1'},this.state.responseStatus),this.state.responseStatus==='Success'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["Grid"],{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["Input"],{value:this.state.searchValue,onChange:this.handleSearchChange,placeholder:'Search Pids'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["Table"],{className:classes.table,'aria-labelledby':'tableTitle'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(EnhancedTableHead,{numSelected:selected.length,onSelectAllClick:this.handleSelectAllClick,rowCount:this.state.pidsArr.length}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["TableBody"],null,this.state.pidsArr.filter(function(pid){return pid.pid.includes(_this4.state.searchValue);}).slice(page*rowsPerPage,page*rowsPerPage+rowsPerPage).map(function(n){var isSelected=_this4.isSelected(n.pid);isSelected=_this4.findArrayElementByTitle(selected,n.pid);// this.state.description.map(d => {
// console.log(n, 'pids')
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["TableRow"],{hover:true,onClick:function onClick(event){return _this4.handleClick(event,n.pid);},role:'checkbox','aria-checked':isSelected,tabIndex:-1,key:n.pid,selected:isSelected},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["TableCell"],{padding:'checkbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["Checkbox"],{checked:isSelected})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["TableCell"],{component:'th',scope:'row',padding:'none'},n.pid),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["TableCell"],{align:'right'},n.desc));// })
}),emptyRows>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["TableRow"],{style:{height:49*emptyRows}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["TableCell"],{colSpan:6})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["TablePagination"],{component:'div',count:this.state.pidsArr.length,rowsPerPage:rowsPerPage,page:page,backIconButtonProps:{'aria-label':'Previous Page'},nextIconButtonProps:{'aria-label':'Next Page'},onChangePage:this.handleChangePage,onChangeRowsPerPage:this.handleChangeRowsPerPage}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["Button"],{variant:'contained',color:'secondary',size:'medium',margin:'normal',className:'btn',type:'button',onClick:this.handleConfigure(this.props.client),disabled:this.state.selected.length===0||this.state.clientLoginId===''||this.state.deviceUniqueId===''},'Configure'),this.state.loadingPid&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["Typography"],{color:'error',variant:'subtitle1'},this.state.responsePidStatus)))));}}]);return PidsConfiguration;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);PidsConfiguration.propTypes={classes:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired,closeModal:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_6__HOCs_withSharedSnackbar__["a" /* default */])(PidsConfiguration))));

/***/ }),
/* 2381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_pickers__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles_zIndex__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles_zIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles_zIndex__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\nquery getLatestVehicleAnalyticData($clientLoginId: Int, $from_ts: String, $to_ts: String) {\n  getLatestVehicleAnalyticData(clientLoginId: $clientLoginId, from_ts: $from_ts, to_ts: $to_ts) {\n    vehicleNumber\n    Date\n    UniqueId\n    TotalNumberofPackets\n    IgOnTrackingPackets\n    IgOffTrackingPackets\n    IgONInterval\n    IgOFFInterval\n    IgnitionONDataLossTime\n    IgnitionONDataLoss\n    IgnitionOFFDataLossTime\n    IgnitionOFFDataLoss\n    TotalIgnitionONTime\n    TotalIgnitionOffTime\n    MainPowerConnectedPackets\n    MainPowerDisconnectedPackets\n    LivePacketsCount\n    LivePacket\n    GPSValidDataCount\n    GPSInvalidDataCount\n    ValidData\n    InvalidwithIgnitionOn\n    InvalidwithIgnitionOff\n    HistoryPacketsCount \n    __typename\n  }\n}\n'],['\nquery getLatestVehicleAnalyticData($clientLoginId: Int, $from_ts: String, $to_ts: String) {\n  getLatestVehicleAnalyticData(clientLoginId: $clientLoginId, from_ts: $from_ts, to_ts: $to_ts) {\n    vehicleNumber\n    Date\n    UniqueId\n    TotalNumberofPackets\n    IgOnTrackingPackets\n    IgOffTrackingPackets\n    IgONInterval\n    IgOFFInterval\n    IgnitionONDataLossTime\n    IgnitionONDataLoss\n    IgnitionOFFDataLossTime\n    IgnitionOFFDataLoss\n    TotalIgnitionONTime\n    TotalIgnitionOffTime\n    MainPowerConnectedPackets\n    MainPowerDisconnectedPackets\n    LivePacketsCount\n    LivePacket\n    GPSValidDataCount\n    GPSInvalidDataCount\n    ValidData\n    InvalidwithIgnitionOn\n    InvalidwithIgnitionOff\n    HistoryPacketsCount \n    __typename\n  }\n}\n']),_templateObject2=_taggedTemplateLiteral(['\n  query allClientDetails($partnerLoginId: Int) {\n    clients: allClientDetails(partnerLoginId: $partnerLoginId) {\n      id\n      clientName\n      loginId\n    }\n  }\n'],['\n  query allClientDetails($partnerLoginId: Int) {\n    clients: allClientDetails(partnerLoginId: $partnerLoginId) {\n      id\n      clientName\n      loginId\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// noDataInMinutes -  Needs to brainstrom and add this in schema
var GET_DEVICE_REPORT=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject);var GET_CLIENTS=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject2);var today=new Date();today.setDate(today.getDate()-1);var style=function style(theme){return{root:{width:'100%',padding:theme.spacing.unit*4,flexGrow:1},formControl:{margin:theme.spacing.unit*3},textField:{width:200},muiStyle:{marginTop:theme.spacing.unit*4},errorMsg:{marginTop:theme.spacing.unit*4}};};var DeviceDataKpi=function(_Component){_inherits(DeviceDataKpi,_Component);function DeviceDataKpi(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,DeviceDataKpi);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DeviceDataKpi.__proto__||Object.getPrototypeOf(DeviceDataKpi)).call.apply(_ref,[this].concat(args))),_this),_this.state={enableSubmit:false,loading:false,responseStatus:"Loading...",selectedDate:'',selectedFromDate:'',selectedToDate:'',clientNameInfo:[],clientNames:[],clientLoginId:'',clientName:'',selectedDateForformat:null,selectedDateToformat:null,errorMsgDisplay:false},_this.columns=['vehicleNumber','Date','UniqueId','TotalNumberofPackets','IgOnTrackingPackets','IgOffTrackingPackets','IgONInterval','IgOFFInterval','IgnitionONDataLossTime','IgnitionONDataLoss (%)','IgnitionOFFDataLossTime','IgnitionOFFDataLoss (%)','TotalIgnitionONTime','TotalIgnitionOffTime','MainPowerConnectedPackets','MainPowerDisconnectedPackets','LivePacketsCount','LivePacket (%)','GPSValidDataCount','GPSInvalidDataCount','ValidData (%)','InvalidwithIgnitionOn','InvalidwithIgnitionOff','HistoryPacketsCount'],_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15,headerStyle:{zIndex:-1}},_this.fromDateChange=function(e){var unixTimestamp=__WEBPACK_IMPORTED_MODULE_8_moment___default()(e,'YYYY-MM-DD').startOf('day').unix();var unixToString=unixTimestamp.toString();_this.setState({selectedDateForformat:e});_this.setState({selectedFromDate:unixToString});},_this.toDateChange=function(e){var unixTimestamp=__WEBPACK_IMPORTED_MODULE_8_moment___default()(e,'YYYY-MM-DD').startOf('day').unix();var unixToString=unixTimestamp.toString();_this.setState({selectedDateToformat:e});_this.setState({selectedToDate:unixToString});},_this.getFormattedDate=function(timestamp){return __WEBPACK_IMPORTED_MODULE_8_moment___default()(timestamp*1000).format('DD-MM-YYYY');},_this.handleSubmit=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var getVehicleReport,vehicleDetails,data,rowData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.setState({loading:true,errorMsgDisplay:false});_context.next=3;return _this.props.client.query({query:GET_DEVICE_REPORT,variables:{clientLoginId:_this.state.clientLoginId,from_ts:_this.state.selectedFromDate,to_ts:_this.state.selectedToDate}// fetchPolicy: 'network-only'
});case 3:getVehicleReport=_context.sent;getVehicleReport&&_this.setState({loading:false});if(getVehicleReport.data.getLatestVehicleAnalyticData&&getVehicleReport.data){vehicleDetails=getVehicleReport.data.getLatestVehicleAnalyticData;data=[];rowData=[];vehicleDetails.forEach(function(element){rowData=[];rowData.push(element.vehicleNumber);rowData.push(_this.getFormattedDate(element.Date));rowData.push(element.UniqueId);rowData.push(element.TotalNumberofPackets);rowData.push(element.IgOnTrackingPackets);rowData.push(element.IgOffTrackingPackets);rowData.push(element.IgONInterval);rowData.push(element.IgOFFInterval);rowData.push(element.IgnitionONDataLossTime);rowData.push(element.IgnitionONDataLoss);rowData.push(element.IgnitionOFFDataLossTime);rowData.push(element.IgnitionOFFDataLoss);rowData.push(element.TotalIgnitionONTime);rowData.push(element.TotalIgnitionOffTime);rowData.push(element.MainPowerConnectedPackets);rowData.push(element.MainPowerDisconnectedPackets);rowData.push(element.LivePacketsCount);rowData.push(element.LivePacket);rowData.push(element.GPSValidDataCount);rowData.push(element.GPSInvalidDataCount);rowData.push(element.ValidData);rowData.push(element.InvalidwithIgnitionOn);rowData.push(element.InvalidwithIgnitionOff);rowData.push(element.HistoryPacketsCount);data.push(rowData);});if(data.length>1){// let result = vehicleDetails.map(obj => Object.values(obj));
_this.setState({fullData:data});}else{_this.props.openSnackbar('No records found');_this.setState({fullData:[]});}}else{_this.props.openSnackbar('No records found');_this.setState({fullData:[]});}if(_this.state.selectedFromDate>_this.state.selectedToDate){_this.props.openSnackbar('Please Select Valid Dates');}case 7:case'end':return _context.stop();}}},_callee,_this2);})),_this.getAllCustomers=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var customers,clientName,clientLoginId,allClients;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this.props.client.query({query:GET_CLIENTS,variables:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_4__utils_getLoginId__["a" /* default */])()},fetchPolicy:'network-only'});case 2:customers=_context2.sent;if(customers&&customers.data){clientName=[];clientLoginId=[];customers.data.clients.forEach(function(element){clientName.push(element.clientName);clientLoginId.push(element.loginId);});_this.setState({clientNameInfo:clientName,clientLoginIdInfo:clientLoginId});allClients=customers.data.clients.map(function(client){return{value:client.loginId,label:client.clientName};});_this.setState({clientNames:allClients});}case 4:case'end':return _context2.stop();}}},_callee2,_this2);})),_this.handleChange=function(event){if(event==null){_this.setState({fullData:[],selectedDateUnformat:null,errorMsgDisplay:false});}_this.setState({clientName:event==null?'':event.label,clientLoginId:event==null?'':event.value});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DeviceDataKpi,[{key:'componentDidMount',value:function componentDidMount(){this.getAllCustomers();}// new ends
},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;var _state=this.state,spacing=_state.spacing,selected=_state.selected,rowsPerPage=_state.rowsPerPage,page=_state.page;// console.log("Error Msg Displlay", this.state.errorMsgDisplay)
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'Device Health Report'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["Grid"],{container:true,spacing:16,xs:12,style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["Grid"],{item:true,xs:3,style:{zIndex:'1000'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */],{style:{alignItems:'center',width:'85%'},options:this.state.clientNames,value:this.state.clientLoginId,onChange:this.handleChange,placeholder:'Select Customer'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["Grid"],{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_pickers__["a" /* DatePicker */],{value:this.state.selectedDateForformat,onChange:this.fromDateChange,format:'DD/MM/YYYY',label:'Select a Date',maxDate:today})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["Grid"],{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_pickers__["a" /* DatePicker */],{value:this.state.selectedDateToformat,onChange:this.toDateChange,format:'DD/MM/YYYY',label:'Select a Date',maxDate:today})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["Grid"],{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["Button"],{variant:'contained',color:'secondary',size:'medium',className:'btn',type:'button',onClick:function onClick(){return _this3.handleSubmit();},disabled:this.state.selectedFromDate==''||this.state.selectedToDate==''||this.state.clientLoginId==''},'Submit')),this.state.loading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,this.state.responseStatus)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["Grid"],{container:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["Grid"],{item:true,xs:12},this.state.errorMsgDisplay&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["Grid"],{container:true,className:classes.errorMsg},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["Grid"],{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["Typography"],{variant:'h3',color:'error'},'No Data Available'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["Grid"],{container:true,className:classes.muiStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_mui_datatables___default.a,{title:'Device Health Report',data:this.state.fullData,columns:this.columns,options:this.options})))))));}}]);return DeviceDataKpi;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);DeviceDataKpi.propTypes={classes:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired,closeModal:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_6__HOCs_withSharedSnackbar__["a" /* default */])(DeviceDataKpi))));

/***/ }),
/* 2382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_getLoginId__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getDevices($partnerLoginId: Int) {\n    getIdleCurrentTrackinfo(partnerLoginId: $partnerLoginId) {\n      vehicleNumber\n      deviceSlNumber\n      phoneNumber\n      imeiNumber\n      simNumber\n      deviceVersion\n      vehicleModel\n      clientName\n      gpsSpeed\n      coordinates\n      address\n      vehicleGroup\n      timestamp\n      trackingStatus\n      batteryStatus\n    }\n  }\n'],['\n  query getDevices($partnerLoginId: Int) {\n    getIdleCurrentTrackinfo(partnerLoginId: $partnerLoginId) {\n      vehicleNumber\n      deviceSlNumber\n      phoneNumber\n      imeiNumber\n      simNumber\n      deviceVersion\n      vehicleModel\n      clientName\n      gpsSpeed\n      coordinates\n      address\n      vehicleGroup\n      timestamp\n      trackingStatus\n      batteryStatus\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var style=function style(theme){return{root:{padding:theme.spacing.unit*4,flexGrow:1},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},iconSmall:{fontSize:20}};};var GET_ALL_VEHICLE_IDLE_SUMMARY=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject);var IdleReport=function(_Component){_inherits(IdleReport,_Component);function IdleReport(props){var _this2=this;_classCallCheck(this,IdleReport);var _this=_possibleConstructorReturn(this,(IdleReport.__proto__||Object.getPrototypeOf(IdleReport)).call(this,props));_this.clientId=[];_this.columns=['VEHICLE NO','UNIQUE ID','CLIENT NAME','TRACKING STATUS','COORDINATES','ADDRESS','GROUP','TIMESTAMP','GPS SPEED','BATTERY STATUS','IMEI NUMBER','PHONE NUMBER','SIM NUMBER','DEVICE MODEL','VEHICLE MODEL'];_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15,filter:false,print:false};_this.state={open:false,open1:false,vehicleInfo:[],userLoginId:'',vehicleInfoTemp:[],isLoading:false};_this.fullData=[];_this.getAllVehicles=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _ref2,vehicles,rowData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:// console.log('clients', clients)
_this.setState({isLoading:true});_context.next=3;return _this.props.client.query({query:GET_ALL_VEHICLE_IDLE_SUMMARY,variables:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_9__utils_getLoginId__["a" /* default */])()},fetchPolicy:'network-only'}).catch(function(error){console.log(error);});case 3:_ref2=_context.sent;vehicles=_ref2.data;_this.setState({isLoading:false});if(vehicles&&vehicles.getIdleCurrentTrackinfo){rowData=[];vehicles.getIdleCurrentTrackinfo.forEach(function(element){rowData=[];rowData.push(element.vehicleNumber);rowData.push(element.deviceSlNumber);rowData.push(element.clientName);rowData.push(element.trackingStatus);rowData.push(element.coordinates);rowData.push(element.address);rowData.push(element.vehicleGroup);if(element&&element.timestamp){rowData.push(_this.getFormattedDate(element.timestamp));}else rowData.push('---');rowData.push(element.gpsSpeed);rowData.push(element.batteryStatus);rowData.push(element.imeiNumber);rowData.push(element.phoneNumber);rowData.push(element.simNumber);rowData.push(element.deviceVersion);rowData.push(element.vehicleModel);_this.fullData.push(rowData);});}// console.log('fullData vehicleInfo', this.fullData)
_this.setState({vehicleInfo:_this.fullData});case 8:case'end':return _context.stop();}}},_callee,_this2);}));_this.getFormattedDate=function(timestamp){return __WEBPACK_IMPORTED_MODULE_4_moment___default()(timestamp*1000).format('DD-MM-YYYY HH:mm:ss');};_this.classes=props;return _this;}_createClass(IdleReport,[{key:'componentDidMount',value:function componentDidMount(){this.getAllVehicles();}},{key:'render',value:function render(){var classes=this.props.classes;// console.log('log', this.fullData)
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},this.state.isLoading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,justify:'space-between'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{variant:'headline'},'Loading.....')):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_mui_datatables___default.a,{data:this.state.vehicleInfo,columns:this.columns,options:this.options,title:'Idle Report'}))));}}]);return IdleReport;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_5_react_apollo__["withApollo"])(IdleReport)));

/***/ }),
/* 2383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Paper__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Paper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_getAccountType__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_file_saver__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__PartnerBillingDetailsProformaInvoice__ = __webpack_require__(2384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_Card__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core_CardHeader__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core_CardHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_CardHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_core_CardContent__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_core_CardContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_CardContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core_CardActions__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core_CardActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_CardActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ViewSubscription_PaymentMethod__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__material_ui_icons_ArrowBack__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__material_ui_icons_ArrowBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__material_ui_icons_ArrowBack__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query($id: Int!) {\n    getPIAndInvoiceDetail(id: $id) {\n      noOfSubscriptions\n      paymentMasterDetails {\n        id\n        invoiceId\n        serviceRemarks\n        paidMoney\n        invoiceAmountWithGST\n        paymentStatus\n      }\n      clientDetails {\n        id\n        clientName\n        wallet\n        simWallet\n      }\n      partnerDetails {\n        id\n        businessName\n        wallet\n        simWallet\n      }\n      billingDetails {\n        totalAmountToBePaidGST\n        hardwareBillDetails {\n          quantity\n          amount\n          amountGST\n          amountPaidGST\n          amountToBePaidGST\n          creditDate\n        }\n        softwareBillDetails {\n          quantity\n          amount\n          amountGST\n          amountPaidGST\n          amountToBePaidGST\n          creditDate\n        }\n        accessoryBillDetails {\n          quantity\n          amount\n          amountGST\n          amountPaidGST\n          amountToBePaidGST\n          creditDate\n        }\n        simBillDetails {\n          quantity\n          amount\n          amountGST\n          amountPaidGST\n          amountToBePaidGST\n          creditDate\n        }\n      }\n      subscriptionBillDetails {\n        invoiceAmount\n      }\n      paymentHitoryDetails {\n        noOfSubscription\n        accountRemarks\n      }\n    }\n  }\n'],['\n  query($id: Int!) {\n    getPIAndInvoiceDetail(id: $id) {\n      noOfSubscriptions\n      paymentMasterDetails {\n        id\n        invoiceId\n        serviceRemarks\n        paidMoney\n        invoiceAmountWithGST\n        paymentStatus\n      }\n      clientDetails {\n        id\n        clientName\n        wallet\n        simWallet\n      }\n      partnerDetails {\n        id\n        businessName\n        wallet\n        simWallet\n      }\n      billingDetails {\n        totalAmountToBePaidGST\n        hardwareBillDetails {\n          quantity\n          amount\n          amountGST\n          amountPaidGST\n          amountToBePaidGST\n          creditDate\n        }\n        softwareBillDetails {\n          quantity\n          amount\n          amountGST\n          amountPaidGST\n          amountToBePaidGST\n          creditDate\n        }\n        accessoryBillDetails {\n          quantity\n          amount\n          amountGST\n          amountPaidGST\n          amountToBePaidGST\n          creditDate\n        }\n        simBillDetails {\n          quantity\n          amount\n          amountGST\n          amountPaidGST\n          amountToBePaidGST\n          creditDate\n        }\n      }\n      subscriptionBillDetails {\n        invoiceAmount\n      }\n      paymentHitoryDetails {\n        noOfSubscription\n        accountRemarks\n      }\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  mutation makePartnerPayment(\n    $paymentId: Int!\n    $totalAmountPaid: Int!\n    $simAmountPaid: Int!\n    $softwareAmountPaid: Int!\n    $accessoryAmountPaid: Int!\n    $hardwareAmountPaid: Int!\n    $accountRemarks: String\n    $paymentMode: paymentMode!\n    $paymentStatus: Int!\n    $bankName: String\n    $referenceNumber: String\n    $chequeDate: String\n    $simExpectedDate: String\n    $softwareExpectedDate: String\n    $hardwareExpectedDate: String\n    $accessoryExpectedDate: String\n  ) {\n    makePartnerPayment(\n      paymentId: $paymentId\n      totalAmountPaid: $totalAmountPaid\n      simAmountPaid: $simAmountPaid\n      softwareAmountPaid: $softwareAmountPaid\n      accessoryAmountPaid: $accessoryAmountPaid\n      hardwareAmountPaid: $hardwareAmountPaid\n      accountRemarks: $accountRemarks\n      paymentMode: $paymentMode\n      paymentStatus: $paymentStatus\n      bankName: $bankName\n      referenceNumber: $referenceNumber\n      chequeDate: $chequeDate\n      simExpectedDate: $simExpectedDate\n      accessoryExpectedDate: $accessoryExpectedDate\n      softwareExpectedDate: $softwareExpectedDate\n      hardwareExpectedDate: $hardwareExpectedDate\n    )\n  }\n'],['\n  mutation makePartnerPayment(\n    $paymentId: Int!\n    $totalAmountPaid: Int!\n    $simAmountPaid: Int!\n    $softwareAmountPaid: Int!\n    $accessoryAmountPaid: Int!\n    $hardwareAmountPaid: Int!\n    $accountRemarks: String\n    $paymentMode: paymentMode!\n    $paymentStatus: Int!\n    $bankName: String\n    $referenceNumber: String\n    $chequeDate: String\n    $simExpectedDate: String\n    $softwareExpectedDate: String\n    $hardwareExpectedDate: String\n    $accessoryExpectedDate: String\n  ) {\n    makePartnerPayment(\n      paymentId: $paymentId\n      totalAmountPaid: $totalAmountPaid\n      simAmountPaid: $simAmountPaid\n      softwareAmountPaid: $softwareAmountPaid\n      accessoryAmountPaid: $accessoryAmountPaid\n      hardwareAmountPaid: $hardwareAmountPaid\n      accountRemarks: $accountRemarks\n      paymentMode: $paymentMode\n      paymentStatus: $paymentStatus\n      bankName: $bankName\n      referenceNumber: $referenceNumber\n      chequeDate: $chequeDate\n      simExpectedDate: $simExpectedDate\n      accessoryExpectedDate: $accessoryExpectedDate\n      softwareExpectedDate: $softwareExpectedDate\n      hardwareExpectedDate: $hardwareExpectedDate\n    )\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation(\n    $id: Int!\n    $paymentStatus: Int!\n    $invoiceAmount: Int\n    $discount: Int\n    $serviceRemarks: String\n    $accountRemarks: String\n  ) {\n    updateAndRaiseInvoice(\n      id: $id\n      paymentStatus: $paymentStatus\n      invoiceAmount: $invoiceAmount\n      discount: $discount\n      serviceRemarks: $serviceRemarks\n      accountRemarks: $accountRemarks\n    )\n  }\n'],['\n  mutation(\n    $id: Int!\n    $paymentStatus: Int!\n    $invoiceAmount: Int\n    $discount: Int\n    $serviceRemarks: String\n    $accountRemarks: String\n  ) {\n    updateAndRaiseInvoice(\n      id: $id\n      paymentStatus: $paymentStatus\n      invoiceAmount: $invoiceAmount\n      discount: $discount\n      serviceRemarks: $serviceRemarks\n      accountRemarks: $accountRemarks\n    )\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query($id: Int!, $isInvoice: Boolean!) {\n    getInvoiceDownloadDetails(id: $id, isInvoice: $isInvoice)\n  }\n'],['\n  query($id: Int!, $isInvoice: Boolean!) {\n    getInvoiceDownloadDetails(id: $id, isInvoice: $isInvoice)\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  query getPIAndInvoiceDetail($id: Int!) {\n    getPIAndInvoiceDetail(id: $id) {\n      paymentMasterDetails {\n        id\n        invoiceId\n      }\n      paymentHitoryDetails {\n        id\n        paidMoney\n        paymentMode\n        referenceNumber\n        createdAt\n        accountRemarks\n        bank\n      }\n    }\n  }\n'],['\n  query getPIAndInvoiceDetail($id: Int!) {\n    getPIAndInvoiceDetail(id: $id) {\n      paymentMasterDetails {\n        id\n        invoiceId\n      }\n      paymentHitoryDetails {\n        id\n        paidMoney\n        paymentMode\n        referenceNumber\n        createdAt\n        accountRemarks\n        bank\n      }\n    }\n  }\n']);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_PI_INFO=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject);var MAKE_PAYMENT=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject2);var CREATE_INVOICE=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject3);var GET_PDF_DOWNLOAD_LINK=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject4);var GET_PI_AND_INVOICE=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject5);var style=function style(theme){return{root:{padding:theme.spacing.unit*4,flexGrow:1,backgroundColor:theme.palette.background.paper},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},iconSmall:{fontSize:20},selectStyle:{margin:theme.spacing.unit,minWidth:250},textField:{marginLeft:theme.spacing.unit,marginRight:theme.spacing.unit,minWidth:250},pad:{padding:theme.spacing.unit*2},redButton:{backgroundColor:theme.palette.error.main,'&:hover':{backgroundColor:theme.palette.error.dark}}};};var paymentOption=['CASH','ONLINE','CHEQUE','DD'];var columns=['Payment Id','Payment Made','Mode of Payment','Reference Number','Bank Name','Date of Payment','Payment Remarks'];var CreatePartnerProformaInvoice=function(_Component){_inherits(CreatePartnerProformaInvoice,_Component);function CreatePartnerProformaInvoice(props){var _this2=this;_classCallCheck(this,CreatePartnerProformaInvoice);var _this=_possibleConstructorReturn(this,(CreatePartnerProformaInvoice.__proto__||Object.getPrototypeOf(CreatePartnerProformaInvoice)).call(this,props));_this.state={labelWidth:0,piInfo:'',paymentType:'',invoiceAmount:0,paymentStatus:'',discount:0,remarks:'',error:true,isDownloading:false,paymentMode:'',paymentId:0,referenceNumber:null,bankName:'',paidMoney:'',accountRemarks:'',validation:false,hardwarePaymentMade:0,softwarePaymentMade:0,accessoryPaymentMade:0,simPaymentMade:0,totalAmountPaid:0,hardwareBalance:0,softwareBalance:0,accessoryBalance:0,simBalance:0,paymentMadeFieldValidation:false,hardwareRemarks:null,softwareRemarks:null,accessoryRemarks:null,simRemarks:null,checkDate:null,expectedHardwareDueDate:__WEBPACK_IMPORTED_MODULE_15_moment___default()().add(1,'weeks'),expectedSoftwareDueDate:__WEBPACK_IMPORTED_MODULE_15_moment___default()().add(1,'weeks'),expectedAccessoryDueDate:__WEBPACK_IMPORTED_MODULE_15_moment___default()().add(1,'weeks'),expectedSimsDueDate:__WEBPACK_IMPORTED_MODULE_15_moment___default()().add(1,'weeks'),approveOrReject:null,allInvoiceData:[],paymentStatusShow:'',saveBtnDisabled:false};_this.getMuiTheme=function(){return Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__["createMuiTheme"])({overrides:{MUIDataTableToolbar:{root:{display:'none'}}}});};_this.options={filterType:'dropdown',filter:false,search:false,download:false,print:false,disableToolbarSelect:false,viewColumns:false,selectableRows:false,responsive:'scroll',rowsPerPage:5,rowHover:false// onRowClick: (rowData, dataIndex, rowIndex) => {
//   this.props.history.push({
//     pathname:
//       '/home/subscriptions' +
//       '/' +
//       this.subcriptionIdPartner[dataIndex.dataIndex] +
//       '/partnerSubscriptionDetail'
//   })
// }
// makePayment = () => {
//   this.props.history.push({
//     pathname: '/home/manage/makePayment'
//   })
// }
// handleChangeDiscount = event => {
//   this.setState(
//     {
//       discount: event.target.value,
//       invoiceAmount: this.state.piInfo.totalPI - event.target.value
//     },
//     () => this.checkTotalInvoice()
//   )
// }
// checkTotalInvoice() {
//   if (
//     this.state.piInfo.totalPI < this.state.invoiceAmount ||
//     this.state.invoiceAmount < 0
//   ) {
//     this.props.openSnackbar(
//       'Discount should not be more than Invoice amount!'
//     )
//     this.setState({
//       error: false,
//       discount: 0,
//       invoiceAmount: 0
//     })
//   }
// }
};_this.handleChangeRemarks=function(event){_this.setState({remarks:event.target.value});};_this.handleSaveMutation=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _ref2,data,errors;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.client.mutate({mutation:MAKE_PAYMENT,variables:{paymentId:parseInt(_this.state.paymentId,10),totalAmountPaid:parseInt(_this.state.totalAmountPaid,10),simAmountPaid:parseInt(_this.state.simPaymentMade,10),softwareAmountPaid:parseInt(_this.state.softwarePaymentMade,10),accessoryAmountPaid:parseInt(_this.state.accessoryPaymentMade,10),hardwareAmountPaid:parseInt(_this.state.hardwarePaymentMade,10),accountRemarks:_this.state.accountRemarks,paymentMode:_this.state.paymentMode,paymentStatus:parseInt(_this.state.paymentStatus,10),bankName:_this.state.bankName,referenceNumber:_this.state.referenceNumber?_this.state.referenceNumber.toString():_this.state.referenceNumber,chequeDate:__WEBPACK_IMPORTED_MODULE_15_moment___default()(parseInt(_this.state.checkDate,10)),simExpectedDate:__WEBPACK_IMPORTED_MODULE_15_moment___default()(_this.state.expectedSimsDueDate).unix().toString(),accessoryExpectedDate:__WEBPACK_IMPORTED_MODULE_15_moment___default()(_this.state.expectedAccessoryDueDate).unix().toString(),softwareExpectedDate:__WEBPACK_IMPORTED_MODULE_15_moment___default()(_this.state.expectedHardwareDueDate).unix().toString(),hardwareExpectedDate:__WEBPACK_IMPORTED_MODULE_15_moment___default()(_this.state.expectedSoftwareDueDate).unix().toString()},errorPolicy:'all'});case 2:_ref2=_context.sent;data=_ref2.data;errors=_ref2.errors;if(errors){_this.props.openSnackbar(errors[0].message,{type:'error'});_this.setState({saveBtnDisabled:false});}else if(data.makePartnerPayment){_this.props.openSnackbar('Successfully Details Saved');_this.props.history.goBack();}case 6:case'end':return _context.stop();}}},_callee,_this2);}));_this.validateFields=function(){var regExValue=new RegExp(/^([a-zA-Z0-9_-]){5,25}$/);var regExValueBank=new RegExp(/^[A-Za-z\s]{3,30}$/);if(_this.state.paymentMode==='ONLINE'){if(_this.state.referenceNumber!==''&&regExValue.test(_this.state.referenceNumber)){_this.setState({validation:true});return true;}else{_this.props.openSnackbar('Reference Number length Should between 5 to 25 and Alphanumeric');_this.setState({validation:false});return false;}}else if(_this.state.accountRemarks.length>100){_this.props.openSnackbar('Remarks should be less than 100 Characters!');return false;}else if(_this.state.paymentMode==='DD'||_this.state.paymentMode==='CHEQUE'){if(!regExValue.test(_this.state.referenceNumber)){console.log('reference in valid');_this.props.openSnackbar('Reference Number length Should between 5 to 25 and Alphanumeric');_this.setState({validation:false});return false;}else if(!regExValueBank.test(_this.state.bankName)||_this.state.bankName===null){_this.props.openSnackbar('Bank Name length Should be between 3 to 30 and only alphabets');_this.setState({validation:false});return false;}else{_this.setState({validation:true});return true;}}else{_this.setState({validation:true});return true;}};_this.handleSave=function(){if(_this.validateFields()){_this.setState({saveBtnDisabled:true});_this.handleSaveMutation();}};_this.handleCancel=function(loginId){console.log('this.props',_this.props);_this.props.history.goBack();// this.props.history.push({
//   pathname: '/home/manage/admin/InvoiceDetails'
// })
};_this.calculateBalance=function(perticularName){var billingDetails=_this.state.piInfo.billingDetails;if(perticularName==='hardwarePaymentMade'){if(billingDetails.hardwareBillDetails){var amountToBePaidGST=billingDetails.hardwareBillDetails.amountToBePaidGST;var hardwarePaymentMade=_this.state.hardwarePaymentMade;_this.setState({hardwareBalance:amountToBePaidGST-hardwarePaymentMade});}}else if(perticularName==='softwarePaymentMade'){if(billingDetails.softwareBillDetails){var _amountToBePaidGST=billingDetails.softwareBillDetails.amountToBePaidGST;var softwarePaymentMade=_this.state.softwarePaymentMade;_this.setState({softwareBalance:_amountToBePaidGST-softwarePaymentMade});}}else if(perticularName==='accessoryPaymentMade'){if(billingDetails.accessoryBillDetails){var _amountToBePaidGST2=billingDetails.accessoryBillDetails.amountToBePaidGST;var accessoryPaymentMade=_this.state.accessoryPaymentMade;_this.setState({accessoryBalance:_amountToBePaidGST2-accessoryPaymentMade});}}else{var _amountToBePaidGST3=billingDetails.simBillDetails.amountToBePaidGST;var simPaymentMade=_this.state.simPaymentMade;_this.setState({simBalance:_amountToBePaidGST3-simPaymentMade});}};_this.handlePaymentMade=function(name){return function(event){console.log('handlepayment made',name);_this.setState(_defineProperty({},name,event.target.value),function(){_this.calculateBalance(name);_this.handleTotalAmountPaid();});};};_this.handleExpectedDateChange=function(name){return function(date){_this.setState(_defineProperty({},name,date),function(){});};};_this.handleRemarksChange=function(name){return function(event){};};_this.paymentModeAndModeValidation=function(){var _this$state=_this.state,totalAmountPaid=_this$state.totalAmountPaid,paymentMode=_this$state.paymentMode;if(totalAmountPaid>0&&paymentMode){_this.setState({paymentMadeFieldValidation:true});}else{_this.setState({paymentMadeFieldValidation:false});}};_this.handleTotalAmountPaid=function(){var total=0;var _this$state2=_this.state,hardwarePaymentMade=_this$state2.hardwarePaymentMade,softwarePaymentMade=_this$state2.softwarePaymentMade,accessoryPaymentMade=_this$state2.accessoryPaymentMade,simPaymentMade=_this$state2.simPaymentMade;total=parseInt(hardwarePaymentMade,10)+parseInt(softwarePaymentMade,10)+parseInt(accessoryPaymentMade,10)+parseInt(simPaymentMade,10);_this.setState({totalAmountPaid:total},function(){_this.paymentModeAndModeValidation();});};_this.handleChangePaymentType=function(event){_this.setState({paymentMode:event.target.value},function(){_this.paymentModeAndModeValidation();});};_this.handleChangeReferenceNumber=function(event){// console.log('event', event.target.value)
_this.setState({referenceNumber:event.target.value});// console.log('referenceNumber', this.state.referenceNumber)
};_this.handleChangeBankName=function(event){_this.setState({bankName:event.target.value});};_this.handleAccountRemarksChange=function(event){_this.setState({accountRemarks:event.target.value});};_this.getClientPIInfo=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var _ref4,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this.props.client.query({query:GET_PI_INFO,variables:{id:parseInt(_this.id,10)},fetchPolicy:'network-only'});case 2:_ref4=_context2.sent;data=_ref4.data;if(data.getPIAndInvoiceDetail){_this.setState({piInfo:data.getPIAndInvoiceDetail},function(){console.log('piInfo',_this.state.piInfo);_this.setInitialData();_this.getPaymentStatusValue();});}case 5:case'end':return _context2.stop();}}},_callee2,_this2);}));_this.setInitialData=function(){var piInfo=_this.state.piInfo;if(piInfo.paymentMasterDetails){_this.setState({paymentId:piInfo.paymentMasterDetails.id,paymentStatus:piInfo.paymentMasterDetails.paymentStatus});}if(piInfo.billingDetails){var _piInfo$billingDetail=piInfo.billingDetails,hardwareBillDetails=_piInfo$billingDetail.hardwareBillDetails,softwareBillDetails=_piInfo$billingDetail.softwareBillDetails,accessoryBillDetails=_piInfo$billingDetail.accessoryBillDetails,simBillDetails=_piInfo$billingDetail.simBillDetails;if(hardwareBillDetails){_this.setState({hardwareBalance:hardwareBillDetails.amountToBePaidGST});}if(softwareBillDetails){_this.setState({softwareBalance:softwareBillDetails.amountToBePaidGST});}if(accessoryBillDetails){_this.setState({accessoryBalance:accessoryBillDetails.amountToBePaidGST});}if(simBillDetails){_this.setState({simBalance:simBillDetails.amountToBePaidGST});}}};_this.mapToArray=function(data){console.log('invoice data',data);var paymentMasterDetails=data.paymentMasterDetails,paymentHitoryDetails=data.paymentHitoryDetails;var mappedArray=paymentHitoryDetails.reduce(function(acc,item){var tableData=[];tableData.push(paymentMasterDetails.invoiceId);item.paidMoney>=0?tableData.push(item.paidMoney):tableData.push('N/A');item.paymentMode?tableData.push(item.paymentMode):tableData.push('N/A');item.referenceNumber?tableData.push(item.referenceNumber):tableData.push('N/A');item.bank?tableData.push(item.bank):tableData.push('N/A');/* eslint-disable indent */item.createdAt?tableData.push(__WEBPACK_IMPORTED_MODULE_15_moment___default.a.unix(parseInt(item.createdAt,10)).format('DD/MM/YYYY')):tableData.push('N/A');/* eslint-enable indent */item.accountRemarks?tableData.push(item.accountRemarks):tableData.push('N/A');acc.push(tableData);return acc;},[]);_this.setState({allInvoiceData:mappedArray},function(){console.log('all Invoive data',_this.state.allInvoiceData);});};_this.getPIandInvoice=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var _ref6,data,loading,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return _this.props.client.query({query:GET_PI_AND_INVOICE,variables:{id:parseInt(_this.props.match.params.id,10)},fetchPolicy:'network-only'});case 2:_ref6=_context3.sent;data=_ref6.data;loading=_ref6.loading;error=_ref6.error;console.log('all PI data',data);if(data&&data.getPIAndInvoiceDetail){_this.mapToArray(data.getPIAndInvoiceDetail);}case 8:case'end':return _context3.stop();}}},_callee3,_this2);}));_this.getPaymentStatusValue=function(){if(_this.state.piInfo){console.log('payment status',_this.state.piInfo.paymentMasterDetails.paymentStatus);switch(_this.state.piInfo.paymentMasterDetails.paymentStatus){case 0:_this.setState({paymentStatusShow:'Unpaid'});break;case 1:_this.setState({paymentStatusShow:'Pending for approval'});break;case 2:_this.setState({paymentStatusShow:'Subscription approved'});break;case 3:_this.setState({paymentStatusShow:'Subscription Rejected'});break;case 4:_this.setState({paymentStatusShow:'Full payment'});break;case 5:_this.setState({paymentStatusShow:'On hold'});break;case 6:_this.setState({paymentStatusShow:'Partial payment'});break;default:_this.setState({paymentStatusShow:'N/A'});break;}}};_this.id=_this.props.match.params.id;return _this;}// handleReject = async () => {
//   await this.props.client.mutate({
//     mutation: CREATE_INVOICE,
//     variables: {
//       id: parseInt(this.id, 10),
//       invoiceAmount: parseInt(this.state.piInfo.totalPI, 10),
//       paymentStatus: 3,
//       discount: 0,
//       ...(!['SER'].includes(getAccountType())
//         ? { accountRemarks: this.state.remarks }
//         : { serviceRemarks: this.state.remarks })
//     },
//     errorPolicy: 'all'
//   })
//   this.setState({
//     invoiceAmount: '',
//     paymentStatus: '',
//     discount: '',
//     remarks: ''
//   })
//   this.props.history.push({
//     pathname: '/home/manage/admin/InvoiceDetails'
//   })
// }
// downloadPdf = async () => {
//   this.setState({ isDownloading: true })
//   const isInvoice = [3, 4].includes(this.state.piInfo.paymentStatus)
//   const { data } = await this.props.client.query({
//     query: GET_PDF_DOWNLOAD_LINK,
//     variables: {
//       id: parseInt(this.id, 10),
//       isInvoice
//     },
//     errorPolicy: 'all'
//   })
//   if (data && data.getInvoiceDownloadDetails) {
//     const res = await axios({
//       url: data.getInvoiceDownloadDetails,
//       method: 'GET',
//       headers: { Accept: 'application/pdf' },
//       responseType: 'blob' // important
//     })
//     FileSaver.saveAs(new Blob([res.data]), 'Invoice.pdf')
//   }
//   this.setState({ isDownloading: false })
// }
_createClass(CreatePartnerProformaInvoice,[{key:'componentDidMount',value:function componentDidMount(){this.getClientPIInfo();this.getPIandInvoice();}},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;var _state=this.state,piInfo=_state.piInfo,paymentMadeFieldValidation=_state.paymentMadeFieldValidation,allInvoiceData=_state.allInvoiceData;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.gridItemHorizontal},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{variant:'outlined',color:'secondary',className:classes.button,onClick:function onClick(){return _this3.props.history.goBack();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__material_ui_icons_ArrowBack___default.a,{className:classes.iconSmall}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,justify:'space-between',alignItems:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'display1',gutterBottom:true},'Invoice Details')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,spacing:16},[3,4].includes(this.state.piInfo.paymentStatus)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{variant:'raised',color:'primary',onClick:function onClick(){return _this3.downloadPdf(true);}},this.state.isDownloading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["CircularProgress"],{size:24}):'Download Invoice'))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_Card___default.a,{className:classes.card,raised:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_CardHeader___default.a,{title:'Partner Details'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body1',color:'textSecondary'},'Partner Name'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body2'},piInfo.partnerDetails&&piInfo.partnerDetails.businessName))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body1',color:'textSecondary'},'Invoice Number'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body2'},piInfo.paymentMasterDetails&&piInfo.paymentMasterDetails.invoiceId)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body1',color:'textSecondary'},'Payment Status'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body2'},piInfo.paymentMasterDetails&&this.state.paymentStatusShow)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body1',color:'textSecondary'},'Total Subscriptions'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body2'},piInfo.noOfSubscriptions&&piInfo.noOfSubscriptions?piInfo.noOfSubscriptions:'N/A'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body1',color:'textSecondary'},'Pending amount(incl GST)'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body2'},'\u20B9',' ',piInfo.partnerDetails&&piInfo.billingDetails.totalAmountToBePaidGST)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body1',color:'textSecondary'},'Invoice Amount (Incl GST)'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body2'},'\u20B9',' ',piInfo.paymentMasterDetails&&piInfo.paymentMasterDetails.invoiceAmountWithGST)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body1',color:'textSecondary'},'Sim Wallet'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body2'},'\u20B9',' ',piInfo.partnerDetails&&piInfo.partnerDetails.simWallet)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body1',color:'textSecondary'},'software Wallet'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body2'},'\u20B9',' ',piInfo.partnerDetails&&piInfo.partnerDetails.wallet)),(this.state.piInfo.paymentStatus===3||this.state.piInfo.paymentStatus===4)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,md:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body1',color:'textSecondary'},'Account Remarks'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body2'},this.state.piInfo.accountRemarks||'-')),this.state.piInfo.paymentStatus===4&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,md:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body1',color:'textSecondary'},'Discount'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body2'},'\u20B9',' ',this.state.piInfo.totalPI-this.state.piInfo.totalInvoice)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,md:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body1',color:'textSecondary'},'Final amount'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'body2'},'\u20B9 ',this.state.piInfo.totalInvoice))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),['ACC'].includes(Object(__WEBPACK_IMPORTED_MODULE_10__utils_getAccountType__["a" /* default */])())&&piInfo.paymentMasterDetails&&[0,6].includes(piInfo.paymentMasterDetails.paymentStatus)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__PartnerBillingDetailsProformaInvoice__["a" /* default */],{piInfoData:piInfo,hardwarePaymentMade:this.state.hardwarePaymentMade,paymentStatus:this.state.paymentStatus,softwarePaymentMade:this.state.softwarePaymentMade,accessoryPaymentMade:this.state.accessoryPaymentMade,simPaymentMade:this.state.simPaymentMade,hardwareBalance:this.state.hardwareBalance,softwareBalance:this.state.softwareBalance,accessoryBalance:this.state.accessoryBalance,simBalance:this.state.simBalance,hardwareRemarks:this.state.hardwareRemarks,softwareRemarks:this.state.softwareRemarks,accessoryRemarks:this.state.accessoryRemarks,simRemarks:this.state.simRemarks,expectedHardwareDueDate:this.state.expectedHardwareDueDate,expectedSoftwareDueDate:this.state.expectedSoftwareDueDate,expectedAccessoryDueDate:this.state.expectedAccessoryDueDate,expectedSimsDueDate:this.state.expectedSimsDueDate,handlePaymentMade:this.handlePaymentMade,handleRemarksChange:this.handleRemarksChange,handleExpectedDateChange:this.handleExpectedDateChange})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},['ACC'].includes(Object(__WEBPACK_IMPORTED_MODULE_10__utils_getAccountType__["a" /* default */])())&&piInfo.paymentMasterDetails&&[0,6,4].includes(piInfo.paymentMasterDetails.paymentStatus)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_Card___default.a,{raised:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_CardHeader___default.a,{className:classes.cardAction,title:'Payment History'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,justify:'space-between'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__["MuiThemeProvider"],{theme:this.getMuiTheme()},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_mui_datatables___default.a,{data:allInvoiceData,columns:columns,options:this.options}))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),['ACC'].includes(Object(__WEBPACK_IMPORTED_MODULE_10__utils_getAccountType__["a" /* default */])())&&piInfo.paymentMasterDetails&&[0,6].includes(piInfo.paymentMasterDetails.paymentStatus)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_Card___default.a,{className:classes.card,raised:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_CardHeader___default.a,{title:'Record Payment'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__material_ui_core_FormControl___default.a,{className:classes.formControl},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__material_ui_core_InputLabel___default.a,{id:'payment-helper'},'Payment Type'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__material_ui_core_Select___default.a,{value:this.state.paymentMode,onChange:this.handleChangePaymentType,className:classes.selectStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_MenuItem___default.a,{value:'CASH'},'Cash'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_MenuItem___default.a,{value:'ONLINE'},'Online'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_MenuItem___default.a,{value:'CHEQUE'},'Cheque'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_MenuItem___default.a,{value:'DD'},'DD')))),paymentOption.includes(this.state.paymentMode)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__ViewSubscription_PaymentMethod__["a" /* default */],{paymentThrough:this.state.paymentMode,handleChangereferenceNumber:this.handleChangeReferenceNumber,handleChangeBankName:this.handleChangeBankName,handleChangePaidMoney:this.handleChangePaidMoney// paidMoney={this.state.paidMoney}
,referenceNumber:this.state.referenceNumber,bankName:this.state.bankName})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField___default.a,{multiline:true,rows:2,label:'Remarks',variant:'contained',onChange:this.handleAccountRemarksChange,value:this.state.accountRemarks})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_CardActions___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{variant:'contained',color:'secondary',classes:{root:classes.redButton},onClick:this.handleCancel},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{disabled:!paymentMadeFieldValidation||this.state.saveBtnDisabled,variant:'contained',color:'secondary',type:'submit',onClick:this.handleSave},'Save'))))));}}]);return CreatePartnerProformaInvoice;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_9__HOCs_withSharedSnackbar__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["withApollo"])(CreatePartnerProformaInvoice))));

/***/ }),
/* 2384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Card__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_CardHeader__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_CardHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_CardHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_CardContent__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_CardContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_CardContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_CardActions__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_CardActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_CardActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui_pickers__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles=function styles(theme){return{rowStyle:{margin:'15px 0'},textFieldStyle:{width:'55%'},dateStyle:{width:'50%'},subHeadingStyle:{marginLeft:'1.9vw',marginBottom:'10px',fontSize:'1rem',fontWeight:'bold'},cardAction:{marginLeft:'-1.9vw'}};};var PartnerBillingDetailsProformaInvoice=function(_Component){_inherits(PartnerBillingDetailsProformaInvoice,_Component);function PartnerBillingDetailsProformaInvoice(){_classCallCheck(this,PartnerBillingDetailsProformaInvoice);return _possibleConstructorReturn(this,(PartnerBillingDetailsProformaInvoice.__proto__||Object.getPrototypeOf(PartnerBillingDetailsProformaInvoice)).apply(this,arguments));}_createClass(PartnerBillingDetailsProformaInvoice,[{key:'render',value:function render(){var _props=this.props,classes=_props.classes,piInfoData=_props.piInfoData;var billingDetails=piInfoData.billingDetails;var _props2=this.props,paymentStatus=_props2.paymentStatus,hardwarePaymentMade=_props2.hardwarePaymentMade,softwarePaymentMade=_props2.softwarePaymentMade,accessoryPaymentMade=_props2.accessoryPaymentMade,simPaymentMade=_props2.simPaymentMade,hardwareBalance=_props2.hardwareBalance,softwareBalance=_props2.softwareBalance,accessoryBalance=_props2.accessoryBalance,simBalance=_props2.simBalance,hardwareRemarks=_props2.hardwareRemarks,softwareRemarks=_props2.softwareRemarks,accessoryRemarks=_props2.accessoryRemarks,simRemarks=_props2.simRemarks,expectedHardwareDueDate=_props2.expectedHardwareDueDate,expectedSoftwareDueDate=_props2.expectedSoftwareDueDate,expectedAccessoryDueDate=_props2.expectedAccessoryDueDate,expectedSimsDueDate=_props2.expectedSimsDueDate,handlePaymentMade=_props2.handlePaymentMade,handleRemarksChange=_props2.handleRemarksChange,handleExpectedDateChange=_props2.handleExpectedDateChange;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,billingDetails&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Card___default.a,{raised:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_CardHeader___default.a,{className:classes.cardAction,title:'Billing Details'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,justify:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,style:{marginRight:'7vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,direction:'column',alignContent:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},'PARTICULARS')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},' Quantity')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},' ','Total Bill(Incl. GST)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},' Total Paid')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},' Total Payable')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},' Payment Made')))),billingDetails.hardwareBillDetails&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,direction:'column',alignContent:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},' HARDWARE')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},billingDetails.hardwareBillDetails.quantity)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9 ',billingDetails.hardwareBillDetails.amountGST)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9',' ',billingDetails.hardwareBillDetails.amountPaidGST)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9',' ',billingDetails.hardwareBillDetails.amountToBePaidGST)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},'\u20B9',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField___default.a,{type:'Number',className:classes.textFieldStyle,label:'Paid Amount *',inputProps:{min:0},value:hardwarePaymentMade,onChange:handlePaymentMade('hardwarePaymentMade'),margin:'none',disabled:billingDetails.hardwareBillDetails.amountToBePaidGST<=0})))),billingDetails.softwareBillDetails&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,direction:'column',alignContent:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},' SOFTWARE ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},billingDetails.softwareBillDetails.quantity)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9 ',billingDetails.softwareBillDetails.amountGST)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9',' ',billingDetails.softwareBillDetails.amountPaidGST)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9',' ',billingDetails.softwareBillDetails.amountToBePaidGST)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},'\u20B9',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField___default.a,{type:'Number',className:classes.textFieldStyle,label:'Paid Amount *',inputProps:{min:0},value:softwarePaymentMade,onChange:handlePaymentMade('softwarePaymentMade'),margin:'none'})))),billingDetails.accessoryBillDetails&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,direction:'column',alignContent:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},' ACCESSORY')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},' ',billingDetails.accessoryBillDetails.quantity)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9',' ',billingDetails.accessoryBillDetails.amountGST)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9',' ',billingDetails.accessoryBillDetails.amountPaidGST)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},'\u20B9',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},billingDetails.accessoryBillDetails.amountToBePaidGST)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},'\u20B9',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField___default.a,{type:'Number',className:classes.textFieldStyle,label:'Paid Amount *',inputProps:{min:0},value:accessoryPaymentMade,onChange:handlePaymentMade('accessoryPaymentMade'),margin:'none'})))),billingDetails.simBillDetails&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,direction:'column',alignContent:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},' SIM ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},billingDetails.simBillDetails.quantity)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9 ',billingDetails.simBillDetails.amountGST)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9 ',billingDetails.simBillDetails.amountPaidGST)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9',' ',billingDetails.simBillDetails.amountToBePaidGST)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},'\u20B9',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_TextField___default.a,{type:'Number',className:classes.textFieldStyle,label:'Paid Amount *',inputProps:{min:0},value:simPaymentMade,onChange:handlePaymentMade('simPaymentMade'),margin:'none'}))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),billingDetails&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Card___default.a,{raised:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_CardHeader___default.a,{className:classes.cardAction,title:'Credit Note'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,justify:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,style:{marginRight:'7vw'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,direction:'column',alignContent:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},'Balance')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},'Credit Date')),[0].includes(paymentStatus)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,style:{margin:'25px 0'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},' ','Expected Due Date')))),billingDetails.hardwareBillDetails&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,disabled:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,direction:'column',alignContent:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},'\u20B9 ',hardwareBalance)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2',style:{marginRight:'100px'}},__WEBPACK_IMPORTED_MODULE_13_moment___default.a.unix(parseInt(piInfoData.billingDetails.hardwareBillDetails.creditDate,10)).format('DD/MM/YYYY'))),[0].includes(paymentStatus)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_material_ui_pickers__["a" /* DatePicker */],{disabled:hardwareBalance===0,className:classes.dateStyle,label:'Due Date',value:expectedHardwareDueDate// views={['year', 'month', 'date']}
,format:'DD/MM/YYYY',onChange:handleExpectedDateChange('expectedHardwareDueDate')})))),billingDetails.softwareBillDetails&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,direction:'column',alignContent:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},'\u20B9 ',softwareBalance)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2',style:{marginRight:'100px'}},__WEBPACK_IMPORTED_MODULE_13_moment___default.a.unix(parseInt(piInfoData.billingDetails.softwareBillDetails.creditDate,10)).format('DD/MM/YYYY'))),[0].includes(paymentStatus)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_material_ui_pickers__["a" /* DatePicker */],{disabled:softwareBalance===0,className:classes.dateStyle,label:'Due Date',value:expectedSoftwareDueDate,onChange:handleExpectedDateChange('expectedSoftwareDueDate'),format:'DD/MM/YYYY'})))),billingDetails.accessoryBillDetails&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,direction:'column',alignContent:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},accessoryBalance)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2',style:{marginRight:'100px'}},__WEBPACK_IMPORTED_MODULE_13_moment___default.a.unix(parseInt(piInfoData.billingDetails.accessoryBillDetails.creditDate,10)).format('DD/MM/YYYY'))),[0].includes(paymentStatus)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_material_ui_pickers__["a" /* DatePicker */],{disabled:accessoryBalance===0,className:classes.dateStyle,label:'Due Date',value:expectedAccessoryDueDate,onChange:handleExpectedDateChange('expectedAccessoryDueDate'),format:'DD/MM/YYYY'})))),billingDetails.simBillDetails?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,direction:'column',alignContent:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2'},simBalance)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'body2',style:{marginRight:'100px'}},__WEBPACK_IMPORTED_MODULE_13_moment___default.a.unix(parseInt(piInfoData.billingDetails.simBillDetails.creditDate,10)).format('DD/MM/YYYY'))),[0].includes(paymentStatus)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_material_ui_pickers__["a" /* DatePicker */],{disabled:simBalance===0,className:classes.dateStyle,label:'Due Date',value:expectedSimsDueDate,onChange:handleExpectedDateChange('expectedSimsDueDate'),format:'DD/MM/YYYY'})))):null))));}}]);return PartnerBillingDetailsProformaInvoice;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_1_react_apollo__["withApollo"])(PartnerBillingDetailsProformaInvoice)));

/***/ }),
/* 2385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Card__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_CardContent__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_CardContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_CardContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_ArrowBack__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_ArrowBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_ArrowBack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query partnerDetail($loginId: Int) {\n    partnerDetail(loginId: $loginId) {\n      id\n      businessName\n      contactPerson\n      address\n    }\n  }\n'],['\n  query partnerDetail($loginId: Int) {\n    partnerDetail(loginId: $loginId) {\n      id\n      businessName\n      contactPerson\n      address\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query checkDeviceAvailableForSubscription(\n    $partnerLoginId: Int!\n    $serial_num: [DeviceListInput!]!\n    $deviceModelId: Int!\n  ) {\n    validation: checkDeviceAvailableForSubscription(\n      partnerLoginId: $partnerLoginId\n      deviceList: $serial_num\n      deviceModelId: $deviceModelId\n    ) {\n      serial_num\n      uniqueDeviceId\n    }\n  }\n'],['\n  query checkDeviceAvailableForSubscription(\n    $partnerLoginId: Int!\n    $serial_num: [DeviceListInput!]!\n    $deviceModelId: Int!\n  ) {\n    validation: checkDeviceAvailableForSubscription(\n      partnerLoginId: $partnerLoginId\n      deviceList: $serial_num\n      deviceModelId: $deviceModelId\n    ) {\n      serial_num\n      uniqueDeviceId\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query checkSimAvailableForSubscription(\n    $partnerLoginId: Int!\n    $simNumber: [SimListInput!]!\n    $serviceProviderId: Int!\n  ) {\n    validation: checkSimAvailableForSubscription(\n      partnerLoginId: $partnerLoginId\n      simList: $simNumber\n      serviceProviderId: $serviceProviderId\n    ) {\n      simNumber\n    }\n  }\n'],['\n  query checkSimAvailableForSubscription(\n    $partnerLoginId: Int!\n    $simNumber: [SimListInput!]!\n    $serviceProviderId: Int!\n  ) {\n    validation: checkSimAvailableForSubscription(\n      partnerLoginId: $partnerLoginId\n      simList: $simNumber\n      serviceProviderId: $serviceProviderId\n    ) {\n      simNumber\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query getPartnerSubscriptions($subscriptionId: Int!) {\n    getPartnerSubscriptions(id: $subscriptionId) {\n      deviceModel {\n        model_name\n      }\n      accessoryType {\n        accessoryName\n        manufacturer {\n          manufacturerCode\n        }\n      }\n      serviceProvider {\n        name\n      }\n      deviceModelId\n      serviceProviderId\n      accessoryTypeId\n      unassignedDeviceQuantity\n      unassignedSimQty\n      unassignedAccessoryQty\n    }\n  }\n'],['\n  query getPartnerSubscriptions($subscriptionId: Int!) {\n    getPartnerSubscriptions(id: $subscriptionId) {\n      deviceModel {\n        model_name\n      }\n      accessoryType {\n        accessoryName\n        manufacturer {\n          manufacturerCode\n        }\n      }\n      serviceProvider {\n        name\n      }\n      deviceModelId\n      serviceProviderId\n      accessoryTypeId\n      unassignedDeviceQuantity\n      unassignedSimQty\n      unassignedAccessoryQty\n    }\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  query checkAccessoryAvailableForSubscription(\n    $partnerLoginId: Int!\n    $serialNumber: [AccessoryListInput!]!\n    $accessoryTypeId: Int!\n  ) {\n    validation: checkAccessoryAvailableForSubscription(\n      partnerLoginId: $partnerLoginId\n      serialNumberList: $serialNumber\n      accessoryTypeId: $accessoryTypeId\n    ) {\n      serialNumber\n      uniqueAccessoryId\n    }\n  }\n'],['\n  query checkAccessoryAvailableForSubscription(\n    $partnerLoginId: Int!\n    $serialNumber: [AccessoryListInput!]!\n    $accessoryTypeId: Int!\n  ) {\n    validation: checkAccessoryAvailableForSubscription(\n      partnerLoginId: $partnerLoginId\n      serialNumberList: $serialNumber\n      accessoryTypeId: $accessoryTypeId\n    ) {\n      serialNumber\n      uniqueAccessoryId\n    }\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  mutation setSubscriptionInventoryAssignment(\n    $uniqueDeviceIdList: [uniqueDeviceIdListInput!]\n    $uniqueAccessoryIdList: [uniqueAccessoryIdListInput!]\n    $simIdList: [simListInput!]\n    $deviceModelId: Int!\n    $accessoryTypeId: Int\n    $serviceProviderId: Int\n    $unAssignedDeviceQuantity: Int!\n    $unAssignedAccessoryQuantity: Int!\n    $unAssignedSimQuantity: Int!\n    $partnerLoginId: Int!\n    $clientLoginId: Int!\n    $subscriptionId: Int!\n  ) {\n    setSubscriptionInventoryAssignment(\n      uniqueDeviceIdList: $uniqueDeviceIdList\n      uniqueAccessoryIdList: $uniqueAccessoryIdList\n      simList: $simIdList\n      deviceModelId: $deviceModelId\n      accessoryTypeId: $accessoryTypeId\n      serviceProviderId: $serviceProviderId\n      unAssignedDeviceQuantity: $unAssignedDeviceQuantity\n      unAssignedAccessoryQuantity: $unAssignedAccessoryQuantity\n      unAssignedSimQuantity: $unAssignedSimQuantity\n      partnerLoginId: $partnerLoginId\n      clientLoginId: $clientLoginId\n      subscriptionId: $subscriptionId\n    )\n  }\n'],['\n  mutation setSubscriptionInventoryAssignment(\n    $uniqueDeviceIdList: [uniqueDeviceIdListInput!]\n    $uniqueAccessoryIdList: [uniqueAccessoryIdListInput!]\n    $simIdList: [simListInput!]\n    $deviceModelId: Int!\n    $accessoryTypeId: Int\n    $serviceProviderId: Int\n    $unAssignedDeviceQuantity: Int!\n    $unAssignedAccessoryQuantity: Int!\n    $unAssignedSimQuantity: Int!\n    $partnerLoginId: Int!\n    $clientLoginId: Int!\n    $subscriptionId: Int!\n  ) {\n    setSubscriptionInventoryAssignment(\n      uniqueDeviceIdList: $uniqueDeviceIdList\n      uniqueAccessoryIdList: $uniqueAccessoryIdList\n      simList: $simIdList\n      deviceModelId: $deviceModelId\n      accessoryTypeId: $accessoryTypeId\n      serviceProviderId: $serviceProviderId\n      unAssignedDeviceQuantity: $unAssignedDeviceQuantity\n      unAssignedAccessoryQuantity: $unAssignedAccessoryQuantity\n      unAssignedSimQuantity: $unAssignedSimQuantity\n      partnerLoginId: $partnerLoginId\n      clientLoginId: $clientLoginId\n      subscriptionId: $subscriptionId\n    )\n  }\n']);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_PARTNER=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject);var VERIFY_DEVICE=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject2);var VERIFY_SIM=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject3);var GET_SUBSCRIPTION=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject4);var VERIFY_ACCESSORY=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject5);var SAVE_SUBSCRIPTION=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject6);var styles=function styles(theme){return{root:{padding:theme.spacing.unit*2,flexGrow:1},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},input:{display:'none'}};};var AssignPartnerInventory=function(_Component){_inherits(AssignPartnerInventory,_Component);function AssignPartnerInventory(props){var _this2=this;_classCallCheck(this,AssignPartnerInventory);var _this=_possibleConstructorReturn(this,(AssignPartnerInventory.__proto__||Object.getPrototypeOf(AssignPartnerInventory)).call(this,props));_this.getSubscriptions=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _ref2,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.client.query({query:GET_SUBSCRIPTION,variables:{subscriptionId:parseInt(_this.subscriptionId,10)},fetchPolicy:'network-only'});case 2:_ref2=_context.sent;data=_ref2.data;// console.log('sub call')
if(data.getPartnerSubscriptions.unassignedDeviceQuantity>0){_this.setState({deviceStatus:false});}else{_this.setState({simStatus:false,accssoryStatus:false});}_this.setState({deviceModelName:data.getPartnerSubscriptions.deviceModel.model_name,deviceQuantity:data.getPartnerSubscriptions.unassignedDeviceQuantity,deviceModelId:data.getPartnerSubscriptions.deviceModelId// manufacturerCode:
//  data.PartnerSubscription.deviceModel.manufacturer.manufacturerCode
});if(data.getPartnerSubscriptions.accessoryType!==null){_this.setState({accessoryType:data.getPartnerSubscriptions.accessoryType.accessoryName,accessoryTypeId:data.getPartnerSubscriptions.accessoryTypeId,accessoryQuantity:data.getPartnerSubscriptions.unAssignedAccessoryQuantity,accManufacturerCode:data.getPartnerSubscriptions.accessoryType.manufacturer.manufacturerCode});}if(data.getPartnerSubscriptions.serviceProvider!==null){_this.setState({simProviderName:data.getPartnerSubscriptions.serviceProvider.name,simProviderId:data.getPartnerSubscriptions.serviceProviderId,simQuantity:data.getPartnerSubscriptions.unAssignedSimQuantity});}case 8:case'end':return _context.stop();}}},_callee,_this2);}));_this.handleDeviceDuplicate=function(type){return _asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var deviceArr,duplicateDeviceList,deviceArrl;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:deviceArr=_this.state.deviceSerialNo;console.log('1st',deviceArr);deviceArr=deviceArr.split(',').map(Number);console.log('2nd',deviceArr);duplicateDeviceList=_this.state.duplicateDeviceList;// console.log('3rd', this.state.duplicateDeviceList)
duplicateDeviceList=duplicateDeviceList.split(' ').map(Number);deviceArrl=deviceArr.filter(function(el){return!duplicateDeviceList.includes(el);});console.log('4deviceArr',deviceArrl.toString());_this.setState({duplicateDeviceList:'',deviceSerialNo:deviceArrl.toString(),duplicateDeviceError:''});case 9:case'end':return _context2.stop();}}},_callee2,_this2);}));};_this.handleSimDuplicate=function(type){return _asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var simArr,duplicateSimList,simArrl;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:simArr=_this.state.simSerialNo;// console.log('1st', simArr)
simArr=simArr.split(',').map(function(e){return e.trim();});// console.log('2nd', simArr)
duplicateSimList=_this.state.duplicateSimList;duplicateSimList=duplicateSimList.split(' ').map(function(e){return e.trim();});// console.log('3rd', duplicateSimList)
simArrl=simArr.filter(function(el){// console.log(el, duplicateSimList)
return!duplicateSimList.includes(el);});// console.log('4deviceArr', simArrl)
_this.setState({duplicateSimList:'',duplicateSimError:'',simSerialNo:simArrl.toString()});case 6:case'end':return _context3.stop();}}},_callee3,_this2);}));};_this.handleDeviceValidate=function(type){return _asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){var deviceArr,tempArr,verifiedSerialNumbers,_ref6,data,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_this.setState({duplicateDeviceError:''});deviceArr=_this.state.deviceSerialNo.trim().replace(/[^A-Za-z0-9,]/g,'').replace(/\s/g,'').replace(/,{1,}$/,'').replace(/^,{1,}/,'').replace(/,+/g,',').split(',');// Remove Duplicates
deviceArr=[].concat(_toConsumableArray(new Set(deviceArr)));tempArr=[];verifiedSerialNumbers='';deviceArr.forEach(function(serialno){verifiedSerialNumbers=verifiedSerialNumbers+serialno+', ';var temp={};temp.serial_num=serialno;temp.uniqueDeviceId=_this.state.manufacturerCode+'_'+serialno;tempArr.push(temp);});verifiedSerialNumbers=verifiedSerialNumbers.slice(0,verifiedSerialNumbers.length-2);_this.setState({deviceSerialNo:verifiedSerialNumbers});_context4.next=10;return _this.props.client.query({query:VERIFY_DEVICE,variables:{serial_num:tempArr,deviceModelId:parseInt(_this.state.deviceModelId,10),partnerLoginId:parseInt(localStorage.getItem('Login_id'),10)},fetchPolicy:['network-only']});case 10:_ref6=_context4.sent;data=_ref6.data;response='';Object.values(data.validation).map(function(res){return response=response+res['serial_num']+' ';});if(deviceArr.length>_this.state.deviceQuantity){_this.setState({duplicateDeviceList:'You can not assign devices more than requested quantity'});}else{_this.setState({duplicateDeviceList:response});if(response!==''){_this.setState({duplicateDeviceError:'Remove Invalid Serial nos:'});}}if(data.validation.length===0&&deviceArr.length!==0&&deviceArr.length<=_this.state.deviceQuantity){_this.setState({deviceStatus:true});}case 16:case'end':return _context4.stop();}}},_callee4,_this2);}));};_this.handleSimValidate=function(type){return _asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(){var simArr,tempArr,verifiedSerialNumbers,_ref8,data,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_this.setState({duplicateSimError:''});simArr=_this.state.simSerialNo.trim().replace(/[^A-Za-z0-9,]/g,'').replace(/\s/g,'').replace(/,{1,}$/,'').replace(/^,{1,}/,'').replace(/,+/g,',').split(',');// Remove Duplicates
simArr=[].concat(_toConsumableArray(new Set(simArr)));tempArr=[];verifiedSerialNumbers='';if(!(simArr.length>0)){_context5.next=17;break;}simArr.forEach(function(serialno){verifiedSerialNumbers=verifiedSerialNumbers+serialno+', ';var temp={};temp.simNumber=serialno;tempArr.push(temp);});verifiedSerialNumbers=verifiedSerialNumbers.slice(0,verifiedSerialNumbers.length-2);_this.setState({simSerialNo:verifiedSerialNumbers});_context5.next=11;return _this.props.client.query({query:VERIFY_SIM,variables:{simNumber:tempArr,serviceProviderId:parseInt(_this.state.simProviderId,10),partnerLoginId:parseInt(localStorage.getItem('Login_id'),10)},fetchPolicy:['network-only']});case 11:_ref8=_context5.sent;data=_ref8.data;response='';Object.values(data.validation).map(function(res){return response=response+res['simNumber']+' ';});if(simArr.length>_this.state.simQuantity){_this.setState({duplicateSimList:'You can not assign sim more than requested quantity'});}else{_this.setState({duplicateSimList:response});if(response!==''){_this.setState({duplicateSimError:'Remove Invalid Sim nos:'});}}if(data.validation.length===0&&simArr.length!==0&&simArr.length<=_this.state.simQuantity){_this.setState({simStatus:true});}case 17:case'end':return _context5.stop();}}},_callee5,_this2);}));};_this.handleAccessoryValidate=function(type){return _asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(){var accArr,tempArr,verifiedSerialNumbers,_ref10,data,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:accArr=_this.state.accessorySerialNo.trim().replace(/[^A-Za-z0-9,]/g,'').replace(/\s/g,'').replace(/,{1,}$/,'').replace(/^,{1,}/,'').replace(/,+/g,',').split(',');// Remove Duplicates
accArr=[].concat(_toConsumableArray(new Set(accArr)));tempArr=[];verifiedSerialNumbers='';if(!(accArr.length>0)){_context6.next=16;break;}accArr.forEach(function(serialno){verifiedSerialNumbers=verifiedSerialNumbers+serialno+', ';var temp={};temp.serialNumber=parseInt(serialno,10);temp.uniqueAccessoryId=_this.state.accManufacturerCode+'_'+serialno;tempArr.push(temp);});verifiedSerialNumbers=verifiedSerialNumbers.slice(0,verifiedSerialNumbers.length-2);_this.setState({accessorySerialNo:verifiedSerialNumbers});_context6.next=10;return _this.props.client.query({query:VERIFY_ACCESSORY,variables:{serialNumber:tempArr,accessoryTypeId:parseInt(_this.state.accessoryTypeId,10),partnerLoginId:parseInt(localStorage.getItem('Login_id'),10)}});case 10:_ref10=_context6.sent;data=_ref10.data;response='';Object.values(data.validation).map(function(res){return response=response+res['serialNumber']+' ';});if(accArr.length>_this.state.accessoryQuantity){_this.setState({duplicateAccessoryList:'You can not assign Accessory more than requested quantity'});}else{_this.setState({duplicateAccessoryList:response});}if(data.validation.length===0&&accArr.length!==0&&accArr.length<=_this.state.accessoryQuantity){_this.setState({accessoryStatus:true});}case 16:case'end':return _context6.stop();}}},_callee6,_this2);}));};_this.handleChange=function(name){return function(event){_this.setState(_defineProperty({},name,event.target.value));};};_this.handleReset=function(type){return function(event){if(type==='device'){_this.setState({deviceSerialNo:'',deviceUniqueNo:'',deviceStatus:false,duplicateDeviceList:''});}if(type==='sim'){_this.setState({simSerialNo:'',simStatus:false,duplicateSimList:''});}if(type==='accessory'){_this.setState({accessorySerialNo:'',accessoryUniqueNo:'',accessoryStatus:false,duplicateAccessoryList:''});}};};_this.handleSaveAssignment=function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(e){var devices,accessories,sims,deviceArr,simArr,accArr,_ref12,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:devices=[];accessories=[];sims=[];deviceArr=[];simArr=[];accArr=[];if(_this.state.deviceSerialNo!==''){deviceArr=_this.state.deviceSerialNo.replace(/\s/g,'').split(',');deviceArr.forEach(function(serialno){var temp={};temp.uniqueDeviceId=_this.state.manufacturerCode+'_'+serialno;devices.push(temp);});}if(_this.state.simSerialNo!==''){simArr=_this.state.simSerialNo.replace(/\s/g,'').split(',');simArr.forEach(function(serialno){var temp={};temp.simNumber=serialno;sims.push(temp);});}if(_this.state.accessorySerialNo!==''){accArr=_this.state.accessorySerialNo.replace(/\s/g,'').split(',');accArr.forEach(function(serialno){var temp={};temp.uniqueAccessoryId=_this.state.accManufacturerCode+'_'+serialno;accessories.push(temp);});}if(!(deviceArr.length>_this.state.deviceQuantity)){_context7.next=13;break;}_this.props.openSnackbar('Device list exceeds Device Quantity');_context7.next=42;break;case 13:if(!(simArr.length>_this.state.simQuantity)){_context7.next=17;break;}_this.props.openSnackbar('Sim list exceeds Sim Quantity');_context7.next=42;break;case 17:if(!(accArr.length>_this.state.accessoryQuantity)){_context7.next=21;break;}_this.props.openSnackbar('Accessory list exceeds Accessory Quantity');_context7.next=42;break;case 21:if(!(_this.state.duplicateDeviceError!=='')){_context7.next=25;break;}_this.props.openSnackbar('Invalid Device list');_context7.next=42;break;case 25:if(!(_this.state.duplicateSimError!=='')){_context7.next=29;break;}_this.props.openSnackbar('Invalid Sim list');_context7.next=42;break;case 29:_context7.next=31;return _this.props.client.mutate({mutation:SAVE_SUBSCRIPTION,variables:{uniqueDeviceIdList:devices,uniqueAccessoryIdList:accessories,simIdList:sims,deviceModelId:_this.state.deviceModelId,accessoryTypeId:_this.state.accessoryTypeId,serviceProviderId:_this.state.simProviderId,unAssignedDeviceQuantity:_this.state.deviceQuantity-deviceArr.length,unAssignedAccessoryQuantity:_this.state.accessoryQuantity-accArr.length,unAssignedSimQuantity:_this.state.simQuantity-simArr.length,partnerLoginId:parseInt(localStorage.getItem('Login_id'),10),clientLoginId:parseInt(_this.loginId,10),subscriptionId:parseInt(_this.subscriptionId,10)},refetchQueries:[{query:GET_SUBSCRIPTION,variables:{subscriptionId:parseInt(_this.subscriptionId,10)}}]});case 31:_ref12=_context7.sent;data=_ref12.data;if(!(data.setSubscriptionInventoryAssignment===true)){_context7.next=41;break;}_context7.next=36;return _this.props.client.clearStore();case 36:_this.props.openSnackbar('Inventory Assignment Successful');_this.setState({deviceSerialNo:'',deviceUniqueNo:'',deviceStatus:false,duplicateDeviceList:'',simSerialNo:'',simStatus:false,duplicateSimList:'',accessorySerialNo:'',accessoryUniqueNo:'',accessoryStatus:false,duplicateAccessoryList:''});_this.props.history.goBack();_context7.next=42;break;case 41:_this.props.openSnackbar('Inventory Assignment Failed');case 42:case'end':return _context7.stop();}}},_callee7,_this2);}));return function(_x){return _ref11.apply(this,arguments);};}();_this.loginId=_this.props.match.params.loginId;_this.subscriptionId=_this.props.match.params.subscriptionId;_this.state={deviceSerialNo:'',deviceUniqueNo:'',deviceModelId:null,deviceModelName:'',deviceQuantity:'',manufacturerCode:'',duplicateDeviceList:'',simSerialNo:'',simProviderName:'',simProviderId:null,simQuantity:'',duplicateSimList:'',accessorySerialNo:'',accessoryType:'',accessoryTypeId:null,accessoryQuantity:'',accManufacturerCode:'',deviceStatus:true,simStatus:true,accessoryStatus:true,duplicateDeviceError:'',duplicateSimError:''};return _this;}_createClass(AssignPartnerInventory,[{key:'componentDidMount',value:function componentDidMount(){this.getSubscriptions();}},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_apollo__["Query"],{query:GET_PARTNER,variables:{loginId:parseInt(this.loginId,10)},fetchPolicy:'network-only'},function(_ref13){var loading=_ref13.loading,error=_ref13.error,partnerDetail=_ref13.data.partnerDetail;if(loading)return'Loading...';if(error)return'Error!: '+error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Button"],{variant:'outlined',color:'secondary',className:classes.button,onClick:function onClick(){return _this3.props.history.goBack();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_ArrowBack___default.a,{className:classes.iconSmall})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'display3'},partnerDetail.businessName.charAt(0).toUpperCase()+partnerDetail.businessName.slice(1)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],null,'Subscription Id: ',_this3.subscriptionId)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'subheading'},'Assign Inventory',' ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Card___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_CardContent___default.a,null,_this3.state.deviceModelId?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row',alignItems:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'title'},'Device(s)')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'body1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',null,'Model:'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'body2'},_this3.state.deviceModelName)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'body1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',null,'Quantity:'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'body2'},_this3.state.deviceQuantity)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_TextField___default.a,{fullWidth:true,id:'outlined-multiline-flexible',label:'Enter Comma Separated Serial Numbers',rowsMax:'4',multiline:true,value:/* eslint-disable */_this3.state.deviceSerialNo/* eslint-enable */,onChange:_this3.handleChange('deviceSerialNo'),onBlur:_this3.handleDeviceValidate('device'),className:classes.textField,margin:'normal',helperText:_this3.state.duplicateDeviceError+_this3.state.duplicateDeviceList,error:_this3.state.duplicateDeviceList,variant:'outlined'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Button"],{variant:'raised',color:'secondary',className:classes.button,onClick:_this3.handleDeviceValidate('device')},'Validate')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Button"],{variant:'raised',color:'secondary',className:classes.button,onClick:_this3.handleDeviceDuplicate('device')},'Remove')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Button"],{variant:'raised',color:'primary',className:classes.button,onClick:_this3.handleReset('device')},'Reset'))):null,_this3.state.simProviderId?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row',alignItems:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'title'},'SIM(s)')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'body1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',null,'SIM Provider:'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'body2'},_this3.state.simProviderName)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'body1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',null,'Quantity:'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'body2'},_this3.state.simQuantity)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_TextField___default.a,{fullWidth:true,id:'outlined-multiline-flexible',label:'Enter Comma Separated SIM Numbers',multiline:true,rowsMax:'4',value:/* eslint-disable */_this3.state.simSerialNo/* eslint-enable */,onChange:_this3.handleChange('simSerialNo'),onBlur:_this3.handleSimValidate('sim'),className:classes.textField,margin:'normal',helperText:_this3.state.duplicateSimError+_this3.state.duplicateSimList,error:_this3.state.duplicateSimList,variant:'outlined'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Button"],{variant:'raised',color:'secondary',className:classes.button,onClick:_this3.handleSimValidate('sim')},'Validate')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Button"],{variant:'raised',color:'secondary',className:classes.button,onClick:_this3.handleSimDuplicate('sim')},'Remove')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Button"],{variant:'raised',color:'primary',className:classes.button,onClick:_this3.handleReset('sim')},'Reset'))):null,_this3.state.accessoryTypeId?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row',alignItems:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'title'},'Accessory')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'body1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',null,'Accessory Type:'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'body2'},_this3.state.accessoryType)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'body1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',null,'Quantity:'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'body2'},_this3.state.accessoryQuantity)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_TextField___default.a,{fullWidth:true,id:'outlined-multiline-flexible',label:'Enter Comma Separated Serial Numbers',multiline:true,rowsMax:'4',value:/* eslint-disable */_this3.state.accessorySerialNo/* eslint-enable */,onChange:_this3.handleChange('accessorySerialNo'),onBlur:_this3.handleAccessoryValidate('accessory'),className:classes.textField,margin:'normal',helperText:_this3.state.duplicateAccessoryList,error:_this3.state.duplicateAccessoryList,variant:'outlined'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Button"],{variant:'raised',color:'secondary',className:classes.button,onClick:_this3.handleAccessoryValidate('accessory')},'Validate')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Button"],{variant:'raised',color:'primary',className:classes.button,onClick:_this3.handleReset('accessory')},'Reset'))):null))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,justify:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Button"],{color:'secondary',variant:'raised',onClick:_this3.handleSaveAssignment,disabled:(_this3.state.deviceSerialNo===''||_this3.state.duplicateDeviceError!=='')&&(_this3.state.simSerialNo===''||_this3.state.duplicateSimError!=='')&&_this3.state.accessorySerialNo===''},'Save')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Button"],{color:'primary',variant:'raised',href:'../../'},'Cancel')))));});}}]);return AssignPartnerInventory;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);AssignPartnerInventory.propTypes={classes:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired};var withApolloClient=function withApolloClient(Component){return function(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_apollo__["ApolloConsumer"],null,function(client){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component,Object.assign({client:client},props));});};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__["withStyles"])(styles)(withApolloClient(Object(__WEBPACK_IMPORTED_MODULE_12__HOCs_withSharedSnackbar__["a" /* default */])(AssignPartnerInventory))));

/***/ }),
/* 2386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ViewLicense_ViewLicenseInfo_jsx__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_getLoginId__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getAllLicenseTypeResellerAssignDetails($resellerLoginId: Int!) {\n    allPlans: getAllLicenseTypeResellerAssignDetails(\n      resellerLoginId: $resellerLoginId\n    ) {\n      id\n      licenseType {\n        licenseType\n        description\n        maxPrice\n      }\n    }\n  }\n'],['\n  query getAllLicenseTypeResellerAssignDetails($resellerLoginId: Int!) {\n    allPlans: getAllLicenseTypeResellerAssignDetails(\n      resellerLoginId: $resellerLoginId\n    ) {\n      id\n      licenseType {\n        licenseType\n        description\n        maxPrice\n      }\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query getLicenseType($id: Int!) {\n    getLicenseType(id: $id) {\n      licenseType\n      description\n      maxPrice\n      featureList {\n        id\n      }\n    }\n  }\n'],['\n  query getLicenseType($id: Int!) {\n    getLicenseType(id: $id) {\n      licenseType\n      description\n      maxPrice\n      featureList {\n        id\n      }\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var styles=function styles(theme){return{root:{flexGrow:1,padding:theme.spacing.unit*2},paper:{width:'100%'},control:{padding:theme.spacing.unit*1},button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{margin:theme.spacing.unit,minWidth:120}};};var GET_ALL_LICENSE_TYPE=Object(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__["a" /* default */])(_templateObject);var GET_LICENCE_BY_ID=Object(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__["a" /* default */])(_templateObject2);var License=function(_Component){_inherits(License,_Component);function License(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,License);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=License.__proto__||Object.getPrototypeOf(License)).call.apply(_ref,[this].concat(args))),_this),_this.state={licenceArr:[],renderArr:[],licenseDetails:[],modelStatus:false,lId:''},_this.getAllLicenses=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var licenses;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.client.query({query:GET_ALL_LICENSE_TYPE,variables:{resellerLoginId:Object(__WEBPACK_IMPORTED_MODULE_10__utils_getLoginId__["a" /* default */])()}});case 2:licenses=_context.sent;if(licenses&&licenses.data){_this.mapToArr(licenses.data.allPlans);}case 4:case'end':return _context.stop();}}},_callee,_this2);})),_this.columns=['LICENSE NAME','DESCRIPTION','MAX PRICE','VIEW'],_this.createPlan=function(e){_this.props.history.push({pathname:'/home/CreatePlan'});},_this.viewLicenceDetails=function(licenseId){return _asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var _ref4,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this.props.client.query({query:GET_LICENCE_BY_ID,variables:{id:parseInt(licenseId,10)}});case 2:_ref4=_context2.sent;data=_ref4.data;_this.setState({licenseDetails:data,modelStatus:true,lId:licenseId});case 5:case'end':return _context2.stop();}}},_callee2,_this2);}));},_this.closeEditModel=function(){_this.setState({modelStatus:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(License,[{key:'componentDidMount',value:function componentDidMount(){this.getAllLicenses();}},{key:'mapToArr',value:function mapToArr(licenses){var _this3=this;var rowData=[];this.fullData=[];this.loginId=[];licenses.forEach(function(element){rowData=[];rowData.push(element.licenseType.licenseType);rowData.push(element.licenseType.description);rowData.push(element.licenseType.maxPrice);rowData.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:_this3.viewLicenceDetails(12)},'VIEW'));_this3.fullData.push(rowData);});this.setState({renderArr:this.fullData});}},{key:'render',value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row-reverse',justify:'space-between'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Typography"],{variant:'headline'},'Licences'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_mui_datatables___default.a,{data:this.state.renderArr,columns:this.columns})),this.state.modelStatus===true&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ViewLicense_ViewLicenseInfo_jsx__["a" /* default */],{licenseInfo:this.state.licenseDetails,openStatus:this.state.modelStatus,closeEditModelFunction:this.closeEditModel,selectedId:this.state.lId}))));}}]);return License;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_5_react_apollo__["withApollo"])(License)));

/***/ }),
/* 2387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ViewLicenseInfo_jsx__ = __webpack_require__(646);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getAllLicenseType($status: Int) {\n    getAllLicenseType(status: $status) {\n      id\n      licenseType\n      description\n      featureList {\n        id\n        featureName\n        costPerAssetPerMonth\n        featureDescription\n      }\n      maxPrice\n    }\n  }\n'],['\n  query getAllLicenseType($status: Int) {\n    getAllLicenseType(status: $status) {\n      id\n      licenseType\n      description\n      featureList {\n        id\n        featureName\n        costPerAssetPerMonth\n        featureDescription\n      }\n      maxPrice\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query getLicenseType($id: Int!) {\n    getLicenseType(id: $id) {\n      licenseType\n      description\n      maxPrice\n      featureList {\n        id\n      }\n    }\n  }\n'],['\n  query getLicenseType($id: Int!) {\n    getLicenseType(id: $id) {\n      licenseType\n      description\n      maxPrice\n      featureList {\n        id\n      }\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var styles=function styles(theme){return{root:{flexGrow:1,padding:theme.spacing.unit*2},paper:{width:'100%'},control:{padding:theme.spacing.unit*1},button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{margin:theme.spacing.unit,minWidth:120}};};var GET_ALL_LICENSE_TYPE=Object(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__["a" /* default */])(_templateObject);var GET_LICENCE_BY_ID=Object(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__["a" /* default */])(_templateObject2);var ViewLicense=function(_Component){_inherits(ViewLicense,_Component);function ViewLicense(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,ViewLicense);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ViewLicense.__proto__||Object.getPrototypeOf(ViewLicense)).call.apply(_ref,[this].concat(args))),_this),_this.state={licenceArr:[],renderArr:[],licenseDetails:[],modelStatus:false,lId:''},_this.getAllLicenses=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var licenses;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:console.log('hi');_context.next=3;return _this.props.client.query({query:GET_ALL_LICENSE_TYPE,variables:{status:1}});case 3:licenses=_context.sent;if(licenses&&licenses.data){_this.mapToArr(licenses.data.getAllLicenseType);}case 5:case'end':return _context.stop();}}},_callee,_this2);})),_this.columns=['LICENSE NAME','DESCRIPTION','MAX PRICE','EDIT'],_this.createPlan=function(e){_this.props.history.push({pathname:'/home/CreatePlan'});},_this.editLicenceInfo=function(licenseId){return _asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var _ref4,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this.props.client.query({query:GET_LICENCE_BY_ID,variables:{id:parseInt(licenseId,10)}});case 2:_ref4=_context2.sent;data=_ref4.data;_this.setState({licenseDetails:data,modelStatus:true,lId:licenseId});case 5:case'end':return _context2.stop();}}},_callee2,_this2);}));},_this.closeEditModel=function(){_this.setState({modelStatus:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ViewLicense,[{key:'componentDidMount',value:function componentDidMount(){this.getAllLicenses();}},{key:'mapToArr',value:function mapToArr(licenses){var _this3=this;var rowData=[];this.fullData=[];this.loginId=[];licenses.forEach(function(element){rowData=[];rowData.push(element.licenseType);rowData.push(element.description);rowData.push(element.maxPrice);rowData.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:_this3.editLicenceInfo(element.id)},'Edit'));_this3.fullData.push(rowData);});this.setState({renderArr:this.fullData});}},{key:'render',value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row-reverse',justify:'space-between'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:this.createPlan,variant:'raised',color:'secondary'},'Create License'),'  '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Typography"],{variant:'headline'},'Licences'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_mui_datatables___default.a,{data:this.state.renderArr,columns:this.columns// options={this.options}
})),this.state.modelStatus===true&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ViewLicenseInfo_jsx__["a" /* default */],{licenseInfo:this.state.licenseDetails,openStatus:this.state.modelStatus,closeEditModelFunction:this.closeEditModel,selectedId:this.state.lId}))));}}]);return ViewLicense;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_5_react_apollo__["withApollo"])(ViewLicense)));

/***/ }),
/* 2388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_getLoginId__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query allClientDetails($resellerLoginId: Int) {\n    clients: allClientDetails(resellerLoginId: $resellerLoginId) {\n      id\n      clientName\n      contactPerson\n      contactNumber\n      email\n      totalAssignedVehicle\n      licenseType {\n        licenseType\n      }\n      loginId\n    }\n  }\n'],['\n  query allClientDetails($resellerLoginId: Int) {\n    clients: allClientDetails(resellerLoginId: $resellerLoginId) {\n      id\n      clientName\n      contactPerson\n      contactNumber\n      email\n      totalAssignedVehicle\n      licenseType {\n        licenseType\n      }\n      loginId\n    }\n  }\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_CLIENTS=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject);var style=function style(theme){return{root:{padding:theme.spacing.unit*4,flexGrow:1},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},iconSmall:{fontSize:20}};};var Customers=function(_Component){_inherits(Customers,_Component);function Customers(props){_classCallCheck(this,Customers);var _this=_possibleConstructorReturn(this,(Customers.__proto__||Object.getPrototypeOf(Customers)).call(this,props));_this.loginId=[];_this.fullData=[];_this.columns=['CLIENT NAME','CONTACT PERSON','EMAIL','PHONE NUMBER','TOTAL VEHICLES','PLAN'];_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15,onRowClick:function onRowClick(rowData,dataIndex,rowIndex){_this.props.history.push({pathname:'/home/reseller/customers/view/'+_this.loginId[dataIndex.dataIndex]});}};_this.addCustomer=function(e){_this.props.history.push({pathname:'/home/reseller/customers/add'});};_this.classes=props;return _this;}_createClass(Customers,[{key:'mapToArr',value:function mapToArr(clients){var _this2=this;var rowData=[];this.fullData=[];this.loginId=[];clients.forEach(function(element){rowData=[];_this2.loginId.push(element.loginId);rowData.push(element.clientName);rowData.push(element.contactPerson);rowData.push(element.email);rowData.push(element.contactNumber);rowData.push(element.totalAssignedVehicle);if(element.licenseType){rowData.push(element.licenseType.licenseType);}else{rowData.push('NA');}_this2.fullData.push(rowData);});}},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;console.log('getLoginId()',Object(__WEBPACK_IMPORTED_MODULE_8__utils_getLoginId__["a" /* default */])());return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["Query"],{query:GET_CLIENTS,variables:{resellerLoginId:Object(__WEBPACK_IMPORTED_MODULE_8__utils_getLoginId__["a" /* default */])()}},function(_ref){var loading=_ref.loading,error=_ref.error,clients=_ref.data.clients;if(loading)return'Loading...';if(error)return'Error!: '+error;_this3.mapToArr(clients);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row-reverse',justify:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default.a,{color:'secondary',onClick:_this3.addCustomer,variant:'raised',className:_this3.classes.button},'Add Customer')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'headline'},'Customers'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_mui_datatables___default.a,{data:_this3.fullData,columns:_this3.columns,options:_this3.options}))));});}}]);return Customers;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["withStyles"])(style)(Customers));

/***/ }),
/* 2389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormGroup__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Modules_CustomTabs__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_FormHelperText__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_FormHelperText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_FormHelperText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_getLoginId__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  mutation clientSignup(\n    $username: String!\n    $password: String!\n    $accountType: String!\n    $clientName: String!\n    $email: String!\n    $contactPerson: String!\n    $contactNumber: String!\n    $address: String!\n    $city: String!\n    $state: Int!\n    $country: Int!\n    $pincode: Int!\n    $panNumber: String!\n    $gst: String!\n    $licenseTypeId: Int!\n    $resellerLoginId: Int!\n    $clientType: String!\n    $timezone: String!\n  ) {\n    clientSignup(\n      username: $username\n      password: $password\n      accountType: $accountType\n      clientName: $clientName\n      email: $email\n      contactPerson: $contactPerson\n      contactNumber: $contactNumber\n      address: $address\n      city: $city\n      state: $state\n      country: $country\n      pincode: $pincode\n      panNumber: $panNumber\n      gst: $gst\n      licenseTypeId: $licenseTypeId\n      resellerLoginId: $resellerLoginId\n      clientType: $clientType\n      timezone: $timezone\n    )\n  }\n'],['\n  mutation clientSignup(\n    $username: String!\n    $password: String!\n    $accountType: String!\n    $clientName: String!\n    $email: String!\n    $contactPerson: String!\n    $contactNumber: String!\n    $address: String!\n    $city: String!\n    $state: Int!\n    $country: Int!\n    $pincode: Int!\n    $panNumber: String!\n    $gst: String!\n    $licenseTypeId: Int!\n    $resellerLoginId: Int!\n    $clientType: String!\n    $timezone: String!\n  ) {\n    clientSignup(\n      username: $username\n      password: $password\n      accountType: $accountType\n      clientName: $clientName\n      email: $email\n      contactPerson: $contactPerson\n      contactNumber: $contactNumber\n      address: $address\n      city: $city\n      state: $state\n      country: $country\n      pincode: $pincode\n      panNumber: $panNumber\n      gst: $gst\n      licenseTypeId: $licenseTypeId\n      resellerLoginId: $resellerLoginId\n      clientType: $clientType\n      timezone: $timezone\n    )\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query getAllLicenseTypeResellerAssignDetails($resellerLoginId: Int!) {\n    allPlans: getAllLicenseTypeResellerAssignDetails(\n      resellerLoginId: $resellerLoginId\n    ) {\n      id\n      licenseType {\n        licenseType\n        description\n      }\n      licenseTypeId\n    }\n  }\n'],['\n  query getAllLicenseTypeResellerAssignDetails($resellerLoginId: Int!) {\n    allPlans: getAllLicenseTypeResellerAssignDetails(\n      resellerLoginId: $resellerLoginId\n    ) {\n      id\n      licenseType {\n        licenseType\n        description\n      }\n      licenseTypeId\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query checkUsername($username: String!) {\n    checkUsername(username: $username)\n  }\n'],['\n  query checkUsername($username: String!) {\n    checkUsername(username: $username)\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query checkClientName($clientName: String!) {\n    checkClientName(clientName: $clientName)\n  }\n'],['\n  query checkClientName($clientName: String!) {\n    checkClientName(clientName: $clientName)\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  query checkClientContactNumber($phoneno: String!) {\n    checkClientContactNumber(contactNumber: $phoneno)\n  }\n'],['\n  query checkClientContactNumber($phoneno: String!) {\n    checkClientContactNumber(contactNumber: $phoneno)\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  query checkClientEmail($email: String!) {\n    checkClientEmail(email: $email)\n  }\n'],['\n  query checkClientEmail($email: String!) {\n    checkClientEmail(email: $email)\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  query checkClientPanNumber($pan: String!) {\n    checkClientPanNumber(panNumber: $pan)\n  }\n'],['\n  query checkClientPanNumber($pan: String!) {\n    checkClientPanNumber(panNumber: $pan)\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var styles=function styles(theme){return{root:{flexGrow:1,padding:theme.spacing.unit*2}};};var ADD_RESCLIENTS=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject);var GET_ALL_LICENSE=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject2);// username validation
var GET_USERNAME=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject3);// Business name validation
var GET_CLIENT_NAME=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject4);// Business name validation
var GET_CONTACTNO=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject5);// Business email validation
var GET_EMAIL=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject6);// Business pan validation
var GET_PAN_NUMBER=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject7);var RegisterCustomer=function(_Component){_inherits(RegisterCustomer,_Component);function RegisterCustomer(props){var _this2=this;_classCallCheck(this,RegisterCustomer);var _this=_possibleConstructorReturn(this,(RegisterCustomer.__proto__||Object.getPrototypeOf(RegisterCustomer)).call(this,props));_this.handleInputChange=function(e){_this.setState(_defineProperty({},e.target.name,e.target.value));};_this.handleCountryChange=function(country){if(!country){_this.setState({state:'',country:''});}else{_this.setState({state:'',country:country.value});}// console.log(this.state.checkResellerClientPanNumberstate, '=lfdfdfdfdf')
};_this.handlePlanChange=function(plan1){console.log('plan: ',plan1.value);if(!plan1){_this.setState({licenseTypeId:''});}else{_this.setState({licenseTypeId:plan1.value});}};_this.handleTimezoneChange=function(timezone){if(!timezone){_this.setState({timezone:''});}else{_this.setState({timezone:timezone.value});}};_this.handleStateChange=function(state){_this.setState({state:state});};_this.checkNameValidity=function(client){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var regex,_ref2,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:regex=new RegExp(/^(?!\s)(?!.*\s$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9 '~?!]{2,}$/);_context.next=3;return client.query({query:GET_CLIENT_NAME,variables:{clientName:_this.state.name}});case 3:_ref2=_context.sent;data=_ref2.data;_this.setState({isNameValid:regex.test(_this.state.name)&&_this.state.name!==''&&data.checkClientName==='AVAILABLE'});case 6:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();};_this.checkUsernameValidity=function(client){return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(event){var regex,_ref4,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:// checkUsernameValidity = () => {
regex=new RegExp(/^[a-zA-Z0-9.\-_$@*!]{3,30}$/);_context2.next=3;return client.query({query:GET_USERNAME,variables:{username:_this.state.username}});case 3:_ref4=_context2.sent;data=_ref4.data;_this.setState({isUsernameUnique:data.checkUsername==='AVAILABLE',isUsernameValid:regex.test(_this.state.username)&&_this.state.username!==''&&data.checkUsername==='AVAILABLE'});case 6:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref3.apply(this,arguments);};}();};_this.checkContactpValidity=function(){var regex=new RegExp(/^[a-zA-Z\s]+$/);_this.setState({isContactpValid:regex.test(_this.state.person)&&_this.state.person!==''});};_this.checkPasswordValidity=function(){_this.setState({isPasswordValid:_this.state.password!==''});};_this.checkPhonenoValidity=function(client){return function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(event){var regex,_ref6,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:regex=new RegExp(/^(\+91[-\s]?)?[0]?(91)?[789]\d{9}$/);_context3.next=3;return client.query({query:GET_CONTACTNO,variables:{phoneno:_this.state.phoneno}});case 3:_ref6=_context3.sent;data=_ref6.data;console.log('data.checkContactNumber',data.checkClientContactNumber);_this.setState({isPhonenoValid:regex.test(_this.state.phoneno)&&_this.state.phoneno!==''&&data.checkClientContactNumber==='AVAILABLE'});// console.log('isPhonenoValid', this.state.isPhonenoValid)
case 7:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x3){return _ref5.apply(this,arguments);};}();};_this.checkEmailValidity=function(client){return function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(event){var regex,_ref8,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:regex=new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);_context4.next=3;return client.query({query:GET_EMAIL,variables:{email:_this.state.email}});case 3:_ref8=_context4.sent;data=_ref8.data;_this.setState({isEmailValid:regex.test(_this.state.email)&&_this.state.email!==''&&data.checkClientEmail==='AVAILABLE'});case 6:case'end':return _context4.stop();}}},_callee4,_this2);}));return function(_x4){return _ref7.apply(this,arguments);};}();};_this.checkAddressValidity=function(){var regex=new RegExp(/^[a-zA-Z0-9\s,.'-]{3,}$/);_this.setState({isAddressValid:regex.test(_this.state.address1)&&_this.state.address1!==''});};_this.checkCountryValidity=function(){_this.setState({isCountryValid:_this.state.country!==''});};_this.checkCityValidity=function(){var regex=new RegExp(/^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/);_this.setState({isCityValid:regex.test(_this.state.city)&&_this.state.city!==''});};_this.checkPinValidity=function(){var regex=new RegExp(/^[1-9][0-9]{5}$/);_this.setState({isPinValid:regex.test(_this.state.pincode)&&_this.state.pincode!==''});};_this.checkPanValidity=function(client){return function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(event){var regex,_ref10,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:regex=new RegExp(/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/);_context5.next=3;return client.query({query:GET_PAN_NUMBER,variables:{pan:_this.state.pan}});case 3:_ref10=_context5.sent;data=_ref10.data;_this.setState({isPanValid:regex.test(_this.state.pan)&&_this.state.pan!==''&&data.checkClientPanNumber==='AVAILABLE'});case 6:case'end':return _context5.stop();}}},_callee5,_this2);}));return function(_x5){return _ref9.apply(this,arguments);};}();};_this.checkGSTValidity=function(){var regex=new RegExp(/\d{2}[A-Z]{5}\d{4}[A-Z]{1}\d[Z]{1}[A-Z\d]{1}/);_this.setState({isGSTValid:regex.test(_this.state.gst)&&_this.state.gst!==''});};_this.submitForm=function(client){return function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(e){var variables,_ref12,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:e.preventDefault();// console.log(
//   this.state.username,
//   this.state.password,
//   this.state.name,
//   this.state.email,
//   this.state.person,
//   this.state.phoneno,
//   this.state.address1,
//   this.state.address2,
//   this.state.city,
//   parseInt(this.state.state.value, 10),
//   parseInt(this.state.country, 10),
//   parseInt(this.state.pincode, 10),
//   this.state.pan,
//   getLoginId(),
//   parseInt(this.state.licenseTypeId, 10),
//   this.state.timezone,
//   this.state.gst
// )
console.log('inside register customer');variables={username:_this.state.username,password:_this.state.password,accountType:'CLT',clientName:_this.state.name,email:_this.state.email,contactPerson:_this.state.person,contactNumber:_this.state.phoneno,address:_this.state.address1+' '+_this.state.address2,city:_this.state.city,state:parseInt(_this.state.state.value,10),country:parseInt(_this.state.country,10),pincode:parseInt(_this.state.pincode,10),panNumber:_this.state.pan,resellerLoginId:Object(__WEBPACK_IMPORTED_MODULE_16__utils_getLoginId__["a" /* default */])(),licenseTypeId:parseInt(_this.state.licenseTypeId,10),timezone:_this.state.timezone,gst:_this.state.gst,clientType:'Live'};_context6.next=5;return client.mutate({mutation:ADD_RESCLIENTS,variables:variables});case 5:_ref12=_context6.sent;data=_ref12.data;if(data.clientSignup){_this.props.openSnackbar('Registered Successfully');__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('https://n8n-dev.taabi.co/webhook/customer-created',variables).catch(function(webhookError){console.log('customer-created webhook failed',webhookError);});}else{_this.props.openSnackbar('Registartion Failed');}_this.setState({name:'',username:'',person:'',password:'',email:'',phoneno:'',address1:'',address2:'',city:'',state:'',country:'',pincode:'',pan:'',gst:'',plan:'',timezone:'',response:true});case 9:case'end':return _context6.stop();}}},_callee6,_this2);}));return function(_x6){return _ref11.apply(this,arguments);};}();};_this.cancelForm=function(e){_this.setState({name:'',username:'',person:'',password:'',email:'',phoneno:'',address1:'',address2:'',city:'',state:'',country:'',pincode:'',pan:'',gst:'',plan:'',timezone:''});};var timezoneLists=__webpack_require__(187).getTimezones();var timezoneList=timezoneLists.map(function(timezone){return{value:timezone,label:timezone};});_this.state={name:'',username:'',person:'',password:'',email:'',phoneno:'',address1:'',address2:'',city:'',state:'',country:'',pincode:'',pan:'',gst:'',licenseType:'',timezoneList:timezoneList,timezone:'',isEmailValid:true,isPhonenoValid:true,isAddressValid:true,isCityValid:true,isPinValid:true,isPanValid:true,isGSTValid:true,isUsernameValid:true,isNameValid:true,isContactpValid:true,isPasswordValid:true,isUsernameUnique:true,response:false// console.log('timezone', this.state.timezoneList)
};return _this;}// submitForm = addClient => e => {
_createClass(RegisterCustomer,[{key:'render',value:function render(){var _this3=this;var _state=this.state,name=_state.name,username=_state.username,person=_state.person,password=_state.password,email=_state.email,phoneno=_state.phoneno,address1=_state.address1,address2=_state.address2,city=_state.city,state=_state.state,country=_state.country,pincode=_state.pincode,pan=_state.pan,gst=_state.gst;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_apollo__["ApolloConsumer"],null,function(client){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_apollo__["Query"],{query:GET_ALL_LICENSE// Fetch Billing Modes here
,variables:{resellerLoginId:Object(__WEBPACK_IMPORTED_MODULE_16__utils_getLoginId__["a" /* default */])()}},function(_ref13){var loading=_ref13.loading,error=_ref13.error,allPlans=_ref13.data.allPlans;if(loading)return'Loading...';if(error)return'Error!: '+error;var plans=allPlans.map(function(plan){return{value:plan.licenseTypeId,label:plan.licenseType.licenseType};});console.log('allPlans',allPlans);console.log('Plans',plans);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_apollo__["Mutation"],{mutation:ADD_RESCLIENTS},function(addClient,_ref14){var data=_ref14.data,error=_ref14.error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default.a,{variant:'outlined',color:'primary',className:classes.button,onClick:function onClick(){return _this3.props.history.goBack();}},'Back'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{variant:'title'},'Register Customer')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField___default.a// autoComplete="Full Name"
,{name:'name',value:name,type:'text',onChange:_this3.handleInputChange,label:'Full Name',required:true,error:!_this3.state.isNameValid,onBlur:_this3.checkNameValidity(client)}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this3.state.isNameValid?'':'Invalid name'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField___default.a// autoComplete="username"
,{name:'username',value:username,type:'text',onChange:_this3.handleInputChange,required:true,error:!_this3.state.isUsernameValid,onBlur:_this3.checkUsernameValidity(client),label:'User Name'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!_this3.state.isUsernameValid?'Invalid Username':''))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField___default.a,{name:'person',value:person,type:'text',onChange:_this3.handleInputChange,label:'Contact Person',required:true,error:!_this3.state.isContactpValid,onBlur:_this3.checkContactpValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this3.state.isContactpValid?'':'Invalid Contact person'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField___default.a// autoComplete="username"
,{name:'password',value:password,type:'password',onChange:_this3.handleInputChange,label:'Password',error:!_this3.state.isPasswordValid,onBlur:_this3.checkPasswordValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this3.state.isPasswordValid?'':'Invalid-should contain 5 or more characters without blank spaces'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField___default.a// autoComplete="username"
,{name:'email',value:email,type:'text',onChange:_this3.handleInputChange,label:'Email',required:true,error:!_this3.state.isEmailValid,onBlur:_this3.checkEmailValidity(client)}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this3.state.isEmailValid?'':'Invalid Email'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_select__["a" /* default */]// classes={classes}
,{options:plans// components={components}
,value:_this3.state.licenseTypeId,onChange:_this3.handlePlanChange,placeholder:'Select License'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField___default.a// autoComplete="username"
,{name:'phoneno',value:phoneno,type:'text',onChange:_this3.handleInputChange,label:'Phone Number',required:true,error:!_this3.state.isPhonenoValid,onBlur:_this3.checkPhonenoValidity(client)}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this3.state.isPhonenoValid?'':'Invalid Phone No'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_select__["a" /* default */]// classes={classes}
,{options:_this3.state.timezoneList// components={components}
,value:_this3.state.timezone,onChange:_this3.handleTimezoneChange,placeholder:'Select Time Zone'})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Modules_CustomTabs__["a" /* default */],{address1:address1,address2:address2,city:city,state:state,country:country,pincode:pincode,pan:pan,gst:gst,isAddressValid:_this3.state.isAddressValid,isCityValid:_this3.state.isCityValid,isPinValid:_this3.state.isPinValid,isPanValid:_this3.state.isPanValid,isGSTValid:_this3.state.isGSTValid,handleInputChange:_this3.handleInputChange,handleCountryChange:_this3.handleCountryChange,handleStateChange:_this3.handleStateChange,checkAddressValidity:_this3.checkAddressValidity,checkCityValidity:_this3.checkCityValidity,checkPinValidity:_this3.checkPinValidity,checkPanValidity:_this3.checkPanValidity(client),checkGSTValidity:_this3.checkGSTValidity}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,container:true,spacing:8,xs:12,justify:'space-evenly'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default.a,{color:'secondary',variant:'contained'// className={this.classes.button}
,onClick:_this3.submitForm(client),disabled:_this3.state.isEmailValid===false||_this3.state.isPhoneValid===false||_this3.state.isCityValid===false||_this3.state.isPinValid===false||_this3.state.isPanValid===false||_this3.state.isUsernameValid===false||_this3.state.isNameValid===false||_this3.state.isContactpValid===false||_this3.state.isPasswordValid===false||_this3.state.isUsernameUnique===false||name===''||username===''||person===''||password===''||email===''||phoneno===''||address1===''||city===''||state===''||country===''||pincode===''||pan===''||gst===''},'Save')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default.a,{color:'primary',onClick:_this3.cancelForm,variant:'contained'},'Cancel',' ')))));});});});}}]);return RegisterCustomer;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);RegisterCustomer.propTypes={classes:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_15__HOCs_withSharedSnackbar__["a" /* default */])(RegisterCustomer)));

/***/ }),
/* 2390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Paper__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Paper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Card__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_CardContent__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_CardContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_CardContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_IconButton__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_icons_Mail__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_icons_Mail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_icons_Mail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_icons_ContactPhone__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_icons_ContactPhone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_icons_ContactPhone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_icons_Person__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_icons_Person___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_icons_Person__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_icons_LocationOn__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_icons_LocationOn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__material_ui_icons_LocationOn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_icons_LocationCity__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_icons_LocationCity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__material_ui_icons_LocationCity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_icons_Business__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_icons_Business___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__material_ui_icons_Business__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_icons_ArrowBack__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_icons_ArrowBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__material_ui_icons_ArrowBack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Subscriptions_ViewSubscription_subscriptionDetails_jsx__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_fetchClientPublicIp__ = __webpack_require__(166);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query clientDetail($loginId: Int) {\n    clientDetail(loginId: $loginId) {\n      id\n      clientName\n      contactPerson\n      address\n      city\n      state {\n        name\n      }\n      country {\n        name\n      }\n      email\n      contactNumber\n\n      loginId\n\n      totalAssignedVehicle\n      type\n    }\n  }\n'],['\n  query clientDetail($loginId: Int) {\n    clientDetail(loginId: $loginId) {\n      id\n      clientName\n      contactPerson\n      address\n      city\n      state {\n        name\n      }\n      country {\n        name\n      }\n      email\n      contactNumber\n\n      loginId\n\n      totalAssignedVehicle\n      type\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query getAllSubscriptions($partnerLoginId: Int!, $clientLoginId: Int) {\n    allSubscriptions: getAllSubscriptions(\n      partnerLoginId: $partnerLoginId\n      clientLoginId: $clientLoginId\n    ) {\n      id\n      client {\n        loginId\n        clientName\n      }\n      billingMode {\n        billingMode\n      }\n      billingFrequency {\n        frequency\n      }\n      deviceQuantity\n      plan\n      amount\n      createdAt\n    }\n  }\n'],['\n  query getAllSubscriptions($partnerLoginId: Int!, $clientLoginId: Int) {\n    allSubscriptions: getAllSubscriptions(\n      partnerLoginId: $partnerLoginId\n      clientLoginId: $clientLoginId\n    ) {\n      id\n      client {\n        loginId\n        clientName\n      }\n      billingMode {\n        billingMode\n      }\n      billingFrequency {\n        frequency\n      }\n      deviceQuantity\n      plan\n      amount\n      createdAt\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query getClientLoginToken(\n    $clientid: Int!\n    $clientIp: String\n    $source: String\n    $performedByLoginId: Int\n    $performedByUsername: String\n  ) {\n    getClientLoginToken(\n      id: $clientid\n      clientIp: $clientIp\n      source: $source\n      performedByLoginId: $performedByLoginId\n      performedByUsername: $performedByUsername\n    ) {\n      token\n    }\n  }\n'],['\n  query getClientLoginToken(\n    $clientid: Int!\n    $clientIp: String\n    $source: String\n    $performedByLoginId: Int\n    $performedByUsername: String\n  ) {\n    getClientLoginToken(\n      id: $clientid\n      clientIp: $clientIp\n      source: $source\n      performedByLoginId: $performedByLoginId\n      performedByUsername: $performedByUsername\n    ) {\n      token\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query getPartnerDomainConfig($loginId: Int!) {\n    domain: getPartnerDomainConfig(loginId: $loginId)\n  }\n'],['\n  query getPartnerDomainConfig($loginId: Int!) {\n    domain: getPartnerDomainConfig(loginId: $loginId)\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_CLIENTS=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject);var GET_ALL_SUBCRIPTIONS=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject2);var GET_LOGIN_TOKEN=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject3);var GET_CLIENT_DOMAIN=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject4);var styles=function styles(theme){return{root:{flexGrow:1},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},button:{margin:theme.spacing.unit},input:{display:'none'}};};var ViewCustomer=function(_Component){_inherits(ViewCustomer,_Component);function ViewCustomer(props){var _this2=this;_classCallCheck(this,ViewCustomer);var _this=_possibleConstructorReturn(this,(ViewCustomer.__proto__||Object.getPrototypeOf(ViewCustomer)).call(this,props));_this.editCustomer=function(loginId){return function(e){_this.props.history.push({pathname:'/home/reseller/customers/edit/'+_this.loginId});};};_this.handleRegistration=function(e){_this.props.history.push({pathname:'/home/reseller/vehicles/register'});};_this.loginCustomer=function(clientId){return _asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var clientIp,_ref2,data,_ref3,domain,clienturl,win;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:console.log('login');_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_22__utils_fetchClientPublicIp__["a" /* default */])();case 3:clientIp=_context.sent;_context.next=6;return _this.props.client.query({query:GET_LOGIN_TOKEN,variables:{clientid:clientId,clientIp:clientIp,source:'admin-frontend',performedByLoginId:Object(__WEBPACK_IMPORTED_MODULE_21__utils_getLoginId__["a" /* default */])(),performedByUsername:localStorage.getItem('username')}});case 6:_ref2=_context.sent;data=_ref2.data;console.log(data,'data.getClientLoginToken.token');if(!data){_context.next=19;break;}_context.next=12;return _this.props.client.query({query:GET_CLIENT_DOMAIN,variables:{loginId:Object(__WEBPACK_IMPORTED_MODULE_21__utils_getLoginId__["a" /* default */])()}});case 12:_ref3=_context.sent;domain=_ref3.data;console.log(domain,'domain');clienturl='https://'+domain.domain+'/?token='+data.getClientLoginToken.token;console.log('clienturl',clienturl);win=window.open(clienturl,'_blank');win.focus();case 19:case'end':return _context.stop();}}},_callee,_this2);}));};_this.showSubscription=function(subscriptionId){return function(e){_this.props.history.push({pathname:'/home/reseller/subscriptions/view/'+_this.loginId+'/'+subscriptionId});};};_this.allCustomer=function(e){_this.props.history.push({pathname:e,state:{from:_this.props.location.pathname}});};_this.createNewSubscription=function(e){_this.props.history.push({pathname:'/home/reseller/subscriptions/new/'+_this.loginId});};_this.loginId=_this.props.match.params.loginId;return _this;}_createClass(ViewCustomer,[{key:'render',value:function render(){var _this3=this;var classes=this.props;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["Query"],{query:GET_CLIENTS,variables:{loginId:parseInt(this.loginId,10)}},function(_ref4){var loading=_ref4.loading,error=_ref4.error,clientDetail=_ref4.data.clientDetail;if(loading)return'Loading...';if(error)return'Error!: '+error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root,style:{padding:'15px 15px 15px 15px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{float:'left'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{variant:'outlined',color:'secondary',className:classes.button,onClick:function onClick(){return _this3.props.history.goBack();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_icons_ArrowBack___default.a,{className:classes.iconSmall}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{float:'right'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{color:'secondary',variant:'raised',className:classes.button,onClick:_this3.handleRegistration},'Register Devices'),'\xA0\xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{variant:'outlined',color:'primary',className:classes.button,onClick:_this3.editCustomer(clientDetail.loginId)},'Edit'),'\xA0\xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{variant:'outlined',color:'primary',className:classes.button,onClick:_this3.loginCustomer(clientDetail.id)},'Login'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{color:'red',fontSize:'10px',textAlign:'left'}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true,spacing:24},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:9,style:{color:'red',fontSize:'10px',float:'left'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Card___default.a,{className:classes.card,style:{color:'red',fontSize:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'headline',component:'h2',color:'primary'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_IconButton___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_icons_Business___default.a,{color:'primary'})),clientDetail.clientName),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{component:'p'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_IconButton___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_icons_Person___default.a,{color:'primary'})),clientDetail.contactPerson),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{component:'p'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_IconButton___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_icons_LocationOn___default.a,{color:'primary'})),clientDetail.address),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{component:'p'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_IconButton___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_icons_LocationCity___default.a,{color:'primary'})),clientDetail.city,' ',clientDetail.state.name,' ',clientDetail.country.name)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{component:'p',style:{padding:'45px 0 0 0 '}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_IconButton___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_icons_Mail___default.a,{color:'primary'})),clientDetail.email),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{component:'p'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_IconButton___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_icons_ContactPhone___default.a,{color:'primary'})),clientDetail.contactNumber))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Card___default.a,{className:classes.card,style:{color:'red',fontSize:'10px',textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Paper___default.a,{className:classes.paper,style:{padding:'3px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{color:'red',fontSize:'20px'}},clientDetail.totalAssignedVehicle),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{fontSize:'15px',color:'black'}},'Total Devices'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Card___default.a,{className:classes.card,style:{color:'red',fontSize:'10px',textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Paper___default.a,{className:classes.paper,style:{padding:'3px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{color:'red',fontSize:'20px',textAlign:'center'}},Math.floor(0.6*clientDetail.totalAssignedVehicle),' '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{fontSize:'15px',color:'black'}},'Registered Devices ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Card___default.a,{className:classes.card,style:{color:'red',fontSize:'10px',textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Paper___default.a,{className:classes.paper,style:{padding:'3px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{color:'red',fontSize:'20px',textAlign:'center'}},Math.floor(0.4*clientDetail.totalAssignedVehicle),' '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{fontSize:'15px',color:'black'}},' ','Unregistered Devices'))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["Query"],{query:GET_ALL_SUBCRIPTIONS,variables:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_21__utils_getLoginId__["a" /* default */])(),clientLoginId:parseInt(_this3.loginId,10)},errorPolicy:'all'},function(_ref5){var loading=_ref5.loading,error=_ref5.error,data=_ref5.data;if(loading)return'Loading...';if(error){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'sub-heading',color:'error',align:'center'},'No Subscriptions Created!');}// console.log('error2', error)
var allSubscriptions=[];if(data){allSubscriptions=data.allSubscriptions;if(allSubscriptions.length===0){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'sub-heading',color:'error',align:'left'},'No Subscriptions Created! \xA0\xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{color:'secondary',onClick:_this3.createNewSubscription,variant:'contained',className:classes.button},'Create New Subscription'));}}return allSubscriptions.map(function(subscription){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__Subscriptions_ViewSubscription_subscriptionDetails_jsx__["a" /* default */],{clientLoginId:_this3.loginId,showSubscription:_this3.showSubscription,subscriptionId:subscription.id,viewVehicles:true,isDisabled:false,backUrl:_this3.backUrl});});}));});}}]);return ViewCustomer;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);ViewCustomer.propTypes={classes:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["withApollo"])(ViewCustomer)));

/***/ }),
/* 2391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Modules_CustomTabs__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_FormHelperText__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_FormHelperText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_FormHelperText__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query clientDetail($loginId: Int) {\n    clientDetail(loginId: $loginId) {\n      id\n      loginId\n      clientName\n      contactPerson\n      address\n      city\n      timezone\n      gst\n      state {\n        zone_id\n      }\n      country {\n        country_id\n      }\n      email\n      contactNumber\n      login {\n        username\n      }\n      licenseType {\n        id\n        licenseType\n      }\n      pincode\n      panNumber\n      type\n    }\n  }\n'],['\n  query clientDetail($loginId: Int) {\n    clientDetail(loginId: $loginId) {\n      id\n      loginId\n      clientName\n      contactPerson\n      address\n      city\n      timezone\n      gst\n      state {\n        zone_id\n      }\n      country {\n        country_id\n      }\n      email\n      contactNumber\n      login {\n        username\n      }\n      licenseType {\n        id\n        licenseType\n      }\n      pincode\n      panNumber\n      type\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  mutation updateClientDetail(\n    $id: Int!\n    $clientName: String!\n    $login_id: Int!\n    $email: String!\n    $contactPerson: String!\n    $contactNumber: String!\n    $address: String!\n    $city: String!\n    $state_id: Int!\n    $country_id: Int!\n    $pincode: Int!\n    $panNumber: String!\n    $clientType: String!\n    $status: Int!\n    $resellLoginId: Int\n    $timezone: String!\n    $gst: String!\n    $plan: Int\n  ) {\n    updateClientDetail(\n      id: $id\n      clientName: $clientName\n      login_id: $login_id\n      email: $email\n      contactPerson: $contactPerson\n      contactNumber: $contactNumber\n      address: $address\n      city: $city\n      state_id: $state_id\n      country_id: $country_id\n      pincode: $pincode\n      panNumber: $panNumber\n      clientType: $clientType\n      status: $status\n      resellLoginId: $resellLoginId\n      timezone: $timezone\n      gst: $gst\n      licenseTypeId: $plan\n    )\n  }\n'],['\n  mutation updateClientDetail(\n    $id: Int!\n    $clientName: String!\n    $login_id: Int!\n    $email: String!\n    $contactPerson: String!\n    $contactNumber: String!\n    $address: String!\n    $city: String!\n    $state_id: Int!\n    $country_id: Int!\n    $pincode: Int!\n    $panNumber: String!\n    $clientType: String!\n    $status: Int!\n    $resellLoginId: Int\n    $timezone: String!\n    $gst: String!\n    $plan: Int\n  ) {\n    updateClientDetail(\n      id: $id\n      clientName: $clientName\n      login_id: $login_id\n      email: $email\n      contactPerson: $contactPerson\n      contactNumber: $contactNumber\n      address: $address\n      city: $city\n      state_id: $state_id\n      country_id: $country_id\n      pincode: $pincode\n      panNumber: $panNumber\n      clientType: $clientType\n      status: $status\n      resellLoginId: $resellLoginId\n      timezone: $timezone\n      gst: $gst\n      licenseTypeId: $plan\n    )\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query getAllLicenseTypeResellerAssignDetails($resellerLoginId: Int!) {\n    allPlans: getAllLicenseTypeResellerAssignDetails(\n      resellerLoginId: $resellerLoginId\n    ) {\n      id\n      licenseType {\n        licenseType\n        description\n      }\n    }\n  }\n'],['\n  query getAllLicenseTypeResellerAssignDetails($resellerLoginId: Int!) {\n    allPlans: getAllLicenseTypeResellerAssignDetails(\n      resellerLoginId: $resellerLoginId\n    ) {\n      id\n      licenseType {\n        licenseType\n        description\n      }\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query checkClientName($id: Int, $businessname: String!) {\n    checkClientName(id: $id, clientName: $businessname)\n  }\n'],['\n  query checkClientName($id: Int, $businessname: String!) {\n    checkClientName(id: $id, clientName: $businessname)\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  query checkUsername($id: Int, $username: String!) {\n    checkUsername(id: $id, username: $username)\n  }\n'],['\n  query checkUsername($id: Int, $username: String!) {\n    checkUsername(id: $id, username: $username)\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  query checkClientContactNumber($id: Int, $phoneno: String!) {\n    checkClientContactNumber(id: $id, contactNumber: $phoneno)\n  }\n'],['\n  query checkClientContactNumber($id: Int, $phoneno: String!) {\n    checkClientContactNumber(id: $id, contactNumber: $phoneno)\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  query checkClientEmail($id: Int, $email: String!) {\n    checkClientEmail(id: $id, email: $email)\n  }\n'],['\n  query checkClientEmail($id: Int, $email: String!) {\n    checkClientEmail(id: $id, email: $email)\n  }\n']),_templateObject8=_taggedTemplateLiteral(['\n  query checkClientPanNumber($id: Int, $pan: String!) {\n    checkClientPanNumber(id: $id, panNumber: $pan)\n  }\n'],['\n  query checkClientPanNumber($id: Int, $pan: String!) {\n    checkClientPanNumber(id: $id, panNumber: $pan)\n  }\n']);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var styles=function styles(theme){return{root:{flexGrow:1,padding:theme.spacing.unit*2}};};var GET_CLIENT=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject);var UPDATE_CLIENT=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject2);var GET_ALL_LICENSE=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject3);// Business name validation
var GET_CLIENT_NAME=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject4);// username validation
var GET_USERNAME=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject5);// Business name validation
var GET_CONTACTNO=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject6);// Business email validation
var GET_EMAIL=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject7);// Business pan validation
var GET_PAN_NUMBER=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject8);var EditCustomer=function(_Component){_inherits(EditCustomer,_Component);function EditCustomer(props){var _this2=this;_classCallCheck(this,EditCustomer);var _this=_possibleConstructorReturn(this,(EditCustomer.__proto__||Object.getPrototypeOf(EditCustomer)).call(this,props));_this.getClients=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _ref2,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.client.query({query:GET_CLIENT,variables:{loginId:parseInt(_this.loginId,10)}});case 2:_ref2=_context.sent;data=_ref2.data;_this.setDetails(data.clientDetail);case 5:case'end':return _context.stop();}}},_callee,_this2);}));_this.setDetails=function(clientDetail){console.log('clientDetail',clientDetail);_this.setState({clientId:clientDetail.id,name:clientDetail.clientName,username:clientDetail.login.username,person:clientDetail.contactPerson,email:clientDetail.email,phoneno:clientDetail.contactNumber,address1:clientDetail.address,city:clientDetail.city,state:clientDetail.state.zone_id,country:clientDetail.country.country_id,pincode:clientDetail.pincode,pan:clientDetail.panNumber,// timezone: { value: clientDetail.timezone, label: clientDetail.timezone },
// plan: clientDetail.licenseType.id,
timezone:clientDetail.timezone,gst:clientDetail.gst});if(clientDetail.licenseType!==null){_this.setState({plan:{value:clientDetail.licenseType.id,label:clientDetail.licenseType.licenseType}});console.log('plan',_this.state.plan);}};_this.handleInputChange=function(e){_this.setState(_defineProperty({},e.target.name,e.target.value));};_this.handleCountryChange=function(country){if(!country){_this.setState({state:'',country:''});}else{_this.setState({state:'',country:country.value});}};_this.handleStateChange=function(state){_this.setState({state:state});};_this.handlePlanChange=function(plan){if(!plan){_this.setState({plan:''});}else{_this.setState({plan:plan.value});}console.log('lic',_this.state.plan);};_this.handleTimezoneChange=function(timezone){if(!timezone){_this.setState({timezone:''});}else{_this.setState({timezone:timezone.value});}console.log('timezone',_this.state.timezone,timezone.value);};_this.checkNameValidity=function(client){return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(event){var regex,_ref4,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:regex=new RegExp(/^(?!\s)(?!.*\s$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9 '~?!]{2,}$/);_context2.next=3;return client.query({query:GET_CLIENT_NAME,variables:{id:parseInt(_this.state.clientId,10),businessname:_this.state.name}});case 3:_ref4=_context2.sent;data=_ref4.data;console.log('name',data);_this.setState({isNameValid:regex.test(_this.state.name)&&_this.state.name!==''&&data.checkClientName==='AVAILABLE'});case 7:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x){return _ref3.apply(this,arguments);};}();};_this.checkUsernameValidity=function(client){return function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(event){var regex,_ref6,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:// checkUsernameValidity = () => {
regex=new RegExp(/^[a-zA-Z0-9.\-_$@*!]{3,30}$/);_context3.next=3;return client.query({query:GET_USERNAME,variables:{id:parseInt(_this.state.login_id,10),username:_this.state.username}});case 3:_ref6=_context3.sent;data=_ref6.data;_this.setState({isUsernameUnique:data.checkUsername==='AVAILABLE',isUsernameValid:regex.test(_this.state.username)&&_this.state.username!==''&&data.checkUsername==='AVAILABLE'});case 6:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x2){return _ref5.apply(this,arguments);};}();};_this.checkContactpValidity=function(){var regex=new RegExp(/^[a-zA-Z\s]+$/);_this.setState({isContactpValid:regex.test(_this.state.person)&&_this.state.person!==''});};_this.checkPasswordValidity=function(){// const regex = new RegExp(/^((?!.*[\s])(?=.*[A-Z])(?=.*\d).{5,10})/)
var regex=new RegExp(/^[a-zA-Z0-9.\-_$@*!]{3,20}$/);console.log('pass=',regex.test(_this.state.password));_this.setState({isPasswordValid:_this.state.password!==''&&regex.test(_this.state.password)});};_this.checkPhonenoValidity=function(client){return function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(event){var regex,_ref8,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:regex=new RegExp(/^(\+91[-\s]?)?[0]?(91)?[1-9]\d{9,12}$/);_context4.next=3;return client.query({query:GET_CONTACTNO,variables:{id:parseInt(_this.state.clientId,10),phoneno:_this.state.phoneno}});case 3:_ref8=_context4.sent;data=_ref8.data;_this.setState({isPhonenoValid:regex.test(_this.state.phoneno)&&_this.state.phoneno!==''&&data.checkResellerContactNumber==='AVAILABLE'});case 6:case'end':return _context4.stop();}}},_callee4,_this2);}));return function(_x3){return _ref7.apply(this,arguments);};}();};_this.checkEmailValidity=function(client){return function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(event){var regex,_ref10,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:regex=new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);_context5.next=3;return client.query({query:GET_EMAIL,variables:{id:parseInt(_this.state.clientId,10),email:_this.state.email}});case 3:_ref10=_context5.sent;data=_ref10.data;_this.setState({isEmailValid:regex.test(_this.state.email)&&_this.state.email!==''&&data.checkResellerEmail==='AVAILABLE'});case 6:case'end':return _context5.stop();}}},_callee5,_this2);}));return function(_x4){return _ref9.apply(this,arguments);};}();};_this.checkAddressValidity=function(){var regex=new RegExp(/^[a-zA-Z0-9\s,.'-]{3,}$/);_this.setState({isAddressValid:regex.test(_this.state.address1)&&_this.state.address1!==''});};_this.checkCityValidity=function(){var regex=new RegExp(/^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/);_this.setState({isCityValid:regex.test(_this.state.city)&&_this.state.city!==''});};_this.checkPinValidity=function(){var regex=new RegExp(/^[1-9][0-9]{5}$/);_this.setState({isPinValid:regex.test(_this.state.pincode)&&_this.state.pincode!==''});};_this.checkPanValidity=function(client){return function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(event){var regex,_ref12,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:regex=new RegExp(/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/);_context6.next=3;return client.query({query:GET_PAN_NUMBER,variables:{id:parseInt(_this.state.clientId,10),pan:_this.state.pan}});case 3:_ref12=_context6.sent;data=_ref12.data;_this.setState({isPanValid:regex.test(_this.state.pan)&&_this.state.pan!==''&&data.checkClientPanNumber==='AVAILABLE'});case 6:case'end':return _context6.stop();}}},_callee6,_this2);}));return function(_x5){return _ref11.apply(this,arguments);};}();};_this.checkGSTValidity=function(){var regex=new RegExp(/\d{2}[A-Z]{5}\d{4}[A-Z]{1}\d[Z]{1}[A-Z\d]{1}/);_this.setState({isGSTValid:regex.test(_this.state.gst)&&_this.state.gst!==''});};_this.submitForm=function(addClient){return function(e){e.preventDefault();addClient({variables:{id:parseInt(_this.state.clientId,10),clientName:_this.state.name,login_id:parseInt(_this.loginId,10),email:_this.state.email,contactPerson:_this.state.person,contactNumber:_this.state.phoneno,address:_this.state.address1+' '+_this.state.address2,city:_this.state.city,state_id:parseInt(_this.state.state,10),country_id:parseInt(_this.state.country,10),pincode:parseInt(_this.state.pincode,10),panNumber:_this.state.pan,clientType:'Live',subscriptionPlan:'prepaid',periodicity:1,status:1,resellLoginId:Object(__WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__["a" /* default */])(),plan:parseInt(_this.state.plan.value,10),timezone:_this.state.timezone,gst:_this.state.gst}});_this.setState({clientId:'',name:'',username:'',person:'',password:'',email:'',phoneno:'',address1:'',address2:'',city:'',state:'',country:'',pincode:'',pan:'',gst:'',plan:'',timezone:''});};};_this.cancelForm=function(e){_this.setState({clientId:'',name:'',username:'',person:'',password:'',email:'',phoneno:'',address1:'',address2:'',city:'',state:'',country:'',pincode:'',pan:'',gst:'',plan:'',timezone:''});};_this.loginId=_this.props.match.params.loginId;var timezoneLists=__webpack_require__(187).getTimezones();var timezoneList=timezoneLists.map(function(timezone){return{value:timezone,label:timezone};});_this.state={clientId:'',name:'',username:'',person:'',password:'',email:'',phoneno:'',address1:'',address2:'',city:'',state:'',country:'',pincode:'',pan:'',gst:'',plan:'',timezoneList:timezoneList,timezone:'',isEmailValid:true,isPhonenoValid:true,isAddressValid:true,isCityValid:true,isPinValid:true,isPanValid:true,isGSTValid:true,isUsernameValid:true,isNameValid:true,isContactpValid:true,isPasswordValid:true,isUsernameUnique:true,response:false};return _this;}_createClass(EditCustomer,[{key:'componentDidMount',value:function componentDidMount(){this.getClients();}},{key:'render',value:function render(){var _this3=this;var _state=this.state,name=_state.name,username=_state.username,person=_state.person,password=_state.password,email=_state.email,phoneno=_state.phoneno,address1=_state.address1,address2=_state.address2,city=_state.city,state=_state.state,country=_state.country,pincode=_state.pincode,pan=_state.pan,gst=_state.gst,plan=_state.plan;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_apollo__["Query"],{query:GET_ALL_LICENSE// Fetch Billing Modes here
,variables:{resellerLoginId:Object(__WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__["a" /* default */])()}},function(_ref13){var loading=_ref13.loading,error=_ref13.error,allPlans=_ref13.data.allPlans;if(loading)return'Loading...';if(error)return'Error!: '+error;var plans=allPlans.map(function(plan){return{value:plan.id,label:plan.licenseType.licenseType};});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_apollo__["Mutation"],{mutation:UPDATE_CLIENT},function(addClient,_ref14){var data=_ref14.data,error=_ref14.error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'title'},'Edit Customer')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a// autoComplete="username"
,{name:'name',value:name,type:'text',onChange:_this3.handleInputChange,label:'Full Name',required:true,error:!_this3.state.isNameValid,onBlur:_this3.checkNameValidity(_this3.props.client)}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this3.state.isNameValid?'':'Invalid name'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a// autoComplete="username"
,{name:'username',value:username,type:'text',onChange:_this3.handleInputChange,label:'Username',required:true,error:!_this3.state.isUsernameValid,onBlur:_this3.checkUsernameValidity(_this3.props.client)}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a// autoComplete="username"
,{name:'person',value:person,type:'text',onChange:_this3.handleInputChange,label:'Contact Person',required:true,error:!_this3.state.isContactpValid,onBlur:_this3.checkContactpValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this3.state.isContactpValid?'':'Invalid Contact person'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a// autoComplete="username"
,{name:'password',value:password,type:'password',onChange:_this3.handleInputChange,label:'Password',error:!_this3.state.isPasswordValid,onBlur:_this3.checkPasswordValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this3.state.isPasswordValid?'':'Password should be 3-20 charcaters without blank space'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a// autoComplete="username"
,{name:'email',value:email,type:'text',onChange:_this3.handleInputChange,label:'Email',required:true,error:!_this3.state.isEmailValid,onBlur:_this3.checkEmailValidity(_this3.props.client)}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},_this3.state.isEmailValid?'':'Invalid Email'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_select__["a" /* default */]// classes={classes}
,{options:plans// components={components}
,value:plan,onChange:_this3.handlePlanChange,placeholder:'Select License'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_TextField___default.a// autoComplete="username"
,{name:'phoneno',value:phoneno,type:'text',onChange:_this3.handleInputChange,label:'Phone Number',required:true,error:!_this3.state.isPhonenoValid,onBlur:_this3.checkPhonenoValidity(_this3.props.client)}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_select__["a" /* default */]// classes={classes}
,{options:_this3.state.timezoneList// components={components}
,value:_this3.state.timezone,onChange:_this3.handleTimezoneChange,placeholder:'Select Time Zone'})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Modules_CustomTabs__["a" /* default */],{address1:address1,address2:address2,city:city,state:state,country:country,pincode:pincode,pan:pan,gst:gst,handleInputChange:_this3.handleInputChange,handleCountryChange:_this3.handleCountryChange,handleStateChange:_this3.handleStateChange,isAddressValid:_this3.state.isAddressValid,isCityValid:_this3.state.isCityValid,isPinValid:_this3.state.isPinValid,isPanValid:_this3.state.isPanValid,isGSTValid:_this3.state.isGSTValid}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,xs:12,justify:'space-evenly'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Button___default.a,{color:'primary',variant:'flat'// className={this.classes.button}
,onClick:_this3.submitForm(addClient)},'Save',' ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Button___default.a,{color:'inherit'// className={this.classes.button}
,onClick:_this3.cancelForm},'Cancel',' ')))));});});}}]);return EditCustomer;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var withApolloClient=function withApolloClient(Component){return function(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_apollo__["ApolloConsumer"],null,function(client){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component,Object.assign({client:client},props));});};};EditCustomer.propTypes={classes:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__["withStyles"])(styles)(withApolloClient(EditCustomer)));

/***/ }),
/* 2392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_getLoginId__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getAllResellerSubscriptions($resellerLoginId: Int!) {\n    getAllResellerSubscriptions(resellerLoginId: $resellerLoginId) {\n      id\n      client {\n        loginId\n        clientName\n      }\n      billingMode {\n        billingMode\n      }\n      billingFrequency {\n        frequency\n      }\n      deviceQuantity\n      deviceModel {\n        model_name\n      }\n      serviceProvider{\n        name\n      }\n      licenseType {\n        licenseType\n      }\n      licenseTypeId\n      amount\n    }\n  }\n'],['\n  query getAllResellerSubscriptions($resellerLoginId: Int!) {\n    getAllResellerSubscriptions(resellerLoginId: $resellerLoginId) {\n      id\n      client {\n        loginId\n        clientName\n      }\n      billingMode {\n        billingMode\n      }\n      billingFrequency {\n        frequency\n      }\n      deviceQuantity\n      deviceModel {\n        model_name\n      }\n      serviceProvider{\n        name\n      }\n      licenseType {\n        licenseType\n      }\n      licenseTypeId\n      amount\n    }\n  }\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// TODO: Replace this query with the one to get all subscriptions associated with a loginId
var GET_ALL_SUBSCRIPTION=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject);var style=function style(theme){return{root:{padding:theme.spacing.unit*4,flexGrow:1},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},iconSmall:{fontSize:20}};};var Subscriptions=function(_Component){_inherits(Subscriptions,_Component);function Subscriptions(props){_classCallCheck(this,Subscriptions);var _this=_possibleConstructorReturn(this,(Subscriptions.__proto__||Object.getPrototypeOf(Subscriptions)).call(this,props));_this.clientId=[];_this.fullData=[];_this.columns=['CUSTOMER NAME','PLAN','DEVICE COUNT','MODEL NAME','SERVICE PROVIDER','BILLING MODE','BILLING FREQUENCY','AMOUNT'];_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15,onRowClick:function onRowClick(rowData,dataIndex,rowIndex){_this.props.history.push({pathname:'/home/reseller/subscriptions/view/'+_this.clientId[dataIndex.dataIndex]+'/'+_this.subcriptionId[dataIndex.dataIndex]// pathname: '/home/subscriptions/view/' + this.clientId[rowIndex]
});}};_this.createNewSubscription=function(e){_this.props.history.push({pathname:'/home/reseller/subscriptions/new'});};_this.classes=props;return _this;}_createClass(Subscriptions,[{key:'mapToArr',value:function mapToArr(allSubscriptions){var _this2=this;var rowData=[];this.fullData=[];this.clientId=[];this.subcriptionId=[];allSubscriptions.forEach(function(element){rowData=[];_this2.clientId.push(element.client.loginId);_this2.subcriptionId.push(element.id);rowData.push(element.client.clientName);if(element.licenseType){rowData.push(element.licenseType.licenseType);}else{rowData.push('NA');}rowData.push(element.deviceQuantity);rowData.push(element.deviceModel.model_name);if(element.serviceProvider===null||element.serviceProvider===undefined){rowData.push('NA');}else{rowData.push(element.serviceProvider.name);}rowData.push(element.billingMode.billingMode);rowData.push(element.billingFrequency.frequency);rowData.push(element.amount);_this2.fullData.push(rowData);});}},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["Query"],{query:GET_ALL_SUBSCRIPTION// TODO: Change Query
,variables:{resellerLoginId:Object(__WEBPACK_IMPORTED_MODULE_9__utils_getLoginId__["a" /* default */])()}},function(_ref){var loading=_ref.loading,error=_ref.error,data=_ref.data;if(loading)return'Loading...';if(error)return'Error!: '+error;console.log('allSubscriptions',data);_this3.mapToArr(data.getAllResellerSubscriptions);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row-reverse',justify:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default.a,{color:'secondary',onClick:_this3.createNewSubscription,variant:'contained',className:classes.button},'New Subscription')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'headline'},'All Subscriptions'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_mui_datatables___default.a,{data:_this3.fullData,columns:_this3.columns,options:_this3.options}))));});}}]);return Subscriptions;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Subscriptions.propTypes={classes:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__["withStyles"])(style)(Subscriptions));

/***/ }),
/* 2393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__subscriptionDetails_jsx__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_ArrowBack__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_ArrowBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_ArrowBack__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query clientDetail($loginId: Int) {\n    clientDetail: clientDetail(loginId: $loginId) {\n      id\n      clientName\n      contactPerson\n      address\n      city\n      state {\n        name\n      }\n      country {\n        name\n      }\n      email\n      contactNumber\n      loginId\n      totalAssignedVehicle\n      type\n    }\n  }\n'],['\n  query clientDetail($loginId: Int) {\n    clientDetail: clientDetail(loginId: $loginId) {\n      id\n      clientName\n      contactPerson\n      address\n      city\n      state {\n        name\n      }\n      country {\n        name\n      }\n      email\n      contactNumber\n      loginId\n      totalAssignedVehicle\n      type\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query getAllVehicleDetails($clientLoginId: Int) {\n    vehicles: getAllVehicleDetails(clientLoginId: $clientLoginId) {\n      vehicleNumber\n      entityId\n      speedSensorType\n      speedLimit\n      vehicleType\n      vehicleModel\n    }\n  }\n'],['\n  query getAllVehicleDetails($clientLoginId: Int) {\n    vehicles: getAllVehicleDetails(clientLoginId: $clientLoginId) {\n      vehicleNumber\n      entityId\n      speedSensorType\n      speedLimit\n      vehicleType\n      vehicleModel\n    }\n  }\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_CLIENT=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject);var GET_VEHICLES=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject2);var styles=function styles(theme){return{root:{padding:theme.spacing.unit*2,flexGrow:1},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},input:{display:'none'}};};var ViewSubscription=function(_Component){_inherits(ViewSubscription,_Component);function ViewSubscription(props){_classCallCheck(this,ViewSubscription);var _this=_possibleConstructorReturn(this,(ViewSubscription.__proto__||Object.getPrototypeOf(ViewSubscription)).call(this,props));_this.columns1=['VEHICLE NUMBER','SPEED SENSOR','SPEED LIMIT','VEHICLE TYPE','VEHICLE MODEL'];_this.options1={selectableRows:false,responsive:'scroll',rowsPerPage:5,onRowClick:function onRowClick(rowData,dataIndex,rowIndex){_this.props.history.push({pathname:'/home/reseller/vehicles/edit/'+_this.entityId[dataIndex.dataIndex]});}};_this.editCustomer=function(loginId){return function(e){_this.props.history.push({pathname:'/home/reseller/customers/edit/'+loginId});};};_this.editSubscription=function(e){_this.props.history.push({pathname:'/home/reseller/subscriptions/edit/'+_this.loginId+'/'+_this.subscriptionId});};_this.showSubscription=function(value){return function(e){// this.props.history.push({
//   pathname: '/home/subscriptions/view-detail/' + this.subscriptionId
// })
};};_this.mapToArr=function(data){var rowData=[];var fullData=[];_this.entityId=[];data.forEach(function(element){rowData=[];_this.entityId.push(element.entityId);rowData.push(element.vehicleNumber);rowData.push(element.speedSensorType);rowData.push(element.speedLimit);rowData.push(element.vehicleType);rowData.push(element.vehicleModel);fullData.push(rowData);});return fullData;};_this.loginId=_this.props.match.params.loginId;_this.subscriptionId=_this.props.match.params.subscriptionId;return _this;}_createClass(ViewSubscription,[{key:'render',value:function render(){var _this2=this;var classes=this.props.classes;console.log('cl',this.loginId);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_apollo__["Query"],{query:GET_CLIENT,variables:{loginId:parseInt(this.loginId,10)}},function(_ref){var loading=_ref.loading,error=_ref.error,clientDetail=_ref.data.clientDetail;if(loading)return'Loading...';if(error)return'Error!: '+error;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_apollo__["Query"],{query:GET_VEHICLES// TODO: Change Query
,variables:{clientLoginId:parseInt(_this2.loginId,10)}},function(_ref2){var loading=_ref2.loading,error=_ref2.error,vehicles=_ref2.data.vehicles;if(loading)return'Loading...';if(error)return'Error!: '+error;var VehData=_this2.mapToArr(vehicles);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row-reverse',justify:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default.a,{variant:'raised',color:'primary',className:classes.button,onClick:_this2.editSubscription},'Edit')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Button___default.a,{variant:'outlined',color:'secondary',className:classes.button// onClick={this.viewAllSubscription}
,onClick:function onClick(){return _this2.props.history.goBack();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_ArrowBack___default.a,{className:classes.iconSmall})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'display1',gutterBottom:true},'\xA0',clientDetail.clientName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__subscriptionDetails_jsx__["a" /* default */],{clientDetail:clientDetail,showSubscription:_this2.showSubscription,subscriptionId:_this2.subscriptionId,clientLoginId:_this2.loginId,isDisabled:true})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_mui_datatables___default.a,{title:'Assigned Vehicles',data:VehData,columns:_this2.columns1,options:_this2.options1}))));});}));}}]);return ViewSubscription;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ViewSubscription.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__["withStyles"])(styles)(ViewSubscription));

/***/ }),
/* 2394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Modules_CustomerDetailsCard__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__subscriptionDetails_jsx__ = __webpack_require__(2395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_getLoginId__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query allClientDetails($resellerLoginId: Int) {\n    clients: allClientDetails(resellerLoginId: $resellerLoginId) {\n      id\n      clientName\n      loginId\n    }\n  }\n'],['\n  query allClientDetails($resellerLoginId: Int) {\n    clients: allClientDetails(resellerLoginId: $resellerLoginId) {\n      id\n      clientName\n      loginId\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query clientDetail($id: Int) {\n    clientDetail(loginId: $id) {\n      id\n      clientName\n      contactPerson\n      address\n      city\n      state {\n        zone_id\n      }\n      country {\n        country_id\n      }\n      email\n      contactNumber\n      login {\n        username\n      }\n      pincode\n      panNumber\n      licenseType {\n        id\n        licenseType\n      }\n    }\n  }\n'],['\n  query clientDetail($id: Int) {\n    clientDetail(loginId: $id) {\n      id\n      clientName\n      contactPerson\n      address\n      city\n      state {\n        zone_id\n      }\n      country {\n        country_id\n      }\n      email\n      contactNumber\n      login {\n        username\n      }\n      pincode\n      panNumber\n      licenseType {\n        id\n        licenseType\n      }\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation addResellerSubscriptions(\n    $clientLoginId: Int!\n    $resellerLoginId: Int!\n    $billingModeId: Int!\n    $billingFrequencyId: Int!\n    $deviceModelId: Int!\n    $deviceQuantity: Int!\n    $unAssignedDeviceQuantity: Int!\n    $serviceProviderId: Int\n    $simQuantity: Int\n    $unAssignedSimQuantity: Int\n    $amount: Int!\n    $billingdate: Int!\n    $gst: Float!\n    $grandTotalAmount: Int!\n    $billingLogicId: Int\n    $licenseTypeId: Int\n    $licenseQuantity: Int\n    $unAssignedLicenseQuantity: Int\n  ) {\n    addResellerSubscriptions(\n      clientLoginId: $clientLoginId\n      resellerLoginId: $resellerLoginId\n      billingModeId: $billingModeId\n      billingFrequencyId: $billingFrequencyId\n      deviceModelId: $deviceModelId\n      deviceQuantity: $deviceQuantity\n      unAssignedDeviceQuantity: $unAssignedDeviceQuantity\n      serviceProviderId: $serviceProviderId\n      simQuantity: $simQuantity\n      unAssignedSimQuantity: $unAssignedSimQuantity\n      amount: $amount\n      billingDay: $billingdate\n      gst: $gst\n      totalAmount: $grandTotalAmount\n      billingLogicId: $billingLogicId\n      licenseTypeId: $licenseTypeId\n      licenseQuantity: $licenseQuantity\n      unAssignedLicenseQuantity: $unAssignedLicenseQuantity\n    )\n  }\n'],['\n  mutation addResellerSubscriptions(\n    $clientLoginId: Int!\n    $resellerLoginId: Int!\n    $billingModeId: Int!\n    $billingFrequencyId: Int!\n    $deviceModelId: Int!\n    $deviceQuantity: Int!\n    $unAssignedDeviceQuantity: Int!\n    $serviceProviderId: Int\n    $simQuantity: Int\n    $unAssignedSimQuantity: Int\n    $amount: Int!\n    $billingdate: Int!\n    $gst: Float!\n    $grandTotalAmount: Int!\n    $billingLogicId: Int\n    $licenseTypeId: Int\n    $licenseQuantity: Int\n    $unAssignedLicenseQuantity: Int\n  ) {\n    addResellerSubscriptions(\n      clientLoginId: $clientLoginId\n      resellerLoginId: $resellerLoginId\n      billingModeId: $billingModeId\n      billingFrequencyId: $billingFrequencyId\n      deviceModelId: $deviceModelId\n      deviceQuantity: $deviceQuantity\n      unAssignedDeviceQuantity: $unAssignedDeviceQuantity\n      serviceProviderId: $serviceProviderId\n      simQuantity: $simQuantity\n      unAssignedSimQuantity: $unAssignedSimQuantity\n      amount: $amount\n      billingDay: $billingdate\n      gst: $gst\n      totalAmount: $grandTotalAmount\n      billingLogicId: $billingLogicId\n      licenseTypeId: $licenseTypeId\n      licenseQuantity: $licenseQuantity\n      unAssignedLicenseQuantity: $unAssignedLicenseQuantity\n    )\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query getAllBillingFrequency($billingModeId: Int!) {\n    getAllBillingFrequency(billingModeId: $billingModeId) {\n      id\n      frequency\n      billingModeId\n      numberOfMonths\n    }\n  }\n'],['\n  query getAllBillingFrequency($billingModeId: Int!) {\n    getAllBillingFrequency(billingModeId: $billingModeId) {\n      id\n      frequency\n      billingModeId\n      numberOfMonths\n    }\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  query getAllBillingLogic($billingModeId: Int!) {\n    getAllBillingLogic(billingModeId: $billingModeId) {\n      id\n      billingLogic\n    }\n  }\n'],['\n  query getAllBillingLogic($billingModeId: Int!) {\n    getAllBillingLogic(billingModeId: $billingModeId) {\n      id\n      billingLogic\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_CLIENTS=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject);var GET_CLIENT=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject2);var ADD_SUBSCRIPTION=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject3);var GET_BILLING_FREQUENCY=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject4);var GET_BILLING_LOGIC=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject5);var style=function style(theme){return{root:{padding:theme.spacing.unit*2,flexGrow:1},input:{display:'flex',padding:0}};};function ClientSelected(props){var isClientSelected=props.isClientSelected;if(isClientSelected){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Modules_CustomerDetailsCard__["a" /* default */],{clientDetail:props.clientDetails})));}return null;}function ShowSubDetails(props){var isClientSelected=props.isClientSelected;if(isClientSelected){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'subheading'},'Subscription Details')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'body1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',null,'All fields marked with (*) are mandatory'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__subscriptionDetails_jsx__["a" /* default */],{isClientSelected:props.isClientSelected,billingMode:props.billingMode,billingFrequency:props.billingFrequency,billingFrequencies:props.billingFrequencies,billingLogic:props.billingLogic,billingLogics:props.billingLogics,billingDate:props.billingDate,billingDates:props.billingDates,gstRate:props.gstRate,gstRates:props.gstRates,totalQuantity:props.totalQuantity,totalAmount:props.totalAmount,grandTotalAmount:props.grandTotalAmount,billingStartFrom:props.billingStartFrom,billingPayTill:props.billingPayTill,deviceModel:props.deviceModel,deviceQuantity:props.deviceQuantity,accessoryModel:props.accessoryModel,accessoryQuantity:props.accessoryQuantity,simModel:props.simModel,simQuantity:props.simQuantity,handleDateChange:props.handleDateChange,handleChange:props.handleChange,handleSelectChange:props.handleSelectChange,handleSelectBillingModeChange:props.handleSelectBillingModeChange})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,justify:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{color:'secondary',variant:'raised',onClick:props.handleSaveSubscription(props.client)},'Save')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{color:'secondary',variant:'raised',onClick:props.handleCancelSubscription},'Cancel'))));}return null;}var NewSubscription=function(_Component){_inherits(NewSubscription,_Component);function NewSubscription(props){var _this2=this;_classCallCheck(this,NewSubscription);var _this=_possibleConstructorReturn(this,(NewSubscription.__proto__||Object.getPrototypeOf(NewSubscription)).call(this,props));_this.handleDateChange=function(name){return function(date){var tempDate=_this.state[name];tempDate.date=date;tempDate.unix=__WEBPACK_IMPORTED_MODULE_13_moment___default()(date).unix().toString();console.log(tempDate.unix);_this.setState(_defineProperty({},name,tempDate));};};_this.handleChange=function(name){return function(event){if(event.target.value>=0){_this.setState(_defineProperty({},name,event.target.value),function(){_this.calculateAmount(_this.state.gstRate);});}else if(!event.target.value){var _this$setState3;_this.setState((_this$setState3={},_defineProperty(_this$setState3,name,null),_defineProperty(_this$setState3,'grandTotalAmount',null),_this$setState3));}};};_this.handleSelectChange=function(name){return function(value){if(value){_this.setState(_defineProperty({},name,value.value),function(){if(name==='gstRate'){_this.calculateAmount(_this.state.gstRate);}});}else{_this.setState(_defineProperty({},name,''),function(){if(name==='gstRate'){_this.calculateAmount(_this.state.gstRate);}});}};};_this.handleSelectBillingModeChange=function(name){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(value){var _this$setState6,_this$setState7,billId,_ref2,data,billingFrequencies,billLogics,allBillingLogics,billingLogics,arrayDates,billingDates,gstRates,billingGst;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(value){_context.next=4;break;}_this.setState((_this$setState6={},_defineProperty(_this$setState6,name,null),_defineProperty(_this$setState6,'billingFrequency',null),_defineProperty(_this$setState6,'billingFrequencies',null),_defineProperty(_this$setState6,'billingLogic',null),_defineProperty(_this$setState6,'billingLogics',null),_defineProperty(_this$setState6,'gstRates',null),_defineProperty(_this$setState6,'gstRate',null),_defineProperty(_this$setState6,'billingDate',null),_this$setState6));_context.next=20;break;case 4:billId=value;_context.next=7;return _this.props.client.query({query:GET_BILLING_FREQUENCY,variables:{billingModeId:parseInt(billId.value,10)}});case 7:_ref2=_context.sent;data=_ref2.data;billingFrequencies=data.getAllBillingFrequency.map(function(billFrq){return{value:billFrq.id,label:billFrq.frequency};});_context.next=12;return _this.props.client.query({query:GET_BILLING_LOGIC,variables:{billingModeId:parseInt(billId.value,10)}});case 12:billLogics=_context.sent;allBillingLogics=billLogics.data.getAllBillingLogic;billingLogics=allBillingLogics.map(function(billLogic){return{value:billLogic.id,label:billLogic.billingLogic};});arrayDates=[5,10,15,20];billingDates=arrayDates.map(function(days){return{value:days,label:days+'th'};});gstRates=[5,10,12,15,18];billingGst=gstRates.map(function(gst){return{value:gst/100,label:gst};});_this.setState((_this$setState7={},_defineProperty(_this$setState7,name,value.value),_defineProperty(_this$setState7,'billingFrequency',null),_defineProperty(_this$setState7,'billingFrequencies',billingFrequencies),_defineProperty(_this$setState7,'billingLogic',null),_defineProperty(_this$setState7,'billingLogics',billingLogics),_defineProperty(_this$setState7,'billingDates',billingDates),_defineProperty(_this$setState7,'gstRates',billingGst),_this$setState7));case 20:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();};_this.handleClientChange=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(customer){var _ref4,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(customer){_context2.next=4;break;}_this.setState({clientId:null,isClientSelected:false,clientDetails:null});_context2.next=9;break;case 4:_context2.next=6;return _this.props.client.query({query:GET_CLIENT,variables:{id:parseInt(customer.value,10)}});case 6:_ref4=_context2.sent;data=_ref4.data;_this.setState({clientDetails:data.clientDetail,clientId:customer.value,isClientSelected:true,licenseTypeId:data.clientDetail.licenseType.id},console.log('clt',customer.value,10));case 9:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref3.apply(this,arguments);};}();_this.handleCancelSubscription=function(e){_this.setState({billingMode:null,billingFrequency:null,billingFrequencies:null,billingLogic:null,billingLogics:null,totalQuantity:null,totalAmount:null,deviceModel:null,deviceQuantity:null,accessoryModel:null,accessoryQuantity:null,simModel:null,simQuantity:null,grandTotalAmount:null});};_this.handleSaveSubscription=function(client){return function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(event){var _ref6,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:// event.preventDeafault()
console.log('gggggg',_this.state.clientId,Object(__WEBPACK_IMPORTED_MODULE_14__utils_getLoginId__["a" /* default */])());_context3.next=3;return client.mutate({mutation:ADD_SUBSCRIPTION,variables:{clientLoginId:parseInt(_this.state.clientId,10),resellerLoginId:Object(__WEBPACK_IMPORTED_MODULE_14__utils_getLoginId__["a" /* default */])(),billingModeId:parseInt(_this.state.billingMode,10),billingFrequencyId:parseInt(_this.state.billingFrequency,10),deviceModelId:parseInt(_this.state.deviceModel,10),deviceQuantity:parseInt(_this.state.deviceQuantity,10),unAssignedDeviceQuantity:parseInt(_this.state.deviceQuantity,10),licenseTypeId:parseInt(_this.state.licenseTypeId,10),// licenseTypeId: 9,
licenseQuantity:parseInt(_this.state.deviceQuantity,10),unAssignedLicenseQuantity:parseInt(_this.state.deviceQuantity,10),accessoryTypeId:parseInt(_this.state.accessoryModel,10),accessoryQuantity:parseInt(_this.state.accessoryQuantity,10),unAssignedAccessoryQuantity:parseInt(_this.state.accessoryQuantity,10),serviceProviderId:parseInt(_this.state.simModel,10),simQuantity:parseInt(_this.state.simQuantity,10),unAssignedSimQuantity:parseInt(_this.state.simQuantity,10),amount:parseInt(_this.state.totalAmount,10),grandTotalAmount:parseInt(_this.state.grandTotalAmount,10),gst:parseFloat(_this.state.gstRate,10),billingdate:parseInt(_this.state.billingDate,10),billingLogicId:parseInt(_this.state.billingLogic,10),billingStartFrom:_this.state.billingStartFrom.unix,billingPayTill:_this.state.billingPayTill.unix}});case 3:_ref6=_context3.sent;data=_ref6.data;console.log('data',data);if(!(data.addResellerSubscriptions===true)){_context3.next=13;break;}_context3.next=9;return client.clearStore();case 9:_this.props.openSnackbar('Subscription Creation Successful');_this.props.history.push({pathname:'/home/reseller/subscriptions'});_context3.next=14;break;case 13:_this.props.openSnackbar('Subscription Creation Failed');case 14:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x3){return _ref5.apply(this,arguments);};}();};_this.state={clientId:null,isClientSelected:false,clientDetails:null,billingMode:null,billingFrequency:null,billingFrequencies:null,billingLogic:null,billingLogics:null,totalQuantity:null,totalAmount:null,deviceModel:null,deviceQuantity:null,accessoryModel:null,accessoryQuantity:null,simModel:null,simQuantity:null,billingDates:null,billingDate:null,gstRates:null,gstRate:null,grandTotalAmount:null,showTotalAmount:false,licenseTypeId:null,billingStartFrom:{date:__WEBPACK_IMPORTED_MODULE_13_moment___default()(),unix:__WEBPACK_IMPORTED_MODULE_13_moment___default()().unix().toString()},billingPayTill:{date:__WEBPACK_IMPORTED_MODULE_13_moment___default()(),unix:__WEBPACK_IMPORTED_MODULE_13_moment___default()().unix().toString()}};return _this;}_createClass(NewSubscription,[{key:'calculateAmount',value:function calculateAmount(gst){if(gst){var totalamount=0;totalamount=parseInt(this.state.totalQuantity,10)*parseInt(this.state.totalAmount,10)+parseInt(this.state.totalQuantity,10)*parseInt(this.state.totalAmount,10)*gst;if(!isNaN(totalamount)){this.setState({grandTotalAmount:totalamount});}else{this.setState({grandTotalAmount:''});}}else{this.setState({grandTotalAmount:''});}}},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_apollo__["Query"],{query:GET_CLIENTS,variables:{resellerLoginId:Object(__WEBPACK_IMPORTED_MODULE_14__utils_getLoginId__["a" /* default */])()}},function(_ref7){var loading=_ref7.loading,error=_ref7.error,clients=_ref7.data.clients;if(loading)return'Loading...';if(error)return'Error!: '+error;var allClients=clients.map(function(client){return{value:client.loginId,label:client.clientName};});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'headline'},'Create Subscription')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */],{classes:classes,options:allClients,value:_this3.state.clientId,onChange:_this3.handleClientChange,placeholder:'Select Customer'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ClientSelected,{isClientSelected:_this3.state.isClientSelected,clientDetails:_this3.state.clientDetails})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ShowSubDetails,{isClientSelected:_this3.state.isClientSelected,billingMode:_this3.state.billingMode,billingFrequency:_this3.state.billingFrequency,billingFrequencies:_this3.state.billingFrequencies,billingLogic:_this3.state.billingLogic,billingLogics:_this3.state.billingLogics,billingDate:_this3.state.billingDate,billingDates:_this3.state.billingDates,gstRate:_this3.state.gstRate,gstRates:_this3.state.gstRates,totalQuantity:_this3.state.totalQuantity,totalAmount:_this3.state.totalAmount,grandTotalAmount:_this3.state.grandTotalAmount,billingStartFrom:_this3.state.billingStartFrom,billingPayTill:_this3.state.billingPayTill,deviceModel:_this3.state.deviceModel,deviceQuantity:_this3.state.deviceQuantity,accessoryModel:_this3.state.accessoryModel,accessoryQuantity:_this3.state.accessoryQuantity,simModel:_this3.state.simModel,simQuantity:_this3.state.simQuantity,handleDateChange:_this3.handleDateChange,handleSelectChange:_this3.handleSelectChange,handleChange:_this3.handleChange,handleCancelSubscription:_this3.handleCancelSubscription,handleSaveSubscription:_this3.handleSaveSubscription,handleSelectBillingModeChange:_this3.handleSelectBillingModeChange,client:_this3.props.client})))));});}}]);return NewSubscription;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);NewSubscription.propTypes={classes:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired};var withApolloClient=function withApolloClient(Component){return function(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_apollo__["ApolloConsumer"],null,function(client){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component,Object.assign({client:client},props));});};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__["withStyles"])(style)(withApolloClient(Object(__WEBPACK_IMPORTED_MODULE_12__HOCs_withSharedSnackbar__["a" /* default */])(NewSubscription))));

/***/ }),
/* 2395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Card__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_CardContent__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_CardContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_CardContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui_pickers__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query {\n    billingMode: getAllBillingMode {\n      id\n      billingMode\n    }\n  }\n'],['\n  query {\n    billingMode: getAllBillingMode {\n      id\n      billingMode\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query getResellerDeviceStockByDeviceModel($resellerLoginId: Int!) {\n    deviceModel: getResellerDeviceStockByDeviceModel(\n      resellerLoginId: $resellerLoginId\n    ) {\n      deviceModelId\n      modelName\n    }\n  }\n'],['\n  query getResellerDeviceStockByDeviceModel($resellerLoginId: Int!) {\n    deviceModel: getResellerDeviceStockByDeviceModel(\n      resellerLoginId: $resellerLoginId\n    ) {\n      deviceModelId\n      modelName\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query {\n    accessoryDetails: getAllAccessoryTypes {\n      id\n      accessoryName\n    }\n  }\n'],['\n  query {\n    accessoryDetails: getAllAccessoryTypes {\n      id\n      accessoryName\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query {\n    simDetails: allServiceProviders {\n      id\n      name\n    }\n  }\n'],['\n  query {\n    simDetails: allServiceProviders {\n      id\n      name\n    }\n  }\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_BILLING_MODE=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject);// const GET_DEVICE_MODELS = gql`
//   query {
//     deviceModel: allDeviceModels {
//       id
//       model_name
//     }
//   }
// `
var GET_DEVICE_MODELS=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject2);var GET_ACCESSORY=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject3);var GET_SIM_PROVIDER=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject4);var style=function style(theme){return{textField:{marginLeft:theme.spacing.unit*2,marginRight:theme.spacing.unit*2,width:'100%'},root:{padding:theme.spacing.unit*2,flexGrow:1},input:{display:'flex',padding:0}};};var SubscriptionDetails=function(_Component){_inherits(SubscriptionDetails,_Component);function SubscriptionDetails(){_classCallCheck(this,SubscriptionDetails);return _possibleConstructorReturn(this,(SubscriptionDetails.__proto__||Object.getPrototypeOf(SubscriptionDetails)).apply(this,arguments));}_createClass(SubscriptionDetails,[{key:'render',value:function render(){var _this2=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["Query"],{query:GET_BILLING_MODE,variables:{resellerLoginId:Object(__WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__["a" /* default */])()}},function(_ref){var loading=_ref.loading,error=_ref.error,billingMode=_ref.data.billingMode;if(loading)return'Loading...';if(error)return'Error!: '+error;var billingModes=billingMode.map(function(billingMode){return{value:billingMode.id,label:billingMode.billingMode};});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["Query"],{query:GET_DEVICE_MODELS,variables:{resellerLoginId:Object(__WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__["a" /* default */])()}},function(_ref2){var loading=_ref2.loading,error=_ref2.error,deviceModel=_ref2.data.deviceModel;if(loading)return'Loading...';if(error)return'Error!: '+error;var deviceModels=deviceModel.map(function(deviceModel){return{value:deviceModel.deviceModelId,label:deviceModel.modelName};});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["Query"],{query:GET_ACCESSORY},function(_ref3){var loading=_ref3.loading,error=_ref3.error,accessoryDetails=_ref3.data.accessoryDetails;if(loading)return'Loading...';if(error)return'Error!: '+error;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["Query"],{query:GET_SIM_PROVIDER},function(_ref4){var loading=_ref4.loading,error=_ref4.error,simDetails=_ref4.data.simDetails;if(loading)return'Loading...';if(error)return'Error!: '+error;var simProviders=simDetails.map(function(simDetails){return{value:simDetails.id,label:simDetails.name};});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Card___default.a,{className:classes.card,style:{overflow:'visible'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,alignItems:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */],{classes:classes,options:billingModes,value:_this2.props.billingMode,onChange:_this2.props.handleSelectBillingModeChange('billingMode'),placeholder:'Billing Mode *'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */],{classes:classes,options:_this2.props.billingFrequencies,value:_this2.props.billingFrequency,onChange:_this2.props.handleSelectChange('billingFrequency'),placeholder:'Billing Frequency *'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */],{classes:classes,options:_this2.props.billingDates,value:_this2.props.billingDate,onChange:_this2.props.handleSelectChange('billingDate'),placeholder:'Billing Day *'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,alignItems:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */],{classes:classes,options:_this2.props.billingLogics,value:_this2.props.billingLogic,onChange:_this2.props.handleSelectChange('billingLogic'),placeholder:'Billing Logic *'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Typography"],{variant:'caption'},'Billing From'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_material_ui_pickers__["a" /* DatePicker */],{value:_this2.props.billingStartFrom.date,onChange:_this2.props.handleDateChange('billingStartFrom'),format:'DD/MM/YYYY'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Typography"],{variant:'caption'},'Billing Upto'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_material_ui_pickers__["a" /* DatePicker */],{value:_this2.props.billingPayTill.date,onChange:_this2.props.handleDateChange('billingPayTill'),format:'DD/MM/YYYY'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true,spacing:16,alignItems:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'quantity',label:'Quantity *',value:_this2.props.totalQuantity,onChange:_this2.props.handleChange('totalQuantity'),type:'number',className:classes.textField,margin:'normal'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'amount',label:'Amount per device *',className:classes.textField,value:_this2.props.totalAmount,onChange:_this2.props.handleChange('totalAmount'),margin:'normal'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */],{classes:classes,options:_this2.props.gstRates,value:_this2.props.gstRate,onChange:_this2.props.handleSelectChange('gstRate'),placeholder:'Gst Rate *'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Typography"],{variant:'body1'},'Total Amount:',' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Typography"],{variant:'body2'},_this2.props.grandTotalAmount))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider___default.a,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true,spacing:8,alignItems:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Typography"],{variant:'body1'},'Devices')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */],{classes:classes,options:deviceModels,value:_this2.props.deviceModel,onChange:_this2.props.handleSelectChange('deviceModel'),placeholder:'Select Model *'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:1}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'deviceQuantity',label:'Quantity *',className:classes.textField,value:_this2.props.deviceQuantity,onChange:_this2.props.handleChange('deviceQuantity'),type:'number',margin:'normal'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider___default.a,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true,spacing:8,alignItems:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Typography"],{variant:'body1'},'SIM Cards')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */],{classes:classes,options:simProviders,value:_this2.props.simModel,onChange:_this2.props.handleSelectChange('simModel'),placeholder:'Select Provider'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:1}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'simQuantity',label:'Quantity',className:classes.textField,value:_this2.props.simQuantity,onChange:_this2.props.handleChange('simQuantity'),type:'number',margin:'normal'}))))));});});});});}}]);return SubscriptionDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SubscriptionDetails.PropTypes={classes:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired};var withApolloClient=function withApolloClient(Component){return function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["ApolloConsumer"],null,function(client){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,Object.assign({client:client},props));});};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__["withStyles"])(style)(withApolloClient(SubscriptionDetails)));

/***/ }),
/* 2396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Modules_CustomerDetailsCard__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__subscriptionDetails_jsx__ = __webpack_require__(2397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__HOCs_withSharedSnackbar_withSharedSnackbar_jsx__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query allClientDetails($resellerLoginId: Int) {\n    clients: allClientDetails(resellerLoginId: $resellerLoginId) {\n      id\n      clientName\n      loginId\n    }\n  }\n'],['\n  query allClientDetails($resellerLoginId: Int) {\n    clients: allClientDetails(resellerLoginId: $resellerLoginId) {\n      id\n      clientName\n      loginId\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query clientDetail($id: Int) {\n    clientDetail(loginId: $id) {\n      id\n      clientName\n      contactPerson\n      address\n      city\n      state {\n        zone_id\n        name\n      }\n      country {\n        country_id\n        name\n      }\n      email\n      contactNumber\n      login {\n        username\n      }\n      pincode\n      panNumber\n    }\n  }\n'],['\n  query clientDetail($id: Int) {\n    clientDetail(loginId: $id) {\n      id\n      clientName\n      contactPerson\n      address\n      city\n      state {\n        zone_id\n        name\n      }\n      country {\n        country_id\n        name\n      }\n      email\n      contactNumber\n      login {\n        username\n      }\n      pincode\n      panNumber\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation updateResellerSubscriptions(\n    $id: Int!\n    $clientLoginId: Int!\n    $resellerLoginId: Int!\n    $billingModeId: Int!\n    $billingFrequencyId: Int!\n    $billingLogicId: Int\n    $billingDay: Int!\n    $gst: Float!\n    $deviceModelId: Int!\n    $deviceQuantity: Int!\n    $unAssignedDeviceQuantity: Int!\n    $licenseTypeId: Int\n    $licenseQuantity: Int\n    $unAssignedLicenseQuantity: Int\n    $serviceProviderId: Int\n    $simQuantity: Int\n    $unAssignedSimQuantity: Int\n    $amount: Int!\n    $totalAmount: Int!\n    $status: Int!\n  ) {\n    updateResellerSubscriptions(\n      id: $id\n      clientLoginId: $clientLoginId\n      resellerLoginId: $resellerLoginId\n      billingModeId: $billingModeId\n      billingFrequencyId: $billingFrequencyId\n      billingLogicId: $billingLogicId\n      billingDay: $billingDay\n      gst: $gst\n      deviceModelId: $deviceModelId\n      deviceQuantity: $deviceQuantity\n      unAssignedDeviceQuantity: $unAssignedDeviceQuantity\n      licenseTypeId: $licenseTypeId\n      licenseQuantity: $licenseQuantity\n      unAssignedLicenseQuantity: $unAssignedLicenseQuantity\n      serviceProviderId: $serviceProviderId\n      simQuantity: $simQuantity\n      unAssignedSimQuantity: $unAssignedSimQuantity\n      amount: $amount\n      totalAmount: $totalAmount\n      status: $status\n    )\n  }\n'],['\n  mutation updateResellerSubscriptions(\n    $id: Int!\n    $clientLoginId: Int!\n    $resellerLoginId: Int!\n    $billingModeId: Int!\n    $billingFrequencyId: Int!\n    $billingLogicId: Int\n    $billingDay: Int!\n    $gst: Float!\n    $deviceModelId: Int!\n    $deviceQuantity: Int!\n    $unAssignedDeviceQuantity: Int!\n    $licenseTypeId: Int\n    $licenseQuantity: Int\n    $unAssignedLicenseQuantity: Int\n    $serviceProviderId: Int\n    $simQuantity: Int\n    $unAssignedSimQuantity: Int\n    $amount: Int!\n    $totalAmount: Int!\n    $status: Int!\n  ) {\n    updateResellerSubscriptions(\n      id: $id\n      clientLoginId: $clientLoginId\n      resellerLoginId: $resellerLoginId\n      billingModeId: $billingModeId\n      billingFrequencyId: $billingFrequencyId\n      billingLogicId: $billingLogicId\n      billingDay: $billingDay\n      gst: $gst\n      deviceModelId: $deviceModelId\n      deviceQuantity: $deviceQuantity\n      unAssignedDeviceQuantity: $unAssignedDeviceQuantity\n      licenseTypeId: $licenseTypeId\n      licenseQuantity: $licenseQuantity\n      unAssignedLicenseQuantity: $unAssignedLicenseQuantity\n      serviceProviderId: $serviceProviderId\n      simQuantity: $simQuantity\n      unAssignedSimQuantity: $unAssignedSimQuantity\n      amount: $amount\n      totalAmount: $totalAmount\n      status: $status\n    )\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query getResellerSubscriptions($subscriptionId: Int) {\n    getResellerSubscriptions(id: $subscriptionId) {\n      id\n      billingMode {\n        id\n        billingMode\n      }\n      billingFrequency {\n        id\n        frequency\n        numberOfMonths\n      }\n      billingLogic {\n        id\n        billingLogic\n      }\n      billingDay\n      gst\n      deviceModel {\n        model_name\n      }\n      deviceQuantity\n      unAssignedDeviceQuantity\n      simQuantity\n      unAssignedSimQuantity\n      deviceModelId\n      serviceProviderId\n      amount\n      totalAmount\n      licenseTypeId\n    }\n  }\n'],['\n  query getResellerSubscriptions($subscriptionId: Int) {\n    getResellerSubscriptions(id: $subscriptionId) {\n      id\n      billingMode {\n        id\n        billingMode\n      }\n      billingFrequency {\n        id\n        frequency\n        numberOfMonths\n      }\n      billingLogic {\n        id\n        billingLogic\n      }\n      billingDay\n      gst\n      deviceModel {\n        model_name\n      }\n      deviceQuantity\n      unAssignedDeviceQuantity\n      simQuantity\n      unAssignedSimQuantity\n      deviceModelId\n      serviceProviderId\n      amount\n      totalAmount\n      licenseTypeId\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_CLIENTS=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject);var GET_CLIENT=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject2);var UPDATE_SUBSCRIPTION=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject3);var GET_SUBSCRIPTION_DETAIL=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject4);var style=function style(theme){return{root:{padding:theme.spacing.unit*2,flexGrow:1},input:{display:'flex',padding:0}};};function ClientSelected(props){var isClientSelected=props.isClientSelected;if(isClientSelected){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Modules_CustomerDetailsCard__["a" /* default */],{clientDetail:props.clientDetails})));}return null;}function ShowSubDetails(props){var isClientSelected=props.isClientSelected;if(isClientSelected){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'subheading'},'Subscription Details')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__subscriptionDetails_jsx__["a" /* default */],{isClientSelected:props.isClientSelected,billingMode:props.billingMode,billingFrequency:props.billingFrequency,billingLogic:props.billingLogic,billingDate:props.billingDate,gstRate:props.gstRate,totalQuantity:props.totalQuantity,totalAmount:props.totalAmount,grandTotalAmount:props.grandTotalAmount,billingStartedFrom:props.billingStartedFrom,billingPayTill:props.billingPayTill,deviceModel:props.deviceModel,deviceQuantity:props.deviceQuantity,accessoryModel:props.accessoryModel,accessoryQuantity:props.accessoryQuantity,simModel:props.simModel,simQuantity:props.simQuantity,handleSelectChange:props.handleSelectChange,handleSelectDayChange:props.handleSelectDayChange,handleSelectGstChange:props.handleSelectGstChange,handleChange:props.handleChange,handleSelectBillingModeChange:props.handleSelectBillingModeChange})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,justify:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{color:'secondary',variant:'raised',onClick:props.handleUpdateSubscription},'Update')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{color:'secondary',variant:'raised',onClick:props.handleCancelSubscription},'Cancel'))));}return null;}var EditSubscription=function(_Component){_inherits(EditSubscription,_Component);function EditSubscription(props){var _this2=this;_classCallCheck(this,EditSubscription);var _this=_possibleConstructorReturn(this,(EditSubscription.__proto__||Object.getPrototypeOf(EditSubscription)).call(this,props));_this.handleChange=function(name){return function(event){if(!(event.target.value<_this.state.initStatus[name])&&event.target.value>=0){if(name==='deviceQuantity'){var newDevices=parseInt(event.target.value,10)-_this.state.initStatus[name];var total=event.target.value*_this.state.totalAmount+event.target.value*_this.state.totalAmount*_this.state.gstRate;_this.setState(_defineProperty({totalQuantity:event.target.value,grandTotalAmount:total,newDevices:newDevices},name,event.target.value));}else if(name==='accessoryQuantity'){var newAccessories=parseInt(event.target.value,10)-_this.state.initStatus[name];_this.setState(_defineProperty({newAccessories:newAccessories},name,event.target.value));}else if(name==='simQuantity'){var newSims=event.target.value-_this.state.initStatus[name];_this.setState(_defineProperty({newSims:newSims},name,event.target.value));}}};};_this.handleCancelSubscription=function(e){};_this.handleUpdateSubscription=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _ref2,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.client.mutate({mutation:UPDATE_SUBSCRIPTION,variables:{id:parseInt(_this.subscriptionId,10),clientLoginId:parseInt(_this.loginId,10),resellerLoginId:Object(__WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__["a" /* default */])(),billingModeId:parseInt(_this.state.billingModeId,10),billingFrequencyId:parseInt(_this.state.billingFrequencyId,10),billingLogicId:parseInt(_this.state.billingLogicId,10),billingDay:_this.state.billingDate,gst:_this.state.gstRate,deviceModelId:parseInt(_this.state.deviceModelId,10),deviceQuantity:parseInt(_this.state.deviceQuantity,10),unAssignedDeviceQuantity:parseInt(_this.state.unAssignedDeviceQuantity,10)+parseInt(_this.state.newDevices,10),licenseTypeId:parseInt(_this.state.licenseTypeId,10),licenseQuantity:parseInt(_this.state.deviceQuantity,10),unAssignedLicenseQuantity:parseInt(_this.state.unAssignedDeviceQuantity,10)+parseInt(_this.state.newDevices,10),accessoryTypeId:_this.state.accessoryModelId,accessoryQuantity:_this.state.accessoryQuantity,unAssignedAccessoryQuantity:parseInt(_this.state.unAssignedAccessoryQuantity,10)+parseInt(_this.state.newAccessories,10),serviceProviderId:parseInt(_this.state.simModelId,10),simQuantity:parseInt(_this.state.simQuantity,10),unAssignedSimQuantity:parseInt(_this.state.unAssignedSimQuantity,10)+parseInt(_this.state.newSims,10),amount:parseInt(_this.state.totalAmount,10),totalAmount:parseInt(_this.state.grandTotalAmount,10),billingStartedFrom:_this.state.billingStartedFrom,billingPayTill:_this.state.billingPayTill,status:1}});case 2:_ref2=_context.sent;data=_ref2.data;console.log('res',data);if(data.updateResellerSubscriptions===true){_this.props.openSnackbar('Subscription Updation Successful');_this.props.history.push({pathname:'/home/reseller/subscriptions'});}else{_this.props.openSnackbar('Subscription Updation Failed');}case 6:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.getAllDetails=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var initStatus,clientDetails,subsDetails,fields;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:initStatus={deviceQuantity:0,accessoryQuantity:0,simQuantity:0};_context2.next=3;return _this.props.client.query({query:GET_CLIENT,variables:{id:parseInt(_this.loginId,10)}});case 3:clientDetails=_context2.sent;_context2.next=6;return _this.props.client.query({query:GET_SUBSCRIPTION_DETAIL,variables:{subscriptionId:parseInt(_this.subscriptionId,10)}});case 6:subsDetails=_context2.sent;console.log('detail',subsDetails);// Maintain initial settings
initStatus['deviceQuantity']=subsDetails.data.getResellerSubscriptions.deviceQuantity;initStatus['accessoryQuantity']=subsDetails.data.getResellerSubscriptions.accessoryQuantity;initStatus['simQuantity']=subsDetails.data.getResellerSubscriptions.simQuantity;// Take care of non mandatory fields
// TODO: Explore handling this in the query
fields={initStatus:initStatus,clientDetails:clientDetails.data.clientDetail,clientId:_this.loginId,isClientSelected:true,billingMode:subsDetails.data.getResellerSubscriptions.billingMode.billingMode,billingModeId:subsDetails.data.getResellerSubscriptions.billingMode.id,billingFrequencyId:subsDetails.data.getResellerSubscriptions.billingFrequency.id,billingFrequency:subsDetails.data.getResellerSubscriptions.billingFrequency.frequency,billingLogic:subsDetails.data.getResellerSubscriptions.billingLogic.billingLogic,billingLogicId:subsDetails.data.getResellerSubscriptions.billingLogic.id,billingDate:subsDetails.data.getResellerSubscriptions.billingDay,gstRate:subsDetails.data.getResellerSubscriptions.gst,totalQuantity:subsDetails.data.getResellerSubscriptions.deviceQuantity,totalAmount:subsDetails.data.getResellerSubscriptions.amount,grandTotalAmount:subsDetails.data.getResellerSubscriptions.totalAmount,deviceModelId:subsDetails.data.getResellerSubscriptions.deviceModelId,deviceModel:subsDetails.data.getResellerSubscriptions.deviceModel.model_name,deviceQuantity:subsDetails.data.getResellerSubscriptions.deviceQuantity,unAssignedDeviceQuantity:subsDetails.data.getResellerSubscriptions.unAssignedDeviceQuantity,licenseTypeId:subsDetails.data.getResellerSubscriptions.licenseTypeId,accessoryQuantity:subsDetails.data.getResellerSubscriptions.accessoryQuantity,unAssignedAccessoryQuantity:subsDetails.data.getResellerSubscriptions.unAssignedAccessoryQuantity,simQuantity:subsDetails.data.getResellerSubscriptions.simQuantity,unAssignedSimQuantity:subsDetails.data.getResellerSubscriptions.unAssignedSimQuantity,billingStartedFrom:subsDetails.data.getResellerSubscriptions.billingStartedFrom,billingPayTill:subsDetails.data.getResellerSubscriptions.billingPayTill// accessory
// if (subsDetails.data.getSubscriptions.accessoryType) {
//   fields['accessoryModel'] =
//     subsDetails.data.getSubscriptions.accessoryType.accessoryName
//   fields['accessoryModelId'] =
//     subsDetails.data.getSubscriptions.accessoryTypeId
// } else {
//   fields['accessoryModel'] = null
//   fields['accessoryModelId'] = null
// }
// sim
};if(subsDetails.data.getResellerSubscriptions.serviceProvider){fields['simModel']=subsDetails.data.getResellerSubscriptions.serviceProvider.name;fields['simModelId']=subsDetails.data.getResellerSubscriptions.serviceProviderId;}else{fields['simModel']=null;fields['simModelId']=null;}_this.setState(fields);case 14:case'end':return _context2.stop();}}},_callee2,_this2);}));_this.subscriptionId=_this.props.match.params.subscriptionId;_this.loginId=_this.props.match.params.loginId;_this.state={clientId:null,isClientSelected:false,clientDetails:null,billingModeId:null,billingFrequencyId:null,billingMode:null,billingFrequency:null,billingLogic:null,billingLogicId:null,totalQuantity:null,totalAmount:null,deviceModelId:null,deviceModel:null,deviceQuantity:null,unAssignedDeviceQuantity:null,licenseTypeId:null,accessoryModelId:null,accessoryModel:null,accessoryQuantity:null,unAssignedAccessoryQuantity:null,simModelId:null,simModel:null,simQuantity:null,unAssignedSimQuantity:null,billingDate:null,gstRate:null,grandTotalAmount:null,newDevices:0,newAccessories:0,newSims:0,billingStartedFrom:null,billingPayTill:null,initStatus:{deviceQuantity:0,accessoryQuantity:0,simQuantity:0}};return _this;}_createClass(EditSubscription,[{key:'componentDidMount',value:function componentDidMount(){this.getAllDetails();}},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_apollo__["Query"],{query:GET_CLIENTS,variables:{resellerLoginId:Object(__WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__["a" /* default */])()}},function(_ref4){var loading=_ref4.loading,error=_ref4.error,clients=_ref4.data.clients;if(loading)return'Loading...';if(error)return'Error!: '+error;var allClients=clients.map(function(client){return{value:client.loginId,label:client.clientName};});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'headline'},'Edit Subscription')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */],{classes:classes,options:allClients,value:_this3.state.clientId,disabled:true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ClientSelected,{isClientSelected:_this3.state.isClientSelected,clientDetails:_this3.state.clientDetails})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ShowSubDetails,{isClientSelected:_this3.state.isClientSelected,billingMode:_this3.state.billingMode,billingFrequency:_this3.state.billingFrequency,billingLogic:_this3.state.billingLogic,billingDate:_this3.state.billingDate,gstRate:_this3.state.gstRate,totalQuantity:_this3.state.totalQuantity,totalAmount:_this3.state.totalAmount,grandTotalAmount:_this3.state.grandTotalAmount,billingStartedFrom:_this3.state.billingStartedFrom,billingPayTill:_this3.state.billingPayTill,deviceModel:_this3.state.deviceModel,deviceQuantity:_this3.state.deviceQuantity,accessoryModel:_this3.state.accessoryModel,accessoryQuantity:_this3.state.accessoryQuantity,simModel:_this3.state.simModel,simQuantity:_this3.state.simQuantity,handleChange:_this3.handleChange,handleCancelSubscription:_this3.handleCancelSubscription,handleUpdateSubscription:_this3.handleUpdateSubscription})))));});}}]);return EditSubscription;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);EditSubscription.propTypes={classes:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired};var withApolloClient=function withApolloClient(Component){return function(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_apollo__["ApolloConsumer"],null,function(client){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component,Object.assign({client:client},props));});};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__["withStyles"])(style)(withApolloClient(Object(__WEBPACK_IMPORTED_MODULE_12__HOCs_withSharedSnackbar_withSharedSnackbar_jsx__["a" /* default */])(EditSubscription))));

/***/ }),
/* 2397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Card__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_CardContent__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_CardContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_CardContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var style=function style(theme){return{textField:{marginLeft:theme.spacing.unit*2,marginRight:theme.spacing.unit*2,width:'100%'},root:{padding:theme.spacing.unit*2,flexGrow:1},input:{display:'flex',padding:0}};};var SubscriptionDetails=function(_Component){_inherits(SubscriptionDetails,_Component);function SubscriptionDetails(){_classCallCheck(this,SubscriptionDetails);return _possibleConstructorReturn(this,(SubscriptionDetails.__proto__||Object.getPrototypeOf(SubscriptionDetails)).apply(this,arguments));}_createClass(SubscriptionDetails,[{key:'render',value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Card___default.a,{className:classes.card,style:{overflow:'visible'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Typography"],{variant:'subheading'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'Billing Mode: '),this.props.billingMode)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Typography"],{variant:'subheading'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'Billing Frequency: '),this.props.billingFrequency)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Typography"],{variant:'subheading'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'Billing Date: '),this.props.billingDate))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Typography"],{variant:'subheading'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'Billing Logic: '),this.props.billingLogic)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Typography"],{variant:'subheading'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'Billing Started From: '),this.props.billingStartedFrom==='0'?'NA':__WEBPACK_IMPORTED_MODULE_10_moment___default.a.unix(this.props.billingStartedFrom).format('DD/MM/YYYY'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Typography"],{variant:'subheading'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'Billing Upto: '),this.props.billingPayTill==='0'?'NA':__WEBPACK_IMPORTED_MODULE_10_moment___default.a.unix(this.props.billingPayTill).format('DD/MM/YYYY')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Typography"],{variant:'subheading'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'Total Quantity: '),this.props.totalQuantity)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Typography"],{variant:'subheading'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'Amount per device: '),this.props.totalAmount)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Typography"],{variant:'subheading'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'GST: '),this.props.gstRate*100,'%')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Typography"],{variant:'subheading'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'Total Amount: '),this.props.grandTotalAmount))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Divider___default.a,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,alignItems:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Typography"],{variant:'subheading'},'Devices')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Typography"],{variant:'body2'},this.props.deviceModel)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:1}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{id:'deviceQuantity',label:'Quantity',className:classes.textField,value:this.props.deviceQuantity,onChange:this.props.handleChange('deviceQuantity'),type:'number',margin:'normal'}))),this.props.accessoryQuantity?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Divider___default.a,null)):null,this.props.accessoryQuantity?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,alignItems:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Typography"],{variant:'subheading'},'Accessories')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Typography"],{variant:'body2'},this.props.accessoryModel)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:1}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{id:'accessoryQuantity',label:'Quantity',className:classes.textField,value:this.props.accessoryQuantity,onChange:this.props.handleChange('accessoryQuantity'),type:'number',margin:'normal'}))):null,this.props.simQuantity?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Divider___default.a,null)):null,this.props.simQuantity?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,alignItems:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Typography"],{variant:'subheading'},'SIM Cards')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Typography"],{variant:'body2'},this.props.simModel)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:1}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{id:'simQuantity',label:'Quantity',placeholder:'Quantity',className:classes.textField,value:this.props.simQuantity,onChange:this.props.handleChange('simQuantity'),type:'number',margin:'normal'}))):null)));}}]);return SubscriptionDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SubscriptionDetails.PropTypes={classes:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired};var withApolloClient=function withApolloClient(Component){return function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_apollo__["ApolloConsumer"],null,function(client){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,Object.assign({client:client},props));});};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__["withStyles"])(style)(withApolloClient(SubscriptionDetails)));

/***/ }),
/* 2398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Modules_CustomerDetailsCard__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Card__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_CardContent__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_CardContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_CardContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_ArrowBack__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_ArrowBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_ArrowBack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_mui_datatables__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query clientDetail($loginId: Int) {\n    clientDetail(loginId: $loginId) {\n      id\n      clientName\n      contactPerson\n      address\n      city\n      state {\n        zone_id\n      }\n      country {\n        country_id\n      }\n      email\n      contactNumber\n      login {\n        username\n      }\n      pincode\n      panNumber\n      type\n    }\n  }\n'],['\n  query clientDetail($loginId: Int) {\n    clientDetail(loginId: $loginId) {\n      id\n      clientName\n      contactPerson\n      address\n      city\n      state {\n        zone_id\n      }\n      country {\n        country_id\n      }\n      email\n      contactNumber\n      login {\n        username\n      }\n      pincode\n      panNumber\n      type\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query checkDeviceAvailableForResellerSubscription(\n    $resellerLoginId: Int!\n    $serial_num: [DeviceListInput!]!\n    $deviceModelId: Int!\n  ) {\n    validation: checkDeviceAvailableForResellerSubscription(\n      resellerLoginId: $resellerLoginId\n      deviceList: $serial_num\n      deviceModelId: $deviceModelId\n    ) {\n      serial_num\n      uniqueDeviceId\n    }\n  }\n'],['\n  query checkDeviceAvailableForResellerSubscription(\n    $resellerLoginId: Int!\n    $serial_num: [DeviceListInput!]!\n    $deviceModelId: Int!\n  ) {\n    validation: checkDeviceAvailableForResellerSubscription(\n      resellerLoginId: $resellerLoginId\n      deviceList: $serial_num\n      deviceModelId: $deviceModelId\n    ) {\n      serial_num\n      uniqueDeviceId\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query checkSimAvailableForResellerSubscription(\n    $resellerLoginId: Int!\n    $simNumber: [SimListInput!]!\n    $serviceProviderId: Int!\n  ) {\n    validation: checkSimAvailableForResellerSubscription(\n      resellerLoginId: $resellerLoginId\n      simList: $simNumber\n      serviceProviderId: $serviceProviderId\n    ) {\n      simNumber\n    }\n  }\n'],['\n  query checkSimAvailableForResellerSubscription(\n    $resellerLoginId: Int!\n    $simNumber: [SimListInput!]!\n    $serviceProviderId: Int!\n  ) {\n    validation: checkSimAvailableForResellerSubscription(\n      resellerLoginId: $resellerLoginId\n      simList: $simNumber\n      serviceProviderId: $serviceProviderId\n    ) {\n      simNumber\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query getResellerSubscriptions(\n    $subscriptionId: Int\n    $clientLoginId: Int\n    $resellerLoginId: Int\n  ) {\n    getResellerSubscriptions(\n      id: $subscriptionId\n      clientLoginId: $clientLoginId\n      resellerLoginId: $resellerLoginId\n    ) {\n      deviceModel {\n        model_name\n        manufacturer {\n          manufacturerCode\n        }\n      }\n      licenseType {\n        licenseType\n      }\n      licenseQuantity\n      unAssignedLicenseQuantity\n      serviceProvider {\n        name\n      }\n      deviceModelId\n\n      serviceProviderId\n      unAssignedDeviceQuantity\n      unAssignedSimQuantity\n      licenseTypeId\n      resellerLicenseInventory {\n        id\n        licenseExpiryTime\n        approvedQuantity\n        assignedQuantityToClient\n      }\n      reseller {\n        licenseExpiryPeriod\n      }\n    }\n  }\n'],['\n  query getResellerSubscriptions(\n    $subscriptionId: Int\n    $clientLoginId: Int\n    $resellerLoginId: Int\n  ) {\n    getResellerSubscriptions(\n      id: $subscriptionId\n      clientLoginId: $clientLoginId\n      resellerLoginId: $resellerLoginId\n    ) {\n      deviceModel {\n        model_name\n        manufacturer {\n          manufacturerCode\n        }\n      }\n      licenseType {\n        licenseType\n      }\n      licenseQuantity\n      unAssignedLicenseQuantity\n      serviceProvider {\n        name\n      }\n      deviceModelId\n\n      serviceProviderId\n      unAssignedDeviceQuantity\n      unAssignedSimQuantity\n      licenseTypeId\n      resellerLicenseInventory {\n        id\n        licenseExpiryTime\n        approvedQuantity\n        assignedQuantityToClient\n      }\n      reseller {\n        licenseExpiryPeriod\n      }\n    }\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  query checkAccessoryAvailableForSubscription(\n    $partnerLoginId: Int!\n    $serialNumber: [AccessoryListInput!]!\n    $accessoryTypeId: Int!\n  ) {\n    validation: checkAccessoryAvailableForSubscription(\n      partnerLoginId: $partnerLoginId\n      serialNumberList: $serialNumber\n      accessoryTypeId: $accessoryTypeId\n    ) {\n      serialNumber\n      uniqueAccessoryId\n    }\n  }\n'],['\n  query checkAccessoryAvailableForSubscription(\n    $partnerLoginId: Int!\n    $serialNumber: [AccessoryListInput!]!\n    $accessoryTypeId: Int!\n  ) {\n    validation: checkAccessoryAvailableForSubscription(\n      partnerLoginId: $partnerLoginId\n      serialNumberList: $serialNumber\n      accessoryTypeId: $accessoryTypeId\n    ) {\n      serialNumber\n      uniqueAccessoryId\n    }\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  mutation setResellerSubscriptionInventoryAssignment(\n    $uniqueDeviceIdList: [uniqueDeviceIdListInput!]\n    $licenseList: [licenseListInput!]\n    $simIdList: [simListInput!]\n    $deviceModelId: Int!\n    $licenseTypeId: Int\n    $serviceProviderId: Int\n    $unAssignedDeviceQuantity: Int!\n    $unAssignedLicenseQuantity: Int!\n    $unAssignedSimQuantity: Int!\n    $resellerLoginId: Int!\n    $clientLoginId: Int!\n    $subscriptionId: Int!\n  ) {\n    setResellerSubscriptionInventoryAssignment(\n      uniqueDeviceIdList: $uniqueDeviceIdList\n      licenseList: $licenseList\n      simList: $simIdList\n      deviceModelId: $deviceModelId\n      licenseTypeId: $licenseTypeId\n      serviceProviderId: $serviceProviderId\n      unAssignedDeviceQuantity: $unAssignedDeviceQuantity\n      unAssignedLicenseQuantity: $unAssignedLicenseQuantity\n      unAssignedSimQuantity: $unAssignedSimQuantity\n      resellerLoginId: $resellerLoginId\n      clientLoginId: $clientLoginId\n      subscriptionId: $subscriptionId\n    )\n  }\n'],['\n  mutation setResellerSubscriptionInventoryAssignment(\n    $uniqueDeviceIdList: [uniqueDeviceIdListInput!]\n    $licenseList: [licenseListInput!]\n    $simIdList: [simListInput!]\n    $deviceModelId: Int!\n    $licenseTypeId: Int\n    $serviceProviderId: Int\n    $unAssignedDeviceQuantity: Int!\n    $unAssignedLicenseQuantity: Int!\n    $unAssignedSimQuantity: Int!\n    $resellerLoginId: Int!\n    $clientLoginId: Int!\n    $subscriptionId: Int!\n  ) {\n    setResellerSubscriptionInventoryAssignment(\n      uniqueDeviceIdList: $uniqueDeviceIdList\n      licenseList: $licenseList\n      simList: $simIdList\n      deviceModelId: $deviceModelId\n      licenseTypeId: $licenseTypeId\n      serviceProviderId: $serviceProviderId\n      unAssignedDeviceQuantity: $unAssignedDeviceQuantity\n      unAssignedLicenseQuantity: $unAssignedLicenseQuantity\n      unAssignedSimQuantity: $unAssignedSimQuantity\n      resellerLoginId: $resellerLoginId\n      clientLoginId: $clientLoginId\n      subscriptionId: $subscriptionId\n    )\n  }\n']);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_CLIENT=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject);var VERIFY_DEVICE=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject2);var VERIFY_SIM=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject3);var GET_SUBSCRIPTION=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject4);var VERIFY_ACCESSORY=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject5);var SAVE_SUBSCRIPTION=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject6);var styles=function styles(theme){return{root:{padding:theme.spacing.unit*2,flexGrow:1},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},input:{display:'none'}};};var AssignDevices=function(_Component){_inherits(AssignDevices,_Component);function AssignDevices(props){var _this2=this;_classCallCheck(this,AssignDevices);var _this=_possibleConstructorReturn(this,(AssignDevices.__proto__||Object.getPrototypeOf(AssignDevices)).call(this,props));_this.getSubscriptions=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _ref2,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.client.query({query:GET_SUBSCRIPTION,variables:{subscriptionId:_this.subscriptionId,loginId:_this.loginId,resellerLoginId:Object(__WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__["a" /* default */])()}});case 2:_ref2=_context.sent;data=_ref2.data;console.log('data',data);if(data.getResellerSubscriptions.unAssignedDeviceQuantity>0){_this.setState({deviceStatus:false});}else{_this.setState({simStatus:false,accssoryStatus:false});}_this.setState({deviceModelName:data.getResellerSubscriptions.deviceModel.model_name,deviceQuantity:data.getResellerSubscriptions.unAssignedDeviceQuantity,deviceModelId:data.getResellerSubscriptions.deviceModelId,manufacturerCode:data.getResellerSubscriptions.deviceModel.manufacturer.manufacturerCode,licenseName:data.getResellerSubscriptions.licenseType.licenseType,licenseExpiryPeriod:data.getResellerSubscriptions.reseller.licenseExpiryPeriod});if(data.getResellerSubscriptions.serviceProvider!==null){_this.setState({simProviderName:data.getResellerSubscriptions.serviceProvider.name,// simProviderId: data.getSubscriptions.serviceProvider.id,
simProviderId:data.getResellerSubscriptions.serviceProviderId,simQuantity:data.getResellerSubscriptions.unAssignedSimQuantity});}_this.mapToArr(data.getResellerSubscriptions.resellerLicenseInventory);case 9:case'end':return _context.stop();}}},_callee,_this2);}));_this.columns=['LICENSE NAME','LICENSE EXPIRY','TOTAL STOCK','SELECT QUANTITY'];_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15};_this.state={open:false,open1:false};_this.submitArr=[];_this.handleInputChange=function(index,id,expiry){return function(event){var tempArr={resellerLicenseInventoryId:id,licenseExpiryTime:expiry,licenseExpiryPeriod:_this.state.licenseExpiryPeriod,quantity:parseInt(event.target.value,10)};_this.submitArr[index]=tempArr;_this.setState({licenseSelectedArr:_this.submitArr});};};_this.handleDeviceValidate=function(type){return _asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var deviceArr,tempArr,_ref4,data,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:deviceArr=_this.state.deviceSerialNo.split(',');tempArr=[];deviceArr.forEach(function(serialno){var temp={};temp.serial_num=serialno;temp.uniqueDeviceId=_this.state.manufacturerCode+'_'+serialno;tempArr.push(temp);});_context2.next=5;return _this.props.client.query({query:VERIFY_DEVICE,variables:{serial_num:tempArr,deviceModelId:parseInt(_this.state.deviceModelId,10),resellerLoginId:Object(__WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__["a" /* default */])()}});case 5:_ref4=_context2.sent;data=_ref4.data;response='';Object.values(data.validation).map(function(res){return response=response+','+res['serial_num'];});if(deviceArr.length>_this.state.deviceQuantity){_this.setState({duplicateDeviceList:'You cannot assign devices more than requested quantity'});}else{_this.setState({duplicateDeviceList:response});}if(data.validation.length===0&&deviceArr.length!==0&&deviceArr.length<=_this.state.deviceQuantity){_this.setState({deviceStatus:true});}case 11:case'end':return _context2.stop();}}},_callee2,_this2);}));};_this.handleSimValidate=function(type){return _asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var simArr,tempArr,_ref6,data,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:simArr=_this.state.simSerialNo.split(',');tempArr=[];if(!(simArr.length>0)){_context3.next=12;break;}simArr.forEach(function(serialno){var temp={};temp.simNumber=serialno;tempArr.push(temp);});_context3.next=6;return _this.props.client.query({query:VERIFY_SIM,variables:{simNumber:tempArr,serviceProviderId:parseInt(_this.state.simProviderId,10),resellerLoginId:Object(__WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__["a" /* default */])()}});case 6:_ref6=_context3.sent;data=_ref6.data;response='';Object.values(data.validation).map(function(res){return response=response+','+res['simNumber'];});if(simArr.length>_this.state.simQuantity){_this.setState({duplicateSimList:'You cannot assign sim more than requested quantity'});}else{_this.setState({duplicateSimList:response});}if(data.validation.length===0&&simArr.length!==0&&simArr.length<=_this.state.simQuantity){_this.setState({simStatus:true});}case 12:case'end':return _context3.stop();}}},_callee3,_this2);}));};_this.handleAccessoryValidate=function(type){return _asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){var accArr,tempArr,_ref8,data,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:accArr=_this.state.accessorySerialNo.split(',');tempArr=[];if(!(accArr.length>0)){_context4.next=12;break;}accArr.forEach(function(serialno){var temp={};temp.serialNumber=serialno;temp.uniqueAccessoryId=_this.state.accManufacturerCode+'_'+serialno;tempArr.push(temp);});_context4.next=6;return _this.props.client.query({query:VERIFY_ACCESSORY,variables:{serialNumber:tempArr,accessoryTypeId:_this.state.accessoryTypeId,partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__["a" /* default */])()}});case 6:_ref8=_context4.sent;data=_ref8.data;response='';Object.values(data.validation).map(function(res){return response=response+','+res['serialNumber'];});if(accArr.length>_this.state.accessoryQuantity){_this.setState({duplicateAccessoryList:'You cannot assign Accessory more than requested quantity'});}else{_this.setState({duplicateAccessoryList:response});}if(data.validation.length===0&&accArr.length!==0&&accArr.length<=_this.state.accessoryQuantity){_this.setState({accessoryStatus:true});}case 12:case'end':return _context4.stop();}}},_callee4,_this2);}));};_this.viewSubscription=function(e){_this.props.history.push({pathname:'/home/reseller/customers/view/'+_this.loginId,state:{from:_this.props.location.pathname}});};_this.handleChange=function(name){return function(event){_this.setState(_defineProperty({},name,event.target.value));};};_this.handleReset=function(type){return function(event){if(type==='device'){_this.setState({deviceSerialNo:'',deviceUniqueNo:'',deviceStatus:false,duplicateDeviceList:''});}if(type==='sim'){_this.setState({simSerialNo:'',simStatus:false,duplicateSimList:''});}if(type==='accessory'){_this.setState({accessorySerialNo:'',accessoryUniqueNo:'',accessoryStatus:false,duplicateAccessoryList:''});}};};_this.handleSaveAssignment=function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(e){var devices,accessories,sims,deviceArr,simArr,accArr;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:devices=[];accessories=[];sims=[];deviceArr=[];simArr=[];accArr=[];if(_this.state.deviceSerialNo!==''){deviceArr=_this.state.deviceSerialNo.split(',');deviceArr.forEach(function(serialno){var temp={};temp.uniqueDeviceId=_this.state.manufacturerCode+'_'+serialno;devices.push(temp);});}if(_this.state.simSerialNo!==''){simArr=_this.state.simSerialNo.split(',');simArr.forEach(function(serialno){var temp={};temp.simNumber=serialno;sims.push(temp);});}if(_this.state.accessorySerialNo!==''){accArr=_this.state.accessorySerialNo.split(',');accArr.forEach(function(serialno){var temp={};temp.uniqueAccessoryId=_this.state.accManufacturerCode+'_'+serialno;accessories.push(temp);});}_context5.next=11;return _this.props.client.mutate({mutation:SAVE_SUBSCRIPTION,variables:{uniqueDeviceIdList:devices,uniqueAccessoryIdList:accessories,simIdList:sims,deviceModelId:_this.state.deviceModelId,accessoryTypeId:_this.state.accessoryTypeId,serviceProviderId:_this.state.simProviderId,unAssignedDeviceQuantity:_this.state.deviceQuantity-deviceArr.length,unAssignedAccessoryQuantity:_this.state.accessoryQuantity-accArr.length,unAssignedSimQuantity:_this.state.simQuantity-simArr.length,resellerLoginId:Object(__WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__["a" /* default */])(),clientLoginId:_this.loginId,subscriptionId:_this.subscriptionId,licenseList:_this.state.licenseSelectedArr,unAssignedLicenseQuantity:_this.state.deviceQuantity-deviceArr.length}});case 11:_this.setState({deviceSerialNo:'',simSerialNo:'',accessorySerialNo:'',duplicateDeviceList:'',duplicateAccessoryList:'',duplicateSimList:'',licenseList:''});case 12:case'end':return _context5.stop();}}},_callee5,_this2);}));return function(_x){return _ref9.apply(this,arguments);};}();_this.loginId=parseInt(_this.props.match.params.loginId,10);_this.subscriptionId=parseInt(_this.props.match.params.subscriptionId,10);_this.state={deviceSerialNo:'',deviceUniqueNo:'',deviceModelId:'',deviceModelName:'',deviceQuantity:'',manufacturerCode:'',duplicateDeviceList:'',simSerialNo:'',simProviderName:'',simProviderId:'',simQuantity:'',duplicateSimList:'',accessorySerialNo:'',accessoryType:'',accessoryTypeId:null,accessoryQuantity:'',accManufacturerCode:'',deviceStatus:true,simStatus:true,accessoryStatus:true,licenseStock:[],licenseName:'',selectLicenceQty:[],selectLicenceQtyArr:[],licenseSelectedArr:''};return _this;}_createClass(AssignDevices,[{key:'mapToArr',value:function mapToArr(licenses){var _this3=this;var rowData=[];var fullData=[];// this.clientId = []
licenses.forEach(function(element,index){rowData=[];// this.clientId.push(element.id)
rowData.push(_this3.state.licenseName);rowData.push(element.licenseExpiryTime);rowData.push(element.approvedQuantity);rowData.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_TextField___default.a,{margin:'dense',id:'selectLicenceQty',name:'selectLicenceQty',label:'Enter Quantity',type:'text',required:true,fullWidth:true,value:_this3.state.selectLicenceQty[element.id],onChange:_this3.handleInputChange(index,element.id,element.licenseExpiryTime)}));fullData.push(rowData);});this.setState({licenseStock:fullData});}},{key:'componentDidMount',value:function componentDidMount(){this.getSubscriptions();}},{key:'render',value:function render(){var _this4=this;var classes=this.props.classes;// console.log('selectLicenceQty', this.state.selectLicenceQty)
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_apollo__["Query"],{query:GET_CLIENT,variables:{loginId:parseInt(this.loginId,10)}},function(_ref10){var loading=_ref10.loading,error=_ref10.error,clientDetail=_ref10.data.clientDetail;if(loading)return'Loading...';if(error)return'Error!: '+error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Button"],{variant:'outlined',color:'secondary',className:classes.button,onClick:function onClick(){return _this4.props.history.goBack();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_ArrowBack___default.a,{className:classes.iconSmall})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Modules_CustomerDetailsCard__["a" /* default */],{clientDetail:clientDetail}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'subheading'},'Assigned Inventory Details',' ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Card___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row',alignItems:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'subheading'},'Device :')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'body1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',null,'Model:'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'body2'},_this4.state.deviceModelName)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'body1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',null,'Quantity:'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'body2'},_this4.state.deviceQuantity)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:5},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_TextField___default.a,{fullWidth:true,id:'outlined-multiline-flexible',label:'Enter Serial Number With Comma Seprate',multiline:true,value:/* eslint-disable */_this4.state.deviceSerialNo/* eslint-enable */,onChange:_this4.handleChange('deviceSerialNo'),onBlur:_this4.handleDeviceValidate('device'),className:classes.textField,margin:'normal',helperText:_this4.state.duplicateDeviceList,error:_this4.state.duplicateDeviceList,variant:'outlined'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Button"],{variant:'raised',color:'secondary',className:classes.button,onClick:_this4.handleDeviceValidate('device')},'Validate')),'\xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Button"],{variant:'raised',color:'primary',className:classes.button,onClick:_this4.handleReset('device')},'Reset'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row',alignItems:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'subheading'},'SIM :')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'body1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',null,'SIM Provider:'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'body2'},_this4.state.simProviderName)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'body1'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',null,'Quantity:'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'body2'},_this4.state.simQuantity)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:5},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_TextField___default.a,{fullWidth:true,id:'outlined-multiline-flexible',label:'Enter Serial Number With Comma Seprate',multiline:true,value:/* eslint-disable */_this4.state.simSerialNo/* eslint-enable */,onChange:_this4.handleChange('simSerialNo'),onBlur:_this4.handleSimValidate('sim'),className:classes.textField,margin:'normal',helperText:_this4.state.duplicateSimList,error:_this4.state.duplicateSimList,variant:'outlined'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Button"],{variant:'raised',color:'secondary',className:classes.button,onClick:_this4.handleSimValidate('sim')},'Validate')),'\xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Button"],{variant:'raised',color:'primary',className:classes.button,onClick:_this4.handleReset('sim')},'Reset')))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_mui_datatables___default.a,{data:_this4.state.licenseStock,columns:_this4.columns,options:_this4.options})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,justify:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Button"],{color:'primary',variant:'raised',onClick:_this4.handleSaveAssignment,disabled:!(_this4.state.deviceStatus&&_this4.state.simStatus)// this.state.accessoryStatus
},'Save')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Button"],{color:'secondary',variant:'raised',onClick:_this4.handleCancelAssignment},'Cancel')))));});}}]);return AssignDevices;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);AssignDevices.propTypes={classes:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired};var withApolloClient=function withApolloClient(Component){return function(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_apollo__["ApolloConsumer"],null,function(client){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component,Object.assign({client:client},props));});};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__["withStyles"])(styles)(withApolloClient(AssignDevices)));

/***/ }),
/* 2399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Dialog__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RegisterDevice__ = __webpack_require__(2400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_file_saver__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_getLoginId__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getResellerDeviceStockByDeviceModel($resellerLoginId: Int!) {\n    devices: getResellerDeviceStockByDeviceModel(\n      resellerLoginId: $resellerLoginId\n    ) {\n      deviceModelId\n      modelName\n      totalAssignedDevice\n      totalAssignedDeviceToClient\n      totalRegisteredDevice\n      availableStock\n    }\n  }\n'],['\n  query getResellerDeviceStockByDeviceModel($resellerLoginId: Int!) {\n    devices: getResellerDeviceStockByDeviceModel(\n      resellerLoginId: $resellerLoginId\n    ) {\n      deviceModelId\n      modelName\n      totalAssignedDevice\n      totalAssignedDeviceToClient\n      totalRegisteredDevice\n      availableStock\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n'],['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var style=function style(theme){return{root:{padding:theme.spacing.unit*4,flexGrow:1},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},iconSmall:{fontSize:20}};};var GET_DEVICE_STOCK=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject);var GET_FILE_FORMAT=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject2);var InventoryDevices=function(_Component){_inherits(InventoryDevices,_Component);function InventoryDevices(props){var _this2=this;_classCallCheck(this,InventoryDevices);var _this=_possibleConstructorReturn(this,(InventoryDevices.__proto__||Object.getPrototypeOf(InventoryDevices)).call(this,props));_this.clientId=[];_this.columns=['MODEL NAME','TOTAL ASSIGNED DEVICES','TOTAL DEVICES ASSIGNED TO CLIENT','TOTAL REGISTERED DEVICES','TOTAL STOCK'];_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15,onRowClick:function onRowClick(rowData,dataIndex,rowIndex){_this.props.history.push({pathname:'/home/reseller/devices/view/'+_this.modelId[dataIndex.dataIndex]});}};_this.state={open:false,open1:false};_this.handleClickOpen=function(){_this.setState({open:true});};_this.handleClose=function(){_this.setState({open:false});};_this.handleClickBulkOpen=function(){_this.setState({open1:true});};_this.handleBulkClose=function(){_this.setState({open1:false});};_this.addBulkUpload=function(e){_this.props.history.push({pathname:'/home/reseller/devices/bulk-register'});};_this.downloadBulkUpload=function(client){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _ref2,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.client.query({query:GET_FILE_FORMAT,variables:{bucketname:'excel-templates',filename:'deviceUpload.xlsx'},errorPolicy:'all'});case 2:_ref2=_context.sent;data=_ref2.data;__WEBPACK_IMPORTED_MODULE_10_file_saver___default.a.saveAs(data.getPublicDownloadURL,'sample.xlsx');case 5:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();};_this.classes=props;return _this;}_createClass(InventoryDevices,[{key:'mapToArr',value:function mapToArr(devices){var _this3=this;var rowData=[];var fullData=[];this.modelId=[];console.log('devices',devices);devices.forEach(function(element){rowData=[];_this3.modelId.push(element.deviceModelId);rowData.push(element.modelName);rowData.push(element.totalAssignedDevice);rowData.push(element.totalAssignedDeviceToClient);rowData.push(element.totalRegisteredDevice);rowData.push(element.availableStock);fullData.push(rowData);});return fullData;}},{key:'render',value:function render(){var _this4=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["Query"],{query:GET_DEVICE_STOCK,variables:{resellerLoginId:Object(__WEBPACK_IMPORTED_MODULE_11__utils_getLoginId__["a" /* default */])()}},function(_ref3){var loading=_ref3.loading,error=_ref3.error,devices=_ref3.data.devices;if(loading)return'Loading...';if(error)return'Error!: '+error;var data=_this4.mapToArr(devices);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16// direction="row-reverse"
,justify:'space-between'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Typography___default.a,{variant:'headline'},'Devices'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Dialog___default.a,{open:_this4.state.open,onClose:_this4.handleClose,'aria-labelledby':'form-dialog-title'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__RegisterDevice__["a" /* default */],{handleClose:_this4.handleClose})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_mui_datatables___default.a,{data:data,columns:_this4.columns,options:_this4.options}))));});}}]);return InventoryDevices;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["withApollo"])(InventoryDevices)));

/***/ }),
/* 2400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_DialogActions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogContent__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContentText__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContentText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContentText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogTitle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_getLoginId__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query {\n    models: allDeviceModels(status: 1) {\n      id\n      model_name\n    }\n  }\n'],['\n  query {\n    models: allDeviceModels(status: 1) {\n      id\n      model_name\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query {\n    manufacturers: getAllManufacturer(status: 1) {\n      id\n      manufacturerName\n      manufacturerCode\n    }\n  }\n'],['\n  query {\n    manufacturers: getAllManufacturer(status: 1) {\n      id\n      manufacturerName\n      manufacturerCode\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation addDeviceDetailsFromPartnerAdmin(\n    $serial_num: Int!\n    $imei_num: String!\n    $device_model_id: Int!\n    $uniqueSerialNumber: String!\n    $manufacturerId: Int!\n    $ownerLoginId: Int!\n  ) {\n    addDeviceDetailsFromPartnerAdmin(\n      serial_num: $serial_num\n      imei_num: $imei_num\n      deviceModelId: $device_model_id\n      uniqueDeviceId: $uniqueSerialNumber\n      manufacturerId: $manufacturerId\n      ownerLoginId: $ownerLoginId\n    )\n  }\n'],['\n  mutation addDeviceDetailsFromPartnerAdmin(\n    $serial_num: Int!\n    $imei_num: String!\n    $device_model_id: Int!\n    $uniqueSerialNumber: String!\n    $manufacturerId: Int!\n    $ownerLoginId: Int!\n  ) {\n    addDeviceDetailsFromPartnerAdmin(\n      serial_num: $serial_num\n      imei_num: $imei_num\n      deviceModelId: $device_model_id\n      uniqueDeviceId: $uniqueSerialNumber\n      manufacturerId: $manufacturerId\n      ownerLoginId: $ownerLoginId\n    )\n  }\n']);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_MODELS=Object(__WEBPACK_IMPORTED_MODULE_13_graphql_tag__["a" /* default */])(_templateObject);var GET_MANUFACTURER=Object(__WEBPACK_IMPORTED_MODULE_13_graphql_tag__["a" /* default */])(_templateObject2);// calling server for updation
var ADD_DEVICE=Object(__WEBPACK_IMPORTED_MODULE_13_graphql_tag__["a" /* default */])(_templateObject3);var styles=function styles(theme){return{button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{margin:theme.spacing.unit,minWidth:120}};};var RegisterDevice=function(_Component){_inherits(RegisterDevice,_Component);function RegisterDevice(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RegisterDevice);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RegisterDevice.__proto__||Object.getPrototypeOf(RegisterDevice)).call.apply(_ref,[this].concat(args))),_this),_this.state={open1:false,modelname:'',serialno:'',imeino:'',uniqueSerialNumber:'',isModelNameValid:true,isSerialnoValid:true,isImeinoValid:true,isManufacturerNameValid:true,manufacturerName:'',open_man:false,manufacturerCode:'',manufacturerId:''},_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));};},_this.handleChange=function(event){_this.setState(_defineProperty({},event.target.name,event.target.value));},_this.handleOpen=function(){_this.setState({open:true});},_this.handleOpenSelect=function(){_this.setState({open1:true});},_this.handleCloseSelect=function(){_this.setState({open1:false});},_this.handleOpenSelectMan=function(){_this.setState({open_man:true});},_this.handleCloseSelectMan=function(){_this.setState({open_man:false});},_this.checkImeinoValidity=function(){// const regex = new RegExp(/^[0-9]{15}$/)
_this.setState({isImeinoValid:_this.state.imeino!==''// this.state.modelname === ''
});// console.log(this.state.isModelNameValid)
},_this.checkSerialnoValidity=function(){console.log('here1');var regex=new RegExp(/^[0-9]{9}$/);var code=[];code=_this.state.manufacturerName.split('*');if(code[0]===''){_this.setState({isSerialnoValid:regex.test(_this.state.serialno)||_this.state.serialno===''});}else{_this.setState({isSerialnoValid:regex.test(_this.state.serialno)||_this.state.serialno==='',uniqueSerialNumber:code[1]+'_'+_this.state.serialno});}},_this.checkModelNameValidity=function(){_this.setState({isModelNameValid:_this.state.modelname!==''});},_this.checkManufacturerNameValidity=function(){var code=[];code=_this.state.manufacturerName.split('*');if(code[0]===''){_this.setState({isManufacturerNameValid:_this.state.manufacturerName!=='',// manufacturerCode:this
uniqueSerialNumber:code[1]+'_'+_this.state.serialno,manufacturerId:code[0]});}else{_this.setState({isManufacturerNameValid:_this.state.manufacturerName!=='',// manufacturerCode:this
uniqueSerialNumber:'',manufacturerId:code[0]});}},_this.handleSubmit=function(addDevice){return function(e){e.preventDefault();addDevice({variables:{serial_num:_this.state.serialno,imei_num:_this.state.imeino,device_model_id:_this.state.modelname,uniqueSerialNumber:_this.state.uniqueSerialNumber,manufacturerId:_this.state.manufacturerId,ownerLoginId:Object(__WEBPACK_IMPORTED_MODULE_16__utils_getLoginId__["a" /* default */])()}});// this.state.simprovider = ''
_this.setState({serial_num:'',imei_num:'',device_model_id:'',uniqueSerialNumber:'',manufacturerId:''});};},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RegisterDevice,[{key:'render',value:function render(){var _this2=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_apollo__["Query"],{query:GET_MODELS},function(_ref2){var isModelsLoading=_ref2.loading,error=_ref2.error,models=_ref2.data.models;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_apollo__["Query"],{query:GET_MANUFACTURER},function(_ref3){var isManufacturersLoading=_ref3.loading,error=_ref3.error,manufacturers=_ref3.data.manufacturers;if(isModelsLoading||isManufacturersLoading)return null;if(error)return'Error!: '+error;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_apollo__["Mutation"],{mutation:ADD_DEVICE},function(addDevice,_ref4){var data=_ref4.data,error=_ref4.error;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogTitle___default.a,{id:'form-dialog-title'},'Add Device Details :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["Typography"],{variant:'subheading',gutterBottom:true,style:{color:'red',marginLeft:'25px'}},error&&error.graphQLErrors.map(function(_ref5,i){var message=_ref5.message;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:i},message);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["Typography"],{variant:'subheading',gutterBottom:true,style:{color:'green',marginLeft:'25px'}},data&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Sucessfully Added')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Divider___default.a,{light:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:_this2.handleSubmit(addDevice)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContentText___default.a,null,'* Marked fields are mandatory'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'60%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_InputLabel___default.a,{htmlFor:'demo-controlled-open-select'},'Select Manufacturer'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select___default.a,{open:_this2.state.open_man,fullWidth:true,onClose:_this2.handleCloseSelectMan,onOpen:_this2.handleOpenSelectMan,value:_this2.state.manufacturerName,onChange:_this2.handleChange,onBlur:_this2.checkManufacturerNameValidity,inputProps:{name:'manufacturerName',id:'manufacturerName'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'None')),manufacturers.map(function(manufacturer){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default.a,{value:manufacturer.id+'*'+manufacturer.manufacturerCode,key:manufacturer.id},manufacturer.manufacturerName);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'60%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_InputLabel___default.a,{htmlFor:'demo-controlled-open-select'},'Select Model'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select___default.a,{open:_this2.state.open1,fullWidth:true,onClose:_this2.handleCloseSelect,onOpen:_this2.handleOpenSelect,value:_this2.state.modelname,onChange:_this2.handleChange,onBlur:_this2.checkModelNameValidity,inputProps:{name:'modelname',id:'modelname'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'None')),models.map(function(allDeviceModelsByStatus){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default.a,{value:allDeviceModelsByStatus.id,key:allDeviceModelsByStatus.id},allDeviceModelsByStatus.model_name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'serialno',name:'serialno',label:'Serial No',type:'text',required:true,value:_this2.state.serialno,fullWidth:true,onChange:_this2.handleInputChange('serialno'),error:!_this2.state.isSerialnoValid,onBlur:_this2.checkSerialnoValidity})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'imeino',name:'imeino',label:'IMEI No',type:'text',required:true,fullWidth:true,value:_this2.state.imeino,onChange:_this2.handleInputChange('imeino'),error:!_this2.state.isImeinoValid,onBlur:_this2.checkImeinoValidity})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'uniqueSerialNumber',name:'uniqueSerialNumber',label:'Unique Id',type:'text',disabled:true,required:true,fullWidth:true,value:_this2.state.uniqueSerialNumber,onChange:_this2.handleInputChange('uniqueSerialNumber')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_DialogActions___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button___default.a,{onClick:_this2.props.handleClose,color:'default',variant:'contained'},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button___default.a,{type:'submit',color:'primary',variant:'contained',disabled:!(_this2.state.isModelNameValid&&_this2.state.isSerialnoValid&&_this2.state.isImeinoValid&&_this2.state.serialno!==''&&_this2.state.imeino!=='')},'Submit'))));});});});}}]);return RegisterDevice;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__["withStyles"])(styles)(RegisterDevice));

/***/ }),
/* 2401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Dialog__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_getLoginId__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getAllDeviceDetailsByLoginId(\n    $loginId: Int!\n    $accountType: String!\n    $deviceModelId: Int!\n  ) {\n    devices: getAllDeviceDetailsByLoginId(\n      loginId: $loginId\n      accountType: $accountType\n      deviceModelId: $deviceModelId\n    ) {\n      serial_num\n      imei_num\n      uniqueDeviceId\n      status\n    }\n  }\n'],['\n  query getAllDeviceDetailsByLoginId(\n    $loginId: Int!\n    $accountType: String!\n    $deviceModelId: Int!\n  ) {\n    devices: getAllDeviceDetailsByLoginId(\n      loginId: $loginId\n      accountType: $accountType\n      deviceModelId: $deviceModelId\n    ) {\n      serial_num\n      imei_num\n      uniqueDeviceId\n      status\n    }\n  }\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var style=function style(theme){return{root:{padding:theme.spacing.unit*4,flexGrow:1},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},iconSmall:{fontSize:20}};};var GET_DEVICE_LIST=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject);var ViewInventoryDevices=function(_Component){_inherits(ViewInventoryDevices,_Component);function ViewInventoryDevices(props){_classCallCheck(this,ViewInventoryDevices);var _this=_possibleConstructorReturn(this,(ViewInventoryDevices.__proto__||Object.getPrototypeOf(ViewInventoryDevices)).call(this,props));_this.clientId=[];_this.columns=['SERIAL NO','IMEI NO','UNIQUE ID','STATUS'];_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15};_this.state={open:false,open1:false};_this.getStatus=function(status){if(status===2){return'Instock';}else if(status===3){return'Assigned to Client';}else if(status===4){return'Registered to vehicle';}};_this.handleClickOpen=function(){_this.setState({open:true});};_this.handleClose=function(){_this.setState({open:false});};_this.handleClickBulkOpen=function(){_this.setState({open1:true});};_this.handleBulkClose=function(){_this.setState({open1:false});};_this.addBulkUpload=function(e){_this.props.history.push({pathname:'/home/DeviceInventory/BulkUpload'});};_this.assignBulkUpload=function(e){console.log('bulk');_this.props.history.push({pathname:'/home/DeviceInventory/BulkDeviceAssign'});};_this.classes=props;return _this;}_createClass(ViewInventoryDevices,[{key:'mapToArr',value:function mapToArr(devices){var _this2=this;var rowData=[];var fullData=[];// this.clientId = []
devices.forEach(function(element){rowData=[];// this.clientId.push(element.id)
rowData.push(element.serial_num);rowData.push(element.imei_num);rowData.push(element.uniqueDeviceId);rowData.push(_this2.getStatus(element.status));fullData.push(rowData);});return fullData;}},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["Query"],{query:GET_DEVICE_LIST,variables:{loginId:Object(__WEBPACK_IMPORTED_MODULE_8__utils_getLoginId__["a" /* default */])(),accountType:localStorage.getItem('Account_type'),deviceModelId:parseInt(this.props.match.params.modelId,10)}},function(_ref){var loading=_ref.loading,error=_ref.error,devices=_ref.data.devices;if(loading)return'Loading...';if(error)return'Error!: '+error;var data=_this3.mapToArr(devices);console.log('devices',devices);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16// direction="row-reverse"
,justify:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'headline'},'Device Details'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Dialog___default.a,{open:_this3.state.open,onClose:_this3.handleClose,'aria-labelledby':'form-dialog-title'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_mui_datatables___default.a,{data:data,columns:_this3.columns,options:_this3.options}))));});}}]);return ViewInventoryDevices;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["withApollo"])(ViewInventoryDevices)));

/***/ }),
/* 2402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_getLoginId__ = __webpack_require__(12);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query {\n    models: allDeviceModels(status: 1) {\n      id\n      model_name\n    }\n  }\n'],['\n  query {\n    models: allDeviceModels(status: 1) {\n      id\n      model_name\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query {\n    manufacturers: getAllManufacturer(status: 1) {\n      id\n      manufacturerName\n      manufacturerCode\n    }\n  }\n'],['\n  query {\n    manufacturers: getAllManufacturer(status: 1) {\n      id\n      manufacturerName\n      manufacturerCode\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation excelFileUpload(\n    $fileInfo: FileUploadInput!\n    $commonInput: CommonInput!\n  ) {\n    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {\n      failedToUpload\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedUploadList\n    }\n  }\n'],['\n  mutation excelFileUpload(\n    $fileInfo: FileUploadInput!\n    $commonInput: CommonInput!\n  ) {\n    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {\n      failedToUpload\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedUploadList\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n'],['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_MODELS=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject);var GET_MANUFACTURER=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject2);var ADD_DEVICE=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject3);var GET_UPLOAD_URL=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject4);var styles=function styles(theme){return{button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{margin:theme.spacing.unit,minWidth:120},root:{flexGrow:1,padding:theme.spacing.unit*2}};};var RegisterBulkDevice=function(_Component){_inherits(RegisterBulkDevice,_Component);function RegisterBulkDevice(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,RegisterBulkDevice);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RegisterBulkDevice.__proto__||Object.getPrototypeOf(RegisterBulkDevice)).call.apply(_ref,[this].concat(args))),_this),_this.state={open:false,open1:false,modelname:'',isModelNameValid:false,isManufacturerNameValid:false,manufacturerName:'',open_man:false,manufacturerCode:'',manufacturerId:'',publicUploadURL:'',fileName:'',bucketName:'',isUploading:false,uploadSucess:true,response:'',failList:'',result:false},_this.columns=['Serial Number','IMEI Number'],_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15,print:false,download:false},_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));};},_this.handleChange=function(event){_this.setState(_defineProperty({},event.target.name,event.target.value));},_this.handleOpen=function(){_this.setState({open:true});},_this.handleOpenSelect=function(){_this.setState({open1:true});},_this.handleCloseSelect=function(){_this.setState({open1:false});},_this.handleOpenSelectMan=function(){_this.setState({open_man:true});},_this.handleCloseSelectMan=function(){_this.setState({open_man:false});},_this.checkModelNameValidity=function(){_this.setState({isModelNameValid:_this.state.modelname!==''});},_this.checkManufacturerNameValidity=function(){var code=_this.state.manufacturerName.split('*');_this.setState({isManufacturerNameValid:_this.state.manufacturerName!=='',// manufacturerCode:this
uniqueSerialNumber:code[1]+'_'+_this.state.serialno,manufacturerId:code[0]});},_this.handleSubmit=function(client){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var manarr,_ref3,data,fullData,arrList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:event.preventDefault();manarr=_this.state.manufacturerName.split('*');_context.next=4;return client.mutate({mutation:ADD_DEVICE,variables:{fileInfo:{uploadFor:'DeviceUploadByPartner',bucketName:_this.state.bucketName,fileName:_this.state.fileName,operationType:'SKIP'},commonInput:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_16__utils_getLoginId__["a" /* default */])(),manufacturerId:manarr[0],manufacturerCode:manarr[1],deviceModelId:_this.state.modelname}}});case 4:_ref3=_context.sent;data=_ref3.data;fullData=[];arrList=data.excelFileUpload.failedUploadList;JSON.parse(arrList).forEach(function(element){var rowData=[];// this.clientId.push(element.id)
rowData.push(element.Serial_Number);rowData.push(element.IMEI);fullData.push(rowData);});_this.setState({device_model_id:'',manufacturerId:'',response:'Total Excel Records= '+data.excelFileUpload.totalExcelDataRecords+','+'Total Records Uploaded='+data.excelFileUpload.successfullyUploaded+', Total Records Failed To Upload='+data.excelFileUpload.failedToUpload+', Total Duplicate Records in Excel='+data.excelFileUpload.totalDuplicateRecords,uploadSucess:true,failList:fullData,result:true});case 10:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}();},_this.onUpload=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4){var _ref4$target=_ref4.target,validity=_ref4$target.validity,_ref4$target$files=_slicedToArray(_ref4$target.files,1),file=_ref4$target$files[0];var fileExtension,response,url;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:// TODO: Handle upload errors
_this.setState({isUploading:true});if(!validity.valid){_context2.next=11;break;}fileExtension=file.name.substring(file.name.lastIndexOf('.')+1);_context2.next=5;return _this.props.client.mutate({mutation:GET_UPLOAD_URL,variables:{fileExtension:fileExtension}});case 5:response=_context2.sent;if(!(response.data&&response.data.getPublicUploadURL)){_context2.next=11;break;}url=response.data.getPublicUploadURL.publicUploadURL;_context2.next=10;return __WEBPACK_IMPORTED_MODULE_13_axios___default.a.put(url,file,{headers:{"x-ms-blob-type":"BlockBlob","Content-Type":file.type||"application/octet-stream"}});case 10:_this.setState({fileName:response.data.getPublicUploadURL.filename,bucketName:response.data.getPublicUploadURL.bucketName,publicUploadURL:response.data.getPublicUploadURL.publicUploadURL});case 11:_this.setState({isUploading:false});case 12:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref5.apply(this,arguments);};}(),_temp),_possibleConstructorReturn(_this,_ret);}// handleSubmit = addDevice => e => {
_createClass(RegisterBulkDevice,[{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["Query"],{query:GET_MODELS},function(_ref6){var isModelsLoading=_ref6.loading,error=_ref6.error,models=_ref6.data.models;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["Query"],{query:GET_MANUFACTURER},function(_ref7){var isManufacturersLoading=_ref7.loading,error=_ref7.error,manufacturers=_ref7.data.manufacturers;if(isModelsLoading||isManufacturersLoading)return null;if(error)return'Error!: '+error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{container:true,direction:'row',justify:'flex-start',alignItems:'center',spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Typography"],{variant:'title'},' ','Add Device Details')),_this3.state.uploadSucess&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Typography"],{variant:'subheading',color:'primary'},_this3.state.response),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider___default.a,{light:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{style:{minWidth:'40%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'100%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel___default.a,{htmlFor:'demo-controlled-open-select'},'Select Manufacturer'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select___default.a,{open:_this3.state.open_man,fullWidth:true,onClose:_this3.handleCloseSelectMan,onOpen:_this3.handleOpenSelectMan,value:_this3.state.manufacturerName,onChange:_this3.handleChange,onBlur:_this3.checkManufacturerNameValidity,inputProps:{name:'manufacturerName',id:'manufacturerName'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),manufacturers.map(function(manufacturer){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem___default.a,{value:manufacturer.id+'*'+manufacturer.manufacturerCode,key:manufacturer.id},manufacturer.manufacturerName);}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'100%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel___default.a,{htmlFor:'demo-controlled-open-select'},'Select Model'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select___default.a,{open:_this3.state.open1,fullWidth:true,onClose:_this3.handleCloseSelect,onOpen:_this3.handleOpenSelect,value:_this3.state.modelname,onChange:_this3.handleChange,onBlur:_this3.checkModelNameValidity,inputProps:{name:'modelname',id:'modelname'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),models.map(function(allDeviceModelsByStatus){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem___default.a,{value:allDeviceModelsByStatus.id,key:allDeviceModelsByStatus.id},allDeviceModelsByStatus.model_name);}))),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{accept:'*/*',id:'contained-button-file',multiple:true,type:'file',style:{display:'none'},onChange:_this3.onUpload}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'contained-button-file'},'Upload excel file here \xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{variant:'contained',component:'span',color:'primary'},_this3.state.isUploading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress___default.a,{size:15}):'Upload')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:_this3.handleClose,color:'default',variant:'contained'},'Cancel'),'       ','       ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:_this3.handleSubmit(_this3.props.client),type:'submit',color:'primary',variant:'contained',disabled:!(_this3.state.isModelNameValid&&_this3.state.fileName!==''&&_this3.state.isManufacturerNameValid)},'Submit')),_this3.state.result&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',null,'Failed records list'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_mui_datatables___default.a,{data:_this3.state.failList,columns:_this3.columns,options:_this3.options})))));});});}}]);return RegisterBulkDevice;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["withStyles"])(styles)(__WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter___default()(Object(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["withApollo"])(RegisterBulkDevice))));

/***/ }),
/* 2403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Menu__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Dialog__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__RegisterAccessory__ = __webpack_require__(2404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_file_saver__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getPartnerAccessoryStockByAccessoryType($partnerLoginId: Int!) {\n    accessory: getPartnerAccessoryStockByAccessoryType(\n      partnerLoginId: $partnerLoginId\n    ) {\n      accessoryTypeName\n      availableStock\n      totalAssignedAccessory\n    }\n  }\n'],['\n  query getPartnerAccessoryStockByAccessoryType($partnerLoginId: Int!) {\n    accessory: getPartnerAccessoryStockByAccessoryType(\n      partnerLoginId: $partnerLoginId\n    ) {\n      accessoryTypeName\n      availableStock\n      totalAssignedAccessory\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n'],['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var style=function style(theme){return{root:{padding:theme.spacing.unit*4,flexGrow:1},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},iconSmall:{fontSize:20}};};var GET_ACCESSORY_STOCK=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject);var GET_FILE_FORMAT=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject2);var InventoryDevices=function(_Component){_inherits(InventoryDevices,_Component);function InventoryDevices(props){var _this2=this;_classCallCheck(this,InventoryDevices);var _this=_possibleConstructorReturn(this,(InventoryDevices.__proto__||Object.getPrototypeOf(InventoryDevices)).call(this,props));_this.clientId=[];_this.columns=['MODEL NAME','TOTAL QUANTITY','AVAILABLE STOCK'];_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15};_this.state={open:false};_this.handleClickOpen=function(){_this.setState({open:true});};_this.handleClose=function(){_this.setState({open:false});};_this.addBulkUpload=function(e){_this.props.history.push({pathname:'/home/reseller/accessories/bulk-register'});};_this.downloadBulkUpload=function(client){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _ref2,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return client.query({query:GET_FILE_FORMAT,variables:{bucketname:'excel-templates',filename:'deviceUpload.xlsx'},errorPolicy:'all'});case 2:_ref2=_context.sent;data=_ref2.data;__WEBPACK_IMPORTED_MODULE_12_file_saver___default.a.saveAs(data.getPublicDownloadURL,'sample.xlsx');case 5:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();};_this.classes=props;return _this;}_createClass(InventoryDevices,[{key:'mapToArr',value:function mapToArr(devices){var rowData=[];var fullData=[];// this.clientId = []
devices.forEach(function(element){rowData=[];// this.clientId.push(element.id)
rowData.push(element.accessoryTypeName);rowData.push(element.totalAssignedAccessory);rowData.push(element.availableStock);fullData.push(rowData);});return fullData;}},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["Query"],{query:GET_ACCESSORY_STOCK,variables:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__["a" /* default */])()}},function(_ref3){var loading=_ref3.loading,error=_ref3.error,accessory=_ref3.data.accessory;if(loading)return'Loading...';if(error)return'Error!: '+error;var data=_this3.mapToArr(accessory);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row-reverse',justify:'space-between'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{color:'secondary',variant:'contained',className:classes.button,onClick:_this3.handleClickOpen},'New Accessory'),'  ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{color:'secondary',variant:'contained',className:classes.button,onClick:_this3.addBulkUpload},'Bulk Upload'),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{color:'secondary',variant:'contained',className:classes.button,onClick:_this3.downloadBulkUpload(_this3.props.client)},'Download Format'),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{variant:'outlined',className:classes.button},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Menu___default.a,{className:classes.iconSmall}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{variant:'headline'},'Accessories'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Dialog___default.a,{open:_this3.state.open,onClose:_this3.handleClose,'aria-labelledby':'form-dialog-title'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__RegisterAccessory__["a" /* default */],{handleClose:_this3.handleClose})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_mui_datatables___default.a,{data:data,columns:_this3.columns,options:_this3.options}))));});}}]);return InventoryDevices;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["withApollo"])(InventoryDevices)));

/***/ }),
/* 2404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_DialogActions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogContent__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContentText__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContentText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContentText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogTitle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_getLoginId__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query {\n    accessory: getAllAccessoryTypes(status: 1) {\n      id\n      accessoryName\n      version\n    }\n  }\n'],['\n  query {\n    accessory: getAllAccessoryTypes(status: 1) {\n      id\n      accessoryName\n      version\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query {\n    manufacturers: getAllManufacturer(status: 1) {\n      id\n      manufacturerName\n      manufacturerCode\n    }\n  }\n'],['\n  query {\n    manufacturers: getAllManufacturer(status: 1) {\n      id\n      manufacturerName\n      manufacturerCode\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation addAccessoryDetailsFromPartnerAdmin(\n    $serial_num: Int!\n    $device_model_id: Int!\n    $uniqueSerialNumber: String!\n    $manufacturerId: Int!\n    $ownerLoginId: Int!\n  ) {\n    addAccessoryDetailsFromPartnerAdmin(\n      serialNumber: $serial_num\n      accessoryTypeId: $device_model_id\n      uniqueAccessoryId: $uniqueSerialNumber\n      manufacturerId: $manufacturerId\n      ownerLoginId: $ownerLoginId\n    )\n  }\n'],['\n  mutation addAccessoryDetailsFromPartnerAdmin(\n    $serial_num: Int!\n    $device_model_id: Int!\n    $uniqueSerialNumber: String!\n    $manufacturerId: Int!\n    $ownerLoginId: Int!\n  ) {\n    addAccessoryDetailsFromPartnerAdmin(\n      serialNumber: $serial_num\n      accessoryTypeId: $device_model_id\n      uniqueAccessoryId: $uniqueSerialNumber\n      manufacturerId: $manufacturerId\n      ownerLoginId: $ownerLoginId\n    )\n  }\n']);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_ACCESSORY=Object(__WEBPACK_IMPORTED_MODULE_13_graphql_tag__["a" /* default */])(_templateObject);var GET_MANUFACTURER=Object(__WEBPACK_IMPORTED_MODULE_13_graphql_tag__["a" /* default */])(_templateObject2);// calling server for updation
var ADD_ACCESSORY=Object(__WEBPACK_IMPORTED_MODULE_13_graphql_tag__["a" /* default */])(_templateObject3);var styles=function styles(theme){return{button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{margin:theme.spacing.unit,minWidth:120}};};var RegisterAccessory=function(_Component){_inherits(RegisterAccessory,_Component);function RegisterAccessory(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RegisterAccessory);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RegisterAccessory.__proto__||Object.getPrototypeOf(RegisterAccessory)).call.apply(_ref,[this].concat(args))),_this),_this.state={open1:false,modelname:'',serialno:'',imeino:'',uniqueSerialNumber:'',isModelNameValid:true,isSerialnoValid:true,isImeinoValid:true,isManufacturerNameValid:true,manufacturerName:'',open_man:false,manufacturerCode:'',manufacturerId:''},_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));};},_this.handleChange=function(event){_this.setState(_defineProperty({},event.target.name,event.target.value));},_this.handleOpen=function(){_this.setState({open:true});},_this.handleOpenSelect=function(){_this.setState({open1:true});},_this.handleCloseSelect=function(){_this.setState({open1:false});},_this.handleOpenSelectMan=function(){_this.setState({open_man:true});},_this.handleCloseSelectMan=function(){_this.setState({open_man:false});},_this.checkImeinoValidity=function(){var regex=new RegExp(// eslint-disable-next-line
/^[0-9]{15}$/);_this.setState({isImeinoValid:regex.test(_this.state.imeino)||_this.state.imeino===''});},_this.checkSerialnoValidity=function(){var regex=new RegExp(/^[0-9]{9}$/);var code=_this.state.manufacturerName.split('*');_this.setState({isSerialnoValid:regex.test(_this.state.serialno)||_this.state.serialno==='',uniqueSerialNumber:code[1]+'_'+_this.state.serialno});},_this.checkModelNameValidity=function(){_this.setState({isModelNameValid:_this.state.modelname!==''});},_this.checkManufacturerNameValidity=function(){var code=_this.state.manufacturerName.split('*');_this.setState({isManufacturerNameValid:_this.state.manufacturerName!=='',// manufacturerCode:this
uniqueSerialNumber:code[1]+'_'+_this.state.serialno,manufacturerId:code[0]});},_this.handleSubmit=function(addDevice){return function(e){e.preventDefault();addDevice({variables:{serial_num:parseInt(_this.state.serialno,10),device_model_id:parseInt(_this.state.modelname,10),uniqueSerialNumber:_this.state.uniqueSerialNumber,manufacturerId:parseInt(_this.state.manufacturerId,10),ownerLoginId:Object(__WEBPACK_IMPORTED_MODULE_16__utils_getLoginId__["a" /* default */])()}});// this.state.simprovider = ''
_this.setState({serial_num:'',imei_num:'',device_model_id:'',uniqueSerialNumber:'',manufacturerId:''});};},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RegisterAccessory,[{key:'render',value:function render(){var _this2=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_apollo__["Query"],{query:GET_ACCESSORY},function(_ref2){var isModelsLoading=_ref2.loading,error=_ref2.error,accessory=_ref2.data.accessory;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_apollo__["Query"],{query:GET_MANUFACTURER},function(_ref3){var isManufacturersLoading=_ref3.loading,error=_ref3.error,manufacturers=_ref3.data.manufacturers;if(isModelsLoading||isManufacturersLoading)return null;if(error)return'Error!: '+error;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_apollo__["Mutation"],{mutation:ADD_ACCESSORY},function(addDevice,_ref4){var data=_ref4.data,error=_ref4.error;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogTitle___default.a,{id:'form-dialog-title'},'Add Accessory Details :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["Typography"],{variant:'subheading',gutterBottom:true,style:{color:'red',marginLeft:'25px'}},error&&error.graphQLErrors.map(function(_ref5,i){var message=_ref5.message;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:i},message);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["Typography"],{variant:'subheading',gutterBottom:true,style:{color:'green',marginLeft:'25px'}},data&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Sucessfully Added')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Divider___default.a,{light:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:_this2.handleSubmit(addDevice)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContentText___default.a,null,'* Marked fields are mandatory'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'60%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_InputLabel___default.a,{htmlFor:'demo-controlled-open-select'},'Select Manufacturer'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select___default.a,{open:_this2.state.open_man,fullWidth:true,onClose:_this2.handleCloseSelectMan,onOpen:_this2.handleOpenSelectMan,value:_this2.state.manufacturerName,onChange:_this2.handleChange,onBlur:_this2.checkManufacturerNameValidity,inputProps:{name:'manufacturerName',id:'manufacturerName'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'None')),manufacturers.map(function(manufacturer){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default.a,{value:manufacturer.id+'*'+manufacturer.manufacturerCode,key:manufacturer.id},manufacturer.manufacturerName);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'60%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_InputLabel___default.a,{htmlFor:'demo-controlled-open-select'},'Select Accessory Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select___default.a,{open:_this2.state.open1,fullWidth:true,onClose:_this2.handleCloseSelect,onOpen:_this2.handleOpenSelect,value:_this2.state.modelname,onChange:_this2.handleChange,onBlur:_this2.checkModelNameValidity,inputProps:{name:'modelname',id:'modelname'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'None')),accessory.map(function(allDeviceModelsByStatus){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default.a,{value:allDeviceModelsByStatus.id,key:allDeviceModelsByStatus.id},allDeviceModelsByStatus.accessoryName+' '+allDeviceModelsByStatus.version);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'serialno',name:'serialno',label:'Serial No',type:'text',required:true,value:_this2.state.serialno,fullWidth:true,onChange:_this2.handleInputChange('serialno'),error:!_this2.state.isSerialnoValid,onBlur:_this2.checkSerialnoValidity})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'uniqueSerialNumber',name:'uniqueSerialNumber',label:'Unique Accessory Id',type:'text',disabled:true,required:true,fullWidth:true,value:_this2.state.uniqueSerialNumber,onChange:_this2.handleInputChange('uniqueSerialNumber')}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_DialogActions___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button___default.a,{onClick:_this2.props.handleClose,color:'default',variant:'contained'},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button___default.a// onClick={this.handleClose}
,{type:'submit',color:'primary',variant:'contained',disabled:!(_this2.state.isModelNameValid&&_this2.state.isSerialnoValid&&_this2.state.isImeinoValid&&_this2.state.serialno!=='')},'Submit'))));});});});}}]);return RegisterAccessory;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__["withStyles"])(styles)(RegisterAccessory));

/***/ }),
/* 2405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_getLoginId__ = __webpack_require__(12);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query {\n    accessory: getAllAccessoryTypes(status: 1) {\n      id\n      accessoryName\n      version\n    }\n  }\n'],['\n  query {\n    accessory: getAllAccessoryTypes(status: 1) {\n      id\n      accessoryName\n      version\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query {\n    manufacturers: getAllManufacturer(status: 1) {\n      id\n      manufacturerName\n      manufacturerCode\n    }\n  }\n'],['\n  query {\n    manufacturers: getAllManufacturer(status: 1) {\n      id\n      manufacturerName\n      manufacturerCode\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation excelFileUpload(\n    $fileInfo: FileUploadInput!\n    $commonInput: CommonInput!\n  ) {\n    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {\n      failedToUpload\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedUploadList\n    }\n  }\n'],['\n  mutation excelFileUpload(\n    $fileInfo: FileUploadInput!\n    $commonInput: CommonInput!\n  ) {\n    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {\n      failedToUpload\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedUploadList\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n'],['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_ACCESSORY=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject);var GET_MANUFACTURER=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject2);// calling server for updation
var ADD_ACCESSORY=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject3);var GET_UPLOAD_URL=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject4);var styles=function styles(theme){return{button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{margin:theme.spacing.unit,minWidth:120},root:{flexGrow:1,padding:theme.spacing.unit*2}};};var RegisterBulkAccessory=function(_Component){_inherits(RegisterBulkAccessory,_Component);function RegisterBulkAccessory(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,RegisterBulkAccessory);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RegisterBulkAccessory.__proto__||Object.getPrototypeOf(RegisterBulkAccessory)).call.apply(_ref,[this].concat(args))),_this),_this.state={open:false,open1:false,modelname:'',isModelNameValid:false,isManufacturerNameValid:false,manufacturerName:'',open_man:false,manufacturerCode:'',manufacturerId:'',publicUploadURL:'',fileName:'',bucketName:'',isUploading:false,uploadSucess:true,response:'',failList:'',result:false},_this.columns=['Serial Number'],_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15,print:false,download:false},_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));};},_this.handleChange=function(event){_this.setState(_defineProperty({},event.target.name,event.target.value));},_this.handleOpen=function(){_this.setState({open:true});},_this.handleOpenSelect=function(){_this.setState({open1:true});},_this.handleCloseSelect=function(){_this.setState({open1:false});},_this.handleOpenSelectMan=function(){_this.setState({open_man:true});},_this.handleCloseSelectMan=function(){_this.setState({open_man:false});},_this.checkModelNameValidity=function(){_this.setState({isModelNameValid:_this.state.modelname!==''});},_this.checkManufacturerNameValidity=function(){var code=_this.state.manufacturerName.split('*');_this.setState({isManufacturerNameValid:_this.state.manufacturerName!=='',// manufacturerCode:this
uniqueSerialNumber:code[1]+'_'+_this.state.serialno,manufacturerId:code[0]});},_this.handleSubmit=function(client){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var manarr,_ref3,data,fullData,arrList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:event.preventDefault();manarr=_this.state.manufacturerName.split('*');_context.next=4;return client.mutate({mutation:ADD_ACCESSORY,variables:{fileInfo:{uploadFor:'AccessoryUploadByPartner',bucketName:_this.state.bucketName,fileName:_this.state.fileName,operationType:'SKIP'},commonInput:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_16__utils_getLoginId__["a" /* default */])(),manufacturerId:manarr[0],manufacturerCode:manarr[1],deviceModelId:_this.state.modelname}}});case 4:_ref3=_context.sent;data=_ref3.data;fullData=[];arrList=data.excelFileUpload.failedUploadList;JSON.parse(arrList).forEach(function(element){var rowData=[];// this.clientId.push(element.id)
rowData.push(element.Serial_Number);// rowData.push(element.IMEI)
fullData.push(rowData);});// this.state.simprovider = ''
_this.setState({device_model_id:'',manufacturerId:'',response:'Total Excel Records= '+data.excelFileUpload.totalExcelDataRecords+','+'Total Records Uploaded='+data.excelFileUpload.successfullyUploaded+', Total Records Failed To Upload='+data.excelFileUpload.failedToUpload+', Total Duplicate Records in Excel='+data.excelFileUpload.totalDuplicateRecords,uploadSucess:true,failList:fullData,result:true});case 10:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}();},_this.onUpload=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4){var _ref4$target=_ref4.target,validity=_ref4$target.validity,_ref4$target$files=_slicedToArray(_ref4$target.files,1),file=_ref4$target$files[0];var fileExtension,response,url;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:// TODO: Handle upload errors
_this.setState({isUploading:true});if(!validity.valid){_context2.next=11;break;}fileExtension=file.name.substring(file.name.lastIndexOf('.')+1);_context2.next=5;return _this.props.client.mutate({mutation:GET_UPLOAD_URL,variables:{fileExtension:fileExtension}});case 5:response=_context2.sent;if(!(response.data&&response.data.getPublicUploadURL)){_context2.next=11;break;}url=response.data.getPublicUploadURL.publicUploadURL;_context2.next=10;return __WEBPACK_IMPORTED_MODULE_13_axios___default.a.put(url,file,{headers:{"x-ms-blob-type":"BlockBlob","Content-Type":file.type||"application/octet-stream"}});case 10:_this.setState({fileName:response.data.getPublicUploadURL.filename,bucketName:response.data.getPublicUploadURL.bucketName,publicUploadURL:response.data.getPublicUploadURL.publicUploadURL});case 11:_this.setState({isUploading:false});case 12:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref5.apply(this,arguments);};}(),_temp),_possibleConstructorReturn(_this,_ret);}// handleSubmit = addDevice => e => {
_createClass(RegisterBulkAccessory,[{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["Query"],{query:GET_ACCESSORY},function(_ref6){var isModelsLoading=_ref6.loading,error=_ref6.error,accessory=_ref6.data.accessory;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["Query"],{query:GET_MANUFACTURER},function(_ref7){var isManufacturersLoading=_ref7.loading,error=_ref7.error,manufacturers=_ref7.data.manufacturers;if(isModelsLoading||isManufacturersLoading)return null;if(error)return'Error!: '+error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{container:true,direction:'row',justify:'flex-start',alignItems:'center',spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Typography"],{variant:'title'},' ','Add Acessory Details')),_this3.state.uploadSucess&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Typography"],{variant:'subheading',color:'primary'},_this3.state.response),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider___default.a,{light:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{style:{minWidth:'40%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'100%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel___default.a,{htmlFor:'demo-controlled-open-select'},'Select Manufacturer'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select___default.a,{open:_this3.state.open_man,fullWidth:true,onClose:_this3.handleCloseSelectMan,onOpen:_this3.handleOpenSelectMan,value:_this3.state.manufacturerName,onChange:_this3.handleChange,onBlur:_this3.checkManufacturerNameValidity,inputProps:{name:'manufacturerName',id:'manufacturerName'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),manufacturers.map(function(manufacturer){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem___default.a,{value:manufacturer.id+'*'+manufacturer.manufacturerCode,key:manufacturer.id},manufacturer.manufacturerName);}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'100%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel___default.a,{htmlFor:'demo-controlled-open-select'},'Select Accessory Type'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select___default.a,{open:_this3.state.open1,fullWidth:true,onClose:_this3.handleCloseSelect,onOpen:_this3.handleOpenSelect,value:_this3.state.modelname,onChange:_this3.handleChange,onBlur:_this3.checkModelNameValidity,inputProps:{name:'modelname',id:'modelname'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),accessory.map(function(allDeviceModelsByStatus){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem___default.a,{value:allDeviceModelsByStatus.id,key:allDeviceModelsByStatus.id},allDeviceModelsByStatus.accessoryName);}))),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{accept:'*/*',id:'contained-button-file',multiple:true,type:'file',style:{display:'none'},onChange:_this3.onUpload}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'contained-button-file'},'Upload excel file here \xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{variant:'contained',component:'span',color:'primary'},_this3.state.isUploading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress___default.a,{size:15}):'Upload')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:_this3.handleClose,color:'default',variant:'contained'},'Cancel'),'       ','       ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:_this3.handleSubmit(_this3.props.client),type:'submit',color:'primary',variant:'contained',disabled:!(_this3.state.isModelNameValid&&_this3.state.fileName!==''&&_this3.state.isManufacturerNameValid)},'Submit')),_this3.state.result&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',null,'Failed records list'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_mui_datatables___default.a,{data:_this3.state.failList,columns:_this3.columns,options:_this3.options})))));});});}}]);return RegisterBulkAccessory;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["withStyles"])(styles)(__WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter___default()(Object(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["withApollo"])(RegisterBulkAccessory))));

/***/ }),
/* 2406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Paper__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Paper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__RegisterSIM__ = __webpack_require__(2407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_file_saver__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__DetailsCard__ = __webpack_require__(2408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ProviderSims__ = __webpack_require__(2409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__EditStatus__ = __webpack_require__(2410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_getLoginId__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getResellerSimStockByServiceProvider($resellerLoginId: Int!) {\n    sims: getResellerSimStockByServiceProvider(\n      resellerLoginId: $resellerLoginId\n    ) {\n      serviceProviderName\n      totalAssignedSim\n      availableStock\n    }\n  }\n'],['\n  query getResellerSimStockByServiceProvider($resellerLoginId: Int!) {\n    sims: getResellerSimStockByServiceProvider(\n      resellerLoginId: $resellerLoginId\n    ) {\n      serviceProviderName\n      totalAssignedSim\n      availableStock\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n'],['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query allSimDetails($resellerLoginId: Int!) {\n    simStock: allSimDetails(ownerLoginId: $resellerLoginId) {\n      id\n      phoneNumber\n      simNumber\n      monthlyCharges\n      status\n      serviceProvider {\n        name\n        id\n      }\n    }\n  }\n'],['\n  query allSimDetails($resellerLoginId: Int!) {\n    simStock: allSimDetails(ownerLoginId: $resellerLoginId) {\n      id\n      phoneNumber\n      simNumber\n      monthlyCharges\n      status\n      serviceProvider {\n        name\n        id\n      }\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var style=function style(theme){return{root:{padding:theme.spacing.unit*2,flexGrow:1},paper:{padding:theme.spacing.unit*2,color:theme.palette.text.secondary},iconSmall:{fontSize:20}};};var GET_SIM_STOCK=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject);var GET_FILE_FORMAT=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject2);var ALL_SIM_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject3);var InventoryDevices=function(_Component){_inherits(InventoryDevices,_Component);function InventoryDevices(props){var _this2=this;_classCallCheck(this,InventoryDevices);var _this=_possibleConstructorReturn(this,(InventoryDevices.__proto__||Object.getPrototypeOf(InventoryDevices)).call(this,props));_this.tableOptions={selectableRows:false,responsive:'scroll',rowsPerPage:5,onRowClick:function onRowClick(rowData,dataIndex,rowIndex){if(rowData.length===5){var installationStatus=void 0;if(rowData[4]==='Yes'){installationStatus='Installed';}else{installationStatus='Not Installed';}_this.setState({editStatusOpen:true,serviceProvider:rowData[0],simNumber:rowData[1],phoneNumber:rowData[2],monthlyCharges:parseInt(rowData[3],10),isInstalled:installationStatus,currentSimId:_this.state.currentSimIds[dataIndex.dataIndex],// prettier-ignore
currentServiceProviderId:_this.state.currentServiceProviderIds[dataIndex.dataIndex]});}else if(rowData.length===4){_this.setState({editStatusOpen:true,serviceProvider:rowData[0],simNumber:rowData[1],phoneNumber:rowData[2],monthlyCharges:parseInt(rowData[3],10),isInstalled:'NA',currentSimId:_this.state.currentSimIds[dataIndex.dataIndex],// prettier-ignore
currentServiceProviderId:_this.state.currentServiceProviderIds[dataIndex.dataIndex]});}}};_this.state={open:false,tableColumns:[],tableData:[],enableButton:false,editStatusOpen:false,serviceProvider:'',simNumber:'',phoneNumber:'',monthlyCharges:'',selectedCategory:'',isInstalled:'',currentSimIds:[],currentServiceProviderIds:[],currentSimId:'',currentServiceProviderId:'',clickStatus:{Activated:false,Deactivated:false,'Safe Custody':false,Unknown:false}};_this.handleClickOpen=function(){_this.setState({open:true});};_this.handleClose=function(){_this.setState({open:false,editStatusOpen:false});};_this.addBulkUpload=function(e){_this.props.history.push({pathname:'/home/reseller/sims/bulk-register'});};_this.downloadBulkUpload=function(client){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _ref2,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.client.query({query:GET_FILE_FORMAT,variables:{bucketname:'excel-templates',filename:'simUpload.xlsx'},errorPolicy:'all'});case 2:_ref2=_context.sent;data=_ref2.data;__WEBPACK_IMPORTED_MODULE_13_file_saver___default.a.saveAs(data.getPublicDownloadURL,'sample.xlsx');case 5:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();};_this.handleClick=function(status){var columns=[];var data=[];var category=void 0;var simProviderIds=[];var simIds=[];var clickStatus={Activated:false,Deactivated:false,'Safe Custody':false,Unknown:false};if(status===1){columns=['SERVICE PROVIDER','SIM NUMBER','PHONE NUMBER','COST','INSTALLED'];category='Activated';clickStatus={Activated:true,Deactivated:false,'Safe Custody':false,Unknown:false};_this.simData.forEach(function(sim){var tempData=[];// make a check for statuses
if(sim.status===1||sim.status===2||sim.status===3){simProviderIds.push(sim.serviceProvider.id);simIds.push(sim.id);tempData.push(sim.serviceProvider.name.toString());tempData.push(sim.simNumber.toString());tempData.push(sim.phoneNumber.toString());tempData.push(sim.monthlyCharges.toString());tempData.push('No');data.push(tempData);}else if(sim.status===4){simProviderIds.push(sim.serviceProvider.id);simIds.push(sim.id);tempData.push(sim.serviceProvider.name.toString());tempData.push(sim.simNumber.toString());tempData.push(sim.phoneNumber.toString());tempData.push(sim.monthlyCharges.toString());tempData.push('Yes');data.push(tempData);}});}else{columns=['SERVICE PROVIDER','SIM NUMBER','PHONE NUMBER','COST'];if(status===0){category='Deactivated';clickStatus={Activated:false,Deactivated:true,'Safe Custody':false,Unknown:false};_this.simData.forEach(function(sim){var tempData=[];// make a check for statuses
if(sim.status===0){simProviderIds.push(sim.serviceProvider.id);simIds.push(sim.id);tempData.push(sim.serviceProvider.name.toString());tempData.push(sim.simNumber.toString());tempData.push(sim.phoneNumber.toString());tempData.push(sim.monthlyCharges.toString());data.push(tempData);}});}else if(status===99){category='Safe Custody';clickStatus={Activated:false,Deactivated:false,'Safe Custody':true,Unknown:false};_this.simData.forEach(function(sim){var tempData=[];// make a check for statuses
if(sim.status===99){simProviderIds.push(sim.serviceProvider.id);simIds.push(sim.id);tempData.push(sim.serviceProvider.name.toString());tempData.push(sim.simNumber.toString());tempData.push(sim.phoneNumber.toString());tempData.push(sim.monthlyCharges.toString());data.push(tempData);}});}else if(status===-1){category='Unknown';clickStatus={Activated:false,Deactivated:false,'Safe Custody':false,Unknown:true};_this.simData.forEach(function(sim){var tempData=[];// make a check for statuses
if(sim.status===-1){simProviderIds.push(sim.serviceProvider.id);simIds.push(sim.id);tempData.push(sim.serviceProvider.name.toString());tempData.push(sim.simNumber.toString());tempData.push(sim.phoneNumber.toString());tempData.push(sim.monthlyCharges.toString());data.push(tempData);}});}}_this.setState({tableData:data,tableColumns:columns,selectedCategory:category,currentSimIds:simIds,currentServiceProviderIds:simProviderIds,clickStatus:clickStatus});};_this.classes=props;_this.simData=[];return _this;}_createClass(InventoryDevices,[{key:'componentDidMount',value:function componentDidMount(){this.handleClick(1);}},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;// SIM Card categories
var simCategories=[{category:'Activated',status:1,count:0,installed:0,uninstalled:0},{category:'Deactivated',status:0,count:0,installed:0,uninstalled:0},{category:'Safe Custody',status:99,count:0,installed:0,uninstalled:0},{category:'Unknown',status:-1,count:0,installed:0,uninstalled:0}];// set currently selected
var currentlySelected=void 0;if(this.state.clickStatus['Activated']===true){currentlySelected='Activated SIMs';}else if(this.state.clickStatus['Deactivated']===true){currentlySelected='Deactivated SIMs';}else if(this.state.clickStatus['Safe Custody']===true){currentlySelected='Safe Custody SIMs';}else if(this.state.clickStatus['Unknown']===true){currentlySelected='Unknown SIMs';}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["Query"],{query:GET_SIM_STOCK,variables:{resellerLoginId:Object(__WEBPACK_IMPORTED_MODULE_17__utils_getLoginId__["a" /* default */])()}},function(_ref3){var loading=_ref3.loading,error=_ref3.error,sims=_ref3.data.sims;if(loading)return'Loading...';if(error)return'Error!: '+error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["Query"],{query:ALL_SIM_DETAILS,variables:{resellerLoginId:Object(__WEBPACK_IMPORTED_MODULE_17__utils_getLoginId__["a" /* default */])()}},function(_ref4){var loading=_ref4.loading,error=_ref4.error,simStock=_ref4.data.simStock;if(loading)return'Loading...';if(error)return'Error!: '+error;console.log('simStock',simStock);_this3.simData=simStock;var totalSims=0;var totalCost=0;var totalExtraSpend=0;// get count of each category
simStock.forEach(function(sim){totalSims+=1;// get activated count
if(sim.status===1||sim.status===2||sim.status===3||sim.status===4){totalCost+=sim.monthlyCharges;simCategories[0].count+=1;if(sim.status===3){totalExtraSpend+=sim.monthlyCharges;simCategories[0].uninstalled+=1;}else if(sim.status===4){simCategories[0].installed+=1;}}else if(sim.status===0){simCategories[1].count+=1;}else if(sim.status===99){simCategories[2].count+=1;}else if(sim.status===-1){simCategories[3].count+=1;}});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row-reverse',justify:'space-between'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{color:'secondary'// href="/home/customers/add"
,variant:'contained',className:classes.button,onClick:_this3.handleClickOpen},'Add SIM Card'),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{color:'secondary',variant:'contained',className:classes.button,onClick:_this3.downloadBulkUpload(_this3.props.client)},'Download Format'),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{color:'secondary',variant:'contained',className:classes.button,onClick:_this3.addBulkUpload},'Bulk SIM Upload')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{variant:'headline'},'SIM Card Management'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{variant:'subheading',color:'textSecondary'},'Details')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:8},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{variant:'subheading',color:'textSecondary'},'Categories'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Paper___default.a,{className:classes.paper},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:8},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{variant:'body1'},'SIMs')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{variant:'body2'},totalSims))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:8},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{variant:'body1'},'Cost (pm)')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{variant:'body2'},totalCost,'/-'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:8},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{variant:'body1'},'Extra Spend (pm)')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{variant:'body2',color:'error'},totalExtraSpend,'/-'))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{variant:'subheading',color:'textSecondary'},'SIM Provider(s)')),sims.map(function(sim){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__ProviderSims__["a" /* default */],{provider:sim.serviceProviderName,noOfSims:sim.totalAssignedSim}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Divider___default.a,null));}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:8,container:true,spacing:16,direction:'row'},simCategories.map(function(category){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__DetailsCard__["a" /* default */],{title:category.category,status:category.status,handleClick:_this3.handleClick,count:category.count,installed:category.installed,uninstalled:category.uninstalled,isClicked:_this3.state.clickStatus[category.category]}));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{variant:'subheading',color:'textSecondary'},currentlySelected)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_mui_datatables___default.a,{data:_this3.state.tableData,columns:_this3.state.tableColumns,options:_this3.tableOptions})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog___default.a,{open:_this3.state.open,'aria-labelledby':'form-dialog-title'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__RegisterSIM__["a" /* default */],{handleClose:_this3.handleClose})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Dialog___default.a,{open:_this3.state.editStatusOpen,'aria-labelledby':'edit-status-dialog'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__EditStatus__["a" /* default */],{handleClose:_this3.handleClose,category:_this3.state.selectedCategory,serviceProvider:_this3.state.serviceProvider,simNumber:_this3.state.simNumber,phoneNumber:_this3.state.phoneNumber,monthlyCharges:_this3.state.monthlyCharges,isInstalled:_this3.state.isInstalled,simId:_this3.state.currentSimId,serviceProviderId:_this3.state.currentServiceProviderId}))));});});}}]);return InventoryDevices;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["withApollo"])(InventoryDevices)));

/***/ }),
/* 2407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_DialogActions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogContent__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContentText__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContentText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContentText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogTitle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_getLoginId__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query {\n    allServiceProviders(status: 1) {\n      id\n      name\n    }\n  }\n'],['\n  query {\n    allServiceProviders(status: 1) {\n      id\n      name\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  mutation addSimDetailsFromResellerAdmin(\n    $phoneNumber: String!\n    $simNumber: String!\n    $service_provider_id: Int!\n    $ownerLoginId: Int!\n    $monthlyCharges: Int!\n  ) {\n    addSimDetailsFromResellerAdmin(\n      phoneNumber: $phoneNumber\n      simNumber: $simNumber\n      service_provider_id: $service_provider_id\n      ownerLoginId: $ownerLoginId\n      monthlyCharges: $monthlyCharges\n    )\n  }\n'],['\n  mutation addSimDetailsFromResellerAdmin(\n    $phoneNumber: String!\n    $simNumber: String!\n    $service_provider_id: Int!\n    $ownerLoginId: Int!\n    $monthlyCharges: Int!\n  ) {\n    addSimDetailsFromResellerAdmin(\n      phoneNumber: $phoneNumber\n      simNumber: $simNumber\n      service_provider_id: $service_provider_id\n      ownerLoginId: $ownerLoginId\n      monthlyCharges: $monthlyCharges\n    )\n  }\n']);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// graph ql querries
var GET_PROVIDER=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject);// calling server for updation
var ADD_SIM=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject2);var styles=function styles(theme){return{button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{margin:theme.spacing.unit,minWidth:120}};};var AddSim=function(_Component){_inherits(AddSim,_Component);function AddSim(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AddSim);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AddSim.__proto__||Object.getPrototypeOf(AddSim)).call.apply(_ref,[this].concat(args))),_this),_this.state={open1:false,simprovider:'',phoneno:'',simno:'',simPrice:'',isSimProviderValid:true,isphonenoValid:true,isSimnoValid:true,isSimPriceValid:true},_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));};},_this.handleChange=function(event){_this.setState(_defineProperty({},event.target.name,event.target.value));},_this.handleOpenSelect=function(){_this.setState({open1:true});},_this.handleCloseSelect=function(){_this.setState({open1:false});},_this.checkSimnoValidity=function(){var regex=new RegExp(// eslint-disable-next-line
/^[0-9]{15}$/);// console.log('a', this.state.imeino)
// console.log(regex.test(this.state.imeino))
_this.setState({isSimnoValid:regex.test(_this.state.simno)||_this.state.simno===''// this.state.modelname === ''
});// console.log(this.state.isModelNameValid)
},_this.checkPhonenoValidity=function(){var regex=new RegExp(/^[0-9]{9,14}$/);_this.setState({isPhonenoValid:regex.test(_this.state.phoneno)||_this.state.phoneno===''});},_this.checkSimPriceValidity=function(){var regex=new RegExp(/^[0-9]+$/);_this.setState({isSimPriceValid:regex.test(_this.state.simPrice)||_this.state.simPrice===''});},_this.checkSimProviderValidity=function(){_this.setState({isSimProviderValid:_this.state.simprovider!==''});},_this.handleSubmit=function(addProvider){return function(e){e.preventDefault();addProvider({variables:{type:_this.state.simprovider}});// this.state.simprovider = ''
_this.setState({simprovider:''});};},_this.handleSubmit=function(addSim){return function(e){console.log('click fun');e.preventDefault();addSim({variables:{phoneNumber:_this.state.phoneno,simNumber:_this.state.simno,service_provider_id:_this.state.simprovider,ownerLoginId:Object(__WEBPACK_IMPORTED_MODULE_15__utils_getLoginId__["a" /* default */])(),monthlyCharges:parseInt(_this.state.simPrice,10)}});_this.setState({phoneNumber:'',simNumber:'',service_provider_id:'',simPrice:''});};},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AddSim,[{key:'render',value:function render(){var _this2=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_apollo__["Query"],{query:GET_PROVIDER},function(_ref2){var loading=_ref2.loading,error=_ref2.error,data=_ref2.data;var queriedData=data;if(loading)return'Loading...';if(error)return'Error!: '+error;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_apollo__["Mutation"],{mutation:ADD_SIM},function(addSim,_ref3){var data=_ref3.data,error=_ref3.error;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogTitle___default.a,{id:'form-dialog-title'},'Add SIM Details :',' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core__["Typography"],{variant:'subheading',gutterBottom:true,style:{color:'red',marginLeft:'25px'}},error&&error.graphQLErrors.map(function(_ref4,i){var message=_ref4.message;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:i},message);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core__["Typography"],{variant:'subheading',gutterBottom:true,style:{color:'green',marginLeft:'25px'}},data&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Sucessfully Added')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:_this2.handleSubmit(addSim)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContentText___default.a,null,'* Marked fields are mandatory'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_InputLabel___default.a,{htmlFor:'demo-controlled-open-select'},'Sim Provider'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Select___default.a,{open:_this2.state.open1,fullWidth:true,onClose:_this2.handleCloseSelect,onOpen:_this2.handleOpenSelect,value:_this2.state.simprovider,onChange:_this2.handleChange,onBlur:_this2.checkSimProviderValidity,inputProps:{name:'simprovider',id:'simprovider'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('em',null,'None')),queriedData.allServiceProviders.map(function(allServiceProvidersByStatus){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_MenuItem___default.a,{value:allServiceProvidersByStatus.id,key:allServiceProvidersByStatus.id},allServiceProvidersByStatus.name);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'phoneno',name:'phoneno',label:'Phone No',type:'text',required:true,value:_this2.state.phoneno,fullWidth:true,onChange:_this2.handleInputChange('phoneno'),error:!_this2.state.isPhonenoValid,onBlur:_this2.checkPhonenoValidity})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'simno',name:'simno',label:'SIM No',type:'text',required:true,fullWidth:true,value:_this2.state.simno,onChange:_this2.handleInputChange('simno'),error:!_this2.state.isSimnoValid})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'simPrice',name:'simPrice',label:'SIM Price per Month',type:'text',required:true,fullWidth:true,value:_this2.state.simPrice,onChange:_this2.handleInputChange('simPrice'),error:!_this2.state.isSimPriceValid,onBlur:_this2.checkSimPriceValidity}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_DialogActions___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button___default.a,{onClick:_this2.props.handleClose,color:'default',variant:'contained'},'Cancel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Button___default.a// onClick={this.handleClose}
,{color:'primary',type:'submit',variant:'contained',disabled:!(_this2.state.isSimProviderValid&&_this2.state.isSimnoValid&&_this2.state.isphonenoValid&&_this2.state.phoneno!==''&&_this2.state.simno!==''&&_this2.state.isSimPriceValid)},'Submit'))));});});}}]);return AddSim;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_styles__["withStyles"])(styles)(AddSim));

/***/ }),
/* 2408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Card__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_CardContent__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_CardContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_CardContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var style=function style(theme){return{title:{fontSize:14},card:{width:'100%',textAlign:'center'},buttonBase:{width:'100%',textAlign:'left'},pos:{marginBottom:12}};};var DetailsCard=function(_Component){_inherits(DetailsCard,_Component);function DetailsCard(){_classCallCheck(this,DetailsCard);return _possibleConstructorReturn(this,(DetailsCard.__proto__||Object.getPrototypeOf(DetailsCard)).apply(this,arguments));}_createClass(DetailsCard,[{key:'render',value:function render(){var _this2=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["ButtonBase"],{className:classes.buttonBase,onClick:function onClick(){return _this2.props.handleClick(_this2.props.status);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Card___default.a,{className:classes.card,raised:!this.props.isClicked},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'body2'},this.props.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'title',color:'error'},this.props.count))));}}]);return DetailsCard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__["withStyles"])(style)(DetailsCard));

/***/ }),
/* 2409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Avatar__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Paper__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Paper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core__ = __webpack_require__(15);
var styles=function styles(theme){return{avatar:{margin:10,width:60,height:60},root:{backgroundColor:theme.palette.background.paper},paper:{padding:theme.spacing.unit*2,color:theme.palette.text.secondary},listItem:{width:'100%',textAlign:'left'}};};function ProviderSims(props){var classes=props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Paper___default.a,{className:classes.paper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Avatar___default.a,{className:classes.avatar},props.provider.charAt(0).toUpperCase())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,xs:8,direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Typography"],{variant:'display1'},props.provider.charAt(0).toUpperCase()+props.provider.substr(1))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Typography"],{variant:'body1'},'Total SIMs')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Typography"],{variant:'body2'},props.noOfSims))))));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles__["withStyles"])(styles)(ProviderSims));

/***/ }),
/* 2410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_DialogActions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogContent__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogTitle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Radio__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_getLoginId__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  mutation updateSimDetail(\n    $id: Int!\n    $phoneNumber: String!\n    $simNumber: String!\n    $ownerLoginId: Int!\n    $monthlyCharges: Int!\n    $status: Int!\n    $service_provider_id: Int!\n  ) {\n    updateSimDetail(\n      id: $id\n      phoneNumber: $phoneNumber\n      simNumber: $simNumber\n      ownerLoginId: $ownerLoginId\n      monthlyCharges: $monthlyCharges\n      status: $status\n      service_provider_id: $service_provider_id\n    )\n  }\n'],['\n  mutation updateSimDetail(\n    $id: Int!\n    $phoneNumber: String!\n    $simNumber: String!\n    $ownerLoginId: Int!\n    $monthlyCharges: Int!\n    $status: Int!\n    $service_provider_id: Int!\n  ) {\n    updateSimDetail(\n      id: $id\n      phoneNumber: $phoneNumber\n      simNumber: $simNumber\n      ownerLoginId: $ownerLoginId\n      monthlyCharges: $monthlyCharges\n      status: $status\n      service_provider_id: $service_provider_id\n    )\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// calling server for updation
var UPDATE_SIM_STATUS=Object(__WEBPACK_IMPORTED_MODULE_7_graphql_tag__["a" /* default */])(_templateObject);var styles=function styles(theme){return{button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{margin:theme.spacing.unit,minWidth:120},root:{padding:theme.spacing.unit*2,flexGrow:1}};};var EditStatus=function(_Component){_inherits(EditStatus,_Component);function EditStatus(props){var _this2=this;_classCallCheck(this,EditStatus);var _this=_possibleConstructorReturn(this,(EditStatus.__proto__||Object.getPrototypeOf(EditStatus)).call(this,props));_this.state={newStatusSelected:false,selectedValue:'',simStatus:'',updateSuccess:false};_this.handleChange=function(event){if(event.target.value!==_this.props.category){_this.setState({selectedValue:event.target.value,newStatusSelected:true,simStatus:event.target.name});}else{_this.setState({selectedValue:event.target.value,newStatusSelected:false,simStatus:event.target.name});}};_this.updateSimStatus=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _ref2,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.client.mutate({mutation:UPDATE_SIM_STATUS,variables:{id:_this.props.simId,phoneNumber:_this.props.phoneNumber,simNumber:_this.props.simNumber,ownerLoginId:Object(__WEBPACK_IMPORTED_MODULE_12__utils_getLoginId__["a" /* default */])(),monthlyCharges:_this.props.monthlyCharges,status:parseInt(_this.state.simStatus,10),service_provider_id:_this.props.serviceProviderId}});case 2:_ref2=_context.sent;data=_ref2.data;if(data.updateSimDetail===true){_this.setState({updateSuccess:true,newStatusSelected:false});}// () => this.props.handleClose()
case 5:case'end':return _context.stop();}}},_callee,_this2);}));_this.classes=props;return _this;}_createClass(EditStatus,[{key:'componentDidMount',value:function componentDidMount(){this.setState({selectedValue:this.props.category});}},{key:'render',value:function render(){var _this3=this;// SIM Card categories
var simCategories=[{category:'Activated',status:1,count:0,installed:0,uninstalled:0},{category:'Deactivated',status:0,count:0,installed:0,uninstalled:0},{category:'Safe Custody',status:99,count:0,installed:0,uninstalled:0}];var activeCategories=['Activate','Deactivate','Safe Custody'];var status=void 0;if(this.state.updateSuccess===true){status=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Typography"],{variant:'body2',color:'primary'},'Update Successful'));}else{status=null;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogTitle___default.a,{id:'form-dialog-title'},'Edit SIM Status'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Typography"],{variant:'body1'},'Service Provider:')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:8},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Typography"],{variant:'body2'},this.props.serviceProvider)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Typography"],{variant:'body1'},'SIM Number:')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:8},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Typography"],{variant:'body2'},this.props.simNumber)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Typography"],{variant:'body1'},'Phone Number:')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:8},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Typography"],{variant:'body2'},this.props.phoneNumber)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Typography"],{variant:'body1'},'Cost per month:')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:8},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Typography"],{variant:'body2'},this.props.monthlyCharges)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Typography"],{variant:'body1'},'Current Status:')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:8},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Typography"],{variant:'body2'},this.props.category)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Typography"],{variant:'body1'},'Installation Status:')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:8},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Typography"],{variant:'body2'},this.props.isInstalled)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Typography"],{variant:'subheading'},'Update SIM Status')),activeCategories.map(function(category){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:4,alignItems:'center',justify:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Typography"],{variant:'body1'},category));}),simCategories.map(function(sim){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:4,alignItems:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Radio___default.a,{checked:_this3.state.selectedValue===sim.category,onChange:_this3.handleChange,value:sim.category,name:sim.status,'aria-label':sim.category}));}),status)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_DialogActions___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:this.props.handleClose,color:'default',variant:'contained'},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:this.updateSimStatus,color:'primary',type:'submit',variant:'contained',disabled:!this.state.newStatusSelected},'Update')));}}]);return EditStatus;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var withApolloClient=function withApolloClient(Component){return function(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_apollo__["ApolloConsumer"],null,function(client){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component,Object.assign({client:client},props));});};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__["withStyles"])(styles)(withApolloClient(EditStatus)));

/***/ }),
/* 2411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_getLoginId__ = __webpack_require__(12);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query {\n    allServiceProviders(status: 1) {\n      id\n      name\n    }\n  }\n'],['\n  query {\n    allServiceProviders(status: 1) {\n      id\n      name\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  mutation excelFileUpload(\n    $fileInfo: FileUploadInput!\n    $commonInput: CommonInput!\n  ) {\n    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {\n      failedToUpload\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedUploadList\n    }\n  }\n'],['\n  mutation excelFileUpload(\n    $fileInfo: FileUploadInput!\n    $commonInput: CommonInput!\n  ) {\n    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {\n      failedToUpload\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedUploadList\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n'],['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_PROVIDER=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject);// calling server for updation
var ADD_SIM=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject2);var GET_UPLOAD_URL=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject3);var styles=function styles(theme){return{button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{margin:theme.spacing.unit,minWidth:120},root:{flexGrow:1,padding:theme.spacing.unit*2}};};var RegisterBulkSim=function(_Component){_inherits(RegisterBulkSim,_Component);function RegisterBulkSim(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,RegisterBulkSim);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RegisterBulkSim.__proto__||Object.getPrototypeOf(RegisterBulkSim)).call.apply(_ref,[this].concat(args))),_this),_this.state={open:false,open1:false,simprovider:'',uploadSucess:true,isSimProviderValid:false,response:'',failList:'',result:false,fileName:''},_this.columns=['Phone Number','SIM Number','Monthly Charges'],_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15,print:false,download:false},_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));};},_this.handleClickOpen=function(){_this.setState({open:true});},_this.handleClose=function(){_this.setState({open:false});},_this.handleChange=function(event){_this.setState(_defineProperty({},event.target.name,event.target.value));},_this.handleOpen=function(){_this.setState({open:true});},_this.handleOpenSelect=function(){_this.setState({open1:true});},_this.handleCloseSelect=function(){_this.setState({open1:false});},_this.checkSimProviderValidity=function(){_this.setState({isSimProviderValid:_this.state.simprovider!==''});},_this.handleSubmit=function(client){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _ref3,data,fullData,arrList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:event.preventDefault();_context.next=3;return client.mutate({mutation:ADD_SIM,variables:{fileInfo:{uploadFor:'SimUploadByPartner',bucketName:_this.state.bucketName,fileName:_this.state.fileName,operationType:'SKIP'},commonInput:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_15__utils_getLoginId__["a" /* default */])(),serviceProviderId:_this.state.simprovider}}});case 3:_ref3=_context.sent;data=_ref3.data;fullData=[];arrList=data.excelFileUpload.failedUploadList;JSON.parse(arrList).forEach(function(element){var rowData=[];// this.clientId.push(element.id)
rowData.push(element.Phone_Number);rowData.push(element.Phone_Number);rowData.push(element.Monthly_Charges);fullData.push(rowData);});_this.setState({simprovider:'',response:'Total Excel Records= '+data.excelFileUpload.totalExcelDataRecords+','+'Total Records Uploaded='+data.excelFileUpload.successfullyUploaded+', Total Records Failed To Upload='+data.excelFileUpload.failedToUpload+', Total Duplicate Records in Excel='+data.excelFileUpload.totalDuplicateRecords,uploadSucess:true,failList:fullData,result:true});case 9:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}();},_this.onUpload=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4){var _ref4$target=_ref4.target,validity=_ref4$target.validity,_ref4$target$files=_slicedToArray(_ref4$target.files,1),file=_ref4$target$files[0];var fileExtension,response,url;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:// TODO: Handle upload errors
_this.setState({isUploading:true});if(!validity.valid){_context2.next=11;break;}fileExtension=file.name.substring(file.name.lastIndexOf('.')+1);_context2.next=5;return _this.props.client.mutate({mutation:GET_UPLOAD_URL,variables:{fileExtension:fileExtension}});case 5:response=_context2.sent;if(!(response.data&&response.data.getPublicUploadURL)){_context2.next=11;break;}url=response.data.getPublicUploadURL.publicUploadURL;_context2.next=10;return __WEBPACK_IMPORTED_MODULE_13_axios___default.a.put(url,file,{headers:{"x-ms-blob-type":"BlockBlob","Content-Type":file.type||"application/octet-stream"}});case 10:_this.setState({fileName:response.data.getPublicUploadURL.filename,bucketName:response.data.getPublicUploadURL.bucketName,publicUploadURL:response.data.getPublicUploadURL.publicUploadURL});case 11:_this.setState({isUploading:false});case 12:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref5.apply(this,arguments);};}(),_temp),_possibleConstructorReturn(_this,_ret);}// handleSubmit = addDevice => e => {
_createClass(RegisterBulkSim,[{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["Query"],{query:GET_PROVIDER},function(_ref6){var loading=_ref6.loading,error=_ref6.error,data=_ref6.data;var queriedData=data;if(loading)return'Loading...';if(error)return'Error!: '+error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{container:true,direction:'row',justify:'flex-start',alignItems:'center',spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Typography"],{variant:'headline'},'Select SIM Details')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{style:{minWidth:'40%'}},_this3.state.uploadSucess&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Typography"],{variant:'subheading',color:'primary'},_this3.state.response),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 60%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel___default.a,{htmlFor:'demo-controlled-open-select'},'Sim Provider'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select___default.a,{open:_this3.state.open1,fullWidth:true,onClose:_this3.handleCloseSelect,onOpen:_this3.handleOpenSelect,value:_this3.state.simprovider,onChange:_this3.handleChange,onBlur:_this3.checkSimProviderValidity,inputProps:{name:'simprovider',id:'simprovider'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),queriedData.allServiceProviders.map(function(allServiceProvidersByStatus){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem___default.a,{value:allServiceProvidersByStatus.id,key:allServiceProvidersByStatus.id},allServiceProvidersByStatus.name);}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{accept:'*/*',id:'contained-button-file',multiple:true,type:'file',style:{display:'none'},onChange:_this3.onUpload}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'contained-button-file'},'Upload excel file here \xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{variant:'contained',component:'span',color:'primary'},_this3.state.isUploading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress___default.a,{size:15}):'Upload')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:_this3.handleClose,color:'default',variant:'contained'},'Cancel'),'\xA0 \xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:_this3.handleSubmit(_this3.props.client),color:'primary',type:'submit',variant:'contained',disabled:!(_this3.state.isSimProviderValid&&_this3.state.fileName!=='')},'Submit'),_this3.state.result&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',null,'Failed records list'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_mui_datatables___default.a,{data:_this3.state.failList,columns:_this3.columns,options:_this3.options})))));});}}]);return RegisterBulkSim;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["withStyles"])(styles)(__WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter___default()(Object(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["withApollo"])(RegisterBulkSim))));

/***/ }),
/* 2412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vehicle_css__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vehicle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__vehicle_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormHelperText__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormHelperText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormHelperText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Reusable_ItemCard__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ClientDetails__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_FormControlLabel__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_FormControlLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_FormControlLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_Checkbox__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_getLoginId__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getAllAssignedDevicesToResellerClient($clientId: Int!) {\n    device: getAllAssignedDevicesToResellerClient(clientLoginId: $clientId) {\n      uniqueDeviceId\n      deviceModel {\n        model_name\n      }\n    }\n  }\n'],['\n  query getAllAssignedDevicesToResellerClient($clientId: Int!) {\n    device: getAllAssignedDevicesToResellerClient(clientLoginId: $clientId) {\n      uniqueDeviceId\n      deviceModel {\n        model_name\n      }\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query allClientDetails($resellerLoginId: Int, $status: Int) {\n    clientsDetails: allClientDetails(\n      resellerLoginId: $resellerLoginId\n      status: $status\n    ) {\n      clientName\n\n      loginId\n      partner {\n        businessName\n      }\n    }\n  }\n'],['\n  query allClientDetails($resellerLoginId: Int, $status: Int) {\n    clientsDetails: allClientDetails(\n      resellerLoginId: $resellerLoginId\n      status: $status\n    ) {\n      clientName\n\n      loginId\n      partner {\n        businessName\n      }\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query checkVehicleNumber($vlpn: String!) {\n    checkVehicleNumber(vehicleNumber: $vlpn)\n  }\n'],['\n  query checkVehicleNumber($vlpn: String!) {\n    checkVehicleNumber(vehicleNumber: $vlpn)\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query deviceResellerAssignDetail($uniqueId: String) {\n    deviceResellerAssignDetail(uniqueDeviceId: $uniqueId) {\n      deviceModel {\n        model_name\n        devicetype\n      }\n      uniqueDeviceId\n    }\n  }\n'],['\n  query deviceResellerAssignDetail($uniqueId: String) {\n    deviceResellerAssignDetail(uniqueDeviceId: $uniqueId) {\n      deviceModel {\n        model_name\n        devicetype\n      }\n      uniqueDeviceId\n    }\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  query getAllAssignedSimToResellerClient($clientId: Int!) {\n    simDetails: getAllAssignedSimToResellerClient(clientLoginId: $clientId) {\n      id\n      simId\n      sim {\n        phoneNumber\n      }\n    }\n  }\n'],['\n  query getAllAssignedSimToResellerClient($clientId: Int!) {\n    simDetails: getAllAssignedSimToResellerClient(clientLoginId: $clientId) {\n      id\n      simId\n      sim {\n        phoneNumber\n      }\n    }\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  query getAllAssignedAccessoryToClient($clientId: Int!) {\n    getAllAssignedAccessoryToClient(clientLoginId: $clientId) {\n      accessory {\n        uniqueAccessoryId\n      }\n    }\n  }\n'],['\n  query getAllAssignedAccessoryToClient($clientId: Int!) {\n    getAllAssignedAccessoryToClient(clientLoginId: $clientId) {\n      accessory {\n        uniqueAccessoryId\n      }\n    }\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  query simResellerAssignDetail($simId: Int) {\n    simResellerAssignDetail(simId: $simId) {\n      sim {\n        simNumber\n      }\n      serviceProvider {\n        name\n      }\n    }\n  }\n'],['\n  query simResellerAssignDetail($simId: Int) {\n    simResellerAssignDetail(simId: $simId) {\n      sim {\n        simNumber\n      }\n      serviceProvider {\n        name\n      }\n    }\n  }\n']),_templateObject8=_taggedTemplateLiteral(['\n  mutation addVehicleDetail(\n    $vehicleNumber: String!\n    $clientLoginId: Int!\n    $uniqueDeviceId: String!\n    $simId: Int!\n    $speedSensorType: String!\n    $speedLimit: Int!\n    $vehicleType: String!\n    $vehcleModel: String!\n    $uniqueAccessoryId: String\n    $vehicleCapacity: Int\n    $engineNumber: String\n    $chassisNumber: String\n    $status: Boolean\n    $accountType: String\n  ) {\n    addVehicleDetail(\n      vehicleNumber: $vehicleNumber\n      clientLoginId: $clientLoginId\n      uniqueDeviceId: $uniqueDeviceId\n      simId: $simId\n      speedSensorType: $speedSensorType\n      speedLimit: $speedLimit\n      vehicleType: $vehicleType\n      vehicleModel: $vehcleModel\n      uniqueAccessoryId: $uniqueAccessoryId\n      vehicleCapacity: $vehicleCapacity\n      engineNumber: $engineNumber\n      chassisNumber: $chassisNumber\n      isActivated: $status\n      accountType: $accountType\n    )\n  }\n'],['\n  mutation addVehicleDetail(\n    $vehicleNumber: String!\n    $clientLoginId: Int!\n    $uniqueDeviceId: String!\n    $simId: Int!\n    $speedSensorType: String!\n    $speedLimit: Int!\n    $vehicleType: String!\n    $vehcleModel: String!\n    $uniqueAccessoryId: String\n    $vehicleCapacity: Int\n    $engineNumber: String\n    $chassisNumber: String\n    $status: Boolean\n    $accountType: String\n  ) {\n    addVehicleDetail(\n      vehicleNumber: $vehicleNumber\n      clientLoginId: $clientLoginId\n      uniqueDeviceId: $uniqueDeviceId\n      simId: $simId\n      speedSensorType: $speedSensorType\n      speedLimit: $speedLimit\n      vehicleType: $vehicleType\n      vehicleModel: $vehcleModel\n      uniqueAccessoryId: $uniqueAccessoryId\n      vehicleCapacity: $vehicleCapacity\n      engineNumber: $engineNumber\n      chassisNumber: $chassisNumber\n      isActivated: $status\n      accountType: $accountType\n    )\n  }\n']),_templateObject9=_taggedTemplateLiteral(['\n  query clientDetail($clientId: Int!) {\n    clientDetail(loginId: $clientId) {\n      address\n      city\n    }\n  }\n'],['\n  query clientDetail($clientId: Int!) {\n    clientDetail(loginId: $clientId) {\n      address\n      city\n    }\n  }\n']),_templateObject10=_taggedTemplateLiteral(['\n  query checkEngineNumber($engineNumber: String!) {\n    checkEngineNumber(engineNumber: $engineNumber)\n  }\n'],['\n  query checkEngineNumber($engineNumber: String!) {\n    checkEngineNumber(engineNumber: $engineNumber)\n  }\n']),_templateObject11=_taggedTemplateLiteral(['\n  query checkChassisNumber($chassisNumber: String!) {\n    checkChassisNumber(chassisNumber: $chassisNumber)\n  }\n'],['\n  query checkChassisNumber($chassisNumber: String!) {\n    checkChassisNumber(chassisNumber: $chassisNumber)\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_DEVICE_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_12_graphql_tag__["a" /* default */])(_templateObject);var GET_CLIENTS=Object(__WEBPACK_IMPORTED_MODULE_12_graphql_tag__["a" /* default */])(_templateObject2);var GET_VLPN=Object(__WEBPACK_IMPORTED_MODULE_12_graphql_tag__["a" /* default */])(_templateObject3);var GET_SELECT_DEV_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_12_graphql_tag__["a" /* default */])(_templateObject4);var GET_SIM_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_12_graphql_tag__["a" /* default */])(_templateObject5);var GET_ACCESSORY_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_12_graphql_tag__["a" /* default */])(_templateObject6);var GET_SELECT_PHONE_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_12_graphql_tag__["a" /* default */])(_templateObject7);// calling server for updation
var ADD_VEHICLE=Object(__WEBPACK_IMPORTED_MODULE_12_graphql_tag__["a" /* default */])(_templateObject8);var GET_CLIENT_DETAILS_BYID=Object(__WEBPACK_IMPORTED_MODULE_12_graphql_tag__["a" /* default */])(_templateObject9);// Engine Number validation
var CHECK_ENGINE_NUMBER=Object(__WEBPACK_IMPORTED_MODULE_12_graphql_tag__["a" /* default */])(_templateObject10);// CHASSIS Number validation
var CHECK_CHASSIS_NUMBER=Object(__WEBPACK_IMPORTED_MODULE_12_graphql_tag__["a" /* default */])(_templateObject11);var VehicleRegistration=function(_Component){_inherits(VehicleRegistration,_Component);function VehicleRegistration(props){var _this2=this;_classCallCheck(this,VehicleRegistration);var _this=_possibleConstructorReturn(this,(VehicleRegistration.__proto__||Object.getPrototypeOf(VehicleRegistration)).call(this,props));_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));};};_this.handleChangeDevice=function(client){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _ref2,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.setState({serialNumber:event.value});_context.next=3;return client.query({query:GET_SELECT_DEV_DETAILS,variables:{uniqueId:event.value}});case 3:_ref2=_context.sent;data=_ref2.data;console.log('devdata',data);_this.setState({modelName:data.deviceResellerAssignDetail.deviceModel.model_name,deviceType:data.deviceResellerAssignDetail.deviceModel.devicetype,uniqueId:_this.state.serialNumber});// await this.onCountryFetched(data.allStatesByCountryId)
case 7:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();};_this.handleChangePhoneNumber=function(client){return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(event){var _ref4,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return client.query({query:GET_SELECT_PHONE_DETAILS,variables:{simId:event.value}});case 2:_ref4=_context2.sent;data=_ref4.data;_this.setState({simProvider:data.simResellerAssignDetail.serviceProvider.name,simNumber:data.simResellerAssignDetail.sim.simNumber,phoneNumber:event.value});case 5:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref3.apply(this,arguments);};}();};_this.handleChangeClient=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(event){var _ref6,data,_ref7,device,deviceError,allDevices,_ref8,simDetails,simError,allSims,_ref9,accessory,error,allAccessory;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_this.setState({clientName:event.value});_context3.next=3;return _this.props.client.query({query:GET_CLIENT_DETAILS_BYID,variables:{clientId:event.value},errorPolicy:'all'});case 3:_ref6=_context3.sent;data=_ref6.data;_context3.next=7;return _this.props.client.query({query:GET_DEVICE_DETAILS,variables:{clientId:event.value},errorPolicy:'all'});case 7:_ref7=_context3.sent;device=_ref7.data;deviceError=_ref7.error;allDevices=device.device.map(function(device){return{value:device.uniqueDeviceId,label:device.uniqueDeviceId};});_context3.next=13;return _this.props.client.query({query:GET_SIM_DETAILS,variables:{clientId:event.value},errorPolicy:'all'});case 13:_ref8=_context3.sent;simDetails=_ref8.data;simError=_ref8.error;allSims=simDetails.simDetails.map(function(sim){return{value:sim.simId,label:sim.sim.phoneNumber};});_context3.next=19;return _this.props.client.query({query:GET_ACCESSORY_DETAILS,variables:{clientId:event.value},errorPolicy:'all'});case 19:_ref9=_context3.sent;accessory=_ref9.data;error=_ref9.error;allAccessory=accessory.getAllAssignedAccessoryToClient.map(function(accessory){return{value:accessory.uniqueAccessoryId,label:accessory.uniqueAccessoryId};});if(deviceError){_this.setState({deviceDetails:[]});}else{_this.setState({deviceDetails:allDevices});}if(simError){_this.setState({simDetails:[]});}else{_this.setState({simDetails:allSims});}if(error){_this.setState({accessoryDetails:[]});}else{_this.setState({accessoryDetails:allAccessory});}_this.setState({address:data.clientDetail.address,city:data.clientDetail.city,totalRegisteredVehicle:30,totalActiveDevicess:15,totalInactiveDevices:5,showClientDetails:true});case 27:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x3){return _ref5.apply(this,arguments);};}();_this.handleChangeType=function(event){_this.setState({vehicleType:event.value});};_this.handleChangeSpeedSensor=function(event){_this.setState({speedSensor:event.value});};_this.handleChangeAccessories=function(event){if(event.value===''){_this.setState({accessories:null});}else{_this.setState({accessories:event.value});}};_this.checkSerialNumberValidity=function(){// const regex = new RegExp(/^[a-zA-Z\s]+$/)
_this.setState({isSerialNumberValid:_this.state.serialNumber!==''});};_this.checkAddressValidity=function(){var regex=new RegExp(/^[a-zA-Z0-9\s,.'-]{3,}$/);_this.setState({isAddressValid:regex.test(_this.state.address)&&_this.state.address===''});};_this.checkVehicleModelValidity=function(){var regex=new RegExp(/^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/);_this.setState({isVehicleModelValid:regex.test(_this.state.vehicleModel)&&_this.state.vehicleModel!==''});};_this.checkSpeedLimitValidity=function(){var regex=new RegExp(/^[1-9][0-9]$/);_this.setState({isSpeedLimitValid:regex.test(_this.state.speedLimit)&&_this.state.speedLimit!==''});};_this.checkSeatLimitValidity=function(){var regex=new RegExp(/^[1-9][0-9]$/);_this.setState({isSeatLimitValid:regex.test(_this.state.seatLimit)&&_this.state.seatLimit!==''});};_this.checkVlpnValidity=function(client){return function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(event){var _ref11,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return client.query({query:GET_VLPN,variables:{vlpn:_this.state.vlpn}});case 2:_ref11=_context4.sent;data=_ref11.data;_this.setState({// isVlpnValid: data.checkVehicleNumber === 'AVAILABLE'
isVlpnValid:_this.state.vlpn!==''&&data.checkVehicleNumber==='AVAILABLE'});case 5:case'end':return _context4.stop();}}},_callee4,_this2);}));return function(_x4){return _ref10.apply(this,arguments);};}();};_this.checkVlpnUnique=function(client){return function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(event){var _ref13,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return client.query({query:GET_VLPN,variables:{vlpn:_this.state.vlpn}});case 2:_ref13=_context5.sent;data=_ref13.data;_this.setState({isVlpnValid:data.checkVehicleNumber==='AVAILABLE'});// await this.onCountryFetched(data.allStatesByCountryId)
case 5:case'end':return _context5.stop();}}},_callee5,_this2);}));return function(_x5){return _ref12.apply(this,arguments);};}();};_this.checkClientNameValidity=function(){_this.setState({isClientNameValid:_this.state.clientName!==''});};_this.checkVehicleTypeValidity=function(){_this.setState({isVehicleTypeValid:_this.state.vehicleType!==''});if(_this.state.vehicleType==='school bus'){_this.setState({isseatLimitValid:true});}else{_this.setState({isseatLimitValid:false});}};_this.checkSpeedSensorValidity=function(){_this.setState({isSpeedSensorValid:_this.state.speedSensor!==''});};_this.handleSubmit=function(client){return function(){var _ref14=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(event){var _ref15,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:if(_this.state.seatLimit===''){_this.setState({seatLimit:null});}event.preventDefault();_context6.next=4;return client.mutate({mutation:ADD_VEHICLE,variables:{vehicleNumber:_this.state.vlpn,clientLoginId:parseInt(_this.state.clientName,10),uniqueDeviceId:_this.state.serialNumber,simId:parseInt(_this.state.phoneNumber,10),speedSensorType:_this.state.speedSensor,speedLimit:parseInt(_this.state.speedLimit,10),vehicleType:_this.state.vehicleType,vehcleModel:_this.state.vehicleModel,uniqueAccessoryId:_this.state.accessories,vehicleCapacity:_this.state.seatLimit,status:_this.state.installStatus,engineNumber:_this.state.engineNumber,chassisNumber:_this.state.chassisNumber,accountType:'RES'// errorPolicy: 'all'
}});case 4:_ref15=_context6.sent;data=_ref15.data;_this.setState({vehicleNumber:'',clientLoginId:'',uniqueDeviceId:'',simId:'',speedSensorType:'',speedLimit:'',seatLimit:'',vehicleType:'',vehcleModel:'',showClientDetails:false,address:'',city:'',totalRegisteredVehicle:'',totalActiveDevicess:'',totalInactiveDevices:''});if(data!==null){_this.setState({response:data.addVehicleDetail});_this.props.openSnackbar('Registered Successfully');}else{_this.setState({failure:true});_this.props.openSnackbar('Registartion Failed');}case 8:case'end':return _context6.stop();}}},_callee6,_this2);}));return function(_x6){return _ref14.apply(this,arguments);};}();};_this.getAllClients=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(){var clientsDetails,allClients;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return _this.props.client.query({query:GET_CLIENTS,variables:{resellerLoginId:_this.state.resellerLoginId,status:_this.state.status}});case 2:clientsDetails=_context7.sent;allClients=clientsDetails.data.clientsDetails.map(function(client){return{value:client.loginId,label:client.clientName};});_this.setState({clientsDetails:allClients});case 5:case'end':return _context7.stop();}}},_callee7,_this2);}));_this.handleChange=function(name){return function(event){_this.setState(_defineProperty({},name,event.target.checked));// console.log('installStatus', event.target.checked, this.state.installStatus)
};};_this.checkEngineNumber=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(){var _ref18,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:if(!(_this.state.engineNumber!=='')){_context8.next=6;break;}_context8.next=3;return _this.props.client.query({query:CHECK_ENGINE_NUMBER,variables:{engineNumber:_this.state.engineNumber}});case 3:_ref18=_context8.sent;data=_ref18.data;_this.setState({isengineNumberValid:data.checkEngineNumber==='AVAILABLE'});case 6:case'end':return _context8.stop();}}},_callee8,_this2);}));_this.checkChassisNumber=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(){var _ref20,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:if(!(_this.state.chassisNumber!=='')){_context9.next=6;break;}_context9.next=3;return _this.props.client.query({query:CHECK_CHASSIS_NUMBER,variables:{chassisNumber:_this.state.chassisNumber}});case 3:_ref20=_context9.sent;data=_ref20.data;_this.setState({ischassisNumberValid:data.checkChassisNumber==='AVAILABLE'});case 6:case'end':return _context9.stop();}}},_callee9,_this2);}));_this.bulkRegister=function(event){_this.props.history.push({pathname:'/home/reseller/vehicles/bulk-register'});};_this.state={isSpeedLimitValid:true,isSeatLimitValid:true,speedLimit:'',seatLimit:null,serialNumber:'',resellerLoginId:Object(__WEBPACK_IMPORTED_MODULE_20__utils_getLoginId__["a" /* default */])(),// partnerLoginId: 8,
isSerialNumberValid:true,modelName:'',deviceType:'',status:1,phoneNumber:'',isPhoneNoValid:true,simProvider:'',simNumber:'',vlpn:'',isVlpnValid:true,vehicleModel:'',isVehicleModelValid:true,clientName:'',isClientNameValid:true,vehicleType:'',isVehicleTypeValid:true,speedSensor:'',isSpeedSensorValid:true,accessories:null,clientsDetails:[],deviceDetails:[],simDetails:[],accessoryDetails:[],response:false,failure:false,schoolBusEnable:false,installStatus:true,isengineNumberValid:true,engineNumber:'',chassisNumber:'',ischassisNumberValid:true};if(_this.props.location.state){_this.setState({clientName:_this.props.location.state.clientId});}else{_this.setState({clientName:''});}return _this;}_createClass(VehicleRegistration,[{key:'componentDidMount',value:function componentDidMount(){this.getAllClients();}},{key:'render',value:function render(){var classes=this.props.classes;var allSpeedSensor=[];allSpeedSensor[0]={value:'GPS SPEED SENSOR',label:'Gps speed sensor'};allSpeedSensor[1]={value:'DELTA_DISTANCE_CALCULATION',label:'Delta Distance'};allSpeedSensor[2]={value:'ODOMETRIC',label:'Odometric'};var vehiclearr=['Car','Truck','Ambulance','School Bus','Bike','Tractor','Excavator','3-Wheeler','GeneratorTanker'];var allvehicleTypes=vehiclearr.map(function(vehicle){return{value:vehicle,label:vehicle};});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'Landing'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,justify:'center',className:'full-screen',alignItems:'flex-end'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Reusable_ItemCard__["a" /* default */],{className:'form_layout'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',{className:'Formheader'},'Register Vehicle'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Typography___default.a,{variant:'subheading',gutterBottom:true,style:{color:'red',marginLeft:'25px'}},this.state.failure&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Registration Failed')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Typography___default.a,{variant:'subheading',gutterBottom:true,style:{color:'green',marginLeft:'25px'}},this.state.response&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Vehicle Registered Sucessfully')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'formouter'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,className:'searchdiv',spacing:'8'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,justify:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{style:{marginRight:'20px'}},'Customer Name :',' '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{style:{minWidth:'50%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_InputLabel___default.a,{htmlFor:'selectLabel'},'Select Client'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select__["a" /* default */],{classes:classes,options:this.state.clientsDetails// components={components}
,value:this.state.clientName,onChange:this.handleChangeClient,placeholder:'Select Customer'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isClientNameValid?'Invalid Selection':'')))),this.state.showClientDetails&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__ClientDetails__["a" /* default */],{address:this.state.address,city:this.state.city})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,fullwidth:true,style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{xs:12,sm:12},'Vehicle Info:'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,fullwidth:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'vlpn',name:'vlpn',className:'textfield',margin:'dense',label:'Vehicle Number'// type="Multi-line"
,value:this.state.vlpn,required:true,onChange:this.handleInputChange('vlpn'),error:!this.state.isVlpnValid,onBlur:this.checkVlpnValidity(this.props.client)}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isVlpnValid?'Invalid Vehicle Number':'')))),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,fullwidth:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'engineNumber',name:'engineNumber',className:'textfield',margin:'dense',label:'Engine Number'// type="Multi-line"
,value:this.state.engineNumber,onChange:this.handleInputChange('engineNumber'),onBlur:this.checkEngineNumber}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isengineNumberValid?'Invalid Engine Number':'')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,fullwidth:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'chassisNumber',name:'chassisNumber',className:'textfield',margin:'dense',label:'Chassis Number'// type="Multi-line"
,value:this.state.chassisNumber,onChange:this.handleInputChange('chassisNumber'),onBlur:this.checkChassisNumber}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.ischassisNumberValid?'Invalid Chassis Number':'')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_InputLabel___default.a,{htmlFor:'selectLabel'},'Select Speed Sensor'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select__["a" /* default */],{classes:classes,options:allSpeedSensor// components={components}
,value:this.state.speedSensor,onChange:this.handleChangeSpeedSensor,placeholder:'Select Speed Sensor *'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isSpeedSensorValid?'Invalid Selection':'')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'speedLimit',name:'speedLimit',className:'textfield',margin:'dense',label:'Speed Limit',type:'text'// type="Multi-line"
,value:this.state.speedLimit,required:true,onChange:this.handleInputChange('speedLimit'),error:!this.state.isSpeedLimitValid,onBlur:this.checkSpeedLimitValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isSpeedLimitValid?'Invalid Speed Limit':'')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'vehicleModel',name:'vehicleModel',className:'textfield',margin:'dense',label:'Vehicle Model'// type="Multi-line"
,value:this.state.vehicleModel,required:true,onChange:this.handleInputChange('vehicleModel'),error:!this.state.isVehicleModelValid,onBlur:this.checkVehicleModelValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isVehicleModelValid?'Invalid Vehicle Model':'')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_InputLabel___default.a,{htmlFor:'selectLabel'},'Select Vehicle Type'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select__["a" /* default */],{classes:classes,options:allvehicleTypes// components={components}
,value:this.state.vehicleType,onChange:this.handleChangeType,placeholder:'Select vehicle Type *'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isClientNameValid?'Invalid Selection':'')))),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_Checkbox___default.a,{checked:this.state.installStatus,onChange:this.handleChange('installStatus'),value:'installStatus',color:'primary'}),label:'Installation Completed'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{xs:12,sm:12},'Device Info:'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select__["a" /* default */],{classes:classes,options:this.state.deviceDetails//  components={components}
,value:this.state.serialNumber,onChange:this.handleChangeDevice(this.props.client),placeholder:'Select Device *'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isSerialNumberValid?'Invalid Selection':'')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'modelName',name:'modelName',className:'textfield',margin:'dense',label:'Model Name',type:'text',disabled:true,value:this.state.modelName,required:true,onChange:this.handleInputChange('modelName')})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'deviceType',name:'deviceType',className:'textfield',margin:'dense',label:'Device Type',type:'text',disabled:true,value:this.state.deviceType,required:true,onChange:this.handleInputChange('deviceType')})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_InputLabel___default.a,{htmlFor:'selectLabel'},'Select Phoneno'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select__["a" /* default */],{classes:classes,options:this.state.simDetails// components={components}
,value:this.state.phoneNumber,onChange:this.handleChangePhoneNumber(this.props.client),placeholder:'Select Phoneno *'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isPhoneNoValid?'Invalid Selection':'')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'simProvider',name:'simProvider',className:'textfield',margin:'dense',label:'Service Provider',type:'text',disabled:true,value:this.state.simProvider,required:true,onChange:this.handleInputChange('simProvider')})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'simNumber',name:'simNumber',className:'textfield',margin:'dense',label:'SIM Number'// type="Multi-line"
,value:this.state.simNumber,disabled:true,onChange:this.handleInputChange('simNumber')})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_InputLabel___default.a,{htmlFor:'selectLabel'},'Accessories'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select__["a" /* default */],{classes:classes,options:this.state.accessoryDetails// components={components}
,value:this.state.accessories,onChange:this.handleChangeAccessories,placeholder:'Select Accessories'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isSpeedSensorValid?'Invalid Selection':'')))),' ',this.state.isseatLimitValid&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{id:'seatLimit',name:'seatLimit',className:'textfield',margin:'dense',label:'Seat Capacity',type:'text'// type="Multi-line"
,value:this.state.seatLimit,required:true,onChange:this.handleInputChange('seatLimit'),error:!this.state.isSeatLimitValid,onBlur:this.checkSeatLimitValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isSeatLimitValid?'Invalid Seat Capacity':''))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{justify:'center',container:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{color:'default',variant:'outlined',size:'medium',margin:'normal',className:'btn'},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{variant:'contained',color:'secondary',size:'medium',margin:'normal',className:'btn',type:'button',onClick:this.handleSubmit(this.props.client),disabled:!(this.state.isVlpnValid&&this.state.vlpn!==''&&this.state.isSerialNumberValid&&this.state.isPhoneNoValid&&this.state.isClientNameValid&&this.state.isSpeedLimitValid&&this.state.isVehicleModelValid&&this.state.isVehicleTypeValid&&this.state.isSpeedSensorValid&&this.state.uniqueDeviceId!==''&&this.state.simId!==''&&this.state.speedSensorType!==''&&this.state.speedLimit!==''&&this.state.vehicleType!==''&&this.state.vehcleModel!==''&&this.state.showClientDetails&&this.state.address!==''&&this.state.city!==''&&this.state.isengineNumberValid&&this.state.ischassisNumberValid)},'Submit')))))))));}}]);return VehicleRegistration;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);VehicleRegistration.propTypes={classes:__WEBPACK_IMPORTED_MODULE_18_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_13_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_19__HOCs_withSharedSnackbar__["a" /* default */])(VehicleRegistration)));

/***/ }),
/* 2413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormHelperText__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormHelperText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormHelperText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Input__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ClientDetails__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_FormControlLabel__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_FormControlLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_FormControlLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_Checkbox__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_icons_ArrowBack__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_icons_ArrowBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__material_ui_icons_ArrowBack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_core_Dialog__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_core_Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ChangeVehicleStatus__ = __webpack_require__(2414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__DecoupleDevices__ = __webpack_require__(2415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__vehicle_css__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__vehicle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__vehicle_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query checkVehicleNumber($vlpn: String!) {\n    checkVehicleNumber(vehicleNumber: $vlpn)\n  }\n'],['\n  query checkVehicleNumber($vlpn: String!) {\n    checkVehicleNumber(vehicleNumber: $vlpn)\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  mutation updateVehicleDetail(\n    $entityId: Int!\n    $vehicleNumber: String!\n    $clientLoginId: Int!\n    $speedSensorType: String!\n    $speedLimit: Int!\n    $vehicleType: String!\n    $vehcleModel: String!\n    $vehicleCapacity: Int\n    $isActivated: Boolean\n    $status: Int!\n    $chassisNumber: String\n    $engineNumber: String\n  ) {\n    updateVehicleDetail(\n      entityId: $entityId\n      vehicleNumber: $vehicleNumber\n      clientLoginId: $clientLoginId\n      speedSensorType: $speedSensorType\n      speedLimit: $speedLimit\n      vehicleType: $vehicleType\n      vehicleModel: $vehcleModel\n      vehicleCapacity: $vehicleCapacity\n      isActivated: $isActivated\n      status: $status\n      chassisNumber: $chassisNumber\n      engineNumber: $engineNumber\n    )\n  }\n'],['\n  mutation updateVehicleDetail(\n    $entityId: Int!\n    $vehicleNumber: String!\n    $clientLoginId: Int!\n    $speedSensorType: String!\n    $speedLimit: Int!\n    $vehicleType: String!\n    $vehcleModel: String!\n    $vehicleCapacity: Int\n    $isActivated: Boolean\n    $status: Int!\n    $chassisNumber: String\n    $engineNumber: String\n  ) {\n    updateVehicleDetail(\n      entityId: $entityId\n      vehicleNumber: $vehicleNumber\n      clientLoginId: $clientLoginId\n      speedSensorType: $speedSensorType\n      speedLimit: $speedLimit\n      vehicleType: $vehicleType\n      vehicleModel: $vehcleModel\n      vehicleCapacity: $vehicleCapacity\n      isActivated: $isActivated\n      status: $status\n      chassisNumber: $chassisNumber\n      engineNumber: $engineNumber\n    )\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query getVehicleDetail($entityId: Int) {\n    getVehicleDetail(entityId: $entityId) {\n      vehicleNumber\n      speedSensorType\n      speedLimit\n      vehicleType\n      vehicleModel\n      vehicleCapacity\n      chassisNumber\n      engineNumber\n      status\n      client {\n        clientName\n        contactPerson\n        address\n        city\n        email\n        contactNumber\n        loginId\n      }\n      device {\n        serial_num\n        imei_num\n        uniqueDeviceId\n        deviceModelId {\n          model_name\n          devicetype\n        }\n      }\n      sim {\n        phoneNumber\n        simNumber\n        serviceProvider {\n          name\n        }\n      }\n    }\n  }\n'],['\n  query getVehicleDetail($entityId: Int) {\n    getVehicleDetail(entityId: $entityId) {\n      vehicleNumber\n      speedSensorType\n      speedLimit\n      vehicleType\n      vehicleModel\n      vehicleCapacity\n      chassisNumber\n      engineNumber\n      status\n      client {\n        clientName\n        contactPerson\n        address\n        city\n        email\n        contactNumber\n        loginId\n      }\n      device {\n        serial_num\n        imei_num\n        uniqueDeviceId\n        deviceModelId {\n          model_name\n          devicetype\n        }\n      }\n      sim {\n        phoneNumber\n        simNumber\n        serviceProvider {\n          name\n        }\n      }\n    }\n  }\n']);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_VLPN=Object(__WEBPACK_IMPORTED_MODULE_12_graphql_tag__["a" /* default */])(_templateObject);// calling server for updation
var UPDATE_VEHICLE=Object(__WEBPACK_IMPORTED_MODULE_12_graphql_tag__["a" /* default */])(_templateObject2);var GET_VEHICLE_DETAIL=Object(__WEBPACK_IMPORTED_MODULE_12_graphql_tag__["a" /* default */])(_templateObject3);var styles=function styles(theme){return{root:{padding:theme.spacing.unit*2,flexGrow:1},textField:{marginLeft:theme.spacing.unit,marginRight:theme.spacing.unit,width:'200px'},container:{display:'flex',flexWrap:'wrap'}};};var VehicleRegistration=function(_Component){_inherits(VehicleRegistration,_Component);function VehicleRegistration(props){var _this2=this;_classCallCheck(this,VehicleRegistration);var _this=_possibleConstructorReturn(this,(VehicleRegistration.__proto__||Object.getPrototypeOf(VehicleRegistration)).call(this,props));_this.getVehicleDetails=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _ref2,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.client.query({query:GET_VEHICLE_DETAIL,variables:{entityId:_this.entityId}});case 2:_ref2=_context.sent;data=_ref2.data;_this.setDetails(data.getVehicleDetail);case 5:case'end':return _context.stop();}}},_callee,_this2);}));_this.setDetails=function(vehicleDetail){console.log('vehicleDetail',vehicleDetail);_this.setState({address:vehicleDetail.client.address,city:vehicleDetail.client.city,clientName:vehicleDetail.client.clientName,contactPerson:vehicleDetail.client.contactPerson,email:vehicleDetail.client.email,contactNumber:vehicleDetail.client.contactNumber,vlpn:vehicleDetail.vehicleNumber,speedSensor:vehicleDetail.speedSensorType,speedLimit:vehicleDetail.speedLimit,vehicleType:vehicleDetail.vehicleType,vehicleModel:vehicleDetail.vehicleModel,vehicleCapacity:vehicleDetail.vehicleCapacity,status:vehicleDetail.status,serialNumber:vehicleDetail.device.serial_num,modelName:vehicleDetail.device.deviceModelId.model_name,deviceType:vehicleDetail.device.deviceModelId.devicetype,phoneNumber:vehicleDetail.sim.phoneNumber,simProvider:vehicleDetail.sim.serviceProvider.name,simNumber:vehicleDetail.sim.simNumber,uniqueDeviceId:vehicleDetail.device.uniqueDeviceId,clientLoginId:vehicleDetail.client.loginId,chassisNumber:vehicleDetail.chassisNumber,engineNumber:vehicleDetail.chassisNumber});if(vehicleDetail.status===1){_this.setState({installStatus:true});}};_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));};};_this.handleChangeType=function(event){_this.setState({vehicleType:event.target.value});};_this.handleChangeSpeedSensor=function(event){_this.setState({speedSensor:event.target.value});};_this.checkVehicleModelValidity=function(){var regex=new RegExp(/^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/);_this.setState({isVehicleModelValid:regex.test(_this.state.vehicleModel)&&_this.state.vehicleModel!==''});};_this.checkSpeedLimitValidity=function(){var regex=new RegExp(/^[1-9][0-9]$/);_this.setState({isSpeedLimitValid:regex.test(_this.state.speedLimit)&&_this.state.speedLimit!==''});};_this.checkSeatLimitValidity=function(){var regex=new RegExp(/^[1-9][0-9]$/);_this.setState({isSeatLimitValid:regex.test(_this.state.seatLimit)&&_this.state.seatLimit!==''});};_this.checkVlpnValidity=function(client){return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(event){var regex,_ref4,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:regex=new RegExp(/^[A-Z]{2}[0-9]{2}[A-Z]{2}[0-9]{4}$/);// this.setState({
//   isVlpnValid: regex.test(this.state.vlpn) && this.state.vlpn !== ''
// })
_context2.next=3;return client.query({query:GET_VLPN,variables:{vlpn:_this.state.vlpn}});case 3:_ref4=_context2.sent;data=_ref4.data;_this.setState({// isVlpnValid: data.checkVehicleNumber === 'AVAILABLE'
isVlpnValid:regex.test(_this.state.vlpn)&&_this.state.vlpn!==''&&data.checkVehicleNumber==='AVAILABLE'});case 6:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x){return _ref3.apply(this,arguments);};}();};_this.checkVlpnUnique=function(client){return function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(event){var _ref6,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return client.query({query:GET_VLPN,variables:{vlpn:_this.state.vlpn}});case 2:_ref6=_context3.sent;data=_ref6.data;_this.setState({isVlpnValid:data.checkVehicleNumber==='AVAILABLE'});// await this.onCountryFetched(data.allStatesByCountryId)
case 5:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x2){return _ref5.apply(this,arguments);};}();};_this.checkClientNameValidity=function(){_this.setState({isClientNameValid:_this.state.clientName!==''});};_this.checkVehicleTypeValidity=function(){_this.setState({isVehicleTypeValid:_this.state.vehicleType!==''});if(_this.state.vehicleType==='school bus'){_this.setState({isseatLimitValid:true});}else{_this.setState({isseatLimitValid:false});}};_this.checkSpeedSensorValidity=function(){_this.setState({isSpeedSensorValid:_this.state.speedSensor!==''});};_this.handleSubmit=function(client){return function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(event){var installationStatus,_ref8,data,Error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:if(_this.state.seatLimit===''){_this.setState({seatLimit:null});}event.preventDefault();installationStatus=void 0;if(_this.state.installStatus){installationStatus=1;}else{installationStatus=0;}console.log('engineNumber',_this.state.engineNumber,_this.state.chassisNumber);_context4.next=7;return client.mutate({mutation:UPDATE_VEHICLE,variables:{vehicleNumber:_this.state.vlpn,entityId:_this.entityId,clientLoginId:_this.state.clientLoginId,speedSensorType:_this.state.speedSensor,speedLimit:_this.state.speedLimit,vehicleType:_this.state.vehicleType,vehcleModel:_this.state.vehicleModel,vehicleCapacity:_this.state.seatLimit,isActivated:_this.state.installStatus,chassisNumber:_this.state.chassisNumber,engineNumber:_this.state.engineNumber,status:installationStatus// errorPolicy: 'all'
}});case 7:_ref8=_context4.sent;data=_ref8.data;Error=_ref8.Error;console.log('update',data,Error);_this.setState({vehicleNumber:'',clientLoginId:'',uniqueDeviceId:'',simId:'',speedSensorType:'',speedLimit:'',seatLimit:'',vehicleType:'',vehcleModel:'',showClientDetails:false,address:'',city:'',totalRegisteredVehicle:'',totalActiveDevicess:'',totalInactiveDevices:''});if(data!==null){_this.setState({response:data.addVehicleDetail});}else{_this.setState({failure:true});}case 13:case'end':return _context4.stop();}}},_callee4,_this2);}));return function(_x3){return _ref7.apply(this,arguments);};}();};_this.handleChange=function(name){return function(event){_this.setState(_defineProperty({},name,event.target.checked));// console.log('installStatus', event.target.checked, this.state.installStatus)
};};_this.handleClickOpen=function(){_this.setState({open:true});};_this.handleClose=function(){_this.setState({open:false});};_this.handleDecoupleOpen=function(){_this.setState({open2:true});};_this.handleDecoupleClose=function(){_this.setState({open2:false});};_this.entityId=parseInt(_this.props.match.params.entityId,10);_this.state={isSpeedLimitValid:true,isSeatLimitValid:true,speedLimit:'',seatLimit:null,serialNumber:'',partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_21__utils_getLoginId__["a" /* default */])(),// partnerLoginId: 8,
isSerialNumberValid:true,modelName:'',deviceType:'',status:1,phoneNumber:'',isPhoneNoValid:true,simProvider:'',simNumber:'',vlpn:'',isVlpnValid:true,vehicleModel:'',isVehicleModelValid:true,clientName:'',isClientNameValid:true,vehicleType:'',isVehicleTypeValid:true,speedSensor:'',isSpeedSensorValid:true,accessories:null,clientsDetails:[],deviceDetails:[],simDetails:[],accessoryDetails:[],response:false,failure:false,schoolBusEnable:false,clientLoginId:'',installStatus:false,open:false,open2:false};if(_this.props.location.state){_this.setState({clientName:_this.props.location.state.clientId});}else{_this.setState({clientName:''});}return _this;}_createClass(VehicleRegistration,[{key:'componentDidMount',value:function componentDidMount(){this.getVehicleDetails();// this.handleClickOpen()
}},{key:'render',// Activate deactivate function
// handleClickButtonAction = client => async currentStatus => {
//   let updateStatus
//   if (currentStatus === 0) {
//     updateStatus = true
//   } else {
//     updateStatus = false
//   }
//   const { data, Error } = await client.mutate({
//     mutation: UPDATE_VEHICLE_STATUS,
//     variables: {
//       uniqueDeviceId: this.state.uniqueDeviceId,
//       isActivated: updateStatus
//     },
//     errorPolicy: 'all'
//   })
//   this.setState({
//     currentStatus: ''
//   })
// }
value:function render(){var _this3=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'Landing'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{float:'left'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button___default.a,{variant:'outlined',color:'secondary',className:classes.button,onClick:function onClick(){return _this3.props.history.goBack();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_icons_ArrowBack___default.a,{className:classes.iconSmall}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true,justify:'center',className:'full-screen',alignItems:'flex-end'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',{className:'Formheader'},'Edit Vehicle Details'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Typography___default.a,{variant:'subheading',gutterBottom:true,style:{color:'red',marginLeft:'25px'}},this.state.failure&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'Updation Failed')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Typography___default.a,{variant:'subheading',gutterBottom:true,style:{color:'green',marginLeft:'25px'}},this.state.response&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Vehicle Details Updated Sucessfully')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'formouter'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true,className:'searchdiv'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__ClientDetails__["a" /* default */],{address:this.state.address,city:this.state.city})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true,style:{marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},'Vehicle Info:'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{id:'vlpn',name:'vlpn',className:'textfield',margin:'dense',label:'Vehicle Number'// type="Multi-line"
,value:this.state.vlpn,required:true,onChange:this.handleInputChange('vlpn'),error:!this.state.isVlpnValid,onBlur:this.checkVlpnValidity(this.props.client)}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isVlpnValid?'Invalid Vehicle Number':'')))),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{id:'engineNumber',name:'engineNumber',className:'textfield',margin:'dense',label:'Engine Number',type:'text',value:this.state.engineNumber,onChange:this.handleInputChange('engineNumber')})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{id:'chassisNumber',name:'chassisNumber',className:'textfield',margin:'dense',label:'Chassis Number'// type="Multi-line"
,value:this.state.chassisNumber,onChange:this.handleInputChange('chassisNumber')})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_InputLabel___default.a,{htmlFor:'selectLabel'},'Select Speed Sensor'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select___default.a,{value:this.state.speedSensor,onChange:this.handleChangeSpeedSensor,name:'Speed Sensor Type'// label="Speed Sensor Type"
,error:!this.state.isSpeedSensorValid,onBlur:this.checkSpeedSensorValidity,input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Input___default.a,{name:'speedSensor',id:'age-helper'})},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{value:'GPS SPEED SENSOR'},'Gps Speed Sensor'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{value:'DELTA_DISTANCE_CALCULATION'},'Delta Distance'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{value:'ODOMETRIC'},'Odometric')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isSpeedSensorValid?'Invalid Selection':'')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{id:'speedLimit',name:'speedLimit',className:'textfield',margin:'dense',label:'Speed Limit',type:'text'// type="Multi-line"
,value:this.state.speedLimit,required:true,onChange:this.handleInputChange('speedLimit'),error:!this.state.isSpeedLimitValid,onBlur:this.checkSpeedLimitValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isSpeedLimitValid?'Invalid Speed Limit':'')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{id:'vehicleModel',name:'vehicleModel',className:'textfield',margin:'dense',label:'Vehicle Model'// type="Multi-line"
,value:this.state.vehicleModel,required:true,onChange:this.handleInputChange('vehicleModel'),error:!this.state.isVehicleModelValid,onBlur:this.checkVehicleModelValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isVehicleModelValid?'Invalid Vehicle Model':'')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_InputLabel___default.a,{htmlFor:'selectLabel'},'Select Vehicle Type'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Select___default.a,{value:this.state.vehicleType,onChange:this.handleChangeType,error:!this.state.isVehicleTypeValid,onBlur:this.checkVehicleTypeValidity,name:'Select Client'// label="Select Vehicle Type"
,input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Input___default.a,{name:'vehicleType',id:'age-helper'})},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{value:'car'},'Car'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{value:'truck'},'Truck'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{value:'ambulance'},'Ambulance'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{value:'school bus'},'School Bus'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{value:'bike'},'Bike'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{value:'Tractor'},'Tractor'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_MenuItem___default.a,{value:'Tractor'},'Excavator')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isClientNameValid?'Invalid Selection':'')))),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_FormControlLabel___default.a,{control:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_Checkbox___default.a,{checked:this.state.installStatus,onChange:this.handleChange('installStatus'),value:'installStatus',color:'primary',disabled:this.state.installStatus}),label:'Installation Completed'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},'Device Info:'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{id:'serialNumber',name:'serialNumber',className:'textfield',margin:'dense'// label="Serial Number"
,type:'text',disabled:true,value:this.state.uniqueDeviceId})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{id:'modelName',name:'modelName',className:'textfield',margin:'dense',label:'Model Name',type:'text',disabled:true,value:this.state.modelName,onChange:this.handleInputChange('modelName')})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{id:'deviceType',name:'deviceType',className:'textfield',margin:'dense',label:'Device Type',type:'text',disabled:true,value:this.state.deviceType,onChange:this.handleInputChange('deviceType')})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{id:'phoneNumber',name:'phoneNumber',className:'textfield',margin:'dense',label:'Phone Number',type:'text',disabled:true,value:this.state.phoneNumber})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{id:'simProvider',name:'simProvider',className:'textfield',margin:'dense',label:'Service Provider',type:'text',disabled:true,value:this.state.simProvider,onChange:this.handleInputChange('simProvider')})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{id:'simNumber',name:'simNumber',className:'textfield',margin:'dense',label:'SIM Number'// type="Multi-line"
,value:this.state.simNumber,disabled:true,onChange:this.handleInputChange('simNumber')})))),this.state.isseatLimitValid&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{id:'seatLimit',name:'seatLimit',className:'textfield',margin:'dense',label:'Seat Capacity',type:'text'// type="Multi-line"
,value:this.state.seatLimit,required:true,onChange:this.handleInputChange('seatLimit'),error:!this.state.isSeatLimitValid,onBlur:this.checkSeatLimitValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isSeatLimitValid?'Invalid Seat Capacity':''))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{justify:'center',container:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button___default.a,{color:'default',variant:'outlined',size:'medium',margin:'normal',className:'btn'},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button___default.a,{variant:'contained',color:'secondary',size:'medium',margin:'normal',className:'btn',type:'button',onClick:this.handleSubmit(this.props.client),disabled:!(this.state.isVlpnValid&&this.state.vlpn!==''&&this.state.isSpeedLimitValid&&this.state.isVehicleModelValid&&this.state.isVehicleTypeValid&&this.state.isSpeedSensorValid&&this.state.speedSensorType!==''&&this.state.speedLimit!==''&&this.state.vehicleType!==''&&this.state.vehcleModel!=='')},'Submit'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button___default.a,{color:'primary',variant:'contained',size:'medium',margin:'normal',className:'btn',onClick:function onClick(event){return _this3.handleClickOpen();}},this.state.status===0||this.state.status===3?'Activate':'De-Activate/Service'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button___default.a,{color:'default',variant:'contained',size:'medium',margin:'normal',className:'btn',onClick:function onClick(event){return _this3.handleDecoupleOpen();}},'Decouple')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Dialog___default.a,{open:this.state.open,keepMounted:true,onClose:this.handleClose,'aria-labelledby':'alert-dialog-slide-title','aria-describedby':'alert-dialog-slide-description'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__ChangeVehicleStatus__["a" /* default */],{handleClose:this.handleClose,vehicleStatus:this.state.status,uniqueDeviceId:this.state.uniqueDeviceId})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Dialog___default.a,{open:this.state.open2,onClose:this.handleDecoupleClose,'aria-labelledby':'alert-dialog-slide-title','aria-describedby':'alert-dialog-slide-description'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__DecoupleDevices__["a" /* default */],{handleClose:this.handleDecoupleClose,vehicleStatus:this.state.status,uniqueDeviceId:this.state.uniqueDeviceId,simId:this.state.simId,clientLoginId:this.state.clientLoginId}))))))));}}]);return VehicleRegistration;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_13_react_apollo__["withApollo"])(VehicleRegistration)));

/***/ }),
/* 2414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormGroup__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Input__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_DialogActions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_DialogContent__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_DialogContentText__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_DialogContentText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_DialogContentText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_DialogTitle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_DialogTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_DialogTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__vehicle_css__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__vehicle_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__vehicle_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  mutation deviceActivateDeactivateService(\n    $uniqueDeviceId: String!\n    $type: String!\n    $reason: String!\n  ) {\n    deviceActivateDeactivateService(\n      uniqueDeviceId: $uniqueDeviceId\n      type: $type\n      reason: $reason\n    )\n  }\n'],['\n  mutation deviceActivateDeactivateService(\n    $uniqueDeviceId: String!\n    $type: String!\n    $reason: String!\n  ) {\n    deviceActivateDeactivateService(\n      uniqueDeviceId: $uniqueDeviceId\n      type: $type\n      reason: $reason\n    )\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var styles=function styles(theme){return{root:{padding:theme.spacing.unit*2,flexGrow:1},textField:{marginLeft:theme.spacing.unit,marginRight:theme.spacing.unit,width:'200px'},container:{display:'flex',flexWrap:'wrap'}};};// calling server for updation
var UPDATE_DEVICE_STATUS=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject);var ChangeVehicleStatus=function(_Component){_inherits(ChangeVehicleStatus,_Component);function ChangeVehicleStatus(props){var _this2=this;_classCallCheck(this,ChangeVehicleStatus);var _this=_possibleConstructorReturn(this,(ChangeVehicleStatus.__proto__||Object.getPrototypeOf(ChangeVehicleStatus)).call(this,props));_this.handleChangeType=function(event){_this.setState({vehicleStatus:event.target.value});};_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));};};_this.handleSubmit=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _ref2,data,Error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:console.log('submit');event.preventDefault();_context.next=4;return _this.props.client.mutate({mutation:UPDATE_DEVICE_STATUS,variables:{uniqueDeviceId:_this.props.uniqueDeviceId,type:_this.state.vehicleStatus,reason:_this.state.reason// errorPolicy: 'all'
}});case 4:_ref2=_context.sent;data=_ref2.data;Error=_ref2.Error;_this.setState({reason:'',vehicleStatus:'',type:'',response:data.deviceActivateDeactivateService});console.log('Success',data.deviceActivateDeactivateService,Error);case 9:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();console.log('vehicleStatus=',_this.props.vehicleStatus);_this.uniqueDeviceId=_this.props.uniqueDeviceId;_this.state={open1:false,vehicleStatus:'Activate',response:'',reason:''};return _this;}_createClass(ChangeVehicleStatus,[{key:'render',value:function render(){var classes=this.props;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{className:classes.container},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_DialogTitle___default.a,{id:'alert-dialog-slide-title'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_DialogContentText___default.a,{id:'alert-dialog-slide-description'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Typography___default.a,{variant:'body2',gutterBottom:true},this.props.vehicleStatus===0?'Do you want to Activate this vehicle!':'Do you want to De-activate this vehicle!'),this.state.response==='Success'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Typography___default.a,{variant:'subheading',gutterBottom:true,style:{color:'green',marginLeft:'25px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Sucessfully Updated')),this.state.response!=='Success'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Typography___default.a,{variant:'subheading',gutterBottom:true,style:{color:'red',marginLeft:'25px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,this.state.response)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_FormControl___default.a,{className:'selectbox'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_InputLabel___default.a,{htmlFor:'selectLabel'},'Select Status'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Select___default.a,{value:this.state.vehicleStatus,onChange:this.handleChangeType,onBlur:this.checkVehicleTypeValidity,name:'Select Status',input:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Input___default.a,{name:'vehicleStatus',id:'age-helper'})},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_MenuItem___default.a,{value:''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('em',null,'None')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_MenuItem___default.a,{value:'Activate'},'Activate'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_MenuItem___default.a,{value:'Deactivate'},'Deactivate'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_MenuItem___default.a,{value:'Service'},'Service')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_TextField___default.a,{id:'reason',name:'reason',className:'textfield',margin:'dense',label:'Reason for updation!',type:'Multi-line',value:this.state.reason,onChange:this.handleInputChange('reason')})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_DialogActions___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{onClick:this.handleSubmit,color:'primary',variant:'contained',disabled:!(this.state.vehicleStatus!==''&&this.state.reason!=='')},'Submit'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Button___default.a,{onClick:this.props.handleClose,color:'default',variant:'contained'},'Cancel')));}}]);return ChangeVehicleStatus;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["withApollo"])(ChangeVehicleStatus)));

/***/ }),
/* 2415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getAllAssignedDevicesToClient($clientId: Int!) {\n    device: getAllAssignedDevicesToClient(clientLoginId: $clientId) {\n      uniqueDeviceId\n      deviceModel {\n        model_name\n      }\n    }\n  }\n'],['\n  query getAllAssignedDevicesToClient($clientId: Int!) {\n    device: getAllAssignedDevicesToClient(clientLoginId: $clientId) {\n      uniqueDeviceId\n      deviceModel {\n        model_name\n      }\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query getAllAssignedSimToClient($clientId: Int!) {\n    simDetails: getAllAssignedSimToClient(clientLoginId: $clientId) {\n      id\n      simId\n      sim {\n        phoneNumber\n      }\n    }\n  }\n'],['\n  query getAllAssignedSimToClient($clientId: Int!) {\n    simDetails: getAllAssignedSimToClient(clientLoginId: $clientId) {\n      id\n      simId\n      sim {\n        phoneNumber\n      }\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation decoupleDeviceSim(\n    $newDeviceUniqueId: String\n    $existingDeviceUniqueId: String\n    $newSimId: Int\n    $existingSimId: Int\n    $decoupleType: String!\n    $loginType: String!\n  ) {\n    decoupleDeviceSim(\n      newDeviceUniqueId: $newDeviceUniqueId\n      existingDeviceUniqueId: $existingDeviceUniqueId\n      newSimId: $newSimId\n      existingSimId: $existingSimId\n      decoupleType: $decoupleType\n      loginType: $loginType\n    )\n  }\n'],['\n  mutation decoupleDeviceSim(\n    $newDeviceUniqueId: String\n    $existingDeviceUniqueId: String\n    $newSimId: Int\n    $existingSimId: Int\n    $decoupleType: String!\n    $loginType: String!\n  ) {\n    decoupleDeviceSim(\n      newDeviceUniqueId: $newDeviceUniqueId\n      existingDeviceUniqueId: $existingDeviceUniqueId\n      newSimId: $newSimId\n      existingSimId: $existingSimId\n      decoupleType: $decoupleType\n      loginType: $loginType\n    )\n  }\n']);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_DEVICE_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_12_graphql_tag__["a" /* default */])(_templateObject);var GET_SIM_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_12_graphql_tag__["a" /* default */])(_templateObject2);// calling server for updation
var DECOUPLE_DEVICESIM=Object(__WEBPACK_IMPORTED_MODULE_12_graphql_tag__["a" /* default */])(_templateObject3);var styles=function styles(theme){return{button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{margin:theme.spacing.unit,minWidth:120}};};var DecoupleDevices=function(_Component){_inherits(DecoupleDevices,_Component);function DecoupleDevices(props){var _this2=this;_classCallCheck(this,DecoupleDevices);var _this=_possibleConstructorReturn(this,(DecoupleDevices.__proto__||Object.getPrototypeOf(DecoupleDevices)).call(this,props));_this.handleChangeType=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var clientLoginId,_ref2,device,deviceError,allDevices,_ref3,simDetails,simError,allSims,_ref4,_device,_deviceError,_allDevices,_ref5,_simDetails,_simError,_allSims;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:// console.log('type', event)
_this.setState({vehicleStatus:event.value,deviceDecouple:false,simDecouple:false,deviceSimDecouple:false});clientLoginId=parseInt(_this.props.clientLoginId,10);if(!(event.value==='Device')){_context.next=12;break;}_context.next=5;return _this.props.client.query({query:GET_DEVICE_DETAILS,variables:{clientId:clientLoginId},errorPolicy:'all'});case 5:_ref2=_context.sent;device=_ref2.data;deviceError=_ref2.error;allDevices=device.device.map(function(device){return{value:device.uniqueDeviceId,label:device.uniqueDeviceId};});if(deviceError){_this.setState({deviceDetails:[]});}else{// console.log('alldevices', allDevices)
_this.setState({deviceDetails:allDevices,deviceDecouple:true});}_context.next=36;break;case 12:if(!(event.value==='Sim')){_context.next=22;break;}_context.next=15;return _this.props.client.query({query:GET_SIM_DETAILS,variables:{clientId:clientLoginId},errorPolicy:'all'});case 15:_ref3=_context.sent;simDetails=_ref3.data;simError=_ref3.error;allSims=simDetails.simDetails.map(function(sim){return{value:sim.simId,label:sim.sim.phoneNumber};});if(simError){_this.setState({simDetails:[]});}else{_this.setState({simDetails:allSims,simDecouple:true});}_context.next=36;break;case 22:_context.next=24;return _this.props.client.query({query:GET_DEVICE_DETAILS,variables:{clientId:clientLoginId},errorPolicy:'all'});case 24:_ref4=_context.sent;_device=_ref4.data;_deviceError=_ref4.error;_allDevices=_device.device.map(function(device){return{value:device.uniqueDeviceId,label:device.uniqueDeviceId};});_context.next=30;return _this.props.client.query({query:GET_SIM_DETAILS,variables:{clientId:clientLoginId},errorPolicy:'all'});case 30:_ref5=_context.sent;_simDetails=_ref5.data;_simError=_ref5.error;_allSims=_simDetails.simDetails.map(function(sim){return{value:sim.simId,label:sim.sim.phoneNumber};});if(_deviceError){_this.setState({deviceDetails:[]});}else{_this.setState({deviceDetails:_allDevices,deviceDecouple:true});}if(_simError){_this.setState({simDetails:[]});}else{_this.setState({simDetails:_allSims,simDecouple:true});}case 36:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.handleSubmit=function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(event){var _ref7,data,Error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:console.log('submit',_this.props.uniqueDeviceId);event.preventDefault();_context2.next=4;return _this.props.client.mutate({mutation:DECOUPLE_DEVICESIM,variables:{existingDeviceUniqueId:_this.props.uniqueDeviceId,newDeviceUniqueId:_this.state.serialNumber,newSimId:_this.state.phoneNumber,existingSimId:_this.props.simId,decoupleType:_this.state.vehicleStatus,loginType:localStorage.getItem('Account_type')// errorPolicy: 'all'
}});case 4:_ref7=_context2.sent;data=_ref7.data;Error=_ref7.Error;console.log('res=',data,Error);_this.setState({response:data.decoupleDeviceSim});if(_this.state.response==='Success'){_this.props.openSnackbar('Vehicle Decoupled Successfully');_this.props.handleClose();}else{_this.props.openSnackbar('Vehicle Decouple unsuccessful');}case 10:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref6.apply(this,arguments);};}();_this.handleChangeDevice=function(event){_this.setState({serialNumber:event.value});};_this.handleChangePhoneNumber=function(event){_this.setState({phoneNumber:event.value});};_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));};};_this.entityId=_this.props.entityId;// console.log('sjhfskjdg')
_this.state={vehicleStatus:_this.props.vehicleStatus,deviceDetails:[],simDetails:[],serialNumber:'',phoneNumber:'',deviceDecouple:false,simDecouple:false,deviceSimDecouple:false,response:'',reason:''// console.log('client', this.props.clientLoginId)
};return _this;}_createClass(DecoupleDevices,[{key:'render',value:function render(){var classes=this.props;var arr1=['Device','Sim','DeviceAndSim'];var allTypes=arr1.map(function(a1){return{value:a1,label:a1};});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_DialogTitle___default.a,{id:'form-dialog-title'},'Decouple Device/SIm'),this.state.response==='Success'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core__["Typography"],{variant:'subheading',gutterBottom:true,style:{color:'green',marginLeft:'25px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Decoupled Successfully')),this.state.response!=='Success'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core__["Typography"],{variant:'subheading',gutterBottom:true,style:{color:'red',marginLeft:'25px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,this.state.response)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Divider___default.a,{light:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_DialogContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_DialogContentText___default.a,null,'* Marked fields are mandatory'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'100%',marginTop:'5%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */],{classes:classes,options:allTypes// components={components}
,value:this.state.vehicleStatus,onChange:this.handleChangeType,placeholder:'Select Decouple Type'})),(this.state.deviceDecouple||this.state.deviceSimDecouple)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'100%',marginTop:'5%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */],{classes:classes,options:this.state.deviceDetails//  components={components}
,value:this.state.serialNumber,onChange:this.handleChangeDevice,placeholder:'Select Device *'})),(this.state.simDecouple||this.state.deviceSimDecouple)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:'100%',marginTop:'5%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */],{classes:classes,options:this.state.simDetails// components={components}
,value:this.state.phoneNumber,onChange:this.handleChangePhoneNumber,placeholder:'Select Phoneno *'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_FormControl___default.a,{className:classes.formControl,style:{minWidth:' 100%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_TextField___default.a,{autoFocus:true,margin:'dense',id:'reason',name:'reason',label:'Reason For Decouple!',type:'Multi-line',required:true,value:this.state.reason,fullWidth:true}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_DialogActions___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:this.props.handleClose,color:'default',variant:'contained'},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a// onClick={this.handleClose}
,{type:'submit',color:'primary',variant:'contained',disabled:!(this.state.vehicleStatus!==''&&this.state.reason!=='')},'Submit'))));}}]);return DecoupleDevices;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_13_react_apollo__["withApollo"])(DecoupleDevices)));

/***/ }),
/* 2416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_getLoginId__ = __webpack_require__(12);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query {\n    manufacturers: getAllManufacturer(status: 1) {\n      id\n      manufacturerName\n      manufacturerCode\n    }\n  }\n'],['\n  query {\n    manufacturers: getAllManufacturer(status: 1) {\n      id\n      manufacturerName\n      manufacturerCode\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query allClientDetails($partnerLoginId: Int) {\n    clientsDetails: allClientDetails(partnerLoginId: $partnerLoginId) {\n      clientName\n      loginId\n    }\n  }\n'],['\n  query allClientDetails($partnerLoginId: Int) {\n    clientsDetails: allClientDetails(partnerLoginId: $partnerLoginId) {\n      clientName\n      loginId\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation excelFileUpload(\n    $fileInfo: FileUploadInput!\n    $commonInput: CommonInput!\n  ) {\n    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {\n      failedToUpload\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedUploadList\n    }\n  }\n'],['\n  mutation excelFileUpload(\n    $fileInfo: FileUploadInput!\n    $commonInput: CommonInput!\n  ) {\n    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {\n      failedToUpload\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedUploadList\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n'],['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var style=function style(theme){return{root:{padding:theme.spacing.unit*2,flexGrow:1}};};var GET_MANUFACTURERS=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject);var GET_CLIENTS=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject2);var ADD_VEHICLES=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject3);var GET_UPLOAD_URL=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject4);var VehicleRegistration=function(_Component){_inherits(VehicleRegistration,_Component);function VehicleRegistration(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,VehicleRegistration);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=VehicleRegistration.__proto__||Object.getPrototypeOf(VehicleRegistration)).call.apply(_ref,[this].concat(args))),_this),_this.state={clients:[],manufacturers:[],client:{value:null,label:null},manufacturer:{value:null,label:null,code:null},isUploading:false,fileName:'',bucketName:'',publicUploadURL:'',response:''},_this.handleSelectChange=function(name){return function(value){_this.setState(_defineProperty({},name,value));};},_this.onUpload=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2){var _ref2$target=_ref2.target,validity=_ref2$target.validity,_ref2$target$files=_slicedToArray(_ref2$target.files,1),file=_ref2$target$files[0];var fileExtension,response,url;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.setState({isUploading:true});if(!validity.valid){_context.next=11;break;}fileExtension=file.name.substring(file.name.lastIndexOf('.')+1);_context.next=5;return _this.props.client.mutate({mutation:GET_UPLOAD_URL,variables:{fileExtension:fileExtension}});case 5:response=_context.sent;if(!(response.data&&response.data.getPublicUploadURL)){_context.next=11;break;}url=response.data.getPublicUploadURL.publicUploadURL;_context.next=10;return __WEBPACK_IMPORTED_MODULE_10_axios___default.a.put(url,file,{headers:{"x-ms-blob-type":"BlockBlob","Content-Type":file.type||"application/octet-stream"}});case 10:_this.setState({fileName:response.data.getPublicUploadURL.filename,bucketName:response.data.getPublicUploadURL.bucketName,publicUploadURL:response.data.getPublicUploadURL.publicUploadURL});case 11:_this.setState({isUploading:false});case 12:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref3.apply(this,arguments);};}(),_this.handleSubmit=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(event){var _ref5,data,fullData,arrList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this.props.client.mutate({mutation:ADD_VEHICLES,variables:{fileInfo:{uploadFor:'VehicleUpload',bucketName:_this.state.bucketName,fileName:_this.state.fileName,operationType:'SKIP'},commonInput:{clientLoginId:_this.state.client.value,partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_12__utils_getLoginId__["a" /* default */])(),manufacturerCode:_this.state.manufacturer.code}}});case 2:_ref5=_context2.sent;data=_ref5.data;fullData=[];arrList=data.excelFileUpload.failedUploadList;JSON.parse(arrList).forEach(function(element){var rowData=[];rowData.push(element.Serial_Number);rowData.push(element.IMEI);fullData.push(rowData);});_this.setState({response:'Total Excel Records= '+data.excelFileUpload.totalExcelDataRecords+','+'Total Records Uploaded='+data.excelFileUpload.successfullyUploaded+', Total Records Failed To Upload='+data.excelFileUpload.failedToUpload+', Total Duplicate Records in Excel='+data.excelFileUpload.totalDuplicateRecords});case 8:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref4.apply(this,arguments);};}(),_this.handleCancel=function(event){_this.props.history.goBack();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(VehicleRegistration,[{key:'componentDidMount',value:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var data,allClients,allManufacturers;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return this.props.client.query({query:GET_CLIENTS,variables:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_12__utils_getLoginId__["a" /* default */])()}});case 2:data=_context3.sent;allClients=data.data.clientsDetails.map(function(client){return{value:client.loginId,label:client.clientName};});_context3.next=6;return this.props.client.query({query:GET_MANUFACTURERS});case 6:data=_context3.sent;allManufacturers=data.data.manufacturers.map(function(manufacturer){return{value:manufacturer.id,label:manufacturer.manufacturerName,code:manufacturer.manufacturerCode};});this.setState({clients:allClients,manufacturers:allManufacturers});case 9:case'end':return _context3.stop();}}},_callee3,this);}));function componentDidMount(){return _ref6.apply(this,arguments);}return componentDidMount;}()},{key:'render',value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Typography"],{variant:'headline'},'Bulk Device Registration')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,item:true,xs:12,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */],{classes:classes,options:this.state.clients,value:this.state.client.value,onChange:this.handleSelectChange('client'),placeholder:'Select Customer'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,item:true,xs:12,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */],{classes:classes,options:this.state.manufacturers,value:this.state.manufacturer.value,onChange:this.handleSelectChange('manufacturer'),placeholder:'Select Manufacturer'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{accept:'*/*',id:'contained-button-file',multiple:true,type:'file',style:{display:'none'},onChange:this.onUpload}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'contained-button-file'},'Upload excel file here \xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{variant:'contained',component:'span',color:'primary'},this.state.isUploading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_CircularProgress___default.a,{size:15}):'Upload')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{color:'secondary',variant:'raised',onClick:this.handleSubmit},'Submit')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{color:'primary',variant:'raised',onClick:this.handleCancel},'Cancel'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Typography"],null,this.state.response))));}}]);return VehicleRegistration;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_7__HOCs_withSharedSnackbar__["a" /* default */])(VehicleRegistration))));

/***/ }),
/* 2417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StatusCard_jsx__ = __webpack_require__(2418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_apollo__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getAllPurchaseRequestInfo($resellerLoginId: Int!) {\n    allPrs: getAllPurchaseRequestInfo(resellerLoginId: $resellerLoginId) {\n      id\n      status\n      licenseTypeList {\n        id\n        maxPrice\n      }\n      deviceModelList {\n        id\n        model_name\n      }\n      createdAt\n    }\n  }\n'],['\n  query getAllPurchaseRequestInfo($resellerLoginId: Int!) {\n    allPrs: getAllPurchaseRequestInfo(resellerLoginId: $resellerLoginId) {\n      id\n      status\n      licenseTypeList {\n        id\n        maxPrice\n      }\n      deviceModelList {\n        id\n        model_name\n      }\n      createdAt\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ALL_PURCHASE_REQUESTS=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject);var style=function style(theme){return{root:{padding:theme.spacing.unit*2,flexGrow:1}};};var PurchaseRequest=function(_Component){_inherits(PurchaseRequest,_Component);function PurchaseRequest(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PurchaseRequest);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PurchaseRequest.__proto__||Object.getPrototypeOf(PurchaseRequest)).call.apply(_ref,[this].concat(args))),_this),_this.handleClick=function(title){var clickStatus={'Sent Requests':false,'Approval Pending':false,Approved:false,Cancelled:false,'Partially Executed':false,Completed:false};clickStatus[title]=true;_this.setState({clickStatus:clickStatus,currentlySelected:title});},_this.columns=['MODEL TYPES','LICENSE TYPES','RAISED ON'],_this.tableOptions={selectableRows:false,responsive:'scroll',rowsPerPage:5,onRowClick:function onRowClick(rowData,dataIndex){var index=dataIndex.dataIndex;if(_this.state.currentlySelected==='Approval Pending'){_this.props.history.push({pathname:'/home/reseller/purchase-request/pending/'+_this.state.data[_this.state.currentlySelected].ids[index]});}else{_this.props.history.push({pathname:'/home/reseller/purchase-request/view/'+_this.state.data[_this.state.currentlySelected].ids[index],state:_this.state.currentlySelected});}}},_this.state={clickStatus:{'Sent Requests':false,'Approval Pending':false,Approved:false,Cancelled:false,'Partially Executed':false,Completed:false},data:{'Sent Requests':{ids:[],data:[]},'Approval Pending':{ids:[],data:[]},Approved:{ids:[],data:[]},Cancelled:{ids:[],data:[]},'Partially Executed':{ids:[],data:[]},Completed:{ids:[],data:[]}},currentlySelected:'Sent Requests'},_this.getTableData=function(purchaseReq){var tempArr=[];tempArr.push(purchaseReq.deviceModelList.length.toString());tempArr.push(purchaseReq.licenseTypeList.length.toString());tempArr.push(__WEBPACK_IMPORTED_MODULE_10_moment___default.a.unix(purchaseReq.createdAt).format('DD/MM/YYYY').toString());return tempArr;},_this.handleNew=function(event){_this.props.history.push({pathname:'/home/reseller/purchase-request/new'});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PurchaseRequest,[{key:'componentDidMount',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _this2=this;var _ref3,data,prData,clickStatus,currentlySelected;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return this.props.client.query({query:ALL_PURCHASE_REQUESTS,variables:{resellerLoginId:Object(__WEBPACK_IMPORTED_MODULE_11__utils_getLoginId__["a" /* default */])()}});case 2:_ref3=_context.sent;data=_ref3.data;data=data.allPrs;// init final data
prData={'Sent Requests':{ids:[],data:[]},'Approval Pending':{ids:[],data:[]},Approved:{ids:[],data:[]},Cancelled:{ids:[],data:[]},'Partially Executed':{ids:[],data:[]},Completed:{ids:[],data:[]}// prep data in the format required
};data.forEach(function(purchaseReq){switch(purchaseReq.status){case 1:prData['Sent Requests'].ids.push(purchaseReq.id);prData['Sent Requests'].data.push(_this2.getTableData(purchaseReq));break;case 2:prData['Approval Pending'].ids.push(purchaseReq.id);prData['Approval Pending'].data.push(_this2.getTableData(purchaseReq));break;case 3:prData['Approved'].ids.push(purchaseReq.id);prData['Approved'].data.push(_this2.getTableData(purchaseReq));break;case-1:prData['Cancelled'].ids.push(purchaseReq.id);prData['Cancelled'].data.push(_this2.getTableData(purchaseReq));break;case 4:prData['Partially Executed'].ids.push(purchaseReq.id);prData['Partially Executed'].data.push(_this2.getTableData(purchaseReq));break;case 5:prData['Completed'].ids.push(purchaseReq.id);prData['Completed'].data.push(_this2.getTableData(purchaseReq));break;default:break;}});// initialize click status
clickStatus={'Sent Requests':true,'Approval Pending':false,Approved:false,Cancelled:false,'Partially Executed':false,Completed:false// init currently selected
};currentlySelected='Sent Requests';this.setState({clickStatus:clickStatus,data:prData,currentlySelected:currentlySelected});case 10:case'end':return _context.stop();}}},_callee,this);}));function componentDidMount(){return _ref2.apply(this,arguments);}return componentDidMount;}()},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;var categories=[{title:'Sent Requests',description:'Shows a list of purchase requests sent by the reseller'},{title:'Approval Pending',description:'Shows a list of purchase requests to be approved by the reseller'},{title:'Approved',description:'Shows a list of purchase requests approved by the reseller'},{title:'Cancelled',description:'Shows a list of all purchase requests which have been cancelled by the reseller'},{title:'Partially Executed',description:'Shows a list of all purchase requests which have been partially serviced by the super admin'},{title:'Completed',description:'Shows a list of all purchase requests which have been completely serviced by the super admin'}];return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row',justify:'space-between'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'headline'},'Purchase Requests'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'caption'},'Manage Purchase Requests')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{color:'secondary',variant:'raised',onClick:this.handleNew},'New Purchase Request'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12,container:true,spacing:16,direction:'row'},categories.map(function(category,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:2,key:index},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__StatusCard_jsx__["a" /* default */],{title:category.title,tooltip:category.description,handleClick:_this3.handleClick,isClicked:_this3.state.clickStatus[category.title],count:_this3.state.data[category.title].ids.length}));})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},this.state.currentlySelected!==null?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_mui_datatables___default.a,{data:this.state.data[this.state.currentlySelected].data,columns:this.columns,options:this.tableOptions,title:this.state.currentlySelected}):null)));}}]);return PurchaseRequest;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_12_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_6__HOCs_withSharedSnackbar__["a" /* default */])(PurchaseRequest))));

/***/ }),
/* 2418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Card__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_CardContent__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_CardContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_CardContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Tooltip__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Tooltip__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var style=function style(theme){return{title:{fontSize:14},card:{width:'100%',textAlign:'center'},customWidth:{maxWidth:300},buttonBase:{width:'100%',textAlign:'left'},pos:{marginBottom:12}};};var StatusCard=function(_Component){_inherits(StatusCard,_Component);function StatusCard(){_classCallCheck(this,StatusCard);return _possibleConstructorReturn(this,(StatusCard.__proto__||Object.getPrototypeOf(StatusCard)).apply(this,arguments));}_createClass(StatusCard,[{key:'render',value:function render(){var _this2=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["ButtonBase"],{className:classes.buttonBase,onClick:function onClick(){return _this2.props.handleClick(_this2.props.title);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Tooltip___default.a,{title:this.props.tooltip,classes:{tooltip:classes.customWidth}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Card___default.a,{className:classes.card,raised:!this.props.isClicked},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'body2'},this.props.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'title',color:'error'},this.props.count)))));}}]);return StatusCard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__["withStyles"])(style)(StatusCard));

/***/ }),
/* 2419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_apollo__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getAllDeviceModelResellerAssignDetails($resellerLoginId: Int!) {\n    allModels: getAllDeviceModelResellerAssignDetails(\n      resellerLoginId: $resellerLoginId\n    ) {\n      deviceModel {\n        model_name\n        maxPrice\n      }\n      deviceModelId\n    }\n  }\n'],['\n  query getAllDeviceModelResellerAssignDetails($resellerLoginId: Int!) {\n    allModels: getAllDeviceModelResellerAssignDetails(\n      resellerLoginId: $resellerLoginId\n    ) {\n      deviceModel {\n        model_name\n        maxPrice\n      }\n      deviceModelId\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query getAllLicenseTypeResellerAssignDetails($resellerLoginId: Int!) {\n    allLicenses: getAllLicenseTypeResellerAssignDetails(\n      resellerLoginId: $resellerLoginId\n    ) {\n      licenseTypeId\n      licenseType {\n        licenseType\n        maxPrice\n      }\n    }\n  }\n'],['\n  query getAllLicenseTypeResellerAssignDetails($resellerLoginId: Int!) {\n    allLicenses: getAllLicenseTypeResellerAssignDetails(\n      resellerLoginId: $resellerLoginId\n    ) {\n      licenseTypeId\n      licenseType {\n        licenseType\n        maxPrice\n      }\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation raisePurchaseRequest(\n    $licenseTypeList: [LicenseTypeRequest!]!\n    $deviceModelList: [DeviceModelRequest!]!\n    $resellerLoginId: Int!\n  ) {\n    raisePurchaseRequest(\n      licenseTypeList: $licenseTypeList\n      deviceModelList: $deviceModelList\n      resellerLoginId: $resellerLoginId\n    )\n  }\n'],['\n  mutation raisePurchaseRequest(\n    $licenseTypeList: [LicenseTypeRequest!]!\n    $deviceModelList: [DeviceModelRequest!]!\n    $resellerLoginId: Int!\n  ) {\n    raisePurchaseRequest(\n      licenseTypeList: $licenseTypeList\n      deviceModelList: $deviceModelList\n      resellerLoginId: $resellerLoginId\n    )\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_ALL_MODELS=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject);var GET_ALL_LICENSES=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject2);var RAISE_PURCHASE_REQUEST=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject3);var style=function style(theme){return{root:{padding:theme.spacing.unit*2,flexGrow:1}};};function AddRemoveButton(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{color:'secondary',variant:'raised',onClick:props.handleAdd(props.name),disabled:props.buttonStatus.add[props.name]},'Add')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{color:'primary',variant:'raised',onClick:props.handleRemove(props.name),disabled:props.buttonStatus.remove[props.name]},'Remove')));}var PurchaseRequest=function(_Component){_inherits(PurchaseRequest,_Component);function PurchaseRequest(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,PurchaseRequest);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PurchaseRequest.__proto__||Object.getPrototypeOf(PurchaseRequest)).call.apply(_ref,[this].concat(args))),_this),_this.state={models:[],licenses:[],modelDetails:[],licenseDetails:[],buttonStatus:{add:{model:false,license:false},remove:{model:false,license:false}}},_this.handleAdd=function(value){return function(event){if(value==='model'){var tempObject={model:null,qty:0,maxPrice:'NA'};var currentState=_this.state.models;// add new row
currentState.push(tempObject);_this.setState({models:currentState},function(){var buttonStatus=_this.state.buttonStatus;if(_this.state.models.length===_this.state.modelDetails.length){buttonStatus.add.model=true;}if(_this.state.models.length>1){buttonStatus.remove.model=false;}_this.setState({buttonStatus:buttonStatus});});}else if(value==='license'){var _tempObject={license:null,qty:0,maxPrice:'NA'};var _currentState=_this.state.licenses;// add new row
_currentState.push(_tempObject);_this.setState({licenses:_currentState},function(){var buttonStatus=_this.state.buttonStatus;if(_this.state.licenses.length===_this.state.licenseDetails.length){buttonStatus.add.license=true;}if(_this.state.licenses.length>1){buttonStatus.remove.license=false;}_this.setState({buttonStatus:buttonStatus});});}};},_this.handleRemove=function(value){return function(event){if(value==='model'){var currentState=_this.state.models;if(currentState.length>1){currentState.pop();_this.setState({models:currentState},function(){var buttonStatus=_this.state.buttonStatus;if(_this.state.models.length===1){buttonStatus.remove.model=true;}if(_this.state.models.length<_this.state.modelDetails.length){buttonStatus.add.model=false;}_this.setState({buttonStatus:buttonStatus});});}}else if(value==='license'){var _currentState2=_this.state.licenses;if(_currentState2.length>1){_currentState2.pop();_this.setState({licenses:_currentState2},function(){var buttonStatus=_this.state.buttonStatus;if(_this.state.licenses.length===1){buttonStatus.remove.license=true;}if(_this.state.licenses.length<_this.state.licenseDetails.length){buttonStatus.add.license=false;}_this.setState({buttonStatus:buttonStatus});});}}};},_this.handleSelectChange=function(type,index){return function(value){var i=0;if(type==='model'){var currModels=_this.state.models;if(value){currModels[index].model=value.value;for(i=0;i<_this.state.modelDetails.length;i++){if(_this.state.modelDetails[i].value===value.value){currModels[index].maxPrice=_this.state.modelDetails[i].maxPrice;}}}else{currModels[index].model=null;currModels[index].qty=0;currModels[index].maxPrice='NA';}_this.setState({models:currModels});}else if(type==='license'){var currLicenses=_this.state.licenses;if(value){currLicenses[index].license=value.value;for(i=0;i<_this.state.licenseDetails.length;i++){if(_this.state.licenseDetails[i].value===value.value){currLicenses[index].maxPrice=_this.state.licenseDetails[i].maxPrice;}}}else{currLicenses[index].license=null;currLicenses[index].qty=0;currLicenses[index].maxPrice='NA';}_this.setState({licenses:currLicenses});}};},_this.handleChange=function(type,index){return function(event){var value=event.target.value;if(type==='model'){var currModels=_this.state.models;if(value>=0){currModels[index].qty=value;}_this.setState({models:currModels});}else if(type==='license'){var currLicenses=_this.state.licenses;if(value>=0){currLicenses[index].qty=value;}_this.setState({licenses:currLicenses});}};},_this.handleSubmit=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var devicesUnique,licensesUnique,deviceCount,licenseCount,countMatch,j,i,finalModels,finalLicenses,_ref3,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:// check if devices and licenses are unique and number of licenses match devices
devicesUnique=true;licensesUnique=true;deviceCount=0;licenseCount=0;countMatch=true;// Device uniqueness check
for(j=0;j<_this.state.models.length;j++){deviceCount+=parseInt(_this.state.models[j].qty,10);for(i=j+1;i<_this.state.models.length;i++){if(_this.state.models[i].model===_this.state.models[j].model){devicesUnique=false;}}}// License uniqueness check
for(j=0;j<_this.state.licenses.length;j++){licenseCount+=parseInt(_this.state.licenses[j].qty,10);for(i=j+1;i<_this.state.licenses.length;i++){if(_this.state.licenses[i].license===_this.state.licenses[j].license){licensesUnique=false;}}}// check for count match
if(deviceCount!==licenseCount){countMatch=false;}if(!(devicesUnique===false||licensesUnique===false)){_context.next=12;break;}_this.props.openSnackbar('Devices / Licenses should be unique');_context.next=29;break;case 12:if(!(countMatch===false)){_context.next=16;break;}_this.props.openSnackbar('Total Devices and Licenses should match');_context.next=29;break;case 16:if(!(deviceCount===0||licenseCount===0)){_context.next=20;break;}_this.props.openSnackbar('Devices and Licenses should have a valid quantity');_context.next=29;break;case 20:// Prep data in the necessary format
finalModels=[];finalLicenses=[];_this.state.models.forEach(function(model){var tempModel={};tempModel.deviceModelId=parseInt(model.model,10);tempModel.quantity=parseInt(model.qty,10);tempModel.assignedQuantity=0;finalModels.push(tempModel);});_this.state.licenses.forEach(function(license){var tempLicense={};tempLicense.licenseTypeId=parseInt(license.license,10);tempLicense.quantity=parseInt(license.qty,10);tempLicense.assignedQuantity=0;finalLicenses.push(tempLicense);});_context.next=26;return _this.props.client.mutate({mutation:RAISE_PURCHASE_REQUEST,variables:{licenseTypeList:finalLicenses,deviceModelList:finalModels,resellerLoginId:Object(__WEBPACK_IMPORTED_MODULE_10__utils_getLoginId__["a" /* default */])()}});case 26:_ref3=_context.sent;data=_ref3.data;if(data.raisePurchaseRequest===true){_this.props.openSnackbar('Purchase Request Raised Successfully');_this.props.history.push({pathname:'/home/reseller/purchase-request'});}else{_this.props.openSnackbar('Purchase Request Failed. Retry');}case 29:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}(),_this.handleCancel=function(event){_this.props.openSnackbar('Purchase Request Cancelled');_this.props.history.goBack();},_this.handleBack=function(event){_this.props.history.goBack();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PurchaseRequest,[{key:'componentDidMount',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var modelDetails,licenseDetails,allModels,allLicenses,tempModelType,tempLicenseType,buttonStatus;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:modelDetails=[];licenseDetails=[];// Query to get all device models
_context2.next=4;return this.props.client.query({query:GET_ALL_MODELS,variables:{resellerLoginId:Object(__WEBPACK_IMPORTED_MODULE_10__utils_getLoginId__["a" /* default */])()}});case 4:allModels=_context2.sent;allModels=allModels.data.allModels;// Map models in the required format
allModels.forEach(function(model){var tempModel={};tempModel.value=model.deviceModelId;tempModel.label=model.deviceModel.model_name;tempModel.maxPrice=model.deviceModel.maxPrice;modelDetails.push(tempModel);});// Query to get all licenses
_context2.next=9;return this.props.client.query({query:GET_ALL_LICENSES,variables:{resellerLoginId:Object(__WEBPACK_IMPORTED_MODULE_10__utils_getLoginId__["a" /* default */])()}});case 9:allLicenses=_context2.sent;allLicenses=allLicenses.data.allLicenses;// Map licenses in the required format
allLicenses.forEach(function(license){var tempLicense={};tempLicense.value=license.licenseTypeId;tempLicense.label=license.licenseType.licenseType;tempLicense.maxPrice=license.licenseType.maxPrice;licenseDetails.push(tempLicense);});// initialize one row each for devices & plans and init button status
tempModelType=[{model:null,qty:0,maxPrice:'NA'}];tempLicenseType=[{license:null,qty:0,maxPrice:'NA'}];buttonStatus={add:{model:false,license:false},remove:{model:true,license:true}// If only one license or model is available, disable add buttons
};if(modelDetails.length===1){buttonStatus.add.model=true;}if(licenseDetails.length===1){buttonStatus.add.license=true;}this.setState({modelDetails:modelDetails,licenseDetails:licenseDetails,buttonStatus:buttonStatus,models:tempModelType,licenses:tempLicenseType});case 18:case'end':return _context2.stop();}}},_callee2,this);}));function componentDidMount(){return _ref4.apply(this,arguments);}return componentDidMount;}()},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{color:'primary',variant:'raised',onClick:this.handleBack},'Back'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Typography"],{variant:'headline'},'Purchase Request')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Typography"],{variant:'title'},'Device Model(s)')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,container:true,xs:12,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Typography"],{variant:'subheading'},'Select Model')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Typography"],{variant:'subheading'},'Maximum Price')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Typography"],{variant:'subheading'},'Order Quantity'))),this.state.models.map(function(model,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,container:true,xs:12,spacing:16,direction:'row',key:index},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select__["a" /* default */],{placeholder:'Select Device Model',classes:classes,options:_this3.state.modelDetails,value:model.model,onChange:_this3.handleSelectChange('model',index)})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Typography"],{variant:'subheading'},model.maxPrice)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField___default.a,{placeholder:'Quantity',value:model.qty,onChange:_this3.handleChange('model',index),type:'number'})));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AddRemoveButton,{name:'model',handleAdd:this.handleAdd,handleRemove:this.handleRemove,buttonStatus:this.state.buttonStatus}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Typography"],{variant:'title'},'License(s)')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,container:true,xs:12,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Typography"],{variant:'subheading'},'License Type')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Typography"],{variant:'subheading'},'Maximum Price')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Typography"],{variant:'subheading'},'Order Quantity'))),this.state.licenses.map(function(license,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,container:true,xs:12,spacing:16,direction:'row',key:index},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select__["a" /* default */],{placeholder:'Select License Type',classes:classes,options:_this3.state.licenseDetails,value:license.license,onChange:_this3.handleSelectChange('license',index)})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Typography"],{variant:'subheading'},license.maxPrice)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_TextField___default.a,{placeholder:'Quantity',value:license.qty,onChange:_this3.handleChange('license',index),type:'number'})));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AddRemoveButton,{name:'license',handleAdd:this.handleAdd,handleRemove:this.handleRemove,buttonStatus:this.state.buttonStatus}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,container:true,xs:12,spacing:16,direction:'row',justify:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{color:'secondary',variant:'raised',onClick:this.handleSubmit},'Submit')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{color:'primary',variant:'raised',onClick:this.handleCancel},'Cancel')))));}}]);return PurchaseRequest;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_5__HOCs_withSharedSnackbar__["a" /* default */])(PurchaseRequest))));

/***/ }),
/* 2420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ViewPendingRequest_jsx__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ViewRequest=function(_Component){_inherits(ViewRequest,_Component);function ViewRequest(){_classCallCheck(this,ViewRequest);return _possibleConstructorReturn(this,(ViewRequest.__proto__||Object.getPrototypeOf(ViewRequest)).apply(this,arguments));}_createClass(ViewRequest,[{key:'render',value:function render(){var state=this.props.location.state;var details=void 0;if(state==='Sent Requests'){details=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Typography___default.a,{variant:'headline'},'Sent Purchase Requests'));}else if(state==='Approved'){details=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Typography___default.a,{variant:'headline'},'Approved Purchase Request'));}else if(state==='Cancelled'){details=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Typography___default.a,{variant:'headline'},'Cancelled Purchase Request'));}else if(state==='Partially Executed'){details=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Typography___default.a,{variant:'headline'},'Partially Executed Purchase Request'));}else if(state==='Completed'){details=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Typography___default.a,{variant:'headline'},'Completed Purchase Request'));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__ViewPendingRequest_jsx__["a" /* default */],{externallyRendered:true,goBack:this.props.history.goBack,details:details,purchaseRequestId:this.props.match.params.purchaseRequestId});}}]);return ViewRequest;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ViewRequest);

/***/ }),
/* 2421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_getLoginId__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getAllVehicleDetailsByStatus($loginId: Int, $status: Int) {\n    vehicles: getAllVehicleDetailsByStatus(\n      resellerloginId: $loginId\n      status: $status\n    ) {\n      entityId\n      vehicleNumber\n      chassisNumber\n      deviceDetail {\n        serial_num\n        uniqueDeviceId\n        deviceModelId {\n          model_name\n          devicetype\n        }\n      }\n      simDetail {\n        phoneNumber\n      }\n      vehicleType\n      vehicleModel\n    }\n  }\n'],['\n  query getAllVehicleDetailsByStatus($loginId: Int, $status: Int) {\n    vehicles: getAllVehicleDetailsByStatus(\n      resellerloginId: $loginId\n      status: $status\n    ) {\n      entityId\n      vehicleNumber\n      chassisNumber\n      deviceDetail {\n        serial_num\n        uniqueDeviceId\n        deviceModelId {\n          model_name\n          devicetype\n        }\n      }\n      simDetail {\n        phoneNumber\n      }\n      vehicleType\n      vehicleModel\n    }\n  }\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var style=function style(theme){return{root:{padding:theme.spacing.unit*4,flexGrow:1},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},iconSmall:{fontSize:20}};};var GET_VEHICLE_LIST=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject);var ViewVehicleList=function(_Component){_inherits(ViewVehicleList,_Component);function ViewVehicleList(props){_classCallCheck(this,ViewVehicleList);var _this=_possibleConstructorReturn(this,(ViewVehicleList.__proto__||Object.getPrototypeOf(ViewVehicleList)).call(this,props));_this.clientId=[];_this.columns=['VEHICLE NO','CHASSIS NO','UNIQUE ID','PHONE NO','MODEL','DEVICE TYPE'];_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15,onRowClick:function onRowClick(rowData,dataIndex,rowIndex){// console.log('meena', this.entityId[rowIndex])
_this.props.history.push({pathname:'/home/reseller/vehicles/edit/'+_this.entityId[dataIndex.dataIndex]});}};_this.state={open:false,open1:false};_this.getStatus=function(status){if(status===1){return'Instock';}else if(status===2){return'Assigned to Partner';}else if(status===3){return'Assigned to Client';}else if(status===4){return'Registered to vehicle';}};_this.handleClickOpen=function(){_this.setState({open:true});};_this.handleClose=function(){_this.setState({open:false});};_this.handleClickBulkOpen=function(){_this.setState({open1:true});};_this.handleBulkClose=function(){_this.setState({open1:false});};_this.addBulkUpload=function(e){_this.props.history.push({pathname:'/home/DeviceInventory/BulkUpload'});};_this.assignBulkUpload=function(e){console.log('bulk');_this.props.history.push({pathname:'/home/DeviceInventory/BulkDeviceAssign'});};_this.classes=props;return _this;}_createClass(ViewVehicleList,[{key:'mapToArr',value:function mapToArr(devices){var _this2=this;var rowData=[];var fullData=[];this.entityId=[];devices.forEach(function(element){rowData=[];_this2.entityId.push(element.entityId);rowData.push(element.vehicleNumber);rowData.push(element.chassisNumber);rowData.push(element.deviceDetail.uniqueDeviceId);_this2.getStatus(rowData.push(element.simDetail.phoneNumber));rowData.push(element.deviceDetail.deviceModelId.devicetype);rowData.push(element.deviceDetail.deviceModelId.model_name);fullData.push(rowData);});return fullData;}},{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["Query"],{query:GET_VEHICLE_LIST,variables:{loginId:Object(__WEBPACK_IMPORTED_MODULE_7__utils_getLoginId__["a" /* default */])(),// loginId: 21,
accountType:localStorage.getItem('Account_type'),status:parseInt(this.props.match.params.status,10)}},function(_ref){var loading=_ref.loading,error=_ref.error,vehicles=_ref.data.vehicles;if(loading)return'Loading...';if(error)return'Error!: '+error;var data=_this3.mapToArr(vehicles);// console.log('devices', vehicles)
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row-reverse',justify:'space-between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'headline'},'Vehicles'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_mui_datatables___default.a,{data:data,columns:_this3.columns,options:_this3.options}))));});}}]);return ViewVehicleList;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["withApollo"])(ViewVehicleList)));

/***/ }),
/* 2422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Card__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_CardContent__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_CardContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_CardContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_CardActions__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_CardActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_CardActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Reusable_Charts_PieChart__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Reusable_ItemCard__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getVehicleCountByStatus($partnerLoginId: Int!) {\n    allvehicle: getVehicleCountByStatus(resellerloginId: $partnerLoginId) {\n      totalRegisteredVehicle\n      totalActiveVehicle\n      totalInActiveVehicle\n      totalServicedVehicle\n      totalDeactiveVehicle\n    }\n  }\n'],['\n  query getVehicleCountByStatus($partnerLoginId: Int!) {\n    allvehicle: getVehicleCountByStatus(resellerloginId: $partnerLoginId) {\n      totalRegisteredVehicle\n      totalActiveVehicle\n      totalInActiveVehicle\n      totalServicedVehicle\n      totalDeactiveVehicle\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_ALL_VEHICLE_STATUS=Object(__WEBPACK_IMPORTED_MODULE_7_graphql_tag__["a" /* default */])(_templateObject);var styles=function styles(theme){return{root:{flexGrow:1,padding:theme.spacing.unit*2},paper:{height:140,width:100},control:{padding:theme.spacing.unit*2}};};var vechicleType=['Active','De-active','Service','Not Registered','Inactive'];var VehcileDashboard=function(_Component){_inherits(VehcileDashboard,_Component);function VehcileDashboard(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,VehcileDashboard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=VehcileDashboard.__proto__||Object.getPrototypeOf(VehcileDashboard)).call.apply(_ref,[this].concat(args))),_this),_this.mapToArr=function(vechicleType,allvehicle){console.log('vechicleType',vechicleType,allvehicle);var pieChartArr=[];var fullData=[];vechicleType.forEach(function(element){pieChartArr=[];pieChartArr['value']=Math.random();// To be removed random function
pieChartArr['label']=element;pieChartArr['id']=element;fullData.push(pieChartArr);});return fullData;},_this.showClientwise=function(vehType){return _asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:console.log('vehType',vehType);if(vehType==='unregistred'){_this.props.history.push({pathname:'/home/VehicleDashboard/ViewDevices/'+2});}else{console.log('hi',vehType);_this.props.history.push({pathname:'/home/reseller/VehicleDashboard/ViewVehicles'+vehType});}case 2:case'end':return _context.stop();}}},_callee,_this2);}));},_this.addVehicle=function(e){_this.props.history.push({pathname:'/home/reseller/vehicles/register'});},_this.bulkRegister=function(event){_this.props.history.push({pathname:'/home/reseller/vehicles/bulk-register'});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(VehcileDashboard,[{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row-reverse',justify:'space-between',alignItems:'flex-end'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{color:'secondary',onClick:this.addVehicle,variant:'raised'// className={this.classes.button}
},'Register Vehicle'),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{color:'default',variant:'outlined',size:'medium',margin:'normal',className:'btn',onClick:this.bulkRegister},'Bulk Registration'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'headline'},'Vehicle Dashboard')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_apollo__["Query"],{query:GET_ALL_VEHICLE_STATUS,variables:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__["a" /* default */])()}},function(_ref3){var loading=_ref3.loading,error=_ref3.error,allvehicle=_ref3.data.allvehicle;if(loading)return'Loading...';if(error)return'Error!: '+error;var rowData=allvehicle&&_this3.mapToArr(vechicleType,allvehicle);console.log('rowdata',allvehicle);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row',justify:'flex-start',alignItems:'flex-start',className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:8},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row',justify:'flex-start',alignItems:'flex-start'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Card___default.a,{className:classes.card},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{gutterBottom:true,variant:'headline',component:'h2'},'Active'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{component:'p'},allvehicle.totalActiveVehicle)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_CardActions___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{color:'primary',variant:'outlined',onClick:_this3.showClientwise(1)},'View Vehicles')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Card___default.a,{className:classes.card},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{gutterBottom:true,variant:'headline',component:'h2'},'Deactive'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{component:'p'},allvehicle.totalDeactiveVehicle)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_CardActions___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{color:'primary',variant:'outlined',onClick:_this3.showClientwise(0)},'View Vehicles')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Card___default.a,{className:classes.card},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{gutterBottom:true,variant:'headline',component:'h2'},'Inactive'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{component:'p'},allvehicle.totalInActiveVehicle)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_CardActions___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{color:'primary',variant:'outlined',onClick:_this3.showClientwise(2)},'View Vehicles')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Card___default.a,{className:classes.card},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{gutterBottom:true,variant:'headline',component:'h2'},'Service'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{component:'p'},allvehicle.totalServicedVehicle)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_CardActions___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{color:'primary',variant:'outlined',onClick:_this3.showClientwise(3)},'View Vehicles')))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Reusable_ItemCard__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography___default.a,{variant:'body2'},'Vehicle Chart!'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Reusable_Charts_PieChart__["a" /* default */],{data:rowData})))));})));}}]);return VehcileDashboard;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__["withStyles"])(styles)(VehcileDashboard));

/***/ }),
/* 2423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getDevices($superAdminLogin: Boolean) {\n    getCurrentTrackinfo(superAdminLogin: $superAdminLogin) {\n      vehicleNumber\n      deviceSlNumber\n      phoneNumber\n      imeiNumber\n      simNumber\n      deviceVersion\n      vehicleModel\n      clientName\n      gpsSpeed\n      coordinates\n      address\n      vehicleGroup\n      timestamp\n      trackingStatus\n      batteryStatus\n    }\n  }\n'],['\n  query getDevices($superAdminLogin: Boolean) {\n    getCurrentTrackinfo(superAdminLogin: $superAdminLogin) {\n      vehicleNumber\n      deviceSlNumber\n      phoneNumber\n      imeiNumber\n      simNumber\n      deviceVersion\n      vehicleModel\n      clientName\n      gpsSpeed\n      coordinates\n      address\n      vehicleGroup\n      timestamp\n      trackingStatus\n      batteryStatus\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var style=function style(theme){return{root:{padding:theme.spacing.unit*4,flexGrow:1},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},iconSmall:{fontSize:20}};};var GET_ALL_VEHICLE_SUMMARY=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject);var SATrackinfo=function(_Component){_inherits(SATrackinfo,_Component);function SATrackinfo(props){var _this2=this;_classCallCheck(this,SATrackinfo);var _this=_possibleConstructorReturn(this,(SATrackinfo.__proto__||Object.getPrototypeOf(SATrackinfo)).call(this,props));_this.clientId=[];_this.columns=['VLPN','DEVICE SlNUMBER','IMEI NUMBER','PHONE NUMBER','SIM NUMBER','DEVICE VERSION','VEHICLE MODEL','CLIENT NAME','TIMESTAMP','SPEED','COORDINATES','ADDRESS','VEHICLE GROUP','TRACKING STATUS','BATTERY STATUS'];_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15,filter:false,print:false};_this.state={open:false,open1:false,vehicleInfo:[],userLoginId:'',vehicleInfoTemp:[],isLoading:false};_this.fullData=[];_this.getAllVehicles=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var vehicles,rowData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.setState({isLoading:true});_context.next=3;return _this.props.client.query({query:GET_ALL_VEHICLE_SUMMARY,variables:{superAdminLogin:true},fetchPolicy:'network-only'});case 3:vehicles=_context.sent;_this.setState({isLoading:false});if(vehicles&&vehicles.data){// console.log('vehi Data', vehicles.data)
rowData=[];vehicles.data.getCurrentTrackinfo.forEach(function(element){rowData=[];rowData.push(element.vehicleNumber);rowData.push(element.deviceSlNumber);rowData.push(element.imeiNumber);rowData.push(element.phoneNumber);rowData.push(element.simNumber);rowData.push(element.deviceVersion);rowData.push(element.vehicleModel);rowData.push(element.clientName);if(element&&element.timestamp){rowData.push(_this.getFormattedDate(element.timestamp));}else rowData.push('---');if(element&&element.gpsSpeed!==null)rowData.push(element.gpsSpeed);else rowData.push('---');if(element&&element.coordinates)rowData.push(element.coordinates);else rowData.push('---');if(element&&element.address)rowData.push(element.address);else rowData.push('---');rowData.push(element.vehicleGroup);rowData.push(element.trackingStatus);rowData.push(element.batteryStatus);_this.fullData.push(rowData);});}_this.setState({vehicleInfo:_this.fullData});// console.log('fullData vehicleInfo', this.fullData)
case 7:case'end':return _context.stop();}}},_callee,_this2);}));_this.getFormattedDate=function(timestamp){return __WEBPACK_IMPORTED_MODULE_4_moment___default()(timestamp*1000).format('MMM Do YYYY, h:mm a');};_this.classes=props;return _this;}_createClass(SATrackinfo,[{key:'componentDidMount',value:function componentDidMount(){this.getAllVehicles();}},{key:'render',value:function render(){var classes=this.props.classes;// console.log('log', this.fullData)
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},this.state.isLoading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,justify:'space-between'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Typography___default.a,{variant:'headline'},'Loading.....')):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Grid___default.a,{item:true,xs:12,style:{maxWidth:'1000px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_mui_datatables___default.a,{data:this.state.vehicleInfo,columns:this.columns,options:this.options,title:'Current Trackinfo'}))));}}]);return SATrackinfo;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_5_react_apollo__["withApollo"])(SATrackinfo)));

/***/ }),
/* 2424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CreateDemoLink__ = __webpack_require__(2425);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CreateDemoLink__["a"]; });


/***/ }),
/* 2425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DemoLoginForm__ = __webpack_require__(2426);
var styles=function styles(theme){return{fullHeight:{height:'100%'},softPadding:{padding:theme.spacing.unit}};};function CreateDemoLink(_ref){var classes=_ref.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Grid"],{container:true,className:classes.fullHeight,alignContent:'flex-start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Grid"],{item:true,xs:12,className:classes.softPadding},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Typography"],{variant:'headline'},'Create Demo Login Link')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Divider"],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Grid"],{item:true,xs:12,className:classes.softPadding},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__DemoLoginForm__["a" /* default */],null)));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["withStyles"])(styles)(CreateDemoLink));

/***/ }),
/* 2426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HOCs_withSharedSnackbar__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query(\n    $username: String!\n    $password: String!\n    $domain: String!\n    $hours: Int!\n  ) {\n    loginToken: createTimeLimitedLogin(\n      username: $username\n      password: $password\n      portalURL: $domain\n      hours: $hours\n    ) {\n      token\n    }\n  }\n'],['\n  query(\n    $username: String!\n    $password: String!\n    $domain: String!\n    $hours: Int!\n  ) {\n    loginToken: createTimeLimitedLogin(\n      username: $username\n      password: $password\n      portalURL: $domain\n      hours: $hours\n    ) {\n      token\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_TOKEN=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject);var styles=function styles(theme){return{formPaper:{padding:theme.spacing.unit*4,width:'100%'},formContainer:{maxWidth:theme.spacing.unit*40},linkText:{background:'rgb(240, 240, 240)',wordWrap:'break-word',width:500}};};var DemoLoginForm=function(_Component){_inherits(DemoLoginForm,_Component);function DemoLoginForm(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,DemoLoginForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DemoLoginForm.__proto__||Object.getPrototypeOf(DemoLoginForm)).call.apply(_ref,[this].concat(args))),_this),_this.state={username:'',password:'',domain:'',hours:'',link:'',loading:false,error:false},_this.handleChange=function(name){return function(e){_this.setState(_defineProperty({},name,e.target.value));};},_this.handleSubmit=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(e){var _this$state,username,password,domain,hours,_ref3,data,errors;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.setState({link:'',loading:true,error:false});_this$state=_this.state,username=_this$state.username,password=_this$state.password,domain=_this$state.domain,hours=_this$state.hours;e.preventDefault();_context.next=5;return _this.props.client.query({query:GET_TOKEN,variables:{username:username,password:password,domain:domain,hours:parseInt(hours,10)},errorPolicy:'all',fetchPolicy:'network-only'});case 5:_ref3=_context.sent;data=_ref3.data;errors=_ref3.errors;if(errors){_this.props.openSnackbar(errors[0].message);_this.setState({error:true,loading:false,link:''});}if(data&&data.loginToken&&data.loginToken.token){_this.setState({link:'https://'+domain+'/?demo=true&token='+data.loginToken.token,loading:false,error:false});}case 10:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}(),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DemoLoginForm,[{key:'render',value:function render(){var classes=this.props.classes;var _state=this.state,username=_state.username,password=_state.password,domain=_state.domain,hours=_state.hours,link=_state.link,loading=_state.loading,error=_state.error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Paper"],{className:classes.formPaper},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Grid"],{container:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Grid"],{item:true,xs:12,md:5},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{className:classes.formContainer,autoComplete:'off',onSubmit:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["TextField"],{fullWidth:true,id:'username',label:'Username (demo account)',value:username,onChange:this.handleChange('username'),margin:'normal',required:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["TextField"],{fullWidth:true,id:'password',label:'Password (demo account)',value:password,onChange:this.handleChange('password'),margin:'normal',type:'password',required:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["TextField"],{fullWidth:true,id:'domain',label:'Domain (eg: dev.aquilatrack.com)',value:domain,onChange:this.handleChange('domain'),margin:'normal',required:true,placeholder:'dev.aquilatrack.com'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["TextField"],{fullWidth:true,id:'hours',label:'Valid for (in no of hours)',value:hours,onChange:this.handleChange('hours'),margin:'normal',type:'number',required:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Button"],{variant:'outlined',type:'submit'},'GENERATE LINK'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Grid"],{item:true,xs:12,md:7},error&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Could not generate demo login link. Check username/password')),loading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Loading...')),link&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.linkText},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:link,rel:'noopener noreferrer',target:'_blank'},link)))));}}]);return DemoLoginForm;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_5__HOCs_withSharedSnackbar__["a" /* default */])(DemoLoginForm))));

/***/ }),
/* 2427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__APIDashboard__ = __webpack_require__(2428);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__APIDashboard__["a"]; });


/***/ }),
/* 2428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_pickers__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_MultiCheckComboBox__ = __webpack_require__(2429);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _templateObject=_taggedTemplateLiteral(['\n  {\n    partners: allPartnerDetails(status: 1) {\n      name: businessName\n      login {\n        id: loginId\n        username\n      }\n    }\n  }\n'],['\n  {\n    partners: allPartnerDetails(status: 1) {\n      name: businessName\n      login {\n        id: loginId\n        username\n      }\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query($id: Int) {\n    clients: allClientDetails(partnerLoginId: $id, status: 1) {\n      name: clientName\n      id: loginId\n      login {\n        username\n      }\n    }\n  }\n'],['\n  query($id: Int) {\n    clients: allClientDetails(partnerLoginId: $id, status: 1) {\n      name: clientName\n      id: loginId\n      login {\n        username\n      }\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query(\n    $partnerIds: [Int!]!\n    $clientIds: [Int!]!\n    $from: String!\n    $to: String!\n    $limit: Int\n  ) {\n    apiStats: getApiStat(\n      businessAdminId: $partnerIds\n      clientId: $clientIds\n      fromTimestamp: $from\n      toTimestamp: $to\n      limit: $limit\n    ) {\n      apiName\n      apiCount\n      apiType\n    }\n  }\n'],['\n  query(\n    $partnerIds: [Int!]!\n    $clientIds: [Int!]!\n    $from: String!\n    $to: String!\n    $limit: Int\n  ) {\n    apiStats: getApiStat(\n      businessAdminId: $partnerIds\n      clientId: $clientIds\n      fromTimestamp: $from\n      toTimestamp: $to\n      limit: $limit\n    ) {\n      apiName\n      apiCount\n      apiType\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var styles={container:{background:'white',height:'100%'},itemPadding:{padding:16}};var GET_BUSINESS_ADMINS=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject);var GET_CLIENTS=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject2);var GET_API_STATS=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject3);function APIDashboard(props){var handleFormSubmit=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(e){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:e.preventDefault();_context3.next=3;return props.client.query({query:GET_API_STATS,variables:{partnerIds:selectedPartners.map(function(p){return p.id;}),clientIds:selectedClients.map(function(c){return c.id;}),from:String(fromTime.unix()),to:String(toTime.unix())}});case 3:response=_context3.sent;if(response&&response.data&&response.data.apiStats){setApiStats(response.data.apiStats);}case 5:case'end':return _context3.stop();}}},_callee3,this);}));return function handleFormSubmit(_x2){return _ref3.apply(this,arguments);};}();var _React$useState=__WEBPACK_IMPORTED_MODULE_1_react___default.a.useState(null),_React$useState2=_slicedToArray(_React$useState,2),fromTime=_React$useState2[0],setFromTime=_React$useState2[1];var _React$useState3=__WEBPACK_IMPORTED_MODULE_1_react___default.a.useState(null),_React$useState4=_slicedToArray(_React$useState3,2),toTime=_React$useState4[0],setToTime=_React$useState4[1];var _React$useState5=__WEBPACK_IMPORTED_MODULE_1_react___default.a.useState([]),_React$useState6=_slicedToArray(_React$useState5,2),selectedPartners=_React$useState6[0],setSelectedPartners=_React$useState6[1];var _React$useState7=__WEBPACK_IMPORTED_MODULE_1_react___default.a.useState([]),_React$useState8=_slicedToArray(_React$useState7,2),selectedClients=_React$useState8[0],setSelectedClients=_React$useState8[1];var _React$useState9=__WEBPACK_IMPORTED_MODULE_1_react___default.a.useState(false),_React$useState10=_slicedToArray(_React$useState9,2),loadingPartners=_React$useState10[0],setLoadingPartners=_React$useState10[1];var _React$useState11=__WEBPACK_IMPORTED_MODULE_1_react___default.a.useState([]),_React$useState12=_slicedToArray(_React$useState11,2),partners=_React$useState12[0],setPartners=_React$useState12[1];var _React$useState13=__WEBPACK_IMPORTED_MODULE_1_react___default.a.useState(false),_React$useState14=_slicedToArray(_React$useState13,2),loadingClients=_React$useState14[0],setLoadingClients=_React$useState14[1];var _React$useState15=__WEBPACK_IMPORTED_MODULE_1_react___default.a.useState([]),_React$useState16=_slicedToArray(_React$useState15,2),clients=_React$useState16[0],setClients=_React$useState16[1];var _React$useState17=__WEBPACK_IMPORTED_MODULE_1_react___default.a.useState(null),_React$useState18=_slicedToArray(_React$useState17,2),newPartner=_React$useState18[0],setNewPartner=_React$useState18[1];var _React$useState19=__WEBPACK_IMPORTED_MODULE_1_react___default.a.useState(null),_React$useState20=_slicedToArray(_React$useState19,2),apiStats=_React$useState20[0],setApiStats=_React$useState20[1];__WEBPACK_IMPORTED_MODULE_1_react___default.a.useEffect(function(){},[selectedPartners]);__WEBPACK_IMPORTED_MODULE_1_react___default.a.useEffect(function(){var fetchBusinessAdmins=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:setLoadingPartners(true);_context.next=3;return props.client.query({query:GET_BUSINESS_ADMINS});case 3:response=_context.sent;setLoadingPartners(false);if(response&&response.data&&response.data.partners){setPartners(response.data.partners.map(function(partner){return{id:partner.login.id,name:partner.name+' ('+partner.login.username+')'};}));}case 6:case'end':return _context.stop();}}},_callee,this);}));return function fetchBusinessAdmins(){return _ref.apply(this,arguments);};}();fetchBusinessAdmins();},[props.client]);__WEBPACK_IMPORTED_MODULE_1_react___default.a.useEffect(function(){var fetchClients=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(id){var response,allClients;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:setLoadingClients(true);_context2.next=3;return props.client.query({query:GET_CLIENTS,variables:{id:id}});case 3:response=_context2.sent;setLoadingClients(false);if(response&&response.data&&response.data.clients){allClients=clients.concat(response.data.clients.map(function(client){return{id:client.id,name:client.name+' ('+client.login.username+')',partnerId:id};}));filterClients(allClients);}case 6:case'end':return _context2.stop();}}},_callee2,this);}));return function fetchClients(_x){return _ref2.apply(this,arguments);};}();function filterClients(allClients){var selectedPartnerIds=selectedPartners.map(function(p){return p.id;});var filteredClients=allClients.filter(function(client){return selectedPartnerIds.includes(client.partnerId);});setClients(filteredClients);var filteredClientIds=filteredClients.map(function(c){return c.id;});setSelectedClients(function(selectedClients){return selectedClients.filter(function(sc){return filteredClientIds.includes(sc.id);});});}if(newPartner){fetchClients(newPartner.id);}else{filterClients(clients);}},[props.client,selectedPartners,newPartner]);function handleSelectedPartnersChange(newSelectedPartners){if(newSelectedPartners.length<selectedPartners.length){setNewPartner(null);setSelectedPartners(newSelectedPartners);}else{var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=newSelectedPartners[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var n=_step.value;var flag=false;var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=selectedPartners[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var p=_step2.value;if(p.id===n.id){flag=true;break;}}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}if(!flag){setNewPartner(n);break;}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}setSelectedPartners(newSelectedPartners);}}var handleDelete=function handleDelete(id,type){if(type==='partner'){setSelectedPartners(function(selectedPartners){return selectedPartners.filter(function(partner){return partner.id!==id;});});}else{setSelectedClients(function(selectedClients){return selectedClients.filter(function(client){return client.id!==id;});});}};var classes=props.classes;var enableSubmit=selectedClients.length>0&&fromTime&&toTime;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Grid"],{container:true,className:classes.container,alignContent:'flex-start'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Grid"],{item:true,xs:12,className:classes.itemPadding},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Typography"],{variant:'title'},'API Dashboard')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Divider"],null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Grid"],{item:true,xs:12,className:classes.itemPadding},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{onSubmit:handleFormSubmit},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Grid"],{container:true,spacing:16,alignItems:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Grid"],{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_MultiCheckComboBox__["a" /* default */],{items:partners,itemKey:'id',itemToStringKey:'name',itemToLabelKey:'type',placeholder:'Select Business admins',isLoading:loadingPartners,filterSize:100,selectedItems:selectedPartners,onSelectedItemsChange:handleSelectedPartnersChange,searchByFields:['name']})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Grid"],{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_MultiCheckComboBox__["a" /* default */],{items:clients,itemKey:'id',itemToStringKey:'name',itemToLabelKey:'type',placeholder:'Select Clients',isLoading:loadingClients,filterSize:100,selectedItems:selectedClients,onSelectedItemsChange:setSelectedClients,searchByFields:['name'],disabled:selectedPartners.length===0})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Grid"],{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_pickers__["b" /* DateTimePicker */],{label:'From Time',value:fromTime,onChange:setFromTime,inputProps:{name:'fromTime'}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Grid"],{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_pickers__["b" /* DateTimePicker */],{label:'To Time',value:toTime,onChange:setToTime,inputProps:{name:'toTime'}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Grid"],{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Button"],{color:'primary',variant:'outlined',disabled:!enableSubmit,type:'submit'},'Submit'))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Grid"],{item:true,xs:12,container:true,style:{padding:16},spacing:16},selectedPartners.length>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Typography"],null,'Business Admins')),selectedPartners.map(function(partner){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Grid"],{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Chip"],{label:partner.name,onDelete:function onDelete(){return handleDelete(partner.id,'partner');}}));})),selectedClients.length>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Typography"],null,'Clients')),selectedClients.map(function(client){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Grid"],{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Chip"],{label:client.name,onDelete:function onDelete(){return handleDelete(client.id,'client');}}));}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Divider"],null)),apiStats&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Grid"],{item:true,xs:12,container:true,spacing:16,style:{padding:16}},!apiStats.length?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Typography"],null,'No API Stats available')):apiStats.map(function(stat){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Grid"],{item:true,xs:12,sm:6,md:4,lg:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Paper"],{style:{padding:8}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Grid"],{container:true,spacing:8},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Typography"],{align:'right',style:{color:stat.apiType==='query'?'#b52253':stat.apiType==='mutation'?'#296994':'#759c1c'}},stat.apiType)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Typography"],{align:'center',variant:'subheading'},stat.apiName)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Typography"],{align:'center',variant:'title'},stat.apiCount)))));})));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_3_react_apollo__["withApollo"])(APIDashboard)));

/***/ }),
/* 2429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MultiCheckComboBox_jsx__ = __webpack_require__(2430);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__MultiCheckComboBox_jsx__["a"]; });


/***/ }),
/* 2430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_downshift__ = __webpack_require__(2431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Search__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core__ = __webpack_require__(15);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}/**
 * @module MultiCheckComboBox
 * @summary This module exports the MultiCheckComboBox
 */var style=function style(theme){return{inputRoot:{width:theme.spacing.unit*30},chipRoot:{backgroundColor:'#f5f5f5',fontSize:'0.6rem',height:'auto'},searchDropdown:{position:'absolute',marginTop:theme.spacing.unit,left:0,right:0,zIndex:2,maxHeight:theme.spacing.unit*25,overflowY:'auto'},comboboxContainer:{position:'relative'},errorMessage:{textAlign:'center',padding:theme.spacing.unit}};};/**
 * Renders the Input component of Combobox
 * @param {Object} props Props passed to the Input component of Combobox
 */function renderInput(inputProps){var InputProps=inputProps.InputProps,classes=inputProps.classes,disabled=inputProps.disabled,ref=inputProps.ref,other=_objectWithoutProperties(inputProps,['InputProps','classes','disabled','ref']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Input"],Object.assign({disabled:disabled,inputRef:ref,classes:{root:classes.inputRoot}},InputProps,other));}renderInput.propTypes={InputProps:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,ref:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired/**
 * Renders each item in the dropdown
 * @param {Object} props Props passed to the individual dropdown item
 */};function renderDropdownItem(_ref){var item=_ref.item,itemProps=_ref.itemProps,selectedItems=_ref.selectedItems,itemToStringKey=_ref.itemToStringKey,itemKey=_ref.itemKey;var isSelected=Boolean(selectedItems.find(function(a){return a[itemKey]===item[itemKey];}));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["MenuItem"],Object.assign({},itemProps,{key:item[itemKey],selected:isSelected,component:'div',title:item[itemToStringKey]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Checkbox"],{checked:isSelected,color:'primary'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontWeight:isSelected?500:400,display:'block',textOverflow:'ellipsis',whiteSpace:'nowrap',overflow:'hidden'}},item[itemToStringKey]));}renderDropdownItem.propTypes={itemProps:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,itemToStringKey:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,itemKey:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,selectedItems:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,item:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired/**
 * Filter most relevant items
 * @param {Array} items The array of items to be filtered
 * @param {String} inputValue The value entered in the input against which items are to be filtered
 * @param {String} itemToStringKey The key of the object to be used to filter items
 * @param {number} filterSize The max size of filtered items to show
 * @returns {Array} Filtered array of items
 */};function getFilteredItems(items,inputValue,searchByFields,filterSize){if(!inputValue)return items.slice(0,50);var count=0;var filteredItems=[];var finder=function finder(item){var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=searchByFields[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var field=_step.value;if(item[field].toLowerCase().includes(inputValue.toLowerCase())){filteredItems.push(item);return true;}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return false;};var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=items[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var item=_step2.value;if(inputValue&&count<filterSize){if(finder(item)){count++;}}}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}return filteredItems;}/**
 * @summary MultiCheckComboBox component is a re-usable component for rendering searchable dropdown
 * with multi-select and check box
 */var MultiCheckComboBox=function(_Component){_inherits(MultiCheckComboBox,_Component);function MultiCheckComboBox(){var _ref2;var _temp,_this,_ret;_classCallCheck(this,MultiCheckComboBox);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref2=MultiCheckComboBox.__proto__||Object.getPrototypeOf(MultiCheckComboBox)).call.apply(_ref2,[this].concat(args))),_this),_this.handleSelectionChange=function(selectedItem){var action='ADD';var itemIndex=-1;for(var i in _this.props.selectedItems){if(selectedItem[_this.props.itemKey]===_this.props.selectedItems[i][_this.props.itemKey]){action='REMOVE';itemIndex=i;break;}}var items=void 0;if(action==='ADD'){items=[selectedItem].concat(_toConsumableArray(_this.props.selectedItems));}else{items=[].concat(_toConsumableArray(_this.props.selectedItems));items.splice(itemIndex,1);}_this.props.onSelectedItemsChange(items);},_this.stateReducer=function(state,changes){// this prevents the menu from being closed when the user
// selects an item with a keyboard or mouse
switch(changes.type){case __WEBPACK_IMPORTED_MODULE_2_downshift__["a" /* default */].stateChangeTypes.keyDownEnter:case __WEBPACK_IMPORTED_MODULE_2_downshift__["a" /* default */].stateChangeTypes.clickItem:return Object.assign({},changes,{isOpen:state.isOpen,highlightedIndex:state.highlightedIndex});default:return changes;}},_temp),_possibleConstructorReturn(_this,_ret);}/**
   * @function
   * @param {object} selectedItem The item that is selected
   * @summary Handles selction/de-selection of an item in the ComboBox
   *//**
   * @function
   * @param {object} state The state of the Downshift component
   * @param {object} changes The object describing the type of change on the state
   * @summary A reducer to change the state of Downshift component based on changes
   */_createClass(MultiCheckComboBox,[{key:'render',value:function render(){var _props=this.props,classes=_props.classes,items=_props.items,placeholder=_props.placeholder,searchByFields=_props.searchByFields,isLoading=_props.isLoading,disabled=_props.disabled,loadingComponent=_props.loadingComponent,errorComponent=_props.errorComponent,itemKey=_props.itemKey,itemToStringKey=_props.itemToStringKey,filterSize=_props.filterSize;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_downshift__["a" /* default */],{onChange:this.handleSelectionChange,selectedItem:this.props.selectedItems,itemToString:function itemToString(item){return'';},stateReducer:this.stateReducer},function(_ref3){var getInputProps=_ref3.getInputProps,getItemProps=_ref3.getItemProps,isOpen=_ref3.isOpen,inputValue=_ref3.inputValue,openMenu=_ref3.openMenu,selectedItems=_ref3.selectedItem;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.comboboxContainer},renderInput({disabled:disabled,classes:classes,InputProps:getInputProps({placeholder:placeholder,onFocus:function onFocus(){openMenu();},startAdornment:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["InputAdornment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Search___default.a,null))})}),isOpen?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Paper"],{className:classes.searchDropdown,square:true},items.length>0?getFilteredItems(items,inputValue,searchByFields,filterSize).map(function(item){return renderDropdownItem({item:item,itemProps:getItemProps({item:item}),selectedItems:selectedItems,itemKey:itemKey,itemToStringKey:itemToStringKey});}):isLoading?loadingComponent:errorComponent):null);});}}]);return MultiCheckComboBox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);MultiCheckComboBox.propTypes={items:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,selectedItems:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,onSelectedItemsChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,searchByFields:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string).isRequired,isLoading:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,itemKey:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,itemToStringKey:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,placeholder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,loadingComponent:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,errorComponent:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,filterSize:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};MultiCheckComboBox.defaultProps={placeholder:'Search',loadingComponent:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Typography"],null,'Loading ...'),errorComponent:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["Typography"],null,'Something went wrong. Try again!'),disabled:false,filterSize:5};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_core__["withStyles"])(style)(MultiCheckComboBox));

/***/ }),
/* 2431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export resetIdCounter */
/* unused harmony export useSelect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(2432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(2433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(2434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(2435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_is__ = __webpack_require__(2437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_compute_scroll_into_view__ = __webpack_require__(2439);









var idCounter = 0;
/**
 * Accepts a parameter and returns it if it's a function
 * or a noop function if it's not. This allows us to
 * accept a callback, but not worry about it if it's not
 * passed.
 * @param {Function} cb the callback
 * @return {Function} a function
 */

function cbToCb(cb) {
  return typeof cb === 'function' ? cb : noop;
}

function noop() {}
/**
 * Scroll node into view if necessary
 * @param {HTMLElement} node the element that should scroll into view
 * @param {HTMLElement} menuNode the menu element of the component
 */


function scrollIntoView(node, menuNode) {
  if (node === null) {
    return;
  }

  var actions = Object(__WEBPACK_IMPORTED_MODULE_7_compute_scroll_into_view__["a" /* default */])(node, {
    boundary: menuNode,
    block: 'nearest',
    scrollMode: 'if-needed'
  });
  actions.forEach(function (_ref) {
    var el = _ref.el,
        top = _ref.top,
        left = _ref.left;
    el.scrollTop = top;
    el.scrollLeft = left;
  });
}
/**
 * @param {HTMLElement} parent the parent node
 * @param {HTMLElement} child the child node
 * @return {Boolean} whether the parent is the child or the child is in the parent
 */


function isOrContainsNode(parent, child) {
  return parent === child || parent.contains && parent.contains(child);
}
/**
 * Simple debounce implementation. Will call the given
 * function once after the time given has passed since
 * it was last called.
 * @param {Function} fn the function to call after the time
 * @param {Number} time the time to wait
 * @return {Function} the debounced function
 */


function debounce(fn, time) {
  var timeoutId;

  function cancel() {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  }

  function wrapper() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    cancel();
    timeoutId = setTimeout(function () {
      timeoutId = null;
      fn.apply(void 0, args);
    }, time);
  }

  wrapper.cancel = cancel;
  return wrapper;
}
/**
 * This is intended to be used to compose event handlers.
 * They are executed in order until one of them sets
 * `event.preventDownshiftDefault = true`.
 * @param {...Function} fns the event handler functions
 * @return {Function} the event handler to add to an element
 */


function callAllEventHandlers() {
  for (var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }

  return function (event) {
    for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }

    return fns.some(function (fn) {
      if (fn) {
        fn.apply(void 0, [event].concat(args));
      }

      return event.preventDownshiftDefault || event.hasOwnProperty('nativeEvent') && event.nativeEvent.preventDownshiftDefault;
    });
  };
}

function handleRefs() {
  for (var _len4 = arguments.length, refs = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    refs[_key4] = arguments[_key4];
  }

  return function (node) {
    refs.forEach(function (ref) {
      if (typeof ref === 'function') {
        ref(node);
      } else if (ref) {
        ref.current = node;
      }
    });
  };
}
/**
 * This generates a unique ID for an instance of Downshift
 * @return {String} the unique ID
 */


function generateId() {
  return String(idCounter++);
}
/**
 * Resets idCounter to 0. Used for SSR.
 */


function resetIdCounter() {
  idCounter = 0;
}
/**
 * @param {Object} param the downshift state and other relevant properties
 * @return {String} the a11y status message
 */


function getA11yStatusMessage(_ref2) {
  var isOpen = _ref2.isOpen,
      selectedItem = _ref2.selectedItem,
      resultCount = _ref2.resultCount,
      previousResultCount = _ref2.previousResultCount,
      itemToString = _ref2.itemToString;

  if (!isOpen) {
    return selectedItem ? itemToString(selectedItem) : '';
  }

  if (!resultCount) {
    return 'No results are available.';
  }

  if (resultCount !== previousResultCount) {
    return resultCount + " result" + (resultCount === 1 ? ' is' : 's are') + " available, use up and down arrow keys to navigate. Press Enter key to select.";
  }

  return '';
}
/**
 * Takes an argument and if it's an array, returns the first item in the array
 * otherwise returns the argument
 * @param {*} arg the maybe-array
 * @param {*} defaultValue the value if arg is falsey not defined
 * @return {*} the arg or it's first item
 */


function unwrapArray(arg, defaultValue) {
  arg = Array.isArray(arg) ?
  /* istanbul ignore next (preact) */
  arg[0] : arg;

  if (!arg && defaultValue) {
    return defaultValue;
  } else {
    return arg;
  }
}
/**
 * @param {Object} element (P)react element
 * @return {Boolean} whether it's a DOM element
 */


function isDOMElement(element) {
  // then we assume this is react
  return typeof element.type === 'string';
}
/**
 * @param {Object} element (P)react element
 * @return {Object} the props
 */


function getElementProps(element) {
  return element.props;
}
/**
 * Throws a helpful error message for required properties. Useful
 * to be used as a default in destructuring or object params.
 * @param {String} fnName the function name
 * @param {String} propName the prop name
 */


function requiredProp(fnName, propName) {
  // eslint-disable-next-line no-console
  console.error("The property \"" + propName + "\" is required in \"" + fnName + "\"");
}

var stateKeys = ['highlightedIndex', 'inputValue', 'isOpen', 'selectedItem', 'type'];
/**
 * @param {Object} state the state object
 * @return {Object} state that is relevant to downshift
 */

function pickState(state) {
  if (state === void 0) {
    state = {};
  }

  var result = {};
  stateKeys.forEach(function (k) {
    if (state.hasOwnProperty(k)) {
      result[k] = state[k];
    }
  });
  return result;
}
/**
 * Normalizes the 'key' property of a KeyboardEvent in IE/Edge
 * @param {Object} event a keyboardEvent object
 * @return {String} keyboard key
 */


function normalizeArrowKey(event) {
  var key = event.key,
      keyCode = event.keyCode;
  /* istanbul ignore next (ie) */

  if (keyCode >= 37 && keyCode <= 40 && key.indexOf('Arrow') !== 0) {
    return "Arrow" + key;
  }

  return key;
}
/**
 * Simple check if the value passed is object literal
 * @param {*} obj any things
 * @return {Boolean} whether it's object literal
 */


function isPlainObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
}
/**
 * Returns the new index in the list, in a circular way. If next value is out of bonds from the total,
 * it will wrap to either 0 or itemCount - 1.
 *
 * @param {number} moveAmount Number of positions to move. Negative to move backwards, positive forwards.
 * @param {number} baseIndex The initial position to move from.
 * @param {number} itemCount The total number of items.
 * @returns {number} The new index after the move.
 */


function getNextWrappingIndex(moveAmount, baseIndex, itemCount) {
  var itemsLastIndex = itemCount - 1;

  if (typeof baseIndex !== 'number' || baseIndex < 0 || baseIndex >= itemCount) {
    baseIndex = moveAmount > 0 ? -1 : itemsLastIndex + 1;
  }

  var newIndex = baseIndex + moveAmount;

  if (newIndex < 0) {
    newIndex = itemsLastIndex;
  } else if (newIndex > itemsLastIndex) {
    newIndex = 0;
  }

  return newIndex;
}

var cleanupStatus = debounce(function () {
  getStatusDiv().textContent = '';
}, 500);
/**
 * @param {String} status the status message
 * @param {Object} documentProp document passed by the user.
 */

function setStatus(status, documentProp) {
  var div = getStatusDiv(documentProp);

  if (!status) {
    return;
  }

  div.textContent = status;
  cleanupStatus();
}
/**
 * Get the status node or create it if it does not already exist.
 * @param {Object} documentProp document passed by the user.
 * @return {HTMLElement} the status node.
 */


function getStatusDiv(documentProp) {
  if (documentProp === void 0) {
    documentProp = document;
  }

  var statusDiv = documentProp.getElementById('a11y-status-message');

  if (statusDiv) {
    return statusDiv;
  }

  statusDiv = documentProp.createElement('div');
  statusDiv.setAttribute('id', 'a11y-status-message');
  statusDiv.setAttribute('role', 'status');
  statusDiv.setAttribute('aria-live', 'polite');
  statusDiv.setAttribute('aria-relevant', 'additions text');
  Object.assign(statusDiv.style, {
    border: '0',
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: '0',
    position: 'absolute',
    width: '1px'
  });
  documentProp.body.appendChild(statusDiv);
  return statusDiv;
}

var unknown =  false ? '__autocomplete_unknown__' : 0;
var mouseUp =  false ? '__autocomplete_mouseup__' : 1;
var itemMouseEnter =  false ? '__autocomplete_item_mouseenter__' : 2;
var keyDownArrowUp =  false ? '__autocomplete_keydown_arrow_up__' : 3;
var keyDownArrowDown =  false ? '__autocomplete_keydown_arrow_down__' : 4;
var keyDownEscape =  false ? '__autocomplete_keydown_escape__' : 5;
var keyDownEnter =  false ? '__autocomplete_keydown_enter__' : 6;
var keyDownHome =  false ? '__autocomplete_keydown_home__' : 7;
var keyDownEnd =  false ? '__autocomplete_keydown_end__' : 8;
var clickItem =  false ? '__autocomplete_click_item__' : 9;
var blurInput =  false ? '__autocomplete_blur_input__' : 10;
var changeInput =  false ? '__autocomplete_change_input__' : 11;
var keyDownSpaceButton =  false ? '__autocomplete_keydown_space_button__' : 12;
var clickButton =  false ? '__autocomplete_click_button__' : 13;
var blurButton =  false ? '__autocomplete_blur_button__' : 14;
var controlledPropUpdatedSelectedItem =  false ? '__autocomplete_controlled_prop_updated_selected_item__' : 15;
var touchEnd =  false ? '__autocomplete_touchend__' : 16;

var stateChangeTypes = /*#__PURE__*/Object.freeze({
  __proto__: null,
  unknown: unknown,
  mouseUp: mouseUp,
  itemMouseEnter: itemMouseEnter,
  keyDownArrowUp: keyDownArrowUp,
  keyDownArrowDown: keyDownArrowDown,
  keyDownEscape: keyDownEscape,
  keyDownEnter: keyDownEnter,
  keyDownHome: keyDownHome,
  keyDownEnd: keyDownEnd,
  clickItem: clickItem,
  blurInput: blurInput,
  changeInput: changeInput,
  keyDownSpaceButton: keyDownSpaceButton,
  clickButton: clickButton,
  blurButton: blurButton,
  controlledPropUpdatedSelectedItem: controlledPropUpdatedSelectedItem,
  touchEnd: touchEnd
});

var Downshift =
/*#__PURE__*/
function () {
  var Downshift =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Downshift, _Component);

    function Downshift(_props) {
      var _this = _Component.call(this, _props) || this;

      _this.id = _this.props.id || "downshift-" + generateId();
      _this.menuId = _this.props.menuId || _this.id + "-menu";
      _this.labelId = _this.props.labelId || _this.id + "-label";
      _this.inputId = _this.props.inputId || _this.id + "-input";

      _this.getItemId = _this.props.getItemId || function (index) {
        return _this.id + "-item-" + index;
      };

      _this.input = null;
      _this.items = [];
      _this.itemCount = null;
      _this.previousResultCount = 0;
      _this.timeoutIds = [];

      _this.internalSetTimeout = function (fn, time) {
        var id = setTimeout(function () {
          _this.timeoutIds = _this.timeoutIds.filter(function (i) {
            return i !== id;
          });
          fn();
        }, time);

        _this.timeoutIds.push(id);
      };

      _this.setItemCount = function (count) {
        _this.itemCount = count;
      };

      _this.unsetItemCount = function () {
        _this.itemCount = null;
      };

      _this.setHighlightedIndex = function (highlightedIndex, otherStateToSet) {
        if (highlightedIndex === void 0) {
          highlightedIndex = _this.props.defaultHighlightedIndex;
        }

        if (otherStateToSet === void 0) {
          otherStateToSet = {};
        }

        otherStateToSet = pickState(otherStateToSet);

        _this.internalSetState(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
          highlightedIndex: highlightedIndex
        }, otherStateToSet));
      };

      _this.clearSelection = function (cb) {
        _this.internalSetState({
          selectedItem: null,
          inputValue: '',
          highlightedIndex: _this.props.defaultHighlightedIndex,
          isOpen: _this.props.defaultIsOpen
        }, cb);
      };

      _this.selectItem = function (item, otherStateToSet, cb) {
        otherStateToSet = pickState(otherStateToSet);

        _this.internalSetState(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
          isOpen: _this.props.defaultIsOpen,
          highlightedIndex: _this.props.defaultHighlightedIndex,
          selectedItem: item,
          inputValue: _this.props.itemToString(item)
        }, otherStateToSet), cb);
      };

      _this.selectItemAtIndex = function (itemIndex, otherStateToSet, cb) {
        var item = _this.items[itemIndex];

        if (item == null) {
          return;
        }

        _this.selectItem(item, otherStateToSet, cb);
      };

      _this.selectHighlightedItem = function (otherStateToSet, cb) {
        return _this.selectItemAtIndex(_this.getState().highlightedIndex, otherStateToSet, cb);
      };

      _this.internalSetState = function (stateToSet, cb) {
        var isItemSelected, onChangeArg;
        var onStateChangeArg = {};
        var isStateToSetFunction = typeof stateToSet === 'function'; // we want to call `onInputValueChange` before the `setState` call
        // so someone controlling the `inputValue` state gets notified of
        // the input change as soon as possible. This avoids issues with
        // preserving the cursor position.
        // See https://github.com/downshift-js/downshift/issues/217 for more info.

        if (!isStateToSetFunction && stateToSet.hasOwnProperty('inputValue')) {
          _this.props.onInputValueChange(stateToSet.inputValue, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _this.getStateAndHelpers(), {}, stateToSet));
        }

        return _this.setState(function (state) {
          state = _this.getState(state);
          var newStateToSet = isStateToSetFunction ? stateToSet(state) : stateToSet; // Your own function that could modify the state that will be set.

          newStateToSet = _this.props.stateReducer(state, newStateToSet); // checks if an item is selected, regardless of if it's different from
          // what was selected before
          // used to determine if onSelect and onChange callbacks should be called

          isItemSelected = newStateToSet.hasOwnProperty('selectedItem'); // this keeps track of the object we want to call with setState

          var nextState = {}; // this is just used to tell whether the state changed

          var nextFullState = {}; // we need to call on change if the outside world is controlling any of our state
          // and we're trying to update that state. OR if the selection has changed and we're
          // trying to update the selection

          if (isItemSelected && newStateToSet.selectedItem !== state.selectedItem) {
            onChangeArg = newStateToSet.selectedItem;
          }

          newStateToSet.type = newStateToSet.type || unknown;
          Object.keys(newStateToSet).forEach(function (key) {
            // onStateChangeArg should only have the state that is
            // actually changing
            if (state[key] !== newStateToSet[key]) {
              onStateChangeArg[key] = newStateToSet[key];
            } // the type is useful for the onStateChangeArg
            // but we don't actually want to set it in internal state.
            // this is an undocumented feature for now... Not all internalSetState
            // calls support it and I'm not certain we want them to yet.
            // But it enables users controlling the isOpen state to know when
            // the isOpen state changes due to mouseup events which is quite handy.


            if (key === 'type') {
              return;
            }

            nextFullState[key] = newStateToSet[key]; // if it's coming from props, then we don't care to set it internally

            if (!_this.isControlledProp(key)) {
              nextState[key] = newStateToSet[key];
            }
          }); // if stateToSet is a function, then we weren't able to call onInputValueChange
          // earlier, so we'll call it now that we know what the inputValue state will be.

          if (isStateToSetFunction && newStateToSet.hasOwnProperty('inputValue')) {
            _this.props.onInputValueChange(newStateToSet.inputValue, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _this.getStateAndHelpers(), {}, newStateToSet));
          }

          return nextState;
        }, function () {
          // call the provided callback if it's a function
          cbToCb(cb)(); // only call the onStateChange and onChange callbacks if
          // we have relevant information to pass them.

          var hasMoreStateThanType = Object.keys(onStateChangeArg).length > 1;

          if (hasMoreStateThanType) {
            _this.props.onStateChange(onStateChangeArg, _this.getStateAndHelpers());
          }

          if (isItemSelected) {
            _this.props.onSelect(stateToSet.selectedItem, _this.getStateAndHelpers());
          }

          if (onChangeArg !== undefined) {
            _this.props.onChange(onChangeArg, _this.getStateAndHelpers());
          } // this is currently undocumented and therefore subject to change
          // We'll try to not break it, but just be warned.


          _this.props.onUserAction(onStateChangeArg, _this.getStateAndHelpers());
        });
      };

      _this.rootRef = function (node) {
        return _this._rootNode = node;
      };

      _this.getRootProps = function (_temp, _temp2) {
        var _extends2;

        var _ref = _temp === void 0 ? {} : _temp,
            _ref$refKey = _ref.refKey,
            refKey = _ref$refKey === void 0 ? 'ref' : _ref$refKey,
            ref = _ref.ref,
            rest = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["refKey", "ref"]);

        var _ref2 = _temp2 === void 0 ? {} : _temp2,
            _ref2$suppressRefErro = _ref2.suppressRefError,
            suppressRefError = _ref2$suppressRefErro === void 0 ? false : _ref2$suppressRefErro;

        // this is used in the render to know whether the user has called getRootProps.
        // It uses that to know whether to apply the props automatically
        _this.getRootProps.called = true;
        _this.getRootProps.refKey = refKey;
        _this.getRootProps.suppressRefError = suppressRefError;

        var _this$getState = _this.getState(),
            isOpen = _this$getState.isOpen;

        return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])((_extends2 = {}, _extends2[refKey] = handleRefs(ref, _this.rootRef), _extends2.role = 'combobox', _extends2['aria-expanded'] = isOpen, _extends2['aria-haspopup'] = 'listbox', _extends2['aria-owns'] = isOpen ? _this.menuId : null, _extends2['aria-labelledby'] = _this.labelId, _extends2), rest);
      };

      _this.keyDownHandlers = {
        ArrowDown: function ArrowDown(event) {
          var _this2 = this;

          event.preventDefault();

          if (this.getState().isOpen) {
            var amount = event.shiftKey ? 5 : 1;
            this.moveHighlightedIndex(amount, {
              type: keyDownArrowDown
            });
          } else {
            this.internalSetState({
              isOpen: true,
              type: keyDownArrowDown
            }, function () {
              var itemCount = _this2.getItemCount();

              if (itemCount > 0) {
                _this2.setHighlightedIndex(getNextWrappingIndex(1, _this2.getState().highlightedIndex, itemCount), {
                  type: keyDownArrowDown
                });
              }
            });
          }
        },
        ArrowUp: function ArrowUp(event) {
          var _this3 = this;

          event.preventDefault();

          if (this.getState().isOpen) {
            var amount = event.shiftKey ? -5 : -1;
            this.moveHighlightedIndex(amount, {
              type: keyDownArrowUp
            });
          } else {
            this.internalSetState({
              isOpen: true,
              type: keyDownArrowUp
            }, function () {
              var itemCount = _this3.getItemCount();

              if (itemCount > 0) {
                _this3.setHighlightedIndex(getNextWrappingIndex(-1, _this3.getState().highlightedIndex, itemCount), {
                  type: keyDownArrowDown
                });
              }
            });
          }
        },
        Enter: function Enter(event) {
          var _this$getState2 = this.getState(),
              isOpen = _this$getState2.isOpen,
              highlightedIndex = _this$getState2.highlightedIndex;

          if (isOpen && highlightedIndex != null) {
            event.preventDefault();
            var item = this.items[highlightedIndex];
            var itemNode = this.getItemNodeFromIndex(highlightedIndex);

            if (item == null || itemNode && itemNode.hasAttribute('disabled')) {
              return;
            }

            this.selectHighlightedItem({
              type: keyDownEnter
            });
          }
        },
        Escape: function Escape(event) {
          event.preventDefault();
          this.reset({
            type: keyDownEscape,
            selectedItem: null,
            inputValue: ''
          });
        }
      };
      _this.buttonKeyDownHandlers = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _this.keyDownHandlers, {
        ' ': function _(event) {
          event.preventDefault();
          this.toggleMenu({
            type: keyDownSpaceButton
          });
        }
      });
      _this.inputKeyDownHandlers = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _this.keyDownHandlers, {
        Home: function Home(event) {
          this.highlightFirstOrLastIndex(event, true, {
            type: keyDownHome
          });
        },
        End: function End(event) {
          this.highlightFirstOrLastIndex(event, false, {
            type: keyDownEnd
          });
        }
      });

      _this.getToggleButtonProps = function (_temp3) {
        var _ref3 = _temp3 === void 0 ? {} : _temp3,
            onClick = _ref3.onClick,
            onPress = _ref3.onPress,
            onKeyDown = _ref3.onKeyDown,
            onKeyUp = _ref3.onKeyUp,
            onBlur = _ref3.onBlur,
            rest = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["onClick", "onPress", "onKeyDown", "onKeyUp", "onBlur"]);

        var _this$getState3 = _this.getState(),
            isOpen = _this$getState3.isOpen;

        var enabledEventHandlers = {
          onClick: callAllEventHandlers(onClick, _this.buttonHandleClick),
          onKeyDown: callAllEventHandlers(onKeyDown, _this.buttonHandleKeyDown),
          onKeyUp: callAllEventHandlers(onKeyUp, _this.buttonHandleKeyUp),
          onBlur: callAllEventHandlers(onBlur, _this.buttonHandleBlur)
        };
        var eventHandlers = rest.disabled ? {} : enabledEventHandlers;
        return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
          type: 'button',
          role: 'button',
          'aria-label': isOpen ? 'close menu' : 'open menu',
          'aria-haspopup': true,
          'data-toggle': true
        }, eventHandlers, {}, rest);
      };

      _this.buttonHandleKeyUp = function (event) {
        // Prevent click event from emitting in Firefox
        event.preventDefault();
      };

      _this.buttonHandleKeyDown = function (event) {
        var key = normalizeArrowKey(event);

        if (_this.buttonKeyDownHandlers[key]) {
          _this.buttonKeyDownHandlers[key].call(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), event);
        }
      };

      _this.buttonHandleClick = function (event) {
        event.preventDefault(); // handle odd case for Safari and Firefox which
        // don't give the button the focus properly.

        /* istanbul ignore if (can't reasonably test this) */

        if ( _this.props.environment.document.activeElement === _this.props.environment.document.body) {
          event.target.focus();
        } // to simplify testing components that use downshift, we'll not wrap this in a setTimeout
        // if the NODE_ENV is test. With the proper build system, this should be dead code eliminated
        // when building for production and should therefore have no impact on production code.


        if (false) {
          _this.toggleMenu({
            type: clickButton
          });
        } else {
          // Ensure that toggle of menu occurs after the potential blur event in iOS
          _this.internalSetTimeout(function () {
            return _this.toggleMenu({
              type: clickButton
            });
          });
        }
      };

      _this.buttonHandleBlur = function (event) {
        var blurTarget = event.target; // Save blur target for comparison with activeElement later
        // Need setTimeout, so that when the user presses Tab, the activeElement is the next focused element, not body element

        _this.internalSetTimeout(function () {
          if (!_this.isMouseDown && (_this.props.environment.document.activeElement == null || _this.props.environment.document.activeElement.id !== _this.inputId) && _this.props.environment.document.activeElement !== blurTarget // Do nothing if we refocus the same element again (to solve issue in Safari on iOS)
          ) {
              _this.reset({
                type: blurButton
              });
            }
        });
      };

      _this.getLabelProps = function (props) {
        return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
          htmlFor: _this.inputId,
          id: _this.labelId
        }, props);
      };

      _this.getInputProps = function (_temp4) {
        var _ref4 = _temp4 === void 0 ? {} : _temp4,
            onKeyDown = _ref4.onKeyDown,
            onBlur = _ref4.onBlur,
            onChange = _ref4.onChange,
            onInput = _ref4.onInput,
            onChangeText = _ref4.onChangeText,
            rest = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref4, ["onKeyDown", "onBlur", "onChange", "onInput", "onChangeText"]);

        var onChangeKey;
        var eventHandlers = {};
        /* istanbul ignore next (preact) */

        onChangeKey = 'onChange';

        var _this$getState4 = _this.getState(),
            inputValue = _this$getState4.inputValue,
            isOpen = _this$getState4.isOpen,
            highlightedIndex = _this$getState4.highlightedIndex;

        if (!rest.disabled) {
          var _eventHandlers;

          eventHandlers = (_eventHandlers = {}, _eventHandlers[onChangeKey] = callAllEventHandlers(onChange, onInput, _this.inputHandleChange), _eventHandlers.onKeyDown = callAllEventHandlers(onKeyDown, _this.inputHandleKeyDown), _eventHandlers.onBlur = callAllEventHandlers(onBlur, _this.inputHandleBlur), _eventHandlers);
        }
        /* istanbul ignore if (react-native) */


        return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
          'aria-autocomplete': 'list',
          'aria-activedescendant': isOpen && typeof highlightedIndex === 'number' && highlightedIndex >= 0 ? _this.getItemId(highlightedIndex) : null,
          'aria-controls': isOpen ? _this.menuId : null,
          'aria-labelledby': _this.labelId,
          // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
          // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
          autoComplete: 'off',
          value: inputValue,
          id: _this.inputId
        }, eventHandlers, {}, rest);
      };

      _this.inputHandleKeyDown = function (event) {
        var key = normalizeArrowKey(event);

        if (key && _this.inputKeyDownHandlers[key]) {
          _this.inputKeyDownHandlers[key].call(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), event);
        }
      };

      _this.inputHandleChange = function (event) {
        _this.internalSetState({
          type: changeInput,
          isOpen: true,
          inputValue: event.target.value,
          highlightedIndex: _this.props.defaultHighlightedIndex
        });
      };

      _this.inputHandleBlur = function () {
        // Need setTimeout, so that when the user presses Tab, the activeElement is the next focused element, not the body element
        _this.internalSetTimeout(function () {
          var downshiftButtonIsActive = _this.props.environment.document && !!_this.props.environment.document.activeElement && !!_this.props.environment.document.activeElement.dataset && _this.props.environment.document.activeElement.dataset.toggle && _this._rootNode && _this._rootNode.contains(_this.props.environment.document.activeElement);

          if (!_this.isMouseDown && !downshiftButtonIsActive) {
            _this.reset({
              type: blurInput
            });
          }
        });
      };

      _this.menuRef = function (node) {
        _this._menuNode = node;
      };

      _this.getMenuProps = function (_temp5, _temp6) {
        var _extends3;

        var _ref5 = _temp5 === void 0 ? {} : _temp5,
            _ref5$refKey = _ref5.refKey,
            refKey = _ref5$refKey === void 0 ? 'ref' : _ref5$refKey,
            ref = _ref5.ref,
            props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref5, ["refKey", "ref"]);

        var _ref6 = _temp6 === void 0 ? {} : _temp6,
            _ref6$suppressRefErro = _ref6.suppressRefError,
            suppressRefError = _ref6$suppressRefErro === void 0 ? false : _ref6$suppressRefErro;

        _this.getMenuProps.called = true;
        _this.getMenuProps.refKey = refKey;
        _this.getMenuProps.suppressRefError = suppressRefError;
        return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])((_extends3 = {}, _extends3[refKey] = handleRefs(ref, _this.menuRef), _extends3.role = 'listbox', _extends3['aria-labelledby'] = props && props['aria-label'] ? null : _this.labelId, _extends3.id = _this.menuId, _extends3), props);
      };

      _this.getItemProps = function (_temp7) {
        var _enabledEventHandlers;

        var _ref7 = _temp7 === void 0 ? {} : _temp7,
            onMouseMove = _ref7.onMouseMove,
            onMouseDown = _ref7.onMouseDown,
            onClick = _ref7.onClick,
            onPress = _ref7.onPress,
            index = _ref7.index,
            _ref7$item = _ref7.item,
            item = _ref7$item === void 0 ?  true ?
        /* istanbul ignore next */
        undefined : requiredProp('getItemProps', 'item') : _ref7$item,
            rest = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref7, ["onMouseMove", "onMouseDown", "onClick", "onPress", "index", "item"]);

        if (index === undefined) {
          _this.items.push(item);

          index = _this.items.indexOf(item);
        } else {
          _this.items[index] = item;
        }

        var onSelectKey = 'onClick';
        var customClickHandler = onClick;
        var enabledEventHandlers = (_enabledEventHandlers = {
          // onMouseMove is used over onMouseEnter here. onMouseMove
          // is only triggered on actual mouse movement while onMouseEnter
          // can fire on DOM changes, interrupting keyboard navigation
          onMouseMove: callAllEventHandlers(onMouseMove, function () {
            if (index === _this.getState().highlightedIndex) {
              return;
            }

            _this.setHighlightedIndex(index, {
              type: itemMouseEnter
            }); // We never want to manually scroll when changing state based
            // on `onMouseMove` because we will be moving the element out
            // from under the user which is currently scrolling/moving the
            // cursor


            _this.avoidScrolling = true;

            _this.internalSetTimeout(function () {
              return _this.avoidScrolling = false;
            }, 250);
          }),
          onMouseDown: callAllEventHandlers(onMouseDown, function (event) {
            // This prevents the activeElement from being changed
            // to the item so it can remain with the current activeElement
            // which is a more common use case.
            event.preventDefault();
          })
        }, _enabledEventHandlers[onSelectKey] = callAllEventHandlers(customClickHandler, function () {
          _this.selectItemAtIndex(index, {
            type: clickItem
          });
        }), _enabledEventHandlers); // Passing down the onMouseDown handler to prevent redirect
        // of the activeElement if clicking on disabled items

        var eventHandlers = rest.disabled ? {
          onMouseDown: enabledEventHandlers.onMouseDown
        } : enabledEventHandlers;
        return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
          id: _this.getItemId(index),
          role: 'option',
          'aria-selected': _this.getState().highlightedIndex === index
        }, eventHandlers, {}, rest);
      };

      _this.clearItems = function () {
        _this.items = [];
      };

      _this.reset = function (otherStateToSet, cb) {
        if (otherStateToSet === void 0) {
          otherStateToSet = {};
        }

        otherStateToSet = pickState(otherStateToSet);

        _this.internalSetState(function (_ref8) {
          var selectedItem = _ref8.selectedItem;
          return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
            isOpen: _this.props.defaultIsOpen,
            highlightedIndex: _this.props.defaultHighlightedIndex,
            inputValue: _this.props.itemToString(selectedItem)
          }, otherStateToSet);
        }, cb);
      };

      _this.toggleMenu = function (otherStateToSet, cb) {
        if (otherStateToSet === void 0) {
          otherStateToSet = {};
        }

        otherStateToSet = pickState(otherStateToSet);

        _this.internalSetState(function (_ref9) {
          var isOpen = _ref9.isOpen;
          return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
            isOpen: !isOpen
          }, isOpen && {
            highlightedIndex: _this.props.defaultHighlightedIndex
          }, {}, otherStateToSet);
        }, function () {
          var _this$getState5 = _this.getState(),
              isOpen = _this$getState5.isOpen,
              highlightedIndex = _this$getState5.highlightedIndex;

          if (isOpen) {
            if (_this.getItemCount() > 0 && typeof highlightedIndex === 'number') {
              _this.setHighlightedIndex(highlightedIndex, otherStateToSet);
            }
          }

          cbToCb(cb)();
        });
      };

      _this.openMenu = function (cb) {
        _this.internalSetState({
          isOpen: true
        }, cb);
      };

      _this.closeMenu = function (cb) {
        _this.internalSetState({
          isOpen: false
        }, cb);
      };

      _this.updateStatus = debounce(function () {
        var state = _this.getState();

        var item = _this.items[state.highlightedIndex];

        var resultCount = _this.getItemCount();

        var status = _this.props.getA11yStatusMessage(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
          itemToString: _this.props.itemToString,
          previousResultCount: _this.previousResultCount,
          resultCount: resultCount,
          highlightedItem: item
        }, state));

        _this.previousResultCount = resultCount;
        setStatus(status, _this.props.environment.document);
      }, 200);

      // fancy destructuring + defaults + aliases
      // this basically says each value of state should either be set to
      // the initial value or the default value if the initial value is not provided
      var _this$props = _this.props,
          defaultHighlightedIndex = _this$props.defaultHighlightedIndex,
          _this$props$initialHi = _this$props.initialHighlightedIndex,
          _highlightedIndex = _this$props$initialHi === void 0 ? defaultHighlightedIndex : _this$props$initialHi,
          defaultIsOpen = _this$props.defaultIsOpen,
          _this$props$initialIs = _this$props.initialIsOpen,
          _isOpen = _this$props$initialIs === void 0 ? defaultIsOpen : _this$props$initialIs,
          _this$props$initialIn = _this$props.initialInputValue,
          _inputValue = _this$props$initialIn === void 0 ? '' : _this$props$initialIn,
          _this$props$initialSe = _this$props.initialSelectedItem,
          _selectedItem = _this$props$initialSe === void 0 ? null : _this$props$initialSe;

      var _state = _this.getState({
        highlightedIndex: _highlightedIndex,
        isOpen: _isOpen,
        inputValue: _inputValue,
        selectedItem: _selectedItem
      });

      if (_state.selectedItem != null && _this.props.initialInputValue === undefined) {
        _state.inputValue = _this.props.itemToString(_state.selectedItem);
      }

      _this.state = _state;
      return _this;
    }

    var _proto = Downshift.prototype;

    /**
     * Clear all running timeouts
     */
    _proto.internalClearTimeouts = function internalClearTimeouts() {
      this.timeoutIds.forEach(function (id) {
        clearTimeout(id);
      });
      this.timeoutIds = [];
    }
    /**
     * Gets the state based on internal state or props
     * If a state value is passed via props, then that
     * is the value given, otherwise it's retrieved from
     * stateToMerge
     *
     * This will perform a shallow merge of the given state object
     * with the state coming from props
     * (for the controlled component scenario)
     * This is used in state updater functions so they're referencing
     * the right state regardless of where it comes from.
     *
     * @param {Object} stateToMerge defaults to this.state
     * @return {Object} the state
     */
    ;

    _proto.getState = function getState(stateToMerge) {
      var _this4 = this;

      if (stateToMerge === void 0) {
        stateToMerge = this.state;
      }

      return Object.keys(stateToMerge).reduce(function (state, key) {
        state[key] = _this4.isControlledProp(key) ? _this4.props[key] : stateToMerge[key];
        return state;
      }, {});
    }
    /**
     * This determines whether a prop is a "controlled prop" meaning it is
     * state which is controlled by the outside of this component rather
     * than within this component.
     * @param {String} key the key to check
     * @return {Boolean} whether it is a controlled controlled prop
     */
    ;

    _proto.isControlledProp = function isControlledProp(key) {
      return this.props[key] !== undefined;
    };

    _proto.getItemCount = function getItemCount() {
      // things read better this way. They're in priority order:
      // 1. `this.itemCount`
      // 2. `this.props.itemCount`
      // 3. `this.items.length`
      var itemCount = this.items.length;

      if (this.itemCount != null) {
        itemCount = this.itemCount;
      } else if (this.props.itemCount !== undefined) {
        itemCount = this.props.itemCount;
      }

      return itemCount;
    };

    _proto.getItemNodeFromIndex = function getItemNodeFromIndex(index) {
      return this.props.environment.document.getElementById(this.getItemId(index));
    };

    _proto.scrollHighlightedItemIntoView = function scrollHighlightedItemIntoView() {
      /* istanbul ignore else (react-native) */
      {
        var node = this.getItemNodeFromIndex(this.getState().highlightedIndex);
        this.props.scrollIntoView(node, this._menuNode);
      }
    };

    _proto.moveHighlightedIndex = function moveHighlightedIndex(amount, otherStateToSet) {
      var itemCount = this.getItemCount();

      if (itemCount > 0) {
        var nextHighlightedIndex = getNextWrappingIndex(amount, this.getState().highlightedIndex, itemCount);
        this.setHighlightedIndex(nextHighlightedIndex, otherStateToSet);
      }
    };

    _proto.highlightFirstOrLastIndex = function highlightFirstOrLastIndex(event, first, otherStateToSet) {
      var itemsLastIndex = this.getItemCount() - 1;

      if (itemsLastIndex < 0 || !this.getState().isOpen) {
        return;
      }

      event.preventDefault();
      this.setHighlightedIndex(first ? 0 : itemsLastIndex, otherStateToSet);
    };

    _proto.getStateAndHelpers = function getStateAndHelpers() {
      var _this$getState6 = this.getState(),
          highlightedIndex = _this$getState6.highlightedIndex,
          inputValue = _this$getState6.inputValue,
          selectedItem = _this$getState6.selectedItem,
          isOpen = _this$getState6.isOpen;

      var itemToString = this.props.itemToString;
      var id = this.id;
      var getRootProps = this.getRootProps,
          getToggleButtonProps = this.getToggleButtonProps,
          getLabelProps = this.getLabelProps,
          getMenuProps = this.getMenuProps,
          getInputProps = this.getInputProps,
          getItemProps = this.getItemProps,
          openMenu = this.openMenu,
          closeMenu = this.closeMenu,
          toggleMenu = this.toggleMenu,
          selectItem = this.selectItem,
          selectItemAtIndex = this.selectItemAtIndex,
          selectHighlightedItem = this.selectHighlightedItem,
          setHighlightedIndex = this.setHighlightedIndex,
          clearSelection = this.clearSelection,
          clearItems = this.clearItems,
          reset = this.reset,
          setItemCount = this.setItemCount,
          unsetItemCount = this.unsetItemCount,
          setState = this.internalSetState;
      return {
        // prop getters
        getRootProps: getRootProps,
        getToggleButtonProps: getToggleButtonProps,
        getLabelProps: getLabelProps,
        getMenuProps: getMenuProps,
        getInputProps: getInputProps,
        getItemProps: getItemProps,
        // actions
        reset: reset,
        openMenu: openMenu,
        closeMenu: closeMenu,
        toggleMenu: toggleMenu,
        selectItem: selectItem,
        selectItemAtIndex: selectItemAtIndex,
        selectHighlightedItem: selectHighlightedItem,
        setHighlightedIndex: setHighlightedIndex,
        clearSelection: clearSelection,
        clearItems: clearItems,
        setItemCount: setItemCount,
        unsetItemCount: unsetItemCount,
        setState: setState,
        // props
        itemToString: itemToString,
        // derived
        id: id,
        // state
        highlightedIndex: highlightedIndex,
        inputValue: inputValue,
        isOpen: isOpen,
        selectedItem: selectedItem
      };
    } //////////////////////////// ROOT
    ;

    _proto.componentDidMount = function componentDidMount() {
      var _this5 = this;

      /* istanbul ignore if (react-native) */
      if (false) {
        validateGetMenuPropsCalledCorrectly(this._menuNode, this.getMenuProps);
      }
      /* istanbul ignore if (react-native) */


      {
        var targetWithinDownshift = function (target, checkActiveElement) {
          if (checkActiveElement === void 0) {
            checkActiveElement = true;
          }

          var document = _this5.props.environment.document;
          return [_this5._rootNode, _this5._menuNode].some(function (contextNode) {
            return contextNode && (isOrContainsNode(contextNode, target) || checkActiveElement && isOrContainsNode(contextNode, document.activeElement));
          });
        }; // this.isMouseDown helps us track whether the mouse is currently held down.
        // This is useful when the user clicks on an item in the list, but holds the mouse
        // down long enough for the list to disappear (because the blur event fires on the input)
        // this.isMouseDown is used in the blur handler on the input to determine whether the blur event should
        // trigger hiding the menu.


        var onMouseDown = function () {
          _this5.isMouseDown = true;
        };

        var onMouseUp = function (event) {
          _this5.isMouseDown = false; // if the target element or the activeElement is within a downshift node
          // then we don't want to reset downshift

          var contextWithinDownshift = targetWithinDownshift(event.target);

          if (!contextWithinDownshift && _this5.getState().isOpen) {
            _this5.reset({
              type: mouseUp
            }, function () {
              return _this5.props.onOuterClick(_this5.getStateAndHelpers());
            });
          }
        }; // Touching an element in iOS gives focus and hover states, but touching out of
        // the element will remove hover, and persist the focus state, resulting in the
        // blur event not being triggered.
        // this.isTouchMove helps us track whether the user is tapping or swiping on a touch screen.
        // If the user taps outside of Downshift, the component should be reset,
        // but not if the user is swiping


        var onTouchStart = function () {
          _this5.isTouchMove = false;
        };

        var onTouchMove = function () {
          _this5.isTouchMove = true;
        };

        var onTouchEnd = function (event) {
          var contextWithinDownshift = targetWithinDownshift(event.target, false);

          if (!_this5.isTouchMove && !contextWithinDownshift && _this5.getState().isOpen) {
            _this5.reset({
              type: touchEnd
            }, function () {
              return _this5.props.onOuterClick(_this5.getStateAndHelpers());
            });
          }
        };

        var environment = this.props.environment;
        environment.addEventListener('mousedown', onMouseDown);
        environment.addEventListener('mouseup', onMouseUp);
        environment.addEventListener('touchstart', onTouchStart);
        environment.addEventListener('touchmove', onTouchMove);
        environment.addEventListener('touchend', onTouchEnd);

        this.cleanup = function () {
          _this5.internalClearTimeouts();

          _this5.updateStatus.cancel();

          environment.removeEventListener('mousedown', onMouseDown);
          environment.removeEventListener('mouseup', onMouseUp);
          environment.removeEventListener('touchstart', onTouchStart);
          environment.removeEventListener('touchmove', onTouchMove);
          environment.removeEventListener('touchend', onTouchEnd);
        };
      }
    };

    _proto.shouldScroll = function shouldScroll(prevState, prevProps) {
      var _ref10 = this.props.highlightedIndex === undefined ? this.getState() : this.props,
          currentHighlightedIndex = _ref10.highlightedIndex;

      var _ref11 = prevProps.highlightedIndex === undefined ? prevState : prevProps,
          prevHighlightedIndex = _ref11.highlightedIndex;

      var scrollWhenOpen = currentHighlightedIndex && this.getState().isOpen && !prevState.isOpen;
      return scrollWhenOpen || currentHighlightedIndex !== prevHighlightedIndex;
    };

    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
      if (false) {
        validateControlledUnchanged(prevProps, this.props);
        /* istanbul ignore if (react-native) */

        if ( this.getMenuProps.called && !this.getMenuProps.suppressRefError) {
          validateGetMenuPropsCalledCorrectly(this._menuNode, this.getMenuProps);
        }
      }

      if (this.isControlledProp('selectedItem') && this.props.selectedItemChanged(prevProps.selectedItem, this.props.selectedItem)) {
        this.internalSetState({
          type: controlledPropUpdatedSelectedItem,
          inputValue: this.props.itemToString(this.props.selectedItem)
        });
      }

      if (!this.avoidScrolling && this.shouldScroll(prevState, prevProps)) {
        this.scrollHighlightedItemIntoView();
      }
      /* istanbul ignore else (react-native) */


      this.updateStatus();
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.cleanup(); // avoids memory leak
    };

    _proto.render = function render() {
      var children = unwrapArray(this.props.children, noop); // because the items are rerendered every time we call the children
      // we clear this out each render and it will be populated again as
      // getItemProps is called.

      this.clearItems(); // we reset this so we know whether the user calls getRootProps during
      // this render. If they do then we don't need to do anything,
      // if they don't then we need to clone the element they return and
      // apply the props for them.

      this.getRootProps.called = false;
      this.getRootProps.refKey = undefined;
      this.getRootProps.suppressRefError = undefined; // we do something similar for getMenuProps

      this.getMenuProps.called = false;
      this.getMenuProps.refKey = undefined;
      this.getMenuProps.suppressRefError = undefined; // we do something similar for getLabelProps

      this.getLabelProps.called = false; // and something similar for getInputProps

      this.getInputProps.called = false;
      var element = unwrapArray(children(this.getStateAndHelpers()));

      if (!element) {
        return null;
      }

      if (this.getRootProps.called || this.props.suppressRefError) {
        if (false) {
          validateGetRootPropsCalledCorrectly(element, this.getRootProps);
        }

        return element;
      } else if (isDOMElement(element)) {
        // they didn't apply the root props, but we can clone
        // this and apply the props ourselves
        return Object(__WEBPACK_IMPORTED_MODULE_5_react__["cloneElement"])(element, this.getRootProps(getElementProps(element)));
      }
      /* istanbul ignore else */


      if (false) {
        // they didn't apply the root props, but they need to
        // otherwise we can't query around the autocomplete
        throw new Error('downshift: If you return a non-DOM element, you must apply the getRootProps function');
      }
      /* istanbul ignore next */


      return undefined;
    };

    return Downshift;
  }(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

  Downshift.defaultProps = {
    defaultHighlightedIndex: null,
    defaultIsOpen: false,
    getA11yStatusMessage: getA11yStatusMessage,
    itemToString: function itemToString(i) {
      if (i == null) {
        return '';
      }

      if (false) {
        // eslint-disable-next-line no-console
        console.warn('downshift: An object was passed to the default implementation of `itemToString`. You should probably provide your own `itemToString` implementation. Please refer to the `itemToString` API documentation.', 'The object that was passed:', i);
      }

      return String(i);
    },
    onStateChange: noop,
    onInputValueChange: noop,
    onUserAction: noop,
    onChange: noop,
    onSelect: noop,
    onOuterClick: noop,
    selectedItemChanged: function selectedItemChanged(prevItem, item) {
      return prevItem !== item;
    },
    environment: typeof window === 'undefined'
    /* istanbul ignore next (ssr) */
    ? {} : window,
    stateReducer: function stateReducer(state, stateToSet) {
      return stateToSet;
    },
    suppressRefError: false,
    scrollIntoView: scrollIntoView
  };
  Downshift.stateChangeTypes = stateChangeTypes;
  return Downshift;
}();

 false ? Downshift.propTypes = {
  children: PropTypes.func,
  defaultHighlightedIndex: PropTypes.number,
  defaultIsOpen: PropTypes.bool,
  initialHighlightedIndex: PropTypes.number,
  initialSelectedItem: PropTypes.any,
  initialInputValue: PropTypes.string,
  initialIsOpen: PropTypes.bool,
  getA11yStatusMessage: PropTypes.func,
  itemToString: PropTypes.func,
  onChange: PropTypes.func,
  onSelect: PropTypes.func,
  onStateChange: PropTypes.func,
  onInputValueChange: PropTypes.func,
  onUserAction: PropTypes.func,
  onOuterClick: PropTypes.func,
  selectedItemChanged: PropTypes.func,
  stateReducer: PropTypes.func,
  itemCount: PropTypes.number,
  id: PropTypes.string,
  environment: PropTypes.shape({
    addEventListener: PropTypes.func,
    removeEventListener: PropTypes.func,
    document: PropTypes.shape({
      getElementById: PropTypes.func,
      activeElement: PropTypes.any,
      body: PropTypes.any
    })
  }),
  suppressRefError: PropTypes.bool,
  scrollIntoView: PropTypes.func,
  // things we keep in state for uncontrolled components
  // but can accept as props for controlled components

  /* eslint-disable react/no-unused-prop-types */
  selectedItem: PropTypes.any,
  isOpen: PropTypes.bool,
  inputValue: PropTypes.string,
  highlightedIndex: PropTypes.number,
  labelId: PropTypes.string,
  inputId: PropTypes.string,
  menuId: PropTypes.string,
  getItemId: PropTypes.func
  /* eslint-enable react/no-unused-prop-types */

} : void 0;

function validateGetMenuPropsCalledCorrectly(node, _ref12) {
  var refKey = _ref12.refKey;

  if (!node) {
    // eslint-disable-next-line no-console
    console.error("downshift: The ref prop \"" + refKey + "\" from getMenuProps was not applied correctly on your menu element.");
  }
}

function validateGetRootPropsCalledCorrectly(element, _ref13) {
  var refKey = _ref13.refKey;
  var refKeySpecified = refKey !== 'ref';
  var isComposite = !isDOMElement(element);

  if (isComposite && !refKeySpecified && !Object(__WEBPACK_IMPORTED_MODULE_6_react_is__["isForwardRef"])(element)) {
    // eslint-disable-next-line no-console
    console.error('downshift: You returned a non-DOM element. You must specify a refKey in getRootProps');
  } else if (!isComposite && refKeySpecified) {
    // eslint-disable-next-line no-console
    console.error("downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified \"" + refKey + "\"");
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_6_react_is__["isForwardRef"])(element) && !getElementProps(element)[refKey]) {
    // eslint-disable-next-line no-console
    console.error("downshift: You must apply the ref prop \"" + refKey + "\" from getRootProps onto your root element.");
  }
}

function validateControlledUnchanged(prevProps, nextProps) {
  var warningDescription = "This prop should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled Downshift element for the lifetime of the component. More info: https://github.com/downshift-js/downshift#control-props";
  ['selectedItem', 'isOpen', 'inputValue', 'highlightedIndex'].forEach(function (propKey) {
    if (prevProps[propKey] !== undefined && nextProps[propKey] === undefined) {
      // eslint-disable-next-line no-console
      console.error("downshift: A component has changed the controlled prop \"" + propKey + "\" to be uncontrolled. " + warningDescription);
    } else if (prevProps[propKey] === undefined && nextProps[propKey] !== undefined) {
      // eslint-disable-next-line no-console
      console.error("downshift: A component has changed the uncontrolled prop \"" + propKey + "\" to be controlled. " + warningDescription);
    }
  });
}

function getElementIds(generateDefaultId, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      id = _ref.id,
      labelId = _ref.labelId,
      menuId = _ref.menuId,
      getItemId = _ref.getItemId,
      toggleButtonId = _ref.toggleButtonId;

  var uniqueId = id === undefined ? "downshift-" + generateDefaultId() : id;
  return {
    labelId: labelId || uniqueId + "-label",
    menuId: menuId || uniqueId + "-menu",
    getItemId: getItemId || function (index) {
      return uniqueId + "-item-" + index;
    },
    toggleButtonId: toggleButtonId || uniqueId + "-toggle-button"
  };
}

function getNextWrappingIndex$1(moveAmount, baseIndex, itemsLength, circular) {
  if (baseIndex === -1) {
    return moveAmount > 0 ? 0 : itemsLength - 1;
  }

  var nextIndex = baseIndex + moveAmount;

  if (nextIndex < 0) {
    return circular ? itemsLength - 1 : 0;
  }

  if (nextIndex >= itemsLength) {
    return circular ? 0 : itemsLength - 1;
  }

  return nextIndex;
}

function getItemIndexByCharacterKey(keysSoFar, highlightedIndex, items, itemToStringParam) {
  var newHighlightedIndex = -1;
  var itemStrings = items.map(function (item) {
    return itemToStringParam(item).toLowerCase();
  });
  var startPosition = highlightedIndex + 1;
  newHighlightedIndex = itemStrings.slice(startPosition).findIndex(function (itemString) {
    return itemString.startsWith(keysSoFar);
  });

  if (newHighlightedIndex > -1) {
    return newHighlightedIndex + startPosition;
  } else {
    return itemStrings.slice(0, startPosition).findIndex(function (itemString) {
      return itemString.startsWith(keysSoFar);
    });
  }
}

function getState(state, props) {
  return Object.keys(state).reduce(function (prevState, key) {
    // eslint-disable-next-line no-param-reassign
    prevState[key] = key in props ? props[key] : state[key];
    return prevState;
  }, {});
}

function getItemIndex(index, item, items) {
  if (index !== undefined) {
    return index;
  }

  if (items.length === 0) {
    return -1;
  }

  return items.indexOf(item);
}

function itemToString(item) {
  return item ? String(item) : '';
}

function getPropTypesValidator(caller, propTypes) {
  // istanbul ignore next
  return function (options) {
    if (options === void 0) {
      options = {};
    }

    Object.entries(propTypes).forEach(function (_ref2) {
      var key = _ref2[0];
      __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.checkPropTypes(propTypes, options, key, caller.name);
    });
  };
}

function isAcceptedCharacterKey(key) {
  return /^\S{1}$/.test(key);
}

function capitalizeString(string) {
  return "" + string.slice(0, 1).toUpperCase() + string.slice(1);
}

function invokeOnChangeHandler(propKey, props, state, changes) {
  var handler = "on" + capitalizeString(propKey) + "Change";

  if (props[handler] && changes[propKey] !== undefined && changes[propKey] !== state[propKey]) {
    props[handler](changes);
  }
}

function callOnChangeProps(props, state, changes) {
  Object.keys(state).forEach(function (stateKey) {
    invokeOnChangeHandler(stateKey, props, state, changes);
  });

  if (props.onStateChange && changes !== undefined) {
    props.onStateChange(changes);
  }
}

function useEnhancedReducer(reducer, initialState, props) {
  var enhancedReducer = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useCallback"])(function (state, action) {
    state = getState(state, action.props);
    var stateReducer = action.props.stateReducer;
    var changes = reducer(state, action);
    var newState = stateReducer(state, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, action, {
      changes: changes
    }));
    callOnChangeProps(action.props, state, newState);
    return newState;
  }, [reducer]);

  var _useReducer = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useReducer"])(enhancedReducer, initialState),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  return [getState(state, props), dispatch];
}

var lastId = 0; // istanbul ignore next

var genId = function () {
  return ++lastId;
};
/**
 * Autogenerate IDs to facilitate WAI-ARIA and server rendering.
 * Taken from @reach/auto-id
 * @see https://github.com/reach/reach-ui/blob/6e9dbcf716d5c9a3420e062e5bac1ac4671d01cb/packages/auto-id/src/index.js
 */
// istanbul ignore next


function useId() {
  var _useState = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useState"])(null),
      id = _useState[0],
      setId = _useState[1];

  Object(__WEBPACK_IMPORTED_MODULE_5_react__["useEffect"])(function () {
    return setId(genId());
  }, []);
  return id;
}
/**
 * Checks if nextElement receives focus after the blur event.
 *
 * @param {FocusEvent} event The blur event.
 * @param {Element} nextElement The element to check that receive focus next.
 * @returns {boolean} If the focus lands on nextElement.
 */


function focusLandsOnElement(event, nextElement) {
  return event.relatedTarget === nextElement || // https://github.com/downshift-js/downshift/issues/832 - workaround for Firefox.
  event.nativeEvent && (nextElement === event.nativeEvent.explicitOriginalTarget || nextElement.contains(event.nativeEvent.explicitOriginalTarget));
}

var defaultStateValues = {
  highlightedIndex: -1,
  isOpen: false,
  selectedItem: null
};

function getA11yStatusMessage$1(_ref) {
  var isOpen = _ref.isOpen,
      items = _ref.items;

  if (!items) {
    return '';
  }

  var resultCount = items.length;

  if (isOpen) {
    if (resultCount === 0) {
      return 'No results are available';
    }

    return resultCount + " result" + (resultCount === 1 ? ' is' : 's are') + " available, use up and down arrow keys to navigate. Press Enter key to select.";
  }

  return '';
}

function getA11ySelectionMessage(_ref2) {
  var selectedItem = _ref2.selectedItem,
      itemToString = _ref2.itemToString;
  return itemToString(selectedItem) + " has been selected.";
}

function getHighlightedIndexOnOpen(props, state, offset) {
  var items = props.items,
      initialHighlightedIndex = props.initialHighlightedIndex,
      defaultHighlightedIndex = props.defaultHighlightedIndex;
  var selectedItem = state.selectedItem,
      highlightedIndex = state.highlightedIndex; // initialHighlightedIndex will give value to highlightedIndex on initial state only.

  if (initialHighlightedIndex !== undefined && highlightedIndex > -1) {
    return initialHighlightedIndex;
  }

  if (defaultHighlightedIndex !== undefined) {
    return defaultHighlightedIndex;
  }

  if (selectedItem) {
    if (offset === 0) {
      return items.indexOf(selectedItem);
    }

    return getNextWrappingIndex$1(offset, items.indexOf(selectedItem), items.length, false);
  }

  if (offset === 0) {
    return -1;
  }

  return offset < 0 ? items.length - 1 : 0;
}

function getDefaultValue(props, propKey) {
  var defaultPropKey = "default" + capitalizeString(propKey);

  if (defaultPropKey in props) {
    return props[defaultPropKey];
  }

  return defaultStateValues[propKey];
}

function getInitialValue(props, propKey) {
  if (propKey in props) {
    return props[propKey];
  }

  var initialPropKey = "initial" + capitalizeString(propKey);

  if (initialPropKey in props) {
    return props[initialPropKey];
  }

  return getDefaultValue(props, propKey);
}

function getInitialState(props) {
  var selectedItem = getInitialValue(props, 'selectedItem');
  var highlightedIndex = getInitialValue(props, 'highlightedIndex');
  var isOpen = getInitialValue(props, 'isOpen');
  return {
    highlightedIndex: highlightedIndex < 0 && selectedItem ? props.items.indexOf(selectedItem) : highlightedIndex,
    isOpen: isOpen,
    selectedItem: selectedItem,
    keysSoFar: ''
  };
}

var propTypes = {
  items: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array.isRequired,
  itemToString: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  getA11yStatusMessage: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  getA11ySelectionMessage: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  circularNavigation: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  highlightedIndex: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  defaultHighlightedIndex: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  initialHighlightedIndex: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  isOpen: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  defaultIsOpen: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  initialIsOpen: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  selectedItem: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
  initialSelectedItem: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
  defaultSelectedItem: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
  id: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  labelId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  menuId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  getItemId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  toggleButtonId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  stateReducer: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onSelectedItemChange: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onHighlightedIndexChange: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onStateChange: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onIsOpenChange: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  environment: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    addEventListener: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
    removeEventListener: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
    document: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
      getElementById: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
      activeElement: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
      body: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
    })
  })
};

var MenuKeyDownArrowDown =  false ? '__menu_keydown_arrow_down__' : 0;
var MenuKeyDownArrowUp =  false ? '__menu_keydown_arrow_up__' : 1;
var MenuKeyDownEscape =  false ? '__menu_keydown_escape__' : 2;
var MenuKeyDownHome =  false ? '__menu_keydown_home__' : 3;
var MenuKeyDownEnd =  false ? '__menu_keydown_end__' : 4;
var MenuKeyDownEnter =  false ? '__menu_keydown_enter__' : 5;
var MenuKeyDownCharacter =  false ? '__menu_keydown_character__' : 6;
var MenuBlur =  false ? '__menu_blur__' : 7;
var MenuMouseLeave =  false ? '__menu_mouse_leave__' : 8;
var ItemMouseMove =  false ? '__item_mouse_move__' : 9;
var ItemClick =  false ? '__item_click__' : 10;
var ToggleButtonKeyDownCharacter =  false ? '__togglebutton_keydown_character__' : 11;
var ToggleButtonKeyDownArrowDown =  false ? '__togglebutton_keydown_arrow_down__' : 12;
var ToggleButtonKeyDownArrowUp =  false ? '__togglebutton_keydown_arrow_up__' : 13;
var ToggleButtonClick =  false ? '__togglebutton_click__' : 14;
var FunctionToggleMenu =  false ? '__function_toggle_menu__' : 15;
var FunctionOpenMenu =  false ? '__function_open_menu__' : 16;
var FunctionCloseMenu =  false ? '__function_close_menu__' : 17;
var FunctionSetHighlightedIndex =  false ? '__function_set_highlighted_index__' : 18;
var FunctionSelectItem =  false ? '__function_select_item__' : 19;
var FunctionClearKeysSoFar =  false ? '__function_clear_keys_so_far__' : 20;
var FunctionReset =  false ? '__function_reset__' : 21;

var stateChangeTypes$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  MenuKeyDownArrowDown: MenuKeyDownArrowDown,
  MenuKeyDownArrowUp: MenuKeyDownArrowUp,
  MenuKeyDownEscape: MenuKeyDownEscape,
  MenuKeyDownHome: MenuKeyDownHome,
  MenuKeyDownEnd: MenuKeyDownEnd,
  MenuKeyDownEnter: MenuKeyDownEnter,
  MenuKeyDownCharacter: MenuKeyDownCharacter,
  MenuBlur: MenuBlur,
  MenuMouseLeave: MenuMouseLeave,
  ItemMouseMove: ItemMouseMove,
  ItemClick: ItemClick,
  ToggleButtonKeyDownCharacter: ToggleButtonKeyDownCharacter,
  ToggleButtonKeyDownArrowDown: ToggleButtonKeyDownArrowDown,
  ToggleButtonKeyDownArrowUp: ToggleButtonKeyDownArrowUp,
  ToggleButtonClick: ToggleButtonClick,
  FunctionToggleMenu: FunctionToggleMenu,
  FunctionOpenMenu: FunctionOpenMenu,
  FunctionCloseMenu: FunctionCloseMenu,
  FunctionSetHighlightedIndex: FunctionSetHighlightedIndex,
  FunctionSelectItem: FunctionSelectItem,
  FunctionClearKeysSoFar: FunctionClearKeysSoFar,
  FunctionReset: FunctionReset
});

/* eslint-disable complexity */

function downshiftSelectReducer(state, action) {
  var type = action.type,
      props = action.props,
      shiftKey = action.shiftKey;
  var changes;

  switch (type) {
    case ItemMouseMove:
      changes = {
        highlightedIndex: action.index
      };
      break;

    case ItemClick:
      changes = {
        isOpen: getDefaultValue(props, 'isOpen'),
        highlightedIndex: getDefaultValue(props, 'highlightedIndex'),
        selectedItem: props.items[action.index]
      };
      break;

    case MenuBlur:
      changes = {
        isOpen: false,
        highlightedIndex: -1
      };
      break;

    case MenuKeyDownArrowDown:
      changes = {
        highlightedIndex: getNextWrappingIndex$1(shiftKey ? 5 : 1, state.highlightedIndex, props.items.length, props.circularNavigation)
      };
      break;

    case MenuKeyDownArrowUp:
      changes = {
        highlightedIndex: getNextWrappingIndex$1(shiftKey ? -5 : -1, state.highlightedIndex, props.items.length, props.circularNavigation)
      };
      break;

    case MenuKeyDownHome:
      changes = {
        highlightedIndex: 0
      };
      break;

    case MenuKeyDownEnd:
      changes = {
        highlightedIndex: props.items.length - 1
      };
      break;

    case MenuKeyDownEscape:
      changes = {
        isOpen: false,
        highlightedIndex: -1
      };
      break;

    case MenuKeyDownEnter:
      changes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        isOpen: getDefaultValue(props, 'isOpen'),
        highlightedIndex: getDefaultValue(props, 'highlightedIndex')
      }, state.highlightedIndex >= 0 && {
        selectedItem: props.items[state.highlightedIndex]
      });
      break;

    case MenuKeyDownCharacter:
      {
        var lowercasedKey = action.key;
        var keysSoFar = "" + state.keysSoFar + lowercasedKey;
        var highlightedIndex = getItemIndexByCharacterKey(keysSoFar, state.highlightedIndex, props.items, props.itemToString);
        changes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
          keysSoFar: keysSoFar
        }, highlightedIndex >= 0 && {
          highlightedIndex: highlightedIndex
        });
      }
      break;

    case MenuMouseLeave:
      changes = {
        highlightedIndex: -1
      };
      break;

    case ToggleButtonKeyDownCharacter:
      {
        var _lowercasedKey = action.key;

        var _keysSoFar = "" + state.keysSoFar + _lowercasedKey;

        var itemIndex = getItemIndexByCharacterKey(_keysSoFar, state.selectedItem ? props.items.indexOf(state.selectedItem) : -1, props.items, props.itemToString);
        changes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
          keysSoFar: _keysSoFar
        }, itemIndex >= 0 && {
          selectedItem: props.items[itemIndex]
        });
      }
      break;

    case ToggleButtonKeyDownArrowDown:
      {
        changes = {
          isOpen: true,
          highlightedIndex: getHighlightedIndexOnOpen(props, state, 1)
        };
        break;
      }

    case ToggleButtonKeyDownArrowUp:
      changes = {
        isOpen: true,
        highlightedIndex: getHighlightedIndexOnOpen(props, state, -1)
      };
      break;

    case ToggleButtonClick:
    case FunctionToggleMenu:
      changes = {
        isOpen: !state.isOpen,
        highlightedIndex: state.isOpen ? -1 : getHighlightedIndexOnOpen(props, state, 0)
      };
      break;

    case FunctionOpenMenu:
      changes = {
        isOpen: true,
        highlightedIndex: getHighlightedIndexOnOpen(props, state, 0)
      };
      break;

    case FunctionCloseMenu:
      changes = {
        isOpen: false
      };
      break;

    case FunctionSetHighlightedIndex:
      changes = {
        highlightedIndex: action.highlightedIndex
      };
      break;

    case FunctionSelectItem:
      changes = {
        selectedItem: action.selectedItem
      };
      break;

    case FunctionClearKeysSoFar:
      changes = {
        keysSoFar: ''
      };
      break;

    case FunctionReset:
      changes = {
        highlightedIndex: getDefaultValue(props, 'highlightedIndex'),
        isOpen: getDefaultValue(props, 'isOpen'),
        selectedItem: getDefaultValue(props, 'selectedItem')
      };
      break;

    default:
      throw new Error('Reducer called without proper action type.');
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state, {}, changes);
}
/* eslint-enable complexity */

var validatePropTypes =  true ?
/* istanbul ignore next */
null : getPropTypesValidator(useSelect, propTypes);
var defaultProps = {
  itemToString: itemToString,
  stateReducer: function stateReducer(s, a) {
    return a.changes;
  },
  getA11yStatusMessage: getA11yStatusMessage$1,
  getA11ySelectionMessage: getA11ySelectionMessage,
  scrollIntoView: scrollIntoView,
  environment: typeof window === 'undefined'
  /* istanbul ignore next (ssr) */
  ? {} : window
};
useSelect.stateChangeTypes = stateChangeTypes$1;

function useSelect(userProps) {
  if (userProps === void 0) {
    userProps = {};
  }

  /* istanbul ignore else */
  if (false) {
    validatePropTypes(userProps);
  } // Props defaults and destructuring.


  var props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, defaultProps, {}, userProps);

  var items = props.items,
      itemToString = props.itemToString,
      getA11yStatusMessage = props.getA11yStatusMessage,
      getA11ySelectionMessage = props.getA11ySelectionMessage,
      initialIsOpen = props.initialIsOpen,
      defaultIsOpen = props.defaultIsOpen,
      scrollIntoView = props.scrollIntoView,
      environment = props.environment; // Initial state depending on controlled props.

  var initialState = getInitialState(props); // Reducer init.

  var _useEnhancedReducer = useEnhancedReducer(downshiftSelectReducer, initialState, props),
      _useEnhancedReducer$ = _useEnhancedReducer[0],
      isOpen = _useEnhancedReducer$.isOpen,
      highlightedIndex = _useEnhancedReducer$.highlightedIndex,
      selectedItem = _useEnhancedReducer$.selectedItem,
      keysSoFar = _useEnhancedReducer$.keysSoFar,
      dispatchWithoutProps = _useEnhancedReducer[1];

  var dispatch = function (action) {
    return dispatchWithoutProps(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
      props: props
    }, action));
  }; // IDs generation.


  var _getElementIds = getElementIds(useId, props),
      labelId = _getElementIds.labelId,
      getItemId = _getElementIds.getItemId,
      menuId = _getElementIds.menuId,
      toggleButtonId = _getElementIds.toggleButtonId;
  /* Refs */


  var toggleButtonRef = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])(null);
  var menuRef = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])(null);
  var itemRefs = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])();
  itemRefs.current = [];
  var isInitialMount = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])(true);
  var shouldScroll = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])(true);
  var clearTimeout = Object(__WEBPACK_IMPORTED_MODULE_5_react__["useRef"])(null);
  /* Effects */

  /* Sets a11y status message on changes in isOpen. */

  Object(__WEBPACK_IMPORTED_MODULE_5_react__["useEffect"])(function () {
    if (isInitialMount.current) {
      return;
    }

    setStatus(getA11yStatusMessage({
      isOpen: isOpen,
      items: items,
      selectedItem: selectedItem,
      itemToString: itemToString
    }), environment.document); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);
  /* Sets a11y status message on changes in selectedItem. */

  Object(__WEBPACK_IMPORTED_MODULE_5_react__["useEffect"])(function () {
    if (isInitialMount.current) {
      return;
    }

    setStatus(getA11ySelectionMessage({
      isOpen: isOpen,
      items: items,
      selectedItem: selectedItem,
      itemToString: itemToString
    }), environment.document); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItem]);
  /* Sets cleanup for the keysSoFar after 500ms. */

  Object(__WEBPACK_IMPORTED_MODULE_5_react__["useEffect"])(function () {
    // init the clean function here as we need access to dispatch.
    if (isInitialMount.current) {
      clearTimeout.current = debounce(function () {
        dispatch({
          type: FunctionClearKeysSoFar
        });
      }, 500);
    }

    if (!keysSoFar) {
      return;
    }

    clearTimeout.current(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keysSoFar]);
  /* Controls the focus on the menu or the toggle button. */

  Object(__WEBPACK_IMPORTED_MODULE_5_react__["useEffect"])(function () {
    // Don't focus menu on first render.
    if (isInitialMount.current) {
      // Unless it was initialised as open.
      if (initialIsOpen || defaultIsOpen || isOpen) {
        menuRef.current.focus();
      }

      return;
    } // Focus menu on open.
    // istanbul ignore next


    if (isOpen) {
      menuRef.current.focus(); // Focus toggleButton on close.
    } else if (environment.document.activeElement === menuRef.current) {
      toggleButtonRef.current.focus();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [isOpen]);
  /* Scroll on highlighted item if change comes from keyboard. */

  Object(__WEBPACK_IMPORTED_MODULE_5_react__["useEffect"])(function () {
    if (highlightedIndex < 0 || !isOpen || !itemRefs.current.length) {
      return;
    }

    if (shouldScroll.current === false) {
      shouldScroll.current = true;
    } else {
      scrollIntoView(itemRefs.current[highlightedIndex], menuRef.current);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [highlightedIndex]);
  /* Make initial ref false. */

  Object(__WEBPACK_IMPORTED_MODULE_5_react__["useEffect"])(function () {
    isInitialMount.current = false;
  }, []);
  /* Event handler functions */

  var menuKeyDownHandlers = {
    ArrowDown: function ArrowDown(event) {
      event.preventDefault();
      dispatch({
        type: MenuKeyDownArrowDown,
        shiftKey: event.shiftKey
      });
    },
    ArrowUp: function ArrowUp(event) {
      event.preventDefault();
      dispatch({
        type: MenuKeyDownArrowUp,
        shiftKey: event.shiftKey
      });
    },
    Home: function Home(event) {
      event.preventDefault();
      dispatch({
        type: MenuKeyDownHome
      });
    },
    End: function End(event) {
      event.preventDefault();
      dispatch({
        type: MenuKeyDownEnd
      });
    },
    Escape: function Escape() {
      dispatch({
        type: MenuKeyDownEscape
      });
    },
    Enter: function Enter(event) {
      event.preventDefault();
      dispatch({
        type: MenuKeyDownEnter
      });
    },
    Tab: function Tab(event) {
      // The exception that calls MenuBlur.
      // istanbul ignore next
      if (event.shiftKey) {
        dispatch({
          type: MenuBlur
        });
      }
    }
  };
  var toggleButtonKeyDownHandlers = {
    ArrowDown: function ArrowDown(event) {
      event.preventDefault();
      dispatch({
        type: ToggleButtonKeyDownArrowDown
      });
    },
    ArrowUp: function ArrowUp(event) {
      event.preventDefault();
      dispatch({
        type: ToggleButtonKeyDownArrowUp
      });
    }
  }; // Event handlers.

  var menuHandleKeyDown = function (event) {
    var key = normalizeArrowKey(event);

    if (key && menuKeyDownHandlers[key]) {
      menuKeyDownHandlers[key](event);
    } else if (isAcceptedCharacterKey(key)) {
      dispatch({
        type: MenuKeyDownCharacter,
        key: key
      });
    }
  }; // Focus going back to the toggleButton is something we control (Escape, Enter, Click).
  // We are toggleing special actions for these cases in reducer, not MenuBlur.
  // Since Shift-Tab also lands focus on toggleButton, we will handle it as exception and call MenuBlur.


  var menuHandleBlur = function (event) {
    if (!focusLandsOnElement(event, toggleButtonRef.current)) {
      dispatch({
        type: MenuBlur
      });
    }
  };

  var menuHandleMouseLeave = function () {
    dispatch({
      type: MenuMouseLeave
    });
  };

  var toggleButtonHandleClick = function () {
    dispatch({
      type: ToggleButtonClick
    });
  };

  var toggleButtonHandleKeyDown = function (event) {
    var key = normalizeArrowKey(event);

    if (key && toggleButtonKeyDownHandlers[key]) {
      toggleButtonKeyDownHandlers[key](event);
    } else if (isAcceptedCharacterKey(key)) {
      dispatch({
        type: ToggleButtonKeyDownCharacter,
        key: key
      });
    }
  };

  var itemHandleMouseMove = function (index) {
    if (index === highlightedIndex) {
      return;
    }

    shouldScroll.current = false;
    dispatch({
      type: ItemMouseMove,
      index: index
    });
  };

  var itemHandleClick = function (index) {
    dispatch({
      type: ItemClick,
      index: index
    });
  }; // returns


  return {
    // prop getters.
    getToggleButtonProps: function getToggleButtonProps(_temp2) {
      var _extends3;

      var _ref2 = _temp2 === void 0 ? {} : _temp2,
          onClick = _ref2.onClick,
          onKeyDown = _ref2.onKeyDown,
          _ref2$refKey = _ref2.refKey,
          refKey = _ref2$refKey === void 0 ? 'ref' : _ref2$refKey,
          ref = _ref2.ref,
          rest = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["onClick", "onKeyDown", "refKey", "ref"]);

      var toggleProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])((_extends3 = {}, _extends3[refKey] = handleRefs(ref, function (toggleButtonNode) {
        toggleButtonRef.current = toggleButtonNode;
      }), _extends3.id = toggleButtonId, _extends3['aria-haspopup'] = 'listbox', _extends3['aria-expanded'] = isOpen, _extends3['aria-labelledby'] = labelId + " " + toggleButtonId, _extends3), rest);

      if (!rest.disabled) {
        toggleProps.onClick = callAllEventHandlers(onClick, toggleButtonHandleClick);
        toggleProps.onKeyDown = callAllEventHandlers(onKeyDown, toggleButtonHandleKeyDown);
      }

      return toggleProps;
    },
    getLabelProps: function getLabelProps(labelProps) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        id: labelId,
        htmlFor: toggleButtonId
      }, labelProps);
    },
    getMenuProps: function getMenuProps(_temp) {
      var _extends2;

      var _ref = _temp === void 0 ? {} : _temp,
          onKeyDown = _ref.onKeyDown,
          onBlur = _ref.onBlur,
          onMouseLeave = _ref.onMouseLeave,
          _ref$refKey = _ref.refKey,
          refKey = _ref$refKey === void 0 ? 'ref' : _ref$refKey,
          ref = _ref.ref,
          rest = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["onKeyDown", "onBlur", "onMouseLeave", "refKey", "ref"]);

      return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])((_extends2 = {}, _extends2[refKey] = handleRefs(ref, function (menuNode) {
        menuRef.current = menuNode;
      }), _extends2.id = menuId, _extends2.role = 'listbox', _extends2['aria-labelledby'] = labelId, _extends2.tabIndex = -1, _extends2), highlightedIndex > -1 && {
        'aria-activedescendant': getItemId(highlightedIndex)
      }, {
        onKeyDown: callAllEventHandlers(onKeyDown, menuHandleKeyDown),
        onBlur: callAllEventHandlers(onBlur, menuHandleBlur),
        onMouseLeave: callAllEventHandlers(onMouseLeave, menuHandleMouseLeave)
      }, rest);
    },
    getItemProps: function getItemProps(_temp3) {
      var _extends4;

      var _ref3 = _temp3 === void 0 ? {} : _temp3,
          item = _ref3.item,
          index = _ref3.index,
          _ref3$refKey = _ref3.refKey,
          refKey = _ref3$refKey === void 0 ? 'ref' : _ref3$refKey,
          ref = _ref3.ref,
          onMouseMove = _ref3.onMouseMove,
          onClick = _ref3.onClick,
          rest = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["item", "index", "refKey", "ref", "onMouseMove", "onClick"]);

      var itemIndex = getItemIndex(index, item, items);

      if (itemIndex < 0) {
        throw new Error('Pass either item or item index in getItemProps!');
      }

      var itemProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])((_extends4 = {}, _extends4[refKey] = handleRefs(ref, function (itemNode) {
        if (itemNode) {
          itemRefs.current.push(itemNode);
        }
      }), _extends4.role = 'option', _extends4), itemIndex === highlightedIndex && {
        'aria-selected': true
      }, {
        id: getItemId(itemIndex)
      }, rest);

      if (!rest.disabled) {
        itemProps.onMouseMove = callAllEventHandlers(onMouseMove, function () {
          return itemHandleMouseMove(itemIndex);
        });
        itemProps.onClick = callAllEventHandlers(onClick, function () {
          return itemHandleClick(itemIndex);
        });
      }

      return itemProps;
    },
    // actions.
    toggleMenu: function toggleMenu() {
      dispatch({
        type: FunctionToggleMenu
      });
    },
    openMenu: function openMenu() {
      dispatch({
        type: FunctionOpenMenu
      });
    },
    closeMenu: function closeMenu() {
      dispatch({
        type: FunctionCloseMenu
      });
    },
    setHighlightedIndex: function setHighlightedIndex(newHighlightedIndex) {
      dispatch({
        type: FunctionSetHighlightedIndex,
        highlightedIndex: newHighlightedIndex
      });
    },
    selectItem: function selectItem(newSelectedItem) {
      dispatch({
        type: FunctionSelectItem,
        selectedItem: newSelectedItem
      });
    },
    reset: function reset() {
      dispatch({
        type: FunctionReset
      });
    },
    // state.
    highlightedIndex: highlightedIndex,
    isOpen: isOpen,
    selectedItem: selectedItem
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Downshift);



/***/ }),
/* 2432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ }),
/* 2433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),
/* 2434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

/***/ }),
/* 2435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(2436);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 2436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),
/* 2437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(2438);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 2438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 2439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return i; });
function t(t){return"object"==typeof t&&null!=t&&1===t.nodeType}function e(t,e){return(!e||"hidden"!==t)&&"visible"!==t&&"clip"!==t}function n(t,n){if(t.clientHeight<t.scrollHeight||t.clientWidth<t.scrollWidth){var r=getComputedStyle(t,null);return e(r.overflowY,n)||e(r.overflowX,n)||function(t){var e=function(t){if(!t.ownerDocument||!t.ownerDocument.defaultView)return null;try{return t.ownerDocument.defaultView.frameElement}catch(t){return null}}(t);return!!e&&(e.clientHeight<t.scrollHeight||e.clientWidth<t.scrollWidth)}(t)}return!1}function r(t,e,n,r,i,o,l,d){return o<t&&l>e||o>t&&l<e?0:o<=t&&d<=n||l>=e&&d>=n?o-t-r:l>e&&d<n||o<t&&d>n?l-e+i:0}var i=function(e,i){var o=window,l=i.scrollMode,d=i.block,f=i.inline,h=i.boundary,u=i.skipOverflowHiddenElements,s="function"==typeof h?h:function(t){return t!==h};if(!t(e))throw new TypeError("Invalid target");for(var a,c,g=document.scrollingElement||document.documentElement,p=[],m=e;t(m)&&s(m);){if((m=null==(c=(a=m).parentElement)?a.getRootNode().host||null:c)===g){p.push(m);break}null!=m&&m===document.body&&n(m)&&!n(document.documentElement)||null!=m&&n(m,u)&&p.push(m)}for(var w=o.visualViewport?o.visualViewport.width:innerWidth,v=o.visualViewport?o.visualViewport.height:innerHeight,W=window.scrollX||pageXOffset,H=window.scrollY||pageYOffset,b=e.getBoundingClientRect(),y=b.height,E=b.width,M=b.top,V=b.right,x=b.bottom,I=b.left,C="start"===d||"nearest"===d?M:"end"===d?x:M+y/2,R="center"===f?I+E/2:"end"===f?V:I,T=[],k=0;k<p.length;k++){var B=p[k],D=B.getBoundingClientRect(),O=D.height,X=D.width,Y=D.top,L=D.right,S=D.bottom,j=D.left;if("if-needed"===l&&M>=0&&I>=0&&x<=v&&V<=w&&M>=Y&&x<=S&&I>=j&&V<=L)return T;var N=getComputedStyle(B),q=parseInt(N.borderLeftWidth,10),z=parseInt(N.borderTopWidth,10),A=parseInt(N.borderRightWidth,10),F=parseInt(N.borderBottomWidth,10),G=0,J=0,K="offsetWidth"in B?B.offsetWidth-B.clientWidth-q-A:0,P="offsetHeight"in B?B.offsetHeight-B.clientHeight-z-F:0,Q="offsetWidth"in B?0===B.offsetWidth?0:X/B.offsetWidth:0,U="offsetHeight"in B?0===B.offsetHeight?0:O/B.offsetHeight:0;if(g===B)G="start"===d?C:"end"===d?C-v:"nearest"===d?r(H,H+v,v,z,F,H+C,H+C+y,y):C-v/2,J="start"===f?R:"center"===f?R-w/2:"end"===f?R-w:r(W,W+w,w,q,A,W+R,W+R+E,E),G=Math.max(0,G+H),J=Math.max(0,J+W);else{G="start"===d?C-Y-z:"end"===d?C-S+F+P:"nearest"===d?r(Y,S,O,z,F+P,C,C+y,y):C-(Y+O/2)+P/2,J="start"===f?R-j-q:"center"===f?R-(j+X/2)+K/2:"end"===f?R-L+A+K:r(j,L,X,q,A+K,R,R+E,E);var Z=B.scrollLeft,$=B.scrollTop;C+=$-(G=Math.max(0,Math.min($+G/U,B.scrollHeight-O/U+P))),R+=Z-(J=Math.max(0,Math.min(Z+J/Q,B.scrollWidth-X/Q+K)))}T.push({el:B,top:G,left:J})}return T};
//# sourceMappingURL=index.mjs.map


/***/ }),
/* 2440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_FormGroup__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_FormGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_FormGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_FormHelperText__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_FormHelperText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_FormHelperText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_material_ui_pickers__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getVehicleSerialNumbers($partnerLoginId: Int!) {\n    vtsNos: getVehicleSerialNumbers(partnerLoginId: $partnerLoginId) {\n      vtsNo\n      clientLoginId\n    }\n  }\n'],['\n  query getVehicleSerialNumbers($partnerLoginId: Int!) {\n    vtsNos: getVehicleSerialNumbers(partnerLoginId: $partnerLoginId) {\n      vtsNo\n      clientLoginId\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  mutation setSparePart(\n    $sparePartConfigs: [SparePartConfig!]\n    $clientLoginId: Int\n  ) {\n    setSparePartReplacement(\n      sparePartConfigs: $sparePartConfigs\n      clientLoginId: $clientLoginId\n    )\n  }\n'],['\n  mutation setSparePart(\n    $sparePartConfigs: [SparePartConfig!]\n    $clientLoginId: Int\n  ) {\n    setSparePartReplacement(\n      sparePartConfigs: $sparePartConfigs\n      clientLoginId: $clientLoginId\n    )\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query allClientDetails($partnerLoginId: Int, $status: Int) {\n    clientsDetails: allClientDetails(\n      partnerLoginId: $partnerLoginId\n      status: $status\n    ) {\n      clientName\n\n      loginId\n      partner {\n        businessName\n      }\n    }\n  }\n'],['\n  query allClientDetails($partnerLoginId: Int, $status: Int) {\n    clientsDetails: allClientDetails(\n      partnerLoginId: $partnerLoginId\n      status: $status\n    ) {\n      clientName\n\n      loginId\n      partner {\n        businessName\n      }\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query getSpareAdmin($partnerLoginId: Int!) {\n    sparePartsHistory: getSparePartHistoryForAdmin(\n      partnerLoginId: $partnerLoginId\n    ) {\n      sparePartName\n      sparePartNumber\n      description\n      replacedPartNumber\n      replacedBy\n      replacedDate\n      uniqueDeviceId\n      clientLoginId\n    }\n  }\n'],['\n  query getSpareAdmin($partnerLoginId: Int!) {\n    sparePartsHistory: getSparePartHistoryForAdmin(\n      partnerLoginId: $partnerLoginId\n    ) {\n      sparePartName\n      sparePartNumber\n      description\n      replacedPartNumber\n      replacedBy\n      replacedDate\n      uniqueDeviceId\n      clientLoginId\n    }\n  }\n']);function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable *///TODO :add client NAme in row and update onClickRow fn
var GET_VEHICLE_SERIAL_NUMBERS=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject);var SET_SPARE_PART=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject2);var GET_CLIENTS=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject3);var GET_SPAREPARTS_REPLACEMENT_HISTORY=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject4);var style=function style(theme){return{root:{padding:theme.spacing.unit*4,flexGrow:1,backgroundColor:theme.palette.background.paper},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},iconSmall:{fontSize:20},textField:{marginLeft:theme.spacing.unit,marginRight:theme.spacing.unit},dense:{marginTop:16},button:{margin:theme.spacing.unit*1}};};var SparePartReplacement=function(_Component){_inherits(SparePartReplacement,_Component);function SparePartReplacement(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,SparePartReplacement);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SparePartReplacement.__proto__||Object.getPrototypeOf(SparePartReplacement)).call.apply(_ref,[this].concat(args))),_this),_this.state={vtsNos:[],//creation variables
toBeDeleted:false,dataToBeDeleted:null,toUpdate:false,vehicleSerialNo:'',sparePartNumber:'',sparePartReplacementHistory:[],sparePartsTableLoading:true,sparePartName:'',clientName:'',status:1,clientsDetails:[],description:'',replacedPartNumber:'',replacedBy:'',partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_14__utils_getLoginId__["a" /* default */])(),replacedDate:{date:__WEBPACK_IMPORTED_MODULE_17_moment___default()(),unix:__WEBPACK_IMPORTED_MODULE_17_moment___default()().unix().toString()},clientVtsNos:[]},_this.columns=['CLIENT NAME','UNIQUE DEVICE ID','SPARE PART NAME','SPARE PART NUMBER','DESCRIPTION','REPLACED PART NUMBER','REPLACED BY','REPLACED DATE'],_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15,onRowClick:function onRowClick(rowData,dataIndex,rowIndex){// console.log('meena', this.entityId[rowIndex])
var rD=rowData[7];var unixTs=__WEBPACK_IMPORTED_MODULE_17_moment___default()(''+rD).format('X');var newReplacedDate={date:rD,unix:unixTs};var clientLoginId=_this.getClientLoginId(rowData[0]);_this.setState({clientName:clientLoginId,vehicleSerialNo:rowData[1],sparePartName:rowData[2],sparePartNumber:rowData[3],description:rowData[4],replacedPartNumber:rowData[5],replacedBy:rowData[6],replacedDate:newReplacedDate,toUpdate:true,dataToBeDeleted:dataIndex.rowIndex},_this.getClientVtsNos);}},_this.getFormattedDate=function(timestamp){return __WEBPACK_IMPORTED_MODULE_17_moment___default()(timestamp*1000).format('YYYY/MM/DD');},_this.handleVtsNoChange=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.setState({vehicleSerialNo:event.value});case 1:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}(),_this.getAllClients=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var clientsDetails,allClients;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this.props.client.query({query:GET_CLIENTS,variables:{partnerLoginId:parseInt(_this.state.partnerLoginId,10),status:parseInt(_this.state.status,10)},fetchPolicy:'network-only'});case 2:clientsDetails=_context2.sent;// console.log(clientsDetails)
allClients=clientsDetails.data.clientsDetails.map(function(client){return{value:client.loginId,label:client.clientName};});_this.setState({clientsDetails:allClients});case 5:case'end':return _context2.stop();}}},_callee2,_this2);})),_this.getClientName=function(clientLoginId){console.log(clientLoginId);var clientName='NA';_this.state.clientsDetails.forEach(function(client,index){if(client.value===clientLoginId){clientName=client.label;}});return clientName;},_this.getClientLoginId=function(clientLoginValue){console.log(clientLoginValue);var clientValue=void 0;_this.state.clientsDetails.forEach(function(client,index){if(client.label===clientLoginValue){clientValue=client.value;}});return clientValue;},_this.handleInputChange=function(key){return function(e){var _this$state=_this.state,vehicleSerialNo=_this$state.vehicleSerialNo,sparePartNumber=_this$state.sparePartNumber,sparePartName=_this$state.sparePartName,description=_this$state.description,replacedPartNumber=_this$state.replacedPartNumber,replacedBy=_this$state.replacedBy,replacedDate=_this$state.replacedDate;if(sparePartNumber.length<25||sparePartName.length<30||replacedPartNumber.length<25||description.length<71||replacedBy.length<51){_this.setState(_defineProperty({},key,e.target.value));}};},_this.getVtsNos=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var loginId,_ref5,data,allVtsNos;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:loginId=parseInt(localStorage.getItem('Login_id'),10);_context3.next=3;return _this.props.client.query({query:GET_VEHICLE_SERIAL_NUMBERS,variables:{partnerLoginId:loginId},fetchPolicy:'network-only'});case 3:_ref5=_context3.sent;data=_ref5.data;allVtsNos=data.vtsNos.map(function(vtsNo){return{value:vtsNo.vtsNo,label:vtsNo.vtsNo,clientLoginId:vtsNo.clientLoginId};});// console.log('data', allVtsNos)
_this.setState({vtsNos:allVtsNos});case 7:case'end':return _context3.stop();}}},_callee3,_this2);})),_this.getSparePartsReplacementHistory=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){var loginId,_ref7,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:loginId=parseInt(localStorage.getItem('Login_id'),10);_context4.next=3;return _this.props.client.query({query:GET_SPAREPARTS_REPLACEMENT_HISTORY,variables:{partnerLoginId:loginId},fetchPolicy:'network-only'});case 3:_ref7=_context4.sent;data=_ref7.data;_this.mapToArr(data.sparePartsHistory);case 6:case'end':return _context4.stop();}}},_callee4,_this2);})),_this.handleDelete=function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(event){var _this$state2,toBeDeleted,vehicleSerialNo,sparePartNumber,sparePartName,description,replacedPartNumber,sparePartReplacementHistory,dataToBeDeleted,replacedBy,replacedDate,clientName,newReplacedDate,loginId,_ref9,data,errors;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0://TODO Construct here.
event.preventDefault();_this$state2=_this.state,toBeDeleted=_this$state2.toBeDeleted,vehicleSerialNo=_this$state2.vehicleSerialNo,sparePartNumber=_this$state2.sparePartNumber,sparePartName=_this$state2.sparePartName,description=_this$state2.description,replacedPartNumber=_this$state2.replacedPartNumber,sparePartReplacementHistory=_this$state2.sparePartReplacementHistory,dataToBeDeleted=_this$state2.dataToBeDeleted,replacedBy=_this$state2.replacedBy,replacedDate=_this$state2.replacedDate,clientName=_this$state2.clientName;newReplacedDate=parseInt(replacedDate.unix);loginId=parseInt(localStorage.getItem('Login_id'),10);_context5.next=6;return _this.props.client.mutate({mutation:SET_SPARE_PART,variables:{sparePartConfigs:[{toBeDeleted:true,uniqueDeviceId:vehicleSerialNo,sparePartNumber:sparePartNumber,sparePartName:sparePartName,description:description,replacedPartNumber:replacedPartNumber,replacedBy:replacedBy,replacedDate:newReplacedDate}],clientLoginId:clientName},errorPolicy:'all'});case 6:_ref9=_context5.sent;data=_ref9.data;errors=_ref9.errors;if(data){_this.props.openSnackbar('Spare Part deleted successfully');_this.setState({sparePartsTableLoading:true,sparePartName:'',sparePartNumber:'',replacedPartNumber:'',replacedDate:{date:__WEBPACK_IMPORTED_MODULE_17_moment___default()(),unix:__WEBPACK_IMPORTED_MODULE_17_moment___default()().unix().toString()},replacedBy:'',vehicleSerialNo:'',clientName:'',description:'',toBeDeleted:false,dataToBeDeleted:null,toUpdate:false},_this.getSparePartsReplacementHistory);}else{console.log(errors,'err');_this.props.openSnackbar(errors[0].message);}case 10:case'end':return _context5.stop();}}},_callee5,_this2);}));return function(_x2){return _ref8.apply(this,arguments);};}(),_this.checkSpNoIsPresent=function(sparePartReplacementHistory,sparePartNumber){var sparePartNumberPresent=false;sparePartReplacementHistory.forEach(function(ArrayElement,index){if(ArrayElement[3]===sparePartNumber){sparePartNumberPresent=true;}});return sparePartNumberPresent;},_this.handleSubmit=function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(event){var _this$state3,toBeDeleted,vehicleSerialNo,sparePartNumber,sparePartName,description,replacedPartNumber,replacedBy,replacedDate,clientName,toUpdate,dataToBeDeleted,sparePartReplacementHistory,newReplacedDate,loginId,sparePartNumberIsPresent,_ref11,data,errors,_ref12,_data,_errors;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0://TODO Construct here.
event.preventDefault();_this$state3=_this.state,toBeDeleted=_this$state3.toBeDeleted,vehicleSerialNo=_this$state3.vehicleSerialNo,sparePartNumber=_this$state3.sparePartNumber,sparePartName=_this$state3.sparePartName,description=_this$state3.description,replacedPartNumber=_this$state3.replacedPartNumber,replacedBy=_this$state3.replacedBy,replacedDate=_this$state3.replacedDate,clientName=_this$state3.clientName,toUpdate=_this$state3.toUpdate,dataToBeDeleted=_this$state3.dataToBeDeleted,sparePartReplacementHistory=_this$state3.sparePartReplacementHistory;newReplacedDate=parseInt(replacedDate.unix);console.log(toBeDeleted,vehicleSerialNo,sparePartNumber,sparePartName,description,replacedPartNumber,replacedBy,replacedDate,clientName,toUpdate,dataToBeDeleted);loginId=parseInt(localStorage.getItem('Login_id'),10);if(toUpdate){_context6.next=21;break;}sparePartNumberIsPresent=_this.checkSpNoIsPresent(sparePartReplacementHistory,sparePartNumber);if(sparePartNumberIsPresent){_context6.next=17;break;}_context6.next=10;return _this.props.client.mutate({mutation:SET_SPARE_PART,variables:{sparePartConfigs:[{toBeDeleted:toBeDeleted,uniqueDeviceId:vehicleSerialNo,sparePartNumber:sparePartNumber,sparePartName:sparePartName,description:description,replacedPartNumber:replacedPartNumber,replacedBy:replacedBy,replacedDate:newReplacedDate}],clientLoginId:clientName},errorPolicy:'all'});case 10:_ref11=_context6.sent;data=_ref11.data;errors=_ref11.errors;console.log(data);if(data){_this.props.openSnackbar('Spare Part operation successful');_this.setState({sparePartsTableLoading:true,sparePartName:'',sparePartNumber:'',replacedPartNumber:'',replacedDate:{date:__WEBPACK_IMPORTED_MODULE_17_moment___default()(),unix:__WEBPACK_IMPORTED_MODULE_17_moment___default()().unix().toString()},replacedBy:'',vehicleSerialNo:'',clientName:'',description:'',toBeDeleted:false,dataToBeDeleted:null,toUpdate:false},_this.getSparePartsReplacementHistory);}else{console.log(errors,'err');_this.props.openSnackbar(errors[0].message);}_context6.next=19;break;case 17:_this.setState({sparePartNumber:''});_this.props.openSnackbar('Spare Part Number Already Present');case 19:_context6.next=28;break;case 21:_context6.next=23;return _this.props.client.mutate({mutation:SET_SPARE_PART,variables:{sparePartConfigs:[{toBeDeleted:toBeDeleted,uniqueDeviceId:vehicleSerialNo,sparePartNumber:sparePartNumber,sparePartName:sparePartName,description:description,replacedPartNumber:replacedPartNumber,replacedBy:replacedBy,replacedDate:newReplacedDate}],clientLoginId:clientName},errorPolicy:'all'});case 23:_ref12=_context6.sent;_data=_ref12.data;_errors=_ref12.errors;console.log(_data);if(_data){_this.props.openSnackbar('Spare Part operation successful');_this.setState({sparePartsTableLoading:true,sparePartName:'',sparePartNumber:'',replacedPartNumber:'',replacedDate:{date:__WEBPACK_IMPORTED_MODULE_17_moment___default()(),unix:__WEBPACK_IMPORTED_MODULE_17_moment___default()().unix().toString()},replacedBy:'',vehicleSerialNo:'',clientName:'',description:'',toBeDeleted:false,dataToBeDeleted:null,toUpdate:false},_this.getSparePartsReplacementHistory);}else{console.log(_errors,'err');_this.props.openSnackbar(_errors[0].message);}case 28:case'end':return _context6.stop();}}},_callee6,_this2);}));return function(_x3){return _ref10.apply(this,arguments);};}(),_this.getClientVtsNos=function(){var allVtsNos=[].concat(_toConsumableArray(_this.state.vtsNos));var clientName=_this.state.clientName;var clientVtsNos=[];allVtsNos.forEach(function(vts,index){if(vts.clientLoginId===clientName){clientVtsNos.push(allVtsNos[index]);}});_this.setState({clientVtsNos:clientVtsNos});},_this.handleCancel=function(){_this.setState({sparePartName:'',sparePartNumber:'',replacedPartNumber:'',replacedDate:{date:__WEBPACK_IMPORTED_MODULE_17_moment___default()(),unix:__WEBPACK_IMPORTED_MODULE_17_moment___default()().unix().toString()},replacedBy:'',vehicleSerialNo:'',clientName:'',description:'',toBeDeleted:false,dataToBeDeleted:null,toUpdate:false});},_this.handleDateChange=function(name){return function(date){var tempDate=_this.state[name];tempDate.date=date;console.log(date);tempDate.unix=__WEBPACK_IMPORTED_MODULE_17_moment___default()(date).unix().toString();_this.setState(_defineProperty({},name,tempDate));};},_this.handleChangeClient=function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(e){var cltId;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:cltId=parseInt(e.value,10);_this.setState({clientName:cltId,vehicleSerialNo:''},_this.getClientVtsNos);case 2:case'end':return _context7.stop();}}},_callee7,_this2);}));return function(_x4){return _ref13.apply(this,arguments);};}(),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SparePartReplacement,[{key:'mapToArr',value:function mapToArr(spareParts){var _this3=this;var rowData=[];var fullData=[];spareParts.forEach(function(element,index){rowData=[];// console.log(element)
var description=element.description?element.description:'NA';var clientName=_this3.getClientName(element.clientLoginId);rowData.push(clientName);rowData.push(element.uniqueDeviceId);rowData.push(element.sparePartName);rowData.push(element.sparePartNumber);rowData.push(description);rowData.push(element.replacedPartNumber);rowData.push(element.replacedBy);rowData.push(_this3.getFormattedDate(element.replacedDate));// console.log(rowData)
fullData.push(rowData);});this.setState({sparePartReplacementHistory:fullData,sparePartsTableLoading:false});}},{key:'componentDidMount',value:function(){var _ref14=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return this.getVtsNos(this.props.client);case 2:if(!(this.props.match.params.loginId===undefined)){_context8.next=7;break;}_context8.next=5;return this.getAllClients();case 5:_context8.next=11;break;case 7:_context8.next=9;return this.getAllClients();case 9:_context8.next=11;return this.handleChangeClient();case 11:_context8.next=13;return this.getSparePartsReplacementHistory(this.props.client);case 13:case'end':return _context8.stop();}}},_callee8,this);}));function componentDidMount(){return _ref14.apply(this,arguments);}return componentDidMount;}()},{key:'render',value:function render(){console.log(this.state);console.log(this.props);var classes=this.props.classes;var _state=this.state,vehicleSerialNo=_state.vehicleSerialNo,sparePartNumber=_state.sparePartNumber,sparePartName=_state.sparePartName,description=_state.description,replacedPartNumber=_state.replacedPartNumber,replacedBy=_state.replacedBy,replacedDate=_state.replacedDate,sparePartReplacementHistory=_state.sparePartReplacementHistory,sparePartsTableLoading=_state.sparePartsTableLoading,toUpdate=_state.toUpdate;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'title',gutterBottom:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Spare Part Replacement Details ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true,className:'searchdiv',spacing:8,justify:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{style:{marginRight:'20px'}},'Customer Name :'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default.a,{style:{minWidth:'50%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select__["a" /* default */],{classes:classes,options:this.state.clientsDetails,value:this.state.clientName,onChange:this.handleChangeClient,placeholder:'Select Customer *'// disabled={this.state.toUpdate}
}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default.a,{style:{minWidth:'70%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select__["a" /* default */],{classes:classes.paper,options:this.state.clientVtsNos// components={components}
,value:this.state.vehicleSerialNo,onChange:this.handleVtsNoChange,placeholder:'Select unique device Id'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,fullwidth:'true'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default.a,{style:{minWidth:'70%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_TextField___default.a,{disabled:toUpdate,id:'sparePartNumber',name:'sparePartNumber',className:'textfield',margin:'dense',label:'Spare Part Number'// type="Multi-line"
,value:this.state.sparePartNumber,required:true,onChange:this.handleInputChange('sparePartNumber')})))),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,fullwidth:'true'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default.a,{style:{minWidth:'70%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_TextField___default.a,{id:'sparePartName',name:'sparePartName',className:'textfield',margin:'dense',label:'Spare part name',value:this.state.sparePartName,required:true,onChange:this.handleInputChange('sparePartName')})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,fullwidth:'true'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default.a,{style:{minWidth:'70%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_TextField___default.a,{id:'description',name:'description',className:'textfield',margin:'dense',label:'Description',value:this.state.description,onChange:this.handleInputChange('description')})))),' '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,fullwidth:'true'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default.a,{style:{minWidth:'70%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_TextField___default.a,{id:'replacedPartNumber',name:'replacedPartNumber',className:'textfield',margin:'dense',label:'Replaced part number',value:this.state.replacedPartNumber,required:true,onChange:this.handleInputChange('replacedPartNumber')})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,fullwidth:'true'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default.a,{style:{minWidth:'70%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_TextField___default.a,{id:'replacedBy',name:'replacedBy',className:'textfield',margin:'dense',label:'Replaced by'// type="Multi-line"
,value:this.state.replacedBy,required:true,onChange:this.handleInputChange('replacedBy')})))),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,fullwidth:'true'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default.a,{style:{minWidth:'70%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_material_ui_pickers__["a" /* DatePicker */],{format:'DD/MM/YYYY',maxDate:new Date(),value:this.state.replacedDate.date,onChange:this.handleDateChange('replacedDate'),label:'Replaced date'}))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_FormGroup___default.a,{className:'form-input',style:{padding:'25px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{justify:'left',container:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{variant:'contained',color:'secondary',className:classes.button,onClick:this.handleSubmit,disabled:vehicleSerialNo===''||sparePartNumber===''||sparePartName===''||replacedPartNumber===''||replacedBy===''},'\u21AA Submit'),toUpdate&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{variant:'contained',color:'primary',className:classes.button,onClick:this.handleDelete},'\uD83D\uDDD1\uFE0F Delete'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{variant:'outlined',color:'primary',className:classes.button,onClick:this.handleCancel},'\u274C Cancel')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12},sparePartsTableLoading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Loading...'):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_mui_datatables___default.a,{data:sparePartReplacementHistory,columns:this.columns,options:this.options})));}}]);return SparePartReplacement;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_10__HOCs_withSharedSnackbar__["a" /* default */])(SparePartReplacement))));

/***/ }),
/* 2441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Card__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_CardHeader__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_CardHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_CardHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_CardContent__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_CardContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_CardContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_CardActions__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_CardActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_CardActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_material_ui_pickers__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_getAccountType__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_router_dom_withRouter__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_router_dom_withRouter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react_router_dom_withRouter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__common_Loader__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_icons_ArrowBack__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_icons_ArrowBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__material_ui_icons_ArrowBack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__ViewSubscription_PaymentMethod__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_mui_datatables__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getPartnerSubscriptions($id: Int!) {\n    partnerSubscription: getPartnerSubscriptions(id: $id) {\n      id\n      partnerLoginId\n      status\n      createdAt\n      salesRemarks\n      gst\n      partnerDetail {\n        id\n        businessName\n      }\n      billingFrequency {\n        id\n        frequency\n      }\n      noOfDevices\n      nextPaymentDate\n      totalSoftwareQty\n      unassignedDeviceQuantity\n      unassignedSimQty\n      unassignedAccessoryQty\n      deviceTrackingCharges\n      billingMode {\n        id\n        billingMode\n      }\n      billingDetails {\n        paymentId\n        totalAmount\n        totalAmountWithGST\n        softwareBill {\n          quantity\n          rate\n          amountWithGST\n          amountToBePaid\n          amountPaidGST\n        }\n        hardwareBill {\n          quantity\n          rate\n          amountWithGST\n          amountToBePaid\n          amountPaidGST\n        }\n        accessoryBill {\n          quantity\n          rate\n          amountWithGST\n          amountToBePaid\n          amountPaidGST\n        }\n        simBill {\n          quantity\n          rate\n          amountWithGST\n          amountToBePaid\n          amountPaidGST\n        }\n      }\n    }\n  }\n'],['\n  query getPartnerSubscriptions($id: Int!) {\n    partnerSubscription: getPartnerSubscriptions(id: $id) {\n      id\n      partnerLoginId\n      status\n      createdAt\n      salesRemarks\n      gst\n      partnerDetail {\n        id\n        businessName\n      }\n      billingFrequency {\n        id\n        frequency\n      }\n      noOfDevices\n      nextPaymentDate\n      totalSoftwareQty\n      unassignedDeviceQuantity\n      unassignedSimQty\n      unassignedAccessoryQty\n      deviceTrackingCharges\n      billingMode {\n        id\n        billingMode\n      }\n      billingDetails {\n        paymentId\n        totalAmount\n        totalAmountWithGST\n        softwareBill {\n          quantity\n          rate\n          amountWithGST\n          amountToBePaid\n          amountPaidGST\n        }\n        hardwareBill {\n          quantity\n          rate\n          amountWithGST\n          amountToBePaid\n          amountPaidGST\n        }\n        accessoryBill {\n          quantity\n          rate\n          amountWithGST\n          amountToBePaid\n          amountPaidGST\n        }\n        simBill {\n          quantity\n          rate\n          amountWithGST\n          amountToBePaid\n          amountPaidGST\n        }\n      }\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  mutation(\n    $partnerLoginId: Int!\n    $paymentId: Int!\n    $partnerSubscriptionId: Int!\n    $approveOrReject: approveOrReject!\n    $paidDetails: inputBillingDetails\n    $paymentMode: paymentMode\n    $bankName: String\n    $referenceNumber: String\n    $accountsRemarks: String\n  ) {\n    approveOrRejectPartnerSubscription(\n      partnerLoginId: $partnerLoginId\n      paymentId: $paymentId\n      partnerSubscriptionId: $partnerSubscriptionId\n      approveOrReject: $approveOrReject\n      paidDetails: $paidDetails\n      paymentMode: $paymentMode\n      bankName: $bankName\n      referenceNumber: $referenceNumber\n      accountsRemarks: $accountsRemarks\n    )\n  }\n'],['\n  mutation(\n    $partnerLoginId: Int!\n    $paymentId: Int!\n    $partnerSubscriptionId: Int!\n    $approveOrReject: approveOrReject!\n    $paidDetails: inputBillingDetails\n    $paymentMode: paymentMode\n    $bankName: String\n    $referenceNumber: String\n    $accountsRemarks: String\n  ) {\n    approveOrRejectPartnerSubscription(\n      partnerLoginId: $partnerLoginId\n      paymentId: $paymentId\n      partnerSubscriptionId: $partnerSubscriptionId\n      approveOrReject: $approveOrReject\n      paidDetails: $paidDetails\n      paymentMode: $paymentMode\n      bankName: $bankName\n      referenceNumber: $referenceNumber\n      accountsRemarks: $accountsRemarks\n    )\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_PARTNER_SUBSCRIPTION=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject);var APPROVE_REJECT_PARTNER_SUBSCRIPTION=Object(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__["a" /* default */])(_templateObject2);var styles=function styles(theme){return{containerStyle:{margin:'0 2%'},rowStyle:{margin:'15px 0'},textFieldStyle:{width:'55%'},dateStyle:{width:'50%'},subHeadingStyle:{marginLeft:'1.9vw',marginBottom:'10px',fontSize:'1rem',fontWeight:'bold'},cardAction:{marginLeft:'-1.9vw'},selectStyle:{minWidth:250},redButton:{backgroundColor:theme.palette.error.main,'&:hover':{backgroundColor:theme.palette.error.dark}}};};var paymentOption=['NONE','CASH','ONLINE','CHEQUE','DD'];var PartnerSubscriptionDetail=function(_Component){_inherits(PartnerSubscriptionDetail,_Component);function PartnerSubscriptionDetail(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,PartnerSubscriptionDetail);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PartnerSubscriptionDetail.__proto__||Object.getPrototypeOf(PartnerSubscriptionDetail)).call.apply(_ref,[this].concat(args))),_this),_this.state={partnerLoginId:0,partnerSubscriptionData:null,hardwarePaymentMade:0,softwarePaymentMade:0,accessoryPaymentMade:0,simPaymentMade:0,paymentId:0,hardwareBalance:0,softwareBalance:0,accessoryBalance:0,simBalance:0,hardwareRemarks:null,softwareRemarks:null,accessoryRemarks:null,simRemarks:null,// expectedHardwareDueDate: moment()
//   .add(7, 'days')
//   .format('DD-MM-YYYY'),
expectedHardwareDueDate:__WEBPACK_IMPORTED_MODULE_16_moment___default()().add(1,'weeks'),expectedSoftwareDueDate:__WEBPACK_IMPORTED_MODULE_16_moment___default()().add(1,'weeks'),expectedAccessoryDueDate:__WEBPACK_IMPORTED_MODULE_16_moment___default()().add(1,'weeks'),expectedSimsDueDate:__WEBPACK_IMPORTED_MODULE_16_moment___default()().add(1,'weeks'),approveOrReject:null,isLoading:true,paymentMode:'',referenceNumber:null,bankName:null,isEditButton:true,isValidReferenceNumber:true,referenceMessage:'',allInvoiceData:[]},_this.getFormattedDate=function(date1){var d1=parseInt(date1,10);var unixEpochTimeMS=d1*1000;var d=new Date(unixEpochTimeMS);// Careful, the string output here can vary by implementation...
var strDate=d.toLocaleDateString();return strDate;},_this.handleEditSubcription=function(){// console.log('this.props.location', this.props.match.params)
_this.props.history.push({pathname:'/home/partner/view/'+_this.props.match.params.loginId+'/'+_this.props.match.params.subscriptionId+'/partnerSubscriptionEdit'});},_this.handlePaymentMade=function(name){return function(event){var value=event.target.value;if(value>=0){_this.setState(_defineProperty({},name,value),function(){_this.calculateBalance(name);});}};},_this.calculateBalance=function(particularName){var _this$state=_this.state,hardwarePaymentMade=_this$state.hardwarePaymentMade,softwarePaymentMade=_this$state.softwarePaymentMade,accessoryPaymentMade=_this$state.accessoryPaymentMade,simPaymentMade=_this$state.simPaymentMade;var partnerSubscriptionData=_this.state.partnerSubscriptionData;var _partnerSubscriptionD=partnerSubscriptionData.billingDetails,hardwareBill=_partnerSubscriptionD.hardwareBill,softwareBill=_partnerSubscriptionD.softwareBill,accessoryBill=_partnerSubscriptionD.accessoryBill,simBill=_partnerSubscriptionD.simBill;// console.log('balance calculating:', particularName)
var balanceAmount=0;if(particularName==='hardwarePaymentMade'){balanceAmount=hardwareBill.amountWithGST-hardwarePaymentMade;_this.setState({hardwareBalance:balanceAmount});}if(particularName==='softwarePaymentMade'){balanceAmount=softwareBill.amountWithGST-softwarePaymentMade;_this.setState({softwareBalance:balanceAmount});}if(particularName==='accessoryPaymentMade'){balanceAmount=accessoryBill.amountWithGST-accessoryPaymentMade;_this.setState({accessoryBalance:balanceAmount});}if(particularName==='simPaymentMade'){balanceAmount=simBill.amountWithGST-simPaymentMade;_this.setState({simBalance:balanceAmount});}},_this.handleRemarksChange=function(name){return function(event){var value=event.target.value;_this.setState(_defineProperty({},name,value));};},_this.handleExpectedDateChange=function(name){return function(date){_this.setState(_defineProperty({},name,date));};},_this.handleChangePaymentType=function(event){_this.setState({paymentMode:event.target.value,isValidReferenceNumber:true,referenceMessage:'',referenceNumber:null,bankName:null});},_this.handleChangeReferenceNumber=function(event){console.log('reference number',_typeof(event.target.value));_this.setState({referenceNumber:event.target.value});},_this.checkReferenceNumberValidity=function(){var regExValue=new RegExp(/(^[a-zA-Z0-9]{6,15})|(^[0-9]{6,15})|(^[a-zA-Z]{6,15})|(?!)$/);if(_this.state.referenceNumber===null){_this.setState({isValidReferenceNumber:true,referenceMessage:'Please enter Reference/DD/Check number'});}else if(regExValue.test(_this.state.referenceNumber)&&_this.state.referenceNumber!==' '){_this.setState({isValidReferenceNumber:true,referenceMessage:''});}else if(_this.state.referenceNumber===''){_this.setState({isValidReferenceNumber:false,referenceMessage:'Please enter Reference/DD/Check number'});}else{_this.setState({isValidReferenceNumber:false,referenceMessage:'Please enter a valid Reference/DD/Check number'});}},_this.handleChangeBankName=function(event){_this.setState({bankName:event.target.value});},_this.assignDevice=function(){_this.props.history.push({pathname:'/home/partnerSubscriptions/assign/'+_this.props.match.params.loginId+'/'+_this.props.match.params.subscriptionId});},_this.validateFields=function(){// console.log('this.state.paymentModeff', this.state.paymentMode)
var _this$state2=_this.state,hardwarePaymentMade=_this$state2.hardwarePaymentMade,softwarePaymentMade=_this$state2.softwarePaymentMade,simPaymentMade=_this$state2.simPaymentMade,accessoryPaymentMade=_this$state2.accessoryPaymentMade;// console.log('meena', this.state.paidMoney, this.state.paymentMode)
if(hardwarePaymentMade===''){_this.props.openSnackbar('Hardware payment made should not be blank!');return false;}else if(softwarePaymentMade===''){_this.props.openSnackbar('Software payment made should not be blank!');return false;}else if(accessoryPaymentMade===''){_this.props.openSnackbar('Accessory payment made should not be blank!');return false;}else if(simPaymentMade===''){_this.props.openSnackbar('Sim payment made should not be blank!');return false;}else if(_this.state.hardwarePaymentMade===0&&_this.state.softwarePaymentMade===0&&_this.state.accessoryPaymentMade===0&&_this.state.simPaymentMade===0&&_this.state.paymentMode!=='NONE'){_this.props.openSnackbar('Please Select NONE option if you are not paying any amount!');return false;}else if((_this.state.hardwarePaymentMade>0||_this.state.softwarePaymentMade>0||_this.state.accessoryPaymentMade>0||_this.state.simPaymentMade>0)&&_this.state.paymentMode==='NONE'){_this.props.openSnackbar('Please select valid  payment option if you are making payment!');return false;}else if(_this.state.paymentMode==='ONLINE'){if(_this.state.referenceNumber===null||_this.state.referenceNumber===''){_this.props.openSnackbar('Reference Number Should not be blank');_this.setState({validation:false});return false;}else{_this.setState({validation:true});return true;}}else if(_this.state.paymentMode==='DD'||_this.state.paymentMode==='CHEQUE'){if(_this.state.referenceNumber===null||_this.state.referenceNumber===''){_this.props.openSnackbar('Reference Number Should not blank!');_this.setState({validation:false});return false;}else if(_this.state.bankName===null){_this.props.openSnackbar('Bank Name Should not blank!');_this.setState({validation:false});return false;}else{_this.setState({validation:true});return true;}}else{_this.setState({validation:true});return true;}},_this.handleRejectMutation=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _ref3,data,approveOrRejectPartnerSubscription;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.client.mutate({mutation:APPROVE_REJECT_PARTNER_SUBSCRIPTION,variables:{partnerLoginId:parseInt(_this.state.partnerLoginId,10),paymentId:parseInt(_this.state.paymentId,10),partnerSubscriptionId:parseInt(_this.props.match.params.subscriptionId,10),approveOrReject:_this.state.approveOrReject,accountsRemarks:_this.state.accountRemarks}});case 2:_ref3=_context.sent;data=_ref3.data;approveOrRejectPartnerSubscription=data.approveOrRejectPartnerSubscription;if(approveOrRejectPartnerSubscription){_this.props.openSnackbar('Subscription Rejected');_this.props.history.goBack();}case 6:case'end':return _context.stop();}}},_callee,_this2);})),_this.handleCancel=function(){_this.setState({approveOrReject:'REJECTED'},function(){_this.handleRejectMutation();});},_this.handleApproveMutation=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var _ref5,data,approveOrRejectPartnerSubscription;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this.props.client.mutate({mutation:APPROVE_REJECT_PARTNER_SUBSCRIPTION,variables:{partnerLoginId:parseInt(_this.state.partnerLoginId,10),partnerSubscriptionId:parseInt(_this.props.match.params.subscriptionId,10),paidDetails:{hardwareBill:{amountWithGST:parseInt(_this.state.hardwarePaymentMade,10),expectedDateTime:__WEBPACK_IMPORTED_MODULE_16_moment___default()(_this.state.expectedSoftwareDueDate).unix().toString(),accountsRemrks:_this.state.hardwareRemarks},softwareBill:{amountWithGST:parseInt(_this.state.softwarePaymentMade,10),expectedDateTime:__WEBPACK_IMPORTED_MODULE_16_moment___default()(_this.state.expectedHardwareDueDate).unix().toString(),accountsRemrks:_this.state.softwareRemarks},accessoryBill:{amountWithGST:parseInt(_this.state.accessoryPaymentMade,10),expectedDateTime:__WEBPACK_IMPORTED_MODULE_16_moment___default()(_this.state.expectedAccessoryDueDate).unix().toString(),accountsRemrks:_this.state.accessoryRemarks},simBill:{amountWithGST:parseInt(_this.state.simPaymentMade,10),expectedDateTime:__WEBPACK_IMPORTED_MODULE_16_moment___default()(_this.state.expectedSimsDueDate).unix().toString(),accountsRemrks:_this.state.simRemarks}},paymentMode:_this.state.paymentMode,paymentId:parseInt(_this.state.paymentId,10),bankName:_this.state.bankName,referenceNumber:_this.state.referenceNumber,accountsRemarks:_this.state.accountRemarks,approveOrReject:_this.state.approveOrReject}});case 2:_ref5=_context2.sent;data=_ref5.data;approveOrRejectPartnerSubscription=data.approveOrRejectPartnerSubscription;if(approveOrRejectPartnerSubscription){_this.props.openSnackbar(' Subscription Approved');_this.props.history.goBack();}case 6:case'end':return _context2.stop();}}},_callee2,_this2);})),_this.handleSubmit=function(){if(_this.validateFields()){_this.setState({approveOrReject:'APPROVED'},function(){_this.handleApproveMutation();});}},_this.setInitialBalanceAndEditBooleans=function(){var partnerSubscriptionData=_this.state.partnerSubscriptionData;if(partnerSubscriptionData.billingDetails){var _partnerSubscriptionD2=partnerSubscriptionData.billingDetails,hardwareBill=_partnerSubscriptionD2.hardwareBill,softwareBill=_partnerSubscriptionD2.softwareBill,accessoryBill=_partnerSubscriptionD2.accessoryBill,simBill=_partnerSubscriptionD2.simBill;if(hardwareBill){_this.setState({hardwareBalance:hardwareBill.amountWithGST});}if(softwareBill){_this.setState({softwareBalance:softwareBill.amountWithGST});}if(accessoryBill){_this.setState({accessoryBalance:accessoryBill.amountWithGST});}if(simBill){_this.setState({simBalance:simBill.amountWithGST});}}if(partnerSubscriptionData.status===1||partnerSubscriptionData.status===3||partnerSubscriptionData.status===4){_this.setState({isEditButton:false});}else{_this.setState({isEditButton:true});}},_this.getPartnerSubscriptionData=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var _ref7,data,loading,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return _this.props.client.query({query:GET_PARTNER_SUBSCRIPTION,variables:{id:parseInt(_this.props.match.params.subscriptionId,10)// id: 23
},fetchPolicy:'network-only'});case 2:_ref7=_context3.sent;data=_ref7.data;loading=_ref7.loading;error=_ref7.error;// console.log('lladong', loading, data, error)
if(!loading){_this.setState({isLoading:loading,partnerSubscriptionData:data.partnerSubscription},function(){_this.setInitialBalanceAndEditBooleans();_this.getPaymentAndPartnerLogInId();});// console.log('hh', data.partnerSubscription)
}case 7:case'end':return _context3.stop();}}},_callee3,_this2);})),_this.getPaymentAndPartnerLogInId=function(){var partnerSubscriptionData=_this.state.partnerSubscriptionData;// console.log('partnerSubscriptionData', partnerSubscriptionData)
if(partnerSubscriptionData.billingDetails!==null){_this.setState({paymentId:partnerSubscriptionData.billingDetails.paymentId});}else{_this.setState({paymentId:0});}_this.setState({partnerLoginId:partnerSubscriptionData.partnerLoginId});},_this.componentDidMount=function(){_this.getPartnerSubscriptionData();},_this.getStatusType=function(status){// console.log(getAccountType(), status, 'alllll')
if(status===1||status===4){return'Pending';}else if(status===2||status===5){return'Approved';}else if(status===3){return'Rejected';}},_this.getGst=function(Gst){return Gst*100;},_this.handleAccountRemarksChange=function(e){_this.setState({accountRemarks:e.target.value});},_temp),_possibleConstructorReturn(_this,_ret);}// handleChangePaidMoney = event => {
//   this.setState({ paidMoney: event.target.value })
// }
_createClass(PartnerSubscriptionDetail,[{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;var _state=this.state,isLoading=_state.isLoading,partnerSubscriptionData=_state.partnerSubscriptionData;// console.log('loading', this.state.partnerSubscriptionData, isLoading)
// let isTrue = isOne && isTwo ? 'True' : 'false'
// let isFalse = isTwo ? 'true' : 'false'
console.log(partnerSubscriptionData,'======',this.state.expectedSoftwareDueDate,this.state.expectedHardwareDueDate);var _state2=this.state,hardwarePaymentMade=_state2.hardwarePaymentMade,softwarePaymentMade=_state2.softwarePaymentMade,accessoryPaymentMade=_state2.accessoryPaymentMade,simPaymentMade=_state2.simPaymentMade,hardwareBalance=_state2.hardwareBalance,softwareBalance=_state2.softwareBalance,accessoryBalance=_state2.accessoryBalance,simBalance=_state2.simBalance,expectedHardwareDueDate=_state2.expectedHardwareDueDate,expectedSoftwareDueDate=_state2.expectedSoftwareDueDate,expectedAccessoryDueDate=_state2.expectedAccessoryDueDate,expectedSimsDueDate=_state2.expectedSimsDueDate,isEditButton=_state2.isEditButton;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,isLoading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__common_Loader__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{className:classes.containerStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,justify:'space-between'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.gridItemHorizontal},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Button___default.a,{variant:'outlined',color:'secondary',className:classes.button,onClick:function onClick(){return _this3.props.history.goBack();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_icons_ArrowBack___default.a,{className:classes.iconSmall}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.gridItemHorizontal},!['INV','ACC'].includes(Object(__WEBPACK_IMPORTED_MODULE_14__utils_getAccountType__["a" /* default */])())&&isEditButton&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Button___default.a,{variant:'contained',color:'secondary',className:classes.button,onClick:this.handleEditSubcription},'Edit'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'display1'},'\xA0',partnerSubscriptionData.partnerDetail.businessName))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Card___default.a,{raised:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_CardHeader___default.a,{classes:{action:classes.cardAction}// title={partnerSubscriptionData.partnerDetail.businessName}
,title:partnerSubscriptionData.billingFrequency.frequency,subheader:partnerSubscriptionData?this.getFormattedDate(partnerSubscriptionData.createdAt):'N/A',action:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body1',style:{fontSize:'20px',paddingTop:'10%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{opacity:'.6'}},'Status:'),' ',partnerSubscriptionData?this.getStatusType(partnerSubscriptionData.status):'N/A'))}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6,sm:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body2'},'Quantity:'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body1'},partnerSubscriptionData.totalSoftwareQty)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6,sm:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body2'},'MMTC:'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9',partnerSubscriptionData.totalSoftwareQty>0?partnerSubscriptionData.deviceTrackingCharges+' /-':'N/A')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6,sm:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body2'},'Un-assigned Quantity'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body1'},partnerSubscriptionData.noOfDevices)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6,sm:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body2'},'Next Payment Date:'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body1'},__WEBPACK_IMPORTED_MODULE_16_moment___default.a.unix(parseInt(partnerSubscriptionData.nextPaymentDate,10)).format('DD/MM/YYYY'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6,sm:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body2'},'Bill Mode:'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body1'},partnerSubscriptionData.billingMode.billingMode)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6,sm:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body2'},'Sales Remarks:'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body1'},partnerSubscriptionData.salesRemarks?partnerSubscriptionData.salesRemarks:'N/A')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6,sm:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body2'},'Total Amount (Incl. GST)'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9',partnerSubscriptionData.billingDetails?partnerSubscriptionData.billingDetails.totalAmountWithGST:'N/A')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6,sm:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body2'},'GST Rate:'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body1'},partnerSubscriptionData.gst?this.getGst(partnerSubscriptionData.gst):'N/A')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('cardAction',null))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},partnerSubscriptionData.billingDetails&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Card___default.a,{raised:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_CardHeader___default.a,{className:classes.cardAction,title:'Billing Details'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,justify:'space-between'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,style:{marginRight:'7vw'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,direction:'column',alignContent:'space-between'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body2'},'PARTICULARS')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body2'},' Quantity')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body2'},' Price/item')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body2'},' ','Total Amount(Incl. GST)')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body2'},' ','Amount paid(Incl. GST)')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body2'},' ','Amount to be paid(Incl. GST)')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},['ACC'].includes(Object(__WEBPACK_IMPORTED_MODULE_14__utils_getAccountType__["a" /* default */])())&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body2'},' ','Payment Made')))),partnerSubscriptionData.billingDetails.hardwareBill&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,direction:'column',alignContent:'space-between'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body2'},' HARDWARE')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body1'},' ',partnerSubscriptionData.billingDetails.hardwareBill.quantity)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9',' ',partnerSubscriptionData.billingDetails.hardwareBill.rate)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9',' ',partnerSubscriptionData.billingDetails.hardwareBill.amountWithGST)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9',' ',partnerSubscriptionData.billingDetails.hardwareBill.amountPaidGST)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9',' ',partnerSubscriptionData.billingDetails.hardwareBill.amountToBePaid)),['ACC'].includes(Object(__WEBPACK_IMPORTED_MODULE_14__utils_getAccountType__["a" /* default */])())&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},'\u20B9',' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_TextField___default.a,{disabled:['SA'].includes(Object(__WEBPACK_IMPORTED_MODULE_14__utils_getAccountType__["a" /* default */])()),id:'amount',type:'Number',className:classes.textFieldStyle,label:'Paid Amount *',inputProps:{min:0},value:hardwarePaymentMade,onChange:this.handlePaymentMade('hardwarePaymentMade'),margin:'none'})))),partnerSubscriptionData.billingDetails.softwareBill&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,direction:'column',alignContent:'space-between'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body2'},' SOFTWARE')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body1'},' ',partnerSubscriptionData.billingDetails.softwareBill.quantity)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9',' ',partnerSubscriptionData.billingDetails.softwareBill.rate)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9',' ',partnerSubscriptionData.billingDetails.softwareBill.amountWithGST)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9',' ',partnerSubscriptionData.billingDetails.softwareBill.amountPaidGST)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9',' ',partnerSubscriptionData.billingDetails.softwareBill.amountToBePaid)),['ACC'].includes(Object(__WEBPACK_IMPORTED_MODULE_14__utils_getAccountType__["a" /* default */])())&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},'\u20B9',' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_TextField___default.a,{disabled:['SA'].includes(Object(__WEBPACK_IMPORTED_MODULE_14__utils_getAccountType__["a" /* default */])()),id:'amount',type:'Number',className:classes.textFieldStyle,label:'Paid Amount *',inputProps:{min:0},value:softwarePaymentMade,onChange:this.handlePaymentMade('softwarePaymentMade'),margin:'none'})))),partnerSubscriptionData.billingDetails.accessoryBill&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,direction:'column',alignContent:'space-between'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body2'},' ','ACCESSORY')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body1'},' ',partnerSubscriptionData.billingDetails.accessoryBill.quantity)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9',' ',partnerSubscriptionData.billingDetails.accessoryBill.rate)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9',' ',partnerSubscriptionData.billingDetails.accessoryBill.amountWithGST)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9',' ',partnerSubscriptionData.billingDetails.accessoryBill.amountPaidGST)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9',' ',partnerSubscriptionData.billingDetails.accessoryBill.amountToBePaid)),['ACC'].includes(Object(__WEBPACK_IMPORTED_MODULE_14__utils_getAccountType__["a" /* default */])())&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},'\u20B9',' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_TextField___default.a,{disabled:['SA'].includes(Object(__WEBPACK_IMPORTED_MODULE_14__utils_getAccountType__["a" /* default */])()),id:'amount',type:'Number',className:classes.textFieldStyle,label:'Paid Amount *',inputProps:{min:0},value:accessoryPaymentMade,onChange:this.handlePaymentMade('accessoryPaymentMade'),margin:'none'})))),partnerSubscriptionData.billingDetails.simBill&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,direction:'column',alignContent:'space-between'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body2'},' SIMS')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body1'},' ',partnerSubscriptionData.billingDetails.simBill.quantity)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9',' ',partnerSubscriptionData.billingDetails.simBill.rate)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9',' ',partnerSubscriptionData.billingDetails.simBill.amountWithGST)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9',' ',partnerSubscriptionData.billingDetails.simBill.amountPaidGST)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9',' ',partnerSubscriptionData.billingDetails.simBill.amountToBePaid)),['ACC'].includes(Object(__WEBPACK_IMPORTED_MODULE_14__utils_getAccountType__["a" /* default */])())&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},'\u20B9',' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_TextField___default.a,{disabled:['SA'].includes(Object(__WEBPACK_IMPORTED_MODULE_14__utils_getAccountType__["a" /* default */])()),id:'amount',type:'Number',className:classes.textFieldStyle,label:'Paid Amount *',inputProps:{min:0},value:simPaymentMade,onChange:this.handlePaymentMade('simPaymentMade'),margin:'none'})))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},partnerSubscriptionData.billingDetails&&['ACC'].includes(Object(__WEBPACK_IMPORTED_MODULE_14__utils_getAccountType__["a" /* default */])())&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Card___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_CardHeader___default.a,{className:classes.cardAction,title:'Credit Notes'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,justify:'space-between'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,style:{marginRight:'7vw'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,direction:'column',alignContent:'space-between'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body2'},' Balance')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,style:{margin:'25px 0'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body2'},' ','Expected Due Date')))),partnerSubscriptionData.billingDetails.hardwareBill?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,disabled:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,direction:'column',alignContent:'space-between'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9 ',hardwareBalance)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_material_ui_pickers__["a" /* DatePicker */],{disabled:hardwareBalance===0,className:classes.dateStyle,label:'Due Date',value:expectedHardwareDueDate// views={['year', 'month', 'date']}
// format="dd/MM/yyyy"
,onChange:this.handleExpectedDateChange('expectedHardwareDueDate'),format:'DD/MM/YYYY'})))):null,partnerSubscriptionData.billingDetails.softwareBill?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,direction:'column',alignContent:'space-between'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9 ',softwareBalance)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_material_ui_pickers__["a" /* DatePicker */],{disabled:softwareBalance===0,className:classes.dateStyle,label:'Due Date',value:expectedSoftwareDueDate,format:'DD/MM/YYYY',onChange:this.handleExpectedDateChange('expectedSoftwareDueDate')// inputProps={{
//   name: 'expiryDateTime'
// }}
})))):null,partnerSubscriptionData.billingDetails.accessoryBill?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,direction:'column',alignContent:'space-between'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9 ',accessoryBalance)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_material_ui_pickers__["a" /* DatePicker */],{disabled:accessoryBalance===0,className:classes.dateStyle,label:'Due Date',value:expectedAccessoryDueDate,onChange:this.handleExpectedDateChange('expectedAccessoryDueDate'),format:'DD/MM/YYYY'// inputProps={{
//   name: 'expiryDateTime'
// }}
})))):null,partnerSubscriptionData.billingDetails.simBill?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,direction:'column',alignContent:'space-between'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Typography___default.a,{variant:'body1'},'\u20B9 ',simBalance)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,className:classes.rowStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_material_ui_pickers__["a" /* DatePicker */],{disabled:simBalance===0,className:classes.dateStyle,label:'Due Date',value:expectedSimsDueDate,onChange:this.handleExpectedDateChange('expectedSimsDueDate'),format:'DD/MM/YYYY'// inputProps={{
//   name: 'expiryDateTime'
// }}
})))):null)))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),['ACC'].includes(Object(__WEBPACK_IMPORTED_MODULE_14__utils_getAccountType__["a" /* default */])())&&// data.subscription.minimumAmountDue > 0 &&
__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Card___default.a,{className:classes.card,raised:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_CardHeader___default.a,{title:'Record Payment'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_FormControl___default.a,{className:classes.formControl},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__material_ui_core_InputLabel___default.a,{id:'payment-helper'},'Payment Type'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_Select___default.a,{value:this.state.paymentMode,onChange:this.handleChangePaymentType,className:classes.selectStyle},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__material_ui_core_MenuItem___default.a,{value:'NONE'},'None'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__material_ui_core_MenuItem___default.a,{value:'CASH'},'Cash'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__material_ui_core_MenuItem___default.a,{value:'ONLINE'},'Online'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__material_ui_core_MenuItem___default.a,{value:'CHEQUE'},'Cheque'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__material_ui_core_MenuItem___default.a,{value:'DD'},'DD')))),paymentOption.includes(this.state.paymentMode)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__ViewSubscription_PaymentMethod__["a" /* default */],{paymentThrough:this.state.paymentMode,handleChangereferenceNumber:this.handleChangeReferenceNumber,checkReferenceNumberValidity:this.checkReferenceNumberValidity,isValidReferenceNumber:this.state.isValidReferenceNumber,referenceMessage:this.state.referenceMessage,handleChangeBankName:this.handleChangeBankName,handleChangePaidMoney:this.handleChangePaidMoney// paidMoney={this.state.paidMoney}
,referenceNumber:this.state.referenceNumber,bankName:this.state.bankName})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_TextField___default.a,{multiline:true,rows:2,label:'Remarks',variant:'contained',onChange:this.handleAccountRemarksChange,value:this.state.accountRemarks})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_CardActions___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Button___default.a,{variant:'contained',color:'secondary',classes:{root:classes.redButton},onClick:this.handleCancel},'Reject'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Button___default.a,{disabled:!this.state.paymentMode,variant:'contained',color:'secondary',type:'submit',onClick:this.handleSubmit},'Approve'))))));}}]);return PartnerSubscriptionDetail;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_25__HOCs_withSharedSnackbar__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["withApollo"])(__WEBPACK_IMPORTED_MODULE_15_react_router_dom_withRouter___default()(PartnerSubscriptionDetail)))));

/***/ }),
/* 2442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_ArrowBack__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_ArrowBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_ArrowBack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Modules_CustomerDetailsCard__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PartnerSubscriptionDetailsEdit__ = __webpack_require__(2443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_common_Loader__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_ConfirmationDialog__ = __webpack_require__(65);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getPartnerSubscriptions($subscriptionId: Int!) {\n    partnerSubscription: getPartnerSubscriptions(id: $subscriptionId) {\n      id\n      partnerLoginId\n      status\n      partnerDetail {\n        id\n        businessName\n      }\n      billingFrequency {\n        id\n        frequency\n      }\n      deviceModel {\n        model_name\n      }\n      accessoryType {\n        accessoryName\n      }\n      serviceProvider {\n        name\n      }\n      noOfDevices\n      nextPaymentDate\n      totalSoftwareQty\n      billingMode {\n        id\n        billingMode\n      }\n      billingDetails {\n        paymentId\n        totalAmount\n        totalAmountWithGST\n        softwareBill {\n          quantity\n          rate\n          amountWithGST\n        }\n        hardwareBill {\n          quantity\n          rate\n          amountWithGST\n        }\n        accessoryBill {\n          quantity\n          rate\n          amountWithGST\n        }\n        simBill {\n          quantity\n          rate\n          amountWithGST\n        }\n      }\n    }\n  }\n'],['\n  query getPartnerSubscriptions($subscriptionId: Int!) {\n    partnerSubscription: getPartnerSubscriptions(id: $subscriptionId) {\n      id\n      partnerLoginId\n      status\n      partnerDetail {\n        id\n        businessName\n      }\n      billingFrequency {\n        id\n        frequency\n      }\n      deviceModel {\n        model_name\n      }\n      accessoryType {\n        accessoryName\n      }\n      serviceProvider {\n        name\n      }\n      noOfDevices\n      nextPaymentDate\n      totalSoftwareQty\n      billingMode {\n        id\n        billingMode\n      }\n      billingDetails {\n        paymentId\n        totalAmount\n        totalAmountWithGST\n        softwareBill {\n          quantity\n          rate\n          amountWithGST\n        }\n        hardwareBill {\n          quantity\n          rate\n          amountWithGST\n        }\n        accessoryBill {\n          quantity\n          rate\n          amountWithGST\n        }\n        simBill {\n          quantity\n          rate\n          amountWithGST\n        }\n      }\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  mutation updatePartnerSubscriptions(\n    $partnerSubscriptionId: Int!\n    $partnerLoginId: Int!\n    $billingFrequencyId: Int!\n    $hardwareQuantity: Int!\n    $softwareQuantity: Int!\n    $accessoryQuantity: Int!\n    $simQuantity: Int!\n  ) {\n    updatePartnerSubscriptions(\n      partnerSubscriptionId: $partnerSubscriptionId\n      partnerLoginId: $partnerLoginId\n      billingFrequencyId: $billingFrequencyId\n      hardwareQuantity: $hardwareQuantity\n      softwareQuantity: $softwareQuantity\n      accessoryQuantity: $accessoryQuantity\n      simQuantity: $simQuantity\n    )\n  }\n'],['\n  mutation updatePartnerSubscriptions(\n    $partnerSubscriptionId: Int!\n    $partnerLoginId: Int!\n    $billingFrequencyId: Int!\n    $hardwareQuantity: Int!\n    $softwareQuantity: Int!\n    $accessoryQuantity: Int!\n    $simQuantity: Int!\n  ) {\n    updatePartnerSubscriptions(\n      partnerSubscriptionId: $partnerSubscriptionId\n      partnerLoginId: $partnerLoginId\n      billingFrequencyId: $billingFrequencyId\n      hardwareQuantity: $hardwareQuantity\n      softwareQuantity: $softwareQuantity\n      accessoryQuantity: $accessoryQuantity\n      simQuantity: $simQuantity\n    )\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// const GET_CLIENTS = gql`
//   query allClientDetails($partnerLoginId: Int) {
//     clients: allClientDetails(partnerLoginId: $partnerLoginId) {
//       id
//       clientName
//       loginId
//     }
//   }
// `
// const GET_CLIENT = gql`
//   query clientDetail($id: Int) {
//     clientDetail(loginId: $id) {
//       id
//       clientName
//       contactPerson
//       address
//       city
//       state {
//         zone_id
//         name
//       }
//       country {
//         country_id
//         name
//       }
//       email
//       contactNumber
//       login {
//         username
//       }
//       pincode
//       panNumber
//     }
//   }
// `
var GET_PARTNER_SUBSCRIPTION=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject);var UPDATE_PARTNER_SUBSCRIPTION=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject2);var style=function style(theme){var _root;return{root:(_root={padding:theme.spacing.unit*4},_defineProperty(_root,theme.breakpoints.down('sm'),{padding:theme.spacing.unit*2}),_defineProperty(_root,'flexGrow',1),_root),input:{display:'flex',padding:0}};};// function ClientSelected(props) {
//   const isClientSelected = props.isClientSelected
//   if (isClientSelected) {
//     return (
//       <Grid container spacing={16}>
//         <Grid item xs={12}>
//           <CustomerDetailsCard clientDetail={props.clientDetails} />
//         </Grid>
//       </Grid>
//     )
//   }
//   return null
// }
function ShowSubDetails(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__common_ConfirmationDialog__["a" /* default */],{isDialogOpen:props.isUpdateConfDialogOpen,dialogMessage:'Are you sure you want to Update this subscription?',negativeResponseHandler:props.updateNegativeResponseHandler,positiveResponseHandler:props.updatePositiveResponseHandler}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__common_ConfirmationDialog__["a" /* default */],{isDialogOpen:props.isCancelConfDialogOpen,dialogMessage:'Are you sure you want to Cancel the changes?',negativeResponseHandler:props.cancelNegativeResponseHandler,positiveResponseHandler:props.cancelPositiveResponseHandler}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__PartnerSubscriptionDetailsEdit__["a" /* default */],{subscriptionData:props.subscriptionData,billingFrequencyId:props.billingFrequencyId,nextPaymentDate:props.nextPaymentDate,totalQuantity:props.totalQuantity,deviceQuantity:props.deviceQuantity,accessoryQuantity:props.accessoryQuantity,simQuantity:props.simQuantity,softwareQuantity:props.softwareQuantity,deviceTotalAmount:props.deviceTotalAmount,softwareTotalAmount:props.softwareTotalAmount,accessoryTotalAmount:props.accessoryTotalAmount,simTotalAmount:props.simTotalAmount,handleSelectChange:props.handleSelectChange,handleSelectDayChange:props.handleSelectDayChange,handleSelectGstChange:props.handleSelectGstChange,handleChange:props.handleChange,handleSelectBillingModeChange:props.handleSelectBillingModeChange,handleCancelClick:props.handleCancelClick,handleUpdateClick:props.handleUpdateClick}));}var EditPartnerSubscription=function(_Component){_inherits(EditPartnerSubscription,_Component);function EditPartnerSubscription(props){var _this2=this;_classCallCheck(this,EditPartnerSubscription);var _this=_possibleConstructorReturn(this,(EditPartnerSubscription.__proto__||Object.getPrototypeOf(EditPartnerSubscription)).call(this,props));_this.handleChange=function(name){return function(event){console.log('change values');var _this$state$subscript=_this.state.subscriptionData.billingDetails,softwareBill=_this$state$subscript.softwareBill,hardwareBill=_this$state$subscript.hardwareBill,accessoryBill=_this$state$subscript.accessoryBill,simBill=_this$state$subscript.simBill;if(!(event.target.value<_this.state.initStatus[name])&&event.target.value>=0){console.log(name);if(name==='softwareQuantity'){var total=event.target.value*softwareBill.rate;_this.setState({softwareTotalAmount:total,softwareQuantity:event.target.value});}else if(name==='deviceQuantity'){console.log(event.target.value);var _total=event.target.value*hardwareBill.rate;_this.setState(_defineProperty({deviceTotalAmount:_total},name,event.target.value));}else if(name==='accessoryQuantity'){var _total2=event.target.value*accessoryBill.rate;_this.setState(_defineProperty({accessoryTotalAmount:_total2},name,event.target.value));}else if(name==='simQuantity'){var _total3=event.target.value*simBill.rate;_this.setState(_defineProperty({simTotalAmount:_total3},name,event.target.value));}}};};_this.handleCancelClick=function(e){_this.setState({isCancelConfDialogOpen:true});};_this.handleUpdateClick=function(e){_this.setState({isUpdateConfDialogOpen:true});};_this.handleCancelNegativeResponse=function(e){_this.setState({isCancelConfDialogOpen:false});};_this.handleUpdateNegativeResponse=function(e){_this.setState({isUpdateConfDialogOpen:false});};_this.handleCancelSubscription=function(e){_this.props.history.goBack();};_this.handleUpdateSubscription=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _ref2,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!(parseInt(_this.state.deviceQuantity,10)!==parseInt(_this.state.softwareQuantity,10))){_context.next=4;break;}_this.props.openSnackbar('Device total quantity and device quantity should be equal');_context.next=20;break;case 4:if(!(parseInt(_this.state.deviceQuantity,10)===parseInt(_this.state.oldDeviceQuantity,10)&&parseInt(_this.state.softwareQuantity,10)===parseInt(_this.state.oldSoftwareQuantity,10)&&parseInt(_this.state.accessoryQuantity,10)===parseInt(_this.state.oldAccessoryQuantity,10)&&parseInt(_this.state.simQuantity,10)===parseInt(_this.state.oldSimQuantity,10))){_context.next=8;break;}_this.props.openSnackbar('No changes are made in the request');_context.next=20;break;case 8:_context.next=10;return _this.props.client.mutate({mutation:UPDATE_PARTNER_SUBSCRIPTION,variables:{partnerSubscriptionId:parseInt(_this.subscriptionId,10),partnerLoginId:parseInt(_this.loginId,10),billingFrequencyId:parseInt(_this.state.billingFrequencyId,10),hardwareQuantity:parseInt(_this.state.deviceQuantity,10),softwareQuantity:parseInt(_this.state.softwareQuantity,10),accessoryQuantity:parseInt(_this.state.accessoryQuantity,10),simQuantity:parseInt(_this.state.simQuantity,10)}});case 10:_ref2=_context.sent;data=_ref2.data;if(!(data.updatePartnerSubscriptions===true)){_context.next=19;break;}_context.next=15;return _this.props.client.clearStore();case 15:_this.props.openSnackbar('Subscription Updation Successful');_this.props.history.push({pathname:'/home/users/partner'});_context.next=20;break;case 19:_this.props.openSnackbar('Subscription Updation Failed');case 20:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.getAllDetails=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var initStatus,_ref4,data,loading,error,partnerSubscription,_partnerSubscription$,softwareBill,hardwareBill,accessoryBill,simBill,fields;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:initStatus={deviceQuantity:0,accessoryQuantity:0,simQuantity:0,softwareQuantity:0};_context2.next=3;return _this.props.client.query({query:GET_PARTNER_SUBSCRIPTION,variables:{subscriptionId:parseInt(_this.props.match.params.subscriptionId,10)},fetchPolicy:'network-only'});case 3:_ref4=_context2.sent;data=_ref4.data;loading=_ref4.loading;error=_ref4.error;if(data&&data.partnerSubscription){partnerSubscription=data.partnerSubscription;_this.setState({subscriptionData:partnerSubscription,isLoading:false});console.log('Edit subscription data:',data);// Maintain initial settings
if(partnerSubscription.billingDetails){_partnerSubscription$=partnerSubscription.billingDetails,softwareBill=_partnerSubscription$.softwareBill,hardwareBill=_partnerSubscription$.hardwareBill,accessoryBill=_partnerSubscription$.accessoryBill,simBill=_partnerSubscription$.simBill;if(hardwareBill){initStatus['deviceQuantity']=hardwareBill.quantity;_this.setState({deviceQuantity:hardwareBill.quantity,oldDeviceQuantity:hardwareBill.quantity,deviceTotalAmount:hardwareBill.quantity*hardwareBill.rate});}if(softwareBill){initStatus['softwareQuantity']=softwareBill.quantity;_this.setState({softwareQuantity:softwareBill.quantity,oldSoftwareQuantity:softwareBill.quantity,softwareTotalAmount:softwareBill.quantity*softwareBill.rate});}if(accessoryBill){initStatus['accessoryQuantity']=accessoryBill.quantity;_this.setState({accessoryQuantity:accessoryBill.quantity,oldAccessoryQuantity:accessoryBill.quantity,accessoryTotalAmount:accessoryBill.quantity*accessoryBill.rate});}if(simBill){initStatus['simQuantity']=simBill.quantity;_this.setState({simQuantity:simBill.quantity,oldSimQuantity:simBill.quantity,simTotalAmount:simBill.quantity*simBill.rate});}}}// Take care of non mandatory fields
// TODO: Explore handling this in the query
// console.log(fetchedSubscriptionData.data.getSubscriptions.nextPaymentDate, 'nextpay')
fields={initStatus:initStatus,billingFrequencyId:data.partnerSubscription.billingFrequency.id};_this.setState(fields);case 10:case'end':return _context2.stop();}}},_callee2,_this2);}));_this.subscriptionId=_this.props.match.params.subscriptionId;_this.loginId=_this.props.match.params.loginId;_this.state={subscriptionData:null,isUpdateConfDialogOpen:false,isCancelConfDialogOpen:false,billingFrequencyId:null,nextPaymentDate:null,totalQuantity:null,modelName:null,accessoryName:null,serviceProvider:null,deviceQuantity:0,softwareQuantity:0,accessoryQuantity:0,simQuantity:0,oldSoftwareQuantity:0,oldDeviceQuantity:0,oldAccessoryQuantity:0,oldSimQuantity:0,deviceTotalAmount:0,softwareTotalAmount:0,accessoryTotalAmount:0,simTotalAmount:0,grandTotalAmount:null,initStatus:{deviceQuantity:0,accessoryQuantity:0,simQuantity:0,softwareQuantity:0},isLoading:true};return _this;}_createClass(EditPartnerSubscription,[{key:'componentDidMount',value:function componentDidMount(){this.getAllDetails();}},{key:'render',value:function render(){var classes=this.props.classes;var isLoading=this.state.isLoading;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button___default.a,{variant:'outlined',color:'secondary',className:classes.button,onClick:this.handleCancelClick},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_ArrowBack___default.a,{className:classes.iconSmall}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Typography"],{variant:'headline'},'Edit Subscription')),!isLoading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,container:true,spacing:16,direction:'row'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ShowSubDetails,{subscriptionData:this.state.subscriptionData,isUpdateConfDialogOpen:this.state.isUpdateConfDialogOpen,isCancelConfDialogOpen:this.state.isCancelConfDialogOpen,billingFrequencyId:this.state.billingFrequencyId,totalQuantity:this.state.totalQuantity,deviceQuantity:this.state.deviceQuantity,accessoryQuantity:this.state.accessoryQuantity,simQuantity:this.state.simQuantity,softwareQuantity:this.state.softwareQuantity,deviceTotalAmount:this.state.deviceTotalAmount,softwareTotalAmount:this.state.softwareTotalAmount,accessoryTotalAmount:this.state.accessoryTotalAmount,simTotalAmount:this.state.simTotalAmount,handleChange:this.handleChange,handleCancelSubscription:this.handleCancelSubscription,handleUpdateSubscription:this.handleUpdateSubscription,handleCancelClick:this.handleCancelClick,handleUpdateClick:this.handleUpdateClick,cancelNegativeResponseHandler:this.handleCancelNegativeResponse,cancelPositiveResponseHandler:this.handleCancelSubscription,updateNegativeResponseHandler:this.handleUpdateNegativeResponse,updatePositiveResponseHandler:this.handleUpdateSubscription})))));}}]);return EditPartnerSubscription;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);EditPartnerSubscription.propTypes={classes:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired};var withApolloClient=function withApolloClient(Component){return function(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_apollo__["ApolloConsumer"],null,function(client){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component,Object.assign({client:client},props));});};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__["withStyles"])(style)(withApolloClient(Object(__WEBPACK_IMPORTED_MODULE_13__HOCs_withSharedSnackbar__["a" /* default */])(EditPartnerSubscription))));

/***/ }),
/* 2443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Card__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_CardHeader__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_CardHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_CardHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_CardContent__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_CardContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_CardContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_CardActions__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_CardActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_CardActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_apollo__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var style=function style(theme){return{card:{overflow:'visible'},root:{padding:theme.spacing.unit*2,flexGrow:1},input:{display:'flex',padding:0},italicizedText:{fontStyle:'italic'},fileDownloadIcon:{marginLeft:theme.spacing.unit,marginRight:-theme.spacing.unit},wrapFileName:{overflow:'hidden',whiteSpace:'nowrap',textOverflow:'ellipsis',maxWidth:'250px'},cardHeaderAction:{marginTop:'0px',marginRight:'-8px'},selectSytle:{width:'80%'},dividerStyle:{margin:'10px 0px 0 0'},subHeading:{margin:'5px 0'}};};var SubscriptionDetails=function(_Component){_inherits(SubscriptionDetails,_Component);function SubscriptionDetails(){_classCallCheck(this,SubscriptionDetails);return _possibleConstructorReturn(this,(SubscriptionDetails.__proto__||Object.getPrototypeOf(SubscriptionDetails)).apply(this,arguments));}_createClass(SubscriptionDetails,[{key:'render',value:function render(){var _props=this.props,classes=_props.classes,subscriptionData=_props.subscriptionData;console.log('subscriptionData',subscriptionData);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Card___default.a,{className:classes.card},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_CardHeader___default.a,{title:'Subscription Details'}),subscriptionData.billingDetails?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true,spacing:16},subscriptionData.billingDetails.softwareBill?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true,alignItems:'baseline',spacing:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{gutterBottom:true,variant:'h3',component:'h3'},'Software')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true,justify:'flex-start',alignItems:'flex-end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{gutterBottom:true,variant:'h3',component:'body2'},'Devices Name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'h3',component:'h4'},'AquilaTrack Software')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{id:'softwareQuantity',label:'Software Quantity *',value:this.props.softwareQuantity,inputProps:{min:subscriptionData.billingDetails.softwareBill.quantity},onChange:this.props.handleChange('softwareQuantity'),type:'number',margin:'none'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{gutterBottom:true,variant:'h3',component:'body2'},'Software Charges'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'h3',component:'h4'},subscriptionData.billingDetails.softwareBill.rate)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body1'},'Total Amount per month (excl GST): \xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body2'},isNaN(parseInt(this.props.softwareTotalAmount,10))?'-':this.props.softwareTotalAmount))))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Divider___default.a,{className:classes.dividerStyle})),subscriptionData.billingDetails.hardwareBill?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true,alignItems:'baseline',spacing:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{gutterBottom:true,variant:'h3',component:'h3'},'Devices')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true,justify:'flex-start',alignItems:'flex-end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{gutterBottom:true,variant:'h3',component:'body2'},subscriptionData.deviceModel.model_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'h3',component:'h4'},'DEVICES')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{id:'quantity',label:'Device Quantity *',value:this.props.deviceQuantity,onChange:this.props.handleChange('deviceQuantity'),type:'number',inputProps:{min:subscriptionData.billingDetails.hardwareBill.quantity},margin:'none'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{gutterBottom:true,variant:'h3',component:'body2'},'Device Charges'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'h3',component:'h4'},subscriptionData.billingDetails.hardwareBill.rate)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body1'},'Total Amount per month (excl GST): \xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body2'},isNaN(parseInt(this.props.deviceTotalAmount,10))?'-':this.props.deviceTotalAmount))))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Divider___default.a,{className:classes.dividerStyle})),subscriptionData.accessoryType?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true,alignItems:'baseline',spacing:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{gutterBottom:true,variant:'h3',component:'h3'},'Accessory')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true,justify:'flex-start',alignItems:'flex-end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{gutterBottom:true,variant:'h3',component:'body2'},subscriptionData.accessoryType.accessoryName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'h3',component:'h4'},'ACCESSORY')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{id:'accessoryQuantity',label:'Quantity',value:this.props.accessoryQuantity,onChange:this.props.handleChange('accessoryQuantity'),type:'number',inputProps:{min:subscriptionData.billingDetails.accessoryBill.quantity},margin:'none'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{gutterBottom:true,variant:'h3',component:'body2'},'Accessory Charges'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'h3',component:'h4'},subscriptionData.billingDetails.accessoryBill.rate)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body1'},'Total Amount per month (excl GST): \xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body2'},isNaN(parseInt(this.props.accessoryTotalAmount,10))?'-':this.props.accessoryTotalAmount))))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Divider___default.a,{className:classes.dividerStyle})),subscriptionData.serviceProvider?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true,alignItems:'baseline',spacing:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{gutterBottom:true,variant:'h3',component:'h3'},'Software')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{container:true,justify:'flex-start',alignItems:'flex-end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{gutterBottom:true,variant:'h3',component:'body2'},'Service Provider'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'h3',component:'h4'},subscriptionData.serviceProvider.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_TextField___default.a,{id:'simQuantity',label:'Quantity',value:this.props.simQuantity,onChange:this.props.handleChange('simQuantity'),type:'number',inputProps:{min:subscriptionData.billingDetails.simBill.quantity},margin:'none'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{gutterBottom:true,variant:'h3',component:'body2'},'Sim Charges'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'h3',component:'h4'},subscriptionData.billingDetails.simBill.rate)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body1'},'Total Amount per month (excl GST): \xA0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body2'},isNaN(parseInt(this.props.simTotalAmount,10))?'-':this.props.simTotalAmount))))):null)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{gutterBottom:true,color:'error',variant:'sub-heading',component:'body2'},'Sorry! No Subscriptions are available.')),subscriptionData.billingDetails?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_CardActions___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button___default.a,{color:'secondary',variant:'raised',onClick:this.props.handleUpdateClick},'Update'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button___default.a,{color:'secondary',onClick:this.props.handleCancelClick},'Cancel')):null);}}]);return SubscriptionDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SubscriptionDetails.propTypes={classes:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_12_react_apollo__["withApollo"])(SubscriptionDetails)));

/***/ }),
/* 2444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_pickers__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ConstantData__ = __webpack_require__(2445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_graphql_execution_values__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_Loader__ = __webpack_require__(47);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _templateObject=_taggedTemplateLiteral(['\n  query($date: String!) {\n    packetsCountData: getMasterPacketCountByDate(date: $date) {\n      date\n      totalMasterPacketCount\n      data {\n        server\n        dayMasterPacketCount\n        deviceCount\n      }\n    }\n  }\n'],['\n  query($date: String!) {\n    packetsCountData: getMasterPacketCountByDate(date: $date) {\n      date\n      totalMasterPacketCount\n      data {\n        server\n        dayMasterPacketCount\n        deviceCount\n      }\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query($month: String!) {\n    packetsCountData: getMasterPacketCountByMonth(month: $month) {\n      month\n      totalMasterPacketCount\n      data {\n        server\n        monthMasterPacketCount\n        deviceCount\n      }\n    }\n  }\n'],['\n  query($month: String!) {\n    packetsCountData: getMasterPacketCountByMonth(month: $month) {\n      month\n      totalMasterPacketCount\n      data {\n        server\n        monthMasterPacketCount\n        deviceCount\n      }\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var styles=function styles(theme){return{root:{margin:'1rem 1rem'},selectStyle:{maxWidth:200,zIndex:150},footerStyle:{fontSize:'1rem'}};};var GET_DAILY_PACKETS_DATA=Object(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__["a" /* default */])(_templateObject);var GET_MONTHLY_PACKETS_DATA=Object(__WEBPACK_IMPORTED_MODULE_4_graphql_tag__["a" /* default */])(_templateObject2);var FREQUENCY=[{label:'Day',value:1},{label:'Month',value:2}];function HereMapsDashboard(props){var _this=this;var classes=props.classes;var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(null),_useState2=_slicedToArray(_useState,2),packetsData=_useState2[0],setPacketsData=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])([]),_useState4=_slicedToArray(_useState3,2),packetTableData=_useState4[0],setPacketTableData=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(null),_useState6=_slicedToArray(_useState5,2),frequency=_useState6[0],setFrequency=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(new Date()),_useState8=_slicedToArray(_useState7,2),dayInput=_useState8[0],setDayInput=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(),_useState10=_slicedToArray(_useState9,2),monthInput=_useState10[0],setMonthInput=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(),_useState12=_slicedToArray(_useState11,2),yearInput=_useState12[0],setYearInput=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState14=_slicedToArray(_useState13,2),isLoading=_useState14[0],setIsLoading=_useState14[1];var column=['Server Name','Device Count','Total Packets'];var options={print:false,checkbox:false,rowHover:false,selectableRows:false,selectableRowsHeader:false};var getQueryAndVariables=function getQueryAndVariables(){var query=null;var variable={};if(frequency.value===1){query=GET_DAILY_PACKETS_DATA;variable={date:__WEBPACK_IMPORTED_MODULE_8_moment___default()(dayInput).format('DD/MM/YYYY')};}else if(frequency.value===2){query=GET_MONTHLY_PACKETS_DATA;variable={month:monthInput.value+'/'+yearInput.label};}return{query:query,variable:variable};};var mapPacketData=function mapPacketData(packetData){var data=packetData.data;var mappedData=data.reduce(function(acc,item){var temp=[];item.server?temp.push(item.server):temp.push('N/A');item.deviceCount?temp.push(item.deviceCount.toLocaleString('en-US')):temp.push(0);if(packetData.date){item.dayMasterPacketCount?temp.push(item.dayMasterPacketCount.toLocaleString('en-US')):temp.push(0);}if(packetData.month){item.monthMasterPacketCount?temp.push(item.monthMasterPacketCount.toLocaleString('en-US')):temp.push(0);}acc.push(temp);return acc;},[]);console.log('mapp data',mappedData);setPacketTableData(mappedData);};var getPacketsData=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _getQueryAndVariables,query,variable,response,packetsCountData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_getQueryAndVariables=getQueryAndVariables(),query=_getQueryAndVariables.query,variable=_getQueryAndVariables.variable;_context.next=3;return props.client.query({query:query,variables:variable,fetchPolicy:'network-only'}).catch(function(err){console.log(err);props.openSnackbar('Data not available');});case 3:response=_context.sent;if(!(response&&response.loading)){_context.next=6;break;}return _context.abrupt('return',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,' Loading... '));case 6:if(response){if(response.data){packetsCountData=response.data.packetsCountData;console.log(packetsCountData);setIsLoading(response.loading);setPacketsData(packetsCountData);mapPacketData(packetsCountData);}}case 7:case'end':return _context.stop();}}},_callee,_this);}));return function getPacketsData(){return _ref.apply(this,arguments);};}();var handleChange=function handleChange(option){setFrequency(option);setMonthInput(null);setYearInput(null);setDayInput();};var handleClick=function handleClick(){setIsLoading(true);if(frequency){getPacketsData();}else{props.openSnackbar('Choose Frequency');}};Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(function(){if(frequency){getPacketsData();}},[]);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Grid"],{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Grid"],{item:true,container:true,md:12,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Grid"],{item:true,md:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */],{options:FREQUENCY,name:'frequency',value:frequency,onChange:handleChange,className:classes.selectStyle})),frequency?frequency.value===1?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Grid"],{item:true,md:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_pickers__["a" /* DatePicker */],{value:dayInput,onChange:setDayInput,format:'DD/MM/YYYY'})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Grid"],{item:true,container:true,md:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Grid"],{item:true,md:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */],{options:__WEBPACK_IMPORTED_MODULE_9__ConstantData__["a" /* MONTHS */],name:'month',value:monthInput,onChange:setMonthInput,className:classes.selectStyle})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Grid"],{item:true,md:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */],{options:__WEBPACK_IMPORTED_MODULE_9__ConstantData__["b" /* YEARS */],name:'year',value:yearInput,onChange:setYearInput,className:classes.selectStyle}))):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Grid"],{item:true,md:2},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Button"],{variant:'contained',color:'primary',onClick:handleClick},' ','Get Data'))),!isLoading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Grid"],{item:true,md:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_mui_datatables___default.a,{title:'Packets Usage Table',options:options,columns:column,data:packetTableData})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Grid"],{item:true,container:true,md:12,justify:'flex-end'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Grid"],{item:true,md:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Typography"],{variant:'h3',component:'h4'},'Date :',' ',packetsData?packetsData.date?packetsData.date:packetsData.month:'')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Grid"],{item:true,md:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Typography"],{variant:'h3',component:'h4'},'Total Packets Count :',' ',packetsData?packetsData.totalMasterPacketCount.toLocaleString('en-US'):0)))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["CircularProgress"],{color:'secondary'})));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_3__HOCs_withSharedSnackbar__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["withApollo"])(HereMapsDashboard))));

/***/ }),
/* 2445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MONTHS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return YEARS; });
var MONTHS=[{label:'January',value:'01'},{label:'February',value:'02'},{label:'March',value:'03'},{label:'April',value:'04'},{label:'May',value:'05'},{label:'June',value:'06'},{label:'July',value:'07'},{label:'August',value:'08'},{label:'September',value:'09'},{label:'October',value:'10'},{label:'November',value:'11'},{label:'December',value:'12'}];var YEARS=[{label:2016,value:1},{label:2017,value:2},{label:2018,value:3},{label:2019,value:4},{label:2020,value:5},{label:2021,value:6},{label:2022,value:7},{label:2023,value:8},{label:2024,value:9},{label:2025,value:10}];

/***/ }),
/* 2446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormHelperText__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormHelperText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormHelperText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plans_css__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plans_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__plans_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Basic__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AllFeatures__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__HOCs_withSharedSnackbar__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_icons_ArrowBack__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_icons_ArrowBack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_icons_ArrowBack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_Card__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_CardHeader__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_core_CardHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_CardHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core_CardContent__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_core_CardContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_CardContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__common_ConfirmationDialog__ = __webpack_require__(65);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query {\n    features: allFeatures(status: 1) {\n      id\n      featureName\n      costPerAssetPerMonth\n      featureDescription\n    }\n  }\n'],['\n  query {\n    features: allFeatures(status: 1) {\n      id\n      featureName\n      costPerAssetPerMonth\n      featureDescription\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query getPlans($planid: Int!) {\n    getPlans(id: $planid) {\n      id\n      planName\n      description\n      featureList {\n        id\n        featureName\n        costPerAssetPerMonth\n        featureDescription\n      }\n    }\n  }\n'],['\n  query getPlans($planid: Int!) {\n    getPlans(id: $planid) {\n      id\n      planName\n      description\n      featureList {\n        id\n        featureName\n        costPerAssetPerMonth\n        featureDescription\n      }\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation updatePlans(\n    $id: Int!\n    $planName: String!\n    $description: String!\n    $featureList: String!\n    $costPerAsset: Int!\n    $partnerLoginId: Int!\n    $status: Int!\n  ) {\n    updatePlans(\n      id: $id\n      planName: $planName\n      description: $description\n      featureList: $featureList\n      costPerAsset: $costPerAsset\n      partnerLoginId: $partnerLoginId\n      status: $status\n    )\n  }\n'],['\n  mutation updatePlans(\n    $id: Int!\n    $planName: String!\n    $description: String!\n    $featureList: String!\n    $costPerAsset: Int!\n    $partnerLoginId: Int!\n    $status: Int!\n  ) {\n    updatePlans(\n      id: $id\n      planName: $planName\n      description: $description\n      featureList: $featureList\n      costPerAsset: $costPerAsset\n      partnerLoginId: $partnerLoginId\n      status: $status\n    )\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var styles=function styles(theme){var _root;return{root:(_root={padding:theme.spacing.unit*4},_defineProperty(_root,theme.breakpoints.down('sm'),{padding:theme.spacing.unit*2}),_defineProperty(_root,'flexGrow',1),_root),italicizedText:{fontStyle:'italic'},fullWidth:{width:'100%'}};};var GET_ALL_FEATURES=Object(__WEBPACK_IMPORTED_MODULE_12_graphql_tag__["a" /* default */])(_templateObject);var GET_FEATURE_BY_PLAN=Object(__WEBPACK_IMPORTED_MODULE_12_graphql_tag__["a" /* default */])(_templateObject2);var UPDATE_PLANS=Object(__WEBPACK_IMPORTED_MODULE_12_graphql_tag__["a" /* default */])(_templateObject3);var editPlan=function(_Component){_inherits(editPlan,_Component);function editPlan(props){var _this2=this;_classCallCheck(this,editPlan);var _this=_possibleConstructorReturn(this,(editPlan.__proto__||Object.getPrototypeOf(editPlan)).call(this,props));_this.handleChangeChecked=function(name,price){return function(event){// console.log(name, event.target.value, event.target.checked)
var tempState=_this.state.tempState;var a=Object.assign({},tempState);var p=Object.assign({},_this.state.tempPrice);// console.log('mee', a)
if(event.target.checked===true){_this.setState(_defineProperty({},name,event.target.checked));a[name]=true;p[name]=price;}if(event.target.checked===false){_this.setState(_defineProperty({},name,event.target.checked));a[name]=false;p[name]=0;}_this.setState({tempState:a,tempPrice:p});// console.log('lastS', this.state.tempState)
// console.log('lastP', this.state.tempPrice)
var tempcost=0;// console.log('ll', this.state.tempPrice[1])
Object.values(_this.state.tempPrice).map(function(price){return tempcost=tempcost+price;});_this.setState({cost:tempcost});// console.log('last=', a)
// console.log('2p', this.state.cost)
};};_this.handleTermsChangeChecked=function(name){return function(event){var _this$setState3;// console.log('terms1', this.state.terms)
// console.log('tt', event.target.checked)
var val=void 0;if(event.target.checked){val=true;}else{val=false;}_this.setState((_this$setState3={},_defineProperty(_this$setState3,name,event.target.checked),_defineProperty(_this$setState3,'terms',val),_this$setState3));// console.log('terms2', this.state.terms)
};};_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));// if (e.target.value != '') {
// }
};};_this.handleChangePlan=function(event){_this.setState({clientPlan:event.target.value});};_this.handleChange=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(tempState){var _ref2,data,a,p,tempcost;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.client.query({query:GET_FEATURE_BY_PLAN,fetchPolicy:'network-only',variables:{planid:parseInt(_this.props.match.params.planId,10)}});case 2:_ref2=_context.sent;data=_ref2.data;a=Object.assign({},tempState);p=Object.assign({},_this.state.tempPrice);// console.log('data===', data.getPlans.featureList)
_this.state.featuresList.features.forEach(function(allFeatures){a[allFeatures.id]=false;p[allFeatures.id]=0;});data.getPlans.featureList.forEach(function(defaultFeature){a[defaultFeature.id]=true;p[defaultFeature.id]=defaultFeature.costPerAssetPerMonth;//  console.log('uuuu', this.state.tempState[[defaultFeature.id]])
});_this.setState({id:data.getPlans.id,planName:data.getPlans.planName,description:data.getPlans.description,plan:data.getPlans.id,//  defaultFeatures: data,
tempState:a,tempPrice:p});tempcost=0;// console.log('ll', this.state.tempPrice[1])
Object.values(_this.state.tempPrice).map(function(price){return tempcost=tempcost+price;});_this.setState({cost:tempcost});// console.log('2p', this.state.cost)
case 12:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.handleCancelClick=function(e){_this.setState({isCancelConfDialogOpen:true});};_this.handleSubmitClick=function(e){_this.setState({isSubmitConfDialogOpen:true});};_this.handleCancelNegativeResponse=function(e){_this.setState({isCancelConfDialogOpen:false});};_this.handleSaveNegativeResponse=function(e){_this.setState({isSubmitConfDialogOpen:false});};_this.cancelNewPlan=function(e){_this.props.history.goBack();};_this.handleSubmit=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(event){var checkedlist,selCost,_ref4,data,errors;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:checkedlist=[];Object.keys(_this.state.tempState).forEach(function(price){if(_this.state.tempState[price]){var temp={};temp['featureId']=price;checkedlist.push(temp);}});// this.setState.isFeatureChanged =
//   JSON.stringify(initial) === JSON.stringify(final)
selCost=0;if(_this.state.featuresList){_this.state.featuresList.features.map(function(featuresList){return selCost=selCost+_this.state.tempPrice[featuresList.id];});}if(!(_this.state.tempState[8]&&_this.state.tempState[24])){_context2.next=8;break;}_this.props.openSnackbar('Select only one Google Map or Open Street map');_context2.next=18;break;case 8:if(!(_this.state.terms===true&&_this.state.planName!==''&&_this.state.description!==''&&checkedlist.length!==0)){_context2.next=17;break;}_context2.next=11;return _this.props.client.mutate({mutation:UPDATE_PLANS,variables:{id:parseInt(_this.state.id,10),partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__["a" /* default */])(),planName:_this.state.planName,description:_this.state.description,featureList:JSON.stringify(checkedlist),costPerAsset:parseInt(selCost,10),status:1},errorPolicy:'all'});case 11:_ref4=_context2.sent;data=_ref4.data;errors=_ref4.errors;if(data){_this.setState({id:'',planName:'',description:'',featureList:'',costPerAsset:''});_this.props.openSnackbar('Plan Edited Sucessfully');_this.props.history.goBack();}else if(errors){_this.props.openSnackbar(errors[0].message);}_context2.next=18;break;case 17:if(_this.state.terms===false&&_this.state.planName!==''&&_this.state.description!==''){_this.props.openSnackbar('Accept terms and conditions');}else if(_this.state.planName===''){_this.props.openSnackbar('Plan Name field should not be empty');}else if(_this.state.description===''){_this.props.openSnackbar('Description field should not be empty');}else if(_this.state.isPlanValid===false){_this.props.openSnackbar('Plan Name should be 4 to 20 Letters');}else{_this.props.openSnackbar('Select Atleast One Feature');}case 18:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref3.apply(this,arguments);};}();_this.getAllFeatures=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var response,tempState,tempPrice,tempcost;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return _this.props.client.query({query:GET_ALL_FEATURES,fetchPolicy:'network-only'});case 2:response=_context3.sent;if(response.data&&response.data.features){tempState={};tempPrice={};response.data.features.forEach(function(feature){tempState[feature.id]=false;tempPrice[feature.id]=0;});_this.setState({tempState:tempState,featuresList:response.data,tempPrice:tempPrice});tempcost=0;response.data.features.map(function(featuresList){return tempcost=tempcost+_this.state.tempPrice[featuresList.id];});_this.setState({cost:tempcost});}case 4:case'end':return _context3.stop();}}},_callee3,_this2);}));_this.checkPlanValidity=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){var regex;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:regex=new RegExp(/^[a-zA-Z0-9\s-_"]{4,20}$/);_this.setState({isPlanValid:regex.test(_this.state.planName)});case 2:case'end':return _context4.stop();}}},_callee4,_this2);}));_this.state={id:'',isSpeedLimitValid:true,planName:'',description:'',tempState:{},plan:'',featuresList:'',tempPrice:{},terms:false,message:'',isPlanValid:true,// basic: '',
partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_13__utils_getLoginId__["a" /* default */])()};return _this;}_createClass(editPlan,[{key:'componentDidMount',value:function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return this.getAllFeatures();case 2:this.handleChange(this.state.tempState);case 3:case'end':return _context5.stop();}}},_callee5,this);}));function componentDidMount(){return _ref7.apply(this,arguments);}return componentDidMount;}()},{key:'render',value:function render(){var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__common_ConfirmationDialog__["a" /* default */],{isDialogOpen:this.state.isSubmitConfDialogOpen,dialogMessage:'Are you sure you want to Save this Edited Plan?',negativeResponseHandler:this.handleSaveNegativeResponse,positiveResponseHandler:this.handleSubmit}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__common_ConfirmationDialog__["a" /* default */],{isDialogOpen:this.state.isCancelConfDialogOpen,dialogMessage:'Are you sure you want to Cancel Edit Plan ?',negativeResponseHandler:this.handleCancelNegativeResponse,positiveResponseHandler:this.cancelNewPlan}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_Button___default.a,{variant:'outlined',color:'secondary',className:classes.button,onClick:this.handleCancelClick},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_icons_ArrowBack___default.a,null))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core_Card___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_core_CardHeader___default.a,{title:'Edit Plan',subheader:'All fields marked with (*) are mandatory',subheaderTypographyProps:{className:classes.italicizedText}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_core_CardContent___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,spacing:8},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:classes.fullWidth},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{fullWidth:true,id:'planName',name:'planName',margin:'none',label:'Plan Name',type:'text'// type="Multi-line"
,value:this.state.planName,required:true,onChange:this.handleInputChange('planName'),error:!this.state.isSpeedLimitValid,onBlur:this.checkSpeedLimitValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isSpeedLimitValid?'Invalid Speed Limit':'')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_FormControl___default.a,{className:classes.fullWidth},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormGroup___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_TextField___default.a,{fullWidth:true,id:'description',name:'description',margin:'none',label:'Description',type:'text',value:this.state.description,required:true,onChange:this.handleInputChange('description'),error:!this.state.isSpeedLimitValid,onBlur:this.checkSpeedLimitValidity}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'},!this.state.isSpeedLimitValid?'Invalid Speed Limit':'')))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Divider___default.a,null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,spacing:8},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__AllFeatures__["a" /* default */],{allFeaturesList:this.state.featuresList,tempState:this.state.tempState,handleChangeChecked:this.handleChangeChecked})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Divider___default.a,null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{container:true,spacing:8},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Basic__["a" /* default */],{allFeaturesList:this.state.featuresList,tempPrice:this.state.tempPrice,terms:this.state.terms,message:this.state.message,plan:this.state.plan,description:this.state.description,handleSubmit:this.handleSubmitClick,handleCancel:this.handleCancelClick,handleTermsChangeChecked:this.handleTermsChangeChecked}))))))))));}}]);return editPlan;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_14__HOCs_withSharedSnackbar__["a" /* default */])(editPlan))));

/***/ }),
/* 2447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_file_saver__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_file_saver__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query {\n    models: allDeviceModels(status: 1) {\n      id\n      model_name\n    }\n  }\n'],['\n  query {\n    models: allDeviceModels(status: 1) {\n      id\n      model_name\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query {\n    manufacturers: getAllManufacturer(status: 1) {\n      id\n      manufacturerName\n      manufacturerCode\n    }\n  }\n'],['\n  query {\n    manufacturers: getAllManufacturer(status: 1) {\n      id\n      manufacturerName\n      manufacturerCode\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation excelFileUpload(\n    $fileInfo: FileUploadInput!\n    $commonInput: CommonInput!\n  ) {\n    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {\n      failedToUpload\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedUploadList\n    }\n  }\n'],['\n  mutation excelFileUpload(\n    $fileInfo: FileUploadInput!\n    $commonInput: CommonInput!\n  ) {\n    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {\n      failedToUpload\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedUploadList\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n'],['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n'],['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable */var GET_MODELS=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject);var GET_MANUFACTURER=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject2);var ADD_DEVICE=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject3);var GET_UPLOAD_URL=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject4);var GET_FILE_FORMAT=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject5);var styles=function styles(theme){return{button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{margin:theme.spacing.unit,minWidth:120},root:{flexGrow:1,padding:theme.spacing.unit*2}};};var BulkAssignDevice=function(_Component){_inherits(BulkAssignDevice,_Component);function BulkAssignDevice(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,BulkAssignDevice);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BulkAssignDevice.__proto__||Object.getPrototypeOf(BulkAssignDevice)).call.apply(_ref,[this].concat(args))),_this),_this.state={open:false,open1:false,modelname:'',isModelNameValid:false,isManufacturerNameValid:false,manufacturerName:'',open_man:false,manufacturerCode:'',manufacturerId:'',publicUploadURL:'',fileName:'',bucketName:'',isUploading:false,uploadSucess:true,response:'',failList:'',result:false,isLoading:false,disable:false},_this.columns=['Serial Number','Reason'],_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15},_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));};},_this.handleChange=function(event){_this.setState(_defineProperty({},event.target.name,event.target.value));},_this.handleOpen=function(){_this.setState({open:true});},_this.handleOpenSelect=function(){_this.setState({open1:true});},_this.handleCloseSelect=function(){_this.setState({open1:false});},_this.handleOpenSelectMan=function(){_this.setState({open_man:true});},_this.handleCloseSelectMan=function(){_this.setState({open_man:false});},_this.checkModelNameValidity=function(){_this.setState({isModelNameValid:_this.state.modelname!==''});},_this.checkManufacturerNameValidity=function(){// console.log(this.state.manufacturerName)
var code=_this.state.manufacturerName.split('*');// console.log('man', code[0])
_this.setState({isManufacturerNameValid:_this.state.manufacturerName!=='',// manufacturerCode:this
uniqueSerialNumber:code[1]+'_'+_this.state.serialno,manufacturerId:code[0]});},_this.setToDefaults=function(){_this.setState({open:false,open1:false,modelname:'',isModelNameValid:false,isManufacturerNameValid:false,manufacturerName:'',open_man:false,manufacturerCode:'',manufacturerId:'',publicUploadURL:'',fileName:'',bucketName:'',isUploading:false,uploadSucess:true,response:'',failList:'',result:false,isLoading:false,selectedFile:null,disable:false});},_this.handleSubmit=function(client){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var manarr,_ref3,data,errors,fullData,arrList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:event.preventDefault();_this.setState({isLoading:true,disable:true});manarr=_this.state.manufacturerName.split('*');_context.next=5;return client.mutate({mutation:ADD_DEVICE,variables:{fileInfo:{uploadFor:'AssignDevicesToSubscription',bucketName:_this.state.bucketName,fileName:_this.state.fileName,operationType:'SKIP'},commonInput:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_16__utils_getLoginId__["a" /* default */])(),subscriptionId:parseInt(_this.props.match.params.subscriptionId,10),manufacturerId:parseInt(manarr[0],10),manufacturerCode:manarr[1],deviceModelId:parseInt(_this.state.modelname,10)}},errorPolicy:'all'});case 5:_ref3=_context.sent;data=_ref3.data;errors=_ref3.errors;_this.setState({isLoading:false});if(data!==null){fullData=[];arrList=data.excelFileUpload.failedUploadList;// console.log('arr_list', JSON.parse(arrList))
JSON.parse(arrList).forEach(function(element){var rowData=[];rowData.push(element.serialNum);rowData.push(element.errorMsg?element.errorMsg:'Invalid Sim');fullData.push(rowData);});// this.state.simprovider = ''
_this.setState({device_model_id:'',manufacturerId:'',response:'Total Excel Records= '+data.excelFileUpload.totalExcelDataRecords+','+'Total Records Uploaded='+data.excelFileUpload.successfullyUploaded+', Total Records Failed To Upload='+data.excelFileUpload.failedToUpload+', Total Duplicate Records in Excel='+data.excelFileUpload.totalDuplicateRecords,uploadSucess:true,failList:fullData,result:true});}else{_this.setState({response:errors[0].message,uploadSucess:true});}// console.log('res=', this.state.failList)
case 10:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}();},_this.onUpload=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4){var _ref4$target=_ref4.target,validity=_ref4$target.validity,_ref4$target$files=_slicedToArray(_ref4$target.files,1),file=_ref4$target$files[0];var fileExtension,response,url;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:// TODO: Handle upload errors
_this.setState({isUploading:true});if(!validity.valid){_context2.next=11;break;}fileExtension=file.name.substring(file.name.lastIndexOf('.')+1);_context2.next=5;return _this.props.client.mutate({mutation:GET_UPLOAD_URL,variables:{fileExtension:fileExtension}});case 5:response=_context2.sent;if(!(response.data&&response.data.getPublicUploadURL)){_context2.next=11;break;}url=response.data.getPublicUploadURL.publicUploadURL;_context2.next=10;return __WEBPACK_IMPORTED_MODULE_13_axios___default.a.put(url,file,{headers:{"x-ms-blob-type":"BlockBlob","Content-Type":file.type||"application/octet-stream"}});case 10:// console.log('upload', res)
_this.setState({fileName:response.data.getPublicUploadURL.filename,bucketName:response.data.getPublicUploadURL.bucketName,publicUploadURL:response.data.getPublicUploadURL.publicUploadURL});case 11:_this.setState({isUploading:false,selectedFile:file.name});case 12:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref5.apply(this,arguments);};}(),_this.downloadBulkUpload=function(client){return function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(event){var _ref7,data,res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return _this.props.client.query({query:GET_FILE_FORMAT,variables:{bucketname:'excel-templates',filename:'BulkAssignDeviceTemplate.xlsx'},errorPolicy:'all'});case 2:_ref7=_context3.sent;data=_ref7.data;_context3.next=6;return __WEBPACK_IMPORTED_MODULE_13_axios___default()({url:data.getPublicDownloadURL,method:'GET',headers:{Accept:'application/vnd.ms-excel'},responseType:'blob'// important
});case 6:res=_context3.sent;__WEBPACK_IMPORTED_MODULE_17_file_saver___default.a.saveAs(new Blob([res.data]),'sample.xlsx');// FileSaver.saveAs(data.getPublicDownloadURL, 'sample.xlsx')
case 8:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x3){return _ref6.apply(this,arguments);};}();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BulkAssignDevice,[{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;// console.log('MIDhere=')
// console.log(this.state.selectedFile, "this.state.selectedFile")
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["Query"],{query:GET_MODELS,fetchPolicy:'network-only'},function(_ref8){var isModelsLoading=_ref8.loading,error=_ref8.error,models=_ref8.data.models;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["Query"],{query:GET_MANUFACTURER,fetchPolicy:'network-only'},function(_ref9){var isManufacturersLoading=_ref9.loading,error=_ref9.error,manufacturers=_ref9.data.manufacturers;if(isModelsLoading||isManufacturersLoading)return null;if(error)return'Error!: '+error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{container:true,direction:'row',justify:'flex-start',alignItems:'center',spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Typography"],{variant:'title'},' ','Upload Bulk Assign Device Details')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},_this3.state.uploadSucess&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Typography"],{variant:'subheading',color:'primary'},_this3.state.response)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Divider___default.a,{light:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{style:{minWidth:'40%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),'Download sample template for assigning devices in bulk'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a// fullWidth
,{color:'secondary',variant:'contained',className:classes.button,onClick:_this3.downloadBulkUpload(_this3.props.client)},'Download Bulk Assign Device Excel')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{accept:'*/*',id:'contained-button-file',multiple:true,type:'file',style:{display:'none'},onChange:_this3.onUpload}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'contained-button-file'},'Upload excel file here \xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{variant:'contained',component:'span',color:'primary'},_this3.state.isUploading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress___default.a,{size:15}):'Upload')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{color:'#43a146'}},_this3.state.selectedFile===undefined?'  No File Selected':'   '+_this3.state.selectedFile))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{color:'default',variant:'contained',onClick:function onClick(){return _this3.props.history.goBack();}},'Cancel'),'       ','       ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:_this3.handleSubmit(_this3.props.client),type:'submit',color:'primary',variant:'contained',disabled:!_this3.state.fileName||_this3.state.disable// disabled={
//     !(
//         this.state.isModelNameValid &&
//         this.state.fileName !== '' &&
//         this.state.isManufacturerNameValid
//     ) || this.state.disable
// }
},'Submit'),' ',_this3.state.isLoading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'Excel sheet upload is in progress..')),_this3.state.result&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',null,'Failed records list'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_mui_datatables___default.a,{data:_this3.state.failList,columns:_this3.columns,options:_this3.options})))));});});}}]);return BulkAssignDevice;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["withStyles"])(styles)(__WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter___default()(Object(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["withApollo"])(BulkAssignDevice))));

/***/ }),
/* 2448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_MenuItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_InputLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_file_saver__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_file_saver__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query {\n    allServiceProviders(status: 1) {\n      id\n      name\n    }\n  }\n'],['\n  query {\n    allServiceProviders(status: 1) {\n      id\n      name\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  mutation excelFileUpload(\n    $fileInfo: FileUploadInput!\n    $commonInput: CommonInput!\n  ) {\n    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {\n      failedToUpload\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedUploadList\n    }\n  }\n'],['\n  mutation excelFileUpload(\n    $fileInfo: FileUploadInput!\n    $commonInput: CommonInput!\n  ) {\n    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {\n      failedToUpload\n      totalExcelDataRecords\n      totalDuplicateRecords\n      successfullyUploaded\n      failedUploadList\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n'],['\n  mutation($fileExtension: String!) {\n    getPublicUploadURL(fileExtension: $fileExtension) {\n      bucketName\n      filename\n      publicUploadURL\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n'],['\n  query getPublicDownloadURL($bucketname: String!, $filename: String!) {\n    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable */var GET_PROVIDER=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject);// calling server for updation
var ADD_SIM=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject2);var GET_UPLOAD_URL=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject3);var GET_FILE_FORMAT=Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject4);var styles=function styles(theme){return{button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{margin:theme.spacing.unit,minWidth:120},root:{flexGrow:1,padding:theme.spacing.unit*2}};};var AssignBulkSim=function(_Component){_inherits(AssignBulkSim,_Component);function AssignBulkSim(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,AssignBulkSim);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AssignBulkSim.__proto__||Object.getPrototypeOf(AssignBulkSim)).call.apply(_ref,[this].concat(args))),_this),_this.state={open:false,open1:false,simprovider:'',uploadSucess:true,isSimProviderValid:false,response:'',failList:'',result:false,fileName:'',isLoading:false,selectedFile:null,disable:false},_this.columns=['Sim Number','Reason'],_this.options={selectableRows:false,responsive:'scroll',rowsPerPage:15},_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));};},_this.handleClickOpen=function(){_this.setState({open:true});},_this.handleClose=function(){_this.setState({open:false});},_this.handleChange=function(event){_this.setState(_defineProperty({},event.target.name,event.target.value));},_this.handleOpen=function(){_this.setState({open:true});},_this.handleOpenSelect=function(){_this.setState({open1:true});},_this.handleCloseSelect=function(){_this.setState({open1:false});},_this.checkSimProviderValidity=function(){_this.setState({isSimProviderValid:_this.state.simprovider!==''});},_this.handleSubmit=function(client){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _ref3,data,errors,fullData,arrList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:event.preventDefault();_this.setState({isLoading:true,disable:true});_context.next=4;return client.mutate({mutation:ADD_SIM,variables:{fileInfo:{uploadFor:'AssignSimToSubscription',bucketName:_this.state.bucketName,fileName:_this.state.fileName,operationType:'SKIP'},commonInput:{partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_15__utils_getLoginId__["a" /* default */])(),subscriptionId:parseInt(_this.props.match.params.subscriptionId,10),serviceProviderId:parseInt(_this.state.simprovider,10)}},errorPolicy:'all'});case 4:_ref3=_context.sent;data=_ref3.data;errors=_ref3.errors;_this.setState({isLoading:false});if(data!==null){fullData=[];arrList=data.excelFileUpload.failedUploadList;// console.log('arrList', JSON.parse(arrList))
JSON.parse(arrList).forEach(function(element){var rowData=[];// this.clientId.push(element.id)
rowData.push(element.simNumber);rowData.push(element.errorMsg?element.errorMsg:'Invalid Device');// console.log(element.phoneNumber)
fullData.push(rowData);});_this.setState({simprovider:'',response:'Total Excel Records= '+data.excelFileUpload.totalExcelDataRecords+','+'Total Records Uploaded='+data.excelFileUpload.successfullyUploaded+', Total Records Failed To Upload='+data.excelFileUpload.failedToUpload+', Total Duplicate Records in Excel='+data.excelFileUpload.totalDuplicateRecords,uploadSucess:true,failList:fullData,result:true});}else{_this.setState({response:errors[0].message,uploadSucess:true});}// console.log('failList', this.state.failList)
case 9:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}();},_this.onUpload=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4){var _ref4$target=_ref4.target,validity=_ref4$target.validity,_ref4$target$files=_slicedToArray(_ref4$target.files,1),file=_ref4$target$files[0];var fileExtension,response,url;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:// TODO: Handle upload errors
_this.setState({isUploading:true});if(!validity.valid){_context2.next=11;break;}fileExtension=file.name.substring(file.name.lastIndexOf('.')+1);_context2.next=5;return _this.props.client.mutate({mutation:GET_UPLOAD_URL,variables:{fileExtension:fileExtension}});case 5:response=_context2.sent;if(!(response.data&&response.data.getPublicUploadURL)){_context2.next=11;break;}url=response.data.getPublicUploadURL.publicUploadURL;_context2.next=10;return __WEBPACK_IMPORTED_MODULE_13_axios___default.a.put(url,file,{headers:{"x-ms-blob-type":"BlockBlob","Content-Type":file.type||"application/octet-stream"}});case 10:_this.setState({fileName:response.data.getPublicUploadURL.filename,bucketName:response.data.getPublicUploadURL.bucketName,publicUploadURL:response.data.getPublicUploadURL.publicUploadURL});case 11:_this.setState({isUploading:false,selectedFile:file.name});case 12:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref5.apply(this,arguments);};}(),_this.downloadBulkUpload=function(client){return function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(event){var _ref7,data,res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return _this.props.client.query({query:GET_FILE_FORMAT,variables:{bucketname:'excel-templates',filename:'BulkAssignSimTemplate.xlsx'},errorPolicy:'all'});case 2:_ref7=_context3.sent;data=_ref7.data;_context3.next=6;return __WEBPACK_IMPORTED_MODULE_13_axios___default()({url:data.getPublicDownloadURL,method:'GET',headers:{Accept:'application/vnd.ms-excel'},responseType:'blob'// important
});case 6:res=_context3.sent;__WEBPACK_IMPORTED_MODULE_16_file_saver___default.a.saveAs(new Blob([res.data]),'sample.xlsx');// FileSaver.saveAs(data.getPublicDownloadURL, 'sample.xlsx')
case 8:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x3){return _ref6.apply(this,arguments);};}();},_this.setToDefaults=function(){_this.setState({open:false,open1:false,simprovider:'',uploadSucess:true,isSimProviderValid:false,response:'',failList:'',result:false,fileName:'',isLoading:false,disable:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AssignBulkSim,[{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["Query"],{query:GET_PROVIDER,fetchPolicy:'network-only'},function(_ref8){var loading=_ref8.loading,error=_ref8.error,data=_ref8.data;var queriedData=data;if(loading)return'Loading...';if(error)return'Error!: '+error;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{container:true,direction:'row',justify:'flex-start',alignItems:'center',spacing:16},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Typography"],{variant:'headline'},'Upload Bulk Assign Sim Details ')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{style:{minWidth:'40%'}},_this3.state.uploadSucess&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Typography"],{variant:'subheading',color:'primary'},_this3.state.response),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{xs:12},'Download sample template for assigning sim in bulk'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:7},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a// fullWidth
,{color:'secondary',variant:'contained',className:classes.button,onClick:_this3.downloadBulkUpload(_this3.props.client)},'Download Bulk Assign Sim Excel')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{accept:'*/*',id:'contained-button-file',multiple:true,type:'file',style:{display:'none'},onChange:_this3.onUpload}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{htmlFor:'contained-button-file'},'Upload excel file here \xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{variant:'contained',component:'span',color:'primary'},_this3.state.isUploading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_CircularProgress___default.a,{size:15}):'Upload')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{color:'#43a146'}},_this3.state.selectedFile===null?'   No File Selected':'     '+_this3.state.selectedFile))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),'\xA0 \xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:function onClick(){return _this3.props.history.goBack();},color:'default',variant:'contained'// href={this.props.history.goBack()}
},'Cancel'),'\xA0 \xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Button___default.a,{onClick:_this3.handleSubmit(_this3.props.client),color:'primary',type:'submit',variant:'contained',disabled:!_this3.state.fileName||_this3.state.disable// disabled={
//     !(
//         this.state.isSimProviderValid &&
//         this.state.fileName !== ''
//     ) || this.state.disable
// }
},'Submit'),' ',_this3.state.isLoading&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'Excel sheet upload is in progress..'),_this3.state.result&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["Grid"],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h5',null,'Failed records list'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_mui_datatables___default.a,{data:_this3.state.failList,columns:_this3.columns,options:_this3.options})))));});}}]);return AssignBulkSim;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["withStyles"])(styles)(__WEBPACK_IMPORTED_MODULE_14_react_router_dom_withRouter___default()(Object(__WEBPACK_IMPORTED_MODULE_11_react_apollo__["withApollo"])(AssignBulkSim))));

/***/ }),
/* 2449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DetailedAlerts */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__HOCs_withSharedSnackbar_withSharedSnackbar__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_FormGroup__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_FormGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_FormGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_FormHelperText__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_FormHelperText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_FormHelperText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_multiselect_react_dropdown__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_multiselect_react_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_multiselect_react_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_material_ui_pickers__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_core_Radio__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_core_Radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core_RadioGroup__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core_RadioGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_RadioGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_core_FormControlLabel__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_core_FormControlLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_FormControlLabel__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query allClientDetails($partnerLoginId: Int, $status: Int) {\n    clientsDetails: allClientDetails(\n      partnerLoginId: $partnerLoginId\n      status: $status\n    ) {\n      clientName\n      loginId\n      partner {\n        businessName\n      }\n    }\n  }\n'],['\n  query allClientDetails($partnerLoginId: Int, $status: Int) {\n    clientsDetails: allClientDetails(\n      partnerLoginId: $partnerLoginId\n      status: $status\n    ) {\n      clientName\n      loginId\n      partner {\n        businessName\n      }\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query allClientDetails($partnerLoginId: Int) {\n    allVehicles: getAllVehicleDetailsByStatus(\n      partnerLoginId: $partnerLoginId\n      status: 1\n    ) {\n      vehicleNumber\n      clientLoginId\n      deviceDetail {\n        uniqueDeviceId\n      }\n    }\n  }\n'],['\n  query allClientDetails($partnerLoginId: Int) {\n    allVehicles: getAllVehicleDetailsByStatus(\n      partnerLoginId: $partnerLoginId\n      status: 1\n    ) {\n      vehicleNumber\n      clientLoginId\n      deviceDetail {\n        uniqueDeviceId\n      }\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query getDetailedAlertsData(\n    $clientLoginIds: [Int!]\n    $startTime: Int\n    $endTime: Int\n    $vehicleNumbers: [String!]\n    $useAlgo: String\n    $rawDataPackets: Int\n    $forAllVehicles: Boolean\n  ) {\n    getDetailedAlertsData(\n      clientLoginIds: $clientLoginIds\n      startTime: $startTime\n      endTime: $endTime\n      rawDataPackets: $rawDataPackets\n      vehicleNumbers: $vehicleNumbers\n      useAlgo: $useAlgo\n      forAllVehicles: $forAllVehicles\n    ) {\n      vehicleNumber\n      customerName\n      eventId\n      eventType\n      eventVolume\n      date\n      startTime\n      endTime\n      startTimeStamp\n      endTimeStamp\n      totalDistance_duringEvent_mts\n      totalDistance_betweenEvents_kms\n      timeElapsed_duringEvent_min\n      timeElapsed_betweenEvents_hrs\n      averageSpeed_kmph\n      currentStatus\n      ignitionOnTime_min\n      ignitionOffTime_min\n      actualDataPackets\n      idealDataPackets\n      dataConsistency\n      rawData {\n        rawFuelLevel\n        smoothFuelLevel\n        timeStamp\n        lat\n        lng\n        obdDistance\n      }\n    }\n  }\n'],['\n  query getDetailedAlertsData(\n    $clientLoginIds: [Int!]\n    $startTime: Int\n    $endTime: Int\n    $vehicleNumbers: [String!]\n    $useAlgo: String\n    $rawDataPackets: Int\n    $forAllVehicles: Boolean\n  ) {\n    getDetailedAlertsData(\n      clientLoginIds: $clientLoginIds\n      startTime: $startTime\n      endTime: $endTime\n      rawDataPackets: $rawDataPackets\n      vehicleNumbers: $vehicleNumbers\n      useAlgo: $useAlgo\n      forAllVehicles: $forAllVehicles\n    ) {\n      vehicleNumber\n      customerName\n      eventId\n      eventType\n      eventVolume\n      date\n      startTime\n      endTime\n      startTimeStamp\n      endTimeStamp\n      totalDistance_duringEvent_mts\n      totalDistance_betweenEvents_kms\n      timeElapsed_duringEvent_min\n      timeElapsed_betweenEvents_hrs\n      averageSpeed_kmph\n      currentStatus\n      ignitionOnTime_min\n      ignitionOffTime_min\n      actualDataPackets\n      idealDataPackets\n      dataConsistency\n      rawData {\n        rawFuelLevel\n        smoothFuelLevel\n        timeStamp\n        lat\n        lng\n        obdDistance\n      }\n    }\n  }\n']);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// import { Select } from '@material-ui/core'
// import MenuItem from '@material-ui/core/MenuItem'
// import FileSaver from "file-saver";
// import ExcelJS from "exceljs";
// import * as XLSX from 'xlsx'
// import FileSaver from 'file-saver'
// import {
//     MobileDateTimePicker,
//   } from "@mui/x-date-pickers";
// import { sync } from 'resolve'
var style=function style(theme){return{root:{padding:theme.spacing.unit*4,flexGrow:1,backgroundColor:theme.palette.background.paper},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},iconSmall:{fontSize:20},textField:{marginLeft:theme.spacing.unit,marginRight:theme.spacing.unit},dense:{marginTop:16},button:{margin:theme.spacing.unit*1}};};var GET_CLIENTS=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject);var ALL_VEH=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject2);var DETAILED_ALERTS_QUERY=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject3);var DetailedAlerts=function(_Component){_inherits(DetailedAlerts,_Component);function DetailedAlerts(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,DetailedAlerts);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DetailedAlerts.__proto__||Object.getPrototypeOf(DetailedAlerts)).call.apply(_ref,[this].concat(args))),_this),_this.state={detailedAlertsLoading:false,isLoading:false,selectedFormDate:new Date(),allVehicles:[],allVehiclesOption:[],rawData:[],clientsDetails:[],vehicleDetails:[],selectedClients:[],clientLoginIds:[],selectedVehicles:[],selectedUniqueIds:[],response:[],// getAllVeh: { id: false, label: 'false' },
getAllVeh:'true',useAlgo:null,rawDataPackets:30,startTime:__WEBPACK_IMPORTED_MODULE_18_moment___default()().unix().toString(),startDate:{date:__WEBPACK_IMPORTED_MODULE_18_moment___default()(),unix:__WEBPACK_IMPORTED_MODULE_18_moment___default()().unix().toString()},endDate:{date:__WEBPACK_IMPORTED_MODULE_18_moment___default()(),unix:__WEBPACK_IMPORTED_MODULE_18_moment___default()().unix().toString()},endTime:__WEBPACK_IMPORTED_MODULE_18_moment___default()().unix().toString(),partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_14__utils_getLoginId__["a" /* default */])()},_this.columns=[{name:'vehicleNumber',label:'Vehicle Number'},{name:'customerName',label:'Customer Name'},{name:'eventId',label:'eventID'},{name:'eventType',label:'event Type'// dataType: 'number'
},{name:'eventVolume',label:'Event Volume'},{name:'date',label:'Date'},{name:'startTime',label:'Start Time'},{name:'endTime',label:'End Time'},{name:'startTimeStamp',label:'Start Timestamp'},{name:'endTimeStamp',label:'End Timestamp'},{name:'timeElapsed_duringEvent_min',label:'Time Elapsed During_Event(Min)'},{name:'timeElapsed_betweenEvents_hrs',label:'TimeElapsed BetweenEvents(Hrs)',options:{customBodyRender:function customBodyRender(value,tableMeta,updateValue){var a=void 0;if(value==null)a='No Next Event';else a=value;return a;}}},{name:'totalDistance_duringEvent_mts',label:'TotalDistance DuringEvent(mtrs)'},{name:'totalDistance_betweenEvents_kms',label:'TotalDistance BetweenEvents(Kms)',options:{customBodyRender:function customBodyRender(value,tableMeta,updateValue){var a=void 0;if(value==null)a='No Next Event';else a=value;return a;}}},{name:'averageSpeed_kmph',label:'Average Speed(Kmph)',options:{customBodyRender:function customBodyRender(value,tableMeta,updateValue){var a=void 0;if(value==null)a=0;else a=value;return a;}}},{name:'currentStatus',label:'Current Status'},{name:'ignitionOnTime_min',label:'ignitionOnTime(Min)'},{name:'ignitionOffTime_min',label:'ignitionOffTime(Min)'},{name:'actualDataPackets',label:'actualDataPackets'},{name:'idealDataPackets',label:'idealDataPackets'},{name:'dataConsistency',label:'dataConsistency'},{name:'rawData',label:'rawData',options:{display:true,customBodyRender:function customBodyRender(value,tableMeta,updateValue){// const rowData = tableMeta.rowData // Get the entire row's data
// // Assuming value is an array of objects
// const csvString = value
//   .map(obj => Object.values(obj).join(', '))
//   .join('\n')
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{onClick:function onClick(){return _this.handleCellClick(value);}},'Click Me');}}}],_this.RawDatacolumns=[{label:'Raw Fuel Level',name:'rawFuelLevel'},{label:'Smooth Fuel Level',name:'smoothFuelLevel'},{label:'Timestamp',name:'timeStamp'},{label:'Latitude',name:'lat'},{label:'Longitude',name:'lng'},{label:'OBD Distance',name:'obdDistance'}],_this.handleFromDate=function(date){_this.setState({selectedFormDate:date});var finalStart=__WEBPACK_IMPORTED_MODULE_18_moment___default()(date).unix();_this.setState({fromDate:finalStart});var dateNow=new Date(date);// Now
dateNow.setDate(dateNow.getDate()+30);_this.setState({toMaxDate:dateNow});},_this.options={filter:true},_this.handleSubmit=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var res,resData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.setState({isLoading:true});_context.next=3;return _this.props.client.query({query:DETAILED_ALERTS_QUERY,variables:{clientLoginIds:_this.state.selectedClients,vehicleNumbers:_this.state.selectedVehicles,startTime:parseInt(_this.state.startTime),endTime:parseInt(_this.state.endTime),rawDataPackets:parseInt(_this.state.rawDataPackets),useAlgo:_this.state.useAlgo==null?null:_this.state.useAlgo.id,forAllVehicles:_this.state.getAllVeh==='true'?Boolean(true):Boolean(false)},fetchPolicy:'network-only'});case 3:res=_context.sent;resData=res.data.getDetailedAlertsData;_this.setState({response:resData,isLoading:false});console.log(resData);console.log(res);case 8:case'end':return _context.stop();}}},_callee,_this2);})),_this.getAllClients=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var clientsDetails,allClients;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this.props.client.query({query:GET_CLIENTS,variables:{partnerLoginId:parseInt(_this.state.partnerLoginId,10),status:parseInt(1,10)},fetchPolicy:'network-only'});case 2:clientsDetails=_context2.sent;// console.log(clientsDetails)
allClients=clientsDetails.data.clientsDetails.map(function(client){return{name:client.loginId,label:client.clientName};});console.log(allClients);_this.setState({clientsDetails:allClients});case 6:case'end':return _context2.stop();}}},_callee2,_this2);})),_this.getAllVehicles=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var allVehicles,allvehs;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return _this.props.client.query({query:ALL_VEH,variables:{partnerLoginId:parseInt(_this.state.partnerLoginId,10)},fetchPolicy:'network-only'});case 2:allVehicles=_context3.sent;console.log(allVehicles.data.allVehicles);allvehs=allVehicles.data.allVehicles.map(function(veh){return{value:veh.vehicleNumber,label:veh.vehicleNumber};});_this.setState({allVehicles:allVehicles.data.allVehicles,allVehiclesOption:allvehs});case 6:case'end':return _context3.stop();}}},_callee3,_this2);})),_this.getVehicleDetails=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(ids){var clientLoginIds,vehicleFiltered,filteredVeh;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:clientLoginIds=ids;console.log(clientLoginIds);if(clientLoginIds&&clientLoginIds.length>0){vehicleFiltered=_this.state.allVehicles.filter(function(item){return clientLoginIds.includes(item.clientLoginId);});filteredVeh=vehicleFiltered.map(function(veh){return{value:veh.vehicleNumber,label:veh.vehicleNumber};});console.log(filteredVeh);_this.setState({vehicleDetails:filteredVeh});}case 3:case'end':return _context4.stop();}}},_callee4,_this2);}));return function(_x){return _ref5.apply(this,arguments);};}(),_this.handleChangeAlgo=function(event){console.log(event);_this.setState({useAlgo:event});},_this.handleGetAll=function(event){var a=event.target.value;_this.setState({getAllVeh:a});if(a==='true'){var nextDay=__WEBPACK_IMPORTED_MODULE_18_moment___default()(_this.state.startDate.date).add(1,'days');_this.setState({endDate:{date:nextDay,unix:nextDay.unix().toString()},endTime:nextDay.unix().toString()});}},_this.handleStartDateChange=function(name){return function(date){var _this$setState;var tempDate=_this.state[name];tempDate.date=date;tempDate.unix=__WEBPACK_IMPORTED_MODULE_18_moment___default()(date).unix().toString();_this.setState((_this$setState={},_defineProperty(_this$setState,name,tempDate),_defineProperty(_this$setState,'startTime',tempDate.unix),_this$setState));if(_this.state.selectedVehicles.length===0||_this.state.getAllVeh==='true'){var nextDay=__WEBPACK_IMPORTED_MODULE_18_moment___default()(date).add(1,'days');_this.setState({endDate:{date:nextDay,unix:nextDay.unix().toString()},endTime:nextDay.unix().toString()});}};},_this.handleRawDataPacketsChange=function(event){var value=event.target.value;if(/^\d+$/.test(value)||value===''){_this.setState({rawDataPackets:Number(value)});}},_this.handleEndDateChange=function(name){return function(date){var _this$setState2;var tempDate=_this.state[name];tempDate.date=date;console.log(date);tempDate.unix=__WEBPACK_IMPORTED_MODULE_18_moment___default()(date).unix().toString();_this.setState((_this$setState2={},_defineProperty(_this$setState2,name,tempDate),_defineProperty(_this$setState2,'endTime',tempDate.unix),_this$setState2));};},_this.handleClientRemove=function(selectedList,removedItem){var updatedSelectedClients=selectedList.map(function(item){return item.name;});_this.setState({selectedClients:updatedSelectedClients,selectedVehicles:[]});_this.getVehicleDetails(updatedSelectedClients);},_this.handleClientSelect=function(selectedList,selectedItem){var updatedSelectedClients=selectedList.map(function(item){return item.name;});_this.setState({selectedClients:updatedSelectedClients,selectedVehicles:[]});_this.getVehicleDetails(updatedSelectedClients);},_this.handleVehicleRemove=function(selectedList,removedItem){var updatedSelectedClients=selectedList.map(function(item){return item.name;});_this.setState({selectedClients:updatedSelectedClients,selectedVehicles:[]});// Check if any vehicles are still selected, if not, update end date
if(updatedSelectedClients.length===0){var nextDay=__WEBPACK_IMPORTED_MODULE_18_moment___default()(_this.state.startDate.date).add(1,'days');_this.setState({endDate:{date:nextDay,unix:nextDay.unix().toString()},endTime:nextDay.unix().toString()});}else{_this.getVehicleDetails(updatedSelectedClients);}},_this.handleVehicleSelect=function(selectedList,selectedItem){var updatedSelectedClients=selectedList.map(function(item){return item.value;});_this.setState({selectedVehicles:updatedSelectedClients});},_this.downloadExcel=function(buildHead,buildBody,columns,data){console.log('in download excel function.....');var processedData=data.map(function(row){var processedRow=Object.assign({},row);if(row.data&&Array.isArray(row.data)){var processedDataArray=row.data.map(function(item){return Array.isArray(item)?// ? item.map(subItem => Object.values(subItem).join(' ')).join(',')
JSON.stringify(item):item===null?'NoNextEvent':item;});processedRow.data=processedDataArray;}return processedRow;});var csvContent=buildHead(columns)+'\n'+buildBody(processedData);var blob=new Blob([csvContent],{type:'text/csv'});var link=document.createElement('a');link.href=window.URL.createObjectURL(blob);link.download='exported_data.csv';link.click();window.URL.revokeObjectURL(link.href);link.remove();return false;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DetailedAlerts,[{key:'handleCellClick',value:function handleCellClick(cellValue){console.log(cellValue);this.setState({rawData:cellValue});}},{key:'componentDidMount',value:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:this.getAllClients();this.getAllVehicles();case 2:case'end':return _context5.stop();}}},_callee5,this);}));function componentDidMount(){return _ref6.apply(this,arguments);}return componentDidMount;}()// handleGetAll = event => {
//   console.log(event.target.value)
//   let a = event.target.value
//   console.log(a)
//   this.setState({ getAllVeh: a })
// }
// handleStartDateChange = name => date => {
//   let tempDate = this.state[name]
//   tempDate.date = date
//   console.log(date)
//   tempDate.unix = moment(date)
//     .unix()
//     .toString()
//   this.setState({ [name]: tempDate, startTime: tempDate.unix })
// }
// handleVehicleRemove = (selectedList, removedItem) => {
//   const updatedSelectedClients = selectedList.map(item => item.value)
//   this.setState({ selectedVehicles: updatedSelectedClients })
// }
},{key:'render',value:function render(){console.log(this.state);console.log(this.props);var classes=this.props.classes;var _state=this.state,detailedAlertsLoading=_state.detailedAlertsLoading,clientsDetails=_state.clientsDetails,selectedClients=_state.selectedClients,useAlgo=_state.useAlgo;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'title',gutterBottom:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Detailed Alerts',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true,spacing:16,style:{display:'flex',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true,style:{display:'flex',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true,className:'searchdiv',spacing:8,justify:'center',style:{display:'flex',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{style:{marginRight:'20px'}},'Clinet LoginIDs :'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default.a,{style:{minWidth:'50%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_multiselect_react_dropdown___default.a,{displayValue:'label',onKeyPressFn:function noRefCheck(){},onSearch:function noRefCheck(){},onRemove:this.handleClientRemove,onSelect:this.handleClientSelect,options:this.state.clientsDetails,placeholder:'Select ClinetLoginIDs'// style={{
//   chips: {
//     background: 'grey'
//   },
//   // searchBox: {
//   //   border: 'none',
//   //   'border-bottom': '1px solid blue',
//   //   'border-radius': '0px'
//   // }
// }}
}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{style:{marginRight:'20px'}},'Vehicle Numbers :'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default.a,{style:{minWidth:'50%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_multiselect_react_dropdown___default.a,{displayValue:'label',onKeyPressFn:function noRefCheck(){},onSearch:function noRefCheck(){},onRemove:this.handleVehicleRemove,onSelect:this.handleVehicleSelect,placeholder:'Select Vehicles',options:this.state.selectedClients.length==0?this.state.allVehiclesOption:this.state.vehicleDetails}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,fullwidth:'true'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{style:{marginRight:'20px'}},'Use Algo :'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default.a,{style:{minWidth:'50%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select__["a" /* default */],{classes:classes,options:[{id:'taabi1',label:'taabi1'},{id:'taabi3',label:'taabi3'}],value:this.state.useAlgo,onChange:this.handleChangeAlgo,placeholder:'Select Algorithm'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,fullwidth:'true',style:{display:'flex',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{style:{marginRight:'10px'}},'Get AllVehicles:'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default.a,{style:{minWidth:'50%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_FormGroup___default.a,{row:true,className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_RadioGroup___default.a,{'aria-label':'getAllVeh',name:'getAllVeh',value:this.state.getAllVeh,onChange:this.handleGetAll,row:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_FormControlLabel___default.a,{value:'true',control:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Radio___default.a,null),label:'true'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_FormControlLabel___default.a,{value:'false',control:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Radio___default.a,null),label:'false'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,fullwidth:'true'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default.a,{style:{minWidth:'70%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_TextField___default.a,{className:'textfield',type:'number',label:'raw data packets',value:this.state.rawDataPackets,required:true,onChange:this.handleRawDataPacketsChange}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,fullwidth:'true'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default.a,{style:{minWidth:'70%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_material_ui_pickers__["a" /* DatePicker */],{format:'DD/MM/YYYY',maxDate:new Date(),value:this.state.startDate.date,onChange:this.handleStartDateChange('startDate'),label:'Start Date'})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,fullwidth:'true'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default.a,{style:{minWidth:'70%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_material_ui_pickers__["a" /* DatePicker */],{format:'DD/MM/YYYY',maxDate:new Date(),value:this.state.endDate.date,onChange:this.handleEndDateChange('endDate'),label:'End Date',disabled:this.state.selectedVehicles.length===0||this.state.getAllVeh==='true'}))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_FormGroup___default.a,{className:'form-input',style:{padding:'25px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{justify:'left',container:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{variant:'contained',color:'secondary',className:classes.button,onClick:this.handleSubmit},'\u21AA Submit'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12},detailedAlertsLoading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Loading...'):this.state.isLoading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Loading...'):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_mui_datatables___default.a,{title:'Detailed Alerts',data:this.state.response,columns:this.columns,options:{onDownload:this.downloadExcel}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12,style:{paddingTop:'10px'}},this.state.rawData.length>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_mui_datatables___default.a,{title:'Raw Data',data:this.state.rawData,columns:this.RawDatacolumns})));}}]);return DetailedAlerts;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_10__HOCs_withSharedSnackbar_withSharedSnackbar__["a" /* default */])(DetailedAlerts))));

/***/ }),
/* 2450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PilRefuleAlerts */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mui_datatables__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mui_datatables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mui_datatables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__HOCs_withSharedSnackbar_withSharedSnackbar__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_FormGroup__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_FormGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_FormGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_FormHelperText__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_FormHelperText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_FormHelperText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_multiselect_react_dropdown__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_multiselect_react_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_multiselect_react_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_material_ui_pickers__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_moment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_core_Radio__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_core_Radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core_RadioGroup__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_core_RadioGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_RadioGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_core_FormControlLabel__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_core_FormControlLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_FormControlLabel__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query allClientDetails($partnerLoginId: Int, $status: Int) {\n    clientsDetails: allClientDetails(\n      partnerLoginId: $partnerLoginId\n      status: $status\n    ) {\n      clientName\n      loginId\n      partner {\n        businessName\n      }\n    }\n  }\n'],['\n  query allClientDetails($partnerLoginId: Int, $status: Int) {\n    clientsDetails: allClientDetails(\n      partnerLoginId: $partnerLoginId\n      status: $status\n    ) {\n      clientName\n      loginId\n      partner {\n        businessName\n      }\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query allClientDetails($partnerLoginId: Int) {\n    allVehicles: getAllVehicleDetailsByStatus(\n      partnerLoginId: $partnerLoginId\n      status: 1\n    ) {\n      vehicleNumber\n      clientLoginId\n      deviceDetail {\n        uniqueDeviceId\n      }\n    }\n  }\n'],['\n  query allClientDetails($partnerLoginId: Int) {\n    allVehicles: getAllVehicleDetailsByStatus(\n      partnerLoginId: $partnerLoginId\n      status: 1\n    ) {\n      vehicleNumber\n      clientLoginId\n      deviceDetail {\n        uniqueDeviceId\n      }\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query getRefuelAndPilferageAlerts(\n    $clientLoginIds: [Int!]\n    $startTime: Int\n    $endTime: Int\n    $forAllVehicles: Boolean\n    $vehicleNumbers: [String!]\n  ) {\n    getRefuelAndPilferageAlerts(\n      clientLoginIds: $clientLoginIds\n      startTime: $startTime\n      endTime: $endTime\n      forAllVehicles: $forAllVehicles\n      vehicleNumbers: $vehicleNumbers\n    ) {\n      vehicleNumber\n      date\n      eventType\n      eventVolume\n      startTime\n      endTime\n      loc\n      lat\n      lng\n    }\n  }\n'],['\n  query getRefuelAndPilferageAlerts(\n    $clientLoginIds: [Int!]\n    $startTime: Int\n    $endTime: Int\n    $forAllVehicles: Boolean\n    $vehicleNumbers: [String!]\n  ) {\n    getRefuelAndPilferageAlerts(\n      clientLoginIds: $clientLoginIds\n      startTime: $startTime\n      endTime: $endTime\n      forAllVehicles: $forAllVehicles\n      vehicleNumbers: $vehicleNumbers\n    ) {\n      vehicleNumber\n      date\n      eventType\n      eventVolume\n      startTime\n      endTime\n      loc\n      lat\n      lng\n    }\n  }\n']);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// import { Select } from '@material-ui/core'
// import MenuItem from '@material-ui/core/MenuItem'
// import FileSaver from "file-saver";
// import ExcelJS from "exceljs";
// import * as XLSX from 'xlsx'
// import FileSaver from 'file-saver'
// import {
//     MobileDateTimePicker,
//   } from "@mui/x-date-pickers";
// import { sync } from 'resolve'
var style=function style(theme){return{root:{padding:theme.spacing.unit*4,flexGrow:1,backgroundColor:theme.palette.background.paper},paper:{padding:theme.spacing.unit*2,textAlign:'center',color:theme.palette.text.secondary},iconSmall:{fontSize:20},textField:{marginLeft:theme.spacing.unit,marginRight:theme.spacing.unit},dense:{marginTop:16},button:{margin:theme.spacing.unit*1}};};var GET_CLIENTS=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject);var ALL_VEH=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject2);var REFUEL_AND_PILFERAGE_ALERTS_QUERY=Object(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__["a" /* default */])(_templateObject3);var PilRefuleAlerts=function(_Component){_inherits(PilRefuleAlerts,_Component);function PilRefuleAlerts(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,PilRefuleAlerts);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PilRefuleAlerts.__proto__||Object.getPrototypeOf(PilRefuleAlerts)).call.apply(_ref,[this].concat(args))),_this),_this.state={detailedAlertsLoading:false,isLoading:false,selectedFormDate:new Date(),allVehicles:[],allVehiclesOption:[],rawData:[],clientsDetails:[],vehicleDetails:[],selectedClients:[],clientLoginIds:[],selectedVehicles:[],selectedUniqueIds:[],response:[],getAllVeh:'false',startTime:__WEBPACK_IMPORTED_MODULE_18_moment___default()().unix().toString(),startDate:{date:__WEBPACK_IMPORTED_MODULE_18_moment___default()(),unix:__WEBPACK_IMPORTED_MODULE_18_moment___default()().unix().toString()},endDate:{date:__WEBPACK_IMPORTED_MODULE_18_moment___default()(),unix:__WEBPACK_IMPORTED_MODULE_18_moment___default()().unix().toString()},endTime:__WEBPACK_IMPORTED_MODULE_18_moment___default()().unix().toString(),partnerLoginId:Object(__WEBPACK_IMPORTED_MODULE_14__utils_getLoginId__["a" /* default */])()},_this.columns=[{name:'vehicleNumber',label:'Vehicle Number'},{name:'date',label:'Date'},{name:'startTime',label:'Start Time'},{name:'endTime',label:'End Time'},{name:'eventType',label:'event Type'// dataType: 'number'
},{name:'eventVolume',label:'Event Volume'},{name:'loc',label:'Event Address'},{name:'lat',label:'lat'},{name:'lng',label:'lng'}],_this.handleFromDate=function(date){_this.setState({selectedFormDate:date});var finalStart=__WEBPACK_IMPORTED_MODULE_18_moment___default()(date).unix();_this.setState({fromDate:finalStart});var dateNow=new Date(date);// Now
dateNow.setDate(dateNow.getDate()+30);_this.setState({toMaxDate:dateNow});},_this.options={filter:true},_this.handleSubmit=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var res,resData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.setState({isLoading:true});_context.next=3;return _this.props.client.query({query:REFUEL_AND_PILFERAGE_ALERTS_QUERY,variables:{clientLoginIds:_this.state.selectedClients,vehicleNumbers:_this.state.selectedVehicles,startTime:parseInt(_this.state.startTime),endTime:parseInt(_this.state.endTime),forAllVehicles:_this.state.getAllVeh==='true'?Boolean(true):Boolean(false)},fetchPolicy:'network-only'});case 3:res=_context.sent;resData=res.data.getRefuelAndPilferageAlerts;_this.setState({response:resData,isLoading:false});console.log(resData);console.log(res);case 8:case'end':return _context.stop();}}},_callee,_this2);})),_this.getAllClients=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var clientsDetails,allClients;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this.props.client.query({query:GET_CLIENTS,variables:{partnerLoginId:parseInt(_this.state.partnerLoginId,10),status:parseInt(1,10)},fetchPolicy:'network-only'});case 2:clientsDetails=_context2.sent;// console.log(clientsDetails)
allClients=clientsDetails.data.clientsDetails.map(function(client){return{name:client.loginId,label:client.clientName};});console.log(allClients);_this.setState({clientsDetails:allClients});case 6:case'end':return _context2.stop();}}},_callee2,_this2);})),_this.getAllVehicles=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var allVehicles,allvehs;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return _this.props.client.query({query:ALL_VEH,variables:{partnerLoginId:parseInt(_this.state.partnerLoginId,10)},fetchPolicy:'network-only'});case 2:allVehicles=_context3.sent;console.log(allVehicles.data.allVehicles);allvehs=allVehicles.data.allVehicles.map(function(veh){return{value:veh.vehicleNumber,label:veh.vehicleNumber};});_this.setState({allVehicles:allVehicles.data.allVehicles,allVehiclesOption:allvehs});case 6:case'end':return _context3.stop();}}},_callee3,_this2);})),_this.getVehicleDetails=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(ids){var clientLoginIds,vehicleFiltered,filteredVeh;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:clientLoginIds=ids;console.log(clientLoginIds);if(clientLoginIds&&clientLoginIds.length>0){vehicleFiltered=_this.state.allVehicles.filter(function(item){return clientLoginIds.includes(item.clientLoginId);});filteredVeh=vehicleFiltered.map(function(veh){return{value:veh.vehicleNumber,label:veh.vehicleNumber};});console.log(filteredVeh);_this.setState({vehicleDetails:filteredVeh});}case 3:case'end':return _context4.stop();}}},_callee4,_this2);}));return function(_x){return _ref5.apply(this,arguments);};}(),_this.handleGetAll=function(event){console.log(event.target.value);var a=event.target.value;console.log(a);_this.setState({getAllVeh:a});},_this.handleStartDateChange=function(name){return function(date){var _this$setState;var tempDate=_this.state[name];tempDate.date=date;console.log(date);tempDate.unix=__WEBPACK_IMPORTED_MODULE_18_moment___default()(date).unix().toString();_this.setState((_this$setState={},_defineProperty(_this$setState,name,tempDate),_defineProperty(_this$setState,'startTime',tempDate.unix),_this$setState));};},_this.handleEndDateChange=function(name){return function(date){var _this$setState2;var tempDate=_this.state[name];tempDate.date=date;console.log(date);tempDate.unix=__WEBPACK_IMPORTED_MODULE_18_moment___default()(date).unix().toString();_this.setState((_this$setState2={},_defineProperty(_this$setState2,name,tempDate),_defineProperty(_this$setState2,'endTime',tempDate.unix),_this$setState2));};},_this.handleClientRemove=function(selectedList,removedItem){var updatedSelectedClients=selectedList.map(function(item){return item.name;});_this.setState({selectedClients:updatedSelectedClients,selectedVehicles:[]});_this.getVehicleDetails(updatedSelectedClients);},_this.handleClientSelect=function(selectedList,selectedItem){var updatedSelectedClients=selectedList.map(function(item){return item.name;});_this.setState({selectedClients:updatedSelectedClients,selectedVehicles:[]});_this.getVehicleDetails(updatedSelectedClients);},_this.handleVehicleRemove=function(selectedList,removedItem){var updatedSelectedClients=selectedList.map(function(item){return item.value;});_this.setState({selectedVehicles:updatedSelectedClients});},_this.handleVehicleSelect=function(selectedList,selectedItem){var updatedSelectedClients=selectedList.map(function(item){return item.value;});_this.setState({selectedVehicles:updatedSelectedClients});},_this.downloadExcel=function(buildHead,buildBody,columns,data){console.log('in download excel function.....');var processedData=data.map(function(row){var processedRow=Object.assign({},row);if(row.data&&Array.isArray(row.data)){var processedDataArray=row.data.map(function(item){return Array.isArray(item)?// ? item.map(subItem => Object.values(subItem).join(' ')).join(',')
JSON.stringify(item):item===null?'NoNextEvent':item;});processedRow.data=processedDataArray;}return processedRow;});var csvContent=buildHead(columns)+'\n'+buildBody(processedData);var blob=new Blob([csvContent],{type:'text/csv'});var link=document.createElement('a');link.href=window.URL.createObjectURL(blob);link.download='exported_data.csv';link.click();window.URL.revokeObjectURL(link.href);link.remove();return false;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PilRefuleAlerts,[{key:'handleCellClick',value:function handleCellClick(cellValue){console.log(cellValue);this.setState({rawData:cellValue});}},{key:'componentDidMount',value:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:this.getAllClients();this.getAllVehicles();case 2:case'end':return _context5.stop();}}},_callee5,this);}));function componentDidMount(){return _ref6.apply(this,arguments);}return componentDidMount;}()},{key:'render',value:function render(){console.log(this.state);console.log(this.props);var classes=this.props.classes;var _state=this.state,detailedAlertsLoading=_state.detailedAlertsLoading,clientsDetails=_state.clientsDetails,selectedClients=_state.selectedClients;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Typography___default.a,{variant:'title',gutterBottom:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Refuel And Pilferage Alerts',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true,spacing:16,style:{display:'flex',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true,style:{display:'flex',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true,className:'searchdiv',spacing:8,justify:'center',style:{display:'flex',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{style:{marginRight:'20px'}},'Clinet LoginIDs :'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default.a,{style:{minWidth:'50%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_multiselect_react_dropdown___default.a,{displayValue:'label',onKeyPressFn:function noRefCheck(){},onSearch:function noRefCheck(){},onRemove:this.handleClientRemove,onSelect:this.handleClientSelect,options:this.state.clientsDetails,placeholder:'Select ClinetLoginIDs'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{style:{marginRight:'20px'}},'Vehicle Numbers :'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default.a,{style:{minWidth:'50%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_multiselect_react_dropdown___default.a,{displayValue:'label',onKeyPressFn:function noRefCheck(){},onSearch:function noRefCheck(){},onRemove:this.handleVehicleRemove,onSelect:this.handleVehicleSelect,placeholder:'Select Vehicles',options:this.state.selectedClients.length==0?this.state.allVehiclesOption:this.state.vehicleDetails}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,fullwidth:'true',style:{display:'flex',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{style:{marginRight:'10px'}},'Get AllVehicles:'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default.a,{style:{minWidth:'50%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_FormGroup___default.a,{row:true,className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_core_RadioGroup___default.a,{'aria-label':'getAllVeh',name:'getAllVeh',value:this.state.getAllVeh,onChange:this.handleGetAll,row:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_FormControlLabel___default.a,{value:'true',control:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Radio___default.a,null),label:'true'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_core_FormControlLabel___default.a,{value:'false',control:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_core_Radio___default.a,null),label:'false'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_FormHelperText___default.a,{id:'name-error-text',className:'Error_msg'})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,fullwidth:'true'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default.a,{style:{minWidth:'70%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_material_ui_pickers__["a" /* DatePicker */],{format:'DD/MM/YYYY',maxDate:new Date(),value:this.state.startDate.date,onChange:this.handleStartDateChange('startDate'),label:'Start Date'})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12,sm:12,fullwidth:'true'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_FormControl___default.a,{style:{minWidth:'70%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_FormGroup___default.a,{className:'form-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_material_ui_pickers__["a" /* DatePicker */],{format:'DD/MM/YYYY',maxDate:new Date(),value:this.state.endDate.date,onChange:this.handleEndDateChange('endDate'),label:'End Date'}))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_FormGroup___default.a,{className:'form-input',style:{padding:'25px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{justify:'left',container:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Button___default.a,{variant:'contained',color:'secondary',className:classes.button,onClick:this.handleSubmit},'\u21AA Submit'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12},detailedAlertsLoading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Loading...'):this.state.isLoading?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Loading...'):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_mui_datatables___default.a,{title:'Refuel And Pilferage Alerts',data:this.state.response,columns:this.columns,options:{onDownload:this.downloadExcel}})));}}]);return PilRefuleAlerts;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__["withStyles"])(style)(Object(__WEBPACK_IMPORTED_MODULE_4_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_10__HOCs_withSharedSnackbar_withSharedSnackbar__["a" /* default */])(PilRefuleAlerts))));

/***/ }),
/* 2451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Paper__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Paper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormGroup__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Tabs__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Tab__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Checkbox__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_FormControlLabel__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_FormControlLabel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_FormControlLabel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_Icon__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__common_ConfirmationDialog__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__solutionTypeMapping__ = __webpack_require__(2452);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query allClientDetails($partnerLoginId: Int) {\n    clients: allClientDetails(partnerLoginId: $partnerLoginId) {\n      id\n      clientName\n      loginId\n    }\n  }\n'],['\n  query allClientDetails($partnerLoginId: Int) {\n    clients: allClientDetails(partnerLoginId: $partnerLoginId) {\n      id\n      clientName\n      loginId\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query GetDashcamRegistrations {\n    getDashcamRegistrations {\n      success\n      message\n      data {\n        uuid\n        simid\n        memorycardid\n        uniqueid\n        vtid\n        status\n        createdat\n        updatedat\n      }\n    }\n  }\n'],['\n  query GetDashcamRegistrations {\n    getDashcamRegistrations {\n      success\n      message\n      data {\n        uuid\n        simid\n        memorycardid\n        uniqueid\n        vtid\n        status\n        createdat\n        updatedat\n      }\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query getAllVehicleDetails($clientLoginId: Int) {\n    getAllVehicleDetails(clientLoginId: $clientLoginId) {\n      entityId\n      vehicleNumber\n      solution_type\n      deviceDetail {\n        uniqueDeviceId\n      }\n      simDetail {\n        id\n        phoneNumber\n      }\n      videoTelematicsType\n      videoTelematicsId\n    }\n  }\n'],['\n  query getAllVehicleDetails($clientLoginId: Int) {\n    getAllVehicleDetails(clientLoginId: $clientLoginId) {\n      entityId\n      vehicleNumber\n      solution_type\n      deviceDetail {\n        uniqueDeviceId\n      }\n      simDetail {\n        id\n        phoneNumber\n      }\n      videoTelematicsType\n      videoTelematicsId\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query GetAllMasterSolutionType {\n    getAllMasterSolutionType {\n      id\n      solutionTypeName\n    }\n  }\n'],['\n  query GetAllMasterSolutionType {\n    getAllMasterSolutionType {\n      id\n      solutionTypeName\n    }\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  query GetAllSolutionTypes($clientCategory: ClientCategory, $clientLoginId: Int) {\n    getAllSolutionTypes(\n      clientCategory: $clientCategory\n      clientLoginId: $clientLoginId\n    ) {\n      id\n      solution_type_name\n      description\n      solutionTypeCategory\n      plans {\n        id\n        planName\n        planTypeId\n        durationInYears\n        durationInMonths\n        durationLabel\n        description\n        basePrice\n        discount\n        perMonthBaseValue\n        perMonthDiscountedValue\n        isPopular\n      }\n    }\n  }\n'],['\n  query GetAllSolutionTypes($clientCategory: ClientCategory, $clientLoginId: Int) {\n    getAllSolutionTypes(\n      clientCategory: $clientCategory\n      clientLoginId: $clientLoginId\n    ) {\n      id\n      solution_type_name\n      description\n      solutionTypeCategory\n      plans {\n        id\n        planName\n        planTypeId\n        durationInYears\n        durationInMonths\n        durationLabel\n        description\n        basePrice\n        discount\n        perMonthBaseValue\n        perMonthDiscountedValue\n        isPopular\n      }\n    }\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  mutation AddDeviceTop(\n    $clientLoginId: Int\n    $uniqueDeviceId: String\n    $existingSolutionType: String\n    $newSolutionType: String\n    $planDuration: String\n    $vehicledeviceid: Int\n    $vt_created_by: String\n    $created_by: String\n    $updated_by: String\n    $newSimId: Int\n    $loginType: String\n  ) {\n    addDeviceTop(\n      clientLoginId: $clientLoginId\n      uniqueDeviceId: $uniqueDeviceId\n      existingSolutionType: $existingSolutionType\n      newSolutionType: $newSolutionType\n      planDuration: $planDuration\n      vehicledeviceid: $vehicledeviceid\n      vt_created_by: $vt_created_by\n      created_by: $created_by\n      updated_by: $updated_by\n      newSimId: $newSimId\n      loginType: $loginType\n    ) {\n      success\n      message\n    }\n  }\n'],['\n  mutation AddDeviceTop(\n    $clientLoginId: Int\n    $uniqueDeviceId: String\n    $existingSolutionType: String\n    $newSolutionType: String\n    $planDuration: String\n    $vehicledeviceid: Int\n    $vt_created_by: String\n    $created_by: String\n    $updated_by: String\n    $newSimId: Int\n    $loginType: String\n  ) {\n    addDeviceTop(\n      clientLoginId: $clientLoginId\n      uniqueDeviceId: $uniqueDeviceId\n      existingSolutionType: $existingSolutionType\n      newSolutionType: $newSolutionType\n      planDuration: $planDuration\n      vehicledeviceid: $vehicledeviceid\n      vt_created_by: $vt_created_by\n      created_by: $created_by\n      updated_by: $updated_by\n      newSimId: $newSimId\n      loginType: $loginType\n    ) {\n      success\n      message\n    }\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  query getAllAssignedDevicesToClient($clientId: Int!) {\n    device: getAllAssignedDevicesToClient(clientLoginId: $clientId) {\n      uniqueDeviceId\n      deviceModel {\n        model_name\n      }\n    }\n  }\n'],['\n  query getAllAssignedDevicesToClient($clientId: Int!) {\n    device: getAllAssignedDevicesToClient(clientLoginId: $clientId) {\n      uniqueDeviceId\n      deviceModel {\n        model_name\n      }\n    }\n  }\n']),_templateObject8=_taggedTemplateLiteral(['\n  query getAllAssignedSimToClient($clientId: Int!) {\n    simDetails: getAllAssignedSimToClient(clientLoginId: $clientId) {\n      id\n      simId\n      sim {\n        phoneNumber\n      }\n    }\n  }\n'],['\n  query getAllAssignedSimToClient($clientId: Int!) {\n    simDetails: getAllAssignedSimToClient(clientLoginId: $clientId) {\n      id\n      simId\n      sim {\n        phoneNumber\n      }\n    }\n  }\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var SolutionTypeOption=function SolutionTypeOption(props){var onSelect=props.onSelect,onFocus=props.onFocus,isSelected=props.isSelected,option=props.option,children=props.children,className=props.className;var handleMouseDown=function handleMouseDown(event){event.preventDefault();event.stopPropagation();onSelect(option,event);};var handleMouseEnter=function handleMouseEnter(event){onFocus(option,event);};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:className,onMouseDown:handleMouseDown,onMouseEnter:handleMouseEnter,onMouseMove:handleMouseEnter,title:option.title,style:{display:'flex',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Checkbox___default.a,{checked:!!isSelected,color:'primary'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,children));};var GET_CLIENTS=Object(__WEBPACK_IMPORTED_MODULE_16_graphql_tag__["a" /* default */])(_templateObject);var GET_DASHCAM_REGISTRATIONS=Object(__WEBPACK_IMPORTED_MODULE_16_graphql_tag__["a" /* default */])(_templateObject2);var GET_VEHICLES=Object(__WEBPACK_IMPORTED_MODULE_16_graphql_tag__["a" /* default */])(_templateObject3);var GET_SOLUTION_TYPES=Object(__WEBPACK_IMPORTED_MODULE_16_graphql_tag__["a" /* default */])(_templateObject4);var GET_SOLUTION_TYPES_WITH_PLANS=Object(__WEBPACK_IMPORTED_MODULE_16_graphql_tag__["a" /* default */])(_templateObject5);var ADD_DEVICE_TOP=Object(__WEBPACK_IMPORTED_MODULE_16_graphql_tag__["a" /* default */])(_templateObject6);// Query to fetch available devices assigned to the selected customer
var GET_AVAILABLE_DEVICES=Object(__WEBPACK_IMPORTED_MODULE_16_graphql_tag__["a" /* default */])(_templateObject7);// Query to fetch available SIMs (phone numbers) assigned to the selected customer
var GET_AVAILABLE_SIMS=Object(__WEBPACK_IMPORTED_MODULE_16_graphql_tag__["a" /* default */])(_templateObject8);var styles=function styles(theme){return{root:{padding:24,marginTop:24,backgroundColor:'#fafafa',minHeight:'100vh'},paper:{padding:24,marginBottom:20,borderRadius:8,boxShadow:'0 2px 8px rgba(0,0,0,0.08)'},formControl:{marginTop:8,width:'100%'},selectBox:{width:'100%'},button:{marginLeft:10,minWidth:140,height:40},sectionTitle:{fontWeight:600,marginBottom:16,color:'#2c3e50'},vehicleCard:{background:'#ffffff',padding:16,borderRadius:8,border:'1px solid #e0e0e0',boxShadow:'0 1px 4px rgba(0,0,0,0.06)'},infoRow:{display:'flex',alignItems:'center',padding:'8px 0',borderBottom:'1px solid #f0f0f0','&:last-child':{borderBottom:'none'}},infoLabel:{fontWeight:600,color:'#555',minWidth:160,fontSize:13},infoValue:{color:'#222',fontSize:13},solutionChip:{display:'inline-block',padding:'3px 10px',borderRadius:20,background:'#e3f2fd',color:'#1565c0',border:'1px solid #90caf9',marginRight:6,marginTop:4,fontSize:12,fontWeight:500},planCard:{display:'flex',alignItems:'center',gap:10,padding:'10px 16px',background:'#f1f8e9',border:'1px solid #aed581',borderRadius:6},submitBtn:{minWidth:150,height:40,backgroundColor:'#1976d2',color:'#fff','&:hover':{backgroundColor:'#1565c0'},'&:disabled':{backgroundColor:'#bdbdbd',color:'#fff'}},cancelBtn:{minWidth:120,height:40,marginRight:10}};};var DeviceTopup=function(_Component){_inherits(DeviceTopup,_Component);function DeviceTopup(props){_classCallCheck(this,DeviceTopup);var _this=_possibleConstructorReturn(this,(DeviceTopup.__proto__||Object.getPrototypeOf(DeviceTopup)).call(this,props));_this.isDeviceReplacementRequired=function(existingSolutions,newSolutionCodes){if(!existingSolutions||!newSolutionCodes||newSolutionCodes.length===0)return false;var hasObd=function hasObd(arr){return arr.includes('obd_solution')||arr.includes('obd_fuel+fuel_solution');};var existingHasObd=hasObd(existingSolutions);var newHasObd=hasObd(newSolutionCodes);var newHasFuelOnly=newSolutionCodes.includes('fuel_solution')&&!newHasObd;return newHasObd||newHasFuelOnly&&!existingHasObd;};_this.handleCustomerChange=function(selectedCustomer){_this.setState({selectedCustomer:selectedCustomer,selectedVehicle:null,selectedSolutionTypes:[],selectedNewDevice:null,selectedNewSimId:null,existingSubscriptions:[]});};_this.handleVehicleChange=function(selectedVehicle){_this.setState({selectedVehicle:selectedVehicle,selectedSolutionTypes:[],selectedNewDevice:null,selectedNewSimId:null,existingSubscriptions:[]});};_this.handleSolutionTypeChange=function(selectedSolutionTypes){console.log('Solution type change triggered:',selectedSolutionTypes);var selectedCodes=selectedSolutionTypes?selectedSolutionTypes.map(function(option){return option.code;}):[];console.log('Extracted codes:',selectedCodes);_this.setState({selectedSolutionTypes:selectedCodes,selectedNewDevice:null,selectedNewSimId:null});};_this.handlePlanChange=function(selectedPlan){_this.setState({selectedPlan:selectedPlan});};_this.handleNewDeviceChange=function(selectedOption){_this.setState({selectedNewDevice:selectedOption});};_this.handleNewSimChange=function(selectedOption){_this.setState({selectedNewSimId:selectedOption?selectedOption.value:null});};_this.handleSubmit=function(addDeviceTop){var _this$state=_this.state,selectedCustomer=_this$state.selectedCustomer,selectedVehicle=_this$state.selectedVehicle,selectedSolutionTypes=_this$state.selectedSolutionTypes,selectedPlan=_this$state.selectedPlan,selectedVTM=_this$state.selectedVTM,selectedVtid=_this$state.selectedVtid,videoTelematicsId=_this$state.videoTelematicsId,topupMode=_this$state.topupMode,selectedNewDevice=_this$state.selectedNewDevice,selectedNewSimId=_this$state.selectedNewSimId;// Validation
if(!selectedCustomer||!selectedVehicle||!selectedSolutionTypes||selectedSolutionTypes.length===0||!selectedPlan){_this.setState({alertDialogOpen:true,alertDialogTitle:'Validation Error',alertDialogMessage:'Please fill all required fields'});return;}// Existing solution type
var existingSolutionType=Array.isArray(selectedVehicle.solution_type)?selectedVehicle.solution_type.join(','):selectedVehicle.solution_type||'';// Convert UI solution codes → DB format
var newSolutionType=selectedSolutionTypes.join("+");if(newSolutionType==="obd_fuel+fuel_solution"){newSolutionType="obd_solution+fuel_solution";}// Determine if device replacement is needed (only for non-VT topup)
var needsReplacement=false;if(topupMode!=='vt'){var existingSolutions=Array.isArray(selectedVehicle.solution_type)?selectedVehicle.solution_type:selectedVehicle.solution_type?[selectedVehicle.solution_type]:[];needsReplacement=_this.isDeviceReplacementRequired(existingSolutions,selectedSolutionTypes);}// For VT topup, uniqueDeviceId will be set to VT ID
// For normal topup, if replacement needed and new device selected, use that; else use existing device ID
var uniqueDeviceId='';if(topupMode==='vt'){if(selectedVTM&&selectedVTM.value==='mettax'&&selectedVtid){uniqueDeviceId=selectedVtid.value;}else if(selectedVTM&&selectedVTM.value==='loconav'&&videoTelematicsId){uniqueDeviceId=videoTelematicsId;}else{_this.setState({alertDialogOpen:true,alertDialogTitle:'Validation Error',alertDialogMessage:'Please select VT device details'});return;}}else{// Normal topup (single/combo)
if(needsReplacement){if(!selectedNewDevice||!selectedNewSimId){_this.setState({alertDialogOpen:true,alertDialogTitle:'Validation Error',alertDialogMessage:'Please select a replacement device and SIM for the solution upgrade'});return;}uniqueDeviceId=selectedNewDevice.value;}else{// Use existing device ID from vehicle
uniqueDeviceId=selectedVehicle.deviceDetail&&selectedVehicle.deviceDetail.uniqueDeviceId?selectedVehicle.deviceDetail.uniqueDeviceId:'';}}var planDuration=selectedPlan.durationLabel||'';var vtCreatedBy=null;if(topupMode==='vt'){vtCreatedBy=localStorage.getItem('username')||'';}// Mutation call
addDeviceTop({variables:{clientLoginId:selectedCustomer.value,uniqueDeviceId:uniqueDeviceId,existingSolutionType:existingSolutionType,newSolutionType:newSolutionType,planDuration:planDuration,vehicledeviceid:parseInt(selectedVehicle.entityId,10),vt_created_by:vtCreatedBy,created_by:localStorage.getItem('username'),updated_by:localStorage.getItem('username'),newSimId:needsReplacement?selectedNewSimId:null,loginType:localStorage.getItem('Account_type')||'PA'}}).then(function(result){var _result$data$addDevic=result.data.addDeviceTop,success=_result$data$addDevic.success,message=_result$data$addDevic.message;if(success){_this.setState({alertDialogOpen:true,alertDialogTitle:'Success',alertDialogMessage:'Topup submitted successfully!',topupMode:'single',selectedCustomer:null,selectedVehicle:null,selectedSolutionTypes:[],selectedPlan:{durationLabel:'1 Year'},existingSubscriptions:[],selectedVTM:null,videoTelematicsId:'',selectedVtid:null,selectedSimId:'',selectedMemoryCardId:'',selectedNewDevice:null,selectedNewSimId:null});}else{_this.setState({alertDialogOpen:true,alertDialogTitle:'Error',alertDialogMessage:message||'Failed to submit topup'});}}).catch(function(error){console.error('Topup Error:',error);var errorMessage=error.graphQLErrors&&error.graphQLErrors.length>0?error.graphQLErrors[0].message:error.message||'Failed to submit topup';_this.setState({alertDialogOpen:true,alertDialogTitle:'Error',alertDialogMessage:errorMessage});});};_this.handleCancel=function(){_this.setState({topupMode:'single',selectedCustomer:null,selectedVehicle:null,selectedSolutionTypes:[],selectedPlan:{durationLabel:'1 Year'},existingSubscriptions:[],selectedVTM:null,videoTelematicsId:'',selectedVtid:null,selectedSimId:'',selectedMemoryCardId:'',selectedNewDevice:null,selectedNewSimId:null});};_this.handleTopupModeChange=function(event,topupMode){if(!topupMode)return;_this.setState({topupMode:topupMode,selectedSolutionTypes:topupMode==='vt'?['vt']:[],selectedVTM:null,videoTelematicsId:'',selectedVtid:null,selectedSimId:'',selectedMemoryCardId:'',selectedCustomer:null,selectedVehicle:null,selectedPlan:{durationLabel:'1 Year'},existingSubscriptions:[],selectedNewDevice:null,selectedNewSimId:null});};_this.handleVideoTelematicsMenuChange=function(selectedOption){_this.setState({selectedVTM:selectedOption,selectedVtid:null,selectedSimId:'',selectedMemoryCardId:'',videoTelematicsId:'',selectedSolutionTypes:['video_telematics']// IMPORTANT for VT topup
});};_this.handleVideoTelematicsIdChange=function(event){_this.setState({videoTelematicsId:event.target.value});};_this.handleVtidChange=function(selectedOption){if(!selectedOption){_this.setState({selectedVtid:null,selectedSimId:'',selectedMemoryCardId:''});return;}_this.setState({selectedVtid:selectedOption,selectedSimId:selectedOption.simid||'',selectedMemoryCardId:selectedOption.memorycardid||''});};_this.closeAlertDialog=function(){_this.setState({alertDialogOpen:false});};_this.state={topupMode:'single',videoTelematicsType:[{label:'LocoNav',value:'loconav'},{label:'MettaX',value:'mettax'}],selectedVTM:null,videoTelematicsId:'',selectedVtid:null,selectedSimId:'',selectedMemoryCardId:'',selectedCustomer:null,selectedVehicle:null,selectedSolutionTypes:[],selectedPlan:{durationLabel:'1 Year'},selectedNewDevice:null,selectedNewSimId:null,existingSubscriptions:[],loading:false,alertDialogOpen:false,alertDialogMessage:'',alertDialogTitle:''};return _this;}// Helper: check if the new solution types require device replacement
// according to backend rules:
// 1) new solution includes "obd_solution" or "obd_fuel+fuel_solution" -> replace
// 2) new solution is "fuel_solution" alone AND existing has no OBD -> replace
_createClass(DeviceTopup,[{key:'render',value:function render(){var _this2=this;var classes=this.props.classes;var _state=this.state,topupMode=_state.topupMode,videoTelematicsType=_state.videoTelematicsType,selectedVTM=_state.selectedVTM,videoTelematicsId=_state.videoTelematicsId,selectedVtid=_state.selectedVtid,selectedSimId=_state.selectedSimId,selectedMemoryCardId=_state.selectedMemoryCardId,selectedCustomer=_state.selectedCustomer,selectedVehicle=_state.selectedVehicle,selectedSolutionTypes=_state.selectedSolutionTypes,selectedPlan=_state.selectedPlan,selectedNewDevice=_state.selectedNewDevice,selectedNewSimId=_state.selectedNewSimId,existingSubscriptions=_state.existingSubscriptions,alertDialogOpen=_state.alertDialogOpen,alertDialogMessage=_state.alertDialogMessage,alertDialogTitle=_state.alertDialogTitle;var partnerLoginId=Object(__WEBPACK_IMPORTED_MODULE_18__utils_getLoginId__["a" /* default */])();// Compute whether device replacement is needed for the current selection
var needsReplacement=false;var existingSolutions=[];if(selectedVehicle&&topupMode!=='vt'&&selectedSolutionTypes.length>0){existingSolutions=Array.isArray(selectedVehicle.solution_type)?selectedVehicle.solution_type:selectedVehicle.solution_type?[selectedVehicle.solution_type]:[];needsReplacement=this.isDeviceReplacementRequired(existingSolutions,selectedSolutionTypes);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'h4',component:'h1',gutterBottom:true,style:{fontWeight:700,marginBottom:20}},'Solution Topup'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Paper___default.a,{className:classes.paper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Tabs___default.a,{value:topupMode,onChange:this.handleTopupModeChange,indicatorColor:'primary',textColor:'primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Tab___default.a,{value:'single',label:'Single Topup'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Tab___default.a,{value:'combo',label:'Combo Topup'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Tab___default.a,{value:'vt',label:'VT Topup'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Paper___default.a,{className:classes.paper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,spacing:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default.a,{className:classes.formControl,fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormGroup___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'subtitle1',gutterBottom:true},'Select Customer *'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_apollo__["Query"],{query:GET_CLIENTS,variables:{partnerLoginId:partnerLoginId}},function(_ref){var loading=_ref.loading,error=_ref.error,data=_ref.data;if(loading)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["CircularProgress"],{size:24});if(error)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Error loading customers');var customerOptions=data.clients.map(function(client){return Object.assign({value:client.loginId,label:client.clientName},client);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */],{value:selectedCustomer,onChange:_this2.handleCustomerChange,options:customerOptions,placeholder:'Select a customer',className:classes.selectBox});})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default.a,{className:classes.formControl,fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormGroup___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'subtitle1',gutterBottom:true},'Select Vehicle *'),selectedCustomer?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_apollo__["Query"],{query:GET_VEHICLES,variables:{clientLoginId:selectedCustomer.value}},function(_ref2){var loading=_ref2.loading,error=_ref2.error,data=_ref2.data;if(loading)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["CircularProgress"],{size:24});if(error)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Error loading vehicles');var vehicleOptions=data.getAllVehicleDetails.map(function(vehicle){return Object.assign({value:vehicle.entityId,label:vehicle.vehicleNumber},vehicle);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */],{value:selectedVehicle,onChange:_this2.handleVehicleChange,options:vehicleOptions,placeholder:'Select a vehicle',className:classes.selectBox});}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{color:'#666',padding:'8px'}},'Please select a customer first')))))),selectedVehicle&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Paper___default.a,{className:classes.paper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'h6',className:classes.sectionTitle},'Vehicle Details'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_apollo__["Query"],{query:GET_VEHICLES,variables:{clientLoginId:selectedCustomer.value}},function(_ref3){var loading=_ref3.loading,error=_ref3.error,data=_ref3.data;if(loading)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["CircularProgress"],{size:24});if(error)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Error loading vehicle details');var selectedVehicleData=data.getAllVehicleDetails.find(function(vehicle){return vehicle.entityId===selectedVehicle.value;});if(!selectedVehicleData){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'No vehicle data found');}var deviceId=selectedVehicleData.deviceDetail&&selectedVehicleData.deviceDetail.uniqueDeviceId?selectedVehicleData.deviceDetail.uniqueDeviceId:'Not Installed';var solutionTypes=Array.isArray(selectedVehicleData.solution_type)?selectedVehicleData.solution_type:[];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.vehicleCard},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.infoRow},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classes.infoLabel},'Vehicle Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classes.infoValue},selectedVehicleData.vehicleNumber)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.infoRow},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classes.infoLabel},'Device Unique ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classes.infoValue,style:{fontFamily:'monospace',fontSize:12}},deviceId)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.infoRow},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classes.infoLabel},'Existing Solutions'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classes.infoValue},solutionTypes.length>0?solutionTypes.map(function(sol,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:i,className:classes.solutionChip},sol);}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#999',fontSize:12}},'No solutions assigned'))));})),selectedVehicle&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Paper___default.a,{className:classes.paper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'h6',gutterBottom:true},'Add New Solution Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,spacing:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default.a,{className:classes.formControl,fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormGroup___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'subtitle1',gutterBottom:true},'Solution Type *'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_apollo__["Query"],{query:GET_VEHICLES,variables:{clientLoginId:selectedCustomer.value}},function(_ref4){var vehicleLoading=_ref4.loading,vehicleError=_ref4.error,vehicleData=_ref4.data;if(vehicleLoading)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["CircularProgress"],{size:24});if(vehicleError)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Error loading vehicle data');// Get existing solution types for the selected vehicle
var selectedVehicleData=vehicleData.getAllVehicleDetails.find(function(vehicle){return vehicle.entityId===selectedVehicle.value;});var existingSolutionTypes=selectedVehicleData&&Array.isArray(selectedVehicleData.solution_type)?selectedVehicleData.solution_type:[];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_apollo__["Query"],{query:GET_SOLUTION_TYPES},function(_ref5){var loading=_ref5.loading,error=_ref5.error,data=_ref5.data;if(loading)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["CircularProgress"],{size:24});if(error)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Error loading solution types');var solutionTypeMultiOptions=data.getAllMasterSolutionType.map(function(type){var code=type.id;return{value:code,// Use the code as value for consistency
label:type.solutionTypeName,code:code,id:type.id};});var modeFilteredOptions=solutionTypeMultiOptions.filter(function(option){var isCombo=typeof option.id==='string'&&option.id.includes('+');var isVt=option.id==='video_telematics'||option.code==='vt';if(topupMode==='single')return!isCombo&&!isVt;if(topupMode==='combo')return isCombo;if(topupMode==='vt')return isVt;return true;});// Filter out already existing solution types
var availableOptions=modeFilteredOptions.filter(function(option){return!existingSolutionTypes.includes(option.code);});var selectedMultiValue=availableOptions.filter(function(option){return selectedSolutionTypes&&selectedSolutionTypes.some(function(selectedVal){return option.code===selectedVal||option.code&&option.code.split(',').includes(selectedVal);});});console.log('Selected solution types from state:',selectedSolutionTypes);console.log('Selected multi value:',selectedMultiValue);if(availableOptions.length===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{color:'#666',padding:'16px'}},'All solution types are already assigned to this vehicle');}return topupMode==='vt'?selectedVehicleData&&selectedVehicleData.videoTelematicsType&&selectedVehicleData.videoTelematicsId?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:'16px',background:'#e8f5e9',border:'1px solid #c8e6c9',borderRadius:'4px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'subtitle1',style:{color:'#2e7d32',fontWeight:600}},'Video Telematics Already Exists'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'body2',style:{color:'#1b5e20',marginTop:'8px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Type:'),' ',selectedVehicleData.videoTelematicsType,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'ID:'),' ',selectedVehicleData.videoTelematicsId)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginRight:'10px',minWidth:'130px'}},'Video Telematics'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{flex:1}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */],{options:videoTelematicsType,value:selectedVTM,onChange:_this2.handleVideoTelematicsMenuChange,placeholder:'Select Video Telematics'}))),selectedVTM&&selectedVTM.value&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginTop:'10px'}},selectedVTM.value==='mettax'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_apollo__["Query"],{query:GET_DASHCAM_REGISTRATIONS,fetchPolicy:'network-only'},function(_ref6){var dashcamLoading=_ref6.loading,dashcamError=_ref6.error,dashcamData=_ref6.data;if(dashcamLoading)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["CircularProgress"],{size:30});if(dashcamError)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Error loading MettaX VT IDs');var rows=dashcamData&&dashcamData.getDashcamRegistrations&&dashcamData.getDashcamRegistrations.success&&Array.isArray(dashcamData.getDashcamRegistrations.data)?dashcamData.getDashcamRegistrations.data:[];var available=rows.filter(function(r){return r.status==='available';});var vtidOptions=available.filter(function(r){return r&&r.vtid;}).map(function(r){return{label:r.vtid,value:r.vtid,simid:r.simid,memorycardid:r.memorycardid};});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginRight:'10px',minWidth:'130px'}},'Mettax VT ID *'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{flex:1}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */],{options:vtidOptions,value:selectedVtid,onChange:_this2.handleVtidChange,placeholder:'Select ID'}))),selectedVtid&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,spacing:2,style:{marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_TextField___default.a,{label:'SIM ID',disabled:true,value:selectedSimId,fullWidth:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_TextField___default.a,{label:'Memory Card',disabled:true,value:selectedMemoryCardId,fullWidth:true}))));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_TextField___default.a,{label:'Video Telematics Id'+(selectedVTM?'*':''),value:videoTelematicsId,onChange:_this2.handleVideoTelematicsIdChange,fullWidth:true}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */],{id:'solution_type',name:'solution_type',options:availableOptions,value:selectedMultiValue,multi:true,optionComponent:SolutionTypeOption,closeOnSelect:false,removeSelected:false,onChange:_this2.handleSolutionTypeChange,placeholder:'Select additional solution types',className:classes.selectBox});});})))),selectedSolutionTypes&&selectedSolutionTypes.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default.a,{className:classes.formControl,fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormGroup___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'subtitle1',gutterBottom:true},'Plan Duration'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.planCard},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core_Icon___default.a,{style:{color:'#558b2f',fontSize:20}},'event_available'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'body1',style:{fontWeight:700,color:'#33691e'}},'1 Year'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'caption',style:{color:'#558b2f'}},'Standard subscription duration'))))))),needsReplacement&&topupMode!=='vt'&&selectedCustomer&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,spacing:3,style:{marginTop:16}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default.a,{className:classes.formControl,fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormGroup___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'subtitle1',gutterBottom:true},'Select New Device ID *'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_apollo__["Query"],{query:GET_AVAILABLE_DEVICES,variables:{clientId:selectedCustomer.value},fetchPolicy:'network-only'},function(_ref7){var devicesLoading=_ref7.loading,devicesError=_ref7.error,devicesData=_ref7.data;if(devicesLoading)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["CircularProgress"],{size:24});if(devicesError)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Error loading available devices');var devices=devicesData&&devicesData.device?devicesData.device:[];var deviceOptions=devices.map(function(device){return{value:device.uniqueDeviceId,label:device.uniqueDeviceId,model:device.deviceModel?device.deviceModel.model_name:null};});// Optionally exclude the current device ID from the list
var currentDeviceId=selectedVehicle&&selectedVehicle.deviceDetail&&selectedVehicle.deviceDetail.uniqueDeviceId;var filteredOptions=currentDeviceId?deviceOptions.filter(function(opt){return opt.value!==currentDeviceId;}):deviceOptions;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */],{value:selectedNewDevice,onChange:_this2.handleNewDeviceChange,options:filteredOptions,placeholder:'Choose a new device ID',className:classes.selectBox,isClearable:true});})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default.a,{className:classes.formControl,fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormGroup___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'subtitle1',gutterBottom:true},'Select New Phone Number *'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_apollo__["Query"],{query:GET_AVAILABLE_SIMS,variables:{clientId:selectedCustomer.value},fetchPolicy:'network-only'},function(_ref8){var simsLoading=_ref8.loading,simsError=_ref8.error,simsData=_ref8.data;if(simsLoading)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["CircularProgress"],{size:24});if(simsError)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Error loading available SIMs');var sims=simsData&&simsData.simDetails?simsData.simDetails:[];var simOptions=sims.filter(function(sim){return sim.sim;}).map(function(sim){return{value:sim.simId,label:sim.sim.phoneNumber};});var selectedSimOption=selectedNewSimId?simOptions.find(function(opt){return opt.value===selectedNewSimId;}):null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */],{value:selectedSimOption,onChange:_this2.handleNewSimChange,options:simOptions,placeholder:'Choose a phone number',className:classes.selectBox,isClearable:true});})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'caption',style:{color:'#f57c00'}},'Note: Selected solution type requires replacing the Existing device Id. Replacing the device also requires replacing the SIM.')))),selectedVehicle&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Paper___default.a,{className:classes.paper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,justify:'flex-end',alignItems:'center',spacing:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button___default.a,{variant:'outlined',onClick:this.handleCancel,className:classes.cancelBtn},'Cancel')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_apollo__["Mutation"],{mutation:ADD_DEVICE_TOP},function(addDeviceTop,_ref9){var loading=_ref9.loading;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button___default.a,{variant:'contained',className:classes.submitBtn,onClick:function onClick(){return _this2.handleSubmit(addDeviceTop);},disabled:loading||!selectedCustomer||!selectedVehicle||!selectedSolutionTypes||selectedSolutionTypes.length===0||!selectedPlan||needsReplacement&&(!selectedNewDevice||!selectedNewSimId)},loading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core__["CircularProgress"],{size:20,style:{color:'#fff'}}):'Submit Topup');})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__common_ConfirmationDialog__["a" /* default */],{isDialogOpen:alertDialogOpen,dialogTitle:alertDialogTitle,dialogMessage:alertDialogMessage,positiveResponseButtonText:'OK',negativeResponseButtonText:'',positiveResponseHandler:this.closeAlertDialog,negativeResponseHandler:this.closeAlertDialog,dialogCloseHandler:this.closeAlertDialog}));}}]);return DeviceTopup;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles__["withStyles"])(styles)(DeviceTopup));

/***/ }),
/* 2452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export solutionToDB */
/* unused harmony export solutionFromDB */
/* unused harmony export convertUIToDBSolutions */
/* unused harmony export convertDBToUISolutions */
// solutionTypeMapping.js
// UI → DB mapping
var solutionToDB={vt:"video_telematics",obd:"obd_solution",fuel:"fuel_solution",fuelsensor:"fuel_sensor",obdfuelsensor:"obd_fuel_sensor",portedfuelsolution:"ported_fuel_solution",portedobdsolution:"ported_obd_solution",ais140:"ais_140",ais140obd:"ais_140_obd_solution",basictracking:"basic_tracking",controltower:"control_tower",dummyvehicle:"dummy_vehicle",testingvehicle:"testing_vehicle",testsolution:"testSolutionId",// FIXED
"obd,fuel":"obd_solution+fuel_solution"// DB → UI mapping
};var solutionFromDB={video_telematics:"vt",obd_solution:"obd",fuel_solution:"fuel",fuel_sensor:"fuelsensor",obd_fuel_sensor:"obdfuelsensor",ported_fuel_solution:"portedfuelsolution",ported_obd_solution:"portedobdsolution",ais_140:"ais140",ais_140_obd_solution:"ais140obd",basic_tracking:"basictracking",control_tower:"controltower",dummy_vehicle:"dummyvehicle",testing_vehicle:"testingvehicle",testSolutionId:"testsolution",// keep this if DB sends this format
"obd_solution+fuel_solution":"obd,fuel"// Convert UI → DB
};var convertUIToDBSolutions=function convertUIToDBSolutions(){var solutions=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];if(!Array.isArray(solutions))return"";return solutions.map(function(sol){return solutionToDB[sol]||sol;}).join("+");};// Convert DB → UI
var convertDBToUISolutions=function convertDBToUISolutions(){var solutions=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];if(!Array.isArray(solutions))return[];return solutions.map(function(sol){return solutionFromDB[sol]||sol;});};

/***/ }),
/* 2453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Paper__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Paper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormGroup__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Tabs__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Tab__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Modules_VehicleRegistartion_DecoupleDeviceSimDialog__ = __webpack_require__(2454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_ConfirmationDialog__ = __webpack_require__(65);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query allClientDetails($partnerLoginId: Int) {\n    clients: allClientDetails(partnerLoginId: $partnerLoginId) {\n      id\n      clientName\n      loginId\n    }\n  }\n'],['\n  query allClientDetails($partnerLoginId: Int) {\n    clients: allClientDetails(partnerLoginId: $partnerLoginId) {\n      id\n      clientName\n      loginId\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query getAllVehicleDetails($clientLoginId: Int) {\n    vehicles: getAllVehicleDetails(clientLoginId: $clientLoginId) {\n      entityId\n      vehicleNumber\n      videoTelematicsType\n      videoTelematicsId\n      deviceDetail {\n        serial_num\n        uniqueDeviceId\n        deviceModelId {\n          model_name\n          devicetype\n          __typename\n        }\n        __typename\n      }\n      simDetail {\n      id\n        phoneNumber\n        __typename\n      }\n      solution_type\n      __typename\n    }\n  }\n'],['\n  query getAllVehicleDetails($clientLoginId: Int) {\n    vehicles: getAllVehicleDetails(clientLoginId: $clientLoginId) {\n      entityId\n      vehicleNumber\n      videoTelematicsType\n      videoTelematicsId\n      deviceDetail {\n        serial_num\n        uniqueDeviceId\n        deviceModelId {\n          model_name\n          devicetype\n          __typename\n        }\n        __typename\n      }\n      simDetail {\n      id\n        phoneNumber\n        __typename\n      }\n      solution_type\n      __typename\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query getAllVehicleDetails($clientLoginId: Int) {\n    getAllVehicleDetails(clientLoginId: $clientLoginId) {\n      id\n      vehicleNumber\n      solution_type\n      deviceDetail {\n        uniqueDeviceId\n        imeiNumber\n        simNumber\n        simProvider\n        simStatus\n      }\n    }\n  }\n'],['\n  query getAllVehicleDetails($clientLoginId: Int) {\n    getAllVehicleDetails(clientLoginId: $clientLoginId) {\n      id\n      vehicleNumber\n      solution_type\n      deviceDetail {\n        uniqueDeviceId\n        imeiNumber\n        simNumber\n        simProvider\n        simStatus\n      }\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query GetDashcamRegistrations {\n    getDashcamRegistrations {\n      success\n      message\n      data {\n        uuid\n        simid\n        memorycardid\n        uniqueid\n        vtid\n        status\n      }\n    }\n  }\n'],['\n  query GetDashcamRegistrations {\n    getDashcamRegistrations {\n      success\n      message\n      data {\n        uuid\n        simid\n        memorycardid\n        uniqueid\n        vtid\n        status\n      }\n    }\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  mutation vtreplacementonboarding( $existingvtid: String, $newvtid: String, $solution_type: String, $existinguniqueid: String, $created_by: String, $updated_by: String) {\n    vtreplacementonboarding( existingvtid: $existingvtid, newvtid: $newvtid, solution_type: $solution_type, existinguniqueid: $existinguniqueid, created_by: $created_by, updated_by: $updated_by) {\n      success\n      message\n    }\n  }\n'],['\n  mutation vtreplacementonboarding( $existingvtid: String, $newvtid: String, $solution_type: String, $existinguniqueid: String, $created_by: String, $updated_by: String) {\n    vtreplacementonboarding( existingvtid: $existingvtid, newvtid: $newvtid, solution_type: $solution_type, existinguniqueid: $existinguniqueid, created_by: $created_by, updated_by: $updated_by) {\n      success\n      message\n    }\n  }\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_CLIENTS=Object(__WEBPACK_IMPORTED_MODULE_12_graphql_tag__["a" /* default */])(_templateObject);var GET_VEHICLES=Object(__WEBPACK_IMPORTED_MODULE_12_graphql_tag__["a" /* default */])(_templateObject2);// Fallback query with potentially different field names
var GET_VEHICLES_FALLBACK=Object(__WEBPACK_IMPORTED_MODULE_12_graphql_tag__["a" /* default */])(_templateObject3);var GET_DASHCAM_REGISTRATIONS=Object(__WEBPACK_IMPORTED_MODULE_12_graphql_tag__["a" /* default */])(_templateObject4);var VT_REPLACEMENT_ONBOARDING=Object(__WEBPACK_IMPORTED_MODULE_12_graphql_tag__["a" /* default */])(_templateObject5);var styles=function styles(theme){return{root:{padding:24,marginTop:24},paper:{padding:24,marginBottom:16},formControl:{margin:theme.spacing.unit,minWidth:200},selectBox:{width:'100%'},button:{margin:theme.spacing.unit},vehicleInfoCard:{padding:16,marginBottom:16,border:'1px solid #e0e0e0',borderRadius:4,backgroundColor:'#f5f5f5'},vehicleInfoHeader:{fontWeight:'bold',marginBottom:12,fontSize:'1.1rem',color:'#333'},vehicleInfoDetails:{fontSize:'0.9rem',color:'#666'},infoRow:{marginBottom:8,display:'flex',justifyContent:'space-between'},infoLabel:{fontWeight:'600',color:'#555'},infoValue:{color:'#333'},replacementSection:{marginTop:16}};};var DeviceReplacement=function(_Component){_inherits(DeviceReplacement,_Component);function DeviceReplacement(props){_classCallCheck(this,DeviceReplacement);var _this=_possibleConstructorReturn(this,(DeviceReplacement.__proto__||Object.getPrototypeOf(DeviceReplacement)).call(this,props));_this.handleCustomerChange=function(selectedCustomer){_this.setState({selectedCustomer:selectedCustomer,selectedVehicle:null,selectedDevice:null,selectedSim:null,selectedFromDevice:null,selectedToDevice:null,selectedVTVehicle:null});};_this.handleVehicleChange=function(selectedVehicle){_this.setState({selectedVehicle:selectedVehicle,selectedDevice:null,selectedSim:null});};_this.handleReplacementModeChange=function(event,replacementMode){if(!replacementMode)return;_this.setState({replacementMode:replacementMode,selectedVehicle:null,selectedDevice:null,selectedSim:null,selectedFromDevice:null,selectedToDevice:null,selectedVTVehicle:null});};_this.handleFromDeviceChange=function(selectedFromDevice){_this.setState({selectedFromDevice:selectedFromDevice,selectedToDevice:null});};_this.handleToDeviceChange=function(selectedToDevice){_this.setState({selectedToDevice:selectedToDevice});};_this.handleVTVehicleChange=function(selectedVTVehicle,dashcamRegistrations){var vehicle=selectedVTVehicle&&selectedVTVehicle.vehicle;var vtId=vehicle&&vehicle.videoTelematicsId;var rows=dashcamRegistrations&&dashcamRegistrations.getDashcamRegistrations&&dashcamRegistrations.getDashcamRegistrations.success&&Array.isArray(dashcamRegistrations.getDashcamRegistrations.data)?dashcamRegistrations.getDashcamRegistrations.data:[];var registration=rows.find(function(r){return r.vtid===vtId;});_this.setState({selectedVTVehicle:selectedVTVehicle,selectedToDevice:null,selectedFromDevice:vtId?{value:vtId,label:vtId,uniqueid:registration?registration.uniqueid:null,vehicleNumber:vehicle.vehicleNumber}:null});};_this.handleDeviceChange=function(selectedDevice){_this.setState({selectedDevice:selectedDevice});};_this.handleSimChange=function(selectedSim){_this.setState({selectedSim:selectedSim});};_this.handleDecoupleDialogOpen=function(){_this.setState({decoupleDialogOpen:true});};_this.handleDecoupleDialogClose=function(){_this.setState({decoupleDialogOpen:false});};_this.handleSubmit=function(){var _this$state=_this.state,replacementMode=_this$state.replacementMode,selectedCustomer=_this$state.selectedCustomer,selectedVehicle=_this$state.selectedVehicle,selectedDevice=_this$state.selectedDevice,selectedSim=_this$state.selectedSim,selectedFromDevice=_this$state.selectedFromDevice,selectedToDevice=_this$state.selectedToDevice;if(!selectedCustomer){_this.setState({alertDialogOpen:true,alertDialogTitle:'Validation Error',alertDialogMessage:'Please select customer'});return;}if(replacementMode==='vt'){if(!selectedFromDevice||!selectedToDevice){_this.setState({alertDialogOpen:true,alertDialogTitle:'Validation Error',alertDialogMessage:'Please select current and target device'});return;}_this.setState({confirmDialogOpen:true,confirmDialogTitle:'Confirm VT ID Replacement',confirmDialogMessage:'Are you sure you want to move the Video Telematics ID from '+selectedFromDevice.label+' to '+selectedToDevice.label+'? This only changes the VT ID - the vehicle\'s GPS device is not affected.',pendingAction:'vt'});return;}if(!selectedVehicle){_this.setState({alertDialogOpen:true,alertDialogTitle:'Validation Error',alertDialogMessage:'Please select vehicle'});return;}console.log('Submitting device replacement:',{customer:selectedCustomer,vehicle:selectedVehicle,device:selectedDevice,sim:selectedSim});// TODO: Implement actual submission logic
_this.setState({alertDialogOpen:true,alertDialogTitle:'Success',alertDialogMessage:'Device replacement submitted successfully!'});};_this.handleCancel=function(){_this.setState({replacementMode:'device',selectedCustomer:null,selectedVehicle:null,selectedDevice:null,selectedSim:null,selectedFromDevice:null,selectedToDevice:null});};_this.executeVTReplacement=function(){var _this$state2=_this.state,selectedFromDevice=_this$state2.selectedFromDevice,selectedToDevice=_this$state2.selectedToDevice,selectedVTVehicle=_this$state2.selectedVTVehicle;var client=_this.props.client;if(!selectedFromDevice||!selectedToDevice||!selectedVTVehicle)return;_this.setState({loading:true,confirmDialogOpen:false});client.mutate({mutation:VT_REPLACEMENT_ONBOARDING,variables:{existingvtid:selectedFromDevice.value,existinguniqueid:selectedFromDevice.uniqueid,newvtid:selectedToDevice.value,solution_type:selectedVTVehicle.vehicle&&selectedVTVehicle.vehicle.solution_type?Array.isArray(selectedVTVehicle.vehicle.solution_type)?selectedVTVehicle.vehicle.solution_type.join(','):selectedVTVehicle.vehicle.solution_type:null,created_by:localStorage.getItem('username'),updated_by:localStorage.getItem('username')}}).then(function(_ref){var data=_ref.data;_this.setState({loading:false,alertDialogOpen:true,alertDialogTitle:data.vtreplacementonboarding.success?'Success':'Error',alertDialogMessage:data.vtreplacementonboarding.message});}).catch(function(error){_this.setState({loading:false,alertDialogOpen:true,alertDialogTitle:'Error',alertDialogMessage:error.message||'Something went wrong while replacing VT'});});};_this.closeAlertDialog=function(){_this.setState({alertDialogOpen:false});};_this.closeConfirmDialog=function(){_this.setState({confirmDialogOpen:false});};_this.state={replacementMode:'device',selectedCustomer:null,selectedVehicle:null,selectedDevice:null,selectedSim:null,selectedFromDevice:null,selectedToDevice:null,selectedVTVehicle:null,loading:false,decoupleDialogOpen:false,alertDialogOpen:false,alertDialogMessage:'',alertDialogTitle:'',confirmDialogOpen:false,confirmDialogMessage:'',confirmDialogTitle:'',pendingAction:null};return _this;}_createClass(DeviceReplacement,[{key:'render',value:function render(){var _this2=this;var classes=this.props.classes;var _state=this.state,replacementMode=_state.replacementMode,selectedCustomer=_state.selectedCustomer,selectedVehicle=_state.selectedVehicle,selectedDevice=_state.selectedDevice,selectedSim=_state.selectedSim,decoupleDialogOpen=_state.decoupleDialogOpen,selectedFromDevice=_state.selectedFromDevice,selectedToDevice=_state.selectedToDevice,selectedVTVehicle=_state.selectedVTVehicle,loading=_state.loading,alertDialogOpen=_state.alertDialogOpen,alertDialogMessage=_state.alertDialogMessage,alertDialogTitle=_state.alertDialogTitle,confirmDialogOpen=_state.confirmDialogOpen,confirmDialogMessage=_state.confirmDialogMessage,confirmDialogTitle=_state.confirmDialogTitle;var partnerLoginId=Object(__WEBPACK_IMPORTED_MODULE_14__utils_getLoginId__["a" /* default */])();// Get solution type from selected vehicle for the dialog
var getSolutionType=function getSolutionType(){if(!selectedVehicle)return'No Solution Type';// This would come from the vehicle data when selected
return(Array.isArray(selectedVehicle.solution_type)?selectedVehicle.solution_type.join(', '):selectedVehicle.solution_type)||'No Solution Type';};// Get device and SIM details for the dialog
var getUniqueDeviceId=function getUniqueDeviceId(){if(!selectedVehicle)return null;return selectedVehicle.deviceDetail&&selectedVehicle.deviceDetail.uniqueDeviceId||null;};var getSimPhoneNumber=function getSimPhoneNumber(){if(!selectedVehicle)return null;return selectedVehicle.simDetail&&selectedVehicle.simDetail.phoneNumber||null;};var getSimId=function getSimId(){if(!selectedVehicle)return null;return selectedVehicle.simDetail&&selectedVehicle.simDetail.id||null;};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'h4',component:'h1',gutterBottom:true},'Device Replacement'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Paper___default.a,{className:classes.paper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Tabs___default.a,{value:replacementMode,onChange:this.handleReplacementModeChange,indicatorColor:'primary',textColor:'primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Tab___default.a,{value:'device',label:'Device Replacement'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Tab___default.a,{value:'vt',label:'VT ID Replacement'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Paper___default.a,{className:classes.paper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,spacing:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default.a,{className:classes.formControl,fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormGroup___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'subtitle1',gutterBottom:true},'Select Customer *'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_apollo__["Query"],{query:GET_CLIENTS,variables:{partnerLoginId:partnerLoginId}},function(_ref2){var loading=_ref2.loading,error=_ref2.error,data=_ref2.data;if(loading)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["CircularProgress"],{size:24});if(error)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Error loading customers');var customerOptions=data.clients.map(function(client){return Object.assign({value:client.loginId,label:client.clientName},client);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */],{value:selectedCustomer,onChange:_this2.handleCustomerChange,options:customerOptions,placeholder:'Select a customer',className:classes.selectBox});})))),replacementMode==='device'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default.a,{className:classes.formControl,fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormGroup___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'subtitle1',gutterBottom:true},'Select Vehicle *'),selectedCustomer?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_apollo__["Query"],{query:GET_VEHICLES,variables:{clientLoginId:selectedCustomer.value}},function(_ref3){var loading=_ref3.loading,error=_ref3.error,data=_ref3.data;if(loading)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["CircularProgress"],{size:24});if(error)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Error loading vehicles');var vehicleOptions=data.vehicles.map(function(vehicle){return Object.assign({value:vehicle.entityId,label:vehicle.vehicleNumber},vehicle);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */],{value:selectedVehicle,onChange:_this2.handleVehicleChange,options:vehicleOptions,placeholder:'Select a vehicle',className:classes.selectBox});}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{color:'#666',padding:'8px'}},'Please select a customer first')))))),replacementMode==='vt'&&selectedCustomer&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_apollo__["Query"],{query:GET_DASHCAM_REGISTRATIONS,fetchPolicy:'network-only'},function(_ref4){var dashLoading=_ref4.loading,dashError=_ref4.error,dashData=_ref4.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Paper___default.a,{className:classes.paper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'h6',gutterBottom:true},'VT ID Replacement'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'body2',style:{color:'#666',marginBottom:16}},'This replaces only the Video Telematics (VT) ID assigned to the vehicle - the unique ID is not affected. To replace the unique ID itself, use the Device Replacement tab instead.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_apollo__["Query"],{query:GET_VEHICLES,variables:{clientLoginId:selectedCustomer.value}},function(_ref5){var vLoading=_ref5.loading,vError=_ref5.error,vData=_ref5.data;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_apollo__["Query"],{query:GET_VEHICLES,variables:{clientLoginId:selectedCustomer.value}},function(_ref6){var sLoading=_ref6.loading,sError=_ref6.error,sData=_ref6.data;if(vLoading||sLoading)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["CircularProgress"],{size:24});if(vError||sError)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Error loading vehicles');var selectedVTVehicleData=(vData.vehicles||[]).map(function(v){var statusV=(sData.vehicles||[]).find(function(sv){return sv.entityId===v.entityId;})||{};return Object.assign({},v,statusV);}).find(function(v){return selectedVTVehicle&&v.entityId===selectedVTVehicle.value;});var vehicleOptions=(vData.vehicles||[]).map(function(v){var statusV=(sData.vehicles||[]).find(function(sv){return sv.entityId===v.entityId;})||{};return{value:v.entityId,label:v.vehicleNumber,vehicle:Object.assign({},v,statusV)};});var vtVehicles=vehicleOptions.map(function(o){return o.vehicle;}).filter(function(v){return v&&v.videoTelematicsType||v&&v.videoTelematicsId;});var fromOptions=vtVehicles.filter(function(v){return v.deviceDetail&&v.deviceDetail.uniqueDeviceId;}).map(function(v){return{value:v.deviceDetail.uniqueDeviceId,label:v.deviceDetail.uniqueDeviceId+' ('+v.vehicleNumber+')',vehicle:v};});var toOptions=fromOptions.filter(function(o){return!selectedFromDevice||o.value!==selectedFromDevice.value;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,spacing:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default.a,{className:classes.formControl,fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormGroup___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'subtitle1',gutterBottom:true},'Select Vehicle *'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */],{value:selectedVTVehicle,onChange:function onChange(val){return _this2.handleVTVehicleChange(val,dashData);},options:vehicleOptions,placeholder:'Select a vehicle',className:classes.selectBox})))),selectedVTVehicleData&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.vehicleInfoCard,style:{backgroundColor:selectedVTVehicleData.videoTelematicsId?'#e8f5e9':'#ffebee'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'subtitle2',style:{fontWeight:'bold'}},'VT Information for ',selectedVTVehicleData.vehicleNumber,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.infoRow,style:{marginTop:'8px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classes.infoLabel},'Video Telematics Status:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classes.infoValue,style:{color:selectedVTVehicleData.videoTelematicsId?'green':'red',fontWeight:'bold'}},selectedVTVehicleData.videoTelematicsId?'Connected (ID: '+selectedVTVehicleData.videoTelematicsId+')':'Not attached any')),selectedVTVehicleData.videoTelematicsType&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.infoRow},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classes.infoLabel},'Telematics Type:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classes.infoValue},selectedVTVehicleData.videoTelematicsType)),selectedVTVehicleData.videoTelematicsId&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.infoRow},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classes.infoLabel},'Unique ID:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classes.infoValue},function(){var rows=dashData&&dashData.getDashcamRegistrations&&dashData.getDashcamRegistrations.success&&Array.isArray(dashData.getDashcamRegistrations.data)?dashData.getDashcamRegistrations.data:[];var registration=rows.find(function(r){return r.vtid===selectedVTVehicleData.videoTelematicsId;});return registration?registration.uniqueid:'Not Available';}())))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default.a,{className:classes.formControl,fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormGroup___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'subtitle1',gutterBottom:true},'Current VT ID (From) *'),function(){if(dashLoading)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["CircularProgress"],{size:24});if(dashError)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Error loading MettaX VT IDs');var rows=dashData&&dashData.getDashcamRegistrations&&dashData.getDashcamRegistrations.success&&Array.isArray(dashData.getDashcamRegistrations.data)?dashData.getDashcamRegistrations.data:[];var vtidOptions=rows.filter(function(r){return r&&r.vtid;}).map(function(r){return{label:r.vtid,value:r.vtid,simid:r.simid,memorycardid:r.memorycardid,uniqueid:r.uniqueid,status:r.status};});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{pointerEvents:'none',opacity:selectedVTVehicle?0.7:1}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */],{value:selectedFromDevice,onChange:function onChange(){},options:vtidOptions,placeholder:'Current VT ID',className:classes.selectBox,isDisabled:!!selectedVTVehicle}));}()))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default.a,{className:classes.formControl,fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormGroup___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'subtitle1',gutterBottom:true},'Target VT ID (To) *'),function(){if(dashLoading)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["CircularProgress"],{size:24});if(dashError)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Error loading MettaX VT IDs');var rows2=dashData&&dashData.getDashcamRegistrations&&dashData.getDashcamRegistrations.success&&Array.isArray(dashData.getDashcamRegistrations.data)?dashData.getDashcamRegistrations.data:[];var availableOptions=rows2.filter(function(r){return r&&r.vtid&&r.status==='available';}).filter(function(r){return!selectedFromDevice||r.vtid!==selectedFromDevice.value;}).map(function(r){return{label:r.vtid,value:r.vtid,simid:r.simid,memorycardid:r.memorycardid,uniqueid:r.uniqueid,status:r.status};});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */],{value:selectedToDevice,onChange:_this2.handleToDeviceChange,options:availableOptions,placeholder:'Select target VT ID',className:classes.selectBox,isDisabled:!selectedFromDevice});}()))));});}));}),replacementMode==='device'&&selectedVehicle&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Paper___default.a,{className:classes.paper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'h6',gutterBottom:true},'Current Vehicle Information'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_apollo__["Query"],{query:GET_VEHICLES,variables:{clientLoginId:selectedCustomer.value}},function(_ref7){var loading=_ref7.loading,error=_ref7.error,data=_ref7.data;if(loading)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["CircularProgress"],{size:24});if(error)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Error loading vehicle details');var selectedVehicleData=data.vehicles.find(function(vehicle){return vehicle.entityId===selectedVehicle.value;});if(!selectedVehicleData){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{color:'#666',padding:'16px'}},'Vehicle details not found');}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.vehicleInfoCard},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.vehicleInfoHeader},selectedVehicleData.vehicleNumber),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.vehicleInfoDetails},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.infoRow},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classes.infoLabel},'Device Unique ID:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classes.infoValue},selectedVehicleData.deviceDetail&&selectedVehicleData.deviceDetail.uniqueDeviceId?selectedVehicleData.deviceDetail.uniqueDeviceId:'Not Available')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.infoRow},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classes.infoLabel},'Solution Present:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classes.infoValue},selectedVehicleData.solution_type?Array.isArray(selectedVehicleData.solution_type)?selectedVehicleData.solution_type.join(', ').toUpperCase():selectedVehicleData.solution_type.toUpperCase():'No Solution')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.infoRow},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classes.infoLabel},'SIM Number:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classes.infoValue},selectedVehicleData.simDetail&&selectedVehicleData.simDetail.phoneNumber?selectedVehicleData.simDetail.phoneNumber:'Not Available')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.infoRow},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classes.infoLabel},'Device Model:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classes.infoValue},selectedVehicleData.deviceDetail&&selectedVehicleData.deviceDetail.deviceModelId&&selectedVehicleData.deviceDetail.deviceModelId.model_name?selectedVehicleData.deviceDetail.deviceModelId.model_name:'Not Available'))));})),(replacementMode==='device'&&selectedVehicle||replacementMode==='vt'&&selectedCustomer)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Paper___default.a,{className:classes.paper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,justify:'flex-end',spacing:2},replacementMode==='device'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button___default.a,{variant:'contained',color:'secondary',onClick:this.handleDecoupleDialogOpen,className:classes.button},'Decouple Device/Sim')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button___default.a,{variant:'outlined',onClick:this.handleCancel,className:classes.button},'Cancel')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true},replacementMode==='vt'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button___default.a,{variant:'contained',color:'primary',onClick:this.handleSubmit,disabled:!selectedCustomer||!selectedFromDevice||!selectedToDevice||loading,className:classes.button},loading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core__["CircularProgress"],{size:24}):'Submit Replacement')))),replacementMode==='device'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Modules_VehicleRegistartion_DecoupleDeviceSimDialog__["a" /* default */],{open:decoupleDialogOpen,onClose:this.handleDecoupleDialogClose,solutionType:getSolutionType(),clientLoginId:selectedCustomer&&selectedCustomer.value,uniqueDeviceId:getUniqueDeviceId(),simId:getSimId(),simPhoneNumber:getSimPhoneNumber()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__common_ConfirmationDialog__["a" /* default */],{isDialogOpen:alertDialogOpen,dialogTitle:alertDialogTitle,dialogMessage:alertDialogMessage,positiveResponseButtonText:'OK',negativeResponseButtonText:'',positiveResponseHandler:this.closeAlertDialog,negativeResponseHandler:this.closeAlertDialog,dialogCloseHandler:this.closeAlertDialog}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__common_ConfirmationDialog__["a" /* default */],{isDialogOpen:confirmDialogOpen,dialogTitle:confirmDialogTitle,dialogMessage:confirmDialogMessage,positiveResponseButtonText:'Yes',negativeResponseButtonText:'No',positiveResponseHandler:this.executeVTReplacement,negativeResponseHandler:this.closeConfirmDialog,dialogCloseHandler:this.closeConfirmDialog}));}}]);return DeviceReplacement;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_13_react_apollo__["withApollo"])(DeviceReplacement)));

/***/ }),
/* 2454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_apollo__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getAllAssignedDevicesToClient($clientId: Int!) {\n    device: getAllAssignedDevicesToClient(clientLoginId: $clientId) {\n      uniqueDeviceId\n      deviceModel {\n        model_name\n      }\n    }\n  }\n'],['\n  query getAllAssignedDevicesToClient($clientId: Int!) {\n    device: getAllAssignedDevicesToClient(clientLoginId: $clientId) {\n      uniqueDeviceId\n      deviceModel {\n        model_name\n      }\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query getAllAssignedSimToClient($clientId: Int!) {\n    simDetails: getAllAssignedSimToClient(clientLoginId: $clientId) {\n      id\n      simId\n      sim {\n        phoneNumber\n      }\n    }\n  }\n'],['\n  query getAllAssignedSimToClient($clientId: Int!) {\n    simDetails: getAllAssignedSimToClient(clientLoginId: $clientId) {\n      id\n      simId\n      sim {\n        phoneNumber\n      }\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation decoupleDeviceSim(\n    $newDeviceUniqueId: String\n    $existingDeviceUniqueId: String\n    $newSimId: Int\n    $existingSimId: Int\n    $decoupleType: String!\n    $loginType: String!\n  ) {\n    decoupleDeviceSim(\n      newDeviceUniqueId: $newDeviceUniqueId\n      existingDeviceUniqueId: $existingDeviceUniqueId\n      newSimId: $newSimId\n      existingSimId: $existingSimId\n      decoupleType: $decoupleType\n      loginType: $loginType\n    )\n  }\n'],['\n  mutation decoupleDeviceSim(\n    $newDeviceUniqueId: String\n    $existingDeviceUniqueId: String\n    $newSimId: Int\n    $existingSimId: Int\n    $decoupleType: String!\n    $loginType: String!\n  ) {\n    decoupleDeviceSim(\n      newDeviceUniqueId: $newDeviceUniqueId\n      existingDeviceUniqueId: $existingDeviceUniqueId\n      newSimId: $newSimId\n      existingSimId: $existingSimId\n      decoupleType: $decoupleType\n      loginType: $loginType\n    )\n  }\n']);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var GET_DEVICE_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject);var GET_SIM_DETAILS=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject2);var DECOUPLE_DEVICESIM=Object(__WEBPACK_IMPORTED_MODULE_5_graphql_tag__["a" /* default */])(_templateObject3);var styles=function styles(theme){return{button:{display:'block',marginTop:theme.spacing.unit*2},formControl:{margin:theme.spacing.unit,minWidth:120,width:'100%'},dialogContent:{height:'450px'},infoContainer:{backgroundColor:'#f8f9fa',border:'1px solid #dee2e6',borderRadius:'4px',padding:'12px 16px',marginBottom:'20px'},infoItem:{marginBottom:'8px','&:last-child':{marginBottom:0}}};};var DecoupleDeviceSimDialog=function(_Component){_inherits(DecoupleDeviceSimDialog,_Component);function DecoupleDeviceSimDialog(props){var _this2=this;_classCallCheck(this,DecoupleDeviceSimDialog);var _this=_possibleConstructorReturn(this,(DecoupleDeviceSimDialog.__proto__||Object.getPrototypeOf(DecoupleDeviceSimDialog)).call(this,props));_this.handleChangeType=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var clientLoginId,_ref2,device,deviceError,allDevices,_ref3,simDetails,simError,allSims,_ref4,_device,_deviceError,_allDevices,_ref5,_simDetails,_simError,_allSims;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.setState({vehicleStatus:event.value,deviceDecouple:false,simDecouple:false,deviceSimDecouple:false});clientLoginId=parseInt(_this.props.clientLoginId,10);if(!(event.value==='Device')){_context.next=12;break;}_context.next=5;return _this.props.client.query({query:GET_DEVICE_DETAILS,variables:{clientId:clientLoginId},errorPolicy:'all'});case 5:_ref2=_context.sent;device=_ref2.data;deviceError=_ref2.error;allDevices=device.device.map(function(device){return{value:device.uniqueDeviceId,label:device.uniqueDeviceId};});if(deviceError){_this.setState({deviceDetails:[]});}else{_this.setState({deviceDetails:allDevices,deviceDecouple:true});}_context.next=36;break;case 12:if(!(event.value==='Sim')){_context.next=22;break;}_context.next=15;return _this.props.client.query({query:GET_SIM_DETAILS,variables:{clientId:clientLoginId},errorPolicy:'all'});case 15:_ref3=_context.sent;simDetails=_ref3.data;simError=_ref3.error;allSims=simDetails.simDetails.map(function(sim){return{value:sim.simId,label:sim.sim.phoneNumber};});if(simError){_this.setState({simDetails:[]});}else{_this.setState({simDetails:allSims,simDecouple:true});}_context.next=36;break;case 22:_context.next=24;return _this.props.client.query({query:GET_DEVICE_DETAILS,variables:{clientId:clientLoginId},errorPolicy:'all'});case 24:_ref4=_context.sent;_device=_ref4.data;_deviceError=_ref4.error;_allDevices=_device.device.map(function(device){return{value:device.uniqueDeviceId,label:device.uniqueDeviceId};});_context.next=30;return _this.props.client.query({query:GET_SIM_DETAILS,variables:{clientId:clientLoginId},errorPolicy:'all'});case 30:_ref5=_context.sent;_simDetails=_ref5.data;_simError=_ref5.error;_allSims=_simDetails.simDetails.map(function(sim){return{value:sim.simId,label:sim.sim.phoneNumber};});if(_deviceError){_this.setState({deviceDetails:[]});}else{_this.setState({deviceDetails:_allDevices,deviceDecouple:true});}if(_simError){_this.setState({simDetails:[]});}else{_this.setState({simDetails:_allSims,simDecouple:true});}case 36:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.handleTabChange=function(event,newValue){_this.handleChangeType({value:newValue});};_this.handleSubmit=function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(event){var _this$state,vehicleStatus,serialNumber,phoneNumber,_this$props,uniqueDeviceId,simId,variables,_ref7,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:event.preventDefault();_this$state=_this.state,vehicleStatus=_this$state.vehicleStatus,serialNumber=_this$state.serialNumber,phoneNumber=_this$state.phoneNumber;_this$props=_this.props,uniqueDeviceId=_this$props.uniqueDeviceId,simId=_this$props.simId;variables={decoupleType:vehicleStatus,loginType:localStorage.getItem('Account_type')||'PA'};if(vehicleStatus==='Device'){variables.existingDeviceUniqueId=uniqueDeviceId;variables.newDeviceUniqueId=serialNumber;variables.existingSimId=null;variables.newSimId=null;}else if(vehicleStatus==='Sim'){variables.existingDeviceUniqueId=null;variables.newDeviceUniqueId=null;variables.existingSimId=simId;variables.newSimId=phoneNumber;}else if(vehicleStatus==='DeviceAndSim'){variables.existingDeviceUniqueId=uniqueDeviceId;variables.newDeviceUniqueId=serialNumber;variables.existingSimId=simId;variables.newSimId=phoneNumber;}_context2.next=7;return _this.props.client.mutate({mutation:DECOUPLE_DEVICESIM,variables:variables,refetchQueries:['getVehicleDetail']});case 7:_ref7=_context2.sent;data=_ref7.data;_this.setState({response:data.decoupleDeviceSim});if(_this.state.response==='Success'){setTimeout(function(){_this.props.onClose();},1500);}case 11:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref6.apply(this,arguments);};}();_this.handleChangeDevice=function(event){_this.setState({serialNumber:event.value});};_this.handleChangePhoneNumber=function(event){_this.setState({phoneNumber:event.value});};_this.handleInputChange=function(key){return function(e){_this.setState(_defineProperty({},key,e.target.value));};};_this.state={vehicleStatus:'',deviceDetails:[],simDetails:[],serialNumber:null,phoneNumber:null,deviceDecouple:false,simDecouple:false,deviceSimDecouple:false,response:'',reason:''};return _this;}_createClass(DecoupleDeviceSimDialog,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.open){this.handleChangeType({value:'Device'});}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var _this3=this;if(this.props.open&&!prevProps.open){this.setState({vehicleStatus:'',serialNumber:null,phoneNumber:null,response:'',reason:''},function(){_this3.handleChangeType({value:'Device'});});}}},{key:'render',value:function render(){var _this4=this;var classes=this.props.classes;var _props=this.props,open=_props.open,onClose=_props.onClose,solutionType=_props.solutionType,uniqueDeviceId=_props.uniqueDeviceId,simPhoneNumber=_props.simPhoneNumber;var _state=this.state,vehicleStatus=_state.vehicleStatus,response=_state.response,reason=_state.reason;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["Dialog"],{open:open,onClose:onClose,maxWidth:'sm',fullWidth:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["DialogTitle"],{id:'form-dialog-title'},'Decouple Device/Sim'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["Tabs"],{value:vehicleStatus||false,onChange:this.handleTabChange,indicatorColor:'primary',textColor:'primary',centered:true,style:{borderBottom:'1px solid #e0e0e0'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["Tab"],{value:'Device',label:'Device'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["Tab"],{value:'Sim',label:'Sim'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["Tab"],{value:'DeviceAndSim',label:'Device & Sim'})),response==='Success'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["Typography"],{variant:'subheading',gutterBottom:true,style:{color:'green',marginLeft:'25px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Decoupled Successfully')),response!=='Success'&&response!==''&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["Typography"],{variant:'subheading',gutterBottom:true,style:{color:'red',marginLeft:'25px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,response)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["Divider"],{light:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{onSubmit:this.handleSubmit,style:{height:'550px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["DialogContent"],{className:classes.dialogContent},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["Typography"],{variant:'body2',style:{marginBottom:'10px'}},'* Marked fields are mandatory'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.infoContainer},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.infoItem},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["Typography"],{variant:'caption',style:{color:'#6c757d',marginBottom:'2px',display:'block'}},'Solution Type'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["Typography"],{variant:'body2',style:{fontWeight:'500',color:'#333'}},solutionType||'N/A')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{display:'flex',gap:'20px',marginTop:'10px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{flex:1}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["Typography"],{variant:'caption',style:{color:'#6c757d',marginBottom:'2px',display:'block'}},'Current Device ID'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["Typography"],{variant:'body2',style:{fontWeight:'500',color:'#333'}},uniqueDeviceId||'Not Assigned')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{flex:1}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["Typography"],{variant:'caption',style:{color:'#6c757d',marginBottom:'2px',display:'block'}},'Current SIM Number'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["Typography"],{variant:'body2',style:{fontWeight:'500',color:'#333'}},simPhoneNumber||'Not Assigned')))),!vehicleStatus&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["Typography"],{variant:'body2',style:{textAlign:'center',marginTop:'40px',color:'#666'}},'Please select a decouple type using the tabs above to proceed'),(this.state.deviceDecouple||this.state.deviceSimDecouple)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["FormControl"],{className:classes.formControl,style:{minWidth:'100%',marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["Typography"],{variant:'subtitle2',style:{marginBottom:'8px',color:'#555',fontWeight:'bold'}},'Select New Device *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{options:this.state.deviceDetails,value:this.state.serialNumber?this.state.deviceDetails.find(function(device){return device.value===_this4.state.serialNumber;}):null,onChange:this.handleChangeDevice,placeholder:'Choose Device ID'})),(this.state.simDecouple||this.state.deviceSimDecouple)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["FormControl"],{className:classes.formControl,style:{minWidth:'100%',marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["Typography"],{variant:'subtitle2',style:{marginBottom:'8px',color:'#555',fontWeight:'bold'}},'Select New SIM Number *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */],{options:this.state.simDetails,value:this.state.phoneNumber?this.state.simDetails.find(function(sim){return sim.value===_this4.state.phoneNumber;}):null,onChange:this.handleChangePhoneNumber,placeholder:'Choose SIM Card'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["FormControl"],{className:classes.formControl,style:{minWidth:'100%'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["TextField"],{autoFocus:true,margin:'dense',id:'reason',name:'reason',label:'Reason For Decouple!',multiline:true,rows:3,required:true,value:reason,fullWidth:true,onChange:this.handleInputChange('reason')}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["DialogActions"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["Button"],{onClick:onClose,color:'default',variant:'contained'},'Cancel'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["Button"],{type:'submit',color:'primary',variant:'contained',disabled:!(vehicleStatus!==''&&reason!=='')},'Submit'))));}}]);return DecoupleDeviceSimDialog;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_6_react_apollo__["withApollo"])(DecoupleDeviceSimDialog)));

/***/ }),
/* 2455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Paper__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Paper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Tabs__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Tab__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Chip__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Chip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Chip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Checkbox__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_InputAdornment__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_InputAdornment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_InputAdornment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Icon__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__common_ConfirmationDialog__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__HOCs_withSharedSnackbar__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query getAllVehicleDetailsByStatus($loginId: Int, $status: Int) {\n    vehicles: getAllVehicleDetailsByStatus(\n      partnerLoginId: $loginId\n      status: $status\n    ) {\n      entityId\n      vehicleNumber\n      status\n      deviceDetail {\n        uniqueDeviceId\n      }\n    }\n  }\n'],['\n  query getAllVehicleDetailsByStatus($loginId: Int, $status: Int) {\n    vehicles: getAllVehicleDetailsByStatus(\n      partnerLoginId: $loginId\n      status: $status\n    ) {\n      entityId\n      vehicleNumber\n      status\n      deviceDetail {\n        uniqueDeviceId\n      }\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  mutation activateDeactivateVehiclesonboarding(\n    $uniqueids: [String!]!\n    $entityids: [Int!]!\n    $action: String!\n    $reason: String!\n    $created_by: String\n    $updated_by: String\n  ) {\n    activateDeactivateVehiclesonboarding(\n      uniqueids: $uniqueids\n      entityids: $entityids\n      action: $action\n      reason: $reason\n      created_by: $created_by\n      updated_by: $updated_by\n    ) {\n      success\n      message\n    }\n  }\n'],['\n  mutation activateDeactivateVehiclesonboarding(\n    $uniqueids: [String!]!\n    $entityids: [Int!]!\n    $action: String!\n    $reason: String!\n    $created_by: String\n    $updated_by: String\n  ) {\n    activateDeactivateVehiclesonboarding(\n      uniqueids: $uniqueids\n      entityids: $entityids\n      action: $action\n      reason: $reason\n      created_by: $created_by\n      updated_by: $updated_by\n    ) {\n      success\n      message\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var styles=function styles(){return{root:{padding:24,marginTop:24},paper:{padding:0,marginBottom:16,overflow:'hidden'},tabContent:{padding:20},sectionTitle:{fontWeight:600,marginBottom:12,color:'#2c3e50'},vehicleListSection:{border:'1px solid #e0e0e0',borderRadius:6,overflow:'hidden',marginBottom:16},vehicleRow:{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'6px 16px 6px 8px',borderBottom:'1px solid #f5f5f5',cursor:'pointer','&:last-child':{borderBottom:'none'},'&:hover':{backgroundColor:'#fafafa'}},chipActive:{backgroundColor:'#e8f5e9',color:'#2e7d32',border:'1px solid #a5d6a7',fontSize:11},chipInactive:{backgroundColor:'#ffebee',color:'#c62828',border:'1px solid #ef9a9a',fontSize:11},activateBtn:{backgroundColor:'#2e7d32',color:'#fff',marginTop:12,'&:hover':{backgroundColor:'#1b5e20'},'&:disabled':{backgroundColor:'#bdbdbd',color:'#fff'}},deactivateBtn:{backgroundColor:'#c62828',color:'#fff',marginTop:12,'&:hover':{backgroundColor:'#7f0000'},'&:disabled':{backgroundColor:'#bdbdbd',color:'#fff'}},emptyState:{padding:32,textAlign:'center',color:'#999'},searchBar:{padding:'10px 16px',borderBottom:'1px solid #e0e0e0',backgroundColor:'#fff'}};};// status: 0 → inactive vehicles (shown in Activate tab)
// status: 1 → active vehicles (shown in Deactivate tab)
var GET_VEHICLES=Object(__WEBPACK_IMPORTED_MODULE_16_graphql_tag__["a" /* default */])(_templateObject);var BULK_ACTIVATE_DEACTIVATE=Object(__WEBPACK_IMPORTED_MODULE_16_graphql_tag__["a" /* default */])(_templateObject2);var HARDCODED_LOGIN_ID=8148;var VehicleDeactivationActivation=function(_Component){_inherits(VehicleDeactivationActivation,_Component);function VehicleDeactivationActivation(props){var _this2=this;_classCallCheck(this,VehicleDeactivationActivation);var _this=_possibleConstructorReturn(this,(VehicleDeactivationActivation.__proto__||Object.getPrototypeOf(VehicleDeactivationActivation)).call(this,props));_this.handleTabChange=function(event,value){_this.setState({activeTab:value,selectedVehicles:[],reason:'',searchQuery:''});};_this.handleSearchChange=function(e){_this.setState({searchQuery:e.target.value});};_this.clearSearch=function(){_this.setState({searchQuery:''});};_this.handleToggleVehicle=function(vehicle){var selectedVehicles=_this.state.selectedVehicles;var safeSelected=Array.isArray(selectedVehicles)?selectedVehicles:[];var exists=safeSelected.find(function(v){return v.value===vehicle.value;});if(exists){_this.setState({selectedVehicles:safeSelected.filter(function(v){return v.value!==vehicle.value;})});}else{_this.setState({selectedVehicles:[].concat(_toConsumableArray(safeSelected),[vehicle])});}};_this.submitAction=function(){var _this$state=_this.state,activeTab=_this$state.activeTab,selectedVehicles=_this$state.selectedVehicles,reason=_this$state.reason;var safeSelected=Array.isArray(selectedVehicles)?selectedVehicles:[];var action=activeTab===0?'Activate':'Deactivate';if(safeSelected.length===0){_this.props.openSnackbar('Please select at least one vehicle');return;}if(!reason||reason.trim()===''){_this.props.openSnackbar('Please provide a reason');return;}var vehicleLabels=safeSelected.map(function(v){return v.vehicleNumber;}).join(', ');_this.setState({confirmDialogOpen:true,confirmDialogTitle:'Confirm '+action,confirmDialogMessage:'Are you sure you want to '+action.toLowerCase()+' '+safeSelected.length+' vehicle(s)?\n\n'+vehicleLabels,pendingAction:action});};_this.executeAction=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _this$state2,pendingAction,selectedVehicles,reason,safeSelected,uniqueids,entityids,_ref2,data,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this$state2=_this.state,pendingAction=_this$state2.pendingAction,selectedVehicles=_this$state2.selectedVehicles,reason=_this$state2.reason;safeSelected=Array.isArray(selectedVehicles)?selectedVehicles:[];uniqueids=safeSelected.map(function(v){return v.deviceDetail&&v.deviceDetail.uniqueDeviceId;}).filter(function(id){return id;});entityids=safeSelected.map(function(v){return parseInt(v.entityId||v.value,10);}).filter(function(id){return!isNaN(id);});_this.setState({isSubmitting:true,confirmDialogOpen:false});_context.prev=5;_context.next=8;return _this.props.client.mutate({mutation:BULK_ACTIVATE_DEACTIVATE,variables:{uniqueids:uniqueids,entityids:entityids,action:pendingAction,reason:reason.trim(),created_by:localStorage.getItem('username'),updated_by:localStorage.getItem('username')},refetchQueries:['getAllVehicleDetailsByStatus']});case 8:_ref2=_context.sent;data=_ref2.data;response=data&&data.activateDeactivateVehiclesonboarding;_this.props.openSnackbar(response&&response.message||pendingAction+' submitted for '+uniqueids.length+' vehicle(s)');_this.setState({selectedVehicles:[],reason:'',searchQuery:''});_context.next=19;break;case 15:_context.prev=15;_context.t0=_context['catch'](5);console.error('Action error:',_context.t0);_this.props.openSnackbar('Failed to '+pendingAction+' vehicle(s)');case 19:_context.prev=19;_this.setState({isSubmitting:false});return _context.finish(19);case 22:case'end':return _context.stop();}}},_callee,_this2,[[5,15,19,22]]);}));_this.closeConfirmDialog=function(){_this.setState({confirmDialogOpen:false});};_this.renderVehicleList=function(allVehicles,chipLabel,chipClass,classes){var _this$state3=_this.state,selectedVehicles=_this$state3.selectedVehicles,searchQuery=_this$state3.searchQuery;var safeSelected=Array.isArray(selectedVehicles)?selectedVehicles:[];var query=searchQuery.trim().toLowerCase();// Filter vehicles by search query
var filtered=query?allVehicles.filter(function(v){var matchVehicle=v.vehicleNumber&&v.vehicleNumber.toLowerCase().includes(query);var matchDevice=v.deviceDetail&&v.deviceDetail.uniqueDeviceId&&v.deviceDetail.uniqueDeviceId.toLowerCase().includes(query);return matchVehicle||matchDevice;}):allVehicles;if(allVehicles.length===0){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.emptyState},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body2'},'No vehicles found'));}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.vehicleListSection},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.searchBar},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_TextField___default.a,{placeholder:'Search by vehicle number or device ID...',value:searchQuery,onChange:_this.handleSearchChange,fullWidth:true,variant:'outlined',size:'small',autoComplete:'off',InputProps:{startAdornment:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_InputAdornment___default.a,{position:'start'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Icon___default.a,{style:{color:'#aaa',fontSize:20}},'search')),endAdornment:searchQuery?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_InputAdornment___default.a,{position:'end'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Icon___default.a,{style:{color:'#aaa',fontSize:18,cursor:'pointer'},onClick:_this.clearSearch},'close')):null}}),query&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'caption',style:{color:'#666',marginTop:4,display:'block'}},'Showing ',filtered.length,' of ',allVehicles.length,' vehicles',safeSelected.length>0&&' \u2022 '+safeSelected.length+' total selected')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{maxHeight:320,overflowY:'auto'}},filtered.length===0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.emptyState},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body2',style:{color:'#aaa'}},'No vehicles match "',searchQuery,'"')):filtered.map(function(vehicle){var isChecked=safeSelected.some(function(v){return v.value===vehicle.value;});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:vehicle.value,className:classes.vehicleRow,onClick:function onClick(){return _this.handleToggleVehicle(vehicle);},style:{backgroundColor:isChecked?'#f3f8ff':'transparent'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{display:'flex',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Checkbox___default.a,{checked:isChecked,color:'primary',style:{padding:'0 8px 0 0'},onClick:function onClick(e){return e.stopPropagation();},onChange:function onChange(){return _this.handleToggleVehicle(vehicle);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body2',style:{fontWeight:500}},vehicle.vehicleNumber),vehicle.deviceDetail&&vehicle.deviceDetail.uniqueDeviceId&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'caption',style:{color:'#888'}},vehicle.deviceDetail.uniqueDeviceId))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Chip___default.a,{label:chipLabel,size:'small',className:chipClass}));})));};_this.state={activeTab:0,selectedVehicles:[],searchQuery:'',reason:'',isSubmitting:false,confirmDialogOpen:false,confirmDialogMessage:'',confirmDialogTitle:'',pendingAction:null};return _this;}_createClass(VehicleDeactivationActivation,[{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;var _state=this.state,activeTab=_state.activeTab,selectedVehicles=_state.selectedVehicles,reason=_state.reason,isSubmitting=_state.isSubmitting,confirmDialogOpen=_state.confirmDialogOpen,confirmDialogMessage=_state.confirmDialogMessage,confirmDialogTitle=_state.confirmDialogTitle;var safeSelected=Array.isArray(selectedVehicles)?selectedVehicles:[];var isActivateTab=activeTab===0;var queryStatus=isActivateTab?0:1;var action=isActivateTab?'Activate':'Deactivate';var btnClass=isActivateTab?classes.activateBtn:classes.deactivateBtn;var chipLabel=isActivateTab?'Inactive':'Active';var chipClass=isActivateTab?classes.chipInactive:classes.chipActive;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'h4',component:'h1',gutterBottom:true},'Vehicle Deactivation / Activation'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Paper___default.a,{className:classes.paper},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Tabs___default.a,{value:activeTab,onChange:this.handleTabChange,indicatorColor:'primary',textColor:'primary',style:{borderBottom:'1px solid #e0e0e0'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Tab___default.a,{label:'Activate Vehicles',style:{color:activeTab===0?'#2e7d32':undefined,fontWeight:600}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Tab___default.a,{label:'Deactivate Vehicles',style:{color:activeTab===1?'#c62828':undefined,fontWeight:600}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.tabContent},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'subtitle1',className:classes.sectionTitle},isActivateTab?'Search and select inactive vehicles to activate':'Search and select active vehicles to deactivate',safeSelected.length>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{fontWeight:400,fontSize:13,color:'#555',marginLeft:8}},'(',safeSelected.length,' selected)')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_apollo__["Query"],{query:GET_VEHICLES,variables:{loginId:HARDCODED_LOGIN_ID,status:queryStatus},fetchPolicy:'network-only'},function(_ref3){var loading=_ref3.loading,error=_ref3.error,data=_ref3.data;if(loading){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{padding:32,textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["CircularProgress"],null));}if(error){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{padding:16,color:'red'}},'Error loading vehicles');}var vehicleOptions=(data.vehicles||[]).map(function(v){return{value:v.entityId,entityId:v.entityId,vehicleNumber:v.vehicleNumber,status:v.status,deviceDetail:v.deviceDetail};});return _this3.renderVehicleList(vehicleOptions,chipLabel,chipClass,classes);}),safeSelected.length>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Divider___default.a,{style:{marginBottom:16}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true,spacing:2,alignItems:'flex-end'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12,sm:9},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_TextField___default.a,{label:'Reason for '+action+' *',placeholder:'Enter reason...',value:reason,onChange:function onChange(e){return _this3.setState({reason:e.target.value});},multiline:true,rows:2,fullWidth:true,variant:'outlined',size:'small'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Button___default.a,{variant:'contained',fullWidth:true,className:btnClass,disabled:isSubmitting||!reason.trim(),onClick:this.submitAction},isSubmitting?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_core__["CircularProgress"],{size:20,style:{color:'#fff'}}):action+' ('+safeSelected.length+')')))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__common_ConfirmationDialog__["a" /* default */],{isDialogOpen:confirmDialogOpen,dialogTitle:confirmDialogTitle,dialogMessage:confirmDialogMessage,positiveResponseButtonText:'Yes, Proceed',negativeResponseButtonText:'Cancel',positiveResponseHandler:this.executeAction,negativeResponseHandler:this.closeConfirmDialog,dialogCloseHandler:this.closeConfirmDialog}));}}]);return VehicleDeactivationActivation;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_17_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_19__HOCs_withSharedSnackbar__["a" /* default */])(VehicleDeactivationActivation))));

/***/ }),
/* 2456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Paper__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Paper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormGroup__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Checkbox__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Chip__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Chip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Chip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Divider__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_InputAdornment__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_InputAdornment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_InputAdornment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Icon__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__common_ConfirmationDialog__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__HOCs_withSharedSnackbar__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query allClientDetails($partnerLoginId: Int) {\n    clients: allClientDetails(partnerLoginId: $partnerLoginId) {\n      id\n      clientName\n      loginId\n    }\n  }\n'],['\n  query allClientDetails($partnerLoginId: Int) {\n    clients: allClientDetails(partnerLoginId: $partnerLoginId) {\n      id\n      clientName\n      loginId\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query getAllVehicleDetails($clientLoginId: Int) {\n    vehicles: getAllVehicleDetails(clientLoginId: $clientLoginId) {\n      entityId\n      vehicleNumber\n      clientLoginId\n      deviceDetail {\n        uniqueDeviceId\n      }\n      simDetail {\n        phoneNumber\n      }\n      solutionType\n    }\n  }\n'],['\n  query getAllVehicleDetails($clientLoginId: Int) {\n    vehicles: getAllVehicleDetails(clientLoginId: $clientLoginId) {\n      entityId\n      vehicleNumber\n      clientLoginId\n      deviceDetail {\n        uniqueDeviceId\n      }\n      simDetail {\n        phoneNumber\n      }\n      solutionType\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation bulkUnregisterVehiclesonboarding(\n    $entityIds: [Int!]!\n    $uniqueids: [String!]!\n    $reason: String!\n    $created_by: String\n    $updated_by: String\n  ) {\n    bulkUnregisterVehiclesonboarding(\n      entityIds: $entityIds\n      uniqueids: $uniqueids\n      reason: $reason\n      created_by: $created_by\n      updated_by: $updated_by\n    ) {\n      success\n      message\n    }\n  }\n'],['\n  mutation bulkUnregisterVehiclesonboarding(\n    $entityIds: [Int!]!\n    $uniqueids: [String!]!\n    $reason: String!\n    $created_by: String\n    $updated_by: String\n  ) {\n    bulkUnregisterVehiclesonboarding(\n      entityIds: $entityIds\n      uniqueids: $uniqueids\n      reason: $reason\n      created_by: $created_by\n      updated_by: $updated_by\n    ) {\n      success\n      message\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var styles=function styles(){return{root:{padding:24,marginTop:24},paper:{padding:20,marginBottom:16},sectionTitle:{fontWeight:600,marginBottom:12,color:'#2c3e50'},vehicleListSection:{border:'1px solid #e0e0e0',borderRadius:6,overflow:'hidden',marginBottom:16},searchBar:{padding:'10px 16px',borderBottom:'1px solid #e0e0e0',backgroundColor:'#fff'},vehicleRow:{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'6px 16px 6px 8px',borderBottom:'1px solid #f5f5f5',cursor:'pointer','&:last-child':{borderBottom:'none'},'&:hover':{backgroundColor:'#fafafa'}},summaryCard:{backgroundColor:'#fff8f8',border:'1px solid #ffcccc',borderLeft:'4px solid #c62828',borderRadius:6,padding:'12px 16px',marginBottom:16},summaryRow:{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'6px 0',borderBottom:'1px solid #f0f0f0','&:last-child':{borderBottom:'none'}},warningBox:{backgroundColor:'#fff3e0',border:'1px solid #ff9800',borderRadius:6,padding:'10px 16px',marginBottom:16,display:'flex',alignItems:'center',gap:8},deleteBtn:{backgroundColor:'#c62828',color:'#fff','&:hover':{backgroundColor:'#7f0000'},'&:disabled':{backgroundColor:'#bdbdbd',color:'#fff'}},emptyState:{padding:32,textAlign:'center',color:'#999'}};};var GET_CLIENTS=Object(__WEBPACK_IMPORTED_MODULE_17_graphql_tag__["a" /* default */])(_templateObject);var GET_VEHICLES=Object(__WEBPACK_IMPORTED_MODULE_17_graphql_tag__["a" /* default */])(_templateObject2);// New dedicated bulk unregistration mutation
var BULK_UNREGISTER_VEHICLES=Object(__WEBPACK_IMPORTED_MODULE_17_graphql_tag__["a" /* default */])(_templateObject3);var VehicleUnregistration=function(_Component){_inherits(VehicleUnregistration,_Component);function VehicleUnregistration(props){var _this2=this;_classCallCheck(this,VehicleUnregistration);var _this=_possibleConstructorReturn(this,(VehicleUnregistration.__proto__||Object.getPrototypeOf(VehicleUnregistration)).call(this,props));_this.handleCustomerChange=function(selectedCustomer){_this.setState({selectedCustomer:selectedCustomer,selectedVehicles:[],searchQuery:'',reason:''});};_this.handleSearchChange=function(e){_this.setState({searchQuery:e.target.value});};_this.clearSearch=function(){_this.setState({searchQuery:''});};_this.handleToggleVehicle=function(vehicle){var selectedVehicles=_this.state.selectedVehicles;var safeSelected=Array.isArray(selectedVehicles)?selectedVehicles:[];var exists=safeSelected.find(function(v){return v.value===vehicle.value;});if(exists){_this.setState({selectedVehicles:safeSelected.filter(function(v){return v.value!==vehicle.value;})});}else{_this.setState({selectedVehicles:[].concat(_toConsumableArray(safeSelected),[vehicle])});}};_this.handleDeleteConfirm=function(){var _this$state=_this.state,selectedVehicles=_this$state.selectedVehicles,reason=_this$state.reason;var safeSelected=Array.isArray(selectedVehicles)?selectedVehicles:[];if(safeSelected.length===0){_this.props.openSnackbar('Please select at least one vehicle to unregister');return;}if(!reason||reason.trim()===''){_this.props.openSnackbar('Please provide a reason for unregistration');return;}var vehicleList=safeSelected.map(function(v){return v.vehicleNumber;}).join(', ');_this.setState({confirmDialogOpen:true,confirmDialogTitle:'Confirm Unregistration',confirmDialogMessage:'\u26A0\uFE0F This action is IRREVERSIBLE.\n\nYou are about to permanently unregister '+safeSelected.length+' vehicle(s):\n\n'+vehicleList+'\n\nAre you sure you want to proceed?'});};_this.executeDelete=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _this$state2,selectedVehicles,reason,safeSelected,entityIds,uniqueids,_ref2,data,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this$state2=_this.state,selectedVehicles=_this$state2.selectedVehicles,reason=_this$state2.reason;safeSelected=Array.isArray(selectedVehicles)?selectedVehicles:[];entityIds=safeSelected.map(function(v){return parseInt(v.entityId||v.value,10);}).filter(function(id){return!isNaN(id);});uniqueids=safeSelected.map(function(v){return v.deviceDetail&&v.deviceDetail.uniqueDeviceId;}).filter(function(id){return id;});_this.setState({isSubmitting:true,confirmDialogOpen:false});_context.prev=5;_context.next=8;return _this.props.client.mutate({mutation:BULK_UNREGISTER_VEHICLES,variables:{entityIds:entityIds,uniqueids:uniqueids,reason:reason.trim(),created_by:localStorage.getItem('username'),updated_by:localStorage.getItem('username')},refetchQueries:['getAllVehicleDetails']});case 8:_ref2=_context.sent;data=_ref2.data;response=data&&data.bulkUnregisterVehiclesonboarding;_this.props.openSnackbar(response&&response.message||entityIds.length+' vehicle(s) unregistered successfully');_this.setState({selectedVehicles:[],reason:'',searchQuery:''});_context.next=19;break;case 15:_context.prev=15;_context.t0=_context['catch'](5);console.error('Unregister error:',_context.t0);_this.props.openSnackbar('Failed to unregister vehicle(s)');case 19:_context.prev=19;_this.setState({isSubmitting:false});return _context.finish(19);case 22:case'end':return _context.stop();}}},_callee,_this2,[[5,15,19,22]]);}));_this.closeConfirmDialog=function(){_this.setState({confirmDialogOpen:false});};_this.renderVehicleList=function(allVehicles,classes){var _this$state3=_this.state,selectedVehicles=_this$state3.selectedVehicles,searchQuery=_this$state3.searchQuery;var safeSelected=Array.isArray(selectedVehicles)?selectedVehicles:[];var query=searchQuery.trim().toLowerCase();var filtered=query?allVehicles.filter(function(v){var matchVehicle=v.vehicleNumber&&v.vehicleNumber.toLowerCase().includes(query);var matchDevice=v.deviceDetail&&v.deviceDetail.uniqueDeviceId&&v.deviceDetail.uniqueDeviceId.toLowerCase().includes(query);return matchVehicle||matchDevice;}):allVehicles;if(allVehicles.length===0){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.emptyState},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body2'},'No registered vehicles found for this customer'));}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.vehicleListSection},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.searchBar},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_TextField___default.a,{placeholder:'Search by vehicle number or device ID...',value:searchQuery,onChange:_this.handleSearchChange,fullWidth:true,variant:'outlined',size:'small',autoComplete:'off',InputProps:{startAdornment:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_InputAdornment___default.a,{position:'start'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Icon___default.a,{style:{color:'#aaa',fontSize:20}},'search')),endAdornment:searchQuery?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_InputAdornment___default.a,{position:'end'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Icon___default.a,{style:{color:'#aaa',fontSize:18,cursor:'pointer'},onClick:_this.clearSearch},'close')):null}}),query&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'caption',style:{color:'#666',marginTop:4,display:'block'}},'Showing ',filtered.length,' of ',allVehicles.length,' vehicles',safeSelected.length>0&&' \u2022 '+safeSelected.length+' total selected')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{maxHeight:320,overflowY:'auto'}},filtered.length===0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.emptyState},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body2',style:{color:'#aaa'}},'No vehicles match "',searchQuery,'"')):filtered.map(function(vehicle){var isChecked=safeSelected.some(function(v){return v.value===vehicle.value;});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:vehicle.value,className:classes.vehicleRow,onClick:function onClick(){return _this.handleToggleVehicle(vehicle);},style:{backgroundColor:isChecked?'#fff8f8':'transparent'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{display:'flex',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Checkbox___default.a,{checked:isChecked,color:'secondary',style:{padding:'0 8px 0 0'},onClick:function onClick(e){return e.stopPropagation();},onChange:function onChange(){return _this.handleToggleVehicle(vehicle);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body2',style:{fontWeight:500}},vehicle.vehicleNumber),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'caption',style:{color:'#888'}},vehicle.deviceDetail&&vehicle.deviceDetail.uniqueDeviceId?vehicle.deviceDetail.uniqueDeviceId:'No Device',vehicle.simDetail&&vehicle.simDetail.phoneNumber?' \u2022 SIM: '+vehicle.simDetail.phoneNumber:'',vehicle.solutionType?' \u2022 '+vehicle.solutionType.toUpperCase():''))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Chip___default.a,{label:'Registered',size:'small',style:{backgroundColor:'#e8f5e9',color:'#2e7d32',border:'1px solid #a5d6a7',fontSize:11}}));})));};_this.state={selectedCustomer:null,selectedVehicles:[],searchQuery:'',reason:'',isSubmitting:false,confirmDialogOpen:false,confirmDialogMessage:'',confirmDialogTitle:''};return _this;}_createClass(VehicleUnregistration,[{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;var _state=this.state,selectedCustomer=_state.selectedCustomer,selectedVehicles=_state.selectedVehicles,reason=_state.reason,isSubmitting=_state.isSubmitting,confirmDialogOpen=_state.confirmDialogOpen,confirmDialogMessage=_state.confirmDialogMessage,confirmDialogTitle=_state.confirmDialogTitle;var safeSelected=Array.isArray(selectedVehicles)?selectedVehicles:[];var partnerLoginId=Object(__WEBPACK_IMPORTED_MODULE_19__utils_getLoginId__["a" /* default */])();return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'h4',component:'h1',gutterBottom:true},'Vehicle Unregistration'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Paper___default.a,{className:classes.paper},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'subtitle1',className:classes.sectionTitle},'Step 1 \u2014 Select Customer'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true,spacing:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormControl___default.a,{fullWidth:true},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormGroup___default.a,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'subtitle2',gutterBottom:true},'Select Customer *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_apollo__["Query"],{query:GET_CLIENTS,variables:{partnerLoginId:partnerLoginId}},function(_ref3){var loading=_ref3.loading,error=_ref3.error,data=_ref3.data;if(loading)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core__["CircularProgress"],{size:20});if(error)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Error loading customers');var customerOptions=(data.clients||[]).map(function(c){return Object.assign({value:c.loginId,label:c.clientName},c);});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_select__["a" /* default */],{value:selectedCustomer,onChange:_this3.handleCustomerChange,options:customerOptions,placeholder:'Select a customer'});})))))),selectedCustomer&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Paper___default.a,{className:classes.paper},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'subtitle1',className:classes.sectionTitle},'Step 2 \u2014 Select Vehicles to Unregister',safeSelected.length>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{fontWeight:400,fontSize:13,color:'#c62828',marginLeft:8}},'(',safeSelected.length,' selected)')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_apollo__["Query"],{query:GET_VEHICLES,variables:{clientLoginId:selectedCustomer.value},fetchPolicy:'network-only'},function(_ref4){var loading=_ref4.loading,error=_ref4.error,data=_ref4.data;if(loading)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{padding:24,textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core__["CircularProgress"],null));if(error)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{padding:16,color:'red'}},'Error loading vehicles');var vehicleOptions=(data.vehicles||[]).map(function(v){return{value:v.entityId,entityId:v.entityId,vehicleNumber:v.vehicleNumber,solutionType:v.solutionType,deviceDetail:v.deviceDetail,simDetail:v.simDetail};});return _this3.renderVehicleList(vehicleOptions,classes);})),safeSelected.length>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Paper___default.a,{className:classes.paper},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'subtitle1',className:classes.sectionTitle},'Step 3 \u2014 Review & Confirm Unregistration'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.warningBox},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Icon___default.a,{style:{color:'#e65100',fontSize:22}},'warning'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body2',style:{color:'#e65100',fontWeight:500}},'The following ',safeSelected.length,' vehicle',safeSelected.length!==1?'s':'',' will be permanently unregistered. This action cannot be undone.')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.summaryCard},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'subtitle2',style:{fontWeight:700,marginBottom:10,color:'#c62828'}},'Vehicles to be Unregistered (',safeSelected.length,')'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{maxHeight:240,overflowY:'auto'}},safeSelected.map(function(v){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:v.value,className:classes.summaryRow},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'body2',style:{fontWeight:600}},v.vehicleNumber),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'caption',style:{color:'#888'}},v.deviceDetail&&v.deviceDetail.uniqueDeviceId?'Device: '+v.deviceDetail.uniqueDeviceId:'No Device',v.simDetail&&v.simDetail.phoneNumber?' \u2022 SIM: '+v.simDetail.phoneNumber:'',v.solutionType?' \u2022 '+v.solutionType.toUpperCase():'')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button___default.a,{size:'small',onClick:function onClick(e){e.stopPropagation();_this3.handleToggleVehicle(v);},style:{color:'#c62828',minWidth:0,padding:'2px 6px'},title:'Remove from selection'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_Icon___default.a,{style:{fontSize:16}},'close')));}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Divider___default.a,{style:{marginBottom:16}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true,spacing:2,alignItems:'flex-end'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12,sm:9},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_TextField___default.a,{label:'Reason for Unregistration *',placeholder:'Enter reason for unregistering these vehicles...',value:reason,onChange:function onChange(e){return _this3.setState({reason:e.target.value});},multiline:true,rows:2,fullWidth:true,variant:'outlined',size:'small'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12,sm:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button___default.a,{variant:'contained',fullWidth:true,className:classes.deleteBtn,disabled:isSubmitting||!reason.trim(),onClick:this.handleDeleteConfirm},isSubmitting?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_core__["CircularProgress"],{size:20,style:{color:'#fff'}}):'Unregister ('+safeSelected.length+')')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__common_ConfirmationDialog__["a" /* default */],{isDialogOpen:confirmDialogOpen,dialogTitle:confirmDialogTitle,dialogMessage:confirmDialogMessage,positiveResponseButtonText:'Yes, Unregister',negativeResponseButtonText:'Cancel',positiveResponseHandler:this.executeDelete,negativeResponseHandler:this.closeConfirmDialog,dialogCloseHandler:this.closeConfirmDialog}));}}]);return VehicleUnregistration;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_18_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_21__HOCs_withSharedSnackbar__["a" /* default */])(VehicleUnregistration))));

/***/ }),
/* 2457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Paper__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Paper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormGroup__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Checkbox__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Tabs__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Tab__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_Tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Icon__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__common_ConfirmationDialog__ = __webpack_require__(65);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query allClientDetails($partnerLoginId: Int) {\n    clients: allClientDetails(partnerLoginId: $partnerLoginId) {\n      id\n      clientName\n      loginId\n    }\n  }\n'],['\n  query allClientDetails($partnerLoginId: Int) {\n    clients: allClientDetails(partnerLoginId: $partnerLoginId) {\n      id\n      clientName\n      loginId\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query getAllVehicleDetails($clientLoginId: Int) {\n    getAllVehicleDetails(clientLoginId: $clientLoginId) {\n      entityId\n      vehicleNumber\n      solutionType\n      solution_type\n      deviceDetail {\n        uniqueDeviceId\n      }\n      simDetail {\n        id\n        phoneNumber\n      }\n      videoTelematicsType\n      videoTelematicsId\n    }\n  }\n'],['\n  query getAllVehicleDetails($clientLoginId: Int) {\n    getAllVehicleDetails(clientLoginId: $clientLoginId) {\n      entityId\n      vehicleNumber\n      solutionType\n      solution_type\n      deviceDetail {\n        uniqueDeviceId\n      }\n      simDetail {\n        id\n        phoneNumber\n      }\n      videoTelematicsType\n      videoTelematicsId\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query GetAllMasterSolutionType {\n    getAllMasterSolutionType {\n      id\n      solutionTypeName\n    }\n  }\n'],['\n  query GetAllMasterSolutionType {\n    getAllMasterSolutionType {\n      id\n      solutionTypeName\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query getAllAssignedDevicesToClient($clientId: Int!) {\n    device: getAllAssignedDevicesToClient(clientLoginId: $clientId) {\n      uniqueDeviceId\n      deviceModel {\n        model_name\n      }\n    }\n  }\n'],['\n  query getAllAssignedDevicesToClient($clientId: Int!) {\n    device: getAllAssignedDevicesToClient(clientLoginId: $clientId) {\n      uniqueDeviceId\n      deviceModel {\n        model_name\n      }\n    }\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  query getAllAssignedSimToClient($clientId: Int!) {\n    simDetails: getAllAssignedSimToClient(clientLoginId: $clientId) {\n      id\n      simId\n      sim {\n        phoneNumber\n      }\n    }\n  }\n'],['\n  query getAllAssignedSimToClient($clientId: Int!) {\n    simDetails: getAllAssignedSimToClient(clientLoginId: $clientId) {\n      id\n      simId\n      sim {\n        phoneNumber\n      }\n    }\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  mutation RemoveDeviceTop(\n    $clientLoginId: Int\n    $vehicledeviceid: Int\n    $removeSolutionType: String!\n    $newUniqueDeviceId: String\n    $newSimId: Int\n    $isDeviceAndSimDecoupleNotRequired: Boolean\n    $loginType: String\n    $reason: String\n    $created_by: String\n    $updated_by: String\n  ) {\n    removeDeviceTop(\n      clientLoginId: $clientLoginId\n      vehicledeviceid: $vehicledeviceid\n      removeSolutionType: $removeSolutionType\n      newUniqueDeviceId: $newUniqueDeviceId\n      newSimId: $newSimId\n      isDeviceAndSimDecoupleNotRequired: $isDeviceAndSimDecoupleNotRequired\n      loginType: $loginType\n      reason: $reason\n      created_by: $created_by\n      updated_by: $updated_by\n    ) {\n      success\n      message\n    }\n  }\n'],['\n  mutation RemoveDeviceTop(\n    $clientLoginId: Int\n    $vehicledeviceid: Int\n    $removeSolutionType: String!\n    $newUniqueDeviceId: String\n    $newSimId: Int\n    $isDeviceAndSimDecoupleNotRequired: Boolean\n    $loginType: String\n    $reason: String\n    $created_by: String\n    $updated_by: String\n  ) {\n    removeDeviceTop(\n      clientLoginId: $clientLoginId\n      vehicledeviceid: $vehicledeviceid\n      removeSolutionType: $removeSolutionType\n      newUniqueDeviceId: $newUniqueDeviceId\n      newSimId: $newSimId\n      isDeviceAndSimDecoupleNotRequired: $isDeviceAndSimDecoupleNotRequired\n      loginType: $loginType\n      reason: $reason\n      created_by: $created_by\n      updated_by: $updated_by\n    ) {\n      success\n      message\n    }\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  mutation vtremovalonboarding(\n    $existingvtid: String\n    $solution_type: String\n    $existinguniqueid: String\n    $created_by: String\n    $updated_by: String\n  ) {\n    vtremovalonboarding(\n      existingvtid: $existingvtid\n      solution_type: $solution_type\n      existinguniqueid: $existinguniqueid\n      created_by: $created_by\n      updated_by: $updated_by\n    ) {\n      success\n      message\n    }\n  }\n'],['\n  mutation vtremovalonboarding(\n    $existingvtid: String\n    $solution_type: String\n    $existinguniqueid: String\n    $created_by: String\n    $updated_by: String\n  ) {\n    vtremovalonboarding(\n      existingvtid: $existingvtid\n      solution_type: $solution_type\n      existinguniqueid: $existinguniqueid\n      created_by: $created_by\n      updated_by: $updated_by\n    ) {\n      success\n      message\n    }\n  }\n']),_templateObject8=_taggedTemplateLiteral(['\n  mutation UpdateVehicleSolutionType(\n    $clientLoginId: Int\n    $vehicledeviceid: Int\n    $solutionType: String\n    $solution_type: [String]!\n    $reason: String\n    $created_by: String\n    $updated_by: String\n  ) {\n    updateVehicleSolutionType(\n      clientLoginId: $clientLoginId\n      vehicledeviceid: $vehicledeviceid\n      solutionType: $solutionType\n      solution_type: $solution_type\n      reason: $reason\n      created_by: $created_by\n      updated_by: $updated_by\n    ) {\n      success\n      message\n    }\n  }\n'],['\n  mutation UpdateVehicleSolutionType(\n    $clientLoginId: Int\n    $vehicledeviceid: Int\n    $solutionType: String\n    $solution_type: [String]!\n    $reason: String\n    $created_by: String\n    $updated_by: String\n  ) {\n    updateVehicleSolutionType(\n      clientLoginId: $clientLoginId\n      vehicledeviceid: $vehicledeviceid\n      solutionType: $solutionType\n      solution_type: $solution_type\n      reason: $reason\n      created_by: $created_by\n      updated_by: $updated_by\n    ) {\n      success\n      message\n    }\n  }\n']);function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// Same literal solution codes that participate in the OBD > Fuel > VT device-tier model on the
// backend (addDeviceTop / removeDeviceTop). Anything else in solution_type is an independent
// product code that never drives a device replacement.
var TIER_SOLUTION_CODES=new Set(['obd_solution','fuel_solution','video_telematics','obd_fuel+fuel_solution','obd_solution+fuel_solution','fuel+vt','obd+vt','fuel+obd+vt']);// Normalizes a possibly-mixed solution_type array (atomic codes and/or legacy combo codes like
// "obd_fuel+fuel_solution" stored as a single element) into obd/fuel/vt capability booleans, so
// both representations of "this vehicle has obd+fuel" collapse to the same picker options.
var getCapabilityFlags=function getCapabilityFlags(arr){var flags={obd:false,fuel:false,vt:false};if(!Array.isArray(arr))return flags;arr.forEach(function(code){if(code==='obd_solution'||code==='obd_fuel+fuel_solution'||code==='obd_solution+fuel_solution'||code==='obd+vt'||code==='fuel+obd+vt'){flags.obd=true;}if(code==='fuel_solution'||code==='obd_fuel+fuel_solution'||code==='obd_solution+fuel_solution'||code==='fuel+vt'||code==='fuel+obd+vt'){flags.fuel=true;}if(code==='video_telematics'||code==='fuel+vt'||code==='obd+vt'||code==='fuel+obd+vt'){flags.vt=true;}});return flags;};// OBD > Fuel > none/VT - same priority ladder addDeviceTop/removeDeviceTop use on the backend.
var requiredDeviceTier=function requiredDeviceTier(flags){if(flags.obd)return'obd';if(flags.fuel)return'fuel';return'none';};var SolutionOption=function SolutionOption(props){var onSelect=props.onSelect,onFocus=props.onFocus,isSelected=props.isSelected,option=props.option,children=props.children,className=props.className;var handleMouseDown=function handleMouseDown(event){event.preventDefault();event.stopPropagation();onSelect(option,event);};var handleMouseEnter=function handleMouseEnter(event){onFocus(option,event);};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:className,onMouseDown:handleMouseDown,onMouseEnter:handleMouseEnter,onMouseMove:handleMouseEnter,style:{display:'flex',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Checkbox___default.a,{checked:!!isSelected,color:'primary'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,children));};var GET_CLIENTS=Object(__WEBPACK_IMPORTED_MODULE_15_graphql_tag__["a" /* default */])(_templateObject);var GET_VEHICLES=Object(__WEBPACK_IMPORTED_MODULE_15_graphql_tag__["a" /* default */])(_templateObject2);var GET_SOLUTION_TYPES=Object(__WEBPACK_IMPORTED_MODULE_15_graphql_tag__["a" /* default */])(_templateObject3);// Query to fetch available devices assigned to the selected customer
var GET_AVAILABLE_DEVICES=Object(__WEBPACK_IMPORTED_MODULE_15_graphql_tag__["a" /* default */])(_templateObject4);// Query to fetch available SIMs (phone numbers) assigned to the selected customer
var GET_AVAILABLE_SIMS=Object(__WEBPACK_IMPORTED_MODULE_15_graphql_tag__["a" /* default */])(_templateObject5);var REMOVE_DEVICE_TOP=Object(__WEBPACK_IMPORTED_MODULE_15_graphql_tag__["a" /* default */])(_templateObject6);var VT_REMOVAL_ONBOARDING=Object(__WEBPACK_IMPORTED_MODULE_15_graphql_tag__["a" /* default */])(_templateObject7);var UPDATE_VEHICLE_SOLUTION_TYPE=Object(__WEBPACK_IMPORTED_MODULE_15_graphql_tag__["a" /* default */])(_templateObject8);var styles=function styles(theme){return{root:{padding:24,marginTop:24,backgroundColor:'#fafafa',minHeight:'100vh'},paper:{padding:24,marginBottom:20,borderRadius:8,boxShadow:'0 2px 8px rgba(0,0,0,0.08)'},formControl:{marginTop:8,width:'100%'},selectBox:{width:'100%'},sectionTitle:{fontWeight:600,marginBottom:16,color:'#2c3e50'},vehicleCard:{background:'#ffffff',padding:16,borderRadius:8,border:'1px solid #e0e0e0',boxShadow:'0 1px 4px rgba(0,0,0,0.06)'},infoRow:{display:'flex',alignItems:'center',padding:'8px 0',borderBottom:'1px solid #f0f0f0','&:last-child':{borderBottom:'none'}},infoLabel:{fontWeight:600,color:'#555',minWidth:160,fontSize:13},infoValue:{color:'#222',fontSize:13},solutionChip:{display:'inline-block',padding:'3px 10px',borderRadius:20,background:'#e3f2fd',color:'#1565c0',border:'1px solid #90caf9',marginRight:6,marginTop:4,fontSize:12,fontWeight:500},warningBox:{backgroundColor:'#fff3e0',border:'1px solid #ff9800',borderRadius:6,padding:'10px 16px',marginBottom:16,display:'flex',alignItems:'center',gap:8},blockedBox:{backgroundColor:'#ffebee',border:'1px solid #ef9a9a',borderRadius:6,padding:'12px 16px',display:'flex',alignItems:'center',gap:8},submitBtn:{minWidth:170,height:40,backgroundColor:'#c62828',color:'#fff','&:hover':{backgroundColor:'#7f0000'},'&:disabled':{backgroundColor:'#bdbdbd',color:'#fff'}},cancelBtn:{minWidth:120,height:40,marginRight:10}};};var SolutionWiseUnregistration=function(_Component){_inherits(SolutionWiseUnregistration,_Component);function SolutionWiseUnregistration(props){_classCallCheck(this,SolutionWiseUnregistration);var _this=_possibleConstructorReturn(this,(SolutionWiseUnregistration.__proto__||Object.getPrototypeOf(SolutionWiseUnregistration)).call(this,props));_this.handleTabChange=function(event,activeTab){if(!activeTab)return;_this.setState({activeTab:activeTab,selectedCustomer:null,selectedVehicle:null,selectedRemovals:[],reason:'',selectedNewDevice:null,selectedNewSimId:null,updateSelectedSolutionTypes:[],updateSolutionType:'',updateReason:''});};_this.handleCustomerChange=function(selectedCustomer){_this.setState({selectedCustomer:selectedCustomer,selectedVehicle:null,selectedRemovals:[],reason:'',selectedNewDevice:null,selectedNewSimId:null,updateSelectedSolutionTypes:[],updateSolutionType:'',updateReason:''});};_this.handleVehicleChange=function(selectedVehicle){var existingSolutions=selectedVehicle&&Array.isArray(selectedVehicle.solution_type)?selectedVehicle.solution_type:[];_this.setState({selectedVehicle:selectedVehicle,selectedRemovals:[],reason:'',selectedNewDevice:null,selectedNewSimId:null,// Update Solution Type tab pre-fills from the vehicle's current solution_type, mirroring
// how Vehicle Edit shows what's currently set.
updateSelectedSolutionTypes:existingSolutions,updateSolutionType:selectedVehicle?selectedVehicle.solutionType||'':'',updateReason:''});};_this.handleRemovalsChange=function(selectedRemovals){_this.setState({selectedRemovals:selectedRemovals||[],selectedNewDevice:null,selectedNewSimId:null});};_this.handleNewDeviceChange=function(selectedOption){_this.setState({selectedNewDevice:selectedOption});};_this.handleNewSimChange=function(selectedOption){_this.setState({selectedNewSimId:selectedOption?selectedOption.value:null});};_this.computeNeedsReplacement=function(existingFlags,removingCodes){if(!removingCodes||removingCodes.length===0)return false;var removingFlags={obd:removingCodes.includes('obd_solution'),fuel:removingCodes.includes('fuel_solution'),vt:removingCodes.includes('video_telematics')};var remainingFlags={obd:existingFlags.obd&&!removingFlags.obd,fuel:existingFlags.fuel&&!removingFlags.fuel,vt:existingFlags.vt&&!removingFlags.vt};return requiredDeviceTier(existingFlags)!==requiredDeviceTier(remainingFlags);};_this.handleSubmitClick=function(removableOptionsCount){var _this$state=_this.state,selectedCustomer=_this$state.selectedCustomer,selectedVehicle=_this$state.selectedVehicle,selectedRemovals=_this$state.selectedRemovals,reason=_this$state.reason,selectedNewDevice=_this$state.selectedNewDevice,selectedNewSimId=_this$state.selectedNewSimId;if(!selectedCustomer||!selectedVehicle||!selectedRemovals||selectedRemovals.length===0){_this.setState({alertDialogOpen:true,alertDialogTitle:'Validation Error',alertDialogMessage:'Please select a vehicle and at least one solution type to unregister'});return;}if(!reason||!reason.trim()){_this.setState({alertDialogOpen:true,alertDialogTitle:'Validation Error',alertDialogMessage:'Please provide a reason for unregistration'});return;}if(selectedRemovals.length>=removableOptionsCount){_this.setState({alertDialogOpen:true,alertDialogTitle:'Validation Error',alertDialogMessage:'Cannot unregister all solution types on this vehicle. At least one must remain - use Vehicle Unregistration to fully unregister the vehicle instead.'});return;}var existingSolutions=Array.isArray(selectedVehicle.solution_type)?selectedVehicle.solution_type:[];var existingFlags=getCapabilityFlags(existingSolutions);var removingCodes=selectedRemovals.map(function(r){return r.value;});var needsReplacement=_this.computeNeedsReplacement(existingFlags,removingCodes);if(needsReplacement&&(!selectedNewDevice||!selectedNewSimId)){_this.setState({alertDialogOpen:true,alertDialogTitle:'Validation Error',alertDialogMessage:'Removing this solution requires downgrading the GPS device. Please select a replacement device and SIM.'});return;}var solutionLabels=selectedRemovals.map(function(r){return r.label;}).join(', ');var replacementNote=needsReplacement?' This will also replace the existing device with '+selectedNewDevice.value+' and SIM '+selectedNewSimId+'.':'';var vtNote=removingCodes.includes('video_telematics')?' The Video Telematics ID assigned to this vehicle will also be unregistered.':'';_this.setState({confirmDialogOpen:true,confirmDialogMessage:'Are you sure you want to unregister '+solutionLabels+' from '+selectedVehicle.label+'?'+replacementNote+vtNote});};_this.executeSubmit=function(){var _this$state2=_this.state,selectedCustomer=_this$state2.selectedCustomer,selectedVehicle=_this$state2.selectedVehicle,selectedRemovals=_this$state2.selectedRemovals,reason=_this$state2.reason,selectedNewDevice=_this$state2.selectedNewDevice,selectedNewSimId=_this$state2.selectedNewSimId;var existingSolutions=Array.isArray(selectedVehicle.solution_type)?selectedVehicle.solution_type:[];var existingFlags=getCapabilityFlags(existingSolutions);var removingCodes=selectedRemovals.map(function(r){return r.value;});var needsReplacement=_this.computeNeedsReplacement(existingFlags,removingCodes);_this.setState({confirmDialogOpen:false});if(!_this.pendingMutate)return;_this.pendingMutate({variables:{clientLoginId:selectedCustomer.value,vehicledeviceid:parseInt(selectedVehicle.entityId,10),removeSolutionType:removingCodes.join('+'),newUniqueDeviceId:needsReplacement?selectedNewDevice.value:null,newSimId:needsReplacement?selectedNewSimId:null,isDeviceAndSimDecoupleNotRequired:false,loginType:localStorage.getItem('Account_type')||'PA',reason:reason.trim(),created_by:localStorage.getItem('username'),updated_by:localStorage.getItem('username')}}).then(function(result){var _result$data$removeDe=result.data.removeDeviceTop,success=_result$data$removeDe.success,message=_result$data$removeDe.message;if(success){_this.setState({alertDialogOpen:true,alertDialogTitle:'Success',alertDialogMessage:message||'Solution unregistered successfully!',selectedCustomer:null,selectedVehicle:null,selectedRemovals:[],reason:'',selectedNewDevice:null,selectedNewSimId:null});}else{_this.setState({alertDialogOpen:true,alertDialogTitle:'Error',alertDialogMessage:message||'Failed to unregister the solution'});}}).catch(function(error){console.error('Solution unregistration error:',error);var errorMessage=error.graphQLErrors&&error.graphQLErrors.length>0?error.graphQLErrors[0].message:error.message||'Failed to unregister the solution';_this.setState({alertDialogOpen:true,alertDialogTitle:'Error',alertDialogMessage:errorMessage});});};_this.handleVtSubmitClick=function(){var _this$state3=_this.state,selectedCustomer=_this$state3.selectedCustomer,selectedVehicle=_this$state3.selectedVehicle;if(!selectedCustomer||!selectedVehicle){_this.setState({alertDialogOpen:true,alertDialogTitle:'Validation Error',alertDialogMessage:'Please select a vehicle'});return;}if(!selectedVehicle.videoTelematicsId){_this.setState({alertDialogOpen:true,alertDialogTitle:'Validation Error',alertDialogMessage:'Selected vehicle has no Video Telematics ID to unregister'});return;}_this.setState({vtConfirmDialogOpen:true});};_this.executeVtSubmit=function(){var selectedVehicle=_this.state.selectedVehicle;_this.setState({vtConfirmDialogOpen:false});if(!_this.pendingVtMutate)return;_this.pendingVtMutate({variables:{existingvtid:selectedVehicle.videoTelematicsId,solution_type:Array.isArray(selectedVehicle.solution_type)?selectedVehicle.solution_type.join(','):selectedVehicle.solution_type||null,existinguniqueid:selectedVehicle.deviceDetail&&selectedVehicle.deviceDetail.uniqueDeviceId,created_by:localStorage.getItem('username'),updated_by:localStorage.getItem('username')}}).then(function(result){var _result$data$vtremova=result.data.vtremovalonboarding,success=_result$data$vtremova.success,message=_result$data$vtremova.message;_this.setState(Object.assign({alertDialogOpen:true,alertDialogTitle:success?'Success':'Error',alertDialogMessage:message||(success?'VT ID unregistered successfully!':'Failed to unregister VT ID')},success?{selectedCustomer:null,selectedVehicle:null}:{}));}).catch(function(error){console.error('VT unregistration error:',error);var errorMessage=error.graphQLErrors&&error.graphQLErrors.length>0?error.graphQLErrors[0].message:error.message||'Failed to unregister VT ID';_this.setState({alertDialogOpen:true,alertDialogTitle:'Error',alertDialogMessage:errorMessage});});};_this.closeVtConfirmDialog=function(){_this.setState({vtConfirmDialogOpen:false});};_this.handleUpdateSolutionTypesChange=function(selected){if(!selected){_this.setState({updateSelectedSolutionTypes:[],updateSolutionType:''});return;}var selectedCodes=selected.map(function(opt){return opt.code;});var legacySolutionType=_this.computeLegacySolutionType(selectedCodes);_this.setState({updateSelectedSolutionTypes:selectedCodes,updateSolutionType:legacySolutionType});};_this.handleUpdateSubmitClick=function(){var _this$state4=_this.state,selectedCustomer=_this$state4.selectedCustomer,selectedVehicle=_this$state4.selectedVehicle,updateSelectedSolutionTypes=_this$state4.updateSelectedSolutionTypes,updateReason=_this$state4.updateReason;if(!selectedCustomer||!selectedVehicle){_this.setState({alertDialogOpen:true,alertDialogTitle:'Validation Error',alertDialogMessage:'Please select a vehicle'});return;}if(!updateSelectedSolutionTypes||updateSelectedSolutionTypes.length===0){_this.setState({alertDialogOpen:true,alertDialogTitle:'Validation Error',alertDialogMessage:'Please select at least one solution type'});return;}if(!updateReason||!updateReason.trim()){_this.setState({alertDialogOpen:true,alertDialogTitle:'Validation Error',alertDialogMessage:'Please provide a reason for updating the solution type'});return;}_this.setState({updateConfirmDialogOpen:true});};_this.executeUpdateSubmit=function(){var _this$state5=_this.state,selectedCustomer=_this$state5.selectedCustomer,selectedVehicle=_this$state5.selectedVehicle,updateSelectedSolutionTypes=_this$state5.updateSelectedSolutionTypes,updateSolutionType=_this$state5.updateSolutionType,updateReason=_this$state5.updateReason;_this.setState({updateConfirmDialogOpen:false});if(!_this.pendingUpdateMutate)return;_this.pendingUpdateMutate({variables:{clientLoginId:selectedCustomer.value,vehicledeviceid:parseInt(selectedVehicle.entityId,10),solutionType:updateSolutionType,solution_type:updateSelectedSolutionTypes,reason:updateReason.trim(),created_by:localStorage.getItem('username'),updated_by:localStorage.getItem('username')}}).then(function(result){var _result$data$updateVe=result.data.updateVehicleSolutionType,success=_result$data$updateVe.success,message=_result$data$updateVe.message;_this.setState(Object.assign({alertDialogOpen:true,alertDialogTitle:success?'Success':'Error',alertDialogMessage:message||(success?'Solution type updated successfully!':'Failed to update solution type')},success?{selectedCustomer:null,selectedVehicle:null,updateSelectedSolutionTypes:[],updateSolutionType:'',updateReason:''}:{}));}).catch(function(error){console.error('Update solution type error:',error);var errorMessage=error.graphQLErrors&&error.graphQLErrors.length>0?error.graphQLErrors[0].message:error.message||'Failed to update solution type';_this.setState({alertDialogOpen:true,alertDialogTitle:'Error',alertDialogMessage:errorMessage});});};_this.closeUpdateConfirmDialog=function(){_this.setState({updateConfirmDialogOpen:false});};_this.closeConfirmDialog=function(){_this.setState({confirmDialogOpen:false});};_this.closeAlertDialog=function(){_this.setState({alertDialogOpen:false});};_this.state={activeTab:'unregister',selectedCustomer:null,selectedVehicle:null,// Tab 1 - Solution-Wise Unregistration
selectedRemovals:[],reason:'',selectedNewDevice:null,selectedNewSimId:null,// Tab 2 - VT ID Unregistration
vtConfirmDialogOpen:false,// Tab 3 - Update Solution Type
updateSelectedSolutionTypes:[],updateSolutionType:'',updateReason:'',updateConfirmDialogOpen:false,confirmDialogOpen:false,confirmDialogMessage:'',alertDialogOpen:false,alertDialogMessage:'',alertDialogTitle:''};return _this;}// ───────────────────────── Tab 1: Solution-Wise Unregistration ─────────────────────────
// Recomputes the same before/after device-tier comparison the backend uses, so the UI can
// require a replacement device+SIM up front instead of failing only after submit.
// ───────────────────────── Tab 2: VT ID Unregistration ─────────────────────────
_createClass(SolutionWiseUnregistration,[{key:'computeLegacySolutionType',// ───────────────────────── Tab 3: Update Solution Type ─────────────────────────
// Compute legacy solutionType string from new solution_type array codes - ported verbatim from
// Vehicle Registration (VehicleRegistartion/index.jsx computeLegacySolutionType) so a vehicle's
// solutionType is always derived the same way regardless of where it's edited from.
value:function computeLegacySolutionType(solutionCodes){var codeToMaster={fuel:'fuel_solution',obd:'obd_solution',vt:'video_telematics',obdanalogsolution:'obd_analog_solution',basic_tracking:'basic_tracking',ais_140:'ais_140',asset_tracking:'Asset Tracking',control_tower:'control_tower',testing_vehicle:'testing_vehicle','fuel+vt':'fuel+vt','obd+vt':'obd+vt','fuel+obd+vt':'fuel+obd+vt',reverse_camera_screen:'reverse_camera_screen'};if(!solutionCodes||solutionCodes.length===0){return'';}if(solutionCodes.length===1){var code=solutionCodes[0];return codeToMaster[code]||code;}var hasFuel=solutionCodes.includes('fuel_solution');var hasObd=solutionCodes.includes('obd_solution');var hasVt=solutionCodes.includes('video_telematics');if(hasFuel&&hasObd&&hasVt){return'fuel+obd+vt';}if(hasFuel&&hasVt){return'fuel+vt';}if(hasObd&&hasVt){return'obd+vt';}if(hasFuel&&hasObd){return'obd_fuel+fuel_solution';}if(hasVt){if(hasFuel)return'fuel+vt';if(hasObd)return'obd+vt';}var firstCode=solutionCodes[0];return codeToMaster[firstCode]||firstCode;}// ───────────────────────── Shared ─────────────────────────
},{key:'renderCustomerVehicleSelectors',value:function renderCustomerVehicleSelectors(classes,vehicleFilter){var _this2=this;var _state=this.state,selectedCustomer=_state.selectedCustomer,selectedVehicle=_state.selectedVehicle;var partnerLoginId=Object(__WEBPACK_IMPORTED_MODULE_17__utils_getLoginId__["a" /* default */])();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Paper___default.a,{className:classes.paper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,spacing:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default.a,{className:classes.formControl,fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormGroup___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'subtitle1',gutterBottom:true},'Select Customer *'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_apollo__["Query"],{query:GET_CLIENTS,variables:{partnerLoginId:partnerLoginId}},function(_ref){var loading=_ref.loading,error=_ref.error,data=_ref.data;if(loading)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core__["CircularProgress"],{size:24});if(error)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Error loading customers');var customerOptions=data.clients.map(function(client){return Object.assign({value:client.loginId,label:client.clientName},client);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */],{value:selectedCustomer,onChange:_this2.handleCustomerChange,options:customerOptions,placeholder:'Select a customer',className:classes.selectBox});})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default.a,{className:classes.formControl,fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormGroup___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'subtitle1',gutterBottom:true},'Select Vehicle *'),selectedCustomer?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_apollo__["Query"],{query:GET_VEHICLES,variables:{clientLoginId:selectedCustomer.value}},function(_ref2){var loading=_ref2.loading,error=_ref2.error,data=_ref2.data;if(loading)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core__["CircularProgress"],{size:24});if(error)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Error loading vehicles');var vehicleOptions=data.getAllVehicleDetails.map(function(vehicle){return Object.assign({value:vehicle.entityId,label:vehicle.vehicleNumber},vehicle);});if(vehicleFilter){vehicleOptions=vehicleOptions.filter(vehicleFilter);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */],{value:selectedVehicle,onChange:_this2.handleVehicleChange,options:vehicleOptions,placeholder:'Select a vehicle',className:classes.selectBox});}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{color:'#666',padding:'8px'}},'Please select a customer first'))))));}},{key:'renderUnregisterTab',value:function renderUnregisterTab(classes){var _this3=this;var _state2=this.state,selectedCustomer=_state2.selectedCustomer,selectedVehicle=_state2.selectedVehicle,selectedRemovals=_state2.selectedRemovals,reason=_state2.reason,selectedNewDevice=_state2.selectedNewDevice,selectedNewSimId=_state2.selectedNewSimId;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.renderCustomerVehicleSelectors(classes),selectedVehicle&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_apollo__["Query"],{query:GET_SOLUTION_TYPES},function(_ref3){var solLoading=_ref3.loading,solError=_ref3.error,solData=_ref3.data;if(solLoading)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Paper___default.a,{className:classes.paper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core__["CircularProgress"],{size:24}));if(solError)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Paper___default.a,{className:classes.paper},'Error loading solution types');var masterSolutionTypes=solData.getAllMasterSolutionType||[];// Same label source the Solution Topup dropdown uses - getAllMasterSolutionType's
// solutionTypeName - so a code reads identically ("OBD Solution") in both places.
var masterLabel=function masterLabel(code){var master=masterSolutionTypes.find(function(s){return s.id===code;});return master?master.solutionTypeName:code;};var existingSolutions=Array.isArray(selectedVehicle.solution_type)?selectedVehicle.solution_type:[];var existingFlags=getCapabilityFlags(existingSolutions);var otherExisting=[].concat(_toConsumableArray(new Set(existingSolutions.filter(function(c){return c&&!TIER_SOLUTION_CODES.has(c);}))));var removableOptions=[];if(existingFlags.obd)removableOptions.push({value:'obd_solution',label:masterLabel('obd_solution')});if(existingFlags.fuel)removableOptions.push({value:'fuel_solution',label:masterLabel('fuel_solution')});if(existingFlags.vt)removableOptions.push({value:'video_telematics',label:masterLabel('video_telematics')});otherExisting.forEach(function(code){removableOptions.push({value:code,label:masterLabel(code)});});var onlyOneSolution=removableOptions.length<=1;var removingCodes=selectedRemovals.map(function(r){return r.value;});var needsReplacement=_this3.computeNeedsReplacement(existingFlags,removingCodes);// Selecting every remaining solution (not just the single-solution case above) would
// leave the vehicle with none - block that here too, not just at submit time.
var wouldRemoveAll=selectedRemovals.length>0&&selectedRemovals.length>=removableOptions.length;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Paper___default.a,{className:classes.paper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'h6',className:classes.sectionTitle},'Vehicle Details'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.vehicleCard},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.infoRow},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classes.infoLabel},'Vehicle Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classes.infoValue},selectedVehicle.vehicleNumber)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.infoRow},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classes.infoLabel},'Device Unique ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classes.infoValue,style:{fontFamily:'monospace',fontSize:12}},selectedVehicle.deviceDetail&&selectedVehicle.deviceDetail.uniqueDeviceId||'Not Installed')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.infoRow},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classes.infoLabel},'Existing Solutions'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classes.infoValue},existingSolutions.length>0?existingSolutions.map(function(sol,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:i,className:classes.solutionChip},sol);}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#999',fontSize:12}},'No solutions assigned'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Paper___default.a,{className:classes.paper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'h6',gutterBottom:true},'Remove Solution Type'),onlyOneSolution?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.blockedBox},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Icon___default.a,{style:{color:'#c62828',fontSize:22}},'block'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'body2',style:{color:'#c62828',fontWeight:500}},'This vehicle has only one solution type (',removableOptions[0]?removableOptions[0].label:'none','). It cannot be unregistered here - use Vehicle Unregistration to fully unregister the vehicle instead.')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,spacing:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default.a,{className:classes.formControl,fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormGroup___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'subtitle1',gutterBottom:true},'Solution Type(s) to Remove *'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */],{id:'remove_solution_type',name:'remove_solution_type',options:removableOptions.filter(function(opt){var alreadySelected=selectedRemovals.some(function(r){return r.value===opt.value;});if(alreadySelected)return true;// Don't offer an option whose selection would leave the vehicle
// with no solution type at all.
return selectedRemovals.length+1<removableOptions.length;}),value:selectedRemovals,multi:true,optionComponent:SolutionOption,closeOnSelect:false,removeSelected:false,onChange:_this3.handleRemovalsChange,placeholder:'Select solution type(s) to unregister',className:classes.selectBox}),wouldRemoveAll&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.blockedBox,style:{marginTop:12}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_Icon___default.a,{style:{color:'#c62828',fontSize:22}},'block'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'body2',style:{color:'#c62828',fontWeight:500}},'This would remove every solution type on this vehicle. At least one must remain - deselect one, or use Vehicle Unregistration to fully unregister the vehicle instead.')))))),needsReplacement&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,spacing:3,style:{marginTop:16}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'caption',style:{color:'#f57c00',display:'block',marginBottom:4}},'Note: Removing the selected solution type lowers the existing device id tier this vehicle needs. Replacing the device also requires replacing the SIM.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default.a,{className:classes.formControl,fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormGroup___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'subtitle1',gutterBottom:true},'Select New Device ID *'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_apollo__["Query"],{query:GET_AVAILABLE_DEVICES,variables:{clientId:selectedCustomer.value},fetchPolicy:'network-only'},function(_ref4){var devicesLoading=_ref4.loading,devicesError=_ref4.error,devicesData=_ref4.data;if(devicesLoading)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core__["CircularProgress"],{size:24});if(devicesError)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Error loading available devices');var devices=devicesData&&devicesData.device?devicesData.device:[];var deviceOptions=devices.map(function(device){return{value:device.uniqueDeviceId,label:device.uniqueDeviceId,model:device.deviceModel?device.deviceModel.model_name:null};});var currentDeviceId=selectedVehicle.deviceDetail&&selectedVehicle.deviceDetail.uniqueDeviceId;var filteredOptions=currentDeviceId?deviceOptions.filter(function(opt){return opt.value!==currentDeviceId;}):deviceOptions;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */],{value:selectedNewDevice,onChange:_this3.handleNewDeviceChange,options:filteredOptions,placeholder:'Choose a new device ID',className:classes.selectBox,isClearable:true});})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,sm:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default.a,{className:classes.formControl,fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormGroup___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'subtitle1',gutterBottom:true},'Select New Phone Number *'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_apollo__["Query"],{query:GET_AVAILABLE_SIMS,variables:{clientId:selectedCustomer.value},fetchPolicy:'network-only'},function(_ref5){var simsLoading=_ref5.loading,simsError=_ref5.error,simsData=_ref5.data;if(simsLoading)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core__["CircularProgress"],{size:24});if(simsError)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Error loading available SIMs');var sims=simsData&&simsData.simDetails?simsData.simDetails:[];var simOptions=sims.filter(function(sim){return sim.sim;}).map(function(sim){return{value:sim.simId,label:sim.sim.phoneNumber};});var selectedSimOption=selectedNewSimId?simOptions.find(function(opt){return opt.value===selectedNewSimId;}):null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */],{value:selectedSimOption,onChange:_this3.handleNewSimChange,options:simOptions,placeholder:'Choose a phone number',className:classes.selectBox,isClearable:true});}))))),selectedRemovals.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,spacing:2,style:{marginTop:16},alignItems:'flex-end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{label:'Reason for Unregistration *',placeholder:'Enter reason for unregistering this solution...',value:reason,onChange:function onChange(e){return _this3.setState({reason:e.target.value});},multiline:true,rows:2,fullWidth:true,variant:'outlined',size:'small'}))))),!onlyOneSolution&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Paper___default.a,{className:classes.paper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,justify:'flex-end',alignItems:'center',spacing:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_apollo__["Mutation"],{mutation:REMOVE_DEVICE_TOP},function(removeDeviceTop,_ref6){var loading=_ref6.loading;_this3.pendingMutate=removeDeviceTop;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button___default.a,{variant:'contained',className:classes.submitBtn,onClick:function onClick(){return _this3.handleSubmitClick(removableOptions.length);},disabled:loading||!selectedRemovals||selectedRemovals.length===0||wouldRemoveAll||!reason.trim()||needsReplacement&&(!selectedNewDevice||!selectedNewSimId)},loading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core__["CircularProgress"],{size:20,style:{color:'#fff'}}):'Unregister Solution');})))));}));}},{key:'renderVtRemovalTab',value:function renderVtRemovalTab(classes){var _this4=this;var selectedVehicle=this.state.selectedVehicle;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Paper___default.a,{className:classes.paper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'body2',style:{color:'#666'}},'This removes only the Video Telematics (VT) ID assigned to the vehicle - the vehicle\'s unique ID is not affected. To fully unregister the vehicle, use Vehicle Unregistration instead.')),this.renderCustomerVehicleSelectors(classes,function(v){return v.videoTelematicsId;}),selectedVehicle&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Paper___default.a,{className:classes.paper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'h6',className:classes.sectionTitle},'Vehicle Details'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.vehicleCard},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.infoRow},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classes.infoLabel},'Vehicle Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classes.infoValue},selectedVehicle.vehicleNumber)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.infoRow},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classes.infoLabel},'Video Telematics Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classes.infoValue},selectedVehicle.videoTelematicsType||'N/A')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.infoRow},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classes.infoLabel},'Video Telematics ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classes.infoValue,style:{fontFamily:'monospace',fontSize:12}},selectedVehicle.videoTelematicsId||'Not Assigned')))),selectedVehicle&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Paper___default.a,{className:classes.paper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,justify:'flex-end',alignItems:'center',spacing:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_apollo__["Mutation"],{mutation:VT_REMOVAL_ONBOARDING},function(vtremovalonboarding,_ref7){var loading=_ref7.loading;_this4.pendingVtMutate=vtremovalonboarding;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button___default.a,{variant:'contained',className:classes.submitBtn,onClick:_this4.handleVtSubmitClick,disabled:loading||!selectedVehicle.videoTelematicsId},loading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core__["CircularProgress"],{size:20,style:{color:'#fff'}}):'Unregister VT ID');})))));}},{key:'renderUpdateSolutionTypeTab',value:function renderUpdateSolutionTypeTab(classes){var _this5=this;var _state3=this.state,selectedVehicle=_state3.selectedVehicle,updateSelectedSolutionTypes=_state3.updateSelectedSolutionTypes,updateReason=_state3.updateReason;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,this.renderCustomerVehicleSelectors(classes),selectedVehicle&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_apollo__["Query"],{query:GET_SOLUTION_TYPES},function(_ref8){var loading=_ref8.loading,error=_ref8.error,data=_ref8.data;if(loading)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Paper___default.a,{className:classes.paper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core__["CircularProgress"],{size:24}));if(error)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Paper___default.a,{className:classes.paper},'Error loading solution types');var solutionTypeMultiOptions=data.getAllMasterSolutionType.map(function(type){return{value:type.id,label:type.solutionTypeName,code:type.id};});var selectedMultiValue=solutionTypeMultiOptions.filter(function(option){return updateSelectedSolutionTypes&&updateSelectedSolutionTypes.includes(option.code);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Paper___default.a,{className:classes.paper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'h6',className:classes.sectionTitle},'Vehicle Details'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.vehicleCard},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.infoRow},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classes.infoLabel},'Vehicle Number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classes.infoValue},selectedVehicle.vehicleNumber)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.infoRow},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classes.infoLabel},'Device Unique ID'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classes.infoValue,style:{fontFamily:'monospace',fontSize:12}},selectedVehicle.deviceDetail&&selectedVehicle.deviceDetail.uniqueDeviceId||'Not Installed')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.infoRow},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classes.infoLabel},'Existing Solutions'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:classes.infoValue},Array.isArray(selectedVehicle.solution_type)&&selectedVehicle.solution_type.length>0?selectedVehicle.solution_type.map(function(sol,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:i,className:classes.solutionChip},sol);}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{color:'#999',fontSize:12}},'No solutions assigned'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Paper___default.a,{className:classes.paper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'h6',gutterBottom:true},'Update Solution Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,spacing:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_FormControl___default.a,{className:classes.formControl,fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormGroup___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'subtitle1',gutterBottom:true},'Solution Type(s) *'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */],{id:'update_solution_type',name:'update_solution_type',options:solutionTypeMultiOptions,value:selectedMultiValue,multi:true,optionComponent:SolutionOption,closeOnSelect:false,removeSelected:false,onChange:_this5.handleUpdateSolutionTypesChange,placeholder:'Select solution type(s)',className:classes.selectBox}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,spacing:2,style:{marginTop:16},alignItems:'flex-end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true,xs:12,sm:9},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_TextField___default.a,{label:'Reason for Update *',placeholder:'Enter reason for updating the solution type...',value:updateReason,onChange:function onChange(e){return _this5.setState({updateReason:e.target.value});},multiline:true,rows:2,fullWidth:true,variant:'outlined',size:'small'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Paper___default.a,{className:classes.paper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{container:true,justify:'flex-end',alignItems:'center',spacing:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_apollo__["Mutation"],{mutation:UPDATE_VEHICLE_SOLUTION_TYPE},function(updateVehicleSolutionType,_ref9){var updateLoading=_ref9.loading;_this5.pendingUpdateMutate=updateVehicleSolutionType;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Button___default.a,{variant:'contained',className:classes.submitBtn,onClick:_this5.handleUpdateSubmitClick,disabled:updateLoading||!updateSelectedSolutionTypes||updateSelectedSolutionTypes.length===0||!updateReason||!updateReason.trim()},updateLoading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_core__["CircularProgress"],{size:20,style:{color:'#fff'}}):'Update Solution Type');})))));}));}},{key:'render',value:function render(){var classes=this.props.classes;var _state4=this.state,activeTab=_state4.activeTab,confirmDialogOpen=_state4.confirmDialogOpen,confirmDialogMessage=_state4.confirmDialogMessage,vtConfirmDialogOpen=_state4.vtConfirmDialogOpen,updateConfirmDialogOpen=_state4.updateConfirmDialogOpen,alertDialogOpen=_state4.alertDialogOpen,alertDialogMessage=_state4.alertDialogMessage,alertDialogTitle=_state4.alertDialogTitle;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Typography___default.a,{variant:'h4',component:'h1',gutterBottom:true,style:{fontWeight:700,marginBottom:20}},'Solution-Wise Unregistration'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_Paper___default.a,{className:classes.paper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Tabs___default.a,{value:activeTab,onChange:this.handleTabChange,indicatorColor:'primary',textColor:'primary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Tab___default.a,{value:'unregister',label:'Solution-Wise Unregistration'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Tab___default.a,{value:'vt',label:'VT ID Unregistration'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_Tab___default.a,{value:'update',label:'Update Solution Type'}))),activeTab==='unregister'&&this.renderUnregisterTab(classes),activeTab==='vt'&&this.renderVtRemovalTab(classes),activeTab==='update'&&this.renderUpdateSolutionTypeTab(classes),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__common_ConfirmationDialog__["a" /* default */],{isDialogOpen:confirmDialogOpen,dialogTitle:'Confirm Solution Unregistration',dialogMessage:confirmDialogMessage,positiveResponseButtonText:'Yes, Unregister',negativeResponseButtonText:'Cancel',positiveResponseHandler:this.executeSubmit,negativeResponseHandler:this.closeConfirmDialog,dialogCloseHandler:this.closeConfirmDialog}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__common_ConfirmationDialog__["a" /* default */],{isDialogOpen:vtConfirmDialogOpen,dialogTitle:'Confirm VT ID Unregistration',dialogMessage:this.state.selectedVehicle?'Are you sure you want to unregister VT ID '+this.state.selectedVehicle.videoTelematicsId+' from '+this.state.selectedVehicle.label+'?':'',positiveResponseButtonText:'Yes, Unregister',negativeResponseButtonText:'Cancel',positiveResponseHandler:this.executeVtSubmit,negativeResponseHandler:this.closeVtConfirmDialog,dialogCloseHandler:this.closeVtConfirmDialog}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__common_ConfirmationDialog__["a" /* default */],{isDialogOpen:updateConfirmDialogOpen,dialogTitle:'Confirm Solution Type Update',dialogMessage:this.state.selectedVehicle?'Are you sure you want to update the solution type for '+this.state.selectedVehicle.label+' to "'+this.state.updateSolutionType+'"?':'',positiveResponseButtonText:'Yes, Update',negativeResponseButtonText:'Cancel',positiveResponseHandler:this.executeUpdateSubmit,negativeResponseHandler:this.closeUpdateConfirmDialog,dialogCloseHandler:this.closeUpdateConfirmDialog}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__common_ConfirmationDialog__["a" /* default */],{isDialogOpen:alertDialogOpen,dialogTitle:alertDialogTitle,dialogMessage:alertDialogMessage,positiveResponseButtonText:'OK',negativeResponseButtonText:'',positiveResponseHandler:this.closeAlertDialog,negativeResponseHandler:this.closeAlertDialog,dialogCloseHandler:this.closeAlertDialog}));}}]);return SolutionWiseUnregistration;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_styles__["withStyles"])(styles)(SolutionWiseUnregistration));

/***/ }),
/* 2458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Paper__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Paper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormControl__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_FormControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormGroup__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_FormGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_select__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Tabs__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Tab__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_graphql_tag__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_apollo__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_getLoginId__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_ConfirmationDialog__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__HOCs_withSharedSnackbar__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query allClientDetails($partnerLoginId: Int) {\n    clients: allClientDetails(partnerLoginId: $partnerLoginId) {\n      id\n      clientName\n      loginId\n    }\n  }\n'],['\n  query allClientDetails($partnerLoginId: Int) {\n    clients: allClientDetails(partnerLoginId: $partnerLoginId) {\n      id\n      clientName\n      loginId\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query getAllVehicleDetailsByStatus($loginId: Int, $status: Int) {\n    vehicles: getAllVehicleDetailsByStatus(\n      partnerLoginId: $loginId\n      status: $status\n    ) {\n      entityId\n      vehicleNumber\n      clientLoginId\n      status\n      deviceDetail {\n        uniqueDeviceId\n      }\n      solutionType\n    }\n  }\n'],['\n  query getAllVehicleDetailsByStatus($loginId: Int, $status: Int) {\n    vehicles: getAllVehicleDetailsByStatus(\n      partnerLoginId: $loginId\n      status: $status\n    ) {\n      entityId\n      vehicleNumber\n      clientLoginId\n      status\n      deviceDetail {\n        uniqueDeviceId\n      }\n      solutionType\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation DeviceShiftOnbaording($solutionType: String!, $customerType: String!, $sourceUniqueId: String, $targetUniqueId: String, $sourceCustomerId: Int, $targetCustomerId: Int, $sourceentityid: Int, $targetentityid: Int, $created_by: String, $updated_by: String) {\n    deviceShiftOnbaording(solutionType: $solutionType, customerType: $customerType, sourceUniqueId: $sourceUniqueId, targetUniqueId: $targetUniqueId, sourceCustomerId: $sourceCustomerId, targetCustomerId: $targetCustomerId, sourceentityid: $sourceentityid, targetentityid: $targetentityid, created_by: $created_by, updated_by: $updated_by) {\n      success\n      message\n    }\n  }\n'],['\n  mutation DeviceShiftOnbaording($solutionType: String!, $customerType: String!, $sourceUniqueId: String, $targetUniqueId: String, $sourceCustomerId: Int, $targetCustomerId: Int, $sourceentityid: Int, $targetentityid: Int, $created_by: String, $updated_by: String) {\n    deviceShiftOnbaording(solutionType: $solutionType, customerType: $customerType, sourceUniqueId: $sourceUniqueId, targetUniqueId: $targetUniqueId, sourceCustomerId: $sourceCustomerId, targetCustomerId: $targetCustomerId, sourceentityid: $sourceentityid, targetentityid: $targetentityid, created_by: $created_by, updated_by: $updated_by) {\n      success\n      message\n    }\n  }\n']);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var styles=function styles(theme){return{root:{padding:24,marginTop:24},paper:{padding:24,marginBottom:16,textAlign:'center',color:theme.palette.text.secondary},formControl:{margin:theme.spacing.unit,minWidth:200},selectBox:{width:'100%'},button:{margin:theme.spacing.unit},existingSubscriptionCard:{padding:16,marginBottom:16,border:'1px solid #e0e0e0',borderRadius:4,textAlign:'left'},subscriptionHeader:{fontWeight:'bold',marginBottom:8,color:theme.palette.primary.main},sectionTitle:{marginBottom:16,textAlign:'left',fontWeight:'bold',color:theme.palette.primary.main},tabPaper:{padding:'32px 24px',marginBottom:16,borderRadius:8,boxShadow:'0 4px 20px rgba(0,0,0,0.08)'},gridHeader:{display:'flex',alignItems:'center',fontWeight:'bold',fontSize:'1.1rem',color:'#333',height:'100%'},fieldGroup:{padding:'8px 0'},fieldLabel:{fontSize:'0.85rem',color:'#666',marginBottom:8,fontWeight:600},readoutBox:{backgroundColor:'#e3f2fd',// Light blue from screenshot
padding:'12px 16px',borderRadius:4,border:'1px solid #bbdefb',fontSize:'0.95rem',color:'#1976d2',fontWeight:500,minHeight:48,display:'flex',alignItems:'center'},divider:{height:1,backgroundColor:'#eee',margin:'24px 0'},shiftButtonContainer:{display:'flex',justifyContent:'flex-end',marginTop:24}};};var GET_CLIENTS=Object(__WEBPACK_IMPORTED_MODULE_12_graphql_tag__["a" /* default */])(_templateObject);var GET_VEHICLES=Object(__WEBPACK_IMPORTED_MODULE_12_graphql_tag__["a" /* default */])(_templateObject2);var DEVICE_SHIFT_MUTATION=Object(__WEBPACK_IMPORTED_MODULE_12_graphql_tag__["a" /* default */])(_templateObject3);var DeviceShift=function(_Component){_inherits(DeviceShift,_Component);function DeviceShift(props){var _this2=this;_classCallCheck(this,DeviceShift);var _this=_possibleConstructorReturn(this,(DeviceShift.__proto__||Object.getPrototypeOf(DeviceShift)).call(this,props));_this.handleShiftModeChange=function(event,shiftMode){if(!shiftMode)return;_this.setState({shiftMode:shiftMode,selectedCustomer:null,selectedTargetCustomer:null,selectedSourceVehicle:null,selectedTargetVehicle:null});};_this.handleCustomerChange=function(selectedCustomer){_this.setState({selectedCustomer:selectedCustomer,selectedSourceVehicle:null});};_this.handleTargetCustomerChange=function(selectedTargetCustomer){_this.setState({selectedTargetCustomer:selectedTargetCustomer});};_this.handleSourceVehicleChange=function(selectedSourceVehicle){_this.setState({selectedSourceVehicle:selectedSourceVehicle});};_this.handleTargetVehicleChange=function(selectedTargetVehicle){_this.setState({selectedTargetVehicle:selectedTargetVehicle});};_this.submitDeviceShift=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _this$state,shiftMode,selectedCustomer,selectedTargetCustomer,selectedSourceVehicle,selectedTargetVehicle,solutionType,sourceUniqueId,targetUniqueId,confirmMessage;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this$state=_this.state,shiftMode=_this$state.shiftMode,selectedCustomer=_this$state.selectedCustomer,selectedTargetCustomer=_this$state.selectedTargetCustomer,selectedSourceVehicle=_this$state.selectedSourceVehicle,selectedTargetVehicle=_this$state.selectedTargetVehicle;solutionType=selectedSourceVehicle&&selectedSourceVehicle.solutionType;if(solutionType){_context.next=5;break;}_this.props.openSnackbar('Source vehicle has no solution type associated');return _context.abrupt('return');case 5:sourceUniqueId=selectedSourceVehicle&&selectedSourceVehicle.deviceDetail&&selectedSourceVehicle.deviceDetail.uniqueDeviceId;targetUniqueId=selectedTargetVehicle&&selectedTargetVehicle.deviceDetail&&selectedTargetVehicle.deviceDetail.uniqueDeviceId;if(!(shiftMode==='same')){_context.next=19;break;}if(!(!sourceUniqueId||!targetUniqueId)){_context.next=11;break;}_this.props.openSnackbar('Both source and target vehicles must have devices');return _context.abrupt('return');case 11:if(selectedCustomer){_context.next=14;break;}_this.props.openSnackbar('Please select a customer');return _context.abrupt('return');case 14:if(!(!selectedSourceVehicle||!selectedTargetVehicle)){_context.next=17;break;}_this.props.openSnackbar('Please select both source and target vehicles');return _context.abrupt('return');case 17:_context.next=28;break;case 19:if(sourceUniqueId){_context.next=22;break;}_this.props.openSnackbar('Source vehicle must have a device');return _context.abrupt('return');case 22:if(!(!selectedCustomer||!selectedTargetCustomer)){_context.next=25;break;}_this.props.openSnackbar('Please select both source and target customers');return _context.abrupt('return');case 25:if(selectedSourceVehicle){_context.next=28;break;}_this.props.openSnackbar('Please select a source vehicle');return _context.abrupt('return');case 28:confirmMessage='';if(shiftMode==='same'){confirmMessage='Are you sure you want to shift device from '+selectedSourceVehicle.vehicleNumber+' to '+selectedTargetVehicle.vehicleNumber+'?';}else{confirmMessage='Are you sure you want to shift device from '+selectedSourceVehicle.vehicleNumber+' (customer: '+selectedCustomer.label+') to the target customer '+selectedTargetCustomer.label+'?';}_this.setState({confirmDialogOpen:true,confirmDialogTitle:'Confirm Device Shift',confirmDialogMessage:confirmMessage,pendingAction:'shift'});case 31:case'end':return _context.stop();}}},_callee,_this2);}));_this.executeDeviceShift=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var _this$state2,shiftMode,selectedCustomer,selectedTargetCustomer,selectedSourceVehicle,selectedTargetVehicle,solutionType,sourceUniqueId,targetUniqueId,targetEntityId,targetCustomerId,_ref3,data,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_this$state2=_this.state,shiftMode=_this$state2.shiftMode,selectedCustomer=_this$state2.selectedCustomer,selectedTargetCustomer=_this$state2.selectedTargetCustomer,selectedSourceVehicle=_this$state2.selectedSourceVehicle,selectedTargetVehicle=_this$state2.selectedTargetVehicle;solutionType=selectedSourceVehicle&&selectedSourceVehicle.solutionType;sourceUniqueId=selectedSourceVehicle&&selectedSourceVehicle.deviceDetail&&selectedSourceVehicle.deviceDetail.uniqueDeviceId;targetUniqueId=null;targetEntityId=null;targetCustomerId=null;if(shiftMode==='same'){targetUniqueId=selectedTargetVehicle&&selectedTargetVehicle.deviceDetail&&selectedTargetVehicle.deviceDetail.uniqueDeviceId;targetEntityId=selectedTargetVehicle&&selectedTargetVehicle.entityId;targetCustomerId=selectedCustomer&&selectedCustomer.value;}else{targetUniqueId=null;targetEntityId=null;targetCustomerId=selectedTargetCustomer&&selectedTargetCustomer.value;}_this.setState({isSubmitting:true,confirmDialogOpen:false});_context2.prev=8;_context2.next=11;return _this.props.client.mutate({mutation:DEVICE_SHIFT_MUTATION,variables:{sourceUniqueId:sourceUniqueId,targetUniqueId:targetUniqueId,solutionType:solutionType,customerType:shiftMode,sourceCustomerId:selectedCustomer&&selectedCustomer.value,targetCustomerId:targetCustomerId,sourceentityid:selectedSourceVehicle&&selectedSourceVehicle.entityId,targetentityid:targetEntityId,created_by:localStorage.getItem('username'),updated_by:localStorage.getItem('username')},errorPolicy:'all'});case 11:_ref3=_context2.sent;data=_ref3.data;response=data&&data.deviceShiftOnbaording;_this.props.openSnackbar(response&&response.message?response.message:'Device shift completed successfully');if(response&&response.success){// Reset form only on success
_this.setState({selectedCustomer:null,selectedTargetCustomer:null,selectedSourceVehicle:null,selectedTargetVehicle:null});}_context2.next=22;break;case 18:_context2.prev=18;_context2.t0=_context2['catch'](8);console.error(_context2.t0);_this.props.openSnackbar('Failed to shift device');case 22:_context2.prev=22;_this.setState({isSubmitting:false});return _context2.finish(22);case 25:case'end':return _context2.stop();}}},_callee2,_this2,[[8,18,22,25]]);}));_this.closeConfirmDialog=function(){_this.setState({confirmDialogOpen:false});};_this.state={shiftMode:'same',// 'same' or 'different'
selectedCustomer:null,selectedTargetCustomer:null,selectedSourceVehicle:null,selectedTargetVehicle:null,isSubmitting:false,confirmDialogOpen:false,confirmDialogMessage:'',confirmDialogTitle:'',pendingAction:null};return _this;}// handleSolutionTypeChange removed
_createClass(DeviceShift,[{key:'render',value:function render(){var _this3=this;var classes=this.props.classes;var _state=this.state,shiftMode=_state.shiftMode,selectedCustomer=_state.selectedCustomer,selectedTargetCustomer=_state.selectedTargetCustomer,selectedSourceVehicle=_state.selectedSourceVehicle,selectedTargetVehicle=_state.selectedTargetVehicle,isSubmitting=_state.isSubmitting,confirmDialogOpen=_state.confirmDialogOpen,confirmDialogMessage=_state.confirmDialogMessage,confirmDialogTitle=_state.confirmDialogTitle;var partnerLoginId=Object(__WEBPACK_IMPORTED_MODULE_14__utils_getLoginId__["a" /* default */])();return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.root},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_Typography___default.a,{variant:'h4',component:'h1',gutterBottom:true,className:classes.sectionTitle},'Device Shift'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Paper___default.a,{className:classes.paper,style:{padding:0,overflow:'hidden',marginBottom:24}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Tabs___default.a,{value:shiftMode,onChange:this.handleShiftModeChange,indicatorColor:'primary',textColor:'primary',variant:'fullWidth'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Tab___default.a,{value:'same',label:'Same Customer'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Tab___default.a,{value:'different',label:'Different Customer'}))),shiftMode==='same'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Paper___default.a,{className:classes.tabPaper},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true,spacing:4,alignItems:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12,md:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.gridHeader},'Customer & Vehicle')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12,md:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.fieldLabel},'Customer *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_apollo__["Query"],{query:GET_CLIENTS,variables:{partnerLoginId:partnerLoginId}},function(_ref4){var loading=_ref4.loading,error=_ref4.error,data=_ref4.data;if(loading)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Loading...');if(error)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Error loading customers');var customerOptions=(data.clients||[]).map(function(client){return Object.assign({value:client.loginId,label:client.clientName},client);});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */],{value:selectedCustomer,onChange:_this3.handleCustomerChange,options:customerOptions,placeholder:'Select a customer',className:classes.selectBox});})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12,md:5},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.fieldLabel},'Source Vehicle *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_apollo__["Query"],{query:GET_VEHICLES,variables:{loginId:partnerLoginId,status:1}},function(_ref5){var loading=_ref5.loading,error=_ref5.error,data=_ref5.data;if(loading)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */],{placeholder:'Loading...',disabled:true});if(error)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Error loading vehicles');var filteredVehicles=(data.vehicles||[]).filter(function(v){return v&&v.clientLoginId===(selectedCustomer?selectedCustomer.value:null);});var vehicleOptions=filteredVehicles.map(function(vehicle){return Object.assign({value:vehicle.entityId,label:vehicle.vehicleNumber},vehicle);});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */],{value:selectedSourceVehicle,onChange:_this3.handleSourceVehicleChange,options:vehicleOptions,placeholder:'Select source vehicle',className:classes.selectBox,disabled:!selectedCustomer});}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true,spacing:4,style:{marginTop:8}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12,md:3}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12,md:9},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.fieldLabel},'Source vehicle device id'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.readoutBox},selectedSourceVehicle&&selectedSourceVehicle.deviceDetail?selectedSourceVehicle.deviceDetail.uniqueDeviceId+' '+(selectedSourceVehicle.solutionType?'('+selectedSourceVehicle.solutionType.toUpperCase()+')':''):'No device associated'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.divider}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true,spacing:4,alignItems:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12,md:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.gridHeader},'Target Vehicle')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12,md:4}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12,md:5},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.fieldLabel},'Target Vehicle *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_apollo__["Query"],{query:GET_VEHICLES,variables:{loginId:partnerLoginId,status:1}},function(_ref6){var loading=_ref6.loading,error=_ref6.error,data=_ref6.data;if(loading)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */],{placeholder:'Loading...',disabled:true});if(error)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Error loading vehicles');var filteredVehicles=(data.vehicles||[]).filter(function(v){return v&&v.clientLoginId===(selectedCustomer?selectedCustomer.value:null);});var vehicleOptions=filteredVehicles.map(function(vehicle){return Object.assign({value:vehicle.entityId,label:vehicle.vehicleNumber},vehicle);});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */],{value:selectedTargetVehicle,onChange:_this3.handleTargetVehicleChange,options:vehicleOptions,placeholder:'Select target vehicle',className:classes.selectBox,disabled:!selectedCustomer});}))),selectedCustomer&&selectedSourceVehicle&&selectedTargetVehicle&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.shiftButtonContainer},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{variant:'contained',color:'primary',size:'large',disabled:isSubmitting,onClick:this.submitDeviceShift,className:classes.button},isSubmitting?'Processing...':'Shift'))),shiftMode==='different'&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_Paper___default.a,{className:classes.tabPaper},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true,spacing:4,alignItems:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12,md:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.gridHeader},'Source Customer & Vehicle')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12,md:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.fieldLabel},'Source Customer *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_apollo__["Query"],{query:GET_CLIENTS,variables:{partnerLoginId:partnerLoginId}},function(_ref7){var loading=_ref7.loading,error=_ref7.error,data=_ref7.data;if(loading)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Loading...');if(error)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Error loading customers');var customerOptions=(data.clients||[]).map(function(client){return Object.assign({value:client.loginId,label:client.clientName},client);});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */],{value:selectedCustomer,onChange:_this3.handleCustomerChange,options:customerOptions,placeholder:'Select source customer',className:classes.selectBox});})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12,md:5},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.fieldLabel},'Source Vehicle *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_apollo__["Query"],{query:GET_VEHICLES,variables:{loginId:partnerLoginId,status:1}},function(_ref8){var loading=_ref8.loading,error=_ref8.error,data=_ref8.data;if(loading)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */],{placeholder:'Loading...',disabled:true});if(error)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Error loading vehicles');var filteredVehicles=(data.vehicles||[]).filter(function(v){return v&&v.clientLoginId===(selectedCustomer?selectedCustomer.value:null);});var vehicleOptions=filteredVehicles.map(function(vehicle){return Object.assign({value:vehicle.entityId,label:vehicle.vehicleNumber},vehicle);});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */],{value:selectedSourceVehicle,onChange:_this3.handleSourceVehicleChange,options:vehicleOptions,placeholder:'Select source vehicle',className:classes.selectBox,disabled:!selectedCustomer});}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true,spacing:4,style:{marginTop:8}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12,md:3}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12,md:9},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.fieldLabel},'Source Vehicle Device ID'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.readoutBox},selectedSourceVehicle&&selectedSourceVehicle.deviceDetail?selectedSourceVehicle.deviceDetail.uniqueDeviceId+' '+(selectedSourceVehicle.solutionType?'('+selectedSourceVehicle.solutionType.toUpperCase()+')':''):'No device associated'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.divider}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{container:true,spacing:4,alignItems:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12,md:3},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.gridHeader},'Target Customer')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Grid___default.a,{item:true,xs:12,md:4},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.fieldLabel},'Target Customer *'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_apollo__["Query"],{query:GET_CLIENTS,variables:{partnerLoginId:partnerLoginId}},function(_ref9){var loading=_ref9.loading,error=_ref9.error,data=_ref9.data;if(loading)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Loading...');if(error)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Error loading customers');var customerOptions=(data.clients||[]).map(function(client){return Object.assign({value:client.loginId,label:client.clientName},client);});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */],{value:selectedTargetCustomer,onChange:_this3.handleTargetCustomerChange,options:customerOptions,placeholder:'Select target customer',className:classes.selectBox});}))),selectedCustomer&&selectedTargetCustomer&&selectedSourceVehicle&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:classes.shiftButtonContainer},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_Button___default.a,{variant:'contained',color:'primary',size:'large',disabled:isSubmitting,onClick:this.submitDeviceShift,className:classes.button},isSubmitting?'Processing...':'Shift'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__common_ConfirmationDialog__["a" /* default */],{isDialogOpen:confirmDialogOpen,dialogTitle:confirmDialogTitle,dialogMessage:confirmDialogMessage,positiveResponseButtonText:'Yes',negativeResponseButtonText:'No',positiveResponseHandler:this.executeDeviceShift,negativeResponseHandler:this.closeConfirmDialog,dialogCloseHandler:this.closeConfirmDialog}));}}]);return DeviceShift;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__["withStyles"])(styles)(Object(__WEBPACK_IMPORTED_MODULE_13_react_apollo__["withApollo"])(Object(__WEBPACK_IMPORTED_MODULE_16__HOCs_withSharedSnackbar__["a" /* default */])(DeviceShift))));

/***/ }),
/* 2459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__asyncLandingPages_js__ = __webpack_require__(2460);
/* harmony default export */ __webpack_exports__["a"] = ({AQUILATRACK:{component:__WEBPACK_IMPORTED_MODULE_0__asyncLandingPages_js__["a" /* AsyncDefaultLanding */]},PLAIN:{component:__WEBPACK_IMPORTED_MODULE_0__asyncLandingPages_js__["b" /* AsyncPlainLanding */]}});

/***/ }),
/* 2460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AsyncDefaultLanding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AsyncPlainLanding; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_loadable__ = __webpack_require__(2461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_loadable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_loadable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Loader__ = __webpack_require__(47);
var AsyncDefaultLanding=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 2496));},loading:function loading(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_common_Loader__["a" /* default */],{fullscreen:true});}});var AsyncPlainLanding=__WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({loader:function loader(){return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 2497));},loading:function loading(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_common_Loader__["a" /* default */],{fullscreen:true});}});

/***/ }),
/* 2461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var PropTypes = __webpack_require__(3);

var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];

function isWebpackReady(getModuleIds) {
  if (( false ? "undefined" : _typeof(__webpack_require__.m)) !== "object") {
    return false;
  }

  return getModuleIds().every(function (moduleId) {
    return typeof moduleId !== "undefined" && typeof __webpack_require__.m[moduleId] !== "undefined";
  });
}

function load(loader) {
  var promise = loader();

  var state = {
    loading: true,
    loaded: null,
    error: null
  };

  state.promise = promise.then(function (loaded) {
    state.loading = false;
    state.loaded = loaded;
    return loaded;
  }).catch(function (err) {
    state.loading = false;
    state.error = err;
    throw err;
  });

  return state;
}

function loadMap(obj) {
  var state = {
    loading: false,
    loaded: {},
    error: null
  };

  var promises = [];

  try {
    Object.keys(obj).forEach(function (key) {
      var result = load(obj[key]);

      if (!result.loading) {
        state.loaded[key] = result.loaded;
        state.error = result.error;
      } else {
        state.loading = true;
      }

      promises.push(result.promise);

      result.promise.then(function (res) {
        state.loaded[key] = res;
      }).catch(function (err) {
        state.error = err;
      });
    });
  } catch (err) {
    state.error = err;
  }

  state.promise = Promise.all(promises).then(function (res) {
    state.loading = false;
    return res;
  }).catch(function (err) {
    state.loading = false;
    throw err;
  });

  return state;
}

function resolve(obj) {
  return obj && obj.__esModule ? obj.default : obj;
}

function render(loaded, props) {
  return React.createElement(resolve(loaded), props);
}

function createLoadableComponent(loadFn, options) {
  var _class, _temp;

  if (!options.loading) {
    throw new Error("react-loadable requires a `loading` component");
  }

  var opts = Object.assign({
    loader: null,
    loading: null,
    delay: 200,
    timeout: null,
    render: render,
    webpack: null,
    modules: null
  }, options);

  var res = null;

  function init() {
    if (!res) {
      res = loadFn(opts.loader);
    }
    return res.promise;
  }

  ALL_INITIALIZERS.push(init);

  if (typeof opts.webpack === "function") {
    READY_INITIALIZERS.push(function () {
      if (isWebpackReady(opts.webpack)) {
        return init();
      }
    });
  }

  return _temp = _class = function (_React$Component) {
    _inherits(LoadableComponent, _React$Component);

    function LoadableComponent(props) {
      _classCallCheck(this, LoadableComponent);

      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

      _this.retry = function () {
        _this.setState({ error: null, loading: true, timedOut: false });
        res = loadFn(opts.loader);
        _this._loadModule();
      };

      init();

      _this.state = {
        error: res.error,
        pastDelay: false,
        timedOut: false,
        loading: res.loading,
        loaded: res.loaded
      };
      return _this;
    }

    LoadableComponent.preload = function preload() {
      return init();
    };

    LoadableComponent.prototype.componentWillMount = function componentWillMount() {
      this._mounted = true;
      this._loadModule();
    };

    LoadableComponent.prototype._loadModule = function _loadModule() {
      var _this2 = this;

      if (this.context.loadable && Array.isArray(opts.modules)) {
        opts.modules.forEach(function (moduleName) {
          _this2.context.loadable.report(moduleName);
        });
      }

      if (!res.loading) {
        return;
      }

      if (typeof opts.delay === "number") {
        if (opts.delay === 0) {
          this.setState({ pastDelay: true });
        } else {
          this._delay = setTimeout(function () {
            _this2.setState({ pastDelay: true });
          }, opts.delay);
        }
      }

      if (typeof opts.timeout === "number") {
        this._timeout = setTimeout(function () {
          _this2.setState({ timedOut: true });
        }, opts.timeout);
      }

      var update = function update() {
        if (!_this2._mounted) {
          return;
        }

        _this2.setState({
          error: res.error,
          loaded: res.loaded,
          loading: res.loading
        });

        _this2._clearTimeouts();
      };

      res.promise.then(function () {
        update();
      }).catch(function (err) {
        update();
      });
    };

    LoadableComponent.prototype.componentWillUnmount = function componentWillUnmount() {
      this._mounted = false;
      this._clearTimeouts();
    };

    LoadableComponent.prototype._clearTimeouts = function _clearTimeouts() {
      clearTimeout(this._delay);
      clearTimeout(this._timeout);
    };

    LoadableComponent.prototype.render = function render() {
      if (this.state.loading || this.state.error) {
        return React.createElement(opts.loading, {
          isLoading: this.state.loading,
          pastDelay: this.state.pastDelay,
          timedOut: this.state.timedOut,
          error: this.state.error,
          retry: this.retry
        });
      } else if (this.state.loaded) {
        return opts.render(this.state.loaded, this.props);
      } else {
        return null;
      }
    };

    return LoadableComponent;
  }(React.Component), _class.contextTypes = {
    loadable: PropTypes.shape({
      report: PropTypes.func.isRequired
    })
  }, _temp;
}

function Loadable(opts) {
  return createLoadableComponent(load, opts);
}

function LoadableMap(opts) {
  if (typeof opts.render !== "function") {
    throw new Error("LoadableMap requires a `render(loaded, props)` function");
  }

  return createLoadableComponent(loadMap, opts);
}

Loadable.Map = LoadableMap;

var Capture = function (_React$Component2) {
  _inherits(Capture, _React$Component2);

  function Capture() {
    _classCallCheck(this, Capture);

    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
  }

  Capture.prototype.getChildContext = function getChildContext() {
    return {
      loadable: {
        report: this.props.report
      }
    };
  };

  Capture.prototype.render = function render() {
    return React.Children.only(this.props.children);
  };

  return Capture;
}(React.Component);

Capture.propTypes = {
  report: PropTypes.func.isRequired
};
Capture.childContextTypes = {
  loadable: PropTypes.shape({
    report: PropTypes.func.isRequired
  }).isRequired
};


Loadable.Capture = Capture;

function flushInitializers(initializers) {
  var promises = [];

  while (initializers.length) {
    var init = initializers.pop();
    promises.push(init());
  }

  return Promise.all(promises).then(function () {
    if (initializers.length) {
      return flushInitializers(initializers);
    }
  });
}

Loadable.preloadAll = function () {
  return new Promise(function (resolve, reject) {
    flushInitializers(ALL_INITIALIZERS).then(resolve, reject);
  });
};

Loadable.preloadReady = function () {
  return new Promise(function (resolve, reject) {
    // We always will resolve, errors should be handled within loading UIs.
    flushInitializers(READY_INITIALIZERS).then(resolve, resolve);
  });
};

module.exports = Loadable;

/***/ }),
/* 2462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony export (immutable) */ __webpack_exports__["a"] = unregister;
/* eslint-disable */// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if('serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl=""+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);// Add some additional logging to localhost, pointing developers to the
// service worker/PWA documentation.
navigator.serviceWorker.ready.then(function(){console.log('This web app is being served cache-first by a service '+'worker. To learn more, visit https://goo.gl/SC7cgQ');});}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;if(installingWorker==null){return;}installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
console.log('New content is available; please refresh.');// Prompt user to refresh (Simple way)
if(window.confirm('New version available! Refresh now?')){window.location.reload();}}else{// At this point, everything has been precached.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ }),
/* 2463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getApolloClient;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_client__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_apollo_cache_inmemory__ = __webpack_require__(2464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apollo_link_http__ = __webpack_require__(2467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_apollo_link__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_apollo_link_error__ = __webpack_require__(2468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_apollo_link_context__ = __webpack_require__(2469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_apollo_upload_client__ = __webpack_require__(2470);
var cache=new __WEBPACK_IMPORTED_MODULE_1_apollo_cache_inmemory__["a" /* InMemoryCache */]();var httpLink=new __WEBPACK_IMPORTED_MODULE_2_apollo_link_http__["a" /* HttpLink */]({uri:"https://uat-api-dtwin.taabi.ai/graphql"});var authLink=Object(__WEBPACK_IMPORTED_MODULE_5_apollo_link_context__["a" /* setContext */])(function(_,_ref){var headers=_ref.headers;// get the authentication token from local storage if it exists
var token=localStorage.getItem('Authorization_token');// return the headers to the context so httpLink can read them
/* eslint-disable indent */// console.log(token)
return token?{headers:Object.assign({},headers,{authorization:token?'Bearer '+token:''})}:{headers:Object.assign({},headers)/* eslint-enable indent */};});var isFile=function isFile(value){return typeof File!=='undefined'&&value instanceof File||typeof Blob!=='undefined'&&value instanceof Blob;};var isUpload=function isUpload(_ref2){var variables=_ref2.variables;return Object.values(variables).some(isFile);};function getApolloClient(_ref3){var logout=_ref3.logout;var logoutLink=Object(__WEBPACK_IMPORTED_MODULE_4_apollo_link_error__["a" /* onError */])(function(_ref4){var graphQLErrors=_ref4.graphQLErrors;if(graphQLErrors){graphQLErrors.forEach(function(error){if(error.message.toLowerCase().includes('auth')){logout();}});}});var client=new __WEBPACK_IMPORTED_MODULE_0_apollo_client__["ApolloClient"]({link:__WEBPACK_IMPORTED_MODULE_3_apollo_link__["a" /* ApolloLink */].from([logoutLink,Object(__WEBPACK_IMPORTED_MODULE_3_apollo_link__["e" /* split */])(isUpload,Object(__WEBPACK_IMPORTED_MODULE_6_apollo_upload_client__["a" /* createUploadLink */])({uri:"https://uat-api-dtwin.taabi.ai/graphql"}),authLink.concat(httpLink))]),cache:cache});return client;}

/***/ }),
/* 2464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HeuristicFragmentMatcher */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InMemoryCache; });
/* unused harmony export IntrospectionFragmentMatcher */
/* unused harmony export ObjectCache */
/* unused harmony export StoreReader */
/* unused harmony export StoreWriter */
/* unused harmony export WriteError */
/* unused harmony export assertIdValue */
/* unused harmony export defaultDataIdFromObject */
/* unused harmony export defaultNormalizedCacheFactory */
/* unused harmony export enhanceErrorWithDocument */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_apollo_cache__ = __webpack_require__(2465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apollo_utilities__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_optimism__ = __webpack_require__(2466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ts_invariant__ = __webpack_require__(172);






var haveWarned = false;
function shouldWarn() {
    var answer = !haveWarned;
    if (!Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["z" /* isTest */])()) {
        haveWarned = true;
    }
    return answer;
}
var HeuristicFragmentMatcher = (function () {
    function HeuristicFragmentMatcher() {
    }
    HeuristicFragmentMatcher.prototype.ensureReady = function () {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function () {
        return true;
    };
    HeuristicFragmentMatcher.prototype.match = function (idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) {
            return isRootQuery;
        }
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        if (!__typename) {
            if (shouldWarn()) {
                "production" === "production" || __WEBPACK_IMPORTED_MODULE_4_ts_invariant__["b" /* invariant */].warn("You're using fragments in your queries, but either don't have the addTypename:\n  true option set in Apollo Client, or you are trying to write a fragment to the store without the __typename.\n   Please turn on the addTypename option and include __typename when writing fragments so that Apollo Client\n   can accurately match fragments.");
                "production" === "production" || __WEBPACK_IMPORTED_MODULE_4_ts_invariant__["b" /* invariant */].warn('Could not find __typename on Fragment ', typeCondition, obj);
                "production" === "production" || __WEBPACK_IMPORTED_MODULE_4_ts_invariant__["b" /* invariant */].warn("DEPRECATION WARNING: using fragments without __typename is unsupported behavior " +
                    "and will be removed in future versions of Apollo client. You should fix this and set addTypename to true now.");
            }
            return 'heuristic';
        }
        if (__typename === typeCondition) {
            return true;
        }
        if (shouldWarn()) {
            "production" === "production" || __WEBPACK_IMPORTED_MODULE_4_ts_invariant__["b" /* invariant */].error('You are using the simple (heuristic) fragment matcher, but your ' +
                'queries contain union or interface types. Apollo Client will not be ' +
                'able to accurately map fragments. To make this error go away, use ' +
                'the `IntrospectionFragmentMatcher` as described in the docs: ' +
                'https://www.apollographql.com/docs/react/advanced/fragments.html#fragment-matcher');
        }
        return 'heuristic';
    };
    return HeuristicFragmentMatcher;
}());
var IntrospectionFragmentMatcher = (function () {
    function IntrospectionFragmentMatcher(options) {
        if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
        }
        else {
            this.isReady = false;
        }
        this.match = this.match.bind(this);
    }
    IntrospectionFragmentMatcher.prototype.match = function (idValue, typeCondition, context) {
         true ? Object(__WEBPACK_IMPORTED_MODULE_4_ts_invariant__["b" /* invariant */])(this.isReady, 1) : invariant(this.isReady, 'FragmentMatcher.match() was called before FragmentMatcher.init()');
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) {
            return isRootQuery;
        }
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
         true ? Object(__WEBPACK_IMPORTED_MODULE_4_ts_invariant__["b" /* invariant */])(__typename, 2) : invariant(__typename, "Cannot match fragment because __typename property is missing: " + JSON.stringify(obj));
        if (__typename === typeCondition) {
            return true;
        }
        var implementingTypes = this.possibleTypesMap[typeCondition];
        if (__typename &&
            implementingTypes &&
            implementingTypes.indexOf(__typename) > -1) {
            return true;
        }
        return false;
    };
    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function (introspectionResultData) {
        var typeMap = {};
        introspectionResultData.__schema.types.forEach(function (type) {
            if (type.kind === 'UNION' || type.kind === 'INTERFACE') {
                typeMap[type.name] = type.possibleTypes.map(function (implementingType) { return implementingType.name; });
            }
        });
        return typeMap;
    };
    return IntrospectionFragmentMatcher;
}());

var hasOwn = Object.prototype.hasOwnProperty;
var DepTrackingCache = (function () {
    function DepTrackingCache(data) {
        var _this = this;
        if (data === void 0) { data = Object.create(null); }
        this.data = data;
        this.depend = Object(__WEBPACK_IMPORTED_MODULE_3_optimism__["b" /* wrap */])(function (dataId) { return _this.data[dataId]; }, {
            disposable: true,
            makeCacheKey: function (dataId) {
                return dataId;
            },
        });
    }
    DepTrackingCache.prototype.toObject = function () {
        return this.data;
    };
    DepTrackingCache.prototype.get = function (dataId) {
        this.depend(dataId);
        return this.data[dataId];
    };
    DepTrackingCache.prototype.set = function (dataId, value) {
        var oldValue = this.data[dataId];
        if (value !== oldValue) {
            this.data[dataId] = value;
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.delete = function (dataId) {
        if (hasOwn.call(this.data, dataId)) {
            delete this.data[dataId];
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.clear = function () {
        this.replace(null);
    };
    DepTrackingCache.prototype.replace = function (newData) {
        var _this = this;
        if (newData) {
            Object.keys(newData).forEach(function (dataId) {
                _this.set(dataId, newData[dataId]);
            });
            Object.keys(this.data).forEach(function (dataId) {
                if (!hasOwn.call(newData, dataId)) {
                    _this.delete(dataId);
                }
            });
        }
        else {
            Object.keys(this.data).forEach(function (dataId) {
                _this.delete(dataId);
            });
        }
    };
    return DepTrackingCache;
}());
function defaultNormalizedCacheFactory(seed) {
    return new DepTrackingCache(seed);
}

var StoreReader = (function () {
    function StoreReader(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new __WEBPACK_IMPORTED_MODULE_3_optimism__["a" /* KeyTrie */](__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["e" /* canUseWeakMap */]) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
        var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
        this.freezeResults = freezeResults;
        this.executeStoreQuery = Object(__WEBPACK_IMPORTED_MODULE_3_optimism__["b" /* wrap */])(function (options) {
            return executeStoreQuery.call(_this, options);
        }, {
            makeCacheKey: function (_a) {
                var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                if (contextValue.store instanceof DepTrackingCache) {
                    return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
                }
            }
        });
        this.executeSelectionSet = Object(__WEBPACK_IMPORTED_MODULE_3_optimism__["b" /* wrap */])(function (options) {
            return executeSelectionSet.call(_this, options);
        }, {
            makeCacheKey: function (_a) {
                var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof DepTrackingCache) {
                    return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
                }
            }
        });
        this.executeSubSelectedArray = Object(__WEBPACK_IMPORTED_MODULE_3_optimism__["b" /* wrap */])(function (options) {
            return executeSubSelectedArray.call(_this, options);
        }, {
            makeCacheKey: function (_a) {
                var field = _a.field, array = _a.array, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof DepTrackingCache) {
                    return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
                }
            }
        });
    }
    StoreReader.prototype.readQueryFromStore = function (options) {
        return this.diffQueryAgainstStore(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, options), { returnPartialData: false })).result;
    };
    StoreReader.prototype.diffQueryAgainstStore = function (_a) {
        var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
        var queryDefinition = Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["o" /* getQueryDefinition */])(query);
        variables = Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["c" /* assign */])({}, Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["h" /* getDefaultValues */])(queryDefinition), variables);
        var context = {
            store: store,
            dataIdFromObject: config && config.dataIdFromObject,
            cacheRedirects: (config && config.cacheRedirects) || {},
        };
        var execResult = this.executeStoreQuery({
            query: query,
            rootValue: {
                type: 'id',
                id: rootId,
                generated: true,
                typename: 'Query',
            },
            contextValue: context,
            variableValues: variables,
            fragmentMatcher: fragmentMatcherFunction,
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) {
            execResult.missing.forEach(function (info) {
                if (info.tolerable)
                    return;
                throw  true ? new __WEBPACK_IMPORTED_MODULE_4_ts_invariant__["a" /* InvariantError */](8) : new InvariantError("Can't find field " + info.fieldName + " on object " + JSON.stringify(info.object, null, 2) + ".");
            });
        }
        if (previousResult) {
            if (Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["t" /* isEqual */])(previousResult, execResult.result)) {
                execResult.result = previousResult;
            }
        }
        return {
            result: execResult.result,
            complete: !hasMissingFields,
        };
    };
    StoreReader.prototype.executeStoreQuery = function (_a) {
        var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? defaultFragmentMatcher : _b;
        var mainDefinition = Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["l" /* getMainDefinition */])(query);
        var fragments = Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["j" /* getFragmentDefinitions */])(query);
        var fragmentMap = Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["g" /* createFragmentMap */])(fragments);
        var execContext = {
            query: query,
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            fragmentMatcher: fragmentMatcher,
        };
        return this.executeSelectionSet({
            selectionSet: mainDefinition.selectionSet,
            rootValue: rootValue,
            execContext: execContext,
        });
    };
    StoreReader.prototype.executeSelectionSet = function (_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var finalResult = { result: null };
        var objectsToMerge = [];
        var object = contextValue.store.get(rootValue.id);
        var typename = (object && object.__typename) ||
            (rootValue.id === 'ROOT_QUERY' && 'Query') ||
            void 0;
        function handleMissing(result) {
            var _a;
            if (result.missing) {
                finalResult.missing = finalResult.missing || [];
                (_a = finalResult.missing).push.apply(_a, result.missing);
            }
            return result.result;
        }
        selectionSet.selections.forEach(function (selection) {
            var _a;
            if (!Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["G" /* shouldInclude */])(selection, variables)) {
                return;
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["u" /* isField */])(selection)) {
                var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                if (typeof fieldResult !== 'undefined') {
                    objectsToMerge.push((_a = {},
                        _a[Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["F" /* resultKeyNameFromField */])(selection)] = fieldResult,
                        _a));
                }
            }
            else {
                var fragment = void 0;
                if (Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["w" /* isInlineFragment */])(selection)) {
                    fragment = selection;
                }
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) {
                        throw  true ? new __WEBPACK_IMPORTED_MODULE_4_ts_invariant__["a" /* InvariantError */](9) : new InvariantError("No fragment named " + selection.name.value);
                    }
                }
                var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                var match = !typeCondition ||
                    execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                if (match) {
                    var fragmentExecResult = _this.executeSelectionSet({
                        selectionSet: fragment.selectionSet,
                        rootValue: rootValue,
                        execContext: execContext,
                    });
                    if (match === 'heuristic' && fragmentExecResult.missing) {
                        fragmentExecResult = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, fragmentExecResult), { missing: fragmentExecResult.missing.map(function (info) {
                                return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, info), { tolerable: true });
                            }) });
                    }
                    objectsToMerge.push(handleMissing(fragmentExecResult));
                }
            }
        });
        finalResult.result = Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["C" /* mergeDeepArray */])(objectsToMerge);
        if (this.freezeResults && "production" !== 'production') {
            Object.freeze(finalResult.result);
        }
        return finalResult;
    };
    StoreReader.prototype.executeField = function (object, typename, field, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue;
        var fieldName = field.name.value;
        var args = Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["b" /* argumentsObjectFromField */])(field, variables);
        var info = {
            resultKey: Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["F" /* resultKeyNameFromField */])(field),
            directives: Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["i" /* getDirectiveInfoFromField */])(field, variables),
        };
        var readStoreResult = readStoreResolver(object, typename, fieldName, args, contextValue, info);
        if (Array.isArray(readStoreResult.result)) {
            return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
                field: field,
                array: readStoreResult.result,
                execContext: execContext,
            }));
        }
        if (!field.selectionSet) {
            assertSelectionSetForIdValue(field, readStoreResult.result);
            if (this.freezeResults && "production" !== 'production') {
                Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["A" /* maybeDeepFreeze */])(readStoreResult);
            }
            return readStoreResult;
        }
        if (readStoreResult.result == null) {
            return readStoreResult;
        }
        return this.combineExecResults(readStoreResult, this.executeSelectionSet({
            selectionSet: field.selectionSet,
            rootValue: readStoreResult.result,
            execContext: execContext,
        }));
    };
    StoreReader.prototype.combineExecResults = function () {
        var execResults = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            execResults[_i] = arguments[_i];
        }
        var missing;
        execResults.forEach(function (execResult) {
            if (execResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, execResult.missing);
            }
        });
        return {
            result: execResults.pop().result,
            missing: missing,
        };
    };
    StoreReader.prototype.executeSubSelectedArray = function (_a) {
        var _this = this;
        var field = _a.field, array = _a.array, execContext = _a.execContext;
        var missing;
        function handleMissing(childResult) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            return childResult.result;
        }
        array = array.map(function (item) {
            if (item === null) {
                return null;
            }
            if (Array.isArray(item)) {
                return handleMissing(_this.executeSubSelectedArray({
                    field: field,
                    array: item,
                    execContext: execContext,
                }));
            }
            if (field.selectionSet) {
                return handleMissing(_this.executeSelectionSet({
                    selectionSet: field.selectionSet,
                    rootValue: item,
                    execContext: execContext,
                }));
            }
            assertSelectionSetForIdValue(field, item);
            return item;
        });
        if (this.freezeResults && "production" !== 'production') {
            Object.freeze(array);
        }
        return { result: array, missing: missing };
    };
    return StoreReader;
}());
function assertSelectionSetForIdValue(field, value) {
    if (!field.selectionSet && Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["v" /* isIdValue */])(value)) {
        throw  true ? new __WEBPACK_IMPORTED_MODULE_4_ts_invariant__["a" /* InvariantError */](10) : new InvariantError("Missing selection set for object of type " + value.typename + " returned for query field " + field.name.value);
    }
}
function defaultFragmentMatcher() {
    return true;
}
function assertIdValue(idValue) {
     true ? Object(__WEBPACK_IMPORTED_MODULE_4_ts_invariant__["b" /* invariant */])(Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["v" /* isIdValue */])(idValue), 11) : invariant(isIdValue(idValue), "Encountered a sub-selection on the query, but the store doesn't have an object reference. This should never happen during normal use unless you have custom code that is directly manipulating the store; please file an issue.");
}
function readStoreResolver(object, typename, fieldName, args, context, _a) {
    var resultKey = _a.resultKey, directives = _a.directives;
    var storeKeyName = fieldName;
    if (args || directives) {
        storeKeyName = Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["p" /* getStoreKeyName */])(storeKeyName, args, directives);
    }
    var fieldValue = void 0;
    if (object) {
        fieldValue = object[storeKeyName];
        if (typeof fieldValue === 'undefined' &&
            context.cacheRedirects &&
            typeof typename === 'string') {
            var type = context.cacheRedirects[typename];
            if (type) {
                var resolver = type[fieldName];
                if (resolver) {
                    fieldValue = resolver(object, args, {
                        getCacheKey: function (storeObj) {
                            var id = context.dataIdFromObject(storeObj);
                            return id && Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["I" /* toIdValue */])({
                                id: id,
                                typename: storeObj.__typename,
                            });
                        },
                    });
                }
            }
        }
    }
    if (typeof fieldValue === 'undefined') {
        return {
            result: fieldValue,
            missing: [{
                    object: object,
                    fieldName: storeKeyName,
                    tolerable: false,
                }],
        };
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["x" /* isJsonValue */])(fieldValue)) {
        fieldValue = fieldValue.json;
    }
    return {
        result: fieldValue,
    };
}

var ObjectCache = (function () {
    function ObjectCache(data) {
        if (data === void 0) { data = Object.create(null); }
        this.data = data;
    }
    ObjectCache.prototype.toObject = function () {
        return this.data;
    };
    ObjectCache.prototype.get = function (dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function (dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function (dataId) {
        this.data[dataId] = void 0;
    };
    ObjectCache.prototype.clear = function () {
        this.data = Object.create(null);
    };
    ObjectCache.prototype.replace = function (newData) {
        this.data = newData || Object.create(null);
    };
    return ObjectCache;
}());
function defaultNormalizedCacheFactory$1(seed) {
    return new ObjectCache(seed);
}

var WriteError = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'WriteError';
        return _this;
    }
    return WriteError;
}(Error));
function enhanceErrorWithDocument(error, document) {
    var enhancedError = new WriteError("Error writing result to store for query:\n " + JSON.stringify(document));
    enhancedError.message += '\n' + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
var StoreWriter = (function () {
    function StoreWriter() {
    }
    StoreWriter.prototype.writeQueryToStore = function (_a) {
        var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        return this.writeResultToStore({
            dataId: 'ROOT_QUERY',
            result: result,
            document: query,
            store: store,
            variables: variables,
            dataIdFromObject: dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction,
        });
    };
    StoreWriter.prototype.writeResultToStore = function (_a) {
        var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        var operationDefinition = Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["m" /* getOperationDefinition */])(document);
        try {
            return this.writeSelectionSetToStore({
                result: result,
                dataId: dataId,
                selectionSet: operationDefinition.selectionSet,
                context: {
                    store: store,
                    processedData: {},
                    variables: Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["c" /* assign */])({}, Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["h" /* getDefaultValues */])(operationDefinition), variables),
                    dataIdFromObject: dataIdFromObject,
                    fragmentMap: Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["g" /* createFragmentMap */])(Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["j" /* getFragmentDefinitions */])(document)),
                    fragmentMatcherFunction: fragmentMatcherFunction,
                },
            });
        }
        catch (e) {
            throw enhanceErrorWithDocument(e, document);
        }
    };
    StoreWriter.prototype.writeSelectionSetToStore = function (_a) {
        var _this = this;
        var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
        var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
        selectionSet.selections.forEach(function (selection) {
            var _a;
            if (!Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["G" /* shouldInclude */])(selection, variables)) {
                return;
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["u" /* isField */])(selection)) {
                var resultFieldKey = Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["F" /* resultKeyNameFromField */])(selection);
                var value = result[resultFieldKey];
                if (typeof value !== 'undefined') {
                    _this.writeFieldToStore({
                        dataId: dataId,
                        value: value,
                        field: selection,
                        context: context,
                    });
                }
                else {
                    var isDefered = false;
                    var isClient = false;
                    if (selection.directives && selection.directives.length) {
                        isDefered = selection.directives.some(function (directive) { return directive.name && directive.name.value === 'defer'; });
                        isClient = selection.directives.some(function (directive) { return directive.name && directive.name.value === 'client'; });
                    }
                    if (!isDefered && !isClient && context.fragmentMatcherFunction) {
                        "production" === "production" || __WEBPACK_IMPORTED_MODULE_4_ts_invariant__["b" /* invariant */].warn("Missing field " + resultFieldKey + " in " + JSON.stringify(result, null, 2).substring(0, 100));
                    }
                }
            }
            else {
                var fragment = void 0;
                if (Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["w" /* isInlineFragment */])(selection)) {
                    fragment = selection;
                }
                else {
                    fragment = (fragmentMap || {})[selection.name.value];
                     true ? Object(__WEBPACK_IMPORTED_MODULE_4_ts_invariant__["b" /* invariant */])(fragment, 3) : invariant(fragment, "No fragment named " + selection.name.value + ".");
                }
                var matches = true;
                if (context.fragmentMatcherFunction && fragment.typeCondition) {
                    var id = dataId || 'self';
                    var idValue = Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["I" /* toIdValue */])({ id: id, typename: undefined });
                    var fakeContext = {
                        store: new ObjectCache((_a = {}, _a[id] = result, _a)),
                        cacheRedirects: {},
                    };
                    var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                    if (!Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["y" /* isProduction */])() && match === 'heuristic') {
                        "production" === "production" || __WEBPACK_IMPORTED_MODULE_4_ts_invariant__["b" /* invariant */].error('WARNING: heuristic fragment matching going on!');
                    }
                    matches = !!match;
                }
                if (matches) {
                    _this.writeSelectionSetToStore({
                        result: result,
                        selectionSet: fragment.selectionSet,
                        dataId: dataId,
                        context: context,
                    });
                }
            }
        });
        return store;
    };
    StoreWriter.prototype.writeFieldToStore = function (_a) {
        var _b;
        var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
        var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
        var storeValue;
        var storeObject;
        var storeFieldName = Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["H" /* storeKeyNameFromField */])(field, variables);
        if (!field.selectionSet || value === null) {
            storeValue =
                value != null && typeof value === 'object'
                    ?
                        { type: 'json', json: value }
                    :
                        value;
        }
        else if (Array.isArray(value)) {
            var generatedId = dataId + "." + storeFieldName;
            storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
        }
        else {
            var valueDataId = dataId + "." + storeFieldName;
            var generated = true;
            if (!isGeneratedId(valueDataId)) {
                valueDataId = '$' + valueDataId;
            }
            if (dataIdFromObject) {
                var semanticId = dataIdFromObject(value);
                 true ? Object(__WEBPACK_IMPORTED_MODULE_4_ts_invariant__["b" /* invariant */])(!semanticId || !isGeneratedId(semanticId), 4) : invariant(!semanticId || !isGeneratedId(semanticId), 'IDs returned by dataIdFromObject cannot begin with the "$" character.');
                if (semanticId ||
                    (typeof semanticId === 'number' && semanticId === 0)) {
                    valueDataId = semanticId;
                    generated = false;
                }
            }
            if (!isDataProcessed(valueDataId, field, context.processedData)) {
                this.writeSelectionSetToStore({
                    dataId: valueDataId,
                    result: value,
                    selectionSet: field.selectionSet,
                    context: context,
                });
            }
            var typename = value.__typename;
            storeValue = Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["I" /* toIdValue */])({ id: valueDataId, typename: typename }, generated);
            storeObject = store.get(dataId);
            var escapedId = storeObject && storeObject[storeFieldName];
            if (escapedId !== storeValue && Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["v" /* isIdValue */])(escapedId)) {
                var hadTypename = escapedId.typename !== undefined;
                var hasTypename = typename !== undefined;
                var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                 true ? Object(__WEBPACK_IMPORTED_MODULE_4_ts_invariant__["b" /* invariant */])(!generated || escapedId.generated || typenameChanged, 5) : invariant(!generated || escapedId.generated || typenameChanged, "Store error: the application attempted to write an object with no provided id but the store already contains an id of " + escapedId.id + " for this object. The selectionSet that was trying to be written is:\n" + JSON.stringify(field));
                 true ? Object(__WEBPACK_IMPORTED_MODULE_4_ts_invariant__["b" /* invariant */])(!hadTypename || hasTypename, 6) : invariant(!hadTypename || hasTypename, "Store error: the application attempted to write an object with no provided typename but the store already contains an object with typename of " + escapedId.typename + " for the object of id " + escapedId.id + ". The selectionSet that was trying to be written is:\n" + JSON.stringify(field));
                if (escapedId.generated) {
                    if (typenameChanged) {
                        if (!generated) {
                            store.delete(escapedId.id);
                        }
                    }
                    else {
                        mergeWithGenerated(escapedId.id, storeValue.id, store);
                    }
                }
            }
        }
        storeObject = store.get(dataId);
        if (!storeObject || !Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["t" /* isEqual */])(storeValue, storeObject[storeFieldName])) {
            store.set(dataId, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
        }
    };
    StoreWriter.prototype.processArrayValue = function (value, generatedId, selectionSet, context) {
        var _this = this;
        return value.map(function (item, index) {
            if (item === null) {
                return null;
            }
            var itemDataId = generatedId + "." + index;
            if (Array.isArray(item)) {
                return _this.processArrayValue(item, itemDataId, selectionSet, context);
            }
            var generated = true;
            if (context.dataIdFromObject) {
                var semanticId = context.dataIdFromObject(item);
                if (semanticId) {
                    itemDataId = semanticId;
                    generated = false;
                }
            }
            if (!isDataProcessed(itemDataId, selectionSet, context.processedData)) {
                _this.writeSelectionSetToStore({
                    dataId: itemDataId,
                    result: item,
                    selectionSet: selectionSet,
                    context: context,
                });
            }
            return Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["I" /* toIdValue */])({ id: itemDataId, typename: item.__typename }, generated);
        });
    };
    return StoreWriter;
}());
function isGeneratedId(id) {
    return id[0] === '$';
}
function mergeWithGenerated(generatedKey, realKey, cache) {
    if (generatedKey === realKey) {
        return false;
    }
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    var madeChanges = false;
    Object.keys(generated).forEach(function (key) {
        var value = generated[key];
        var realValue = real[key];
        if (Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["v" /* isIdValue */])(value) &&
            isGeneratedId(value.id) &&
            Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["v" /* isIdValue */])(realValue) &&
            !Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["t" /* isEqual */])(value, realValue) &&
            mergeWithGenerated(value.id, realValue.id, cache)) {
            madeChanges = true;
        }
    });
    cache.delete(generatedKey);
    var newRealValue = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, generated), real);
    if (Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["t" /* isEqual */])(newRealValue, real)) {
        return madeChanges;
    }
    cache.set(realKey, newRealValue);
    return true;
}
function isDataProcessed(dataId, field, processedData) {
    if (!processedData) {
        return false;
    }
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) {
            return true;
        }
        else {
            processedData[dataId].push(field);
        }
    }
    else {
        processedData[dataId] = [field];
    }
    return false;
}

var defaultConfig = {
    fragmentMatcher: new HeuristicFragmentMatcher(),
    dataIdFromObject: defaultDataIdFromObject,
    addTypename: true,
    resultCaching: true,
    freezeResults: false,
};
function defaultDataIdFromObject(result) {
    if (result.__typename) {
        if (result.id !== undefined) {
            return result.__typename + ":" + result.id;
        }
        if (result._id !== undefined) {
            return result.__typename + ":" + result._id;
        }
    }
    return null;
}
var hasOwn$1 = Object.prototype.hasOwnProperty;
var OptimisticCacheLayer = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(OptimisticCacheLayer, _super);
    function OptimisticCacheLayer(optimisticId, parent, transaction) {
        var _this = _super.call(this, Object.create(null)) || this;
        _this.optimisticId = optimisticId;
        _this.parent = parent;
        _this.transaction = transaction;
        return _this;
    }
    OptimisticCacheLayer.prototype.toObject = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this.parent.toObject()), this.data);
    };
    OptimisticCacheLayer.prototype.get = function (dataId) {
        return hasOwn$1.call(this.data, dataId)
            ? this.data[dataId]
            : this.parent.get(dataId);
    };
    return OptimisticCacheLayer;
}(ObjectCache));
var InMemoryCache = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) { config = {}; }
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.cacheKeyRoot = new __WEBPACK_IMPORTED_MODULE_3_optimism__["a" /* KeyTrie */](__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["e" /* canUseWeakMap */]);
        _this.silenceBroadcast = false;
        _this.config = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, defaultConfig), config);
        if (_this.config.customResolvers) {
            "production" === "production" || __WEBPACK_IMPORTED_MODULE_4_ts_invariant__["b" /* invariant */].warn('customResolvers have been renamed to cacheRedirects. Please update your config as we will be deprecating customResolvers in the next major version.');
            _this.config.cacheRedirects = _this.config.customResolvers;
        }
        if (_this.config.cacheResolvers) {
            "production" === "production" || __WEBPACK_IMPORTED_MODULE_4_ts_invariant__["b" /* invariant */].warn('cacheResolvers have been renamed to cacheRedirects. Please update your config as we will be deprecating cacheResolvers in the next major version.');
            _this.config.cacheRedirects = _this.config.cacheResolvers;
        }
        _this.addTypename = !!_this.config.addTypename;
        _this.data = _this.config.resultCaching
            ? new DepTrackingCache()
            : new ObjectCache();
        _this.optimisticData = _this.data;
        _this.storeWriter = new StoreWriter();
        _this.storeReader = new StoreReader({
            cacheKeyRoot: _this.cacheKeyRoot,
            freezeResults: config.freezeResults,
        });
        var cache = _this;
        var maybeBroadcastWatch = cache.maybeBroadcastWatch;
        _this.maybeBroadcastWatch = Object(__WEBPACK_IMPORTED_MODULE_3_optimism__["b" /* wrap */])(function (c) {
            return maybeBroadcastWatch.call(_this, c);
        }, {
            makeCacheKey: function (c) {
                if (c.optimistic) {
                    return;
                }
                if (c.previousResult) {
                    return;
                }
                if (cache.data instanceof DepTrackingCache) {
                    return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
                }
            }
        });
        return _this;
    }
    InMemoryCache.prototype.restore = function (data) {
        if (data)
            this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function (optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return (optimistic ? this.optimisticData : this.data).toObject();
    };
    InMemoryCache.prototype.read = function (options) {
        if (typeof options.rootId === 'string' &&
            typeof this.data.get(options.rootId) === 'undefined') {
            return null;
        }
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.readQueryFromStore({
            store: options.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
            rootId: options.rootId,
            fragmentMatcherFunction: fragmentMatcherFunction,
            previousResult: options.previousResult,
            config: this.config,
        }) || null;
    };
    InMemoryCache.prototype.write = function (write) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        this.storeWriter.writeResultToStore({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction,
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function (query) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.diffQueryAgainstStore({
            store: query.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: fragmentMatcherFunction,
            config: this.config,
        });
    };
    InMemoryCache.prototype.watch = function (watch) {
        var _this = this;
        this.watches.add(watch);
        return function () {
            _this.watches.delete(watch);
        };
    };
    InMemoryCache.prototype.evict = function (query) {
        throw  true ? new __WEBPACK_IMPORTED_MODULE_4_ts_invariant__["a" /* InvariantError */](7) : new InvariantError("eviction is not implemented on InMemory Cache");
    };
    InMemoryCache.prototype.reset = function () {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function (idToRemove) {
        var toReapply = [];
        var removedCount = 0;
        var layer = this.optimisticData;
        while (layer instanceof OptimisticCacheLayer) {
            if (layer.optimisticId === idToRemove) {
                ++removedCount;
            }
            else {
                toReapply.push(layer);
            }
            layer = layer.parent;
        }
        if (removedCount > 0) {
            this.optimisticData = layer;
            while (toReapply.length > 0) {
                var layer_1 = toReapply.pop();
                this.performTransaction(layer_1.transaction, layer_1.optimisticId);
            }
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.performTransaction = function (transaction, optimisticId) {
        var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
        this.silenceBroadcast = true;
        if (typeof optimisticId === 'string') {
            this.data = this.optimisticData = new OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
        }
        try {
            transaction(this);
        }
        finally {
            this.silenceBroadcast = silenceBroadcast;
            this.data = data;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function (transaction, id) {
        return this.performTransaction(transaction, id);
    };
    InMemoryCache.prototype.transformDocument = function (document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = Object(__WEBPACK_IMPORTED_MODULE_2_apollo_utilities__["a" /* addTypenameToDocument */])(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function () {
        var _this = this;
        if (!this.silenceBroadcast) {
            this.watches.forEach(function (c) { return _this.maybeBroadcastWatch(c); });
        }
    };
    InMemoryCache.prototype.maybeBroadcastWatch = function (c) {
        c.callback(this.diff({
            query: c.query,
            variables: c.variables,
            previousResult: c.previousResult && c.previousResult(),
            optimistic: c.optimistic,
        }));
    };
    return InMemoryCache;
}(__WEBPACK_IMPORTED_MODULE_1_apollo_cache__["a" /* ApolloCache */]));


//# sourceMappingURL=bundle.esm.js.map


/***/ }),
/* 2465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApolloCache; });
/* unused harmony export Cache */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_utilities__ = __webpack_require__(171);


function queryFromPojo(obj) {
    var op = {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery',
        },
        selectionSet: selectionSetFromObj(obj),
    };
    var out = {
        kind: 'Document',
        definitions: [op],
    };
    return out;
}
function fragmentFromPojo(obj, typename) {
    var frag = {
        kind: 'FragmentDefinition',
        typeCondition: {
            kind: 'NamedType',
            name: {
                kind: 'Name',
                value: typename || '__FakeType',
            },
        },
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery',
        },
        selectionSet: selectionSetFromObj(obj),
    };
    var out = {
        kind: 'Document',
        definitions: [frag],
    };
    return out;
}
function selectionSetFromObj(obj) {
    if (typeof obj === 'number' ||
        typeof obj === 'boolean' ||
        typeof obj === 'string' ||
        typeof obj === 'undefined' ||
        obj === null) {
        return null;
    }
    if (Array.isArray(obj)) {
        return selectionSetFromObj(obj[0]);
    }
    var selections = [];
    Object.keys(obj).forEach(function (key) {
        var nestedSelSet = selectionSetFromObj(obj[key]);
        var field = {
            kind: 'Field',
            name: {
                kind: 'Name',
                value: key,
            },
            selectionSet: nestedSelSet || undefined,
        };
        selections.push(field);
    });
    var selectionSet = {
        kind: 'SelectionSet',
        selections: selections,
    };
    return selectionSet;
}
var justTypenameQuery = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: null,
                        name: {
                            kind: 'Name',
                            value: '__typename',
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null,
                    },
                ],
            },
        },
    ],
};

var ApolloCache = (function () {
    function ApolloCache() {
    }
    ApolloCache.prototype.transformDocument = function (document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function (document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic,
        });
    };
    ApolloCache.prototype.readFragment = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.read({
            query: Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["k" /* getFragmentQueryDocument */])(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic,
        });
    };
    ApolloCache.prototype.writeQuery = function (options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables,
        });
    };
    ApolloCache.prototype.writeFragment = function (options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["k" /* getFragmentQueryDocument */])(options.fragment, options.fragmentName),
        });
    };
    ApolloCache.prototype.writeData = function (_a) {
        var id = _a.id, data = _a.data;
        if (typeof id !== 'undefined') {
            var typenameResult = null;
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: justTypenameQuery,
                });
            }
            catch (e) {
            }
            var __typename = (typenameResult && typenameResult.__typename) || '__ClientData';
            var dataToWrite = Object.assign({ __typename: __typename }, data);
            this.writeFragment({
                id: id,
                fragment: fragmentFromPojo(dataToWrite, __typename),
                data: dataToWrite,
            });
        }
        else {
            this.writeQuery({ query: queryFromPojo(data), data: data });
        }
    };
    return ApolloCache;
}());

var Cache;
(function (Cache) {
})(Cache || (Cache = {}));


//# sourceMappingURL=bundle.esm.js.map


/***/ }),
/* 2466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KeyTrie; });
/* unused harmony export defaultMakeCacheKey */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return wrap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wry_context__ = __webpack_require__(650);
/* unused harmony reexport asyncFromGen */
/* unused harmony reexport bindContext */
/* unused harmony reexport noContext */
/* unused harmony reexport setTimeout */



function defaultDispose() { }
var Cache = /** @class */ (function () {
    function Cache(max, dispose) {
        if (max === void 0) { max = Infinity; }
        if (dispose === void 0) { dispose = defaultDispose; }
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function (key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function (key) {
        var entry = this.getEntry(key);
        return entry && entry.value;
    };
    Cache.prototype.getEntry = function (key) {
        var entry = this.map.get(key);
        if (entry && entry !== this.newest) {
            var older = entry.older, newer = entry.newer;
            if (newer) {
                newer.older = older;
            }
            if (older) {
                older.newer = newer;
            }
            entry.older = this.newest;
            entry.older.newer = entry;
            entry.newer = null;
            this.newest = entry;
            if (entry === this.oldest) {
                this.oldest = newer;
            }
        }
        return entry;
    };
    Cache.prototype.set = function (key, value) {
        var entry = this.getEntry(key);
        if (entry) {
            return entry.value = value;
        }
        entry = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) {
            this.newest.newer = entry;
        }
        this.newest = entry;
        this.oldest = this.oldest || entry;
        this.map.set(key, entry);
        return entry.value;
    };
    Cache.prototype.clean = function () {
        while (this.oldest && this.map.size > this.max) {
            this.delete(this.oldest.key);
        }
    };
    Cache.prototype.delete = function (key) {
        var entry = this.map.get(key);
        if (entry) {
            if (entry === this.newest) {
                this.newest = entry.older;
            }
            if (entry === this.oldest) {
                this.oldest = entry.newer;
            }
            if (entry.newer) {
                entry.newer.older = entry.older;
            }
            if (entry.older) {
                entry.older.newer = entry.newer;
            }
            this.map.delete(key);
            this.dispose(entry.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}());

var parentEntrySlot = new __WEBPACK_IMPORTED_MODULE_0__wry_context__["a" /* Slot */]();

var reusableEmptyArray = [];
var emptySetPool = [];
var POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function assert(condition, optionalMessage) {
    if (!condition) {
        throw new Error(optionalMessage || "assertion failure");
    }
}
function valueIs(a, b) {
    var len = a.length;
    return (
    // Unknown values are not equal to each other.
    len > 0 &&
        // Both values must be ordinary (or both exceptional) to be equal.
        len === b.length &&
        // The underlying value or exception must be the same.
        a[len - 1] === b[len - 1]);
}
function valueGet(value) {
    switch (value.length) {
        case 0: throw new Error("unknown value");
        case 1: return value[0];
        case 2: throw value[1];
    }
}
function valueCopy(value) {
    return value.slice(0);
}
var Entry = /** @class */ (function () {
    function Entry(fn, args) {
        this.fn = fn;
        this.args = args;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        ++Entry.count;
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function () {
        assert(!this.recomputing, "already recomputing");
        if (!rememberParent(this) && maybeReportOrphan(this)) {
            // The recipient of the entry.reportOrphan callback decided to dispose
            // of this orphan entry by calling entry.dispose(), so we don't need to
            // (and should not) proceed with the recomputation.
            return void 0;
        }
        return mightBeDirty(this)
            ? reallyRecompute(this)
            : valueGet(this.value);
    };
    Entry.prototype.setDirty = function () {
        if (this.dirty)
            return;
        this.dirty = true;
        this.value.length = 0;
        reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function () {
        var _this = this;
        forgetChildren(this).forEach(maybeReportOrphan);
        maybeUnsubscribe(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        this.parents.forEach(function (parent) {
            parent.setDirty();
            forgetChild(parent, _this);
        });
    };
    Entry.count = 0;
    return Entry;
}());
function rememberParent(child) {
    var parent = parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) {
            parent.childValues.set(child, []);
        }
        if (mightBeDirty(child)) {
            reportDirtyChild(parent, child);
        }
        else {
            reportCleanChild(parent, child);
        }
        return parent;
    }
}
function reallyRecompute(entry) {
    // Since this recomputation is likely to re-remember some of this
    // entry's children, we forget our children here but do not call
    // maybeReportOrphan until after the recomputation finishes.
    var originalChildren = forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    parentEntrySlot.withValue(entry, recomputeNewValue, [entry]);
    if (maybeSubscribe(entry)) {
        // If we successfully recomputed entry.value and did not fail to
        // (re)subscribe, then this Entry is no longer explicitly dirty.
        setClean(entry);
    }
    // Now that we've had a chance to re-remember any children that were
    // involved in the recomputation, we can safely report any orphan
    // children that remain.
    originalChildren.forEach(maybeReportOrphan);
    return valueGet(entry.value);
}
function recomputeNewValue(entry) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, entry.args);
    }
    catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function setClean(entry) {
    entry.dirty = false;
    if (mightBeDirty(entry)) {
        // This Entry may still have dirty children, in which case we can't
        // let our parents know we're clean just yet.
        return;
    }
    reportClean(entry);
}
function reportDirty(child) {
    child.parents.forEach(function (parent) { return reportDirtyChild(parent, child); });
}
function reportClean(child) {
    child.parents.forEach(function (parent) { return reportCleanChild(parent, child); });
}
// Let a parent Entry know that one of its children may be dirty.
function reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    assert(parent.childValues.has(child));
    assert(mightBeDirty(child));
    if (!parent.dirtyChildren) {
        parent.dirtyChildren = emptySetPool.pop() || new Set;
    }
    else if (parent.dirtyChildren.has(child)) {
        // If we already know this child is dirty, then we must have already
        // informed our own parents that we are dirty, so we can terminate
        // the recursion early.
        return;
    }
    parent.dirtyChildren.add(child);
    reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    assert(parent.childValues.has(child));
    assert(!mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) {
        parent.childValues.set(child, valueCopy(child.value));
    }
    else if (!valueIs(childValue, child.value)) {
        parent.setDirty();
    }
    removeDirtyChild(parent, child);
    if (mightBeDirty(parent)) {
        return;
    }
    reportClean(parent);
}
function removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if (emptySetPool.length < POOL_TARGET_SIZE) {
                emptySetPool.push(dc);
            }
            parent.dirtyChildren = null;
        }
    }
}
// If the given entry has a reportOrphan method, and no remaining parents,
// call entry.reportOrphan and return true iff it returns true. The
// reportOrphan function should return true to indicate entry.dispose()
// has been called, and the entry has been removed from any other caches
// (see index.js for the only current example).
function maybeReportOrphan(entry) {
    return entry.parents.size === 0 &&
        typeof entry.reportOrphan === "function" &&
        entry.reportOrphan() === true;
}
// Removes all children from this entry and returns an array of the
// removed children.
function forgetChildren(parent) {
    var children = reusableEmptyArray;
    if (parent.childValues.size > 0) {
        children = [];
        parent.childValues.forEach(function (_value, child) {
            forgetChild(parent, child);
            children.push(child);
        });
    }
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    assert(parent.dirtyChildren === null);
    return children;
}
function forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    removeDirtyChild(parent, child);
}
function maybeSubscribe(entry) {
    if (typeof entry.subscribe === "function") {
        try {
            maybeUnsubscribe(entry); // Prevent double subscriptions.
            entry.unsubscribe = entry.subscribe.apply(null, entry.args);
        }
        catch (e) {
            // If this Entry has a subscribe function and it threw an exception
            // (or an unsubscribe function it previously returned now throws),
            // return false to indicate that we were not able to subscribe (or
            // unsubscribe), and this Entry should remain dirty.
            entry.setDirty();
            return false;
        }
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
function maybeUnsubscribe(entry) {
    var unsubscribe = entry.unsubscribe;
    if (typeof unsubscribe === "function") {
        entry.unsubscribe = void 0;
        unsubscribe();
    }
}

// A trie data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var KeyTrie = /** @class */ (function () {
    function KeyTrie(weakness) {
        this.weakness = weakness;
    }
    KeyTrie.prototype.lookup = function () {
        var array = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            array[_i] = arguments[_i];
        }
        return this.lookupArray(array);
    };
    KeyTrie.prototype.lookupArray = function (array) {
        var node = this;
        array.forEach(function (key) { return node = node.getChildTrie(key); });
        return node.data || (node.data = Object.create(null));
    };
    KeyTrie.prototype.getChildTrie = function (key) {
        var map = this.weakness && isObjRef(key)
            ? this.weak || (this.weak = new WeakMap())
            : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child)
            map.set(key, child = new KeyTrie(this.weakness));
        return child;
    };
    return KeyTrie;
}());
function isObjRef(value) {
    switch (typeof value) {
        case "object":
            if (value === null)
                break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}

// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var keyTrie = new KeyTrie(typeof WeakMap === "function");
function defaultMakeCacheKey() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return keyTrie.lookupArray(args);
}
var caches = new Set();
function wrap(originalFunction, options) {
    if (options === void 0) { options = Object.create(null); }
    var cache = new Cache(options.max || Math.pow(2, 16), function (entry) { return entry.dispose(); });
    var disposable = !!options.disposable;
    var makeCacheKey = options.makeCacheKey || defaultMakeCacheKey;
    function optimistic() {
        if (disposable && !parentEntrySlot.hasValue()) {
            // If there's no current parent computation, and this wrapped
            // function is disposable (meaning we don't care about entry.value,
            // just dependency tracking), then we can short-cut everything else
            // in this function, because entry.recompute() is going to recycle
            // the entry object without recomputing anything, anyway.
            return void 0;
        }
        var key = makeCacheKey.apply(null, arguments);
        if (key === void 0) {
            return originalFunction.apply(null, arguments);
        }
        var args = Array.prototype.slice.call(arguments);
        var entry = cache.get(key);
        if (entry) {
            entry.args = args;
        }
        else {
            entry = new Entry(originalFunction, args);
            cache.set(key, entry);
            entry.subscribe = options.subscribe;
            if (disposable) {
                entry.reportOrphan = function () { return cache.delete(key); };
            }
        }
        var value = entry.recompute();
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!parentEntrySlot.hasValue()) {
            caches.forEach(function (cache) { return cache.clean(); });
            caches.clear();
        }
        // If options.disposable is truthy, the caller of wrap is telling us
        // they don't care about the result of entry.recompute(), so we should
        // avoid returning the value, so it won't be accidentally used.
        return disposable ? void 0 : value;
    }
    optimistic.dirty = function () {
        var key = makeCacheKey.apply(null, arguments);
        var child = key !== void 0 && cache.get(key);
        if (child) {
            child.setDirty();
        }
    };
    return optimistic;
}


//# sourceMappingURL=bundle.esm.js.map


/***/ }),
/* 2467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HttpLink; });
/* unused harmony export createHttpLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_apollo_link__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apollo_link_http_common__ = __webpack_require__(651);




var createHttpLink = function (linkOptions) {
    if (linkOptions === void 0) { linkOptions = {}; }
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, requestOptions = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __rest */])(linkOptions, ["uri", "fetch", "includeExtensions", "useGETForQueries"]);
    Object(__WEBPACK_IMPORTED_MODULE_2_apollo_link_http_common__["a" /* checkFetcher */])(fetcher);
    if (!fetcher) {
        fetcher = fetch;
    }
    var linkConfig = {
        http: { includeExtensions: includeExtensions },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers,
    };
    return new __WEBPACK_IMPORTED_MODULE_1_apollo_link__["a" /* ApolloLink */](function (operation) {
        var chosenURI = Object(__WEBPACK_IMPORTED_MODULE_2_apollo_link_http_common__["f" /* selectURI */])(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) {
                clientAwarenessHeaders['apollographql-client-name'] = name_1;
            }
            if (version) {
                clientAwarenessHeaders['apollographql-client-version'] = version;
            }
        }
        var contextHeaders = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, clientAwarenessHeaders, context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders,
        };
        var _b = Object(__WEBPACK_IMPORTED_MODULE_2_apollo_link_http_common__["e" /* selectHttpOptionsAndBody */])(operation, __WEBPACK_IMPORTED_MODULE_2_apollo_link_http_common__["c" /* fallbackHttpConfig */], linkConfig, contextConfig), options = _b.options, body = _b.body;
        var controller;
        if (!options.signal) {
            var _c = Object(__WEBPACK_IMPORTED_MODULE_2_apollo_link_http_common__["b" /* createSignalIfSupported */])(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller)
                options.signal = signal;
        }
        var definitionIsMutation = function (d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries &&
            !operation.query.definitions.some(definitionIsMutation)) {
            options.method = 'GET';
        }
        if (options.method === 'GET') {
            var _d = rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) {
                return Object(__WEBPACK_IMPORTED_MODULE_1_apollo_link__["d" /* fromError */])(parseError);
            }
            chosenURI = newURI;
        }
        else {
            try {
                options.body = Object(__WEBPACK_IMPORTED_MODULE_2_apollo_link_http_common__["g" /* serializeFetchParameter */])(body, 'Payload');
            }
            catch (parseError) {
                return Object(__WEBPACK_IMPORTED_MODULE_1_apollo_link__["d" /* fromError */])(parseError);
            }
        }
        return new __WEBPACK_IMPORTED_MODULE_1_apollo_link__["b" /* Observable */](function (observer) {
            fetcher(chosenURI, options)
                .then(function (response) {
                operation.setContext({ response: response });
                return response;
            })
                .then(Object(__WEBPACK_IMPORTED_MODULE_2_apollo_link_http_common__["d" /* parseAndCheckHttpResponse */])(operation))
                .then(function (result) {
                observer.next(result);
                observer.complete();
                return result;
            })
                .catch(function (err) {
                if (err.name === 'AbortError')
                    return;
                if (err.result && err.result.errors && err.result.data) {
                    observer.next(err.result);
                }
                observer.error(err);
            });
            return function () {
                if (controller)
                    controller.abort();
            };
        });
    });
};
function rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function (key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ('query' in body) {
        addQueryParam('query', body.query);
    }
    if (body.operationName) {
        addQueryParam('operationName', body.operationName);
    }
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = Object(__WEBPACK_IMPORTED_MODULE_2_apollo_link_http_common__["g" /* serializeFetchParameter */])(body.variables, 'Variables map');
        }
        catch (parseError) {
            return { parseError: parseError };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = Object(__WEBPACK_IMPORTED_MODULE_2_apollo_link_http_common__["g" /* serializeFetchParameter */])(body.extensions, 'Extensions map');
        }
        catch (parseError) {
            return { parseError: parseError };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return { newURI: newURI };
}
var HttpLink = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(HttpLink, _super);
    function HttpLink(opts) {
        return _super.call(this, createHttpLink(opts).request) || this;
    }
    return HttpLink;
}(__WEBPACK_IMPORTED_MODULE_1_apollo_link__["a" /* ApolloLink */]));


//# sourceMappingURL=bundle.esm.js.map


/***/ }),
/* 2468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ErrorLink */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return onError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_apollo_link__ = __webpack_require__(140);



function onError(errorHandler) {
    return new __WEBPACK_IMPORTED_MODULE_1_apollo_link__["a" /* ApolloLink */](function (operation, forward) {
        return new __WEBPACK_IMPORTED_MODULE_1_apollo_link__["b" /* Observable */](function (observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function (result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward,
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer),
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function (networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            graphQLErrors: networkError &&
                                networkError.result &&
                                networkError.result.errors,
                            forward: forward,
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer),
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function () {
                        if (!retriedResult) {
                            observer.complete.bind(observer)();
                        }
                    },
                });
            }
            catch (e) {
                errorHandler({ networkError: e, operation: operation, forward: forward });
                observer.error(e);
            }
            return function () {
                if (sub)
                    sub.unsubscribe();
                if (retriedSub)
                    sub.unsubscribe();
            };
        });
    });
}
var ErrorLink = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = onError(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function (operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}(__WEBPACK_IMPORTED_MODULE_1_apollo_link__["a" /* ApolloLink */]));


//# sourceMappingURL=bundle.esm.js.map


/***/ }),
/* 2469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_link__ = __webpack_require__(140);
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};

var setContext = function (setter) {
    return new __WEBPACK_IMPORTED_MODULE_0_apollo_link__["a" /* ApolloLink */](function (operation, forward) {
        var request = __rest(operation, []);
        return new __WEBPACK_IMPORTED_MODULE_0_apollo_link__["b" /* Observable */](function (observer) {
            var handle;
            Promise.resolve(request)
                .then(function (req) { return setter(req, operation.getContext()); })
                .then(operation.setContext)
                .then(function () {
                handle = forward(operation).subscribe({
                    next: observer.next.bind(observer),
                    error: observer.error.bind(observer),
                    complete: observer.complete.bind(observer),
                });
            })
                .catch(observer.error.bind(observer));
            return function () {
                if (handle)
                    handle.unsubscribe();
            };
        });
    });
};
//# sourceMappingURL=index.js.map

/***/ }),
/* 2470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createUploadLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_function_name__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_function_name___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_function_name__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_web_dom_iterable__ = __webpack_require__(2473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_web_dom_iterable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_web_dom_iterable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apollo_link__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_apollo_link_http_common__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_extract_files__ = __webpack_require__(662);
/* unused harmony reexport ReactNativeFile */






var createUploadLink = function createUploadLink() {
  var _ref =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$uri = _ref.uri,
    fetchUri = _ref$uri === void 0 ? '/graphql' : _ref$uri,
    _ref$fetch = _ref.fetch,
    linkFetch = _ref$fetch === void 0 ? fetch : _ref$fetch,
    fetchOptions = _ref.fetchOptions,
    credentials = _ref.credentials,
    headers = _ref.headers,
    includeExtensions = _ref.includeExtensions

  var linkConfig = {
    http: {
      includeExtensions: includeExtensions
    },
    options: fetchOptions,
    credentials: credentials,
    headers: headers
  }
  return new __WEBPACK_IMPORTED_MODULE_2_apollo_link__["a" /* ApolloLink */](function(operation) {
    var uri = Object(__WEBPACK_IMPORTED_MODULE_3_apollo_link_http_common__["f" /* selectURI */])(operation, fetchUri)
    var context = operation.getContext()
    var contextConfig = {
      http: context.http,
      options: context.fetchOptions,
      credentials: context.credentials,
      headers: context.headers
    }

    var _selectHttpOptionsAnd = Object(__WEBPACK_IMPORTED_MODULE_3_apollo_link_http_common__["e" /* selectHttpOptionsAndBody */])(
        operation,
        __WEBPACK_IMPORTED_MODULE_3_apollo_link_http_common__["c" /* fallbackHttpConfig */],
        linkConfig,
        contextConfig
      ),
      options = _selectHttpOptionsAnd.options,
      body = _selectHttpOptionsAnd.body

    var files = Object(__WEBPACK_IMPORTED_MODULE_4_extract_files__["a" /* default */])(body)
    var payload = Object(__WEBPACK_IMPORTED_MODULE_3_apollo_link_http_common__["g" /* serializeFetchParameter */])(body, 'Payload')

    if (files.length) {
      delete options.headers['content-type']
      options.body = new FormData()
      options.body.append('operations', payload)
      options.body.append(
        'map',
        JSON.stringify(
          files.reduce(function(map, _ref2, index) {
            var path = _ref2.path
            map[''.concat(index)] = [path]
            return map
          }, {})
        )
      )
      files.forEach(function(_ref3, index) {
        var file = _ref3.file
        return options.body.append(index, file, file.name)
      })
    } else options.body = payload

    return new __WEBPACK_IMPORTED_MODULE_2_apollo_link__["b" /* Observable */](function(observer) {
      var _createSignalIfSuppor = Object(__WEBPACK_IMPORTED_MODULE_3_apollo_link_http_common__["b" /* createSignalIfSupported */])(),
        controller = _createSignalIfSuppor.controller,
        signal = _createSignalIfSuppor.signal

      if (controller) options.signal = signal
      linkFetch(uri, options)
        .then(function(response) {
          operation.setContext({
            response: response
          })
          return response
        })
        .then(Object(__WEBPACK_IMPORTED_MODULE_3_apollo_link_http_common__["d" /* parseAndCheckHttpResponse */])(operation))
        .then(function(result) {
          observer.next(result)
          observer.complete()
        })
        .catch(function(error) {
          if (error.name === 'AbortError') return
          if (error.result && error.result.errors && error.result.data)
            observer.next(error.result)
          observer.error(error)
        })
      return function() {
        if (controller) controller.abort()
      }
    })
  })
}


/***/ }),
/* 2471 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(205) && !__webpack_require__(653)(function () {
  return Object.defineProperty(__webpack_require__(654)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 2472 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(380);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 2473 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(2474);
var getKeys = __webpack_require__(658);
var redefine = __webpack_require__(386);
var global = __webpack_require__(136);
var hide = __webpack_require__(165);
var Iterators = __webpack_require__(384);
var wks = __webpack_require__(206);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 2474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(2475);
var step = __webpack_require__(2476);
var Iterators = __webpack_require__(384);
var toIObject = __webpack_require__(385);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(2479)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 2475 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(206)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(165)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 2476 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 2477 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(2478);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 2478 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 2479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(655);
var $export = __webpack_require__(2480);
var redefine = __webpack_require__(386);
var hide = __webpack_require__(165);
var Iterators = __webpack_require__(384);
var $iterCreate = __webpack_require__(2484);
var setToStringTag = __webpack_require__(661);
var getPrototypeOf = __webpack_require__(2492);
var ITERATOR = __webpack_require__(206)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 2480 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(136);
var core = __webpack_require__(382);
var hide = __webpack_require__(165);
var redefine = __webpack_require__(386);
var ctx = __webpack_require__(2482);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 2481 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(381)('native-function-to-string', Function.toString);


/***/ }),
/* 2482 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(2483);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 2483 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 2484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(2485);
var descriptor = __webpack_require__(656);
var setToStringTag = __webpack_require__(661);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(165)(IteratorPrototype, __webpack_require__(206)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 2485 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(379);
var dPs = __webpack_require__(2486);
var enumBugKeys = __webpack_require__(660);
var IE_PROTO = __webpack_require__(387)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(654)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(2491).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 2486 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(268);
var anObject = __webpack_require__(379);
var getKeys = __webpack_require__(658);

module.exports = __webpack_require__(205) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 2487 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(269);
var toIObject = __webpack_require__(385);
var arrayIndexOf = __webpack_require__(2488)(false);
var IE_PROTO = __webpack_require__(387)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 2488 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(385);
var toLength = __webpack_require__(2489);
var toAbsoluteIndex = __webpack_require__(2490);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 2489 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(659);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 2490 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(659);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 2491 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(136).document;
module.exports = document && document.documentElement;


/***/ }),
/* 2492 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(269);
var toObject = __webpack_require__(2493);
var IE_PROTO = __webpack_require__(387)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 2493 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(657);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 2494 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setItem */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checkTokenAuth; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jwt_decode__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jwt_decode__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function getQueryParams(){var url=window.location.href;var queryParams=url.split('?')[1];var params=queryParams?queryParams.split('&'):[];var paramsObject={};var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=params[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var param=_step.value;var _param$split=param.split('='),_param$split2=_slicedToArray(_param$split,2),key=_param$split2[0],val=_param$split2[1];paramsObject[key]=val;}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return paramsObject;}function checkTokeninQueryParams(params){return params.token?params.token:false;}function setItem(key,value){var storageType=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'TEMPORARY';if(storageType==='PERSISTENT'){localStorage.setItem(key,value);}else{sessionStorage.setItem(key,value);}}var checkTokenAuth=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var params,token,isDemo,payload,loginId,username;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:params=getQueryParams();token=checkTokeninQueryParams(params);isDemo=Boolean(params.demo);if(token){try{payload=__WEBPACK_IMPORTED_MODULE_1_jwt_decode___default()(token);loginId=payload.loginId;username=payload.username;setItem('loginId',loginId,'TEMPORARY');setItem('username',username,'TEMPORARY');setItem('token',token,'TEMPORARY');setItem('loginType','TOKEN','TEMPORARY');if(isDemo){setItem('isDemo','true','TEMPORARY');}window.location.replace(window.location.href.split('?')[0]);}catch(e){}}case 4:case'end':return _context.stop();}}},_callee,this);}));return function checkTokenAuth(){return _ref.apply(this,arguments);};}();

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.ed378431.js